(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2888],{

/***/ 71068:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ isPropValid; }
/* harmony export */ });
/* harmony import */ var _emotion_memoize__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45042);


// eslint-disable-next-line no-undef
var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var isPropValid = /* #__PURE__ */(0,_emotion_memoize__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);




/***/ }),

/***/ 45042:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ memoize; }
/* harmony export */ });
function memoize(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}




/***/ }),

/***/ 78947:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "api": function() { return /* binding */ api; },
/* harmony export */   "config": function() { return /* binding */ config$1; },
/* harmony export */   "counter": function() { return /* binding */ counter; },
/* harmony export */   "dom": function() { return /* binding */ dom$1; },
/* harmony export */   "findIconDefinition": function() { return /* binding */ findIconDefinition$1; },
/* harmony export */   "icon": function() { return /* binding */ icon; },
/* harmony export */   "layer": function() { return /* binding */ layer; },
/* harmony export */   "library": function() { return /* binding */ library$1; },
/* harmony export */   "noAuto": function() { return /* binding */ noAuto$1; },
/* harmony export */   "parse": function() { return /* binding */ parse$1; },
/* harmony export */   "text": function() { return /* binding */ text; },
/* harmony export */   "toHtml": function() { return /* binding */ toHtml$1; }
/* harmony export */ });
/*!
 * Font Awesome Free 6.0.0 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2022 Fonticons, Inc.
 */
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function _wrapRegExp() {
  _wrapRegExp = function (re, groups) {
    return new BabelRegExp(re, void 0, groups);
  };

  var _super = RegExp.prototype,
      _groups = new WeakMap();

  function BabelRegExp(re, flags, groups) {
    var _this = new RegExp(re, flags);

    return _groups.set(_this, groups || _groups.get(re)), _setPrototypeOf(_this, BabelRegExp.prototype);
  }

  function buildGroups(result, re) {
    var g = _groups.get(re);

    return Object.keys(g).reduce(function (groups, name) {
      return groups[name] = result[g[name]], groups;
    }, Object.create(null));
  }

  return _inherits(BabelRegExp, RegExp), BabelRegExp.prototype.exec = function (str) {
    var result = _super.exec.call(this, str);

    return result && (result.groups = buildGroups(result, this)), result;
  }, BabelRegExp.prototype[Symbol.replace] = function (str, substitution) {
    if ("string" == typeof substitution) {
      var groups = _groups.get(this);

      return _super[Symbol.replace].call(this, str, substitution.replace(/\$<([^>]+)>/g, function (_, name) {
        return "$" + groups[name];
      }));
    }

    if ("function" == typeof substitution) {
      var _this = this;

      return _super[Symbol.replace].call(this, str, function () {
        var args = arguments;
        return "object" != typeof args[args.length - 1] && (args = [].slice.call(args)).push(buildGroups(args, _this)), substitution.apply(this, args);
      });
    }

    return _super[Symbol.replace].call(this, str, substitution);
  }, _wrapRegExp.apply(this, arguments);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var noop = function noop() {};

var _WINDOW = {};
var _DOCUMENT = {};
var _MUTATION_OBSERVER = null;
var _PERFORMANCE = {
  mark: noop,
  measure: noop
};

try {
  if (typeof window !== 'undefined') _WINDOW = window;
  if (typeof document !== 'undefined') _DOCUMENT = document;
  if (typeof MutationObserver !== 'undefined') _MUTATION_OBSERVER = MutationObserver;
  if (typeof performance !== 'undefined') _PERFORMANCE = performance;
} catch (e) {}

var _ref = _WINDOW.navigator || {},
    _ref$userAgent = _ref.userAgent,
    userAgent = _ref$userAgent === void 0 ? '' : _ref$userAgent;
var WINDOW = _WINDOW;
var DOCUMENT = _DOCUMENT;
var MUTATION_OBSERVER = _MUTATION_OBSERVER;
var PERFORMANCE = _PERFORMANCE;
var IS_BROWSER = !!WINDOW.document;
var IS_DOM = !!DOCUMENT.documentElement && !!DOCUMENT.head && typeof DOCUMENT.addEventListener === 'function' && typeof DOCUMENT.createElement === 'function';
var IS_IE = ~userAgent.indexOf('MSIE') || ~userAgent.indexOf('Trident/');

var NAMESPACE_IDENTIFIER = '___FONT_AWESOME___';
var UNITS_IN_GRID = 16;
var DEFAULT_FAMILY_PREFIX = 'fa';
var DEFAULT_REPLACEMENT_CLASS = 'svg-inline--fa';
var DATA_FA_I2SVG = 'data-fa-i2svg';
var DATA_FA_PSEUDO_ELEMENT = 'data-fa-pseudo-element';
var DATA_FA_PSEUDO_ELEMENT_PENDING = 'data-fa-pseudo-element-pending';
var DATA_PREFIX = 'data-prefix';
var DATA_ICON = 'data-icon';
var HTML_CLASS_I2SVG_BASE_CLASS = 'fontawesome-i2svg';
var MUTATION_APPROACH_ASYNC = 'async';
var TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS = ['HTML', 'HEAD', 'STYLE', 'SCRIPT'];
var PRODUCTION = function () {
  try {
    return "production" === 'production';
  } catch (e) {
    return false;
  }
}();
var PREFIX_TO_STYLE = {
  'fas': 'solid',
  'fa-solid': 'solid',
  'far': 'regular',
  'fa-regular': 'regular',
  'fal': 'light',
  'fa-light': 'light',
  'fat': 'thin',
  'fa-thin': 'thin',
  'fad': 'duotone',
  'fa-duotone': 'duotone',
  'fab': 'brands',
  'fa-brands': 'brands',
  'fak': 'kit',
  'fa-kit': 'kit',
  'fa': 'solid'
};
var STYLE_TO_PREFIX = {
  'solid': 'fas',
  'regular': 'far',
  'light': 'fal',
  'thin': 'fat',
  'duotone': 'fad',
  'brands': 'fab',
  'kit': 'fak'
};
var PREFIX_TO_LONG_STYLE = {
  'fab': 'fa-brands',
  'fad': 'fa-duotone',
  'fak': 'fa-kit',
  'fal': 'fa-light',
  'far': 'fa-regular',
  'fas': 'fa-solid',
  'fat': 'fa-thin'
};
var LONG_STYLE_TO_PREFIX = {
  'fa-brands': 'fab',
  'fa-duotone': 'fad',
  'fa-kit': 'fak',
  'fa-light': 'fal',
  'fa-regular': 'far',
  'fa-solid': 'fas',
  'fa-thin': 'fat'
};
var ICON_SELECTION_SYNTAX_PATTERN = /fa[srltdbk\-\ ]/; // eslint-disable-line no-useless-escape

var LAYERS_TEXT_CLASSNAME = 'fa-layers-text';
var FONT_FAMILY_PATTERN = /Font ?Awesome ?([56 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Kit)?.*/i; // TODO: do we need to handle font-weight for kit SVG pseudo-elements?

var FONT_WEIGHT_TO_PREFIX = {
  '900': 'fas',
  '400': 'far',
  'normal': 'far',
  '300': 'fal',
  '100': 'fat'
};
var oneToTen = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
var oneToTwenty = oneToTen.concat([11, 12, 13, 14, 15, 16, 17, 18, 19, 20]);
var ATTRIBUTES_WATCHED_FOR_MUTATION = ['class', 'data-prefix', 'data-icon', 'data-fa-transform', 'data-fa-mask'];
var DUOTONE_CLASSES = {
  GROUP: 'duotone-group',
  SWAP_OPACITY: 'swap-opacity',
  PRIMARY: 'primary',
  SECONDARY: 'secondary'
};
var RESERVED_CLASSES = [].concat(_toConsumableArray(Object.keys(STYLE_TO_PREFIX)), ['2xs', 'xs', 'sm', 'lg', 'xl', '2xl', 'beat', 'border', 'fade', 'beat-fade', 'bounce', 'flip-both', 'flip-horizontal', 'flip-vertical', 'flip', 'fw', 'inverse', 'layers-counter', 'layers-text', 'layers', 'li', 'pull-left', 'pull-right', 'pulse', 'rotate-180', 'rotate-270', 'rotate-90', 'rotate-by', 'shake', 'spin-pulse', 'spin-reverse', 'spin', 'stack-1x', 'stack-2x', 'stack', 'ul', DUOTONE_CLASSES.GROUP, DUOTONE_CLASSES.SWAP_OPACITY, DUOTONE_CLASSES.PRIMARY, DUOTONE_CLASSES.SECONDARY]).concat(oneToTen.map(function (n) {
  return "".concat(n, "x");
})).concat(oneToTwenty.map(function (n) {
  return "w-".concat(n);
}));

var initial = WINDOW.FontAwesomeConfig || {};

function getAttrConfig(attr) {
  var element = DOCUMENT.querySelector('script[' + attr + ']');

  if (element) {
    return element.getAttribute(attr);
  }
}

function coerce(val) {
  // Getting an empty string will occur if the attribute is set on the HTML tag but without a value
  // We'll assume that this is an indication that it should be toggled to true
  // For example <script data-search-pseudo-elements src="..."></script>
  if (val === '') return true;
  if (val === 'false') return false;
  if (val === 'true') return true;
  return val;
}

if (DOCUMENT && typeof DOCUMENT.querySelector === 'function') {
  var attrs = [['data-family-prefix', 'familyPrefix'], ['data-style-default', 'styleDefault'], ['data-replacement-class', 'replacementClass'], ['data-auto-replace-svg', 'autoReplaceSvg'], ['data-auto-add-css', 'autoAddCss'], ['data-auto-a11y', 'autoA11y'], ['data-search-pseudo-elements', 'searchPseudoElements'], ['data-observe-mutations', 'observeMutations'], ['data-mutate-approach', 'mutateApproach'], ['data-keep-original-source', 'keepOriginalSource'], ['data-measure-performance', 'measurePerformance'], ['data-show-missing-icons', 'showMissingIcons']];
  attrs.forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        attr = _ref2[0],
        key = _ref2[1];

    var val = coerce(getAttrConfig(attr));

    if (val !== undefined && val !== null) {
      initial[key] = val;
    }
  });
}

var _default = {
  familyPrefix: DEFAULT_FAMILY_PREFIX,
  styleDefault: 'solid',
  replacementClass: DEFAULT_REPLACEMENT_CLASS,
  autoReplaceSvg: true,
  autoAddCss: true,
  autoA11y: true,
  searchPseudoElements: false,
  observeMutations: true,
  mutateApproach: 'async',
  keepOriginalSource: true,
  measurePerformance: false,
  showMissingIcons: true
};

var _config = _objectSpread2(_objectSpread2({}, _default), initial);

if (!_config.autoReplaceSvg) _config.observeMutations = false;
var config = {};
Object.keys(_config).forEach(function (key) {
  Object.defineProperty(config, key, {
    enumerable: true,
    set: function set(val) {
      _config[key] = val;

      _onChangeCb.forEach(function (cb) {
        return cb(config);
      });
    },
    get: function get() {
      return _config[key];
    }
  });
});
WINDOW.FontAwesomeConfig = config;
var _onChangeCb = [];
function onChange(cb) {
  _onChangeCb.push(cb);

  return function () {
    _onChangeCb.splice(_onChangeCb.indexOf(cb), 1);
  };
}

var d = UNITS_IN_GRID;
var meaninglessTransform = {
  size: 16,
  x: 0,
  y: 0,
  rotate: 0,
  flipX: false,
  flipY: false
};
function insertCss(css) {
  if (!css || !IS_DOM) {
    return;
  }

  var style = DOCUMENT.createElement('style');
  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  var headChildren = DOCUMENT.head.childNodes;
  var beforeChild = null;

  for (var i = headChildren.length - 1; i > -1; i--) {
    var child = headChildren[i];
    var tagName = (child.tagName || '').toUpperCase();

    if (['STYLE', 'LINK'].indexOf(tagName) > -1) {
      beforeChild = child;
    }
  }

  DOCUMENT.head.insertBefore(style, beforeChild);
  return css;
}
var idPool = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
function nextUniqueId() {
  var size = 12;
  var id = '';

  while (size-- > 0) {
    id += idPool[Math.random() * 62 | 0];
  }

  return id;
}
function toArray(obj) {
  var array = [];

  for (var i = (obj || []).length >>> 0; i--;) {
    array[i] = obj[i];
  }

  return array;
}
function classArray(node) {
  if (node.classList) {
    return toArray(node.classList);
  } else {
    return (node.getAttribute('class') || '').split(' ').filter(function (i) {
      return i;
    });
  }
}
function htmlEscape(str) {
  return "".concat(str).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
function joinAttributes(attributes) {
  return Object.keys(attributes || {}).reduce(function (acc, attributeName) {
    return acc + "".concat(attributeName, "=\"").concat(htmlEscape(attributes[attributeName]), "\" ");
  }, '').trim();
}
function joinStyles(styles) {
  return Object.keys(styles || {}).reduce(function (acc, styleName) {
    return acc + "".concat(styleName, ": ").concat(styles[styleName].trim(), ";");
  }, '');
}
function transformIsMeaningful(transform) {
  return transform.size !== meaninglessTransform.size || transform.x !== meaninglessTransform.x || transform.y !== meaninglessTransform.y || transform.rotate !== meaninglessTransform.rotate || transform.flipX || transform.flipY;
}
function transformForSvg(_ref) {
  var transform = _ref.transform,
      containerWidth = _ref.containerWidth,
      iconWidth = _ref.iconWidth;
  var outer = {
    transform: "translate(".concat(containerWidth / 2, " 256)")
  };
  var innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
  var innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
  var innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
  var inner = {
    transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
  };
  var path = {
    transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
  };
  return {
    outer: outer,
    inner: inner,
    path: path
  };
}
function transformForCss(_ref2) {
  var transform = _ref2.transform,
      _ref2$width = _ref2.width,
      width = _ref2$width === void 0 ? UNITS_IN_GRID : _ref2$width,
      _ref2$height = _ref2.height,
      height = _ref2$height === void 0 ? UNITS_IN_GRID : _ref2$height,
      _ref2$startCentered = _ref2.startCentered,
      startCentered = _ref2$startCentered === void 0 ? false : _ref2$startCentered;
  var val = '';

  if (startCentered && IS_IE) {
    val += "translate(".concat(transform.x / d - width / 2, "em, ").concat(transform.y / d - height / 2, "em) ");
  } else if (startCentered) {
    val += "translate(calc(-50% + ".concat(transform.x / d, "em), calc(-50% + ").concat(transform.y / d, "em)) ");
  } else {
    val += "translate(".concat(transform.x / d, "em, ").concat(transform.y / d, "em) ");
  }

  val += "scale(".concat(transform.size / d * (transform.flipX ? -1 : 1), ", ").concat(transform.size / d * (transform.flipY ? -1 : 1), ") ");
  val += "rotate(".concat(transform.rotate, "deg) ");
  return val;
}

var baseStyles = ":root, :host {\n  --fa-font-solid: normal 900 1em/1 \"Font Awesome 6 Solid\";\n  --fa-font-regular: normal 400 1em/1 \"Font Awesome 6 Regular\";\n  --fa-font-light: normal 300 1em/1 \"Font Awesome 6 Light\";\n  --fa-font-thin: normal 100 1em/1 \"Font Awesome 6 Thin\";\n  --fa-font-duotone: normal 900 1em/1 \"Font Awesome 6 Duotone\";\n  --fa-font-brands: normal 400 1em/1 \"Font Awesome 6 Brands\";\n}\n\nsvg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {\n  overflow: visible;\n  box-sizing: content-box;\n}\n\n.svg-inline--fa {\n  display: var(--fa-display, inline-block);\n  height: 1em;\n  overflow: visible;\n  vertical-align: -0.125em;\n}\n.svg-inline--fa.fa-2xs {\n  vertical-align: 0.1em;\n}\n.svg-inline--fa.fa-xs {\n  vertical-align: 0em;\n}\n.svg-inline--fa.fa-sm {\n  vertical-align: -0.0714285705em;\n}\n.svg-inline--fa.fa-lg {\n  vertical-align: -0.2em;\n}\n.svg-inline--fa.fa-xl {\n  vertical-align: -0.25em;\n}\n.svg-inline--fa.fa-2xl {\n  vertical-align: -0.3125em;\n}\n.svg-inline--fa.fa-pull-left {\n  margin-right: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-pull-right {\n  margin-left: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-li {\n  width: var(--fa-li-width, 2em);\n  top: 0.25em;\n}\n.svg-inline--fa.fa-fw {\n  width: var(--fa-fw-width, 1.25em);\n}\n\n.fa-layers svg.svg-inline--fa {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.fa-layers-counter, .fa-layers-text {\n  display: inline-block;\n  position: absolute;\n  text-align: center;\n}\n\n.fa-layers {\n  display: inline-block;\n  height: 1em;\n  position: relative;\n  text-align: center;\n  vertical-align: -0.125em;\n  width: 1em;\n}\n.fa-layers svg.svg-inline--fa {\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-text {\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-counter {\n  background-color: var(--fa-counter-background-color, #ff253a);\n  border-radius: var(--fa-counter-border-radius, 1em);\n  box-sizing: border-box;\n  color: var(--fa-inverse, #fff);\n  line-height: var(--fa-counter-line-height, 1);\n  max-width: var(--fa-counter-max-width, 5em);\n  min-width: var(--fa-counter-min-width, 1.5em);\n  overflow: hidden;\n  padding: var(--fa-counter-padding, 0.25em 0.5em);\n  right: var(--fa-right, 0);\n  text-overflow: ellipsis;\n  top: var(--fa-top, 0);\n  -webkit-transform: scale(var(--fa-counter-scale, 0.25));\n          transform: scale(var(--fa-counter-scale, 0.25));\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-bottom-right {\n  bottom: var(--fa-bottom, 0);\n  right: var(--fa-right, 0);\n  top: auto;\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: bottom right;\n          transform-origin: bottom right;\n}\n\n.fa-layers-bottom-left {\n  bottom: var(--fa-bottom, 0);\n  left: var(--fa-left, 0);\n  right: auto;\n  top: auto;\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: bottom left;\n          transform-origin: bottom left;\n}\n\n.fa-layers-top-right {\n  top: var(--fa-top, 0);\n  right: var(--fa-right, 0);\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-top-left {\n  left: var(--fa-left, 0);\n  right: auto;\n  top: var(--fa-top, 0);\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: top left;\n          transform-origin: top left;\n}\n\n.fa-1x {\n  font-size: 1em;\n}\n\n.fa-2x {\n  font-size: 2em;\n}\n\n.fa-3x {\n  font-size: 3em;\n}\n\n.fa-4x {\n  font-size: 4em;\n}\n\n.fa-5x {\n  font-size: 5em;\n}\n\n.fa-6x {\n  font-size: 6em;\n}\n\n.fa-7x {\n  font-size: 7em;\n}\n\n.fa-8x {\n  font-size: 8em;\n}\n\n.fa-9x {\n  font-size: 9em;\n}\n\n.fa-10x {\n  font-size: 10em;\n}\n\n.fa-2xs {\n  font-size: 0.625em;\n  line-height: 0.1em;\n  vertical-align: 0.225em;\n}\n\n.fa-xs {\n  font-size: 0.75em;\n  line-height: 0.0833333337em;\n  vertical-align: 0.125em;\n}\n\n.fa-sm {\n  font-size: 0.875em;\n  line-height: 0.0714285718em;\n  vertical-align: 0.0535714295em;\n}\n\n.fa-lg {\n  font-size: 1.25em;\n  line-height: 0.05em;\n  vertical-align: -0.075em;\n}\n\n.fa-xl {\n  font-size: 1.5em;\n  line-height: 0.0416666682em;\n  vertical-align: -0.125em;\n}\n\n.fa-2xl {\n  font-size: 2em;\n  line-height: 0.03125em;\n  vertical-align: -0.1875em;\n}\n\n.fa-fw {\n  text-align: center;\n  width: 1.25em;\n}\n\n.fa-ul {\n  list-style-type: none;\n  margin-left: var(--fa-li-margin, 2.5em);\n  padding-left: 0;\n}\n.fa-ul > li {\n  position: relative;\n}\n\n.fa-li {\n  left: calc(var(--fa-li-width, 2em) * -1);\n  position: absolute;\n  text-align: center;\n  width: var(--fa-li-width, 2em);\n  line-height: inherit;\n}\n\n.fa-border {\n  border-color: var(--fa-border-color, #eee);\n  border-radius: var(--fa-border-radius, 0.1em);\n  border-style: var(--fa-border-style, solid);\n  border-width: var(--fa-border-width, 0.08em);\n  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);\n}\n\n.fa-pull-left {\n  float: left;\n  margin-right: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-pull-right {\n  float: right;\n  margin-left: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-beat {\n  -webkit-animation-name: fa-beat;\n          animation-name: fa-beat;\n  -webkit-animation-delay: var(--fa-animation-delay, 0);\n          animation-delay: var(--fa-animation-delay, 0);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);\n          animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-bounce {\n  -webkit-animation-name: fa-bounce;\n          animation-name: fa-bounce;\n  -webkit-animation-delay: var(--fa-animation-delay, 0);\n          animation-delay: var(--fa-animation-delay, 0);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));\n}\n\n.fa-fade {\n  -webkit-animation-name: fa-fade;\n          animation-name: fa-fade;\n  -webkit-animation-delay: var(--fa-animation-delay, 0);\n          animation-delay: var(--fa-animation-delay, 0);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-beat-fade {\n  -webkit-animation-name: fa-beat-fade;\n          animation-name: fa-beat-fade;\n  -webkit-animation-delay: var(--fa-animation-delay, 0);\n          animation-delay: var(--fa-animation-delay, 0);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-flip {\n  -webkit-animation-name: fa-flip;\n          animation-name: fa-flip;\n  -webkit-animation-delay: var(--fa-animation-delay, 0);\n          animation-delay: var(--fa-animation-delay, 0);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);\n          animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-shake {\n  -webkit-animation-name: fa-shake;\n          animation-name: fa-shake;\n  -webkit-animation-delay: var(--fa-animation-delay, 0);\n          animation-delay: var(--fa-animation-delay, 0);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, linear);\n          animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin {\n  -webkit-animation-name: fa-spin;\n          animation-name: fa-spin;\n  -webkit-animation-delay: var(--fa-animation-delay, 0);\n          animation-delay: var(--fa-animation-delay, 0);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 2s);\n          animation-duration: var(--fa-animation-duration, 2s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, linear);\n          animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin-reverse {\n  --fa-animation-direction: reverse;\n}\n\n.fa-pulse,\n.fa-spin-pulse {\n  -webkit-animation-name: fa-spin;\n          animation-name: fa-spin;\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, steps(8));\n          animation-timing-function: var(--fa-animation-timing, steps(8));\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .fa-beat,\n.fa-bounce,\n.fa-fade,\n.fa-beat-fade,\n.fa-flip,\n.fa-pulse,\n.fa-shake,\n.fa-spin,\n.fa-spin-pulse {\n    -webkit-animation-delay: -1ms;\n            animation-delay: -1ms;\n    -webkit-animation-duration: 1ms;\n            animation-duration: 1ms;\n    -webkit-animation-iteration-count: 1;\n            animation-iteration-count: 1;\n    transition-delay: 0s;\n    transition-duration: 0s;\n  }\n}\n@-webkit-keyframes fa-beat {\n  0%, 90% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  45% {\n    -webkit-transform: scale(var(--fa-beat-scale, 1.25));\n            transform: scale(var(--fa-beat-scale, 1.25));\n  }\n}\n@keyframes fa-beat {\n  0%, 90% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  45% {\n    -webkit-transform: scale(var(--fa-beat-scale, 1.25));\n            transform: scale(var(--fa-beat-scale, 1.25));\n  }\n}\n@-webkit-keyframes fa-bounce {\n  0% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  10% {\n    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n  }\n  30% {\n    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n  }\n  50% {\n    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n  }\n  57% {\n    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n  }\n  64% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  100% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n}\n@keyframes fa-bounce {\n  0% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  10% {\n    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n  }\n  30% {\n    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n  }\n  50% {\n    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n  }\n  57% {\n    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n  }\n  64% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  100% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n}\n@-webkit-keyframes fa-fade {\n  50% {\n    opacity: var(--fa-fade-opacity, 0.4);\n  }\n}\n@keyframes fa-fade {\n  50% {\n    opacity: var(--fa-fade-opacity, 0.4);\n  }\n}\n@-webkit-keyframes fa-beat-fade {\n  0%, 100% {\n    opacity: var(--fa-beat-fade-opacity, 0.4);\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));\n            transform: scale(var(--fa-beat-fade-scale, 1.125));\n  }\n}\n@keyframes fa-beat-fade {\n  0%, 100% {\n    opacity: var(--fa-beat-fade-opacity, 0.4);\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));\n            transform: scale(var(--fa-beat-fade-scale, 1.125));\n  }\n}\n@-webkit-keyframes fa-flip {\n  50% {\n    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n  }\n}\n@keyframes fa-flip {\n  50% {\n    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n  }\n}\n@-webkit-keyframes fa-shake {\n  0% {\n    -webkit-transform: rotate(-15deg);\n            transform: rotate(-15deg);\n  }\n  4% {\n    -webkit-transform: rotate(15deg);\n            transform: rotate(15deg);\n  }\n  8%, 24% {\n    -webkit-transform: rotate(-18deg);\n            transform: rotate(-18deg);\n  }\n  12%, 28% {\n    -webkit-transform: rotate(18deg);\n            transform: rotate(18deg);\n  }\n  16% {\n    -webkit-transform: rotate(-22deg);\n            transform: rotate(-22deg);\n  }\n  20% {\n    -webkit-transform: rotate(22deg);\n            transform: rotate(22deg);\n  }\n  32% {\n    -webkit-transform: rotate(-12deg);\n            transform: rotate(-12deg);\n  }\n  36% {\n    -webkit-transform: rotate(12deg);\n            transform: rotate(12deg);\n  }\n  40%, 100% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n}\n@keyframes fa-shake {\n  0% {\n    -webkit-transform: rotate(-15deg);\n            transform: rotate(-15deg);\n  }\n  4% {\n    -webkit-transform: rotate(15deg);\n            transform: rotate(15deg);\n  }\n  8%, 24% {\n    -webkit-transform: rotate(-18deg);\n            transform: rotate(-18deg);\n  }\n  12%, 28% {\n    -webkit-transform: rotate(18deg);\n            transform: rotate(18deg);\n  }\n  16% {\n    -webkit-transform: rotate(-22deg);\n            transform: rotate(-22deg);\n  }\n  20% {\n    -webkit-transform: rotate(22deg);\n            transform: rotate(22deg);\n  }\n  32% {\n    -webkit-transform: rotate(-12deg);\n            transform: rotate(-12deg);\n  }\n  36% {\n    -webkit-transform: rotate(12deg);\n            transform: rotate(12deg);\n  }\n  40%, 100% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n}\n@-webkit-keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n@keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n.fa-rotate-90 {\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n}\n\n.fa-rotate-180 {\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg);\n}\n\n.fa-rotate-270 {\n  -webkit-transform: rotate(270deg);\n          transform: rotate(270deg);\n}\n\n.fa-flip-horizontal {\n  -webkit-transform: scale(-1, 1);\n          transform: scale(-1, 1);\n}\n\n.fa-flip-vertical {\n  -webkit-transform: scale(1, -1);\n          transform: scale(1, -1);\n}\n\n.fa-flip-both,\n.fa-flip-horizontal.fa-flip-vertical {\n  -webkit-transform: scale(-1, -1);\n          transform: scale(-1, -1);\n}\n\n.fa-rotate-by {\n  -webkit-transform: rotate(var(--fa-rotate-angle, none));\n          transform: rotate(var(--fa-rotate-angle, none));\n}\n\n.fa-stack {\n  display: inline-block;\n  vertical-align: middle;\n  height: 2em;\n  position: relative;\n  width: 2.5em;\n}\n\n.fa-stack-1x,\n.fa-stack-2x {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: var(--fa-stack-z-index, auto);\n}\n\n.svg-inline--fa.fa-stack-1x {\n  height: 1em;\n  width: 1.25em;\n}\n.svg-inline--fa.fa-stack-2x {\n  height: 2em;\n  width: 2.5em;\n}\n\n.fa-inverse {\n  color: var(--fa-inverse, #fff);\n}\n\n.sr-only,\n.fa-sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.sr-only-focusable:not(:focus),\n.fa-sr-only-focusable:not(:focus) {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.svg-inline--fa .fa-primary {\n  fill: var(--fa-primary-color, currentColor);\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa .fa-secondary {\n  fill: var(--fa-secondary-color, currentColor);\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-primary {\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-secondary {\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa mask .fa-primary,\n.svg-inline--fa mask .fa-secondary {\n  fill: black;\n}\n\n.fad.fa-inverse,\n.fa-duotone.fa-inverse {\n  color: var(--fa-inverse, #fff);\n}";

function css() {
  var dfp = DEFAULT_FAMILY_PREFIX;
  var drc = DEFAULT_REPLACEMENT_CLASS;
  var fp = config.familyPrefix;
  var rc = config.replacementClass;
  var s = baseStyles;

  if (fp !== dfp || rc !== drc) {
    var dPatt = new RegExp("\\.".concat(dfp, "\\-"), 'g');
    var customPropPatt = new RegExp("\\--".concat(dfp, "\\-"), 'g');
    var rPatt = new RegExp("\\.".concat(drc), 'g');
    s = s.replace(dPatt, ".".concat(fp, "-")).replace(customPropPatt, "--".concat(fp, "-")).replace(rPatt, ".".concat(rc));
  }

  return s;
}

var _cssInserted = false;

function ensureCss() {
  if (config.autoAddCss && !_cssInserted) {
    insertCss(css());
    _cssInserted = true;
  }
}

var InjectCSS = {
  mixout: function mixout() {
    return {
      dom: {
        css: css,
        insertCss: ensureCss
      }
    };
  },
  hooks: function hooks() {
    return {
      beforeDOMElementCreation: function beforeDOMElementCreation() {
        ensureCss();
      },
      beforeI2svg: function beforeI2svg() {
        ensureCss();
      }
    };
  }
};

var w = WINDOW || {};
if (!w[NAMESPACE_IDENTIFIER]) w[NAMESPACE_IDENTIFIER] = {};
if (!w[NAMESPACE_IDENTIFIER].styles) w[NAMESPACE_IDENTIFIER].styles = {};
if (!w[NAMESPACE_IDENTIFIER].hooks) w[NAMESPACE_IDENTIFIER].hooks = {};
if (!w[NAMESPACE_IDENTIFIER].shims) w[NAMESPACE_IDENTIFIER].shims = [];
var namespace = w[NAMESPACE_IDENTIFIER];

var functions = [];

var listener = function listener() {
  DOCUMENT.removeEventListener('DOMContentLoaded', listener);
  loaded = 1;
  functions.map(function (fn) {
    return fn();
  });
};

var loaded = false;

if (IS_DOM) {
  loaded = (DOCUMENT.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(DOCUMENT.readyState);
  if (!loaded) DOCUMENT.addEventListener('DOMContentLoaded', listener);
}

function domready (fn) {
  if (!IS_DOM) return;
  loaded ? setTimeout(fn, 0) : functions.push(fn);
}

function toHtml(abstractNodes) {
  var tag = abstractNodes.tag,
      _abstractNodes$attrib = abstractNodes.attributes,
      attributes = _abstractNodes$attrib === void 0 ? {} : _abstractNodes$attrib,
      _abstractNodes$childr = abstractNodes.children,
      children = _abstractNodes$childr === void 0 ? [] : _abstractNodes$childr;

  if (typeof abstractNodes === 'string') {
    return htmlEscape(abstractNodes);
  } else {
    return "<".concat(tag, " ").concat(joinAttributes(attributes), ">").concat(children.map(toHtml).join(''), "</").concat(tag, ">");
  }
}

function iconFromMapping(mapping, prefix, iconName) {
  if (mapping && mapping[prefix] && mapping[prefix][iconName]) {
    return {
      prefix: prefix,
      iconName: iconName,
      icon: mapping[prefix][iconName]
    };
  }
}

/**
 * Internal helper to bind a function known to have 4 arguments
 * to a given context.
 */

var bindInternal4 = function bindInternal4(func, thisContext) {
  return function (a, b, c, d) {
    return func.call(thisContext, a, b, c, d);
  };
};

/**
 * # Reduce
 *
 * A fast object `.reduce()` implementation.
 *
 * @param  {Object}   subject      The object to reduce over.
 * @param  {Function} fn           The reducer function.
 * @param  {mixed}    initialValue The initial value for the reducer, defaults to subject[0].
 * @param  {Object}   thisContext  The context for the reducer.
 * @return {mixed}                 The final result.
 */


var reduce = function fastReduceObject(subject, fn, initialValue, thisContext) {
  var keys = Object.keys(subject),
      length = keys.length,
      iterator = thisContext !== undefined ? bindInternal4(fn, thisContext) : fn,
      i,
      key,
      result;

  if (initialValue === undefined) {
    i = 1;
    result = subject[keys[0]];
  } else {
    i = 0;
    result = initialValue;
  }

  for (; i < length; i++) {
    key = keys[i];
    result = iterator(result, subject[key], key, subject);
  }

  return result;
};

/**
 * ucs2decode() and codePointAt() are both works of Mathias Bynens and licensed under MIT
 *
 * Copyright Mathias Bynens <https://mathiasbynens.be/>

 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:

 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */
function ucs2decode(string) {
  var output = [];
  var counter = 0;
  var length = string.length;

  while (counter < length) {
    var value = string.charCodeAt(counter++);

    if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
      var extra = string.charCodeAt(counter++);

      if ((extra & 0xFC00) == 0xDC00) {
        // eslint-disable-line eqeqeq
        output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
      } else {
        output.push(value);
        counter--;
      }
    } else {
      output.push(value);
    }
  }

  return output;
}

function toHex(unicode) {
  var decoded = ucs2decode(unicode);
  return decoded.length === 1 ? decoded[0].toString(16) : null;
}
function codePointAt(string, index) {
  var size = string.length;
  var first = string.charCodeAt(index);
  var second;

  if (first >= 0xD800 && first <= 0xDBFF && size > index + 1) {
    second = string.charCodeAt(index + 1);

    if (second >= 0xDC00 && second <= 0xDFFF) {
      return (first - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
    }
  }

  return first;
}

function normalizeIcons(icons) {
  return Object.keys(icons).reduce(function (acc, iconName) {
    var icon = icons[iconName];
    var expanded = !!icon.icon;

    if (expanded) {
      acc[icon.iconName] = icon.icon;
    } else {
      acc[iconName] = icon;
    }

    return acc;
  }, {});
}

function defineIcons(prefix, icons) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _params$skipHooks = params.skipHooks,
      skipHooks = _params$skipHooks === void 0 ? false : _params$skipHooks;
  var normalized = normalizeIcons(icons);

  if (typeof namespace.hooks.addPack === 'function' && !skipHooks) {
    namespace.hooks.addPack(prefix, normalizeIcons(icons));
  } else {
    namespace.styles[prefix] = _objectSpread2(_objectSpread2({}, namespace.styles[prefix] || {}), normalized);
  }
  /**
   * Font Awesome 4 used the prefix of `fa` for all icons. With the introduction
   * of new styles we needed to differentiate between them. Prefix `fa` is now an alias
   * for `fas` so we'll ease the upgrade process for our users by automatically defining
   * this as well.
   */


  if (prefix === 'fas') {
    defineIcons('fa', icons);
  }
}

var duotonePathRe = [/*#__PURE__*/_wrapRegExp(/path d="((?:(?!")[\s\S])+)".*path d="((?:(?!")[\s\S])+)"/, {
  d1: 1,
  d2: 2
}), /*#__PURE__*/_wrapRegExp(/path class="((?:(?!")[\s\S])+)".*d="((?:(?!")[\s\S])+)".*path class="((?:(?!")[\s\S])+)".*d="((?:(?!")[\s\S])+)"/, {
  cls1: 1,
  d1: 2,
  cls2: 3,
  d2: 4
}), /*#__PURE__*/_wrapRegExp(/path class="((?:(?!")[\s\S])+)".*d="((?:(?!")[\s\S])+)"/, {
  cls1: 1,
  d1: 2
})];

var styles = namespace.styles,
    shims = namespace.shims;
var LONG_STYLE = Object.values(PREFIX_TO_LONG_STYLE);
var _defaultUsablePrefix = null;
var _byUnicode = {};
var _byLigature = {};
var _byOldName = {};
var _byOldUnicode = {};
var _byAlias = {};
var PREFIXES = Object.keys(PREFIX_TO_STYLE);

function isReserved(name) {
  return ~RESERVED_CLASSES.indexOf(name);
}

function getIconName(familyPrefix, cls) {
  var parts = cls.split('-');
  var prefix = parts[0];
  var iconName = parts.slice(1).join('-');

  if (prefix === familyPrefix && iconName !== '' && !isReserved(iconName)) {
    return iconName;
  } else {
    return null;
  }
}
var build = function build() {
  var lookup = function lookup(reducer) {
    return reduce(styles, function (o, style, prefix) {
      o[prefix] = reduce(style, reducer, {});
      return o;
    }, {});
  };

  _byUnicode = lookup(function (acc, icon, iconName) {
    if (icon[3]) {
      acc[icon[3]] = iconName;
    }

    if (icon[2]) {
      var aliases = icon[2].filter(function (a) {
        return typeof a === 'number';
      });
      aliases.forEach(function (alias) {
        acc[alias.toString(16)] = iconName;
      });
    }

    return acc;
  });
  _byLigature = lookup(function (acc, icon, iconName) {
    acc[iconName] = iconName;

    if (icon[2]) {
      var aliases = icon[2].filter(function (a) {
        return typeof a === 'string';
      });
      aliases.forEach(function (alias) {
        acc[alias] = iconName;
      });
    }

    return acc;
  });
  _byAlias = lookup(function (acc, icon, iconName) {
    var aliases = icon[2];
    acc[iconName] = iconName;
    aliases.forEach(function (alias) {
      acc[alias] = iconName;
    });
    return acc;
  }); // If we have a Kit, we can't determine if regular is available since we
  // could be auto-fetching it. We'll have to assume that it is available.

  var hasRegular = 'far' in styles || config.autoFetchSvg;
  var shimLookups = reduce(shims, function (acc, shim) {
    var maybeNameMaybeUnicode = shim[0];
    var prefix = shim[1];
    var iconName = shim[2];

    if (prefix === 'far' && !hasRegular) {
      prefix = 'fas';
    }

    if (typeof maybeNameMaybeUnicode === 'string') {
      acc.names[maybeNameMaybeUnicode] = {
        prefix: prefix,
        iconName: iconName
      };
    }

    if (typeof maybeNameMaybeUnicode === 'number') {
      acc.unicodes[maybeNameMaybeUnicode.toString(16)] = {
        prefix: prefix,
        iconName: iconName
      };
    }

    return acc;
  }, {
    names: {},
    unicodes: {}
  });
  _byOldName = shimLookups.names;
  _byOldUnicode = shimLookups.unicodes;
  _defaultUsablePrefix = getCanonicalPrefix(config.styleDefault);
};
onChange(function (c) {
  _defaultUsablePrefix = getCanonicalPrefix(c.styleDefault);
});
build();
function byUnicode(prefix, unicode) {
  return (_byUnicode[prefix] || {})[unicode];
}
function byLigature(prefix, ligature) {
  return (_byLigature[prefix] || {})[ligature];
}
function byAlias(prefix, alias) {
  return (_byAlias[prefix] || {})[alias];
}
function byOldName(name) {
  return _byOldName[name] || {
    prefix: null,
    iconName: null
  };
}
function byOldUnicode(unicode) {
  var oldUnicode = _byOldUnicode[unicode];
  var newUnicode = byUnicode('fas', unicode);
  return oldUnicode || (newUnicode ? {
    prefix: 'fas',
    iconName: newUnicode
  } : null) || {
    prefix: null,
    iconName: null
  };
}
function getDefaultUsablePrefix() {
  return _defaultUsablePrefix;
}
var emptyCanonicalIcon = function emptyCanonicalIcon() {
  return {
    prefix: null,
    iconName: null,
    rest: []
  };
};
function getCanonicalPrefix(styleOrPrefix) {
  var style = PREFIX_TO_STYLE[styleOrPrefix];
  var prefix = STYLE_TO_PREFIX[styleOrPrefix] || STYLE_TO_PREFIX[style];
  var defined = styleOrPrefix in namespace.styles ? styleOrPrefix : null;
  return prefix || defined || null;
}
function getCanonicalIcon(values) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _params$skipLookups = params.skipLookups,
      skipLookups = _params$skipLookups === void 0 ? false : _params$skipLookups;
  var givenPrefix = null;
  var canonical = values.reduce(function (acc, cls) {
    var iconName = getIconName(config.familyPrefix, cls);

    if (styles[cls]) {
      cls = LONG_STYLE.includes(cls) ? LONG_STYLE_TO_PREFIX[cls] : cls;
      givenPrefix = cls;
      acc.prefix = cls;
    } else if (PREFIXES.indexOf(cls) > -1) {
      givenPrefix = cls;
      acc.prefix = getCanonicalPrefix(cls);
    } else if (iconName) {
      acc.iconName = iconName;
    } else if (cls !== config.replacementClass) {
      acc.rest.push(cls);
    }

    if (!skipLookups && acc.prefix && acc.iconName) {
      var shim = givenPrefix === 'fa' ? byOldName(acc.iconName) : {};
      var aliasIconName = byAlias(acc.prefix, acc.iconName);

      if (shim.prefix) {
        givenPrefix = null;
      }

      acc.iconName = shim.iconName || aliasIconName || acc.iconName;
      acc.prefix = shim.prefix || acc.prefix;

      if (acc.prefix === 'far' && !styles['far'] && styles['fas'] && !config.autoFetchSvg) {
        // Allow a fallback from the regular style to solid if regular is not available
        // but only if we aren't auto-fetching SVGs
        acc.prefix = 'fas';
      }
    }

    return acc;
  }, emptyCanonicalIcon());

  if (canonical.prefix === 'fa' || givenPrefix === 'fa') {
    // The fa prefix is not canonical. So if it has made it through until this point
    // we will shift it to the correct prefix.
    canonical.prefix = getDefaultUsablePrefix() || 'fas';
  }

  return canonical;
}

var Library = /*#__PURE__*/function () {
  function Library() {
    _classCallCheck(this, Library);

    this.definitions = {};
  }

  _createClass(Library, [{
    key: "add",
    value: function add() {
      var _this = this;

      for (var _len = arguments.length, definitions = new Array(_len), _key = 0; _key < _len; _key++) {
        definitions[_key] = arguments[_key];
      }

      var additions = definitions.reduce(this._pullDefinitions, {});
      Object.keys(additions).forEach(function (key) {
        _this.definitions[key] = _objectSpread2(_objectSpread2({}, _this.definitions[key] || {}), additions[key]);
        defineIcons(key, additions[key]);
        var longPrefix = PREFIX_TO_LONG_STYLE[key];
        if (longPrefix) defineIcons(longPrefix, additions[key]);
        build();
      });
    }
  }, {
    key: "reset",
    value: function reset() {
      this.definitions = {};
    }
  }, {
    key: "_pullDefinitions",
    value: function _pullDefinitions(additions, definition) {
      var normalized = definition.prefix && definition.iconName && definition.icon ? {
        0: definition
      } : definition;
      Object.keys(normalized).map(function (key) {
        var _normalized$key = normalized[key],
            prefix = _normalized$key.prefix,
            iconName = _normalized$key.iconName,
            icon = _normalized$key.icon;
        var aliases = icon[2];
        if (!additions[prefix]) additions[prefix] = {};

        if (aliases.length > 0) {
          aliases.forEach(function (alias) {
            if (typeof alias === 'string') {
              additions[prefix][alias] = icon;
            }
          });
        }

        additions[prefix][iconName] = icon;
      });
      return additions;
    }
  }]);

  return Library;
}();

var _plugins = [];
var _hooks = {};
var providers = {};
var defaultProviderKeys = Object.keys(providers);
function registerPlugins(nextPlugins, _ref) {
  var obj = _ref.mixoutsTo;
  _plugins = nextPlugins;
  _hooks = {};
  Object.keys(providers).forEach(function (k) {
    if (defaultProviderKeys.indexOf(k) === -1) {
      delete providers[k];
    }
  });

  _plugins.forEach(function (plugin) {
    var mixout = plugin.mixout ? plugin.mixout() : {};
    Object.keys(mixout).forEach(function (tk) {
      if (typeof mixout[tk] === 'function') {
        obj[tk] = mixout[tk];
      }

      if (_typeof(mixout[tk]) === 'object') {
        Object.keys(mixout[tk]).forEach(function (sk) {
          if (!obj[tk]) {
            obj[tk] = {};
          }

          obj[tk][sk] = mixout[tk][sk];
        });
      }
    });

    if (plugin.hooks) {
      var hooks = plugin.hooks();
      Object.keys(hooks).forEach(function (hook) {
        if (!_hooks[hook]) {
          _hooks[hook] = [];
        }

        _hooks[hook].push(hooks[hook]);
      });
    }

    if (plugin.provides) {
      plugin.provides(providers);
    }
  });

  return obj;
}
function chainHooks(hook, accumulator) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var hookFns = _hooks[hook] || [];
  hookFns.forEach(function (hookFn) {
    accumulator = hookFn.apply(null, [accumulator].concat(args)); // eslint-disable-line no-useless-call
  });
  return accumulator;
}
function callHooks(hook) {
  for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }

  var hookFns = _hooks[hook] || [];
  hookFns.forEach(function (hookFn) {
    hookFn.apply(null, args);
  });
  return undefined;
}
function callProvided() {
  var hook = arguments[0];
  var args = Array.prototype.slice.call(arguments, 1);
  return providers[hook] ? providers[hook].apply(null, args) : undefined;
}

function findIconDefinition(iconLookup) {
  if (iconLookup.prefix === 'fa') {
    iconLookup.prefix = 'fas';
  }

  var iconName = iconLookup.iconName;
  var prefix = iconLookup.prefix || getDefaultUsablePrefix();
  if (!iconName) return;
  iconName = byAlias(prefix, iconName) || iconName;
  return iconFromMapping(library.definitions, prefix, iconName) || iconFromMapping(namespace.styles, prefix, iconName);
}
var library = new Library();
var noAuto = function noAuto() {
  config.autoReplaceSvg = false;
  config.observeMutations = false;
  callHooks('noAuto');
};
var dom = {
  i2svg: function i2svg() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (IS_DOM) {
      callHooks('beforeI2svg', params);
      callProvided('pseudoElements2svg', params);
      return callProvided('i2svg', params);
    } else {
      return Promise.reject('Operation requires a DOM of some kind.');
    }
  },
  watch: function watch() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var autoReplaceSvgRoot = params.autoReplaceSvgRoot;

    if (config.autoReplaceSvg === false) {
      config.autoReplaceSvg = true;
    }

    config.observeMutations = true;
    domready(function () {
      autoReplace({
        autoReplaceSvgRoot: autoReplaceSvgRoot
      });
      callHooks('watch', params);
    });
  }
};
var parse = {
  icon: function icon(_icon) {
    if (_icon === null) {
      return null;
    }

    if (_typeof(_icon) === 'object' && _icon.prefix && _icon.iconName) {
      return {
        prefix: _icon.prefix,
        iconName: byAlias(_icon.prefix, _icon.iconName) || _icon.iconName
      };
    }

    if (Array.isArray(_icon) && _icon.length === 2) {
      var iconName = _icon[1].indexOf('fa-') === 0 ? _icon[1].slice(3) : _icon[1];
      var prefix = getCanonicalPrefix(_icon[0]);
      return {
        prefix: prefix,
        iconName: byAlias(prefix, iconName) || iconName
      };
    }

    if (typeof _icon === 'string' && (_icon.indexOf("".concat(config.familyPrefix, "-")) > -1 || _icon.match(ICON_SELECTION_SYNTAX_PATTERN))) {
      var canonicalIcon = getCanonicalIcon(_icon.split(' '), {
        skipLookups: true
      });
      return {
        prefix: canonicalIcon.prefix || getDefaultUsablePrefix(),
        iconName: byAlias(canonicalIcon.prefix, canonicalIcon.iconName) || canonicalIcon.iconName
      };
    }

    if (typeof _icon === 'string') {
      var _prefix = getDefaultUsablePrefix();

      return {
        prefix: _prefix,
        iconName: byAlias(_prefix, _icon) || _icon
      };
    }
  }
};
var api = {
  noAuto: noAuto,
  config: config,
  dom: dom,
  parse: parse,
  library: library,
  findIconDefinition: findIconDefinition,
  toHtml: toHtml
};

var autoReplace = function autoReplace() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _params$autoReplaceSv = params.autoReplaceSvgRoot,
      autoReplaceSvgRoot = _params$autoReplaceSv === void 0 ? DOCUMENT : _params$autoReplaceSv;
  if ((Object.keys(namespace.styles).length > 0 || config.autoFetchSvg) && IS_DOM && config.autoReplaceSvg) api.dom.i2svg({
    node: autoReplaceSvgRoot
  });
};

function domVariants(val, abstractCreator) {
  Object.defineProperty(val, 'abstract', {
    get: abstractCreator
  });
  Object.defineProperty(val, 'html', {
    get: function get() {
      return val.abstract.map(function (a) {
        return toHtml(a);
      });
    }
  });
  Object.defineProperty(val, 'node', {
    get: function get() {
      if (!IS_DOM) return;
      var container = DOCUMENT.createElement('div');
      container.innerHTML = val.html;
      return container.children;
    }
  });
  return val;
}

function asIcon (_ref) {
  var children = _ref.children,
      main = _ref.main,
      mask = _ref.mask,
      attributes = _ref.attributes,
      styles = _ref.styles,
      transform = _ref.transform;

  if (transformIsMeaningful(transform) && main.found && !mask.found) {
    var width = main.width,
        height = main.height;
    var offset = {
      x: width / height / 2,
      y: 0.5
    };
    attributes['style'] = joinStyles(_objectSpread2(_objectSpread2({}, styles), {}, {
      'transform-origin': "".concat(offset.x + transform.x / 16, "em ").concat(offset.y + transform.y / 16, "em")
    }));
  }

  return [{
    tag: 'svg',
    attributes: attributes,
    children: children
  }];
}

function asSymbol (_ref) {
  var prefix = _ref.prefix,
      iconName = _ref.iconName,
      children = _ref.children,
      attributes = _ref.attributes,
      symbol = _ref.symbol;
  var id = symbol === true ? "".concat(prefix, "-").concat(config.familyPrefix, "-").concat(iconName) : symbol;
  return [{
    tag: 'svg',
    attributes: {
      style: 'display: none;'
    },
    children: [{
      tag: 'symbol',
      attributes: _objectSpread2(_objectSpread2({}, attributes), {}, {
        id: id
      }),
      children: children
    }]
  }];
}

function makeInlineSvgAbstract(params) {
  var _params$icons = params.icons,
      main = _params$icons.main,
      mask = _params$icons.mask,
      prefix = params.prefix,
      iconName = params.iconName,
      transform = params.transform,
      symbol = params.symbol,
      title = params.title,
      maskId = params.maskId,
      titleId = params.titleId,
      extra = params.extra,
      _params$watchable = params.watchable,
      watchable = _params$watchable === void 0 ? false : _params$watchable;

  var _ref = mask.found ? mask : main,
      width = _ref.width,
      height = _ref.height;

  var isUploadedIcon = prefix === 'fak';
  var attrClass = [config.replacementClass, iconName ? "".concat(config.familyPrefix, "-").concat(iconName) : ''].filter(function (c) {
    return extra.classes.indexOf(c) === -1;
  }).filter(function (c) {
    return c !== '' || !!c;
  }).concat(extra.classes).join(' ');
  var content = {
    children: [],
    attributes: _objectSpread2(_objectSpread2({}, extra.attributes), {}, {
      'data-prefix': prefix,
      'data-icon': iconName,
      'class': attrClass,
      'role': extra.attributes.role || 'img',
      'xmlns': 'http://www.w3.org/2000/svg',
      'viewBox': "0 0 ".concat(width, " ").concat(height)
    })
  };
  var uploadedIconWidthStyle = isUploadedIcon && !~extra.classes.indexOf('fa-fw') ? {
    width: "".concat(width / height * 16 * 0.0625, "em")
  } : {};

  if (watchable) {
    content.attributes[DATA_FA_I2SVG] = '';
  }

  if (title) {
    content.children.push({
      tag: 'title',
      attributes: {
        id: content.attributes['aria-labelledby'] || "title-".concat(titleId || nextUniqueId())
      },
      children: [title]
    });
    delete content.attributes.title;
  }

  var args = _objectSpread2(_objectSpread2({}, content), {}, {
    prefix: prefix,
    iconName: iconName,
    main: main,
    mask: mask,
    maskId: maskId,
    transform: transform,
    symbol: symbol,
    styles: _objectSpread2(_objectSpread2({}, uploadedIconWidthStyle), extra.styles)
  });

  var _ref2 = mask.found && main.found ? callProvided('generateAbstractMask', args) || {
    children: [],
    attributes: {}
  } : callProvided('generateAbstractIcon', args) || {
    children: [],
    attributes: {}
  },
      children = _ref2.children,
      attributes = _ref2.attributes;

  args.children = children;
  args.attributes = attributes;

  if (symbol) {
    return asSymbol(args);
  } else {
    return asIcon(args);
  }
}
function makeLayersTextAbstract(params) {
  var content = params.content,
      width = params.width,
      height = params.height,
      transform = params.transform,
      title = params.title,
      extra = params.extra,
      _params$watchable2 = params.watchable,
      watchable = _params$watchable2 === void 0 ? false : _params$watchable2;

  var attributes = _objectSpread2(_objectSpread2(_objectSpread2({}, extra.attributes), title ? {
    'title': title
  } : {}), {}, {
    'class': extra.classes.join(' ')
  });

  if (watchable) {
    attributes[DATA_FA_I2SVG] = '';
  }

  var styles = _objectSpread2({}, extra.styles);

  if (transformIsMeaningful(transform)) {
    styles['transform'] = transformForCss({
      transform: transform,
      startCentered: true,
      width: width,
      height: height
    });
    styles['-webkit-transform'] = styles['transform'];
  }

  var styleString = joinStyles(styles);

  if (styleString.length > 0) {
    attributes['style'] = styleString;
  }

  var val = [];
  val.push({
    tag: 'span',
    attributes: attributes,
    children: [content]
  });

  if (title) {
    val.push({
      tag: 'span',
      attributes: {
        class: 'sr-only'
      },
      children: [title]
    });
  }

  return val;
}
function makeLayersCounterAbstract(params) {
  var content = params.content,
      title = params.title,
      extra = params.extra;

  var attributes = _objectSpread2(_objectSpread2(_objectSpread2({}, extra.attributes), title ? {
    'title': title
  } : {}), {}, {
    'class': extra.classes.join(' ')
  });

  var styleString = joinStyles(extra.styles);

  if (styleString.length > 0) {
    attributes['style'] = styleString;
  }

  var val = [];
  val.push({
    tag: 'span',
    attributes: attributes,
    children: [content]
  });

  if (title) {
    val.push({
      tag: 'span',
      attributes: {
        class: 'sr-only'
      },
      children: [title]
    });
  }

  return val;
}

var styles$1 = namespace.styles;
function asFoundIcon(icon) {
  var width = icon[0];
  var height = icon[1];

  var _icon$slice = icon.slice(4),
      _icon$slice2 = _slicedToArray(_icon$slice, 1),
      vectorData = _icon$slice2[0];

  var element = null;

  if (Array.isArray(vectorData)) {
    element = {
      tag: 'g',
      attributes: {
        class: "".concat(config.familyPrefix, "-").concat(DUOTONE_CLASSES.GROUP)
      },
      children: [{
        tag: 'path',
        attributes: {
          class: "".concat(config.familyPrefix, "-").concat(DUOTONE_CLASSES.SECONDARY),
          fill: 'currentColor',
          d: vectorData[0]
        }
      }, {
        tag: 'path',
        attributes: {
          class: "".concat(config.familyPrefix, "-").concat(DUOTONE_CLASSES.PRIMARY),
          fill: 'currentColor',
          d: vectorData[1]
        }
      }]
    };
  } else {
    element = {
      tag: 'path',
      attributes: {
        fill: 'currentColor',
        d: vectorData
      }
    };
  }

  return {
    found: true,
    width: width,
    height: height,
    icon: element
  };
}
var missingIconResolutionMixin = {
  found: false,
  width: 512,
  height: 512
};

function maybeNotifyMissing(iconName, prefix) {
  if (!PRODUCTION && !config.showMissingIcons && iconName) {
    console.error("Icon with name \"".concat(iconName, "\" and prefix \"").concat(prefix, "\" is missing."));
  }
}

function findIcon(iconName, prefix) {
  var givenPrefix = prefix;

  if (prefix === 'fa' && config.styleDefault !== null) {
    prefix = getDefaultUsablePrefix();
  }

  return new Promise(function (resolve, reject) {
    var val = {
      found: false,
      width: 512,
      height: 512,
      icon: callProvided('missingIconAbstract') || {}
    };

    if (givenPrefix === 'fa') {
      var shim = byOldName(iconName) || {};
      iconName = shim.iconName || iconName;
      prefix = shim.prefix || prefix;
    }

    if (iconName && prefix && styles$1[prefix] && styles$1[prefix][iconName]) {
      var icon = styles$1[prefix][iconName];
      return resolve(asFoundIcon(icon));
    }

    maybeNotifyMissing(iconName, prefix);
    resolve(_objectSpread2(_objectSpread2({}, missingIconResolutionMixin), {}, {
      icon: config.showMissingIcons && iconName ? callProvided('missingIconAbstract') || {} : {}
    }));
  });
}

var noop$1 = function noop() {};

var p = config.measurePerformance && PERFORMANCE && PERFORMANCE.mark && PERFORMANCE.measure ? PERFORMANCE : {
  mark: noop$1,
  measure: noop$1
};
var preamble = "FA \"6.0.0\"";

var begin = function begin(name) {
  p.mark("".concat(preamble, " ").concat(name, " begins"));
  return function () {
    return end(name);
  };
};

var end = function end(name) {
  p.mark("".concat(preamble, " ").concat(name, " ends"));
  p.measure("".concat(preamble, " ").concat(name), "".concat(preamble, " ").concat(name, " begins"), "".concat(preamble, " ").concat(name, " ends"));
};

var perf = {
  begin: begin,
  end: end
};

var noop$2 = function noop() {};

function isWatched(node) {
  var i2svg = node.getAttribute ? node.getAttribute(DATA_FA_I2SVG) : null;
  return typeof i2svg === 'string';
}

function hasPrefixAndIcon(node) {
  var prefix = node.getAttribute ? node.getAttribute(DATA_PREFIX) : null;
  var icon = node.getAttribute ? node.getAttribute(DATA_ICON) : null;
  return prefix && icon;
}

function hasBeenReplaced(node) {
  return node && node.classList && node.classList.contains && node.classList.contains(config.replacementClass);
}

function getMutator() {
  if (config.autoReplaceSvg === true) {
    return mutators.replace;
  }

  var mutator = mutators[config.autoReplaceSvg];
  return mutator || mutators.replace;
}

function createElementNS(tag) {
  return DOCUMENT.createElementNS('http://www.w3.org/2000/svg', tag);
}

function createElement(tag) {
  return DOCUMENT.createElement(tag);
}

function convertSVG(abstractObj) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _params$ceFn = params.ceFn,
      ceFn = _params$ceFn === void 0 ? abstractObj.tag === 'svg' ? createElementNS : createElement : _params$ceFn;

  if (typeof abstractObj === 'string') {
    return DOCUMENT.createTextNode(abstractObj);
  }

  var tag = ceFn(abstractObj.tag);
  Object.keys(abstractObj.attributes || []).forEach(function (key) {
    tag.setAttribute(key, abstractObj.attributes[key]);
  });
  var children = abstractObj.children || [];
  children.forEach(function (child) {
    tag.appendChild(convertSVG(child, {
      ceFn: ceFn
    }));
  });
  return tag;
}

function nodeAsComment(node) {
  var comment = " ".concat(node.outerHTML, " ");
  /* BEGIN.ATTRIBUTION */

  comment = "".concat(comment, "Font Awesome fontawesome.com ");
  /* END.ATTRIBUTION */

  return comment;
}

var mutators = {
  replace: function replace(mutation) {
    var node = mutation[0];

    if (node.parentNode) {
      mutation[1].forEach(function (abstract) {
        node.parentNode.insertBefore(convertSVG(abstract), node);
      });

      if (node.getAttribute(DATA_FA_I2SVG) === null && config.keepOriginalSource) {
        var comment = DOCUMENT.createComment(nodeAsComment(node));
        node.parentNode.replaceChild(comment, node);
      } else {
        node.remove();
      }
    }
  },
  nest: function nest(mutation) {
    var node = mutation[0];
    var abstract = mutation[1]; // If we already have a replaced node we do not want to continue nesting within it.
    // Short-circuit to the standard replacement

    if (~classArray(node).indexOf(config.replacementClass)) {
      return mutators.replace(mutation);
    }

    var forSvg = new RegExp("".concat(config.familyPrefix, "-.*"));
    delete abstract[0].attributes.id;

    if (abstract[0].attributes.class) {
      var splitClasses = abstract[0].attributes.class.split(' ').reduce(function (acc, cls) {
        if (cls === config.replacementClass || cls.match(forSvg)) {
          acc.toSvg.push(cls);
        } else {
          acc.toNode.push(cls);
        }

        return acc;
      }, {
        toNode: [],
        toSvg: []
      });
      abstract[0].attributes.class = splitClasses.toSvg.join(' ');

      if (splitClasses.toNode.length === 0) {
        node.removeAttribute('class');
      } else {
        node.setAttribute('class', splitClasses.toNode.join(' '));
      }
    }

    var newInnerHTML = abstract.map(function (a) {
      return toHtml(a);
    }).join('\n');
    node.setAttribute(DATA_FA_I2SVG, '');
    node.innerHTML = newInnerHTML;
  }
};

function performOperationSync(op) {
  op();
}

function perform(mutations, callback) {
  var callbackFunction = typeof callback === 'function' ? callback : noop$2;

  if (mutations.length === 0) {
    callbackFunction();
  } else {
    var frame = performOperationSync;

    if (config.mutateApproach === MUTATION_APPROACH_ASYNC) {
      frame = WINDOW.requestAnimationFrame || performOperationSync;
    }

    frame(function () {
      var mutator = getMutator();
      var mark = perf.begin('mutate');
      mutations.map(mutator);
      mark();
      callbackFunction();
    });
  }
}
var disabled = false;
function disableObservation() {
  disabled = true;
}
function enableObservation() {
  disabled = false;
}
var mo = null;
function observe(options) {
  if (!MUTATION_OBSERVER) {
    return;
  }

  if (!config.observeMutations) {
    return;
  }

  var _options$treeCallback = options.treeCallback,
      treeCallback = _options$treeCallback === void 0 ? noop$2 : _options$treeCallback,
      _options$nodeCallback = options.nodeCallback,
      nodeCallback = _options$nodeCallback === void 0 ? noop$2 : _options$nodeCallback,
      _options$pseudoElemen = options.pseudoElementsCallback,
      pseudoElementsCallback = _options$pseudoElemen === void 0 ? noop$2 : _options$pseudoElemen,
      _options$observeMutat = options.observeMutationsRoot,
      observeMutationsRoot = _options$observeMutat === void 0 ? DOCUMENT : _options$observeMutat;
  mo = new MUTATION_OBSERVER(function (objects) {
    if (disabled) return;
    var defaultPrefix = getDefaultUsablePrefix();
    toArray(objects).forEach(function (mutationRecord) {
      if (mutationRecord.type === 'childList' && mutationRecord.addedNodes.length > 0 && !isWatched(mutationRecord.addedNodes[0])) {
        if (config.searchPseudoElements) {
          pseudoElementsCallback(mutationRecord.target);
        }

        treeCallback(mutationRecord.target);
      }

      if (mutationRecord.type === 'attributes' && mutationRecord.target.parentNode && config.searchPseudoElements) {
        pseudoElementsCallback(mutationRecord.target.parentNode);
      }

      if (mutationRecord.type === 'attributes' && isWatched(mutationRecord.target) && ~ATTRIBUTES_WATCHED_FOR_MUTATION.indexOf(mutationRecord.attributeName)) {
        if (mutationRecord.attributeName === 'class' && hasPrefixAndIcon(mutationRecord.target)) {
          var _getCanonicalIcon = getCanonicalIcon(classArray(mutationRecord.target)),
              prefix = _getCanonicalIcon.prefix,
              iconName = _getCanonicalIcon.iconName;

          mutationRecord.target.setAttribute(DATA_PREFIX, prefix || defaultPrefix);
          if (iconName) mutationRecord.target.setAttribute(DATA_ICON, iconName);
        } else if (hasBeenReplaced(mutationRecord.target)) {
          nodeCallback(mutationRecord.target);
        }
      }
    });
  });
  if (!IS_DOM) return;
  mo.observe(observeMutationsRoot, {
    childList: true,
    attributes: true,
    characterData: true,
    subtree: true
  });
}
function disconnect() {
  if (!mo) return;
  mo.disconnect();
}

function styleParser (node) {
  var style = node.getAttribute('style');
  var val = [];

  if (style) {
    val = style.split(';').reduce(function (acc, style) {
      var styles = style.split(':');
      var prop = styles[0];
      var value = styles.slice(1);

      if (prop && value.length > 0) {
        acc[prop] = value.join(':').trim();
      }

      return acc;
    }, {});
  }

  return val;
}

function classParser (node) {
  var existingPrefix = node.getAttribute('data-prefix');
  var existingIconName = node.getAttribute('data-icon');
  var innerText = node.innerText !== undefined ? node.innerText.trim() : '';
  var val = getCanonicalIcon(classArray(node));

  if (!val.prefix) {
    val.prefix = getDefaultUsablePrefix();
  }

  if (existingPrefix && existingIconName) {
    val.prefix = existingPrefix;
    val.iconName = existingIconName;
  }

  if (val.iconName && val.prefix) {
    return val;
  }

  if (val.prefix && innerText.length > 0) {
    val.iconName = byLigature(val.prefix, node.innerText) || byUnicode(val.prefix, toHex(node.innerText));
  }

  return val;
}

function attributesParser (node) {
  var extraAttributes = toArray(node.attributes).reduce(function (acc, attr) {
    if (acc.name !== 'class' && acc.name !== 'style') {
      acc[attr.name] = attr.value;
    }

    return acc;
  }, {});
  var title = node.getAttribute('title');
  var titleId = node.getAttribute('data-fa-title-id');

  if (config.autoA11y) {
    if (title) {
      extraAttributes['aria-labelledby'] = "".concat(config.replacementClass, "-title-").concat(titleId || nextUniqueId());
    } else {
      extraAttributes['aria-hidden'] = 'true';
      extraAttributes['focusable'] = 'false';
    }
  }

  return extraAttributes;
}

function blankMeta() {
  return {
    iconName: null,
    title: null,
    titleId: null,
    prefix: null,
    transform: meaninglessTransform,
    symbol: false,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    extra: {
      classes: [],
      styles: {},
      attributes: {}
    }
  };
}
function parseMeta(node) {
  var parser = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    styleParser: true
  };

  var _classParser = classParser(node),
      iconName = _classParser.iconName,
      prefix = _classParser.prefix,
      extraClasses = _classParser.rest;

  var extraAttributes = attributesParser(node);
  var pluginMeta = chainHooks('parseNodeAttributes', {}, node);
  var extraStyles = parser.styleParser ? styleParser(node) : [];
  return _objectSpread2({
    iconName: iconName,
    title: node.getAttribute('title'),
    titleId: node.getAttribute('data-fa-title-id'),
    prefix: prefix,
    transform: meaninglessTransform,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    symbol: false,
    extra: {
      classes: extraClasses,
      styles: extraStyles,
      attributes: extraAttributes
    }
  }, pluginMeta);
}

var styles$2 = namespace.styles;

function generateMutation(node) {
  var nodeMeta = config.autoReplaceSvg === 'nest' ? parseMeta(node, {
    styleParser: false
  }) : parseMeta(node);

  if (~nodeMeta.extra.classes.indexOf(LAYERS_TEXT_CLASSNAME)) {
    return callProvided('generateLayersText', node, nodeMeta);
  } else {
    return callProvided('generateSvgReplacementMutation', node, nodeMeta);
  }
}

function onTree(root) {
  var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  if (!IS_DOM) return Promise.resolve();
  var htmlClassList = DOCUMENT.documentElement.classList;

  var hclAdd = function hclAdd(suffix) {
    return htmlClassList.add("".concat(HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
  };

  var hclRemove = function hclRemove(suffix) {
    return htmlClassList.remove("".concat(HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
  };

  var prefixes = config.autoFetchSvg ? Object.keys(PREFIX_TO_STYLE) : Object.keys(styles$2);
  var prefixesDomQuery = [".".concat(LAYERS_TEXT_CLASSNAME, ":not([").concat(DATA_FA_I2SVG, "])")].concat(prefixes.map(function (p) {
    return ".".concat(p, ":not([").concat(DATA_FA_I2SVG, "])");
  })).join(', ');

  if (prefixesDomQuery.length === 0) {
    return Promise.resolve();
  }

  var candidates = [];

  try {
    candidates = toArray(root.querySelectorAll(prefixesDomQuery));
  } catch (e) {// noop
  }

  if (candidates.length > 0) {
    hclAdd('pending');
    hclRemove('complete');
  } else {
    return Promise.resolve();
  }

  var mark = perf.begin('onTree');
  var mutations = candidates.reduce(function (acc, node) {
    try {
      var mutation = generateMutation(node);

      if (mutation) {
        acc.push(mutation);
      }
    } catch (e) {
      if (!PRODUCTION) {
        if (e.name === 'MissingIcon') {
          console.error(e);
        }
      }
    }

    return acc;
  }, []);
  return new Promise(function (resolve, reject) {
    Promise.all(mutations).then(function (resolvedMutations) {
      perform(resolvedMutations, function () {
        hclAdd('active');
        hclAdd('complete');
        hclRemove('pending');
        if (typeof callback === 'function') callback();
        mark();
        resolve();
      });
    }).catch(function (e) {
      mark();
      reject(e);
    });
  });
}

function onNode(node) {
  var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  generateMutation(node).then(function (mutation) {
    if (mutation) {
      perform([mutation], callback);
    }
  });
}

function resolveIcons(next) {
  return function (maybeIconDefinition) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var iconDefinition = (maybeIconDefinition || {}).icon ? maybeIconDefinition : findIconDefinition(maybeIconDefinition || {});
    var mask = params.mask;

    if (mask) {
      mask = (mask || {}).icon ? mask : findIconDefinition(mask || {});
    }

    return next(iconDefinition, _objectSpread2(_objectSpread2({}, params), {}, {
      mask: mask
    }));
  };
}

var render = function render(iconDefinition) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _params$transform = params.transform,
      transform = _params$transform === void 0 ? meaninglessTransform : _params$transform,
      _params$symbol = params.symbol,
      symbol = _params$symbol === void 0 ? false : _params$symbol,
      _params$mask = params.mask,
      mask = _params$mask === void 0 ? null : _params$mask,
      _params$maskId = params.maskId,
      maskId = _params$maskId === void 0 ? null : _params$maskId,
      _params$title = params.title,
      title = _params$title === void 0 ? null : _params$title,
      _params$titleId = params.titleId,
      titleId = _params$titleId === void 0 ? null : _params$titleId,
      _params$classes = params.classes,
      classes = _params$classes === void 0 ? [] : _params$classes,
      _params$attributes = params.attributes,
      attributes = _params$attributes === void 0 ? {} : _params$attributes,
      _params$styles = params.styles,
      styles = _params$styles === void 0 ? {} : _params$styles;
  if (!iconDefinition) return;
  var prefix = iconDefinition.prefix,
      iconName = iconDefinition.iconName,
      icon = iconDefinition.icon;
  return domVariants(_objectSpread2({
    type: 'icon'
  }, iconDefinition), function () {
    callHooks('beforeDOMElementCreation', {
      iconDefinition: iconDefinition,
      params: params
    });

    if (config.autoA11y) {
      if (title) {
        attributes['aria-labelledby'] = "".concat(config.replacementClass, "-title-").concat(titleId || nextUniqueId());
      } else {
        attributes['aria-hidden'] = 'true';
        attributes['focusable'] = 'false';
      }
    }

    return makeInlineSvgAbstract({
      icons: {
        main: asFoundIcon(icon),
        mask: mask ? asFoundIcon(mask.icon) : {
          found: false,
          width: null,
          height: null,
          icon: {}
        }
      },
      prefix: prefix,
      iconName: iconName,
      transform: _objectSpread2(_objectSpread2({}, meaninglessTransform), transform),
      symbol: symbol,
      title: title,
      maskId: maskId,
      titleId: titleId,
      extra: {
        attributes: attributes,
        styles: styles,
        classes: classes
      }
    });
  });
};
var ReplaceElements = {
  mixout: function mixout() {
    return {
      icon: resolveIcons(render)
    };
  },
  hooks: function hooks() {
    return {
      mutationObserverCallbacks: function mutationObserverCallbacks(accumulator) {
        accumulator.treeCallback = onTree;
        accumulator.nodeCallback = onNode;
        return accumulator;
      }
    };
  },
  provides: function provides(providers$$1) {
    providers$$1.i2svg = function (params) {
      var _params$node = params.node,
          node = _params$node === void 0 ? DOCUMENT : _params$node,
          _params$callback = params.callback,
          callback = _params$callback === void 0 ? function () {} : _params$callback;
      return onTree(node, callback);
    };

    providers$$1.generateSvgReplacementMutation = function (node, nodeMeta) {
      var iconName = nodeMeta.iconName,
          title = nodeMeta.title,
          titleId = nodeMeta.titleId,
          prefix = nodeMeta.prefix,
          transform = nodeMeta.transform,
          symbol = nodeMeta.symbol,
          mask = nodeMeta.mask,
          maskId = nodeMeta.maskId,
          extra = nodeMeta.extra;
      return new Promise(function (resolve, reject) {
        Promise.all([findIcon(iconName, prefix), mask.iconName ? findIcon(mask.iconName, mask.prefix) : Promise.resolve({
          found: false,
          width: 512,
          height: 512,
          icon: {}
        })]).then(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
              main = _ref2[0],
              mask = _ref2[1];

          resolve([node, makeInlineSvgAbstract({
            icons: {
              main: main,
              mask: mask
            },
            prefix: prefix,
            iconName: iconName,
            transform: transform,
            symbol: symbol,
            maskId: maskId,
            title: title,
            titleId: titleId,
            extra: extra,
            watchable: true
          })]);
        }).catch(reject);
      });
    };

    providers$$1.generateAbstractIcon = function (_ref3) {
      var children = _ref3.children,
          attributes = _ref3.attributes,
          main = _ref3.main,
          transform = _ref3.transform,
          styles = _ref3.styles;
      var styleString = joinStyles(styles);

      if (styleString.length > 0) {
        attributes['style'] = styleString;
      }

      var nextChild;

      if (transformIsMeaningful(transform)) {
        nextChild = callProvided('generateAbstractTransformGrouping', {
          main: main,
          transform: transform,
          containerWidth: main.width,
          iconWidth: main.width
        });
      }

      children.push(nextChild || main.icon);
      return {
        children: children,
        attributes: attributes
      };
    };
  }
};

var Layers = {
  mixout: function mixout() {
    return {
      layer: function layer(assembler) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var _params$classes = params.classes,
            classes = _params$classes === void 0 ? [] : _params$classes;
        return domVariants({
          type: 'layer'
        }, function () {
          callHooks('beforeDOMElementCreation', {
            assembler: assembler,
            params: params
          });
          var children = [];
          assembler(function (args) {
            Array.isArray(args) ? args.map(function (a) {
              children = children.concat(a.abstract);
            }) : children = children.concat(args.abstract);
          });
          return [{
            tag: 'span',
            attributes: {
              class: ["".concat(config.familyPrefix, "-layers")].concat(_toConsumableArray(classes)).join(' ')
            },
            children: children
          }];
        });
      }
    };
  }
};

var LayersCounter = {
  mixout: function mixout() {
    return {
      counter: function counter(content) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var _params$title = params.title,
            title = _params$title === void 0 ? null : _params$title,
            _params$classes = params.classes,
            classes = _params$classes === void 0 ? [] : _params$classes,
            _params$attributes = params.attributes,
            attributes = _params$attributes === void 0 ? {} : _params$attributes,
            _params$styles = params.styles,
            styles = _params$styles === void 0 ? {} : _params$styles;
        return domVariants({
          type: 'counter',
          content: content
        }, function () {
          callHooks('beforeDOMElementCreation', {
            content: content,
            params: params
          });
          return makeLayersCounterAbstract({
            content: content.toString(),
            title: title,
            extra: {
              attributes: attributes,
              styles: styles,
              classes: ["".concat(config.familyPrefix, "-layers-counter")].concat(_toConsumableArray(classes))
            }
          });
        });
      }
    };
  }
};

var LayersText = {
  mixout: function mixout() {
    return {
      text: function text(content) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var _params$transform = params.transform,
            transform = _params$transform === void 0 ? meaninglessTransform : _params$transform,
            _params$title = params.title,
            title = _params$title === void 0 ? null : _params$title,
            _params$classes = params.classes,
            classes = _params$classes === void 0 ? [] : _params$classes,
            _params$attributes = params.attributes,
            attributes = _params$attributes === void 0 ? {} : _params$attributes,
            _params$styles = params.styles,
            styles = _params$styles === void 0 ? {} : _params$styles;
        return domVariants({
          type: 'text',
          content: content
        }, function () {
          callHooks('beforeDOMElementCreation', {
            content: content,
            params: params
          });
          return makeLayersTextAbstract({
            content: content,
            transform: _objectSpread2(_objectSpread2({}, meaninglessTransform), transform),
            title: title,
            extra: {
              attributes: attributes,
              styles: styles,
              classes: ["".concat(config.familyPrefix, "-layers-text")].concat(_toConsumableArray(classes))
            }
          });
        });
      }
    };
  },
  provides: function provides(providers$$1) {
    providers$$1.generateLayersText = function (node, nodeMeta) {
      var title = nodeMeta.title,
          transform = nodeMeta.transform,
          extra = nodeMeta.extra;
      var width = null;
      var height = null;

      if (IS_IE) {
        var computedFontSize = parseInt(getComputedStyle(node).fontSize, 10);
        var boundingClientRect = node.getBoundingClientRect();
        width = boundingClientRect.width / computedFontSize;
        height = boundingClientRect.height / computedFontSize;
      }

      if (config.autoA11y && !title) {
        extra.attributes['aria-hidden'] = 'true';
      }

      return Promise.resolve([node, makeLayersTextAbstract({
        content: node.innerHTML,
        width: width,
        height: height,
        transform: transform,
        title: title,
        extra: extra,
        watchable: true
      })]);
    };
  }
};

var CLEAN_CONTENT_PATTERN = new RegExp("\"", 'ug');
var SECONDARY_UNICODE_RANGE = [1105920, 1112319];
function hexValueFromContent(content) {
  var cleaned = content.replace(CLEAN_CONTENT_PATTERN, '');
  var codePoint = codePointAt(cleaned, 0);
  var isPrependTen = codePoint >= SECONDARY_UNICODE_RANGE[0] && codePoint <= SECONDARY_UNICODE_RANGE[1];
  var isDoubled = cleaned.length === 2 ? cleaned[0] === cleaned[1] : false;
  return {
    value: isDoubled ? toHex(cleaned[0]) : toHex(cleaned),
    isSecondary: isPrependTen || isDoubled
  };
}

function replaceForPosition(node, position) {
  var pendingAttribute = "".concat(DATA_FA_PSEUDO_ELEMENT_PENDING).concat(position.replace(':', '-'));
  return new Promise(function (resolve, reject) {
    if (node.getAttribute(pendingAttribute) !== null) {
      // This node is already being processed
      return resolve();
    }

    var children = toArray(node.children);
    var alreadyProcessedPseudoElement = children.filter(function (c) {
      return c.getAttribute(DATA_FA_PSEUDO_ELEMENT) === position;
    })[0];
    var styles = WINDOW.getComputedStyle(node, position);
    var fontFamily = styles.getPropertyValue('font-family').match(FONT_FAMILY_PATTERN);
    var fontWeight = styles.getPropertyValue('font-weight');
    var content = styles.getPropertyValue('content');

    if (alreadyProcessedPseudoElement && !fontFamily) {
      // If we've already processed it but the current computed style does not result in a font-family,
      // that probably means that a class name that was previously present to make the icon has been
      // removed. So we now should delete the icon.
      node.removeChild(alreadyProcessedPseudoElement);
      return resolve();
    } else if (fontFamily && content !== 'none' && content !== '') {
      var _content = styles.getPropertyValue('content');

      var prefix = ~['Solid', 'Regular', 'Light', 'Thin', 'Duotone', 'Brands', 'Kit'].indexOf(fontFamily[2]) ? STYLE_TO_PREFIX[fontFamily[2].toLowerCase()] : FONT_WEIGHT_TO_PREFIX[fontWeight];

      var _hexValueFromContent = hexValueFromContent(_content),
          hexValue = _hexValueFromContent.value,
          isSecondary = _hexValueFromContent.isSecondary;

      var isV4 = fontFamily[0].startsWith('FontAwesome');
      var iconName = byUnicode(prefix, hexValue);
      var iconIdentifier = iconName;

      if (isV4) {
        var iconName4 = byOldUnicode(hexValue);

        if (iconName4.iconName && iconName4.prefix) {
          iconName = iconName4.iconName;
          prefix = iconName4.prefix;
        }
      } // Only convert the pseudo element in this ::before/::after position into an icon if we haven't
      // already done so with the same prefix and iconName


      if (iconName && !isSecondary && (!alreadyProcessedPseudoElement || alreadyProcessedPseudoElement.getAttribute(DATA_PREFIX) !== prefix || alreadyProcessedPseudoElement.getAttribute(DATA_ICON) !== iconIdentifier)) {
        node.setAttribute(pendingAttribute, iconIdentifier);

        if (alreadyProcessedPseudoElement) {
          // Delete the old one, since we're replacing it with a new one
          node.removeChild(alreadyProcessedPseudoElement);
        }

        var meta = blankMeta();
        var extra = meta.extra;
        extra.attributes[DATA_FA_PSEUDO_ELEMENT] = position;
        findIcon(iconName, prefix).then(function (main) {
          var abstract = makeInlineSvgAbstract(_objectSpread2(_objectSpread2({}, meta), {}, {
            icons: {
              main: main,
              mask: emptyCanonicalIcon()
            },
            prefix: prefix,
            iconName: iconIdentifier,
            extra: extra,
            watchable: true
          }));
          var element = DOCUMENT.createElement('svg');

          if (position === '::before') {
            node.insertBefore(element, node.firstChild);
          } else {
            node.appendChild(element);
          }

          element.outerHTML = abstract.map(function (a) {
            return toHtml(a);
          }).join('\n');
          node.removeAttribute(pendingAttribute);
          resolve();
        }).catch(reject);
      } else {
        resolve();
      }
    } else {
      resolve();
    }
  });
}

function replace(node) {
  return Promise.all([replaceForPosition(node, '::before'), replaceForPosition(node, '::after')]);
}

function processable(node) {
  return node.parentNode !== document.head && !~TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS.indexOf(node.tagName.toUpperCase()) && !node.getAttribute(DATA_FA_PSEUDO_ELEMENT) && (!node.parentNode || node.parentNode.tagName !== 'svg');
}

function searchPseudoElements(root) {
  if (!IS_DOM) return;
  return new Promise(function (resolve, reject) {
    var operations = toArray(root.querySelectorAll('*')).filter(processable).map(replace);
    var end = perf.begin('searchPseudoElements');
    disableObservation();
    Promise.all(operations).then(function () {
      end();
      enableObservation();
      resolve();
    }).catch(function () {
      end();
      enableObservation();
      reject();
    });
  });
}

var PseudoElements = {
  hooks: function hooks() {
    return {
      mutationObserverCallbacks: function mutationObserverCallbacks(accumulator) {
        accumulator.pseudoElementsCallback = searchPseudoElements;
        return accumulator;
      }
    };
  },
  provides: function provides(providers$$1) {
    providers$$1.pseudoElements2svg = function (params) {
      var _params$node = params.node,
          node = _params$node === void 0 ? DOCUMENT : _params$node;

      if (config.searchPseudoElements) {
        searchPseudoElements(node);
      }
    };
  }
};

var _unwatched = false;
var MutationObserver$1 = {
  mixout: function mixout() {
    return {
      dom: {
        unwatch: function unwatch() {
          disableObservation();
          _unwatched = true;
        }
      }
    };
  },
  hooks: function hooks() {
    return {
      bootstrap: function bootstrap() {
        observe(chainHooks('mutationObserverCallbacks', {}));
      },
      noAuto: function noAuto() {
        disconnect();
      },
      watch: function watch(params) {
        var observeMutationsRoot = params.observeMutationsRoot;

        if (_unwatched) {
          enableObservation();
        } else {
          observe(chainHooks('mutationObserverCallbacks', {
            observeMutationsRoot: observeMutationsRoot
          }));
        }
      }
    };
  }
};

var parseTransformString = function parseTransformString(transformString) {
  var transform = {
    size: 16,
    x: 0,
    y: 0,
    flipX: false,
    flipY: false,
    rotate: 0
  };
  return transformString.toLowerCase().split(' ').reduce(function (acc, n) {
    var parts = n.toLowerCase().split('-');
    var first = parts[0];
    var rest = parts.slice(1).join('-');

    if (first && rest === 'h') {
      acc.flipX = true;
      return acc;
    }

    if (first && rest === 'v') {
      acc.flipY = true;
      return acc;
    }

    rest = parseFloat(rest);

    if (isNaN(rest)) {
      return acc;
    }

    switch (first) {
      case 'grow':
        acc.size = acc.size + rest;
        break;

      case 'shrink':
        acc.size = acc.size - rest;
        break;

      case 'left':
        acc.x = acc.x - rest;
        break;

      case 'right':
        acc.x = acc.x + rest;
        break;

      case 'up':
        acc.y = acc.y - rest;
        break;

      case 'down':
        acc.y = acc.y + rest;
        break;

      case 'rotate':
        acc.rotate = acc.rotate + rest;
        break;
    }

    return acc;
  }, transform);
};
var PowerTransforms = {
  mixout: function mixout() {
    return {
      parse: {
        transform: function transform(transformString) {
          return parseTransformString(transformString);
        }
      }
    };
  },
  hooks: function hooks() {
    return {
      parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
        var transformString = node.getAttribute('data-fa-transform');

        if (transformString) {
          accumulator.transform = parseTransformString(transformString);
        }

        return accumulator;
      }
    };
  },
  provides: function provides(providers) {
    providers.generateAbstractTransformGrouping = function (_ref) {
      var main = _ref.main,
          transform = _ref.transform,
          containerWidth = _ref.containerWidth,
          iconWidth = _ref.iconWidth;
      var outer = {
        transform: "translate(".concat(containerWidth / 2, " 256)")
      };
      var innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
      var innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
      var innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
      var inner = {
        transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
      };
      var path = {
        transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
      };
      var operations = {
        outer: outer,
        inner: inner,
        path: path
      };
      return {
        tag: 'g',
        attributes: _objectSpread2({}, operations.outer),
        children: [{
          tag: 'g',
          attributes: _objectSpread2({}, operations.inner),
          children: [{
            tag: main.icon.tag,
            children: main.icon.children,
            attributes: _objectSpread2(_objectSpread2({}, main.icon.attributes), operations.path)
          }]
        }]
      };
    };
  }
};

var ALL_SPACE = {
  x: 0,
  y: 0,
  width: '100%',
  height: '100%'
};

function fillBlack(abstract) {
  var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  if (abstract.attributes && (abstract.attributes.fill || force)) {
    abstract.attributes.fill = 'black';
  }

  return abstract;
}

function deGroup(abstract) {
  if (abstract.tag === 'g') {
    return abstract.children;
  } else {
    return [abstract];
  }
}

var Masks = {
  hooks: function hooks() {
    return {
      parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
        var maskData = node.getAttribute('data-fa-mask');
        var mask = !maskData ? emptyCanonicalIcon() : getCanonicalIcon(maskData.split(' ').map(function (i) {
          return i.trim();
        }));

        if (!mask.prefix) {
          mask.prefix = getDefaultUsablePrefix();
        }

        accumulator.mask = mask;
        accumulator.maskId = node.getAttribute('data-fa-mask-id');
        return accumulator;
      }
    };
  },
  provides: function provides(providers) {
    providers.generateAbstractMask = function (_ref) {
      var children = _ref.children,
          attributes = _ref.attributes,
          main = _ref.main,
          mask = _ref.mask,
          explicitMaskId = _ref.maskId,
          transform = _ref.transform;
      var mainWidth = main.width,
          mainPath = main.icon;
      var maskWidth = mask.width,
          maskPath = mask.icon;
      var trans = transformForSvg({
        transform: transform,
        containerWidth: maskWidth,
        iconWidth: mainWidth
      });
      var maskRect = {
        tag: 'rect',
        attributes: _objectSpread2(_objectSpread2({}, ALL_SPACE), {}, {
          fill: 'white'
        })
      };
      var maskInnerGroupChildrenMixin = mainPath.children ? {
        children: mainPath.children.map(fillBlack)
      } : {};
      var maskInnerGroup = {
        tag: 'g',
        attributes: _objectSpread2({}, trans.inner),
        children: [fillBlack(_objectSpread2({
          tag: mainPath.tag,
          attributes: _objectSpread2(_objectSpread2({}, mainPath.attributes), trans.path)
        }, maskInnerGroupChildrenMixin))]
      };
      var maskOuterGroup = {
        tag: 'g',
        attributes: _objectSpread2({}, trans.outer),
        children: [maskInnerGroup]
      };
      var maskId = "mask-".concat(explicitMaskId || nextUniqueId());
      var clipId = "clip-".concat(explicitMaskId || nextUniqueId());
      var maskTag = {
        tag: 'mask',
        attributes: _objectSpread2(_objectSpread2({}, ALL_SPACE), {}, {
          id: maskId,
          maskUnits: 'userSpaceOnUse',
          maskContentUnits: 'userSpaceOnUse'
        }),
        children: [maskRect, maskOuterGroup]
      };
      var defs = {
        tag: 'defs',
        children: [{
          tag: 'clipPath',
          attributes: {
            id: clipId
          },
          children: deGroup(maskPath)
        }, maskTag]
      };
      children.push(defs, {
        tag: 'rect',
        attributes: _objectSpread2({
          fill: 'currentColor',
          'clip-path': "url(#".concat(clipId, ")"),
          mask: "url(#".concat(maskId, ")")
        }, ALL_SPACE)
      });
      return {
        children: children,
        attributes: attributes
      };
    };
  }
};

var MissingIconIndicator = {
  provides: function provides(providers) {
    var reduceMotion = false;

    if (WINDOW.matchMedia) {
      reduceMotion = WINDOW.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    providers.missingIconAbstract = function () {
      var gChildren = [];
      var FILL = {
        fill: 'currentColor'
      };
      var ANIMATION_BASE = {
        attributeType: 'XML',
        repeatCount: 'indefinite',
        dur: '2s'
      }; // Ring

      gChildren.push({
        tag: 'path',
        attributes: _objectSpread2(_objectSpread2({}, FILL), {}, {
          d: 'M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z'
        })
      });

      var OPACITY_ANIMATE = _objectSpread2(_objectSpread2({}, ANIMATION_BASE), {}, {
        attributeName: 'opacity'
      });

      var dot = {
        tag: 'circle',
        attributes: _objectSpread2(_objectSpread2({}, FILL), {}, {
          cx: '256',
          cy: '364',
          r: '28'
        }),
        children: []
      };

      if (!reduceMotion) {
        dot.children.push({
          tag: 'animate',
          attributes: _objectSpread2(_objectSpread2({}, ANIMATION_BASE), {}, {
            attributeName: 'r',
            values: '28;14;28;28;14;28;'
          })
        }, {
          tag: 'animate',
          attributes: _objectSpread2(_objectSpread2({}, OPACITY_ANIMATE), {}, {
            values: '1;0;1;1;0;1;'
          })
        });
      }

      gChildren.push(dot);
      gChildren.push({
        tag: 'path',
        attributes: _objectSpread2(_objectSpread2({}, FILL), {}, {
          opacity: '1',
          d: 'M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z'
        }),
        children: reduceMotion ? [] : [{
          tag: 'animate',
          attributes: _objectSpread2(_objectSpread2({}, OPACITY_ANIMATE), {}, {
            values: '1;0;0;0;0;1;'
          })
        }]
      });

      if (!reduceMotion) {
        // Exclamation
        gChildren.push({
          tag: 'path',
          attributes: _objectSpread2(_objectSpread2({}, FILL), {}, {
            opacity: '0',
            d: 'M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z'
          }),
          children: [{
            tag: 'animate',
            attributes: _objectSpread2(_objectSpread2({}, OPACITY_ANIMATE), {}, {
              values: '0;0;1;1;0;0;'
            })
          }]
        });
      }

      return {
        tag: 'g',
        attributes: {
          'class': 'missing'
        },
        children: gChildren
      };
    };
  }
};

var SvgSymbols = {
  hooks: function hooks() {
    return {
      parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
        var symbolData = node.getAttribute('data-fa-symbol');
        var symbol = symbolData === null ? false : symbolData === '' ? true : symbolData;
        accumulator['symbol'] = symbol;
        return accumulator;
      }
    };
  }
};

var plugins = [InjectCSS, ReplaceElements, Layers, LayersCounter, LayersText, PseudoElements, MutationObserver$1, PowerTransforms, Masks, MissingIconIndicator, SvgSymbols];

registerPlugins(plugins, {
  mixoutsTo: api
});
var noAuto$1 = api.noAuto;
var config$1 = api.config;
var library$1 = api.library;
var dom$1 = api.dom;
var parse$1 = api.parse;
var findIconDefinition$1 = api.findIconDefinition;
var toHtml$1 = api.toHtml;
var icon = api.icon;
var layer = api.layer;
var text = api.text;
var counter = api.counter;




/***/ }),

/***/ 51436:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "faAd": function() { return /* binding */ faAd; },
/* harmony export */   "faAddressBook": function() { return /* binding */ faAddressBook; },
/* harmony export */   "faAddressCard": function() { return /* binding */ faAddressCard; },
/* harmony export */   "faAdjust": function() { return /* binding */ faAdjust; },
/* harmony export */   "faAirFreshener": function() { return /* binding */ faAirFreshener; },
/* harmony export */   "faAlignCenter": function() { return /* binding */ faAlignCenter; },
/* harmony export */   "faAlignJustify": function() { return /* binding */ faAlignJustify; },
/* harmony export */   "faAlignLeft": function() { return /* binding */ faAlignLeft; },
/* harmony export */   "faAlignRight": function() { return /* binding */ faAlignRight; },
/* harmony export */   "faAllergies": function() { return /* binding */ faAllergies; },
/* harmony export */   "faAmbulance": function() { return /* binding */ faAmbulance; },
/* harmony export */   "faAmericanSignLanguageInterpreting": function() { return /* binding */ faAmericanSignLanguageInterpreting; },
/* harmony export */   "faAnchor": function() { return /* binding */ faAnchor; },
/* harmony export */   "faAngleDoubleDown": function() { return /* binding */ faAngleDoubleDown; },
/* harmony export */   "faAngleDoubleLeft": function() { return /* binding */ faAngleDoubleLeft; },
/* harmony export */   "faAngleDoubleRight": function() { return /* binding */ faAngleDoubleRight; },
/* harmony export */   "faAngleDoubleUp": function() { return /* binding */ faAngleDoubleUp; },
/* harmony export */   "faAngleDown": function() { return /* binding */ faAngleDown; },
/* harmony export */   "faAngleLeft": function() { return /* binding */ faAngleLeft; },
/* harmony export */   "faAngleRight": function() { return /* binding */ faAngleRight; },
/* harmony export */   "faAngleUp": function() { return /* binding */ faAngleUp; },
/* harmony export */   "faAngry": function() { return /* binding */ faAngry; },
/* harmony export */   "faAnkh": function() { return /* binding */ faAnkh; },
/* harmony export */   "faAppleAlt": function() { return /* binding */ faAppleAlt; },
/* harmony export */   "faArchive": function() { return /* binding */ faArchive; },
/* harmony export */   "faArchway": function() { return /* binding */ faArchway; },
/* harmony export */   "faArrowAltCircleDown": function() { return /* binding */ faArrowAltCircleDown; },
/* harmony export */   "faArrowAltCircleLeft": function() { return /* binding */ faArrowAltCircleLeft; },
/* harmony export */   "faArrowAltCircleRight": function() { return /* binding */ faArrowAltCircleRight; },
/* harmony export */   "faArrowAltCircleUp": function() { return /* binding */ faArrowAltCircleUp; },
/* harmony export */   "faArrowCircleDown": function() { return /* binding */ faArrowCircleDown; },
/* harmony export */   "faArrowCircleLeft": function() { return /* binding */ faArrowCircleLeft; },
/* harmony export */   "faArrowCircleRight": function() { return /* binding */ faArrowCircleRight; },
/* harmony export */   "faArrowCircleUp": function() { return /* binding */ faArrowCircleUp; },
/* harmony export */   "faArrowDown": function() { return /* binding */ faArrowDown; },
/* harmony export */   "faArrowLeft": function() { return /* binding */ faArrowLeft; },
/* harmony export */   "faArrowRight": function() { return /* binding */ faArrowRight; },
/* harmony export */   "faArrowUp": function() { return /* binding */ faArrowUp; },
/* harmony export */   "faArrowsAlt": function() { return /* binding */ faArrowsAlt; },
/* harmony export */   "faArrowsAltH": function() { return /* binding */ faArrowsAltH; },
/* harmony export */   "faArrowsAltV": function() { return /* binding */ faArrowsAltV; },
/* harmony export */   "faAssistiveListeningSystems": function() { return /* binding */ faAssistiveListeningSystems; },
/* harmony export */   "faAsterisk": function() { return /* binding */ faAsterisk; },
/* harmony export */   "faAt": function() { return /* binding */ faAt; },
/* harmony export */   "faAtlas": function() { return /* binding */ faAtlas; },
/* harmony export */   "faAtom": function() { return /* binding */ faAtom; },
/* harmony export */   "faAudioDescription": function() { return /* binding */ faAudioDescription; },
/* harmony export */   "faAward": function() { return /* binding */ faAward; },
/* harmony export */   "faBaby": function() { return /* binding */ faBaby; },
/* harmony export */   "faBabyCarriage": function() { return /* binding */ faBabyCarriage; },
/* harmony export */   "faBackspace": function() { return /* binding */ faBackspace; },
/* harmony export */   "faBackward": function() { return /* binding */ faBackward; },
/* harmony export */   "faBacon": function() { return /* binding */ faBacon; },
/* harmony export */   "faBacteria": function() { return /* binding */ faBacteria; },
/* harmony export */   "faBacterium": function() { return /* binding */ faBacterium; },
/* harmony export */   "faBahai": function() { return /* binding */ faBahai; },
/* harmony export */   "faBalanceScale": function() { return /* binding */ faBalanceScale; },
/* harmony export */   "faBalanceScaleLeft": function() { return /* binding */ faBalanceScaleLeft; },
/* harmony export */   "faBalanceScaleRight": function() { return /* binding */ faBalanceScaleRight; },
/* harmony export */   "faBan": function() { return /* binding */ faBan; },
/* harmony export */   "faBandAid": function() { return /* binding */ faBandAid; },
/* harmony export */   "faBarcode": function() { return /* binding */ faBarcode; },
/* harmony export */   "faBars": function() { return /* binding */ faBars; },
/* harmony export */   "faBaseballBall": function() { return /* binding */ faBaseballBall; },
/* harmony export */   "faBasketballBall": function() { return /* binding */ faBasketballBall; },
/* harmony export */   "faBath": function() { return /* binding */ faBath; },
/* harmony export */   "faBatteryEmpty": function() { return /* binding */ faBatteryEmpty; },
/* harmony export */   "faBatteryFull": function() { return /* binding */ faBatteryFull; },
/* harmony export */   "faBatteryHalf": function() { return /* binding */ faBatteryHalf; },
/* harmony export */   "faBatteryQuarter": function() { return /* binding */ faBatteryQuarter; },
/* harmony export */   "faBatteryThreeQuarters": function() { return /* binding */ faBatteryThreeQuarters; },
/* harmony export */   "faBed": function() { return /* binding */ faBed; },
/* harmony export */   "faBeer": function() { return /* binding */ faBeer; },
/* harmony export */   "faBell": function() { return /* binding */ faBell; },
/* harmony export */   "faBellSlash": function() { return /* binding */ faBellSlash; },
/* harmony export */   "faBezierCurve": function() { return /* binding */ faBezierCurve; },
/* harmony export */   "faBible": function() { return /* binding */ faBible; },
/* harmony export */   "faBicycle": function() { return /* binding */ faBicycle; },
/* harmony export */   "faBiking": function() { return /* binding */ faBiking; },
/* harmony export */   "faBinoculars": function() { return /* binding */ faBinoculars; },
/* harmony export */   "faBiohazard": function() { return /* binding */ faBiohazard; },
/* harmony export */   "faBirthdayCake": function() { return /* binding */ faBirthdayCake; },
/* harmony export */   "faBlender": function() { return /* binding */ faBlender; },
/* harmony export */   "faBlenderPhone": function() { return /* binding */ faBlenderPhone; },
/* harmony export */   "faBlind": function() { return /* binding */ faBlind; },
/* harmony export */   "faBlog": function() { return /* binding */ faBlog; },
/* harmony export */   "faBold": function() { return /* binding */ faBold; },
/* harmony export */   "faBolt": function() { return /* binding */ faBolt; },
/* harmony export */   "faBomb": function() { return /* binding */ faBomb; },
/* harmony export */   "faBone": function() { return /* binding */ faBone; },
/* harmony export */   "faBong": function() { return /* binding */ faBong; },
/* harmony export */   "faBook": function() { return /* binding */ faBook; },
/* harmony export */   "faBookDead": function() { return /* binding */ faBookDead; },
/* harmony export */   "faBookMedical": function() { return /* binding */ faBookMedical; },
/* harmony export */   "faBookOpen": function() { return /* binding */ faBookOpen; },
/* harmony export */   "faBookReader": function() { return /* binding */ faBookReader; },
/* harmony export */   "faBookmark": function() { return /* binding */ faBookmark; },
/* harmony export */   "faBorderAll": function() { return /* binding */ faBorderAll; },
/* harmony export */   "faBorderNone": function() { return /* binding */ faBorderNone; },
/* harmony export */   "faBorderStyle": function() { return /* binding */ faBorderStyle; },
/* harmony export */   "faBowlingBall": function() { return /* binding */ faBowlingBall; },
/* harmony export */   "faBox": function() { return /* binding */ faBox; },
/* harmony export */   "faBoxOpen": function() { return /* binding */ faBoxOpen; },
/* harmony export */   "faBoxTissue": function() { return /* binding */ faBoxTissue; },
/* harmony export */   "faBoxes": function() { return /* binding */ faBoxes; },
/* harmony export */   "faBraille": function() { return /* binding */ faBraille; },
/* harmony export */   "faBrain": function() { return /* binding */ faBrain; },
/* harmony export */   "faBreadSlice": function() { return /* binding */ faBreadSlice; },
/* harmony export */   "faBriefcase": function() { return /* binding */ faBriefcase; },
/* harmony export */   "faBriefcaseMedical": function() { return /* binding */ faBriefcaseMedical; },
/* harmony export */   "faBroadcastTower": function() { return /* binding */ faBroadcastTower; },
/* harmony export */   "faBroom": function() { return /* binding */ faBroom; },
/* harmony export */   "faBrush": function() { return /* binding */ faBrush; },
/* harmony export */   "faBug": function() { return /* binding */ faBug; },
/* harmony export */   "faBuilding": function() { return /* binding */ faBuilding; },
/* harmony export */   "faBullhorn": function() { return /* binding */ faBullhorn; },
/* harmony export */   "faBullseye": function() { return /* binding */ faBullseye; },
/* harmony export */   "faBurn": function() { return /* binding */ faBurn; },
/* harmony export */   "faBus": function() { return /* binding */ faBus; },
/* harmony export */   "faBusAlt": function() { return /* binding */ faBusAlt; },
/* harmony export */   "faBusinessTime": function() { return /* binding */ faBusinessTime; },
/* harmony export */   "faCalculator": function() { return /* binding */ faCalculator; },
/* harmony export */   "faCalendar": function() { return /* binding */ faCalendar; },
/* harmony export */   "faCalendarAlt": function() { return /* binding */ faCalendarAlt; },
/* harmony export */   "faCalendarCheck": function() { return /* binding */ faCalendarCheck; },
/* harmony export */   "faCalendarDay": function() { return /* binding */ faCalendarDay; },
/* harmony export */   "faCalendarMinus": function() { return /* binding */ faCalendarMinus; },
/* harmony export */   "faCalendarPlus": function() { return /* binding */ faCalendarPlus; },
/* harmony export */   "faCalendarTimes": function() { return /* binding */ faCalendarTimes; },
/* harmony export */   "faCalendarWeek": function() { return /* binding */ faCalendarWeek; },
/* harmony export */   "faCamera": function() { return /* binding */ faCamera; },
/* harmony export */   "faCameraRetro": function() { return /* binding */ faCameraRetro; },
/* harmony export */   "faCampground": function() { return /* binding */ faCampground; },
/* harmony export */   "faCandyCane": function() { return /* binding */ faCandyCane; },
/* harmony export */   "faCannabis": function() { return /* binding */ faCannabis; },
/* harmony export */   "faCapsules": function() { return /* binding */ faCapsules; },
/* harmony export */   "faCar": function() { return /* binding */ faCar; },
/* harmony export */   "faCarAlt": function() { return /* binding */ faCarAlt; },
/* harmony export */   "faCarBattery": function() { return /* binding */ faCarBattery; },
/* harmony export */   "faCarCrash": function() { return /* binding */ faCarCrash; },
/* harmony export */   "faCarSide": function() { return /* binding */ faCarSide; },
/* harmony export */   "faCaravan": function() { return /* binding */ faCaravan; },
/* harmony export */   "faCaretDown": function() { return /* binding */ faCaretDown; },
/* harmony export */   "faCaretLeft": function() { return /* binding */ faCaretLeft; },
/* harmony export */   "faCaretRight": function() { return /* binding */ faCaretRight; },
/* harmony export */   "faCaretSquareDown": function() { return /* binding */ faCaretSquareDown; },
/* harmony export */   "faCaretSquareLeft": function() { return /* binding */ faCaretSquareLeft; },
/* harmony export */   "faCaretSquareRight": function() { return /* binding */ faCaretSquareRight; },
/* harmony export */   "faCaretSquareUp": function() { return /* binding */ faCaretSquareUp; },
/* harmony export */   "faCaretUp": function() { return /* binding */ faCaretUp; },
/* harmony export */   "faCarrot": function() { return /* binding */ faCarrot; },
/* harmony export */   "faCartArrowDown": function() { return /* binding */ faCartArrowDown; },
/* harmony export */   "faCartPlus": function() { return /* binding */ faCartPlus; },
/* harmony export */   "faCashRegister": function() { return /* binding */ faCashRegister; },
/* harmony export */   "faCat": function() { return /* binding */ faCat; },
/* harmony export */   "faCertificate": function() { return /* binding */ faCertificate; },
/* harmony export */   "faChair": function() { return /* binding */ faChair; },
/* harmony export */   "faChalkboard": function() { return /* binding */ faChalkboard; },
/* harmony export */   "faChalkboardTeacher": function() { return /* binding */ faChalkboardTeacher; },
/* harmony export */   "faChargingStation": function() { return /* binding */ faChargingStation; },
/* harmony export */   "faChartArea": function() { return /* binding */ faChartArea; },
/* harmony export */   "faChartBar": function() { return /* binding */ faChartBar; },
/* harmony export */   "faChartLine": function() { return /* binding */ faChartLine; },
/* harmony export */   "faChartPie": function() { return /* binding */ faChartPie; },
/* harmony export */   "faCheck": function() { return /* binding */ faCheck; },
/* harmony export */   "faCheckCircle": function() { return /* binding */ faCheckCircle; },
/* harmony export */   "faCheckDouble": function() { return /* binding */ faCheckDouble; },
/* harmony export */   "faCheckSquare": function() { return /* binding */ faCheckSquare; },
/* harmony export */   "faCheese": function() { return /* binding */ faCheese; },
/* harmony export */   "faChess": function() { return /* binding */ faChess; },
/* harmony export */   "faChessBishop": function() { return /* binding */ faChessBishop; },
/* harmony export */   "faChessBoard": function() { return /* binding */ faChessBoard; },
/* harmony export */   "faChessKing": function() { return /* binding */ faChessKing; },
/* harmony export */   "faChessKnight": function() { return /* binding */ faChessKnight; },
/* harmony export */   "faChessPawn": function() { return /* binding */ faChessPawn; },
/* harmony export */   "faChessQueen": function() { return /* binding */ faChessQueen; },
/* harmony export */   "faChessRook": function() { return /* binding */ faChessRook; },
/* harmony export */   "faChevronCircleDown": function() { return /* binding */ faChevronCircleDown; },
/* harmony export */   "faChevronCircleLeft": function() { return /* binding */ faChevronCircleLeft; },
/* harmony export */   "faChevronCircleRight": function() { return /* binding */ faChevronCircleRight; },
/* harmony export */   "faChevronCircleUp": function() { return /* binding */ faChevronCircleUp; },
/* harmony export */   "faChevronDown": function() { return /* binding */ faChevronDown; },
/* harmony export */   "faChevronLeft": function() { return /* binding */ faChevronLeft; },
/* harmony export */   "faChevronRight": function() { return /* binding */ faChevronRight; },
/* harmony export */   "faChevronUp": function() { return /* binding */ faChevronUp; },
/* harmony export */   "faChild": function() { return /* binding */ faChild; },
/* harmony export */   "faChurch": function() { return /* binding */ faChurch; },
/* harmony export */   "faCircle": function() { return /* binding */ faCircle; },
/* harmony export */   "faCircleNotch": function() { return /* binding */ faCircleNotch; },
/* harmony export */   "faCity": function() { return /* binding */ faCity; },
/* harmony export */   "faClinicMedical": function() { return /* binding */ faClinicMedical; },
/* harmony export */   "faClipboard": function() { return /* binding */ faClipboard; },
/* harmony export */   "faClipboardCheck": function() { return /* binding */ faClipboardCheck; },
/* harmony export */   "faClipboardList": function() { return /* binding */ faClipboardList; },
/* harmony export */   "faClock": function() { return /* binding */ faClock; },
/* harmony export */   "faClone": function() { return /* binding */ faClone; },
/* harmony export */   "faClosedCaptioning": function() { return /* binding */ faClosedCaptioning; },
/* harmony export */   "faCloud": function() { return /* binding */ faCloud; },
/* harmony export */   "faCloudDownloadAlt": function() { return /* binding */ faCloudDownloadAlt; },
/* harmony export */   "faCloudMeatball": function() { return /* binding */ faCloudMeatball; },
/* harmony export */   "faCloudMoon": function() { return /* binding */ faCloudMoon; },
/* harmony export */   "faCloudMoonRain": function() { return /* binding */ faCloudMoonRain; },
/* harmony export */   "faCloudRain": function() { return /* binding */ faCloudRain; },
/* harmony export */   "faCloudShowersHeavy": function() { return /* binding */ faCloudShowersHeavy; },
/* harmony export */   "faCloudSun": function() { return /* binding */ faCloudSun; },
/* harmony export */   "faCloudSunRain": function() { return /* binding */ faCloudSunRain; },
/* harmony export */   "faCloudUploadAlt": function() { return /* binding */ faCloudUploadAlt; },
/* harmony export */   "faCocktail": function() { return /* binding */ faCocktail; },
/* harmony export */   "faCode": function() { return /* binding */ faCode; },
/* harmony export */   "faCodeBranch": function() { return /* binding */ faCodeBranch; },
/* harmony export */   "faCoffee": function() { return /* binding */ faCoffee; },
/* harmony export */   "faCog": function() { return /* binding */ faCog; },
/* harmony export */   "faCogs": function() { return /* binding */ faCogs; },
/* harmony export */   "faCoins": function() { return /* binding */ faCoins; },
/* harmony export */   "faColumns": function() { return /* binding */ faColumns; },
/* harmony export */   "faComment": function() { return /* binding */ faComment; },
/* harmony export */   "faCommentAlt": function() { return /* binding */ faCommentAlt; },
/* harmony export */   "faCommentDollar": function() { return /* binding */ faCommentDollar; },
/* harmony export */   "faCommentDots": function() { return /* binding */ faCommentDots; },
/* harmony export */   "faCommentMedical": function() { return /* binding */ faCommentMedical; },
/* harmony export */   "faCommentSlash": function() { return /* binding */ faCommentSlash; },
/* harmony export */   "faComments": function() { return /* binding */ faComments; },
/* harmony export */   "faCommentsDollar": function() { return /* binding */ faCommentsDollar; },
/* harmony export */   "faCompactDisc": function() { return /* binding */ faCompactDisc; },
/* harmony export */   "faCompass": function() { return /* binding */ faCompass; },
/* harmony export */   "faCompress": function() { return /* binding */ faCompress; },
/* harmony export */   "faCompressAlt": function() { return /* binding */ faCompressAlt; },
/* harmony export */   "faCompressArrowsAlt": function() { return /* binding */ faCompressArrowsAlt; },
/* harmony export */   "faConciergeBell": function() { return /* binding */ faConciergeBell; },
/* harmony export */   "faCookie": function() { return /* binding */ faCookie; },
/* harmony export */   "faCookieBite": function() { return /* binding */ faCookieBite; },
/* harmony export */   "faCopy": function() { return /* binding */ faCopy; },
/* harmony export */   "faCopyright": function() { return /* binding */ faCopyright; },
/* harmony export */   "faCouch": function() { return /* binding */ faCouch; },
/* harmony export */   "faCreditCard": function() { return /* binding */ faCreditCard; },
/* harmony export */   "faCrop": function() { return /* binding */ faCrop; },
/* harmony export */   "faCropAlt": function() { return /* binding */ faCropAlt; },
/* harmony export */   "faCross": function() { return /* binding */ faCross; },
/* harmony export */   "faCrosshairs": function() { return /* binding */ faCrosshairs; },
/* harmony export */   "faCrow": function() { return /* binding */ faCrow; },
/* harmony export */   "faCrown": function() { return /* binding */ faCrown; },
/* harmony export */   "faCrutch": function() { return /* binding */ faCrutch; },
/* harmony export */   "faCube": function() { return /* binding */ faCube; },
/* harmony export */   "faCubes": function() { return /* binding */ faCubes; },
/* harmony export */   "faCut": function() { return /* binding */ faCut; },
/* harmony export */   "faDatabase": function() { return /* binding */ faDatabase; },
/* harmony export */   "faDeaf": function() { return /* binding */ faDeaf; },
/* harmony export */   "faDemocrat": function() { return /* binding */ faDemocrat; },
/* harmony export */   "faDesktop": function() { return /* binding */ faDesktop; },
/* harmony export */   "faDharmachakra": function() { return /* binding */ faDharmachakra; },
/* harmony export */   "faDiagnoses": function() { return /* binding */ faDiagnoses; },
/* harmony export */   "faDice": function() { return /* binding */ faDice; },
/* harmony export */   "faDiceD20": function() { return /* binding */ faDiceD20; },
/* harmony export */   "faDiceD6": function() { return /* binding */ faDiceD6; },
/* harmony export */   "faDiceFive": function() { return /* binding */ faDiceFive; },
/* harmony export */   "faDiceFour": function() { return /* binding */ faDiceFour; },
/* harmony export */   "faDiceOne": function() { return /* binding */ faDiceOne; },
/* harmony export */   "faDiceSix": function() { return /* binding */ faDiceSix; },
/* harmony export */   "faDiceThree": function() { return /* binding */ faDiceThree; },
/* harmony export */   "faDiceTwo": function() { return /* binding */ faDiceTwo; },
/* harmony export */   "faDigitalTachograph": function() { return /* binding */ faDigitalTachograph; },
/* harmony export */   "faDirections": function() { return /* binding */ faDirections; },
/* harmony export */   "faDisease": function() { return /* binding */ faDisease; },
/* harmony export */   "faDivide": function() { return /* binding */ faDivide; },
/* harmony export */   "faDizzy": function() { return /* binding */ faDizzy; },
/* harmony export */   "faDna": function() { return /* binding */ faDna; },
/* harmony export */   "faDog": function() { return /* binding */ faDog; },
/* harmony export */   "faDollarSign": function() { return /* binding */ faDollarSign; },
/* harmony export */   "faDolly": function() { return /* binding */ faDolly; },
/* harmony export */   "faDollyFlatbed": function() { return /* binding */ faDollyFlatbed; },
/* harmony export */   "faDonate": function() { return /* binding */ faDonate; },
/* harmony export */   "faDoorClosed": function() { return /* binding */ faDoorClosed; },
/* harmony export */   "faDoorOpen": function() { return /* binding */ faDoorOpen; },
/* harmony export */   "faDotCircle": function() { return /* binding */ faDotCircle; },
/* harmony export */   "faDove": function() { return /* binding */ faDove; },
/* harmony export */   "faDownload": function() { return /* binding */ faDownload; },
/* harmony export */   "faDraftingCompass": function() { return /* binding */ faDraftingCompass; },
/* harmony export */   "faDragon": function() { return /* binding */ faDragon; },
/* harmony export */   "faDrawPolygon": function() { return /* binding */ faDrawPolygon; },
/* harmony export */   "faDrum": function() { return /* binding */ faDrum; },
/* harmony export */   "faDrumSteelpan": function() { return /* binding */ faDrumSteelpan; },
/* harmony export */   "faDrumstickBite": function() { return /* binding */ faDrumstickBite; },
/* harmony export */   "faDumbbell": function() { return /* binding */ faDumbbell; },
/* harmony export */   "faDumpster": function() { return /* binding */ faDumpster; },
/* harmony export */   "faDumpsterFire": function() { return /* binding */ faDumpsterFire; },
/* harmony export */   "faDungeon": function() { return /* binding */ faDungeon; },
/* harmony export */   "faEdit": function() { return /* binding */ faEdit; },
/* harmony export */   "faEgg": function() { return /* binding */ faEgg; },
/* harmony export */   "faEject": function() { return /* binding */ faEject; },
/* harmony export */   "faEllipsisH": function() { return /* binding */ faEllipsisH; },
/* harmony export */   "faEllipsisV": function() { return /* binding */ faEllipsisV; },
/* harmony export */   "faEnvelope": function() { return /* binding */ faEnvelope; },
/* harmony export */   "faEnvelopeOpen": function() { return /* binding */ faEnvelopeOpen; },
/* harmony export */   "faEnvelopeOpenText": function() { return /* binding */ faEnvelopeOpenText; },
/* harmony export */   "faEnvelopeSquare": function() { return /* binding */ faEnvelopeSquare; },
/* harmony export */   "faEquals": function() { return /* binding */ faEquals; },
/* harmony export */   "faEraser": function() { return /* binding */ faEraser; },
/* harmony export */   "faEthernet": function() { return /* binding */ faEthernet; },
/* harmony export */   "faEuroSign": function() { return /* binding */ faEuroSign; },
/* harmony export */   "faExchangeAlt": function() { return /* binding */ faExchangeAlt; },
/* harmony export */   "faExclamation": function() { return /* binding */ faExclamation; },
/* harmony export */   "faExclamationCircle": function() { return /* binding */ faExclamationCircle; },
/* harmony export */   "faExclamationTriangle": function() { return /* binding */ faExclamationTriangle; },
/* harmony export */   "faExpand": function() { return /* binding */ faExpand; },
/* harmony export */   "faExpandAlt": function() { return /* binding */ faExpandAlt; },
/* harmony export */   "faExpandArrowsAlt": function() { return /* binding */ faExpandArrowsAlt; },
/* harmony export */   "faExternalLinkAlt": function() { return /* binding */ faExternalLinkAlt; },
/* harmony export */   "faExternalLinkSquareAlt": function() { return /* binding */ faExternalLinkSquareAlt; },
/* harmony export */   "faEye": function() { return /* binding */ faEye; },
/* harmony export */   "faEyeDropper": function() { return /* binding */ faEyeDropper; },
/* harmony export */   "faEyeSlash": function() { return /* binding */ faEyeSlash; },
/* harmony export */   "faFan": function() { return /* binding */ faFan; },
/* harmony export */   "faFastBackward": function() { return /* binding */ faFastBackward; },
/* harmony export */   "faFastForward": function() { return /* binding */ faFastForward; },
/* harmony export */   "faFaucet": function() { return /* binding */ faFaucet; },
/* harmony export */   "faFax": function() { return /* binding */ faFax; },
/* harmony export */   "faFeather": function() { return /* binding */ faFeather; },
/* harmony export */   "faFeatherAlt": function() { return /* binding */ faFeatherAlt; },
/* harmony export */   "faFemale": function() { return /* binding */ faFemale; },
/* harmony export */   "faFighterJet": function() { return /* binding */ faFighterJet; },
/* harmony export */   "faFile": function() { return /* binding */ faFile; },
/* harmony export */   "faFileAlt": function() { return /* binding */ faFileAlt; },
/* harmony export */   "faFileArchive": function() { return /* binding */ faFileArchive; },
/* harmony export */   "faFileAudio": function() { return /* binding */ faFileAudio; },
/* harmony export */   "faFileCode": function() { return /* binding */ faFileCode; },
/* harmony export */   "faFileContract": function() { return /* binding */ faFileContract; },
/* harmony export */   "faFileCsv": function() { return /* binding */ faFileCsv; },
/* harmony export */   "faFileDownload": function() { return /* binding */ faFileDownload; },
/* harmony export */   "faFileExcel": function() { return /* binding */ faFileExcel; },
/* harmony export */   "faFileExport": function() { return /* binding */ faFileExport; },
/* harmony export */   "faFileImage": function() { return /* binding */ faFileImage; },
/* harmony export */   "faFileImport": function() { return /* binding */ faFileImport; },
/* harmony export */   "faFileInvoice": function() { return /* binding */ faFileInvoice; },
/* harmony export */   "faFileInvoiceDollar": function() { return /* binding */ faFileInvoiceDollar; },
/* harmony export */   "faFileMedical": function() { return /* binding */ faFileMedical; },
/* harmony export */   "faFileMedicalAlt": function() { return /* binding */ faFileMedicalAlt; },
/* harmony export */   "faFilePdf": function() { return /* binding */ faFilePdf; },
/* harmony export */   "faFilePowerpoint": function() { return /* binding */ faFilePowerpoint; },
/* harmony export */   "faFilePrescription": function() { return /* binding */ faFilePrescription; },
/* harmony export */   "faFileSignature": function() { return /* binding */ faFileSignature; },
/* harmony export */   "faFileUpload": function() { return /* binding */ faFileUpload; },
/* harmony export */   "faFileVideo": function() { return /* binding */ faFileVideo; },
/* harmony export */   "faFileWord": function() { return /* binding */ faFileWord; },
/* harmony export */   "faFill": function() { return /* binding */ faFill; },
/* harmony export */   "faFillDrip": function() { return /* binding */ faFillDrip; },
/* harmony export */   "faFilm": function() { return /* binding */ faFilm; },
/* harmony export */   "faFilter": function() { return /* binding */ faFilter; },
/* harmony export */   "faFingerprint": function() { return /* binding */ faFingerprint; },
/* harmony export */   "faFire": function() { return /* binding */ faFire; },
/* harmony export */   "faFireAlt": function() { return /* binding */ faFireAlt; },
/* harmony export */   "faFireExtinguisher": function() { return /* binding */ faFireExtinguisher; },
/* harmony export */   "faFirstAid": function() { return /* binding */ faFirstAid; },
/* harmony export */   "faFish": function() { return /* binding */ faFish; },
/* harmony export */   "faFistRaised": function() { return /* binding */ faFistRaised; },
/* harmony export */   "faFlag": function() { return /* binding */ faFlag; },
/* harmony export */   "faFlagCheckered": function() { return /* binding */ faFlagCheckered; },
/* harmony export */   "faFlagUsa": function() { return /* binding */ faFlagUsa; },
/* harmony export */   "faFlask": function() { return /* binding */ faFlask; },
/* harmony export */   "faFlushed": function() { return /* binding */ faFlushed; },
/* harmony export */   "faFolder": function() { return /* binding */ faFolder; },
/* harmony export */   "faFolderMinus": function() { return /* binding */ faFolderMinus; },
/* harmony export */   "faFolderOpen": function() { return /* binding */ faFolderOpen; },
/* harmony export */   "faFolderPlus": function() { return /* binding */ faFolderPlus; },
/* harmony export */   "faFont": function() { return /* binding */ faFont; },
/* harmony export */   "faFontAwesomeLogoFull": function() { return /* binding */ faFontAwesomeLogoFull; },
/* harmony export */   "faFootballBall": function() { return /* binding */ faFootballBall; },
/* harmony export */   "faForward": function() { return /* binding */ faForward; },
/* harmony export */   "faFrog": function() { return /* binding */ faFrog; },
/* harmony export */   "faFrown": function() { return /* binding */ faFrown; },
/* harmony export */   "faFrownOpen": function() { return /* binding */ faFrownOpen; },
/* harmony export */   "faFunnelDollar": function() { return /* binding */ faFunnelDollar; },
/* harmony export */   "faFutbol": function() { return /* binding */ faFutbol; },
/* harmony export */   "faGamepad": function() { return /* binding */ faGamepad; },
/* harmony export */   "faGasPump": function() { return /* binding */ faGasPump; },
/* harmony export */   "faGavel": function() { return /* binding */ faGavel; },
/* harmony export */   "faGem": function() { return /* binding */ faGem; },
/* harmony export */   "faGenderless": function() { return /* binding */ faGenderless; },
/* harmony export */   "faGhost": function() { return /* binding */ faGhost; },
/* harmony export */   "faGift": function() { return /* binding */ faGift; },
/* harmony export */   "faGifts": function() { return /* binding */ faGifts; },
/* harmony export */   "faGlassCheers": function() { return /* binding */ faGlassCheers; },
/* harmony export */   "faGlassMartini": function() { return /* binding */ faGlassMartini; },
/* harmony export */   "faGlassMartiniAlt": function() { return /* binding */ faGlassMartiniAlt; },
/* harmony export */   "faGlassWhiskey": function() { return /* binding */ faGlassWhiskey; },
/* harmony export */   "faGlasses": function() { return /* binding */ faGlasses; },
/* harmony export */   "faGlobe": function() { return /* binding */ faGlobe; },
/* harmony export */   "faGlobeAfrica": function() { return /* binding */ faGlobeAfrica; },
/* harmony export */   "faGlobeAmericas": function() { return /* binding */ faGlobeAmericas; },
/* harmony export */   "faGlobeAsia": function() { return /* binding */ faGlobeAsia; },
/* harmony export */   "faGlobeEurope": function() { return /* binding */ faGlobeEurope; },
/* harmony export */   "faGolfBall": function() { return /* binding */ faGolfBall; },
/* harmony export */   "faGopuram": function() { return /* binding */ faGopuram; },
/* harmony export */   "faGraduationCap": function() { return /* binding */ faGraduationCap; },
/* harmony export */   "faGreaterThan": function() { return /* binding */ faGreaterThan; },
/* harmony export */   "faGreaterThanEqual": function() { return /* binding */ faGreaterThanEqual; },
/* harmony export */   "faGrimace": function() { return /* binding */ faGrimace; },
/* harmony export */   "faGrin": function() { return /* binding */ faGrin; },
/* harmony export */   "faGrinAlt": function() { return /* binding */ faGrinAlt; },
/* harmony export */   "faGrinBeam": function() { return /* binding */ faGrinBeam; },
/* harmony export */   "faGrinBeamSweat": function() { return /* binding */ faGrinBeamSweat; },
/* harmony export */   "faGrinHearts": function() { return /* binding */ faGrinHearts; },
/* harmony export */   "faGrinSquint": function() { return /* binding */ faGrinSquint; },
/* harmony export */   "faGrinSquintTears": function() { return /* binding */ faGrinSquintTears; },
/* harmony export */   "faGrinStars": function() { return /* binding */ faGrinStars; },
/* harmony export */   "faGrinTears": function() { return /* binding */ faGrinTears; },
/* harmony export */   "faGrinTongue": function() { return /* binding */ faGrinTongue; },
/* harmony export */   "faGrinTongueSquint": function() { return /* binding */ faGrinTongueSquint; },
/* harmony export */   "faGrinTongueWink": function() { return /* binding */ faGrinTongueWink; },
/* harmony export */   "faGrinWink": function() { return /* binding */ faGrinWink; },
/* harmony export */   "faGripHorizontal": function() { return /* binding */ faGripHorizontal; },
/* harmony export */   "faGripLines": function() { return /* binding */ faGripLines; },
/* harmony export */   "faGripLinesVertical": function() { return /* binding */ faGripLinesVertical; },
/* harmony export */   "faGripVertical": function() { return /* binding */ faGripVertical; },
/* harmony export */   "faGuitar": function() { return /* binding */ faGuitar; },
/* harmony export */   "faHSquare": function() { return /* binding */ faHSquare; },
/* harmony export */   "faHamburger": function() { return /* binding */ faHamburger; },
/* harmony export */   "faHammer": function() { return /* binding */ faHammer; },
/* harmony export */   "faHamsa": function() { return /* binding */ faHamsa; },
/* harmony export */   "faHandHolding": function() { return /* binding */ faHandHolding; },
/* harmony export */   "faHandHoldingHeart": function() { return /* binding */ faHandHoldingHeart; },
/* harmony export */   "faHandHoldingMedical": function() { return /* binding */ faHandHoldingMedical; },
/* harmony export */   "faHandHoldingUsd": function() { return /* binding */ faHandHoldingUsd; },
/* harmony export */   "faHandHoldingWater": function() { return /* binding */ faHandHoldingWater; },
/* harmony export */   "faHandLizard": function() { return /* binding */ faHandLizard; },
/* harmony export */   "faHandMiddleFinger": function() { return /* binding */ faHandMiddleFinger; },
/* harmony export */   "faHandPaper": function() { return /* binding */ faHandPaper; },
/* harmony export */   "faHandPeace": function() { return /* binding */ faHandPeace; },
/* harmony export */   "faHandPointDown": function() { return /* binding */ faHandPointDown; },
/* harmony export */   "faHandPointLeft": function() { return /* binding */ faHandPointLeft; },
/* harmony export */   "faHandPointRight": function() { return /* binding */ faHandPointRight; },
/* harmony export */   "faHandPointUp": function() { return /* binding */ faHandPointUp; },
/* harmony export */   "faHandPointer": function() { return /* binding */ faHandPointer; },
/* harmony export */   "faHandRock": function() { return /* binding */ faHandRock; },
/* harmony export */   "faHandScissors": function() { return /* binding */ faHandScissors; },
/* harmony export */   "faHandSparkles": function() { return /* binding */ faHandSparkles; },
/* harmony export */   "faHandSpock": function() { return /* binding */ faHandSpock; },
/* harmony export */   "faHands": function() { return /* binding */ faHands; },
/* harmony export */   "faHandsHelping": function() { return /* binding */ faHandsHelping; },
/* harmony export */   "faHandsWash": function() { return /* binding */ faHandsWash; },
/* harmony export */   "faHandshake": function() { return /* binding */ faHandshake; },
/* harmony export */   "faHandshakeAltSlash": function() { return /* binding */ faHandshakeAltSlash; },
/* harmony export */   "faHandshakeSlash": function() { return /* binding */ faHandshakeSlash; },
/* harmony export */   "faHanukiah": function() { return /* binding */ faHanukiah; },
/* harmony export */   "faHardHat": function() { return /* binding */ faHardHat; },
/* harmony export */   "faHashtag": function() { return /* binding */ faHashtag; },
/* harmony export */   "faHatCowboy": function() { return /* binding */ faHatCowboy; },
/* harmony export */   "faHatCowboySide": function() { return /* binding */ faHatCowboySide; },
/* harmony export */   "faHatWizard": function() { return /* binding */ faHatWizard; },
/* harmony export */   "faHdd": function() { return /* binding */ faHdd; },
/* harmony export */   "faHeadSideCough": function() { return /* binding */ faHeadSideCough; },
/* harmony export */   "faHeadSideCoughSlash": function() { return /* binding */ faHeadSideCoughSlash; },
/* harmony export */   "faHeadSideMask": function() { return /* binding */ faHeadSideMask; },
/* harmony export */   "faHeadSideVirus": function() { return /* binding */ faHeadSideVirus; },
/* harmony export */   "faHeading": function() { return /* binding */ faHeading; },
/* harmony export */   "faHeadphones": function() { return /* binding */ faHeadphones; },
/* harmony export */   "faHeadphonesAlt": function() { return /* binding */ faHeadphonesAlt; },
/* harmony export */   "faHeadset": function() { return /* binding */ faHeadset; },
/* harmony export */   "faHeart": function() { return /* binding */ faHeart; },
/* harmony export */   "faHeartBroken": function() { return /* binding */ faHeartBroken; },
/* harmony export */   "faHeartbeat": function() { return /* binding */ faHeartbeat; },
/* harmony export */   "faHelicopter": function() { return /* binding */ faHelicopter; },
/* harmony export */   "faHighlighter": function() { return /* binding */ faHighlighter; },
/* harmony export */   "faHiking": function() { return /* binding */ faHiking; },
/* harmony export */   "faHippo": function() { return /* binding */ faHippo; },
/* harmony export */   "faHistory": function() { return /* binding */ faHistory; },
/* harmony export */   "faHockeyPuck": function() { return /* binding */ faHockeyPuck; },
/* harmony export */   "faHollyBerry": function() { return /* binding */ faHollyBerry; },
/* harmony export */   "faHome": function() { return /* binding */ faHome; },
/* harmony export */   "faHorse": function() { return /* binding */ faHorse; },
/* harmony export */   "faHorseHead": function() { return /* binding */ faHorseHead; },
/* harmony export */   "faHospital": function() { return /* binding */ faHospital; },
/* harmony export */   "faHospitalAlt": function() { return /* binding */ faHospitalAlt; },
/* harmony export */   "faHospitalSymbol": function() { return /* binding */ faHospitalSymbol; },
/* harmony export */   "faHospitalUser": function() { return /* binding */ faHospitalUser; },
/* harmony export */   "faHotTub": function() { return /* binding */ faHotTub; },
/* harmony export */   "faHotdog": function() { return /* binding */ faHotdog; },
/* harmony export */   "faHotel": function() { return /* binding */ faHotel; },
/* harmony export */   "faHourglass": function() { return /* binding */ faHourglass; },
/* harmony export */   "faHourglassEnd": function() { return /* binding */ faHourglassEnd; },
/* harmony export */   "faHourglassHalf": function() { return /* binding */ faHourglassHalf; },
/* harmony export */   "faHourglassStart": function() { return /* binding */ faHourglassStart; },
/* harmony export */   "faHouseDamage": function() { return /* binding */ faHouseDamage; },
/* harmony export */   "faHouseUser": function() { return /* binding */ faHouseUser; },
/* harmony export */   "faHryvnia": function() { return /* binding */ faHryvnia; },
/* harmony export */   "faICursor": function() { return /* binding */ faICursor; },
/* harmony export */   "faIceCream": function() { return /* binding */ faIceCream; },
/* harmony export */   "faIcicles": function() { return /* binding */ faIcicles; },
/* harmony export */   "faIcons": function() { return /* binding */ faIcons; },
/* harmony export */   "faIdBadge": function() { return /* binding */ faIdBadge; },
/* harmony export */   "faIdCard": function() { return /* binding */ faIdCard; },
/* harmony export */   "faIdCardAlt": function() { return /* binding */ faIdCardAlt; },
/* harmony export */   "faIgloo": function() { return /* binding */ faIgloo; },
/* harmony export */   "faImage": function() { return /* binding */ faImage; },
/* harmony export */   "faImages": function() { return /* binding */ faImages; },
/* harmony export */   "faInbox": function() { return /* binding */ faInbox; },
/* harmony export */   "faIndent": function() { return /* binding */ faIndent; },
/* harmony export */   "faIndustry": function() { return /* binding */ faIndustry; },
/* harmony export */   "faInfinity": function() { return /* binding */ faInfinity; },
/* harmony export */   "faInfo": function() { return /* binding */ faInfo; },
/* harmony export */   "faInfoCircle": function() { return /* binding */ faInfoCircle; },
/* harmony export */   "faItalic": function() { return /* binding */ faItalic; },
/* harmony export */   "faJedi": function() { return /* binding */ faJedi; },
/* harmony export */   "faJoint": function() { return /* binding */ faJoint; },
/* harmony export */   "faJournalWhills": function() { return /* binding */ faJournalWhills; },
/* harmony export */   "faKaaba": function() { return /* binding */ faKaaba; },
/* harmony export */   "faKey": function() { return /* binding */ faKey; },
/* harmony export */   "faKeyboard": function() { return /* binding */ faKeyboard; },
/* harmony export */   "faKhanda": function() { return /* binding */ faKhanda; },
/* harmony export */   "faKiss": function() { return /* binding */ faKiss; },
/* harmony export */   "faKissBeam": function() { return /* binding */ faKissBeam; },
/* harmony export */   "faKissWinkHeart": function() { return /* binding */ faKissWinkHeart; },
/* harmony export */   "faKiwiBird": function() { return /* binding */ faKiwiBird; },
/* harmony export */   "faLandmark": function() { return /* binding */ faLandmark; },
/* harmony export */   "faLanguage": function() { return /* binding */ faLanguage; },
/* harmony export */   "faLaptop": function() { return /* binding */ faLaptop; },
/* harmony export */   "faLaptopCode": function() { return /* binding */ faLaptopCode; },
/* harmony export */   "faLaptopHouse": function() { return /* binding */ faLaptopHouse; },
/* harmony export */   "faLaptopMedical": function() { return /* binding */ faLaptopMedical; },
/* harmony export */   "faLaugh": function() { return /* binding */ faLaugh; },
/* harmony export */   "faLaughBeam": function() { return /* binding */ faLaughBeam; },
/* harmony export */   "faLaughSquint": function() { return /* binding */ faLaughSquint; },
/* harmony export */   "faLaughWink": function() { return /* binding */ faLaughWink; },
/* harmony export */   "faLayerGroup": function() { return /* binding */ faLayerGroup; },
/* harmony export */   "faLeaf": function() { return /* binding */ faLeaf; },
/* harmony export */   "faLemon": function() { return /* binding */ faLemon; },
/* harmony export */   "faLessThan": function() { return /* binding */ faLessThan; },
/* harmony export */   "faLessThanEqual": function() { return /* binding */ faLessThanEqual; },
/* harmony export */   "faLevelDownAlt": function() { return /* binding */ faLevelDownAlt; },
/* harmony export */   "faLevelUpAlt": function() { return /* binding */ faLevelUpAlt; },
/* harmony export */   "faLifeRing": function() { return /* binding */ faLifeRing; },
/* harmony export */   "faLightbulb": function() { return /* binding */ faLightbulb; },
/* harmony export */   "faLink": function() { return /* binding */ faLink; },
/* harmony export */   "faLiraSign": function() { return /* binding */ faLiraSign; },
/* harmony export */   "faList": function() { return /* binding */ faList; },
/* harmony export */   "faListAlt": function() { return /* binding */ faListAlt; },
/* harmony export */   "faListOl": function() { return /* binding */ faListOl; },
/* harmony export */   "faListUl": function() { return /* binding */ faListUl; },
/* harmony export */   "faLocationArrow": function() { return /* binding */ faLocationArrow; },
/* harmony export */   "faLock": function() { return /* binding */ faLock; },
/* harmony export */   "faLockOpen": function() { return /* binding */ faLockOpen; },
/* harmony export */   "faLongArrowAltDown": function() { return /* binding */ faLongArrowAltDown; },
/* harmony export */   "faLongArrowAltLeft": function() { return /* binding */ faLongArrowAltLeft; },
/* harmony export */   "faLongArrowAltRight": function() { return /* binding */ faLongArrowAltRight; },
/* harmony export */   "faLongArrowAltUp": function() { return /* binding */ faLongArrowAltUp; },
/* harmony export */   "faLowVision": function() { return /* binding */ faLowVision; },
/* harmony export */   "faLuggageCart": function() { return /* binding */ faLuggageCart; },
/* harmony export */   "faLungs": function() { return /* binding */ faLungs; },
/* harmony export */   "faLungsVirus": function() { return /* binding */ faLungsVirus; },
/* harmony export */   "faMagic": function() { return /* binding */ faMagic; },
/* harmony export */   "faMagnet": function() { return /* binding */ faMagnet; },
/* harmony export */   "faMailBulk": function() { return /* binding */ faMailBulk; },
/* harmony export */   "faMale": function() { return /* binding */ faMale; },
/* harmony export */   "faMap": function() { return /* binding */ faMap; },
/* harmony export */   "faMapMarked": function() { return /* binding */ faMapMarked; },
/* harmony export */   "faMapMarkedAlt": function() { return /* binding */ faMapMarkedAlt; },
/* harmony export */   "faMapMarker": function() { return /* binding */ faMapMarker; },
/* harmony export */   "faMapMarkerAlt": function() { return /* binding */ faMapMarkerAlt; },
/* harmony export */   "faMapPin": function() { return /* binding */ faMapPin; },
/* harmony export */   "faMapSigns": function() { return /* binding */ faMapSigns; },
/* harmony export */   "faMarker": function() { return /* binding */ faMarker; },
/* harmony export */   "faMars": function() { return /* binding */ faMars; },
/* harmony export */   "faMarsDouble": function() { return /* binding */ faMarsDouble; },
/* harmony export */   "faMarsStroke": function() { return /* binding */ faMarsStroke; },
/* harmony export */   "faMarsStrokeH": function() { return /* binding */ faMarsStrokeH; },
/* harmony export */   "faMarsStrokeV": function() { return /* binding */ faMarsStrokeV; },
/* harmony export */   "faMask": function() { return /* binding */ faMask; },
/* harmony export */   "faMedal": function() { return /* binding */ faMedal; },
/* harmony export */   "faMedkit": function() { return /* binding */ faMedkit; },
/* harmony export */   "faMeh": function() { return /* binding */ faMeh; },
/* harmony export */   "faMehBlank": function() { return /* binding */ faMehBlank; },
/* harmony export */   "faMehRollingEyes": function() { return /* binding */ faMehRollingEyes; },
/* harmony export */   "faMemory": function() { return /* binding */ faMemory; },
/* harmony export */   "faMenorah": function() { return /* binding */ faMenorah; },
/* harmony export */   "faMercury": function() { return /* binding */ faMercury; },
/* harmony export */   "faMeteor": function() { return /* binding */ faMeteor; },
/* harmony export */   "faMicrochip": function() { return /* binding */ faMicrochip; },
/* harmony export */   "faMicrophone": function() { return /* binding */ faMicrophone; },
/* harmony export */   "faMicrophoneAlt": function() { return /* binding */ faMicrophoneAlt; },
/* harmony export */   "faMicrophoneAltSlash": function() { return /* binding */ faMicrophoneAltSlash; },
/* harmony export */   "faMicrophoneSlash": function() { return /* binding */ faMicrophoneSlash; },
/* harmony export */   "faMicroscope": function() { return /* binding */ faMicroscope; },
/* harmony export */   "faMinus": function() { return /* binding */ faMinus; },
/* harmony export */   "faMinusCircle": function() { return /* binding */ faMinusCircle; },
/* harmony export */   "faMinusSquare": function() { return /* binding */ faMinusSquare; },
/* harmony export */   "faMitten": function() { return /* binding */ faMitten; },
/* harmony export */   "faMobile": function() { return /* binding */ faMobile; },
/* harmony export */   "faMobileAlt": function() { return /* binding */ faMobileAlt; },
/* harmony export */   "faMoneyBill": function() { return /* binding */ faMoneyBill; },
/* harmony export */   "faMoneyBillAlt": function() { return /* binding */ faMoneyBillAlt; },
/* harmony export */   "faMoneyBillWave": function() { return /* binding */ faMoneyBillWave; },
/* harmony export */   "faMoneyBillWaveAlt": function() { return /* binding */ faMoneyBillWaveAlt; },
/* harmony export */   "faMoneyCheck": function() { return /* binding */ faMoneyCheck; },
/* harmony export */   "faMoneyCheckAlt": function() { return /* binding */ faMoneyCheckAlt; },
/* harmony export */   "faMonument": function() { return /* binding */ faMonument; },
/* harmony export */   "faMoon": function() { return /* binding */ faMoon; },
/* harmony export */   "faMortarPestle": function() { return /* binding */ faMortarPestle; },
/* harmony export */   "faMosque": function() { return /* binding */ faMosque; },
/* harmony export */   "faMotorcycle": function() { return /* binding */ faMotorcycle; },
/* harmony export */   "faMountain": function() { return /* binding */ faMountain; },
/* harmony export */   "faMouse": function() { return /* binding */ faMouse; },
/* harmony export */   "faMousePointer": function() { return /* binding */ faMousePointer; },
/* harmony export */   "faMugHot": function() { return /* binding */ faMugHot; },
/* harmony export */   "faMusic": function() { return /* binding */ faMusic; },
/* harmony export */   "faNetworkWired": function() { return /* binding */ faNetworkWired; },
/* harmony export */   "faNeuter": function() { return /* binding */ faNeuter; },
/* harmony export */   "faNewspaper": function() { return /* binding */ faNewspaper; },
/* harmony export */   "faNotEqual": function() { return /* binding */ faNotEqual; },
/* harmony export */   "faNotesMedical": function() { return /* binding */ faNotesMedical; },
/* harmony export */   "faObjectGroup": function() { return /* binding */ faObjectGroup; },
/* harmony export */   "faObjectUngroup": function() { return /* binding */ faObjectUngroup; },
/* harmony export */   "faOilCan": function() { return /* binding */ faOilCan; },
/* harmony export */   "faOm": function() { return /* binding */ faOm; },
/* harmony export */   "faOtter": function() { return /* binding */ faOtter; },
/* harmony export */   "faOutdent": function() { return /* binding */ faOutdent; },
/* harmony export */   "faPager": function() { return /* binding */ faPager; },
/* harmony export */   "faPaintBrush": function() { return /* binding */ faPaintBrush; },
/* harmony export */   "faPaintRoller": function() { return /* binding */ faPaintRoller; },
/* harmony export */   "faPalette": function() { return /* binding */ faPalette; },
/* harmony export */   "faPallet": function() { return /* binding */ faPallet; },
/* harmony export */   "faPaperPlane": function() { return /* binding */ faPaperPlane; },
/* harmony export */   "faPaperclip": function() { return /* binding */ faPaperclip; },
/* harmony export */   "faParachuteBox": function() { return /* binding */ faParachuteBox; },
/* harmony export */   "faParagraph": function() { return /* binding */ faParagraph; },
/* harmony export */   "faParking": function() { return /* binding */ faParking; },
/* harmony export */   "faPassport": function() { return /* binding */ faPassport; },
/* harmony export */   "faPastafarianism": function() { return /* binding */ faPastafarianism; },
/* harmony export */   "faPaste": function() { return /* binding */ faPaste; },
/* harmony export */   "faPause": function() { return /* binding */ faPause; },
/* harmony export */   "faPauseCircle": function() { return /* binding */ faPauseCircle; },
/* harmony export */   "faPaw": function() { return /* binding */ faPaw; },
/* harmony export */   "faPeace": function() { return /* binding */ faPeace; },
/* harmony export */   "faPen": function() { return /* binding */ faPen; },
/* harmony export */   "faPenAlt": function() { return /* binding */ faPenAlt; },
/* harmony export */   "faPenFancy": function() { return /* binding */ faPenFancy; },
/* harmony export */   "faPenNib": function() { return /* binding */ faPenNib; },
/* harmony export */   "faPenSquare": function() { return /* binding */ faPenSquare; },
/* harmony export */   "faPencilAlt": function() { return /* binding */ faPencilAlt; },
/* harmony export */   "faPencilRuler": function() { return /* binding */ faPencilRuler; },
/* harmony export */   "faPeopleArrows": function() { return /* binding */ faPeopleArrows; },
/* harmony export */   "faPeopleCarry": function() { return /* binding */ faPeopleCarry; },
/* harmony export */   "faPepperHot": function() { return /* binding */ faPepperHot; },
/* harmony export */   "faPercent": function() { return /* binding */ faPercent; },
/* harmony export */   "faPercentage": function() { return /* binding */ faPercentage; },
/* harmony export */   "faPersonBooth": function() { return /* binding */ faPersonBooth; },
/* harmony export */   "faPhone": function() { return /* binding */ faPhone; },
/* harmony export */   "faPhoneAlt": function() { return /* binding */ faPhoneAlt; },
/* harmony export */   "faPhoneSlash": function() { return /* binding */ faPhoneSlash; },
/* harmony export */   "faPhoneSquare": function() { return /* binding */ faPhoneSquare; },
/* harmony export */   "faPhoneSquareAlt": function() { return /* binding */ faPhoneSquareAlt; },
/* harmony export */   "faPhoneVolume": function() { return /* binding */ faPhoneVolume; },
/* harmony export */   "faPhotoVideo": function() { return /* binding */ faPhotoVideo; },
/* harmony export */   "faPiggyBank": function() { return /* binding */ faPiggyBank; },
/* harmony export */   "faPills": function() { return /* binding */ faPills; },
/* harmony export */   "faPizzaSlice": function() { return /* binding */ faPizzaSlice; },
/* harmony export */   "faPlaceOfWorship": function() { return /* binding */ faPlaceOfWorship; },
/* harmony export */   "faPlane": function() { return /* binding */ faPlane; },
/* harmony export */   "faPlaneArrival": function() { return /* binding */ faPlaneArrival; },
/* harmony export */   "faPlaneDeparture": function() { return /* binding */ faPlaneDeparture; },
/* harmony export */   "faPlaneSlash": function() { return /* binding */ faPlaneSlash; },
/* harmony export */   "faPlay": function() { return /* binding */ faPlay; },
/* harmony export */   "faPlayCircle": function() { return /* binding */ faPlayCircle; },
/* harmony export */   "faPlug": function() { return /* binding */ faPlug; },
/* harmony export */   "faPlus": function() { return /* binding */ faPlus; },
/* harmony export */   "faPlusCircle": function() { return /* binding */ faPlusCircle; },
/* harmony export */   "faPlusSquare": function() { return /* binding */ faPlusSquare; },
/* harmony export */   "faPodcast": function() { return /* binding */ faPodcast; },
/* harmony export */   "faPoll": function() { return /* binding */ faPoll; },
/* harmony export */   "faPollH": function() { return /* binding */ faPollH; },
/* harmony export */   "faPoo": function() { return /* binding */ faPoo; },
/* harmony export */   "faPooStorm": function() { return /* binding */ faPooStorm; },
/* harmony export */   "faPoop": function() { return /* binding */ faPoop; },
/* harmony export */   "faPortrait": function() { return /* binding */ faPortrait; },
/* harmony export */   "faPoundSign": function() { return /* binding */ faPoundSign; },
/* harmony export */   "faPowerOff": function() { return /* binding */ faPowerOff; },
/* harmony export */   "faPray": function() { return /* binding */ faPray; },
/* harmony export */   "faPrayingHands": function() { return /* binding */ faPrayingHands; },
/* harmony export */   "faPrescription": function() { return /* binding */ faPrescription; },
/* harmony export */   "faPrescriptionBottle": function() { return /* binding */ faPrescriptionBottle; },
/* harmony export */   "faPrescriptionBottleAlt": function() { return /* binding */ faPrescriptionBottleAlt; },
/* harmony export */   "faPrint": function() { return /* binding */ faPrint; },
/* harmony export */   "faProcedures": function() { return /* binding */ faProcedures; },
/* harmony export */   "faProjectDiagram": function() { return /* binding */ faProjectDiagram; },
/* harmony export */   "faPumpMedical": function() { return /* binding */ faPumpMedical; },
/* harmony export */   "faPumpSoap": function() { return /* binding */ faPumpSoap; },
/* harmony export */   "faPuzzlePiece": function() { return /* binding */ faPuzzlePiece; },
/* harmony export */   "faQrcode": function() { return /* binding */ faQrcode; },
/* harmony export */   "faQuestion": function() { return /* binding */ faQuestion; },
/* harmony export */   "faQuestionCircle": function() { return /* binding */ faQuestionCircle; },
/* harmony export */   "faQuidditch": function() { return /* binding */ faQuidditch; },
/* harmony export */   "faQuoteLeft": function() { return /* binding */ faQuoteLeft; },
/* harmony export */   "faQuoteRight": function() { return /* binding */ faQuoteRight; },
/* harmony export */   "faQuran": function() { return /* binding */ faQuran; },
/* harmony export */   "faRadiation": function() { return /* binding */ faRadiation; },
/* harmony export */   "faRadiationAlt": function() { return /* binding */ faRadiationAlt; },
/* harmony export */   "faRainbow": function() { return /* binding */ faRainbow; },
/* harmony export */   "faRandom": function() { return /* binding */ faRandom; },
/* harmony export */   "faReceipt": function() { return /* binding */ faReceipt; },
/* harmony export */   "faRecordVinyl": function() { return /* binding */ faRecordVinyl; },
/* harmony export */   "faRecycle": function() { return /* binding */ faRecycle; },
/* harmony export */   "faRedo": function() { return /* binding */ faRedo; },
/* harmony export */   "faRedoAlt": function() { return /* binding */ faRedoAlt; },
/* harmony export */   "faRegistered": function() { return /* binding */ faRegistered; },
/* harmony export */   "faRemoveFormat": function() { return /* binding */ faRemoveFormat; },
/* harmony export */   "faReply": function() { return /* binding */ faReply; },
/* harmony export */   "faReplyAll": function() { return /* binding */ faReplyAll; },
/* harmony export */   "faRepublican": function() { return /* binding */ faRepublican; },
/* harmony export */   "faRestroom": function() { return /* binding */ faRestroom; },
/* harmony export */   "faRetweet": function() { return /* binding */ faRetweet; },
/* harmony export */   "faRibbon": function() { return /* binding */ faRibbon; },
/* harmony export */   "faRing": function() { return /* binding */ faRing; },
/* harmony export */   "faRoad": function() { return /* binding */ faRoad; },
/* harmony export */   "faRobot": function() { return /* binding */ faRobot; },
/* harmony export */   "faRocket": function() { return /* binding */ faRocket; },
/* harmony export */   "faRoute": function() { return /* binding */ faRoute; },
/* harmony export */   "faRss": function() { return /* binding */ faRss; },
/* harmony export */   "faRssSquare": function() { return /* binding */ faRssSquare; },
/* harmony export */   "faRubleSign": function() { return /* binding */ faRubleSign; },
/* harmony export */   "faRuler": function() { return /* binding */ faRuler; },
/* harmony export */   "faRulerCombined": function() { return /* binding */ faRulerCombined; },
/* harmony export */   "faRulerHorizontal": function() { return /* binding */ faRulerHorizontal; },
/* harmony export */   "faRulerVertical": function() { return /* binding */ faRulerVertical; },
/* harmony export */   "faRunning": function() { return /* binding */ faRunning; },
/* harmony export */   "faRupeeSign": function() { return /* binding */ faRupeeSign; },
/* harmony export */   "faSadCry": function() { return /* binding */ faSadCry; },
/* harmony export */   "faSadTear": function() { return /* binding */ faSadTear; },
/* harmony export */   "faSatellite": function() { return /* binding */ faSatellite; },
/* harmony export */   "faSatelliteDish": function() { return /* binding */ faSatelliteDish; },
/* harmony export */   "faSave": function() { return /* binding */ faSave; },
/* harmony export */   "faSchool": function() { return /* binding */ faSchool; },
/* harmony export */   "faScrewdriver": function() { return /* binding */ faScrewdriver; },
/* harmony export */   "faScroll": function() { return /* binding */ faScroll; },
/* harmony export */   "faSdCard": function() { return /* binding */ faSdCard; },
/* harmony export */   "faSearch": function() { return /* binding */ faSearch; },
/* harmony export */   "faSearchDollar": function() { return /* binding */ faSearchDollar; },
/* harmony export */   "faSearchLocation": function() { return /* binding */ faSearchLocation; },
/* harmony export */   "faSearchMinus": function() { return /* binding */ faSearchMinus; },
/* harmony export */   "faSearchPlus": function() { return /* binding */ faSearchPlus; },
/* harmony export */   "faSeedling": function() { return /* binding */ faSeedling; },
/* harmony export */   "faServer": function() { return /* binding */ faServer; },
/* harmony export */   "faShapes": function() { return /* binding */ faShapes; },
/* harmony export */   "faShare": function() { return /* binding */ faShare; },
/* harmony export */   "faShareAlt": function() { return /* binding */ faShareAlt; },
/* harmony export */   "faShareAltSquare": function() { return /* binding */ faShareAltSquare; },
/* harmony export */   "faShareSquare": function() { return /* binding */ faShareSquare; },
/* harmony export */   "faShekelSign": function() { return /* binding */ faShekelSign; },
/* harmony export */   "faShieldAlt": function() { return /* binding */ faShieldAlt; },
/* harmony export */   "faShieldVirus": function() { return /* binding */ faShieldVirus; },
/* harmony export */   "faShip": function() { return /* binding */ faShip; },
/* harmony export */   "faShippingFast": function() { return /* binding */ faShippingFast; },
/* harmony export */   "faShoePrints": function() { return /* binding */ faShoePrints; },
/* harmony export */   "faShoppingBag": function() { return /* binding */ faShoppingBag; },
/* harmony export */   "faShoppingBasket": function() { return /* binding */ faShoppingBasket; },
/* harmony export */   "faShoppingCart": function() { return /* binding */ faShoppingCart; },
/* harmony export */   "faShower": function() { return /* binding */ faShower; },
/* harmony export */   "faShuttleVan": function() { return /* binding */ faShuttleVan; },
/* harmony export */   "faSign": function() { return /* binding */ faSign; },
/* harmony export */   "faSignInAlt": function() { return /* binding */ faSignInAlt; },
/* harmony export */   "faSignLanguage": function() { return /* binding */ faSignLanguage; },
/* harmony export */   "faSignOutAlt": function() { return /* binding */ faSignOutAlt; },
/* harmony export */   "faSignal": function() { return /* binding */ faSignal; },
/* harmony export */   "faSignature": function() { return /* binding */ faSignature; },
/* harmony export */   "faSimCard": function() { return /* binding */ faSimCard; },
/* harmony export */   "faSink": function() { return /* binding */ faSink; },
/* harmony export */   "faSitemap": function() { return /* binding */ faSitemap; },
/* harmony export */   "faSkating": function() { return /* binding */ faSkating; },
/* harmony export */   "faSkiing": function() { return /* binding */ faSkiing; },
/* harmony export */   "faSkiingNordic": function() { return /* binding */ faSkiingNordic; },
/* harmony export */   "faSkull": function() { return /* binding */ faSkull; },
/* harmony export */   "faSkullCrossbones": function() { return /* binding */ faSkullCrossbones; },
/* harmony export */   "faSlash": function() { return /* binding */ faSlash; },
/* harmony export */   "faSleigh": function() { return /* binding */ faSleigh; },
/* harmony export */   "faSlidersH": function() { return /* binding */ faSlidersH; },
/* harmony export */   "faSmile": function() { return /* binding */ faSmile; },
/* harmony export */   "faSmileBeam": function() { return /* binding */ faSmileBeam; },
/* harmony export */   "faSmileWink": function() { return /* binding */ faSmileWink; },
/* harmony export */   "faSmog": function() { return /* binding */ faSmog; },
/* harmony export */   "faSmoking": function() { return /* binding */ faSmoking; },
/* harmony export */   "faSmokingBan": function() { return /* binding */ faSmokingBan; },
/* harmony export */   "faSms": function() { return /* binding */ faSms; },
/* harmony export */   "faSnowboarding": function() { return /* binding */ faSnowboarding; },
/* harmony export */   "faSnowflake": function() { return /* binding */ faSnowflake; },
/* harmony export */   "faSnowman": function() { return /* binding */ faSnowman; },
/* harmony export */   "faSnowplow": function() { return /* binding */ faSnowplow; },
/* harmony export */   "faSoap": function() { return /* binding */ faSoap; },
/* harmony export */   "faSocks": function() { return /* binding */ faSocks; },
/* harmony export */   "faSolarPanel": function() { return /* binding */ faSolarPanel; },
/* harmony export */   "faSort": function() { return /* binding */ faSort; },
/* harmony export */   "faSortAlphaDown": function() { return /* binding */ faSortAlphaDown; },
/* harmony export */   "faSortAlphaDownAlt": function() { return /* binding */ faSortAlphaDownAlt; },
/* harmony export */   "faSortAlphaUp": function() { return /* binding */ faSortAlphaUp; },
/* harmony export */   "faSortAlphaUpAlt": function() { return /* binding */ faSortAlphaUpAlt; },
/* harmony export */   "faSortAmountDown": function() { return /* binding */ faSortAmountDown; },
/* harmony export */   "faSortAmountDownAlt": function() { return /* binding */ faSortAmountDownAlt; },
/* harmony export */   "faSortAmountUp": function() { return /* binding */ faSortAmountUp; },
/* harmony export */   "faSortAmountUpAlt": function() { return /* binding */ faSortAmountUpAlt; },
/* harmony export */   "faSortDown": function() { return /* binding */ faSortDown; },
/* harmony export */   "faSortNumericDown": function() { return /* binding */ faSortNumericDown; },
/* harmony export */   "faSortNumericDownAlt": function() { return /* binding */ faSortNumericDownAlt; },
/* harmony export */   "faSortNumericUp": function() { return /* binding */ faSortNumericUp; },
/* harmony export */   "faSortNumericUpAlt": function() { return /* binding */ faSortNumericUpAlt; },
/* harmony export */   "faSortUp": function() { return /* binding */ faSortUp; },
/* harmony export */   "faSpa": function() { return /* binding */ faSpa; },
/* harmony export */   "faSpaceShuttle": function() { return /* binding */ faSpaceShuttle; },
/* harmony export */   "faSpellCheck": function() { return /* binding */ faSpellCheck; },
/* harmony export */   "faSpider": function() { return /* binding */ faSpider; },
/* harmony export */   "faSpinner": function() { return /* binding */ faSpinner; },
/* harmony export */   "faSplotch": function() { return /* binding */ faSplotch; },
/* harmony export */   "faSprayCan": function() { return /* binding */ faSprayCan; },
/* harmony export */   "faSquare": function() { return /* binding */ faSquare; },
/* harmony export */   "faSquareFull": function() { return /* binding */ faSquareFull; },
/* harmony export */   "faSquareRootAlt": function() { return /* binding */ faSquareRootAlt; },
/* harmony export */   "faStamp": function() { return /* binding */ faStamp; },
/* harmony export */   "faStar": function() { return /* binding */ faStar; },
/* harmony export */   "faStarAndCrescent": function() { return /* binding */ faStarAndCrescent; },
/* harmony export */   "faStarHalf": function() { return /* binding */ faStarHalf; },
/* harmony export */   "faStarHalfAlt": function() { return /* binding */ faStarHalfAlt; },
/* harmony export */   "faStarOfDavid": function() { return /* binding */ faStarOfDavid; },
/* harmony export */   "faStarOfLife": function() { return /* binding */ faStarOfLife; },
/* harmony export */   "faStepBackward": function() { return /* binding */ faStepBackward; },
/* harmony export */   "faStepForward": function() { return /* binding */ faStepForward; },
/* harmony export */   "faStethoscope": function() { return /* binding */ faStethoscope; },
/* harmony export */   "faStickyNote": function() { return /* binding */ faStickyNote; },
/* harmony export */   "faStop": function() { return /* binding */ faStop; },
/* harmony export */   "faStopCircle": function() { return /* binding */ faStopCircle; },
/* harmony export */   "faStopwatch": function() { return /* binding */ faStopwatch; },
/* harmony export */   "faStopwatch20": function() { return /* binding */ faStopwatch20; },
/* harmony export */   "faStore": function() { return /* binding */ faStore; },
/* harmony export */   "faStoreAlt": function() { return /* binding */ faStoreAlt; },
/* harmony export */   "faStoreAltSlash": function() { return /* binding */ faStoreAltSlash; },
/* harmony export */   "faStoreSlash": function() { return /* binding */ faStoreSlash; },
/* harmony export */   "faStream": function() { return /* binding */ faStream; },
/* harmony export */   "faStreetView": function() { return /* binding */ faStreetView; },
/* harmony export */   "faStrikethrough": function() { return /* binding */ faStrikethrough; },
/* harmony export */   "faStroopwafel": function() { return /* binding */ faStroopwafel; },
/* harmony export */   "faSubscript": function() { return /* binding */ faSubscript; },
/* harmony export */   "faSubway": function() { return /* binding */ faSubway; },
/* harmony export */   "faSuitcase": function() { return /* binding */ faSuitcase; },
/* harmony export */   "faSuitcaseRolling": function() { return /* binding */ faSuitcaseRolling; },
/* harmony export */   "faSun": function() { return /* binding */ faSun; },
/* harmony export */   "faSuperscript": function() { return /* binding */ faSuperscript; },
/* harmony export */   "faSurprise": function() { return /* binding */ faSurprise; },
/* harmony export */   "faSwatchbook": function() { return /* binding */ faSwatchbook; },
/* harmony export */   "faSwimmer": function() { return /* binding */ faSwimmer; },
/* harmony export */   "faSwimmingPool": function() { return /* binding */ faSwimmingPool; },
/* harmony export */   "faSynagogue": function() { return /* binding */ faSynagogue; },
/* harmony export */   "faSync": function() { return /* binding */ faSync; },
/* harmony export */   "faSyncAlt": function() { return /* binding */ faSyncAlt; },
/* harmony export */   "faSyringe": function() { return /* binding */ faSyringe; },
/* harmony export */   "faTable": function() { return /* binding */ faTable; },
/* harmony export */   "faTableTennis": function() { return /* binding */ faTableTennis; },
/* harmony export */   "faTablet": function() { return /* binding */ faTablet; },
/* harmony export */   "faTabletAlt": function() { return /* binding */ faTabletAlt; },
/* harmony export */   "faTablets": function() { return /* binding */ faTablets; },
/* harmony export */   "faTachometerAlt": function() { return /* binding */ faTachometerAlt; },
/* harmony export */   "faTag": function() { return /* binding */ faTag; },
/* harmony export */   "faTags": function() { return /* binding */ faTags; },
/* harmony export */   "faTape": function() { return /* binding */ faTape; },
/* harmony export */   "faTasks": function() { return /* binding */ faTasks; },
/* harmony export */   "faTaxi": function() { return /* binding */ faTaxi; },
/* harmony export */   "faTeeth": function() { return /* binding */ faTeeth; },
/* harmony export */   "faTeethOpen": function() { return /* binding */ faTeethOpen; },
/* harmony export */   "faTemperatureHigh": function() { return /* binding */ faTemperatureHigh; },
/* harmony export */   "faTemperatureLow": function() { return /* binding */ faTemperatureLow; },
/* harmony export */   "faTenge": function() { return /* binding */ faTenge; },
/* harmony export */   "faTerminal": function() { return /* binding */ faTerminal; },
/* harmony export */   "faTextHeight": function() { return /* binding */ faTextHeight; },
/* harmony export */   "faTextWidth": function() { return /* binding */ faTextWidth; },
/* harmony export */   "faTh": function() { return /* binding */ faTh; },
/* harmony export */   "faThLarge": function() { return /* binding */ faThLarge; },
/* harmony export */   "faThList": function() { return /* binding */ faThList; },
/* harmony export */   "faTheaterMasks": function() { return /* binding */ faTheaterMasks; },
/* harmony export */   "faThermometer": function() { return /* binding */ faThermometer; },
/* harmony export */   "faThermometerEmpty": function() { return /* binding */ faThermometerEmpty; },
/* harmony export */   "faThermometerFull": function() { return /* binding */ faThermometerFull; },
/* harmony export */   "faThermometerHalf": function() { return /* binding */ faThermometerHalf; },
/* harmony export */   "faThermometerQuarter": function() { return /* binding */ faThermometerQuarter; },
/* harmony export */   "faThermometerThreeQuarters": function() { return /* binding */ faThermometerThreeQuarters; },
/* harmony export */   "faThumbsDown": function() { return /* binding */ faThumbsDown; },
/* harmony export */   "faThumbsUp": function() { return /* binding */ faThumbsUp; },
/* harmony export */   "faThumbtack": function() { return /* binding */ faThumbtack; },
/* harmony export */   "faTicketAlt": function() { return /* binding */ faTicketAlt; },
/* harmony export */   "faTimes": function() { return /* binding */ faTimes; },
/* harmony export */   "faTimesCircle": function() { return /* binding */ faTimesCircle; },
/* harmony export */   "faTint": function() { return /* binding */ faTint; },
/* harmony export */   "faTintSlash": function() { return /* binding */ faTintSlash; },
/* harmony export */   "faTired": function() { return /* binding */ faTired; },
/* harmony export */   "faToggleOff": function() { return /* binding */ faToggleOff; },
/* harmony export */   "faToggleOn": function() { return /* binding */ faToggleOn; },
/* harmony export */   "faToilet": function() { return /* binding */ faToilet; },
/* harmony export */   "faToiletPaper": function() { return /* binding */ faToiletPaper; },
/* harmony export */   "faToiletPaperSlash": function() { return /* binding */ faToiletPaperSlash; },
/* harmony export */   "faToolbox": function() { return /* binding */ faToolbox; },
/* harmony export */   "faTools": function() { return /* binding */ faTools; },
/* harmony export */   "faTooth": function() { return /* binding */ faTooth; },
/* harmony export */   "faTorah": function() { return /* binding */ faTorah; },
/* harmony export */   "faToriiGate": function() { return /* binding */ faToriiGate; },
/* harmony export */   "faTractor": function() { return /* binding */ faTractor; },
/* harmony export */   "faTrademark": function() { return /* binding */ faTrademark; },
/* harmony export */   "faTrafficLight": function() { return /* binding */ faTrafficLight; },
/* harmony export */   "faTrailer": function() { return /* binding */ faTrailer; },
/* harmony export */   "faTrain": function() { return /* binding */ faTrain; },
/* harmony export */   "faTram": function() { return /* binding */ faTram; },
/* harmony export */   "faTransgender": function() { return /* binding */ faTransgender; },
/* harmony export */   "faTransgenderAlt": function() { return /* binding */ faTransgenderAlt; },
/* harmony export */   "faTrash": function() { return /* binding */ faTrash; },
/* harmony export */   "faTrashAlt": function() { return /* binding */ faTrashAlt; },
/* harmony export */   "faTrashRestore": function() { return /* binding */ faTrashRestore; },
/* harmony export */   "faTrashRestoreAlt": function() { return /* binding */ faTrashRestoreAlt; },
/* harmony export */   "faTree": function() { return /* binding */ faTree; },
/* harmony export */   "faTrophy": function() { return /* binding */ faTrophy; },
/* harmony export */   "faTruck": function() { return /* binding */ faTruck; },
/* harmony export */   "faTruckLoading": function() { return /* binding */ faTruckLoading; },
/* harmony export */   "faTruckMonster": function() { return /* binding */ faTruckMonster; },
/* harmony export */   "faTruckMoving": function() { return /* binding */ faTruckMoving; },
/* harmony export */   "faTruckPickup": function() { return /* binding */ faTruckPickup; },
/* harmony export */   "faTshirt": function() { return /* binding */ faTshirt; },
/* harmony export */   "faTty": function() { return /* binding */ faTty; },
/* harmony export */   "faTv": function() { return /* binding */ faTv; },
/* harmony export */   "faUmbrella": function() { return /* binding */ faUmbrella; },
/* harmony export */   "faUmbrellaBeach": function() { return /* binding */ faUmbrellaBeach; },
/* harmony export */   "faUnderline": function() { return /* binding */ faUnderline; },
/* harmony export */   "faUndo": function() { return /* binding */ faUndo; },
/* harmony export */   "faUndoAlt": function() { return /* binding */ faUndoAlt; },
/* harmony export */   "faUniversalAccess": function() { return /* binding */ faUniversalAccess; },
/* harmony export */   "faUniversity": function() { return /* binding */ faUniversity; },
/* harmony export */   "faUnlink": function() { return /* binding */ faUnlink; },
/* harmony export */   "faUnlock": function() { return /* binding */ faUnlock; },
/* harmony export */   "faUnlockAlt": function() { return /* binding */ faUnlockAlt; },
/* harmony export */   "faUpload": function() { return /* binding */ faUpload; },
/* harmony export */   "faUser": function() { return /* binding */ faUser; },
/* harmony export */   "faUserAlt": function() { return /* binding */ faUserAlt; },
/* harmony export */   "faUserAltSlash": function() { return /* binding */ faUserAltSlash; },
/* harmony export */   "faUserAstronaut": function() { return /* binding */ faUserAstronaut; },
/* harmony export */   "faUserCheck": function() { return /* binding */ faUserCheck; },
/* harmony export */   "faUserCircle": function() { return /* binding */ faUserCircle; },
/* harmony export */   "faUserClock": function() { return /* binding */ faUserClock; },
/* harmony export */   "faUserCog": function() { return /* binding */ faUserCog; },
/* harmony export */   "faUserEdit": function() { return /* binding */ faUserEdit; },
/* harmony export */   "faUserFriends": function() { return /* binding */ faUserFriends; },
/* harmony export */   "faUserGraduate": function() { return /* binding */ faUserGraduate; },
/* harmony export */   "faUserInjured": function() { return /* binding */ faUserInjured; },
/* harmony export */   "faUserLock": function() { return /* binding */ faUserLock; },
/* harmony export */   "faUserMd": function() { return /* binding */ faUserMd; },
/* harmony export */   "faUserMinus": function() { return /* binding */ faUserMinus; },
/* harmony export */   "faUserNinja": function() { return /* binding */ faUserNinja; },
/* harmony export */   "faUserNurse": function() { return /* binding */ faUserNurse; },
/* harmony export */   "faUserPlus": function() { return /* binding */ faUserPlus; },
/* harmony export */   "faUserSecret": function() { return /* binding */ faUserSecret; },
/* harmony export */   "faUserShield": function() { return /* binding */ faUserShield; },
/* harmony export */   "faUserSlash": function() { return /* binding */ faUserSlash; },
/* harmony export */   "faUserTag": function() { return /* binding */ faUserTag; },
/* harmony export */   "faUserTie": function() { return /* binding */ faUserTie; },
/* harmony export */   "faUserTimes": function() { return /* binding */ faUserTimes; },
/* harmony export */   "faUsers": function() { return /* binding */ faUsers; },
/* harmony export */   "faUsersCog": function() { return /* binding */ faUsersCog; },
/* harmony export */   "faUsersSlash": function() { return /* binding */ faUsersSlash; },
/* harmony export */   "faUtensilSpoon": function() { return /* binding */ faUtensilSpoon; },
/* harmony export */   "faUtensils": function() { return /* binding */ faUtensils; },
/* harmony export */   "faVectorSquare": function() { return /* binding */ faVectorSquare; },
/* harmony export */   "faVenus": function() { return /* binding */ faVenus; },
/* harmony export */   "faVenusDouble": function() { return /* binding */ faVenusDouble; },
/* harmony export */   "faVenusMars": function() { return /* binding */ faVenusMars; },
/* harmony export */   "faVest": function() { return /* binding */ faVest; },
/* harmony export */   "faVestPatches": function() { return /* binding */ faVestPatches; },
/* harmony export */   "faVial": function() { return /* binding */ faVial; },
/* harmony export */   "faVials": function() { return /* binding */ faVials; },
/* harmony export */   "faVideo": function() { return /* binding */ faVideo; },
/* harmony export */   "faVideoSlash": function() { return /* binding */ faVideoSlash; },
/* harmony export */   "faVihara": function() { return /* binding */ faVihara; },
/* harmony export */   "faVirus": function() { return /* binding */ faVirus; },
/* harmony export */   "faVirusSlash": function() { return /* binding */ faVirusSlash; },
/* harmony export */   "faViruses": function() { return /* binding */ faViruses; },
/* harmony export */   "faVoicemail": function() { return /* binding */ faVoicemail; },
/* harmony export */   "faVolleyballBall": function() { return /* binding */ faVolleyballBall; },
/* harmony export */   "faVolumeDown": function() { return /* binding */ faVolumeDown; },
/* harmony export */   "faVolumeMute": function() { return /* binding */ faVolumeMute; },
/* harmony export */   "faVolumeOff": function() { return /* binding */ faVolumeOff; },
/* harmony export */   "faVolumeUp": function() { return /* binding */ faVolumeUp; },
/* harmony export */   "faVoteYea": function() { return /* binding */ faVoteYea; },
/* harmony export */   "faVrCardboard": function() { return /* binding */ faVrCardboard; },
/* harmony export */   "faWalking": function() { return /* binding */ faWalking; },
/* harmony export */   "faWallet": function() { return /* binding */ faWallet; },
/* harmony export */   "faWarehouse": function() { return /* binding */ faWarehouse; },
/* harmony export */   "faWater": function() { return /* binding */ faWater; },
/* harmony export */   "faWaveSquare": function() { return /* binding */ faWaveSquare; },
/* harmony export */   "faWeight": function() { return /* binding */ faWeight; },
/* harmony export */   "faWeightHanging": function() { return /* binding */ faWeightHanging; },
/* harmony export */   "faWheelchair": function() { return /* binding */ faWheelchair; },
/* harmony export */   "faWifi": function() { return /* binding */ faWifi; },
/* harmony export */   "faWind": function() { return /* binding */ faWind; },
/* harmony export */   "faWindowClose": function() { return /* binding */ faWindowClose; },
/* harmony export */   "faWindowMaximize": function() { return /* binding */ faWindowMaximize; },
/* harmony export */   "faWindowMinimize": function() { return /* binding */ faWindowMinimize; },
/* harmony export */   "faWindowRestore": function() { return /* binding */ faWindowRestore; },
/* harmony export */   "faWineBottle": function() { return /* binding */ faWineBottle; },
/* harmony export */   "faWineGlass": function() { return /* binding */ faWineGlass; },
/* harmony export */   "faWineGlassAlt": function() { return /* binding */ faWineGlassAlt; },
/* harmony export */   "faWonSign": function() { return /* binding */ faWonSign; },
/* harmony export */   "faWrench": function() { return /* binding */ faWrench; },
/* harmony export */   "faXRay": function() { return /* binding */ faXRay; },
/* harmony export */   "faYenSign": function() { return /* binding */ faYenSign; },
/* harmony export */   "faYinYang": function() { return /* binding */ faYinYang; },
/* harmony export */   "fas": function() { return /* binding */ _iconsCache; },
/* harmony export */   "prefix": function() { return /* binding */ prefix; }
/* harmony export */ });
/*!
 * Font Awesome Free 5.15.4 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 */
var prefix = "fas";
var faAd = {
  prefix: 'fas',
  iconName: 'ad',
  icon: [512, 512, [], "f641", "M157.52 272h36.96L176 218.78 157.52 272zM352 256c-13.23 0-24 10.77-24 24s10.77 24 24 24 24-10.77 24-24-10.77-24-24-24zM464 64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM250.58 352h-16.94c-6.81 0-12.88-4.32-15.12-10.75L211.15 320h-70.29l-7.38 21.25A16 16 0 0 1 118.36 352h-16.94c-11.01 0-18.73-10.85-15.12-21.25L140 176.12A23.995 23.995 0 0 1 162.67 160h26.66A23.99 23.99 0 0 1 212 176.13l53.69 154.62c3.61 10.4-4.11 21.25-15.11 21.25zM424 336c0 8.84-7.16 16-16 16h-16c-4.85 0-9.04-2.27-11.98-5.68-8.62 3.66-18.09 5.68-28.02 5.68-39.7 0-72-32.3-72-72s32.3-72 72-72c8.46 0 16.46 1.73 24 4.42V176c0-8.84 7.16-16 16-16h16c8.84 0 16 7.16 16 16v160z"]
};
var faAddressBook = {
  prefix: 'fas',
  iconName: 'address-book',
  icon: [448, 512, [], "f2b9", "M436 160c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h320c26.5 0 48-21.5 48-48v-48h20c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20v-64h20c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20v-64h20zm-228-32c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm112 236.8c0 10.6-10 19.2-22.4 19.2H118.4C106 384 96 375.4 96 364.8v-19.2c0-31.8 30.1-57.6 67.2-57.6h5c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h5c37.1 0 67.2 25.8 67.2 57.6v19.2z"]
};
var faAddressCard = {
  prefix: 'fas',
  iconName: 'address-card',
  icon: [576, 512, [], "f2bb", "M528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-352 96c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm112 236.8c0 10.6-10 19.2-22.4 19.2H86.4C74 384 64 375.4 64 364.8v-19.2c0-31.8 30.1-57.6 67.2-57.6h5c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h5c37.1 0 67.2 25.8 67.2 57.6v19.2zM512 312c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-64c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-64c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16z"]
};
var faAdjust = {
  prefix: 'fas',
  iconName: 'adjust',
  icon: [512, 512, [], "f042", "M8 256c0 136.966 111.033 248 248 248s248-111.034 248-248S392.966 8 256 8 8 119.033 8 256zm248 184V72c101.705 0 184 82.311 184 184 0 101.705-82.311 184-184 184z"]
};
var faAirFreshener = {
  prefix: 'fas',
  iconName: 'air-freshener',
  icon: [512, 512, [], "f5d0", "M224 160H96C43 160 0 203 0 256V480C0 497.625 14.375 512 32 512H288C305.625 512 320 497.625 320 480V256C320 203 277 160 224 160ZM160 416C115.875 416 80 380.125 80 336S115.875 256 160 256S240 291.875 240 336S204.125 416 160 416ZM224 32C224 14.375 209.625 0 192 0H128C110.375 0 96 14.375 96 32V128H224V32ZM381.781 51.578C383 50.969 384 49.359 384 48C384 46.625 383 45.031 381.781 44.422L352 32L339.562 2.219C338.969 1 337.375 0 336 0S333.031 1 332.406 2.219L320 32L290.219 44.422C289 45.031 288 46.625 288 48C288 49.359 289 50.969 290.219 51.578L320 64L332.406 93.781C333.031 95 334.625 96 336 96S338.969 95 339.562 93.781L352 64L381.781 51.578ZM448 64L460.406 93.781C461.031 95 462.625 96 464 96S466.969 95 467.562 93.781L480 64L509.781 51.578C511 50.969 512 49.359 512 48C512 46.625 511 45.031 509.781 44.422L480 32L467.562 2.219C466.969 1 465.375 0 464 0S461.031 1 460.406 2.219L448 32L418.219 44.422C417 45.031 416 46.625 416 48C416 49.359 417 50.969 418.219 51.578L448 64ZM480 224L467.562 194.219C466.969 193 465.375 192 464 192S461.031 193 460.406 194.219L448 224L418.219 236.422C417 237.031 416 238.625 416 240C416 241.359 417 242.969 418.219 243.578L448 256L460.406 285.781C461.031 287 462.625 288 464 288S466.969 287 467.562 285.781L480 256L509.781 243.578C511 242.969 512 241.359 512 240C512 238.625 511 237.031 509.781 236.422L480 224ZM445.781 147.578C447 146.969 448 145.359 448 144C448 142.625 447 141.031 445.781 140.422L416 128L403.562 98.219C402.969 97 401.375 96 400 96S397.031 97 396.406 98.219L384 128L354.219 140.422C353 141.031 352 142.625 352 144C352 145.359 353 146.969 354.219 147.578L384 160L396.406 189.781C397.031 191 398.625 192 400 192S402.969 191 403.562 189.781L416 160L445.781 147.578Z"]
};
var faAlignCenter = {
  prefix: 'fas',
  iconName: 'align-center',
  icon: [448, 512, [], "f037", "M432 160H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 256H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM108.1 96h231.81A12.09 12.09 0 0 0 352 83.9V44.09A12.09 12.09 0 0 0 339.91 32H108.1A12.09 12.09 0 0 0 96 44.09V83.9A12.1 12.1 0 0 0 108.1 96zm231.81 256A12.09 12.09 0 0 0 352 339.9v-39.81A12.09 12.09 0 0 0 339.91 288H108.1A12.09 12.09 0 0 0 96 300.09v39.81a12.1 12.1 0 0 0 12.1 12.1z"]
};
var faAlignJustify = {
  prefix: 'fas',
  iconName: 'align-justify',
  icon: [448, 512, [], "f039", "M432 416H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-128H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-128H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-128H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"]
};
var faAlignLeft = {
  prefix: 'fas',
  iconName: 'align-left',
  icon: [448, 512, [], "f036", "M12.83 352h262.34A12.82 12.82 0 0 0 288 339.17v-38.34A12.82 12.82 0 0 0 275.17 288H12.83A12.82 12.82 0 0 0 0 300.83v38.34A12.82 12.82 0 0 0 12.83 352zm0-256h262.34A12.82 12.82 0 0 0 288 83.17V44.83A12.82 12.82 0 0 0 275.17 32H12.83A12.82 12.82 0 0 0 0 44.83v38.34A12.82 12.82 0 0 0 12.83 96zM432 160H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 256H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"]
};
var faAlignRight = {
  prefix: 'fas',
  iconName: 'align-right',
  icon: [448, 512, [], "f038", "M16 224h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm416 192H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm3.17-384H172.83A12.82 12.82 0 0 0 160 44.83v38.34A12.82 12.82 0 0 0 172.83 96h262.34A12.82 12.82 0 0 0 448 83.17V44.83A12.82 12.82 0 0 0 435.17 32zm0 256H172.83A12.82 12.82 0 0 0 160 300.83v38.34A12.82 12.82 0 0 0 172.83 352h262.34A12.82 12.82 0 0 0 448 339.17v-38.34A12.82 12.82 0 0 0 435.17 288z"]
};
var faAllergies = {
  prefix: 'fas',
  iconName: 'allergies',
  icon: [448, 512, [], "f461", "M416 112c-17.6 0-32 14.4-32 32v72c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V64c0-17.6-14.4-32-32-32s-32 14.4-32 32v152c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V32c0-17.6-14.4-32-32-32s-32 14.4-32 32v184c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V64c0-17.6-14.4-32-32-32S96 46.4 96 64v241l-23.6-32.5c-13-17.9-38-21.8-55.9-8.8s-21.8 38-8.8 55.9l125.6 172.7c9 12.4 23.5 19.8 38.8 19.8h197.6c22.3 0 41.6-15.3 46.7-37l26.5-112.7c3.2-13.7 4.9-28.3 5.1-42.3V144c0-17.6-14.4-32-32-32zM176 416c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-96c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm64 128c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-96c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm64 32c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm32 64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm32-128c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"]
};
var faAmbulance = {
  prefix: 'fas',
  iconName: 'ambulance',
  icon: [640, 512, [], "f0f9", "M624 352h-16V243.9c0-12.7-5.1-24.9-14.1-33.9L494 110.1c-9-9-21.2-14.1-33.9-14.1H416V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h16c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM160 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm144-248c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48zm176 248c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-208H416V144h44.1l99.9 99.9V256z"]
};
var faAmericanSignLanguageInterpreting = {
  prefix: 'fas',
  iconName: 'american-sign-language-interpreting',
  icon: [640, 512, [], "f2a3", "M290.547 189.039c-20.295-10.149-44.147-11.199-64.739-3.89 42.606 0 71.208 20.475 85.578 50.576 8.576 17.899-5.148 38.071-23.617 38.071 18.429 0 32.211 20.136 23.617 38.071-14.725 30.846-46.123 50.854-80.298 50.854-.557 0-94.471-8.615-94.471-8.615l-66.406 33.347c-9.384 4.693-19.815.379-23.895-7.781L1.86 290.747c-4.167-8.615-1.111-18.897 6.946-23.621l58.072-33.069L108 159.861c6.39-57.245 34.731-109.767 79.743-146.726 11.391-9.448 28.341-7.781 37.51 3.613 9.446 11.394 7.78 28.067-3.612 37.516-12.503 10.559-23.618 22.509-32.509 35.57 21.672-14.729 46.679-24.732 74.186-28.067 14.725-1.945 28.063 8.336 29.73 23.065 1.945 14.728-8.336 28.067-23.062 29.734-16.116 1.945-31.12 7.503-44.178 15.284 26.114-5.713 58.712-3.138 88.079 11.115 13.336 6.669 18.893 22.509 12.224 35.848-6.389 13.06-22.504 18.617-35.564 12.226zm-27.229 69.472c-6.112-12.505-18.338-20.286-32.231-20.286a35.46 35.46 0 0 0-35.565 35.57c0 21.428 17.808 35.57 35.565 35.57 13.893 0 26.119-7.781 32.231-20.286 4.446-9.449 13.614-15.006 23.339-15.284-9.725-.277-18.893-5.835-23.339-15.284zm374.821-37.237c4.168 8.615 1.111 18.897-6.946 23.621l-58.071 33.069L532 352.16c-6.39 57.245-34.731 109.767-79.743 146.726-10.932 9.112-27.799 8.144-37.51-3.613-9.446-11.394-7.78-28.067 3.613-37.516 12.503-10.559 23.617-22.509 32.508-35.57-21.672 14.729-46.679 24.732-74.186 28.067-10.021 2.506-27.552-5.643-29.73-23.065-1.945-14.728 8.336-28.067 23.062-29.734 16.116-1.946 31.12-7.503 44.178-15.284-26.114 5.713-58.712 3.138-88.079-11.115-13.336-6.669-18.893-22.509-12.224-35.848 6.389-13.061 22.505-18.619 35.565-12.227 20.295 10.149 44.147 11.199 64.739 3.89-42.606 0-71.208-20.475-85.578-50.576-8.576-17.899 5.148-38.071 23.617-38.071-18.429 0-32.211-20.136-23.617-38.071 14.033-29.396 44.039-50.887 81.966-50.854l92.803 8.615 66.406-33.347c9.408-4.704 19.828-.354 23.894 7.781l44.455 88.926zm-229.227-18.618c-13.893 0-26.119 7.781-32.231 20.286-4.446 9.449-13.614 15.006-23.339 15.284 9.725.278 18.893 5.836 23.339 15.284 6.112 12.505 18.338 20.286 32.231 20.286a35.46 35.46 0 0 0 35.565-35.57c0-21.429-17.808-35.57-35.565-35.57z"]
};
var faAnchor = {
  prefix: 'fas',
  iconName: 'anchor',
  icon: [576, 512, [], "f13d", "M12.971 352h32.394C67.172 454.735 181.944 512 288 512c106.229 0 220.853-57.38 242.635-160h32.394c10.691 0 16.045-12.926 8.485-20.485l-67.029-67.029c-4.686-4.686-12.284-4.686-16.971 0l-67.029 67.029c-7.56 7.56-2.206 20.485 8.485 20.485h35.146c-20.29 54.317-84.963 86.588-144.117 94.015V256h52c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-52v-5.47c37.281-13.178 63.995-48.725 64-90.518C384.005 43.772 341.605.738 289.37.01 235.723-.739 192 42.525 192 96c0 41.798 26.716 77.35 64 90.53V192h-52c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h52v190.015c-58.936-7.399-123.82-39.679-144.117-94.015h35.146c10.691 0 16.045-12.926 8.485-20.485l-67.029-67.029c-4.686-4.686-12.284-4.686-16.971 0L4.485 331.515C-3.074 339.074 2.28 352 12.971 352zM288 64c17.645 0 32 14.355 32 32s-14.355 32-32 32-32-14.355-32-32 14.355-32 32-32z"]
};
var faAngleDoubleDown = {
  prefix: 'fas',
  iconName: 'angle-double-down',
  icon: [320, 512, [], "f103", "M143 256.3L7 120.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0L313 86.3c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.4 9.5-24.6 9.5-34 .1zm34 192l136-136c9.4-9.4 9.4-24.6 0-33.9l-22.6-22.6c-9.4-9.4-24.6-9.4-33.9 0L160 352.1l-96.4-96.4c-9.4-9.4-24.6-9.4-33.9 0L7 278.3c-9.4 9.4-9.4 24.6 0 33.9l136 136c9.4 9.5 24.6 9.5 34 .1z"]
};
var faAngleDoubleLeft = {
  prefix: 'fas',
  iconName: 'angle-double-left',
  icon: [448, 512, [], "f100", "M223.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L319.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L393.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34zm-192 34l136 136c9.4 9.4 24.6 9.4 33.9 0l22.6-22.6c9.4-9.4 9.4-24.6 0-33.9L127.9 256l96.4-96.4c9.4-9.4 9.4-24.6 0-33.9L201.7 103c-9.4-9.4-24.6-9.4-33.9 0l-136 136c-9.5 9.4-9.5 24.6-.1 34z"]
};
var faAngleDoubleRight = {
  prefix: 'fas',
  iconName: 'angle-double-right',
  icon: [448, 512, [], "f101", "M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34zm192-34l-136-136c-9.4-9.4-24.6-9.4-33.9 0l-22.6 22.6c-9.4 9.4-9.4 24.6 0 33.9l96.4 96.4-96.4 96.4c-9.4 9.4-9.4 24.6 0 33.9l22.6 22.6c9.4 9.4 24.6 9.4 33.9 0l136-136c9.4-9.2 9.4-24.4 0-33.8z"]
};
var faAngleDoubleUp = {
  prefix: 'fas',
  iconName: 'angle-double-up',
  icon: [320, 512, [], "f102", "M177 255.7l136 136c9.4 9.4 9.4 24.6 0 33.9l-22.6 22.6c-9.4 9.4-24.6 9.4-33.9 0L160 351.9l-96.4 96.4c-9.4 9.4-24.6 9.4-33.9 0L7 425.7c-9.4-9.4-9.4-24.6 0-33.9l136-136c9.4-9.5 24.6-9.5 34-.1zm-34-192L7 199.7c-9.4 9.4-9.4 24.6 0 33.9l22.6 22.6c9.4 9.4 24.6 9.4 33.9 0l96.4-96.4 96.4 96.4c9.4 9.4 24.6 9.4 33.9 0l22.6-22.6c9.4-9.4 9.4-24.6 0-33.9l-136-136c-9.2-9.4-24.4-9.4-33.8 0z"]
};
var faAngleDown = {
  prefix: 'fas',
  iconName: 'angle-down',
  icon: [320, 512, [], "f107", "M143 352.3L7 216.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.2 9.4-24.4 9.4-33.8 0z"]
};
var faAngleLeft = {
  prefix: 'fas',
  iconName: 'angle-left',
  icon: [256, 512, [], "f104", "M31.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L127.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L201.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34z"]
};
var faAngleRight = {
  prefix: 'fas',
  iconName: 'angle-right',
  icon: [256, 512, [], "f105", "M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z"]
};
var faAngleUp = {
  prefix: 'fas',
  iconName: 'angle-up',
  icon: [320, 512, [], "f106", "M177 159.7l136 136c9.4 9.4 9.4 24.6 0 33.9l-22.6 22.6c-9.4 9.4-24.6 9.4-33.9 0L160 255.9l-96.4 96.4c-9.4 9.4-24.6 9.4-33.9 0L7 329.7c-9.4-9.4-9.4-24.6 0-33.9l136-136c9.4-9.5 24.6-9.5 34-.1z"]
};
var faAngry = {
  prefix: 'fas',
  iconName: 'angry',
  icon: [496, 512, [], "f556", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM136 240c0-9.3 4.1-17.5 10.5-23.4l-31-9.3c-8.5-2.5-13.3-11.5-10.7-19.9 2.5-8.5 11.4-13.2 19.9-10.7l80 24c8.5 2.5 13.3 11.5 10.7 19.9-2.1 6.9-8.4 11.4-15.3 11.4-.5 0-1.1-.2-1.7-.2.7 2.7 1.7 5.3 1.7 8.2 0 17.7-14.3 32-32 32S136 257.7 136 240zm168 154.2c-27.8-33.4-84.2-33.4-112.1 0-13.5 16.3-38.2-4.2-24.6-20.5 20-24 49.4-37.8 80.6-37.8s60.6 13.8 80.6 37.8c13.8 16.5-11.1 36.6-24.5 20.5zm76.6-186.9l-31 9.3c6.3 5.8 10.5 14.1 10.5 23.4 0 17.7-14.3 32-32 32s-32-14.3-32-32c0-2.9.9-5.6 1.7-8.2-.6.1-1.1.2-1.7.2-6.9 0-13.2-4.5-15.3-11.4-2.5-8.5 2.3-17.4 10.7-19.9l80-24c8.4-2.5 17.4 2.3 19.9 10.7 2.5 8.5-2.3 17.4-10.8 19.9z"]
};
var faAnkh = {
  prefix: 'fas',
  iconName: 'ankh',
  icon: [320, 512, [], "f644", "M296 256h-44.62C272.46 222.01 288 181.65 288 144 288 55.63 230.69 0 160 0S32 55.63 32 144c0 37.65 15.54 78.01 36.62 112H24c-13.25 0-24 10.74-24 24v32c0 13.25 10.75 24 24 24h96v152c0 13.25 10.75 24 24 24h32c13.25 0 24-10.75 24-24V336h96c13.25 0 24-10.75 24-24v-32c0-13.26-10.75-24-24-24zM160 80c29.61 0 48 24.52 48 64 0 34.66-27.14 78.14-48 100.87-20.86-22.72-48-66.21-48-100.87 0-39.48 18.39-64 48-64z"]
};
var faAppleAlt = {
  prefix: 'fas',
  iconName: 'apple-alt',
  icon: [448, 512, [], "f5d1", "M350.85 129c25.97 4.67 47.27 18.67 63.92 42 14.65 20.67 24.64 46.67 29.96 78 4.67 28.67 4.32 57.33-1 86-7.99 47.33-23.97 87-47.94 119-28.64 38.67-64.59 58-107.87 58-10.66 0-22.3-3.33-34.96-10-8.66-5.33-18.31-8-28.97-8s-20.3 2.67-28.97 8c-12.66 6.67-24.3 10-34.96 10-43.28 0-79.23-19.33-107.87-58-23.97-32-39.95-71.67-47.94-119-5.32-28.67-5.67-57.33-1-86 5.32-31.33 15.31-57.33 29.96-78 16.65-23.33 37.95-37.33 63.92-42 15.98-2.67 37.95-.33 65.92 7 23.97 6.67 44.28 14.67 60.93 24 16.65-9.33 36.96-17.33 60.93-24 27.98-7.33 49.96-9.67 65.94-7zm-54.94-41c-9.32 8.67-21.65 15-36.96 19-10.66 3.33-22.3 5-34.96 5l-14.98-1c-1.33-9.33-1.33-20 0-32 2.67-24 10.32-42.33 22.97-55 9.32-8.67 21.65-15 36.96-19 10.66-3.33 22.3-5 34.96-5l14.98 1 1 15c0 12.67-1.67 24.33-4.99 35-3.99 15.33-10.31 27.67-18.98 37z"]
};
var faArchive = {
  prefix: 'fas',
  iconName: 'archive',
  icon: [512, 512, [], "f187", "M32 448c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32V160H32v288zm160-212c0-6.6 5.4-12 12-12h104c6.6 0 12 5.4 12 12v8c0 6.6-5.4 12-12 12H204c-6.6 0-12-5.4-12-12v-8zM480 32H32C14.3 32 0 46.3 0 64v48c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16V64c0-17.7-14.3-32-32-32z"]
};
var faArchway = {
  prefix: 'fas',
  iconName: 'archway',
  icon: [576, 512, [], "f557", "M560 448h-16V96H32v352H16.02c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16H176c8.84 0 16-7.16 16-16V320c0-53.02 42.98-96 96-96s96 42.98 96 96l.02 160v16c0 8.84 7.16 16 16 16H560c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm0-448H16C7.16 0 0 7.16 0 16v32c0 8.84 7.16 16 16 16h544c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16z"]
};
var faArrowAltCircleDown = {
  prefix: 'fas',
  iconName: 'arrow-alt-circle-down',
  icon: [512, 512, [], "f358", "M504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zM212 140v116h-70.9c-10.7 0-16.1 13-8.5 20.5l114.9 114.3c4.7 4.7 12.2 4.7 16.9 0l114.9-114.3c7.6-7.6 2.2-20.5-8.5-20.5H300V140c0-6.6-5.4-12-12-12h-64c-6.6 0-12 5.4-12 12z"]
};
var faArrowAltCircleLeft = {
  prefix: 'fas',
  iconName: 'arrow-alt-circle-left',
  icon: [512, 512, [], "f359", "M256 504C119 504 8 393 8 256S119 8 256 8s248 111 248 248-111 248-248 248zm116-292H256v-70.9c0-10.7-13-16.1-20.5-8.5L121.2 247.5c-4.7 4.7-4.7 12.2 0 16.9l114.3 114.9c7.6 7.6 20.5 2.2 20.5-8.5V300h116c6.6 0 12-5.4 12-12v-64c0-6.6-5.4-12-12-12z"]
};
var faArrowAltCircleRight = {
  prefix: 'fas',
  iconName: 'arrow-alt-circle-right',
  icon: [512, 512, [], "f35a", "M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zM140 300h116v70.9c0 10.7 13 16.1 20.5 8.5l114.3-114.9c4.7-4.7 4.7-12.2 0-16.9l-114.3-115c-7.6-7.6-20.5-2.2-20.5 8.5V212H140c-6.6 0-12 5.4-12 12v64c0 6.6 5.4 12 12 12z"]
};
var faArrowAltCircleUp = {
  prefix: 'fas',
  iconName: 'arrow-alt-circle-up',
  icon: [512, 512, [], "f35b", "M8 256C8 119 119 8 256 8s248 111 248 248-111 248-248 248S8 393 8 256zm292 116V256h70.9c10.7 0 16.1-13 8.5-20.5L264.5 121.2c-4.7-4.7-12.2-4.7-16.9 0l-115 114.3c-7.6 7.6-2.2 20.5 8.5 20.5H212v116c0 6.6 5.4 12 12 12h64c6.6 0 12-5.4 12-12z"]
};
var faArrowCircleDown = {
  prefix: 'fas',
  iconName: 'arrow-circle-down',
  icon: [512, 512, [], "f0ab", "M504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-143.6-28.9L288 302.6V120c0-13.3-10.7-24-24-24h-16c-13.3 0-24 10.7-24 24v182.6l-72.4-75.5c-9.3-9.7-24.8-9.9-34.3-.4l-10.9 11c-9.4 9.4-9.4 24.6 0 33.9L239 404.3c9.4 9.4 24.6 9.4 33.9 0l132.7-132.7c9.4-9.4 9.4-24.6 0-33.9l-10.9-11c-9.5-9.5-25-9.3-34.3.4z"]
};
var faArrowCircleLeft = {
  prefix: 'fas',
  iconName: 'arrow-circle-left',
  icon: [512, 512, [], "f0a8", "M256 504C119 504 8 393 8 256S119 8 256 8s248 111 248 248-111 248-248 248zm28.9-143.6L209.4 288H392c13.3 0 24-10.7 24-24v-16c0-13.3-10.7-24-24-24H209.4l75.5-72.4c9.7-9.3 9.9-24.8.4-34.3l-11-10.9c-9.4-9.4-24.6-9.4-33.9 0L107.7 239c-9.4 9.4-9.4 24.6 0 33.9l132.7 132.7c9.4 9.4 24.6 9.4 33.9 0l11-10.9c9.5-9.5 9.3-25-.4-34.3z"]
};
var faArrowCircleRight = {
  prefix: 'fas',
  iconName: 'arrow-circle-right',
  icon: [512, 512, [], "f0a9", "M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zm-28.9 143.6l75.5 72.4H120c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24h182.6l-75.5 72.4c-9.7 9.3-9.9 24.8-.4 34.3l11 10.9c9.4 9.4 24.6 9.4 33.9 0L404.3 273c9.4-9.4 9.4-24.6 0-33.9L271.6 106.3c-9.4-9.4-24.6-9.4-33.9 0l-11 10.9c-9.5 9.6-9.3 25.1.4 34.4z"]
};
var faArrowCircleUp = {
  prefix: 'fas',
  iconName: 'arrow-circle-up',
  icon: [512, 512, [], "f0aa", "M8 256C8 119 119 8 256 8s248 111 248 248-111 248-248 248S8 393 8 256zm143.6 28.9l72.4-75.5V392c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V209.4l72.4 75.5c9.3 9.7 24.8 9.9 34.3.4l10.9-11c9.4-9.4 9.4-24.6 0-33.9L273 107.7c-9.4-9.4-24.6-9.4-33.9 0L106.3 240.4c-9.4 9.4-9.4 24.6 0 33.9l10.9 11c9.6 9.5 25.1 9.3 34.4-.4z"]
};
var faArrowDown = {
  prefix: 'fas',
  iconName: 'arrow-down',
  icon: [448, 512, [], "f063", "M413.1 222.5l22.2 22.2c9.4 9.4 9.4 24.6 0 33.9L241 473c-9.4 9.4-24.6 9.4-33.9 0L12.7 278.6c-9.4-9.4-9.4-24.6 0-33.9l22.2-22.2c9.5-9.5 25-9.3 34.3.4L184 343.4V56c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24v287.4l114.8-120.5c9.3-9.8 24.8-10 34.3-.4z"]
};
var faArrowLeft = {
  prefix: 'fas',
  iconName: 'arrow-left',
  icon: [448, 512, [], "f060", "M257.5 445.1l-22.2 22.2c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L201.4 44.7c9.4-9.4 24.6-9.4 33.9 0l22.2 22.2c9.5 9.5 9.3 25-.4 34.3L136.6 216H424c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H136.6l120.5 114.8c9.8 9.3 10 24.8.4 34.3z"]
};
var faArrowRight = {
  prefix: 'fas',
  iconName: 'arrow-right',
  icon: [448, 512, [], "f061", "M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z"]
};
var faArrowUp = {
  prefix: 'fas',
  iconName: 'arrow-up',
  icon: [448, 512, [], "f062", "M34.9 289.5l-22.2-22.2c-9.4-9.4-9.4-24.6 0-33.9L207 39c9.4-9.4 24.6-9.4 33.9 0l194.3 194.3c9.4 9.4 9.4 24.6 0 33.9L413 289.4c-9.5 9.5-25 9.3-34.3-.4L264 168.6V456c0 13.3-10.7 24-24 24h-32c-13.3 0-24-10.7-24-24V168.6L69.2 289.1c-9.3 9.8-24.8 10-34.3.4z"]
};
var faArrowsAlt = {
  prefix: 'fas',
  iconName: 'arrows-alt',
  icon: [512, 512, [], "f0b2", "M352.201 425.775l-79.196 79.196c-9.373 9.373-24.568 9.373-33.941 0l-79.196-79.196c-15.119-15.119-4.411-40.971 16.971-40.97h51.162L228 284H127.196v51.162c0 21.382-25.851 32.09-40.971 16.971L7.029 272.937c-9.373-9.373-9.373-24.569 0-33.941L86.225 159.8c15.119-15.119 40.971-4.411 40.971 16.971V228H228V127.196h-51.23c-21.382 0-32.09-25.851-16.971-40.971l79.196-79.196c9.373-9.373 24.568-9.373 33.941 0l79.196 79.196c15.119 15.119 4.411 40.971-16.971 40.971h-51.162V228h100.804v-51.162c0-21.382 25.851-32.09 40.97-16.971l79.196 79.196c9.373 9.373 9.373 24.569 0 33.941L425.773 352.2c-15.119 15.119-40.971 4.411-40.97-16.971V284H284v100.804h51.23c21.382 0 32.09 25.851 16.971 40.971z"]
};
var faArrowsAltH = {
  prefix: 'fas',
  iconName: 'arrows-alt-h',
  icon: [512, 512, [], "f337", "M377.941 169.941V216H134.059v-46.059c0-21.382-25.851-32.09-40.971-16.971L7.029 239.029c-9.373 9.373-9.373 24.568 0 33.941l86.059 86.059c15.119 15.119 40.971 4.411 40.971-16.971V296h243.882v46.059c0 21.382 25.851 32.09 40.971 16.971l86.059-86.059c9.373-9.373 9.373-24.568 0-33.941l-86.059-86.059c-15.119-15.12-40.971-4.412-40.971 16.97z"]
};
var faArrowsAltV = {
  prefix: 'fas',
  iconName: 'arrows-alt-v',
  icon: [256, 512, [], "f338", "M214.059 377.941H168V134.059h46.059c21.382 0 32.09-25.851 16.971-40.971L144.971 7.029c-9.373-9.373-24.568-9.373-33.941 0L24.971 93.088c-15.119 15.119-4.411 40.971 16.971 40.971H88v243.882H41.941c-21.382 0-32.09 25.851-16.971 40.971l86.059 86.059c9.373 9.373 24.568 9.373 33.941 0l86.059-86.059c15.12-15.119 4.412-40.971-16.97-40.971z"]
};
var faAssistiveListeningSystems = {
  prefix: 'fas',
  iconName: 'assistive-listening-systems',
  icon: [512, 512, [], "f2a2", "M216 260c0 15.464-12.536 28-28 28s-28-12.536-28-28c0-44.112 35.888-80 80-80s80 35.888 80 80c0 15.464-12.536 28-28 28s-28-12.536-28-28c0-13.234-10.767-24-24-24s-24 10.766-24 24zm24-176c-97.047 0-176 78.953-176 176 0 15.464 12.536 28 28 28s28-12.536 28-28c0-66.168 53.832-120 120-120s120 53.832 120 120c0 75.164-71.009 70.311-71.997 143.622L288 404c0 28.673-23.327 52-52 52-15.464 0-28 12.536-28 28s12.536 28 28 28c59.475 0 107.876-48.328 108-107.774.595-34.428 72-48.24 72-144.226 0-97.047-78.953-176-176-176zm-80 236c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zM32 448c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm480-187.993c0-1.518-.012-3.025-.045-4.531C510.076 140.525 436.157 38.47 327.994 1.511c-14.633-4.998-30.549 2.809-35.55 17.442-5 14.633 2.81 30.549 17.442 35.55 85.906 29.354 144.61 110.513 146.077 201.953l.003.188c.026 1.118.033 2.236.033 3.363 0 15.464 12.536 28 28 28s28.001-12.536 28.001-28zM152.971 439.029l-80-80L39.03 392.97l80 80 33.941-33.941z"]
};
var faAsterisk = {
  prefix: 'fas',
  iconName: 'asterisk',
  icon: [512, 512, [], "f069", "M478.21 334.093L336 256l142.21-78.093c11.795-6.477 15.961-21.384 9.232-33.037l-19.48-33.741c-6.728-11.653-21.72-15.499-33.227-8.523L296 186.718l3.475-162.204C299.763 11.061 288.937 0 275.48 0h-38.96c-13.456 0-24.283 11.061-23.994 24.514L216 186.718 77.265 102.607c-11.506-6.976-26.499-3.13-33.227 8.523l-19.48 33.741c-6.728 11.653-2.562 26.56 9.233 33.037L176 256 33.79 334.093c-11.795 6.477-15.961 21.384-9.232 33.037l19.48 33.741c6.728 11.653 21.721 15.499 33.227 8.523L216 325.282l-3.475 162.204C212.237 500.939 223.064 512 236.52 512h38.961c13.456 0 24.283-11.061 23.995-24.514L296 325.282l138.735 84.111c11.506 6.976 26.499 3.13 33.227-8.523l19.48-33.741c6.728-11.653 2.563-26.559-9.232-33.036z"]
};
var faAt = {
  prefix: 'fas',
  iconName: 'at',
  icon: [512, 512, [], "f1fa", "M256 8C118.941 8 8 118.919 8 256c0 137.059 110.919 248 248 248 48.154 0 95.342-14.14 135.408-40.223 12.005-7.815 14.625-24.288 5.552-35.372l-10.177-12.433c-7.671-9.371-21.179-11.667-31.373-5.129C325.92 429.757 291.314 440 256 440c-101.458 0-184-82.542-184-184S154.542 72 256 72c100.139 0 184 57.619 184 160 0 38.786-21.093 79.742-58.17 83.693-17.349-.454-16.91-12.857-13.476-30.024l23.433-121.11C394.653 149.75 383.308 136 368.225 136h-44.981a13.518 13.518 0 0 0-13.432 11.993l-.01.092c-14.697-17.901-40.448-21.775-59.971-21.775-74.58 0-137.831 62.234-137.831 151.46 0 65.303 36.785 105.87 96 105.87 26.984 0 57.369-15.637 74.991-38.333 9.522 34.104 40.613 34.103 70.71 34.103C462.609 379.41 504 307.798 504 232 504 95.653 394.023 8 256 8zm-21.68 304.43c-22.249 0-36.07-15.623-36.07-40.771 0-44.993 30.779-72.729 58.63-72.729 22.292 0 35.601 15.241 35.601 40.77 0 45.061-33.875 72.73-58.161 72.73z"]
};
var faAtlas = {
  prefix: 'fas',
  iconName: 'atlas',
  icon: [448, 512, [], "f558", "M318.38 208h-39.09c-1.49 27.03-6.54 51.35-14.21 70.41 27.71-13.24 48.02-39.19 53.3-70.41zm0-32c-5.29-31.22-25.59-57.17-53.3-70.41 7.68 19.06 12.72 43.38 14.21 70.41h39.09zM224 97.31c-7.69 7.45-20.77 34.42-23.43 78.69h46.87c-2.67-44.26-15.75-71.24-23.44-78.69zm-41.08 8.28c-27.71 13.24-48.02 39.19-53.3 70.41h39.09c1.49-27.03 6.53-51.35 14.21-70.41zm0 172.82c-7.68-19.06-12.72-43.38-14.21-70.41h-39.09c5.28 31.22 25.59 57.17 53.3 70.41zM247.43 208h-46.87c2.66 44.26 15.74 71.24 23.43 78.69 7.7-7.45 20.78-34.43 23.44-78.69zM448 358.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16c0-6.4-3.2-12.8-9.6-19.2-3.2-16-3.2-60.8 0-73.6 6.4-3.2 9.6-9.6 9.6-19.2zM224 64c70.69 0 128 57.31 128 128s-57.31 128-128 128S96 262.69 96 192 153.31 64 224 64zm160 384H96c-19.2 0-32-12.8-32-32s16-32 32-32h288v64z"]
};
var faAtom = {
  prefix: 'fas',
  iconName: 'atom',
  icon: [448, 512, [], "f5d2", "M223.99908,224a32,32,0,1,0,32.00782,32A32.06431,32.06431,0,0,0,223.99908,224Zm214.172-96c-10.877-19.5-40.50979-50.75-116.27544-41.875C300.39168,34.875,267.63386,0,223.99908,0s-76.39066,34.875-97.89653,86.125C50.3369,77.375,20.706,108.5,9.82907,128-6.54984,157.375-5.17484,201.125,34.958,256-5.17484,310.875-6.54984,354.625,9.82907,384c29.13087,52.375,101.64652,43.625,116.27348,41.875C147.60842,477.125,180.36429,512,223.99908,512s76.3926-34.875,97.89652-86.125c14.62891,1.75,87.14456,10.5,116.27544-41.875C454.55,354.625,453.175,310.875,413.04017,256,453.175,201.125,454.55,157.375,438.171,128ZM63.33886,352c-4-7.25-.125-24.75,15.00391-48.25,6.87695,6.5,14.12891,12.875,21.88087,19.125,1.625,13.75,4,27.125,6.75,40.125C82.34472,363.875,67.09081,358.625,63.33886,352Zm36.88478-162.875c-7.752,6.25-15.00392,12.625-21.88087,19.125-15.12891-23.5-19.00392-41-15.00391-48.25,3.377-6.125,16.37891-11.5,37.88478-11.5,1.75,0,3.875.375,5.75.375C104.09864,162.25,101.84864,175.625,100.22364,189.125ZM223.99908,64c9.50195,0,22.25586,13.5,33.88282,37.25-11.252,3.75-22.50391,8-33.88282,12.875-11.377-4.875-22.62892-9.125-33.88283-12.875C201.74516,77.5,214.49712,64,223.99908,64Zm0,384c-9.502,0-22.25392-13.5-33.88283-37.25,11.25391-3.75,22.50587-8,33.88283-12.875C235.378,402.75,246.62994,407,257.8819,410.75,246.25494,434.5,233.501,448,223.99908,448Zm0-112a80,80,0,1,1,80-80A80.00023,80.00023,0,0,1,223.99908,336ZM384.6593,352c-3.625,6.625-19.00392,11.875-43.63479,11,2.752-13,5.127-26.375,6.752-40.125,7.75195-6.25,15.00391-12.625,21.87891-19.125C384.7843,327.25,388.6593,344.75,384.6593,352ZM369.65538,208.25c-6.875-6.5-14.127-12.875-21.87891-19.125-1.625-13.5-3.875-26.875-6.752-40.25,1.875,0,4.002-.375,5.752-.375,21.50391,0,34.50782,5.375,37.88283,11.5C388.6593,167.25,384.7843,184.75,369.65538,208.25Z"]
};
var faAudioDescription = {
  prefix: 'fas',
  iconName: 'audio-description',
  icon: [512, 512, [], "f29e", "M162.925 238.709l8.822 30.655h-25.606l9.041-30.652c1.277-4.421 2.651-9.994 3.872-15.245 1.22 5.251 2.594 10.823 3.871 15.242zm166.474-32.099h-14.523v98.781h14.523c29.776 0 46.175-17.678 46.175-49.776 0-32.239-17.49-49.005-46.175-49.005zM512 112v288c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h416c26.51 0 48 21.49 48 48zM245.459 336.139l-57.097-168A12.001 12.001 0 0 0 177 160h-35.894a12.001 12.001 0 0 0-11.362 8.139l-57.097 168C70.003 343.922 75.789 352 84.009 352h29.133a12 12 0 0 0 11.535-8.693l8.574-29.906h51.367l8.793 29.977A12 12 0 0 0 204.926 352h29.172c8.22 0 14.006-8.078 11.361-15.861zm184.701-80.525c0-58.977-37.919-95.614-98.96-95.614h-57.366c-6.627 0-12 5.373-12 12v168c0 6.627 5.373 12 12 12H331.2c61.041 0 98.96-36.933 98.96-96.386z"]
};
var faAward = {
  prefix: 'fas',
  iconName: 'award',
  icon: [384, 512, [], "f559", "M97.12 362.63c-8.69-8.69-4.16-6.24-25.12-11.85-9.51-2.55-17.87-7.45-25.43-13.32L1.2 448.7c-4.39 10.77 3.81 22.47 15.43 22.03l52.69-2.01L105.56 507c8 8.44 22.04 5.81 26.43-4.96l52.05-127.62c-10.84 6.04-22.87 9.58-35.31 9.58-19.5 0-37.82-7.59-51.61-21.37zM382.8 448.7l-45.37-111.24c-7.56 5.88-15.92 10.77-25.43 13.32-21.07 5.64-16.45 3.18-25.12 11.85-13.79 13.78-32.12 21.37-51.62 21.37-12.44 0-24.47-3.55-35.31-9.58L252 502.04c4.39 10.77 18.44 13.4 26.43 4.96l36.25-38.28 52.69 2.01c11.62.44 19.82-11.27 15.43-22.03zM263 340c15.28-15.55 17.03-14.21 38.79-20.14 13.89-3.79 24.75-14.84 28.47-28.98 7.48-28.4 5.54-24.97 25.95-45.75 10.17-10.35 14.14-25.44 10.42-39.58-7.47-28.38-7.48-24.42 0-52.83 3.72-14.14-.25-29.23-10.42-39.58-20.41-20.78-18.47-17.36-25.95-45.75-3.72-14.14-14.58-25.19-28.47-28.98-27.88-7.61-24.52-5.62-44.95-26.41-10.17-10.35-25-14.4-38.89-10.61-27.87 7.6-23.98 7.61-51.9 0-13.89-3.79-28.72.25-38.89 10.61-20.41 20.78-17.05 18.8-44.94 26.41-13.89 3.79-24.75 14.84-28.47 28.98-7.47 28.39-5.54 24.97-25.95 45.75-10.17 10.35-14.15 25.44-10.42 39.58 7.47 28.36 7.48 24.4 0 52.82-3.72 14.14.25 29.23 10.42 39.59 20.41 20.78 18.47 17.35 25.95 45.75 3.72 14.14 14.58 25.19 28.47 28.98C104.6 325.96 106.27 325 121 340c13.23 13.47 33.84 15.88 49.74 5.82a39.676 39.676 0 0 1 42.53 0c15.89 10.06 36.5 7.65 49.73-5.82zM97.66 175.96c0-53.03 42.24-96.02 94.34-96.02s94.34 42.99 94.34 96.02-42.24 96.02-94.34 96.02-94.34-42.99-94.34-96.02z"]
};
var faBaby = {
  prefix: 'fas',
  iconName: 'baby',
  icon: [384, 512, [], "f77c", "M192 160c44.2 0 80-35.8 80-80S236.2 0 192 0s-80 35.8-80 80 35.8 80 80 80zm-53.4 248.8l25.6-32-61.5-51.2L56.8 383c-11.4 14.2-11.7 34.4-.8 49l48 64c7.9 10.5 19.9 16 32 16 8.3 0 16.8-2.6 24-8 17.7-13.2 21.2-38.3 8-56l-29.4-39.2zm142.7-83.2l-61.5 51.2 25.6 32L216 448c-13.2 17.7-9.7 42.8 8 56 7.2 5.4 15.6 8 24 8 12.2 0 24.2-5.5 32-16l48-64c10.9-14.6 10.6-34.8-.8-49l-45.9-57.4zM376.7 145c-12.7-18.1-37.6-22.4-55.7-9.8l-40.6 28.5c-52.7 37-124.2 37-176.8 0L63 135.3C44.9 122.6 20 127 7.3 145-5.4 163.1-1 188 17 200.7l40.6 28.5c17 11.9 35.4 20.9 54.4 27.9V288h160v-30.8c19-7 37.4-16 54.4-27.9l40.6-28.5c18.1-12.8 22.4-37.7 9.7-55.8z"]
};
var faBabyCarriage = {
  prefix: 'fas',
  iconName: 'baby-carriage',
  icon: [512, 512, [], "f77d", "M144.8 17c-11.3-17.8-37.2-22.8-54-9.4C35.3 51.9 0 118 0 192h256L144.8 17zM496 96h-48c-35.3 0-64 28.7-64 64v64H0c0 50.6 23 96.4 60.3 130.7C25.7 363.6 0 394.7 0 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-8.9-1.8-17.2-4.4-25.2 21.6 5.9 44.6 9.2 68.4 9.2s46.9-3.3 68.4-9.2c-2.7 8-4.4 16.3-4.4 25.2 0 44.2 35.8 80 80 80s80-35.8 80-80c0-37.3-25.7-68.4-60.3-77.3C425 320.4 448 274.6 448 224v-64h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM80 464c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm320-32c0 17.6-14.4 32-32 32s-32-14.4-32-32 14.4-32 32-32 32 14.4 32 32z"]
};
var faBackspace = {
  prefix: 'fas',
  iconName: 'backspace',
  icon: [640, 512, [], "f55a", "M576 64H205.26A63.97 63.97 0 0 0 160 82.75L9.37 233.37c-12.5 12.5-12.5 32.76 0 45.25L160 429.25c12 12 28.28 18.75 45.25 18.75H576c35.35 0 64-28.65 64-64V128c0-35.35-28.65-64-64-64zm-84.69 254.06c6.25 6.25 6.25 16.38 0 22.63l-22.62 22.62c-6.25 6.25-16.38 6.25-22.63 0L384 301.25l-62.06 62.06c-6.25 6.25-16.38 6.25-22.63 0l-22.62-22.62c-6.25-6.25-6.25-16.38 0-22.63L338.75 256l-62.06-62.06c-6.25-6.25-6.25-16.38 0-22.63l22.62-22.62c6.25-6.25 16.38-6.25 22.63 0L384 210.75l62.06-62.06c6.25-6.25 16.38-6.25 22.63 0l22.62 22.62c6.25 6.25 6.25 16.38 0 22.63L429.25 256l62.06 62.06z"]
};
var faBackward = {
  prefix: 'fas',
  iconName: 'backward',
  icon: [512, 512, [], "f04a", "M11.5 280.6l192 160c20.6 17.2 52.5 2.8 52.5-24.6V96c0-27.4-31.9-41.8-52.5-24.6l-192 160c-15.3 12.8-15.3 36.4 0 49.2zm256 0l192 160c20.6 17.2 52.5 2.8 52.5-24.6V96c0-27.4-31.9-41.8-52.5-24.6l-192 160c-15.3 12.8-15.3 36.4 0 49.2z"]
};
var faBacon = {
  prefix: 'fas',
  iconName: 'bacon',
  icon: [576, 512, [], "f7e5", "M218.92 336.39c34.89-34.89 44.2-59.7 54.05-86 10.61-28.29 21.59-57.54 61.37-97.34s69.05-50.77 97.35-61.38c23.88-9 46.64-17.68 76.79-45.37L470.81 8.91a31 31 0 0 0-40.18-2.83c-13.64 10.1-25.15 14.39-41 20.3C247 79.52 209.26 191.29 200.65 214.1c-29.75 78.83-89.55 94.68-98.72 98.09-24.86 9.26-54.73 20.38-91.07 50.36C-3 374-3.63 395 9.07 407.61l35.76 35.51C80 410.52 107 400.15 133 390.39c26.27-9.84 51.06-19.12 85.92-54zm348-232l-35.75-35.51c-35.19 32.63-62.18 43-88.25 52.79-26.26 9.85-51.06 19.16-85.95 54s-44.19 59.69-54 86C292.33 290 281.34 319.22 241.55 359s-69 50.73-97.3 61.32c-23.86 9-46.61 17.66-76.72 45.33l37.68 37.43a31 31 0 0 0 40.18 2.82c13.6-10.06 25.09-14.34 40.94-20.24 142.2-53 180-164.1 188.94-187.69C405 219.18 464.8 203.3 474 199.86c24.87-9.27 54.74-20.4 91.11-50.41 13.89-11.4 14.52-32.45 1.82-45.05z"]
};
var faBacteria = {
  prefix: 'fas',
  iconName: 'bacteria',
  icon: [640, 512, [], "e059", "M272.35,226.4A17.71,17.71,0,0,0,281.46,203l-4-9.08a121.29,121.29,0,0,1,12.36-3.08A83.34,83.34,0,0,0,323.57,177l10,9a17.76,17.76,0,1,0,23.92-26.27l-9.72-8.76a83.12,83.12,0,0,0,11.65-48.18l11.85-3.51a17.73,17.73,0,1,0-10.15-34l-11.34,3.36a84,84,0,0,0-36.38-35.57l2.84-10.85a17.8,17.8,0,0,0-34.47-8.93l-2.82,10.78a83.25,83.25,0,0,0-16.74,1.1C250.83,27,240,30.22,229.1,33.39l-3.38-9.46a17.8,17.8,0,0,0-33.56,11.89l3.49,9.8a286.74,286.74,0,0,0-43.94,23.57l-6.32-8.43a17.9,17.9,0,0,0-24.94-3.6A17.69,17.69,0,0,0,116.84,82l6.45,8.61a286.59,286.59,0,0,0-34.95,35.33l-8.82-6.42a17.84,17.84,0,0,0-24.89,3.86,17.66,17.66,0,0,0,3.88,24.77l8.88,6.47a286.6,286.6,0,0,0-23,43.91l-10.48-3.59a17.73,17.73,0,1,0-11.59,33.52L32.67,232c-2.79,10-5.79,19.84-7.52,30.22a83.16,83.16,0,0,0-.82,19l-11.58,3.43a17.73,17.73,0,1,0,10.13,34l11.27-3.33a83.51,83.51,0,0,0,36.39,35.43l-2.88,11.06a17.81,17.81,0,0,0,34.48,8.92l2.87-11c1,0,2.07.26,3.1.26a83.39,83.39,0,0,0,45.65-13.88l8.59,8.8a17.77,17.77,0,0,0,25.56-24.7l-9.14-9.37a83.41,83.41,0,0,0,12.08-31.05,119.08,119.08,0,0,1,3.87-15.53l9,4.22a17.74,17.74,0,1,0,15.15-32.09l-8.8-4.11c.67-1,1.2-2.08,1.9-3.05a119.89,119.89,0,0,1,7.87-9.41,121.73,121.73,0,0,1,11.65-11.4,119.49,119.49,0,0,1,9.94-7.82c1.12-.77,2.32-1.42,3.47-2.15l3.92,8.85a17.86,17.86,0,0,0,16.32,10.58A18.14,18.14,0,0,0,272.35,226.4ZM128,256a32,32,0,1,1,32-32A32,32,0,0,1,128,256Zm80-96a16,16,0,1,1,16-16A16,16,0,0,1,208,160Zm431.26,45.3a17.79,17.79,0,0,0-17.06-12.69,17.55,17.55,0,0,0-5.08.74l-11.27,3.33a83.61,83.61,0,0,0-36.39-35.43l2.88-11.06a17.81,17.81,0,0,0-34.48-8.91l-2.87,11c-1,0-2.07-.26-3.1-.26a83.32,83.32,0,0,0-45.65,13.89l-8.59-8.81a17.77,17.77,0,0,0-25.56,24.7l9.14,9.37a83.28,83.28,0,0,0-12.08,31.06,119.34,119.34,0,0,1-3.87,15.52l-9-4.22a17.74,17.74,0,1,0-15.15,32.09l8.8,4.11c-.67,1-1.2,2.08-1.89,3.05a117.71,117.71,0,0,1-7.94,9.47,119,119,0,0,1-11.57,11.33,121.59,121.59,0,0,1-10,7.83c-1.12.77-2.32,1.42-3.47,2.15l-3.92-8.85a17.86,17.86,0,0,0-16.32-10.58,18.14,18.14,0,0,0-7.18,1.5A17.71,17.71,0,0,0,358.54,309l4,9.08a118.71,118.71,0,0,1-12.36,3.08,83.34,83.34,0,0,0-33.77,13.9l-10-9a17.77,17.77,0,1,0-23.92,26.28l9.72,8.75a83.12,83.12,0,0,0-11.65,48.18l-11.86,3.51a17.73,17.73,0,1,0,10.16,34l11.34-3.36A84,84,0,0,0,326.61,479l-2.84,10.85a17.8,17.8,0,0,0,34.47,8.93L361.06,488a83.3,83.3,0,0,0,16.74-1.1c11.37-1.89,22.24-5.07,33.1-8.24l3.38,9.46a17.8,17.8,0,0,0,33.56-11.89l-3.49-9.79a287.66,287.66,0,0,0,43.94-23.58l6.32,8.43a17.88,17.88,0,0,0,24.93,3.6A17.67,17.67,0,0,0,523.16,430l-6.45-8.61a287.37,287.37,0,0,0,34.95-35.34l8.82,6.42a17.76,17.76,0,1,0,21-28.63l-8.88-6.46a287.17,287.17,0,0,0,23-43.92l10.48,3.59a17.73,17.73,0,1,0,11.59-33.52L607.33,280c2.79-10,5.79-19.84,7.52-30.21a83.27,83.27,0,0,0,.82-19.05l11.58-3.43A17.7,17.7,0,0,0,639.26,205.3ZM416,416a32,32,0,1,1,32-32A32,32,0,0,1,416,416Z"]
};
var faBacterium = {
  prefix: 'fas',
  iconName: 'bacterium',
  icon: [512, 512, [], "e05a", "M511,102.93A23.76,23.76,0,0,0,481.47,87l-15.12,4.48a111.85,111.85,0,0,0-48.5-47.42l3.79-14.47a23.74,23.74,0,0,0-46-11.91l-3.76,14.37a111.94,111.94,0,0,0-22.33,1.47,386.74,386.74,0,0,0-44.33,10.41l-4.3-12a23.74,23.74,0,0,0-44.75,15.85l4.3,12.05a383.4,383.4,0,0,0-58.69,31.83l-8-10.63a23.85,23.85,0,0,0-33.24-4.8,23.57,23.57,0,0,0-4.83,33.09l8,10.63a386.14,386.14,0,0,0-46.7,47.44l-11-8a23.68,23.68,0,1,0-28,38.17l11.09,8.06a383.45,383.45,0,0,0-30.92,58.75l-12.93-4.43a23.65,23.65,0,1,0-15.47,44.69l13,4.48a385.81,385.81,0,0,0-9.3,40.53A111.58,111.58,0,0,0,32.44,375L17,379.56a23.64,23.64,0,0,0,13.51,45.31l15-4.44a111.49,111.49,0,0,0,48.53,47.24l-3.85,14.75a23.66,23.66,0,0,0,17,28.83,24.7,24.7,0,0,0,6,.75,23.73,23.73,0,0,0,23-17.7L140,479.67c1.37.05,2.77.35,4.13.35A111.22,111.22,0,0,0,205,461.5l11.45,11.74a23.7,23.7,0,0,0,34.08-32.93l-12.19-12.5a111,111,0,0,0,16.11-41.4,158.69,158.69,0,0,1,5.16-20.71l12,5.64a23.66,23.66,0,1,0,20.19-42.79l-11.72-5.49c.89-1.32,1.59-2.77,2.52-4.06a157.86,157.86,0,0,1,10.46-12.49,159.5,159.5,0,0,1,15.59-15.28,162.18,162.18,0,0,1,13.23-10.4c1.5-1,3.1-1.89,4.63-2.87l5.23,11.8a23.74,23.74,0,0,0,43.48-19.08l-5.36-12.11a158.87,158.87,0,0,1,16.49-4.1,111,111,0,0,0,45-18.54l13.33,12a23.69,23.69,0,1,0,31.88-35l-12.94-11.67A110.83,110.83,0,0,0,479.21,137L495,132.32A23.61,23.61,0,0,0,511,102.93ZM160,368a48,48,0,1,1,48-48A48,48,0,0,1,160,368Zm80-136a24,24,0,1,1,24-24A24,24,0,0,1,240,232Z"]
};
var faBahai = {
  prefix: 'fas',
  iconName: 'bahai',
  icon: [512, 512, [], "f666", "M496.25 202.52l-110-15.44 41.82-104.34c6.67-16.64-11.6-32.18-26.59-22.63L307.44 120 273.35 12.82C270.64 4.27 263.32 0 256 0c-7.32 0-14.64 4.27-17.35 12.82l-34.09 107.19-94.04-59.89c-14.99-9.55-33.25 5.99-26.59 22.63l41.82 104.34-110 15.43c-17.54 2.46-21.68 26.27-6.03 34.67l98.16 52.66-74.48 83.54c-10.92 12.25-1.72 30.93 13.29 30.93 1.31 0 2.67-.14 4.07-.45l108.57-23.65-4.11 112.55c-.43 11.65 8.87 19.22 18.41 19.22 5.15 0 10.39-2.21 14.2-7.18l68.18-88.9 68.18 88.9c3.81 4.97 9.04 7.18 14.2 7.18 9.54 0 18.84-7.57 18.41-19.22l-4.11-112.55 108.57 23.65c17.36 3.76 29.21-17.2 17.35-30.49l-74.48-83.54 98.16-52.66c15.64-8.39 11.5-32.2-6.04-34.66zM338.51 311.68l-51.89-11.3 1.97 53.79L256 311.68l-32.59 42.49 1.96-53.79-51.89 11.3 35.6-39.93-46.92-25.17 52.57-7.38-19.99-49.87 44.95 28.62L256 166.72l16.29 51.23 44.95-28.62-19.99 49.87 52.57 7.38-46.92 25.17 35.61 39.93z"]
};
var faBalanceScale = {
  prefix: 'fas',
  iconName: 'balance-scale',
  icon: [640, 512, [], "f24e", "M256 336h-.02c0-16.18 1.34-8.73-85.05-181.51-17.65-35.29-68.19-35.36-85.87 0C-2.06 328.75.02 320.33.02 336H0c0 44.18 57.31 80 128 80s128-35.82 128-80zM128 176l72 144H56l72-144zm511.98 160c0-16.18 1.34-8.73-85.05-181.51-17.65-35.29-68.19-35.36-85.87 0-87.12 174.26-85.04 165.84-85.04 181.51H384c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02zM440 320l72-144 72 144H440zm88 128H352V153.25c23.51-10.29 41.16-31.48 46.39-57.25H528c8.84 0 16-7.16 16-16V48c0-8.84-7.16-16-16-16H383.64C369.04 12.68 346.09 0 320 0s-49.04 12.68-63.64 32H112c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h129.61c5.23 25.76 22.87 46.96 46.39 57.25V448H112c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"]
};
var faBalanceScaleLeft = {
  prefix: 'fas',
  iconName: 'balance-scale-left',
  icon: [640, 512, [], "f515", "M528 448H352V153.25c20.42-8.94 36.1-26.22 43.38-47.47l132-44.26c8.38-2.81 12.89-11.88 10.08-20.26l-10.17-30.34C524.48 2.54 515.41-1.97 507.03.84L389.11 40.37C375.3 16.36 349.69 0 320 0c-44.18 0-80 35.82-80 80 0 3.43.59 6.71 1.01 10.03l-128.39 43.05c-8.38 2.81-12.89 11.88-10.08 20.26l10.17 30.34c2.81 8.38 11.88 12.89 20.26 10.08l142.05-47.63c4.07 2.77 8.43 5.12 12.99 7.12V496c0 8.84 7.16 16 16 16h224c8.84 0 16-7.16 16-16v-32c-.01-8.84-7.17-16-16.01-16zm111.98-144c0-16.18 1.34-8.73-85.05-181.51-17.65-35.29-68.19-35.36-85.87 0-87.12 174.26-85.04 165.84-85.04 181.51H384c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02zM440 288l72-144 72 144H440zm-269.07-37.51c-17.65-35.29-68.19-35.36-85.87 0C-2.06 424.75.02 416.33.02 432H0c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02c0-16.18 1.34-8.73-85.05-181.51zM56 416l72-144 72 144H56z"]
};
var faBalanceScaleRight = {
  prefix: 'fas',
  iconName: 'balance-scale-right',
  icon: [640, 512, [], "f516", "M96 464v32c0 8.84 7.16 16 16 16h224c8.84 0 16-7.16 16-16V153.25c4.56-2 8.92-4.35 12.99-7.12l142.05 47.63c8.38 2.81 17.45-1.71 20.26-10.08l10.17-30.34c2.81-8.38-1.71-17.45-10.08-20.26l-128.4-43.05c.42-3.32 1.01-6.6 1.01-10.03 0-44.18-35.82-80-80-80-29.69 0-55.3 16.36-69.11 40.37L132.96.83c-8.38-2.81-17.45 1.71-20.26 10.08l-10.17 30.34c-2.81 8.38 1.71 17.45 10.08 20.26l132 44.26c7.28 21.25 22.96 38.54 43.38 47.47V448H112c-8.84 0-16 7.16-16 16zM0 304c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02c0-15.67 2.08-7.25-85.05-181.51-17.68-35.36-68.22-35.29-85.87 0C-1.32 295.27.02 287.82.02 304H0zm56-16l72-144 72 144H56zm328.02 144H384c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02c0-15.67 2.08-7.25-85.05-181.51-17.68-35.36-68.22-35.29-85.87 0-86.38 172.78-85.04 165.33-85.04 181.51zM440 416l72-144 72 144H440z"]
};
var faBan = {
  prefix: 'fas',
  iconName: 'ban',
  icon: [512, 512, [], "f05e", "M256 8C119.034 8 8 119.033 8 256s111.034 248 248 248 248-111.034 248-248S392.967 8 256 8zm130.108 117.892c65.448 65.448 70 165.481 20.677 235.637L150.47 105.216c70.204-49.356 170.226-44.735 235.638 20.676zM125.892 386.108c-65.448-65.448-70-165.481-20.677-235.637L361.53 406.784c-70.203 49.356-170.226 44.736-235.638-20.676z"]
};
var faBandAid = {
  prefix: 'fas',
  iconName: 'band-aid',
  icon: [640, 512, [], "f462", "M0 160v192c0 35.3 28.7 64 64 64h96V96H64c-35.3 0-64 28.7-64 64zm576-64h-96v320h96c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64zM192 416h256V96H192v320zm176-232c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm0 96c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm-96-96c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm0 96c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24z"]
};
var faBarcode = {
  prefix: 'fas',
  iconName: 'barcode',
  icon: [512, 512, [], "f02a", "M0 448V64h18v384H0zm26.857-.273V64H36v383.727h-9.143zm27.143 0V64h8.857v383.727H54zm44.857 0V64h8.857v383.727h-8.857zm36 0V64h17.714v383.727h-17.714zm44.857 0V64h8.857v383.727h-8.857zm18 0V64h8.857v383.727h-8.857zm18 0V64h8.857v383.727h-8.857zm35.715 0V64h18v383.727h-18zm44.857 0V64h18v383.727h-18zm35.999 0V64h18.001v383.727h-18.001zm36.001 0V64h18.001v383.727h-18.001zm26.857 0V64h18v383.727h-18zm45.143 0V64h26.857v383.727h-26.857zm35.714 0V64h9.143v383.727H476zm18 .273V64h18v384h-18z"]
};
var faBars = {
  prefix: 'fas',
  iconName: 'bars',
  icon: [448, 512, [], "f0c9", "M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"]
};
var faBaseballBall = {
  prefix: 'fas',
  iconName: 'baseball-ball',
  icon: [496, 512, [], "f433", "M368.5 363.9l28.8-13.9c11.1 22.9 26 43.2 44.1 60.9 34-42.5 54.5-96.3 54.5-154.9 0-58.5-20.4-112.2-54.2-154.6-17.8 17.3-32.6 37.1-43.6 59.5l-28.7-14.1c12.8-26 30-49 50.8-69C375.6 34.7 315 8 248 8 181.1 8 120.5 34.6 75.9 77.7c20.7 19.9 37.9 42.9 50.7 68.8l-28.7 14.1c-11-22.3-25.7-42.1-43.5-59.4C20.4 143.7 0 197.4 0 256c0 58.6 20.4 112.3 54.4 154.7 18.2-17.7 33.2-38 44.3-61l28.8 13.9c-12.9 26.7-30.3 50.3-51.5 70.7 44.5 43.1 105.1 69.7 172 69.7 66.8 0 127.3-26.5 171.9-69.5-21.1-20.4-38.5-43.9-51.4-70.6zm-228.3-32l-30.5-9.8c14.9-46.4 12.7-93.8-.6-134l30.4-10c15 45.6 18 99.9.7 153.8zm216.3-153.4l30.4 10c-13.2 40.1-15.5 87.5-.6 134l-30.5 9.8c-17.3-54-14.3-108.3.7-153.8z"]
};
var faBasketballBall = {
  prefix: 'fas',
  iconName: 'basketball-ball',
  icon: [496, 512, [], "f434", "M212.3 10.3c-43.8 6.3-86.2 24.1-122.2 53.8l77.4 77.4c27.8-35.8 43.3-81.2 44.8-131.2zM248 222L405.9 64.1c-42.4-35-93.6-53.5-145.5-56.1-1.2 63.9-21.5 122.3-58.7 167.7L248 222zM56.1 98.1c-29.7 36-47.5 78.4-53.8 122.2 50-1.5 95.5-17 131.2-44.8L56.1 98.1zm272.2 204.2c45.3-37.1 103.7-57.4 167.7-58.7-2.6-51.9-21.1-103.1-56.1-145.5L282 256l46.3 46.3zM248 290L90.1 447.9c42.4 34.9 93.6 53.5 145.5 56.1 1.3-64 21.6-122.4 58.7-167.7L248 290zm191.9 123.9c29.7-36 47.5-78.4 53.8-122.2-50.1 1.6-95.5 17.1-131.2 44.8l77.4 77.4zM167.7 209.7C122.3 246.9 63.9 267.3 0 268.4c2.6 51.9 21.1 103.1 56.1 145.5L214 256l-46.3-46.3zm116 292c43.8-6.3 86.2-24.1 122.2-53.8l-77.4-77.4c-27.7 35.7-43.2 81.2-44.8 131.2z"]
};
var faBath = {
  prefix: 'fas',
  iconName: 'bath',
  icon: [512, 512, [], "f2cd", "M32,384a95.4,95.4,0,0,0,32,71.09V496a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16V480H384v16a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16V455.09A95.4,95.4,0,0,0,480,384V336H32ZM496,256H80V69.25a21.26,21.26,0,0,1,36.28-15l19.27,19.26c-13.13,29.88-7.61,59.11,8.62,79.73l-.17.17A16,16,0,0,0,144,176l11.31,11.31a16,16,0,0,0,22.63,0L283.31,81.94a16,16,0,0,0,0-22.63L272,48a16,16,0,0,0-22.62,0l-.17.17c-20.62-16.23-49.83-21.75-79.73-8.62L150.22,20.28A69.25,69.25,0,0,0,32,69.25V256H16A16,16,0,0,0,0,272v16a16,16,0,0,0,16,16H496a16,16,0,0,0,16-16V272A16,16,0,0,0,496,256Z"]
};
var faBatteryEmpty = {
  prefix: 'fas',
  iconName: 'battery-empty',
  icon: [640, 512, [], "f244", "M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48z"]
};
var faBatteryFull = {
  prefix: 'fas',
  iconName: 'battery-full',
  icon: [640, 512, [], "f240", "M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48zm-48 96H96v128h416V192z"]
};
var faBatteryHalf = {
  prefix: 'fas',
  iconName: 'battery-half',
  icon: [640, 512, [], "f242", "M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48zm-240 96H96v128h224V192z"]
};
var faBatteryQuarter = {
  prefix: 'fas',
  iconName: 'battery-quarter',
  icon: [640, 512, [], "f243", "M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48zm-336 96H96v128h128V192z"]
};
var faBatteryThreeQuarters = {
  prefix: 'fas',
  iconName: 'battery-three-quarters',
  icon: [640, 512, [], "f241", "M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48zm-144 96H96v128h320V192z"]
};
var faBed = {
  prefix: 'fas',
  iconName: 'bed',
  icon: [640, 512, [], "f236", "M176 256c44.11 0 80-35.89 80-80s-35.89-80-80-80-80 35.89-80 80 35.89 80 80 80zm352-128H304c-8.84 0-16 7.16-16 16v144H64V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v352c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-48h512v48c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V240c0-61.86-50.14-112-112-112z"]
};
var faBeer = {
  prefix: 'fas',
  iconName: 'beer',
  icon: [448, 512, [], "f0fc", "M368 96h-48V56c0-13.255-10.745-24-24-24H24C10.745 32 0 42.745 0 56v400c0 13.255 10.745 24 24 24h272c13.255 0 24-10.745 24-24v-42.11l80.606-35.977C429.396 365.063 448 336.388 448 304.86V176c0-44.112-35.888-80-80-80zm16 208.86a16.018 16.018 0 0 1-9.479 14.611L320 343.805V160h48c8.822 0 16 7.178 16 16v128.86zM208 384c-8.836 0-16-7.164-16-16V144c0-8.836 7.164-16 16-16s16 7.164 16 16v224c0 8.836-7.164 16-16 16zm-96 0c-8.836 0-16-7.164-16-16V144c0-8.836 7.164-16 16-16s16 7.164 16 16v224c0 8.836-7.164 16-16 16z"]
};
var faBell = {
  prefix: 'fas',
  iconName: 'bell',
  icon: [448, 512, [], "f0f3", "M224 512c35.32 0 63.97-28.65 63.97-64H160.03c0 35.35 28.65 64 63.97 64zm215.39-149.71c-19.32-20.76-55.47-51.99-55.47-154.29 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84C118.56 68.1 64.08 130.3 64.08 208c0 102.3-36.15 133.53-55.47 154.29-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h383.8c19.12 0 32-15.6 32.1-32 .05-7.55-2.61-15.27-8.61-21.71z"]
};
var faBellSlash = {
  prefix: 'fas',
  iconName: 'bell-slash',
  icon: [640, 512, [], "f1f6", "M633.82 458.1l-90.62-70.05c.19-1.38.8-2.66.8-4.06.05-7.55-2.61-15.27-8.61-21.71-19.32-20.76-55.47-51.99-55.47-154.29 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84c-40.33 8.38-74.66 31.07-97.59 62.57L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.35 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.42-6.97 4.17-17.02-2.81-22.45zM157.23 251.54c-8.61 67.96-36.41 93.33-52.62 110.75-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h241.92L157.23 251.54zM320 512c35.32 0 63.97-28.65 63.97-64H256.03c0 35.35 28.65 64 63.97 64z"]
};
var faBezierCurve = {
  prefix: 'fas',
  iconName: 'bezier-curve',
  icon: [640, 512, [], "f55b", "M368 32h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zM208 88h-84.75C113.75 64.56 90.84 48 64 48 28.66 48 0 76.65 0 112s28.66 64 64 64c26.84 0 49.75-16.56 59.25-40h79.73c-55.37 32.52-95.86 87.32-109.54 152h49.4c11.3-41.61 36.77-77.21 71.04-101.56-3.7-8.08-5.88-16.99-5.88-26.44V88zm-48 232H64c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32zM576 48c-26.84 0-49.75 16.56-59.25 40H432v72c0 9.45-2.19 18.36-5.88 26.44 34.27 24.35 59.74 59.95 71.04 101.56h49.4c-13.68-64.68-54.17-119.48-109.54-152h79.73c9.5 23.44 32.41 40 59.25 40 35.34 0 64-28.65 64-64s-28.66-64-64-64zm0 272h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32z"]
};
var faBible = {
  prefix: 'fas',
  iconName: 'bible',
  icon: [448, 512, [], "f647", "M448 358.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16c0-6.4-3.2-12.8-9.6-19.2-3.2-16-3.2-60.8 0-73.6 6.4-3.2 9.6-9.6 9.6-19.2zM144 144c0-8.84 7.16-16 16-16h48V80c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v48h48c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16h-48v112c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16V192h-48c-8.84 0-16-7.16-16-16v-32zm236.8 304H96c-19.2 0-32-12.8-32-32s16-32 32-32h284.8v64z"]
};
var faBicycle = {
  prefix: 'fas',
  iconName: 'bicycle',
  icon: [640, 512, [], "f206", "M512.509 192.001c-16.373-.064-32.03 2.955-46.436 8.495l-77.68-125.153A24 24 0 0 0 368.001 64h-64c-8.837 0-16 7.163-16 16v16c0 8.837 7.163 16 16 16h50.649l14.896 24H256.002v-16c0-8.837-7.163-16-16-16h-87.459c-13.441 0-24.777 10.999-24.536 24.437.232 13.044 10.876 23.563 23.995 23.563h48.726l-29.417 47.52c-13.433-4.83-27.904-7.483-42.992-7.52C58.094 191.83.412 249.012.002 319.236-.413 390.279 57.055 448 128.002 448c59.642 0 109.758-40.793 123.967-96h52.033a24 24 0 0 0 20.406-11.367L410.37 201.77l14.938 24.067c-25.455 23.448-41.385 57.081-41.307 94.437.145 68.833 57.899 127.051 126.729 127.719 70.606.685 128.181-55.803 129.255-125.996 1.086-70.941-56.526-129.72-127.476-129.996zM186.75 265.772c9.727 10.529 16.673 23.661 19.642 38.228h-43.306l23.664-38.228zM128.002 400c-44.112 0-80-35.888-80-80s35.888-80 80-80c5.869 0 11.586.653 17.099 1.859l-45.505 73.509C89.715 331.327 101.213 352 120.002 352h81.3c-12.37 28.225-40.562 48-73.3 48zm162.63-96h-35.624c-3.96-31.756-19.556-59.894-42.383-80.026L237.371 184h127.547l-74.286 120zm217.057 95.886c-41.036-2.165-74.049-35.692-75.627-76.755-.812-21.121 6.633-40.518 19.335-55.263l44.433 71.586c4.66 7.508 14.524 9.816 22.032 5.156l13.594-8.437c7.508-4.66 9.817-14.524 5.156-22.032l-44.468-71.643a79.901 79.901 0 0 1 19.858-2.497c44.112 0 80 35.888 80 80-.001 45.54-38.252 82.316-84.313 79.885z"]
};
var faBiking = {
  prefix: 'fas',
  iconName: 'biking',
  icon: [640, 512, [], "f84a", "M400 96a48 48 0 1 0-48-48 48 48 0 0 0 48 48zm-4 121a31.9 31.9 0 0 0 20 7h64a32 32 0 0 0 0-64h-52.78L356 103a31.94 31.94 0 0 0-40.81.68l-112 96a32 32 0 0 0 3.08 50.92L288 305.12V416a32 32 0 0 0 64 0V288a32 32 0 0 0-14.25-26.62l-41.36-27.57 58.25-49.92zm116 39a128 128 0 1 0 128 128 128 128 0 0 0-128-128zm0 192a64 64 0 1 1 64-64 64 64 0 0 1-64 64zM128 256a128 128 0 1 0 128 128 128 128 0 0 0-128-128zm0 192a64 64 0 1 1 64-64 64 64 0 0 1-64 64z"]
};
var faBinoculars = {
  prefix: 'fas',
  iconName: 'binoculars',
  icon: [512, 512, [], "f1e5", "M416 48c0-8.84-7.16-16-16-16h-64c-8.84 0-16 7.16-16 16v48h96V48zM63.91 159.99C61.4 253.84 3.46 274.22 0 404v44c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32V288h32V128H95.84c-17.63 0-31.45 14.37-31.93 31.99zm384.18 0c-.48-17.62-14.3-31.99-31.93-31.99H320v160h32v160c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-44c-3.46-129.78-61.4-150.16-63.91-244.01zM176 32h-64c-8.84 0-16 7.16-16 16v48h96V48c0-8.84-7.16-16-16-16zm48 256h64V128h-64v160z"]
};
var faBiohazard = {
  prefix: 'fas',
  iconName: 'biohazard',
  icon: [576, 512, [], "f780", "M287.9 112c18.6 0 36.2 3.8 52.8 9.6 13.3-10.3 23.6-24.3 29.5-40.7-25.2-10.9-53-17-82.2-17-29.1 0-56.9 6-82.1 16.9 5.9 16.4 16.2 30.4 29.5 40.7 16.5-5.7 34-9.5 52.5-9.5zM163.6 438.7c12-11.8 20.4-26.4 24.5-42.4-32.9-26.4-54.8-65.3-58.9-109.6-8.5-2.8-17.2-4.6-26.4-4.6-7.6 0-15.2 1-22.5 3.1 4.1 62.8 35.8 118 83.3 153.5zm224.2-42.6c4.1 16 12.5 30.7 24.5 42.5 47.4-35.5 79.1-90.7 83-153.5-7.2-2-14.7-3-22.2-3-9.2 0-18 1.9-26.6 4.7-4.1 44.2-26 82.9-58.7 109.3zm113.5-205c-17.6-10.4-36.3-16.6-55.3-19.9 6-17.7 10-36.4 10-56.2 0-41-14.5-80.8-41-112.2-2.5-3-6.6-3.7-10-1.8-3.3 1.9-4.8 6-3.6 9.7 4.5 13.8 6.6 26.3 6.6 38.5 0 67.8-53.8 122.9-120 122.9S168 117 168 49.2c0-12.1 2.2-24.7 6.6-38.5 1.2-3.7-.3-7.8-3.6-9.7-3.4-1.9-7.5-1.2-10 1.8C134.6 34.2 120 74 120 115c0 19.8 3.9 38.5 10 56.2-18.9 3.3-37.7 9.5-55.3 19.9-34.6 20.5-61 53.3-74.3 92.4-1.3 3.7.2 7.7 3.5 9.8 3.3 2 7.5 1.3 10-1.6 9.4-10.8 19-19.1 29.2-25.1 57.3-33.9 130.8-13.7 163.9 45 33.1 58.7 13.4 134-43.9 167.9-10.2 6.1-22 10.4-35.8 13.4-3.7.8-6.4 4.2-6.4 8.1.1 4 2.7 7.3 6.5 8 39.7 7.8 80.6.8 115.2-19.7 18-10.6 32.9-24.5 45.3-40.1 12.4 15.6 27.3 29.5 45.3 40.1 34.6 20.5 75.5 27.5 115.2 19.7 3.8-.7 6.4-4 6.5-8 0-3.9-2.6-7.3-6.4-8.1-13.9-2.9-25.6-7.3-35.8-13.4-57.3-33.9-77-109.2-43.9-167.9s106.6-78.9 163.9-45c10.2 6.1 19.8 14.3 29.2 25.1 2.5 2.9 6.7 3.6 10 1.6s4.8-6.1 3.5-9.8c-13.1-39.1-39.5-72-74.1-92.4zm-213.4 129c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"]
};
var faBirthdayCake = {
  prefix: 'fas',
  iconName: 'birthday-cake',
  icon: [448, 512, [], "f1fd", "M448 384c-28.02 0-31.26-32-74.5-32-43.43 0-46.825 32-74.75 32-27.695 0-31.454-32-74.75-32-42.842 0-47.218 32-74.5 32-28.148 0-31.202-32-74.75-32-43.547 0-46.653 32-74.75 32v-80c0-26.5 21.5-48 48-48h16V112h64v144h64V112h64v144h64V112h64v144h16c26.5 0 48 21.5 48 48v80zm0 128H0v-96c43.356 0 46.767-32 74.75-32 27.951 0 31.253 32 74.75 32 42.843 0 47.217-32 74.5-32 28.148 0 31.201 32 74.75 32 43.357 0 46.767-32 74.75-32 27.488 0 31.252 32 74.5 32v96zM96 96c-17.75 0-32-14.25-32-32 0-31 32-23 32-64 12 0 32 29.5 32 56s-14.25 40-32 40zm128 0c-17.75 0-32-14.25-32-32 0-31 32-23 32-64 12 0 32 29.5 32 56s-14.25 40-32 40zm128 0c-17.75 0-32-14.25-32-32 0-31 32-23 32-64 12 0 32 29.5 32 56s-14.25 40-32 40z"]
};
var faBlender = {
  prefix: 'fas',
  iconName: 'blender',
  icon: [512, 512, [], "f517", "M416 384H160c-35.35 0-64 28.65-64 64v32c0 17.67 14.33 32 32 32h320c17.67 0 32-14.33 32-32v-32c0-35.35-28.65-64-64-64zm-128 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm40-416h166.54L512 0H48C21.49 0 0 21.49 0 48v160c0 26.51 21.49 48 48 48h103.27l8.73 96h256l17.46-64H328c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h114.18l17.46-64H328c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h140.36l17.46-64H328c-4.42 0-8-3.58-8-8V72c0-4.42 3.58-8 8-8zM64 192V64h69.82l11.64 128H64z"]
};
var faBlenderPhone = {
  prefix: 'fas',
  iconName: 'blender-phone',
  icon: [576, 512, [], "f6b6", "M392 64h166.54L576 0H192v352h288l17.46-64H392c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h114.18l17.46-64H392c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h140.36l17.46-64H392c-4.42 0-8-3.58-8-8V72c0-4.42 3.58-8 8-8zM158.8 335.01l-25.78-63.26c-2.78-6.81-9.8-10.99-17.24-10.26l-45.03 4.42c-17.28-46.94-17.65-99.78 0-147.72l45.03 4.42c7.43.73 14.46-3.46 17.24-10.26l25.78-63.26c3.02-7.39.2-15.85-6.68-20.07l-39.28-24.1C98.51-3.87 80.09-.5 68.95 11.97c-92.57 103.6-92 259.55 2.1 362.49 9.87 10.8 29.12 12.48 41.65 4.8l39.41-24.18c6.89-4.22 9.7-12.67 6.69-20.07zM480 384H192c-35.35 0-64 28.65-64 64v32c0 17.67 14.33 32 32 32h352c17.67 0 32-14.33 32-32v-32c0-35.35-28.65-64-64-64zm-144 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"]
};
var faBlind = {
  prefix: 'fas',
  iconName: 'blind',
  icon: [384, 512, [], "f29d", "M380.15 510.837a8 8 0 0 1-10.989-2.687l-125.33-206.427a31.923 31.923 0 0 0 12.958-9.485l126.048 207.608a8 8 0 0 1-2.687 10.991zM142.803 314.338l-32.54 89.485 36.12 88.285c6.693 16.36 25.377 24.192 41.733 17.501 16.357-6.692 24.193-25.376 17.501-41.734l-62.814-153.537zM96 88c24.301 0 44-19.699 44-44S120.301 0 96 0 52 19.699 52 44s19.699 44 44 44zm154.837 169.128l-120-152c-4.733-5.995-11.75-9.108-18.837-9.112V96H80v.026c-7.146.003-14.217 3.161-18.944 9.24L0 183.766v95.694c0 13.455 11.011 24.791 24.464 24.536C37.505 303.748 48 293.1 48 280v-79.766l16-20.571v140.698L9.927 469.055c-6.04 16.609 2.528 34.969 19.138 41.009 16.602 6.039 34.968-2.524 41.009-19.138L136 309.638V202.441l-31.406-39.816a4 4 0 1 1 6.269-4.971l102.3 129.217c9.145 11.584 24.368 11.339 33.708 3.965 10.41-8.216 12.159-23.334 3.966-33.708z"]
};
var faBlog = {
  prefix: 'fas',
  iconName: 'blog',
  icon: [512, 512, [], "f781", "M172.2 226.8c-14.6-2.9-28.2 8.9-28.2 23.8V301c0 10.2 7.1 18.4 16.7 22 18.2 6.8 31.3 24.4 31.3 45 0 26.5-21.5 48-48 48s-48-21.5-48-48V120c0-13.3-10.7-24-24-24H24c-13.3 0-24 10.7-24 24v248c0 89.5 82.1 160.2 175 140.7 54.4-11.4 98.3-55.4 109.7-109.7 17.4-82.9-37-157.2-112.5-172.2zM209 0c-9.2-.5-17 6.8-17 16v31.6c0 8.5 6.6 15.5 15 15.9 129.4 7 233.4 112 240.9 241.5.5 8.4 7.5 15 15.9 15h32.1c9.2 0 16.5-7.8 16-17C503.4 139.8 372.2 8.6 209 0zm.3 96c-9.3-.7-17.3 6.7-17.3 16.1v32.1c0 8.4 6.5 15.3 14.8 15.9 76.8 6.3 138 68.2 144.9 145.2.8 8.3 7.6 14.7 15.9 14.7h32.2c9.3 0 16.8-8 16.1-17.3-8.4-110.1-96.5-198.2-206.6-206.7z"]
};
var faBold = {
  prefix: 'fas',
  iconName: 'bold',
  icon: [384, 512, [], "f032", "M333.49 238a122 122 0 0 0 27-65.21C367.87 96.49 308 32 233.42 32H34a16 16 0 0 0-16 16v48a16 16 0 0 0 16 16h31.87v288H34a16 16 0 0 0-16 16v48a16 16 0 0 0 16 16h209.32c70.8 0 134.14-51.75 141-122.4 4.74-48.45-16.39-92.06-50.83-119.6zM145.66 112h87.76a48 48 0 0 1 0 96h-87.76zm87.76 288h-87.76V288h87.76a56 56 0 0 1 0 112z"]
};
var faBolt = {
  prefix: 'fas',
  iconName: 'bolt',
  icon: [320, 512, [], "f0e7", "M296 160H180.6l42.6-129.8C227.2 15 215.7 0 200 0H56C44 0 33.8 8.9 32.2 20.8l-32 240C-1.7 275.2 9.5 288 24 288h118.7L96.6 482.5c-3.6 15.2 8 29.5 23.3 29.5 8.4 0 16.4-4.4 20.8-12l176-304c9.3-15.9-2.2-36-20.7-36z"]
};
var faBomb = {
  prefix: 'fas',
  iconName: 'bomb',
  icon: [512, 512, [], "f1e2", "M440.5 88.5l-52 52L415 167c9.4 9.4 9.4 24.6 0 33.9l-17.4 17.4c11.8 26.1 18.4 55.1 18.4 85.6 0 114.9-93.1 208-208 208S0 418.9 0 304 93.1 96 208 96c30.5 0 59.5 6.6 85.6 18.4L311 97c9.4-9.4 24.6-9.4 33.9 0l26.5 26.5 52-52 17.1 17zM500 60h-24c-6.6 0-12 5.4-12 12s5.4 12 12 12h24c6.6 0 12-5.4 12-12s-5.4-12-12-12zM440 0c-6.6 0-12 5.4-12 12v24c0 6.6 5.4 12 12 12s12-5.4 12-12V12c0-6.6-5.4-12-12-12zm33.9 55l17-17c4.7-4.7 4.7-12.3 0-17-4.7-4.7-12.3-4.7-17 0l-17 17c-4.7 4.7-4.7 12.3 0 17 4.8 4.7 12.4 4.7 17 0zm-67.8 0c4.7 4.7 12.3 4.7 17 0 4.7-4.7 4.7-12.3 0-17l-17-17c-4.7-4.7-12.3-4.7-17 0-4.7 4.7-4.7 12.3 0 17l17 17zm67.8 34c-4.7-4.7-12.3-4.7-17 0-4.7 4.7-4.7 12.3 0 17l17 17c4.7 4.7 12.3 4.7 17 0 4.7-4.7 4.7-12.3 0-17l-17-17zM112 272c0-35.3 28.7-64 64-64 8.8 0 16-7.2 16-16s-7.2-16-16-16c-52.9 0-96 43.1-96 96 0 8.8 7.2 16 16 16s16-7.2 16-16z"]
};
var faBone = {
  prefix: 'fas',
  iconName: 'bone',
  icon: [640, 512, [], "f5d7", "M598.88 244.56c25.2-12.6 41.12-38.36 41.12-66.53v-7.64C640 129.3 606.7 96 565.61 96c-32.02 0-60.44 20.49-70.57 50.86-7.68 23.03-11.6 45.14-38.11 45.14H183.06c-27.38 0-31.58-25.54-38.11-45.14C134.83 116.49 106.4 96 74.39 96 33.3 96 0 129.3 0 170.39v7.64c0 28.17 15.92 53.93 41.12 66.53 9.43 4.71 9.43 18.17 0 22.88C15.92 280.04 0 305.8 0 333.97v7.64C0 382.7 33.3 416 74.38 416c32.02 0 60.44-20.49 70.57-50.86 7.68-23.03 11.6-45.14 38.11-45.14h273.87c27.38 0 31.58 25.54 38.11 45.14C505.17 395.51 533.6 416 565.61 416c41.08 0 74.38-33.3 74.38-74.39v-7.64c0-28.18-15.92-53.93-41.12-66.53-9.42-4.71-9.42-18.17.01-22.88z"]
};
var faBong = {
  prefix: 'fas',
  iconName: 'bong',
  icon: [448, 512, [], "f55c", "M302.5 512c23.18 0 44.43-12.58 56-32.66C374.69 451.26 384 418.75 384 384c0-36.12-10.08-69.81-27.44-98.62L400 241.94l9.38 9.38c6.25 6.25 16.38 6.25 22.63 0l11.3-11.32c6.25-6.25 6.25-16.38 0-22.63l-52.69-52.69c-6.25-6.25-16.38-6.25-22.63 0l-11.31 11.31c-6.25 6.25-6.25 16.38 0 22.63l9.38 9.38-39.41 39.41c-11.56-11.37-24.53-21.33-38.65-29.51V63.74l15.97-.02c8.82-.01 15.97-7.16 15.98-15.98l.04-31.72C320 7.17 312.82-.01 303.97 0L80.03.26c-8.82.01-15.97 7.16-15.98 15.98l-.04 31.73c-.01 8.85 7.17 16.02 16.02 16.01L96 63.96v153.93C38.67 251.1 0 312.97 0 384c0 34.75 9.31 67.27 25.5 95.34C37.08 499.42 58.33 512 81.5 512h221zM120.06 259.43L144 245.56V63.91l96-.11v181.76l23.94 13.87c24.81 14.37 44.12 35.73 56.56 60.57h-257c12.45-24.84 31.75-46.2 56.56-60.57z"]
};
var faBook = {
  prefix: 'fas',
  iconName: 'book',
  icon: [448, 512, [], "f02d", "M448 360V24c0-13.3-10.7-24-24-24H96C43 0 0 43 0 96v320c0 53 43 96 96 96h328c13.3 0 24-10.7 24-24v-16c0-7.5-3.5-14.3-8.9-18.7-4.2-15.4-4.2-59.3 0-74.7 5.4-4.3 8.9-11.1 8.9-18.6zM128 134c0-3.3 2.7-6 6-6h212c3.3 0 6 2.7 6 6v20c0 3.3-2.7 6-6 6H134c-3.3 0-6-2.7-6-6v-20zm0 64c0-3.3 2.7-6 6-6h212c3.3 0 6 2.7 6 6v20c0 3.3-2.7 6-6 6H134c-3.3 0-6-2.7-6-6v-20zm253.4 250H96c-17.7 0-32-14.3-32-32 0-17.6 14.4-32 32-32h285.4c-1.9 17.1-1.9 46.9 0 64z"]
};
var faBookDead = {
  prefix: 'fas',
  iconName: 'book-dead',
  icon: [448, 512, [], "f6b7", "M272 136c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zm176 222.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16c0-6.4-3.2-12.8-9.6-19.2-3.2-16-3.2-60.8 0-73.6 6.4-3.2 9.6-9.6 9.6-19.2zM240 56c44.2 0 80 28.7 80 64 0 20.9-12.7 39.2-32 50.9V184c0 8.8-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16v-13.1c-19.3-11.7-32-30-32-50.9 0-35.3 35.8-64 80-64zM124.8 223.3l6.3-14.7c1.7-4.1 6.4-5.9 10.5-4.2l98.3 42.1 98.4-42.1c4.1-1.7 8.8.1 10.5 4.2l6.3 14.7c1.7 4.1-.1 8.8-4.2 10.5L280.6 264l70.3 30.1c4.1 1.7 5.9 6.4 4.2 10.5l-6.3 14.7c-1.7 4.1-6.4 5.9-10.5 4.2L240 281.4l-98.3 42.2c-4.1 1.7-8.8-.1-10.5-4.2l-6.3-14.7c-1.7-4.1.1-8.8 4.2-10.5l70.4-30.1-70.5-30.3c-4.1-1.7-5.9-6.4-4.2-10.5zm256 224.7H96c-19.2 0-32-12.8-32-32s16-32 32-32h284.8zM208 136c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16z"]
};
var faBookMedical = {
  prefix: 'fas',
  iconName: 'book-medical',
  icon: [448, 512, [], "f7e6", "M448 358.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16q0-9.6-9.6-19.2c-3.2-16-3.2-60.8 0-73.6q9.6-4.8 9.6-19.2zM144 168a8 8 0 0 1 8-8h56v-56a8 8 0 0 1 8-8h48a8 8 0 0 1 8 8v56h56a8 8 0 0 1 8 8v48a8 8 0 0 1-8 8h-56v56a8 8 0 0 1-8 8h-48a8 8 0 0 1-8-8v-56h-56a8 8 0 0 1-8-8zm236.8 280H96c-19.2 0-32-12.8-32-32s16-32 32-32h284.8z"]
};
var faBookOpen = {
  prefix: 'fas',
  iconName: 'book-open',
  icon: [576, 512, [], "f518", "M542.22 32.05c-54.8 3.11-163.72 14.43-230.96 55.59-4.64 2.84-7.27 7.89-7.27 13.17v363.87c0 11.55 12.63 18.85 23.28 13.49 69.18-34.82 169.23-44.32 218.7-46.92 16.89-.89 30.02-14.43 30.02-30.66V62.75c.01-17.71-15.35-31.74-33.77-30.7zM264.73 87.64C197.5 46.48 88.58 35.17 33.78 32.05 15.36 31.01 0 45.04 0 62.75V400.6c0 16.24 13.13 29.78 30.02 30.66 49.49 2.6 149.59 12.11 218.77 46.95 10.62 5.35 23.21-1.94 23.21-13.46V100.63c0-5.29-2.62-10.14-7.27-12.99z"]
};
var faBookReader = {
  prefix: 'fas',
  iconName: 'book-reader',
  icon: [512, 512, [], "f5da", "M352 96c0-53.02-42.98-96-96-96s-96 42.98-96 96 42.98 96 96 96 96-42.98 96-96zM233.59 241.1c-59.33-36.32-155.43-46.3-203.79-49.05C13.55 191.13 0 203.51 0 219.14v222.8c0 14.33 11.59 26.28 26.49 27.05 43.66 2.29 131.99 10.68 193.04 41.43 9.37 4.72 20.48-1.71 20.48-11.87V252.56c-.01-4.67-2.32-8.95-6.42-11.46zm248.61-49.05c-48.35 2.74-144.46 12.73-203.78 49.05-4.1 2.51-6.41 6.96-6.41 11.63v245.79c0 10.19 11.14 16.63 20.54 11.9 61.04-30.72 149.32-39.11 192.97-41.4 14.9-.78 26.49-12.73 26.49-27.06V219.14c-.01-15.63-13.56-28.01-29.81-27.09z"]
};
var faBookmark = {
  prefix: 'fas',
  iconName: 'bookmark',
  icon: [384, 512, [], "f02e", "M0 512V48C0 21.49 21.49 0 48 0h288c26.51 0 48 21.49 48 48v464L192 400 0 512z"]
};
var faBorderAll = {
  prefix: 'fas',
  iconName: 'border-all',
  icon: [448, 512, [], "f84c", "M416 32H32A32 32 0 0 0 0 64v384a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32V64a32 32 0 0 0-32-32zm-32 64v128H256V96zm-192 0v128H64V96zM64 416V288h128v128zm192 0V288h128v128z"]
};
var faBorderNone = {
  prefix: 'fas',
  iconName: 'border-none',
  icon: [448, 512, [], "f850", "M240 224h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-288 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 192h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-96h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-192h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM240 320h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-192h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-96 288h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96-384h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM48 224H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 192H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-96H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-192H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-96H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"]
};
var faBorderStyle = {
  prefix: 'fas',
  iconName: 'border-style',
  icon: [448, 512, [], "f853", "M240 416h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm192 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96-192h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 96h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 96h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-288h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-96H32A32 32 0 0 0 0 64v400a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V96h368a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"]
};
var faBowlingBall = {
  prefix: 'fas',
  iconName: 'bowling-ball',
  icon: [496, 512, [], "f436", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM120 192c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm64-96c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm48 144c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"]
};
var faBox = {
  prefix: 'fas',
  iconName: 'box',
  icon: [512, 512, [], "f466", "M509.5 184.6L458.9 32.8C452.4 13.2 434.1 0 413.4 0H272v192h238.7c-.4-2.5-.4-5-1.2-7.4zM240 0H98.6c-20.7 0-39 13.2-45.5 32.8L2.5 184.6c-.8 2.4-.8 4.9-1.2 7.4H240V0zM0 224v240c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V224H0z"]
};
var faBoxOpen = {
  prefix: 'fas',
  iconName: 'box-open',
  icon: [640, 512, [], "f49e", "M425.7 256c-16.9 0-32.8-9-41.4-23.4L320 126l-64.2 106.6c-8.7 14.5-24.6 23.5-41.5 23.5-4.5 0-9-.6-13.3-1.9L64 215v178c0 14.7 10 27.5 24.2 31l216.2 54.1c10.2 2.5 20.9 2.5 31 0L551.8 424c14.2-3.6 24.2-16.4 24.2-31V215l-137 39.1c-4.3 1.3-8.8 1.9-13.3 1.9zm212.6-112.2L586.8 41c-3.1-6.2-9.8-9.8-16.7-8.9L320 64l91.7 152.1c3.8 6.3 11.4 9.3 18.5 7.3l197.9-56.5c9.9-2.9 14.7-13.9 10.2-23.1zM53.2 41L1.7 143.8c-4.6 9.2.3 20.2 10.1 23l197.9 56.5c7.1 2 14.7-1 18.5-7.3L320 64 69.8 32.1c-6.9-.8-13.5 2.7-16.6 8.9z"]
};
var faBoxTissue = {
  prefix: 'fas',
  iconName: 'box-tissue',
  icon: [512, 512, [], "e05b", "M383.88,287.82l64-192H338.47a70.2,70.2,0,0,1-66.59-48,70.21,70.21,0,0,0-66.6-48H63.88l64,288Zm-384,192a32,32,0,0,0,32,32h448a32,32,0,0,0,32-32v-64H-.12Zm480-256H438.94l-21.33,64h14.27a16,16,0,0,1,0,32h-352a16,16,0,1,1,0-32H95.09l-14.22-64h-49a32,32,0,0,0-32,32v128h512v-128A32,32,0,0,0,479.88,223.82Z"]
};
var faBoxes = {
  prefix: 'fas',
  iconName: 'boxes',
  icon: [576, 512, [], "f468", "M560 288h-80v96l-32-21.3-32 21.3v-96h-80c-8.8 0-16 7.2-16 16v192c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16zm-384-64h224c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16h-80v96l-32-21.3L256 96V0h-80c-8.8 0-16 7.2-16 16v192c0 8.8 7.2 16 16 16zm64 64h-80v96l-32-21.3L96 384v-96H16c-8.8 0-16 7.2-16 16v192c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16z"]
};
var faBraille = {
  prefix: 'fas',
  iconName: 'braille',
  icon: [640, 512, [], "f2a1", "M128 256c0 35.346-28.654 64-64 64S0 291.346 0 256s28.654-64 64-64 64 28.654 64 64zM64 384c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0-352C28.654 32 0 60.654 0 96s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64zm160 192c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0 160c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0-352c-35.346 0-64 28.654-64 64s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64zm224 192c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0 160c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0-352c-35.346 0-64 28.654-64 64s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64zm160 192c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0 160c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0-320c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32z"]
};
var faBrain = {
  prefix: 'fas',
  iconName: 'brain',
  icon: [576, 512, [], "f5dc", "M208 0c-29.9 0-54.7 20.5-61.8 48.2-.8 0-1.4-.2-2.2-.2-35.3 0-64 28.7-64 64 0 4.8.6 9.5 1.7 14C52.5 138 32 166.6 32 200c0 12.6 3.2 24.3 8.3 34.9C16.3 248.7 0 274.3 0 304c0 33.3 20.4 61.9 49.4 73.9-.9 4.6-1.4 9.3-1.4 14.1 0 39.8 32.2 72 72 72 4.1 0 8.1-.5 12-1.2 9.6 28.5 36.2 49.2 68 49.2 39.8 0 72-32.2 72-72V64c0-35.3-28.7-64-64-64zm368 304c0-29.7-16.3-55.3-40.3-69.1 5.2-10.6 8.3-22.3 8.3-34.9 0-33.4-20.5-62-49.7-74 1-4.5 1.7-9.2 1.7-14 0-35.3-28.7-64-64-64-.8 0-1.5.2-2.2.2C422.7 20.5 397.9 0 368 0c-35.3 0-64 28.6-64 64v376c0 39.8 32.2 72 72 72 31.8 0 58.4-20.7 68-49.2 3.9.7 7.9 1.2 12 1.2 39.8 0 72-32.2 72-72 0-4.8-.5-9.5-1.4-14.1 29-12 49.4-40.6 49.4-73.9z"]
};
var faBreadSlice = {
  prefix: 'fas',
  iconName: 'bread-slice',
  icon: [576, 512, [], "f7ec", "M288 0C108 0 0 93.4 0 169.14 0 199.44 24.24 224 64 224v256c0 17.67 16.12 32 36 32h376c19.88 0 36-14.33 36-32V224c39.76 0 64-24.56 64-54.86C576 93.4 468 0 288 0z"]
};
var faBriefcase = {
  prefix: 'fas',
  iconName: 'briefcase',
  icon: [512, 512, [], "f0b1", "M320 336c0 8.84-7.16 16-16 16h-96c-8.84 0-16-7.16-16-16v-48H0v144c0 25.6 22.4 48 48 48h416c25.6 0 48-22.4 48-48V288H320v48zm144-208h-80V80c0-25.6-22.4-48-48-48H176c-25.6 0-48 22.4-48 48v48H48c-25.6 0-48 22.4-48 48v80h512v-80c0-25.6-22.4-48-48-48zm-144 0H192V96h128v32z"]
};
var faBriefcaseMedical = {
  prefix: 'fas',
  iconName: 'briefcase-medical',
  icon: [512, 512, [], "f469", "M464 128h-80V80c0-26.5-21.5-48-48-48H176c-26.5 0-48 21.5-48 48v48H48c-26.5 0-48 21.5-48 48v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48zM192 96h128v32H192V96zm160 248c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48z"]
};
var faBroadcastTower = {
  prefix: 'fas',
  iconName: 'broadcast-tower',
  icon: [640, 512, [], "f519", "M150.94 192h33.73c11.01 0 18.61-10.83 14.86-21.18-4.93-13.58-7.55-27.98-7.55-42.82s2.62-29.24 7.55-42.82C203.29 74.83 195.68 64 184.67 64h-33.73c-7.01 0-13.46 4.49-15.41 11.23C130.64 92.21 128 109.88 128 128c0 18.12 2.64 35.79 7.54 52.76 1.94 6.74 8.39 11.24 15.4 11.24zM89.92 23.34C95.56 12.72 87.97 0 75.96 0H40.63c-6.27 0-12.14 3.59-14.74 9.31C9.4 45.54 0 85.65 0 128c0 24.75 3.12 68.33 26.69 118.86 2.62 5.63 8.42 9.14 14.61 9.14h34.84c12.02 0 19.61-12.74 13.95-23.37-49.78-93.32-16.71-178.15-.17-209.29zM614.06 9.29C611.46 3.58 605.6 0 599.33 0h-35.42c-11.98 0-19.66 12.66-14.02 23.25 18.27 34.29 48.42 119.42.28 209.23-5.72 10.68 1.8 23.52 13.91 23.52h35.23c6.27 0 12.13-3.58 14.73-9.29C630.57 210.48 640 170.36 640 128s-9.42-82.48-25.94-118.71zM489.06 64h-33.73c-11.01 0-18.61 10.83-14.86 21.18 4.93 13.58 7.55 27.98 7.55 42.82s-2.62 29.24-7.55 42.82c-3.76 10.35 3.85 21.18 14.86 21.18h33.73c7.02 0 13.46-4.49 15.41-11.24 4.9-16.97 7.53-34.64 7.53-52.76 0-18.12-2.64-35.79-7.54-52.76-1.94-6.75-8.39-11.24-15.4-11.24zm-116.3 100.12c7.05-10.29 11.2-22.71 11.2-36.12 0-35.35-28.63-64-63.96-64-35.32 0-63.96 28.65-63.96 64 0 13.41 4.15 25.83 11.2 36.12l-130.5 313.41c-3.4 8.15.46 17.52 8.61 20.92l29.51 12.31c8.15 3.4 17.52-.46 20.91-8.61L244.96 384h150.07l49.2 118.15c3.4 8.16 12.76 12.01 20.91 8.61l29.51-12.31c8.15-3.4 12-12.77 8.61-20.92l-130.5-313.41zM271.62 320L320 203.81 368.38 320h-96.76z"]
};
var faBroom = {
  prefix: 'fas',
  iconName: 'broom',
  icon: [640, 512, [], "f51a", "M256.47 216.77l86.73 109.18s-16.6 102.36-76.57 150.12C206.66 523.85 0 510.19 0 510.19s3.8-23.14 11-55.43l94.62-112.17c3.97-4.7-.87-11.62-6.65-9.5l-60.4 22.09c14.44-41.66 32.72-80.04 54.6-97.47 59.97-47.76 163.3-40.94 163.3-40.94zM636.53 31.03l-19.86-25c-5.49-6.9-15.52-8.05-22.41-2.56l-232.48 177.8-34.14-42.97c-5.09-6.41-15.14-5.21-18.59 2.21l-25.33 54.55 86.73 109.18 58.8-12.45c8-1.69 11.42-11.2 6.34-17.6l-34.09-42.92 232.48-177.8c6.89-5.48 8.04-15.53 2.55-22.44z"]
};
var faBrush = {
  prefix: 'fas',
  iconName: 'brush',
  icon: [384, 512, [], "f55d", "M352 0H32C14.33 0 0 14.33 0 32v224h384V32c0-17.67-14.33-32-32-32zM0 320c0 35.35 28.66 64 64 64h64v64c0 35.35 28.66 64 64 64s64-28.65 64-64v-64h64c35.34 0 64-28.65 64-64v-32H0v32zm192 104c13.25 0 24 10.74 24 24 0 13.25-10.75 24-24 24s-24-10.75-24-24c0-13.26 10.75-24 24-24z"]
};
var faBug = {
  prefix: 'fas',
  iconName: 'bug',
  icon: [512, 512, [], "f188", "M511.988 288.9c-.478 17.43-15.217 31.1-32.653 31.1H424v16c0 21.864-4.882 42.584-13.6 61.145l60.228 60.228c12.496 12.497 12.496 32.758 0 45.255-12.498 12.497-32.759 12.496-45.256 0l-54.736-54.736C345.886 467.965 314.351 480 280 480V236c0-6.627-5.373-12-12-12h-24c-6.627 0-12 5.373-12 12v244c-34.351 0-65.886-12.035-90.636-32.108l-54.736 54.736c-12.498 12.497-32.759 12.496-45.256 0-12.496-12.497-12.496-32.758 0-45.255l60.228-60.228C92.882 378.584 88 357.864 88 336v-16H32.666C15.23 320 .491 306.33.013 288.9-.484 270.816 14.028 256 32 256h56v-58.745l-46.628-46.628c-12.496-12.497-12.496-32.758 0-45.255 12.498-12.497 32.758-12.497 45.256 0L141.255 160h229.489l54.627-54.627c12.498-12.497 32.758-12.497 45.256 0 12.496 12.497 12.496 32.758 0 45.255L424 197.255V256h56c17.972 0 32.484 14.816 31.988 32.9zM257 0c-61.856 0-112 50.144-112 112h224C369 50.144 318.856 0 257 0z"]
};
var faBuilding = {
  prefix: 'fas',
  iconName: 'building',
  icon: [448, 512, [], "f1ad", "M436 480h-20V24c0-13.255-10.745-24-24-24H56C42.745 0 32 10.745 32 24v456H12c-6.627 0-12 5.373-12 12v20h448v-20c0-6.627-5.373-12-12-12zM128 76c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12V76zm0 96c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40zm52 148h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12zm76 160h-64v-84c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v84zm64-172c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40zm0-96c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40zm0-96c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12V76c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40z"]
};
var faBullhorn = {
  prefix: 'fas',
  iconName: 'bullhorn',
  icon: [576, 512, [], "f0a1", "M576 240c0-23.63-12.95-44.04-32-55.12V32.01C544 23.26 537.02 0 512 0c-7.12 0-14.19 2.38-19.98 7.02l-85.03 68.03C364.28 109.19 310.66 128 256 128H64c-35.35 0-64 28.65-64 64v96c0 35.35 28.65 64 64 64h33.7c-1.39 10.48-2.18 21.14-2.18 32 0 39.77 9.26 77.35 25.56 110.94 5.19 10.69 16.52 17.06 28.4 17.06h74.28c26.05 0 41.69-29.84 25.9-50.56-16.4-21.52-26.15-48.36-26.15-77.44 0-11.11 1.62-21.79 4.41-32H256c54.66 0 108.28 18.81 150.98 52.95l85.03 68.03a32.023 32.023 0 0 0 19.98 7.02c24.92 0 32-22.78 32-32V295.13C563.05 284.04 576 263.63 576 240zm-96 141.42l-33.05-26.44C392.95 311.78 325.12 288 256 288v-96c69.12 0 136.95-23.78 190.95-66.98L480 98.58v282.84z"]
};
var faBullseye = {
  prefix: 'fas',
  iconName: 'bullseye',
  icon: [496, 512, [], "f140", "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 432c-101.69 0-184-82.29-184-184 0-101.69 82.29-184 184-184 101.69 0 184 82.29 184 184 0 101.69-82.29 184-184 184zm0-312c-70.69 0-128 57.31-128 128s57.31 128 128 128 128-57.31 128-128-57.31-128-128-128zm0 192c-35.29 0-64-28.71-64-64s28.71-64 64-64 64 28.71 64 64-28.71 64-64 64z"]
};
var faBurn = {
  prefix: 'fas',
  iconName: 'burn',
  icon: [384, 512, [], "f46a", "M192 0C79.7 101.3 0 220.9 0 300.5 0 425 79 512 192 512s192-87 192-211.5c0-79.9-80.2-199.6-192-300.5zm0 448c-56.5 0-96-39-96-94.8 0-13.5 4.6-61.5 96-161.2 91.4 99.7 96 147.7 96 161.2 0 55.8-39.5 94.8-96 94.8z"]
};
var faBus = {
  prefix: 'fas',
  iconName: 'bus',
  icon: [512, 512, [], "f207", "M488 128h-8V80c0-44.8-99.2-80-224-80S32 35.2 32 80v48h-8c-13.25 0-24 10.74-24 24v80c0 13.25 10.75 24 24 24h8v160c0 17.67 14.33 32 32 32v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h192v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h6.4c16 0 25.6-12.8 25.6-25.6V256h8c13.25 0 24-10.75 24-24v-80c0-13.26-10.75-24-24-24zM112 400c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm16-112c-17.67 0-32-14.33-32-32V128c0-17.67 14.33-32 32-32h256c17.67 0 32 14.33 32 32v128c0 17.67-14.33 32-32 32H128zm272 112c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"]
};
var faBusAlt = {
  prefix: 'fas',
  iconName: 'bus-alt',
  icon: [512, 512, [], "f55e", "M488 128h-8V80c0-44.8-99.2-80-224-80S32 35.2 32 80v48h-8c-13.25 0-24 10.74-24 24v80c0 13.25 10.75 24 24 24h8v160c0 17.67 14.33 32 32 32v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h192v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h6.4c16 0 25.6-12.8 25.6-25.6V256h8c13.25 0 24-10.75 24-24v-80c0-13.26-10.75-24-24-24zM160 72c0-4.42 3.58-8 8-8h176c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H168c-4.42 0-8-3.58-8-8V72zm-48 328c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm128-112H128c-17.67 0-32-14.33-32-32v-96c0-17.67 14.33-32 32-32h112v160zm32 0V128h112c17.67 0 32 14.33 32 32v96c0 17.67-14.33 32-32 32H272zm128 112c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"]
};
var faBusinessTime = {
  prefix: 'fas',
  iconName: 'business-time',
  icon: [640, 512, [], "f64a", "M496 224c-79.59 0-144 64.41-144 144s64.41 144 144 144 144-64.41 144-144-64.41-144-144-144zm64 150.29c0 5.34-4.37 9.71-9.71 9.71h-60.57c-5.34 0-9.71-4.37-9.71-9.71v-76.57c0-5.34 4.37-9.71 9.71-9.71h12.57c5.34 0 9.71 4.37 9.71 9.71V352h38.29c5.34 0 9.71 4.37 9.71 9.71v12.58zM496 192c5.4 0 10.72.33 16 .81V144c0-25.6-22.4-48-48-48h-80V48c0-25.6-22.4-48-48-48H176c-25.6 0-48 22.4-48 48v48H48c-25.6 0-48 22.4-48 48v80h395.12c28.6-20.09 63.35-32 100.88-32zM320 96H192V64h128v32zm6.82 224H208c-8.84 0-16-7.16-16-16v-48H0v144c0 25.6 22.4 48 48 48h291.43C327.1 423.96 320 396.82 320 368c0-16.66 2.48-32.72 6.82-48z"]
};
var faCalculator = {
  prefix: 'fas',
  iconName: 'calculator',
  icon: [448, 512, [], "f1ec", "M400 0H48C22.4 0 0 22.4 0 48v416c0 25.6 22.4 48 48 48h352c25.6 0 48-22.4 48-48V48c0-25.6-22.4-48-48-48zM128 435.2c0 6.4-6.4 12.8-12.8 12.8H76.8c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm0-128c0 6.4-6.4 12.8-12.8 12.8H76.8c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm128 128c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm0-128c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm128 128c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8V268.8c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v166.4zm0-256c0 6.4-6.4 12.8-12.8 12.8H76.8c-6.4 0-12.8-6.4-12.8-12.8V76.8C64 70.4 70.4 64 76.8 64h294.4c6.4 0 12.8 6.4 12.8 12.8v102.4z"]
};
var faCalendar = {
  prefix: 'fas',
  iconName: 'calendar',
  icon: [448, 512, [], "f133", "M12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm436-44v-36c0-26.5-21.5-48-48-48h-48V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H160V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H48C21.5 64 0 85.5 0 112v36c0 6.6 5.4 12 12 12h424c6.6 0 12-5.4 12-12z"]
};
var faCalendarAlt = {
  prefix: 'fas',
  iconName: 'calendar-alt',
  icon: [448, 512, [], "f073", "M0 464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V192H0v272zm320-196c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zM192 268c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zM64 268c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zM400 64h-48V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H160V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48z"]
};
var faCalendarCheck = {
  prefix: 'fas',
  iconName: 'calendar-check',
  icon: [448, 512, [], "f274", "M436 160H12c-6.627 0-12-5.373-12-12v-36c0-26.51 21.49-48 48-48h48V12c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v52h128V12c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v52h48c26.51 0 48 21.49 48 48v36c0 6.627-5.373 12-12 12zM12 192h424c6.627 0 12 5.373 12 12v260c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V204c0-6.627 5.373-12 12-12zm333.296 95.947l-28.169-28.398c-4.667-4.705-12.265-4.736-16.97-.068L194.12 364.665l-45.98-46.352c-4.667-4.705-12.266-4.736-16.971-.068l-28.397 28.17c-4.705 4.667-4.736 12.265-.068 16.97l82.601 83.269c4.667 4.705 12.265 4.736 16.97.068l142.953-141.805c4.705-4.667 4.736-12.265.068-16.97z"]
};
var faCalendarDay = {
  prefix: 'fas',
  iconName: 'calendar-day',
  icon: [448, 512, [], "f783", "M0 464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V192H0v272zm64-192c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-96zM400 64h-48V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H160V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48z"]
};
var faCalendarMinus = {
  prefix: 'fas',
  iconName: 'calendar-minus',
  icon: [448, 512, [], "f272", "M436 160H12c-6.6 0-12-5.4-12-12v-36c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48v36c0 6.6-5.4 12-12 12zM12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm304 192c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12H132c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h184z"]
};
var faCalendarPlus = {
  prefix: 'fas',
  iconName: 'calendar-plus',
  icon: [448, 512, [], "f271", "M436 160H12c-6.6 0-12-5.4-12-12v-36c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48v36c0 6.6-5.4 12-12 12zM12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm316 140c0-6.6-5.4-12-12-12h-60v-60c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v60h-60c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h60v60c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-60h60c6.6 0 12-5.4 12-12v-40z"]
};
var faCalendarTimes = {
  prefix: 'fas',
  iconName: 'calendar-times',
  icon: [448, 512, [], "f273", "M436 160H12c-6.6 0-12-5.4-12-12v-36c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48v36c0 6.6-5.4 12-12 12zM12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm257.3 160l48.1-48.1c4.7-4.7 4.7-12.3 0-17l-28.3-28.3c-4.7-4.7-12.3-4.7-17 0L224 306.7l-48.1-48.1c-4.7-4.7-12.3-4.7-17 0l-28.3 28.3c-4.7 4.7-4.7 12.3 0 17l48.1 48.1-48.1 48.1c-4.7 4.7-4.7 12.3 0 17l28.3 28.3c4.7 4.7 12.3 4.7 17 0l48.1-48.1 48.1 48.1c4.7 4.7 12.3 4.7 17 0l28.3-28.3c4.7-4.7 4.7-12.3 0-17L269.3 352z"]
};
var faCalendarWeek = {
  prefix: 'fas',
  iconName: 'calendar-week',
  icon: [448, 512, [], "f784", "M0 464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V192H0v272zm64-192c0-8.8 7.2-16 16-16h288c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-64zM400 64h-48V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H160V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48z"]
};
var faCamera = {
  prefix: 'fas',
  iconName: 'camera',
  icon: [512, 512, [], "f030", "M512 144v288c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48h88l12.3-32.9c7-18.7 24.9-31.1 44.9-31.1h125.5c20 0 37.9 12.4 44.9 31.1L376 96h88c26.5 0 48 21.5 48 48zM376 288c0-66.2-53.8-120-120-120s-120 53.8-120 120 53.8 120 120 120 120-53.8 120-120zm-32 0c0 48.5-39.5 88-88 88s-88-39.5-88-88 39.5-88 88-88 88 39.5 88 88z"]
};
var faCameraRetro = {
  prefix: 'fas',
  iconName: 'camera-retro',
  icon: [512, 512, [], "f083", "M48 32C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H48zm0 32h106c3.3 0 6 2.7 6 6v20c0 3.3-2.7 6-6 6H38c-3.3 0-6-2.7-6-6V80c0-8.8 7.2-16 16-16zm426 96H38c-3.3 0-6-2.7-6-6v-36c0-3.3 2.7-6 6-6h138l30.2-45.3c1.1-1.7 3-2.7 5-2.7H464c8.8 0 16 7.2 16 16v74c0 3.3-2.7 6-6 6zM256 424c-66.2 0-120-53.8-120-120s53.8-120 120-120 120 53.8 120 120-53.8 120-120 120zm0-208c-48.5 0-88 39.5-88 88s39.5 88 88 88 88-39.5 88-88-39.5-88-88-88zm-48 104c-8.8 0-16-7.2-16-16 0-35.3 28.7-64 64-64 8.8 0 16 7.2 16 16s-7.2 16-16 16c-17.6 0-32 14.4-32 32 0 8.8-7.2 16-16 16z"]
};
var faCampground = {
  prefix: 'fas',
  iconName: 'campground',
  icon: [640, 512, [], "f6bb", "M624 448h-24.68L359.54 117.75l53.41-73.55c5.19-7.15 3.61-17.16-3.54-22.35l-25.9-18.79c-7.15-5.19-17.15-3.61-22.35 3.55L320 63.3 278.83 6.6c-5.19-7.15-15.2-8.74-22.35-3.55l-25.88 18.8c-7.15 5.19-8.74 15.2-3.54 22.35l53.41 73.55L40.68 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM320 288l116.36 160H203.64L320 288z"]
};
var faCandyCane = {
  prefix: 'fas',
  iconName: 'candy-cane',
  icon: [512, 512, [], "f786", "M497.5 92C469.6 33.1 411.8 0 352.4 0c-27.9 0-56.2 7.3-81.8 22.6L243.1 39c-15.2 9.1-20.1 28.7-11 43.9l32.8 54.9c6 10 16.6 15.6 27.5 15.6 5.6 0 11.2-1.5 16.4-4.5l27.5-16.4c5.1-3.1 10.8-4.5 16.4-4.5 10.9 0 21.5 5.6 27.5 15.6 9.1 15.1 4.1 34.8-11 43.9L15.6 397.6c-15.2 9.1-20.1 28.7-11 43.9l32.8 54.9c6 10 16.6 15.6 27.5 15.6 5.6 0 11.2-1.5 16.4-4.5L428.6 301c71.7-42.9 104.6-133.5 68.9-209zm-177.7 13l-2.5 1.5L296.8 45c9.7-4.7 19.8-8.1 30.3-10.2l20.6 61.8c-9.8.8-19.4 3.3-27.9 8.4zM145.9 431.8l-60.5-38.5 30.8-18.3 60.5 38.5-30.8 18.3zm107.5-63.9l-60.5-38.5 30.8-18.3 60.5 38.5-30.8 18.3zM364.3 302l-60.5-38.5 30.8-18.3 60.5 38.5-30.8 18.3zm20.4-197.3l46-46c8.4 6.5 16 14.1 22.6 22.6L407.6 127c-5.7-9.3-13.7-16.9-22.9-22.3zm82.1 107.8l-59.5-19.8c3.2-5.3 5.8-10.9 7.4-17.1 1.1-4.5 1.7-9.1 1.8-13.6l60.4 20.1c-2.1 10.4-5.5 20.6-10.1 30.4z"]
};
var faCannabis = {
  prefix: 'fas',
  iconName: 'cannabis',
  icon: [512, 512, [], "f55f", "M503.47 360.25c-1.56-.82-32.39-16.89-76.78-25.81 64.25-75.12 84.05-161.67 84.93-165.64 1.18-5.33-.44-10.9-4.3-14.77-3.03-3.04-7.12-4.7-11.32-4.7-1.14 0-2.29.12-3.44.38-3.88.85-86.54 19.59-160.58 79.76.01-1.46.01-2.93.01-4.4 0-118.79-59.98-213.72-62.53-217.7A15.973 15.973 0 0 0 256 0c-5.45 0-10.53 2.78-13.47 7.37-2.55 3.98-62.53 98.91-62.53 217.7 0 1.47.01 2.94.01 4.4-74.03-60.16-156.69-78.9-160.58-79.76-1.14-.25-2.29-.38-3.44-.38-4.2 0-8.29 1.66-11.32 4.7A15.986 15.986 0 0 0 .38 168.8c.88 3.97 20.68 90.52 84.93 165.64-44.39 8.92-75.21 24.99-76.78 25.81a16.003 16.003 0 0 0-.02 28.29c2.45 1.29 60.76 31.72 133.49 31.72 6.14 0 11.96-.1 17.5-.31-11.37 22.23-16.52 38.31-16.81 39.22-1.8 5.68-.29 11.89 3.91 16.11a16.019 16.019 0 0 0 16.1 3.99c1.83-.57 37.72-11.99 77.3-39.29V504c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-64.01c39.58 27.3 75.47 38.71 77.3 39.29a16.019 16.019 0 0 0 16.1-3.99c4.2-4.22 5.71-10.43 3.91-16.11-.29-.91-5.45-16.99-16.81-39.22 5.54.21 11.37.31 17.5.31 72.72 0 131.04-30.43 133.49-31.72 5.24-2.78 8.52-8.22 8.51-14.15-.01-5.94-3.29-11.39-8.53-14.15z"]
};
var faCapsules = {
  prefix: 'fas',
  iconName: 'capsules',
  icon: [576, 512, [], "f46b", "M555.3 300.1L424.2 112.8C401.9 81 366.4 64 330.4 64c-22.6 0-45.5 6.7-65.5 20.7-19.7 13.8-33.7 32.8-41.5 53.8C220.5 79.2 172 32 112 32 50.1 32 0 82.1 0 144v224c0 61.9 50.1 112 112 112s112-50.1 112-112V218.9c3.3 8.6 7.3 17.1 12.8 25L368 431.2c22.2 31.8 57.7 48.8 93.8 48.8 22.7 0 45.5-6.7 65.5-20.7 51.7-36.2 64.2-107.5 28-159.2zM160 256H64V144c0-26.5 21.5-48 48-48s48 21.5 48 48v112zm194.8 44.9l-65.6-93.7c-7.7-11-10.7-24.4-8.3-37.6 2.3-13.2 9.7-24.8 20.7-32.5 8.5-6 18.5-9.1 28.8-9.1 16.5 0 31.9 8 41.3 21.5l65.6 93.7-82.5 57.7z"]
};
var faCar = {
  prefix: 'fas',
  iconName: 'car',
  icon: [512, 512, [], "f1b9", "M499.99 176h-59.87l-16.64-41.6C406.38 91.63 365.57 64 319.5 64h-127c-46.06 0-86.88 27.63-103.99 70.4L71.87 176H12.01C4.2 176-1.53 183.34.37 190.91l6 24C7.7 220.25 12.5 224 18.01 224h20.07C24.65 235.73 16 252.78 16 272v48c0 16.12 6.16 30.67 16 41.93V416c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h256v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-54.07c9.84-11.25 16-25.8 16-41.93v-48c0-19.22-8.65-36.27-22.07-48H494c5.51 0 10.31-3.75 11.64-9.09l6-24c1.89-7.57-3.84-14.91-11.65-14.91zm-352.06-17.83c7.29-18.22 24.94-30.17 44.57-30.17h127c19.63 0 37.28 11.95 44.57 30.17L384 208H128l19.93-49.83zM96 319.8c-19.2 0-32-12.76-32-31.9S76.8 256 96 256s48 28.71 48 47.85-28.8 15.95-48 15.95zm320 0c-19.2 0-48 3.19-48-15.95S396.8 256 416 256s32 12.76 32 31.9-12.8 31.9-32 31.9z"]
};
var faCarAlt = {
  prefix: 'fas',
  iconName: 'car-alt',
  icon: [480, 512, [], "f5de", "M438.66 212.33l-11.24-28.1-19.93-49.83C390.38 91.63 349.57 64 303.5 64h-127c-46.06 0-86.88 27.63-103.99 70.4l-19.93 49.83-11.24 28.1C17.22 221.5 0 244.66 0 272v48c0 16.12 6.16 30.67 16 41.93V416c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h256v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-54.07c9.84-11.25 16-25.8 16-41.93v-48c0-27.34-17.22-50.5-41.34-59.67zm-306.73-54.16c7.29-18.22 24.94-30.17 44.57-30.17h127c19.63 0 37.28 11.95 44.57 30.17L368 208H112l19.93-49.83zM80 319.8c-19.2 0-32-12.76-32-31.9S60.8 256 80 256s48 28.71 48 47.85-28.8 15.95-48 15.95zm320 0c-19.2 0-48 3.19-48-15.95S380.8 256 400 256s32 12.76 32 31.9-12.8 31.9-32 31.9z"]
};
var faCarBattery = {
  prefix: 'fas',
  iconName: 'car-battery',
  icon: [512, 512, [], "f5df", "M480 128h-32V80c0-8.84-7.16-16-16-16h-96c-8.84 0-16 7.16-16 16v48H192V80c0-8.84-7.16-16-16-16H80c-8.84 0-16 7.16-16 16v48H32c-17.67 0-32 14.33-32 32v256c0 17.67 14.33 32 32 32h448c17.67 0 32-14.33 32-32V160c0-17.67-14.33-32-32-32zM192 264c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h112c4.42 0 8 3.58 8 8v16zm256 0c0 4.42-3.58 8-8 8h-40v40c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-40h-40c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h40v-40c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v40h40c4.42 0 8 3.58 8 8v16z"]
};
var faCarCrash = {
  prefix: 'fas',
  iconName: 'car-crash',
  icon: [640, 512, [], "f5e1", "M143.25 220.81l-12.42 46.37c-3.01 11.25-3.63 22.89-2.41 34.39l-35.2 28.98c-6.57 5.41-16.31-.43-14.62-8.77l15.44-76.68c1.06-5.26-2.66-10.28-8-10.79l-77.86-7.55c-8.47-.82-11.23-11.83-4.14-16.54l65.15-43.3c4.46-2.97 5.38-9.15 1.98-13.29L21.46 93.22c-5.41-6.57.43-16.3 8.78-14.62l76.68 15.44c5.26 1.06 10.28-2.66 10.8-8l7.55-77.86c.82-8.48 11.83-11.23 16.55-4.14l43.3 65.14c2.97 4.46 9.15 5.38 13.29 1.98l60.4-49.71c6.57-5.41 16.3.43 14.62 8.77L262.1 86.38c-2.71 3.05-5.43 6.09-7.91 9.4l-32.15 42.97-10.71 14.32c-32.73 8.76-59.18 34.53-68.08 67.74zm494.57 132.51l-12.42 46.36c-3.13 11.68-9.38 21.61-17.55 29.36a66.876 66.876 0 0 1-8.76 7l-13.99 52.23c-1.14 4.27-3.1 8.1-5.65 11.38-7.67 9.84-20.74 14.68-33.54 11.25L515 502.62c-17.07-4.57-27.2-22.12-22.63-39.19l8.28-30.91-247.28-66.26-8.28 30.91c-4.57 17.07-22.12 27.2-39.19 22.63l-30.91-8.28c-12.8-3.43-21.7-14.16-23.42-26.51-.57-4.12-.35-8.42.79-12.68l13.99-52.23a66.62 66.62 0 0 1-4.09-10.45c-3.2-10.79-3.65-22.52-.52-34.2l12.42-46.37c5.31-19.8 19.36-34.83 36.89-42.21a64.336 64.336 0 0 1 18.49-4.72l18.13-24.23 32.15-42.97c3.45-4.61 7.19-8.9 11.2-12.84 8-7.89 17.03-14.44 26.74-19.51 4.86-2.54 9.89-4.71 15.05-6.49 10.33-3.58 21.19-5.63 32.24-6.04 11.05-.41 22.31.82 33.43 3.8l122.68 32.87c11.12 2.98 21.48 7.54 30.85 13.43a111.11 111.11 0 0 1 34.69 34.5c8.82 13.88 14.64 29.84 16.68 46.99l6.36 53.29 3.59 30.05a64.49 64.49 0 0 1 22.74 29.93c4.39 11.88 5.29 25.19 1.75 38.39zM255.58 234.34c-18.55-4.97-34.21 4.04-39.17 22.53-4.96 18.49 4.11 34.12 22.65 39.09 18.55 4.97 45.54 15.51 50.49-2.98 4.96-18.49-15.43-53.67-33.97-58.64zm290.61 28.17l-6.36-53.29c-.58-4.87-1.89-9.53-3.82-13.86-5.8-12.99-17.2-23.01-31.42-26.82l-122.68-32.87a48.008 48.008 0 0 0-50.86 17.61l-32.15 42.97 172 46.08 75.29 20.18zm18.49 54.65c-18.55-4.97-53.8 15.31-58.75 33.79-4.95 18.49 23.69 22.86 42.24 27.83 18.55 4.97 34.21-4.04 39.17-22.53 4.95-18.48-4.11-34.12-22.66-39.09z"]
};
var faCarSide = {
  prefix: 'fas',
  iconName: 'car-side',
  icon: [640, 512, [], "f5e4", "M544 192h-16L419.22 56.02A64.025 64.025 0 0 0 369.24 32H155.33c-26.17 0-49.7 15.93-59.42 40.23L48 194.26C20.44 201.4 0 226.21 0 256v112c0 8.84 7.16 16 16 16h48c0 53.02 42.98 96 96 96s96-42.98 96-96h128c0 53.02 42.98 96 96 96s96-42.98 96-96h48c8.84 0 16-7.16 16-16v-80c0-53.02-42.98-96-96-96zM160 432c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48zm72-240H116.93l38.4-96H232v96zm48 0V96h89.24l76.8 96H280zm200 240c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48z"]
};
var faCaravan = {
  prefix: 'fas',
  iconName: 'caravan',
  icon: [640, 512, [], "f8ff", "M416,208a16,16,0,1,0,16,16A16,16,0,0,0,416,208ZM624,320H576V160A160,160,0,0,0,416,0H64A64,64,0,0,0,0,64V320a64,64,0,0,0,64,64H96a96,96,0,0,0,192,0H624a16,16,0,0,0,16-16V336A16,16,0,0,0,624,320ZM192,432a48,48,0,1,1,48-48A48.05,48.05,0,0,1,192,432Zm64-240a32,32,0,0,1-32,32H96a32,32,0,0,1-32-32V128A32,32,0,0,1,96,96H224a32,32,0,0,1,32,32ZM448,320H320V128a32,32,0,0,1,32-32h64a32,32,0,0,1,32,32Z"]
};
var faCaretDown = {
  prefix: 'fas',
  iconName: 'caret-down',
  icon: [320, 512, [], "f0d7", "M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z"]
};
var faCaretLeft = {
  prefix: 'fas',
  iconName: 'caret-left',
  icon: [192, 512, [], "f0d9", "M192 127.338v257.324c0 17.818-21.543 26.741-34.142 14.142L29.196 270.142c-7.81-7.81-7.81-20.474 0-28.284l128.662-128.662c12.599-12.6 34.142-3.676 34.142 14.142z"]
};
var faCaretRight = {
  prefix: 'fas',
  iconName: 'caret-right',
  icon: [192, 512, [], "f0da", "M0 384.662V127.338c0-17.818 21.543-26.741 34.142-14.142l128.662 128.662c7.81 7.81 7.81 20.474 0 28.284L34.142 398.804C21.543 411.404 0 402.48 0 384.662z"]
};
var faCaretSquareDown = {
  prefix: 'fas',
  iconName: 'caret-square-down',
  icon: [448, 512, [], "f150", "M448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zM92.5 220.5l123 123c4.7 4.7 12.3 4.7 17 0l123-123c7.6-7.6 2.2-20.5-8.5-20.5H101c-10.7 0-16.1 12.9-8.5 20.5z"]
};
var faCaretSquareLeft = {
  prefix: 'fas',
  iconName: 'caret-square-left',
  icon: [448, 512, [], "f191", "M400 480H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48zM259.515 124.485l-123.03 123.03c-4.686 4.686-4.686 12.284 0 16.971l123.029 123.029c7.56 7.56 20.485 2.206 20.485-8.485V132.971c.001-10.691-12.925-16.045-20.484-8.486z"]
};
var faCaretSquareRight = {
  prefix: 'fas',
  iconName: 'caret-square-right',
  icon: [448, 512, [], "f152", "M48 32h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48zm140.485 355.515l123.029-123.029c4.686-4.686 4.686-12.284 0-16.971l-123.029-123.03c-7.56-7.56-20.485-2.206-20.485 8.485v246.059c0 10.691 12.926 16.045 20.485 8.486z"]
};
var faCaretSquareUp = {
  prefix: 'fas',
  iconName: 'caret-square-up',
  icon: [448, 512, [], "f151", "M0 432V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48zm355.515-140.485l-123.03-123.03c-4.686-4.686-12.284-4.686-16.971 0L92.485 291.515c-7.56 7.56-2.206 20.485 8.485 20.485h246.059c10.691 0 16.045-12.926 8.486-20.485z"]
};
var faCaretUp = {
  prefix: 'fas',
  iconName: 'caret-up',
  icon: [320, 512, [], "f0d8", "M288.662 352H31.338c-17.818 0-26.741-21.543-14.142-34.142l128.662-128.662c7.81-7.81 20.474-7.81 28.284 0l128.662 128.662c12.6 12.599 3.676 34.142-14.142 34.142z"]
};
var faCarrot = {
  prefix: 'fas',
  iconName: 'carrot',
  icon: [512, 512, [], "f787", "M298.2 156.6c-52.7-25.7-114.5-10.5-150.2 32.8l55.2 55.2c6.3 6.3 6.3 16.4 0 22.6-3.1 3.1-7.2 4.7-11.3 4.7s-8.2-1.6-11.3-4.7L130.4 217 2.3 479.7c-2.9 6-3.1 13.3 0 19.7 5.4 11.1 18.9 15.7 30 10.3l133.6-65.2-49.2-49.2c-6.3-6.2-6.3-16.4 0-22.6 6.3-6.2 16.4-6.2 22.6 0l57 57 102-49.8c24-11.7 44.5-31.3 57.1-57.1 30.1-61.7 4.5-136.1-57.2-166.2zm92.1-34.9C409.8 81 399.7 32.9 360 0c-50.3 41.7-52.5 107.5-7.9 151.9l8 8c44.4 44.6 110.3 42.4 151.9-7.9-32.9-39.7-81-49.8-121.7-30.3z"]
};
var faCartArrowDown = {
  prefix: 'fas',
  iconName: 'cart-arrow-down',
  icon: [576, 512, [], "f218", "M504.717 320H211.572l6.545 32h268.418c15.401 0 26.816 14.301 23.403 29.319l-5.517 24.276C523.112 414.668 536 433.828 536 456c0 31.202-25.519 56.444-56.824 55.994-29.823-.429-54.35-24.631-55.155-54.447-.44-16.287 6.085-31.049 16.803-41.548H231.176C241.553 426.165 248 440.326 248 456c0 31.813-26.528 57.431-58.67 55.938-28.54-1.325-51.751-24.385-53.251-52.917-1.158-22.034 10.436-41.455 28.051-51.586L93.883 64H24C10.745 64 0 53.255 0 40V24C0 10.745 10.745 0 24 0h102.529c11.401 0 21.228 8.021 23.513 19.19L159.208 64H551.99c15.401 0 26.816 14.301 23.403 29.319l-47.273 208C525.637 312.246 515.923 320 504.717 320zM403.029 192H360v-60c0-6.627-5.373-12-12-12h-24c-6.627 0-12 5.373-12 12v60h-43.029c-10.691 0-16.045 12.926-8.485 20.485l67.029 67.029c4.686 4.686 12.284 4.686 16.971 0l67.029-67.029c7.559-7.559 2.205-20.485-8.486-20.485z"]
};
var faCartPlus = {
  prefix: 'fas',
  iconName: 'cart-plus',
  icon: [576, 512, [], "f217", "M504.717 320H211.572l6.545 32h268.418c15.401 0 26.816 14.301 23.403 29.319l-5.517 24.276C523.112 414.668 536 433.828 536 456c0 31.202-25.519 56.444-56.824 55.994-29.823-.429-54.35-24.631-55.155-54.447-.44-16.287 6.085-31.049 16.803-41.548H231.176C241.553 426.165 248 440.326 248 456c0 31.813-26.528 57.431-58.67 55.938-28.54-1.325-51.751-24.385-53.251-52.917-1.158-22.034 10.436-41.455 28.051-51.586L93.883 64H24C10.745 64 0 53.255 0 40V24C0 10.745 10.745 0 24 0h102.529c11.401 0 21.228 8.021 23.513 19.19L159.208 64H551.99c15.401 0 26.816 14.301 23.403 29.319l-47.273 208C525.637 312.246 515.923 320 504.717 320zM408 168h-48v-40c0-8.837-7.163-16-16-16h-16c-8.837 0-16 7.163-16 16v40h-48c-8.837 0-16 7.163-16 16v16c0 8.837 7.163 16 16 16h48v40c0 8.837 7.163 16 16 16h16c8.837 0 16-7.163 16-16v-40h48c8.837 0 16-7.163 16-16v-16c0-8.837-7.163-16-16-16z"]
};
var faCashRegister = {
  prefix: 'fas',
  iconName: 'cash-register',
  icon: [512, 512, [], "f788", "M511.1 378.8l-26.7-160c-2.6-15.4-15.9-26.7-31.6-26.7H208v-64h96c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h96v64H59.1c-15.6 0-29 11.3-31.6 26.7L.8 378.7c-.6 3.5-.9 7-.9 10.5V480c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32v-90.7c.1-3.5-.2-7-.8-10.5zM280 248c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16zm-32 64h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16zm-32-80c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h16zM80 80V48h192v32H80zm40 200h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16zm16 64v-16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16zm216 112c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h176c4.4 0 8 3.6 8 8v16zm24-112c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16zm48-80c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16z"]
};
var faCat = {
  prefix: 'fas',
  iconName: 'cat',
  icon: [512, 512, [], "f6be", "M290.59 192c-20.18 0-106.82 1.98-162.59 85.95V192c0-52.94-43.06-96-96-96-17.67 0-32 14.33-32 32s14.33 32 32 32c17.64 0 32 14.36 32 32v256c0 35.3 28.7 64 64 64h176c8.84 0 16-7.16 16-16v-16c0-17.67-14.33-32-32-32h-32l128-96v144c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V289.86c-10.29 2.67-20.89 4.54-32 4.54-61.81 0-113.52-44.05-125.41-102.4zM448 96h-64l-64-64v134.4c0 53.02 42.98 96 96 96s96-42.98 96-96V32l-64 64zm-72 80c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm80 0c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16z"]
};
var faCertificate = {
  prefix: 'fas',
  iconName: 'certificate',
  icon: [512, 512, [], "f0a3", "M458.622 255.92l45.985-45.005c13.708-12.977 7.316-36.039-10.664-40.339l-62.65-15.99 17.661-62.015c4.991-17.838-11.829-34.663-29.661-29.671l-61.994 17.667-15.984-62.671C337.085.197 313.765-6.276 300.99 7.228L256 53.57 211.011 7.229c-12.63-13.351-36.047-7.234-40.325 10.668l-15.984 62.671-61.995-17.667C74.87 57.907 58.056 74.738 63.046 92.572l17.661 62.015-62.65 15.99C.069 174.878-6.31 197.944 7.392 210.915l45.985 45.005-45.985 45.004c-13.708 12.977-7.316 36.039 10.664 40.339l62.65 15.99-17.661 62.015c-4.991 17.838 11.829 34.663 29.661 29.671l61.994-17.667 15.984 62.671c4.439 18.575 27.696 24.018 40.325 10.668L256 458.61l44.989 46.001c12.5 13.488 35.987 7.486 40.325-10.668l15.984-62.671 61.994 17.667c17.836 4.994 34.651-11.837 29.661-29.671l-17.661-62.015 62.65-15.99c17.987-4.302 24.366-27.367 10.664-40.339l-45.984-45.004z"]
};
var faChair = {
  prefix: 'fas',
  iconName: 'chair',
  icon: [448, 512, [], "f6c0", "M112 128c0-29.5 16.2-55 40-68.9V256h48V48h48v208h48V59.1c23.8 13.9 40 39.4 40 68.9v128h48V128C384 57.3 326.7 0 256 0h-64C121.3 0 64 57.3 64 128v128h48zm334.3 213.9l-10.7-32c-4.4-13.1-16.6-21.9-30.4-21.9H42.7c-13.8 0-26 8.8-30.4 21.9l-10.7 32C-5.2 362.6 10.2 384 32 384v112c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V384h256v112c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V384c21.8 0 37.2-21.4 30.3-42.1z"]
};
var faChalkboard = {
  prefix: 'fas',
  iconName: 'chalkboard',
  icon: [640, 512, [], "f51b", "M96 64h448v352h64V40c0-22.06-17.94-40-40-40H72C49.94 0 32 17.94 32 40v376h64V64zm528 384H480v-64H288v64H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"]
};
var faChalkboardTeacher = {
  prefix: 'fas',
  iconName: 'chalkboard-teacher',
  icon: [640, 512, [], "f51c", "M208 352c-2.39 0-4.78.35-7.06 1.09C187.98 357.3 174.35 360 160 360c-14.35 0-27.98-2.7-40.95-6.91-2.28-.74-4.66-1.09-7.05-1.09C49.94 352-.33 402.48 0 464.62.14 490.88 21.73 512 48 512h224c26.27 0 47.86-21.12 48-47.38.33-62.14-49.94-112.62-112-112.62zm-48-32c53.02 0 96-42.98 96-96s-42.98-96-96-96-96 42.98-96 96 42.98 96 96 96zM592 0H208c-26.47 0-48 22.25-48 49.59V96c23.42 0 45.1 6.78 64 17.8V64h352v288h-64v-64H384v64h-76.24c19.1 16.69 33.12 38.73 39.69 64H592c26.47 0 48-22.25 48-49.59V49.59C640 22.25 618.47 0 592 0z"]
};
var faChargingStation = {
  prefix: 'fas',
  iconName: 'charging-station',
  icon: [576, 512, [], "f5e7", "M336 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h320c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm208-320V80c0-8.84-7.16-16-16-16s-16 7.16-16 16v48h-32V80c0-8.84-7.16-16-16-16s-16 7.16-16 16v48h-16c-8.84 0-16 7.16-16 16v32c0 35.76 23.62 65.69 56 75.93v118.49c0 13.95-9.5 26.92-23.26 29.19C431.22 402.5 416 388.99 416 372v-28c0-48.6-39.4-88-88-88h-8V64c0-35.35-28.65-64-64-64H96C60.65 0 32 28.65 32 64v352h288V304h8c22.09 0 40 17.91 40 40v24.61c0 39.67 28.92 75.16 68.41 79.01C481.71 452.05 520 416.41 520 372V251.93c32.38-10.24 56-40.17 56-75.93v-32c0-8.84-7.16-16-16-16h-16zm-283.91 47.76l-93.7 139c-2.2 3.33-6.21 5.24-10.39 5.24-7.67 0-13.47-6.28-11.67-12.92L167.35 224H108c-7.25 0-12.85-5.59-11.89-11.89l16-107C112.9 99.9 117.98 96 124 96h68c7.88 0 13.62 6.54 11.6 13.21L192 160h57.7c9.24 0 15.01 8.78 10.39 15.76z"]
};
var faChartArea = {
  prefix: 'fas',
  iconName: 'chart-area',
  icon: [512, 512, [], "f1fe", "M500 384c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H12c-6.6 0-12-5.4-12-12V76c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v308h436zM372.7 159.5L288 216l-85.3-113.7c-5.1-6.8-15.5-6.3-19.9 1L96 248v104h384l-89.9-187.8c-3.2-6.5-11.4-8.7-17.4-4.7z"]
};
var faChartBar = {
  prefix: 'fas',
  iconName: 'chart-bar',
  icon: [512, 512, [], "f080", "M332.8 320h38.4c6.4 0 12.8-6.4 12.8-12.8V172.8c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v134.4c0 6.4 6.4 12.8 12.8 12.8zm96 0h38.4c6.4 0 12.8-6.4 12.8-12.8V76.8c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v230.4c0 6.4 6.4 12.8 12.8 12.8zm-288 0h38.4c6.4 0 12.8-6.4 12.8-12.8v-70.4c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v70.4c0 6.4 6.4 12.8 12.8 12.8zm96 0h38.4c6.4 0 12.8-6.4 12.8-12.8V108.8c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v198.4c0 6.4 6.4 12.8 12.8 12.8zM496 384H64V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v336c0 17.67 14.33 32 32 32h464c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"]
};
var faChartLine = {
  prefix: 'fas',
  iconName: 'chart-line',
  icon: [512, 512, [], "f201", "M496 384H64V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v336c0 17.67 14.33 32 32 32h464c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM464 96H345.94c-21.38 0-32.09 25.85-16.97 40.97l32.4 32.4L288 242.75l-73.37-73.37c-12.5-12.5-32.76-12.5-45.25 0l-68.69 68.69c-6.25 6.25-6.25 16.38 0 22.63l22.62 22.62c6.25 6.25 16.38 6.25 22.63 0L192 237.25l73.37 73.37c12.5 12.5 32.76 12.5 45.25 0l96-96 32.4 32.4c15.12 15.12 40.97 4.41 40.97-16.97V112c.01-8.84-7.15-16-15.99-16z"]
};
var faChartPie = {
  prefix: 'fas',
  iconName: 'chart-pie',
  icon: [544, 512, [], "f200", "M527.79 288H290.5l158.03 158.03c6.04 6.04 15.98 6.53 22.19.68 38.7-36.46 65.32-85.61 73.13-140.86 1.34-9.46-6.51-17.85-16.06-17.85zm-15.83-64.8C503.72 103.74 408.26 8.28 288.8.04 279.68-.59 272 7.1 272 16.24V240h223.77c9.14 0 16.82-7.68 16.19-16.8zM224 288V50.71c0-9.55-8.39-17.4-17.84-16.06C86.99 51.49-4.1 155.6.14 280.37 4.5 408.51 114.83 513.59 243.03 511.98c50.4-.63 96.97-16.87 135.26-44.03 7.9-5.6 8.42-17.23 1.57-24.08L224 288z"]
};
var faCheck = {
  prefix: 'fas',
  iconName: 'check',
  icon: [512, 512, [], "f00c", "M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"]
};
var faCheckCircle = {
  prefix: 'fas',
  iconName: 'check-circle',
  icon: [512, 512, [], "f058", "M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"]
};
var faCheckDouble = {
  prefix: 'fas',
  iconName: 'check-double',
  icon: [512, 512, [], "f560", "M505 174.8l-39.6-39.6c-9.4-9.4-24.6-9.4-33.9 0L192 374.7 80.6 263.2c-9.4-9.4-24.6-9.4-33.9 0L7 302.9c-9.4 9.4-9.4 24.6 0 34L175 505c9.4 9.4 24.6 9.4 33.9 0l296-296.2c9.4-9.5 9.4-24.7.1-34zm-324.3 106c6.2 6.3 16.4 6.3 22.6 0l208-208.2c6.2-6.3 6.2-16.4 0-22.6L366.1 4.7c-6.2-6.3-16.4-6.3-22.6 0L192 156.2l-55.4-55.5c-6.2-6.3-16.4-6.3-22.6 0L68.7 146c-6.2 6.3-6.2 16.4 0 22.6l112 112.2z"]
};
var faCheckSquare = {
  prefix: 'fas',
  iconName: 'check-square',
  icon: [448, 512, [], "f14a", "M400 480H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48zm-204.686-98.059l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.248-16.379-6.249-22.628 0L184 302.745l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.25 16.379 6.25 22.628.001z"]
};
var faCheese = {
  prefix: 'fas',
  iconName: 'cheese',
  icon: [512, 512, [], "f7ef", "M0 288v160a32 32 0 0 0 32 32h448a32 32 0 0 0 32-32V288zM299.83 32a32 32 0 0 0-21.13 7L0 256h512c0-119.89-94-217.8-212.17-224z"]
};
var faChess = {
  prefix: 'fas',
  iconName: 'chess',
  icon: [512, 512, [], "f439", "M74 208H64a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h15.94A535.78 535.78 0 0 1 64 384h128a535.78 535.78 0 0 1-15.94-128H192a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16h-10l33.89-90.38a16 16 0 0 0-15-21.62H144V64h24a8 8 0 0 0 8-8V40a8 8 0 0 0-8-8h-24V8a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v24H88a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h24v32H55.09a16 16 0 0 0-15 21.62zm173.16 251.58L224 448v-16a16 16 0 0 0-16-16H48a16 16 0 0 0-16 16v16L8.85 459.58A16 16 0 0 0 0 473.89V496a16 16 0 0 0 16 16h224a16 16 0 0 0 16-16v-22.11a16 16 0 0 0-8.84-14.31zm92.77-157.78l-3.29 82.2h126.72l-3.29-82.21 24.6-20.79A32 32 0 0 0 496 256.54V198a6 6 0 0 0-6-6h-26.38a6 6 0 0 0-6 6v26h-24.71v-26a6 6 0 0 0-6-6H373.1a6 6 0 0 0-6 6v26h-24.71v-26a6 6 0 0 0-6-6H310a6 6 0 0 0-6 6v58.6a32 32 0 0 0 11.36 24.4zM384 304a16 16 0 0 1 32 0v32h-32zm119.16 155.58L480 448v-16a16 16 0 0 0-16-16H336a16 16 0 0 0-16 16v16l-23.15 11.58a16 16 0 0 0-8.85 14.31V496a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16v-22.11a16 16 0 0 0-8.84-14.31z"]
};
var faChessBishop = {
  prefix: 'fas',
  iconName: 'chess-bishop',
  icon: [320, 512, [], "f43a", "M8 287.88c0 51.64 22.14 73.83 56 84.6V416h192v-43.52c33.86-10.77 56-33 56-84.6 0-30.61-10.73-67.1-26.69-102.56L185 285.65a8 8 0 0 1-11.31 0l-11.31-11.31a8 8 0 0 1 0-11.31L270.27 155.1c-20.8-37.91-46.47-72.1-70.87-92.59C213.4 59.09 224 47.05 224 32a32 32 0 0 0-32-32h-64a32 32 0 0 0-32 32c0 15 10.6 27.09 24.6 30.51C67.81 106.8 8 214.5 8 287.88zM304 448H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"]
};
var faChessBoard = {
  prefix: 'fas',
  iconName: 'chess-board',
  icon: [512, 512, [], "f43c", "M255.9.2h-64v64h64zM0 64.17v64h64v-64zM128 .2H64v64h64zm64 255.9v64h64v-64zM0 192.12v64h64v-64zM383.85.2h-64v64h64zm128 0h-64v64h64zM128 256.1H64v64h64zM511.8 448v-64h-64v64zm0-128v-64h-64v64zM383.85 512h64v-64h-64zm128-319.88v-64h-64v64zM128 512h64v-64h-64zM0 512h64v-64H0zm255.9 0h64v-64h-64zM0 320.07v64h64v-64zm319.88-191.92v-64h-64v64zm-64 128h64v-64h-64zm-64 128v64h64v-64zm128-64h64v-64h-64zm0-127.95h64v-64h-64zm0 191.93v64h64v-64zM64 384.05v64h64v-64zm128-255.9v-64h-64v64zm191.92 255.9h64v-64h-64zm-128-191.93v-64h-64v64zm128-127.95v64h64v-64zm-128 255.9v64h64v-64zm-64-127.95H128v64h64zm191.92 64h64v-64h-64zM128 128.15H64v64h64zm0 191.92v64h64v-64z"]
};
var faChessKing = {
  prefix: 'fas',
  iconName: 'chess-king',
  icon: [448, 512, [], "f43f", "M400 448H48a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h352a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm16-288H256v-48h40a8 8 0 0 0 8-8V56a8 8 0 0 0-8-8h-40V8a8 8 0 0 0-8-8h-48a8 8 0 0 0-8 8v40h-40a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8h40v48H32a32 32 0 0 0-30.52 41.54L74.56 416h298.88l73.08-214.46A32 32 0 0 0 416 160z"]
};
var faChessKnight = {
  prefix: 'fas',
  iconName: 'chess-knight',
  icon: [384, 512, [], "f441", "M19 272.47l40.63 18.06a32 32 0 0 0 24.88.47l12.78-5.12a32 32 0 0 0 18.76-20.5l9.22-30.65a24 24 0 0 1 12.55-15.65L159.94 208v50.33a48 48 0 0 1-26.53 42.94l-57.22 28.65A80 80 0 0 0 32 401.48V416h319.86V224c0-106-85.92-192-191.92-192H12A12 12 0 0 0 0 44a16.9 16.9 0 0 0 1.79 7.58L16 80l-9 9a24 24 0 0 0-7 17v137.21a32 32 0 0 0 19 29.26zM52 128a20 20 0 1 1-20 20 20 20 0 0 1 20-20zm316 320H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h352a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"]
};
var faChessPawn = {
  prefix: 'fas',
  iconName: 'chess-pawn',
  icon: [320, 512, [], "f443", "M105.1 224H80a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h16v5.49c0 44-4.14 86.6-24 122.51h176c-19.89-35.91-24-78.51-24-122.51V288h16a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-25.1c29.39-18.38 49.1-50.78 49.1-88a104 104 0 0 0-208 0c0 37.22 19.71 69.62 49.1 88zM304 448H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"]
};
var faChessQueen = {
  prefix: 'fas',
  iconName: 'chess-queen',
  icon: [512, 512, [], "f445", "M256 112a56 56 0 1 0-56-56 56 56 0 0 0 56 56zm176 336H80a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h352a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm72.87-263.84l-28.51-15.92c-7.44-5-16.91-2.46-22.29 4.68a47.59 47.59 0 0 1-47.23 18.23C383.7 186.86 368 164.93 368 141.4a13.4 13.4 0 0 0-13.4-13.4h-38.77c-6 0-11.61 4-12.86 9.91a48 48 0 0 1-93.94 0c-1.25-5.92-6.82-9.91-12.86-9.91H157.4a13.4 13.4 0 0 0-13.4 13.4c0 25.69-19 48.75-44.67 50.49a47.5 47.5 0 0 1-41.54-19.15c-5.28-7.09-14.73-9.45-22.09-4.54l-28.57 16a16 16 0 0 0-5.44 20.47L104.24 416h303.52l102.55-211.37a16 16 0 0 0-5.44-20.47z"]
};
var faChessRook = {
  prefix: 'fas',
  iconName: 'chess-rook',
  icon: [384, 512, [], "f447", "M368 32h-56a16 16 0 0 0-16 16v48h-48V48a16 16 0 0 0-16-16h-80a16 16 0 0 0-16 16v48H88.1V48a16 16 0 0 0-16-16H16A16 16 0 0 0 0 48v176l64 32c0 48.33-1.54 95-13.21 160h282.42C321.54 351 320 303.72 320 256l64-32V48a16 16 0 0 0-16-16zM224 320h-64v-64a32 32 0 0 1 64 0zm144 128H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h352a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"]
};
var faChevronCircleDown = {
  prefix: 'fas',
  iconName: 'chevron-circle-down',
  icon: [512, 512, [], "f13a", "M504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zM273 369.9l135.5-135.5c9.4-9.4 9.4-24.6 0-33.9l-17-17c-9.4-9.4-24.6-9.4-33.9 0L256 285.1 154.4 183.5c-9.4-9.4-24.6-9.4-33.9 0l-17 17c-9.4 9.4-9.4 24.6 0 33.9L239 369.9c9.4 9.4 24.6 9.4 34 0z"]
};
var faChevronCircleLeft = {
  prefix: 'fas',
  iconName: 'chevron-circle-left',
  icon: [512, 512, [], "f137", "M256 504C119 504 8 393 8 256S119 8 256 8s248 111 248 248-111 248-248 248zM142.1 273l135.5 135.5c9.4 9.4 24.6 9.4 33.9 0l17-17c9.4-9.4 9.4-24.6 0-33.9L226.9 256l101.6-101.6c9.4-9.4 9.4-24.6 0-33.9l-17-17c-9.4-9.4-24.6-9.4-33.9 0L142.1 239c-9.4 9.4-9.4 24.6 0 34z"]
};
var faChevronCircleRight = {
  prefix: 'fas',
  iconName: 'chevron-circle-right',
  icon: [512, 512, [], "f138", "M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zm113.9 231L234.4 103.5c-9.4-9.4-24.6-9.4-33.9 0l-17 17c-9.4 9.4-9.4 24.6 0 33.9L285.1 256 183.5 357.6c-9.4 9.4-9.4 24.6 0 33.9l17 17c9.4 9.4 24.6 9.4 33.9 0L369.9 273c9.4-9.4 9.4-24.6 0-34z"]
};
var faChevronCircleUp = {
  prefix: 'fas',
  iconName: 'chevron-circle-up',
  icon: [512, 512, [], "f139", "M8 256C8 119 119 8 256 8s248 111 248 248-111 248-248 248S8 393 8 256zm231-113.9L103.5 277.6c-9.4 9.4-9.4 24.6 0 33.9l17 17c9.4 9.4 24.6 9.4 33.9 0L256 226.9l101.6 101.6c9.4 9.4 24.6 9.4 33.9 0l17-17c9.4-9.4 9.4-24.6 0-33.9L273 142.1c-9.4-9.4-24.6-9.4-34 0z"]
};
var faChevronDown = {
  prefix: 'fas',
  iconName: 'chevron-down',
  icon: [448, 512, [], "f078", "M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"]
};
var faChevronLeft = {
  prefix: 'fas',
  iconName: 'chevron-left',
  icon: [320, 512, [], "f053", "M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z"]
};
var faChevronRight = {
  prefix: 'fas',
  iconName: 'chevron-right',
  icon: [320, 512, [], "f054", "M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"]
};
var faChevronUp = {
  prefix: 'fas',
  iconName: 'chevron-up',
  icon: [448, 512, [], "f077", "M240.971 130.524l194.343 194.343c9.373 9.373 9.373 24.569 0 33.941l-22.667 22.667c-9.357 9.357-24.522 9.375-33.901.04L224 227.495 69.255 381.516c-9.379 9.335-24.544 9.317-33.901-.04l-22.667-22.667c-9.373-9.373-9.373-24.569 0-33.941L207.03 130.525c9.372-9.373 24.568-9.373 33.941-.001z"]
};
var faChild = {
  prefix: 'fas',
  iconName: 'child',
  icon: [384, 512, [], "f1ae", "M120 72c0-39.765 32.235-72 72-72s72 32.235 72 72c0 39.764-32.235 72-72 72s-72-32.236-72-72zm254.627 1.373c-12.496-12.497-32.758-12.497-45.254 0L242.745 160H141.254L54.627 73.373c-12.496-12.497-32.758-12.497-45.254 0-12.497 12.497-12.497 32.758 0 45.255L104 213.254V480c0 17.673 14.327 32 32 32h16c17.673 0 32-14.327 32-32V368h16v112c0 17.673 14.327 32 32 32h16c17.673 0 32-14.327 32-32V213.254l94.627-94.627c12.497-12.497 12.497-32.757 0-45.254z"]
};
var faChurch = {
  prefix: 'fas',
  iconName: 'church',
  icon: [640, 512, [], "f51d", "M464.46 246.68L352 179.2V128h48c8.84 0 16-7.16 16-16V80c0-8.84-7.16-16-16-16h-48V16c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v48h-48c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h48v51.2l-112.46 67.48A31.997 31.997 0 0 0 160 274.12V512h96v-96c0-35.35 28.65-64 64-64s64 28.65 64 64v96h96V274.12c0-11.24-5.9-21.66-15.54-27.44zM0 395.96V496c0 8.84 7.16 16 16 16h112V320L19.39 366.54A32.024 32.024 0 0 0 0 395.96zm620.61-29.42L512 320v192h112c8.84 0 16-7.16 16-16V395.96c0-12.8-7.63-24.37-19.39-29.42z"]
};
var faCircle = {
  prefix: 'fas',
  iconName: 'circle',
  icon: [512, 512, [], "f111", "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z"]
};
var faCircleNotch = {
  prefix: 'fas',
  iconName: 'circle-notch',
  icon: [512, 512, [], "f1ce", "M288 39.056v16.659c0 10.804 7.281 20.159 17.686 23.066C383.204 100.434 440 171.518 440 256c0 101.689-82.295 184-184 184-101.689 0-184-82.295-184-184 0-84.47 56.786-155.564 134.312-177.219C216.719 75.874 224 66.517 224 55.712V39.064c0-15.709-14.834-27.153-30.046-23.234C86.603 43.482 7.394 141.206 8.003 257.332c.72 137.052 111.477 246.956 248.531 246.667C393.255 503.711 504 392.788 504 256c0-115.633-79.14-212.779-186.211-240.236C302.678 11.889 288 23.456 288 39.056z"]
};
var faCity = {
  prefix: 'fas',
  iconName: 'city',
  icon: [640, 512, [], "f64f", "M616 192H480V24c0-13.26-10.74-24-24-24H312c-13.26 0-24 10.74-24 24v72h-64V16c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v80h-64V16c0-8.84-7.16-16-16-16H80c-8.84 0-16 7.16-16 16v80H24c-13.26 0-24 10.74-24 24v360c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V216c0-13.26-10.75-24-24-24zM128 404c0 6.63-5.37 12-12 12H76c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12H76c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12H76c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm128 192c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm160 96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12V76c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm160 288c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40z"]
};
var faClinicMedical = {
  prefix: 'fas',
  iconName: 'clinic-medical',
  icon: [576, 512, [], "f7f2", "M288 115L69.47 307.71c-1.62 1.46-3.69 2.14-5.47 3.35V496a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V311.1c-1.7-1.16-3.72-1.82-5.26-3.2zm96 261a8 8 0 0 1-8 8h-56v56a8 8 0 0 1-8 8h-48a8 8 0 0 1-8-8v-56h-56a8 8 0 0 1-8-8v-48a8 8 0 0 1 8-8h56v-56a8 8 0 0 1 8-8h48a8 8 0 0 1 8 8v56h56a8 8 0 0 1 8 8zm186.69-139.72l-255.94-226a39.85 39.85 0 0 0-53.45 0l-256 226a16 16 0 0 0-1.21 22.6L25.5 282.7a16 16 0 0 0 22.6 1.21L277.42 81.63a16 16 0 0 1 21.17 0L527.91 283.9a16 16 0 0 0 22.6-1.21l21.4-23.82a16 16 0 0 0-1.22-22.59z"]
};
var faClipboard = {
  prefix: 'fas',
  iconName: 'clipboard',
  icon: [384, 512, [], "f328", "M384 112v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h80c0-35.29 28.71-64 64-64s64 28.71 64 64h80c26.51 0 48 21.49 48 48zM192 40c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24m96 114v-20a6 6 0 0 0-6-6H102a6 6 0 0 0-6 6v20a6 6 0 0 0 6 6h180a6 6 0 0 0 6-6z"]
};
var faClipboardCheck = {
  prefix: 'fas',
  iconName: 'clipboard-check',
  icon: [384, 512, [], "f46c", "M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM192 40c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm121.2 231.8l-143 141.8c-4.7 4.7-12.3 4.6-17-.1l-82.6-83.3c-4.7-4.7-4.6-12.3.1-17L99.1 285c4.7-4.7 12.3-4.6 17 .1l46 46.4 106-105.2c4.7-4.7 12.3-4.6 17 .1l28.2 28.4c4.7 4.8 4.6 12.3-.1 17z"]
};
var faClipboardList = {
  prefix: 'fas',
  iconName: 'clipboard-list',
  icon: [384, 512, [], "f46d", "M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM96 424c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm0-96c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm0-96c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm96-192c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm128 368c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16z"]
};
var faClock = {
  prefix: 'fas',
  iconName: 'clock',
  icon: [512, 512, [], "f017", "M256,8C119,8,8,119,8,256S119,504,256,504,504,393,504,256,393,8,256,8Zm92.49,313h0l-20,25a16,16,0,0,1-22.49,2.5h0l-67-49.72a40,40,0,0,1-15-31.23V112a16,16,0,0,1,16-16h32a16,16,0,0,1,16,16V256l58,42.5A16,16,0,0,1,348.49,321Z"]
};
var faClone = {
  prefix: 'fas',
  iconName: 'clone',
  icon: [512, 512, [], "f24d", "M464 0c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48H176c-26.51 0-48-21.49-48-48V48c0-26.51 21.49-48 48-48h288M176 416c-44.112 0-80-35.888-80-80V128H48c-26.51 0-48 21.49-48 48v288c0 26.51 21.49 48 48 48h288c26.51 0 48-21.49 48-48v-48H176z"]
};
var faClosedCaptioning = {
  prefix: 'fas',
  iconName: 'closed-captioning',
  icon: [512, 512, [], "f20a", "M464 64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM218.1 287.7c2.8-2.5 7.1-2.1 9.2.9l19.5 27.7c1.7 2.4 1.5 5.6-.5 7.7-53.6 56.8-172.8 32.1-172.8-67.9 0-97.3 121.7-119.5 172.5-70.1 2.1 2 2.5 3.2 1 5.7l-17.5 30.5c-1.9 3.1-6.2 4-9.1 1.7-40.8-32-94.6-14.9-94.6 31.2.1 48 51.1 70.5 92.3 32.6zm190.4 0c2.8-2.5 7.1-2.1 9.2.9l19.5 27.7c1.7 2.4 1.5 5.6-.5 7.7-53.5 56.9-172.7 32.1-172.7-67.9 0-97.3 121.7-119.5 172.5-70.1 2.1 2 2.5 3.2 1 5.7L420 222.2c-1.9 3.1-6.2 4-9.1 1.7-40.8-32-94.6-14.9-94.6 31.2 0 48 51 70.5 92.2 32.6z"]
};
var faCloud = {
  prefix: 'fas',
  iconName: 'cloud',
  icon: [640, 512, [], "f0c2", "M537.6 226.6c4.1-10.7 6.4-22.4 6.4-34.6 0-53-43-96-96-96-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32c-88.4 0-160 71.6-160 160 0 2.7.1 5.4.2 8.1C40.2 219.8 0 273.2 0 336c0 79.5 64.5 144 144 144h368c70.7 0 128-57.3 128-128 0-61.9-44-113.6-102.4-125.4z"]
};
var faCloudDownloadAlt = {
  prefix: 'fas',
  iconName: 'cloud-download-alt',
  icon: [640, 512, [], "f381", "M537.6 226.6c4.1-10.7 6.4-22.4 6.4-34.6 0-53-43-96-96-96-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32c-88.4 0-160 71.6-160 160 0 2.7.1 5.4.2 8.1C40.2 219.8 0 273.2 0 336c0 79.5 64.5 144 144 144h368c70.7 0 128-57.3 128-128 0-61.9-44-113.6-102.4-125.4zm-132.9 88.7L299.3 420.7c-6.2 6.2-16.4 6.2-22.6 0L171.3 315.3c-10.1-10.1-2.9-27.3 11.3-27.3H248V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v112h65.4c14.2 0 21.4 17.2 11.3 27.3z"]
};
var faCloudMeatball = {
  prefix: 'fas',
  iconName: 'cloud-meatball',
  icon: [512, 512, [], "f73b", "M48 352c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48zm416 0c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48zm-119 11.1c4.6-14.5 1.6-30.8-9.8-42.3-11.5-11.5-27.8-14.4-42.3-9.9-7-13.5-20.7-23-36.9-23s-29.9 9.5-36.9 23c-14.5-4.6-30.8-1.6-42.3 9.9-11.5 11.5-14.4 27.8-9.9 42.3-13.5 7-23 20.7-23 36.9s9.5 29.9 23 36.9c-4.6 14.5-1.6 30.8 9.9 42.3 8.2 8.2 18.9 12.3 29.7 12.3 4.3 0 8.5-1.1 12.6-2.5 7 13.5 20.7 23 36.9 23s29.9-9.5 36.9-23c4.1 1.3 8.3 2.5 12.6 2.5 10.8 0 21.5-4.1 29.7-12.3 11.5-11.5 14.4-27.8 9.8-42.3 13.5-7 23-20.7 23-36.9s-9.5-29.9-23-36.9zM512 224c0-53-43-96-96-96-.6 0-1.1.2-1.6.2 1.1-5.2 1.6-10.6 1.6-16.2 0-44.2-35.8-80-80-80-24.6 0-46.3 11.3-61 28.8C256.4 24.8 219.3 0 176 0 114.1 0 64 50.1 64 112c0 7.3.8 14.3 2.1 21.2C27.8 145.8 0 181.5 0 224c0 53 43 96 96 96h43.4c3.6-8 8.4-15.4 14.8-21.8 13.5-13.5 31.5-21.1 50.8-21.3 13.5-13.2 31.7-20.9 51-20.9s37.5 7.7 51 20.9c19.3.2 37.3 7.8 50.8 21.3 6.4 6.4 11.3 13.8 14.8 21.8H416c53 0 96-43 96-96z"]
};
var faCloudMoon = {
  prefix: 'fas',
  iconName: 'cloud-moon',
  icon: [576, 512, [], "f6c3", "M342.8 352.7c5.7-9.6 9.2-20.7 9.2-32.7 0-35.3-28.7-64-64-64-17.2 0-32.8 6.9-44.3 17.9-16.3-29.6-47.5-49.9-83.7-49.9-53 0-96 43-96 96 0 2 .5 3.8.6 5.7C27.1 338.8 0 374.1 0 416c0 53 43 96 96 96h240c44.2 0 80-35.8 80-80 0-41.9-32.3-75.8-73.2-79.3zm222.5-54.3c-93.1 17.7-178.5-53.7-178.5-147.7 0-54.2 29-104 76.1-130.8 7.3-4.1 5.4-15.1-2.8-16.7C448.4 1.1 436.7 0 425 0 319.1 0 233.1 85.9 233.1 192c0 8.5.7 16.8 1.8 25 5.9 4.3 11.6 8.9 16.7 14.2 11.4-4.7 23.7-7.2 36.4-7.2 52.9 0 96 43.1 96 96 0 3.6-.2 7.2-.6 10.7 23.6 10.8 42.4 29.5 53.5 52.6 54.4-3.4 103.7-29.3 137.1-70.4 5.3-6.5-.5-16.1-8.7-14.5z"]
};
var faCloudMoonRain = {
  prefix: 'fas',
  iconName: 'cloud-moon-rain',
  icon: [576, 512, [], "f73c", "M350.5 225.5c-6.9-37.2-39.3-65.5-78.5-65.5-12.3 0-23.9 3-34.3 8-17.4-24.1-45.6-40-77.7-40-53 0-96 43-96 96 0 .5.2 1.1.2 1.6C27.6 232.9 0 265.2 0 304c0 44.2 35.8 80 80 80h256c44.2 0 80-35.8 80-80 0-39.2-28.2-71.7-65.5-78.5zm217.4-1.7c-70.4 13.3-135-40.3-135-110.8 0-40.6 21.9-78 57.5-98.1 5.5-3.1 4.1-11.4-2.1-12.5C479.6.8 470.7 0 461.8 0c-77.9 0-141.1 61.2-144.4 137.9 26.7 11.9 48.2 33.8 58.9 61.7 37.1 14.3 64 47.4 70.2 86.8 5.1.5 10 1.5 15.2 1.5 44.7 0 85.6-20.2 112.6-53.3 4.2-4.8-.2-12-6.4-10.8zM364.5 418.1c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8z"]
};
var faCloudRain = {
  prefix: 'fas',
  iconName: 'cloud-rain',
  icon: [512, 512, [], "f73d", "M416 128c-.6 0-1.1.2-1.6.2 1.1-5.2 1.6-10.6 1.6-16.2 0-44.2-35.8-80-80-80-24.6 0-46.3 11.3-61 28.8C256.4 24.8 219.3 0 176 0 114.1 0 64 50.1 64 112c0 7.3.8 14.3 2.1 21.2C27.8 145.8 0 181.5 0 224c0 53 43 96 96 96h320c53 0 96-43 96-96s-43-96-96-96zM88 374.2c-12.8 44.4-40 56.4-40 87.7 0 27.7 21.5 50.1 48 50.1s48-22.4 48-50.1c0-31.4-27.2-43.1-40-87.7-2.2-8.1-13.5-8.5-16 0zm160 0c-12.8 44.4-40 56.4-40 87.7 0 27.7 21.5 50.1 48 50.1s48-22.4 48-50.1c0-31.4-27.2-43.1-40-87.7-2.2-8.1-13.5-8.5-16 0zm160 0c-12.8 44.4-40 56.4-40 87.7 0 27.7 21.5 50.1 48 50.1s48-22.4 48-50.1c0-31.4-27.2-43.1-40-87.7-2.2-8.1-13.5-8.5-16 0z"]
};
var faCloudShowersHeavy = {
  prefix: 'fas',
  iconName: 'cloud-showers-heavy',
  icon: [512, 512, [], "f740", "M183.9 370.1c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zm96 0c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zm-192 0c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zm384 0c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zm-96 0c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zM416 128c-.6 0-1.1.2-1.6.2 1.1-5.2 1.6-10.6 1.6-16.2 0-44.2-35.8-80-80-80-24.6 0-46.3 11.3-61 28.8C256.4 24.8 219.3 0 176 0 114.2 0 64 50.1 64 112c0 7.3.8 14.3 2.1 21.2C27.8 145.8 0 181.5 0 224c0 53 43 96 96 96h320c53 0 96-43 96-96s-43-96-96-96z"]
};
var faCloudSun = {
  prefix: 'fas',
  iconName: 'cloud-sun',
  icon: [640, 512, [], "f6c4", "M575.2 325.7c.2-1.9.8-3.7.8-5.6 0-35.3-28.7-64-64-64-12.6 0-24.2 3.8-34.1 10-17.6-38.8-56.5-66-101.9-66-61.8 0-112 50.1-112 112 0 3 .7 5.8.9 8.7-49.6 3.7-88.9 44.7-88.9 95.3 0 53 43 96 96 96h272c53 0 96-43 96-96 0-42.1-27.2-77.4-64.8-90.4zm-430.4-22.6c-43.7-43.7-43.7-114.7 0-158.3 43.7-43.7 114.7-43.7 158.4 0 9.7 9.7 16.9 20.9 22.3 32.7 9.8-3.7 20.1-6 30.7-7.5L386 81.1c4-11.9-7.3-23.1-19.2-19.2L279 91.2 237.5 8.4C232-2.8 216-2.8 210.4 8.4L169 91.2 81.1 61.9C69.3 58 58 69.3 61.9 81.1l29.3 87.8-82.8 41.5c-11.2 5.6-11.2 21.5 0 27.1l82.8 41.4-29.3 87.8c-4 11.9 7.3 23.1 19.2 19.2l76.1-25.3c6.1-12.4 14-23.7 23.6-33.5-13.1-5.4-25.4-13.4-36-24zm-4.8-79.2c0 40.8 29.3 74.8 67.9 82.3 8-4.7 16.3-8.8 25.2-11.7 5.4-44.3 31-82.5 67.4-105C287.3 160.4 258 140 224 140c-46.3 0-84 37.6-84 83.9z"]
};
var faCloudSunRain = {
  prefix: 'fas',
  iconName: 'cloud-sun-rain',
  icon: [576, 512, [], "f743", "M510.5 225.5c-6.9-37.2-39.3-65.5-78.5-65.5-12.3 0-23.9 3-34.3 8-17.4-24.1-45.6-40-77.7-40-53 0-96 43-96 96 0 .5.2 1.1.2 1.6C187.6 233 160 265.2 160 304c0 44.2 35.8 80 80 80h256c44.2 0 80-35.8 80-80 0-39.2-28.2-71.7-65.5-78.5zm-386.4 34.4c-37.4-37.4-37.4-98.3 0-135.8 34.6-34.6 89.1-36.8 126.7-7.4 20-12.9 43.6-20.7 69.2-20.7.7 0 1.3.2 2 .2l8.9-26.7c3.4-10.2-6.3-19.8-16.5-16.4l-75.3 25.1-35.5-71c-4.8-9.6-18.5-9.6-23.3 0l-35.5 71-75.3-25.1c-10.2-3.4-19.8 6.3-16.4 16.5l25.1 75.3-71 35.5c-9.6 4.8-9.6 18.5 0 23.3l71 35.5-25.1 75.3c-3.4 10.2 6.3 19.8 16.5 16.5l59.2-19.7c-.2-2.4-.7-4.7-.7-7.2 0-12.5 2.3-24.5 6.2-35.9-3.6-2.7-7.1-5.2-10.2-8.3zm69.8-58c4.3-24.5 15.8-46.4 31.9-64-9.8-6.2-21.4-9.9-33.8-9.9-35.3 0-64 28.7-64 64 0 18.7 8.2 35.4 21.1 47.1 11.3-15.9 26.6-28.9 44.8-37.2zm330.6 216.2c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8z"]
};
var faCloudUploadAlt = {
  prefix: 'fas',
  iconName: 'cloud-upload-alt',
  icon: [640, 512, [], "f382", "M537.6 226.6c4.1-10.7 6.4-22.4 6.4-34.6 0-53-43-96-96-96-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32c-88.4 0-160 71.6-160 160 0 2.7.1 5.4.2 8.1C40.2 219.8 0 273.2 0 336c0 79.5 64.5 144 144 144h368c70.7 0 128-57.3 128-128 0-61.9-44-113.6-102.4-125.4zM393.4 288H328v112c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V288h-65.4c-14.3 0-21.4-17.2-11.3-27.3l105.4-105.4c6.2-6.2 16.4-6.2 22.6 0l105.4 105.4c10.1 10.1 2.9 27.3-11.3 27.3z"]
};
var faCocktail = {
  prefix: 'fas',
  iconName: 'cocktail',
  icon: [576, 512, [], "f561", "M296 464h-56V338.78l168.74-168.73c15.52-15.52 4.53-42.05-17.42-42.05H24.68c-21.95 0-32.94 26.53-17.42 42.05L176 338.78V464h-56c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h240c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40zM432 0c-62.61 0-115.35 40.2-135.18 96h52.54c16.65-28.55 47.27-48 82.64-48 52.93 0 96 43.06 96 96s-43.07 96-96 96c-14.04 0-27.29-3.2-39.32-8.64l-35.26 35.26C379.23 279.92 404.59 288 432 288c79.53 0 144-64.47 144-144S511.53 0 432 0z"]
};
var faCode = {
  prefix: 'fas',
  iconName: 'code',
  icon: [640, 512, [], "f121", "M278.9 511.5l-61-17.7c-6.4-1.8-10-8.5-8.2-14.9L346.2 8.7c1.8-6.4 8.5-10 14.9-8.2l61 17.7c6.4 1.8 10 8.5 8.2 14.9L293.8 503.3c-1.9 6.4-8.5 10.1-14.9 8.2zm-114-112.2l43.5-46.4c4.6-4.9 4.3-12.7-.8-17.2L117 256l90.6-79.7c5.1-4.5 5.5-12.3.8-17.2l-43.5-46.4c-4.5-4.8-12.1-5.1-17-.5L3.8 247.2c-5.1 4.7-5.1 12.8 0 17.5l144.1 135.1c4.9 4.6 12.5 4.4 17-.5zm327.2.6l144.1-135.1c5.1-4.7 5.1-12.8 0-17.5L492.1 112.1c-4.8-4.5-12.4-4.3-17 .5L431.6 159c-4.6 4.9-4.3 12.7.8 17.2L523 256l-90.6 79.7c-5.1 4.5-5.5 12.3-.8 17.2l43.5 46.4c4.5 4.9 12.1 5.1 17 .6z"]
};
var faCodeBranch = {
  prefix: 'fas',
  iconName: 'code-branch',
  icon: [384, 512, [], "f126", "M384 144c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 36.4 24.3 67.1 57.5 76.8-.6 16.1-4.2 28.5-11 36.9-15.4 19.2-49.3 22.4-85.2 25.7-28.2 2.6-57.4 5.4-81.3 16.9v-144c32.5-10.2 56-40.5 56-76.3 0-44.2-35.8-80-80-80S0 35.8 0 80c0 35.8 23.5 66.1 56 76.3v199.3C23.5 365.9 0 396.2 0 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-34-21.2-63.1-51.2-74.6 3.1-5.2 7.8-9.8 14.9-13.4 16.2-8.2 40.4-10.4 66.1-12.8 42.2-3.9 90-8.4 118.2-43.4 14-17.4 21.1-39.8 21.6-67.9 31.6-10.8 54.4-40.7 54.4-75.9zM80 64c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16 7.2-16 16-16zm0 384c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm224-320c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16 7.2-16 16-16z"]
};
var faCoffee = {
  prefix: 'fas',
  iconName: 'coffee',
  icon: [640, 512, [], "f0f4", "M192 384h192c53 0 96-43 96-96h32c70.6 0 128-57.4 128-128S582.6 32 512 32H120c-13.3 0-24 10.7-24 24v232c0 53 43 96 96 96zM512 96c35.3 0 64 28.7 64 64s-28.7 64-64 64h-32V96h32zm47.7 384H48.3c-47.6 0-61-64-36-64h583.3c25 0 11.8 64-35.9 64z"]
};
var faCog = {
  prefix: 'fas',
  iconName: 'cog',
  icon: [512, 512, [], "f013", "M487.4 315.7l-42.6-24.6c4.3-23.2 4.3-47 0-70.2l42.6-24.6c4.9-2.8 7.1-8.6 5.5-14-11.1-35.6-30-67.8-54.7-94.6-3.8-4.1-10-5.1-14.8-2.3L380.8 110c-17.9-15.4-38.5-27.3-60.8-35.1V25.8c0-5.6-3.9-10.5-9.4-11.7-36.7-8.2-74.3-7.8-109.2 0-5.5 1.2-9.4 6.1-9.4 11.7V75c-22.2 7.9-42.8 19.8-60.8 35.1L88.7 85.5c-4.9-2.8-11-1.9-14.8 2.3-24.7 26.7-43.6 58.9-54.7 94.6-1.7 5.4.6 11.2 5.5 14L67.3 221c-4.3 23.2-4.3 47 0 70.2l-42.6 24.6c-4.9 2.8-7.1 8.6-5.5 14 11.1 35.6 30 67.8 54.7 94.6 3.8 4.1 10 5.1 14.8 2.3l42.6-24.6c17.9 15.4 38.5 27.3 60.8 35.1v49.2c0 5.6 3.9 10.5 9.4 11.7 36.7 8.2 74.3 7.8 109.2 0 5.5-1.2 9.4-6.1 9.4-11.7v-49.2c22.2-7.9 42.8-19.8 60.8-35.1l42.6 24.6c4.9 2.8 11 1.9 14.8-2.3 24.7-26.7 43.6-58.9 54.7-94.6 1.5-5.5-.7-11.3-5.6-14.1zM256 336c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"]
};
var faCogs = {
  prefix: 'fas',
  iconName: 'cogs',
  icon: [640, 512, [], "f085", "M512.1 191l-8.2 14.3c-3 5.3-9.4 7.5-15.1 5.4-11.8-4.4-22.6-10.7-32.1-18.6-4.6-3.8-5.8-10.5-2.8-15.7l8.2-14.3c-6.9-8-12.3-17.3-15.9-27.4h-16.5c-6 0-11.2-4.3-12.2-10.3-2-12-2.1-24.6 0-37.1 1-6 6.2-10.4 12.2-10.4h16.5c3.6-10.1 9-19.4 15.9-27.4l-8.2-14.3c-3-5.2-1.9-11.9 2.8-15.7 9.5-7.9 20.4-14.2 32.1-18.6 5.7-2.1 12.1.1 15.1 5.4l8.2 14.3c10.5-1.9 21.2-1.9 31.7 0L552 6.3c3-5.3 9.4-7.5 15.1-5.4 11.8 4.4 22.6 10.7 32.1 18.6 4.6 3.8 5.8 10.5 2.8 15.7l-8.2 14.3c6.9 8 12.3 17.3 15.9 27.4h16.5c6 0 11.2 4.3 12.2 10.3 2 12 2.1 24.6 0 37.1-1 6-6.2 10.4-12.2 10.4h-16.5c-3.6 10.1-9 19.4-15.9 27.4l8.2 14.3c3 5.2 1.9 11.9-2.8 15.7-9.5 7.9-20.4 14.2-32.1 18.6-5.7 2.1-12.1-.1-15.1-5.4l-8.2-14.3c-10.4 1.9-21.2 1.9-31.7 0zm-10.5-58.8c38.5 29.6 82.4-14.3 52.8-52.8-38.5-29.7-82.4 14.3-52.8 52.8zM386.3 286.1l33.7 16.8c10.1 5.8 14.5 18.1 10.5 29.1-8.9 24.2-26.4 46.4-42.6 65.8-7.4 8.9-20.2 11.1-30.3 5.3l-29.1-16.8c-16 13.7-34.6 24.6-54.9 31.7v33.6c0 11.6-8.3 21.6-19.7 23.6-24.6 4.2-50.4 4.4-75.9 0-11.5-2-20-11.9-20-23.6V418c-20.3-7.2-38.9-18-54.9-31.7L74 403c-10 5.8-22.9 3.6-30.3-5.3-16.2-19.4-33.3-41.6-42.2-65.7-4-10.9.4-23.2 10.5-29.1l33.3-16.8c-3.9-20.9-3.9-42.4 0-63.4L12 205.8c-10.1-5.8-14.6-18.1-10.5-29 8.9-24.2 26-46.4 42.2-65.8 7.4-8.9 20.2-11.1 30.3-5.3l29.1 16.8c16-13.7 34.6-24.6 54.9-31.7V57.1c0-11.5 8.2-21.5 19.6-23.5 24.6-4.2 50.5-4.4 76-.1 11.5 2 20 11.9 20 23.6v33.6c20.3 7.2 38.9 18 54.9 31.7l29.1-16.8c10-5.8 22.9-3.6 30.3 5.3 16.2 19.4 33.2 41.6 42.1 65.8 4 10.9.1 23.2-10 29.1l-33.7 16.8c3.9 21 3.9 42.5 0 63.5zm-117.6 21.1c59.2-77-28.7-164.9-105.7-105.7-59.2 77 28.7 164.9 105.7 105.7zm243.4 182.7l-8.2 14.3c-3 5.3-9.4 7.5-15.1 5.4-11.8-4.4-22.6-10.7-32.1-18.6-4.6-3.8-5.8-10.5-2.8-15.7l8.2-14.3c-6.9-8-12.3-17.3-15.9-27.4h-16.5c-6 0-11.2-4.3-12.2-10.3-2-12-2.1-24.6 0-37.1 1-6 6.2-10.4 12.2-10.4h16.5c3.6-10.1 9-19.4 15.9-27.4l-8.2-14.3c-3-5.2-1.9-11.9 2.8-15.7 9.5-7.9 20.4-14.2 32.1-18.6 5.7-2.1 12.1.1 15.1 5.4l8.2 14.3c10.5-1.9 21.2-1.9 31.7 0l8.2-14.3c3-5.3 9.4-7.5 15.1-5.4 11.8 4.4 22.6 10.7 32.1 18.6 4.6 3.8 5.8 10.5 2.8 15.7l-8.2 14.3c6.9 8 12.3 17.3 15.9 27.4h16.5c6 0 11.2 4.3 12.2 10.3 2 12 2.1 24.6 0 37.1-1 6-6.2 10.4-12.2 10.4h-16.5c-3.6 10.1-9 19.4-15.9 27.4l8.2 14.3c3 5.2 1.9 11.9-2.8 15.7-9.5 7.9-20.4 14.2-32.1 18.6-5.7 2.1-12.1-.1-15.1-5.4l-8.2-14.3c-10.4 1.9-21.2 1.9-31.7 0zM501.6 431c38.5 29.6 82.4-14.3 52.8-52.8-38.5-29.6-82.4 14.3-52.8 52.8z"]
};
var faCoins = {
  prefix: 'fas',
  iconName: 'coins',
  icon: [512, 512, [], "f51e", "M0 405.3V448c0 35.3 86 64 192 64s192-28.7 192-64v-42.7C342.7 434.4 267.2 448 192 448S41.3 434.4 0 405.3zM320 128c106 0 192-28.7 192-64S426 0 320 0 128 28.7 128 64s86 64 192 64zM0 300.4V352c0 35.3 86 64 192 64s192-28.7 192-64v-51.6c-41.3 34-116.9 51.6-192 51.6S41.3 334.4 0 300.4zm416 11c57.3-11.1 96-31.7 96-55.4v-42.7c-23.2 16.4-57.3 27.6-96 34.5v63.6zM192 160C86 160 0 195.8 0 240s86 80 192 80 192-35.8 192-80-86-80-192-80zm219.3 56.3c60-10.8 100.7-32 100.7-56.3v-42.7c-35.5 25.1-96.5 38.6-160.7 41.8 29.5 14.3 51.2 33.5 60 57.2z"]
};
var faColumns = {
  prefix: 'fas',
  iconName: 'columns',
  icon: [512, 512, [], "f0db", "M464 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM224 416H64V160h160v256zm224 0H288V160h160v256z"]
};
var faComment = {
  prefix: 'fas',
  iconName: 'comment',
  icon: [512, 512, [], "f075", "M256 32C114.6 32 0 125.1 0 240c0 49.6 21.4 95 57 130.7C44.5 421.1 2.7 466 2.2 466.5c-2.2 2.3-2.8 5.7-1.5 8.7S4.8 480 8 480c66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 141.4 0 256-93.1 256-208S397.4 32 256 32z"]
};
var faCommentAlt = {
  prefix: 'fas',
  iconName: 'comment-alt',
  icon: [512, 512, [], "f27a", "M448 0H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v84c0 9.8 11.2 15.5 19.1 9.7L304 416h144c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64z"]
};
var faCommentDollar = {
  prefix: 'fas',
  iconName: 'comment-dollar',
  icon: [512, 512, [], "f651", "M256 32C114.62 32 0 125.12 0 240c0 49.56 21.41 95.01 57.02 130.74C44.46 421.05 2.7 465.97 2.2 466.5A7.995 7.995 0 0 0 8 480c66.26 0 115.99-31.75 140.6-51.38C181.29 440.93 217.59 448 256 448c141.38 0 256-93.12 256-208S397.38 32 256 32zm24 302.44V352c0 8.84-7.16 16-16 16h-16c-8.84 0-16-7.16-16-16v-17.73c-11.42-1.35-22.28-5.19-31.78-11.46-6.22-4.11-6.82-13.11-1.55-18.38l17.52-17.52c3.74-3.74 9.31-4.24 14.11-2.03 3.18 1.46 6.66 2.22 10.26 2.22h32.78c4.66 0 8.44-3.78 8.44-8.42 0-3.75-2.52-7.08-6.12-8.11l-50.07-14.3c-22.25-6.35-40.01-24.71-42.91-47.67-4.05-32.07 19.03-59.43 49.32-63.05V128c0-8.84 7.16-16 16-16h16c8.84 0 16 7.16 16 16v17.73c11.42 1.35 22.28 5.19 31.78 11.46 6.22 4.11 6.82 13.11 1.55 18.38l-17.52 17.52c-3.74 3.74-9.31 4.24-14.11 2.03a24.516 24.516 0 0 0-10.26-2.22h-32.78c-4.66 0-8.44 3.78-8.44 8.42 0 3.75 2.52 7.08 6.12 8.11l50.07 14.3c22.25 6.36 40.01 24.71 42.91 47.67 4.05 32.06-19.03 59.42-49.32 63.04z"]
};
var faCommentDots = {
  prefix: 'fas',
  iconName: 'comment-dots',
  icon: [512, 512, [], "f4ad", "M256 32C114.6 32 0 125.1 0 240c0 49.6 21.4 95 57 130.7C44.5 421.1 2.7 466 2.2 466.5c-2.2 2.3-2.8 5.7-1.5 8.7S4.8 480 8 480c66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 141.4 0 256-93.1 256-208S397.4 32 256 32zM128 272c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"]
};
var faCommentMedical = {
  prefix: 'fas',
  iconName: 'comment-medical',
  icon: [512, 512, [], "f7f5", "M256 32C114.62 32 0 125.12 0 240c0 49.56 21.41 95 57 130.74C44.46 421.05 2.7 466 2.2 466.5A8 8 0 0 0 8 480c66.26 0 116-31.75 140.6-51.38A304.66 304.66 0 0 0 256 448c141.39 0 256-93.12 256-208S397.39 32 256 32zm96 232a8 8 0 0 1-8 8h-56v56a8 8 0 0 1-8 8h-48a8 8 0 0 1-8-8v-56h-56a8 8 0 0 1-8-8v-48a8 8 0 0 1 8-8h56v-56a8 8 0 0 1 8-8h48a8 8 0 0 1 8 8v56h56a8 8 0 0 1 8 8z"]
};
var faCommentSlash = {
  prefix: 'fas',
  iconName: 'comment-slash',
  icon: [640, 512, [], "f4b3", "M64 240c0 49.6 21.4 95 57 130.7-12.6 50.3-54.3 95.2-54.8 95.8-2.2 2.3-2.8 5.7-1.5 8.7 1.3 2.9 4.1 4.8 7.3 4.8 66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 27.4 0 53.7-3.6 78.4-10L72.9 186.4c-5.6 17.1-8.9 35-8.9 53.6zm569.8 218.1l-114.4-88.4C554.6 334.1 576 289.2 576 240c0-114.9-114.6-208-256-208-65.1 0-124.2 20.1-169.4 52.7L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4l588.4 454.7c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.4-6.8 4.1-16.9-2.9-22.3z"]
};
var faComments = {
  prefix: 'fas',
  iconName: 'comments',
  icon: [576, 512, [], "f086", "M416 192c0-88.4-93.1-160-208-160S0 103.6 0 192c0 34.3 14.1 65.9 38 92-13.4 30.2-35.5 54.2-35.8 54.5-2.2 2.3-2.8 5.7-1.5 8.7S4.8 352 8 352c36.6 0 66.9-12.3 88.7-25 32.2 15.7 70.3 25 111.3 25 114.9 0 208-71.6 208-160zm122 220c23.9-26 38-57.7 38-92 0-66.9-53.5-124.2-129.3-148.1.9 6.6 1.3 13.3 1.3 20.1 0 105.9-107.7 192-240 192-10.8 0-21.3-.8-31.7-1.9C207.8 439.6 281.8 480 368 480c41 0 79.1-9.2 111.3-25 21.8 12.7 52.1 25 88.7 25 3.2 0 6.1-1.9 7.3-4.8 1.3-2.9.7-6.3-1.5-8.7-.3-.3-22.4-24.2-35.8-54.5z"]
};
var faCommentsDollar = {
  prefix: 'fas',
  iconName: 'comments-dollar',
  icon: [576, 512, [], "f653", "M416 192c0-88.37-93.12-160-208-160S0 103.63 0 192c0 34.27 14.13 65.95 37.97 91.98C24.61 314.22 2.52 338.16 2.2 338.5A7.995 7.995 0 0 0 8 352c36.58 0 66.93-12.25 88.73-24.98C128.93 342.76 167.02 352 208 352c114.88 0 208-71.63 208-160zm-224 96v-16.29c-11.29-.58-22.27-4.52-31.37-11.35-3.9-2.93-4.1-8.77-.57-12.14l11.75-11.21c2.77-2.64 6.89-2.76 10.13-.73 3.87 2.42 8.26 3.72 12.82 3.72h28.11c6.5 0 11.8-5.92 11.8-13.19 0-5.95-3.61-11.19-8.77-12.73l-45-13.5c-18.59-5.58-31.58-23.42-31.58-43.39 0-24.52 19.05-44.44 42.67-45.07V96c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16.29c11.29.58 22.27 4.51 31.37 11.35 3.9 2.93 4.1 8.77.57 12.14l-11.75 11.21c-2.77 2.64-6.89 2.76-10.13.73-3.87-2.43-8.26-3.72-12.82-3.72h-28.11c-6.5 0-11.8 5.92-11.8 13.19 0 5.95 3.61 11.19 8.77 12.73l45 13.5c18.59 5.58 31.58 23.42 31.58 43.39 0 24.53-19.05 44.44-42.67 45.07V288c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8zm346.01 123.99C561.87 385.96 576 354.27 576 320c0-66.94-53.49-124.2-129.33-148.07.86 6.6 1.33 13.29 1.33 20.07 0 105.87-107.66 192-240 192-10.78 0-21.32-.77-31.73-1.88C207.8 439.63 281.77 480 368 480c40.98 0 79.07-9.24 111.27-24.98C501.07 467.75 531.42 480 568 480c3.2 0 6.09-1.91 7.34-4.84 1.27-2.94.66-6.34-1.55-8.67-.31-.33-22.42-24.24-35.78-54.5z"]
};
var faCompactDisc = {
  prefix: 'fas',
  iconName: 'compact-disc',
  icon: [496, 512, [], "f51f", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM88 256H56c0-105.9 86.1-192 192-192v32c-88.2 0-160 71.8-160 160zm160 96c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96zm0-128c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"]
};
var faCompass = {
  prefix: 'fas',
  iconName: 'compass',
  icon: [496, 512, [], "f14e", "M225.38 233.37c-12.5 12.5-12.5 32.76 0 45.25 12.49 12.5 32.76 12.5 45.25 0 12.5-12.5 12.5-32.76 0-45.25-12.5-12.49-32.76-12.49-45.25 0zM248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm126.14 148.05L308.17 300.4a31.938 31.938 0 0 1-15.77 15.77l-144.34 65.97c-16.65 7.61-33.81-9.55-26.2-26.2l65.98-144.35a31.938 31.938 0 0 1 15.77-15.77l144.34-65.97c16.65-7.6 33.8 9.55 26.19 26.2z"]
};
var faCompress = {
  prefix: 'fas',
  iconName: 'compress',
  icon: [448, 512, [], "f066", "M436 192H312c-13.3 0-24-10.7-24-24V44c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v84h84c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm-276-24V44c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v84H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h124c13.3 0 24-10.7 24-24zm0 300V344c0-13.3-10.7-24-24-24H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h84v84c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm192 0v-84h84c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12H312c-13.3 0-24 10.7-24 24v124c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12z"]
};
var faCompressAlt = {
  prefix: 'fas',
  iconName: 'compress-alt',
  icon: [448, 512, [], "f422", "M4.686 427.314L104 328l-32.922-31.029C55.958 281.851 66.666 256 88.048 256h112C213.303 256 224 266.745 224 280v112c0 21.382-25.803 32.09-40.922 16.971L152 376l-99.314 99.314c-6.248 6.248-16.379 6.248-22.627 0L4.686 449.941c-6.248-6.248-6.248-16.379 0-22.627zM443.314 84.686L344 184l32.922 31.029c15.12 15.12 4.412 40.971-16.97 40.971h-112C234.697 256 224 245.255 224 232V120c0-21.382 25.803-32.09 40.922-16.971L296 136l99.314-99.314c6.248-6.248 16.379-6.248 22.627 0l25.373 25.373c6.248 6.248 6.248 16.379 0 22.627z"]
};
var faCompressArrowsAlt = {
  prefix: 'fas',
  iconName: 'compress-arrows-alt',
  icon: [512, 512, [], "f78c", "M200 288H88c-21.4 0-32.1 25.8-17 41l32.9 31-99.2 99.3c-6.2 6.2-6.2 16.4 0 22.6l25.4 25.4c6.2 6.2 16.4 6.2 22.6 0L152 408l31.1 33c15.1 15.1 40.9 4.4 40.9-17V312c0-13.3-10.7-24-24-24zm112-64h112c21.4 0 32.1-25.9 17-41l-33-31 99.3-99.3c6.2-6.2 6.2-16.4 0-22.6L481.9 4.7c-6.2-6.2-16.4-6.2-22.6 0L360 104l-31.1-33C313.8 55.9 288 66.6 288 88v112c0 13.3 10.7 24 24 24zm96 136l33-31.1c15.1-15.1 4.4-40.9-17-40.9H312c-13.3 0-24 10.7-24 24v112c0 21.4 25.9 32.1 41 17l31-32.9 99.3 99.3c6.2 6.2 16.4 6.2 22.6 0l25.4-25.4c6.2-6.2 6.2-16.4 0-22.6L408 360zM183 71.1L152 104 52.7 4.7c-6.2-6.2-16.4-6.2-22.6 0L4.7 30.1c-6.2 6.2-6.2 16.4 0 22.6L104 152l-33 31.1C55.9 198.2 66.6 224 88 224h112c13.3 0 24-10.7 24-24V88c0-21.3-25.9-32-41-16.9z"]
};
var faConciergeBell = {
  prefix: 'fas',
  iconName: 'concierge-bell',
  icon: [512, 512, [], "f562", "M288 130.54V112h16c8.84 0 16-7.16 16-16V80c0-8.84-7.16-16-16-16h-96c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h16v18.54C115.49 146.11 32 239.18 32 352h448c0-112.82-83.49-205.89-192-221.46zM496 384H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"]
};
var faCookie = {
  prefix: 'fas',
  iconName: 'cookie',
  icon: [512, 512, [], "f563", "M510.37 254.79l-12.08-76.26a132.493 132.493 0 0 0-37.16-72.95l-54.76-54.75c-19.73-19.72-45.18-32.7-72.71-37.05l-76.7-12.15c-27.51-4.36-55.69.11-80.52 12.76L107.32 49.6a132.25 132.25 0 0 0-57.79 57.8l-35.1 68.88a132.602 132.602 0 0 0-12.82 80.94l12.08 76.27a132.493 132.493 0 0 0 37.16 72.95l54.76 54.75a132.087 132.087 0 0 0 72.71 37.05l76.7 12.14c27.51 4.36 55.69-.11 80.52-12.75l69.12-35.21a132.302 132.302 0 0 0 57.79-57.8l35.1-68.87c12.71-24.96 17.2-53.3 12.82-80.96zM176 368c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm32-160c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm160 128c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"]
};
var faCookieBite = {
  prefix: 'fas',
  iconName: 'cookie-bite',
  icon: [512, 512, [], "f564", "M510.52 255.82c-69.97-.85-126.47-57.69-126.47-127.86-70.17 0-127-56.49-127.86-126.45-27.26-4.14-55.13.3-79.72 12.82l-69.13 35.22a132.221 132.221 0 0 0-57.79 57.81l-35.1 68.88a132.645 132.645 0 0 0-12.82 80.95l12.08 76.27a132.521 132.521 0 0 0 37.16 72.96l54.77 54.76a132.036 132.036 0 0 0 72.71 37.06l76.71 12.15c27.51 4.36 55.7-.11 80.53-12.76l69.13-35.21a132.273 132.273 0 0 0 57.79-57.81l35.1-68.88c12.56-24.64 17.01-52.58 12.91-79.91zM176 368c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm32-160c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm160 128c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"]
};
var faCopy = {
  prefix: 'fas',
  iconName: 'copy',
  icon: [448, 512, [], "f0c5", "M320 448v40c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V120c0-13.255 10.745-24 24-24h72v296c0 30.879 25.121 56 56 56h168zm0-344V0H152c-13.255 0-24 10.745-24 24v368c0 13.255 10.745 24 24 24h272c13.255 0 24-10.745 24-24V128H344c-13.2 0-24-10.8-24-24zm120.971-31.029L375.029 7.029A24 24 0 0 0 358.059 0H352v96h96v-6.059a24 24 0 0 0-7.029-16.97z"]
};
var faCopyright = {
  prefix: 'fas',
  iconName: 'copyright',
  icon: [512, 512, [], "f1f9", "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm117.134 346.753c-1.592 1.867-39.776 45.731-109.851 45.731-84.692 0-144.484-63.26-144.484-145.567 0-81.303 62.004-143.401 143.762-143.401 66.957 0 101.965 37.315 103.422 38.904a12 12 0 0 1 1.238 14.623l-22.38 34.655c-4.049 6.267-12.774 7.351-18.234 2.295-.233-.214-26.529-23.88-61.88-23.88-46.116 0-73.916 33.575-73.916 76.082 0 39.602 25.514 79.692 74.277 79.692 38.697 0 65.28-28.338 65.544-28.625 5.132-5.565 14.059-5.033 18.508 1.053l24.547 33.572a12.001 12.001 0 0 1-.553 14.866z"]
};
var faCouch = {
  prefix: 'fas',
  iconName: 'couch',
  icon: [640, 512, [], "f4b8", "M160 224v64h320v-64c0-35.3 28.7-64 64-64h32c0-53-43-96-96-96H160c-53 0-96 43-96 96h32c35.3 0 64 28.7 64 64zm416-32h-32c-17.7 0-32 14.3-32 32v96H128v-96c0-17.7-14.3-32-32-32H64c-35.3 0-64 28.7-64 64 0 23.6 13 44 32 55.1V432c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-16h384v16c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V311.1c19-11.1 32-31.5 32-55.1 0-35.3-28.7-64-64-64z"]
};
var faCreditCard = {
  prefix: 'fas',
  iconName: 'credit-card',
  icon: [576, 512, [], "f09d", "M0 432c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V256H0v176zm192-68c0-6.6 5.4-12 12-12h136c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H204c-6.6 0-12-5.4-12-12v-40zm-128 0c0-6.6 5.4-12 12-12h72c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zM576 80v48H0V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48z"]
};
var faCrop = {
  prefix: 'fas',
  iconName: 'crop',
  icon: [512, 512, [], "f125", "M488 352h-40V109.25l59.31-59.31c6.25-6.25 6.25-16.38 0-22.63L484.69 4.69c-6.25-6.25-16.38-6.25-22.63 0L402.75 64H192v96h114.75L160 306.75V24c0-13.26-10.75-24-24-24H88C74.75 0 64 10.74 64 24v40H24C10.75 64 0 74.74 0 88v48c0 13.25 10.75 24 24 24h40v264c0 13.25 10.75 24 24 24h232v-96H205.25L352 205.25V488c0 13.25 10.75 24 24 24h48c13.25 0 24-10.75 24-24v-40h40c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24z"]
};
var faCropAlt = {
  prefix: 'fas',
  iconName: 'crop-alt',
  icon: [512, 512, [], "f565", "M488 352h-40V96c0-17.67-14.33-32-32-32H192v96h160v328c0 13.25 10.75 24 24 24h48c13.25 0 24-10.75 24-24v-40h40c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24zM160 24c0-13.26-10.75-24-24-24H88C74.75 0 64 10.74 64 24v40H24C10.75 64 0 74.74 0 88v48c0 13.25 10.75 24 24 24h40v256c0 17.67 14.33 32 32 32h224v-96H160V24z"]
};
var faCross = {
  prefix: 'fas',
  iconName: 'cross',
  icon: [384, 512, [], "f654", "M352 128h-96V32c0-17.67-14.33-32-32-32h-64c-17.67 0-32 14.33-32 32v96H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h96v224c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V256h96c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32z"]
};
var faCrosshairs = {
  prefix: 'fas',
  iconName: 'crosshairs',
  icon: [512, 512, [], "f05b", "M500 224h-30.364C455.724 130.325 381.675 56.276 288 42.364V12c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v30.364C130.325 56.276 56.276 130.325 42.364 224H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h30.364C56.276 381.675 130.325 455.724 224 469.636V500c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-30.364C381.675 455.724 455.724 381.675 469.636 288H500c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zM288 404.634V364c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40.634C165.826 392.232 119.783 346.243 107.366 288H148c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-40.634C119.768 165.826 165.757 119.783 224 107.366V148c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40.634C346.174 119.768 392.217 165.757 404.634 224H364c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40.634C392.232 346.174 346.243 392.217 288 404.634zM288 256c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z"]
};
var faCrow = {
  prefix: 'fas',
  iconName: 'crow',
  icon: [640, 512, [], "f520", "M544 32h-16.36C513.04 12.68 490.09 0 464 0c-44.18 0-80 35.82-80 80v20.98L12.09 393.57A30.216 30.216 0 0 0 0 417.74c0 22.46 23.64 37.07 43.73 27.03L165.27 384h96.49l44.41 120.1c2.27 6.23 9.15 9.44 15.38 7.17l22.55-8.21c6.23-2.27 9.44-9.15 7.17-15.38L312.94 384H352c1.91 0 3.76-.23 5.66-.29l44.51 120.38c2.27 6.23 9.15 9.44 15.38 7.17l22.55-8.21c6.23-2.27 9.44-9.15 7.17-15.38l-41.24-111.53C485.74 352.8 544 279.26 544 192v-80l96-16c0-35.35-42.98-64-96-64zm-80 72c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"]
};
var faCrown = {
  prefix: 'fas',
  iconName: 'crown',
  icon: [640, 512, [], "f521", "M528 448H112c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h416c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm64-320c-26.5 0-48 21.5-48 48 0 7.1 1.6 13.7 4.4 19.8L476 239.2c-15.4 9.2-35.3 4-44.2-11.6L350.3 85C361 76.2 368 63 368 48c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 15 7 28.2 17.7 37l-81.5 142.6c-8.9 15.6-28.9 20.8-44.2 11.6l-72.3-43.4c2.7-6 4.4-12.7 4.4-19.8 0-26.5-21.5-48-48-48S0 149.5 0 176s21.5 48 48 48c2.6 0 5.2-.4 7.7-.8L128 416h384l72.3-192.8c2.5.4 5.1.8 7.7.8 26.5 0 48-21.5 48-48s-21.5-48-48-48z"]
};
var faCrutch = {
  prefix: 'fas',
  iconName: 'crutch',
  icon: [512, 512, [], "f7f7", "M507.31 185.71l-181-181a16 16 0 0 0-22.62 0L281 27.31a16 16 0 0 0 0 22.63l181 181a16 16 0 0 0 22.63 0l22.62-22.63a16 16 0 0 0 .06-22.6zm-179.54 66.41l-67.89-67.89 55.1-55.1-45.25-45.25-109.67 109.67a96.08 96.08 0 0 0-25.67 46.29L106.65 360.1l-102 102a16 16 0 0 0 0 22.63l22.62 22.62a16 16 0 0 0 22.63 0l102-102 120.25-27.75a95.88 95.88 0 0 0 46.29-25.65l109.68-109.68L382.87 197zm-54.57 54.57a32 32 0 0 1-15.45 8.54l-79.3 18.32 18.3-79.3a32.22 32.22 0 0 1 8.56-15.45l9.31-9.31 67.89 67.89z"]
};
var faCube = {
  prefix: 'fas',
  iconName: 'cube',
  icon: [512, 512, [], "f1b2", "M239.1 6.3l-208 78c-18.7 7-31.1 25-31.1 45v225.1c0 18.2 10.3 34.8 26.5 42.9l208 104c13.5 6.8 29.4 6.8 42.9 0l208-104c16.3-8.1 26.5-24.8 26.5-42.9V129.3c0-20-12.4-37.9-31.1-44.9l-208-78C262 2.2 250 2.2 239.1 6.3zM256 68.4l192 72v1.1l-192 78-192-78v-1.1l192-72zm32 356V275.5l160-65v133.9l-160 80z"]
};
var faCubes = {
  prefix: 'fas',
  iconName: 'cubes',
  icon: [512, 512, [], "f1b3", "M488.6 250.2L392 214V105.5c0-15-9.3-28.4-23.4-33.7l-100-37.5c-8.1-3.1-17.1-3.1-25.3 0l-100 37.5c-14.1 5.3-23.4 18.7-23.4 33.7V214l-96.6 36.2C9.3 255.5 0 268.9 0 283.9V394c0 13.6 7.7 26.1 19.9 32.2l100 50c10.1 5.1 22.1 5.1 32.2 0l103.9-52 103.9 52c10.1 5.1 22.1 5.1 32.2 0l100-50c12.2-6.1 19.9-18.6 19.9-32.2V283.9c0-15-9.3-28.4-23.4-33.7zM358 214.8l-85 31.9v-68.2l85-37v73.3zM154 104.1l102-38.2 102 38.2v.6l-102 41.4-102-41.4v-.6zm84 291.1l-85 42.5v-79.1l85-38.8v75.4zm0-112l-102 41.4-102-41.4v-.6l102-38.2 102 38.2v.6zm240 112l-85 42.5v-79.1l85-38.8v75.4zm0-112l-102 41.4-102-41.4v-.6l102-38.2 102 38.2v.6z"]
};
var faCut = {
  prefix: 'fas',
  iconName: 'cut',
  icon: [448, 512, [], "f0c4", "M278.06 256L444.48 89.57c4.69-4.69 4.69-12.29 0-16.97-32.8-32.8-85.99-32.8-118.79 0L210.18 188.12l-24.86-24.86c4.31-10.92 6.68-22.81 6.68-35.26 0-53.02-42.98-96-96-96S0 74.98 0 128s42.98 96 96 96c4.54 0 8.99-.32 13.36-.93L142.29 256l-32.93 32.93c-4.37-.61-8.83-.93-13.36-.93-53.02 0-96 42.98-96 96s42.98 96 96 96 96-42.98 96-96c0-12.45-2.37-24.34-6.68-35.26l24.86-24.86L325.69 439.4c32.8 32.8 85.99 32.8 118.79 0 4.69-4.68 4.69-12.28 0-16.97L278.06 256zM96 160c-17.64 0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32zm0 256c-17.64 0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32z"]
};
var faDatabase = {
  prefix: 'fas',
  iconName: 'database',
  icon: [448, 512, [], "f1c0", "M448 73.143v45.714C448 159.143 347.667 192 224 192S0 159.143 0 118.857V73.143C0 32.857 100.333 0 224 0s224 32.857 224 73.143zM448 176v102.857C448 319.143 347.667 352 224 352S0 319.143 0 278.857V176c48.125 33.143 136.208 48.572 224 48.572S399.874 209.143 448 176zm0 160v102.857C448 479.143 347.667 512 224 512S0 479.143 0 438.857V336c48.125 33.143 136.208 48.572 224 48.572S399.874 369.143 448 336z"]
};
var faDeaf = {
  prefix: 'fas',
  iconName: 'deaf',
  icon: [512, 512, [], "f2a4", "M216 260c0 15.464-12.536 28-28 28s-28-12.536-28-28c0-44.112 35.888-80 80-80s80 35.888 80 80c0 15.464-12.536 28-28 28s-28-12.536-28-28c0-13.234-10.767-24-24-24s-24 10.766-24 24zm24-176c-97.047 0-176 78.953-176 176 0 15.464 12.536 28 28 28s28-12.536 28-28c0-66.168 53.832-120 120-120s120 53.832 120 120c0 75.164-71.009 70.311-71.997 143.622L288 404c0 28.673-23.327 52-52 52-15.464 0-28 12.536-28 28s12.536 28 28 28c59.475 0 107.876-48.328 108-107.774.595-34.428 72-48.24 72-144.226 0-97.047-78.953-176-176-176zm268.485-52.201L480.2 3.515c-4.687-4.686-12.284-4.686-16.971 0L376.2 90.544c-4.686 4.686-4.686 12.284 0 16.971l28.285 28.285c4.686 4.686 12.284 4.686 16.97 0l87.03-87.029c4.687-4.688 4.687-12.286 0-16.972zM168.97 314.745c-4.686-4.686-12.284-4.686-16.97 0L3.515 463.23c-4.686 4.686-4.686 12.284 0 16.971L31.8 508.485c4.687 4.686 12.284 4.686 16.971 0L197.256 360c4.686-4.686 4.686-12.284 0-16.971l-28.286-28.284z"]
};
var faDemocrat = {
  prefix: 'fas',
  iconName: 'democrat',
  icon: [640, 512, [], "f747", "M637.3 256.9l-19.6-29.4c-28.2-42.3-75.3-67.5-126.1-67.5H256l-81.2-81.2c20.1-20.1 22.6-51.1 7.5-73.9-3.4-5.2-10.8-5.9-15.2-1.5l-41.8 41.8L82.4 2.4c-3.6-3.6-9.6-3-12.4 1.2-12.3 18.6-10.3 44 6.1 60.4 3.3 3.3 7.3 5.3 11.3 7.5-2.2 1.7-4.7 3.1-6.4 5.4L6.4 176.2c-7.3 9.7-8.4 22.7-3 33.5l14.3 28.6c5.4 10.8 16.5 17.7 28.6 17.7h31c8.5 0 16.6-3.4 22.6-9.4L138 212l54 108h352v-77.8c16.2 12.2 18.3 17.6 40.1 50.3 4.9 7.4 14.8 9.3 22.2 4.4l26.6-17.7c7.3-5 9.3-14.9 4.4-22.3zm-341.1-13.6l-16.5 16.1 3.9 22.7c.7 4.1-3.6 7.2-7.2 5.3L256 276.7l-20.4 10.7c-3.6 1.9-7.9-1.2-7.2-5.3l3.9-22.7-16.5-16.1c-3-2.9-1.3-7.9 2.8-8.5l22.8-3.3 10.2-20.7c1.8-3.7 7.1-3.7 9 0l10.2 20.7 22.8 3.3c4 .6 5.6 5.6 2.6 8.5zm112 0l-16.5 16.1 3.9 22.7c.7 4.1-3.6 7.2-7.2 5.3L368 276.7l-20.4 10.7c-3.6 1.9-7.9-1.2-7.2-5.3l3.9-22.7-16.5-16.1c-3-2.9-1.3-7.9 2.8-8.5l22.8-3.3 10.2-20.7c1.8-3.7 7.1-3.7 9 0l10.2 20.7 22.8 3.3c4 .6 5.6 5.6 2.6 8.5zm112 0l-16.5 16.1 3.9 22.7c.7 4.1-3.6 7.2-7.2 5.3L480 276.7l-20.4 10.7c-3.6 1.9-7.9-1.2-7.2-5.3l3.9-22.7-16.5-16.1c-3-2.9-1.3-7.9 2.8-8.5l22.8-3.3 10.2-20.7c1.8-3.7 7.1-3.7 9 0l10.2 20.7 22.8 3.3c4 .6 5.6 5.6 2.6 8.5zM192 496c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-80h160v80c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V352H192v144z"]
};
var faDesktop = {
  prefix: 'fas',
  iconName: 'desktop',
  icon: [576, 512, [], "f108", "M528 0H48C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h192l-16 48h-72c-13.3 0-24 10.7-24 24s10.7 24 24 24h272c13.3 0 24-10.7 24-24s-10.7-24-24-24h-72l-16-48h192c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zm-16 352H64V64h448v288z"]
};
var faDharmachakra = {
  prefix: 'fas',
  iconName: 'dharmachakra',
  icon: [512, 512, [], "f655", "M495 225.06l-17.22 1.08c-5.27-39.49-20.79-75.64-43.86-105.84l12.95-11.43c6.92-6.11 7.25-16.79.73-23.31L426.44 64.4c-6.53-6.53-17.21-6.19-23.31.73L391.7 78.07c-30.2-23.06-66.35-38.58-105.83-43.86L286.94 17c.58-9.21-6.74-17-15.97-17h-29.94c-9.23 0-16.54 7.79-15.97 17l1.08 17.22c-39.49 5.27-75.64 20.79-105.83 43.86l-11.43-12.95c-6.11-6.92-16.79-7.25-23.31-.73L64.4 85.56c-6.53 6.53-6.19 17.21.73 23.31l12.95 11.43c-23.06 30.2-38.58 66.35-43.86 105.84L17 225.06c-9.21-.58-17 6.74-17 15.97v29.94c0 9.23 7.79 16.54 17 15.97l17.22-1.08c5.27 39.49 20.79 75.64 43.86 105.83l-12.95 11.43c-6.92 6.11-7.25 16.79-.73 23.31l21.17 21.17c6.53 6.53 17.21 6.19 23.31-.73l11.43-12.95c30.2 23.06 66.35 38.58 105.84 43.86L225.06 495c-.58 9.21 6.74 17 15.97 17h29.94c9.23 0 16.54-7.79 15.97-17l-1.08-17.22c39.49-5.27 75.64-20.79 105.84-43.86l11.43 12.95c6.11 6.92 16.79 7.25 23.31.73l21.17-21.17c6.53-6.53 6.19-17.21-.73-23.31l-12.95-11.43c23.06-30.2 38.58-66.35 43.86-105.83l17.22 1.08c9.21.58 17-6.74 17-15.97v-29.94c-.01-9.23-7.8-16.54-17.01-15.97zM281.84 98.61c24.81 4.07 47.63 13.66 67.23 27.78l-42.62 48.29c-8.73-5.44-18.32-9.54-28.62-11.95l4.01-64.12zm-51.68 0l4.01 64.12c-10.29 2.41-19.89 6.52-28.62 11.95l-42.62-48.29c19.6-14.12 42.42-23.71 67.23-27.78zm-103.77 64.33l48.3 42.61c-5.44 8.73-9.54 18.33-11.96 28.62l-64.12-4.01c4.07-24.81 13.66-47.62 27.78-67.22zm-27.78 118.9l64.12-4.01c2.41 10.29 6.52 19.89 11.95 28.62l-48.29 42.62c-14.12-19.6-23.71-42.42-27.78-67.23zm131.55 131.55c-24.81-4.07-47.63-13.66-67.23-27.78l42.61-48.3c8.73 5.44 18.33 9.54 28.62 11.96l-4 64.12zM256 288c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm25.84 125.39l-4.01-64.12c10.29-2.41 19.89-6.52 28.62-11.96l42.61 48.3c-19.6 14.12-42.41 23.71-67.22 27.78zm103.77-64.33l-48.29-42.62c5.44-8.73 9.54-18.32 11.95-28.62l64.12 4.01c-4.07 24.82-13.66 47.64-27.78 67.23zm-36.34-114.89c-2.41-10.29-6.52-19.89-11.96-28.62l48.3-42.61c14.12 19.6 23.71 42.42 27.78 67.23l-64.12 4z"]
};
var faDiagnoses = {
  prefix: 'fas',
  iconName: 'diagnoses',
  icon: [640, 512, [], "f470", "M496 256c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zm-176-80c48.5 0 88-39.5 88-88S368.5 0 320 0s-88 39.5-88 88 39.5 88 88 88zM59.8 364c10.2 15.3 29.3 17.8 42.9 9.8 16.2-9.6 56.2-31.7 105.3-48.6V416h224v-90.7c49.1 16.8 89.1 39 105.3 48.6 13.6 8 32.7 5.3 42.9-9.8l17.8-26.7c8.8-13.2 7.6-34.6-10-45.1-11.9-7.1-29.7-17-51.1-27.4-28.1 46.1-99.4 17.8-87.7-35.1C409.3 217.2 365.1 208 320 208c-57 0-112.9 14.5-160 32.2-.2 40.2-47.6 63.3-79.2 36-11.2 6-21.3 11.6-28.7 16-17.6 10.5-18.8 31.8-10 45.1L59.8 364zM368 344c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm-96-96c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm-160 8c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zm512 192H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"]
};
var faDice = {
  prefix: 'fas',
  iconName: 'dice',
  icon: [640, 512, [], "f522", "M592 192H473.26c12.69 29.59 7.12 65.2-17 89.32L320 417.58V464c0 26.51 21.49 48 48 48h224c26.51 0 48-21.49 48-48V240c0-26.51-21.49-48-48-48zM480 376c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm-46.37-186.7L258.7 14.37c-19.16-19.16-50.23-19.16-69.39 0L14.37 189.3c-19.16 19.16-19.16 50.23 0 69.39L189.3 433.63c19.16 19.16 50.23 19.16 69.39 0L433.63 258.7c19.16-19.17 19.16-50.24 0-69.4zM96 248c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm128 128c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm0-128c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm0-128c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm128 128c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"]
};
var faDiceD20 = {
  prefix: 'fas',
  iconName: 'dice-d20',
  icon: [480, 512, [], "f6cf", "M106.75 215.06L1.2 370.95c-3.08 5 .1 11.5 5.93 12.14l208.26 22.07-108.64-190.1zM7.41 315.43L82.7 193.08 6.06 147.1c-2.67-1.6-6.06.32-6.06 3.43v162.81c0 4.03 5.29 5.53 7.41 2.09zM18.25 423.6l194.4 87.66c5.3 2.45 11.35-1.43 11.35-7.26v-65.67l-203.55-22.3c-4.45-.5-6.23 5.59-2.2 7.57zm81.22-257.78L179.4 22.88c4.34-7.06-3.59-15.25-10.78-11.14L17.81 110.35c-2.47 1.62-2.39 5.26.13 6.78l81.53 48.69zM240 176h109.21L253.63 7.62C250.5 2.54 245.25 0 240 0s-10.5 2.54-13.63 7.62L130.79 176H240zm233.94-28.9l-76.64 45.99 75.29 122.35c2.11 3.44 7.41 1.94 7.41-2.1V150.53c0-3.11-3.39-5.03-6.06-3.43zm-93.41 18.72l81.53-48.7c2.53-1.52 2.6-5.16.13-6.78l-150.81-98.6c-7.19-4.11-15.12 4.08-10.78 11.14l79.93 142.94zm79.02 250.21L256 438.32v65.67c0 5.84 6.05 9.71 11.35 7.26l194.4-87.66c4.03-1.97 2.25-8.06-2.2-7.56zm-86.3-200.97l-108.63 190.1 208.26-22.07c5.83-.65 9.01-7.14 5.93-12.14L373.25 215.06zM240 208H139.57L240 383.75 340.43 208H240z"]
};
var faDiceD6 = {
  prefix: 'fas',
  iconName: 'dice-d6',
  icon: [448, 512, [], "f6d1", "M422.19 109.95L256.21 9.07c-19.91-12.1-44.52-12.1-64.43 0L25.81 109.95c-5.32 3.23-5.29 11.27.06 14.46L224 242.55l198.14-118.14c5.35-3.19 5.38-11.22.05-14.46zm13.84 44.63L240 271.46v223.82c0 12.88 13.39 20.91 24.05 14.43l152.16-92.48c19.68-11.96 31.79-33.94 31.79-57.7v-197.7c0-6.41-6.64-10.43-11.97-7.25zM0 161.83v197.7c0 23.77 12.11 45.74 31.79 57.7l152.16 92.47c10.67 6.48 24.05-1.54 24.05-14.43V271.46L11.97 154.58C6.64 151.4 0 155.42 0 161.83z"]
};
var faDiceFive = {
  prefix: 'fas',
  iconName: 'dice-five',
  icon: [448, 512, [], "f523", "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm96 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm96 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"]
};
var faDiceFour = {
  prefix: 'fas',
  iconName: 'dice-four',
  icon: [448, 512, [], "f524", "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm192 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"]
};
var faDiceOne = {
  prefix: 'fas',
  iconName: 'dice-one',
  icon: [448, 512, [], "f525", "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM224 288c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"]
};
var faDiceSix = {
  prefix: 'fas',
  iconName: 'dice-six',
  icon: [448, 512, [], "f526", "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm192 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"]
};
var faDiceThree = {
  prefix: 'fas',
  iconName: 'dice-three',
  icon: [448, 512, [], "f527", "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm96 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm96 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"]
};
var faDiceTwo = {
  prefix: 'fas',
  iconName: 'dice-two',
  icon: [448, 512, [], "f528", "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm192 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"]
};
var faDigitalTachograph = {
  prefix: 'fas',
  iconName: 'digital-tachograph',
  icon: [640, 512, [], "f566", "M608 96H32c-17.67 0-32 14.33-32 32v256c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V128c0-17.67-14.33-32-32-32zM304 352c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-8c0-4.42 3.58-8 8-8h224c4.42 0 8 3.58 8 8v8zM72 288v-16c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H80c-4.42 0-8-3.58-8-8zm64 0v-16c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8zm64 0v-16c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8zm64 0v-16c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8zm40-64c0 8.84-7.16 16-16 16H80c-8.84 0-16-7.16-16-16v-48c0-8.84 7.16-16 16-16h208c8.84 0 16 7.16 16 16v48zm272 128c0 4.42-3.58 8-8 8H344c-4.42 0-8-3.58-8-8v-8c0-4.42 3.58-8 8-8h224c4.42 0 8 3.58 8 8v8z"]
};
var faDirections = {
  prefix: 'fas',
  iconName: 'directions',
  icon: [512, 512, [], "f5eb", "M502.61 233.32L278.68 9.39c-12.52-12.52-32.83-12.52-45.36 0L9.39 233.32c-12.52 12.53-12.52 32.83 0 45.36l223.93 223.93c12.52 12.53 32.83 12.53 45.36 0l223.93-223.93c12.52-12.53 12.52-32.83 0-45.36zm-100.98 12.56l-84.21 77.73c-5.12 4.73-13.43 1.1-13.43-5.88V264h-96v64c0 4.42-3.58 8-8 8h-32c-4.42 0-8-3.58-8-8v-80c0-17.67 14.33-32 32-32h112v-53.73c0-6.97 8.3-10.61 13.43-5.88l84.21 77.73c3.43 3.17 3.43 8.59 0 11.76z"]
};
var faDisease = {
  prefix: 'fas',
  iconName: 'disease',
  icon: [512, 512, [], "f7fa", "M472.29 195.9l-67.06-23c-19.28-6.6-33.54-20.92-38.14-38.31l-16-60.45c-11.58-43.77-76.57-57.13-110-22.62L195 99.24c-13.26 13.71-33.54 20.93-54.2 19.31l-71.9-5.62c-52-4.07-86.93 44.89-59 82.84l38.54 52.42c11.08 15.07 12.82 33.86 4.64 50.24l-28.43 57C4 396.67 47.46 440.29 98.11 429.23l70-15.28c20.11-4.39 41.45 0 57.07 11.73l54.32 40.83c39.32 29.56 101 7.57 104.45-37.22l4.7-61.86c1.35-17.8 12.8-33.87 30.63-43l62-31.74c44.84-22.96 39.55-80.17-8.99-96.79zM160 256a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm128 96a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm16-128a16 16 0 1 1 16-16 16 16 0 0 1-16 16z"]
};
var faDivide = {
  prefix: 'fas',
  iconName: 'divide',
  icon: [448, 512, [], "f529", "M224 352c-35.35 0-64 28.65-64 64s28.65 64 64 64 64-28.65 64-64-28.65-64-64-64zm0-192c35.35 0 64-28.65 64-64s-28.65-64-64-64-64 28.65-64 64 28.65 64 64 64zm192 48H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"]
};
var faDizzy = {
  prefix: 'fas',
  iconName: 'dizzy',
  icon: [496, 512, [], "f567", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-96 206.6l-28.7 28.7c-14.8 14.8-37.8-7.5-22.6-22.6l28.7-28.7-28.7-28.7c-15-15 7.7-37.6 22.6-22.6l28.7 28.7 28.7-28.7c15-15 37.6 7.7 22.6 22.6L174.6 192l28.7 28.7c15.2 15.2-7.9 37.4-22.6 22.6L152 214.6zM248 416c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm147.3-195.3c15.2 15.2-7.9 37.4-22.6 22.6L344 214.6l-28.7 28.7c-14.8 14.8-37.8-7.5-22.6-22.6l28.7-28.7-28.7-28.7c-15-15 7.7-37.6 22.6-22.6l28.7 28.7 28.7-28.7c15-15 37.6 7.7 22.6 22.6L366.6 192l28.7 28.7z"]
};
var faDna = {
  prefix: 'fas',
  iconName: 'dna',
  icon: [448, 512, [], "f471", "M.1 494.1c-1.1 9.5 6.3 17.8 15.9 17.8l32.3.1c8.1 0 14.9-5.9 16-13.9.7-4.9 1.8-11.1 3.4-18.1H380c1.6 6.9 2.9 13.2 3.5 18.1 1.1 8 7.9 14 16 13.9l32.3-.1c9.6 0 17.1-8.3 15.9-17.8-4.6-37.9-25.6-129-118.9-207.7-17.6 12.4-37.1 24.2-58.5 35.4 6.2 4.6 11.4 9.4 17 14.2H159.7c21.3-18.1 47-35.6 78.7-51.4C410.5 199.1 442.1 65.8 447.9 17.9 449 8.4 441.6.1 432 .1L399.6 0c-8.1 0-14.9 5.9-16 13.9-.7 4.9-1.8 11.1-3.4 18.1H67.8c-1.6-7-2.7-13.1-3.4-18.1-1.1-8-7.9-14-16-13.9L16.1.1C6.5.1-1 8.4.1 17.9 5.3 60.8 31.4 171.8 160 256 31.5 340.2 5.3 451.2.1 494.1zM224 219.6c-25.1-13.7-46.4-28.4-64.3-43.6h128.5c-17.8 15.2-39.1 30-64.2 43.6zM355.1 96c-5.8 10.4-12.8 21.1-21 32H114c-8.3-10.9-15.3-21.6-21-32h262.1zM92.9 416c5.8-10.4 12.8-21.1 21-32h219.4c8.3 10.9 15.4 21.6 21.2 32H92.9z"]
};
var faDog = {
  prefix: 'fas',
  iconName: 'dog',
  icon: [576, 512, [], "f6d3", "M298.06,224,448,277.55V496a16,16,0,0,1-16,16H368a16,16,0,0,1-16-16V384H192V496a16,16,0,0,1-16,16H112a16,16,0,0,1-16-16V282.09C58.84,268.84,32,233.66,32,192a32,32,0,0,1,64,0,32.06,32.06,0,0,0,32,32ZM544,112v32a64,64,0,0,1-64,64H448v35.58L320,197.87V48c0-14.25,17.22-21.39,27.31-11.31L374.59,64h53.63c10.91,0,23.75,7.92,28.62,17.69L464,96h64A16,16,0,0,1,544,112Zm-112,0a16,16,0,1,0-16,16A16,16,0,0,0,432,112Z"]
};
var faDollarSign = {
  prefix: 'fas',
  iconName: 'dollar-sign',
  icon: [288, 512, [], "f155", "M209.2 233.4l-108-31.6C88.7 198.2 80 186.5 80 173.5c0-16.3 13.2-29.5 29.5-29.5h66.3c12.2 0 24.2 3.7 34.2 10.5 6.1 4.1 14.3 3.1 19.5-2l34.8-34c7.1-6.9 6.1-18.4-1.8-24.5C238 74.8 207.4 64.1 176 64V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48h-2.5C45.8 64-5.4 118.7.5 183.6c4.2 46.1 39.4 83.6 83.8 96.6l102.5 30c12.5 3.7 21.2 15.3 21.2 28.3 0 16.3-13.2 29.5-29.5 29.5h-66.3C100 368 88 364.3 78 357.5c-6.1-4.1-14.3-3.1-19.5 2l-34.8 34c-7.1 6.9-6.1 18.4 1.8 24.5 24.5 19.2 55.1 29.9 86.5 30v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-48.2c46.6-.9 90.3-28.6 105.7-72.7 21.5-61.6-14.6-124.8-72.5-141.7z"]
};
var faDolly = {
  prefix: 'fas',
  iconName: 'dolly',
  icon: [576, 512, [], "f472", "M294.2 277.7c18 5 34.7 13.4 49.5 24.7l161.5-53.8c8.4-2.8 12.9-11.9 10.1-20.2L454.9 47.2c-2.8-8.4-11.9-12.9-20.2-10.1l-61.1 20.4 33.1 99.4L346 177l-33.1-99.4-61.6 20.5c-8.4 2.8-12.9 11.9-10.1 20.2l53 159.4zm281 48.7L565 296c-2.8-8.4-11.9-12.9-20.2-10.1l-213.5 71.2c-17.2-22-43.6-36.4-73.5-37L158.4 21.9C154 8.8 141.8 0 128 0H16C7.2 0 0 7.2 0 16v32c0 8.8 7.2 16 16 16h88.9l92.2 276.7c-26.1 20.4-41.7 53.6-36 90.5 6.1 39.4 37.9 72.3 77.3 79.2 60.2 10.7 112.3-34.8 113.4-92.6l213.3-71.2c8.3-2.8 12.9-11.8 10.1-20.2zM256 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"]
};
var faDollyFlatbed = {
  prefix: 'fas',
  iconName: 'dolly-flatbed',
  icon: [640, 512, [], "f474", "M208 320h384c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H448v128l-48-32-48 32V32H208c-8.8 0-16 7.2-16 16v256c0 8.8 7.2 16 16 16zm416 64H128V16c0-8.8-7.2-16-16-16H16C7.2 0 0 7.2 0 16v32c0 8.8 7.2 16 16 16h48v368c0 8.8 7.2 16 16 16h82.9c-1.8 5-2.9 10.4-2.9 16 0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1.2-11-2.9-16H451c-1.8 5-2.9 10.4-2.9 16 0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1.2-11-2.9-16H624c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"]
};
var faDonate = {
  prefix: 'fas',
  iconName: 'donate',
  icon: [512, 512, [], "f4b9", "M256 416c114.9 0 208-93.1 208-208S370.9 0 256 0 48 93.1 48 208s93.1 208 208 208zM233.8 97.4V80.6c0-9.2 7.4-16.6 16.6-16.6h11.1c9.2 0 16.6 7.4 16.6 16.6v17c15.5.8 30.5 6.1 43 15.4 5.6 4.1 6.2 12.3 1.2 17.1L306 145.6c-3.8 3.7-9.5 3.8-14 1-5.4-3.4-11.4-5.1-17.8-5.1h-38.9c-9 0-16.3 8.2-16.3 18.3 0 8.2 5 15.5 12.1 17.6l62.3 18.7c25.7 7.7 43.7 32.4 43.7 60.1 0 34-26.4 61.5-59.1 62.4v16.8c0 9.2-7.4 16.6-16.6 16.6h-11.1c-9.2 0-16.6-7.4-16.6-16.6v-17c-15.5-.8-30.5-6.1-43-15.4-5.6-4.1-6.2-12.3-1.2-17.1l16.3-15.5c3.8-3.7 9.5-3.8 14-1 5.4 3.4 11.4 5.1 17.8 5.1h38.9c9 0 16.3-8.2 16.3-18.3 0-8.2-5-15.5-12.1-17.6l-62.3-18.7c-25.7-7.7-43.7-32.4-43.7-60.1.1-34 26.4-61.5 59.1-62.4zM480 352h-32.5c-19.6 26-44.6 47.7-73 64h63.8c5.3 0 9.6 3.6 9.6 8v16c0 4.4-4.3 8-9.6 8H73.6c-5.3 0-9.6-3.6-9.6-8v-16c0-4.4 4.3-8 9.6-8h63.8c-28.4-16.3-53.3-38-73-64H32c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32v-96c0-17.7-14.3-32-32-32z"]
};
var faDoorClosed = {
  prefix: 'fas',
  iconName: 'door-closed',
  icon: [640, 512, [], "f52a", "M624 448H512V50.8C512 22.78 490.47 0 464 0H175.99c-26.47 0-48 22.78-48 50.8V448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM415.99 288c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32c.01 17.67-14.32 32-32 32z"]
};
var faDoorOpen = {
  prefix: 'fas',
  iconName: 'door-open',
  icon: [640, 512, [], "f52b", "M624 448h-80V113.45C544 86.19 522.47 64 496 64H384v64h96v384h144c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM312.24 1.01l-192 49.74C105.99 54.44 96 67.7 96 82.92V448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h336V33.18c0-21.58-19.56-37.41-39.76-32.17zM264 288c-13.25 0-24-14.33-24-32s10.75-32 24-32 24 14.33 24 32-10.75 32-24 32z"]
};
var faDotCircle = {
  prefix: 'fas',
  iconName: 'dot-circle',
  icon: [512, 512, [], "f192", "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm80 248c0 44.112-35.888 80-80 80s-80-35.888-80-80 35.888-80 80-80 80 35.888 80 80z"]
};
var faDove = {
  prefix: 'fas',
  iconName: 'dove',
  icon: [512, 512, [], "f4ba", "M288 167.2v-28.1c-28.2-36.3-47.1-79.3-54.1-125.2-2.1-13.5-19-18.8-27.8-8.3-21.1 24.9-37.7 54.1-48.9 86.5 34.2 38.3 80 64.6 130.8 75.1zM400 64c-44.2 0-80 35.9-80 80.1v59.4C215.6 197.3 127 133 87 41.8c-5.5-12.5-23.2-13.2-29-.9C41.4 76 32 115.2 32 156.6c0 70.8 34.1 136.9 85.1 185.9 13.2 12.7 26.1 23.2 38.9 32.8l-143.9 36C1.4 414-3.4 426.4 2.6 435.7 20 462.6 63 508.2 155.8 512c8 .3 16-2.6 22.1-7.9l65.2-56.1H320c88.4 0 160-71.5 160-159.9V128l32-64H400zm0 96.1c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"]
};
var faDownload = {
  prefix: 'fas',
  iconName: 'download',
  icon: [512, 512, [], "f019", "M216 0h80c13.3 0 24 10.7 24 24v168h87.7c17.8 0 26.7 21.5 14.1 34.1L269.7 378.3c-7.5 7.5-19.8 7.5-27.3 0L90.1 226.1c-12.6-12.6-3.7-34.1 14.1-34.1H192V24c0-13.3 10.7-24 24-24zm296 376v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h146.7l49 49c20.1 20.1 52.5 20.1 72.6 0l49-49H488c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z"]
};
var faDraftingCompass = {
  prefix: 'fas',
  iconName: 'drafting-compass',
  icon: [512, 512, [], "f568", "M457.01 344.42c-25.05 20.33-52.63 37.18-82.54 49.05l54.38 94.19 53.95 23.04c9.81 4.19 20.89-2.21 22.17-12.8l7.02-58.25-54.98-95.23zm42.49-94.56c4.86-7.67 1.89-17.99-6.05-22.39l-28.07-15.57c-7.48-4.15-16.61-1.46-21.26 5.72C403.01 281.15 332.25 320 256 320c-23.93 0-47.23-4.25-69.41-11.53l67.36-116.68c.7.02 1.34.21 2.04.21s1.35-.19 2.04-.21l51.09 88.5c31.23-8.96 59.56-25.75 82.61-48.92l-51.79-89.71C347.39 128.03 352 112.63 352 96c0-53.02-42.98-96-96-96s-96 42.98-96 96c0 16.63 4.61 32.03 12.05 45.66l-68.3 118.31c-12.55-11.61-23.96-24.59-33.68-39-4.79-7.1-13.97-9.62-21.38-5.33l-27.75 16.07c-7.85 4.54-10.63 14.9-5.64 22.47 15.57 23.64 34.69 44.21 55.98 62.02L0 439.66l7.02 58.25c1.28 10.59 12.36 16.99 22.17 12.8l53.95-23.04 70.8-122.63C186.13 377.28 220.62 384 256 384c99.05 0 190.88-51.01 243.5-134.14zM256 64c17.67 0 32 14.33 32 32s-14.33 32-32 32-32-14.33-32-32 14.33-32 32-32z"]
};
var faDragon = {
  prefix: 'fas',
  iconName: 'dragon',
  icon: [640, 512, [], "f6d5", "M18.32 255.78L192 223.96l-91.28 68.69c-10.08 10.08-2.94 27.31 11.31 27.31h222.7c-9.44-26.4-14.73-54.47-14.73-83.38v-42.27l-119.73-87.6c-23.82-15.88-55.29-14.01-77.06 4.59L5.81 227.64c-12.38 10.33-3.45 30.42 12.51 28.14zm556.87 34.1l-100.66-50.31A47.992 47.992 0 0 1 448 196.65v-36.69h64l28.09 22.63c6 6 14.14 9.37 22.63 9.37h30.97a32 32 0 0 0 28.62-17.69l14.31-28.62a32.005 32.005 0 0 0-3.02-33.51l-74.53-99.38C553.02 4.7 543.54 0 533.47 0H296.02c-7.13 0-10.7 8.57-5.66 13.61L352 63.96 292.42 88.8c-5.9 2.95-5.9 11.36 0 14.31L352 127.96v108.62c0 72.08 36.03 139.39 96 179.38-195.59 6.81-344.56 41.01-434.1 60.91C5.78 478.67 0 485.88 0 494.2 0 504 7.95 512 17.76 512h499.08c63.29.01 119.61-47.56 122.99-110.76 2.52-47.28-22.73-90.4-64.64-111.36zM489.18 66.25l45.65 11.41c-2.75 10.91-12.47 18.89-24.13 18.26-12.96-.71-25.85-12.53-21.52-29.67z"]
};
var faDrawPolygon = {
  prefix: 'fas',
  iconName: 'draw-polygon',
  icon: [448, 512, [], "f5ee", "M384 352c-.35 0-.67.1-1.02.1l-39.2-65.32c5.07-9.17 8.22-19.56 8.22-30.78s-3.14-21.61-8.22-30.78l39.2-65.32c.35.01.67.1 1.02.1 35.35 0 64-28.65 64-64s-28.65-64-64-64c-23.63 0-44.04 12.95-55.12 32H119.12C108.04 44.95 87.63 32 64 32 28.65 32 0 60.65 0 96c0 23.63 12.95 44.04 32 55.12v209.75C12.95 371.96 0 392.37 0 416c0 35.35 28.65 64 64 64 23.63 0 44.04-12.95 55.12-32h209.75c11.09 19.05 31.49 32 55.12 32 35.35 0 64-28.65 64-64 .01-35.35-28.64-64-63.99-64zm-288 8.88V151.12A63.825 63.825 0 0 0 119.12 128h208.36l-38.46 64.1c-.35-.01-.67-.1-1.02-.1-35.35 0-64 28.65-64 64s28.65 64 64 64c.35 0 .67-.1 1.02-.1l38.46 64.1H119.12A63.748 63.748 0 0 0 96 360.88zM272 256c0-8.82 7.18-16 16-16s16 7.18 16 16-7.18 16-16 16-16-7.18-16-16zM400 96c0 8.82-7.18 16-16 16s-16-7.18-16-16 7.18-16 16-16 16 7.18 16 16zM64 80c8.82 0 16 7.18 16 16s-7.18 16-16 16-16-7.18-16-16 7.18-16 16-16zM48 416c0-8.82 7.18-16 16-16s16 7.18 16 16-7.18 16-16 16-16-7.18-16-16zm336 16c-8.82 0-16-7.18-16-16s7.18-16 16-16 16 7.18 16 16-7.18 16-16 16z"]
};
var faDrum = {
  prefix: 'fas',
  iconName: 'drum',
  icon: [512, 512, [], "f569", "M431.34 122.05l73.53-47.42a16 16 0 0 0 4.44-22.19l-8.87-13.31a16 16 0 0 0-22.19-4.44l-110.06 71C318.43 96.91 271.22 96 256 96 219.55 96 0 100.55 0 208.15v160.23c0 30.27 27.5 57.68 72 77.86v-101.9a24 24 0 1 1 48 0v118.93c33.05 9.11 71.07 15.06 112 16.73V376.39a24 24 0 1 1 48 0V480c40.93-1.67 78.95-7.62 112-16.73V344.34a24 24 0 1 1 48 0v101.9c44.5-20.18 72-47.59 72-77.86V208.15c0-43.32-35.76-69.76-80.66-86.1zM256 272.24c-114.88 0-208-28.69-208-64.09s93.12-64.08 208-64.08c17.15 0 33.73.71 49.68 1.91l-72.81 47a16 16 0 0 0-4.43 22.19l8.87 13.31a16 16 0 0 0 22.19 4.44l118.64-76.52C430.09 168 464 186.84 464 208.15c0 35.4-93.13 64.09-208 64.09z"]
};
var faDrumSteelpan = {
  prefix: 'fas',
  iconName: 'drum-steelpan',
  icon: [576, 512, [], "f56a", "M288 32C128.94 32 0 89.31 0 160v192c0 70.69 128.94 128 288 128s288-57.31 288-128V160c0-70.69-128.94-128-288-128zm-82.99 158.36c-4.45 16.61-14.54 30.57-28.31 40.48C100.23 217.46 48 190.78 48 160c0-30.16 50.11-56.39 124.04-70.03l25.6 44.34c9.86 17.09 12.48 36.99 7.37 56.05zM288 240c-21.08 0-41.41-1-60.89-2.7 8.06-26.13 32.15-45.3 60.89-45.3s52.83 19.17 60.89 45.3C329.41 239 309.08 240 288 240zm64-144c0 35.29-28.71 64-64 64s-64-28.71-64-64V82.96c20.4-1.88 41.8-2.96 64-2.96s43.6 1.08 64 2.96V96zm46.93 134.9c-13.81-9.91-23.94-23.9-28.4-40.54-5.11-19.06-2.49-38.96 7.38-56.04l25.65-44.42C477.72 103.5 528 129.79 528 160c0 30.83-52.4 57.54-129.07 70.9z"]
};
var faDrumstickBite = {
  prefix: 'fas',
  iconName: 'drumstick-bite',
  icon: [512, 512, [], "f6d7", "M462.8 49.57a169.44 169.44 0 0 0-239.5 0C187.82 85 160.13 128 160.13 192v85.83l-40.62 40.59c-9.7 9.69-24 11.07-36.78 6a60.33 60.33 0 0 0-65 98.72C33 438.39 54.24 442.7 73.85 438.21c-4.5 19.6-.18 40.83 15.1 56.1a60.35 60.35 0 0 0 98.8-65c-5.09-12.73-3.72-27 6-36.75L234.36 352h85.89a187.87 187.87 0 0 0 61.89-10c-39.64-43.89-39.83-110.23 1.05-151.07 34.38-34.36 86.76-39.46 128.74-16.8 1.3-44.96-14.81-90.28-49.13-124.56z"]
};
var faDumbbell = {
  prefix: 'fas',
  iconName: 'dumbbell',
  icon: [640, 512, [], "f44b", "M104 96H56c-13.3 0-24 10.7-24 24v104H8c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h24v104c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24zm528 128h-24V120c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24v272c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V288h24c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM456 32h-48c-13.3 0-24 10.7-24 24v168H256V56c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24v400c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V288h128v168c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24z"]
};
var faDumpster = {
  prefix: 'fas',
  iconName: 'dumpster',
  icon: [576, 512, [], "f793", "M560 160c10.4 0 18-9.8 15.5-19.9l-24-96C549.7 37 543.3 32 536 32h-98.9l25.6 128H560zM272 32H171.5l-25.6 128H272V32zm132.5 0H304v128h126.1L404.5 32zM16 160h97.3l25.6-128H40c-7.3 0-13.7 5-15.5 12.1l-24 96C-2 150.2 5.6 160 16 160zm544 64h-20l4-32H32l4 32H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h28l20 160v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h320v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16l20-160h28c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"]
};
var faDumpsterFire = {
  prefix: 'fas',
  iconName: 'dumpster-fire',
  icon: [640, 512, [], "f794", "M418.7 104.1l.2-.2-14.4-72H304v128h60.8c16.2-19.3 34.2-38.2 53.9-55.8zM272 32H171.5l-25.6 128H272V32zm189.3 72.1c18.2 16.3 35.5 33.7 51.1 51.5 5.7-5.6 11.4-11.1 17.3-16.3l21.3-19 21.3 19c1.1.9 2.1 2.1 3.1 3.1-.1-.8.2-1.5 0-2.3l-24-96C549.7 37 543.3 32 536 32h-98.9l12.3 61.5 11.9 10.6zM16 160h97.3l25.6-128H40c-7.3 0-13.7 5-15.5 12.1l-24 96C-2 150.2 5.6 160 16 160zm324.6 32H32l4 32H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h28l20 160v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h208.8c-30.2-33.7-48.8-77.9-48.8-126.4 0-35.9 19.9-82.9 52.6-129.6zm210.5-28.8c-14.9 13.3-28.3 27.2-40.2 41.2-19.5-25.8-43.6-52-71-76.4-70.2 62.7-120 144.3-120 193.6 0 87.5 71.6 158.4 160 158.4s160-70.9 160-158.4c.1-36.6-37-112.2-88.8-158.4zm-18.6 229.4c-14.7 10.7-32.9 17-52.5 17-49 0-88.9-33.5-88.9-88 0-27.1 16.5-51 49.4-91.9 4.7 5.6 67.1 88.1 67.1 88.1l39.8-47c2.8 4.8 5.4 9.5 7.7 14 18.6 36.7 10.8 83.6-22.6 107.8z"]
};
var faDungeon = {
  prefix: 'fas',
  iconName: 'dungeon',
  icon: [512, 512, [], "f6d9", "M128.73 195.32l-82.81-51.76c-8.04-5.02-18.99-2.17-22.93 6.45A254.19 254.19 0 0 0 .54 239.28C-.05 248.37 7.59 256 16.69 256h97.13c7.96 0 14.08-6.25 15.01-14.16 1.09-9.33 3.24-18.33 6.24-26.94 2.56-7.34.25-15.46-6.34-19.58zM319.03 8C298.86 2.82 277.77 0 256 0s-42.86 2.82-63.03 8c-9.17 2.35-13.91 12.6-10.39 21.39l37.47 104.03A16.003 16.003 0 0 0 235.1 144h41.8c6.75 0 12.77-4.23 15.05-10.58l37.47-104.03c3.52-8.79-1.22-19.03-10.39-21.39zM112 288H16c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h96c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zm0 128H16c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h96c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zm77.31-283.67l-36.32-90.8c-3.53-8.83-14.13-12.99-22.42-8.31a257.308 257.308 0 0 0-71.61 59.89c-6.06 7.32-3.85 18.48 4.22 23.52l82.93 51.83c6.51 4.07 14.66 2.62 20.11-2.79 5.18-5.15 10.79-9.85 16.79-14.05 6.28-4.41 9.15-12.17 6.3-19.29zM398.18 256h97.13c9.1 0 16.74-7.63 16.15-16.72a254.135 254.135 0 0 0-22.45-89.27c-3.94-8.62-14.89-11.47-22.93-6.45l-82.81 51.76c-6.59 4.12-8.9 12.24-6.34 19.58 3.01 8.61 5.15 17.62 6.24 26.94.93 7.91 7.05 14.16 15.01 14.16zm54.85-162.89a257.308 257.308 0 0 0-71.61-59.89c-8.28-4.68-18.88-.52-22.42 8.31l-36.32 90.8c-2.85 7.12.02 14.88 6.3 19.28 6 4.2 11.61 8.9 16.79 14.05 5.44 5.41 13.6 6.86 20.11 2.79l82.93-51.83c8.07-5.03 10.29-16.19 4.22-23.51zM496 288h-96c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h96c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zm0 128h-96c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h96c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zM240 177.62V472c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V177.62c-5.23-.89-10.52-1.62-16-1.62s-10.77.73-16 1.62zm-64 41.51V472c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V189.36c-12.78 7.45-23.84 17.47-32 29.77zm128-29.77V472c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V219.13c-8.16-12.3-19.22-22.32-32-29.77z"]
};
var faEdit = {
  prefix: 'fas',
  iconName: 'edit',
  icon: [576, 512, [], "f044", "M402.6 83.2l90.2 90.2c3.8 3.8 3.8 10 0 13.8L274.4 405.6l-92.8 10.3c-12.4 1.4-22.9-9.1-21.5-21.5l10.3-92.8L388.8 83.2c3.8-3.8 10-3.8 13.8 0zm162-22.9l-48.8-48.8c-15.2-15.2-39.9-15.2-55.2 0l-35.4 35.4c-3.8 3.8-3.8 10 0 13.8l90.2 90.2c3.8 3.8 10 3.8 13.8 0l35.4-35.4c15.2-15.3 15.2-40 0-55.2zM384 346.2V448H64V128h229.8c3.2 0 6.2-1.3 8.5-3.5l40-40c7.6-7.6 2.2-20.5-8.5-20.5H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V306.2c0-10.7-12.9-16-20.5-8.5l-40 40c-2.2 2.3-3.5 5.3-3.5 8.5z"]
};
var faEgg = {
  prefix: 'fas',
  iconName: 'egg',
  icon: [384, 512, [], "f7fb", "M192 0C86 0 0 214 0 320s86 192 192 192 192-86 192-192S298 0 192 0z"]
};
var faEject = {
  prefix: 'fas',
  iconName: 'eject',
  icon: [448, 512, [], "f052", "M448 384v64c0 17.673-14.327 32-32 32H32c-17.673 0-32-14.327-32-32v-64c0-17.673 14.327-32 32-32h384c17.673 0 32 14.327 32 32zM48.053 320h351.886c41.651 0 63.581-49.674 35.383-80.435L259.383 47.558c-19.014-20.743-51.751-20.744-70.767 0L12.67 239.565C-15.475 270.268 6.324 320 48.053 320z"]
};
var faEllipsisH = {
  prefix: 'fas',
  iconName: 'ellipsis-h',
  icon: [512, 512, [], "f141", "M328 256c0 39.8-32.2 72-72 72s-72-32.2-72-72 32.2-72 72-72 72 32.2 72 72zm104-72c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72zm-352 0c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72z"]
};
var faEllipsisV = {
  prefix: 'fas',
  iconName: 'ellipsis-v',
  icon: [192, 512, [], "f142", "M96 184c39.8 0 72 32.2 72 72s-32.2 72-72 72-72-32.2-72-72 32.2-72 72-72zM24 80c0 39.8 32.2 72 72 72s72-32.2 72-72S135.8 8 96 8 24 40.2 24 80zm0 352c0 39.8 32.2 72 72 72s72-32.2 72-72-32.2-72-72-72-72 32.2-72 72z"]
};
var faEnvelope = {
  prefix: 'fas',
  iconName: 'envelope',
  icon: [512, 512, [], "f0e0", "M502.3 190.8c3.9-3.1 9.7-.2 9.7 4.7V400c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V195.6c0-5 5.7-7.8 9.7-4.7 22.4 17.4 52.1 39.5 154.1 113.6 21.1 15.4 56.7 47.8 92.2 47.6 35.7.3 72-32.8 92.3-47.6 102-74.1 131.6-96.3 154-113.7zM256 320c23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7 5.8-4.5 9.2-11.5 9.2-18.9v-19c0-26.5-21.5-48-48-48H48C21.5 64 0 85.5 0 112v19c0 7.4 3.4 14.3 9.2 18.9 30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4z"]
};
var faEnvelopeOpen = {
  prefix: 'fas',
  iconName: 'envelope-open',
  icon: [512, 512, [], "f2b6", "M512 464c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V200.724a48 48 0 0 1 18.387-37.776c24.913-19.529 45.501-35.365 164.2-121.511C199.412 29.17 232.797-.347 256 .003c23.198-.354 56.596 29.172 73.413 41.433 118.687 86.137 139.303 101.995 164.2 121.512A48 48 0 0 1 512 200.724V464zm-65.666-196.605c-2.563-3.728-7.7-4.595-11.339-1.907-22.845 16.873-55.462 40.705-105.582 77.079-16.825 12.266-50.21 41.781-73.413 41.43-23.211.344-56.559-29.143-73.413-41.43-50.114-36.37-82.734-60.204-105.582-77.079-3.639-2.688-8.776-1.821-11.339 1.907l-9.072 13.196a7.998 7.998 0 0 0 1.839 10.967c22.887 16.899 55.454 40.69 105.303 76.868 20.274 14.781 56.524 47.813 92.264 47.573 35.724.242 71.961-32.771 92.263-47.573 49.85-36.179 82.418-59.97 105.303-76.868a7.998 7.998 0 0 0 1.839-10.967l-9.071-13.196z"]
};
var faEnvelopeOpenText = {
  prefix: 'fas',
  iconName: 'envelope-open-text',
  icon: [512, 512, [], "f658", "M176 216h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16H176c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16zm-16 80c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16H176c-8.84 0-16 7.16-16 16v16zm96 121.13c-16.42 0-32.84-5.06-46.86-15.19L0 250.86V464c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V250.86L302.86 401.94c-14.02 10.12-30.44 15.19-46.86 15.19zm237.61-254.18c-8.85-6.94-17.24-13.47-29.61-22.81V96c0-26.51-21.49-48-48-48h-77.55c-3.04-2.2-5.87-4.26-9.04-6.56C312.6 29.17 279.2-.35 256 0c-23.2-.35-56.59 29.17-73.41 41.44-3.17 2.3-6 4.36-9.04 6.56H96c-26.51 0-48 21.49-48 48v44.14c-12.37 9.33-20.76 15.87-29.61 22.81A47.995 47.995 0 0 0 0 200.72v10.65l96 69.35V96h320v184.72l96-69.35v-10.65c0-14.74-6.78-28.67-18.39-37.77z"]
};
var faEnvelopeSquare = {
  prefix: 'fas',
  iconName: 'envelope-square',
  icon: [448, 512, [], "f199", "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM178.117 262.104C87.429 196.287 88.353 196.121 64 177.167V152c0-13.255 10.745-24 24-24h272c13.255 0 24 10.745 24 24v25.167c-24.371 18.969-23.434 19.124-114.117 84.938-10.5 7.655-31.392 26.12-45.883 25.894-14.503.218-35.367-18.227-45.883-25.895zM384 217.775V360c0 13.255-10.745 24-24 24H88c-13.255 0-24-10.745-24-24V217.775c13.958 10.794 33.329 25.236 95.303 70.214 14.162 10.341 37.975 32.145 64.694 32.01 26.887.134 51.037-22.041 64.72-32.025 61.958-44.965 81.325-59.406 95.283-70.199z"]
};
var faEquals = {
  prefix: 'fas',
  iconName: 'equals',
  icon: [448, 512, [], "f52c", "M416 304H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32zm0-192H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"]
};
var faEraser = {
  prefix: 'fas',
  iconName: 'eraser',
  icon: [512, 512, [], "f12d", "M497.941 273.941c18.745-18.745 18.745-49.137 0-67.882l-160-160c-18.745-18.745-49.136-18.746-67.883 0l-256 256c-18.745 18.745-18.745 49.137 0 67.882l96 96A48.004 48.004 0 0 0 144 480h356c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12H355.883l142.058-142.059zm-302.627-62.627l137.373 137.373L265.373 416H150.628l-80-80 124.686-124.686z"]
};
var faEthernet = {
  prefix: 'fas',
  iconName: 'ethernet',
  icon: [512, 512, [], "f796", "M496 192h-48v-48c0-8.8-7.2-16-16-16h-48V80c0-8.8-7.2-16-16-16H144c-8.8 0-16 7.2-16 16v48H80c-8.8 0-16 7.2-16 16v48H16c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16h80V320h32v128h64V320h32v128h64V320h32v128h64V320h32v128h80c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16z"]
};
var faEuroSign = {
  prefix: 'fas',
  iconName: 'euro-sign',
  icon: [320, 512, [], "f153", "M310.706 413.765c-1.314-6.63-7.835-10.872-14.424-9.369-10.692 2.439-27.422 5.413-45.426 5.413-56.763 0-101.929-34.79-121.461-85.449h113.689a12 12 0 0 0 11.708-9.369l6.373-28.36c1.686-7.502-4.019-14.631-11.708-14.631H115.22c-1.21-14.328-1.414-28.287.137-42.245H261.95a12 12 0 0 0 11.723-9.434l6.512-29.755c1.638-7.484-4.061-14.566-11.723-14.566H130.184c20.633-44.991 62.69-75.03 117.619-75.03 14.486 0 28.564 2.25 37.851 4.145 6.216 1.268 12.347-2.498 14.002-8.623l11.991-44.368c1.822-6.741-2.465-13.616-9.326-14.917C290.217 34.912 270.71 32 249.635 32 152.451 32 74.03 92.252 45.075 176H12c-6.627 0-12 5.373-12 12v29.755c0 6.627 5.373 12 12 12h21.569c-1.009 13.607-1.181 29.287-.181 42.245H12c-6.627 0-12 5.373-12 12v28.36c0 6.627 5.373 12 12 12h30.114C67.139 414.692 145.264 480 249.635 480c26.301 0 48.562-4.544 61.101-7.788 6.167-1.595 10.027-7.708 8.788-13.957l-8.818-44.49z"]
};
var faExchangeAlt = {
  prefix: 'fas',
  iconName: 'exchange-alt',
  icon: [512, 512, [], "f362", "M0 168v-16c0-13.255 10.745-24 24-24h360V80c0-21.367 25.899-32.042 40.971-16.971l80 80c9.372 9.373 9.372 24.569 0 33.941l-80 80C409.956 271.982 384 261.456 384 240v-48H24c-13.255 0-24-10.745-24-24zm488 152H128v-48c0-21.314-25.862-32.08-40.971-16.971l-80 80c-9.372 9.373-9.372 24.569 0 33.941l80 80C102.057 463.997 128 453.437 128 432v-48h360c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24z"]
};
var faExclamation = {
  prefix: 'fas',
  iconName: 'exclamation',
  icon: [192, 512, [], "f12a", "M176 432c0 44.112-35.888 80-80 80s-80-35.888-80-80 35.888-80 80-80 80 35.888 80 80zM25.26 25.199l13.6 272C39.499 309.972 50.041 320 62.83 320h66.34c12.789 0 23.331-10.028 23.97-22.801l13.6-272C167.425 11.49 156.496 0 142.77 0H49.23C35.504 0 24.575 11.49 25.26 25.199z"]
};
var faExclamationCircle = {
  prefix: 'fas',
  iconName: 'exclamation-circle',
  icon: [512, 512, [], "f06a", "M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248 111.083 248 248zm-248 50c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"]
};
var faExclamationTriangle = {
  prefix: 'fas',
  iconName: 'exclamation-triangle',
  icon: [576, 512, [], "f071", "M569.517 440.013C587.975 472.007 564.806 512 527.94 512H48.054c-36.937 0-59.999-40.055-41.577-71.987L246.423 23.985c18.467-32.009 64.72-31.951 83.154 0l239.94 416.028zM288 354c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"]
};
var faExpand = {
  prefix: 'fas',
  iconName: 'expand',
  icon: [448, 512, [], "f065", "M0 180V56c0-13.3 10.7-24 24-24h124c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H64v84c0 6.6-5.4 12-12 12H12c-6.6 0-12-5.4-12-12zM288 44v40c0 6.6 5.4 12 12 12h84v84c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12V56c0-13.3-10.7-24-24-24H300c-6.6 0-12 5.4-12 12zm148 276h-40c-6.6 0-12 5.4-12 12v84h-84c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h124c13.3 0 24-10.7 24-24V332c0-6.6-5.4-12-12-12zM160 468v-40c0-6.6-5.4-12-12-12H64v-84c0-6.6-5.4-12-12-12H12c-6.6 0-12 5.4-12 12v124c0 13.3 10.7 24 24 24h124c6.6 0 12-5.4 12-12z"]
};
var faExpandAlt = {
  prefix: 'fas',
  iconName: 'expand-alt',
  icon: [448, 512, [], "f424", "M212.686 315.314L120 408l32.922 31.029c15.12 15.12 4.412 40.971-16.97 40.971h-112C10.697 480 0 469.255 0 456V344c0-21.382 25.803-32.09 40.922-16.971L72 360l92.686-92.686c6.248-6.248 16.379-6.248 22.627 0l25.373 25.373c6.249 6.248 6.249 16.378 0 22.627zm22.628-118.628L328 104l-32.922-31.029C279.958 57.851 290.666 32 312.048 32h112C437.303 32 448 42.745 448 56v112c0 21.382-25.803 32.09-40.922 16.971L376 152l-92.686 92.686c-6.248 6.248-16.379 6.248-22.627 0l-25.373-25.373c-6.249-6.248-6.249-16.378 0-22.627z"]
};
var faExpandArrowsAlt = {
  prefix: 'fas',
  iconName: 'expand-arrows-alt',
  icon: [448, 512, [], "f31e", "M448 344v112a23.94 23.94 0 0 1-24 24H312c-21.39 0-32.09-25.9-17-41l36.2-36.2L224 295.6 116.77 402.9 153 439c15.09 15.1 4.39 41-17 41H24a23.94 23.94 0 0 1-24-24V344c0-21.4 25.89-32.1 41-17l36.19 36.2L184.46 256 77.18 148.7 41 185c-15.1 15.1-41 4.4-41-17V56a23.94 23.94 0 0 1 24-24h112c21.39 0 32.09 25.9 17 41l-36.2 36.2L224 216.4l107.23-107.3L295 73c-15.09-15.1-4.39-41 17-41h112a23.94 23.94 0 0 1 24 24v112c0 21.4-25.89 32.1-41 17l-36.19-36.2L263.54 256l107.28 107.3L407 327.1c15.1-15.2 41-4.5 41 16.9z"]
};
var faExternalLinkAlt = {
  prefix: 'fas',
  iconName: 'external-link-alt',
  icon: [512, 512, [], "f35d", "M432,320H400a16,16,0,0,0-16,16V448H64V128H208a16,16,0,0,0,16-16V80a16,16,0,0,0-16-16H48A48,48,0,0,0,0,112V464a48,48,0,0,0,48,48H400a48,48,0,0,0,48-48V336A16,16,0,0,0,432,320ZM488,0h-128c-21.37,0-32.05,25.91-17,41l35.73,35.73L135,320.37a24,24,0,0,0,0,34L157.67,377a24,24,0,0,0,34,0L435.28,133.32,471,169c15,15,41,4.5,41-17V24A24,24,0,0,0,488,0Z"]
};
var faExternalLinkSquareAlt = {
  prefix: 'fas',
  iconName: 'external-link-square-alt',
  icon: [448, 512, [], "f360", "M448 80v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48zm-88 16H248.029c-21.313 0-32.08 25.861-16.971 40.971l31.984 31.987L67.515 364.485c-4.686 4.686-4.686 12.284 0 16.971l31.029 31.029c4.687 4.686 12.285 4.686 16.971 0l195.526-195.526 31.988 31.991C358.058 263.977 384 253.425 384 231.979V120c0-13.255-10.745-24-24-24z"]
};
var faEye = {
  prefix: 'fas',
  iconName: 'eye',
  icon: [576, 512, [], "f06e", "M572.52 241.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 400a144 144 0 1 1 144-144 143.93 143.93 0 0 1-144 144zm0-240a95.31 95.31 0 0 0-25.31 3.79 47.85 47.85 0 0 1-66.9 66.9A95.78 95.78 0 1 0 288 160z"]
};
var faEyeDropper = {
  prefix: 'fas',
  iconName: 'eye-dropper',
  icon: [512, 512, [], "f1fb", "M50.75 333.25c-12 12-18.75 28.28-18.75 45.26V424L0 480l32 32 56-32h45.49c16.97 0 33.25-6.74 45.25-18.74l126.64-126.62-128-128L50.75 333.25zM483.88 28.12c-37.47-37.5-98.28-37.5-135.75 0l-77.09 77.09-13.1-13.1c-9.44-9.44-24.65-9.31-33.94 0l-40.97 40.97c-9.37 9.37-9.37 24.57 0 33.94l161.94 161.94c9.44 9.44 24.65 9.31 33.94 0L419.88 288c9.37-9.37 9.37-24.57 0-33.94l-13.1-13.1 77.09-77.09c37.51-37.48 37.51-98.26.01-135.75z"]
};
var faEyeSlash = {
  prefix: 'fas',
  iconName: 'eye-slash',
  icon: [640, 512, [], "f070", "M320 400c-75.85 0-137.25-58.71-142.9-133.11L72.2 185.82c-13.79 17.3-26.48 35.59-36.72 55.59a32.35 32.35 0 0 0 0 29.19C89.71 376.41 197.07 448 320 448c26.91 0 52.87-4 77.89-10.46L346 397.39a144.13 144.13 0 0 1-26 2.61zm313.82 58.1l-110.55-85.44a331.25 331.25 0 0 0 81.25-102.07 32.35 32.35 0 0 0 0-29.19C550.29 135.59 442.93 64 320 64a308.15 308.15 0 0 0-147.32 37.7L45.46 3.37A16 16 0 0 0 23 6.18L3.37 31.45A16 16 0 0 0 6.18 53.9l588.36 454.73a16 16 0 0 0 22.46-2.81l19.64-25.27a16 16 0 0 0-2.82-22.45zm-183.72-142l-39.3-30.38A94.75 94.75 0 0 0 416 256a94.76 94.76 0 0 0-121.31-92.21A47.65 47.65 0 0 1 304 192a46.64 46.64 0 0 1-1.54 10l-73.61-56.89A142.31 142.31 0 0 1 320 112a143.92 143.92 0 0 1 144 144c0 21.63-5.29 41.79-13.9 60.11z"]
};
var faFan = {
  prefix: 'fas',
  iconName: 'fan',
  icon: [512, 512, [], "f863", "M352.57 128c-28.09 0-54.09 4.52-77.06 12.86l12.41-123.11C289 7.31 279.81-1.18 269.33.13 189.63 10.13 128 77.64 128 159.43c0 28.09 4.52 54.09 12.86 77.06L17.75 224.08C7.31 223-1.18 232.19.13 242.67c10 79.7 77.51 141.33 159.3 141.33 28.09 0 54.09-4.52 77.06-12.86l-12.41 123.11c-1.05 10.43 8.11 18.93 18.59 17.62 79.7-10 141.33-77.51 141.33-159.3 0-28.09-4.52-54.09-12.86-77.06l123.11 12.41c10.44 1.05 18.93-8.11 17.62-18.59-10-79.7-77.51-141.33-159.3-141.33zM256 288a32 32 0 1 1 32-32 32 32 0 0 1-32 32z"]
};
var faFastBackward = {
  prefix: 'fas',
  iconName: 'fast-backward',
  icon: [512, 512, [], "f049", "M0 436V76c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v151.9L235.5 71.4C256.1 54.3 288 68.6 288 96v131.9L459.5 71.4C480.1 54.3 512 68.6 512 96v320c0 27.4-31.9 41.7-52.5 24.6L288 285.3V416c0 27.4-31.9 41.7-52.5 24.6L64 285.3V436c0 6.6-5.4 12-12 12H12c-6.6 0-12-5.4-12-12z"]
};
var faFastForward = {
  prefix: 'fas',
  iconName: 'fast-forward',
  icon: [512, 512, [], "f050", "M512 76v360c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12V284.1L276.5 440.6c-20.6 17.2-52.5 2.8-52.5-24.6V284.1L52.5 440.6C31.9 457.8 0 443.4 0 416V96c0-27.4 31.9-41.7 52.5-24.6L224 226.8V96c0-27.4 31.9-41.7 52.5-24.6L448 226.8V76c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12z"]
};
var faFaucet = {
  prefix: 'fas',
  iconName: 'faucet',
  icon: [512, 512, [], "e005", "M352,256H313.39c-15.71-13.44-35.46-23.07-57.39-28V180.44l-32-3.38-32,3.38V228c-21.93,5-41.68,14.6-57.39,28H16A16,16,0,0,0,0,272v96a16,16,0,0,0,16,16h92.79C129.38,421.73,173,448,224,448s94.62-26.27,115.21-64H352a32,32,0,0,1,32,32,32,32,0,0,0,32,32h64a32,32,0,0,0,32-32A160,160,0,0,0,352,256ZM81.59,159.91l142.41-15,142.41,15c9.42,1,17.59-6.81,17.59-16.8V112.89c0-10-8.17-17.8-17.59-16.81L256,107.74V80a16,16,0,0,0-16-16H208a16,16,0,0,0-16,16v27.74L81.59,96.08C72.17,95.09,64,102.9,64,112.89v30.22C64,153.1,72.17,160.91,81.59,159.91Z"]
};
var faFax = {
  prefix: 'fas',
  iconName: 'fax',
  icon: [512, 512, [], "f1ac", "M480 160V77.25a32 32 0 0 0-9.38-22.63L425.37 9.37A32 32 0 0 0 402.75 0H160a32 32 0 0 0-32 32v448a32 32 0 0 0 32 32h320a32 32 0 0 0 32-32V192a32 32 0 0 0-32-32zM288 432a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16zm0-128a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16zm128 128a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16zm0-128a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16zm0-112H192V64h160v48a16 16 0 0 0 16 16h48zM64 128H32a32 32 0 0 0-32 32v320a32 32 0 0 0 32 32h32a32 32 0 0 0 32-32V160a32 32 0 0 0-32-32z"]
};
var faFeather = {
  prefix: 'fas',
  iconName: 'feather',
  icon: [512, 512, [], "f52d", "M467.14 44.84c-62.55-62.48-161.67-64.78-252.28 25.73-78.61 78.52-60.98 60.92-85.75 85.66-60.46 60.39-70.39 150.83-63.64 211.17l178.44-178.25c6.26-6.25 16.4-6.25 22.65 0s6.25 16.38 0 22.63L7.04 471.03c-9.38 9.37-9.38 24.57 0 33.94 9.38 9.37 24.6 9.37 33.98 0l66.1-66.03C159.42 454.65 279 457.11 353.95 384h-98.19l147.57-49.14c49.99-49.93 36.38-36.18 46.31-46.86h-97.78l131.54-43.8c45.44-74.46 34.31-148.84-16.26-199.36z"]
};
var faFeatherAlt = {
  prefix: 'fas',
  iconName: 'feather-alt',
  icon: [512, 512, [], "f56b", "M512 0C460.22 3.56 96.44 38.2 71.01 287.61c-3.09 26.66-4.84 53.44-5.99 80.24l178.87-178.69c6.25-6.25 16.4-6.25 22.65 0s6.25 16.38 0 22.63L7.04 471.03c-9.38 9.37-9.38 24.57 0 33.94 9.38 9.37 24.59 9.37 33.98 0l57.13-57.07c42.09-.14 84.15-2.53 125.96-7.36 53.48-5.44 97.02-26.47 132.58-56.54H255.74l146.79-48.88c11.25-14.89 21.37-30.71 30.45-47.12h-81.14l106.54-53.21C500.29 132.86 510.19 26.26 512 0z"]
};
var faFemale = {
  prefix: 'fas',
  iconName: 'female',
  icon: [256, 512, [], "f182", "M128 0c35.346 0 64 28.654 64 64s-28.654 64-64 64c-35.346 0-64-28.654-64-64S92.654 0 128 0m119.283 354.179l-48-192A24 24 0 0 0 176 144h-11.36c-22.711 10.443-49.59 10.894-73.28 0H80a24 24 0 0 0-23.283 18.179l-48 192C4.935 369.305 16.383 384 32 384h56v104c0 13.255 10.745 24 24 24h32c13.255 0 24-10.745 24-24V384h56c15.591 0 27.071-14.671 23.283-29.821z"]
};
var faFighterJet = {
  prefix: 'fas',
  iconName: 'fighter-jet',
  icon: [640, 512, [], "f0fb", "M544 224l-128-16-48-16h-24L227.158 44h39.509C278.333 44 288 41.375 288 38s-9.667-6-21.333-6H152v12h16v164h-48l-66.667-80H18.667L8 138.667V208h8v16h48v2.666l-64 8v42.667l64 8V288H16v16H8v69.333L18.667 384h34.667L120 304h48v164h-16v12h114.667c11.667 0 21.333-2.625 21.333-6s-9.667-6-21.333-6h-39.509L344 320h24l48-16 128-16c96-21.333 96-26.583 96-32 0-5.417 0-10.667-96-32z"]
};
var faFile = {
  prefix: 'fas',
  iconName: 'file',
  icon: [384, 512, [], "f15b", "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm160-14.1v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"]
};
var faFileAlt = {
  prefix: 'fas',
  iconName: 'file-alt',
  icon: [384, 512, [], "f15c", "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm64 236c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8zm0-64c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8zm0-72v8c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm96-114.1v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"]
};
var faFileArchive = {
  prefix: 'fas',
  iconName: 'file-archive',
  icon: [384, 512, [], "f1c6", "M377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zM128.4 336c-17.9 0-32.4 12.1-32.4 27 0 15 14.6 27 32.5 27s32.4-12.1 32.4-27-14.6-27-32.5-27zM224 136V0h-63.6v32h-32V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zM95.9 32h32v32h-32zm32.3 384c-33.2 0-58-30.4-51.4-62.9L96.4 256v-32h32v-32h-32v-32h32v-32h-32V96h32V64h32v32h-32v32h32v32h-32v32h32v32h-32v32h22.1c5.7 0 10.7 4.1 11.8 9.7l17.3 87.7c6.4 32.4-18.4 62.6-51.4 62.6z"]
};
var faFileAudio = {
  prefix: 'fas',
  iconName: 'file-audio',
  icon: [384, 512, [], "f1c7", "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm-64 268c0 10.7-12.9 16-20.5 8.5L104 376H76c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h28l35.5-36.5c7.6-7.6 20.5-2.2 20.5 8.5v136zm33.2-47.6c9.1-9.3 9.1-24.1 0-33.4-22.1-22.8 12.2-56.2 34.4-33.5 27.2 27.9 27.2 72.4 0 100.4-21.8 22.3-56.9-10.4-34.4-33.5zm86-117.1c54.4 55.9 54.4 144.8 0 200.8-21.8 22.4-57-10.3-34.4-33.5 36.2-37.2 36.3-96.5 0-133.8-22.1-22.8 12.3-56.3 34.4-33.5zM384 121.9v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"]
};
var faFileCode = {
  prefix: 'fas',
  iconName: 'file-code',
  icon: [384, 512, [], "f1c9", "M384 121.941V128H256V0h6.059c6.365 0 12.47 2.529 16.971 7.029l97.941 97.941A24.005 24.005 0 0 1 384 121.941zM248 160c-13.2 0-24-10.8-24-24V0H24C10.745 0 0 10.745 0 24v464c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24V160H248zM123.206 400.505a5.4 5.4 0 0 1-7.633.246l-64.866-60.812a5.4 5.4 0 0 1 0-7.879l64.866-60.812a5.4 5.4 0 0 1 7.633.246l19.579 20.885a5.4 5.4 0 0 1-.372 7.747L101.65 336l40.763 35.874a5.4 5.4 0 0 1 .372 7.747l-19.579 20.884zm51.295 50.479l-27.453-7.97a5.402 5.402 0 0 1-3.681-6.692l61.44-211.626a5.402 5.402 0 0 1 6.692-3.681l27.452 7.97a5.4 5.4 0 0 1 3.68 6.692l-61.44 211.626a5.397 5.397 0 0 1-6.69 3.681zm160.792-111.045l-64.866 60.812a5.4 5.4 0 0 1-7.633-.246l-19.58-20.885a5.4 5.4 0 0 1 .372-7.747L284.35 336l-40.763-35.874a5.4 5.4 0 0 1-.372-7.747l19.58-20.885a5.4 5.4 0 0 1 7.633-.246l64.866 60.812a5.4 5.4 0 0 1-.001 7.879z"]
};
var faFileContract = {
  prefix: 'fas',
  iconName: 'file-contract',
  icon: [384, 512, [], "f56c", "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zM64 72c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8V72zm0 64c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16zm192.81 248H304c8.84 0 16 7.16 16 16s-7.16 16-16 16h-47.19c-16.45 0-31.27-9.14-38.64-23.86-2.95-5.92-8.09-6.52-10.17-6.52s-7.22.59-10.02 6.19l-7.67 15.34a15.986 15.986 0 0 1-14.31 8.84c-.38 0-.75-.02-1.14-.05-6.45-.45-12-4.75-14.03-10.89L144 354.59l-10.61 31.88c-5.89 17.66-22.38 29.53-41 29.53H80c-8.84 0-16-7.16-16-16s7.16-16 16-16h12.39c4.83 0 9.11-3.08 10.64-7.66l18.19-54.64c3.3-9.81 12.44-16.41 22.78-16.41s19.48 6.59 22.77 16.41l13.88 41.64c19.77-16.19 54.05-9.7 66 14.16 2.02 4.06 5.96 6.5 10.16 6.5zM377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"]
};
var faFileCsv = {
  prefix: 'fas',
  iconName: 'file-csv',
  icon: [384, 512, [], "f6dd", "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm-96 144c0 4.42-3.58 8-8 8h-8c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h8c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-8c-26.51 0-48-21.49-48-48v-32c0-26.51 21.49-48 48-48h8c4.42 0 8 3.58 8 8v16zm44.27 104H160c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h12.27c5.95 0 10.41-3.5 10.41-6.62 0-1.3-.75-2.66-2.12-3.84l-21.89-18.77c-8.47-7.22-13.33-17.48-13.33-28.14 0-21.3 19.02-38.62 42.41-38.62H200c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-12.27c-5.95 0-10.41 3.5-10.41 6.62 0 1.3.75 2.66 2.12 3.84l21.89 18.77c8.47 7.22 13.33 17.48 13.33 28.14.01 21.29-19 38.62-42.39 38.62zM256 264v20.8c0 20.27 5.7 40.17 16 56.88 10.3-16.7 16-36.61 16-56.88V264c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v20.8c0 35.48-12.88 68.89-36.28 94.09-3.02 3.25-7.27 5.11-11.72 5.11s-8.7-1.86-11.72-5.11c-23.4-25.2-36.28-58.61-36.28-94.09V264c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8zm121-159L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"]
};
var faFileDownload = {
  prefix: 'fas',
  iconName: 'file-download',
  icon: [384, 512, [], "f56d", "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm76.45 211.36l-96.42 95.7c-6.65 6.61-17.39 6.61-24.04 0l-96.42-95.7C73.42 337.29 80.54 320 94.82 320H160v-80c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v80h65.18c14.28 0 21.4 17.29 11.27 27.36zM377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"]
};
var faFileExcel = {
  prefix: 'fas',
  iconName: 'file-excel',
  icon: [384, 512, [], "f1c3", "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm60.1 106.5L224 336l60.1 93.5c5.1 8-.6 18.5-10.1 18.5h-34.9c-4.4 0-8.5-2.4-10.6-6.3C208.9 405.5 192 373 192 373c-6.4 14.8-10 20-36.6 68.8-2.1 3.9-6.1 6.3-10.5 6.3H110c-9.5 0-15.2-10.5-10.1-18.5l60.3-93.5-60.3-93.5c-5.2-8 .6-18.5 10.1-18.5h34.8c4.4 0 8.5 2.4 10.6 6.3 26.1 48.8 20 33.6 36.6 68.5 0 0 6.1-11.7 36.6-68.5 2.1-3.9 6.2-6.3 10.6-6.3H274c9.5-.1 15.2 10.4 10.1 18.4zM384 121.9v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"]
};
var faFileExport = {
  prefix: 'fas',
  iconName: 'file-export',
  icon: [576, 512, [], "f56e", "M384 121.9c0-6.3-2.5-12.4-7-16.9L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128zM571 308l-95.7-96.4c-10.1-10.1-27.4-3-27.4 11.3V288h-64v64h64v65.2c0 14.3 17.3 21.4 27.4 11.3L571 332c6.6-6.6 6.6-17.4 0-24zm-379 28v-32c0-8.8 7.2-16 16-16h176V160H248c-13.2 0-24-10.8-24-24V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V352H208c-8.8 0-16-7.2-16-16z"]
};
var faFileImage = {
  prefix: 'fas',
  iconName: 'file-image',
  icon: [384, 512, [], "f1c5", "M384 121.941V128H256V0h6.059a24 24 0 0 1 16.97 7.029l97.941 97.941a24.002 24.002 0 0 1 7.03 16.971zM248 160c-13.2 0-24-10.8-24-24V0H24C10.745 0 0 10.745 0 24v464c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24V160H248zm-135.455 16c26.51 0 48 21.49 48 48s-21.49 48-48 48-48-21.49-48-48 21.491-48 48-48zm208 240h-256l.485-48.485L104.545 328c4.686-4.686 11.799-4.201 16.485.485L160.545 368 264.06 264.485c4.686-4.686 12.284-4.686 16.971 0L320.545 304v112z"]
};
var faFileImport = {
  prefix: 'fas',
  iconName: 'file-import',
  icon: [512, 512, [], "f56f", "M16 288c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h112v-64zm489-183L407.1 7c-4.5-4.5-10.6-7-17-7H384v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H152c-13.3 0-24 10.7-24 24v264h128v-65.2c0-14.3 17.3-21.4 27.4-11.3L379 308c6.6 6.7 6.6 17.4 0 24l-95.7 96.4c-10.1 10.1-27.4 3-27.4-11.3V352H128v136c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H376c-13.2 0-24-10.8-24-24z"]
};
var faFileInvoice = {
  prefix: 'fas',
  iconName: 'file-invoice',
  icon: [384, 512, [], "f570", "M288 256H96v64h192v-64zm89-151L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zM64 72c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8V72zm0 64c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16zm256 304c0 4.42-3.58 8-8 8h-80c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16zm0-200v96c0 8.84-7.16 16-16 16H80c-8.84 0-16-7.16-16-16v-96c0-8.84 7.16-16 16-16h224c8.84 0 16 7.16 16 16z"]
};
var faFileInvoiceDollar = {
  prefix: 'fas',
  iconName: 'file-invoice-dollar',
  icon: [384, 512, [], "f571", "M377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zM64 72c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8V72zm0 80v-16c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8zm144 263.88V440c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-24.29c-11.29-.58-22.27-4.52-31.37-11.35-3.9-2.93-4.1-8.77-.57-12.14l11.75-11.21c2.77-2.64 6.89-2.76 10.13-.73 3.87 2.42 8.26 3.72 12.82 3.72h28.11c6.5 0 11.8-5.92 11.8-13.19 0-5.95-3.61-11.19-8.77-12.73l-45-13.5c-18.59-5.58-31.58-23.42-31.58-43.39 0-24.52 19.05-44.44 42.67-45.07V232c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v24.29c11.29.58 22.27 4.51 31.37 11.35 3.9 2.93 4.1 8.77.57 12.14l-11.75 11.21c-2.77 2.64-6.89 2.76-10.13.73-3.87-2.43-8.26-3.72-12.82-3.72h-28.11c-6.5 0-11.8 5.92-11.8 13.19 0 5.95 3.61 11.19 8.77 12.73l45 13.5c18.59 5.58 31.58 23.42 31.58 43.39 0 24.53-19.05 44.44-42.67 45.07z"]
};
var faFileMedical = {
  prefix: 'fas',
  iconName: 'file-medical',
  icon: [384, 512, [], "f477", "M377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm64 160v48c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8z"]
};
var faFileMedicalAlt = {
  prefix: 'fas',
  iconName: 'file-medical-alt',
  icon: [448, 512, [], "f478", "M288 136V0H88C74.7 0 64 10.7 64 24v232H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h140.9c3 0 5.8 1.7 7.2 4.4l19.9 39.8 56.8-113.7c2.9-5.9 11.4-5.9 14.3 0l34.7 69.5H352c8.8 0 16 7.2 16 16s-7.2 16-16 16h-89.9L240 275.8l-56.8 113.7c-2.9 5.9-11.4 5.9-14.3 0L134.1 320H64v168c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H312c-13.2 0-24-10.8-24-24zm153-31L343.1 7c-4.5-4.5-10.6-7-17-7H320v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"]
};
var faFilePdf = {
  prefix: 'fas',
  iconName: 'file-pdf',
  icon: [384, 512, [], "f1c1", "M181.9 256.1c-5-16-4.9-46.9-2-46.9 8.4 0 7.6 36.9 2 46.9zm-1.7 47.2c-7.7 20.2-17.3 43.3-28.4 62.7 18.3-7 39-17.2 62.9-21.9-12.7-9.6-24.9-23.4-34.5-40.8zM86.1 428.1c0 .8 13.2-5.4 34.9-40.2-6.7 6.3-29.1 24.5-34.9 40.2zM248 160h136v328c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V24C0 10.7 10.7 0 24 0h200v136c0 13.2 10.8 24 24 24zm-8 171.8c-20-12.2-33.3-29-42.7-53.8 4.5-18.5 11.6-46.6 6.2-64.2-4.7-29.4-42.4-26.5-47.8-6.8-5 18.3-.4 44.1 8.1 77-11.6 27.6-28.7 64.6-40.8 85.8-.1 0-.1.1-.2.1-27.1 13.9-73.6 44.5-54.5 68 5.6 6.9 16 10 21.5 10 17.9 0 35.7-18 61.1-61.8 25.8-8.5 54.1-19.1 79-23.2 21.7 11.8 47.1 19.5 64 19.5 29.2 0 31.2-32 19.7-43.4-13.9-13.6-54.3-9.7-73.6-7.2zM377 105L279 7c-4.5-4.5-10.6-7-17-7h-6v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-74.1 255.3c4.1-2.7-2.5-11.9-42.8-9 37.1 15.8 42.8 9 42.8 9z"]
};
var faFilePowerpoint = {
  prefix: 'fas',
  iconName: 'file-powerpoint',
  icon: [384, 512, [], "f1c4", "M193.7 271.2c8.8 0 15.5 2.7 20.3 8.1 9.6 10.9 9.8 32.7-.2 44.1-4.9 5.6-11.9 8.5-21.1 8.5h-26.9v-60.7h27.9zM377 105L279 7c-4.5-4.5-10.6-7-17-7h-6v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm53 165.2c0 90.3-88.8 77.6-111.1 77.6V436c0 6.6-5.4 12-12 12h-30.8c-6.6 0-12-5.4-12-12V236.2c0-6.6 5.4-12 12-12h81c44.5 0 72.9 32.8 72.9 77z"]
};
var faFilePrescription = {
  prefix: 'fas',
  iconName: 'file-prescription',
  icon: [384, 512, [], "f572", "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm68.53 179.48l11.31 11.31c6.25 6.25 6.25 16.38 0 22.63l-29.9 29.9L304 409.38c6.25 6.25 6.25 16.38 0 22.63l-11.31 11.31c-6.25 6.25-16.38 6.25-22.63 0L240 413.25l-30.06 30.06c-6.25 6.25-16.38 6.25-22.63 0L176 432c-6.25-6.25-6.25-16.38 0-22.63l30.06-30.06L146.74 320H128v48c0 8.84-7.16 16-16 16H96c-8.84 0-16-7.16-16-16V208c0-8.84 7.16-16 16-16h80c35.35 0 64 28.65 64 64 0 24.22-13.62 45.05-33.46 55.92L240 345.38l29.9-29.9c6.25-6.25 16.38-6.25 22.63 0zM176 272h-48v-32h48c8.82 0 16 7.18 16 16s-7.18 16-16 16zm208-150.1v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"]
};
var faFileSignature = {
  prefix: 'fas',
  iconName: 'file-signature',
  icon: [576, 512, [], "f573", "M218.17 424.14c-2.95-5.92-8.09-6.52-10.17-6.52s-7.22.59-10.02 6.19l-7.67 15.34c-6.37 12.78-25.03 11.37-29.48-2.09L144 386.59l-10.61 31.88c-5.89 17.66-22.38 29.53-41 29.53H80c-8.84 0-16-7.16-16-16s7.16-16 16-16h12.39c4.83 0 9.11-3.08 10.64-7.66l18.19-54.64c3.3-9.81 12.44-16.41 22.78-16.41s19.48 6.59 22.77 16.41l13.88 41.64c19.75-16.19 54.06-9.7 66 14.16 1.89 3.78 5.49 5.95 9.36 6.26v-82.12l128-127.09V160H248c-13.2 0-24-10.8-24-24V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24v-40l-128-.11c-16.12-.31-30.58-9.28-37.83-23.75zM384 121.9c0-6.3-2.5-12.4-7-16.9L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1zm-96 225.06V416h68.99l161.68-162.78-67.88-67.88L288 346.96zm280.54-179.63l-31.87-31.87c-9.94-9.94-26.07-9.94-36.01 0l-27.25 27.25 67.88 67.88 27.25-27.25c9.95-9.94 9.95-26.07 0-36.01z"]
};
var faFileUpload = {
  prefix: 'fas',
  iconName: 'file-upload',
  icon: [384, 512, [], "f574", "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm65.18 216.01H224v80c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-80H94.82c-14.28 0-21.41-17.29-11.27-27.36l96.42-95.7c6.65-6.61 17.39-6.61 24.04 0l96.42 95.7c10.15 10.07 3.03 27.36-11.25 27.36zM377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"]
};
var faFileVideo = {
  prefix: 'fas',
  iconName: 'file-video',
  icon: [384, 512, [], "f1c8", "M384 121.941V128H256V0h6.059c6.365 0 12.47 2.529 16.971 7.029l97.941 97.941A24.005 24.005 0 0 1 384 121.941zM224 136V0H24C10.745 0 0 10.745 0 24v464c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24V160H248c-13.2 0-24-10.8-24-24zm96 144.016v111.963c0 21.445-25.943 31.998-40.971 16.971L224 353.941V392c0 13.255-10.745 24-24 24H88c-13.255 0-24-10.745-24-24V280c0-13.255 10.745-24 24-24h112c13.255 0 24 10.745 24 24v38.059l55.029-55.013c15.011-15.01 40.971-4.491 40.971 16.97z"]
};
var faFileWord = {
  prefix: 'fas',
  iconName: 'file-word',
  icon: [384, 512, [], "f1c2", "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm57.1 120H305c7.7 0 13.4 7.1 11.7 14.7l-38 168c-1.2 5.5-6.1 9.3-11.7 9.3h-38c-5.5 0-10.3-3.8-11.6-9.1-25.8-103.5-20.8-81.2-25.6-110.5h-.5c-1.1 14.3-2.4 17.4-25.6 110.5-1.3 5.3-6.1 9.1-11.6 9.1H117c-5.6 0-10.5-3.9-11.7-9.4l-37.8-168c-1.7-7.5 4-14.6 11.7-14.6h24.5c5.7 0 10.7 4 11.8 9.7 15.6 78 20.1 109.5 21 122.2 1.6-10.2 7.3-32.7 29.4-122.7 1.3-5.4 6.1-9.1 11.7-9.1h29.1c5.6 0 10.4 3.8 11.7 9.2 24 100.4 28.8 124 29.6 129.4-.2-11.2-2.6-17.8 21.6-129.2 1-5.6 5.9-9.5 11.5-9.5zM384 121.9v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"]
};
var faFill = {
  prefix: 'fas',
  iconName: 'fill',
  icon: [512, 512, [], "f575", "M502.63 217.06L294.94 9.37C288.69 3.12 280.5 0 272.31 0s-16.38 3.12-22.62 9.37l-81.58 81.58L81.93 4.77c-6.24-6.25-16.38-6.25-22.62 0L36.69 27.38c-6.24 6.25-6.24 16.38 0 22.63l86.19 86.18-94.76 94.76c-37.49 37.49-37.49 98.26 0 135.75l117.19 117.19c18.75 18.74 43.31 28.12 67.87 28.12 24.57 0 49.13-9.37 67.88-28.12l221.57-221.57c12.49-12.5 12.49-32.76 0-45.26zm-116.22 70.97H65.93c1.36-3.84 3.57-7.98 7.43-11.83l13.15-13.15 81.61-81.61 58.61 58.6c12.49 12.49 32.75 12.49 45.24 0 12.49-12.49 12.49-32.75 0-45.24l-58.61-58.6 58.95-58.95 162.45 162.44-48.35 48.34z"]
};
var faFillDrip = {
  prefix: 'fas',
  iconName: 'fill-drip',
  icon: [576, 512, [], "f576", "M512 320s-64 92.65-64 128c0 35.35 28.66 64 64 64s64-28.65 64-64-64-128-64-128zm-9.37-102.94L294.94 9.37C288.69 3.12 280.5 0 272.31 0s-16.38 3.12-22.62 9.37l-81.58 81.58L81.93 4.76c-6.25-6.25-16.38-6.25-22.62 0L36.69 27.38c-6.24 6.25-6.24 16.38 0 22.62l86.19 86.18-94.76 94.76c-37.49 37.48-37.49 98.26 0 135.75l117.19 117.19c18.74 18.74 43.31 28.12 67.87 28.12 24.57 0 49.13-9.37 67.87-28.12l221.57-221.57c12.5-12.5 12.5-32.75.01-45.25zm-116.22 70.97H65.93c1.36-3.84 3.57-7.98 7.43-11.83l13.15-13.15 81.61-81.61 58.6 58.6c12.49 12.49 32.75 12.49 45.24 0s12.49-32.75 0-45.24l-58.6-58.6 58.95-58.95 162.44 162.44-48.34 48.34z"]
};
var faFilm = {
  prefix: 'fas',
  iconName: 'film',
  icon: [512, 512, [], "f008", "M488 64h-8v20c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12V64H96v20c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12V64h-8C10.7 64 0 74.7 0 88v336c0 13.3 10.7 24 24 24h8v-20c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v20h320v-20c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v20h8c13.3 0 24-10.7 24-24V88c0-13.3-10.7-24-24-24zM96 372c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm272 208c0 6.6-5.4 12-12 12H156c-6.6 0-12-5.4-12-12v-96c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v96zm0-168c0 6.6-5.4 12-12 12H156c-6.6 0-12-5.4-12-12v-96c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v96zm112 152c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40z"]
};
var faFilter = {
  prefix: 'fas',
  iconName: 'filter',
  icon: [512, 512, [], "f0b0", "M487.976 0H24.028C2.71 0-8.047 25.866 7.058 40.971L192 225.941V432c0 7.831 3.821 15.17 10.237 19.662l80 55.98C298.02 518.69 320 507.493 320 487.98V225.941l184.947-184.97C520.021 25.896 509.338 0 487.976 0z"]
};
var faFingerprint = {
  prefix: 'fas',
  iconName: 'fingerprint',
  icon: [512, 512, [], "f577", "M256.12 245.96c-13.25 0-24 10.74-24 24 1.14 72.25-8.14 141.9-27.7 211.55-2.73 9.72 2.15 30.49 23.12 30.49 10.48 0 20.11-6.92 23.09-17.52 13.53-47.91 31.04-125.41 29.48-224.52.01-13.25-10.73-24-23.99-24zm-.86-81.73C194 164.16 151.25 211.3 152.1 265.32c.75 47.94-3.75 95.91-13.37 142.55-2.69 12.98 5.67 25.69 18.64 28.36 13.05 2.67 25.67-5.66 28.36-18.64 10.34-50.09 15.17-101.58 14.37-153.02-.41-25.95 19.92-52.49 54.45-52.34 31.31.47 57.15 25.34 57.62 55.47.77 48.05-2.81 96.33-10.61 143.55-2.17 13.06 6.69 25.42 19.76 27.58 19.97 3.33 26.81-15.1 27.58-19.77 8.28-50.03 12.06-101.21 11.27-152.11-.88-55.8-47.94-101.88-104.91-102.72zm-110.69-19.78c-10.3-8.34-25.37-6.8-33.76 3.48-25.62 31.5-39.39 71.28-38.75 112 .59 37.58-2.47 75.27-9.11 112.05-2.34 13.05 6.31 25.53 19.36 27.89 20.11 3.5 27.07-14.81 27.89-19.36 7.19-39.84 10.5-80.66 9.86-121.33-.47-29.88 9.2-57.88 28-80.97 8.35-10.28 6.79-25.39-3.49-33.76zm109.47-62.33c-15.41-.41-30.87 1.44-45.78 4.97-12.89 3.06-20.87 15.98-17.83 28.89 3.06 12.89 16 20.83 28.89 17.83 11.05-2.61 22.47-3.77 34-3.69 75.43 1.13 137.73 61.5 138.88 134.58.59 37.88-1.28 76.11-5.58 113.63-1.5 13.17 7.95 25.08 21.11 26.58 16.72 1.95 25.51-11.88 26.58-21.11a929.06 929.06 0 0 0 5.89-119.85c-1.56-98.75-85.07-180.33-186.16-181.83zm252.07 121.45c-2.86-12.92-15.51-21.2-28.61-18.27-12.94 2.86-21.12 15.66-18.26 28.61 4.71 21.41 4.91 37.41 4.7 61.6-.11 13.27 10.55 24.09 23.8 24.2h.2c13.17 0 23.89-10.61 24-23.8.18-22.18.4-44.11-5.83-72.34zm-40.12-90.72C417.29 43.46 337.6 1.29 252.81.02 183.02-.82 118.47 24.91 70.46 72.94 24.09 119.37-.9 181.04.14 246.65l-.12 21.47c-.39 13.25 10.03 24.31 23.28 24.69.23.02.48.02.72.02 12.92 0 23.59-10.3 23.97-23.3l.16-23.64c-.83-52.5 19.16-101.86 56.28-139 38.76-38.8 91.34-59.67 147.68-58.86 69.45 1.03 134.73 35.56 174.62 92.39 7.61 10.86 22.56 13.45 33.42 5.86 10.84-7.62 13.46-22.59 5.84-33.43z"]
};
var faFire = {
  prefix: 'fas',
  iconName: 'fire',
  icon: [384, 512, [], "f06d", "M216 23.86c0-23.8-30.65-32.77-44.15-13.04C48 191.85 224 200 224 288c0 35.63-29.11 64.46-64.85 63.99-35.17-.45-63.15-29.77-63.15-64.94v-85.51c0-21.7-26.47-32.23-41.43-16.5C27.8 213.16 0 261.33 0 320c0 105.87 86.13 192 192 192s192-86.13 192-192c0-170.29-168-193-168-296.14z"]
};
var faFireAlt = {
  prefix: 'fas',
  iconName: 'fire-alt',
  icon: [448, 512, [], "f7e4", "M323.56 51.2c-20.8 19.3-39.58 39.59-56.22 59.97C240.08 73.62 206.28 35.53 168 0 69.74 91.17 0 209.96 0 281.6 0 408.85 100.29 512 224 512s224-103.15 224-230.4c0-53.27-51.98-163.14-124.44-230.4zm-19.47 340.65C282.43 407.01 255.72 416 226.86 416 154.71 416 96 368.26 96 290.75c0-38.61 24.31-72.63 72.79-130.75 6.93 7.98 98.83 125.34 98.83 125.34l58.63-66.88c4.14 6.85 7.91 13.55 11.27 19.97 27.35 52.19 15.81 118.97-33.43 153.42z"]
};
var faFireExtinguisher = {
  prefix: 'fas',
  iconName: 'fire-extinguisher',
  icon: [448, 512, [], "f134", "M434.027 26.329l-168 28C254.693 56.218 256 67.8 256 72h-58.332C208.353 36.108 181.446 0 144 0c-39.435 0-66.368 39.676-52.228 76.203-52.039 13.051-75.381 54.213-90.049 90.884-4.923 12.307 1.063 26.274 13.37 31.197 12.317 4.926 26.279-1.075 31.196-13.37C75.058 112.99 106.964 120 168 120v27.076c-41.543 10.862-72 49.235-72 94.129V488c0 13.255 10.745 24 24 24h144c13.255 0 24-10.745 24-24V240c0-44.731-30.596-82.312-72-92.97V120h40c0 2.974-1.703 15.716 10.027 17.671l168 28C441.342 166.89 448 161.25 448 153.834V38.166c0-7.416-6.658-13.056-13.973-11.837zM144 72c-8.822 0-16-7.178-16-16s7.178-16 16-16 16 7.178 16 16-7.178 16-16 16z"]
};
var faFirstAid = {
  prefix: 'fas',
  iconName: 'first-aid',
  icon: [576, 512, [], "f479", "M0 80v352c0 26.5 21.5 48 48 48h48V32H48C21.5 32 0 53.5 0 80zm128 400h320V32H128v448zm64-248c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48zM528 32h-48v448h48c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48z"]
};
var faFish = {
  prefix: 'fas',
  iconName: 'fish',
  icon: [576, 512, [], "f578", "M327.1 96c-89.97 0-168.54 54.77-212.27 101.63L27.5 131.58c-12.13-9.18-30.24.6-27.14 14.66L24.54 256 .35 365.77c-3.1 14.06 15.01 23.83 27.14 14.66l87.33-66.05C158.55 361.23 237.13 416 327.1 416 464.56 416 576 288 576 256S464.56 96 327.1 96zm87.43 184c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24 13.26 0 24 10.74 24 24 0 13.25-10.75 24-24 24z"]
};
var faFistRaised = {
  prefix: 'fas',
  iconName: 'fist-raised',
  icon: [384, 512, [], "f6de", "M255.98 160V16c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v146.93c5.02-1.78 10.34-2.93 15.97-2.93h48.03zm128 95.99c-.01-35.34-28.66-63.99-63.99-63.99H207.85c-8.78 0-15.9 7.07-15.9 15.85v.56c0 26.27 21.3 47.59 47.57 47.59h35.26c9.68 0 13.2 3.58 13.2 8v16.2c0 4.29-3.59 7.78-7.88 8-44.52 2.28-64.16 24.71-96.05 72.55l-6.31 9.47a7.994 7.994 0 0 1-11.09 2.22l-13.31-8.88a7.994 7.994 0 0 1-2.22-11.09l6.31-9.47c15.73-23.6 30.2-43.26 47.31-58.08-17.27-5.51-31.4-18.12-38.87-34.45-6.59 3.41-13.96 5.52-21.87 5.52h-32c-12.34 0-23.49-4.81-32-12.48C71.48 251.19 60.33 256 48 256H16c-5.64 0-10.97-1.15-16-2.95v77.93c0 33.95 13.48 66.5 37.49 90.51L63.99 448v64h255.98v-63.96l35.91-35.92A96.035 96.035 0 0 0 384 344.21l-.02-88.22zm-32.01-90.09V48c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v112h32c11.28 0 21.94 2.31 32 5.9zM16 224h32c8.84 0 16-7.16 16-16V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v128c0 8.84 7.16 16 16 16zm95.99 0h32c8.84 0 16-7.16 16-16V48c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v160c0 8.84 7.16 16 16 16z"]
};
var faFlag = {
  prefix: 'fas',
  iconName: 'flag',
  icon: [512, 512, [], "f024", "M349.565 98.783C295.978 98.783 251.721 64 184.348 64c-24.955 0-47.309 4.384-68.045 12.013a55.947 55.947 0 0 0 3.586-23.562C118.117 24.015 94.806 1.206 66.338.048 34.345-1.254 8 24.296 8 56c0 19.026 9.497 35.825 24 45.945V488c0 13.255 10.745 24 24 24h16c13.255 0 24-10.745 24-24v-94.4c28.311-12.064 63.582-22.122 114.435-22.122 53.588 0 97.844 34.783 165.217 34.783 48.169 0 86.667-16.294 122.505-40.858C506.84 359.452 512 349.571 512 339.045v-243.1c0-23.393-24.269-38.87-45.485-29.016-34.338 15.948-76.454 31.854-116.95 31.854z"]
};
var faFlagCheckered = {
  prefix: 'fas',
  iconName: 'flag-checkered',
  icon: [512, 512, [], "f11e", "M243.2 189.9V258c26.1 5.9 49.3 15.6 73.6 22.3v-68.2c-26-5.8-49.4-15.5-73.6-22.2zm223.3-123c-34.3 15.9-76.5 31.9-117 31.9C296 98.8 251.7 64 184.3 64c-25 0-47.3 4.4-68 12 2.8-7.3 4.1-15.2 3.6-23.6C118.1 24 94.8 1.2 66.3 0 34.3-1.3 8 24.3 8 56c0 19 9.5 35.8 24 45.9V488c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24v-94.4c28.3-12.1 63.6-22.1 114.4-22.1 53.6 0 97.8 34.8 165.2 34.8 48.2 0 86.7-16.3 122.5-40.9 8.7-6 13.8-15.8 13.8-26.4V95.9c.1-23.3-24.2-38.8-45.4-29zM169.6 325.5c-25.8 2.7-50 8.2-73.6 16.6v-70.5c26.2-9.3 47.5-15 73.6-17.4zM464 191c-23.6 9.8-46.3 19.5-73.6 23.9V286c24.8-3.4 51.4-11.8 73.6-26v70.5c-25.1 16.1-48.5 24.7-73.6 27.1V286c-27 3.7-47.9 1.5-73.6-5.6v67.4c-23.9-7.4-47.3-16.7-73.6-21.3V258c-19.7-4.4-40.8-6.8-73.6-3.8v-70c-22.4 3.1-44.6 10.2-73.6 20.9v-70.5c33.2-12.2 50.1-19.8 73.6-22v71.6c27-3.7 48.4-1.3 73.6 5.7v-67.4c23.7 7.4 47.2 16.7 73.6 21.3v68.4c23.7 5.3 47.6 6.9 73.6 2.7V143c27-4.8 52.3-13.6 73.6-22.5z"]
};
var faFlagUsa = {
  prefix: 'fas',
  iconName: 'flag-usa',
  icon: [512, 512, [], "f74d", "M32 0C14.3 0 0 14.3 0 32v464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V32C64 14.3 49.7 0 32 0zm267.9 303.6c-57.2-15.1-111.7-28.8-203.9 11.1V384c185.7-92.2 221.7 53.3 397.5-23.1 11.4-5 18.5-16.5 18.5-28.8v-36c-43.6 17.3-80.2 24.1-112.1 24.1-37.4-.1-68.9-8.4-100-16.6zm0-96c-57.2-15.1-111.7-28.8-203.9 11.1v61.5c94.8-37.6 154.6-22.7 212.1-7.6 57.2 15.1 111.7 28.8 203.9-11.1V200c-43.6 17.3-80.2 24.1-112.1 24.1-37.4 0-68.9-8.3-100-16.5zm9.5-125.9c51.8 15.6 97.4 29 202.6-20.1V30.8c0-25.1-26.8-38.1-49.4-26.6C291.3 91.5 305.4-62.2 96 32.4v151.9c94.8-37.5 154.6-22.7 212.1-7.6 57.2 15 111.7 28.7 203.9-11.1V96.7c-53.6 23.5-93.3 31.4-126.1 31.4s-59-7.8-85.7-15.9c-4-1.2-8.1-2.4-12.1-3.5V75.5c7.2 2 14.3 4.1 21.3 6.2zM160 128.1c-8.8 0-16-7.1-16-16 0-8.8 7.2-16 16-16s16 7.1 16 16-7.2 16-16 16zm0-55.8c-8.8 0-16-7.1-16-16 0-8.8 7.2-16 16-16s16 7.1 16 16c0 8.8-7.2 16-16 16zm64 47.9c-8.8 0-16-7.1-16-16 0-8.8 7.2-16 16-16s16 7.1 16 16c0 8.8-7.2 16-16 16zm0-55.9c-8.8 0-16-7.1-16-16 0-8.8 7.2-16 16-16s16 7.1 16 16c0 8.8-7.2 16-16 16z"]
};
var faFlask = {
  prefix: 'fas',
  iconName: 'flask',
  icon: [448, 512, [], "f0c3", "M437.2 403.5L320 215V64h8c13.3 0 24-10.7 24-24V24c0-13.3-10.7-24-24-24H120c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24h8v151L10.8 403.5C-18.5 450.6 15.3 512 70.9 512h306.2c55.7 0 89.4-61.5 60.1-108.5zM137.9 320l48.2-77.6c3.7-5.2 5.8-11.6 5.8-18.4V64h64v160c0 6.9 2.2 13.2 5.8 18.4l48.2 77.6h-172z"]
};
var faFlushed = {
  prefix: 'fas',
  iconName: 'flushed',
  icon: [496, 512, [], "f579", "M344 200c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm-192 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM80 224c0-39.8 32.2-72 72-72s72 32.2 72 72-32.2 72-72 72-72-32.2-72-72zm232 176H184c-21.2 0-21.2-32 0-32h128c21.2 0 21.2 32 0 32zm32-104c-39.8 0-72-32.2-72-72s32.2-72 72-72 72 32.2 72 72-32.2 72-72 72z"]
};
var faFolder = {
  prefix: 'fas',
  iconName: 'folder',
  icon: [512, 512, [], "f07b", "M464 128H272l-64-64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V176c0-26.51-21.49-48-48-48z"]
};
var faFolderMinus = {
  prefix: 'fas',
  iconName: 'folder-minus',
  icon: [512, 512, [], "f65d", "M464 128H272l-64-64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V176c0-26.51-21.49-48-48-48zm-96 168c0 8.84-7.16 16-16 16H160c-8.84 0-16-7.16-16-16v-16c0-8.84 7.16-16 16-16h192c8.84 0 16 7.16 16 16v16z"]
};
var faFolderOpen = {
  prefix: 'fas',
  iconName: 'folder-open',
  icon: [576, 512, [], "f07c", "M572.694 292.093L500.27 416.248A63.997 63.997 0 0 1 444.989 448H45.025c-18.523 0-30.064-20.093-20.731-36.093l72.424-124.155A64 64 0 0 1 152 256h399.964c18.523 0 30.064 20.093 20.73 36.093zM152 224h328v-48c0-26.51-21.49-48-48-48H272l-64-64H48C21.49 64 0 85.49 0 112v278.046l69.077-118.418C86.214 242.25 117.989 224 152 224z"]
};
var faFolderPlus = {
  prefix: 'fas',
  iconName: 'folder-plus',
  icon: [512, 512, [], "f65e", "M464,128H272L208,64H48A48,48,0,0,0,0,112V400a48,48,0,0,0,48,48H464a48,48,0,0,0,48-48V176A48,48,0,0,0,464,128ZM359.5,296a16,16,0,0,1-16,16h-64v64a16,16,0,0,1-16,16h-16a16,16,0,0,1-16-16V312h-64a16,16,0,0,1-16-16V280a16,16,0,0,1,16-16h64V200a16,16,0,0,1,16-16h16a16,16,0,0,1,16,16v64h64a16,16,0,0,1,16,16Z"]
};
var faFont = {
  prefix: 'fas',
  iconName: 'font',
  icon: [448, 512, [], "f031", "M432 416h-23.41L277.88 53.69A32 32 0 0 0 247.58 32h-47.16a32 32 0 0 0-30.3 21.69L39.41 416H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-19.58l23.3-64h152.56l23.3 64H304a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM176.85 272L224 142.51 271.15 272z"]
};
var faFontAwesomeLogoFull = {
  prefix: 'fas',
  iconName: 'font-awesome-logo-full',
  icon: [3992, 512, ["Font Awesome"], "f4e6", "M454.6 0H57.4C25.9 0 0 25.9 0 57.4v397.3C0 486.1 25.9 512 57.4 512h397.3c31.4 0 57.4-25.9 57.4-57.4V57.4C512 25.9 486.1 0 454.6 0zm-58.9 324.9c0 4.8-4.1 6.9-8.9 8.9-19.2 8.1-39.7 15.7-61.5 15.7-40.5 0-68.7-44.8-163.2 2.5v51.8c0 30.3-45.7 30.2-45.7 0v-250c-9-7-15-17.9-15-30.3 0-21 17.1-38.2 38.2-38.2 21 0 38.2 17.1 38.2 38.2 0 12.2-5.8 23.2-14.9 30.2v21c37.1-12 65.5-34.4 146.1-3.4 26.6 11.4 68.7-15.7 76.5-15.7 5.5 0 10.3 4.1 10.3 8.9v160.4zm432.9-174.2h-137v70.1H825c39.8 0 40.4 62.2 0 62.2H691.6v105.6c0 45.5-70.7 46.4-70.7 0V128.3c0-22 18-39.8 39.8-39.8h167.8c39.6 0 40.5 62.2.1 62.2zm191.1 23.4c-169.3 0-169.1 252.4 0 252.4 169.9 0 169.9-252.4 0-252.4zm0 196.1c-81.6 0-82.1-139.8 0-139.8 82.5 0 82.4 139.8 0 139.8zm372.4 53.4c-17.5 0-31.4-13.9-31.4-31.4v-117c0-62.4-72.6-52.5-99.1-16.4v133.4c0 41.5-63.3 41.8-63.3 0V208c0-40 63.1-41.6 63.1 0v3.4c43.3-51.6 162.4-60.4 162.4 39.3v141.5c.3 30.4-31.5 31.4-31.7 31.4zm179.7 2.9c-44.3 0-68.3-22.9-68.3-65.8V235.2H1488c-35.6 0-36.7-55.3 0-55.3h15.5v-37.3c0-41.3 63.8-42.1 63.8 0v37.5h24.9c35.4 0 35.7 55.3 0 55.3h-24.9v108.5c0 29.6 26.1 26.3 27.4 26.3 31.4 0 52.6 56.3-22.9 56.3zM1992 123c-19.5-50.2-95.5-50-114.5 0-107.3 275.7-99.5 252.7-99.5 262.8 0 42.8 58.3 51.2 72.1 14.4l13.5-35.9H2006l13 35.9c14.2 37.7 72.1 27.2 72.1-14.4 0-10.1 5.3 6.8-99.1-262.8zm-108.9 179.1l51.7-142.9 51.8 142.9h-103.5zm591.3-85.6l-53.7 176.3c-12.4 41.2-72 41-84 0l-42.3-135.9-42.3 135.9c-12.4 40.9-72 41.2-84.5 0l-54.2-176.3c-12.5-39.4 49.8-56.1 60.2-16.9L2213 342l45.3-139.5c10.9-32.7 59.6-34.7 71.2 0l45.3 139.5 39.3-142.4c10.3-38.3 72.6-23.8 60.3 16.9zm275.4 75.1c0-42.4-33.9-117.5-119.5-117.5-73.2 0-124.4 56.3-124.4 126 0 77.2 55.3 126.4 128.5 126.4 31.7 0 93-11.5 93-39.8 0-18.3-21.1-31.5-39.3-22.4-49.4 26.2-109 8.4-115.9-43.8h148.3c16.3 0 29.3-13.4 29.3-28.9zM2571 277.7c9.5-73.4 113.9-68.6 118.6 0H2571zm316.7 148.8c-31.4 0-81.6-10.5-96.6-31.9-12.4-17 2.5-39.8 21.8-39.8 16.3 0 36.8 22.9 77.7 22.9 27.4 0 40.4-11 40.4-25.8 0-39.8-142.9-7.4-142.9-102 0-40.4 35.3-75.7 98.6-75.7 31.4 0 74.1 9.9 87.6 29.4 10.8 14.8-1.4 36.2-20.9 36.2-15.1 0-26.7-17.3-66.2-17.3-22.9 0-37.8 10.5-37.8 23.8 0 35.9 142.4 6 142.4 103.1-.1 43.7-37.4 77.1-104.1 77.1zm266.8-252.4c-169.3 0-169.1 252.4 0 252.4 170.1 0 169.6-252.4 0-252.4zm0 196.1c-81.8 0-82-139.8 0-139.8 82.5 0 82.4 139.8 0 139.8zm476.9 22V268.7c0-53.8-61.4-45.8-85.7-10.5v134c0 41.3-63.8 42.1-63.8 0V268.7c0-52.1-59.5-47.4-85.7-10.1v133.6c0 41.5-63.3 41.8-63.3 0V208c0-40 63.1-41.6 63.1 0v3.4c9.9-14.4 41.8-37.3 78.6-37.3 35.3 0 57.7 16.4 66.7 43.8 13.9-21.8 45.8-43.8 82.6-43.8 44.3 0 70.7 23.4 70.7 72.7v145.3c.5 17.3-13.5 31.4-31.9 31.4 3.5.1-31.3 1.1-31.3-31.3zM3992 291.6c0-42.4-32.4-117.5-117.9-117.5-73.2 0-127.5 56.3-127.5 126 0 77.2 58.3 126.4 131.6 126.4 31.7 0 91.5-11.5 91.5-39.8 0-18.3-21.1-31.5-39.3-22.4-49.4 26.2-110.5 8.4-117.5-43.8h149.8c16.3 0 29.1-13.4 29.3-28.9zm-180.5-13.9c9.7-74.4 115.9-68.3 120.1 0h-120.1z"]
};
var faFootballBall = {
  prefix: 'fas',
  iconName: 'football-ball',
  icon: [496, 512, [], "f44e", "M481.5 60.3c-4.8-18.2-19.1-32.5-37.3-37.4C420.3 16.5 383 8.9 339.4 8L496 164.8c-.8-43.5-8.2-80.6-14.5-104.5zm-467 391.4c4.8 18.2 19.1 32.5 37.3 37.4 23.9 6.4 61.2 14 104.8 14.9L0 347.2c.8 43.5 8.2 80.6 14.5 104.5zM4.2 283.4L220.4 500c132.5-19.4 248.8-118.7 271.5-271.4L275.6 12C143.1 31.4 26.8 130.7 4.2 283.4zm317.3-123.6c3.1-3.1 8.2-3.1 11.3 0l11.3 11.3c3.1 3.1 3.1 8.2 0 11.3l-28.3 28.3 28.3 28.3c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-28.3-28.3-22.6 22.7 28.3 28.3c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0L248 278.6l-22.6 22.6 28.3 28.3c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-28.3-28.3-28.3 28.3c-3.1 3.1-8.2 3.1-11.3 0l-11.3-11.3c-3.1-3.1-3.1-8.2 0-11.3l28.3-28.3-28.3-28.2c-3.1-3.1-3.1-8.2 0-11.3l11.3-11.3c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3 22.6-22.6-28.3-28.3c-3.1-3.1-3.1-8.2 0-11.3l11.3-11.3c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3 22.6-22.6-28.3-28.3c-3.1-3.1-3.1-8.2 0-11.3l11.3-11.3c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3 28.3-28.5z"]
};
var faForward = {
  prefix: 'fas',
  iconName: 'forward',
  icon: [512, 512, [], "f04e", "M500.5 231.4l-192-160C287.9 54.3 256 68.6 256 96v320c0 27.4 31.9 41.8 52.5 24.6l192-160c15.3-12.8 15.3-36.4 0-49.2zm-256 0l-192-160C31.9 54.3 0 68.6 0 96v320c0 27.4 31.9 41.8 52.5 24.6l192-160c15.3-12.8 15.3-36.4 0-49.2z"]
};
var faFrog = {
  prefix: 'fas',
  iconName: 'frog',
  icon: [576, 512, [], "f52e", "M446.53 97.43C439.67 60.23 407.19 32 368 32c-39.23 0-71.72 28.29-78.54 65.54C126.75 112.96-.5 250.12 0 416.98.11 451.9 29.08 480 64 480h304c8.84 0 16-7.16 16-16 0-17.67-14.33-32-32-32h-79.49l35.8-48.33c24.14-36.23 10.35-88.28-33.71-106.6-23.89-9.93-51.55-4.65-72.24 10.88l-32.76 24.59c-7.06 5.31-17.09 3.91-22.41-3.19-5.3-7.08-3.88-17.11 3.19-22.41l34.78-26.09c36.84-27.66 88.28-27.62 125.13 0 10.87 8.15 45.87 39.06 40.8 93.21L469.62 480H560c8.84 0 16-7.16 16-16 0-17.67-14.33-32-32-32h-53.63l-98.52-104.68 154.44-86.65A58.16 58.16 0 0 0 576 189.94c0-21.4-11.72-40.95-30.48-51.23-40.56-22.22-98.99-41.28-98.99-41.28zM368 136c-13.26 0-24-10.75-24-24 0-13.26 10.74-24 24-24 13.25 0 24 10.74 24 24 0 13.25-10.75 24-24 24z"]
};
var faFrown = {
  prefix: 'fas',
  iconName: 'frown',
  icon: [496, 512, [], "f119", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm-160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm170.2 218.2C315.8 367.4 282.9 352 248 352s-67.8 15.4-90.2 42.2c-13.5 16.3-38.1-4.2-24.6-20.5C161.7 339.6 203.6 320 248 320s86.3 19.6 114.7 53.8c13.6 16.2-11 36.7-24.5 20.4z"]
};
var faFrownOpen = {
  prefix: 'fas',
  iconName: 'frown-open',
  icon: [496, 512, [], "f57a", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM136 208c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm187.3 183.3c-31.2-9.6-59.4-15.3-75.3-15.3s-44.1 5.7-75.3 15.3c-11.5 3.5-22.5-6.3-20.5-18.1 7-40 60.1-61.2 95.8-61.2s88.8 21.3 95.8 61.2c2 11.9-9.1 21.6-20.5 18.1zM328 240c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"]
};
var faFunnelDollar = {
  prefix: 'fas',
  iconName: 'funnel-dollar',
  icon: [640, 512, [], "f662", "M433.46 165.94l101.2-111.87C554.61 34.12 540.48 0 512.26 0H31.74C3.52 0-10.61 34.12 9.34 54.07L192 256v155.92c0 12.59 5.93 24.44 16 32l79.99 60c20.86 15.64 48.47 6.97 59.22-13.57C310.8 455.38 288 406.35 288 352c0-89.79 62.05-165.17 145.46-186.06zM480 192c-88.37 0-160 71.63-160 160s71.63 160 160 160 160-71.63 160-160-71.63-160-160-160zm16 239.88V448c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-16.29c-11.29-.58-22.27-4.52-31.37-11.35-3.9-2.93-4.1-8.77-.57-12.14l11.75-11.21c2.77-2.64 6.89-2.76 10.13-.73 3.87 2.42 8.26 3.72 12.82 3.72h28.11c6.5 0 11.8-5.92 11.8-13.19 0-5.95-3.61-11.19-8.77-12.73l-45-13.5c-18.59-5.58-31.58-23.42-31.58-43.39 0-24.52 19.05-44.44 42.67-45.07V256c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16.29c11.29.58 22.27 4.51 31.37 11.35 3.9 2.93 4.1 8.77.57 12.14l-11.75 11.21c-2.77 2.64-6.89 2.76-10.13.73-3.87-2.43-8.26-3.72-12.82-3.72h-28.11c-6.5 0-11.8 5.92-11.8 13.19 0 5.95 3.61 11.19 8.77 12.73l45 13.5c18.59 5.58 31.58 23.42 31.58 43.39 0 24.53-19.04 44.44-42.67 45.07z"]
};
var faFutbol = {
  prefix: 'fas',
  iconName: 'futbol',
  icon: [512, 512, [], "f1e3", "M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zm-48 0l-.003-.282-26.064 22.741-62.679-58.5 16.454-84.355 34.303 3.072c-24.889-34.216-60.004-60.089-100.709-73.141l13.651 31.939L256 139l-74.953-41.525 13.651-31.939c-40.631 13.028-75.78 38.87-100.709 73.141l34.565-3.073 16.192 84.355-62.678 58.5-26.064-22.741-.003.282c0 43.015 13.497 83.952 38.472 117.991l7.704-33.897 85.138 10.447 36.301 77.826-29.902 17.786c40.202 13.122 84.29 13.148 124.572 0l-29.902-17.786 36.301-77.826 85.138-10.447 7.704 33.897C442.503 339.952 456 299.015 456 256zm-248.102 69.571l-29.894-91.312L256 177.732l77.996 56.527-29.622 91.312h-96.476z"]
};
var faGamepad = {
  prefix: 'fas',
  iconName: 'gamepad',
  icon: [640, 512, [], "f11b", "M480.07 96H160a160 160 0 1 0 114.24 272h91.52A160 160 0 1 0 480.07 96zM248 268a12 12 0 0 1-12 12h-52v52a12 12 0 0 1-12 12h-24a12 12 0 0 1-12-12v-52H84a12 12 0 0 1-12-12v-24a12 12 0 0 1 12-12h52v-52a12 12 0 0 1 12-12h24a12 12 0 0 1 12 12v52h52a12 12 0 0 1 12 12zm216 76a40 40 0 1 1 40-40 40 40 0 0 1-40 40zm64-96a40 40 0 1 1 40-40 40 40 0 0 1-40 40z"]
};
var faGasPump = {
  prefix: 'fas',
  iconName: 'gas-pump',
  icon: [512, 512, [], "f52f", "M336 448H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm157.2-340.7l-81-81c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-6.2 6.2-6.2 16.4 0 22.6L416 97.9V160c0 28.1 20.9 51.3 48 55.2V376c0 13.2-10.8 24-24 24s-24-10.8-24-24v-32c0-48.6-39.4-88-88-88h-8V64c0-35.3-28.7-64-64-64H96C60.7 0 32 28.7 32 64v352h288V304h8c22.1 0 40 17.9 40 40v27.8c0 37.7 27 72 64.5 75.9 43 4.3 79.5-29.5 79.5-71.7V152.6c0-17-6.8-33.3-18.8-45.3zM256 192H96V64h160v128z"]
};
var faGavel = {
  prefix: 'fas',
  iconName: 'gavel',
  icon: [512, 512, [], "f0e3", "M504.971 199.362l-22.627-22.627c-9.373-9.373-24.569-9.373-33.941 0l-5.657 5.657L329.608 69.255l5.657-5.657c9.373-9.373 9.373-24.569 0-33.941L312.638 7.029c-9.373-9.373-24.569-9.373-33.941 0L154.246 131.48c-9.373 9.373-9.373 24.569 0 33.941l22.627 22.627c9.373 9.373 24.569 9.373 33.941 0l5.657-5.657 39.598 39.598-81.04 81.04-5.657-5.657c-12.497-12.497-32.758-12.497-45.255 0L9.373 412.118c-12.497 12.497-12.497 32.758 0 45.255l45.255 45.255c12.497 12.497 32.758 12.497 45.255 0l114.745-114.745c12.497-12.497 12.497-32.758 0-45.255l-5.657-5.657 81.04-81.04 39.598 39.598-5.657 5.657c-9.373 9.373-9.373 24.569 0 33.941l22.627 22.627c9.373 9.373 24.569 9.373 33.941 0l124.451-124.451c9.372-9.372 9.372-24.568 0-33.941z"]
};
var faGem = {
  prefix: 'fas',
  iconName: 'gem',
  icon: [576, 512, [], "f3a5", "M485.5 0L576 160H474.9L405.7 0h79.8zm-128 0l69.2 160H149.3L218.5 0h139zm-267 0h79.8l-69.2 160H0L90.5 0zM0 192h100.7l123 251.7c1.5 3.1-2.7 5.9-5 3.3L0 192zm148.2 0h279.6l-137 318.2c-1 2.4-4.5 2.4-5.5 0L148.2 192zm204.1 251.7l123-251.7H576L357.3 446.9c-2.3 2.7-6.5-.1-5-3.2z"]
};
var faGenderless = {
  prefix: 'fas',
  iconName: 'genderless',
  icon: [288, 512, [], "f22d", "M144 176c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80m0-64C64.5 112 0 176.5 0 256s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144z"]
};
var faGhost = {
  prefix: 'fas',
  iconName: 'ghost',
  icon: [384, 512, [], "f6e2", "M186.1.09C81.01 3.24 0 94.92 0 200.05v263.92c0 14.26 17.23 21.39 27.31 11.31l24.92-18.53c6.66-4.95 16-3.99 21.51 2.21l42.95 48.35c6.25 6.25 16.38 6.25 22.63 0l40.72-45.85c6.37-7.17 17.56-7.17 23.92 0l40.72 45.85c6.25 6.25 16.38 6.25 22.63 0l42.95-48.35c5.51-6.2 14.85-7.17 21.51-2.21l24.92 18.53c10.08 10.08 27.31 2.94 27.31-11.31V192C384 84 294.83-3.17 186.1.09zM128 224c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm128 0c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"]
};
var faGift = {
  prefix: 'fas',
  iconName: 'gift',
  icon: [512, 512, [], "f06b", "M32 448c0 17.7 14.3 32 32 32h160V320H32v128zm256 32h160c17.7 0 32-14.3 32-32V320H288v160zm192-320h-42.1c6.2-12.1 10.1-25.5 10.1-40 0-48.5-39.5-88-88-88-41.6 0-68.5 21.3-103 68.3-34.5-47-61.4-68.3-103-68.3-48.5 0-88 39.5-88 88 0 14.5 3.8 27.9 10.1 40H32c-17.7 0-32 14.3-32 32v80c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16v-80c0-17.7-14.3-32-32-32zm-326.1 0c-22.1 0-40-17.9-40-40s17.9-40 40-40c19.9 0 34.6 3.3 86.1 80h-86.1zm206.1 0h-86.1c51.4-76.5 65.7-80 86.1-80 22.1 0 40 17.9 40 40s-17.9 40-40 40z"]
};
var faGifts = {
  prefix: 'fas',
  iconName: 'gifts',
  icon: [640, 512, [], "f79c", "M240.6 194.1c1.9-30.8 17.3-61.2 44-79.8C279.4 103.5 268.7 96 256 96h-29.4l30.7-22c7.2-5.1 8.9-15.1 3.7-22.3l-9.3-13c-5.1-7.2-15.1-8.9-22.3-3.7l-32 22.9 11.5-30.6c3.1-8.3-1.1-17.5-9.4-20.6l-15-5.6c-8.3-3.1-17.5 1.1-20.6 9.4l-19.9 53-19.9-53.1C121 2.1 111.8-2.1 103.5 1l-15 5.6C80.2 9.7 76 19 79.2 27.2l11.5 30.6L58.6 35c-7.2-5.1-17.2-3.5-22.3 3.7l-9.3 13c-5.1 7.2-3.5 17.2 3.7 22.3l30.7 22H32c-17.7 0-32 14.3-32 32v352c0 17.7 14.3 32 32 32h168.9c-5.5-9.5-8.9-20.3-8.9-32V256c0-29.9 20.8-55 48.6-61.9zM224 480c0 17.7 14.3 32 32 32h160V384H224v96zm224 32h160c17.7 0 32-14.3 32-32v-96H448v128zm160-288h-20.4c2.6-7.6 4.4-15.5 4.4-23.8 0-35.5-27-72.2-72.1-72.2-48.1 0-75.9 47.7-87.9 75.3-12.1-27.6-39.9-75.3-87.9-75.3-45.1 0-72.1 36.7-72.1 72.2 0 8.3 1.7 16.2 4.4 23.8H256c-17.7 0-32 14.3-32 32v96h192V224h15.3l.7-.2.7.2H448v128h192v-96c0-17.7-14.3-32-32-32zm-272 0c-2.7-1.4-5.1-3-7.2-4.8-7.3-6.4-8.8-13.8-8.8-19 0-9.7 6.4-24.2 24.1-24.2 18.7 0 35.6 27.4 44.5 48H336zm199.2-4.8c-2.1 1.8-4.5 3.4-7.2 4.8h-52.6c8.8-20.3 25.8-48 44.5-48 17.7 0 24.1 14.5 24.1 24.2 0 5.2-1.5 12.6-8.8 19z"]
};
var faGlassCheers = {
  prefix: 'fas',
  iconName: 'glass-cheers',
  icon: [640, 512, [], "f79f", "M639.4 433.6c-8.4-20.4-31.8-30.1-52.2-21.6l-22.1 9.2-38.7-101.9c47.9-35 64.8-100.3 34.5-152.8L474.3 16c-8-13.9-25.1-19.7-40-13.6L320 49.8 205.7 2.4c-14.9-6.2-32-.3-40 13.6L79.1 166.5C48.9 219 65.7 284.3 113.6 319.2L74.9 421.1l-22.1-9.2c-20.4-8.5-43.7 1.2-52.2 21.6-1.7 4.1.2 8.8 4.3 10.5l162.3 67.4c4.1 1.7 8.7-.2 10.4-4.3 8.4-20.4-1.2-43.8-21.6-52.3l-22.1-9.2L173.3 342c4.4.5 8.8 1.3 13.1 1.3 51.7 0 99.4-33.1 113.4-85.3l20.2-75.4 20.2 75.4c14 52.2 61.7 85.3 113.4 85.3 4.3 0 8.7-.8 13.1-1.3L506 445.6l-22.1 9.2c-20.4 8.5-30.1 31.9-21.6 52.3 1.7 4.1 6.4 6 10.4 4.3L635.1 444c4-1.7 6-6.3 4.3-10.4zM275.9 162.1l-112.1-46.5 36.5-63.4 94.5 39.2-18.9 70.7zm88.2 0l-18.9-70.7 94.5-39.2 36.5 63.4-112.1 46.5z"]
};
var faGlassMartini = {
  prefix: 'fas',
  iconName: 'glass-martini',
  icon: [512, 512, [], "f000", "M502.05 57.6C523.3 36.34 508.25 0 478.2 0H33.8C3.75 0-11.3 36.34 9.95 57.6L224 271.64V464h-56c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h240c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40h-56V271.64L502.05 57.6z"]
};
var faGlassMartiniAlt = {
  prefix: 'fas',
  iconName: 'glass-martini-alt',
  icon: [512, 512, [], "f57b", "M502.05 57.6C523.3 36.34 508.25 0 478.2 0H33.8C3.75 0-11.3 36.34 9.95 57.6L224 271.64V464h-56c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h240c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40h-56V271.64L502.05 57.6zM443.77 48l-48 48H116.24l-48-48h375.53z"]
};
var faGlassWhiskey = {
  prefix: 'fas',
  iconName: 'glass-whiskey',
  icon: [512, 512, [], "f7a0", "M480 32H32C12.5 32-2.4 49.2.3 68.5l56 356.5c4.5 31.5 31.5 54.9 63.4 54.9h273c31.8 0 58.9-23.4 63.4-54.9l55.6-356.5C514.4 49.2 499.5 32 480 32zm-37.4 64l-30 192h-313L69.4 96h373.2z"]
};
var faGlasses = {
  prefix: 'fas',
  iconName: 'glasses',
  icon: [576, 512, [], "f530", "M574.1 280.37L528.75 98.66c-5.91-23.7-21.59-44.05-43-55.81-21.44-11.73-46.97-14.11-70.19-6.33l-15.25 5.08c-8.39 2.79-12.92 11.86-10.12 20.24l5.06 15.18c2.79 8.38 11.85 12.91 20.23 10.12l13.18-4.39c10.87-3.62 23-3.57 33.16 1.73 10.29 5.37 17.57 14.56 20.37 25.82l38.46 153.82c-22.19-6.81-49.79-12.46-81.2-12.46-34.77 0-73.98 7.02-114.85 26.74h-73.18c-40.87-19.74-80.08-26.75-114.86-26.75-31.42 0-59.02 5.65-81.21 12.46l38.46-153.83c2.79-11.25 10.09-20.45 20.38-25.81 10.16-5.3 22.28-5.35 33.15-1.73l13.17 4.39c8.38 2.79 17.44-1.74 20.23-10.12l5.06-15.18c2.8-8.38-1.73-17.45-10.12-20.24l-15.25-5.08c-23.22-7.78-48.75-5.41-70.19 6.33-21.41 11.77-37.09 32.11-43 55.8L1.9 280.37A64.218 64.218 0 0 0 0 295.86v70.25C0 429.01 51.58 480 115.2 480h37.12c60.28 0 110.37-45.94 114.88-105.37l2.93-38.63h35.75l2.93 38.63C313.31 434.06 363.4 480 423.68 480h37.12c63.62 0 115.2-50.99 115.2-113.88v-70.25c0-5.23-.64-10.43-1.9-15.5zm-370.72 89.42c-1.97 25.91-24.4 46.21-51.06 46.21H115.2C86.97 416 64 393.62 64 366.11v-37.54c18.12-6.49 43.42-12.92 72.58-12.92 23.86 0 47.26 4.33 69.93 12.92l-3.13 41.22zM512 366.12c0 27.51-22.97 49.88-51.2 49.88h-37.12c-26.67 0-49.1-20.3-51.06-46.21l-3.13-41.22c22.67-8.59 46.08-12.92 69.95-12.92 29.12 0 54.43 6.44 72.55 12.93v37.54z"]
};
var faGlobe = {
  prefix: 'fas',
  iconName: 'globe',
  icon: [496, 512, [], "f0ac", "M336.5 160C322 70.7 287.8 8 248 8s-74 62.7-88.5 152h177zM152 256c0 22.2 1.2 43.5 3.3 64h185.3c2.1-20.5 3.3-41.8 3.3-64s-1.2-43.5-3.3-64H155.3c-2.1 20.5-3.3 41.8-3.3 64zm324.7-96c-28.6-67.9-86.5-120.4-158-141.6 24.4 33.8 41.2 84.7 50 141.6h108zM177.2 18.4C105.8 39.6 47.8 92.1 19.3 160h108c8.7-56.9 25.5-107.8 49.9-141.6zM487.4 192H372.7c2.1 21 3.3 42.5 3.3 64s-1.2 43-3.3 64h114.6c5.5-20.5 8.6-41.8 8.6-64s-3.1-43.5-8.5-64zM120 256c0-21.5 1.2-43 3.3-64H8.6C3.2 212.5 0 233.8 0 256s3.2 43.5 8.6 64h114.6c-2-21-3.2-42.5-3.2-64zm39.5 96c14.5 89.3 48.7 152 88.5 152s74-62.7 88.5-152h-177zm159.3 141.6c71.4-21.2 129.4-73.7 158-141.6h-108c-8.8 56.9-25.6 107.8-50 141.6zM19.3 352c28.6 67.9 86.5 120.4 158 141.6-24.4-33.8-41.2-84.7-50-141.6h-108z"]
};
var faGlobeAfrica = {
  prefix: 'fas',
  iconName: 'globe-africa',
  icon: [496, 512, [], "f57c", "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm160 215.5v6.93c0 5.87-3.32 11.24-8.57 13.86l-15.39 7.7a15.485 15.485 0 0 1-15.53-.97l-18.21-12.14a15.52 15.52 0 0 0-13.5-1.81l-2.65.88c-9.7 3.23-13.66 14.79-7.99 23.3l13.24 19.86c2.87 4.31 7.71 6.9 12.89 6.9h8.21c8.56 0 15.5 6.94 15.5 15.5v11.34c0 3.35-1.09 6.62-3.1 9.3l-18.74 24.98c-1.42 1.9-2.39 4.1-2.83 6.43l-4.3 22.83c-.62 3.29-2.29 6.29-4.76 8.56a159.608 159.608 0 0 0-25 29.16l-13.03 19.55a27.756 27.756 0 0 1-23.09 12.36c-10.51 0-20.12-5.94-24.82-15.34a78.902 78.902 0 0 1-8.33-35.29V367.5c0-8.56-6.94-15.5-15.5-15.5h-25.88c-14.49 0-28.38-5.76-38.63-16a54.659 54.659 0 0 1-16-38.63v-14.06c0-17.19 8.1-33.38 21.85-43.7l27.58-20.69a54.663 54.663 0 0 1 32.78-10.93h.89c8.48 0 16.85 1.97 24.43 5.77l14.72 7.36c3.68 1.84 7.93 2.14 11.83.84l47.31-15.77c6.33-2.11 10.6-8.03 10.6-14.7 0-8.56-6.94-15.5-15.5-15.5h-10.09c-4.11 0-8.05-1.63-10.96-4.54l-6.92-6.92a15.493 15.493 0 0 0-10.96-4.54H199.5c-8.56 0-15.5-6.94-15.5-15.5v-4.4c0-7.11 4.84-13.31 11.74-15.04l14.45-3.61c3.74-.94 7-3.23 9.14-6.44l8.08-12.11c2.87-4.31 7.71-6.9 12.89-6.9h24.21c8.56 0 15.5-6.94 15.5-15.5v-21.7C359.23 71.63 422.86 131.02 441.93 208H423.5c-8.56 0-15.5 6.94-15.5 15.5z"]
};
var faGlobeAmericas = {
  prefix: 'fas',
  iconName: 'globe-americas',
  icon: [496, 512, [], "f57d", "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm82.29 357.6c-3.9 3.88-7.99 7.95-11.31 11.28-2.99 3-5.1 6.7-6.17 10.71-1.51 5.66-2.73 11.38-4.77 16.87l-17.39 46.85c-13.76 3-28 4.69-42.65 4.69v-27.38c1.69-12.62-7.64-36.26-22.63-51.25-6-6-9.37-14.14-9.37-22.63v-32.01c0-11.64-6.27-22.34-16.46-27.97-14.37-7.95-34.81-19.06-48.81-26.11-11.48-5.78-22.1-13.14-31.65-21.75l-.8-.72a114.792 114.792 0 0 1-18.06-20.74c-9.38-13.77-24.66-36.42-34.59-51.14 20.47-45.5 57.36-82.04 103.2-101.89l24.01 12.01C203.48 89.74 216 82.01 216 70.11v-11.3c7.99-1.29 16.12-2.11 24.39-2.42l28.3 28.3c6.25 6.25 6.25 16.38 0 22.63L264 112l-10.34 10.34c-3.12 3.12-3.12 8.19 0 11.31l4.69 4.69c3.12 3.12 3.12 8.19 0 11.31l-8 8a8.008 8.008 0 0 1-5.66 2.34h-8.99c-2.08 0-4.08.81-5.58 2.27l-9.92 9.65a8.008 8.008 0 0 0-1.58 9.31l15.59 31.19c2.66 5.32-1.21 11.58-7.15 11.58h-5.64c-1.93 0-3.79-.7-5.24-1.96l-9.28-8.06a16.017 16.017 0 0 0-15.55-3.1l-31.17 10.39a11.95 11.95 0 0 0-8.17 11.34c0 4.53 2.56 8.66 6.61 10.69l11.08 5.54c9.41 4.71 19.79 7.16 30.31 7.16s22.59 27.29 32 32h66.75c8.49 0 16.62 3.37 22.63 9.37l13.69 13.69a30.503 30.503 0 0 1 8.93 21.57 46.536 46.536 0 0 1-13.72 32.98zM417 274.25c-5.79-1.45-10.84-5-14.15-9.97l-17.98-26.97a23.97 23.97 0 0 1 0-26.62l19.59-29.38c2.32-3.47 5.5-6.29 9.24-8.15l12.98-6.49C440.2 193.59 448 223.87 448 256c0 8.67-.74 17.16-1.82 25.54L417 274.25z"]
};
var faGlobeAsia = {
  prefix: 'fas',
  iconName: 'globe-asia',
  icon: [496, 512, [], "f57e", "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm-11.34 240.23c-2.89 4.82-8.1 7.77-13.72 7.77h-.31c-4.24 0-8.31 1.69-11.31 4.69l-5.66 5.66c-3.12 3.12-3.12 8.19 0 11.31l5.66 5.66c3 3 4.69 7.07 4.69 11.31V304c0 8.84-7.16 16-16 16h-6.11c-6.06 0-11.6-3.42-14.31-8.85l-22.62-45.23c-2.44-4.88-8.95-5.94-12.81-2.08l-19.47 19.46c-3 3-7.07 4.69-11.31 4.69H50.81C49.12 277.55 48 266.92 48 256c0-110.28 89.72-200 200-200 21.51 0 42.2 3.51 61.63 9.82l-50.16 38.53c-5.11 3.41-4.63 11.06.86 13.81l10.83 5.41c5.42 2.71 8.84 8.25 8.84 14.31V216c0 4.42-3.58 8-8 8h-3.06c-3.03 0-5.8-1.71-7.15-4.42-1.56-3.12-5.96-3.29-7.76-.3l-17.37 28.95zM408 358.43c0 4.24-1.69 8.31-4.69 11.31l-9.57 9.57c-3 3-7.07 4.69-11.31 4.69h-15.16c-4.24 0-8.31-1.69-11.31-4.69l-13.01-13.01a26.767 26.767 0 0 0-25.42-7.04l-21.27 5.32c-1.27.32-2.57.48-3.88.48h-10.34c-4.24 0-8.31-1.69-11.31-4.69l-11.91-11.91a8.008 8.008 0 0 1-2.34-5.66v-10.2c0-3.27 1.99-6.21 5.03-7.43l39.34-15.74c1.98-.79 3.86-1.82 5.59-3.05l23.71-16.89a7.978 7.978 0 0 1 4.64-1.48h12.09c3.23 0 6.15 1.94 7.39 4.93l5.35 12.85a4 4 0 0 0 3.69 2.46h3.8c1.78 0 3.35-1.18 3.84-2.88l4.2-14.47c.5-1.71 2.06-2.88 3.84-2.88h6.06c2.21 0 4 1.79 4 4v12.93c0 2.12.84 4.16 2.34 5.66l11.91 11.91c3 3 4.69 7.07 4.69 11.31v24.6z"]
};
var faGlobeEurope = {
  prefix: 'fas',
  iconName: 'globe-europe',
  icon: [496, 512, [], "f7a2", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm200 248c0 22.5-3.9 44.2-10.8 64.4h-20.3c-4.3 0-8.4-1.7-11.4-4.8l-32-32.6c-4.5-4.6-4.5-12.1.1-16.7l12.5-12.5v-8.7c0-3-1.2-5.9-3.3-8l-9.4-9.4c-2.1-2.1-5-3.3-8-3.3h-16c-6.2 0-11.3-5.1-11.3-11.3 0-3 1.2-5.9 3.3-8l9.4-9.4c2.1-2.1 5-3.3 8-3.3h32c6.2 0 11.3-5.1 11.3-11.3v-9.4c0-6.2-5.1-11.3-11.3-11.3h-36.7c-8.8 0-16 7.2-16 16v4.5c0 6.9-4.4 13-10.9 15.2l-31.6 10.5c-3.3 1.1-5.5 4.1-5.5 7.6v2.2c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8s-3.6-8-8-8H247c-3 0-5.8 1.7-7.2 4.4l-9.4 18.7c-2.7 5.4-8.2 8.8-14.3 8.8H194c-8.8 0-16-7.2-16-16V199c0-4.2 1.7-8.3 4.7-11.3l20.1-20.1c4.6-4.6 7.2-10.9 7.2-17.5 0-3.4 2.2-6.5 5.5-7.6l40-13.3c1.7-.6 3.2-1.5 4.4-2.7l26.8-26.8c2.1-2.1 3.3-5 3.3-8 0-6.2-5.1-11.3-11.3-11.3H258l-16 16v8c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8v-20c0-2.5 1.2-4.9 3.2-6.4l28.9-21.7c1.9-.1 3.8-.3 5.7-.3C358.3 56 448 145.7 448 256zM130.1 149.1c0-3 1.2-5.9 3.3-8l25.4-25.4c2.1-2.1 5-3.3 8-3.3 6.2 0 11.3 5.1 11.3 11.3v16c0 3-1.2 5.9-3.3 8l-9.4 9.4c-2.1 2.1-5 3.3-8 3.3h-16c-6.2 0-11.3-5.1-11.3-11.3zm128 306.4v-7.1c0-8.8-7.2-16-16-16h-20.2c-10.8 0-26.7-5.3-35.4-11.8l-22.2-16.7c-11.5-8.6-18.2-22.1-18.2-36.4v-23.9c0-16 8.4-30.8 22.1-39l42.9-25.7c7.1-4.2 15.2-6.5 23.4-6.5h31.2c10.9 0 21.4 3.9 29.6 10.9l43.2 37.1h18.3c8.5 0 16.6 3.4 22.6 9.4l17.3 17.3c3.4 3.4 8.1 5.3 12.9 5.3H423c-32.4 58.9-93.8 99.5-164.9 103.1z"]
};
var faGolfBall = {
  prefix: 'fas',
  iconName: 'golf-ball',
  icon: [416, 512, [], "f450", "M96 416h224c0 17.7-14.3 32-32 32h-16c-17.7 0-32 14.3-32 32v20c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-20c0-17.7-14.3-32-32-32h-16c-17.7 0-32-14.3-32-32zm320-208c0 74.2-39 139.2-97.5 176h-221C39 347.2 0 282.2 0 208 0 93.1 93.1 0 208 0s208 93.1 208 208zm-180.1 43.9c18.3 0 33.1-14.8 33.1-33.1 0-14.4-9.3-26.3-22.1-30.9 9.6 26.8-15.6 51.3-41.9 41.9 4.6 12.8 16.5 22.1 30.9 22.1zm49.1 46.9c0-14.4-9.3-26.3-22.1-30.9 9.6 26.8-15.6 51.3-41.9 41.9 4.6 12.8 16.5 22.1 30.9 22.1 18.3 0 33.1-14.9 33.1-33.1zm64-64c0-14.4-9.3-26.3-22.1-30.9 9.6 26.8-15.6 51.3-41.9 41.9 4.6 12.8 16.5 22.1 30.9 22.1 18.3 0 33.1-14.9 33.1-33.1z"]
};
var faGopuram = {
  prefix: 'fas',
  iconName: 'gopuram',
  icon: [512, 512, [], "f664", "M496 352h-16V240c0-8.8-7.2-16-16-16h-16v-80c0-8.8-7.2-16-16-16h-16V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h-64V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h-64V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h-64V16c0-8.8-7.2-16-16-16S96 7.2 96 16v112H80c-8.8 0-16 7.2-16 16v80H48c-8.8 0-16 7.2-16 16v112H16c-8.8 0-16 7.2-16 16v128c0 8.8 7.2 16 16 16h80V352h32V224h32v-96h32v96h-32v128h-32v160h80v-80c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16v80h80V352h-32V224h-32v-96h32v96h32v128h32v160h80c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16zM232 176c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v48h-48zm56 176h-64v-64c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16z"]
};
var faGraduationCap = {
  prefix: 'fas',
  iconName: 'graduation-cap',
  icon: [640, 512, [], "f19d", "M622.34 153.2L343.4 67.5c-15.2-4.67-31.6-4.67-46.79 0L17.66 153.2c-23.54 7.23-23.54 38.36 0 45.59l48.63 14.94c-10.67 13.19-17.23 29.28-17.88 46.9C38.78 266.15 32 276.11 32 288c0 10.78 5.68 19.85 13.86 25.65L20.33 428.53C18.11 438.52 25.71 448 35.94 448h56.11c10.24 0 17.84-9.48 15.62-19.47L82.14 313.65C90.32 307.85 96 298.78 96 288c0-11.57-6.47-21.25-15.66-26.87.76-15.02 8.44-28.3 20.69-36.72L296.6 284.5c9.06 2.78 26.44 6.25 46.79 0l278.95-85.7c23.55-7.24 23.55-38.36 0-45.6zM352.79 315.09c-28.53 8.76-52.84 3.92-65.59 0l-145.02-44.55L128 384c0 35.35 85.96 64 192 64s192-28.65 192-64l-14.18-113.47-145.03 44.56z"]
};
var faGreaterThan = {
  prefix: 'fas',
  iconName: 'greater-than',
  icon: [384, 512, [], "f531", "M365.52 209.85L59.22 67.01c-16.06-7.49-35.15-.54-42.64 15.52L3.01 111.61c-7.49 16.06-.54 35.15 15.52 42.64L236.96 256.1 18.49 357.99C2.47 365.46-4.46 384.5 3.01 400.52l13.52 29C24 445.54 43.04 452.47 59.06 445l306.47-142.91a32.003 32.003 0 0 0 18.48-29v-34.23c-.01-12.45-7.21-23.76-18.49-29.01z"]
};
var faGreaterThanEqual = {
  prefix: 'fas',
  iconName: 'greater-than-equal',
  icon: [448, 512, [], "f532", "M55.22 107.69l175.56 68.09-175.44 68.05c-18.39 6.03-27.88 24.39-21.2 41l12.09 30.08c6.68 16.61 26.99 25.19 45.38 19.15L393.02 214.2c13.77-4.52 22.98-16.61 22.98-30.17v-15.96c0-13.56-9.21-25.65-22.98-30.17L91.3 17.92c-18.29-6-38.51 2.53-45.15 19.06L34.12 66.9c-6.64 16.53 2.81 34.79 21.1 40.79zM424 400H24c-13.25 0-24 10.74-24 24v48c0 13.25 10.75 24 24 24h400c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24z"]
};
var faGrimace = {
  prefix: 'fas',
  iconName: 'grimace',
  icon: [496, 512, [], "f57f", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM144 400h-8c-17.7 0-32-14.3-32-32v-8h40v40zm0-56h-40v-8c0-17.7 14.3-32 32-32h8v40zm-8-136c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm72 192h-48v-40h48v40zm0-56h-48v-40h48v40zm64 56h-48v-40h48v40zm0-56h-48v-40h48v40zm64 56h-48v-40h48v40zm0-56h-48v-40h48v40zm-8-104c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm64 128c0 17.7-14.3 32-32 32h-8v-40h40v8zm0-24h-40v-40h8c17.7 0 32 14.3 32 32v8z"]
};
var faGrin = {
  prefix: 'fas',
  iconName: 'grin',
  icon: [496, 512, [], "f580", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm-160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm80 256c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.3-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.3-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"]
};
var faGrinAlt = {
  prefix: 'fas',
  iconName: 'grin-alt',
  icon: [496, 512, [], "f581", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm63.7 128.7c7.6-11.4 24.7-11.7 32.7 0 12.4 18.4 15.1 36.9 15.7 55.3-.5 18.4-3.3 36.9-15.7 55.3-7.6 11.4-24.7 11.7-32.7 0-12.4-18.4-15.1-36.9-15.7-55.3.5-18.4 3.3-36.9 15.7-55.3zm-160 0c7.6-11.4 24.7-11.7 32.7 0 12.4 18.4 15.1 36.9 15.7 55.3-.5 18.4-3.3 36.9-15.7 55.3-7.6 11.4-24.7 11.7-32.7 0-12.4-18.4-15.1-36.9-15.7-55.3.5-18.4 3.3-36.9 15.7-55.3zM248 432c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.3-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"]
};
var faGrinBeam = {
  prefix: 'fas',
  iconName: 'grin-beam',
  icon: [496, 512, [], "f582", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 144c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.1 7.3-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm-160 0c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm80 280c-60.6 0-134.5-38.3-143.8-93.3-2-11.9 9.4-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"]
};
var faGrinBeamSweat = {
  prefix: 'fas',
  iconName: 'grin-beam-sweat',
  icon: [504, 512, [], "f583", "M456 128c26.5 0 48-21 48-47 0-20-28.5-60.4-41.6-77.8-3.2-4.3-9.6-4.3-12.8 0C436.5 20.6 408 61 408 81c0 26 21.5 47 48 47zm0 32c-44.1 0-80-35.4-80-79 0-4.4.3-14.2 8.1-32.2C345 23.1 298.3 8 248 8 111 8 0 119 0 256s111 248 248 248 248-111 248-248c0-35.1-7.4-68.4-20.5-98.6-6.3 1.5-12.7 2.6-19.5 2.6zm-128-8c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 12-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.1 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm-160 0c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 12-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm80 280c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.3-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.5-3.7 22.6 6.2 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"]
};
var faGrinHearts = {
  prefix: 'fas',
  iconName: 'grin-hearts',
  icon: [496, 512, [], "f584", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM90.4 183.6c6.7-17.6 26.7-26.7 44.9-21.9l7.1 1.9 2-7.1c5-18.1 22.8-30.9 41.5-27.9 21.4 3.4 34.4 24.2 28.8 44.5L195.3 243c-1.2 4.5-5.9 7.2-10.5 6l-70.2-18.2c-20.4-5.4-31.9-27-24.2-47.2zM248 432c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.2-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.6 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3zm133.4-201.3l-70.2 18.2c-4.5 1.2-9.2-1.5-10.5-6L281.3 173c-5.6-20.3 7.4-41.1 28.8-44.5 18.6-3 36.4 9.8 41.5 27.9l2 7.1 7.1-1.9c18.2-4.7 38.2 4.3 44.9 21.9 7.7 20.3-3.8 41.9-24.2 47.2z"]
};
var faGrinSquint = {
  prefix: 'fas',
  iconName: 'grin-squint',
  icon: [496, 512, [], "f585", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm33.8 189.7l80-48c11.6-6.9 24 7.7 15.4 18L343.6 208l33.6 40.3c8.7 10.4-3.9 24.8-15.4 18l-80-48c-7.7-4.7-7.7-15.9 0-20.6zm-163-30c-8.6-10.3 3.8-24.9 15.4-18l80 48c7.8 4.7 7.8 15.9 0 20.6l-80 48c-11.5 6.8-24-7.6-15.4-18l33.6-40.3-33.6-40.3zM248 432c-60.6 0-134.5-38.3-143.8-93.3-2-11.9 9.4-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.5-3.7 22.6 6.2 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"]
};
var faGrinSquintTears = {
  prefix: 'fas',
  iconName: 'grin-squint-tears',
  icon: [512, 512, [], "f586", "M409.6 111.9c22.6-3.2 73.5-12 88.3-26.8 19.2-19.2 18.9-50.6-.7-70.2S446-5 426.9 14.2c-14.8 14.8-23.5 65.7-26.8 88.3-.8 5.5 3.9 10.2 9.5 9.4zM102.4 400.1c-22.6 3.2-73.5 12-88.3 26.8-19.1 19.1-18.8 50.6.8 70.2s51 19.9 70.2.7c14.8-14.8 23.5-65.7 26.8-88.3.8-5.5-3.9-10.2-9.5-9.4zm311.7-256.5c-33 3.9-48.6-25.1-45.7-45.7 3.4-24 7.4-42.1 11.5-56.5C285.1-13.4 161.8-.5 80.6 80.6-.5 161.7-13.4 285 41.4 379.9c14.4-4.1 32.4-8 56.5-11.5 33.2-3.9 48.6 25.2 45.7 45.7-3.4 24-7.4 42.1-11.5 56.5 94.8 54.8 218.1 41.9 299.3-39.2s94-204.4 39.2-299.3c-14.4 4.1-32.5 8-56.5 11.5zM255.7 106c3.3-13.2 22.4-11.5 23.6 1.8l4.8 52.3 52.3 4.8c13.4 1.2 14.9 20.3 1.8 23.6l-90.5 22.6c-8.9 2.2-16.7-5.9-14.5-14.5l22.5-90.6zm-90.9 230.3L160 284l-52.3-4.8c-13.4-1.2-14.9-20.3-1.8-23.6l90.5-22.6c8.8-2.2 16.7 5.8 14.5 14.5L188.3 338c-3.1 13.2-22.2 11.7-23.5-1.7zm215.7 44.2c-29.3 29.3-75.7 50.4-116.7 50.4-18.9 0-36.6-4.5-51-14.7-9.8-6.9-8.7-21.8 2-27.2 28.3-14.6 63.9-42.4 97.8-76.3s61.7-69.6 76.3-97.8c5.4-10.5 20.2-11.9 27.3-2 32.3 45.3 7.1 124.7-35.7 167.6z"]
};
var faGrinStars = {
  prefix: 'fas',
  iconName: 'grin-stars',
  icon: [496, 512, [], "f587", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM94.6 168.9l34.9-5 15.5-31.6c2.9-5.8 11-5.8 13.9 0l15.5 31.6 34.9 5c6.2 1 8.9 8.6 4.3 13.2l-25.4 24.6 6 34.9c1 6.2-5.3 11-11 7.9L152 233.3l-31.3 16.3c-5.7 3.1-12-1.7-11-7.9l6-34.9-25.4-24.6c-4.6-4.7-1.9-12.3 4.3-13.3zM248 432c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.3-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.5-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3zm157.7-249.9l-25.4 24.6 6 34.9c1 6.2-5.3 11-11 7.9L344 233.3l-31.3 16.3c-5.7 3.1-12-1.7-11-7.9l6-34.9-25.4-24.6c-4.5-4.6-1.9-12.2 4.3-13.2l34.9-5 15.5-31.6c2.9-5.8 11-5.8 13.9 0l15.5 31.6 34.9 5c6.3.9 9 8.5 4.4 13.1z"]
};
var faGrinTears = {
  prefix: 'fas',
  iconName: 'grin-tears',
  icon: [640, 512, [], "f588", "M102.4 256.1c-22.6 3.2-73.5 12-88.3 26.8-19.1 19.1-18.8 50.6.8 70.2s51 19.9 70.2.7c14.8-14.8 23.5-65.7 26.8-88.3.8-5.5-3.9-10.2-9.5-9.4zm523.4 26.8c-14.8-14.8-65.7-23.5-88.3-26.8-5.5-.8-10.3 3.9-9.5 9.5 3.2 22.6 12 73.5 26.8 88.3 19.2 19.2 50.6 18.9 70.2-.7s20-51.2.8-70.3zm-129.4-12.8c-3.8-26.6 19.1-49.5 45.7-45.7 8.9 1.3 16.8 2.7 24.3 4.1C552.7 104.5 447.7 8 320 8S87.3 104.5 73.6 228.5c7.5-1.4 15.4-2.8 24.3-4.1 33.2-3.9 48.6 25.3 45.7 45.7-11.8 82.3-29.9 100.4-35.8 106.4-.9.9-2 1.6-3 2.5 42.7 74.6 123 125 215.2 125s172.5-50.4 215.2-125.1c-1-.9-2.1-1.5-3-2.5-5.9-5.9-24-24-35.8-106.3zM400 152c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 12-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm-160 0c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 12-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm80 280c-60.6 0-134.5-38.3-143.8-93.3-2-11.7 9.2-21.6 20.7-17.9C227.1 330.5 272 336 320 336s92.9-5.5 123.1-15.2c11.4-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"]
};
var faGrinTongue = {
  prefix: 'fas',
  iconName: 'grin-tongue',
  icon: [496, 512, [], "f589", "M248 8C111 8 0 119 0 256c0 106.3 67 196.7 161 232-5.6-12.2-9-25.7-9-40v-45.5c-24.7-16.2-43.5-38.1-47.8-63.8-2-11.8 9.3-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.6 22.6 6.1 20.7 17.9-4.3 25.7-23.1 47.6-47.8 63.8V448c0 14.3-3.4 27.8-9 40 94-35.3 161-125.7 161-232C496 119 385 8 248 8zm-80 232c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm160 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm-34.9 134.6c-14.4-6.5-31.1 2.2-34.6 17.6l-1.8 7.8c-2.1 9.2-15.2 9.2-17.3 0l-1.8-7.8c-3.5-15.4-20.2-24.1-34.6-17.6-.9.4.3-.2-18.9 9.4v63c0 35.2 28 64.5 63.1 64.9 35.7.5 64.9-28.4 64.9-64v-64c-19.5-9.6-18.2-8.9-19-9.3z"]
};
var faGrinTongueSquint = {
  prefix: 'fas',
  iconName: 'grin-tongue-squint',
  icon: [496, 512, [], "f58a", "M293.1 374.6c-14.4-6.5-31.1 2.2-34.6 17.6l-1.8 7.8c-2.1 9.2-15.2 9.2-17.3 0l-1.8-7.8c-3.5-15.4-20.2-24.1-34.6-17.6-.9.4.3-.2-18.9 9.4v63c0 35.2 28 64.5 63.1 64.9 35.7.5 64.9-28.4 64.9-64v-64c-19.5-9.6-18.2-8.9-19-9.3zM248 8C111 8 0 119 0 256c0 106.3 67 196.7 161 232-5.6-12.2-9-25.7-9-40v-45.5c-24.7-16.2-43.5-38.1-47.8-63.8-2-11.8 9.2-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.7 22.6 6.1 20.7 17.9-4.3 25.7-23.1 47.6-47.8 63.8V448c0 14.3-3.4 27.8-9 40 94-35.3 161-125.7 161-232C496 119 385 8 248 8zm-33.8 210.3l-80 48c-11.5 6.8-24-7.6-15.4-18l33.6-40.3-33.6-40.3c-8.6-10.3 3.8-24.9 15.4-18l80 48c7.7 4.7 7.7 15.9 0 20.6zm163 30c8.7 10.4-3.9 24.8-15.4 18l-80-48c-7.8-4.7-7.8-15.9 0-20.6l80-48c11.7-6.9 23.9 7.7 15.4 18L343.6 208l33.6 40.3z"]
};
var faGrinTongueWink = {
  prefix: 'fas',
  iconName: 'grin-tongue-wink',
  icon: [496, 512, [], "f58b", "M344 184c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zM248 8C111 8 0 119 0 256c0 106.3 67 196.7 161 232-5.6-12.2-9-25.7-9-40v-45.5c-24.7-16.2-43.5-38.1-47.8-63.8-2-11.8 9.3-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.5-3.7 22.6 6.1 20.7 17.9-4.3 25.7-23.1 47.6-47.8 63.8V448c0 14.3-3.4 27.8-9 40 94-35.3 161-125.7 161-232C496 119 385 8 248 8zm-56 225l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L112 233c-8.5 7.4-21.6.3-19.8-10.8 4-25.2 34.2-42.1 59.9-42.1S208 197 212 222.2c1.6 11.1-11.6 18.2-20 10.8zm152 39c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm-50.9 102.6c-14.4-6.5-31.1 2.2-34.6 17.6l-1.8 7.8c-2.1 9.2-15.2 9.2-17.3 0l-1.8-7.8c-3.5-15.4-20.2-24.1-34.6-17.6-.9.4.3-.2-18.9 9.4v63c0 35.2 28 64.5 63.1 64.9 35.7.5 64.9-28.4 64.9-64v-64c-19.5-9.6-18.2-8.9-19-9.3z"]
};
var faGrinWink = {
  prefix: 'fas',
  iconName: 'grin-wink',
  icon: [496, 512, [], "f58c", "M0 256c0 137 111 248 248 248s248-111 248-248S385 8 248 8 0 119 0 256zm200-48c0 17.7-14.3 32-32 32s-32-14.3-32-32 14.3-32 32-32 32 14.3 32 32zm168 25l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L288 233c-8.3 7.4-21.6.4-19.8-10.8 4-25.2 34.2-42.1 59.9-42.1S384 197 388 222.2c1.6 11-11.5 18.2-20 10.8zm-243.1 87.8C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.3-3.7 22.6 6 20.7 17.9-9.2 55-83.2 93.3-143.8 93.3s-134.5-38.3-143.8-93.3c-2-11.9 9.3-21.6 20.7-17.9z"]
};
var faGripHorizontal = {
  prefix: 'fas',
  iconName: 'grip-horizontal',
  icon: [448, 512, [], "f58d", "M96 288H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm160 0h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm160 0h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zM96 96H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm160 0h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm160 0h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32z"]
};
var faGripLines = {
  prefix: 'fas',
  iconName: 'grip-lines',
  icon: [512, 512, [], "f7a4", "M496 288H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-128H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"]
};
var faGripLinesVertical = {
  prefix: 'fas',
  iconName: 'grip-lines-vertical',
  icon: [256, 512, [], "f7a5", "M96 496V16c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16v480c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16zm128 0V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v480c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16z"]
};
var faGripVertical = {
  prefix: 'fas',
  iconName: 'grip-vertical',
  icon: [320, 512, [], "f58e", "M96 32H32C14.33 32 0 46.33 0 64v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zm0 160H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm0 160H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zM288 32h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zm0 160h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm0 160h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32z"]
};
var faGuitar = {
  prefix: 'fas',
  iconName: 'guitar',
  icon: [512, 512, [], "f7a6", "M502.63 39L473 9.37a32 32 0 0 0-45.26 0L381.46 55.7a35.14 35.14 0 0 0-8.53 13.79L360.77 106l-76.26 76.26c-12.16-8.76-25.5-15.74-40.1-19.14-33.45-7.78-67-.88-89.88 22a82.45 82.45 0 0 0-20.24 33.47c-6 18.56-23.21 32.69-42.15 34.46-23.7 2.27-45.73 11.45-62.61 28.44C-16.11 327-7.9 409 47.58 464.45S185 528 230.56 482.52c17-16.88 26.16-38.9 28.45-62.71 1.76-18.85 15.89-36.13 34.43-42.14a82.6 82.6 0 0 0 33.48-20.25c22.87-22.88 29.74-56.36 22-89.75-3.39-14.64-10.37-28-19.16-40.2L406 151.23l36.48-12.16a35.14 35.14 0 0 0 13.79-8.53l46.33-46.32a32 32 0 0 0 .03-45.22zM208 352a48 48 0 1 1 48-48 48 48 0 0 1-48 48z"]
};
var faHSquare = {
  prefix: 'fas',
  iconName: 'h-square',
  icon: [448, 512, [], "f0fd", "M448 80v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48zm-112 48h-32c-8.837 0-16 7.163-16 16v80H160v-80c0-8.837-7.163-16-16-16h-32c-8.837 0-16 7.163-16 16v224c0 8.837 7.163 16 16 16h32c8.837 0 16-7.163 16-16v-80h128v80c0 8.837 7.163 16 16 16h32c8.837 0 16-7.163 16-16V144c0-8.837-7.163-16-16-16z"]
};
var faHamburger = {
  prefix: 'fas',
  iconName: 'hamburger',
  icon: [512, 512, [], "f805", "M464 256H48a48 48 0 0 0 0 96h416a48 48 0 0 0 0-96zm16 128H32a16 16 0 0 0-16 16v16a64 64 0 0 0 64 64h352a64 64 0 0 0 64-64v-16a16 16 0 0 0-16-16zM58.64 224h394.72c34.57 0 54.62-43.9 34.82-75.88C448 83.2 359.55 32.1 256 32c-103.54.1-192 51.2-232.18 116.11C4 180.09 24.07 224 58.64 224zM384 112a16 16 0 1 1-16 16 16 16 0 0 1 16-16zM256 80a16 16 0 1 1-16 16 16 16 0 0 1 16-16zm-128 32a16 16 0 1 1-16 16 16 16 0 0 1 16-16z"]
};
var faHammer = {
  prefix: 'fas',
  iconName: 'hammer',
  icon: [576, 512, [], "f6e3", "M571.31 193.94l-22.63-22.63c-6.25-6.25-16.38-6.25-22.63 0l-11.31 11.31-28.9-28.9c5.63-21.31.36-44.9-16.35-61.61l-45.25-45.25c-62.48-62.48-163.79-62.48-226.28 0l90.51 45.25v18.75c0 16.97 6.74 33.25 18.75 45.25l49.14 49.14c16.71 16.71 40.3 21.98 61.61 16.35l28.9 28.9-11.31 11.31c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l90.51-90.51c6.23-6.24 6.23-16.37-.02-22.62zm-286.72-15.2c-3.7-3.7-6.84-7.79-9.85-11.95L19.64 404.96c-25.57 23.88-26.26 64.19-1.53 88.93s65.05 24.05 88.93-1.53l238.13-255.07c-3.96-2.91-7.9-5.87-11.44-9.41l-49.14-49.14z"]
};
var faHamsa = {
  prefix: 'fas',
  iconName: 'hamsa',
  icon: [512, 512, [], "f665", "M509.34 307.25C504.28 295.56 492.75 288 480 288h-64V80c0-22-18-40-40-40s-40 18-40 40v134c0 5.52-4.48 10-10 10h-20c-5.52 0-10-4.48-10-10V40c0-22-18-40-40-40s-40 18-40 40v174c0 5.52-4.48 10-10 10h-20c-5.52 0-10-4.48-10-10V80c0-22-18-40-40-40S96 58 96 80v208H32c-12.75 0-24.28 7.56-29.34 19.25a31.966 31.966 0 0 0 5.94 34.58l102.69 110.03C146.97 490.08 199.69 512 256 512s109.03-21.92 144.72-60.14L503.4 341.83a31.966 31.966 0 0 0 5.94-34.58zM256 416c-53.02 0-96-64-96-64s42.98-64 96-64 96 64 96 64-42.98 64-96 64zm0-96c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32z"]
};
var faHandHolding = {
  prefix: 'fas',
  iconName: 'hand-holding',
  icon: [576, 512, [], "f4bd", "M565.3 328.1c-11.8-10.7-30.2-10-42.6 0L430.3 402c-11.3 9.1-25.4 14-40 14H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h78.3c15.9 0 30.7-10.9 33.3-26.6 3.3-20-12.1-37.4-31.6-37.4H192c-27 0-53.1 9.3-74.1 26.3L71.4 384H16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h356.8c14.5 0 28.6-4.9 40-14L564 377c15.2-12.1 16.4-35.3 1.3-48.9z"]
};
var faHandHoldingHeart = {
  prefix: 'fas',
  iconName: 'hand-holding-heart',
  icon: [576, 512, [], "f4be", "M275.3 250.5c7 7.4 18.4 7.4 25.5 0l108.9-114.2c31.6-33.2 29.8-88.2-5.6-118.8-30.8-26.7-76.7-21.9-104.9 7.7L288 36.9l-11.1-11.6C248.7-4.4 202.8-9.2 172 17.5c-35.3 30.6-37.2 85.6-5.6 118.8l108.9 114.2zm290 77.6c-11.8-10.7-30.2-10-42.6 0L430.3 402c-11.3 9.1-25.4 14-40 14H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h78.3c15.9 0 30.7-10.9 33.3-26.6 3.3-20-12.1-37.4-31.6-37.4H192c-27 0-53.1 9.3-74.1 26.3L71.4 384H16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h356.8c14.5 0 28.6-4.9 40-14L564 377c15.2-12.1 16.4-35.3 1.3-48.9z"]
};
var faHandHoldingMedical = {
  prefix: 'fas',
  iconName: 'hand-holding-medical',
  icon: [576, 512, [], "e05c", "M159.88,175.82h64v64a16,16,0,0,0,16,16h64a16,16,0,0,0,16-16v-64h64a16,16,0,0,0,16-16v-64a16,16,0,0,0-16-16h-64v-64a16,16,0,0,0-16-16h-64a16,16,0,0,0-16,16v64h-64a16,16,0,0,0-16,16v64A16,16,0,0,0,159.88,175.82ZM568.07,336.13a39.91,39.91,0,0,0-55.93-8.47L392.47,415.84H271.86a16,16,0,0,1,0-32H350.1c16,0,30.75-10.87,33.37-26.61a32.06,32.06,0,0,0-31.62-37.38h-160a117.7,117.7,0,0,0-74.12,26.25l-46.5,37.74H15.87a16.11,16.11,0,0,0-16,16v96a16.11,16.11,0,0,0,16,16h347a104.8,104.8,0,0,0,61.7-20.27L559.6,392A40,40,0,0,0,568.07,336.13Z"]
};
var faHandHoldingUsd = {
  prefix: 'fas',
  iconName: 'hand-holding-usd',
  icon: [576, 512, [], "f4c0", "M271.06,144.3l54.27,14.3a8.59,8.59,0,0,1,6.63,8.1c0,4.6-4.09,8.4-9.12,8.4h-35.6a30,30,0,0,1-11.19-2.2c-5.24-2.2-11.28-1.7-15.3,2l-19,17.5a11.68,11.68,0,0,0-2.25,2.66,11.42,11.42,0,0,0,3.88,15.74,83.77,83.77,0,0,0,34.51,11.5V240c0,8.8,7.83,16,17.37,16h17.37c9.55,0,17.38-7.2,17.38-16V222.4c32.93-3.6,57.84-31,53.5-63-3.15-23-22.46-41.3-46.56-47.7L282.68,97.4a8.59,8.59,0,0,1-6.63-8.1c0-4.6,4.09-8.4,9.12-8.4h35.6A30,30,0,0,1,332,83.1c5.23,2.2,11.28,1.7,15.3-2l19-17.5A11.31,11.31,0,0,0,368.47,61a11.43,11.43,0,0,0-3.84-15.78,83.82,83.82,0,0,0-34.52-11.5V16c0-8.8-7.82-16-17.37-16H295.37C285.82,0,278,7.2,278,16V33.6c-32.89,3.6-57.85,31-53.51,63C227.63,119.6,247,137.9,271.06,144.3ZM565.27,328.1c-11.8-10.7-30.2-10-42.6,0L430.27,402a63.64,63.64,0,0,1-40,14H272a16,16,0,0,1,0-32h78.29c15.9,0,30.71-10.9,33.25-26.6a31.2,31.2,0,0,0,.46-5.46A32,32,0,0,0,352,320H192a117.66,117.66,0,0,0-74.1,26.29L71.4,384H16A16,16,0,0,0,0,400v96a16,16,0,0,0,16,16H372.77a64,64,0,0,0,40-14L564,377a32,32,0,0,0,1.28-48.9Z"]
};
var faHandHoldingWater = {
  prefix: 'fas',
  iconName: 'hand-holding-water',
  icon: [576, 512, [], "f4c1", "M288 256c53 0 96-42.1 96-94 0-40-57.1-120.7-83.2-155.6-6.4-8.5-19.2-8.5-25.6 0C249.1 41.3 192 122 192 162c0 51.9 43 94 96 94zm277.3 72.1c-11.8-10.7-30.2-10-42.6 0L430.3 402c-11.3 9.1-25.4 14-40 14H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h78.3c15.9 0 30.7-10.9 33.3-26.6 3.3-20-12.1-37.4-31.6-37.4H192c-27 0-53.1 9.3-74.1 26.3L71.4 384H16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h356.8c14.5 0 28.6-4.9 40-14L564 377c15.2-12.1 16.4-35.3 1.3-48.9z"]
};
var faHandLizard = {
  prefix: 'fas',
  iconName: 'hand-lizard',
  icon: [576, 512, [], "f258", "M384 480h192V363.778a95.998 95.998 0 0 0-14.833-51.263L398.127 54.368A48 48 0 0 0 357.544 32H24C10.745 32 0 42.745 0 56v16c0 30.928 25.072 56 56 56h229.981c12.844 0 21.556 13.067 16.615 24.923l-21.41 51.385A32 32 0 0 1 251.648 224H128c-35.346 0-64 28.654-64 64v8c0 13.255 10.745 24 24 24h147.406a47.995 47.995 0 0 1 25.692 7.455l111.748 70.811A24.001 24.001 0 0 1 384 418.539V480z"]
};
var faHandMiddleFinger = {
  prefix: 'fas',
  iconName: 'hand-middle-finger',
  icon: [512, 512, [], "f806", "M479.93 317.12a37.33 37.33 0 0 0-28.28-36.19L416 272v-49.59c0-11.44-9.69-21.29-23.15-23.54l-38.4-6.4C336.63 189.5 320 200.86 320 216v32a8 8 0 0 1-16 0V50c0-26.28-20.25-49.2-46.52-50A48 48 0 0 0 208 48v200a8 8 0 0 1-16 0v-32c0-15.15-16.63-26.51-34.45-23.54l-30.68 5.12c-18 3-30.87 16.12-30.87 31.38V376a8 8 0 0 1-16 0v-76l-27.36 15A37.34 37.34 0 0 0 32 348.4v73.47a37.31 37.31 0 0 0 10.93 26.39l30.93 30.93A112 112 0 0 0 153.05 512h215A112 112 0 0 0 480 400z"]
};
var faHandPaper = {
  prefix: 'fas',
  iconName: 'hand-paper',
  icon: [448, 512, [], "f256", "M408.781 128.007C386.356 127.578 368 146.36 368 168.79V256h-8V79.79c0-22.43-18.356-41.212-40.781-40.783C297.488 39.423 280 57.169 280 79v177h-8V40.79C272 18.36 253.644-.422 231.219.007 209.488.423 192 18.169 192 40v216h-8V80.79c0-22.43-18.356-41.212-40.781-40.783C121.488 40.423 104 58.169 104 80v235.992l-31.648-43.519c-12.993-17.866-38.009-21.817-55.877-8.823-17.865 12.994-21.815 38.01-8.822 55.877l125.601 172.705A48 48 0 0 0 172.073 512h197.59c22.274 0 41.622-15.324 46.724-37.006l26.508-112.66a192.011 192.011 0 0 0 5.104-43.975V168c.001-21.831-17.487-39.577-39.218-39.993z"]
};
var faHandPeace = {
  prefix: 'fas',
  iconName: 'hand-peace',
  icon: [448, 512, [], "f25b", "M408 216c-22.092 0-40 17.909-40 40h-8v-32c0-22.091-17.908-40-40-40s-40 17.909-40 40v32h-8V48c0-26.51-21.49-48-48-48s-48 21.49-48 48v208h-13.572L92.688 78.449C82.994 53.774 55.134 41.63 30.461 51.324 5.787 61.017-6.356 88.877 3.337 113.551l74.765 190.342-31.09 24.872c-15.381 12.306-19.515 33.978-9.741 51.081l64 112A39.998 39.998 0 0 0 136 512h240c18.562 0 34.686-12.77 38.937-30.838l32-136A39.97 39.97 0 0 0 448 336v-80c0-22.091-17.908-40-40-40z"]
};
var faHandPointDown = {
  prefix: 'fas',
  iconName: 'hand-point-down',
  icon: [384, 512, [], "f0a7", "M91.826 467.2V317.966c-8.248 5.841-16.558 10.57-24.918 14.153C35.098 345.752-.014 322.222 0 288c.008-18.616 10.897-32.203 29.092-40 28.286-12.122 64.329-78.648 77.323-107.534 7.956-17.857 25.479-28.453 43.845-28.464l.001-.002h171.526c11.812 0 21.897 8.596 23.703 20.269 7.25 46.837 38.483 61.76 38.315 123.731-.007 2.724.195 13.254.195 16 0 50.654-22.122 81.574-71.263 72.6-9.297 18.597-39.486 30.738-62.315 16.45-21.177 24.645-53.896 22.639-70.944 6.299V467.2c0 24.15-20.201 44.8-43.826 44.8-23.283 0-43.826-21.35-43.826-44.8zM112 72V24c0-13.255 10.745-24 24-24h192c13.255 0 24 10.745 24 24v48c0 13.255-10.745 24-24 24H136c-13.255 0-24-10.745-24-24zm212-24c0-11.046-8.954-20-20-20s-20 8.954-20 20 8.954 20 20 20 20-8.954 20-20z"]
};
var faHandPointLeft = {
  prefix: 'fas',
  iconName: 'hand-point-left',
  icon: [512, 512, [], "f0a5", "M44.8 155.826h149.234c-5.841-8.248-10.57-16.558-14.153-24.918C166.248 99.098 189.778 63.986 224 64c18.616.008 32.203 10.897 40 29.092 12.122 28.286 78.648 64.329 107.534 77.323 17.857 7.956 28.453 25.479 28.464 43.845l.002.001v171.526c0 11.812-8.596 21.897-20.269 23.703-46.837 7.25-61.76 38.483-123.731 38.315-2.724-.007-13.254.195-16 .195-50.654 0-81.574-22.122-72.6-71.263-18.597-9.297-30.738-39.486-16.45-62.315-24.645-21.177-22.639-53.896-6.299-70.944H44.8c-24.15 0-44.8-20.201-44.8-43.826 0-23.283 21.35-43.826 44.8-43.826zM440 176h48c13.255 0 24 10.745 24 24v192c0 13.255-10.745 24-24 24h-48c-13.255 0-24-10.745-24-24V200c0-13.255 10.745-24 24-24zm24 212c11.046 0 20-8.954 20-20s-8.954-20-20-20-20 8.954-20 20 8.954 20 20 20z"]
};
var faHandPointRight = {
  prefix: 'fas',
  iconName: 'hand-point-right',
  icon: [512, 512, [], "f0a4", "M512 199.652c0 23.625-20.65 43.826-44.8 43.826h-99.851c16.34 17.048 18.346 49.766-6.299 70.944 14.288 22.829 2.147 53.017-16.45 62.315C353.574 425.878 322.654 448 272 448c-2.746 0-13.276-.203-16-.195-61.971.168-76.894-31.065-123.731-38.315C120.596 407.683 112 397.599 112 385.786V214.261l.002-.001c.011-18.366 10.607-35.889 28.464-43.845 28.886-12.994 95.413-49.038 107.534-77.323 7.797-18.194 21.384-29.084 40-29.092 34.222-.014 57.752 35.098 44.119 66.908-3.583 8.359-8.312 16.67-14.153 24.918H467.2c23.45 0 44.8 20.543 44.8 43.826zM96 200v192c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V200c0-13.255 10.745-24 24-24h48c13.255 0 24 10.745 24 24zM68 368c0-11.046-8.954-20-20-20s-20 8.954-20 20 8.954 20 20 20 20-8.954 20-20z"]
};
var faHandPointUp = {
  prefix: 'fas',
  iconName: 'hand-point-up',
  icon: [384, 512, [], "f0a6", "M135.652 0c23.625 0 43.826 20.65 43.826 44.8v99.851c17.048-16.34 49.766-18.346 70.944 6.299 22.829-14.288 53.017-2.147 62.315 16.45C361.878 158.426 384 189.346 384 240c0 2.746-.203 13.276-.195 16 .168 61.971-31.065 76.894-38.315 123.731C343.683 391.404 333.599 400 321.786 400H150.261l-.001-.002c-18.366-.011-35.889-10.607-43.845-28.464C93.421 342.648 57.377 276.122 29.092 264 10.897 256.203.008 242.616 0 224c-.014-34.222 35.098-57.752 66.908-44.119 8.359 3.583 16.67 8.312 24.918 14.153V44.8c0-23.45 20.543-44.8 43.826-44.8zM136 416h192c13.255 0 24 10.745 24 24v48c0 13.255-10.745 24-24 24H136c-13.255 0-24-10.745-24-24v-48c0-13.255 10.745-24 24-24zm168 28c-11.046 0-20 8.954-20 20s8.954 20 20 20 20-8.954 20-20-8.954-20-20-20z"]
};
var faHandPointer = {
  prefix: 'fas',
  iconName: 'hand-pointer',
  icon: [448, 512, [], "f25a", "M448 240v96c0 3.084-.356 6.159-1.063 9.162l-32 136C410.686 499.23 394.562 512 376 512H168a40.004 40.004 0 0 1-32.35-16.473l-127.997-176c-12.993-17.866-9.043-42.883 8.822-55.876 17.867-12.994 42.884-9.043 55.877 8.823L104 315.992V40c0-22.091 17.908-40 40-40s40 17.909 40 40v200h8v-40c0-22.091 17.908-40 40-40s40 17.909 40 40v40h8v-24c0-22.091 17.908-40 40-40s40 17.909 40 40v24h8c0-22.091 17.908-40 40-40s40 17.909 40 40zm-256 80h-8v96h8v-96zm88 0h-8v96h8v-96zm88 0h-8v96h8v-96z"]
};
var faHandRock = {
  prefix: 'fas',
  iconName: 'hand-rock',
  icon: [512, 512, [], "f255", "M464.8 80c-26.9-.4-48.8 21.2-48.8 48h-8V96.8c0-26.3-20.9-48.3-47.2-48.8-26.9-.4-48.8 21.2-48.8 48v32h-8V80.8c0-26.3-20.9-48.3-47.2-48.8-26.9-.4-48.8 21.2-48.8 48v48h-8V96.8c0-26.3-20.9-48.3-47.2-48.8-26.9-.4-48.8 21.2-48.8 48v136l-8-7.1v-48.1c0-26.3-20.9-48.3-47.2-48.8C21.9 127.6 0 149.2 0 176v66.4c0 27.4 11.7 53.5 32.2 71.8l111.7 99.3c10.2 9.1 16.1 22.2 16.1 35.9v6.7c0 13.3 10.7 24 24 24h240c13.3 0 24-10.7 24-24v-2.9c0-12.8 2.6-25.5 7.5-37.3l49-116.3c5-11.8 7.5-24.5 7.5-37.3V128.8c0-26.3-20.9-48.4-47.2-48.8z"]
};
var faHandScissors = {
  prefix: 'fas',
  iconName: 'hand-scissors',
  icon: [512, 512, [], "f257", "M216 440c0-22.092 17.909-40 40-40v-8h-32c-22.091 0-40-17.908-40-40s17.909-40 40-40h32v-8H48c-26.51 0-48-21.49-48-48s21.49-48 48-48h208v-13.572l-177.551-69.74c-24.674-9.694-36.818-37.555-27.125-62.228 9.693-24.674 37.554-36.817 62.228-27.124l190.342 74.765 24.872-31.09c12.306-15.381 33.978-19.515 51.081-9.741l112 64A40.002 40.002 0 0 1 512 168v240c0 18.562-12.77 34.686-30.838 38.937l-136 32A39.982 39.982 0 0 1 336 480h-80c-22.091 0-40-17.908-40-40z"]
};
var faHandSparkles = {
  prefix: 'fas',
  iconName: 'hand-sparkles',
  icon: [640, 512, [], "e05d", "M106.66,170.64l.09,0,49.55-20.65a7.32,7.32,0,0,0,3.68-6h0a7.29,7.29,0,0,0-3.68-6l-49.57-20.67-.07,0L86,67.68a6.66,6.66,0,0,0-11.92,0l-20.7,49.63-.05,0L3.7,138A7.29,7.29,0,0,0,0,144H0a7.32,7.32,0,0,0,3.68,6L53.27,170.6l.07,0L74,220.26a6.65,6.65,0,0,0,11.92,0l20.69-49.62ZM471.38,467.41l-1-.42-1-.5a38.67,38.67,0,0,1,0-69.14l1-.49,1-.43,37.49-15.63,15.63-37.48.41-1,.47-.95c3.85-7.74,10.58-13.63,18.35-17.34,0-1.33.25-2.69.27-4V144a32,32,0,0,0-64,0v72a8,8,0,0,1-8,8H456a8,8,0,0,1-8-8V64a32,32,0,0,0-64,0V216a8,8,0,0,1-8,8H360a8,8,0,0,1-8-8V32a32,32,0,0,0-64,0V216a8,8,0,0,1-8,8H264a8,8,0,0,1-8-8V64a32,32,0,0,0-64,0v241l-23.59-32.49a40,40,0,0,0-64.71,47.09L229.3,492.21A48.07,48.07,0,0,0,268.09,512H465.7c19.24,0,35.65-11.73,43.24-28.79l-.07-.17ZM349.79,339.52,320,351.93l-12.42,29.78a4,4,0,0,1-7.15,0L288,351.93l-29.79-12.41a4,4,0,0,1,0-7.16L288,319.94l12.42-29.78a4,4,0,0,1,7.15,0L320,319.94l29.79,12.42a4,4,0,0,1,0,7.16ZM640,431.91a7.28,7.28,0,0,0-3.68-6l-49.57-20.67-.07,0L566,355.63a6.66,6.66,0,0,0-11.92,0l-20.7,49.63-.05,0L483.7,426a7.28,7.28,0,0,0-3.68,6h0a7.29,7.29,0,0,0,3.68,5.95l49.57,20.67.07,0L554,508.21a6.65,6.65,0,0,0,11.92,0l20.69-49.62h0l.09,0,49.55-20.66a7.29,7.29,0,0,0,3.68-5.95h0Z"]
};
var faHandSpock = {
  prefix: 'fas',
  iconName: 'hand-spock',
  icon: [512, 512, [], "f259", "M510.9005,145.27027,442.604,432.09391A103.99507,103.99507,0,0,1,341.43745,512H214.074a135.96968,135.96968,0,0,1-93.18489-36.95291L12.59072,373.12723a39.992,39.992,0,0,1,54.8122-58.24988l60.59342,57.02528v0a283.24849,283.24849,0,0,0-11.6703-80.46734L73.63726,147.36011a40.00575,40.00575,0,1,1,76.71833-22.7187l37.15458,125.39477a8.33113,8.33113,0,0,0,16.05656-4.4414L153.26183,49.95406A39.99638,39.99638,0,1,1,230.73015,30.0166l56.09491,218.15825a10.42047,10.42047,0,0,0,20.30018-.501L344.80766,63.96966a40.052,40.052,0,0,1,51.30245-30.0893c19.86073,6.2998,30.86262,27.67378,26.67564,48.08487l-33.83869,164.966a7.55172,7.55172,0,0,0,14.74406,3.2666l29.3973-123.45874a39.99414,39.99414,0,1,1,77.81208,18.53121Z"]
};
var faHands = {
  prefix: 'fas',
  iconName: 'hands',
  icon: [640, 512, [], "f4c2", "M204.8 230.4c-10.6-14.1-30.7-17-44.8-6.4-14.1 10.6-17 30.7-6.4 44.8l38.1 50.8c4.8 6.4 4.1 15.3-1.5 20.9l-12.8 12.8c-6.7 6.7-17.6 6.2-23.6-1.1L64 244.4V96c0-17.7-14.3-32-32-32S0 78.3 0 96v218.4c0 10.9 3.7 21.5 10.5 30l104.1 134.3c5 6.5 8.4 13.9 10.4 21.7 1.8 6.9 8.1 11.6 15.3 11.6H272c8.8 0 16-7.2 16-16V384c0-27.7-9-54.6-25.6-76.8l-57.6-76.8zM608 64c-17.7 0-32 14.3-32 32v148.4l-89.8 107.8c-6 7.2-17 7.7-23.6 1.1l-12.8-12.8c-5.6-5.6-6.3-14.5-1.5-20.9l38.1-50.8c10.6-14.1 7.7-34.2-6.4-44.8-14.1-10.6-34.2-7.7-44.8 6.4l-57.6 76.8C361 329.4 352 356.3 352 384v112c0 8.8 7.2 16 16 16h131.7c7.1 0 13.5-4.7 15.3-11.6 2-7.8 5.4-15.2 10.4-21.7l104.1-134.3c6.8-8.5 10.5-19.1 10.5-30V96c0-17.7-14.3-32-32-32z"]
};
var faHandsHelping = {
  prefix: 'fas',
  iconName: 'hands-helping',
  icon: [640, 512, [], "f4c4", "M488 192H336v56c0 39.7-32.3 72-72 72s-72-32.3-72-72V126.4l-64.9 39C107.8 176.9 96 197.8 96 220.2v47.3l-80 46.2C.7 322.5-4.6 342.1 4.3 357.4l80 138.6c8.8 15.3 28.4 20.5 43.7 11.7L231.4 448H368c35.3 0 64-28.7 64-64h16c17.7 0 32-14.3 32-32v-64h8c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24zm147.7-37.4L555.7 16C546.9.7 527.3-4.5 512 4.3L408.6 64H306.4c-12 0-23.7 3.4-33.9 9.7L239 94.6c-9.4 5.8-15 16.1-15 27.1V248c0 22.1 17.9 40 40 40s40-17.9 40-40v-88h184c30.9 0 56 25.1 56 56v28.5l80-46.2c15.3-8.9 20.5-28.4 11.7-43.7z"]
};
var faHandsWash = {
  prefix: 'fas',
  iconName: 'hands-wash',
  icon: [576, 512, [], "e05e", "M496,224a48,48,0,1,0-48-48A48,48,0,0,0,496,224ZM311.47,178.45A56.77,56.77,0,0,1,328,176a56,56,0,0,1,19,3.49l15.35-48.61A24,24,0,0,0,342,99.74c-11.53-1.35-22.21,6.44-25.71,17.51l-20.9,66.17ZM93.65,386.33c.8-.19,1.54-.54,2.35-.71V359.93a156,156,0,0,1,107.06-148l73.7-22.76L310.92,81.05a24,24,0,0,0-20.33-31.11c-11.53-1.34-22.22,6.45-25.72,17.52L231.42,173.88a8,8,0,0,1-15.26-4.83L259.53,31.26A24,24,0,0,0,239.2.15C227.67-1.19,217,6.6,213.49,17.66L165.56,169.37a8,8,0,1,1-15.26-4.82l38.56-122a24,24,0,0,0-20.33-31.11C157,10,146.32,17.83,142.82,28.9l-60,189.85L80.76,168.7A24,24,0,0,0,56.9,144.55c-13.23-.05-24.72,10.54-24.9,23.86V281.14A123.69,123.69,0,0,0,93.65,386.33ZM519.1,336H360a8,8,0,0,1,0-16H488a24,24,0,0,0,23.54-28.76C509.35,279.84,498.71,272,487.1,272H288l47.09-17.06a24,24,0,0,0-14.18-45.88L213.19,242.31A123.88,123.88,0,0,0,128,360v25.65a79.78,79.78,0,0,1,58,108.63A118.9,118.9,0,0,0,248,512H456a24,24,0,0,0,23.54-28.76C477.35,471.84,466.71,464,455.1,464H360a8,8,0,0,1,0-16H488a24,24,0,0,0,23.54-28.76C509.35,407.84,498.71,400,487.1,400H360a8,8,0,0,1,0-16H520a24,24,0,0,0,23.54-28.76C541.35,343.84,530.71,336,519.1,336ZM416,64a32,32,0,1,0-32-32A32,32,0,0,0,416,64ZM112,416a48,48,0,1,0,48,48A48,48,0,0,0,112,416Z"]
};
var faHandshake = {
  prefix: 'fas',
  iconName: 'handshake',
  icon: [640, 512, [], "f2b5", "M434.7 64h-85.9c-8 0-15.7 3-21.6 8.4l-98.3 90c-.1.1-.2.3-.3.4-16.6 15.6-16.3 40.5-2.1 56 12.7 13.9 39.4 17.6 56.1 2.7.1-.1.3-.1.4-.2l79.9-73.2c6.5-5.9 16.7-5.5 22.6 1 6 6.5 5.5 16.6-1 22.6l-26.1 23.9L504 313.8c2.9 2.4 5.5 5 7.9 7.7V128l-54.6-54.6c-5.9-6-14.1-9.4-22.6-9.4zM544 128.2v223.9c0 17.7 14.3 32 32 32h64V128.2h-96zm48 223.9c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zM0 384h64c17.7 0 32-14.3 32-32V128.2H0V384zm48-63.9c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16c0-8.9 7.2-16 16-16zm435.9 18.6L334.6 217.5l-30 27.5c-29.7 27.1-75.2 24.5-101.7-4.4-26.9-29.4-24.8-74.9 4.4-101.7L289.1 64h-83.8c-8.5 0-16.6 3.4-22.6 9.4L128 128v223.9h18.3l90.5 81.9c27.4 22.3 67.7 18.1 90-9.3l.2-.2 17.9 15.5c15.9 13 39.4 10.5 52.3-5.4l31.4-38.6 5.4 4.4c13.7 11.1 33.9 9.1 45-4.7l9.5-11.7c11.2-13.8 9.1-33.9-4.6-45.1z"]
};
var faHandshakeAltSlash = {
  prefix: 'fas',
  iconName: 'handshake-alt-slash',
  icon: [640, 512, [], "e05f", "M358.59,195.6,504.2,313.8a63.4,63.4,0,0,1,22.21,37.91H624a16.05,16.05,0,0,0,16-16V143.91A16,16,0,0,0,624,128H512L457.41,73.41A32,32,0,0,0,434.8,64H348.91a32,32,0,0,0-21.61,8.41l-88.12,80.68-25.69-19.85L289.09,64H205.3a32,32,0,0,0-22.6,9.41l-20.34,20.3L45.47,3.38A16,16,0,0,0,23,6.19L3.38,31.46A16,16,0,0,0,6.19,53.91L594.54,508.63A16,16,0,0,0,617,505.82l19.64-25.27a16,16,0,0,0-2.81-22.45L303.4,202.72l32.69-29.92,27-24.7a16,16,0,0,1,21.61,23.61ZM16,128A16.05,16.05,0,0,0,0,144V335.91a16,16,0,0,0,16,16H146.3l90.5,81.89a64,64,0,0,0,90-9.3l.2-.2,17.91,15.5a37.16,37.16,0,0,0,52.29-5.39l8.8-10.82L23.56,128Z"]
};
var faHandshakeSlash = {
  prefix: 'fas',
  iconName: 'handshake-slash',
  icon: [640, 512, [], "e060", "M0,128.21V384H64a32,32,0,0,0,32-32V184L23.83,128.21ZM48,320.1a16,16,0,1,1-16,16A16,16,0,0,1,48,320.1Zm80,31.81h18.3l90.5,81.89a64,64,0,0,0,90-9.3l.2-.2,17.91,15.5a37.16,37.16,0,0,0,52.29-5.39l8.8-10.82L128,208.72Zm416-223.7V352.1a32,32,0,0,0,32,32h64V128.21ZM592,352.1a16,16,0,1,1,16-16A16,16,0,0,1,592,352.1ZM303.33,202.67l59.58-54.57a16,16,0,0,1,21.59,23.61L358.41,195.6,504,313.8a73.08,73.08,0,0,1,7.91,7.7V128L457.3,73.41A31.76,31.76,0,0,0,434.7,64H348.8a31.93,31.93,0,0,0-21.6,8.41l-88.07,80.64-25.64-19.81L289.09,64H205.3a32,32,0,0,0-22.6,9.41L162.36,93.72,45.47,3.38A16,16,0,0,0,23,6.19L3.38,31.46A16,16,0,0,0,6.19,53.91L594.53,508.63A16,16,0,0,0,617,505.82l19.65-25.27a16,16,0,0,0-2.82-22.45Z"]
};
var faHanukiah = {
  prefix: 'fas',
  iconName: 'hanukiah',
  icon: [640, 512, [], "f6e6", "M232 160c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm-64 0c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm224 0c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm64 0c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm88 8c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v120h32V168zm-440-8c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm520 0h-32c-8.84 0-16 7.16-16 16v112c0 17.67-14.33 32-32 32H352V128c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v192H96c-17.67 0-32-14.33-32-32V176c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v112c0 53.02 42.98 96 96 96h192v64H112c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16H352v-64h192c53.02 0 96-42.98 96-96V176c0-8.84-7.16-16-16-16zm-16-32c13.25 0 24-11.94 24-26.67S608 48 608 48s-24 38.61-24 53.33S594.75 128 608 128zm-576 0c13.25 0 24-11.94 24-26.67S32 48 32 48 8 86.61 8 101.33 18.75 128 32 128zm288-48c13.25 0 24-11.94 24-26.67S320 0 320 0s-24 38.61-24 53.33S306.75 80 320 80zm-208 48c13.25 0 24-11.94 24-26.67S112 48 112 48s-24 38.61-24 53.33S98.75 128 112 128zm64 0c13.25 0 24-11.94 24-26.67S176 48 176 48s-24 38.61-24 53.33S162.75 128 176 128zm64 0c13.25 0 24-11.94 24-26.67S240 48 240 48s-24 38.61-24 53.33S226.75 128 240 128zm160 0c13.25 0 24-11.94 24-26.67S400 48 400 48s-24 38.61-24 53.33S386.75 128 400 128zm64 0c13.25 0 24-11.94 24-26.67S464 48 464 48s-24 38.61-24 53.33S450.75 128 464 128zm64 0c13.25 0 24-11.94 24-26.67S528 48 528 48s-24 38.61-24 53.33S514.75 128 528 128z"]
};
var faHardHat = {
  prefix: 'fas',
  iconName: 'hard-hat',
  icon: [512, 512, [], "f807", "M480 288c0-80.25-49.28-148.92-119.19-177.62L320 192V80a16 16 0 0 0-16-16h-96a16 16 0 0 0-16 16v112l-40.81-81.62C81.28 139.08 32 207.75 32 288v64h448zm16 96H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h480a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"]
};
var faHashtag = {
  prefix: 'fas',
  iconName: 'hashtag',
  icon: [448, 512, [], "f292", "M440.667 182.109l7.143-40c1.313-7.355-4.342-14.109-11.813-14.109h-74.81l14.623-81.891C377.123 38.754 371.468 32 363.997 32h-40.632a12 12 0 0 0-11.813 9.891L296.175 128H197.54l14.623-81.891C213.477 38.754 207.822 32 200.35 32h-40.632a12 12 0 0 0-11.813 9.891L132.528 128H53.432a12 12 0 0 0-11.813 9.891l-7.143 40C33.163 185.246 38.818 192 46.289 192h74.81L98.242 320H19.146a12 12 0 0 0-11.813 9.891l-7.143 40C-1.123 377.246 4.532 384 12.003 384h74.81L72.19 465.891C70.877 473.246 76.532 480 84.003 480h40.632a12 12 0 0 0 11.813-9.891L151.826 384h98.634l-14.623 81.891C234.523 473.246 240.178 480 247.65 480h40.632a12 12 0 0 0 11.813-9.891L315.472 384h79.096a12 12 0 0 0 11.813-9.891l7.143-40c1.313-7.355-4.342-14.109-11.813-14.109h-74.81l22.857-128h79.096a12 12 0 0 0 11.813-9.891zM261.889 320h-98.634l22.857-128h98.634l-22.857 128z"]
};
var faHatCowboy = {
  prefix: 'fas',
  iconName: 'hat-cowboy',
  icon: [640, 512, [], "f8c0", "M490 296.9C480.51 239.51 450.51 64 392.3 64c-14 0-26.49 5.93-37 14a58.21 58.21 0 0 1-70.58 0c-10.51-8-23-14-37-14-58.2 0-88.2 175.47-97.71 232.88C188.81 309.47 243.73 320 320 320s131.23-10.51 170-23.1zm142.9-37.18a16 16 0 0 0-19.75 1.5c-1 .9-101.27 90.78-293.16 90.78-190.82 0-292.22-89.94-293.24-90.84A16 16 0 0 0 1 278.53C1.73 280.55 78.32 480 320 480s318.27-199.45 319-201.47a16 16 0 0 0-6.09-18.81z"]
};
var faHatCowboySide = {
  prefix: 'fas',
  iconName: 'hat-cowboy-side',
  icon: [640, 512, [], "f8c1", "M260.8 291.06c-28.63-22.94-62-35.06-96.4-35.06C87 256 21.47 318.72 1.43 412.06c-3.55 16.6-.43 33.83 8.57 47.3C18.75 472.47 31.83 480 45.88 480H592c-103.21 0-155-37.07-233.19-104.46zm234.65-18.29L468.4 116.2A64 64 0 0 0 392 64.41L200.85 105a64 64 0 0 0-50.35 55.79L143.61 226c6.9-.83 13.7-2 20.79-2 41.79 0 82 14.55 117.29 42.82l98 84.48C450.76 412.54 494.9 448 592 448a48 48 0 0 0 48-48c0-25.39-29.6-119.33-144.55-127.23z"]
};
var faHatWizard = {
  prefix: 'fas',
  iconName: 'hat-wizard',
  icon: [512, 512, [], "f6e8", "M496 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-304-64l-64-32 64-32 32-64 32 64 64 32-64 32-16 32h208l-86.41-201.63a63.955 63.955 0 0 1-1.89-45.45L416 0 228.42 107.19a127.989 127.989 0 0 0-53.46 59.15L64 416h144l-16-32zm64-224l16-32 16 32 32 16-32 16-16 32-16-32-32-16 32-16z"]
};
var faHdd = {
  prefix: 'fas',
  iconName: 'hdd',
  icon: [576, 512, [], "f0a0", "M576 304v96c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48v-96c0-26.51 21.49-48 48-48h480c26.51 0 48 21.49 48 48zm-48-80a79.557 79.557 0 0 1 30.777 6.165L462.25 85.374A48.003 48.003 0 0 0 422.311 64H153.689a48 48 0 0 0-39.938 21.374L17.223 230.165A79.557 79.557 0 0 1 48 224h480zm-48 96c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm-96 0c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32z"]
};
var faHeadSideCough = {
  prefix: 'fas',
  iconName: 'head-side-cough',
  icon: [640, 512, [], "e061", "M616,304a24,24,0,1,0-24-24A24,24,0,0,0,616,304ZM552,416a24,24,0,1,0,24,24A24,24,0,0,0,552,416Zm-64-56a24,24,0,1,0,24,24A24,24,0,0,0,488,360ZM616,464a24,24,0,1,0,24,24A24,24,0,0,0,616,464Zm0-104a24,24,0,1,0,24,24A24,24,0,0,0,616,360Zm-64-40a24,24,0,1,0,24,24A24,24,0,0,0,552,320Zm-74.78-45c-21-47.12-48.5-151.75-73.12-186.75A208.13,208.13,0,0,0,234.1,0H192C86,0,0,86,0,192c0,56.75,24.75,107.62,64,142.88V512H288V480h64a64,64,0,0,0,64-64H320a32,32,0,0,1,0-64h96V320h32A32,32,0,0,0,477.22,275ZM288,224a32,32,0,1,1,32-32A32.07,32.07,0,0,1,288,224Z"]
};
var faHeadSideCoughSlash = {
  prefix: 'fas',
  iconName: 'head-side-cough-slash',
  icon: [640, 512, [], "e062", "M454.11,319.21c19.56-3.81,31.62-25,23.11-44.21-21-47.12-48.5-151.75-73.12-186.75A208.13,208.13,0,0,0,234.1,0H192A190.64,190.64,0,0,0,84.18,33.3L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.46A16,16,0,0,0,6.18,53.91L594.53,508.63A16,16,0,0,0,617,505.82l19.64-25.27a16,16,0,0,0-2.81-22.45ZM313.39,210.45,263.61,172c5.88-7.14,14.43-12,24.36-12a32.06,32.06,0,0,1,32,32C320,199,317.24,205.17,313.39,210.45ZM616,304a24,24,0,1,0-24-24A24,24,0,0,0,616,304Zm-64,64a24,24,0,1,0-24-24A24,24,0,0,0,552,368ZM288,384a32,32,0,0,1,32-32h19.54L20.73,105.59A190.86,190.86,0,0,0,0,192c0,56.75,24.75,107.62,64,142.88V512H288V480h64a64,64,0,0,0,64-64H320A32,32,0,0,1,288,384Zm328-24a24,24,0,1,0,24,24A24,24,0,0,0,616,360Z"]
};
var faHeadSideMask = {
  prefix: 'fas',
  iconName: 'head-side-mask',
  icon: [512, 512, [], "e063", "M.15,184.42C-2.17,244.21,23,298.06,64,334.88V512H224V316.51L3.67,156.25A182.28,182.28,0,0,0,.15,184.42ZM509.22,275c-21-47.12-48.5-151.75-73.12-186.75A208.11,208.11,0,0,0,266.11,0H200C117,0,42.48,50.57,13.25,123.65L239.21,288H511.76A31.35,31.35,0,0,0,509.22,275ZM320,224a32,32,0,1,1,32-32A32.07,32.07,0,0,1,320,224Zm16,144H496l16-48H256V512H401.88a64,64,0,0,0,60.71-43.76L464,464H336a16,16,0,0,1,0-32H474.67l10.67-32H336a16,16,0,0,1,0-32Z"]
};
var faHeadSideVirus = {
  prefix: 'fas',
  iconName: 'head-side-virus',
  icon: [512, 512, [], "e064", "M272,240a16,16,0,1,0,16,16A16,16,0,0,0,272,240Zm-64-64a16,16,0,1,0,16,16A16,16,0,0,0,208,176Zm301.2,99c-20.93-47.12-48.43-151.73-73.07-186.75A207.9,207.9,0,0,0,266.09,0H192C86,0,0,86,0,192A191.23,191.23,0,0,0,64,334.81V512H320V448h64a64,64,0,0,0,64-64V320H480A32,32,0,0,0,509.2,275ZM368,240H355.88c-28.51,0-42.79,34.47-22.63,54.63l8.58,8.57a16,16,0,1,1-22.63,22.63l-8.57-8.58C290.47,297.09,256,311.37,256,339.88V352a16,16,0,0,1-32,0V339.88c0-28.51-34.47-42.79-54.63-22.63l-8.57,8.58a16,16,0,0,1-22.63-22.63l8.58-8.57c20.16-20.16,5.88-54.63-22.63-54.63H112a16,16,0,0,1,0-32h12.12c28.51,0,42.79-34.47,22.63-54.63l-8.58-8.57a16,16,0,0,1,22.63-22.63l8.57,8.58c20.16,20.16,54.63,5.88,54.63-22.63V96a16,16,0,0,1,32,0v12.12c0,28.51,34.47,42.79,54.63,22.63l8.57-8.58a16,16,0,0,1,22.63,22.63l-8.58,8.57C313.09,173.53,327.37,208,355.88,208H368a16,16,0,0,1,0,32Z"]
};
var faHeading = {
  prefix: 'fas',
  iconName: 'heading',
  icon: [512, 512, [], "f1dc", "M448 96v320h32a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H320a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32V288H160v128h32a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32V96H32a16 16 0 0 1-16-16V48a16 16 0 0 1 16-16h160a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16h-32v128h192V96h-32a16 16 0 0 1-16-16V48a16 16 0 0 1 16-16h160a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16z"]
};
var faHeadphones = {
  prefix: 'fas',
  iconName: 'headphones',
  icon: [512, 512, [], "f025", "M256 32C114.52 32 0 146.496 0 288v48a32 32 0 0 0 17.689 28.622l14.383 7.191C34.083 431.903 83.421 480 144 480h24c13.255 0 24-10.745 24-24V280c0-13.255-10.745-24-24-24h-24c-31.342 0-59.671 12.879-80 33.627V288c0-105.869 86.131-192 192-192s192 86.131 192 192v1.627C427.671 268.879 399.342 256 368 256h-24c-13.255 0-24 10.745-24 24v176c0 13.255 10.745 24 24 24h24c60.579 0 109.917-48.098 111.928-108.187l14.382-7.191A32 32 0 0 0 512 336v-48c0-141.479-114.496-256-256-256z"]
};
var faHeadphonesAlt = {
  prefix: 'fas',
  iconName: 'headphones-alt',
  icon: [512, 512, [], "f58f", "M160 288h-16c-35.35 0-64 28.7-64 64.12v63.76c0 35.41 28.65 64.12 64 64.12h16c17.67 0 32-14.36 32-32.06V320.06c0-17.71-14.33-32.06-32-32.06zm208 0h-16c-17.67 0-32 14.35-32 32.06v127.88c0 17.7 14.33 32.06 32 32.06h16c35.35 0 64-28.71 64-64.12v-63.76c0-35.41-28.65-64.12-64-64.12zM256 32C112.91 32 4.57 151.13 0 288v112c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V288c0-114.67 93.33-207.8 208-207.82 114.67.02 208 93.15 208 207.82v112c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V288C507.43 151.13 399.09 32 256 32z"]
};
var faHeadset = {
  prefix: 'fas',
  iconName: 'headset',
  icon: [512, 512, [], "f590", "M192 208c0-17.67-14.33-32-32-32h-16c-35.35 0-64 28.65-64 64v48c0 35.35 28.65 64 64 64h16c17.67 0 32-14.33 32-32V208zm176 144c35.35 0 64-28.65 64-64v-48c0-35.35-28.65-64-64-64h-16c-17.67 0-32 14.33-32 32v112c0 17.67 14.33 32 32 32h16zM256 0C113.18 0 4.58 118.83 0 256v16c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-16c0-114.69 93.31-208 208-208s208 93.31 208 208h-.12c.08 2.43.12 165.72.12 165.72 0 23.35-18.93 42.28-42.28 42.28H320c0-26.51-21.49-48-48-48h-32c-26.51 0-48 21.49-48 48s21.49 48 48 48h181.72c49.86 0 90.28-40.42 90.28-90.28V256C507.42 118.83 398.82 0 256 0z"]
};
var faHeart = {
  prefix: 'fas',
  iconName: 'heart',
  icon: [512, 512, [], "f004", "M462.3 62.6C407.5 15.9 326 24.3 275.7 76.2L256 96.5l-19.7-20.3C186.1 24.3 104.5 15.9 49.7 62.6c-62.8 53.6-66.1 149.8-9.9 207.9l193.5 199.8c12.5 12.9 32.8 12.9 45.3 0l193.5-199.8c56.3-58.1 53-154.3-9.8-207.9z"]
};
var faHeartBroken = {
  prefix: 'fas',
  iconName: 'heart-broken',
  icon: [512, 512, [], "f7a9", "M473.7 73.8l-2.4-2.5c-46-47-118-51.7-169.6-14.8L336 159.9l-96 64 48 128-144-144 96-64-28.6-86.5C159.7 19.6 87 24 40.7 71.4l-2.4 2.4C-10.4 123.6-12.5 202.9 31 256l212.1 218.6c7.1 7.3 18.6 7.3 25.7 0L481 255.9c43.5-53 41.4-132.3-7.3-182.1z"]
};
var faHeartbeat = {
  prefix: 'fas',
  iconName: 'heartbeat',
  icon: [512, 512, [], "f21e", "M320.2 243.8l-49.7 99.4c-6 12.1-23.4 11.7-28.9-.6l-56.9-126.3-30 71.7H60.6l182.5 186.5c7.1 7.3 18.6 7.3 25.7 0L451.4 288H342.3l-22.1-44.2zM473.7 73.9l-2.4-2.5c-51.5-52.6-135.8-52.6-187.4 0L256 100l-27.9-28.5c-51.5-52.7-135.9-52.7-187.4 0l-2.4 2.4C-10.4 123.7-12.5 203 31 256h102.4l35.9-86.2c5.4-12.9 23.6-13.2 29.4-.4l58.2 129.3 49-97.9c5.9-11.8 22.7-11.8 28.6 0l27.6 55.2H481c43.5-53 41.4-132.3-7.3-182.1z"]
};
var faHelicopter = {
  prefix: 'fas',
  iconName: 'helicopter',
  icon: [640, 512, [], "f533", "M304 384h272c17.67 0 32-14.33 32-32 0-123.71-100.29-224-224-224V64h176c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16H144c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h176v64H112L68.8 70.4C65.78 66.37 61.03 64 56 64H16.01C5.6 64-2.04 73.78.49 83.88L32 192l160 64 86.4 115.2A31.992 31.992 0 0 0 304 384zm112-188.49C478.55 208.3 528.03 257.44 540.79 320H416V195.51zm219.37 263.3l-22.15-22.2c-6.25-6.26-16.24-6.1-22.64.01-7.09 6.77-13.84 11.25-24.64 11.25H240c-8.84 0-16 7.18-16 16.03v32.06c0 8.85 7.16 16.03 16 16.03h325.94c14.88 0 35.3-.47 68.45-29.52 7.02-6.14 7.57-17.05.98-23.66z"]
};
var faHighlighter = {
  prefix: 'fas',
  iconName: 'highlighter',
  icon: [544, 512, [], "f591", "M0 479.98L99.92 512l35.45-35.45-67.04-67.04L0 479.98zm124.61-240.01a36.592 36.592 0 0 0-10.79 38.1l13.05 42.83-50.93 50.94 96.23 96.23 50.86-50.86 42.74 13.08c13.73 4.2 28.65-.01 38.15-10.78l35.55-41.64-173.34-173.34-41.52 35.44zm403.31-160.7l-63.2-63.2c-20.49-20.49-53.38-21.52-75.12-2.35L190.55 183.68l169.77 169.78L530.27 154.4c19.18-21.74 18.15-54.63-2.35-75.13z"]
};
var faHiking = {
  prefix: 'fas',
  iconName: 'hiking',
  icon: [384, 512, [], "f6ec", "M80.95 472.23c-4.28 17.16 6.14 34.53 23.28 38.81 2.61.66 5.22.95 7.8.95 14.33 0 27.37-9.7 31.02-24.23l25.24-100.97-52.78-52.78-34.56 138.22zm14.89-196.12L137 117c2.19-8.42-3.14-16.95-11.92-19.06-43.88-10.52-88.35 15.07-99.32 57.17L.49 253.24c-2.19 8.42 3.14 16.95 11.92 19.06l63.56 15.25c8.79 2.1 17.68-3.02 19.87-11.44zM368 160h-16c-8.84 0-16 7.16-16 16v16h-34.75l-46.78-46.78C243.38 134.11 228.61 128 212.91 128c-27.02 0-50.47 18.3-57.03 44.52l-26.92 107.72a32.012 32.012 0 0 0 8.42 30.39L224 397.25V480c0 17.67 14.33 32 32 32s32-14.33 32-32v-82.75c0-17.09-6.66-33.16-18.75-45.25l-46.82-46.82c.15-.5.49-.89.62-1.41l19.89-79.57 22.43 22.43c6 6 14.14 9.38 22.62 9.38h48v240c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V176c.01-8.84-7.15-16-15.99-16zM240 96c26.51 0 48-21.49 48-48S266.51 0 240 0s-48 21.49-48 48 21.49 48 48 48z"]
};
var faHippo = {
  prefix: 'fas',
  iconName: 'hippo',
  icon: [640, 512, [], "f6ed", "M581.12 96.2c-27.67-.15-52.5 17.58-76.6 26.62C489.98 88.27 455.83 64 416 64c-11.28 0-21.95 2.3-32 5.88V56c0-13.26-10.75-24-24-24h-16c-13.25 0-24 10.74-24 24v48.98C286.01 79.58 241.24 64 192 64 85.96 64 0 135.64 0 224v240c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16v-70.79C128.35 407.57 166.72 416 208 416s79.65-8.43 112-22.79V464c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16V288h128v32c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-32c17.67 0 32-14.33 32-32v-92.02c0-34.09-24.79-67.59-58.88-67.78zM448 176c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16z"]
};
var faHistory = {
  prefix: 'fas',
  iconName: 'history',
  icon: [512, 512, [], "f1da", "M504 255.531c.253 136.64-111.18 248.372-247.82 248.468-59.015.042-113.223-20.53-155.822-54.911-11.077-8.94-11.905-25.541-1.839-35.607l11.267-11.267c8.609-8.609 22.353-9.551 31.891-1.984C173.062 425.135 212.781 440 256 440c101.705 0 184-82.311 184-184 0-101.705-82.311-184-184-184-48.814 0-93.149 18.969-126.068 49.932l50.754 50.754c10.08 10.08 2.941 27.314-11.313 27.314H24c-8.837 0-16-7.163-16-16V38.627c0-14.254 17.234-21.393 27.314-11.314l49.372 49.372C129.209 34.136 189.552 8 256 8c136.81 0 247.747 110.78 248 247.531zm-180.912 78.784l9.823-12.63c8.138-10.463 6.253-25.542-4.21-33.679L288 256.349V152c0-13.255-10.745-24-24-24h-16c-13.255 0-24 10.745-24 24v135.651l65.409 50.874c10.463 8.137 25.541 6.253 33.679-4.21z"]
};
var faHockeyPuck = {
  prefix: 'fas',
  iconName: 'hockey-puck',
  icon: [512, 512, [], "f453", "M0 160c0-53 114.6-96 256-96s256 43 256 96-114.6 96-256 96S0 213 0 160zm0 82.2V352c0 53 114.6 96 256 96s256-43 256-96V242.2c-113.4 82.3-398.5 82.4-512 0z"]
};
var faHollyBerry = {
  prefix: 'fas',
  iconName: 'holly-berry',
  icon: [448, 512, [], "f7aa", "M144 192c26.5 0 48-21.5 48-48s-21.5-48-48-48-48 21.5-48 48 21.5 48 48 48zm112-48c0 26.5 21.5 48 48 48s48-21.5 48-48-21.5-48-48-48-48 21.5-48 48zm-32-48c26.5 0 48-21.5 48-48S250.5 0 224 0s-48 21.5-48 48 21.5 48 48 48zm-16.2 139.1c.1-12.4-13.1-20.1-23.8-13.7-34.3 20.3-71.4 32.7-108.7 36.2-9.7.9-15.6 11.3-11.6 20.2 6.2 13.9 11.1 28.6 14.7 43.8 3.6 15.2-5.3 30.6-20.2 35.1-14.9 4.5-30.1 7.6-45.3 9.1-9.7 1-15.7 11.3-11.7 20.2 15 32.8 22.9 69.5 23 107.7.1 14.4 15.2 23.1 27.6 16 33.2-19 68.9-30.5 104.8-33.9 9.7-.9 15.6-11.3 11.6-20.2-6.2-13.9-11.1-28.6-14.7-43.8-3.6-15.2 5.3-30.6 20.2-35.1 14.9-4.5 30.1-7.6 45.3-9.1 9.7-1 15.7-11.3 11.7-20.2-15.5-34.2-23.3-72.5-22.9-112.3zM435 365.6c-15.2-1.6-30.3-4.7-45.3-9.1-14.9-4.5-23.8-19.9-20.2-35.1 3.6-15.2 8.5-29.8 14.7-43.8 4-8.9-1.9-19.3-11.6-20.2-37.3-3.5-74.4-15.9-108.7-36.2-10.7-6.3-23.9 1.4-23.8 13.7 0 1.6-.2 3.2-.2 4.9.2 33.3 7 65.7 19.9 94 5.7 12.4 5.2 26.6-.6 38.9 4.9 1.2 9.9 2.2 14.8 3.7 14.9 4.5 23.8 19.9 20.2 35.1-3.6 15.2-8.5 29.8-14.7 43.8-4 8.9 1.9 19.3 11.6 20.2 35.9 3.4 71.6 14.9 104.8 33.9 12.5 7.1 27.6-1.6 27.6-16 .2-38.2 8-75 23-107.7 4.3-8.7-1.8-19.1-11.5-20.1z"]
};
var faHome = {
  prefix: 'fas',
  iconName: 'home',
  icon: [576, 512, [], "f015", "M280.37 148.26L96 300.11V464a16 16 0 0 0 16 16l112.06-.29a16 16 0 0 0 15.92-16V368a16 16 0 0 1 16-16h64a16 16 0 0 1 16 16v95.64a16 16 0 0 0 16 16.05L464 480a16 16 0 0 0 16-16V300L295.67 148.26a12.19 12.19 0 0 0-15.3 0zM571.6 251.47L488 182.56V44.05a12 12 0 0 0-12-12h-56a12 12 0 0 0-12 12v72.61L318.47 43a48 48 0 0 0-61 0L4.34 251.47a12 12 0 0 0-1.6 16.9l25.5 31A12 12 0 0 0 45.15 301l235.22-193.74a12.19 12.19 0 0 1 15.3 0L530.9 301a12 12 0 0 0 16.9-1.6l25.5-31a12 12 0 0 0-1.7-16.93z"]
};
var faHorse = {
  prefix: 'fas',
  iconName: 'horse',
  icon: [576, 512, [], "f6f0", "M575.92 76.6c-.01-8.13-3.02-15.87-8.58-21.8-3.78-4.03-8.58-9.12-13.69-14.5 11.06-6.84 19.5-17.49 22.18-30.66C576.85 4.68 572.96 0 567.9 0H447.92c-70.69 0-128 57.31-128 128H160c-28.84 0-54.4 12.98-72 33.11V160c-48.53 0-88 39.47-88 88v56c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-56c0-13.22 6.87-24.39 16.78-31.68-.21 2.58-.78 5.05-.78 7.68 0 27.64 11.84 52.36 30.54 69.88l-25.72 68.6a63.945 63.945 0 0 0-2.16 37.99l24.85 99.41A15.982 15.982 0 0 0 107.02 512h65.96c10.41 0 18.05-9.78 15.52-19.88l-26.31-105.26 23.84-63.59L320 345.6V496c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16V318.22c19.74-20.19 32-47.75 32-78.22 0-.22-.07-.42-.08-.64V136.89l16 7.11 18.9 37.7c7.45 14.87 25.05 21.55 40.49 15.37l32.55-13.02a31.997 31.997 0 0 0 20.12-29.74l-.06-77.71zm-64 19.4c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16z"]
};
var faHorseHead = {
  prefix: 'fas',
  iconName: 'horse-head',
  icon: [512, 512, [], "f7ab", "M509.8 332.5l-69.9-164.3c-14.9-41.2-50.4-71-93-79.2 18-10.6 46.3-35.9 34.2-82.3-1.3-5-7.1-7.9-12-6.1L166.9 76.3C35.9 123.4 0 238.9 0 398.8V480c0 17.7 14.3 32 32 32h236.2c23.8 0 39.3-25 28.6-46.3L256 384v-.7c-45.6-3.5-84.6-30.7-104.3-69.6-1.6-3.1-.9-6.9 1.6-9.3l12.1-12.1c3.9-3.9 10.6-2.7 12.9 2.4 14.8 33.7 48.2 57.4 87.4 57.4 17.2 0 33-5.1 46.8-13.2l46 63.9c6 8.4 15.7 13.3 26 13.3h50.3c8.5 0 16.6-3.4 22.6-9.4l45.3-39.8c8.9-9.1 11.7-22.6 7.1-34.4zM328 224c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24z"]
};
var faHospital = {
  prefix: 'fas',
  iconName: 'hospital',
  icon: [448, 512, [], "f0f8", "M448 492v20H0v-20c0-6.627 5.373-12 12-12h20V120c0-13.255 10.745-24 24-24h88V24c0-13.255 10.745-24 24-24h112c13.255 0 24 10.745 24 24v72h88c13.255 0 24 10.745 24 24v360h20c6.627 0 12 5.373 12 12zM308 192h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zm-168 64h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12zm104 128h-40c-6.627 0-12 5.373-12 12v84h64v-84c0-6.627-5.373-12-12-12zm64-96h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zm-116 12c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40zM182 96h26v26a6 6 0 0 0 6 6h20a6 6 0 0 0 6-6V96h26a6 6 0 0 0 6-6V70a6 6 0 0 0-6-6h-26V38a6 6 0 0 0-6-6h-20a6 6 0 0 0-6 6v26h-26a6 6 0 0 0-6 6v20a6 6 0 0 0 6 6z"]
};
var faHospitalAlt = {
  prefix: 'fas',
  iconName: 'hospital-alt',
  icon: [576, 512, [], "f47d", "M544 96H416V32c0-17.7-14.3-32-32-32H192c-17.7 0-32 14.3-32 32v64H32c-17.7 0-32 14.3-32 32v368c0 8.8 7.2 16 16 16h544c8.8 0 16-7.2 16-16V128c0-17.7-14.3-32-32-32zM160 436c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-128c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm160 128c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-128c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm16-170c0 3.3-2.7 6-6 6h-26v26c0 3.3-2.7 6-6 6h-20c-3.3 0-6-2.7-6-6v-26h-26c-3.3 0-6-2.7-6-6v-20c0-3.3 2.7-6 6-6h26V86c0-3.3 2.7-6 6-6h20c3.3 0 6 2.7 6 6v26h26c3.3 0 6 2.7 6 6v20zm144 298c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-128c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40z"]
};
var faHospitalSymbol = {
  prefix: 'fas',
  iconName: 'hospital-symbol',
  icon: [512, 512, [], "f47e", "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256 256-114.6 256-256S397.4 0 256 0zm112 376c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-88h-96v88c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V136c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v88h96v-88c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v240z"]
};
var faHospitalUser = {
  prefix: 'fas',
  iconName: 'hospital-user',
  icon: [640, 512, [], "f80d", "M480 320a96 96 0 1 0-96-96 96 96 0 0 0 96 96zm48 32a22.88 22.88 0 0 0-7.06 1.09 124.76 124.76 0 0 1-81.89 0A22.82 22.82 0 0 0 432 352a112 112 0 0 0-112 112.62c.14 26.26 21.73 47.38 48 47.38h224c26.27 0 47.86-21.12 48-47.38A112 112 0 0 0 528 352zm-198.09 10.45A145.19 145.19 0 0 1 352 344.62V128a32 32 0 0 0-32-32h-32V32a32 32 0 0 0-32-32H96a32 32 0 0 0-32 32v64H32a32 32 0 0 0-32 32v368a16 16 0 0 0 16 16h288.31A78.62 78.62 0 0 1 288 464.79a143.06 143.06 0 0 1 41.91-102.34zM144 404a12 12 0 0 1-12 12H92a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12zm0-128a12 12 0 0 1-12 12H92a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12zm48-122a6 6 0 0 1-6 6h-20a6 6 0 0 1-6-6v-26h-26a6 6 0 0 1-6-6v-20a6 6 0 0 1 6-6h26V70a6 6 0 0 1 6-6h20a6 6 0 0 1 6 6v26h26a6 6 0 0 1 6 6v20a6 6 0 0 1-6 6h-26zm80 250a12 12 0 0 1-12 12h-40a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12zm0-128a12 12 0 0 1-12 12h-40a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12z"]
};
var faHotTub = {
  prefix: 'fas',
  iconName: 'hot-tub',
  icon: [512, 512, [], "f593", "M414.21 177.65c1.02 8.21 7.75 14.35 15.75 14.35h16.12c9.51 0 17.08-8.57 16-18.35-4.34-39.11-22.4-74.53-50.13-97.16-17.37-14.17-28.82-36.75-31.98-62.15C378.96 6.14 372.22 0 364.23 0h-16.12c-9.51 0-17.09 8.57-16 18.35 4.34 39.11 22.4 74.53 50.13 97.16 17.36 14.17 28.82 36.75 31.97 62.14zm-108 0c1.02 8.21 7.75 14.35 15.75 14.35h16.12c9.51 0 17.08-8.57 16-18.35-4.34-39.11-22.4-74.53-50.13-97.16-17.37-14.17-28.82-36.75-31.98-62.15C270.96 6.14 264.22 0 256.23 0h-16.12c-9.51 0-17.09 8.57-16 18.35 4.34 39.11 22.4 74.53 50.13 97.16 17.36 14.17 28.82 36.75 31.97 62.14zM480 256H256l-110.93-83.2a63.99 63.99 0 0 0-38.4-12.8H64c-35.35 0-64 28.65-64 64v224c0 35.35 28.65 64 64 64h384c35.35 0 64-28.65 64-64V288c0-17.67-14.33-32-32-32zM128 440c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8V328c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v112zm96 0c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8V328c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v112zm96 0c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8V328c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v112zm96 0c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8V328c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v112zM64 128c35.35 0 64-28.65 64-64S99.35 0 64 0 0 28.65 0 64s28.65 64 64 64z"]
};
var faHotdog = {
  prefix: 'fas',
  iconName: 'hotdog',
  icon: [512, 512, [], "f80f", "M488.56 23.44a80 80 0 0 0-113.12 0l-352 352a80 80 0 1 0 113.12 113.12l352-352a80 80 0 0 0 0-113.12zm-49.93 95.19c-19.6 19.59-37.52 22.67-51.93 25.14C373.76 146 364.4 147.6 352 160s-14 21.76-16.23 34.71c-2.48 14.4-5.55 32.33-25.15 51.92s-37.52 22.67-51.92 25.15C245.75 274 236.4 275.6 224 288s-14 21.75-16.23 34.7c-2.47 14.4-5.54 32.33-25.14 51.92s-37.53 22.68-51.93 25.15C117.76 402 108.4 403.6 96 416a16 16 0 0 1-22.63-22.63c19.6-19.59 37.52-22.67 51.92-25.14 13-2.22 22.3-3.82 34.71-16.23s14-21.75 16.22-34.7c2.48-14.4 5.55-32.33 25.15-51.92s37.52-22.67 51.92-25.14c13-2.22 22.3-3.83 34.7-16.23s14-21.76 16.24-34.71c2.47-14.4 5.54-32.33 25.14-51.92s37.52-22.68 51.92-25.15C394.24 110 403.59 108.41 416 96a16 16 0 0 1 22.63 22.63zM31.44 322.18L322.18 31.44l-11.54-11.55c-25-25-63.85-26.66-86.79-3.72L16.17 223.85c-22.94 22.94-21.27 61.79 3.72 86.78zm449.12-132.36L189.82 480.56l11.54 11.55c25 25 63.85 26.66 86.79 3.72l207.68-207.68c22.94-22.94 21.27-61.79-3.72-86.79z"]
};
var faHotel = {
  prefix: 'fas',
  iconName: 'hotel',
  icon: [576, 512, [], "f594", "M560 64c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16H16C7.16 0 0 7.16 0 16v32c0 8.84 7.16 16 16 16h15.98v384H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h240v-80c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v80h240c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16h-16V64h16zm-304 44.8c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4zm0 96c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4zm-128-96c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4zM179.2 256h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4c0 6.4-6.4 12.8-12.8 12.8zM192 384c0-53.02 42.98-96 96-96s96 42.98 96 96H192zm256-140.8c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm0-96c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4z"]
};
var faHourglass = {
  prefix: 'fas',
  iconName: 'hourglass',
  icon: [384, 512, [], "f254", "M360 64c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24 0 90.965 51.016 167.734 120.842 192C75.016 280.266 24 357.035 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24 0-90.965-51.016-167.734-120.842-192C308.984 231.734 360 154.965 360 64z"]
};
var faHourglassEnd = {
  prefix: 'fas',
  iconName: 'hourglass-end',
  icon: [384, 512, [], "f253", "M360 64c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24 0 90.965 51.016 167.734 120.842 192C75.016 280.266 24 357.035 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24 0-90.965-51.016-167.734-120.842-192C308.984 231.734 360 154.965 360 64zM192 208c-57.787 0-104-66.518-104-144h208c0 77.945-46.51 144-104 144z"]
};
var faHourglassHalf = {
  prefix: 'fas',
  iconName: 'hourglass-half',
  icon: [384, 512, [], "f252", "M360 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24 0 90.965 51.016 167.734 120.842 192C75.016 280.266 24 357.035 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24 0-90.965-51.016-167.734-120.842-192C308.984 231.734 360 154.965 360 64c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24zm-75.078 384H99.08c17.059-46.797 52.096-80 92.92-80 40.821 0 75.862 33.196 92.922 80zm.019-256H99.078C91.988 108.548 88 86.748 88 64h208c0 22.805-3.987 44.587-11.059 64z"]
};
var faHourglassStart = {
  prefix: 'fas',
  iconName: 'hourglass-start',
  icon: [384, 512, [], "f251", "M360 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24 0 90.965 51.016 167.734 120.842 192C75.016 280.266 24 357.035 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24 0-90.965-51.016-167.734-120.842-192C308.984 231.734 360 154.965 360 64c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24zm-64 448H88c0-77.458 46.204-144 104-144 57.786 0 104 66.517 104 144z"]
};
var faHouseDamage = {
  prefix: 'fas',
  iconName: 'house-damage',
  icon: [576, 512, [], "f6f1", "M288 114.96L69.47 307.71c-1.62 1.46-3.69 2.14-5.47 3.35V496c0 8.84 7.16 16 16 16h149.23L192 439.19l104.11-64-60.16-119.22L384 392.75l-104.11 64L319.81 512H496c8.84 0 16-7.16 16-16V311.1c-1.7-1.16-3.72-1.82-5.26-3.2L288 114.96zm282.69 121.32L512 184.45V48c0-8.84-7.16-16-16-16h-64c-8.84 0-16 7.16-16 16v51.69L314.75 10.31C307.12 3.45 297.56.01 288 0s-19.1 3.41-26.7 10.27L5.31 236.28c-6.57 5.91-7.12 16.02-1.21 22.6l21.4 23.82c5.9 6.57 16.02 7.12 22.6 1.21L277.42 81.63c6.05-5.33 15.12-5.33 21.17 0L527.91 283.9c6.57 5.9 16.69 5.36 22.6-1.21l21.4-23.82c5.9-6.57 5.36-16.69-1.22-22.59z"]
};
var faHouseUser = {
  prefix: 'fas',
  iconName: 'house-user',
  icon: [576, 512, [], "e065", "M570.69,236.27,512,184.44V48a16,16,0,0,0-16-16H432a16,16,0,0,0-16,16V99.67L314.78,10.3C308.5,4.61,296.53,0,288,0s-20.46,4.61-26.74,10.3l-256,226A18.27,18.27,0,0,0,0,248.2a18.64,18.64,0,0,0,4.09,10.71L25.5,282.7a21.14,21.14,0,0,0,12,5.3,21.67,21.67,0,0,0,10.69-4.11l15.9-14V480a32,32,0,0,0,32,32H480a32,32,0,0,0,32-32V269.88l15.91,14A21.94,21.94,0,0,0,538.63,288a20.89,20.89,0,0,0,11.87-5.31l21.41-23.81A21.64,21.64,0,0,0,576,248.19,21,21,0,0,0,570.69,236.27ZM288,176a64,64,0,1,1-64,64A64,64,0,0,1,288,176ZM400,448H176a16,16,0,0,1-16-16,96,96,0,0,1,96-96h64a96,96,0,0,1,96,96A16,16,0,0,1,400,448Z"]
};
var faHryvnia = {
  prefix: 'fas',
  iconName: 'hryvnia',
  icon: [384, 512, [], "f6f2", "M368 240c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16h-41.86c13.41-28.63 13.74-63.33-4.13-94.05C303.34 49.84 267.1 32 229.96 32h-78.82c-24.32 0-47.86 8.53-66.54 24.09L72.83 65.9c-10.18 8.49-11.56 23.62-3.07 33.8l20.49 24.59c8.49 10.19 23.62 11.56 33.81 3.07l11.73-9.78c4.32-3.6 9.77-5.57 15.39-5.57h83.62c11.69 0 21.2 9.52 21.2 21.2 0 5.91-2.48 11.58-6.81 15.58L219.7 176H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h134.37l-34.67 32H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h41.86c-13.41 28.63-13.74 63.33 4.13 94.05C80.66 462.15 116.9 480 154.04 480h78.82c24.32 0 47.86-8.53 66.54-24.09l11.77-9.81c10.18-8.49 11.56-23.62 3.07-33.8l-20.49-24.59c-8.49-10.19-23.62-11.56-33.81-3.07l-11.75 9.8a23.992 23.992 0 0 1-15.36 5.56H149.2c-11.69 0-21.2-9.52-21.2-21.2 0-5.91 2.48-11.58 6.81-15.58L164.3 336H368c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16H233.63l34.67-32H368z"]
};
var faICursor = {
  prefix: 'fas',
  iconName: 'i-cursor',
  icon: [256, 512, [], "f246", "M256 52.048V12.065C256 5.496 250.726.148 244.158.066 211.621-.344 166.469.011 128 37.959 90.266.736 46.979-.114 11.913.114 5.318.157 0 5.519 0 12.114v39.645c0 6.687 5.458 12.078 12.145 11.998C38.111 63.447 96 67.243 96 112.182V224H60c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h36v112c0 44.932-56.075 48.031-83.95 47.959C5.404 447.942 0 453.306 0 459.952v39.983c0 6.569 5.274 11.917 11.842 11.999 32.537.409 77.689.054 116.158-37.894 37.734 37.223 81.021 38.073 116.087 37.845 6.595-.043 11.913-5.405 11.913-12V460.24c0-6.687-5.458-12.078-12.145-11.998C217.889 448.553 160 444.939 160 400V288h36c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-36V112.182c0-44.932 56.075-48.213 83.95-48.142 6.646.018 12.05-5.346 12.05-11.992z"]
};
var faIceCream = {
  prefix: 'fas',
  iconName: 'ice-cream',
  icon: [448, 512, [], "f810", "M368 160h-.94a144 144 0 1 0-286.12 0H80a48 48 0 0 0 0 96h288a48 48 0 0 0 0-96zM195.38 493.69a31.52 31.52 0 0 0 57.24 0L352 288H96z"]
};
var faIcicles = {
  prefix: 'fas',
  iconName: 'icicles',
  icon: [512, 512, [], "f7ad", "M511.4 37.9C515.1 18.2 500 0 480 0H32C10.6 0-4.8 20.7 1.4 41.2l87.1 273.4c2.5 7.2 12.7 7.2 15.1 0L140 190.5l44.2 187.3c1.9 8.3 13.7 8.3 15.6 0l46.5-196.9 34.1 133.4c2.3 7.6 13 7.6 15.3 0l45.8-172.5 66.7 363.8c1.7 8.6 14 8.6 15.7 0l87.5-467.7z"]
};
var faIcons = {
  prefix: 'fas',
  iconName: 'icons',
  icon: [512, 512, [], "f86d", "M116.65 219.35a15.68 15.68 0 0 0 22.65 0l96.75-99.83c28.15-29 26.5-77.1-4.91-103.88C203.75-7.7 163-3.5 137.86 22.44L128 32.58l-9.85-10.14C93.05-3.5 52.25-7.7 24.86 15.64c-31.41 26.78-33 74.85-5 103.88zm143.92 100.49h-48l-7.08-14.24a27.39 27.39 0 0 0-25.66-17.78h-71.71a27.39 27.39 0 0 0-25.66 17.78l-7 14.24h-48A27.45 27.45 0 0 0 0 347.3v137.25A27.44 27.44 0 0 0 27.43 512h233.14A27.45 27.45 0 0 0 288 484.55V347.3a27.45 27.45 0 0 0-27.43-27.46zM144 468a52 52 0 1 1 52-52 52 52 0 0 1-52 52zm355.4-115.9h-60.58l22.36-50.75c2.1-6.65-3.93-13.21-12.18-13.21h-75.59c-6.3 0-11.66 3.9-12.5 9.1l-16.8 106.93c-1 6.3 4.88 11.89 12.5 11.89h62.31l-24.2 83c-1.89 6.65 4.2 12.9 12.23 12.9a13.26 13.26 0 0 0 10.92-5.25l92.4-138.91c4.88-6.91-1.16-15.7-10.87-15.7zM478.08.33L329.51 23.17C314.87 25.42 304 38.92 304 54.83V161.6a83.25 83.25 0 0 0-16-1.7c-35.35 0-64 21.48-64 48s28.65 48 64 48c35.2 0 63.73-21.32 64-47.66V99.66l112-17.22v47.18a83.25 83.25 0 0 0-16-1.7c-35.35 0-64 21.48-64 48s28.65 48 64 48c35.2 0 63.73-21.32 64-47.66V32c0-19.48-16-34.42-33.92-31.67z"]
};
var faIdBadge = {
  prefix: 'fas',
  iconName: 'id-badge',
  icon: [384, 512, [], "f2c1", "M336 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM144 32h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16s7.2-16 16-16zm48 128c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm112 236.8c0 10.6-10 19.2-22.4 19.2H102.4C90 416 80 407.4 80 396.8v-19.2c0-31.8 30.1-57.6 67.2-57.6h5c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h5c37.1 0 67.2 25.8 67.2 57.6v19.2z"]
};
var faIdCard = {
  prefix: 'fas',
  iconName: 'id-card',
  icon: [576, 512, [], "f2c2", "M528 32H48C21.5 32 0 53.5 0 80v16h576V80c0-26.5-21.5-48-48-48zM0 432c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V128H0v304zm352-232c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16zm0 64c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16zm0 64c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16zM176 192c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zM67.1 396.2C75.5 370.5 99.6 352 128 352h8.2c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h8.2c28.4 0 52.5 18.5 60.9 44.2 3.2 9.9-5.2 19.8-15.6 19.8H82.7c-10.4 0-18.8-10-15.6-19.8z"]
};
var faIdCardAlt = {
  prefix: 'fas',
  iconName: 'id-card-alt',
  icon: [576, 512, [], "f47f", "M528 64H384v96H192V64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM288 224c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm93.3 224H194.7c-10.4 0-18.8-10-15.6-19.8 8.3-25.6 32.4-44.2 60.9-44.2h8.2c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h8.2c28.4 0 52.5 18.5 60.9 44.2 3.2 9.8-5.2 19.8-15.6 19.8zM352 32c0-17.7-14.3-32-32-32h-64c-17.7 0-32 14.3-32 32v96h128V32z"]
};
var faIgloo = {
  prefix: 'fas',
  iconName: 'igloo',
  icon: [576, 512, [], "f7ae", "M320 33.9c-10.5-1.2-21.2-1.9-32-1.9-99.8 0-187.8 50.8-239.4 128H320V33.9zM96 192H30.3C11.1 230.6 0 274 0 320h96V192zM352 39.4V160h175.4C487.2 99.9 424.8 55.9 352 39.4zM480 320h96c0-46-11.1-89.4-30.3-128H480v128zm-64 64v96h128c17.7 0 32-14.3 32-32v-96H411.5c2.6 10.3 4.5 20.9 4.5 32zm32-192H128v128h49.8c22.2-38.1 63-64 110.2-64s88 25.9 110.2 64H448V192zM0 448c0 17.7 14.3 32 32 32h128v-96c0-11.1 1.9-21.7 4.5-32H0v96zm288-160c-53 0-96 43-96 96v96h192v-96c0-53-43-96-96-96z"]
};
var faImage = {
  prefix: 'fas',
  iconName: 'image',
  icon: [512, 512, [], "f03e", "M464 448H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h416c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48zM112 120c-30.928 0-56 25.072-56 56s25.072 56 56 56 56-25.072 56-56-25.072-56-56-56zM64 384h384V272l-87.515-87.515c-4.686-4.686-12.284-4.686-16.971 0L208 320l-55.515-55.515c-4.686-4.686-12.284-4.686-16.971 0L64 336v48z"]
};
var faImages = {
  prefix: 'fas',
  iconName: 'images',
  icon: [576, 512, [], "f302", "M480 416v16c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V176c0-26.51 21.49-48 48-48h16v208c0 44.112 35.888 80 80 80h336zm96-80V80c0-26.51-21.49-48-48-48H144c-26.51 0-48 21.49-48 48v256c0 26.51 21.49 48 48 48h384c26.51 0 48-21.49 48-48zM256 128c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-96 144l55.515-55.515c4.686-4.686 12.284-4.686 16.971 0L272 256l135.515-135.515c4.686-4.686 12.284-4.686 16.971 0L512 208v112H160v-48z"]
};
var faInbox = {
  prefix: 'fas',
  iconName: 'inbox',
  icon: [576, 512, [], "f01c", "M567.938 243.908L462.25 85.374A48.003 48.003 0 0 0 422.311 64H153.689a48 48 0 0 0-39.938 21.374L8.062 243.908A47.994 47.994 0 0 0 0 270.533V400c0 26.51 21.49 48 48 48h480c26.51 0 48-21.49 48-48V270.533a47.994 47.994 0 0 0-8.062-26.625zM162.252 128h251.497l85.333 128H376l-32 64H232l-32-64H76.918l85.334-128z"]
};
var faIndent = {
  prefix: 'fas',
  iconName: 'indent',
  icon: [448, 512, [], "f03c", "M27.31 363.3l96-96a16 16 0 0 0 0-22.62l-96-96C17.27 138.66 0 145.78 0 160v192c0 14.31 17.33 21.3 27.31 11.3zM432 416H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm3.17-128H204.83A12.82 12.82 0 0 0 192 300.83v38.34A12.82 12.82 0 0 0 204.83 352h230.34A12.82 12.82 0 0 0 448 339.17v-38.34A12.82 12.82 0 0 0 435.17 288zm0-128H204.83A12.82 12.82 0 0 0 192 172.83v38.34A12.82 12.82 0 0 0 204.83 224h230.34A12.82 12.82 0 0 0 448 211.17v-38.34A12.82 12.82 0 0 0 435.17 160zM432 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"]
};
var faIndustry = {
  prefix: 'fas',
  iconName: 'industry',
  icon: [512, 512, [], "f275", "M475.115 163.781L336 252.309v-68.28c0-18.916-20.931-30.399-36.885-20.248L160 252.309V56c0-13.255-10.745-24-24-24H24C10.745 32 0 42.745 0 56v400c0 13.255 10.745 24 24 24h464c13.255 0 24-10.745 24-24V184.029c0-18.917-20.931-30.399-36.885-20.248z"]
};
var faInfinity = {
  prefix: 'fas',
  iconName: 'infinity',
  icon: [640, 512, [], "f534", "M471.1 96C405 96 353.3 137.3 320 174.6 286.7 137.3 235 96 168.9 96 75.8 96 0 167.8 0 256s75.8 160 168.9 160c66.1 0 117.8-41.3 151.1-78.6 33.3 37.3 85 78.6 151.1 78.6 93.1 0 168.9-71.8 168.9-160S564.2 96 471.1 96zM168.9 320c-40.2 0-72.9-28.7-72.9-64s32.7-64 72.9-64c38.2 0 73.4 36.1 94 64-20.4 27.6-55.9 64-94 64zm302.2 0c-38.2 0-73.4-36.1-94-64 20.4-27.6 55.9-64 94-64 40.2 0 72.9 28.7 72.9 64s-32.7 64-72.9 64z"]
};
var faInfo = {
  prefix: 'fas',
  iconName: 'info',
  icon: [192, 512, [], "f129", "M20 424.229h20V279.771H20c-11.046 0-20-8.954-20-20V212c0-11.046 8.954-20 20-20h112c11.046 0 20 8.954 20 20v212.229h20c11.046 0 20 8.954 20 20V492c0 11.046-8.954 20-20 20H20c-11.046 0-20-8.954-20-20v-47.771c0-11.046 8.954-20 20-20zM96 0C56.235 0 24 32.235 24 72s32.235 72 72 72 72-32.235 72-72S135.764 0 96 0z"]
};
var faInfoCircle = {
  prefix: 'fas',
  iconName: 'info-circle',
  icon: [512, 512, [], "f05a", "M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z"]
};
var faItalic = {
  prefix: 'fas',
  iconName: 'italic',
  icon: [320, 512, [], "f033", "M320 48v32a16 16 0 0 1-16 16h-62.76l-80 320H208a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H16a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h62.76l80-320H112a16 16 0 0 1-16-16V48a16 16 0 0 1 16-16h192a16 16 0 0 1 16 16z"]
};
var faJedi = {
  prefix: 'fas',
  iconName: 'jedi',
  icon: [576, 512, [], "f669", "M535.95308,352c-42.64069,94.17188-137.64086,160-247.9848,160q-6.39844,0-12.84377-.29688C171.15558,506.9375,81.26481,442.23438,40.01474,352H79.93668L21.3272,293.40625a264.82522,264.82522,0,0,1-5.10938-39.42187,273.6653,273.6653,0,0,1,.5-29.98438H63.93665L22.546,182.625A269.79782,269.79782,0,0,1,130.51489,20.54688a16.06393,16.06393,0,0,1,9.28127-3,16.36332,16.36332,0,0,1,13.5,7.25,16.02739,16.02739,0,0,1,1.625,15.09374,138.387,138.387,0,0,0-9.84376,51.26563c0,45.10937,21.04691,86.57813,57.71884,113.73437a16.29989,16.29989,0,0,1,1.20313,25.39063c-26.54692,23.98437-41.17194,56.5-41.17194,91.57813,0,60.03124,42.95319,110.28124,99.89079,121.92187l2.5-65.26563L238.062,397a8.33911,8.33911,0,0,1-10-.75,8.025,8.025,0,0,1-1.39063-9.9375l20.125-33.76562-42.06257-8.73438a7.9898,7.9898,0,0,1,0-15.65625l42.06257-8.71875-20.10941-33.73438a7.99122,7.99122,0,0,1,11.35939-10.71874L268.437,295.64062,279.95265,7.67188a7.97138,7.97138,0,0,1,8-7.67188h.04687a8.02064,8.02064,0,0,1,7.95314,7.70312L307.48394,295.625l30.39068-20.67188a8.08327,8.08327,0,0,1,10,.8125,7.99866,7.99866,0,0,1,1.39062,9.90626L329.12461,319.4375l42.07819,8.73438a7.99373,7.99373,0,0,1,0,15.65624l-42.07819,8.71876,20.1094,33.73437a7.97791,7.97791,0,0,1-1.32812,9.92187A8.25739,8.25739,0,0,1,337.87462,397L310.7027,378.53125l2.5,65.34375c48.48446-9.40625,87.57828-48.15625,97.31267-96.5A123.52652,123.52652,0,0,0,371.9528,230.29688a16.30634,16.30634,0,0,1,1.20313-25.42188c36.65631-27.17188,57.6876-68.60938,57.6876-113.73438a138.01689,138.01689,0,0,0-9.85939-51.3125,15.98132,15.98132,0,0,1,1.60937-15.09374,16.36914,16.36914,0,0,1,13.5-7.23438,16.02453,16.02453,0,0,1,9.25,2.98438A271.26947,271.26947,0,0,1,553.25,182.76562L511.99992,224h46.9532C559.3125,229.76562,560,235.45312,560,241.26562a270.092,270.092,0,0,1-5.125,51.85938L495.98427,352Z"]
};
var faJoint = {
  prefix: 'fas',
  iconName: 'joint',
  icon: [640, 512, [], "f595", "M444.34 181.1c22.38 15.68 35.66 41.16 35.66 68.59V280c0 4.42 3.58 8 8 8h48c4.42 0 8-3.58 8-8v-30.31c0-43.24-21.01-83.41-56.34-108.06C463.85 125.02 448 99.34 448 70.31V8c0-4.42-3.58-8-8-8h-48c-4.42 0-8 3.58-8 8v66.4c0 43.69 24.56 81.63 60.34 106.7zM194.97 358.98C126.03 370.07 59.69 394.69 0 432c83.65 52.28 180.3 80 278.94 80h88.57L254.79 380.49c-14.74-17.2-37.45-25.11-59.82-21.51zM553.28 87.09c-5.67-3.8-9.28-9.96-9.28-16.78V8c0-4.42-3.58-8-8-8h-48c-4.42 0-8 3.58-8 8v62.31c0 22.02 10.17 43.41 28.64 55.39C550.79 153.04 576 199.54 576 249.69V280c0 4.42 3.58 8 8 8h48c4.42 0 8-3.58 8-8v-30.31c0-65.44-32.41-126.19-86.72-162.6zM360.89 352.05c-34.4.06-86.81.15-88.21.17l117.8 137.43A63.987 63.987 0 0 0 439.07 512h88.45L409.57 374.4a63.955 63.955 0 0 0-48.68-22.35zM616 352H432l117.99 137.65A63.987 63.987 0 0 0 598.58 512H616c13.25 0 24-10.75 24-24V376c0-13.26-10.75-24-24-24z"]
};
var faJournalWhills = {
  prefix: 'fas',
  iconName: 'journal-whills',
  icon: [448, 512, [], "f66a", "M438.40625,377.59375c-3.20313,12.8125-3.20313,57.60937,0,73.60937Q447.9922,460.78907,448,470.40625v16c0,16-12.79688,25.59375-25.59375,25.59375H96c-54.40625,0-96-41.59375-96-96V96C0,41.59375,41.59375,0,96,0H422.40625C438.40625,0,448,9.59375,448,25.59375v332.8125Q448,372.79688,438.40625,377.59375ZM380.79688,384H96c-16,0-32,12.79688-32,32s12.79688,32,32,32H380.79688ZM128.01562,176.01562c0,.51563.14063.98438.14063,1.5l37.10937,32.46876A7.99954,7.99954,0,0,1,160,224h-.01562a9.17678,9.17678,0,0,1-5.25-1.98438L131.14062,201.375C142.6875,250.95312,186.90625,288,240,288s97.3125-37.04688,108.875-86.625l-23.59375,20.64062a8.02516,8.02516,0,0,1-5.26563,1.96876H320a9.14641,9.14641,0,0,1-6.01562-2.71876A9.26508,9.26508,0,0,1,312,216a9.097,9.097,0,0,1,2.73438-6.01562l37.10937-32.46876c.01563-.53124.15625-1,.15625-1.51562,0-11.04688-2.09375-21.51562-5.06251-31.59375l-21.26562,21.25a8.00467,8.00467,0,0,1-11.32812-11.3125l26.42187-26.40625a111.81517,111.81517,0,0,0-46.35937-49.26562,63.02336,63.02336,0,0,1-14.0625,82.64062A55.83846,55.83846,0,0,1,251.625,254.73438l-1.42188-34.28126,12.67188,8.625a3.967,3.967,0,0,0,2.25.6875,3.98059,3.98059,0,0,0,3.43749-6.03124l-8.53124-14.3125,17.90625-3.71876a4.00647,4.00647,0,0,0,0-7.84374l-17.90625-3.71876,8.53124-14.3125a3.98059,3.98059,0,0,0-3.43749-6.03124,4.726,4.726,0,0,0-2.25.67187L248.6875,184.125,244,71.82812a4.00386,4.00386,0,0,0-8,0l-4.625,110.8125-12-8.15624a4.003,4.003,0,0,0-5.68751,5.35937l8.53126,14.3125L204.3125,197.875a3.99686,3.99686,0,0,0,0,7.82812l17.90625,3.73438-8.53126,14.29688a4.72469,4.72469,0,0,0-.56249,2.04687,4.59547,4.59547,0,0,0,1.25,2.90625,4.01059,4.01059,0,0,0,2.75,1.09375,4.09016,4.09016,0,0,0,2.25-.6875l10.35937-7.04687L228.375,254.76562a55.86414,55.86414,0,0,1-28.71875-93.45312,63.01119,63.01119,0,0,1-14.04688-82.65625,111.93158,111.93158,0,0,0-46.375,49.26563l26.42187,26.42187a7.99917,7.99917,0,0,1-11.3125,11.3125l-21.26563-21.26563C130.09375,154.48438,128,164.95312,128.01562,176.01562Z"]
};
var faKaaba = {
  prefix: 'fas',
  iconName: 'kaaba',
  icon: [576, 512, [], "f66b", "M554.12 83.51L318.36 4.93a95.962 95.962 0 0 0-60.71 0L21.88 83.51A32.006 32.006 0 0 0 0 113.87v49.01l265.02-79.51c15.03-4.5 30.92-4.5 45.98 0l265 79.51v-49.01c0-13.77-8.81-26-21.88-30.36zm-279.9 30.52L0 196.3v228.38c0 15 10.42 27.98 25.06 31.24l242.12 53.8a95.937 95.937 0 0 0 41.65 0l242.12-53.8c14.64-3.25 25.06-16.24 25.06-31.24V196.29l-274.2-82.26c-9.04-2.72-18.59-2.72-27.59 0zM128 230.11c0 3.61-2.41 6.77-5.89 7.72l-80 21.82C37.02 261.03 32 257.2 32 251.93v-16.58c0-3.61 2.41-6.77 5.89-7.72l80-21.82c5.09-1.39 10.11 2.44 10.11 7.72v16.58zm144-39.28c0 3.61-2.41 6.77-5.89 7.72l-96 26.18c-5.09 1.39-10.11-2.44-10.11-7.72v-16.58c0-3.61 2.41-6.77 5.89-7.72l96-26.18c5.09-1.39 10.11 2.44 10.11 7.72v16.58zm176 22.7c0-5.28 5.02-9.11 10.11-7.72l80 21.82c3.48.95 5.89 4.11 5.89 7.72v16.58c0 5.28-5.02 9.11-10.11 7.72l-80-21.82a7.997 7.997 0 0 1-5.89-7.72v-16.58zm-144-39.27c0-5.28 5.02-9.11 10.11-7.72l96 26.18c3.48.95 5.89 4.11 5.89 7.72v16.58c0 5.28-5.02 9.11-10.11 7.72l-96-26.18a7.997 7.997 0 0 1-5.89-7.72v-16.58z"]
};
var faKey = {
  prefix: 'fas',
  iconName: 'key',
  icon: [512, 512, [], "f084", "M512 176.001C512 273.203 433.202 352 336 352c-11.22 0-22.19-1.062-32.827-3.069l-24.012 27.014A23.999 23.999 0 0 1 261.223 384H224v40c0 13.255-10.745 24-24 24h-40v40c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24v-78.059c0-6.365 2.529-12.47 7.029-16.971l161.802-161.802C163.108 213.814 160 195.271 160 176 160 78.798 238.797.001 335.999 0 433.488-.001 512 78.511 512 176.001zM336 128c0 26.51 21.49 48 48 48s48-21.49 48-48-21.49-48-48-48-48 21.49-48 48z"]
};
var faKeyboard = {
  prefix: 'fas',
  iconName: 'keyboard',
  icon: [576, 512, [], "f11c", "M528 448H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h480c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48zM128 180v-40c0-6.627-5.373-12-12-12H76c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm-336 96v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm-336 96v-40c0-6.627-5.373-12-12-12H76c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm288 0v-40c0-6.627-5.373-12-12-12H172c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h232c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12z"]
};
var faKhanda = {
  prefix: 'fas',
  iconName: 'khanda',
  icon: [512, 512, [], "f66d", "M415.81 66c-6.37-3.5-14.37-2.33-19.36 3.02a15.974 15.974 0 0 0-1.91 19.52c16.49 26.16 25.2 56.39 25.2 87.41-.19 53.25-26.77 102.69-71.27 132.41l-76.63 53.35v-20.1l44.05-36.09c3.92-4.2 5-10.09 2.81-15.28L310.85 273c33.84-19.26 56.94-55.25 56.94-96.99 0-40.79-22.02-76.13-54.59-95.71l5.22-11.44c2.34-5.53.93-11.83-3.57-16.04L255.86 0l-58.99 52.81c-4.5 4.21-5.9 10.51-3.57 16.04l5.22 11.44c-32.57 19.58-54.59 54.93-54.59 95.72 0 41.75 23.09 77.73 56.94 96.99l-7.85 17.24c-2.19 5.18-1.1 11.07 2.81 15.28l44.05 36.09v19.9l-76.59-53.33C119.02 278.62 92.44 229.19 92.26 176c0-31.08 8.71-61.31 25.2-87.47 3.87-6.16 2.4-13.77-2.59-19.08-5-5.34-13.68-6.2-20.02-2.7C16.32 109.6-22.3 205.3 13.36 295.99c7.07 17.99 17.89 34.38 30.46 49.06l55.97 65.36c4.87 5.69 13.04 7.24 19.65 3.72l79.35-42.23L228 392.23l-47.08 32.78c-1.67-.37-3.23-1.01-5.01-1.01-13.25 0-23.99 10.74-23.99 24 0 13.25 10.74 24 23.99 24 12.1 0 21.69-9.11 23.33-20.76l40.63-28.28v29.95c-9.39 5.57-15.99 15.38-15.99 27.1 0 17.67 14.32 32 31.98 32s31.98-14.33 31.98-32c0-11.71-6.61-21.52-15.99-27.1v-30.15l40.91 28.48C314.41 462.89 324 472 336.09 472c13.25 0 23.99-10.75 23.99-24 0-13.26-10.74-24-23.99-24-1.78 0-3.34.64-5.01 1.01L284 392.23l29.21-20.34 79.35 42.23c6.61 3.52 14.78 1.97 19.65-3.71l52.51-61.31c18.87-22.02 34-47.5 41.25-75.59 21.62-83.66-16.45-167.27-90.16-207.51zm-95.99 110c0 22.3-11.49 41.92-28.83 53.38l-5.65-12.41c-8.75-24.52-8.75-51.04 0-75.56l7.83-17.18c16.07 11.65 26.65 30.45 26.65 51.77zm-127.93 0c0-21.32 10.58-40.12 26.66-51.76l7.83 17.18c8.75 24.52 8.75 51.03 0 75.56l-5.65 12.41c-17.34-11.46-28.84-31.09-28.84-53.39z"]
};
var faKiss = {
  prefix: 'fas',
  iconName: 'kiss',
  icon: [496, 512, [], "f596", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-80 232c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm136 156c0 19.2-28.7 41.5-71.5 44-8.5.8-12.1-11.8-3.6-15.4l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-6-2.5-6.1-12.2 0-14.8l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-8.6-3.6-4.8-16.5 3.6-15.4 42.8 2.5 71.5 24.8 71.5 44 0 13-13.4 27.3-35.2 36C290.6 368.7 304 383 304 396zm24-156c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"]
};
var faKissBeam = {
  prefix: 'fas',
  iconName: 'kiss-beam',
  icon: [496, 512, [], "f597", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-39 219.9l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.5 8.5-10.9 12-15.1 4.5zM304 396c0 19.2-28.7 41.5-71.5 44-8.5.8-12.1-11.8-3.6-15.4l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-6-2.5-6.1-12.2 0-14.8l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-8.6-3.6-4.8-16.5 3.6-15.4 42.8 2.5 71.5 24.8 71.5 44 0 13-13.4 27.3-35.2 36C290.6 368.7 304 383 304 396zm65-168.1l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.1 7.3-15.6 4-14.9-4.5 3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.5 8.5-10.9 12-15.1 4.5z"]
};
var faKissWinkHeart = {
  prefix: 'fas',
  iconName: 'kiss-wink-heart',
  icon: [504, 512, [], "f598", "M501.1 402.5c-8-20.8-31.5-31.5-53.1-25.9l-8.4 2.2-2.3-8.4c-5.9-21.4-27-36.5-49-33-25.2 4-40.6 28.6-34 52.6l22.9 82.6c1.5 5.3 7 8.5 12.4 7.1l83-21.5c24.1-6.3 37.7-31.8 28.5-55.7zm-177.6-4c-5.6-20.3-2.3-42 9-59.7 29.7-46.3 98.7-45.5 127.8 4.3 6.4.1 12.6 1.4 18.6 2.9 10.9-27.9 17.1-58.2 17.1-90C496 119 385 8 248 8S0 119 0 256s111 248 248 248c35.4 0 68.9-7.5 99.4-20.9-.3-.7-23.9-84.6-23.9-84.6zM168 240c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm120 156c0 19.2-28.7 41.5-71.5 44-8.5.8-12.1-11.8-3.6-15.4l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-6-2.5-5.7-12.3 0-14.8l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-8.8-3.7-4.6-16.6 3.6-15.4 42.8 2.5 71.5 24.8 71.5 44 0 13-13.4 27.3-35.2 36C274.6 368.7 288 383 288 396zm16-179c-8.3 7.4-21.6.4-19.8-10.8 4-25.2 34.2-42.1 59.9-42.1S400 181 404 206.2c1.7 11.1-11.3 18.3-19.8 10.8l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L304 217z"]
};
var faKiwiBird = {
  prefix: 'fas',
  iconName: 'kiwi-bird',
  icon: [576, 512, [], "f535", "M575.81 217.98C572.64 157.41 518.28 112 457.63 112h-9.37c-52.82 0-104.25-16.25-147.74-46.24-41.99-28.96-96.04-41.62-153.21-28.7C129.3 41.12-.08 78.24 0 224c.04 70.95 38.68 132.8 95.99 166.01V464c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-54.26c15.36 3.96 31.4 6.26 48 6.26 5.44 0 10.68-.73 16-1.18V464c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-59.43c14.24-5.06 27.88-11.39 40.34-19.51C342.07 355.25 393.86 336 448.46 336c25.48 0 16.01-.31 23.05-.78l74.41 136.44c2.86 5.23 8.3 8.34 14.05 8.34 1.31 0 2.64-.16 3.95-.5 7.09-1.8 12.05-8.19 12.05-15.5 0 0 .14-240.24-.16-246.02zM463.97 248c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm80 153.25l-39.86-73.08c15.12-5.83 28.73-14.6 39.86-25.98v99.06z"]
};
var faLandmark = {
  prefix: 'fas',
  iconName: 'landmark',
  icon: [512, 512, [], "f66f", "M501.62 92.11L267.24 2.04a31.958 31.958 0 0 0-22.47 0L10.38 92.11A16.001 16.001 0 0 0 0 107.09V144c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-36.91c0-6.67-4.14-12.64-10.38-14.98zM64 192v160H48c-8.84 0-16 7.16-16 16v48h448v-48c0-8.84-7.16-16-16-16h-16V192h-64v160h-96V192h-64v160h-96V192H64zm432 256H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"]
};
var faLanguage = {
  prefix: 'fas',
  iconName: 'language',
  icon: [640, 512, [], "f1ab", "M152.1 236.2c-3.5-12.1-7.8-33.2-7.8-33.2h-.5s-4.3 21.1-7.8 33.2l-11.1 37.5H163zM616 96H336v320h280c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24zm-24 120c0 6.6-5.4 12-12 12h-11.4c-6.9 23.6-21.7 47.4-42.7 69.9 8.4 6.4 17.1 12.5 26.1 18 5.5 3.4 7.3 10.5 4.1 16.2l-7.9 13.9c-3.4 5.9-10.9 7.8-16.7 4.3-12.6-7.8-24.5-16.1-35.4-24.9-10.9 8.7-22.7 17.1-35.4 24.9-5.8 3.5-13.3 1.6-16.7-4.3l-7.9-13.9c-3.2-5.6-1.4-12.8 4.2-16.2 9.3-5.7 18-11.7 26.1-18-7.9-8.4-14.9-17-21-25.7-4-5.7-2.2-13.6 3.7-17.1l6.5-3.9 7.3-4.3c5.4-3.2 12.4-1.7 16 3.4 5 7 10.8 14 17.4 20.9 13.5-14.2 23.8-28.9 30-43.2H412c-6.6 0-12-5.4-12-12v-16c0-6.6 5.4-12 12-12h64v-16c0-6.6 5.4-12 12-12h16c6.6 0 12 5.4 12 12v16h64c6.6 0 12 5.4 12 12zM0 120v272c0 13.3 10.7 24 24 24h280V96H24c-13.3 0-24 10.7-24 24zm58.9 216.1L116.4 167c1.7-4.9 6.2-8.1 11.4-8.1h32.5c5.1 0 9.7 3.3 11.4 8.1l57.5 169.1c2.6 7.8-3.1 15.9-11.4 15.9h-22.9a12 12 0 0 1-11.5-8.6l-9.4-31.9h-60.2l-9.1 31.8c-1.5 5.1-6.2 8.7-11.5 8.7H70.3c-8.2 0-14-8.1-11.4-15.9z"]
};
var faLaptop = {
  prefix: 'fas',
  iconName: 'laptop',
  icon: [640, 512, [], "f109", "M624 416H381.54c-.74 19.81-14.71 32-32.74 32H288c-18.69 0-33.02-17.47-32.77-32H16c-8.8 0-16 7.2-16 16v16c0 35.2 28.8 64 64 64h512c35.2 0 64-28.8 64-64v-16c0-8.8-7.2-16-16-16zM576 48c0-26.4-21.6-48-48-48H112C85.6 0 64 21.6 64 48v336h512V48zm-64 272H128V64h384v256z"]
};
var faLaptopCode = {
  prefix: 'fas',
  iconName: 'laptop-code',
  icon: [640, 512, [], "f5fc", "M255.03 261.65c6.25 6.25 16.38 6.25 22.63 0l11.31-11.31c6.25-6.25 6.25-16.38 0-22.63L253.25 192l35.71-35.72c6.25-6.25 6.25-16.38 0-22.63l-11.31-11.31c-6.25-6.25-16.38-6.25-22.63 0l-58.34 58.34c-6.25 6.25-6.25 16.38 0 22.63l58.35 58.34zm96.01-11.3l11.31 11.31c6.25 6.25 16.38 6.25 22.63 0l58.34-58.34c6.25-6.25 6.25-16.38 0-22.63l-58.34-58.34c-6.25-6.25-16.38-6.25-22.63 0l-11.31 11.31c-6.25 6.25-6.25 16.38 0 22.63L386.75 192l-35.71 35.72c-6.25 6.25-6.25 16.38 0 22.63zM624 416H381.54c-.74 19.81-14.71 32-32.74 32H288c-18.69 0-33.02-17.47-32.77-32H16c-8.8 0-16 7.2-16 16v16c0 35.2 28.8 64 64 64h512c35.2 0 64-28.8 64-64v-16c0-8.8-7.2-16-16-16zM576 48c0-26.4-21.6-48-48-48H112C85.6 0 64 21.6 64 48v336h512V48zm-64 272H128V64h384v256z"]
};
var faLaptopHouse = {
  prefix: 'fas',
  iconName: 'laptop-house',
  icon: [640, 512, [], "e066", "M272,288H208a16,16,0,0,1-16-16V208a16,16,0,0,1,16-16h64a16,16,0,0,1,16,16v37.12C299.11,232.24,315,224,332.8,224H469.74l6.65-7.53A16.51,16.51,0,0,0,480,207a16.31,16.31,0,0,0-4.75-10.61L416,144V48a16,16,0,0,0-16-16H368a16,16,0,0,0-16,16V87.3L263.5,8.92C258,4,247.45,0,240.05,0s-17.93,4-23.47,8.92L4.78,196.42A16.15,16.15,0,0,0,0,207a16.4,16.4,0,0,0,3.55,9.39L22.34,237.7A16.22,16.22,0,0,0,33,242.48,16.51,16.51,0,0,0,42.34,239L64,219.88V384a32,32,0,0,0,32,32H272ZM629.33,448H592V288c0-17.67-12.89-32-28.8-32H332.8c-15.91,0-28.8,14.33-28.8,32V448H266.67A10.67,10.67,0,0,0,256,458.67v10.66A42.82,42.82,0,0,0,298.6,512H597.4A42.82,42.82,0,0,0,640,469.33V458.67A10.67,10.67,0,0,0,629.33,448ZM544,448H352V304H544Z"]
};
var faLaptopMedical = {
  prefix: 'fas',
  iconName: 'laptop-medical',
  icon: [640, 512, [], "f812", "M232 224h56v56a8 8 0 0 0 8 8h48a8 8 0 0 0 8-8v-56h56a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8h-56v-56a8 8 0 0 0-8-8h-48a8 8 0 0 0-8 8v56h-56a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8zM576 48a48.14 48.14 0 0 0-48-48H112a48.14 48.14 0 0 0-48 48v336h512zm-64 272H128V64h384zm112 96H381.54c-.74 19.81-14.71 32-32.74 32H288c-18.69 0-33-17.47-32.77-32H16a16 16 0 0 0-16 16v16a64.19 64.19 0 0 0 64 64h512a64.19 64.19 0 0 0 64-64v-16a16 16 0 0 0-16-16z"]
};
var faLaugh = {
  prefix: 'fas',
  iconName: 'laugh',
  icon: [496, 512, [], "f599", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 152c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm-160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm88 272h-16c-73.4 0-134-55-142.9-126-1.2-9.5 6.3-18 15.9-18h270c9.6 0 17.1 8.4 15.9 18-8.9 71-69.5 126-142.9 126z"]
};
var faLaughBeam = {
  prefix: 'fas',
  iconName: 'laugh-beam',
  icon: [496, 512, [], "f59a", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm24 199.4c3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.8 4.1-15.1-4.5zm-160 0c3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.3 7.4-15.8 4-15.1-4.5zM398.9 306C390 377 329.4 432 256 432h-16c-73.4 0-134-55-142.9-126-1.2-9.5 6.3-18 15.9-18h270c9.6 0 17.1 8.4 15.9 18z"]
};
var faLaughSquint = {
  prefix: 'fas',
  iconName: 'laugh-squint',
  icon: [496, 512, [], "f59b", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm33.8 161.7l80-48c11.6-6.9 24 7.7 15.4 18L343.6 180l33.6 40.3c8.7 10.4-3.9 24.8-15.4 18l-80-48c-7.7-4.7-7.7-15.9 0-20.6zm-163-30c-8.6-10.3 3.8-24.9 15.4-18l80 48c7.8 4.7 7.8 15.9 0 20.6l-80 48c-11.5 6.8-24-7.6-15.4-18l33.6-40.3-33.6-40.3zM398.9 306C390 377 329.4 432 256 432h-16c-73.4 0-134-55-142.9-126-1.2-9.5 6.3-18 15.9-18h270c9.6 0 17.1 8.4 15.9 18z"]
};
var faLaughWink = {
  prefix: 'fas',
  iconName: 'laugh-wink',
  icon: [496, 512, [], "f59c", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm20.1 198.1c4-25.2 34.2-42.1 59.9-42.1s55.9 16.9 59.9 42.1c1.7 11.1-11.4 18.3-19.8 10.8l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L288 217c-8.4 7.4-21.6.3-19.9-10.9zM168 160c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm230.9 146C390 377 329.4 432 256 432h-16c-73.4 0-134-55-142.9-126-1.2-9.5 6.3-18 15.9-18h270c9.6 0 17.1 8.4 15.9 18z"]
};
var faLayerGroup = {
  prefix: 'fas',
  iconName: 'layer-group',
  icon: [512, 512, [], "f5fd", "M12.41 148.02l232.94 105.67c6.8 3.09 14.49 3.09 21.29 0l232.94-105.67c16.55-7.51 16.55-32.52 0-40.03L266.65 2.31a25.607 25.607 0 0 0-21.29 0L12.41 107.98c-16.55 7.51-16.55 32.53 0 40.04zm487.18 88.28l-58.09-26.33-161.64 73.27c-7.56 3.43-15.59 5.17-23.86 5.17s-16.29-1.74-23.86-5.17L70.51 209.97l-58.1 26.33c-16.55 7.5-16.55 32.5 0 40l232.94 105.59c6.8 3.08 14.49 3.08 21.29 0L499.59 276.3c16.55-7.5 16.55-32.5 0-40zm0 127.8l-57.87-26.23-161.86 73.37c-7.56 3.43-15.59 5.17-23.86 5.17s-16.29-1.74-23.86-5.17L70.29 337.87 12.41 364.1c-16.55 7.5-16.55 32.5 0 40l232.94 105.59c6.8 3.08 14.49 3.08 21.29 0L499.59 404.1c16.55-7.5 16.55-32.5 0-40z"]
};
var faLeaf = {
  prefix: 'fas',
  iconName: 'leaf',
  icon: [576, 512, [], "f06c", "M546.2 9.7c-5.6-12.5-21.6-13-28.3-1.2C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 7 .8 13.7 1.5 20.5C161.3 262.8 253.4 224 384 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C132.6 256 26 410.1 2.4 468c-6.6 16.3 1.2 34.9 17.5 41.6 16.4 6.8 35-1.1 41.8-17.3 1.5-3.6 20.9-47.9 71.9-90.6 32.4 43.9 94 85.8 174.9 77.2C465.5 467.5 576 326.7 576 154.3c0-50.2-10.8-102.2-29.8-144.6z"]
};
var faLemon = {
  prefix: 'fas',
  iconName: 'lemon',
  icon: [512, 512, [], "f094", "M489.038 22.963C465.944-.13 434.648-5.93 413.947 6.129c-58.906 34.312-181.25-53.077-321.073 86.746S40.441 355.041 6.129 413.945c-12.059 20.702-6.26 51.999 16.833 75.093 23.095 23.095 54.392 28.891 75.095 16.832 58.901-34.31 181.246 53.079 321.068-86.743S471.56 156.96 505.871 98.056c12.059-20.702 6.261-51.999-16.833-75.093zM243.881 95.522c-58.189 14.547-133.808 90.155-148.358 148.358-1.817 7.27-8.342 12.124-15.511 12.124-1.284 0-2.59-.156-3.893-.481-8.572-2.144-13.784-10.83-11.642-19.403C81.901 166.427 166.316 81.93 236.119 64.478c8.575-2.143 17.261 3.069 19.403 11.642s-3.069 17.259-11.641 19.402z"]
};
var faLessThan = {
  prefix: 'fas',
  iconName: 'less-than',
  icon: [384, 512, [], "f536", "M365.46 357.74L147.04 255.89l218.47-101.88c16.02-7.47 22.95-26.51 15.48-42.53l-13.52-29C360 66.46 340.96 59.53 324.94 67L18.48 209.91a32.014 32.014 0 0 0-18.48 29v34.24c0 12.44 7.21 23.75 18.48 29l306.31 142.83c16.06 7.49 35.15.54 42.64-15.52l13.56-29.08c7.49-16.06.54-35.15-15.53-42.64z"]
};
var faLessThanEqual = {
  prefix: 'fas',
  iconName: 'less-than-equal',
  icon: [448, 512, [], "f537", "M54.98 214.2l301.41 119.87c18.39 6.03 38.71-2.54 45.38-19.15l12.09-30.08c6.68-16.61-2.82-34.97-21.21-41l-175.44-68.05 175.56-68.09c18.29-6 27.74-24.27 21.1-40.79l-12.03-29.92c-6.64-16.53-26.86-25.06-45.15-19.06L54.98 137.89C41.21 142.41 32 154.5 32 168.07v15.96c0 13.56 9.21 25.65 22.98 30.17zM424 400H24c-13.25 0-24 10.74-24 24v48c0 13.25 10.75 24 24 24h400c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24z"]
};
var faLevelDownAlt = {
  prefix: 'fas',
  iconName: 'level-down-alt',
  icon: [320, 512, [], "f3be", "M313.553 392.331L209.587 504.334c-9.485 10.214-25.676 10.229-35.174 0L70.438 392.331C56.232 377.031 67.062 352 88.025 352H152V80H68.024a11.996 11.996 0 0 1-8.485-3.515l-56-56C-4.021 12.926 1.333 0 12.024 0H208c13.255 0 24 10.745 24 24v328h63.966c20.878 0 31.851 24.969 17.587 40.331z"]
};
var faLevelUpAlt = {
  prefix: 'fas',
  iconName: 'level-up-alt',
  icon: [320, 512, [], "f3bf", "M313.553 119.669L209.587 7.666c-9.485-10.214-25.676-10.229-35.174 0L70.438 119.669C56.232 134.969 67.062 160 88.025 160H152v272H68.024a11.996 11.996 0 0 0-8.485 3.515l-56 56C-4.021 499.074 1.333 512 12.024 512H208c13.255 0 24-10.745 24-24V160h63.966c20.878 0 31.851-24.969 17.587-40.331z"]
};
var faLifeRing = {
  prefix: 'fas',
  iconName: 'life-ring',
  icon: [512, 512, [], "f1cd", "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm173.696 119.559l-63.399 63.399c-10.987-18.559-26.67-34.252-45.255-45.255l63.399-63.399a218.396 218.396 0 0 1 45.255 45.255zM256 352c-53.019 0-96-42.981-96-96s42.981-96 96-96 96 42.981 96 96-42.981 96-96 96zM127.559 82.304l63.399 63.399c-18.559 10.987-34.252 26.67-45.255 45.255l-63.399-63.399a218.372 218.372 0 0 1 45.255-45.255zM82.304 384.441l63.399-63.399c10.987 18.559 26.67 34.252 45.255 45.255l-63.399 63.399a218.396 218.396 0 0 1-45.255-45.255zm302.137 45.255l-63.399-63.399c18.559-10.987 34.252-26.67 45.255-45.255l63.399 63.399a218.403 218.403 0 0 1-45.255 45.255z"]
};
var faLightbulb = {
  prefix: 'fas',
  iconName: 'lightbulb',
  icon: [352, 512, [], "f0eb", "M96.06 454.35c.01 6.29 1.87 12.45 5.36 17.69l17.09 25.69a31.99 31.99 0 0 0 26.64 14.28h61.71a31.99 31.99 0 0 0 26.64-14.28l17.09-25.69a31.989 31.989 0 0 0 5.36-17.69l.04-38.35H96.01l.05 38.35zM0 176c0 44.37 16.45 84.85 43.56 115.78 16.52 18.85 42.36 58.23 52.21 91.45.04.26.07.52.11.78h160.24c.04-.26.07-.51.11-.78 9.85-33.22 35.69-72.6 52.21-91.45C335.55 260.85 352 220.37 352 176 352 78.61 272.91-.3 175.45 0 73.44.31 0 82.97 0 176zm176-80c-44.11 0-80 35.89-80 80 0 8.84-7.16 16-16 16s-16-7.16-16-16c0-61.76 50.24-112 112-112 8.84 0 16 7.16 16 16s-7.16 16-16 16z"]
};
var faLink = {
  prefix: 'fas',
  iconName: 'link',
  icon: [512, 512, [], "f0c1", "M326.612 185.391c59.747 59.809 58.927 155.698.36 214.59-.11.12-.24.25-.36.37l-67.2 67.2c-59.27 59.27-155.699 59.262-214.96 0-59.27-59.26-59.27-155.7 0-214.96l37.106-37.106c9.84-9.84 26.786-3.3 27.294 10.606.648 17.722 3.826 35.527 9.69 52.721 1.986 5.822.567 12.262-3.783 16.612l-13.087 13.087c-28.026 28.026-28.905 73.66-1.155 101.96 28.024 28.579 74.086 28.749 102.325.51l67.2-67.19c28.191-28.191 28.073-73.757 0-101.83-3.701-3.694-7.429-6.564-10.341-8.569a16.037 16.037 0 0 1-6.947-12.606c-.396-10.567 3.348-21.456 11.698-29.806l21.054-21.055c5.521-5.521 14.182-6.199 20.584-1.731a152.482 152.482 0 0 1 20.522 17.197zM467.547 44.449c-59.261-59.262-155.69-59.27-214.96 0l-67.2 67.2c-.12.12-.25.25-.36.37-58.566 58.892-59.387 154.781.36 214.59a152.454 152.454 0 0 0 20.521 17.196c6.402 4.468 15.064 3.789 20.584-1.731l21.054-21.055c8.35-8.35 12.094-19.239 11.698-29.806a16.037 16.037 0 0 0-6.947-12.606c-2.912-2.005-6.64-4.875-10.341-8.569-28.073-28.073-28.191-73.639 0-101.83l67.2-67.19c28.239-28.239 74.3-28.069 102.325.51 27.75 28.3 26.872 73.934-1.155 101.96l-13.087 13.087c-4.35 4.35-5.769 10.79-3.783 16.612 5.864 17.194 9.042 34.999 9.69 52.721.509 13.906 17.454 20.446 27.294 10.606l37.106-37.106c59.271-59.259 59.271-155.699.001-214.959z"]
};
var faLiraSign = {
  prefix: 'fas',
  iconName: 'lira-sign',
  icon: [384, 512, [], "f195", "M371.994 256h-48.019C317.64 256 312 260.912 312 267.246 312 368 230.179 416 144 416V256.781l134.603-29.912A12 12 0 0 0 288 215.155v-40.976c0-7.677-7.109-13.38-14.603-11.714L144 191.219V160.78l134.603-29.912A12 12 0 0 0 288 119.154V78.179c0-7.677-7.109-13.38-14.603-11.714L144 95.219V44c0-6.627-5.373-12-12-12H76c-6.627 0-12 5.373-12 12v68.997L9.397 125.131A12 12 0 0 0 0 136.845v40.976c0 7.677 7.109 13.38 14.603 11.714L64 178.558v30.439L9.397 221.131A12 12 0 0 0 0 232.845v40.976c0 7.677 7.109 13.38 14.603 11.714L64 274.558V468c0 6.627 5.373 12 12 12h79.583c134.091 0 223.255-77.834 228.408-211.592.261-6.782-5.211-12.408-11.997-12.408z"]
};
var faList = {
  prefix: 'fas',
  iconName: 'list',
  icon: [512, 512, [], "f03a", "M80 368H16a16 16 0 0 0-16 16v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-64a16 16 0 0 0-16-16zm0-320H16A16 16 0 0 0 0 64v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16V64a16 16 0 0 0-16-16zm0 160H16a16 16 0 0 0-16 16v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-64a16 16 0 0 0-16-16zm416 176H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"]
};
var faListAlt = {
  prefix: 'fas',
  iconName: 'list-alt',
  icon: [512, 512, [], "f022", "M464 480H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h416c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48zM128 120c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zm0 96c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zm0 96c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zm288-136v-32c0-6.627-5.373-12-12-12H204c-6.627 0-12 5.373-12 12v32c0 6.627 5.373 12 12 12h200c6.627 0 12-5.373 12-12zm0 96v-32c0-6.627-5.373-12-12-12H204c-6.627 0-12 5.373-12 12v32c0 6.627 5.373 12 12 12h200c6.627 0 12-5.373 12-12zm0 96v-32c0-6.627-5.373-12-12-12H204c-6.627 0-12 5.373-12 12v32c0 6.627 5.373 12 12 12h200c6.627 0 12-5.373 12-12z"]
};
var faListOl = {
  prefix: 'fas',
  iconName: 'list-ol',
  icon: [512, 512, [], "f0cb", "M61.77 401l17.5-20.15a19.92 19.92 0 0 0 5.07-14.19v-3.31C84.34 356 80.5 352 73 352H16a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h22.83a157.41 157.41 0 0 0-11 12.31l-5.61 7c-4 5.07-5.25 10.13-2.8 14.88l1.05 1.93c3 5.76 6.29 7.88 12.25 7.88h4.73c10.33 0 15.94 2.44 15.94 9.09 0 4.72-4.2 8.22-14.36 8.22a41.54 41.54 0 0 1-15.47-3.12c-6.49-3.88-11.74-3.5-15.6 3.12l-5.59 9.31c-3.72 6.13-3.19 11.72 2.63 15.94 7.71 4.69 20.38 9.44 37 9.44 34.16 0 48.5-22.75 48.5-44.12-.03-14.38-9.12-29.76-28.73-34.88zM496 224H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-160H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 320H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM16 160h64a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8H64V40a8 8 0 0 0-8-8H32a8 8 0 0 0-7.14 4.42l-8 16A8 8 0 0 0 24 64h8v64H16a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8zm-3.91 160H80a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8H41.32c3.29-10.29 48.34-18.68 48.34-56.44 0-29.06-25-39.56-44.47-39.56-21.36 0-33.8 10-40.46 18.75-4.37 5.59-3 10.84 2.8 15.37l8.58 6.88c5.61 4.56 11 2.47 16.12-2.44a13.44 13.44 0 0 1 9.46-3.84c3.33 0 9.28 1.56 9.28 8.75C51 248.19 0 257.31 0 304.59v4C0 316 5.08 320 12.09 320z"]
};
var faListUl = {
  prefix: 'fas',
  iconName: 'list-ul',
  icon: [512, 512, [], "f0ca", "M48 48a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm0 160a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm0 160a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm448 16H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"]
};
var faLocationArrow = {
  prefix: 'fas',
  iconName: 'location-arrow',
  icon: [512, 512, [], "f124", "M444.52 3.52L28.74 195.42c-47.97 22.39-31.98 92.75 19.19 92.75h175.91v175.91c0 51.17 70.36 67.17 92.75 19.19l191.9-415.78c15.99-38.39-25.59-79.97-63.97-63.97z"]
};
var faLock = {
  prefix: 'fas',
  iconName: 'lock',
  icon: [448, 512, [], "f023", "M400 224h-24v-72C376 68.2 307.8 0 224 0S72 68.2 72 152v72H48c-26.5 0-48 21.5-48 48v192c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48zm-104 0H152v-72c0-39.7 32.3-72 72-72s72 32.3 72 72v72z"]
};
var faLockOpen = {
  prefix: 'fas',
  iconName: 'lock-open',
  icon: [576, 512, [], "f3c1", "M423.5 0C339.5.3 272 69.5 272 153.5V224H48c-26.5 0-48 21.5-48 48v192c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48h-48v-71.1c0-39.6 31.7-72.5 71.3-72.9 40-.4 72.7 32.1 72.7 72v80c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24v-80C576 68 507.5-.3 423.5 0z"]
};
var faLongArrowAltDown = {
  prefix: 'fas',
  iconName: 'long-arrow-alt-down',
  icon: [256, 512, [], "f309", "M168 345.941V44c0-6.627-5.373-12-12-12h-56c-6.627 0-12 5.373-12 12v301.941H41.941c-21.382 0-32.09 25.851-16.971 40.971l86.059 86.059c9.373 9.373 24.569 9.373 33.941 0l86.059-86.059c15.119-15.119 4.411-40.971-16.971-40.971H168z"]
};
var faLongArrowAltLeft = {
  prefix: 'fas',
  iconName: 'long-arrow-alt-left',
  icon: [448, 512, [], "f30a", "M134.059 296H436c6.627 0 12-5.373 12-12v-56c0-6.627-5.373-12-12-12H134.059v-46.059c0-21.382-25.851-32.09-40.971-16.971L7.029 239.029c-9.373 9.373-9.373 24.569 0 33.941l86.059 86.059c15.119 15.119 40.971 4.411 40.971-16.971V296z"]
};
var faLongArrowAltRight = {
  prefix: 'fas',
  iconName: 'long-arrow-alt-right',
  icon: [448, 512, [], "f30b", "M313.941 216H12c-6.627 0-12 5.373-12 12v56c0 6.627 5.373 12 12 12h301.941v46.059c0 21.382 25.851 32.09 40.971 16.971l86.059-86.059c9.373-9.373 9.373-24.569 0-33.941l-86.059-86.059c-15.119-15.119-40.971-4.411-40.971 16.971V216z"]
};
var faLongArrowAltUp = {
  prefix: 'fas',
  iconName: 'long-arrow-alt-up',
  icon: [256, 512, [], "f30c", "M88 166.059V468c0 6.627 5.373 12 12 12h56c6.627 0 12-5.373 12-12V166.059h46.059c21.382 0 32.09-25.851 16.971-40.971l-86.059-86.059c-9.373-9.373-24.569-9.373-33.941 0l-86.059 86.059c-15.119 15.119-4.411 40.971 16.971 40.971H88z"]
};
var faLowVision = {
  prefix: 'fas',
  iconName: 'low-vision',
  icon: [576, 512, [], "f2a8", "M569.344 231.631C512.96 135.949 407.81 72 288 72c-28.468 0-56.102 3.619-82.451 10.409L152.778 10.24c-7.601-10.858-22.564-13.5-33.423-5.9l-13.114 9.178c-10.86 7.601-13.502 22.566-5.9 33.426l43.131 58.395C89.449 131.73 40.228 174.683 6.682 231.581c-.01.017-.023.033-.034.05-8.765 14.875-8.964 33.528 0 48.739 38.5 65.332 99.742 115.862 172.859 141.349L55.316 244.302A272.194 272.194 0 0 1 83.61 208.39l119.4 170.58h.01l40.63 58.04a330.055 330.055 0 0 0 78.94 1.17l-189.98-271.4a277.628 277.628 0 0 1 38.777-21.563l251.836 356.544c7.601 10.858 22.564 13.499 33.423 5.9l13.114-9.178c10.86-7.601 13.502-22.567 5.9-33.426l-43.12-58.377-.007-.009c57.161-27.978 104.835-72.04 136.81-126.301a47.938 47.938 0 0 0 .001-48.739zM390.026 345.94l-19.066-27.23c24.682-32.567 27.711-76.353 8.8-111.68v.03c0 23.65-19.17 42.82-42.82 42.82-23.828 0-42.82-19.349-42.82-42.82 0-23.65 19.17-42.82 42.82-42.82h.03c-24.75-13.249-53.522-15.643-79.51-7.68l-19.068-27.237C253.758 123.306 270.488 120 288 120c75.162 0 136 60.826 136 136 0 34.504-12.833 65.975-33.974 89.94z"]
};
var faLuggageCart = {
  prefix: 'fas',
  iconName: 'luggage-cart',
  icon: [640, 512, [], "f59d", "M224 320h32V96h-32c-17.67 0-32 14.33-32 32v160c0 17.67 14.33 32 32 32zm352-32V128c0-17.67-14.33-32-32-32h-32v224h32c17.67 0 32-14.33 32-32zm48 96H128V16c0-8.84-7.16-16-16-16H16C7.16 0 0 7.16 0 16v32c0 8.84 7.16 16 16 16h48v368c0 8.84 7.16 16 16 16h82.94c-1.79 5.03-2.94 10.36-2.94 16 0 26.51 21.49 48 48 48s48-21.49 48-48c0-5.64-1.15-10.97-2.94-16h197.88c-1.79 5.03-2.94 10.36-2.94 16 0 26.51 21.49 48 48 48s48-21.49 48-48c0-5.64-1.15-10.97-2.94-16H624c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM480 96V48c0-26.51-21.49-48-48-48h-96c-26.51 0-48 21.49-48 48v272h192V96zm-48 0h-96V48h96v48z"]
};
var faLungs = {
  prefix: 'fas',
  iconName: 'lungs',
  icon: [640, 512, [], "f604", "M636.11 390.15C614.44 308.85 580.07 231 534.1 159.13 511.98 124.56 498.03 96 454.05 96 415.36 96 384 125.42 384 161.71v60.11l-32.88-21.92a15.996 15.996 0 0 1-7.12-13.31V16c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v170.59c0 5.35-2.67 10.34-7.12 13.31L256 221.82v-60.11C256 125.42 224.64 96 185.95 96c-43.98 0-57.93 28.56-80.05 63.13C59.93 231 25.56 308.85 3.89 390.15 1.3 399.84 0 409.79 0 419.78c0 61.23 62.48 105.44 125.24 88.62l59.5-15.95c42.18-11.3 71.26-47.47 71.26-88.62v-87.49l-85.84 57.23a7.992 7.992 0 0 1-11.09-2.22l-8.88-13.31a7.992 7.992 0 0 1 2.22-11.09L320 235.23l167.59 111.72a7.994 7.994 0 0 1 2.22 11.09l-8.88 13.31a7.994 7.994 0 0 1-11.09 2.22L384 316.34v87.49c0 41.15 29.08 77.31 71.26 88.62l59.5 15.95C577.52 525.22 640 481.01 640 419.78c0-9.99-1.3-19.94-3.89-29.63z"]
};
var faLungsVirus = {
  prefix: 'fas',
  iconName: 'lungs-virus',
  icon: [640, 512, [], "e067", "M344,150.68V16A16,16,0,0,0,328,0H312a16,16,0,0,0-16,16V150.68a46.45,46.45,0,0,1,48,0ZM195.54,444.46a48.06,48.06,0,0,1,0-67.88l8.58-8.58H192a48,48,0,0,1,0-96h12.12l-8.58-8.57a48,48,0,0,1,60.46-74V161.75C256,125.38,224.62,96,186,96c-44,0-58,28.5-80.12,63.13a819.52,819.52,0,0,0-102,231A113.16,113.16,0,0,0,0,419.75C0,481,62.5,525.26,125.25,508.38l59.5-15.87a98.51,98.51,0,0,0,52.5-34.75,46.49,46.49,0,0,1-41.71-13.3Zm226.29-22.63a16,16,0,0,0,0-22.62l-8.58-8.58C393.09,370.47,407.37,336,435.88,336H448a16,16,0,0,0,0-32H435.88c-28.51,0-42.79-34.47-22.63-54.62l8.58-8.58a16,16,0,0,0-22.63-22.63l-8.57,8.58C370.47,246.91,336,232.63,336,204.12V192a16,16,0,0,0-32,0v12.12c0,28.51-34.47,42.79-54.63,22.63l-8.57-8.58a16,16,0,0,0-22.63,22.63l8.58,8.58c20.16,20.15,5.88,54.62-22.63,54.62H192a16,16,0,0,0,0,32h12.12c28.51,0,42.79,34.47,22.63,54.63l-8.58,8.58a16,16,0,1,0,22.63,22.62l8.57-8.57C269.53,393.1,304,407.38,304,435.88V448a16,16,0,0,0,32,0V435.88c0-28.5,34.47-42.78,54.63-22.62l8.57,8.57a16,16,0,0,0,22.63,0ZM288,304a16,16,0,1,1,16-16A16,16,0,0,1,288,304Zm64,64a16,16,0,1,1,16-16A16,16,0,0,1,352,368Zm284.12,22.13a819.52,819.52,0,0,0-102-231C512,124.5,498,96,454,96c-38.62,0-70,29.38-70,65.75v27.72a48,48,0,0,1,60.46,74L435.88,272H448a48,48,0,0,1,0,96H435.88l8.58,8.58a47.7,47.7,0,0,1-41.71,81.18,98.51,98.51,0,0,0,52.5,34.75l59.5,15.87C577.5,525.26,640,481,640,419.75A113.16,113.16,0,0,0,636.12,390.13Z"]
};
var faMagic = {
  prefix: 'fas',
  iconName: 'magic',
  icon: [512, 512, [], "f0d0", "M224 96l16-32 32-16-32-16-16-32-16 32-32 16 32 16 16 32zM80 160l26.66-53.33L160 80l-53.34-26.67L80 0 53.34 53.33 0 80l53.34 26.67L80 160zm352 128l-26.66 53.33L352 368l53.34 26.67L432 448l26.66-53.33L512 368l-53.34-26.67L432 288zm70.62-193.77L417.77 9.38C411.53 3.12 403.34 0 395.15 0c-8.19 0-16.38 3.12-22.63 9.38L9.38 372.52c-12.5 12.5-12.5 32.76 0 45.25l84.85 84.85c6.25 6.25 14.44 9.37 22.62 9.37 8.19 0 16.38-3.12 22.63-9.37l363.14-363.15c12.5-12.48 12.5-32.75 0-45.24zM359.45 203.46l-50.91-50.91 86.6-86.6 50.91 50.91-86.6 86.6z"]
};
var faMagnet = {
  prefix: 'fas',
  iconName: 'magnet',
  icon: [512, 512, [], "f076", "M164.07 148.1H12a12 12 0 0 1-12-12v-80a36 36 0 0 1 36-36h104a36 36 0 0 1 36 36v80a11.89 11.89 0 0 1-11.93 12zm347.93-12V56a36 36 0 0 0-36-36H372a36 36 0 0 0-36 36v80a12 12 0 0 0 12 12h152a11.89 11.89 0 0 0 12-11.9zm-164 44a12 12 0 0 0-12 12v52c0 128.1-160 127.9-160 0v-52a12 12 0 0 0-12-12H12.1a12 12 0 0 0-12 12.1c.1 21.4.6 40.3 0 53.3 0 150.6 136.17 246.6 256.75 246.6s255-96 255-246.7c-.6-12.8-.2-33 0-53.2a12 12 0 0 0-12-12.1z"]
};
var faMailBulk = {
  prefix: 'fas',
  iconName: 'mail-bulk',
  icon: [576, 512, [], "f674", "M160 448c-25.6 0-51.2-22.4-64-32-64-44.8-83.2-60.8-96-70.4V480c0 17.67 14.33 32 32 32h256c17.67 0 32-14.33 32-32V345.6c-12.8 9.6-32 25.6-96 70.4-12.8 9.6-38.4 32-64 32zm128-192H32c-17.67 0-32 14.33-32 32v16c25.6 19.2 22.4 19.2 115.2 86.4 9.6 6.4 28.8 25.6 44.8 25.6s35.2-19.2 44.8-22.4c92.8-67.2 89.6-67.2 115.2-86.4V288c0-17.67-14.33-32-32-32zm256-96H224c-17.67 0-32 14.33-32 32v32h96c33.21 0 60.59 25.42 63.71 57.82l.29-.22V416h192c17.67 0 32-14.33 32-32V192c0-17.67-14.33-32-32-32zm-32 128h-64v-64h64v64zm-352-96c0-35.29 28.71-64 64-64h224V32c0-17.67-14.33-32-32-32H96C78.33 0 64 14.33 64 32v192h96v-32z"]
};
var faMale = {
  prefix: 'fas',
  iconName: 'male',
  icon: [192, 512, [], "f183", "M96 0c35.346 0 64 28.654 64 64s-28.654 64-64 64-64-28.654-64-64S60.654 0 96 0m48 144h-11.36c-22.711 10.443-49.59 10.894-73.28 0H48c-26.51 0-48 21.49-48 48v136c0 13.255 10.745 24 24 24h16v136c0 13.255 10.745 24 24 24h64c13.255 0 24-10.745 24-24V352h16c13.255 0 24-10.745 24-24V192c0-26.51-21.49-48-48-48z"]
};
var faMap = {
  prefix: 'fas',
  iconName: 'map',
  icon: [576, 512, [], "f279", "M0 117.66v346.32c0 11.32 11.43 19.06 21.94 14.86L160 416V32L20.12 87.95A32.006 32.006 0 0 0 0 117.66zM192 416l192 64V96L192 32v384zM554.06 33.16L416 96v384l139.88-55.95A31.996 31.996 0 0 0 576 394.34V48.02c0-11.32-11.43-19.06-21.94-14.86z"]
};
var faMapMarked = {
  prefix: 'fas',
  iconName: 'map-marked',
  icon: [576, 512, [], "f59f", "M288 0c-69.59 0-126 56.41-126 126 0 56.26 82.35 158.8 113.9 196.02 6.39 7.54 17.82 7.54 24.2 0C331.65 284.8 414 182.26 414 126 414 56.41 357.59 0 288 0zM20.12 215.95A32.006 32.006 0 0 0 0 245.66v250.32c0 11.32 11.43 19.06 21.94 14.86L160 448V214.92c-8.84-15.98-16.07-31.54-21.25-46.42L20.12 215.95zM288 359.67c-14.07 0-27.38-6.18-36.51-16.96-19.66-23.2-40.57-49.62-59.49-76.72v182l192 64V266c-18.92 27.09-39.82 53.52-59.49 76.72-9.13 10.77-22.44 16.95-36.51 16.95zm266.06-198.51L416 224v288l139.88-55.95A31.996 31.996 0 0 0 576 426.34V176.02c0-11.32-11.43-19.06-21.94-14.86z"]
};
var faMapMarkedAlt = {
  prefix: 'fas',
  iconName: 'map-marked-alt',
  icon: [576, 512, [], "f5a0", "M288 0c-69.59 0-126 56.41-126 126 0 56.26 82.35 158.8 113.9 196.02 6.39 7.54 17.82 7.54 24.2 0C331.65 284.8 414 182.26 414 126 414 56.41 357.59 0 288 0zm0 168c-23.2 0-42-18.8-42-42s18.8-42 42-42 42 18.8 42 42-18.8 42-42 42zM20.12 215.95A32.006 32.006 0 0 0 0 245.66v250.32c0 11.32 11.43 19.06 21.94 14.86L160 448V214.92c-8.84-15.98-16.07-31.54-21.25-46.42L20.12 215.95zM288 359.67c-14.07 0-27.38-6.18-36.51-16.96-19.66-23.2-40.57-49.62-59.49-76.72v182l192 64V266c-18.92 27.09-39.82 53.52-59.49 76.72-9.13 10.77-22.44 16.95-36.51 16.95zm266.06-198.51L416 224v288l139.88-55.95A31.996 31.996 0 0 0 576 426.34V176.02c0-11.32-11.43-19.06-21.94-14.86z"]
};
var faMapMarker = {
  prefix: 'fas',
  iconName: 'map-marker',
  icon: [384, 512, [], "f041", "M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0z"]
};
var faMapMarkerAlt = {
  prefix: 'fas',
  iconName: 'map-marker-alt',
  icon: [384, 512, [], "f3c5", "M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0zM192 272c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80z"]
};
var faMapPin = {
  prefix: 'fas',
  iconName: 'map-pin',
  icon: [288, 512, [], "f276", "M112 316.94v156.69l22.02 33.02c4.75 7.12 15.22 7.12 19.97 0L176 473.63V316.94c-10.39 1.92-21.06 3.06-32 3.06s-21.61-1.14-32-3.06zM144 0C64.47 0 0 64.47 0 144s64.47 144 144 144 144-64.47 144-144S223.53 0 144 0zm0 76c-37.5 0-68 30.5-68 68 0 6.62-5.38 12-12 12s-12-5.38-12-12c0-50.73 41.28-92 92-92 6.62 0 12 5.38 12 12s-5.38 12-12 12z"]
};
var faMapSigns = {
  prefix: 'fas',
  iconName: 'map-signs',
  icon: [512, 512, [], "f277", "M507.31 84.69L464 41.37c-6-6-14.14-9.37-22.63-9.37H288V16c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v16H56c-13.25 0-24 10.75-24 24v80c0 13.25 10.75 24 24 24h385.37c8.49 0 16.62-3.37 22.63-9.37l43.31-43.31c6.25-6.26 6.25-16.38 0-22.63zM224 496c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V384h-64v112zm232-272H288v-32h-64v32H70.63c-8.49 0-16.62 3.37-22.63 9.37L4.69 276.69c-6.25 6.25-6.25 16.38 0 22.63L48 342.63c6 6 14.14 9.37 22.63 9.37H456c13.25 0 24-10.75 24-24v-80c0-13.25-10.75-24-24-24z"]
};
var faMarker = {
  prefix: 'fas',
  iconName: 'marker',
  icon: [512, 512, [], "f5a1", "M93.95 290.03A327.038 327.038 0 0 0 .17 485.11l-.03.23c-1.7 15.28 11.21 28.2 26.49 26.51a327.02 327.02 0 0 0 195.34-93.8l75.4-75.4-128.02-128.02-75.4 75.4zM485.49 26.51c-35.35-35.35-92.67-35.35-128.02 0l-21.76 21.76-36.56-36.55c-15.62-15.62-40.95-15.62-56.56 0L138.47 115.84c-6.25 6.25-6.25 16.38 0 22.63l22.62 22.62c6.25 6.25 16.38 6.25 22.63 0l87.15-87.15 19.59 19.59L191.98 192 320 320.02l165.49-165.49c35.35-35.35 35.35-92.66 0-128.02z"]
};
var faMars = {
  prefix: 'fas',
  iconName: 'mars',
  icon: [384, 512, [], "f222", "M372 64h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-80.7 80.7c-22.2-14-48.5-22.1-76.7-22.1C64.5 160 0 224.5 0 304s64.5 144 144 144 144-64.5 144-144c0-28.2-8.1-54.5-22.1-76.7l80.7-80.7 16.9 16.9c7.6 7.6 20.5 2.2 20.5-8.5V76c0-6.6-5.4-12-12-12zM144 384c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"]
};
var faMarsDouble = {
  prefix: 'fas',
  iconName: 'mars-double',
  icon: [512, 512, [], "f227", "M340 0h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-48.7 48.7C198.5 72.1 172.2 64 144 64 64.5 64 0 128.5 0 208s64.5 144 144 144 144-64.5 144-144c0-28.2-8.1-54.5-22.1-76.7l48.7-48.7 16.9 16.9c2.4 2.4 5.5 3.5 8.4 3.5 6.2 0 12.1-4.8 12.1-12V12c0-6.6-5.4-12-12-12zM144 288c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80zm356-128.1h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-48.7 48.7c-18.2-11.4-39-18.9-61.5-21.3-2.1 21.8-8.2 43.3-18.4 63.3 1.1 0 2.2-.1 3.2-.1 44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80c0-1.1 0-2.2.1-3.2-20 10.2-41.5 16.4-63.3 18.4C168.4 455.6 229.6 512 304 512c79.5 0 144-64.5 144-144 0-28.2-8.1-54.5-22.1-76.7l48.7-48.7 16.9 16.9c2.4 2.4 5.4 3.5 8.4 3.5 6.2 0 12.1-4.8 12.1-12v-79c0-6.7-5.4-12.1-12-12.1z"]
};
var faMarsStroke = {
  prefix: 'fas',
  iconName: 'mars-stroke',
  icon: [384, 512, [], "f229", "M372 64h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-17.5 17.5-14.1-14.1c-4.7-4.7-12.3-4.7-17 0L224.5 133c-4.7 4.7-4.7 12.3 0 17l14.1 14.1-18 18c-22.2-14-48.5-22.1-76.7-22.1C64.5 160 0 224.5 0 304s64.5 144 144 144 144-64.5 144-144c0-28.2-8.1-54.5-22.1-76.7l18-18 14.1 14.1c4.7 4.7 12.3 4.7 17 0l28.3-28.3c4.7-4.7 4.7-12.3 0-17L329.2 164l17.5-17.5 16.9 16.9c7.6 7.6 20.5 2.2 20.5-8.5V76c-.1-6.6-5.5-12-12.1-12zM144 384c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"]
};
var faMarsStrokeH = {
  prefix: 'fas',
  iconName: 'mars-stroke-h',
  icon: [480, 512, [], "f22b", "M476.2 247.5l-55.9-55.9c-7.6-7.6-20.5-2.2-20.5 8.5V224H376v-20c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v20h-27.6c-5.8-25.6-18.7-49.9-38.6-69.8C189.6 98 98.4 98 42.2 154.2c-56.2 56.2-56.2 147.4 0 203.6 56.2 56.2 147.4 56.2 203.6 0 19.9-19.9 32.8-44.2 38.6-69.8H312v20c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-20h23.9v23.9c0 10.7 12.9 16 20.5 8.5l55.9-55.9c4.6-4.7 4.6-12.3-.1-17zm-275.6 65.1c-31.2 31.2-81.9 31.2-113.1 0-31.2-31.2-31.2-81.9 0-113.1 31.2-31.2 81.9-31.2 113.1 0 31.2 31.1 31.2 81.9 0 113.1z"]
};
var faMarsStrokeV = {
  prefix: 'fas',
  iconName: 'mars-stroke-v',
  icon: [288, 512, [], "f22a", "M245.8 234.2c-19.9-19.9-44.2-32.8-69.8-38.6v-25.4h20c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20V81.4h23.9c10.7 0 16-12.9 8.5-20.5L152.5 5.1c-4.7-4.7-12.3-4.7-17 0L79.6 61c-7.6 7.6-2.2 20.5 8.5 20.5H112v24.7H92c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h20v25.4c-25.6 5.8-49.9 18.7-69.8 38.6-56.2 56.2-56.2 147.4 0 203.6 56.2 56.2 147.4 56.2 203.6 0 56.3-56.2 56.3-147.4 0-203.6zm-45.2 158.4c-31.2 31.2-81.9 31.2-113.1 0-31.2-31.2-31.2-81.9 0-113.1 31.2-31.2 81.9-31.2 113.1 0 31.2 31.1 31.2 81.9 0 113.1z"]
};
var faMask = {
  prefix: 'fas',
  iconName: 'mask',
  icon: [640, 512, [], "f6fa", "M320.67 64c-442.6 0-357.57 384-158.46 384 39.9 0 77.47-20.69 101.42-55.86l25.73-37.79c15.66-22.99 46.97-22.99 62.63 0l25.73 37.79C401.66 427.31 439.23 448 479.13 448c189.86 0 290.63-384-158.46-384zM184 308.36c-41.06 0-67.76-25.66-80.08-41.05-5.23-6.53-5.23-16.09 0-22.63 12.32-15.4 39.01-41.05 80.08-41.05s67.76 25.66 80.08 41.05c5.23 6.53 5.23 16.09 0 22.63-12.32 15.4-39.02 41.05-80.08 41.05zm272 0c-41.06 0-67.76-25.66-80.08-41.05-5.23-6.53-5.23-16.09 0-22.63 12.32-15.4 39.01-41.05 80.08-41.05s67.76 25.66 80.08 41.05c5.23 6.53 5.23 16.09 0 22.63-12.32 15.4-39.02 41.05-80.08 41.05z"]
};
var faMedal = {
  prefix: 'fas',
  iconName: 'medal',
  icon: [512, 512, [], "f5a2", "M223.75 130.75L154.62 15.54A31.997 31.997 0 0 0 127.18 0H16.03C3.08 0-4.5 14.57 2.92 25.18l111.27 158.96c29.72-27.77 67.52-46.83 109.56-53.39zM495.97 0H384.82c-11.24 0-21.66 5.9-27.44 15.54l-69.13 115.21c42.04 6.56 79.84 25.62 109.56 53.38L509.08 25.18C516.5 14.57 508.92 0 495.97 0zM256 160c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm92.52 157.26l-37.93 36.96 8.97 52.22c1.6 9.36-8.26 16.51-16.65 12.09L256 393.88l-46.9 24.65c-8.4 4.45-18.25-2.74-16.65-12.09l8.97-52.22-37.93-36.96c-6.82-6.64-3.05-18.23 6.35-19.59l52.43-7.64 23.43-47.52c2.11-4.28 6.19-6.39 10.28-6.39 4.11 0 8.22 2.14 10.33 6.39l23.43 47.52 52.43 7.64c9.4 1.36 13.17 12.95 6.35 19.59z"]
};
var faMedkit = {
  prefix: 'fas',
  iconName: 'medkit',
  icon: [512, 512, [], "f0fa", "M96 480h320V128h-32V80c0-26.51-21.49-48-48-48H176c-26.51 0-48 21.49-48 48v48H96v352zm96-384h128v32H192V96zm320 80v256c0 26.51-21.49 48-48 48h-16V128h16c26.51 0 48 21.49 48 48zM64 480H48c-26.51 0-48-21.49-48-48V176c0-26.51 21.49-48 48-48h16v352zm288-208v32c0 8.837-7.163 16-16 16h-48v48c0 8.837-7.163 16-16 16h-32c-8.837 0-16-7.163-16-16v-48h-48c-8.837 0-16-7.163-16-16v-32c0-8.837 7.163-16 16-16h48v-48c0-8.837 7.163-16 16-16h32c8.837 0 16 7.163 16 16v48h48c8.837 0 16 7.163 16 16z"]
};
var faMeh = {
  prefix: 'fas',
  iconName: 'meh',
  icon: [496, 512, [], "f11a", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm176 192H152c-21.2 0-21.2-32 0-32h192c21.2 0 21.2 32 0 32zm-16-128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"]
};
var faMehBlank = {
  prefix: 'fas',
  iconName: 'meh-blank',
  icon: [496, 512, [], "f5a4", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-80 232c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm160 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"]
};
var faMehRollingEyes = {
  prefix: 'fas',
  iconName: 'meh-rolling-eyes',
  icon: [496, 512, [], "f5a5", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM88 224c0-24.3 13.7-45.2 33.6-56-.7 2.6-1.6 5.2-1.6 8 0 17.7 14.3 32 32 32s32-14.3 32-32c0-2.8-.9-5.4-1.6-8 19.9 10.8 33.6 31.7 33.6 56 0 35.3-28.7 64-64 64s-64-28.7-64-64zm224 176H184c-21.2 0-21.2-32 0-32h128c21.2 0 21.2 32 0 32zm32-112c-35.3 0-64-28.7-64-64 0-24.3 13.7-45.2 33.6-56-.7 2.6-1.6 5.2-1.6 8 0 17.7 14.3 32 32 32s32-14.3 32-32c0-2.8-.9-5.4-1.6-8 19.9 10.8 33.6 31.7 33.6 56 0 35.3-28.7 64-64 64z"]
};
var faMemory = {
  prefix: 'fas',
  iconName: 'memory',
  icon: [640, 512, [], "f538", "M640 130.94V96c0-17.67-14.33-32-32-32H32C14.33 64 0 78.33 0 96v34.94c18.6 6.61 32 24.19 32 45.06s-13.4 38.45-32 45.06V320h640v-98.94c-18.6-6.61-32-24.19-32-45.06s13.4-38.45 32-45.06zM224 256h-64V128h64v128zm128 0h-64V128h64v128zm128 0h-64V128h64v128zM0 448h64v-26.67c0-8.84 7.16-16 16-16s16 7.16 16 16V448h128v-26.67c0-8.84 7.16-16 16-16s16 7.16 16 16V448h128v-26.67c0-8.84 7.16-16 16-16s16 7.16 16 16V448h128v-26.67c0-8.84 7.16-16 16-16s16 7.16 16 16V448h64v-96H0v96z"]
};
var faMenorah = {
  prefix: 'fas',
  iconName: 'menorah',
  icon: [640, 512, [], "f676", "M144 128h-32c-8.84 0-16 7.16-16 16v144h64V144c0-8.84-7.16-16-16-16zm96 0h-32c-8.84 0-16 7.16-16 16v144h64V144c0-8.84-7.16-16-16-16zm192 0h-32c-8.84 0-16 7.16-16 16v144h64V144c0-8.84-7.16-16-16-16zm96 0h-32c-8.84 0-16 7.16-16 16v144h64V144c0-8.84-7.16-16-16-16zm80-32c17.67 0 32-14.33 32-32S608 0 608 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S512 0 512 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S416 0 416 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S320 0 320 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S224 0 224 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S128 0 128 0 96 46.33 96 64s14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S32 0 32 0 0 46.33 0 64s14.33 32 32 32zm544 192c0 17.67-14.33 32-32 32H352V144c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v176H96c-17.67 0-32-14.33-32-32V144c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v144c0 53.02 42.98 96 96 96h192v64H112c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16H352v-64h192c53.02 0 96-42.98 96-96V144c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v144z"]
};
var faMercury = {
  prefix: 'fas',
  iconName: 'mercury',
  icon: [288, 512, [], "f223", "M288 208c0-44.2-19.9-83.7-51.2-110.1 2.5-1.8 4.9-3.8 7.2-5.8 24.7-21.2 39.8-48.8 43.2-78.8.9-7.1-4.7-13.3-11.9-13.3h-40.5C229 0 224.1 4.1 223 9.8c-2.4 12.5-9.6 24.3-20.7 33.8C187 56.8 166.3 64 144 64s-43-7.2-58.4-20.4C74.5 34.1 67.4 22.3 64.9 9.8 63.8 4.1 58.9 0 53.2 0H12.7C5.5 0-.1 6.2.8 13.3 4.2 43.4 19.2 71 44 92.2c2.3 2 4.7 3.9 7.2 5.8C19.9 124.3 0 163.8 0 208c0 68.5 47.9 125.9 112 140.4V400H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v36c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-36h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-51.6c64.1-14.5 112-71.9 112-140.4zm-224 0c0-44.1 35.9-80 80-80s80 35.9 80 80-35.9 80-80 80-80-35.9-80-80z"]
};
var faMeteor = {
  prefix: 'fas',
  iconName: 'meteor',
  icon: [512, 512, [], "f753", "M511.328,20.8027c-11.60759,38.70264-34.30724,111.70173-61.30311,187.70077,6.99893,2.09372,13.4042,4,18.60653,5.59368a16.06158,16.06158,0,0,1,9.49854,22.906c-22.106,42.29635-82.69047,152.795-142.47819,214.40356-.99984,1.09373-1.99969,2.5-2.99954,3.49995A194.83046,194.83046,0,1,1,57.085,179.41009c.99985-1,2.40588-2,3.49947-3,61.59994-59.90549,171.97367-120.40473,214.37343-142.4982a16.058,16.058,0,0,1,22.90274,9.49988c1.59351,5.09368,3.49947,11.5936,5.5929,18.59351C379.34818,35.00565,452.43074,12.30281,491.12794.70921A16.18325,16.18325,0,0,1,511.328,20.8027ZM319.951,320.00207A127.98041,127.98041,0,1,0,191.97061,448.00046,127.97573,127.97573,0,0,0,319.951,320.00207Zm-127.98041-31.9996a31.9951,31.9951,0,1,1-31.9951-31.9996A31.959,31.959,0,0,1,191.97061,288.00247Zm31.9951,79.999a15.99755,15.99755,0,1,1-15.99755-15.9998A16.04975,16.04975,0,0,1,223.96571,368.00147Z"]
};
var faMicrochip = {
  prefix: 'fas',
  iconName: 'microchip',
  icon: [512, 512, [], "f2db", "M416 48v416c0 26.51-21.49 48-48 48H144c-26.51 0-48-21.49-48-48V48c0-26.51 21.49-48 48-48h224c26.51 0 48 21.49 48 48zm96 58v12a6 6 0 0 1-6 6h-18v6a6 6 0 0 1-6 6h-42V88h42a6 6 0 0 1 6 6v6h18a6 6 0 0 1 6 6zm0 96v12a6 6 0 0 1-6 6h-18v6a6 6 0 0 1-6 6h-42v-48h42a6 6 0 0 1 6 6v6h18a6 6 0 0 1 6 6zm0 96v12a6 6 0 0 1-6 6h-18v6a6 6 0 0 1-6 6h-42v-48h42a6 6 0 0 1 6 6v6h18a6 6 0 0 1 6 6zm0 96v12a6 6 0 0 1-6 6h-18v6a6 6 0 0 1-6 6h-42v-48h42a6 6 0 0 1 6 6v6h18a6 6 0 0 1 6 6zM30 376h42v48H30a6 6 0 0 1-6-6v-6H6a6 6 0 0 1-6-6v-12a6 6 0 0 1 6-6h18v-6a6 6 0 0 1 6-6zm0-96h42v48H30a6 6 0 0 1-6-6v-6H6a6 6 0 0 1-6-6v-12a6 6 0 0 1 6-6h18v-6a6 6 0 0 1 6-6zm0-96h42v48H30a6 6 0 0 1-6-6v-6H6a6 6 0 0 1-6-6v-12a6 6 0 0 1 6-6h18v-6a6 6 0 0 1 6-6zm0-96h42v48H30a6 6 0 0 1-6-6v-6H6a6 6 0 0 1-6-6v-12a6 6 0 0 1 6-6h18v-6a6 6 0 0 1 6-6z"]
};
var faMicrophone = {
  prefix: 'fas',
  iconName: 'microphone',
  icon: [352, 512, [], "f130", "M176 352c53.02 0 96-42.98 96-96V96c0-53.02-42.98-96-96-96S80 42.98 80 96v160c0 53.02 42.98 96 96 96zm160-160h-16c-8.84 0-16 7.16-16 16v48c0 74.8-64.49 134.82-140.79 127.38C96.71 376.89 48 317.11 48 250.3V208c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v40.16c0 89.64 63.97 169.55 152 181.69V464H96c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16h-56v-33.77C285.71 418.47 352 344.9 352 256v-48c0-8.84-7.16-16-16-16z"]
};
var faMicrophoneAlt = {
  prefix: 'fas',
  iconName: 'microphone-alt',
  icon: [352, 512, [], "f3c9", "M336 192h-16c-8.84 0-16 7.16-16 16v48c0 74.8-64.49 134.82-140.79 127.38C96.71 376.89 48 317.11 48 250.3V208c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v40.16c0 89.64 63.97 169.55 152 181.69V464H96c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16h-56v-33.77C285.71 418.47 352 344.9 352 256v-48c0-8.84-7.16-16-16-16zM176 352c53.02 0 96-42.98 96-96h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H272v-32h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H272v-32h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H272c0-53.02-42.98-96-96-96S80 42.98 80 96v160c0 53.02 42.98 96 96 96z"]
};
var faMicrophoneAltSlash = {
  prefix: 'fas',
  iconName: 'microphone-alt-slash',
  icon: [640, 512, [], "f539", "M633.82 458.1L476.26 336.33C488.74 312.21 496 284.98 496 256v-48c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v48c0 17.92-3.96 34.8-10.72 50.2l-26.55-20.52c3.1-9.4 5.28-19.22 5.28-29.67h-43.67l-41.4-32H416v-32h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H416v-32h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H416c0-53.02-42.98-96-96-96s-96 42.98-96 96v45.36L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.36 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.41-6.97 4.16-17.02-2.82-22.45zM400 464h-56v-33.78c11.71-1.62 23.1-4.28 33.96-8.08l-50.4-38.96c-6.71.4-13.41.87-20.35.2-55.85-5.45-98.74-48.63-111.18-101.85L144 241.31v6.85c0 89.64 63.97 169.55 152 181.69V464h-56c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16z"]
};
var faMicrophoneSlash = {
  prefix: 'fas',
  iconName: 'microphone-slash',
  icon: [640, 512, [], "f131", "M633.82 458.1l-157.8-121.96C488.61 312.13 496 285.01 496 256v-48c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v48c0 17.92-3.96 34.8-10.72 50.2l-26.55-20.52c3.1-9.4 5.28-19.22 5.28-29.67V96c0-53.02-42.98-96-96-96s-96 42.98-96 96v45.36L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.36 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.41-6.97 4.16-17.02-2.82-22.45zM400 464h-56v-33.77c11.66-1.6 22.85-4.54 33.67-8.31l-50.11-38.73c-6.71.4-13.41.87-20.35.2-55.85-5.45-98.74-48.63-111.18-101.85L144 241.31v6.85c0 89.64 63.97 169.55 152 181.69V464h-56c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16z"]
};
var faMicroscope = {
  prefix: 'fas',
  iconName: 'microscope',
  icon: [512, 512, [], "f610", "M160 320h12v16c0 8.84 7.16 16 16 16h40c8.84 0 16-7.16 16-16v-16h12c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32V16c0-8.84-7.16-16-16-16h-64c-8.84 0-16 7.16-16 16v16c-17.67 0-32 14.33-32 32v224c0 17.67 14.33 32 32 32zm304 128h-1.29C493.24 413.99 512 369.2 512 320c0-105.88-86.12-192-192-192v64c70.58 0 128 57.42 128 128s-57.42 128-128 128H48c-26.51 0-48 21.49-48 48 0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16 0-26.51-21.49-48-48-48zm-360-32h208c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8H104c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8z"]
};
var faMinus = {
  prefix: 'fas',
  iconName: 'minus',
  icon: [448, 512, [], "f068", "M416 208H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"]
};
var faMinusCircle = {
  prefix: 'fas',
  iconName: 'minus-circle',
  icon: [512, 512, [], "f056", "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zM124 296c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h264c6.6 0 12 5.4 12 12v56c0 6.6-5.4 12-12 12H124z"]
};
var faMinusSquare = {
  prefix: 'fas',
  iconName: 'minus-square',
  icon: [448, 512, [], "f146", "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM92 296c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h264c6.6 0 12 5.4 12 12v56c0 6.6-5.4 12-12 12H92z"]
};
var faMitten = {
  prefix: 'fas',
  iconName: 'mitten',
  icon: [448, 512, [], "f7b5", "M368 416H48c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16zm57-209.1c-27.2-22.6-67.5-19-90.1 8.2l-20.9 25-29.6-128.4c-18-77.5-95.4-125.9-172.8-108C34.2 21.6-14.2 98.9 3.7 176.4L51.6 384h309l72.5-87c22.7-27.2 19-67.5-8.1-90.1z"]
};
var faMobile = {
  prefix: 'fas',
  iconName: 'mobile',
  icon: [320, 512, [], "f10b", "M272 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM160 480c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"]
};
var faMobileAlt = {
  prefix: 'fas',
  iconName: 'mobile-alt',
  icon: [320, 512, [], "f3cd", "M272 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM160 480c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm112-108c0 6.6-5.4 12-12 12H60c-6.6 0-12-5.4-12-12V60c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v312z"]
};
var faMoneyBill = {
  prefix: 'fas',
  iconName: 'money-bill',
  icon: [640, 512, [], "f0d6", "M608 64H32C14.33 64 0 78.33 0 96v320c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V96c0-17.67-14.33-32-32-32zM48 400v-64c35.35 0 64 28.65 64 64H48zm0-224v-64h64c0 35.35-28.65 64-64 64zm272 176c-44.19 0-80-42.99-80-96 0-53.02 35.82-96 80-96s80 42.98 80 96c0 53.03-35.83 96-80 96zm272 48h-64c0-35.35 28.65-64 64-64v64zm0-224c-35.35 0-64-28.65-64-64h64v64z"]
};
var faMoneyBillAlt = {
  prefix: 'fas',
  iconName: 'money-bill-alt',
  icon: [640, 512, [], "f3d1", "M352 288h-16v-88c0-4.42-3.58-8-8-8h-13.58c-4.74 0-9.37 1.4-13.31 4.03l-15.33 10.22a7.994 7.994 0 0 0-2.22 11.09l8.88 13.31a7.994 7.994 0 0 0 11.09 2.22l.47-.31V288h-16c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h64c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8zM608 64H32C14.33 64 0 78.33 0 96v320c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V96c0-17.67-14.33-32-32-32zM48 400v-64c35.35 0 64 28.65 64 64H48zm0-224v-64h64c0 35.35-28.65 64-64 64zm272 192c-53.02 0-96-50.15-96-112 0-61.86 42.98-112 96-112s96 50.14 96 112c0 61.87-43 112-96 112zm272 32h-64c0-35.35 28.65-64 64-64v64zm0-224c-35.35 0-64-28.65-64-64h64v64z"]
};
var faMoneyBillWave = {
  prefix: 'fas',
  iconName: 'money-bill-wave',
  icon: [640, 512, [], "f53a", "M621.16 54.46C582.37 38.19 543.55 32 504.75 32c-123.17-.01-246.33 62.34-369.5 62.34-30.89 0-61.76-3.92-92.65-13.72-3.47-1.1-6.95-1.62-10.35-1.62C15.04 79 0 92.32 0 110.81v317.26c0 12.63 7.23 24.6 18.84 29.46C57.63 473.81 96.45 480 135.25 480c123.17 0 246.34-62.35 369.51-62.35 30.89 0 61.76 3.92 92.65 13.72 3.47 1.1 6.95 1.62 10.35 1.62 17.21 0 32.25-13.32 32.25-31.81V83.93c-.01-12.64-7.24-24.6-18.85-29.47zM48 132.22c20.12 5.04 41.12 7.57 62.72 8.93C104.84 170.54 79 192.69 48 192.69v-60.47zm0 285v-47.78c34.37 0 62.18 27.27 63.71 61.4-22.53-1.81-43.59-6.31-63.71-13.62zM320 352c-44.19 0-80-42.99-80-96 0-53.02 35.82-96 80-96s80 42.98 80 96c0 53.03-35.83 96-80 96zm272 27.78c-17.52-4.39-35.71-6.85-54.32-8.44 5.87-26.08 27.5-45.88 54.32-49.28v57.72zm0-236.11c-30.89-3.91-54.86-29.7-55.81-61.55 19.54 2.17 38.09 6.23 55.81 12.66v48.89z"]
};
var faMoneyBillWaveAlt = {
  prefix: 'fas',
  iconName: 'money-bill-wave-alt',
  icon: [640, 512, [], "f53b", "M621.16 54.46C582.37 38.19 543.55 32 504.75 32c-123.17-.01-246.33 62.34-369.5 62.34-30.89 0-61.76-3.92-92.65-13.72-3.47-1.1-6.95-1.62-10.35-1.62C15.04 79 0 92.32 0 110.81v317.26c0 12.63 7.23 24.6 18.84 29.46C57.63 473.81 96.45 480 135.25 480c123.17 0 246.34-62.35 369.51-62.35 30.89 0 61.76 3.92 92.65 13.72 3.47 1.1 6.95 1.62 10.35 1.62 17.21 0 32.25-13.32 32.25-31.81V83.93c-.01-12.64-7.24-24.6-18.85-29.47zM320 352c-44.19 0-80-42.99-80-96 0-53.02 35.82-96 80-96s80 42.98 80 96c0 53.03-35.83 96-80 96z"]
};
var faMoneyCheck = {
  prefix: 'fas',
  iconName: 'money-check',
  icon: [640, 512, [], "f53c", "M0 448c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V128H0v320zm448-208c0-8.84 7.16-16 16-16h96c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16h-96c-8.84 0-16-7.16-16-16v-32zm0 120c0-4.42 3.58-8 8-8h112c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H456c-4.42 0-8-3.58-8-8v-16zM64 264c0-4.42 3.58-8 8-8h304c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16zm0 96c0-4.42 3.58-8 8-8h176c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16zM624 32H16C7.16 32 0 39.16 0 48v48h640V48c0-8.84-7.16-16-16-16z"]
};
var faMoneyCheckAlt = {
  prefix: 'fas',
  iconName: 'money-check-alt',
  icon: [640, 512, [], "f53d", "M608 32H32C14.33 32 0 46.33 0 64v384c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zM176 327.88V344c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-16.29c-11.29-.58-22.27-4.52-31.37-11.35-3.9-2.93-4.1-8.77-.57-12.14l11.75-11.21c2.77-2.64 6.89-2.76 10.13-.73 3.87 2.42 8.26 3.72 12.82 3.72h28.11c6.5 0 11.8-5.92 11.8-13.19 0-5.95-3.61-11.19-8.77-12.73l-45-13.5c-18.59-5.58-31.58-23.42-31.58-43.39 0-24.52 19.05-44.44 42.67-45.07V152c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16.29c11.29.58 22.27 4.51 31.37 11.35 3.9 2.93 4.1 8.77.57 12.14l-11.75 11.21c-2.77 2.64-6.89 2.76-10.13.73-3.87-2.43-8.26-3.72-12.82-3.72h-28.11c-6.5 0-11.8 5.92-11.8 13.19 0 5.95 3.61 11.19 8.77 12.73l45 13.5c18.59 5.58 31.58 23.42 31.58 43.39 0 24.53-19.05 44.44-42.67 45.07zM416 312c0 4.42-3.58 8-8 8H296c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h112c4.42 0 8 3.58 8 8v16zm160 0c0 4.42-3.58 8-8 8h-80c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16zm0-96c0 4.42-3.58 8-8 8H296c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h272c4.42 0 8 3.58 8 8v16z"]
};
var faMonument = {
  prefix: 'fas',
  iconName: 'monument',
  icon: [384, 512, [], "f5a6", "M368 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h352c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-78.86-347.26a31.97 31.97 0 0 0-9.21-19.44L203.31 4.69c-6.25-6.25-16.38-6.25-22.63 0l-76.6 76.61a31.97 31.97 0 0 0-9.21 19.44L64 416h256l-30.86-315.26zM240 307.2c0 6.4-6.4 12.8-12.8 12.8h-70.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h70.4c6.4 0 12.8 6.4 12.8 12.8v38.4z"]
};
var faMoon = {
  prefix: 'fas',
  iconName: 'moon',
  icon: [512, 512, [], "f186", "M283.211 512c78.962 0 151.079-35.925 198.857-94.792 7.068-8.708-.639-21.43-11.562-19.35-124.203 23.654-238.262-71.576-238.262-196.954 0-72.222 38.662-138.635 101.498-174.394 9.686-5.512 7.25-20.197-3.756-22.23A258.156 258.156 0 0 0 283.211 0c-141.309 0-256 114.511-256 256 0 141.309 114.511 256 256 256z"]
};
var faMortarPestle = {
  prefix: 'fas',
  iconName: 'mortar-pestle',
  icon: [512, 512, [], "f5a7", "M501.54 60.91c17.22-17.22 12.51-46.25-9.27-57.14a35.696 35.696 0 0 0-37.37 3.37L251.09 160h151.37l99.08-99.09zM496 192H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h16c0 80.98 50.2 150.11 121.13 178.32-12.76 16.87-21.72 36.8-24.95 58.69-1.46 9.92 6.04 18.98 16.07 18.98h223.5c10.03 0 17.53-9.06 16.07-18.98-3.22-21.89-12.18-41.82-24.95-58.69C429.8 406.11 480 336.98 480 256h16c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"]
};
var faMosque = {
  prefix: 'fas',
  iconName: 'mosque',
  icon: [640, 512, [], "f678", "M0 480c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V160H0v320zm579.16-192c17.86-17.39 28.84-37.34 28.84-58.91 0-52.86-41.79-93.79-87.92-122.9-41.94-26.47-80.63-57.77-111.96-96.22L400 0l-8.12 9.97c-31.33 38.45-70.01 69.76-111.96 96.22C233.79 135.3 192 176.23 192 229.09c0 21.57 10.98 41.52 28.84 58.91h358.32zM608 320H192c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h32v-64c0-17.67 14.33-32 32-32s32 14.33 32 32v64h64v-72c0-48 48-72 48-72s48 24 48 72v72h64v-64c0-17.67 14.33-32 32-32s32 14.33 32 32v64h32c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32zM64 0S0 32 0 96v32h128V96c0-64-64-96-64-96z"]
};
var faMotorcycle = {
  prefix: 'fas',
  iconName: 'motorcycle',
  icon: [640, 512, [], "f21c", "M512.9 192c-14.9-.1-29.1 2.3-42.4 6.9L437.6 144H520c13.3 0 24-10.7 24-24V88c0-13.3-10.7-24-24-24h-45.3c-6.8 0-13.3 2.9-17.8 7.9l-37.5 41.7-22.8-38C392.2 68.4 384.4 64 376 64h-80c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h66.4l19.2 32H227.9c-17.7-23.1-44.9-40-99.9-40H72.5C59 104 47.7 115 48 128.5c.2 13 10.9 23.5 24 23.5h56c24.5 0 38.7 10.9 47.8 24.8l-11.3 20.5c-13-3.9-26.9-5.7-41.3-5.2C55.9 194.5 1.6 249.6 0 317c-1.6 72.1 56.3 131 128 131 59.6 0 109.7-40.8 124-96h84.2c13.7 0 24.6-11.4 24-25.1-2.1-47.1 17.5-93.7 56.2-125l12.5 20.8c-27.6 23.7-45.1 58.9-44.8 98.2.5 69.6 57.2 126.5 126.8 127.1 71.6.7 129.8-57.5 129.2-129.1-.7-69.6-57.6-126.4-127.2-126.9zM128 400c-44.1 0-80-35.9-80-80s35.9-80 80-80c4.2 0 8.4.3 12.5 1L99 316.4c-8.8 16 2.8 35.6 21 35.6h81.3c-12.4 28.2-40.6 48-73.3 48zm463.9-75.6c-2.2 40.6-35 73.4-75.5 75.5-46.1 2.5-84.4-34.3-84.4-79.9 0-21.4 8.4-40.8 22.1-55.1l49.4 82.4c4.5 7.6 14.4 10 22 5.5l13.7-8.2c7.6-4.5 10-14.4 5.5-22l-48.6-80.9c5.2-1.1 10.5-1.6 15.9-1.6 45.6-.1 82.3 38.2 79.9 84.3z"]
};
var faMountain = {
  prefix: 'fas',
  iconName: 'mountain',
  icon: [640, 512, [], "f6fc", "M634.92 462.7l-288-448C341.03 5.54 330.89 0 320 0s-21.03 5.54-26.92 14.7l-288 448a32.001 32.001 0 0 0-1.17 32.64A32.004 32.004 0 0 0 32 512h576c11.71 0 22.48-6.39 28.09-16.67a31.983 31.983 0 0 0-1.17-32.63zM320 91.18L405.39 224H320l-64 64-38.06-38.06L320 91.18z"]
};
var faMouse = {
  prefix: 'fas',
  iconName: 'mouse',
  icon: [384, 512, [], "f8cc", "M0 352a160 160 0 0 0 160 160h64a160 160 0 0 0 160-160V224H0zM176 0h-16A160 160 0 0 0 0 160v32h176zm48 0h-16v192h176v-32A160 160 0 0 0 224 0z"]
};
var faMousePointer = {
  prefix: 'fas',
  iconName: 'mouse-pointer',
  icon: [320, 512, [], "f245", "M302.189 329.126H196.105l55.831 135.993c3.889 9.428-.555 19.999-9.444 23.999l-49.165 21.427c-9.165 4-19.443-.571-23.332-9.714l-53.053-129.136-86.664 89.138C18.729 472.71 0 463.554 0 447.977V18.299C0 1.899 19.921-6.096 30.277 5.443l284.412 292.542c11.472 11.179 3.007 31.141-12.5 31.141z"]
};
var faMugHot = {
  prefix: 'fas',
  iconName: 'mug-hot',
  icon: [512, 512, [], "f7b6", "M127.1 146.5c1.3 7.7 8 13.5 16 13.5h16.5c9.8 0 17.6-8.5 16.3-18-3.8-28.2-16.4-54.2-36.6-74.7-14.4-14.7-23.6-33.3-26.4-53.5C111.8 5.9 105 0 96.8 0H80.4C70.6 0 63 8.5 64.1 18c3.9 31.9 18 61.3 40.6 84.4 12 12.2 19.7 27.5 22.4 44.1zm112 0c1.3 7.7 8 13.5 16 13.5h16.5c9.8 0 17.6-8.5 16.3-18-3.8-28.2-16.4-54.2-36.6-74.7-14.4-14.7-23.6-33.3-26.4-53.5C223.8 5.9 217 0 208.8 0h-16.4c-9.8 0-17.5 8.5-16.3 18 3.9 31.9 18 61.3 40.6 84.4 12 12.2 19.7 27.5 22.4 44.1zM400 192H32c-17.7 0-32 14.3-32 32v192c0 53 43 96 96 96h192c53 0 96-43 96-96h16c61.8 0 112-50.2 112-112s-50.2-112-112-112zm0 160h-16v-96h16c26.5 0 48 21.5 48 48s-21.5 48-48 48z"]
};
var faMusic = {
  prefix: 'fas',
  iconName: 'music',
  icon: [512, 512, [], "f001", "M470.38 1.51L150.41 96A32 32 0 0 0 128 126.51v261.41A139 139 0 0 0 96 384c-53 0-96 28.66-96 64s43 64 96 64 96-28.66 96-64V214.32l256-75v184.61a138.4 138.4 0 0 0-32-3.93c-53 0-96 28.66-96 64s43 64 96 64 96-28.65 96-64V32a32 32 0 0 0-41.62-30.49z"]
};
var faNetworkWired = {
  prefix: 'fas',
  iconName: 'network-wired',
  icon: [640, 512, [], "f6ff", "M640 264v-16c0-8.84-7.16-16-16-16H344v-40h72c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32H224c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h72v40H16c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h104v40H64c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h160c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32h-56v-40h304v40h-56c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h160c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32h-56v-40h104c8.84 0 16-7.16 16-16zM256 128V64h128v64H256zm-64 320H96v-64h96v64zm352 0h-96v-64h96v64z"]
};
var faNeuter = {
  prefix: 'fas',
  iconName: 'neuter',
  icon: [288, 512, [], "f22c", "M288 176c0-79.5-64.5-144-144-144S0 96.5 0 176c0 68.5 47.9 125.9 112 140.4V468c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12V316.4c64.1-14.5 112-71.9 112-140.4zm-144 80c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"]
};
var faNewspaper = {
  prefix: 'fas',
  iconName: 'newspaper',
  icon: [576, 512, [], "f1ea", "M552 64H88c-13.255 0-24 10.745-24 24v8H24c-13.255 0-24 10.745-24 24v272c0 30.928 25.072 56 56 56h472c26.51 0 48-21.49 48-48V88c0-13.255-10.745-24-24-24zM56 400a8 8 0 0 1-8-8V144h16v248a8 8 0 0 1-8 8zm236-16H140c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm208 0H348c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm-208-96H140c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm208 0H348c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm0-96H140c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h360c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12z"]
};
var faNotEqual = {
  prefix: 'fas',
  iconName: 'not-equal',
  icon: [448, 512, [], "f53e", "M416 208c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32h-23.88l51.87-66.81c5.37-7.02 4.04-17.06-2.97-22.43L415.61 3.3c-7.02-5.38-17.06-4.04-22.44 2.97L311.09 112H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h204.56l-74.53 96H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h55.49l-51.87 66.81c-5.37 7.01-4.04 17.05 2.97 22.43L64 508.7c7.02 5.38 17.06 4.04 22.43-2.97L168.52 400H416c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32H243.05l74.53-96H416z"]
};
var faNotesMedical = {
  prefix: 'fas',
  iconName: 'notes-medical',
  icon: [384, 512, [], "f481", "M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM192 40c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm96 304c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48zm0-192c0 4.4-3.6 8-8 8H104c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h176c4.4 0 8 3.6 8 8v16z"]
};
var faObjectGroup = {
  prefix: 'fas',
  iconName: 'object-group',
  icon: [512, 512, [], "f247", "M480 128V96h20c6.627 0 12-5.373 12-12V44c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v20H64V44c0-6.627-5.373-12-12-12H12C5.373 32 0 37.373 0 44v40c0 6.627 5.373 12 12 12h20v320H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-20h384v20c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-20V128zM96 276V140c0-6.627 5.373-12 12-12h168c6.627 0 12 5.373 12 12v136c0 6.627-5.373 12-12 12H108c-6.627 0-12-5.373-12-12zm320 96c0 6.627-5.373 12-12 12H236c-6.627 0-12-5.373-12-12v-52h72c13.255 0 24-10.745 24-24v-72h84c6.627 0 12 5.373 12 12v136z"]
};
var faObjectUngroup = {
  prefix: 'fas',
  iconName: 'object-ungroup',
  icon: [576, 512, [], "f248", "M64 320v26a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6v-52a6 6 0 0 1 6-6h26V96H6a6 6 0 0 1-6-6V38a6 6 0 0 1 6-6h52a6 6 0 0 1 6 6v26h288V38a6 6 0 0 1 6-6h52a6 6 0 0 1 6 6v52a6 6 0 0 1-6 6h-26v192h26a6 6 0 0 1 6 6v52a6 6 0 0 1-6 6h-52a6 6 0 0 1-6-6v-26H64zm480-64v-32h26a6 6 0 0 0 6-6v-52a6 6 0 0 0-6-6h-52a6 6 0 0 0-6 6v26H408v72h8c13.255 0 24 10.745 24 24v64c0 13.255-10.745 24-24 24h-64c-13.255 0-24-10.745-24-24v-8H192v72h-26a6 6 0 0 0-6 6v52a6 6 0 0 0 6 6h52a6 6 0 0 0 6-6v-26h288v26a6 6 0 0 0 6 6h52a6 6 0 0 0 6-6v-52a6 6 0 0 0-6-6h-26V256z"]
};
var faOilCan = {
  prefix: 'fas',
  iconName: 'oil-can',
  icon: [640, 512, [], "f613", "M629.8 160.31L416 224l-50.49-25.24a64.07 64.07 0 0 0-28.62-6.76H280v-48h56c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16H176c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h56v48h-56L37.72 166.86a31.9 31.9 0 0 0-5.79-.53C14.67 166.33 0 180.36 0 198.34v94.95c0 15.46 11.06 28.72 26.28 31.48L96 337.46V384c0 17.67 14.33 32 32 32h274.63c8.55 0 16.75-3.42 22.76-9.51l212.26-214.75c1.5-1.5 2.34-3.54 2.34-5.66V168c.01-5.31-5.08-9.15-10.19-7.69zM96 288.67l-48-8.73v-62.43l48 8.73v62.43zm453.33 84.66c0 23.56 19.1 42.67 42.67 42.67s42.67-19.1 42.67-42.67S592 288 592 288s-42.67 61.77-42.67 85.33z"]
};
var faOm = {
  prefix: 'fas',
  iconName: 'om',
  icon: [512, 512, [], "f679", "M360.6 60.94a10.43 10.43 0 0 0 14.76 0l21.57-21.56a10.43 10.43 0 0 0 0-14.76L375.35 3.06c-4.08-4.07-10.68-4.07-14.76 0l-21.57 21.56a10.43 10.43 0 0 0 0 14.76l21.58 21.56zM412.11 192c-26.69 0-51.77 10.39-70.64 29.25l-24.25 24.25c-6.78 6.77-15.78 10.5-25.38 10.5H245c10.54-22.1 14.17-48.11 7.73-75.23-10.1-42.55-46.36-76.11-89.52-83.19-36.15-5.93-70.9 5.04-96.01 28.78-7.36 6.96-6.97 18.85 1.12 24.93l26.15 19.63c5.72 4.3 13.66 4.32 19.2-.21 8.45-6.9 19.02-10.71 30.27-10.71 26.47 0 48.01 21.53 48.01 48s-21.54 48-48.01 48h-31.9c-11.96 0-19.74 12.58-14.39 23.28l16.09 32.17c2.53 5.06 7.6 8.1 13.17 8.55h33.03c35.3 0 64.01 28.7 64.01 64s-28.71 64-64.01 64c-96.02 0-122.35-54.02-145.15-92.03-4.53-7.55-14.77-3.58-14.79 5.22C-.09 416 41.13 512 159.94 512c70.59 0 128.02-57.42 128.02-128 0-23.42-6.78-45.1-17.81-64h21.69c26.69 0 51.77-10.39 70.64-29.25l24.25-24.25c6.78-6.77 15.78-10.5 25.38-10.5 19.78 0 35.88 16.09 35.88 35.88V392c0 13.23-18.77 24-32.01 24-39.4 0-66.67-24.24-81.82-42.89-4.77-5.87-14.2-2.54-14.2 5.02V416s0 64 96.02 64c48.54 0 96.02-39.47 96.02-88V291.88c0-55.08-44.8-99.88-99.89-99.88zm42.18-124.73c-85.55 65.12-169.05 2.75-172.58.05-6.02-4.62-14.44-4.38-20.14.55-5.74 4.92-7.27 13.17-3.66 19.8 1.61 2.95 40.37 72.34 118.8 72.34 79.92 0 98.78-31.36 101.75-37.66 1.02-2.12 1.53-4.47 1.53-6.83V80c0-13.22-15.14-20.69-25.7-12.73z"]
};
var faOtter = {
  prefix: 'fas',
  iconName: 'otter',
  icon: [640, 512, [], "f700", "M608 32h-32l-13.25-13.25A63.97 63.97 0 0 0 517.49 0H497c-11.14 0-22.08 2.91-31.75 8.43L312 96h-56C149.96 96 64 181.96 64 288v1.61c0 32.75-16 62.14-39.56 84.89-18.19 17.58-28.1 43.68-23.19 71.8 6.76 38.8 42.9 65.7 82.28 65.7H192c17.67 0 32-14.33 32-32s-14.33-32-32-32H80c-8.83 0-16-7.17-16-16s7.17-16 16-16h224c8.84 0 16-7.16 16-16v-16c0-17.67-14.33-32-32-32h-64l149.49-80.5L448 416h80c8.84 0 16-7.16 16-16v-16c0-17.67-14.33-32-32-32h-28.22l-55.11-110.21L521.14 192H544c53.02 0 96-42.98 96-96V64c0-17.67-14.33-32-32-32zm-96 16c8.84 0 16 7.16 16 16s-7.16 16-16 16-16-7.16-16-16 7.16-16 16-16zm32 96h-34.96L407.2 198.84l-13.77-27.55L512 112h77.05c-6.62 18.58-24.22 32-45.05 32z"]
};
var faOutdent = {
  prefix: 'fas',
  iconName: 'outdent',
  icon: [448, 512, [], "f03b", "M100.69 363.29c10 10 27.31 2.93 27.31-11.31V160c0-14.32-17.33-21.31-27.31-11.31l-96 96a16 16 0 0 0 0 22.62zM432 416H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm3.17-128H204.83A12.82 12.82 0 0 0 192 300.83v38.34A12.82 12.82 0 0 0 204.83 352h230.34A12.82 12.82 0 0 0 448 339.17v-38.34A12.82 12.82 0 0 0 435.17 288zm0-128H204.83A12.82 12.82 0 0 0 192 172.83v38.34A12.82 12.82 0 0 0 204.83 224h230.34A12.82 12.82 0 0 0 448 211.17v-38.34A12.82 12.82 0 0 0 435.17 160zM432 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"]
};
var faPager = {
  prefix: 'fas',
  iconName: 'pager',
  icon: [512, 512, [], "f815", "M448 64H64a64 64 0 0 0-64 64v256a64 64 0 0 0 64 64h384a64 64 0 0 0 64-64V128a64 64 0 0 0-64-64zM160 368H80a16 16 0 0 1-16-16v-16a16 16 0 0 1 16-16h80zm128-16a16 16 0 0 1-16 16h-80v-48h80a16 16 0 0 1 16 16zm160-128a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32v-64a32 32 0 0 1 32-32h320a32 32 0 0 1 32 32z"]
};
var faPaintBrush = {
  prefix: 'fas',
  iconName: 'paint-brush',
  icon: [512, 512, [], "f1fc", "M167.02 309.34c-40.12 2.58-76.53 17.86-97.19 72.3-2.35 6.21-8 9.98-14.59 9.98-11.11 0-45.46-27.67-55.25-34.35C0 439.62 37.93 512 128 512c75.86 0 128-43.77 128-120.19 0-3.11-.65-6.08-.97-9.13l-88.01-73.34zM457.89 0c-15.16 0-29.37 6.71-40.21 16.45C213.27 199.05 192 203.34 192 257.09c0 13.7 3.25 26.76 8.73 38.7l63.82 53.18c7.21 1.8 14.64 3.03 22.39 3.03 62.11 0 98.11-45.47 211.16-256.46 7.38-14.35 13.9-29.85 13.9-45.99C512 20.64 486 0 457.89 0z"]
};
var faPaintRoller = {
  prefix: 'fas',
  iconName: 'paint-roller',
  icon: [512, 512, [], "f5aa", "M416 128V32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v96c0 17.67 14.33 32 32 32h352c17.67 0 32-14.33 32-32zm32-64v128c0 17.67-14.33 32-32 32H256c-35.35 0-64 28.65-64 64v32c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32v-32h160c53.02 0 96-42.98 96-96v-64c0-35.35-28.65-64-64-64z"]
};
var faPalette = {
  prefix: 'fas',
  iconName: 'palette',
  icon: [512, 512, [], "f53f", "M204.3 5C104.9 24.4 24.8 104.3 5.2 203.4c-37 187 131.7 326.4 258.8 306.7 41.2-6.4 61.4-54.6 42.5-91.7-23.1-45.4 9.9-98.4 60.9-98.4h79.7c35.8 0 64.8-29.6 64.9-65.3C511.5 97.1 368.1-26.9 204.3 5zM96 320c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm32-128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128-64c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 64c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"]
};
var faPallet = {
  prefix: 'fas',
  iconName: 'pallet',
  icon: [640, 512, [], "f482", "M144 256h352c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16H384v128l-64-32-64 32V0H144c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16zm480 128c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v64H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-48v-64h48zm-336 64H128v-64h160v64zm224 0H352v-64h160v64z"]
};
var faPaperPlane = {
  prefix: 'fas',
  iconName: 'paper-plane',
  icon: [512, 512, [], "f1d8", "M476 3.2L12.5 270.6c-18.1 10.4-15.8 35.6 2.2 43.2L121 358.4l287.3-253.2c5.5-4.9 13.3 2.6 8.6 8.3L176 407v80.5c0 23.6 28.5 32.9 42.5 15.8L282 426l124.6 52.2c14.2 6 30.4-2.9 33-18.2l72-432C515 7.8 493.3-6.8 476 3.2z"]
};
var faPaperclip = {
  prefix: 'fas',
  iconName: 'paperclip',
  icon: [448, 512, [], "f0c6", "M43.246 466.142c-58.43-60.289-57.341-157.511 1.386-217.581L254.392 34c44.316-45.332 116.351-45.336 160.671 0 43.89 44.894 43.943 117.329 0 162.276L232.214 383.128c-29.855 30.537-78.633 30.111-107.982-.998-28.275-29.97-27.368-77.473 1.452-106.953l143.743-146.835c6.182-6.314 16.312-6.422 22.626-.241l22.861 22.379c6.315 6.182 6.422 16.312.241 22.626L171.427 319.927c-4.932 5.045-5.236 13.428-.648 18.292 4.372 4.634 11.245 4.711 15.688.165l182.849-186.851c19.613-20.062 19.613-52.725-.011-72.798-19.189-19.627-49.957-19.637-69.154 0L90.39 293.295c-34.763 35.56-35.299 93.12-1.191 128.313 34.01 35.093 88.985 35.137 123.058.286l172.06-175.999c6.177-6.319 16.307-6.433 22.626-.256l22.877 22.364c6.319 6.177 6.434 16.307.256 22.626l-172.06 175.998c-59.576 60.938-155.943 60.216-214.77-.485z"]
};
var faParachuteBox = {
  prefix: 'fas',
  iconName: 'parachute-box',
  icon: [512, 512, [], "f4cd", "M511.9 175c-9.1-75.6-78.4-132.4-158.3-158.7C390 55.7 416 116.9 416 192h28.1L327.5 321.5c-2.5-.6-4.8-1.5-7.5-1.5h-48V192h112C384 76.8 315.1 0 256 0S128 76.8 128 192h112v128h-48c-2.7 0-5 .9-7.5 1.5L67.9 192H96c0-75.1 26-136.3 62.4-175.7C78.5 42.7 9.2 99.5.1 175c-1.1 9.1 6.8 17 16 17h8.7l136.7 151.9c-.7 2.6-1.6 5.2-1.6 8.1v128c0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32V352c0-2.9-.9-5.4-1.6-8.1L487.1 192h8.7c9.3 0 17.2-7.8 16.1-17z"]
};
var faParagraph = {
  prefix: 'fas',
  iconName: 'paragraph',
  icon: [448, 512, [], "f1dd", "M448 48v32a16 16 0 0 1-16 16h-48v368a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V96h-32v368a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V352h-32a160 160 0 0 1 0-320h240a16 16 0 0 1 16 16z"]
};
var faParking = {
  prefix: 'fas',
  iconName: 'parking',
  icon: [448, 512, [], "f540", "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM240 320h-48v48c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16h96c52.9 0 96 43.1 96 96s-43.1 96-96 96zm0-128h-48v64h48c17.6 0 32-14.4 32-32s-14.4-32-32-32z"]
};
var faPassport = {
  prefix: 'fas',
  iconName: 'passport',
  icon: [448, 512, [], "f5ab", "M129.62 176h39.09c1.49-27.03 6.54-51.35 14.21-70.41-27.71 13.24-48.02 39.19-53.3 70.41zm0 32c5.29 31.22 25.59 57.17 53.3 70.41-7.68-19.06-12.72-43.38-14.21-70.41h-39.09zM224 286.69c7.69-7.45 20.77-34.42 23.43-78.69h-46.87c2.67 44.26 15.75 71.24 23.44 78.69zM200.57 176h46.87c-2.66-44.26-15.74-71.24-23.43-78.69-7.7 7.45-20.78 34.43-23.44 78.69zm64.51 102.41c27.71-13.24 48.02-39.19 53.3-70.41h-39.09c-1.49 27.03-6.53 51.35-14.21 70.41zM416 0H64C28.65 0 0 28.65 0 64v384c0 35.35 28.65 64 64 64h352c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32zm-80 416H112c-8.8 0-16-7.2-16-16s7.2-16 16-16h224c8.8 0 16 7.2 16 16s-7.2 16-16 16zm-112-96c-70.69 0-128-57.31-128-128S153.31 64 224 64s128 57.31 128 128-57.31 128-128 128zm41.08-214.41c7.68 19.06 12.72 43.38 14.21 70.41h39.09c-5.28-31.22-25.59-57.17-53.3-70.41z"]
};
var faPastafarianism = {
  prefix: 'fas',
  iconName: 'pastafarianism',
  icon: [640, 512, [], "f67b", "M624.54 347.67c-32.7-12.52-57.36 4.25-75.37 16.45-17.06 11.53-23.25 14.42-31.41 11.36-8.12-3.09-10.83-9.38-15.89-29.38-3.33-13.15-7.44-29.32-17.95-42.65 2.24-2.91 4.43-5.79 6.38-8.57C500.47 304.45 513.71 312 532 312c33.95 0 50.87-25.78 62.06-42.83 10.59-16.14 15-21.17 21.94-21.17 13.25 0 24-10.75 24-24s-10.75-24-24-24c-33.95 0-50.87 25.78-62.06 42.83-10.6 16.14-15 21.17-21.94 21.17-17.31 0-37.48-61.43-97.26-101.91l17.25-34.5C485.43 125.5 512 97.98 512 64c0-35.35-28.65-64-64-64s-64 28.65-64 64c0 13.02 3.94 25.1 10.62 35.21l-18.15 36.3c-16.98-4.6-35.6-7.51-56.46-7.51s-39.49 2.91-56.46 7.51l-18.15-36.3C252.06 89.1 256 77.02 256 64c0-35.35-28.65-64-64-64s-64 28.65-64 64c0 33.98 26.56 61.5 60.02 63.6l17.25 34.5C145.68 202.44 125.15 264 108 264c-6.94 0-11.34-5.03-21.94-21.17C74.88 225.78 57.96 200 24 200c-13.25 0-24 10.75-24 24s10.75 24 24 24c6.94 0 11.34 5.03 21.94 21.17C57.13 286.22 74.05 312 108 312c18.29 0 31.53-7.55 41.7-17.11 1.95 2.79 4.14 5.66 6.38 8.57-10.51 13.33-14.62 29.5-17.95 42.65-5.06 20-7.77 26.28-15.89 29.38-8.11 3.06-14.33.17-31.41-11.36-18.03-12.2-42.72-28.92-75.37-16.45-12.39 4.72-18.59 18.58-13.87 30.97 4.72 12.41 18.61 18.61 30.97 13.88 8.16-3.09 14.34-.19 31.39 11.36 13.55 9.16 30.83 20.86 52.42 20.84 7.17 0 14.83-1.28 22.97-4.39 32.66-12.44 39.98-41.33 45.33-62.44 2.21-8.72 3.99-14.49 5.95-18.87 16.62 13.61 36.95 25.88 61.64 34.17-9.96 37-32.18 90.8-60.26 90.8-13.25 0-24 10.75-24 24s10.75 24 24 24c66.74 0 97.05-88.63 107.42-129.14 6.69.6 13.42 1.14 20.58 1.14s13.89-.54 20.58-1.14C350.95 423.37 381.26 512 448 512c13.25 0 24-10.75 24-24s-10.75-24-24-24c-27.94 0-50.21-53.81-60.22-90.81 24.69-8.29 45-20.56 61.62-34.16 1.96 4.38 3.74 10.15 5.95 18.87 5.34 21.11 12.67 50 45.33 62.44 8.14 3.11 15.8 4.39 22.97 4.39 21.59 0 38.87-11.69 52.42-20.84 17.05-11.55 23.28-14.45 31.39-11.36 12.39 4.75 26.27-1.47 30.97-13.88 4.71-12.4-1.49-26.26-13.89-30.98zM448 48c8.82 0 16 7.18 16 16s-7.18 16-16 16-16-7.18-16-16 7.18-16 16-16zm-256 0c8.82 0 16 7.18 16 16s-7.18 16-16 16-16-7.18-16-16 7.18-16 16-16z"]
};
var faPaste = {
  prefix: 'fas',
  iconName: 'paste',
  icon: [448, 512, [], "f0ea", "M128 184c0-30.879 25.122-56 56-56h136V56c0-13.255-10.745-24-24-24h-80.61C204.306 12.89 183.637 0 160 0s-44.306 12.89-55.39 32H24C10.745 32 0 42.745 0 56v336c0 13.255 10.745 24 24 24h104V184zm32-144c13.255 0 24 10.745 24 24s-10.745 24-24 24-24-10.745-24-24 10.745-24 24-24zm184 248h104v200c0 13.255-10.745 24-24 24H184c-13.255 0-24-10.745-24-24V184c0-13.255 10.745-24 24-24h136v104c0 13.2 10.8 24 24 24zm104-38.059V256h-96v-96h6.059a24 24 0 0 1 16.97 7.029l65.941 65.941a24.002 24.002 0 0 1 7.03 16.971z"]
};
var faPause = {
  prefix: 'fas',
  iconName: 'pause',
  icon: [448, 512, [], "f04c", "M144 479H48c-26.5 0-48-21.5-48-48V79c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48zm304-48V79c0-26.5-21.5-48-48-48h-96c-26.5 0-48 21.5-48 48v352c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48z"]
};
var faPauseCircle = {
  prefix: 'fas',
  iconName: 'pause-circle',
  icon: [512, 512, [], "f28b", "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm-16 328c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v160zm112 0c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v160z"]
};
var faPaw = {
  prefix: 'fas',
  iconName: 'paw',
  icon: [512, 512, [], "f1b0", "M256 224c-79.41 0-192 122.76-192 200.25 0 34.9 26.81 55.75 71.74 55.75 48.84 0 81.09-25.08 120.26-25.08 39.51 0 71.85 25.08 120.26 25.08 44.93 0 71.74-20.85 71.74-55.75C448 346.76 335.41 224 256 224zm-147.28-12.61c-10.4-34.65-42.44-57.09-71.56-50.13-29.12 6.96-44.29 40.69-33.89 75.34 10.4 34.65 42.44 57.09 71.56 50.13 29.12-6.96 44.29-40.69 33.89-75.34zm84.72-20.78c30.94-8.14 46.42-49.94 34.58-93.36s-46.52-72.01-77.46-63.87-46.42 49.94-34.58 93.36c11.84 43.42 46.53 72.02 77.46 63.87zm281.39-29.34c-29.12-6.96-61.15 15.48-71.56 50.13-10.4 34.65 4.77 68.38 33.89 75.34 29.12 6.96 61.15-15.48 71.56-50.13 10.4-34.65-4.77-68.38-33.89-75.34zm-156.27 29.34c30.94 8.14 65.62-20.45 77.46-63.87 11.84-43.42-3.64-85.21-34.58-93.36s-65.62 20.45-77.46 63.87c-11.84 43.42 3.64 85.22 34.58 93.36z"]
};
var faPeace = {
  prefix: 'fas',
  iconName: 'peace',
  icon: [496, 512, [], "f67c", "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm184 248c0 31.93-8.2 61.97-22.57 88.17L280 240.63V74.97c86.23 15.21 152 90.5 152 181.03zM216 437.03c-33.86-5.97-64.49-21.2-89.29-43.02L216 322.57v114.46zm64-114.46L369.29 394c-24.8 21.82-55.43 37.05-89.29 43.02V322.57zm-64-247.6v165.66L86.57 344.17C72.2 317.97 64 287.93 64 256c0-90.53 65.77-165.82 152-181.03z"]
};
var faPen = {
  prefix: 'fas',
  iconName: 'pen',
  icon: [512, 512, [], "f304", "M290.74 93.24l128.02 128.02-277.99 277.99-114.14 12.6C11.35 513.54-1.56 500.62.14 485.34l12.7-114.22 277.9-277.88zm207.2-19.06l-60.11-60.11c-18.75-18.75-49.16-18.75-67.91 0l-56.55 56.55 128.02 128.02 56.55-56.55c18.75-18.76 18.75-49.16 0-67.91z"]
};
var faPenAlt = {
  prefix: 'fas',
  iconName: 'pen-alt',
  icon: [512, 512, [], "f305", "M497.94 74.17l-60.11-60.11c-18.75-18.75-49.16-18.75-67.91 0l-56.55 56.55 128.02 128.02 56.55-56.55c18.75-18.75 18.75-49.15 0-67.91zm-246.8-20.53c-15.62-15.62-40.94-15.62-56.56 0L75.8 172.43c-6.25 6.25-6.25 16.38 0 22.62l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l101.82-101.82 22.63 22.62L93.95 290.03A327.038 327.038 0 0 0 .17 485.11l-.03.23c-1.7 15.28 11.21 28.2 26.49 26.51a327.02 327.02 0 0 0 195.34-93.8l196.79-196.79-82.77-82.77-84.85-84.85z"]
};
var faPenFancy = {
  prefix: 'fas',
  iconName: 'pen-fancy',
  icon: [512, 512, [], "f5ac", "M79.18 282.94a32.005 32.005 0 0 0-20.24 20.24L0 480l4.69 4.69 92.89-92.89c-.66-2.56-1.57-5.03-1.57-7.8 0-17.67 14.33-32 32-32s32 14.33 32 32-14.33 32-32 32c-2.77 0-5.24-.91-7.8-1.57l-92.89 92.89L32 512l176.82-58.94a31.983 31.983 0 0 0 20.24-20.24l33.07-84.07-98.88-98.88-84.07 33.07zM369.25 28.32L186.14 227.81l97.85 97.85 199.49-183.11C568.4 67.48 443.73-55.94 369.25 28.32z"]
};
var faPenNib = {
  prefix: 'fas',
  iconName: 'pen-nib',
  icon: [512, 512, [], "f5ad", "M136.6 138.79a64.003 64.003 0 0 0-43.31 41.35L0 460l14.69 14.69L164.8 324.58c-2.99-6.26-4.8-13.18-4.8-20.58 0-26.51 21.49-48 48-48s48 21.49 48 48-21.49 48-48 48c-7.4 0-14.32-1.81-20.58-4.8L37.31 497.31 52 512l279.86-93.29a64.003 64.003 0 0 0 41.35-43.31L416 224 288 96l-151.4 42.79zm361.34-64.62l-60.11-60.11c-18.75-18.75-49.16-18.75-67.91 0l-56.55 56.55 128.02 128.02 56.55-56.55c18.75-18.75 18.75-49.15 0-67.91z"]
};
var faPenSquare = {
  prefix: 'fas',
  iconName: 'pen-square',
  icon: [448, 512, [], "f14b", "M400 480H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48zM238.1 177.9L102.4 313.6l-6.3 57.1c-.8 7.6 5.6 14.1 13.3 13.3l57.1-6.3L302.2 242c2.3-2.3 2.3-6.1 0-8.5L246.7 178c-2.5-2.4-6.3-2.4-8.6-.1zM345 165.1L314.9 135c-9.4-9.4-24.6-9.4-33.9 0l-23.1 23.1c-2.3 2.3-2.3 6.1 0 8.5l55.5 55.5c2.3 2.3 6.1 2.3 8.5 0L345 199c9.3-9.3 9.3-24.5 0-33.9z"]
};
var faPencilAlt = {
  prefix: 'fas',
  iconName: 'pencil-alt',
  icon: [512, 512, [], "f303", "M497.9 142.1l-46.1 46.1c-4.7 4.7-12.3 4.7-17 0l-111-111c-4.7-4.7-4.7-12.3 0-17l46.1-46.1c18.7-18.7 49.1-18.7 67.9 0l60.1 60.1c18.8 18.7 18.8 49.1 0 67.9zM284.2 99.8L21.6 362.4.4 483.9c-2.9 16.4 11.4 30.6 27.8 27.8l121.5-21.3 262.6-262.6c4.7-4.7 4.7-12.3 0-17l-111-111c-4.8-4.7-12.4-4.7-17.1 0zM124.1 339.9c-5.5-5.5-5.5-14.3 0-19.8l154-154c5.5-5.5 14.3-5.5 19.8 0s5.5 14.3 0 19.8l-154 154c-5.5 5.5-14.3 5.5-19.8 0zM88 424h48v36.3l-64.5 11.3-31.1-31.1L51.7 376H88v48z"]
};
var faPencilRuler = {
  prefix: 'fas',
  iconName: 'pencil-ruler',
  icon: [512, 512, [], "f5ae", "M109.46 244.04l134.58-134.56-44.12-44.12-61.68 61.68a7.919 7.919 0 0 1-11.21 0l-11.21-11.21c-3.1-3.1-3.1-8.12 0-11.21l61.68-61.68-33.64-33.65C131.47-3.1 111.39-3.1 99 9.29L9.29 99c-12.38 12.39-12.39 32.47 0 44.86l100.17 100.18zm388.47-116.8c18.76-18.76 18.75-49.17 0-67.93l-45.25-45.25c-18.76-18.76-49.18-18.76-67.95 0l-46.02 46.01 113.2 113.2 46.02-46.03zM316.08 82.71l-297 296.96L.32 487.11c-2.53 14.49 10.09 27.11 24.59 24.56l107.45-18.84L429.28 195.9 316.08 82.71zm186.63 285.43l-33.64-33.64-61.68 61.68c-3.1 3.1-8.12 3.1-11.21 0l-11.21-11.21c-3.09-3.1-3.09-8.12 0-11.21l61.68-61.68-44.14-44.14L267.93 402.5l100.21 100.2c12.39 12.39 32.47 12.39 44.86 0l89.71-89.7c12.39-12.39 12.39-32.47 0-44.86z"]
};
var faPeopleArrows = {
  prefix: 'fas',
  iconName: 'people-arrows',
  icon: [576, 512, [], "e068", "M96,128A64,64,0,1,0,32,64,64,64,0,0,0,96,128Zm0,176.08a44.11,44.11,0,0,1,13.64-32L181.77,204c1.65-1.55,3.77-2.31,5.61-3.57A63.91,63.91,0,0,0,128,160H64A64,64,0,0,0,0,224v96a32,32,0,0,0,32,32V480a32,32,0,0,0,32,32h64a32,32,0,0,0,32-32V383.61l-50.36-47.53A44.08,44.08,0,0,1,96,304.08ZM480,128a64,64,0,1,0-64-64A64,64,0,0,0,480,128Zm32,32H448a63.91,63.91,0,0,0-59.38,40.42c1.84,1.27,4,2,5.62,3.59l72.12,68.06a44.37,44.37,0,0,1,0,64L416,383.62V480a32,32,0,0,0,32,32h64a32,32,0,0,0,32-32V352a32,32,0,0,0,32-32V224A64,64,0,0,0,512,160ZM444.4,295.34l-72.12-68.06A12,12,0,0,0,352,236v36H224V236a12,12,0,0,0-20.28-8.73L131.6,295.34a12.4,12.4,0,0,0,0,17.47l72.12,68.07A12,12,0,0,0,224,372.14V336H352v36.14a12,12,0,0,0,20.28,8.74l72.12-68.07A12.4,12.4,0,0,0,444.4,295.34Z"]
};
var faPeopleCarry = {
  prefix: 'fas',
  iconName: 'people-carry',
  icon: [640, 512, [], "f4ce", "M128 96c26.5 0 48-21.5 48-48S154.5 0 128 0 80 21.5 80 48s21.5 48 48 48zm384 0c26.5 0 48-21.5 48-48S538.5 0 512 0s-48 21.5-48 48 21.5 48 48 48zm125.7 372.1l-44-110-41.1 46.4-2 18.2 27.7 69.2c5 12.5 17 20.1 29.7 20.1 4 0 8-.7 11.9-2.3 16.4-6.6 24.4-25.2 17.8-41.6zm-34.2-209.8L585 178.1c-4.6-20-18.6-36.8-37.5-44.9-18.5-8-39-6.7-56.1 3.3-22.7 13.4-39.7 34.5-48.1 59.4L432 229.8 416 240v-96c0-8.8-7.2-16-16-16H240c-8.8 0-16 7.2-16 16v96l-16.1-10.2-11.3-33.9c-8.3-25-25.4-46-48.1-59.4-17.2-10-37.6-11.3-56.1-3.3-18.9 8.1-32.9 24.9-37.5 44.9l-18.4 80.2c-4.6 20 .7 41.2 14.4 56.7l67.2 75.9 10.1 92.6C130 499.8 143.8 512 160 512c1.2 0 2.3-.1 3.5-.2 17.6-1.9 30.2-17.7 28.3-35.3l-10.1-92.8c-1.5-13-6.9-25.1-15.6-35l-43.3-49 17.6-70.3 6.8 20.4c4.1 12.5 11.9 23.4 24.5 32.6l51.1 32.5c4.6 2.9 12.1 4.6 17.2 5h160c5.1-.4 12.6-2.1 17.2-5l51.1-32.5c12.6-9.2 20.4-20 24.5-32.6l6.8-20.4 17.6 70.3-43.3 49c-8.7 9.9-14.1 22-15.6 35l-10.1 92.8c-1.9 17.6 10.8 33.4 28.3 35.3 1.2.1 2.3.2 3.5.2 16.1 0 30-12.1 31.8-28.5l10.1-92.6 67.2-75.9c13.6-15.5 19-36.7 14.4-56.7zM46.3 358.1l-44 110c-6.6 16.4 1.4 35 17.8 41.6 16.8 6.6 35.1-1.7 41.6-17.8l27.7-69.2-2-18.2-41.1-46.4z"]
};
var faPepperHot = {
  prefix: 'fas',
  iconName: 'pepper-hot',
  icon: [512, 512, [], "f816", "M330.67 263.12V173.4l-52.75-24.22C219.44 218.76 197.58 400 56 400a56 56 0 0 0 0 112c212.64 0 370.65-122.87 419.18-210.34l-37.05-38.54zm131.09-128.37C493.92 74.91 477.18 26.48 458.62 3a8 8 0 0 0-11.93-.59l-22.9 23a8.06 8.06 0 0 0-.89 10.23c6.86 10.36 17.05 35.1-1.4 72.32A142.85 142.85 0 0 0 364.34 96c-28 0-54 8.54-76.34 22.59l74.67 34.29v78.24h89.09L506.44 288c3.26-12.62 5.56-25.63 5.56-39.31a154 154 0 0 0-50.24-113.94z"]
};
var faPercent = {
  prefix: 'fas',
  iconName: 'percent',
  icon: [448, 512, [], "f295", "M112 224c61.9 0 112-50.1 112-112S173.9 0 112 0 0 50.1 0 112s50.1 112 112 112zm0-160c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zm224 224c-61.9 0-112 50.1-112 112s50.1 112 112 112 112-50.1 112-112-50.1-112-112-112zm0 160c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zM392.3.2l31.6-.1c19.4-.1 30.9 21.8 19.7 37.8L77.4 501.6a23.95 23.95 0 0 1-19.6 10.2l-33.4.1c-19.5 0-30.9-21.9-19.7-37.8l368-463.7C377.2 4 384.5.2 392.3.2z"]
};
var faPercentage = {
  prefix: 'fas',
  iconName: 'percentage',
  icon: [384, 512, [], "f541", "M109.25 173.25c24.99-24.99 24.99-65.52 0-90.51-24.99-24.99-65.52-24.99-90.51 0-24.99 24.99-24.99 65.52 0 90.51 25 25 65.52 25 90.51 0zm256 165.49c-24.99-24.99-65.52-24.99-90.51 0-24.99 24.99-24.99 65.52 0 90.51 24.99 24.99 65.52 24.99 90.51 0 25-24.99 25-65.51 0-90.51zm-1.94-231.43l-22.62-22.62c-12.5-12.5-32.76-12.5-45.25 0L20.69 359.44c-12.5 12.5-12.5 32.76 0 45.25l22.62 22.62c12.5 12.5 32.76 12.5 45.25 0l274.75-274.75c12.5-12.49 12.5-32.75 0-45.25z"]
};
var faPersonBooth = {
  prefix: 'fas',
  iconName: 'person-booth',
  icon: [576, 512, [], "f756", "M192 496c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320h-64v176zm32-272h-50.9l-45.2-45.3C115.8 166.6 99.7 160 82.7 160H64c-17.1 0-33.2 6.7-45.3 18.8C6.7 190.9 0 207 0 224.1L.2 320 0 480c0 17.7 14.3 32 31.9 32 17.6 0 32-14.3 32-32l.1-100.7c.9.5 1.6 1.3 2.5 1.7l29.1 43v56c0 17.7 14.3 32 32 32s32-14.3 32-32v-56.5c0-9.9-2.3-19.8-6.7-28.6l-41.2-61.3V253l20.9 20.9c9.1 9.1 21.1 14.1 33.9 14.1H224c17.7 0 32-14.3 32-32s-14.3-32-32-32zM64 128c26.5 0 48-21.5 48-48S90.5 32 64 32 16 53.5 16 80s21.5 48 48 48zm224-96l31.5 223.1-30.9 154.6c-4.3 21.6 13 38.3 31.4 38.3 15.2 0 28-9.1 32.3-30.4.9 16.9 14.6 30.4 31.7 30.4 17.7 0 32-14.3 32-32 0 17.7 14.3 32 32 32s32-14.3 32-32V0H288v32zm-96 0v160h64V0h-32c-17.7 0-32 14.3-32 32zM544 0h-32v496c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V32c0-17.7-14.3-32-32-32z"]
};
var faPhone = {
  prefix: 'fas',
  iconName: 'phone',
  icon: [512, 512, [], "f095", "M493.4 24.6l-104-24c-11.3-2.6-22.9 3.3-27.5 13.9l-48 112c-4.2 9.8-1.4 21.3 6.9 28l60.6 49.6c-36 76.7-98.9 140.5-177.2 177.2l-49.6-60.6c-6.8-8.3-18.2-11.1-28-6.9l-112 48C3.9 366.5-2 378.1.6 389.4l24 104C27.1 504.2 36.7 512 48 512c256.1 0 464-207.5 464-464 0-11.2-7.7-20.9-18.6-23.4z"]
};
var faPhoneAlt = {
  prefix: 'fas',
  iconName: 'phone-alt',
  icon: [512, 512, [], "f879", "M497.39 361.8l-112-48a24 24 0 0 0-28 6.9l-49.6 60.6A370.66 370.66 0 0 1 130.6 204.11l60.6-49.6a23.94 23.94 0 0 0 6.9-28l-48-112A24.16 24.16 0 0 0 122.6.61l-104 24A24 24 0 0 0 0 48c0 256.5 207.9 464 464 464a24 24 0 0 0 23.4-18.6l24-104a24.29 24.29 0 0 0-14.01-27.6z"]
};
var faPhoneSlash = {
  prefix: 'fas',
  iconName: 'phone-slash',
  icon: [640, 512, [], "f3dd", "M268.2 381.4l-49.6-60.6c-6.8-8.3-18.2-11.1-28-6.9l-112 48c-10.7 4.6-16.5 16.1-13.9 27.5l24 104c2.5 10.8 12.1 18.6 23.4 18.6 100.7 0 193.7-32.4 269.7-86.9l-80-61.8c-10.9 6.5-22.1 12.7-33.6 18.1zm365.6 76.7L475.1 335.5C537.9 256.4 576 156.9 576 48c0-11.2-7.7-20.9-18.6-23.4l-104-24c-11.3-2.6-22.9 3.3-27.5 13.9l-48 112c-4.2 9.8-1.4 21.3 6.9 28l60.6 49.6c-12.2 26.1-27.9 50.3-46 72.8L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4l588.4 454.7c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.4-6.8 4.1-16.9-2.9-22.3z"]
};
var faPhoneSquare = {
  prefix: 'fas',
  iconName: 'phone-square',
  icon: [448, 512, [], "f098", "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM94 416c-7.033 0-13.057-4.873-14.616-11.627l-14.998-65a15 15 0 0 1 8.707-17.16l69.998-29.999a15 15 0 0 1 17.518 4.289l30.997 37.885c48.944-22.963 88.297-62.858 110.781-110.78l-37.886-30.997a15.001 15.001 0 0 1-4.289-17.518l30-69.998a15 15 0 0 1 17.16-8.707l65 14.998A14.997 14.997 0 0 1 384 126c0 160.292-129.945 290-290 290z"]
};
var faPhoneSquareAlt = {
  prefix: 'fas',
  iconName: 'phone-square-alt',
  icon: [448, 512, [], "f87b", "M400 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h352a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48zm-16.39 307.37l-15 65A15 15 0 0 1 354 416C194 416 64 286.29 64 126a15.7 15.7 0 0 1 11.63-14.61l65-15A18.23 18.23 0 0 1 144 96a16.27 16.27 0 0 1 13.79 9.09l30 70A17.9 17.9 0 0 1 189 181a17 17 0 0 1-5.5 11.61l-37.89 31a231.91 231.91 0 0 0 110.78 110.78l31-37.89A17 17 0 0 1 299 291a17.85 17.85 0 0 1 5.91 1.21l70 30A16.25 16.25 0 0 1 384 336a17.41 17.41 0 0 1-.39 3.37z"]
};
var faPhoneVolume = {
  prefix: 'fas',
  iconName: 'phone-volume',
  icon: [384, 512, [], "f2a0", "M97.333 506.966c-129.874-129.874-129.681-340.252 0-469.933 5.698-5.698 14.527-6.632 21.263-2.422l64.817 40.513a17.187 17.187 0 0 1 6.849 20.958l-32.408 81.021a17.188 17.188 0 0 1-17.669 10.719l-55.81-5.58c-21.051 58.261-20.612 122.471 0 179.515l55.811-5.581a17.188 17.188 0 0 1 17.669 10.719l32.408 81.022a17.188 17.188 0 0 1-6.849 20.958l-64.817 40.513a17.19 17.19 0 0 1-21.264-2.422zM247.126 95.473c11.832 20.047 11.832 45.008 0 65.055-3.95 6.693-13.108 7.959-18.718 2.581l-5.975-5.726c-3.911-3.748-4.793-9.622-2.261-14.41a32.063 32.063 0 0 0 0-29.945c-2.533-4.788-1.65-10.662 2.261-14.41l5.975-5.726c5.61-5.378 14.768-4.112 18.718 2.581zm91.787-91.187c60.14 71.604 60.092 175.882 0 247.428-4.474 5.327-12.53 5.746-17.552.933l-5.798-5.557c-4.56-4.371-4.977-11.529-.93-16.379 49.687-59.538 49.646-145.933 0-205.422-4.047-4.85-3.631-12.008.93-16.379l5.798-5.557c5.022-4.813 13.078-4.394 17.552.933zm-45.972 44.941c36.05 46.322 36.108 111.149 0 157.546-4.39 5.641-12.697 6.251-17.856 1.304l-5.818-5.579c-4.4-4.219-4.998-11.095-1.285-15.931 26.536-34.564 26.534-82.572 0-117.134-3.713-4.836-3.115-11.711 1.285-15.931l5.818-5.579c5.159-4.947 13.466-4.337 17.856 1.304z"]
};
var faPhotoVideo = {
  prefix: 'fas',
  iconName: 'photo-video',
  icon: [640, 512, [], "f87c", "M608 0H160a32 32 0 0 0-32 32v96h160V64h192v320h128a32 32 0 0 0 32-32V32a32 32 0 0 0-32-32zM232 103a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9V73a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm352 208a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9v-30a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm0-104a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9v-30a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm0-104a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9V73a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm-168 57H32a32 32 0 0 0-32 32v288a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32V192a32 32 0 0 0-32-32zM96 224a32 32 0 1 1-32 32 32 32 0 0 1 32-32zm288 224H64v-32l64-64 32 32 128-128 96 96z"]
};
var faPiggyBank = {
  prefix: 'fas',
  iconName: 'piggy-bank',
  icon: [576, 512, [], "f4d3", "M560 224h-29.5c-8.8-20-21.6-37.7-37.4-52.5L512 96h-32c-29.4 0-55.4 13.5-73 34.3-7.6-1.1-15.1-2.3-23-2.3H256c-77.4 0-141.9 55-156.8 128H56c-14.8 0-26.5-13.5-23.5-28.8C34.7 215.8 45.4 208 57 208h1c3.3 0 6-2.7 6-6v-20c0-3.3-2.7-6-6-6-28.5 0-53.9 20.4-57.5 48.6C-3.9 258.8 22.7 288 56 288h40c0 52.2 25.4 98.1 64 127.3V496c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-48h128v48c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-80.7c11.8-8.9 22.3-19.4 31.3-31.3H560c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16zm-128 64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zM256 96h128c5.4 0 10.7.4 15.9.8 0-.3.1-.5.1-.8 0-53-43-96-96-96s-96 43-96 96c0 2.1.5 4.1.6 6.2 15.2-3.9 31-6.2 47.4-6.2z"]
};
var faPills = {
  prefix: 'fas',
  iconName: 'pills',
  icon: [576, 512, [], "f484", "M112 32C50.1 32 0 82.1 0 144v224c0 61.9 50.1 112 112 112s112-50.1 112-112V144c0-61.9-50.1-112-112-112zm48 224H64V144c0-26.5 21.5-48 48-48s48 21.5 48 48v112zm139.7-29.7c-3.5-3.5-9.4-3.1-12.3.8-45.3 62.5-40.4 150.1 15.9 206.4 56.3 56.3 143.9 61.2 206.4 15.9 4-2.9 4.3-8.8.8-12.3L299.7 226.3zm229.8-19c-56.3-56.3-143.9-61.2-206.4-15.9-4 2.9-4.3 8.8-.8 12.3l210.8 210.8c3.5 3.5 9.4 3.1 12.3-.8 45.3-62.6 40.5-150.1-15.9-206.4z"]
};
var faPizzaSlice = {
  prefix: 'fas',
  iconName: 'pizza-slice',
  icon: [512, 512, [], "f818", "M158.87.15c-16.16-1.52-31.2 8.42-35.33 24.12l-14.81 56.27c187.62 5.49 314.54 130.61 322.48 317l56.94-15.78c15.72-4.36 25.49-19.68 23.62-35.9C490.89 165.08 340.78 17.32 158.87.15zm-58.47 112L.55 491.64a16.21 16.21 0 0 0 20 19.75l379-105.1c-4.27-174.89-123.08-292.14-299.15-294.1zM128 416a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm48-152a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm104 104a32 32 0 1 1 32-32 32 32 0 0 1-32 32z"]
};
var faPlaceOfWorship = {
  prefix: 'fas',
  iconName: 'place-of-worship',
  icon: [640, 512, [], "f67f", "M620.61 366.55L512 320v192h112c8.84 0 16-7.16 16-16V395.96a32 32 0 0 0-19.39-29.41zM0 395.96V496c0 8.84 7.16 16 16 16h112V320L19.39 366.55A32 32 0 0 0 0 395.96zm464.46-149.28L416 217.6V102.63c0-8.49-3.37-16.62-9.38-22.63L331.31 4.69c-6.25-6.25-16.38-6.25-22.62 0L233.38 80c-6 6-9.38 14.14-9.38 22.63V217.6l-48.46 29.08A31.997 31.997 0 0 0 160 274.12V512h96v-96c0-35.35 28.66-64 64-64s64 28.65 64 64v96h96V274.12c0-11.24-5.9-21.66-15.54-27.44z"]
};
var faPlane = {
  prefix: 'fas',
  iconName: 'plane',
  icon: [576, 512, [], "f072", "M480 192H365.71L260.61 8.06A16.014 16.014 0 0 0 246.71 0h-65.5c-10.63 0-18.3 10.17-15.38 20.39L214.86 192H112l-43.2-57.6c-3.02-4.03-7.77-6.4-12.8-6.4H16.01C5.6 128-2.04 137.78.49 147.88L32 256 .49 364.12C-2.04 374.22 5.6 384 16.01 384H56c5.04 0 9.78-2.37 12.8-6.4L112 320h102.86l-49.03 171.6c-2.92 10.22 4.75 20.4 15.38 20.4h65.5c5.74 0 11.04-3.08 13.89-8.06L365.71 320H480c35.35 0 96-28.65 96-64s-60.65-64-96-64z"]
};
var faPlaneArrival = {
  prefix: 'fas',
  iconName: 'plane-arrival',
  icon: [640, 512, [], "f5af", "M624 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM44.81 205.66l88.74 80a62.607 62.607 0 0 0 25.47 13.93l287.6 78.35c26.48 7.21 54.56 8.72 81 1.36 29.67-8.27 43.44-21.21 47.25-35.71 3.83-14.5-1.73-32.71-23.37-54.96-19.28-19.82-44.35-32.79-70.83-40l-97.51-26.56L282.8 30.22c-1.51-5.81-5.95-10.35-11.66-11.91L206.05.58c-10.56-2.88-20.9 5.32-20.71 16.44l47.92 164.21-102.2-27.84-27.59-67.88c-1.93-4.89-6.01-8.57-11.02-9.93L52.72 64.75c-10.34-2.82-20.53 5-20.72 15.88l.23 101.78c.19 8.91 6.03 17.34 12.58 23.25z"]
};
var faPlaneDeparture = {
  prefix: 'fas',
  iconName: 'plane-departure',
  icon: [640, 512, [], "f5b0", "M624 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM80.55 341.27c6.28 6.84 15.1 10.72 24.33 10.71l130.54-.18a65.62 65.62 0 0 0 29.64-7.12l290.96-147.65c26.74-13.57 50.71-32.94 67.02-58.31 18.31-28.48 20.3-49.09 13.07-63.65-7.21-14.57-24.74-25.27-58.25-27.45-29.85-1.94-59.54 5.92-86.28 19.48l-98.51 49.99-218.7-82.06a17.799 17.799 0 0 0-18-1.11L90.62 67.29c-10.67 5.41-13.25 19.65-5.17 28.53l156.22 98.1-103.21 52.38-72.35-36.47a17.804 17.804 0 0 0-16.07.02L9.91 230.22c-10.44 5.3-13.19 19.12-5.57 28.08l76.21 82.97z"]
};
var faPlaneSlash = {
  prefix: 'fas',
  iconName: 'plane-slash',
  icon: [640, 512, [], "e069", "M32.48,147.88,64,256,32.48,364.13A16,16,0,0,0,48,384H88a16,16,0,0,0,12.8-6.41L144,320H246.85l-49,171.59A16,16,0,0,0,213.2,512h65.5a16,16,0,0,0,13.89-8.06l66.6-116.54L34.35,136.34A15.47,15.47,0,0,0,32.48,147.88ZM633.82,458.09,455.14,320H512c35.34,0,96-28.66,96-64s-60.66-64-96-64H397.7L292.61,8.06C290.06,3.61,283.84,0,278.71,0H213.2a16,16,0,0,0-15.38,20.39l36.94,129.29L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.45A16,16,0,0,0,6.18,53.91L594.54,508.63A16,16,0,0,0,617,505.81l19.64-25.26A16,16,0,0,0,633.82,458.09Z"]
};
var faPlay = {
  prefix: 'fas',
  iconName: 'play',
  icon: [448, 512, [], "f04b", "M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z"]
};
var faPlayCircle = {
  prefix: 'fas',
  iconName: 'play-circle',
  icon: [512, 512, [], "f144", "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm115.7 272l-176 101c-15.8 8.8-35.7-2.5-35.7-21V152c0-18.4 19.8-29.8 35.7-21l176 107c16.4 9.2 16.4 32.9 0 42z"]
};
var faPlug = {
  prefix: 'fas',
  iconName: 'plug',
  icon: [384, 512, [], "f1e6", "M320,32a32,32,0,0,0-64,0v96h64Zm48,128H16A16,16,0,0,0,0,176v32a16,16,0,0,0,16,16H32v32A160.07,160.07,0,0,0,160,412.8V512h64V412.8A160.07,160.07,0,0,0,352,256V224h16a16,16,0,0,0,16-16V176A16,16,0,0,0,368,160ZM128,32a32,32,0,0,0-64,0v96h64Z"]
};
var faPlus = {
  prefix: 'fas',
  iconName: 'plus',
  icon: [448, 512, [], "f067", "M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"]
};
var faPlusCircle = {
  prefix: 'fas',
  iconName: 'plus-circle',
  icon: [512, 512, [], "f055", "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm144 276c0 6.6-5.4 12-12 12h-92v92c0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12v-92h-92c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h92v-92c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v92h92c6.6 0 12 5.4 12 12v56z"]
};
var faPlusSquare = {
  prefix: 'fas',
  iconName: 'plus-square',
  icon: [448, 512, [], "f0fe", "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-32 252c0 6.6-5.4 12-12 12h-92v92c0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12v-92H92c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h92v-92c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v92h92c6.6 0 12 5.4 12 12v56z"]
};
var faPodcast = {
  prefix: 'fas',
  iconName: 'podcast',
  icon: [448, 512, [], "f2ce", "M267.429 488.563C262.286 507.573 242.858 512 224 512c-18.857 0-38.286-4.427-43.428-23.437C172.927 460.134 160 388.898 160 355.75c0-35.156 31.142-43.75 64-43.75s64 8.594 64 43.75c0 32.949-12.871 104.179-20.571 132.813zM156.867 288.554c-18.693-18.308-29.958-44.173-28.784-72.599 2.054-49.724 42.395-89.956 92.124-91.881C274.862 121.958 320 165.807 320 220c0 26.827-11.064 51.116-28.866 68.552-2.675 2.62-2.401 6.986.628 9.187 9.312 6.765 16.46 15.343 21.234 25.363 1.741 3.654 6.497 4.66 9.449 1.891 28.826-27.043 46.553-65.783 45.511-108.565-1.855-76.206-63.595-138.208-139.793-140.369C146.869 73.753 80 139.215 80 220c0 41.361 17.532 78.7 45.55 104.989 2.953 2.771 7.711 1.77 9.453-1.887 4.774-10.021 11.923-18.598 21.235-25.363 3.029-2.2 3.304-6.566.629-9.185zM224 0C100.204 0 0 100.185 0 224c0 89.992 52.602 165.647 125.739 201.408 4.333 2.118 9.267-1.544 8.535-6.31-2.382-15.512-4.342-30.946-5.406-44.339-.146-1.836-1.149-3.486-2.678-4.512-47.4-31.806-78.564-86.016-78.187-147.347.592-96.237 79.29-174.648 175.529-174.899C320.793 47.747 400 126.797 400 224c0 61.932-32.158 116.49-80.65 147.867-.999 14.037-3.069 30.588-5.624 47.23-.732 4.767 4.203 8.429 8.535 6.31C395.227 389.727 448 314.187 448 224 448 100.205 347.815 0 224 0zm0 160c-35.346 0-64 28.654-64 64s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64z"]
};
var faPoll = {
  prefix: 'fas',
  iconName: 'poll',
  icon: [448, 512, [], "f681", "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM160 368c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16V240c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v128zm96 0c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16V144c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v224zm96 0c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-64c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v64z"]
};
var faPollH = {
  prefix: 'fas',
  iconName: 'poll-h',
  icon: [448, 512, [], "f682", "M448 432V80c0-26.5-21.5-48-48-48H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48zM112 192c-8.84 0-16-7.16-16-16v-32c0-8.84 7.16-16 16-16h128c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16H112zm0 96c-8.84 0-16-7.16-16-16v-32c0-8.84 7.16-16 16-16h224c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16H112zm0 96c-8.84 0-16-7.16-16-16v-32c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16h-64z"]
};
var faPoo = {
  prefix: 'fas',
  iconName: 'poo',
  icon: [512, 512, [], "f2fe", "M451.4 369.1C468.7 356 480 335.4 480 312c0-39.8-32.2-72-72-72h-14.1c13.4-11.7 22.1-28.8 22.1-48 0-35.3-28.7-64-64-64h-5.9c3.6-10.1 5.9-20.7 5.9-32 0-53-43-96-96-96-5.2 0-10.2.7-15.1 1.5C250.3 14.6 256 30.6 256 48c0 44.2-35.8 80-80 80h-16c-35.3 0-64 28.7-64 64 0 19.2 8.7 36.3 22.1 48H104c-39.8 0-72 32.2-72 72 0 23.4 11.3 44 28.6 57.1C26.3 374.6 0 404.1 0 440c0 39.8 32.2 72 72 72h368c39.8 0 72-32.2 72-72 0-35.9-26.3-65.4-60.6-70.9zM192 256c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm159.5 139C341 422.9 293 448 256 448s-85-25.1-95.5-53c-2-5.3 2-11 7.8-11h175.4c5.8 0 9.8 5.7 7.8 11zM320 320c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"]
};
var faPooStorm = {
  prefix: 'fas',
  iconName: 'poo-storm',
  icon: [448, 512, [], "f75a", "M308 336h-57.7l17.3-64.9c2-7.6-3.7-15.1-11.6-15.1h-68c-6 0-11.1 4.5-11.9 10.4l-16 120c-1 7.2 4.6 13.6 11.9 13.6h59.3l-23 97.2c-1.8 7.6 4 14.8 11.7 14.8 4.2 0 8.2-2.2 10.4-6l88-152c4.6-8-1.2-18-10.4-18zm66.4-111.3c5.9-9.6 9.6-20.6 9.6-32.7 0-35.3-28.7-64-64-64h-5.9c3.6-10.1 5.9-20.7 5.9-32 0-53-43-96-96-96-5.2 0-10.2.7-15.1 1.5C218.3 14.6 224 30.6 224 48c0 44.2-35.8 80-80 80h-16c-35.3 0-64 28.7-64 64 0 12.1 3.7 23.1 9.6 32.7C32.6 228 0 262.2 0 304c0 44 36 80 80 80h48.3c.1-.6 0-1.2 0-1.8l16-120c3-21.8 21.7-38.2 43.7-38.2h68c13.8 0 26.5 6.3 34.9 17.2s11.2 24.8 7.6 38.1l-6.6 24.7h16c15.7 0 30.3 8.4 38.1 22 7.8 13.6 7.8 30.5 0 44l-8.1 14h30c44 0 80-36 80-80 .1-41.8-32.5-76-73.5-79.3z"]
};
var faPoop = {
  prefix: 'fas',
  iconName: 'poop',
  icon: [512, 512, [], "f619", "M451.36 369.14C468.66 355.99 480 335.41 480 312c0-39.77-32.24-72-72-72h-14.07c13.42-11.73 22.07-28.78 22.07-48 0-35.35-28.65-64-64-64h-5.88c3.57-10.05 5.88-20.72 5.88-32 0-53.02-42.98-96-96-96-5.17 0-10.15.74-15.11 1.52C250.31 14.64 256 30.62 256 48c0 44.18-35.82 80-80 80h-16c-35.35 0-64 28.65-64 64 0 19.22 8.65 36.27 22.07 48H104c-39.76 0-72 32.23-72 72 0 23.41 11.34 43.99 28.64 57.14C26.31 374.62 0 404.12 0 440c0 39.76 32.24 72 72 72h368c39.76 0 72-32.24 72-72 0-35.88-26.31-65.38-60.64-70.86z"]
};
var faPortrait = {
  prefix: 'fas',
  iconName: 'portrait',
  icon: [384, 512, [], "f3e0", "M336 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM192 128c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm112 236.8c0 10.6-10 19.2-22.4 19.2H102.4C90 384 80 375.4 80 364.8v-19.2c0-31.8 30.1-57.6 67.2-57.6h5c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h5c37.1 0 67.2 25.8 67.2 57.6v19.2z"]
};
var faPoundSign = {
  prefix: 'fas',
  iconName: 'pound-sign',
  icon: [320, 512, [], "f154", "M308 352h-45.495c-6.627 0-12 5.373-12 12v50.848H128V288h84c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-84v-63.556c0-32.266 24.562-57.086 61.792-57.086 23.658 0 45.878 11.505 57.652 18.849 5.151 3.213 11.888 2.051 15.688-2.685l28.493-35.513c4.233-5.276 3.279-13.005-2.119-17.081C273.124 54.56 236.576 32 187.931 32 106.026 32 48 84.742 48 157.961V224H20c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h28v128H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h296c6.627 0 12-5.373 12-12V364c0-6.627-5.373-12-12-12z"]
};
var faPowerOff = {
  prefix: 'fas',
  iconName: 'power-off',
  icon: [512, 512, [], "f011", "M400 54.1c63 45 104 118.6 104 201.9 0 136.8-110.8 247.7-247.5 248C120 504.3 8.2 393 8 256.4 7.9 173.1 48.9 99.3 111.8 54.2c11.7-8.3 28-4.8 35 7.7L162.6 90c5.9 10.5 3.1 23.8-6.6 31-41.5 30.8-68 79.6-68 134.9-.1 92.3 74.5 168.1 168 168.1 91.6 0 168.6-74.2 168-169.1-.3-51.8-24.7-101.8-68.1-134-9.7-7.2-12.4-20.5-6.5-30.9l15.8-28.1c7-12.4 23.2-16.1 34.8-7.8zM296 264V24c0-13.3-10.7-24-24-24h-32c-13.3 0-24 10.7-24 24v240c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24z"]
};
var faPray = {
  prefix: 'fas',
  iconName: 'pray',
  icon: [384, 512, [], "f683", "M256 128c35.35 0 64-28.65 64-64S291.35 0 256 0s-64 28.65-64 64 28.65 64 64 64zm-30.63 169.75c14.06 16.72 39 19.09 55.97 5.22l88-72.02c17.09-13.98 19.59-39.19 5.62-56.28-13.97-17.11-39.19-19.59-56.31-5.62l-57.44 47-38.91-46.31c-15.44-18.39-39.22-27.92-64-25.33-24.19 2.48-45.25 16.27-56.37 36.92l-49.37 92.03c-23.4 43.64-8.69 96.37 34.19 123.75L131.56 432H40c-22.09 0-40 17.91-40 40s17.91 40 40 40h208c34.08 0 53.77-42.79 28.28-68.28L166.42 333.86l34.8-64.87 24.15 28.76z"]
};
var faPrayingHands = {
  prefix: 'fas',
  iconName: 'praying-hands',
  icon: [640, 512, [], "f684", "M272 191.91c-17.6 0-32 14.4-32 32v80c0 8.84-7.16 16-16 16s-16-7.16-16-16v-76.55c0-17.39 4.72-34.47 13.69-49.39l77.75-129.59c9.09-15.16 4.19-34.81-10.97-43.91-14.45-8.67-32.72-4.3-42.3 9.21-.2.23-.62.21-.79.48l-117.26 175.9C117.56 205.9 112 224.31 112 243.29v80.23l-90.12 30.04A31.974 31.974 0 0 0 0 383.91v96c0 10.82 8.52 32 32 32 2.69 0 5.41-.34 8.06-1.03l179.19-46.62C269.16 449.99 304 403.8 304 351.91v-128c0-17.6-14.4-32-32-32zm346.12 161.73L528 323.6v-80.23c0-18.98-5.56-37.39-16.12-53.23L394.62 14.25c-.18-.27-.59-.24-.79-.48-9.58-13.51-27.85-17.88-42.3-9.21-15.16 9.09-20.06 28.75-10.97 43.91l77.75 129.59c8.97 14.92 13.69 32 13.69 49.39V304c0 8.84-7.16 16-16 16s-16-7.16-16-16v-80c0-17.6-14.4-32-32-32s-32 14.4-32 32v128c0 51.89 34.84 98.08 84.75 112.34l179.19 46.62c2.66.69 5.38 1.03 8.06 1.03 23.48 0 32-21.18 32-32v-96c0-13.77-8.81-25.99-21.88-30.35z"]
};
var faPrescription = {
  prefix: 'fas',
  iconName: 'prescription',
  icon: [384, 512, [], "f5b1", "M301.26 352l78.06-78.06c6.25-6.25 6.25-16.38 0-22.63l-22.63-22.63c-6.25-6.25-16.38-6.25-22.63 0L256 306.74l-83.96-83.96C219.31 216.8 256 176.89 256 128c0-53.02-42.98-96-96-96H16C7.16 32 0 39.16 0 48v256c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-80h18.75l128 128-78.06 78.06c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0L256 397.25l78.06 78.06c6.25 6.25 16.38 6.25 22.63 0l22.63-22.63c6.25-6.25 6.25-16.38 0-22.63L301.26 352zM64 96h96c17.64 0 32 14.36 32 32s-14.36 32-32 32H64V96z"]
};
var faPrescriptionBottle = {
  prefix: 'fas',
  iconName: 'prescription-bottle',
  icon: [384, 512, [], "f485", "M32 192h120c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H32v64h120c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H32v64h120c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H32v64c0 17.6 14.4 32 32 32h256c17.6 0 32-14.4 32-32V128H32v64zM360 0H24C10.8 0 0 10.8 0 24v48c0 13.2 10.8 24 24 24h336c13.2 0 24-10.8 24-24V24c0-13.2-10.8-24-24-24z"]
};
var faPrescriptionBottleAlt = {
  prefix: 'fas',
  iconName: 'prescription-bottle-alt',
  icon: [384, 512, [], "f486", "M360 0H24C10.8 0 0 10.8 0 24v48c0 13.2 10.8 24 24 24h336c13.2 0 24-10.8 24-24V24c0-13.2-10.8-24-24-24zM32 480c0 17.6 14.4 32 32 32h256c17.6 0 32-14.4 32-32V128H32v352zm64-184c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48z"]
};
var faPrint = {
  prefix: 'fas',
  iconName: 'print',
  icon: [512, 512, [], "f02f", "M448 192V77.25c0-8.49-3.37-16.62-9.37-22.63L393.37 9.37c-6-6-14.14-9.37-22.63-9.37H96C78.33 0 64 14.33 64 32v160c-35.35 0-64 28.65-64 64v112c0 8.84 7.16 16 16 16h48v96c0 17.67 14.33 32 32 32h320c17.67 0 32-14.33 32-32v-96h48c8.84 0 16-7.16 16-16V256c0-35.35-28.65-64-64-64zm-64 256H128v-96h256v96zm0-224H128V64h192v48c0 8.84 7.16 16 16 16h48v96zm48 72c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"]
};
var faProcedures = {
  prefix: 'fas',
  iconName: 'procedures',
  icon: [640, 512, [], "f487", "M528 224H272c-8.8 0-16 7.2-16 16v144H64V144c0-8.8-7.2-16-16-16H16c-8.8 0-16 7.2-16 16v352c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-48h512v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V336c0-61.9-50.1-112-112-112zM136 96h126.1l27.6 55.2c5.9 11.8 22.7 11.8 28.6 0L368 51.8 390.1 96H512c8.8 0 16-7.2 16-16s-7.2-16-16-16H409.9L382.3 8.8C376.4-3 359.6-3 353.7 8.8L304 108.2l-19.9-39.8c-1.4-2.7-4.1-4.4-7.2-4.4H136c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm24 256c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64z"]
};
var faProjectDiagram = {
  prefix: 'fas',
  iconName: 'project-diagram',
  icon: [640, 512, [], "f542", "M384 320H256c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h128c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32zM192 32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v128c0 17.67 14.33 32 32 32h95.72l73.16 128.04C211.98 300.98 232.4 288 256 288h.28L192 175.51V128h224V64H192V32zM608 0H480c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h128c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32z"]
};
var faPumpMedical = {
  prefix: 'fas',
  iconName: 'pump-medical',
  icon: [384, 512, [], "e06a", "M235.51,159.82H84.24A64,64,0,0,0,20.51,218L.14,442a64,64,0,0,0,63.74,69.8h192A64,64,0,0,0,319.61,442L299.24,218A64,64,0,0,0,235.51,159.82Zm4.37,173.33a13.35,13.35,0,0,1-13.34,13.34h-40v40a13.33,13.33,0,0,1-13.33,13.33H146.54a13.33,13.33,0,0,1-13.33-13.33v-40h-40a13.34,13.34,0,0,1-13.33-13.34V306.49a13.33,13.33,0,0,1,13.33-13.34h40v-40a13.33,13.33,0,0,1,13.33-13.33h26.67a13.33,13.33,0,0,1,13.33,13.33v40h40a13.34,13.34,0,0,1,13.34,13.34ZM379.19,93.88,335.87,50.56a64,64,0,0,0-45.24-18.74H223.88a32,32,0,0,0-32-32h-64a32,32,0,0,0-32,32v96h128v-32h66.75l43.31,43.31a16,16,0,0,0,22.63,0l22.62-22.62A16,16,0,0,0,379.19,93.88Z"]
};
var faPumpSoap = {
  prefix: 'fas',
  iconName: 'pump-soap',
  icon: [384, 512, [], "e06b", "M235.63,160H84.37a64,64,0,0,0-63.74,58.21L.27,442.21A64,64,0,0,0,64,512H256a64,64,0,0,0,63.74-69.79l-20.36-224A64,64,0,0,0,235.63,160ZM160,416c-33.12,0-60-26.33-60-58.75,0-25,35.7-75.47,52-97.27A10,10,0,0,1,168,260c16.33,21.8,52,72.27,52,97.27C220,389.67,193.12,416,160,416ZM379.31,94.06,336,50.74A64,64,0,0,0,290.75,32H224A32,32,0,0,0,192,0H128A32,32,0,0,0,96,32v96H224V96h66.75l43.31,43.31a16,16,0,0,0,22.63,0l22.62-22.62A16,16,0,0,0,379.31,94.06Z"]
};
var faPuzzlePiece = {
  prefix: 'fas',
  iconName: 'puzzle-piece',
  icon: [576, 512, [], "f12e", "M519.442 288.651c-41.519 0-59.5 31.593-82.058 31.593C377.409 320.244 432 144 432 144s-196.288 80-196.288-3.297c0-35.827 36.288-46.25 36.288-85.985C272 19.216 243.885 0 210.539 0c-34.654 0-66.366 18.891-66.366 56.346 0 41.364 31.711 59.277 31.711 81.75C175.885 207.719 0 166.758 0 166.758v333.237s178.635 41.047 178.635-28.662c0-22.473-40-40.107-40-81.471 0-37.456 29.25-56.346 63.577-56.346 33.673 0 61.788 19.216 61.788 54.717 0 39.735-36.288 50.158-36.288 85.985 0 60.803 129.675 25.73 181.23 25.73 0 0-34.725-120.101 25.827-120.101 35.962 0 46.423 36.152 86.308 36.152C556.712 416 576 387.99 576 354.443c0-34.199-18.962-65.792-56.558-65.792z"]
};
var faQrcode = {
  prefix: 'fas',
  iconName: 'qrcode',
  icon: [448, 512, [], "f029", "M0 224h192V32H0v192zM64 96h64v64H64V96zm192-64v192h192V32H256zm128 128h-64V96h64v64zM0 480h192V288H0v192zm64-128h64v64H64v-64zm352-64h32v128h-96v-32h-32v96h-64V288h96v32h64v-32zm0 160h32v32h-32v-32zm-64 0h32v32h-32v-32z"]
};
var faQuestion = {
  prefix: 'fas',
  iconName: 'question',
  icon: [384, 512, [], "f128", "M202.021 0C122.202 0 70.503 32.703 29.914 91.026c-7.363 10.58-5.093 25.086 5.178 32.874l43.138 32.709c10.373 7.865 25.132 6.026 33.253-4.148 25.049-31.381 43.63-49.449 82.757-49.449 30.764 0 68.816 19.799 68.816 49.631 0 22.552-18.617 34.134-48.993 51.164-35.423 19.86-82.299 44.576-82.299 106.405V320c0 13.255 10.745 24 24 24h72.471c13.255 0 24-10.745 24-24v-5.773c0-42.86 125.268-44.645 125.268-160.627C377.504 66.256 286.902 0 202.021 0zM192 373.459c-38.196 0-69.271 31.075-69.271 69.271 0 38.195 31.075 69.27 69.271 69.27s69.271-31.075 69.271-69.271-31.075-69.27-69.271-69.27z"]
};
var faQuestionCircle = {
  prefix: 'fas',
  iconName: 'question-circle',
  icon: [512, 512, [], "f059", "M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248 111.083 248 248zM262.655 90c-54.497 0-89.255 22.957-116.549 63.758-3.536 5.286-2.353 12.415 2.715 16.258l34.699 26.31c5.205 3.947 12.621 3.008 16.665-2.122 17.864-22.658 30.113-35.797 57.303-35.797 20.429 0 45.698 13.148 45.698 32.958 0 14.976-12.363 22.667-32.534 33.976C247.128 238.528 216 254.941 216 296v4c0 6.627 5.373 12 12 12h56c6.627 0 12-5.373 12-12v-1.333c0-28.462 83.186-29.647 83.186-106.667 0-58.002-60.165-102-116.531-102zM256 338c-25.365 0-46 20.635-46 46 0 25.364 20.635 46 46 46s46-20.636 46-46c0-25.365-20.635-46-46-46z"]
};
var faQuidditch = {
  prefix: 'fas',
  iconName: 'quidditch',
  icon: [640, 512, [], "f458", "M256.5 216.8L343.2 326s-16.6 102.4-76.6 150.1C206.7 523.8 0 510.2 0 510.2s3.8-23.1 11-55.4l94.6-112.2c4-4.7-.9-11.6-6.6-9.5l-60.4 22.1c14.4-41.7 32.7-80 54.6-97.5 59.9-47.8 163.3-40.9 163.3-40.9zm238 135c-44 0-79.8 35.8-79.8 79.9 0 44.1 35.7 79.9 79.8 79.9 44.1 0 79.8-35.8 79.8-79.9 0-44.2-35.8-79.9-79.8-79.9zM636.5 31L616.7 6c-5.5-6.9-15.5-8-22.4-2.6L361.8 181.3l-34.1-43c-5.1-6.4-15.1-5.2-18.6 2.2l-25.3 54.6 86.7 109.2 58.8-12.4c8-1.7 11.4-11.2 6.3-17.6l-34.1-42.9L634 53.5c6.9-5.5 8-15.6 2.5-22.5z"]
};
var faQuoteLeft = {
  prefix: 'fas',
  iconName: 'quote-left',
  icon: [512, 512, [], "f10d", "M464 256h-80v-64c0-35.3 28.7-64 64-64h8c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24h-8c-88.4 0-160 71.6-160 160v240c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48zm-288 0H96v-64c0-35.3 28.7-64 64-64h8c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24h-8C71.6 32 0 103.6 0 192v240c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48z"]
};
var faQuoteRight = {
  prefix: 'fas',
  iconName: 'quote-right',
  icon: [512, 512, [], "f10e", "M464 32H336c-26.5 0-48 21.5-48 48v128c0 26.5 21.5 48 48 48h80v64c0 35.3-28.7 64-64 64h-8c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h8c88.4 0 160-71.6 160-160V80c0-26.5-21.5-48-48-48zm-288 0H48C21.5 32 0 53.5 0 80v128c0 26.5 21.5 48 48 48h80v64c0 35.3-28.7 64-64 64h-8c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h8c88.4 0 160-71.6 160-160V80c0-26.5-21.5-48-48-48z"]
};
var faQuran = {
  prefix: 'fas',
  iconName: 'quran',
  icon: [448, 512, [], "f687", "M448 358.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16c0-6.4-3.2-12.8-9.6-19.2-3.2-16-3.2-60.8 0-73.6 6.4-3.2 9.6-9.6 9.6-19.2zM301.08 145.82c.6-1.21 1.76-1.82 2.92-1.82s2.32.61 2.92 1.82l11.18 22.65 25 3.63c2.67.39 3.74 3.67 1.81 5.56l-18.09 17.63 4.27 24.89c.36 2.11-1.31 3.82-3.21 3.82-.5 0-1.02-.12-1.52-.38L304 211.87l-22.36 11.75c-.5.26-1.02.38-1.52.38-1.9 0-3.57-1.71-3.21-3.82l4.27-24.89-18.09-17.63c-1.94-1.89-.87-5.17 1.81-5.56l24.99-3.63 11.19-22.65zm-57.89-69.01c13.67 0 27.26 2.49 40.38 7.41a6.775 6.775 0 1 1-2.38 13.12c-.67 0-3.09-.21-4.13-.21-52.31 0-94.86 42.55-94.86 94.86 0 52.3 42.55 94.86 94.86 94.86 1.03 0 3.48-.21 4.13-.21 3.93 0 6.8 3.14 6.8 6.78 0 2.98-1.94 5.51-4.62 6.42-13.07 4.87-26.59 7.34-40.19 7.34C179.67 307.19 128 255.51 128 192c0-63.52 51.67-115.19 115.19-115.19zM380.8 448H96c-19.2 0-32-12.8-32-32s16-32 32-32h284.8v64z"]
};
var faRadiation = {
  prefix: 'fas',
  iconName: 'radiation',
  icon: [496, 512, [], "f7b9", "M328.2 255.8h151.6c9.1 0 16.8-7.7 16.2-16.8-5.1-75.8-44.4-142.2-102.5-184.2-7.4-5.3-17.9-2.9-22.7 4.8L290.4 188c22.6 14.3 37.8 39.2 37.8 67.8zm-37.8 67.7c-12.3 7.7-26.8 12.4-42.4 12.4-15.6 0-30-4.7-42.4-12.4L125.2 452c-4.8 7.7-2.4 18.1 5.6 22.4C165.7 493.2 205.6 504 248 504s82.3-10.8 117.2-29.6c8-4.3 10.4-14.8 5.6-22.4l-80.4-128.5zM248 303.8c26.5 0 48-21.5 48-48s-21.5-48-48-48-48 21.5-48 48 21.5 48 48 48zm-231.8-48h151.6c0-28.6 15.2-53.5 37.8-67.7L125.2 59.7c-4.8-7.7-15.3-10.2-22.7-4.8C44.4 96.9 5.1 163.3 0 239.1c-.6 9 7.1 16.7 16.2 16.7z"]
};
var faRadiationAlt = {
  prefix: 'fas',
  iconName: 'radiation-alt',
  icon: [496, 512, [], "f7ba", "M312 256h79.1c9.2 0 16.9-7.7 16-16.8-4.6-43.6-27-81.8-59.5-107.8-7.6-6.1-18.8-4.5-24 3.8L281.9 202c18 11.2 30.1 31.2 30.1 54zm-97.8 54.1L172.4 377c-4.9 7.8-2.4 18.4 5.8 22.5 21.1 10.4 44.7 16.5 69.8 16.5s48.7-6.1 69.9-16.5c8.2-4.1 10.6-14.7 5.8-22.5l-41.8-66.9c-9.8 6.2-21.4 9.9-33.8 9.9s-24.1-3.7-33.9-9.9zM104.9 256H184c0-22.8 12.1-42.8 30.2-54.1l-41.7-66.8c-5.2-8.3-16.4-9.9-24-3.8-32.6 26-54.9 64.2-59.5 107.8-1.1 9.2 6.7 16.9 15.9 16.9zM248 504c137 0 248-111 248-248S385 8 248 8 0 119 0 256s111 248 248 248zm0-432c101.5 0 184 82.5 184 184s-82.5 184-184 184S64 357.5 64 256 146.5 72 248 72zm0 216c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32z"]
};
var faRainbow = {
  prefix: 'fas',
  iconName: 'rainbow',
  icon: [576, 512, [], "f75b", "M268.3 32.7C115.4 42.9 0 176.9 0 330.2V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320C64 186.8 180.9 80.3 317.5 97.9 430.4 112.4 512 214 512 327.8V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-165.3-140-298.6-307.7-287.3zm-5.6 96.9C166 142 96 229.1 96 326.7V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-74.8 64.5-134.8 140.8-127.4 66.5 6.5 115.2 66.2 115.2 133.1V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-114.2-100.2-205.4-217.3-190.4zm6.2 96.3c-45.6 8.9-76.9 51.5-76.9 97.9V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-17.6 14.3-32 32-32s32 14.4 32 32v144c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-59.2-53.8-106-115.1-94.1z"]
};
var faRandom = {
  prefix: 'fas',
  iconName: 'random',
  icon: [512, 512, [], "f074", "M504.971 359.029c9.373 9.373 9.373 24.569 0 33.941l-80 79.984c-15.01 15.01-40.971 4.49-40.971-16.971V416h-58.785a12.004 12.004 0 0 1-8.773-3.812l-70.556-75.596 53.333-57.143L352 336h32v-39.981c0-21.438 25.943-31.998 40.971-16.971l80 79.981zM12 176h84l52.781 56.551 53.333-57.143-70.556-75.596A11.999 11.999 0 0 0 122.785 96H12c-6.627 0-12 5.373-12 12v56c0 6.627 5.373 12 12 12zm372 0v39.984c0 21.46 25.961 31.98 40.971 16.971l80-79.984c9.373-9.373 9.373-24.569 0-33.941l-80-79.981C409.943 24.021 384 34.582 384 56.019V96h-58.785a12.004 12.004 0 0 0-8.773 3.812L96 336H12c-6.627 0-12 5.373-12 12v56c0 6.627 5.373 12 12 12h110.785c3.326 0 6.503-1.381 8.773-3.812L352 176h32z"]
};
var faReceipt = {
  prefix: 'fas',
  iconName: 'receipt',
  icon: [384, 512, [], "f543", "M358.4 3.2L320 48 265.6 3.2a15.9 15.9 0 0 0-19.2 0L192 48 137.6 3.2a15.9 15.9 0 0 0-19.2 0L64 48 25.6 3.2C15-4.7 0 2.8 0 16v480c0 13.2 15 20.7 25.6 12.8L64 464l54.4 44.8a15.9 15.9 0 0 0 19.2 0L192 464l54.4 44.8a15.9 15.9 0 0 0 19.2 0L320 464l38.4 44.8c10.5 7.9 25.6.4 25.6-12.8V16c0-13.2-15-20.7-25.6-12.8zM320 360c0 4.4-3.6 8-8 8H72c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h240c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H72c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h240c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H72c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h240c4.4 0 8 3.6 8 8v16z"]
};
var faRecordVinyl = {
  prefix: 'fas',
  iconName: 'record-vinyl',
  icon: [512, 512, [], "f8d9", "M256 152a104 104 0 1 0 104 104 104 104 0 0 0-104-104zm0 128a24 24 0 1 1 24-24 24 24 0 0 1-24 24zm0-272C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 376a128 128 0 1 1 128-128 128 128 0 0 1-128 128z"]
};
var faRecycle = {
  prefix: 'fas',
  iconName: 'recycle',
  icon: [512, 512, [], "f1b8", "M184.561 261.903c3.232 13.997-12.123 24.635-24.068 17.168l-40.736-25.455-50.867 81.402C55.606 356.273 70.96 384 96.012 384H148c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12H96.115c-75.334 0-121.302-83.048-81.408-146.88l50.822-81.388-40.725-25.448c-12.081-7.547-8.966-25.961 4.879-29.158l110.237-25.45c8.611-1.988 17.201 3.381 19.189 11.99l25.452 110.237zm98.561-182.915l41.289 66.076-40.74 25.457c-12.051 7.528-9 25.953 4.879 29.158l110.237 25.45c8.672 1.999 17.215-3.438 19.189-11.99l25.45-110.237c3.197-13.844-11.99-24.719-24.068-17.168l-40.687 25.424-41.263-66.082c-37.521-60.033-125.209-60.171-162.816 0l-17.963 28.766c-3.51 5.62-1.8 13.021 3.82 16.533l33.919 21.195c5.62 3.512 13.024 1.803 16.536-3.817l17.961-28.743c12.712-20.341 41.973-19.676 54.257-.022zM497.288 301.12l-27.515-44.065c-3.511-5.623-10.916-7.334-16.538-3.821l-33.861 21.159c-5.62 3.512-7.33 10.915-3.818 16.536l27.564 44.112c13.257 21.211-2.057 48.96-27.136 48.96H320V336.02c0-14.213-17.242-21.383-27.313-11.313l-80 79.981c-6.249 6.248-6.249 16.379 0 22.627l80 79.989C302.689 517.308 320 510.3 320 495.989V448h95.88c75.274 0 121.335-82.997 81.408-146.88z"]
};
var faRedo = {
  prefix: 'fas',
  iconName: 'redo',
  icon: [512, 512, [], "f01e", "M500.33 0h-47.41a12 12 0 0 0-12 12.57l4 82.76A247.42 247.42 0 0 0 256 8C119.34 8 7.9 119.53 8 256.19 8.1 393.07 119.1 504 256 504a247.1 247.1 0 0 0 166.18-63.91 12 12 0 0 0 .48-17.43l-34-34a12 12 0 0 0-16.38-.55A176 176 0 1 1 402.1 157.8l-101.53-4.87a12 12 0 0 0-12.57 12v47.41a12 12 0 0 0 12 12h200.33a12 12 0 0 0 12-12V12a12 12 0 0 0-12-12z"]
};
var faRedoAlt = {
  prefix: 'fas',
  iconName: 'redo-alt',
  icon: [512, 512, [], "f2f9", "M256.455 8c66.269.119 126.437 26.233 170.859 68.685l35.715-35.715C478.149 25.851 504 36.559 504 57.941V192c0 13.255-10.745 24-24 24H345.941c-21.382 0-32.09-25.851-16.971-40.971l41.75-41.75c-30.864-28.899-70.801-44.907-113.23-45.273-92.398-.798-170.283 73.977-169.484 169.442C88.764 348.009 162.184 424 256 424c41.127 0 79.997-14.678 110.629-41.556 4.743-4.161 11.906-3.908 16.368.553l39.662 39.662c4.872 4.872 4.631 12.815-.482 17.433C378.202 479.813 319.926 504 256 504 119.034 504 8.001 392.967 8 256.002 7.999 119.193 119.646 7.755 256.455 8z"]
};
var faRegistered = {
  prefix: 'fas',
  iconName: 'registered',
  icon: [512, 512, [], "f25d", "M285.363 207.475c0 18.6-9.831 28.431-28.431 28.431h-29.876v-56.14h23.378c28.668 0 34.929 8.773 34.929 27.709zM504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM363.411 360.414c-46.729-84.825-43.299-78.636-44.702-80.98 23.432-15.172 37.945-42.979 37.945-74.486 0-54.244-31.5-89.252-105.498-89.252h-70.667c-13.255 0-24 10.745-24 24V372c0 13.255 10.745 24 24 24h22.567c13.255 0 24-10.745 24-24v-71.663h25.556l44.129 82.937a24.001 24.001 0 0 0 21.188 12.727h24.464c18.261-.001 29.829-19.591 21.018-35.587z"]
};
var faRemoveFormat = {
  prefix: 'fas',
  iconName: 'remove-format',
  icon: [640, 512, [], "f87d", "M336 416h-11.17l9.26-27.77L267 336.4 240.49 416H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm297.82 42.1L377 259.59 426.17 112H544v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16H176a16 16 0 0 0-16 16v43.9L45.46 3.38A16 16 0 0 0 23 6.19L3.37 31.46a16 16 0 0 0 2.81 22.45l588.36 454.72a16 16 0 0 0 22.46-2.81l19.64-25.27a16 16 0 0 0-2.82-22.45zM309.91 207.76L224 141.36V112h117.83z"]
};
var faReply = {
  prefix: 'fas',
  iconName: 'reply',
  icon: [512, 512, [], "f3e5", "M8.309 189.836L184.313 37.851C199.719 24.546 224 35.347 224 56.015v80.053c160.629 1.839 288 34.032 288 186.258 0 61.441-39.581 122.309-83.333 154.132-13.653 9.931-33.111-2.533-28.077-18.631 45.344-145.012-21.507-183.51-176.59-185.742V360c0 20.7-24.3 31.453-39.687 18.164l-176.004-152c-11.071-9.562-11.086-26.753 0-36.328z"]
};
var faReplyAll = {
  prefix: 'fas',
  iconName: 'reply-all',
  icon: [576, 512, [], "f122", "M136.309 189.836L312.313 37.851C327.72 24.546 352 35.348 352 56.015v82.763c129.182 10.231 224 52.212 224 183.548 0 61.441-39.582 122.309-83.333 154.132-13.653 9.931-33.111-2.533-28.077-18.631 38.512-123.162-3.922-169.482-112.59-182.015v84.175c0 20.701-24.3 31.453-39.687 18.164L136.309 226.164c-11.071-9.561-11.086-26.753 0-36.328zm-128 36.328L184.313 378.15C199.7 391.439 224 380.687 224 359.986v-15.818l-108.606-93.785A55.96 55.96 0 0 1 96 207.998a55.953 55.953 0 0 1 19.393-42.38L224 71.832V56.015c0-20.667-24.28-31.469-39.687-18.164L8.309 189.836c-11.086 9.575-11.071 26.767 0 36.328z"]
};
var faRepublican = {
  prefix: 'fas',
  iconName: 'republican',
  icon: [640, 512, [], "f75e", "M544 192c0-88.4-71.6-160-160-160H160C71.6 32 0 103.6 0 192v64h544v-64zm-367.7-21.6l-19.8 19.3 4.7 27.3c.8 4.9-4.3 8.6-8.7 6.3L128 210.4l-24.5 12.9c-4.3 2.3-9.5-1.4-8.7-6.3l4.7-27.3-19.8-19.3c-3.6-3.5-1.6-9.5 3.3-10.2l27.4-4 12.2-24.8c2.2-4.5 8.6-4.4 10.7 0l12.2 24.8 27.4 4c5 .7 6.9 6.7 3.4 10.2zm144 0l-19.8 19.3 4.7 27.3c.8 4.9-4.3 8.6-8.7 6.3L272 210.4l-24.5 12.9c-4.3 2.3-9.5-1.4-8.7-6.3l4.7-27.3-19.8-19.3c-3.6-3.5-1.6-9.5 3.3-10.2l27.4-4 12.2-24.8c2.2-4.5 8.6-4.4 10.7 0l12.2 24.8 27.4 4c5 .7 6.9 6.7 3.4 10.2zm144 0l-19.8 19.3 4.7 27.3c.8 4.9-4.3 8.6-8.7 6.3L416 210.4l-24.5 12.9c-4.3 2.3-9.5-1.4-8.7-6.3l4.7-27.3-19.8-19.3c-3.6-3.5-1.6-9.5 3.3-10.2l27.4-4 12.2-24.8c2.2-4.5 8.6-4.4 10.7 0l12.2 24.8 27.4 4c5 .7 6.9 6.7 3.4 10.2zM624 320h-32c-8.8 0-16 7.2-16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V288H0v176c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16v-80h192v80c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V352h32v43.3c0 41.8 30 80.1 71.6 84.3 47.8 4.9 88.4-32.7 88.4-79.6v-64c0-8.8-7.2-16-16-16z"]
};
var faRestroom = {
  prefix: 'fas',
  iconName: 'restroom',
  icon: [640, 512, [], "f7bd", "M128 128c35.3 0 64-28.7 64-64S163.3 0 128 0 64 28.7 64 64s28.7 64 64 64zm384 0c35.3 0 64-28.7 64-64S547.3 0 512 0s-64 28.7-64 64 28.7 64 64 64zm127.3 226.5l-45.6-185.8c-3.3-13.5-15.5-23-29.8-24.2-15 9.7-32.8 15.5-52 15.5-19.2 0-37-5.8-52-15.5-14.3 1.2-26.5 10.7-29.8 24.2l-45.6 185.8C381 369.6 393 384 409.2 384H464v104c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V384h54.8c16.2 0 28.2-14.4 24.5-29.5zM336 0h-32c-8.8 0-16 7.2-16 16v480c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16zM180.1 144.4c-15 9.8-32.9 15.6-52.1 15.6-19.2 0-37.1-5.8-52.1-15.6C51.3 146.5 32 166.9 32 192v136c0 13.3 10.7 24 24 24h8v136c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V352h8c13.3 0 24-10.7 24-24V192c0-25.1-19.3-45.5-43.9-47.6z"]
};
var faRetweet = {
  prefix: 'fas',
  iconName: 'retweet',
  icon: [640, 512, [], "f079", "M629.657 343.598L528.971 444.284c-9.373 9.372-24.568 9.372-33.941 0L394.343 343.598c-9.373-9.373-9.373-24.569 0-33.941l10.823-10.823c9.562-9.562 25.133-9.34 34.419.492L480 342.118V160H292.451a24.005 24.005 0 0 1-16.971-7.029l-16-16C244.361 121.851 255.069 96 276.451 96H520c13.255 0 24 10.745 24 24v222.118l40.416-42.792c9.285-9.831 24.856-10.054 34.419-.492l10.823 10.823c9.372 9.372 9.372 24.569-.001 33.941zm-265.138 15.431A23.999 23.999 0 0 0 347.548 352H160V169.881l40.416 42.792c9.286 9.831 24.856 10.054 34.419.491l10.822-10.822c9.373-9.373 9.373-24.569 0-33.941L144.971 67.716c-9.373-9.373-24.569-9.373-33.941 0L10.343 168.402c-9.373 9.373-9.373 24.569 0 33.941l10.822 10.822c9.562 9.562 25.133 9.34 34.419-.491L96 169.881V392c0 13.255 10.745 24 24 24h243.549c21.382 0 32.09-25.851 16.971-40.971l-16.001-16z"]
};
var faRibbon = {
  prefix: 'fas',
  iconName: 'ribbon',
  icon: [448, 512, [], "f4d6", "M6.1 444.3c-9.6 10.8-7.5 27.6 4.5 35.7l68.8 27.9c9.9 6.7 23.3 5 31.3-3.8l91.8-101.9-79.2-87.9-117.2 130zm435.8 0s-292-324.6-295.4-330.1c15.4-8.4 40.2-17.9 77.5-17.9s62.1 9.5 77.5 17.9c-3.3 5.6-56 64.6-56 64.6l79.1 87.7 34.2-38c28.7-31.9 33.3-78.6 11.4-115.5l-43.7-73.5c-4.3-7.2-9.9-13.3-16.8-18-40.7-27.6-127.4-29.7-171.4 0-6.9 4.7-12.5 10.8-16.8 18l-43.6 73.2c-1.5 2.5-37.1 62.2 11.5 116L337.5 504c8 8.9 21.4 10.5 31.3 3.8l68.8-27.9c11.9-8 14-24.8 4.3-35.6z"]
};
var faRing = {
  prefix: 'fas',
  iconName: 'ring',
  icon: [512, 512, [], "f70b", "M256 64C110.06 64 0 125.91 0 208v98.13C0 384.48 114.62 448 256 448s256-63.52 256-141.87V208c0-82.09-110.06-144-256-144zm0 64c106.04 0 192 35.82 192 80 0 9.26-3.97 18.12-10.91 26.39C392.15 208.21 328.23 192 256 192s-136.15 16.21-181.09 42.39C67.97 226.12 64 217.26 64 208c0-44.18 85.96-80 192-80zM120.43 264.64C155.04 249.93 201.64 240 256 240s100.96 9.93 135.57 24.64C356.84 279.07 308.93 288 256 288s-100.84-8.93-135.57-23.36z"]
};
var faRoad = {
  prefix: 'fas',
  iconName: 'road',
  icon: [576, 512, [], "f018", "M573.19 402.67l-139.79-320C428.43 71.29 417.6 64 405.68 64h-97.59l2.45 23.16c.5 4.72-3.21 8.84-7.96 8.84h-29.16c-4.75 0-8.46-4.12-7.96-8.84L267.91 64h-97.59c-11.93 0-22.76 7.29-27.73 18.67L2.8 402.67C-6.45 423.86 8.31 448 30.54 448h196.84l10.31-97.68c.86-8.14 7.72-14.32 15.91-14.32h68.8c8.19 0 15.05 6.18 15.91 14.32L348.62 448h196.84c22.23 0 36.99-24.14 27.73-45.33zM260.4 135.16a8 8 0 0 1 7.96-7.16h39.29c4.09 0 7.53 3.09 7.96 7.16l4.6 43.58c.75 7.09-4.81 13.26-11.93 13.26h-40.54c-7.13 0-12.68-6.17-11.93-13.26l4.59-43.58zM315.64 304h-55.29c-9.5 0-16.91-8.23-15.91-17.68l5.07-48c.86-8.14 7.72-14.32 15.91-14.32h45.15c8.19 0 15.05 6.18 15.91 14.32l5.07 48c1 9.45-6.41 17.68-15.91 17.68z"]
};
var faRobot = {
  prefix: 'fas',
  iconName: 'robot',
  icon: [640, 512, [], "f544", "M32,224H64V416H32A31.96166,31.96166,0,0,1,0,384V256A31.96166,31.96166,0,0,1,32,224Zm512-48V448a64.06328,64.06328,0,0,1-64,64H160a64.06328,64.06328,0,0,1-64-64V176a79.974,79.974,0,0,1,80-80H288V32a32,32,0,0,1,64,0V96H464A79.974,79.974,0,0,1,544,176ZM264,256a40,40,0,1,0-40,40A39.997,39.997,0,0,0,264,256Zm-8,128H192v32h64Zm96,0H288v32h64ZM456,256a40,40,0,1,0-40,40A39.997,39.997,0,0,0,456,256Zm-8,128H384v32h64ZM640,256V384a31.96166,31.96166,0,0,1-32,32H576V224h32A31.96166,31.96166,0,0,1,640,256Z"]
};
var faRocket = {
  prefix: 'fas',
  iconName: 'rocket',
  icon: [512, 512, [], "f135", "M505.12019,19.09375c-1.18945-5.53125-6.65819-11-12.207-12.1875C460.716,0,435.507,0,410.40747,0,307.17523,0,245.26909,55.20312,199.05238,128H94.83772c-16.34763.01562-35.55658,11.875-42.88664,26.48438L2.51562,253.29688A28.4,28.4,0,0,0,0,264a24.00867,24.00867,0,0,0,24.00582,24H127.81618l-22.47457,22.46875c-11.36521,11.36133-12.99607,32.25781,0,45.25L156.24582,406.625c11.15623,11.1875,32.15619,13.15625,45.27726,0l22.47457-22.46875V488a24.00867,24.00867,0,0,0,24.00581,24,28.55934,28.55934,0,0,0,10.707-2.51562l98.72834-49.39063c14.62888-7.29687,26.50776-26.5,26.50776-42.85937V312.79688c72.59753-46.3125,128.03493-108.40626,128.03493-211.09376C512.07526,76.5,512.07526,51.29688,505.12019,19.09375ZM384.04033,168A40,40,0,1,1,424.05,128,40.02322,40.02322,0,0,1,384.04033,168Z"]
};
var faRoute = {
  prefix: 'fas',
  iconName: 'route',
  icon: [512, 512, [], "f4d7", "M416 320h-96c-17.6 0-32-14.4-32-32s14.4-32 32-32h96s96-107 96-160-43-96-96-96-96 43-96 96c0 25.5 22.2 63.4 45.3 96H320c-52.9 0-96 43.1-96 96s43.1 96 96 96h96c17.6 0 32 14.4 32 32s-14.4 32-32 32H185.5c-16 24.8-33.8 47.7-47.3 64H416c52.9 0 96-43.1 96-96s-43.1-96-96-96zm0-256c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zM96 256c-53 0-96 43-96 96s96 160 96 160 96-107 96-160-43-96-96-96zm0 128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"]
};
var faRss = {
  prefix: 'fas',
  iconName: 'rss',
  icon: [448, 512, [], "f09e", "M128.081 415.959c0 35.369-28.672 64.041-64.041 64.041S0 451.328 0 415.959s28.672-64.041 64.041-64.041 64.04 28.673 64.04 64.041zm175.66 47.25c-8.354-154.6-132.185-278.587-286.95-286.95C7.656 175.765 0 183.105 0 192.253v48.069c0 8.415 6.49 15.472 14.887 16.018 111.832 7.284 201.473 96.702 208.772 208.772.547 8.397 7.604 14.887 16.018 14.887h48.069c9.149.001 16.489-7.655 15.995-16.79zm144.249.288C439.596 229.677 251.465 40.445 16.503 32.01 7.473 31.686 0 38.981 0 48.016v48.068c0 8.625 6.835 15.645 15.453 15.999 191.179 7.839 344.627 161.316 352.465 352.465.353 8.618 7.373 15.453 15.999 15.453h48.068c9.034-.001 16.329-7.474 16.005-16.504z"]
};
var faRssSquare = {
  prefix: 'fas',
  iconName: 'rss-square',
  icon: [448, 512, [], "f143", "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM112 416c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm157.533 0h-34.335c-6.011 0-11.051-4.636-11.442-10.634-5.214-80.05-69.243-143.92-149.123-149.123-5.997-.39-10.633-5.431-10.633-11.441v-34.335c0-6.535 5.468-11.777 11.994-11.425 110.546 5.974 198.997 94.536 204.964 204.964.352 6.526-4.89 11.994-11.425 11.994zm103.027 0h-34.334c-6.161 0-11.175-4.882-11.427-11.038-5.598-136.535-115.204-246.161-251.76-251.76C68.882 152.949 64 147.935 64 141.774V107.44c0-6.454 5.338-11.664 11.787-11.432 167.83 6.025 302.21 141.191 308.205 308.205.232 6.449-4.978 11.787-11.432 11.787z"]
};
var faRubleSign = {
  prefix: 'fas',
  iconName: 'ruble-sign',
  icon: [384, 512, [], "f158", "M239.36 320C324.48 320 384 260.542 384 175.071S324.48 32 239.36 32H76c-6.627 0-12 5.373-12 12v206.632H12c-6.627 0-12 5.373-12 12V308c0 6.627 5.373 12 12 12h52v32H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h52v52c0 6.627 5.373 12 12 12h58.56c6.627 0 12-5.373 12-12v-52H308c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12H146.56v-32h92.8zm-92.8-219.252h78.72c46.72 0 74.88 29.11 74.88 74.323 0 45.832-28.16 75.561-76.16 75.561h-77.44V100.748z"]
};
var faRuler = {
  prefix: 'fas',
  iconName: 'ruler',
  icon: [640, 512, [], "f545", "M635.7 167.2L556.1 31.7c-8.8-15-28.3-20.1-43.5-11.5l-69 39.1L503.3 161c2.2 3.8.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9L416 75l-55.2 31.3 27.9 47.4c2.2 3.8.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9L333.2 122 278 153.3 337.8 255c2.2 3.7.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9l-59.7-101.7-55.2 31.3 27.9 47.4c2.2 3.8.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9l-27.9-47.5-55.2 31.3 59.7 101.7c2.2 3.7.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9L84.9 262.9l-69 39.1C.7 310.7-4.6 329.8 4.2 344.8l79.6 135.6c8.8 15 28.3 20.1 43.5 11.5L624.1 210c15.2-8.6 20.4-27.8 11.6-42.8z"]
};
var faRulerCombined = {
  prefix: 'fas',
  iconName: 'ruler-combined',
  icon: [512, 512, [], "f546", "M160 288h-56c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h56v-64h-56c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h56V96h-56c-4.42 0-8-3.58-8-8V72c0-4.42 3.58-8 8-8h56V32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v448c0 2.77.91 5.24 1.57 7.8L160 329.38V288zm320 64h-32v56c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-56h-64v56c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-56h-64v56c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-56h-41.37L24.2 510.43c2.56.66 5.04 1.57 7.8 1.57h448c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32z"]
};
var faRulerHorizontal = {
  prefix: 'fas',
  iconName: 'ruler-horizontal',
  icon: [576, 512, [], "f547", "M544 128h-48v88c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-88h-64v88c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-88h-64v88c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-88h-64v88c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-88h-64v88c0 4.42-3.58 8-8 8H88c-4.42 0-8-3.58-8-8v-88H32c-17.67 0-32 14.33-32 32v192c0 17.67 14.33 32 32 32h512c17.67 0 32-14.33 32-32V160c0-17.67-14.33-32-32-32z"]
};
var faRulerVertical = {
  prefix: 'fas',
  iconName: 'ruler-vertical',
  icon: [256, 512, [], "f548", "M168 416c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h88v-64h-88c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h88v-64h-88c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h88v-64h-88c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h88V32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v448c0 17.67 14.33 32 32 32h192c17.67 0 32-14.33 32-32v-64h-88z"]
};
var faRunning = {
  prefix: 'fas',
  iconName: 'running',
  icon: [416, 512, [], "f70c", "M272 96c26.51 0 48-21.49 48-48S298.51 0 272 0s-48 21.49-48 48 21.49 48 48 48zM113.69 317.47l-14.8 34.52H32c-17.67 0-32 14.33-32 32s14.33 32 32 32h77.45c19.25 0 36.58-11.44 44.11-29.09l8.79-20.52-10.67-6.3c-17.32-10.23-30.06-25.37-37.99-42.61zM384 223.99h-44.03l-26.06-53.25c-12.5-25.55-35.45-44.23-61.78-50.94l-71.08-21.14c-28.3-6.8-57.77-.55-80.84 17.14l-39.67 30.41c-14.03 10.75-16.69 30.83-5.92 44.86s30.84 16.66 44.86 5.92l39.69-30.41c7.67-5.89 17.44-8 25.27-6.14l14.7 4.37-37.46 87.39c-12.62 29.48-1.31 64.01 26.3 80.31l84.98 50.17-27.47 87.73c-5.28 16.86 4.11 34.81 20.97 40.09 3.19 1 6.41 1.48 9.58 1.48 13.61 0 26.23-8.77 30.52-22.45l31.64-101.06c5.91-20.77-2.89-43.08-21.64-54.39l-61.24-36.14 31.31-78.28 20.27 41.43c8 16.34 24.92 26.89 43.11 26.89H384c17.67 0 32-14.33 32-32s-14.33-31.99-32-31.99z"]
};
var faRupeeSign = {
  prefix: 'fas',
  iconName: 'rupee-sign',
  icon: [320, 512, [], "f156", "M308 96c6.627 0 12-5.373 12-12V44c0-6.627-5.373-12-12-12H12C5.373 32 0 37.373 0 44v44.748c0 6.627 5.373 12 12 12h85.28c27.308 0 48.261 9.958 60.97 27.252H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h158.757c-6.217 36.086-32.961 58.632-74.757 58.632H12c-6.627 0-12 5.373-12 12v53.012c0 3.349 1.4 6.546 3.861 8.818l165.052 152.356a12.001 12.001 0 0 0 8.139 3.182h82.562c10.924 0 16.166-13.408 8.139-20.818L116.871 319.906c76.499-2.34 131.144-53.395 138.318-127.906H308c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-58.69c-3.486-11.541-8.28-22.246-14.252-32H308z"]
};
var faSadCry = {
  prefix: 'fas',
  iconName: 'sad-cry',
  icon: [496, 512, [], "f5b3", "M248 8C111 8 0 119 0 256c0 90.1 48.2 168.7 120 212.1V288c0-8.8 7.2-16 16-16s16 7.2 16 16v196.7c29.5 12.4 62 19.3 96 19.3s66.5-6.9 96-19.3V288c0-8.8 7.2-16 16-16s16 7.2 16 16v180.1C447.8 424.7 496 346 496 256 496 119 385 8 248 8zm-65.5 216.5c-14.8-13.2-46.2-13.2-61 0L112 233c-3.8 3.3-9.3 4-13.7 1.6-4.4-2.4-6.9-7.4-6.1-12.4 4-25.2 34.2-42.1 59.9-42.1S208 197 212 222.2c.8 5-1.7 10-6.1 12.4-5.8 3.1-11.2.7-13.7-1.6l-9.7-8.5zM248 416c-26.5 0-48-28.7-48-64s21.5-64 48-64 48 28.7 48 64-21.5 64-48 64zm149.8-181.5c-5.8 3.1-11.2.7-13.7-1.6l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L304 233c-3.8 3.3-9.3 4-13.7 1.6-4.4-2.4-6.9-7.4-6.1-12.4 4-25.2 34.2-42.1 59.9-42.1S400 197 404 222.2c.6 4.9-1.8 9.9-6.2 12.3z"]
};
var faSadTear = {
  prefix: 'fas',
  iconName: 'sad-tear',
  icon: [496, 512, [], "f5b4", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zM152 416c-26.5 0-48-21-48-47 0-20 28.5-60.4 41.6-77.8 3.2-4.3 9.6-4.3 12.8 0C171.5 308.6 200 349 200 369c0 26-21.5 47-48 47zm16-176c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm170.2 154.2C315.8 367.4 282.9 352 248 352c-21.2 0-21.2-32 0-32 44.4 0 86.3 19.6 114.7 53.8 13.8 16.4-11.2 36.5-24.5 20.4z"]
};
var faSatellite = {
  prefix: 'fas',
  iconName: 'satellite',
  icon: [512, 512, [], "f7bf", "M502.60969,310.04206l-96.70393,96.71625a31.88151,31.88151,0,0,1-45.00765,0L280.572,326.34115l-9.89231,9.90759a190.56343,190.56343,0,0,1-5.40716,168.52287c-4.50077,8.50115-16.39342,9.59505-23.20707,2.79725L134.54715,400.05428l-17.7999,17.79929c.70324,2.60972,1.60965,5.00067,1.60965,7.79793a32.00544,32.00544,0,1,1-32.00544-32.00434c2.79735,0,5.18838.90637,7.7982,1.60959l17.7999-17.79929L4.43129,269.94287c-6.798-6.81342-5.70409-18.6119,2.79735-23.20627a190.58161,190.58161,0,0,1,168.52864-5.407l9.79854-9.79821-80.31053-80.41716a32.002,32.002,0,0,1,0-45.09987L201.96474,9.29814A31.62639,31.62639,0,0,1,224.46868,0a31.99951,31.99951,0,0,1,22.59759,9.29814l80.32615,80.30777,47.805-47.89713a33.6075,33.6075,0,0,1,47.50808,0l47.50807,47.50645a33.63308,33.63308,0,0,1,0,47.50644l-47.805,47.89713L502.71908,265.036A31.78938,31.78938,0,0,1,502.60969,310.04206ZM219.56159,197.433l73.82505-73.82252-68.918-68.9-73.80942,73.80689Zm237.74352,90.106-68.90233-68.9156-73.825,73.82252,68.918,68.9Z"]
};
var faSatelliteDish = {
  prefix: 'fas',
  iconName: 'satellite-dish',
  icon: [512, 512, [], "f7c0", "M305.44954,462.59c7.39157,7.29792,6.18829,20.09661-3.00038,25.00356-77.713,41.80281-176.72559,29.9105-242.34331-35.7082C-5.49624,386.28227-17.404,287.362,24.41381,209.554c4.89125-9.095,17.68975-10.29834,25.00318-3.00043L166.22872,323.36708l27.39411-27.39452c-.68759-2.60974-1.594-5.00071-1.594-7.81361a32.00407,32.00407,0,1,1,32.00407,32.00455c-2.79723,0-5.20378-.89075-7.79786-1.594l-27.40974,27.41015ZM511.9758,303.06732a16.10336,16.10336,0,0,1-16.002,17.00242H463.86031a15.96956,15.96956,0,0,1-15.89265-15.00213C440.46671,175.5492,336.45348,70.53427,207.03078,63.53328a15.84486,15.84486,0,0,1-15.00191-15.90852V16.02652A16.09389,16.09389,0,0,1,209.031.02425C372.25491,8.61922,503.47472,139.841,511.9758,303.06732Zm-96.01221-.29692a16.21093,16.21093,0,0,1-16.11142,17.29934H367.645a16.06862,16.06862,0,0,1-15.89265-14.70522c-6.90712-77.01094-68.118-138.91037-144.92467-145.22376a15.94,15.94,0,0,1-14.79876-15.89289V112.13393a16.134,16.134,0,0,1,17.29908-16.096C319.45132,104.5391,407.55627,192.64538,415.96359,302.7704Z"]
};
var faSave = {
  prefix: 'fas',
  iconName: 'save',
  icon: [448, 512, [], "f0c7", "M433.941 129.941l-83.882-83.882A48 48 0 0 0 316.118 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V163.882a48 48 0 0 0-14.059-33.941zM224 416c-35.346 0-64-28.654-64-64 0-35.346 28.654-64 64-64s64 28.654 64 64c0 35.346-28.654 64-64 64zm96-304.52V212c0 6.627-5.373 12-12 12H76c-6.627 0-12-5.373-12-12V108c0-6.627 5.373-12 12-12h228.52c3.183 0 6.235 1.264 8.485 3.515l3.48 3.48A11.996 11.996 0 0 1 320 111.48z"]
};
var faSchool = {
  prefix: 'fas',
  iconName: 'school',
  icon: [640, 512, [], "f549", "M0 224v272c0 8.84 7.16 16 16 16h80V192H32c-17.67 0-32 14.33-32 32zm360-48h-24v-40c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v64c0 4.42 3.58 8 8 8h48c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8zm137.75-63.96l-160-106.67a32.02 32.02 0 0 0-35.5 0l-160 106.67A32.002 32.002 0 0 0 128 138.66V512h128V368c0-8.84 7.16-16 16-16h96c8.84 0 16 7.16 16 16v144h128V138.67c0-10.7-5.35-20.7-14.25-26.63zM320 256c-44.18 0-80-35.82-80-80s35.82-80 80-80 80 35.82 80 80-35.82 80-80 80zm288-64h-64v320h80c8.84 0 16-7.16 16-16V224c0-17.67-14.33-32-32-32z"]
};
var faScrewdriver = {
  prefix: 'fas',
  iconName: 'screwdriver',
  icon: [512, 512, [], "f54a", "M448 0L320 96v62.06l-83.03 83.03c6.79 4.25 13.27 9.06 19.07 14.87 5.8 5.8 10.62 12.28 14.87 19.07L353.94 192H416l96-128-64-64zM128 278.59L10.92 395.67c-14.55 14.55-14.55 38.15 0 52.71l52.7 52.7c14.56 14.56 38.15 14.56 52.71 0L233.41 384c29.11-29.11 29.11-76.3 0-105.41s-76.3-29.11-105.41 0z"]
};
var faScroll = {
  prefix: 'fas',
  iconName: 'scroll',
  icon: [640, 512, [], "f70e", "M48 0C21.53 0 0 21.53 0 48v64c0 8.84 7.16 16 16 16h80V48C96 21.53 74.47 0 48 0zm208 412.57V352h288V96c0-52.94-43.06-96-96-96H111.59C121.74 13.41 128 29.92 128 48v368c0 38.87 34.65 69.65 74.75 63.12C234.22 474 256 444.46 256 412.57zM288 384v32c0 52.93-43.06 96-96 96h336c61.86 0 112-50.14 112-112 0-8.84-7.16-16-16-16H288z"]
};
var faSdCard = {
  prefix: 'fas',
  iconName: 'sd-card',
  icon: [384, 512, [], "f7c2", "M320 0H128L0 128v320c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zM160 160h-48V64h48v96zm80 0h-48V64h48v96zm80 0h-48V64h48v96z"]
};
var faSearch = {
  prefix: 'fas',
  iconName: 'search',
  icon: [512, 512, [], "f002", "M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"]
};
var faSearchDollar = {
  prefix: 'fas',
  iconName: 'search-dollar',
  icon: [512, 512, [], "f688", "M505.04 442.66l-99.71-99.69c-4.5-4.5-10.6-7-17-7h-16.3c27.6-35.3 44-79.69 44-127.99C416.03 93.09 322.92 0 208.02 0S0 93.09 0 207.98s93.11 207.98 208.02 207.98c48.3 0 92.71-16.4 128.01-44v16.3c0 6.4 2.5 12.5 7 17l99.71 99.69c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.59.1-33.99zm-297.02-90.7c-79.54 0-144-64.34-144-143.98 0-79.53 64.35-143.98 144-143.98 79.54 0 144 64.34 144 143.98 0 79.53-64.35 143.98-144 143.98zm27.11-152.54l-45.01-13.5c-5.16-1.55-8.77-6.78-8.77-12.73 0-7.27 5.3-13.19 11.8-13.19h28.11c4.56 0 8.96 1.29 12.82 3.72 3.24 2.03 7.36 1.91 10.13-.73l11.75-11.21c3.53-3.37 3.33-9.21-.57-12.14-9.1-6.83-20.08-10.77-31.37-11.35V112c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v16.12c-23.63.63-42.68 20.55-42.68 45.07 0 19.97 12.99 37.81 31.58 43.39l45.01 13.5c5.16 1.55 8.77 6.78 8.77 12.73 0 7.27-5.3 13.19-11.8 13.19h-28.1c-4.56 0-8.96-1.29-12.82-3.72-3.24-2.03-7.36-1.91-10.13.73l-11.75 11.21c-3.53 3.37-3.33 9.21.57 12.14 9.1 6.83 20.08 10.77 31.37 11.35V304c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-16.12c23.63-.63 42.68-20.54 42.68-45.07 0-19.97-12.99-37.81-31.59-43.39z"]
};
var faSearchLocation = {
  prefix: 'fas',
  iconName: 'search-location',
  icon: [512, 512, [], "f689", "M505.04 442.66l-99.71-99.69c-4.5-4.5-10.6-7-17-7h-16.3c27.6-35.3 44-79.69 44-127.99C416.03 93.09 322.92 0 208.02 0S0 93.09 0 207.98s93.11 207.98 208.02 207.98c48.3 0 92.71-16.4 128.01-44v16.3c0 6.4 2.5 12.5 7 17l99.71 99.69c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.59.1-33.99zm-297.02-90.7c-79.54 0-144-64.34-144-143.98 0-79.53 64.35-143.98 144-143.98 79.54 0 144 64.34 144 143.98 0 79.53-64.35 143.98-144 143.98zm.02-239.96c-40.78 0-73.84 33.05-73.84 73.83 0 32.96 48.26 93.05 66.75 114.86a9.24 9.24 0 0 0 14.18 0c18.49-21.81 66.75-81.89 66.75-114.86 0-40.78-33.06-73.83-73.84-73.83zm0 96c-13.26 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"]
};
var faSearchMinus = {
  prefix: 'fas',
  iconName: 'search-minus',
  icon: [512, 512, [], "f010", "M304 192v32c0 6.6-5.4 12-12 12H124c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm201 284.7L476.7 505c-9.4 9.4-24.6 9.4-33.9 0L343 405.3c-4.5-4.5-7-10.6-7-17V372c-35.3 27.6-79.7 44-128 44C93.1 416 0 322.9 0 208S93.1 0 208 0s208 93.1 208 208c0 48.3-16.4 92.7-44 128h16.3c6.4 0 12.5 2.5 17 7l99.7 99.7c9.3 9.4 9.3 24.6 0 34zM344 208c0-75.2-60.8-136-136-136S72 132.8 72 208s60.8 136 136 136 136-60.8 136-136z"]
};
var faSearchPlus = {
  prefix: 'fas',
  iconName: 'search-plus',
  icon: [512, 512, [], "f00e", "M304 192v32c0 6.6-5.4 12-12 12h-56v56c0 6.6-5.4 12-12 12h-32c-6.6 0-12-5.4-12-12v-56h-56c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h56v-56c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v56h56c6.6 0 12 5.4 12 12zm201 284.7L476.7 505c-9.4 9.4-24.6 9.4-33.9 0L343 405.3c-4.5-4.5-7-10.6-7-17V372c-35.3 27.6-79.7 44-128 44C93.1 416 0 322.9 0 208S93.1 0 208 0s208 93.1 208 208c0 48.3-16.4 92.7-44 128h16.3c6.4 0 12.5 2.5 17 7l99.7 99.7c9.3 9.4 9.3 24.6 0 34zM344 208c0-75.2-60.8-136-136-136S72 132.8 72 208s60.8 136 136 136 136-60.8 136-136z"]
};
var faSeedling = {
  prefix: 'fas',
  iconName: 'seedling',
  icon: [512, 512, [], "f4d8", "M64 96H0c0 123.7 100.3 224 224 224v144c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320C288 196.3 187.7 96 64 96zm384-64c-84.2 0-157.4 46.5-195.7 115.2 27.7 30.2 48.2 66.9 59 107.6C424 243.1 512 147.9 512 32h-64z"]
};
var faServer = {
  prefix: 'fas',
  iconName: 'server',
  icon: [512, 512, [], "f233", "M480 160H32c-17.673 0-32-14.327-32-32V64c0-17.673 14.327-32 32-32h448c17.673 0 32 14.327 32 32v64c0 17.673-14.327 32-32 32zm-48-88c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm-64 0c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm112 248H32c-17.673 0-32-14.327-32-32v-64c0-17.673 14.327-32 32-32h448c17.673 0 32 14.327 32 32v64c0 17.673-14.327 32-32 32zm-48-88c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm-64 0c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm112 248H32c-17.673 0-32-14.327-32-32v-64c0-17.673 14.327-32 32-32h448c17.673 0 32 14.327 32 32v64c0 17.673-14.327 32-32 32zm-48-88c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm-64 0c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24z"]
};
var faShapes = {
  prefix: 'fas',
  iconName: 'shapes',
  icon: [512, 512, [], "f61f", "M128,256A128,128,0,1,0,256,384,128,128,0,0,0,128,256Zm379-54.86L400.07,18.29a37.26,37.26,0,0,0-64.14,0L229,201.14C214.76,225.52,232.58,256,261.09,256H474.91C503.42,256,521.24,225.52,507,201.14ZM480,288H320a32,32,0,0,0-32,32V480a32,32,0,0,0,32,32H480a32,32,0,0,0,32-32V320A32,32,0,0,0,480,288Z"]
};
var faShare = {
  prefix: 'fas',
  iconName: 'share',
  icon: [512, 512, [], "f064", "M503.691 189.836L327.687 37.851C312.281 24.546 288 35.347 288 56.015v80.053C127.371 137.907 0 170.1 0 322.326c0 61.441 39.581 122.309 83.333 154.132 13.653 9.931 33.111-2.533 28.077-18.631C66.066 312.814 132.917 274.316 288 272.085V360c0 20.7 24.3 31.453 39.687 18.164l176.004-152c11.071-9.562 11.086-26.753 0-36.328z"]
};
var faShareAlt = {
  prefix: 'fas',
  iconName: 'share-alt',
  icon: [448, 512, [], "f1e0", "M352 320c-22.608 0-43.387 7.819-59.79 20.895l-102.486-64.054a96.551 96.551 0 0 0 0-41.683l102.486-64.054C308.613 184.181 329.392 192 352 192c53.019 0 96-42.981 96-96S405.019 0 352 0s-96 42.981-96 96c0 7.158.79 14.13 2.276 20.841L155.79 180.895C139.387 167.819 118.608 160 96 160c-53.019 0-96 42.981-96 96s42.981 96 96 96c22.608 0 43.387-7.819 59.79-20.895l102.486 64.054A96.301 96.301 0 0 0 256 416c0 53.019 42.981 96 96 96s96-42.981 96-96-42.981-96-96-96z"]
};
var faShareAltSquare = {
  prefix: 'fas',
  iconName: 'share-alt-square',
  icon: [448, 512, [], "f1e1", "M448 80v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48zM304 296c-14.562 0-27.823 5.561-37.783 14.671l-67.958-40.775a56.339 56.339 0 0 0 0-27.793l67.958-40.775C276.177 210.439 289.438 216 304 216c30.928 0 56-25.072 56-56s-25.072-56-56-56-56 25.072-56 56c0 4.797.605 9.453 1.74 13.897l-67.958 40.775C171.823 205.561 158.562 200 144 200c-30.928 0-56 25.072-56 56s25.072 56 56 56c14.562 0 27.823-5.561 37.783-14.671l67.958 40.775a56.088 56.088 0 0 0-1.74 13.897c0 30.928 25.072 56 56 56s56-25.072 56-56C360 321.072 334.928 296 304 296z"]
};
var faShareSquare = {
  prefix: 'fas',
  iconName: 'share-square',
  icon: [576, 512, [], "f14d", "M568.482 177.448L424.479 313.433C409.3 327.768 384 317.14 384 295.985v-71.963c-144.575.97-205.566 35.113-164.775 171.353 4.483 14.973-12.846 26.567-25.006 17.33C155.252 383.105 120 326.488 120 269.339c0-143.937 117.599-172.5 264-173.312V24.012c0-21.174 25.317-31.768 40.479-17.448l144.003 135.988c10.02 9.463 10.028 25.425 0 34.896zM384 379.128V448H64V128h50.916a11.99 11.99 0 0 0 8.648-3.693c14.953-15.568 32.237-27.89 51.014-37.676C185.708 80.83 181.584 64 169.033 64H48C21.49 64 0 85.49 0 112v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48v-88.806c0-8.288-8.197-14.066-16.011-11.302a71.83 71.83 0 0 1-34.189 3.377c-7.27-1.046-13.8 4.514-13.8 11.859z"]
};
var faShekelSign = {
  prefix: 'fas',
  iconName: 'shekel-sign',
  icon: [448, 512, [], "f20b", "M248 168v168c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V168c0-75.11-60.89-136-136-136H24C10.75 32 0 42.74 0 56v408c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V112h112c30.93 0 56 25.07 56 56zM432 32h-48c-8.84 0-16 7.16-16 16v296c0 30.93-25.07 56-56 56H200V176c0-8.84-7.16-16-16-16h-48c-8.84 0-16 7.16-16 16v280c0 13.25 10.75 24 24 24h168c75.11 0 136-60.89 136-136V48c0-8.84-7.16-16-16-16z"]
};
var faShieldAlt = {
  prefix: 'fas',
  iconName: 'shield-alt',
  icon: [512, 512, [], "f3ed", "M466.5 83.7l-192-80a48.15 48.15 0 0 0-36.9 0l-192 80C27.7 91.1 16 108.6 16 128c0 198.5 114.5 335.7 221.5 380.3 11.8 4.9 25.1 4.9 36.9 0C360.1 472.6 496 349.3 496 128c0-19.4-11.7-36.9-29.5-44.3zM256.1 446.3l-.1-381 175.9 73.3c-3.3 151.4-82.1 261.1-175.8 307.7z"]
};
var faShieldVirus = {
  prefix: 'fas',
  iconName: 'shield-virus',
  icon: [512, 512, [], "e06c", "M224,192a16,16,0,1,0,16,16A16,16,0,0,0,224,192ZM466.5,83.68l-192-80A57.4,57.4,0,0,0,256.05,0a57.4,57.4,0,0,0-18.46,3.67l-192,80A47.93,47.93,0,0,0,16,128C16,326.5,130.5,463.72,237.5,508.32a48.09,48.09,0,0,0,36.91,0C360.09,472.61,496,349.3,496,128A48,48,0,0,0,466.5,83.68ZM384,256H371.88c-28.51,0-42.79,34.47-22.63,54.63l8.58,8.57a16,16,0,1,1-22.63,22.63l-8.57-8.58C306.47,313.09,272,327.37,272,355.88V368a16,16,0,0,1-32,0V355.88c0-28.51-34.47-42.79-54.63-22.63l-8.57,8.58a16,16,0,0,1-22.63-22.63l8.58-8.57c20.16-20.16,5.88-54.63-22.63-54.63H128a16,16,0,0,1,0-32h12.12c28.51,0,42.79-34.47,22.63-54.63l-8.58-8.57a16,16,0,0,1,22.63-22.63l8.57,8.58c20.16,20.16,54.63,5.88,54.63-22.63V112a16,16,0,0,1,32,0v12.12c0,28.51,34.47,42.79,54.63,22.63l8.57-8.58a16,16,0,0,1,22.63,22.63l-8.58,8.57C329.09,189.53,343.37,224,371.88,224H384a16,16,0,0,1,0,32Zm-96,0a16,16,0,1,0,16,16A16,16,0,0,0,288,256Z"]
};
var faShip = {
  prefix: 'fas',
  iconName: 'ship',
  icon: [640, 512, [], "f21a", "M496.616 372.639l70.012-70.012c16.899-16.9 9.942-45.771-12.836-53.092L512 236.102V96c0-17.673-14.327-32-32-32h-64V24c0-13.255-10.745-24-24-24H248c-13.255 0-24 10.745-24 24v40h-64c-17.673 0-32 14.327-32 32v140.102l-41.792 13.433c-22.753 7.313-29.754 36.173-12.836 53.092l70.012 70.012C125.828 416.287 85.587 448 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24 61.023 0 107.499-20.61 143.258-59.396C181.677 487.432 216.021 512 256 512h128c39.979 0 74.323-24.568 88.742-59.396C508.495 491.384 554.968 512 616 512c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24-60.817 0-101.542-31.001-119.384-75.361zM192 128h256v87.531l-118.208-37.995a31.995 31.995 0 0 0-19.584 0L192 215.531V128z"]
};
var faShippingFast = {
  prefix: 'fas',
  iconName: 'shipping-fast',
  icon: [640, 512, [], "f48b", "M624 352h-16V243.9c0-12.7-5.1-24.9-14.1-33.9L494 110.1c-9-9-21.2-14.1-33.9-14.1H416V48c0-26.5-21.5-48-48-48H112C85.5 0 64 21.5 64 48v48H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h272c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H40c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h208c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h208c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H64v128c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM160 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm320 0c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-208H416V144h44.1l99.9 99.9V256z"]
};
var faShoePrints = {
  prefix: 'fas',
  iconName: 'shoe-prints',
  icon: [640, 512, [], "f54b", "M192 160h32V32h-32c-35.35 0-64 28.65-64 64s28.65 64 64 64zM0 416c0 35.35 28.65 64 64 64h32V352H64c-35.35 0-64 28.65-64 64zm337.46-128c-34.91 0-76.16 13.12-104.73 32-24.79 16.38-44.52 32-104.73 32v128l57.53 15.97c26.21 7.28 53.01 13.12 80.31 15.05 32.69 2.31 65.6.67 97.58-6.2C472.9 481.3 512 429.22 512 384c0-64-84.18-96-174.54-96zM491.42 7.19C459.44.32 426.53-1.33 393.84.99c-27.3 1.93-54.1 7.77-80.31 15.04L256 32v128c60.2 0 79.94 15.62 104.73 32 28.57 18.88 69.82 32 104.73 32C555.82 224 640 192 640 128c0-45.22-39.1-97.3-148.58-120.81z"]
};
var faShoppingBag = {
  prefix: 'fas',
  iconName: 'shopping-bag',
  icon: [448, 512, [], "f290", "M352 160v-32C352 57.42 294.579 0 224 0 153.42 0 96 57.42 96 128v32H0v272c0 44.183 35.817 80 80 80h288c44.183 0 80-35.817 80-80V160h-96zm-192-32c0-35.29 28.71-64 64-64s64 28.71 64 64v32H160v-32zm160 120c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24zm-192 0c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24z"]
};
var faShoppingBasket = {
  prefix: 'fas',
  iconName: 'shopping-basket',
  icon: [576, 512, [], "f291", "M576 216v16c0 13.255-10.745 24-24 24h-8l-26.113 182.788C514.509 462.435 494.257 480 470.37 480H105.63c-23.887 0-44.139-17.565-47.518-41.212L32 256h-8c-13.255 0-24-10.745-24-24v-16c0-13.255 10.745-24 24-24h67.341l106.78-146.821c10.395-14.292 30.407-17.453 44.701-7.058 14.293 10.395 17.453 30.408 7.058 44.701L170.477 192h235.046L326.12 82.821c-10.395-14.292-7.234-34.306 7.059-44.701 14.291-10.395 34.306-7.235 44.701 7.058L484.659 192H552c13.255 0 24 10.745 24 24zM312 392V280c0-13.255-10.745-24-24-24s-24 10.745-24 24v112c0 13.255 10.745 24 24 24s24-10.745 24-24zm112 0V280c0-13.255-10.745-24-24-24s-24 10.745-24 24v112c0 13.255 10.745 24 24 24s24-10.745 24-24zm-224 0V280c0-13.255-10.745-24-24-24s-24 10.745-24 24v112c0 13.255 10.745 24 24 24s24-10.745 24-24z"]
};
var faShoppingCart = {
  prefix: 'fas',
  iconName: 'shopping-cart',
  icon: [576, 512, [], "f07a", "M528.12 301.319l47.273-208C578.806 78.301 567.391 64 551.99 64H159.208l-9.166-44.81C147.758 8.021 137.93 0 126.529 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24h69.883l70.248 343.435C147.325 417.1 136 435.222 136 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-15.674-6.447-29.835-16.824-40h209.647C430.447 426.165 424 440.326 424 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-22.172-12.888-41.332-31.579-50.405l5.517-24.276c3.413-15.018-8.002-29.319-23.403-29.319H218.117l-6.545-32h293.145c11.206 0 20.92-7.754 23.403-18.681z"]
};
var faShower = {
  prefix: 'fas',
  iconName: 'shower',
  icon: [512, 512, [], "f2cc", "M304,320a16,16,0,1,0,16,16A16,16,0,0,0,304,320Zm32-96a16,16,0,1,0,16,16A16,16,0,0,0,336,224Zm32,64a16,16,0,1,0-16-16A16,16,0,0,0,368,288Zm-32,32a16,16,0,1,0-16-16A16,16,0,0,0,336,320Zm-32-64a16,16,0,1,0,16,16A16,16,0,0,0,304,256Zm128-32a16,16,0,1,0-16-16A16,16,0,0,0,432,224Zm-48,16a16,16,0,1,0,16-16A16,16,0,0,0,384,240Zm-16-48a16,16,0,1,0,16,16A16,16,0,0,0,368,192Zm96,32a16,16,0,1,0,16,16A16,16,0,0,0,464,224Zm32-32a16,16,0,1,0,16,16A16,16,0,0,0,496,192Zm-64,64a16,16,0,1,0,16,16A16,16,0,0,0,432,256Zm-32,32a16,16,0,1,0,16,16A16,16,0,0,0,400,288Zm-64,64a16,16,0,1,0,16,16A16,16,0,0,0,336,352Zm-32,32a16,16,0,1,0,16,16A16,16,0,0,0,304,384Zm64-64a16,16,0,1,0,16,16A16,16,0,0,0,368,320Zm21.65-218.35-11.3-11.31a16,16,0,0,0-22.63,0L350.05,96A111.19,111.19,0,0,0,272,64c-19.24,0-37.08,5.3-52.9,13.85l-10-10A121.72,121.72,0,0,0,123.44,32C55.49,31.5,0,92.91,0,160.85V464a16,16,0,0,0,16,16H48a16,16,0,0,0,16-16V158.4c0-30.15,21-58.2,51-61.93a58.38,58.38,0,0,1,48.93,16.67l10,10C165.3,138.92,160,156.76,160,176a111.23,111.23,0,0,0,32,78.05l-5.66,5.67a16,16,0,0,0,0,22.62l11.3,11.31a16,16,0,0,0,22.63,0L389.65,124.28A16,16,0,0,0,389.65,101.65Z"]
};
var faShuttleVan = {
  prefix: 'fas',
  iconName: 'shuttle-van',
  icon: [640, 512, [], "f5b6", "M628.88 210.65L494.39 49.27A48.01 48.01 0 0 0 457.52 32H32C14.33 32 0 46.33 0 64v288c0 17.67 14.33 32 32 32h32c0 53.02 42.98 96 96 96s96-42.98 96-96h128c0 53.02 42.98 96 96 96s96-42.98 96-96h32c17.67 0 32-14.33 32-32V241.38c0-11.23-3.94-22.1-11.12-30.73zM64 192V96h96v96H64zm96 240c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm160-240h-96V96h96v96zm160 240c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm-96-240V96h66.02l80 96H384z"]
};
var faSign = {
  prefix: 'fas',
  iconName: 'sign',
  icon: [512, 512, [], "f4d9", "M496 64H128V16c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16v48H16C7.2 64 0 71.2 0 80v32c0 8.8 7.2 16 16 16h48v368c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V128h368c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16zM160 384h320V160H160v224z"]
};
var faSignInAlt = {
  prefix: 'fas',
  iconName: 'sign-in-alt',
  icon: [512, 512, [], "f2f6", "M416 448h-84c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h84c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32h-84c-6.6 0-12-5.4-12-12V76c0-6.6 5.4-12 12-12h84c53 0 96 43 96 96v192c0 53-43 96-96 96zm-47-201L201 79c-15-15-41-4.5-41 17v96H24c-13.3 0-24 10.7-24 24v96c0 13.3 10.7 24 24 24h136v96c0 21.5 26 32 41 17l168-168c9.3-9.4 9.3-24.6 0-34z"]
};
var faSignLanguage = {
  prefix: 'fas',
  iconName: 'sign-language',
  icon: [448, 512, [], "f2a7", "M91.434 483.987c-.307-16.018 13.109-29.129 29.13-29.129h62.293v-5.714H56.993c-16.021 0-29.437-13.111-29.13-29.129C28.16 404.491 40.835 392 56.428 392h126.429v-5.714H29.136c-16.021 0-29.437-13.111-29.13-29.129.297-15.522 12.973-28.013 28.566-28.013h154.286v-5.714H57.707c-16.021 0-29.437-13.111-29.13-29.129.297-15.522 12.973-28.013 28.566-28.013h168.566l-31.085-22.606c-12.762-9.281-15.583-27.149-6.302-39.912 9.281-12.761 27.15-15.582 39.912-6.302l123.361 89.715a34.287 34.287 0 0 1 14.12 27.728v141.136c0 15.91-10.946 29.73-26.433 33.374l-80.471 18.934a137.16 137.16 0 0 1-31.411 3.646H120c-15.593-.001-28.269-12.492-28.566-28.014zm73.249-225.701h36.423l-11.187-8.136c-18.579-13.511-20.313-40.887-3.17-56.536l-13.004-16.7c-9.843-12.641-28.43-15.171-40.88-5.088-12.065 9.771-14.133 27.447-4.553 39.75l36.371 46.71zm283.298-2.103l-5.003-152.452c-.518-15.771-13.722-28.136-29.493-27.619-15.773.518-28.137 13.722-27.619 29.493l1.262 38.415L283.565 11.019c-9.58-12.303-27.223-14.63-39.653-5.328-12.827 9.599-14.929 28.24-5.086 40.881l76.889 98.745-4.509 3.511-94.79-121.734c-9.58-12.303-27.223-14.63-39.653-5.328-12.827 9.599-14.929 28.24-5.086 40.881l94.443 121.288-4.509 3.511-77.675-99.754c-9.58-12.303-27.223-14.63-39.653-5.328-12.827 9.599-14.929 28.24-5.086 40.881l52.053 66.849c12.497-8.257 29.055-8.285 41.69.904l123.36 89.714c10.904 7.93 17.415 20.715 17.415 34.198v16.999l61.064-47.549a34.285 34.285 0 0 0 13.202-28.177z"]
};
var faSignOutAlt = {
  prefix: 'fas',
  iconName: 'sign-out-alt',
  icon: [512, 512, [], "f2f5", "M497 273L329 441c-15 15-41 4.5-41-17v-96H152c-13.3 0-24-10.7-24-24v-96c0-13.3 10.7-24 24-24h136V88c0-21.4 25.9-32 41-17l168 168c9.3 9.4 9.3 24.6 0 34zM192 436v-40c0-6.6-5.4-12-12-12H96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h84c6.6 0 12-5.4 12-12V76c0-6.6-5.4-12-12-12H96c-53 0-96 43-96 96v192c0 53 43 96 96 96h84c6.6 0 12-5.4 12-12z"]
};
var faSignal = {
  prefix: 'fas',
  iconName: 'signal',
  icon: [640, 512, [], "f012", "M216 288h-48c-8.84 0-16 7.16-16 16v192c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V304c0-8.84-7.16-16-16-16zM88 384H40c-8.84 0-16 7.16-16 16v96c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16v-96c0-8.84-7.16-16-16-16zm256-192h-48c-8.84 0-16 7.16-16 16v288c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V208c0-8.84-7.16-16-16-16zm128-96h-48c-8.84 0-16 7.16-16 16v384c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V112c0-8.84-7.16-16-16-16zM600 0h-48c-8.84 0-16 7.16-16 16v480c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16z"]
};
var faSignature = {
  prefix: 'fas',
  iconName: 'signature',
  icon: [640, 512, [], "f5b7", "M623.2 192c-51.8 3.5-125.7 54.7-163.1 71.5-29.1 13.1-54.2 24.4-76.1 24.4-22.6 0-26-16.2-21.3-51.9 1.1-8 11.7-79.2-42.7-76.1-25.1 1.5-64.3 24.8-169.5 126L192 182.2c30.4-75.9-53.2-151.5-129.7-102.8L7.4 116.3C0 121-2.2 130.9 2.5 138.4l17.2 27c4.7 7.5 14.6 9.7 22.1 4.9l58-38.9c18.4-11.7 40.7 7.2 32.7 27.1L34.3 404.1C27.5 421 37 448 64 448c8.3 0 16.5-3.2 22.6-9.4 42.2-42.2 154.7-150.7 211.2-195.8-2.2 28.5-2.1 58.9 20.6 83.8 15.3 16.8 37.3 25.3 65.5 25.3 35.6 0 68-14.6 102.3-30 33-14.8 99-62.6 138.4-65.8 8.5-.7 15.2-7.3 15.2-15.8v-32.1c.2-9.1-7.5-16.8-16.6-16.2z"]
};
var faSimCard = {
  prefix: 'fas',
  iconName: 'sim-card',
  icon: [384, 512, [], "f7c4", "M0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V128L256 0H64C28.7 0 0 28.7 0 64zm224 192h-64v-64h64v64zm96 0h-64v-64h32c17.7 0 32 14.3 32 32v32zm-64 128h64v32c0 17.7-14.3 32-32 32h-32v-64zm-96 0h64v64h-64v-64zm-96 0h64v64H96c-17.7 0-32-14.3-32-32v-32zm0-96h256v64H64v-64zm0-64c0-17.7 14.3-32 32-32h32v64H64v-32z"]
};
var faSink = {
  prefix: 'fas',
  iconName: 'sink',
  icon: [512, 512, [], "e06d", "M32,416a96,96,0,0,0,96,96H384a96,96,0,0,0,96-96V384H32ZM496,288H400V256h64a16,16,0,0,0,16-16V224a16,16,0,0,0-16-16H384a32,32,0,0,0-32,32v48H288V96a32,32,0,0,1,64,0v16a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16V96A96.16,96.16,0,0,0,300.87,1.86C255.29,10.71,224,53.36,224,99.79V288H160V240a32,32,0,0,0-32-32H48a16,16,0,0,0-16,16v16a16,16,0,0,0,16,16h64v32H16A16,16,0,0,0,0,304v32a16,16,0,0,0,16,16H496a16,16,0,0,0,16-16V304A16,16,0,0,0,496,288Z"]
};
var faSitemap = {
  prefix: 'fas',
  iconName: 'sitemap',
  icon: [640, 512, [], "f0e8", "M128 352H32c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32zm-24-80h192v48h48v-48h192v48h48v-57.59c0-21.17-17.23-38.41-38.41-38.41H344v-64h40c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32H256c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h40v64H94.41C73.23 224 56 241.23 56 262.41V320h48v-48zm264 80h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32zm240 0h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32z"]
};
var faSkating = {
  prefix: 'fas',
  iconName: 'skating',
  icon: [448, 512, [], "f7c5", "M400 0c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48zm0 448c-8.8 0-16 7.2-16 16s-7.2 16-16 16h-96c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c26.5 0 48-21.5 48-48 0-8.8-7.2-16-16-16zm-282.2 8.6c-6.2 6.2-16.4 6.3-22.6 0l-67.9-67.9c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l67.9 67.9c9.4 9.4 21.7 14 34 14s24.6-4.7 33.9-14c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.3-22.7 0zm56.1-179.8l-93.7 93.7c-12.5 12.5-12.5 32.8 0 45.2 6.2 6.2 14.4 9.4 22.6 9.4s16.4-3.1 22.6-9.4l91.9-91.9-30.2-30.2c-5-5-9.4-10.7-13.2-16.8zM128 160h105.5l-20.1 17.2c-13.5 11.5-21.6 28.4-22.3 46.1-.7 17.8 6.1 35.2 18.7 47.7l78.2 78.2V432c0 17.7 14.3 32 32 32s32-14.3 32-32v-89.4c0-12.6-5.1-25-14.1-33.9l-61-61c.5-.4 1.2-.6 1.7-1.1l82.3-82.3c11.5-11.5 14.9-28.6 8.7-43.6-6.2-15-20.7-24.7-37-24.7H128c-17.7 0-32 14.3-32 32s14.3 32 32 32z"]
};
var faSkiing = {
  prefix: 'fas',
  iconName: 'skiing',
  icon: [512, 512, [], "f7c9", "M432 96c26.5 0 48-21.5 48-48S458.5 0 432 0s-48 21.5-48 48 21.5 48 48 48zm73 356.1c-9.4-9.4-24.6-9.4-33.9 0-12.1 12.1-30.5 15.4-45.1 8.7l-135.8-70.2 49.2-73.8c12.7-19 10.2-44.5-6-60.6L293 215.7l-107-53.1c-2.9 19.9 3.4 40 17.7 54.4l75.1 75.2-45.9 68.8L35 258.7c-11.7-6-26.2-1.5-32.3 10.3-6.1 11.8-1.5 26.3 10.3 32.3l391.9 202.5c11.9 5.5 24.5 8.1 37.1 8.1 23.2 0 46-9 63-26 9.3-9.3 9.3-24.5 0-33.8zM120 91.6l-11.5 22.5c14.4 7.3 31.2 4.9 42.8-4.8l47.2 23.4c-.1.1-.1.2-.2.3l114.5 56.8 32.4-13 6.4 19.1c4 12.1 12.6 22 24 27.7l58.1 29c15.9 7.9 35 1.5 42.9-14.3 7.9-15.8 1.5-35-14.3-42.9l-52.1-26.1-17.1-51.2c-8.1-24.2-40.9-56.6-84.5-39.2l-81.2 32.5-62.5-31c.3-14.5-7.2-28.6-20.9-35.6l-11.1 21.7h-.2l-34.4-7c-1.8-.4-3.7.2-5 1.7-1.9 2.2-1.7 5.5.5 7.4l26.2 23z"]
};
var faSkiingNordic = {
  prefix: 'fas',
  iconName: 'skiing-nordic',
  icon: [576, 512, [], "f7ca", "M336 96c26.5 0 48-21.5 48-48S362.5 0 336 0s-48 21.5-48 48 21.5 48 48 48zm216 320c-13.2 0-24 10.7-24 24 0 13.2-10.8 24-24 24h-69.5L460 285.6c11.7-4.7 20.1-16.2 20.1-29.6 0-17.7-14.3-32-32-32h-44L378 170.8c-12.5-25.5-35.5-44.2-61.8-50.9L245 98.7c-28.3-6.8-57.8-.5-80.8 17.1l-39.7 30.4c-14 10.7-16.7 30.8-5.9 44.9.7.9 1.7 1.3 2.4 2.1L66.9 464H24c-13.2 0-24 10.7-24 24s10.8 24 24 24h480c39.7 0 72-32.3 72-72 0-13.2-10.8-24-24-24zm-260.5 48h-96.9l43.1-91-22-13c-12.1-7.2-21.9-16.9-29.5-27.8L123.7 464H99.5l52.3-261.4c4.1-1 8.1-2.9 11.7-5.6l39.7-30.4c7.7-5.9 17.4-8 25.3-6.1l14.7 4.4-37.5 87.4c-12.6 29.5-1.3 64 26.3 80.3l85 50.2-25.5 81.2zm110.6 0h-43.6l23.6-75.5c5.9-20.8-2.9-43.1-21.6-54.4L299.3 298l31.3-78.3 20.3 41.4c8 16.3 24.9 26.9 43.1 26.9h33.3l-25.2 176z"]
};
var faSkull = {
  prefix: 'fas',
  iconName: 'skull',
  icon: [512, 512, [], "f54c", "M256 0C114.6 0 0 100.3 0 224c0 70.1 36.9 132.6 94.5 173.7 9.6 6.9 15.2 18.1 13.5 29.9l-9.4 66.2c-1.4 9.6 6 18.2 15.7 18.2H192v-56c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v56h64v-56c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v56h77.7c9.7 0 17.1-8.6 15.7-18.2l-9.4-66.2c-1.7-11.7 3.8-23 13.5-29.9C475.1 356.6 512 294.1 512 224 512 100.3 397.4 0 256 0zm-96 320c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm192 0c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64z"]
};
var faSkullCrossbones = {
  prefix: 'fas',
  iconName: 'skull-crossbones',
  icon: [448, 512, [], "f714", "M439.15 453.06L297.17 384l141.99-69.06c7.9-3.95 11.11-13.56 7.15-21.46L432 264.85c-3.95-7.9-13.56-11.11-21.47-7.16L224 348.41 37.47 257.69c-7.9-3.95-17.51-.75-21.47 7.16L1.69 293.48c-3.95 7.9-.75 17.51 7.15 21.46L150.83 384 8.85 453.06c-7.9 3.95-11.11 13.56-7.15 21.47l14.31 28.63c3.95 7.9 13.56 11.11 21.47 7.15L224 419.59l186.53 90.72c7.9 3.95 17.51.75 21.47-7.15l14.31-28.63c3.95-7.91.74-17.52-7.16-21.47zM150 237.28l-5.48 25.87c-2.67 12.62 5.42 24.85 16.45 24.85h126.08c11.03 0 19.12-12.23 16.45-24.85l-5.5-25.87c41.78-22.41 70-62.75 70-109.28C368 57.31 303.53 0 224 0S80 57.31 80 128c0 46.53 28.22 86.87 70 109.28zM280 112c17.65 0 32 14.35 32 32s-14.35 32-32 32-32-14.35-32-32 14.35-32 32-32zm-112 0c17.65 0 32 14.35 32 32s-14.35 32-32 32-32-14.35-32-32 14.35-32 32-32z"]
};
var faSlash = {
  prefix: 'fas',
  iconName: 'slash',
  icon: [640, 512, [], "f715", "M594.53 508.63L6.18 53.9c-6.97-5.42-8.23-15.47-2.81-22.45L23.01 6.18C28.43-.8 38.49-2.06 45.47 3.37L633.82 458.1c6.97 5.42 8.23 15.47 2.81 22.45l-19.64 25.27c-5.42 6.98-15.48 8.23-22.46 2.81z"]
};
var faSleigh = {
  prefix: 'fas',
  iconName: 'sleigh',
  icon: [640, 512, [], "f7cc", "M612.7 350.7l-9.3-7.4c-6.9-5.5-17-4.4-22.5 2.5l-10 12.5c-5.5 6.9-4.4 17 2.5 22.5l9.3 7.4c5.9 4.7 9.2 11.7 9.2 19.2 0 13.6-11 24.6-24.6 24.6H48c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h516c39 0 73.7-29.3 75.9-68.3 1.4-23.8-8.7-46.3-27.2-61zM32 224c0 59.6 40.9 109.2 96 123.5V400h64v-48h192v48h64v-48c53 0 96-43 96-96v-96c17.7 0 32-14.3 32-32s-14.3-32-32-32h-96v64c0 35.3-28.7 64-64 64h-20.7c-65.8 0-125.9-37.2-155.3-96-29.4-58.8-89.6-96-155.3-96H32C14.3 32 0 46.3 0 64s14.3 32 32 32v128z"]
};
var faSlidersH = {
  prefix: 'fas',
  iconName: 'sliders-h',
  icon: [512, 512, [], "f1de", "M496 384H160v-16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h80v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h336c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-160h-80v-16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h336v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h80c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-160H288V48c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16C7.2 64 0 71.2 0 80v32c0 8.8 7.2 16 16 16h208v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h208c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16z"]
};
var faSmile = {
  prefix: 'fas',
  iconName: 'smile',
  icon: [496, 512, [], "f118", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm-160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm194.8 170.2C334.3 380.4 292.5 400 248 400s-86.3-19.6-114.8-53.8c-13.6-16.3 11-36.7 24.6-20.5 22.4 26.9 55.2 42.2 90.2 42.2s67.8-15.4 90.2-42.2c13.4-16.2 38.1 4.2 24.6 20.5z"]
};
var faSmileBeam = {
  prefix: 'fas',
  iconName: 'smile-beam',
  icon: [496, 512, [], "f5b8", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM112 223.4c3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.3 7.4-15.8 4-15.1-4.5zm250.8 122.8C334.3 380.4 292.5 400 248 400s-86.3-19.6-114.8-53.8c-13.5-16.3 11-36.7 24.6-20.5 22.4 26.9 55.2 42.2 90.2 42.2s67.8-15.4 90.2-42.2c13.6-16.2 38.1 4.3 24.6 20.5zm6.2-118.3l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.1 7.3-15.6 4-14.9-4.5 3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.6 8.6-11 11.9-15.1 4.5z"]
};
var faSmileWink = {
  prefix: 'fas',
  iconName: 'smile-wink',
  icon: [496, 512, [], "f4da", "M0 256c0 137 111 248 248 248s248-111 248-248S385 8 248 8 0 119 0 256zm200-48c0 17.7-14.3 32-32 32s-32-14.3-32-32 14.3-32 32-32 32 14.3 32 32zm158.5 16.5c-14.8-13.2-46.2-13.2-61 0L288 233c-8.3 7.4-21.6.4-19.8-10.8 4-25.2 34.2-42.1 59.9-42.1S384 197 388 222.2c1.7 11.1-11.4 18.3-19.8 10.8l-9.7-8.5zM157.8 325.8C180.2 352.7 213 368 248 368s67.8-15.4 90.2-42.2c13.6-16.2 38.1 4.2 24.6 20.5C334.3 380.4 292.5 400 248 400s-86.3-19.6-114.8-53.8c-13.5-16.3 11.2-36.7 24.6-20.4z"]
};
var faSmog = {
  prefix: 'fas',
  iconName: 'smog',
  icon: [640, 512, [], "f75f", "M624 368H80c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h544c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zm-480 96H16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zm416 0H224c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h336c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zM144 288h156.1c22.5 19.7 51.6 32 83.9 32s61.3-12.3 83.9-32H528c61.9 0 112-50.1 112-112S589.9 64 528 64c-18 0-34.7 4.6-49.7 12.1C454 31 406.8 0 352 0c-41 0-77.8 17.3-104 44.8C221.8 17.3 185 0 144 0 64.5 0 0 64.5 0 144s64.5 144 144 144z"]
};
var faSmoking = {
  prefix: 'fas',
  iconName: 'smoking',
  icon: [640, 512, [], "f48d", "M632 352h-48c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8zM553.3 87.1c-5.7-3.8-9.3-10-9.3-16.8V8c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v62.3c0 22 10.2 43.4 28.6 55.4 42.2 27.3 67.4 73.8 67.4 124V280c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-30.3c0-65.5-32.4-126.2-86.7-162.6zM432 352H48c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h384c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16zm-32 112H224v-64h176v64zm87.7-322.4C463.8 125 448 99.3 448 70.3V8c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v66.4c0 43.7 24.6 81.6 60.3 106.7 22.4 15.7 35.7 41.2 35.7 68.6V280c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-30.3c0-43.3-21-83.4-56.3-108.1zM536 352h-48c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8z"]
};
var faSmokingBan = {
  prefix: 'fas',
  iconName: 'smoking-ban',
  icon: [512, 512, [], "f54d", "M96 304c0 8.8 7.2 16 16 16h117.5l-96-96H112c-8.8 0-16 7.2-16 16v64zM256 0C114.6 0 0 114.6 0 256s114.6 256 256 256 256-114.6 256-256S397.4 0 256 0zm0 448c-105.9 0-192-86.1-192-192 0-41.4 13.3-79.7 35.7-111.1l267.4 267.4C335.7 434.7 297.4 448 256 448zm45.2-192H384v32h-50.8l-32-32zm111.1 111.1L365.2 320H400c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16H269.2L144.9 99.7C176.3 77.3 214.6 64 256 64c105.9 0 192 86.1 192 192 0 41.4-13.3 79.7-35.7 111.1zM320.6 128c-15.6 0-28.6-11.2-31.4-25.9-.7-3.6-4-6.1-7.7-6.1h-16.2c-5 0-8.7 4.5-8 9.4 4.6 30.9 31.2 54.6 63.3 54.6 15.6 0 28.6 11.2 31.4 25.9.7 3.6 4 6.1 7.7 6.1h16.2c5 0 8.7-4.5 8-9.4-4.6-30.9-31.2-54.6-63.3-54.6z"]
};
var faSms = {
  prefix: 'fas',
  iconName: 'sms',
  icon: [512, 512, [], "f7cd", "M256 32C114.6 32 0 125.1 0 240c0 49.6 21.4 95 57 130.7C44.5 421.1 2.7 466 2.2 466.5c-2.2 2.3-2.8 5.7-1.5 8.7 1.3 3 4.1 4.8 7.3 4.8 66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 141.4 0 256-93.1 256-208S397.4 32 256 32zM128.2 304H116c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h12.3c6 0 10.4-3.5 10.4-6.6 0-1.3-.8-2.7-2.1-3.8l-21.9-18.8c-8.5-7.2-13.3-17.5-13.3-28.1 0-21.3 19-38.6 42.4-38.6H156c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8h-12.3c-6 0-10.4 3.5-10.4 6.6 0 1.3.8 2.7 2.1 3.8l21.9 18.8c8.5 7.2 13.3 17.5 13.3 28.1.1 21.3-19 38.6-42.4 38.6zm191.8-8c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8v-68.2l-24.8 55.8c-2.9 5.9-11.4 5.9-14.3 0L224 227.8V296c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V192c0-8.8 7.2-16 16-16h16c6.1 0 11.6 3.4 14.3 8.8l17.7 35.4 17.7-35.4c2.7-5.4 8.3-8.8 14.3-8.8h16c8.8 0 16 7.2 16 16v104zm48.3 8H356c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h12.3c6 0 10.4-3.5 10.4-6.6 0-1.3-.8-2.7-2.1-3.8l-21.9-18.8c-8.5-7.2-13.3-17.5-13.3-28.1 0-21.3 19-38.6 42.4-38.6H396c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8h-12.3c-6 0-10.4 3.5-10.4 6.6 0 1.3.8 2.7 2.1 3.8l21.9 18.8c8.5 7.2 13.3 17.5 13.3 28.1.1 21.3-18.9 38.6-42.3 38.6z"]
};
var faSnowboarding = {
  prefix: 'fas',
  iconName: 'snowboarding',
  icon: [512, 512, [], "f7ce", "M432 96c26.5 0 48-21.5 48-48S458.5 0 432 0s-48 21.5-48 48 21.5 48 48 48zm28.8 153.6c5.8 4.3 12.5 6.4 19.2 6.4 9.7 0 19.3-4.4 25.6-12.8 10.6-14.1 7.8-34.2-6.4-44.8l-111.4-83.5c-13.8-10.3-29.1-18.4-45.4-23.8l-63.7-21.2-26.1-52.1C244.7 2 225.5-4.4 209.7 3.5c-15.8 7.9-22.2 27.1-14.3 42.9l29.1 58.1c5.7 11.4 15.6 19.9 27.7 24l16.4 5.5-41.2 20.6c-21.8 10.9-35.4 32.8-35.4 57.2v53.1l-74.1 24.7c-16.8 5.6-25.8 23.7-20.2 40.5 1.7 5.2 4.9 9.4 8.7 12.9l-38.7-14.1c-9.7-3.5-17.4-10.6-21.8-20-5.6-12-19.9-17.2-31.9-11.6s-17.2 19.9-11.6 31.9c9.8 21 27.1 36.9 48.9 44.8l364.8 132.7c9.7 3.5 19.7 5.3 29.7 5.3 12.5 0 24.9-2.7 36.5-8.2 12-5.6 17.2-19.9 11.6-31.9S474 454.7 462 460.3c-9.3 4.4-19.8 4.8-29.5 1.3l-90.8-33.1c8.7-4.1 15.6-11.8 17.8-21.9l21.9-102c3.9-18.2-3.2-37.2-18.1-48.4l-52-39 66-30.5 83.5 62.9zm-144.4 51.7l-19.7 92c-1.5 7.1-.1 13.9 2.8 20l-169.4-61.6c2.7-.2 5.4-.4 8-1.3l85-28.4c19.6-6.5 32.8-24.8 32.8-45.5V256l60.5 45.3z"]
};
var faSnowflake = {
  prefix: 'fas',
  iconName: 'snowflake',
  icon: [448, 512, [], "f2dc", "M440.3 345.2l-33.8-19.5 26-7c8.2-2.2 13.1-10.7 10.9-18.9l-4-14.9c-2.2-8.2-10.7-13.1-18.9-10.9l-70.8 19-63.9-37 63.8-36.9 70.8 19c8.2 2.2 16.7-2.7 18.9-10.9l4-14.9c2.2-8.2-2.7-16.7-10.9-18.9l-26-7 33.8-19.5c7.4-4.3 9.9-13.7 5.7-21.1L430.4 119c-4.3-7.4-13.7-9.9-21.1-5.7l-33.8 19.5 7-26c2.2-8.2-2.7-16.7-10.9-18.9l-14.9-4c-8.2-2.2-16.7 2.7-18.9 10.9l-19 70.8-62.8 36.2v-77.5l53.7-53.7c6.2-6.2 6.2-16.4 0-22.6l-11.3-11.3c-6.2-6.2-16.4-6.2-22.6 0L256 56.4V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v40.4l-19.7-19.7c-6.2-6.2-16.4-6.2-22.6 0L138.3 48c-6.3 6.2-6.3 16.4 0 22.6l53.7 53.7v77.5l-62.8-36.2-19-70.8c-2.2-8.2-10.7-13.1-18.9-10.9l-14.9 4c-8.2 2.2-13.1 10.7-10.9 18.9l7 26-33.8-19.5c-7.4-4.3-16.8-1.7-21.1 5.7L2.1 145.7c-4.3 7.4-1.7 16.8 5.7 21.1l33.8 19.5-26 7c-8.3 2.2-13.2 10.7-11 19l4 14.9c2.2 8.2 10.7 13.1 18.9 10.9l70.8-19 63.8 36.9-63.8 36.9-70.8-19c-8.2-2.2-16.7 2.7-18.9 10.9l-4 14.9c-2.2 8.2 2.7 16.7 10.9 18.9l26 7-33.8 19.6c-7.4 4.3-9.9 13.7-5.7 21.1l15.5 26.8c4.3 7.4 13.7 9.9 21.1 5.7l33.8-19.5-7 26c-2.2 8.2 2.7 16.7 10.9 18.9l14.9 4c8.2 2.2 16.7-2.7 18.9-10.9l19-70.8 62.8-36.2v77.5l-53.7 53.7c-6.3 6.2-6.3 16.4 0 22.6l11.3 11.3c6.2 6.2 16.4 6.2 22.6 0l19.7-19.7V496c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-40.4l19.7 19.7c6.2 6.2 16.4 6.2 22.6 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6L256 387.7v-77.5l62.8 36.2 19 70.8c2.2 8.2 10.7 13.1 18.9 10.9l14.9-4c8.2-2.2 13.1-10.7 10.9-18.9l-7-26 33.8 19.5c7.4 4.3 16.8 1.7 21.1-5.7l15.5-26.8c4.3-7.3 1.8-16.8-5.6-21z"]
};
var faSnowman = {
  prefix: 'fas',
  iconName: 'snowman',
  icon: [512, 512, [], "f7d0", "M510.9 152.3l-5.9-14.5c-3.3-8-12.6-11.9-20.8-8.7L456 140.6v-29c0-8.6-7.2-15.6-16-15.6h-16c-8.8 0-16 7-16 15.6v46.9c0 .5.3 1 .3 1.5l-56.4 23c-5.9-10-13.3-18.9-22-26.6 13.6-16.6 22-37.4 22-60.5 0-53-43-96-96-96s-96 43-96 96c0 23.1 8.5 43.9 22 60.5-8.7 7.7-16 16.6-22 26.6l-56.4-23c.1-.5.3-1 .3-1.5v-46.9C104 103 96.8 96 88 96H72c-8.8 0-16 7-16 15.6v29l-28.1-11.5c-8.2-3.2-17.5.7-20.8 8.7l-5.9 14.5c-3.3 8 .7 17.1 8.9 20.3l135.2 55.2c-.4 4-1.2 8-1.2 12.2 0 10.1 1.7 19.6 4.2 28.9C120.9 296.4 104 334.2 104 376c0 54 28.4 100.9 70.8 127.8 9.3 5.9 20.3 8.2 31.3 8.2h99.2c13.3 0 26.3-4.1 37.2-11.7 46.5-32.3 74.4-89.4 62.9-152.6-5.5-30.2-20.5-57.6-41.6-79 2.5-9.2 4.2-18.7 4.2-28.7 0-4.2-.8-8.1-1.2-12.2L502 172.6c8.1-3.1 12.1-12.2 8.9-20.3zM224 96c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm32 272c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-88s-16-23.2-16-32 7.2-16 16-16 16 7.2 16 16-16 32-16 32zm32-56c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"]
};
var faSnowplow = {
  prefix: 'fas',
  iconName: 'snowplow',
  icon: [640, 512, [], "f7d2", "M120 376c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm238.6 49.4c-14.5-14.5-22.6-34.1-22.6-54.6V269.2c0-20.5 8.1-40.1 22.6-54.6l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6l-22.6-22.6c-6.2-6.2-16.4-6.2-22.6 0l-36.7 36.7c-26.5 26.5-41.4 62.4-41.4 99.9V288h-64v-50.9c0-8.7-1.8-17.2-5.2-25.2L364.5 29.1C356.9 11.4 339.6 0 320.3 0H176c-26.5 0-48 21.5-48 48v112h-16c-26.5 0-48 21.5-48 48v91.2C26.3 317.2 0 355.4 0 400c0 61.9 50.1 112 112 112h256c61.9 0 112-50.1 112-112 0-17.3-4.2-33.4-11.2-48H512v18.7c0 37.5 14.9 73.4 41.4 99.9l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0l22.6-22.6c6.2-6.2 6.2-16.4 0-22.6l-36.7-36.7zM192 64h117.8l68.6 160H256l-64-64V64zm176 384H112c-26.5 0-48-21.5-48-48s21.5-48 48-48h256c26.5 0 48 21.5 48 48s-21.5 48-48 48z"]
};
var faSoap = {
  prefix: 'fas',
  iconName: 'soap',
  icon: [512, 512, [], "e06e", "M416,192a95.42,95.42,0,0,1-30.94,70.21A95.8,95.8,0,0,1,352,448H160a96,96,0,0,1,0-192h88.91A95.3,95.3,0,0,1,224,192H96A96,96,0,0,0,0,288V416a96,96,0,0,0,96,96H416a96,96,0,0,0,96-96V288A96,96,0,0,0,416,192Zm-96,64a64,64,0,1,0-64-64A64,64,0,0,0,320,256ZM208,96a48,48,0,1,0-48-48A48,48,0,0,0,208,96ZM384,64a32,32,0,1,0-32-32A32,32,0,0,0,384,64ZM160,288a64,64,0,0,0,0,128H352a64,64,0,0,0,0-128Z"]
};
var faSocks = {
  prefix: 'fas',
  iconName: 'socks',
  icon: [512, 512, [], "f696", "M214.66 311.01L288 256V96H128v176l-86.65 64.61c-39.4 29.56-53.86 84.42-29.21 127.06C30.39 495.25 63.27 512 96.08 512c20.03 0 40.25-6.25 57.52-19.2l21.86-16.39c-29.85-55.38-13.54-125.84 39.2-165.4zM288 32c0-11.05 3.07-21.3 8.02-30.38C293.4.92 290.85 0 288 0H160c-17.67 0-32 14.33-32 32v32h160V32zM480 0H352c-17.67 0-32 14.33-32 32v32h192V32c0-17.67-14.33-32-32-32zM320 272l-86.13 64.61c-39.4 29.56-53.86 84.42-29.21 127.06 18.25 31.58 50.61 48.33 83.42 48.33 20.03 0 40.25-6.25 57.52-19.2l115.2-86.4A127.997 127.997 0 0 0 512 304V96H320v176z"]
};
var faSolarPanel = {
  prefix: 'fas',
  iconName: 'solar-panel',
  icon: [640, 512, [], "f5ba", "M431.98 448.01l-47.97.05V416h-128v32.21l-47.98.05c-8.82.01-15.97 7.16-15.98 15.99l-.05 31.73c-.01 8.85 7.17 16.03 16.02 16.02l223.96-.26c8.82-.01 15.97-7.16 15.98-15.98l.04-31.73c.01-8.85-7.17-16.03-16.02-16.02zM585.2 26.74C582.58 11.31 568.99 0 553.06 0H86.93C71 0 57.41 11.31 54.79 26.74-3.32 369.16.04 348.08.03 352c-.03 17.32 14.29 32 32.6 32h574.74c18.23 0 32.51-14.56 32.59-31.79.02-4.08 3.35 16.95-54.76-325.47zM259.83 64h120.33l9.77 96H250.06l9.77-96zm-75.17 256H71.09L90.1 208h105.97l-11.41 112zm16.29-160H98.24l16.29-96h96.19l-9.77 96zm32.82 160l11.4-112h149.65l11.4 112H233.77zm195.5-256h96.19l16.29 96H439.04l-9.77-96zm26.06 256l-11.4-112H549.9l19.01 112H455.33z"]
};
var faSort = {
  prefix: 'fas',
  iconName: 'sort',
  icon: [320, 512, [], "f0dc", "M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41zm255-105L177 64c-9.4-9.4-24.6-9.4-33.9 0L24 183c-15.1 15.1-4.4 41 17 41h238c21.4 0 32.1-25.9 17-41z"]
};
var faSortAlphaDown = {
  prefix: 'fas',
  iconName: 'sort-alpha-down',
  icon: [448, 512, [], "f15d", "M176 352h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.36 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352zm240-64H288a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h56l-61.26 70.45A32 32 0 0 0 272 446.37V464a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-56l61.26-70.45A32 32 0 0 0 432 321.63V304a16 16 0 0 0-16-16zm31.06-85.38l-59.27-160A16 16 0 0 0 372.72 32h-41.44a16 16 0 0 0-15.07 10.62l-59.27 160A16 16 0 0 0 272 224h24.83a16 16 0 0 0 15.23-11.08l4.42-12.92h71l4.41 12.92A16 16 0 0 0 407.16 224H432a16 16 0 0 0 15.06-21.38zM335.61 144L352 96l16.39 48z"]
};
var faSortAlphaDownAlt = {
  prefix: 'fas',
  iconName: 'sort-alpha-down-alt',
  icon: [448, 512, [], "f881", "M176 352h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.36 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352zm112-128h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-56l61.26-70.45A32 32 0 0 0 432 65.63V48a16 16 0 0 0-16-16H288a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h56l-61.26 70.45A32 32 0 0 0 272 190.37V208a16 16 0 0 0 16 16zm159.06 234.62l-59.27-160A16 16 0 0 0 372.72 288h-41.44a16 16 0 0 0-15.07 10.62l-59.27 160A16 16 0 0 0 272 480h24.83a16 16 0 0 0 15.23-11.08l4.42-12.92h71l4.41 12.92A16 16 0 0 0 407.16 480H432a16 16 0 0 0 15.06-21.38zM335.61 400L352 352l16.39 48z"]
};
var faSortAlphaUp = {
  prefix: 'fas',
  iconName: 'sort-alpha-up',
  icon: [448, 512, [], "f15e", "M16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31l-80-96a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160zm400 128H288a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h56l-61.26 70.45A32 32 0 0 0 272 446.37V464a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-56l61.26-70.45A32 32 0 0 0 432 321.63V304a16 16 0 0 0-16-16zm31.06-85.38l-59.27-160A16 16 0 0 0 372.72 32h-41.44a16 16 0 0 0-15.07 10.62l-59.27 160A16 16 0 0 0 272 224h24.83a16 16 0 0 0 15.23-11.08l4.42-12.92h71l4.41 12.92A16 16 0 0 0 407.16 224H432a16 16 0 0 0 15.06-21.38zM335.61 144L352 96l16.39 48z"]
};
var faSortAlphaUpAlt = {
  prefix: 'fas',
  iconName: 'sort-alpha-up-alt',
  icon: [448, 512, [], "f882", "M16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31l-80-96a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160zm272 64h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-56l61.26-70.45A32 32 0 0 0 432 65.63V48a16 16 0 0 0-16-16H288a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h56l-61.26 70.45A32 32 0 0 0 272 190.37V208a16 16 0 0 0 16 16zm159.06 234.62l-59.27-160A16 16 0 0 0 372.72 288h-41.44a16 16 0 0 0-15.07 10.62l-59.27 160A16 16 0 0 0 272 480h24.83a16 16 0 0 0 15.23-11.08l4.42-12.92h71l4.41 12.92A16 16 0 0 0 407.16 480H432a16 16 0 0 0 15.06-21.38zM335.61 400L352 352l16.39 48z"]
};
var faSortAmountDown = {
  prefix: 'fas',
  iconName: 'sort-amount-down',
  icon: [512, 512, [], "f160", "M304 416h-64a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-128-64h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.37 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352zm256-192H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-64 128H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM496 32H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h256a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"]
};
var faSortAmountDownAlt = {
  prefix: 'fas',
  iconName: 'sort-amount-down-alt',
  icon: [512, 512, [], "f884", "M240 96h64a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-64a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm0 128h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm256 192H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h256a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-256-64h192a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm-64 0h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.37 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352z"]
};
var faSortAmountUp = {
  prefix: 'fas',
  iconName: 'sort-amount-up',
  icon: [512, 512, [], "f161", "M304 416h-64a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31l-80-96a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.77 160 16 160zm416 0H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-64 128H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM496 32H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h256a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"]
};
var faSortAmountUpAlt = {
  prefix: 'fas',
  iconName: 'sort-amount-up-alt',
  icon: [512, 512, [], "f885", "M240 96h64a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-64a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm0 128h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm256 192H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h256a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-256-64h192a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zM16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.39-17.24 11.31-27.31l-80-96a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160z"]
};
var faSortDown = {
  prefix: 'fas',
  iconName: 'sort-down',
  icon: [320, 512, [], "f0dd", "M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41z"]
};
var faSortNumericDown = {
  prefix: 'fas',
  iconName: 'sort-numeric-down',
  icon: [448, 512, [], "f162", "M304 96h16v64h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-16V48a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 304 96zm26.15 162.91a79 79 0 0 0-55 54.17c-14.25 51.05 21.21 97.77 68.85 102.53a84.07 84.07 0 0 1-20.85 12.91c-7.57 3.4-10.8 12.47-8.18 20.34l9.9 20c2.87 8.63 12.53 13.49 20.9 9.91 58-24.76 86.25-61.61 86.25-132V336c-.02-51.21-48.4-91.34-101.85-77.09zM352 356a20 20 0 1 1 20-20 20 20 0 0 1-20 20zm-176-4h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.36 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352z"]
};
var faSortNumericDownAlt = {
  prefix: 'fas',
  iconName: 'sort-numeric-down-alt',
  icon: [448, 512, [], "f886", "M176 352h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.36 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352zm224 64h-16V304a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 304 352h16v64h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM330.17 34.91a79 79 0 0 0-55 54.17c-14.27 51.05 21.19 97.77 68.83 102.53a84.07 84.07 0 0 1-20.85 12.91c-7.57 3.4-10.8 12.47-8.18 20.34l9.9 20c2.87 8.63 12.53 13.49 20.9 9.91 58-24.77 86.25-61.61 86.25-132V112c-.02-51.21-48.4-91.34-101.85-77.09zM352 132a20 20 0 1 1 20-20 20 20 0 0 1-20 20z"]
};
var faSortNumericUp = {
  prefix: 'fas',
  iconName: 'sort-numeric-up',
  icon: [448, 512, [], "f163", "M330.17 258.91a79 79 0 0 0-55 54.17c-14.27 51.05 21.19 97.77 68.83 102.53a84.07 84.07 0 0 1-20.85 12.91c-7.57 3.4-10.8 12.47-8.18 20.34l9.9 20c2.87 8.63 12.53 13.49 20.9 9.91 58-24.76 86.25-61.61 86.25-132V336c-.02-51.21-48.4-91.34-101.85-77.09zM352 356a20 20 0 1 1 20-20 20 20 0 0 1-20 20zM304 96h16v64h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-16V48a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 304 96zM107.31 36.69a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31z"]
};
var faSortNumericUpAlt = {
  prefix: 'fas',
  iconName: 'sort-numeric-up-alt',
  icon: [448, 512, [], "f887", "M107.31 36.69a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31zM400 416h-16V304a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 304 352h16v64h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM330.17 34.91a79 79 0 0 0-55 54.17c-14.27 51.05 21.19 97.77 68.83 102.53a84.07 84.07 0 0 1-20.85 12.91c-7.57 3.4-10.8 12.47-8.18 20.34l9.9 20c2.87 8.63 12.53 13.49 20.9 9.91 58-24.77 86.25-61.61 86.25-132V112c-.02-51.21-48.4-91.34-101.85-77.09zM352 132a20 20 0 1 1 20-20 20 20 0 0 1-20 20z"]
};
var faSortUp = {
  prefix: 'fas',
  iconName: 'sort-up',
  icon: [320, 512, [], "f0de", "M279 224H41c-21.4 0-32.1-25.9-17-41L143 64c9.4-9.4 24.6-9.4 33.9 0l119 119c15.2 15.1 4.5 41-16.9 41z"]
};
var faSpa = {
  prefix: 'fas',
  iconName: 'spa',
  icon: [576, 512, [], "f5bb", "M568.25 192c-29.04.13-135.01 6.16-213.84 83-33.12 29.63-53.36 63.3-66.41 94.86-13.05-31.56-33.29-65.23-66.41-94.86-78.83-76.84-184.8-82.87-213.84-83-4.41-.02-7.79 3.4-7.75 7.82.23 27.92 7.14 126.14 88.77 199.3C172.79 480.94 256 480 288 480s115.19.95 199.23-80.88c81.64-73.17 88.54-171.38 88.77-199.3.04-4.42-3.34-7.84-7.75-7.82zM287.98 302.6c12.82-18.85 27.6-35.78 44.09-50.52 19.09-18.61 39.58-33.3 60.26-45.18-16.44-70.5-51.72-133.05-96.73-172.22-4.11-3.58-11.02-3.58-15.14 0-44.99 39.14-80.27 101.63-96.74 172.07 20.37 11.7 40.5 26.14 59.22 44.39a282.768 282.768 0 0 1 45.04 51.46z"]
};
var faSpaceShuttle = {
  prefix: 'fas',
  iconName: 'space-shuttle',
  icon: [640, 512, [], "f197", "M592.604 208.244C559.735 192.836 515.777 184 472 184H186.327c-4.952-6.555-10.585-11.978-16.72-16H376C229.157 137.747 219.403 32 96.003 32H96v128H80V32c-26.51 0-48 28.654-48 64v64c-23.197 0-32 10.032-32 24v40c0 13.983 8.819 24 32 24v16c-23.197 0-32 10.032-32 24v40c0 13.983 8.819 24 32 24v64c0 35.346 21.49 64 48 64V352h16v128h.003c123.4 0 133.154-105.747 279.997-136H169.606c6.135-4.022 11.768-9.445 16.72-16H472c43.777 0 87.735-8.836 120.604-24.244C622.282 289.845 640 271.992 640 256s-17.718-33.845-47.396-47.756zM488 296a8 8 0 0 1-8-8v-64a8 8 0 0 1 8-8c31.909 0 31.942 80 0 80z"]
};
var faSpellCheck = {
  prefix: 'fas',
  iconName: 'spell-check',
  icon: [576, 512, [], "f891", "M272 256h91.36c43.2 0 82-32.2 84.51-75.34a79.82 79.82 0 0 0-25.26-63.07 79.81 79.81 0 0 0 9.06-44.91C427.9 30.57 389.3 0 347 0h-75a16 16 0 0 0-16 16v224a16 16 0 0 0 16 16zm40-200h40a24 24 0 0 1 0 48h-40zm0 96h56a24 24 0 0 1 0 48h-56zM155.12 22.25A32 32 0 0 0 124.64 0H99.36a32 32 0 0 0-30.48 22.25L.59 235.73A16 16 0 0 0 16 256h24.93a16 16 0 0 0 15.42-11.73L68.29 208h87.42l11.94 36.27A16 16 0 0 0 183.07 256H208a16 16 0 0 0 15.42-20.27zM89.37 144L112 75.3l22.63 68.7zm482 132.48l-45.21-45.3a15.88 15.88 0 0 0-22.59 0l-151.5 151.5-55.41-55.5a15.88 15.88 0 0 0-22.59 0l-45.3 45.3a16 16 0 0 0 0 22.59l112 112.21a15.89 15.89 0 0 0 22.6 0l208-208.21a16 16 0 0 0-.02-22.59z"]
};
var faSpider = {
  prefix: 'fas',
  iconName: 'spider',
  icon: [576, 512, [], "f717", "M151.17 167.35L177.1 176h4.67l5.22-26.12c.72-3.58 1.8-7.58 3.21-11.79l-20.29-40.58 23.8-71.39c2.79-8.38-1.73-17.44-10.12-20.24L168.42.82c-8.38-2.8-17.45 1.73-20.24 10.12l-25.89 77.68a32.04 32.04 0 0 0 1.73 24.43l27.15 54.3zm422.14 182.03l-52.75-79.12a32.002 32.002 0 0 0-26.62-14.25H416l68.99-24.36a32.03 32.03 0 0 0 16.51-12.61l53.6-80.41c4.9-7.35 2.91-17.29-4.44-22.19l-13.31-8.88c-7.35-4.9-17.29-2.91-22.19 4.44l-50.56 75.83L404.1 208H368l-10.37-51.85C355.44 145.18 340.26 96 288 96c-52.26 0-67.44 49.18-69.63 60.15L208 208h-36.1l-60.49-20.17L60.84 112c-4.9-7.35-14.83-9.34-22.19-4.44l-13.31 8.88c-7.35 4.9-9.34 14.83-4.44 22.19l53.6 80.41a32.03 32.03 0 0 0 16.51 12.61L160 256H82.06a32.02 32.02 0 0 0-26.63 14.25L2.69 349.38c-4.9 7.35-2.92 17.29 4.44 22.19l13.31 8.88c7.35 4.9 17.29 2.91 22.19-4.44l48-72h47.06l-60.83 97.33A31.988 31.988 0 0 0 72 418.3V496c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-73.11l74.08-118.53c-1.01 14.05-2.08 28.11-2.08 42.21C192 399.64 232.76 448 288 448s96-48.36 96-101.43c0-14.1-1.08-28.16-2.08-42.21L456 422.89V496c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-77.71c0-6-1.69-11.88-4.86-16.96L438.31 304h47.06l48 72c4.9 7.35 14.84 9.34 22.19 4.44l13.31-8.88c7.36-4.9 9.34-14.83 4.44-22.18zM406.09 97.51l-20.29 40.58c1.41 4.21 2.49 8.21 3.21 11.79l5.22 26.12h4.67l25.93-8.65 27.15-54.3a31.995 31.995 0 0 0 1.73-24.43l-25.89-77.68C425.03 2.56 415.96-1.98 407.58.82l-15.17 5.06c-8.38 2.8-12.91 11.86-10.12 20.24l23.8 71.39z"]
};
var faSpinner = {
  prefix: 'fas',
  iconName: 'spinner',
  icon: [512, 512, [], "f110", "M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"]
};
var faSplotch = {
  prefix: 'fas',
  iconName: 'splotch',
  icon: [512, 512, [], "f5bc", "M472.29 195.89l-67.06-22.95c-19.28-6.6-33.54-20.92-38.14-38.3L351.1 74.19c-11.58-43.77-76.57-57.13-109.98-22.62l-46.14 47.67c-13.26 13.71-33.54 20.93-54.2 19.31l-71.88-5.62c-52.05-4.07-86.93 44.88-59.03 82.83l38.54 52.42c11.08 15.07 12.82 33.86 4.64 50.24L24.62 355.4c-20.59 41.25 22.84 84.87 73.49 73.81l69.96-15.28c20.11-4.39 41.45 0 57.07 11.73l54.32 40.83c39.32 29.56 101.04 7.57 104.45-37.22l4.7-61.86c1.35-17.79 12.8-33.86 30.63-42.99l62-31.74c44.88-22.96 39.59-80.17-8.95-96.79z"]
};
var faSprayCan = {
  prefix: 'fas',
  iconName: 'spray-can',
  icon: [512, 512, [], "f5bd", "M224 32c0-17.67-14.33-32-32-32h-64c-17.67 0-32 14.33-32 32v96h128V32zm256 96c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm-256 32H96c-53.02 0-96 42.98-96 96v224c0 17.67 14.33 32 32 32h256c17.67 0 32-14.33 32-32V256c0-53.02-42.98-96-96-96zm-64 256c-44.18 0-80-35.82-80-80s35.82-80 80-80 80 35.82 80 80-35.82 80-80 80zM480 96c17.67 0 32-14.33 32-32s-14.33-32-32-32-32 14.33-32 32 14.33 32 32 32zm-96 32c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm-96-96c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm96 0c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm96 192c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32z"]
};
var faSquare = {
  prefix: 'fas',
  iconName: 'square',
  icon: [448, 512, [], "f0c8", "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48z"]
};
var faSquareFull = {
  prefix: 'fas',
  iconName: 'square-full',
  icon: [512, 512, [], "f45c", "M512 512H0V0h512v512z"]
};
var faSquareRootAlt = {
  prefix: 'fas',
  iconName: 'square-root-alt',
  icon: [576, 512, [], "f698", "M571.31 251.31l-22.62-22.62c-6.25-6.25-16.38-6.25-22.63 0L480 274.75l-46.06-46.06c-6.25-6.25-16.38-6.25-22.63 0l-22.62 22.62c-6.25 6.25-6.25 16.38 0 22.63L434.75 320l-46.06 46.06c-6.25 6.25-6.25 16.38 0 22.63l22.62 22.62c6.25 6.25 16.38 6.25 22.63 0L480 365.25l46.06 46.06c6.25 6.25 16.38 6.25 22.63 0l22.62-22.62c6.25-6.25 6.25-16.38 0-22.63L525.25 320l46.06-46.06c6.25-6.25 6.25-16.38 0-22.63zM552 0H307.65c-14.54 0-27.26 9.8-30.95 23.87l-84.79 322.8-58.41-106.1A32.008 32.008 0 0 0 105.47 224H24c-13.25 0-24 10.74-24 24v48c0 13.25 10.75 24 24 24h43.62l88.88 163.73C168.99 503.5 186.3 512 204.94 512c17.27 0 44.44-9 54.28-41.48L357.03 96H552c13.25 0 24-10.75 24-24V24c0-13.26-10.75-24-24-24z"]
};
var faStamp = {
  prefix: 'fas',
  iconName: 'stamp',
  icon: [512, 512, [], "f5bf", "M32 512h448v-64H32v64zm384-256h-66.56c-16.26 0-29.44-13.18-29.44-29.44v-9.46c0-27.37 8.88-53.41 21.46-77.72 9.11-17.61 12.9-38.39 9.05-60.42-6.77-38.78-38.47-70.7-77.26-77.45C212.62-9.04 160 37.33 160 96c0 14.16 3.12 27.54 8.69 39.58C182.02 164.43 192 194.7 192 226.49v.07c0 16.26-13.18 29.44-29.44 29.44H96c-53.02 0-96 42.98-96 96v32c0 17.67 14.33 32 32 32h448c17.67 0 32-14.33 32-32v-32c0-53.02-42.98-96-96-96z"]
};
var faStar = {
  prefix: 'fas',
  iconName: 'star',
  icon: [576, 512, [], "f005", "M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"]
};
var faStarAndCrescent = {
  prefix: 'fas',
  iconName: 'star-and-crescent',
  icon: [512, 512, [], "f699", "M340.47 466.36c-1.45 0-6.89.46-9.18.46-116.25 0-210.82-94.57-210.82-210.82S215.04 45.18 331.29 45.18c2.32 0 7.7.46 9.18.46 7.13 0 13.33-5.03 14.75-12.07 1.46-7.25-2.55-14.49-9.47-17.09C316.58 5.54 286.39 0 256 0 114.84 0 0 114.84 0 256s114.84 256 256 256c30.23 0 60.28-5.49 89.32-16.32 5.96-2.02 10.28-7.64 10.28-14.26 0-8.09-6.39-15.06-15.13-15.06zm162.99-252.5l-76.38-11.1-34.16-69.21c-1.83-3.7-5.38-5.55-8.93-5.55s-7.1 1.85-8.93 5.55l-34.16 69.21-76.38 11.1c-8.17 1.18-11.43 11.22-5.52 16.99l55.27 53.87-13.05 76.07c-1.11 6.44 4.01 11.66 9.81 11.66 1.53 0 3.11-.36 4.64-1.17L384 335.37l68.31 35.91c1.53.8 3.11 1.17 4.64 1.17 5.8 0 10.92-5.23 9.81-11.66l-13.05-76.07 55.27-53.87c5.91-5.77 2.65-15.81-5.52-16.99z"]
};
var faStarHalf = {
  prefix: 'fas',
  iconName: 'star-half',
  icon: [576, 512, [], "f089", "M288 0c-11.4 0-22.8 5.9-28.7 17.8L194 150.2 47.9 171.4c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.1 23 46 46.4 33.7L288 439.6V0z"]
};
var faStarHalfAlt = {
  prefix: 'fas',
  iconName: 'star-half-alt',
  icon: [536, 512, [], "f5c0", "M508.55 171.51L362.18 150.2 296.77 17.81C290.89 5.98 279.42 0 267.95 0c-11.4 0-22.79 5.9-28.69 17.81l-65.43 132.38-146.38 21.29c-26.25 3.8-36.77 36.09-17.74 54.59l105.89 103-25.06 145.48C86.98 495.33 103.57 512 122.15 512c4.93 0 10-1.17 14.87-3.75l130.95-68.68 130.94 68.7c4.86 2.55 9.92 3.71 14.83 3.71 18.6 0 35.22-16.61 31.66-37.4l-25.03-145.49 105.91-102.98c19.04-18.5 8.52-50.8-17.73-54.6zm-121.74 123.2l-18.12 17.62 4.28 24.88 19.52 113.45-102.13-53.59-22.38-11.74.03-317.19 51.03 103.29 11.18 22.63 25.01 3.64 114.23 16.63-82.65 80.38z"]
};
var faStarOfDavid = {
  prefix: 'fas',
  iconName: 'star-of-david',
  icon: [464, 512, [], "f69a", "M405.68 256l53.21-89.39C473.3 142.4 455.48 112 426.88 112H319.96l-55.95-93.98C256.86 6.01 244.43 0 232 0s-24.86 6.01-32.01 18.02L144.04 112H37.11c-28.6 0-46.42 30.4-32.01 54.61L58.32 256 5.1 345.39C-9.31 369.6 8.51 400 37.11 400h106.93l55.95 93.98C207.14 505.99 219.57 512 232 512s24.86-6.01 32.01-18.02L319.96 400h106.93c28.6 0 46.42-30.4 32.01-54.61L405.68 256zm-12.78-88l-19.8 33.26L353.3 168h39.6zm-52.39 88l-52.39 88H175.88l-52.39-88 52.38-88h112.25l52.39 88zM232 73.72L254.79 112h-45.57L232 73.72zM71.1 168h39.6l-19.8 33.26L71.1 168zm0 176l19.8-33.26L110.7 344H71.1zM232 438.28L209.21 400h45.57L232 438.28zM353.29 344l19.8-33.26L392.9 344h-39.61z"]
};
var faStarOfLife = {
  prefix: 'fas',
  iconName: 'star-of-life',
  icon: [480, 512, [], "f621", "M471.99 334.43L336.06 256l135.93-78.43c7.66-4.42 10.28-14.2 5.86-21.86l-32.02-55.43c-4.42-7.65-14.21-10.28-21.87-5.86l-135.93 78.43V16c0-8.84-7.17-16-16.01-16h-64.04c-8.84 0-16.01 7.16-16.01 16v156.86L56.04 94.43c-7.66-4.42-17.45-1.79-21.87 5.86L2.15 155.71c-4.42 7.65-1.8 17.44 5.86 21.86L143.94 256 8.01 334.43c-7.66 4.42-10.28 14.21-5.86 21.86l32.02 55.43c4.42 7.65 14.21 10.27 21.87 5.86l135.93-78.43V496c0 8.84 7.17 16 16.01 16h64.04c8.84 0 16.01-7.16 16.01-16V339.14l135.93 78.43c7.66 4.42 17.45 1.8 21.87-5.86l32.02-55.43c4.42-7.65 1.8-17.43-5.86-21.85z"]
};
var faStepBackward = {
  prefix: 'fas',
  iconName: 'step-backward',
  icon: [448, 512, [], "f048", "M64 468V44c0-6.6 5.4-12 12-12h48c6.6 0 12 5.4 12 12v176.4l195.5-181C352.1 22.3 384 36.6 384 64v384c0 27.4-31.9 41.7-52.5 24.6L136 292.7V468c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12z"]
};
var faStepForward = {
  prefix: 'fas',
  iconName: 'step-forward',
  icon: [448, 512, [], "f051", "M384 44v424c0 6.6-5.4 12-12 12h-48c-6.6 0-12-5.4-12-12V291.6l-195.5 181C95.9 489.7 64 475.4 64 448V64c0-27.4 31.9-41.7 52.5-24.6L312 219.3V44c0-6.6 5.4-12 12-12h48c6.6 0 12 5.4 12 12z"]
};
var faStethoscope = {
  prefix: 'fas',
  iconName: 'stethoscope',
  icon: [512, 512, [], "f0f1", "M447.1 112c-34.2.5-62.3 28.4-63 62.6-.5 24.3 12.5 45.6 32 56.8V344c0 57.3-50.2 104-112 104-60 0-109.2-44.1-111.9-99.2C265 333.8 320 269.2 320 192V36.6c0-11.4-8.1-21.3-19.3-23.5L237.8.5c-13-2.6-25.6 5.8-28.2 18.8L206.4 35c-2.6 13 5.8 25.6 18.8 28.2l30.7 6.1v121.4c0 52.9-42.2 96.7-95.1 97.2-53.4.5-96.9-42.7-96.9-96V69.4l30.7-6.1c13-2.6 21.4-15.2 18.8-28.2l-3.1-15.7C107.7 6.4 95.1-2 82.1.6L19.3 13C8.1 15.3 0 25.1 0 36.6V192c0 77.3 55.1 142 128.1 156.8C130.7 439.2 208.6 512 304 512c97 0 176-75.4 176-168V231.4c19.1-11.1 32-31.7 32-55.4 0-35.7-29.2-64.5-64.9-64zm.9 80c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"]
};
var faStickyNote = {
  prefix: 'fas',
  iconName: 'sticky-note',
  icon: [448, 512, [], "f249", "M312 320h136V56c0-13.3-10.7-24-24-24H24C10.7 32 0 42.7 0 56v400c0 13.3 10.7 24 24 24h264V344c0-13.2 10.8-24 24-24zm129 55l-98 98c-4.5 4.5-10.6 7-17 7h-6V352h128v6.1c0 6.3-2.5 12.4-7 16.9z"]
};
var faStop = {
  prefix: 'fas',
  iconName: 'stop',
  icon: [448, 512, [], "f04d", "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48z"]
};
var faStopCircle = {
  prefix: 'fas',
  iconName: 'stop-circle',
  icon: [512, 512, [], "f28d", "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm96 328c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h160c8.8 0 16 7.2 16 16v160z"]
};
var faStopwatch = {
  prefix: 'fas',
  iconName: 'stopwatch',
  icon: [448, 512, [], "f2f2", "M432 304c0 114.9-93.1 208-208 208S16 418.9 16 304c0-104 76.3-190.2 176-205.5V64h-28c-6.6 0-12-5.4-12-12V12c0-6.6 5.4-12 12-12h120c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-28v34.5c37.5 5.8 71.7 21.6 99.7 44.6l27.5-27.5c4.7-4.7 12.3-4.7 17 0l28.3 28.3c4.7 4.7 4.7 12.3 0 17l-29.4 29.4-.6.6C419.7 223.3 432 262.2 432 304zm-176 36V188.5c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12V340c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12z"]
};
var faStopwatch20 = {
  prefix: 'fas',
  iconName: 'stopwatch-20',
  icon: [448, 512, [], "e06f", "M398.5,190.91l.59-.61,26.59-26.58a16,16,0,0,0,0-22.63L403,118.41a16,16,0,0,0-22.63,0l-24.68,24.68A206.68,206.68,0,0,0,256,98.5V64h32a16,16,0,0,0,16-16V16A16,16,0,0,0,288,0H160a16.05,16.05,0,0,0-16,16V48a16.05,16.05,0,0,0,16,16h32V98.5A207.92,207.92,0,0,0,16.09,297.57C12.64,411.5,106.76,510.22,220.72,512,337.13,513.77,432,420,432,304A206,206,0,0,0,398.5,190.91ZM204.37,377.55a8.2,8.2,0,0,1,8.32,8.07v22.31a8.2,8.2,0,0,1-8.32,8.07H121.52a16.46,16.46,0,0,1-16.61-17.62c2.78-35.22,14.67-57.41,38.45-91.37,20.42-29.19,27.1-37.32,27.1-62.34,0-16.92-1.79-24.27-12.21-24.27-9.39,0-12.69,7.4-12.69,22.68v5.23a8.2,8.2,0,0,1-8.33,8.07h-24.9a8.2,8.2,0,0,1-8.33-8.07v-4.07c0-27.3,8.48-60.24,56.43-60.24,43,0,55.57,25.85,55.57,61,0,35.58-12.44,51.21-34.35,81.31-11.56,15-24.61,35.57-26.41,51.2ZM344,352.32c0,35.16-12.3,63.68-57.23,63.68C243.19,416,232,386.48,232,352.55V247.22c0-40.73,19.58-63.22,56.2-63.22C325,184,344,206.64,344,245.3ZM287.87,221.73c-9.41,0-13.23,7.5-13.23,20V357.68c0,13.11,3.59,20.59,13.23,20.59s13-8,13-21.27V241.06C300.89,229.79,297.88,221.73,287.87,221.73Z"]
};
var faStore = {
  prefix: 'fas',
  iconName: 'store',
  icon: [616, 512, [], "f54e", "M602 118.6L537.1 15C531.3 5.7 521 0 510 0H106C95 0 84.7 5.7 78.9 15L14 118.6c-33.5 53.5-3.8 127.9 58.8 136.4 4.5.6 9.1.9 13.7.9 29.6 0 55.8-13 73.8-33.1 18 20.1 44.3 33.1 73.8 33.1 29.6 0 55.8-13 73.8-33.1 18 20.1 44.3 33.1 73.8 33.1 29.6 0 55.8-13 73.8-33.1 18.1 20.1 44.3 33.1 73.8 33.1 4.7 0 9.2-.3 13.7-.9 62.8-8.4 92.6-82.8 59-136.4zM529.5 288c-10 0-19.9-1.5-29.5-3.8V384H116v-99.8c-9.6 2.2-19.5 3.8-29.5 3.8-6 0-12.1-.4-18-1.2-5.6-.8-11.1-2.1-16.4-3.6V480c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32V283.2c-5.4 1.6-10.8 2.9-16.4 3.6-6.1.8-12.1 1.2-18.2 1.2z"]
};
var faStoreAlt = {
  prefix: 'fas',
  iconName: 'store-alt',
  icon: [640, 512, [], "f54f", "M320 384H128V224H64v256c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32V224h-64v160zm314.6-241.8l-85.3-128c-6-8.9-16-14.2-26.7-14.2H117.4c-10.7 0-20.7 5.3-26.6 14.2l-85.3 128c-14.2 21.3 1 49.8 26.6 49.8H608c25.5 0 40.7-28.5 26.6-49.8zM512 496c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V224h-64v272z"]
};
var faStoreAltSlash = {
  prefix: 'fas',
  iconName: 'store-alt-slash',
  icon: [640, 512, [], "e070", "M17.89,123.62,5.51,142.2c-14.2,21.3,1,49.8,26.59,49.8h74.26ZM576,413.42V224H512V364L384,265V224H330.92l-41.4-32H608c25.5,0,40.7-28.5,26.59-49.8l-85.29-128A32.18,32.18,0,0,0,522.6,0H117.42A31.87,31.87,0,0,0,90.81,14.2l-10.66,16L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.46A16,16,0,0,0,6.18,53.91L594.53,508.63A16,16,0,0,0,617,505.81l19.64-25.26a16,16,0,0,0-2.81-22.45ZM320,384H128V224H64V480a32,32,0,0,0,32,32H352a32,32,0,0,0,32-32V406.59l-64-49.47Z"]
};
var faStoreSlash = {
  prefix: 'fas',
  iconName: 'store-slash',
  icon: [640, 512, [], "e071", "M121.51,384V284.2a119.43,119.43,0,0,1-28,3.8,123.46,123.46,0,0,1-17.1-1.2,114.88,114.88,0,0,1-15.58-3.6V480c0,17.7,13.59,32,30.4,32H505.75L348.42,384Zm-28-128.09c25.1,0,47.29-10.72,64-27.24L24,120.05c-30.52,53.39-2.45,126.53,56.49,135A95.68,95.68,0,0,0,93.48,255.91ZM602.13,458.09,547.2,413.41V283.2a93.5,93.5,0,0,1-15.57,3.6,127.31,127.31,0,0,1-17.29,1.2,114.89,114.89,0,0,1-28-3.8v79.68L348.52,251.77a88.06,88.06,0,0,0,25.41,4.14c28.11,0,53-13,70.11-33.11,17.19,20.11,42.08,33.11,70.11,33.11a94.31,94.31,0,0,0,13-.91c59.66-8.41,88-82.8,56.06-136.4L521.55,15A30.1,30.1,0,0,0,495.81,0H112A30.11,30.11,0,0,0,86.27,15L76.88,30.78,43.19,3.38A14.68,14.68,0,0,0,21.86,6.19L3.2,31.45A16.58,16.58,0,0,0,5.87,53.91L564.81,508.63a14.69,14.69,0,0,0,21.33-2.82l18.66-25.26A16.58,16.58,0,0,0,602.13,458.09Z"]
};
var faStream = {
  prefix: 'fas',
  iconName: 'stream',
  icon: [512, 512, [], "f550", "M16 128h416c8.84 0 16-7.16 16-16V48c0-8.84-7.16-16-16-16H16C7.16 32 0 39.16 0 48v64c0 8.84 7.16 16 16 16zm480 80H80c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zm-64 176H16c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16z"]
};
var faStreetView = {
  prefix: 'fas',
  iconName: 'street-view',
  icon: [512, 512, [], "f21d", "M367.9 329.76c-4.62 5.3-9.78 10.1-15.9 13.65v22.94c66.52 9.34 112 28.05 112 49.65 0 30.93-93.12 56-208 56S48 446.93 48 416c0-21.6 45.48-40.3 112-49.65v-22.94c-6.12-3.55-11.28-8.35-15.9-13.65C58.87 345.34 0 378.05 0 416c0 53.02 114.62 96 256 96s256-42.98 256-96c0-37.95-58.87-70.66-144.1-86.24zM256 128c35.35 0 64-28.65 64-64S291.35 0 256 0s-64 28.65-64 64 28.65 64 64 64zm-64 192v96c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-96c17.67 0 32-14.33 32-32v-96c0-26.51-21.49-48-48-48h-11.8c-11.07 5.03-23.26 8-36.2 8s-25.13-2.97-36.2-8H208c-26.51 0-48 21.49-48 48v96c0 17.67 14.33 32 32 32z"]
};
var faStrikethrough = {
  prefix: 'fas',
  iconName: 'strikethrough',
  icon: [512, 512, [], "f0cc", "M496 224H293.9l-87.17-26.83A43.55 43.55 0 0 1 219.55 112h66.79A49.89 49.89 0 0 1 331 139.58a16 16 0 0 0 21.46 7.15l42.94-21.47a16 16 0 0 0 7.16-21.46l-.53-1A128 128 0 0 0 287.51 32h-68a123.68 123.68 0 0 0-123 135.64c2 20.89 10.1 39.83 21.78 56.36H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h480a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-180.24 96A43 43 0 0 1 336 356.45 43.59 43.59 0 0 1 292.45 400h-66.79A49.89 49.89 0 0 1 181 372.42a16 16 0 0 0-21.46-7.15l-42.94 21.47a16 16 0 0 0-7.16 21.46l.53 1A128 128 0 0 0 224.49 480h68a123.68 123.68 0 0 0 123-135.64 114.25 114.25 0 0 0-5.34-24.36z"]
};
var faStroopwafel = {
  prefix: 'fas',
  iconName: 'stroopwafel',
  icon: [512, 512, [], "f551", "M188.12 210.74L142.86 256l45.25 45.25L233.37 256l-45.25-45.26zm113.13-22.62L256 142.86l-45.25 45.25L256 233.37l45.25-45.25zm-90.5 135.76L256 369.14l45.26-45.26L256 278.63l-45.25 45.25zM256 0C114.62 0 0 114.62 0 256s114.62 256 256 256 256-114.62 256-256S397.38 0 256 0zm186.68 295.6l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0l-28.29-28.29-45.25 45.25 33.94 33.94 16.97-16.97c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31l-16.97 16.97 16.97 16.97c3.12 3.12 3.12 8.19 0 11.31l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0l-16.97-16.97-16.97 16.97c-3.12 3.12-8.19 3.12-11.31 0l-11.31-11.31c-3.12-3.12-3.12-8.19 0-11.31l16.97-16.97-33.94-33.94-45.26 45.26 28.29 28.29c3.12 3.12 3.12 8.19 0 11.31l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0L256 414.39l-28.29 28.29c-3.12 3.12-8.19 3.12-11.31 0l-11.31-11.31c-3.12-3.12-3.12-8.19 0-11.31l28.29-28.29-45.25-45.26-33.94 33.94 16.97 16.97c3.12 3.12 3.12 8.19 0 11.31l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0l-16.97-16.97-16.97 16.97c-3.12 3.12-8.19 3.12-11.31 0l-11.31-11.31c-3.12-3.12-3.12-8.19 0-11.31l16.97-16.97-16.97-16.97c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0l16.97 16.97 33.94-33.94-45.25-45.25-28.29 28.29c-3.12 3.12-8.19 3.12-11.31 0L69.32 295.6c-3.12-3.12-3.12-8.19 0-11.31L97.61 256l-28.29-28.29c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0l28.29 28.29 45.25-45.26-33.94-33.94-16.97 16.97c-3.12 3.12-8.19 3.12-11.31 0l-11.31-11.31c-3.12-3.12-3.12-8.19 0-11.31l16.97-16.97-16.97-16.97c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0l16.97 16.97 16.97-16.97c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31l-16.97 16.97 33.94 33.94 45.26-45.25-28.29-28.29c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0L256 97.61l28.29-28.29c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31l-28.29 28.29 45.26 45.25 33.94-33.94-16.97-16.97c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0l16.97 16.97 16.97-16.97c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31l-16.97 16.97 16.97 16.97c3.12 3.12 3.12 8.19 0 11.31l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0l-16.97-16.97-33.94 33.94 45.25 45.26 28.29-28.29c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31L414.39 256l28.29 28.28a8.015 8.015 0 0 1 0 11.32zM278.63 256l45.26 45.25L369.14 256l-45.25-45.26L278.63 256z"]
};
var faSubscript = {
  prefix: 'fas',
  iconName: 'subscript',
  icon: [512, 512, [], "f12c", "M496 448h-16V304a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 400 352h16v96h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM336 64h-67a16 16 0 0 0-13.14 6.87l-79.9 115-79.9-115A16 16 0 0 0 83 64H16A16 16 0 0 0 0 80v48a16 16 0 0 0 16 16h33.48l77.81 112-77.81 112H16a16 16 0 0 0-16 16v48a16 16 0 0 0 16 16h67a16 16 0 0 0 13.14-6.87l79.9-115 79.9 115A16 16 0 0 0 269 448h67a16 16 0 0 0 16-16v-48a16 16 0 0 0-16-16h-33.48l-77.81-112 77.81-112H336a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16z"]
};
var faSubway = {
  prefix: 'fas',
  iconName: 'subway',
  icon: [448, 512, [], "f239", "M448 96v256c0 51.815-61.624 96-130.022 96l62.98 49.721C386.905 502.417 383.562 512 376 512H72c-7.578 0-10.892-9.594-4.957-14.279L130.022 448C61.82 448 0 403.954 0 352V96C0 42.981 64 0 128 0h192c65 0 128 42.981 128 96zM200 232V120c0-13.255-10.745-24-24-24H72c-13.255 0-24 10.745-24 24v112c0 13.255 10.745 24 24 24h104c13.255 0 24-10.745 24-24zm200 0V120c0-13.255-10.745-24-24-24H272c-13.255 0-24 10.745-24 24v112c0 13.255 10.745 24 24 24h104c13.255 0 24-10.745 24-24zm-48 56c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm-256 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48z"]
};
var faSuitcase = {
  prefix: 'fas',
  iconName: 'suitcase',
  icon: [512, 512, [], "f0f2", "M128 480h256V80c0-26.5-21.5-48-48-48H176c-26.5 0-48 21.5-48 48v400zm64-384h128v32H192V96zm320 80v256c0 26.5-21.5 48-48 48h-48V128h48c26.5 0 48 21.5 48 48zM96 480H48c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48h48v352z"]
};
var faSuitcaseRolling = {
  prefix: 'fas',
  iconName: 'suitcase-rolling',
  icon: [384, 512, [], "f5c1", "M336 160H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h16v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16h128v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16h16c26.51 0 48-21.49 48-48V208c0-26.51-21.49-48-48-48zm-16 216c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h240c4.42 0 8 3.58 8 8v16zm0-96c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h240c4.42 0 8 3.58 8 8v16zM144 48h96v80h48V48c0-26.51-21.49-48-48-48h-96c-26.51 0-48 21.49-48 48v80h48V48z"]
};
var faSun = {
  prefix: 'fas',
  iconName: 'sun',
  icon: [512, 512, [], "f185", "M256 160c-52.9 0-96 43.1-96 96s43.1 96 96 96 96-43.1 96-96-43.1-96-96-96zm246.4 80.5l-94.7-47.3 33.5-100.4c4.5-13.6-8.4-26.5-21.9-21.9l-100.4 33.5-47.4-94.8c-6.4-12.8-24.6-12.8-31 0l-47.3 94.7L92.7 70.8c-13.6-4.5-26.5 8.4-21.9 21.9l33.5 100.4-94.7 47.4c-12.8 6.4-12.8 24.6 0 31l94.7 47.3-33.5 100.5c-4.5 13.6 8.4 26.5 21.9 21.9l100.4-33.5 47.3 94.7c6.4 12.8 24.6 12.8 31 0l47.3-94.7 100.4 33.5c13.6 4.5 26.5-8.4 21.9-21.9l-33.5-100.4 94.7-47.3c13-6.5 13-24.7.2-31.1zm-155.9 106c-49.9 49.9-131.1 49.9-181 0-49.9-49.9-49.9-131.1 0-181 49.9-49.9 131.1-49.9 181 0 49.9 49.9 49.9 131.1 0 181z"]
};
var faSuperscript = {
  prefix: 'fas',
  iconName: 'superscript',
  icon: [512, 512, [], "f12b", "M496 160h-16V16a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 400 64h16v96h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM336 64h-67a16 16 0 0 0-13.14 6.87l-79.9 115-79.9-115A16 16 0 0 0 83 64H16A16 16 0 0 0 0 80v48a16 16 0 0 0 16 16h33.48l77.81 112-77.81 112H16a16 16 0 0 0-16 16v48a16 16 0 0 0 16 16h67a16 16 0 0 0 13.14-6.87l79.9-115 79.9 115A16 16 0 0 0 269 448h67a16 16 0 0 0 16-16v-48a16 16 0 0 0-16-16h-33.48l-77.81-112 77.81-112H336a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16z"]
};
var faSurprise = {
  prefix: 'fas',
  iconName: 'surprise',
  icon: [496, 512, [], "f5c2", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM136 208c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm112 208c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm80-176c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"]
};
var faSwatchbook = {
  prefix: 'fas',
  iconName: 'swatchbook',
  icon: [512, 512, [], "f5c3", "M434.66,167.71h0L344.5,77.36a31.83,31.83,0,0,0-45-.07h0l-.07.07L224,152.88V424L434.66,212.9A32,32,0,0,0,434.66,167.71ZM480,320H373.09L186.68,506.51c-2.06,2.07-4.5,3.58-6.68,5.49H480a32,32,0,0,0,32-32V352A32,32,0,0,0,480,320ZM192,32A32,32,0,0,0,160,0H32A32,32,0,0,0,0,32V416a96,96,0,0,0,192,0ZM96,440a24,24,0,1,1,24-24A24,24,0,0,1,96,440Zm32-184H64V192h64Zm0-128H64V64h64Z"]
};
var faSwimmer = {
  prefix: 'fas',
  iconName: 'swimmer',
  icon: [640, 512, [], "f5c4", "M189.61 310.58c3.54 3.26 15.27 9.42 34.39 9.42s30.86-6.16 34.39-9.42c16.02-14.77 34.5-22.58 53.46-22.58h16.3c18.96 0 37.45 7.81 53.46 22.58 3.54 3.26 15.27 9.42 34.39 9.42s30.86-6.16 34.39-9.42c14.86-13.71 31.88-21.12 49.39-22.16l-112.84-80.6 18-12.86c3.64-2.58 8.28-3.52 12.62-2.61l100.35 21.53c25.91 5.53 51.44-10.97 57-36.88 5.55-25.92-10.95-51.44-36.88-57L437.68 98.47c-30.73-6.58-63.02.12-88.56 18.38l-80.02 57.17c-10.38 7.39-19.36 16.44-26.72 26.94L173.75 299c5.47 3.23 10.82 6.93 15.86 11.58zM624 352h-16c-26.04 0-45.8-8.42-56.09-17.9-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C461.8 343.58 442.04 352 416 352s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C269.8 343.58 250.04 352 224 352s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C77.8 343.58 58.04 352 32 352H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h16c38.62 0 72.72-12.19 96-31.84 23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84h16c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-512-96c44.18 0 80-35.82 80-80s-35.82-80-80-80-80 35.82-80 80 35.82 80 80 80z"]
};
var faSwimmingPool = {
  prefix: 'fas',
  iconName: 'swimming-pool',
  icon: [640, 512, [], "f5c5", "M624 416h-16c-26.04 0-45.8-8.42-56.09-17.9-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C461.8 407.58 442.04 416 416 416s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C269.8 407.58 250.04 416 224 416s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C77.8 407.58 58.04 416 32 416H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h16c38.62 0 72.72-12.19 96-31.84 23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84h16c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-400-32v-96h192v96c19.12 0 30.86-6.16 34.39-9.42 9.17-8.46 19.2-14.34 29.61-18.07V128c0-17.64 14.36-32 32-32s32 14.36 32 32v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16c0-52.94-43.06-96-96-96s-96 43.06-96 96v96H224v-96c0-17.64 14.36-32 32-32s32 14.36 32 32v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16c0-52.94-43.06-96-96-96s-96 43.06-96 96v228.5c10.41 3.73 20.44 9.62 29.61 18.07 3.53 3.27 15.27 9.43 34.39 9.43z"]
};
var faSynagogue = {
  prefix: 'fas',
  iconName: 'synagogue',
  icon: [640, 512, [], "f69b", "M70 196.51L6.67 268.29A26.643 26.643 0 0 0 0 285.93V512h128V239.58l-38-43.07c-5.31-6.01-14.69-6.01-20 0zm563.33 71.78L570 196.51c-5.31-6.02-14.69-6.02-20 0l-38 43.07V512h128V285.93c0-6.5-2.37-12.77-6.67-17.64zM339.99 7.01c-11.69-9.35-28.29-9.35-39.98 0l-128 102.4A32.005 32.005 0 0 0 160 134.4V512h96v-92.57c0-31.88 21.78-61.43 53.25-66.55C349.34 346.35 384 377.13 384 416v96h96V134.4c0-9.72-4.42-18.92-12.01-24.99l-128-102.4zm52.07 215.55c1.98 3.15-.29 7.24-4 7.24h-38.94L324 269.79c-1.85 2.95-6.15 2.95-8 0l-25.12-39.98h-38.94c-3.72 0-5.98-4.09-4-7.24l19.2-30.56-19.2-30.56c-1.98-3.15.29-7.24 4-7.24h38.94l25.12-40c1.85-2.95 6.15-2.95 8 0l25.12 39.98h38.95c3.71 0 5.98 4.09 4 7.24L372.87 192l19.19 30.56z"]
};
var faSync = {
  prefix: 'fas',
  iconName: 'sync',
  icon: [512, 512, [], "f021", "M440.65 12.57l4 82.77A247.16 247.16 0 0 0 255.83 8C134.73 8 33.91 94.92 12.29 209.82A12 12 0 0 0 24.09 224h49.05a12 12 0 0 0 11.67-9.26 175.91 175.91 0 0 1 317-56.94l-101.46-4.86a12 12 0 0 0-12.57 12v47.41a12 12 0 0 0 12 12H500a12 12 0 0 0 12-12V12a12 12 0 0 0-12-12h-47.37a12 12 0 0 0-11.98 12.57zM255.83 432a175.61 175.61 0 0 1-146-77.8l101.8 4.87a12 12 0 0 0 12.57-12v-47.4a12 12 0 0 0-12-12H12a12 12 0 0 0-12 12V500a12 12 0 0 0 12 12h47.35a12 12 0 0 0 12-12.6l-4.15-82.57A247.17 247.17 0 0 0 255.83 504c121.11 0 221.93-86.92 243.55-201.82a12 12 0 0 0-11.8-14.18h-49.05a12 12 0 0 0-11.67 9.26A175.86 175.86 0 0 1 255.83 432z"]
};
var faSyncAlt = {
  prefix: 'fas',
  iconName: 'sync-alt',
  icon: [512, 512, [], "f2f1", "M370.72 133.28C339.458 104.008 298.888 87.962 255.848 88c-77.458.068-144.328 53.178-162.791 126.85-1.344 5.363-6.122 9.15-11.651 9.15H24.103c-7.498 0-13.194-6.807-11.807-14.176C33.933 94.924 134.813 8 256 8c66.448 0 126.791 26.136 171.315 68.685L463.03 40.97C478.149 25.851 504 36.559 504 57.941V192c0 13.255-10.745 24-24 24H345.941c-21.382 0-32.09-25.851-16.971-40.971l41.75-41.749zM32 296h134.059c21.382 0 32.09 25.851 16.971 40.971l-41.75 41.75c31.262 29.273 71.835 45.319 114.876 45.28 77.418-.07 144.315-53.144 162.787-126.849 1.344-5.363 6.122-9.15 11.651-9.15h57.304c7.498 0 13.194 6.807 11.807 14.176C478.067 417.076 377.187 504 256 504c-66.448 0-126.791-26.136-171.315-68.685L48.97 471.03C33.851 486.149 8 475.441 8 454.059V320c0-13.255 10.745-24 24-24z"]
};
var faSyringe = {
  prefix: 'fas',
  iconName: 'syringe',
  icon: [512, 512, [], "f48e", "M201.5 174.8l55.7 55.8c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-55.7-55.8-45.3 45.3 55.8 55.8c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0L111 265.2l-26.4 26.4c-17.3 17.3-25.6 41.1-23 65.4l7.1 63.6L2.3 487c-3.1 3.1-3.1 8.2 0 11.3l11.3 11.3c3.1 3.1 8.2 3.1 11.3 0l66.3-66.3 63.6 7.1c23.9 2.6 47.9-5.4 65.4-23l181.9-181.9-135.7-135.7-64.9 65zm308.2-93.3L430.5 2.3c-3.1-3.1-8.2-3.1-11.3 0l-11.3 11.3c-3.1 3.1-3.1 8.2 0 11.3l28.3 28.3-45.3 45.3-56.6-56.6-17-17c-3.1-3.1-8.2-3.1-11.3 0l-33.9 33.9c-3.1 3.1-3.1 8.2 0 11.3l17 17L424.8 223l17 17c3.1 3.1 8.2 3.1 11.3 0l33.9-34c3.1-3.1 3.1-8.2 0-11.3l-73.5-73.5 45.3-45.3 28.3 28.3c3.1 3.1 8.2 3.1 11.3 0l11.3-11.3c3.1-3.2 3.1-8.2 0-11.4z"]
};
var faTable = {
  prefix: 'fas',
  iconName: 'table',
  icon: [512, 512, [], "f0ce", "M464 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM224 416H64v-96h160v96zm0-160H64v-96h160v96zm224 160H288v-96h160v96zm0-160H288v-96h160v96z"]
};
var faTableTennis = {
  prefix: 'fas',
  iconName: 'table-tennis',
  icon: [512, 512, [], "f45d", "M496.2 296.5C527.7 218.7 512 126.2 449 63.1 365.1-21 229-21 145.1 63.1l-56 56.1 211.5 211.5c46.1-62.1 131.5-77.4 195.6-34.2zm-217.9 79.7L57.9 155.9c-27.3 45.3-21.7 105 17.3 144.1l34.5 34.6L6.7 424c-8.6 7.5-9.1 20.7-1 28.8l53.4 53.5c8 8.1 21.2 7.6 28.7-1L177.1 402l35.7 35.7c19.7 19.7 44.6 30.5 70.3 33.3-7.1-17-11-35.6-11-55.1-.1-13.8 2.5-27 6.2-39.7zM416 320c-53 0-96 43-96 96s43 96 96 96 96-43 96-96-43-96-96-96z"]
};
var faTablet = {
  prefix: 'fas',
  iconName: 'tablet',
  icon: [448, 512, [], "f10a", "M400 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM224 480c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"]
};
var faTabletAlt = {
  prefix: 'fas',
  iconName: 'tablet-alt',
  icon: [448, 512, [], "f3fa", "M400 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM224 480c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm176-108c0 6.6-5.4 12-12 12H60c-6.6 0-12-5.4-12-12V60c0-6.6 5.4-12 12-12h328c6.6 0 12 5.4 12 12v312z"]
};
var faTablets = {
  prefix: 'fas',
  iconName: 'tablets',
  icon: [640, 512, [], "f490", "M160 192C78.9 192 12.5 250.5.1 326.7c-.8 4.8 3.3 9.3 8.3 9.3h303.3c5 0 9.1-4.5 8.3-9.3C307.5 250.5 241.1 192 160 192zm151.6 176H8.4c-5 0-9.1 4.5-8.3 9.3C12.5 453.5 78.9 512 160 512s147.5-58.5 159.9-134.7c.8-4.8-3.3-9.3-8.3-9.3zM593.4 46.6c-56.5-56.5-144.2-61.4-206.9-16-4 2.9-4.3 8.9-.8 12.3L597 254.3c3.5 3.5 9.5 3.2 12.3-.8 45.5-62.7 40.6-150.4-15.9-206.9zM363 65.7c-3.5-3.5-9.5-3.2-12.3.8-45.4 62.7-40.5 150.4 15.9 206.9 56.5 56.5 144.2 61.4 206.9 15.9 4-2.9 4.3-8.9.8-12.3L363 65.7z"]
};
var faTachometerAlt = {
  prefix: 'fas',
  iconName: 'tachometer-alt',
  icon: [576, 512, [], "f3fd", "M288 32C128.94 32 0 160.94 0 320c0 52.8 14.25 102.26 39.06 144.8 5.61 9.62 16.3 15.2 27.44 15.2h443c11.14 0 21.83-5.58 27.44-15.2C561.75 422.26 576 372.8 576 320c0-159.06-128.94-288-288-288zm0 64c14.71 0 26.58 10.13 30.32 23.65-1.11 2.26-2.64 4.23-3.45 6.67l-9.22 27.67c-5.13 3.49-10.97 6.01-17.64 6.01-17.67 0-32-14.33-32-32S270.33 96 288 96zM96 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm48-160c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm246.77-72.41l-61.33 184C343.13 347.33 352 364.54 352 384c0 11.72-3.38 22.55-8.88 32H232.88c-5.5-9.45-8.88-20.28-8.88-32 0-33.94 26.5-61.43 59.9-63.59l61.34-184.01c4.17-12.56 17.73-19.45 30.36-15.17 12.57 4.19 19.35 17.79 15.17 30.36zm14.66 57.2l15.52-46.55c3.47-1.29 7.13-2.23 11.05-2.23 17.67 0 32 14.33 32 32s-14.33 32-32 32c-11.38-.01-20.89-6.28-26.57-15.22zM480 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"]
};
var faTag = {
  prefix: 'fas',
  iconName: 'tag',
  icon: [512, 512, [], "f02b", "M0 252.118V48C0 21.49 21.49 0 48 0h204.118a48 48 0 0 1 33.941 14.059l211.882 211.882c18.745 18.745 18.745 49.137 0 67.882L293.823 497.941c-18.745 18.745-49.137 18.745-67.882 0L14.059 286.059A48 48 0 0 1 0 252.118zM112 64c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48z"]
};
var faTags = {
  prefix: 'fas',
  iconName: 'tags',
  icon: [640, 512, [], "f02c", "M497.941 225.941L286.059 14.059A48 48 0 0 0 252.118 0H48C21.49 0 0 21.49 0 48v204.118a48 48 0 0 0 14.059 33.941l211.882 211.882c18.744 18.745 49.136 18.746 67.882 0l204.118-204.118c18.745-18.745 18.745-49.137 0-67.882zM112 160c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm513.941 133.823L421.823 497.941c-18.745 18.745-49.137 18.745-67.882 0l-.36-.36L527.64 323.522c16.999-16.999 26.36-39.6 26.36-63.64s-9.362-46.641-26.36-63.64L331.397 0h48.721a48 48 0 0 1 33.941 14.059l211.882 211.882c18.745 18.745 18.745 49.137 0 67.882z"]
};
var faTape = {
  prefix: 'fas',
  iconName: 'tape',
  icon: [640, 512, [], "f4db", "M224 192c-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64-28.7-64-64-64zm400 224H380.6c41.5-40.7 67.4-97.3 67.4-160 0-123.7-100.3-224-224-224S0 132.3 0 256s100.3 224 224 224h400c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm-400-64c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96z"]
};
var faTasks = {
  prefix: 'fas',
  iconName: 'tasks',
  icon: [512, 512, [], "f0ae", "M139.61 35.5a12 12 0 0 0-17 0L58.93 98.81l-22.7-22.12a12 12 0 0 0-17 0L3.53 92.41a12 12 0 0 0 0 17l47.59 47.4a12.78 12.78 0 0 0 17.61 0l15.59-15.62L156.52 69a12.09 12.09 0 0 0 .09-17zm0 159.19a12 12 0 0 0-17 0l-63.68 63.72-22.7-22.1a12 12 0 0 0-17 0L3.53 252a12 12 0 0 0 0 17L51 316.5a12.77 12.77 0 0 0 17.6 0l15.7-15.69 72.2-72.22a12 12 0 0 0 .09-16.9zM64 368c-26.49 0-48.59 21.5-48.59 48S37.53 464 64 464a48 48 0 0 0 0-96zm432 16H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"]
};
var faTaxi = {
  prefix: 'fas',
  iconName: 'taxi',
  icon: [512, 512, [], "f1ba", "M462 241.64l-22-84.84c-9.6-35.2-41.6-60.8-76.8-60.8H352V64c0-17.67-14.33-32-32-32H192c-17.67 0-32 14.33-32 32v32h-11.2c-35.2 0-67.2 25.6-76.8 60.8l-22 84.84C21.41 248.04 0 273.47 0 304v48c0 23.63 12.95 44.04 32 55.12V448c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h256v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-40.88c19.05-11.09 32-31.5 32-55.12v-48c0-30.53-21.41-55.96-50-62.36zM96 352c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm20.55-112l17.2-66.36c2.23-8.16 9.59-13.64 15.06-13.64h214.4c5.47 0 12.83 5.48 14.85 12.86L395.45 240h-278.9zM416 352c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"]
};
var faTeeth = {
  prefix: 'fas',
  iconName: 'teeth',
  icon: [640, 512, [], "f62e", "M544 0H96C42.98 0 0 42.98 0 96v320c0 53.02 42.98 96 96 96h448c53.02 0 96-42.98 96-96V96c0-53.02-42.98-96-96-96zM160 368c0 26.51-21.49 48-48 48s-48-21.49-48-48v-64c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v64zm0-128c0 8.84-7.16 16-16 16H80c-8.84 0-16-7.16-16-16v-64c0-26.51 21.49-48 48-48s48 21.49 48 48v64zm144 120c0 30.93-25.07 56-56 56s-56-25.07-56-56v-56c0-8.84 7.16-16 16-16h80c8.84 0 16 7.16 16 16v56zm0-120c0 8.84-7.16 16-16 16h-80c-8.84 0-16-7.16-16-16v-88c0-30.93 25.07-56 56-56s56 25.07 56 56v88zm144 120c0 30.93-25.07 56-56 56s-56-25.07-56-56v-56c0-8.84 7.16-16 16-16h80c8.84 0 16 7.16 16 16v56zm0-120c0 8.84-7.16 16-16 16h-80c-8.84 0-16-7.16-16-16v-88c0-30.93 25.07-56 56-56s56 25.07 56 56v88zm128 128c0 26.51-21.49 48-48 48s-48-21.49-48-48v-64c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v64zm0-128c0 8.84-7.16 16-16 16h-64c-8.84 0-16-7.16-16-16v-64c0-26.51 21.49-48 48-48s48 21.49 48 48v64z"]
};
var faTeethOpen = {
  prefix: 'fas',
  iconName: 'teeth-open',
  icon: [640, 512, [], "f62f", "M544 0H96C42.98 0 0 42.98 0 96v64c0 35.35 28.66 64 64 64h512c35.34 0 64-28.65 64-64V96c0-53.02-42.98-96-96-96zM160 176c0 8.84-7.16 16-16 16H80c-8.84 0-16-7.16-16-16v-32c0-26.51 21.49-48 48-48s48 21.49 48 48v32zm144 0c0 8.84-7.16 16-16 16h-80c-8.84 0-16-7.16-16-16v-56c0-30.93 25.07-56 56-56s56 25.07 56 56v56zm144 0c0 8.84-7.16 16-16 16h-80c-8.84 0-16-7.16-16-16v-56c0-30.93 25.07-56 56-56s56 25.07 56 56v56zm128 0c0 8.84-7.16 16-16 16h-64c-8.84 0-16-7.16-16-16v-32c0-26.51 21.49-48 48-48s48 21.49 48 48v32zm0 144H64c-35.34 0-64 28.65-64 64v32c0 53.02 42.98 96 96 96h448c53.02 0 96-42.98 96-96v-32c0-35.35-28.66-64-64-64zm-416 80c0 26.51-21.49 48-48 48s-48-21.49-48-48v-32c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v32zm144-8c0 30.93-25.07 56-56 56s-56-25.07-56-56v-24c0-8.84 7.16-16 16-16h80c8.84 0 16 7.16 16 16v24zm144 0c0 30.93-25.07 56-56 56s-56-25.07-56-56v-24c0-8.84 7.16-16 16-16h80c8.84 0 16 7.16 16 16v24zm128 8c0 26.51-21.49 48-48 48s-48-21.49-48-48v-32c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v32z"]
};
var faTemperatureHigh = {
  prefix: 'fas',
  iconName: 'temperature-high',
  icon: [512, 512, [], "f769", "M416 0c-52.9 0-96 43.1-96 96s43.1 96 96 96 96-43.1 96-96-43.1-96-96-96zm0 128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm-160-16C256 50.1 205.9 0 144 0S32 50.1 32 112v166.5C12.3 303.2 0 334 0 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-34-12.3-64.9-32-89.5V112zM144 448c-44.1 0-80-35.9-80-80 0-25.5 12.2-48.9 32-63.8V112c0-26.5 21.5-48 48-48s48 21.5 48 48v192.2c19.8 14.8 32 38.3 32 63.8 0 44.1-35.9 80-80 80zm16-125.1V112c0-8.8-7.2-16-16-16s-16 7.2-16 16v210.9c-18.6 6.6-32 24.2-32 45.1 0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.5-32-45.1z"]
};
var faTemperatureLow = {
  prefix: 'fas',
  iconName: 'temperature-low',
  icon: [512, 512, [], "f76b", "M416 0c-52.9 0-96 43.1-96 96s43.1 96 96 96 96-43.1 96-96-43.1-96-96-96zm0 128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm-160-16C256 50.1 205.9 0 144 0S32 50.1 32 112v166.5C12.3 303.2 0 334 0 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-34-12.3-64.9-32-89.5V112zM144 448c-44.1 0-80-35.9-80-80 0-25.5 12.2-48.9 32-63.8V112c0-26.5 21.5-48 48-48s48 21.5 48 48v192.2c19.8 14.8 32 38.3 32 63.8 0 44.1-35.9 80-80 80zm16-125.1V304c0-8.8-7.2-16-16-16s-16 7.2-16 16v18.9c-18.6 6.6-32 24.2-32 45.1 0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.5-32-45.1z"]
};
var faTenge = {
  prefix: 'fas',
  iconName: 'tenge',
  icon: [384, 512, [], "f7d7", "M372 160H12c-6.6 0-12 5.4-12 12v56c0 6.6 5.4 12 12 12h140v228c0 6.6 5.4 12 12 12h56c6.6 0 12-5.4 12-12V240h140c6.6 0 12-5.4 12-12v-56c0-6.6-5.4-12-12-12zm0-128H12C5.4 32 0 37.4 0 44v56c0 6.6 5.4 12 12 12h360c6.6 0 12-5.4 12-12V44c0-6.6-5.4-12-12-12z"]
};
var faTerminal = {
  prefix: 'fas',
  iconName: 'terminal',
  icon: [640, 512, [], "f120", "M257.981 272.971L63.638 467.314c-9.373 9.373-24.569 9.373-33.941 0L7.029 444.647c-9.357-9.357-9.375-24.522-.04-33.901L161.011 256 6.99 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L257.981 239.03c9.373 9.372 9.373 24.568 0 33.941zM640 456v-32c0-13.255-10.745-24-24-24H312c-13.255 0-24 10.745-24 24v32c0 13.255 10.745 24 24 24h304c13.255 0 24-10.745 24-24z"]
};
var faTextHeight = {
  prefix: 'fas',
  iconName: 'text-height',
  icon: [576, 512, [], "f034", "M304 32H16A16 16 0 0 0 0 48v96a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32h56v304H80a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h160a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-40V112h56v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm256 336h-48V144h48c14.31 0 21.33-17.31 11.31-27.31l-80-80a16 16 0 0 0-22.62 0l-80 80C379.36 126 384.36 144 400 144h48v224h-48c-14.31 0-21.32 17.31-11.31 27.31l80 80a16 16 0 0 0 22.62 0l80-80C580.64 386 575.64 368 560 368z"]
};
var faTextWidth = {
  prefix: 'fas',
  iconName: 'text-width',
  icon: [448, 512, [], "f035", "M432 32H16A16 16 0 0 0 0 48v80a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-16h120v112h-24a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-24V112h120v16a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm-68.69 260.69C354 283.36 336 288.36 336 304v48H112v-48c0-14.31-17.31-21.32-27.31-11.31l-80 80a16 16 0 0 0 0 22.62l80 80C94 484.64 112 479.64 112 464v-48h224v48c0 14.31 17.31 21.33 27.31 11.31l80-80a16 16 0 0 0 0-22.62z"]
};
var faTh = {
  prefix: 'fas',
  iconName: 'th',
  icon: [512, 512, [], "f00a", "M149.333 56v80c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V56c0-13.255 10.745-24 24-24h101.333c13.255 0 24 10.745 24 24zm181.334 240v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24h101.333c13.256 0 24.001-10.745 24.001-24zm32-240v80c0 13.255 10.745 24 24 24H488c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24H386.667c-13.255 0-24 10.745-24 24zm-32 80V56c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24h101.333c13.256 0 24.001-10.745 24.001-24zm-205.334 56H24c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24zM0 376v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H24c-13.255 0-24 10.745-24 24zm386.667-56H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H386.667c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24zm0 160H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H386.667c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24zM181.333 376v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24z"]
};
var faThLarge = {
  prefix: 'fas',
  iconName: 'th-large',
  icon: [512, 512, [], "f009", "M296 32h192c13.255 0 24 10.745 24 24v160c0 13.255-10.745 24-24 24H296c-13.255 0-24-10.745-24-24V56c0-13.255 10.745-24 24-24zm-80 0H24C10.745 32 0 42.745 0 56v160c0 13.255 10.745 24 24 24h192c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24zM0 296v160c0 13.255 10.745 24 24 24h192c13.255 0 24-10.745 24-24V296c0-13.255-10.745-24-24-24H24c-13.255 0-24 10.745-24 24zm296 184h192c13.255 0 24-10.745 24-24V296c0-13.255-10.745-24-24-24H296c-13.255 0-24 10.745-24 24v160c0 13.255 10.745 24 24 24z"]
};
var faThList = {
  prefix: 'fas',
  iconName: 'th-list',
  icon: [512, 512, [], "f00b", "M149.333 216v80c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24v-80c0-13.255 10.745-24 24-24h101.333c13.255 0 24 10.745 24 24zM0 376v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H24c-13.255 0-24 10.745-24 24zM125.333 32H24C10.745 32 0 42.745 0 56v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24zm80 448H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24zm-24-424v80c0 13.255 10.745 24 24 24H488c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24zm24 264H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24z"]
};
var faTheaterMasks = {
  prefix: 'fas',
  iconName: 'theater-masks',
  icon: [640, 512, [], "f630", "M206.86 245.15c-35.88 10.45-59.95 41.2-57.53 74.1 11.4-12.72 28.81-23.7 49.9-30.92l7.63-43.18zM95.81 295L64.08 115.49c-.29-1.62.28-2.62.24-2.65 57.76-32.06 123.12-49.01 189.01-49.01 1.61 0 3.23.17 4.85.19 13.95-13.47 31.73-22.83 51.59-26 18.89-3.02 38.05-4.55 57.18-5.32-9.99-13.95-24.48-24.23-41.77-27C301.27 1.89 277.24 0 253.32 0 176.66 0 101.02 19.42 33.2 57.06 9.03 70.48-3.92 98.48 1.05 126.58l31.73 179.51c14.23 80.52 136.33 142.08 204.45 142.08 3.59 0 6.75-.46 10.01-.8-13.52-17.08-28.94-40.48-39.5-67.58-47.61-12.98-106.06-51.62-111.93-84.79zm97.55-137.46c-.73-4.12-2.23-7.87-4.07-11.4-8.25 8.91-20.67 15.75-35.32 18.32-14.65 2.58-28.67.4-39.48-5.17-.52 3.94-.64 7.98.09 12.1 3.84 21.7 24.58 36.19 46.34 32.37 21.75-3.82 36.28-24.52 32.44-46.22zM606.8 120.9c-88.98-49.38-191.43-67.41-291.98-51.35-27.31 4.36-49.08 26.26-54.04 54.36l-31.73 179.51c-15.39 87.05 95.28 196.27 158.31 207.35 63.03 11.09 204.47-53.79 219.86-140.84l31.73-179.51c4.97-28.11-7.98-56.11-32.15-69.52zm-273.24 96.8c3.84-21.7 24.58-36.19 46.34-32.36 21.76 3.83 36.28 24.52 32.45 46.22-.73 4.12-2.23 7.87-4.07 11.4-8.25-8.91-20.67-15.75-35.32-18.32-14.65-2.58-28.67-.4-39.48 5.17-.53-3.95-.65-7.99.08-12.11zm70.47 198.76c-55.68-9.79-93.52-59.27-89.04-112.9 20.6 25.54 56.21 46.17 99.49 53.78 43.28 7.61 83.82.37 111.93-16.6-14.18 51.94-66.71 85.51-122.38 75.72zm130.3-151.34c-8.25-8.91-20.68-15.75-35.33-18.32-14.65-2.58-28.67-.4-39.48 5.17-.52-3.94-.64-7.98.09-12.1 3.84-21.7 24.58-36.19 46.34-32.37 21.75 3.83 36.28 24.52 32.45 46.22-.73 4.13-2.23 7.88-4.07 11.4z"]
};
var faThermometer = {
  prefix: 'fas',
  iconName: 'thermometer',
  icon: [512, 512, [], "f491", "M476.8 20.4c-37.5-30.7-95.5-26.3-131.9 10.2l-45.7 46 50.5 50.5c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-50.4-50.5-45.1 45.4 50.3 50.4c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0L209 167.4l-45.1 45.4L214 263c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-50.1-50.2L96 281.1V382L7 471c-9.4 9.4-9.4 24.6 0 33.9 9.4 9.4 24.6 9.4 33.9 0l89-89h99.9L484 162.6c34.9-34.9 42.2-101.5-7.2-142.2z"]
};
var faThermometerEmpty = {
  prefix: 'fas',
  iconName: 'thermometer-empty',
  icon: [256, 512, [], "f2cb", "M192 384c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-35.346 28.654-64 64-64s64 28.654 64 64zm32-84.653c19.912 22.563 32 52.194 32 84.653 0 70.696-57.303 128-128 128-.299 0-.609-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.755 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM208 384c0-34.339-19.37-52.19-32-66.502V96c0-26.467-21.533-48-48-48S80 69.533 80 96v221.498c-12.732 14.428-31.825 32.1-31.999 66.08-.224 43.876 35.563 80.116 79.423 80.42L128 464c44.112 0 80-35.888 80-80z"]
};
var faThermometerFull = {
  prefix: 'fas',
  iconName: 'thermometer-full',
  icon: [256, 512, [], "f2c7", "M224 96c0-53.019-42.981-96-96-96S32 42.981 32 96v203.347C12.225 321.756.166 351.136.002 383.333c-.359 70.303 56.787 128.176 127.089 128.664.299.002.61.003.909.003 70.698 0 128-57.304 128-128 0-32.459-12.088-62.09-32-84.653V96zm-96 368l-.576-.002c-43.86-.304-79.647-36.544-79.423-80.42.173-33.98 19.266-51.652 31.999-66.08V96c0-26.467 21.533-48 48-48s48 21.533 48 48v221.498c12.63 14.312 32 32.164 32 66.502 0 44.112-35.888 80-80 80zm64-80c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-23.685 12.876-44.349 32-55.417V96c0-17.673 14.327-32 32-32s32 14.327 32 32v232.583c19.124 11.068 32 31.732 32 55.417z"]
};
var faThermometerHalf = {
  prefix: 'fas',
  iconName: 'thermometer-half',
  icon: [256, 512, [], "f2c9", "M192 384c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-23.685 12.876-44.349 32-55.417V224c0-17.673 14.327-32 32-32s32 14.327 32 32v104.583c19.124 11.068 32 31.732 32 55.417zm32-84.653c19.912 22.563 32 52.194 32 84.653 0 70.696-57.303 128-128 128-.299 0-.609-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.755 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM208 384c0-34.339-19.37-52.19-32-66.502V96c0-26.467-21.533-48-48-48S80 69.533 80 96v221.498c-12.732 14.428-31.825 32.1-31.999 66.08-.224 43.876 35.563 80.116 79.423 80.42L128 464c44.112 0 80-35.888 80-80z"]
};
var faThermometerQuarter = {
  prefix: 'fas',
  iconName: 'thermometer-quarter',
  icon: [256, 512, [], "f2ca", "M192 384c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-23.685 12.876-44.349 32-55.417V288c0-17.673 14.327-32 32-32s32 14.327 32 32v40.583c19.124 11.068 32 31.732 32 55.417zm32-84.653c19.912 22.563 32 52.194 32 84.653 0 70.696-57.303 128-128 128-.299 0-.609-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.755 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM208 384c0-34.339-19.37-52.19-32-66.502V96c0-26.467-21.533-48-48-48S80 69.533 80 96v221.498c-12.732 14.428-31.825 32.1-31.999 66.08-.224 43.876 35.563 80.116 79.423 80.42L128 464c44.112 0 80-35.888 80-80z"]
};
var faThermometerThreeQuarters = {
  prefix: 'fas',
  iconName: 'thermometer-three-quarters',
  icon: [256, 512, [], "f2c8", "M192 384c0 35.346-28.654 64-64 64-35.346 0-64-28.654-64-64 0-23.685 12.876-44.349 32-55.417V160c0-17.673 14.327-32 32-32s32 14.327 32 32v168.583c19.124 11.068 32 31.732 32 55.417zm32-84.653c19.912 22.563 32 52.194 32 84.653 0 70.696-57.303 128-128 128-.299 0-.609-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.755 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM208 384c0-34.339-19.37-52.19-32-66.502V96c0-26.467-21.533-48-48-48S80 69.533 80 96v221.498c-12.732 14.428-31.825 32.1-31.999 66.08-.224 43.876 35.563 80.116 79.423 80.42L128 464c44.112 0 80-35.888 80-80z"]
};
var faThumbsDown = {
  prefix: 'fas',
  iconName: 'thumbs-down',
  icon: [512, 512, [], "f165", "M0 56v240c0 13.255 10.745 24 24 24h80c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24H24C10.745 32 0 42.745 0 56zm40 200c0-13.255 10.745-24 24-24s24 10.745 24 24-10.745 24-24 24-24-10.745-24-24zm272 256c-20.183 0-29.485-39.293-33.931-57.795-5.206-21.666-10.589-44.07-25.393-58.902-32.469-32.524-49.503-73.967-89.117-113.111a11.98 11.98 0 0 1-3.558-8.521V59.901c0-6.541 5.243-11.878 11.783-11.998 15.831-.29 36.694-9.079 52.651-16.178C256.189 17.598 295.709.017 343.995 0h2.844c42.777 0 93.363.413 113.774 29.737 8.392 12.057 10.446 27.034 6.148 44.632 16.312 17.053 25.063 48.863 16.382 74.757 17.544 23.432 19.143 56.132 9.308 79.469l.11.11c11.893 11.949 19.523 31.259 19.439 49.197-.156 30.352-26.157 58.098-59.553 58.098H350.723C358.03 364.34 384 388.132 384 430.548 384 504 336 512 312 512z"]
};
var faThumbsUp = {
  prefix: 'fas',
  iconName: 'thumbs-up',
  icon: [512, 512, [], "f164", "M104 224H24c-13.255 0-24 10.745-24 24v240c0 13.255 10.745 24 24 24h80c13.255 0 24-10.745 24-24V248c0-13.255-10.745-24-24-24zM64 472c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24zM384 81.452c0 42.416-25.97 66.208-33.277 94.548h101.723c33.397 0 59.397 27.746 59.553 58.098.084 17.938-7.546 37.249-19.439 49.197l-.11.11c9.836 23.337 8.237 56.037-9.308 79.469 8.681 25.895-.069 57.704-16.382 74.757 4.298 17.598 2.244 32.575-6.148 44.632C440.202 511.587 389.616 512 346.839 512l-2.845-.001c-48.287-.017-87.806-17.598-119.56-31.725-15.957-7.099-36.821-15.887-52.651-16.178-6.54-.12-11.783-5.457-11.783-11.998v-213.77c0-3.2 1.282-6.271 3.558-8.521 39.614-39.144 56.648-80.587 89.117-113.111 14.804-14.832 20.188-37.236 25.393-58.902C282.515 39.293 291.817 0 312 0c24 0 72 8 72 81.452z"]
};
var faThumbtack = {
  prefix: 'fas',
  iconName: 'thumbtack',
  icon: [384, 512, [], "f08d", "M298.028 214.267L285.793 96H328c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24H56C42.745 0 32 10.745 32 24v48c0 13.255 10.745 24 24 24h42.207L85.972 214.267C37.465 236.82 0 277.261 0 328c0 13.255 10.745 24 24 24h136v104.007c0 1.242.289 2.467.845 3.578l24 48c2.941 5.882 11.364 5.893 14.311 0l24-48a8.008 8.008 0 0 0 .845-3.578V352h136c13.255 0 24-10.745 24-24-.001-51.183-37.983-91.42-85.973-113.733z"]
};
var faTicketAlt = {
  prefix: 'fas',
  iconName: 'ticket-alt',
  icon: [576, 512, [], "f3ff", "M128 160h320v192H128V160zm400 96c0 26.51 21.49 48 48 48v96c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48v-96c26.51 0 48-21.49 48-48s-21.49-48-48-48v-96c0-26.51 21.49-48 48-48h480c26.51 0 48 21.49 48 48v96c-26.51 0-48 21.49-48 48zm-48-104c0-13.255-10.745-24-24-24H120c-13.255 0-24 10.745-24 24v208c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24V152z"]
};
var faTimes = {
  prefix: 'fas',
  iconName: 'times',
  icon: [352, 512, [], "f00d", "M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"]
};
var faTimesCircle = {
  prefix: 'fas',
  iconName: 'times-circle',
  icon: [512, 512, [], "f057", "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z"]
};
var faTint = {
  prefix: 'fas',
  iconName: 'tint',
  icon: [352, 512, [], "f043", "M205.22 22.09c-7.94-28.78-49.44-30.12-58.44 0C100.01 179.85 0 222.72 0 333.91 0 432.35 78.72 512 176 512s176-79.65 176-178.09c0-111.75-99.79-153.34-146.78-311.82zM176 448c-61.75 0-112-50.25-112-112 0-8.84 7.16-16 16-16s16 7.16 16 16c0 44.11 35.89 80 80 80 8.84 0 16 7.16 16 16s-7.16 16-16 16z"]
};
var faTintSlash = {
  prefix: 'fas',
  iconName: 'tint-slash',
  icon: [640, 512, [], "f5c7", "M633.82 458.1L494.97 350.78c.52-5.57 1.03-11.16 1.03-16.87 0-111.76-99.79-153.34-146.78-311.82-7.94-28.78-49.44-30.12-58.44 0-15.52 52.34-36.87 91.96-58.49 125.68L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.36 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.41-6.97 4.16-17.02-2.82-22.45zM144 333.91C144 432.35 222.72 512 320 512c44.71 0 85.37-16.96 116.4-44.7L162.72 255.78c-11.41 23.5-18.72 48.35-18.72 78.13z"]
};
var faTired = {
  prefix: 'fas',
  iconName: 'tired',
  icon: [496, 512, [], "f5c8", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm33.8 189.7l80-48c11.6-6.9 24 7.7 15.4 18L343.6 208l33.6 40.3c8.7 10.4-3.9 24.8-15.4 18l-80-48c-7.7-4.7-7.7-15.9 0-20.6zm-163-30c-8.6-10.3 3.8-24.9 15.4-18l80 48c7.8 4.7 7.8 15.9 0 20.6l-80 48c-11.5 6.8-24-7.6-15.4-18l33.6-40.3-33.6-40.3zM248 288c51.9 0 115.3 43.8 123.2 106.7 1.7 13.6-8 24.6-17.7 20.4-25.9-11.1-64.4-17.4-105.5-17.4s-79.6 6.3-105.5 17.4c-9.8 4.2-19.4-7-17.7-20.4C132.7 331.8 196.1 288 248 288z"]
};
var faToggleOff = {
  prefix: 'fas',
  iconName: 'toggle-off',
  icon: [576, 512, [], "f204", "M384 64H192C85.961 64 0 149.961 0 256s85.961 192 192 192h192c106.039 0 192-85.961 192-192S490.039 64 384 64zM64 256c0-70.741 57.249-128 128-128 70.741 0 128 57.249 128 128 0 70.741-57.249 128-128 128-70.741 0-128-57.249-128-128zm320 128h-48.905c65.217-72.858 65.236-183.12 0-256H384c70.741 0 128 57.249 128 128 0 70.74-57.249 128-128 128z"]
};
var faToggleOn = {
  prefix: 'fas',
  iconName: 'toggle-on',
  icon: [576, 512, [], "f205", "M384 64H192C86 64 0 150 0 256s86 192 192 192h192c106 0 192-86 192-192S490 64 384 64zm0 320c-70.8 0-128-57.3-128-128 0-70.8 57.3-128 128-128 70.8 0 128 57.3 128 128 0 70.8-57.3 128-128 128z"]
};
var faToilet = {
  prefix: 'fas',
  iconName: 'toilet',
  icon: [384, 512, [], "f7d8", "M368 48c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16H16C7.2 0 0 7.2 0 16v16c0 8.8 7.2 16 16 16h16v156.7C11.8 214.8 0 226.9 0 240c0 67.2 34.6 126.2 86.8 160.5l-21.4 70.2C59.1 491.2 74.5 512 96 512h192c21.5 0 36.9-20.8 30.6-41.3l-21.4-70.2C349.4 366.2 384 307.2 384 240c0-13.1-11.8-25.2-32-35.3V48h16zM80 72c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H88c-4.4 0-8-3.6-8-8V72zm112 200c-77.1 0-139.6-14.3-139.6-32s62.5-32 139.6-32 139.6 14.3 139.6 32-62.5 32-139.6 32z"]
};
var faToiletPaper = {
  prefix: 'fas',
  iconName: 'toilet-paper',
  icon: [576, 512, [], "f71e", "M128 0C74.98 0 32 85.96 32 192v172.07c0 41.12-9.8 62.77-31.17 126.87C-2.62 501.3 5.09 512 16.01 512h280.92c13.77 0 26-8.81 30.36-21.88 12.83-38.48 24.71-72.4 24.71-126.05V192c0-83.6 23.67-153.52 60.44-192H128zM96 224c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm64 0c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm64 0c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm64 0c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zM480 0c-53.02 0-96 85.96-96 192s42.98 192 96 192 96-85.96 96-192S533.02 0 480 0zm0 256c-17.67 0-32-28.65-32-64s14.33-64 32-64 32 28.65 32 64-14.33 64-32 64z"]
};
var faToiletPaperSlash = {
  prefix: 'fas',
  iconName: 'toilet-paper-slash',
  icon: [640, 512, [], "e072", "M64,192V364.13c0,41.12-9.75,62.75-31.12,126.87A16,16,0,0,0,48,512H328.86a31.87,31.87,0,0,0,30.38-21.87c9.31-27.83,18-53.35,22.18-85.55l-316-244.25C64.53,170.66,64,181.19,64,192ZM633.82,458.09l-102-78.81C575.28,360.91,608,284.32,608,192,608,86,565,0,512,0s-96,86-96,192c0,42,7,80.4,18.43,112L384,265V192c0-83.62,23.63-153.5,60.5-192H160c-23.33,0-44.63,16.83-61.26,44.53L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.45A16,16,0,0,0,6.18,53.91L594.54,508.63A16,16,0,0,0,617,505.81l19.64-25.26A16,16,0,0,0,633.82,458.09ZM512,256c-17.63,0-32-28.62-32-64s14.37-64,32-64,32,28.63,32,64S529.62,256,512,256Z"]
};
var faToolbox = {
  prefix: 'fas',
  iconName: 'toolbox',
  icon: [512, 512, [], "f552", "M502.63 214.63l-45.25-45.25c-6-6-14.14-9.37-22.63-9.37H384V80c0-26.51-21.49-48-48-48H176c-26.51 0-48 21.49-48 48v80H77.25c-8.49 0-16.62 3.37-22.63 9.37L9.37 214.63c-6 6-9.37 14.14-9.37 22.63V320h128v-16c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v16h128v-16c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v16h128v-82.75c0-8.48-3.37-16.62-9.37-22.62zM320 160H192V96h128v64zm64 208c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-16H192v16c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-16H0v96c0 17.67 14.33 32 32 32h448c17.67 0 32-14.33 32-32v-96H384v16z"]
};
var faTools = {
  prefix: 'fas',
  iconName: 'tools',
  icon: [512, 512, [], "f7d9", "M501.1 395.7L384 278.6c-23.1-23.1-57.6-27.6-85.4-13.9L192 158.1V96L64 0 0 64l96 128h62.1l106.6 106.6c-13.6 27.8-9.2 62.3 13.9 85.4l117.1 117.1c14.6 14.6 38.2 14.6 52.7 0l52.7-52.7c14.5-14.6 14.5-38.2 0-52.7zM331.7 225c28.3 0 54.9 11 74.9 31l19.4 19.4c15.8-6.9 30.8-16.5 43.8-29.5 37.1-37.1 49.7-89.3 37.9-136.7-2.2-9-13.5-12.1-20.1-5.5l-74.4 74.4-67.9-11.3L334 98.9l74.4-74.4c6.6-6.6 3.4-17.9-5.7-20.2-47.4-11.7-99.6.9-136.6 37.9-28.5 28.5-41.9 66.1-41.2 103.6l82.1 82.1c8.1-1.9 16.5-2.9 24.7-2.9zm-103.9 82l-56.7-56.7L18.7 402.8c-25 25-25 65.5 0 90.5s65.5 25 90.5 0l123.6-123.6c-7.6-19.9-9.9-41.6-5-62.7zM64 472c-13.2 0-24-10.8-24-24 0-13.3 10.7-24 24-24s24 10.7 24 24c0 13.2-10.7 24-24 24z"]
};
var faTooth = {
  prefix: 'fas',
  iconName: 'tooth',
  icon: [448, 512, [], "f5c9", "M443.98 96.25c-11.01-45.22-47.11-82.06-92.01-93.72-32.19-8.36-63 5.1-89.14 24.33-3.25 2.39-6.96 3.73-10.5 5.48l28.32 18.21c7.42 4.77 9.58 14.67 4.8 22.11-4.46 6.95-14.27 9.86-22.11 4.8L162.83 12.84c-20.7-10.85-43.38-16.4-66.81-10.31-44.9 11.67-81 48.5-92.01 93.72-10.13 41.62-.42 80.81 21.5 110.43 23.36 31.57 32.68 68.66 36.29 107.35 4.4 47.16 10.33 94.16 20.94 140.32l7.8 33.95c3.19 13.87 15.49 23.7 29.67 23.7 13.97 0 26.15-9.55 29.54-23.16l34.47-138.42c4.56-18.32 20.96-31.16 39.76-31.16s35.2 12.85 39.76 31.16l34.47 138.42c3.39 13.61 15.57 23.16 29.54 23.16 14.18 0 26.48-9.83 29.67-23.7l7.8-33.95c10.61-46.15 16.53-93.16 20.94-140.32 3.61-38.7 12.93-75.78 36.29-107.35 21.95-29.61 31.66-68.8 21.53-110.43z"]
};
var faTorah = {
  prefix: 'fas',
  iconName: 'torah',
  icon: [640, 512, [], "f6a0", "M320.05 366.48l17.72-29.64h-35.46zm99.21-166H382.4l18.46 30.82zM48 0C21.49 0 0 14.33 0 32v448c0 17.67 21.49 32 48 32s48-14.33 48-32V32C96 14.33 74.51 0 48 0zm172.74 311.5h36.85l-18.46-30.82zm161.71 0h36.86l-18.45-30.8zM128 464h384V48H128zm66.77-278.13a21.22 21.22 0 0 1 18.48-10.71h59.45l29.13-48.71a21.13 21.13 0 0 1 18.22-10.37A20.76 20.76 0 0 1 338 126.29l29.25 48.86h59.52a21.12 21.12 0 0 1 18.1 32L415.63 256 445 305a20.69 20.69 0 0 1 .24 21.12 21.25 21.25 0 0 1-18.48 10.72h-59.47l-29.13 48.7a21.13 21.13 0 0 1-18.16 10.4 20.79 20.79 0 0 1-18-10.22l-29.25-48.88h-59.5a21.11 21.11 0 0 1-18.1-32L224.36 256 195 207a20.7 20.7 0 0 1-.23-21.13zM592 0c-26.51 0-48 14.33-48 32v448c0 17.67 21.49 32 48 32s48-14.33 48-32V32c0-17.67-21.49-32-48-32zM320 145.53l-17.78 29.62h35.46zm-62.45 55h-36.81l18.44 30.8zm29.58 111h65.79L386.09 256l-33.23-55.52h-65.79L253.9 256z"]
};
var faToriiGate = {
  prefix: 'fas',
  iconName: 'torii-gate',
  icon: [512, 512, [], "f6a1", "M376.45 32h-240.9A303.17 303.17 0 0 1 0 0v96c0 17.67 14.33 32 32 32h32v64H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h48v240c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V256h256v240c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V256h48c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16h-48v-64h32c17.67 0 32-14.33 32-32V0a303.17 303.17 0 0 1-135.55 32zM128 128h96v64h-96v-64zm256 64h-96v-64h96v64z"]
};
var faTractor = {
  prefix: 'fas',
  iconName: 'tractor',
  icon: [640, 512, [], "f722", "M528 336c-48.6 0-88 39.4-88 88s39.4 88 88 88 88-39.4 88-88-39.4-88-88-88zm0 112c-13.23 0-24-10.77-24-24s10.77-24 24-24 24 10.77 24 24-10.77 24-24 24zm80-288h-64v-40.2c0-14.12 4.7-27.76 13.15-38.84 4.42-5.8 3.55-14.06-1.32-19.49L534.2 37.3c-6.66-7.45-18.32-6.92-24.7.78C490.58 60.9 480 89.81 480 119.8V160H377.67L321.58 29.14A47.914 47.914 0 0 0 277.45 0H144c-26.47 0-48 21.53-48 48v146.52c-8.63-6.73-20.96-6.46-28.89 1.47L36 227.1c-8.59 8.59-8.59 22.52 0 31.11l5.06 5.06c-4.99 9.26-8.96 18.82-11.91 28.72H22c-12.15 0-22 9.85-22 22v44c0 12.15 9.85 22 22 22h7.14c2.96 9.91 6.92 19.46 11.91 28.73l-5.06 5.06c-8.59 8.59-8.59 22.52 0 31.11L67.1 476c8.59 8.59 22.52 8.59 31.11 0l5.06-5.06c9.26 4.99 18.82 8.96 28.72 11.91V490c0 12.15 9.85 22 22 22h44c12.15 0 22-9.85 22-22v-7.14c9.9-2.95 19.46-6.92 28.72-11.91l5.06 5.06c8.59 8.59 22.52 8.59 31.11 0l31.11-31.11c8.59-8.59 8.59-22.52 0-31.11l-5.06-5.06c4.99-9.26 8.96-18.82 11.91-28.72H330c12.15 0 22-9.85 22-22v-6h80.54c21.91-28.99 56.32-48 95.46-48 18.64 0 36.07 4.61 51.8 12.2l50.82-50.82c6-6 9.37-14.14 9.37-22.63V192c.01-17.67-14.32-32-31.99-32zM176 416c-44.18 0-80-35.82-80-80s35.82-80 80-80 80 35.82 80 80-35.82 80-80 80zm22-256h-38V64h106.89l41.15 96H198z"]
};
var faTrademark = {
  prefix: 'fas',
  iconName: 'trademark',
  icon: [640, 512, [], "f25c", "M260.6 96H12c-6.6 0-12 5.4-12 12v43.1c0 6.6 5.4 12 12 12h85.1V404c0 6.6 5.4 12 12 12h54.3c6.6 0 12-5.4 12-12V163.1h85.1c6.6 0 12-5.4 12-12V108c.1-6.6-5.3-12-11.9-12zM640 403l-24-296c-.5-6.2-5.7-11-12-11h-65.4c-5.1 0-9.7 3.3-11.3 8.1l-43.8 127.1c-7.2 20.6-16.1 52.8-16.1 52.8h-.9s-8.9-32.2-16.1-52.8l-43.8-127.1c-1.7-4.8-6.2-8.1-11.3-8.1h-65.4c-6.2 0-11.4 4.8-12 11l-24.4 296c-.6 7 4.9 13 12 13H360c6.3 0 11.5-4.9 12-11.2l9.1-132.9c1.8-24.2 0-53.7 0-53.7h.9s10.7 33.6 17.9 53.7l30.7 84.7c1.7 4.7 6.2 7.9 11.3 7.9h50.3c5.1 0 9.6-3.2 11.3-7.9l30.7-84.7c7.2-20.1 17.9-53.7 17.9-53.7h.9s-1.8 29.5 0 53.7l9.1 132.9c.4 6.3 5.7 11.2 12 11.2H628c7 0 12.5-6 12-13z"]
};
var faTrafficLight = {
  prefix: 'fas',
  iconName: 'traffic-light',
  icon: [384, 512, [], "f637", "M384 192h-64v-37.88c37.2-13.22 64-48.38 64-90.12h-64V32c0-17.67-14.33-32-32-32H96C78.33 0 64 14.33 64 32v32H0c0 41.74 26.8 76.9 64 90.12V192H0c0 41.74 26.8 76.9 64 90.12V320H0c0 42.84 28.25 78.69 66.99 91.05C79.42 468.72 130.6 512 192 512s112.58-43.28 125.01-100.95C355.75 398.69 384 362.84 384 320h-64v-37.88c37.2-13.22 64-48.38 64-90.12zM192 416c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm0-128c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm0-128c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48z"]
};
var faTrailer = {
  prefix: 'fas',
  iconName: 'trailer',
  icon: [640, 512, [], "e041", "M624,320H544V80a16,16,0,0,0-16-16H16A16,16,0,0,0,0,80V368a16,16,0,0,0,16,16H65.61c7.83-54.21,54-96,110.39-96s102.56,41.79,110.39,96H624a16,16,0,0,0,16-16V336A16,16,0,0,0,624,320ZM96,243.68a176.29,176.29,0,0,0-32,20.71V136a8,8,0,0,1,8-8H88a8,8,0,0,1,8,8Zm96-18.54c-5.31-.49-10.57-1.14-16-1.14s-10.69.65-16,1.14V136a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8Zm96,39.25a176.29,176.29,0,0,0-32-20.71V136a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8ZM384,320H352V136a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8Zm96,0H448V136a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8Zm-304,0a80,80,0,1,0,80,80A80,80,0,0,0,176,320Zm0,112a32,32,0,1,1,32-32A32,32,0,0,1,176,432Z"]
};
var faTrain = {
  prefix: 'fas',
  iconName: 'train',
  icon: [448, 512, [], "f238", "M448 96v256c0 51.815-61.624 96-130.022 96l62.98 49.721C386.905 502.417 383.562 512 376 512H72c-7.578 0-10.892-9.594-4.957-14.279L130.022 448C61.82 448 0 403.954 0 352V96C0 42.981 64 0 128 0h192c65 0 128 42.981 128 96zm-48 136V120c0-13.255-10.745-24-24-24H72c-13.255 0-24 10.745-24 24v112c0 13.255 10.745 24 24 24h304c13.255 0 24-10.745 24-24zm-176 64c-30.928 0-56 25.072-56 56s25.072 56 56 56 56-25.072 56-56-25.072-56-56-56z"]
};
var faTram = {
  prefix: 'fas',
  iconName: 'tram',
  icon: [512, 512, [], "f7da", "M288 64c17.7 0 32-14.3 32-32S305.7 0 288 0s-32 14.3-32 32 14.3 32 32 32zm223.5-12.1c-2.3-8.6-11-13.6-19.6-11.3l-480 128c-8.5 2.3-13.6 11-11.3 19.6C2.5 195.3 8.9 200 16 200c1.4 0 2.8-.2 4.1-.5L240 140.8V224H64c-17.7 0-32 14.3-32 32v224c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32H272v-91.7l228.1-60.8c8.6-2.3 13.6-11.1 11.4-19.6zM176 384H80v-96h96v96zm160-96h96v96h-96v-96zm-32 0v96h-96v-96h96zM192 96c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32z"]
};
var faTransgender = {
  prefix: 'fas',
  iconName: 'transgender',
  icon: [384, 512, [], "f224", "M372 0h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-80.7 80.7C198.5 104.1 172.2 96 144 96 64.5 96 0 160.5 0 240c0 68.5 47.9 125.9 112 140.4V408H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v28c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-28h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-27.6c64.1-14.6 112-71.9 112-140.4 0-28.2-8.1-54.5-22.1-76.7l80.7-80.7 16.9 16.9c7.6 7.6 20.5 2.2 20.5-8.5V12c0-6.6-5.4-12-12-12zM144 320c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"]
};
var faTransgenderAlt = {
  prefix: 'fas',
  iconName: 'transgender-alt',
  icon: [480, 512, [], "f225", "M468 0h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-80.7 80.7C294.5 104.1 268.2 96 240 96c-28.2 0-54.5 8.1-76.7 22.1l-16.5-16.5 19.8-19.8c4.7-4.7 4.7-12.3 0-17l-28.3-28.3c-4.7-4.7-12.3-4.7-17 0l-19.8 19.8-19-19 16.9-16.9C107.1 12.9 101.7 0 91 0H12C5.4 0 0 5.4 0 12v79c0 10.7 12.9 16 20.5 8.5l16.9-16.9 19 19-19.8 19.8c-4.7 4.7-4.7 12.3 0 17l28.3 28.3c4.7 4.7 12.3 4.7 17 0l19.8-19.8 16.5 16.5C104.1 185.5 96 211.8 96 240c0 68.5 47.9 125.9 112 140.4V408h-36c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v28c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-28h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-27.6c64.1-14.6 112-71.9 112-140.4 0-28.2-8.1-54.5-22.1-76.7l80.7-80.7 16.9 16.9c7.6 7.6 20.5 2.2 20.5-8.5V12c0-6.6-5.4-12-12-12zM240 320c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"]
};
var faTrash = {
  prefix: 'fas',
  iconName: 'trash',
  icon: [448, 512, [], "f1f8", "M432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM53.2 467a48 48 0 0 0 47.9 45h245.8a48 48 0 0 0 47.9-45L416 128H32z"]
};
var faTrashAlt = {
  prefix: 'fas',
  iconName: 'trash-alt',
  icon: [448, 512, [], "f2ed", "M32 464a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128H32zm272-256a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"]
};
var faTrashRestore = {
  prefix: 'fas',
  iconName: 'trash-restore',
  icon: [448, 512, [], "f829", "M53.2 467a48 48 0 0 0 47.9 45h245.8a48 48 0 0 0 47.9-45L416 128H32zm70.11-175.8l89.38-94.26a15.41 15.41 0 0 1 22.62 0l89.38 94.26c10.08 10.62 2.94 28.8-11.32 28.8H256v112a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V320h-57.37c-14.26 0-21.4-18.18-11.32-28.8zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"]
};
var faTrashRestoreAlt = {
  prefix: 'fas',
  iconName: 'trash-restore-alt',
  icon: [448, 512, [], "f82a", "M32 464a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128H32zm91.31-172.8l89.38-94.26a15.41 15.41 0 0 1 22.62 0l89.38 94.26c10.08 10.62 2.94 28.8-11.32 28.8H256v112a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V320h-57.37c-14.26 0-21.4-18.18-11.32-28.8zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"]
};
var faTree = {
  prefix: 'fas',
  iconName: 'tree',
  icon: [384, 512, [], "f1bb", "M378.31 378.49L298.42 288h30.63c9.01 0 16.98-5 20.78-13.06 3.8-8.04 2.55-17.26-3.28-24.05L268.42 160h28.89c9.1 0 17.3-5.35 20.86-13.61 3.52-8.13 1.86-17.59-4.24-24.08L203.66 4.83c-6.03-6.45-17.28-6.45-23.32 0L70.06 122.31c-6.1 6.49-7.75 15.95-4.24 24.08C69.38 154.65 77.59 160 86.69 160h28.89l-78.14 90.91c-5.81 6.78-7.06 15.99-3.27 24.04C37.97 283 45.93 288 54.95 288h30.63L5.69 378.49c-6 6.79-7.36 16.09-3.56 24.26 3.75 8.05 12 13.25 21.01 13.25H160v24.45l-30.29 48.4c-5.32 10.64 2.42 23.16 14.31 23.16h95.96c11.89 0 19.63-12.52 14.31-23.16L224 440.45V416h136.86c9.01 0 17.26-5.2 21.01-13.25 3.8-8.17 2.44-17.47-3.56-24.26z"]
};
var faTrophy = {
  prefix: 'fas',
  iconName: 'trophy',
  icon: [576, 512, [], "f091", "M552 64H448V24c0-13.3-10.7-24-24-24H152c-13.3 0-24 10.7-24 24v40H24C10.7 64 0 74.7 0 88v56c0 35.7 22.5 72.4 61.9 100.7 31.5 22.7 69.8 37.1 110 41.7C203.3 338.5 240 360 240 360v72h-48c-35.3 0-64 20.7-64 56v12c0 6.6 5.4 12 12 12h296c6.6 0 12-5.4 12-12v-12c0-35.3-28.7-56-64-56h-48v-72s36.7-21.5 68.1-73.6c40.3-4.6 78.6-19 110-41.7 39.3-28.3 61.9-65 61.9-100.7V88c0-13.3-10.7-24-24-24zM99.3 192.8C74.9 175.2 64 155.6 64 144v-16h64.2c1 32.6 5.8 61.2 12.8 86.2-15.1-5.2-29.2-12.4-41.7-21.4zM512 144c0 16.1-17.7 36.1-35.3 48.8-12.5 9-26.7 16.2-41.8 21.4 7-25 11.8-53.6 12.8-86.2H512v16z"]
};
var faTruck = {
  prefix: 'fas',
  iconName: 'truck',
  icon: [640, 512, [], "f0d1", "M624 352h-16V243.9c0-12.7-5.1-24.9-14.1-33.9L494 110.1c-9-9-21.2-14.1-33.9-14.1H416V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h16c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM160 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm320 0c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-208H416V144h44.1l99.9 99.9V256z"]
};
var faTruckLoading = {
  prefix: 'fas',
  iconName: 'truck-loading',
  icon: [640, 512, [], "f4de", "M50.2 375.6c2.3 8.5 11.1 13.6 19.6 11.3l216.4-58c8.5-2.3 13.6-11.1 11.3-19.6l-49.7-185.5c-2.3-8.5-11.1-13.6-19.6-11.3L151 133.3l24.8 92.7-61.8 16.5-24.8-92.7-77.3 20.7C3.4 172.8-1.7 181.6.6 190.1l49.6 185.5zM384 0c-17.7 0-32 14.3-32 32v323.6L5.9 450c-4.3 1.2-6.8 5.6-5.6 9.8l12.6 46.3c1.2 4.3 5.6 6.8 9.8 5.6l393.7-107.4C418.8 464.1 467.6 512 528 512c61.9 0 112-50.1 112-112V0H384zm144 448c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"]
};
var faTruckMonster = {
  prefix: 'fas',
  iconName: 'truck-monster',
  icon: [640, 512, [], "f63b", "M624 224h-16v-64c0-17.67-14.33-32-32-32h-73.6L419.22 24.02A64.025 64.025 0 0 0 369.24 0H256c-17.67 0-32 14.33-32 32v96H48c-8.84 0-16 7.16-16 16v80H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h16.72c29.21-38.65 75.1-64 127.28-64s98.07 25.35 127.28 64h65.45c29.21-38.65 75.1-64 127.28-64s98.07 25.35 127.28 64H624c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-336-96V64h81.24l51.2 64H288zm304 224h-5.2c-2.2-7.33-5.07-14.28-8.65-20.89l3.67-3.67c6.25-6.25 6.25-16.38 0-22.63l-22.63-22.63c-6.25-6.25-16.38-6.25-22.63 0l-3.67 3.67A110.85 110.85 0 0 0 512 277.2V272c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v5.2c-7.33 2.2-14.28 5.07-20.89 8.65l-3.67-3.67c-6.25-6.25-16.38-6.25-22.63 0l-22.63 22.63c-6.25 6.25-6.25 16.38 0 22.63l3.67 3.67A110.85 110.85 0 0 0 373.2 352H368c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h5.2c2.2 7.33 5.07 14.28 8.65 20.89l-3.67 3.67c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l3.67-3.67c6.61 3.57 13.57 6.45 20.9 8.65v5.2c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-5.2c7.33-2.2 14.28-5.07 20.9-8.65l3.67 3.67c6.25 6.25 16.38 6.25 22.63 0l22.63-22.63c6.25-6.25 6.25-16.38 0-22.63l-3.67-3.67a110.85 110.85 0 0 0 8.65-20.89h5.2c8.84 0 16-7.16 16-16v-32c-.02-8.84-7.18-16-16.02-16zm-112 80c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm-208-80h-5.2c-2.2-7.33-5.07-14.28-8.65-20.89l3.67-3.67c6.25-6.25 6.25-16.38 0-22.63l-22.63-22.63c-6.25-6.25-16.38-6.25-22.63 0l-3.67 3.67A110.85 110.85 0 0 0 192 277.2V272c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v5.2c-7.33 2.2-14.28 5.07-20.89 8.65l-3.67-3.67c-6.25-6.25-16.38-6.25-22.63 0L58.18 304.8c-6.25 6.25-6.25 16.38 0 22.63l3.67 3.67a110.85 110.85 0 0 0-8.65 20.89H48c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h5.2c2.2 7.33 5.07 14.28 8.65 20.89l-3.67 3.67c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l3.67-3.67c6.61 3.57 13.57 6.45 20.9 8.65v5.2c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-5.2c7.33-2.2 14.28-5.07 20.9-8.65l3.67 3.67c6.25 6.25 16.38 6.25 22.63 0l22.63-22.63c6.25-6.25 6.25-16.38 0-22.63l-3.67-3.67a110.85 110.85 0 0 0 8.65-20.89h5.2c8.84 0 16-7.16 16-16v-32C288 359.16 280.84 352 272 352zm-112 80c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48z"]
};
var faTruckMoving = {
  prefix: 'fas',
  iconName: 'truck-moving',
  icon: [640, 512, [], "f4df", "M621.3 237.3l-58.5-58.5c-12-12-28.3-18.7-45.3-18.7H480V64c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64v336c0 44.2 35.8 80 80 80 26.3 0 49.4-12.9 64-32.4 14.6 19.6 37.7 32.4 64 32.4 44.2 0 80-35.8 80-80 0-5.5-.6-10.8-1.6-16h163.2c-1.1 5.2-1.6 10.5-1.6 16 0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.6-10.8-1.6-16H624c8.8 0 16-7.2 16-16v-85.5c0-17-6.7-33.2-18.7-45.2zM80 432c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm128 0c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm272-224h37.5c4.3 0 8.3 1.7 11.3 4.7l43.3 43.3H480v-48zm48 224c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32z"]
};
var faTruckPickup = {
  prefix: 'fas',
  iconName: 'truck-pickup',
  icon: [640, 512, [], "f63c", "M624 288h-16v-64c0-17.67-14.33-32-32-32h-48L419.22 56.02A64.025 64.025 0 0 0 369.24 32H256c-17.67 0-32 14.33-32 32v128H64c-17.67 0-32 14.33-32 32v64H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h49.61c-.76 5.27-1.61 10.52-1.61 16 0 61.86 50.14 112 112 112s112-50.14 112-112c0-5.48-.85-10.73-1.61-16h67.23c-.76 5.27-1.61 10.52-1.61 16 0 61.86 50.14 112 112 112s112-50.14 112-112c0-5.48-.85-10.73-1.61-16H624c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM288 96h81.24l76.8 96H288V96zM176 416c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48zm288 0c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48z"]
};
var faTshirt = {
  prefix: 'fas',
  iconName: 'tshirt',
  icon: [640, 512, [], "f553", "M631.2 96.5L436.5 0C416.4 27.8 371.9 47.2 320 47.2S223.6 27.8 203.5 0L8.8 96.5c-7.9 4-11.1 13.6-7.2 21.5l57.2 114.5c4 7.9 13.6 11.1 21.5 7.2l56.6-27.7c10.6-5.2 23 2.5 23 14.4V480c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32V226.3c0-11.8 12.4-19.6 23-14.4l56.6 27.7c7.9 4 17.5.8 21.5-7.2L638.3 118c4-7.9.8-17.6-7.1-21.5z"]
};
var faTty = {
  prefix: 'fas',
  iconName: 'tty',
  icon: [512, 512, [], "f1e4", "M5.37 103.822c138.532-138.532 362.936-138.326 501.262 0 6.078 6.078 7.074 15.496 2.583 22.681l-43.214 69.138a18.332 18.332 0 0 1-22.356 7.305l-86.422-34.569a18.335 18.335 0 0 1-11.434-18.846L351.741 90c-62.145-22.454-130.636-21.986-191.483 0l5.953 59.532a18.331 18.331 0 0 1-11.434 18.846l-86.423 34.568a18.334 18.334 0 0 1-22.356-7.305L2.787 126.502a18.333 18.333 0 0 1 2.583-22.68zM96 308v-40c0-6.627-5.373-12-12-12H44c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm-336 96v-40c0-6.627-5.373-12-12-12H92c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zM96 500v-40c0-6.627-5.373-12-12-12H44c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm288 0v-40c0-6.627-5.373-12-12-12H140c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h232c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12z"]
};
var faTv = {
  prefix: 'fas',
  iconName: 'tv',
  icon: [640, 512, [], "f26c", "M592 0H48A48 48 0 0 0 0 48v320a48 48 0 0 0 48 48h240v32H112a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H352v-32h240a48 48 0 0 0 48-48V48a48 48 0 0 0-48-48zm-16 352H64V64h512z"]
};
var faUmbrella = {
  prefix: 'fas',
  iconName: 'umbrella',
  icon: [576, 512, [], "f0e9", "M575.7 280.8C547.1 144.5 437.3 62.6 320 49.9V32c0-17.7-14.3-32-32-32s-32 14.3-32 32v17.9C138.3 62.6 29.5 144.5.3 280.8c-2.2 10.1 8.5 21.3 18.7 11.4 52-55 107.7-52.4 158.6 37 5.3 9.5 14.9 8.6 19.7 0 20.2-35.4 44.9-73.2 90.7-73.2 58.5 0 88.2 68.8 90.7 73.2 4.8 8.6 14.4 9.5 19.7 0 51-89.5 107.1-91.4 158.6-37 10.3 10 20.9-1.3 18.7-11.4zM256 301.7V432c0 8.8-7.2 16-16 16-7.8 0-13.2-5.3-15.1-10.7-5.9-16.7-24.1-25.4-40.8-19.5-16.7 5.9-25.4 24.2-19.5 40.8 11.2 31.9 41.6 53.3 75.4 53.3 44.1 0 80-35.9 80-80V301.6c-9.1-7.9-19.8-13.6-32-13.6-12.3.1-22.4 4.8-32 13.7z"]
};
var faUmbrellaBeach = {
  prefix: 'fas',
  iconName: 'umbrella-beach',
  icon: [640, 512, [], "f5ca", "M115.38 136.9l102.11 37.18c35.19-81.54 86.21-144.29 139-173.7-95.88-4.89-188.78 36.96-248.53 111.8-6.69 8.4-2.66 21.05 7.42 24.72zm132.25 48.16l238.48 86.83c35.76-121.38 18.7-231.66-42.63-253.98-7.4-2.7-15.13-4-23.09-4-58.02.01-128.27 69.17-172.76 171.15zM521.48 60.5c6.22 16.3 10.83 34.6 13.2 55.19 5.74 49.89-1.42 108.23-18.95 166.98l102.62 37.36c10.09 3.67 21.31-3.43 21.57-14.17 2.32-95.69-41.91-187.44-118.44-245.36zM560 447.98H321.06L386 269.5l-60.14-21.9-72.9 200.37H16c-8.84 0-16 7.16-16 16.01v32.01C0 504.83 7.16 512 16 512h544c8.84 0 16-7.17 16-16.01v-32.01c0-8.84-7.16-16-16-16z"]
};
var faUnderline = {
  prefix: 'fas',
  iconName: 'underline',
  icon: [448, 512, [], "f0cd", "M32 64h32v160c0 88.22 71.78 160 160 160s160-71.78 160-160V64h32a16 16 0 0 0 16-16V16a16 16 0 0 0-16-16H272a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32v160a80 80 0 0 1-160 0V64h32a16 16 0 0 0 16-16V16a16 16 0 0 0-16-16H32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm400 384H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"]
};
var faUndo = {
  prefix: 'fas',
  iconName: 'undo',
  icon: [512, 512, [], "f0e2", "M212.333 224.333H12c-6.627 0-12-5.373-12-12V12C0 5.373 5.373 0 12 0h48c6.627 0 12 5.373 12 12v78.112C117.773 39.279 184.26 7.47 258.175 8.007c136.906.994 246.448 111.623 246.157 248.532C504.041 393.258 393.12 504 256.333 504c-64.089 0-122.496-24.313-166.51-64.215-5.099-4.622-5.334-12.554-.467-17.42l33.967-33.967c4.474-4.474 11.662-4.717 16.401-.525C170.76 415.336 211.58 432 256.333 432c97.268 0 176-78.716 176-176 0-97.267-78.716-176-176-176-58.496 0-110.28 28.476-142.274 72.333h98.274c6.627 0 12 5.373 12 12v48c0 6.627-5.373 12-12 12z"]
};
var faUndoAlt = {
  prefix: 'fas',
  iconName: 'undo-alt',
  icon: [512, 512, [], "f2ea", "M255.545 8c-66.269.119-126.438 26.233-170.86 68.685L48.971 40.971C33.851 25.851 8 36.559 8 57.941V192c0 13.255 10.745 24 24 24h134.059c21.382 0 32.09-25.851 16.971-40.971l-41.75-41.75c30.864-28.899 70.801-44.907 113.23-45.273 92.398-.798 170.283 73.977 169.484 169.442C423.236 348.009 349.816 424 256 424c-41.127 0-79.997-14.678-110.63-41.556-4.743-4.161-11.906-3.908-16.368.553L89.34 422.659c-4.872 4.872-4.631 12.815.482 17.433C133.798 479.813 192.074 504 256 504c136.966 0 247.999-111.033 248-247.998C504.001 119.193 392.354 7.755 255.545 8z"]
};
var faUniversalAccess = {
  prefix: 'fas',
  iconName: 'universal-access',
  icon: [512, 512, [], "f29a", "M256 48c114.953 0 208 93.029 208 208 0 114.953-93.029 208-208 208-114.953 0-208-93.029-208-208 0-114.953 93.029-208 208-208m0-40C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 56C149.961 64 64 149.961 64 256s85.961 192 192 192 192-85.961 192-192S362.039 64 256 64zm0 44c19.882 0 36 16.118 36 36s-16.118 36-36 36-36-16.118-36-36 16.118-36 36-36zm117.741 98.023c-28.712 6.779-55.511 12.748-82.14 15.807.851 101.023 12.306 123.052 25.037 155.621 3.617 9.26-.957 19.698-10.217 23.315-9.261 3.617-19.699-.957-23.316-10.217-8.705-22.308-17.086-40.636-22.261-78.549h-9.686c-5.167 37.851-13.534 56.208-22.262 78.549-3.615 9.255-14.05 13.836-23.315 10.217-9.26-3.617-13.834-14.056-10.217-23.315 12.713-32.541 24.185-54.541 25.037-155.621-26.629-3.058-53.428-9.027-82.141-15.807-8.6-2.031-13.926-10.648-11.895-19.249s10.647-13.926 19.249-11.895c96.686 22.829 124.283 22.783 220.775 0 8.599-2.03 17.218 3.294 19.249 11.895 2.029 8.601-3.297 17.219-11.897 19.249z"]
};
var faUniversity = {
  prefix: 'fas',
  iconName: 'university',
  icon: [512, 512, [], "f19c", "M496 128v16a8 8 0 0 1-8 8h-24v12c0 6.627-5.373 12-12 12H60c-6.627 0-12-5.373-12-12v-12H24a8 8 0 0 1-8-8v-16a8 8 0 0 1 4.941-7.392l232-88a7.996 7.996 0 0 1 6.118 0l232 88A8 8 0 0 1 496 128zm-24 304H40c-13.255 0-24 10.745-24 24v16a8 8 0 0 0 8 8h464a8 8 0 0 0 8-8v-16c0-13.255-10.745-24-24-24zM96 192v192H60c-6.627 0-12 5.373-12 12v20h416v-20c0-6.627-5.373-12-12-12h-36V192h-64v192h-64V192h-64v192h-64V192H96z"]
};
var faUnlink = {
  prefix: 'fas',
  iconName: 'unlink',
  icon: [512, 512, [], "f127", "M304.083 405.907c4.686 4.686 4.686 12.284 0 16.971l-44.674 44.674c-59.263 59.262-155.693 59.266-214.961 0-59.264-59.265-59.264-155.696 0-214.96l44.675-44.675c4.686-4.686 12.284-4.686 16.971 0l39.598 39.598c4.686 4.686 4.686 12.284 0 16.971l-44.675 44.674c-28.072 28.073-28.072 73.75 0 101.823 28.072 28.072 73.75 28.073 101.824 0l44.674-44.674c4.686-4.686 12.284-4.686 16.971 0l39.597 39.598zm-56.568-260.216c4.686 4.686 12.284 4.686 16.971 0l44.674-44.674c28.072-28.075 73.75-28.073 101.824 0 28.072 28.073 28.072 73.75 0 101.823l-44.675 44.674c-4.686 4.686-4.686 12.284 0 16.971l39.598 39.598c4.686 4.686 12.284 4.686 16.971 0l44.675-44.675c59.265-59.265 59.265-155.695 0-214.96-59.266-59.264-155.695-59.264-214.961 0l-44.674 44.674c-4.686 4.686-4.686 12.284 0 16.971l39.597 39.598zm234.828 359.28l22.627-22.627c9.373-9.373 9.373-24.569 0-33.941L63.598 7.029c-9.373-9.373-24.569-9.373-33.941 0L7.029 29.657c-9.373 9.373-9.373 24.569 0 33.941l441.373 441.373c9.373 9.372 24.569 9.372 33.941 0z"]
};
var faUnlock = {
  prefix: 'fas',
  iconName: 'unlock',
  icon: [448, 512, [], "f09c", "M400 256H152V152.9c0-39.6 31.7-72.5 71.3-72.9 40-.4 72.7 32.1 72.7 72v16c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24v-16C376 68 307.5-.3 223.5 0 139.5.3 72 69.5 72 153.5V256H48c-26.5 0-48 21.5-48 48v160c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48z"]
};
var faUnlockAlt = {
  prefix: 'fas',
  iconName: 'unlock-alt',
  icon: [448, 512, [], "f13e", "M400 256H152V152.9c0-39.6 31.7-72.5 71.3-72.9 40-.4 72.7 32.1 72.7 72v16c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24v-16C376 68 307.5-.3 223.5 0 139.5.3 72 69.5 72 153.5V256H48c-26.5 0-48 21.5-48 48v160c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48zM264 408c0 22.1-17.9 40-40 40s-40-17.9-40-40v-48c0-22.1 17.9-40 40-40s40 17.9 40 40v48z"]
};
var faUpload = {
  prefix: 'fas',
  iconName: 'upload',
  icon: [512, 512, [], "f093", "M296 384h-80c-13.3 0-24-10.7-24-24V192h-87.7c-17.8 0-26.7-21.5-14.1-34.1L242.3 5.7c7.5-7.5 19.8-7.5 27.3 0l152.2 152.2c12.6 12.6 3.7 34.1-14.1 34.1H320v168c0 13.3-10.7 24-24 24zm216-8v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h136v8c0 30.9 25.1 56 56 56h80c30.9 0 56-25.1 56-56v-8h136c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z"]
};
var faUser = {
  prefix: 'fas',
  iconName: 'user',
  icon: [448, 512, [], "f007", "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"]
};
var faUserAlt = {
  prefix: 'fas',
  iconName: 'user-alt',
  icon: [512, 512, [], "f406", "M256 288c79.5 0 144-64.5 144-144S335.5 0 256 0 112 64.5 112 144s64.5 144 144 144zm128 32h-55.1c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16H128C57.3 320 0 377.3 0 448v16c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48v-16c0-70.7-57.3-128-128-128z"]
};
var faUserAltSlash = {
  prefix: 'fas',
  iconName: 'user-alt-slash',
  icon: [640, 512, [], "f4fa", "M633.8 458.1L389.6 269.3C433.8 244.7 464 198.1 464 144 464 64.5 399.5 0 320 0c-67.1 0-123 46.1-139 108.2L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4l588.4 454.7c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.4-6.8 4.1-16.9-2.9-22.3zM198.4 320C124.2 320 64 380.2 64 454.4v9.6c0 26.5 21.5 48 48 48h382.2L245.8 320h-47.4z"]
};
var faUserAstronaut = {
  prefix: 'fas',
  iconName: 'user-astronaut',
  icon: [448, 512, [], "f4fb", "M64 224h13.5c24.7 56.5 80.9 96 146.5 96s121.8-39.5 146.5-96H384c8.8 0 16-7.2 16-16v-96c0-8.8-7.2-16-16-16h-13.5C345.8 39.5 289.6 0 224 0S102.2 39.5 77.5 96H64c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16zm40-88c0-22.1 21.5-40 48-40h144c26.5 0 48 17.9 48 40v24c0 53-43 96-96 96h-48c-53 0-96-43-96-96v-24zm72 72l12-36 36-12-36-12-12-36-12 36-36 12 36 12 12 36zm151.6 113.4C297.7 340.7 262.2 352 224 352s-73.7-11.3-103.6-30.6C52.9 328.5 0 385 0 454.4v9.6c0 26.5 21.5 48 48 48h80v-64c0-17.7 14.3-32 32-32h128c17.7 0 32 14.3 32 32v64h80c26.5 0 48-21.5 48-48v-9.6c0-69.4-52.9-125.9-120.4-133zM272 448c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm-96 0c-8.8 0-16 7.2-16 16v48h32v-48c0-8.8-7.2-16-16-16z"]
};
var faUserCheck = {
  prefix: 'fas',
  iconName: 'user-check',
  icon: [640, 512, [], "f4fc", "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4zm323-128.4l-27.8-28.1c-4.6-4.7-12.1-4.7-16.8-.1l-104.8 104-45.5-45.8c-4.6-4.7-12.1-4.7-16.8-.1l-28.1 27.9c-4.7 4.6-4.7 12.1-.1 16.8l81.7 82.3c4.6 4.7 12.1 4.7 16.8.1l141.3-140.2c4.6-4.7 4.7-12.2.1-16.8z"]
};
var faUserCircle = {
  prefix: 'fas',
  iconName: 'user-circle',
  icon: [496, 512, [], "f2bd", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 96c48.6 0 88 39.4 88 88s-39.4 88-88 88-88-39.4-88-88 39.4-88 88-88zm0 344c-58.7 0-111.3-26.6-146.5-68.2 18.8-35.4 55.6-59.8 98.5-59.8 2.4 0 4.8.4 7.1 1.1 13 4.2 26.6 6.9 40.9 6.9 14.3 0 28-2.7 40.9-6.9 2.3-.7 4.7-1.1 7.1-1.1 42.9 0 79.7 24.4 98.5 59.8C359.3 421.4 306.7 448 248 448z"]
};
var faUserClock = {
  prefix: 'fas',
  iconName: 'user-clock',
  icon: [640, 512, [], "f4fd", "M496 224c-79.6 0-144 64.4-144 144s64.4 144 144 144 144-64.4 144-144-64.4-144-144-144zm64 150.3c0 5.3-4.4 9.7-9.7 9.7h-60.6c-5.3 0-9.7-4.4-9.7-9.7v-76.6c0-5.3 4.4-9.7 9.7-9.7h12.6c5.3 0 9.7 4.4 9.7 9.7V352h38.3c5.3 0 9.7 4.4 9.7 9.7v12.6zM320 368c0-27.8 6.7-54.1 18.2-77.5-8-1.5-16.2-2.5-24.6-2.5h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h347.1c-45.3-31.9-75.1-84.5-75.1-144zm-96-112c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128z"]
};
var faUserCog = {
  prefix: 'fas',
  iconName: 'user-cog',
  icon: [640, 512, [], "f4fe", "M610.5 373.3c2.6-14.1 2.6-28.5 0-42.6l25.8-14.9c3-1.7 4.3-5.2 3.3-8.5-6.7-21.6-18.2-41.2-33.2-57.4-2.3-2.5-6-3.1-9-1.4l-25.8 14.9c-10.9-9.3-23.4-16.5-36.9-21.3v-29.8c0-3.4-2.4-6.4-5.7-7.1-22.3-5-45-4.8-66.2 0-3.3.7-5.7 3.7-5.7 7.1v29.8c-13.5 4.8-26 12-36.9 21.3l-25.8-14.9c-2.9-1.7-6.7-1.1-9 1.4-15 16.2-26.5 35.8-33.2 57.4-1 3.3.4 6.8 3.3 8.5l25.8 14.9c-2.6 14.1-2.6 28.5 0 42.6l-25.8 14.9c-3 1.7-4.3 5.2-3.3 8.5 6.7 21.6 18.2 41.1 33.2 57.4 2.3 2.5 6 3.1 9 1.4l25.8-14.9c10.9 9.3 23.4 16.5 36.9 21.3v29.8c0 3.4 2.4 6.4 5.7 7.1 22.3 5 45 4.8 66.2 0 3.3-.7 5.7-3.7 5.7-7.1v-29.8c13.5-4.8 26-12 36.9-21.3l25.8 14.9c2.9 1.7 6.7 1.1 9-1.4 15-16.2 26.5-35.8 33.2-57.4 1-3.3-.4-6.8-3.3-8.5l-25.8-14.9zM496 400.5c-26.8 0-48.5-21.8-48.5-48.5s21.8-48.5 48.5-48.5 48.5 21.8 48.5 48.5-21.7 48.5-48.5 48.5zM224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm201.2 226.5c-2.3-1.2-4.6-2.6-6.8-3.9l-7.9 4.6c-6 3.4-12.8 5.3-19.6 5.3-10.9 0-21.4-4.6-28.9-12.6-18.3-19.8-32.3-43.9-40.2-69.6-5.5-17.7 1.9-36.4 17.9-45.7l7.9-4.6c-.1-2.6-.1-5.2 0-7.8l-7.9-4.6c-16-9.2-23.4-28-17.9-45.7.9-2.9 2.2-5.8 3.2-8.7-3.8-.3-7.5-1.2-11.4-1.2h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c10.1 0 19.5-3.2 27.2-8.5-1.2-3.8-2-7.7-2-11.8v-9.2z"]
};
var faUserEdit = {
  prefix: 'fas',
  iconName: 'user-edit',
  icon: [640, 512, [], "f4ff", "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h274.9c-2.4-6.8-3.4-14-2.6-21.3l6.8-60.9 1.2-11.1 7.9-7.9 77.3-77.3c-24.5-27.7-60-45.5-99.9-45.5zm45.3 145.3l-6.8 61c-1.1 10.2 7.5 18.8 17.6 17.6l60.9-6.8 137.9-137.9-71.7-71.7-137.9 137.8zM633 268.9L595.1 231c-9.3-9.3-24.5-9.3-33.8 0l-37.8 37.8-4.1 4.1 71.8 71.7 41.8-41.8c9.3-9.4 9.3-24.5 0-33.9z"]
};
var faUserFriends = {
  prefix: 'fas',
  iconName: 'user-friends',
  icon: [640, 512, [], "f500", "M192 256c61.9 0 112-50.1 112-112S253.9 32 192 32 80 82.1 80 144s50.1 112 112 112zm76.8 32h-8.3c-20.8 10-43.9 16-68.5 16s-47.6-6-68.5-16h-8.3C51.6 288 0 339.6 0 403.2V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-28.8c0-63.6-51.6-115.2-115.2-115.2zM480 256c53 0 96-43 96-96s-43-96-96-96-96 43-96 96 43 96 96 96zm48 32h-3.8c-13.9 4.8-28.6 8-44.2 8s-30.3-3.2-44.2-8H432c-20.4 0-39.2 5.9-55.7 15.4 24.4 26.3 39.7 61.2 39.7 99.8v38.4c0 2.2-.5 4.3-.6 6.4H592c26.5 0 48-21.5 48-48 0-61.9-50.1-112-112-112z"]
};
var faUserGraduate = {
  prefix: 'fas',
  iconName: 'user-graduate',
  icon: [448, 512, [], "f501", "M319.4 320.6L224 416l-95.4-95.4C57.1 323.7 0 382.2 0 454.4v9.6c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-9.6c0-72.2-57.1-130.7-128.6-133.8zM13.6 79.8l6.4 1.5v58.4c-7 4.2-12 11.5-12 20.3 0 8.4 4.6 15.4 11.1 19.7L3.5 242c-1.7 6.9 2.1 14 7.6 14h41.8c5.5 0 9.3-7.1 7.6-14l-15.6-62.3C51.4 175.4 56 168.4 56 160c0-8.8-5-16.1-12-20.3V87.1l66 15.9c-8.6 17.2-14 36.4-14 57 0 70.7 57.3 128 128 128s128-57.3 128-128c0-20.6-5.3-39.8-14-57l96.3-23.2c18.2-4.4 18.2-27.1 0-31.5l-190.4-46c-13-3.1-26.7-3.1-39.7 0L13.6 48.2c-18.1 4.4-18.1 27.2 0 31.6z"]
};
var faUserInjured = {
  prefix: 'fas',
  iconName: 'user-injured',
  icon: [448, 512, [], "f728", "M277.37 11.98C261.08 4.47 243.11 0 224 0c-53.69 0-99.5 33.13-118.51 80h81.19l90.69-68.02zM342.51 80c-7.9-19.47-20.67-36.2-36.49-49.52L239.99 80h102.52zM224 256c70.69 0 128-57.31 128-128 0-5.48-.95-10.7-1.61-16H97.61c-.67 5.3-1.61 10.52-1.61 16 0 70.69 57.31 128 128 128zM80 299.7V512h128.26l-98.45-221.52A132.835 132.835 0 0 0 80 299.7zM0 464c0 26.51 21.49 48 48 48V320.24C18.88 344.89 0 381.26 0 422.4V464zm256-48h-55.38l42.67 96H256c26.47 0 48-21.53 48-48s-21.53-48-48-48zm57.6-128h-16.71c-22.24 10.18-46.88 16-72.89 16s-50.65-5.82-72.89-16h-7.37l42.67 96H256c44.11 0 80 35.89 80 80 0 18.08-6.26 34.59-16.41 48H400c26.51 0 48-21.49 48-48v-41.6c0-74.23-60.17-134.4-134.4-134.4z"]
};
var faUserLock = {
  prefix: 'fas',
  iconName: 'user-lock',
  icon: [640, 512, [], "f502", "M224 256A128 128 0 1 0 96 128a128 128 0 0 0 128 128zm96 64a63.08 63.08 0 0 1 8.1-30.5c-4.8-.5-9.5-1.5-14.5-1.5h-16.7a174.08 174.08 0 0 1-145.8 0h-16.7A134.43 134.43 0 0 0 0 422.4V464a48 48 0 0 0 48 48h280.9a63.54 63.54 0 0 1-8.9-32zm288-32h-32v-80a80 80 0 0 0-160 0v80h-32a32 32 0 0 0-32 32v160a32 32 0 0 0 32 32h224a32 32 0 0 0 32-32V320a32 32 0 0 0-32-32zM496 432a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm32-144h-64v-80a32 32 0 0 1 64 0z"]
};
var faUserMd = {
  prefix: 'fas',
  iconName: 'user-md',
  icon: [448, 512, [], "f0f0", "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zM104 424c0 13.3 10.7 24 24 24s24-10.7 24-24-10.7-24-24-24-24 10.7-24 24zm216-135.4v49c36.5 7.4 64 39.8 64 78.4v41.7c0 7.6-5.4 14.2-12.9 15.7l-32.2 6.4c-4.3.9-8.5-1.9-9.4-6.3l-3.1-15.7c-.9-4.3 1.9-8.6 6.3-9.4l19.3-3.9V416c0-62.8-96-65.1-96 1.9v26.7l19.3 3.9c4.3.9 7.1 5.1 6.3 9.4l-3.1 15.7c-.9 4.3-5.1 7.1-9.4 6.3l-31.2-4.2c-7.9-1.1-13.8-7.8-13.8-15.9V416c0-38.6 27.5-70.9 64-78.4v-45.2c-2.2.7-4.4 1.1-6.6 1.9-18 6.3-37.3 9.8-57.4 9.8s-39.4-3.5-57.4-9.8c-7.4-2.6-14.9-4.2-22.6-5.2v81.6c23.1 6.9 40 28.1 40 53.4 0 30.9-25.1 56-56 56s-56-25.1-56-56c0-25.3 16.9-46.5 40-53.4v-80.4C48.5 301 0 355.8 0 422.4v44.8C0 491.9 20.1 512 44.8 512h358.4c24.7 0 44.8-20.1 44.8-44.8v-44.8c0-72-56.8-130.3-128-133.8z"]
};
var faUserMinus = {
  prefix: 'fas',
  iconName: 'user-minus',
  icon: [640, 512, [], "f503", "M624 208H432c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h192c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm-400 48c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"]
};
var faUserNinja = {
  prefix: 'fas',
  iconName: 'user-ninja',
  icon: [448, 512, [], "f504", "M325.4 289.2L224 390.6 122.6 289.2C54 295.3 0 352.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-70.2-54-127.1-122.6-133.2zM32 192c27.3 0 51.8-11.5 69.2-29.7 15.1 53.9 64 93.7 122.8 93.7 70.7 0 128-57.3 128-128S294.7 0 224 0c-50.4 0-93.6 29.4-114.5 71.8C92.1 47.8 64 32 32 32c0 33.4 17.1 62.8 43.1 80-26 17.2-43.1 46.6-43.1 80zm144-96h96c17.7 0 32 14.3 32 32H144c0-17.7 14.3-32 32-32z"]
};
var faUserNurse = {
  prefix: 'fas',
  iconName: 'user-nurse',
  icon: [448, 512, [], "f82f", "M319.41,320,224,415.39,128.59,320C57.1,323.1,0,381.6,0,453.79A58.21,58.21,0,0,0,58.21,512H389.79A58.21,58.21,0,0,0,448,453.79C448,381.6,390.9,323.1,319.41,320ZM224,304A128,128,0,0,0,352,176V65.82a32,32,0,0,0-20.76-30L246.47,4.07a64,64,0,0,0-44.94,0L116.76,35.86A32,32,0,0,0,96,65.82V176A128,128,0,0,0,224,304ZM184,71.67a5,5,0,0,1,5-5h21.67V45a5,5,0,0,1,5-5h16.66a5,5,0,0,1,5,5V66.67H259a5,5,0,0,1,5,5V88.33a5,5,0,0,1-5,5H237.33V115a5,5,0,0,1-5,5H215.67a5,5,0,0,1-5-5V93.33H189a5,5,0,0,1-5-5ZM144,160H304v16a80,80,0,0,1-160,0Z"]
};
var faUserPlus = {
  prefix: 'fas',
  iconName: 'user-plus',
  icon: [640, 512, [], "f234", "M624 208h-64v-64c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v64h-64c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h64v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-64h64c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm-400 48c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"]
};
var faUserSecret = {
  prefix: 'fas',
  iconName: 'user-secret',
  icon: [448, 512, [], "f21b", "M383.9 308.3l23.9-62.6c4-10.5-3.7-21.7-15-21.7h-58.5c11-18.9 17.8-40.6 17.8-64v-.3c39.2-7.8 64-19.1 64-31.7 0-13.3-27.3-25.1-70.1-33-9.2-32.8-27-65.8-40.6-82.8-9.5-11.9-25.9-15.6-39.5-8.8l-27.6 13.8c-9 4.5-19.6 4.5-28.6 0L182.1 3.4c-13.6-6.8-30-3.1-39.5 8.8-13.5 17-31.4 50-40.6 82.8-42.7 7.9-70 19.7-70 33 0 12.6 24.8 23.9 64 31.7v.3c0 23.4 6.8 45.1 17.8 64H56.3c-11.5 0-19.2 11.7-14.7 22.3l25.8 60.2C27.3 329.8 0 372.7 0 422.4v44.8C0 491.9 20.1 512 44.8 512h358.4c24.7 0 44.8-20.1 44.8-44.8v-44.8c0-48.4-25.8-90.4-64.1-114.1zM176 480l-41.6-192 49.6 32 24 40-32 120zm96 0l-32-120 24-40 49.6-32L272 480zm41.7-298.5c-3.9 11.9-7 24.6-16.5 33.4-10.1 9.3-48 22.4-64-25-2.8-8.4-15.4-8.4-18.3 0-17 50.2-56 32.4-64 25-9.5-8.8-12.7-21.5-16.5-33.4-.8-2.5-6.3-5.7-6.3-5.8v-10.8c28.3 3.6 61 5.8 96 5.8s67.7-2.1 96-5.8v10.8c-.1.1-5.6 3.2-6.4 5.8z"]
};
var faUserShield = {
  prefix: 'fas',
  iconName: 'user-shield',
  icon: [640, 512, [], "f505", "M622.3 271.1l-115.2-45c-4.1-1.6-12.6-3.7-22.2 0l-115.2 45c-10.7 4.2-17.7 14-17.7 24.9 0 111.6 68.7 188.8 132.9 213.9 9.6 3.7 18 1.6 22.2 0C558.4 489.9 640 420.5 640 296c0-10.9-7-20.7-17.7-24.9zM496 462.4V273.3l95.5 37.3c-5.6 87.1-60.9 135.4-95.5 151.8zM224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm96 40c0-2.5.8-4.8 1.1-7.2-2.5-.1-4.9-.8-7.5-.8h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c6.8 0 13.3-1.5 19.2-4-54-42.9-99.2-116.7-99.2-212z"]
};
var faUserSlash = {
  prefix: 'fas',
  iconName: 'user-slash',
  icon: [640, 512, [], "f506", "M633.8 458.1L362.3 248.3C412.1 230.7 448 183.8 448 128 448 57.3 390.7 0 320 0c-67.1 0-121.5 51.8-126.9 117.4L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4l588.4 454.7c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.4-6.8 4.1-16.9-2.9-22.3zM96 422.4V464c0 26.5 21.5 48 48 48h350.2L207.4 290.3C144.2 301.3 96 356 96 422.4z"]
};
var faUserTag = {
  prefix: 'fas',
  iconName: 'user-tag',
  icon: [640, 512, [], "f507", "M630.6 364.9l-90.3-90.2c-12-12-28.3-18.7-45.3-18.7h-79.3c-17.7 0-32 14.3-32 32v79.2c0 17 6.7 33.2 18.7 45.2l90.3 90.2c12.5 12.5 32.8 12.5 45.3 0l92.5-92.5c12.6-12.5 12.6-32.7.1-45.2zm-182.8-21c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24c0 13.2-10.7 24-24 24zm-223.8-88c70.7 0 128-57.3 128-128C352 57.3 294.7 0 224 0S96 57.3 96 128c0 70.6 57.3 127.9 128 127.9zm127.8 111.2V294c-12.2-3.6-24.9-6.2-38.2-6.2h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 287.9 0 348.1 0 422.3v41.6c0 26.5 21.5 48 48 48h352c15.5 0 29.1-7.5 37.9-18.9l-58-58c-18.1-18.1-28.1-42.2-28.1-67.9z"]
};
var faUserTie = {
  prefix: 'fas',
  iconName: 'user-tie',
  icon: [448, 512, [], "f508", "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm95.8 32.6L272 480l-32-136 32-56h-96l32 56-32 136-47.8-191.4C56.9 292 0 350.3 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-72.1-56.9-130.4-128.2-133.8z"]
};
var faUserTimes = {
  prefix: 'fas',
  iconName: 'user-times',
  icon: [640, 512, [], "f235", "M589.6 240l45.6-45.6c6.3-6.3 6.3-16.5 0-22.8l-22.8-22.8c-6.3-6.3-16.5-6.3-22.8 0L544 194.4l-45.6-45.6c-6.3-6.3-16.5-6.3-22.8 0l-22.8 22.8c-6.3 6.3-6.3 16.5 0 22.8l45.6 45.6-45.6 45.6c-6.3 6.3-6.3 16.5 0 22.8l22.8 22.8c6.3 6.3 16.5 6.3 22.8 0l45.6-45.6 45.6 45.6c6.3 6.3 16.5 6.3 22.8 0l22.8-22.8c6.3-6.3 6.3-16.5 0-22.8L589.6 240zM224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"]
};
var faUsers = {
  prefix: 'fas',
  iconName: 'users',
  icon: [640, 512, [], "f0c0", "M96 224c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm448 0c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm32 32h-64c-17.6 0-33.5 7.1-45.1 18.6 40.3 22.1 68.9 62 75.1 109.4h66c17.7 0 32-14.3 32-32v-32c0-35.3-28.7-64-64-64zm-256 0c61.9 0 112-50.1 112-112S381.9 32 320 32 208 82.1 208 144s50.1 112 112 112zm76.8 32h-8.3c-20.8 10-43.9 16-68.5 16s-47.6-6-68.5-16h-8.3C179.6 288 128 339.6 128 403.2V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-28.8c0-63.6-51.6-115.2-115.2-115.2zm-223.7-13.4C161.5 263.1 145.6 256 128 256H64c-35.3 0-64 28.7-64 64v32c0 17.7 14.3 32 32 32h65.9c6.3-47.4 34.9-87.3 75.2-109.4z"]
};
var faUsersCog = {
  prefix: 'fas',
  iconName: 'users-cog',
  icon: [640, 512, [], "f509", "M610.5 341.3c2.6-14.1 2.6-28.5 0-42.6l25.8-14.9c3-1.7 4.3-5.2 3.3-8.5-6.7-21.6-18.2-41.2-33.2-57.4-2.3-2.5-6-3.1-9-1.4l-25.8 14.9c-10.9-9.3-23.4-16.5-36.9-21.3v-29.8c0-3.4-2.4-6.4-5.7-7.1-22.3-5-45-4.8-66.2 0-3.3.7-5.7 3.7-5.7 7.1v29.8c-13.5 4.8-26 12-36.9 21.3l-25.8-14.9c-2.9-1.7-6.7-1.1-9 1.4-15 16.2-26.5 35.8-33.2 57.4-1 3.3.4 6.8 3.3 8.5l25.8 14.9c-2.6 14.1-2.6 28.5 0 42.6l-25.8 14.9c-3 1.7-4.3 5.2-3.3 8.5 6.7 21.6 18.2 41.1 33.2 57.4 2.3 2.5 6 3.1 9 1.4l25.8-14.9c10.9 9.3 23.4 16.5 36.9 21.3v29.8c0 3.4 2.4 6.4 5.7 7.1 22.3 5 45 4.8 66.2 0 3.3-.7 5.7-3.7 5.7-7.1v-29.8c13.5-4.8 26-12 36.9-21.3l25.8 14.9c2.9 1.7 6.7 1.1 9-1.4 15-16.2 26.5-35.8 33.2-57.4 1-3.3-.4-6.8-3.3-8.5l-25.8-14.9zM496 368.5c-26.8 0-48.5-21.8-48.5-48.5s21.8-48.5 48.5-48.5 48.5 21.8 48.5 48.5-21.7 48.5-48.5 48.5zM96 224c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm224 32c1.9 0 3.7-.5 5.6-.6 8.3-21.7 20.5-42.1 36.3-59.2 7.4-8 17.9-12.6 28.9-12.6 6.9 0 13.7 1.8 19.6 5.3l7.9 4.6c.8-.5 1.6-.9 2.4-1.4 7-14.6 11.2-30.8 11.2-48 0-61.9-50.1-112-112-112S208 82.1 208 144c0 61.9 50.1 112 112 112zm105.2 194.5c-2.3-1.2-4.6-2.6-6.8-3.9-8.2 4.8-15.3 9.8-27.5 9.8-10.9 0-21.4-4.6-28.9-12.6-18.3-19.8-32.3-43.9-40.2-69.6-10.7-34.5 24.9-49.7 25.8-50.3-.1-2.6-.1-5.2 0-7.8l-7.9-4.6c-3.8-2.2-7-5-9.8-8.1-3.3.2-6.5.6-9.8.6-24.6 0-47.6-6-68.5-16h-8.3C179.6 288 128 339.6 128 403.2V432c0 26.5 21.5 48 48 48h255.4c-3.7-6-6.2-12.8-6.2-20.3v-9.2zM173.1 274.6C161.5 263.1 145.6 256 128 256H64c-35.3 0-64 28.7-64 64v32c0 17.7 14.3 32 32 32h65.9c6.3-47.4 34.9-87.3 75.2-109.4z"]
};
var faUsersSlash = {
  prefix: 'fas',
  iconName: 'users-slash',
  icon: [640, 512, [], "e073", "M132.65,212.32,36.21,137.78A63.4,63.4,0,0,0,32,160a63.84,63.84,0,0,0,100.65,52.32Zm40.44,62.28A63.79,63.79,0,0,0,128,256H64A64.06,64.06,0,0,0,0,320v32a32,32,0,0,0,32,32H97.91A146.62,146.62,0,0,1,173.09,274.6ZM544,224a64,64,0,1,0-64-64A64.06,64.06,0,0,0,544,224ZM500.56,355.11a114.24,114.24,0,0,0-84.47-65.28L361,247.23c41.46-16.3,71-55.92,71-103.23A111.93,111.93,0,0,0,320,32c-57.14,0-103.69,42.83-110.6,98.08L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.46A16,16,0,0,0,6.18,53.91L594.53,508.63A16,16,0,0,0,617,505.82l19.64-25.27a16,16,0,0,0-2.81-22.45ZM128,403.21V432a48,48,0,0,0,48,48H464a47.45,47.45,0,0,0,12.57-1.87L232,289.13C173.74,294.83,128,343.42,128,403.21ZM576,256H512a63.79,63.79,0,0,0-45.09,18.6A146.29,146.29,0,0,1,542,384h66a32,32,0,0,0,32-32V320A64.06,64.06,0,0,0,576,256Z"]
};
var faUtensilSpoon = {
  prefix: 'fas',
  iconName: 'utensil-spoon',
  icon: [512, 512, [], "f2e5", "M480.1 31.9c-55-55.1-164.9-34.5-227.8 28.5-49.3 49.3-55.1 110-28.8 160.4L9 413.2c-11.6 10.5-12.1 28.5-1 39.5L59.3 504c11 11 29.1 10.5 39.5-1.1l192.4-214.4c50.4 26.3 111.1 20.5 160.4-28.8 63-62.9 83.6-172.8 28.5-227.8z"]
};
var faUtensils = {
  prefix: 'fas',
  iconName: 'utensils',
  icon: [416, 512, [], "f2e7", "M207.9 15.2c.8 4.7 16.1 94.5 16.1 128.8 0 52.3-27.8 89.6-68.9 104.6L168 486.7c.7 13.7-10.2 25.3-24 25.3H80c-13.7 0-24.7-11.5-24-25.3l12.9-238.1C27.7 233.6 0 196.2 0 144 0 109.6 15.3 19.9 16.1 15.2 19.3-5.1 61.4-5.4 64 16.3v141.2c1.3 3.4 15.1 3.2 16 0 1.4-25.3 7.9-139.2 8-141.8 3.3-20.8 44.7-20.8 47.9 0 .2 2.7 6.6 116.5 8 141.8.9 3.2 14.8 3.4 16 0V16.3c2.6-21.6 44.8-21.4 48-1.1zm119.2 285.7l-15 185.1c-1.2 14 9.9 26 23.9 26h56c13.3 0 24-10.7 24-24V24c0-13.2-10.7-24-24-24-82.5 0-221.4 178.5-64.9 300.9z"]
};
var faVectorSquare = {
  prefix: 'fas',
  iconName: 'vector-square',
  icon: [512, 512, [], "f5cb", "M512 128V32c0-17.67-14.33-32-32-32h-96c-17.67 0-32 14.33-32 32H160c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v96c0 17.67 14.33 32 32 32v192c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32h192c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32V160c17.67 0 32-14.33 32-32zm-96-64h32v32h-32V64zM64 64h32v32H64V64zm32 384H64v-32h32v32zm352 0h-32v-32h32v32zm-32-96h-32c-17.67 0-32 14.33-32 32v32H160v-32c0-17.67-14.33-32-32-32H96V160h32c17.67 0 32-14.33 32-32V96h192v32c0 17.67 14.33 32 32 32h32v192z"]
};
var faVenus = {
  prefix: 'fas',
  iconName: 'venus',
  icon: [288, 512, [], "f221", "M288 176c0-79.5-64.5-144-144-144S0 96.5 0 176c0 68.5 47.9 125.9 112 140.4V368H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v36c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-36h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-51.6c64.1-14.5 112-71.9 112-140.4zm-224 0c0-44.1 35.9-80 80-80s80 35.9 80 80-35.9 80-80 80-80-35.9-80-80z"]
};
var faVenusDouble = {
  prefix: 'fas',
  iconName: 'venus-double',
  icon: [512, 512, [], "f226", "M288 176c0-79.5-64.5-144-144-144S0 96.5 0 176c0 68.5 47.9 125.9 112 140.4V368H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v36c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-36h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-51.6c64.1-14.5 112-71.9 112-140.4zm-224 0c0-44.1 35.9-80 80-80s80 35.9 80 80-35.9 80-80 80-80-35.9-80-80zm336 140.4V368h36c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-36v36c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-36h-36c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h36v-51.6c-21.2-4.8-40.6-14.3-57.2-27.3 14-16.7 25-36 32.1-57.1 14.5 14.8 34.7 24 57.1 24 44.1 0 80-35.9 80-80s-35.9-80-80-80c-22.3 0-42.6 9.2-57.1 24-7.1-21.1-18-40.4-32.1-57.1C303.4 43.6 334.3 32 368 32c79.5 0 144 64.5 144 144 0 68.5-47.9 125.9-112 140.4z"]
};
var faVenusMars = {
  prefix: 'fas',
  iconName: 'venus-mars',
  icon: [576, 512, [], "f228", "M564 0h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-48.7 48.7C422.5 72.1 396.2 64 368 64c-33.7 0-64.6 11.6-89.2 30.9 14 16.7 25 36 32.1 57.1 14.5-14.8 34.7-24 57.1-24 44.1 0 80 35.9 80 80s-35.9 80-80 80c-22.3 0-42.6-9.2-57.1-24-7.1 21.1-18 40.4-32.1 57.1 24.5 19.4 55.5 30.9 89.2 30.9 79.5 0 144-64.5 144-144 0-28.2-8.1-54.5-22.1-76.7l48.7-48.7 16.9 16.9c2.4 2.4 5.4 3.5 8.4 3.5 6.2 0 12.1-4.8 12.1-12V12c0-6.6-5.4-12-12-12zM144 64C64.5 64 0 128.5 0 208c0 68.5 47.9 125.9 112 140.4V400H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v36c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-36h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-51.6c64.1-14.6 112-71.9 112-140.4 0-79.5-64.5-144-144-144zm0 224c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"]
};
var faVest = {
  prefix: 'fas',
  iconName: 'vest',
  icon: [448, 512, [], "e085", "M437.252,239.877,384,160V32A32,32,0,0,0,352,0H320a24.021,24.021,0,0,0-13.312,4.031l-25,16.672a103.794,103.794,0,0,1-115.376,0l-25-16.672A24.021,24.021,0,0,0,128,0H96A32,32,0,0,0,64,32V160L10.748,239.877A64,64,0,0,0,0,275.377V480a32,32,0,0,0,32,32H192V288a31.987,31.987,0,0,1,1.643-10.119L207.135,237.4,150.188,66.564A151.518,151.518,0,0,0,224,86.234a151.55,151.55,0,0,0,73.812-19.672L224,288V512H416a32,32,0,0,0,32-32V275.377A64,64,0,0,0,437.252,239.877ZM131.312,371.312l-48,48a16,16,0,0,1-22.624-22.624l48-48a16,16,0,0,1,22.624,22.624Zm256,48a15.992,15.992,0,0,1-22.624,0l-48-48a16,16,0,0,1,22.624-22.624l48,48A15.993,15.993,0,0,1,387.312,419.312Z"]
};
var faVestPatches = {
  prefix: 'fas',
  iconName: 'vest-patches',
  icon: [448, 512, [], "e086", "M437.252,239.877,384,160V32A32,32,0,0,0,352,0H320a23.982,23.982,0,0,0-13.312,4.031l-25,16.672a103.794,103.794,0,0,1-115.376,0l-25-16.672A23.982,23.982,0,0,0,128,0H96A32,32,0,0,0,64,32V160L10.748,239.877A64,64,0,0,0,0,275.377V480a32,32,0,0,0,32,32H192V288a31.987,31.987,0,0,1,1.643-10.119L207.135,237.4,150.188,66.561A151.579,151.579,0,0,0,224,86.234a151.565,151.565,0,0,0,73.811-19.668L224,288V512H416a32,32,0,0,0,32-32V275.377A64,64,0,0,0,437.252,239.877ZM63.5,272.484a12.01,12.01,0,0,1,17-16.968l15.5,15.5,15.5-15.5a12.01,12.01,0,0,1,17,16.968L112.984,288,128.5,303.516a12.01,12.01,0,0,1-17,16.968L96,304.984l-15.5,15.5a12.01,12.01,0,0,1-17-16.968L79.016,288ZM96,456a40,40,0,1,1,40-40A40,40,0,0,1,96,456ZM359.227,335.785,310.7,336a6.671,6.671,0,0,1-6.7-6.7l.215-48.574A24.987,24.987,0,0,1,331.43,256.1c12.789,1.162,22.129,12.619,22.056,25.419l-.037,5.057,5.051-.037c12.826-.035,24.236,9.275,25.4,22.076A24.948,24.948,0,0,1,359.227,335.785Z"]
};
var faVial = {
  prefix: 'fas',
  iconName: 'vial',
  icon: [480, 512, [], "f492", "M477.7 186.1L309.5 18.3c-3.1-3.1-8.2-3.1-11.3 0l-34 33.9c-3.1 3.1-3.1 8.2 0 11.3l11.2 11.1L33 316.5c-38.8 38.7-45.1 102-9.4 143.5 20.6 24 49.5 36 78.4 35.9 26.4 0 52.8-10 72.9-30.1l246.3-245.7 11.2 11.1c3.1 3.1 8.2 3.1 11.3 0l34-33.9c3.1-3 3.1-8.1 0-11.2zM318 256H161l148-147.7 78.5 78.3L318 256z"]
};
var faVials = {
  prefix: 'fas',
  iconName: 'vials',
  icon: [640, 512, [], "f493", "M72 64h24v240c0 44.1 35.9 80 80 80s80-35.9 80-80V64h24c4.4 0 8-3.6 8-8V8c0-4.4-3.6-8-8-8H72c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm72 0h64v96h-64V64zm480 384H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM360 64h24v240c0 44.1 35.9 80 80 80s80-35.9 80-80V64h24c4.4 0 8-3.6 8-8V8c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm72 0h64v96h-64V64z"]
};
var faVideo = {
  prefix: 'fas',
  iconName: 'video',
  icon: [576, 512, [], "f03d", "M336.2 64H47.8C21.4 64 0 85.4 0 111.8v288.4C0 426.6 21.4 448 47.8 448h288.4c26.4 0 47.8-21.4 47.8-47.8V111.8c0-26.4-21.4-47.8-47.8-47.8zm189.4 37.7L416 177.3v157.4l109.6 75.5c21.2 14.6 50.4-.3 50.4-25.8V127.5c0-25.4-29.1-40.4-50.4-25.8z"]
};
var faVideoSlash = {
  prefix: 'fas',
  iconName: 'video-slash',
  icon: [640, 512, [], "f4e2", "M633.8 458.1l-55-42.5c15.4-1.4 29.2-13.7 29.2-31.1v-257c0-25.5-29.1-40.4-50.4-25.8L448 177.3v137.2l-32-24.7v-178c0-26.4-21.4-47.8-47.8-47.8H123.9L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4L42.7 82 416 370.6l178.5 138c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.5-6.9 4.2-17-2.8-22.4zM32 400.2c0 26.4 21.4 47.8 47.8 47.8h288.4c11.2 0 21.4-4 29.6-10.5L32 154.7v245.5z"]
};
var faVihara = {
  prefix: 'fas',
  iconName: 'vihara',
  icon: [640, 512, [], "f6a7", "M632.88 400.71L544 352v-64l55.16-17.69c11.79-5.9 11.79-22.72 0-28.62L480 192v-64l27.31-16.3c7.72-7.72 5.61-20.74-4.16-25.62L320 0 136.85 86.07c-9.77 4.88-11.88 17.9-4.16 25.62L160 128v64L40.84 241.69c-11.79 5.9-11.79 22.72 0 28.62L96 288v64L7.12 400.71c-5.42 3.62-7.7 9.63-7 15.29.62 5.01 3.57 9.75 8.72 12.33L64 448v48c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-48h160v48c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-48h160v48c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-48l55.15-19.67c5.16-2.58 8.1-7.32 8.72-12.33.71-5.67-1.57-11.68-6.99-15.29zM224 128h192v64H224v-64zm-64 224v-64h320v64H160z"]
};
var faVirus = {
  prefix: 'fas',
  iconName: 'virus',
  icon: [512, 512, [], "e074", "M483.55,227.55H462c-50.68,0-76.07-61.27-40.23-97.11L437,115.19A28.44,28.44,0,0,0,396.8,75L381.56,90.22c-35.84,35.83-97.11,10.45-97.11-40.23V28.44a28.45,28.45,0,0,0-56.9,0V50c0,50.68-61.27,76.06-97.11,40.23L115.2,75A28.44,28.44,0,0,0,75,115.19l15.25,15.25c35.84,35.84,10.45,97.11-40.23,97.11H28.45a28.45,28.45,0,1,0,0,56.89H50c50.68,0,76.07,61.28,40.23,97.12L75,396.8A28.45,28.45,0,0,0,115.2,437l15.24-15.25c35.84-35.84,97.11-10.45,97.11,40.23v21.54a28.45,28.45,0,0,0,56.9,0V462c0-50.68,61.27-76.07,97.11-40.23L396.8,437A28.45,28.45,0,0,0,437,396.8l-15.25-15.24c-35.84-35.84-10.45-97.12,40.23-97.12h21.54a28.45,28.45,0,1,0,0-56.89ZM224,272a48,48,0,1,1,48-48A48,48,0,0,1,224,272Zm80,56a24,24,0,1,1,24-24A24,24,0,0,1,304,328Z"]
};
var faVirusSlash = {
  prefix: 'fas',
  iconName: 'virus-slash',
  icon: [640, 512, [], "e075", "M114,227.6H92.4C76.7,227.6,64,240.3,64,256s12.7,28.4,28.4,28.4H114c50.7,0,76.1,61.3,40.2,97.1L139,396.8 c-11.5,10.7-12.2,28.7-1.6,40.2s28.7,12.2,40.2,1.6c0.5-0.5,1.1-1,1.6-1.6l15.2-15.2c35.8-35.8,97.1-10.5,97.1,40.2v21.5 c0,15.7,12.8,28.4,28.5,28.4c15.7,0,28.4-12.7,28.4-28.4V462c0-26.6,17-45.9,38.2-53.4l-244.5-189 C133.7,224.7,123.9,227.5,114,227.6z M617,505.8l19.6-25.3c5.4-7,4.2-17-2.8-22.5L470.6,332c4.2-25.4,24.9-47.5,55.4-47.5h21.5 c15.7,0,28.4-12.7,28.4-28.4s-12.7-28.4-28.4-28.4H526c-50.7,0-76.1-61.3-40.2-97.1l15.2-15.3c10.7-11.5,10-29.5-1.6-40.2 c-10.9-10.1-27.7-10.1-38.6,0l-15.2,15.2c-35.8,35.8-97.1,10.5-97.1-40.2V28.5C348.4,12.7,335.7,0,320,0 c-15.7,0-28.4,12.7-28.4,28.4V50c0,50.7-61.3,76.1-97.1,40.2L179.2,75c-11.1-11.1-29.4-10.6-40.5,0.5L45.5,3.4 c-7-5.4-17-4.2-22.5,2.8L3.4,31.5c-5.4,7-4.2,17,2.8,22.5l588.4,454.7C601.5,514.1,611.6,512.8,617,505.8z M335.4,227.5l-62.9-48.6 c4.9-1.8,10.2-2.8,15.4-2.9c26.5,0,48,21.5,48,48C336,225.2,335.5,226.3,335.4,227.5z"]
};
var faViruses = {
  prefix: 'fas',
  iconName: 'viruses',
  icon: [640, 512, [], "e076", "M624,352H611.88c-28.51,0-42.79-34.47-22.63-54.63l8.58-8.57a16,16,0,1,0-22.63-22.63l-8.57,8.58C546.47,294.91,512,280.63,512,252.12V240a16,16,0,0,0-32,0v12.12c0,28.51-34.47,42.79-54.63,22.63l-8.57-8.58a16,16,0,0,0-22.63,22.63l8.58,8.57c20.16,20.16,5.88,54.63-22.63,54.63H368a16,16,0,0,0,0,32h12.12c28.51,0,42.79,34.47,22.63,54.63l-8.58,8.57a16,16,0,1,0,22.63,22.63l8.57-8.58c20.16-20.16,54.63-5.88,54.63,22.63V496a16,16,0,0,0,32,0V483.88c0-28.51,34.47-42.79,54.63-22.63l8.57,8.58a16,16,0,1,0,22.63-22.63l-8.58-8.57C569.09,418.47,583.37,384,611.88,384H624a16,16,0,0,0,0-32ZM480,384a32,32,0,1,1,32-32A32,32,0,0,1,480,384ZM346.51,213.33h16.16a21.33,21.33,0,0,0,0-42.66H346.51c-38,0-57.05-46-30.17-72.84l11.43-11.44A21.33,21.33,0,0,0,297.6,56.23L286.17,67.66c-26.88,26.88-72.84,7.85-72.84-30.17V21.33a21.33,21.33,0,0,0-42.66,0V37.49c0,38-46,57.05-72.84,30.17L86.4,56.23A21.33,21.33,0,0,0,56.23,86.39L67.66,97.83c26.88,26.88,7.85,72.84-30.17,72.84H21.33a21.33,21.33,0,0,0,0,42.66H37.49c38,0,57.05,46,30.17,72.84L56.23,297.6A21.33,21.33,0,1,0,86.4,327.77l11.43-11.43c26.88-26.88,72.84-7.85,72.84,30.17v16.16a21.33,21.33,0,0,0,42.66,0V346.51c0-38,46-57.05,72.84-30.17l11.43,11.43a21.33,21.33,0,0,0,30.17-30.17l-11.43-11.43C289.46,259.29,308.49,213.33,346.51,213.33ZM160,192a32,32,0,1,1,32-32A32,32,0,0,1,160,192Zm80,32a16,16,0,1,1,16-16A16,16,0,0,1,240,224Z"]
};
var faVoicemail = {
  prefix: 'fas',
  iconName: 'voicemail',
  icon: [640, 512, [], "f897", "M496 128a144 144 0 0 0-119.74 224H263.74A144 144 0 1 0 144 416h352a144 144 0 0 0 0-288zM64 272a80 80 0 1 1 80 80 80 80 0 0 1-80-80zm432 80a80 80 0 1 1 80-80 80 80 0 0 1-80 80z"]
};
var faVolleyballBall = {
  prefix: 'fas',
  iconName: 'volleyball-ball',
  icon: [512, 512, [], "f45f", "M231.39 243.48a285.56 285.56 0 0 0-22.7-105.7c-90.8 42.4-157.5 122.4-180.3 216.8a249 249 0 0 0 56.9 81.1 333.87 333.87 0 0 1 146.1-192.2zm-36.9-134.4a284.23 284.23 0 0 0-57.4-70.7c-91 49.8-144.8 152.9-125 262.2 33.4-83.1 98.4-152 182.4-191.5zm187.6 165.1c8.6-99.8-27.3-197.5-97.5-264.4-14.7-1.7-51.6-5.5-98.9 8.5A333.87 333.87 0 0 1 279.19 241a285 285 0 0 0 102.9 33.18zm-124.7 9.5a286.33 286.33 0 0 0-80.2 72.6c82 57.3 184.5 75.1 277.5 47.8a247.15 247.15 0 0 0 42.2-89.9 336.1 336.1 0 0 1-80.9 10.4c-54.6-.1-108.9-14.1-158.6-40.9zm-98.3 99.7c-15.2 26-25.7 54.4-32.1 84.2a247.07 247.07 0 0 0 289-22.1c-112.9 16.1-203.3-24.8-256.9-62.1zm180.3-360.6c55.3 70.4 82.5 161.2 74.6 253.6a286.59 286.59 0 0 0 89.7-14.2c0-2 .3-4 .3-6 0-107.8-68.7-199.1-164.6-233.4z"]
};
var faVolumeDown = {
  prefix: 'fas',
  iconName: 'volume-down',
  icon: [384, 512, [], "f027", "M215.03 72.04L126.06 161H24c-13.26 0-24 10.74-24 24v144c0 13.25 10.74 24 24 24h102.06l88.97 88.95c15.03 15.03 40.97 4.47 40.97-16.97V89.02c0-21.47-25.96-31.98-40.97-16.98zm123.2 108.08c-11.58-6.33-26.19-2.16-32.61 9.45-6.39 11.61-2.16 26.2 9.45 32.61C327.98 229.28 336 242.62 336 257c0 14.38-8.02 27.72-20.92 34.81-11.61 6.41-15.84 21-9.45 32.61 6.43 11.66 21.05 15.8 32.61 9.45 28.23-15.55 45.77-45 45.77-76.88s-17.54-61.32-45.78-76.87z"]
};
var faVolumeMute = {
  prefix: 'fas',
  iconName: 'volume-mute',
  icon: [512, 512, [], "f6a9", "M215.03 71.05L126.06 160H24c-13.26 0-24 10.74-24 24v144c0 13.25 10.74 24 24 24h102.06l88.97 88.95c15.03 15.03 40.97 4.47 40.97-16.97V88.02c0-21.46-25.96-31.98-40.97-16.97zM461.64 256l45.64-45.64c6.3-6.3 6.3-16.52 0-22.82l-22.82-22.82c-6.3-6.3-16.52-6.3-22.82 0L416 210.36l-45.64-45.64c-6.3-6.3-16.52-6.3-22.82 0l-22.82 22.82c-6.3 6.3-6.3 16.52 0 22.82L370.36 256l-45.63 45.63c-6.3 6.3-6.3 16.52 0 22.82l22.82 22.82c6.3 6.3 16.52 6.3 22.82 0L416 301.64l45.64 45.64c6.3 6.3 16.52 6.3 22.82 0l22.82-22.82c6.3-6.3 6.3-16.52 0-22.82L461.64 256z"]
};
var faVolumeOff = {
  prefix: 'fas',
  iconName: 'volume-off',
  icon: [256, 512, [], "f026", "M215 71l-89 89H24a24 24 0 0 0-24 24v144a24 24 0 0 0 24 24h102.06L215 441c15 15 41 4.47 41-17V88c0-21.47-26-32-41-17z"]
};
var faVolumeUp = {
  prefix: 'fas',
  iconName: 'volume-up',
  icon: [576, 512, [], "f028", "M215.03 71.05L126.06 160H24c-13.26 0-24 10.74-24 24v144c0 13.25 10.74 24 24 24h102.06l88.97 88.95c15.03 15.03 40.97 4.47 40.97-16.97V88.02c0-21.46-25.96-31.98-40.97-16.97zm233.32-51.08c-11.17-7.33-26.18-4.24-33.51 6.95-7.34 11.17-4.22 26.18 6.95 33.51 66.27 43.49 105.82 116.6 105.82 195.58 0 78.98-39.55 152.09-105.82 195.58-11.17 7.32-14.29 22.34-6.95 33.5 7.04 10.71 21.93 14.56 33.51 6.95C528.27 439.58 576 351.33 576 256S528.27 72.43 448.35 19.97zM480 256c0-63.53-32.06-121.94-85.77-156.24-11.19-7.14-26.03-3.82-33.12 7.46s-3.78 26.21 7.41 33.36C408.27 165.97 432 209.11 432 256s-23.73 90.03-63.48 115.42c-11.19 7.14-14.5 22.07-7.41 33.36 6.51 10.36 21.12 15.14 33.12 7.46C447.94 377.94 480 319.54 480 256zm-141.77-76.87c-11.58-6.33-26.19-2.16-32.61 9.45-6.39 11.61-2.16 26.2 9.45 32.61C327.98 228.28 336 241.63 336 256c0 14.38-8.02 27.72-20.92 34.81-11.61 6.41-15.84 21-9.45 32.61 6.43 11.66 21.05 15.8 32.61 9.45 28.23-15.55 45.77-45 45.77-76.88s-17.54-61.32-45.78-76.86z"]
};
var faVoteYea = {
  prefix: 'fas',
  iconName: 'vote-yea',
  icon: [640, 512, [], "f772", "M608 320h-64v64h22.4c5.3 0 9.6 3.6 9.6 8v16c0 4.4-4.3 8-9.6 8H73.6c-5.3 0-9.6-3.6-9.6-8v-16c0-4.4 4.3-8 9.6-8H96v-64H32c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32h576c17.7 0 32-14.3 32-32v-96c0-17.7-14.3-32-32-32zm-96 64V64.3c0-17.9-14.5-32.3-32.3-32.3H160.4C142.5 32 128 46.5 128 64.3V384h384zM211.2 202l25.5-25.3c4.2-4.2 11-4.2 15.2.1l41.3 41.6 95.2-94.4c4.2-4.2 11-4.2 15.2.1l25.3 25.5c4.2 4.2 4.2 11-.1 15.2L300.5 292c-4.2 4.2-11 4.2-15.2-.1l-74.1-74.7c-4.3-4.2-4.2-11 0-15.2z"]
};
var faVrCardboard = {
  prefix: 'fas',
  iconName: 'vr-cardboard',
  icon: [640, 512, [], "f729", "M608 64H32C14.33 64 0 78.33 0 96v320c0 17.67 14.33 32 32 32h160.22c25.19 0 48.03-14.77 58.36-37.74l27.74-61.64C286.21 331.08 302.35 320 320 320s33.79 11.08 41.68 28.62l27.74 61.64C399.75 433.23 422.6 448 447.78 448H608c17.67 0 32-14.33 32-32V96c0-17.67-14.33-32-32-32zM160 304c-35.35 0-64-28.65-64-64s28.65-64 64-64 64 28.65 64 64-28.65 64-64 64zm320 0c-35.35 0-64-28.65-64-64s28.65-64 64-64 64 28.65 64 64-28.65 64-64 64z"]
};
var faWalking = {
  prefix: 'fas',
  iconName: 'walking',
  icon: [320, 512, [], "f554", "M208 96c26.5 0 48-21.5 48-48S234.5 0 208 0s-48 21.5-48 48 21.5 48 48 48zm94.5 149.1l-23.3-11.8-9.7-29.4c-14.7-44.6-55.7-75.8-102.2-75.9-36-.1-55.9 10.1-93.3 25.2-21.6 8.7-39.3 25.2-49.7 46.2L17.6 213c-7.8 15.8-1.5 35 14.2 42.9 15.6 7.9 34.6 1.5 42.5-14.3L81 228c3.5-7 9.3-12.5 16.5-15.4l26.8-10.8-15.2 60.7c-5.2 20.8.4 42.9 14.9 58.8l59.9 65.4c7.2 7.9 12.3 17.4 14.9 27.7l18.3 73.3c4.3 17.1 21.7 27.6 38.8 23.3 17.1-4.3 27.6-21.7 23.3-38.8l-22.2-89c-2.6-10.3-7.7-19.9-14.9-27.7l-45.5-49.7 17.2-68.7 5.5 16.5c5.3 16.1 16.7 29.4 31.7 37l23.3 11.8c15.6 7.9 34.6 1.5 42.5-14.3 7.7-15.7 1.4-35.1-14.3-43zM73.6 385.8c-3.2 8.1-8 15.4-14.2 21.5l-50 50.1c-12.5 12.5-12.5 32.8 0 45.3s32.7 12.5 45.2 0l59.4-59.4c6.1-6.1 10.9-13.4 14.2-21.5l13.5-33.8c-55.3-60.3-38.7-41.8-47.4-53.7l-20.7 51.5z"]
};
var faWallet = {
  prefix: 'fas',
  iconName: 'wallet',
  icon: [512, 512, [], "f555", "M461.2 128H80c-8.84 0-16-7.16-16-16s7.16-16 16-16h384c8.84 0 16-7.16 16-16 0-26.51-21.49-48-48-48H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h397.2c28.02 0 50.8-21.53 50.8-48V176c0-26.47-22.78-48-50.8-48zM416 336c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"]
};
var faWarehouse = {
  prefix: 'fas',
  iconName: 'warehouse',
  icon: [640, 512, [], "f494", "M504 352H136.4c-4.4 0-8 3.6-8 8l-.1 48c0 4.4 3.6 8 8 8H504c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm0 96H136.1c-4.4 0-8 3.6-8 8l-.1 48c0 4.4 3.6 8 8 8h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm0-192H136.6c-4.4 0-8 3.6-8 8l-.1 48c0 4.4 3.6 8 8 8H504c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm106.5-139L338.4 3.7a48.15 48.15 0 0 0-36.9 0L29.5 117C11.7 124.5 0 141.9 0 161.3V504c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8V256c0-17.6 14.6-32 32.6-32h382.8c18 0 32.6 14.4 32.6 32v248c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8V161.3c0-19.4-11.7-36.8-29.5-44.3z"]
};
var faWater = {
  prefix: 'fas',
  iconName: 'water',
  icon: [576, 512, [], "f773", "M562.1 383.9c-21.5-2.4-42.1-10.5-57.9-22.9-14.1-11.1-34.2-11.3-48.2 0-37.9 30.4-107.2 30.4-145.7-1.5-13.5-11.2-33-9.1-46.7 1.8-38 30.1-106.9 30-145.2-1.7-13.5-11.2-33.3-8.9-47.1 2-15.5 12.2-36 20.1-57.7 22.4-7.9.8-13.6 7.8-13.6 15.7v32.2c0 9.1 7.6 16.8 16.7 16 28.8-2.5 56.1-11.4 79.4-25.9 56.5 34.6 137 34.1 192 0 56.5 34.6 137 34.1 192 0 23.3 14.2 50.9 23.3 79.1 25.8 9.1.8 16.7-6.9 16.7-16v-31.6c.1-8-5.7-15.4-13.8-16.3zm0-144c-21.5-2.4-42.1-10.5-57.9-22.9-14.1-11.1-34.2-11.3-48.2 0-37.9 30.4-107.2 30.4-145.7-1.5-13.5-11.2-33-9.1-46.7 1.8-38 30.1-106.9 30-145.2-1.7-13.5-11.2-33.3-8.9-47.1 2-15.5 12.2-36 20.1-57.7 22.4-7.9.8-13.6 7.8-13.6 15.7v32.2c0 9.1 7.6 16.8 16.7 16 28.8-2.5 56.1-11.4 79.4-25.9 56.5 34.6 137 34.1 192 0 56.5 34.6 137 34.1 192 0 23.3 14.2 50.9 23.3 79.1 25.8 9.1.8 16.7-6.9 16.7-16v-31.6c.1-8-5.7-15.4-13.8-16.3zm0-144C540.6 93.4 520 85.4 504.2 73 490.1 61.9 470 61.7 456 73c-37.9 30.4-107.2 30.4-145.7-1.5-13.5-11.2-33-9.1-46.7 1.8-38 30.1-106.9 30-145.2-1.7-13.5-11.2-33.3-8.9-47.1 2-15.5 12.2-36 20.1-57.7 22.4-7.9.8-13.6 7.8-13.6 15.7v32.2c0 9.1 7.6 16.8 16.7 16 28.8-2.5 56.1-11.4 79.4-25.9 56.5 34.6 137 34.1 192 0 56.5 34.6 137 34.1 192 0 23.3 14.2 50.9 23.3 79.1 25.8 9.1.8 16.7-6.9 16.7-16v-31.6c.1-8-5.7-15.4-13.8-16.3z"]
};
var faWaveSquare = {
  prefix: 'fas',
  iconName: 'wave-square',
  icon: [640, 512, [], "f83e", "M476 480H324a36 36 0 0 1-36-36V96h-96v156a36 36 0 0 1-36 36H16a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h112V68a36 36 0 0 1 36-36h152a36 36 0 0 1 36 36v348h96V260a36 36 0 0 1 36-36h140a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H512v156a36 36 0 0 1-36 36z"]
};
var faWeight = {
  prefix: 'fas',
  iconName: 'weight',
  icon: [512, 512, [], "f496", "M448 64h-25.98C438.44 92.28 448 125.01 448 160c0 105.87-86.13 192-192 192S64 265.87 64 160c0-34.99 9.56-67.72 25.98-96H64C28.71 64 0 92.71 0 128v320c0 35.29 28.71 64 64 64h384c35.29 0 64-28.71 64-64V128c0-35.29-28.71-64-64-64zM256 320c88.37 0 160-71.63 160-160S344.37 0 256 0 96 71.63 96 160s71.63 160 160 160zm-.3-151.94l33.58-78.36c3.5-8.17 12.94-11.92 21.03-8.41 8.12 3.48 11.88 12.89 8.41 21l-33.67 78.55C291.73 188 296 197.45 296 208c0 22.09-17.91 40-40 40s-40-17.91-40-40c0-21.98 17.76-39.77 39.7-39.94z"]
};
var faWeightHanging = {
  prefix: 'fas',
  iconName: 'weight-hanging',
  icon: [512, 512, [], "f5cd", "M510.28 445.86l-73.03-292.13c-3.8-15.19-16.44-25.72-30.87-25.72h-60.25c3.57-10.05 5.88-20.72 5.88-32 0-53.02-42.98-96-96-96s-96 42.98-96 96c0 11.28 2.3 21.95 5.88 32h-60.25c-14.43 0-27.08 10.54-30.87 25.72L1.72 445.86C-6.61 479.17 16.38 512 48.03 512h415.95c31.64 0 54.63-32.83 46.3-66.14zM256 128c-17.64 0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32z"]
};
var faWheelchair = {
  prefix: 'fas',
  iconName: 'wheelchair',
  icon: [512, 512, [], "f193", "M496.101 385.669l14.227 28.663c3.929 7.915.697 17.516-7.218 21.445l-65.465 32.886c-16.049 7.967-35.556 1.194-43.189-15.055L331.679 320H192c-15.925 0-29.426-11.71-31.679-27.475C126.433 55.308 128.38 70.044 128 64c0-36.358 30.318-65.635 67.052-63.929 33.271 1.545 60.048 28.905 60.925 62.201.868 32.933-23.152 60.423-54.608 65.039l4.67 32.69H336c8.837 0 16 7.163 16 16v32c0 8.837-7.163 16-16 16H215.182l4.572 32H352a32 32 0 0 1 28.962 18.392L438.477 396.8l36.178-18.349c7.915-3.929 17.517-.697 21.446 7.218zM311.358 352h-24.506c-7.788 54.204-54.528 96-110.852 96-61.757 0-112-50.243-112-112 0-41.505 22.694-77.809 56.324-97.156-3.712-25.965-6.844-47.86-9.488-66.333C45.956 198.464 0 261.963 0 336c0 97.047 78.953 176 176 176 71.87 0 133.806-43.308 161.11-105.192L311.358 352z"]
};
var faWifi = {
  prefix: 'fas',
  iconName: 'wifi',
  icon: [640, 512, [], "f1eb", "M634.91 154.88C457.74-8.99 182.19-8.93 5.09 154.88c-6.66 6.16-6.79 16.59-.35 22.98l34.24 33.97c6.14 6.1 16.02 6.23 22.4.38 145.92-133.68 371.3-133.71 517.25 0 6.38 5.85 16.26 5.71 22.4-.38l34.24-33.97c6.43-6.39 6.3-16.82-.36-22.98zM320 352c-35.35 0-64 28.65-64 64s28.65 64 64 64 64-28.65 64-64-28.65-64-64-64zm202.67-83.59c-115.26-101.93-290.21-101.82-405.34 0-6.9 6.1-7.12 16.69-.57 23.15l34.44 33.99c6 5.92 15.66 6.32 22.05.8 83.95-72.57 209.74-72.41 293.49 0 6.39 5.52 16.05 5.13 22.05-.8l34.44-33.99c6.56-6.46 6.33-17.06-.56-23.15z"]
};
var faWind = {
  prefix: 'fas',
  iconName: 'wind',
  icon: [512, 512, [], "f72e", "M156.7 256H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h142.2c15.9 0 30.8 10.9 33.4 26.6 3.3 20-12.1 37.4-31.6 37.4-14.1 0-26.1-9.2-30.4-21.9-2.1-6.3-8.6-10.1-15.2-10.1H81.6c-9.8 0-17.7 8.8-15.9 18.4 8.6 44.1 47.6 77.6 94.2 77.6 57.1 0 102.7-50.1 95.2-108.6C249 291 205.4 256 156.7 256zM16 224h336c59.7 0 106.8-54.8 93.8-116.7-7.6-36.2-36.9-65.5-73.1-73.1-55.4-11.6-105.1 24.9-114.9 75.5-1.9 9.6 6.1 18.3 15.8 18.3h32.8c6.7 0 13.1-3.8 15.2-10.1C325.9 105.2 337.9 96 352 96c19.4 0 34.9 17.4 31.6 37.4-2.6 15.7-17.4 26.6-33.4 26.6H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16zm384 32H243.7c19.3 16.6 33.2 38.8 39.8 64H400c26.5 0 48 21.5 48 48s-21.5 48-48 48c-17.9 0-33.3-9.9-41.6-24.4-2.9-5-8.7-7.6-14.5-7.6h-33.8c-10.9 0-19 10.8-15.3 21.1 17.8 50.6 70.5 84.8 129.4 72.3 41.2-8.7 75.1-41.6 84.7-82.7C526 321.5 470.5 256 400 256z"]
};
var faWindowClose = {
  prefix: 'fas',
  iconName: 'window-close',
  icon: [512, 512, [], "f410", "M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-83.6 290.5c4.8 4.8 4.8 12.6 0 17.4l-40.5 40.5c-4.8 4.8-12.6 4.8-17.4 0L256 313.3l-66.5 67.1c-4.8 4.8-12.6 4.8-17.4 0l-40.5-40.5c-4.8-4.8-4.8-12.6 0-17.4l67.1-66.5-67.1-66.5c-4.8-4.8-4.8-12.6 0-17.4l40.5-40.5c4.8-4.8 12.6-4.8 17.4 0l66.5 67.1 66.5-67.1c4.8-4.8 12.6-4.8 17.4 0l40.5 40.5c4.8 4.8 4.8 12.6 0 17.4L313.3 256l67.1 66.5z"]
};
var faWindowMaximize = {
  prefix: 'fas',
  iconName: 'window-maximize',
  icon: [512, 512, [], "f2d0", "M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-16 160H64v-84c0-6.6 5.4-12 12-12h360c6.6 0 12 5.4 12 12v84z"]
};
var faWindowMinimize = {
  prefix: 'fas',
  iconName: 'window-minimize',
  icon: [512, 512, [], "f2d1", "M464 352H48c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48v-32c0-26.5-21.5-48-48-48z"]
};
var faWindowRestore = {
  prefix: 'fas',
  iconName: 'window-restore',
  icon: [512, 512, [], "f2d2", "M512 48v288c0 26.5-21.5 48-48 48h-48V176c0-44.1-35.9-80-80-80H128V48c0-26.5 21.5-48 48-48h288c26.5 0 48 21.5 48 48zM384 176v288c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48h288c26.5 0 48 21.5 48 48zm-68 28c0-6.6-5.4-12-12-12H76c-6.6 0-12 5.4-12 12v52h252v-52z"]
};
var faWineBottle = {
  prefix: 'fas',
  iconName: 'wine-bottle',
  icon: [512, 512, [], "f72f", "M507.31 72.57L439.43 4.69c-6.25-6.25-16.38-6.25-22.63 0l-22.63 22.63c-6.25 6.25-6.25 16.38 0 22.63l-76.67 76.67c-46.58-19.7-102.4-10.73-140.37 27.23L18.75 312.23c-24.99 24.99-24.99 65.52 0 90.51l90.51 90.51c24.99 24.99 65.52 24.99 90.51 0l158.39-158.39c37.96-37.96 46.93-93.79 27.23-140.37l76.67-76.67c6.25 6.25 16.38 6.25 22.63 0l22.63-22.63c6.24-6.24 6.24-16.37-.01-22.62zM179.22 423.29l-90.51-90.51 122.04-122.04 90.51 90.51-122.04 122.04z"]
};
var faWineGlass = {
  prefix: 'fas',
  iconName: 'wine-glass',
  icon: [288, 512, [], "f4e3", "M216 464h-40V346.81c68.47-15.89 118.05-79.91 111.4-154.16l-15.95-178.1C270.71 6.31 263.9 0 255.74 0H32.26c-8.15 0-14.97 6.31-15.7 14.55L.6 192.66C-6.05 266.91 43.53 330.93 112 346.82V464H72c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h208c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40z"]
};
var faWineGlassAlt = {
  prefix: 'fas',
  iconName: 'wine-glass-alt',
  icon: [288, 512, [], "f5ce", "M216 464h-40V346.81c68.47-15.89 118.05-79.91 111.4-154.16l-15.95-178.1C270.71 6.31 263.9 0 255.74 0H32.26c-8.15 0-14.97 6.31-15.7 14.55L.6 192.66C-6.05 266.91 43.53 330.93 112 346.82V464H72c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h208c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40zM61.75 48h164.5l7.17 80H54.58l7.17-80z"]
};
var faWonSign = {
  prefix: 'fas',
  iconName: 'won-sign',
  icon: [576, 512, [], "f159", "M564 192c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-48l18.6-80.6c1.7-7.5-4-14.7-11.7-14.7h-46.1c-5.7 0-10.6 4-11.7 9.5L450.7 128H340.8l-19.7-86c-1.3-5.5-6.1-9.3-11.7-9.3h-44c-5.6 0-10.4 3.8-11.7 9.3l-20 86H125l-17.5-85.7c-1.1-5.6-6.1-9.6-11.8-9.6H53.6c-7.7 0-13.4 7.1-11.7 14.6L60 128H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h62.3l7.2 32H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h83.9l40.9 182.6c1.2 5.5 6.1 9.4 11.7 9.4h56.8c5.6 0 10.4-3.9 11.7-9.3L259.3 288h55.1l42.4 182.7c1.3 5.4 6.1 9.3 11.7 9.3h56.8c5.6 0 10.4-3.9 11.7-9.3L479.1 288H564c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-70.1l7.4-32zM183.8 342c-6.2 25.8-6.8 47.2-7.3 47.2h-1.1s-1.7-22-6.8-47.2l-11-54h38.8zm27.5-118h-66.8l-6.5-32h80.8zm62.9 0l2-8.6c1.9-8 3.5-16 4.8-23.4h11.8c1.3 7.4 2.9 15.4 4.8 23.4l2 8.6zm130.9 118c-5.1 25.2-6.8 47.2-6.8 47.2h-1.1c-.6 0-1.1-21.4-7.3-47.2l-12.4-54h39.1zm25.2-118h-67.4l-7.3-32h81.6z"]
};
var faWrench = {
  prefix: 'fas',
  iconName: 'wrench',
  icon: [512, 512, [], "f0ad", "M507.73 109.1c-2.24-9.03-13.54-12.09-20.12-5.51l-74.36 74.36-67.88-11.31-11.31-67.88 74.36-74.36c6.62-6.62 3.43-17.9-5.66-20.16-47.38-11.74-99.55.91-136.58 37.93-39.64 39.64-50.55 97.1-34.05 147.2L18.74 402.76c-24.99 24.99-24.99 65.51 0 90.5 24.99 24.99 65.51 24.99 90.5 0l213.21-213.21c50.12 16.71 107.47 5.68 147.37-34.22 37.07-37.07 49.7-89.32 37.91-136.73zM64 472c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"]
};
var faXRay = {
  prefix: 'fas',
  iconName: 'x-ray',
  icon: [640, 512, [], "f497", "M240 384c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm160 32c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zM624 0H16C7.2 0 0 7.2 0 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16zm0 448h-48V96H64v352H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM480 248c0 4.4-3.6 8-8 8H336v32h104c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H336v32h64c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48v-16h-64v16c0 26.5-21.5 48-48 48s-48-21.5-48-48 21.5-48 48-48h64v-32H200c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h104v-32H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h136v-32H200c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h104v-24c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v24h104c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H336v32h136c4.4 0 8 3.6 8 8v16z"]
};
var faYenSign = {
  prefix: 'fas',
  iconName: 'yen-sign',
  icon: [384, 512, [], "f157", "M351.2 32h-65.3c-4.6 0-8.8 2.6-10.8 6.7l-55.4 113.2c-14.5 34.7-27.1 71.9-27.1 71.9h-1.3s-12.6-37.2-27.1-71.9L108.8 38.7c-2-4.1-6.2-6.7-10.8-6.7H32.8c-9.1 0-14.8 9.7-10.6 17.6L102.3 200H44c-6.6 0-12 5.4-12 12v32c0 6.6 5.4 12 12 12h88.2l19.8 37.2V320H44c-6.6 0-12 5.4-12 12v32c0 6.6 5.4 12 12 12h108v92c0 6.6 5.4 12 12 12h56c6.6 0 12-5.4 12-12v-92h108c6.6 0 12-5.4 12-12v-32c0-6.6-5.4-12-12-12H232v-26.8l19.8-37.2H340c6.6 0 12-5.4 12-12v-32c0-6.6-5.4-12-12-12h-58.3l80.1-150.4c4.3-7.9-1.5-17.6-10.6-17.6z"]
};
var faYinYang = {
  prefix: 'fas',
  iconName: 'yin-yang',
  icon: [496, 512, [], "f6ad", "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 376c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-128c-53.02 0-96 42.98-96 96s42.98 96 96 96c-106.04 0-192-85.96-192-192S141.96 64 248 64c53.02 0 96 42.98 96 96s-42.98 96-96 96zm0-128c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32z"]
};
var _iconsCache = {
  faAd: faAd,
  faAddressBook: faAddressBook,
  faAddressCard: faAddressCard,
  faAdjust: faAdjust,
  faAirFreshener: faAirFreshener,
  faAlignCenter: faAlignCenter,
  faAlignJustify: faAlignJustify,
  faAlignLeft: faAlignLeft,
  faAlignRight: faAlignRight,
  faAllergies: faAllergies,
  faAmbulance: faAmbulance,
  faAmericanSignLanguageInterpreting: faAmericanSignLanguageInterpreting,
  faAnchor: faAnchor,
  faAngleDoubleDown: faAngleDoubleDown,
  faAngleDoubleLeft: faAngleDoubleLeft,
  faAngleDoubleRight: faAngleDoubleRight,
  faAngleDoubleUp: faAngleDoubleUp,
  faAngleDown: faAngleDown,
  faAngleLeft: faAngleLeft,
  faAngleRight: faAngleRight,
  faAngleUp: faAngleUp,
  faAngry: faAngry,
  faAnkh: faAnkh,
  faAppleAlt: faAppleAlt,
  faArchive: faArchive,
  faArchway: faArchway,
  faArrowAltCircleDown: faArrowAltCircleDown,
  faArrowAltCircleLeft: faArrowAltCircleLeft,
  faArrowAltCircleRight: faArrowAltCircleRight,
  faArrowAltCircleUp: faArrowAltCircleUp,
  faArrowCircleDown: faArrowCircleDown,
  faArrowCircleLeft: faArrowCircleLeft,
  faArrowCircleRight: faArrowCircleRight,
  faArrowCircleUp: faArrowCircleUp,
  faArrowDown: faArrowDown,
  faArrowLeft: faArrowLeft,
  faArrowRight: faArrowRight,
  faArrowUp: faArrowUp,
  faArrowsAlt: faArrowsAlt,
  faArrowsAltH: faArrowsAltH,
  faArrowsAltV: faArrowsAltV,
  faAssistiveListeningSystems: faAssistiveListeningSystems,
  faAsterisk: faAsterisk,
  faAt: faAt,
  faAtlas: faAtlas,
  faAtom: faAtom,
  faAudioDescription: faAudioDescription,
  faAward: faAward,
  faBaby: faBaby,
  faBabyCarriage: faBabyCarriage,
  faBackspace: faBackspace,
  faBackward: faBackward,
  faBacon: faBacon,
  faBacteria: faBacteria,
  faBacterium: faBacterium,
  faBahai: faBahai,
  faBalanceScale: faBalanceScale,
  faBalanceScaleLeft: faBalanceScaleLeft,
  faBalanceScaleRight: faBalanceScaleRight,
  faBan: faBan,
  faBandAid: faBandAid,
  faBarcode: faBarcode,
  faBars: faBars,
  faBaseballBall: faBaseballBall,
  faBasketballBall: faBasketballBall,
  faBath: faBath,
  faBatteryEmpty: faBatteryEmpty,
  faBatteryFull: faBatteryFull,
  faBatteryHalf: faBatteryHalf,
  faBatteryQuarter: faBatteryQuarter,
  faBatteryThreeQuarters: faBatteryThreeQuarters,
  faBed: faBed,
  faBeer: faBeer,
  faBell: faBell,
  faBellSlash: faBellSlash,
  faBezierCurve: faBezierCurve,
  faBible: faBible,
  faBicycle: faBicycle,
  faBiking: faBiking,
  faBinoculars: faBinoculars,
  faBiohazard: faBiohazard,
  faBirthdayCake: faBirthdayCake,
  faBlender: faBlender,
  faBlenderPhone: faBlenderPhone,
  faBlind: faBlind,
  faBlog: faBlog,
  faBold: faBold,
  faBolt: faBolt,
  faBomb: faBomb,
  faBone: faBone,
  faBong: faBong,
  faBook: faBook,
  faBookDead: faBookDead,
  faBookMedical: faBookMedical,
  faBookOpen: faBookOpen,
  faBookReader: faBookReader,
  faBookmark: faBookmark,
  faBorderAll: faBorderAll,
  faBorderNone: faBorderNone,
  faBorderStyle: faBorderStyle,
  faBowlingBall: faBowlingBall,
  faBox: faBox,
  faBoxOpen: faBoxOpen,
  faBoxTissue: faBoxTissue,
  faBoxes: faBoxes,
  faBraille: faBraille,
  faBrain: faBrain,
  faBreadSlice: faBreadSlice,
  faBriefcase: faBriefcase,
  faBriefcaseMedical: faBriefcaseMedical,
  faBroadcastTower: faBroadcastTower,
  faBroom: faBroom,
  faBrush: faBrush,
  faBug: faBug,
  faBuilding: faBuilding,
  faBullhorn: faBullhorn,
  faBullseye: faBullseye,
  faBurn: faBurn,
  faBus: faBus,
  faBusAlt: faBusAlt,
  faBusinessTime: faBusinessTime,
  faCalculator: faCalculator,
  faCalendar: faCalendar,
  faCalendarAlt: faCalendarAlt,
  faCalendarCheck: faCalendarCheck,
  faCalendarDay: faCalendarDay,
  faCalendarMinus: faCalendarMinus,
  faCalendarPlus: faCalendarPlus,
  faCalendarTimes: faCalendarTimes,
  faCalendarWeek: faCalendarWeek,
  faCamera: faCamera,
  faCameraRetro: faCameraRetro,
  faCampground: faCampground,
  faCandyCane: faCandyCane,
  faCannabis: faCannabis,
  faCapsules: faCapsules,
  faCar: faCar,
  faCarAlt: faCarAlt,
  faCarBattery: faCarBattery,
  faCarCrash: faCarCrash,
  faCarSide: faCarSide,
  faCaravan: faCaravan,
  faCaretDown: faCaretDown,
  faCaretLeft: faCaretLeft,
  faCaretRight: faCaretRight,
  faCaretSquareDown: faCaretSquareDown,
  faCaretSquareLeft: faCaretSquareLeft,
  faCaretSquareRight: faCaretSquareRight,
  faCaretSquareUp: faCaretSquareUp,
  faCaretUp: faCaretUp,
  faCarrot: faCarrot,
  faCartArrowDown: faCartArrowDown,
  faCartPlus: faCartPlus,
  faCashRegister: faCashRegister,
  faCat: faCat,
  faCertificate: faCertificate,
  faChair: faChair,
  faChalkboard: faChalkboard,
  faChalkboardTeacher: faChalkboardTeacher,
  faChargingStation: faChargingStation,
  faChartArea: faChartArea,
  faChartBar: faChartBar,
  faChartLine: faChartLine,
  faChartPie: faChartPie,
  faCheck: faCheck,
  faCheckCircle: faCheckCircle,
  faCheckDouble: faCheckDouble,
  faCheckSquare: faCheckSquare,
  faCheese: faCheese,
  faChess: faChess,
  faChessBishop: faChessBishop,
  faChessBoard: faChessBoard,
  faChessKing: faChessKing,
  faChessKnight: faChessKnight,
  faChessPawn: faChessPawn,
  faChessQueen: faChessQueen,
  faChessRook: faChessRook,
  faChevronCircleDown: faChevronCircleDown,
  faChevronCircleLeft: faChevronCircleLeft,
  faChevronCircleRight: faChevronCircleRight,
  faChevronCircleUp: faChevronCircleUp,
  faChevronDown: faChevronDown,
  faChevronLeft: faChevronLeft,
  faChevronRight: faChevronRight,
  faChevronUp: faChevronUp,
  faChild: faChild,
  faChurch: faChurch,
  faCircle: faCircle,
  faCircleNotch: faCircleNotch,
  faCity: faCity,
  faClinicMedical: faClinicMedical,
  faClipboard: faClipboard,
  faClipboardCheck: faClipboardCheck,
  faClipboardList: faClipboardList,
  faClock: faClock,
  faClone: faClone,
  faClosedCaptioning: faClosedCaptioning,
  faCloud: faCloud,
  faCloudDownloadAlt: faCloudDownloadAlt,
  faCloudMeatball: faCloudMeatball,
  faCloudMoon: faCloudMoon,
  faCloudMoonRain: faCloudMoonRain,
  faCloudRain: faCloudRain,
  faCloudShowersHeavy: faCloudShowersHeavy,
  faCloudSun: faCloudSun,
  faCloudSunRain: faCloudSunRain,
  faCloudUploadAlt: faCloudUploadAlt,
  faCocktail: faCocktail,
  faCode: faCode,
  faCodeBranch: faCodeBranch,
  faCoffee: faCoffee,
  faCog: faCog,
  faCogs: faCogs,
  faCoins: faCoins,
  faColumns: faColumns,
  faComment: faComment,
  faCommentAlt: faCommentAlt,
  faCommentDollar: faCommentDollar,
  faCommentDots: faCommentDots,
  faCommentMedical: faCommentMedical,
  faCommentSlash: faCommentSlash,
  faComments: faComments,
  faCommentsDollar: faCommentsDollar,
  faCompactDisc: faCompactDisc,
  faCompass: faCompass,
  faCompress: faCompress,
  faCompressAlt: faCompressAlt,
  faCompressArrowsAlt: faCompressArrowsAlt,
  faConciergeBell: faConciergeBell,
  faCookie: faCookie,
  faCookieBite: faCookieBite,
  faCopy: faCopy,
  faCopyright: faCopyright,
  faCouch: faCouch,
  faCreditCard: faCreditCard,
  faCrop: faCrop,
  faCropAlt: faCropAlt,
  faCross: faCross,
  faCrosshairs: faCrosshairs,
  faCrow: faCrow,
  faCrown: faCrown,
  faCrutch: faCrutch,
  faCube: faCube,
  faCubes: faCubes,
  faCut: faCut,
  faDatabase: faDatabase,
  faDeaf: faDeaf,
  faDemocrat: faDemocrat,
  faDesktop: faDesktop,
  faDharmachakra: faDharmachakra,
  faDiagnoses: faDiagnoses,
  faDice: faDice,
  faDiceD20: faDiceD20,
  faDiceD6: faDiceD6,
  faDiceFive: faDiceFive,
  faDiceFour: faDiceFour,
  faDiceOne: faDiceOne,
  faDiceSix: faDiceSix,
  faDiceThree: faDiceThree,
  faDiceTwo: faDiceTwo,
  faDigitalTachograph: faDigitalTachograph,
  faDirections: faDirections,
  faDisease: faDisease,
  faDivide: faDivide,
  faDizzy: faDizzy,
  faDna: faDna,
  faDog: faDog,
  faDollarSign: faDollarSign,
  faDolly: faDolly,
  faDollyFlatbed: faDollyFlatbed,
  faDonate: faDonate,
  faDoorClosed: faDoorClosed,
  faDoorOpen: faDoorOpen,
  faDotCircle: faDotCircle,
  faDove: faDove,
  faDownload: faDownload,
  faDraftingCompass: faDraftingCompass,
  faDragon: faDragon,
  faDrawPolygon: faDrawPolygon,
  faDrum: faDrum,
  faDrumSteelpan: faDrumSteelpan,
  faDrumstickBite: faDrumstickBite,
  faDumbbell: faDumbbell,
  faDumpster: faDumpster,
  faDumpsterFire: faDumpsterFire,
  faDungeon: faDungeon,
  faEdit: faEdit,
  faEgg: faEgg,
  faEject: faEject,
  faEllipsisH: faEllipsisH,
  faEllipsisV: faEllipsisV,
  faEnvelope: faEnvelope,
  faEnvelopeOpen: faEnvelopeOpen,
  faEnvelopeOpenText: faEnvelopeOpenText,
  faEnvelopeSquare: faEnvelopeSquare,
  faEquals: faEquals,
  faEraser: faEraser,
  faEthernet: faEthernet,
  faEuroSign: faEuroSign,
  faExchangeAlt: faExchangeAlt,
  faExclamation: faExclamation,
  faExclamationCircle: faExclamationCircle,
  faExclamationTriangle: faExclamationTriangle,
  faExpand: faExpand,
  faExpandAlt: faExpandAlt,
  faExpandArrowsAlt: faExpandArrowsAlt,
  faExternalLinkAlt: faExternalLinkAlt,
  faExternalLinkSquareAlt: faExternalLinkSquareAlt,
  faEye: faEye,
  faEyeDropper: faEyeDropper,
  faEyeSlash: faEyeSlash,
  faFan: faFan,
  faFastBackward: faFastBackward,
  faFastForward: faFastForward,
  faFaucet: faFaucet,
  faFax: faFax,
  faFeather: faFeather,
  faFeatherAlt: faFeatherAlt,
  faFemale: faFemale,
  faFighterJet: faFighterJet,
  faFile: faFile,
  faFileAlt: faFileAlt,
  faFileArchive: faFileArchive,
  faFileAudio: faFileAudio,
  faFileCode: faFileCode,
  faFileContract: faFileContract,
  faFileCsv: faFileCsv,
  faFileDownload: faFileDownload,
  faFileExcel: faFileExcel,
  faFileExport: faFileExport,
  faFileImage: faFileImage,
  faFileImport: faFileImport,
  faFileInvoice: faFileInvoice,
  faFileInvoiceDollar: faFileInvoiceDollar,
  faFileMedical: faFileMedical,
  faFileMedicalAlt: faFileMedicalAlt,
  faFilePdf: faFilePdf,
  faFilePowerpoint: faFilePowerpoint,
  faFilePrescription: faFilePrescription,
  faFileSignature: faFileSignature,
  faFileUpload: faFileUpload,
  faFileVideo: faFileVideo,
  faFileWord: faFileWord,
  faFill: faFill,
  faFillDrip: faFillDrip,
  faFilm: faFilm,
  faFilter: faFilter,
  faFingerprint: faFingerprint,
  faFire: faFire,
  faFireAlt: faFireAlt,
  faFireExtinguisher: faFireExtinguisher,
  faFirstAid: faFirstAid,
  faFish: faFish,
  faFistRaised: faFistRaised,
  faFlag: faFlag,
  faFlagCheckered: faFlagCheckered,
  faFlagUsa: faFlagUsa,
  faFlask: faFlask,
  faFlushed: faFlushed,
  faFolder: faFolder,
  faFolderMinus: faFolderMinus,
  faFolderOpen: faFolderOpen,
  faFolderPlus: faFolderPlus,
  faFont: faFont,
  faFontAwesomeLogoFull: faFontAwesomeLogoFull,
  faFootballBall: faFootballBall,
  faForward: faForward,
  faFrog: faFrog,
  faFrown: faFrown,
  faFrownOpen: faFrownOpen,
  faFunnelDollar: faFunnelDollar,
  faFutbol: faFutbol,
  faGamepad: faGamepad,
  faGasPump: faGasPump,
  faGavel: faGavel,
  faGem: faGem,
  faGenderless: faGenderless,
  faGhost: faGhost,
  faGift: faGift,
  faGifts: faGifts,
  faGlassCheers: faGlassCheers,
  faGlassMartini: faGlassMartini,
  faGlassMartiniAlt: faGlassMartiniAlt,
  faGlassWhiskey: faGlassWhiskey,
  faGlasses: faGlasses,
  faGlobe: faGlobe,
  faGlobeAfrica: faGlobeAfrica,
  faGlobeAmericas: faGlobeAmericas,
  faGlobeAsia: faGlobeAsia,
  faGlobeEurope: faGlobeEurope,
  faGolfBall: faGolfBall,
  faGopuram: faGopuram,
  faGraduationCap: faGraduationCap,
  faGreaterThan: faGreaterThan,
  faGreaterThanEqual: faGreaterThanEqual,
  faGrimace: faGrimace,
  faGrin: faGrin,
  faGrinAlt: faGrinAlt,
  faGrinBeam: faGrinBeam,
  faGrinBeamSweat: faGrinBeamSweat,
  faGrinHearts: faGrinHearts,
  faGrinSquint: faGrinSquint,
  faGrinSquintTears: faGrinSquintTears,
  faGrinStars: faGrinStars,
  faGrinTears: faGrinTears,
  faGrinTongue: faGrinTongue,
  faGrinTongueSquint: faGrinTongueSquint,
  faGrinTongueWink: faGrinTongueWink,
  faGrinWink: faGrinWink,
  faGripHorizontal: faGripHorizontal,
  faGripLines: faGripLines,
  faGripLinesVertical: faGripLinesVertical,
  faGripVertical: faGripVertical,
  faGuitar: faGuitar,
  faHSquare: faHSquare,
  faHamburger: faHamburger,
  faHammer: faHammer,
  faHamsa: faHamsa,
  faHandHolding: faHandHolding,
  faHandHoldingHeart: faHandHoldingHeart,
  faHandHoldingMedical: faHandHoldingMedical,
  faHandHoldingUsd: faHandHoldingUsd,
  faHandHoldingWater: faHandHoldingWater,
  faHandLizard: faHandLizard,
  faHandMiddleFinger: faHandMiddleFinger,
  faHandPaper: faHandPaper,
  faHandPeace: faHandPeace,
  faHandPointDown: faHandPointDown,
  faHandPointLeft: faHandPointLeft,
  faHandPointRight: faHandPointRight,
  faHandPointUp: faHandPointUp,
  faHandPointer: faHandPointer,
  faHandRock: faHandRock,
  faHandScissors: faHandScissors,
  faHandSparkles: faHandSparkles,
  faHandSpock: faHandSpock,
  faHands: faHands,
  faHandsHelping: faHandsHelping,
  faHandsWash: faHandsWash,
  faHandshake: faHandshake,
  faHandshakeAltSlash: faHandshakeAltSlash,
  faHandshakeSlash: faHandshakeSlash,
  faHanukiah: faHanukiah,
  faHardHat: faHardHat,
  faHashtag: faHashtag,
  faHatCowboy: faHatCowboy,
  faHatCowboySide: faHatCowboySide,
  faHatWizard: faHatWizard,
  faHdd: faHdd,
  faHeadSideCough: faHeadSideCough,
  faHeadSideCoughSlash: faHeadSideCoughSlash,
  faHeadSideMask: faHeadSideMask,
  faHeadSideVirus: faHeadSideVirus,
  faHeading: faHeading,
  faHeadphones: faHeadphones,
  faHeadphonesAlt: faHeadphonesAlt,
  faHeadset: faHeadset,
  faHeart: faHeart,
  faHeartBroken: faHeartBroken,
  faHeartbeat: faHeartbeat,
  faHelicopter: faHelicopter,
  faHighlighter: faHighlighter,
  faHiking: faHiking,
  faHippo: faHippo,
  faHistory: faHistory,
  faHockeyPuck: faHockeyPuck,
  faHollyBerry: faHollyBerry,
  faHome: faHome,
  faHorse: faHorse,
  faHorseHead: faHorseHead,
  faHospital: faHospital,
  faHospitalAlt: faHospitalAlt,
  faHospitalSymbol: faHospitalSymbol,
  faHospitalUser: faHospitalUser,
  faHotTub: faHotTub,
  faHotdog: faHotdog,
  faHotel: faHotel,
  faHourglass: faHourglass,
  faHourglassEnd: faHourglassEnd,
  faHourglassHalf: faHourglassHalf,
  faHourglassStart: faHourglassStart,
  faHouseDamage: faHouseDamage,
  faHouseUser: faHouseUser,
  faHryvnia: faHryvnia,
  faICursor: faICursor,
  faIceCream: faIceCream,
  faIcicles: faIcicles,
  faIcons: faIcons,
  faIdBadge: faIdBadge,
  faIdCard: faIdCard,
  faIdCardAlt: faIdCardAlt,
  faIgloo: faIgloo,
  faImage: faImage,
  faImages: faImages,
  faInbox: faInbox,
  faIndent: faIndent,
  faIndustry: faIndustry,
  faInfinity: faInfinity,
  faInfo: faInfo,
  faInfoCircle: faInfoCircle,
  faItalic: faItalic,
  faJedi: faJedi,
  faJoint: faJoint,
  faJournalWhills: faJournalWhills,
  faKaaba: faKaaba,
  faKey: faKey,
  faKeyboard: faKeyboard,
  faKhanda: faKhanda,
  faKiss: faKiss,
  faKissBeam: faKissBeam,
  faKissWinkHeart: faKissWinkHeart,
  faKiwiBird: faKiwiBird,
  faLandmark: faLandmark,
  faLanguage: faLanguage,
  faLaptop: faLaptop,
  faLaptopCode: faLaptopCode,
  faLaptopHouse: faLaptopHouse,
  faLaptopMedical: faLaptopMedical,
  faLaugh: faLaugh,
  faLaughBeam: faLaughBeam,
  faLaughSquint: faLaughSquint,
  faLaughWink: faLaughWink,
  faLayerGroup: faLayerGroup,
  faLeaf: faLeaf,
  faLemon: faLemon,
  faLessThan: faLessThan,
  faLessThanEqual: faLessThanEqual,
  faLevelDownAlt: faLevelDownAlt,
  faLevelUpAlt: faLevelUpAlt,
  faLifeRing: faLifeRing,
  faLightbulb: faLightbulb,
  faLink: faLink,
  faLiraSign: faLiraSign,
  faList: faList,
  faListAlt: faListAlt,
  faListOl: faListOl,
  faListUl: faListUl,
  faLocationArrow: faLocationArrow,
  faLock: faLock,
  faLockOpen: faLockOpen,
  faLongArrowAltDown: faLongArrowAltDown,
  faLongArrowAltLeft: faLongArrowAltLeft,
  faLongArrowAltRight: faLongArrowAltRight,
  faLongArrowAltUp: faLongArrowAltUp,
  faLowVision: faLowVision,
  faLuggageCart: faLuggageCart,
  faLungs: faLungs,
  faLungsVirus: faLungsVirus,
  faMagic: faMagic,
  faMagnet: faMagnet,
  faMailBulk: faMailBulk,
  faMale: faMale,
  faMap: faMap,
  faMapMarked: faMapMarked,
  faMapMarkedAlt: faMapMarkedAlt,
  faMapMarker: faMapMarker,
  faMapMarkerAlt: faMapMarkerAlt,
  faMapPin: faMapPin,
  faMapSigns: faMapSigns,
  faMarker: faMarker,
  faMars: faMars,
  faMarsDouble: faMarsDouble,
  faMarsStroke: faMarsStroke,
  faMarsStrokeH: faMarsStrokeH,
  faMarsStrokeV: faMarsStrokeV,
  faMask: faMask,
  faMedal: faMedal,
  faMedkit: faMedkit,
  faMeh: faMeh,
  faMehBlank: faMehBlank,
  faMehRollingEyes: faMehRollingEyes,
  faMemory: faMemory,
  faMenorah: faMenorah,
  faMercury: faMercury,
  faMeteor: faMeteor,
  faMicrochip: faMicrochip,
  faMicrophone: faMicrophone,
  faMicrophoneAlt: faMicrophoneAlt,
  faMicrophoneAltSlash: faMicrophoneAltSlash,
  faMicrophoneSlash: faMicrophoneSlash,
  faMicroscope: faMicroscope,
  faMinus: faMinus,
  faMinusCircle: faMinusCircle,
  faMinusSquare: faMinusSquare,
  faMitten: faMitten,
  faMobile: faMobile,
  faMobileAlt: faMobileAlt,
  faMoneyBill: faMoneyBill,
  faMoneyBillAlt: faMoneyBillAlt,
  faMoneyBillWave: faMoneyBillWave,
  faMoneyBillWaveAlt: faMoneyBillWaveAlt,
  faMoneyCheck: faMoneyCheck,
  faMoneyCheckAlt: faMoneyCheckAlt,
  faMonument: faMonument,
  faMoon: faMoon,
  faMortarPestle: faMortarPestle,
  faMosque: faMosque,
  faMotorcycle: faMotorcycle,
  faMountain: faMountain,
  faMouse: faMouse,
  faMousePointer: faMousePointer,
  faMugHot: faMugHot,
  faMusic: faMusic,
  faNetworkWired: faNetworkWired,
  faNeuter: faNeuter,
  faNewspaper: faNewspaper,
  faNotEqual: faNotEqual,
  faNotesMedical: faNotesMedical,
  faObjectGroup: faObjectGroup,
  faObjectUngroup: faObjectUngroup,
  faOilCan: faOilCan,
  faOm: faOm,
  faOtter: faOtter,
  faOutdent: faOutdent,
  faPager: faPager,
  faPaintBrush: faPaintBrush,
  faPaintRoller: faPaintRoller,
  faPalette: faPalette,
  faPallet: faPallet,
  faPaperPlane: faPaperPlane,
  faPaperclip: faPaperclip,
  faParachuteBox: faParachuteBox,
  faParagraph: faParagraph,
  faParking: faParking,
  faPassport: faPassport,
  faPastafarianism: faPastafarianism,
  faPaste: faPaste,
  faPause: faPause,
  faPauseCircle: faPauseCircle,
  faPaw: faPaw,
  faPeace: faPeace,
  faPen: faPen,
  faPenAlt: faPenAlt,
  faPenFancy: faPenFancy,
  faPenNib: faPenNib,
  faPenSquare: faPenSquare,
  faPencilAlt: faPencilAlt,
  faPencilRuler: faPencilRuler,
  faPeopleArrows: faPeopleArrows,
  faPeopleCarry: faPeopleCarry,
  faPepperHot: faPepperHot,
  faPercent: faPercent,
  faPercentage: faPercentage,
  faPersonBooth: faPersonBooth,
  faPhone: faPhone,
  faPhoneAlt: faPhoneAlt,
  faPhoneSlash: faPhoneSlash,
  faPhoneSquare: faPhoneSquare,
  faPhoneSquareAlt: faPhoneSquareAlt,
  faPhoneVolume: faPhoneVolume,
  faPhotoVideo: faPhotoVideo,
  faPiggyBank: faPiggyBank,
  faPills: faPills,
  faPizzaSlice: faPizzaSlice,
  faPlaceOfWorship: faPlaceOfWorship,
  faPlane: faPlane,
  faPlaneArrival: faPlaneArrival,
  faPlaneDeparture: faPlaneDeparture,
  faPlaneSlash: faPlaneSlash,
  faPlay: faPlay,
  faPlayCircle: faPlayCircle,
  faPlug: faPlug,
  faPlus: faPlus,
  faPlusCircle: faPlusCircle,
  faPlusSquare: faPlusSquare,
  faPodcast: faPodcast,
  faPoll: faPoll,
  faPollH: faPollH,
  faPoo: faPoo,
  faPooStorm: faPooStorm,
  faPoop: faPoop,
  faPortrait: faPortrait,
  faPoundSign: faPoundSign,
  faPowerOff: faPowerOff,
  faPray: faPray,
  faPrayingHands: faPrayingHands,
  faPrescription: faPrescription,
  faPrescriptionBottle: faPrescriptionBottle,
  faPrescriptionBottleAlt: faPrescriptionBottleAlt,
  faPrint: faPrint,
  faProcedures: faProcedures,
  faProjectDiagram: faProjectDiagram,
  faPumpMedical: faPumpMedical,
  faPumpSoap: faPumpSoap,
  faPuzzlePiece: faPuzzlePiece,
  faQrcode: faQrcode,
  faQuestion: faQuestion,
  faQuestionCircle: faQuestionCircle,
  faQuidditch: faQuidditch,
  faQuoteLeft: faQuoteLeft,
  faQuoteRight: faQuoteRight,
  faQuran: faQuran,
  faRadiation: faRadiation,
  faRadiationAlt: faRadiationAlt,
  faRainbow: faRainbow,
  faRandom: faRandom,
  faReceipt: faReceipt,
  faRecordVinyl: faRecordVinyl,
  faRecycle: faRecycle,
  faRedo: faRedo,
  faRedoAlt: faRedoAlt,
  faRegistered: faRegistered,
  faRemoveFormat: faRemoveFormat,
  faReply: faReply,
  faReplyAll: faReplyAll,
  faRepublican: faRepublican,
  faRestroom: faRestroom,
  faRetweet: faRetweet,
  faRibbon: faRibbon,
  faRing: faRing,
  faRoad: faRoad,
  faRobot: faRobot,
  faRocket: faRocket,
  faRoute: faRoute,
  faRss: faRss,
  faRssSquare: faRssSquare,
  faRubleSign: faRubleSign,
  faRuler: faRuler,
  faRulerCombined: faRulerCombined,
  faRulerHorizontal: faRulerHorizontal,
  faRulerVertical: faRulerVertical,
  faRunning: faRunning,
  faRupeeSign: faRupeeSign,
  faSadCry: faSadCry,
  faSadTear: faSadTear,
  faSatellite: faSatellite,
  faSatelliteDish: faSatelliteDish,
  faSave: faSave,
  faSchool: faSchool,
  faScrewdriver: faScrewdriver,
  faScroll: faScroll,
  faSdCard: faSdCard,
  faSearch: faSearch,
  faSearchDollar: faSearchDollar,
  faSearchLocation: faSearchLocation,
  faSearchMinus: faSearchMinus,
  faSearchPlus: faSearchPlus,
  faSeedling: faSeedling,
  faServer: faServer,
  faShapes: faShapes,
  faShare: faShare,
  faShareAlt: faShareAlt,
  faShareAltSquare: faShareAltSquare,
  faShareSquare: faShareSquare,
  faShekelSign: faShekelSign,
  faShieldAlt: faShieldAlt,
  faShieldVirus: faShieldVirus,
  faShip: faShip,
  faShippingFast: faShippingFast,
  faShoePrints: faShoePrints,
  faShoppingBag: faShoppingBag,
  faShoppingBasket: faShoppingBasket,
  faShoppingCart: faShoppingCart,
  faShower: faShower,
  faShuttleVan: faShuttleVan,
  faSign: faSign,
  faSignInAlt: faSignInAlt,
  faSignLanguage: faSignLanguage,
  faSignOutAlt: faSignOutAlt,
  faSignal: faSignal,
  faSignature: faSignature,
  faSimCard: faSimCard,
  faSink: faSink,
  faSitemap: faSitemap,
  faSkating: faSkating,
  faSkiing: faSkiing,
  faSkiingNordic: faSkiingNordic,
  faSkull: faSkull,
  faSkullCrossbones: faSkullCrossbones,
  faSlash: faSlash,
  faSleigh: faSleigh,
  faSlidersH: faSlidersH,
  faSmile: faSmile,
  faSmileBeam: faSmileBeam,
  faSmileWink: faSmileWink,
  faSmog: faSmog,
  faSmoking: faSmoking,
  faSmokingBan: faSmokingBan,
  faSms: faSms,
  faSnowboarding: faSnowboarding,
  faSnowflake: faSnowflake,
  faSnowman: faSnowman,
  faSnowplow: faSnowplow,
  faSoap: faSoap,
  faSocks: faSocks,
  faSolarPanel: faSolarPanel,
  faSort: faSort,
  faSortAlphaDown: faSortAlphaDown,
  faSortAlphaDownAlt: faSortAlphaDownAlt,
  faSortAlphaUp: faSortAlphaUp,
  faSortAlphaUpAlt: faSortAlphaUpAlt,
  faSortAmountDown: faSortAmountDown,
  faSortAmountDownAlt: faSortAmountDownAlt,
  faSortAmountUp: faSortAmountUp,
  faSortAmountUpAlt: faSortAmountUpAlt,
  faSortDown: faSortDown,
  faSortNumericDown: faSortNumericDown,
  faSortNumericDownAlt: faSortNumericDownAlt,
  faSortNumericUp: faSortNumericUp,
  faSortNumericUpAlt: faSortNumericUpAlt,
  faSortUp: faSortUp,
  faSpa: faSpa,
  faSpaceShuttle: faSpaceShuttle,
  faSpellCheck: faSpellCheck,
  faSpider: faSpider,
  faSpinner: faSpinner,
  faSplotch: faSplotch,
  faSprayCan: faSprayCan,
  faSquare: faSquare,
  faSquareFull: faSquareFull,
  faSquareRootAlt: faSquareRootAlt,
  faStamp: faStamp,
  faStar: faStar,
  faStarAndCrescent: faStarAndCrescent,
  faStarHalf: faStarHalf,
  faStarHalfAlt: faStarHalfAlt,
  faStarOfDavid: faStarOfDavid,
  faStarOfLife: faStarOfLife,
  faStepBackward: faStepBackward,
  faStepForward: faStepForward,
  faStethoscope: faStethoscope,
  faStickyNote: faStickyNote,
  faStop: faStop,
  faStopCircle: faStopCircle,
  faStopwatch: faStopwatch,
  faStopwatch20: faStopwatch20,
  faStore: faStore,
  faStoreAlt: faStoreAlt,
  faStoreAltSlash: faStoreAltSlash,
  faStoreSlash: faStoreSlash,
  faStream: faStream,
  faStreetView: faStreetView,
  faStrikethrough: faStrikethrough,
  faStroopwafel: faStroopwafel,
  faSubscript: faSubscript,
  faSubway: faSubway,
  faSuitcase: faSuitcase,
  faSuitcaseRolling: faSuitcaseRolling,
  faSun: faSun,
  faSuperscript: faSuperscript,
  faSurprise: faSurprise,
  faSwatchbook: faSwatchbook,
  faSwimmer: faSwimmer,
  faSwimmingPool: faSwimmingPool,
  faSynagogue: faSynagogue,
  faSync: faSync,
  faSyncAlt: faSyncAlt,
  faSyringe: faSyringe,
  faTable: faTable,
  faTableTennis: faTableTennis,
  faTablet: faTablet,
  faTabletAlt: faTabletAlt,
  faTablets: faTablets,
  faTachometerAlt: faTachometerAlt,
  faTag: faTag,
  faTags: faTags,
  faTape: faTape,
  faTasks: faTasks,
  faTaxi: faTaxi,
  faTeeth: faTeeth,
  faTeethOpen: faTeethOpen,
  faTemperatureHigh: faTemperatureHigh,
  faTemperatureLow: faTemperatureLow,
  faTenge: faTenge,
  faTerminal: faTerminal,
  faTextHeight: faTextHeight,
  faTextWidth: faTextWidth,
  faTh: faTh,
  faThLarge: faThLarge,
  faThList: faThList,
  faTheaterMasks: faTheaterMasks,
  faThermometer: faThermometer,
  faThermometerEmpty: faThermometerEmpty,
  faThermometerFull: faThermometerFull,
  faThermometerHalf: faThermometerHalf,
  faThermometerQuarter: faThermometerQuarter,
  faThermometerThreeQuarters: faThermometerThreeQuarters,
  faThumbsDown: faThumbsDown,
  faThumbsUp: faThumbsUp,
  faThumbtack: faThumbtack,
  faTicketAlt: faTicketAlt,
  faTimes: faTimes,
  faTimesCircle: faTimesCircle,
  faTint: faTint,
  faTintSlash: faTintSlash,
  faTired: faTired,
  faToggleOff: faToggleOff,
  faToggleOn: faToggleOn,
  faToilet: faToilet,
  faToiletPaper: faToiletPaper,
  faToiletPaperSlash: faToiletPaperSlash,
  faToolbox: faToolbox,
  faTools: faTools,
  faTooth: faTooth,
  faTorah: faTorah,
  faToriiGate: faToriiGate,
  faTractor: faTractor,
  faTrademark: faTrademark,
  faTrafficLight: faTrafficLight,
  faTrailer: faTrailer,
  faTrain: faTrain,
  faTram: faTram,
  faTransgender: faTransgender,
  faTransgenderAlt: faTransgenderAlt,
  faTrash: faTrash,
  faTrashAlt: faTrashAlt,
  faTrashRestore: faTrashRestore,
  faTrashRestoreAlt: faTrashRestoreAlt,
  faTree: faTree,
  faTrophy: faTrophy,
  faTruck: faTruck,
  faTruckLoading: faTruckLoading,
  faTruckMonster: faTruckMonster,
  faTruckMoving: faTruckMoving,
  faTruckPickup: faTruckPickup,
  faTshirt: faTshirt,
  faTty: faTty,
  faTv: faTv,
  faUmbrella: faUmbrella,
  faUmbrellaBeach: faUmbrellaBeach,
  faUnderline: faUnderline,
  faUndo: faUndo,
  faUndoAlt: faUndoAlt,
  faUniversalAccess: faUniversalAccess,
  faUniversity: faUniversity,
  faUnlink: faUnlink,
  faUnlock: faUnlock,
  faUnlockAlt: faUnlockAlt,
  faUpload: faUpload,
  faUser: faUser,
  faUserAlt: faUserAlt,
  faUserAltSlash: faUserAltSlash,
  faUserAstronaut: faUserAstronaut,
  faUserCheck: faUserCheck,
  faUserCircle: faUserCircle,
  faUserClock: faUserClock,
  faUserCog: faUserCog,
  faUserEdit: faUserEdit,
  faUserFriends: faUserFriends,
  faUserGraduate: faUserGraduate,
  faUserInjured: faUserInjured,
  faUserLock: faUserLock,
  faUserMd: faUserMd,
  faUserMinus: faUserMinus,
  faUserNinja: faUserNinja,
  faUserNurse: faUserNurse,
  faUserPlus: faUserPlus,
  faUserSecret: faUserSecret,
  faUserShield: faUserShield,
  faUserSlash: faUserSlash,
  faUserTag: faUserTag,
  faUserTie: faUserTie,
  faUserTimes: faUserTimes,
  faUsers: faUsers,
  faUsersCog: faUsersCog,
  faUsersSlash: faUsersSlash,
  faUtensilSpoon: faUtensilSpoon,
  faUtensils: faUtensils,
  faVectorSquare: faVectorSquare,
  faVenus: faVenus,
  faVenusDouble: faVenusDouble,
  faVenusMars: faVenusMars,
  faVest: faVest,
  faVestPatches: faVestPatches,
  faVial: faVial,
  faVials: faVials,
  faVideo: faVideo,
  faVideoSlash: faVideoSlash,
  faVihara: faVihara,
  faVirus: faVirus,
  faVirusSlash: faVirusSlash,
  faViruses: faViruses,
  faVoicemail: faVoicemail,
  faVolleyballBall: faVolleyballBall,
  faVolumeDown: faVolumeDown,
  faVolumeMute: faVolumeMute,
  faVolumeOff: faVolumeOff,
  faVolumeUp: faVolumeUp,
  faVoteYea: faVoteYea,
  faVrCardboard: faVrCardboard,
  faWalking: faWalking,
  faWallet: faWallet,
  faWarehouse: faWarehouse,
  faWater: faWater,
  faWaveSquare: faWaveSquare,
  faWeight: faWeight,
  faWeightHanging: faWeightHanging,
  faWheelchair: faWheelchair,
  faWifi: faWifi,
  faWind: faWind,
  faWindowClose: faWindowClose,
  faWindowMaximize: faWindowMaximize,
  faWindowMinimize: faWindowMinimize,
  faWindowRestore: faWindowRestore,
  faWineBottle: faWineBottle,
  faWineGlass: faWineGlass,
  faWineGlassAlt: faWineGlassAlt,
  faWonSign: faWonSign,
  faWrench: faWrench,
  faXRay: faXRay,
  faYenSign: faYenSign,
  faYinYang: faYinYang
};




/***/ }),

/***/ 67814:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FontAwesomeIcon": function() { return /* binding */ FontAwesomeIcon; }
/* harmony export */ });
/* harmony import */ var _fortawesome_fontawesome_svg_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78947);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);




function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// Get CSS class list from a props object
function classList(props) {
  var _classes;

  var beat = props.beat,
      fade = props.fade,
      beatFade = props.beatFade,
      bounce = props.bounce,
      shake = props.shake,
      flash = props.flash,
      spin = props.spin,
      spinPulse = props.spinPulse,
      spinReverse = props.spinReverse,
      pulse = props.pulse,
      fixedWidth = props.fixedWidth,
      inverse = props.inverse,
      border = props.border,
      listItem = props.listItem,
      flip = props.flip,
      size = props.size,
      rotation = props.rotation,
      pull = props.pull; // map of CSS class names to properties

  var classes = (_classes = {
    'fa-beat': beat,
    'fa-fade': fade,
    'fa-beat-fade': beatFade,
    'fa-bounce': bounce,
    'fa-shake': shake,
    'fa-flash': flash,
    'fa-spin': spin,
    'fa-spin-reverse': spinReverse,
    'fa-spin-pulse': spinPulse,
    'fa-pulse': pulse,
    'fa-fw': fixedWidth,
    'fa-inverse': inverse,
    'fa-border': border,
    'fa-li': listItem,
    'fa-flip': flip === true,
    'fa-flip-horizontal': flip === 'horizontal' || flip === 'both',
    'fa-flip-vertical': flip === 'vertical' || flip === 'both'
  }, _defineProperty(_classes, "fa-".concat(size), typeof size !== 'undefined' && size !== null), _defineProperty(_classes, "fa-rotate-".concat(rotation), typeof rotation !== 'undefined' && rotation !== null && rotation !== 0), _defineProperty(_classes, "fa-pull-".concat(pull), typeof pull !== 'undefined' && pull !== null), _defineProperty(_classes, 'fa-swap-opacity', props.swapOpacity), _classes); // map over all the keys in the classes object
  // return an array of the keys where the value for the key is not null

  return Object.keys(classes).map(function (key) {
    return classes[key] ? key : null;
  }).filter(function (key) {
    return key;
  });
}

// Camelize taken from humps
// humps is copyright © 2012+ Dom Christie
// Released under the MIT license.
// Performant way to determine if object coerces to a number
function _isNumerical(obj) {
  obj = obj - 0; // eslint-disable-next-line no-self-compare

  return obj === obj;
}

function camelize(string) {
  if (_isNumerical(string)) {
    return string;
  } // eslint-disable-next-line no-useless-escape


  string = string.replace(/[\-_\s]+(.)?/g, function (match, chr) {
    return chr ? chr.toUpperCase() : '';
  }); // Ensure 1st char is always lowercase

  return string.substr(0, 1).toLowerCase() + string.substr(1);
}

var _excluded$1 = ["style"];

function capitalize(val) {
  return val.charAt(0).toUpperCase() + val.slice(1);
}

function styleToObject(style) {
  return style.split(';').map(function (s) {
    return s.trim();
  }).filter(function (s) {
    return s;
  }).reduce(function (acc, pair) {
    var i = pair.indexOf(':');
    var prop = camelize(pair.slice(0, i));
    var value = pair.slice(i + 1).trim();
    prop.startsWith('webkit') ? acc[capitalize(prop)] = value : acc[prop] = value;
    return acc;
  }, {});
}

function convert(createElement, element) {
  var extraProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (typeof element === 'string') {
    return element;
  }

  var children = (element.children || []).map(function (child) {
    return convert(createElement, child);
  });
  /* eslint-disable dot-notation */

  var mixins = Object.keys(element.attributes || {}).reduce(function (acc, key) {
    var val = element.attributes[key];

    switch (key) {
      case 'class':
        acc.attrs['className'] = val;
        delete element.attributes['class'];
        break;

      case 'style':
        acc.attrs['style'] = styleToObject(val);
        break;

      default:
        if (key.indexOf('aria-') === 0 || key.indexOf('data-') === 0) {
          acc.attrs[key.toLowerCase()] = val;
        } else {
          acc.attrs[camelize(key)] = val;
        }

    }

    return acc;
  }, {
    attrs: {}
  });

  var _extraProps$style = extraProps.style,
      existingStyle = _extraProps$style === void 0 ? {} : _extraProps$style,
      remaining = _objectWithoutProperties(extraProps, _excluded$1);

  mixins.attrs['style'] = _objectSpread2(_objectSpread2({}, mixins.attrs['style']), existingStyle);
  /* eslint-enable */

  return createElement.apply(void 0, [element.tag, _objectSpread2(_objectSpread2({}, mixins.attrs), remaining)].concat(_toConsumableArray(children)));
}

var PRODUCTION = false;

try {
  PRODUCTION = "production" === 'production';
} catch (e) {}

function log () {
  if (!PRODUCTION && console && typeof console.error === 'function') {
    var _console;

    (_console = console).error.apply(_console, arguments);
  }
}

function normalizeIconArgs(icon) {
  // this has everything that it needs to be rendered which means it was probably imported
  // directly from an icon svg package
  if (icon && _typeof(icon) === 'object' && icon.prefix && icon.iconName && icon.icon) {
    return icon;
  }

  if (_fortawesome_fontawesome_svg_core__WEBPACK_IMPORTED_MODULE_0__.parse.icon) {
    return _fortawesome_fontawesome_svg_core__WEBPACK_IMPORTED_MODULE_0__.parse.icon(icon);
  } // if the icon is null, there's nothing to do


  if (icon === null) {
    return null;
  } // if the icon is an object and has a prefix and an icon name, return it


  if (icon && _typeof(icon) === 'object' && icon.prefix && icon.iconName) {
    return icon;
  } // if it's an array with length of two


  if (Array.isArray(icon) && icon.length === 2) {
    // use the first item as prefix, second as icon name
    return {
      prefix: icon[0],
      iconName: icon[1]
    };
  } // if it's a string, use it as the icon name


  if (typeof icon === 'string') {
    return {
      prefix: 'fas',
      iconName: icon
    };
  }
}

// creates an object with a key of key
// and a value of value
// if certain conditions are met
function objectWithKey(key, value) {
  // if the value is a non-empty array
  // or it's not an array but it is truthy
  // then create the object with the key and the value
  // if not, return an empty array
  return Array.isArray(value) && value.length > 0 || !Array.isArray(value) && value ? _defineProperty({}, key, value) : {};
}

var _excluded = ["forwardedRef"];
function FontAwesomeIcon(_ref) {
  var forwardedRef = _ref.forwardedRef,
      props = _objectWithoutProperties(_ref, _excluded);

  var iconArgs = props.icon,
      maskArgs = props.mask,
      symbol = props.symbol,
      className = props.className,
      title = props.title,
      titleId = props.titleId,
      maskId = props.maskId;
  var iconLookup = normalizeIconArgs(iconArgs);
  var classes = objectWithKey('classes', [].concat(_toConsumableArray(classList(props)), _toConsumableArray(className.split(' '))));
  var transform = objectWithKey('transform', typeof props.transform === 'string' ? _fortawesome_fontawesome_svg_core__WEBPACK_IMPORTED_MODULE_0__.parse.transform(props.transform) : props.transform);
  var mask = objectWithKey('mask', normalizeIconArgs(maskArgs));
  var renderedIcon = (0,_fortawesome_fontawesome_svg_core__WEBPACK_IMPORTED_MODULE_0__.icon)(iconLookup, _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, classes), transform), mask), {}, {
    symbol: symbol,
    title: title,
    titleId: titleId,
    maskId: maskId
  }));

  if (!renderedIcon) {
    log('Could not find icon', iconLookup);
    return null;
  }

  var abstract = renderedIcon.abstract;
  var extraProps = {
    ref: forwardedRef
  };
  Object.keys(props).forEach(function (key) {
    // eslint-disable-next-line no-prototype-builtins
    if (!FontAwesomeIcon.defaultProps.hasOwnProperty(key)) {
      extraProps[key] = props[key];
    }
  });
  return convertCurry(abstract[0], extraProps);
}
FontAwesomeIcon.displayName = 'FontAwesomeIcon';
FontAwesomeIcon.propTypes = {
  beat: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
  border: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
  beatFade: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
  bounce: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
  className: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
  fade: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
  flash: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
  mask: prop_types__WEBPACK_IMPORTED_MODULE_2___default().oneOfType([(prop_types__WEBPACK_IMPORTED_MODULE_2___default().object), (prop_types__WEBPACK_IMPORTED_MODULE_2___default().array), (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string)]),
  maskId: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
  fixedWidth: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
  inverse: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
  flip: prop_types__WEBPACK_IMPORTED_MODULE_2___default().oneOf([true, false, 'horizontal', 'vertical', 'both']),
  icon: prop_types__WEBPACK_IMPORTED_MODULE_2___default().oneOfType([(prop_types__WEBPACK_IMPORTED_MODULE_2___default().object), (prop_types__WEBPACK_IMPORTED_MODULE_2___default().array), (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string)]),
  listItem: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
  pull: prop_types__WEBPACK_IMPORTED_MODULE_2___default().oneOf(['right', 'left']),
  pulse: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
  rotation: prop_types__WEBPACK_IMPORTED_MODULE_2___default().oneOf([0, 90, 180, 270]),
  shake: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
  size: prop_types__WEBPACK_IMPORTED_MODULE_2___default().oneOf(['2xs', 'xs', 'sm', 'lg', 'xl', '2xl', '1x', '2x', '3x', '4x', '5x', '6x', '7x', '8x', '9x', '10x']),
  spin: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
  spinPulse: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
  spinReverse: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
  symbol: prop_types__WEBPACK_IMPORTED_MODULE_2___default().oneOfType([(prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool), (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string)]),
  title: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
  titleId: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
  transform: prop_types__WEBPACK_IMPORTED_MODULE_2___default().oneOfType([(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string), (prop_types__WEBPACK_IMPORTED_MODULE_2___default().object)]),
  swapOpacity: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool)
};
FontAwesomeIcon.defaultProps = {
  border: false,
  className: '',
  mask: null,
  maskId: null,
  fixedWidth: false,
  inverse: false,
  flip: false,
  icon: null,
  listItem: false,
  pull: null,
  pulse: false,
  rotation: null,
  size: null,
  spin: false,
  spinPulse: false,
  spinReverse: false,
  beat: false,
  fade: false,
  beatFade: false,
  bounce: false,
  shake: false,
  symbol: false,
  title: '',
  titleId: null,
  transform: null,
  swapOpacity: false
};
var convertCurry = convert.bind(null, react__WEBPACK_IMPORTED_MODULE_1__.createElement);




/***/ }),

/***/ 32692:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45987);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(33636);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52543);
/* harmony import */ var _Fade__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73637);







var styles = {
  /* Styles applied to the root element. */
  root: {
    // Improve scrollable dialog support.
    zIndex: -1,
    position: 'fixed',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    right: 0,
    bottom: 0,
    top: 0,
    left: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    WebkitTapHighlightColor: 'transparent'
  },

  /* Styles applied to the root element if `invisible={true}`. */
  invisible: {
    backgroundColor: 'transparent'
  }
};
var Backdrop = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Backdrop(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$invisible = props.invisible,
      invisible = _props$invisible === void 0 ? false : _props$invisible,
      open = props.open,
      transitionDuration = props.transitionDuration,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? _Fade__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z : _props$TransitionComp,
      other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props, ["children", "classes", "className", "invisible", "open", "transitionDuration", "TransitionComponent"]);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(TransitionComponent, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    in: open,
    timeout: transitionDuration
  }, other), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(classes.root, className, invisible && classes.invisible),
    "aria-hidden": true,
    ref: ref
  }, children));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(styles, {
  name: 'MuiBackdrop'
})(Backdrop));

/***/ }),

/***/ 95477:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45987);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33636);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52543);
/* harmony import */ var _utils_capitalize__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93871);








var SIZE = 44;
var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'inline-block'
    },

    /* Styles applied to the root element if `variant="static"`. */
    static: {
      transition: theme.transitions.create('transform')
    },

    /* Styles applied to the root element if `variant="indeterminate"`. */
    indeterminate: {
      animation: '$circular-rotate 1.4s linear infinite'
    },

    /* Styles applied to the root element if `variant="determinate"`. */
    determinate: {
      transition: theme.transitions.create('transform')
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main
    },

    /* Styles applied to the `svg` element. */
    svg: {
      display: 'block' // Keeps the progress centered

    },

    /* Styles applied to the `circle` svg path. */
    circle: {
      stroke: 'currentColor' // Use butt to follow the specification, by chance, it's already the default CSS value.
      // strokeLinecap: 'butt',

    },

    /* Styles applied to the `circle` svg path if `variant="static"`. */
    circleStatic: {
      transition: theme.transitions.create('stroke-dashoffset')
    },

    /* Styles applied to the `circle` svg path if `variant="indeterminate"`. */
    circleIndeterminate: {
      animation: '$circular-dash 1.4s ease-in-out infinite',
      // Some default value that looks fine waiting for the animation to kicks in.
      strokeDasharray: '80px, 200px',
      strokeDashoffset: '0px' // Add the unit to fix a Edge 16 and below bug.

    },

    /* Styles applied to the `circle` svg path if `variant="determinate"`. */
    circleDeterminate: {
      transition: theme.transitions.create('stroke-dashoffset')
    },
    '@keyframes circular-rotate': {
      '0%': {
        // Fix IE 11 wobbly
        transformOrigin: '50% 50%'
      },
      '100%': {
        transform: 'rotate(360deg)'
      }
    },
    '@keyframes circular-dash': {
      '0%': {
        strokeDasharray: '1px, 200px',
        strokeDashoffset: '0px'
      },
      '50%': {
        strokeDasharray: '100px, 200px',
        strokeDashoffset: '-15px'
      },
      '100%': {
        strokeDasharray: '100px, 200px',
        strokeDashoffset: '-125px'
      }
    },

    /* Styles applied to the `circle` svg path if `disableShrink={true}`. */
    circleDisableShrink: {
      animation: 'none'
    }
  };
};
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */

var CircularProgress = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function CircularProgress(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'primary' : _props$color,
      _props$disableShrink = props.disableShrink,
      disableShrink = _props$disableShrink === void 0 ? false : _props$disableShrink,
      _props$size = props.size,
      size = _props$size === void 0 ? 40 : _props$size,
      style = props.style,
      _props$thickness = props.thickness,
      thickness = _props$thickness === void 0 ? 3.6 : _props$thickness,
      _props$value = props.value,
      value = _props$value === void 0 ? 0 : _props$value,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'indeterminate' : _props$variant,
      other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(props, ["classes", "className", "color", "disableShrink", "size", "style", "thickness", "value", "variant"]);

  var circleStyle = {};
  var rootStyle = {};
  var rootProps = {};

  if (variant === 'determinate' || variant === 'static') {
    var circumference = 2 * Math.PI * ((SIZE - thickness) / 2);
    circleStyle.strokeDasharray = circumference.toFixed(3);
    rootProps['aria-valuenow'] = Math.round(value);
    circleStyle.strokeDashoffset = "".concat(((100 - value) / 100 * circumference).toFixed(3), "px");
    rootStyle.transform = 'rotate(-90deg)';
  }

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(classes.root, className, color !== 'inherit' && classes["color".concat((0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(color))], {
      'determinate': classes.determinate,
      'indeterminate': classes.indeterminate,
      'static': classes.static
    }[variant]),
    style: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
      width: size,
      height: size
    }, rootStyle, style),
    ref: ref,
    role: "progressbar"
  }, rootProps, other), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
    className: classes.svg,
    viewBox: "".concat(SIZE / 2, " ").concat(SIZE / 2, " ").concat(SIZE, " ").concat(SIZE)
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", {
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(classes.circle, disableShrink && classes.circleDisableShrink, {
      'determinate': classes.circleDeterminate,
      'indeterminate': classes.circleIndeterminate,
      'static': classes.circleStatic
    }[variant]),
    style: circleStyle,
    cx: SIZE,
    cy: SIZE,
    r: (SIZE - thickness) / 2,
    fill: "none",
    strokeWidth: thickness
  })));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(styles, {
  name: 'MuiCircularProgress',
  flip: false
})(CircularProgress));

/***/ }),

/***/ 75834:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports html, body, styles */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87462);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52543);





var html = {
  WebkitFontSmoothing: 'antialiased',
  // Antialiasing.
  MozOsxFontSmoothing: 'grayscale',
  // Antialiasing.
  // Change from `box-sizing: content-box` so that `width`
  // is not affected by `padding` or `border`.
  boxSizing: 'border-box'
};
var body = function body(theme) {
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
    color: theme.palette.text.primary
  }, theme.typography.body2, {
    backgroundColor: theme.palette.background.default,
    '@media print': {
      // Save printer ink.
      backgroundColor: theme.palette.common.white
    }
  });
};
var styles = function styles(theme) {
  return {
    '@global': {
      html: html,
      '*, *::before, *::after': {
        boxSizing: 'inherit'
      },
      'strong, b': {
        fontWeight: theme.typography.fontWeightBold
      },
      body: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
        margin: 0
      }, body(theme), {
        // Add support for document.body.requestFullScreen().
        // Other elements, if background transparent, are not supported.
        '&::backdrop': {
          backgroundColor: theme.palette.background.default
        }
      })
    }
  };
};
/**
 * Kickstart an elegant, consistent, and simple baseline to build upon.
 */

function CssBaseline(props) {
  /* eslint-disable no-unused-vars */
  var _props$children = props.children,
      children = _props$children === void 0 ? null : _props$children,
      classes = props.classes;
  /* eslint-enable no-unused-vars */

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, children);
}

 false ? 0 : void 0;

if (false) {}

/* harmony default export */ __webpack_exports__["ZP"] = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(styles, {
  name: 'MuiCssBaseline'
})(CssBaseline));

/***/ }),

/***/ 73637:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(97685);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45987);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_transition_group__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98885);
/* harmony import */ var _styles_transitions__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43366);
/* harmony import */ var _styles_useTheme__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8920);
/* harmony import */ var _transitions_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5653);
/* harmony import */ var _utils_useForkRef__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17294);










var styles = {
  entering: {
    opacity: 1
  },
  entered: {
    opacity: 1
  }
};
var defaultTimeout = {
  enter: _styles_transitions__WEBPACK_IMPORTED_MODULE_1__/* .duration.enteringScreen */ .x9.enteringScreen,
  exit: _styles_transitions__WEBPACK_IMPORTED_MODULE_1__/* .duration.leavingScreen */ .x9.leavingScreen
};
/**
 * The Fade transition is used by the [Modal](/components/modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */

var Fade = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Fade(props, ref) {
  var children = props.children,
      _props$disableStrictM = props.disableStrictModeCompat,
      disableStrictModeCompat = _props$disableStrictM === void 0 ? false : _props$disableStrictM,
      inProp = props.in,
      onEnter = props.onEnter,
      onEntered = props.onEntered,
      onEntering = props.onEntering,
      onExit = props.onExit,
      onExited = props.onExited,
      onExiting = props.onExiting,
      style = props.style,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? react_transition_group__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP : _props$TransitionComp,
      _props$timeout = props.timeout,
      timeout = _props$timeout === void 0 ? defaultTimeout : _props$timeout,
      other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(props, ["children", "disableStrictModeCompat", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "TransitionComponent", "timeout"]);

  var theme = (0,_styles_useTheme__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
  var enableStrictModeCompat = theme.unstable_strictMode && !disableStrictModeCompat;
  var nodeRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(null);
  var foreignRef = (0,_utils_useForkRef__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(children.ref, ref);
  var handleRef = (0,_utils_useForkRef__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(enableStrictModeCompat ? nodeRef : undefined, foreignRef);

  var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
    return function (nodeOrAppearing, maybeAppearing) {
      if (callback) {
        var _ref = enableStrictModeCompat ? [nodeRef.current, nodeOrAppearing] : [nodeOrAppearing, maybeAppearing],
            _ref2 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_ref, 2),
            node = _ref2[0],
            isAppearing = _ref2[1]; // onEnterXxx and onExitXxx callbacks have a different arguments.length value.


        if (isAppearing === undefined) {
          callback(node);
        } else {
          callback(node, isAppearing);
        }
      }
    };
  };

  var handleEntering = normalizedTransitionCallback(onEntering);
  var handleEnter = normalizedTransitionCallback(function (node, isAppearing) {
    (0,_transitions_utils__WEBPACK_IMPORTED_MODULE_7__/* .reflow */ .n)(node); // So the animation always start from the start.

    var transitionProps = (0,_transitions_utils__WEBPACK_IMPORTED_MODULE_7__/* .getTransitionProps */ .C)({
      style: style,
      timeout: timeout
    }, {
      mode: 'enter'
    });
    node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
    node.style.transition = theme.transitions.create('opacity', transitionProps);

    if (onEnter) {
      onEnter(node, isAppearing);
    }
  });
  var handleEntered = normalizedTransitionCallback(onEntered);
  var handleExiting = normalizedTransitionCallback(onExiting);
  var handleExit = normalizedTransitionCallback(function (node) {
    var transitionProps = (0,_transitions_utils__WEBPACK_IMPORTED_MODULE_7__/* .getTransitionProps */ .C)({
      style: style,
      timeout: timeout
    }, {
      mode: 'exit'
    });
    node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
    node.style.transition = theme.transitions.create('opacity', transitionProps);

    if (onExit) {
      onExit(node);
    }
  });
  var handleExited = normalizedTransitionCallback(onExited);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(TransitionComponent, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
    appear: true,
    in: inProp,
    nodeRef: enableStrictModeCompat ? nodeRef : undefined,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    timeout: timeout
  }, other), function (state, childProps) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(children, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
      style: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        opacity: 0,
        visibility: state === 'exited' && !inProp ? 'hidden' : undefined
      }, styles[state], style, children.props.style),
      ref: handleRef
    }, childProps));
  });
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = (Fade);

/***/ }),

/***/ 76234:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73935);
/* harmony import */ var _utils_setRef__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34236);
/* harmony import */ var _utils_useForkRef__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17294);








function getContainer(container) {
  container = typeof container === 'function' ? container() : container; // #StrictMode ready

  return react_dom__WEBPACK_IMPORTED_MODULE_1__.findDOMNode(container);
}

var useEnhancedEffect = typeof window !== 'undefined' ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect : react__WEBPACK_IMPORTED_MODULE_0__.useEffect;
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 */

var Portal = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Portal(props, ref) {
  var children = props.children,
      container = props.container,
      _props$disablePortal = props.disablePortal,
      disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal,
      onRendered = props.onRendered;

  var _React$useState = react__WEBPACK_IMPORTED_MODULE_0__.useState(null),
      mountNode = _React$useState[0],
      setMountNode = _React$useState[1];

  var handleRef = (0,_utils_useForkRef__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(children) ? children.ref : null, ref);
  useEnhancedEffect(function () {
    if (!disablePortal) {
      setMountNode(getContainer(container) || document.body);
    }
  }, [container, disablePortal]);
  useEnhancedEffect(function () {
    if (mountNode && !disablePortal) {
      (0,_utils_setRef__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(ref, mountNode);
      return function () {
        (0,_utils_setRef__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(ref, null);
      };
    }

    return undefined;
  }, [ref, mountNode, disablePortal]);
  useEnhancedEffect(function () {
    if (onRendered && (mountNode || disablePortal)) {
      onRendered();
    }
  }, [onRendered, mountNode, disablePortal]);

  if (disablePortal) {
    if ( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(children)) {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(children, {
        ref: handleRef
      });
    }

    return children;
  }

  return mountNode ? /*#__PURE__*/react_dom__WEBPACK_IMPORTED_MODULE_1__.createPortal(children, mountNode) : mountNode;
});
 false ? 0 : void 0;

if (false) {}

/* harmony default export */ __webpack_exports__["Z"] = (Portal);

/***/ }),

/***/ 62087:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45987);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33636);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52543);
/* harmony import */ var _utils_capitalize__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93871);








var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      userSelect: 'none',
      width: '1em',
      height: '1em',
      display: 'inline-block',
      fill: 'currentColor',
      flexShrink: 0,
      fontSize: theme.typography.pxToRem(24),
      transition: theme.transitions.create('fill', {
        duration: theme.transitions.duration.shorter
      })
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main
    },

    /* Styles applied to the root element if `color="action"`. */
    colorAction: {
      color: theme.palette.action.active
    },

    /* Styles applied to the root element if `color="error"`. */
    colorError: {
      color: theme.palette.error.main
    },

    /* Styles applied to the root element if `color="disabled"`. */
    colorDisabled: {
      color: theme.palette.action.disabled
    },

    /* Styles applied to the root element if `fontSize="inherit"`. */
    fontSizeInherit: {
      fontSize: 'inherit'
    },

    /* Styles applied to the root element if `fontSize="small"`. */
    fontSizeSmall: {
      fontSize: theme.typography.pxToRem(20)
    },

    /* Styles applied to the root element if `fontSize="large"`. */
    fontSizeLarge: {
      fontSize: theme.typography.pxToRem(35)
    }
  };
};
var SvgIcon = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function SvgIcon(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'inherit' : _props$color,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'svg' : _props$component,
      _props$fontSize = props.fontSize,
      fontSize = _props$fontSize === void 0 ? 'medium' : _props$fontSize,
      htmlColor = props.htmlColor,
      titleAccess = props.titleAccess,
      _props$viewBox = props.viewBox,
      viewBox = _props$viewBox === void 0 ? '0 0 24 24' : _props$viewBox,
      other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(props, ["children", "classes", "className", "color", "component", "fontSize", "htmlColor", "titleAccess", "viewBox"]);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(classes.root, className, color !== 'inherit' && classes["color".concat((0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(color))], fontSize !== 'default' && fontSize !== 'medium' && classes["fontSize".concat((0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(fontSize))]),
    focusable: "false",
    viewBox: viewBox,
    color: htmlColor,
    "aria-hidden": titleAccess ? undefined : true,
    role: titleAccess ? 'img' : undefined,
    ref: ref
  }, other), children, titleAccess ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", null, titleAccess) : null);
});
 false ? 0 : void 0;
SvgIcon.muiName = 'SvgIcon';
/* harmony default export */ __webpack_exports__["Z"] = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(styles, {
  name: 'MuiSvgIcon'
})(SvgIcon));

/***/ }),

/***/ 96230:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var blue = {
  50: '#e3f2fd',
  100: '#bbdefb',
  200: '#90caf9',
  300: '#64b5f6',
  400: '#42a5f5',
  500: '#2196f3',
  600: '#1e88e5',
  700: '#1976d2',
  800: '#1565c0',
  900: '#0d47a1',
  A100: '#82b1ff',
  A200: '#448aff',
  A400: '#2979ff',
  A700: '#2962ff'
};
/* harmony default export */ __webpack_exports__["Z"] = (blue);

/***/ }),

/***/ 34733:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var common = {
  black: '#000',
  white: '#fff'
};
/* harmony default export */ __webpack_exports__["Z"] = (common);

/***/ }),

/***/ 18334:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var green = {
  50: '#e8f5e9',
  100: '#c8e6c9',
  200: '#a5d6a7',
  300: '#81c784',
  400: '#66bb6a',
  500: '#4caf50',
  600: '#43a047',
  700: '#388e3c',
  800: '#2e7d32',
  900: '#1b5e20',
  A100: '#b9f6ca',
  A200: '#69f0ae',
  A400: '#00e676',
  A700: '#00c853'
};
/* harmony default export */ __webpack_exports__["Z"] = (green);

/***/ }),

/***/ 88105:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var grey = {
  50: '#fafafa',
  100: '#f5f5f5',
  200: '#eeeeee',
  300: '#e0e0e0',
  400: '#bdbdbd',
  500: '#9e9e9e',
  600: '#757575',
  700: '#616161',
  800: '#424242',
  900: '#212121',
  A100: '#d5d5d5',
  A200: '#aaaaaa',
  A400: '#303030',
  A700: '#616161'
};
/* harmony default export */ __webpack_exports__["Z"] = (grey);

/***/ }),

/***/ 34446:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var indigo = {
  50: '#e8eaf6',
  100: '#c5cae9',
  200: '#9fa8da',
  300: '#7986cb',
  400: '#5c6bc0',
  500: '#3f51b5',
  600: '#3949ab',
  700: '#303f9f',
  800: '#283593',
  900: '#1a237e',
  A100: '#8c9eff',
  A200: '#536dfe',
  A400: '#3d5afe',
  A700: '#304ffe'
};
/* harmony default export */ __webpack_exports__["Z"] = (indigo);

/***/ }),

/***/ 59546:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var orange = {
  50: '#fff3e0',
  100: '#ffe0b2',
  200: '#ffcc80',
  300: '#ffb74d',
  400: '#ffa726',
  500: '#ff9800',
  600: '#fb8c00',
  700: '#f57c00',
  800: '#ef6c00',
  900: '#e65100',
  A100: '#ffd180',
  A200: '#ffab40',
  A400: '#ff9100',
  A700: '#ff6d00'
};
/* harmony default export */ __webpack_exports__["Z"] = (orange);

/***/ }),

/***/ 9198:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var pink = {
  50: '#fce4ec',
  100: '#f8bbd0',
  200: '#f48fb1',
  300: '#f06292',
  400: '#ec407a',
  500: '#e91e63',
  600: '#d81b60',
  700: '#c2185b',
  800: '#ad1457',
  900: '#880e4f',
  A100: '#ff80ab',
  A200: '#ff4081',
  A400: '#f50057',
  A700: '#c51162'
};
/* harmony default export */ __webpack_exports__["Z"] = (pink);

/***/ }),

/***/ 20907:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var red = {
  50: '#ffebee',
  100: '#ffcdd2',
  200: '#ef9a9a',
  300: '#e57373',
  400: '#ef5350',
  500: '#f44336',
  600: '#e53935',
  700: '#d32f2f',
  800: '#c62828',
  900: '#b71c1c',
  A100: '#ff8a80',
  A200: '#ff5252',
  A400: '#ff1744',
  A700: '#d50000'
};
/* harmony default export */ __webpack_exports__["Z"] = (red);

/***/ }),

/***/ 59693:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$n": function() { return /* binding */ lighten; },
/* harmony export */   "Fq": function() { return /* binding */ alpha; },
/* harmony export */   "H3": function() { return /* binding */ getLuminance; },
/* harmony export */   "U1": function() { return /* binding */ fade; },
/* harmony export */   "_4": function() { return /* binding */ emphasize; },
/* harmony export */   "_j": function() { return /* binding */ darken; },
/* harmony export */   "mi": function() { return /* binding */ getContrastRatio; },
/* harmony export */   "oo": function() { return /* binding */ hexToRgb; },
/* harmony export */   "tB": function() { return /* binding */ decomposeColor; },
/* harmony export */   "ve": function() { return /* binding */ hslToRgb; },
/* harmony export */   "vq": function() { return /* binding */ rgbToHex; },
/* harmony export */   "wy": function() { return /* binding */ recomposeColor; }
/* harmony export */ });
/* harmony import */ var _material_ui_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(60288);


/* eslint-disable no-use-before-define */

/**
 * Returns a number whose value is limited to the given range.
 *
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */
function clamp(value) {
  var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

  if (false) {}

  return Math.min(Math.max(min, value), max);
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 *
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */


function hexToRgb(color) {
  color = color.substr(1);
  var re = new RegExp(".{1,".concat(color.length >= 6 ? 2 : 1, "}"), 'g');
  var colors = color.match(re);

  if (colors && colors[0].length === 1) {
    colors = colors.map(function (n) {
      return n + n;
    });
  }

  return colors ? "rgb".concat(colors.length === 4 ? 'a' : '', "(").concat(colors.map(function (n, index) {
    return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
  }).join(', '), ")") : '';
}

function intToHex(int) {
  var hex = int.toString(16);
  return hex.length === 1 ? "0".concat(hex) : hex;
}
/**
 * Converts a color from CSS rgb format to CSS hex format.
 *
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */


function rgbToHex(color) {
  // Idempotent
  if (color.indexOf('#') === 0) {
    return color;
  }

  var _decomposeColor = decomposeColor(color),
      values = _decomposeColor.values;

  return "#".concat(values.map(function (n) {
    return intToHex(n);
  }).join(''));
}
/**
 * Converts a color from hsl format to rgb format.
 *
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */

function hslToRgb(color) {
  color = decomposeColor(color);
  var _color = color,
      values = _color.values;
  var h = values[0];
  var s = values[1] / 100;
  var l = values[2] / 100;
  var a = s * Math.min(l, 1 - l);

  var f = function f(n) {
    var k = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (n + h / 30) % 12;
    return l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
  };

  var type = 'rgb';
  var rgb = [Math.round(f(0) * 255), Math.round(f(8) * 255), Math.round(f(4) * 255)];

  if (color.type === 'hsla') {
    type += 'a';
    rgb.push(values[3]);
  }

  return recomposeColor({
    type: type,
    values: rgb
  });
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */

function decomposeColor(color) {
  // Idempotent
  if (color.type) {
    return color;
  }

  if (color.charAt(0) === '#') {
    return decomposeColor(hexToRgb(color));
  }

  var marker = color.indexOf('(');
  var type = color.substring(0, marker);

  if (['rgb', 'rgba', 'hsl', 'hsla'].indexOf(type) === -1) {
    throw new Error( false ? 0 : (0,_material_ui_utils__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(3, color));
  }

  var values = color.substring(marker + 1, color.length - 1).split(',');
  values = values.map(function (value) {
    return parseFloat(value);
  });
  return {
    type: type,
    values: values
  };
}
/**
 * Converts a color object with type and values to a string.
 *
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */

function recomposeColor(color) {
  var type = color.type;
  var values = color.values;

  if (type.indexOf('rgb') !== -1) {
    // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map(function (n, i) {
      return i < 3 ? parseInt(n, 10) : n;
    });
  } else if (type.indexOf('hsl') !== -1) {
    values[1] = "".concat(values[1], "%");
    values[2] = "".concat(values[2], "%");
  }

  return "".concat(type, "(").concat(values.join(', '), ")");
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 *
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */

function getContrastRatio(foreground, background) {
  var lumA = getLuminance(foreground);
  var lumB = getLuminance(background);
  return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */

function getLuminance(color) {
  color = decomposeColor(color);
  var rgb = color.type === 'hsl' ? decomposeColor(hslToRgb(color)).values : color.values;
  rgb = rgb.map(function (val) {
    val /= 255; // normalized

    return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
  }); // Truncate at 3 digits

  return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
/**
 * Darken or lighten a color, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function emphasize(color) {
  var coefficient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.15;
  return getLuminance(color) > 0.5 ? darken(color, coefficient) : lighten(color, coefficient);
}
var warnedOnce = false;
/**
 * Set the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} value - value to set the alpha channel to in the range 0 -1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 *
 * @deprecated
 * Use `import { alpha } from '@material-ui/core/styles'` instead.
 */

function fade(color, value) {
  if (false) {}

  return alpha(color, value);
}
/**
 * Set the absolute transparency of a color.
 * Any existing alpha value is overwritten.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} value - value to set the alpha channel to in the range 0-1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function alpha(color, value) {
  color = decomposeColor(color);
  value = clamp(value);

  if (color.type === 'rgb' || color.type === 'hsl') {
    color.type += 'a';
  }

  color.values[3] = value;
  return recomposeColor(color);
}
/**
 * Darkens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function darken(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clamp(coefficient);

  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] *= 1 - coefficient;
  } else if (color.type.indexOf('rgb') !== -1) {
    for (var i = 0; i < 3; i += 1) {
      color.values[i] *= 1 - coefficient;
    }
  }

  return recomposeColor(color);
}
/**
 * Lightens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function lighten(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clamp(coefficient);

  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] += (100 - color.values[2]) * coefficient;
  } else if (color.type.indexOf('rgb') !== -1) {
    for (var i = 0; i < 3; i += 1) {
      color.values[i] += (255 - color.values[i]) * coefficient;
    }
  }

  return recomposeColor(color);
}

/***/ }),

/***/ 90157:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ keys; },
/* harmony export */   "Z": function() { return /* binding */ createBreakpoints; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45987);


// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
var keys = ['xs', 'sm', 'md', 'lg', 'xl']; // Keep in mind that @media is inclusive by the CSS specification.

function createBreakpoints(breakpoints) {
  var _breakpoints$values = breakpoints.values,
      values = _breakpoints$values === void 0 ? {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920
  } : _breakpoints$values,
      _breakpoints$unit = breakpoints.unit,
      unit = _breakpoints$unit === void 0 ? 'px' : _breakpoints$unit,
      _breakpoints$step = breakpoints.step,
      step = _breakpoints$step === void 0 ? 5 : _breakpoints$step,
      other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(breakpoints, ["values", "unit", "step"]);

  function up(key) {
    var value = typeof values[key] === 'number' ? values[key] : key;
    return "@media (min-width:".concat(value).concat(unit, ")");
  }

  function down(key) {
    var endIndex = keys.indexOf(key) + 1;
    var upperbound = values[keys[endIndex]];

    if (endIndex === keys.length) {
      // xl down applies to all sizes
      return up('xs');
    }

    var value = typeof upperbound === 'number' && endIndex > 0 ? upperbound : key;
    return "@media (max-width:".concat(value - step / 100).concat(unit, ")");
  }

  function between(start, end) {
    var endIndex = keys.indexOf(end);

    if (endIndex === keys.length - 1) {
      return up(start);
    }

    return "@media (min-width:".concat(typeof values[start] === 'number' ? values[start] : start).concat(unit, ") and ") + "(max-width:".concat((endIndex !== -1 && typeof values[keys[endIndex + 1]] === 'number' ? values[keys[endIndex + 1]] : end) - step / 100).concat(unit, ")");
  }

  function only(key) {
    return between(key, key);
  }

  var warnedOnce = false;

  function width(key) {
    if (false) {}

    return values[key];
  }

  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
    keys: keys,
    values: values,
    up: up,
    down: down,
    between: between,
    only: only,
    width: width
  }, other);
}

/***/ }),

/***/ 73690:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* binding */ createMuiTheme; },
  "Z": function() { return /* binding */ styles_createTheme; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(45987);
// EXTERNAL MODULE: ./node_modules/@material-ui/utils/esm/deepmerge.js
var deepmerge = __webpack_require__(35953);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/createBreakpoints.js
var createBreakpoints = __webpack_require__(90157);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(4942);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/styles/createMixins.js


function createMixins(breakpoints, spacing, mixins) {
  var _toolbar;

  return (0,esm_extends/* default */.Z)({
    gutters: function gutters() {
      var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      console.warn(['Material-UI: theme.mixins.gutters() is deprecated.', 'You can use the source of the mixin directly:', "\n      paddingLeft: theme.spacing(2),\n      paddingRight: theme.spacing(2),\n      [theme.breakpoints.up('sm')]: {\n        paddingLeft: theme.spacing(3),\n        paddingRight: theme.spacing(3),\n      },\n      "].join('\n'));
      return (0,esm_extends/* default */.Z)({
        paddingLeft: spacing(2),
        paddingRight: spacing(2)
      }, styles, (0,defineProperty/* default */.Z)({}, breakpoints.up('sm'), (0,esm_extends/* default */.Z)({
        paddingLeft: spacing(3),
        paddingRight: spacing(3)
      }, styles[breakpoints.up('sm')])));
    },
    toolbar: (_toolbar = {
      minHeight: 56
    }, (0,defineProperty/* default */.Z)(_toolbar, "".concat(breakpoints.up('xs'), " and (orientation: landscape)"), {
      minHeight: 48
    }), (0,defineProperty/* default */.Z)(_toolbar, breakpoints.up('sm'), {
      minHeight: 64
    }), _toolbar)
  }, mixins);
}
// EXTERNAL MODULE: ./node_modules/@material-ui/utils/esm/formatMuiErrorMessage.js
var formatMuiErrorMessage = __webpack_require__(60288);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/colors/common.js
var common = __webpack_require__(34733);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/colors/grey.js
var grey = __webpack_require__(88105);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/colors/indigo.js
var indigo = __webpack_require__(34446);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/colors/pink.js
var pink = __webpack_require__(9198);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/colors/red.js
var red = __webpack_require__(20907);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/colors/orange.js
var orange = __webpack_require__(59546);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/colors/blue.js
var blue = __webpack_require__(96230);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/colors/green.js
var green = __webpack_require__(18334);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/colorManipulator.js
var colorManipulator = __webpack_require__(59693);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/styles/createPalette.js













var light = {
  // The colors used to style the text.
  text: {
    // The most important text.
    primary: 'rgba(0, 0, 0, 0.87)',
    // Secondary text.
    secondary: 'rgba(0, 0, 0, 0.54)',
    // Disabled text have even lower visual prominence.
    disabled: 'rgba(0, 0, 0, 0.38)',
    // Text hints.
    hint: 'rgba(0, 0, 0, 0.38)'
  },
  // The color used to divide different elements.
  divider: 'rgba(0, 0, 0, 0.12)',
  // The background colors used to style the surfaces.
  // Consistency between these values is important.
  background: {
    paper: common/* default.white */.Z.white,
    default: grey/* default.50 */.Z[50]
  },
  // The colors used to style the action elements.
  action: {
    // The color of an active action like an icon button.
    active: 'rgba(0, 0, 0, 0.54)',
    // The color of an hovered action.
    hover: 'rgba(0, 0, 0, 0.04)',
    hoverOpacity: 0.04,
    // The color of a selected action.
    selected: 'rgba(0, 0, 0, 0.08)',
    selectedOpacity: 0.08,
    // The color of a disabled action.
    disabled: 'rgba(0, 0, 0, 0.26)',
    // The background color of a disabled action.
    disabledBackground: 'rgba(0, 0, 0, 0.12)',
    disabledOpacity: 0.38,
    focus: 'rgba(0, 0, 0, 0.12)',
    focusOpacity: 0.12,
    activatedOpacity: 0.12
  }
};
var dark = {
  text: {
    primary: common/* default.white */.Z.white,
    secondary: 'rgba(255, 255, 255, 0.7)',
    disabled: 'rgba(255, 255, 255, 0.5)',
    hint: 'rgba(255, 255, 255, 0.5)',
    icon: 'rgba(255, 255, 255, 0.5)'
  },
  divider: 'rgba(255, 255, 255, 0.12)',
  background: {
    paper: grey/* default.800 */.Z[800],
    default: '#303030'
  },
  action: {
    active: common/* default.white */.Z.white,
    hover: 'rgba(255, 255, 255, 0.08)',
    hoverOpacity: 0.08,
    selected: 'rgba(255, 255, 255, 0.16)',
    selectedOpacity: 0.16,
    disabled: 'rgba(255, 255, 255, 0.3)',
    disabledBackground: 'rgba(255, 255, 255, 0.12)',
    disabledOpacity: 0.38,
    focus: 'rgba(255, 255, 255, 0.12)',
    focusOpacity: 0.12,
    activatedOpacity: 0.24
  }
};

function addLightOrDark(intent, direction, shade, tonalOffset) {
  var tonalOffsetLight = tonalOffset.light || tonalOffset;
  var tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;

  if (!intent[direction]) {
    if (intent.hasOwnProperty(shade)) {
      intent[direction] = intent[shade];
    } else if (direction === 'light') {
      intent.light = (0,colorManipulator/* lighten */.$n)(intent.main, tonalOffsetLight);
    } else if (direction === 'dark') {
      intent.dark = (0,colorManipulator/* darken */._j)(intent.main, tonalOffsetDark);
    }
  }
}

function createPalette(palette) {
  var _palette$primary = palette.primary,
      primary = _palette$primary === void 0 ? {
    light: indigo/* default.300 */.Z[300],
    main: indigo/* default.500 */.Z[500],
    dark: indigo/* default.700 */.Z[700]
  } : _palette$primary,
      _palette$secondary = palette.secondary,
      secondary = _palette$secondary === void 0 ? {
    light: pink/* default.A200 */.Z.A200,
    main: pink/* default.A400 */.Z.A400,
    dark: pink/* default.A700 */.Z.A700
  } : _palette$secondary,
      _palette$error = palette.error,
      error = _palette$error === void 0 ? {
    light: red/* default.300 */.Z[300],
    main: red/* default.500 */.Z[500],
    dark: red/* default.700 */.Z[700]
  } : _palette$error,
      _palette$warning = palette.warning,
      warning = _palette$warning === void 0 ? {
    light: orange/* default.300 */.Z[300],
    main: orange/* default.500 */.Z[500],
    dark: orange/* default.700 */.Z[700]
  } : _palette$warning,
      _palette$info = palette.info,
      info = _palette$info === void 0 ? {
    light: blue/* default.300 */.Z[300],
    main: blue/* default.500 */.Z[500],
    dark: blue/* default.700 */.Z[700]
  } : _palette$info,
      _palette$success = palette.success,
      success = _palette$success === void 0 ? {
    light: green/* default.300 */.Z[300],
    main: green/* default.500 */.Z[500],
    dark: green/* default.700 */.Z[700]
  } : _palette$success,
      _palette$type = palette.type,
      type = _palette$type === void 0 ? 'light' : _palette$type,
      _palette$contrastThre = palette.contrastThreshold,
      contrastThreshold = _palette$contrastThre === void 0 ? 3 : _palette$contrastThre,
      _palette$tonalOffset = palette.tonalOffset,
      tonalOffset = _palette$tonalOffset === void 0 ? 0.2 : _palette$tonalOffset,
      other = (0,objectWithoutProperties/* default */.Z)(palette, ["primary", "secondary", "error", "warning", "info", "success", "type", "contrastThreshold", "tonalOffset"]); // Use the same logic as
  // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
  // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54


  function getContrastText(background) {
    var contrastText = (0,colorManipulator/* getContrastRatio */.mi)(background, dark.text.primary) >= contrastThreshold ? dark.text.primary : light.text.primary;

    if (false) { var contrast; }

    return contrastText;
  }

  var augmentColor = function augmentColor(color) {
    var mainShade = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
    var lightShade = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 300;
    var darkShade = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 700;
    color = (0,esm_extends/* default */.Z)({}, color);

    if (!color.main && color[mainShade]) {
      color.main = color[mainShade];
    }

    if (!color.main) {
      throw new Error( false ? 0 : (0,formatMuiErrorMessage/* default */.Z)(4, mainShade));
    }

    if (typeof color.main !== 'string') {
      throw new Error( false ? 0 : (0,formatMuiErrorMessage/* default */.Z)(5, JSON.stringify(color.main)));
    }

    addLightOrDark(color, 'light', lightShade, tonalOffset);
    addLightOrDark(color, 'dark', darkShade, tonalOffset);

    if (!color.contrastText) {
      color.contrastText = getContrastText(color.main);
    }

    return color;
  };

  var types = {
    dark: dark,
    light: light
  };

  if (false) {}

  var paletteOutput = (0,deepmerge/* default */.Z)((0,esm_extends/* default */.Z)({
    // A collection of common colors.
    common: common/* default */.Z,
    // The palette type, can be light or dark.
    type: type,
    // The colors used to represent primary interface elements for a user.
    primary: augmentColor(primary),
    // The colors used to represent secondary interface elements for a user.
    secondary: augmentColor(secondary, 'A400', 'A200', 'A700'),
    // The colors used to represent interface elements that the user should be made aware of.
    error: augmentColor(error),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: augmentColor(warning),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: augmentColor(info),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: augmentColor(success),
    // The grey colors.
    grey: grey/* default */.Z,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: contrastThreshold,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText: getContrastText,
    // Generate a rich color object.
    augmentColor: augmentColor,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: tonalOffset
  }, types[type]), other);
  return paletteOutput;
}
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/styles/createTypography.js




function round(value) {
  return Math.round(value * 1e5) / 1e5;
}

var warnedOnce = false;

function roundWithDeprecationWarning(value) {
  if (false) {}

  return round(value);
}

var caseAllCaps = {
  textTransform: 'uppercase'
};
var defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
/**
 * @see @link{https://material.io/design/typography/the-type-system.html}
 * @see @link{https://material.io/design/typography/understanding-typography.html}
 */

function createTypography(palette, typography) {
  var _ref = typeof typography === 'function' ? typography(palette) : typography,
      _ref$fontFamily = _ref.fontFamily,
      fontFamily = _ref$fontFamily === void 0 ? defaultFontFamily : _ref$fontFamily,
      _ref$fontSize = _ref.fontSize,
      fontSize = _ref$fontSize === void 0 ? 14 : _ref$fontSize,
      _ref$fontWeightLight = _ref.fontWeightLight,
      fontWeightLight = _ref$fontWeightLight === void 0 ? 300 : _ref$fontWeightLight,
      _ref$fontWeightRegula = _ref.fontWeightRegular,
      fontWeightRegular = _ref$fontWeightRegula === void 0 ? 400 : _ref$fontWeightRegula,
      _ref$fontWeightMedium = _ref.fontWeightMedium,
      fontWeightMedium = _ref$fontWeightMedium === void 0 ? 500 : _ref$fontWeightMedium,
      _ref$fontWeightBold = _ref.fontWeightBold,
      fontWeightBold = _ref$fontWeightBold === void 0 ? 700 : _ref$fontWeightBold,
      _ref$htmlFontSize = _ref.htmlFontSize,
      htmlFontSize = _ref$htmlFontSize === void 0 ? 16 : _ref$htmlFontSize,
      allVariants = _ref.allVariants,
      pxToRem2 = _ref.pxToRem,
      other = (0,objectWithoutProperties/* default */.Z)(_ref, ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"]);

  if (false) {}

  var coef = fontSize / 14;

  var pxToRem = pxToRem2 || function (size) {
    return "".concat(size / htmlFontSize * coef, "rem");
  };

  var buildVariant = function buildVariant(fontWeight, size, lineHeight, letterSpacing, casing) {
    return (0,esm_extends/* default */.Z)({
      fontFamily: fontFamily,
      fontWeight: fontWeight,
      fontSize: pxToRem(size),
      // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
      lineHeight: lineHeight
    }, fontFamily === defaultFontFamily ? {
      letterSpacing: "".concat(round(letterSpacing / size), "em")
    } : {}, casing, allVariants);
  };

  var variants = {
    h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
    h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
    h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
    h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
    h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
    h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
    subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
    subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
    body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
    body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
    button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, caseAllCaps),
    caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
    overline: buildVariant(fontWeightRegular, 12, 2.66, 1, caseAllCaps)
  };
  return (0,deepmerge/* default */.Z)((0,esm_extends/* default */.Z)({
    htmlFontSize: htmlFontSize,
    pxToRem: pxToRem,
    round: roundWithDeprecationWarning,
    // TODO v5: remove
    fontFamily: fontFamily,
    fontSize: fontSize,
    fontWeightLight: fontWeightLight,
    fontWeightRegular: fontWeightRegular,
    fontWeightMedium: fontWeightMedium,
    fontWeightBold: fontWeightBold
  }, variants), other, {
    clone: false // No need to clone deep

  });
}
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/styles/shadows.js
var shadowKeyUmbraOpacity = 0.2;
var shadowKeyPenumbraOpacity = 0.14;
var shadowAmbientShadowOpacity = 0.12;

function createShadow() {
  return ["".concat(arguments.length <= 0 ? undefined : arguments[0], "px ").concat(arguments.length <= 1 ? undefined : arguments[1], "px ").concat(arguments.length <= 2 ? undefined : arguments[2], "px ").concat(arguments.length <= 3 ? undefined : arguments[3], "px rgba(0,0,0,").concat(shadowKeyUmbraOpacity, ")"), "".concat(arguments.length <= 4 ? undefined : arguments[4], "px ").concat(arguments.length <= 5 ? undefined : arguments[5], "px ").concat(arguments.length <= 6 ? undefined : arguments[6], "px ").concat(arguments.length <= 7 ? undefined : arguments[7], "px rgba(0,0,0,").concat(shadowKeyPenumbraOpacity, ")"), "".concat(arguments.length <= 8 ? undefined : arguments[8], "px ").concat(arguments.length <= 9 ? undefined : arguments[9], "px ").concat(arguments.length <= 10 ? undefined : arguments[10], "px ").concat(arguments.length <= 11 ? undefined : arguments[11], "px rgba(0,0,0,").concat(shadowAmbientShadowOpacity, ")")].join(',');
} // Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss


var shadows = ['none', createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)];
/* harmony default export */ var styles_shadows = (shadows);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/styles/shape.js
var shape = {
  borderRadius: 4
};
/* harmony default export */ var styles_shape = (shape);
// EXTERNAL MODULE: ./node_modules/@material-ui/system/esm/spacing.js + 1 modules
var esm_spacing = __webpack_require__(27122);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/styles/createSpacing.js

var warnOnce;
function createSpacing() {
  var spacingInput = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 8;

  // Already transformed.
  if (spacingInput.mui) {
    return spacingInput;
  } // Material Design layouts are visually balanced. Most measurements align to an 8dp grid applied, which aligns both spacing and the overall layout.
  // Smaller components, such as icons and type, can align to a 4dp grid.
  // https://material.io/design/layout/understanding-layout.html#usage


  var transform = (0,esm_spacing/* createUnarySpacing */.h)({
    spacing: spacingInput
  });

  var spacing = function spacing() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (false) {}

    if (args.length === 0) {
      return transform(1);
    }

    if (args.length === 1) {
      return transform(args[0]);
    }

    return args.map(function (argument) {
      if (typeof argument === 'string') {
        return argument;
      }

      var output = transform(argument);
      return typeof output === 'number' ? "".concat(output, "px") : output;
    }).join(' ');
  }; // Backward compatibility, to remove in v5.


  Object.defineProperty(spacing, 'unit', {
    get: function get() {
      if (false) {}

      return spacingInput;
    }
  });
  spacing.mui = true;
  return spacing;
}
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/transitions.js
var transitions = __webpack_require__(43366);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/zIndex.js
var zIndex = __webpack_require__(92781);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/styles/createTheme.js













function createTheme() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _options$breakpoints = options.breakpoints,
      breakpointsInput = _options$breakpoints === void 0 ? {} : _options$breakpoints,
      _options$mixins = options.mixins,
      mixinsInput = _options$mixins === void 0 ? {} : _options$mixins,
      _options$palette = options.palette,
      paletteInput = _options$palette === void 0 ? {} : _options$palette,
      spacingInput = options.spacing,
      _options$typography = options.typography,
      typographyInput = _options$typography === void 0 ? {} : _options$typography,
      other = (0,objectWithoutProperties/* default */.Z)(options, ["breakpoints", "mixins", "palette", "spacing", "typography"]);

  var palette = createPalette(paletteInput);
  var breakpoints = (0,createBreakpoints/* default */.Z)(breakpointsInput);
  var spacing = createSpacing(spacingInput);
  var muiTheme = (0,deepmerge/* default */.Z)({
    breakpoints: breakpoints,
    direction: 'ltr',
    mixins: createMixins(breakpoints, spacing, mixinsInput),
    overrides: {},
    // Inject custom styles
    palette: palette,
    props: {},
    // Provide default props
    shadows: styles_shadows,
    typography: createTypography(palette, typographyInput),
    spacing: spacing,
    shape: styles_shape,
    transitions: transitions/* default */.ZP,
    zIndex: zIndex/* default */.Z
  }, other);

  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  muiTheme = args.reduce(function (acc, argument) {
    return (0,deepmerge/* default */.Z)(acc, argument);
  }, muiTheme);

  if (false) { var traverse, pseudoClasses; }

  return muiTheme;
}

var createTheme_warnedOnce = false;
function createMuiTheme() {
  if (false) {}

  return createTheme.apply(void 0, arguments);
}
/* harmony default export */ var styles_createTheme = (createTheme);

/***/ }),

/***/ 99700:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _createTheme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73690);

var defaultTheme = (0,_createTheme__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
/* harmony default export */ __webpack_exports__["Z"] = (defaultTheme);

/***/ }),

/***/ 43366:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ui": function() { return /* binding */ easing; },
/* harmony export */   "x9": function() { return /* binding */ duration; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45987);

// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
// to learn the context in which each easing should be used.
var easing = {
  // This is the most common easing curve.
  easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
}; // Follow https://material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
// to learn when use what timing

var duration = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};

function formatMs(milliseconds) {
  return "".concat(Math.round(milliseconds), "ms");
}
/**
 * @param {string|Array} props
 * @param {object} param
 * @param {string} param.prop
 * @param {number} param.duration
 * @param {string} param.easing
 * @param {number} param.delay
 */


/* harmony default export */ __webpack_exports__["ZP"] = ({
  easing: easing,
  duration: duration,
  create: function create() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['all'];
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var _options$duration = options.duration,
        durationOption = _options$duration === void 0 ? duration.standard : _options$duration,
        _options$easing = options.easing,
        easingOption = _options$easing === void 0 ? easing.easeInOut : _options$easing,
        _options$delay = options.delay,
        delay = _options$delay === void 0 ? 0 : _options$delay,
        other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(options, ["duration", "easing", "delay"]);

    if (false) { var isNumber, isString; }

    return (Array.isArray(props) ? props : [props]).map(function (animatedProp) {
      return "".concat(animatedProp, " ").concat(typeof durationOption === 'string' ? durationOption : formatMs(durationOption), " ").concat(easingOption, " ").concat(typeof delay === 'string' ? delay : formatMs(delay));
    }).join(',');
  },
  getAutoHeightDuration: function getAutoHeightDuration(height) {
    if (!height) {
      return 0;
    }

    var constant = height / 36; // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10

    return Math.round((4 + 15 * Math.pow(constant, 0.25) + constant / 5) * 10);
  }
});

/***/ }),

/***/ 8920:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useTheme; }
/* harmony export */ });
/* harmony import */ var _material_ui_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(159);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _defaultTheme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99700);



function useTheme() {
  var theme = (0,_material_ui_styles__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)() || _defaultTheme__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z;

  if (false) {}

  return theme;
}

/***/ }),

/***/ 52543:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87462);
/* harmony import */ var _material_ui_styles__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38920);
/* harmony import */ var _defaultTheme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99700);




function withStyles(stylesOrCreator, options) {
  return (0,_material_ui_styles__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(stylesOrCreator, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
    defaultTheme: _defaultTheme__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z
  }, options));
}

/* harmony default export */ __webpack_exports__["Z"] = (withStyles);

/***/ }),

/***/ 92781:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
var zIndex = {
  mobileStepper: 1000,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};
/* harmony default export */ __webpack_exports__["Z"] = (zIndex);

/***/ }),

/***/ 5653:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ getTransitionProps; },
/* harmony export */   "n": function() { return /* binding */ reflow; }
/* harmony export */ });
var reflow = function reflow(node) {
  return node.scrollTop;
};
function getTransitionProps(props, options) {
  var timeout = props.timeout,
      _props$style = props.style,
      style = _props$style === void 0 ? {} : _props$style;
  return {
    duration: style.transitionDuration || typeof timeout === 'number' ? timeout : timeout[options.mode] || 0,
    delay: style.transitionDelay
  };
}

/***/ }),

/***/ 93871:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ capitalize; }
/* harmony export */ });
/* harmony import */ var _material_ui_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(60288);

// It should to be noted that this function isn't equivalent to `text-transform: capitalize`.
//
// A strict capitalization should uppercase the first letter of each word a the sentence.
// We only handle the first word.
function capitalize(string) {
  if (typeof string !== 'string') {
    throw new Error( false ? 0 : (0,_material_ui_utils__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(7));
  }

  return string.charAt(0).toUpperCase() + string.slice(1);
}

/***/ }),

/***/ 42959:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ createChainedFunction; }
/* harmony export */ });
/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */
function createChainedFunction() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  return funcs.reduce(function (acc, func) {
    if (func == null) {
      return acc;
    }

    if (false) {}

    return function chainedFunction() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      acc.apply(this, args);
      func.apply(this, args);
    };
  }, function () {});
}

/***/ }),

/***/ 63786:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ createSvgIcon; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87462);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _SvgIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62087);



/**
 * Private module reserved for @material-ui/x packages.
 */

function createSvgIcon(path, displayName) {
  var Component = function Component(props, ref) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_SvgIcon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
      ref: ref
    }, props), path);
  };

  if (false) {}

  Component.muiName = _SvgIcon__WEBPACK_IMPORTED_MODULE_1__/* ["default"].muiName */ .Z.muiName;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.memo( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(Component));
}

/***/ }),

/***/ 79437:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ debounce; }
/* harmony export */ });
// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function debounce(func) {
  var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 166;
  var timeout;

  function debounced() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    // eslint-disable-next-line consistent-this
    var that = this;

    var later = function later() {
      func.apply(that, args);
    };

    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  }

  debounced.clear = function () {
    clearTimeout(timeout);
  };

  return debounced;
}

/***/ }),

/***/ 44343:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "capitalize": function() { return /* reexport */ capitalize/* default */.Z; },
  "createChainedFunction": function() { return /* reexport */ createChainedFunction/* default */.Z; },
  "createSvgIcon": function() { return /* reexport */ createSvgIcon/* default */.Z; },
  "debounce": function() { return /* reexport */ debounce/* default */.Z; },
  "deprecatedPropType": function() { return /* reexport */ deprecatedPropType; },
  "isMuiElement": function() { return /* reexport */ isMuiElement/* default */.Z; },
  "ownerDocument": function() { return /* reexport */ ownerDocument/* default */.Z; },
  "ownerWindow": function() { return /* reexport */ ownerWindow/* default */.Z; },
  "requirePropFactory": function() { return /* reexport */ requirePropFactory; },
  "setRef": function() { return /* reexport */ setRef/* default */.Z; },
  "unstable_useId": function() { return /* reexport */ unstable_useId/* default */.Z; },
  "unsupportedProp": function() { return /* reexport */ unsupportedProp; },
  "useControlled": function() { return /* reexport */ useControlled/* default */.Z; },
  "useEventCallback": function() { return /* reexport */ useEventCallback/* default */.Z; },
  "useForkRef": function() { return /* reexport */ useForkRef/* default */.Z; },
  "useIsFocusVisible": function() { return /* reexport */ useIsFocusVisible/* default */.Z; }
});

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/capitalize.js
var capitalize = __webpack_require__(93871);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/createChainedFunction.js
var createChainedFunction = __webpack_require__(42959);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/createSvgIcon.js
var createSvgIcon = __webpack_require__(63786);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/debounce.js
var debounce = __webpack_require__(79437);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/utils/deprecatedPropType.js
function deprecatedPropType(validator, reason) {
  if (true) {
    return function () {
      return null;
    };
  }

  return function (props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (typeof props[propName] !== 'undefined') {
      return new Error("The ".concat(location, " `").concat(propFullNameSafe, "` of ") + "`".concat(componentNameSafe, "` is deprecated. ").concat(reason));
    }

    return null;
  };
}
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/isMuiElement.js
var isMuiElement = __webpack_require__(83711);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/ownerDocument.js
var ownerDocument = __webpack_require__(30626);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/ownerWindow.js
var ownerWindow = __webpack_require__(80713);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/utils/requirePropFactory.js
function requirePropFactory(componentNameInError) {
  if (true) {
    return function () {
      return null;
    };
  }

  var requireProp = function requireProp(requiredProp) {
    return function (props, propName, componentName, location, propFullName) {
      var propFullNameSafe = propFullName || propName;

      if (typeof props[propName] !== 'undefined' && !props[requiredProp]) {
        return new Error("The prop `".concat(propFullNameSafe, "` of ") + "`".concat(componentNameInError, "` must be used on `").concat(requiredProp, "`."));
      }

      return null;
    };
  };

  return requireProp;
}
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/setRef.js
var setRef = __webpack_require__(34236);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/utils/unsupportedProp.js
function unsupportedProp(props, propName, componentName, location, propFullName) {
  if (true) {
    return null;
  }

  var propFullNameSafe = propFullName || propName;

  if (typeof props[propName] !== 'undefined') {
    return new Error("The prop `".concat(propFullNameSafe, "` is not supported. Please remove it."));
  }

  return null;
}
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/useControlled.js
var useControlled = __webpack_require__(22775);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/useEventCallback.js
var useEventCallback = __webpack_require__(55192);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/useForkRef.js
var useForkRef = __webpack_require__(17294);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/unstable_useId.js
var unstable_useId = __webpack_require__(95001);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/useIsFocusVisible.js
var useIsFocusVisible = __webpack_require__(24896);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/utils/index.js













 // eslint-disable-next-line camelcase




/***/ }),

/***/ 83711:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ isMuiElement; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function isMuiElement(element, muiNames) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(element) && muiNames.indexOf(element.type.muiName) !== -1;
}

/***/ }),

/***/ 30626:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ownerDocument; }
/* harmony export */ });
function ownerDocument(node) {
  return node && node.ownerDocument || document;
}

/***/ }),

/***/ 80713:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ownerWindow; }
/* harmony export */ });
/* harmony import */ var _ownerDocument__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30626);

function ownerWindow(node) {
  var doc = (0,_ownerDocument__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(node);
  return doc.defaultView || window;
}

/***/ }),

/***/ 34236:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ setRef; }
/* harmony export */ });
// TODO v5: consider to make it private
function setRef(ref, value) {
  if (typeof ref === 'function') {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
}

/***/ }),

/***/ 95001:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useId; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/**
 * Private module reserved for @material-ui/x packages.
 */

function useId(idOverride) {
  var _React$useState = react__WEBPACK_IMPORTED_MODULE_0__.useState(idOverride),
      defaultId = _React$useState[0],
      setDefaultId = _React$useState[1];

  var id = idOverride || defaultId;
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function () {
    if (defaultId == null) {
      // Fallback to this default id when possible.
      // Use the random value for client-side rendering only.
      // We can't use it server-side.
      setDefaultId("mui-".concat(Math.round(Math.random() * 1e5)));
    }
  }, [defaultId]);
  return id;
}

/***/ }),

/***/ 22775:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useControlled; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* eslint-disable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */

function useControlled(_ref) {
  var controlled = _ref.controlled,
      defaultProp = _ref.default,
      name = _ref.name,
      _ref$state = _ref.state,
      state = _ref$state === void 0 ? 'value' : _ref$state;

  var _React$useRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(controlled !== undefined),
      isControlled = _React$useRef.current;

  var _React$useState = react__WEBPACK_IMPORTED_MODULE_0__.useState(defaultProp),
      valueState = _React$useState[0],
      setValue = _React$useState[1];

  var value = isControlled ? controlled : valueState;

  if (false) { var _React$useRef2, defaultValue; }

  var setValueIfUncontrolled = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function (newValue) {
    if (!isControlled) {
      setValue(newValue);
    }
  }, []);
  return [value, setValueIfUncontrolled];
}

/***/ }),

/***/ 55192:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useEventCallback; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var useEnhancedEffect = typeof window !== 'undefined' ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect : react__WEBPACK_IMPORTED_MODULE_0__.useEffect;
/**
 * https://github.com/facebook/react/issues/14099#issuecomment-440013892
 *
 * @param {function} fn
 */

function useEventCallback(fn) {
  var ref = react__WEBPACK_IMPORTED_MODULE_0__.useRef(fn);
  useEnhancedEffect(function () {
    ref.current = fn;
  });
  return react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function () {
    return (0, ref.current).apply(void 0, arguments);
  }, []);
}

/***/ }),

/***/ 17294:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useForkRef; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _setRef__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34236);


function useForkRef(refA, refB) {
  /**
   * This will create a new function if the ref props change and are defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior
   */
  return react__WEBPACK_IMPORTED_MODULE_0__.useMemo(function () {
    if (refA == null && refB == null) {
      return null;
    }

    return function (refValue) {
      (0,_setRef__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(refA, refValue);
      (0,_setRef__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(refB, refValue);
    };
  }, [refA, refB]);
}

/***/ }),

/***/ 24896:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useIsFocusVisible; }
/* harmony export */ });
/* unused harmony export teardown */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73935);
// based on https://github.com/WICG/focus-visible/blob/v4.1.5/src/focus-visible.js


var hadKeyboardEvent = true;
var hadFocusVisibleRecently = false;
var hadFocusVisibleRecentlyTimeout = null;
var inputTypesWhitelist = {
  text: true,
  search: true,
  url: true,
  tel: true,
  email: true,
  password: true,
  number: true,
  date: true,
  month: true,
  week: true,
  time: true,
  datetime: true,
  'datetime-local': true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @return {boolean}
 */

function focusTriggersKeyboardModality(node) {
  var type = node.type,
      tagName = node.tagName;

  if (tagName === 'INPUT' && inputTypesWhitelist[type] && !node.readOnly) {
    return true;
  }

  if (tagName === 'TEXTAREA' && !node.readOnly) {
    return true;
  }

  if (node.isContentEditable) {
    return true;
  }

  return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */


function handleKeyDown(event) {
  if (event.metaKey || event.altKey || event.ctrlKey) {
    return;
  }

  hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */


function handlePointerDown() {
  hadKeyboardEvent = false;
}

function handleVisibilityChange() {
  if (this.visibilityState === 'hidden') {
    // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    if (hadFocusVisibleRecently) {
      hadKeyboardEvent = true;
    }
  }
}

function prepare(doc) {
  doc.addEventListener('keydown', handleKeyDown, true);
  doc.addEventListener('mousedown', handlePointerDown, true);
  doc.addEventListener('pointerdown', handlePointerDown, true);
  doc.addEventListener('touchstart', handlePointerDown, true);
  doc.addEventListener('visibilitychange', handleVisibilityChange, true);
}

function teardown(doc) {
  doc.removeEventListener('keydown', handleKeyDown, true);
  doc.removeEventListener('mousedown', handlePointerDown, true);
  doc.removeEventListener('pointerdown', handlePointerDown, true);
  doc.removeEventListener('touchstart', handlePointerDown, true);
  doc.removeEventListener('visibilitychange', handleVisibilityChange, true);
}

function isFocusVisible(event) {
  var target = event.target;

  try {
    return target.matches(':focus-visible');
  } catch (error) {} // browsers not implementing :focus-visible will throw a SyntaxError
  // we use our own heuristic for those browsers
  // rethrow might be better if it's not the expected error but do we really
  // want to crash if focus-visible malfunctioned?
  // no need for validFocusTarget check. the user does that by attaching it to
  // focusable events only


  return hadKeyboardEvent || focusTriggersKeyboardModality(target);
}
/**
 * Should be called if a blur event is fired on a focus-visible element
 */


function handleBlurVisible() {
  // To detect a tab/window switch, we look for a blur event followed
  // rapidly by a visibility change.
  // If we don't see a visibility change within 100ms, it's probably a
  // regular focus change.
  hadFocusVisibleRecently = true;
  window.clearTimeout(hadFocusVisibleRecentlyTimeout);
  hadFocusVisibleRecentlyTimeout = window.setTimeout(function () {
    hadFocusVisibleRecently = false;
  }, 100);
}

function useIsFocusVisible() {
  var ref = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function (instance) {
    var node = react_dom__WEBPACK_IMPORTED_MODULE_1__.findDOMNode(instance);

    if (node != null) {
      prepare(node.ownerDocument);
    }
  }, []);

  if (false) {}

  return {
    isFocusVisible: isFocusVisible,
    onBlurVisible: handleBlurVisible,
    ref: ref
  };
}

/***/ }),

/***/ 33636:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export clsx */
function r(e){var t,f,n="";if("string"==typeof e||"number"==typeof e)n+=e;else if("object"==typeof e)if(Array.isArray(e))for(t=0;t<e.length;t++)e[t]&&(f=r(e[t]))&&(n&&(n+=" "),n+=f);else for(t in e)e[t]&&(n&&(n+=" "),n+=t);return n}function clsx(){for(var e,t,f=0,n="";f<arguments.length;)(e=arguments[f++])&&(t=r(e))&&(n&&(n+=" "),n+=t);return n}/* harmony default export */ __webpack_exports__["Z"] = (clsx);

/***/ }),

/***/ 18042:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);

var _interopRequireWildcard = __webpack_require__(75263);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(67294));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2108));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
}), 'NavigateBefore');

exports.Z = _default;

/***/ }),

/***/ 98121:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);

var _interopRequireWildcard = __webpack_require__(75263);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(67294));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2108));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), 'NavigateNext');

exports.Z = _default;

/***/ }),

/***/ 2108:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "default", ({
  enumerable: true,
  get: function get() {
    return _utils.createSvgIcon;
  }
}));

var _utils = __webpack_require__(44343);

/***/ }),

/***/ 26975:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "NU": function() { return /* binding */ StylesContext; },
/* harmony export */   "ZP": function() { return /* binding */ StylesProvider; }
/* harmony export */ });
/* unused harmony export sheetsManager */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45987);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _createGenerateClassName__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5034);
/* harmony import */ var jss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54013);
/* harmony import */ var _jssPreset__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54620);







 // Default JSS instance.

var jss = (0,jss__WEBPACK_IMPORTED_MODULE_1__/* .create */ .Ue)((0,_jssPreset__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)()); // Use a singleton or the provided one by the context.
//
// The counter-based approach doesn't tolerate any mistake.
// It's much safer to use the same counter everywhere.

var generateClassName = (0,_createGenerateClassName__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(); // Exported for test purposes

var sheetsManager = new Map();
var defaultOptions = {
  disableGeneration: false,
  generateClassName: generateClassName,
  jss: jss,
  sheetsCache: null,
  sheetsManager: sheetsManager,
  sheetsRegistry: null
};
var StylesContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext(defaultOptions);

if (false) {}

var injectFirstNode;
function StylesProvider(props) {
  var children = props.children,
      _props$injectFirst = props.injectFirst,
      injectFirst = _props$injectFirst === void 0 ? false : _props$injectFirst,
      _props$disableGenerat = props.disableGeneration,
      disableGeneration = _props$disableGenerat === void 0 ? false : _props$disableGenerat,
      localOptions = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(props, ["children", "injectFirst", "disableGeneration"]);

  var outerOptions = react__WEBPACK_IMPORTED_MODULE_0__.useContext(StylesContext);

  var context = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, outerOptions, {
    disableGeneration: disableGeneration
  }, localOptions);

  if (false) {}

  if (false) {}

  if (false) {}

  if (!context.jss.options.insertionPoint && injectFirst && typeof window !== 'undefined') {
    if (!injectFirstNode) {
      var head = document.head;
      injectFirstNode = document.createComment('mui-inject-first');
      head.insertBefore(injectFirstNode, head.firstChild);
    }

    context.jss = (0,jss__WEBPACK_IMPORTED_MODULE_1__/* .create */ .Ue)({
      plugins: (0,_jssPreset__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().plugins,
      insertionPoint: injectFirstNode
    });
  }

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(StylesContext.Provider, {
    value: context
  }, children);
}
 false ? 0 : void 0;

if (false) {}

/***/ }),

/***/ 13457:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87462);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _useTheme_ThemeContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83800);
/* harmony import */ var _useTheme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(159);
/* harmony import */ var _nested__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17076);






 // To support composition of theme.

function mergeOuterLocalTheme(outerTheme, localTheme) {
  if (typeof localTheme === 'function') {
    var mergedTheme = localTheme(outerTheme);

    if (false) {}

    return mergedTheme;
  }

  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, outerTheme, localTheme);
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */


function ThemeProvider(props) {
  var children = props.children,
      localTheme = props.theme;
  var outerTheme = (0,_useTheme__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();

  if (false) {}

  var theme = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(function () {
    var output = outerTheme === null ? localTheme : mergeOuterLocalTheme(outerTheme, localTheme);

    if (output != null) {
      output[_nested__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z] = outerTheme !== null;
    }

    return output;
  }, [localTheme, outerTheme]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_useTheme_ThemeContext__WEBPACK_IMPORTED_MODULE_4__/* ["default"].Provider */ .Z.Provider, {
    value: theme
  }, children);
}

 false ? 0 : void 0;

if (false) {}

/* harmony default export */ __webpack_exports__["Z"] = (ThemeProvider);

/***/ }),

/***/ 17076:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
/* harmony default export */ __webpack_exports__["Z"] = (hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__');

/***/ }),

/***/ 5034:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ createGenerateClassName; }
/* harmony export */ });
/* harmony import */ var _ThemeProvider_nested__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17076);

/**
 * This is the list of the style rule name we use as drop in replacement for the built-in
 * pseudo classes (:checked, :disabled, :focused, etc.).
 *
 * Why do they exist in the first place?
 * These classes are used at a specificity of 2.
 * It allows them to override previously definied styles as well as
 * being untouched by simple user overrides.
 */

var pseudoClasses = ['checked', 'disabled', 'error', 'focused', 'focusVisible', 'required', 'expanded', 'selected']; // Returns a function which generates unique class names based on counters.
// When new generator function is created, rule counter is reset.
// We need to reset the rule counter for SSR for each request.
//
// It's inspired by
// https://github.com/cssinjs/jss/blob/4e6a05dd3f7b6572fdd3ab216861d9e446c20331/src/utils/createGenerateClassName.js

function createGenerateClassName() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$disableGloba = options.disableGlobal,
      disableGlobal = _options$disableGloba === void 0 ? false : _options$disableGloba,
      _options$productionPr = options.productionPrefix,
      productionPrefix = _options$productionPr === void 0 ? 'jss' : _options$productionPr,
      _options$seed = options.seed,
      seed = _options$seed === void 0 ? '' : _options$seed;
  var seedPrefix = seed === '' ? '' : "".concat(seed, "-");
  var ruleCounter = 0;

  var getNextCounterId = function getNextCounterId() {
    ruleCounter += 1;

    if (false) {}

    return ruleCounter;
  };

  return function (rule, styleSheet) {
    var name = styleSheet.options.name; // Is a global static MUI style?

    if (name && name.indexOf('Mui') === 0 && !styleSheet.options.link && !disableGlobal) {
      // We can use a shorthand class name, we never use the keys to style the components.
      if (pseudoClasses.indexOf(rule.key) !== -1) {
        return "Mui-".concat(rule.key);
      }

      var prefix = "".concat(seedPrefix).concat(name, "-").concat(rule.key);

      if (!styleSheet.options.theme[_ThemeProvider_nested__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z] || seed !== '') {
        return prefix;
      }

      return "".concat(prefix, "-").concat(getNextCounterId());
    }

    if (true) {
      return "".concat(seedPrefix).concat(productionPrefix).concat(getNextCounterId());
    }

    var suffix = "".concat(rule.key, "-").concat(getNextCounterId()); // Help with debuggability.

    if (styleSheet.options.classNamePrefix) {
      return "".concat(seedPrefix).concat(styleSheet.options.classNamePrefix, "-").concat(suffix);
    }

    return "".concat(seedPrefix).concat(suffix);
  };
}

/***/ }),

/***/ 93869:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getThemeProps; }
/* harmony export */ });
/* eslint-disable no-restricted-syntax */
function getThemeProps(params) {
  var theme = params.theme,
      name = params.name,
      props = params.props;

  if (!theme || !theme.props || !theme.props[name]) {
    return props;
  } // Resolve default props, code borrow from React source.
  // https://github.com/facebook/react/blob/15a8f031838a553e41c0b66eb1bcf1da8448104d/packages/react/src/ReactElement.js#L221


  var defaultProps = theme.props[name];
  var propName;

  for (propName in defaultProps) {
    if (props[propName] === undefined) {
      props[propName] = defaultProps[propName];
    }
  }

  return props;
}

/***/ }),

/***/ 54620:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ jssPreset; }
/* harmony export */ });
/* harmony import */ var jss_plugin_rule_value_function__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27202);
/* harmony import */ var jss_plugin_global__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5019);
/* harmony import */ var jss_plugin_nested__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63057);
/* harmony import */ var jss_plugin_camel_case__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16345);
/* harmony import */ var jss_plugin_default_unit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83961);
/* harmony import */ var jss_plugin_vendor_prefixer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3203);
/* harmony import */ var jss_plugin_props_sort__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26895);






 // Subset of jss-preset-default with only the plugins the Material-UI components are using.

function jssPreset() {
  return {
    plugins: [(0,jss_plugin_rule_value_function__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(), (0,jss_plugin_global__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(), (0,jss_plugin_nested__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(), (0,jss_plugin_camel_case__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(), (0,jss_plugin_default_unit__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(), // Disable the vendor prefixer server-side, it does nothing.
    // This way, we can get a performance boost.
    // In the documentation, we are using `autoprefixer` to solve this problem.
    typeof window === 'undefined' ? null : (0,jss_plugin_vendor_prefixer__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(), (0,jss_plugin_props_sort__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)()]
  };
}

/***/ }),

/***/ 11719:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ makeStyles; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(45987);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/jss/dist/jss.esm.js
var jss_esm = __webpack_require__(54013);
// EXTERNAL MODULE: ./node_modules/@material-ui/styles/esm/mergeClasses/mergeClasses.js
var mergeClasses = __webpack_require__(65835);
;// CONCATENATED MODULE: ./node_modules/@material-ui/styles/esm/makeStyles/multiKeyStore.js
// Used https://github.com/thinkloop/multi-key-cache as inspiration
var multiKeyStore = {
  set: function set(cache, key1, key2, value) {
    var subCache = cache.get(key1);

    if (!subCache) {
      subCache = new Map();
      cache.set(key1, subCache);
    }

    subCache.set(key2, value);
  },
  get: function get(cache, key1, key2) {
    var subCache = cache.get(key1);
    return subCache ? subCache.get(key2) : undefined;
  },
  delete: function _delete(cache, key1, key2) {
    var subCache = cache.get(key1);
    subCache.delete(key2);
  }
};
/* harmony default export */ var makeStyles_multiKeyStore = (multiKeyStore);
// EXTERNAL MODULE: ./node_modules/@material-ui/styles/esm/useTheme/useTheme.js
var useTheme = __webpack_require__(159);
// EXTERNAL MODULE: ./node_modules/@material-ui/styles/esm/StylesProvider/StylesProvider.js
var StylesProvider = __webpack_require__(26975);
;// CONCATENATED MODULE: ./node_modules/@material-ui/styles/esm/makeStyles/indexCounter.js
/* eslint-disable import/prefer-default-export */
// Global index counter to preserve source order.
// We create the style sheet during the creation of the component,
// children are handled after the parents, so the order of style elements would be parent->child.
// It is a problem though when a parent passes a className
// which needs to override any child's styles.
// StyleSheet of the child has a higher specificity, because of the source order.
// So our solution is to render sheets them in the reverse order child->sheet, so
// that parent has a higher specificity.
var indexCounter = -1e9;
function increment() {
  indexCounter += 1;

  if (false) {}

  return indexCounter;
}
// EXTERNAL MODULE: ./node_modules/@material-ui/utils/esm/deepmerge.js
var deepmerge = __webpack_require__(35953);
;// CONCATENATED MODULE: ./node_modules/@material-ui/styles/esm/getStylesCreator/getStylesCreator.js




function getStylesCreator(stylesOrCreator) {
  var themingEnabled = typeof stylesOrCreator === 'function';

  if (false) {}

  return {
    create: function create(theme, name) {
      var styles;

      try {
        styles = themingEnabled ? stylesOrCreator(theme) : stylesOrCreator;
      } catch (err) {
        if (false) {}

        throw err;
      }

      if (!name || !theme.overrides || !theme.overrides[name]) {
        return styles;
      }

      var overrides = theme.overrides[name];

      var stylesWithOverrides = (0,esm_extends/* default */.Z)({}, styles);

      Object.keys(overrides).forEach(function (key) {
        if (false) {}

        stylesWithOverrides[key] = (0,deepmerge/* default */.Z)(stylesWithOverrides[key], overrides[key]);
      });
      return stylesWithOverrides;
    },
    options: {}
  };
}
;// CONCATENATED MODULE: ./node_modules/@material-ui/styles/esm/getStylesCreator/noopTheme.js
// We use the same empty object to ref count the styles that don't need a theme object.
var noopTheme = {};
/* harmony default export */ var getStylesCreator_noopTheme = (noopTheme);
;// CONCATENATED MODULE: ./node_modules/@material-ui/styles/esm/makeStyles/makeStyles.js












function getClasses(_ref, classes, Component) {
  var state = _ref.state,
      stylesOptions = _ref.stylesOptions;

  if (stylesOptions.disableGeneration) {
    return classes || {};
  }

  if (!state.cacheClasses) {
    state.cacheClasses = {
      // Cache for the finalized classes value.
      value: null,
      // Cache for the last used classes prop pointer.
      lastProp: null,
      // Cache for the last used rendered classes pointer.
      lastJSS: {}
    };
  } // Tracks if either the rendered classes or classes prop has changed,
  // requiring the generation of a new finalized classes object.


  var generate = false;

  if (state.classes !== state.cacheClasses.lastJSS) {
    state.cacheClasses.lastJSS = state.classes;
    generate = true;
  }

  if (classes !== state.cacheClasses.lastProp) {
    state.cacheClasses.lastProp = classes;
    generate = true;
  }

  if (generate) {
    state.cacheClasses.value = (0,mergeClasses/* default */.Z)({
      baseClasses: state.cacheClasses.lastJSS,
      newClasses: classes,
      Component: Component
    });
  }

  return state.cacheClasses.value;
}

function attach(_ref2, props) {
  var state = _ref2.state,
      theme = _ref2.theme,
      stylesOptions = _ref2.stylesOptions,
      stylesCreator = _ref2.stylesCreator,
      name = _ref2.name;

  if (stylesOptions.disableGeneration) {
    return;
  }

  var sheetManager = makeStyles_multiKeyStore.get(stylesOptions.sheetsManager, stylesCreator, theme);

  if (!sheetManager) {
    sheetManager = {
      refs: 0,
      staticSheet: null,
      dynamicStyles: null
    };
    makeStyles_multiKeyStore.set(stylesOptions.sheetsManager, stylesCreator, theme, sheetManager);
  }

  var options = (0,esm_extends/* default */.Z)({}, stylesCreator.options, stylesOptions, {
    theme: theme,
    flip: typeof stylesOptions.flip === 'boolean' ? stylesOptions.flip : theme.direction === 'rtl'
  });

  options.generateId = options.serverGenerateClassName || options.generateClassName;
  var sheetsRegistry = stylesOptions.sheetsRegistry;

  if (sheetManager.refs === 0) {
    var staticSheet;

    if (stylesOptions.sheetsCache) {
      staticSheet = makeStyles_multiKeyStore.get(stylesOptions.sheetsCache, stylesCreator, theme);
    }

    var styles = stylesCreator.create(theme, name);

    if (!staticSheet) {
      staticSheet = stylesOptions.jss.createStyleSheet(styles, (0,esm_extends/* default */.Z)({
        link: false
      }, options));
      staticSheet.attach();

      if (stylesOptions.sheetsCache) {
        makeStyles_multiKeyStore.set(stylesOptions.sheetsCache, stylesCreator, theme, staticSheet);
      }
    }

    if (sheetsRegistry) {
      sheetsRegistry.add(staticSheet);
    }

    sheetManager.staticSheet = staticSheet;
    sheetManager.dynamicStyles = (0,jss_esm/* getDynamicStyles */._$)(styles);
  }

  if (sheetManager.dynamicStyles) {
    var dynamicSheet = stylesOptions.jss.createStyleSheet(sheetManager.dynamicStyles, (0,esm_extends/* default */.Z)({
      link: true
    }, options));
    dynamicSheet.update(props);
    dynamicSheet.attach();
    state.dynamicSheet = dynamicSheet;
    state.classes = (0,mergeClasses/* default */.Z)({
      baseClasses: sheetManager.staticSheet.classes,
      newClasses: dynamicSheet.classes
    });

    if (sheetsRegistry) {
      sheetsRegistry.add(dynamicSheet);
    }
  } else {
    state.classes = sheetManager.staticSheet.classes;
  }

  sheetManager.refs += 1;
}

function update(_ref3, props) {
  var state = _ref3.state;

  if (state.dynamicSheet) {
    state.dynamicSheet.update(props);
  }
}

function detach(_ref4) {
  var state = _ref4.state,
      theme = _ref4.theme,
      stylesOptions = _ref4.stylesOptions,
      stylesCreator = _ref4.stylesCreator;

  if (stylesOptions.disableGeneration) {
    return;
  }

  var sheetManager = makeStyles_multiKeyStore.get(stylesOptions.sheetsManager, stylesCreator, theme);
  sheetManager.refs -= 1;
  var sheetsRegistry = stylesOptions.sheetsRegistry;

  if (sheetManager.refs === 0) {
    makeStyles_multiKeyStore["delete"](stylesOptions.sheetsManager, stylesCreator, theme);
    stylesOptions.jss.removeStyleSheet(sheetManager.staticSheet);

    if (sheetsRegistry) {
      sheetsRegistry.remove(sheetManager.staticSheet);
    }
  }

  if (state.dynamicSheet) {
    stylesOptions.jss.removeStyleSheet(state.dynamicSheet);

    if (sheetsRegistry) {
      sheetsRegistry.remove(state.dynamicSheet);
    }
  }
}

function useSynchronousEffect(func, values) {
  var key = react.useRef([]);
  var output; // Store "generation" key. Just returns a new object every time

  var currentKey = react.useMemo(function () {
    return {};
  }, values); // eslint-disable-line react-hooks/exhaustive-deps
  // "the first render", or "memo dropped the value"

  if (key.current !== currentKey) {
    key.current = currentKey;
    output = func();
  }

  react.useEffect(function () {
    return function () {
      if (output) {
        output();
      }
    };
  }, [currentKey] // eslint-disable-line react-hooks/exhaustive-deps
  );
}

function makeStyles(stylesOrCreator) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var name = options.name,
      classNamePrefixOption = options.classNamePrefix,
      Component = options.Component,
      _options$defaultTheme = options.defaultTheme,
      defaultTheme = _options$defaultTheme === void 0 ? getStylesCreator_noopTheme : _options$defaultTheme,
      stylesOptions2 = (0,objectWithoutProperties/* default */.Z)(options, ["name", "classNamePrefix", "Component", "defaultTheme"]);

  var stylesCreator = getStylesCreator(stylesOrCreator);
  var classNamePrefix = name || classNamePrefixOption || 'makeStyles';
  stylesCreator.options = {
    index: increment(),
    name: name,
    meta: classNamePrefix,
    classNamePrefix: classNamePrefix
  };

  var useStyles = function useStyles() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var theme = (0,useTheme/* default */.Z)() || defaultTheme;

    var stylesOptions = (0,esm_extends/* default */.Z)({}, react.useContext(StylesProvider/* StylesContext */.NU), stylesOptions2);

    var instance = react.useRef();
    var shouldUpdate = react.useRef();
    useSynchronousEffect(function () {
      var current = {
        name: name,
        state: {},
        stylesCreator: stylesCreator,
        stylesOptions: stylesOptions,
        theme: theme
      };
      attach(current, props);
      shouldUpdate.current = false;
      instance.current = current;
      return function () {
        detach(current);
      };
    }, [theme, stylesCreator]);
    react.useEffect(function () {
      if (shouldUpdate.current) {
        update(instance.current, props);
      }

      shouldUpdate.current = true;
    });
    var classes = getClasses(instance.current, props.classes, Component);

    if (false) {}

    return classes;
  };

  return useStyles;
}

/***/ }),

/***/ 65835:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ mergeClasses; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87462);


function mergeClasses() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var baseClasses = options.baseClasses,
      newClasses = options.newClasses,
      Component = options.Component;

  if (!newClasses) {
    return baseClasses;
  }

  var nextClasses = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, baseClasses);

  if (false) {}

  Object.keys(newClasses).forEach(function (key) {
    if (false) {}

    if (newClasses[key]) {
      nextClasses[key] = "".concat(baseClasses[key], " ").concat(newClasses[key]);
    }
  });
  return nextClasses;
}

/***/ }),

/***/ 83800:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var ThemeContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext(null);

if (false) {}

/* harmony default export */ __webpack_exports__["Z"] = (ThemeContext);

/***/ }),

/***/ 159:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useTheme; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _ThemeContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83800);


function useTheme() {
  var theme = react__WEBPACK_IMPORTED_MODULE_0__.useContext(_ThemeContext__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);

  if (false) {}

  return theme;
}

/***/ }),

/***/ 38920:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45987);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8679);
/* harmony import */ var hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _makeStyles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11719);
/* harmony import */ var _getThemeProps__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(93869);
/* harmony import */ var _useTheme__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(159);








 // Link a style sheet with a component.
// It does not modify the component passed to it;
// instead, it returns a new component, with a `classes` property.

var withStyles = function withStyles(stylesOrCreator) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (Component) {
    var defaultTheme = options.defaultTheme,
        _options$withTheme = options.withTheme,
        withTheme = _options$withTheme === void 0 ? false : _options$withTheme,
        name = options.name,
        stylesOptions = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(options, ["defaultTheme", "withTheme", "name"]);

    if (false) {}

    var classNamePrefix = name;

    if (false) { var displayName; }

    var useStyles = (0,_makeStyles__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(stylesOrCreator, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
      defaultTheme: defaultTheme,
      Component: Component,
      name: name || Component.displayName,
      classNamePrefix: classNamePrefix
    }, stylesOptions));
    var WithStyles = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function WithStyles(props, ref) {
      var classesProp = props.classes,
          innerRef = props.innerRef,
          other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props, ["classes", "innerRef"]); // The wrapper receives only user supplied props, which could be a subset of
      // the actual props Component might receive due to merging with defaultProps.
      // So copying it here would give us the same result in the wrapper as well.


      var classes = useStyles((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, Component.defaultProps, props));
      var theme;
      var more = other;

      if (typeof name === 'string' || withTheme) {
        // name and withTheme are invariant in the outer scope
        // eslint-disable-next-line react-hooks/rules-of-hooks
        theme = (0,_useTheme__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)() || defaultTheme;

        if (name) {
          more = (0,_getThemeProps__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
            theme: theme,
            name: name,
            props: other
          });
        } // Provide the theme to the wrapped component.
        // So we don't have to use the `withTheme()` Higher-order Component.


        if (withTheme && !more.theme) {
          more.theme = theme;
        }
      }

      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        ref: innerRef || ref,
        classes: classes
      }, more));
    });
     false ? 0 : void 0;

    if (false) {}

    hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_1___default()(WithStyles, Component);

    if (false) {}

    return WithStyles;
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (withStyles);

/***/ }),

/***/ 71410:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ handleBreakpoints; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71002);




 // The breakpoint **start** at this value.
// For instance with the first breakpoint xs: [xs, sm[.

var values = {
  xs: 0,
  sm: 600,
  md: 960,
  lg: 1280,
  xl: 1920
};
var defaultBreakpoints = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ['xs', 'sm', 'md', 'lg', 'xl'],
  up: function up(key) {
    return "@media (min-width:".concat(values[key], "px)");
  }
};
function handleBreakpoints(props, propValue, styleFromPropValue) {
  if (false) {}

  if (Array.isArray(propValue)) {
    var themeBreakpoints = props.theme.breakpoints || defaultBreakpoints;
    return propValue.reduce(function (acc, item, index) {
      acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
      return acc;
    }, {});
  }

  if ((0,_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(propValue) === 'object') {
    var _themeBreakpoints = props.theme.breakpoints || defaultBreakpoints;

    return Object.keys(propValue).reduce(function (acc, breakpoint) {
      acc[_themeBreakpoints.up(breakpoint)] = styleFromPropValue(propValue[breakpoint]);
      return acc;
    }, {});
  }

  var output = styleFromPropValue(propValue);
  return output;
}

function breakpoints(styleFunction) {
  var newStyleFunction = function newStyleFunction(props) {
    var base = styleFunction(props);
    var themeBreakpoints = props.theme.breakpoints || defaultBreakpoints;
    var extended = themeBreakpoints.keys.reduce(function (acc, key) {
      if (props[key]) {
        acc = acc || {};
        acc[themeBreakpoints.up(key)] = styleFunction(_extends({
          theme: props.theme
        }, props[key]));
      }

      return acc;
    }, null);
    return merge(base, extended);
  };

  newStyleFunction.propTypes =  false ? 0 : {};
  newStyleFunction.filterProps = ['xs', 'sm', 'md', 'lg', 'xl'].concat(_toConsumableArray(styleFunction.filterProps));
  return newStyleFunction;
}

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (breakpoints)));

/***/ }),

/***/ 19668:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _material_ui_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35953);


function merge(acc, item) {
  if (!item) {
    return acc;
  }

  return (0,_material_ui_utils__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(acc, item, {
    clone: false // No need to clone deep, it's way faster.

  });
}

/* harmony default export */ __webpack_exports__["Z"] = (merge);

/***/ }),

/***/ 27122:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* binding */ createUnarySpacing; },
  "Z": function() { return /* binding */ esm_spacing; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(97685);
// EXTERNAL MODULE: ./node_modules/@material-ui/system/esm/breakpoints.js
var breakpoints = __webpack_require__(71410);
// EXTERNAL MODULE: ./node_modules/@material-ui/system/esm/merge.js
var merge = __webpack_require__(19668);
;// CONCATENATED MODULE: ./node_modules/@material-ui/system/esm/memoize.js
function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) {
      cache[arg] = fn(arg);
    }

    return cache[arg];
  };
}
;// CONCATENATED MODULE: ./node_modules/@material-ui/system/esm/spacing.js





var properties = {
  m: 'margin',
  p: 'padding'
};
var directions = {
  t: 'Top',
  r: 'Right',
  b: 'Bottom',
  l: 'Left',
  x: ['Left', 'Right'],
  y: ['Top', 'Bottom']
};
var aliases = {
  marginX: 'mx',
  marginY: 'my',
  paddingX: 'px',
  paddingY: 'py'
}; // memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec

var getCssProperties = memoize(function (prop) {
  // It's not a shorthand notation.
  if (prop.length > 2) {
    if (aliases[prop]) {
      prop = aliases[prop];
    } else {
      return [prop];
    }
  }

  var _prop$split = prop.split(''),
      _prop$split2 = (0,slicedToArray/* default */.Z)(_prop$split, 2),
      a = _prop$split2[0],
      b = _prop$split2[1];

  var property = properties[a];
  var direction = directions[b] || '';
  return Array.isArray(direction) ? direction.map(function (dir) {
    return property + dir;
  }) : [property + direction];
});
var spacingKeys = ['m', 'mt', 'mr', 'mb', 'ml', 'mx', 'my', 'p', 'pt', 'pr', 'pb', 'pl', 'px', 'py', 'margin', 'marginTop', 'marginRight', 'marginBottom', 'marginLeft', 'marginX', 'marginY', 'padding', 'paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft', 'paddingX', 'paddingY'];
function createUnarySpacing(theme) {
  var themeSpacing = theme.spacing || 8;

  if (typeof themeSpacing === 'number') {
    return function (abs) {
      if (false) {}

      return themeSpacing * abs;
    };
  }

  if (Array.isArray(themeSpacing)) {
    return function (abs) {
      if (false) {}

      return themeSpacing[abs];
    };
  }

  if (typeof themeSpacing === 'function') {
    return themeSpacing;
  }

  if (false) {}

  return function () {
    return undefined;
  };
}

function getValue(transformer, propValue) {
  if (typeof propValue === 'string' || propValue == null) {
    return propValue;
  }

  var abs = Math.abs(propValue);
  var transformed = transformer(abs);

  if (propValue >= 0) {
    return transformed;
  }

  if (typeof transformed === 'number') {
    return -transformed;
  }

  return "-".concat(transformed);
}

function getStyleFromPropValue(cssProperties, transformer) {
  return function (propValue) {
    return cssProperties.reduce(function (acc, cssProperty) {
      acc[cssProperty] = getValue(transformer, propValue);
      return acc;
    }, {});
  };
}

function spacing(props) {
  var theme = props.theme;
  var transformer = createUnarySpacing(theme);
  return Object.keys(props).map(function (prop) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (spacingKeys.indexOf(prop) === -1) {
      return null;
    }

    var cssProperties = getCssProperties(prop);
    var styleFromPropValue = getStyleFromPropValue(cssProperties, transformer);
    var propValue = props[prop];
    return (0,breakpoints/* handleBreakpoints */.k)(props, propValue, styleFromPropValue);
  }).reduce(merge/* default */.Z, {});
}

spacing.propTypes =  false ? 0 : {};
spacing.filterProps = spacingKeys;
/* harmony default export */ var esm_spacing = (spacing);

/***/ }),

/***/ 35953:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ deepmerge; }
/* harmony export */ });
/* unused harmony export isPlainObject */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71002);


function isPlainObject(item) {
  return item && (0,_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(item) === 'object' && item.constructor === Object;
}
function deepmerge(target, source) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    clone: true
  };
  var output = options.clone ? (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, target) : target;

  if (isPlainObject(target) && isPlainObject(source)) {
    Object.keys(source).forEach(function (key) {
      // Avoid prototype pollution
      if (key === '__proto__') {
        return;
      }

      if (isPlainObject(source[key]) && key in target) {
        output[key] = deepmerge(target[key], source[key], options);
      } else {
        output[key] = source[key];
      }
    });
  }

  return output;
}

/***/ }),

/***/ 60288:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ formatMuiErrorMessage; }
/* harmony export */ });
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@material-ui/utils/macros/MuiError.macro` instead.
 * @param {number} code
 */
function formatMuiErrorMessage(code) {
  // Apply babel-plugin-transform-template-literals in loose mode
  // loose mode is safe iff we're concatenating primitives
  // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose

  /* eslint-disable prefer-template */
  var url = 'https://mui.com/production-error/?code=' + code;

  for (var i = 1; i < arguments.length; i += 1) {
    // rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += '&args[]=' + encodeURIComponent(arguments[i]);
  }

  return 'Minified Material-UI error #' + code + '; visit ' + url + ' for the full message.';
  /* eslint-enable prefer-template */
}

/***/ }),

/***/ 79361:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({
    value: true
});
exports.Z = _defineProperty;
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}


/***/ }),

/***/ 16313:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* provided dependency */ var Buffer = __webpack_require__(21876)["Buffer"];
var clone = (function() {
'use strict';

function _instanceof(obj, type) {
  return type != null && obj instanceof type;
}

var nativeMap;
try {
  nativeMap = Map;
} catch(_) {
  // maybe a reference error because no `Map`. Give it a dummy value that no
  // value will ever be an instanceof.
  nativeMap = function() {};
}

var nativeSet;
try {
  nativeSet = Set;
} catch(_) {
  nativeSet = function() {};
}

var nativePromise;
try {
  nativePromise = Promise;
} catch(_) {
  nativePromise = function() {};
}

/**
 * Clones (copies) an Object using deep copying.
 *
 * This function supports circular references by default, but if you are certain
 * there are no circular references in your object, you can save some CPU time
 * by calling clone(obj, false).
 *
 * Caution: if `circular` is false and `parent` contains circular references,
 * your program may enter an infinite loop and crash.
 *
 * @param `parent` - the object to be cloned
 * @param `circular` - set to true if the object to be cloned may contain
 *    circular references. (optional - true by default)
 * @param `depth` - set to a number if the object is only to be cloned to
 *    a particular depth. (optional - defaults to Infinity)
 * @param `prototype` - sets the prototype to be used when cloning an object.
 *    (optional - defaults to parent prototype).
 * @param `includeNonEnumerable` - set to true if the non-enumerable properties
 *    should be cloned as well. Non-enumerable properties on the prototype
 *    chain will be ignored. (optional - false by default)
*/
function clone(parent, circular, depth, prototype, includeNonEnumerable) {
  if (typeof circular === 'object') {
    depth = circular.depth;
    prototype = circular.prototype;
    includeNonEnumerable = circular.includeNonEnumerable;
    circular = circular.circular;
  }
  // maintain two arrays for circular references, where corresponding parents
  // and children have the same index
  var allParents = [];
  var allChildren = [];

  var useBuffer = typeof Buffer != 'undefined';

  if (typeof circular == 'undefined')
    circular = true;

  if (typeof depth == 'undefined')
    depth = Infinity;

  // recurse this function so we don't reset allParents and allChildren
  function _clone(parent, depth) {
    // cloning null always returns null
    if (parent === null)
      return null;

    if (depth === 0)
      return parent;

    var child;
    var proto;
    if (typeof parent != 'object') {
      return parent;
    }

    if (_instanceof(parent, nativeMap)) {
      child = new nativeMap();
    } else if (_instanceof(parent, nativeSet)) {
      child = new nativeSet();
    } else if (_instanceof(parent, nativePromise)) {
      child = new nativePromise(function (resolve, reject) {
        parent.then(function(value) {
          resolve(_clone(value, depth - 1));
        }, function(err) {
          reject(_clone(err, depth - 1));
        });
      });
    } else if (clone.__isArray(parent)) {
      child = [];
    } else if (clone.__isRegExp(parent)) {
      child = new RegExp(parent.source, __getRegExpFlags(parent));
      if (parent.lastIndex) child.lastIndex = parent.lastIndex;
    } else if (clone.__isDate(parent)) {
      child = new Date(parent.getTime());
    } else if (useBuffer && Buffer.isBuffer(parent)) {
      if (Buffer.allocUnsafe) {
        // Node.js >= 4.5.0
        child = Buffer.allocUnsafe(parent.length);
      } else {
        // Older Node.js versions
        child = new Buffer(parent.length);
      }
      parent.copy(child);
      return child;
    } else if (_instanceof(parent, Error)) {
      child = Object.create(parent);
    } else {
      if (typeof prototype == 'undefined') {
        proto = Object.getPrototypeOf(parent);
        child = Object.create(proto);
      }
      else {
        child = Object.create(prototype);
        proto = prototype;
      }
    }

    if (circular) {
      var index = allParents.indexOf(parent);

      if (index != -1) {
        return allChildren[index];
      }
      allParents.push(parent);
      allChildren.push(child);
    }

    if (_instanceof(parent, nativeMap)) {
      parent.forEach(function(value, key) {
        var keyChild = _clone(key, depth - 1);
        var valueChild = _clone(value, depth - 1);
        child.set(keyChild, valueChild);
      });
    }
    if (_instanceof(parent, nativeSet)) {
      parent.forEach(function(value) {
        var entryChild = _clone(value, depth - 1);
        child.add(entryChild);
      });
    }

    for (var i in parent) {
      var attrs;
      if (proto) {
        attrs = Object.getOwnPropertyDescriptor(proto, i);
      }

      if (attrs && attrs.set == null) {
        continue;
      }
      child[i] = _clone(parent[i], depth - 1);
    }

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(parent);
      for (var i = 0; i < symbols.length; i++) {
        // Don't need to worry about cloning a symbol because it is a primitive,
        // like a number or string.
        var symbol = symbols[i];
        var descriptor = Object.getOwnPropertyDescriptor(parent, symbol);
        if (descriptor && !descriptor.enumerable && !includeNonEnumerable) {
          continue;
        }
        child[symbol] = _clone(parent[symbol], depth - 1);
        if (!descriptor.enumerable) {
          Object.defineProperty(child, symbol, {
            enumerable: false
          });
        }
      }
    }

    if (includeNonEnumerable) {
      var allPropertyNames = Object.getOwnPropertyNames(parent);
      for (var i = 0; i < allPropertyNames.length; i++) {
        var propertyName = allPropertyNames[i];
        var descriptor = Object.getOwnPropertyDescriptor(parent, propertyName);
        if (descriptor && descriptor.enumerable) {
          continue;
        }
        child[propertyName] = _clone(parent[propertyName], depth - 1);
        Object.defineProperty(child, propertyName, {
          enumerable: false
        });
      }
    }

    return child;
  }

  return _clone(parent, depth);
}

/**
 * Simple flat clone using prototype, accepts only objects, usefull for property
 * override on FLAT configuration object (no nested props).
 *
 * USE WITH CAUTION! This may not behave as you wish if you do not know how this
 * works.
 */
clone.clonePrototype = function clonePrototype(parent) {
  if (parent === null)
    return null;

  var c = function () {};
  c.prototype = parent;
  return new c();
};

// private utility functions

function __objToStr(o) {
  return Object.prototype.toString.call(o);
}
clone.__objToStr = __objToStr;

function __isDate(o) {
  return typeof o === 'object' && __objToStr(o) === '[object Date]';
}
clone.__isDate = __isDate;

function __isArray(o) {
  return typeof o === 'object' && __objToStr(o) === '[object Array]';
}
clone.__isArray = __isArray;

function __isRegExp(o) {
  return typeof o === 'object' && __objToStr(o) === '[object RegExp]';
}
clone.__isRegExp = __isRegExp;

function __getRegExpFlags(re) {
  var flags = '';
  if (re.global) flags += 'g';
  if (re.ignoreCase) flags += 'i';
  if (re.multiline) flags += 'm';
  return flags;
}
clone.__getRegExpFlags = __getRegExpFlags;

return clone;
})();

if ( true && module.exports) {
  module.exports = clone;
}


/***/ }),

/***/ 86010:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* export default binding */ __WEBPACK_DEFAULT_EXPORT__; }
/* harmony export */ });
function toVal(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__() {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal(tmp)) {
				str && (str += ' ');
				str += x
			}
		}
	}
	return str;
}


/***/ }),

/***/ 54098:
/***/ (function(module, exports, __webpack_require__) {

// Save global object in a variable
var __global__ =
(typeof globalThis !== 'undefined' && globalThis) ||
(typeof self !== 'undefined' && self) ||
(typeof __webpack_require__.g !== 'undefined' && __webpack_require__.g);
// Create an object that extends from __global__ without the fetch function
var __globalThis__ = (function () {
function F() {
this.fetch = false;
this.DOMException = __global__.DOMException
}
F.prototype = __global__; // Needed for feature detection on whatwg-fetch's code
return new F();
})();
// Wraps whatwg-fetch with a function scope to hijack the global object
// "globalThis" that's going to be patched
(function(globalThis) {

var irrelevant = (function (exports) {

  var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof self !== 'undefined' && self) ||
    (typeof global !== 'undefined' && global);

  var support = {
    searchParams: 'URLSearchParams' in global,
    iterable: 'Symbol' in global && 'iterator' in Symbol,
    blob:
      'FileReader' in global &&
      'Blob' in global &&
      (function() {
        try {
          new Blob();
          return true
        } catch (e) {
          return false
        }
      })(),
    formData: 'FormData' in global,
    arrayBuffer: 'ArrayBuffer' in global
  };

  function isDataView(obj) {
    return obj && DataView.prototype.isPrototypeOf(obj)
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ];

    var isArrayBufferView =
      ArrayBuffer.isView ||
      function(obj) {
        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
      };
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name);
    }
    if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === '') {
      throw new TypeError('Invalid character in header field name: "' + name + '"')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value);
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift();
        return {done: value === undefined, value: value}
      }
    };

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      };
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {};

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value);
      }, this);
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1]);
      }, this);
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name]);
      }, this);
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name);
    value = normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
  };

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)];
  };

  Headers.prototype.get = function(name) {
    name = normalizeName(name);
    return this.has(name) ? this.map[name] : null
  };

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  };

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value);
  };

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this);
      }
    }
  };

  Headers.prototype.keys = function() {
    var items = [];
    this.forEach(function(value, name) {
      items.push(name);
    });
    return iteratorFor(items)
  };

  Headers.prototype.values = function() {
    var items = [];
    this.forEach(function(value) {
      items.push(value);
    });
    return iteratorFor(items)
  };

  Headers.prototype.entries = function() {
    var items = [];
    this.forEach(function(value, name) {
      items.push([name, value]);
    });
    return iteratorFor(items)
  };

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true;
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result);
      };
      reader.onerror = function() {
        reject(reader.error);
      };
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsText(blob);
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i]);
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength);
      view.set(new Uint8Array(buf));
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false;

    this._initBody = function(body) {
      /*
        fetch-mock wraps the Response object in an ES6 Proxy to
        provide useful test harness features such as flush. However, on
        ES5 browsers without fetch or Proxy support pollyfills must be used;
        the proxy-pollyfill is unable to proxy an attribute unless it exists
        on the object before the Proxy is created. This change ensures
        Response.bodyUsed exists on the instance, while maintaining the
        semantic of setting Request.bodyUsed in the constructor before
        _initBody is called.
      */
      this.bodyUsed = this.bodyUsed;
      this._bodyInit = body;
      if (!body) {
        this._bodyText = '';
      } else if (typeof body === 'string') {
        this._bodyText = body;
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body;
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body;
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString();
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer);
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer]);
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body);
      } else {
        this._bodyText = body = Object.prototype.toString.call(body);
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8');
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type);
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
      }
    };

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this);
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      };

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          var isConsumed = consumed(this);
          if (isConsumed) {
            return isConsumed
          }
          if (ArrayBuffer.isView(this._bodyArrayBuffer)) {
            return Promise.resolve(
              this._bodyArrayBuffer.buffer.slice(
                this._bodyArrayBuffer.byteOffset,
                this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength
              )
            )
          } else {
            return Promise.resolve(this._bodyArrayBuffer)
          }
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      };
    }

    this.text = function() {
      var rejected = consumed(this);
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    };

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      };
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    };

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];

  function normalizeMethod(method) {
    var upcased = method.toUpperCase();
    return methods.indexOf(upcased) > -1 ? upcased : method
  }

  function Request(input, options) {
    if (!(this instanceof Request)) {
      throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.')
    }

    options = options || {};
    var body = options.body;

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url;
      this.credentials = input.credentials;
      if (!options.headers) {
        this.headers = new Headers(input.headers);
      }
      this.method = input.method;
      this.mode = input.mode;
      this.signal = input.signal;
      if (!body && input._bodyInit != null) {
        body = input._bodyInit;
        input.bodyUsed = true;
      }
    } else {
      this.url = String(input);
    }

    this.credentials = options.credentials || this.credentials || 'same-origin';
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers);
    }
    this.method = normalizeMethod(options.method || this.method || 'GET');
    this.mode = options.mode || this.mode || null;
    this.signal = options.signal || this.signal;
    this.referrer = null;

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body);

    if (this.method === 'GET' || this.method === 'HEAD') {
      if (options.cache === 'no-store' || options.cache === 'no-cache') {
        // Search for a '_' parameter in the query string
        var reParamSearch = /([?&])_=[^&]*/;
        if (reParamSearch.test(this.url)) {
          // If it already exists then set the value with the current time
          this.url = this.url.replace(reParamSearch, '$1_=' + new Date().getTime());
        } else {
          // Otherwise add a new '_' parameter to the end with the current time
          var reQueryString = /\?/;
          this.url += (reQueryString.test(this.url) ? '&' : '?') + '_=' + new Date().getTime();
        }
      }
    }
  }

  Request.prototype.clone = function() {
    return new Request(this, {body: this._bodyInit})
  };

  function decode(body) {
    var form = new FormData();
    body
      .trim()
      .split('&')
      .forEach(function(bytes) {
        if (bytes) {
          var split = bytes.split('=');
          var name = split.shift().replace(/\+/g, ' ');
          var value = split.join('=').replace(/\+/g, ' ');
          form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
      });
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    // Avoiding split via regex to work around a common IE11 bug with the core-js 3.6.0 regex polyfill
    // https://github.com/github/fetch/issues/748
    // https://github.com/zloirock/core-js/issues/751
    preProcessedHeaders
      .split('\r')
      .map(function(header) {
        return header.indexOf('\n') === 0 ? header.substr(1, header.length) : header
      })
      .forEach(function(line) {
        var parts = line.split(':');
        var key = parts.shift().trim();
        if (key) {
          var value = parts.join(':').trim();
          headers.append(key, value);
        }
      });
    return headers
  }

  Body.call(Request.prototype);

  function Response(bodyInit, options) {
    if (!(this instanceof Response)) {
      throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.')
    }
    if (!options) {
      options = {};
    }

    this.type = 'default';
    this.status = options.status === undefined ? 200 : options.status;
    this.ok = this.status >= 200 && this.status < 300;
    this.statusText = options.statusText === undefined ? '' : '' + options.statusText;
    this.headers = new Headers(options.headers);
    this.url = options.url || '';
    this._initBody(bodyInit);
  }

  Body.call(Response.prototype);

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  };

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''});
    response.type = 'error';
    return response
  };

  var redirectStatuses = [301, 302, 303, 307, 308];

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  };

  exports.DOMException = global.DOMException;
  try {
    new exports.DOMException();
  } catch (err) {
    exports.DOMException = function(message, name) {
      this.message = message;
      this.name = name;
      var error = Error(message);
      this.stack = error.stack;
    };
    exports.DOMException.prototype = Object.create(Error.prototype);
    exports.DOMException.prototype.constructor = exports.DOMException;
  }

  function fetch(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init);

      if (request.signal && request.signal.aborted) {
        return reject(new exports.DOMException('Aborted', 'AbortError'))
      }

      var xhr = new XMLHttpRequest();

      function abortXhr() {
        xhr.abort();
      }

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        };
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
        var body = 'response' in xhr ? xhr.response : xhr.responseText;
        setTimeout(function() {
          resolve(new Response(body, options));
        }, 0);
      };

      xhr.onerror = function() {
        setTimeout(function() {
          reject(new TypeError('Network request failed'));
        }, 0);
      };

      xhr.ontimeout = function() {
        setTimeout(function() {
          reject(new TypeError('Network request failed'));
        }, 0);
      };

      xhr.onabort = function() {
        setTimeout(function() {
          reject(new exports.DOMException('Aborted', 'AbortError'));
        }, 0);
      };

      function fixUrl(url) {
        try {
          return url === '' && global.location.href ? global.location.href : url
        } catch (e) {
          return url
        }
      }

      xhr.open(request.method, fixUrl(request.url), true);

      if (request.credentials === 'include') {
        xhr.withCredentials = true;
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false;
      }

      if ('responseType' in xhr) {
        if (support.blob) {
          xhr.responseType = 'blob';
        } else if (
          support.arrayBuffer &&
          request.headers.get('Content-Type') &&
          request.headers.get('Content-Type').indexOf('application/octet-stream') !== -1
        ) {
          xhr.responseType = 'arraybuffer';
        }
      }

      if (init && typeof init.headers === 'object' && !(init.headers instanceof Headers)) {
        Object.getOwnPropertyNames(init.headers).forEach(function(name) {
          xhr.setRequestHeader(name, normalizeValue(init.headers[name]));
        });
      } else {
        request.headers.forEach(function(value, name) {
          xhr.setRequestHeader(name, value);
        });
      }

      if (request.signal) {
        request.signal.addEventListener('abort', abortXhr);

        xhr.onreadystatechange = function() {
          // DONE (success or failure)
          if (xhr.readyState === 4) {
            request.signal.removeEventListener('abort', abortXhr);
          }
        };
      }

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    })
  }

  fetch.polyfill = true;

  if (!global.fetch) {
    global.fetch = fetch;
    global.Headers = Headers;
    global.Request = Request;
    global.Response = Response;
  }

  exports.Headers = Headers;
  exports.Request = Request;
  exports.Response = Response;
  exports.fetch = fetch;

  return exports;

})({});
})(__globalThis__);
// This is a ponyfill, so...
__globalThis__.fetch.ponyfill = true;
delete __globalThis__.fetch.polyfill;
// Choose between native implementation (__global__) or custom implementation (__globalThis__)
var ctx = __global__.fetch ? __global__ : __globalThis__;
exports = ctx.fetch // To enable: import fetch from 'cross-fetch'
exports["default"] = ctx.fetch // For TypeScript consumers without esModuleInterop.
exports.fetch = ctx.fetch // To enable: import {fetch} from 'cross-fetch'
exports.Headers = ctx.Headers
exports.Request = ctx.Request
exports.Response = ctx.Response
module.exports = exports


/***/ }),

/***/ 86559:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ defaultLocale; }
});

;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/formatDistance/index.js
var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },
  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },
  halfAMinute: 'half a minute',
  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },
  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },
  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },
  aboutXWeeks: {
    one: 'about 1 week',
    other: 'about {{count}} weeks'
  },
  xWeeks: {
    one: '1 week',
    other: '{{count}} weeks'
  },
  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },
  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },
  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },
  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },
  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },
  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};
var formatDistance = function formatDistance(token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale[token];
  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', count.toString());
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'in ' + result;
    } else {
      return result + ' ago';
    }
  }
  return result;
};
/* harmony default export */ var _lib_formatDistance = (formatDistance);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/_lib/buildFormatLongFn/index.js
function buildFormatLongFn(args) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // TODO: Remove String()
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/formatLong/index.js

var dateFormats = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};
var timeFormats = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};
/* harmony default export */ var _lib_formatLong = (formatLong);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/formatRelative/index.js
var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
};
/* harmony default export */ var _lib_formatRelative = (formatRelative);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/_lib/buildLocalizeFn/index.js
function buildLocalizeFn(args) {
  return function (dirtyIndex, options) {
    var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
    var valuesArray;
    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;
      var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }
    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
    // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
    return valuesArray[index];
  };
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/localize/index.js

var eraValues = {
  narrow: ['B', 'A'],
  abbreviated: ['BC', 'AD'],
  wide: ['Before Christ', 'Anno Domini']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter']
};

// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};
var dayValues = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};
var dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
  var number = Number(dirtyNumber);

  // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`.
  //
  // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'.

  var rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st';
      case 2:
        return number + 'nd';
      case 3:
        return number + 'rd';
    }
  }
  return number + 'th';
};
var localize = {
  ordinalNumber: ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
/* harmony default export */ var _lib_localize = (localize);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/_lib/buildMatchFn/index.js
function buildMatchFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);
    if (!matchResult) {
      return null;
    }
    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    }) : findKey(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    });
    var value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}
function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }
  return undefined;
}
function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }
  return undefined;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/_lib/buildMatchPatternFn/index.js
function buildMatchPatternFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/match/index.js


var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
/* harmony default export */ var _lib_match = (match);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-US/index.js





/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */
var locale = {
  code: 'en-US',
  formatDistance: _lib_formatDistance,
  formatLong: _lib_formatLong,
  formatRelative: _lib_formatRelative,
  localize: _lib_localize,
  match: _lib_match,
  options: {
    weekStartsOn: 0 /* Sunday */,
    firstWeekContainsDate: 1
  }
};
/* harmony default export */ var en_US = (locale);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/defaultLocale/index.js

/* harmony default export */ var defaultLocale = (en_US);

/***/ }),

/***/ 84314:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ getDefaultOptions; }
/* harmony export */ });
/* unused harmony export setDefaultOptions */
var defaultOptions = {};
function getDefaultOptions() {
  return defaultOptions;
}
function setDefaultOptions(newOptions) {
  defaultOptions = newOptions;
}

/***/ }),

/***/ 97621:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'P':
      return formatLong.date({
        width: 'short'
      });
    case 'PP':
      return formatLong.date({
        width: 'medium'
      });
    case 'PPP':
      return formatLong.date({
        width: 'long'
      });
    case 'PPPP':
    default:
      return formatLong.date({
        width: 'full'
      });
  }
};
var timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'p':
      return formatLong.time({
        width: 'short'
      });
    case 'pp':
      return formatLong.time({
        width: 'medium'
      });
    case 'ppp':
      return formatLong.time({
        width: 'long'
      });
    case 'pppp':
    default:
      return formatLong.time({
        width: 'full'
      });
  }
};
var dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
  var matchResult = pattern.match(/(P+)(p+)?/) || [];
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];
  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }
  var dateTimeFormat;
  switch (datePattern) {
    case 'P':
      dateTimeFormat = formatLong.dateTime({
        width: 'short'
      });
      break;
    case 'PP':
      dateTimeFormat = formatLong.dateTime({
        width: 'medium'
      });
      break;
    case 'PPP':
      dateTimeFormat = formatLong.dateTime({
        width: 'long'
      });
      break;
    case 'PPPP':
    default:
      dateTimeFormat = formatLong.dateTime({
        width: 'full'
      });
      break;
  }
  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
};
var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};
/* harmony default export */ __webpack_exports__["Z"] = (longFormatters);

/***/ }),

/***/ 24262:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getTimezoneOffsetInMilliseconds; }
/* harmony export */ });
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
function getTimezoneOffsetInMilliseconds(date) {
  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
  utcDate.setUTCFullYear(date.getFullYear());
  return date.getTime() - utcDate.getTime();
}

/***/ }),

/***/ 33276:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ getUTCISOWeek; }
});

// EXTERNAL MODULE: ./node_modules/date-fns/esm/toDate/index.js
var toDate = __webpack_require__(19013);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/startOfUTCISOWeek/index.js
var startOfUTCISOWeek = __webpack_require__(66979);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/getUTCISOWeekYear/index.js
var getUTCISOWeekYear = __webpack_require__(7032);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(13882);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/startOfUTCISOWeekYear/index.js



function startOfUTCISOWeekYear(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var year = (0,getUTCISOWeekYear/* default */.Z)(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = (0,startOfUTCISOWeek/* default */.Z)(fourthOfJanuary);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/getUTCISOWeek/index.js




var MILLISECONDS_IN_WEEK = 604800000;
function getUTCISOWeek(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var diff = (0,startOfUTCISOWeek/* default */.Z)(date).getTime() - startOfUTCISOWeekYear(date).getTime();

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

/***/ }),

/***/ 7032:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getUTCISOWeekYear; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);
/* harmony import */ var _startOfUTCISOWeek_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66979);



function getUTCISOWeekYear(dirtyDate) {
  (0,_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = (0,_startOfUTCISOWeek_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = (0,_startOfUTCISOWeek_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(fourthOfJanuaryOfThisYear);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

/***/ }),

/***/ 5230:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ getUTCWeek; }
});

// EXTERNAL MODULE: ./node_modules/date-fns/esm/toDate/index.js
var toDate = __webpack_require__(19013);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/startOfUTCWeek/index.js
var startOfUTCWeek = __webpack_require__(59025);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/getUTCWeekYear/index.js
var getUTCWeekYear = __webpack_require__(7651);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(13882);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/toInteger/index.js
var toInteger = __webpack_require__(83946);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/defaultOptions/index.js
var _lib_defaultOptions = __webpack_require__(84314);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/startOfUTCWeekYear/index.js





function startOfUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  (0,requiredArgs/* default */.Z)(1, arguments);
  var defaultOptions = (0,_lib_defaultOptions/* getDefaultOptions */.j)();
  var firstWeekContainsDate = (0,toInteger/* default */.Z)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
  var year = (0,getUTCWeekYear/* default */.Z)(dirtyDate, options);
  var firstWeek = new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = (0,startOfUTCWeek/* default */.Z)(firstWeek, options);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/getUTCWeek/index.js




var MILLISECONDS_IN_WEEK = 604800000;
function getUTCWeek(dirtyDate, options) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var diff = (0,startOfUTCWeek/* default */.Z)(date, options).getTime() - startOfUTCWeekYear(date, options).getTime();

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

/***/ }),

/***/ 7651:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getUTCWeekYear; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);
/* harmony import */ var _startOfUTCWeek_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59025);
/* harmony import */ var _toInteger_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83946);
/* harmony import */ var _defaultOptions_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84314);





function getUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  (0,_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate);
  var year = date.getUTCFullYear();
  var defaultOptions = (0,_defaultOptions_index_js__WEBPACK_IMPORTED_MODULE_2__/* .getDefaultOptions */ .j)();
  var firstWeekContainsDate = (0,_toInteger_index_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);

  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }
  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = (0,_startOfUTCWeek_index_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(firstWeekOfNextYear, options);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = (0,_startOfUTCWeek_index_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(firstWeekOfThisYear, options);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

/***/ }),

/***/ 5267:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Do": function() { return /* binding */ isProtectedWeekYearToken; },
/* harmony export */   "Iu": function() { return /* binding */ isProtectedDayOfYearToken; },
/* harmony export */   "qp": function() { return /* binding */ throwProtectedError; }
/* harmony export */ });
var protectedDayOfYearTokens = ['D', 'DD'];
var protectedWeekYearTokens = ['YY', 'YYYY'];
function isProtectedDayOfYearToken(token) {
  return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
  return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format, input) {
  if (token === 'YYYY') {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'YY') {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'D') {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'DD') {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  }
}

/***/ }),

/***/ 13882:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ requiredArgs; }
/* harmony export */ });
function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}

/***/ }),

/***/ 66979:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ startOfUTCISOWeek; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


function startOfUTCISOWeek(dirtyDate) {
  (0,_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var weekStartsOn = 1;
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

/***/ }),

/***/ 59025:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ startOfUTCWeek; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19013);
/* harmony import */ var _requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);
/* harmony import */ var _toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83946);
/* harmony import */ var _defaultOptions_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84314);




function startOfUTCWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  (0,_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var defaultOptions = (0,_defaultOptions_index_js__WEBPACK_IMPORTED_MODULE_1__/* .getDefaultOptions */ .j)();
  var weekStartsOn = (0,_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

/***/ }),

/***/ 83946:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ toInteger; }
/* harmony export */ });
function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }
  var number = Number(dirtyNumber);
  if (isNaN(number)) {
    return number;
  }
  return number < 0 ? Math.ceil(number) : Math.floor(number);
}

/***/ }),

/***/ 42298:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ format; }
});

// EXTERNAL MODULE: ./node_modules/date-fns/esm/isValid/index.js + 1 modules
var isValid = __webpack_require__(61436);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/subMilliseconds/index.js + 1 modules
var subMilliseconds = __webpack_require__(92234);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/toDate/index.js
var toDate = __webpack_require__(19013);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(13882);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/getUTCDayOfYear/index.js


var MILLISECONDS_IN_DAY = 86400000;
function getUTCDayOfYear(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/getUTCISOWeek/index.js + 1 modules
var getUTCISOWeek = __webpack_require__(33276);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/getUTCISOWeekYear/index.js
var getUTCISOWeekYear = __webpack_require__(7032);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/getUTCWeek/index.js + 1 modules
var getUTCWeek = __webpack_require__(5230);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/getUTCWeekYear/index.js
var getUTCWeekYear = __webpack_require__(7651);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/addLeadingZeros/index.js
function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();
  while (output.length < targetLength) {
    output = '0' + output;
  }
  return sign + output;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/format/lightFormatters/index.js

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */
var formatters = {
  // Year
  y: function y(date, token) {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |

    var signedYear = date.getUTCFullYear();
    // Returns 1 for 1 BC (which is year 0 in JavaScript)
    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token === 'yy' ? year % 100 : year, token.length);
  },
  // Month
  M: function M(date, token) {
    var month = date.getUTCMonth();
    return token === 'M' ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },
  // Day of the month
  d: function d(date, token) {
    return addLeadingZeros(date.getUTCDate(), token.length);
  },
  // AM or PM
  a: function a(date, token) {
    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
    switch (token) {
      case 'a':
      case 'aa':
        return dayPeriodEnumValue.toUpperCase();
      case 'aaa':
        return dayPeriodEnumValue;
      case 'aaaaa':
        return dayPeriodEnumValue[0];
      case 'aaaa':
      default:
        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
    }
  },
  // Hour [1-12]
  h: function h(date, token) {
    return addLeadingZeros(date.getUTCHours() % 12 || 12, token.length);
  },
  // Hour [0-23]
  H: function H(date, token) {
    return addLeadingZeros(date.getUTCHours(), token.length);
  },
  // Minute
  m: function m(date, token) {
    return addLeadingZeros(date.getUTCMinutes(), token.length);
  },
  // Second
  s: function s(date, token) {
    return addLeadingZeros(date.getUTCSeconds(), token.length);
  },
  // Fraction of second
  S: function S(date, token) {
    var numberOfDigits = token.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return addLeadingZeros(fractionalSeconds, token.length);
  }
};
/* harmony default export */ var lightFormatters = (formatters);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/format/formatters/index.js







var dayPeriodEnum = {
  am: 'am',
  pm: 'pm',
  midnight: 'midnight',
  noon: 'noon',
  morning: 'morning',
  afternoon: 'afternoon',
  evening: 'evening',
  night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */

var formatters_formatters = {
  // Era
  G: function G(date, token, localize) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;
    switch (token) {
      // AD, BC
      case 'G':
      case 'GG':
      case 'GGG':
        return localize.era(era, {
          width: 'abbreviated'
        });
      // A, B
      case 'GGGGG':
        return localize.era(era, {
          width: 'narrow'
        });
      // Anno Domini, Before Christ
      case 'GGGG':
      default:
        return localize.era(era, {
          width: 'wide'
        });
    }
  },
  // Year
  y: function y(date, token, localize) {
    // Ordinal number
    if (token === 'yo') {
      var signedYear = date.getUTCFullYear();
      // Returns 1 for 1 BC (which is year 0 in JavaScript)
      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, {
        unit: 'year'
      });
    }
    return lightFormatters.y(date, token);
  },
  // Local week-numbering year
  Y: function Y(date, token, localize, options) {
    var signedWeekYear = (0,getUTCWeekYear/* default */.Z)(date, options);
    // Returns 1 for 1 BC (which is year 0 in JavaScript)
    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;

    // Two digit year
    if (token === 'YY') {
      var twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    }

    // Ordinal number
    if (token === 'Yo') {
      return localize.ordinalNumber(weekYear, {
        unit: 'year'
      });
    }

    // Padding
    return addLeadingZeros(weekYear, token.length);
  },
  // ISO week-numbering year
  R: function R(date, token) {
    var isoWeekYear = (0,getUTCISOWeekYear/* default */.Z)(date);

    // Padding
    return addLeadingZeros(isoWeekYear, token.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function u(date, token) {
    var year = date.getUTCFullYear();
    return addLeadingZeros(year, token.length);
  },
  // Quarter
  Q: function Q(date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case 'Q':
        return String(quarter);
      // 01, 02, 03, 04
      case 'QQ':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case 'Qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4
      case 'QQQ':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case 'QQQQQ':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'formatting'
        });
      // 1st quarter, 2nd quarter, ...
      case 'QQQQ':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone quarter
  q: function q(date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case 'q':
        return String(quarter);
      // 01, 02, 03, 04
      case 'qq':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case 'qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4
      case 'qqq':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case 'qqqqq':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'standalone'
        });
      // 1st quarter, 2nd quarter, ...
      case 'qqqq':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Month
  M: function M(date, token, localize) {
    var month = date.getUTCMonth();
    switch (token) {
      case 'M':
      case 'MM':
        return lightFormatters.M(date, token);
      // 1st, 2nd, ..., 12th
      case 'Mo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec
      case 'MMM':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // J, F, ..., D
      case 'MMMMM':
        return localize.month(month, {
          width: 'narrow',
          context: 'formatting'
        });
      // January, February, ..., December
      case 'MMMM':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone month
  L: function L(date, token, localize) {
    var month = date.getUTCMonth();
    switch (token) {
      // 1, 2, ..., 12
      case 'L':
        return String(month + 1);
      // 01, 02, ..., 12
      case 'LL':
        return addLeadingZeros(month + 1, 2);
      // 1st, 2nd, ..., 12th
      case 'Lo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec
      case 'LLL':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // J, F, ..., D
      case 'LLLLL':
        return localize.month(month, {
          width: 'narrow',
          context: 'standalone'
        });
      // January, February, ..., December
      case 'LLLL':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Local week of year
  w: function w(date, token, localize, options) {
    var week = (0,getUTCWeek/* default */.Z)(date, options);
    if (token === 'wo') {
      return localize.ordinalNumber(week, {
        unit: 'week'
      });
    }
    return addLeadingZeros(week, token.length);
  },
  // ISO week of year
  I: function I(date, token, localize) {
    var isoWeek = (0,getUTCISOWeek/* default */.Z)(date);
    if (token === 'Io') {
      return localize.ordinalNumber(isoWeek, {
        unit: 'week'
      });
    }
    return addLeadingZeros(isoWeek, token.length);
  },
  // Day of the month
  d: function d(date, token, localize) {
    if (token === 'do') {
      return localize.ordinalNumber(date.getUTCDate(), {
        unit: 'date'
      });
    }
    return lightFormatters.d(date, token);
  },
  // Day of year
  D: function D(date, token, localize) {
    var dayOfYear = getUTCDayOfYear(date);
    if (token === 'Do') {
      return localize.ordinalNumber(dayOfYear, {
        unit: 'dayOfYear'
      });
    }
    return addLeadingZeros(dayOfYear, token.length);
  },
  // Day of week
  E: function E(date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    switch (token) {
      // Tue
      case 'E':
      case 'EE':
      case 'EEE':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T
      case 'EEEEE':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu
      case 'EEEEEE':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday
      case 'EEEE':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Local day of week
  e: function e(date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case 'e':
        return String(localDayOfWeek);
      // Padded numerical value
      case 'ee':
        return addLeadingZeros(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th
      case 'eo':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });
      case 'eee':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T
      case 'eeeee':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu
      case 'eeeeee':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday
      case 'eeee':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone local day of week
  c: function c(date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (same as in `e`)
      case 'c':
        return String(localDayOfWeek);
      // Padded numerical value
      case 'cc':
        return addLeadingZeros(localDayOfWeek, token.length);
      // 1st, 2nd, ..., 7th
      case 'co':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });
      case 'ccc':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // T
      case 'ccccc':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'standalone'
        });
      // Tu
      case 'cccccc':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'standalone'
        });
      // Tuesday
      case 'cccc':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // ISO day of week
  i: function i(date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
    switch (token) {
      // 2
      case 'i':
        return String(isoDayOfWeek);
      // 02
      case 'ii':
        return addLeadingZeros(isoDayOfWeek, token.length);
      // 2nd
      case 'io':
        return localize.ordinalNumber(isoDayOfWeek, {
          unit: 'day'
        });
      // Tue
      case 'iii':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T
      case 'iiiii':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu
      case 'iiiiii':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday
      case 'iiii':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM or PM
  a: function a(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    switch (token) {
      case 'a':
      case 'aa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'aaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();
      case 'aaaaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'aaaa':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM, PM, midnight, noon
  b: function b(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    }
    switch (token) {
      case 'b':
      case 'bb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'bbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();
      case 'bbbbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'bbbb':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function B(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }
    switch (token) {
      case 'B':
      case 'BB':
      case 'BBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'BBBBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'BBBB':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Hour [1-12]
  h: function h(date, token, localize) {
    if (token === 'ho') {
      var hours = date.getUTCHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return lightFormatters.h(date, token);
  },
  // Hour [0-23]
  H: function H(date, token, localize) {
    if (token === 'Ho') {
      return localize.ordinalNumber(date.getUTCHours(), {
        unit: 'hour'
      });
    }
    return lightFormatters.H(date, token);
  },
  // Hour [0-11]
  K: function K(date, token, localize) {
    var hours = date.getUTCHours() % 12;
    if (token === 'Ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return addLeadingZeros(hours, token.length);
  },
  // Hour [1-24]
  k: function k(date, token, localize) {
    var hours = date.getUTCHours();
    if (hours === 0) hours = 24;
    if (token === 'ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return addLeadingZeros(hours, token.length);
  },
  // Minute
  m: function m(date, token, localize) {
    if (token === 'mo') {
      return localize.ordinalNumber(date.getUTCMinutes(), {
        unit: 'minute'
      });
    }
    return lightFormatters.m(date, token);
  },
  // Second
  s: function s(date, token, localize) {
    if (token === 'so') {
      return localize.ordinalNumber(date.getUTCSeconds(), {
        unit: 'second'
      });
    }
    return lightFormatters.s(date, token);
  },
  // Fraction of second
  S: function S(date, token) {
    return lightFormatters.S(date, token);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function X(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    if (timezoneOffset === 0) {
      return 'Z';
    }
    switch (token) {
      // Hours and optional minutes
      case 'X':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);

      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case 'XXXX':
      case 'XX':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);

      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case 'XXXXX':
      case 'XXX': // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function x(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      // Hours and optional minutes
      case 'x':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);

      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case 'xxxx':
      case 'xx':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);

      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case 'xxxxx':
      case 'xxx': // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (GMT)
  O: function O(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      // Short
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long
      case 'OOOO':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (specific non-location)
  z: function z(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      // Short
      case 'z':
      case 'zz':
      case 'zzz':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long
      case 'zzzz':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Seconds timestamp
  t: function t(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1000);
    return addLeadingZeros(timestamp, token.length);
  },
  // Milliseconds timestamp
  T: function T(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return addLeadingZeros(timestamp, token.length);
  }
};
function formatTimezoneShort(offset, dirtyDelimiter) {
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;
  if (minutes === 0) {
    return sign + String(hours);
  }
  var delimiter = dirtyDelimiter || '';
  return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}
function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? '-' : '+';
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
  }
  return formatTimezone(offset, dirtyDelimiter);
}
function formatTimezone(offset, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
  var minutes = addLeadingZeros(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}
/* harmony default export */ var format_formatters = (formatters_formatters);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/format/longFormatters/index.js
var longFormatters = __webpack_require__(97621);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/getTimezoneOffsetInMilliseconds/index.js
var getTimezoneOffsetInMilliseconds = __webpack_require__(24262);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/protectedTokens/index.js
var protectedTokens = __webpack_require__(5267);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/toInteger/index.js
var toInteger = __webpack_require__(83946);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/defaultOptions/index.js
var _lib_defaultOptions = __webpack_require__(84314);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/defaultLocale/index.js + 10 modules
var defaultLocale = __webpack_require__(86559);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/format/index.js










 // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;

// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;

/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */

function format(dirtyDate, dirtyFormatStr, options) {
  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
  (0,requiredArgs/* default */.Z)(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var defaultOptions = (0,_lib_defaultOptions/* getDefaultOptions */.j)();
  var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : defaultLocale/* default */.Z;
  var firstWeekContainsDate = (0,toInteger/* default */.Z)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);

  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }
  var weekStartsOn = (0,toInteger/* default */.Z)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  if (!locale.localize) {
    throw new RangeError('locale must contain localize property');
  }
  if (!locale.formatLong) {
    throw new RangeError('locale must contain formatLong property');
  }
  var originalDate = (0,toDate/* default */.Z)(dirtyDate);
  if (!(0,isValid/* default */.Z)(originalDate)) {
    throw new RangeError('Invalid time value');
  }

  // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
  var timezoneOffset = (0,getTimezoneOffsetInMilliseconds/* default */.Z)(originalDate);
  var utcDate = (0,subMilliseconds/* default */.Z)(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];
    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = longFormatters/* default */.Z[firstCharacter];
      return longFormatter(substring, locale.formatLong);
    }
    return substring;
  }).join('').match(formattingTokensRegExp).map(function (substring) {
    // Replace two single quote characters with one single quote character
    if (substring === "''") {
      return "'";
    }
    var firstCharacter = substring[0];
    if (firstCharacter === "'") {
      return cleanEscapedString(substring);
    }
    var formatter = format_formatters[firstCharacter];
    if (formatter) {
      if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0,protectedTokens/* isProtectedWeekYearToken */.Do)(substring)) {
        (0,protectedTokens/* throwProtectedError */.qp)(substring, dirtyFormatStr, String(dirtyDate));
      }
      if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0,protectedTokens/* isProtectedDayOfYearToken */.Iu)(substring)) {
        (0,protectedTokens/* throwProtectedError */.qp)(substring, dirtyFormatStr, String(dirtyDate));
      }
      return formatter(utcDate, substring, locale.localize, formatterOptions);
    }
    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
    }
    return substring;
  }).join('');
  return result;
}
function cleanEscapedString(input) {
  var matched = input.match(escapedStringRegExp);
  if (!matched) {
    return input;
  }
  return matched[1].replace(doubleQuoteRegExp, "'");
}

/***/ }),

/***/ 61436:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ isValid; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(71002);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(13882);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/isDate/index.js


/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param {*} value - the value to check
 * @returns {boolean} true if the given value is a date
 * @throws {TypeError} 1 arguments required
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */
function isDate(value) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  return value instanceof Date || (0,esm_typeof/* default */.Z)(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/toDate/index.js
var toDate = __webpack_require__(19013);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/isValid/index.js



/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */
function isValid(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  if (!isDate(dirtyDate) && typeof dirtyDate !== 'number') {
    return false;
  }
  var date = (0,toDate/* default */.Z)(dirtyDate);
  return !isNaN(Number(date));
}

/***/ }),

/***/ 92234:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ subMilliseconds; }
});

// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/toInteger/index.js
var toInteger = __webpack_require__(83946);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/toDate/index.js
var toDate = __webpack_require__(19013);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(13882);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/addMilliseconds/index.js



/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */
function addMilliseconds(dirtyDate, dirtyAmount) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var timestamp = (0,toDate/* default */.Z)(dirtyDate).getTime();
  var amount = (0,toInteger/* default */.Z)(dirtyAmount);
  return new Date(timestamp + amount);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/subMilliseconds/index.js



/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */
function subMilliseconds(dirtyDate, dirtyAmount) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var amount = (0,toInteger/* default */.Z)(dirtyAmount);
  return addMilliseconds(dirtyDate, -amount);
}

/***/ }),

/***/ 19013:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ toDate; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71002);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */
function toDate(argument) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var argStr = Object.prototype.toString.call(argument);

  // Clone the date
  if (argument instanceof Date || (0,_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(argument) === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
      // eslint-disable-next-line no-console
      console.warn(new Error().stack);
    }
    return new Date(NaN);
  }
}

/***/ }),

/***/ 8679:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(21296);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),

/***/ 96103:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),

/***/ 21296:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(96103);
} else {}


/***/ }),

/***/ 81580:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Backend; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15671);
/* harmony import */ var _babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43144);



var arr = [];
var each = arr.forEach;
var slice = arr.slice;
function defaults(obj) {
  each.call(slice.call(arguments, 1), function (source) {
    if (source) {
      for (var prop in source) {
        if (obj[prop] === undefined) obj[prop] = source[prop];
      }
    }
  });
  return obj;
}
function createClassOnDemand(ClassOrObject) {
  if (!ClassOrObject) return null;
  if (typeof ClassOrObject === 'function') return new ClassOrObject();
  return ClassOrObject;
}

function getDefaults() {
  return {
    handleEmptyResourcesAsFailed: true,
    cacheHitMode: 'none'
    // reloadInterval: typeof window !== 'undefined' ? false : 60 * 60 * 1000
    // refreshExpirationTime: 60 * 60 * 1000
  };
}

function handleCorrectReadFunction(backend, language, namespace, resolver) {
  var fc = backend.read.bind(backend);
  if (fc.length === 2) {
    // no callback
    try {
      var r = fc(language, namespace);
      if (r && typeof r.then === 'function') {
        // promise
        r.then(function (data) {
          return resolver(null, data);
        })["catch"](resolver);
      } else {
        // sync
        resolver(null, r);
      }
    } catch (err) {
      resolver(err);
    }
    return;
  }

  // normal with callback
  fc(language, namespace, resolver);
}
var Backend = /*#__PURE__*/function () {
  function Backend(services) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var i18nextOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    (0,_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, Backend);
    this.backends = [];
    this.type = 'backend';
    this.allOptions = i18nextOptions;
    this.init(services, options);
  }
  (0,_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(Backend, [{
    key: "init",
    value: function init(services) {
      var _this = this;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var i18nextOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      this.services = services;
      this.options = defaults(options, this.options || {}, getDefaults());
      this.allOptions = i18nextOptions;
      this.options.backends && this.options.backends.forEach(function (b, i) {
        _this.backends[i] = _this.backends[i] || createClassOnDemand(b);
        _this.backends[i].init(services, _this.options.backendOptions && _this.options.backendOptions[i] || {}, i18nextOptions);
      });
      if (this.services && this.options.reloadInterval) {
        setInterval(function () {
          return _this.reload();
        }, this.options.reloadInterval);
      }
    }
  }, {
    key: "read",
    value: function read(language, namespace, callback) {
      var _this2 = this;
      var bLen = this.backends.length;
      var loadPosition = function loadPosition(pos) {
        if (pos >= bLen) return callback(new Error('non of the backend loaded data', true)); // failed pass retry flag
        var isLastBackend = pos === bLen - 1;
        var lengthCheckAmount = _this2.options.handleEmptyResourcesAsFailed && !isLastBackend ? 0 : -1;
        var backend = _this2.backends[pos];
        if (backend.read) {
          handleCorrectReadFunction(backend, language, namespace, function (err, data, savedAt) {
            if (!err && data && Object.keys(data).length > lengthCheckAmount) {
              callback(null, data, pos);
              savePosition(pos - 1, data); // save one in front
              if (backend.save && _this2.options.cacheHitMode && ['refresh', 'refreshAndUpdateStore'].indexOf(_this2.options.cacheHitMode) > -1) {
                if (savedAt && _this2.options.refreshExpirationTime && savedAt + _this2.options.refreshExpirationTime > Date.now()) return;
                var nextBackend = _this2.backends[pos + 1];
                if (nextBackend && nextBackend.read) {
                  handleCorrectReadFunction(nextBackend, language, namespace, function (err, data) {
                    if (err) return;
                    if (!data) return;
                    if (Object.keys(data).length <= lengthCheckAmount) return;
                    savePosition(pos, data);
                    if (_this2.options.cacheHitMode !== 'refreshAndUpdateStore') return;
                    if (_this2.services && _this2.services.resourceStore) {
                      _this2.services.resourceStore.addResourceBundle(language, namespace, data);
                    }
                  });
                }
              }
            } else {
              loadPosition(pos + 1); // try load from next
            }
          });
        } else {
          loadPosition(pos + 1); // try load from next
        }
      };

      var savePosition = function savePosition(pos, data) {
        if (pos < 0) return;
        var backend = _this2.backends[pos];
        if (backend.save) {
          backend.save(language, namespace, data);
          savePosition(pos - 1, data);
        } else {
          savePosition(pos - 1, data);
        }
      };
      loadPosition(0);
    }
  }, {
    key: "create",
    value: function create(languages, namespace, key, fallbackValue) {
      var clb = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function () {};
      var opts = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
      this.backends.forEach(function (b) {
        if (!b.create) return;
        var fc = b.create.bind(b);
        if (fc.length < 6) {
          // no callback
          try {
            var r;
            if (fc.length === 5) {
              // future callback-less api for i18next-locize-backend
              r = fc(languages, namespace, key, fallbackValue, opts);
            } else {
              r = fc(languages, namespace, key, fallbackValue);
            }
            if (r && typeof r.then === 'function') {
              // promise
              r.then(function (data) {
                return clb(null, data);
              })["catch"](clb);
            } else {
              // sync
              clb(null, r);
            }
          } catch (err) {
            clb(err);
          }
          return;
        }

        // normal with callback
        fc(languages, namespace, key, fallbackValue, clb /* unused callback */, opts);
      });
    }
  }, {
    key: "reload",
    value: function reload() {
      var _this3 = this;
      var _this$services = this.services,
        backendConnector = _this$services.backendConnector,
        languageUtils = _this$services.languageUtils,
        logger = _this$services.logger;
      var currentLanguage = backendConnector.language;
      if (currentLanguage && currentLanguage.toLowerCase() === 'cimode') return; // avoid loading resources for cimode

      var toLoad = [];
      var append = function append(lng) {
        var lngs = languageUtils.toResolveHierarchy(lng);
        lngs.forEach(function (l) {
          if (toLoad.indexOf(l) < 0) toLoad.push(l);
        });
      };
      append(currentLanguage);
      if (this.allOptions.preload) this.allOptions.preload.forEach(function (l) {
        return append(l);
      });
      toLoad.forEach(function (lng) {
        _this3.allOptions.ns.forEach(function (ns) {
          backendConnector.read(lng, ns, 'read', null, null, function (err, data) {
            if (err) logger.warn("loading namespace ".concat(ns, " for language ").concat(lng, " failed"), err);
            if (!err && data) logger.log("loaded namespace ".concat(ns, " for language ").concat(lng), data);
            backendConnector.loaded("".concat(lng, "|").concat(ns), err, data);
          });
        });
      });
    }
  }]);
  return Backend;
}();
Backend.type = 'backend';




/***/ }),

/***/ 70660:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Cache; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71002);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4942);
/* harmony import */ var _babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15671);
/* harmony import */ var _babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43144);






function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-classes-per-file */
var Storage = /*#__PURE__*/function () {
  function Storage(options) {
    (0,_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, Storage);
    this.store = options.store;
  }
  return (0,_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(Storage, [{
    key: "setItem",
    value: function setItem(key, value) {
      if (this.store) {
        try {
          this.store.setItem(key, value);
        } catch (e) {
          // f.log('failed to set value for key "' + key + '" to localStorage.');
        }
      }
    }
  }, {
    key: "getItem",
    value: function getItem(key, value) {
      if (this.store) {
        try {
          return this.store.getItem(key, value);
        } catch (e) {
          // f.log('failed to get value for key "' + key + '" from localStorage.');
        }
      }
      return undefined;
    }
  }]);
}();
function getDefaults() {
  var store = null;
  try {
    store = window.localStorage;
  } catch (e) {
    if (typeof window !== 'undefined') {
      console.log('Failed to load local storage.', e);
    }
  }
  return {
    prefix: 'i18next_res_',
    expirationTime: 7 * 24 * 60 * 60 * 1000,
    defaultVersion: undefined,
    getVersion: undefined,
    versions: {},
    store: store
  };
}
var Cache = /*#__PURE__*/function () {
  function Cache(services) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    (0,_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, Cache);
    this.init(services, options);
    this.type = 'backend';
  }
  return (0,_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(Cache, [{
    key: "init",
    value: function init(services) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.services = services;
      this.options = _objectSpread(_objectSpread(_objectSpread({}, getDefaults()), this.options), options);
      this.storage = new Storage(this.options);
    }
  }, {
    key: "read",
    value: function read(language, namespace, callback) {
      var nowMS = Date.now();
      if (!this.storage.store) {
        return callback(null, null);
      }
      var local = this.storage.getItem("".concat(this.options.prefix).concat(language, "-").concat(namespace));
      if (local) {
        try {
          local = JSON.parse(local);
        } catch (e) {
          // A corrupted or foreign value under our key must not take the whole
          // translation load down with it. Treat it as a cache miss; the next
          // successful load overwrites the entry via save().
          local = null;
        }
      }

      // JSON.parse can legitimately yield null or a primitive ('null', '5', '"x"')
      if (local && (0,_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(local) === 'object') {
        var version = this.getVersion(language, namespace);
        if (
        // expiration field is mandatory, and should not be expired
        local.i18nStamp && local.i18nStamp + this.options.expirationTime > nowMS &&
        // there should be no language version set, or if it is, it should match the one in translation
        version === local.i18nVersion) {
          var i18nStamp = local.i18nStamp;
          delete local.i18nVersion;
          delete local.i18nStamp;
          return callback(null, local, i18nStamp);
        }
      }
      return callback(null, null);
    }
  }, {
    key: "save",
    value: function save(language, namespace, data) {
      if (this.storage.store) {
        // Copy rather than mutate: with i18next-chained-backend the very same
        // object is already live in i18next's resourceStore by the time save()
        // runs, so i18nStamp / i18nVersion would show up as translation keys.
        var payload = _objectSpread(_objectSpread({}, data), {}, {
          i18nStamp: Date.now()
        });

        // language version (if set)
        var version = this.getVersion(language, namespace);
        if (version) {
          payload.i18nVersion = version;
        }

        // save
        this.storage.setItem("".concat(this.options.prefix).concat(language, "-").concat(namespace), JSON.stringify(payload));
      }
    }
  }, {
    key: "getVersion",
    value: function getVersion(language, namespace) {
      var _getVersion;
      var _this$options = this.options,
        getVersion = _this$options.getVersion,
        versions = _this$options.versions,
        defaultVersion = _this$options.defaultVersion;
      // own-property lookup only: a language such as `__proto__` or `toString`
      // would otherwise inherit a truthy value from Object.prototype and
      // silently defeat the version check on every read
      var version = Object.prototype.hasOwnProperty.call(versions, language) ? versions[language] : undefined;
      return ((_getVersion = getVersion) === null || _getVersion === void 0 ? void 0 : _getVersion(language, namespace)) || version || defaultVersion;
    }
  }]);
}();
Cache.type = 'backend';
// i18next >= 26.7 calls read and create with a callback (and create with the options too) instead of
// guessing that from the number of parameters
Cache.callbackApi = true;




/***/ }),

/***/ 33827:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isBrowser */
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var isBrowser = (typeof window === "undefined" ? "undefined" : _typeof(window)) === "object" && (typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && document.nodeType === 9;

/* harmony default export */ __webpack_exports__["Z"] = (isBrowser);


/***/ }),

/***/ 36808:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader;
	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
		__WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		registeredInModuleLoader = true;
	}
	if (true) {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function decode (s) {
		return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
	}

	function init (converter) {
		function api() {}

		function set (key, value, attributes) {
			if (typeof document === 'undefined') {
				return;
			}

			attributes = extend({
				path: '/'
			}, api.defaults, attributes);

			if (typeof attributes.expires === 'number') {
				attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
			}

			// We're using "expires" because "max-age" is not supported by IE
			attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

			try {
				var result = JSON.stringify(value);
				if (/^[\{\[]/.test(result)) {
					value = result;
				}
			} catch (e) {}

			value = converter.write ?
				converter.write(value, key) :
				encodeURIComponent(String(value))
					.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);

			key = encodeURIComponent(String(key))
				.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
				.replace(/[\(\)]/g, escape);

			var stringifiedAttributes = '';
			for (var attributeName in attributes) {
				if (!attributes[attributeName]) {
					continue;
				}
				stringifiedAttributes += '; ' + attributeName;
				if (attributes[attributeName] === true) {
					continue;
				}

				// Considers RFC 6265 section 5.2:
				// ...
				// 3.  If the remaining unparsed-attributes contains a %x3B (";")
				//     character:
				// Consume the characters of the unparsed-attributes up to,
				// not including, the first %x3B (";") character.
				// ...
				stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
			}

			return (document.cookie = key + '=' + value + stringifiedAttributes);
		}

		function get (key, json) {
			if (typeof document === 'undefined') {
				return;
			}

			var jar = {};
			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all.
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = decode(parts[0]);
					cookie = (converter.read || converter)(cookie, name) ||
						decode(cookie);

					if (json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					jar[name] = cookie;

					if (key === name) {
						break;
					}
				} catch (e) {}
			}

			return key ? jar[key] : jar;
		}

		api.set = set;
		api.get = function (key) {
			return get(key, false /* read as raw */);
		};
		api.getJSON = function (key) {
			return get(key, true /* read as json */);
		};
		api.remove = function (key, attributes) {
			set(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.defaults = {};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));


/***/ }),

/***/ 16345:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ jss_plugin_camel_case_esm; }
});

;// CONCATENATED MODULE: ./node_modules/hyphenate-style-name/index.js
/* eslint-disable no-var, prefer-template */
var uppercasePattern = /[A-Z]/g
var msPattern = /^ms-/
var cache = {}

function toHyphenLower(match) {
  return '-' + match.toLowerCase()
}

function hyphenateStyleName(name) {
  if (cache.hasOwnProperty(name)) {
    return cache[name]
  }

  var hName = name.replace(uppercasePattern, toHyphenLower)
  return (cache[name] = msPattern.test(hName) ? '-' + hName : hName)
}

/* harmony default export */ var hyphenate_style_name = (hyphenateStyleName);

;// CONCATENATED MODULE: ./node_modules/jss-plugin-camel-case/dist/jss-plugin-camel-case.esm.js


/**
 * Convert camel cased property names to dash separated.
 */

function convertCase(style) {
  var converted = {};

  for (var prop in style) {
    var key = prop.indexOf('--') === 0 ? prop : hyphenate_style_name(prop);
    converted[key] = style[prop];
  }

  if (style.fallbacks) {
    if (Array.isArray(style.fallbacks)) converted.fallbacks = style.fallbacks.map(convertCase);else converted.fallbacks = convertCase(style.fallbacks);
  }

  return converted;
}
/**
 * Allow camel cased property names by converting them back to dasherized.
 */


function camelCase() {
  function onProcessStyle(style) {
    if (Array.isArray(style)) {
      // Handle rules like @font-face, which can have multiple styles in an array
      for (var index = 0; index < style.length; index++) {
        style[index] = convertCase(style[index]);
      }

      return style;
    }

    return convertCase(style);
  }

  function onChangeValue(value, prop, rule) {
    if (prop.indexOf('--') === 0) {
      return value;
    }

    var hyphenatedProp = hyphenate_style_name(prop); // There was no camel case in place

    if (prop === hyphenatedProp) return value;
    rule.prop(hyphenatedProp, value); // Core will ignore that property value we set the proper one above.

    return null;
  }

  return {
    onProcessStyle: onProcessStyle,
    onChangeValue: onChangeValue
  };
}

/* harmony default export */ var jss_plugin_camel_case_esm = (camelCase);


/***/ }),

/***/ 83961:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var jss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54013);


var px = jss__WEBPACK_IMPORTED_MODULE_0__/* .hasCSSTOMSupport */ .HZ && CSS ? CSS.px : 'px';
var ms = jss__WEBPACK_IMPORTED_MODULE_0__/* .hasCSSTOMSupport */ .HZ && CSS ? CSS.ms : 'ms';
var percent = jss__WEBPACK_IMPORTED_MODULE_0__/* .hasCSSTOMSupport */ .HZ && CSS ? CSS.percent : '%';
/**
 * Generated jss-plugin-default-unit CSS property units
 */

var defaultUnits = {
  // Animation properties
  'animation-delay': ms,
  'animation-duration': ms,
  // Background properties
  'background-position': px,
  'background-position-x': px,
  'background-position-y': px,
  'background-size': px,
  // Border Properties
  border: px,
  'border-bottom': px,
  'border-bottom-left-radius': px,
  'border-bottom-right-radius': px,
  'border-bottom-width': px,
  'border-left': px,
  'border-left-width': px,
  'border-radius': px,
  'border-right': px,
  'border-right-width': px,
  'border-top': px,
  'border-top-left-radius': px,
  'border-top-right-radius': px,
  'border-top-width': px,
  'border-width': px,
  'border-block': px,
  'border-block-end': px,
  'border-block-end-width': px,
  'border-block-start': px,
  'border-block-start-width': px,
  'border-block-width': px,
  'border-inline': px,
  'border-inline-end': px,
  'border-inline-end-width': px,
  'border-inline-start': px,
  'border-inline-start-width': px,
  'border-inline-width': px,
  'border-start-start-radius': px,
  'border-start-end-radius': px,
  'border-end-start-radius': px,
  'border-end-end-radius': px,
  // Margin properties
  margin: px,
  'margin-bottom': px,
  'margin-left': px,
  'margin-right': px,
  'margin-top': px,
  'margin-block': px,
  'margin-block-end': px,
  'margin-block-start': px,
  'margin-inline': px,
  'margin-inline-end': px,
  'margin-inline-start': px,
  // Padding properties
  padding: px,
  'padding-bottom': px,
  'padding-left': px,
  'padding-right': px,
  'padding-top': px,
  'padding-block': px,
  'padding-block-end': px,
  'padding-block-start': px,
  'padding-inline': px,
  'padding-inline-end': px,
  'padding-inline-start': px,
  // Mask properties
  'mask-position-x': px,
  'mask-position-y': px,
  'mask-size': px,
  // Width and height properties
  height: px,
  width: px,
  'min-height': px,
  'max-height': px,
  'min-width': px,
  'max-width': px,
  // Position properties
  bottom: px,
  left: px,
  top: px,
  right: px,
  inset: px,
  'inset-block': px,
  'inset-block-end': px,
  'inset-block-start': px,
  'inset-inline': px,
  'inset-inline-end': px,
  'inset-inline-start': px,
  // Shadow properties
  'box-shadow': px,
  'text-shadow': px,
  // Column properties
  'column-gap': px,
  'column-rule': px,
  'column-rule-width': px,
  'column-width': px,
  // Font and text properties
  'font-size': px,
  'font-size-delta': px,
  'letter-spacing': px,
  'text-decoration-thickness': px,
  'text-indent': px,
  'text-stroke': px,
  'text-stroke-width': px,
  'word-spacing': px,
  // Motion properties
  motion: px,
  'motion-offset': px,
  // Outline properties
  outline: px,
  'outline-offset': px,
  'outline-width': px,
  // Perspective properties
  perspective: px,
  'perspective-origin-x': percent,
  'perspective-origin-y': percent,
  // Transform properties
  'transform-origin': percent,
  'transform-origin-x': percent,
  'transform-origin-y': percent,
  'transform-origin-z': percent,
  // Transition properties
  'transition-delay': ms,
  'transition-duration': ms,
  // Alignment properties
  'vertical-align': px,
  'flex-basis': px,
  // Some random properties
  'shape-margin': px,
  size: px,
  gap: px,
  // Grid properties
  grid: px,
  'grid-gap': px,
  'row-gap': px,
  'grid-row-gap': px,
  'grid-column-gap': px,
  'grid-template-rows': px,
  'grid-template-columns': px,
  'grid-auto-rows': px,
  'grid-auto-columns': px,
  // Not existing properties.
  // Used to avoid issues with jss-plugin-expand integration.
  'box-shadow-x': px,
  'box-shadow-y': px,
  'box-shadow-blur': px,
  'box-shadow-spread': px,
  'font-line-height': px,
  'text-shadow-x': px,
  'text-shadow-y': px,
  'text-shadow-blur': px
};

/**
 * Clones the object and adds a camel cased property version.
 */

function addCamelCasedVersion(obj) {
  var regExp = /(-[a-z])/g;

  var replace = function replace(str) {
    return str[1].toUpperCase();
  };

  var newObj = {};

  for (var key in obj) {
    newObj[key] = obj[key];
    newObj[key.replace(regExp, replace)] = obj[key];
  }

  return newObj;
}

var units = addCamelCasedVersion(defaultUnits);
/**
 * Recursive deep style passing function
 */

function iterate(prop, value, options) {
  if (value == null) return value;

  if (Array.isArray(value)) {
    for (var i = 0; i < value.length; i++) {
      value[i] = iterate(prop, value[i], options);
    }
  } else if (typeof value === 'object') {
    if (prop === 'fallbacks') {
      for (var innerProp in value) {
        value[innerProp] = iterate(innerProp, value[innerProp], options);
      }
    } else {
      for (var _innerProp in value) {
        value[_innerProp] = iterate(prop + "-" + _innerProp, value[_innerProp], options);
      }
    } // eslint-disable-next-line no-restricted-globals

  } else if (typeof value === 'number' && isNaN(value) === false) {
    var unit = options[prop] || units[prop]; // Add the unit if available, except for the special case of 0px.

    if (unit && !(value === 0 && unit === px)) {
      return typeof unit === 'function' ? unit(value).toString() : "" + value + unit;
    }

    return value.toString();
  }

  return value;
}
/**
 * Add unit to numeric values.
 */


function defaultUnit(options) {
  if (options === void 0) {
    options = {};
  }

  var camelCasedOptions = addCamelCasedVersion(options);

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;

    for (var prop in style) {
      style[prop] = iterate(prop, style[prop], camelCasedOptions);
    }

    return style;
  }

  function onChangeValue(value, prop) {
    return iterate(prop, value, camelCasedOptions);
  }

  return {
    onProcessStyle: onProcessStyle,
    onChangeValue: onChangeValue
  };
}

/* harmony default export */ __webpack_exports__["Z"] = (defaultUnit);


/***/ }),

/***/ 5019:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87462);
/* harmony import */ var jss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54013);



var at = '@global';
var atPrefix = '@global ';

var GlobalContainerRule =
/*#__PURE__*/
function () {
  function GlobalContainerRule(key, styles, options) {
    this.type = 'global';
    this.at = at;
    this.isProcessed = false;
    this.key = key;
    this.options = options;
    this.rules = new jss__WEBPACK_IMPORTED_MODULE_0__/* .RuleList */ .RB((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, options, {
      parent: this
    }));

    for (var selector in styles) {
      this.rules.add(selector, styles[selector]);
    }

    this.rules.process();
  }
  /**
   * Get a rule.
   */


  var _proto = GlobalContainerRule.prototype;

  _proto.getRule = function getRule(name) {
    return this.rules.get(name);
  }
  /**
   * Create and register rule, run plugins.
   */
  ;

  _proto.addRule = function addRule(name, style, options) {
    var rule = this.rules.add(name, style, options);
    if (rule) this.options.jss.plugins.onProcessRule(rule);
    return rule;
  }
  /**
   * Replace rule, run plugins.
   */
  ;

  _proto.replaceRule = function replaceRule(name, style, options) {
    var newRule = this.rules.replace(name, style, options);
    if (newRule) this.options.jss.plugins.onProcessRule(newRule);
    return newRule;
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.rules.indexOf(rule);
  }
  /**
   * Generates a CSS string.
   */
  ;

  _proto.toString = function toString(options) {
    return this.rules.toString(options);
  };

  return GlobalContainerRule;
}();

var GlobalPrefixedRule =
/*#__PURE__*/
function () {
  function GlobalPrefixedRule(key, style, options) {
    this.type = 'global';
    this.at = at;
    this.isProcessed = false;
    this.key = key;
    this.options = options;
    var selector = key.substr(atPrefix.length);
    this.rule = options.jss.createRule(selector, style, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, options, {
      parent: this
    }));
  }

  var _proto2 = GlobalPrefixedRule.prototype;

  _proto2.toString = function toString(options) {
    return this.rule ? this.rule.toString(options) : '';
  };

  return GlobalPrefixedRule;
}();

var separatorRegExp = /\s*,\s*/g;

function addScope(selector, scope) {
  var parts = selector.split(separatorRegExp);
  var scoped = '';

  for (var i = 0; i < parts.length; i++) {
    scoped += scope + " " + parts[i].trim();
    if (parts[i + 1]) scoped += ', ';
  }

  return scoped;
}

function handleNestedGlobalContainerRule(rule, sheet) {
  var options = rule.options,
      style = rule.style;
  var rules = style ? style[at] : null;
  if (!rules) return;

  for (var name in rules) {
    sheet.addRule(name, rules[name], (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, options, {
      selector: addScope(name, rule.selector)
    }));
  }

  delete style[at];
}

function handlePrefixedGlobalRule(rule, sheet) {
  var options = rule.options,
      style = rule.style;

  for (var prop in style) {
    if (prop[0] !== '@' || prop.substr(0, at.length) !== at) continue;
    var selector = addScope(prop.substr(at.length), rule.selector);
    sheet.addRule(selector, style[prop], (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, options, {
      selector: selector
    }));
    delete style[prop];
  }
}
/**
 * Convert nested rules to separate, remove them from original styles.
 */


function jssGlobal() {
  function onCreateRule(name, styles, options) {
    if (!name) return null;

    if (name === at) {
      return new GlobalContainerRule(name, styles, options);
    }

    if (name[0] === '@' && name.substr(0, atPrefix.length) === atPrefix) {
      return new GlobalPrefixedRule(name, styles, options);
    }

    var parent = options.parent;

    if (parent) {
      if (parent.type === 'global' || parent.options.parent && parent.options.parent.type === 'global') {
        options.scoped = false;
      }
    }

    if (!options.selector && options.scoped === false) {
      options.selector = name;
    }

    return null;
  }

  function onProcessRule(rule, sheet) {
    if (rule.type !== 'style' || !sheet) return;
    handleNestedGlobalContainerRule(rule, sheet);
    handlePrefixedGlobalRule(rule, sheet);
  }

  return {
    onCreateRule: onCreateRule,
    onProcessRule: onProcessRule
  };
}

/* harmony default export */ __webpack_exports__["Z"] = (jssGlobal);


/***/ }),

/***/ 63057:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87462);



var separatorRegExp = /\s*,\s*/g;
var parentRegExp = /&/g;
var refRegExp = /\$([\w-]+)/g;
/**
 * Convert nested rules to separate, remove them from original styles.
 */

function jssNested() {
  // Get a function to be used for $ref replacement.
  function getReplaceRef(container, sheet) {
    return function (match, key) {
      var rule = container.getRule(key) || sheet && sheet.getRule(key);

      if (rule) {
        return rule.selector;
      }

       false ? 0 : void 0;
      return key;
    };
  }

  function replaceParentRefs(nestedProp, parentProp) {
    var parentSelectors = parentProp.split(separatorRegExp);
    var nestedSelectors = nestedProp.split(separatorRegExp);
    var result = '';

    for (var i = 0; i < parentSelectors.length; i++) {
      var parent = parentSelectors[i];

      for (var j = 0; j < nestedSelectors.length; j++) {
        var nested = nestedSelectors[j];
        if (result) result += ', '; // Replace all & by the parent or prefix & with the parent.

        result += nested.indexOf('&') !== -1 ? nested.replace(parentRegExp, parent) : parent + " " + nested;
      }
    }

    return result;
  }

  function getOptions(rule, container, prevOptions) {
    // Options has been already created, now we only increase index.
    if (prevOptions) return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, prevOptions, {
      index: prevOptions.index + 1
    });
    var nestingLevel = rule.options.nestingLevel;
    nestingLevel = nestingLevel === undefined ? 1 : nestingLevel + 1;

    var options = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, rule.options, {
      nestingLevel: nestingLevel,
      index: container.indexOf(rule) + 1 // We don't need the parent name to be set options for chlid.

    });

    delete options.name;
    return options;
  }

  function onProcessStyle(style, rule, sheet) {
    if (rule.type !== 'style') return style;
    var styleRule = rule;
    var container = styleRule.options.parent;
    var options;
    var replaceRef;

    for (var prop in style) {
      var isNested = prop.indexOf('&') !== -1;
      var isNestedConditional = prop[0] === '@';
      if (!isNested && !isNestedConditional) continue;
      options = getOptions(styleRule, container, options);

      if (isNested) {
        var selector = replaceParentRefs(prop, styleRule.selector); // Lazily create the ref replacer function just once for
        // all nested rules within the sheet.

        if (!replaceRef) replaceRef = getReplaceRef(container, sheet); // Replace all $refs.

        selector = selector.replace(refRegExp, replaceRef);
        var name = styleRule.key + "-" + prop;

        if ('replaceRule' in container) {
          // for backward compatibility
          container.replaceRule(name, style[prop], (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, options, {
            selector: selector
          }));
        } else {
          container.addRule(name, style[prop], (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, options, {
            selector: selector
          }));
        }
      } else if (isNestedConditional) {
        // Place conditional right after the parent rule to ensure right ordering.
        container.addRule(prop, {}, options).addRule(styleRule.key, style[prop], {
          selector: styleRule.selector
        });
      }

      delete style[prop];
    }

    return style;
  }

  return {
    onProcessStyle: onProcessStyle
  };
}

/* harmony default export */ __webpack_exports__["Z"] = (jssNested);


/***/ }),

/***/ 26895:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/**
 * Sort props by length.
 */
function jssPropsSort() {
  var sort = function sort(prop0, prop1) {
    if (prop0.length === prop1.length) {
      return prop0 > prop1 ? 1 : -1;
    }

    return prop0.length - prop1.length;
  };

  return {
    onProcessStyle: function onProcessStyle(style, rule) {
      if (rule.type !== 'style') return style;
      var newStyle = {};
      var props = Object.keys(style).sort(sort);

      for (var i = 0; i < props.length; i++) {
        newStyle[props[i]] = style[props[i]];
      }

      return newStyle;
    }
  };
}

/* harmony default export */ __webpack_exports__["Z"] = (jssPropsSort);


/***/ }),

/***/ 27202:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var jss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54013);



var now = Date.now();
var fnValuesNs = "fnValues" + now;
var fnRuleNs = "fnStyle" + ++now;

var functionPlugin = function functionPlugin() {
  return {
    onCreateRule: function onCreateRule(name, decl, options) {
      if (typeof decl !== 'function') return null;
      var rule = (0,jss__WEBPACK_IMPORTED_MODULE_0__/* .createRule */ .JH)(name, {}, options);
      rule[fnRuleNs] = decl;
      return rule;
    },
    onProcessStyle: function onProcessStyle(style, rule) {
      // We need to extract function values from the declaration, so that we can keep core unaware of them.
      // We need to do that only once.
      // We don't need to extract functions on each style update, since this can happen only once.
      // We don't support function values inside of function rules.
      if (fnValuesNs in rule || fnRuleNs in rule) return style;
      var fnValues = {};

      for (var prop in style) {
        var value = style[prop];
        if (typeof value !== 'function') continue;
        delete style[prop];
        fnValues[prop] = value;
      }

      rule[fnValuesNs] = fnValues;
      return style;
    },
    onUpdate: function onUpdate(data, rule, sheet, options) {
      var styleRule = rule;
      var fnRule = styleRule[fnRuleNs]; // If we have a style function, the entire rule is dynamic and style object
      // will be returned from that function.

      if (fnRule) {
        // Empty object will remove all currently defined props
        // in case function rule returns a falsy value.
        styleRule.style = fnRule(data) || {};

        if (false) { var prop; }
      }

      var fnValues = styleRule[fnValuesNs]; // If we have a fn values map, it is a rule with function values.

      if (fnValues) {
        for (var _prop in fnValues) {
          styleRule.prop(_prop, fnValues[_prop](data), options);
        }
      }
    }
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (functionPlugin);


/***/ }),

/***/ 3203:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ jss_plugin_vendor_prefixer_esm; }
});

// EXTERNAL MODULE: ./node_modules/is-in-browser/dist/module.js
var dist_module = __webpack_require__(33827);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(74902);
;// CONCATENATED MODULE: ./node_modules/css-vendor/dist/css-vendor.esm.js



// Export javascript style and css style vendor prefixes.
var js = '';
var css = '';
var vendor = '';
var browser = '';
var isTouch = dist_module/* default */.Z && 'ontouchstart' in document.documentElement; // We should not do anything if required serverside.

if (dist_module/* default */.Z) {
  // Order matters. We need to check Webkit the last one because
  // other vendors use to add Webkit prefixes to some properties
  var jsCssMap = {
    Moz: '-moz-',
    ms: '-ms-',
    O: '-o-',
    Webkit: '-webkit-'
  };

  var _document$createEleme = document.createElement('p'),
      style = _document$createEleme.style;

  var testProp = 'Transform';

  for (var key in jsCssMap) {
    if (key + testProp in style) {
      js = key;
      css = jsCssMap[key];
      break;
    }
  } // Correctly detect the Edge browser.


  if (js === 'Webkit' && 'msHyphens' in style) {
    js = 'ms';
    css = jsCssMap.ms;
    browser = 'edge';
  } // Correctly detect the Safari browser.


  if (js === 'Webkit' && '-apple-trailing-word' in style) {
    vendor = 'apple';
  }
}
/**
 * Vendor prefix string for the current browser.
 *
 * @type {{js: String, css: String, vendor: String, browser: String}}
 * @api public
 */


var prefix = {
  js: js,
  css: css,
  vendor: vendor,
  browser: browser,
  isTouch: isTouch
};

/**
 * Test if a keyframe at-rule should be prefixed or not
 *
 * @param {String} vendor prefix string for the current browser.
 * @return {String}
 * @api public
 */

function supportedKeyframes(key) {
  // Keyframes is already prefixed. e.g. key = '@-webkit-keyframes a'
  if (key[1] === '-') return key; // No need to prefix IE/Edge. Older browsers will ignore unsupported rules.
  // https://caniuse.com/#search=keyframes

  if (prefix.js === 'ms') return key;
  return "@" + prefix.css + "keyframes" + key.substr(10);
}

// https://caniuse.com/#search=appearance

var appearence = {
  noPrefill: ['appearance'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'appearance') return false;
    if (prefix.js === 'ms') return "-webkit-" + prop;
    return prefix.css + prop;
  }
};

// https://caniuse.com/#search=color-adjust

var colorAdjust = {
  noPrefill: ['color-adjust'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'color-adjust') return false;
    if (prefix.js === 'Webkit') return prefix.css + "print-" + prop;
    return prop;
  }
};

var regExp = /[-\s]+(.)?/g;
/**
 * Replaces the letter with the capital letter
 *
 * @param {String} match
 * @param {String} c
 * @return {String}
 * @api private
 */

function toUpper(match, c) {
  return c ? c.toUpperCase() : '';
}
/**
 * Convert dash separated strings to camel-cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */


function camelize(str) {
  return str.replace(regExp, toUpper);
}

/**
 * Convert dash separated strings to pascal cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */

function pascalize(str) {
  return camelize("-" + str);
}

// but we can use a longhand property instead.
// https://caniuse.com/#search=mask

var mask = {
  noPrefill: ['mask'],
  supportedProperty: function supportedProperty(prop, style) {
    if (!/^mask/.test(prop)) return false;

    if (prefix.js === 'Webkit') {
      var longhand = 'mask-image';

      if (camelize(longhand) in style) {
        return prop;
      }

      if (prefix.js + pascalize(longhand) in style) {
        return prefix.css + prop;
      }
    }

    return prop;
  }
};

// https://caniuse.com/#search=text-orientation

var textOrientation = {
  noPrefill: ['text-orientation'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'text-orientation') return false;

    if (prefix.vendor === 'apple' && !prefix.isTouch) {
      return prefix.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=transform

var transform = {
  noPrefill: ['transform'],
  supportedProperty: function supportedProperty(prop, style, options) {
    if (prop !== 'transform') return false;

    if (options.transform) {
      return prop;
    }

    return prefix.css + prop;
  }
};

// https://caniuse.com/#search=transition

var transition = {
  noPrefill: ['transition'],
  supportedProperty: function supportedProperty(prop, style, options) {
    if (prop !== 'transition') return false;

    if (options.transition) {
      return prop;
    }

    return prefix.css + prop;
  }
};

// https://caniuse.com/#search=writing-mode

var writingMode = {
  noPrefill: ['writing-mode'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'writing-mode') return false;

    if (prefix.js === 'Webkit' || prefix.js === 'ms' && prefix.browser !== 'edge') {
      return prefix.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=user-select

var userSelect = {
  noPrefill: ['user-select'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'user-select') return false;

    if (prefix.js === 'Moz' || prefix.js === 'ms' || prefix.vendor === 'apple') {
      return prefix.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=multicolumn
// https://github.com/postcss/autoprefixer/issues/491
// https://github.com/postcss/autoprefixer/issues/177

var breakPropsOld = {
  supportedProperty: function supportedProperty(prop, style) {
    if (!/^break-/.test(prop)) return false;

    if (prefix.js === 'Webkit') {
      var jsProp = "WebkitColumn" + pascalize(prop);
      return jsProp in style ? prefix.css + "column-" + prop : false;
    }

    if (prefix.js === 'Moz') {
      var _jsProp = "page" + pascalize(prop);

      return _jsProp in style ? "page-" + prop : false;
    }

    return false;
  }
};

// See https://github.com/postcss/autoprefixer/issues/324.

var inlineLogicalOld = {
  supportedProperty: function supportedProperty(prop, style) {
    if (!/^(border|margin|padding)-inline/.test(prop)) return false;
    if (prefix.js === 'Moz') return prop;
    var newProp = prop.replace('-inline', '');
    return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
  }
};

// Camelization is required because we can't test using.
// CSS syntax for e.g. in FF.

var unprefixed = {
  supportedProperty: function supportedProperty(prop, style) {
    return camelize(prop) in style ? prop : false;
  }
};

var prefixed = {
  supportedProperty: function supportedProperty(prop, style) {
    var pascalized = pascalize(prop); // Return custom CSS variable without prefixing.

    if (prop[0] === '-') return prop; // Return already prefixed value without prefixing.

    if (prop[0] === '-' && prop[1] === '-') return prop;
    if (prefix.js + pascalized in style) return prefix.css + prop; // Try webkit fallback.

    if (prefix.js !== 'Webkit' && "Webkit" + pascalized in style) return "-webkit-" + prop;
    return false;
  }
};

// https://caniuse.com/#search=scroll-snap

var scrollSnap = {
  supportedProperty: function supportedProperty(prop) {
    if (prop.substring(0, 11) !== 'scroll-snap') return false;

    if (prefix.js === 'ms') {
      return "" + prefix.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=overscroll-behavior

var overscrollBehavior = {
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'overscroll-behavior') return false;

    if (prefix.js === 'ms') {
      return prefix.css + "scroll-chaining";
    }

    return prop;
  }
};

var propMap = {
  'flex-grow': 'flex-positive',
  'flex-shrink': 'flex-negative',
  'flex-basis': 'flex-preferred-size',
  'justify-content': 'flex-pack',
  order: 'flex-order',
  'align-items': 'flex-align',
  'align-content': 'flex-line-pack' // 'align-self' is handled by 'align-self' plugin.

}; // Support old flex spec from 2012.

var flex2012 = {
  supportedProperty: function supportedProperty(prop, style) {
    var newProp = propMap[prop];
    if (!newProp) return false;
    return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
  }
};

var propMap$1 = {
  flex: 'box-flex',
  'flex-grow': 'box-flex',
  'flex-direction': ['box-orient', 'box-direction'],
  order: 'box-ordinal-group',
  'align-items': 'box-align',
  'flex-flow': ['box-orient', 'box-direction'],
  'justify-content': 'box-pack'
};
var propKeys = Object.keys(propMap$1);

var prefixCss = function prefixCss(p) {
  return prefix.css + p;
}; // Support old flex spec from 2009.


var flex2009 = {
  supportedProperty: function supportedProperty(prop, style, _ref) {
    var multiple = _ref.multiple;

    if (propKeys.indexOf(prop) > -1) {
      var newProp = propMap$1[prop];

      if (!Array.isArray(newProp)) {
        return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
      }

      if (!multiple) return false;

      for (var i = 0; i < newProp.length; i++) {
        if (!(prefix.js + pascalize(newProp[0]) in style)) {
          return false;
        }
      }

      return newProp.map(prefixCss);
    }

    return false;
  }
};

// plugins = [
//   ...plugins,
//    breakPropsOld,
//    inlineLogicalOld,
//    unprefixed,
//    prefixed,
//    scrollSnap,
//    flex2012,
//    flex2009
// ]
// Plugins without 'noPrefill' value, going last.
// 'flex-*' plugins should be at the bottom.
// 'flex2009' going after 'flex2012'.
// 'prefixed' going after 'unprefixed'

var plugins = [appearence, colorAdjust, mask, textOrientation, transform, transition, writingMode, userSelect, breakPropsOld, inlineLogicalOld, unprefixed, prefixed, scrollSnap, overscrollBehavior, flex2012, flex2009];
var propertyDetectors = plugins.filter(function (p) {
  return p.supportedProperty;
}).map(function (p) {
  return p.supportedProperty;
});
var noPrefill = plugins.filter(function (p) {
  return p.noPrefill;
}).reduce(function (a, p) {
  a.push.apply(a, (0,toConsumableArray/* default */.Z)(p.noPrefill));
  return a;
}, []);

var el;
var cache = {};

if (dist_module/* default */.Z) {
  el = document.createElement('p'); // We test every property on vendor prefix requirement.
  // Once tested, result is cached. It gives us up to 70% perf boost.
  // http://jsperf.com/element-style-object-access-vs-plain-object
  //
  // Prefill cache with known css properties to reduce amount of
  // properties we need to feature test at runtime.
  // http://davidwalsh.name/vendor-prefix

  var computed = window.getComputedStyle(document.documentElement, '');

  for (var key$1 in computed) {
    // eslint-disable-next-line no-restricted-globals
    if (!isNaN(key$1)) cache[computed[key$1]] = computed[key$1];
  } // Properties that cannot be correctly detected using the
  // cache prefill method.


  noPrefill.forEach(function (x) {
    return delete cache[x];
  });
}
/**
 * Test if a property is supported, returns supported property with vendor
 * prefix if required. Returns `false` if not supported.
 *
 * @param {String} prop dash separated
 * @param {Object} [options]
 * @return {String|Boolean}
 * @api public
 */


function supportedProperty(prop, options) {
  if (options === void 0) {
    options = {};
  }

  // For server-side rendering.
  if (!el) return prop; // Remove cache for benchmark tests or return property from the cache.

  if ( true && cache[prop] != null) {
    return cache[prop];
  } // Check if 'transition' or 'transform' natively supported in browser.


  if (prop === 'transition' || prop === 'transform') {
    options[prop] = prop in el.style;
  } // Find a plugin for current prefix property.


  for (var i = 0; i < propertyDetectors.length; i++) {
    cache[prop] = propertyDetectors[i](prop, el.style, options); // Break loop, if value found.

    if (cache[prop]) break;
  } // Reset styles for current property.
  // Firefox can even throw an error for invalid properties, e.g., "0".


  try {
    el.style[prop] = '';
  } catch (err) {
    return false;
  }

  return cache[prop];
}

var cache$1 = {};
var transitionProperties = {
  transition: 1,
  'transition-property': 1,
  '-webkit-transition': 1,
  '-webkit-transition-property': 1
};
var transPropsRegExp = /(^\s*[\w-]+)|, (\s*[\w-]+)(?![^()]*\))/g;
var el$1;
/**
 * Returns prefixed value transition/transform if needed.
 *
 * @param {String} match
 * @param {String} p1
 * @param {String} p2
 * @return {String}
 * @api private
 */

function prefixTransitionCallback(match, p1, p2) {
  if (p1 === 'var') return 'var';
  if (p1 === 'all') return 'all';
  if (p2 === 'all') return ', all';
  var prefixedValue = p1 ? supportedProperty(p1) : ", " + supportedProperty(p2);
  if (!prefixedValue) return p1 || p2;
  return prefixedValue;
}

if (dist_module/* default */.Z) el$1 = document.createElement('p');
/**
 * Returns prefixed value if needed. Returns `false` if value is not supported.
 *
 * @param {String} property
 * @param {String} value
 * @return {String|Boolean}
 * @api public
 */

function supportedValue(property, value) {
  // For server-side rendering.
  var prefixedValue = value;
  if (!el$1 || property === 'content') return value; // It is a string or a number as a string like '1'.
  // We want only prefixable values here.
  // eslint-disable-next-line no-restricted-globals

  if (typeof prefixedValue !== 'string' || !isNaN(parseInt(prefixedValue, 10))) {
    return prefixedValue;
  } // Create cache key for current value.


  var cacheKey = property + prefixedValue; // Remove cache for benchmark tests or return value from cache.

  if ( true && cache$1[cacheKey] != null) {
    return cache$1[cacheKey];
  } // IE can even throw an error in some cases, for e.g. style.content = 'bar'.


  try {
    // Test value as it is.
    el$1.style[property] = prefixedValue;
  } catch (err) {
    // Return false if value not supported.
    cache$1[cacheKey] = false;
    return false;
  } // If 'transition' or 'transition-property' property.


  if (transitionProperties[property]) {
    prefixedValue = prefixedValue.replace(transPropsRegExp, prefixTransitionCallback);
  } else if (el$1.style[property] === '') {
    // Value with a vendor prefix.
    prefixedValue = prefix.css + prefixedValue; // Hardcode test to convert "flex" to "-ms-flexbox" for IE10.

    if (prefixedValue === '-ms-flex') el$1.style[property] = '-ms-flexbox'; // Test prefixed value.

    el$1.style[property] = prefixedValue; // Return false if value not supported.

    if (el$1.style[property] === '') {
      cache$1[cacheKey] = false;
      return false;
    }
  } // Reset styles for current property.


  el$1.style[property] = ''; // Write current value to cache.

  cache$1[cacheKey] = prefixedValue;
  return cache$1[cacheKey];
}



// EXTERNAL MODULE: ./node_modules/jss/dist/jss.esm.js
var jss_esm = __webpack_require__(54013);
;// CONCATENATED MODULE: ./node_modules/jss-plugin-vendor-prefixer/dist/jss-plugin-vendor-prefixer.esm.js



/**
 * Add vendor prefix to a property name when needed.
 */

function jssVendorPrefixer() {
  function onProcessRule(rule) {
    if (rule.type === 'keyframes') {
      var atRule = rule;
      atRule.at = supportedKeyframes(atRule.at);
    }
  }

  function prefixStyle(style) {
    for (var prop in style) {
      var value = style[prop];

      if (prop === 'fallbacks' && Array.isArray(value)) {
        style[prop] = value.map(prefixStyle);
        continue;
      }

      var changeProp = false;
      var supportedProp = supportedProperty(prop);
      if (supportedProp && supportedProp !== prop) changeProp = true;
      var changeValue = false;
      var supportedValue$1 = supportedValue(supportedProp, (0,jss_esm/* toCssValue */.EK)(value));
      if (supportedValue$1 && supportedValue$1 !== value) changeValue = true;

      if (changeProp || changeValue) {
        if (changeProp) delete style[prop];
        style[supportedProp || prop] = supportedValue$1 || value;
      }
    }

    return style;
  }

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;
    return prefixStyle(style);
  }

  function onChangeValue(value, prop) {
    return supportedValue(prop, (0,jss_esm/* toCssValue */.EK)(value)) || value;
  }

  return {
    onProcessRule: onProcessRule,
    onProcessStyle: onProcessStyle,
    onChangeValue: onChangeValue
  };
}

/* harmony default export */ var jss_plugin_vendor_prefixer_esm = (jssVendorPrefixer);


/***/ }),

/***/ 54013:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EK": function() { return /* binding */ toCssValue; },
/* harmony export */   "HZ": function() { return /* binding */ hasCSSTOMSupport; },
/* harmony export */   "JH": function() { return /* binding */ createRule; },
/* harmony export */   "RB": function() { return /* binding */ RuleList; },
/* harmony export */   "Ue": function() { return /* binding */ createJss; },
/* harmony export */   "_$": function() { return /* binding */ getDynamicStyles; },
/* harmony export */   "xE": function() { return /* binding */ SheetsRegistry; }
/* harmony export */ });
/* unused harmony exports SheetsManager, createGenerateId, sheets */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87462);
/* harmony import */ var is_in_browser__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33827);
/* harmony import */ var _babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43144);
/* harmony import */ var _babel_runtime_helpers_esm_inheritsLoose__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94578);
/* harmony import */ var _babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97326);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(63366);








var plainObjectConstrurctor = {}.constructor;
function cloneStyle(style) {
  if (style == null || typeof style !== 'object') return style;
  if (Array.isArray(style)) return style.map(cloneStyle);
  if (style.constructor !== plainObjectConstrurctor) return style;
  var newStyle = {};

  for (var name in style) {
    newStyle[name] = cloneStyle(style[name]);
  }

  return newStyle;
}

/**
 * Create a rule instance.
 */

function createRule(name, decl, options) {
  if (name === void 0) {
    name = 'unnamed';
  }

  var jss = options.jss;
  var declCopy = cloneStyle(decl);
  var rule = jss.plugins.onCreateRule(name, declCopy, options);
  if (rule) return rule; // It is an at-rule and it has no instance.

  if (name[0] === '@') {
     false ? 0 : void 0;
  }

  return null;
}

var join = function join(value, by) {
  var result = '';

  for (var i = 0; i < value.length; i++) {
    // Remove !important from the value, it will be readded later.
    if (value[i] === '!important') break;
    if (result) result += by;
    result += value[i];
  }

  return result;
};
/**
 * Converts JSS array value to a CSS string.
 *
 * `margin: [['5px', '10px']]` > `margin: 5px 10px;`
 * `border: ['1px', '2px']` > `border: 1px, 2px;`
 * `margin: [['5px', '10px'], '!important']` > `margin: 5px 10px !important;`
 * `color: ['red', !important]` > `color: red !important;`
 */


var toCssValue = function toCssValue(value) {
  if (!Array.isArray(value)) return value;
  var cssValue = ''; // Support space separated values via `[['5px', '10px']]`.

  if (Array.isArray(value[0])) {
    for (var i = 0; i < value.length; i++) {
      if (value[i] === '!important') break;
      if (cssValue) cssValue += ', ';
      cssValue += join(value[i], ' ');
    }
  } else cssValue = join(value, ', '); // Add !important, because it was ignored.


  if (value[value.length - 1] === '!important') {
    cssValue += ' !important';
  }

  return cssValue;
};

function getWhitespaceSymbols(options) {
  if (options && options.format === false) {
    return {
      linebreak: '',
      space: ''
    };
  }

  return {
    linebreak: '\n',
    space: ' '
  };
}

/**
 * Indent a string.
 * http://jsperf.com/array-join-vs-for
 */

function indentStr(str, indent) {
  var result = '';

  for (var index = 0; index < indent; index++) {
    result += '  ';
  }

  return result + str;
}
/**
 * Converts a Rule to CSS string.
 */


function toCss(selector, style, options) {
  if (options === void 0) {
    options = {};
  }

  var result = '';
  if (!style) return result;
  var _options = options,
      _options$indent = _options.indent,
      indent = _options$indent === void 0 ? 0 : _options$indent;
  var fallbacks = style.fallbacks;

  if (options.format === false) {
    indent = -Infinity;
  }

  var _getWhitespaceSymbols = getWhitespaceSymbols(options),
      linebreak = _getWhitespaceSymbols.linebreak,
      space = _getWhitespaceSymbols.space;

  if (selector) indent++; // Apply fallbacks first.

  if (fallbacks) {
    // Array syntax {fallbacks: [{prop: value}]}
    if (Array.isArray(fallbacks)) {
      for (var index = 0; index < fallbacks.length; index++) {
        var fallback = fallbacks[index];

        for (var prop in fallback) {
          var value = fallback[prop];

          if (value != null) {
            if (result) result += linebreak;
            result += indentStr(prop + ":" + space + toCssValue(value) + ";", indent);
          }
        }
      }
    } else {
      // Object syntax {fallbacks: {prop: value}}
      for (var _prop in fallbacks) {
        var _value = fallbacks[_prop];

        if (_value != null) {
          if (result) result += linebreak;
          result += indentStr(_prop + ":" + space + toCssValue(_value) + ";", indent);
        }
      }
    }
  }

  for (var _prop2 in style) {
    var _value2 = style[_prop2];

    if (_value2 != null && _prop2 !== 'fallbacks') {
      if (result) result += linebreak;
      result += indentStr(_prop2 + ":" + space + toCssValue(_value2) + ";", indent);
    }
  } // Allow empty style in this case, because properties will be added dynamically.


  if (!result && !options.allowEmpty) return result; // When rule is being stringified before selector was defined.

  if (!selector) return result;
  indent--;
  if (result) result = "" + linebreak + result + linebreak;
  return indentStr("" + selector + space + "{" + result, indent) + indentStr('}', indent);
}

var escapeRegex = /([[\].#*$><+~=|^:(),"'`\s])/g;
var nativeEscape = typeof CSS !== 'undefined' && CSS.escape;
var escape = (function (str) {
  return nativeEscape ? nativeEscape(str) : str.replace(escapeRegex, '\\$1');
});

var BaseStyleRule =
/*#__PURE__*/
function () {
  function BaseStyleRule(key, style, options) {
    this.type = 'style';
    this.isProcessed = false;
    var sheet = options.sheet,
        Renderer = options.Renderer;
    this.key = key;
    this.options = options;
    this.style = style;
    if (sheet) this.renderer = sheet.renderer;else if (Renderer) this.renderer = new Renderer();
  }
  /**
   * Get or set a style property.
   */


  var _proto = BaseStyleRule.prototype;

  _proto.prop = function prop(name, value, options) {
    // It's a getter.
    if (value === undefined) return this.style[name]; // Don't do anything if the value has not changed.

    var force = options ? options.force : false;
    if (!force && this.style[name] === value) return this;
    var newValue = value;

    if (!options || options.process !== false) {
      newValue = this.options.jss.plugins.onChangeValue(value, name, this);
    }

    var isEmpty = newValue == null || newValue === false;
    var isDefined = name in this.style; // Value is empty and wasn't defined before.

    if (isEmpty && !isDefined && !force) return this; // We are going to remove this value.

    var remove = isEmpty && isDefined;
    if (remove) delete this.style[name];else this.style[name] = newValue; // Renderable is defined if StyleSheet option `link` is true.

    if (this.renderable && this.renderer) {
      if (remove) this.renderer.removeProperty(this.renderable, name);else this.renderer.setProperty(this.renderable, name, newValue);
      return this;
    }

    var sheet = this.options.sheet;

    if (sheet && sheet.attached) {
       false ? 0 : void 0;
    }

    return this;
  };

  return BaseStyleRule;
}();
var StyleRule =
/*#__PURE__*/
function (_BaseStyleRule) {
  (0,_babel_runtime_helpers_esm_inheritsLoose__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(StyleRule, _BaseStyleRule);

  function StyleRule(key, style, options) {
    var _this;

    _this = _BaseStyleRule.call(this, key, style, options) || this;
    var selector = options.selector,
        scoped = options.scoped,
        sheet = options.sheet,
        generateId = options.generateId;

    if (selector) {
      _this.selectorText = selector;
    } else if (scoped !== false) {
      _this.id = generateId((0,_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_this)), sheet);
      _this.selectorText = "." + escape(_this.id);
    }

    return _this;
  }
  /**
   * Set selector string.
   * Attention: use this with caution. Most browsers didn't implement
   * selectorText setter, so this may result in rerendering of entire Style Sheet.
   */


  var _proto2 = StyleRule.prototype;

  /**
   * Apply rule to an element inline.
   */
  _proto2.applyTo = function applyTo(renderable) {
    var renderer = this.renderer;

    if (renderer) {
      var json = this.toJSON();

      for (var prop in json) {
        renderer.setProperty(renderable, prop, json[prop]);
      }
    }

    return this;
  }
  /**
   * Returns JSON representation of the rule.
   * Fallbacks are not supported.
   * Useful for inline styles.
   */
  ;

  _proto2.toJSON = function toJSON() {
    var json = {};

    for (var prop in this.style) {
      var value = this.style[prop];
      if (typeof value !== 'object') json[prop] = value;else if (Array.isArray(value)) json[prop] = toCssValue(value);
    }

    return json;
  }
  /**
   * Generates a CSS string.
   */
  ;

  _proto2.toString = function toString(options) {
    var sheet = this.options.sheet;
    var link = sheet ? sheet.options.link : false;
    var opts = link ? (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, options, {
      allowEmpty: true
    }) : options;
    return toCss(this.selectorText, this.style, opts);
  };

  (0,_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(StyleRule, [{
    key: "selector",
    set: function set(selector) {
      if (selector === this.selectorText) return;
      this.selectorText = selector;
      var renderer = this.renderer,
          renderable = this.renderable;
      if (!renderable || !renderer) return;
      var hasChanged = renderer.setSelector(renderable, selector); // If selector setter is not implemented, rerender the rule.

      if (!hasChanged) {
        renderer.replaceRule(renderable, this);
      }
    }
    /**
     * Get selector string.
     */
    ,
    get: function get() {
      return this.selectorText;
    }
  }]);

  return StyleRule;
}(BaseStyleRule);
var pluginStyleRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    if (key[0] === '@' || options.parent && options.parent.type === 'keyframes') {
      return null;
    }

    return new StyleRule(key, style, options);
  }
};

var defaultToStringOptions = {
  indent: 1,
  children: true
};
var atRegExp = /@([\w-]+)/;
/**
 * Conditional rule for @media, @supports
 */

var ConditionalRule =
/*#__PURE__*/
function () {
  function ConditionalRule(key, styles, options) {
    this.type = 'conditional';
    this.isProcessed = false;
    this.key = key;
    var atMatch = key.match(atRegExp);
    this.at = atMatch ? atMatch[1] : 'unknown'; // Key might contain a unique suffix in case the `name` passed by user was duplicate.

    this.query = options.name || "@" + this.at;
    this.options = options;
    this.rules = new RuleList((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, options, {
      parent: this
    }));

    for (var name in styles) {
      this.rules.add(name, styles[name]);
    }

    this.rules.process();
  }
  /**
   * Get a rule.
   */


  var _proto = ConditionalRule.prototype;

  _proto.getRule = function getRule(name) {
    return this.rules.get(name);
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.rules.indexOf(rule);
  }
  /**
   * Create and register rule, run plugins.
   */
  ;

  _proto.addRule = function addRule(name, style, options) {
    var rule = this.rules.add(name, style, options);
    if (!rule) return null;
    this.options.jss.plugins.onProcessRule(rule);
    return rule;
  }
  /**
   * Replace rule, run plugins.
   */
  ;

  _proto.replaceRule = function replaceRule(name, style, options) {
    var newRule = this.rules.replace(name, style, options);
    if (newRule) this.options.jss.plugins.onProcessRule(newRule);
    return newRule;
  }
  /**
   * Generates a CSS string.
   */
  ;

  _proto.toString = function toString(options) {
    if (options === void 0) {
      options = defaultToStringOptions;
    }

    var _getWhitespaceSymbols = getWhitespaceSymbols(options),
        linebreak = _getWhitespaceSymbols.linebreak;

    if (options.indent == null) options.indent = defaultToStringOptions.indent;
    if (options.children == null) options.children = defaultToStringOptions.children;

    if (options.children === false) {
      return this.query + " {}";
    }

    var children = this.rules.toString(options);
    return children ? this.query + " {" + linebreak + children + linebreak + "}" : '';
  };

  return ConditionalRule;
}();
var keyRegExp = /@container|@media|@supports\s+/;
var pluginConditionalRule = {
  onCreateRule: function onCreateRule(key, styles, options) {
    return keyRegExp.test(key) ? new ConditionalRule(key, styles, options) : null;
  }
};

var defaultToStringOptions$1 = {
  indent: 1,
  children: true
};
var nameRegExp = /@keyframes\s+([\w-]+)/;
/**
 * Rule for @keyframes
 */

var KeyframesRule =
/*#__PURE__*/
function () {
  function KeyframesRule(key, frames, options) {
    this.type = 'keyframes';
    this.at = '@keyframes';
    this.isProcessed = false;
    var nameMatch = key.match(nameRegExp);

    if (nameMatch && nameMatch[1]) {
      this.name = nameMatch[1];
    } else {
      this.name = 'noname';
       false ? 0 : void 0;
    }

    this.key = this.type + "-" + this.name;
    this.options = options;
    var scoped = options.scoped,
        sheet = options.sheet,
        generateId = options.generateId;
    this.id = scoped === false ? this.name : escape(generateId(this, sheet));
    this.rules = new RuleList((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, options, {
      parent: this
    }));

    for (var name in frames) {
      this.rules.add(name, frames[name], (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, options, {
        parent: this
      }));
    }

    this.rules.process();
  }
  /**
   * Generates a CSS string.
   */


  var _proto = KeyframesRule.prototype;

  _proto.toString = function toString(options) {
    if (options === void 0) {
      options = defaultToStringOptions$1;
    }

    var _getWhitespaceSymbols = getWhitespaceSymbols(options),
        linebreak = _getWhitespaceSymbols.linebreak;

    if (options.indent == null) options.indent = defaultToStringOptions$1.indent;
    if (options.children == null) options.children = defaultToStringOptions$1.children;

    if (options.children === false) {
      return this.at + " " + this.id + " {}";
    }

    var children = this.rules.toString(options);
    if (children) children = "" + linebreak + children + linebreak;
    return this.at + " " + this.id + " {" + children + "}";
  };

  return KeyframesRule;
}();
var keyRegExp$1 = /@keyframes\s+/;
var refRegExp = /\$([\w-]+)/g;

var findReferencedKeyframe = function findReferencedKeyframe(val, keyframes) {
  if (typeof val === 'string') {
    return val.replace(refRegExp, function (match, name) {
      if (name in keyframes) {
        return keyframes[name];
      }

       false ? 0 : void 0;
      return match;
    });
  }

  return val;
};
/**
 * Replace the reference for a animation name.
 */


var replaceRef = function replaceRef(style, prop, keyframes) {
  var value = style[prop];
  var refKeyframe = findReferencedKeyframe(value, keyframes);

  if (refKeyframe !== value) {
    style[prop] = refKeyframe;
  }
};

var pluginKeyframesRule = {
  onCreateRule: function onCreateRule(key, frames, options) {
    return typeof key === 'string' && keyRegExp$1.test(key) ? new KeyframesRule(key, frames, options) : null;
  },
  // Animation name ref replacer.
  onProcessStyle: function onProcessStyle(style, rule, sheet) {
    if (rule.type !== 'style' || !sheet) return style;
    if ('animation-name' in style) replaceRef(style, 'animation-name', sheet.keyframes);
    if ('animation' in style) replaceRef(style, 'animation', sheet.keyframes);
    return style;
  },
  onChangeValue: function onChangeValue(val, prop, rule) {
    var sheet = rule.options.sheet;

    if (!sheet) {
      return val;
    }

    switch (prop) {
      case 'animation':
        return findReferencedKeyframe(val, sheet.keyframes);

      case 'animation-name':
        return findReferencedKeyframe(val, sheet.keyframes);

      default:
        return val;
    }
  }
};

var KeyframeRule =
/*#__PURE__*/
function (_BaseStyleRule) {
  (0,_babel_runtime_helpers_esm_inheritsLoose__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(KeyframeRule, _BaseStyleRule);

  function KeyframeRule() {
    return _BaseStyleRule.apply(this, arguments) || this;
  }

  var _proto = KeyframeRule.prototype;

  /**
   * Generates a CSS string.
   */
  _proto.toString = function toString(options) {
    var sheet = this.options.sheet;
    var link = sheet ? sheet.options.link : false;
    var opts = link ? (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, options, {
      allowEmpty: true
    }) : options;
    return toCss(this.key, this.style, opts);
  };

  return KeyframeRule;
}(BaseStyleRule);
var pluginKeyframeRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    if (options.parent && options.parent.type === 'keyframes') {
      return new KeyframeRule(key, style, options);
    }

    return null;
  }
};

var FontFaceRule =
/*#__PURE__*/
function () {
  function FontFaceRule(key, style, options) {
    this.type = 'font-face';
    this.at = '@font-face';
    this.isProcessed = false;
    this.key = key;
    this.style = style;
    this.options = options;
  }
  /**
   * Generates a CSS string.
   */


  var _proto = FontFaceRule.prototype;

  _proto.toString = function toString(options) {
    var _getWhitespaceSymbols = getWhitespaceSymbols(options),
        linebreak = _getWhitespaceSymbols.linebreak;

    if (Array.isArray(this.style)) {
      var str = '';

      for (var index = 0; index < this.style.length; index++) {
        str += toCss(this.at, this.style[index]);
        if (this.style[index + 1]) str += linebreak;
      }

      return str;
    }

    return toCss(this.at, this.style, options);
  };

  return FontFaceRule;
}();
var keyRegExp$2 = /@font-face/;
var pluginFontFaceRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    return keyRegExp$2.test(key) ? new FontFaceRule(key, style, options) : null;
  }
};

var ViewportRule =
/*#__PURE__*/
function () {
  function ViewportRule(key, style, options) {
    this.type = 'viewport';
    this.at = '@viewport';
    this.isProcessed = false;
    this.key = key;
    this.style = style;
    this.options = options;
  }
  /**
   * Generates a CSS string.
   */


  var _proto = ViewportRule.prototype;

  _proto.toString = function toString(options) {
    return toCss(this.key, this.style, options);
  };

  return ViewportRule;
}();
var pluginViewportRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    return key === '@viewport' || key === '@-ms-viewport' ? new ViewportRule(key, style, options) : null;
  }
};

var SimpleRule =
/*#__PURE__*/
function () {
  function SimpleRule(key, value, options) {
    this.type = 'simple';
    this.isProcessed = false;
    this.key = key;
    this.value = value;
    this.options = options;
  }
  /**
   * Generates a CSS string.
   */
  // eslint-disable-next-line no-unused-vars


  var _proto = SimpleRule.prototype;

  _proto.toString = function toString(options) {
    if (Array.isArray(this.value)) {
      var str = '';

      for (var index = 0; index < this.value.length; index++) {
        str += this.key + " " + this.value[index] + ";";
        if (this.value[index + 1]) str += '\n';
      }

      return str;
    }

    return this.key + " " + this.value + ";";
  };

  return SimpleRule;
}();
var keysMap = {
  '@charset': true,
  '@import': true,
  '@namespace': true
};
var pluginSimpleRule = {
  onCreateRule: function onCreateRule(key, value, options) {
    return key in keysMap ? new SimpleRule(key, value, options) : null;
  }
};

var plugins = [pluginStyleRule, pluginConditionalRule, pluginKeyframesRule, pluginKeyframeRule, pluginFontFaceRule, pluginViewportRule, pluginSimpleRule];

var defaultUpdateOptions = {
  process: true
};
var forceUpdateOptions = {
  force: true,
  process: true
  /**
   * Contains rules objects and allows adding/removing etc.
   * Is used for e.g. by `StyleSheet` or `ConditionalRule`.
   */

};

var RuleList =
/*#__PURE__*/
function () {
  // Rules registry for access by .get() method.
  // It contains the same rule registered by name and by selector.
  // Original styles object.
  // Used to ensure correct rules order.
  function RuleList(options) {
    this.map = {};
    this.raw = {};
    this.index = [];
    this.counter = 0;
    this.options = options;
    this.classes = options.classes;
    this.keyframes = options.keyframes;
  }
  /**
   * Create and register rule.
   *
   * Will not render after Style Sheet was rendered the first time.
   */


  var _proto = RuleList.prototype;

  _proto.add = function add(name, decl, ruleOptions) {
    var _this$options = this.options,
        parent = _this$options.parent,
        sheet = _this$options.sheet,
        jss = _this$options.jss,
        Renderer = _this$options.Renderer,
        generateId = _this$options.generateId,
        scoped = _this$options.scoped;

    var options = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
      classes: this.classes,
      parent: parent,
      sheet: sheet,
      jss: jss,
      Renderer: Renderer,
      generateId: generateId,
      scoped: scoped,
      name: name,
      keyframes: this.keyframes,
      selector: undefined
    }, ruleOptions); // When user uses .createStyleSheet(), duplicate names are not possible, but
    // `sheet.addRule()` opens the door for any duplicate rule name. When this happens
    // we need to make the key unique within this RuleList instance scope.


    var key = name;

    if (name in this.raw) {
      key = name + "-d" + this.counter++;
    } // We need to save the original decl before creating the rule
    // because cache plugin needs to use it as a key to return a cached rule.


    this.raw[key] = decl;

    if (key in this.classes) {
      // E.g. rules inside of @media container
      options.selector = "." + escape(this.classes[key]);
    }

    var rule = createRule(key, decl, options);
    if (!rule) return null;
    this.register(rule);
    var index = options.index === undefined ? this.index.length : options.index;
    this.index.splice(index, 0, rule);
    return rule;
  }
  /**
   * Replace rule.
   * Create a new rule and remove old one instead of overwriting
   * because we want to invoke onCreateRule hook to make plugins work.
   */
  ;

  _proto.replace = function replace(name, decl, ruleOptions) {
    var oldRule = this.get(name);
    var oldIndex = this.index.indexOf(oldRule);

    if (oldRule) {
      this.remove(oldRule);
    }

    var options = ruleOptions;
    if (oldIndex !== -1) options = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, ruleOptions, {
      index: oldIndex
    });
    return this.add(name, decl, options);
  }
  /**
   * Get a rule by name or selector.
   */
  ;

  _proto.get = function get(nameOrSelector) {
    return this.map[nameOrSelector];
  }
  /**
   * Delete a rule.
   */
  ;

  _proto.remove = function remove(rule) {
    this.unregister(rule);
    delete this.raw[rule.key];
    this.index.splice(this.index.indexOf(rule), 1);
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.index.indexOf(rule);
  }
  /**
   * Run `onProcessRule()` plugins on every rule.
   */
  ;

  _proto.process = function process() {
    var plugins = this.options.jss.plugins; // We need to clone array because if we modify the index somewhere else during a loop
    // we end up with very hard-to-track-down side effects.

    this.index.slice(0).forEach(plugins.onProcessRule, plugins);
  }
  /**
   * Register a rule in `.map`, `.classes` and `.keyframes` maps.
   */
  ;

  _proto.register = function register(rule) {
    this.map[rule.key] = rule;

    if (rule instanceof StyleRule) {
      this.map[rule.selector] = rule;
      if (rule.id) this.classes[rule.key] = rule.id;
    } else if (rule instanceof KeyframesRule && this.keyframes) {
      this.keyframes[rule.name] = rule.id;
    }
  }
  /**
   * Unregister a rule.
   */
  ;

  _proto.unregister = function unregister(rule) {
    delete this.map[rule.key];

    if (rule instanceof StyleRule) {
      delete this.map[rule.selector];
      delete this.classes[rule.key];
    } else if (rule instanceof KeyframesRule) {
      delete this.keyframes[rule.name];
    }
  }
  /**
   * Update the function values with a new data.
   */
  ;

  _proto.update = function update() {
    var name;
    var data;
    var options;

    if (typeof (arguments.length <= 0 ? undefined : arguments[0]) === 'string') {
      name = arguments.length <= 0 ? undefined : arguments[0];
      data = arguments.length <= 1 ? undefined : arguments[1];
      options = arguments.length <= 2 ? undefined : arguments[2];
    } else {
      data = arguments.length <= 0 ? undefined : arguments[0];
      options = arguments.length <= 1 ? undefined : arguments[1];
      name = null;
    }

    if (name) {
      this.updateOne(this.get(name), data, options);
    } else {
      for (var index = 0; index < this.index.length; index++) {
        this.updateOne(this.index[index], data, options);
      }
    }
  }
  /**
   * Execute plugins, update rule props.
   */
  ;

  _proto.updateOne = function updateOne(rule, data, options) {
    if (options === void 0) {
      options = defaultUpdateOptions;
    }

    var _this$options2 = this.options,
        plugins = _this$options2.jss.plugins,
        sheet = _this$options2.sheet; // It is a rules container like for e.g. ConditionalRule.

    if (rule.rules instanceof RuleList) {
      rule.rules.update(data, options);
      return;
    }

    var style = rule.style;
    plugins.onUpdate(data, rule, sheet, options); // We rely on a new `style` ref in case it was mutated during onUpdate hook.

    if (options.process && style && style !== rule.style) {
      // We need to run the plugins in case new `style` relies on syntax plugins.
      plugins.onProcessStyle(rule.style, rule, sheet); // Update and add props.

      for (var prop in rule.style) {
        var nextValue = rule.style[prop];
        var prevValue = style[prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
        // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.

        if (nextValue !== prevValue) {
          rule.prop(prop, nextValue, forceUpdateOptions);
        }
      } // Remove props.


      for (var _prop in style) {
        var _nextValue = rule.style[_prop];
        var _prevValue = style[_prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
        // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.

        if (_nextValue == null && _nextValue !== _prevValue) {
          rule.prop(_prop, null, forceUpdateOptions);
        }
      }
    }
  }
  /**
   * Convert rules to a CSS string.
   */
  ;

  _proto.toString = function toString(options) {
    var str = '';
    var sheet = this.options.sheet;
    var link = sheet ? sheet.options.link : false;

    var _getWhitespaceSymbols = getWhitespaceSymbols(options),
        linebreak = _getWhitespaceSymbols.linebreak;

    for (var index = 0; index < this.index.length; index++) {
      var rule = this.index[index];
      var css = rule.toString(options); // No need to render an empty rule.

      if (!css && !link) continue;
      if (str) str += linebreak;
      str += css;
    }

    return str;
  };

  return RuleList;
}();

var StyleSheet =
/*#__PURE__*/
function () {
  function StyleSheet(styles, options) {
    this.attached = false;
    this.deployed = false;
    this.classes = {};
    this.keyframes = {};
    this.options = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, options, {
      sheet: this,
      parent: this,
      classes: this.classes,
      keyframes: this.keyframes
    });

    if (options.Renderer) {
      this.renderer = new options.Renderer(this);
    }

    this.rules = new RuleList(this.options);

    for (var name in styles) {
      this.rules.add(name, styles[name]);
    }

    this.rules.process();
  }
  /**
   * Attach renderable to the render tree.
   */


  var _proto = StyleSheet.prototype;

  _proto.attach = function attach() {
    if (this.attached) return this;
    if (this.renderer) this.renderer.attach();
    this.attached = true; // Order is important, because we can't use insertRule API if style element is not attached.

    if (!this.deployed) this.deploy();
    return this;
  }
  /**
   * Remove renderable from render tree.
   */
  ;

  _proto.detach = function detach() {
    if (!this.attached) return this;
    if (this.renderer) this.renderer.detach();
    this.attached = false;
    return this;
  }
  /**
   * Add a rule to the current stylesheet.
   * Will insert a rule also after the stylesheet has been rendered first time.
   */
  ;

  _proto.addRule = function addRule(name, decl, options) {
    var queue = this.queue; // Plugins can create rules.
    // In order to preserve the right order, we need to queue all `.addRule` calls,
    // which happen after the first `rules.add()` call.

    if (this.attached && !queue) this.queue = [];
    var rule = this.rules.add(name, decl, options);
    if (!rule) return null;
    this.options.jss.plugins.onProcessRule(rule);

    if (this.attached) {
      if (!this.deployed) return rule; // Don't insert rule directly if there is no stringified version yet.
      // It will be inserted all together when .attach is called.

      if (queue) queue.push(rule);else {
        this.insertRule(rule);

        if (this.queue) {
          this.queue.forEach(this.insertRule, this);
          this.queue = undefined;
        }
      }
      return rule;
    } // We can't add rules to a detached style node.
    // We will redeploy the sheet once user will attach it.


    this.deployed = false;
    return rule;
  }
  /**
   * Replace a rule in the current stylesheet.
   */
  ;

  _proto.replaceRule = function replaceRule(nameOrSelector, decl, options) {
    var oldRule = this.rules.get(nameOrSelector);
    if (!oldRule) return this.addRule(nameOrSelector, decl, options);
    var newRule = this.rules.replace(nameOrSelector, decl, options);

    if (newRule) {
      this.options.jss.plugins.onProcessRule(newRule);
    }

    if (this.attached) {
      if (!this.deployed) return newRule; // Don't replace / delete rule directly if there is no stringified version yet.
      // It will be inserted all together when .attach is called.

      if (this.renderer) {
        if (!newRule) {
          this.renderer.deleteRule(oldRule);
        } else if (oldRule.renderable) {
          this.renderer.replaceRule(oldRule.renderable, newRule);
        }
      }

      return newRule;
    } // We can't replace rules to a detached style node.
    // We will redeploy the sheet once user will attach it.


    this.deployed = false;
    return newRule;
  }
  /**
   * Insert rule into the StyleSheet
   */
  ;

  _proto.insertRule = function insertRule(rule) {
    if (this.renderer) {
      this.renderer.insertRule(rule);
    }
  }
  /**
   * Create and add rules.
   * Will render also after Style Sheet was rendered the first time.
   */
  ;

  _proto.addRules = function addRules(styles, options) {
    var added = [];

    for (var name in styles) {
      var rule = this.addRule(name, styles[name], options);
      if (rule) added.push(rule);
    }

    return added;
  }
  /**
   * Get a rule by name or selector.
   */
  ;

  _proto.getRule = function getRule(nameOrSelector) {
    return this.rules.get(nameOrSelector);
  }
  /**
   * Delete a rule by name.
   * Returns `true`: if rule has been deleted from the DOM.
   */
  ;

  _proto.deleteRule = function deleteRule(name) {
    var rule = typeof name === 'object' ? name : this.rules.get(name);

    if (!rule || // Style sheet was created without link: true and attached, in this case we
    // won't be able to remove the CSS rule from the DOM.
    this.attached && !rule.renderable) {
      return false;
    }

    this.rules.remove(rule);

    if (this.attached && rule.renderable && this.renderer) {
      return this.renderer.deleteRule(rule.renderable);
    }

    return true;
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.rules.indexOf(rule);
  }
  /**
   * Deploy pure CSS string to a renderable.
   */
  ;

  _proto.deploy = function deploy() {
    if (this.renderer) this.renderer.deploy();
    this.deployed = true;
    return this;
  }
  /**
   * Update the function values with a new data.
   */
  ;

  _proto.update = function update() {
    var _this$rules;

    (_this$rules = this.rules).update.apply(_this$rules, arguments);

    return this;
  }
  /**
   * Updates a single rule.
   */
  ;

  _proto.updateOne = function updateOne(rule, data, options) {
    this.rules.updateOne(rule, data, options);
    return this;
  }
  /**
   * Convert rules to a CSS string.
   */
  ;

  _proto.toString = function toString(options) {
    return this.rules.toString(options);
  };

  return StyleSheet;
}();

var PluginsRegistry =
/*#__PURE__*/
function () {
  function PluginsRegistry() {
    this.plugins = {
      internal: [],
      external: []
    };
    this.registry = {};
  }

  var _proto = PluginsRegistry.prototype;

  /**
   * Call `onCreateRule` hooks and return an object if returned by a hook.
   */
  _proto.onCreateRule = function onCreateRule(name, decl, options) {
    for (var i = 0; i < this.registry.onCreateRule.length; i++) {
      var rule = this.registry.onCreateRule[i](name, decl, options);
      if (rule) return rule;
    }

    return null;
  }
  /**
   * Call `onProcessRule` hooks.
   */
  ;

  _proto.onProcessRule = function onProcessRule(rule) {
    if (rule.isProcessed) return;
    var sheet = rule.options.sheet;

    for (var i = 0; i < this.registry.onProcessRule.length; i++) {
      this.registry.onProcessRule[i](rule, sheet);
    }

    if (rule.style) this.onProcessStyle(rule.style, rule, sheet);
    rule.isProcessed = true;
  }
  /**
   * Call `onProcessStyle` hooks.
   */
  ;

  _proto.onProcessStyle = function onProcessStyle(style, rule, sheet) {
    for (var i = 0; i < this.registry.onProcessStyle.length; i++) {
      rule.style = this.registry.onProcessStyle[i](rule.style, rule, sheet);
    }
  }
  /**
   * Call `onProcessSheet` hooks.
   */
  ;

  _proto.onProcessSheet = function onProcessSheet(sheet) {
    for (var i = 0; i < this.registry.onProcessSheet.length; i++) {
      this.registry.onProcessSheet[i](sheet);
    }
  }
  /**
   * Call `onUpdate` hooks.
   */
  ;

  _proto.onUpdate = function onUpdate(data, rule, sheet, options) {
    for (var i = 0; i < this.registry.onUpdate.length; i++) {
      this.registry.onUpdate[i](data, rule, sheet, options);
    }
  }
  /**
   * Call `onChangeValue` hooks.
   */
  ;

  _proto.onChangeValue = function onChangeValue(value, prop, rule) {
    var processedValue = value;

    for (var i = 0; i < this.registry.onChangeValue.length; i++) {
      processedValue = this.registry.onChangeValue[i](processedValue, prop, rule);
    }

    return processedValue;
  }
  /**
   * Register a plugin.
   */
  ;

  _proto.use = function use(newPlugin, options) {
    if (options === void 0) {
      options = {
        queue: 'external'
      };
    }

    var plugins = this.plugins[options.queue]; // Avoids applying same plugin twice, at least based on ref.

    if (plugins.indexOf(newPlugin) !== -1) {
      return;
    }

    plugins.push(newPlugin);
    this.registry = [].concat(this.plugins.external, this.plugins.internal).reduce(function (registry, plugin) {
      for (var name in plugin) {
        if (name in registry) {
          registry[name].push(plugin[name]);
        } else {
           false ? 0 : void 0;
        }
      }

      return registry;
    }, {
      onCreateRule: [],
      onProcessRule: [],
      onProcessStyle: [],
      onProcessSheet: [],
      onChangeValue: [],
      onUpdate: []
    });
  };

  return PluginsRegistry;
}();

/**
 * Sheets registry to access all instances in one place.
 */

var SheetsRegistry =
/*#__PURE__*/
function () {
  function SheetsRegistry() {
    this.registry = [];
  }

  var _proto = SheetsRegistry.prototype;

  /**
   * Register a Style Sheet.
   */
  _proto.add = function add(sheet) {
    var registry = this.registry;
    var index = sheet.options.index;
    if (registry.indexOf(sheet) !== -1) return;

    if (registry.length === 0 || index >= this.index) {
      registry.push(sheet);
      return;
    } // Find a position.


    for (var i = 0; i < registry.length; i++) {
      if (registry[i].options.index > index) {
        registry.splice(i, 0, sheet);
        return;
      }
    }
  }
  /**
   * Reset the registry.
   */
  ;

  _proto.reset = function reset() {
    this.registry = [];
  }
  /**
   * Remove a Style Sheet.
   */
  ;

  _proto.remove = function remove(sheet) {
    var index = this.registry.indexOf(sheet);
    this.registry.splice(index, 1);
  }
  /**
   * Convert all attached sheets to a CSS string.
   */
  ;

  _proto.toString = function toString(_temp) {
    var _ref = _temp === void 0 ? {} : _temp,
        attached = _ref.attached,
        options = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref, ["attached"]);

    var _getWhitespaceSymbols = getWhitespaceSymbols(options),
        linebreak = _getWhitespaceSymbols.linebreak;

    var css = '';

    for (var i = 0; i < this.registry.length; i++) {
      var sheet = this.registry[i];

      if (attached != null && sheet.attached !== attached) {
        continue;
      }

      if (css) css += linebreak;
      css += sheet.toString(options);
    }

    return css;
  };

  (0,_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(SheetsRegistry, [{
    key: "index",

    /**
     * Current highest index number.
     */
    get: function get() {
      return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
    }
  }]);

  return SheetsRegistry;
}();

/**
 * This is a global sheets registry. Only DomRenderer will add sheets to it.
 * On the server one should use an own SheetsRegistry instance and add the
 * sheets to it, because you need to make sure to create a new registry for
 * each request in order to not leak sheets across requests.
 */

var sheets = new SheetsRegistry();

/* eslint-disable */

/**
 * Now that `globalThis` is available on most platforms
 * (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/globalThis#browser_compatibility)
 * we check for `globalThis` first. `globalThis` is necessary for jss
 * to run in Agoric's secure version of JavaScript (SES). Under SES,
 * `globalThis` exists, but `window`, `self`, and `Function('return
 * this')()` are all undefined for security reasons.
 *
 * https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
 */
var globalThis$1 = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' && window.Math === Math ? window : typeof self !== 'undefined' && self.Math === Math ? self : Function('return this')();

var ns = '2f1acc6c3a606b082e5eef5e54414ffb';
if (globalThis$1[ns] == null) globalThis$1[ns] = 0; // Bundle may contain multiple JSS versions at the same time. In order to identify
// the current version with just one short number and use it for classes generation
// we use a counter. Also it is more accurate, because user can manually reevaluate
// the module.

var moduleId = globalThis$1[ns]++;

var maxRules = 1e10;
/**
 * Returns a function which generates unique class names based on counters.
 * When new generator function is created, rule counter is reseted.
 * We need to reset the rule counter for SSR for each request.
 */

var createGenerateId = function createGenerateId(options) {
  if (options === void 0) {
    options = {};
  }

  var ruleCounter = 0;

  var generateId = function generateId(rule, sheet) {
    ruleCounter += 1;

    if (ruleCounter > maxRules) {
       false ? 0 : void 0;
    }

    var jssId = '';
    var prefix = '';

    if (sheet) {
      if (sheet.options.classNamePrefix) {
        prefix = sheet.options.classNamePrefix;
      }

      if (sheet.options.jss.id != null) {
        jssId = String(sheet.options.jss.id);
      }
    }

    if (options.minify) {
      // Using "c" because a number can't be the first char in a class name.
      return "" + (prefix || 'c') + moduleId + jssId + ruleCounter;
    }

    return prefix + rule.key + "-" + moduleId + (jssId ? "-" + jssId : '') + "-" + ruleCounter;
  };

  return generateId;
};

/**
 * Cache the value from the first time a function is called.
 */

var memoize = function memoize(fn) {
  var value;
  return function () {
    if (!value) value = fn();
    return value;
  };
};
/**
 * Get a style property value.
 */


var getPropertyValue = function getPropertyValue(cssRule, prop) {
  try {
    // Support CSSTOM.
    if (cssRule.attributeStyleMap) {
      return cssRule.attributeStyleMap.get(prop);
    }

    return cssRule.style.getPropertyValue(prop);
  } catch (err) {
    // IE may throw if property is unknown.
    return '';
  }
};
/**
 * Set a style property.
 */


var setProperty = function setProperty(cssRule, prop, value) {
  try {
    var cssValue = value;

    if (Array.isArray(value)) {
      cssValue = toCssValue(value);
    } // Support CSSTOM.


    if (cssRule.attributeStyleMap) {
      cssRule.attributeStyleMap.set(prop, cssValue);
    } else {
      var indexOfImportantFlag = cssValue ? cssValue.indexOf('!important') : -1;
      var cssValueWithoutImportantFlag = indexOfImportantFlag > -1 ? cssValue.substr(0, indexOfImportantFlag - 1) : cssValue;
      cssRule.style.setProperty(prop, cssValueWithoutImportantFlag, indexOfImportantFlag > -1 ? 'important' : '');
    }
  } catch (err) {
    // IE may throw if property is unknown.
    return false;
  }

  return true;
};
/**
 * Remove a style property.
 */


var removeProperty = function removeProperty(cssRule, prop) {
  try {
    // Support CSSTOM.
    if (cssRule.attributeStyleMap) {
      cssRule.attributeStyleMap.delete(prop);
    } else {
      cssRule.style.removeProperty(prop);
    }
  } catch (err) {
     false ? 0 : void 0;
  }
};
/**
 * Set the selector.
 */


var setSelector = function setSelector(cssRule, selectorText) {
  cssRule.selectorText = selectorText; // Return false if setter was not successful.
  // Currently works in chrome only.

  return cssRule.selectorText === selectorText;
};
/**
 * Gets the `head` element upon the first call and caches it.
 * We assume it can't be null.
 */


var getHead = memoize(function () {
  return document.querySelector('head');
});
/**
 * Find attached sheet with an index higher than the passed one.
 */

function findHigherSheet(registry, options) {
  for (var i = 0; i < registry.length; i++) {
    var sheet = registry[i];

    if (sheet.attached && sheet.options.index > options.index && sheet.options.insertionPoint === options.insertionPoint) {
      return sheet;
    }
  }

  return null;
}
/**
 * Find attached sheet with the highest index.
 */


function findHighestSheet(registry, options) {
  for (var i = registry.length - 1; i >= 0; i--) {
    var sheet = registry[i];

    if (sheet.attached && sheet.options.insertionPoint === options.insertionPoint) {
      return sheet;
    }
  }

  return null;
}
/**
 * Find a comment with "jss" inside.
 */


function findCommentNode(text) {
  var head = getHead();

  for (var i = 0; i < head.childNodes.length; i++) {
    var node = head.childNodes[i];

    if (node.nodeType === 8 && node.nodeValue.trim() === text) {
      return node;
    }
  }

  return null;
}
/**
 * Find a node before which we can insert the sheet.
 */


function findPrevNode(options) {
  var registry = sheets.registry;

  if (registry.length > 0) {
    // Try to insert before the next higher sheet.
    var sheet = findHigherSheet(registry, options);

    if (sheet && sheet.renderer) {
      return {
        parent: sheet.renderer.element.parentNode,
        node: sheet.renderer.element
      };
    } // Otherwise insert after the last attached.


    sheet = findHighestSheet(registry, options);

    if (sheet && sheet.renderer) {
      return {
        parent: sheet.renderer.element.parentNode,
        node: sheet.renderer.element.nextSibling
      };
    }
  } // Try to find a comment placeholder if registry is empty.


  var insertionPoint = options.insertionPoint;

  if (insertionPoint && typeof insertionPoint === 'string') {
    var comment = findCommentNode(insertionPoint);

    if (comment) {
      return {
        parent: comment.parentNode,
        node: comment.nextSibling
      };
    } // If user specifies an insertion point and it can't be found in the document -
    // bad specificity issues may appear.


     false ? 0 : void 0;
  }

  return false;
}
/**
 * Insert style element into the DOM.
 */


function insertStyle(style, options) {
  var insertionPoint = options.insertionPoint;
  var nextNode = findPrevNode(options);

  if (nextNode !== false && nextNode.parent) {
    nextNode.parent.insertBefore(style, nextNode.node);
    return;
  } // Works with iframes and any node types.


  if (insertionPoint && typeof insertionPoint.nodeType === 'number') {
    var insertionPointElement = insertionPoint;
    var parentNode = insertionPointElement.parentNode;
    if (parentNode) parentNode.insertBefore(style, insertionPointElement.nextSibling);else  false ? 0 : void 0;
    return;
  }

  getHead().appendChild(style);
}
/**
 * Read jss nonce setting from the page if the user has set it.
 */


var getNonce = memoize(function () {
  var node = document.querySelector('meta[property="csp-nonce"]');
  return node ? node.getAttribute('content') : null;
});

var _insertRule = function insertRule(container, rule, index) {
  try {
    if ('insertRule' in container) {
      container.insertRule(rule, index);
    } // Keyframes rule.
    else if ('appendRule' in container) {
        container.appendRule(rule);
      }
  } catch (err) {
     false ? 0 : void 0;
    return false;
  }

  return container.cssRules[index];
};

var getValidRuleInsertionIndex = function getValidRuleInsertionIndex(container, index) {
  var maxIndex = container.cssRules.length; // In case previous insertion fails, passed index might be wrong

  if (index === undefined || index > maxIndex) {
    // eslint-disable-next-line no-param-reassign
    return maxIndex;
  }

  return index;
};

var createStyle = function createStyle() {
  var el = document.createElement('style'); // Without it, IE will have a broken source order specificity if we
  // insert rules after we insert the style tag.
  // It seems to kick-off the source order specificity algorithm.

  el.textContent = '\n';
  return el;
};

var DomRenderer =
/*#__PURE__*/
function () {
  // Will be empty if link: true option is not set, because
  // it is only for use together with insertRule API.
  function DomRenderer(sheet) {
    this.getPropertyValue = getPropertyValue;
    this.setProperty = setProperty;
    this.removeProperty = removeProperty;
    this.setSelector = setSelector;
    this.hasInsertedRules = false;
    this.cssRules = [];
    // There is no sheet when the renderer is used from a standalone StyleRule.
    if (sheet) sheets.add(sheet);
    this.sheet = sheet;

    var _ref = this.sheet ? this.sheet.options : {},
        media = _ref.media,
        meta = _ref.meta,
        element = _ref.element;

    this.element = element || createStyle();
    this.element.setAttribute('data-jss', '');
    if (media) this.element.setAttribute('media', media);
    if (meta) this.element.setAttribute('data-meta', meta);
    var nonce = getNonce();
    if (nonce) this.element.setAttribute('nonce', nonce);
  }
  /**
   * Insert style element into render tree.
   */


  var _proto = DomRenderer.prototype;

  _proto.attach = function attach() {
    // In the case the element node is external and it is already in the DOM.
    if (this.element.parentNode || !this.sheet) return;
    insertStyle(this.element, this.sheet.options); // When rules are inserted using `insertRule` API, after `sheet.detach().attach()`
    // most browsers create a new CSSStyleSheet, except of all IEs.

    var deployed = Boolean(this.sheet && this.sheet.deployed);

    if (this.hasInsertedRules && deployed) {
      this.hasInsertedRules = false;
      this.deploy();
    }
  }
  /**
   * Remove style element from render tree.
   */
  ;

  _proto.detach = function detach() {
    if (!this.sheet) return;
    var parentNode = this.element.parentNode;
    if (parentNode) parentNode.removeChild(this.element); // In the most browsers, rules inserted using insertRule() API will be lost when style element is removed.
    // Though IE will keep them and we need a consistent behavior.

    if (this.sheet.options.link) {
      this.cssRules = [];
      this.element.textContent = '\n';
    }
  }
  /**
   * Inject CSS string into element.
   */
  ;

  _proto.deploy = function deploy() {
    var sheet = this.sheet;
    if (!sheet) return;

    if (sheet.options.link) {
      this.insertRules(sheet.rules);
      return;
    }

    this.element.textContent = "\n" + sheet.toString() + "\n";
  }
  /**
   * Insert RuleList into an element.
   */
  ;

  _proto.insertRules = function insertRules(rules, nativeParent) {
    for (var i = 0; i < rules.index.length; i++) {
      this.insertRule(rules.index[i], i, nativeParent);
    }
  }
  /**
   * Insert a rule into element.
   */
  ;

  _proto.insertRule = function insertRule(rule, index, nativeParent) {
    if (nativeParent === void 0) {
      nativeParent = this.element.sheet;
    }

    if (rule.rules) {
      var parent = rule;
      var latestNativeParent = nativeParent;

      if (rule.type === 'conditional' || rule.type === 'keyframes') {
        var _insertionIndex = getValidRuleInsertionIndex(nativeParent, index); // We need to render the container without children first.


        latestNativeParent = _insertRule(nativeParent, parent.toString({
          children: false
        }), _insertionIndex);

        if (latestNativeParent === false) {
          return false;
        }

        this.refCssRule(rule, _insertionIndex, latestNativeParent);
      }

      this.insertRules(parent.rules, latestNativeParent);
      return latestNativeParent;
    }

    var ruleStr = rule.toString();
    if (!ruleStr) return false;
    var insertionIndex = getValidRuleInsertionIndex(nativeParent, index);

    var nativeRule = _insertRule(nativeParent, ruleStr, insertionIndex);

    if (nativeRule === false) {
      return false;
    }

    this.hasInsertedRules = true;
    this.refCssRule(rule, insertionIndex, nativeRule);
    return nativeRule;
  };

  _proto.refCssRule = function refCssRule(rule, index, cssRule) {
    rule.renderable = cssRule; // We only want to reference the top level rules, deleteRule API doesn't support removing nested rules
    // like rules inside media queries or keyframes

    if (rule.options.parent instanceof StyleSheet) {
      this.cssRules.splice(index, 0, cssRule);
    }
  }
  /**
   * Delete a rule.
   */
  ;

  _proto.deleteRule = function deleteRule(cssRule) {
    var sheet = this.element.sheet;
    var index = this.indexOf(cssRule);
    if (index === -1) return false;
    sheet.deleteRule(index);
    this.cssRules.splice(index, 1);
    return true;
  }
  /**
   * Get index of a CSS Rule.
   */
  ;

  _proto.indexOf = function indexOf(cssRule) {
    return this.cssRules.indexOf(cssRule);
  }
  /**
   * Generate a new CSS rule and replace the existing one.
   */
  ;

  _proto.replaceRule = function replaceRule(cssRule, rule) {
    var index = this.indexOf(cssRule);
    if (index === -1) return false;
    this.element.sheet.deleteRule(index);
    this.cssRules.splice(index, 1);
    return this.insertRule(rule, index);
  }
  /**
   * Get all rules elements.
   */
  ;

  _proto.getRules = function getRules() {
    return this.element.sheet.cssRules;
  };

  return DomRenderer;
}();

var instanceCounter = 0;

var Jss =
/*#__PURE__*/
function () {
  function Jss(options) {
    this.id = instanceCounter++;
    this.version = "10.10.0";
    this.plugins = new PluginsRegistry();
    this.options = {
      id: {
        minify: false
      },
      createGenerateId: createGenerateId,
      Renderer: is_in_browser__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z ? DomRenderer : null,
      plugins: []
    };
    this.generateId = createGenerateId({
      minify: false
    });

    for (var i = 0; i < plugins.length; i++) {
      this.plugins.use(plugins[i], {
        queue: 'internal'
      });
    }

    this.setup(options);
  }
  /**
   * Prepares various options, applies plugins.
   * Should not be used twice on the same instance, because there is no plugins
   * deduplication logic.
   */


  var _proto = Jss.prototype;

  _proto.setup = function setup(options) {
    if (options === void 0) {
      options = {};
    }

    if (options.createGenerateId) {
      this.options.createGenerateId = options.createGenerateId;
    }

    if (options.id) {
      this.options.id = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, this.options.id, options.id);
    }

    if (options.createGenerateId || options.id) {
      this.generateId = this.options.createGenerateId(this.options.id);
    }

    if (options.insertionPoint != null) this.options.insertionPoint = options.insertionPoint;

    if ('Renderer' in options) {
      this.options.Renderer = options.Renderer;
    } // eslint-disable-next-line prefer-spread


    if (options.plugins) this.use.apply(this, options.plugins);
    return this;
  }
  /**
   * Create a Style Sheet.
   */
  ;

  _proto.createStyleSheet = function createStyleSheet(styles, options) {
    if (options === void 0) {
      options = {};
    }

    var _options = options,
        index = _options.index;

    if (typeof index !== 'number') {
      index = sheets.index === 0 ? 0 : sheets.index + 1;
    }

    var sheet = new StyleSheet(styles, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, options, {
      jss: this,
      generateId: options.generateId || this.generateId,
      insertionPoint: this.options.insertionPoint,
      Renderer: this.options.Renderer,
      index: index
    }));
    this.plugins.onProcessSheet(sheet);
    return sheet;
  }
  /**
   * Detach the Style Sheet and remove it from the registry.
   */
  ;

  _proto.removeStyleSheet = function removeStyleSheet(sheet) {
    sheet.detach();
    sheets.remove(sheet);
    return this;
  }
  /**
   * Create a rule without a Style Sheet.
   * [Deprecated] will be removed in the next major version.
   */
  ;

  _proto.createRule = function createRule$1(name, style, options) {
    if (style === void 0) {
      style = {};
    }

    if (options === void 0) {
      options = {};
    }

    // Enable rule without name for inline styles.
    if (typeof name === 'object') {
      return this.createRule(undefined, name, style);
    }

    var ruleOptions = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, options, {
      name: name,
      jss: this,
      Renderer: this.options.Renderer
    });

    if (!ruleOptions.generateId) ruleOptions.generateId = this.generateId;
    if (!ruleOptions.classes) ruleOptions.classes = {};
    if (!ruleOptions.keyframes) ruleOptions.keyframes = {};

    var rule = createRule(name, style, ruleOptions);

    if (rule) this.plugins.onProcessRule(rule);
    return rule;
  }
  /**
   * Register plugin. Passed function will be invoked with a rule instance.
   */
  ;

  _proto.use = function use() {
    var _this = this;

    for (var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++) {
      plugins[_key] = arguments[_key];
    }

    plugins.forEach(function (plugin) {
      _this.plugins.use(plugin);
    });
    return this;
  };

  return Jss;
}();

var createJss = function createJss(options) {
  return new Jss(options);
};

/**
 * SheetsManager is like a WeakMap which is designed to count StyleSheet
 * instances and attach/detach automatically.
 * Used in react-jss.
 */

var SheetsManager =
/*#__PURE__*/
(/* unused pure expression or super */ null && (function () {
  function SheetsManager() {
    this.length = 0;
    this.sheets = new WeakMap();
  }

  var _proto = SheetsManager.prototype;

  _proto.get = function get(key) {
    var entry = this.sheets.get(key);
    return entry && entry.sheet;
  };

  _proto.add = function add(key, sheet) {
    if (this.sheets.has(key)) return;
    this.length++;
    this.sheets.set(key, {
      sheet: sheet,
      refs: 0
    });
  };

  _proto.manage = function manage(key) {
    var entry = this.sheets.get(key);

    if (entry) {
      if (entry.refs === 0) {
        entry.sheet.attach();
      }

      entry.refs++;
      return entry.sheet;
    }

    warning(false, "[JSS] SheetsManager: can't find sheet to manage");
    return undefined;
  };

  _proto.unmanage = function unmanage(key) {
    var entry = this.sheets.get(key);

    if (entry) {
      if (entry.refs > 0) {
        entry.refs--;
        if (entry.refs === 0) entry.sheet.detach();
      }
    } else {
      warning(false, "SheetsManager: can't find sheet to unmanage");
    }
  };

  _createClass(SheetsManager, [{
    key: "size",
    get: function get() {
      return this.length;
    }
  }]);

  return SheetsManager;
}()));

/**
* Export a constant indicating if this browser has CSSTOM support.
* https://developers.google.com/web/updates/2018/03/cssom
*/
var hasCSSTOMSupport = typeof CSS === 'object' && CSS != null && 'number' in CSS;

/**
 * Extracts a styles object with only props that contain function values.
 */
function getDynamicStyles(styles) {
  var to = null;

  for (var key in styles) {
    var value = styles[key];
    var type = typeof value;

    if (type === 'function') {
      if (!to) to = {};
      to[key] = value;
    } else if (type === 'object' && value !== null && !Array.isArray(value)) {
      var extracted = getDynamicStyles(value);

      if (extracted) {
        if (!to) to = {};
        to[key] = extracted;
      }
    }
  }

  return to;
}

/**
 * A better abstraction over CSS.
 *
 * @copyright Oleg Isonen (Slobodskoi) / Isonen 2014-present
 * @website https://github.com/cssinjs/jss
 * @license MIT
 */
var index = createJss();

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (index)));



/***/ }),

/***/ 5233:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Jc": function() { return /* reexport */ appWithTranslation; },
  "ag": function() { return /* reexport */ globalI18n; },
  "$G": function() { return /* reexport */ es/* useTranslation */.$G; }
});

// UNUSED EXPORTS: I18nContext, Trans, Translation, withTranslation

// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/index.js + 15 modules
var es = __webpack_require__(67421);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(4942);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(8679);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(74902);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(71002);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(97685);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(45987);
;// CONCATENATED MODULE: ./node_modules/next-i18next/dist/esm/config/defaultConfig.js
var DEFAULT_LOCALE = 'en';
var LOCALES = ['en'];
var DEFAULT_NAMESPACE = 'common';
var LOCALE_PATH = './public/locales';
var LOCALE_STRUCTURE = '{{lng}}/{{ns}}';
var LOCALE_EXTENSION = 'json';
var defaultConfig = {
  defaultNS: DEFAULT_NAMESPACE,
  errorStackTraceLimit: 0,
  i18n: {
    defaultLocale: DEFAULT_LOCALE,
    locales: LOCALES
  },
  get initImmediate() {
    // i18next < 24
    return typeof window !== 'undefined';
  },
  get initAsync() {
    return typeof window !== 'undefined';
  },
  interpolation: {
    escapeValue: false
  },
  load: 'currentOnly',
  localeExtension: LOCALE_EXTENSION,
  localePath: LOCALE_PATH,
  localeStructure: LOCALE_STRUCTURE,
  react: {
    useSuspense: false
  },
  reloadOnPrerender: false,
  serializeConfig: true,
  use: []
};
;// CONCATENATED MODULE: ./node_modules/next-i18next/dist/esm/utils.js



var getFallbackForLng = function getFallbackForLng(lng, fallbackLng) {
  if (typeof fallbackLng === 'string') {
    return [fallbackLng];
  }
  if (Array.isArray(fallbackLng)) {
    return fallbackLng;
  }
  if (_typeof(fallbackLng) === 'object') {
    var fallbackList = fallbackLng[lng];
    var fallbackDefault = fallbackLng["default"];
    return [].concat(_toConsumableArray(fallbackList !== null && fallbackList !== void 0 ? fallbackList : []), _toConsumableArray(fallbackDefault !== null && fallbackDefault !== void 0 ? fallbackDefault : []));
  }
  if (typeof fallbackLng === 'function') {
    return getFallbackForLng(lng, fallbackLng(lng));
  }
  return [];
};
var unique = function unique(list) {
  return Array.from(new Set(list));
};

/**
 * This hook behaves like `useLayoutEffect` on the client,
 * and `useEffect` on the server(no effect).
 *
 * Since using `useLayoutEffect` on the server cause warning messages in nextjs,
 * this hook is workaround for that.
 */
var useIsomorphicLayoutEffect = typeof window !== 'undefined' ? react.useLayoutEffect : react.useEffect;
;// CONCATENATED MODULE: ./node_modules/next-i18next/dist/esm/config/createConfig.js





var _excluded = ["i18n"],
  _excluded2 = ["i18n"];
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }


var deepMergeObjects = ['backend', 'detection'];
var createConfig = function createConfig(userConfig) {
  var _userConfig$interpola, _userConfig$interpola2, _userConfig$use;
  if (typeof (userConfig === null || userConfig === void 0 ? void 0 : userConfig.lng) !== 'string') {
    throw new Error('config.lng was not passed into createConfig');
  }

  //
  // Initial merge of default and user-provided config
  //
  var userI18n = userConfig.i18n,
    userConfigStripped = (0,objectWithoutProperties/* default */.Z)(userConfig, _excluded);
  var defaultI18n = defaultConfig.i18n,
    defaultConfigStripped = (0,objectWithoutProperties/* default */.Z)(defaultConfig, _excluded2);
  var combinedConfig = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, defaultConfigStripped), userConfigStripped), defaultI18n), userI18n);
  var defaultNS = combinedConfig.defaultNS,
    lng = combinedConfig.lng,
    localeExtension = combinedConfig.localeExtension,
    localePath = combinedConfig.localePath,
    nonExplicitSupportedLngs = combinedConfig.nonExplicitSupportedLngs;
  var locales = combinedConfig.locales.filter(function (l) {
    return l !== 'default';
  });

  /**
   * Skips translation file resolution while in cimode
   * https://github.com/i18next/next-i18next/pull/851#discussion_r503113620
   */
  if (lng === 'cimode') {
    return combinedConfig;
  }
  if (typeof combinedConfig.fallbackLng === 'undefined') {
    combinedConfig.fallbackLng = combinedConfig.defaultLocale;
    if (combinedConfig.fallbackLng === 'default') {
      var _locales = (0,slicedToArray/* default */.Z)(locales, 1);
      combinedConfig.fallbackLng = _locales[0];
    }
  }
  var userPrefix = userConfig === null || userConfig === void 0 || (_userConfig$interpola = userConfig.interpolation) === null || _userConfig$interpola === void 0 ? void 0 : _userConfig$interpola.prefix;
  var userSuffix = userConfig === null || userConfig === void 0 || (_userConfig$interpola2 = userConfig.interpolation) === null || _userConfig$interpola2 === void 0 ? void 0 : _userConfig$interpola2.suffix;
  var prefix = userPrefix !== null && userPrefix !== void 0 ? userPrefix : '{{';
  var suffix = userSuffix !== null && userSuffix !== void 0 ? userSuffix : '}}';
  if (typeof (userConfig === null || userConfig === void 0 ? void 0 : userConfig.localeStructure) !== 'string' && (userPrefix || userSuffix)) {
    combinedConfig.localeStructure = "".concat(prefix, "lng").concat(suffix, "/").concat(prefix, "ns").concat(suffix);
  }
  var fallbackLng = combinedConfig.fallbackLng,
    localeStructure = combinedConfig.localeStructure;
  if (nonExplicitSupportedLngs) {
    var createFallbackObject = function createFallbackObject(acc, l) {
      var _l$split = l.split('-'),
        _l$split2 = (0,slicedToArray/* default */.Z)(_l$split, 1),
        locale = _l$split2[0];
      acc[l] = [locale];
      return acc;
    };
    if (typeof fallbackLng === 'string') {
      combinedConfig.fallbackLng = combinedConfig.locales.filter(function (l) {
        return l.includes('-');
      }).reduce(createFallbackObject, {
        "default": [fallbackLng]
      });
    } else if (Array.isArray(fallbackLng)) {
      combinedConfig.fallbackLng = combinedConfig.locales.filter(function (l) {
        return l.includes('-');
      }).reduce(createFallbackObject, {
        "default": fallbackLng
      });
    } else if ((0,esm_typeof/* default */.Z)(fallbackLng) === 'object') {
      combinedConfig.fallbackLng = Object.entries(combinedConfig.fallbackLng).reduce(function (acc, _ref) {
        var _ref2 = (0,slicedToArray/* default */.Z)(_ref, 2),
          l = _ref2[0],
          f = _ref2[1];
        acc[l] = l.includes('-') ? unique([l.split('-')[0]].concat((0,toConsumableArray/* default */.Z)(f))) : f;
        return acc;
      }, fallbackLng);
    } else if (typeof fallbackLng === 'function') {
      throw new Error('If nonExplicitSupportedLngs is true, no functions are allowed for fallbackLng');
    }
  }
  var hasCustomBackend = userConfig === null || userConfig === void 0 || (_userConfig$use = userConfig.use) === null || _userConfig$use === void 0 ? void 0 : _userConfig$use.some(function (b) {
    return b.type === 'backend';
  });
  if (false) { var getNamespaces, _defaultFallbackNSExists, _fallback, _defaultNSExists, _defaultNSPath, defaultFallbackNSExists, fallback, defaultNSExists, defaultNSPath, defaultFile, defaultLocaleStructure, path, fs; } else {
    //
    // Set client side backend, if there is no custom backend
    //
    if (!hasCustomBackend) {
      if (typeof localePath === 'string') {
        combinedConfig.backend = {
          addPath: "".concat(localePath, "/").concat(localeStructure, ".missing.").concat(localeExtension),
          loadPath: "".concat(localePath, "/").concat(localeStructure, ".").concat(localeExtension)
        };
      } else if (typeof localePath === 'function') {
        combinedConfig.backend = {
          addPath: function addPath(locale, namespace) {
            return localePath(locale, namespace, true);
          },
          loadPath: function loadPath(locale, namespace) {
            return localePath(locale, namespace, false);
          }
        };
      }
    }
    if (typeof combinedConfig.ns !== 'string' && !Array.isArray(combinedConfig.ns)) {
      combinedConfig.ns = [defaultNS];
    }
  }

  //
  // Deep merge with overwrite - goes last
  //
  deepMergeObjects.forEach(function (obj) {
    if (userConfig[obj]) {
      combinedConfig[obj] = _objectSpread(_objectSpread({}, combinedConfig[obj]), userConfig[obj]);
    }
  });
  return combinedConfig;
};
;// CONCATENATED MODULE: ./node_modules/i18next/dist/esm/i18next.js
const isString = obj => typeof obj === 'string';
const defer = () => {
  let res;
  let rej;
  const promise = new Promise((resolve, reject) => {
    res = resolve;
    rej = reject;
  });
  promise.resolve = res;
  promise.reject = rej;
  return promise;
};
const makeString = object => {
  if (object == null) return '';
  return '' + object;
};
const copy = (a, s, t) => {
  a.forEach(m => {
    if (s[m]) t[m] = s[m];
  });
};
const lastOfPathSeparatorRegExp = /###/g;
const cleanKey = key => key && key.indexOf('###') > -1 ? key.replace(lastOfPathSeparatorRegExp, '.') : key;
const canNotTraverseDeeper = object => !object || isString(object);
const getLastOfPath = (object, path, Empty) => {
  const stack = !isString(path) ? path : path.split('.');
  let stackIndex = 0;
  while (stackIndex < stack.length - 1) {
    if (canNotTraverseDeeper(object)) return {};
    const key = cleanKey(stack[stackIndex]);
    if (!object[key] && Empty) object[key] = new Empty();
    if (Object.prototype.hasOwnProperty.call(object, key)) {
      object = object[key];
    } else {
      object = {};
    }
    ++stackIndex;
  }
  if (canNotTraverseDeeper(object)) return {};
  return {
    obj: object,
    k: cleanKey(stack[stackIndex])
  };
};
const setPath = (object, path, newValue) => {
  const {
    obj,
    k
  } = getLastOfPath(object, path, Object);
  if (obj !== undefined || path.length === 1) {
    obj[k] = newValue;
    return;
  }
  let e = path[path.length - 1];
  let p = path.slice(0, path.length - 1);
  let last = getLastOfPath(object, p, Object);
  while (last.obj === undefined && p.length) {
    e = `${p[p.length - 1]}.${e}`;
    p = p.slice(0, p.length - 1);
    last = getLastOfPath(object, p, Object);
    if (last && last.obj && typeof last.obj[`${last.k}.${e}`] !== 'undefined') {
      last.obj = undefined;
    }
  }
  last.obj[`${last.k}.${e}`] = newValue;
};
const pushPath = (object, path, newValue, concat) => {
  const {
    obj,
    k
  } = getLastOfPath(object, path, Object);
  obj[k] = obj[k] || [];
  obj[k].push(newValue);
};
const getPath = (object, path) => {
  const {
    obj,
    k
  } = getLastOfPath(object, path);
  if (!obj) return undefined;
  return obj[k];
};
const getPathWithDefaults = (data, defaultData, key) => {
  const value = getPath(data, key);
  if (value !== undefined) {
    return value;
  }
  return getPath(defaultData, key);
};
const deepExtend = (target, source, overwrite) => {
  for (const prop in source) {
    if (prop !== '__proto__' && prop !== 'constructor') {
      if (prop in target) {
        if (isString(target[prop]) || target[prop] instanceof String || isString(source[prop]) || source[prop] instanceof String) {
          if (overwrite) target[prop] = source[prop];
        } else {
          deepExtend(target[prop], source[prop], overwrite);
        }
      } else {
        target[prop] = source[prop];
      }
    }
  }
  return target;
};
const regexEscape = str => str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
var _entityMap = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
  '/': '&#x2F;'
};
const i18next_escape = data => {
  if (isString(data)) {
    return data.replace(/[&<>"'\/]/g, s => _entityMap[s]);
  }
  return data;
};
class RegExpCache {
  constructor(capacity) {
    this.capacity = capacity;
    this.regExpMap = new Map();
    this.regExpQueue = [];
  }
  getRegExp(pattern) {
    const regExpFromCache = this.regExpMap.get(pattern);
    if (regExpFromCache !== undefined) {
      return regExpFromCache;
    }
    const regExpNew = new RegExp(pattern);
    if (this.regExpQueue.length === this.capacity) {
      this.regExpMap.delete(this.regExpQueue.shift());
    }
    this.regExpMap.set(pattern, regExpNew);
    this.regExpQueue.push(pattern);
    return regExpNew;
  }
}
const chars = [' ', ',', '?', '!', ';'];
const looksLikeObjectPathRegExpCache = new RegExpCache(20);
const looksLikeObjectPath = (key, nsSeparator, keySeparator) => {
  nsSeparator = nsSeparator || '';
  keySeparator = keySeparator || '';
  const possibleChars = chars.filter(c => nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0);
  if (possibleChars.length === 0) return true;
  const r = looksLikeObjectPathRegExpCache.getRegExp(`(${possibleChars.map(c => c === '?' ? '\\?' : c).join('|')})`);
  let matched = !r.test(key);
  if (!matched) {
    const ki = key.indexOf(keySeparator);
    if (ki > 0 && !r.test(key.substring(0, ki))) {
      matched = true;
    }
  }
  return matched;
};
const deepFind = function (obj, path) {
  let keySeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.';
  if (!obj) return undefined;
  if (obj[path]) return obj[path];
  const tokens = path.split(keySeparator);
  let current = obj;
  for (let i = 0; i < tokens.length;) {
    if (!current || typeof current !== 'object') {
      return undefined;
    }
    let next;
    let nextPath = '';
    for (let j = i; j < tokens.length; ++j) {
      if (j !== i) {
        nextPath += keySeparator;
      }
      nextPath += tokens[j];
      next = current[nextPath];
      if (next !== undefined) {
        if (['string', 'number', 'boolean'].indexOf(typeof next) > -1 && j < tokens.length - 1) {
          continue;
        }
        i += j - i + 1;
        break;
      }
    }
    current = next;
  }
  return current;
};
const getCleanedCode = code => code && code.replace('_', '-');

const consoleLogger = {
  type: 'logger',
  log(args) {
    this.output('log', args);
  },
  warn(args) {
    this.output('warn', args);
  },
  error(args) {
    this.output('error', args);
  },
  output(type, args) {
    if (console && console[type]) console[type].apply(console, args);
  }
};
class Logger {
  constructor(concreteLogger) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.init(concreteLogger, options);
  }
  init(concreteLogger) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.prefix = options.prefix || 'i18next:';
    this.logger = concreteLogger || consoleLogger;
    this.options = options;
    this.debug = options.debug;
  }
  log() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return this.forward(args, 'log', '', true);
  }
  warn() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    return this.forward(args, 'warn', '', true);
  }
  error() {
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }
    return this.forward(args, 'error', '');
  }
  deprecate() {
    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }
    return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
  }
  forward(args, lvl, prefix, debugOnly) {
    if (debugOnly && !this.debug) return null;
    if (isString(args[0])) args[0] = `${prefix}${this.prefix} ${args[0]}`;
    return this.logger[lvl](args);
  }
  create(moduleName) {
    return new Logger(this.logger, {
      ...{
        prefix: `${this.prefix}:${moduleName}:`
      },
      ...this.options
    });
  }
  clone(options) {
    options = options || this.options;
    options.prefix = options.prefix || this.prefix;
    return new Logger(this.logger, options);
  }
}
var baseLogger = new Logger();

class EventEmitter {
  constructor() {
    this.observers = {};
  }
  on(events, listener) {
    events.split(' ').forEach(event => {
      if (!this.observers[event]) this.observers[event] = new Map();
      const numListeners = this.observers[event].get(listener) || 0;
      this.observers[event].set(listener, numListeners + 1);
    });
    return this;
  }
  off(event, listener) {
    if (!this.observers[event]) return;
    if (!listener) {
      delete this.observers[event];
      return;
    }
    this.observers[event].delete(listener);
  }
  emit(event) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    if (this.observers[event]) {
      const cloned = Array.from(this.observers[event].entries());
      cloned.forEach(_ref => {
        let [observer, numTimesAdded] = _ref;
        for (let i = 0; i < numTimesAdded; i++) {
          observer(...args);
        }
      });
    }
    if (this.observers['*']) {
      const cloned = Array.from(this.observers['*'].entries());
      cloned.forEach(_ref2 => {
        let [observer, numTimesAdded] = _ref2;
        for (let i = 0; i < numTimesAdded; i++) {
          observer.apply(observer, [event, ...args]);
        }
      });
    }
  }
}

class ResourceStore extends EventEmitter {
  constructor(data) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      ns: ['translation'],
      defaultNS: 'translation'
    };
    super();
    this.data = data || {};
    this.options = options;
    if (this.options.keySeparator === undefined) {
      this.options.keySeparator = '.';
    }
    if (this.options.ignoreJSONStructure === undefined) {
      this.options.ignoreJSONStructure = true;
    }
  }
  addNamespaces(ns) {
    if (this.options.ns.indexOf(ns) < 0) {
      this.options.ns.push(ns);
    }
  }
  removeNamespaces(ns) {
    const index = this.options.ns.indexOf(ns);
    if (index > -1) {
      this.options.ns.splice(index, 1);
    }
  }
  getResource(lng, ns, key) {
    let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
    const ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
    let path;
    if (lng.indexOf('.') > -1) {
      path = lng.split('.');
    } else {
      path = [lng, ns];
      if (key) {
        if (Array.isArray(key)) {
          path.push(...key);
        } else if (isString(key) && keySeparator) {
          path.push(...key.split(keySeparator));
        } else {
          path.push(key);
        }
      }
    }
    const result = getPath(this.data, path);
    if (!result && !ns && !key && lng.indexOf('.') > -1) {
      lng = path[0];
      ns = path[1];
      key = path.slice(2).join('.');
    }
    if (result || !ignoreJSONStructure || !isString(key)) return result;
    return deepFind(this.data && this.data[lng] && this.data[lng][ns], key, keySeparator);
  }
  addResource(lng, ns, key, value) {
    let options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
      silent: false
    };
    const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
    let path = [lng, ns];
    if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
    if (lng.indexOf('.') > -1) {
      path = lng.split('.');
      value = ns;
      ns = path[1];
    }
    this.addNamespaces(ns);
    setPath(this.data, path, value);
    if (!options.silent) this.emit('added', lng, ns, key, value);
  }
  addResources(lng, ns, resources) {
    let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
      silent: false
    };
    for (const m in resources) {
      if (isString(resources[m]) || Array.isArray(resources[m])) this.addResource(lng, ns, m, resources[m], {
        silent: true
      });
    }
    if (!options.silent) this.emit('added', lng, ns, resources);
  }
  addResourceBundle(lng, ns, resources, deep, overwrite) {
    let options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
      silent: false,
      skipCopy: false
    };
    let path = [lng, ns];
    if (lng.indexOf('.') > -1) {
      path = lng.split('.');
      deep = resources;
      resources = ns;
      ns = path[1];
    }
    this.addNamespaces(ns);
    let pack = getPath(this.data, path) || {};
    if (!options.skipCopy) resources = JSON.parse(JSON.stringify(resources));
    if (deep) {
      deepExtend(pack, resources, overwrite);
    } else {
      pack = {
        ...pack,
        ...resources
      };
    }
    setPath(this.data, path, pack);
    if (!options.silent) this.emit('added', lng, ns, resources);
  }
  removeResourceBundle(lng, ns) {
    if (this.hasResourceBundle(lng, ns)) {
      delete this.data[lng][ns];
    }
    this.removeNamespaces(ns);
    this.emit('removed', lng, ns);
  }
  hasResourceBundle(lng, ns) {
    return this.getResource(lng, ns) !== undefined;
  }
  getResourceBundle(lng, ns) {
    if (!ns) ns = this.options.defaultNS;
    if (this.options.compatibilityAPI === 'v1') return {
      ...{},
      ...this.getResource(lng, ns)
    };
    return this.getResource(lng, ns);
  }
  getDataByLanguage(lng) {
    return this.data[lng];
  }
  hasLanguageSomeTranslations(lng) {
    const data = this.getDataByLanguage(lng);
    const n = data && Object.keys(data) || [];
    return !!n.find(v => data[v] && Object.keys(data[v]).length > 0);
  }
  toJSON() {
    return this.data;
  }
}

var postProcessor = {
  processors: {},
  addPostProcessor(module) {
    this.processors[module.name] = module;
  },
  handle(processors, value, key, options, translator) {
    processors.forEach(processor => {
      if (this.processors[processor]) value = this.processors[processor].process(value, key, options, translator);
    });
    return value;
  }
};

const checkedLoadedFor = {};
class Translator extends EventEmitter {
  constructor(services) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    super();
    copy(['resourceStore', 'languageUtils', 'pluralResolver', 'interpolator', 'backendConnector', 'i18nFormat', 'utils'], services, this);
    this.options = options;
    if (this.options.keySeparator === undefined) {
      this.options.keySeparator = '.';
    }
    this.logger = baseLogger.create('translator');
  }
  changeLanguage(lng) {
    if (lng) this.language = lng;
  }
  exists(key) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      interpolation: {}
    };
    if (key === undefined || key === null) {
      return false;
    }
    const resolved = this.resolve(key, options);
    return resolved && resolved.res !== undefined;
  }
  extractFromKey(key, options) {
    let nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
    if (nsSeparator === undefined) nsSeparator = ':';
    const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
    let namespaces = options.ns || this.options.defaultNS || [];
    const wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
    const seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !options.keySeparator && !this.options.userDefinedNsSeparator && !options.nsSeparator && !looksLikeObjectPath(key, nsSeparator, keySeparator);
    if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
      const m = key.match(this.interpolator.nestingRegexp);
      if (m && m.length > 0) {
        return {
          key,
          namespaces: isString(namespaces) ? [namespaces] : namespaces
        };
      }
      const parts = key.split(nsSeparator);
      if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
      key = parts.join(keySeparator);
    }
    return {
      key,
      namespaces: isString(namespaces) ? [namespaces] : namespaces
    };
  }
  translate(keys, options, lastKey) {
    if (typeof options !== 'object' && this.options.overloadTranslationOptionHandler) {
      options = this.options.overloadTranslationOptionHandler(arguments);
    }
    if (typeof options === 'object') options = {
      ...options
    };
    if (!options) options = {};
    if (keys === undefined || keys === null) return '';
    if (!Array.isArray(keys)) keys = [String(keys)];
    const returnDetails = options.returnDetails !== undefined ? options.returnDetails : this.options.returnDetails;
    const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
    const {
      key,
      namespaces
    } = this.extractFromKey(keys[keys.length - 1], options);
    const namespace = namespaces[namespaces.length - 1];
    const lng = options.lng || this.language;
    const appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (lng && lng.toLowerCase() === 'cimode') {
      if (appendNamespaceToCIMode) {
        const nsSeparator = options.nsSeparator || this.options.nsSeparator;
        if (returnDetails) {
          return {
            res: `${namespace}${nsSeparator}${key}`,
            usedKey: key,
            exactUsedKey: key,
            usedLng: lng,
            usedNS: namespace,
            usedParams: this.getUsedParamsDetails(options)
          };
        }
        return `${namespace}${nsSeparator}${key}`;
      }
      if (returnDetails) {
        return {
          res: key,
          usedKey: key,
          exactUsedKey: key,
          usedLng: lng,
          usedNS: namespace,
          usedParams: this.getUsedParamsDetails(options)
        };
      }
      return key;
    }
    const resolved = this.resolve(keys, options);
    let res = resolved && resolved.res;
    const resUsedKey = resolved && resolved.usedKey || key;
    const resExactUsedKey = resolved && resolved.exactUsedKey || key;
    const resType = Object.prototype.toString.apply(res);
    const noObject = ['[object Number]', '[object Function]', '[object RegExp]'];
    const joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
    const handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
    const handleAsObject = !isString(res) && typeof res !== 'boolean' && typeof res !== 'number';
    if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(isString(joinArrays) && Array.isArray(res))) {
      if (!options.returnObjects && !this.options.returnObjects) {
        if (!this.options.returnedObjectHandler) {
          this.logger.warn('accessing an object - but returnObjects options is not enabled!');
        }
        const r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, {
          ...options,
          ns: namespaces
        }) : `key '${key} (${this.language})' returned an object instead of string.`;
        if (returnDetails) {
          resolved.res = r;
          resolved.usedParams = this.getUsedParamsDetails(options);
          return resolved;
        }
        return r;
      }
      if (keySeparator) {
        const resTypeIsArray = Array.isArray(res);
        const copy = resTypeIsArray ? [] : {};
        const newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
        for (const m in res) {
          if (Object.prototype.hasOwnProperty.call(res, m)) {
            const deepKey = `${newKeyToUse}${keySeparator}${m}`;
            copy[m] = this.translate(deepKey, {
              ...options,
              ...{
                joinArrays: false,
                ns: namespaces
              }
            });
            if (copy[m] === deepKey) copy[m] = res[m];
          }
        }
        res = copy;
      }
    } else if (handleAsObjectInI18nFormat && isString(joinArrays) && Array.isArray(res)) {
      res = res.join(joinArrays);
      if (res) res = this.extendTranslation(res, keys, options, lastKey);
    } else {
      let usedDefault = false;
      let usedKey = false;
      const needsPluralHandling = options.count !== undefined && !isString(options.count);
      const hasDefaultValue = Translator.hasDefaultValue(options);
      const defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, options) : '';
      const defaultValueSuffixOrdinalFallback = options.ordinal && needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, {
        ordinal: false
      }) : '';
      const needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && this.pluralResolver.shouldUseIntlApi();
      const defaultValue = needsZeroSuffixLookup && options[`defaultValue${this.options.pluralSeparator}zero`] || options[`defaultValue${defaultValueSuffix}`] || options[`defaultValue${defaultValueSuffixOrdinalFallback}`] || options.defaultValue;
      if (!this.isValidLookup(res) && hasDefaultValue) {
        usedDefault = true;
        res = defaultValue;
      }
      if (!this.isValidLookup(res)) {
        usedKey = true;
        res = key;
      }
      const missingKeyNoValueFallbackToKey = options.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
      const resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
      const updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
      if (usedKey || usedDefault || updateMissing) {
        this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? defaultValue : res);
        if (keySeparator) {
          const fk = this.resolve(key, {
            ...options,
            keySeparator: false
          });
          if (fk && fk.res) this.logger.warn('Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.');
        }
        let lngs = [];
        const fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
        if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) {
          for (let i = 0; i < fallbackLngs.length; i++) {
            lngs.push(fallbackLngs[i]);
          }
        } else if (this.options.saveMissingTo === 'all') {
          lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
        } else {
          lngs.push(options.lng || this.language);
        }
        const send = (l, k, specificDefaultValue) => {
          const defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
          if (this.options.missingKeyHandler) {
            this.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, options);
          } else if (this.backendConnector && this.backendConnector.saveMissing) {
            this.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, options);
          }
          this.emit('missingKey', l, namespace, k, res);
        };
        if (this.options.saveMissing) {
          if (this.options.saveMissingPlurals && needsPluralHandling) {
            lngs.forEach(language => {
              const suffixes = this.pluralResolver.getSuffixes(language, options);
              if (needsZeroSuffixLookup && options[`defaultValue${this.options.pluralSeparator}zero`] && suffixes.indexOf(`${this.options.pluralSeparator}zero`) < 0) {
                suffixes.push(`${this.options.pluralSeparator}zero`);
              }
              suffixes.forEach(suffix => {
                send([language], key + suffix, options[`defaultValue${suffix}`] || defaultValue);
              });
            });
          } else {
            send(lngs, key, defaultValue);
          }
        }
      }
      res = this.extendTranslation(res, keys, options, resolved, lastKey);
      if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = `${namespace}:${key}`;
      if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) {
        if (this.options.compatibilityAPI !== 'v1') {
          res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${namespace}:${key}` : key, usedDefault ? res : undefined);
        } else {
          res = this.options.parseMissingKeyHandler(res);
        }
      }
    }
    if (returnDetails) {
      resolved.res = res;
      resolved.usedParams = this.getUsedParamsDetails(options);
      return resolved;
    }
    return res;
  }
  extendTranslation(res, key, options, resolved, lastKey) {
    var _this = this;
    if (this.i18nFormat && this.i18nFormat.parse) {
      res = this.i18nFormat.parse(res, {
        ...this.options.interpolation.defaultVariables,
        ...options
      }, options.lng || this.language || resolved.usedLng, resolved.usedNS, resolved.usedKey, {
        resolved
      });
    } else if (!options.skipInterpolation) {
      if (options.interpolation) this.interpolator.init({
        ...options,
        ...{
          interpolation: {
            ...this.options.interpolation,
            ...options.interpolation
          }
        }
      });
      const skipOnVariables = isString(res) && (options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
      let nestBef;
      if (skipOnVariables) {
        const nb = res.match(this.interpolator.nestingRegexp);
        nestBef = nb && nb.length;
      }
      let data = options.replace && !isString(options.replace) ? options.replace : options;
      if (this.options.interpolation.defaultVariables) data = {
        ...this.options.interpolation.defaultVariables,
        ...data
      };
      res = this.interpolator.interpolate(res, data, options.lng || this.language || resolved.usedLng, options);
      if (skipOnVariables) {
        const na = res.match(this.interpolator.nestingRegexp);
        const nestAft = na && na.length;
        if (nestBef < nestAft) options.nest = false;
      }
      if (!options.lng && this.options.compatibilityAPI !== 'v1' && resolved && resolved.res) options.lng = this.language || resolved.usedLng;
      if (options.nest !== false) res = this.interpolator.nest(res, function () {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        if (lastKey && lastKey[0] === args[0] && !options.context) {
          _this.logger.warn(`It seems you are nesting recursively key: ${args[0]} in key: ${key[0]}`);
          return null;
        }
        return _this.translate(...args, key);
      }, options);
      if (options.interpolation) this.interpolator.reset();
    }
    const postProcess = options.postProcess || this.options.postProcess;
    const postProcessorNames = isString(postProcess) ? [postProcess] : postProcess;
    if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) {
      res = postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? {
        i18nResolved: {
          ...resolved,
          usedParams: this.getUsedParamsDetails(options)
        },
        ...options
      } : options, this);
    }
    return res;
  }
  resolve(keys) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    let found;
    let usedKey;
    let exactUsedKey;
    let usedLng;
    let usedNS;
    if (isString(keys)) keys = [keys];
    keys.forEach(k => {
      if (this.isValidLookup(found)) return;
      const extracted = this.extractFromKey(k, options);
      const key = extracted.key;
      usedKey = key;
      let namespaces = extracted.namespaces;
      if (this.options.fallbackNS) namespaces = namespaces.concat(this.options.fallbackNS);
      const needsPluralHandling = options.count !== undefined && !isString(options.count);
      const needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && this.pluralResolver.shouldUseIntlApi();
      const needsContextHandling = options.context !== undefined && (isString(options.context) || typeof options.context === 'number') && options.context !== '';
      const codes = options.lngs ? options.lngs : this.languageUtils.toResolveHierarchy(options.lng || this.language, options.fallbackLng);
      namespaces.forEach(ns => {
        if (this.isValidLookup(found)) return;
        usedNS = ns;
        if (!checkedLoadedFor[`${codes[0]}-${ns}`] && this.utils && this.utils.hasLoadedNamespace && !this.utils.hasLoadedNamespace(usedNS)) {
          checkedLoadedFor[`${codes[0]}-${ns}`] = true;
          this.logger.warn(`key "${usedKey}" for languages "${codes.join(', ')}" won't get resolved as namespace "${usedNS}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
        }
        codes.forEach(code => {
          if (this.isValidLookup(found)) return;
          usedLng = code;
          const finalKeys = [key];
          if (this.i18nFormat && this.i18nFormat.addLookupKeys) {
            this.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
          } else {
            let pluralSuffix;
            if (needsPluralHandling) pluralSuffix = this.pluralResolver.getSuffix(code, options.count, options);
            const zeroSuffix = `${this.options.pluralSeparator}zero`;
            const ordinalPrefix = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
            if (needsPluralHandling) {
              finalKeys.push(key + pluralSuffix);
              if (options.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) {
                finalKeys.push(key + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
              }
              if (needsZeroSuffixLookup) {
                finalKeys.push(key + zeroSuffix);
              }
            }
            if (needsContextHandling) {
              const contextKey = `${key}${this.options.contextSeparator}${options.context}`;
              finalKeys.push(contextKey);
              if (needsPluralHandling) {
                finalKeys.push(contextKey + pluralSuffix);
                if (options.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) {
                  finalKeys.push(contextKey + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                }
                if (needsZeroSuffixLookup) {
                  finalKeys.push(contextKey + zeroSuffix);
                }
              }
            }
          }
          let possibleKey;
          while (possibleKey = finalKeys.pop()) {
            if (!this.isValidLookup(found)) {
              exactUsedKey = possibleKey;
              found = this.getResource(code, ns, possibleKey, options);
            }
          }
        });
      });
    });
    return {
      res: found,
      usedKey,
      exactUsedKey,
      usedLng,
      usedNS
    };
  }
  isValidLookup(res) {
    return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
  }
  getResource(code, ns, key) {
    let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
    return this.resourceStore.getResource(code, ns, key, options);
  }
  getUsedParamsDetails() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const optionsKeys = ['defaultValue', 'ordinal', 'context', 'replace', 'lng', 'lngs', 'fallbackLng', 'ns', 'keySeparator', 'nsSeparator', 'returnObjects', 'returnDetails', 'joinArrays', 'postProcess', 'interpolation'];
    const useOptionsReplaceForData = options.replace && !isString(options.replace);
    let data = useOptionsReplaceForData ? options.replace : options;
    if (useOptionsReplaceForData && typeof options.count !== 'undefined') {
      data.count = options.count;
    }
    if (this.options.interpolation.defaultVariables) {
      data = {
        ...this.options.interpolation.defaultVariables,
        ...data
      };
    }
    if (!useOptionsReplaceForData) {
      data = {
        ...data
      };
      for (const key of optionsKeys) {
        delete data[key];
      }
    }
    return data;
  }
  static hasDefaultValue(options) {
    const prefix = 'defaultValue';
    for (const option in options) {
      if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) {
        return true;
      }
    }
    return false;
  }
}

const capitalize = string => string.charAt(0).toUpperCase() + string.slice(1);
class LanguageUtil {
  constructor(options) {
    this.options = options;
    this.supportedLngs = this.options.supportedLngs || false;
    this.logger = baseLogger.create('languageUtils');
  }
  getScriptPartFromCode(code) {
    code = getCleanedCode(code);
    if (!code || code.indexOf('-') < 0) return null;
    const p = code.split('-');
    if (p.length === 2) return null;
    p.pop();
    if (p[p.length - 1].toLowerCase() === 'x') return null;
    return this.formatLanguageCode(p.join('-'));
  }
  getLanguagePartFromCode(code) {
    code = getCleanedCode(code);
    if (!code || code.indexOf('-') < 0) return code;
    const p = code.split('-');
    return this.formatLanguageCode(p[0]);
  }
  formatLanguageCode(code) {
    if (isString(code) && code.indexOf('-') > -1) {
      if (typeof Intl !== 'undefined' && typeof Intl.getCanonicalLocales !== 'undefined') {
        try {
          let formattedCode = Intl.getCanonicalLocales(code)[0];
          if (formattedCode && this.options.lowerCaseLng) {
            formattedCode = formattedCode.toLowerCase();
          }
          if (formattedCode) return formattedCode;
        } catch (e) {}
      }
      const specialCases = ['hans', 'hant', 'latn', 'cyrl', 'cans', 'mong', 'arab'];
      let p = code.split('-');
      if (this.options.lowerCaseLng) {
        p = p.map(part => part.toLowerCase());
      } else if (p.length === 2) {
        p[0] = p[0].toLowerCase();
        p[1] = p[1].toUpperCase();
        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
      } else if (p.length === 3) {
        p[0] = p[0].toLowerCase();
        if (p[1].length === 2) p[1] = p[1].toUpperCase();
        if (p[0] !== 'sgn' && p[2].length === 2) p[2] = p[2].toUpperCase();
        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
        if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = capitalize(p[2].toLowerCase());
      }
      return p.join('-');
    }
    return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
  }
  isSupportedCode(code) {
    if (this.options.load === 'languageOnly' || this.options.nonExplicitSupportedLngs) {
      code = this.getLanguagePartFromCode(code);
    }
    return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
  }
  getBestMatchFromCodes(codes) {
    if (!codes) return null;
    let found;
    codes.forEach(code => {
      if (found) return;
      const cleanedLng = this.formatLanguageCode(code);
      if (!this.options.supportedLngs || this.isSupportedCode(cleanedLng)) found = cleanedLng;
    });
    if (!found && this.options.supportedLngs) {
      codes.forEach(code => {
        if (found) return;
        const lngOnly = this.getLanguagePartFromCode(code);
        if (this.isSupportedCode(lngOnly)) return found = lngOnly;
        found = this.options.supportedLngs.find(supportedLng => {
          if (supportedLng === lngOnly) return supportedLng;
          if (supportedLng.indexOf('-') < 0 && lngOnly.indexOf('-') < 0) return;
          if (supportedLng.indexOf('-') > 0 && lngOnly.indexOf('-') < 0 && supportedLng.substring(0, supportedLng.indexOf('-')) === lngOnly) return supportedLng;
          if (supportedLng.indexOf(lngOnly) === 0 && lngOnly.length > 1) return supportedLng;
        });
      });
    }
    if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
    return found;
  }
  getFallbackCodes(fallbacks, code) {
    if (!fallbacks) return [];
    if (typeof fallbacks === 'function') fallbacks = fallbacks(code);
    if (isString(fallbacks)) fallbacks = [fallbacks];
    if (Array.isArray(fallbacks)) return fallbacks;
    if (!code) return fallbacks.default || [];
    let found = fallbacks[code];
    if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
    if (!found) found = fallbacks[this.formatLanguageCode(code)];
    if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
    if (!found) found = fallbacks.default;
    return found || [];
  }
  toResolveHierarchy(code, fallbackCode) {
    const fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
    const codes = [];
    const addCode = c => {
      if (!c) return;
      if (this.isSupportedCode(c)) {
        codes.push(c);
      } else {
        this.logger.warn(`rejecting language code not found in supportedLngs: ${c}`);
      }
    };
    if (isString(code) && (code.indexOf('-') > -1 || code.indexOf('_') > -1)) {
      if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
      if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
      if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
    } else if (isString(code)) {
      addCode(this.formatLanguageCode(code));
    }
    fallbackCodes.forEach(fc => {
      if (codes.indexOf(fc) < 0) addCode(this.formatLanguageCode(fc));
    });
    return codes;
  }
}

let sets = [{
  lngs: ['ach', 'ak', 'am', 'arn', 'br', 'fil', 'gun', 'ln', 'mfe', 'mg', 'mi', 'oc', 'pt', 'pt-BR', 'tg', 'tl', 'ti', 'tr', 'uz', 'wa'],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ['af', 'an', 'ast', 'az', 'bg', 'bn', 'ca', 'da', 'de', 'dev', 'el', 'en', 'eo', 'es', 'et', 'eu', 'fi', 'fo', 'fur', 'fy', 'gl', 'gu', 'ha', 'hi', 'hu', 'hy', 'ia', 'it', 'kk', 'kn', 'ku', 'lb', 'mai', 'ml', 'mn', 'mr', 'nah', 'nap', 'nb', 'ne', 'nl', 'nn', 'no', 'nso', 'pa', 'pap', 'pms', 'ps', 'pt-PT', 'rm', 'sco', 'se', 'si', 'so', 'son', 'sq', 'sv', 'sw', 'ta', 'te', 'tk', 'ur', 'yo'],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ['ay', 'bo', 'cgg', 'fa', 'ht', 'id', 'ja', 'jbo', 'ka', 'km', 'ko', 'ky', 'lo', 'ms', 'sah', 'su', 'th', 'tt', 'ug', 'vi', 'wo', 'zh'],
  nr: [1],
  fc: 3
}, {
  lngs: ['be', 'bs', 'cnr', 'dz', 'hr', 'ru', 'sr', 'uk'],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ['ar'],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ['cs', 'sk'],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ['csb', 'pl'],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ['cy'],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ['fr'],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ['ga'],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ['gd'],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ['is'],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ['jv'],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ['kw'],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ['lt'],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ['lv'],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ['mk'],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ['mnk'],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ['mt'],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ['or'],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ['ro'],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ['sl'],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ['he', 'iw'],
  nr: [1, 2, 20, 21],
  fc: 22
}];
let _rulesPluralsTypes = {
  1: n => Number(n > 1),
  2: n => Number(n != 1),
  3: n => 0,
  4: n => Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2),
  5: n => Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5),
  6: n => Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2),
  7: n => Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2),
  8: n => Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3),
  9: n => Number(n >= 2),
  10: n => Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4),
  11: n => Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3),
  12: n => Number(n % 10 != 1 || n % 100 == 11),
  13: n => Number(n !== 0),
  14: n => Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3),
  15: n => Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2),
  16: n => Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2),
  17: n => Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1),
  18: n => Number(n == 0 ? 0 : n == 1 ? 1 : 2),
  19: n => Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3),
  20: n => Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2),
  21: n => Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0),
  22: n => Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3)
};
const nonIntlVersions = ['v1', 'v2', 'v3'];
const intlVersions = ['v4'];
const suffixesOrder = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
};
const createRules = () => {
  const rules = {};
  sets.forEach(set => {
    set.lngs.forEach(l => {
      rules[l] = {
        numbers: set.nr,
        plurals: _rulesPluralsTypes[set.fc]
      };
    });
  });
  return rules;
};
class PluralResolver {
  constructor(languageUtils) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.languageUtils = languageUtils;
    this.options = options;
    this.logger = baseLogger.create('pluralResolver');
    if ((!this.options.compatibilityJSON || intlVersions.includes(this.options.compatibilityJSON)) && (typeof Intl === 'undefined' || !Intl.PluralRules)) {
      this.options.compatibilityJSON = 'v3';
      this.logger.error('Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.');
    }
    this.rules = createRules();
    this.pluralRulesCache = {};
  }
  addRule(lng, obj) {
    this.rules[lng] = obj;
  }
  clearCache() {
    this.pluralRulesCache = {};
  }
  getRule(code) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (this.shouldUseIntlApi()) {
      const cleanedCode = getCleanedCode(code === 'dev' ? 'en' : code);
      const type = options.ordinal ? 'ordinal' : 'cardinal';
      const cacheKey = JSON.stringify({
        cleanedCode,
        type
      });
      if (cacheKey in this.pluralRulesCache) {
        return this.pluralRulesCache[cacheKey];
      }
      let rule;
      try {
        rule = new Intl.PluralRules(cleanedCode, {
          type
        });
      } catch (err) {
        if (!code.match(/-|_/)) return;
        const lngPart = this.languageUtils.getLanguagePartFromCode(code);
        rule = this.getRule(lngPart, options);
      }
      this.pluralRulesCache[cacheKey] = rule;
      return rule;
    }
    return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
  }
  needsPlural(code) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const rule = this.getRule(code, options);
    if (this.shouldUseIntlApi()) {
      return rule && rule.resolvedOptions().pluralCategories.length > 1;
    }
    return rule && rule.numbers.length > 1;
  }
  getPluralFormsOfKey(code, key) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return this.getSuffixes(code, options).map(suffix => `${key}${suffix}`);
  }
  getSuffixes(code) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const rule = this.getRule(code, options);
    if (!rule) {
      return [];
    }
    if (this.shouldUseIntlApi()) {
      return rule.resolvedOptions().pluralCategories.sort((pluralCategory1, pluralCategory2) => suffixesOrder[pluralCategory1] - suffixesOrder[pluralCategory2]).map(pluralCategory => `${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ''}${pluralCategory}`);
    }
    return rule.numbers.map(number => this.getSuffix(code, number, options));
  }
  getSuffix(code, count) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    const rule = this.getRule(code, options);
    if (rule) {
      if (this.shouldUseIntlApi()) {
        return `${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ''}${rule.select(count)}`;
      }
      return this.getSuffixRetroCompatible(rule, count);
    }
    this.logger.warn(`no plural rule found for: ${code}`);
    return '';
  }
  getSuffixRetroCompatible(rule, count) {
    const idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
    let suffix = rule.numbers[idx];
    if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
      if (suffix === 2) {
        suffix = 'plural';
      } else if (suffix === 1) {
        suffix = '';
      }
    }
    const returnSuffix = () => this.options.prepend && suffix.toString() ? this.options.prepend + suffix.toString() : suffix.toString();
    if (this.options.compatibilityJSON === 'v1') {
      if (suffix === 1) return '';
      if (typeof suffix === 'number') return `_plural_${suffix.toString()}`;
      return returnSuffix();
    } else if (this.options.compatibilityJSON === 'v2') {
      return returnSuffix();
    } else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
      return returnSuffix();
    }
    return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
  }
  shouldUseIntlApi() {
    return !nonIntlVersions.includes(this.options.compatibilityJSON);
  }
}

const deepFindWithDefaults = function (data, defaultData, key) {
  let keySeparator = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '.';
  let ignoreJSONStructure = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
  let path = getPathWithDefaults(data, defaultData, key);
  if (!path && ignoreJSONStructure && isString(key)) {
    path = deepFind(data, key, keySeparator);
    if (path === undefined) path = deepFind(defaultData, key, keySeparator);
  }
  return path;
};
const regexSafe = val => val.replace(/\$/g, '$$$$');
class Interpolator {
  constructor() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    this.logger = baseLogger.create('interpolator');
    this.options = options;
    this.format = options.interpolation && options.interpolation.format || (value => value);
    this.init(options);
  }
  init() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (!options.interpolation) options.interpolation = {
      escapeValue: true
    };
    const {
      escape: escape$1,
      escapeValue,
      useRawValueToEscape,
      prefix,
      prefixEscaped,
      suffix,
      suffixEscaped,
      formatSeparator,
      unescapeSuffix,
      unescapePrefix,
      nestingPrefix,
      nestingPrefixEscaped,
      nestingSuffix,
      nestingSuffixEscaped,
      nestingOptionsSeparator,
      maxReplaces,
      alwaysFormat
    } = options.interpolation;
    this.escape = escape$1 !== undefined ? escape$1 : i18next_escape;
    this.escapeValue = escapeValue !== undefined ? escapeValue : true;
    this.useRawValueToEscape = useRawValueToEscape !== undefined ? useRawValueToEscape : false;
    this.prefix = prefix ? regexEscape(prefix) : prefixEscaped || '{{';
    this.suffix = suffix ? regexEscape(suffix) : suffixEscaped || '}}';
    this.formatSeparator = formatSeparator || ',';
    this.unescapePrefix = unescapeSuffix ? '' : unescapePrefix || '-';
    this.unescapeSuffix = this.unescapePrefix ? '' : unescapeSuffix || '';
    this.nestingPrefix = nestingPrefix ? regexEscape(nestingPrefix) : nestingPrefixEscaped || regexEscape('$t(');
    this.nestingSuffix = nestingSuffix ? regexEscape(nestingSuffix) : nestingSuffixEscaped || regexEscape(')');
    this.nestingOptionsSeparator = nestingOptionsSeparator || ',';
    this.maxReplaces = maxReplaces || 1000;
    this.alwaysFormat = alwaysFormat !== undefined ? alwaysFormat : false;
    this.resetRegExp();
  }
  reset() {
    if (this.options) this.init(this.options);
  }
  resetRegExp() {
    const getOrResetRegExp = (existingRegExp, pattern) => {
      if (existingRegExp && existingRegExp.source === pattern) {
        existingRegExp.lastIndex = 0;
        return existingRegExp;
      }
      return new RegExp(pattern, 'g');
    };
    this.regexp = getOrResetRegExp(this.regexp, `${this.prefix}(.+?)${this.suffix}`);
    this.regexpUnescape = getOrResetRegExp(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`);
    this.nestingRegexp = getOrResetRegExp(this.nestingRegexp, `${this.nestingPrefix}(.+?)${this.nestingSuffix}`);
  }
  interpolate(str, data, lng, options) {
    let match;
    let value;
    let replaces;
    const defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
    const handleFormat = key => {
      if (key.indexOf(this.formatSeparator) < 0) {
        const path = deepFindWithDefaults(data, defaultData, key, this.options.keySeparator, this.options.ignoreJSONStructure);
        return this.alwaysFormat ? this.format(path, undefined, lng, {
          ...options,
          ...data,
          interpolationkey: key
        }) : path;
      }
      const p = key.split(this.formatSeparator);
      const k = p.shift().trim();
      const f = p.join(this.formatSeparator).trim();
      return this.format(deepFindWithDefaults(data, defaultData, k, this.options.keySeparator, this.options.ignoreJSONStructure), f, lng, {
        ...options,
        ...data,
        interpolationkey: k
      });
    };
    this.resetRegExp();
    const missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
    const skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
    const todos = [{
      regex: this.regexpUnescape,
      safeValue: val => regexSafe(val)
    }, {
      regex: this.regexp,
      safeValue: val => this.escapeValue ? regexSafe(this.escape(val)) : regexSafe(val)
    }];
    todos.forEach(todo => {
      replaces = 0;
      while (match = todo.regex.exec(str)) {
        const matchedVar = match[1].trim();
        value = handleFormat(matchedVar);
        if (value === undefined) {
          if (typeof missingInterpolationHandler === 'function') {
            const temp = missingInterpolationHandler(str, match, options);
            value = isString(temp) ? temp : '';
          } else if (options && Object.prototype.hasOwnProperty.call(options, matchedVar)) {
            value = '';
          } else if (skipOnVariables) {
            value = match[0];
            continue;
          } else {
            this.logger.warn(`missed to pass in variable ${matchedVar} for interpolating ${str}`);
            value = '';
          }
        } else if (!isString(value) && !this.useRawValueToEscape) {
          value = makeString(value);
        }
        const safeValue = todo.safeValue(value);
        str = str.replace(match[0], safeValue);
        if (skipOnVariables) {
          todo.regex.lastIndex += value.length;
          todo.regex.lastIndex -= match[0].length;
        } else {
          todo.regex.lastIndex = 0;
        }
        replaces++;
        if (replaces >= this.maxReplaces) {
          break;
        }
      }
    });
    return str;
  }
  nest(str, fc) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    let match;
    let value;
    let clonedOptions;
    const handleHasOptions = (key, inheritedOptions) => {
      const sep = this.nestingOptionsSeparator;
      if (key.indexOf(sep) < 0) return key;
      const c = key.split(new RegExp(`${sep}[ ]*{`));
      let optionsString = `{${c[1]}`;
      key = c[0];
      optionsString = this.interpolate(optionsString, clonedOptions);
      const matchedSingleQuotes = optionsString.match(/'/g);
      const matchedDoubleQuotes = optionsString.match(/"/g);
      if (matchedSingleQuotes && matchedSingleQuotes.length % 2 === 0 && !matchedDoubleQuotes || matchedDoubleQuotes.length % 2 !== 0) {
        optionsString = optionsString.replace(/'/g, '"');
      }
      try {
        clonedOptions = JSON.parse(optionsString);
        if (inheritedOptions) clonedOptions = {
          ...inheritedOptions,
          ...clonedOptions
        };
      } catch (e) {
        this.logger.warn(`failed parsing options string in nesting for key ${key}`, e);
        return `${key}${sep}${optionsString}`;
      }
      if (clonedOptions.defaultValue && clonedOptions.defaultValue.indexOf(this.prefix) > -1) delete clonedOptions.defaultValue;
      return key;
    };
    while (match = this.nestingRegexp.exec(str)) {
      let formatters = [];
      clonedOptions = {
        ...options
      };
      clonedOptions = clonedOptions.replace && !isString(clonedOptions.replace) ? clonedOptions.replace : clonedOptions;
      clonedOptions.applyPostProcessor = false;
      delete clonedOptions.defaultValue;
      let doReduce = false;
      if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
        const r = match[1].split(this.formatSeparator).map(elem => elem.trim());
        match[1] = r.shift();
        formatters = r;
        doReduce = true;
      }
      value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
      if (value && match[0] === str && !isString(value)) return value;
      if (!isString(value)) value = makeString(value);
      if (!value) {
        this.logger.warn(`missed to resolve ${match[1]} for nesting ${str}`);
        value = '';
      }
      if (doReduce) {
        value = formatters.reduce((v, f) => this.format(v, f, options.lng, {
          ...options,
          interpolationkey: match[1].trim()
        }), value.trim());
      }
      str = str.replace(match[0], value);
      this.regexp.lastIndex = 0;
    }
    return str;
  }
}

const parseFormatStr = formatStr => {
  let formatName = formatStr.toLowerCase().trim();
  const formatOptions = {};
  if (formatStr.indexOf('(') > -1) {
    const p = formatStr.split('(');
    formatName = p[0].toLowerCase().trim();
    const optStr = p[1].substring(0, p[1].length - 1);
    if (formatName === 'currency' && optStr.indexOf(':') < 0) {
      if (!formatOptions.currency) formatOptions.currency = optStr.trim();
    } else if (formatName === 'relativetime' && optStr.indexOf(':') < 0) {
      if (!formatOptions.range) formatOptions.range = optStr.trim();
    } else {
      const opts = optStr.split(';');
      opts.forEach(opt => {
        if (opt) {
          const [key, ...rest] = opt.split(':');
          const val = rest.join(':').trim().replace(/^'+|'+$/g, '');
          const trimmedKey = key.trim();
          if (!formatOptions[trimmedKey]) formatOptions[trimmedKey] = val;
          if (val === 'false') formatOptions[trimmedKey] = false;
          if (val === 'true') formatOptions[trimmedKey] = true;
          if (!isNaN(val)) formatOptions[trimmedKey] = parseInt(val, 10);
        }
      });
    }
  }
  return {
    formatName,
    formatOptions
  };
};
const createCachedFormatter = fn => {
  const cache = {};
  return (val, lng, options) => {
    let optForCache = options;
    if (options && options.interpolationkey && options.formatParams && options.formatParams[options.interpolationkey] && options[options.interpolationkey]) {
      optForCache = {
        ...optForCache,
        [options.interpolationkey]: undefined
      };
    }
    const key = lng + JSON.stringify(optForCache);
    let formatter = cache[key];
    if (!formatter) {
      formatter = fn(getCleanedCode(lng), options);
      cache[key] = formatter;
    }
    return formatter(val);
  };
};
class Formatter {
  constructor() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    this.logger = baseLogger.create('formatter');
    this.options = options;
    this.formats = {
      number: createCachedFormatter((lng, opt) => {
        const formatter = new Intl.NumberFormat(lng, {
          ...opt
        });
        return val => formatter.format(val);
      }),
      currency: createCachedFormatter((lng, opt) => {
        const formatter = new Intl.NumberFormat(lng, {
          ...opt,
          style: 'currency'
        });
        return val => formatter.format(val);
      }),
      datetime: createCachedFormatter((lng, opt) => {
        const formatter = new Intl.DateTimeFormat(lng, {
          ...opt
        });
        return val => formatter.format(val);
      }),
      relativetime: createCachedFormatter((lng, opt) => {
        const formatter = new Intl.RelativeTimeFormat(lng, {
          ...opt
        });
        return val => formatter.format(val, opt.range || 'day');
      }),
      list: createCachedFormatter((lng, opt) => {
        const formatter = new Intl.ListFormat(lng, {
          ...opt
        });
        return val => formatter.format(val);
      })
    };
    this.init(options);
  }
  init(services) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      interpolation: {}
    };
    this.formatSeparator = options.interpolation.formatSeparator || ',';
  }
  add(name, fc) {
    this.formats[name.toLowerCase().trim()] = fc;
  }
  addCached(name, fc) {
    this.formats[name.toLowerCase().trim()] = createCachedFormatter(fc);
  }
  format(value, format, lng) {
    let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    const formats = format.split(this.formatSeparator);
    if (formats.length > 1 && formats[0].indexOf('(') > 1 && formats[0].indexOf(')') < 0 && formats.find(f => f.indexOf(')') > -1)) {
      const lastIndex = formats.findIndex(f => f.indexOf(')') > -1);
      formats[0] = [formats[0], ...formats.splice(1, lastIndex)].join(this.formatSeparator);
    }
    const result = formats.reduce((mem, f) => {
      const {
        formatName,
        formatOptions
      } = parseFormatStr(f);
      if (this.formats[formatName]) {
        let formatted = mem;
        try {
          const valOptions = options && options.formatParams && options.formatParams[options.interpolationkey] || {};
          const l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
          formatted = this.formats[formatName](mem, l, {
            ...formatOptions,
            ...options,
            ...valOptions
          });
        } catch (error) {
          this.logger.warn(error);
        }
        return formatted;
      } else {
        this.logger.warn(`there was no format function for ${formatName}`);
      }
      return mem;
    }, value);
    return result;
  }
}

const removePending = (q, name) => {
  if (q.pending[name] !== undefined) {
    delete q.pending[name];
    q.pendingCount--;
  }
};
class Connector extends EventEmitter {
  constructor(backend, store, services) {
    let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    super();
    this.backend = backend;
    this.store = store;
    this.services = services;
    this.languageUtils = services.languageUtils;
    this.options = options;
    this.logger = baseLogger.create('backendConnector');
    this.waitingReads = [];
    this.maxParallelReads = options.maxParallelReads || 10;
    this.readingCalls = 0;
    this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
    this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
    this.state = {};
    this.queue = [];
    if (this.backend && this.backend.init) {
      this.backend.init(services, options.backend, options);
    }
  }
  queueLoad(languages, namespaces, options, callback) {
    const toLoad = {};
    const pending = {};
    const toLoadLanguages = {};
    const toLoadNamespaces = {};
    languages.forEach(lng => {
      let hasAllNamespaces = true;
      namespaces.forEach(ns => {
        const name = `${lng}|${ns}`;
        if (!options.reload && this.store.hasResourceBundle(lng, ns)) {
          this.state[name] = 2;
        } else if (this.state[name] < 0) ; else if (this.state[name] === 1) {
          if (pending[name] === undefined) pending[name] = true;
        } else {
          this.state[name] = 1;
          hasAllNamespaces = false;
          if (pending[name] === undefined) pending[name] = true;
          if (toLoad[name] === undefined) toLoad[name] = true;
          if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
        }
      });
      if (!hasAllNamespaces) toLoadLanguages[lng] = true;
    });
    if (Object.keys(toLoad).length || Object.keys(pending).length) {
      this.queue.push({
        pending,
        pendingCount: Object.keys(pending).length,
        loaded: {},
        errors: [],
        callback
      });
    }
    return {
      toLoad: Object.keys(toLoad),
      pending: Object.keys(pending),
      toLoadLanguages: Object.keys(toLoadLanguages),
      toLoadNamespaces: Object.keys(toLoadNamespaces)
    };
  }
  loaded(name, err, data) {
    const s = name.split('|');
    const lng = s[0];
    const ns = s[1];
    if (err) this.emit('failedLoading', lng, ns, err);
    if (!err && data) {
      this.store.addResourceBundle(lng, ns, data, undefined, undefined, {
        skipCopy: true
      });
    }
    this.state[name] = err ? -1 : 2;
    if (err && data) this.state[name] = 0;
    const loaded = {};
    this.queue.forEach(q => {
      pushPath(q.loaded, [lng], ns);
      removePending(q, name);
      if (err) q.errors.push(err);
      if (q.pendingCount === 0 && !q.done) {
        Object.keys(q.loaded).forEach(l => {
          if (!loaded[l]) loaded[l] = {};
          const loadedKeys = q.loaded[l];
          if (loadedKeys.length) {
            loadedKeys.forEach(n => {
              if (loaded[l][n] === undefined) loaded[l][n] = true;
            });
          }
        });
        q.done = true;
        if (q.errors.length) {
          q.callback(q.errors);
        } else {
          q.callback();
        }
      }
    });
    this.emit('loaded', loaded);
    this.queue = this.queue.filter(q => !q.done);
  }
  read(lng, ns, fcName) {
    let tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    let wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : this.retryTimeout;
    let callback = arguments.length > 5 ? arguments[5] : undefined;
    if (!lng.length) return callback(null, {});
    if (this.readingCalls >= this.maxParallelReads) {
      this.waitingReads.push({
        lng,
        ns,
        fcName,
        tried,
        wait,
        callback
      });
      return;
    }
    this.readingCalls++;
    const resolver = (err, data) => {
      this.readingCalls--;
      if (this.waitingReads.length > 0) {
        const next = this.waitingReads.shift();
        this.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
      }
      if (err && data && tried < this.maxRetries) {
        setTimeout(() => {
          this.read.call(this, lng, ns, fcName, tried + 1, wait * 2, callback);
        }, wait);
        return;
      }
      callback(err, data);
    };
    const fc = this.backend[fcName].bind(this.backend);
    if (fc.length === 2) {
      try {
        const r = fc(lng, ns);
        if (r && typeof r.then === 'function') {
          r.then(data => resolver(null, data)).catch(resolver);
        } else {
          resolver(null, r);
        }
      } catch (err) {
        resolver(err);
      }
      return;
    }
    return fc(lng, ns, resolver);
  }
  prepareLoading(languages, namespaces) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    let callback = arguments.length > 3 ? arguments[3] : undefined;
    if (!this.backend) {
      this.logger.warn('No backend was added via i18next.use. Will not load resources.');
      return callback && callback();
    }
    if (isString(languages)) languages = this.languageUtils.toResolveHierarchy(languages);
    if (isString(namespaces)) namespaces = [namespaces];
    const toLoad = this.queueLoad(languages, namespaces, options, callback);
    if (!toLoad.toLoad.length) {
      if (!toLoad.pending.length) callback();
      return null;
    }
    toLoad.toLoad.forEach(name => {
      this.loadOne(name);
    });
  }
  load(languages, namespaces, callback) {
    this.prepareLoading(languages, namespaces, {}, callback);
  }
  reload(languages, namespaces, callback) {
    this.prepareLoading(languages, namespaces, {
      reload: true
    }, callback);
  }
  loadOne(name) {
    let prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    const s = name.split('|');
    const lng = s[0];
    const ns = s[1];
    this.read(lng, ns, 'read', undefined, undefined, (err, data) => {
      if (err) this.logger.warn(`${prefix}loading namespace ${ns} for language ${lng} failed`, err);
      if (!err && data) this.logger.log(`${prefix}loaded namespace ${ns} for language ${lng}`, data);
      this.loaded(name, err, data);
    });
  }
  saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
    let options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
    let clb = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : () => {};
    if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
      this.logger.warn(`did not save key "${key}" as the namespace "${namespace}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
      return;
    }
    if (key === undefined || key === null || key === '') return;
    if (this.backend && this.backend.create) {
      const opts = {
        ...options,
        isUpdate
      };
      const fc = this.backend.create.bind(this.backend);
      if (fc.length < 6) {
        try {
          let r;
          if (fc.length === 5) {
            r = fc(languages, namespace, key, fallbackValue, opts);
          } else {
            r = fc(languages, namespace, key, fallbackValue);
          }
          if (r && typeof r.then === 'function') {
            r.then(data => clb(null, data)).catch(clb);
          } else {
            clb(null, r);
          }
        } catch (err) {
          clb(err);
        }
      } else {
        fc(languages, namespace, key, fallbackValue, clb, opts);
      }
    }
    if (!languages || !languages[0]) return;
    this.store.addResource(languages[0], namespace, key, fallbackValue);
  }
}

const get = () => ({
  debug: false,
  initImmediate: true,
  ns: ['translation'],
  defaultNS: ['translation'],
  fallbackLng: ['dev'],
  fallbackNS: false,
  supportedLngs: false,
  nonExplicitSupportedLngs: false,
  load: 'all',
  preload: false,
  simplifyPluralSuffix: true,
  keySeparator: '.',
  nsSeparator: ':',
  pluralSeparator: '_',
  contextSeparator: '_',
  partialBundledLanguages: false,
  saveMissing: false,
  updateMissing: false,
  saveMissingTo: 'fallback',
  saveMissingPlurals: true,
  missingKeyHandler: false,
  missingInterpolationHandler: false,
  postProcess: false,
  postProcessPassResolved: false,
  returnNull: false,
  returnEmptyString: true,
  returnObjects: false,
  joinArrays: false,
  returnedObjectHandler: false,
  parseMissingKeyHandler: false,
  appendNamespaceToMissingKey: false,
  appendNamespaceToCIMode: false,
  overloadTranslationOptionHandler: args => {
    let ret = {};
    if (typeof args[1] === 'object') ret = args[1];
    if (isString(args[1])) ret.defaultValue = args[1];
    if (isString(args[2])) ret.tDescription = args[2];
    if (typeof args[2] === 'object' || typeof args[3] === 'object') {
      const options = args[3] || args[2];
      Object.keys(options).forEach(key => {
        ret[key] = options[key];
      });
    }
    return ret;
  },
  interpolation: {
    escapeValue: true,
    format: value => value,
    prefix: '{{',
    suffix: '}}',
    formatSeparator: ',',
    unescapePrefix: '-',
    nestingPrefix: '$t(',
    nestingSuffix: ')',
    nestingOptionsSeparator: ',',
    maxReplaces: 1000,
    skipOnVariables: true
  }
});
const transformOptions = options => {
  if (isString(options.ns)) options.ns = [options.ns];
  if (isString(options.fallbackLng)) options.fallbackLng = [options.fallbackLng];
  if (isString(options.fallbackNS)) options.fallbackNS = [options.fallbackNS];
  if (options.supportedLngs && options.supportedLngs.indexOf('cimode') < 0) {
    options.supportedLngs = options.supportedLngs.concat(['cimode']);
  }
  return options;
};

const noop = () => {};
const bindMemberFunctions = inst => {
  const mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
  mems.forEach(mem => {
    if (typeof inst[mem] === 'function') {
      inst[mem] = inst[mem].bind(inst);
    }
  });
};
class I18n extends EventEmitter {
  constructor() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let callback = arguments.length > 1 ? arguments[1] : undefined;
    super();
    this.options = transformOptions(options);
    this.services = {};
    this.logger = baseLogger;
    this.modules = {
      external: []
    };
    bindMemberFunctions(this);
    if (callback && !this.isInitialized && !options.isClone) {
      if (!this.options.initImmediate) {
        this.init(options, callback);
        return this;
      }
      setTimeout(() => {
        this.init(options, callback);
      }, 0);
    }
  }
  init() {
    var _this = this;
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let callback = arguments.length > 1 ? arguments[1] : undefined;
    this.isInitializing = true;
    if (typeof options === 'function') {
      callback = options;
      options = {};
    }
    if (!options.defaultNS && options.defaultNS !== false && options.ns) {
      if (isString(options.ns)) {
        options.defaultNS = options.ns;
      } else if (options.ns.indexOf('translation') < 0) {
        options.defaultNS = options.ns[0];
      }
    }
    const defOpts = get();
    this.options = {
      ...defOpts,
      ...this.options,
      ...transformOptions(options)
    };
    if (this.options.compatibilityAPI !== 'v1') {
      this.options.interpolation = {
        ...defOpts.interpolation,
        ...this.options.interpolation
      };
    }
    if (options.keySeparator !== undefined) {
      this.options.userDefinedKeySeparator = options.keySeparator;
    }
    if (options.nsSeparator !== undefined) {
      this.options.userDefinedNsSeparator = options.nsSeparator;
    }
    const createClassOnDemand = ClassOrObject => {
      if (!ClassOrObject) return null;
      if (typeof ClassOrObject === 'function') return new ClassOrObject();
      return ClassOrObject;
    };
    if (!this.options.isClone) {
      if (this.modules.logger) {
        baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
      } else {
        baseLogger.init(null, this.options);
      }
      let formatter;
      if (this.modules.formatter) {
        formatter = this.modules.formatter;
      } else if (typeof Intl !== 'undefined') {
        formatter = Formatter;
      }
      const lu = new LanguageUtil(this.options);
      this.store = new ResourceStore(this.options.resources, this.options);
      const s = this.services;
      s.logger = baseLogger;
      s.resourceStore = this.store;
      s.languageUtils = lu;
      s.pluralResolver = new PluralResolver(lu, {
        prepend: this.options.pluralSeparator,
        compatibilityJSON: this.options.compatibilityJSON,
        simplifyPluralSuffix: this.options.simplifyPluralSuffix
      });
      if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
        s.formatter = createClassOnDemand(formatter);
        s.formatter.init(s, this.options);
        this.options.interpolation.format = s.formatter.format.bind(s.formatter);
      }
      s.interpolator = new Interpolator(this.options);
      s.utils = {
        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
      };
      s.backendConnector = new Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
      s.backendConnector.on('*', function (event) {
        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }
        _this.emit(event, ...args);
      });
      if (this.modules.languageDetector) {
        s.languageDetector = createClassOnDemand(this.modules.languageDetector);
        if (s.languageDetector.init) s.languageDetector.init(s, this.options.detection, this.options);
      }
      if (this.modules.i18nFormat) {
        s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
        if (s.i18nFormat.init) s.i18nFormat.init(this);
      }
      this.translator = new Translator(this.services, this.options);
      this.translator.on('*', function (event) {
        for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          args[_key2 - 1] = arguments[_key2];
        }
        _this.emit(event, ...args);
      });
      this.modules.external.forEach(m => {
        if (m.init) m.init(this);
      });
    }
    this.format = this.options.interpolation.format;
    if (!callback) callback = noop;
    if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
      const codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
      if (codes.length > 0 && codes[0] !== 'dev') this.options.lng = codes[0];
    }
    if (!this.services.languageDetector && !this.options.lng) {
      this.logger.warn('init: no languageDetector is used and no lng is defined');
    }
    const storeApi = ['getResource', 'hasResourceBundle', 'getResourceBundle', 'getDataByLanguage'];
    storeApi.forEach(fcName => {
      this[fcName] = function () {
        return _this.store[fcName](...arguments);
      };
    });
    const storeApiChained = ['addResource', 'addResources', 'addResourceBundle', 'removeResourceBundle'];
    storeApiChained.forEach(fcName => {
      this[fcName] = function () {
        _this.store[fcName](...arguments);
        return _this;
      };
    });
    const deferred = defer();
    const load = () => {
      const finish = (err, t) => {
        this.isInitializing = false;
        if (this.isInitialized && !this.initializedStoreOnce) this.logger.warn('init: i18next is already initialized. You should call init just once!');
        this.isInitialized = true;
        if (!this.options.isClone) this.logger.log('initialized', this.options);
        this.emit('initialized', this.options);
        deferred.resolve(t);
        callback(err, t);
      };
      if (this.languages && this.options.compatibilityAPI !== 'v1' && !this.isInitialized) return finish(null, this.t.bind(this));
      this.changeLanguage(this.options.lng, finish);
    };
    if (this.options.resources || !this.options.initImmediate) {
      load();
    } else {
      setTimeout(load, 0);
    }
    return deferred;
  }
  loadResources(language) {
    let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
    let usedCallback = callback;
    const usedLng = isString(language) ? language : this.language;
    if (typeof language === 'function') usedCallback = language;
    if (!this.options.resources || this.options.partialBundledLanguages) {
      if (usedLng && usedLng.toLowerCase() === 'cimode' && (!this.options.preload || this.options.preload.length === 0)) return usedCallback();
      const toLoad = [];
      const append = lng => {
        if (!lng) return;
        if (lng === 'cimode') return;
        const lngs = this.services.languageUtils.toResolveHierarchy(lng);
        lngs.forEach(l => {
          if (l === 'cimode') return;
          if (toLoad.indexOf(l) < 0) toLoad.push(l);
        });
      };
      if (!usedLng) {
        const fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
        fallbacks.forEach(l => append(l));
      } else {
        append(usedLng);
      }
      if (this.options.preload) {
        this.options.preload.forEach(l => append(l));
      }
      this.services.backendConnector.load(toLoad, this.options.ns, e => {
        if (!e && !this.resolvedLanguage && this.language) this.setResolvedLanguage(this.language);
        usedCallback(e);
      });
    } else {
      usedCallback(null);
    }
  }
  reloadResources(lngs, ns, callback) {
    const deferred = defer();
    if (typeof lngs === 'function') {
      callback = lngs;
      lngs = undefined;
    }
    if (typeof ns === 'function') {
      callback = ns;
      ns = undefined;
    }
    if (!lngs) lngs = this.languages;
    if (!ns) ns = this.options.ns;
    if (!callback) callback = noop;
    this.services.backendConnector.reload(lngs, ns, err => {
      deferred.resolve();
      callback(err);
    });
    return deferred;
  }
  use(module) {
    if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to i18next.use()');
    if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to i18next.use()');
    if (module.type === 'backend') {
      this.modules.backend = module;
    }
    if (module.type === 'logger' || module.log && module.warn && module.error) {
      this.modules.logger = module;
    }
    if (module.type === 'languageDetector') {
      this.modules.languageDetector = module;
    }
    if (module.type === 'i18nFormat') {
      this.modules.i18nFormat = module;
    }
    if (module.type === 'postProcessor') {
      postProcessor.addPostProcessor(module);
    }
    if (module.type === 'formatter') {
      this.modules.formatter = module;
    }
    if (module.type === '3rdParty') {
      this.modules.external.push(module);
    }
    return this;
  }
  setResolvedLanguage(l) {
    if (!l || !this.languages) return;
    if (['cimode', 'dev'].indexOf(l) > -1) return;
    for (let li = 0; li < this.languages.length; li++) {
      const lngInLngs = this.languages[li];
      if (['cimode', 'dev'].indexOf(lngInLngs) > -1) continue;
      if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
        this.resolvedLanguage = lngInLngs;
        break;
      }
    }
  }
  changeLanguage(lng, callback) {
    var _this2 = this;
    this.isLanguageChangingTo = lng;
    const deferred = defer();
    this.emit('languageChanging', lng);
    const setLngProps = l => {
      this.language = l;
      this.languages = this.services.languageUtils.toResolveHierarchy(l);
      this.resolvedLanguage = undefined;
      this.setResolvedLanguage(l);
    };
    const done = (err, l) => {
      if (l) {
        setLngProps(l);
        this.translator.changeLanguage(l);
        this.isLanguageChangingTo = undefined;
        this.emit('languageChanged', l);
        this.logger.log('languageChanged', l);
      } else {
        this.isLanguageChangingTo = undefined;
      }
      deferred.resolve(function () {
        return _this2.t(...arguments);
      });
      if (callback) callback(err, function () {
        return _this2.t(...arguments);
      });
    };
    const setLng = lngs => {
      if (!lng && !lngs && this.services.languageDetector) lngs = [];
      const l = isString(lngs) ? lngs : this.services.languageUtils.getBestMatchFromCodes(lngs);
      if (l) {
        if (!this.language) {
          setLngProps(l);
        }
        if (!this.translator.language) this.translator.changeLanguage(l);
        if (this.services.languageDetector && this.services.languageDetector.cacheUserLanguage) this.services.languageDetector.cacheUserLanguage(l);
      }
      this.loadResources(l, err => {
        done(err, l);
      });
    };
    if (!lng && this.services.languageDetector && !this.services.languageDetector.async) {
      setLng(this.services.languageDetector.detect());
    } else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
      if (this.services.languageDetector.detect.length === 0) {
        this.services.languageDetector.detect().then(setLng);
      } else {
        this.services.languageDetector.detect(setLng);
      }
    } else {
      setLng(lng);
    }
    return deferred;
  }
  getFixedT(lng, ns, keyPrefix) {
    var _this3 = this;
    const fixedT = function (key, opts) {
      let options;
      if (typeof opts !== 'object') {
        for (var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
          rest[_key3 - 2] = arguments[_key3];
        }
        options = _this3.options.overloadTranslationOptionHandler([key, opts].concat(rest));
      } else {
        options = {
          ...opts
        };
      }
      options.lng = options.lng || fixedT.lng;
      options.lngs = options.lngs || fixedT.lngs;
      options.ns = options.ns || fixedT.ns;
      if (options.keyPrefix !== '') options.keyPrefix = options.keyPrefix || keyPrefix || fixedT.keyPrefix;
      const keySeparator = _this3.options.keySeparator || '.';
      let resultKey;
      if (options.keyPrefix && Array.isArray(key)) {
        resultKey = key.map(k => `${options.keyPrefix}${keySeparator}${k}`);
      } else {
        resultKey = options.keyPrefix ? `${options.keyPrefix}${keySeparator}${key}` : key;
      }
      return _this3.t(resultKey, options);
    };
    if (isString(lng)) {
      fixedT.lng = lng;
    } else {
      fixedT.lngs = lng;
    }
    fixedT.ns = ns;
    fixedT.keyPrefix = keyPrefix;
    return fixedT;
  }
  t() {
    return this.translator && this.translator.translate(...arguments);
  }
  exists() {
    return this.translator && this.translator.exists(...arguments);
  }
  setDefaultNamespace(ns) {
    this.options.defaultNS = ns;
  }
  hasLoadedNamespace(ns) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (!this.isInitialized) {
      this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
      return false;
    }
    if (!this.languages || !this.languages.length) {
      this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
      return false;
    }
    const lng = options.lng || this.resolvedLanguage || this.languages[0];
    const fallbackLng = this.options ? this.options.fallbackLng : false;
    const lastLng = this.languages[this.languages.length - 1];
    if (lng.toLowerCase() === 'cimode') return true;
    const loadNotPending = (l, n) => {
      const loadState = this.services.backendConnector.state[`${l}|${n}`];
      return loadState === -1 || loadState === 0 || loadState === 2;
    };
    if (options.precheck) {
      const preResult = options.precheck(this, loadNotPending);
      if (preResult !== undefined) return preResult;
    }
    if (this.hasResourceBundle(lng, ns)) return true;
    if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
    if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
    return false;
  }
  loadNamespaces(ns, callback) {
    const deferred = defer();
    if (!this.options.ns) {
      if (callback) callback();
      return Promise.resolve();
    }
    if (isString(ns)) ns = [ns];
    ns.forEach(n => {
      if (this.options.ns.indexOf(n) < 0) this.options.ns.push(n);
    });
    this.loadResources(err => {
      deferred.resolve();
      if (callback) callback(err);
    });
    return deferred;
  }
  loadLanguages(lngs, callback) {
    const deferred = defer();
    if (isString(lngs)) lngs = [lngs];
    const preloaded = this.options.preload || [];
    const newLngs = lngs.filter(lng => preloaded.indexOf(lng) < 0 && this.services.languageUtils.isSupportedCode(lng));
    if (!newLngs.length) {
      if (callback) callback();
      return Promise.resolve();
    }
    this.options.preload = preloaded.concat(newLngs);
    this.loadResources(err => {
      deferred.resolve();
      if (callback) callback(err);
    });
    return deferred;
  }
  dir(lng) {
    if (!lng) lng = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language);
    if (!lng) return 'rtl';
    const rtlLngs = ['ar', 'shu', 'sqr', 'ssh', 'xaa', 'yhd', 'yud', 'aao', 'abh', 'abv', 'acm', 'acq', 'acw', 'acx', 'acy', 'adf', 'ads', 'aeb', 'aec', 'afb', 'ajp', 'apc', 'apd', 'arb', 'arq', 'ars', 'ary', 'arz', 'auz', 'avl', 'ayh', 'ayl', 'ayn', 'ayp', 'bbz', 'pga', 'he', 'iw', 'ps', 'pbt', 'pbu', 'pst', 'prp', 'prd', 'ug', 'ur', 'ydd', 'yds', 'yih', 'ji', 'yi', 'hbo', 'men', 'xmn', 'fa', 'jpr', 'peo', 'pes', 'prs', 'dv', 'sam', 'ckb'];
    const languageUtils = this.services && this.services.languageUtils || new LanguageUtil(get());
    return rtlLngs.indexOf(languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf('-arab') > 1 ? 'rtl' : 'ltr';
  }
  static createInstance() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let callback = arguments.length > 1 ? arguments[1] : undefined;
    return new I18n(options, callback);
  }
  cloneInstance() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
    const forkResourceStore = options.forkResourceStore;
    if (forkResourceStore) delete options.forkResourceStore;
    const mergedOptions = {
      ...this.options,
      ...options,
      ...{
        isClone: true
      }
    };
    const clone = new I18n(mergedOptions);
    if (options.debug !== undefined || options.prefix !== undefined) {
      clone.logger = clone.logger.clone(options);
    }
    const membersToCopy = ['store', 'services', 'language'];
    membersToCopy.forEach(m => {
      clone[m] = this[m];
    });
    clone.services = {
      ...this.services
    };
    clone.services.utils = {
      hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
    };
    if (forkResourceStore) {
      clone.store = new ResourceStore(this.store.data, mergedOptions);
      clone.services.resourceStore = clone.store;
    }
    clone.translator = new Translator(clone.services, mergedOptions);
    clone.translator.on('*', function (event) {
      for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
        args[_key4 - 1] = arguments[_key4];
      }
      clone.emit(event, ...args);
    });
    clone.init(mergedOptions, callback);
    clone.translator.options = mergedOptions;
    clone.translator.backendConnector.services.utils = {
      hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
    };
    return clone;
  }
  toJSON() {
    return {
      options: this.options,
      store: this.store,
      language: this.language,
      languages: this.languages,
      resolvedLanguage: this.resolvedLanguage
    };
  }
}
const i18next_instance = I18n.createInstance();
i18next_instance.createInstance = I18n.createInstance;

const createInstance = i18next_instance.createInstance;
const dir = i18next_instance.dir;
const init = i18next_instance.init;
const loadResources = i18next_instance.loadResources;
const reloadResources = i18next_instance.reloadResources;
const use = i18next_instance.use;
const changeLanguage = i18next_instance.changeLanguage;
const getFixedT = i18next_instance.getFixedT;
const t = i18next_instance.t;
const exists = i18next_instance.exists;
const setDefaultNamespace = i18next_instance.setDefaultNamespace;
const hasLoadedNamespace = i18next_instance.hasLoadedNamespace;
const loadNamespaces = i18next_instance.loadNamespaces;
const loadLanguages = i18next_instance.loadLanguages;



;// CONCATENATED MODULE: ./node_modules/next-i18next/dist/esm/createClient/browser.js

/* harmony default export */ var browser = (function (config) {
  if (config.ns === undefined) config.ns = [];
  var instance = i18next_instance.createInstance(config);
  var initPromise;
  if (!instance.isInitialized) {
    var _config$use;
    config === null || config === void 0 || (_config$use = config.use) === null || _config$use === void 0 || _config$use.forEach(function (x) {
      return instance.use(x);
    });
    if (typeof config.onPreInitI18next === 'function') {
      config.onPreInitI18next(instance);
    }
    initPromise = instance.init(config);
  } else {
    initPromise = Promise.resolve(i18next_instance.t);
  }
  return {
    i18n: instance,
    initPromise: initPromise
  };
});
;// CONCATENATED MODULE: ./node_modules/next-i18next/dist/esm/appWithTranslation.js


var __jsx = react.createElement;
function appWithTranslation_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function appWithTranslation_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? appWithTranslation_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : appWithTranslation_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }







var globalI18n = null;
var addResourcesToI18next = function addResourcesToI18next(instance, resources) {
  if (resources && instance.isInitialized) {
    for (var _i = 0, _Object$keys = Object.keys(resources); _i < _Object$keys.length; _i++) {
      var locale = _Object$keys[_i];
      for (var _i2 = 0, _Object$keys2 = Object.keys(resources[locale]); _i2 < _Object$keys2.length; _i2++) {
        var _instance$store;
        var ns = _Object$keys2[_i2];
        if (!(instance !== null && instance !== void 0 && (_instance$store = instance.store) !== null && _instance$store !== void 0 && _instance$store.data) || !instance.store.data[locale] || !instance.store.data[locale][ns]) {
          instance.addResourceBundle(locale, ns, resources[locale][ns], true, true);
        }
      }
    }
  }
};
var appWithTranslation = function appWithTranslation(WrappedComponent) {
  var configOverride = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var AppWithTranslation = function AppWithTranslation(props) {
    var _nextI18Next$initialL, _props$router;
    var _ref = props.pageProps || {},
      _nextI18Next = _ref._nextI18Next; // pageProps may be undefined on strange setups, i.e. https://github.com/i18next/next-i18next/issues/2109
    var locale = (_nextI18Next$initialL = _nextI18Next === null || _nextI18Next === void 0 ? void 0 : _nextI18Next.initialLocale) !== null && _nextI18Next$initialL !== void 0 ? _nextI18Next$initialL : props === null || props === void 0 || (_props$router = props.router) === null || _props$router === void 0 ? void 0 : _props$router.locale;
    var ns = _nextI18Next === null || _nextI18Next === void 0 ? void 0 : _nextI18Next.ns;
    var instanceRef = (0,react.useRef)(null);

    /**
     * Memoize i18n instance and reuse it rather than creating new instance.
     * When the locale or resources are changed after instance was created,
     * we will update the instance by calling addResourceBundle method on it.
     */
    var i18n = (0,react.useMemo)(function () {
      var _userConfig$i18n, _configOverride$resou;
      if (!_nextI18Next && !configOverride) return null;
      var userConfig = configOverride !== null && configOverride !== void 0 ? configOverride : _nextI18Next === null || _nextI18Next === void 0 ? void 0 : _nextI18Next.userConfig;
      if (!userConfig) {
        throw new Error('appWithTranslation was called without a next-i18next config');
      }
      if (!(userConfig !== null && userConfig !== void 0 && userConfig.i18n)) {
        throw new Error('appWithTranslation was called without config.i18n');
      }
      if (!(userConfig !== null && userConfig !== void 0 && (_userConfig$i18n = userConfig.i18n) !== null && _userConfig$i18n !== void 0 && _userConfig$i18n.defaultLocale)) {
        throw new Error('config.i18n does not include a defaultLocale property');
      }
      var _ref2 = _nextI18Next || {},
        initialI18nStore = _ref2.initialI18nStore;
      var resources = (_configOverride$resou = configOverride === null || configOverride === void 0 ? void 0 : configOverride.resources) !== null && _configOverride$resou !== void 0 ? _configOverride$resou : initialI18nStore;
      if (!locale) locale = userConfig.i18n.defaultLocale;
      var instance = instanceRef.current;
      if (instance) {
        addResourcesToI18next(instance, resources);
      } else {
        instance = browser(appWithTranslation_objectSpread(appWithTranslation_objectSpread(appWithTranslation_objectSpread({}, createConfig(appWithTranslation_objectSpread(appWithTranslation_objectSpread({}, userConfig), {}, {
          lng: locale
        }))), {}, {
          lng: locale
        }, ns && {
          ns: ns
        }), {}, {
          resources: resources
        })).i18n;
        addResourcesToI18next(instance, resources);
        globalI18n = instance;
        instanceRef.current = instance;
      }
      return instance;
    }, [_nextI18Next, locale, ns]);

    /**
     * Since calling changeLanguage method on existing i18n instance cause state update in react,
     * we need to call the method in `useLayoutEffect` to prevent state update in render phase.
     */
    useIsomorphicLayoutEffect(function () {
      if (!i18n || !locale) return;
      i18n.changeLanguage(locale);
    }, [i18n, locale]);
    return i18n !== null ? __jsx(es/* I18nextProvider */.a3, {
      i18n: i18n
    }, __jsx(WrappedComponent, props)) : __jsx(WrappedComponent, (0,esm_extends/* default */.Z)({
      key: locale
    }, props));
  };
  return hoist_non_react_statics_cjs_default()(AppWithTranslation, WrappedComponent);
};
;// CONCATENATED MODULE: ./node_modules/next-i18next/dist/esm/index.js



/***/ }),

/***/ 7544:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(46029)


/***/ }),

/***/ 11752:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(88027)


/***/ }),

/***/ 83454:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var ref, ref1;
module.exports = ((ref = __webpack_require__.g.process) == null ? void 0 : ref.env) && typeof ((ref1 = __webpack_require__.g.process) == null ? void 0 : ref1.env) === "object" ? __webpack_require__.g.process : __webpack_require__(77663);

//# sourceMappingURL=process.js.map

/***/ }),

/***/ 91118:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(62996);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 33273:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
// const path = require('path');

var HttpBackend = __webpack_require__(78122);
var ChainedBackend = (__webpack_require__(81580)/* ["default"] */ .Z);
var LocalStorageBackend = (__webpack_require__(70660)/* ["default"] */ .Z);
var isBrowser = "object" !== "undefined";
var isDev = "production" === "development";
module.exports = {
    i18n: {
        defaultLocale: "th",
        locales: [
            "vi",
            "en",
            "cam",
            "th"
        ]
    },
    debug: false,
    backend: {
        backendOptions: [
            {
                expirationTime: isDev ? 0 : 5 * 60 * 1000
            },
            {}
        ],
        backends: isBrowser ? [
            LocalStorageBackend,
            HttpBackend
        ] : []
    },
    // localePath: path.resolve('./public/static/locales'),
    // ns: 'common',
    // defaultNS: 'common',
    // react: {
    //   useSuspense: false,
    //   wait: true,
    // },
    partialBundledLanguages: isBrowser && true,
    // react: { // used only for the lazy reload
    //   bindI18n: 'languageChanged loaded',
    //   useSuspense: false
    // },
    serializeConfig: false,
    use: isBrowser ? [
        ChainedBackend
    ] : []
};


/***/ }),

/***/ 28045:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _defineProperty = (__webpack_require__(79361)/* ["default"] */ .Z);
var _slicedToArray = (__webpack_require__(94941)/* ["default"] */ .Z);
var _toConsumableArray = (__webpack_require__(53929)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = Image;
var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _interop_require_wildcard = (__webpack_require__(91598)/* ["default"] */ .Z);
var _object_without_properties_loose = (__webpack_require__(17273)/* ["default"] */ .Z);
var _react = _interop_require_wildcard(__webpack_require__(67294));
var _head = _interop_require_default(__webpack_require__(5443));
var _imageConfig = __webpack_require__(99309);
var _useIntersection = __webpack_require__(57190);
var _imageConfigContext = __webpack_require__(59977);
var _utils = __webpack_require__(63794);
var _normalizeTrailingSlash = __webpack_require__(82392);
function Image(_param) {
    var src = _param.src, sizes = _param.sizes, _unoptimized = _param.unoptimized, unoptimized = _unoptimized === void 0 ? false : _unoptimized, _priority = _param.priority, priority = _priority === void 0 ? false : _priority, loading = _param.loading, _lazyRoot = _param.lazyRoot, lazyRoot = _lazyRoot === void 0 ? null : _lazyRoot, lazyBoundary = _param.lazyBoundary, className = _param.className, quality = _param.quality, width = _param.width, height = _param.height, style = _param.style, objectFit = _param.objectFit, objectPosition = _param.objectPosition, onLoadingComplete = _param.onLoadingComplete, _placeholder = _param.placeholder, placeholder = _placeholder === void 0 ? "empty" : _placeholder, blurDataURL = _param.blurDataURL, all = _object_without_properties_loose(_param, [
        "src",
        "sizes",
        "unoptimized",
        "priority",
        "loading",
        "lazyRoot",
        "lazyBoundary",
        "className",
        "quality",
        "width",
        "height",
        "style",
        "objectFit",
        "objectPosition",
        "onLoadingComplete",
        "placeholder",
        "blurDataURL"
    ]);
    var configContext = (0, _react).useContext(_imageConfigContext.ImageConfigContext);
    var config = (0, _react).useMemo(function() {
        var c = configEnv || configContext || _imageConfig.imageConfigDefault;
        var allSizes = _toConsumableArray(c.deviceSizes).concat(_toConsumableArray(c.imageSizes)).sort(function(a, b) {
            return a - b;
        });
        var deviceSizes = c.deviceSizes.sort(function(a, b) {
            return a - b;
        });
        return _extends({}, c, {
            allSizes: allSizes,
            deviceSizes: deviceSizes
        });
    }, [
        configContext
    ]);
    var rest = all;
    var layout = sizes ? "responsive" : "intrinsic";
    if ("layout" in rest) {
        // Override default layout if the user specified one:
        if (rest.layout) layout = rest.layout;
        // Remove property so it's not spread on <img>:
        delete rest.layout;
    }
    var loader = defaultImageLoader;
    if ("loader" in rest) {
        if (rest.loader) {
            var customImageLoader = rest.loader;
            var _tmp;
            _tmp = function(obj) {
                var _ = obj.config, opts = _object_without_properties_loose(obj, [
                    "config"
                ]);
                // The config object is internal only so we must
                // not pass it to the user-defined loader()
                return customImageLoader(opts);
            }, loader = _tmp, _tmp;
        }
        // Remove property so it's not spread on <img>
        delete rest.loader;
    }
    var staticSrc = "";
    if (isStaticImport(src)) {
        var staticImageData = isStaticRequire(src) ? src.default : src;
        if (!staticImageData.src) {
            throw new Error("An object should only be passed to the image component src parameter if it comes from a static image import. It must include src. Received ".concat(JSON.stringify(staticImageData)));
        }
        blurDataURL = blurDataURL || staticImageData.blurDataURL;
        staticSrc = staticImageData.src;
        if (!layout || layout !== "fill") {
            height = height || staticImageData.height;
            width = width || staticImageData.width;
            if (!staticImageData.height || !staticImageData.width) {
                throw new Error("An object should only be passed to the image component src parameter if it comes from a static image import. It must include height and width. Received ".concat(JSON.stringify(staticImageData)));
            }
        }
    }
    src = typeof src === "string" ? src : staticSrc;
    var isLazy = !priority && (loading === "lazy" || typeof loading === "undefined");
    if (src.startsWith("data:") || src.startsWith("blob:")) {
        // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/Data_URIs
        unoptimized = true;
        isLazy = false;
    }
    if ( true && loadedImageURLs.has(src)) {
        isLazy = false;
    }
    if (config.unoptimized) {
        unoptimized = true;
    }
    var ref = _slicedToArray((0, _react).useState(false), 2), blurComplete = ref[0], setBlurComplete = ref[1];
    var ref1 = _slicedToArray((0, _useIntersection).useIntersection({
        rootRef: lazyRoot,
        rootMargin: lazyBoundary || "200px",
        disabled: !isLazy
    }), 3), setIntersection = ref1[0], isIntersected = ref1[1], resetIntersected = ref1[2];
    var isVisible = !isLazy || isIntersected;
    var wrapperStyle = {
        boxSizing: "border-box",
        display: "block",
        overflow: "hidden",
        width: "initial",
        height: "initial",
        background: "none",
        opacity: 1,
        border: 0,
        margin: 0,
        padding: 0
    };
    var sizerStyle = {
        boxSizing: "border-box",
        display: "block",
        width: "initial",
        height: "initial",
        background: "none",
        opacity: 1,
        border: 0,
        margin: 0,
        padding: 0
    };
    var hasSizer = false;
    var sizerSvgUrl;
    var layoutStyle = {
        position: "absolute",
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        boxSizing: "border-box",
        padding: 0,
        border: "none",
        margin: "auto",
        display: "block",
        width: 0,
        height: 0,
        minWidth: "100%",
        maxWidth: "100%",
        minHeight: "100%",
        maxHeight: "100%",
        objectFit: objectFit,
        objectPosition: objectPosition
    };
    var widthInt = getInt(width);
    var heightInt = getInt(height);
    var qualityInt = getInt(quality);
    if (false) { var overwrittenStyles, url, urlStr, VALID_BLUR_EXT; }
    var imgStyle = Object.assign({}, style, layoutStyle);
    var blurStyle = placeholder === "blur" && !blurComplete ? {
        backgroundSize: objectFit || "cover",
        backgroundPosition: objectPosition || "0% 0%",
        filter: "blur(20px)",
        backgroundImage: 'url("'.concat(blurDataURL, '")')
    } : {};
    if (layout === "fill") {
        // <Image src="i.png" layout="fill" />
        wrapperStyle.display = "block";
        wrapperStyle.position = "absolute";
        wrapperStyle.top = 0;
        wrapperStyle.left = 0;
        wrapperStyle.bottom = 0;
        wrapperStyle.right = 0;
    } else if (typeof widthInt !== "undefined" && typeof heightInt !== "undefined") {
        // <Image src="i.png" width="100" height="100" />
        var quotient = heightInt / widthInt;
        var paddingTop = isNaN(quotient) ? "100%" : "".concat(quotient * 100, "%");
        if (layout === "responsive") {
            // <Image src="i.png" width="100" height="100" layout="responsive" />
            wrapperStyle.display = "block";
            wrapperStyle.position = "relative";
            hasSizer = true;
            sizerStyle.paddingTop = paddingTop;
        } else if (layout === "intrinsic") {
            // <Image src="i.png" width="100" height="100" layout="intrinsic" />
            wrapperStyle.display = "inline-block";
            wrapperStyle.position = "relative";
            wrapperStyle.maxWidth = "100%";
            hasSizer = true;
            sizerStyle.maxWidth = "100%";
            sizerSvgUrl = "data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%27".concat(widthInt, "%27%20height=%27").concat(heightInt, "%27/%3e");
        } else if (layout === "fixed") {
            // <Image src="i.png" width="100" height="100" layout="fixed" />
            wrapperStyle.display = "inline-block";
            wrapperStyle.position = "relative";
            wrapperStyle.width = widthInt;
            wrapperStyle.height = heightInt;
        }
    } else {
        // <Image src="i.png" />
        if (false) {}
    }
    var imgAttributes = {
        src: emptyDataURL,
        srcSet: undefined,
        sizes: undefined
    };
    if (isVisible) {
        imgAttributes = generateImgAttrs({
            config: config,
            src: src,
            unoptimized: unoptimized,
            layout: layout,
            width: widthInt,
            quality: qualityInt,
            sizes: sizes,
            loader: loader
        });
    }
    var srcString = src;
    if (false) { var fullUrl; }
    var imageSrcSetPropName = "imagesrcset";
    var imageSizesPropName = "imagesizes";
    if (false) {}
    var _obj;
    var linkProps = (_obj = {}, // Note: imagesrcset and imagesizes are not in the link element type with react 17.
    _defineProperty(_obj, imageSrcSetPropName, imgAttributes.srcSet), _defineProperty(_obj, imageSizesPropName, imgAttributes.sizes), _obj);
    var useLayoutEffect =  false ? 0 : _react.default.useLayoutEffect;
    var onLoadingCompleteRef = (0, _react).useRef(onLoadingComplete);
    var previousImageSrc = (0, _react).useRef(src);
    (0, _react).useEffect(function() {
        onLoadingCompleteRef.current = onLoadingComplete;
    }, [
        onLoadingComplete
    ]);
    useLayoutEffect(function() {
        if (previousImageSrc.current !== src) {
            resetIntersected();
            previousImageSrc.current = src;
        }
    }, [
        resetIntersected,
        src
    ]);
    var imgElementArgs = _extends({
        isLazy: isLazy,
        imgAttributes: imgAttributes,
        heightInt: heightInt,
        widthInt: widthInt,
        qualityInt: qualityInt,
        layout: layout,
        className: className,
        imgStyle: imgStyle,
        blurStyle: blurStyle,
        loading: loading,
        config: config,
        unoptimized: unoptimized,
        placeholder: placeholder,
        loader: loader,
        srcString: srcString,
        onLoadingCompleteRef: onLoadingCompleteRef,
        setBlurComplete: setBlurComplete,
        setIntersection: setIntersection,
        isVisible: isVisible,
        noscriptSizes: sizes
    }, rest);
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("span", {
        style: wrapperStyle
    }, hasSizer ? /*#__PURE__*/ _react.default.createElement("span", {
        style: sizerStyle
    }, sizerSvgUrl ? /*#__PURE__*/ _react.default.createElement("img", {
        style: {
            display: "block",
            maxWidth: "100%",
            width: "initial",
            height: "initial",
            background: "none",
            opacity: 1,
            border: 0,
            margin: 0,
            padding: 0
        },
        alt: "",
        "aria-hidden": true,
        src: sizerSvgUrl
    }) : null) : null, /*#__PURE__*/ _react.default.createElement(ImageElement, Object.assign({}, imgElementArgs))), priority ? // for browsers that do not support `imagesrcset`, and in those cases
    // it would likely cause the incorrect image to be preloaded.
    //
    // https://html.spec.whatwg.org/multipage/semantics.html#attr-link-imagesrcset
    /*#__PURE__*/ _react.default.createElement(_head.default, null, /*#__PURE__*/ _react.default.createElement("link", Object.assign({
        key: "__nimg-" + imgAttributes.src + imgAttributes.srcSet + imgAttributes.sizes,
        rel: "preload",
        as: "image",
        href: imgAttributes.srcSet ? undefined : imgAttributes.src
    }, linkProps))) : null);
}
function normalizeSrc(src) {
    return src[0] === "/" ? src.slice(1) : src;
}
var configEnv = {"deviceSizes":[640,750,828,1080,1200,1920,2048,3840],"imageSizes":[16,32,48,64,96,128,256,384],"path":"/_next/image","loader":"default","dangerouslyAllowSVG":true,"unoptimized":true};
var loadedImageURLs = new Set();
var allImgs = new Map();
var perfObserver;
var emptyDataURL = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
if (false) {}
var VALID_LOADING_VALUES = (/* unused pure expression or super */ null && ([
    "lazy",
    "eager",
    undefined
]));
function imgixLoader(param) {
    var config = param.config, src = param.src, width = param.width, quality = param.quality;
    // Demo: https://static.imgix.net/daisy.png?auto=format&fit=max&w=300
    var url = new URL("".concat(config.path).concat(normalizeSrc(src)));
    var params = url.searchParams;
    // auto params can be combined with comma separation, or reiteration
    params.set("auto", params.getAll("auto").join(",") || "format");
    params.set("fit", params.get("fit") || "max");
    params.set("w", params.get("w") || width.toString());
    if (quality) {
        params.set("q", quality.toString());
    }
    return url.href;
}
function akamaiLoader(param) {
    var config = param.config, src = param.src, width = param.width;
    return "".concat(config.path).concat(normalizeSrc(src), "?imwidth=").concat(width);
}
function cloudinaryLoader(param) {
    var config = param.config, src = param.src, width = param.width, quality = param.quality;
    // Demo: https://res.cloudinary.com/demo/image/upload/w_300,c_limit,q_auto/turtles.jpg
    var params = [
        "f_auto",
        "c_limit",
        "w_" + width,
        "q_" + (quality || "auto")
    ];
    var paramsString = params.join(",") + "/";
    return "".concat(config.path).concat(paramsString).concat(normalizeSrc(src));
}
function customLoader(param) {
    var src = param.src;
    throw new Error('Image with src "'.concat(src, '" is missing "loader" prop.') + "\nRead more: https://nextjs.org/docs/messages/next-image-missing-loader");
}
function defaultLoader(param) {
    var config = param.config, src = param.src, width = param.width, quality = param.quality;
    if (false) { var hasMatch, parsedSrc, missingValues; }
    if (src.endsWith(".svg") && !config.dangerouslyAllowSVG) {
        // Special case to make svg serve as-is to avoid proxying
        // through the built-in Image Optimization API.
        return src;
    }
    return "".concat((0, _normalizeTrailingSlash).normalizePathTrailingSlash(config.path), "?url=").concat(encodeURIComponent(src), "&w=").concat(width, "&q=").concat(quality || 75);
}
var loaders = new Map([
    [
        "default",
        defaultLoader
    ],
    [
        "imgix",
        imgixLoader
    ],
    [
        "cloudinary",
        cloudinaryLoader
    ],
    [
        "akamai",
        akamaiLoader
    ],
    [
        "custom",
        customLoader
    ], 
]);
var VALID_LAYOUT_VALUES = (/* unused pure expression or super */ null && ([
    "fill",
    "fixed",
    "intrinsic",
    "responsive",
    undefined, 
]));
function isStaticRequire(src) {
    return src.default !== undefined;
}
function isStaticImageData(src) {
    return src.src !== undefined;
}
function isStaticImport(src) {
    return typeof src === "object" && (isStaticRequire(src) || isStaticImageData(src));
}
function getWidths(param, width, layout, sizes) {
    var deviceSizes = param.deviceSizes, allSizes = param.allSizes;
    if (sizes && (layout === "fill" || layout === "responsive")) {
        // Find all the "vw" percent sizes used in the sizes prop
        var viewportWidthRe = /(^|\s)(1?\d?\d)vw/g;
        var percentSizes = [];
        for(var match; match = viewportWidthRe.exec(sizes); match){
            percentSizes.push(parseInt(match[2]));
        }
        if (percentSizes.length) {
            var _Math;
            var smallestRatio = (_Math = Math).min.apply(_Math, _toConsumableArray(percentSizes)) * 0.01;
            return {
                widths: allSizes.filter(function(s) {
                    return s >= deviceSizes[0] * smallestRatio;
                }),
                kind: "w"
            };
        }
        return {
            widths: allSizes,
            kind: "w"
        };
    }
    if (typeof width !== "number" || layout === "fill" || layout === "responsive") {
        return {
            widths: deviceSizes,
            kind: "w"
        };
    }
    var widths = _toConsumableArray(new Set(// > are actually 3x in the green color, but only 1.5x in the red and
    // > blue colors. Showing a 3x resolution image in the app vs a 2x
    // > resolution image will be visually the same, though the 3x image
    // > takes significantly more data. Even true 3x resolution screens are
    // > wasteful as the human eye cannot see that level of detail without
    // > something like a magnifying glass.
    // https://blog.twitter.com/engineering/en_us/topics/infrastructure/2019/capping-image-fidelity-on-ultra-high-resolution-devices.html
    [
        width,
        width * 2 /*, width * 3*/ 
    ].map(function(w) {
        return allSizes.find(function(p) {
            return p >= w;
        }) || allSizes[allSizes.length - 1];
    })));
    return {
        widths: widths,
        kind: "x"
    };
}
function generateImgAttrs(param) {
    var config = param.config, src = param.src, unoptimized = param.unoptimized, layout = param.layout, width = param.width, quality = param.quality, sizes = param.sizes, loader = param.loader;
    if (unoptimized) {
        return {
            src: src,
            srcSet: undefined,
            sizes: undefined
        };
    }
    var ref = getWidths(config, width, layout, sizes), widths = ref.widths, kind = ref.kind;
    var last = widths.length - 1;
    return {
        sizes: !sizes && kind === "w" ? "100vw" : sizes,
        srcSet: widths.map(function(w, i) {
            return "".concat(loader({
                config: config,
                src: src,
                quality: quality,
                width: w
            }), " ").concat(kind === "w" ? w : i + 1).concat(kind);
        }).join(", "),
        // It's intended to keep `src` the last attribute because React updates
        // attributes in order. If we keep `src` the first one, Safari will
        // immediately start to fetch `src`, before `sizes` and `srcSet` are even
        // updated by React. That causes multiple unnecessary requests if `srcSet`
        // and `sizes` are defined.
        // This bug cannot be reproduced in Chrome or Firefox.
        src: loader({
            config: config,
            src: src,
            quality: quality,
            width: widths[last]
        })
    };
}
function getInt(x) {
    if (typeof x === "number") {
        return x;
    }
    if (typeof x === "string") {
        return parseInt(x, 10);
    }
    return undefined;
}
function defaultImageLoader(loaderProps) {
    var ref;
    var loaderKey = ((ref = loaderProps.config) == null ? void 0 : ref.loader) || "default";
    var load = loaders.get(loaderKey);
    if (load) {
        return load(loaderProps);
    }
    throw new Error('Unknown "loader" found in "next.config.js". Expected: '.concat(_imageConfig.VALID_LOADERS.join(", "), ". Received: ").concat(loaderKey));
}
// See https://stackoverflow.com/q/39777833/266535 for why we use this ref
// handler instead of the img's onLoad attribute.
function handleLoading(img, src, layout, placeholder, onLoadingCompleteRef, setBlurComplete) {
    if (!img || img.src === emptyDataURL || img["data-loaded-src"] === src) {
        return;
    }
    img["data-loaded-src"] = src;
    var p = "decode" in img ? img.decode() : Promise.resolve();
    p.catch(function() {}).then(function() {
        if (!img.parentNode) {
            // Exit early in case of race condition:
            // - onload() is called
            // - decode() is called but incomplete
            // - unmount is called
            // - decode() completes
            return;
        }
        loadedImageURLs.add(src);
        if (placeholder === "blur") {
            setBlurComplete(true);
        }
        if (onLoadingCompleteRef == null ? void 0 : onLoadingCompleteRef.current) {
            var naturalWidth = img.naturalWidth, naturalHeight = img.naturalHeight;
            // Pass back read-only primitive values but not the
            // underlying DOM element because it could be misused.
            onLoadingCompleteRef.current({
                naturalWidth: naturalWidth,
                naturalHeight: naturalHeight
            });
        }
        if (false) { var parent, ref; }
    });
}
var ImageElement = function(_param) {
    var imgAttributes = _param.imgAttributes, heightInt = _param.heightInt, widthInt = _param.widthInt, qualityInt = _param.qualityInt, layout = _param.layout, className = _param.className, imgStyle = _param.imgStyle, blurStyle = _param.blurStyle, isLazy = _param.isLazy, placeholder = _param.placeholder, loading = _param.loading, srcString = _param.srcString, config = _param.config, unoptimized = _param.unoptimized, loader = _param.loader, onLoadingCompleteRef = _param.onLoadingCompleteRef, setBlurComplete = _param.setBlurComplete, setIntersection = _param.setIntersection, onLoad = _param.onLoad, onError = _param.onError, isVisible = _param.isVisible, noscriptSizes = _param.noscriptSizes, rest = _object_without_properties_loose(_param, [
        "imgAttributes",
        "heightInt",
        "widthInt",
        "qualityInt",
        "layout",
        "className",
        "imgStyle",
        "blurStyle",
        "isLazy",
        "placeholder",
        "loading",
        "srcString",
        "config",
        "unoptimized",
        "loader",
        "onLoadingCompleteRef",
        "setBlurComplete",
        "setIntersection",
        "onLoad",
        "onError",
        "isVisible",
        "noscriptSizes"
    ]);
    loading = isLazy ? "lazy" : loading;
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("img", Object.assign({}, rest, imgAttributes, {
        decoding: "async",
        "data-nimg": layout,
        className: className,
        style: _extends({}, imgStyle, blurStyle),
        ref: (0, _react).useCallback(function(img) {
            if (false) {}
            setIntersection(img);
            if (img == null ? void 0 : img.complete) {
                handleLoading(img, srcString, layout, placeholder, onLoadingCompleteRef, setBlurComplete);
            }
        }, [
            setIntersection,
            srcString,
            layout,
            placeholder,
            onLoadingCompleteRef,
            setBlurComplete, 
        ]),
        onLoad: function(event) {
            var img = event.currentTarget;
            handleLoading(img, srcString, layout, placeholder, onLoadingCompleteRef, setBlurComplete);
            if (onLoad) {
                onLoad(event);
            }
        },
        onError: function(event) {
            if (placeholder === "blur") {
                // If the real image fails to load, this will still remove the placeholder.
                setBlurComplete(true);
            }
            if (onError) {
                onError(event);
            }
        }
    })), (isLazy || placeholder === "blur") && /*#__PURE__*/ _react.default.createElement("noscript", null, /*#__PURE__*/ _react.default.createElement("img", Object.assign({}, rest, generateImgAttrs({
        config: config,
        src: srcString,
        unoptimized: unoptimized,
        layout: layout,
        width: widthInt,
        quality: qualityInt,
        sizes: noscriptSizes,
        loader: loader
    }), {
        decoding: "async",
        "data-nimg": layout,
        style: imgStyle,
        className: className,
        // @ts-ignore - TODO: upgrade to `@types/react@17`
        loading: loading
    }))));
};
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=image.js.map


/***/ }),

/***/ 57190:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _slicedToArray = (__webpack_require__(94941)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.useIntersection = useIntersection;
var _react = __webpack_require__(67294);
var _requestIdleCallback = __webpack_require__(9311);
var hasIntersectionObserver = typeof IntersectionObserver === "function";
var observers = new Map();
var idList = [];
function createObserver(options) {
    var id = {
        root: options.root || null,
        margin: options.rootMargin || ""
    };
    var existing = idList.find(function(obj) {
        return obj.root === id.root && obj.margin === id.margin;
    });
    var instance;
    if (existing) {
        instance = observers.get(existing);
        if (instance) {
            return instance;
        }
    }
    var elements = new Map();
    var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            var callback = elements.get(entry.target);
            var isVisible = entry.isIntersecting || entry.intersectionRatio > 0;
            if (callback && isVisible) {
                callback(isVisible);
            }
        });
    }, options);
    instance = {
        id: id,
        observer: observer,
        elements: elements
    };
    idList.push(id);
    observers.set(id, instance);
    return instance;
}
function observe(element, callback, options) {
    var ref = createObserver(options), id = ref.id, observer = ref.observer, elements = ref.elements;
    elements.set(element, callback);
    observer.observe(element);
    return function unobserve() {
        elements.delete(element);
        observer.unobserve(element);
        // Destroy observer when there's nothing left to watch:
        if (elements.size === 0) {
            observer.disconnect();
            observers.delete(id);
            var index = idList.findIndex(function(obj) {
                return obj.root === id.root && obj.margin === id.margin;
            });
            if (index > -1) {
                idList.splice(index, 1);
            }
        }
    };
}
function useIntersection(param) {
    var rootRef = param.rootRef, rootMargin = param.rootMargin, disabled = param.disabled;
    var isDisabled = disabled || !hasIntersectionObserver;
    var ref = _slicedToArray((0, _react).useState(false), 2), visible = ref[0], setVisible = ref[1];
    var ref1 = _slicedToArray((0, _react).useState(null), 2), element = ref1[0], setElement = ref1[1];
    (0, _react).useEffect(function() {
        if (hasIntersectionObserver) {
            if (isDisabled || visible) return;
            if (element && element.tagName) {
                var unobserve = observe(element, function(isVisible) {
                    return isVisible && setVisible(isVisible);
                }, {
                    root: rootRef == null ? void 0 : rootRef.current,
                    rootMargin: rootMargin
                });
                return unobserve;
            }
        } else {
            if (!visible) {
                var idleCallback = (0, _requestIdleCallback).requestIdleCallback(function() {
                    return setVisible(true);
                });
                return function() {
                    return (0, _requestIdleCallback).cancelIdleCallback(idleCallback);
                };
            }
        }
    }, [
        element,
        isDisabled,
        rootMargin,
        rootRef,
        visible
    ]);
    var resetVisible = (0, _react).useCallback(function() {
        setVisible(false);
    }, []);
    return [
        setElement,
        visible,
        resetVisible
    ];
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=use-intersection.js.map


/***/ }),

/***/ 90638:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _instanceof = (__webpack_require__(96856)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;
var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(67294));
var _loadable = _interop_require_default(__webpack_require__(14302));
function dynamic(dynamicOptions, options) {
    var loadableFn = _loadable.default;
    var loadableOptions = {
        // A loading component is not required, so we default it
        loading: function(param) {
            var error = param.error, isLoading = param.isLoading, pastDelay = param.pastDelay;
            if (!pastDelay) return null;
            if (false) {}
            return null;
        }
    };
    // Support for direct import(), eg: dynamic(import('../hello-world'))
    // Note that this is only kept for the edge case where someone is passing in a promise as first argument
    // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
    // To make sure we don't execute the import without rendering first
    if (_instanceof(dynamicOptions, Promise)) {
        loadableOptions.loader = function() {
            return dynamicOptions;
        };
    // Support for having import as a function, eg: dynamic(() => import('../hello-world'))
    } else if (typeof dynamicOptions === "function") {
        loadableOptions.loader = dynamicOptions;
    // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
    } else if (typeof dynamicOptions === "object") {
        loadableOptions = _extends({}, loadableOptions, dynamicOptions);
    }
    // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})
    loadableOptions = _extends({}, loadableOptions, options);
    // Error if Fizz rendering is not enabled and `suspense` option is set to true
    if ( true && loadableOptions.suspense) {
        throw new Error("Invalid suspense option usage in next/dynamic. Read more: https://nextjs.org/docs/messages/invalid-dynamic-suspense");
    }
    if (false) {}
    // coming from build/babel/plugins/react-loadable-plugin.js
    if (loadableOptions.loadableGenerated) {
        loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
        delete loadableOptions.loadableGenerated;
    }
    // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
    // skip `ssr` for suspense mode and opt-in React.lazy directly
    if (typeof loadableOptions.ssr === "boolean" && !loadableOptions.suspense) {
        if (!loadableOptions.ssr) {
            delete loadableOptions.ssr;
            return noSSR(loadableFn, loadableOptions);
        }
        delete loadableOptions.ssr;
    }
    return loadableFn(loadableOptions);
}
var isServerSide = "object" === "undefined";
function noSSR(LoadableInitializer, loadableOptions) {
    // Removing webpack and modules means react-loadable won't try preloading
    delete loadableOptions.webpack;
    delete loadableOptions.modules;
    // This check is necessary to prevent react-loadable from initializing on the server
    if (!isServerSide) {
        return LoadableInitializer(loadableOptions);
    }
    var Loading = loadableOptions.loading;
    // This will only be rendered on the server side
    return function() {
        return /*#__PURE__*/ _react.default.createElement(Loading, {
            error: null,
            isLoading: true,
            pastDelay: false,
            timedOut: false
        });
    };
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=dynamic.js.map


/***/ }),

/***/ 16319:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.LoadableContext = void 0;
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(67294));
var LoadableContext = _react.default.createContext(null);
exports.LoadableContext = LoadableContext;
if (false) {} //# sourceMappingURL=loadable-context.js.map


/***/ }),

/***/ 14302:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _classCallCheck = (__webpack_require__(79658)/* ["default"] */ .Z);
var _createClass = (__webpack_require__(7222)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(67294));
var _loadableContext = __webpack_require__(16319);
var useSyncExternalStore = ( false ? 0 : __webpack_require__(61688)).useSyncExternalStore;
var ALL_INITIALIZERS = [];
var READY_INITIALIZERS = [];
var initialized = false;
function load(loader) {
    var promise = loader();
    var state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then(function(loaded) {
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch(function(err) {
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function createLoadableComponent(loadFn, options) {
    var init = function init() {
        if (!subscription) {
            var sub = new LoadableSubscription(loadFn, opts);
            subscription = {
                getCurrentValue: sub.getCurrentValue.bind(sub),
                subscribe: sub.subscribe.bind(sub),
                retry: sub.retry.bind(sub),
                promise: sub.promise.bind(sub)
            };
        }
        return subscription.promise();
    };
    var useLoadableModule = function useLoadableModule() {
        init();
        var context = _react.default.useContext(_loadableContext.LoadableContext);
        if (context && Array.isArray(opts.modules)) {
            opts.modules.forEach(function(moduleName) {
                context(moduleName);
            });
        }
    };
    var LoadableImpl = function LoadableImpl(props, ref) {
        useLoadableModule();
        var state = useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);
        _react.default.useImperativeHandle(ref, function() {
            return {
                retry: subscription.retry
            };
        }, []);
        return _react.default.useMemo(function() {
            if (state.loading || state.error) {
                return _react.default.createElement(opts.loading, {
                    isLoading: state.loading,
                    pastDelay: state.pastDelay,
                    timedOut: state.timedOut,
                    error: state.error,
                    retry: subscription.retry
                });
            } else if (state.loaded) {
                return _react.default.createElement(resolve(state.loaded), props);
            } else {
                return null;
            }
        }, [
            props,
            state
        ]);
    };
    var LazyImpl = function LazyImpl(props, ref) {
        useLoadableModule();
        return _react.default.createElement(opts.lazy, _extends({}, props, {
            ref: ref
        }));
    };
    var opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        webpack: null,
        modules: null,
        suspense: false
    }, options);
    if (opts.suspense) {
        opts.lazy = _react.default.lazy(opts.loader);
    }
    /** @type LoadableSubscription */ var subscription = null;
    // Server only
    if (false) {}
    // Client only
    if (!initialized && "object" !== "undefined") {
        // require.resolveWeak check is needed for environments that don't have it available like Jest
        var moduleIds = opts.webpack && "function" === "function" ? opts.webpack() : opts.modules;
        if (moduleIds) {
            READY_INITIALIZERS.push(function(ids) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = moduleIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var moduleId = _step.value;
                        if (ids.indexOf(moduleId) !== -1) {
                            return init();
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            });
        }
    }
    var LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;
    LoadableComponent.preload = function() {
        return init();
    };
    LoadableComponent.displayName = "LoadableComponent";
    return _react.default.forwardRef(LoadableComponent);
}
var LoadableSubscription = /*#__PURE__*/ function() {
    function LoadableSubscription(loadFn, opts) {
        _classCallCheck(this, LoadableSubscription);
        this._loadFn = loadFn;
        this._opts = opts;
        this._callbacks = new Set();
        this._delay = null;
        this._timeout = null;
        this.retry();
    }
    _createClass(LoadableSubscription, [
        {
            key: "promise",
            value: function promise() {
                return this._res.promise;
            }
        },
        {
            key: "retry",
            value: function retry() {
                var _this = this;
                this._clearTimeouts();
                this._res = this._loadFn(this._opts.loader);
                this._state = {
                    pastDelay: false,
                    timedOut: false
                };
                var ref = this, res = ref._res, opts = ref._opts;
                if (res.loading) {
                    if (typeof opts.delay === "number") {
                        if (opts.delay === 0) {
                            this._state.pastDelay = true;
                        } else {
                            this._delay = setTimeout(function() {
                                _this._update({
                                    pastDelay: true
                                });
                            }, opts.delay);
                        }
                    }
                    if (typeof opts.timeout === "number") {
                        this._timeout = setTimeout(function() {
                            _this._update({
                                timedOut: true
                            });
                        }, opts.timeout);
                    }
                }
                this._res.promise.then(function() {
                    _this._update({});
                    _this._clearTimeouts();
                }).catch(function(_err) {
                    _this._update({});
                    _this._clearTimeouts();
                });
                this._update({});
            }
        },
        {
            key: "_update",
            value: function _update(partial) {
                this._state = _extends({}, this._state, {
                    error: this._res.error,
                    loaded: this._res.loaded,
                    loading: this._res.loading
                }, partial);
                this._callbacks.forEach(function(callback) {
                    return callback();
                });
            }
        },
        {
            key: "_clearTimeouts",
            value: function _clearTimeouts() {
                clearTimeout(this._delay);
                clearTimeout(this._timeout);
            }
        },
        {
            key: "getCurrentValue",
            value: function getCurrentValue() {
                return this._state;
            }
        },
        {
            key: "subscribe",
            value: function subscribe(callback) {
                var _this = this;
                this._callbacks.add(callback);
                return function() {
                    _this._callbacks.delete(callback);
                };
            }
        }
    ]);
    return LoadableSubscription;
}();
function Loadable(opts) {
    return createLoadableComponent(load, opts);
}
function flushInitializers(initializers, ids) {
    var promises = [];
    while(initializers.length){
        var init = initializers.pop();
        promises.push(init(ids));
    }
    return Promise.all(promises).then(function() {
        if (initializers.length) {
            return flushInitializers(initializers, ids);
        }
    });
}
Loadable.preloadAll = function() {
    return new Promise(function(resolveInitializers, reject) {
        flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
    });
};
Loadable.preloadReady = function() {
    var ids = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return new Promise(function(resolvePreload) {
        var res = function() {
            initialized = true;
            return resolvePreload();
        };
        // We always will resolve, errors should be handled within loading UIs.
        flushInitializers(READY_INITIALIZERS, ids).then(res, res);
    });
};
if (true) {
    window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}
var _default = Loadable;
exports["default"] = _default; //# sourceMappingURL=loadable.js.map


/***/ }),

/***/ 33172:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var sysconfig__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66225);
/* eslint-disable camelcase */ 
var url = "https://api.telegram.org/bot[BOT_API_KEY]/sendMessage?chat_id=[MY_CHANNEL_NAME]&message_thread_id=[MY_THREAD_ID]&text=[MY_MESSAGE_TEXT]";
var urlApiTele = url === null || url === void 0 ? void 0 : url.replace("[BOT_API_KEY]", sysconfig__WEBPACK_IMPORTED_MODULE_0__/* .BOT_TELE_ORDER_TOKEN */ .ch);
var sendMessage = function(param) {
    var _channelID = param.channelID, channelID = _channelID === void 0 ? sysconfig__WEBPACK_IMPORTED_MODULE_0__/* .BOT_TELE_CHANNEL_ID */ .RR : _channelID, message = param.message, message_thread_id = param.message_thread_id;
    return fetch(urlApiTele === null || urlApiTele === void 0 ? void 0 : urlApiTele.replace("[MY_CHANNEL_NAME]", channelID).replace("[MY_MESSAGE_TEXT]", "[".concat(sysconfig__WEBPACK_IMPORTED_MODULE_0__/* .ENV */ .Vi, "] ").concat(message)).replace("[MY_THREAD_ID]", message_thread_id));
};
var sendMesageBotOrderKh = function(param) {
    var message = param.message;
    return sendMessage({
        message: message,
        message_thread_id: 4
    });
};
var sendMesageBotOrderTh = function(param) {
    var message = param.message;
    return sendMessage({
        message: message,
        message_thread_id: 1005853
    });
};
var sendMesageError = function(param) {
    var message = param.message;
    return sendMessage({
        message: message,
        message_thread_id: 1005859
    });
};
var sendMesageBotOrderVn = function(param) {
    var message = param.message;
    return sendMessage({
        message: message,
        message_thread_id: 3
    });
};
var sendMesageReport = function(param) {
    var message = param.message;
    return sendMessage({
        message: message,
        message_thread_id: 1005859
    });
};
var sendMesageSlowApi = function(param) {
    var message = param.message;
    return sendMessage({
        message: message,
        message_thread_id: 1005859
    });
};
// const findThreadId = async () => {
//   for (let i = 200; i < 300; i += 1) {
//     console.log('🚀 ~ file: BotClient.js:24 ~ findThreadId ~ i:', i);
//     await sendMessage({ message: `threadId : ${i}`, message_thread_id: i });
//   }
// };
/* harmony default export */ __webpack_exports__["Z"] = ({
    sendMessage: sendMessage,
    sendMesageBotOrderVn: sendMesageBotOrderVn,
    sendMesageError: sendMesageError,
    sendMesageBotOrderTh: sendMesageBotOrderTh,
    sendMesageBotOrderKh: sendMesageBotOrderKh,
    sendMesageReport: sendMesageReport,
    sendMesageSlowApi: sendMesageSlowApi
});


/***/ }),

/***/ 10741:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(97582);
/* harmony import */ var constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83679);
/* harmony import */ var _Clients__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38307);






var getCartItemList = function(param) {
    var ctx = param.ctx, _params = param.params, params = _params === void 0 ? {
        onlyQuantity: true
    } : _params;
    return (0,_Clients__WEBPACK_IMPORTED_MODULE_1__.GET)({
        ctx: ctx,
        url: constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .CART_API.CART_ITEM_LIST */ .kx.CART_ITEM_LIST,
        params: params
    });
};
var convertBody = function() {
    var body = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, body), {
        source: "thuocsi-web"
    });
};
var loadDataCart = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(ctx) {
        var _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_1__.GET)((_tmp.url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .CART_API.CART_INFO_V2 */ .kx.CART_INFO_V2, _tmp.ctx = ctx, _tmp))
            ];
        });
    });
    return function loadDataCart(ctx) {
        return _ref.apply(this, arguments);
    };
}();
var checkout = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(body) {
        var _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_1__.PUT)((_tmp.url = "/marketplace/order/v2/cart/checkout", _tmp.body = convertBody(body), _tmp))
            ];
        });
    });
    return function checkout(body) {
        return _ref.apply(this, arguments);
    };
}();
var updateCart = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(param) {
        var body, ctx, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            body = param.body, ctx = param.ctx;
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_1__.PUT)((_tmp.url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .CART_API.CART_INFO */ .kx.CART_INFO, _tmp.ctx = ctx, _tmp.body = convertBody(body), _tmp))
            ];
        });
    });
    return function updateCart(_) {
        return _ref.apply(this, arguments);
    };
}();
var getCartIngredient = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
        var _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_1__.GET)((_tmp.url = "/marketplace/order/v2/cart/ingredients", _tmp))
            ];
        });
    });
    return function getCartIngredient() {
        return _ref.apply(this, arguments);
    };
}();
var updateCartItem = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(data) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, body, _tmp, _tmp1;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            _tmp = {};
            body = (_tmp.sku = data.product.sku, _tmp.type = (data === null || data === void 0 ? void 0 : (ref = data.product) === null || ref === void 0 ? void 0 : ref.type) || null, _tmp.isDeal = data === null || data === void 0 ? void 0 : (ref1 = data.product) === null || ref1 === void 0 ? void 0 : ref1.isDeal, _tmp.name = data === null || data === void 0 ? void 0 : (ref2 = data.product) === null || ref2 === void 0 ? void 0 : ref2.name, _tmp.price = (data === null || data === void 0 ? void 0 : (ref3 = data.product) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.deal) === null || ref4 === void 0 ? void 0 : ref4.price) || (data === null || data === void 0 ? void 0 : (ref5 = data.product) === null || ref5 === void 0 ? void 0 : ref5.salePrice) || 0, _tmp.quantity = data.q, _tmp.cartNo = data === null || data === void 0 ? void 0 : data.cartNo, _tmp.page = data === null || data === void 0 ? void 0 : data.page, _tmp.searchKey = data === null || data === void 0 ? void 0 : data.searchKey, _tmp.sellerID = (data === null || data === void 0 ? void 0 : data.sellerID) || null, _tmp.sellerCode = (data === null || data === void 0 ? void 0 : (ref6 = data.product) === null || ref6 === void 0 ? void 0 : ref6.sellerCode) || null, _tmp.productId = (data === null || data === void 0 ? void 0 : (ref7 = data.product) === null || ref7 === void 0 ? void 0 : ref7.productId) || null, _tmp.eventSource = (data === null || data === void 0 ? void 0 : data.eventSource) || "", _tmp.eventScreen = (data === null || data === void 0 ? void 0 : data.eventScreen) || "", _tmp);
            _tmp1 = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_1__.POST)((_tmp1.url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .CART_API.CART_ADD */ .kx.CART_ADD, _tmp1.body = convertBody(body), _tmp1))
            ];
        });
    });
    return function updateCartItem(data) {
        return _ref.apply(this, arguments);
    };
}();
// { sku, quantity, isImportant }
var updateCartItemImportant = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(body) {
        var _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_1__.PUT)((_tmp.url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .CART_API.CART_ITEM */ .kx.CART_ITEM, _tmp.body = convertBody(body), _tmp))
            ];
        });
    });
    return function updateCartItemImportant(body) {
        return _ref.apply(this, arguments);
    };
}();
var removeCartItem = function(body) {
    return (0,_Clients__WEBPACK_IMPORTED_MODULE_1__.PUT)({
        url: constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .CART_API.CART_REMOVE */ .kx.CART_REMOVE,
        body: convertBody(body)
    });
};
var updateRedeemCode = function(redeemCode) {
    var body = {
        redeemCode: redeemCode
    };
    return (0,_Clients__WEBPACK_IMPORTED_MODULE_1__.PUT)({
        url: constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .CART_API.CART_UPDATE_REDEEM_CODE */ .kx.CART_UPDATE_REDEEM_CODE,
        body: convertBody(body)
    });
};
var updateDeliveryMethod = function(body) {
    return (0,_Clients__WEBPACK_IMPORTED_MODULE_1__.PUT)({
        url: constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .CART_API.DELIVERY_METHOD_UPDATE */ .kx.DELIVERY_METHOD_UPDATE,
        body: convertBody(body)
    });
};
var updatePaymentMethod = function(body) {
    return (0,_Clients__WEBPACK_IMPORTED_MODULE_1__.PUT)({
        url: constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .CART_API.PAYMENT_METHOD_UPDATE */ .kx.PAYMENT_METHOD_UPDATE,
        body: convertBody(body)
    });
};
var updateNote = function(note) {
    var body = {
        note: note
    };
    return (0,_Clients__WEBPACK_IMPORTED_MODULE_1__.PUT)({
        url: constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .CART_API.CART_INFO */ .kx.CART_INFO,
        body: convertBody(body)
    });
};
var reOrder = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(body) {
        var _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_1__.POST)((_tmp.url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .CART_API.RE_ORDER */ .kx.RE_ORDER, _tmp.body = body, _tmp))
            ];
        });
    });
    return function reOrder(body) {
        return _ref.apply(this, arguments);
    };
}();
var confirmChangePrice = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(body) {
        var _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_1__.POST)((_tmp.url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .CART_API.CONFIRM */ .kx.CONFIRM, _tmp.body = body, _tmp))
            ];
        });
    });
    return function confirmChangePrice(body) {
        return _ref.apply(this, arguments);
    };
}();
var getDeliveryLimitation = function(param) {
    var ctx = param.ctx;
    return (0,_Clients__WEBPACK_IMPORTED_MODULE_1__.GET)({
        ctx: ctx,
        url: constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .CART_API.DELIVERY_LIMITATION */ .kx.DELIVERY_LIMITATION
    });
};
// APO-08 : tính năng đặt 1 môt giỏ hàng
// select / un-select item
// body : { isSelected, sku , isAppliedAll  }
// isSelected : true / false là có chọn hay không
// nếu theo sku thì có field sku
// nếu select all thì => isAppliedAll : true , isSelected: true
// nếu un-select all thì => isAppliedAll : false , isSelected: true
// https://buymed.atlassian.net/browse/APO-41
// chọn từng item
var selectCartItem = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(param) {
        var sku, skus, isSelected, isAppliedAll, cartNo, name, quantity, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            sku = param.sku, skus = param.skus, isSelected = param.isSelected, isAppliedAll = param.isAppliedAll, cartNo = param.cartNo, name = param.name, quantity = param.quantity;
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_1__.PUT)((_tmp.url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .CART_API.SELECT_ITEM */ .kx.SELECT_ITEM, _tmp.body = {
                    isSelected: isSelected,
                    sku: sku,
                    skus: skus,
                    isAppliedAll: isAppliedAll,
                    cartNo: cartNo,
                    name: name,
                    quantity: quantity
                }, _tmp))
            ];
        });
    });
    return function selectCartItem(_) {
        return _ref.apply(this, arguments);
    };
}();
// verrify gior hangf
var verifyPayment = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(param) {
        var ctx, _body, body, _tmp, _tmp1;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            _tmp = {};
            ctx = param.ctx, _body = param.body, body = _body === void 0 ? _tmp : _body;
            _tmp1 = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_1__.POST)((_tmp1.ctx = ctx, _tmp1.url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .CART_API.VERIFY_CART */ .kx.VERIFY_CART, _tmp1.body = convertBody(body), _tmp1))
            ];
        });
    });
    return function verifyPayment(_) {
        return _ref.apply(this, arguments);
    };
}();
var putRemoveMultiRedeem = function(redeemCode, cartNo) {
    var body = {
        redeemCode: redeemCode,
        cartNo: cartNo
    };
    return (0,_Clients__WEBPACK_IMPORTED_MODULE_1__.PUT)({
        url: constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .CART_API.CART_REMOVE_MULTI_VOUCHER */ .kx.CART_REMOVE_MULTI_VOUCHER,
        body: convertBody(body)
    });
};
var putChangeMultiRedeem = function(redeemCode, cartNo) {
    var body = {
        redeemCode: redeemCode,
        cartNo: cartNo
    };
    return (0,_Clients__WEBPACK_IMPORTED_MODULE_1__.PUT)({
        url: constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .CART_API.CART_CHANGE_MULTI_VOUCHER */ .kx.CART_CHANGE_MULTI_VOUCHER,
        body: convertBody(body)
    });
};
var getPaymentLink = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(param) {
        var orderId, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            orderId = param.orderId;
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_1__.GET)((_tmp.url = "/marketplace/order/v2/order/payment-link", _tmp.params = {
                    orderId: orderId
                }, _tmp))
            ];
        });
    });
    return function getPaymentLink(_) {
        return _ref.apply(this, arguments);
    };
}();
var getPaymentInfoWithBeamGateway = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(param) {
        var ctx, orderId, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            ctx = param.ctx, orderId = param.orderId;
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_1__.GET)((_tmp.ctx = ctx, _tmp.url = "/marketplace/order/v2/beam/qrcode", _tmp.params = {
                    orderId: orderId
                }, _tmp))
            ];
        });
    });
    return function getPaymentInfoWithBeamGateway(_) {
        return _ref.apply(this, arguments);
    };
}();
var trackingPaymentStatusBeamGateway = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(param) {
        var ctx, orderId, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            ctx = param.ctx, orderId = param.orderId;
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_1__.GET)((_tmp.ctx = ctx, _tmp.url = "/marketplace/order/v2/beam/check-in", _tmp.params = {
                    orderId: orderId
                }, _tmp))
            ];
        });
    });
    return function trackingPaymentStatusBeamGateway(_) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ __webpack_exports__["Z"] = ({
    loadDataCart: loadDataCart,
    updateCartItem: updateCartItem,
    removeCartItem: removeCartItem,
    updateRedeemCode: updateRedeemCode,
    updateNote: updateNote,
    updateCartItemImportant: updateCartItemImportant,
    updateDeliveryMethod: updateDeliveryMethod,
    updatePaymentMethod: updatePaymentMethod,
    checkout: checkout,
    updateCart: updateCart,
    reOrder: reOrder,
    confirmChangePrice: confirmChangePrice,
    getDeliveryLimitation: getDeliveryLimitation,
    selectCartItem: selectCartItem,
    getCartItemList: getCartItemList,
    verifyPayment: verifyPayment,
    putRemoveMultiRedeem: putRemoveMultiRedeem,
    putChangeMultiRedeem: putChangeMultiRedeem,
    getPaymentLink: getPaymentLink,
    getCartIngredient: getCartIngredient,
    getPaymentInfoWithBeamGateway: getPaymentInfoWithBeamGateway,
    trackingPaymentStatusBeamGateway: trackingPaymentStatusBeamGateway
});


/***/ }),

/***/ 12141:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(97582);
/* harmony import */ var constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83679);
/* harmony import */ var constants_manufacturer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59893);
/* harmony import */ var utils_ArrUtils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33769);
/* harmony import */ var _Clients__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38307);






function loadBrand(_) {
    return _loadBrand.apply(this, arguments);
}
function _loadBrand() {
    _loadBrand = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(param) {
        var ctx, params, ref, res, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ctx = param.ctx, params = param.params;
                    _tmp = {};
                    return [
                        4,
                        (0,_Clients__WEBPACK_IMPORTED_MODULE_3__.GET_ALL)((_tmp.url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .PRODUCT_API.MANUFACTURER_LIST */ .PJ.MANUFACTURER_LIST, _tmp.ctx = ctx, _tmp.isBasic = true, _tmp.params = params, _tmp))
                    ];
                case 1:
                    res = _state.sent();
                    if (!(0,_Clients__WEBPACK_IMPORTED_MODULE_3__.isValid)(res)) {
                        return [
                            2,
                            []
                        ];
                    }
                    return [
                        2,
                        res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.filter(function(item) {
                            return constants_manufacturer__WEBPACK_IMPORTED_MODULE_1__/* .TopManufacturer.indexOf */ .j.indexOf(item.code) >= 0;
                        }).sort(function(a, b) {
                            var ref, ref1;
                            return (0,utils_ArrUtils__WEBPACK_IMPORTED_MODULE_2__/* .sortComparer */ .J5)((a === null || a === void 0 ? void 0 : (ref = a.name) === null || ref === void 0 ? void 0 : ref.toLowerCase()) || "", (b === null || b === void 0 ? void 0 : (ref1 = b.name) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()) || "");
                        })
                    ];
            }
        });
    });
    return _loadBrand.apply(this, arguments);
}
function loadGroup(_) {
    return _loadGroup.apply(this, arguments);
}
function _loadGroup() {
    _loadGroup = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(param) {
        var ctx, params, ref, res, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ctx = param.ctx, params = param.params;
                    _tmp = {};
                    return [
                        4,
                        (0,_Clients__WEBPACK_IMPORTED_MODULE_3__.GET)((_tmp.url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .PRODUCT_API.CATEGORY_LIST */ .PJ.CATEGORY_LIST, _tmp.ctx = ctx, _tmp.isBasic = true, _tmp.params = params, _tmp.cache = true, _tmp.cacheServer = false, _tmp))
                    ];
                case 1:
                    res = _state.sent();
                    if (!(0,_Clients__WEBPACK_IMPORTED_MODULE_3__.isValid)(res)) {
                        return [
                            2,
                            []
                        ];
                    }
                    return [
                        2,
                        res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.sort(function(a, b) {
                            var ref, ref1;
                            return (0,utils_ArrUtils__WEBPACK_IMPORTED_MODULE_2__/* .sortComparer */ .J5)((a === null || a === void 0 ? void 0 : (ref = a.name) === null || ref === void 0 ? void 0 : ref.toLowerCase()) || "", (b === null || b === void 0 ? void 0 : (ref1 = b.name) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()) || "");
                        })
                    ];
            }
        });
    });
    return _loadGroup.apply(this, arguments);
}
var loadGroupMock = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(param) {
        var ctx, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            ctx = param.ctx;
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_3__.GET)((_tmp.url = "/web/categories", _tmp.ctx = ctx, _tmp.mock = true, _tmp.isAuth = false, _tmp))
            ];
        });
    });
    return function loadGroupMock(_) {
        return _ref.apply(this, arguments);
    };
}();
function loadEfficacyList(_) {
    return _loadEfficacyList.apply(this, arguments);
}
function _loadEfficacyList() {
    _loadEfficacyList = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(param) {
        var ctx, params, res, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ctx = param.ctx, params = param.params;
                    _tmp = {};
                    return [
                        4,
                        (0,_Clients__WEBPACK_IMPORTED_MODULE_3__.GET)((_tmp.url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .PRODUCT_API.EFFICACY_LIST */ .PJ.EFFICACY_LIST, _tmp.ctx = ctx, _tmp.isBasic = true, _tmp.params = params, _tmp))
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        (0,_Clients__WEBPACK_IMPORTED_MODULE_3__.getData)(res)
                    ];
            }
        });
    });
    return _loadEfficacyList.apply(this, arguments);
}
function loadEfficacyCombinedList(_) {
    return _loadEfficacyCombinedList.apply(this, arguments);
}
function _loadEfficacyCombinedList() {
    _loadEfficacyCombinedList = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(param) {
        var ctx, params, res, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ctx = param.ctx, params = param.params;
                    _tmp = {};
                    return [
                        4,
                        (0,_Clients__WEBPACK_IMPORTED_MODULE_3__.GET)((_tmp.url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .PRODUCT_API.EFFICACY_COMBINED_LIST */ .PJ.EFFICACY_COMBINED_LIST, _tmp.ctx = ctx, _tmp.isBasic = true, _tmp.params = params, _tmp))
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        (0,_Clients__WEBPACK_IMPORTED_MODULE_3__.getData)(res)
                    ];
            }
        });
    });
    return _loadEfficacyCombinedList.apply(this, arguments);
}
function loadSellerCategoryList(_) {
    return _loadSellerCategoryList.apply(this, arguments);
}
function _loadSellerCategoryList() {
    _loadSellerCategoryList = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(param) {
        var ctx, params, res, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ctx = param.ctx, params = param.params;
                    _tmp = {};
                    return [
                        4,
                        (0,_Clients__WEBPACK_IMPORTED_MODULE_3__.GET)((_tmp.url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .PRODUCT_API.SELLER_CATEGORY_LIST */ .PJ.SELLER_CATEGORY_LIST, _tmp.ctx = ctx, _tmp.isBasic = true, _tmp.params = params, _tmp))
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        (0,_Clients__WEBPACK_IMPORTED_MODULE_3__.getData)(res)
                    ];
            }
        });
    });
    return _loadSellerCategoryList.apply(this, arguments);
}
function loadCategoryInfoBySlug(ctx) {
    return _loadCategoryInfoBySlug.apply(this, arguments);
}
function _loadCategoryInfoBySlug() {
    _loadCategoryInfoBySlug = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(ctx) {
        var query, params, _tmp, url, res, _tmp1;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    query = ctx.query;
                    _tmp = {};
                    params = (_tmp.q = JSON.stringify({
                        slug: query.slug
                    }), _tmp);
                    url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .PRODUCT_API.CATEGORY_INFO */ .PJ.CATEGORY_INFO;
                    _tmp1 = {};
                    return [
                        4,
                        (0,_Clients__WEBPACK_IMPORTED_MODULE_3__.GET)((_tmp1.url = url, _tmp1.ctx = ctx, _tmp1.params = params, _tmp1.isBasic = true, _tmp1))
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        (0,_Clients__WEBPACK_IMPORTED_MODULE_3__.getData)(res)
                    ];
            }
        });
    });
    return _loadCategoryInfoBySlug.apply(this, arguments);
}
function loadManufacturerInfoBySlug(ctx) {
    return _loadManufacturerInfoBySlug.apply(this, arguments);
}
function _loadManufacturerInfoBySlug() {
    _loadManufacturerInfoBySlug = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(ctx) {
        var query, params, _tmp, url, res, _tmp1;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    query = ctx.query;
                    _tmp = {};
                    params = (_tmp.q = JSON.stringify({
                        slug: query.slug
                    }), _tmp);
                    url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .PRODUCT_API.MANUFACTURER_INFO */ .PJ.MANUFACTURER_INFO;
                    _tmp1 = {};
                    return [
                        4,
                        (0,_Clients__WEBPACK_IMPORTED_MODULE_3__.GET)((_tmp1.url = url, _tmp1.ctx = ctx, _tmp1.params = params, _tmp1.isBasic = true, _tmp1))
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        (0,_Clients__WEBPACK_IMPORTED_MODULE_3__.getData)(res)
                    ];
            }
        });
    });
    return _loadManufacturerInfoBySlug.apply(this, arguments);
}
function loadTags(ctx) {
    return _loadTags.apply(this, arguments);
}
function _loadTags() {
    _loadTags = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(ctx) {
        var url, res, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .PRODUCT_API.TAGS */ .PJ.TAGS;
                    _tmp = {};
                    return [
                        4,
                        (0,_Clients__WEBPACK_IMPORTED_MODULE_3__.GET)((_tmp.url = url, _tmp.ctx = ctx, _tmp.isBasic = true, _tmp))
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        (0,_Clients__WEBPACK_IMPORTED_MODULE_3__.getData)(res)
                    ];
            }
        });
    });
    return _loadTags.apply(this, arguments);
}
function loadTagDetail(_) {
    return _loadTagDetail.apply(this, arguments);
}
function _loadTagDetail() {
    _loadTagDetail = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(param) {
        var ctx, params, url, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            ctx = param.ctx, params = param.params;
            url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .PRODUCT_API.TAGS */ .PJ.TAGS;
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_3__.GET)((_tmp.url = url, _tmp.ctx = ctx, _tmp.isBasic = true, _tmp.params = params, _tmp))
            ];
        });
    });
    return _loadTagDetail.apply(this, arguments);
}
function loadTagInfoBySlug(ctx) {
    return _loadTagInfoBySlug.apply(this, arguments);
}
function _loadTagInfoBySlug() {
    _loadTagInfoBySlug = // mobile V2: get tag by slug
    (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(ctx) {
        var query, params, _tmp, url, res, _tmp1;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    query = ctx.query;
                    _tmp = {};
                    params = (_tmp.q = JSON.stringify({
                        slug: query.slug
                    }), _tmp);
                    url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .PRODUCT_API.TAGS */ .PJ.TAGS;
                    _tmp1 = {};
                    return [
                        4,
                        (0,_Clients__WEBPACK_IMPORTED_MODULE_3__.GET)((_tmp1.url = url, _tmp1.ctx = ctx, _tmp1.params = params, _tmp1.isBasic = true, _tmp1))
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        (0,_Clients__WEBPACK_IMPORTED_MODULE_3__.getData)(res)
                    ];
            }
        });
    });
    return _loadTagInfoBySlug.apply(this, arguments);
}
function loadTabDetail(_) {
    return _loadTabDetail.apply(this, arguments);
}
function _loadTabDetail() {
    _loadTabDetail = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(param) {
        var ctx, params, url, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            ctx = param.ctx, params = param.params;
            url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .PRODUCT_API.TABS_ACTIVE */ .PJ.TABS_ACTIVE;
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_3__.GET)((_tmp.url = url, _tmp.ctx = ctx, _tmp.isBasic = true, _tmp.params = params, _tmp.cache = true, _tmp.cacheServer = false, _tmp))
            ];
        });
    });
    return _loadTabDetail.apply(this, arguments);
}
/* harmony default export */ __webpack_exports__["Z"] = ({
    loadBrand: loadBrand,
    loadGroup: loadGroup,
    loadGroupMock: loadGroupMock,
    loadCategoryInfoBySlug: loadCategoryInfoBySlug,
    loadManufacturerInfoBySlug: loadManufacturerInfoBySlug,
    loadTags: loadTags,
    loadTagDetail: loadTagDetail,
    loadTagInfoBySlug: loadTagInfoBySlug,
    loadTabDetail: loadTabDetail,
    loadEfficacyList: loadEfficacyList,
    loadEfficacyCombinedList: loadEfficacyCombinedList,
    loadSellerCategoryList: loadSellerCategoryList
});


/***/ }),

/***/ 38307:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "DELETE": function() { return /* binding */ DELETE; },
  "GET": function() { return /* binding */ GET; },
  "GET_ALL": function() { return /* binding */ GET_ALL; },
  "LIMIT_DEFAULT": function() { return /* binding */ LIMIT_DEFAULT; },
  "MAX_LIMIT": function() { return /* binding */ MAX_LIMIT; },
  "OFFSET_DEFAULT": function() { return /* binding */ OFFSET_DEFAULT; },
  "POST": function() { return /* binding */ POST; },
  "POST_ALL": function() { return /* binding */ POST_ALL; },
  "PUT": function() { return /* binding */ PUT; },
  "default": function() { return /* binding */ Clients; },
  "getData": function() { return /* binding */ getData; },
  "getFirst": function() { return /* binding */ getFirst; },
  "getSessionToken": function() { return /* binding */ getSessionToken; },
  "isValid": function() { return /* binding */ isValid; },
  "isValidWithData": function() { return /* binding */ isValidWithData; },
  "isValidWithoutData": function() { return /* binding */ isValidWithoutData; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./src/constants/Enums/http.js
var http = __webpack_require__(53208);
// EXTERNAL MODULE: ./src/sysconfig/index.js
var sysconfig = __webpack_require__(66225);
// EXTERNAL MODULE: ./src/utils/CacheUtils.js
var CacheUtils = __webpack_require__(85618);
// EXTERNAL MODULE: ./src/utils/CookieParser.js
var CookieParser = __webpack_require__(44777);
;// CONCATENATED MODULE: ./src/utils/RequestUtils.js
/* eslint-disable no-param-reassign */ /* eslint-disable no-restricted-syntax */ var cleanObj = function(obj) {
    for(var propName in obj){
        if (obj[propName] === null || obj[propName] === undefined) {
            delete obj[propName];
        }
    }
    return obj;
};
var convertObjectToParameter = function(params) {
    if (params == null) return "";
    return new URLSearchParams(cleanObj(params)).toString();
};
/* harmony default export */ var RequestUtils = ({
    convertObjectToParameter: convertObjectToParameter,
    cleanObj: cleanObj
});

// EXTERNAL MODULE: ./src/utils/SessionUtils.js
var SessionUtils = __webpack_require__(69702);
// EXTERNAL MODULE: ./src/clients/BotClient.js
var BotClient = __webpack_require__(33172);
;// CONCATENATED MODULE: ./src/clients/Clients.js
/* eslint-disable no-unused-vars */ 











var MAX_LIMIT = 50;
var OFFSET_DEFAULT = 0;
var LIMIT_DEFAULT = 20;
// use node-js cache with ttl = 1s
// const mapRequest = {};
var mapRequestPromise = {};
// Chống spam log khi backend/proxy chết hàng loạt: mỗi endpoint (đã bỏ query) chỉ log
// timeout tối đa 1 lần / TIMEOUT_LOG_WINDOW, kèm số lần bị dồn nén trong cửa sổ đó.
var TIMEOUT_LOG_WINDOW = 60000;
var timeoutLogMap = new Map();
function isValid(resp) {
    return resp && resp.status && resp.status === http/* HTTP_STATUS.Ok */.M.Ok && resp.data && resp.data[0];
}
function getFirst(resp) {
    var def = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    return resp && resp.data && resp.data.length > 0 ? resp.data[0] : def;
}
function getData(resp) {
    var def = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    return isValid(resp) ? resp.data : def;
}
function isValidWithoutData(resp) {
    return resp && resp.status && resp.status === http/* HTTP_STATUS.Ok */.M.Ok;
}
function getSessionToken(ctx) {
    var ref, ref1, ref2, ref3;
    // Discovery
    // if (ctx?.req?.headers?.authorization) {
    //   return ctx?.req?.headers?.authorization?.split(' ')[1];
    // }
    if ((ctx === null || ctx === void 0 ? void 0 : (ref = ctx.req) === null || ref === void 0 ? void 0 : (ref1 = ref.headers) === null || ref1 === void 0 ? void 0 : ref1.authorization) && (ctx === null || ctx === void 0 ? void 0 : (ref2 = ctx.req) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.headers) === null || ref3 === void 0 ? void 0 : ref3.isAuthorizationClient)) {
        var ref4, ref5, ref6;
        return ctx === null || ctx === void 0 ? void 0 : (ref4 = ctx.req) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.headers) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.authorization) === null || ref6 === void 0 ? void 0 : ref6.split(" ")[1];
    }
    var tk = CookieParser/* default.getCookieFromCtx */.Z.getCookieFromCtx(ctx, sysconfig/* ACCESS_TOKEN */.LA);
    if (tk && tk.length > 0) {
        return tk;
    }
    return CookieParser/* default.getCookieFromCtx */.Z.getCookieFromCtx(ctx, sysconfig/* ACCESS_TOKEN_LONGLIVE */.R$);
}
function request(_) {
    return _request.apply(this, arguments);
}
function _request() {
    _request = (0,_async_to_generator/* default */.Z)(function(param) {
        var url, params, method, body, _mock, mock, _page, page, _isAuth, isAuth, _ctx, ctx, _isBasic, isBasic, _debug, debug, _cache, cache, _logSlowTime, logSlowTime, _cacheServer, cacheServer, _cacheTime, cacheTime, _showLog, showLog, link, requestTimeout, logTime, headers, _tmp, parameters, _tmp1, isUseBasic, AuthorizationValue, AuthorizationValue1, _tmp2, parameterStr, dataRequest, _tmp3, _tmp4, _tmp5, logTimeFetch, isDedupRequest, cacheResp, result, res, result1, timeExcute, timeFetchAPI, _tmp6, err, endpoint, now, entry, _tmp7, _tmp8;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    url = param.url, params = param.params, method = param.method, body = param.body, _mock = param.mock, mock = _mock === void 0 ? false : _mock, _page = param.page, page = _page === void 0 ? false : _page, _isAuth = param.isAuth, isAuth = _isAuth === void 0 ? true : _isAuth, _ctx = param.ctx, ctx = _ctx === void 0 ? null : _ctx, _isBasic = param.isBasic, isBasic = _isBasic === void 0 ? false : _isBasic, _debug = param.debug, debug = _debug === void 0 ? false : _debug, _cache = param.cache, cache = _cache === void 0 ? false : _cache, _logSlowTime = param.logSlowTime, logSlowTime = _logSlowTime === void 0 ? 1000 : _logSlowTime, _cacheServer = param.cacheServer, cacheServer = _cacheServer === void 0 ? false : _cacheServer, _cacheTime = param.cacheTime, cacheTime = _cacheTime === void 0 ? 30 : _cacheTime, _showLog = param.showLog, showLog = _showLog === void 0 ? false : _showLog;
                    link = url;
                    requestTimeout = ctx ? 15000 : 30000;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        ,
                        7
                    ]);
                    logTime = +new Date();
                    _tmp = {};
                    headers = _tmp;
                    _tmp1 = {};
                    parameters = (0,_object_spread/* default */.Z)(_tmp1, params);
                    if (!page && (url === null || url === void 0 ? void 0 : url.indexOf("http")) === -1) {
                        link = (mock ? sysconfig/* MOCK_API_HOST */.iu : sysconfig/* API_HOST */.H) + url;
                    }
                    isUseBasic = false;
                    _tmp2 = {};
                    if (isAuth) {
                        if (ctx) {
                            AuthorizationValue = getSessionToken(ctx);
                            if (AuthorizationValue && AuthorizationValue.length > 0) {
                                headers["user-agent"] = ctx.req.headers["user-agent"];
                                headers.Authorization = "Bearer ".concat(AuthorizationValue);
                            }
                        } else {
                            AuthorizationValue1 = (0,SessionUtils/* getSessionTokenClient */.cQ)();
                            if (AuthorizationValue1 && AuthorizationValue1.length > 0) {
                                headers.Authorization = "Bearer ".concat(AuthorizationValue1);
                            }
                        }
                        if (isBasic && (!headers.Authorization || headers.Authorization.length === 0)) {
                            headers.Authorization = sysconfig/* BASIC_AUTHEN */.mE;
                            isUseBasic = true;
                            parameters.isBasic = true;
                        }
                        if (!headers.Authorization || headers.Authorization.length === 0) {
                            return [
                                2,
                                (_tmp2.errorCode = "MISSING_AUTHORIZATION", _tmp2.status = http/* HTTP_STATUS.Unauthorized */.M.Unauthorized, _tmp2.message = "Missing session", _tmp2)
                            ];
                        }
                    } else if (isBasic && (!headers.Authorization || headers.Authorization.length === 0)) {
                        headers.Authorization = sysconfig/* BASIC_AUTHEN */.mE;
                        isUseBasic = true;
                        parameters.isBasic = true;
                    }
                    // console.log('link : ', link);
                    if (parameters) {
                        parameterStr = RequestUtils.convertObjectToParameter(parameters);
                        if (parameterStr.length > 0) link += ((link === null || link === void 0 ? void 0 : link.indexOf("?")) >= 0 ? "&" : "?") + parameterStr;
                    }
                    _tmp3 = {};
                    _tmp4 = {};
                    _tmp5 = {};
                    dataRequest = (0,_object_spread/* default */.Z)((_tmp3.method = method, _tmp3.credentials = "same-origin", _tmp3.headers = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, headers), {
                        "Content-Type": "application/json"
                    }), _tmp3.body = typeof body === "object" ? JSON.stringify(body) : body, _tmp3), typeof AbortSignal !== "undefined" && AbortSignal.timeout ? (_tmp4.signal = AbortSignal.timeout(requestTimeout), _tmp4) : _tmp5);
                    logTimeFetch = +new Date();
                    isDedupRequest = method === "GET" && cache && (!isUseBasic || cacheServer) && (!ctx || cacheServer);
                    if (!isDedupRequest) return [
                        3,
                        3
                    ];
                    cacheResp = CacheUtils/* default.getCacheValue */.Z.getCacheValue(link);
                    if (cacheResp) {
                        // console.log(`\u001b[1;34m cached data ${method} ${link}`);
                        return [
                            2,
                            cacheResp
                        ];
                    }
                    // Store Promise<JSON> instead of Promise<Response> to prevent "Body is unusable"
                    // error when multiple concurrent SSR requests share the same Response object
                    // and each tries to call .json() on it (Response body can only be consumed once)
                    if (!mapRequestPromise[link]) {
                        // Phải dọn entry ngay khi fetch lỗi (vd connect timeout). Nếu không, promise
                        // đã reject sẽ kẹt lại trong map (vì điều kiện !mapRequestPromise[link] thấy nó
                        // truthy nên không fetch lại) -> mọi request sau cho cùng URL đều trả lỗi cho
                        // tới khi restart process, kéo dài sự cố sau khi backend đã hồi phục.
                        mapRequestPromise[link] = fetch(link, dataRequest).then(function(r) {
                            return r.json();
                        }).catch(function(err) {
                            mapRequestPromise[link] = null;
                            throw err;
                        });
                    }
                    return [
                        4,
                        mapRequestPromise[link]
                    ];
                case 2:
                    result = _state.sent();
                    mapRequestPromise[link] = null;
                    result.cache = true;
                    if (cacheTime > 0) CacheUtils/* default.setCacheKeyobject */.Z.setCacheKeyobject(link, result, cacheTime || 5);
                    return [
                        2,
                        result
                    ];
                case 3:
                    return [
                        4,
                        fetch(link, dataRequest)
                    ];
                case 4:
                    res = _state.sent();
                    return [
                        4,
                        res.json()
                    ];
                case 5:
                    result1 = _state.sent();
                    if (isUseBasic) {
                        result1.isBasic = true;
                    }
                    if (debug) {
                        result1.link = link;
                        result1.method = method;
                        // result.result = result;
                        result1.headers = headers;
                        result1.body = body;
                        result1.params = params;
                    }
                    timeExcute = +new Date() - logTime;
                    timeFetchAPI = +new Date() - logTimeFetch;
                    // console.log(` fetch data ${link}`, timeFetchAPI, timeExcute);
                    result1.timeExcute = timeExcute;
                    result1.timeFetchAPI = timeFetchAPI;
                    _tmp6 = {};
                    // log
                    if (showLog) {
                        if (sysconfig/* ENV */.Vi === "local") console.log("\uD83D\uDE80 ~ file: Clients.js:197 show request : ", "".concat(method).concat(link), timeFetchAPI, timeExcute);
                        if (timeFetchAPI > logSlowTime && [
                            "prd",
                            "stg",
                            "uat"
                        ].includes(sysconfig/* ENV */.Vi)) {
                            // console.log(` fetch data ${link}`, timeFetchAPI, timeExcute);
                            // sendError(` ${method}${link}  - ${timeFetchAPI}`);
                            BotClient/* default.sendMesageSlowApi */.Z.sendMesageSlowApi((_tmp6.message = " ".concat(method).concat(link, "  - ").concat(timeFetchAPI), _tmp6));
                        }
                    }
                    // if (!isValid(result) && ENV === 'local') {
                    //   console.log(` fetch data ${method} ${link}`, params, body, result);
                    // }
                    return [
                        2,
                        result1
                    ];
                case 6:
                    err = _state.sent();
                    _tmp7 = {};
                    // AbortSignal.timeout -> DOMException 'TimeoutError'. Log gọn + chỉ rõ endpoint nào
                    // bị timeout để truy vết backend chậm, thay vì dump stack node-internal khó hiểu.
                    if ((err === null || err === void 0 ? void 0 : err.name) === "TimeoutError") {
                        endpoint = "".concat(method, " ").concat((link || "").split("?")[0]);
                        now = Date.now();
                        entry = timeoutLogMap.get(endpoint) || (_tmp7.last = 0, _tmp7.count = 0, _tmp7);
                        entry.count += 1;
                        if (now - entry.last >= TIMEOUT_LOG_WINDOW) {
                            console.error("\x1b[1;31m API timeout sau ".concat(requestTimeout, "ms (x").concat(entry.count, "/").concat(TIMEOUT_LOG_WINDOW / 1000, "s): ").concat(endpoint));
                            entry.last = now;
                            entry.count = 0;
                        }
                        timeoutLogMap.set(endpoint, entry);
                    } else {
                        console.error("\x1b[1;31m err ", "".concat(method, " ").concat(link), err);
                    }
                    _tmp8 = {};
                    return [
                        2,
                        (_tmp8.error = err, _tmp8.status = http/* HTTP_STATUS.Error */.M.Error, _tmp8.data = [], _tmp8.message = err.message || " Hệ thống đ\xe3 xảy ra lỗi .", _tmp8)
                    ];
                case 7:
                    return [
                        2
                    ];
            }
        });
    });
    return _request.apply(this, arguments);
}
function GET(props) {
    return _GET.apply(this, arguments);
}
function _GET() {
    _GET = (0,_async_to_generator/* default */.Z)(function(props) {
        var _tmp, _tmp1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            _tmp = {};
            _tmp1 = {};
            return [
                2,
                request((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)(_tmp, props), (_tmp1.method = "GET", _tmp1)))
            ];
        });
    });
    return _GET.apply(this, arguments);
}
function POST(props) {
    return _POST.apply(this, arguments);
}
function _POST() {
    _POST = (0,_async_to_generator/* default */.Z)(function(props) {
        var _tmp, _tmp1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            _tmp = {};
            _tmp1 = {};
            return [
                2,
                request((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)(_tmp, props), (_tmp1.method = "POST", _tmp1)))
            ];
        });
    });
    return _POST.apply(this, arguments);
}
function PUT(props) {
    return _PUT.apply(this, arguments);
}
function _PUT() {
    _PUT = (0,_async_to_generator/* default */.Z)(function(props) {
        var _tmp, _tmp1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            _tmp = {};
            _tmp1 = {};
            return [
                2,
                request((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)(_tmp, props), (_tmp1.method = "PUT", _tmp1)))
            ];
        });
    });
    return _PUT.apply(this, arguments);
}
function DELETE(props) {
    return _DELETE.apply(this, arguments);
}
function _DELETE() {
    _DELETE = (0,_async_to_generator/* default */.Z)(function(props) {
        var _tmp, _tmp1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            _tmp = {};
            _tmp1 = {};
            return [
                2,
                request((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)(_tmp, props), (_tmp1.method = "DELETE", _tmp1)))
            ];
        });
    });
    return _DELETE.apply(this, arguments);
}
// @deprecate in next release
function isValidWithData(resp) {
    return resp && resp.status && resp.status === http/* HTTP_STATUS.Ok */.M.Ok && resp.data && resp.data[0];
}
function GET_ALL(props) {
    return _GET_ALL.apply(this, arguments);
}
function _GET_ALL() {
    _GET_ALL = (0,_async_to_generator/* default */.Z)(function(props) {
        var params, limit, result, _tmp, limitPage, rsTotal, _tmp1, _tmp2, _total, total, dataFirst, rsAll, _tmp3, _tmp4, promiseAll, i, _tmp5, _tmp6;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    params = props.params, limit = props.limit;
                    _tmp = {};
                    result = (_tmp.status = http/* HTTP_STATUS.Ok */.M.Ok, _tmp.data = [], _tmp);
                    limitPage = limit || MAX_LIMIT;
                    _tmp1 = {};
                    _tmp2 = {};
                    return [
                        4,
                        GET((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)(_tmp1, props), (_tmp2.params = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, params), {
                            getTotal: true,
                            limit: limitPage,
                            page: 1
                        }), _tmp2)))
                    ];
                case 1:
                    rsTotal = _state.sent();
                    // console.log('get total >> ', rsTotal);
                    if (!isValid(rsTotal)) {
                        return [
                            2,
                            rsTotal
                        ];
                    }
                    _total = rsTotal.total, total = _total === void 0 ? null : _total, dataFirst = rsTotal.data;
                    result.data = dataFirst;
                    if (!!total) return [
                        3,
                        3
                    ];
                    _tmp3 = {};
                    _tmp4 = {};
                    return [
                        4,
                        GET((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)(_tmp3, props), (_tmp4.params = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, params), {
                            getTotal: true,
                            limit: 1000,
                            page: 1
                        }), _tmp4)))
                    ];
                case 2:
                    rsAll = _state.sent();
                    return [
                        2,
                        rsAll
                    ];
                case 3:
                    promiseAll = [];
                    _tmp5 = {};
                    _tmp6 = {};
                    for(i = limitPage; i < total; i += limitPage){
                        // console.log('get all : ', i + 1, totalPage, limitPage);
                        promiseAll.push(GET((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)(_tmp5, props), (_tmp6.params = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, params), {
                            limit: limitPage,
                            page: i / limitPage,
                            offset: i
                        }), _tmp6))).then(function(rs) {
                            if (isValid(rs)) {
                                result.data = (0,_to_consumable_array/* default */.Z)(result.data).concat((0,_to_consumable_array/* default */.Z)(rs.data));
                            } else {
                                result.status = rs.status || "Error";
                                result.message = rs.message || "Lỗi : ";
                            }
                        }));
                    }
                    return [
                        4,
                        Promise.all(promiseAll)
                    ];
                case 4:
                    _state.sent();
                    return [
                        2,
                        result
                    ];
            }
        });
    });
    return _GET_ALL.apply(this, arguments);
}
function POST_ALL(props) {
    return _POST_ALL.apply(this, arguments);
}
function _POST_ALL() {
    _POST_ALL = (0,_async_to_generator/* default */.Z)(function(props) {
        var body, limit, result, _tmp, limitPage, rsTotal, _tmp1, _tmp2, total, promiseAll, totalPage, i, _tmp3, _tmp4;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    body = props.body, limit = props.limit;
                    _tmp = {};
                    result = (_tmp.status = http/* HTTP_STATUS.Ok */.M.Ok, _tmp.data = [], _tmp);
                    limitPage = limit || MAX_LIMIT;
                    _tmp1 = {};
                    _tmp2 = {};
                    return [
                        4,
                        POST((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)(_tmp1, props), (_tmp2.body = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, body), {
                            getTotal: true,
                            limit: 1,
                            page: 1
                        }), _tmp2)))
                    ];
                case 1:
                    rsTotal = _state.sent();
                    // console.log('get total >> ', rsTotal);
                    if (!isValid(rsTotal)) {
                        return [
                            2,
                            rsTotal
                        ];
                    }
                    total = rsTotal.total;
                    promiseAll = [];
                    totalPage = total / limitPage;
                    _tmp3 = {};
                    _tmp4 = {};
                    for(i = 0; i <= totalPage; i += 1){
                        // console.log('post all : ', i + 1, totalPage, limitPage);
                        promiseAll.push(POST((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)(_tmp3, props), (_tmp4.body = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, body), {
                            limit: limitPage,
                            page: i + 1,
                            offset: i * limitPage
                        }), _tmp4))).then(function(rs) {
                            if (isValid(rs)) {
                                result.data = (0,_to_consumable_array/* default */.Z)(result.data).concat((0,_to_consumable_array/* default */.Z)(rs.data));
                            } else {
                                result.status = rs.status || "Error";
                                result.message = rs.message || "Lỗi : ";
                            }
                        }));
                    }
                    return [
                        4,
                        Promise.all(promiseAll)
                    ];
                case 2:
                    _state.sent();
                    return [
                        2,
                        result
                    ];
            }
        });
    });
    return _POST_ALL.apply(this, arguments);
}
/* harmony default export */ var Clients = ({
    GET: GET,
    GET_ALL: GET_ALL,
    POST: POST,
    POST_ALL: POST_ALL,
    PUT: PUT,
    DELETE: DELETE,
    isValid: isValid,
    isValidWithData: isValidWithData,
    getSessionToken: getSessionToken,
    isValidWithoutData: isValidWithoutData,
    getSessionTokenClient: SessionUtils/* getSessionTokenClient */.cQ,
    LIMIT_DEFAULT: LIMIT_DEFAULT,
    MAX_LIMIT: MAX_LIMIT,
    OFFSET_DEFAULT: OFFSET_DEFAULT
});


/***/ }),

/***/ 59261:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "mA": function() { return /* binding */ getLeadSources; }
/* harmony export */ });
/* unused harmony exports getWallet, getPromo, updateProfile, updateProfileEnterprise, getBankAccount */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97582);
/* harmony import */ var constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83679);
/* harmony import */ var constants_Enums__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71569);
/* harmony import */ var _Clients__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38307);





var retrySendSms = function(param) {
    var code = param.code;
    var url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .CUSTOMER_API.RETRY_SEND_SMS */ .Xe.RETRY_SEND_SMS;
    return (0,_Clients__WEBPACK_IMPORTED_MODULE_2__.POST)({
        url: url,
        params: {
            code: code
        }
    });
};
var sendSms = function(param) {
    var phoneNumber = param.phoneNumber;
    var url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .CUSTOMER_API.SEND_SMS */ .Xe.SEND_SMS;
    return (0,_Clients__WEBPACK_IMPORTED_MODULE_2__.POST)({
        url: url,
        body: {
            phone: phoneNumber
        }
    });
};
function getOrder(_) {
    return _getOrder.apply(this, arguments);
}
function _getOrder() {
    _getOrder = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(param) {
        var status, url, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            status = param.status;
            url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .CUSTOMER_API.ORDER */ .Xe.ORDER + (status && status.length > 0 ? "?status=".concat(status) : "");
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_2__.GET)((_tmp.url = url, _tmp.mock = true, _tmp))
            ];
        });
    });
    return _getOrder.apply(this, arguments);
}
function getReferral(_) {
    return _getReferral.apply(this, arguments);
}
function _getReferral() {
    _getReferral = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(param) {
        var params, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            params = param.params;
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_2__.GET)((_tmp.url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .CUSTOMER_API.REFERRAL */ .Xe.REFERRAL, _tmp.params = params, _tmp))
            ];
        });
    });
    return _getReferral.apply(this, arguments);
}
function getWallet() {
    return _getWallet.apply(this, arguments);
}
function _getWallet() {
    _getWallet = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
        var result, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    return [
                        4,
                        (0,_Clients__WEBPACK_IMPORTED_MODULE_2__.GET)((_tmp.url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .CUSTOMER_API.WALLET */ .Xe.WALLET, _tmp.mock = true, _tmp))
                    ];
                case 1:
                    result = _state.sent();
                    if (!(0,_Clients__WEBPACK_IMPORTED_MODULE_2__.isValid)(result)) {
                        return [
                            2,
                            []
                        ];
                    }
                    return [
                        2,
                        result
                    ];
            }
        });
    });
    return _getWallet.apply(this, arguments);
}
function getPromo() {
    return _getPromo.apply(this, arguments);
}
function _getPromo() {
    _getPromo = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
        var result, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    return [
                        4,
                        (0,_Clients__WEBPACK_IMPORTED_MODULE_2__.GET)((_tmp.url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .CUSTOMER_API.PROMO */ .Xe.PROMO, _tmp.mock = true, _tmp))
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        2,
                        (0,_Clients__WEBPACK_IMPORTED_MODULE_2__.getData)(result)
                    ];
            }
        });
    });
    return _getPromo.apply(this, arguments);
}
function updateProfile(data) {
    return _updateProfile.apply(this, arguments);
}
function _updateProfile() {
    _updateProfile = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(data) {
        var url, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .CUSTOMER_API.INFO */ .Xe.INFO;
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_2__.PUT)((_tmp.url = url, _tmp.body = data, _tmp))
            ];
        });
    });
    return _updateProfile.apply(this, arguments);
}
function updateProfileEnterprise(data) {
    return _updateProfileEnterprise.apply(this, arguments);
}
function _updateProfileEnterprise() {
    _updateProfileEnterprise = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(data) {
        var url, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .CUSTOMER_API.UPDATE_INFO_ENTERPRISE */ .Xe.UPDATE_INFO_ENTERPRISE;
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_2__.PUT)((_tmp.url = url, _tmp.body = data, _tmp))
            ];
        });
    });
    return _updateProfileEnterprise.apply(this, arguments);
}
function getBankAccount(ctx) {
    return _getBankAccount.apply(this, arguments);
}
function _getBankAccount() {
    _getBankAccount = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(ctx) {
        var url, result, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .CUSTOMER_API.BANK_ACCOUNT */ .Xe.BANK_ACCOUNT;
                    _tmp = {};
                    return [
                        4,
                        (0,_Clients__WEBPACK_IMPORTED_MODULE_2__.GET)((_tmp.url = url, _tmp.ctx = ctx, _tmp))
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        2,
                        (0,_Clients__WEBPACK_IMPORTED_MODULE_2__.getData)(result)
                    ];
            }
        });
    });
    return _getBankAccount.apply(this, arguments);
}
var getListAddress = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(param) {
        var ctx, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            ctx = param.ctx;
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_2__.GET)((_tmp.url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .CUSTOMER_API.ADDRESS_ACCOUNT */ .Xe.ADDRESS_ACCOUNT, _tmp.ctx = ctx, _tmp))
            ];
        });
    });
    return function getListAddress(_) {
        return _ref.apply(this, arguments);
    };
}();
var createAddress = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(param) {
        var ctx, body, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            ctx = param.ctx, body = param.body;
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_2__.POST)((_tmp.url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .CUSTOMER_API.ADDRESS_ACCOUNT */ .Xe.ADDRESS_ACCOUNT, _tmp.body = body, _tmp.ctx = ctx, _tmp))
            ];
        });
    });
    return function createAddress(_) {
        return _ref.apply(this, arguments);
    };
}();
var deleteAddress = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(param) {
        var ctx, code, customerID, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            ctx = param.ctx, code = param.code, customerID = param.customerID;
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_2__.DELETE)((_tmp.url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .CUSTOMER_API.ADDRESS_ACCOUNT */ .Xe.ADDRESS_ACCOUNT, _tmp.ctx = ctx, _tmp.params = {
                    code: code,
                    customerID: customerID
                }, _tmp))
            ];
        });
    });
    return function deleteAddress(_) {
        return _ref.apply(this, arguments);
    };
}();
var updateAddress = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(param) {
        var ctx, body, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            ctx = param.ctx, body = param.body;
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_2__.PUT)((_tmp.url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .CUSTOMER_API.ADDRESS_ACCOUNT */ .Xe.ADDRESS_ACCOUNT, _tmp.ctx = ctx, _tmp.body = body, _tmp))
            ];
        });
    });
    return function updateAddress(_) {
        return _ref.apply(this, arguments);
    };
}();
var updateAddressDefault = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(param) {
        var ctx, code, customerID, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            ctx = param.ctx, code = param.code, customerID = param.customerID;
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_2__.PUT)((_tmp.url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .CUSTOMER_API.ADDRESS_ACCOUNT */ .Xe.ADDRESS_ACCOUNT, _tmp.ctx = ctx, _tmp.body = {
                    code: code,
                    isDefault: true,
                    customerID: customerID
                }, _tmp))
            ];
        });
    });
    return function updateAddressDefault(_) {
        return _ref.apply(this, arguments);
    };
}();
var getListLoyalty = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(ctx) {
        var _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_2__.GET)((_tmp.url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .CUSTOMER_API.LOYALTY_LIST */ .Xe.LOYALTY_LIST, _tmp.ctx = ctx, _tmp.params = {
                    status: constants_Enums__WEBPACK_IMPORTED_MODULE_1__/* .LOYALTY_STATUS.ACTIVE */ .Uq.ACTIVE
                }, _tmp))
            ];
        });
    });
    return function getListLoyalty(ctx) {
        return _ref.apply(this, arguments);
    };
}();
var getListHistoryLoyalty = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(param) {
        var ctx, offset, limit, q, _type, type, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            ctx = param.ctx, offset = param.offset, limit = param.limit, q = param.q, _type = param.type, type = _type === void 0 ? null : _type;
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_2__.GET)((_tmp.url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .CUSTOMER_API.HISTORY_LOYALTY_LIST */ .Xe.HISTORY_LOYALTY_LIST, _tmp.ctx = ctx, _tmp.params = {
                    offset: offset,
                    limit: limit,
                    getTotal: true,
                    q: q,
                    type: type
                }, _tmp))
            ];
        });
    });
    return function getListHistoryLoyalty(_) {
        return _ref.apply(this, arguments);
    };
}();
var getAllListHistoryLoyalty = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(param) {
        var ctx, q, _type, type, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            ctx = param.ctx, q = param.q, _type = param.type, type = _type === void 0 ? null : _type;
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_2__.GET_ALL)((_tmp.url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .CUSTOMER_API.HISTORY_LOYALTY_LIST */ .Xe.HISTORY_LOYALTY_LIST, _tmp.ctx = ctx, _tmp.params = {
                    q: q,
                    type: type
                }, _tmp))
            ];
        });
    });
    return function getAllListHistoryLoyalty(_) {
        return _ref.apply(this, arguments);
    };
}();
var exchangeLoyalty = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(param) {
        var ctx, body, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            ctx = param.ctx, body = param.body;
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_2__.POST)((_tmp.url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .CUSTOMER_API.LOYALTY */ .Xe.LOYALTY, _tmp.ctx = ctx, _tmp.body = body, _tmp))
            ];
        });
    });
    return function exchangeLoyalty(_) {
        return _ref.apply(this, arguments);
    };
}();
var uploadFile = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(param) {
        var ctx, body, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            ctx = param.ctx, body = param.body;
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_2__.POST)((_tmp.url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .CUSTOMER_API.UPLOAD_DOCUMENT */ .Xe.UPLOAD_DOCUMENT, _tmp.ctx = ctx, _tmp.body = body, _tmp))
            ];
        });
    });
    return function uploadFile(_) {
        return _ref.apply(this, arguments);
    };
}();
var uploadDocument = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(param) {
        var ctx, body, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            ctx = param.ctx, body = param.body;
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_2__.POST)((_tmp.url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .API_UPLOAD_DOCUMENT */ .Bn, _tmp.ctx = ctx, _tmp.body = body, _tmp.isBasic = true, _tmp))
            ];
        });
    });
    return function uploadDocument(_) {
        return _ref.apply(this, arguments);
    };
}();
var uploadFileImage = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(param) {
        var ctx, body, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            ctx = param.ctx, body = param.body;
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_2__.POST)((_tmp.url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .API_UPLOAD_IMAGE */ .Jv, _tmp.ctx = ctx, _tmp.body = body, _tmp.isBasic = true, _tmp))
            ];
        });
    });
    return function uploadFileImage(_) {
        return _ref.apply(this, arguments);
    };
}();
var genToken = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(param) {
        var ctx, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            ctx = param.ctx;
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_2__.GET)((_tmp.url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .API_GEN_TOKEN */ .bp, _tmp.ctx = ctx, _tmp))
            ];
        });
    });
    return function genToken(_) {
        return _ref.apply(this, arguments);
    };
}();
var upload = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(param) {
        var ctx, body, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            ctx = param.ctx, body = param.body;
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_2__.POST)((_tmp.url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .API_UPLOAD */ .$e, _tmp.ctx = ctx, _tmp.mock = true, _tmp.body = body, _tmp))
            ];
        });
    });
    return function upload(_) {
        return _ref.apply(this, arguments);
    };
}();
var uploadFileGpp = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(param) {
        var ctx, body, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            ctx = param.ctx, body = param.body;
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_2__.POST)((_tmp.url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .API_UPLOAD_FILE */ .CO, _tmp.ctx = ctx, _tmp.body = body, _tmp))
            ];
        });
    });
    return function uploadFileGpp(_) {
        return _ref.apply(this, arguments);
    };
}();
var getListInvoiceInfo = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(param) {
        var ctx, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            ctx = param.ctx;
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_2__.GET)((_tmp.url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .CUSTOMER_API.INVOICE_LIST */ .Xe.INVOICE_LIST, _tmp.ctx = ctx, _tmp))
            ];
        });
    });
    return function getListInvoiceInfo(_) {
        return _ref.apply(this, arguments);
    };
}();
var createInvoiceInfo = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(param) {
        var ctx, body, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            ctx = param.ctx, body = param.body;
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_2__.POST)((_tmp.url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .CUSTOMER_API.INVOICE_INFO */ .Xe.INVOICE_INFO, _tmp.body = body, _tmp.ctx = ctx, _tmp))
            ];
        });
    });
    return function createInvoiceInfo(_) {
        return _ref.apply(this, arguments);
    };
}();
var deleteInvoiceInfo = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(param) {
        var ctx, code, customerID, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            ctx = param.ctx, code = param.code, customerID = param.customerID;
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_2__.DELETE)((_tmp.url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .CUSTOMER_API.INVOICE_INFO */ .Xe.INVOICE_INFO, _tmp.ctx = ctx, _tmp.params = {
                    code: code,
                    customerID: customerID
                }, _tmp))
            ];
        });
    });
    return function deleteInvoiceInfo(_) {
        return _ref.apply(this, arguments);
    };
}();
var updateInvoiceInfo = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(body) {
        var url, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .CUSTOMER_API.INVOICE_INFO */ .Xe.INVOICE_INFO;
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_2__.PUT)((_tmp.url = url, _tmp.body = body, _tmp))
            ];
        });
    });
    return function updateInvoiceInfo(body) {
        return _ref.apply(this, arguments);
    };
}();
var updateInvoiceInfoOrder = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(body) {
        var url, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            url = "/marketplace/order/v2/order/invoice";
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_2__.PUT)((_tmp.url = url, _tmp.body = body, _tmp))
            ];
        });
    });
    return function updateInvoiceInfoOrder(body) {
        return _ref.apply(this, arguments);
    };
}();
var getBankAccountInfo = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(param) {
        var ctx, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            ctx = param.ctx;
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_2__.GET)((_tmp.url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .CUSTOMER_API.BANK_ACCOUNT_LIST */ .Xe.BANK_ACCOUNT_LIST, _tmp.ctx = ctx, _tmp))
            ];
        });
    });
    return function getBankAccountInfo(_) {
        return _ref.apply(this, arguments);
    };
}();
var createBankAccountInfo = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(param) {
        var ctx, body, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            ctx = param.ctx, body = param.body;
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_2__.POST)((_tmp.url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .CUSTOMER_API.BANK_ACCOUNT_INFO */ .Xe.BANK_ACCOUNT_INFO, _tmp.body = body, _tmp.ctx = ctx, _tmp))
            ];
        });
    });
    return function createBankAccountInfo(_) {
        return _ref.apply(this, arguments);
    };
}();
var updateBankAccountInfo = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(param) {
        var body, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            body = param.body;
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_2__.PUT)((_tmp.url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .CUSTOMER_API.BANK_ACCOUNT_INFO */ .Xe.BANK_ACCOUNT_INFO, _tmp.body = body, _tmp))
            ];
        });
    });
    return function updateBankAccountInfo(_) {
        return _ref.apply(this, arguments);
    };
}();
var getLevelList = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(param) {
        var ctx, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            ctx = param.ctx;
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_2__.GET)((_tmp.url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .CUSTOMER_API.LEVEL_LIST */ .Xe.LEVEL_LIST, _tmp.ctx = ctx, _tmp))
            ];
        });
    });
    return function getLevelList(_) {
        return _ref.apply(this, arguments);
    };
}();
// update api updateAccountInfo apm - 173 - https://buymed.atlassian.net/browse/APM-173
var updateCustomerInfo = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(dataAccount) {
        var _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_2__.PUT)((_tmp.url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .CUSTOMER_API.UPDATE_INFO_ACCOUNT */ .Xe.UPDATE_INFO_ACCOUNT, _tmp.body = dataAccount, _tmp))
            ];
        });
    });
    return function updateCustomerInfo(dataAccount) {
        return _ref.apply(this, arguments);
    };
}();
// const updateInfoEnterprise = async (dataEnterprise) => PUT({ url: CUSTOMER_API.UPDATE_INFO_ENTERPRISE, body: dataEnterprise });
var updateCaculatePoints = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(param) {
        var signal, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            signal = param.signal;
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_2__.GET)((_tmp.url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .CUSTOMER_API.CACULATE_POINTS_CUSTOMER */ .Xe.CACULATE_POINTS_CUSTOMER, _tmp.signal = signal, _tmp))
            ];
        });
    });
    return function updateCaculatePoints(_) {
        return _ref.apply(this, arguments);
    };
}();
var getBindingLINE = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(param) {
        var customerID, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            customerID = param.customerID;
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_2__.POST)((_tmp.url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .CUSTOMER_API.BINDING_LINE */ .Xe.BINDING_LINE, _tmp.body = {
                    customer_id: customerID
                }, _tmp))
            ];
        });
    });
    return function getBindingLINE(_) {
        return _ref.apply(this, arguments);
    };
}();
var addNotificationPartner = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(param) {
        var token, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            token = param.token;
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_2__.POST)((_tmp.url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .CUSTOMER_API.NOTIFICATION_PARTNER */ .Xe.NOTIFICATION_PARTNER, _tmp.body = {
                    token: token
                }, _tmp))
            ];
        });
    });
    return function addNotificationPartner(_) {
        return _ref.apply(this, arguments);
    };
}();
var deactiveNotificationPartner = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(param) {
        var token, reason, customerID, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            token = param.token, reason = param.reason, customerID = param.customerID;
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_2__.POST)((_tmp.url = "".concat(constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .CUSTOMER_API.NOTIFICATION_PARTNER */ .Xe.NOTIFICATION_PARTNER, "/deactive"), _tmp.body = {
                    token: token,
                    reason: reason,
                    customerID: customerID
                }, _tmp))
            ];
        });
    });
    return function deactiveNotificationPartner(_) {
        return _ref.apply(this, arguments);
    };
}();
var getPointExpire = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(param) {
        var ctx, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            ctx = param.ctx;
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_2__.GET)((_tmp.url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .CUSTOMER_API.GET_POINT_EXPIRE */ .Xe.GET_POINT_EXPIRE, _tmp.ctx = ctx, _tmp))
            ];
        });
    });
    return function getPointExpire(_) {
        return _ref.apply(this, arguments);
    };
}();
var getHoldOrderConfig = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
        var ctx, _tmp, _tmp1;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            _tmp = {};
            ctx = (_arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : _tmp).ctx;
            _tmp1 = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_2__.GET)((_tmp1.url = "/marketplace/order/v2/order/hold-order-config", _tmp1.ctx = ctx, _tmp1))
            ];
        });
    });
    return function getHoldOrderConfig() {
        return _ref.apply(this, arguments);
    };
}();
// Public list of active lead sources for the sign-up form (no login, basic token)
function getLeadSources() {
    return _getLeadSources.apply(this, arguments);
}
function _getLeadSources() {
    _getLeadSources = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
        var ctx, _tmp, _tmp1;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            _tmp = {};
            ctx = (_arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : _tmp).ctx;
            _tmp1 = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_2__.GET)((_tmp1.ctx = ctx, _tmp1.url = "".concat(constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .CUSTOMER_API.LEAD_SOURCE */ .Xe.LEAD_SOURCE, "?isActive=true"), _tmp1.isBasic = true, _tmp1.isAuth = false, _tmp1))
            ];
        });
    });
    return _getLeadSources.apply(this, arguments);
}
/* harmony default export */ __webpack_exports__["ZP"] = ({
    getOrder: getOrder,
    getReferral: getReferral,
    getWallet: getWallet,
    getPromo: getPromo,
    updateProfile: updateProfile,
    sendSms: sendSms,
    retrySendSms: retrySendSms,
    getBankAccount: getBankAccount,
    getListAddress: getListAddress,
    createAddress: createAddress,
    deleteAddress: deleteAddress,
    updateAddressDefault: updateAddressDefault,
    updateAddress: updateAddress,
    getListLoyalty: getListLoyalty,
    getListHistoryLoyalty: getListHistoryLoyalty,
    getAllListHistoryLoyalty: getAllListHistoryLoyalty,
    exchangeLoyalty: exchangeLoyalty,
    uploadFile: uploadFile,
    getListInvoiceInfo: getListInvoiceInfo,
    getBankAccountInfo: getBankAccountInfo,
    createInvoiceInfo: createInvoiceInfo,
    deleteInvoiceInfo: deleteInvoiceInfo,
    updateInvoiceInfo: updateInvoiceInfo,
    updateInvoiceInfoOrder: updateInvoiceInfoOrder,
    getLevelList: getLevelList,
    createBankAccountInfo: createBankAccountInfo,
    updateBankAccountInfo: updateBankAccountInfo,
    uploadDocument: uploadDocument,
    upload: upload,
    uploadFileGpp: uploadFileGpp,
    uploadFileImage: uploadFileImage,
    genToken: genToken,
    updateCustomerInfo: updateCustomerInfo,
    // updateInfoEnterprise,
    updateProfileEnterprise: updateProfileEnterprise,
    updateCaculatePoints: updateCaculatePoints,
    getBindingLINE: getBindingLINE,
    addNotificationPartner: addNotificationPartner,
    deactiveNotificationPartner: deactiveNotificationPartner,
    getPointExpire: getPointExpire,
    getHoldOrderConfig: getHoldOrderConfig,
    getLeadSources: getLeadSources
});


/***/ }),

/***/ 82036:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(97582);
/* harmony import */ var constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83679);
/* harmony import */ var sysconfig__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66225);
/* harmony import */ var _Clients__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38307);
/* harmony import */ var _ProductClientV2__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22997);
// file IngredientClient : GET PUT POST DELTE , not contain logic







function loadDataIngredient(ctx) {
    return _loadDataIngredient.apply(this, arguments);
}
function _loadDataIngredient() {
    _loadDataIngredient = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(ctx) {
        var res, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    return [
                        4,
                        (0,_Clients__WEBPACK_IMPORTED_MODULE_2__.GET_ALL)((_tmp.url = sysconfig__WEBPACK_IMPORTED_MODULE_1__/* .API_HOST_DOMAIN */ .fE + constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .PRODUCT_API.INGREDIENT_LIST */ .PJ.INGREDIENT_LIST, _tmp.ctx = ctx, _tmp.isBasic = true, _tmp.isAuth = false, _tmp.limit = 100, _tmp.cache = true, _tmp.cacheServer = false, _tmp))
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        (0,_Clients__WEBPACK_IMPORTED_MODULE_2__.getData)(res)
                    ];
            }
        });
    });
    return _loadDataIngredient.apply(this, arguments);
}
function loadDataIngredientClient() {
    return _loadDataIngredientClient.apply(this, arguments);
}
function _loadDataIngredientClient() {
    _loadDataIngredientClient = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
        var res, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    return [
                        4,
                        (0,_Clients__WEBPACK_IMPORTED_MODULE_2__.GET_ALL)((_tmp.url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .PRODUCT_API.INGREDIENT_LIST */ .PJ.INGREDIENT_LIST, _tmp.isBasic = true, _tmp.isAuth = false, _tmp.cache = true, _tmp.cacheServer = false, _tmp))
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        (0,_Clients__WEBPACK_IMPORTED_MODULE_2__.getData)(res)
                    ];
            }
        });
    });
    return _loadDataIngredientClient.apply(this, arguments);
}
var loadDataIngredientClientMock = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
        var _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_2__.GET)((_tmp.url = "/ingredients", _tmp.mock = true, _tmp.isAuth = false, _tmp))
            ];
        });
    });
    return function loadDataIngredientClientMock() {
        return _ref.apply(this, arguments);
    };
}();
function getAllIngredientProduct() {
    return _getAllIngredientProduct.apply(this, arguments);
}
function _getAllIngredientProduct() {
    _getAllIngredientProduct = // // 24Aug2021 Update new core : master data ingredient list , support for product ( default limit 20 )
    // TODO: need to check
    (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
        var res, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    return [
                        4,
                        (0,_Clients__WEBPACK_IMPORTED_MODULE_2__.GET_ALL)((_tmp.url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .CORE_API.INGREDIENT_LIST */ .S$.INGREDIENT_LIST, _tmp.isBasic = true, _tmp.isAuth = false, _tmp.limit = 50, _tmp.cache = true, _tmp.cacheServer = false, _tmp))
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        (0,_Clients__WEBPACK_IMPORTED_MODULE_2__.getData)(res)
                    ];
            }
        });
    });
    return _getAllIngredientProduct.apply(this, arguments);
}
var getAllIngredientProductMock = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
        var _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_2__.GET)((_tmp.url = "/ingredients/ingredientProduct", _tmp.mock = true, _tmp.isAuth = false, _tmp))
            ];
        });
    });
    return function getAllIngredientProductMock() {
        return _ref.apply(this, arguments);
    };
}();
function getIngredientBySlug(ctx, slug) {
    return _getIngredientBySlug.apply(this, arguments);
}
function _getIngredientBySlug() {
    _getIngredientBySlug = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(ctx, slug) {
        var slugObject, _tmp, url, params, _tmp1, _tmp2;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            _tmp = {};
            slugObject = JSON.stringify((_tmp.slug = slug, _tmp));
            url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .PRODUCT_API.INGREDIENT */ .PJ.INGREDIENT;
            _tmp1 = {};
            params = (_tmp1.q = slugObject, _tmp1);
            _tmp2 = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_2__.GET)((_tmp2.url = url, _tmp2.params = params, _tmp2.ctx = ctx, _tmp2.isBasic = true, _tmp2))
            ];
        });
    });
    return _getIngredientBySlug.apply(this, arguments);
}
function getProductsBySlug(ctx, code, params) {
    return _getProductsBySlug.apply(this, arguments);
}
function _getProductsBySlug() {
    _getProductsBySlug = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(ctx, code, params) {
        var _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            _tmp = {};
            // const res = await POST({ url, ctx, body: { filter: { ingredient: code }, ...params } });
            return [
                2,
                _ProductClientV2__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getFuzzySearchClient */ .ZP.getFuzzySearchClient((_tmp.ctx = ctx, _tmp.body = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                    filter: {
                        ingredient: code
                    }
                }, params), _tmp))
            ];
        });
    });
    return _getProductsBySlug.apply(this, arguments);
}
/* harmony default export */ __webpack_exports__["Z"] = ({
    loadDataIngredient: loadDataIngredient,
    getIngredientBySlug: getIngredientBySlug,
    getProductsBySlug: getProductsBySlug,
    loadDataIngredientClient: loadDataIngredientClient,
    getAllIngredientProduct: getAllIngredientProduct,
    loadDataIngredientClientMock: loadDataIngredientClientMock,
    getAllIngredientProductMock: getAllIngredientProductMock
});


/***/ }),

/***/ 57601:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97582);


var ref = __webpack_require__(38307), GET = ref.GET, POST = ref.POST;
// load san pham moi
var loadDataNewProducts = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(params) {
        var _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            _tmp = {};
            return [
                2,
                GET((_tmp.url = "/web/sanphammoi", _tmp.mock = true, _tmp.isAuth = false, _tmp.params = params, _tmp))
            ];
        });
    });
    return function loadDataNewProducts(params) {
        return _ref.apply(this, arguments);
    };
}();
var loadDataAlternativeProducts = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(params) {
        var _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            _tmp = {};
            return [
                2,
                GET((_tmp.url = "/web/sanphamthaythe", _tmp.mock = true, _tmp.isAuth = false, _tmp.params = params, _tmp))
            ];
        });
    });
    return function loadDataAlternativeProducts(params) {
        return _ref.apply(this, arguments);
    };
}();
var loadTabs = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function() {
        var _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            _tmp = {};
            return [
                2,
                GET((_tmp.url = "/web/tabs", _tmp.mock = true, _tmp.isAuth = false, _tmp))
            ];
        });
    });
    return function loadTabs() {
        return _ref.apply(this, arguments);
    };
}();
var getAllSellers = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function() {
        var _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            _tmp = {};
            return [
                2,
                GET((_tmp.url = "/web/sellers", _tmp.mock = true, _tmp.isAuth = false, _tmp))
            ];
        });
    });
    return function getAllSellers() {
        return _ref.apply(this, arguments);
    };
}();
var getProductBySlugs = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(body) {
        var _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            _tmp = {};
            return [
                2,
                POST((_tmp.url = "/web/product/slugs", _tmp.mock = true, _tmp.body = body, _tmp))
            ];
        });
    });
    return function getProductBySlugs(body) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ __webpack_exports__["Z"] = ({
    loadDataNewProducts: loadDataNewProducts,
    loadDataAlternativeProducts: loadDataAlternativeProducts,
    loadTabs: loadTabs,
    getProductBySlugs: getProductBySlugs,
    getAllSellers: getAllSellers
});


/***/ }),

/***/ 22997:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Xp": function() { return /* binding */ getProducts; },
/* harmony export */   "yx": function() { return /* binding */ getSuggestKeyword; }
/* harmony export */ });
/* unused harmony exports getTabs, getDeals, getDealsDetail, getSettingTags, getSettingTagsMock, getDataCollections, getFilesProduct, getReplaceProduct, getSubstituteEnabled, getListPriceRange */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(40872);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(97582);
/* harmony import */ var constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83679);
/* harmony import */ var constants_data__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66520);
/* harmony import */ var utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76480);
/* harmony import */ var utils_ArrUtils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33769);
/* harmony import */ var _BotClient__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(33172);
/* harmony import */ var _Clients__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(38307);












function loadDataMostSearch(ctx) {
    return _loadDataMostSearch.apply(this, arguments);
}
function _loadDataMostSearch() {
    _loadDataMostSearch = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(ctx) {
        var url, result, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    url = "/product/most-search";
                    _tmp = {};
                    return [
                        4,
                        (0,_Clients__WEBPACK_IMPORTED_MODULE_5__.GET)((_tmp.url = url, _tmp.ctx = ctx, _tmp))
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        2,
                        (0,_Clients__WEBPACK_IMPORTED_MODULE_5__.getData)(result)
                    ];
            }
        });
    });
    return _loadDataMostSearch.apply(this, arguments);
}
function loadDataManufacturer(ctx) {
    return _loadDataManufacturer.apply(this, arguments);
}
function _loadDataManufacturer() {
    _loadDataManufacturer = // TODO  @dat.le
    (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(ctx) {
        var ref, res, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    return [
                        4,
                        (0,_Clients__WEBPACK_IMPORTED_MODULE_5__.GET_ALL)((_tmp.url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .PRODUCT_API.MANUFACTURER_LIST */ .PJ.MANUFACTURER_LIST, _tmp.ctx = ctx, _tmp.isBasic = true, _tmp.cache = true, _tmp.cacheServer = false, _tmp))
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        (ref = (0,_Clients__WEBPACK_IMPORTED_MODULE_5__.getData)(res)) === null || ref === void 0 ? void 0 : ref.sort(function(a, b) {
                            var ref, ref1;
                            return (0,utils_ArrUtils__WEBPACK_IMPORTED_MODULE_3__/* .sortComparer */ .J5)((a === null || a === void 0 ? void 0 : (ref = a.name) === null || ref === void 0 ? void 0 : ref.toLowerCase()) || "", (b === null || b === void 0 ? void 0 : (ref1 = b.name) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()) || "");
                        })
                    ];
            }
        });
    });
    return _loadDataManufacturer.apply(this, arguments);
}
var loadDataManufacturerMock = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function() {
        var _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_5__.GET)((_tmp.url = "/web/manufactuers", _tmp.mock = true, _tmp.isAuth = false, _tmp))
            ];
        });
    });
    return function loadDataManufacturerMock() {
        return _ref.apply(this, arguments);
    };
}();
var getTagNameFromIds = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(param) {
        var tagIds, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
            tagIds = param.tagIds;
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_5__.GET)((_tmp.url = "/marketplace/product/v2/tag/list", _tmp.params = {
                    codes: tagIds,
                    limit: 100
                }, _tmp))
            ];
        });
    });
    return function getTagNameFromIds(_) {
        return _ref.apply(this, arguments);
    };
}();
var getProductSlugsSEO = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function() {
        var _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_5__.GET)((_tmp.url = "/marketplace/product/v2/seo/slugs", _tmp.isBasic = true, _tmp.cache = true, _tmp.cacheServer = true, _tmp.debug = true, _tmp))
            ];
        });
    });
    return function getProductSlugsSEO() {
        return _ref.apply(this, arguments);
    };
}();
// fix limit 20 of tabs -> converted
var getTabs = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(param) {
        var ctx, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
            ctx = param.ctx;
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_5__.GET)((_tmp.url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .PRODUCT_API.TABS_ACTIVE */ .PJ.TABS_ACTIVE, _tmp.params = {
                    limit: 100
                }, _tmp.ctx = ctx, _tmp.isBasic = true, _tmp.cache = true, _tmp.cacheServer = false, _tmp))
            ];
        });
    });
    return function getTabs(_) {
        return _ref.apply(this, arguments);
    };
}();
var getDeals = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(param) {
        var ctx, params, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
            ctx = param.ctx, params = param.params;
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_5__.GET)((_tmp.url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .PRODUCT_API.DEALS */ .PJ.DEALS, _tmp.params = params, _tmp.ctx = ctx, _tmp.isBasic = true, _tmp))
            ];
        });
    });
    return function getDeals(_) {
        return _ref.apply(this, arguments);
    };
}();
var getDealsDetail = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(param) {
        var ctx, body, params, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
            ctx = param.ctx, body = param.body, params = param.params;
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_5__.POST)((_tmp.url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .PRODUCT_API.DEALS_DETAIL */ .PJ.DEALS_DETAIL, _tmp.body = body, _tmp.ctx = ctx, _tmp.params = params, _tmp.isBasic = true, _tmp))
            ];
        });
    });
    return function getDealsDetail(_) {
        return _ref.apply(this, arguments);
    };
}();
var getSettingTags = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(param) {
        var ctx, _limit, limit, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
            ctx = param.ctx, _limit = param.limit, limit = _limit === void 0 ? 100 : _limit;
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_5__.GET_ALL)((_tmp.url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .PRODUCT_API.TAGS */ .PJ.TAGS, _tmp.ctx = ctx, _tmp.isBasic = true, _tmp.limit = limit, _tmp))
            ];
        });
    });
    return function getSettingTags(_) {
        return _ref.apply(this, arguments);
    };
}();
var getSettingTagsMock = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(param) {
        var ctx, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
            ctx = param.ctx;
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_5__.GET)((_tmp.url = "/web/tags", _tmp.ctx = ctx, _tmp.mock = true, _tmp.isAuth = false, _tmp))
            ];
        });
    });
    return function getSettingTagsMock(_) {
        return _ref.apply(this, arguments);
    };
}();
var getProducts = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(param) {
        var ctx, codes, limit, customerLevel, locationCode, _getPrice, getPrice, customerId, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
            ctx = param.ctx, codes = param.codes, limit = param.limit, customerLevel = param.customerLevel, locationCode = param.locationCode, _getPrice = param.getPrice, getPrice = _getPrice === void 0 ? true : _getPrice, customerId = param.customerId;
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_5__.POST)((_tmp.url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .PRODUCT_API.PRODUCT_LIST */ .PJ.PRODUCT_LIST, _tmp.body = {
                    skus: codes,
                    getProduct: true,
                    locationCode: locationCode,
                    customerLevel: customerLevel,
                    getPrice: getPrice,
                    customerId: customerId
                }, _tmp.params = {
                    limit: limit
                }, _tmp.ctx = ctx, _tmp))
            ];
        });
    });
    return function getProducts(_) {
        return _ref.apply(this, arguments);
    };
}();
var getDataCollections = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(param) {
        var ctx, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
            ctx = param.ctx;
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_5__.GET)((_tmp.url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .PRODUCT_API.PRODUCT_LIST_COLLECTION */ .PJ.PRODUCT_LIST_COLLECTION, _tmp.params = {
                    q: "MAIN_PAGE"
                }, _tmp.isBasic = true, _tmp.ctx = ctx, _tmp))
            ];
        });
    });
    return function getDataCollections(_) {
        return _ref.apply(this, arguments);
    };
}();
var getFilesProduct = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(param) {
        var ctx, refCode, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
            ctx = param.ctx, refCode = param.refCode;
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_5__.GET)((_tmp.url = "/core/file-manager/v1/file", _tmp.params = {
                    q: JSON.stringify({
                        refType: "PRODUCT",
                        fileType: "DOCUMENT",
                        refCode: refCode
                    })
                }, _tmp.isBasic = true, _tmp.ctx = ctx, _tmp))
            ];
        });
    });
    return function getFilesProduct(_) {
        return _ref.apply(this, arguments);
    };
}();
var getProductsByIds = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(_param) {
        var ctx, ids, _limit, limit, restProps, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
            ctx = _param.ctx, ids = _param.ids, _limit = _param.limit, limit = _limit === void 0 ? 20 : _limit, restProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_param, [
                "ctx",
                "ids",
                "limit"
            ]);
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_5__.GET)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((_tmp.ctx = ctx, _tmp.url = "/marketplace/product/v2/product/list", _tmp.params = {
                    ids: ids,
                    limit: limit
                }, _tmp), restProps))
            ];
        });
    });
    return function getProductsByIds(_param) {
        return _ref.apply(this, arguments);
    };
}();
var getProductsByCodes = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(_param) {
        var ctx, _codes, codes, restProps, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
            ctx = _param.ctx, _codes = _param.codes, codes = _codes === void 0 ? [] : _codes, restProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_param, [
                "ctx",
                "codes"
            ]);
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_5__.POST)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((_tmp.ctx = ctx, _tmp.url = "/marketplace/product/v2/product/list", _tmp.body = {
                    codes: codes
                }, _tmp), restProps))
            ];
        });
    });
    return function getProductsByCodes(_param) {
        return _ref.apply(this, arguments);
    };
}();
var getDescriptionById = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(_param) {
        var ctx, productId, restProps, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
            ctx = _param.ctx, productId = _param.productId, restProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_param, [
                "ctx",
                "productId"
            ]);
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_5__.GET)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((_tmp.ctx = ctx, _tmp.url = "/marketplace/product/v2/product/description", _tmp.params = {
                    q: JSON.stringify({
                        productID: productId
                    })
                }, _tmp), restProps))
            ];
        });
    });
    return function getDescriptionById(_param) {
        return _ref.apply(this, arguments);
    };
}();
var loadDiscovery = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(param) {
        var ctx, _lastID, lastID, body, _tmp, _tmp1;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
            ctx = param.ctx, _lastID = param.lastID, lastID = _lastID === void 0 ? "" : _lastID;
            _tmp = {};
            body = (_tmp.limit = 20, _tmp.lastID = lastID, _tmp);
            _tmp1 = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_5__.POST)((_tmp1.ctx = ctx, _tmp1.url = "/marketplace/social/v1/posts", _tmp1.body = body, _tmp1))
            ];
        });
    });
    return function loadDiscovery(_) {
        return _ref.apply(this, arguments);
    };
}();
var getDescriptionBySku = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(param) {
        var ctx, sku, code, params, _tmp, _tmp1;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
            ctx = param.ctx, sku = param.sku;
            code = sku.split(".")[1] || "";
            _tmp = {};
            params = (_tmp.q = JSON.stringify({
                code: code
            }), _tmp);
            _tmp1 = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_5__.GET)((_tmp1.ctx = ctx, _tmp1.url = "/marketplace/product/v2/product/description", _tmp1.params = params, _tmp1))
            ];
        });
    });
    return function getDescriptionBySku(_) {
        return _ref.apply(this, arguments);
    };
}();
var getDetailProductWithoutLogin = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(param) {
        var ctx, provinceCode, url, params, _tmp, _tmp1;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
            ctx = param.ctx, provinceCode = param.provinceCode;
            url = "/marketplace/product/v2/product/detail-raw";
            _tmp = {};
            params = (_tmp.q = ctx.query.slug || null, _tmp.provinceCode = provinceCode, _tmp);
            _tmp1 = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_5__.GET)((_tmp1.ctx = ctx, _tmp1.url = url, _tmp1.params = params, _tmp1.provinceCode = provinceCode, _tmp1.isBasic = true, _tmp1))
            ];
        });
    });
    return function getDetailProductWithoutLogin(_) {
        return _ref.apply(this, arguments);
    };
}();
var getSkusLimit = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(param) {
        var ctx, skuCodes, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
            ctx = param.ctx, skuCodes = param.skuCodes;
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_5__.POST)((_tmp.ctx = ctx, _tmp.url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .PRODUCT_API.SKU_LIMIT */ .PJ.SKU_LIMIT, _tmp.body = {
                    skuCodes: skuCodes
                }, _tmp))
            ];
        });
    });
    return function getSkusLimit(_) {
        return _ref.apply(this, arguments);
    };
}();
var getSkusBuyed = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(param) {
        var ctx, skuCodes, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
            ctx = param.ctx, skuCodes = param.skuCodes;
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_5__.POST)((_tmp.ctx = ctx, _tmp.url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_API.SKU_HISTORY */ .EM.SKU_HISTORY, _tmp.body = {
                    skuCodes: skuCodes
                }, _tmp))
            ];
        });
    });
    return function getSkusBuyed(_) {
        return _ref.apply(this, arguments);
    };
}();
var getSkusByProductId = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(param) {
        var productIds, ctx, url, params, _tmp, _tmp1;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
            productIds = param.productIds, ctx = param.ctx;
            url = "/marketplace/product/v2/sku-item/list";
            _tmp = {};
            params = (_tmp.productIds = productIds, _tmp);
            _tmp1 = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_5__.GET)((_tmp1.ctx = ctx, _tmp1.url = url, _tmp1.params = params, _tmp1.isBasic = true, _tmp1))
            ];
        });
    });
    return function getSkusByProductId(_) {
        return _ref.apply(this, arguments);
    };
}();
// without ctx
// skipInvalidReport: không báo bot khi kết quả rỗng/lỗi là bình thường (vd popup voucher)
var getFuzzySearchClient = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(_param) {
        var body, ctx, _skipInvalidReport, skipInvalidReport, restProps, text, _tmp, textSearch, lengthTextSearch, result, _tmp1, _tmp2;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    body = _param.body, ctx = _param.ctx, _skipInvalidReport = _param.skipInvalidReport, skipInvalidReport = _skipInvalidReport === void 0 ? false : _skipInvalidReport, restProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_param, [
                        "body",
                        "ctx",
                        "skipInvalidReport"
                    ]);
                    _tmp = {};
                    text = (body || _tmp).text;
                    if (text) {
                        textSearch = text.toLocaleLowerCase().trim();
                        lengthTextSearch = textSearch === null || textSearch === void 0 ? void 0 : textSearch.split(" ").length;
                        if (lengthTextSearch === 1 && constants_data__WEBPACK_IMPORTED_MODULE_1__/* .PreventSearchKeywords.indexOf */ .R9.indexOf(textSearch) >= 0 || textSearch.toLocaleLowerCase().startsWith("http") || constants_data__WEBPACK_IMPORTED_MODULE_1__/* .PreventSearchKeywordsAlias.indexOf */ .a3.indexOf(utils__WEBPACK_IMPORTED_MODULE_2__/* .StringUtils.changeAlias */ .xZ.changeAlias(textSearch)) >= 0) {
                            return [
                                2,
                                utils__WEBPACK_IMPORTED_MODULE_2__/* .ResponseUtils.notfound */ .QV.notfound("Keyword is not valid")
                            ];
                        }
                    }
                    _tmp1 = {};
                    return [
                        4,
                        (0,_Clients__WEBPACK_IMPORTED_MODULE_5__.POST)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((_tmp1.ctx = ctx, _tmp1.url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .FUZZY_SEARCH */ .un, _tmp1.body = body, _tmp1), restProps))
                    ];
                case 1:
                    result = _state.sent();
                    _tmp2 = {};
                    // BOT: log search invalid
                    if (!skipInvalidReport && !(0,_Clients__WEBPACK_IMPORTED_MODULE_5__.isValid)(result) && (result === null || result === void 0 ? void 0 : result.errorCode) !== "MISSING_AUTHORIZATION") {
                        _BotClient__WEBPACK_IMPORTED_MODULE_4__/* ["default"].sendMesageReport */ .Z.sendMesageReport((_tmp2.message = "Search is not valid with keyword: ".concat(JSON.stringify(body), " , result : ").concat(JSON.stringify(result)), _tmp2));
                    }
                    return [
                        2,
                        result
                    ];
            }
        });
    });
    return function getFuzzySearchClient(_param) {
        return _ref.apply(this, arguments);
    };
}();
// BV-2408: kiểm tra keyword cấm như getFuzzySearchClient
var isPreventedSearchText = function(text) {
    if (!text) return false;
    var textSearch = text.toLocaleLowerCase().trim();
    var lengthTextSearch = textSearch === null || textSearch === void 0 ? void 0 : textSearch.split(" ").length;
    return lengthTextSearch === 1 && constants_data__WEBPACK_IMPORTED_MODULE_1__/* .PreventSearchKeywords.indexOf */ .R9.indexOf(textSearch) >= 0 || textSearch.startsWith("http") || constants_data__WEBPACK_IMPORTED_MODULE_1__/* .PreventSearchKeywordsAlias.indexOf */ .a3.indexOf(utils__WEBPACK_IMPORTED_MODULE_2__/* .StringUtils.changeAlias */ .xZ.changeAlias(textSearch)) >= 0;
};
// BV-2408: fuzzy search qua frontend-apis (BFF) như VN getFuzzySearchClient, kèm SP thay thế
// (skuReplace) của trang danh sách. Response cùng dạng ProductData của product-service.
var getFuzzySearchBffClient = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(_param) {
        var body, ctx, restProps, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
            body = _param.body, ctx = _param.ctx, restProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_param, [
                "body",
                "ctx"
            ]);
            if (isPreventedSearchText(body === null || body === void 0 ? void 0 : body.text)) {
                return [
                    2,
                    utils__WEBPACK_IMPORTED_MODULE_2__/* .ResponseUtils.notfound */ .QV.notfound("Keyword is not valid")
                ];
            }
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_5__.POST)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((_tmp.ctx = ctx, _tmp.url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .FRONTEND_APIS.FUZZY_SEARCH */ .eI.FUZZY_SEARCH, _tmp.body = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, body), {
                    queryOption: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, body === null || body === void 0 ? void 0 : body.queryOption), {
                        consumedMaxQuantity: true,
                        sellerInfo: true,
                        isGetSKUReplace: true,
                        productListPage: true
                    })
                }), _tmp), restProps))
            ];
        });
    });
    return function getFuzzySearchBffClient(_param) {
        return _ref.apply(this, arguments);
    };
}();
// BV-2408: tìm kiếm trang đặt hàng nhanh qua frontend-apis (VN getProductQuickOrder)
var getProductQuickOrder = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(_param) {
        var body, ctx, restProps, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
            body = _param.body, ctx = _param.ctx, restProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_param, [
                "body",
                "ctx"
            ]);
            if (isPreventedSearchText(body === null || body === void 0 ? void 0 : body.text)) {
                return [
                    2,
                    utils__WEBPACK_IMPORTED_MODULE_2__/* .ResponseUtils.notfound */ .QV.notfound("Keyword is not valid")
                ];
            }
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_5__.POST)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((_tmp.ctx = ctx, _tmp.url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .FRONTEND_APIS.QUICK_ORDER_FUZZY */ .eI.QUICK_ORDER_FUZZY, _tmp.body = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, body), {
                    queryOption: {
                        isGetSKUReplace: true,
                        quickOrderPage: true
                    }
                }), _tmp), restProps))
            ];
        });
    });
    return function getProductQuickOrder(_param) {
        return _ref.apply(this, arguments);
    };
}();
// BV-2408: danh sách SP thay thế của 1 SP (trang /substitutes), như VN getReplaceProduct
var getReplaceProduct = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(param) {
        var _offset, offset, _limit, limit, _slug, slug, _sku, sku, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
            _offset = param.offset, offset = _offset === void 0 ? 0 : _offset, _limit = param.limit, limit = _limit === void 0 ? 10 : _limit, _slug = param.slug, slug = _slug === void 0 ? "" : _slug, _sku = param.sku, sku = _sku === void 0 ? "" : _sku;
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_5__.POST)((_tmp.url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .FRONTEND_APIS.SUBSTITUTES */ .eI.SUBSTITUTES, _tmp.body = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, slug && {
                    slug: slug
                }, sku && {
                    sku: sku
                }), {
                    offset: offset,
                    limit: limit
                }), _tmp))
            ];
        });
    });
    return function getReplaceProduct(_) {
        return _ref.apply(this, arguments);
    };
}();
// BV-2408: khách hiện tại có bật SP thay thế không
var getSubstituteEnabled = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function() {
        var ctx, _tmp, _tmp1;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
            _tmp = {};
            ctx = (_arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : _tmp).ctx;
            _tmp1 = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_5__.GET)((_tmp1.ctx = ctx, _tmp1.url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .FRONTEND_APIS.SUBSTITUTE_ENABLED */ .eI.SUBSTITUTE_ENABLED, _tmp1))
            ];
        });
    });
    return function getSubstituteEnabled() {
        return _ref.apply(this, arguments);
    };
}();
// deprecated 22Feb2023 - Dinh Tran
// export const loadPromotion = async () => GET({ url: '/promotion', mock: true });
// TODO: tool create product support
// create prodcut
var createProductSkuMain = function(param) {
    var ctx = param.ctx, data = param.data;
    return (0,_Clients__WEBPACK_IMPORTED_MODULE_5__.POST)({
        ctx: ctx,
        url: "/marketplace/product/v2/sku-main",
        body: data
    });
};
var validateLocationProductSkuItem = function(param) {
    var ctx = param.ctx, data = param.data;
    return (0,_Clients__WEBPACK_IMPORTED_MODULE_5__.POST)({
        ctx: ctx,
        url: "/marketplace/product/v2/sku-item/location/validate",
        body: data
    });
};
var createProductSkuItem = function(param) {
    var ctx = param.ctx, data = param.data;
    return (0,_Clients__WEBPACK_IMPORTED_MODULE_5__.POST)({
        ctx: ctx,
        url: "/marketplace/product/v2/sku-item",
        body: data
    });
};
var getListPriceRange = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(_param) {
        var ctx, restProps, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
            ctx = _param.ctx, restProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_param, [
                "ctx"
            ]);
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_5__.GET)((_tmp.ctx = ctx, _tmp.url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .PRODUCT_API.PRICE_RANGE_LIST */ .PJ.PRICE_RANGE_LIST, _tmp))
            ];
        });
    });
    return function getListPriceRange(_param) {
        return _ref.apply(this, arguments);
    };
}();
var getSuggestKeyword = function(_param) {
    var props = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, _param);
    return (0,_Clients__WEBPACK_IMPORTED_MODULE_5__.GET)({
        url: constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .PRODUCT_API.SUGGEST_KEYWORD */ .PJ.SUGGEST_KEYWORD,
        params: {}
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = ({
    loadDataMostSearch: loadDataMostSearch,
    loadDataManufacturer: loadDataManufacturer,
    loadDataManufacturerMock: loadDataManufacturerMock,
    getTabs: getTabs,
    getSettingTags: getSettingTags,
    getSettingTagsMock: getSettingTagsMock,
    getDeals: getDeals,
    getDealsDetail: getDealsDetail,
    getProducts: getProducts,
    getDataCollections: getDataCollections,
    getProductsByIds: getProductsByIds,
    getProductsByCodes: getProductsByCodes,
    getFilesProduct: getFilesProduct,
    getDescriptionById: getDescriptionById,
    loadDiscovery: loadDiscovery,
    getDescriptionBySku: getDescriptionBySku,
    getDetailProductWithoutLogin: getDetailProductWithoutLogin,
    getSkusLimit: getSkusLimit,
    getSkusBuyed: getSkusBuyed,
    getTagNameFromIds: getTagNameFromIds,
    getFuzzySearchClient: getFuzzySearchClient,
    getFuzzySearchBffClient: getFuzzySearchBffClient,
    getProductQuickOrder: getProductQuickOrder,
    getReplaceProduct: getReplaceProduct,
    getSubstituteEnabled: getSubstituteEnabled,
    getSkusByProductId: getSkusByProductId,
    createProductSkuMain: createProductSkuMain,
    createProductSkuItem: createProductSkuItem,
    validateLocationProductSkuItem: validateLocationProductSkuItem,
    getListPriceRange: getListPriceRange,
    getSuggestKeyword: getSuggestKeyword,
    getProductSlugsSEO: getProductSlugsSEO
});


/***/ }),

/***/ 46128:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fk": function() { return /* binding */ postGamificationScore; },
/* harmony export */   "Om": function() { return /* binding */ getLogSelfLuckyWheel; },
/* harmony export */   "PW": function() { return /* binding */ postSpinLuckyWheel; },
/* harmony export */   "TA": function() { return /* binding */ getMyHistoryVoucher; },
/* harmony export */   "Tj": function() { return /* binding */ getMissionSelfLuckyWheel; },
/* harmony export */   "YT": function() { return /* binding */ getVoucherDetail; },
/* harmony export */   "bV": function() { return /* binding */ getVoucherConditionMessage; },
/* harmony export */   "ji": function() { return /* binding */ getSelfLuckyWheelRewards; }
/* harmony export */ });
/* unused harmony exports getActiveCampaign, getActiveCampaignClient, getCampaignProducts, getVoucherActiveConfig, postVoucherList, getDataVoucherClient, getSelfLuckyWheelServerSide, getLuckyWheelItems, postShareLog */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(97582);
/* harmony import */ var constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83679);
/* harmony import */ var constants_data__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66520);
/* harmony import */ var _Clients__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38307);
/* harmony import */ var _ProductClientV2__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22997);
/* eslint-disable import/no-cycle */ 







function getPromos(ctx) {
    return _getPromos.apply(this, arguments);
}
function _getPromos() {
    _getPromos = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(ctx) {
        var url, res, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .PROMOTION_API.PROMOTION_ALL */ .rv.PROMOTION_ALL;
                    _tmp = {};
                    return [
                        4,
                        (0,_Clients__WEBPACK_IMPORTED_MODULE_2__.GET)((_tmp.url = url, _tmp.ctx = ctx, _tmp))
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        (0,_Clients__WEBPACK_IMPORTED_MODULE_2__.getData)(res)
                    ];
            }
        });
    });
    return _getPromos.apply(this, arguments);
}
function getPromosByStatus(_) {
    return _getPromosByStatus.apply(this, arguments);
}
function _getPromosByStatus() {
    _getPromosByStatus = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(param) {
        var ctx, status, stringify, _tmp, url, res, _tmp1;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ctx = param.ctx, status = param.status;
                    _tmp = {};
                    stringify = encodeURI(JSON.stringify((_tmp.status = status, _tmp)));
                    url = "".concat(constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .PROMOTION_API.PROMOTION_ALL */ .rv.PROMOTION_ALL, "?q=").concat(stringify);
                    _tmp1 = {};
                    return [
                        4,
                        (0,_Clients__WEBPACK_IMPORTED_MODULE_2__.GET)((_tmp1.url = url, _tmp1.ctx = ctx, _tmp1.isBasic = true, _tmp1))
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        (0,_Clients__WEBPACK_IMPORTED_MODULE_2__.getData)(res)
                    ];
            }
        });
    });
    return _getPromosByStatus.apply(this, arguments);
}
function getPromosActive(_) {
    return _getPromosActive.apply(this, arguments);
}
function _getPromosActive() {
    _getPromosActive = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(param) {
        var ctx, url, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            ctx = param.ctx;
            url = "".concat(constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .PROMOTION_API.PROMOTION_API_PREFIX */ .rv.PROMOTION_API_PREFIX, "/promotion/active");
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_2__.GET_ALL)((_tmp.url = url, _tmp.ctx = ctx, _tmp))
            ];
        });
    });
    return _getPromosActive.apply(this, arguments);
}
function getPromotionByID(_) {
    return _getPromotionByID.apply(this, arguments);
}
function _getPromotionByID() {
    _getPromotionByID = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(param) {
        var ctx, promotionId, url, params, _tmp, _tmp1;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            ctx = param.ctx, promotionId = param.promotionId;
            url = "".concat(constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .PROMOTION_API.PROMOTION_API_PREFIX */ .rv.PROMOTION_API_PREFIX, "/promotion");
            _tmp = {};
            params = (_tmp.promotionId = promotionId, _tmp);
            _tmp1 = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_2__.GET)((_tmp1.url = url, _tmp1.ctx = ctx, _tmp1.params = params, _tmp1))
            ];
        });
    });
    return _getPromotionByID.apply(this, arguments);
}
function getPromotionListByIDs(_) {
    return _getPromotionListByIDs.apply(this, arguments);
}
function _getPromotionListByIDs() {
    _getPromotionListByIDs = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(param) {
        var ctx, promotionIDs, url, params, _tmp, _tmp1;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            ctx = param.ctx, promotionIDs = param.promotionIDs;
            url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .PROMOTION_API.PROMOTION_ALL */ .rv.PROMOTION_ALL;
            _tmp = {};
            params = (_tmp.q = JSON.stringify({
                listIds: promotionIDs
            }), _tmp);
            _tmp1 = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_2__.GET)((_tmp1.url = url, _tmp1.ctx = ctx, _tmp1.params = params, _tmp1))
            ];
        });
    });
    return _getPromotionListByIDs.apply(this, arguments);
}
function getVoucherActiveOrder(_) {
    return _getVoucherActiveOrder.apply(this, arguments);
}
function _getVoucherActiveOrder() {
    _getVoucherActiveOrder = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(param) {
        var ctx, url, params, _tmp, _tmp1;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            ctx = param.ctx;
            url = "/marketplace/order/v2/voucher/active";
            _tmp = {};
            params = (_tmp.getValidate = true, _tmp);
            _tmp1 = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_2__.GET_ALL)((_tmp1.url = url, _tmp1.params = params, _tmp1.ctx = ctx, _tmp1))
            ];
        });
    });
    return _getVoucherActiveOrder.apply(this, arguments);
}
function getVoucherActive(_) {
    return _getVoucherActive.apply(this, arguments);
}
function _getVoucherActive() {
    _getVoucherActive = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(param) {
        var ctx, url, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            ctx = param.ctx;
            url = "".concat(constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .PROMOTION_API.PROMOTION_API_PREFIX */ .rv.PROMOTION_API_PREFIX, "/voucher/active");
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_2__.GET_ALL)((_tmp.url = url, _tmp.ctx = ctx, _tmp))
            ];
        });
    });
    return _getVoucherActive.apply(this, arguments);
}
function checkPromoAvailableForCart(_) {
    return _checkPromoAvailableForCart.apply(this, arguments);
}
function _checkPromoAvailableForCart() {
    _checkPromoAvailableForCart = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(param) {
        var voucherCode, cartItems, totalPrice, ctx, url, body, _tmp, _tmp1;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            voucherCode = param.voucherCode, cartItems = param.cartItems, totalPrice = param.totalPrice, ctx = param.ctx;
            url = "".concat(constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .PROMOTION_API.PROMOTION_API_PREFIX */ .rv.PROMOTION_API_PREFIX, "/check");
            _tmp = {};
            body = (_tmp.voucherCode = voucherCode, _tmp.cartItems = cartItems, _tmp.totalPrice = totalPrice, _tmp);
            _tmp1 = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_2__.POST)((_tmp1.url = url, _tmp1.ctx = ctx, _tmp1.body = body, _tmp1))
            ];
        });
    });
    return _checkPromoAvailableForCart.apply(this, arguments);
}
function getPromoDetailByVoucherCode(_) {
    return _getPromoDetailByVoucherCode.apply(this, arguments);
}
function _getPromoDetailByVoucherCode() {
    _getPromoDetailByVoucherCode = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(param) {
        var voucherCode, url, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            voucherCode = param.voucherCode;
            url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .PROMOTION_API.PROMOTION_DETAI_VOUCHER_CODE */ .rv.PROMOTION_DETAI_VOUCHER_CODE;
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_2__.GET)((_tmp.url = url, _tmp.params = {
                    voucherCode: voucherCode
                }, _tmp))
            ];
        });
    });
    return _getPromoDetailByVoucherCode.apply(this, arguments);
}
function getMyVoucher(_) {
    return _getMyVoucher.apply(this, arguments);
}
function _getMyVoucher() {
    _getMyVoucher = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(param) {
        var ctx, offset, limit, params, _tmp, url, _tmp1;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            ctx = param.ctx, offset = param.offset, limit = param.limit;
            _tmp = {};
            params = (_tmp.offset = offset, _tmp.limit = limit, _tmp.getTotal = true, _tmp);
            url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .PROMOTION_API.VOUCHER */ .rv.VOUCHER;
            _tmp1 = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_2__.GET)((_tmp1.url = url, _tmp1.ctx = ctx, _tmp1.params = params, _tmp1))
            ];
        });
    });
    return _getMyVoucher.apply(this, arguments);
}
var getActiveCampaign = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(param) {
        var ctx, _limit, limit, url, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            ctx = param.ctx, _limit = param.limit, limit = _limit === void 0 ? 100 : _limit;
            url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .PROMOTION_API.PROMOTION_CAMPAIGN */ .rv.PROMOTION_CAMPAIGN;
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_2__.GET)((_tmp.url = url, _tmp.ctx = ctx, _tmp.limit = limit, _tmp))
            ];
        });
    });
    return function getActiveCampaign(_) {
        return _ref.apply(this, arguments);
    };
}();
var getActiveCampaignClient = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
        var url, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .PROMOTION_API.PROMOTION_CAMPAIGN */ .rv.PROMOTION_CAMPAIGN;
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_2__.GET)((_tmp.url = url, _tmp))
            ];
        });
    });
    return function getActiveCampaignClient() {
        return _ref.apply(this, arguments);
    };
}();
var getCampaignProducts = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(param) {
        var slug, ctx, searchStrategy, _tmp, body, _tmp1, _tmp2;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            slug = param.slug, ctx = param.ctx;
            _tmp = {};
            searchStrategy = (_tmp.text = true, _tmp.keyword = true, _tmp.ingredient = true, _tmp);
            _tmp1 = {};
            body = (_tmp1.filter = {
                campaign: slug
            }, _tmp1.limit = constants_data__WEBPACK_IMPORTED_MODULE_1__/* .PAGE_SIZE_30 */ .AV, _tmp1.getTotal = true, _tmp1.searchStrategy = searchStrategy, _tmp1);
            _tmp2 = {};
            // const result = await POST({ url, body, ctx });
            return [
                2,
                _ProductClientV2__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getFuzzySearchClient */ .ZP.getFuzzySearchClient((_tmp2.ctx = ctx, _tmp2.body = body, _tmp2))
            ];
        });
    });
    return function getCampaignProducts(_) {
        return _ref.apply(this, arguments);
    };
}();
var getVoucherActiveConfig = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(param) {
        var offset, _limit, limit, _search, search, signal, url, params, _tmp, _tmp1;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            offset = param.offset, _limit = param.limit, limit = _limit === void 0 ? 20 : _limit, _search = param.search, search = _search === void 0 ? "" : _search, signal = param.signal;
            url = "/marketplace/order/v2/voucher/active";
            _tmp = {};
            params = (_tmp.getValidate = true, _tmp.getTotal = true, _tmp.offset = offset, _tmp.limit = limit, _tmp.search = search, _tmp);
            _tmp1 = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_2__.GET)((_tmp1.url = url, _tmp1.params = params, _tmp1.signal = signal, _tmp1))
            ];
        });
    });
    return function getVoucherActiveConfig(_) {
        return _ref.apply(this, arguments);
    };
}();
var postVoucherList = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(param) {
        var ctx, accountID, _cart, cart, _scope, scope, _limit, limit, _search, search, _getValidate, getValidate, _getTotal, getTotal, _getBySellerInCart, getBySellerInCart, _sellerCode, sellerCode, _getVoucherToCollect, getVoucherToCollect, _skipVoucherCollected, skipVoucherCollected, _sku, sku, _skipVoucherOwner, skipVoucherOwner, _getVoucherAuto, getVoucherAuto, _tmp, url, body, _tmp1, _tmp2;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            _tmp = {};
            ctx = param.ctx, accountID = param.accountID, _cart = param.cart, cart = _cart === void 0 ? _tmp : _cart, _scope = param.scope, scope = _scope === void 0 ? "" : _scope, _limit = param.limit, limit = _limit === void 0 ? 200 : _limit, _search = param.search, search = _search === void 0 ? "" : _search, _getValidate = param.getValidate, getValidate = _getValidate === void 0 ? true : _getValidate, _getTotal = param.getTotal, getTotal = _getTotal === void 0 ? true : _getTotal, _getBySellerInCart = param.getBySellerInCart, getBySellerInCart = _getBySellerInCart === void 0 ? false : _getBySellerInCart, _sellerCode = param.sellerCode, sellerCode = _sellerCode === void 0 ? "" : _sellerCode, _getVoucherToCollect = param.getVoucherToCollect, getVoucherToCollect = _getVoucherToCollect === void 0 ? false : _getVoucherToCollect, _skipVoucherCollected = param.skipVoucherCollected, skipVoucherCollected = _skipVoucherCollected === void 0 ? false : _skipVoucherCollected, _sku = param.sku, sku = _sku === void 0 ? "" : _sku, _skipVoucherOwner = param.skipVoucherOwner, skipVoucherOwner = _skipVoucherOwner === void 0 ? false : _skipVoucherOwner, _getVoucherAuto = param.getVoucherAuto, getVoucherAuto = _getVoucherAuto === void 0 ? true : _getVoucherAuto;
            url = "".concat(constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .PROMOTION_API.PROMOTION_API_PREFIX */ .rv.PROMOTION_API_PREFIX, "/me/voucher/list");
            _tmp1 = {};
            body = (_tmp1.accountId = accountID, _tmp1.cart = {
                paymentMethod: cart.paymentMethod,
                price: cart.price,
                totalItem: cart.totalItem,
                redeemCode: cart.redeemCode,
                cartItems: cart.cartItems,
                redeemApplyResult: cart.redeemApplyResult || [],
                regionCodes: cart.regionCodes || []
            }, _tmp1.scope = scope, _tmp1.limit = limit, _tmp1.getValidate = getValidate, _tmp1.getTotal = getTotal, _tmp1.search = search, _tmp1.getBySellerInCart = getBySellerInCart, _tmp1.sellerCode = sellerCode, _tmp1.sku = sku, _tmp1.getVoucherToCollect = getVoucherToCollect, _tmp1.skipVoucherCollected = skipVoucherCollected, _tmp1.skipVoucherOwner = skipVoucherOwner, _tmp1.getVoucherAuto = getVoucherAuto, _tmp1);
            _tmp2 = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_2__.POST)((_tmp2.ctx = ctx, _tmp2.url = url, _tmp2.body = body, _tmp2))
            ];
        });
    });
    return function postVoucherList(_) {
        return _ref.apply(this, arguments);
    };
}();
// cart gửi kèm các API voucher cần validate theo giỏ, cùng format với postVoucherList
var buildVoucherCartPayload = function() {
    var cart = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return {
        paymentMethod: cart.paymentMethod,
        price: cart.price,
        totalItem: cart.totalItem,
        redeemCode: cart.redeemCode,
        cartItems: cart.cartItems,
        redeemApplyResult: cart.redeemApplyResult || [],
        regionCodes: cart.regionCodes || []
    };
};
// 1 voucher (đã validate theo giỏ) cho popup chi tiết.
// BE TH/KH cũ bỏ qua `codes` nên gửi thêm `search` và lọc lại đúng code ở FE.
var getVoucherDetail = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(param) {
        var accountID, _cart, cart, code, _tmp, url, body, _tmp1, res, _tmp2, data, _tmp3, _tmp4;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    accountID = param.accountID, _cart = param.cart, cart = _cart === void 0 ? _tmp : _cart, code = param.code;
                    url = "".concat(constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .PROMOTION_API.PROMOTION_API_PREFIX */ .rv.PROMOTION_API_PREFIX, "/me/voucher/list");
                    _tmp1 = {};
                    body = (_tmp1.accountId = accountID, _tmp1.cart = buildVoucherCartPayload(cart), _tmp1.codes = [
                        code
                    ], _tmp1.search = code, _tmp1.getValidate = true, _tmp1.getVoucherAuto = true, _tmp1.getTotal = false, _tmp1);
                    _tmp2 = {};
                    return [
                        4,
                        (0,_Clients__WEBPACK_IMPORTED_MODULE_2__.POST)((_tmp2.url = url, _tmp2.body = body, _tmp2))
                    ];
                case 1:
                    res = _state.sent();
                    if (!(0,_Clients__WEBPACK_IMPORTED_MODULE_2__.isValid)(res)) {
                        return [
                            2,
                            res
                        ];
                    }
                    data = res.data.filter(function(voucher) {
                        return (voucher === null || voucher === void 0 ? void 0 : voucher.code) === code;
                    });
                    _tmp3 = {};
                    _tmp4 = {};
                    return [
                        2,
                        (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_tmp3, res), (_tmp4.data = data, _tmp4.total = data.length, _tmp4))
                    ];
            }
        });
    });
    return function getVoucherDetail(_) {
        return _ref.apply(this, arguments);
    };
}();
// data[0] = { percentageCondition, conditionMessages }
var getVoucherConditionMessage = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(param) {
        var accountID, _cart, cart, code, _tmp, url, body, _tmp1, _tmp2;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            _tmp = {};
            accountID = param.accountID, _cart = param.cart, cart = _cart === void 0 ? _tmp : _cart, code = param.code;
            url = "".concat(constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .PROMOTION_API.PROMOTION_API_PREFIX */ .rv.PROMOTION_API_PREFIX, "/voucher/condition-message");
            _tmp1 = {};
            body = (_tmp1.accountId = accountID, _tmp1.cart = buildVoucherCartPayload(cart), _tmp1.codes = [
                code
            ], _tmp1);
            _tmp2 = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_2__.POST)((_tmp2.url = url, _tmp2.body = body, _tmp2))
            ];
        });
    });
    return function getVoucherConditionMessage(_) {
        return _ref.apply(this, arguments);
    };
}();
var getDataVoucherClient = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(param) {
        var signal, _scope, scope, url, params, _tmp, _tmp1;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            signal = param.signal, _scope = param.scope, scope = _scope === void 0 ? "" : _scope;
            url = "".concat(constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .PROMOTION_API.VOUCHER */ .rv.VOUCHER, "/list");
            _tmp = {};
            params = (_tmp.getTotal = true, _tmp.scope = scope, _tmp);
            _tmp1 = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_2__.GET_ALL)((_tmp1.url = url, _tmp1.params = params, _tmp1.signal = signal, _tmp1))
            ];
        });
    });
    return function getDataVoucherClient(_) {
        return _ref.apply(this, arguments);
    };
}();
var getMyHistoryVoucher = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(param) {
        var offset, limit, _q, q, url, params, _tmp, _tmp1;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            offset = param.offset, limit = param.limit, _q = param.q, q = _q === void 0 ? null : _q;
            url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .PROMOTION_API.MYVOUCHER_HISTORY */ .rv.MYVOUCHER_HISTORY;
            _tmp = {};
            params = (_tmp.getTotal = true, _tmp.offset = offset, _tmp.limit = limit, _tmp.q = q, _tmp);
            _tmp1 = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_2__.GET)((_tmp1.url = url, _tmp1.params = params, _tmp1))
            ];
        });
    });
    return function getMyHistoryVoucher(_) {
        return _ref.apply(this, arguments);
    };
}();
var postSpinLuckyWheel = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(param) {
        var _code, code, _type, type, _questionCode, questionCode, _answerId, answerId, url, body, _tmp, _tmp1;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            _code = param.code, code = _code === void 0 ? "" : _code, _type = param.type, type = _type === void 0 ? "" : _type, _questionCode = param.questionCode, questionCode = _questionCode === void 0 ? "" : _questionCode, _answerId = param.answerId, answerId = _answerId === void 0 ? "" : _answerId;
            url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .PROMOTION_LUCKY_WHEEL.SPIN */ .F8.SPIN;
            _tmp = {};
            body = (_tmp.code = code, _tmp.type = type, _tmp);
            if (questionCode) {
                body.questionCode = questionCode;
            }
            if (answerId) {
                body.answerId = answerId;
            }
            _tmp1 = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_2__.POST)((_tmp1.url = url, _tmp1.body = body, _tmp1))
            ];
        });
    });
    return function postSpinLuckyWheel(_) {
        return _ref.apply(this, arguments);
    };
}();
var getSelfLuckyWheelRewards = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
        var luckyWheelCode, url, params, _tmp, _tmp1;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            luckyWheelCode = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : "";
            url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .PROMOTION_LUCKY_WHEEL.SELF_LUCKY_WHEEL */ .F8.SELF_LUCKY_WHEEL;
            _tmp = {};
            params = (_tmp.luckyWheelCode = luckyWheelCode, _tmp);
            _tmp1 = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_2__.GET)((_tmp1.url = url, _tmp1.params = params, _tmp1))
            ];
        });
    });
    return function getSelfLuckyWheelRewards() {
        return _ref.apply(this, arguments);
    };
}();
var getSelfLuckyWheelServerSide = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(param) {
        var ctx, luckyWheelCode, url, params, _tmp, _tmp1;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            ctx = param.ctx, luckyWheelCode = param.luckyWheelCode;
            url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .PROMOTION_LUCKY_WHEEL.SELF_LUCKY_WHEEL */ .F8.SELF_LUCKY_WHEEL;
            _tmp = {};
            params = (_tmp.luckyWheelCode = luckyWheelCode, _tmp);
            _tmp1 = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_2__.GET)((_tmp1.ctx = ctx, _tmp1.url = url, _tmp1.params = params, _tmp1.isBasic = true, _tmp1))
            ];
        });
    });
    return function getSelfLuckyWheelServerSide(_) {
        return _ref.apply(this, arguments);
    };
}();
var getLuckyWheelItems = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(param) {
        var luckyWheelCode, url, params, _tmp, _tmp1;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            luckyWheelCode = param.luckyWheelCode;
            url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .PROMOTION_LUCKY_WHEEL.LUCKY_WHEEL_ITEMS */ .F8.LUCKY_WHEEL_ITEMS;
            _tmp = {};
            params = (_tmp.q = JSON.stringify({
                luckyWheelCode: luckyWheelCode
            }), _tmp);
            _tmp1 = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_2__.GET)((_tmp1.url = url, _tmp1.params = params, _tmp1))
            ];
        });
    });
    return function getLuckyWheelItems(_) {
        return _ref.apply(this, arguments);
    };
}();
var getLogSelfLuckyWheel = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(param) {
        var luckyWheelCode, _limit, limit, _offset, offset, _type, type, url, params, _tmp, _tmp1;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            luckyWheelCode = param.luckyWheelCode, _limit = param.limit, limit = _limit === void 0 ? 100 : _limit, _offset = param.offset, offset = _offset === void 0 ? 0 : _offset, _type = param.type, type = _type === void 0 ? "" : _type;
            url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .PROMOTION_LUCKY_WHEEL.SELF_LOG_LUCKY_WHEEL */ .F8.SELF_LOG_LUCKY_WHEEL;
            _tmp = {};
            params = (_tmp.luckyWheelCode = luckyWheelCode, _tmp.limit = limit, _tmp.type = type, _tmp.offset = offset, _tmp);
            _tmp1 = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_2__.GET)((_tmp1.url = url, _tmp1.params = params, _tmp1))
            ];
        });
    });
    return function getLogSelfLuckyWheel(_) {
        return _ref.apply(this, arguments);
    };
}();
var getMissionSelfLuckyWheel = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(param) {
        var luckyWheelCode, url, params, _tmp, _tmp1;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            luckyWheelCode = param.luckyWheelCode;
            url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .PROMOTION_LUCKY_WHEEL.SELF_MISSION_LUCKY_WHEEL */ .F8.SELF_MISSION_LUCKY_WHEEL;
            _tmp = {};
            params = (_tmp.luckyWheelCode = luckyWheelCode, _tmp);
            _tmp1 = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_2__.GET)((_tmp1.url = url, _tmp1.params = params, _tmp1))
            ];
        });
    });
    return function getMissionSelfLuckyWheel(_) {
        return _ref.apply(this, arguments);
    };
}();
var postGamificationScore = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(param) {
        var _type, type, customerID, accountID, _action, action, luckyWheelCode, gamificationDetailID, _socialNetwork, socialNetwork, url, body, _tmp, _tmp1;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            _type = param.type, type = _type === void 0 ? "" : _type, customerID = param.customerID, accountID = param.accountID, _action = param.action, action = _action === void 0 ? "" : _action, luckyWheelCode = param.luckyWheelCode, gamificationDetailID = param.gamificationDetailID, _socialNetwork = param.socialNetwork, socialNetwork = _socialNetwork === void 0 ? "" : _socialNetwork;
            url = "".concat(constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .PROMOTION_API.PROMOTION_API_PREFIX */ .rv.PROMOTION_API_PREFIX, "/gamification-score");
            _tmp = {};
            body = (_tmp.type = type, _tmp.customerID = customerID, _tmp.accountID = accountID, _tmp.data = {
                luckyWheelCode: luckyWheelCode,
                gamificationDetailID: gamificationDetailID,
                socialNetwork: socialNetwork
            }, _tmp.action = action, _tmp);
            _tmp1 = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_2__.POST)((_tmp1.url = url, _tmp1.body = body, _tmp1))
            ];
        });
    });
    return function postGamificationScore(_) {
        return _ref.apply(this, arguments);
    };
}();
var postShareLog = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(param) {
        var customerID, accountID, _source, source, _page, page, _screen, screen, _shareUrl, shareUrl, _platform, platform, url, body, _tmp, _tmp1;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            customerID = param.customerID, accountID = param.accountID, _source = param.source, source = _source === void 0 ? "" : _source, _page = param.page, page = _page === void 0 ? "" : _page, _screen = param.screen, screen = _screen === void 0 ? "" : _screen, _shareUrl = param.shareUrl, shareUrl = _shareUrl === void 0 ? "" : _shareUrl, _platform = param.platform, platform = _platform === void 0 ? "" : _platform;
            url = "".concat(constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .PROMOTION_API.PROMOTION_API_PREFIX */ .rv.PROMOTION_API_PREFIX, "/share-log");
            _tmp = {};
            body = (_tmp.customerId = customerID, _tmp.accountId = accountID, _tmp.source = source, _tmp.page = page, _tmp.screen = screen, _tmp.shareUrl = shareUrl, _tmp.platform = platform, _tmp);
            _tmp1 = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_2__.POST)((_tmp1.url = url, _tmp1.body = body, _tmp1))
            ];
        });
    });
    return function postShareLog(_) {
        return _ref.apply(this, arguments);
    };
}();
var getSpinQuestion = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(param) {
        var luckyWheelCode, params, _tmp, _tmp1;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            luckyWheelCode = param.luckyWheelCode;
            _tmp = {};
            params = (_tmp.wheelCode = luckyWheelCode, _tmp);
            _tmp1 = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_2__.GET)((_tmp1.url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .PROMOTION_API.SPIN_QUESTION */ .rv.SPIN_QUESTION, _tmp1.params = params, _tmp1))
            ];
        });
    });
    return function getSpinQuestion(_) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ __webpack_exports__["ZP"] = ({
    getPromos: getPromos,
    getPromosByStatus: getPromosByStatus,
    checkPromoAvailableForCart: checkPromoAvailableForCart,
    getPromosActive: getPromosActive,
    getPromoDetailByVoucherCode: getPromoDetailByVoucherCode,
    getMyVoucher: getMyVoucher,
    getPromotionByID: getPromotionByID,
    getPromotionListByIDs: getPromotionListByIDs,
    getVoucherActive: getVoucherActive,
    getActiveCampaign: getActiveCampaign,
    getActiveCampaignClient: getActiveCampaignClient,
    getCampaignProducts: getCampaignProducts,
    getVoucherActiveOrder: getVoucherActiveOrder,
    getVoucherActiveConfig: getVoucherActiveConfig,
    getMyHistoryVoucher: getMyHistoryVoucher,
    getDataVoucherClient: getDataVoucherClient,
    getLogSelfLuckyWheel: getLogSelfLuckyWheel,
    getMissionSelfLuckyWheel: getMissionSelfLuckyWheel,
    getSelfLuckyWheelRewards: getSelfLuckyWheelRewards,
    postGamificationScore: postGamificationScore,
    postSpinLuckyWheel: postSpinLuckyWheel,
    postVoucherList: postVoucherList,
    getVoucherDetail: getVoucherDetail,
    getVoucherConditionMessage: getVoucherConditionMessage,
    postShareLog: postShareLog,
    getSpinQuestion: getSpinQuestion
});


/***/ }),

/***/ 15537:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97582);
/* harmony import */ var constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83679);
/* harmony import */ var _Clients__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38307);
/* harmony import */ var _ProductClientV2__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22997);





// API for wweb
var getAllSellerWeb = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(param) {
        var ctx, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            ctx = param.ctx;
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_1__.GET)((_tmp.ctx = ctx, _tmp.url = "/web/sellers", _tmp.mock = true, _tmp))
            ];
        });
    });
    return function getAllSellerWeb(_) {
        return _ref.apply(this, arguments);
    };
}();
// for server side
var getAllSellers = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(param) {
        var ctx, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            ctx = param.ctx;
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_1__.GET_ALL)((_tmp.ctx = ctx, _tmp.url = "/seller/core/v1/account/list", _tmp.isBasic = true, _tmp.isAuth = false, _tmp))
            ];
        });
    });
    return function getAllSellers(_) {
        return _ref.apply(this, arguments);
    };
}();
var getListBanner = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(param) {
        var ctx, sellerCode, _isActive, isActive, url, params, _tmp, _tmp1;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            ctx = param.ctx, sellerCode = param.sellerCode, _isActive = param.isActive, isActive = _isActive === void 0 ? true : _isActive;
            url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .SUPPLIER_API.SUPPLIER_BANNER */ .yV.SUPPLIER_BANNER;
            _tmp = {};
            params = (_tmp.q = JSON.stringify({
                sellerCode: sellerCode,
                isActive: isActive
            }), _tmp);
            _tmp1 = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_1__.GET)((_tmp1.ctx = ctx, _tmp1.url = url, _tmp1.params = params, _tmp1))
            ];
        });
    });
    return function getListBanner(_) {
        return _ref.apply(this, arguments);
    };
}();
var getSellerInfo = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(param) {
        var ctx, slug, url, params, _tmp, _tmp1;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            ctx = param.ctx, slug = param.slug;
            url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .SUPPLIER_API.SUPPLIER_ACCOUNT_INFO */ .yV.SUPPLIER_ACCOUNT_INFO;
            _tmp = {};
            params = (_tmp.slug = slug, _tmp);
            _tmp1 = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_1__.GET)((_tmp1.ctx = ctx, _tmp1.url = url, _tmp1.params = params, _tmp1))
            ];
        });
    });
    return function getSellerInfo(_) {
        return _ref.apply(this, arguments);
    };
}();
var getStoreInfo = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(param) {
        var ctx, slug, url, params, _tmp, _tmp1;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            ctx = param.ctx, slug = param.slug;
            url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .SUPPLIER_API.STORE_INFO */ .yV.STORE_INFO;
            _tmp = {};
            params = (_tmp.slug = slug, _tmp);
            _tmp1 = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_1__.GET)((_tmp1.ctx = ctx, _tmp1.url = url, _tmp1.params = params, _tmp1.isBasic = true, _tmp1))
            ];
        });
    });
    return function getStoreInfo(_) {
        return _ref.apply(this, arguments);
    };
}();
var getListStoreActive = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(param) {
        var ctx, sellerCode, _status, status, url, params, _tmp, _tmp1;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            ctx = param.ctx, sellerCode = param.sellerCode, _status = param.status, status = _status === void 0 ? "ACTIVE" : _status;
            url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .SUPPLIER_API.SUPPLIER_STORE_LIST */ .yV.SUPPLIER_STORE_LIST;
            _tmp = {};
            params = (_tmp.q = JSON.stringify({
                status: status,
                sellerCode: sellerCode
            }), _tmp);
            _tmp1 = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_1__.GET)((_tmp1.ctx = ctx, _tmp1.url = url, _tmp1.params = params, _tmp1.cache = true, _tmp1.cacheServer = false, _tmp1))
            ];
        });
    });
    return function getListStoreActive(_) {
        return _ref.apply(this, arguments);
    };
}();
// API for mock
var getAllStoreActive = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(param) {
        var ctx, _status, status, url, params, _tmp, _tmp1;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            ctx = param.ctx, _status = param.status, status = _status === void 0 ? "ACTIVE" : _status;
            url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .SUPPLIER_API.SUPPLIER_STORE_LIST */ .yV.SUPPLIER_STORE_LIST;
            _tmp = {};
            params = (_tmp.q = JSON.stringify({
                status: status
            }), _tmp);
            _tmp1 = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_1__.GET_ALL)((_tmp1.ctx = ctx, _tmp1.url = url, _tmp1.params = params, _tmp1.limit = 20, _tmp1.isBasic = true, _tmp1.isAuth = false, _tmp1.cache = true, _tmp1.cacheServer = false, _tmp1))
            ];
        });
    });
    return function getAllStoreActive(_) {
        return _ref.apply(this, arguments);
    };
}();
// API web
var getAllStoreActiveWeb = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(param) {
        var ctx, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            ctx = param.ctx;
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_1__.GET)((_tmp.ctx = ctx, _tmp.url = "/seller/store/active", _tmp.mock = true, _tmp.isAuth = false, _tmp))
            ];
        });
    });
    return function getAllStoreActiveWeb(_) {
        return _ref.apply(this, arguments);
    };
}();
var getProductBySeller = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(param) {
        var ctx, params, url, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            ctx = param.ctx, params = param.params;
            url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_0__/* .PRODUCT_API.SELLER */ .PJ.SELLER;
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_1__.GET)((_tmp.ctx = ctx, _tmp.url = url, _tmp.params = params, _tmp))
            ];
        });
    });
    return function getProductBySeller(_) {
        return _ref.apply(this, arguments);
    };
}();
// https://api.v2-stg.thuocsi.vn/seller/core/v1/account?sellerCode=4GQEM8DN9F
var getSellerByCode = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(param) {
        var ctx, sellerCode, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            ctx = param.ctx, sellerCode = param.sellerCode;
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_1__.GET)((_tmp.ctx = ctx, _tmp.url = "/seller/core/v1/account", _tmp.params = {
                    sellerCode: sellerCode
                }, _tmp.cache = true, _tmp))
            ];
        });
    });
    return function getSellerByCode(_) {
        return _ref.apply(this, arguments);
    };
}();
var searchStore = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(param) {
        var ctx, body, url, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            ctx = param.ctx, body = param.body;
            url = "/seller/core/v1/stores/search";
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_1__.POST)((_tmp.ctx = ctx, _tmp.url = url, _tmp.body = body, _tmp.isBasic = true, _tmp.isAuth = false, _tmp))
            ];
        });
    });
    return function searchStore(_) {
        return _ref.apply(this, arguments);
    };
}();
var searchStoreByText = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(param) {
        var ctx, params, url, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            ctx = param.ctx, params = param.params;
            url = "/seller/core/v1/account/list";
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_1__.GET)((_tmp.ctx = ctx, _tmp.url = url, _tmp.params = params, _tmp.isBasic = true, _tmp.isAuth = false, _tmp))
            ];
        });
    });
    return function searchStoreByText(_) {
        return _ref.apply(this, arguments);
    };
}();
var searchProductInSellers = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(param) {
        var ctx, body, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            ctx = param.ctx, body = param.body;
            _tmp = {};
            // const url = '/marketplace/product/v2/search/fuzzy';
            // return POST({ ctx, url, body });
            return [
                2,
                _ProductClientV2__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getFuzzySearchClient */ .ZP.getFuzzySearchClient((_tmp.ctx = ctx, _tmp.body = body, _tmp))
            ];
        });
    });
    return function searchProductInSellers(_) {
        return _ref.apply(this, arguments);
    };
}();
var getLandingPageSeller = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(param) {
        var ctx, sellerCode, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            ctx = param.ctx, sellerCode = param.sellerCode;
            _tmp = {};
            return [
                2,
                (0,_Clients__WEBPACK_IMPORTED_MODULE_1__.GET)((_tmp.ctx = ctx, _tmp.url = "/seller/core/v1/store/info-for-web", _tmp.params = {
                    sellerCode: sellerCode
                }, _tmp))
            ];
        });
    });
    return function getLandingPageSeller(_) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ __webpack_exports__["Z"] = ({
    getAllStoreActive: getAllStoreActive,
    getAllStoreActiveWeb: getAllStoreActiveWeb,
    getListStoreActive: getListStoreActive,
    getSellerByCode: getSellerByCode,
    getAllSellers: getAllSellers,
    getAllSellerWeb: getAllSellerWeb,
    getListBanner: getListBanner,
    getSellerInfo: getSellerInfo,
    getProductBySeller: getProductBySeller,
    searchStore: searchStore,
    searchProductInSellers: searchProductInSellers,
    getLandingPageSeller: getLandingPageSeller,
    getStoreInfo: getStoreInfo,
    searchStoreByText: searchStoreByText
});


/***/ }),

/***/ 15149:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "uQ": function() { return /* reexport */ AddressClient; },
  "LY": function() { return /* reexport */ AuthClient; },
  "D5": function() { return /* reexport */ BankClient; },
  "HP": function() { return /* reexport */ CartClientV2/* default */.Z; },
  "WO": function() { return /* reexport */ ConfigManagerClient; },
  "Ly": function() { return /* reexport */ ContentClient; },
  "YP": function() { return /* reexport */ CustomerClient/* default */.ZP; },
  "HT": function() { return /* reexport */ Clients.GET; },
  "Ce": function() { return /* reexport */ IngredientClient/* default */.Z; },
  "J0": function() { return /* reexport */ Clients.LIMIT_DEFAULT; },
  "c": function() { return /* reexport */ MarketingClient; },
  "$T": function() { return /* reexport */ NotifyClient; },
  "M6": function() { return /* reexport */ Clients.OFFSET_DEFAULT; },
  "ZT": function() { return /* reexport */ OrderClient; },
  "a4": function() { return /* reexport */ Clients.POST; },
  "C9": function() { return /* reexport */ PricingClients; },
  "j4": function() { return /* reexport */ ProductClientV2/* default */.ZP; },
  "yK": function() { return /* reexport */ PromoClient/* default */.ZP; },
  "$i": function() { return /* reexport */ PromotionClient; },
  "w9": function() { return /* reexport */ SearchClient; },
  "vQ": function() { return /* reexport */ SellerClient/* default */.Z; },
  "z9": function() { return /* reexport */ SettingClient; },
  "VS": function() { return /* reexport */ SupplierClient; },
  "ZX": function() { return /* reexport */ TicketClient; },
  "jn": function() { return /* reexport */ TrackingActionClient; },
  "Hf": function() { return /* reexport */ WebServiceClient; },
  "lH": function() { return /* reexport */ WishlistClient; },
  "Yu": function() { return /* reexport */ Clients.getData; },
  "Xi": function() { return /* reexport */ Clients.getFirst; },
  "YW": function() { return /* reexport */ Clients.getSessionToken; },
  "JY": function() { return /* reexport */ Clients.isValid; },
  "jB": function() { return /* reexport */ Clients.isValidWithData; },
  "Wk": function() { return /* reexport */ Clients.isValidWithoutData; }
});

// UNUSED EXPORTS: CatClient, DELETE, GET_ALL, MAX_LIMIT, POST_ALL, PUT, ProductClient, UploadImageClient

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./src/constants/APIUri.js
var APIUri = __webpack_require__(17233);
// EXTERNAL MODULE: ./src/utils/ResponseUtils.js
var ResponseUtils = __webpack_require__(73744);
// EXTERNAL MODULE: ./src/utils/ValidateUtils.js
var ValidateUtils = __webpack_require__(70220);
// EXTERNAL MODULE: ./src/clients/Clients.js + 1 modules
var Clients = __webpack_require__(38307);
;// CONCATENATED MODULE: ./src/clients/AddressClient.js






var getProvinces = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(ctx) {
        var _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            _tmp = {};
            return [
                2,
                (0,Clients.GET)((_tmp.url = APIUri/* CORE_API.PROVINCE_LIST */.S$.PROVINCE_LIST, _tmp.ctx = ctx, _tmp.isBasic = true, _tmp.isAuth = false, _tmp))
            ];
        });
    });
    return function getProvinces(ctx) {
        return _ref.apply(this, arguments);
    };
}();
var getRegions = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(ctx) {
        var _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            _tmp = {};
            return [
                2,
                (0,Clients.GET_ALL)((_tmp.url = APIUri/* CORE_API.REGIONS */.S$.REGIONS, _tmp.ctx = ctx, _tmp.isBasic = true, _tmp.isAuth = false, _tmp.cache = true, _tmp.cacheServer = false, _tmp))
            ];
        });
    });
    return function getRegions(ctx) {
        return _ref.apply(this, arguments);
    };
}();
var getDistrictsByProvince = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(provinceCode) {
        var _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            _tmp = {};
            return [
                2,
                (0,Clients.GET)((_tmp.url = APIUri/* CORE_API.DISTRICT_LIST */.S$.DISTRICT_LIST, _tmp.params = {
                    provinceCode: provinceCode
                }, _tmp.isBasic = true, _tmp.isAuth = false, _tmp))
            ];
        });
    });
    return function getDistrictsByProvince(provinceCode) {
        return _ref.apply(this, arguments);
    };
}();
var getWardsByDistrict = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function() {
        var districtCode, _tmp;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            districtCode = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : "";
            if ((0,ValidateUtils/* isEmpty */.xb)(districtCode)) {
                return [
                    2,
                    (0,ResponseUtils/* invalid */.I1)("DistrictCode not found")
                ];
            }
            _tmp = {};
            return [
                2,
                (0,Clients.GET)((_tmp.url = APIUri/* CORE_API.ADMINISTRATIVE */.S$.ADMINISTRATIVE, _tmp.params = {
                    districtCode: districtCode
                }, _tmp.isBasic = true, _tmp.isAuth = false, _tmp))
            ];
        });
    });
    return function getWardsByDistrict() {
        return _ref.apply(this, arguments);
    };
}();
var getWardByCode = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(ctx, wardCode) {
        var _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            _tmp = {};
            return [
                2,
                (0,Clients.GET)((_tmp.ctx = ctx, _tmp.url = APIUri/* CORE_API.WARD */.S$.WARD, _tmp.params = {
                    wardCode: wardCode
                }, _tmp))
            ];
        });
    });
    return function getWardByCode(ctx, wardCode) {
        return _ref.apply(this, arguments);
    };
}();
var getDistrictByCode = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(ctx, code) {
        var _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            _tmp = {};
            return [
                2,
                (0,Clients.GET)((_tmp.ctx = ctx, _tmp.url = APIUri/* CORE_API.DISTRICT */.S$.DISTRICT, _tmp.params = {
                    code: code
                }, _tmp))
            ];
        });
    });
    return function getDistrictByCode(ctx, code) {
        return _ref.apply(this, arguments);
    };
}();
var getProvinceByCode = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(ctx, code) {
        var _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            _tmp = {};
            return [
                2,
                (0,Clients.GET)((_tmp.ctx = ctx, _tmp.url = APIUri/* CORE_API.PROVINCE */.S$.PROVINCE, _tmp.params = {
                    code: code
                }, _tmp))
            ];
        });
    });
    return function getProvinceByCode(ctx, code) {
        return _ref.apply(this, arguments);
    };
}();
var getAllCountriesMock = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            ctx = param.ctx;
            _tmp = {};
            return [
                2,
                (0,Clients.GET)((_tmp.url = "/web/master-data/country", _tmp.ctx = ctx, _tmp.mock = true, _tmp.isAuth = false, _tmp))
            ];
        });
    });
    return function getAllCountriesMock(_) {
        return _ref.apply(this, arguments);
    };
}();
var getAllProvinceMock = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            ctx = param.ctx;
            _tmp = {};
            return [
                2,
                (0,Clients.GET)((_tmp.url = "/web/master-data/provinces", _tmp.ctx = ctx, _tmp.mock = true, _tmp.isAuth = false, _tmp))
            ];
        });
    });
    return function getAllProvinceMock(_) {
        return _ref.apply(this, arguments);
    };
}();
var getAllCountries = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            ctx = param.ctx;
            _tmp = {};
            return [
                2,
                (0,Clients.GET)((_tmp.url = APIUri/* CORE_API.COUNTRIES_LIST */.S$.COUNTRIES_LIST, _tmp.ctx = ctx, _tmp.isBasic = true, _tmp.isAuth = false, _tmp))
            ];
        });
    });
    return function getAllCountries(_) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var AddressClient = ({
    getProvinces: getProvinces,
    getAllCountries: getAllCountries,
    getDistrictsByProvince: getDistrictsByProvince,
    getWardsByDistrict: getWardsByDistrict,
    getWardByCode: getWardByCode,
    getDistrictByCode: getDistrictByCode,
    getProvinceByCode: getProvinceByCode,
    getAllCountriesMock: getAllCountriesMock,
    getAllProvinceMock: getAllProvinceMock,
    getRegions: getRegions
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./src/constants/APIUriV2.js
var APIUriV2 = __webpack_require__(83679);
;// CONCATENATED MODULE: ./src/clients/AuthClient.js







var getUserWithContext = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(ctx) {
        var ss, _tmp, _tmp1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            ss = (0,Clients.getSessionToken)(ctx);
            _tmp = {};
            if (!ss) {
                return [
                    2,
                    (_tmp.isAuthenticated = false, _tmp)
                ];
            }
            _tmp1 = {};
            return [
                2,
                (0,Clients.GET)((_tmp1.url = APIUri/* CUSTOMER_API.INFO */.Xe.INFO, _tmp1.ctx = ctx, _tmp1))
            ];
        });
    });
    return function getUserWithContext(ctx) {
        return _ref.apply(this, arguments);
    };
}();
var loginInternal = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx, body, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            ctx = param.ctx, body = param.body;
            _tmp = {};
            return [
                2,
                (0,Clients.POST)((_tmp.ctx = ctx, _tmp.url = APIUri/* ACCOUNT_API.AUTHENTICATION */.V0.AUTHENTICATION, _tmp.body = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, body), {
                    type: "EMPLOYEE"
                }), _tmp.isAuth = true, _tmp))
            ];
        });
    });
    return function loginInternal(_) {
        return _ref.apply(this, arguments);
    };
}();
var login = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(body) {
        var _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            _tmp = {};
            return [
                2,
                (0,Clients.POST)((_tmp.url = APIUri/* CUSTOMER_API.SIGN_IN */.Xe.SIGN_IN, _tmp.// url: ACCOUNT_API.AUTHENTICATION,
                body = body, _tmp.isAuth = false, _tmp))
            ];
        });
    });
    return function login(body) {
        return _ref.apply(this, arguments);
    };
}();
var logout = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function() {
        var _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            _tmp = {};
            return [
                2,
                (0,Clients.PUT)((_tmp.url = APIUri/* ACCOUNT_API.LOGOUT */.V0.LOGOUT, _tmp))
            ];
        });
    });
    return function logout() {
        return _ref.apply(this, arguments);
    };
}();
var passwordRecovery = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(body) {
        var _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            _tmp = {};
            return [
                2,
                (0,Clients.POST)((_tmp.url = APIUriV2/* FRONTEND_APIS.PASSWORD_RECOVERY */.eI.PASSWORD_RECOVERY, _tmp.body = body, _tmp.isAuth = false, _tmp))
            ];
        });
    });
    return function passwordRecovery(body) {
        return _ref.apply(this, arguments);
    };
}();
var passwordUpdate = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(body) {
        var _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            _tmp = {};
            return [
                2,
                (0,Clients.PUT)((_tmp.url = APIUriV2/* FRONTEND_APIS.PASSWORD_RECOVERY */.eI.PASSWORD_RECOVERY, _tmp.body = body, _tmp.isAuth = false, _tmp))
            ];
        });
    });
    return function passwordUpdate(body) {
        return _ref.apply(this, arguments);
    };
}();
var loginLocal = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(body) {
        var _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            _tmp = {};
            return [
                2,
                (0,Clients.POST)((_tmp.url = "/login", _tmp.body = body, _tmp.page = true, _tmp.mock = true, _tmp.isAuth = false, _tmp))
            ];
        });
    });
    return function loginLocal(body) {
        return _ref.apply(this, arguments);
    };
}();
// { username password }
var signUp = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(body) {
        var _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            _tmp = {};
            return [
                2,
                (0,Clients.POST)((_tmp.url = APIUri/* CUSTOMER_API.REGISTER */.Xe.REGISTER, _tmp.body = body, _tmp.isAuth = false, _tmp))
            ];
        });
    });
    return function signUp(body) {
        return _ref.apply(this, arguments);
    };
}();
var registerGuest = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(body) {
        var _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            _tmp = {};
            return [
                2,
                (0,Clients.POST)((_tmp.url = APIUri/* CUSTOMER_API.REGISTER_GUEST */.Xe.REGISTER_GUEST, _tmp.body = body, _tmp.isBasic = true, _tmp))
            ];
        });
    });
    return function registerGuest(body) {
        return _ref.apply(this, arguments);
    };
}();
var registerV1 = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var t, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            t = param.t;
            _tmp = {};
            return [
                2,
                (0,Clients.GET)((_tmp.url = APIUri/* CUSTOMER_API.REGISTER */.Xe.REGISTER, _tmp.params = {
                    t: t
                }, _tmp.isAuth = false, _tmp.isBasic = true, _tmp))
            ];
        });
    });
    return function registerV1(_) {
        return _ref.apply(this, arguments);
    };
}();
var getAccountInfo = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            ctx = param.ctx;
            _tmp = {};
            return [
                2,
                (0,Clients.GET)((_tmp.url = APIUri/* ACCOUNT_API.GET_ACCOUNT_INFO */.V0.GET_ACCOUNT_INFO, _tmp.ctx = ctx, _tmp))
            ];
        });
    });
    return function getAccountInfo(_) {
        return _ref.apply(this, arguments);
    };
}();
var getUser = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function() {
        var result, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    return [
                        4,
                        (0,Clients.GET)((_tmp.url = APIUri/* CUSTOMER_API.INFO */.Xe.INFO, _tmp.params = {
                            getCustomer: true
                        }, _tmp))
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        2,
                        result
                    ];
            }
        });
    });
    return function getUser() {
        return _ref.apply(this, arguments);
    };
}();
var newPassword = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(body) {
        var _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            _tmp = {};
            return [
                2,
                (0,Clients.PUT)((_tmp.url = APIUri/* ACCOUNT_API.PASSWORD_NEW */.V0.PASSWORD_NEW, _tmp.body = body, _tmp.isAuth = true, _tmp))
            ];
        });
    });
    return function newPassword(body) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var AuthClient = ({
    login: login,
    getUser: getUser,
    signUp: signUp,
    registerGuest: registerGuest,
    getUserWithContext: getUserWithContext,
    loginLocal: loginLocal,
    getAccountInfo: getAccountInfo,
    passwordRecovery: passwordRecovery,
    passwordUpdate: passwordUpdate,
    registerV1: registerV1,
    newPassword: newPassword,
    logout: logout,
    loginInternal: loginInternal
});

;// CONCATENATED MODULE: ./src/clients/BankClient.js




var getBanks = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(ctx) {
        var _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            _tmp = {};
            return [
                2,
                (0,Clients.GET_ALL)((_tmp.url = APIUri/* CORE_API.BANK_LIST */.S$.BANK_LIST, _tmp.ctx = ctx, _tmp))
            ];
        });
    });
    return function getBanks(ctx) {
        return _ref.apply(this, arguments);
    };
}();
var getBankById = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx, bankId, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            ctx = param.ctx, bankId = param.bankId;
            _tmp = {};
            return [
                2,
                (0,Clients.GET)((_tmp.ctx = ctx, _tmp.url = APIUri/* CORE_API.BANK_BY_ID */.S$.BANK_BY_ID, _tmp.params = {
                    bankId: bankId
                }, _tmp))
            ];
        });
    });
    return function getBankById(_) {
        return _ref.apply(this, arguments);
    };
}();
var getBranches = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx, bankId, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            ctx = param.ctx, bankId = param.bankId;
            _tmp = {};
            return [
                2,
                (0,Clients.GET_ALL)((_tmp.ctx = ctx, _tmp.url = APIUri/* CORE_API.BANK_BRANCH_LIST */.S$.BANK_BRANCH_LIST, _tmp.params = {
                    bankId: bankId
                }, _tmp))
            ];
        });
    });
    return function getBranches(_) {
        return _ref.apply(this, arguments);
    };
}();
var getBranchById = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx, branchId, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            ctx = param.ctx, branchId = param.branchId;
            _tmp = {};
            return [
                2,
                (0,Clients.GET)((_tmp.ctx = ctx, _tmp.url = APIUri/* CORE_API.BANK_BRANCH_BY_ID */.S$.BANK_BRANCH_BY_ID, _tmp.params = {
                    branchId: branchId
                }, _tmp))
            ];
        });
    });
    return function getBranchById(_) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var BankClient = ({
    getBanks: getBanks,
    getBranches: getBranches,
    getBankById: getBankById,
    getBranchById: getBranchById
});

// EXTERNAL MODULE: ./src/clients/CartClientV2.js
var CartClientV2 = __webpack_require__(10741);
// EXTERNAL MODULE: ./src/constants/manufacturer.js
var manufacturer = __webpack_require__(59893);
// EXTERNAL MODULE: ./src/utils/ArrUtils.js
var ArrUtils = __webpack_require__(33769);
;// CONCATENATED MODULE: ./src/clients/CatClient.js






function loadBrand(_) {
    return _loadBrand.apply(this, arguments);
}
function _loadBrand() {
    _loadBrand = (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx, params, ref, res, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ctx = param.ctx, params = param.params;
                    _tmp = {};
                    return [
                        4,
                        (0,Clients.GET_ALL)((_tmp.url = APIUriV2/* PRODUCT_API.MANUFACTURER_LIST */.PJ.MANUFACTURER_LIST, _tmp.ctx = ctx, _tmp.isBasic = true, _tmp.params = params, _tmp))
                    ];
                case 1:
                    res = _state.sent();
                    if (!(0,Clients.isValid)(res)) {
                        return [
                            2,
                            []
                        ];
                    }
                    return [
                        2,
                        res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.filter(function(item) {
                            return manufacturer/* TopManufacturer.indexOf */.j.indexOf(item.code) >= 0;
                        }).sort(function(a, b) {
                            var ref, ref1;
                            return (0,ArrUtils/* sortComparer */.J5)((a === null || a === void 0 ? void 0 : (ref = a.name) === null || ref === void 0 ? void 0 : ref.toLowerCase()) || "", (b === null || b === void 0 ? void 0 : (ref1 = b.name) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()) || "");
                        })
                    ];
            }
        });
    });
    return _loadBrand.apply(this, arguments);
}
function loadGroup(_) {
    return _loadGroup.apply(this, arguments);
}
function _loadGroup() {
    _loadGroup = (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx, params, ref, res, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ctx = param.ctx, params = param.params;
                    _tmp = {};
                    return [
                        4,
                        (0,Clients.GET_ALL)((_tmp.url = APIUriV2/* PRODUCT_API.CATEGORY_LIST */.PJ.CATEGORY_LIST, _tmp.ctx = ctx, _tmp.isBasic = true, _tmp.params = params, _tmp.cache = true, _tmp.cacheServer = false, _tmp))
                    ];
                case 1:
                    res = _state.sent();
                    if (!(0,Clients.isValid)(res)) {
                        return [
                            2,
                            []
                        ];
                    }
                    return [
                        2,
                        res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.sort(function(a, b) {
                            var ref, ref1;
                            return (0,ArrUtils/* sortComparer */.J5)((a === null || a === void 0 ? void 0 : (ref = a.name) === null || ref === void 0 ? void 0 : ref.toLowerCase()) || "", (b === null || b === void 0 ? void 0 : (ref1 = b.name) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()) || "");
                        })
                    ];
            }
        });
    });
    return _loadGroup.apply(this, arguments);
}
function loadCategoryInfoBySlug(ctx) {
    return _loadCategoryInfoBySlug.apply(this, arguments);
}
function _loadCategoryInfoBySlug() {
    _loadCategoryInfoBySlug = (0,_async_to_generator/* default */.Z)(function(ctx) {
        var query, url, res, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    query = ctx.query;
                    url = "".concat(APIUriV2/* PRODUCT_API.CATEGORY_INFO */.PJ.CATEGORY_INFO, "?q=").concat(query.slug || "");
                    _tmp = {};
                    return [
                        4,
                        (0,Clients.GET)((_tmp.url = url, _tmp.ctx = ctx, _tmp.isBasic = true, _tmp))
                    ];
                case 1:
                    res = _state.sent();
                    if (!(0,Clients.isValid)(res)) {
                        return [
                            2,
                            []
                        ];
                    }
                    return [
                        2,
                        res.data
                    ];
            }
        });
    });
    return _loadCategoryInfoBySlug.apply(this, arguments);
}
function loadManufacturerInfoBySlug(ctx) {
    return _loadManufacturerInfoBySlug.apply(this, arguments);
}
function _loadManufacturerInfoBySlug() {
    _loadManufacturerInfoBySlug = (0,_async_to_generator/* default */.Z)(function(ctx) {
        var query, url, res, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    query = ctx.query;
                    url = "".concat(APIUriV2/* PRODUCT_API.MANUFACTURER_INFO */.PJ.MANUFACTURER_INFO, "?q=").concat(query.slug || "");
                    _tmp = {};
                    return [
                        4,
                        (0,Clients.GET)((_tmp.url = url, _tmp.ctx = ctx, _tmp.isBasic = true, _tmp))
                    ];
                case 1:
                    res = _state.sent();
                    if (!(0,Clients.isValid)(res)) {
                        return [
                            2,
                            []
                        ];
                    }
                    return [
                        2,
                        res.data
                    ];
            }
        });
    });
    return _loadManufacturerInfoBySlug.apply(this, arguments);
}
function loadTags(ctx) {
    return _loadTags.apply(this, arguments);
}
function _loadTags() {
    _loadTags = (0,_async_to_generator/* default */.Z)(function(ctx) {
        var url, res, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    url = APIUriV2/* PRODUCT_API.TAGS */.PJ.TAGS;
                    _tmp = {};
                    return [
                        4,
                        (0,Clients.GET)((_tmp.url = url, _tmp.ctx = ctx, _tmp.isBasic = true, _tmp))
                    ];
                case 1:
                    res = _state.sent();
                    if (!(0,Clients.isValid)(res)) {
                        return [
                            2,
                            []
                        ];
                    }
                    return [
                        2,
                        res.data
                    ];
            }
        });
    });
    return _loadTags.apply(this, arguments);
}
/* harmony default export */ var CatClient = ({
    loadBrand: loadBrand,
    loadGroup: loadGroup,
    loadCategoryInfoBySlug: loadCategoryInfoBySlug,
    loadManufacturerInfoBySlug: loadManufacturerInfoBySlug,
    loadTags: loadTags
});

;// CONCATENATED MODULE: ./src/clients/ContentClient.js




function loadContent() {
    return _loadContent.apply(this, arguments);
}
function _loadContent() {
    _loadContent = (0,_async_to_generator/* default */.Z)(function() {
        var url, staticUrl, result, _tmp;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    url = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : "";
                    staticUrl = "".concat(APIUri/* CONTENT_API.STATIC_CONTENT */.IQ.STATIC_CONTENT, "/").concat(url);
                    _tmp = {};
                    return [
                        4,
                        (0,Clients.POST)((_tmp.url = staticUrl, _tmp.mock = true, _tmp.isAuth = false, _tmp))
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        2,
                        (0,Clients.getData)(result)
                    ];
            }
        });
    });
    return _loadContent.apply(this, arguments);
}
/* harmony default export */ var ContentClient = ({
    loadContent: loadContent
});

// EXTERNAL MODULE: ./src/clients/CustomerClient.js
var CustomerClient = __webpack_require__(59261);
// EXTERNAL MODULE: ./src/clients/IngredientClient.js
var IngredientClient = __webpack_require__(82036);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
;// CONCATENATED MODULE: ./src/clients/MarketingClient.js






var getListBanner = function(ctx) {
    var url = APIUri/* MARKETING_API.BANNER */.ud.BANNER;
    return (0,Clients.GET)({
        url: url,
        ctx: ctx,
        isBasic: true,
        isAuth: false,
        cache: true,
        cacheServer: false
    });
};
var getHashtagTopSearch = function() {
    return (0,Clients.GET)({
        url: "/web/top-search",
        mock: true,
        isAuth: false
    });
};
var getProductFiles = function(param) {
    var _q = param.q, q = _q === void 0 ? {} : _q, _isMienBac = param.isMienBac, isMienBac = _isMienBac === void 0 ? false : _isMienBac;
    return (0,Clients.GET)({
        url: "/web/sanphammoi",
        params: {
            q: JSON.stringify(q),
            isMienBac: isMienBac
        },
        mock: true,
        isAuth: false
    });
};
var getListBannerMock = function() {
    var url = "/web/banner";
    return (0,Clients.GET)({
        url: url,
        mock: true,
        isAuth: false
    });
};
var getMostSearchMock = function() {
    return (0,Clients.GET)({
        url: "/web/most-search",
        mock: true,
        isAuth: false
    });
};
var getSections = function(_param) {
    var _q = _param.q, q = _q === void 0 ? {} : _q, ctx = _param.ctx, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "q",
        "ctx"
    ]);
    return (0,Clients.GET)({
        ctx: ctx,
        url: APIUri/* MARKETING_API.SECTION */.ud.SECTION,
        params: {
            q: JSON.stringify((0,_object_spread/* default */.Z)({}, q))
        }
    });
};
var getPolicies = function(ctx) {
    return (0,Clients.GET)({
        ctx: ctx,
        url: APIUri/* MARKETING_API.POLICY */.ud.POLICY,
        isBasic: true,
        isAuth: false,
        cache: true,
        cacheServer: false
    });
};
var getTrendSearch = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(_param) {
        var ctx, isActive, props, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            ctx = _param.ctx, isActive = _param.isActive, props = (0,_object_without_properties/* default */.Z)(_param, [
                "ctx",
                "isActive"
            ]);
            _tmp = {};
            return [
                2,
                (0,Clients.GET)((_tmp.ctx = ctx, _tmp.url = APIUri/* MARKETING_API.TREND_SEARCH */.ud.TREND_SEARCH, _tmp.params = (0,_object_spread/* default */.Z)({
                    isActive: isActive
                }, props), _tmp))
            ];
        });
    });
    return function getTrendSearch(_param) {
        return _ref.apply(this, arguments);
    };
}();
var getHomeBanner = function(ctx) {
    return (0,Clients.GET)({
        ctx: ctx,
        url: APIUri/* MARKETING_API.HOME_BANNER */.ud.HOME_BANNER,
        isBasic: true,
        isAuth: false,
        cache: true,
        cacheServer: false
    });
};
var getReferralContent = function(ctx) {
    return (0,Clients.GET)({
        ctx: ctx,
        url: APIUri/* MARKETING_API.REFERRAL_CONTENT */.ud.REFERRAL_CONTENT,
        params: {
            key: "referral_content"
        },
        isBasic: true,
        isAuth: false,
        cache: true,
        cacheServer: false
    });
};
/* harmony default export */ var MarketingClient = ({
    getListBanner: getListBanner,
    getListBannerMock: getListBannerMock,
    getMostSearchMock: getMostSearchMock,
    getHashtagTopSearch: getHashtagTopSearch,
    getProductFiles: getProductFiles,
    getSections: getSections,
    getPolicies: getPolicies,
    getTrendSearch: getTrendSearch,
    getHomeBanner: getHomeBanner,
    getReferralContent: getReferralContent
});

;// CONCATENATED MODULE: ./src/clients/NotifyClient.js




var getNotify = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx, url, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            ctx = param.ctx;
            url = APIUri/* NOTIFICATION_API.NOTIFICATION_LIST */.sK.NOTIFICATION_LIST;
            _tmp = {};
            return [
                2,
                (0,Clients.GET)((_tmp.url = url, _tmp.ctx = ctx, _tmp))
            ];
        });
    });
    return function getNotify(_) {
        return _ref.apply(this, arguments);
    };
}();
var getTotalNotification = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx, url, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            ctx = param.ctx;
            url = APIUri/* NOTIFICATION_API.NOTIFICATION_COUNTER */.sK.NOTIFICATION_COUNTER;
            _tmp = {};
            return [
                2,
                (0,Clients.GET)((_tmp.url = url, _tmp.ctx = ctx, _tmp))
            ];
        });
    });
    return function getTotalNotification(_) {
        return _ref.apply(this, arguments);
    };
}();
var markReadNotiByCode = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx, code, url, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            ctx = param.ctx, code = param.code;
            url = APIUri/* NOTIFICATION_API.NOTIFICATION */.sK.NOTIFICATION;
            _tmp = {};
            return [
                2,
                (0,Clients.PUT)((_tmp.url = url, _tmp.ctx = ctx, _tmp.params = {
                    code: code
                }, _tmp))
            ];
        });
    });
    return function markReadNotiByCode(_) {
        return _ref.apply(this, arguments);
    };
}();
var markReadAllNoti = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            ctx = param.ctx;
            _tmp = {};
            return [
                2,
                (0,Clients.PUT)((_tmp.url = APIUri/* NOTIFICATION_API.NOTIFICATION_ALL */.sK.NOTIFICATION_ALL, _tmp.ctx = ctx, _tmp))
            ];
        });
    });
    return function markReadAllNoti(_) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var NotifyClient = ({
    getNotify: getNotify,
    getTotalNotification: getTotalNotification,
    markReadAllNoti: markReadAllNoti,
    markReadNotiByCode: markReadNotiByCode
});

// EXTERNAL MODULE: ./src/constants/Enums/index.js
var Enums = __webpack_require__(71569);
;// CONCATENATED MODULE: ./src/clients/OrderClient.js





function getLoyaltyPoint(_) {
    return _getLoyaltyPoint.apply(this, arguments);
}
function _getLoyaltyPoint() {
    _getLoyaltyPoint = (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            ctx = param.ctx;
            _tmp = {};
            return [
                2,
                (0,Clients.GET)((_tmp.url = "".concat(APIUriV2/* ORDER_API.EXCHANGE_CONFIG */.EM.EXCHANGE_CONFIG), _tmp.ctx = ctx, _tmp))
            ];
        });
    });
    return _getLoyaltyPoint.apply(this, arguments);
}
function getOrders(_) {
    return _getOrders.apply(this, arguments);
}
function _getOrders() {
    _getOrders = (0,_async_to_generator/* default */.Z)(function(param) {
        var _offset, offset, _limit, limit, status, ctx, q, _ids, ids, url, params, _tmp, _tmp1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            _offset = param.offset, offset = _offset === void 0 ? Clients.OFFSET_DEFAULT : _offset, _limit = param.limit, limit = _limit === void 0 ? Clients.LIMIT_DEFAULT : _limit, status = param.status, ctx = param.ctx, q = param.q, _ids = param.ids, ids = _ids === void 0 ? null : _ids;
            url = "".concat(APIUriV2/* ORDER_API.MY_ORDER_LIST */.EM.MY_ORDER_LIST);
            _tmp = {};
            params = (_tmp.offset = offset, _tmp.limit = limit, _tmp.getTotal = true, _tmp.status = status, _tmp.q = q, _tmp.ids = ids, _tmp);
            _tmp1 = {};
            return [
                2,
                (0,Clients.GET)((_tmp1.url = url, _tmp1.ctx = ctx, _tmp1.params = params, _tmp1))
            ];
        });
    });
    return _getOrders.apply(this, arguments);
}
function getAllOrders(_) {
    return _getAllOrders.apply(this, arguments);
}
function _getAllOrders() {
    _getAllOrders = (0,_async_to_generator/* default */.Z)(function(param) {
        var status, ctx, url, params, _tmp, _tmp1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            status = param.status, ctx = param.ctx;
            url = "".concat(APIUriV2/* ORDER_API.MY_ORDER_LIST */.EM.MY_ORDER_LIST);
            _tmp = {};
            params = (_tmp.getTotal = true, _tmp);
            if (status !== Enums/* ENUM_ORDER_STATUS.ALL */.TJ.ALL) params.status = status;
            _tmp1 = {};
            return [
                2,
                (0,Clients.GET_ALL)((_tmp1.url = url, _tmp1.ctx = ctx, _tmp1.params = params, _tmp1))
            ];
        });
    });
    return _getAllOrders.apply(this, arguments);
}
var deleteOrder = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var orderId, url, params, _tmp, _tmp1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            orderId = param.orderId;
            url = APIUriV2/* ORDER_API.REVERT */.EM.REVERT;
            _tmp = {};
            params = (_tmp.orderId = orderId, _tmp);
            _tmp1 = {};
            return [
                2,
                (0,Clients.DELETE)((_tmp1.url = url, _tmp1.params = params, _tmp1))
            ];
        });
    });
    return function deleteOrder(_) {
        return _ref.apply(this, arguments);
    };
}();
function getOrderById(_) {
    return _getOrderById.apply(this, arguments);
}
function _getOrderById() {
    _getOrderById = (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx, _id, id, url, params, _tmp, _tmp1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            ctx = param.ctx, _id = param.id, id = _id === void 0 ? 0 : _id;
            url = APIUriV2/* ORDER_API.ORDER_INFO */.EM.ORDER_INFO;
            _tmp = {};
            params = (_tmp.q = JSON.stringify({
                orderId: id
            }), _tmp);
            _tmp1 = {};
            return [
                2,
                (0,Clients.GET)((_tmp1.url = url, _tmp1.ctx = ctx, _tmp1.params = params, _tmp1))
            ];
        });
    });
    return _getOrderById.apply(this, arguments);
}
function getOrderByIdWithoutLogin(_) {
    return _getOrderByIdWithoutLogin.apply(this, arguments);
}
function _getOrderByIdWithoutLogin() {
    _getOrderByIdWithoutLogin = (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx, id, url, params, _tmp, _tmp1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            ctx = param.ctx, id = param.id;
            url = APIUriV2/* ORDER_API.ORDER_INFO */.EM.ORDER_INFO;
            _tmp = {};
            params = (_tmp.q = JSON.stringify({
                orderId: Number(id)
            }), _tmp);
            _tmp1 = {};
            return [
                2,
                (0,Clients.GET)((_tmp1.url = url, _tmp1.ctx = ctx, _tmp1.params = params, _tmp1.isBasic = true, _tmp1.isAuth = false, _tmp1))
            ];
        });
    });
    return _getOrderByIdWithoutLogin.apply(this, arguments);
}
function getProductByOrderCode(_) {
    return _getProductByOrderCode.apply(this, arguments);
}
function _getProductByOrderCode() {
    _getProductByOrderCode = (0,_async_to_generator/* default */.Z)(function(param) {
        var _orderCode, orderCode, ctx, url, params, _tmp, _tmp1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            _orderCode = param.orderCode, orderCode = _orderCode === void 0 ? "" : _orderCode, ctx = param.ctx;
            url = "".concat(APIUriV2/* ORDER_API.ORDER_ITEM_LIST */.EM.ORDER_ITEM_LIST);
            _tmp = {};
            params = (_tmp.q = JSON.stringify({
                orderCode: orderCode
            }), _tmp);
            _tmp1 = {};
            return [
                2,
                (0,Clients.GET_ALL)((_tmp1.url = url, _tmp1.params = params, _tmp1.ctx = ctx, _tmp1))
            ];
        });
    });
    return _getProductByOrderCode.apply(this, arguments);
}
function getInvoicesByOrderId(_) {
    return _getInvoicesByOrderId.apply(this, arguments);
}
function _getInvoicesByOrderId() {
    _getInvoicesByOrderId = (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx, orderId;
        return (0,tslib_es6.__generator)(this, function(_state) {
            ctx = param.ctx, orderId = param.orderId;
            return [
                2,
                null
            ];
        });
    // 22Jan 2024: not yet run invoice in cam & thai
    // const url = '/accounting/invoice/v1/order/order-invoice/lite';
    // const params = {
    //   orderId,
    // };
    // return GET({ url, ctx, params });
    });
    return _getInvoicesByOrderId.apply(this, arguments);
}
function delayDelivery(orderId) {
    return _delayDelivery.apply(this, arguments);
}
function _delayDelivery() {
    _delayDelivery = (0,_async_to_generator/* default */.Z)(function(orderId) {
        var url, body, _tmp, _tmp1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            url = "/marketplace/order/v2/order/delay-delivery";
            _tmp = {};
            body = (_tmp.orderId = orderId, _tmp);
            _tmp1 = {};
            return [
                2,
                (0,Clients.PUT)((_tmp1.url = url, _tmp1.body = body, _tmp1))
            ];
        });
    });
    return _delayDelivery.apply(this, arguments);
}
// yêu cầu giữ đơn
// async function cancelOrder(orderId) {
//   const url = '/marketplace/order/v2/order/status';
//   const body = {
//     orderId,
//     status: 'CANCEL',
//   };
//   return PUT({ url, body });
//   return result;
// }
// huỷ đơn
var cancelOrder = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(orderId) {
        var url, body, _tmp, _tmp1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            url = "/marketplace/order/v2/order/cancel";
            _tmp = {};
            body = (_tmp.orderId = orderId, _tmp);
            _tmp1 = {};
            return [
                2,
                (0,Clients.PUT)((_tmp1.url = url, _tmp1.body = body, _tmp1))
            ];
        });
    });
    return function cancelOrder(orderId) {
        return _ref.apply(this, arguments);
    };
}();
function getLastOrder(_) {
    return _getLastOrder.apply(this, arguments);
}
function _getLastOrder() {
    _getLastOrder = // https://api.v2-stg.thuocsi.vn/marketplace/order/v2/order/summation?info=LAST_ORDER,TOTAL_ORDER&customerId=1060
    (0,_async_to_generator/* default */.Z)(function(param) {
        var customerId, url, params, _tmp, _tmp1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            customerId = param.customerId;
            url = "/marketplace/order/v2/order/summation?info=LAST_ORDER,TOTAL_ORDER";
            _tmp = {};
            params = (_tmp.customerId = customerId, _tmp);
            _tmp1 = {};
            return [
                2,
                (0,Clients.GET)((_tmp1.url = url, _tmp1.params = params, _tmp1))
            ];
        });
    });
    return _getLastOrder.apply(this, arguments);
}
function getOrderID(orderId) {
    return _getOrderID.apply(this, arguments);
}
function _getOrderID() {
    _getOrderID = // search Order
    (0,_async_to_generator/* default */.Z)(function(orderId) {
        var url, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            url = APIUriV2/* ORDER_API.SEARCH_ORDER_ID */.EM.SEARCH_ORDER_ID;
            _tmp = {};
            return [
                2,
                (0,Clients.GET)((_tmp.url = url, _tmp.params = {
                    q: JSON.stringify({
                        orderId: +orderId
                    })
                }, _tmp))
            ];
        });
    });
    return _getOrderID.apply(this, arguments);
}
var searchOrder = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(params) {
        var url, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            url = APIUriV2/* ORDER_API.MY_ORDER_LIST */.EM.MY_ORDER_LIST;
            _tmp = {};
            return [
                2,
                (0,Clients.GET)((_tmp.url = url, _tmp.params = params, _tmp))
            ];
        });
    });
    return function searchOrder(params) {
        return _ref.apply(this, arguments);
    };
}();
var searchOrderwithDate = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var timeFrom, timeTo, offset, limit, url, params, _tmp, _tmp1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            timeFrom = param.timeFrom, timeTo = param.timeTo, offset = param.offset, limit = param.limit;
            url = APIUriV2/* ORDER_API.MY_ORDER_LIST */.EM.MY_ORDER_LIST;
            _tmp = {};
            params = (_tmp.getTotal = true, _tmp.q = JSON.stringify({
                timeFrom: timeFrom,
                timeTo: timeTo
            }), _tmp.offset = offset, _tmp.limit = limit, _tmp);
            _tmp1 = {};
            return [
                2,
                (0,Clients.GET)((_tmp1.url = url, _tmp1.params = params, _tmp1))
            ];
        });
    });
    return function searchOrderwithDate(_) {
        return _ref.apply(this, arguments);
    };
}();
var getByStatusOrder = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var _offset, offset, _limit, limit, status, timeFrom, timeTo, skuCodes, orderId, url, params, _tmp, _tmp1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            _offset = param.offset, offset = _offset === void 0 ? Clients.OFFSET_DEFAULT : _offset, _limit = param.limit, limit = _limit === void 0 ? Clients.LIMIT_DEFAULT : _limit, status = param.status, timeFrom = param.timeFrom, timeTo = param.timeTo, skuCodes = param.skuCodes, orderId = param.orderId;
            url = APIUriV2/* ORDER_API.MY_ORDER_LIST */.EM.MY_ORDER_LIST;
            _tmp = {};
            params = (_tmp.offset = offset, _tmp.limit = limit, _tmp.skuCodes = skuCodes, _tmp.q = JSON.stringify({
                status: status,
                timeFrom: timeFrom,
                timeTo: timeTo,
                orderId: +orderId
            }), _tmp.getTotal = true, _tmp);
            _tmp1 = {};
            return [
                2,
                (0,Clients.GET)((_tmp1.url = url, _tmp1.params = params, _tmp1))
            ];
        });
    });
    return function getByStatusOrder(_) {
        return _ref.apply(this, arguments);
    };
}();
function getAllOrdersSearch() {
    return _getAllOrdersSearch.apply(this, arguments);
}
function _getAllOrdersSearch() {
    _getAllOrdersSearch = (0,_async_to_generator/* default */.Z)(function() {
        var url, params, _tmp, _tmp1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            url = "".concat(APIUriV2/* ORDER_API.ORDER_ITEM_LIST */.EM.ORDER_ITEM_LIST);
            _tmp = {};
            params = (_tmp.getTotal = true, _tmp);
            _tmp1 = {};
            return [
                2,
                (0,Clients.GET)((_tmp1.url = url, _tmp1.params = params, _tmp1))
            ];
        });
    });
    return _getAllOrdersSearch.apply(this, arguments);
}
function searchOrderwithName(_) {
    return _searchOrderwithName.apply(this, arguments);
}
function _searchOrderwithName() {
    _searchOrderwithName = (0,_async_to_generator/* default */.Z)(function(param) {
        var skuCodes, url, params, _tmp, _tmp1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            skuCodes = param.skuCodes;
            url = "".concat(APIUriV2/* ORDER_API.MY_ORDER_LIST */.EM.MY_ORDER_LIST);
            _tmp = {};
            params = (_tmp.skuCodes = skuCodes, _tmp.getTotal = true, _tmp);
            _tmp1 = {};
            return [
                2,
                (0,Clients.GET)((_tmp1.url = url, _tmp1.params = params, _tmp1))
            ];
        });
    });
    return _searchOrderwithName.apply(this, arguments);
}
function searchOrdersByName(_) {
    return _searchOrdersByName.apply(this, arguments);
}
function _searchOrdersByName() {
    _searchOrdersByName = (0,_async_to_generator/* default */.Z)(function(param) {
        var skuCodes, _offset, offset, _limit, limit, url, params, _tmp, _tmp1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            skuCodes = param.skuCodes, _offset = param.offset, offset = _offset === void 0 ? Clients.OFFSET_DEFAULT : _offset, _limit = param.limit, limit = _limit === void 0 ? Clients.LIMIT_DEFAULT : _limit;
            url = "".concat(APIUriV2/* ORDER_API.MY_ORDER_LIST */.EM.MY_ORDER_LIST);
            _tmp = {};
            params = (_tmp.skuCodes = skuCodes, _tmp.getTotal = true, _tmp.offset = offset, _tmp.limit = limit, _tmp);
            _tmp1 = {};
            return [
                2,
                (0,Clients.GET)((_tmp1.url = url, _tmp1.params = params, _tmp1))
            ];
        });
    });
    return _searchOrdersByName.apply(this, arguments);
}
function waitMoreOrder(_) {
    return _waitMoreOrder.apply(this, arguments);
}
function _waitMoreOrder() {
    _waitMoreOrder = (0,_async_to_generator/* default */.Z)(function(param) {
        var orderId, action, url, body, _tmp, _tmp1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            orderId = param.orderId, action = param.action;
            url = "/marketplace/order/v2/order/hold-order";
            _tmp = {};
            body = (_tmp.orderId = orderId, _tmp.action = action, _tmp);
            _tmp1 = {};
            return [
                2,
                (0,Clients.POST)((_tmp1.url = url, _tmp1.body = body, _tmp1))
            ];
        });
    });
    return _waitMoreOrder.apply(this, arguments);
}
function getHoldOrderConfig(_) {
    return _getHoldOrderConfig.apply(this, arguments);
}
function _getHoldOrderConfig() {
    _getHoldOrderConfig = (0,_async_to_generator/* default */.Z)(function(param) {
        var signal, url, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            signal = param.signal;
            url = "/marketplace/order/v2/order/hold-order-config";
            _tmp = {};
            return [
                2,
                (0,Clients.GET)((_tmp.url = url, _tmp.signal = signal, _tmp))
            ];
        });
    });
    return _getHoldOrderConfig.apply(this, arguments);
}
function getStatusWareHouse(_) {
    return _getStatusWareHouse.apply(this, arguments);
}
function _getStatusWareHouse() {
    _getStatusWareHouse = (0,_async_to_generator/* default */.Z)(function(param) {
        var adminId, signal, url, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            adminId = param.adminId, signal = param.signal;
            url = "/warehouse/core/v1/sale-orders";
            _tmp = {};
            return [
                2,
                (0,Clients.GET)((_tmp.url = url, _tmp.params = {
                    adminId: adminId
                }, _tmp.signal = signal, _tmp))
            ];
        });
    });
    return _getStatusWareHouse.apply(this, arguments);
}
function getVouchers(_) {
    return _getVouchers.apply(this, arguments);
}
function _getVouchers() {
    _getVouchers = (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx, _scope, scope, url, params, _tmp, _tmp1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            ctx = param.ctx, _scope = param.scope, scope = _scope === void 0 ? "" : _scope;
            url = "/marketplace/order/v2/voucher/active";
            _tmp = {};
            params = (_tmp.getValidate = true, _tmp.getTotal = true, _tmp.scope = scope, _tmp);
            _tmp1 = {};
            return [
                2,
                (0,Clients.GET_ALL)((_tmp1.url = url, _tmp1.ctx = ctx, _tmp1.params = params, _tmp1))
            ];
        });
    });
    return _getVouchers.apply(this, arguments);
}
function getInvoiceFee(_) {
    return _getInvoiceFee.apply(this, arguments);
}
function _getInvoiceFee() {
    _getInvoiceFee = (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx, orderId, body, _tmp, _tmp1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            ctx = param.ctx, orderId = param.orderId;
            _tmp = {};
            body = (_tmp.q = {
                orderId: Number(orderId)
            }, _tmp);
            _tmp1 = {};
            return [
                2,
                (0,Clients.POST)((_tmp1.url = APIUriV2/* BUYER_SERVICE_API */.mx, _tmp1.ctx = ctx, _tmp1.body = body, _tmp1))
            ];
        });
    });
    return _getInvoiceFee.apply(this, arguments);
}
/* harmony default export */ var OrderClient = ({
    getOrders: getOrders,
    getOrderById: getOrderById,
    getOrderByIdWithoutLogin: getOrderByIdWithoutLogin,
    getProductByOrderCode: getProductByOrderCode,
    deleteOrder: deleteOrder,
    getAllOrders: getAllOrders,
    getInvoicesByOrderId: getInvoicesByOrderId,
    delayDelivery: delayDelivery,
    cancelOrder: cancelOrder,
    getLastOrder: getLastOrder,
    getOrderID: getOrderID,
    searchOrderwithDate: searchOrderwithDate,
    getByStatusOrder: getByStatusOrder,
    getAllOrdersSearch: getAllOrdersSearch,
    searchOrderwithName: searchOrderwithName,
    searchOrdersByName: searchOrdersByName,
    waitMoreOrder: waitMoreOrder,
    getHoldOrderConfig: getHoldOrderConfig,
    getStatusWareHouse: getStatusWareHouse,
    searchOrder: searchOrder,
    getVouchers: getVouchers,
    getInvoiceFee: getInvoiceFee,
    getLoyaltyPoint: getLoyaltyPoint
});

;// CONCATENATED MODULE: ./src/clients/PricingClients.js




var getDeliveryMethod = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx, params, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            ctx = param.ctx, params = param.params;
            _tmp = {};
            return [
                2,
                (0,Clients.GET)((_tmp.url = APIUriV2/* PRICING_API.DELIVERY_METHOD */.PM.DELIVERY_METHOD, _tmp.ctx = ctx, _tmp.params = params, _tmp))
            ];
        });
    });
    return function getDeliveryMethod(_) {
        return _ref.apply(this, arguments);
    };
}();
var getPaymentMethod = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx, params, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            ctx = param.ctx, params = param.params;
            _tmp = {};
            return [
                2,
                (0,Clients.GET)((_tmp.url = APIUriV2/* PRICING_API.PAYMENT_METHOD */.PM.PAYMENT_METHOD, _tmp.ctx = ctx, _tmp.params = params, _tmp))
            ];
        });
    });
    return function getPaymentMethod(_) {
        return _ref.apply(this, arguments);
    };
}();
var getDetailDeliveryMethod = function(param) {
    var deliveryPlatformCode = param.deliveryPlatformCode, ctx = param.ctx;
    return (0,Clients.GET)({
        ctx: ctx,
        url: APIUriV2/* PRICING_API.DELIVERY_METHOD_DETAIL */.PM.DELIVERY_METHOD_DETAIL,
        params: {
            deliveryPlatformCode: deliveryPlatformCode
        }
    });
};
var getDetailPaymentMethod = function(param) {
    var paymentMethodCode = param.paymentMethodCode, ctx = param.ctx;
    return (0,Clients.GET)({
        ctx: ctx,
        url: APIUriV2/* PRICING_API.PAYMENT_METHOD_DETAIL */.PM.PAYMENT_METHOD_DETAIL,
        params: {
            paymentMethodCode: paymentMethodCode
        }
    });
};
/* harmony default export */ var PricingClients = ({
    getDeliveryMethod: getDeliveryMethod,
    getPaymentMethod: getPaymentMethod,
    getDetailDeliveryMethod: getDetailDeliveryMethod,
    getDetailPaymentMethod: getDetailPaymentMethod
});

;// CONCATENATED MODULE: ./src/clients/ProductClient.js






function loadDataMostSearch(ctx) {
    return _loadDataMostSearch.apply(this, arguments);
}
function _loadDataMostSearch() {
    _loadDataMostSearch = (0,_async_to_generator/* default */.Z)(function(ctx) {
        var url, result, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    url = "/product/most-search";
                    _tmp = {};
                    return [
                        4,
                        (0,Clients.GET)((_tmp.url = url, _tmp.ctx = ctx, _tmp))
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        2,
                        (0,Clients.getData)(result)
                    ];
            }
        });
    });
    return _loadDataMostSearch.apply(this, arguments);
}
function loadFeedback() {
    return _loadFeedback.apply(this, arguments);
}
function _loadFeedback() {
    _loadFeedback = (0,_async_to_generator/* default */.Z)(function() {
        var result, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    return [
                        4,
                        (0,Clients.GET)((_tmp.url = "/feedback", _tmp.mock = true, _tmp))
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        2,
                        (0,Clients.getData)(result)
                    ];
            }
        });
    });
    return _loadFeedback.apply(this, arguments);
}
function getInfoBanner() {
    return _getInfoBanner.apply(this, arguments);
}
function _getInfoBanner() {
    _getInfoBanner = (0,_async_to_generator/* default */.Z)(function() {
        var result, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    return [
                        4,
                        (0,Clients.GET)((_tmp.url = "/banner", _tmp.mock = true, _tmp))
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        2,
                        (0,Clients.getData)(result)
                    ];
            }
        });
    });
    return _getInfoBanner.apply(this, arguments);
}
function loadDataPormotion(ctx) {
    return _loadDataPormotion.apply(this, arguments);
}
function _loadDataPormotion() {
    _loadDataPormotion = (0,_async_to_generator/* default */.Z)(function(ctx) {
        var res, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    return [
                        4,
                        (0,Clients.GET)((_tmp.url = "/mock/product", _tmp.mock = true, _tmp.ctx = ctx, _tmp))
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        (0,Clients.getData)(res)
                    ];
            }
        });
    });
    return _loadDataPormotion.apply(this, arguments);
}
function loadDataManufacturer(ctx) {
    return _loadDataManufacturer.apply(this, arguments);
}
function _loadDataManufacturer() {
    _loadDataManufacturer = // TODO  @dat.le
    (0,_async_to_generator/* default */.Z)(function(ctx) {
        var ref, res, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    return [
                        4,
                        (0,Clients.GET_ALL)((_tmp.url = APIUriV2/* PRODUCT_API.MANUFACTURER_LIST */.PJ.MANUFACTURER_LIST, _tmp.ctx = ctx, _tmp.isBasic = true, _tmp))
                    ];
                case 1:
                    res = _state.sent();
                    if (!(0,Clients.isValid)(res)) {
                        return [
                            2,
                            []
                        ];
                    }
                    return [
                        2,
                        res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.filter(function(item) {
                            return manufacturer/* TopManufacturer.indexOf */.j.indexOf(item.code) >= 0;
                        }).sort(function(a, b) {
                            var ref, ref1;
                            return (0,ArrUtils/* sortComparer */.J5)((a === null || a === void 0 ? void 0 : (ref = a.name) === null || ref === void 0 ? void 0 : ref.toLowerCase()) || "", (b === null || b === void 0 ? void 0 : (ref1 = b.name) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()) || "");
                        })
                    ];
            }
        });
    });
    return _loadDataManufacturer.apply(this, arguments);
}
// fix limit 20 of tabs
var getTabs = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            ctx = param.ctx;
            _tmp = {};
            return [
                2,
                (0,Clients.GET)((_tmp.url = APIUriV2/* PRODUCT_API.TABS_ACTIVE */.PJ.TABS_ACTIVE, _tmp.params = {
                    limit: 20
                }, _tmp.ctx = ctx, _tmp.isBasic = true, _tmp.cache = true, _tmp.cacheServer = false, _tmp))
            ];
        });
    });
    return function getTabs(_) {
        return _ref.apply(this, arguments);
    };
}();
var getDeals = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx, params, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            ctx = param.ctx, params = param.params;
            _tmp = {};
            return [
                2,
                (0,Clients.GET)((_tmp.url = APIUriV2/* PRODUCT_API.DEALS */.PJ.DEALS, _tmp.params = params, _tmp.ctx = ctx, _tmp.isBasic = true, _tmp))
            ];
        });
    });
    return function getDeals(_) {
        return _ref.apply(this, arguments);
    };
}();
var getSettingTags = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            ctx = param.ctx;
            _tmp = {};
            return [
                2,
                (0,Clients.GET)((_tmp.url = APIUriV2/* PRODUCT_API.TAGS */.PJ.TAGS, _tmp.ctx = ctx, _tmp.isBasic = true, _tmp))
            ];
        });
    });
    return function getSettingTags(_) {
        return _ref.apply(this, arguments);
    };
}();
var getProducts = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx, codes, limit, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            ctx = param.ctx, codes = param.codes, limit = param.limit;
            _tmp = {};
            return [
                2,
                (0,Clients.POST)((_tmp.url = APIUriV2/* PRODUCT_API.PRODUCT_LIST */.PJ.PRODUCT_LIST, _tmp.body = {
                    codes: codes
                }, _tmp.params = {
                    limit: limit
                }, _tmp.ctx = ctx, _tmp))
            ];
        });
    });
    return function getProducts(_) {
        return _ref.apply(this, arguments);
    };
}();
var getDataCollections = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            ctx = param.ctx;
            _tmp = {};
            return [
                2,
                (0,Clients.GET)((_tmp.url = APIUriV2/* PRODUCT_API.PRODUCT_LIST_COLLECTION */.PJ.PRODUCT_LIST_COLLECTION, _tmp.params = {
                    q: "MAIN_PAGE"
                }, _tmp.isBasic = true, _tmp.ctx = ctx, _tmp))
            ];
        });
    });
    return function getDataCollections(_) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var ProductClient = ({
    loadDataMostSearch: loadDataMostSearch,
    loadFeedback: loadFeedback,
    getInfoBanner: getInfoBanner,
    loadDataPormotion: loadDataPormotion,
    loadDataManufacturer: loadDataManufacturer,
    getTabs: getTabs,
    getSettingTags: getSettingTags,
    getDeals: getDeals,
    getProducts: getProducts,
    getDataCollections: getDataCollections
});

// EXTERNAL MODULE: ./src/clients/ProductClientV2.js
var ProductClientV2 = __webpack_require__(22997);
// EXTERNAL MODULE: ./src/clients/PromoClient.js
var PromoClient = __webpack_require__(46128);
;// CONCATENATED MODULE: ./src/clients/PromotionClient.js




function getPromoLists(_) {
    return _getPromoLists.apply(this, arguments);
}
function _getPromoLists() {
    _getPromoLists = (0,_async_to_generator/* default */.Z)(function(param) {
        var skus, _getVoucherInfo, getVoucherInfo, signal, url, body, _tmp, _tmp1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            skus = param.skus, _getVoucherInfo = param.getVoucherInfo, getVoucherInfo = _getVoucherInfo === void 0 ? false : _getVoucherInfo, signal = param.signal;
            url = APIUriV2/* PROMOTION_API.PROMOLISTS_DETAIL_PRODUCT */.rv.PROMOLISTS_DETAIL_PRODUCT;
            _tmp = {};
            body = (_tmp.skus = skus, _tmp.getVoucherInfo = getVoucherInfo, _tmp);
            _tmp1 = {};
            return [
                2,
                (0,Clients.POST)((_tmp1.url = url, _tmp1.body = body, _tmp1.signal = signal, _tmp1))
            ];
        });
    });
    return _getPromoLists.apply(this, arguments);
}
/* harmony default export */ var PromotionClient = ({
    getPromoLists: getPromoLists
});

// EXTERNAL MODULE: ./src/constants/data/index.js
var data = __webpack_require__(66520);
;// CONCATENATED MODULE: ./src/clients/SearchClient.js





function searchKeywords(keyword) {
    return _searchKeywords.apply(this, arguments);
}
function _searchKeywords() {
    _searchKeywords = (0,_async_to_generator/* default */.Z)(function(keyword) {
        var body, _tmp, res, _tmp1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    body = (_tmp.text = keyword, _tmp.offset = 0, _tmp.limit = data/* PAGE_SIZE_30 */.AV, _tmp);
                    _tmp1 = {};
                    return [
                        4,
                        ProductClientV2/* default.getFuzzySearchClient */.ZP.getFuzzySearchClient((_tmp1.body = body, _tmp1))
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        (0,Clients.getData)(res)
                    ];
            }
        });
    });
    return _searchKeywords.apply(this, arguments);
}
function searchByKeywords(keyword) {
    return _searchByKeywords.apply(this, arguments);
}
function _searchByKeywords() {
    _searchByKeywords = (0,_async_to_generator/* default */.Z)(function(keyword) {
        var hasIngredients, searchStrategy, _tmp, body, _tmp1, _tmp2;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            hasIngredients = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : true;
            _tmp = {};
            searchStrategy = (_tmp.text = true, _tmp.keyword = true, _tmp.ingredient = hasIngredients, _tmp);
            _tmp1 = {};
            body = (_tmp1.text = keyword, _tmp1.offset = 0, _tmp1.limit = data/* PAGE_SIZE_30 */.AV, _tmp1.searchStrategy = searchStrategy, _tmp1);
            _tmp2 = {};
            // const res = await POST({ url, body });
            return [
                2,
                ProductClientV2/* default.getFuzzySearchClient */.ZP.getFuzzySearchClient((_tmp2.body = body, _tmp2))
            ];
        });
    });
    return _searchByKeywords.apply(this, arguments);
}
/* harmony default export */ var SearchClient = ({
    searchKeywords: searchKeywords,
    searchByKeywords: searchByKeywords
});

// EXTERNAL MODULE: ./src/clients/SellerClient.js
var SellerClient = __webpack_require__(15537);
;// CONCATENATED MODULE: ./src/clients/SettingClient.js




var getSettingList = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            ctx = param.ctx;
            _tmp = {};
            return [
                2,
                (0,Clients.GET)((_tmp.url = APIUri/* SETTING_API.SETTING_LIST */.H.SETTING_LIST, _tmp.ctx = ctx, _tmp.isBasic = true, _tmp))
            ];
        });
    });
    return function getSettingList(_) {
        return _ref.apply(this, arguments);
    };
}();
var getAppInfo = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(ctx, type) {
        var _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            _tmp = {};
            return [
                2,
                (0,Clients.GET)((_tmp.url = APIUri/* SETTING_API.SETTING_APP */.H.SETTING_APP, _tmp.ctx = ctx, _tmp.params = {
                    type: type
                }, _tmp.isBasic = true, _tmp.isAuth = false, _tmp))
            ];
        });
    });
    return function getAppInfo(ctx, type) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var SettingClient = ({
    getSettingList: getSettingList,
    getAppInfo: getAppInfo
});

;// CONCATENATED MODULE: ./src/clients/SupplierClient.js




function getInfoSupplier(_) {
    return _getInfoSupplier.apply(this, arguments);
}
function _getInfoSupplier() {
    _getInfoSupplier = (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx, params, url, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            ctx = param.ctx, params = param.params;
            url = APIUriV2/* SUPPLIER_API.SUPPLIER_INFO */.yV.SUPPLIER_INFO;
            _tmp = {};
            return [
                2,
                (0,Clients.GET)((_tmp.url = url, _tmp.isBasic = true, _tmp.ctx = ctx, _tmp.params = params, _tmp))
            ];
        });
    });
    return _getInfoSupplier.apply(this, arguments);
}
function getAll(_) {
    return _getAll.apply(this, arguments);
}
function _getAll() {
    _getAll = // for api/seller/index.js
    // nhằm hạn chế data trả ra ngoài nên sẽ làm api/seller để lấy hết data , rồi trả ra 1 api dạng internal
    (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx, url, params, _tmp, _tmp1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            ctx = param.ctx;
            url = APIUriV2/* SUPPLIER_API.SUPPLIERS */.yV.SUPPLIERS;
            _tmp = {};
            params = (_tmp.getStoreInfo = true, _tmp);
            _tmp1 = {};
            return [
                2,
                (0,Clients.GET_ALL)((_tmp1.url = url, _tmp1.isBasic = true, _tmp1.ctx = ctx, _tmp1.isAuth = false, _tmp1.params = params, _tmp1))
            ];
        });
    });
    return _getAll.apply(this, arguments);
}
function getSellersMock() {
    return _getSellersMock.apply(this, arguments);
}
function _getSellersMock() {
    _getSellersMock = // for web
    (0,_async_to_generator/* default */.Z)(function() {
        var url, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            url = "/seller";
            _tmp = {};
            return [
                2,
                (0,Clients.GET)((_tmp.url = url, _tmp.mock = true, _tmp.isAuth = false, _tmp))
            ];
        });
    });
    return _getSellersMock.apply(this, arguments);
}
function getSellerConfig(_) {
    return _getSellerConfig.apply(this, arguments);
}
function _getSellerConfig() {
    _getSellerConfig = (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx, sellerCodes, url, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            ctx = param.ctx, sellerCodes = param.sellerCodes;
            url = APIUriV2/* SUPPLIER_API.SUPPLIER_CONFIG */.yV.SUPPLIER_CONFIG;
            _tmp = {};
            return [
                2,
                (0,Clients.GET)((_tmp.url = url, _tmp.ctx = ctx, _tmp.params = {
                    sellerCodes: sellerCodes
                }, _tmp))
            ];
        });
    });
    return _getSellerConfig.apply(this, arguments);
}
/* harmony default export */ var SupplierClient = ({
    getInfoSupplier: getInfoSupplier,
    getAll: getAll,
    // api web
    getSellersMock: getSellersMock,
    getSellerConfig: getSellerConfig
});

// EXTERNAL MODULE: ./src/utils/index.js + 5 modules
var utils = __webpack_require__(76480);
;// CONCATENATED MODULE: ./src/clients/TicketClient.js





var createFeedback = function(body) {
    var url = APIUriV2/* TICKET_API.TICKET */.A1.TICKET;
    return (0,Clients.POST)({
        url: url,
        body: body
    });
};
var createFeedbackDetailProduct = function(body) {
    var url = APIUriV2/* TICKET_API.TICKET_CREATESUPPORT */.A1.TICKET_CREATESUPPORT;
    return (0,Clients.POST)({
        url: url,
        body: body
    });
};
var createFeedbackWithoutLogin = function(body) {
    var url = APIUriV2/* TICKET_API.FEEDBACK_WITHOUT_LOGIN */.A1.FEEDBACK_WITHOUT_LOGIN;
    return (0,Clients.POST)({
        url: url,
        body: body,
        isBasic: true,
        isAuth: false
    });
};
var getListReasons = function(ctx) {
    var url = APIUriV2/* TICKET_API.TICKET_REASONS */.A1.TICKET_REASONS;
    return (0,Clients.GET)({
        url: url,
        ctx: ctx,
        params: {
            status: "ACTIVE"
        }
    });
};
var getListReasonsWithoutLogin = function(ctx) {
    var url = APIUriV2/* TICKET_API.TICKET_REASONS */.A1.TICKET_REASONS;
    return (0,Clients.GET_ALL)({
        url: url,
        ctx: ctx,
        isBasic: true,
        isAuth: false
    });
};
var getListReasonsWithoutLoginMock = function() {
    return (0,Clients.GET)({
        url: "/web/ticket/reasons",
        mock: true
    });
};
var getListTicket = function(param) {
    var ctx = param.ctx, offset = param.offset, limit = param.limit, getTotal = param.getTotal, createdFrom = param.createdFrom, createdTo = param.createdTo;
    var url = APIUriV2/* TICKET_API.TICKET_LIST */.A1.TICKET_LIST;
    var params = {
        offset: offset,
        limit: limit,
        getTotal: getTotal
    };
    var q = {};
    if (createdFrom) {
        q.createdFrom = utils/* DateTimeUtils.getDateStart */.IM.getDateStart(new Date(createdFrom)).toISOString();
    }
    if (createdTo) {
        q.createdTo = utils/* DateTimeUtils.getDateEnd */.IM.getDateEnd(new Date(createdTo)).toISOString();
    }
    params.q = JSON.stringify(q);
    return (0,Clients.GET)({
        url: url,
        ctx: ctx,
        params: params
    });
};
var getDetailTicket = function(param) {
    var ctx = param.ctx, ticketId = param.ticketId;
    var url = APIUriV2/* TICKET_API.TICKET_DETAIL */.A1.TICKET_DETAIL;
    var params = {
        ticketId: ticketId
    };
    return (0,Clients.GET)({
        ctx: ctx,
        url: url,
        params: params
    });
};
var sendFeedback = function(body) {
    return (0,Clients.POST)({
        url: APIUriV2/* TICKET_API.FEEDBACK */.A1.FEEDBACK,
        body: body
    });
};
var acceptFeedback = function(body) {
    return (0,Clients.PUT)({
        url: APIUriV2/* TICKET_API.ACCEPT */.A1.ACCEPT,
        body: body
    });
};
var uploadFile = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx, body, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            ctx = param.ctx, body = param.body;
            _tmp = {};
            return [
                2,
                (0,Clients.POST)((_tmp.url = APIUriV2/* TICKET_API.UPLOAD_FILE */.A1.UPLOAD_FILE, _tmp.ctx = ctx, _tmp.body = body, _tmp))
            ];
        });
    });
    return function uploadFile(_) {
        return _ref.apply(this, arguments);
    };
}();
var uploadFileWithoutLogin = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx, body, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            ctx = param.ctx, body = param.body;
            _tmp = {};
            return [
                2,
                (0,Clients.POST)((_tmp.url = APIUriV2/* TICKET_API.UPLOAD_FILE */.A1.UPLOAD_FILE, _tmp.ctx = ctx, _tmp.body = body, _tmp.isBasic = true, _tmp.isAuth = false, _tmp))
            ];
        });
    });
    return function uploadFileWithoutLogin(_) {
        return _ref.apply(this, arguments);
    };
}();
var getTicketReturn = function(orderId) {
    return (0,Clients.GET)({
        url: APIUriV2/* TICKET_API.RETURN_ORDER */.A1.RETURN_ORDER,
        params: {
            q: JSON.stringify({
                orderId: orderId
            })
        }
    });
};
var getVerifyTickerReturn = function(orderId) {
    return (0,Clients.GET)({
        url: APIUriV2/* TICKET_API.VERIFY_RETURN_ORDER */.A1.VERIFY_RETURN_ORDER,
        params: {
            orderId: orderId
        }
    });
};
/* harmony default export */ var TicketClient = ({
    createFeedback: createFeedback,
    sendFeedback: sendFeedback,
    createFeedbackWithoutLogin: createFeedbackWithoutLogin,
    getListReasonsWithoutLoginMock: getListReasonsWithoutLoginMock,
    uploadFileWithoutLogin: uploadFileWithoutLogin,
    getListReasons: getListReasons,
    getListTicket: getListTicket,
    getListReasonsWithoutLogin: getListReasonsWithoutLogin,
    uploadFile: uploadFile,
    createFeedbackDetailProduct: createFeedbackDetailProduct,
    getDetailTicket: getDetailTicket,
    acceptFeedback: acceptFeedback,
    getTicketReturn: getTicketReturn,
    getVerifyTickerReturn: getVerifyTickerReturn
});

;// CONCATENATED MODULE: ./src/clients/TrackingActionClient.js
/* eslint-disable no-unused-vars */ 

function tracking(_) {
    return _tracking.apply(this, arguments);
}
function _tracking() {
    _tracking = (0,_async_to_generator/* default */.Z)(function(param) {
        var _page, page, accountId, customerID, eventAction, _currentPage, currentPage, isMobile, url, body, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            _page = param.page, page = _page === void 0 ? "/" : _page, accountId = param.accountId, customerID = param.customerID, eventAction = param.eventAction, _currentPage = param.currentPage, currentPage = _currentPage === void 0 ? "/" : _currentPage, isMobile = param.isMobile;
            url = "/marketplace/promotion/v1/tracking";
            _tmp = {};
            body = (_tmp.page = page, _tmp.screen = "", _tmp.source = isMobile ? "thuocsi-mobile" : "thuocsi-web", _tmp.accountId = accountId, _tmp.customerID = customerID, _tmp.eventAction = eventAction, _tmp.currentPage = currentPage, _tmp);
            return [
                2
            ];
        });
    // return POST({ url, body });
    });
    return _tracking.apply(this, arguments);
}
/* harmony default export */ var TrackingActionClient = ({
    tracking: tracking
});

;// CONCATENATED MODULE: ./src/clients/UploadImageClient.js



function uploadImage(body) {
    return _uploadImage.apply(this, arguments);
}
function _uploadImage() {
    _uploadImage = (0,_async_to_generator/* default */.Z)(function(body) {
        var _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            _tmp = {};
            return [
                2,
                (0,Clients.POST)((_tmp.url = "/marketplace/product/v1/upload", _tmp.body = body, _tmp))
            ];
        });
    });
    return _uploadImage.apply(this, arguments);
}
/* harmony default export */ var UploadImageClient = ({
    uploadImage: uploadImage
});

;// CONCATENATED MODULE: ./src/clients/WebServiceClient.js






var loadProductDetail = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx, params, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            ctx = param.ctx, params = param.params;
            _tmp = {};
            return [
                2,
                (0,Clients.GET)((_tmp.url = APIUriV2/* FRONTEND_APIS.PRODUCT_DETAIL */.eI.PRODUCT_DETAIL, _tmp.ctx = ctx, _tmp.isBasic = true, _tmp.params = params, _tmp))
            ];
        });
    });
    return function loadProductDetail(_) {
        return _ref.apply(this, arguments);
    };
}();
var loadProductsFuzzySearch = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(_param) {
        var body, ctx, restProps, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            body = _param.body, ctx = _param.ctx, restProps = (0,_object_without_properties/* default */.Z)(_param, [
                "body",
                "ctx"
            ]);
            _tmp = {};
            return [
                2,
                (0,Clients.POST)((0,_object_spread/* default */.Z)((_tmp.ctx = ctx, _tmp.url = APIUriV2/* FRONTEND_APIS.FUZZY_SEARCH */.eI.FUZZY_SEARCH, _tmp.body = body, _tmp), restProps))
            ];
        });
    });
    return function loadProductsFuzzySearch(_param) {
        return _ref.apply(this, arguments);
    };
}();
var loadCart = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx, params, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            ctx = param.ctx, params = param.params;
            _tmp = {};
            return [
                2,
                (0,Clients.GET)((_tmp.ctx = ctx, _tmp.url = APIUriV2/* FRONTEND_APIS.CART */.eI.CART, _tmp.params = params, _tmp))
            ];
        });
    });
    return function loadCart(_) {
        return _ref.apply(this, arguments);
    };
}();
var searchFuzzyLite = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx, params, body, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            ctx = param.ctx, params = param.params, body = param.body;
            _tmp = {};
            return [
                2,
                (0,Clients.POST)((_tmp.ctx = ctx, _tmp.url = APIUriV2/* FRONTEND_APIS.FUZZY_SEARCH_LITE */.eI.FUZZY_SEARCH_LITE, _tmp.params = params, _tmp.body = body, _tmp))
            ];
        });
    });
    return function searchFuzzyLite(_) {
        return _ref.apply(this, arguments);
    };
}();
var getHomeCategories = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(_param) {
        var ctx, restProps, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            ctx = _param.ctx, restProps = (0,_object_without_properties/* default */.Z)(_param, [
                "ctx"
            ]);
            _tmp = {};
            return [
                2,
                (0,Clients.GET)((0,_object_spread/* default */.Z)((_tmp.ctx = ctx, _tmp.url = APIUriV2/* FRONTEND_APIS.HOME_CATEGORIES */.eI.HOME_CATEGORIES, _tmp), restProps))
            ];
        });
    });
    return function getHomeCategories(_param) {
        return _ref.apply(this, arguments);
    };
}();
var loadRecentProducts = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(_param) {
        var body, ctx, restProps, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            body = _param.body, ctx = _param.ctx, restProps = (0,_object_without_properties/* default */.Z)(_param, [
                "body",
                "ctx"
            ]);
            _tmp = {};
            return [
                2,
                (0,Clients.POST)((0,_object_spread/* default */.Z)((_tmp.ctx = ctx, _tmp.url = APIUriV2/* FRONTEND_APIS.RECENT_PRODUCTS */.eI.RECENT_PRODUCTS, _tmp.body = body, _tmp), restProps))
            ];
        });
    });
    return function loadRecentProducts(_param) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var WebServiceClient = ({
    loadProductDetail: loadProductDetail,
    loadProductsFuzzySearch: loadProductsFuzzySearch,
    loadCart: loadCart,
    searchFuzzyLite: searchFuzzyLite,
    getHomeCategories: getHomeCategories,
    loadRecentProducts: loadRecentProducts
});

;// CONCATENATED MODULE: ./src/clients/WishlistClient.js




var getWishlistBySkus = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx, _skus, skus, body, _tmp, _tmp1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            ctx = param.ctx, _skus = param.skus, skus = _skus === void 0 ? null : _skus;
            _tmp = {};
            body = (_tmp.skus = skus, _tmp);
            _tmp1 = {};
            return [
                2,
                (0,Clients.POST)((_tmp1.url = APIUriV2/* PRODUCT_API.WISHLIST_LIST */.PJ.WISHLIST_LIST, _tmp1.body = body, _tmp1.ctx = ctx, _tmp1))
            ];
        });
    });
    return function getWishlistBySkus(_) {
        return _ref.apply(this, arguments);
    };
}();
var getWishlist = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx, _sku, sku, customerID, offset, limit, params, _tmp, _tmp1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            ctx = param.ctx, _sku = param.sku, sku = _sku === void 0 ? null : _sku, customerID = param.customerID, offset = param.offset, limit = param.limit;
            _tmp = {};
            params = (_tmp.q = JSON.stringify({
                sku: sku,
                customerID: customerID
            }), _tmp.getTotal = true, _tmp.offset = offset, _tmp.limit = limit, _tmp);
            _tmp1 = {};
            return [
                2,
                (0,Clients.GET)((_tmp1.url = APIUriV2/* PRODUCT_API.WISHLIST */.PJ.WISHLIST, _tmp1.params = params, _tmp1.ctx = ctx, _tmp1))
            ];
        });
    });
    return function getWishlist(_) {
        return _ref.apply(this, arguments);
    };
}();
var getAllWishlist = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var customerID, params, _tmp, _tmp1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            customerID = param.customerID;
            _tmp = {};
            params = (_tmp.q = JSON.stringify({
                customerID: customerID
            }), _tmp);
            _tmp1 = {};
            return [
                2,
                (0,Clients.GET_ALL)((_tmp1.url = APIUriV2/* PRODUCT_API.WISHLIST_LIST */.PJ.WISHLIST_LIST, _tmp1.params = params, _tmp1))
            ];
        });
    });
    return function getAllWishlist(_) {
        return _ref.apply(this, arguments);
    };
}();
var updateWishlist = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(sku) {
        var _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            _tmp = {};
            return [
                2,
                (0,Clients.POST)((_tmp.url = APIUriV2/* PRODUCT_API.WISHLIST */.PJ.WISHLIST, _tmp.body = {
                    sku: sku
                }, _tmp))
            ];
        });
    });
    return function updateWishlist(sku) {
        return _ref.apply(this, arguments);
    };
}();
var deleteItemWishlist = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(sku) {
        var _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            _tmp = {};
            return [
                2,
                (0,Clients.PUT)((_tmp.url = APIUriV2/* PRODUCT_API.WISHLIST */.PJ.WISHLIST, _tmp.body = {
                    sku: sku
                }, _tmp))
            ];
        });
    });
    return function deleteItemWishlist(sku) {
        return _ref.apply(this, arguments);
    };
}();
var getListSkuByProductId = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx, productIds, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            ctx = param.ctx, productIds = param.productIds;
            _tmp = {};
            return [
                2,
                (0,Clients.GET)((_tmp.url = APIUriV2/* PRODUCT_API.SKUS_BY_ID */.PJ.SKUS_BY_ID, _tmp.params = {
                    productIds: productIds
                }, _tmp.ctx = ctx, _tmp))
            ];
        });
    });
    return function getListSkuByProductId(_) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var WishlistClient = ({
    getWishlistBySkus: getWishlistBySkus,
    updateWishlist: updateWishlist,
    deleteItemWishlist: deleteItemWishlist,
    getListSkuByProductId: getListSkuByProductId,
    getWishlist: getWishlist,
    getAllWishlist: getAllWishlist
});

;// CONCATENATED MODULE: ./src/clients/ConfigManagerClient.js



function getAppList(_) {
    return _getAppList.apply(this, arguments);
}
function _getAppList() {
    _getAppList = (0,_async_to_generator/* default */.Z)(function(param) {
        var name, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            name = param.name;
            _tmp = {};
            return [
                2,
                (0,Clients.GET)((_tmp.url = "/core/config-manager/v1/app/list?q=".concat(JSON.stringify({
                    name: name
                })), _tmp.isBasic = true, _tmp))
            ];
        });
    });
    return _getAppList.apply(this, arguments);
}
function getAppValueByCode(_) {
    return _getAppValueByCode.apply(this, arguments);
}
function _getAppValueByCode() {
    _getAppValueByCode = (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx, appCode, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            ctx = param.ctx, appCode = param.appCode;
            _tmp = {};
            return [
                2,
                (0,Clients.GET)((_tmp.url = "/core/config-manager/v1/app-value/single?appCode=".concat(appCode), _tmp.isBasic = true, _tmp.// Endpoint config-manager chỉ chấp nhận Basic auth. isAuth: false để KHÔNG gắn
                // Bearer token của user (gây 403 khi gọi ở client lúc đã đăng nhập) -> luôn dùng BASIC_AUTHEN.
                isAuth = false, _tmp.ctx = ctx, _tmp))
            ];
        });
    });
    return _getAppValueByCode.apply(this, arguments);
}
/* harmony default export */ var ConfigManagerClient = ({
    getAppList: getAppList,
    getAppValueByCode: getAppValueByCode
});

;// CONCATENATED MODULE: ./src/clients/index.js





// deprecated 22Feb2023 - Dinh Tran
// export { default as CheckoutClient } from './CheckoutClient';
























/***/ }),

/***/ 30274:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86010);
/* harmony import */ var constants_Enums__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71569);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59621);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_2__);




function LoadingBM(param) {
    var _animateText = param.animateText, animateText = _animateText === void 0 ? false : _animateText;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_2___default().wrapLoad),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_2___default()["loading-3"]),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {})
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(animateText && (_styles_module_css__WEBPACK_IMPORTED_MODULE_2___default().animateTS)),
                children: constants_Enums__WEBPACK_IMPORTED_MODULE_1__/* .BRAND_NAME */ .RS
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (LoadingBM);


/***/ }),

/***/ 41125:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Qu": function() { return /* binding */ VoucherDetailPopupProvider; },
/* harmony export */   "Se": function() { return /* binding */ useVoucherDetailPopupActions; },
/* harmony export */   "UR": function() { return /* binding */ useVoucherDetailPopup; },
/* harmony export */   "uC": function() { return /* binding */ preloadVoucherDetail; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core_Backdrop__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(32692);
/* harmony import */ var _material_ui_core_Portal__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(76234);
/* harmony import */ var components_v2_atoms_LoadingBM__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30274);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5233);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67294);
/* harmony import */ var utils_NotifyUtils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(25872);











// actions ổn định (không đổi khi đóng/mở) tách khỏi isOpen: card chỉ cần mở popup thì không
// re-render mỗi lần popup đóng/mở
var VoucherDetailPopupActionsContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_5__.createContext)(null);
var VoucherDetailPopupStateContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_5__.createContext)(false);
// nội bộ: báo provider khi tải chunk dialog lỗi
var DialogLoadErrorContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_5__.createContext)(null);
var NOOP_ACTIONS = {
    openVoucherDetail: function() {},
    closeVoucherDetail: function() {}
};
// trên Modal / Dialog của MUI (1300): phủ cả modal giỏ đang mở
var DIALOG_LOADING_Z_INDEX = 1301;
// Đang tải chunk dialog: phủ màn hình + spinner để trang phía sau (vd nút thanh toán khi sheet giỏ mobile
// đã ẩn) không bấm được (R-CART S-1). Chỉ hiện khi popup đang mở (đổi trang / đóng giữa chừng thì thôi);
// bấm lớp phủ = huỷ mở popup.
var DialogLoadingOverlay = function() {
    var isOpen = (0,react__WEBPACK_IMPORTED_MODULE_5__.useContext)(VoucherDetailPopupStateContext);
    var closeVoucherDetail = ((0,react__WEBPACK_IMPORTED_MODULE_5__.useContext)(VoucherDetailPopupActionsContext) || NOOP_ACTIONS).closeVoucherDetail;
    if (!isOpen) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Portal__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Backdrop__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
            open: true,
            style: {
                zIndex: DIALOG_LOADING_Z_INDEX
            },
            onClick: closeVoucherDetail,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_v2_atoms_LoadingBM__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {})
        })
    });
};
// Tải chunk lỗi (mất mạng, hash chunk cũ sau deploy): provider đóng popup (isOpen về false, gọi onClose)
// và giữ `retry` cho lần mở sau; toast lỗi nếu lúc đó popup đang mở.
var DialogLoadError = function(param) {
    var retry = param.retry;
    var onLoadError = (0,react__WEBPACK_IMPORTED_MODULE_5__.useContext)(DialogLoadErrorContext);
    var ref = (0,next_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)("voucherDetail"), t = ref.t, ready = ref.ready;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(false), shouldNotify = ref1[0], setShouldNotify = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(function() {
        setShouldNotify(!!(onLoadError === null || onLoadError === void 0 ? void 0 : onLoadError(retry)));
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(function() {
        if (!shouldNotify || !ready) return;
        setShouldNotify(false);
        utils_NotifyUtils__WEBPACK_IMPORTED_MODULE_6__/* ["default"].error */ .Z.error(t("voucherDetail:toast.error"));
    }, [
        shouldNotify,
        ready
    ]);
    return null;
};
var DialogLoading = function(param) {
    var error = param.error, retry = param.retry;
    return error ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DialogLoadError, {
        retry: retry
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DialogLoadingOverlay, {});
};
// Provider được mount ở _app: dialog kéo theo ProductCardNew, ProductServiceV2... nên tách chunk,
// chỉ tải khi mở popup lần đầu (hoặc khi preloadVoucherDetail)
var VoucherDetailDialog = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7112), __webpack_require__.e(868), __webpack_require__.e(9893), __webpack_require__.e(756), __webpack_require__.e(3949), __webpack_require__.e(2221), __webpack_require__.e(2490), __webpack_require__.e(3004), __webpack_require__.e(745), __webpack_require__.e(3316), __webpack_require__.e(5632), __webpack_require__.e(9647), __webpack_require__.e(1325)]).then(__webpack_require__.bind(__webpack_require__, 26167));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(26167)
            ];
        }
    },
    ssr: false,
    loading: DialogLoading
});
// Tải trước chunk dialog (vd lúc mở modal voucher giỏ) để lần bấm "Điều kiện" đầu tiên mở ngay.
// Không bao giờ reject. Dùng import() riêng (webpack dùng chung chunk) chứ không preload của
// next/dynamic: preload lỗi sẽ kẹt trạng thái lỗi của dynamic tới lần retry.
var preloadVoucherDetail = function() {
    return Promise.all(/* import() */[__webpack_require__.e(7112), __webpack_require__.e(868), __webpack_require__.e(9893), __webpack_require__.e(756), __webpack_require__.e(3949), __webpack_require__.e(2221), __webpack_require__.e(2490), __webpack_require__.e(3004), __webpack_require__.e(745), __webpack_require__.e(3316), __webpack_require__.e(5632), __webpack_require__.e(9647), __webpack_require__.e(1325)]).then(__webpack_require__.bind(__webpack_require__, 26167)).then(function() {
        return undefined;
    }, function() {
        return undefined;
    });
};
var runCallbacks = function(callbacks) {
    return callbacks.forEach(function(callback) {
        try {
            callback();
        } catch (error) {
            console.error(error);
        }
    });
};
var VoucherDetailPopupRoot = function(param) {
    var children = param.children, isMobile = param.isMobile;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)({
        open: false,
        code: "",
        initialVoucher: null
    }), popup = ref[0], setPopup = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(false), hasOpened = ref1[0], setHasOpened = ref1[1];
    var isOpenRef = (0,react__WEBPACK_IMPORTED_MODULE_5__.useRef)(false);
    // giống handleOpen(code, cb, onCloseCb) của VN: gom các onClose, gọi hết khi popup đóng
    var onCloseCallbacksRef = (0,react__WEBPACK_IMPORTED_MODULE_5__.useRef)([]);
    // retry của next/dynamic sau khi tải chunk lỗi; gọi ở lần mở kế tiếp
    var retryLoadRef = (0,react__WEBPACK_IMPORTED_MODULE_5__.useRef)(null);
    // initialVoucher (không bắt buộc): dữ liệu card đang có, hiển thị ngay trong lúc gọi API chi tiết
    // options.onClose (không bắt buộc): gọi khi popup đóng (bấm đóng, đổi trang...), vd refetch list
    var openVoucherDetail = (0,react__WEBPACK_IMPORTED_MODULE_5__.useCallback)(function(code) {
        var initialVoucher = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        if (!code) return;
        var onClose = options === null || options === void 0 ? void 0 : options.onClose;
        if (typeof onClose === "function") onCloseCallbacksRef.current.push(onClose);
        isOpenRef.current = true;
        setHasOpened(true);
        setPopup({
            open: true,
            code: code,
            initialVoucher: initialVoucher || null
        });
        var retryLoad = retryLoadRef.current;
        if (retryLoad) {
            retryLoadRef.current = null;
            retryLoad();
        }
    }, []);
    var closeVoucherDetail = (0,react__WEBPACK_IMPORTED_MODULE_5__.useCallback)(function() {
        if (!isOpenRef.current) return;
        isOpenRef.current = false;
        setPopup(function(prev) {
            return prev.open ? (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, prev), {
                open: false
            }) : prev;
        });
        var callbacks = onCloseCallbacksRef.current;
        onCloseCallbacksRef.current = [];
        runCallbacks(callbacks);
    }, []);
    // → true nếu popup đang mở lúc lỗi (để toast)
    var handleDialogLoadError = (0,react__WEBPACK_IMPORTED_MODULE_5__.useCallback)(function(retry) {
        retryLoadRef.current = typeof retry === "function" ? retry : null;
        var wasOpen = isOpenRef.current;
        closeVoucherDetail();
        return wasOpen;
    }, [
        closeVoucherDetail
    ]);
    // giống VN: đổi trang (vd bấm vào sản phẩm trong popup) thì đóng popup
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(function() {
        router.events.on("routeChangeStart", closeVoucherDetail);
        return function() {
            return router.events.off("routeChangeStart", closeVoucherDetail);
        };
    }, [
        router.events,
        closeVoucherDetail
    ]);
    var actions = (0,react__WEBPACK_IMPORTED_MODULE_5__.useMemo)(function() {
        return {
            openVoucherDetail: openVoucherDetail,
            closeVoucherDetail: closeVoucherDetail
        };
    }, [
        openVoucherDetail,
        closeVoucherDetail
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(VoucherDetailPopupActionsContext.Provider, {
        value: actions,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(VoucherDetailPopupStateContext.Provider, {
            value: popup.open,
            children: [
                children,
                hasOpened ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DialogLoadErrorContext.Provider, {
                    value: handleDialogLoadError,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(VoucherDetailDialog, {
                        open: popup.open,
                        code: popup.code,
                        initialVoucher: popup.initialVoucher,
                        isMobile: isMobile,
                        onClose: closeVoucherDetail
                    })
                }) : null
            ]
        })
    });
};
// Lồng nhau được: đã có provider cha (vd ở _app) thì chỉ render children và dùng popup của cha.
var VoucherDetailPopupProvider = function(param) {
    var children = param.children, _isMobile = param.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile;
    var parentActions = (0,react__WEBPACK_IMPORTED_MODULE_5__.useContext)(VoucherDetailPopupActionsContext);
    if (parentActions) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: children
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(VoucherDetailPopupRoot, {
        isMobile: !!isMobile,
        children: children
    });
};
var useActions = function() {
    var actions = (0,react__WEBPACK_IMPORTED_MODULE_5__.useContext)(VoucherDetailPopupActionsContext);
    if (!actions) {
        console.error("useVoucherDetailPopup must be used within VoucherDetailPopupProvider");
        return NOOP_ACTIONS;
    }
    return actions;
};
// Chỉ mở/đóng popup, không theo dõi isOpen (không re-render khi popup đóng/mở).
var useVoucherDetailPopupActions = function() {
    return useActions();
};
// { openVoucherDetail(code, initialVoucher?, { onClose? }), closeVoucherDetail(), isOpen }
var useVoucherDetailPopup = function() {
    var actions = useActions();
    var isOpen = (0,react__WEBPACK_IMPORTED_MODULE_5__.useContext)(VoucherDetailPopupStateContext);
    return (0,react__WEBPACK_IMPORTED_MODULE_5__.useMemo)(function() {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, actions), {
            isOpen: isOpen
        });
    }, [
        actions,
        isOpen
    ]);
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (VoucherDetailPopupProvider)));


/***/ }),

/***/ 6745:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73690);
/* harmony import */ var constants_Colors__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47387);


// Create a theme instance.
var Theme = (0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
    overrides: {
        MuiRadio: {
            colorSecondary: {
                color: "#005C29",
                "&$checked": {
                    color: "#005C29"
                }
            }
        },
        MuiInputAdornment: {
            positionStart: {
                margin: 8
            }
        },
        MuiOutlinedInput: {
            root: {
                position: "relative",
                "& $notchedOutline": {
                    borderColor: "rgba(0, 0, 0, 0.23)"
                },
                "&:hover:not($disabled):not($focused):not($error) $notchedOutline": {
                    borderColor: "#fff",
                    boxShadow: "0 0 0 0.2rem rgba(0,180,110,0.25)",
                    outline: 0,
                    // Reset on touch devices, it doesn't add specificity
                    "@media (hover: none)": {
                        borderColor: "rgba(0, 0, 0, 0.23)"
                    }
                },
                "&$focused $notchedOutline": {
                    borderColor: "#fff",
                    outline: 0,
                    boxShadow: "0 0 0 0.2rem rgba(0,180,110,0.25)",
                    borderWidth: 3
                }
            }
        },
        MuiDrawer: {
            paper: {
                width: "80%",
                overflowY: "auto"
            }
        },
        MuiFormLabel: {
            root: {
                "&$focused": {
                    borderColor: "#fff"
                }
            }
        },
        MuiFab: {
            root: {
                backgroundColor: "#fff",
                textTransform: "unset",
                boxShadow: "0 0 0 0.2rem rgba(0,180,110,0.25)",
                "&$extended": {
                    paddingLeft: 20,
                    paddingRight: 20,
                    paddingTop: 5,
                    paddingBottom: 5,
                    borderRadius: 25,
                    height: 38,
                    color: "#919aa3",
                    boxShadow: "3px 3px 6px rgba(0,0,0,0.08)",
                    "&:hover": {
                        color: "#343a40",
                        backgroundColor: "transparent"
                    }
                }
            }
        },
        MuiButton: {
            root: {
                textTransform: "capitalize"
            }
        },
        MuiPagination: {
            root: {
                padding: 10
            }
        },
        MuiPaginationItem: {
            page: {
                color: "#0E1983",
                "&$disabled": {
                    opacity: 0.18
                },
                "&$selected": {
                    color: "#005C29",
                    backgroundColor: "none",
                    border: "1px solid #005C29"
                }
            }
        }
    },
    typography: {
        fontFamily: "ggsr, sans-serif",
        subtitle2: {
            fontSize: 13
        }
    },
    modal: {
        background: "#f4f7fc"
    },
    colors: {
        primary: "#000",
        secondary: "#fff"
    },
    button: {
        color: {
            primary: "#fff",
            secondary: "#000"
        },
        background: {
            primary: "#005C29",
            success: "#005C29",
            warning: "#FFC107",
            payment: constants_Colors__WEBPACK_IMPORTED_MODULE_0__/* .palette.warning.main */ .D.warning.main,
            disabled: "#dddddd"
        }
    },
    palette: constants_Colors__WEBPACK_IMPORTED_MODULE_0__/* .palette */ .D
});
/* harmony default export */ __webpack_exports__["Z"] = (Theme);


/***/ }),

/***/ 37071:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core_CircularProgress__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(95477);
/* harmony import */ var constants_Images__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13270);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var utils_ImageFallback__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34588);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6837);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_4__);






// const domainLocal = 'https://local.thuocsi.vn';
// const domainTs = 'https://thuocsi.vn';
var LoadingScreen = function() {
    return(// const [domainRedirect, setDomainRedirect] = useState(domainLocal);
    // useEffect(() => {
    //   const curDomain = window?.location.hostname;
    //   if (curDomain === 'local.thuocsi.vn') {
    //     setDomainRedirect(domainTs);
    //   } else {
    //     setDomainRedirect(domainLocal);
    //   }
    // });
    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_4___default().root),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_4___default().wrapper),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_3__/* .ImageFallbackStatic */ .ez, {
                        src: constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .LOGO_THUOCSI_SHORTENED */ .SlS,
                        width: 45,
                        height: 45
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_CircularProgress__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        size: 80,
                        thickness: 4,
                        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_4___default().progress)
                    })
                ]
            })
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.memo(LoadingScreen));


/***/ }),

/***/ 17233:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ SETTING_API; },
/* harmony export */   "IQ": function() { return /* binding */ CONTENT_API; },
/* harmony export */   "S$": function() { return /* binding */ CORE_API; },
/* harmony export */   "SI": function() { return /* binding */ MONITOR_API; },
/* harmony export */   "V0": function() { return /* binding */ ACCOUNT_API; },
/* harmony export */   "Xe": function() { return /* binding */ CUSTOMER_API; },
/* harmony export */   "sK": function() { return /* binding */ NOTIFICATION_API; },
/* harmony export */   "ud": function() { return /* binding */ MARKETING_API; }
/* harmony export */ });
/* unused harmony exports INSIDER_API, PRODUCT_API */
/* harmony import */ var sysconfig__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66225);

var INSIDER_API_PREFIX = "".concat(sysconfig__WEBPACK_IMPORTED_MODULE_0__/* .INSIDER_API_DOMAIN */ .Ad, "/thuocsivn/vi_VN");
var MOST_VIEWED = "".concat(INSIDER_API_PREFIX, "/most/viewed/partner");
var USER_BASED = "".concat(INSIDER_API_PREFIX, "/user");
var INSIDER_API = {
    MOST_VIEWED: MOST_VIEWED,
    USER_BASED: USER_BASED
};
var ACCOUNT_API_PREFIX = "/core/account/v1";
var AUTHENTICATION = "".concat(ACCOUNT_API_PREFIX, "/authentication");
var GET_ACCOUNT_INFO = "".concat(ACCOUNT_API_PREFIX, "/me");
var PASSWORD_RECOVERY = "".concat(ACCOUNT_API_PREFIX, "/password-recovery");
var PASSWORD_NEW = "".concat(GET_ACCOUNT_INFO, "/password");
var LOGOUT = "".concat(GET_ACCOUNT_INFO, "/logout");
var ACCOUNT_API = {
    AUTHENTICATION: AUTHENTICATION,
    GET_ACCOUNT_INFO: GET_ACCOUNT_INFO,
    PASSWORD_RECOVERY: PASSWORD_RECOVERY,
    PASSWORD_NEW: PASSWORD_NEW,
    LOGOUT: LOGOUT
};
// MARKETPLACE
// deprecated 22Feb2023 - Dinh Tran
// PRICING
// const PRICING_API_PREFIX = '/marketplace/pricing/v1';
// const DELIVERY_METHOD = `${PRICING_API_PREFIX}/delivery-platform/list`;
// const DELIVERY_METHOD_DETAIL = `${PRICING_API_PREFIX}/delivery-platform`;
// const PAYMENT_METHOD_DETAIL = `${PRICING_API_PREFIX}/payment-method`;
// export const PRICING_API = {
//   PAYMENT_METHOD,
//   DELIVERY_METHOD,
//   PAYMENT_METHOD_DETAIL,
//   DELIVERY_METHOD_DETAIL,
// };
// CUSTOMER
var CUSTOMER_API_PREFIX = "/marketplace/customer/v1";
var REGISTER = "".concat(CUSTOMER_API_PREFIX, "/register");
var REGISTER_GUEST = "".concat(CUSTOMER_API_PREFIX, "/guest");
var INFO = "".concat(CUSTOMER_API_PREFIX, "/me");
var WALLET = "".concat(CUSTOMER_API_PREFIX, "/wallets");
var ORDER = "".concat(CUSTOMER_API_PREFIX, "/orders");
var REFERRAL = "".concat(CUSTOMER_API_PREFIX, "/me/reference/list");
var SEND_SMS = "".concat(CUSTOMER_API_PREFIX, "/me/reference");
var RETRY_SEND_SMS = "".concat(CUSTOMER_API_PREFIX, "/me/reference/sms");
var PROMO = "".concat(CUSTOMER_API_PREFIX, "/promos");
var BANK_ACCOUNT = "".concat(INFO, "/account/bank");
var ADDRESS_ACCOUNT = "".concat(INFO, "/account/address");
var LOYALTY_LIST = "".concat(CUSTOMER_API_PREFIX, "/loyalty/list");
var LOYALTY = "".concat(INFO, "/loyalty");
var HISTORY_LOYALTY_LIST = "".concat(INFO, "/history-loyalty/list");
var UPLOAD_FILE = "".concat(CUSTOMER_API_PREFIX, "/upload/file");
// const SIGN_IN = `${CUSTOMER_API_PREFIX}/sign-in`;
var SIGN_IN = "".concat(CUSTOMER_API_PREFIX, "/authentication");
var CUSTOMER_API = {
    REGISTER: REGISTER,
    INFO: INFO,
    WALLET: WALLET,
    ORDER: ORDER,
    REFERRAL: REFERRAL,
    PROMO: PROMO,
    SEND_SMS: SEND_SMS,
    RETRY_SEND_SMS: RETRY_SEND_SMS,
    REGISTER_GUEST: REGISTER_GUEST,
    BANK_ACCOUNT: BANK_ACCOUNT,
    ADDRESS_ACCOUNT: ADDRESS_ACCOUNT,
    LOYALTY_LIST: LOYALTY_LIST,
    HISTORY_LOYALTY_LIST: HISTORY_LOYALTY_LIST,
    LOYALTY: LOYALTY,
    UPLOAD_FILE: UPLOAD_FILE,
    SIGN_IN: SIGN_IN
};
// PRODUCTS
var CONTENT_API_PREFIX = "/marketplace/content/v1";
var STATIC_CONTENT = "".concat(CONTENT_API_PREFIX, "/static");
var CONTENT_API = {
    STATIC_CONTENT: STATIC_CONTENT
};
var PRODUCT_API_PREFIX = "/marketplace/product/v1";
var PRODUCT_API = {
    INGREDIENT: "".concat(PRODUCT_API_PREFIX, "/ingredients"),
    INGREDIENT_LIST: "".concat(PRODUCT_API_PREFIX, "/ingredients/list"),
    INGREDIENT_PRODUCT_LIST: "".concat(PRODUCT_API_PREFIX, "/ingredients/list"),
    MANUFACTURER: "".concat(PRODUCT_API_PREFIX, "/manufacturers"),
    MANUFACTURER_LIST: "".concat(PRODUCT_API_PREFIX, "/manufacturers/list"),
    MANUFACTURER_DETAIL: "".concat(PRODUCT_API_PREFIX, "/manufacturer"),
    MANUFACTURER_INFO: "".concat(PRODUCT_API_PREFIX, "/manufacturer/info"),
    PRODUCT_LIST: "".concat(PRODUCT_API_PREFIX, "/products/list"),
    PRODUCT_LIST_COLLECTION: "".concat(PRODUCT_API_PREFIX, "/collection/page"),
    TAGS: "".concat(PRODUCT_API_PREFIX, "/tags/list"),
    TABS_ACTIVE: "".concat(PRODUCT_API_PREFIX, "/tabs/active"),
    DEALS: "".concat(PRODUCT_API_PREFIX, "/products/deal/list"),
    CATEGORY_LIST: "".concat(PRODUCT_API_PREFIX, "/category/list"),
    CATEGORY_INFO: "".concat(PRODUCT_API_PREFIX, "/categories/info")
};
var CORE_MASTER_DATA_PREFIX = "/core/master-data/v1";
var PROVINCE_LIST = "".concat(CORE_MASTER_DATA_PREFIX, "/provinces/list");
var COUNTRIES_LIST = "".concat(CORE_MASTER_DATA_PREFIX, "/country/list");
var DISTRICT_LIST = "".concat(CORE_MASTER_DATA_PREFIX, "/districts");
var ADMINISTRATIVE = "".concat(CORE_MASTER_DATA_PREFIX, "/administratives/list");
var PROVINCE = "".concat(CORE_MASTER_DATA_PREFIX, "/province");
var DISTRICT = "".concat(CORE_MASTER_DATA_PREFIX, "/district");
var WARD = "".concat(CORE_MASTER_DATA_PREFIX, "/ward/list");
var BANK_LIST = "".concat(CORE_MASTER_DATA_PREFIX, "/bank/list");
var BANK_BRANCH_LIST = "".concat(CORE_MASTER_DATA_PREFIX, "/bank-branch/list");
var BANK_BY_ID = "".concat(CORE_MASTER_DATA_PREFIX, "/bank");
var BANK_BRANCH_BY_ID = "".concat(CORE_MASTER_DATA_PREFIX, "/bank-branch");
var REGIONS = "".concat(CORE_MASTER_DATA_PREFIX, "/region/list");
var CORE_API = {
    PROVINCE_LIST: PROVINCE_LIST,
    COUNTRIES_LIST: COUNTRIES_LIST,
    DISTRICT_LIST: DISTRICT_LIST,
    PROVINCE: PROVINCE,
    DISTRICT: DISTRICT,
    WARD: WARD,
    ADMINISTRATIVE: ADMINISTRATIVE,
    CORE_MASTER_DATA_PREFIX: CORE_MASTER_DATA_PREFIX,
    BANK_LIST: BANK_LIST,
    BANK_BRANCH_LIST: BANK_BRANCH_LIST,
    BANK_BY_ID: BANK_BY_ID,
    BANK_BRANCH_BY_ID: BANK_BRANCH_BY_ID,
    REGIONS: REGIONS
};
// deprecated 22Feb2023 - Dinh Tran
// const CART_API_PREFIX = '/marketplace/order/v1';
// const CART_INFO = `${CART_API_PREFIX}/cart`;
// const DELIVERY_METHOD_UPDATE = `${CART_INFO}/delivery-method`;
// const PAYMENT_METHOD_UPDATE = `${CART_INFO}/payment-method`;
// const CART_ADD = `${CART_API_PREFIX}/cart/add`;
// const CART_REMOVE = `${CART_API_PREFIX}/cart/remove`;
// const CART_UPDATE_REDEEM_CODE = `${CART_API_PREFIX}/cart/promotion`;
// export const CART_API = {
//   CART_INFO,
//   CART_ADD,
//   CART_REMOVE,
//   CART_UPDATE_REDEEM_CODE,
//   DELIVERY_METHOD_UPDATE,
//   PAYMENT_METHOD_UPDATE,
// };
// deprecated 22Feb2023 - Dinh Tran
// const ORDER_API_PREFIX = '/marketplace/order/v1';
// export const ORDER_ITEM_LIST = `${ORDER_API_PREFIX}/me/order-item`;
// export const ORDER_INFO = `${ORDER_API_PREFIX}/me/order`;
// export const MY_ORDER_LIST = `${ORDER_API_PREFIX}/me/orders`;
// export const ORDER_API = {
//   ORDER_ITEM_LIST,
//   ORDER_INFO,
//   MY_ORDER_LIST,
// };
// promotion
// /marketplace/promotion/v1/promotion
// deprecated 22Feb2023 - Dinh Tran
// const PROMOTION_API_PREFIX = '/marketplace/promotion/v1';
// const PROMOTION_ALL = `${PROMOTION_API_PREFIX}/promotion`;
// const PROMOTION_DETAI_VOUCHER_CODE = `${PROMOTION_API_PREFIX}/voucher`;
// const VOUCHER = `${PROMOTION_API_PREFIX}/me/voucher`;
// export const PROMOTION_API = {
//   PROMOTION_ALL,
//   PROMOTION_API_PREFIX,
//   PROMOTION_DETAI_VOUCHER_CODE,
//   VOUCHER,
// };
// Supplier API
// deprecated 22Feb2023 - Dinh Tran
// const SUPPLIER_API_PREFIX = '/seller/core/v1';
// const SUPPLIER_INFO = `${SUPPLIER_API_PREFIX}/seller/info`;
// export const SUPPLIER_API = {
//   SUPPLIER_INFO,
// };
var NOTIFICATION_API_PREFIX = "/integration/notification/v1";
var NOTIFICATION_LIST = "".concat(NOTIFICATION_API_PREFIX, "/notification/me");
var NOTIFICATION_COUNTER = "".concat(NOTIFICATION_API_PREFIX, "/notification/me/counter");
var NOTIFICATION_WSS = "".concat(NOTIFICATION_API_PREFIX, "/web-socket");
var NOTIFICATION = "".concat(NOTIFICATION_API_PREFIX, "/notification");
var NOTIFICATION_ALL = "".concat(NOTIFICATION_API_PREFIX, "/notification/all");
var NOTIFICATION_API = {
    NOTIFICATION_COUNTER: NOTIFICATION_COUNTER,
    NOTIFICATION_LIST: NOTIFICATION_LIST,
    NOTIFICATION_WSS: NOTIFICATION_WSS,
    NOTIFICATION_ALL: NOTIFICATION_ALL,
    NOTIFICATION: NOTIFICATION
};
var SETTING_API_PREFIX = "/marketplace/marketing/v1";
var SETTING_LIST = "".concat(SETTING_API_PREFIX, "/settings/all");
var SETTING_API = {
    SETTING_LIST: SETTING_LIST,
    SETTING_APP: "".concat(SETTING_API_PREFIX, "/app-setting/app")
};
var MARKETING_API_PREFIX = "/marketplace/marketing/v1";
var BANNER = "".concat(MARKETING_API_PREFIX, "/banners/available");
var HASHTAG_TOP_SEARCH = "".concat(MARKETING_API_PREFIX, "/hashtag-search/list");
var PRODUCT_FILE = "".concat(MARKETING_API_PREFIX, "/product-file");
var SECTION = "".concat(MARKETING_API_PREFIX, "/sections");
var POLICY = "".concat(MARKETING_API_PREFIX, "/policy/list");
var TREND_SEARCH = "".concat(MARKETING_API_PREFIX, "/trend-search");
var HOME_BANNER = "".concat(MARKETING_API_PREFIX, "/home-banner");
var REFERRAL_CONTENT = "".concat(MARKETING_API_PREFIX, "/setting");
var MARKETING_API = {
    BANNER: BANNER,
    HASHTAG_TOP_SEARCH: HASHTAG_TOP_SEARCH,
    PRODUCT_FILE: PRODUCT_FILE,
    SECTION: SECTION,
    POLICY: POLICY,
    TREND_SEARCH: TREND_SEARCH,
    HOME_BANNER: HOME_BANNER,
    REFERRAL_CONTENT: REFERRAL_CONTENT
};
// deprecated 22Feb2023 - Dinh Tran
// const TICKET_API_PREFIX = '/marketplace/ticket/v1';
// const TICKET_LIST = `${TICKET_API_PREFIX}/me/ticket/list`;
// const TICKET = `${TICKET_API_PREFIX}/me/ticket`;
// const FEEDBACK_WITHOUT_LOGIN = `${TICKET_API_PREFIX}/feedback`;
// const TICKET_REASONS = `${TICKET_API_PREFIX}/reason/list`;
// const TICKET_UPLOAD = `${TICKET_API_PREFIX}/upload`;
// const TICKET_CREATESUPPORT = `${TICKET_API_PREFIX}/me/ticket`;
// export const TICKET_API = {
//   TICKET,
//   TICKET_LIST,
//   FEEDBACK_WITHOUT_LOGIN,
//   TICKET_REASONS,
//   UPLOAD_FILE: TICKET_UPLOAD,
//   TICKET_CREATESUPPORT,
// };
// deprecated 22Feb2023 - Dinh Tran
// export const STATISTIC_PURCHASED_PRODUCT_API = '/api/statistic/purchased-product';
// Tracking event
var MONITOR_API_PREFIX = "/monitoring/collector/v1";
var COLLECTOR = "".concat(MONITOR_API_PREFIX, "/event");
var MONITOR_API = {
    COLLECTOR: COLLECTOR
};


/***/ }),

/***/ 83679:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$e": function() { return /* binding */ API_UPLOAD; },
/* harmony export */   "A1": function() { return /* binding */ TICKET_API; },
/* harmony export */   "AY": function() { return /* binding */ REWARDS_BY_SELLER; },
/* harmony export */   "Bn": function() { return /* binding */ API_UPLOAD_DOCUMENT; },
/* harmony export */   "CO": function() { return /* binding */ API_UPLOAD_FILE; },
/* harmony export */   "EL": function() { return /* binding */ ACCOUNTING_API; },
/* harmony export */   "EM": function() { return /* binding */ ORDER_API; },
/* harmony export */   "F8": function() { return /* binding */ PROMOTION_LUCKY_WHEEL; },
/* harmony export */   "JU": function() { return /* binding */ SEARCH_ORDER; },
/* harmony export */   "Jv": function() { return /* binding */ API_UPLOAD_IMAGE; },
/* harmony export */   "Jy": function() { return /* binding */ REWARD_DETAIL; },
/* harmony export */   "PJ": function() { return /* binding */ PRODUCT_API; },
/* harmony export */   "PM": function() { return /* binding */ PRICING_API; },
/* harmony export */   "Qi": function() { return /* binding */ API_UPLOAD_FEEDBACK_MOCK; },
/* harmony export */   "S$": function() { return /* binding */ CORE_API; },
/* harmony export */   "Tz": function() { return /* binding */ PAYMENT_WALLET_API; },
/* harmony export */   "Xe": function() { return /* binding */ CUSTOMER_API; },
/* harmony export */   "bp": function() { return /* binding */ API_GEN_TOKEN; },
/* harmony export */   "eI": function() { return /* binding */ FRONTEND_APIS; },
/* harmony export */   "hX": function() { return /* binding */ SMART_RECOMMENDATION_API; },
/* harmony export */   "if": function() { return /* binding */ REWARDS_API; },
/* harmony export */   "kx": function() { return /* binding */ CART_API; },
/* harmony export */   "mx": function() { return /* binding */ BUYER_SERVICE_API; },
/* harmony export */   "rv": function() { return /* binding */ PROMOTION_API; },
/* harmony export */   "ud": function() { return /* binding */ MARKETING_API; },
/* harmony export */   "un": function() { return /* binding */ FUZZY_SEARCH; },
/* harmony export */   "yV": function() { return /* binding */ SUPPLIER_API; }
/* harmony export */ });
/* unused harmony exports ORDER_ITEM_LIST, ORDER_INFO, MY_ORDER_LIST, SEARCH_ORDER_ID, REVERT, MARCOM_SERVICE */
/* harmony import */ var sysconfig__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66225);
// file containt file path
// deprecated 22Feb2023 - Dinh Tran
// const ACCOUNT_API_PREFIX = '/core/account/v1';

// const AUTHENTICATION = `${ACCOUNT_API_PREFIX}/authentication`;
// const GET_ACCOUNT_INFO = `${ACCOUNT_API_PREFIX}/me`;
// const PASSWORD_RECOVERY = `${ACCOUNT_API_PREFIX}/password-recovery`;
// export const ACCOUNT_API = {
//   AUTHENTICATION,
//   GET_ACCOUNT_INFO,
//   PASSWORD_RECOVERY,
// };
// MARKETPLACE
// PRICING
var PRICING_API_PREFIX = "/marketplace/pricing/v2";
var DELIVERY_METHOD = "".concat(PRICING_API_PREFIX, "/delivery-platform/list");
var DELIVERY_METHOD_DETAIL = "".concat(PRICING_API_PREFIX, "/delivery-platform");
var PAYMENT_METHOD = "".concat(PRICING_API_PREFIX, "/payment-method/list");
var PAYMENT_METHOD_DETAIL = "".concat(PRICING_API_PREFIX, "/payment-method");
var PRICING_API = {
    PAYMENT_METHOD: PAYMENT_METHOD,
    DELIVERY_METHOD: DELIVERY_METHOD,
    PAYMENT_METHOD_DETAIL: PAYMENT_METHOD_DETAIL,
    DELIVERY_METHOD_DETAIL: DELIVERY_METHOD_DETAIL
};
// CUSTOMER
var CUSTOMER_API_PREFIX = "/marketplace/customer/v1";
var REGISTER = "".concat(CUSTOMER_API_PREFIX, "/register");
var REGISTER_GUEST = "".concat(CUSTOMER_API_PREFIX, "/guest");
var INFO = "".concat(CUSTOMER_API_PREFIX, "/me");
var WALLET = "".concat(CUSTOMER_API_PREFIX, "/wallets");
var ORDER = "".concat(CUSTOMER_API_PREFIX, "/orders");
var REFERRAL = "".concat(CUSTOMER_API_PREFIX, "/me/reference/list");
var SEND_SMS = "".concat(CUSTOMER_API_PREFIX, "/me/reference");
var RETRY_SEND_SMS = "".concat(CUSTOMER_API_PREFIX, "/me/reference/sms");
var PROMO = "".concat(CUSTOMER_API_PREFIX, "/promos");
var BANK_ACCOUNT = "".concat(INFO, "/account/bank");
var BANK_ACCOUNT_LIST = "".concat(INFO, "/bank/list");
var BANK_ACCOUNT_INFO = "".concat(INFO, "/bank");
var INVOICE_INFO = "".concat(CUSTOMER_API_PREFIX, "/me/invoice-info");
var INVOICE_LIST = "".concat(CUSTOMER_API_PREFIX, "/me/invoice-info/list");
var ADDRESS_ACCOUNT = "".concat(INFO, "/account/address");
var LOYALTY_LIST = "".concat(CUSTOMER_API_PREFIX, "/loyalty/list");
var LOYALTY = "".concat(INFO, "/loyalty");
var HISTORY_LOYALTY_LIST = "".concat(INFO, "/history-loyalty/list");
var UPLOAD_FILE = "".concat(CUSTOMER_API_PREFIX, "/upload/file");
// const SIGN_IN = `${CUSTOMER_API_PREFIX}/sign-in`;
// /marketplace/customer/v1/authentication
var SIGN_IN = "".concat(CUSTOMER_API_PREFIX, "/authentication");
var LEVEL_LIST = "".concat(CUSTOMER_API_PREFIX, "/level/list");
var CACULATE_POINTS_CUSTOMER = "".concat(CUSTOMER_API_PREFIX, "/setting");
var API_UPLOAD_DOCUMENT = "/core/file-manager/v1/upload/document";
var API_UPLOAD_IMAGE = "/core/file-manager/v1/upload/image";
var API_GEN_TOKEN = "/core/file-manager/v1/access-token/gen";
var API_UPLOAD = "/upload";
var API_UPLOAD_FEEDBACK_MOCK = "/upload/feedback";
var API_UPLOAD_FILE = "/core/file-manager/v1/upload/document";
var UPDATE_INFO_ACCOUNT = "".concat(CUSTOMER_API_PREFIX, "/me/basic-info");
var UPDATE_INFO_ENTERPRISE = "".concat(CUSTOMER_API_PREFIX, "/me/business-info");
var BINDING_LINE = "/integration/line-crescendo/v1/binding/request";
var NOTIFICATION_PARTNER = "/marketplace/customer/v1/me/notification-partner";
var GET_POINT_EXPIRE = "".concat(CUSTOMER_API_PREFIX, "/me/point-expire");
var LEAD_SOURCE = "".concat(CUSTOMER_API_PREFIX, "/lead-source");
var CUSTOMER_API = {
    REGISTER: REGISTER,
    INFO: INFO,
    WALLET: WALLET,
    ORDER: ORDER,
    REFERRAL: REFERRAL,
    PROMO: PROMO,
    SEND_SMS: SEND_SMS,
    RETRY_SEND_SMS: RETRY_SEND_SMS,
    REGISTER_GUEST: REGISTER_GUEST,
    BANK_ACCOUNT: BANK_ACCOUNT,
    BANK_ACCOUNT_LIST: BANK_ACCOUNT_LIST,
    BANK_ACCOUNT_INFO: BANK_ACCOUNT_INFO,
    INVOICE_INFO: INVOICE_INFO,
    INVOICE_LIST: INVOICE_LIST,
    ADDRESS_ACCOUNT: ADDRESS_ACCOUNT,
    LOYALTY_LIST: LOYALTY_LIST,
    HISTORY_LOYALTY_LIST: HISTORY_LOYALTY_LIST,
    LOYALTY: LOYALTY,
    UPLOAD_FILE: UPLOAD_FILE,
    SIGN_IN: SIGN_IN,
    LEVEL_LIST: LEVEL_LIST,
    UPDATE_INFO_ACCOUNT: UPDATE_INFO_ACCOUNT,
    UPDATE_INFO_ENTERPRISE: UPDATE_INFO_ENTERPRISE,
    CACULATE_POINTS_CUSTOMER: CACULATE_POINTS_CUSTOMER,
    BINDING_LINE: BINDING_LINE,
    NOTIFICATION_PARTNER: NOTIFICATION_PARTNER,
    GET_POINT_EXPIRE: GET_POINT_EXPIRE,
    LEAD_SOURCE: LEAD_SOURCE
};
// PRODUCTS
// deprecated 22Feb2023 - Dinh Tran
// const CONTENT_API_PREFIX = '/marketplace/content/v1';
// const STATIC_CONTENT = `${CONTENT_API_PREFIX}/static`;
// export const CONTENT_API = {
//   STATIC_CONTENT,
// };
var PRODUCT_API_PREFIX = "/marketplace/product/v2";
var PRODUCT_API = {
    INGREDIENT: "".concat(PRODUCT_API_PREFIX, "/ingredient"),
    INGREDIENT_LIST: "".concat(PRODUCT_API_PREFIX, "/ingredient/list"),
    INGREDIENT_PRODUCT_LIST: "".concat(PRODUCT_API_PREFIX, "/ingredients/list"),
    MANUFACTURER: "".concat(PRODUCT_API_PREFIX, "/manufacturers"),
    MANUFACTURER_LIST: "".concat(PRODUCT_API_PREFIX, "/manufacturer/list"),
    MANUFACTURER_DETAIL: "".concat(PRODUCT_API_PREFIX, "/manufacturer"),
    MANUFACTURER_INFO: "".concat(PRODUCT_API_PREFIX, "/manufacturer"),
    PRODUCT_LIST: "".concat(PRODUCT_API_PREFIX, "/search/list"),
    PRODUCT_LIST_COLLECTION: "".concat(PRODUCT_API_PREFIX, "/collection/page"),
    TAGS: "".concat(PRODUCT_API_PREFIX, "/tag/list"),
    TABS_ACTIVE: "".concat(PRODUCT_API_PREFIX, "/tabs/active"),
    DEALS: "".concat(PRODUCT_API_PREFIX, "/products/deal/list"),
    DEALS_DETAIL: "".concat(PRODUCT_API_PREFIX, "/deal/list"),
    CATEGORY_LIST: "".concat(PRODUCT_API_PREFIX, "/category/list"),
    CATEGORY_INFO: "".concat(PRODUCT_API_PREFIX, "/category"),
    WISHLIST: "".concat(PRODUCT_API_PREFIX, "/me/wishlist"),
    WISHLIST_LIST: "".concat(PRODUCT_API_PREFIX, "/me/wishlist/list"),
    RECENT_PRODUCTS: "".concat(PRODUCT_API_PREFIX, "/me/recent-products"),
    SKUS_BY_ID: "".concat(PRODUCT_API_PREFIX, "/sku/list-by-product"),
    SELLER: "".concat(PRODUCT_API_PREFIX, "/sku/list"),
    SKU_LIMIT: "".concat(PRODUCT_API_PREFIX, "/sku-limit/list"),
    EFFICACY_LIST: "".concat(PRODUCT_API_PREFIX, "/efficacy/list"),
    EFFICACY_COMBINED_LIST: "".concat(PRODUCT_API_PREFIX, "/efficacy-combined/list"),
    SELLER_CATEGORY_LIST: "".concat(PRODUCT_API_PREFIX, "/seller-category"),
    PRODUCT_API_PREFIX: "".concat(PRODUCT_API_PREFIX, "/product/detail"),
    PRICE_RANGE_LIST: "".concat(PRODUCT_API_PREFIX, "/search/config/range-price/list"),
    SUGGEST_KEYWORD: "".concat(PRODUCT_API_PREFIX, "/suggest-keyword")
};
var CORE_MASTER_DATA_PREFIX = "/core/master-data/v1";
var PROVINCE_LIST = "".concat(CORE_MASTER_DATA_PREFIX, "/provinces/list");
var DISTRICT = "".concat(CORE_MASTER_DATA_PREFIX, "/districts");
var ADMINISTRATIVE = "".concat(CORE_MASTER_DATA_PREFIX, "/administratives/list");
var REGIONS = "".concat(CORE_MASTER_DATA_PREFIX, "/region/list");
var CORE_API = {
    PROVINCE_LIST: PROVINCE_LIST,
    DISTRICT: DISTRICT,
    ADMINISTRATIVE: ADMINISTRATIVE,
    INGREDIENT_LIST: "".concat(CORE_MASTER_DATA_PREFIX, "/ingredient/list"),
    REGIONS: REGIONS
};
var CART_API_PREFIX = "/marketplace/order/v2";
var CART_INFO = "".concat(CART_API_PREFIX, "/cart");
var CART_INFO_V2 = "".concat(CART_INFO, "/v2");
var DELIVERY_METHOD_UPDATE = "".concat(CART_INFO, "/delivery-method");
var PAYMENT_METHOD_UPDATE = "".concat(CART_INFO, "/payment-method");
var CART_ADD = "".concat(CART_API_PREFIX, "/cart/add");
var CART_REMOVE = "".concat(CART_API_PREFIX, "/cart/remove");
var CART_UPDATE_REDEEM_CODE = "".concat(CART_API_PREFIX, "/cart/voucher");
var CART_ITEM = "".concat(CART_API_PREFIX, "/cart-item");
var CART_ITEM_LIST = "".concat(CART_API_PREFIX, "/cart-item/list");
var RE_ORDER = "".concat(CART_API_PREFIX, "/cart/re-order");
var CONFIRM = "".concat(CART_API_PREFIX, "/cart/confirm");
var DELIVERY_LIMITATION = "".concat(CART_API_PREFIX, "/delivery-limitation");
var SELECT_ITEM = "".concat(CART_INFO, "/select");
var VERIFY_CART = "".concat(CART_INFO, "/verify");
var CART_REMOVE_MULTI_VOUCHER = "".concat(CART_API_PREFIX, "/cart/remove-voucher");
var CART_CHANGE_MULTI_VOUCHER = "".concat(CART_API_PREFIX, "/cart/add-voucher");
var CART_CHECKOUT = "".concat(CART_API_PREFIX, "/cart/checkout");
var CART_INGREDIENT = "".concat(CART_API_PREFIX, "/cart/ingredient");
var CART_API = {
    CART_INFO: CART_INFO,
    CART_INFO_V2: CART_INFO_V2,
    CART_ADD: CART_ADD,
    CART_REMOVE: CART_REMOVE,
    CART_UPDATE_REDEEM_CODE: CART_UPDATE_REDEEM_CODE,
    DELIVERY_METHOD_UPDATE: DELIVERY_METHOD_UPDATE,
    PAYMENT_METHOD_UPDATE: PAYMENT_METHOD_UPDATE,
    RE_ORDER: RE_ORDER,
    CART_ITEM: CART_ITEM,
    CART_ITEM_LIST: CART_ITEM_LIST,
    CONFIRM: CONFIRM,
    DELIVERY_LIMITATION: DELIVERY_LIMITATION,
    SELECT_ITEM: SELECT_ITEM,
    VERIFY_CART: VERIFY_CART,
    CART_REMOVE_MULTI_VOUCHER: CART_REMOVE_MULTI_VOUCHER,
    CART_CHANGE_MULTI_VOUCHER: CART_CHANGE_MULTI_VOUCHER,
    CART_CHECKOUT: CART_CHECKOUT,
    CART_INGREDIENT: CART_INGREDIENT
};
var ORDER_API_PREFIX = "/marketplace/order/v2";
var ORDER_ITEM_LIST = "".concat(ORDER_API_PREFIX, "/order-item/list");
var ORDER_INFO = "".concat(ORDER_API_PREFIX, "/order");
var MY_ORDER_LIST = "".concat(ORDER_API_PREFIX, "/order/list");
var SKU_HISTORY = "".concat(ORDER_API_PREFIX, "/sku-limit/history-today");
var SEARCH_ORDER_ID = "".concat(CART_API_PREFIX, "/order");
var REVERT = "".concat(ORDER_API_PREFIX, "/cart/revert");
var SEARCH_ORDER = "".concat(ORDER_API_PREFIX, "/order/search");
var ORDER_API = {
    ORDER_ITEM_LIST: ORDER_ITEM_LIST,
    ORDER_INFO: ORDER_INFO,
    MY_ORDER_LIST: MY_ORDER_LIST,
    REVERT: REVERT,
    SKU_HISTORY: SKU_HISTORY,
    SEARCH_ORDER_ID: SEARCH_ORDER_ID,
    EXCHANGE_CONFIG: "".concat(ORDER_API_PREFIX, "/config/exchange-point")
};
// promotion
// /marketplace/promotion/v1/promotion
var PROMOTION_API_PREFIX = "/marketplace/promotion/v1";
var PROMOTION_ALL = "".concat(PROMOTION_API_PREFIX, "/promotion");
var PROMOTION_DETAI_VOUCHER_CODE = "".concat(PROMOTION_API_PREFIX, "/voucher");
var PROMOTION_CAMPAIGN = "/marketplace/promotion/v1/campaign/active/list";
var VOUCHER = "".concat(PROMOTION_API_PREFIX, "/me/voucher");
var MYVOUCHER_HISTORY = "".concat(VOUCHER, "/history");
var PROMOLISTS_DETAIL_PRODUCT = "".concat(PROMOTION_API_PREFIX, "/voucher/list-by-sku");
var SPIN_QUESTION = "".concat(PROMOTION_API_PREFIX, "/game-questions/spin-question");
var PROMOTION_API = {
    PROMOTION_ALL: PROMOTION_ALL,
    PROMOTION_API_PREFIX: PROMOTION_API_PREFIX,
    PROMOTION_DETAI_VOUCHER_CODE: PROMOTION_DETAI_VOUCHER_CODE,
    PROMOTION_CAMPAIGN: PROMOTION_CAMPAIGN,
    VOUCHER: VOUCHER,
    MYVOUCHER_HISTORY: MYVOUCHER_HISTORY,
    PROMOLISTS_DETAIL_PRODUCT: PROMOLISTS_DETAIL_PRODUCT,
    SPIN_QUESTION: SPIN_QUESTION
};
// Supplier API
var SUPPLIER_API_PREFIX = "/seller/core/v1";
var SUPPLIERS = "".concat(SUPPLIER_API_PREFIX, "/account/list");
var SUPPLIER_INFO = "".concat(SUPPLIER_API_PREFIX, "/seller/info");
var SUPPLIER_ACCOUNT_INFO = "".concat(SUPPLIER_API_PREFIX, "/account-by-slug");
var SUPPLIER_BANNER = "".concat(SUPPLIER_API_PREFIX, "/store/banner-for-web");
var SUPPLIER_STORE_LIST = "".concat(SUPPLIER_API_PREFIX, "/store/list");
var SUPPLIER_CONFIG = "".concat(SUPPLIER_API_PREFIX, "/seller/config");
var STORE_INFO = "".concat(SUPPLIER_API_PREFIX, "/store/info-for-web");
// seller/core/v1/store/list?q={\"sellerCode\":\"4GQEM8DN9F\", \"status\": \"ACTIVE\"}"
var SUPPLIER_API = {
    SUPPLIER_INFO: SUPPLIER_INFO,
    SUPPLIERS: SUPPLIERS,
    SUPPLIER_ACCOUNT_INFO: SUPPLIER_ACCOUNT_INFO,
    SUPPLIER_BANNER: SUPPLIER_BANNER,
    SUPPLIER_STORE_LIST: SUPPLIER_STORE_LIST,
    SUPPLIER_CONFIG: SUPPLIER_CONFIG,
    STORE_INFO: STORE_INFO
};
// deprecated 22Feb2023 - Dinh Tran
// const NOTIFICATION_API_PREFIX = '/integration/notification/v1';
// const NOTIFICATION_LIST = `${NOTIFICATION_API_PREFIX}/notification/me`;
// const NOTIFICATION_COUNTER = `${NOTIFICATION_API_PREFIX}/notification/me/counter`;
// const NOTIFICATION_WSS = `${NOTIFICATION_API_PREFIX}/web-socket`;
// const NOTIFICATION = `${NOTIFICATION_API_PREFIX}/notification`;
// const NOTIFICATION_ALL = `${NOTIFICATION_API_PREFIX}/notification/all`;
// export const NOTIFICATION_API = {
//   NOTIFICATION_COUNTER,
//   NOTIFICATION_LIST,
//   NOTIFICATION_WSS,
//   NOTIFICATION_ALL,
//   NOTIFICATION,
// };
// deprecated 22Feb2023 - Dinh Tran
// const SETTING_API_PREFIX = '/marketplace/marketing/v1';
// const SETTING_LIST = `${SETTING_API_PREFIX}/settings/all`;
// export const SETTING_API = {
//   SETTING_LIST,
// };
var MARKETING_API_PREFIX = "/marketplace/marketing/v1";
var BANNER = "".concat(MARKETING_API_PREFIX, "/banners/available");
var HASHTAG_TOP_SEARCH = "".concat(MARKETING_API_PREFIX, "/hashtag-search/list");
var COUNTDOWN_BAR = "".concat(MARKETING_API_PREFIX, "/countdownbar/list");
var THUMBNAIL = "".concat(MARKETING_API_PREFIX, "/meta-thumbnail/list");
var MENU_BAR = "".concat(MARKETING_API_PREFIX, "/menu-bar");
var INSIDER_SETTING = "".concat(MARKETING_API_PREFIX, "/insider-setting");
var CHAT_SETTING = "".concat(MARKETING_API_PREFIX, "/setting?key=chat_config");
var TREND_SEARCH = "".concat(MARKETING_API_PREFIX, "/trend-search");
var MARKETING_API = {
    BANNER: BANNER,
    HASHTAG_TOP_SEARCH: HASHTAG_TOP_SEARCH,
    COUNTDOWN_BAR: COUNTDOWN_BAR,
    THUMBNAIL: THUMBNAIL,
    MENU_BAR: MENU_BAR,
    INSIDER_SETTING: INSIDER_SETTING,
    CHAT_SETTING: CHAT_SETTING,
    TREND_SEARCH: TREND_SEARCH
};
var RETURN_ORDER = "/marketplace/ticket/v1/return-ticket/self-list";
var VERIFY_RETURN_ORDER = "/drugstore/inventory/v1/inbound-session/verify-complete";
var TICKET_API_PREFIX = "/marketplace/ticket/v1";
var TICKET_LIST = "".concat(TICKET_API_PREFIX, "/me/ticket/list");
var TICKET = "".concat(TICKET_API_PREFIX, "/me/ticket");
var TICKET_REASONS = "".concat(TICKET_API_PREFIX, "/reason/list");
var TICKET_DETAIL = "".concat(TICKET_API_PREFIX, "/me/ticket");
var FEEDBACK = "".concat(TICKET_API_PREFIX, "/me/ticket/feedback");
var ACCEPT = "".concat(TICKET_API_PREFIX, "/me/ticket/accept");
var FEEDBACK_WITHOUT_LOGIN = "".concat(TICKET_API_PREFIX, "/guest/ticket");
var TICKET_API = {
    TICKET: TICKET,
    TICKET_DETAIL: TICKET_DETAIL,
    TICKET_REASONS: TICKET_REASONS,
    FEEDBACK: FEEDBACK,
    TICKET_LIST: TICKET_LIST,
    ACCEPT: ACCEPT,
    FEEDBACK_WITHOUT_LOGIN: FEEDBACK_WITHOUT_LOGIN,
    RETURN_ORDER: RETURN_ORDER,
    VERIFY_RETURN_ORDER: VERIFY_RETURN_ORDER
};
// PRODUCT SEARCH
var FUZZY_API = "/marketplace/product/v2/search/fuzzy";
var FUZZY_SEARCH = FUZZY_API;
var REWARDS_API = "/marketplace/promotion/v1/me/gamification/list";
var REWARD_DETAIL = "/marketplace/promotion/v1/me/gamification";
var REWARDS_BY_SELLER = "/marketplace/promotion/v1/gamification-by-seller/list";
var SMART_RECOMMENDATION = "/recommendation/product/v1";
var RECOMMEND = "".concat(SMART_RECOMMENDATION, "/recommend");
var RECOMMEND_FOR_HOMEPAGE = "/marketplace/frontend-apis/v1/recommendation/home";
var SMART_RECOMMENDATION_API = {
    RECOMMEND: RECOMMEND,
    RECOMMEND_FOR_HOMEPAGE: RECOMMEND_FOR_HOMEPAGE
};
// accounting/core/v1/debt/list
var ACCOUNTING_API_PREFIX = "/accounting/core/v1";
var ACCOUNTING_API = {
    debt: "".concat(ACCOUNTING_API_PREFIX, "/debt/list"),
    DEBT_CHECK: "".concat(ACCOUNTING_API_PREFIX, "/debt/check"),
    DEBT_ORDER: "".concat(ACCOUNTING_API_PREFIX, "/debt-order/list")
};
// /payment/wallet/v1/me/transaction/list
var PAYMENT_WALLET = "/payment/wallet/v1";
var PAYMENT_WALLET_API = {
    TRANSACTIONS: "".concat(PAYMENT_WALLET, "/me/transaction/list")
};
// buyer-service-invoice
var BUYER_SERVICE_API = "/accounting/invoice/v1/buyer-service-invoice/lite";
// web service frontend-apis
var FRONTEND_APIS_PREFIX = "/marketplace/frontend-apis/v1";
var FRONTEND_APIS = {
    FUZZY_SEARCH: "".concat(FRONTEND_APIS_PREFIX, "/search/fuzzy"),
    PRODUCT_DETAIL: "".concat(FRONTEND_APIS_PREFIX, "/product/detail"),
    CART: "".concat(FRONTEND_APIS_PREFIX, "/cart"),
    FUZZY_SEARCH_LITE: "".concat(FRONTEND_APIS_PREFIX, "/search/fuzzy/lite"),
    HOME_CATEGORIES: "".concat(FRONTEND_APIS_PREFIX, "/home/section/categories"),
    RECENT_PRODUCTS: "".concat(FRONTEND_APIS_PREFIX, "/product/recent"),
    PASSWORD_RECOVERY: "".concat(FRONTEND_APIS_PREFIX, "/account/password-recovery"),
    // BV-2408: sản phẩm thay thế
    SUBSTITUTES: "".concat(FRONTEND_APIS_PREFIX, "/search/substitutes"),
    SUBSTITUTE_ENABLED: "".concat(FRONTEND_APIS_PREFIX, "/substitute/enabled"),
    QUICK_ORDER_FUZZY: "".concat(FRONTEND_APIS_PREFIX, "/quick-order/fuzzy")
};
var PROMOTION_LUCKY_WHEEL = {
    SPIN: "".concat(PROMOTION_API_PREFIX, "/lucky-wheel/spin"),
    SELF_LUCKY_WHEEL: "".concat(PROMOTION_API_PREFIX, "/me/lucky-wheel"),
    LUCKY_WHEEL_ITEMS: "".concat(PROMOTION_API_PREFIX, "/lucky-wheel-item/list"),
    SELF_LOG_LUCKY_WHEEL: "".concat(PROMOTION_API_PREFIX, "/me/lucky-wheel-log/list"),
    SELF_MISSION_LUCKY_WHEEL: "".concat(PROMOTION_API_PREFIX, "/me/lucky-wheel-mission/list")
};
var MARCOM_SERVICE = {
    WEB_REGISTER_TOKEN: "".concat(sysconfig__WEBPACK_IMPORTED_MODULE_0__/* .MARCOM_API_DOMAIN */ .Z3, "/insider/communication/v1/user-token/web-register")
};


/***/ }),

/***/ 47387:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ palette; }
/* harmony export */ });
var palette = {
    warning: {
        lighter: "#FFF7CD",
        light: "#FFE16A",
        main: "#FFC107",
        dark: "#B78103",
        darker: "#7A4F01",
        default: "#FFC107"
    },
    success: {
        lighter: "#E9FCD4",
        light: "#AAF27F",
        main: "#54D62C",
        default: "#54D62C",
        dark: "#229A16",
        darker: "#08660D"
    },
    primary: {
        lighter: "#C8FACD",
        light: "#5BE584",
        default: "#005C29",
        main: "#005C29",
        dark: "#007B55",
        darker: "#005249"
    },
    info: {
        lighter: "##D0F2FF",
        light: "#74CAFF",
        main: "#1890FF",
        default: "#1890FF",
        dark: "#0C53B7",
        darker: "#04297A"
    },
    secondary: {
        main: "#ff4fae",
        default: "#ff4fae"
    },
    thirdly: {
        main: "#00814f",
        default: "#00814f"
    },
    error: {
        lighter: "#FFE7D9",
        light: "#FFA48D",
        main: "#FF4842",
        default: "#FF4842",
        dark: "#B72136",
        darker: "#7A0C2E"
    },
    grey: {
        100: "#F9FAFB",
        200: "#F4F6F8",
        300: "#DFE3E8  ",
        400: "#C4CDD5",
        500: "#919EAB",
        600: "#637381",
        700: "#454F5B",
        800: "#212B36",
        900: "#161C24",
        default: "#919EAB"
    },
    background: {
        default: "#fff"
    }
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
    palette: palette
});


/***/ }),

/***/ 32826:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ MOBILE; }
/* harmony export */ });
var MOBILE = /Android|BlackBerry|iPhone|iPod|Opera Mini|IEMobile|WPDesktop/i;
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
    MOBILE: MOBILE
});


/***/ }),

/***/ 6899:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
// ORDER_CANCELLATION:   "ORDER_CANCELLATION",
// ORDER_INQUIRY:        "ORDER_INQUIRY",
// PROMOTION_AND_REWARD: "PROMOTION_AND_REWARD",
// BUYMED_ACCOUNT:       "BUYMED_ACCOUNT",
// CLAIM_PRODUCT:        "CLAIM_PRODUCT",
// DELIVERY_INQUIRY:     "DELIVERY_INQUIRY",
// PAYMENT_INQUIRY:      "PAYMENT_INQUIRY",
// COMPLAINT:            "COMPLAINT",
// TECHNICAL_ISSUE:      "TECHNICAL_ISSUE",
// PRICE_RECOMMENDATION: "PRICE_RECOMMENDATION",
var MapTicketTypeName = {
    PRODUCT: "Sản phẩm",
    ORDER: "Đơn h\xe0ng",
    OTHER: "Kh\xe1c",
    ACCOUNT: "T\xe0i khoản",
    PROMOTION: "Khuyến m\xe3i"
};
var TicketEnums = {
    PRODUCT: "PRODUCT",
    ACCOUNT: "ACCOUNT",
    ORDER: "ORDER",
    OTHER: "OTHER",
    PROMOTION: "PROMOTION",
    ORDER_CANCELLATION: "ORDER_CANCELLATION",
    ORDER_INQUIRY: "ORDER_INQUIRY",
    PROMOTION_AND_REWARD: "PROMOTION_AND_REWARD",
    BUYMED_ACCOUNT: "BUYMED_ACCOUNT",
    CLAIM_PRODUCT: "CLAIM_PRODUCT",
    DELIVERY_INQUIRY: "DELIVERY_INQUIRY",
    PAYMENT_INQUIRY: "PAYMENT_INQUIRY",
    COMPLAINT: "COMPLAINT",
    TECHNICAL_ISSUE: "TECHNICAL_ISSUE",
    PRICE_RECOMMENDATION: "PRICE_RECOMMENDATION"
};
var TicketLabelEnums = {
    PRODUCT: {
        code: "PRODUCT",
        label: "Sản phẩm"
    },
    ACCOUNT: {
        code: "ACCOUNT",
        label: "T\xe0i khoản"
    },
    ORDER: {
        code: "ORDER",
        label: "Đơn h\xe0ng"
    },
    OTHER: {
        code: "OTHER",
        label: "\xdd kiến đ\xf3ng g\xf3p"
    },
    PROMOTION: {
        code: "PROMOTION",
        label: "Khuyến m\xe3i"
    },
    ORDER_CANCELLATION: {
        code: "ORDER_CANCELLATION",
        label: "Hủy đơn h\xe0ng"
    },
    ORDER_INQUIRY: {
        code: "ORDER_INQUIRY",
        label: "Y\xeau cầu đặt h\xe0ng"
    },
    PROMOTION_AND_REWARD: {
        code: "PROMOTION_AND_REWARD"
    },
    BUYMED_ACCOUNT: {
        code: "BUYMED_ACCOUNT"
    },
    CLAIM_PRODUCT: {
        code: "CLAIM_PRODUCT"
    },
    DELIVERY_INQUIRY: {
        code: "DELIVERY_INQUIRY"
    },
    PAYMENT_INQUIRY: {
        code: "PAYMENT_INQUIRY"
    },
    COMPLAINT: {
        code: "COMPLAINT"
    },
    TECHNICAL_ISSUE: {
        code: "TECHNICAL_ISSUE"
    },
    PRICE_RECOMMENDATION: {
        code: "PRICE_RECOMMENDATION"
    }
};
var TicketStatus = {
    PENDING: {
        code: "PENDING",
        label: "Chưa xử l\xfd"
    },
    IN_PROCESS: {
        code: "IN_PROCESS",
        label: "Đang xử l\xfd"
    },
    REPLIED: {
        code: "REPLIED",
        label: "Đ\xe3 trả lời"
    },
    CANCELLED: {
        code: "CANCELLED",
        label: "Đ\xe3 hủy"
    },
    DONE: {
        code: "DONE",
        label: "Ho\xe0n tất"
    }
};
var TYPE_OF_STATUS = {
    PENDING: "Chưa Xử L\xfd",
    IN_PROCESS: "Đang Xử L\xfd",
    DONE: "Đ\xe3 Xử L\xfd",
    REPLIED: "Đ\xe3 Trả Lời",
    CANCELLED: "Đ\xe3 Hủy"
};
var BACKGROUND_COLOR_STATUS = {
    PENDING: "rgb(204 85 85)",
    IN_PROCESS: "rgb(248 142 31)",
    DONE: "#005C29",
    REPLIED: "#788FCA",
    CANCELLED: "rgb(187 187 187)"
};
var TYPE_OF_TICKET_SUPPORT = {
    PROMOTION: "Khuyến m\xe3i",
    ACCOUNT: "T\xe0i Khoản",
    PRODUCT: "Sản Phẩm",
    ORDER: "Đơn H\xe0ng",
    OTHER: "Kh\xe1c"
};
// ORDER_CANCELLATION:   "ORDER_CANCELLATION",
// ORDER_INQUIRY:        "ORDER_INQUIRY",
// PROMOTION_AND_REWARD: "PROMOTION_AND_REWARD",
// BUYMED_ACCOUNT:       "BUYMED_ACCOUNT",
// CLAIM_PRODUCT:        "CLAIM_PRODUCT",
// DELIVERY_INQUIRY:     "DELIVERY_INQUIRY",
// PAYMENT_INQUIRY:      "PAYMENT_INQUIRY",
// COMPLAINT:            "COMPLAINT",
// TECHNICAL_ISSUE:      "TECHNICAL_ISSUE",
// PRICE_RECOMMENDATION: "PRICE_RECOMMENDATION",
var TicketTypes = [
    // 'PRODUCT',
    // 'ACCOUNT',
    // 'ORDER',
    // 'OTHER',
    // 'PROMOTION',
    "ORDER_CANCELLATION",
    "ORDER_INQUIRY",
    "PROMOTION_AND_REWARD",
    "BUYMED_ACCOUNT",
    "CLAIM_PRODUCT",
    "DELIVERY_INQUIRY",
    "PAYMENT_INQUIRY",
    "COMPLAINT",
    "TECHNICAL_ISSUE",
    "PRICE_RECOMMENDATION", 
];
var TicketTypesNotActive = [
    "ACCOUNT",
    "PRODUCT",
    "OTHER"
];
var TicketTypesPageFeedback = [
    "ACCOUNT"
];
/* harmony default export */ __webpack_exports__["Z"] = ({
    MapTicketTypeName: MapTicketTypeName,
    TicketEnums: TicketEnums,
    TicketLabelEnums: TicketLabelEnums,
    TicketTypes: TicketTypes,
    TicketStatus: TicketStatus,
    TicketTypesNotActive: TicketTypesNotActive,
    TicketTypesPageFeedback: TicketTypesPageFeedback,
    TYPE_OF_STATUS: TYPE_OF_STATUS,
    BACKGROUND_COLOR_STATUS: BACKGROUND_COLOR_STATUS,
    TYPE_OF_TICKET_SUPPORT: TYPE_OF_TICKET_SUPPORT
});


/***/ }),

/***/ 53208:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ HTTP_STATUS; }
/* harmony export */ });
var HTTP_STATUS = {
    Ok: "OK",
    Error: "ERROR",
    Invalid: "INVALID",
    NotFound: "NOT_FOUND",
    Forbidden: "FORBIDDEN",
    Existed: "EXISTED",
    Unauthorized: "UNAUTHORIZED"
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
    HTTP_STATUS: HTTP_STATUS
});


/***/ }),

/***/ 71569:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$O": function() { return /* binding */ GROUP_ADDRESS_TYPE; },
/* harmony export */   "B4": function() { return /* binding */ MOBILE_FLAGSHIP_LABEL; },
/* harmony export */   "E8": function() { return /* binding */ ENUMS_ERROR_ACC_CODE; },
/* harmony export */   "ED": function() { return /* binding */ ENUM_GARMINICATION; },
/* harmony export */   "Ei": function() { return /* binding */ ADDRESS_CHANGE_TYPE; },
/* harmony export */   "FW": function() { return /* binding */ UserType; },
/* harmony export */   "Ff": function() { return /* binding */ ENUMS_PAYMENT_METHOD; },
/* harmony export */   "Gk": function() { return /* binding */ FILE_TYPE; },
/* harmony export */   "Hp": function() { return /* binding */ ALIGN; },
/* harmony export */   "Hq": function() { return /* binding */ MONITORING_COLLECTOR_TYPE; },
/* harmony export */   "Hr": function() { return /* binding */ REFERRAL_STATUS_LABEL; },
/* harmony export */   "IN": function() { return /* binding */ PAYMENT_METHOD_NEED_WAITING; },
/* harmony export */   "Ii": function() { return /* binding */ ENUM_TRACKING_SOURCE; },
/* harmony export */   "Ik": function() { return /* binding */ GARMINICATION_STATUS; },
/* harmony export */   "Iw": function() { return /* binding */ DEFAULT_NON_BANK_WAITING_HOURS; },
/* harmony export */   "MG": function() { return /* binding */ HTTP_STATUS; },
/* harmony export */   "QX": function() { return /* binding */ ENUM_TRACKING_ACTION; },
/* harmony export */   "Ql": function() { return /* binding */ ENUM_ORDER_STATUS_COLOR; },
/* harmony export */   "RS": function() { return /* binding */ BRAND_NAME; },
/* harmony export */   "R_": function() { return /* binding */ ARR_STATUS_WARE_HOUSE; },
/* harmony export */   "Sm": function() { return /* binding */ ENUM_ORDER_STATUS_COLOR_V2; },
/* harmony export */   "TJ": function() { return /* binding */ ENUM_ORDER_STATUS; },
/* harmony export */   "Uq": function() { return /* binding */ LOYALTY_STATUS; },
/* harmony export */   "Wl": function() { return /* binding */ REFERRAL_STATUS; },
/* harmony export */   "Yo": function() { return /* binding */ FLAGSHIP_LABEL; },
/* harmony export */   "_H": function() { return /* binding */ DEFAULT_PAGINATION; },
/* harmony export */   "aM": function() { return /* binding */ SELLER_GROUP; },
/* harmony export */   "cm": function() { return /* binding */ THUOCSI_RECOMMENDATION; },
/* harmony export */   "eb": function() { return /* binding */ ENUM_ORDER_TYPE; },
/* harmony export */   "gP": function() { return /* binding */ ENUM_CONDITION_TYPE; },
/* harmony export */   "gY": function() { return /* binding */ PROMO_TYPE; },
/* harmony export */   "hD": function() { return /* binding */ ENUM_SCOPE; },
/* harmony export */   "hL": function() { return /* binding */ PAYMENT_METHOD; },
/* harmony export */   "iC": function() { return /* binding */ ENUMS_VOUCHER_ERROR_CODE; },
/* harmony export */   "jf": function() { return /* binding */ BRAND_PHONE; },
/* harmony export */   "k0": function() { return /* binding */ PROMO_REWARD_TYPE; },
/* harmony export */   "kW": function() { return /* binding */ BEAM_CHECK_IN_STATUS; },
/* harmony export */   "lH": function() { return /* binding */ LOYALTY_HISTORY_TYPE; },
/* harmony export */   "lk": function() { return /* binding */ CUSTOMER_TAG; },
/* harmony export */   "lo": function() { return /* binding */ ENUMS_FILTER_CATEGORY_TYPE; },
/* harmony export */   "mJ": function() { return /* binding */ ARR_REMOVE_PRODUCT; },
/* harmony export */   "pN": function() { return /* binding */ INSIDER_RECOMMENDATION; },
/* harmony export */   "pO": function() { return /* binding */ ENUM_COUNTDOWN_BAR_DISPLAY_PAGE; },
/* harmony export */   "q0": function() { return /* binding */ TYPE_CUSTOMER_BY_COLOR; },
/* harmony export */   "qG": function() { return /* binding */ DEFAULT_BANK_TRANSFER_WAITING_HOURS; },
/* harmony export */   "qO": function() { return /* binding */ BRAND_EMAIL_HELP; },
/* harmony export */   "sm": function() { return /* binding */ BRAND_PHONE_DISPLAY; },
/* harmony export */   "t7": function() { return /* reexport safe */ _EnumsTicket__WEBPACK_IMPORTED_MODULE_2__.Z; },
/* harmony export */   "t8": function() { return /* binding */ ENUM_COUNTDOWN_BAR_IMAGE_TYPE; },
/* harmony export */   "u7": function() { return /* binding */ ENUMS_CHAT_SETTING_VALUE; },
/* harmony export */   "uc": function() { return /* binding */ POPUP_SHARING_ITEM; },
/* harmony export */   "w4": function() { return /* binding */ FLUCTUATED_TYPE; },
/* harmony export */   "w8": function() { return /* binding */ THUOCSI_LABEL; },
/* harmony export */   "xZ": function() { return /* binding */ ENUM_SCOPE_LABEL; }
/* harmony export */ });
/* unused harmony exports ENUM_TYPE, RIBBON_STATUS, LIST_REASONS, LIST_REASONS_MAP, ENUM_ORDER_STATUS_LABEL, PAYMENT_METHOD_NAME, PAYMENT_METHOD_NAME_SHORT, LEVEL_CUSTOMER, LABEL_GIFT_TAG_PROMOTION, ENUM_INVOICE_STATUS, ENUMS_ERROR_MSG_CODE, LANDING_PAGE_SECTIONS */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14924);
/* harmony import */ var sysconfig__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66225);
/* harmony import */ var _EnumsTicket__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6899);


var ENUM_SCOPE = {
    PHARMACY: "PHARMACY",
    DRUGSTORE: "DRUGSTORE",
    ANIMAL_PHARMACY: "ANIMAL_PHARMACY",
    WHOLESALE_PHARMACY: "WHOLESALE_PHARMACY",
    DENTISTRY: "DENTISTRY",
    HOSPITAL: "HOSPITAL",
    ANIMAL_CLINIC: "ANIMAL_CLINIC",
    CLINIC: "CLINIC",
    NURSE_CLINIC: "NURSE_CLINIC",
    BEAUTY_SALON: "BEAUTY_SALON",
    HEALTH_CENTER: "HEALTH_CENTER",
    PHARMA_COMPANY: "PHARMA_COMPANY",
    NEW_CUSTOMER: "NEW_CUSTOMER"
};
var _obj;
var ENUM_SCOPE_LABEL = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, ENUM_SCOPE.DRUGSTORE, "drugstore"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, ENUM_SCOPE.PHARMACY, "pharmacy"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, ENUM_SCOPE.CLINIC, "clinic"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, ENUM_SCOPE.HOSPITAL, "hospital"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, ENUM_SCOPE.PHARMA_COMPANY, "drug_company"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, ENUM_SCOPE.DENTISTRY, "dentist"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, ENUM_SCOPE.BEAUTY_SALON, "beauty_salon"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, ENUM_SCOPE.HEALTH_CENTER, "health_center"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, ENUM_SCOPE.ANIMAL_PHARMACY, "animal_center"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, ENUM_SCOPE.WHOLESALE_PHARMACY, "wholesale_center"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, ENUM_SCOPE.ANIMAL_CLINIC, "animal_clinic"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, ENUM_SCOPE.NURSE_CLINIC, "nurse_clinic"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, ENUM_SCOPE.NEW_CUSTOMER, "new_customer"), _obj);
var PAYMENT_METHOD = {
    COD: "PAYMENT_METHOD_NORMAL",
    TRANSFER: "PAYMENT_METHOD_BANK",
    CREDIT: "PAYMENT_METHOD_CREDIT",
    QR_BEAM: "PAYMENT_METHOD_QR_BEAM"
};
var DEFAULT_BANK_TRANSFER_WAITING_HOURS = 72;
var DEFAULT_NON_BANK_WAITING_HOURS = 72;
var PAYMENT_METHOD_NEED_WAITING = [
    PAYMENT_METHOD.QR_BEAM
];
var BEAM_CHECK_IN_STATUS = {
    PAID: "PAID",
    UNPAID: "UNPAID",
    CANCELLED: "CANCELLED"
};
var ENUM_TYPE = {};
var RIBBON_STATUS = {
    UP: "up",
    DOWN: "down"
};
var PROMO_TYPE = {
    DISCOUNT: "DISCOUNT",
    COMBO: "COMBO",
    GIFT: "GIFT",
    VOUCHERCODE: "VOUCHERCODE",
    FREESHIP: "FREESHIP",
    PERCENTAGE: "PERCENTAGE",
    ABSOLUTE: "ABSOLUTE",
    POINT: "POINT"
};
// deprecated 22Feb2023 - Dinh Tran
// export const PROMOTION_STATUS = {
//   WAITING: 'WAITING',
//   ACTIVE: 'ACTIVE',
//   FULL: 'FULL',
//   EXPIRED: 'EXPIRED',
//   DELETED: 'DELETED',
// };
// export const PROMOTION_SCOPE = {
//   GLOBAL: 'GLOBAL',
//   SELLER: 'SELLER',
//   CATEGORY: 'CATEGORY',
//   PRODUCT: 'PRODUCT',
//   SKU: 'SKU',
// };
// export const PROMO_RULE_FIELD_TYPE = {
//   MIN_QUANTITY: 'MIN_QUANTITY',
//   MIN_ORDER_VALUE: 'MIN_ORDER_VALUE',
// };
// export const PROMO_RULE_TYPE = {
//   VALUE: 'VALUE',
//   PERCENT: 'PERCENT',
//   GIFT: 'GIFT',
//   PRODUCT: 'PRODUCT',
//   ABSOLUTE: 'ABSOLUTE',
// };
var PROMO_REWARD_TYPE = {
    PERCENTAGE: "PERCENTAGE",
    GIFT: "GIFT",
    POINT: "POINT",
    ABSOLUTE: "ABSOLUTE"
};
var HTTP_STATUS = {
    Ok: "OK",
    Error: "ERROR",
    Invalid: "INVALID",
    NotFound: "NOT_FOUND",
    Forbidden: "FORBIDDEN",
    Existed: "EXISTED",
    Unauthorized: "UNAUTHORIZED"
};
// export const PRODUCT_TYPE = {
//   CAN_INVOICE: 'can invoice',
// };
var DEFAULT_PAGINATION = {
    OFFSET: 0,
    LIMIT: 20,
    TOTAL: 0
};
var ALIGN = {
    LEFT: "left",
    RIGHT: "right",
    CENTER: "center"
};
var LIST_REASONS = [
    {
        code: "SAI_SAN_PHAM",
        name: "Sai sản phẩm"
    },
    {
        code: "DONG_THIEU_HANG",
        name: "Đ\xf3ng thiếu h\xe0ng"
    },
    {
        code: "DONG_DU_HANG",
        name: "Đ\xf3ng dư h\xe0ng"
    },
    {
        code: "CAN_NGAY",
        name: "Cận ng\xe0y"
    },
    {
        code: "SAN_PHAM_HU_BE",
        name: "Sản phẩm hư bể"
    },
    {
        code: "CHENH_LECH_CHUYEN_KHOAN",
        name: "Ch\xeanh lệch chuyển khoản"
    },
    {
        code: "KHACH_DAT_SAI",
        name: "Kh\xe1ch đặt sai"
    },
    {
        code: "MAT_HANG",
        name: "Mất h\xe0ng"
    },
    {
        code: "SAI_HOA_DON",
        name: "Sai h\xf3a đơn"
    },
    {
        code: "GIAO_LON_THUNG_HANG",
        name: "Giao lộn th\xf9ng h\xe0ng"
    },
    {
        code: "GIAO_HANG_TRE",
        name: "Giao h\xe0ng trễ"
    },
    {
        code: "HUY_DON",
        name: "Hủy đơn"
    },
    {
        code: "TRA_HANG_VE",
        name: "Trả h\xe0ng về"
    },
    {
        code: "CHAT_LUONG_SAN_PHAM",
        name: "Chất lượng sản phẩm"
    },
    {
        code: "DONG_SAI_SO_LUONG",
        name: "Đ\xf3ng sai số lượng"
    },
    {
        code: "HEN_GIAO_HANG",
        name: "Hẹn giao h\xe0ng"
    },
    {
        code: "HOA_DON_DO",
        name: "H\xf3a đơn đỏ"
    },
    {
        code: "HOI_GIAO_HANG",
        name: "Hối giao h\xe0ng"
    },
    {
        code: "KHACH_TU_Y_HUY_DON",
        name: "Kh\xe1ch tự \xfd hủy đơn"
    },
    {
        code: "KHONG_LIEN_LAC_DUOC_KHACH",
        name: "Kh\xf4ng li\xean lạc được kh\xe1ch"
    },
    {
        code: "SAI_DIA_CHI",
        name: "Sai địa chỉ"
    },
    {
        code: "THAY_DOI_DIA_CHI",
        name: "Thay đổi địa chỉ"
    },
    {
        code: "THAY_DOI_HINH_THUC_THANH_TOAN",
        name: "Thay đổi h\xecnh thức thanh to\xe1n"
    },
    {
        code: "THAY_DOI_SO_LUONG",
        name: "Thay đổi số lượng"
    },
    {
        code: "TINH_TRANG_DON_HANG",
        name: "T\xecnh trạng đơn h\xe0ng"
    },
    {
        code: "GHI_CHU_DON_HANG",
        name: "Ghi ch\xfa đơn h\xe0ng"
    },
    {
        code: "THAC_MAC_SAN_PHAM",
        name: "Thắc mắc sản phẩm"
    },
    {
        code: "THAC_MAC_DICH_VU",
        name: "Thắc mắc dịch vụ"
    },
    {
        code: "THAC_MAC_THANH_TOAN",
        name: "Thắc mắc thanh to\xe1n"
    },
    {
        code: "LOI_KI_THUAT",
        name: "Lỗi kĩ thuật"
    },
    {
        code: "VAN_DE_KHAC",
        name: "Vấn đề kh\xe1c"
    }, 
];
var LIST_REASONS_MAP = LIST_REASONS.reduce(function(map, item) {
    // eslint-disable-next-line no-param-reassign
    map[item.code] = item;
    return map;
}, {});
// export const FEEDBACK_REASON = LIST_REASONS_MAP;
// {
//   DONG_THIEU_HANG: {
//     code: 'DONG_THIEU_HANG',
//     name: 'Đóng thiếu hàng',
//   },
//   DONG_DU_HANG: {
//     code: 'DONG_DU_HANG',
//     name: 'Đóng dư hàng',
//   },
// };
var ENUM_ORDER_STATUS = {
    ALL: "ALL",
    WAIT_TO_CONFIRM: "WAIT_TO_CONFIRM",
    CONFIRMED: "CONFIRMED",
    PROCESSING: "PROCESSING",
    DELIVERING: "DELIVERING",
    TRANSPORTING: "TRANSPORTING",
    DELIVERED: "DELIVERED",
    CANCEL: "CANCEL",
    COMPLETED: "COMPLETED",
    WAIT_TO_DELIVER: "WAIT_TO_DELIVER"
};
var ENUM_GARMINICATION = {
    ALL: "ALL",
    UPCOMING: "UPCOMING",
    IN_PROGRESS: "IN_PROGRESS",
    FINISHED: "FINISHED",
    COMPLETED: "EXPIRED"
};
var GARMINICATION_STATUS = [
    {
        value: "ALL",
        label: "Tất cả",
        color: "#fff",
        background: "#fff"
    },
    {
        value: "PROCESSING",
        label: "Đang diễn ra",
        color: "#D4323B",
        background: "#FFEAEA"
    },
    {
        value: "UPCOMING",
        label: "Sắp diễn ra",
        color: "#A87E00",
        background: "#FCF4DE"
    },
    {
        value: "EXPIRED",
        label: "Đ\xe3 kết th\xfac",
        color: "#636363",
        background: "#E9E9E9"
    }, 
];
var _obj1;
var ENUM_ORDER_STATUS_LABEL = (_obj1 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, ENUM_ORDER_STATUS.WAIT_TO_CONFIRM, "Chờ x\xe1c nhận"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, ENUM_ORDER_STATUS.CONFIRMED, "Đ\xe3 x\xe1c nhận"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, ENUM_ORDER_STATUS.PROCESSING, "Đang xử l\xfd"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, ENUM_ORDER_STATUS.DELIVERING, "Đang vận chuyển"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, ENUM_ORDER_STATUS.TRANSPORTING, "Đang trung chuyển"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, ENUM_ORDER_STATUS.WAIT_TO_DELIVER, "Chờ vận chuyển"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, ENUM_ORDER_STATUS.DELIVERED, "Đ\xe3 giao"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, ENUM_ORDER_STATUS.CANCEL, "Đ\xe3 hủy"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, ENUM_ORDER_STATUS.COMPLETED, "Đ\xe3 ho\xe0n tất"), _obj1);
var _obj2;
var ENUM_ORDER_STATUS_COLOR = (_obj2 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, ENUM_ORDER_STATUS.WAIT_TO_CONFIRM, "btn--default"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, ENUM_ORDER_STATUS.CONFIRMED, "btn--default"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, ENUM_ORDER_STATUS.PROCESSING, "btn--default"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, ENUM_ORDER_STATUS.WAIT_TO_DELIVER, "btn--default"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, ENUM_ORDER_STATUS.DELIVERING, "btn--delivery"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, ENUM_ORDER_STATUS.TRANSPORTING, "btn--delivery"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, ENUM_ORDER_STATUS.DELIVERED, "btn--delivered"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, ENUM_ORDER_STATUS.CANCEL, "btn--cancel"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, ENUM_ORDER_STATUS.COMPLETED, "btn--complete"), _obj2);
var ENUM_ORDER_TYPE = {
    NORMAL: "NORMAL",
    COMBO: "COMBO",
    DEAL: "DEAL",
    GIFT: "GIFT",
    CAMPAIGN: "CAMPAIGN"
};
var GROUP_ADDRESS_TYPE = {
    VERTICAL: "vertical",
    HORIZONTAL: "horizontal"
};
var ADDRESS_CHANGE_TYPE = {
    ASSIGNED: "ASSIGNED",
    PROVINCE_CHANGE: "PROVINCE_CHANGE",
    DISTRICT_CHANGE: "DISTRICT_CHANGE",
    WARD_CHANGE: "WARD_CHANGE"
};
var LOYALTY_HISTORY_TYPE = {
    INCREMENT: "INCREMENT",
    DECREMENT: "DECREMENT"
};
var REFERRAL_STATUS = {
    NEW: "NEW",
    APPROVED: "APPROVED",
    DECLINED: "DECLINED"
};
var _obj3;
var REFERRAL_STATUS_LABEL = (_obj3 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj3, REFERRAL_STATUS.NEW, "enum.REFERRAL_STATUS_LABEL.NEW"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj3, REFERRAL_STATUS.APPROVED, "enum.REFERRAL_STATUS_LABEL.APPROVED"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj3, REFERRAL_STATUS.DECLINED, "enum.REFERRAL_STATUS_LABEL.DECLINED"), _obj3);
// export const LOYALTY_HISTORY_TYPE_LABEL = {
//   [LOYALTY_HISTORY_TYPE.INCREMENT]: 'Tích luỹ',
//   [LOYALTY_HISTORY_TYPE.DECREMENT]: 'Đã đổi điểm',
// };
var FILE_TYPE = {
    PDF: "application/pdf",
    PNG: "image/png",
    JPEG: "image/jpeg",
    DOC: "application/msword",
    DOCX: "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
};
var LOYALTY_STATUS = {
    ACTIVE: "ACTIVE",
    INACTIVE: "INACTIVE"
};
var ENUMS_PAYMENT_METHOD = {
    PAYMENT_METHOD_NORMAL: "PAYMENT_METHOD_NORMAL",
    PAYMENT_METHOD_BANK: "PAYMENT_METHOD_BANK",
    PAYMENT_METHOD_CREDIT: "PAYMENT_METHOD_CREDIT"
};
var PAYMENT_METHOD_NAME = {
    PAYMENT_METHOD_NORMAL: "Thanh to\xe1n tiền mặt khi nhận h\xe0ng",
    PAYMENT_METHOD_BANK: "Thanh to\xe1n chuyển khoản",
    PAYMENT_METHOD_CREDIT: "Thanh to\xe1n hợp đồng"
};
var PAYMENT_METHOD_NAME_SHORT = {
    PAYMENT_METHOD_NORMAL: "Tiền mặt",
    PAYMENT_METHOD_BANK: "Chuyển khoản",
    PAYMENT_METHOD_BANK_1: "Chuyển khoản",
    PAYMENT_METHOD_CREDIT: "Hợp đồng"
};
var ARR_REMOVE_PRODUCT = [
    "NOT_ACTIVE_SKU",
    "SUSPENDED_SKU",
    "STOP_PRODUCING_SKU",
    "OUT_OF_STOCK_SKU",
    "CART_ITEM_INVALID",
    "NOT_AVAILABLE_SKU",
    "NOT_AVAILABLE_SCOPE",
    "NOT_FOUND_SKU",
    "NOT_FOUND_PRICE_SKU",
    "COMBO_INVALID",
    "REQUIRED_CERTIFICATE", 
];
var FLUCTUATED_TYPE = {
    INCREASED: "INCREASED",
    DECREASED: "DECREASED"
};
var SELLER_GROUP = {
    MEDX: "MEDX",
    DOITAC: "DOITAC",
    HANGMUAHO: "HANGMUAHO",
    DUREX: "DUREX",
    GIFT_ORDER: "GIFT_ORDER"
};
// export const LEVEL_CODE = {
//   LEVEL_SLIVER: 'LEVEL_SLIVER',
//   LEVEL_SILVER: 'LEVEL_SILVER',
//   LEVEL_GOLD: 'LEVEL_GOLD',
//   LEVEL_PLATINUM: 'LEVEL_PLATINUM',
//   LEVEL_DIAMOND: 'LEVEL_DIAMOND',
// };
var LEVEL_CUSTOMER = {
    LEVEL_SLIVER: "bạc",
    LEVEL_SILVER: "bạc",
    LEVEL_GOLD: "v\xe0ng",
    LEVEL_PLATINUM: "bạch kim",
    LEVEL_DIAMOND: "kim cương"
};
// export const ACTIVE_STORE_TAG = 'thuocsi.vn Store';

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
    ENUM_SCOPE: ENUM_SCOPE,
    ENUM_TYPE: ENUM_TYPE,
    HTTP_STATUS: HTTP_STATUS,
    ENUM_ORDER_TYPE: ENUM_ORDER_TYPE
});
// export const MAX_WEIGHT = 20000;
// export const MAX_VOLUME = 62400000;
// export const COLOR_CUSTOMER = {
//   GREEN: 'GREEN',
//   YELLOW: 'YELLOW',
//   ORANGE: 'ORANGE',
//   RED: 'RED',
//   BLUE: 'BLUE', // VIP
//   PURPLE: 'PURPLE', // VIP - công nợ
// };
var CUSTOMER_TAG = {
    BAN: "BAN",
    BLOCK_COD: "BLOCK_COD"
};
var TYPE_CUSTOMER_BY_COLOR = {
    LOCKED_CUSTOMER: "LOCKED_CUSTOMER"
};
var FLAGSHIP_LABEL = "enum.FLAGSHIP_LABEL";
var THUOCSI_LABEL = sysconfig__WEBPACK_IMPORTED_MODULE_0__/* .ENV_COUNTRY */ .ng === "vn" ? "thuocsi.vn Store" : "Buymed Store";
var MOBILE_FLAGSHIP_LABEL = "enum.MOBILE_FLAGSHIP_LABEL";
var LABEL_GIFT_TAG_PROMOTION = "Tặng Qu\xe0";
var _obj4;
var ENUM_ORDER_STATUS_COLOR_V2 = (_obj4 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj4, ENUM_ORDER_STATUS.WAIT_TO_CONFIRM, "#788FCA"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj4, ENUM_ORDER_STATUS.CONFIRMED, "#3B438F"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj4, ENUM_ORDER_STATUS.PROCESSING, "#E8AE00"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj4, ENUM_ORDER_STATUS.DELIVERING, "#D4323B"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj4, ENUM_ORDER_STATUS.DELIVERED, "#01A0B5"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj4, ENUM_ORDER_STATUS.CANCEL, "#A2A0A0"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj4, ENUM_ORDER_STATUS.COMPLETED, "#005C29"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj4, ENUM_ORDER_STATUS.WAIT_TO_DELIVER, "#D55D2A"), _obj4);
var ENUM_INVOICE_STATUS = {
    NOT: "Chưa xuất ho\xe1 đơn",
    REQUEST: "Đ\xe3 y\xeau cầu xuất ho\xe1 đơn",
    EXPORT: "Đ\xe3 xuất ho\xe1 đơn"
};
var ARR_STATUS_WARE_HOUSE = [
    "DRAFT",
    "CONFIRMED",
    "RESERVING",
    "WAIT_TO_PICK",
    "PICKING",
    "WAIT_TO_CHECK",
    "CHECKING",
    "WAIT_TO_PACK",
    "PACKING",
    "WAIT_TO_DELIVERY",
    "DELIVERING",
    "DELIVERED",
    "COMPLETED",
    "RETURN",
    "RETURNING",
    "RETURNED",
    "DAMAGE",
    "LOST",
    "CANCEL", 
];
var MONITORING_COLLECTOR_TYPE = {
    LOGIN: "LOGIN",
    SKU_DETAIL_VIEW: "SKU_DETAIL_VIEW",
    ADD_TO_CART: "ADD_TO_CART",
    REMOVE_FROM_CART: "REMOVE_FROM_CART",
    SKU_IMPRESSION: "SKU_IMPRESSION"
};
var THUOCSI_RECOMMENDATION = {
    SAME_CATEGORY: "SAME_CATEGORY",
    PURCHASE_TOGETHER: "PURCHASE_TOGETHER",
    ALL: "ALL"
};
var INSIDER_RECOMMENDATION = {
    MOST_VIEWED: "MOST_VIEWED",
    USER_BASED: "USER_BASED"
};
// export const ENUM_TRACKING_NAVBAR = {
//   GO_TO_PROMO_CODES_PAGE: 'GO_TO_PROMO_CODES_PAGE',
//   GO_TO_PRODUCTS_PAGE: 'GO_TO_PRODUCTS_PAGE',
//   GO_TO_QUICKORDER_PAGE: 'GO_TO_QUICKORDER_PAGE',
//   GO_TO_CAMPAIGN_PAGE: 'GO_TO_CAMPAIGN_PAGE',
//   GO_TO_SELLER_PAGE: ' GO_TO_SELLER_PAGE',
//   GO_TO_EVENTS_PAGE: ' GO_TO_EVENTS_PAGE',
// };
var ENUM_TRACKING_ACTION = Object.freeze({
    // page promo-codes
    PROMO_GO_TO_QUICK_ORDER: "CLICK_QUICK_ORDER_LINK_ON_PROMO_CODES_PAGE",
    PROMO_GO_TO_PRODUCTS: "CLICK_PRODUCTS_LINK_ON_PROMO_CODES_PAGE",
    PROMO_GO_TO_CART: "CLICK_CART_LINK_ON_PROMO_CODES_PAGE",
    PROMO_GO_TO_USERS_REFERRALS: "CLICK_REFERRALS_LINK_ON_PROMO_CODES_PAGE",
    PROMO_GO_TO_USERS_LOYALTY_POINTS: "CLICK_LOYALTY_POINTS_LINK_ON_PROMO_CODES_PAGE",
    PROMO_CLICK_INFO_VOUCHER: "CLICK_VIEW_VOUCHER_DETAIL_ON_PROMO_CODES_PAGE",
    PROMO_COPY_VOUCHER_CODE: "CLICK_COPY_VOUCHER_DETAIL_ON_PROMO_CODES_PAGE",
    PROMO_CLICK_APPLY_VOUCHER: "CLICK_APPLY_VOUCHER_DETAIL_ON_PROMO_CODES_PAGE",
    SCROLL_DOWN_FIRST_ON_PROMO_CODES_PAGE: "SCROLL_DOWN_FIRST_ON_PROMO_CODES_PAGE",
    // page cart
    CLICK_APPLY_VOUCHER_ON_CART_PAGE: "CLICK_APPLY_VOUCHER_ON_CART_PAGE",
    CLICK_VIEW_VOUCHER_CONDITION_ON_CART_PAGE: "CLICK_VIEW_VOUCHER_CONDITION_ON_CART_PAGE",
    CLICK_SEARCH_VOUCHER_ON_CART_PAGE: "CLICK_SEARCH_VOUCHER_ON_CART_PAGE",
    ON_CHANGE_SEARCH_VOUCHER_ON_CART_PAGE: "ON_CHANGE_SEARCH_VOUCHER_ON_CART_PAGE",
    CLICK_OPEN_VOUCHER_POPUP_ON_CART_PAGE: "CLICK_OPEN_VOUCHER_POPUP_ON_CART_PAGE",
    CLICK_GO_TO_CART_PAGE: "CLICK_GO_TO_CART_PAGE",
    CLICK_COPY_VOUCHER_ON_CART_PAGE: "CLICK_COPY_VOUCHER_ON_CART_PAGE",
    SCROLL_DOWN_FIRST_VOUCHER_POPUP_ON_CART_PAGE: "SCROLL_DOWN_FIRST_VOUCHER_POPUP_ON_CART_PAGE"
});
var ENUM_TRACKING_SOURCE = {
    QUICK_ORDER: "quick-order",
    PRODUCT_LIST: "product-list",
    PROMOTION: "promotion",
    SELLER_HOME: "seller-home",
    RECOMMENDATION: "recommendation",
    RECOMMENDATION_TS: "recommendation-ts",
    SAME_CATEGORY: "same-category",
    WISHLIST: "wishlist",
    VIEWED_LIST: "viewed-list",
    HOME: "home",
    PRODUCT_DETAIL: "product-detail"
};
var ENUM_COUNTDOWN_BAR_IMAGE_TYPE = {
    HALF: "HALF",
    FULL: "FULL"
};
var ENUM_COUNTDOWN_BAR_DISPLAY_PAGE = {
    HOME: "HOME",
    GUEST: "GUEST"
};
var MAP_BRAND_NAME = {
    vn: "thuocsi.vn",
    cam: "BuyMed",
    kh: "BuyMed",
    en: "BuyMed",
    th: "BuyMed"
};
var BRAND_NAME = MAP_BRAND_NAME["".concat(sysconfig__WEBPACK_IMPORTED_MODULE_0__/* .ENV_COUNTRY */ .ng)] || MAP_BRAND_NAME.en;
var BRAND_EMAIL_HELP = "support@buymed.co.th";
var BRAND_PHONE = sysconfig__WEBPACK_IMPORTED_MODULE_0__/* .HOTLINE */ .Y_;
var BRAND_PHONE_DISPLAY = sysconfig__WEBPACK_IMPORTED_MODULE_0__/* .HOTLINE_TEXT */ .GS;
var ENUMS_ERROR_MSG_CODE = {
    STATUS_INVALID: "Đ\xe3 c\xf3 lỗi xảy ra, xin vui l\xf2ng thử lại sau.",
    PROMOTION_NOT_FOUND: "M\xe3 khuyến m\xe3i kh\xf4ng tồn tại.",
    PROMOTION_INACTIVE: "M\xe3 khuyến m\xe3i chưa được k\xedch hoạt.",
    PROMOTION_TYPE_INVALID: "M\xe3 khuyến m\xe3i c\xf3 loại kh\xf4ng hợp lệ.",
    LOYALTY_FAILED: "Đ\xe3 xảy ra lỗi khi đổi điểm.",
    LOYALTY_INVALID: "Số điểm đổi phải nhỏ hơn 1000.",
    LOYALTY_NOT_FOUND: "Điểm đổi kh\xf4ng hợp lệ.",
    NOT_ENOUGH_POINTS: "Bạn kh\xf4ng c\xf3 đủ điểm để đổi m\xe3 giảm gi\xe1 n\xe0y.",
    TYPE_INVALID: "Đ\xe3 c\xf3 lỗi xảy ra, xin vui l\xf2ng thử lại sau."
};
var ENUMS_ERROR_ACC_CODE = {
    CUSTOMER_DELETED: "CUSTOMER_DELETED",
    CUSTOMER_BLOCK: "CUSTOMER_BLOCK",
    WRONG_PASSWORD: "WRONG_PASSWORD",
    NOT_FOUND: "NOT_FOUND",
    CUSTOMER_DELETED_NO_ORDER_60_DAYS: "CUSTOMER_DELETED_NO_ORDER_60_DAYS",
    CUSTOMER_DELETED_NO_ORDER_90_DAYS: "CUSTOMER_DELETED_NO_ORDER_90_DAYS",
    INACTIVE_ACCOUNT: "INACTIVE_ACCOUNT",
    LOGIN_FAILED: "LOGIN_FAILED",
    ACCOUNT_LOGIN_BLOCKED: "ACCOUNT_LOGIN_BLOCKED",
    "2FA_TOKEN_INVALID": "2FA_TOKEN_INVALID",
    NEED_VALIDATE_2FA: "NEED_VALIDATE_2FA",
    WRONG_TIMES_EXCEED_LIMIT: "WRONG_TIMES_EXCEED_LIMIT",
    NOT_FOUND_OTP: "NOT_FOUND_OTP",
    EXPIRED_OTP: "EXPIRED_OTP",
    TOO_MANY_OTP_REQUESTS: "TOO_MANY_OTP_REQUESTS"
};
var ENUMS_CHAT_SETTING_VALUE = {
    THUOCSI: "THUOCSI",
    OFF: "OFF",
    MESSENGER: "MESSENGER"
};
var UserType = {
    CUSTOMER: "CUSTOMER",
    GUEST: "GUEST",
    EMPLOYEE: "EMPLOYEE"
};
var ENUMS_FILTER_CATEGORY_TYPE = {
    EXTRA_CATEGORY: "EXTRA_CATEGORY",
    CATEGORY: "CATEGORY",
    MANUFACTURER: "MANUFACTURER"
};
var LANDING_PAGE_SECTIONS = {
    CAM: {
        FLASH_SALES: "FLASH_SALES",
        DEALS_OF_THE_DAY: "DEALS_OF_THE_DAY",
        PROMOTIONS: "PROMOTIONS",
        FOR_YOU: "FOR_YOU"
    },
    THAI: {
        FLASH_SALES: "FLASH_SALES",
        DEALS_OF_THE_DAY: "DEALS_OF_THE_DAY",
        PROMOTIONS: "PROMOTIONS",
        FOR_YOU: "FOR_YOU"
    }
};
var POPUP_SHARING_ITEM = {
    FACEBOOK: "FACEBOOK",
    ZALO: "ZALO",
    TELEGRAM: "TELEGRAM",
    LINKEDIN: "LINKEDIN",
    TWITTER: "TWITTER",
    VIBER: "VIBER",
    LINE: "LINE"
};
var ENUM_CONDITION_TYPE = {
    SHARE: "SHARE",
    DISCOVER: "DISCOVER"
};
var ENUMS_VOUCHER_ERROR_CODE = {
    NOT_FOUND: "NOT_FOUND",
    INACTIVE: "INACTIVE",
    NOT_START_YET: "NOT_START_YET",
    EXPIRED: "EXPIRED",
    NOT_ENOUGH_CONDITION: "NOT_ENOUGH_CONDITION",
    OUT_OF_STOCK: "OUT_OF_STOCK",
    CAN_NOT_USE: "CAN_NOT_USE",
    OUT_OF_USE: "OUT_OF_USE",
    NOT_SUPPORT_REGION: "NOT_SUPPORT_REGION",
    NOT_SUPPORT_LEVEL: "NOT_SUPPORT_LEVEL",
    NOT_SUPPORT_SCOPE: "NOT_SUPPORT_SCOPE",
    NOT_ENOUGH_ORDER_VALUE: "NOT_ENOUGH_ORDER_VALUE",
    NUMBER_OF_ORDER_EXCEED_LIMIT: "NUMBER_OF_ORDER_EXCEED_LIMIT",
    NOT_ENOUGH_NUMBER_OF_ORDER: "NOT_ENOUGH_NUMBER_OF_ORDER",
    INVALID_NUMBER_OF_ORDER: "INVALID_NUMBER_OF_ORDER",
    NOT_ENOUGH_NO_ORDER_TIME: "NOT_ENOUGH_NO_ORDER_TIME",
    INVALID_PRODUCT: "INVALID_PRODUCT",
    NOT_ENOUGH_PRODUCT_QUANTITY: "NOT_ENOUGH_PRODUCT_QUANTITY",
    NOT_ENOUGH_PRODUCT_AMOUNT: "NOT_ENOUGH_PRODUCT_AMOUNT",
    VOUCHER_CODE_INVALID: "VOUCHER_CODE_INVALID",
    CANNOT_APPLY_WITH_OTHERS: "CANNOT_APPLY_WITH_OTHERS",
    INVALID_APP_VERSION: "INVALID_APP_VERSION",
    NOT_ENOUGH_SKU_QUANTITY: "NOT_ENOUGH_SKU_QUANTITY"
};


/***/ }),

/***/ 83084:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L$": function() { return /* binding */ ERROR_PRODUCTS; },
/* harmony export */   "M5": function() { return /* binding */ ERROR_CODE_CART; }
/* harmony export */ });
// export const ERROR_CART = {
//   MAX_QUANTITY: 'Vượt quá số lượng đặt hàng cho phép',
//   NOT_ACTIVE_SKU: 'Sản phẩm tạm ngưng bán',
//   SUSPENDED_SKU: 'Sản phẩm đã ngưng bán',
//   OUT_OF_STOCK_SKU: 'Sản phẩm tạm hết hàng',
//   OUT_OF_STOCK: 'Sản phẩm tạm hết hàng',
//   CART_ITEM_INVALID: 'Sản phẩm không tìm thấy thông tin',
//   NOT_AVAILABLE_SKU: 'Sản phẩm chưa được hỗ trợ ở khu vực này',
//   NOT_FOUND_SKU: 'Sản phẩm không tìm thấy thông tin',
//   NOT_FOUND_PRICE_SKU: 'Sản phẩm không tìm thấy thông tin',
//   COMBO_INVALID: 'Khuyến mãi đã hết hạn',
//   TYPE_INVALID: 'Giỏ hàng có sự thay đổi sản phẩm, vui lòng kiểm tra lại',
//   QUANTITY_INVALID: 'Giỏ hàng có sự thay đổi về số lượng sản phẩm, vui lòng kiểm tra lại',
//   SKU_MISSING: 'Giỏ hàng có sự thay đổi về sản phẩm, vui lòng kiểm tra lại',
//   SKU_NOT_FOUND: 'Giỏ hàng có sự thay đổi về sản phẩm, vui lòng kiểm tra lại',
//   TOTAL_PRICE_NOT_MATCH: 'Giỏ hàng có sự thay đổi về giá sản phẩm, vui lòng kiểm tra lại',
//   PAYMENT_METHOD_NOT_MATCH: 'Giỏ hàng có sự thay đổi về phương thức thanh toán, vui lòng kiểm tra lại',
//   DELIVERY_METHOD_NOT_MATCH: 'Giỏ hàng có sự thay đổi về phương thức vận chuyển, vui lòng kiểm tra lại',
//   VOUCHER_NOT_MATCH: 'Giỏ hàng có sự thay đổi về mã giảm giá, vui lòng kiểm tra lại',
//   CUSTOMER_ORANGE_NOT_SUPPORT: 'Tài khoản của bạn không hỗ trợ thanh toán bằng tiền mặt khi nhận hàng',
//   VOUCHER_CODE_INVALID: 'Giá trị đơn hàng chưa đủ để áp dụng mã khuyến mãi!',
//   REQUIRED_CERTIFICATE: 'Bạn chưa đủ giấy phép để mua SP của nhà cung cấp này. Vui lòng chọn SP tương tự của NCC khác',
//   INVALID_NOT_YET_DEBT_DAY: 'Thời gian hợp đồng không hợp lệ, vui lòng kiểm tra lại',
//   INVALID_INSUFFICIENT_BALANCE: 'Số hạn mức khả dụng không đủ, vui lòng kiểm tra lại hạn mức hoặc thanh toán để tăng lại hạn mức.',
//   DEBT_CONTRACT_INACTIVE: 'Hợp đồng công nợ đang bị tắt',
//   INVALID_NEED_TO_PAY_ORDER_OVERDUE: 'Tài khoản quý khách có đơn hàng quá hạn thanh toán, vui lòng thanh toán để có thể tiếp tục đặt hàng.',
//   INVALID_NEED_TO_PAY_DEBT: 'Quý khách vui lòng thanh toán dư nợ để có thể tiếp tục đặt hàng.',
//   LIMIT_SKU: 'Vượt quá số lượng đặt hàng cho phép',
//   NOT_FOUND_PRICE_SKU_IN_COMBO: 'Combo không hợp lệ',
// };
var ERROR_CODE_CART = {
    MAX_QUANTITY: "MAX_QUANTITY",
    NOT_ACTIVE_SKU: "NOT_ACTIVE_SKU",
    SUSPENDED_SKU: "SUSPENDED_SKU",
    OUT_OF_STOCK_SKU: "OUT_OF_STOCK_SKU",
    OUT_OF_STOCK: "OUT_OF_STOCK",
    CART_ITEM_INVALID: "CART_ITEM_INVALID",
    NOT_AVAILABLE_SKU: "NOT_AVAILABLE_SKU",
    NOT_AVAILABLE_SCOPE: "NOT_AVAILABLE_SCOPE",
    NOT_FOUND_SKU: "NOT_FOUND_SKU",
    NOT_FOUND_PRICE_SKU: "NOT_FOUND_PRICE_SKU",
    COMBO_INVALID: "COMBO_INVALID",
    CHANGED_PRICE: "CHANGED_PRICE",
    TYPE_INVALID: "TYPE_INVALID",
    QUANTITY_INVALID: "QUANTITY_INVALID",
    SKU_MISSING: "SKU_MISSING",
    SKU_NOT_FOUND: "SKU_NOT_FOUND",
    TOTAL_PRICE_NOT_MATCH: "TOTAL_PRICE_NOT_MATCH",
    PAYMENT_METHOD_NOT_MATCH: "PAYMENT_METHOD_NOT_MATCH",
    DELIVERY_METHOD_NOT_MATCH: "DELIVERY_METHOD_NOT_MATCH",
    VOUCHER_NOT_MATCH: "VOUCHER_NOT_MATCH",
    CUSTOMER_ORANGE_NOT_SUPPORT: "CUSTOMER_ORANGE_NOT_SUPPORT",
    VOUCHER_CODE_INVALID: "VOUCHER_CODE_INVALID",
    REQUIRED_CERTIFICATE: "REQUIRED_CERTIFICATE",
    INVALID_NOT_YET_DEBT_DAY: "INVALID_NOT_YET_DEBT_DAY",
    INVALID_INSUFFICIENT_BALANCE: "INVALID_INSUFFICIENT_BALANCE",
    INVALID_PARSE_DATA: "INVALID_PARSE_DATA",
    REQUIRED_CUSTOMER_ID: "REQUIRED_CUSTOMER_ID",
    REQUIRED_ORDER_CODE: "REQUIRED_ORDER_CODE",
    REQUIRED_TYPE: "REQUIRED_TYPE",
    REQUIRED_TOTAL_ORDER_AMOUNT: "REQUIRED_TOTAL_ORDER_AMOUNT",
    DEBT_CONTRACT_INACTIVE: "DEBT_CONTRACT_INACTIVE",
    INVALID_NEED_TO_PAY_ORDER_OVERDUE: "INVALID_NEED_TO_PAY_ORDER_OVERDUE",
    INVALID_NEED_TO_PAY_DEBT: "INVALID_NEED_TO_PAY_DEBT",
    LIMIT_SKU: "LIMIT_SKU",
    NOT_FOUND_PRICE_SKU_IN_COMBO: "NOT_FOUND_PRICE_SKU_IN_COMBO",
    PROVINCE_NOT_MATCH: "PROVINCE_NOT_MATCH",
    EXCEED_INGREDIENT_LIMIT: "EXCEED_INGREDIENT_LIMIT",
    CART_INGREDIENT_INVALID: "CART_INGREDIENT_INVALID"
};
var ERROR_PRODUCTS = [
    ERROR_CODE_CART.MAX_QUANTITY,
    ERROR_CODE_CART.NOT_ACTIVE_SKU,
    ERROR_CODE_CART.SUSPENDED_SKU,
    ERROR_CODE_CART.OUT_OF_STOCK_SKU,
    ERROR_CODE_CART.OUT_OF_STOCK,
    ERROR_CODE_CART.CART_ITEM_INVALID,
    ERROR_CODE_CART.NOT_AVAILABLE_SKU,
    ERROR_CODE_CART.NOT_FOUND_SKU,
    ERROR_CODE_CART.NOT_FOUND_PRICE_SKU,
    ERROR_CODE_CART.REQUIRED_CERTIFICATE,
    ERROR_CODE_CART.PROVINCE_NOT_MATCH, 
];
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (ERROR_CODE_CART)));


/***/ }),

/***/ 44776:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Al": function() { return /* binding */ NEW_MISSING_IMAGE_CACHED; },
/* harmony export */   "ZO": function() { return /* binding */ VOUCHER_LOGO_DEFAULT; },
/* harmony export */   "ah": function() { return /* binding */ LOGO_MEDX_GG; },
/* harmony export */   "dV": function() { return /* binding */ LOGO_BUYMED_GG; },
/* harmony export */   "g8": function() { return /* binding */ STORE_IMAGE_DEFAULT_CACHED; },
/* harmony export */   "t9": function() { return /* binding */ CONDITIONS; },
/* harmony export */   "y9": function() { return /* binding */ GIFT_IMAGE_DEFAULT_CACHED; }
/* harmony export */ });
/* unused harmony export MISSING_IMAGE_CACHED */
/* harmony import */ var utils_ImageUtils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13744);
/* harmony import */ var _sysconfig__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66225);


// logo cũ
var MISSING_IMAGE_CACHED = "".concat(_sysconfig__WEBPACK_IMPORTED_MODULE_1__/* .GCS_IMAGE */ ._b, "/thuocsi-live/web/static/images/missing.png?size=200");
// apo-1409: logo mới
var NEW_MISSING_IMAGE_CACHED = (0,utils_ImageUtils__WEBPACK_IMPORTED_MODULE_0__/* .getLinkGCS */ .jA)(_sysconfig__WEBPACK_IMPORTED_MODULE_1__/* .NEW_MISSING_IMAGE */ .bp);
var STORE_IMAGE_DEFAULT_CACHED = "".concat(_sysconfig__WEBPACK_IMPORTED_MODULE_1__/* .GCS_IMAGE */ ._b, "/thuocsi-live/web/static/images/default_store.svg?size=origin");
var GIFT_IMAGE_DEFAULT_CACHED = "".concat(_sysconfig__WEBPACK_IMPORTED_MODULE_1__/* .GCS_IMAGE */ ._b, "/thuocsi-live/web/static/images/gift.jpeg?size=origin");
// logo buymed
// const mapLogoBuyMed = {
//   vn: `${PROXY_IMAGE}/thuocsi-live/web/static/images/logo_medx.png?size=origin`,
// }
// https://storage.googleapis.com/thuocsi-live/web/static/images/logo-buymed-th.png
// export const LOGO_BUYMED_GG = `${PROXY_IMAGE}/thuocsi-live/web/static/images/logo_buymed_th.svg`;
// https://storage.googleapis.com/thuocsi-live/web/static/images/logo-buymed-th.svg
// todo : multi
var LOGO_BUYMED_GG = "/static/images/buymed.svg";
var LOGO_MEDX_GG = _sysconfig__WEBPACK_IMPORTED_MODULE_1__/* .ENV_COUNTRY */ .ng === "vn" ? "".concat(_sysconfig__WEBPACK_IMPORTED_MODULE_1__/* .GCS_IMAGE */ ._b, "/thuocsi-live/web/static/images/logo_medx.png?size=origin") : LOGO_BUYMED_GG;
var CONDITIONS = "".concat(_sysconfig__WEBPACK_IMPORTED_MODULE_1__/* .GCS_IMAGE */ ._b, "/thuocsi-live/web/static/images/conditions-en.svg");
// ảnh mặc định của voucher khi promotion không cấu hình ảnh riêng
var VOUCHER_LOGO_DEFAULT = "/images/voucher/buymed-logo.png";
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
    MISSING_IMAGE_CACHED: MISSING_IMAGE_CACHED,
    GIFT_IMAGE_DEFAULT_CACHED: GIFT_IMAGE_DEFAULT_CACHED,
    STORE_IMAGE_DEFAULT_CACHED: STORE_IMAGE_DEFAULT_CACHED
});


/***/ }),

/***/ 13270:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$b5": function() { return /* binding */ WISHLIST_ICON_ACTIVE; },
/* harmony export */   "$bV": function() { return /* binding */ VOUCHER_TITLE; },
/* harmony export */   "$l0": function() { return /* binding */ VOUCHER_TS_PROMO; },
/* harmony export */   "$rc": function() { return /* binding */ PLATINUM_ICON_RANK; },
/* harmony export */   "AON": function() { return /* binding */ GIFT_IMAGE; },
/* harmony export */   "APs": function() { return /* binding */ URL_APPSTORE; },
/* harmony export */   "Ajr": function() { return /* binding */ MOBILE_ICON_RATING_STAR_NOT_FILL; },
/* harmony export */   "Asn": function() { return /* binding */ LUCKYWHEEL_BACKGROUND; },
/* harmony export */   "B1H": function() { return /* binding */ LUCKYWHEEL_MISSION_ICON; },
/* harmony export */   "B3N": function() { return /* binding */ TRUCK_ICON_WHITE; },
/* harmony export */   "CkC": function() { return /* binding */ MOBILE_ICON_RATING_STAR_FILL; },
/* harmony export */   "Cln": function() { return /* binding */ I_PROCESSING_V2; },
/* harmony export */   "CyI": function() { return /* binding */ AMBASSADOR_ICON_RANK; },
/* harmony export */   "DDT": function() { return /* binding */ LOYALTY_ARROW_VIEW_MORE; },
/* harmony export */   "DEp": function() { return /* binding */ QR_ICON_WHITE; },
/* harmony export */   "DQ9": function() { return /* binding */ TICKET_ICON_MOBILE; },
/* harmony export */   "Dmq": function() { return /* binding */ MOBILE_ICON_RATING_SUCCESS; },
/* harmony export */   "Dnl": function() { return /* binding */ GOLD_ICON_RANK_ACTIVE; },
/* harmony export */   "DoS": function() { return /* binding */ QUEST_REWARDS_ICON; },
/* harmony export */   "EnI": function() { return /* binding */ DELETEV2_ICON; },
/* harmony export */   "Erc": function() { return /* binding */ I_WAIT_TO_CONFIRM; },
/* harmony export */   "F3j": function() { return /* binding */ TIKTOK_ICON; },
/* harmony export */   "FTC": function() { return /* binding */ URL_SLIDER_8; },
/* harmony export */   "FTo": function() { return /* binding */ LOGO_PHARMACY; },
/* harmony export */   "FfZ": function() { return /* binding */ PROFILE_THAI; },
/* harmony export */   "FrZ": function() { return /* binding */ FACEBOOK_ICON; },
/* harmony export */   "GTU": function() { return /* binding */ LUCKYWHEEL_WEBVIEW_BACKGROUND; },
/* harmony export */   "GTX": function() { return /* binding */ STORE_ICON; },
/* harmony export */   "GXJ": function() { return /* binding */ URL_SLIDER_12; },
/* harmony export */   "Gbo": function() { return /* binding */ TICKET_ICON; },
/* harmony export */   "H1y": function() { return /* binding */ VIEWED_ICON_ACTIVE; },
/* harmony export */   "H6R": function() { return /* binding */ URL_SLIDER_11; },
/* harmony export */   "Hsp": function() { return /* binding */ LUCKYWHEEL_MOBILE_MISSION_ICON; },
/* harmony export */   "I7K": function() { return /* binding */ STATISTICAL_ICON_ACTIVE; },
/* harmony export */   "IfW": function() { return /* binding */ GIFT_ICON2; },
/* harmony export */   "J$v": function() { return /* binding */ BRAND_LOGO_WHITE_SVG; },
/* harmony export */   "J7Q": function() { return /* binding */ LUCKYWHEEL_SHARE_ICON; },
/* harmony export */   "Jix": function() { return /* binding */ POINTS_ICON_WHITE; },
/* harmony export */   "JyL": function() { return /* binding */ CART_VOUCHER_CHECKED_ICON; },
/* harmony export */   "KLt": function() { return /* binding */ LOGO_FOOTER_LOCATION; },
/* harmony export */   "KVA": function() { return /* binding */ MAIL_ICON; },
/* harmony export */   "KsP": function() { return /* binding */ URL_NEW_LOGO; },
/* harmony export */   "L7K": function() { return /* binding */ VIEWED_ICON_WHITE; },
/* harmony export */   "Lv1": function() { return /* binding */ TimeOrderStatus; },
/* harmony export */   "Mts": function() { return /* binding */ BRAND_LOGO_NEW_SVG; },
/* harmony export */   "N4V": function() { return /* binding */ ORDER_ICON_MENU; },
/* harmony export */   "NdN": function() { return /* binding */ PROFILE_ENGLISH; },
/* harmony export */   "NlY": function() { return /* binding */ URL_SLIDER_9; },
/* harmony export */   "O$W": function() { return /* binding */ VIEWED_ICON; },
/* harmony export */   "O4y": function() { return /* binding */ LOGOUT_ICON; },
/* harmony export */   "O7y": function() { return /* binding */ I_EDIT_ORDER_V2; },
/* harmony export */   "OEc": function() { return /* binding */ REFER_FRIEND_ICON_WHITE; },
/* harmony export */   "OZM": function() { return /* binding */ LUCKYWHEEL_BLOCKED_ICON; },
/* harmony export */   "OaF": function() { return /* binding */ I_WISHLIST_DEL; },
/* harmony export */   "Olk": function() { return /* binding */ MEDIA_VIDEO_TH_4; },
/* harmony export */   "P0s": function() { return /* binding */ BILL_ICON_ACTIVE; },
/* harmony export */   "PKp": function() { return /* binding */ I_COMPLETED; },
/* harmony export */   "P_R": function() { return /* binding */ EDIT_INVOICE; },
/* harmony export */   "PfJ": function() { return /* binding */ AMBASSADOR_ICON_RANK_ACTIVE; },
/* harmony export */   "PwU": function() { return /* binding */ TICKET_PROMO_ICON; },
/* harmony export */   "PwW": function() { return /* binding */ LOGO_FOOTER_CONTACT; },
/* harmony export */   "PzX": function() { return /* binding */ LUCKYWHEEL_ARROW_SELECTOR; },
/* harmony export */   "QQr": function() { return /* binding */ CALL_ICON; },
/* harmony export */   "R7l": function() { return /* binding */ LINK_GOOGLEPLAY; },
/* harmony export */   "RXq": function() { return /* binding */ SUPPORT_ICON; },
/* harmony export */   "RoF": function() { return /* binding */ SEARCHV2_ICON; },
/* harmony export */   "Rvt": function() { return /* binding */ QUEST_REWARDS_ICON_WHITE; },
/* harmony export */   "SLh": function() { return /* binding */ BILL_ICON; },
/* harmony export */   "SfJ": function() { return /* binding */ GIFT_ICON; },
/* harmony export */   "SlS": function() { return /* binding */ LOGO_THUOCSI_SHORTENED; },
/* harmony export */   "Smv": function() { return /* binding */ VOUCHER_TITLE_DETAIL; },
/* harmony export */   "T2Q": function() { return /* binding */ SAME_STORE; },
/* harmony export */   "T32": function() { return /* binding */ AHAMOVE; },
/* harmony export */   "TRy": function() { return /* binding */ URL_LOGO_SEEDSTAR; },
/* harmony export */   "TSM": function() { return /* binding */ NINJAVAN; },
/* harmony export */   "TjD": function() { return /* binding */ DIAMOND_ICON; },
/* harmony export */   "Tng": function() { return /* binding */ LUCKYWHEEL_BORDER; },
/* harmony export */   "Tr7": function() { return /* binding */ URL_LOGO_E27; },
/* harmony export */   "Tzo": function() { return /* binding */ I_CONFIRMED; },
/* harmony export */   "UCA": function() { return /* binding */ USER_ICON_ACTIVE; },
/* harmony export */   "UPS": function() { return /* binding */ FEEDBACK_ICON_WHITE; },
/* harmony export */   "UU2": function() { return /* binding */ AVATARV2_ICON_IMAGE; },
/* harmony export */   "U_B": function() { return /* binding */ URL_SLIDER_4; },
/* harmony export */   "Ucv": function() { return /* binding */ GHTK; },
/* harmony export */   "UeK": function() { return /* binding */ LUCKYWHEEL_BORDER_WITH_CENTER; },
/* harmony export */   "UgS": function() { return /* binding */ PLATINUM_ICON; },
/* harmony export */   "VBB": function() { return /* binding */ URL_SLIDER_10; },
/* harmony export */   "VHI": function() { return /* binding */ ICON_404_PHONE; },
/* harmony export */   "VTu": function() { return /* binding */ CART_VOUCHER_CHECKBOX_ICON; },
/* harmony export */   "VV": function() { return /* binding */ URL_LOGO_VNEXPRESS; },
/* harmony export */   "Vf$": function() { return /* binding */ SLIVER_ICON_RANK_ACTIVE; },
/* harmony export */   "VtR": function() { return /* binding */ PHONEFRAME; },
/* harmony export */   "Vzf": function() { return /* binding */ HANG_DIEM_ICON; },
/* harmony export */   "W0F": function() { return /* binding */ VOUCHER_ICON_WHITE; },
/* harmony export */   "W3N": function() { return /* binding */ QR_ICON; },
/* harmony export */   "WIB": function() { return /* binding */ URL_SLIDER_2; },
/* harmony export */   "WLR": function() { return /* binding */ LUCKYWHEEL_TITLE; },
/* harmony export */   "X4$": function() { return /* binding */ GHN; },
/* harmony export */   "X9M": function() { return /* binding */ LUCKYWHEEL_MOBILE_CLOSE_BUTTON; },
/* harmony export */   "XDS": function() { return /* binding */ STORE_IMAGE_DEFAULT; },
/* harmony export */   "YA3": function() { return /* binding */ FLASH_SALE_ICON; },
/* harmony export */   "YFh": function() { return /* binding */ USER_ICON; },
/* harmony export */   "Yib": function() { return /* binding */ URL_LOGO_BAOTIENPHONG; },
/* harmony export */   "YnC": function() { return /* binding */ DIAMOND_ICON_RANK; },
/* harmony export */   "Z$c": function() { return /* binding */ WISHLIST_ICON_WHITE; },
/* harmony export */   "Z9d": function() { return /* binding */ MEDIA_VIDEO_TH_1; },
/* harmony export */   "ZL$": function() { return /* binding */ ADD_FILE_ICON; },
/* harmony export */   "ZZT": function() { return /* binding */ MOBILE_STORE_ICON; },
/* harmony export */   "Zcn": function() { return /* binding */ SECTION_STORE_ICON; },
/* harmony export */   "ZgI": function() { return /* binding */ LOGOUT_ICON_WHITE; },
/* harmony export */   "_6M": function() { return /* binding */ URL_LOGO_24H; },
/* harmony export */   "_kC": function() { return /* binding */ STATISTICAL_ICON; },
/* harmony export */   "_nW": function() { return /* binding */ REFER_FRIEND_ICON; },
/* harmony export */   "a1U": function() { return /* binding */ DELETE_VOUCHER_ICON; },
/* harmony export */   "aGC": function() { return /* binding */ LOGO_NOT_MATCH_CONDITIONS; },
/* harmony export */   "agI": function() { return /* binding */ URL_SLIDER_7; },
/* harmony export */   "bB1": function() { return /* binding */ STATISTICAL_ICON_WHITE; },
/* harmony export */   "cJE": function() { return /* binding */ IMAGE_404; },
/* harmony export */   "cau": function() { return /* binding */ SAME_INGREDIENT; },
/* harmony export */   "cfK": function() { return /* binding */ SLIVER_ICON_RANK; },
/* harmony export */   "cvC": function() { return /* binding */ I_DELIVERING; },
/* harmony export */   "czL": function() { return /* binding */ GRAB; },
/* harmony export */   "dC0": function() { return /* binding */ ICON_404_MAIL; },
/* harmony export */   "dUG": function() { return /* binding */ PRODUCT_ICON; },
/* harmony export */   "dXV": function() { return /* binding */ VIETTELPOST; },
/* harmony export */   "dd6": function() { return /* binding */ FEEDBACK_ICON; },
/* harmony export */   "eC1": function() { return /* binding */ SEARCHV2ACTIVE_ICON; },
/* harmony export */   "eFM": function() { return /* binding */ LUCKYWHEEL_MOBILE_SPIN_TEXT; },
/* harmony export */   "eXc": function() { return /* binding */ LUCKYWHEEL_MOBILE_GUILDLINE_ICON; },
/* harmony export */   "e_e": function() { return /* binding */ LOGO_THUOCSI; },
/* harmony export */   "ekk": function() { return /* binding */ I_FILE_CHECKED; },
/* harmony export */   "fGn": function() { return /* binding */ I_EXIT; },
/* harmony export */   "fPw": function() { return /* binding */ WISHLIST_ICON_4; },
/* harmony export */   "fRq": function() { return /* binding */ REFER_FRIEND_ICON_ACTIVE; },
/* harmony export */   "fXx": function() { return /* binding */ ORDER_ICON_MENU_WHITE; },
/* harmony export */   "fcB": function() { return /* binding */ VOUHCER_PROMOTION_BOX; },
/* harmony export */   "flC": function() { return /* binding */ I_FEEDBACK_DETAILV2; },
/* harmony export */   "gEK": function() { return /* binding */ USER_ICON_WHITE; },
/* harmony export */   "gXP": function() { return /* binding */ LUCKYWHEEL_MOBILE_BACKGROUND; },
/* harmony export */   "g_W": function() { return /* binding */ MISSING_IMAGE; },
/* harmony export */   "gxg": function() { return /* binding */ LUCKYWHEEL_CENTER; },
/* harmony export */   "h3X": function() { return /* binding */ QR_ICON_ACTIVE; },
/* harmony export */   "hT8": function() { return /* binding */ LUCKWHEEL_ICON_WARNING; },
/* harmony export */   "hTC": function() { return /* binding */ URL_SLIDER_6; },
/* harmony export */   "har": function() { return /* binding */ THAI_ORDER_SUCCESS_THANKYOU; },
/* harmony export */   "hnG": function() { return /* binding */ LUCKYWHEEL_TIME_ICON; },
/* harmony export */   "iMk": function() { return /* binding */ GOLD_ICON; },
/* harmony export */   "iXA": function() { return /* binding */ LINK_DOWNLOAD_AUTO_DETECT; },
/* harmony export */   "iiu": function() { return /* binding */ GOOGLEPLAY; },
/* harmony export */   "ik2": function() { return /* binding */ URL_LICENSE; },
/* harmony export */   "ilf": function() { return /* binding */ URL_LOGO_NTTDATA; },
/* harmony export */   "iuj": function() { return /* binding */ CARTV2_ICON; },
/* harmony export */   "jDq": function() { return /* binding */ BRAND_LOGO_SVG; },
/* harmony export */   "jkw": function() { return /* binding */ DIAMOND_ICON_RANK_ACTIVE; },
/* harmony export */   "jp6": function() { return /* binding */ GOLD_ICON_RANK; },
/* harmony export */   "kUI": function() { return /* binding */ VOUCHER_FRAME_MIN; },
/* harmony export */   "kvq": function() { return /* binding */ WISHLIST_ICON_1; },
/* harmony export */   "lNb": function() { return /* binding */ I_TRANSPORTING; },
/* harmony export */   "leF": function() { return /* binding */ LUCKYWHEEL_MOBILE_OOT_TEXT; },
/* harmony export */   "mbK": function() { return /* binding */ SILVER_ICON; },
/* harmony export */   "nHV": function() { return /* binding */ FEEDBACK_ICON_ACTIVE; },
/* harmony export */   "nwo": function() { return /* binding */ MEDIA_VIDEO_TH_3; },
/* harmony export */   "o1X": function() { return /* binding */ BLOCK_ACCOUNT; },
/* harmony export */   "oCr": function() { return /* binding */ VOUCHER_ICON; },
/* harmony export */   "out": function() { return /* binding */ MEGA_SALE_ICON; },
/* harmony export */   "owv": function() { return /* binding */ MEDIA_VIDEO_TH_2; },
/* harmony export */   "p9V": function() { return /* binding */ PLATINUM_ICON_RANK_ACTIVE; },
/* harmony export */   "pHD": function() { return /* binding */ QUEST_REWARDS_ICON_ACTIVE; },
/* harmony export */   "q7F": function() { return /* binding */ LUCKYWHEEL_MOBILE_POPUP_MISSION_BG; },
/* harmony export */   "qRP": function() { return /* binding */ URL_SLIDER_3; },
/* harmony export */   "rQw": function() { return /* binding */ CART_NEW_GIFT_ICON; },
/* harmony export */   "rqz": function() { return /* binding */ LINKED_ICON; },
/* harmony export */   "ruX": function() { return /* binding */ URL_SLIDER_5; },
/* harmony export */   "sy$": function() { return /* binding */ LOGO_FOOTER_REGISTER; },
/* harmony export */   "t0e": function() { return /* binding */ MEDIA_VIDEO_TH_5; },
/* harmony export */   "tJs": function() { return /* binding */ POINTS_ICON_ACTIVE; },
/* harmony export */   "tKN": function() { return /* binding */ VOUCHER_ICON_ACTIVE; },
/* harmony export */   "tYN": function() { return /* binding */ LUCKYWHEEL_MOBILE_HISTORY_ICON; },
/* harmony export */   "u2W": function() { return /* binding */ URL_LOGO_ECHELON; },
/* harmony export */   "uVr": function() { return /* binding */ DOUBLE_ARROW_ICON; },
/* harmony export */   "uf0": function() { return /* binding */ LUCKYWHEEL_GUILDLINE_ICON; },
/* harmony export */   "uxj": function() { return /* binding */ DELIVERY_FROM; },
/* harmony export */   "v2s": function() { return /* binding */ POINTS_ICON; },
/* harmony export */   "vGY": function() { return /* binding */ MOBILE_ICON_ATTACH_FILE; },
/* harmony export */   "vak": function() { return /* binding */ DELIVERY_APOLOGIZE; },
/* harmony export */   "wEw": function() { return /* binding */ VOUCHER_TS_MIN; },
/* harmony export */   "wKJ": function() { return /* binding */ AVATARV2_ICON; },
/* harmony export */   "wMq": function() { return /* binding */ I_DELIVERED; },
/* harmony export */   "wN4": function() { return /* binding */ LINK_REGISTER; },
/* harmony export */   "weE": function() { return /* binding */ ZALO_ICON; },
/* harmony export */   "wes": function() { return /* binding */ URL_LOGO_CAFEBIZ; },
/* harmony export */   "wfH": function() { return /* binding */ I_RETURN_ORDER_DETAILV2; },
/* harmony export */   "wtK": function() { return /* binding */ WISHLIST_ICON; },
/* harmony export */   "xAG": function() { return /* binding */ LINK_APPLESTORE; },
/* harmony export */   "xJQ": function() { return /* binding */ ICON_FEEDBACK_ORDER; },
/* harmony export */   "xrP": function() { return /* binding */ FEEDBACKSTATUS_ICON; },
/* harmony export */   "y6j": function() { return /* binding */ ORDER_ICON_MENU_ACTIVE; },
/* harmony export */   "yU": function() { return /* binding */ MOBILE_ICON_RATING_STAR; },
/* harmony export */   "za4": function() { return /* binding */ NOTICEV2_ICON; },
/* harmony export */   "zyx": function() { return /* binding */ UP_INVOICE; }
/* harmony export */ });
/* unused harmony exports LOGO_3_TOT, SANPHAMMOI_ICON, LIKE_ICON_GREEN, DEALS_ICON, KG_ICON, KG_ICON_V2, EYE_ICON, SHOPPING_CART_ICON, APPSTORE, NEWSV2_ICON, CAREERV2_ICON, HOMEV2_ICON, LOGO_FOOTER_SVG, LOGO_GHTK, LOGO_AHAMOVE, LOGO_GRAB, LOGO_GHN, LOGO_LOZA, LOGO_NINJA, LOGO_MOBILE, LOGO_GOOGLEPLAY, LOGO_APPSTORE, LOGO_APPSTORE_NEW, LOGO_FACEBOOK_NEW, LOGO_GOOGLEPLAY_NEW, DOMAIN_GOOGLE_PLAY, DOMAIN_STORAGE, FEEDBACKTS_LOGO, FEEDBACKUSER_ICON, PHAN_HOI_ICON, LEVEL_ICON, LEVEL_ICON_ACTIVE, LEVEL_ICON_WHITE, ReturnOrderIcon, NEW_LOGO, LOGO_THUOCSI_404, ICON_ARROW_ORDER, ICON_ARROW_ORDER_ACTIVE, VOUCHER_TITLE_GREEN, ReAddToCartV2, EditDetailV2, I_ARROW_RIGHT_DETAILV2, MOBILE_ICON_ALERT_SUCCESS, GIFT_NEW_GREEN, ORDER_SUCCESS_THANKYOU, CAMBODIAN_ORDER_SUCCESS_THANKYOU, ORDER_SUCCESS_THANKYOU_MAP, ICON_KHUNG_LONG, HOME_BG_MEGA_SALE, HOME_ICON_MEGA_SALE, PROFILE_CHANGE_LANGUAGE, MEDIA_TH_1, MEDIA_TH_2, MEDIA_TH_3, MEDIA_TH_4, MEDIA_TH_5, MEDIA_TH_6, MEDIA_TH_7, MEDIA_TH_8, MEDIA_TH_9, MEDIA_TH_10, MEDIA_TH_11, MEDIA_TH_M_1, MEDIA_TH_M_2, MEDIA_TH_M_3, MEDIA_TH_M_4, MEDIA_TH_M_5, MEDIA_TH_M_6, MEDIA_TH_M_7, MEDIA_TH_M_8, MEDIA_TH_M_9, MEDIA_TH_M_10, MEDIA_TH_M_11, LUCKYWHEEL_TOP_SPIN_BUTTON, LUCKYWHEEL_BOTTOM_SPIN_BUTTON, LUCKYWHEEL_MOBILE_TAB_BACKGROUND, LUCKYWHEEL_MOBILE_PRIZE_BG, LUCKYWHEEL_DEFAULT_BACKGROUND, LUCKYWHEEL_SHARE_FACEBOOK_ICON, LUCKYWHEEL_SHARE_ZALO_ICON */
/* harmony import */ var sysconfig__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66225);
/* harmony import */ var _default__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44776);


// slider
// export const URL_SLIDER_1 = '/images/media/logo_tccs.png'; // deprecated 22Feb2023 - Dinh Tran
var URL_SLIDER_2 = "/images/partner/logo_domesco.jpg";
var URL_SLIDER_3 = "/images/partner/logo_gsk.jpg";
var URL_SLIDER_4 = "/images/partner/logo_imex.jpg";
var URL_SLIDER_5 = "/images/partner/logo_mp.jpg";
var URL_SLIDER_6 = "/images/partner/logo_nic.jpg";
var URL_SLIDER_7 = "/images/partner/logo_pharmedic.jpg";
var URL_SLIDER_8 = "/images/partner/logo_sanofi_8-8-2022.png";
var URL_SLIDER_9 = "/images/partner/logo_stada.jpg";
var URL_SLIDER_10 = "/images/partner/logo_usp.jpg";
var URL_SLIDER_11 = "/images/partner/logo_vpc.jpg";
var URL_SLIDER_12 = "/images/partner/logo_davipharm.png";
// image media
var URL_LOGO_SEEDSTAR = "/images/media/logo_seedstar.png";
// export const URL_LOGO_TCCS = '/images/media/logo_tccs.png'; // deprecated 22Feb2023 - Dinh Tran
// export const URL_LOGO_PITCHPALACE = '/images/media/logo_pitchpalace.png'; // deprecated 22Feb2023 - Dinh Tran
var URL_LOGO_NTTDATA = "/images/media/logo_nttdata.png";
var URL_LOGO_ECHELON = "/images/media/logo_echelon.png";
// export const URL_LOGO_INVESTGLOBAL = '/images/media/logo_investglobal.png'; // deprecated 22Feb2023 - Dinh Tran
// export const URL_LOGO_FORBES = '/images/media/logo_forbes.png'; // deprecated 22Feb2023 - Dinh Tran
var URL_LOGO_E27 = "/images/media/logo_e27.png";
// import media 16Aug2022
var URL_LOGO_24H = "/images/media/logo_24h.jpg";
var URL_LOGO_BAOTIENPHONG = "/images/media/logo_baotienphong.jpg";
var URL_LOGO_CAFEBIZ = "/images/media/logo_cafebiz.png";
var URL_LOGO_VNEXPRESS = "/images/media/logo_vnexpress.jpg";
var MAP_BRAND_LOGO = {
    vn: "/images/logo/brand-logo.svg",
    cam: "/static/images/buymed.svg",
    en: "/static/images/buymed.svg",
    th: "/static/images/buymed.svg"
};
var MAP_BRAND_LOGO_WHITE = {
    vn: "/images/logo/brand-logo.svg",
    cam: "/static/images/buymed_white.svg",
    en: "/static/images/buymed_white.svg",
    th: "/static/images/buymed_white.svg"
};
var BRAND_LOGO_SVG = MAP_BRAND_LOGO["".concat(sysconfig__WEBPACK_IMPORTED_MODULE_0__/* .ENV_COUNTRY */ .ng)] || "/images/logo/brand-logo.svg";
var BRAND_LOGO_WHITE_SVG = MAP_BRAND_LOGO_WHITE["".concat(sysconfig__WEBPACK_IMPORTED_MODULE_0__/* .ENV_COUNTRY */ .ng)] || "/images/logo/brand-logo.svg";
var BRAND_LOGO_NEW_SVG = "/images/logo/brand-logo-new.svg";
var LOGO_FOOTER_CONTACT = "/static/images/footer/contact.svg";
var LOGO_FOOTER_LOCATION = "/static/images/footer/location.svg";
var LOGO_3_TOT = "/icons/3_tot.png";
var SANPHAMMOI_ICON = "/icons/sanphammoi.png";
// export const LIKE_ICON = '/icons/like.png'; // deprecated 22Feb2023 - Dinh Tran
var DOUBLE_ARROW_ICON = "/icons/double_arrow.svg";
var LIKE_ICON_GREEN = "/icons/like_green.png";
var DEALS_ICON = "/icons/deals.png";
var TICKET_PROMO_ICON = "/icons/ticket_promo.svg";
var TICKET_ICON = "/icons/ticket_icon.svg";
var TICKET_ICON_MOBILE = "/icons/ticket_icon_mobile.svg";
// export const ROSE_ICON = '/icons/rose_icon.svg'; // deprecated 22Feb2023 - Dinh Tran
var PRODUCT_ICON = "/icons/product_icon.png";
var ADD_FILE_ICON = "/images/icon/add_file.png";
var KG_ICON = "/images/icon/kg.svg";
var KG_ICON_V2 = "/images/icon/kg_v2.svg";
// export const TROLLEY_ICON = '/images/icon/trolley.svg'; // deprecated 22Feb2023 - Dinh Tran
// export const VIEW_ICON = '/images/icon/view.svg'; // deprecated 22Feb2023 - Dinh Tran
// export const PERSON_ICON = '/icons/person.png'; // deprecated 22Feb2023 - Dinh Tran
// export const PACKAGE_ICON = '/icons/package.png'; // deprecated 22Feb2023 - Dinh Tran
// export const CART_ICON = '/images/icon/cart_icon.png';
var EYE_ICON = "/images/icon/eye.svg";
var SHOPPING_CART_ICON = "/images/icon/shopping-cart.svg";
// export const WISHLIST_ICON_1 = I_WISHLIST_ICON_1;
// export const WISHLIST_ICON_2 = I_WISHLIST_ICON_2;
// export const WISHLIST_ICON_3 = I_WISHLIST_ICON_3;
// export const WISHLIST_ICON_4 = I_WISHLIST_ICON_4;
var WISHLIST_ICON_1 = "/icons/wishlist_icon_1.svg";
// export const WISHLIST_ICON_2 = '/icons/wishlist_icon_2.svg';
// export const WISHLIST_ICON_3 = '/icons/wishlist_icon_3.svg';
var WISHLIST_ICON_4 = "/icons/wishlist_icon_4.svg";
// OTHER
var LOGO_THUOCSI = "/logo_ts.png";
var LOGO_THUOCSI_SHORTENED = "/thuocsi_short.svg";
// export const FAVICON_DEFAULT = '/images/favicon.ico';
// export const MISSING_IMAGE = DEFAULT_MISSING_IMAGE;
var MISSING_IMAGE = _default__WEBPACK_IMPORTED_MODULE_1__/* .NEW_MISSING_IMAGE_CACHED */ .Al;
var GIFT_IMAGE = _default__WEBPACK_IMPORTED_MODULE_1__/* .GIFT_IMAGE_DEFAULT_CACHED */ .y9;
var LOGO_NOT_MATCH_CONDITIONS = "/images/chua_thoa_dk.svg";
var GIFT_ICON = "/images/gift.svg";
var STORE_ICON = "/images/deals/store.svg";
// export const FAST_DELIVERY_ICON = '/images/deals/fast-delivery.svg';
var MOBILE_STORE_ICON = "/images/deals/mobile_store.svg";
// Khuyen mai
var MEGA_SALE_ICON = "/images/deals/mega_sale.svg";
var FLASH_SALE_ICON = "/images/deals/flash_sale.svg";
// FOOTER_V2
var CALL_ICON = "/images/footer-v2/Contact/call.svg";
// export const FB_ICON = '/images/footer-v2/Contact/fbicon.svg';
var SUPPORT_ICON = "/images/footer-v2/Contact/support.svg";
var APPSTORE = "/images/footer-v2/Download/appstore.svg";
var URL_APPSTORE = "/images/footer-v2/Download/appstore.svg";
var GOOGLEPLAY = "/images/footer-v2/Download/googleplay.svg";
var AHAMOVE = "/images/footer-v2/ShipService/ahamove.png";
var GHN = "/images/footer-v2/ShipService/ghn.png";
var GHTK = "/images/footer-v2/ShipService/ghtk.png";
var GRAB = "/images/footer-v2/ShipService/grab.png";
var NINJAVAN = "/images/footer-v2/ShipService/ninjavan.png";
var VIETTELPOST = "/images/footer-v2/ShipService/viettelpost.png";
var PHONEFRAME = "/images/footer-v2/phoneFrame.svg";
var FACEBOOK_ICON = "/images/footer-v2/Connect/facebook_icon.svg";
var LINKED_ICON = "/images/footer-v2/Connect/linked_icon.svg";
var TIKTOK_ICON = "/images/footer-v2/Connect/tiktok_icon.svg";
var ZALO_ICON = "/images/footer-v2/Connect/zalo_icon.svg";
// export const LICENSE = '/images/footer-v2/license.png';
var URL_LICENSE = "/images/footer/logo_register.png";
// export const URL_LICENSE_TRANSPARENT = '/images/footer-v2/license.png';
// slider
// export const SLIDER_1 = I_SLIDER_1;
// export const SLIDER_2 = I_SLIDER_2;
// export const SLIDER_3 = I_SLIDER_3;
// export const SLIDER_4 = I_SLIDER_4;
// export const SLIDER_5 = I_SLIDER_5;
// export const SLIDER_6 = I_SLIDER_6;
// export const SLIDER_7 = I_SLIDER_7;
// export const SLIDER_8 = I_SLIDER_8;
// export const SLIDER_9 = I_SLIDER_9;
// export const SLIDER_10 = I_SLIDER_10;
// export const SLIDER_11 = I_SLIDER_11;
// end slider
var NOTICEV2_ICON = "/images/header-v2/Notice_icon.svg";
var AVATARV2_ICON_IMAGE = "/images/header-v2/UserAvatar_icon.svg";
var AVATARV2_ICON = "/images/header-v2/UserAvatar_icon.svg";
var NEWSV2_ICON = "/images/header-v2/New_icon.svg";
var CAREERV2_ICON = "/images/header-v2/Career_icon.svg";
var HOMEV2_ICON = "/images/header-v2/Home_icon.svg";
var SEARCHV2_ICON = "/images/header-v2/Search_icon.svg";
var SEARCHV2ACTIVE_ICON = "/images/header-v2/SearchActive_icon.svg";
// FOOTER
var LOGO_FOOTER_SVG = "/images/footer/logo_footer.svg";
// export const LOGO_FOOTER_NEW_PNG = '/images/logo_thuocsi_new.png';
var LOGO_FOOTER_REGISTER = "/images/footer/logo_register2.png";
var LOGO_GHTK = "/images/footer/logo_ghtk.png";
var LOGO_AHAMOVE = "/images/footer/logo_ahamove.png";
var LOGO_GRAB = "/images/footer/logo_grab.png";
var LOGO_GHN = "/images/footer/logo_ghn.png";
var LOGO_LOZA = "/images/footer/logo_loza.png";
var LOGO_NINJA = "/images/footer/logo_ninja.png";
var LOGO_MOBILE = "/images/footer/img_mobileapp.png";
var LOGO_GOOGLEPLAY = "/images/footer/logo_googleplay.png";
var LOGO_APPSTORE = "/images/footer/logo_appstore.png";
var LOGO_APPSTORE_NEW = "/images/footer/logo_appstore_new.png";
var LOGO_FACEBOOK_NEW = "/images/footer/logo_fb_new.png";
var LOGO_GOOGLEPLAY_NEW = "/images/footer/logo_chplay_new.png";
var LINK_REGISTER = "http://online.gov.vn/Home/WebDetails/52192";
var LINK_APPLESTORE = "https://apps.apple.com/us/app/buymed-thailand/id6450183967";
var DOMAIN_GOOGLE_PLAY = "https://play.google.com";
var LINK_GOOGLEPLAY = "".concat(DOMAIN_GOOGLE_PLAY, "/store/apps/details?id=com.buymed.app.th");
var DOMAIN_STORAGE = "https://buymed-storage.s3-ap-southeast-1.amazonaws.com";
var LINK_DOWNLOAD_AUTO_DETECT = "https://buymed.co.th/app";
// export const LINK_LICENSE = `${DOMAIN_STORAGE}/trading_license/1.+Trading+License+-+Buymed+(GC+20+June+2019)+(VN).pdf`;
// promotion
// New version 2
// export const CARTV2_ICON = '/images/header-v2/Cart_icon.svg';
var CARTV2_ICON = "/images/header-v2/Cartv2_icon.svg";
var DELETEV2_ICON = "/images/iconV2/deleteIcon.svg";
// Level Icon
var DIAMOND_ICON = "/images/icons/diamond.svg";
var GOLD_ICON = "/images/icons/gold.svg";
var PLATINUM_ICON = "/images/icons/platinum.svg";
var SILVER_ICON = "/images/icons/silver.svg";
// export const GIFT_IMAGE =
//   'https://assets.thuocsi.vn/assets/defaults/qua_tang-d6b9623d40a9924ac56d42815f5ed983f93ef06a88ec91c36261bb3bbb222553.jpg';
var LOGO_PHARMACY = "/images/default/pharmacy.svg";
// seller
// export const BADGE_SELLER = '/images/default/badge.png';
var STORE_IMAGE_DEFAULT = _default__WEBPACK_IMPORTED_MODULE_1__/* .STORE_IMAGE_DEFAULT_CACHED */ .g8;
// productV2
// export const TAGNEWPRODUCT = '/images/iconV2/tagNew_product.svg';
// export const DEFAULTPRODUCT = '/images/iconV2/defaultProduct.svg';
// feedback product detail
var FEEDBACKSTATUS_ICON = "/images/feedbackDetail/statusFeedback.svg";
var FEEDBACKTS_LOGO = "/images/feedbackDetail/logoThuocsi.png";
var FEEDBACKUSER_ICON = "/images/feedbackDetail/userFeedback.png";
var PHAN_HOI_ICON = "/images/icon_phan_hoi.svg";
// qr code
// export const DEFAULT_PRODUCT_ICON = '/images/default/defaultPicture.png';
// export const QUICK_ORDER_ICON = '/images/qrCode/quickOrder.svg';
// export const QUICK_BILL_ICON = '/images/qrCode/quickBill.svg';
// export const FREESHIP_ICON = '/images/qrCode/freeShip.svg';
// export const VONG_QUAY_ICON = '/images/deals/vong_quay_3.svg';
// export const MOTORBIKE_ICON = '/images/deals/motorbike.svg';
// infoTabsV2
var USER_ICON = "/images/infoTabsV2/user.svg";
var USER_ICON_ACTIVE = "/images/infoTabsV2/userActive.svg";
var BILL_ICON = "/images/infoTabsV2/billoflading.svg";
var BILL_ICON_ACTIVE = "/images/infoTabsV2/billofladingActive.svg";
var FEEDBACK_ICON = "/images/infoTabsV2/feedback.svg";
var FEEDBACK_ICON_ACTIVE = "/images/infoTabsV2/feedBackActive.svg";
var ORDER_ICON_MENU = "/images/infoTabsV2/myOrder.svg";
var ORDER_ICON_MENU_ACTIVE = "/images/infoTabsV2/myOrderActive.svg";
var POINTS_ICON = "/images/infoTabsV2/points.svg";
var POINTS_ICON_ACTIVE = "/images/infoTabsV2/pointsActive.svg";
var REFER_FRIEND_ICON = "/images/infoTabsV2/referFriends.svg";
var REFER_FRIEND_ICON_ACTIVE = "/images/infoTabsV2/referFriendsActive.svg";
var STATISTICAL_ICON = "/images/infoTabsV2/statistical.svg";
var STATISTICAL_ICON_ACTIVE = "/images/infoTabsV2/statisticalActive.svg";
var WISHLIST_ICON = "/images/infoTabsV2/wishlist.svg";
var WISHLIST_ICON_ACTIVE = "/images/infoTabsV2/wishlistActive.svg";
var VIEWED_ICON = "/images/infoTabsV2/viewed.svg";
var VIEWED_ICON_ACTIVE = "/images/infoTabsV2/viewedActive.svg";
var QR_ICON = "/images/infoTabsV2/qr.svg";
var QR_ICON_ACTIVE = "/images/infoTabsV2/qrActive.svg";
var QUEST_REWARDS_ICON = "/images/infoTabsV2/quest_rewards.svg";
var QUEST_REWARDS_ICON_WHITE = "/images/infoTabsV2/quest_reward_white.svg";
var QUEST_REWARDS_ICON_ACTIVE = "/images/infoTabsV2/quest_rewards_active.svg";
var LEVEL_ICON = "/images/infoTabsV2/level_icon.svg";
var LEVEL_ICON_ACTIVE = "/images/infoTabsV2/level_icon_active.svg";
var VOUCHER_ICON = "/images/infoTabsV2/voucher_icon.svg";
var VOUCHER_ICON_ACTIVE = "/images/infoTabsV2/voucher_icon_active.svg";
var LOGOUT_ICON = "/images/infoTabsV2/logout.svg";
var USER_ICON_WHITE = "/images/infoTabsV2/account_white.svg";
var TRUCK_ICON_WHITE = "/images/infoTabsV2/truck_white.svg";
var FEEDBACK_ICON_WHITE = "/images/infoTabsV2/feedback_white.svg";
var ORDER_ICON_MENU_WHITE = "/images/infoTabsV2/order_white.svg";
var POINTS_ICON_WHITE = "/images/infoTabsV2/point_white.svg";
var REFER_FRIEND_ICON_WHITE = "/images/infoTabsV2/refer_white.svg";
var STATISTICAL_ICON_WHITE = "/images/infoTabsV2/static_white.svg";
var WISHLIST_ICON_WHITE = "/images/infoTabsV2/heart_white.svg";
var VIEWED_ICON_WHITE = "/images/infoTabsV2/viewed_white.svg";
var QR_ICON_WHITE = "/images/infoTabsV2/qr_white.svg";
var LEVEL_ICON_WHITE = "/images/infoTabsV2/level_white.svg";
var VOUCHER_ICON_WHITE = "/images/infoTabsV2/voucher_white.svg";
var LOGOUT_ICON_WHITE = "/images/infoTabsV2/logout_white.svg";
// export const FILE_NEW_PRODUCT = '/static/files/newproduct.pdf';
// export const FILE_NEW_PRODUCT = '/static/files/sanphammoi.pdf';
// export const TRUCK_ICON_WHITE = '/images/infoTabsV2/truck_white.svg';
// export const FILE_NEW_PRODUCT_MIEN_BAC = '/static/files/sanphammoi_mienbac.pdf';
// export const FILE_NEW_PRODUCT_MIEN_NAM = '/static/files/sanphammoi_miennam.pdf';
// export const FILE_ALTERNATIVE_PRODUCT_MIEN_BAC = '/static/files/san_pham_thay_the_mien_bac.pdf';
// export const FILE_ALTERNATIVE_PRODUCT_MIEN_NAM = '/static/files/san_pham_thay_the_mien_nam.pdf';
// /myOrder icon
var ReturnOrderIcon = "/icons/ReturnOrderIcon.svg";
// block account
var BLOCK_ACCOUNT = "/images/block_account.png";
var MAIL_ICON = "/images/mail.png";
// logoV2
var NEW_LOGO = sysconfig__WEBPACK_IMPORTED_MODULE_0__/* .ENV_COUNTRY */ .ng === "vn" ? "/images/logoV2.svg" : _default__WEBPACK_IMPORTED_MODULE_1__/* .LOGO_BUYMED_GG */ .dV;
var URL_NEW_LOGO = sysconfig__WEBPACK_IMPORTED_MODULE_0__/* .ENV_COUNTRY */ .ng === "vn" ? "/images/logoV2.svg" : _default__WEBPACK_IMPORTED_MODULE_1__/* .LOGO_BUYMED_GG */ .dV;
//
var DELIVERY_FROM = "/images/shipping-policy/delivery-form.png";
var DELIVERY_APOLOGIZE = "/images/shipping-policy/apologize-delivery.png";
// 404
var IMAGE_404 = "/assets/404/404.svg";
var LOGO_THUOCSI_404 = sysconfig__WEBPACK_IMPORTED_MODULE_0__/* .ENV_COUNTRY */ .ng === "vn" ? "/assets/404/newLogoThuocsi.svg" : _default__WEBPACK_IMPORTED_MODULE_1__/* .LOGO_BUYMED_GG */ .dV;
var ICON_404_MAIL = "/assets/404/mail.svg";
var ICON_404_PHONE = "/assets/404/phone.svg";
// loyalty v2
var VOUCHER_TITLE_DETAIL = "/images/loyaltyv2/giftPromotion.svg";
var VOUCHER_TITLE = "/images/loyaltyv2/voucherTS.svg";
// export const VOUCHER_TS_IMG = '/images/loyaltyv2/voucherThuocsi_img.svg';
// export const VOUCHER_FRAME = '/images/loyaltyv2/voucherFrame.svg';
var LOYALTY_ARROW_VIEW_MORE = "/images/loyaltyv2/loyalty_arrow_bottom.svg";
// export const VOUCHER_TS_MIN = '/images/loyaltyv2/voucherTS_min.svg';
var VOUCHER_TS_MIN = "/images/loyaltyv2/voucherNew.svg";
var VOUCHER_FRAME_MIN = "/images/loyaltyv2/voucher_frame_min.svg";
var TimeOrderStatus = "/orderStatus/time.svg";
// export const ICON_VAT_ORDER = '/orderStatus/iconVAT.svg';
// export const ICON_EXPORT_XLS_ORDER = '/orderStatus/iconExportXLS.svg';
var ICON_FEEDBACK_ORDER = "/orderStatus/iconFeedback.svg";
var ICON_ARROW_ORDER = "/orderStatus/arrowOrder.svg";
var ICON_ARROW_ORDER_ACTIVE = "/orderStatus/arrowOder_active.svg";
var VOUCHER_TITLE_GREEN = "/images/loyaltyv2/voucherTSgreen.svg";
var VOUHCER_PROMOTION_BOX = "/images/loyaltyv2/giftBox.svg";
// orderdetail v2
var ReAddToCartV2 = "/images/detailOrderV2/addtocartV2.svg";
var EditDetailV2 = "/images/detailOrderV2/editOrderV2.svg";
var I_WAIT_TO_CONFIRM = "/images/detailOrderV2/wait_to_confirm.svg";
// export const I_PROCESSING = '/images/detailOrderV2/wait_to_confirm.svg';
var I_DELIVERING = "/images/detailOrderV2/delivering.svg";
var I_DELIVERED = "/images/detailOrderV2/delivered.svg";
var I_TRANSPORTING = "/images/detailOrderV2/transporting.svg";
var I_FILE_CHECKED = "/images/detailOrderV2/file_checked.svg";
var I_EDIT_ORDER_V2 = "/images/detailOrderV2/edit_order_v2.svg";
var I_PROCESSING_V2 = "/images/detailOrderV2/processing.svg";
var I_CONFIRMED = "/images/detailOrderV2/confirmed.svg";
var I_COMPLETED = "/images/detailOrderV2/completed.svg";
var I_EXIT = "/images/detailOrderV2/exit.svg";
var I_FEEDBACK_DETAILV2 = "/images/detailOrderV2/feedbackOrderV2.svg";
var I_RETURN_ORDER_DETAILV2 = "/images/detailOrderV2/returnOrderV2.svg";
var I_ARROW_RIGHT_DETAILV2 = "/images/detailOrderV2/arrowRight.svg";
var EDIT_INVOICE = "/images/detailOrderV2/editInvoice.svg";
var UP_INVOICE = "/images/detailOrderV2/iconUP.svg";
// loyalty v2
var SLIVER_ICON_RANK = "/images/loyalty-v2/loyalty_rank_sliver.svg";
var GOLD_ICON_RANK = "/images/loyalty-v2/loyalty_gold_rank.svg";
var PLATINUM_ICON_RANK = "/images/loyalty-v2/loyalty_rank_platinum.svg";
var DIAMOND_ICON_RANK = "/images/loyalty-v2/loyalty_diamond_rank.svg";
var SLIVER_ICON_RANK_ACTIVE = "/images/loyalty-v2/rank_sliver_active.svg";
var DIAMOND_ICON_RANK_ACTIVE = "/images/loyalty-v2/rank_diamond_active.svg";
var PLATINUM_ICON_RANK_ACTIVE = "/images/loyalty-v2/rank_platinum_active.svg";
var GOLD_ICON_RANK_ACTIVE = "/images/loyalty-v2/rank_gold_active.svg";
var SECTION_STORE_ICON = "/images/pill.png";
var AMBASSADOR_ICON_RANK_ACTIVE = "/images/loyalty-v2/loyalty_ambassador_rank_active.svg";
var AMBASSADOR_ICON_RANK = "/images/loyalty-v2/loyalty_ambassador_rank.svg";
// cart -> popup promo
var VOUCHER_TS_PROMO = "/images/logoV2.svg";
var CART_VOUCHER_CHECKED_ICON = "/images/cart/checked_icon.svg";
var CART_VOUCHER_CHECKBOX_ICON = "/images/cart/checkbox_icon.svg";
var CART_NEW_GIFT_ICON = "/images/cart/gift_icon.svg";
// mobile layout
var MOBILE_ICON_ALERT_SUCCESS = "/images/mobile/alert/success.svg";
var MOBILE_ICON_RATING_STAR = "/icons/mobile/conversations/rating_star.svg";
var MOBILE_ICON_RATING_STAR_FILL = "/icons/mobile/conversations/rating_star_fill.svg";
var MOBILE_ICON_RATING_STAR_NOT_FILL = "/icons/mobile/conversations/rating_star_not_fill.svg";
var MOBILE_ICON_RATING_SUCCESS = "/icons/mobile/conversations/rating_success.svg";
var MOBILE_ICON_ATTACH_FILE = "/icons/mobile/conversations/icon_attach_file.svg";
// detail product
var SAME_STORE = "/icons/mobile/detail-product/same_store.svg";
var SAME_INGREDIENT = "/icons/mobile/detail-product/same_ingredient.svg";
// wishlist v2
var I_WISHLIST_DEL = "/icons/wishlist_del_icon.svg";
var DELETE_VOUCHER_ICON = "/images/delete_voucher.svg";
var GIFT_ICON2 = "/images/gift_icon.svg";
// hardcode tab
var HANG_DIEM_ICON = "/icons/hang_diem.png";
// new gift
var GIFT_NEW_GREEN = "/images/gift_icon.svg";
// thankyou page
var ORDER_SUCCESS_THANKYOU = "/images/thankyou/order_success.svg";
var CAMBODIAN_ORDER_SUCCESS_THANKYOU = "/images/thankyou/cam_order_success.svg";
var THAI_ORDER_SUCCESS_THANKYOU = "/images/thankyou/thai_order_success.svg";
var ORDER_SUCCESS_THANKYOU_MAP = {
    vn: ORDER_SUCCESS_THANKYOU,
    en: CAMBODIAN_ORDER_SUCCESS_THANKYOU,
    cam: CAMBODIAN_ORDER_SUCCESS_THANKYOU,
    th: THAI_ORDER_SUCCESS_THANKYOU
};
var ICON_KHUNG_LONG = "/icons/khunglong.svg";
var HOME_BG_MEGA_SALE = "/images/mega-sale-bacground.svg";
var HOME_ICON_MEGA_SALE = "/icons/mega-sale.svg";
// toggle profile
var PROFILE_CHANGE_LANGUAGE = "/images/profile-toggle/change_language.svg";
var PROFILE_ENGLISH = "/images/profile-toggle/english.svg";
var PROFILE_THAI = "/images/profile-toggle/thailand.svg";
// media
var MEDIA_TH_1 = "th/web/Tech-in-Asia.png";
var MEDIA_TH_2 = "th/web/Naewna.png";
var MEDIA_TH_3 = "th/web/Youtube.png";
var MEDIA_TH_4 = "th/web/Kapook.png";
var MEDIA_TH_5 = "th/web/Sanook.png";
var MEDIA_TH_6 = "th/web/MThai.png";
var MEDIA_TH_7 = "th/web/Newswit.png";
var MEDIA_TH_8 = "th/web/Press.in.th.png";
var MEDIA_TH_9 = "th/web/Thailand4.png";
var MEDIA_TH_10 = "th/web/RYT9.png";
var MEDIA_TH_11 = "th/web/ThaiPR.png";
var MEDIA_TH_M_1 = "th/mobile/Tech-in-Asia_m.png";
var MEDIA_TH_M_2 = "th/mobile/Naewna_m.png";
var MEDIA_TH_M_3 = "th/mobile/Youtube_m.png";
var MEDIA_TH_M_4 = "th/mobile/Kapook_m.png";
var MEDIA_TH_M_5 = "th/mobile/Sanook_m.png";
var MEDIA_TH_M_6 = "th/mobile/MThai_m.png";
var MEDIA_TH_M_7 = "th/mobile/Newswit_m.png";
var MEDIA_TH_M_8 = "th/mobile/Press.in.th_m.png";
var MEDIA_TH_M_9 = "th/mobile/Thailand4_m.png";
var MEDIA_TH_M_10 = "th/mobile/RYT9_m.png";
var MEDIA_TH_M_11 = "th/mobile/ThaiPR_m.png";
// banner
var MEDIA_VIDEO_TH_1 = "/static/images/homepage/videos/review01.png";
var MEDIA_VIDEO_TH_2 = "/static/images/homepage/videos/review02.png";
var MEDIA_VIDEO_TH_3 = "/static/images/homepage/videos/review03.png";
var MEDIA_VIDEO_TH_4 = "/static/images/homepage/videos/review04.png";
var MEDIA_VIDEO_TH_5 = "/static/images/homepage/videos/review05.png";
// lucky wheel
var LUCKYWHEEL_BORDER = "/images/spinner/wheel_without_center.svg";
var LUCKYWHEEL_BORDER_WITH_CENTER = "/images/spiner/wheel_with_center.svg";
var LUCKYWHEEL_CENTER = "   /images/spinner/wheel_center.svg";
var LUCKYWHEEL_ARROW_SELECTOR = "/images/spinner/selector.svg";
var LUCKYWHEEL_TOP_SPIN_BUTTON = "/images/spinner/top_button_spin.svg";
var LUCKYWHEEL_BOTTOM_SPIN_BUTTON = "/images/spinner/bottom_button_spin.svg";
var LUCKWHEEL_ICON_WARNING = "/images/spinner/icon_popup_warning.svg";
var LUCKYWHEEL_BACKGROUND = "/images/spinner/spinner_bg.png";
var LUCKYWHEEL_MOBILE_BACKGROUND = "/images/spinner/mobile_spinner_bg.png";
var LUCKYWHEEL_TIME_ICON = "   /images/spinner/time_icon.svg";
var LUCKYWHEEL_GUILDLINE_ICON = "/images/spinner/guildline_icon.svg";
var LUCKYWHEEL_TITLE = "/images/spinner/wheel_title.png";
var LUCKYWHEEL_MOBILE_MISSION_ICON = "/images/spinner/mission_shadow_icon.svg";
var LUCKYWHEEL_MOBILE_GUILDLINE_ICON = "/images/spinner/guildline_shadow_icon.svg";
var LUCKYWHEEL_MOBILE_HISTORY_ICON = "/images/spinner/history_shadow_icon.svg";
var LUCKYWHEEL_MOBILE_TAB_BACKGROUND = "/images/spinner/mobile_tab_background.svg";
var LUCKYWHEEL_MOBILE_CLOSE_BUTTON = "/images/spinner/mobile_close_button.svg";
var LUCKYWHEEL_MOBILE_PRIZE_BG = "/images/spinner/mobile_popup_prize_bg.svg";
var LUCKYWHEEL_MISSION_ICON = "/images/spinner/mission_icon.svg";
var LUCKYWHEEL_MOBILE_POPUP_MISSION_BG = "/images/spinner/mobile_popup_mission_bg.png";
var LUCKYWHEEL_MOBILE_OOT_TEXT = "/images/spinner/mobile_oot.png";
var LUCKYWHEEL_MOBILE_SPIN_TEXT = "/images/spinner/mobile_spin_text.png";
var LUCKYWHEEL_BLOCKED_ICON = "/images/spinner/blocked_icon.svg";
var LUCKYWHEEL_DEFAULT_BACKGROUND = "/images/spinner/spinner_bg.png";
var LUCKYWHEEL_SHARE_ICON = "/images/spinner/popup_share_icon.png";
var LUCKYWHEEL_SHARE_FACEBOOK_ICON = "/images/spinner/facebook_icon.svg";
var LUCKYWHEEL_SHARE_ZALO_ICON = "/images/spinner/zalo_mobile_icon.svg";
var LUCKYWHEEL_WEBVIEW_BACKGROUND = "/images/spinner/mobile_spinner_bg.png";


/***/ }),

/***/ 199:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$T": function() { return /* binding */ PATH_LINKEDIN_BUYMED_JOB; },
/* harmony export */   "$w": function() { return /* binding */ HOW_TO_RETURN_REFUND; },
/* harmony export */   "A3": function() { return /* binding */ QUICK_ORDER; },
/* harmony export */   "Aw": function() { return /* binding */ CAREER; },
/* harmony export */   "Ek": function() { return /* binding */ DOMAINS_THUOCSI; },
/* harmony export */   "FO": function() { return /* binding */ GENERAL_POLICY_URL; },
/* harmony export */   "GN": function() { return /* binding */ QNA; },
/* harmony export */   "IF": function() { return /* binding */ DBD_URL; },
/* harmony export */   "KN": function() { return /* binding */ THUOCSI_SUPPORT; },
/* harmony export */   "L7": function() { return /* binding */ GUEST_HOME_PAGE; },
/* harmony export */   "LS": function() { return /* binding */ MANUFACTURERS; },
/* harmony export */   "NL": function() { return /* binding */ PRODUCTS_URL; },
/* harmony export */   "NY": function() { return /* binding */ THANKYOU_URL; },
/* harmony export */   "Py": function() { return /* binding */ USER_PROMO_CODES_URL; },
/* harmony export */   "Q2": function() { return /* binding */ PROMO_CODES; },
/* harmony export */   "RX": function() { return /* binding */ MY_ACCOUNT; },
/* harmony export */   "So": function() { return /* binding */ ONBOARDING; },
/* harmony export */   "Sx": function() { return /* binding */ CHINH_SACH_GIAI_QUYET_KHIEU_NAI_URL; },
/* harmony export */   "Tn": function() { return /* binding */ BULK_ORDER_LIST; },
/* harmony export */   "UI": function() { return /* binding */ SELLERS; },
/* harmony export */   "VO": function() { return /* binding */ PATH_BUYMED_LINE; },
/* harmony export */   "Vy": function() { return /* binding */ CHINH_SACH_DANG_TAI_SAN_PHAM_URL; },
/* harmony export */   "We": function() { return /* binding */ BULK_ORDER_CART; },
/* harmony export */   "Wj": function() { return /* binding */ PATH_TS_LINKED; },
/* harmony export */   "XK": function() { return /* binding */ QUY_CHE_HOAT_DONG_URL; },
/* harmony export */   "XY": function() { return /* binding */ ORDER_GUIDE; },
/* harmony export */   "X_": function() { return /* binding */ THUOCSI_SUPPORT_SELLER; },
/* harmony export */   "YK": function() { return /* binding */ PATH_TS_ZALO; },
/* harmony export */   "Yp": function() { return /* binding */ CONDITIONS_OF_USE_URL; },
/* harmony export */   "Yz": function() { return /* binding */ REGULATIONS_URL; },
/* harmony export */   "ZS": function() { return /* binding */ PRODUCT_LIST; },
/* harmony export */   "Zi": function() { return /* binding */ PATH_TS_TIKTOK; },
/* harmony export */   "Zo": function() { return /* binding */ LICENSE_PDF; },
/* harmony export */   "a1": function() { return /* binding */ WAITING_PAYMENT; },
/* harmony export */   "a6": function() { return /* binding */ BULK_ORDER; },
/* harmony export */   "aA": function() { return /* binding */ CATEGORIES; },
/* harmony export */   "ab": function() { return /* binding */ KHUYEN_MAI; },
/* harmony export */   "aq": function() { return /* binding */ LEGAL_IMAGE; },
/* harmony export */   "c5": function() { return /* binding */ PRODUCT; },
/* harmony export */   "cK": function() { return /* binding */ ABOUT_US_URL; },
/* harmony export */   "cW": function() { return /* binding */ DEFAULT_THUMBNAIL_PATH; },
/* harmony export */   "dd": function() { return /* binding */ WISHLIST; },
/* harmony export */   "e6": function() { return /* binding */ CHINH_SACH_BAO_MAT_URL; },
/* harmony export */   "fh": function() { return /* binding */ CART_URL; },
/* harmony export */   "gL": function() { return /* binding */ INGREDIENT; },
/* harmony export */   "gg": function() { return /* binding */ PATH_BUYMED_SUPPORT; },
/* harmony export */   "hN": function() { return /* binding */ KHUYEN_MAI_LOADING; },
/* harmony export */   "hh": function() { return /* binding */ getPathTicketByIdWithDomain; },
/* harmony export */   "hq": function() { return /* binding */ getPathProductBySlug; },
/* harmony export */   "i$": function() { return /* binding */ getPathOrderByIdWithDomain; },
/* harmony export */   "iB": function() { return /* binding */ PRODUCTS_LOADING_URL; },
/* harmony export */   "j2": function() { return /* binding */ PATH_INFO_BILL; },
/* harmony export */   "j3": function() { return /* binding */ PATH_SHIPPING_POLICY; },
/* harmony export */   "kH": function() { return /* binding */ SELLERS_LOADING_URL; },
/* harmony export */   "kO": function() { return /* binding */ getPathProductBySlugWithDomain; },
/* harmony export */   "lQ": function() { return /* binding */ DISCOVERY; },
/* harmony export */   "ly": function() { return /* binding */ PATH_TS_FACEBOOK; },
/* harmony export */   "mK": function() { return /* binding */ HELP_CENTER; },
/* harmony export */   "mU": function() { return /* binding */ DISPUTE_RESOLUTION_URL; },
/* harmony export */   "q0": function() { return /* binding */ CONVERSATIONS; },
/* harmony export */   "qJ": function() { return /* binding */ PATH_PROMOTIONS; },
/* harmony export */   "qt": function() { return /* binding */ OLD_KHUYEN_MAI; },
/* harmony export */   "qy": function() { return /* binding */ TERMS_URL; },
/* harmony export */   "rR": function() { return /* binding */ HOW_TO_ORDER_AND_PAYMENT; },
/* harmony export */   "s6": function() { return /* binding */ HOME_PAGE; },
/* harmony export */   "sE": function() { return /* binding */ CHECKOUT_URL; },
/* harmony export */   "wn": function() { return /* binding */ NOTIFICATIONS; },
/* harmony export */   "xD": function() { return /* binding */ BOTTOM_NAVIGATION_PAGES; },
/* harmony export */   "yV": function() { return /* binding */ ACCOUNT; },
/* harmony export */   "z$": function() { return /* binding */ MY_ORDER_URL; },
/* harmony export */   "zA": function() { return /* binding */ HOW_TO_UPLOAD_PRODUCTS; },
/* harmony export */   "z_": function() { return /* binding */ EXCHANGE_LOYALTY; }
/* harmony export */ });
/* unused harmony exports GUIDE_URL, NOT_FOUND_URL, PATH_PROMOTIONS_LOADING, LUCKY_WHEEL, REFERRALS_PAGE, LOYALTY_PAGE, MY_TICKET, NEW_PRODUCTS_URL, BUSINESS_INFORMATION, TAG_PAGE, getPathOrderById, getPathTicketById, PATH_NEWS, PATH_CAREER, PATH_BUYMED_CAREER */
/* harmony import */ var sysconfig__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66225);
/* harmony import */ var utils_StringUtils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52380);
// TODO: refactor contanst


/* eslint-disable operator-linebreak */ // WEB
var MY_ACCOUNT = "/my-account";
var ONBOARDING = "/onboarding";
var MY_ORDER_URL = "/my-order";
var ABOUT_US_URL = "/about-us";
var GUIDE_URL = "/guide";
// export const PRIVACY_POLICY_URL = '/privacy-policy';
var GENERAL_POLICY_URL = "/general-policy";
var CONDITIONS_OF_USE_URL = "/conditions-of-use";
var DISPUTE_RESOLUTION_URL = "/dispute-resolution";
var TERMS_URL = "/terms-and-condition";
var QUY_CHE_HOAT_DONG_URL = "/static/quy-che-hoat-dong/quy-che-hoat-dong.pdf";
var CHINH_SACH_BAO_MAT_URL = "/chinh-sach-bao-mat";
var CHINH_SACH_GIAI_QUYET_KHIEU_NAI_URL = "/chinh-sach-giai-quyet-khieu-nai";
var REGULATIONS_URL = "/regulations";
var NOTIFICATIONS = "/notifications";
var QUICK_ORDER = "/quick-order";
var CHINH_SACH_DANG_TAI_SAN_PHAM_URL = "/chinh-sach-dang-tai-san-pham";
var PRODUCT = "/product/[slug]";
var PRODUCT_LIST = "/products";
// export const DEALS = '/deals';
var PRODUCTS_URL = "/products";
var PRODUCTS_LOADING_URL = "/products/loading";
var CART_URL = "/cart";
// export const SUPPLIER = '/supplier';
var INGREDIENT = "/ingredients";
var MANUFACTURERS = "/manufacturers";
var CHECKOUT_URL = "/checkout";
var THANKYOU_URL = "/thankyou";
var NOT_FOUND_URL = "/404";
var PROMO_CODES = "/promo-codes";
var HOME_PAGE = "/";
var GUEST_HOME_PAGE = "/home";
var CATEGORIES = "/categories";
var USER_PROMO_CODES_URL = "/users/my-voucher";
var OLD_KHUYEN_MAI = "/khuyenmai";
// export const KHUYEN_MAI_LOADING = '/khuyenmai/loading';
var KHUYEN_MAI = "/promotions";
var KHUYEN_MAI_LOADING = "/promotions/loading";
var PATH_PROMOTIONS = "/promotions";
var PATH_PROMOTIONS_LOADING = "/promotions/loading";
var LUCKY_WHEEL = "/lucky-wheel";
var SELLERS = "/sellers";
var SELLERS_LOADING_URL = "/sellers/loading";
var HOW_TO_UPLOAD_PRODUCTS = "/huong-dan-dang-tai-san-pham";
var HOW_TO_ORDER_AND_PAYMENT = "/huong-dan-dat-hang-va-thanh-toan";
var HOW_TO_RETURN_REFUND = "/chinh-sach-doi-tra";
// export const PRODUCT_DETAILS_LOADING_URL = '/product/loading';
var REFERRALS_PAGE = "/users/referrals";
var LOYALTY_PAGE = "/users/loyalty_points";
var WISHLIST = "/user/wishlist";
var BULK_ORDER = "/bulk-order/import";
var BULK_ORDER_CART = "/bulk-order/cart";
var BULK_ORDER_LIST = "/bulk-order";
var DISCOVERY = "/discovery";
var ACCOUNT = "/users/account";
var MY_TICKET = "/users/my-ticket";
var CONVERSATIONS = "/conversations";
var EXCHANGE_LOYALTY = "/users/exchange-loyalty";
// export const MY_VOUCHER_PAGE = '/users/my-voucher';
var NEW_PRODUCTS_URL = "/sanphammoi";
var BUSINESS_INFORMATION = "/user/business-information";
var WAITING_PAYMENT = "/waiting-payment";
var TAG_PAGE = "/tag";
var getPathProductBySlug = function(slug) {
    return "".concat(PRODUCT.replace("[slug]", (0,utils_StringUtils__WEBPACK_IMPORTED_MODULE_1__/* .encodeUrl */ .Mq)(slug)));
};
var getPathProductBySlugWithDomain = function(slug) {
    return sysconfig__WEBPACK_IMPORTED_MODULE_0__/* .DOMAIN_TS */ .tc + getPathProductBySlug(slug);
};
var getPathOrderById = function(id) {
    return "".concat("".concat(MY_ORDER_URL, "/").concat(id));
};
var getPathOrderByIdWithDomain = function(id) {
    return sysconfig__WEBPACK_IMPORTED_MODULE_0__/* .DOMAIN_TS */ .tc + getPathOrderById(id);
};
var getPathTicketById = function(id) {
    return "".concat("".concat(MY_TICKET, "?id=").concat(id));
};
var getPathTicketByIdWithDomain = function(id) {
    return sysconfig__WEBPACK_IMPORTED_MODULE_0__/* .DOMAIN_TS */ .tc + getPathTicketById(id);
};
// SUB DOMAIN
var PATH_NEWS = "https://news.thuocsi.com.vn";
var PATH_CAREER = "https://career.thuocsi.com.vn";
// export const PATH_SUPPLIER = 'https://supplier.thuocsi.vn';
var CAREER = "https://career.thuocsi.com.vn/";
var HELP_CENTER = "https://phanhoi.thuocsi.vn";
var THUOCSI_SUPPORT = "https://thuocsihotro.helpwise.help/";
var THUOCSI_SUPPORT_SELLER = "https://thuocsisellercenter.helpwise.help/";
var PATH_TS_FACEBOOK = "https://www.facebook.com/buymedthai";
var PATH_TS_ZALO = "https://zalo.me/1836616064223034882";
var PATH_TS_LINKED = "https://www.linkedin.com/company/thuocsivn/";
var PATH_BUYMED_LINE = "https://line.me/R/ti/p/@616fszhu";
var PATH_TS_TIKTOK = "https://www.tiktok.com/@buymedthailand";
var PATH_SHIPPING_POLICY = "/shipping-policy";
var PATH_BUYMED_CAREER = "https://career.buymed.vn";
var PATH_LINKEDIN_BUYMED_JOB = "https://www.linkedin.com/company/buymedasia/jobs/";
var PATH_BUYMED_SUPPORT = "https://buymedsiam.helpwise.help/";
// OUTBOUND
var PATH_INFO_BILL = "https://thuocsihotro.helpwise.help";
var QNA = "https://thuocsihotro.helpwise.help/";
var ORDER_GUIDE = "https://thuocsihotro.helpwise.help/";
var LICENSE_PDF = "https://buymed-storage.s3-ap-southeast-1.amazonaws.com/trading_license/1.+Trading+License+-+Buymed+(GC+20+June+2019)+(VN).pdf";
var LEGAL_IMAGE = "https://assets.thuocsi.vn/assets/bct-150ac1809a7ae41e0a4b21f1e1e21a26a2f93ee0c79e5c99cc197dd2fdc988c8.png";
var DBD_URL = "https://dbdregistered.dbd.go.th/api/public/trustmarkinfo/107680";
// export const FEEDBACK = 'https://cs.stg.thuocsi.vn/feedback';
// export const NEW_PRODUCT = 'https://try.thuocsi.vn/daitiechangmoi';
// export const WEB = {};
// export const ASK_PRODUCT =
//   'https://forms.office.com/Pages/ResponsePage.aspx?id=f-ffA68NfkimxyYB5SgTPbGuKhViJltLlJQcOW8IoQpURVY2VU1MTjU1M01LSVdIS0hDSUIzWkZTWC4u';
// DOMAINS_THUOCSI -> domain thuocsi sẽ chạy, các host khác proxy tới thuocsi sẽ bị đá lại domain chính
var DOMAINS_THUOCSI = [
    "v2.thuocsi.vn",
    "mienbac.thuocsi.vn",
    "thuocsi.vn",
    "thuocsi.com.vn",
    "thuocsi.net",
    "web.v2-stg.thuocsi.vn",
    "web.v2-dev.thuocsi.vn",
    "web.v2-uat.thuocsi.vn",
    "localhost",
    "local.thuocsi-web.vn",
    "local-prd.thuocsi-web.vn",
    "local.thuocsi.vn",
    "hk.thuocsi.vn",
    "sg.thuocsi.vn",
    "cambodia-stg.thuocsi.vn",
    "cambodia-dev.thuocsi.vn",
    "cambodia-uat.thuocsi.vn",
    "buymed.com.kh",
    "buymed.co.th",
    "www.buymed.co.th",
    "stg.buymed.co.th",
    "dev.buymed.co.th",
    "uat.buymed.co.th",
    "local.thuocsi-web.th",
    "stg.thailand.buymed.tech",
    "local-th.buymed.tech", 
];
DOMAINS_THUOCSI.push(sysconfig__WEBPACK_IMPORTED_MODULE_0__/* .DOMAIN_TS */ .tc);
var BOTTOM_NAVIGATION_PAGES = [
    "/",
    DISCOVERY,
    SELLERS,
    SELLERS_LOADING_URL,
    KHUYEN_MAI,
    KHUYEN_MAI_LOADING,
    PRODUCT_LIST,
    OLD_KHUYEN_MAI,
    INGREDIENT, 
];
// deprecated 22Feb2023 - Dinh Tran
// export const ROUTES_CAN_PUSH = ['/sellers?type=all']; // list các routes có thể vào stack routing bỏ qua check duplicate
// export const MOBILE_SHOW_LOGO_AND_SWITCH_PAGES = ['/'];
// export const MOBILE_SHOW_BACK_BUTTON_PAGES = [
//   CART_URL,
//   CHECKOUT_URL,
//   QUICK_ORDER,
//   '/thankyou/[id]',
//   MY_ORDER_URL,
//   '/user/dashboard',
//   '/tracking-order',
//   '/productviewed',
//   '/users/referrals',
//   USER_PROMO_CODES_URL,
//   '/user/wishlist',
//   '/qr',
//   '/users/my-ticket',
//   '/users/loyalty_points',
//   '/users/rewards',
//   '/khuyenmai/[slug]',
//   PRODUCT,
//   PRODUCTS_URL,
//   '/product/[slug]/loading',
//   PROMO_CODES,
//   '/seller/[slug]',
//   '/flagship-store/sanofi',
//   '/flagship-store/durex',
//   '/seller/[slug]/list-product',
//   '/sellers?type=flagship',
//   '/sellers?type=all',
//   '/flagship-store/[slug]',
//   '/flagship-store/[slug]/list-product',
//   '/flagship-store/[slug]/flagship-rewards',
// ];
var DEFAULT_THUMBNAIL_PATH = "/default";


/***/ }),

/***/ 91983:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ ENUM_TAG_CODES; }
/* harmony export */ });
/**
 * Code tag của thị trường VN, còn lại cho module tag cũ (`src/components/mocules/*`) và
 * logic sort ở `src/context/Product/context.js`.
 *
 * Module tag TH không dùng bảng này: allow-list và thứ tự lấy từ CMS
 * (xem `src/utils/TagUtils.js`, `docs/product-tag-display-spec.md`).
 */ var ENUM_TAG_CODES = {
    HANG_DIEM: "Y7GB",
    HANG_HANG: "2ABC",
    HOADONNHANH: "HOADONNHANH",
    KHUYENMAI: "DEAL"
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
    ENUM_TAG_CODES: ENUM_TAG_CODES
});


/***/ }),

/***/ 71523:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ TOGGLE_FEATURE_PREFIX; }
/* harmony export */ });
var TOGGLE_FEATURE_PREFIX = "TOGGLE_FEATURE_";
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
    TOGGLE_FEATURE_PREFIX: TOGGLE_FEATURE_PREFIX
});


/***/ }),

/***/ 61213:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ VISITED_URLS_STORAGE_KEY; }
/* harmony export */ });
/* eslint-disable import/prefer-default-export */ var VISITED_URLS_STORAGE_KEY = "visitedUrls";


/***/ }),

/***/ 66520:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$5": function() { return /* binding */ PAGE_SIZE_10; },
/* harmony export */   "$B": function() { return /* binding */ settingsBestProduct; },
/* harmony export */   "$d": function() { return /* binding */ CAMPAIGN_STATUS; },
/* harmony export */   "A1": function() { return /* binding */ DEFAULT_THUOCSI_LONG_TITLE; },
/* harmony export */   "AV": function() { return /* binding */ PAGE_SIZE_30; },
/* harmony export */   "As": function() { return /* binding */ settingsMobileMultiImageBoxV2; },
/* harmony export */   "Eo": function() { return /* binding */ ENTERPRISE; },
/* harmony export */   "F9": function() { return /* binding */ tabsAccountInfo; },
/* harmony export */   "Gn": function() { return /* binding */ settingsNewProducts; },
/* harmony export */   "IV": function() { return /* binding */ PAGE_SIZE; },
/* harmony export */   "Im": function() { return /* binding */ MAX_PRODUCT_QTY_DISPLAY; },
/* harmony export */   "K_": function() { return /* binding */ THUOC_VA_HOAT_CHAT; },
/* harmony export */   "Nf": function() { return /* binding */ DEFAULT_THUOCSI_DESCRIPTION; },
/* harmony export */   "O5": function() { return /* binding */ getTrackingData; },
/* harmony export */   "Oe": function() { return /* binding */ TAB_CONFIG; },
/* harmony export */   "Op": function() { return /* binding */ imageMediaThaiLan; },
/* harmony export */   "PM": function() { return /* binding */ settingsProduct; },
/* harmony export */   "QT": function() { return /* binding */ settingsStore; },
/* harmony export */   "R9": function() { return /* binding */ PreventSearchKeywords; },
/* harmony export */   "VP": function() { return /* binding */ settingsSliderBannerV2; },
/* harmony export */   "Vw": function() { return /* binding */ DEFAULT_THUOCSI_TITLE; },
/* harmony export */   "Yb": function() { return /* binding */ SEARCH_TYPE_LIST; },
/* harmony export */   "Z": function() { return /* binding */ DEFAULT_BULK_ORDER_TITLE; },
/* harmony export */   "_5": function() { return /* binding */ LoyaltyRulesContent; },
/* harmony export */   "_M": function() { return /* binding */ tabsProductDataV2; },
/* harmony export */   "a3": function() { return /* binding */ PreventSearchKeywordsAlias; },
/* harmony export */   "bZ": function() { return /* binding */ settingsMultiImageBoxV2; },
/* harmony export */   "dj": function() { return /* binding */ THUOC; },
/* harmony export */   "en": function() { return /* binding */ IMPORTANT_PERCENT_MAX; },
/* harmony export */   "h5": function() { return /* binding */ HOAT_CHAT; },
/* harmony export */   "hV": function() { return /* binding */ SCREEN_TO_ENUM_TRACKING_SOURCE_MAP; },
/* harmony export */   "jJ": function() { return /* binding */ NHA_BAN_HANG; },
/* harmony export */   "mJ": function() { return /* binding */ SOURCE_TO_ENUM_TRACKING_SOURCE_MAP; },
/* harmony export */   "nZ": function() { return /* binding */ SECTION_CODE; },
/* harmony export */   "qc": function() { return /* binding */ settingsCustomerSeller; },
/* harmony export */   "s2": function() { return /* binding */ ONE_DAY; },
/* harmony export */   "s7": function() { return /* binding */ DEFAULT_THUOCSI_SUBTITLE; },
/* harmony export */   "sQ": function() { return /* binding */ SORT_PRODUCT_NOT_LOGIN; },
/* harmony export */   "wv": function() { return /* binding */ swiperSettings; },
/* harmony export */   "xe": function() { return /* binding */ SORT_PRODUCT; },
/* harmony export */   "y7": function() { return /* binding */ orderTabList; },
/* harmony export */   "yy": function() { return /* binding */ tabsProductData; },
/* harmony export */   "zi": function() { return /* binding */ settingsSliderBanner; }
/* harmony export */ });
/* unused harmony exports imagePartnerSlider, imageMediaTop, imageMediaBottom, settingsCustomer, settingsPartner, settingsTicket, linkQuestionItemLeft, linkQuestionItemRight, LINK_ALL_QUESTION, customerFeedbackData, PASSWORD_SECURITY_WARNING, MAP_BTN_TITLE_BY_REDIRECT_URL */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_icons_NavigateBefore__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(18042);
/* harmony import */ var _material_ui_icons_NavigateNext__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(98121);
/* harmony import */ var constants_Enums__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71569);
/* harmony import */ var constants_Images__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13270);
/* harmony import */ var constants_Paths__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(199);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71911);
/* harmony import */ var sysconfig__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(66225);
/* harmony import */ var utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(76480);
/* eslint-disable jsx-a11y/no-static-element-interactions */ /* eslint-disable jsx-a11y/click-events-have-key-events */ // TODO: refactor contanst




// import { ICON_MEGA } from 'constants/Icons/menu';





var imagePartnerSlider = [
    // { id: 1, url: URL_SLIDER_1, width: '185px', height: '185px' }, APO-1440 - remove partner
    {
        id: 2,
        url: constants_Images__WEBPACK_IMPORTED_MODULE_2__/* .URL_SLIDER_2 */ .WIB,
        width: "185px",
        height: "185px"
    },
    {
        id: 3,
        url: constants_Images__WEBPACK_IMPORTED_MODULE_2__/* .URL_SLIDER_3 */ .qRP,
        width: "185px",
        height: "93px"
    },
    {
        id: 4,
        url: constants_Images__WEBPACK_IMPORTED_MODULE_2__/* .URL_SLIDER_4 */ .U_B,
        width: "185px",
        height: "92px"
    },
    {
        id: 5,
        url: constants_Images__WEBPACK_IMPORTED_MODULE_2__/* .URL_SLIDER_5 */ .ruX,
        width: "185px",
        height: "185px"
    },
    {
        id: 6,
        url: constants_Images__WEBPACK_IMPORTED_MODULE_2__/* .URL_SLIDER_6 */ .hTC,
        width: "185px",
        height: "185px"
    },
    {
        id: 7,
        url: constants_Images__WEBPACK_IMPORTED_MODULE_2__/* .URL_SLIDER_7 */ .agI,
        width: "185px",
        height: "123px"
    },
    {
        id: 8,
        url: constants_Images__WEBPACK_IMPORTED_MODULE_2__/* .URL_SLIDER_8 */ .FTC,
        width: "200px",
        height: "92px"
    },
    {
        id: 9,
        url: constants_Images__WEBPACK_IMPORTED_MODULE_2__/* .URL_SLIDER_9 */ .NlY,
        width: "185px",
        height: "115px"
    },
    {
        id: 10,
        url: constants_Images__WEBPACK_IMPORTED_MODULE_2__/* .URL_SLIDER_10 */ .VBB,
        width: "185px",
        height: "185px"
    },
    {
        id: 11,
        url: constants_Images__WEBPACK_IMPORTED_MODULE_2__/* .URL_SLIDER_11 */ .H6R,
        width: "185px",
        height: "185px"
    },
    {
        id: 12,
        url: constants_Images__WEBPACK_IMPORTED_MODULE_2__/* .URL_SLIDER_12 */ .GXJ,
        width: "185px",
        height: "185px"
    }, 
];
var imageMediaThaiLan = [
    {
        id: 1,
        url_en: constants_Images__WEBPACK_IMPORTED_MODULE_2__/* .MEDIA_VIDEO_TH_1 */ .Z9d,
        url_th: constants_Images__WEBPACK_IMPORTED_MODULE_2__/* .MEDIA_VIDEO_TH_1 */ .Z9d,
        url_mobile_th: constants_Images__WEBPACK_IMPORTED_MODULE_2__/* .MEDIA_VIDEO_TH_1 */ .Z9d,
        url_mobile_en: constants_Images__WEBPACK_IMPORTED_MODULE_2__/* .MEDIA_VIDEO_TH_1 */ .Z9d,
        href: "https://www.youtube.com/watch?v=XxRewx8uxg0&list=PLI4L93_nf5aITtNqcAcMtdWSFEFXc7cds&index=2",
        title: "customer_review_1",
        description: "customer_review_1_content"
    },
    {
        id: 2,
        url_en: constants_Images__WEBPACK_IMPORTED_MODULE_2__/* .MEDIA_VIDEO_TH_3 */ .nwo,
        url_th: constants_Images__WEBPACK_IMPORTED_MODULE_2__/* .MEDIA_VIDEO_TH_3 */ .nwo,
        url_mobile_th: constants_Images__WEBPACK_IMPORTED_MODULE_2__/* .MEDIA_VIDEO_TH_3 */ .nwo,
        url_mobile_en: constants_Images__WEBPACK_IMPORTED_MODULE_2__/* .MEDIA_VIDEO_TH_3 */ .nwo,
        href: "https://www.youtube.com/watch?v=39ynzM2UXZk&list=PLI4L93_nf5aITtNqcAcMtdWSFEFXc7cds&index=4",
        title: "customer_review_2",
        description: "customer_review_2_content"
    },
    {
        id: 3,
        url_en: constants_Images__WEBPACK_IMPORTED_MODULE_2__/* .MEDIA_VIDEO_TH_2 */ .owv,
        url_th: constants_Images__WEBPACK_IMPORTED_MODULE_2__/* .MEDIA_VIDEO_TH_2 */ .owv,
        url_mobile_th: constants_Images__WEBPACK_IMPORTED_MODULE_2__/* .MEDIA_VIDEO_TH_2 */ .owv,
        url_mobile_en: constants_Images__WEBPACK_IMPORTED_MODULE_2__/* .MEDIA_VIDEO_TH_2 */ .owv,
        href: "https://www.youtube.com/watch?v=eXjekyP2EmE&list=PLI4L93_nf5aITtNqcAcMtdWSFEFXc7cds&index=3",
        title: "customer_review_4",
        description: "customer_review_4_content"
    },
    {
        id: 4,
        url_en: constants_Images__WEBPACK_IMPORTED_MODULE_2__/* .MEDIA_VIDEO_TH_4 */ .Olk,
        url_th: constants_Images__WEBPACK_IMPORTED_MODULE_2__/* .MEDIA_VIDEO_TH_4 */ .Olk,
        url_mobile_th: constants_Images__WEBPACK_IMPORTED_MODULE_2__/* .MEDIA_VIDEO_TH_4 */ .Olk,
        url_mobile_en: constants_Images__WEBPACK_IMPORTED_MODULE_2__/* .MEDIA_VIDEO_TH_4 */ .Olk,
        href: "https://www.youtube.com/watch?v=nBiTkySBY1o&list=PLI4L93_nf5aITtNqcAcMtdWSFEFXc7cds&index=6",
        title: "customer_review_3",
        description: "customer_review_3_content"
    },
    {
        id: 5,
        url_en: constants_Images__WEBPACK_IMPORTED_MODULE_2__/* .MEDIA_VIDEO_TH_5 */ .t0e,
        url_th: constants_Images__WEBPACK_IMPORTED_MODULE_2__/* .MEDIA_VIDEO_TH_5 */ .t0e,
        url_mobile_th: constants_Images__WEBPACK_IMPORTED_MODULE_2__/* .MEDIA_VIDEO_TH_5 */ .t0e,
        url_mobile_en: constants_Images__WEBPACK_IMPORTED_MODULE_2__/* .MEDIA_VIDEO_TH_5 */ .t0e,
        href: "https://www.youtube.com/watch?v=3osFYFjo-Ko&list=PLI4L93_nf5aITtNqcAcMtdWSFEFXc7cds&index=5",
        title: "customer_review_5",
        description: "customer_review_5_content"
    }, 
];
var imageMediaTop = [
    {
        id: 1,
        url: constants_Images__WEBPACK_IMPORTED_MODULE_2__/* .URL_LOGO_SEEDSTAR */ .TRy,
        href: "https://www.seedstarsworld.com/event/seedstars-hochiminh-2018",
        width: "168px",
        height: "76px"
    },
    {
        id: 2,
        url: constants_Images__WEBPACK_IMPORTED_MODULE_2__/* .URL_LOGO_VNEXPRESS */ .VV,
        href: "https://startup.vnexpress.net/tin-tuc/xu-huong/nen-tang-phan-phoi-duoc-pham-an-nen-lam-ra-trong-covid-19-4178711.html",
        width: "200px",
        height: "104px"
    },
    {
        id: 3,
        url: constants_Images__WEBPACK_IMPORTED_MODULE_2__/* .URL_LOGO_24H */ ._6M,
        href: "https://www.24h.com.vn/tin-tuc-suc-khoe/thuocsivn-diem-cung-cap-thuoc-si-uy-tin-trong-thoi-dai-so-c683a1373539.html",
        width: "200px",
        height: "200px"
    },
    {
        id: 4,
        url: constants_Images__WEBPACK_IMPORTED_MODULE_2__/* .URL_LOGO_NTTDATA */ .ilf,
        href: "http://oi.nttdata.com/en/contest/9th/venue/c05",
        width: "166px",
        height: "203x"
    }, 
];
var imageMediaBottom = [
    {
        id: 1,
        url: constants_Images__WEBPACK_IMPORTED_MODULE_2__/* .URL_LOGO_ECHELON */ .u2W,
        href: "https://e27.co/our-ho-chi-minh-city-top100-winners-prove-that-the-vietnamese-dragon-is-awake-20190313",
        width: "165px",
        height: "103px",
        dark: true
    },
    {
        id: 2,
        url: constants_Images__WEBPACK_IMPORTED_MODULE_2__/* .URL_LOGO_BAOTIENPHONG */ .Yib,
        href: "https://tienphong.vn/gap-go-thuocsi-vn-don-vi-dung-cong-nghe-toi-uu-hoa-va-lam-moi-quy-trinh-phan-phoi-duoc-pham-post1448510.tpo",
        width: "200px",
        height: "100px"
    },
    {
        id: 3,
        url: constants_Images__WEBPACK_IMPORTED_MODULE_2__/* .URL_LOGO_CAFEBIZ */ .wes,
        href: "https://cafebiz.vn/case-study-buymed-thuocsivn-dung-doi-sales-chay-bang-com-go-cua-tung-nha-thuoc-nho-sau-3-nam-thu-hut-12000-don-vi-tham-gia-20220302175245576.chn",
        width: "200px",
        height: "63px"
    },
    {
        id: 4,
        url: constants_Images__WEBPACK_IMPORTED_MODULE_2__/* .URL_LOGO_E27 */ .Tr7,
        href: "https://e27.co/vietnamese-online-pharma-marketplace-thuocsi-vn-secures-us500k-from-cocoon-capital-vietcapital-ventures-20190926",
        width: "166px",
        height: "166px"
    }, 
];
var settingsCustomer = {
    slidesToShow: 2,
    slidesToScroll: 1,
    dots: true,
    dotsClass: "slick-dots slick-client",
    arrows: false,
    infinite: true,
    rows: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
        {
            breakpoint: 1198,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                rows: 1
            }
        },
        {
            breakpoint: 576,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                rows: 1
            }
        }, 
    ]
};
function SampleNextArrow(props) {
    var className = props.className, onClick = props.onClick;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: className,
        onClick: onClick,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_NavigateNext__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {})
    });
}
function SamplePrevArrow(props) {
    var className = props.className, onClick = props.onClick;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: className,
        onClick: onClick,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_NavigateBefore__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {})
    });
}
// deprecated 22Feb2023 - Dinh Tran
// function MobileSlideNextArrow(props) {
//   const { className, onClick } = props;
//   return (
//     <div className={className} onClick={onClick}>
//       <ICON_MOBILE_ICON_SLIDE_ARROW_RIGHT />
//     </div>
//   );
// }
// function MobileSlidePrevArrow(props) {
//   const { className, onClick } = props;
//   return (
//     <div className={className} onClick={onClick}>
//       <ICON_MOBILE_ICON_SLIDE_ARROW_RIGHT />
//     </div>
//   );
// }
var settingsMultiImageBoxV2 = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    nextArrow: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SampleNextArrow, {}),
    prevArrow: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SamplePrevArrow, {})
};
var settingsMobileMultiImageBoxV2 = {
    dots: false,
    infinite: false,
    slidesToShow: 4,
    swipeToSlide: true,
    rows: 1,
    speed: 500,
    nextArrow: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SampleNextArrow, {}),
    prevArrow: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SamplePrevArrow, {})
};
var settingsNewProducts = {
    slidesToShow: 5,
    slidesToScroll: 5,
    initialSlide: 0,
    rows: 1,
    arrows: true,
    infinite: false,
    autoplay: false,
    autoplaySpeed: 3000,
    speed: 1000,
    lazyLoad: true,
    nextArrow: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SampleNextArrow, {}),
    prevArrow: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SamplePrevArrow, {}),
    responsive: [
        {
            breakpoint: 564,
            settings: {
                arrow: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                centerMode: true
            }
        },
        {
            breakpoint: 640,
            settings: {
                arrow: false,
                variableWidth: true,
                slidesToShow: 2,
                slidesToScroll: 2,
                centerMode: true,
                centerPadding: "15px"
            }
        },
        {
            breakpoint: 960,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3
            }
        },
        {
            breakpoint: 1140,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 4
            }
        }, 
    ]
};
var settingsCustomerSeller = {
    slidesToShow: 3,
    slidesToScroll: 1,
    rows: 1,
    arrows: true,
    infinite: false,
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 1000,
    lazyLoad: true,
    responsive: [
        {
            breakpoint: 1198,
            settings: {
                slidesToShow: 2,
                rows: 1
            }
        },
        {
            breakpoint: 576,
            settings: {
                slidesToShow: 1,
                rows: 1
            }
        }, 
    ]
};
var settingsBestProduct = {
    className: "section-outstanding__slider bestproduct__slider",
    slidesToShow: 3,
    slidesToScroll: 3,
    initialSlide: 1,
    rows: 1,
    arrows: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2500,
    speed: 1000,
    lazyLoad: true,
    centerMode: true,
    responsive: [
        {
            breakpoint: 876,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                centerMode: false
            }
        },
        {
            breakpoint: 576,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                centerMode: true
            }
        }, 
    ]
};
// deprecated 22Feb2023 - Dinh Tran
// export const mobileSettingsBestProduct = {
//   className: 'mobileSection-outstanding__slider section-outstanding__slider bestproduct__slider mobileBestProduct__slider',
//   slidesToShow: 1,
//   slidesToScroll: 3,
//   initialSlide: 1,
//   rows: 1,
//   arrows: true,
//   infinite: true,
//   autoplay: true,
//   autoplaySpeed: 2500,
//   speed: 1000,
//   lazyLoad: true,
//   centerMode: true,
//   nextArrow: <MobileSlideNextArrow />,
//   prevArrow: <MobileSlidePrevArrow />,
// };
var settingsStore = {
    className: "section-outstanding__slider",
    slidesToShow: 4,
    slidesToScroll: 4,
    initialSlide: 0,
    rows: 1,
    arrows: true,
    infinite: false,
    autoplay: true,
    autoplaySpeed: 5000,
    speed: 1000,
    lazyLoad: true,
    responsive: [
        {
            breakpoint: 576,
            settings: {
                arrow: false,
                slidesToShow: 1,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 900,
            settings: {
                arrow: false,
                slidesToShow: 2,
                slidesToScroll: 2
            }
        },
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3
            }
        }, 
    ]
};
var settingsProduct = {
    className: "section-outstanding__slider",
    slidesToShow: 5,
    slidesToScroll: 5,
    initialSlide: 0,
    rows: 1,
    arrows: true,
    infinite: false,
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 1000,
    lazyLoad: true,
    responsive: [
        {
            breakpoint: 420,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 640,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2
            }
        },
        {
            breakpoint: 960,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3
            }
        },
        {
            breakpoint: 1140,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 4
            }
        }, 
    ]
};
var settingsPartner = {
    slidesToShow: 6,
    slidesToScroll: 1,
    arrows: false,
    infinite: true,
    rows: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    swipeToSlide: true,
    responsive: [
        {
            breakpoint: 1198,
            settings: {
                slidesToShow: 5,
                slidesToScroll: 2,
                rows: 1
            }
        },
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                rows: 1
            }
        },
        {
            breakpoint: 960,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                rows: 1
            }
        },
        {
            breakpoint: 576,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                rows: 1
            }
        }, 
    ]
};
// deprecated 22Feb2023 - Dinh Tran
// export const settingsPromotionSliderBanner = {
//   slidesToShow: 1,
//   slidesToScroll: 1,
//   dots: true,
//   arrows: true,
//   infinite: true,
//   rows: 1,
//   autoplay: true,
//   autoplaySpeed: 3000,
//   swipeToSlide: true,
//   nextArrow: <SampleNextArrow />,
//   prevArrow: <SamplePrevArrow />,
// };
// deprecated 22Feb2023 - Dinh Tran
// export const settingsPromotionMultipSliderBanner = {
//   slidesToShow: 1,
//   slidesPerRow: 3,
//   dots: true,
//   infinite: true,
//   rows: 2,
//   nextArrow: <SampleNextArrow />,
//   prevArrow: <SamplePrevArrow />,
//   responsive: [
//     {
//       breakpoint: 1198,
//       settings: {
//         slidesPerRow: 3,
//         slidesToShow: 1,
//         slidesToScroll: 2,
//         rows: 1,
//       },
//     },
//     {
//       breakpoint: 1024,
//       settings: {
//         slidesPerRow: 3,
//         slidesToShow: 1,
//         slidesToScroll: 1,
//         rows: 1,
//       },
//     },
//     {
//       breakpoint: 960,
//       settings: {
//         slidesPerRow: 2,
//         slidesToShow: 1,
//         slidesToScroll: 1,
//         rows: 1,
//       },
//     },
//     {
//       breakpoint: 576,
//       settings: {
//         slidesPerRow: 1,
//         slidesToShow: 1,
//         slidesToScroll: 1,
//         rows: 1,
//       },
//     },
//   ],
// };
var settingsSliderBanner = {
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    dotsClass: "slick-dots slick-thumb",
    arrows: false,
    infinite: true,
    rows: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    swipeToSlide: true
};
var settingsSliderBannerV2 = {
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: true,
    infinite: true,
    rows: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    swipeToSlide: true
};
var settingsTicket = {
    className: "left",
    speed: 500,
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    rows: 1,
    responsive: [
        {
            breakpoint: 767,
            settings: {
                arrow: false,
                variableWidth: true,
                slidesToShow: 2,
                slidesToScroll: 2
            }
        }, 
    ]
};
var swiperSettings = {
    modules: [
        swiper__WEBPACK_IMPORTED_MODULE_4__/* .Autoplay */ .pt,
        swiper__WEBPACK_IMPORTED_MODULE_4__/* .Pagination */ .tl,
        swiper__WEBPACK_IMPORTED_MODULE_4__/* .Navigation */ .W_
    ],
    slidesPerView: 1,
    pagination: {
        clickable: true
    },
    autoplay: {
        delay: 3000,
        disableOnInteraction: false
    },
    preloadImages: false,
    loop: true,
    lazy: {
        loadOnTransitionStart: true,
        loadPrevNext: true,
        loadPrevNextAmount: 2
    },
    speed: 2500,
    observer: true,
    observeParents: true
};
var linkQuestionItemLeft = [
    {
        id: 1,
        href: "https://thuocsi.zendesk.com/hc/vi/articles/360029452912-C%C3%A1ch-%C4%91%C4%83ng-k%C3%BD-v%C3%A0-%C4%91%C4%83ng-nh%E1%BA%ADp-t%C3%A0i-kho%E1%BA%A3n-t%E1%BA%A1i-thuocsi-vn",
        title: "C\xe1ch đăng k\xfd v\xe0 đăng nhập t\xe0i khoản tại thuocsi.vn"
    },
    {
        id: 2,
        href: "https://thuocsi.zendesk.com/hc/vi/articles/360030488231-Qu%C3%AAn-m%E1%BA%ADt-kh%E1%BA%A9u-%C4%91%C4%83ng-nh%E1%BA%ADp",
        title: "Qu\xean mật khẩu đăng nhập"
    },
    {
        id: 3,
        href: "https://thuocsi.zendesk.com/hc/vi/articles/360030159252-Nh%C6%B0-th%E1%BA%BF-n%C3%A0o-l%C3%A0-h%C3%A0ng-c%E1%BA%ADn-date-H%E1%BA%A1n-s%E1%BB%AD-d%E1%BB%A5ng-c%C3%B2n-bao-l%C3%A2u-",
        title: "Như thế n\xe0o l\xe0 h\xe0ng cận date? Hạn sử dụng c\xf2n bao l\xe2u?"
    },
    {
        id: 4,
        href: "https://thuocsi.zendesk.com/hc/vi/articles/360030900651-T%E1%BA%A1i-sao-t%C3%B4i-kh%C3%B4ng-thanh-to%C3%A1n-%C4%91%C6%B0%E1%BB%A3c",
        title: "Tại sao t\xf4i kh\xf4ng thanh to\xe1n được"
    },
    {
        id: 5,
        href: "https://thuocsi.zendesk.com/hc/vi/articles/360029396272-T%C3%B4i-mu%E1%BB%91n-ch%E1%BB%89nh-l%E1%BA%A1i-%C4%91%C6%A1n-h%C3%A0ng-th%C3%AC-l%C3%A0m-c%C3%A1ch-n%C3%A0o-",
        title: "T\xf4i muốn chỉnh lại đơn h\xe0ng th\xec l\xe0m c\xe1ch n\xe0o?"
    }, 
];
var linkQuestionItemRight = [
    {
        id: 1,
        href: "https://thuocsi.zendesk.com/hc/vi/articles/360029452652-H%C6%B0%E1%BB%9Bng-d%E1%BA%ABn-%C4%91%E1%BA%B7t-h%C3%A0ng",
        title: "⭑ Hướng dẫn đặt h\xe0ng"
    },
    {
        id: 2,
        href: "https://thuocsi.zendesk.com/hc/vi/articles/360029505332-D%C3%B9ng-th%E1%BB%AD-t%E1%BA%A1i-website-thuocsi-vn-",
        title: "D\xf9ng thử tại website thuocsi.vn"
    },
    {
        id: 3,
        href: "https://thuocsi.zendesk.com/hc/vi/articles/360029773811-Thanh-to%C3%A1n-b%E1%BA%B1ng-h%C3%ACnh-th%E1%BB%A9c-chuy%E1%BB%83n-kho%E1%BA%A3n-nh%C6%B0-th%E1%BA%BF-n%C3%A0o-",
        title: "Thanh to\xe1n bằng h\xecnh thức chuyển khoản như thế n\xe0o?"
    },
    {
        id: 4,
        href: "https://thuocsi.zendesk.com/hc/vi/articles/360029453432-Xu%E1%BA%A5t-h%C3%B3a-%C4%91%C6%A1n-%C4%91%E1%BB%8F-t%E1%BA%A1i-thuocsi-vn-",
        title: "Xuất h\xf3a đơn đỏ tại thuocsi.vn?"
    },
    {
        id: 5,
        href: "https://thuocsi.zendesk.com/hc/vi/articles/360030403531-Th%E1%BB%9Di-gian-giao-h%C3%A0ng-d%E1%BB%B1-ki%E1%BA%BFn",
        title: "Thời gian giao h\xe0ng dự kiến"
    }, 
];
// eslint-disable-next-line operator-linebreak
var LINK_ALL_QUESTION = "https://thuocsi.zendesk.com/hc/vi/categories/360001885792-C%C3%A2u-h%E1%BB%8Fi-th%C6%B0%E1%BB%9Dng-g%E1%BA%B7p-Q-A-";
var SORT_PRODUCT_NOT_LOGIN = [
    {
        label: "B\xe1n chạy nhất",
        value: "",
        code: "hot_sale"
    },
    {
        label: "Mới nhất",
        value: "NEWEST",
        code: "newest"
    },
    {
        label: "Gi\xe1: Cao đến Thấp",
        value: "PRICE_DESC",
        code: "price_desc"
    },
    {
        label: "Gi\xe1: Thấp đến Cao",
        value: "PRICE_ASC",
        code: "price_asc"
    },
    {
        label: "T\xean: A-Z",
        value: "NAME_ASC",
        code: "name_asc"
    },
    {
        label: "T\xean: Z-A",
        value: "NAME_DESC",
        code: "name_desc"
    }, 
];
var SORT_PRODUCT = [
    {
        label: "B\xe1n chạy nhất",
        value: "",
        code: "hot_sale"
    },
    {
        label: "Mới nhất",
        value: "NEWEST",
        code: "newest"
    },
    {
        label: "Gi\xe1: Cao đến Thấp",
        value: "PRICE_DESC",
        code: "price_desc"
    },
    {
        label: "Gi\xe1: Thấp đến Cao",
        value: "PRICE_ASC",
        code: "price_asc"
    },
    {
        label: "T\xean: A-Z",
        value: "NAME_ASC",
        code: "name_asc"
    },
    {
        label: "T\xean: Z-A",
        value: "NAME_DESC",
        code: "name_desc"
    },
    {
        label: "T\xean: Sản phẩm hết hạn",
        value: "PRODUCT_NEAR_EXPIRED",
        code: "product_near_expired"
    }, 
];
var tabsProductData = [
    {
        id: 1,
        label: "Th\xf4ng tin chung",
        value: "1",
        code: "description"
    },
    {
        id: 2,
        label: "Chỉ định",
        value: "2",
        code: "indication"
    },
    {
        id: 3,
        label: "Liều lượng - C\xe1ch d\xf9ng",
        value: "3",
        code: "dosage"
    },
    {
        id: 4,
        label: "Chống chỉ định",
        value: "4",
        code: "contraindication"
    },
    {
        id: 5,
        label: "Tương t\xe1c thuốc",
        value: "5",
        code: "drugInteraction"
    },
    {
        id: 6,
        label: "Bảo quản",
        value: "6",
        code: "storage"
    },
    {
        id: 7,
        label: "Qu\xe1 liều",
        value: "7",
        code: "drugOverdose"
    }, 
];
var tabsAccountInfo = [
    {
        id: 1,
        label: "Th\xf4ng tin t\xe0i khoản",
        value: "1",
        code: "personal_info"
    },
    {
        id: 2,
        label: "Mật khẩu",
        value: "2",
        code: "password"
    },
    {
        id: 3,
        label: "Th\xf4ng tin doanh nghiệp",
        value: "3",
        code: "business_info"
    },
    {
        id: 4,
        label: "T\xe0i khoản ng\xe2n h\xe0ng",
        value: "4",
        code: "bank_account"
    },
    {
        id: 5,
        label: "Th\xf4ng tin xuất ho\xe1 đơn",
        value: "5",
        code: "list_invoice_info"
    },
    {
        id: 6,
        label: "Th\xf4ng tin giao h\xe0ng",
        value: "6",
        code: "delivery_info"
    }, 
];
var tabsProductDataV2 = [
    {
        id: 1,
        label: "Th\xf4ng tin chung",
        value: "1",
        code: "description"
    },
    {
        id: 2,
        label: "Th\xe0nh phần",
        value: "2",
        code: "ingredients"
    },
    {
        id: 3,
        label: "Chỉ định",
        value: "3",
        code: "indication"
    },
    {
        id: 4,
        label: "Liều lượng - C\xe1ch d\xf9ng",
        value: "4",
        code: "dosage"
    },
    {
        id: 5,
        label: "Chống chỉ định",
        value: "5",
        code: "contraindication"
    },
    {
        id: 6,
        label: "Tương t\xe1c thuốc",
        value: "6",
        code: "drugInteraction"
    },
    {
        id: 7,
        label: "Bảo quản",
        value: "7",
        code: "storage"
    },
    {
        id: 8,
        label: "Qu\xe1 liều",
        value: "8",
        code: "drugOverdose"
    }, 
];
var customerFeedbackData = [
    {
        id: "1",
        avatar: "/images/testimonial/ms_anh-0f18d4903ee5d30ca79d458b799c4c2afa8e1d742e244885a218f831f68789b4.jpg",
        customer: "C\xf4 Lan Anh",
        title: "Chủ nh\xe0 thuốc H\xf2a B\xecnh - Bu\xf4n M\xea Thuột",
        comment: "Địa chỉ đ\xe1ng tin cậy. Đầy đủ h\xe0ng, giao h\xe0ng nhanh v\xe0 thuận tiện"
    },
    {
        id: "2",
        avatar: "/images/testimonial/ms_hang-2ddc116695f4f788b5968112a3185c73536f16a23a740f440c042c9d2057c611.jpg",
        customer: "C\xf4 Hằng",
        title: "Nh\xe0 thuốc Vy Vy - Thủ Đức",
        comment: "Giao h\xe0ng nhanh ch\xf3ng, nh\xe2n vi\xean tư vấn nhiệt t\xecnh."
    },
    {
        id: "3",
        avatar: "/images/testimonial/mr_truong-c6c1718f8fd631366d2ab383f238b9642a3b10ee5d95755a973f82b5c17ad4af.jpg",
        customer: "Anh Trường",
        title: "Nh\xe0 thuốc t\xe2y số 2 - Vĩnh Long",
        comment: "H\xe0ng h\xf3a đa dạng dễ d\xe0ng tra cứu gi\xe1 v\xe0 đặt h\xe0ng thuốc."
    },
    {
        id: "4",
        avatar: "/images/testimonial/ms_hanh-faacbd8f6c93413a7cba4dc60359dca0699b13e999f6681fbe2f0495cc530162.jpg",
        customer: "Chị Hạnh",
        title: "Nh\xe0 thuốc Hạnh - B\xecnh Thạnh",
        comment: "Chị biết v\xe0 đặt thuocsi.vn được hơn 1 năm, chị c\xf3 thể dễ d\xe0ng xem gi\xe1 c\xe1c thuốc v\xe0 c\xe2n chỉnh đơn h\xe0ng ngo\xe0i ra mỗi ng\xe0y đều c\xf3 sản phẩm mới gi\xfap nh\xe0 thuốc đa dạng hơn danh mục h\xe0ng."
    }, 
];
var PAGE_SIZE_10 = 10;
var PAGE_SIZE = 20;
var PAGE_SIZE_30 = 30;
var ONE_DAY = 86400000;
// export const HOLIDAYS = ['0209', '3004', '0105', '0204', '0101'];
var MAX_PRODUCT_QTY_DISPLAY = 100000;
var IMPORTANT_PERCENT_MAX = 20 / 100;
// search bar
var ENTERPRISE = "ENTERPRISE";
// export const SEARCH_TYPE = 'search-type';
var THUOC_VA_HOAT_CHAT = 1;
var HOAT_CHAT = 2;
var NHA_BAN_HANG = 3;
var THUOC = 4;
var SEARCH_TYPE_LIST = [
    {
        label: "Thuốc & Hoạt Chất",
        value: THUOC_VA_HOAT_CHAT
    },
    {
        label: "Thuốc",
        value: THUOC
    },
    {
        label: "Hoạt Chất",
        value: HOAT_CHAT
    },
    sysconfig__WEBPACK_IMPORTED_MODULE_5__/* .ENV_COUNTRY */ .ng === "vn" && {
        label: "Nh\xe0 B\xe1n H\xe0ng",
        value: NHA_BAN_HANG
    }, 
];
var orderTabList = [
    {
        id: 1,
        label: "order_code",
        value: "ORDER_ID"
    },
    {
        id: 2,
        label: "product",
        value: "PRODUCT"
    },
    {
        id: 3,
        label: "date",
        value: "TIME"
    }, 
];
// loyalty v2
var LoyaltyRulesContent = {
    code: "levelRules",
    content: "V\xe0o 0h mỗi ng\xe0y, hệ thống sẽ t\xednh điểm xếp hạng cho kh\xe1ch h\xe0ng, dựa tr\xean số đơn đ\xe3 ho\xe0n tất trong thời gian quy định. \n\n  •  V\xed dụ: Hệ thống quy định thời gian t\xednh điểm xếp hạng l\xe0 3 th\xe1ng tới thời điểm hiện tại. V\xe0o l\xfac 0h ng\xe0y 26/5/2021, ba th\xe1ng gần nhất sẽ được t\xednh từ 01/02/2021 tới 01/05/2021 v\xe0 cộng 25 ng\xe0y tới thời điểm hiện tại (26/5/2021). \n\nQuy đổi điểm theo: \n\n  •  100.000 vnđ sẽ được 1 điểm hoặc theo điểm t\xedch lũy được quy định cho sản phẩm đ\xf3. \n\n  •  Nếu sản phẩm c\xf3 hệ số nh\xe2n sẽ nh\xe2n l\xean tương ứng theo điểm quy đổi. \n\nTrường hợp do thiếu s\xf3t hay chậm trễ từ ph\xeda thuocsi.vn, kh\xe1ch h\xe0ng vui l\xf2ng li\xean hệ 02 873 008 840 hoặc hotro@thuocsi.vn để phản hồi về điểm."
};
// + link sản phẩm của trang khác
var PreventSearchKeywords = [
    "thuốc x\xe1ch tay",
    "h\xe0ng tuồn kho",
    "thuốc hết hạn",
    "thuốc ph\xe1 gi\xe1",
    "thuốc ph\xe1 thai",
    "h\xe0ng chợ",
    "ma tu\xfd",
    "heroine",
    "s\xfang",
    "lựu đạn",
    "bom",
    "m\xecn",
    "kiếm",
    "m\xe1c",
    "facebook",
    "lazada",
    "shopee",
    "tiki",
    "l\xea",
    "dao găm",
    "cung nỏ",
    "ph\xe1o",
    "thuốc l\xe1",
    "x\xec g\xe0",
    "thuốc trừ s\xe2u",
    "amfibole",
    "amiăng",
    "h\xe0ng lậu",
    "độc hại",
    "độc tố",
    "cấm khai th\xe1c",
    "hoang d\xe3",
    "qu\xfd hiếm",
    "tuyệt đối",
    "ch\xednh x\xe1c",
    "dứt điểm",
    "cam kết hiệu quả",
    "điều trị tận gốc",
    "tiệt trừ",
    "h\xe0ng đầu",
    "đầu tay",
    "chất lượng nhất",
    "t\xe1c dụng ngay",
    "giảm ngay",
    "cắt đứt",
    "giảm tức th\xec",
    "khỏi hẳn",
    "kh\xf4ng lo",
    "phải d\xf9ng",
    "thuốc số 1",
    "thuốc số một",
    "tốt hơn tất cả",
    "ho\xe0n to\xe0n v\xf4 hại",
    "kh\xf4ng t\xe1c dụng phụ",
    "thần dược",
    "hotline",
    "li\xean hệ qua",
    "số điện thoại",
    "địa chỉ",
    "số t\xe0i khoản",
    "chuyển tiền",
    "mua h\xe0ng qua đường link",
    "thuốc ph\xe1 thai",
    "thuốc độc", 
];
var PreventSearchKeywordsAlias = PreventSearchKeywords === null || PreventSearchKeywords === void 0 ? void 0 : PreventSearchKeywords.filter(function(item) {
    return item.split(" ").length > 1;
}).map(function(item) {
    return utils__WEBPACK_IMPORTED_MODULE_6__/* .StringUtils.changeAlias */ .xZ.changeAlias(item);
});
var getTrackingData = function(url) {
    var dataTracking = [
        {
            action: "CLICK_GO_TO_PRODUCTS_PAGE",
            trackingPath: "/products"
        },
        {
            action: "CLICK_GO_TO_INGREDIENTS_PAGE",
            trackingPath: "/ingredients"
        },
        {
            action: "CLICK_GO_TO_QUICKORDER_PAGE",
            trackingPath: "/quick-order"
        },
        {
            action: "CLICK_GO_TO_CAMPAIGN_PAGE",
            trackingPath: "".concat(constants_Paths__WEBPACK_IMPORTED_MODULE_3__/* .PATH_PROMOTIONS */ .qJ)
        },
        {
            action: "CLICK_GO_TO_PROMO_CODES_PAGE",
            trackingPath: "/promo-codes"
        },
        {
            action: "CLICK_GO_TO_SELLER_PAGE",
            trackingPath: "/sellers"
        }, 
    ];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // eslint-disable-next-line no-restricted-syntax
        for(var _iterator = dataTracking[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var data = _step.value;
            if (url.includes(data.trackingPath)) return data;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return {
        action: "CLICK_GO_TO_EVENTS_PAGE",
        trackingPath: "/events"
    };
};
var SCREEN_TO_ENUM_TRACKING_SOURCE_MAP = {
    "/quick-order": constants_Enums__WEBPACK_IMPORTED_MODULE_1__/* .ENUM_TRACKING_SOURCE.QUICK_ORDER */ .Ii.QUICK_ORDER,
    "/products": constants_Enums__WEBPACK_IMPORTED_MODULE_1__/* .ENUM_TRACKING_SOURCE.PRODUCT_LIST */ .Ii.PRODUCT_LIST,
    "/khuyenmai": constants_Enums__WEBPACK_IMPORTED_MODULE_1__/* .ENUM_TRACKING_SOURCE.PROMOTION */ .Ii.PROMOTION,
    "/khuyenmai/[slug]": constants_Enums__WEBPACK_IMPORTED_MODULE_1__/* .ENUM_TRACKING_SOURCE.PROMOTION */ .Ii.PROMOTION,
    PATH_PROMOTIONS: constants_Enums__WEBPACK_IMPORTED_MODULE_1__/* .ENUM_TRACKING_SOURCE.PROMOTION */ .Ii.PROMOTION,
    "/promotions/[slug]": constants_Enums__WEBPACK_IMPORTED_MODULE_1__/* .ENUM_TRACKING_SOURCE.PROMOTION */ .Ii.PROMOTION,
    "/list-product": constants_Enums__WEBPACK_IMPORTED_MODULE_1__/* .ENUM_TRACKING_SOURCE.SELLER_HOME */ .Ii.SELLER_HOME,
    "/seller/[slug]": constants_Enums__WEBPACK_IMPORTED_MODULE_1__/* .ENUM_TRACKING_SOURCE.SELLER_HOME */ .Ii.SELLER_HOME,
    "/seller/[slug]/list-product": constants_Enums__WEBPACK_IMPORTED_MODULE_1__/* .ENUM_TRACKING_SOURCE.SELLER_HOME */ .Ii.SELLER_HOME,
    "/seller/[slug]/rewards": constants_Enums__WEBPACK_IMPORTED_MODULE_1__/* .ENUM_TRACKING_SOURCE.SELLER_HOME */ .Ii.SELLER_HOME,
    "/flagship-store/[slug]": constants_Enums__WEBPACK_IMPORTED_MODULE_1__/* .ENUM_TRACKING_SOURCE.SELLER_HOME */ .Ii.SELLER_HOME,
    "/flagship-store/durex": constants_Enums__WEBPACK_IMPORTED_MODULE_1__/* .ENUM_TRACKING_SOURCE.SELLER_HOME */ .Ii.SELLER_HOME,
    "/flagship-store/sanofi": constants_Enums__WEBPACK_IMPORTED_MODULE_1__/* .ENUM_TRACKING_SOURCE.SELLER_HOME */ .Ii.SELLER_HOME,
    "/flagship-store/[slug]/list-product": constants_Enums__WEBPACK_IMPORTED_MODULE_1__/* .ENUM_TRACKING_SOURCE.SELLER_HOME */ .Ii.SELLER_HOME,
    "/flagship-store/durex/list-product": constants_Enums__WEBPACK_IMPORTED_MODULE_1__/* .ENUM_TRACKING_SOURCE.SELLER_HOME */ .Ii.SELLER_HOME,
    "/flagship-store/sanofi/list-product": constants_Enums__WEBPACK_IMPORTED_MODULE_1__/* .ENUM_TRACKING_SOURCE.SELLER_HOME */ .Ii.SELLER_HOME,
    "/flagship-store/[slug]/flagship-rewards": constants_Enums__WEBPACK_IMPORTED_MODULE_1__/* .ENUM_TRACKING_SOURCE.SELLER_HOME */ .Ii.SELLER_HOME,
    "/seller-products/[slug]": constants_Enums__WEBPACK_IMPORTED_MODULE_1__/* .ENUM_TRACKING_SOURCE.SELLER_HOME */ .Ii.SELLER_HOME,
    "/": constants_Enums__WEBPACK_IMPORTED_MODULE_1__/* .ENUM_TRACKING_SOURCE.HOME */ .Ii.HOME,
    "/product/[slug]": constants_Enums__WEBPACK_IMPORTED_MODULE_1__/* .ENUM_TRACKING_SOURCE.PRODUCT_DETAIL */ .Ii.PRODUCT_DETAIL,
    "/products/[slug]": constants_Enums__WEBPACK_IMPORTED_MODULE_1__/* .ENUM_TRACKING_SOURCE.PRODUCT_DETAIL */ .Ii.PRODUCT_DETAIL
};
var SOURCE_TO_ENUM_TRACKING_SOURCE_MAP = {
    "/quick-order": constants_Enums__WEBPACK_IMPORTED_MODULE_1__/* .ENUM_TRACKING_SOURCE.QUICK_ORDER */ .Ii.QUICK_ORDER,
    "/products": constants_Enums__WEBPACK_IMPORTED_MODULE_1__/* .ENUM_TRACKING_SOURCE.PRODUCT_LIST */ .Ii.PRODUCT_LIST,
    "/khuyenmai": constants_Enums__WEBPACK_IMPORTED_MODULE_1__/* .ENUM_TRACKING_SOURCE.PROMOTION */ .Ii.PROMOTION,
    "/khuyenmai/[slug]": constants_Enums__WEBPACK_IMPORTED_MODULE_1__/* .ENUM_TRACKING_SOURCE.PROMOTION */ .Ii.PROMOTION,
    "/promotions": constants_Enums__WEBPACK_IMPORTED_MODULE_1__/* .ENUM_TRACKING_SOURCE.PROMOTION */ .Ii.PROMOTION,
    "/promotions/[slug]": constants_Enums__WEBPACK_IMPORTED_MODULE_1__/* .ENUM_TRACKING_SOURCE.PROMOTION */ .Ii.PROMOTION,
    "/wishlist": constants_Enums__WEBPACK_IMPORTED_MODULE_1__/* .ENUM_TRACKING_SOURCE.WISHLIST */ .Ii.WISHLIST,
    "/productviewed": constants_Enums__WEBPACK_IMPORTED_MODULE_1__/* .ENUM_TRACKING_SOURCE.VIEWED_LIST */ .Ii.VIEWED_LIST,
    "/list-product": constants_Enums__WEBPACK_IMPORTED_MODULE_1__/* .ENUM_TRACKING_SOURCE.SELLER_HOME */ .Ii.SELLER_HOME,
    "/seller/[slug]": constants_Enums__WEBPACK_IMPORTED_MODULE_1__/* .ENUM_TRACKING_SOURCE.SELLER_HOME */ .Ii.SELLER_HOME,
    "/seller/[slug]/list-product": constants_Enums__WEBPACK_IMPORTED_MODULE_1__/* .ENUM_TRACKING_SOURCE.SELLER_HOME */ .Ii.SELLER_HOME,
    "/seller/[slug]/rewards": constants_Enums__WEBPACK_IMPORTED_MODULE_1__/* .ENUM_TRACKING_SOURCE.SELLER_HOME */ .Ii.SELLER_HOME,
    "/flagship-store/[slug]": constants_Enums__WEBPACK_IMPORTED_MODULE_1__/* .ENUM_TRACKING_SOURCE.SELLER_HOME */ .Ii.SELLER_HOME,
    "/flagship-store/durex": constants_Enums__WEBPACK_IMPORTED_MODULE_1__/* .ENUM_TRACKING_SOURCE.SELLER_HOME */ .Ii.SELLER_HOME,
    "/flagship-store/sanofi": constants_Enums__WEBPACK_IMPORTED_MODULE_1__/* .ENUM_TRACKING_SOURCE.SELLER_HOME */ .Ii.SELLER_HOME,
    "/flagship-store/[slug]/list-product": constants_Enums__WEBPACK_IMPORTED_MODULE_1__/* .ENUM_TRACKING_SOURCE.SELLER_HOME */ .Ii.SELLER_HOME,
    "/flagship-store/durex/list-product": constants_Enums__WEBPACK_IMPORTED_MODULE_1__/* .ENUM_TRACKING_SOURCE.SELLER_HOME */ .Ii.SELLER_HOME,
    "/flagship-store/sanofi/list-product": constants_Enums__WEBPACK_IMPORTED_MODULE_1__/* .ENUM_TRACKING_SOURCE.SELLER_HOME */ .Ii.SELLER_HOME,
    "/flagship-store/[slug]/flagship-rewards": constants_Enums__WEBPACK_IMPORTED_MODULE_1__/* .ENUM_TRACKING_SOURCE.SELLER_HOME */ .Ii.SELLER_HOME,
    "/seller-products/[slug]": constants_Enums__WEBPACK_IMPORTED_MODULE_1__/* .ENUM_TRACKING_SOURCE.SELLER_HOME */ .Ii.SELLER_HOME,
    "/product/[slug]": constants_Enums__WEBPACK_IMPORTED_MODULE_1__/* .ENUM_TRACKING_SOURCE.PRODUCT_DETAIL */ .Ii.PRODUCT_DETAIL,
    "/products/[slug]": constants_Enums__WEBPACK_IMPORTED_MODULE_1__/* .ENUM_TRACKING_SOURCE.PRODUCT_DETAIL */ .Ii.PRODUCT_DETAIL
};
// SEO
var DEFAULT_THUOCSI_SUBTITLE = "ร้านยาขายส่งและเวชภัณฑ์ออนไลน์ | Buymed Thailand";
var DEFAULT_THUOCSI_TITLE = "buymed.co.th";
var DEFAULT_THUOCSI_LONG_TITLE = "ร้านยาขายส่งและเวชภัณฑ์ออนไลน์ | Buymed Thailand";
var DEFAULT_THUOCSI_DESCRIPTION = "ร้านยาขายส่งและเวชภัณฑ์ออนไลน์ ครบกว่า 10,000 รายการ สำหรับคลินิก ร้านขายยา สถานพยาบาล จัดส่งทั่วไทย สั่งซื้อได้ตลอด 24 ชม.";
// bulk-order
var DEFAULT_BULK_ORDER_TITLE = "ร้านยาขายส่งและเวชภัณฑ์ออนไลน์ | Buymed Thailand";
// CONFIG TAB HARDCODE
var TAB_CONFIG = {
    Y7GB: {
        icon: constants_Images__WEBPACK_IMPORTED_MODULE_2__/* .HANG_DIEM_ICON */ .Vzf,
        textColor: "#000",
        borderColor: "transparent"
    },
    DEFAULT: {
        textColor: "#000",
        borderColor: "transparent",
        icon: ""
    }
};
var PASSWORD_SECURITY_WARNING = "Nh\xe2n vi\xean thuocsi.vn kh\xf4ng y\xeau cầu cung cấp mật khẩu t\xe0i khoản. Qu\xfd kh\xe1ch vui l\xf2ng bảo vệ t\xe0i khoản c\xe1 nh\xe2n.";
var MAP_BTN_TITLE_BY_REDIRECT_URL = {
    "/sanphammoi": "btn.MAP_BTN_TITLE_BY_REDIRECT_URL./sanphammoi"
};
var CAMPAIGN_STATUS = {
    active: "ACTIVE",
    disabled: "DISABLED",
    next: "NEXT"
};
var SECTION_CODE = {
    FLASH_SALES: "FLASH_SALES",
    DEALS: "DEALS",
    PROMOTION: "PROMOTION",
    TAGS: "TAGS",
    FOR_YOU: "FOR_YOU"
};


/***/ }),

/***/ 59893:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ TopManufacturer; }
/* harmony export */ });
var TopManufacturer = [
    "A6EQ1PGEQ1",
    "F2V84FW961",
    "HXDBCV84FW",
    "TA2AXHR2AX",
    "UD72AXHR2A",
    "KVPGEQ1PGE",
    "8LCV84FW96",
    "TTYJYJYJYJ",
    "2E84FW961P",
    "G8T61PGEQ1",
    "H8R2AXHR2A",
    "WHJYJYJYJY",
    "BVPGEQ1PGE",
    "DUU72AXHR2", 
];
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
    TopManufacturer: TopManufacturer
});


/***/ }),

/***/ 58530:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Ho": function() { return /* binding */ AuthProvider; },
  "sV": function() { return /* binding */ LoadingRoute; },
  "aC": function() { return /* binding */ useAuth; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/clients/index.js + 20 modules
var clients = __webpack_require__(15149);
// EXTERNAL MODULE: ./src/components/organisms/LoadingScreen/index.js
var LoadingScreen = __webpack_require__(37071);
;// CONCATENATED MODULE: ./src/constants/Cookies/index.js
var REMEMBER_ME = "ts_auth_remember_me";
var COOKIE_AUTH_TYPE = "";

// EXTERNAL MODULE: ./src/constants/Enums/index.js
var Enums = __webpack_require__(71569);
// EXTERNAL MODULE: ./src/constants/Enums/http.js
var http = __webpack_require__(53208);
// EXTERNAL MODULE: ./src/constants/Paths/index.js
var Paths = __webpack_require__(199);
// EXTERNAL MODULE: ./src/hooks/index.js + 9 modules
var hooks = __webpack_require__(91866);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/hooks/useLocalStorageState.js


var useLocalStorageState = function(key) {
    var defaultValue = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, _serialize = ref.serialize, serialize = _serialize === void 0 ? JSON.stringify : _serialize, _deserialize = ref.deserialize, deserialize = _deserialize === void 0 ? JSON.parse : _deserialize;
    var ref1 = (0,_sliced_to_array/* default */.Z)(react.useState(function() {
        if (true) {
            // here `window` is available
            var valueInLocalStorage = window.localStorage.getItem(key);
            if (valueInLocalStorage) {
                try {
                    return deserialize(valueInLocalStorage);
                } catch (error) {
                    window.localStorage.removeItem(key);
                }
            }
        }
        return typeof defaultValue === "function" ? defaultValue() : defaultValue;
    }), 2), state = ref1[0], setState = ref1[1];
    var prevKeyRef = react.useRef(key);
    react.useEffect(function() {
        var prevKey = prevKeyRef.current;
        if (prevKey !== key) {
            window.localStorage.removeItem(prevKey);
        }
        prevKeyRef.current = key;
        try {
            window.localStorage.setItem(key, serialize(state));
        } catch (error) {
            window.localStorage.removeItem(key);
        }
    }, [
        key,
        state,
        serialize
    ]);
    return [
        state,
        setState
    ];
};
/* harmony default export */ var hooks_useLocalStorageState = (useLocalStorageState);

// EXTERNAL MODULE: ./node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__(36808);
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 6 modules
var esm = __webpack_require__(5233);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/services/AuthService.js
var AuthService = __webpack_require__(59606);
// EXTERNAL MODULE: ./src/sysconfig/index.js
var sysconfig = __webpack_require__(66225);
;// CONCATENATED MODULE: ./src/services/SettingService.js




var getListSetting = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx, res, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ctx = param.ctx;
                    _tmp = {};
                    return [
                        4,
                        clients/* SettingClient.getSettingList */.z9.getSettingList((_tmp.ctx = ctx, _tmp))
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res
                    ];
            }
        });
    });
    return function getListSetting(_) {
        return _ref.apply(this, arguments);
    };
}();
var getSettingInWeb = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var user, isDisplayNotiTopBar, settingWeb, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            user = param.user;
            isDisplayNotiTopBar = sysconfig/* PROVINCES_TURN_OFF_PAYMENT.indexOf */.qv.indexOf("ALL") >= 0 || (sysconfig/* PROVINCES_TURN_OFF_PAYMENT */.qv === null || sysconfig/* PROVINCES_TURN_OFF_PAYMENT */.qv === void 0 ? void 0 : sysconfig/* PROVINCES_TURN_OFF_PAYMENT.indexOf */.qv.indexOf(user === null || user === void 0 ? void 0 : user.provinceCode)) >= 0 || false;
            _tmp = {};
            settingWeb = (_tmp.MAX_ORDER_IN_WEEK = sysconfig/* MAX_ORDER_IN_WEEK */.YC, _tmp.MAX_SKU_IN_ORDER = sysconfig/* MAX_SKU_IN_ORDER */.n$, _tmp.// totalOrderInWeek,
            isDisplayNotiTopBar = isDisplayNotiTopBar, _tmp.content = sysconfig/* NOTIFY_IN_TOP_BAR */.FO, _tmp.canOrderInWeek = sysconfig/* MAX_ORDER_IN_WEEK */.YC, _tmp.isDisablePayment = isDisplayNotiTopBar, _tmp);
            return [
                2,
                settingWeb
            ];
        });
    });
    return function getSettingInWeb(_) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var SettingService = ({
    getListSetting: getListSetting,
    getSettingInWeb: getSettingInWeb
});

// EXTERNAL MODULE: ./src/services/UserService.js
var UserService = __webpack_require__(89349);
// EXTERNAL MODULE: ./src/utils/index.js + 5 modules
var utils = __webpack_require__(76480);
// EXTERNAL MODULE: ./src/utils/InactiveCustomerUtils.js
var InactiveCustomerUtils = __webpack_require__(29183);
// EXTERNAL MODULE: ./src/utils/Insider.js
var Insider = __webpack_require__(78130);
;// CONCATENATED MODULE: ./src/utils/localStorageUtils.js
var LIST_STORAGE_KEY_NOT_CLEAR = [
    "timeBindingLINE"
];
var clearStorage = function() {
    if (window && window.localStorage) {
        // eslint-disable-next-line no-restricted-syntax
        for(var key in localStorage){
            if (!(key === null || key === void 0 ? void 0 : key.startsWith("ins")) && !(key === null || key === void 0 ? void 0 : key.startsWith("sp")) && !LIST_STORAGE_KEY_NOT_CLEAR.includes(key)) {
                localStorage.removeItem(key);
            }
        }
    }
};
/* harmony default export */ var localStorageUtils = ({
    clearStorage: clearStorage
});

// EXTERNAL MODULE: ./src/utils/maac.js
var maac = __webpack_require__(36753);
// EXTERNAL MODULE: ./src/utils/MonitorUtils.js + 1 modules
var MonitorUtils = __webpack_require__(79903);
// EXTERNAL MODULE: ./src/utils/SessionUtils.js
var SessionUtils = __webpack_require__(69702);
// EXTERNAL MODULE: ./src/zustand-lib/storeGlobal.js + 1 modules
var storeGlobal = __webpack_require__(39423);
// EXTERNAL MODULE: ./src/zustand-lib/storeMobile.js
var storeMobile = __webpack_require__(35810);
// EXTERNAL MODULE: ./src/zustand-lib/useChatGuest.js
var useChatGuest = __webpack_require__(51400);
;// CONCATENATED MODULE: ./src/context/Auth/index.js
/* eslint-disable import/no-named-as-default-member */ /* eslint-disable no-unused-vars */ /* eslint-disable react-hooks/rules-of-hooks */ /* eslint-disable no-return-assign */ 





























var AuthContext = /*#__PURE__*/ (0,react.createContext)({});
var SSR_GUEST_CONTENT_ROUTES = [
    "/product/[slug]"
];
var AuthProvider = function(param) {
    var children = param.children, isShowingLogin = param.isShowingLogin, referCode = param.referCode, tokenv1 = param.tokenv1, token = param.token, redirectUrl = param.redirectUrl, _initialName = param.initialName, initialName = _initialName === void 0 ? "" : _initialName, _initDisplayProduct = param.initDisplayProduct, initDisplayProduct = _initDisplayProduct === void 0 ? "" : _initDisplayProduct, initAccount = param.initAccount, initUser = param.initUser;
    // export const AuthProvider = ({ children, isShowingLogin, tokenv1 }) => {
    var ref = (0,react.useState)(null), user = ref[0], setUser = ref[1];
    var ref1 = (0,react.useState)(null), customerInfo = ref1[0], setCustomerInfo = ref1[1];
    // const [bankInfo, setBankInfo] = useState(null);
    var ref2 = (0,react.useState)(false), isAuthenticated = ref2[0], setIsAuthenticated = ref2[1];
    var router = (0,next_router.useRouter)();
    var pathname = router.pathname, query = router.query;
    // SEO: khách chưa đăng nhập ở route public render nội dung ngay từ server, Googlebot không phải chờ JS.
    // Trạng thái auth của khách đã đúng từ đầu (user null). User đã đăng nhập giữ màn loading như cũ
    var ref3 = (0,react.useState)(function() {
        return !!initUser || !SSR_GUEST_CONTENT_ROUTES.includes(pathname);
    }), isLoading = ref3[0], setIsLoading = ref3[1];
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useModal */.dd)(isShowingLogin), 2), isShowLogin = ref4[0], toggleLogin = ref4[1];
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useModal */.dd)(false), 3), isShowSignUp = ref5[0], toggleSignUpFunc = ref5[1], getValShowSignUp = ref5[2];
    (0,react.useEffect)(function() {
        if (pathname === "/home" && query.signup === "t" || !!referCode) {
            toggleSignUpFunc();
        }
    }, [
        query.signup,
        referCode
    ]);
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useModal */.dd)(), 2), isShowForgetPassword = ref6[0], toggleForgetPassword = ref6[1];
    var ref7 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useModal */.dd)(), 2), isShowChangePassword = ref7[0], toggleChangePassword = ref7[1];
    var ref8 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useModal */.dd)(false), 2), isShowRegisterGuest = ref8[0], toggleRegisterGuest = ref8[1];
    var ref9 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useModal */.dd)(false), 2), isShowForgotPassMess = ref9[0], toggleShowForgotPassMess = ref9[1];
    var ref10 = (0,_sliced_to_array/* default */.Z)(hooks_useLocalStorageState("isMobilePaging", initDisplayProduct), 2), mobileDisplayProduct = ref10[0], setMobileDisplayProduct = ref10[1];
    var isMobileV2 = (0,storeMobile/* default */.Z)(function(state) {
        return state.isMobileV2();
    });
    var appConfig = (0,storeGlobal/* useStore */.o)(function(state) {
        return state.appConfig;
    });
    var removeGuestId = (0,useChatGuest/* default */.Z)(function(state) {
        return state.removeGuestId;
    });
    var removeGuestInfo = (0,useChatGuest/* default */.Z)(function(state) {
        return state.removeGuestInfo;
    });
    var ref11 = (0,esm/* useTranslation */.$G)("alert-action"), translateAlertAction = ref11.t;
    // const getDataMostSearch = useCallback(() => MostSearchData, []);
    // TODO:
    // change password
    (0,react.useEffect)(function() {
        setUser(initUser);
        setCustomerInfo(initUser);
        setIsAuthenticated(!!initUser);
        setIsLoading(false);
        var account = (initUser || {}).account;
        var isTempPassword = (account || {}).isTempPassword;
        if (isTempPassword) {
            toggleChangePassword();
        }
        // FOR LOG tele
        if (initUser && (initUser === null || initUser === void 0 ? void 0 : initUser.customerID)) {
            js_cookie_default().set("customerId", initUser === null || initUser === void 0 ? void 0 : initUser.customerID);
        }
        // Insider: push user data vào InsiderQueue 1 lần duy nhất ở root-level.
        // Đảm bảo user data nằm trong queue TRƯỚC khi bất kỳ page orchestrator nào gọi init.
        Insider/* default.initUser */.ZP.initUser(initUser);
        // MAAC WebSDK Identify: gắn browsing footprint ẩn danh vào member để MAAC map sang LINE user.
        // Không có bước này thì purchase có về đủ nhưng workflow gửi LINE message vẫn không chạy.
        // Đặt ở đây (thay vì trong từng hàm login) để cover cả login mới lẫn session đã đăng nhập sẵn;
        // maac.identify tự guard theo customerId nên không push trùng, và tự bỏ qua khách ẩn danh.
        maac/* default.identify */.Z.identify(initUser);
    }, [
        initUser
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var toggleSignUp = function() {
        if (!isShowSignUp) {
            utils/* gtag.register */.SX.register();
        }
        toggleSignUpFunc();
    };
    var ref12 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useModal */.dd)(false), 2), isShowBlockAccountMess = ref12[0], toggleShowBlockAccountMess = ref12[1];
    var ref13 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useModal */.dd)(false), 3), isShowDeleteAccountMess = ref13[0], toggleShowDeleteAccountMess = ref13[1], getValResponseDeleteAccountMess = ref13[2];
    var ref14 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useModal */.dd)(false), 3), isShowNotFoundAccountMess = ref14[0], toggleShowNotFoundAccountMess = ref14[1], getValShowResponseNotFoundAccountMess = ref14[2];
    var ref15 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useModal */.dd)(), 2), isShowGuestExpiredTime = ref15[0], toggleShowGuestExpiredTime = ref15[1];
    var ref16 = (0,react.useState)(""), auth = ref16[0], setAuth = ref16[1];
    var handleChangeForget = (0,react.useCallback)(function() {
        toggleLogin();
        toggleForgetPassword();
    }, [
        toggleLogin,
        toggleForgetPassword
    ]);
    var handleChangeSignIn = (0,react.useCallback)(function() {
        toggleSignUp();
        toggleLogin();
        if (isMobileV2) {
            toggleSignUp();
        }
    }, [
        toggleSignUp,
        toggleLogin
    ]);
    var handleChangePassword = (0,react.useCallback)(function() {
        toggleChangePassword();
    }, [
        toggleChangePassword
    ]);
    var handleChangeSignUp = (0,react.useCallback)(function() {
        toggleLogin();
        toggleSignUp();
    }, [
        toggleLogin,
        toggleSignUp
    ]);
    var handleChangeRegisterGuest = (0,react.useCallback)(function() {
        toggleLogin();
        toggleRegisterGuest();
    }, [
        toggleLogin,
        toggleRegisterGuest
    ]);
    var setCookies = (0,react.useCallback)(function(info) {
        var rememberMe = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        var _bearerToken = info.bearerToken, bearerToken = _bearerToken === void 0 ? null : _bearerToken;
        js_cookie_default().set(sysconfig/* ACCESS_TOKEN */.LA, bearerToken, {
            domain: sysconfig/* GENERAL_DOMAIN */.oC,
            sameSite: "Lax"
        });
        js_cookie_default().set(REMEMBER_ME, rememberMe, {
            domain: sysconfig/* GENERAL_DOMAIN */.oC,
            sameSite: "Lax"
        });
        if (rememberMe) {
            js_cookie_default().set(sysconfig/* ACCESS_TOKEN_LONGLIVE */.R$, bearerToken, {
                expires: 5000,
                domain: sysconfig/* GENERAL_DOMAIN */.oC,
                sameSite: "Lax"
            });
        }
    }, []);
    // red customer
    var handleRedCustomer = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var userRes, ref, userInfo;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            clients/* AuthClient.getUser */.LY.getUser()
                        ];
                    case 1:
                        userRes = _state.sent();
                        if ((0,clients/* isValid */.JY)(userRes)) {
                            ;
                            userInfo = (0,clients/* getFirst */.Xi)(userRes);
                            if ((userInfo === null || userInfo === void 0 ? void 0 : (ref = userInfo.tags) === null || ref === void 0 ? void 0 : ref.indexOf(Enums/* CUSTOMER_TAG.BAN */.lk.BAN)) >= 0) {
                                router.push("/block-account");
                                return [
                                    2,
                                    true
                                ];
                            }
                        }
                        return [
                            2,
                            false
                        ];
                }
            });
        });
        return function handleRedCustomer() {
            return _ref.apply(this, arguments);
        };
    }();
    var removeCookies = function() {
        js_cookie_default().remove(sysconfig/* ACCESS_TOKEN */.LA);
        js_cookie_default().remove(sysconfig/* ACCESS_TOKEN */.LA, {
            domain: sysconfig/* GENERAL_DOMAIN */.oC
        });
        js_cookie_default().remove(sysconfig/* ACCESS_TOKEN_LONGLIVE */.R$);
        js_cookie_default().remove(sysconfig/* ACCESS_TOKEN_LONGLIVE */.R$, {
            domain: sysconfig/* GENERAL_DOMAIN */.oC
        });
    };
    // 18 Oct 2021 : thêm thông tin bank info vào customerInfo
    var getUserInfo = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var ss, res, ref, ref1, customerInfoData, ref2, bankInfoRes, accountInfoRes, _tmp, _tmp1, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        4,
                        ,
                        5
                    ]);
                    ss = (0,SessionUtils/* getSessionTokenClient */.cQ)();
                    if (!ss || ss.length === 0) return [
                        2,
                        null
                    ];
                    return [
                        4,
                        UserService/* default.getAccount */.ZP.getAccount()
                    ];
                case 1:
                    res = _state.sent();
                    if ((res === null || res === void 0 ? void 0 : res.status) === "EXISTED" && res.errorCode === "RE_LOGIN_REQUIRED") {
                        removeCookies();
                        (0,SessionUtils/* setSessionTokenClient */.fR)(res.data[0].ssoToken);
                        // reload
                        window.location.reload();
                        return [
                            2,
                            res
                        ];
                    }
                    if (!(0,clients/* isValid */.JY)(res)) return [
                        3,
                        3
                    ];
                    customerInfoData = (0,clients/* getFirst */.Xi)(res);
                    _tmp = {};
                    _tmp1 = {};
                    return [
                        4,
                        Promise.all([
                            clients/* CustomerClient.getBankAccountInfo */.YP.getBankAccountInfo(_tmp),
                            UserService/* default.getAccountInfo */.ZP.getAccountInfo(_tmp1)
                        ])
                    ];
                case 2:
                    ref2 = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                        _state.sent(),
                        2
                    ]), bankInfoRes = ref2[0], accountInfoRes = ref2[1];
                    customerInfoData.bank = (0,clients/* getFirst */.Xi)(bankInfoRes);
                    customerInfoData.account = ((ref = (0,clients/* getFirst */.Xi)(accountInfoRes)) === null || ref === void 0 ? void 0 : ref.account) || null;
                    customerInfoData.session = ((ref1 = (0,clients/* getFirst */.Xi)(accountInfoRes)) === null || ref1 === void 0 ? void 0 : ref1.session) || null;
                    setCustomerInfo(customerInfoData);
                    return [
                        2,
                        res
                    ];
                case 3:
                    if (res.status === http/* HTTP_STATUS.Unauthorized */.M.Unauthorized) {
                        removeCookies();
                    }
                    return [
                        3,
                        5
                    ];
                case 4:
                    error = _state.sent();
                    // eslint-disable-next-line no-console
                    console.error(error);
                    return [
                        3,
                        5
                    ];
                case 5:
                    return [
                        2,
                        null
                    ];
            }
        });
    }), []);
    var reloadDataCustomer = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var res, ref, ref1, customerInfoData, ref2, bankInfoRes, accountInfoRes, _tmp, _tmp1, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            UserService/* default.getAccount */.ZP.getAccount()
                        ];
                    case 1:
                        res = _state.sent();
                        if (!(0,clients/* isValid */.JY)(res)) return [
                            3,
                            3
                        ];
                        customerInfoData = (0,clients/* getFirst */.Xi)(res);
                        _tmp = {};
                        _tmp1 = {};
                        return [
                            4,
                            Promise.all([
                                clients/* CustomerClient.getBankAccountInfo */.YP.getBankAccountInfo(_tmp),
                                UserService/* default.getAccountInfo */.ZP.getAccountInfo(_tmp1)
                            ])
                        ];
                    case 2:
                        ref2 = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                            _state.sent(),
                            2
                        ]), bankInfoRes = ref2[0], accountInfoRes = ref2[1];
                        customerInfoData.bank = (0,clients/* getFirst */.Xi)(bankInfoRes);
                        customerInfoData.account = ((ref = (0,clients/* getFirst */.Xi)(accountInfoRes)) === null || ref === void 0 ? void 0 : ref.account) || null;
                        customerInfoData.session = ((ref1 = (0,clients/* getFirst */.Xi)(accountInfoRes)) === null || ref1 === void 0 ? void 0 : ref1.session) || null;
                        setCustomerInfo(customerInfoData);
                        _state.label = 3;
                    case 3:
                        return [
                            3,
                            5
                        ];
                    case 4:
                        error = _state.sent();
                        // eslint-disable-next-line no-console
                        console.error(error);
                        return [
                            3,
                            5
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function reloadDataCustomer() {
            return _ref.apply(this, arguments);
        };
    }();
    var setInfoUser = function(userInfo) {
        setUser(userInfo);
        setIsAuthenticated(!!userInfo);
        setIsLoading(false);
    };
    var clearDataBeforeLogout = function(param) {
        var _clearAll = param.clearAll, clearAll = _clearAll === void 0 ? false : _clearAll;
        try {
            sessionStorage.removeItem("WRT");
            localStorage.removeItem("collectorProductSentArray");
            localStorage.removeItem("isBindingLINE");
            if (clearAll) {
                localStorageUtils.clearStorage();
                localStorage.setItem("logout", new Date());
            }
        } catch (error) {
        // eslint-disable-next-line no-console
        } finally{
            setInfoUser(null);
            setCookies({}, true);
            removeCookies();
        }
    };
    var logout = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(callback) {
            var options, _tmp, _tmp1, _tmp2;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = {};
                        options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : _tmp;
                        if (!sessionStorage.getItem("WRT")) return [
                            3,
                            2
                        ];
                        _tmp1 = {};
                        // Deactive notification partner
                        return [
                            4,
                            clients/* CustomerClient.deactiveNotificationPartner */.YP.deactiveNotificationPartner((_tmp1.reason = "logout", _tmp1.token = sessionStorage.getItem("WRT"), _tmp1.customerID = user === null || user === void 0 ? void 0 : user.customerID, _tmp1))
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        // Reset Insider user flag — cho phép push user mới khi login lại
                        (0,Insider/* resetInsiderUser */.ap)();
                        _tmp2 = {};
                        // clear data before logout
                        clearDataBeforeLogout((_tmp2.clearAll = (options === null || options === void 0 ? void 0 : options.clearAll) || false, _tmp2));
                        // Execute callback if provided
                        if (typeof callback === "function") {
                            callback();
                        }
                        // Redirect to home
                        setTimeout(function() {
                            window.location.replace("/home");
                        }, 500);
                        // This part will not execute because window.location.replace does not return
                        // setTimeout(() => {
                        //   window.location.reload(true);
                        // }, 1000);
                        return [
                            2,
                            false
                        ];
                }
            });
        });
        return function logout(callback) {
            return _ref.apply(this, arguments);
        };
    }();
    var loadUserFromCookies = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(callback) {
            var res, userInfo, timeRemaining, _tmp, cookiesValue, _tmp1, _tmp2;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            getUserInfo()
                        ];
                    case 1:
                        res = _state.sent();
                        userInfo = (0,clients/* getFirst */.Xi)(res, null);
                        // check guest user expireAt
                        if (userInfo && userInfo.isQuest) {
                            timeRemaining = new Date(userInfo.expireAt).getTime() - new Date().getTime();
                            // time remaining
                            // console.log("time remaining: ", `${Math.floor(timeRemaining/1000/60)  }m`);
                            setTimeout(function() {
                                return logout(function() {
                                    if (router.pathname !== "/") {
                                        router.push("/");
                                    }
                                    toggleShowGuestExpiredTime();
                                });
                            }, timeRemaining);
                        } else {
                        // redirect to mienbac.thuocsi.vn
                        // window.location.href = DOMAINT_TS;
                        }
                        if (!userInfo) return [
                            3,
                            3
                        ];
                        _tmp = {};
                        return [
                            4,
                            SettingService.getSettingInWeb((_tmp.user = userInfo, _tmp))
                        ];
                    case 2:
                        userInfo.settings = _state.sent();
                        _state.label = 3;
                    case 3:
                        _tmp1 = {};
                        cookiesValue = js_cookie_default().get(sysconfig/* ACCESS_TOKEN_LONGLIVE */.R$, (_tmp1.domain = sysconfig/* GENERAL_DOMAIN */.oC, _tmp1));
                        _tmp2 = {};
                        if (cookiesValue && cookiesValue.length > 0) {
                            setCookies((_tmp2.bearerToken = cookiesValue, _tmp2), true);
                        }
                        if (userInfo) userInfo.cookiesValue = cookiesValue;
                        setInfoUser(userInfo);
                        setIsLoading(false);
                        if (callback && typeof callback === "function") callback(userInfo);
                        return [
                            2
                        ];
                }
            });
        });
        return function(callback) {
            return _ref.apply(this, arguments);
        };
    }(), [
        getUserInfo,
        setIsLoading
    ]);
    var login = function(info, rememberMe) {
        setCookies(info, rememberMe);
        loadUserFromCookies();
    };
    var handleLogin = function(param) {
        var username = param.username, password = param.password, _rememberMe = param.rememberMe, rememberMe = _rememberMe === void 0 ? true : _rememberMe, success = param.success, _type = param.type, type = _type === void 0 ? "CUSTOMER" : _type, callback = param.callback;
        // tracking login action - thuannc 19Jul2023
        utils/* gtag.clickBtnSignInAction */.SX.clickBtnSignInAction();
        // action
        AuthService/* default.login */.ZP.login({
            username: username,
            password: password,
            type: type,
            remember: rememberMe
        }).then(function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(result) {
                var errorCode, blockedTime, ref, _tmp, userInfo, customerRes, info, _tmp1, ref1, metadata, _tmp2;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (callback) callback(result);
                            _tmp = {};
                            if (!(0,clients/* isValid */.JY)(result)) {
                                errorCode = result.errorCode;
                                blockedTime = 10;
                                switch(errorCode){
                                    case Enums/* ENUMS_ERROR_ACC_CODE.WRONG_PASSWORD */.E8.WRONG_PASSWORD:
                                        utils/* NotifyUtils.error */.QP.error(translateAlertAction("message_wrong_password_sso"));
                                        break;
                                    case Enums/* ENUMS_ERROR_ACC_CODE.LOGIN_FAILED */.E8.LOGIN_FAILED:
                                        utils/* NotifyUtils.error */.QP.error(translateAlertAction("message_wrong_password_sso"));
                                        break;
                                    case Enums/* ENUMS_ERROR_ACC_CODE.NOT_FOUND */.E8.NOT_FOUND:
                                        utils/* NotifyUtils.error */.QP.error(translateAlertAction("message_wrong_password_sso"));
                                        break;
                                    case Enums/* ENUMS_ERROR_ACC_CODE.ACCOUNT_LOGIN_BLOCKED */.E8.ACCOUNT_LOGIN_BLOCKED:
                                        ;
                                        // blocked 10minutes
                                        // blockedTime = data.blockedTime;
                                        // if blockedTime is existed
                                        if (result && result.data && result.data[0] && ((ref = result === null || result === void 0 ? void 0 : result.data[0]) === null || ref === void 0 ? void 0 : ref.blockedTime) && new Date(result.data[0].blockedTime) > new Date()) {
                                            // blockedTime = diff minutes from blockedTime to now
                                            // Minites ( format int )
                                            blockedTime = Math.floor((new Date(result.data[0].blockedTime) - new Date()) / 1000 / 60);
                                        }
                                        utils/* NotifyUtils.error */.QP.error(translateAlertAction("message_blocked_sso", (_tmp.blockedTime = blockedTime, _tmp)));
                                        break;
                                    default:
                                        utils/* NotifyUtils.error */.QP.error(translateAlertAction("message_wrong_password_sso"));
                                }
                                return [
                                    2
                                ];
                            }
                            // NotifyUtils.success('Đăng nhập thành công');
                            removeGuestId(); // remove guestID của khách vãng lai
                            removeGuestInfo(); // remove thông tin của khách vãng lai
                            userInfo = (0,clients/* getFirst */.Xi)(result);
                            login(userInfo, rememberMe);
                            return [
                                4,
                                UserService/* default.getAccount */.ZP.getAccount()
                            ];
                        case 1:
                            customerRes = _state.sent();
                            info = (0,clients/* getFirst */.Xi)(customerRes);
                            _tmp1 = {};
                            if (!(0,clients/* isValid */.JY)(customerRes)) {
                                switch(customerRes.errorCode){
                                    case Enums/* ENUMS_ERROR_ACC_CODE.CUSTOMER_DELETED */.E8.CUSTOMER_DELETED:
                                        toggleShowBlockAccountMess();
                                        return [
                                            2
                                        ];
                                    case Enums/* ENUMS_ERROR_ACC_CODE.CUSTOMER_BLOCK */.E8.CUSTOMER_BLOCK:
                                        toggleShowBlockAccountMess();
                                        return [
                                            2
                                        ];
                                    case Enums/* ENUMS_ERROR_ACC_CODE.CUSTOMER_DELETED_NO_ORDER_60_DAYS */.E8.CUSTOMER_DELETED_NO_ORDER_60_DAYS:
                                    case Enums/* ENUMS_ERROR_ACC_CODE.CUSTOMER_DELETED_NO_ORDER_90_DAYS */.E8.CUSTOMER_DELETED_NO_ORDER_90_DAYS:
                                        setCookies(_tmp1, true);
                                        removeCookies();
                                        toggleShowDeleteAccountMess(customerRes);
                                        return [
                                            2
                                        ];
                                    default:
                                        toggleShowNotFoundAccountMess(customerRes);
                                        return [
                                            2
                                        ];
                                }
                            }
                            _tmp2 = {};
                            // callback
                            if (success) {
                                ;
                                success();
                                // const { redirectUrl = null } = router.query || {};
                                if (isShowLogin) toggleLogin();
                                if (isShowSignUp && isMobileV2) toggleSignUp();
                                metadata = (_tmp2.ref_url = (router === null || router === void 0 ? void 0 : router.pathname) || "/", _tmp2.redirect_url = redirectUrl || "/", _tmp2);
                                MonitorUtils/* default.sendLoginEvent */.ZP.sendLoginEvent(Enums/* MONITORING_COLLECTOR_TYPE.LOGIN */.Hq.LOGIN, metadata);
                                // BV-1886: a locked inactive customer can only use /onboarding, from any page
                                if ((0,InactiveCustomerUtils/* isInactiveCustomerLocked */.YA)(info, appConfig)) {
                                    window.location.href = Paths/* ONBOARDING */.So;
                                    return [
                                        2
                                    ];
                                }
                                if (router.pathname === "/") {
                                    if (!(info === null || info === void 0 ? void 0 : info.isUploadLicense) && (info === null || info === void 0 ? void 0 : info.status) !== "ACTIVE") {
                                        router.push(Paths/* ONBOARDING */.So);
                                        return [
                                            2
                                        ];
                                    }
                                    // router.push(QUICK_ORDER);
                                    router.push(redirectUrl || "/");
                                    return [
                                        2
                                    ]; // de tranh reload
                                }
                                if (router === null || router === void 0 ? void 0 : (ref1 = router.pathname) === null || ref1 === void 0 ? void 0 : ref1.indexOf("product")) {
                                    router.reload();
                                // router.push(redirectUrl || PRODUCTS_URL);
                                }
                                if ((router === null || router === void 0 ? void 0 : router.pathname) === Paths/* GUEST_HOME_PAGE */.L7) {
                                    window.location.href = Paths/* HOME_PAGE */.s6;
                                }
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function(result) {
                return _ref.apply(this, arguments);
            };
        }()).catch(function() {
            utils/* NotifyUtils.error */.QP.error(translateAlertAction("message_error"));
        }).finally(function() {
            setIsLoading(false);
        });
    };
    var handleRegisterGuest = function(data, success) {
        setIsLoading(true);
        AuthService/* default.registerGuest */.ZP.registerGuest(data).then(function(result) {
            if (!(0,clients/* isValid */.JY)(result)) {
                switch(result.errorCode){
                    case "ACCOUNT_NOT_ACCEPTED":
                        utils/* NotifyUtils.error */.QP.error(translateAlertAction("message_trial_error"));
                        toggleRegisterGuest(false);
                        toggleLogin();
                        break;
                    default:
                        utils/* NotifyUtils.error */.QP.error(result.message);
                        toggleRegisterGuest(false);
                        toggleLogin();
                }
                return;
            }
            var phone = (0,clients/* getFirst */.Xi)(result).phone;
            var userName = "guest".concat(phone);
            handleLogin({
                username: userName,
                password: "Guest".concat(phone),
                type: "GUEST"
            });
            setIsLoading(false);
            toggleRegisterGuest(false);
            // callback
            if (success) {
                success();
                if (router.pathname === "/") {
                    router.push(Paths/* QUICK_ORDER */.A3);
                }
            }
        }).catch(function() {
            utils/* NotifyUtils.error */.QP.error(translateAlertAction("message_error"));
        }).finally(function() {
            setIsLoading(false);
        });
    };
    var handleResetPassword = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var result;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            AuthService/* default.resetPassword */.ZP.resetPassword(data)
                        ];
                    case 1:
                        result = _state.sent();
                        if ((0,clients/* isValid */.JY)(result)) {
                            utils/* NotifyUtils.info */.QP.info(result.message);
                        } else {
                            utils/* NotifyUtils.error */.QP.error((result === null || result === void 0 ? void 0 : result.message) || translateAlertAction("message_error"));
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    // off check token
    (0,react.useEffect)(function() {
        // nếu không có user thì mới check token
        if (initUser === null) {
            if (token) {
                setCookies({
                    bearerToken: token
                });
            }
            loadUserFromCookies(function() {
                var _ref = (0,_async_to_generator/* default */.Z)(function(userInfo) {
                    var result, _tmp;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // token
                                if (token) {
                                    if (redirectUrl) {
                                        router.push(redirectUrl);
                                    } else if (router.pathname === "/conversations") {
                                        router.push(router.asPath);
                                    } else {
                                        router.push(router.asPath);
                                    }
                                } // nếu không có user thì check token
                                if (!tokenv1) return [
                                    3,
                                    2
                                ];
                                _tmp = {};
                                return [
                                    4,
                                    AuthService/* default.loginv1 */.ZP.loginv1((_tmp.tokenv1 = tokenv1, _tmp))
                                ];
                            case 1:
                                result = _state.sent();
                                if ((0,clients/* isValid */.JY)(result)) {
                                    utils/* NotifyUtils.info */.QP.info(result.message);
                                    login((0,clients/* getFirst */.Xi)(result), true);
                                } else {
                                    logout();
                                    utils/* NotifyUtils.error */.QP.error((result === null || result === void 0 ? void 0 : result.message) || translateAlertAction("message_error"));
                                    // redirect to mienbac.thuocsi.vn
                                    setTimeout(function() {
                                        window.location.href = "/";
                                    }, 1500);
                                }
                                _state.label = 2;
                            case 2:
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(userInfo) {
                    return _ref.apply(this, arguments);
                };
            }());
        // check: nếu cookie trả về khác với cookie lưu ở máy thì reload lại trang
        // } else if (initUser?.cookiesValue !== Cookies.get(ACCESS_TOKEN_LONGLIVE, { domain: GENERAL_DOMAIN })) {
        //   // clear cookie
        //   logout(null, { clearAll: true });
        // window.location.replace('/');
        // setTimeout(() => {
        //   window.location.reload(true);
        // }, 1000);
        }
    }, [
        pathname,
        loadUserFromCookies,
        tokenv1,
        token,
        redirectUrl
    ]);
    var handleChangeDisplayProduct = function(e) {
        setMobileDisplayProduct(e.target.checked);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthContext.Provider, {
        value: {
            user: user,
            auth: auth,
            customerInfo: customerInfo,
            isAuthenticated: isAuthenticated,
            login: login,
            handleLogin: handleLogin,
            handleRegisterGuest: handleRegisterGuest,
            logout: logout,
            isLoading: isLoading,
            isShowLogin: isShowLogin,
            toggleLogin: toggleLogin,
            isShowSignUp: isShowSignUp,
            toggleSignUp: toggleSignUp,
            isShowForgetPassword: isShowForgetPassword,
            toggleForgetPassword: toggleForgetPassword,
            isShowRegisterGuest: isShowRegisterGuest,
            toggleRegisterGuest: toggleRegisterGuest,
            isShowGuestExpiredTime: isShowGuestExpiredTime,
            toggleShowGuestExpiredTime: toggleShowGuestExpiredTime,
            handleChangeForget: handleChangeForget,
            handleChangeSignIn: handleChangeSignIn,
            handleChangeSignUp: handleChangeSignUp,
            handleChangeRegisterGuest: handleChangeRegisterGuest,
            handleResetPassword: handleResetPassword,
            handleChangePassword: handleChangePassword,
            toggleChangePassword: toggleChangePassword,
            isShowChangePassword: isShowChangePassword,
            isShowForgotPassMess: isShowForgotPassMess,
            toggleShowForgotPassMess: toggleShowForgotPassMess,
            isShowBlockAccountMess: isShowBlockAccountMess,
            toggleShowBlockAccountMess: toggleShowBlockAccountMess,
            reloadDataCustomer: reloadDataCustomer,
            handleRedCustomer: handleRedCustomer,
            mobileDisplayProduct: mobileDisplayProduct,
            handleChangeDisplayProduct: handleChangeDisplayProduct,
            isShowNotFoundAccountMess: isShowNotFoundAccountMess,
            toggleShowNotFoundAccountMess: toggleShowNotFoundAccountMess,
            getValShowResponseNotFoundAccountMess: getValShowResponseNotFoundAccountMess,
            isShowDeleteAccountMess: isShowDeleteAccountMess,
            toggleShowDeleteAccountMess: toggleShowDeleteAccountMess,
            getValResponseDeleteAccountMess: getValResponseDeleteAccountMess
        },
        children: children
    });
};
var useAuth = function() {
    return (0,react.useContext)(AuthContext);
};
var LoadingScreenComponent = /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingScreen/* default */.Z, {});
var LoadingRoute = function(param) {
    var children = param.children;
    var isLoading = useAuth().isLoading;
    if (isLoading) {
        return LoadingScreenComponent;
    }
    return children;
}; // db.createView(
 //   'price_data_all', // Tên view
 //   'price_data_chatchaipharmacy', // Tên collection nguồn đầu tiên
 //   [
 //     { $unionWith: 'price_data_cnypharmacy' },
 //     { $unionWith: 'price_data_dncenter' },
 //     { $unionWith: 'price_data_hatyaipkdrugcenter' },
 //     { $unionWith: 'price_data_spdrug' },
 //   ],
 // );


/***/ }),

/***/ 15012:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "GN": function() { return /* binding */ CartContextProvider; },
  "jD": function() { return /* binding */ useCart; }
});

// UNUSED EXPORTS: CartContext

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/clients/index.js + 20 modules
var clients = __webpack_require__(15149);
// EXTERNAL MODULE: ./src/constants/Enums/index.js
var Enums = __webpack_require__(71569);
// EXTERNAL MODULE: ./src/constants/ErrorCart/index.js
var ErrorCart = __webpack_require__(83084);
// EXTERNAL MODULE: ./src/constants/Paths/index.js
var Paths = __webpack_require__(199);
// EXTERNAL MODULE: ./src/context/Auth/index.js + 4 modules
var Auth = __webpack_require__(58530);
// EXTERNAL MODULE: ./src/context/Product/context.js + 3 modules
var context = __webpack_require__(5632);
// EXTERNAL MODULE: ./src/hooks/index.js + 9 modules
var hooks = __webpack_require__(91866);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 6 modules
var esm = __webpack_require__(5233);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/services/index.js + 15 modules
var services = __webpack_require__(788);
// EXTERNAL MODULE: ./src/sysconfig/index.js
var sysconfig = __webpack_require__(66225);
// EXTERNAL MODULE: ./src/utils/index.js + 5 modules
var utils = __webpack_require__(76480);
// EXTERNAL MODULE: ./src/utils/EnhanceReducer.js
var EnhanceReducer = __webpack_require__(15067);
// EXTERNAL MODULE: ./src/utils/fbpixel.js
var fbpixel = __webpack_require__(70627);
// EXTERNAL MODULE: ./src/utils/FormatNumber.js
var FormatNumber = __webpack_require__(44097);
// EXTERNAL MODULE: ./src/utils/ImageUtils.js
var ImageUtils = __webpack_require__(13744);
// EXTERNAL MODULE: ./src/utils/Insider.js
var Insider = __webpack_require__(78130);
// EXTERNAL MODULE: ./src/utils/maac.js
var maac = __webpack_require__(36753);
// EXTERNAL MODULE: ./src/utils/MonitorUtils.js + 1 modules
var MonitorUtils = __webpack_require__(79903);
// EXTERNAL MODULE: ./src/utils/StringUtils.js
var StringUtils = __webpack_require__(52380);
// EXTERNAL MODULE: ./src/utils/tiktok.js
var tiktok = __webpack_require__(38901);
// EXTERNAL MODULE: ./src/utils/ValidateUtils.js
var ValidateUtils = __webpack_require__(70220);
// EXTERNAL MODULE: ./src/zustand-lib/useSellers.js + 2 modules
var useSellers = __webpack_require__(14626);
// EXTERNAL MODULE: ./src/utils/ArrUtils.js
var ArrUtils = __webpack_require__(33769);
;// CONCATENATED MODULE: ./src/context/Cart/CartType.js
var FETCH_PRODUCT_SUCCESS = "FETCH_PRODUCT_SUCCESS";
var FETCH_SUCCESS = "FETCH_SUCCESS";
var FETCH_ERROR = "FETCH_ERROR";
var ADD_ITEM = "ADD_ITEM";
var REMOVE_ITEM = "REMOVE_ITEM";
var INCREASE = "INCREASE";
var INCREASE_BY = "INCREASE_BY";
var DECREASE = "DECREASE";
var CLEAR = "CLEAR";
var CHECKOUT = "CHECKOUT";
var ADD_IMPORTANT = "ADD_IMPORTANT";
var REMOVE_IMPORTANT = "REMOVE_IMPORTANT";
var SELECT_ITEM = "SELECT_ITEM";
var SELECT_ALL_ITEM = "SELECT_ALL_ITEM";
var UN_SELECT_ALL_ITEM = "UN_SELECT_ALL_ITEM";
var SET_CART_FLUCTUATES = "SET_CART_FLUCTUATES";
/* harmony default export */ var CartType = ({
    FETCH_PRODUCT_SUCCESS: FETCH_PRODUCT_SUCCESS
});

;// CONCATENATED MODULE: ./src/context/Cart/CartReducer.js






// remove cartiItems
var Storage = function() {
    // eslint-disable-next-line no-unused-expressions
    typeof localStorage !== "undefined" && localStorage.removeItem("cartThuocSi");
// typeof localStorage !== 'undefined' && localStorage.setItem('cartThuocSi', JSON.stringify(cartItems.length > 0 ? cartItems : []));
};
var sumItems = function(cartItems) {
    Storage(cartItems);
    var itemCount = cartItems.reduce(function(total, product) {
        return total + product.quantity;
    }, 0);
    return {
        itemCount: itemCount
    };
};
var findIsSelectAllItem = function(cartItems) {
    return !cartItems.find(function(param) {
        var _isSelected = param.isSelected, isSelected = _isSelected === void 0 ? false : _isSelected, _isGift = param.isGift, isGift = _isGift === void 0 ? false : _isGift;
        return !isSelected && !isGift;
    });
};
var getImportantList = function(cartItems) {
    return cartItems === null || cartItems === void 0 ? void 0 : cartItems.filter(function(item) {
        return item.isSelected && item.isImportant;
    });
};
var checkIsHaveProductDeal = function(cartItems) {
    return !!cartItems.find(function(item) {
        return item.type === "DEAL" || item.type === "COMBO" || item.isCampaign;
    });
};
var getErrProducts = function(cartItems) {
    return (cartItems === null || cartItems === void 0 ? void 0 : cartItems.filter(function(item) {
        return (item === null || item === void 0 ? void 0 : item.isSelected) && ((item === null || item === void 0 ? void 0 : item.errorCode) || (item === null || item === void 0 ? void 0 : item.errorMessage));
    })) || [];
};
// logic đánh dấu sp quan trọng , chỉ được đánh 1 sản phẩm trên 5 sp
var checkImportantList = function(cartItems) {
    var cartItemsSelected = cartItems === null || cartItems === void 0 ? void 0 : cartItems.filter(function(item) {
        return item.isSelected;
    });
    var totalImportant = cartItemsSelected === null || cartItemsSelected === void 0 ? void 0 : cartItemsSelected.filter(function(item) {
        return item.isImportant;
    }).length;
    var totalCanImportant = Math.floor(cartItemsSelected.length / 5);
    var totalRemainingCanImportant = totalCanImportant - totalImportant;
    return {
        isErrorImportant: !(totalImportant <= totalCanImportant),
        totalCanImportant: totalCanImportant,
        totalRemainingCanImportant: totalRemainingCanImportant
    };
};
// price là giá mới, currentPrice là giá lúc thêm vào giỏ. Chỉ dùng dự phòng khi
// response thiếu fluctuatedType.
var getFluctuatedTypeByPrice = function(item) {
    var newPrice = Number(item === null || item === void 0 ? void 0 : item.price) || 0;
    var oldPrice = Number(item === null || item === void 0 ? void 0 : item.currentPrice) || 0;
    if (!oldPrice || newPrice === oldPrice) return "";
    return newPrice > oldPrice ? Enums/* FLUCTUATED_TYPE.INCREASED */.w4.INCREASED : Enums/* FLUCTUATED_TYPE.DECREASED */.w4.DECREASED;
};
/* Gộp danh sách item biến động giá (raw từ BE) vào cartItems đã enrich (tên, ảnh, quy cách
   lấy từ product service).

   BE trả 2 nguồn cho cùng một sự kiện đổi giá:
     - fluctuatedItems: chỉ gồm item ĐÃ TICK CHỌN và không lỗi -> banner + modal.
     - cartItems[].fluctuatedType: gắn trên MỌI item -> icon từng dòng.

   Dùng chung cho 2 nguồn dữ liệu: response GET /cart/v2 (reloadDataCart) và response
   PUT /cart/verify (gate ngay trước khi đặt hàng). */ var buildCartFluctuates = function() {
    var cartItems = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], fluctuatedItems = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    var items = fluctuatedItems || [];
    var fluctuatedItemBySku = new Map(items.filter(function(item) {
        return item === null || item === void 0 ? void 0 : item.sku;
    }).map(function(item) {
        return [
            item.sku,
            item
        ];
    }));
    var nextCartItems = (cartItems || []).map(function(item) {
        var fluctuatedItem = fluctuatedItemBySku.get(item === null || item === void 0 ? void 0 : item.sku);
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
            fluctuatedType: (item === null || item === void 0 ? void 0 : item.fluctuatedType) || (fluctuatedItem === null || fluctuatedItem === void 0 ? void 0 : fluctuatedItem.fluctuatedType) || // chỉ suy ra cho item BE đã xác nhận biến động, để giữ nguyên luật của BE
            (fluctuatedItem && getFluctuatedTypeByPrice(fluctuatedItem)) || ""
        });
    });
    var cartFluctuates = nextCartItems.reduce(function(acc, cartItem) {
        var fluctuatedItem = fluctuatedItemBySku.get(cartItem === null || cartItem === void 0 ? void 0 : cartItem.sku);
        if (!fluctuatedItem) return acc;
        var ref, ref1;
        // chỉ lấy field giá từ item thô, KHÔNG spread cả object: volume của item thô
        // là số (m³) sẽ đè lên volume quy cách của sản phẩm.
        return (0,_to_consumable_array/* default */.Z)(acc).concat([
            (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, cartItem), {
                price: (ref = fluctuatedItem === null || fluctuatedItem === void 0 ? void 0 : fluctuatedItem.price) !== null && ref !== void 0 ? ref : cartItem === null || cartItem === void 0 ? void 0 : cartItem.price,
                currentPrice: (ref1 = fluctuatedItem === null || fluctuatedItem === void 0 ? void 0 : fluctuatedItem.currentPrice) !== null && ref1 !== void 0 ? ref1 : cartItem === null || cartItem === void 0 ? void 0 : cartItem.currentPrice,
                warningMessage: (fluctuatedItem === null || fluctuatedItem === void 0 ? void 0 : fluctuatedItem.warningMessage) || (cartItem === null || cartItem === void 0 ? void 0 : cartItem.warningMessage) || ""
            }), 
        ]);
    }, []);
    // Với /cart/v2 thì cartItems và fluctuatedItems đến từ cùng một response nên luôn khớp
    // sku. Với /cart/verify, cartItems trong state có thể cũ hơn (sku vừa đổi ở tab khác)
    // -> merge ra rỗng. Khi đó fallback về item thô để modal vẫn liệt kê được, tuyệt đối
    // không trả mảng rỗng vì nó sẽ mở đường cho đơn đi qua mà chưa xác nhận giá.
    return {
        cartItems: nextCartItems,
        cartFluctuates: cartFluctuates.length === 0 && items.length > 0 ? items : cartFluctuates
    };
};
var initState = {
    itemCount: 0,
    cartItems: [],
    redeemCode: [],
    note: "",
    totalPrice: 0,
    price: 0,
    discount: 0,
    paymentMethod: null,
    paymentMethodFee: 0,
    deliveryMethod: null,
    deliveryMethodFee: 0,
    loading: false,
    mapQuanity: null,
    extraFee: null,
    isSelectedAll: false,
    importantList: [],
    isHaveProductDeal: false,
    customerShippingAddress: null,
    customerWardCode: null,
    customerProvinceCode: null,
    customerDistrictCode: null,
    wardCode: null,
    districtCode: null,
    provinceCode: null,
    customerPhone: null,
    customerName: null,
    customerId: null,
    customerCode: null,
    customerAddressCode: null,
    cartNo: null,
    paymentMethodPercentage: null,
    regionCode: null,
    regionCodes: [],
    subPrice: 0,
    totalFee: 0,
    totalItem: 0,
    totalItemSelected: 0,
    totalPriceAllItem: 0,
    isErrorCartItem: false,
    isErrorImportant: false,
    totalCanImportant: 0,
    totalRemainingCanImportant: 0,
    errProducts: [],
    redeemApplyResult: [],
    // BE trả fluctuatedItems với omitempty: hết biến động giá thì field biến mất khỏi
    // response, phải có default ở đây thì FETCH_SUCCESS mới xoá được giá trị lần trước.
    fluctuatedItems: [],
    cartFluctuates: []
};
var CartReducer = function(state, param) {
    var type = param.type, payload = param.payload;
    var cartItems = state.cartItems;
    // const data = payload && payload.cartItems ? payload.cartItems : [];
    var ref = payload || {}, tmp = ref.cartItems, data = tmp === void 0 ? [] : tmp, _extraFee = ref.extraFee, extraFee = _extraFee === void 0 ? null : _extraFee, _paymentMethodFee = ref.paymentMethodFee, paymentMethodFee = _paymentMethodFee === void 0 ? 0 : _paymentMethodFee, _deliveryMethodFee = ref.deliveryMethodFee, deliveryMethodFee = _deliveryMethodFee === void 0 ? 0 : _deliveryMethodFee, cartNo = ref.cartNo, _subPrice = ref.subPrice, subPrice = _subPrice === void 0 ? 0 : _subPrice;
    var mapQuantity = (0,ArrUtils/* convertArrayToMapValue */.Zx)(data, "sku", "quantity");
    switch(type){
        case FETCH_SUCCESS:
            {
                var result = (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state, initState, sumItems((0,_to_consumable_array/* default */.Z)(data))), {
                    cartItems: (0,_to_consumable_array/* default */.Z)(data),
                    mapQuantity: mapQuantity
                }), payload), {
                    subPrice: Math.max(subPrice, 0),
                    deliveryMethodFee: deliveryMethodFee,
                    paymentMethodFee: paymentMethodFee,
                    extraFee: extraFee,
                    cartNo: cartNo,
                    loading: false,
                    isSelectedAll: findIsSelectAllItem(data),
                    groupBySellerCode: [],
                    importantList: getImportantList(data),
                    isHaveProductDeal: checkIsHaveProductDeal(data),
                    errProducts: getErrProducts(data)
                }), checkImportantList(data));
                return result;
            }
        // Chỉ cập nhật trạng thái biến động giá, giữ nguyên phần còn lại của giỏ.
        // Nguồn dữ liệu là response PUT /cart/verify ngay trước khi đặt hàng.
        case SET_CART_FLUCTUATES:
            {
                var ref1 = payload || {}, _fluctuatedItems = ref1.fluctuatedItems, fluctuatedItems = _fluctuatedItems === void 0 ? [] : _fluctuatedItems;
                var merged = buildCartFluctuates(state.cartItems, fluctuatedItems);
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    fluctuatedItems: fluctuatedItems,
                    cartItems: merged.cartItems,
                    cartFluctuates: merged.cartFluctuates
                });
            }
        case FETCH_ERROR:
            return (0,_object_spread/* default */.Z)({}, state, initState);
        case ADD_ITEM:
            if (!cartItems.find(function(item) {
                return item.sku === payload.sku;
            })) {
                cartItems.push((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, payload), {
                    quantity: 1,
                    isSelected: true
                }));
            }
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state, sumItems(cartItems)), {
                cartItems: (0,_to_consumable_array/* default */.Z)(cartItems),
                mapQuantity: mapQuantity,
                isHaveProductDeal: checkIsHaveProductDeal(data)
            });
        case SELECT_ITEM:
            {
                var _skus = payload.skus, skus = _skus === void 0 ? [] : _skus, sku = payload.sku;
                if (sku) {
                    skus.push(sku);
                }
                skus.forEach(function(skuItem) {
                    cartItems[cartItems.findIndex(function(item) {
                        return item.sku === skuItem;
                    })].isSelected = payload.isSelected || false;
                });
                return (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    cartItems: (0,_to_consumable_array/* default */.Z)(cartItems),
                    isSelectedAll: findIsSelectAllItem(cartItems)
                }), checkImportantList(data));
            }
        case UN_SELECT_ALL_ITEM:
            {
                return (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    cartItems: cartItems.map(function(item) {
                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                            isSelected: false
                        });
                    }),
                    isSelectedAll: false,
                    isHaveProductDeal: checkIsHaveProductDeal(data)
                }), checkImportantList(data));
            }
        case SELECT_ALL_ITEM:
            {
                return (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    cartItems: cartItems.map(function(item) {
                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                            isSelected: true
                        });
                    }),
                    isSelectedAll: true,
                    isHaveProductDeal: checkIsHaveProductDeal(data)
                }), checkImportantList(data));
            }
        case REMOVE_ITEM:
            return (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state, sumItems(cartItems.filter(function(item) {
                return item.sku !== payload.sku;
            }))), {
                cartItems: (0,_to_consumable_array/* default */.Z)(cartItems.filter(function(item) {
                    return item.sku !== payload.sku;
                })),
                mapQuantity: mapQuantity,
                isSelectedAll: findIsSelectAllItem(cartItems),
                isHaveProductDeal: checkIsHaveProductDeal(data)
            }), checkImportantList(data));
        case INCREASE:
            if (!cartItems.find(function(item) {
                return item.sku === payload.sku;
            })) {
                cartItems.push((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, payload), {
                    quantity: 1,
                    isSelected: true
                }));
            } else {
                cartItems[cartItems.findIndex(function(item) {
                    return item.sku === payload.sku;
                })].quantity += 1;
            }
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state, sumItems(cartItems)), {
                cartItems: (0,_to_consumable_array/* default */.Z)(cartItems),
                mapQuantity: mapQuantity,
                isHaveProductDeal: checkIsHaveProductDeal(data)
            });
        case INCREASE_BY:
            if (!cartItems.find(function(item) {
                return item.sku === payload.product.sku;
            })) {
                cartItems.push((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, payload.product), {
                    quantity: payload.q,
                    isSelected: true
                }));
            } else {
                cartItems[cartItems.findIndex(function(item) {
                    return item.sku === payload.product.sku;
                })].quantity = payload.q;
            }
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state, sumItems(cartItems)), {
                cartItems: (0,_to_consumable_array/* default */.Z)(cartItems),
                mapQuantity: mapQuantity,
                isHaveProductDeal: checkIsHaveProductDeal(data)
            });
        case DECREASE:
            // eslint-disable-next-line no-case-declarations
            var currentItem = cartItems[cartItems.findIndex(function(item) {
                return item.sku === payload.sku;
            })];
            if (currentItem && currentItem.quantity !== 0) {
                currentItem.quantity -= 1;
            }
            return (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state, sumItems(currentItem && currentItem.quantity !== 0 ? cartItems : cartItems.filter(function(item) {
                return item.sku !== payload.sku;
            }))), {
                cartItems: currentItem && currentItem.quantity !== 0 ? (0,_to_consumable_array/* default */.Z)(cartItems) : (0,_to_consumable_array/* default */.Z)(cartItems.filter(function(item) {
                    return item.sku !== payload.sku;
                })),
                mapQuantity: mapQuantity,
                isHaveProductDeal: checkIsHaveProductDeal(data)
            }), checkImportantList(data));
        case CHECKOUT:
            return (0,_object_spread/* default */.Z)({
                checkout: true
            }, initState);
        case ADD_IMPORTANT:
            // eslint-disable-next-line no-param-reassign
            state.cartItems[state.cartItems.findIndex(function(item) {
                return item.sku === payload.sku;
            })].isImportant = true;
            return (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state, sumItems(state.cartItems)), {
                cartItems: (0,_to_consumable_array/* default */.Z)(state.cartItems),
                importantList: getImportantList(data)
            }), checkImportantList(data));
        case REMOVE_IMPORTANT:
            // eslint-disable-next-line no-param-reassign
            delete state.cartItems[state.cartItems.findIndex(function(item) {
                return item.sku === payload.sku;
            })].isImportant;
            return (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state, sumItems(state.cartItems)), {
                cartItems: (0,_to_consumable_array/* default */.Z)(state.cartItems),
                importantList: getImportantList(data)
            }), checkImportantList(data));
        case CLEAR:
            return (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                cartItems: []
            }, sumItems([])), {
                note: "",
                redeemCode: [],
                mapQuantity: mapQuantity,
                loading: false
            }), initState);
        default:
            return state;
    }
};

;// CONCATENATED MODULE: ./src/context/Cart/CartContext.js

































var CartContext = /*#__PURE__*/ (0,react.createContext)();
var initialState = {
    loading: true,
    firstInit: true
};
var CartContextProvider = function(param) {
    var children = param.children, cartQuantity = param.cartQuantity;
    var ref = (0,esm/* useTranslation */.$G)("common"), translateCommon = ref.t;
    var ref1 = (0,esm/* useTranslation */.$G)("alert-action"), translateAlertAction = ref1.t;
    var isAuthenticated = (0,Auth/* useAuth */.aC)().isAuthenticated;
    var router = (0,next_router.useRouter)();
    if (cartQuantity && initialState.firstInit) {
        var cartMapQuantity = new Map();
        cartQuantity.forEach(function(cartItem) {
            cartMapQuantity.set(cartItem.sku, cartItem.quantity);
        });
        initialState.mapQuantity = cartMapQuantity;
        initialState.firstInit = false;
    }
    var getProductBySkus = (0,context/* useProduct */.iB)().getProductBySkus;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useModal */.dd)(), 2), isShowModalMax200Item = ref2[0], toggleShowModalMax200Item = ref2[1];
    var getSellerByCode = (0,useSellers/* default */.Z)(function(state) {
        return state.getSellerByCode;
    });
    var giftProductRowRef = (0,react.useRef)(null);
    // Khởi tạo true để các hàm tracking (Insider SDK) không fire với data rỗng.
    // Chuyển sang false khi: (1) reloadDataCart hoàn tất, hoặc (2) user chưa đăng nhập.
    var ref3 = (0,react.useState)(true), isLoadingCart = ref3[0], setIsLoadingCart = ref3[1];
    var ref4 = (0,react.useState)(false), isDeletingPromo = ref4[0], setDeletingPromo = ref4[1];
    var ref5 = (0,react.useState)(false), isOpenPromoList = ref5[0], togglePromoList = ref5[1];
    var ref6 = (0,react.useState)(false), isOpenPriceFluctuationModal = ref6[0], setOpenPriceFluctuationModal = ref6[1];
    // Modal biến động giá ở /cart mở từ 2 nguồn: alert (xác nhận rồi ở lại giỏ) và nút thanh
    // toán (xác nhận rồi đi tiếp /checkout). Cờ này giữ ý định của nguồn đã mở modal.
    var ref7 = (0,react.useState)(false), shouldCheckoutAfterConfirm = ref7[0], setShouldCheckoutAfterConfirm = ref7[1];
    var ref8 = (0,react.useState)([]), tempRedeemApplyResult = ref8[0], setTempRedeemApplyResult = ref8[1];
    var ref9 = (0,react.useState)(false), isOnCheckingPromo = ref9[0], toggleOnCheckingPromo = ref9[1];
    var ref10 = (0,react.useState)(false), isShowRemoveInvalidPromos = ref10[0], toggleShowRemoveInvalidPromos = ref10[1];
    var ref11 = (0,react.useState)(false), isRemovingInvalidPromos = ref11[0], setIsRemovingInvalidPromos = ref11[1];
    // const [state, dispatch] = useReducer(CartReducer, initialState);
    // enhance cartReducer support function getState
    var ref12 = (0,_sliced_to_array/* default */.Z)((0,EnhanceReducer/* useEnhancedReducer */.a)(CartReducer, initialState), 3), state = ref12[0], dispatch = ref12[1], getState = ref12[2];
    var clearCart = function() {
        dispatch({
            type: CLEAR
        });
        setIsLoadingCart(false);
    };
    var handleCheckout = function() {
        dispatch({
            type: CHECKOUT
        });
    };
    // business_client , GPP , business certificate
    // eslint-disable-next-line no-unused-vars
    var getErrorCart = function(param) {
        var errorCode = param.errorCode, _errorMessage = param.errorMessage, errorMessage = _errorMessage === void 0 ? null : _errorMessage;
        return translateAlertAction("message_error_cart.".concat(errorCode));
    };
    var getInfoCartItem = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var data, getPrice, skusReduce, mapInfo, _tmp, cartItems;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        data = param.data, getPrice = param.getPrice;
                        if ((0,ValidateUtils/* isEmpty */.xb)(data)) {
                            return [
                                2,
                                []
                            ];
                        }
                        skusReduce = data.reduce(function(accumulator, item) {
                            if (item === null || item === void 0 ? void 0 : item.sku) return (0,_to_consumable_array/* default */.Z)(accumulator).concat([
                                item.sku
                            ]);
                            return accumulator;
                        }, []);
                        if (skusReduce.length === 0) {
                            return [
                                2,
                                []
                            ];
                        }
                        _tmp = {};
                        return [
                            4,
                            getProductBySkus((_tmp.skus = skusReduce, _tmp.getPrice = getPrice, _tmp))
                        ];
                    case 1:
                        mapInfo = _state.sent();
                        cartItems = data.map(function(item) {
                            var ref = item || {}, quantity = ref.quantity, skuStatus = ref.skuStatus;
                            // TODO: ẩn nhà cung cấp
                            var ref1 = mapInfo.get(item.sku) || {}, imagesProxy = ref1.imagesProxy, unit = ref1.unit, volume = ref1.volume, name = ref1.name, slug = ref1.slug, _deal = ref1.deal, deal = _deal === void 0 ? {} : _deal, isDeal = ref1.isDeal, isGift = ref1.isGift, skuType = ref1.skuType, productId = ref1.productId, defaultImage = ref1.defaultImage, displayPrice = ref1.displayPrice, salePrice = ref1.salePrice, dealPrice = ref1.dealPrice, requireGPPMessage = ref1.requireGPPMessage, isCampaign = ref1.isCampaign, availableProducts = ref1.availableProducts, tags = ref1.tags, productSkuType = ref1.productSkuType, weight = ref1.weight, productVolume = ref1.productVolume, statusData = ref1.statusData, limitPerDay = ref1.limitPerDay, maxQuantityPerDay = ref1.maxQuantityPerDay, quantityPurchasedToday = ref1.quantityPurchasedToday, discountPercent = ref1.discountPercent, messageLimitOrder = ref1.messageLimitOrder, categoryCodes = ref1.categoryCodes, campaign = ref1.campaign, isContractPrice = ref1.isContractPrice, skus = ref1.skus;
                            var _errorCode = item.errorCode, errorCode = _errorCode === void 0 ? "" : _errorCode;
                            var isNearOutOfStock = skuStatus === "LIMIT" || false;
                            if (!errorCode && maxQuantityPerDay > 0 && quantity > maxQuantityPerDay - quantityPurchasedToday) {
                                // eslint-disable-next-line no-param-reassign
                                errorCode = "MAX_QUANTITY";
                            }
                            // const salePrice = deal?.dealType === 'COMBO' || !deal ? item.price : item.salePrice;
                            var disableAddTocart = errorCode === "NOT_ACTIVE_SKU" || errorCode === "SUSPENDED_SKU" || errorCode === "OUT_OF_STOCK_SKU" || errorCode === "CART_ITEM_INVALID" || errorCode === "NOT_AVAILABLE_SKU" || errorCode === "NOT_AVAILABLE_SCOPE" || errorCode === "NOT_FOUND_SKU" || errorCode === "NOT_FOUND_PRICE_SKU" || errorCode === "COMBO_INVALID" || errorCode === ErrorCart/* ERROR_CODE_CART.REQUIRED_CERTIFICATE */.M5.REQUIRED_CERTIFICATE || false;
                            /*
      // nếu item (cart item ) là deal thì có thêm 1 field là  salePrice ( giá gốc )
      // nếu không là deal thì chỉ có price 
      nhưng khi hiển thị ở cartProductBuy lại chỉ check salePrice , nên nếu 
      Updaate chỗ này để nếu có saleprice thì lấy giá saleprice , còn nếu ko có thì lấy giá price theo cartItem 
      salePrice: item.salePrice || item.price,
  */ var info = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                                salePrice: salePrice,
                                errorCode: errorCode,
                                defaultImage: defaultImage,
                                displayPrice: displayPrice,
                                displayPriceFormated: (0,FormatNumber/* formatCurrency */.xG)(displayPrice),
                                dealPrice: dealPrice,
                                imagesProxy: imagesProxy,
                                volume: volume,
                                unit: unit,
                                name: name,
                                slug: slug,
                                deal: deal,
                                isDeal: isDeal,
                                isGift: isGift,
                                disableAddTocart: disableAddTocart,
                                skuType: skuType,
                                productId: productId,
                                requireGPPMessage: requireGPPMessage,
                                isCampaign: isCampaign,
                                availableProducts: availableProducts,
                                productTags: tags || [],
                                tags: tags,
                                productSkuType: productSkuType,
                                weight: weight,
                                productVolume: productVolume,
                                statusData: statusData,
                                isVAT: (tags === null || tags === void 0 ? void 0 : tags.indexOf("HOADONNHANH")) >= 0 || false,
                                limitPerDay: limitPerDay,
                                maxQuantityPerDay: maxQuantityPerDay,
                                quantityPurchasedToday: quantityPurchasedToday,
                                discountPercent: discountPercent,
                                messageLimitOrder: messageLimitOrder,
                                categoryCodes: categoryCodes,
                                campaign: campaign,
                                isNearOutOfStock: isNearOutOfStock,
                                isContractPrice: isContractPrice,
                                skus: skus
                            });
                            // khi add khuyến mãi là các gift quà tặng thì auto sellected là false luôn,
                            function isGiftSellect(giftSellected) {
                                if (giftSellected) return Object.assign(info, {
                                    isSelected: false
                                });
                                return null;
                            }
                            isGiftSellect(isGift);
                            return info;
                        });
                        cartItems = cartItems.sort(function(a, b) {
                            return a.errorCode && !b.errorCode ? -1 : 1;
                        });
                        return [
                            2,
                            cartItems
                        ];
                }
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }());
    var getCartItemsInfo = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var cartData, _tmp, ref, _cartItems, cartItems, _tmp1, ref1, cartItemsInfo, _tmp2, _tmp3, _tmp4;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = {};
                        cartData = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : _tmp;
                        _tmp1 = {};
                        ref = cartData || _tmp1, _cartItems = ref.cartItems, cartItems = _cartItems === void 0 ? [] : _cartItems;
                        _tmp2 = {};
                        return [
                            4,
                            Promise.all([
                                getInfoCartItem((_tmp2.data = cartItems, _tmp2.getPrice = true, _tmp2))
                            ])
                        ];
                    case 1:
                        ref1 = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                            _state.sent(),
                            1
                        ]), cartItemsInfo = ref1[0];
                        _tmp3 = {};
                        _tmp4 = {};
                        return [
                            2,
                            (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)(_tmp3, cartData), (_tmp4.cartItems = cartItemsInfo, _tmp4))
                        ];
                }
            });
        });
        return function getCartItemsInfo() {
            return _ref.apply(this, arguments);
        };
    }();
    // reload cart
    var reloadDataCart = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var cartRes, successMessage, errorMessage, _isUpdate, isUpdate, _isLoadFromStart, isLoadFromStart, ref, ref1, ref2, ref3, ref4, cartResponse, cartResult, cartData, ref5, _cartItems, cartItems, _redeemApplyResult, redeemApplyResult, _maxWeight, maxWeight, _maxVolume, maxVolume, _totalBuymedServiceFee, totalBuymedServiceFee, _tmp, hasGiftArray, giftList, arrayHashmap, _tmp1, giftArray, ref6, cartItemsInfo, giftInfo, _tmp2, _tmp3, giftsInfo, fluctuatedItems, mergedFluctuates, ref7, totalWeight, totalVolume, maxWidth, maxHeight, maxLength, _tmp4, isOverWeightOrVolume, messageOverWeight, messageOverVolume, maxVolumeCalc, _tmp5, error, _tmp6;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        cartRes = param.cartRes, successMessage = param.successMessage, errorMessage = param.errorMessage, _isUpdate = param.isUpdate, isUpdate = _isUpdate === void 0 ? false : _isUpdate, _isLoadFromStart = param.isLoadFromStart, isLoadFromStart = _isLoadFromStart === void 0 ? false : _isLoadFromStart;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        if (isLoadFromStart) setIsLoadingCart(true);
                        if (cartRes && !(0,clients/* isValidWithoutData */.Wk)(cartRes)) {
                            ref4 = (0,_sliced_to_array/* default */.Z)((0,clients/* getFirst */.Xi)(cartRes, []), 1), cartResponse = ref4[0];
                            switch(cartRes.errorCode){
                                case "MAX_QUANTITY":
                                    // [ [ {quantity} ] ]
                                    if ((cartResponse === null || cartResponse === void 0 ? void 0 : cartResponse.quantity) > 0) {
                                        utils/* NotifyUtils.error */.QP.error("".concat(translateAlertAction("message_product.max_quantity_greater_than_0"), " ").concat(cartResponse.quantity));
                                    } else {
                                        utils/* NotifyUtils.error */.QP.error(translateAlertAction("message_product.max_quantity"));
                                    }
                                    break;
                                case "PAYLOAD_VALIDATE":
                                    if (cartRes.message === "Type must be one of [NORMAL DEAL COMBO CAMPAIGN]") {
                                        utils/* NotifyUtils.error */.QP.error(translateAlertAction("message_not_add_gift_to_cart"));
                                    } else {
                                        utils/* NotifyUtils.error */.QP.error(translateAlertAction("error_pls_try_again"));
                                    }
                                    break;
                                default:
                                    if (cartRes && cartRes.message) {
                                        utils/* NotifyUtils.error */.QP.error("".concat(cartRes.message));
                                    } else if (errorMessage) {
                                        utils/* NotifyUtils.error */.QP.error(errorMessage);
                                    }
                                    return [
                                        2
                                    ];
                            }
                        }
                        if (successMessage) utils/* NotifyUtils.success */.QP.success(successMessage);
                        return [
                            4,
                            clients/* CartClientV2.loadDataCart */.HP.loadDataCart()
                        ];
                    case 2:
                        cartResult = _state.sent();
                        cartData = (0,clients/* getFirst */.Xi)(cartResult);
                        if (!cartData) {
                            clearCart();
                            return [
                                2
                            ];
                        }
                        _tmp = {};
                        ref5 = cartData || _tmp, _cartItems = ref5.cartItems, cartItems = _cartItems === void 0 ? [] : _cartItems, _redeemApplyResult = ref5.redeemApplyResult, redeemApplyResult = _redeemApplyResult === void 0 ? [] : _redeemApplyResult, _maxWeight = ref5.maxWeight, maxWeight = _maxWeight === void 0 ? 0 : _maxWeight, _maxVolume = ref5.maxVolume, maxVolume = _maxVolume === void 0 ? 0 : _maxVolume, _totalBuymedServiceFee = ref5.totalBuymedServiceFee, totalBuymedServiceFee = _totalBuymedServiceFee === void 0 ? 0 : _totalBuymedServiceFee;
                        cartData.totalBuymedServiceFee = totalBuymedServiceFee;
                        hasGiftArray = (ref = redeemApplyResult === null || redeemApplyResult === void 0 ? void 0 : redeemApplyResult.filter(function(item) {
                            return (item === null || item === void 0 ? void 0 : item.gifts) && (item === null || item === void 0 ? void 0 : item.canUse) === true;
                        })) === null || ref === void 0 ? void 0 : ref.map(function(item) {
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                                gifts: item === null || item === void 0 ? void 0 : item.gifts.map(function(gift) {
                                    return (0,_object_spread/* default */.Z)({}, gift);
                                })
                            });
                        });
                        giftList = [];
                        hasGiftArray.forEach(function(ele) {
                            var _giftList;
                            (_giftList = giftList).push.apply(_giftList, (0,_to_consumable_array/* default */.Z)(ele.gifts));
                        });
                        _tmp1 = {};
                        arrayHashmap = giftList.reduce(function(obj, item) {
                            var newObj = obj;
                            if (newObj[item === null || item === void 0 ? void 0 : item.sku]) {
                                newObj[item.sku].quantity += item.quantity;
                            } else {
                                newObj[item.sku] = (0,_object_spread/* default */.Z)({}, item);
                            }
                            return newObj;
                        }, _tmp1);
                        giftArray = Object.values(arrayHashmap);
                        _tmp2 = {};
                        _tmp3 = {};
                        return [
                            4,
                            Promise.all([
                                getInfoCartItem((_tmp2.data = cartItems, _tmp2.getPrice = true, _tmp2)),
                                // getPromoInfo({ voucherCode: redeemCode[0] }),
                                getInfoCartItem((_tmp3.data = giftArray, _tmp3.getPrice = false, _tmp3))
                            ])
                        ];
                    case 3:
                        ref6 = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                            _state.sent(),
                            2
                        ]), cartItemsInfo = ref6[0], giftInfo = ref6[1];
                        giftsInfo = giftInfo === null || giftInfo === void 0 ? void 0 : giftInfo.map(function(item) {
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                                isGift: true,
                                type: "GIFT"
                            });
                        });
                        cartData.cartItems = (0,_to_consumable_array/* default */.Z)(cartItemsInfo).concat((0,_to_consumable_array/* default */.Z)(giftsInfo));
                        setTempRedeemApplyResult(cartData === null || cartData === void 0 ? void 0 : cartData.redeemApplyResult); // init tempRedeemApplyResult
                        fluctuatedItems = (cartData === null || cartData === void 0 ? void 0 : cartData.fluctuatedItems) || [];
                        cartData.fluctuatedItems = fluctuatedItems;
                        mergedFluctuates = buildCartFluctuates(cartData.cartItems, fluctuatedItems);
                        cartData.cartItems = mergedFluctuates.cartItems;
                        cartData.cartFluctuates = mergedFluctuates.cartFluctuates;
                        /* Check error cart item */ cartData.isErrorCartItem = (cartData === null || cartData === void 0 ? void 0 : (ref1 = cartData.cartItems) === null || ref1 === void 0 ? void 0 : ref1.some(function(item) {
                            return (item === null || item === void 0 ? void 0 : item.isSelected) && (item === null || item === void 0 ? void 0 : item.errorCode) && (item === null || item === void 0 ? void 0 : item.errorCode) !== ErrorCart/* ERROR_CODE_CART.CHANGED_PRICE */.M5.CHANGED_PRICE;
                        })) || false;
                        cartData.havingItemSelected = !!(cartData === null || cartData === void 0 ? void 0 : (ref2 = cartData.cartItems) === null || ref2 === void 0 ? void 0 : ref2.find(function(item) {
                            return (item === null || item === void 0 ? void 0 : item.isSelected) === true;
                        }));
                        cartData.isItemInArrayRemove = (cartData === null || cartData === void 0 ? void 0 : (ref3 = cartData.cartItems) === null || ref3 === void 0 ? void 0 : ref3.some(function(item) {
                            return Enums/* ARR_REMOVE_PRODUCT.indexOf */.mJ.indexOf(item === null || item === void 0 ? void 0 : item.errorCode) >= 0;
                        })) || false;
                        _tmp4 = {};
                        if (maxVolume > 0 || maxWeight > 0) {
                            ref7 = cartData || _tmp4, totalWeight = ref7.totalWeight, totalVolume = ref7.totalVolume, maxWidth = ref7.maxWidth, maxHeight = ref7.maxHeight, maxLength = ref7.maxLength;
                            isOverWeightOrVolume = maxWeight > 0 && totalWeight >= maxWeight || maxVolume > 0 && totalVolume >= maxVolume;
                            cartData.isOverWeightOrVolume = isOverWeightOrVolume;
                            messageOverWeight = "";
                            messageOverVolume = "";
                            if (maxWeight > 0 && totalWeight >= maxWeight) {
                                // messageOverWeight = `Giỏ hàng hiện tại vượt quá ${maxWeight}kg.`;
                                messageOverWeight = translateAlertAction("message_over_max_weight").replace("{weight}", maxWeight);
                                if (isUpdate) utils/* NotifyUtils.error */.QP.error(translateAlertAction("message_over_weight_cart").replace("{weight}", maxWeight));
                            }
                            if (maxVolume > 0 && totalVolume >= maxVolume) {
                                maxVolumeCalc = "";
                                if (maxWidth > 0 && maxLength > 0 && maxHeight > 0) {
                                    maxVolumeCalc = "".concat(maxLength, "x").concat(maxWidth, "x").concat(maxHeight);
                                }
                                // messageOverVolume = `Giỏ hàng hiện tại vượt quá quy cách đóng gói ${maxVolumeCalc}`;
                                messageOverVolume = translateAlertAction("message_over_packing").replace("{volume}", maxVolumeCalc);
                                if (totalVolume >= maxVolume) {
                                    utils/* NotifyUtils.error */.QP.error(translateAlertAction("message_over_packing").replace("{volume}", maxVolumeCalc));
                                }
                            }
                            if (isOverWeightOrVolume) cartData.messageOverWeightOrVolume = "".concat(messageOverWeight).concat(messageOverVolume);
                        }
                        setIsLoadingCart(false);
                        _tmp5 = {};
                        dispatch((_tmp5.type = FETCH_SUCCESS, _tmp5.payload = cartData || [], _tmp5));
                        return [
                            3,
                            5
                        ];
                    case 4:
                        error = _state.sent();
                        utils/* NotifyUtils.error */.QP.error(error.message || translateAlertAction("message_loading_cart_failed"));
                        _tmp6 = {};
                        dispatch((_tmp6.type = FETCH_ERROR, _tmp6));
                        setIsLoadingCart(false);
                        return [
                            3,
                            5
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function reloadDataCart(_) {
            return _ref.apply(this, arguments);
        };
    }();
    // TODO: change to reloadCart
    var updateCart = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    return [
                        4,
                        reloadDataCart((_tmp.isLoadFromStart = true, _tmp))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    }), []);
    (0,react.useEffect)(function() {
        function fetchData() {
            return _fetchData.apply(this, arguments);
        }
        function _fetchData() {
            _fetchData = (0,_async_to_generator/* default */.Z)(function() {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                updateCart()
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return _fetchData.apply(this, arguments);
        }
        try {
            if (isAuthenticated) {
                fetchData();
            } else {
                // Chưa đăng nhập → không có giỏ hàng → cho phép tracking fire với cart rỗng (đúng thực tế).
                setIsLoadingCart(false);
            }
        } catch (error) {
            clearCart();
        }
    }, [
        updateCart,
        isAuthenticated
    ]);
    var mapDataProduct = function() {
        var products = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
        var ref = getState(), _mapQuantity = ref.mapQuantity, mapQuantity = _mapQuantity === void 0 ? new Map() : _mapQuantity;
        return products.map(function(item) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                imagesProxy: (0,ImageUtils/* getProxyImageList */.V5)(item === null || item === void 0 ? void 0 : item.imageUrls) || [],
                // unit: item.unit && item.unit === '<nil>' ? '' : item.unit,
                quantity: mapQuantity.get(item.sku) || 0
            });
        });
    };
    var updateCartItem = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(payload) {
            var reload, isReloadData, isNotify, ref, ref1, ref2, ref3, ref4, ref5, cartItems, cartNo, mapQuantity, info, sellerInfo, _tmp, dataUpdate, _tmp1, _tmp2, cartRes, ref6, oldQuantity, _tmp3, ref7, _tmp4, _tmp5, ref8, quantity, totalQuantity, newQuantity, product, _tmp6, _tmp7, ref9, tmp, latestCartItems, tmp1, latestPrice, tmp2, latestSubPrice, tmp3, latestDeliveryMethodFee, _tmp8, _tmp9, ref10, ref11, _quantity, quantity1, _tmp10, e;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        reload = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : false, isReloadData = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : false, isNotify = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : true;
                        if (!(payload === null || payload === void 0 ? void 0 : (ref = payload.product) === null || ref === void 0 ? void 0 : ref.sku) && isNotify) {
                            utils/* NotifyUtils.error */.QP.error(translateAlertAction("message_cannot_found_product_add"));
                            return [
                                2,
                                null
                            ];
                        }
                        ref5 = getState(), cartItems = ref5.cartItems, cartNo = ref5.cartNo, mapQuantity = ref5.mapQuantity;
                        info = cartItems === null || cartItems === void 0 ? void 0 : cartItems.find(function(item) {
                            var ref;
                            return item.sku === (payload === null || payload === void 0 ? void 0 : (ref = payload.product) === null || ref === void 0 ? void 0 : ref.sku);
                        });
                        _tmp = {};
                        return [
                            4,
                            getSellerByCode((_tmp.code = payload === null || payload === void 0 ? void 0 : (ref1 = payload.product) === null || ref1 === void 0 ? void 0 : ref1.sellerCode, _tmp))
                        ];
                    case 1:
                        sellerInfo = _state.sent();
                        _tmp1 = {};
                        _tmp2 = {};
                        dataUpdate = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)(_tmp1, payload), (_tmp2.cartNo = cartNo, _tmp2.sellerID = (sellerInfo === null || sellerInfo === void 0 ? void 0 : sellerInfo.sellerID) || null, _tmp2));
                        dataUpdate.page = (info === null || info === void 0 ? void 0 : info.page) || router.pathname.replace("/", "") || "home";
                        dataUpdate.searchKey = info ? info.searchKey : ((ref2 = router.query) === null || ref2 === void 0 ? void 0 : ref2.q) || ((ref3 = router.query) === null || ref3 === void 0 ? void 0 : ref3.text);
                        dataUpdate.eventSource = (0,MonitorUtils/* mapSourceToEnum */.Dw)((payload === null || payload === void 0 ? void 0 : payload.product) || {}, router.pathname) || "";
                        dataUpdate.eventScreen = (0,MonitorUtils/* mapScreenToEnum */.lq)((payload === null || payload === void 0 ? void 0 : payload.product) || {}, router.pathname) || "";
                        return [
                            4,
                            clients/* CartClientV2.updateCartItem */.HP.updateCartItem(dataUpdate)
                        ];
                    case 2:
                        cartRes = _state.sent();
                        oldQuantity = (ref6 = mapQuantity.get(payload === null || payload === void 0 ? void 0 : (ref4 = payload.product) === null || ref4 === void 0 ? void 0 : ref4.sku)) !== null && ref6 !== void 0 ? ref6 : 0;
                        if (!reload) return [
                            3,
                            4
                        ];
                        _tmp3 = {};
                        // Await để FETCH_SUCCESS dispatch xong trước khi tracking re-read state.
                        return [
                            4,
                            reloadDataCart((_tmp3.cartRes = cartRes, _tmp3.isReloadData = isReloadData, _tmp3.isUpdate = true, _tmp3))
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        if (!(0,clients/* isValid */.JY)(cartRes)) return [
                            3,
                            5
                        ];
                        // FB event tracking addToCart
                        fbpixel/* default.addToCart */.ZP.addToCart(payload.product);
                        tiktok/* default.addToCart */.ZP.addToCart(payload.product, (0,clients/* getFirst */.Xi)(cartRes));
                        _tmp4 = {};
                        _tmp5 = {};
                        if (!(info === null || info === void 0 ? void 0 : info.quantity) && (payload === null || payload === void 0 ? void 0 : (ref7 = payload.product) === null || ref7 === void 0 ? void 0 : ref7.isRecommendedByTS)) {
                            // 0 -> 1: send tracking collector event
                            MonitorUtils/* default.sendSKUEvent */.ZP.sendSKUEvent(Enums/* MONITORING_COLLECTOR_TYPE.ADD_TO_CART */.Hq.ADD_TO_CART, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)(_tmp4, payload.product), (_tmp5.quantity = (dataUpdate === null || dataUpdate === void 0 ? void 0 : dataUpdate.q) || 0, _tmp5)), window.location.href);
                        }
                        ref8 = cartRes.data[0], quantity = ref8.quantity, totalQuantity = ref8.totalQuantity;
                        newQuantity = quantity || totalQuantity;
                        _tmp6 = {};
                        _tmp7 = {};
                        product = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)(_tmp6, payload.product), (_tmp7.quantity = Math.abs(newQuantity - oldQuantity), _tmp7.sellerInfo = sellerInfo, _tmp7));
                        ref9 = getState(), tmp = ref9.cartItems, latestCartItems = tmp === void 0 ? [] : tmp, tmp1 = ref9.price, latestPrice = tmp1 === void 0 ? 0 : tmp1, tmp2 = ref9.subPrice, latestSubPrice = tmp2 === void 0 ? 0 : tmp2, tmp3 = ref9.deliveryMethodFee, latestDeliveryMethodFee = tmp3 === void 0 ? 0 : tmp3;
                        _tmp8 = {};
                        _tmp9 = {};
                        if (newQuantity > oldQuantity) {
                            utils/* gtag.addToCartInPage */.SX.addToCartInPage(product, router.pathname);
                            maac/* default.trackAddToCart */.Z.trackAddToCart(product);
                            (0,Insider/* trackAddToCart */.Kc)((_tmp8.product = product, _tmp8.cartItems = latestCartItems, _tmp8.cartTotals = {
                                total: latestSubPrice,
                                subtotal: latestPrice,
                                shippingCost: latestDeliveryMethodFee
                            }, _tmp8));
                        } else {
                            utils/* gtag.removeFromCart */.SX.removeFromCart(product);
                            maac/* default.trackRemoveFromCart */.Z.trackRemoveFromCart(product);
                            (0,Insider/* trackRemoveFromCart */.CL)((_tmp9.product = product, _tmp9.cartItems = latestCartItems, _tmp9.cartTotals = {
                                total: latestSubPrice,
                                subtotal: latestPrice,
                                shippingCost: latestDeliveryMethodFee
                            }, _tmp9));
                        }
                        // gtag.addToCart({ ...payload.product, quantity: dataUpdate?.q || 0, sellerInfo });
                        // gtag.addToCartInPage({ ...payload.product, quantity: dataUpdate?.q || 0, sellerInfo }, router.pathname);
                        if (isNotify) {
                            utils/* NotifyUtils.success */.QP.success("".concat(translateAlertAction("message_update_product_success").replace("{product}", dataUpdate.product.name)));
                        }
                        return [
                            3,
                            9
                        ];
                    case 5:
                        if (!(cartRes.errorCode === "CART_MAX_QUANTITY" || cartRes.errorCode === "MAX_QUANTITY")) return [
                            3,
                            9
                        ];
                        _state.label = 6;
                    case 6:
                        _state.trys.push([
                            6,
                            8,
                            ,
                            9
                        ]);
                        ref10 = (0,_sliced_to_array/* default */.Z)((0,clients/* getFirst */.Xi)(cartRes, []), 1), ref11 = ref10[0], _quantity = ref11.quantity, quantity1 = _quantity === void 0 ? dataUpdate.product.maxQuantity : _quantity;
                        dataUpdate.q = quantity1;
                        return [
                            4,
                            clients/* CartClientV2.updateCartItem */.HP.updateCartItem(dataUpdate)
                        ];
                    case 7:
                        cartRes = _state.sent();
                        _tmp10 = {};
                        // if (isValid(cartRes)) {
                        //   NotifyUtils.success(`Đã cập nhật ${capitalizeText(dataUpdate.product.name)} thành công`);
                        // } else {
                        //   NotifyUtils.error(`Cập nhật sản phẩm thất bại`);
                        // }
                        dispatch((_tmp10.type = INCREASE_BY, _tmp10.payload = dataUpdate, _tmp10));
                        return [
                            3,
                            9
                        ];
                    case 8:
                        e = _state.sent();
                        // eslint-disable-next-line no-console
                        console.error(e);
                        return [
                            3,
                            9
                        ];
                    case 9:
                        return [
                            2,
                            cartRes
                        ];
                }
            });
        });
        return function updateCartItem(payload) {
            return _ref.apply(this, arguments);
        };
    }();
    // clone from updateCardItem add skip call API when payload larger than the quantity required
    var updateCartItemMV2 = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(payload) {
            var reload, isReloadData, ref, ref1, ref2, ref3, ref4, cartItems, cartNo, mapQuantity, info, dataUpdate, _tmp, _tmp1, ref5, oldQuantity, cartRes, _tmp2, ref6, ref7, quantity, totalQuantity, newQuantity, sellerInfo, _tmp3, product, _tmp4, _tmp5, ref8, _tmp6;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        reload = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : false, isReloadData = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : false;
                        if (!(payload === null || payload === void 0 ? void 0 : (ref = payload.product) === null || ref === void 0 ? void 0 : ref.sku)) {
                            utils/* NotifyUtils.error */.QP.error(translateAlertAction("message_cannot_found_product_add"));
                            return [
                                2,
                                null
                            ];
                        }
                        ref4 = getState(), cartItems = ref4.cartItems, cartNo = ref4.cartNo, mapQuantity = ref4.mapQuantity;
                        info = cartItems === null || cartItems === void 0 ? void 0 : cartItems.find(function(item) {
                            var ref;
                            return item.sku === (payload === null || payload === void 0 ? void 0 : (ref = payload.product) === null || ref === void 0 ? void 0 : ref.sku);
                        });
                        _tmp = {};
                        _tmp1 = {};
                        dataUpdate = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)(_tmp, payload), (_tmp1.cartNo = cartNo, _tmp1));
                        dataUpdate.page = (info === null || info === void 0 ? void 0 : info.page) || router.pathname.replace("/", "") || "home";
                        dataUpdate.searchKey = info ? info.searchKey : ((ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.q) || ((ref2 = router.query) === null || ref2 === void 0 ? void 0 : ref2.text);
                        dataUpdate.eventSource = (0,MonitorUtils/* mapSourceToEnum */.Dw)((payload === null || payload === void 0 ? void 0 : payload.product) || {}, router.pathname) || "";
                        dataUpdate.eventScreen = (0,MonitorUtils/* mapScreenToEnum */.lq)((payload === null || payload === void 0 ? void 0 : payload.product) || {}, router.pathname) || "";
                        oldQuantity = (ref5 = mapQuantity.get(payload === null || payload === void 0 ? void 0 : (ref3 = payload.product) === null || ref3 === void 0 ? void 0 : ref3.sku)) !== null && ref5 !== void 0 ? ref5 : 0;
                        return [
                            4,
                            clients/* CartClientV2.updateCartItem */.HP.updateCartItem(dataUpdate)
                        ];
                    case 1:
                        cartRes = _state.sent();
                        _tmp2 = {};
                        if (reload) {
                            reloadDataCart((_tmp2.cartRes = cartRes, _tmp2.isReloadData = isReloadData, _tmp2.isUpdate = true, _tmp2));
                        }
                        if (!(0,clients/* isValid */.JY)(cartRes)) return [
                            3,
                            3
                        ];
                        // FB event tracking addToCart
                        fbpixel/* default.addToCart */.ZP.addToCart(payload.product);
                        tiktok/* default.addToCart */.ZP.addToCart(payload.product, (0,clients/* getFirst */.Xi)(cartRes));
                        ref7 = cartRes.data[0], quantity = ref7.quantity, totalQuantity = ref7.totalQuantity;
                        newQuantity = quantity || totalQuantity;
                        _tmp3 = {};
                        return [
                            4,
                            getSellerByCode((_tmp3.code = (ref6 = payload.product) === null || ref6 === void 0 ? void 0 : ref6.sellerCode, _tmp3))
                        ];
                    case 2:
                        sellerInfo = _state.sent();
                        _tmp4 = {};
                        _tmp5 = {};
                        product = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)(_tmp4, payload.product), (_tmp5.quantity = Math.abs(newQuantity - oldQuantity), _tmp5.sellerInfo = sellerInfo, _tmp5));
                        if (newQuantity > oldQuantity) {
                            utils/* gtag.addToCartInPage */.SX.addToCartInPage(product, router.pathname);
                            maac/* default.trackAddToCart */.Z.trackAddToCart(product);
                            (0,Insider/* trackAddToCart */.Kc)(product);
                        } else {
                            utils/* gtag.removeFromCart */.SX.removeFromCart(product);
                            maac/* default.trackRemoveFromCart */.Z.trackRemoveFromCart(product);
                            (0,Insider/* trackRemoveFromCart */.CL)(product);
                        }
                        // gtag.addToCart({ ...payload.product, quantity: dataUpdate?.q || 0 });
                        // gtag.addToCartInPage({ ...payload.product, quantity: dataUpdate?.q || 0 }, router.pathname);
                        utils/* NotifyUtils.success */.QP.success("".concat(translateAlertAction("message_update_product_success").replace("{product}", dataUpdate.product.name)));
                        return [
                            3,
                            4
                        ];
                    case 3:
                        _tmp6 = {};
                        if (cartRes.errorCode === "CART_MAX_QUANTITY" || cartRes.errorCode === "MAX_QUANTITY") {
                            ;
                            return [
                                2,
                                (_tmp6.status = cartRes.errorCode, _tmp6.maxQuantity = ((ref8 = (0,clients/* getFirst */.Xi)(cartRes, [
                                    0
                                ])[0]) === null || ref8 === void 0 ? void 0 : ref8.quantity) || 0, _tmp6)
                            ];
                        }
                        _state.label = 4;
                    case 4:
                        return [
                            2,
                            cartRes
                        ];
                }
            });
        });
        return function updateCartItemMV2(payload) {
            return _ref.apply(this, arguments);
        };
    }();
    // update for excel
    var updateCartItems = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(items) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                items.forEach(function(item) {
                    var ref = item || {}, sku = ref.sku, quantity = ref.quantity;
                    updateCartItem({
                        product: {
                            sku: sku
                        },
                        q: quantity
                    });
                });
                return [
                    2
                ];
            });
        });
        return function updateCartItems(items) {
            return _ref.apply(this, arguments);
        };
    }();
    var updateCartItemByExecel = function(str) {
        var arr = str.replaceAll("	", " ").split(" ");
        var items = [];
        for(var i = 0; i < arr.length > 0; i += 2){
            var sku = arr[i].trim();
            var quantity = Number(arr[i + 1]);
            items.push({
                sku: sku,
                quantity: quantity
            });
        }
        updateCartItems(items);
    };
    // update for excel
    var increase = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(payload) {
            var cartRes, _tmp, _tmp1, _tmp2;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = {};
                        _tmp1 = {};
                        return [
                            4,
                            clients/* CartClientV2.updateCartItem */.HP.updateCartItem((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)(_tmp, payload), (_tmp1.eventSource = (0,MonitorUtils/* mapSourceToEnum */.Dw)({}, router.pathname) || "", _tmp1.eventScreen = (0,MonitorUtils/* mapScreenToEnum */.lq)({}, router.pathname) || "", _tmp1)))
                        ];
                    case 1:
                        cartRes = _state.sent();
                        _tmp2 = {};
                        reloadDataCart((_tmp2.cartRes = cartRes, _tmp2.successMessage = translateAlertAction("message_add_products_successfully"), _tmp2.errorMessage = translateAlertAction("message_update_product_failed"), _tmp2));
                        return [
                            2
                        ];
                }
            });
        });
        return function increase(payload) {
            return _ref.apply(this, arguments);
        };
    }();
    var decrease = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(payload) {
            var cartRes, _tmp, _tmp1, _tmp2;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = {};
                        _tmp1 = {};
                        return [
                            4,
                            clients/* CartClientV2.updateCartItem */.HP.updateCartItem((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)(_tmp, payload), (_tmp1.eventSource = (0,MonitorUtils/* mapSourceToEnum */.Dw)({}, router.pathname) || "", _tmp1.eventScreen = (0,MonitorUtils/* mapScreenToEnum */.lq)({}, router.pathname) || "", _tmp1)))
                        ];
                    case 1:
                        cartRes = _state.sent();
                        _tmp2 = {};
                        reloadDataCart((_tmp2.cartRes = cartRes, _tmp2.successMessage = translateAlertAction("message_cart_updated"), _tmp2.errorMessage = translateAlertAction("message_update_product_failed"), _tmp2));
                        return [
                            2
                        ];
                }
            });
        });
        return function decrease(payload) {
            return _ref.apply(this, arguments);
        };
    }();
    var removeCartItem = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var sku, _isRecommended, isRecommended, _isSameCategoryProduct, isSameCategoryProduct, isReloadData, isShowMessage, payload, _tmp, ref, cartItems, cartNo, mapQuantity, info, sellerInfo, _tmp1, cartRes, _tmp2, _tmp3, quantity, _tmp4, _tmp5, _tmp6, ref1, tmp, latestCartItems, tmp1, latestPrice, tmp2, latestSubPrice, tmp3, latestDeliveryMethodFee, _tmp7;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        sku = param.sku, _isRecommended = param.isRecommended, isRecommended = _isRecommended === void 0 ? false : _isRecommended, _isSameCategoryProduct = param.isSameCategoryProduct, isSameCategoryProduct = _isSameCategoryProduct === void 0 ? false : _isSameCategoryProduct, isReloadData = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : false, isShowMessage = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : true;
                        _tmp = {};
                        payload = (_tmp.sku = sku, _tmp);
                        ref = getState(), cartItems = ref.cartItems, cartNo = ref.cartNo, mapQuantity = ref.mapQuantity;
                        info = cartItems.find(function(item) {
                            return item.sku === sku;
                        });
                        // :TODO: LOGS info for activity
                        payload.cartNo = cartNo;
                        payload.name = info === null || info === void 0 ? void 0 : info.name;
                        payload.slug = info === null || info === void 0 ? void 0 : info.slug;
                        // payload.productCode = info?.productCode;
                        payload.productId = info === null || info === void 0 ? void 0 : info.productId;
                        payload.salePrice = info === null || info === void 0 ? void 0 : info.salePrice;
                        payload.sellerCode = info === null || info === void 0 ? void 0 : info.sellerCode;
                        payload.cartNo = info === null || info === void 0 ? void 0 : info.cartNo;
                        payload.cartItemType = info === null || info === void 0 ? void 0 : info.cartItemType;
                        payload.type = (info === null || info === void 0 ? void 0 : info.type) || null;
                        payload.eventSource = (0,MonitorUtils/* mapSourceToEnum */.Dw)({
                            isRecommended: isRecommended,
                            isSameCategoryProduct: isSameCategoryProduct
                        }, router.pathname) || "";
                        payload.eventScreen = (0,MonitorUtils/* mapScreenToEnum */.lq)({
                            isRecommended: isRecommended,
                            isSameCategoryProduct: isSameCategoryProduct
                        }, router.pathname) || "";
                        _tmp1 = {};
                        return [
                            4,
                            getSellerByCode((_tmp1.code = payload === null || payload === void 0 ? void 0 : payload.sellerCode, _tmp1))
                        ];
                    case 1:
                        sellerInfo = _state.sent();
                        _tmp2 = {};
                        _tmp3 = {};
                        return [
                            4,
                            clients/* CartClientV2.removeCartItem */.HP.removeCartItem((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)(_tmp2, payload), (_tmp3.sellerID = (sellerInfo === null || sellerInfo === void 0 ? void 0 : sellerInfo.sellerID) || null, _tmp3)))
                        ];
                    case 2:
                        cartRes = _state.sent();
                        quantity = mapQuantity.get(sku);
                        _tmp4 = {};
                        _tmp5 = {};
                        utils/* gtag.removeFromCart */.SX.removeFromCart((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)(_tmp4, info), (_tmp5.quantity = quantity, _tmp5)));
                        if (!isReloadData) return [
                            3,
                            4
                        ];
                        _tmp6 = {};
                        // Await để FETCH_SUCCESS dispatch xong trước khi tracking re-read state.
                        return [
                            4,
                            reloadDataCart((_tmp6.cartRes = cartRes, _tmp6.successMessage = isShowMessage ? translateAlertAction("message_remove_product_successfully").replace("{product}", (0,StringUtils/* capitalizeText */.c7)(payload.name)) : "", _tmp6.errorMessage = isShowMessage ? translateAlertAction("message_remove_failed") : "", _tmp6.isReloadData = isReloadData, _tmp6))
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        _tmp7 = {};
                        // Dùng isValidWithoutData vì API remove trả về { status: 'OK', data: [] } (mảng rỗng)
                        // → isValid() sẽ falsy do data[0] undefined, chặn nhầm tracking.
                        if ((0,clients/* isValidWithoutData */.Wk)(cartRes)) {
                            ref1 = getState(), tmp = ref1.cartItems, latestCartItems = tmp === void 0 ? [] : tmp, tmp1 = ref1.price, latestPrice = tmp1 === void 0 ? 0 : tmp1, tmp2 = ref1.subPrice, latestSubPrice = tmp2 === void 0 ? 0 : tmp2, tmp3 = ref1.deliveryMethodFee, latestDeliveryMethodFee = tmp3 === void 0 ? 0 : tmp3;
                            // Signature đúng: { product, cartItems, cartTotals } — khớp với Insider orchestrator.
                            (0,Insider/* trackRemoveFromCart */.CL)((_tmp7.product = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, info), {
                                quantity: quantity,
                                sellerInfo: sellerInfo
                            }), _tmp7.cartItems = latestCartItems, _tmp7.cartTotals = {
                                total: latestSubPrice,
                                subtotal: latestPrice,
                                shippingCost: latestDeliveryMethodFee
                            }, _tmp7));
                        }
                        return [
                            2,
                            cartRes
                        ];
                }
            });
        });
        return function removeCartItem(_) {
            return _ref.apply(this, arguments);
        };
    }();
    var removeAllCartItems = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var isReloadData, isShowMessage, payload, _tmp, ref, cartNo, cartItems, arrSellerCodes, promises, cartRes, _tmp1;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        isReloadData = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : false, isShowMessage = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : true;
                        _tmp = {};
                        payload = (_tmp.isDeleteAll = true, _tmp);
                        ref = getState(), cartNo = ref.cartNo, cartItems = ref.cartItems;
                        // :TODO: LOGS info for activity
                        payload.cartNo = cartNo;
                        arrSellerCodes = cartItems.map(function(i) {
                            return i.sellerCode;
                        });
                        return [
                            4,
                            Promise.all((0,_to_consumable_array/* default */.Z)(new Set(arrSellerCodes)).map(function(code) {
                                return getSellerByCode({
                                    code: code
                                });
                            }))
                        ];
                    case 1:
                        _state.sent(); // save seller info into cache
                        promises = cartItems.map(function(item) {
                            return new Promise(function(resolve) {
                                getSellerByCode({
                                    code: item.sellerCode
                                }).then(function(sellerInfo) {
                                    utils/* gtag.removeFromCart */.SX.removeFromCart((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                                        sellerInfo: sellerInfo
                                    }));
                                }).finally(function() {
                                    return resolve(true);
                                });
                            });
                        });
                        return [
                            4,
                            Promise.allSettled(promises)
                        ];
                    case 2:
                        _state.sent();
                        return [
                            4,
                            clients/* CartClientV2.removeCartItem */.HP.removeCartItem(payload)
                        ];
                    case 3:
                        cartRes = _state.sent();
                        if (!isReloadData) return [
                            3,
                            5
                        ];
                        _tmp1 = {};
                        return [
                            4,
                            reloadDataCart((_tmp1.cartRes = cartRes, _tmp1.successMessage = isShowMessage ? translateAlertAction("delete_cart_success") : "", _tmp1.errorMessage = isShowMessage ? translateAlertAction("delete_cart_failed") : "", _tmp1.isReloadData = isReloadData, _tmp1))
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        return [
                            2,
                            cartRes
                        ];
                }
            });
        });
        return function removeAllCartItems() {
            return _ref.apply(this, arguments);
        };
    }();
    var addImportant = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(payload) {
            var cartRes, _tmp, _tmp1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = {};
                        return [
                            4,
                            clients/* CartClientV2.updateCartItemImportant */.HP.updateCartItemImportant((_tmp.eventSource = (0,MonitorUtils/* mapSourceToEnum */.Dw)({}, router.pathname) || "", _tmp.eventScreen = (0,MonitorUtils/* mapScreenToEnum */.lq)({}, router.pathname) || "", _tmp.sku = payload.sku, _tmp.isImportant = true, _tmp.type = payload.type, _tmp))
                        ];
                    case 1:
                        cartRes = _state.sent();
                        _tmp1 = {};
                        updateCart((_tmp1.cartRes = cartRes, _tmp1.successMessage = translateAlertAction("message_mark_important_success"), _tmp1.errorMessage = translateAlertAction("message_mark_important_fail"), _tmp1));
                        return [
                            2
                        ];
                }
            });
        });
        return function addImportant(payload) {
            return _ref.apply(this, arguments);
        };
    }();
    var removeImportant = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(payload) {
            var isReloadData, cartRes, _tmp, _tmp1;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        isReloadData = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : true;
                        _tmp = {};
                        return [
                            4,
                            clients/* CartClientV2.updateCartItemImportant */.HP.updateCartItemImportant((_tmp.eventSource = (0,MonitorUtils/* mapSourceToEnum */.Dw)({}, router.pathname) || "", _tmp.eventScreen = (0,MonitorUtils/* mapScreenToEnum */.lq)({}, router.pathname) || "", _tmp.sku = payload.sku, _tmp.isImportant = false, _tmp.type = payload.type, _tmp))
                        ];
                    case 1:
                        cartRes = _state.sent();
                        _tmp1 = {};
                        if (isReloadData) updateCart((_tmp1.cartRes = cartRes, _tmp1.successMessage = translateAlertAction("delete_important_success"), _tmp1.errorMessage = translateAlertAction("delete_important_failed"), _tmp1));
                        return [
                            2
                        ];
                }
            });
        });
        return function removeImportant(payload) {
            return _ref.apply(this, arguments);
        };
    }();
    var updateDeliveryInfo = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(body) {
            var res, _tmp;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = {};
                        return [
                            4,
                            clients/* CartClientV2.updateDeliveryMethod */.HP.updateDeliveryMethod((0,_object_spread/* default */.Z)(_tmp, body))
                        ];
                    case 1:
                        res = _state.sent();
                        if (!(0,clients/* isValid */.JY)(res)) {
                            return [
                                2
                            ];
                        }
                        updateCart();
                        return [
                            2
                        ];
                }
            });
        });
        return function updateDeliveryInfo(body) {
            return _ref.apply(this, arguments);
        };
    }();
    var updateDeliveryMethod = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var deliveryMethod, customerDistrictCode, customerProvinceCode, customerWardCode, customerShippingAddress, info, cartNo, res, _tmp, _tmp1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        deliveryMethod = param.deliveryMethod, customerDistrictCode = param.customerDistrictCode, customerProvinceCode = param.customerProvinceCode, customerWardCode = param.customerWardCode, customerShippingAddress = param.customerShippingAddress, info = param.info;
                        cartNo = getState().cartNo;
                        _tmp = {};
                        _tmp1 = {};
                        return [
                            4,
                            clients/* CartClientV2.updateDeliveryMethod */.HP.updateDeliveryMethod((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((_tmp.deliveryMethod = deliveryMethod, _tmp.customerDistrictCode = customerDistrictCode, _tmp.customerProvinceCode = customerProvinceCode, _tmp.customerWardCode = customerWardCode, _tmp.customerShippingAddress = customerShippingAddress, _tmp), info), (_tmp1.cartNo = cartNo, _tmp1)))
                        ];
                    case 1:
                        res = _state.sent();
                        if (!(0,clients/* isValid */.JY)(res)) {
                            utils/* NotifyUtils.error */.QP.error((res === null || res === void 0 ? void 0 : res.message) || translateAlertAction("message_delivery_method_update_failed"));
                            return [
                                2
                            ];
                        }
                        utils/* NotifyUtils.success */.QP.success(translateAlertAction("message_delivery_method_update_successfully"));
                        updateCart();
                        return [
                            2
                        ];
                }
            });
        });
        return function updateDeliveryMethod(_) {
            return _ref.apply(this, arguments);
        };
    }();
    var updatePaymentMethod = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var paymentMethod, customerDistrictCode, customerProvinceCode, customerWardCode, info, cartNo, res, _tmp, _tmp1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        paymentMethod = param.paymentMethod, customerDistrictCode = param.customerDistrictCode, customerProvinceCode = param.customerProvinceCode, customerWardCode = param.customerWardCode, info = param.info;
                        cartNo = getState().cartNo;
                        _tmp = {};
                        _tmp1 = {};
                        return [
                            4,
                            clients/* CartClientV2.updatePaymentMethod */.HP.updatePaymentMethod((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((_tmp.paymentMethod = paymentMethod, _tmp.customerDistrictCode = customerDistrictCode, _tmp.customerProvinceCode = customerProvinceCode, _tmp.customerWardCode = customerWardCode, _tmp), info), (_tmp1.cartNo = cartNo, _tmp1)))
                        ];
                    case 1:
                        res = _state.sent();
                        if (!(0,clients/* isValid */.JY)(res)) {
                            utils/* NotifyUtils.error */.QP.error(res.message || translateAlertAction("message_payment_method_update_failed"));
                            return [
                                2
                            ];
                        }
                        utils/* NotifyUtils.success */.QP.success(translateAlertAction("message_payment_method_update_successfully"));
                        updateCart();
                        return [
                            2
                        ];
                }
            });
        });
        return function updatePaymentMethod(_) {
            return _ref.apply(this, arguments);
        };
    }();
    var updateInvoice = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(body) {
            var result, _tmp;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = {};
                        return [
                            4,
                            clients/* CartClientV2.updateCart */.HP.updateCart((_tmp.body = body, _tmp))
                        ];
                    case 1:
                        result = _state.sent();
                        if (!(0,clients/* isValid */.JY)(result)) {
                            utils/* NotifyUtils.error */.QP.error(result.message || translateAlertAction("message_update_invoice_information_failed"));
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function updateInvoice(body) {
            return _ref.apply(this, arguments);
        };
    }();
    var updateCartInfo = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(body) {
            var result, _tmp;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = {};
                        return [
                            4,
                            clients/* CartClientV2.updateCart */.HP.updateCart((_tmp.body = body, _tmp))
                        ];
                    case 1:
                        result = _state.sent();
                        if (!(0,clients/* isValid */.JY)(result)) {
                            utils/* NotifyUtils.error */.QP.error(result.message || translateAlertAction("message_failed_update_info"));
                        } else {
                            updateCart();
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function updateCartInfo(body) {
            return _ref.apply(this, arguments);
        };
    }();
    var reOrderById = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var orderId, result, _tmp;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        orderId = param.orderId;
                        _tmp = {};
                        return [
                            4,
                            services/* CartService.reOrder */.Ni.reOrder((_tmp.orderId = orderId, _tmp))
                        ];
                    case 1:
                        result = _state.sent();
                        if ((0,clients/* isValid */.JY)(result)) {
                            updateCart();
                        } else {
                            utils/* NotifyUtils.error */.QP.error(result.message || translateAlertAction("message_cannot_reorder"));
                        }
                        return [
                            2,
                            result
                        ];
                }
            });
        });
        return function reOrderById(_) {
            return _ref.apply(this, arguments);
        };
    }();
    // APO-8
    var selectCartItem = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var sku, skus, isSelected, isReloadCart, name, quantity, _tmp, _tmp1, result, _tmp2;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        sku = param.sku, skus = param.skus, isSelected = param.isSelected, isReloadCart = param.isReloadCart, name = param.name, quantity = param.quantity;
                        _tmp = {};
                        dispatch((_tmp.type = SELECT_ITEM, _tmp.payload = {
                            sku: sku,
                            skus: skus,
                            isSelected: isSelected
                        }, _tmp));
                        _tmp1 = {};
                        if (isReloadCart) {
                            reloadDataCart((_tmp1.successMessage = translateAlertAction("message_add_products_successfully"), _tmp1.errorMessage = translateAlertAction("message_update_product_failed"), _tmp1));
                        }
                        _tmp2 = {};
                        return [
                            4,
                            services/* CartService.selectCartItem */.Ni.selectCartItem((_tmp2.sku = sku, _tmp2.skus = skus, _tmp2.isSelected = isSelected, _tmp2.cartNo = (state === null || state === void 0 ? void 0 : state.cartNo) || "", _tmp2.quantity = quantity, _tmp2.name = name, _tmp2))
                        ];
                    case 1:
                        result = _state.sent();
                        // update lai cart sau khi sellected
                        return [
                            4,
                            updateCart()
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2,
                            result
                        ];
                }
            });
        });
        return function selectCartItem(_) {
            return _ref.apply(this, arguments);
        };
    }();
    var selectAllCartItem = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var _tmp, result, _tmp1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = {};
                        dispatch((_tmp.type = SELECT_ALL_ITEM, _tmp));
                        _tmp1 = {};
                        return [
                            4,
                            services/* CartService.selectAllCartItem */.Ni.selectAllCartItem((_tmp1.cartNo = (state === null || state === void 0 ? void 0 : state.cartNo) || "", _tmp1))
                        ];
                    case 1:
                        result = _state.sent();
                        updateCart();
                        return [
                            2,
                            result
                        ];
                }
            });
        });
        return function selectAllCartItem() {
            return _ref.apply(this, arguments);
        };
    }();
    var unselectAllCartItem = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var _tmp, result, _tmp1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = {};
                        dispatch((_tmp.type = UN_SELECT_ALL_ITEM, _tmp));
                        _tmp1 = {};
                        return [
                            4,
                            services/* CartService.unSelectAllCartItem */.Ni.unSelectAllCartItem((_tmp1.cartNo = (state === null || state === void 0 ? void 0 : state.cartNo) || "", _tmp1))
                        ];
                    case 1:
                        result = _state.sent();
                        updateCart();
                        return [
                            2,
                            result
                        ];
                }
            });
        });
        return function unselectAllCartItem() {
            return _ref.apply(this, arguments);
        };
    }();
    var verifyPayment = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(body) {
            var rs, _tmp;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = {};
                        return [
                            4,
                            clients/* CartClientV2.verifyPayment */.HP.verifyPayment((_tmp.body = body, _tmp))
                        ];
                    case 1:
                        rs = _state.sent();
                        return [
                            2,
                            rs
                        ];
                }
            });
        });
        return function verifyPayment(body) {
            return _ref.apply(this, arguments);
        };
    }();
    var togglePriceFluctuationModal = function(visible) {
        var ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _checkoutAfterConfirm = ref.checkoutAfterConfirm, checkoutAfterConfirm = _checkoutAfterConfirm === void 0 ? false : _checkoutAfterConfirm;
        setShouldCheckoutAfterConfirm(visible && checkoutAfterConfirm);
        setOpenPriceFluctuationModal(visible);
    };
    // Khách chấp nhận giá mới -> BE chốt lại currentPrice của từng sku, cảnh báo tắt ở
    // lần load giỏ hàng kế tiếp.
    var confirmPriceFluctuation = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, _cartFluctuates, cartFluctuates, skus, result, _tmp;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        ref = getState(), _cartFluctuates = ref.cartFluctuates, cartFluctuates = _cartFluctuates === void 0 ? [] : _cartFluctuates;
                        skus = cartFluctuates.map(function(item) {
                            return item === null || item === void 0 ? void 0 : item.sku;
                        }).filter(Boolean);
                        _tmp = {};
                        return [
                            4,
                            services/* CartService.confirmChangePrice */.Ni.confirmChangePrice((_tmp.skus = skus, _tmp))
                        ];
                    case 1:
                        result = _state.sent();
                        if (!(0,clients/* isValidWithoutData */.Wk)(result)) {
                            utils/* NotifyUtils.error */.QP.error((result === null || result === void 0 ? void 0 : result.message) || translateAlertAction("error_pls_try_again"));
                            return [
                                2,
                                result
                            ];
                        }
                        return [
                            4,
                            updateCart()
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2,
                            result
                        ];
                }
            });
        });
        return function confirmPriceFluctuation() {
            return _ref.apply(this, arguments);
        };
    }();
    /* Mã giảm giá trong giỏ không còn đủ điều kiện. BE bỏ canUse khi false (omitempty)
     nên phải kiểm bằng !canUse chứ không so sánh với false. */ var getInvalidPromoCodes = function() {
        var ref = getState(), tmp = ref.redeemApplyResult, currentRedeemApplyResult = tmp === void 0 ? [] : tmp;
        return (currentRedeemApplyResult || []).filter(function(item) {
            return item && !item.canUse && item.code;
        }).map(function(item) {
            return item.code;
        });
    };
    // Cửa duy nhất đi sang /checkout từ giỏ hàng: còn mã giảm giá không đủ điều kiện thì
    // hỏi gỡ trước, còn item biến động giá thì bắt xác nhận trước, không cho qua thẳng.
    var goToCheckout = function() {
        var ref = getState(), _cartFluctuates = ref.cartFluctuates, cartFluctuates = _cartFluctuates === void 0 ? [] : _cartFluctuates;
        if (getInvalidPromoCodes().length > 0) {
            toggleShowRemoveInvalidPromos(true);
            return;
        }
        if (cartFluctuates.length > 0) {
            togglePriceFluctuationModal(true, {
                checkoutAfterConfirm: true
            });
            return;
        }
        router.push(Paths/* CHECKOUT_URL */.sE);
    };
    /* Gate biến động giá cho luồng đặt hàng, dùng danh sách BE trả kèm response
     PUT /cart/verify (validateCart) — request mà luồng đặt hàng vốn đã gọi.

     KHÔNG được quay lại cách gọi updateCart() (GET /cart/v2) ở đây. /cart/v2 khi cache hit
     sẽ trả cache ngay rồi recompute giỏ trong goroutine nền và ghi lại cache bằng Upsert.
     Lệnh ghi muộn đó có thể hoàn tất SAU khi checkout đã xoá cart, tái tạo document cache
     đã bị xoá => cache có cart, main DB không có, và mọi API mutate sau đó trả
     "Not found any matched cart".

     Trả về true = còn biến động giá, modal đã mở và KHÔNG được đi tiếp luồng đặt hàng.
     Quyết định gate đọc thẳng từ tham số, không đọc lại state, để không phụ thuộc thời
     điểm React commit xong dispatch bên dưới. */ var applyPriceFluctuationFromVerify = function() {
        var fluctuatedItems = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
        var items = fluctuatedItems || [];
        // Không biến động thì thoát sớm, KHÔNG dispatch: reducer luôn tạo mảng cartItems mới
        // nên dispatch thừa sẽ re-render toàn bộ danh sách sản phẩm đúng lúc đang submit đơn.
        // Trạng thái cũ (nếu có) đã được reset bởi updateCart() trong confirmPriceFluctuation.
        if (items.length === 0) return false;
        dispatch({
            type: SET_CART_FLUCTUATES,
            payload: {
                fluctuatedItems: items
            }
        });
        togglePriceFluctuationModal(true);
        return true;
    };
    var confirmPriceFluctuationFromCart = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var goCheckoutAfterConfirm, result;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        goCheckoutAfterConfirm = shouldCheckoutAfterConfirm;
                        return [
                            4,
                            confirmPriceFluctuation()
                        ];
                    case 1:
                        result = _state.sent();
                        if (!(0,clients/* isValidWithoutData */.Wk)(result)) return [
                            2
                        ];
                        togglePriceFluctuationModal(false);
                        if (goCheckoutAfterConfirm) {
                            router.push(Paths/* CHECKOUT_URL */.sE);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function confirmPriceFluctuationFromCart() {
            return _ref.apply(this, arguments);
        };
    }();
    // chặn không quá 200 item
    var validate200Item = function(sku) {
        var mapQuantity = getState().mapQuantity;
        var quantity = (mapQuantity === null || mapQuantity === void 0 ? void 0 : mapQuantity.get(sku)) || 0;
        if (quantity === 0 && mapQuantity.size >= sysconfig/* MAX_ITEM_IN_CART */.U3) {
            utils/* NotifyUtils.error */.QP.error(translateAlertAction("message_validate_num_items").replace("{number}", sysconfig/* MAX_ITEM_IN_CART */.U3));
            // toggleShowModalMax200Item();
            return false;
        }
        return true;
    };
    var handleScrollToGiftRow = function() {
        var ref;
        giftProductRowRef === null || giftProductRowRef === void 0 ? void 0 : (ref = giftProductRowRef.current) === null || ref === void 0 ? void 0 : ref.scrollIntoView({
            behavior: "smooth",
            block: "center",
            inline: "start"
        });
    };
    var multiVoucherHandleChangePromoV2 = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(currentPromoCode) {
            var cartNo, res;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        cartNo = getState().cartNo;
                        return [
                            4,
                            clients/* CartClientV2.putChangeMultiRedeem */.HP.putChangeMultiRedeem(currentPromoCode, cartNo)
                        ];
                    case 1:
                        res = _state.sent();
                        return [
                            2,
                            res
                        ];
                }
            });
        });
        return function multiVoucherHandleChangePromoV2(currentPromoCode) {
            return _ref.apply(this, arguments);
        };
    }();
    var multiVoucherHandleRemovePromoV2 = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(currentPromoCode) {
            var cartNo, res;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        cartNo = getState().cartNo;
                        return [
                            4,
                            clients/* CartClientV2.putRemoveMultiRedeem */.HP.putRemoveMultiRedeem(currentPromoCode, cartNo)
                        ];
                    case 1:
                        res = _state.sent();
                        return [
                            2,
                            res
                        ];
                }
            });
        });
        return function multiVoucherHandleRemovePromoV2(currentPromoCode) {
            return _ref.apply(this, arguments);
        };
    }();
    /* Gỡ hết mã không đủ điều kiện rồi đi tiếp. getState đọc qua ref nên sau await
     reloadDataCart là đã thấy giỏ mới, gọi lại goToCheckout an toàn. Nếu mã vẫn còn
     thì dừng lại để khách thao tác tiếp, tránh mở lại dialog ngay lập tức. */ var removeInvalidPromosAndContinue = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var codes, res, _tmp, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (isRemovingInvalidPromos) return [
                            2
                        ];
                        codes = getInvalidPromoCodes();
                        if (codes.length === 0) {
                            toggleShowRemoveInvalidPromos(false);
                            return [
                                2
                            ];
                        }
                        setIsRemovingInvalidPromos(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            5,
                            6
                        ]);
                        return [
                            4,
                            multiVoucherHandleRemovePromoV2(codes)
                        ];
                    case 2:
                        res = _state.sent();
                        _tmp = {};
                        return [
                            4,
                            reloadDataCart((_tmp.cartRes = res, _tmp.successMessage = translateCommon("cart-info.delete_voucher_success"), _tmp.errorMessage = translateCommon("cart-info.delete_voucher_failed"), _tmp.isReloadData = true, _tmp))
                        ];
                    case 3:
                        _state.sent();
                        return [
                            3,
                            6
                        ];
                    case 4:
                        error = _state.sent();
                        console.error(error);
                        return [
                            3,
                            6
                        ];
                    case 5:
                        setIsRemovingInvalidPromos(false);
                        return [
                            7
                        ];
                    case 6:
                        toggleShowRemoveInvalidPromos(false);
                        if (getInvalidPromoCodes().length === 0) {
                            goToCheckout();
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function removeInvalidPromosAndContinue() {
            return _ref.apply(this, arguments);
        };
    }();
    var removeVoucherByCode = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(code) {
            var res, _tmp, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            multiVoucherHandleRemovePromoV2([
                                code
                            ])
                        ];
                    case 1:
                        res = _state.sent();
                        _tmp = {};
                        return [
                            4,
                            reloadDataCart((_tmp.cartRes = res, _tmp.successMessage = translateCommon("cart-info.delete_voucher_success"), _tmp.errorMessage = translateCommon("cart-info.delete_voucher_failed"), _tmp.isReloadData = true, _tmp))
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        console.error(error);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function removeVoucherByCode(code) {
            return _ref.apply(this, arguments);
        };
    }();
    var contextValues = (0,_object_spread/* default */.Z)({
        mapDataProduct: mapDataProduct,
        removeCartItem: removeCartItem,
        removeAllCartItems: removeAllCartItems,
        updateCartItem: updateCartItem,
        updateCartItemMV2: updateCartItemMV2,
        increase: increase,
        decrease: decrease,
        clearCart: clearCart,
        handleCheckout: handleCheckout,
        addImportant: addImportant,
        removeImportant: removeImportant,
        updateCart: updateCart,
        updateDeliveryMethod: updateDeliveryMethod,
        updatePaymentMethod: updatePaymentMethod,
        reloadDataCart: reloadDataCart,
        getCartItemsInfo: getCartItemsInfo,
        updateInvoice: updateInvoice,
        updateDeliveryInfo: updateDeliveryInfo,
        updateCartInfo: updateCartInfo,
        reOrderById: reOrderById,
        updateCartItems: updateCartItems,
        updateCartItemByExecel: updateCartItemByExecel,
        selectCartItem: selectCartItem,
        selectAllCartItem: selectAllCartItem,
        unselectAllCartItem: unselectAllCartItem,
        verifyPayment: verifyPayment,
        confirmPriceFluctuation: confirmPriceFluctuation,
        confirmPriceFluctuationFromCart: confirmPriceFluctuationFromCart,
        applyPriceFluctuationFromVerify: applyPriceFluctuationFromVerify,
        goToCheckout: goToCheckout,
        isOpenPriceFluctuationModal: isOpenPriceFluctuationModal,
        togglePriceFluctuationModal: togglePriceFluctuationModal,
        validate200Item: validate200Item,
        getErrorCart: getErrorCart,
        toggleShowModalMax200Item: toggleShowModalMax200Item,
        isShowModalMax200Item: isShowModalMax200Item,
        giftProductRowRef: giftProductRowRef,
        handleScrollToGiftRow: handleScrollToGiftRow,
        isLoadingCart: isLoadingCart,
        getState: getState,
        isDeletingPromo: isDeletingPromo,
        togglePromoList: togglePromoList,
        tempRedeemApplyResult: tempRedeemApplyResult,
        setTempRedeemApplyResult: setTempRedeemApplyResult,
        toggleOnCheckingPromo: toggleOnCheckingPromo,
        multiVoucherHandleChangePromoV2: multiVoucherHandleChangePromoV2,
        multiVoucherHandleRemovePromoV2: multiVoucherHandleRemovePromoV2,
        removeVoucherByCode: removeVoucherByCode,
        invalidPromoCodes: getInvalidPromoCodes(),
        isShowRemoveInvalidPromos: isShowRemoveInvalidPromos,
        toggleShowRemoveInvalidPromos: toggleShowRemoveInvalidPromos,
        isRemovingInvalidPromos: isRemovingInvalidPromos,
        removeInvalidPromosAndContinue: removeInvalidPromosAndContinue
    }, state);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CartContext.Provider, {
        value: contextValues,
        children: children
    });
};
var useCart = function() {
    return (0,react.useContext)(CartContext);
};


/***/ }),

/***/ 14739:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ usePopup; },
/* harmony export */   "l": function() { return /* binding */ PopupProvider; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


/**
 * @typedef PopupContext
 * @property {boolean} open - true = popup is opened
 * @property {import('react').SetStateAction<boolean>} setOpen
 * @property {boolean} canShowNextPopup - true = popup is fetching popupData
 * @property {import('react').SetStateAction<boolean>} setCanShowNextPopup
 */ /**
 * @type {import('react').Context<PopupContext>}
 */ var PopupContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({});
function PopupProvider(param) {
    var children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), open = ref[0], setOpen = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), canShowNextPopup = ref1[0], setCanShowNextPopup = ref1[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PopupContext.Provider, {
        value: {
            open: open,
            setOpen: setOpen,
            canShowNextPopup: canShowNextPopup,
            setCanShowNextPopup: setCanShowNextPopup
        },
        children: children
    });
}
var usePopup = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(PopupContext);
};


/***/ }),

/***/ 5632:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "dp": function() { return /* binding */ ProductContextProvider; },
  "iB": function() { return /* binding */ useProduct; }
});

// UNUSED EXPORTS: ProductContext

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/clients/index.js + 20 modules
var clients = __webpack_require__(15149);
// EXTERNAL MODULE: ./src/clients/Clients.js + 1 modules
var Clients = __webpack_require__(38307);
;// CONCATENATED MODULE: ./src/clients/InsiderClient.js



var getSmartRecommendation = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var userId, _details, details, type, ctx, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            userId = param.userId, _details = param.details, details = _details === void 0 ? true : _details, type = param.type, ctx = param.ctx;
            _tmp = {};
            return [
                2,
                (0,Clients.GET)((_tmp.url = "/web/insider", _tmp.params = {
                    userId: userId,
                    details: details,
                    type: type
                }, _tmp.ctx = ctx, _tmp.mock = true, _tmp.isAuth = false, _tmp))
            ];
        });
    });
    return function getSmartRecommendation(_) {
        return _ref.apply(this, arguments);
    };
}();
var InsiderClient = {
    getSmartRecommendation: getSmartRecommendation
};
/* harmony default export */ var clients_InsiderClient = (InsiderClient);

// EXTERNAL MODULE: ./src/clients/MockClient.js
var MockClient = __webpack_require__(57601);
// EXTERNAL MODULE: ./src/constants/Enums/index.js
var Enums = __webpack_require__(71569);
// EXTERNAL MODULE: ./src/constants/Enums/http.js
var http = __webpack_require__(53208);
// EXTERNAL MODULE: ./src/constants/Tags/index.js
var Tags = __webpack_require__(91983);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/services/index.js + 15 modules
var services = __webpack_require__(788);
// EXTERNAL MODULE: ./src/sysconfig/index.js
var sysconfig = __webpack_require__(66225);
// EXTERNAL MODULE: ./src/utils/ArrUtils.js
var ArrUtils = __webpack_require__(33769);
// EXTERNAL MODULE: ./src/utils/EnhanceReducer.js
var EnhanceReducer = __webpack_require__(15067);
;// CONCATENATED MODULE: ./src/context/Product/types.js
/* harmony default export */ var types = ({
    GET_PRODUCT_BY_SKUS: "GET_PRODUCT_BY_SKUS",
    GET_PRODUCT_BY_IDS: "GET_PRODUCT_BY_IDS",
    CLEAR: "CLEAR",
    SET_PRODUCT_VIEWED: "SET_PRODUCT_VIEWED",
    CLEAR_MAP_PRODUCT: "CLEAR_MAP_PRODUCT",
    SET_HISTORY_TODAY: "SET_HISTORY_TODAY"
});

;// CONCATENATED MODULE: ./src/context/Product/reducer.js



var initialState = {
    loading: false,
    mapProducts: new Map(),
    mapProductsByIds: new Map(),
    productViewed: null,
    productsPerDay: []
};
var ProductReducer = function(state, param) {
    var type = param.type, payload = param.payload;
    switch(type){
        case types.SET_HISTORY_TODAY:
            {
                var productsPerDay = payload.productsPerDay;
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    productsPerDay: productsPerDay,
                    loading: false
                });
            }
        case types.CLEAR_MAP_PRODUCT:
            {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    mapProducts: new Map(),
                    mapProductsByIds: new Map()
                });
            }
        case types.GET_PRODUCT_BY_SKUS:
            {
                var mapProducts = payload.mapProducts;
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    mapProducts: mapProducts,
                    loading: false
                });
            }
        case types.SET_PRODUCT_VIEWED:
            {
                var productViewed = payload.productViewed;
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    productViewed: productViewed
                });
            }
        case types.GET_PRODUCT_BY_IDS:
            {
                var mapProductsByIds = payload.mapProductsByIds;
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    mapProductsByIds: mapProductsByIds,
                    loading: false
                });
            }
        case types.CLEAR:
            return (0,_object_spread/* default */.Z)({}, initialState);
        default:
            return state;
    }
};
/* harmony default export */ var reducer = (ProductReducer);

;// CONCATENATED MODULE: ./src/context/Product/context.js





















var ProductContext = /*#__PURE__*/ (0,react.createContext)();
var ProductContextProvider = function(param) {
    var children = param.children, initUser = param.initUser;
    var ref = (0,_sliced_to_array/* default */.Z)((0,EnhanceReducer/* useEnhancedReducer */.a)(reducer, {}), 3), state = ref[0], dispatch = ref[1], getState = ref[2];
    var clearProduct = function() {
        dispatch({
            type: types.CLEAR
        });
    };
    var clearMapProduct = function() {
        dispatch({
            type: types.CLEAR_MAP_PRODUCT
        });
    };
    // requiredCertificates: [ 'GPP', 'BUSINESS_CERTIFICATE', 'BUSINESS_LICENSE' ],
    // examinationAndTreatmentLicense  -> BUSINESS_LICENSE
    // pharmacyEligibilityLicense -> BUSINESS_CERTIFICATE
    // const {errorRequiredCertificate , errorRequiredCertificateMessage} = getProductError({product})
    var getProductError = function(param) {
        var product = param.product;
        var skus = (product || {}).skus;
        var requiredCertificates = (product === null || product === void 0 ? void 0 : product.requiredCertificates) || [];
        if ((skus === null || skus === void 0 ? void 0 : skus.length) >= 0) {
            skus.forEach(function(sku) {
                var ref;
                if (sku && ((ref = sku.requiredCertificates) === null || ref === void 0 ? void 0 : ref.length) >= 0) {
                    requiredCertificates = requiredCertificates.concat((sku === null || sku === void 0 ? void 0 : sku.requiredCertificates) || []);
                }
            });
        }
        // chỉ cần check user có 1 trong 3 loại giấy phép là dc
        if ((requiredCertificates === null || requiredCertificates === void 0 ? void 0 : requiredCertificates.length) > 0) {
            requiredCertificates = requiredCertificates.filter(ArrUtils/* default.onlyUnique */.ZP.onlyUnique);
            var errorRequiredCertificate = true;
            var ref = initUser || {}, _examinationAndTreatmentLicense = ref.examinationAndTreatmentLicense, examinationAndTreatmentLicense = _examinationAndTreatmentLicense === void 0 ? [] : _examinationAndTreatmentLicense, _gpp = ref.gpp, gpp = _gpp === void 0 ? [] : _gpp, _pharmacyEligibilityLicense = ref.pharmacyEligibilityLicense, pharmacyEligibilityLicense = _pharmacyEligibilityLicense === void 0 ? [] : _pharmacyEligibilityLicense;
            var userHaveCertificated = [];
            if ((gpp === null || gpp === void 0 ? void 0 : gpp.length) > 0) {
                userHaveCertificated.push("GPP");
            }
            if ((examinationAndTreatmentLicense === null || examinationAndTreatmentLicense === void 0 ? void 0 : examinationAndTreatmentLicense.length) > 0) {
                userHaveCertificated.push("BUSINESS_LICENSE");
            }
            if ((pharmacyEligibilityLicense === null || pharmacyEligibilityLicense === void 0 ? void 0 : pharmacyEligibilityLicense.length) > 0) {
                userHaveCertificated.push("BUSINESS_CERTIFICATE");
            }
            // so sánh 2 mảng có phần tử giống nhau
            if ((userHaveCertificated === null || userHaveCertificated === void 0 ? void 0 : userHaveCertificated.length) > 0) {
                // console.log(
                //   '🚀 ~ file: context.js ~ line 48 ~ getProductError ~ userHaveCertificated',
                //   product?.name,
                //   userHaveCertificated,
                //   requiredCertificates,
                // );
                requiredCertificates.forEach(function(item) {
                    var isHaveCertificated = userHaveCertificated.includes(item);
                    if (isHaveCertificated) {
                        errorRequiredCertificate = false;
                    }
                });
            }
            // chỉ cần check user có 1 trong 3 loại giấy phép là dc
            // errorRequiredCertificate = !(examinationAndTreatmentLicense?.length > 0 || gpp?.length > 0 || pharmacyEligibilityLicense?.length > 0);
            // check đúng Loại mới được mua
            // requiredCertificates.forEach((item) => {
            //   switch (item) {
            //     case 'GPP':
            //       if (!errorRequiredCertificate && gpp?.length === 0) errorRequiredCertificate = true;
            //       break;
            //     case 'BUSINESS_CERTIFICATE':
            //       if (examinationAndTreatmentLicense?.length === 0) errorRequiredCertificate = true;
            //       break;
            //     case 'BUSINESS_LICENSE':
            //       if (pharmacyEligibilityLicense?.length === 0) errorRequiredCertificate = true;
            //       break;
            //     default:
            //   }
            // });
            return {
                errorRequiredCertificate: errorRequiredCertificate,
                errorRequiredCertificateMessage: "Bạn chưa đủ giấy ph\xe9p để mua SP của nh\xe0 cung cấp n\xe0y. Vui l\xf2ng chọn SP tương tự của NCC kh\xe1c"
            };
        }
        return {};
    };
    // TODO:
    var getProductsByIds = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var ids, ref, _mapProductsByIds, mapProductsByIds, newList, result, _tmp, products, _tmp1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        ids = param.ids;
                        ref = getState(), _mapProductsByIds = ref.mapProductsByIds, mapProductsByIds = _mapProductsByIds === void 0 ? new Map() : _mapProductsByIds;
                        newList = ids.filter(function(id) {
                            return !mapProductsByIds.has(id);
                        });
                        // nếu ko có item nào ko có trong cache thì return ra map luôn
                        if (newList && newList.length === 0) {
                            return [
                                2,
                                mapProductsByIds
                            ];
                        }
                        _tmp = {};
                        return [
                            4,
                            services/* ProductServiceV2.getProductsByIds */.Rl.getProductsByIds((_tmp.ids = ids, _tmp))
                        ];
                    case 1:
                        result = _state.sent();
                        products = (0,clients/* getData */.Yu)(result);
                        // set lại vào map cache
                        products.forEach(function(item) {
                            mapProductsByIds.set(item.productID, item);
                        });
                        _tmp1 = {};
                        // lưu vào state
                        dispatch((_tmp1.type = types.GET_PRODUCT_BY_IDS, _tmp1.payload = {
                            mapProductsByIds: mapProductsByIds
                        }, _tmp1));
                        // trả ra map cache
                        return [
                            2,
                            mapProductsByIds
                        ];
                }
            });
        // getProductsByIds
        });
        return function getProductsByIds(_) {
            return _ref.apply(this, arguments);
        };
    }();
    var getProductBySkus = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var _skus, skus, getPrice, ref, _mapProducts, mapProducts, newList, result, _tmp, products, _tmp1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _skus = param.skus, skus = _skus === void 0 ? [] : _skus, getPrice = param.getPrice;
                        ref = getState(), _mapProducts = ref.mapProducts, mapProducts = _mapProducts === void 0 ? new Map() : _mapProducts;
                        newList = skus.filter(function(sku) {
                            return !mapProducts.has(sku);
                        });
                        if (newList && newList.length === 0) {
                            return [
                                2,
                                mapProducts
                            ];
                        }
                        _tmp = {};
                        return [
                            4,
                            services/* ProductServiceV2.getProductInfoFromSkus */.Rl.getProductInfoFromSkus((_tmp.skus = newList, _tmp.locationCode = initUser === null || initUser === void 0 ? void 0 : initUser.provinceCode, _tmp.customerLevel = initUser === null || initUser === void 0 ? void 0 : initUser.level, _tmp.getPrice = getPrice, _tmp.customerId = initUser === null || initUser === void 0 ? void 0 : initUser.customerID, _tmp))
                        ];
                    case 1:
                        result = _state.sent();
                        products = (0,clients/* getData */.Yu)(result);
                        products.forEach(function(item) {
                            mapProducts.set(item.sku, item);
                        });
                        _tmp1 = {};
                        dispatch((_tmp1.type = types.GET_PRODUCT_BY_SKUS, _tmp1.payload = {
                            mapProducts: mapProducts
                        }, _tmp1));
                        return [
                            2,
                            mapProducts
                        ];
                }
            });
        });
        return function getProductBySkus(_) {
            return _ref.apply(this, arguments);
        };
    }();
    var getProductByCampaign = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var campaignCode, _tmp;
            return (0,tslib_es6.__generator)(this, function(_state) {
                campaignCode = param.campaignCode;
                _tmp = {};
                return [
                    2,
                    services/* ProductServiceV2.getProductByCampaign */.Rl.getProductByCampaign((_tmp.campaignCode = campaignCode, _tmp))
                ];
            });
        });
        return function getProductByCampaign(_) {
            return _ref.apply(this, arguments);
        };
    }();
    //   const getBySku = (sku) => {};
    //   const getInfoProductBySlug = ({ slug }) => {};
    (0,react.useEffect)(function() {
        var ref = getState(), _productViewed = ref.productViewed, productViewed = _productViewed === void 0 ? null : _productViewed;
        if (!productViewed) {
            productViewed = [];
            var listViewed = JSON.parse(localStorage.getItem("productListViewed") || "[]") || [];
            listViewed === null || listViewed === void 0 ? void 0 : listViewed.forEach(function(list) {
                return productViewed.push(list);
            });
            dispatch({
                type: types.SET_PRODUCT_VIEWED,
                payload: {
                    productViewed: productViewed
                }
            });
        }
    // return productViewed;
    }, []);
    var addProductToListViewed = function(sku) {
        if (!sku || typeof sku !== "string") {
            return;
        }
        var ref = getState(), _productViewed = ref.productViewed, productViewed = _productViewed === void 0 ? [] : _productViewed;
        // Check sku đã có trong listViewed hay chưa, nếu đã có rồi thì xóa nó và thêm vào đầu listViewed
        var newProductViewed = (productViewed === null || productViewed === void 0 ? void 0 : productViewed.filter(function(item) {
            return item !== sku;
        })) || [];
        newProductViewed.unshift(sku);
        localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem("productListViewed", JSON.stringify(newProductViewed));
        dispatch({
            type: types.SET_PRODUCT_VIEWED,
            payload: {
                productViewed: newProductViewed
            }
        });
    };
    var getListViewed = function() {
        return getState().productViewed;
    };
    var filterProductByTag = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(_param) {
            var filter, offset, params, productRes, _tmp;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        filter = _param.filter, offset = _param.offset, params = (0,_object_without_properties/* default */.Z)(_param, [
                            "filter",
                            "offset"
                        ]);
                        _tmp = {};
                        return [
                            4,
                            services/* ProductServiceV2.loadProductFuzzy */.Rl.loadProductFuzzy((0,_object_spread/* default */.Z)((_tmp.filter = filter, _tmp.offset = offset, _tmp), params))
                        ];
                    case 1:
                        productRes = _state.sent();
                        return [
                            2,
                            productRes
                        ];
                }
            });
        });
        return function filterProductByTag(_param) {
            return _ref.apply(this, arguments);
        };
    }();
    var getDataProductBySlug = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var slug, getProductBySlug, productDataRes, _tmp;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        slug = param.slug;
                        getProductBySlug = sysconfig/* IS_WEB_SERVICE */.N9 ? services/* WebService.getDataProductDetail */.Qy.getDataProductDetail : services/* ProductServiceV2.getDataProductBySlug */.Rl.getDataProductBySlug;
                        _tmp = {};
                        return [
                            4,
                            getProductBySlug((_tmp.slug = slug, _tmp))
                        ];
                    case 1:
                        productDataRes = _state.sent();
                        return [
                            2,
                            productDataRes
                        ];
                }
            });
        });
        return function getDataProductBySlug(_) {
            return _ref.apply(this, arguments);
        };
    }();
    var getSortedProducts = function(products) {
        var medxNormalProducts = [];
        var medxKhuyenMaiProducts = [];
        var khuyenMaiProducts = [];
        var hoaDonNhanhProducts = [];
        var normalProducts = [];
        products === null || products === void 0 ? void 0 : products.forEach(function(product) {
            var ref, ref1, ref2;
            if ((product === null || product === void 0 ? void 0 : product.sellerCode) === Enums/* SELLER_GROUP.MEDX */.aM.MEDX && ((ref = product.tags) === null || ref === void 0 ? void 0 : ref.includes(Tags/* ENUM_TAG_CODES.HOADONNHANH */.c.HOADONNHANH))) {
                var ref3;
                if ((ref3 = product.tags) === null || ref3 === void 0 ? void 0 : ref3.includes(Tags/* ENUM_TAG_CODES.KHUYENMAI */.c.KHUYENMAI)) medxKhuyenMaiProducts.push(product);
                else medxNormalProducts.push(product);
            } else if ((ref1 = product.tags) === null || ref1 === void 0 ? void 0 : ref1.includes(Tags/* ENUM_TAG_CODES.KHUYENMAI */.c.KHUYENMAI)) {
                khuyenMaiProducts.push(product);
            } else if ((ref2 = product.tags) === null || ref2 === void 0 ? void 0 : ref2.includes(Tags/* ENUM_TAG_CODES.HOADONNHANH */.c.HOADONNHANH)) {
                hoaDonNhanhProducts.push(product);
            } else {
                normalProducts.push(product);
            }
        });
        var mergedData = (0,_to_consumable_array/* default */.Z)(medxKhuyenMaiProducts).concat((0,_to_consumable_array/* default */.Z)(khuyenMaiProducts), (0,_to_consumable_array/* default */.Z)(hoaDonNhanhProducts), (0,_to_consumable_array/* default */.Z)(medxNormalProducts), (0,_to_consumable_array/* default */.Z)(normalProducts));
        return mergedData;
    };
    var getDataProductRecommendation = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var type, ref, insiderLocalData, userId, _tmp, insiderRes, _tmp1, productSlugs, result, _tmp2;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        type = param.type;
                        insiderLocalData = JSON.parse((localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem("spUID")) || "{}");
                        userId = (insiderLocalData === null || insiderLocalData === void 0 ? void 0 : insiderLocalData.data) || "";
                        _tmp = {};
                        if (!userId) {
                            return [
                                2,
                                (_tmp.status = http/* HTTP_STATUS.NotFound */.M.NotFound, _tmp.data = [], _tmp)
                            ];
                        }
                        _tmp1 = {};
                        return [
                            4,
                            clients_InsiderClient.getSmartRecommendation((_tmp1.type = type, _tmp1.userId = userId, _tmp1))
                        ];
                    case 1:
                        insiderRes = _state.sent();
                        productSlugs = (insiderRes === null || insiderRes === void 0 ? void 0 : (ref = insiderRes.data) === null || ref === void 0 ? void 0 : ref.map(function(param) {
                            var url = param.url;
                            return url.substring(url.lastIndexOf("/") + 1, url.indexOf("?#ins_sr"));
                        })) || [];
                        _tmp2 = {};
                        return [
                            4,
                            MockClient/* default.getProductBySlugs */.Z.getProductBySlugs((_tmp2.slugs = productSlugs, _tmp2))
                        ];
                    case 2:
                        result = _state.sent();
                        if ((0,clients/* isValid */.JY)(result)) {
                            result.data = getSortedProducts(result.data);
                        }
                        return [
                            2,
                            result
                        ];
                }
            });
        });
        return function getDataProductRecommendation(_) {
            return _ref.apply(this, arguments);
        };
    }();
    // lấy ds sản phẩm recommend cxaur thuocsi
    var getDataProductRecommendationTS = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var type, value, _limit, limit, ref, q, _tmp, body, _tmp1, recommnendResult, _tmp2, productSkus, mapProduct, _tmp3, result, _tmp4, _tmp5;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        type = param.type, value = param.value, _limit = param.limit, limit = _limit === void 0 ? 20 : _limit;
                        _tmp = {};
                        q = _tmp;
                        switch(type){
                            case Enums/* THUOCSI_RECOMMENDATION.SAME_CATEGORY */.cm.SAME_CATEGORY:
                                q = {
                                    configMetricses: [
                                        {
                                            configMetricsCode: "SKU_SAME_CATEGORY"
                                        }, 
                                    ],
                                    categories: value
                                };
                                break;
                            case Enums/* THUOCSI_RECOMMENDATION.PURCHASE_TOGETHER */.cm.PURCHASE_TOGETHER:
                                q = {
                                    configMetricses: [
                                        {
                                            configMetricsCode: "SKU_PURCHASE_TOGETHER"
                                        }, 
                                    ],
                                    skuCodes: [
                                        value
                                    ]
                                };
                                break;
                            default:
                                q = {};
                        }
                        _tmp1 = {};
                        body = (_tmp1.q = q, _tmp1.limit = limit, _tmp1);
                        _tmp2 = {};
                        return [
                            4,
                            services/* SmartRecommendationService.getRecommendation */.J.getRecommendation((_tmp2.body = body, _tmp2))
                        ];
                    case 1:
                        recommnendResult = _state.sent();
                        productSkus = (ref = (0,clients/* getData */.Yu)(recommnendResult)) === null || ref === void 0 ? void 0 : ref.map(function(item) {
                            return item.sku;
                        });
                        _tmp3 = {};
                        return [
                            4,
                            getProductBySkus((_tmp3.skus = productSkus, _tmp3))
                        ];
                    case 2:
                        mapProduct = _state.sent();
                        _tmp4 = {};
                        _tmp5 = {};
                        result = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)(_tmp4, recommnendResult), (_tmp5.data = productSkus === null || productSkus === void 0 ? void 0 : productSkus.map(function(item) {
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (mapProduct === null || mapProduct === void 0 ? void 0 : mapProduct.get(item)) || {}), {
                                isRecommendedByTS: true
                            });
                        }), _tmp5));
                        return [
                            2,
                            result
                        ];
                }
            });
        });
        return function getDataProductRecommendationTS(_) {
            return _ref.apply(this, arguments);
        };
    }();
    var getProductRecommendationForHomePage = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var _limit, limit, _offset, offset, ref, q, _tmp, body, _tmp1, recommendResult, _tmp2, result, _tmp3;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _limit = param.limit, limit = _limit === void 0 ? 20 : _limit, _offset = param.offset, offset = _offset === void 0 ? 0 : _offset;
                        _tmp = {};
                        q = (_tmp.configMetricses = [
                            {
                                configMetricsCode: "SKU_NOT_BUY_RECENTLY"
                            }, 
                        ], _tmp);
                        _tmp1 = {};
                        body = (_tmp1.q = q, _tmp1.limit = limit, _tmp1.getTotal = true, _tmp1.queryOption = {
                            consumedMaxQuantity: true,
                            sellerInfo: true,
                            sellerInfoLive: true,
                            price: true,
                            quantityOnCart: true
                        }, _tmp1);
                        if (offset) {
                            body.offset = offset;
                        }
                        _tmp2 = {};
                        return [
                            4,
                            services/* SmartRecommendationService.getRecommendationForHomePage */.J.getRecommendationForHomePage((_tmp2.body = body, _tmp2))
                        ];
                    case 1:
                        recommendResult = _state.sent();
                        _tmp3 = {};
                        result = (_tmp3.data = [], _tmp3.total = 0, _tmp3);
                        result.data = ((ref = (0,clients/* getData */.Yu)(recommendResult)) === null || ref === void 0 ? void 0 : ref.map(function(item) {
                            return services/* ProductServiceV2.convertProductV2 */.Rl.convertProductV2(item);
                        })) || [];
                        result.total = recommendResult.total;
                        return [
                            2,
                            result
                        ];
                }
            });
        });
        return function getProductRecommendationForHomePage(_) {
            return _ref.apply(this, arguments);
        };
    }();
    var getSkuHistoryPerDay = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var sku, result, _tmp, productsPerDay, _tmp1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        sku = param.sku;
                        _tmp = {};
                        return [
                            4,
                            clients/* ProductClientV2.getSkusBuyed */.j4.getSkusBuyed((_tmp.skuCode = sku, _tmp))
                        ];
                    case 1:
                        result = _state.sent();
                        productsPerDay = (0,clients/* getData */.Yu)(result);
                        _tmp1 = {};
                        if ((0,clients/* isValid */.JY)(result)) {
                            // const productsPerDay = getData(result);
                            dispatch((_tmp1.type = types.SET_HISTORY_TODAY, _tmp1.payload = {
                                productsPerDay: productsPerDay
                            }, _tmp1));
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function getSkuHistoryPerDay(_) {
            return _ref.apply(this, arguments);
        };
    }();
    var getInfoProductPerDay = function() {
        return getState().productsPerDay;
    };
    // using FE-apis
    var filterProducts = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(_param) {
            var filter, offset, params, productRes, _tmp;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        filter = _param.filter, offset = _param.offset, params = (0,_object_without_properties/* default */.Z)(_param, [
                            "filter",
                            "offset"
                        ]);
                        _tmp = {};
                        return [
                            4,
                            services/* WebService.loadProductFuzzy */.Qy.loadProductFuzzy((0,_object_spread/* default */.Z)((_tmp.filter = filter, _tmp.offset = offset, _tmp), params))
                        ];
                    case 1:
                        productRes = _state.sent();
                        return [
                            2,
                            productRes
                        ];
                }
            });
        });
        return function filterProducts(_param) {
            return _ref.apply(this, arguments);
        };
    }();
    var getRecentProducts = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(_param) {
            var filter, offset, params, productRes, _tmp;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        filter = _param.filter, offset = _param.offset, params = (0,_object_without_properties/* default */.Z)(_param, [
                            "filter",
                            "offset"
                        ]);
                        _tmp = {};
                        return [
                            4,
                            services/* WebService.loadRecentProducts */.Qy.loadRecentProducts((0,_object_spread/* default */.Z)((_tmp.filter = filter, _tmp.offset = offset, _tmp), params))
                        ];
                    case 1:
                        productRes = _state.sent();
                        return [
                            2,
                            productRes
                        ];
                }
            });
        });
        return function getRecentProducts(_param) {
            return _ref.apply(this, arguments);
        };
    }();
    var contextValues = (0,_object_spread/* default */.Z)({
        clearProduct: clearProduct,
        getProductBySkus: getProductBySkus,
        getProductsByIds: getProductsByIds,
        getDataProductBySlug: getDataProductBySlug,
        getDataProductRecommendation: getDataProductRecommendation,
        getProductByCampaign: getProductByCampaign,
        getListViewed: getListViewed,
        addProductToListViewed: addProductToListViewed,
        filterProductByTag: filterProductByTag,
        clearMapProduct: clearMapProduct,
        getSkuHistoryPerDay: getSkuHistoryPerDay,
        getInfoProductPerDay: getInfoProductPerDay,
        getDataProductRecommendationTS: getDataProductRecommendationTS,
        getProductRecommendationForHomePage: getProductRecommendationForHomePage,
        getProductError: getProductError,
        getSortedProducts: getSortedProducts,
        filterProducts: filterProducts,
        getRecentProducts: getRecentProducts
    }, state);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductContext.Provider, {
        value: contextValues,
        children: children
    });
};
var useProduct = function() {
    return (0,react.useContext)(ProductContext);
};


/***/ }),

/***/ 33436:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Ho": function() { return /* reexport */ Auth/* AuthProvider */.Ho; },
  "GN": function() { return /* reexport */ CartContext/* CartContextProvider */.GN; },
  "sV": function() { return /* reexport */ Auth/* LoadingRoute */.sV; },
  "aO": function() { return /* reexport */ NotiContextProvider; },
  "dp": function() { return /* reexport */ context/* ProductContextProvider */.dp; },
  "X$": function() { return /* reexport */ SearchProvider; },
  "oh": function() { return /* reexport */ SettingProvider; },
  "tp": function() { return /* reexport */ TicketProvider; },
  "XG": function() { return /* reexport */ WishListProvider; },
  "aC": function() { return /* reexport */ Auth/* useAuth */.aC; },
  "jD": function() { return /* reexport */ CartContext/* useCart */.jD; },
  "d$": function() { return /* reexport */ useNotify; },
  "iB": function() { return /* reexport */ context/* useProduct */.iB; },
  "Rx": function() { return /* reexport */ useSearch; },
  "yu": function() { return /* reexport */ useSetting; },
  "Q$": function() { return /* reexport */ useTicket; },
  "L4": function() { return /* reexport */ useWishList; }
});

// UNUSED EXPORTS: CartContext, NOTIFY_TYPES, NotiContext, ProductContext, ViewProvider, useView

// EXTERNAL MODULE: ./src/context/Auth/index.js + 4 modules
var Auth = __webpack_require__(58530);
// EXTERNAL MODULE: ./src/context/Cart/CartContext.js + 2 modules
var CartContext = __webpack_require__(15012);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/clients/index.js + 20 modules
var clients = __webpack_require__(15149);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 6 modules
var esm = __webpack_require__(5233);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/services/NofifyService.js



var getTotalNotification = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx, res, _tmp, _tmp1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ctx = param.ctx;
                    _tmp = {};
                    return [
                        4,
                        clients/* NotifyClient.getTotalNotification */.$T.getTotalNotification((_tmp.ctx = ctx, _tmp))
                    ];
                case 1:
                    res = _state.sent();
                    _tmp1 = {};
                    if (!(0,clients/* isValid */.JY)(res)) {
                        return [
                            2,
                            _tmp1
                        ];
                    }
                    return [
                        2,
                        (0,clients/* getFirst */.Xi)(res)
                    ];
            }
        });
    });
    return function getTotalNotification(_) {
        return _ref.apply(this, arguments);
    };
}();
var getNotifications = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx, res, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ctx = param.ctx;
                    _tmp = {};
                    return [
                        4,
                        clients/* NotifyClient.getNotify */.$T.getNotify((_tmp.ctx = ctx, _tmp))
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res
                    ];
            }
        });
    });
    return function getNotifications(_) {
        return _ref.apply(this, arguments);
    };
}();
var markReadAll = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            ctx = param.ctx;
            _tmp = {};
            return [
                2,
                clients/* NotifyClient.markReadAllNoti */.$T.markReadAllNoti((_tmp.ctx = ctx, _tmp))
            ];
        });
    });
    return function markReadAll(_) {
        return _ref.apply(this, arguments);
    };
}();
var markReadByCode = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx, code, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            ctx = param.ctx, code = param.code;
            _tmp = {};
            return [
                2,
                clients/* NotifyClient.markReadNotiByCode */.$T.markReadNotiByCode((_tmp.ctx = ctx, _tmp.code = code, _tmp))
            ];
        });
    });
    return function markReadByCode(_) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var NofifyService = ({
    getTotalNotification: getTotalNotification,
    getNotifications: getNotifications,
    markReadAll: markReadAll,
    markReadByCode: markReadByCode
});

// EXTERNAL MODULE: ./src/utils/index.js + 5 modules
var utils = __webpack_require__(76480);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
;// CONCATENATED MODULE: ./src/context/Notifications/NotiReducer.js



var NotiReducer = function(state, action) {
    var notification = state.notification;
    switch(action.type){
        case "INIT_WEB_SOCKET_SUCCESS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                initSocket: true
            });
        case "FETCH_SUCCESS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                notification: (0,_to_consumable_array/* default */.Z)(action.payload.notification),
                unread: action.payload.unread,
                total: action.payload.total,
                loading: false
            });
        case "FETCH_ERROR":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                notification: [],
                unread: 0,
                total: 0,
                loading: false
            });
        case "GET_NOTIFICATIONS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                notification: (0,_to_consumable_array/* default */.Z)(notification)
            });
        case "CLEAR_ALL":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                notification: [],
                unread: 0,
                total: 0
            });
        default:
            return state;
    }
};
/* harmony default export */ var Notifications_NotiReducer = (NotiReducer);

;// CONCATENATED MODULE: ./src/context/Notifications/index.js
/* eslint-disable import/no-named-as-default-member */ 











var NOTIFY_TYPES = {
    FETCH_SUCCESS: "FETCH_SUCCESS",
    FETCH_ERROR: "FETCH_ERROR",
    INIT_WEB_SOCKET_SUCCESS: "INIT_WEB_SOCKET_SUCCESS",
    INIT_WEB_SOCKET_FAIL: "INIT_WEB_SOCKET_FAIL"
};
var NotiContext = /*#__PURE__*/ (0,react.createContext)();
var NotiContextProvider = function(param) {
    var children = param.children;
    var ref = (0,esm/* useTranslation */.$G)("common"), translateCommon = ref.t;
    var user = (0,Auth/* useAuth */.aC)().user;
    var initialState = {
        loading: true,
        notification: [],
        totalNotification: 0,
        initSocket: false
    };
    var ref1 = (0,react.useReducer)(Notifications_NotiReducer, initialState), state = ref1[0], dispatch = ref1[1];
    var fetchData = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var totalNotification, _tmp, unread, total, read, notificationRes, _tmp1, _tmp2, _tmp3, error, _tmp4;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        _tmp = {};
                        return [
                            4,
                            NofifyService.getTotalNotification(_tmp)
                        ];
                    case 1:
                        totalNotification = _state.sent();
                        if (!totalNotification) {
                            return [
                                2
                            ];
                        }
                        unread = totalNotification.unread, total = totalNotification.total, read = totalNotification.read;
                        _tmp1 = {};
                        return [
                            4,
                            NofifyService.getNotifications(_tmp1)
                        ];
                    case 2:
                        notificationRes = _state.sent();
                        _tmp2 = {};
                        _tmp3 = {};
                        if ((0,clients/* isValid */.JY)(notificationRes)) {
                            dispatch((_tmp2.type = NOTIFY_TYPES.FETCH_SUCCESS, _tmp2.payload = {
                                notification: notificationRes.data,
                                unread: unread,
                                total: total,
                                read: read
                            }, _tmp2));
                        } else {
                            dispatch((_tmp3.type = NOTIFY_TYPES.FETCH_ERROR, _tmp3));
                        }
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        _tmp4 = {};
                        dispatch((_tmp4.type = NOTIFY_TYPES.FETCH_ERROR, _tmp4));
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function fetchData() {
            return _ref.apply(this, arguments);
        };
    }();
    var initSocketFunc = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var userInfo, url, ws, authSocket;
            return (0,tslib_es6.__generator)(this, function(_state) {
                userInfo = param.user;
                try {
                    url = "wss://".concat(window.location.hostname, "/integration/notification/v1/web-socket");
                    ws = new WebSocket(url);
                    authSocket = function() {
                        var _ref = (0,_async_to_generator/* default */.Z)(function() {
                            var ref, account, _session, session, _tmp, _tmp1, ref1, token, type, _tmp2, authMessage, _tmp3, _tmp4;
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                _tmp = {};
                                _tmp1 = {};
                                ref = userInfo || _tmp, account = ref.account, _session = ref.session, session = _session === void 0 ? _tmp1 : _session;
                                _tmp2 = {};
                                ref1 = session || _tmp2, token = ref1.token, type = ref1.type;
                                _tmp3 = {};
                                authMessage = (_tmp3.topic = "AUTHORIZATION", _tmp3.content = {
                                    username: account === null || account === void 0 ? void 0 : account.username,
                                    sessionToken: token,
                                    type: type
                                }, _tmp3);
                                // NotifyUtils.success(`SOCKET: send auth message ${JSON.stringify(authMessage)}`);
                                ws.send(JSON.stringify(authMessage));
                                _tmp4 = {};
                                dispatch((_tmp4.type = NOTIFY_TYPES.INIT_WEB_SOCKET_SUCCESS, _tmp4));
                                return [
                                    2
                                ];
                            });
                        });
                        return function authSocket() {
                            return _ref.apply(this, arguments);
                        };
                    }();
                    ws.onopen = function() {
                    // NotifyUtils.success('SOCKET: is open ');
                    };
                    ws.onclose = function() {
                        // NotifyUtils.error('SOCKET: is closed ');
                        authSocket({});
                    };
                    ws.onmessage = function(e) {
                        try {
                            // NotifyUtils.success('SOCKET: is on message ');
                            var data = JSON.parse(e.data);
                            if (data) {
                                var topic = data.topic;
                                switch(topic){
                                    case "CONNECTED":
                                        authSocket({});
                                        break;
                                    case "AUTHORIZATION":
                                        break;
                                    case "CONNECTION":
                                        break;
                                    case "PROMOTION":
                                        break;
                                    case "EVENT":
                                        break;
                                    case "ANNOUNCEMENT":
                                        utils/* NotifyUtils.info */.QP.info(translateCommon("message_have_new_notification"));
                                        fetchData();
                                        break;
                                    case "CART_UPDATE":
                                        utils/* NotifyUtils.info */.QP.info(translateCommon("message_cart_change"));
                                        break;
                                    default:
                                        break;
                                }
                            }
                        } catch (ex) {
                            console.error(ex);
                        }
                    };
                //
                } catch (err) {
                    console.error(err);
                }
                return [
                    2
                ];
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    (0,react.useEffect)(function() {
        if (user) {
            if (!state.initSocket) {
                fetchData();
                initSocketFunc({
                    user: user
                });
            }
        } else {
            // clear all if don't have notification
            dispatch({
                type: "CLEAR_ALL"
            });
        }
    }, [
        initSocketFunc,
        user
    ]);
    var markAll = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var rest, _tmp;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = {};
                        return [
                            4,
                            NofifyService.markReadAll(_tmp)
                        ];
                    case 1:
                        rest = _state.sent();
                        fetchData();
                        return [
                            2,
                            rest
                        ];
                }
            });
        });
        return function markAll() {
            return _ref.apply(this, arguments);
        };
    }();
    var markReadByCode = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(code) {
            var res, _tmp;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = {};
                        return [
                            4,
                            NofifyService.markReadByCode((_tmp.code = code, _tmp))
                        ];
                    case 1:
                        res = _state.sent();
                        fetchData();
                        return [
                            2,
                            res
                        ];
                }
            });
        });
        return function markReadByCode(code) {
            return _ref.apply(this, arguments);
        };
    }();
    var contextValues = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
        markAll: markAll,
        markReadByCode: markReadByCode
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NotiContext.Provider, {
        value: contextValues,
        children: children
    });
};
var useNotify = function() {
    return (0,react.useContext)(NotiContext);
};

// EXTERNAL MODULE: ./src/context/Product/context.js + 3 modules
var context = __webpack_require__(5632);
// EXTERNAL MODULE: ./src/clients/ProductClientV2.js
var ProductClientV2 = __webpack_require__(22997);
// EXTERNAL MODULE: ./src/constants/data/index.js
var constants_data = __webpack_require__(66520);
// EXTERNAL MODULE: ./src/constants/Paths/index.js
var Paths = __webpack_require__(199);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var src_sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./src/clients/CatClientV2.js
var CatClientV2 = __webpack_require__(12141);
// EXTERNAL MODULE: ./src/clients/IngredientClient.js
var IngredientClient = __webpack_require__(82036);
// EXTERNAL MODULE: ./src/constants/manufacturer.js
var manufacturer = __webpack_require__(59893);
// EXTERNAL MODULE: ./src/hooks/index.js + 9 modules
var hooks = __webpack_require__(91866);
// EXTERNAL MODULE: ./src/services/AddressService.js
var AddressService = __webpack_require__(84378);
// EXTERNAL MODULE: ./src/utils/ArrUtils.js
var ArrUtils = __webpack_require__(33769);
;// CONCATENATED MODULE: ./src/context/Settings/index.js














var SettingContext = /*#__PURE__*/ (0,react.createContext)({});
var SettingProvider = function(param) {
    var children = param.children;
    var isAuthenticated = (0,Auth/* useAuth */.aC)().isAuthenticated;
    var ref = (0,src_sliced_to_array/* default */.Z)((0,hooks/* useLocalStorage */._)({
        key: "suggestKeywords",
        getValueDefault: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var suggestKeywordsRes, data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,ProductClientV2/* getSuggestKeyword */.yx)()
                        ];
                    case 1:
                        suggestKeywordsRes = _state.sent();
                        data = (0,clients/* getData */.Yu)(suggestKeywordsRes);
                        return [
                            2,
                            data && data.length > 0 ? data : null
                        ];
                }
            });
        }),
        fieldNames: [
            "id",
            "keyword"
        ]
    }), 2), suggestKeywords = ref[0], getSuggestKeywords = ref[1];
    // getProvinces
    var ref1 = (0,src_sliced_to_array/* default */.Z)((0,hooks/* useLocalStorage */._)({
        key: "provincesList",
        getValueDefault: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var provinceRes, _tmp, data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = {};
                        return [
                            4,
                            AddressService/* default.getAllProvinceMock */.Z.getAllProvinceMock(_tmp)
                        ];
                    case 1:
                        provinceRes = _state.sent();
                        data = (0,clients/* getData */.Yu)(provinceRes);
                        return [
                            2,
                            data && data.length > 0 ? data : null
                        ];
                }
            });
        }),
        fieldNames: [
            "label",
            "value",
            "regionCode"
        ]
    }), 2), provinces = ref1[0], getProvinces = ref1[1];
    var getRegionByProvinceCode = function(provinceCode) {
        var ref;
        return ((ref = provinces === null || provinces === void 0 ? void 0 : provinces.find(function(item) {
            return item.value === provinceCode;
        })) === null || ref === void 0 ? void 0 : ref.regionCode) || null;
    };
    // categories
    var ref2 = (0,src_sliced_to_array/* default */.Z)((0,hooks/* useLocalStorage */._)({
        key: "categories",
        getValueDefault: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var categoriesRes, _tmp, data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = {};
                        return [
                            4,
                            CatClientV2/* default.loadGroupMock */.Z.loadGroupMock(_tmp)
                        ];
                    case 1:
                        categoriesRes = _state.sent();
                        data = (0,clients/* getData */.Yu)(categoriesRes);
                        return [
                            2,
                            data && data.length > 0 ? data : null
                        ];
                }
            });
        }),
        fieldNames: [
            "code",
            "name",
            "slug",
            "subEfficacies",
            "relatedEfficacyCodes",
            "relatedSellerCategoryCodes",
            "relatedCategoryCodes", 
        ]
    }), 2), categories = ref2[0], getCategories = ref2[1];
    var ref3 = (0,react.useState)(new Map()), mapCategories = ref3[0], setMapCategories = ref3[1];
    (0,react.useEffect)(function() {
        if (categories && categories.length > 0) {
            setMapCategories((0,ArrUtils/* convertArrayToMap */.lE)(categories, "code"));
        }
    }, [
        categories
    ]);
    // const getStyleBySlugOfTag = (code) => settingTags?.get(code);
    // manufactor
    var ref4 = (0,react.useState)(new Map()), mapManufactuers = ref4[0], setMapManufactuers = ref4[1];
    var ref5 = (0,react.useState)([]), topManufacturers = ref5[0], setTopManufacturers = ref5[1];
    var ref6 = (0,src_sliced_to_array/* default */.Z)((0,hooks/* useLocalStorage */._)({
        key: "manufactuers",
        getValueDefault: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var settingRes, data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            clients/* ProductClientV2.loadDataManufacturerMock */.j4.loadDataManufacturerMock()
                        ];
                    case 1:
                        settingRes = _state.sent();
                        data = (0,clients/* getData */.Yu)(settingRes);
                        return [
                            2,
                            data && data.length > 0 ? data : null
                        ];
                }
            });
        }),
        fieldNames: [
            "code",
            "name",
            "slug",
            "shortName"
        ]
    }), 2), manufactuers = ref6[0], getManufacturers = ref6[1];
    (0,react.useEffect)(function() {
        if (manufactuers && manufactuers.length > 0) {
            setMapManufactuers((0,ArrUtils/* convertArrayToMap */.lE)(manufactuers, "code"));
            if (manufacturer/* TopManufacturer */.j && manufacturer/* TopManufacturer.length */.j.length > 0) {
                var topManufacturersList = manufactuers === null || manufactuers === void 0 ? void 0 : manufactuers.filter(function(item) {
                    return manufacturer/* TopManufacturer.indexOf */.j.indexOf(item.code) >= 0;
                });
                if (topManufacturersList.length === 0) {
                    setTopManufacturers((manufactuers === null || manufactuers === void 0 ? void 0 : manufactuers.slice(0, 20)) || []);
                } else {
                    setTopManufacturers(topManufacturersList);
                }
            }
        }
    }, [
        manufactuers
    ]);
    // ingredients
    var ref7 = (0,react.useState)(new Map()), mapIngredients = ref7[0], setMapIngredients = ref7[1];
    var ref8 = (0,react.useState)(new Map()), mapIngredientsById = ref8[0], setMapIngredientsById = ref8[1];
    var ref9 = (0,src_sliced_to_array/* default */.Z)((0,hooks/* useLocalStorage */._)({
        key: "ingredients",
        getValueDefault: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var settingRes, data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            IngredientClient/* default.loadDataIngredientClientMock */.Z.loadDataIngredientClientMock()
                        ];
                    case 1:
                        settingRes = _state.sent();
                        data = settingRes === null || settingRes === void 0 ? void 0 : settingRes.data;
                        return [
                            2,
                            data && data.length > 0 ? data : null
                        ];
                }
            });
        }),
        fieldNames: [
            "id",
            "name",
            "slug",
            "code",
            "isMedicine",
            "unsignedKey"
        ]
    }), 2), ingredients = ref9[0], getIngredients = ref9[1];
    (0,react.useEffect)(function() {
        if (ingredients && ingredients.length > 0) {
            setMapIngredients((0,ArrUtils/* convertArrayToMap */.lE)(ingredients, "code"));
            setMapIngredientsById((0,ArrUtils/* convertArrayToMap */.lE)(ingredients, "id"));
        }
    }, [
        ingredients
    ]);
    // -------------------------------------------------------------------------------------------------------------
    /*
   ingredient product ( là dạng chưa tên và số lượng sẵn để chọn cho nhanh - không thay thế cho ingredient cũ )
   ingredientProduct  
  {
            "code": "5335B42U1Y",  // mã code mà bên trong product detail trả về 
            "lastUpdatedTime": "2021-08-18T07:12:29.873Z",
            "localName": "Kẽm 70Mg/Liều", // tên kèm cả miligam 
            "name": "Zinc 70Mg/Dose"// tên kèm cả miligam 
  },

  ở đây dùng để cache data xuống local storage để tránh phải get đi get lại nhiều lần
  */ var ref10 = (0,react.useState)(new Map()), mapIngredientsProduct = ref10[0], setMapIngredientsProduct = ref10[1];
    // useLocalStorage :(nhấn vào để xem chi tiết ) dùng để lưu xuống local storage với ttl ( expired ) , giá trị mặc định , và key : dùng dể get từ local storage ra
    var ref11 = (0,src_sliced_to_array/* default */.Z)((0,hooks/* useLocalStorage */._)({
        key: "ingredientsProduct",
        getValueDefault: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var settingRes, data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            IngredientClient/* default.getAllIngredientProductMock */.Z.getAllIngredientProductMock()
                        ];
                    case 1:
                        settingRes = _state.sent();
                        data = settingRes === null || settingRes === void 0 ? void 0 : settingRes.data;
                        // const data = getData(settingRes)?.map(({ code, name, ingredientId }) => ({ code, name, ingredientId })) || null;
                        return [
                            2,
                            data && data.length > 0 ? data : null
                        ];
                }
            });
        }),
        fieldNames: [
            "name",
            "code"
        ]
    }), 2), ingredientsProduct = ref11[0], getIngredientsProduct = ref11[1];
    (0,react.useEffect)(function() {
        if (ingredientsProduct && ingredientsProduct.length > 0) {
            setMapIngredientsProduct((0,ArrUtils/* convertArrayToMap */.lE)(ingredientsProduct, "code"));
        }
    }, [
        ingredientsProduct
    ]);
    // -------------------------------------------------------------------------------------------------------------
    // Seller info
    var ref12 = (0,react.useState)(new Map()), mapSeller = ref12[0], setMapSeller = ref12[1];
    var ref13 = (0,src_sliced_to_array/* default */.Z)((0,hooks/* useLocalStorage */._)({
        key: "seller",
        getValueDefault: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var sellerRes, data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            clients/* SupplierClient.getSellersMock */.VS.getSellersMock()
                        ];
                    case 1:
                        sellerRes = _state.sent();
                        data = (0,clients/* getData */.Yu)(sellerRes);
                        return [
                            2,
                            data && data.length > 0 ? data : null
                        ];
                }
            });
        }),
        fieldNames: [
            "code",
            "isInternal",
            "name",
            "sellerType",
            "slug",
            "landingPage",
            "fullName",
            "isVip",
            "avatar",
            "status",
            "statusStore",
            "storeSlug",
            "isStore", 
        ]
    }), 2), sellers = ref13[0], getSellers = ref13[1];
    (0,react.useEffect)(function() {
        if (sellers && sellers.length > 0) {
            setMapSeller((0,ArrUtils/* convertArrayToMap */.lE)(sellers, "code"));
        }
    }, [
        sellers
    ]);
    // end sellers
    // reasons ticket list
    var ref14 = (0,react.useState)(new Map()), mapReasonsTicket = ref14[0], setMapReasonsTicket = ref14[1];
    var ref15 = (0,src_sliced_to_array/* default */.Z)((0,hooks/* useLocalStorage */._)({
        key: "reasonsTicket",
        getValueDefault: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var reasonResult, data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            clients/* TicketClient.getListReasonsWithoutLoginMock */.ZX.getListReasonsWithoutLoginMock()
                        ];
                    case 1:
                        reasonResult = _state.sent();
                        data = (0,clients/* getData */.Yu)(reasonResult);
                        return [
                            2,
                            data && data.length > 0 ? data : null
                        ];
                }
            });
        }),
        fieldNames: [
            "code",
            "name",
            "nameEn",
            "orderStatuses",
            "showBankAccount",
            "status",
            "ticketType", 
        ]
    }), 2), reasonsTicket = ref15[0], getReasonsTicket = ref15[1];
    (0,react.useEffect)(function() {
        if (reasonsTicket && reasonsTicket.length > 0) {
            setMapReasonsTicket((0,ArrUtils/* convertArrayToMap */.lE)(reasonsTicket, "code"));
        }
    }, [
        reasonsTicket
    ]);
    // end reasons ticket
    // store active
    var ref16 = (0,react.useState)(new Map()), mapStoreActives = ref16[0], setMapStoreActives = ref16[1];
    var ref17 = (0,src_sliced_to_array/* default */.Z)((0,hooks/* useLocalStorage */._)({
        key: "storeActives",
        getValueDefault: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var ref, storeActiveResult, _tmp, data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = {};
                        return [
                            4,
                            clients/* SellerClient.getAllStoreActiveWeb */.vQ.getAllStoreActiveWeb(_tmp)
                        ];
                    case 1:
                        storeActiveResult = _state.sent();
                        data = (ref = (0,clients/* getData */.Yu)(storeActiveResult)) === null || ref === void 0 ? void 0 : ref.map(function(param) {
                            var sellerCode = param.sellerCode;
                            return {
                                sellerCode: sellerCode
                            };
                        });
                        return [
                            2,
                            data && data.length > 0 ? data : null
                        ];
                }
            });
        }),
        fieldNames: [
            "sellerCode"
        ]
    }), 2), storeActives = ref17[0], getStoreActives = ref17[1];
    (0,react.useEffect)(function() {
        if (storeActives && storeActives.length > 0) {
            setMapStoreActives((0,ArrUtils/* convertArrayToMap */.lE)(storeActives, "sellerCode"));
        }
    }, [
        storeActives
    ]);
    // COUNTRY
    var ref18 = (0,react.useState)(new Map()), mapCountry = ref18[0], setMapCountry = ref18[1];
    var ref19 = (0,src_sliced_to_array/* default */.Z)((0,hooks/* useLocalStorage */._)({
        key: "countries",
        getValueDefault: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var contryListRes, _tmp, data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = {};
                        return [
                            4,
                            AddressService/* default.getAllCountriesMock */.Z.getAllCountriesMock(_tmp)
                        ];
                    case 1:
                        contryListRes = _state.sent();
                        data = (0,clients/* getData */.Yu)(contryListRes);
                        return [
                            2,
                            data && data.length > 0 ? data : null
                        ];
                }
            });
        }),
        fieldNames: [
            "label",
            "value"
        ]
    }), 2), countryLists = ref19[0], getCountryLists = ref19[1];
    (0,react.useEffect)(function() {
        if (countryLists && countryLists.length > 0) {
            setMapCountry((0,ArrUtils/* convertArrayToMap */.lE)(countryLists, "value"));
        }
    }, [
        countryLists
    ]);
    // ENd COUNTRY
    (0,react.useEffect)(function() {
        if (!((countryLists === null || countryLists === void 0 ? void 0 : countryLists.length) > 0)) {
            getCountryLists();
        }
        if (!((reasonsTicket === null || reasonsTicket === void 0 ? void 0 : reasonsTicket.length) > 0)) {
            getReasonsTicket();
        }
        if (!ingredients || ingredients.length === 0) {
            getIngredients();
        }
        if (isAuthenticated) {
            if (!storeActives) {
                getStoreActives();
            }
            if (!manufactuers) {
                getManufacturers();
            }
            if (!categories) {
                getCategories();
            }
            if (!provinces) {
                getProvinces();
            }
            // if (!suggestKeywords) {
            //   getSuggestKeywords();
            // }
            // nếu khi vào trang chưa có thì sẽ tự động load lên
            if (!ingredientsProduct) {
                getIngredientsProduct();
            }
            if (!sellers) {
                getSellers();
            }
        }
    }, [
        isAuthenticated
    ]);
    // seller name
    var getNameSeller = function(props) {
        var _seller = props.seller, seller = _seller === void 0 ? {} : _seller, _tags = props.tags, tags = _tags === void 0 ? [] : _tags;
        // const { code } = seller;
        // const isVAT = tags?.indexOf('HOADONNHANH') >= 0 || false;
        // const sellerInfo = mapSeller?.get(code) || null;
        // let sellerName = '';
        // let isDisplayStore = false;
        // let fullNameSeller = '';
        // let tcode = '';
        // const { isVip = false, slug = '' } = sellerInfo || {};
        // let linkSeller = sellerInfo?.landingPage?.startsWith('https://try.thuocsi.vn')
        //   ? sellerInfo?.landingPage
        //   : `/seller-products/${sellerInfo?.slugStore || sellerInfo?.slug}`;
        // let linkStore = `/seller/${slug}`;
        // if (isVip) {
        //   linkStore = DOMAIN_FLAGSHIP_STORE.replace('{seller}', slug) || `/flagship-store/${slug}`;
        // }
        // // nếu không có sellerinfo => hiện rỗng
        // if (sellerInfo) {
        //   if (sellerInfo?.isInternal) {
        //     tcode = 'medx_novat';
        //     fullNameSeller = 'MEDX';
        //     if (isVAT) {
        //       sellerName = 'MEDX';
        //       tcode = 'medx';
        //     }
        //   } else if (sellerInfo?.sellerType === 'ENTERPRISE') {
        //     tcode = 'seller';
        //     sellerName = sellerInfo?.name || '';
        //     fullNameSeller = sellerInfo?.fullName || '';
        //   } else {
        //     tcode = 'seller_partner';
        //     sellerName = `seller_partner`;
        //     isDisplayStore = false;
        //     fullNameSeller = `seller_parnter`;
        //     linkSeller = `/partner/${code}`;
        //   }
        // }
        // console.log('{ sellerName, tcode, linkStore, linkSeller, isDisplayStore, fullNameSeller, ...sellerInfo }', {
        //   sellerName,
        //   tcode,
        //   linkStore,
        //   linkSeller,
        //   isDisplayStore,
        //   fullNameSeller,
        //   ...sellerInfo,
        // });
        // temporarily return a hardcoded value and comment all logic above
        return {
            avatar: "",
            code: "BUYMED",
            fullName: "Seller BUYMED",
            fullNameSeller: "BUYMED",
            isDisplayStore: false,
            isInternal: true,
            isStore: false,
            isVip: null,
            landingPage: "",
            linkSeller: "/seller-products/seller-buymed",
            linkStore: "/seller/seller-buymed",
            name: "Seller Buymed",
            sellerName: "BUYMED",
            sellerType: "INDIVIDUAL",
            slug: "seller-buymed",
            status: "ACTIVE",
            statusStore: undefined,
            storeSlug: "",
            tcode: "medx_novat"
        };
    // return { sellerName, tcode, linkStore, linkSeller, isDisplayStore, fullNameSeller, ...sellerInfo };
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SettingContext.Provider, {
        value: {
            getProvinces: getProvinces,
            categories: categories,
            provinces: provinces,
            mapCategories: mapCategories,
            mapManufactuers: mapManufactuers,
            topManufacturers: topManufacturers,
            ingredients: ingredients,
            getIngredients: getIngredients,
            mapIngredients: mapIngredients,
            mapIngredientsById: mapIngredientsById,
            mapIngredientsProduct: mapIngredientsProduct,
            mapSeller: mapSeller,
            getRegionByProvinceCode: getRegionByProvinceCode,
            sellers: sellers,
            mapStoreActives: mapStoreActives,
            countryLists: countryLists,
            getCountryLists: getCountryLists,
            mapCountry: mapCountry,
            mapReasonsTicket: mapReasonsTicket,
            reasonsTicket: reasonsTicket,
            // tabs,
            getNameSeller: getNameSeller,
            suggestKeywords: suggestKeywords,
            getSuggestKeywords: getSuggestKeywords
        },
        children: children
    });
};
var useSetting = function() {
    return (0,react.useContext)(SettingContext);
};
/* harmony default export */ var Settings = ({
    SettingContext: SettingContext,
    useSetting: useSetting
});

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/services/index.js + 15 modules
var services = __webpack_require__(788);
// EXTERNAL MODULE: ./src/sysconfig/index.js
var sysconfig = __webpack_require__(66225);
// EXTERNAL MODULE: ./src/utils/debounce.js
var debounce = __webpack_require__(74118);
;// CONCATENATED MODULE: ./src/context/Search/index.js
/* eslint-disable no-param-reassign */ 















var SearchContext = /*#__PURE__*/ (0,react.createContext)({});
var SearchProvider = function(param) {
    var children = param.children;
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)([]), searchProduct = ref[0], setSearchProduct = ref[1];
    var ref1 = (0,react.useState)([]), searchIngredient = ref1[0], setSearchIngredient = ref1[1];
    var ref2 = (0,react.useState)([]), searchSeller = ref2[0], setSearchSeller = ref2[1];
    var ref3 = (0,react.useState)(false), isFocus = ref3[0], setIsFocus = ref3[1];
    var ref4 = (0,react.useState)(""), keyword = ref4[0], setKeyword = ref4[1];
    var ref5 = (0,react.useState)(constants_data/* THUOC_VA_HOAT_CHAT */.K_), searchType = ref5[0], setSearchType = ref5[1];
    var ref6 = (0,react.useState)({
        isFetching: false,
        isSearching: false
    }), action = ref6[0], setAction = ref6[1];
    var ref7 = (0,react.useState)([]), suggestKeywords = ref7[0], setSuggestKeywords = ref7[1];
    var ref8 = useSetting(), ingredients = ref8.ingredients, getNameSeller = ref8.getNameSeller;
    var convertSellers = function() {
        var seller = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
        var ref;
        return (ref = seller === null || seller === void 0 ? void 0 : seller.sort(function(a, b) {
            return a === null || a === void 0 ? void 0 : a.name.localeCompare(b === null || b === void 0 ? void 0 : b.name);
        })) === null || ref === void 0 ? void 0 : ref.map(function(itemSeller) {
            var ref = itemSeller || {}, _name = ref.name, name = _name === void 0 ? null : _name, _slug = ref.slug, slug = _slug === void 0 ? null : _slug, _code = ref.code, code = _code === void 0 ? null : _code;
            var info = getNameSeller({
                seller: {
                    code: code
                }
            });
            var ref1 = info || {}, _linkStore = ref1.linkStore, linkStore = _linkStore === void 0 ? "" : _linkStore, _linkSeller = ref1.linkSeller, linkSeller = _linkSeller === void 0 ? "" : _linkSeller;
            return {
                name: name,
                slug: slug,
                code: code,
                link: linkStore || linkSeller
            };
        });
    };
    (0,react.useEffect)(function() {
        if (router.pathname !== "/users/rewards" && !router.asPath.includes(Paths/* MY_ORDER_URL */.z$)) {
            var ref = router === null || router === void 0 ? void 0 : router.query, _q = ref.q, q = _q === void 0 ? "" : _q, _search = ref.search, search = _search === void 0 ? "" : _search;
            var keywordVal = q || search;
            setKeyword(keywordVal.trim());
        }
    }, [
        router === null || router === void 0 ? void 0 : router.query
    ]);
    (0,react.useEffect)(function() {
        var ref;
        var dataSearchType = Number(router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.searchType);
        setSearchType(dataSearchType || constants_data/* THUOC_VA_HOAT_CHAT */.K_);
        (0,ProductClientV2/* getSuggestKeyword */.yx)().then(function(suggestKeywordsRes) {
            var data = (0,clients/* getData */.Yu)(suggestKeywordsRes);
            setSuggestKeywords(data || []);
        });
    }, []);
    var clearSearchRes = function() {
        setSearchProduct([]);
        setSearchIngredient([]);
        setSearchSeller([]);
    };
    var handleSearch = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var _val, val, _isIngredients, isIngredients, _tmp, _tmp1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _val = param.val, val = _val === void 0 ? "" : _val, _isIngredients = param.isIngredients, isIngredients = _isIngredients === void 0 ? true : _isIngredients;
                        if (!sysconfig/* IS_WEB_SERVICE_SEARCH_LITE */.GO) return [
                            3,
                            2
                        ];
                        _tmp1 = {};
                        return [
                            4,
                            services/* WebService.searchFuzzyLite */.Qy.searchFuzzyLite((_tmp1.body = {
                                text: val,
                                offset: 0,
                                limit: constants_data/* PAGE_SIZE_30 */.AV,
                                searchStrategy: {
                                    text: true,
                                    keyword: true,
                                    ingredient: isIngredients
                                }
                            }, _tmp1))
                        ];
                    case 1:
                        _tmp = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            clients/* SearchClient.searchByKeywords */.w9.searchByKeywords(val, isIngredients)
                        ];
                    case 3:
                        _tmp = clients/* getData.apply */.Yu.apply(void 0, [
                            _state.sent()
                        ]);
                        _state.label = 4;
                    case 4:
                        setSearchProduct.apply(void 0, [
                            _tmp
                        ]);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSearch(_) {
            return _ref.apply(this, arguments);
        };
    }();
    var fetchDataSearch = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(val) {
            var _tmp, _tmp1, _tmp2, data, sellerRes, _tmp3, _tmp4, _tmp5, _tmp6;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = {};
                        _tmp1 = {};
                        setAction((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)(_tmp, action), (_tmp1.isFetching = true, _tmp1)));
                        switch(searchType){
                            case constants_data/* THUOC_VA_HOAT_CHAT */.K_:
                                return [
                                    3,
                                    1
                                ];
                            case constants_data/* HOAT_CHAT */.h5:
                                return [
                                    3,
                                    2
                                ];
                            case constants_data/* NHA_BAN_HANG */.jJ:
                                return [
                                    3,
                                    3
                                ];
                            case constants_data/* THUOC */.dj:
                                return [
                                    3,
                                    5
                                ];
                        }
                        return [
                            3,
                            6
                        ];
                    case 1:
                        _tmp2 = {};
                        handleSearch((_tmp2.val = val, _tmp2));
                        utils/* gtag.clickSearch */.SX.clickSearch(constants_data/* THUOC_VA_HOAT_CHAT */.K_, val);
                        return [
                            3,
                            7
                        ];
                    case 2:
                        {
                            data = utils/* StringUtils.searchStringInStrings */.xZ.searchStringInStrings(ingredients, val);
                            setSearchIngredient(data);
                            utils/* gtag.clickSearch */.SX.clickSearch(constants_data/* HOAT_CHAT */.h5, val);
                        }
                        return [
                            3,
                            7
                        ];
                    case 3:
                        _tmp3 = {};
                        return [
                            4,
                            clients/* SellerClient.searchStoreByText */.vQ.searchStoreByText((_tmp3.params = {
                                search: val,
                                offset: 0,
                                limit: 30,
                                getTotal: true,
                                sellerType: constants_data/* ENTERPRISE */.Eo
                            }, _tmp3))
                        ];
                    case 4:
                        sellerRes = _state.sent();
                        setSearchSeller(convertSellers((0,clients/* getData */.Yu)(sellerRes)));
                        utils/* gtag.clickSearch */.SX.clickSearch(constants_data/* NHA_BAN_HANG */.jJ, val);
                        return [
                            3,
                            7
                        ];
                    case 5:
                        _tmp4 = {};
                        handleSearch((_tmp4.val = val, _tmp4.isIngredients = false, _tmp4));
                        utils/* gtag.clickSearch */.SX.clickSearch(constants_data/* THUOC */.dj, val);
                        return [
                            3,
                            7
                        ];
                    case 6:
                        clearSearchRes();
                        return [
                            3,
                            7
                        ];
                    case 7:
                        _tmp5 = {};
                        _tmp6 = {};
                        setAction((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)(_tmp5, action), (_tmp6.isFetching = false, _tmp6.isSearching = false, _tmp6)));
                        return [
                            2
                        ];
                }
            });
        });
        return function fetchDataSearch(val) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleSearchbox = function(e) {
        setAction((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, action), {
            isSearching: true
        }));
        var val = e.target.value;
        setKeyword(val);
        (0,debounce/* debounceFunc300 */.V9)(function() {
            if (val) {
                fetchDataSearch(val);
            } else {
                clearSearchRes();
            }
        });
    };
    var handleClearSearchBox = function() {
        setAction((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, action), {
            isFetching: true
        }));
        setKeyword("");
        (0,debounce/* debounceFunc300 */.V9)(function() {
            clearSearchRes();
        });
        setAction((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, action), {
            isFetching: false
        }));
    };
    var handleKeyDown = function(event) {
        var trimKeyword = event.target.value.trim();
        if (event.keyCode === 13) {
            event.preventDefault();
            event.target.blur();
            switch(searchType){
                case constants_data/* THUOC_VA_HOAT_CHAT */.K_:
                case constants_data/* THUOC */.dj:
                    router.push({
                        pathname: "".concat(Paths/* PRODUCTS_URL */.NL),
                        query: {
                            q: trimKeyword,
                            searchType: searchType
                        }
                    });
                    break;
                // TODO: improve phase 2
                // enter ko chuyển đến page hoạt chất
                case constants_data/* HOAT_CHAT */.h5:
                    break;
                case constants_data/* NHA_BAN_HANG */.jJ:
                    router.push({
                        pathname: "".concat(Paths/* SELLERS */.UI),
                        query: {
                            search: trimKeyword,
                            searchType: searchType
                        }
                    });
                    break;
                default:
                    router.push("".concat(Paths/* PRODUCTS_URL */.NL));
                    break;
            }
        }
    };
    var handleFocus = function() {
        setIsFocus(true);
    };
    var handleChangeTypeSearch = function(e) {
        setSearchType(Number(e.target.value));
    };
    var handleBlur = function() {
        var ref;
        setIsFocus(false);
        if (((ref = keyword === null || keyword === void 0 ? void 0 : keyword.trim()) === null || ref === void 0 ? void 0 : ref.length) === 0) {
            handleClearSearchBox();
        }
    };
    // call api when select dropdown
    (0,react.useEffect)(function() {
        if (keyword) {
            fetchDataSearch(keyword);
        } else {
            clearSearchRes();
        }
    }, [
        searchType
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchContext.Provider, {
        value: {
            suggestKeywords: suggestKeywords,
            searchProduct: searchProduct,
            keyword: keyword,
            setKeyword: setKeyword,
            handleSearchbox: handleSearchbox,
            handleKeyDown: handleKeyDown,
            handleFocus: handleFocus,
            handleBlur: handleBlur,
            setSearchProduct: setSearchProduct,
            isFocus: isFocus,
            setIsFocus: setIsFocus,
            searchType: searchType,
            setSearchType: setSearchType,
            handleChangeTypeSearch: handleChangeTypeSearch,
            searchIngredient: searchIngredient,
            setSearchIngredient: setSearchIngredient,
            searchSeller: searchSeller,
            setSearchSeller: setSearchSeller,
            action: action,
            handleClearSearchBox: handleClearSearchBox,
            fetchDataSearch: fetchDataSearch,
            clearSearchRes: clearSearchRes
        },
        children: children
    });
};
var useSearch = function() {
    return (0,react.useContext)(SearchContext);
};

// EXTERNAL MODULE: ./src/constants/Enums/index.js
var Enums = __webpack_require__(71569);
;// CONCATENATED MODULE: ./src/context/Ticket/index.js












var TicketContext = /*#__PURE__*/ (0,react.createContext)();
var TicketProvider = function(param) {
    var children = param.children;
    var ref = (0,esm/* useTranslation */.$G)("alert-action"), translateAlertAction = ref.t;
    var ref1 = (0,react.useState)([]), feedbackedListSku = ref1[0], setFeedbackedListSku = ref1[1];
    var handleRedCustomer = (0,Auth/* useAuth */.aC)().handleRedCustomer;
    (0,react.useEffect)(function() {
        var feedbackInfo = JSON.parse(localStorage.getItem("feedbackPrice"));
        setFeedbackedListSku(feedbackInfo);
    }, []);
    var sendFeedback = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var data, res, sku, reasonCodes, feedbackInfo, _tmp, newListFeedback;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        data = param.data;
                        return [
                            4,
                            clients/* TicketClient.createFeedback */.ZX.createFeedback(data)
                        ];
                    case 1:
                        res = _state.sent();
                        _tmp = {};
                        if ((0,clients/* isValid */.JY)(res)) {
                            // NotifyUtils.success(`${BRAND_NAME} đã nhận phản hồi về giá của bạn.`);
                            utils/* NotifyUtils.success */.QP.success(translateAlertAction("message_send_feedback_price").replace("{BRAND_NAME}", Enums/* BRAND_NAME */.RS));
                            sku = data.sku, reasonCodes = data.reasonCodes;
                            feedbackInfo = (_tmp.sku = sku, _tmp.type = reasonCodes.toString(), _tmp.createAt = new Date(), _tmp.expiredAt = new Date(Date.now() + +sysconfig/* TIME_PREVENT_FEEDBACK_PRICE */.uI), _tmp);
                            newListFeedback = (feedbackedListSku === null || feedbackedListSku === void 0 ? void 0 : feedbackedListSku.filter(function(item) {
                                return (item === null || item === void 0 ? void 0 : item.sku) !== sku;
                            })) || [];
                            newListFeedback.push(feedbackInfo);
                            localStorage.setItem("feedbackPrice", JSON.stringify(Array.from(newListFeedback).reverse()));
                            setFeedbackedListSku(newListFeedback);
                            return [
                                2,
                                true
                            ];
                        }
                        if ((res === null || res === void 0 ? void 0 : res.errorCode) === Enums/* TYPE_CUSTOMER_BY_COLOR.LOCKED_CUSTOMER */.q0.LOCKED_CUSTOMER && handleRedCustomer()) {
                            return [
                                2,
                                false
                            ];
                        }
                        utils/* NotifyUtils.error */.QP.error(translateAlertAction("message_send_feedback_fail"));
                        return [
                            2,
                            false
                        ];
                }
            });
        });
        return function sendFeedback(_) {
            return _ref.apply(this, arguments);
        };
    }();
    var sendLikeFeedback = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var sku, productId, data, _tmp, _tmp1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                sku = param.sku, productId = param.productId;
                _tmp = {};
                data = (_tmp.source = "WEB", _tmp.reasonCodes = [
                    sysconfig/* LIKE_FEEDBACK_CODE */.wN
                ], _tmp.type = "PRODUCT", _tmp.sku = sku, _tmp.productId = productId, _tmp.isAcceptPrice = true, _tmp);
                _tmp1 = {};
                return [
                    2,
                    sendFeedback((_tmp1.data = data, _tmp1))
                ];
            });
        });
        return function sendLikeFeedback(_) {
            return _ref.apply(this, arguments);
        };
    }();
    var sendDislikeFeedback = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var sku, productId, feedbackContent, data, _tmp, _tmp1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                sku = param.sku, productId = param.productId, feedbackContent = param.feedbackContent;
                _tmp = {};
                data = (_tmp.source = "WEB", _tmp.reasonCodes = [
                    sysconfig/* DISLIKE_FEEDBACK_CODE */.bO
                ], _tmp.type = "PRODUCT", _tmp.sku = sku, _tmp.productId = productId, _tmp.feedbackContent = feedbackContent, _tmp.isHighPrice = true, _tmp);
                _tmp1 = {};
                return [
                    2,
                    sendFeedback((_tmp1.data = data, _tmp1))
                ];
            });
        });
        return function sendDislikeFeedback(_) {
            return _ref.apply(this, arguments);
        };
    }();
    var isSkuFeedbackedPrice = function(param) {
        var sku = param.sku;
        var existFeedbackItem = feedbackedListSku === null || feedbackedListSku === void 0 ? void 0 : feedbackedListSku.find(function(item) {
            return (item === null || item === void 0 ? void 0 : item.sku) === sku;
        });
        var ref = existFeedbackItem || {}, _expiredAt = ref.expiredAt, expiredAt = _expiredAt === void 0 ? null : _expiredAt;
        if (!existFeedbackItem) return null;
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, existFeedbackItem), {
            disabledFeedbackPrice: new Date(expiredAt).getTime() > new Date().getTime()
        });
    };
    var contextValues = {
        sendLikeFeedback: sendLikeFeedback,
        sendDislikeFeedback: sendDislikeFeedback,
        sendFeedback: sendFeedback,
        feedbackedListSku: feedbackedListSku,
        isSkuFeedbackedPrice: isSkuFeedbackedPrice
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TicketContext.Provider, {
        value: contextValues,
        children: children
    });
};
var useTicket = function() {
    return (0,react.useContext)(TicketContext);
};

;// CONCATENATED MODULE: ./src/context/View/index.js



var viewContext = /*#__PURE__*/ react.createContext({});
var ViewProvider = function(param) {
    var children = param.children;
    var ref = _sliced_to_array(React.useState(window.innerWidth), 2), width = ref[0], setWidth = ref[1];
    var ref1 = _sliced_to_array(React.useState(window.innerHeight), 2), height = ref1[0], setHeight = ref1[1];
    var handleWindowResize = function() {
        setWidth(window.innerWidth);
        setHeight(window.innerHeight);
    };
    React.useEffect(function() {
        window.addEventListener("resize", handleWindowResize);
        return function() {
            return window.removeEventListener("resize", handleWindowResize);
        };
    }, []);
    return /*#__PURE__*/ _jsx(viewContext.Provider, {
        value: {
            width: width,
            height: height
        },
        children: children
    });
};
var useView = function() {
    var ref = React.useContext(viewContext), width = ref.width, height = ref.height;
    return {
        width: width,
        height: height
    };
};

// EXTERNAL MODULE: ./src/utils/EnhanceReducer.js
var EnhanceReducer = __webpack_require__(15067);
// EXTERNAL MODULE: ./src/utils/fbpixel.js
var fbpixel = __webpack_require__(70627);
// EXTERNAL MODULE: ./src/utils/tiktok.js
var tiktok = __webpack_require__(38901);
// EXTERNAL MODULE: ./src/zustand-lib/useSellers.js + 2 modules
var useSellers = __webpack_require__(14626);
;// CONCATENATED MODULE: ./src/context/WishList/types.js
/* harmony default export */ var types = ({
    CLEAR: "CLEAR",
    GET_WISHLIST: "GET_WISHLIST",
    GET_WISHLIST_RESP: "GET_WISHLIST_RESP",
    REMOVE_WISHLIST: "REMOVE_WISHLIST",
    ADD_WISHLIST_ITEM: "ADD_WISHLIST_ITEM"
});

;// CONCATENATED MODULE: ./src/context/WishList/reducer.js




var initialState = {
    loading: true,
    mapWishList: new Map()
};
var ProductReducer = function(state, param) {
    var type = param.type, payload = param.payload;
    switch(type){
        case types.GET_WISHLIST:
            {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    loading: true
                });
            }
        case types.GET_WISHLIST_RESP:
            {
                var data = payload.data;
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    mapWishList: data && (0,ArrUtils/* convertArrayToMap */.lE)(data, "sku"),
                    loading: false
                });
            }
        case types.REMOVE_WISHLIST:
            {
                var sku = payload.sku;
                state.mapWishList.delete(sku);
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    mapWishList: state.mapWishList
                });
            }
        case types.ADD_WISHLIST_ITEM:
            {
                var sku1 = payload.sku;
                state.mapWishList.set(sku1, true);
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    mapWishList: state.mapWishList
                });
            }
        case types.CLEAR:
            return (0,_object_spread/* default */.Z)({}, initialState);
        default:
            return state;
    }
};
/* harmony default export */ var reducer = (ProductReducer);

;// CONCATENATED MODULE: ./src/context/WishList/index.js


















var WishListContext = /*#__PURE__*/ (0,react.createContext)();
var WishListProvider = function(param) {
    var children = param.children;
    var ref = (0,esm/* useTranslation */.$G)("alert-action"), translateAlertAction = ref.t;
    var user = (0,Auth/* useAuth */.aC)().user;
    var ref1 = (0,src_sliced_to_array/* default */.Z)((0,EnhanceReducer/* useEnhancedReducer */.a)(reducer, {}), 3), state = ref1[0], dispatch = ref1[1], getState = ref1[2];
    // eslint-disable-next-line no-shadow
    var getSellerByCode = (0,useSellers/* default */.Z)(function(state) {
        return state.getSellerByCode;
    });
    // getWishlist
    (0,react.useEffect)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var wishlistResult, _tmp, data, _tmp1, _tmp2;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(user && user.customerID)) return [
                        3,
                        2
                    ];
                    _tmp = {};
                    return [
                        4,
                        clients/* WishlistClient.getAllWishlist */.lH.getAllWishlist((_tmp.customerID = user.customerID, _tmp))
                    ];
                case 1:
                    wishlistResult = _state.sent();
                    data = (0,clients/* getData */.Yu)(wishlistResult);
                    _tmp1 = {};
                    dispatch((_tmp1.type = types.GET_WISHLIST_RESP, _tmp1.payload = {
                        data: data
                    }, _tmp1));
                    return [
                        3,
                        3
                    ];
                case 2:
                    _tmp2 = {};
                    // clear wishlist
                    dispatch((_tmp2.type = types.CLEAR, _tmp2));
                    _state.label = 3;
                case 3:
                    return [
                        2
                    ];
            }
        });
    }), [
        user
    ]);
    var getWishlistBySkus = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(product) {
            var ref, _mapWishList, mapWishList;
            return (0,tslib_es6.__generator)(this, function(_state) {
                if (!product || !(product === null || product === void 0 ? void 0 : product.sku)) {
                    return [
                        2,
                        false
                    ];
                }
                ref = getState(), _mapWishList = ref.mapWishList, mapWishList = _mapWishList === void 0 ? new Map() : _mapWishList;
                return [
                    2,
                    mapWishList.has(product === null || product === void 0 ? void 0 : product.sku)
                ];
            });
        });
        return function(product) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    var handleDeleteProductWishlist = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(product) {
            var res, _tmp;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            clients/* WishlistClient.deleteItemWishlist */.lH.deleteItemWishlist(product === null || product === void 0 ? void 0 : product.sku)
                        ];
                    case 1:
                        res = _state.sent();
                        _tmp = {};
                        if ((0,clients/* isValidWithoutData */.Wk)(res)) {
                            utils/* NotifyUtils.success */.QP.success(translateAlertAction("mess_wishlist.success_remove_x_product").replace(/{productName}/, product === null || product === void 0 ? void 0 : product.name));
                            dispatch((_tmp.type = types.REMOVE_WISHLIST, _tmp.payload = {
                                sku: product === null || product === void 0 ? void 0 : product.sku
                            }, _tmp));
                            return [
                                2,
                                false
                            ];
                        }
                        utils/* NotifyUtils.error */.QP.error(translateAlertAction("mess_wishlist.fail_remove_x_product").replace(/{productName}/, product === null || product === void 0 ? void 0 : product.name));
                        return [
                            2,
                            null
                        ];
                }
            });
        });
        return function handleDeleteProductWishlist(product) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleUpdateWishlist = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(product) {
            var res, _tmp, sellerInfo, _tmp1, _tmp2, _tmp3;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            clients/* WishlistClient.updateWishlist */.lH.updateWishlist(product === null || product === void 0 ? void 0 : product.sku)
                        ];
                    case 1:
                        res = _state.sent();
                        if (!((0,clients/* isValid */.JY)(res) || (res === null || res === void 0 ? void 0 : res.status) === Enums/* HTTP_STATUS.Existed */.MG.Existed)) return [
                            3,
                            3
                        ];
                        utils/* NotifyUtils.success */.QP.success(translateAlertAction("mess_wishlist.success_add_x_product").replace(/{productName}/, product === null || product === void 0 ? void 0 : product.name));
                        _tmp = {};
                        dispatch((_tmp.type = types.ADD_WISHLIST_ITEM, _tmp.payload = {
                            sku: product === null || product === void 0 ? void 0 : product.sku
                        }, _tmp));
                        // FB event tracking addToWishlist
                        fbpixel/* default.addToWishlist */.ZP.addToWishlist(product);
                        tiktok/* default.addToWishlist */.ZP.addToWishlist(product);
                        _tmp1 = {};
                        return [
                            4,
                            getSellerByCode((_tmp1.code = product === null || product === void 0 ? void 0 : product.sellerCode, _tmp1.tags = product === null || product === void 0 ? void 0 : product.tags, _tmp1))
                        ];
                    case 2:
                        sellerInfo = _state.sent();
                        _tmp2 = {};
                        _tmp3 = {};
                        utils/* gtag.addToWishList */.SX.addToWishList((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)(_tmp2, product), (_tmp3.sellerInfo = sellerInfo, _tmp3)));
                        return [
                            2,
                            true
                        ];
                    case 3:
                        utils/* NotifyUtils.error */.QP.error(translateAlertAction("mess_wishlist.fail_remove_x_product").replace(/{productName}/, product === null || product === void 0 ? void 0 : product.name));
                        return [
                            2,
                            null
                        ];
                }
            });
        });
        return function handleUpdateWishlist(product) {
            return _ref.apply(this, arguments);
        };
    }();
    var contextValues = (0,_object_spread/* default */.Z)({
        getWishlistBySkus: getWishlistBySkus,
        handleDeleteProductWishlist: handleDeleteProductWishlist,
        handleUpdateWishlist: handleUpdateWishlist
    }, state);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(WishListContext.Provider, {
        value: contextValues,
        children: children
    });
};
var useWishList = function() {
    return (0,react.useContext)(WishListContext);
};

;// CONCATENATED MODULE: ./src/context/index.js











/***/ }),

/***/ 91866:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ct": function() { return /* reexport */ hooks_useDealTagUrl; },
  "Co": function() { return /* reexport */ hooks_useDetectScrollModal; },
  "QB": function() { return /* reexport */ useDragDetection; },
  "_": function() { return /* reexport */ hooks_useLocalStorage; },
  "dd": function() { return /* reexport */ useModal/* default */.Z; },
  "Yv": function() { return /* reexport */ useMultiImageBox/* default */.Z; },
  "k": function() { return /* reexport */ hooks_useOverflowTooltip; },
  "aT": function() { return /* reexport */ hooks_useScrollIntoViewOnShow; },
  "OT": function() { return /* reexport */ useToggle/* default */.Z; }
});

// UNUSED EXPORTS: useHover, useIsMobile, useMapCache, useScrollTrackingViewport, useStateCallback

// EXTERNAL MODULE: ./src/constants/Paths/index.js
var Paths = __webpack_require__(199);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/hooks/useDealTagUrl.js


function useDealTagUrl(datas) {
    var baseURL = Paths/* PATH_PROMOTIONS */.qJ;
    var ref = (0,react.useState)(""), link = ref[0], setLink = ref[1];
    var ref1 = datas || {}, dataDeal = ref1.campaign;
    var ref2 = (dataDeal === null || dataDeal === void 0 ? void 0 : dataDeal.campaign) || {}, campaignType = ref2.campaignType, slug = ref2.slug;
    (0,react.useEffect)(function() {
        var getLink = function getLink() {
            if (campaignType !== "DAILY_DEAL") {
                setLink("".concat(baseURL, "/").concat(slug));
            }
            // deal
            if (!dataDeal) setLink("/deals");
        };
        getLink();
    // console.log('counts render', link, `render ${link} lan`);
    }, [
        datas
    ]);
    return [
        link
    ];
}
/* harmony default export */ var hooks_useDealTagUrl = (useDealTagUrl);

;// CONCATENATED MODULE: ./src/hooks/useDetectScrollModal.js

var useDetectScrollModal = function() {
    var isOpenModal = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    //   render 1 lan
    var targetRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(false), isScroll = ref[0], setIsScroll = ref[1];
    var onScrollFunc = (0,react.useCallback)(function() {
        var scrollTop = targetRef.current.scrollTop;
        if (isOpenModal === true && scrollTop > 0) {
            setIsScroll(true);
        } else {
            setIsScroll(function() {
                return false;
            });
        }
    }, [
        isOpenModal
    ]);
    (0,react.useEffect)(function() {
        if (targetRef.current) onScrollFunc();
        return function() {
            if (!isOpenModal) setIsScroll(function() {
                return false;
            });
        };
    }, [
        !isOpenModal
    ]);
    //   console.log('scroll out side', isScroll);
    return [
        isScroll,
        targetRef,
        onScrollFunc
    ];
};
/* harmony default export */ var hooks_useDetectScrollModal = (useDetectScrollModal);

;// CONCATENATED MODULE: ./src/hooks/useDragDetection.js

var MoveDragThreshold = 20;
function useDragDetection() {
    var handleMouseDown = function handleMouseDown() {
        setMouseDown(true);
        setDragging(false);
    };
    var ref = (0,react.useState)(false), mouseDown = ref[0], setMouseDown = ref[1];
    var ref1 = (0,react.useState)(false), dragging = ref1[0], setDragging = ref1[1];
    (0,react.useEffect)(function() {
        var handleMouseUp = function handleMouseUp() {
            setMouseDown(false);
        };
        var handleMouseMove = function handleMouseMove(e) {
            mouseMove += Math.abs(e.movementX) + Math.abs(e.movementY);
            setDragging(mouseMove > MoveDragThreshold);
        };
        var mouseMove = 0;
        if (mouseDown) {
            document.addEventListener("mouseup", handleMouseUp);
            document.addEventListener("mousemove", handleMouseMove);
        }
        return function() {
            document.removeEventListener("mouseup", handleMouseUp);
            document.removeEventListener("mousemove", handleMouseMove);
        };
    }, [
        mouseDown
    ]);
    return {
        handleMouseDown: handleMouseDown,
        dragging: dragging
    };
};

// EXTERNAL MODULE: ./src/hooks/useHover.js
var useHover = __webpack_require__(82163);
// EXTERNAL MODULE: ./src/hooks/useIsMobile.js
var useIsMobile = __webpack_require__(88262);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var src_async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var src_sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./src/sysconfig/index.js
var sysconfig = __webpack_require__(66225);
// EXTERNAL MODULE: ./src/utils/ArrUtils.js
var ArrUtils = __webpack_require__(33769);
// EXTERNAL MODULE: ./src/utils/ObjectUtils.js
var ObjectUtils = __webpack_require__(51380);
;// CONCATENATED MODULE: ./src/hooks/useLocalStorage.js
/* eslint-disable no-unused-vars */ 






var verDefault = 4;
function utf8ToB64(str) {
    return window.btoa(unescape(encodeURIComponent(str)));
}
function b64ToUtf8(str) {
    return decodeURIComponent(escape(window.atob(str)));
}
var serializeFuncDefault = function(param) {
    var fieldNames = param.fieldNames, dataList = param.dataList;
    return dataList.map(function(item) {
        var object = {};
        fieldNames === null || fieldNames === void 0 ? void 0 : fieldNames.forEach(function(name, index) {
            object[index] = item[name];
        });
        return ObjectUtils/* default.isEmpty */.Z.isEmpty(object) ? null : object;
    });
};
var deserializeFuncDefault = function(param) {
    var fieldNames = param.fieldNames, dataList = param.dataList;
    return dataList.map(function(item) {
        var object = {};
        fieldNames === null || fieldNames === void 0 ? void 0 : fieldNames.forEach(function(name, index) {
            object[name] = item[index];
        });
        return ObjectUtils/* default.isEmpty */.Z.isEmpty(object) ? null : object;
    });
};
var encodeData = function(dataStr) {
    return dataStr;
};
var decodeData = function(itemStr) {
    return itemStr;
};
var useLocalStorage = function(param) {
    var _defaultValue = param.defaultValue, defaultValue = _defaultValue === void 0 ? null : _defaultValue, key = param.key, _ttl = param.ttl, ttl = _ttl === void 0 ? sysconfig/* TTL_CACHE_LOCAL */.m1 || 900 : _ttl, getValueDefault = param.getValueDefault, _fieldNames = param.fieldNames, fieldNames = _fieldNames === void 0 ? null : _fieldNames, serializeFunc = param.serializeFunc, deserializeFunc = param.deserializeFunc, _ver = param.ver, ver = _ver === void 0 ? verDefault : _ver;
    if (fieldNames && fieldNames.length === 0) {
        throw Error("Missing fieldNames");
    }
    var getWithExpiry = (0,react.useRef)(function(keyLocalStorage) {
        try {
            var itemStr = window.localStorage.getItem(keyLocalStorage);
            if (!itemStr) {
                return null;
            }
            var decodeDt = decodeData(itemStr);
            var item = JSON.parse(decodeDt, ArrUtils/* reviver */.yf);
            // const item = JSON.parse(itemStr, reviver);
            var curTime = new Date().getTime();
            if (item.expiry && curTime > item.expiry || item.ver !== ver) {
                window.localStorage.removeItem(key);
                return null;
            }
            // deserialFunc
            var data = item.value;
            if (item && item.value) {
                if (fieldNames) {
                    data = deserializeFuncDefault({
                        fieldNames: fieldNames,
                        dataList: item.value
                    });
                } else if (deserializeFunc) {
                    data = deserializeFunc(item.value);
                }
            }
            return data;
        } catch (error) {
            return null;
        }
    }, []);
    var ref = (0,src_sliced_to_array/* default */.Z)(react.useState(function() {
        return getWithExpiry.current(key);
    }), 2), value = ref[0], setValue = ref[1];
    var fetchData = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            getValueDefault()
                        ];
                    case 1:
                        data = _state.sent();
                        if (data) {
                            setValue(data);
                        }
                        return [
                            2,
                            data
                        ];
                }
            });
        });
        return function fetchData() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        return setValue(function() {
            return getWithExpiry.current(key);
        });
    }, [
        key
    ]);
    var getValue = (0,react.useCallback)(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        var dataLocalstorage, dataLocalstorageSerilize, dataStr, _tmp, dataEncoded;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    dataLocalstorage = value;
                    dataLocalstorageSerilize = value;
                    if (!!dataLocalstorage) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        fetchData()
                    ];
                case 1:
                    dataLocalstorage = _state.sent();
                    _state.label = 2;
                case 2:
                    if (dataLocalstorage) {
                        if (fieldNames) {
                            dataLocalstorageSerilize = serializeFuncDefault({
                                dataList: dataLocalstorage,
                                fieldNames: fieldNames
                            });
                        } else if (typeof serializeFunc === "function") {
                            dataLocalstorageSerilize = serializeFunc(dataLocalstorage);
                        }
                    }
                    _tmp = {};
                    dataStr = JSON.stringify((_tmp.value = dataLocalstorageSerilize, _tmp.expiry = ttl > 0 ? new Date().getTime() + ttl * 1000 : null, _tmp.ver = ver, _tmp), ArrUtils/* replacer */.PH);
                    dataEncoded = encodeData(dataStr);
                    try {
                        window.localStorage.setItem(key, dataEncoded);
                        setValue(dataLocalstorage);
                    } catch (error) {
                        // console.error(error.code);
                        window.localStorage.clear();
                    }
                    return [
                        2,
                        dataLocalstorage
                    ];
            }
        });
    }));
    // React.useEffect(async () => {
    //   const stickyValue = getWithExpiry();
    //   console.log('🚀 ~ file: useLocalStorage.js ~ line 146 ~ React.useEffect ~ stickyValue', stickyValue);
    //   if (stickyValue !== null) {
    //     setValue(stickyValue);
    //   }
    // }, []);
    var remove = (0,react.useCallback)(function() {
        try {
            localStorage.removeItem(key);
            setValue(undefined);
        } catch (error) {
            console.error(error);
        }
    }, [
        key,
        setValue
    ]);
    return [
        value,
        getValue,
        remove
    ];
};
/* harmony default export */ var hooks_useLocalStorage = (useLocalStorage); // deprecated 22Feb2023 - Dinh Tran
 // const makeLocalStorageFull = () => {
 //   try {
 //     while (true) {
 //       console.log('running ');
 //       localStorage.setItem(new Date() + Math.random(), new Date());
 //     }
 //   } catch (error) {
 //     if (error === 'QUOTA_EXCEEDED_ERR') {
 //       console.log('quota -> ');
 //     }
 //   }
 // };

;// CONCATENATED MODULE: ./src/hooks/useMapCache.js





var MAP_GLOBAL = new Map();
var useMapCache = function(param) {
    var _defaultValue = param.defaultValue, defaultValue = _defaultValue === void 0 ? null : _defaultValue, key = param.key, _ttl = param.ttl, ttl = _ttl === void 0 ? 0 : _ttl, getValueDefault = param.getValueDefault;
    var ref = _sliced_to_array(React.useState(defaultValue), 2), value = ref[0], setValue = ref[1];
    var getWithExpiry = useCallback(function() {
        var itemStr = MAP_GLOBAL.get(key);
        if (!itemStr) {
            return null;
        }
        var item = JSON.parse(itemStr, reviver);
        if (item.expiry && new Date().getTime() > item.expiry) {
            MAP_GLOBAL.delete(key);
            return null;
        }
        return item.value;
    }, []);
    React.useEffect(function() {
        var stickyValue = getWithExpiry();
        if (stickyValue !== null) {
            setValue(stickyValue);
        } else if (getValueDefault) {
            var fetchData = function() {
                var _ref = _async_to_generator(function() {
                    var data;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    getValueDefault()
                                ];
                            case 1:
                                data = _state.sent();
                                if (data) {
                                    setValue(data);
                                }
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function fetchData() {
                    return _ref.apply(this, arguments);
                };
            }();
            fetchData();
        }
    }, [
        key
    ]);
    React.useEffect(function() {
        var dataStr = JSON.stringify({
            value: value,
            expiry: ttl > 0 ? new Date().getTime() + ttl * 1000 : null
        }, replacer);
        MAP_GLOBAL.set(key, dataStr);
    }, [
        key,
        value
    ]);
    var getValue = function() {
        return getWithExpiry();
    };
    return [
        value,
        getValue
    ];
};
/* harmony default export */ var hooks_useMapCache = ((/* unused pure expression or super */ null && (useMapCache)));

// EXTERNAL MODULE: ./src/hooks/useModal.js
var useModal = __webpack_require__(16028);
// EXTERNAL MODULE: ./src/hooks/useMultiImageBox.js
var useMultiImageBox = __webpack_require__(66621);
;// CONCATENATED MODULE: ./src/hooks/useOverflowTooltip.js

function useOverflowTooltip() {
    var ref = (0,react.useState)(false), isOverflowed = ref[0], setIsOverflow = ref[1];
    var textElementRef = (0,react.useRef)();
    (0,react.useEffect)(function() {
        var ref, ref1;
        setIsOverflow((textElementRef === null || textElementRef === void 0 ? void 0 : (ref = textElementRef.current) === null || ref === void 0 ? void 0 : ref.scrollHeight) > (textElementRef === null || textElementRef === void 0 ? void 0 : (ref1 = textElementRef.current) === null || ref1 === void 0 ? void 0 : ref1.clientHeight));
    }, []);
    return [
        isOverflowed,
        textElementRef
    ];
}
/* harmony default export */ var hooks_useOverflowTooltip = (useOverflowTooltip);

;// CONCATENATED MODULE: ./src/hooks/useScrollIntoViewOnShow.js

/**
 * Tự cuộn tới element ngay khi nó xuất hiện, dùng cho các khối cảnh báo mà khách
 * dễ bỏ sót vì nằm ngoài vùng nhìn thấy.
 *
 * Chỉ cuộn MỘT lần cho mỗi lần xuất hiện: isShow giữ nguyên true qua các lần
 * re-render sẽ không cuộn lại, tránh giật màn hình khi khách đang thao tác. Cờ được
 * reset khi isShow về false nên khối ẩn rồi hiện lại vẫn cuộn tiếp.
 *
 * @param {boolean} isShow điều kiện render của chính element gắn ref
 * @returns ref để gắn vào element cần cuộn tới
 */ var useScrollIntoViewOnShow = function(isShow) {
    var ref = (0,react.useRef)(null);
    var hasScrolledRef = (0,react.useRef)(false);
    (0,react.useEffect)(function() {
        if (!isShow) {
            hasScrolledRef.current = false;
            return;
        }
        if (hasScrolledRef.current || !ref.current) return;
        hasScrolledRef.current = true;
        ref.current.scrollIntoView({
            behavior: "smooth",
            block: "center"
        });
    }, [
        isShow
    ]);
    return ref;
};
/* harmony default export */ var hooks_useScrollIntoViewOnShow = (useScrollIntoViewOnShow);

;// CONCATENATED MODULE: ./src/hooks/useScrollTrackingViewport.js


var useScrollTrackingViewport = function(options) {
    var ref = useState(false), inview = ref[0], setInview = ref[1];
    var targetRef = useRef(null);
    var funcObserverTracking = function(entries) {
        var _entries = _sliced_to_array(entries, 1), entry = _entries[0];
        setInview(entry.isIntersecting);
    };
    useEffect(function() {
        var observer = new IntersectionObserver(funcObserverTracking, options);
        if (targetRef.current) observer.observe(targetRef.current);
        return function() {
            if (targetRef.current) observer.unobserve(targetRef.current);
        };
    }, [
        targetRef,
        options
    ]);
    return [
        inview,
        targetRef
    ];
};
/* harmony default export */ var hooks_useScrollTrackingViewport = ((/* unused pure expression or super */ null && (useScrollTrackingViewport)));

;// CONCATENATED MODULE: ./src/hooks/useStateCallback.js

var useStateCallback = function(initialState) {
    var ref = useState(initialState), state = ref[0], setState = ref[1];
    var cbRef = useRef(null); // mutable ref to store current callback
    var setStateCallback = function(newState, cb) {
        cbRef.current = cb; // store passed callback to ref
        setState(newState);
    };
    useEffect(function() {
        // cb.current is `null` on initial render, so we only execute cb on state *updates*
        if (cbRef.current) {
            cbRef.current(state);
            cbRef.current = null; // reset callback after execution
        }
    }, [
        state
    ]);
    return [
        state,
        setStateCallback
    ];
};
/* harmony default export */ var hooks_useStateCallback = ((/* unused pure expression or super */ null && (useStateCallback)));

// EXTERNAL MODULE: ./src/hooks/useToggle.js
var useToggle = __webpack_require__(53376);
;// CONCATENATED MODULE: ./src/hooks/index.js












// export { default as useRollbar } from './useRollbar';




/***/ }),

/***/ 82163:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useHover; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function useHover(ref) {
    var isActive = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, isDisabled = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var _$ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), value = _$ref[0], setValue = _$ref[1];
    var handleMouseOver = function() {
        return setValue(true);
    };
    var handleMouseOut = function() {
        return setValue(false);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!isDisabled || !isActive) {
            var node = ref.current;
            if (node) {
                node.addEventListener("mouseenter", handleMouseOver);
                node.addEventListener("mouseleave", handleMouseOut);
                return function() {
                    node.removeEventListener("mouseenter", handleMouseOver);
                    node.removeEventListener("mouseleave", handleMouseOut);
                };
            }
        }
        return {};
    }, [
        ref.current
    ]);
    return [
        value
    ];
};


/***/ }),

/***/ 84157:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var context__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33436);
/* harmony import */ var utils_InactiveCustomerUtils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29183);
/* harmony import */ var zustand_lib_storeGlobal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39423);



// true when the logged-in customer is INACTIVE and HIDE_PRODUCT_INACTIVE_CUSTOMER is on:
// the customer is kept on /onboarding with a stripped-down header and no navbar/footer.
var useInactiveCustomerLock = function() {
    var customerInfo = (0,context__WEBPACK_IMPORTED_MODULE_0__/* .useAuth */ .aC)().customerInfo;
    var appConfig = (0,zustand_lib_storeGlobal__WEBPACK_IMPORTED_MODULE_2__/* .useStore */ .o)(function(state) {
        return state.appConfig;
    });
    return (0,utils_InactiveCustomerUtils__WEBPACK_IMPORTED_MODULE_1__/* .isInactiveCustomerLocked */ .YA)(customerInfo, appConfig);
};
/* harmony default export */ __webpack_exports__["Z"] = (useInactiveCustomerLock);


/***/ }),

/***/ 88262:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
var useEffect = (__webpack_require__(67294).useEffect);
var getMobileDetect = function(userAgent) {
    var isAndroid = function() {
        return Boolean(userAgent.match(/Android/i));
    };
    var isIos = function() {
        return Boolean(userAgent.match(/iPhone|iPad|iPod/i));
    };
    var isOpera = function() {
        return Boolean(userAgent.match(/Opera Mini/i));
    };
    var isWindows = function() {
        return Boolean(userAgent.match(/IEMobile/i));
    };
    var isSSR = function() {
        return Boolean(userAgent.match(/SSR/i));
    };
    var isMobile = function() {
        return Boolean(isAndroid() || isIos() || isOpera() || isWindows());
    };
    var isDesktop = function() {
        return Boolean(!isMobile() && !isSSR());
    };
    return {
        isMobile: isMobile,
        isDesktop: isDesktop,
        isAndroid: isAndroid,
        isIos: isIos,
        isSSR: isSSR
    };
};
var useMobileDetect = function() {
    useEffect(function() {}, []);
    var userAgent = typeof navigator === "undefined" ? "SSR" : navigator.userAgent;
    return getMobileDetect(userAgent);
};
/* harmony default export */ __webpack_exports__["Z"] = (useMobileDetect);


/***/ }),

/***/ 16028:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10253);

var useState = (__webpack_require__(67294).useState);
var useModal = function() {
    var data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, defvalue = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(useState(data), 2), isShowing = ref[0], setIsShowing = ref[1];
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(useState(defvalue), 2), value = ref1[0], setValue = ref1[1];
    var toggle = function(val, callback) {
        setValue(val);
        if (callback && typeof callback === "function") {
            callback();
        }
        setIsShowing(!isShowing);
    };
    var getVal = function() {
        return value;
    };
    var toggleCheckShowing = function() {
        // eslint-disable-next-line no-unused-expressions
        isShowing && toggle();
    };
    return [
        isShowing,
        toggle,
        getVal,
        toggleCheckShowing
    ];
};
/* harmony default export */ __webpack_exports__["Z"] = (useModal);


/***/ }),

/***/ 66621:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var useMultiImageBox = function(param) {
    var _images = param.images, images = _images === void 0 ? [] : _images;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0), selectedImage = ref[0], setSelectedImage = ref[1];
    var handleDecrement = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        if (selectedImage === 0) {
            setSelectedImage(images.length - 1);
            return;
        }
        setSelectedImage(function(current) {
            return current - 1;
        });
    }, [
        selectedImage,
        images
    ]);
    var handleIncrement = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        if (selectedImage === images.length - 1) {
            setSelectedImage(0);
            return;
        }
        setSelectedImage(function(current) {
            return current + 1;
        });
    }, [
        selectedImage,
        images
    ]);
    var handlePrevious = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(e) {
        e.stopPropagation();
        handleDecrement();
    }, [
        handleDecrement
    ]);
    var handleKeyDown = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(e) {
        if (e.key === "ArrowRight") {
            handleDecrement();
            return;
        }
        if (e.key === "ArrowLeft") {
            handleIncrement();
        }
    }, [
        handleIncrement,
        handleDecrement
    ]);
    var handleNext = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(e) {
        e.stopPropagation();
        handleIncrement();
    }, [
        handleIncrement
    ]);
    var handleImageSelection = function(index) {
        setSelectedImage(index);
    };
    var handleHoverImage = function(index) {
        handleImageSelection(index);
    };
    return {
        selectedImage: selectedImage,
        handlePrevious: handlePrevious,
        handleNext: handleNext,
        handleKeyDown: handleKeyDown,
        handleImageSelection: handleImageSelection,
        handleHoverImage: handleHoverImage
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useMultiImageBox);


/***/ }),

/***/ 53376:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var useToggle = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), open = ref[0], setOpen = ref[1];
    var handleOpen = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        setOpen(true);
    }, []);
    var handleClose = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        setOpen(false);
    }, []);
    var handleToggle = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        setOpen(function(current) {
            return !current;
        });
    }, []);
    return {
        open: open,
        handleOpen: handleOpen,
        handleClose: handleClose,
        handleToggle: handleToggle
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useToggle);


/***/ }),

/***/ 62996:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _app; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@fortawesome/fontawesome-free/css/all.min.css
var all_min = __webpack_require__(5673);
// EXTERNAL MODULE: ./node_modules/@material-ui/styles/esm/StylesProvider/StylesProvider.js
var StylesProvider = __webpack_require__(26975);
// EXTERNAL MODULE: ./node_modules/@material-ui/styles/esm/ThemeProvider/ThemeProvider.js
var ThemeProvider = __webpack_require__(13457);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/CssBaseline/CssBaseline.js
var CssBaseline = __webpack_require__(75834);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: ./src/components/layout/Theme/index.js
var Theme = __webpack_require__(6745);
// EXTERNAL MODULE: ./src/constants/Paths/index.js
var Paths = __webpack_require__(199);
// EXTERNAL MODULE: ./src/hooks/useInactiveCustomerLock.js
var useInactiveCustomerLock = __webpack_require__(84157);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/utils/InactiveCustomerUtils.js
var InactiveCustomerUtils = __webpack_require__(29183);
;// CONCATENATED MODULE: ./src/components/organisms/InactiveCustomerGuard/index.js





/**
 * Client-side fallback of the SSR redirect in doWithServerSide (BV-1886): keeps a locked
 * inactive customer on /onboarding for pages served from cache, pages that do not go
 * through doWithServerSide, and right after logging in.
 */ var InactiveCustomerGuard = function() {
    var router = (0,next_router.useRouter)();
    var isLocked = (0,useInactiveCustomerLock/* default */.Z)();
    (0,react.useEffect)(function() {
        if (!isLocked || (0,InactiveCustomerUtils/* isPathAllowedForLockedCustomer */.iL)(router.pathname)) return;
        router.replace(Paths/* ONBOARDING */.So);
    }, [
        isLocked,
        router.pathname
    ]);
    return null;
};
/* harmony default export */ var organisms_InactiveCustomerGuard = (InactiveCustomerGuard);

// EXTERNAL MODULE: ./src/components-v3/organisms/VoucherDetailPopup/index.js
var VoucherDetailPopup = __webpack_require__(41125);
// EXTERNAL MODULE: ./src/constants/Device/index.js
var Device = __webpack_require__(32826);
// EXTERNAL MODULE: ./src/context/index.js + 10 modules
var context = __webpack_require__(33436);
;// CONCATENATED MODULE: ./src/context/ContextProviderComposer.js
/* eslint-disable no-shadow */ 
var ContextProviderComposer = function(param) {
    var contextProviders = param.contextProviders, children = param.children;
    return contextProviders.reduceRight(function(children, parent) {
        return /*#__PURE__*/ react.cloneElement(parent, {
            children: children
        });
    }, children);
};
/* harmony default export */ var context_ContextProviderComposer = (ContextProviderComposer);

// EXTERNAL MODULE: ./node_modules/next/app.js
var app = __webpack_require__(7544);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.mjs + 1 modules
var react_toastify_esm = __webpack_require__(91444);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/ReactToastify.css
var ReactToastify = __webpack_require__(40993);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(186);
// EXTERNAL MODULE: ./src/sysconfig/index.js
var sysconfig = __webpack_require__(66225);
// EXTERNAL MODULE: ./src/utils/index.js + 5 modules
var utils = __webpack_require__(76480);
// EXTERNAL MODULE: ./src/constants/data/index.js
var data = __webpack_require__(66520);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 6 modules
var esm = __webpack_require__(5233);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./src/constants/data/cookies.js
var cookies = __webpack_require__(61213);
// EXTERNAL MODULE: ./src/context/Popup/index.js
var Popup = __webpack_require__(14739);
;// CONCATENATED MODULE: ./src/third-party/Clarity.js
// components/Clarity.js


var Clarity = function() {
    (0,react.useEffect)(function() {
        if (sysconfig/* CLARITY_KEY */.F7 != "") {
            (function(c, l, a, r, i, t, y) {
                c[a] = c[a] || function() {
                    (c[a].q = c[a].q || []).push(arguments);
                };
                t = l.createElement(r);
                t.async = 1;
                t.src = "https://www.clarity.ms/tag/" + i;
                y = l.getElementsByTagName(r)[0];
                y.parentNode.insertBefore(t, y);
            })(window, document, "clarity", "script", sysconfig/* CLARITY_KEY */.F7);
        }
    }, []);
    return null;
};
/* harmony default export */ var third_party_Clarity = (Clarity);

// EXTERNAL MODULE: ./src/utils/CacheImageUtils.js
var CacheImageUtils = __webpack_require__(65342);
// EXTERNAL MODULE: ./src/utils/fbpixel.js
var fbpixel = __webpack_require__(70627);
// EXTERNAL MODULE: ./src/utils/gtag.js
var gtag = __webpack_require__(57059);
// EXTERNAL MODULE: ./src/utils/registerURL.js
var registerURL = __webpack_require__(15563);
// EXTERNAL MODULE: ./src/zustand-lib/storeGlobal.js + 1 modules
var storeGlobal = __webpack_require__(39423);
;// CONCATENATED MODULE: ./src/zustand-lib/index.js
/* eslint-disable import/prefer-default-export */ 

// EXTERNAL MODULE: ./src/zustand-lib/storeMobile.js
var storeMobile = __webpack_require__(35810);
// EXTERNAL MODULE: ./src/zustand-lib/useChat.js
var useChat = __webpack_require__(25886);
// EXTERNAL MODULE: ./next-i18next.config.js
var next_i18next_config = __webpack_require__(33273);
var next_i18next_config_default = /*#__PURE__*/__webpack_require__.n(next_i18next_config);
// EXTERNAL MODULE: ./src/styles/globals.css
var globals = __webpack_require__(20472);
// EXTERNAL MODULE: ./src/styles/icomoon.css
var icomoon = __webpack_require__(39988);
;// CONCATENATED MODULE: ./src/pages/_app.js
/* eslint-disable no-unused-vars */ 









// import * as Sentry from '@sentry/nextjs';











// import '../scripts/wydr';
// Toast


// Theme



// CSS global
// import IconChat from 'components-v2/atoms/IconChat';




// import * as Services from 'services';













// Happy lunar new year 2023
var IconChat = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9893), __webpack_require__.e(4179), __webpack_require__.e(756), __webpack_require__.e(7676), __webpack_require__.e(3004), __webpack_require__.e(3316), __webpack_require__.e(2746), __webpack_require__.e(3136), __webpack_require__.e(9035)]).then(__webpack_require__.bind(__webpack_require__, 23136));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(23136)
            ];
        }
    },
    ssr: false
});
var ChatThuocSi = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7112), __webpack_require__.e(9510), __webpack_require__.e(9893), __webpack_require__.e(130), __webpack_require__.e(756), __webpack_require__.e(8807), __webpack_require__.e(9918), __webpack_require__.e(5621), __webpack_require__.e(2354), __webpack_require__.e(7676), __webpack_require__.e(5522), __webpack_require__.e(664), __webpack_require__.e(9278), __webpack_require__.e(3316), __webpack_require__.e(4942)]).then(__webpack_require__.bind(__webpack_require__, 55238));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(55238)
            ];
        }
    },
    ssr: false
});
// Widget hỗ trợ nổi - chỉ chạy phía client, lazy-load để tách khỏi initial chunk của _app
var SupportCenter = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3004), __webpack_require__.e(2972)]).then(__webpack_require__.bind(__webpack_require__, 12972));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(12972)
            ];
        }
    },
    ssr: false
});
var publicRuntimeConfig = config_default()().publicRuntimeConfig;
var pathNoRedirect = (/* unused pure expression or super */ null && ([
    "/",
    "/list-product",
    "",
    "/flagship-store",
    "/flagship-store/[slug]/list-product",
    "/flagship-store/[slug]",
    "/flagship-store/durex",
    "/flagship-store/durex/list-product",
    "/flagship-store/durex/rewards",
    "/flagship-store/sanofi",
    "/flagship-store/sanofi/list-product",
    "/flagship-store/sanofi/rewards",
    "/phanhoi",
    "/qr",
    "/qr/[code]",
    "phanhoi",
    "feedback",
    "/feedback",
    "/flagship-store/[slug]/flagship-rewards",
    "/flagship-store/[slug]/rewards",
    "/tracking-order", 
]));
var DISABLE_INSIDER = [
    "tracuu.thuocsi.vn",
    "phanhoi.thuocsi.vn"
];
var CHAT_HIDE_URLS = [
    "/discovery",
    Paths/* CART_URL */.fh,
    Paths/* CHECKOUT_URL */.sE,
    Paths/* ACCOUNT */.yV,
    Paths/* QUICK_ORDER */.A3
];
var MyApp = function(props) {
    var Component = props.Component, pageProps = props.pageProps, _host = props.host, host = _host === void 0 ? "" : _host, _buildId = props.buildId, buildId = _buildId === void 0 ? "" : _buildId;
    var ref = pageProps || {}, _user = ref.user, user = _user === void 0 ? {} : _user, _accountInfo = ref.accountInfo, accountInfo = _accountInfo === void 0 ? {} : _accountInfo, _SEO_CONFIG = ref.SEO_CONFIG, SEO_CONFIG = _SEO_CONFIG === void 0 ? {} : _SEO_CONFIG, _initialZustandState = ref.initialZustandState, initialZustandState = _initialZustandState === void 0 ? {} : _initialZustandState, _cartQuantity = ref.cartQuantity, cartQuantity = _cartQuantity === void 0 ? [] : _cartQuantity;
    var ref1 = storeGlobal/* default */.Z || {}, useCreateStore = ref1.useCreateStore, Provider = ref1.Provider;
    // Sentry?.setTag('buildId', buildId);
    // Sentry.setUser({ id: user?.customerID });
    var ref2 = initialZustandState || {}, _insiderSetting = ref2.insiderSetting, insiderSetting = _insiderSetting === void 0 ? false : _insiderSetting, _thumbnailMap = ref2.thumbnailMap, thumbnailMap = _thumbnailMap === void 0 ? {} : _thumbnailMap, _defaultThumbnail = ref2.defaultThumbnail, defaultThumbnail = _defaultThumbnail === void 0 ? {} : _defaultThumbnail;
    var router = (0,next_router.useRouter)();
    var ref3 = router || {}, query = ref3.query, replace = ref3.replace, pathname = ref3.pathname;
    var createStore = useCreateStore(pageProps.initialZustandState);
    var ref4 = query || {}, referCode = ref4.referCode, action = ref4.action, login = ref4.login, forgetpasscode = ref4.forgetpasscode, t = ref4.t, token = ref4.token, redirectUrl = ref4.redirectUrl;
    var isShowingLogin = login === "true";
    var isMobileV2 = (0,storeMobile/* default */.Z)(function(state) {
        return state.isMobileV2();
    });
    var isTrackingMobileV2 = (0,storeMobile/* default */.Z)(function(state) {
        return state.isTrackingMobileV2;
    });
    var clearState = (0,useChat/* default */.Z)(function(state) {
        return state;
    }).clearState;
    var isEnableInsider = insiderSetting;
    if (host) {
        isEnableInsider = !DISABLE_INSIDER.some(function(item) {
            return item === host;
        }) && insiderSetting;
    }
    // Dùng SEO default là thông tin SEO của trang chủ
    var seoInfo = thumbnailMap[router.asPath] || {};
    var toggleChat = function() {
        clearState();
        router.push("/conversations");
    };
    // Generate canonical url
    // SEO: bỏ query string, để ?utm=..., ?fbclid=..., ?page=... không bị Google coi là bản trùng
    var canonicalUrl = sysconfig/* WEB_HOST */.Ul + ((router === null || router === void 0 ? void 0 : router.asPath) || "/").split(/[?#]/)[0];
    var canonicalUrlMobile = canonicalUrl;
    // hide page chat
    var isShowIconFBPage = !CHAT_HIDE_URLS.includes(pathname);
    // config https://material-ui.com/guides/server-rendering/
    (0,react.useEffect)(function() {
        // if (window) window.Services = Service;
        // initAllSellers();
        // Remove the server-side injected CSS.
        // if (!isPrd && window) {
        //   window.Services = Services;
        // }
        var jssStyles = document.querySelector("#jss-server-side");
        if (jssStyles) {
            jssStyles.parentElement.removeChild(jssStyles);
        }
        // lỗi zalo
        // if (!window.zaloJSV2) {
        //   window.zaloJSV2 = {};
        // }
        // nếu khách vào thuocsi.com.vn -> cần redirect lại domain chính
        // if (window && window?.location?.href?.indexOf('thuocsi.com.vn') >= 0) {
        //   router.push(`${DOMAIN_WEB_HOST}`);
        // }
        // Prevent pull to refresh for chat mobile
        if (router.pathname === "/conversations") {
            var ref;
            (ref = document.querySelector("html")) === null || ref === void 0 ? void 0 : ref.classList.add("preventPullToRefresh");
        } else {
            var ref1, ref2;
            (ref1 = document.querySelector("html")) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.classList) === null || ref2 === void 0 ? void 0 : ref2.remove("preventPullToRefresh");
        }
    }, []);
    var saveUrlWhenChangeRoute = function() {
        try {
            var ref;
            var visitedUrls = JSON.parse(localStorage.getItem(cookies/* VISITED_URLS_STORAGE_KEY */.k) || "[]");
            var currentUrl = window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.href;
            if (currentUrl && (currentUrl === null || currentUrl === void 0 ? void 0 : currentUrl.startsWith("http"))) {
                var newVisitedUrls = currentUrl;
                if (visitedUrls[visitedUrls.length - 1] !== currentUrl) {
                    newVisitedUrls = (0,_to_consumable_array/* default */.Z)(visitedUrls).concat([
                        currentUrl
                    ]);
                }
                if (newVisitedUrls.length > 5) {
                    // Chỉ lấy 5 urls gần nhất
                    newVisitedUrls = newVisitedUrls.slice(newVisitedUrls.length - 5, newVisitedUrls.length);
                }
                localStorage.setItem(cookies/* VISITED_URLS_STORAGE_KEY */.k, JSON.stringify(newVisitedUrls));
            }
        } catch (e) {
            localStorage.setItem(cookies/* VISITED_URLS_STORAGE_KEY */.k, "[]");
        }
    };
    // DOMAINS_THUOCSI -> domain thuocsi sẽ chạy, các host khác proxy tới thuocsi sẽ bị đá lại domain chính
    // useEffect(() => {
    // nếu chuyển sang trang products ... thì sẽ check host , nếu ko đúng host thì tự redirect sang domain chính
    // if (DOMAINS_THUOCSI?.indexOf(host) === -1 && !pathNoRedirect.includes(router.pathname)) {
    //   router.push(`${DOMAIN_WEB_HOST}${router.asPath}`);
    // }
    // TODO:   nếu user là miền bắc -> hk.thuocsi.vn , nếu user là miền nam ->thuocsi.vn
    // internet bị đứt nên cần move uat / prd sang hk.thuocsi.vn
    // NG dùng miền bắc - sài domain thuocsi.vn -> thì vào hk
    // off redirect -> hk  06Mar2023
    // if (['prd'].includes(ENV) && user && regionsMB && regionsMB?.includes(`${user.provinceCode}`) && host?.startsWith('thuocsi.vn')) {
    //   // test
    //   // if (user && regionsMB && regionsMB?.includes(`${user.provinceCode}`) && host !== 'hk.thuocsi.vn') {
    //   // redirect to hk / nếu là khách miền abwcs
    //   router.push(`https://hk.thuocsi.vn/${router.asPath}`);
    // }
    // }, [router.asPath]);
    (0,react.useEffect)(function() {
        var handleRouteChange = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(url) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    utils/* gtag.pageview */.SX.pageview(url, user);
                    // save router change
                    saveUrlWhenChangeRoute();
                    fbpixel/* default.pageview */.ZP.pageview();
                    return [
                        2
                    ];
                });
            });
            return function handleRouteChange(url) {
                return _ref.apply(this, arguments);
            };
        }();
        router.events.on("routeChangeComplete", handleRouteChange);
        return function() {
            router.events.off("routeChangeComplete", handleRouteChange);
        };
    }, [
        router.events
    ]);
    // Lead tracking: lưu URL có UTM gần nhất ("last click") để gửi registerURL khi đăng ký
    (0,react.useEffect)(function() {
        (0,registerURL/* captureUtmLandingURL */.RM)();
        router.events.on("routeChangeComplete", registerURL/* captureUtmLandingURL */.RM);
        return function() {
            router.events.off("routeChangeComplete", registerURL/* captureUtmLandingURL */.RM);
        };
    }, [
        router.events
    ]);
    var LinkBanner = "".concat(sysconfig/* WEB_HOST */.Ul, "/logo_banner.png");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        charSet: "utf-8"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        httpEquiv: "Cache-Control",
                        content: "no-cache"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        httpEquiv: "Expires",
                        content: "-1"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "keywords",
                        content: "buymed"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: (seoInfo === null || seoInfo === void 0 ? void 0 : seoInfo.pageTitle) || (SEO_CONFIG === null || SEO_CONFIG === void 0 ? void 0 : SEO_CONFIG.title) || (defaultThumbnail === null || defaultThumbnail === void 0 ? void 0 : defaultThumbnail.pageTitle) || data/* DEFAULT_THUOCSI_LONG_TITLE */.A1
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "viewport",
                        content: "width=device-width, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0, user-scalable=no"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: canonicalUrl
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "alternate",
                        media: "only screen and (max-width: 640px)",
                        href: canonicalUrlMobile
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "title",
                        content: (seoInfo === null || seoInfo === void 0 ? void 0 : seoInfo.title) || (SEO_CONFIG === null || SEO_CONFIG === void 0 ? void 0 : SEO_CONFIG.title) || (defaultThumbnail === null || defaultThumbnail === void 0 ? void 0 : defaultThumbnail.title) || data/* DEFAULT_THUOCSI_TITLE */.Vw
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "description",
                        content: (seoInfo === null || seoInfo === void 0 ? void 0 : seoInfo.description) || (SEO_CONFIG === null || SEO_CONFIG === void 0 ? void 0 : SEO_CONFIG.description) || (defaultThumbnail === null || defaultThumbnail === void 0 ? void 0 : defaultThumbnail.description) || data/* DEFAULT_THUOCSI_DESCRIPTION */.Nf
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: (seoInfo === null || seoInfo === void 0 ? void 0 : seoInfo.title) || (SEO_CONFIG === null || SEO_CONFIG === void 0 ? void 0 : SEO_CONFIG.ogTitle) || (defaultThumbnail === null || defaultThumbnail === void 0 ? void 0 : defaultThumbnail.title) || data/* DEFAULT_THUOCSI_TITLE */.Vw
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: (0,CacheImageUtils/* changeDomainStorage */.If)((seoInfo === null || seoInfo === void 0 ? void 0 : seoInfo.imageUrl) || (SEO_CONFIG === null || SEO_CONFIG === void 0 ? void 0 : SEO_CONFIG.ogImage) || (defaultThumbnail === null || defaultThumbnail === void 0 ? void 0 : defaultThumbnail.imageUrl) || LinkBanner)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image:alt",
                        content: (seoInfo === null || seoInfo === void 0 ? void 0 : seoInfo.title) || (SEO_CONFIG === null || SEO_CONFIG === void 0 ? void 0 : SEO_CONFIG.ogImageAlt) || (defaultThumbnail === null || defaultThumbnail === void 0 ? void 0 : defaultThumbnail.title) || data/* DEFAULT_THUOCSI_LONG_TITLE */.A1
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: (seoInfo === null || seoInfo === void 0 ? void 0 : seoInfo.description) || (SEO_CONFIG === null || SEO_CONFIG === void 0 ? void 0 : SEO_CONFIG.ogDescription) || (defaultThumbnail === null || defaultThumbnail === void 0 ? void 0 : defaultThumbnail.description) || data/* DEFAULT_THUOCSI_DESCRIPTION */.Nf
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "manifest",
                        href: "/manifest.json"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StylesProvider/* default */.ZP, {
                injectFirst: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_components_browser_esm/* ThemeProvider */.f6, {
                    theme: Theme/* default */.Z,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ThemeProvider/* default */.Z, {
                        theme: Theme/* default */.Z,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CssBaseline/* default */.ZP, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Provider, {
                                createStore: createStore,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(context_ContextProviderComposer, {
                                    contextProviders: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(context/* AuthProvider */.Ho, {
                                            isShowingLogin: isShowingLogin,
                                            referCode: referCode,
                                            forgetpasscode: forgetpasscode,
                                            action: action,
                                            tokenv1: t,
                                            token: token,
                                            redirectUrl: redirectUrl,
                                            // initAccount={accountInfo}
                                            initUser: user
                                        }, "auth"),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(context/* ProductContextProvider */.dp, {
                                            initUser: user
                                        }, "product"),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(context/* CartContextProvider */.GN, {
                                            cartQuantity: cartQuantity
                                        }, "cart"),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(context/* NotiContextProvider */.aO, {
                                            initUser: user
                                        }, "noti"),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(context/* SettingProvider */.oh, {}, "setting"),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(context/* SearchProvider */.X$, {}, "search"),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(context/* WishListProvider */.XG, {}, "wishlist"),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(context/* TicketProvider */.tp, {}, "ticket"),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Popup/* PopupProvider */.l, {}, "popup"), 
                                    ],
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(context/* LoadingRoute */.sV, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(third_party_Clarity, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(organisms_InactiveCustomerGuard, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(VoucherDetailPopup/* VoucherDetailPopupProvider */.Qu, {
                                                isMobile: !!(pageProps === null || pageProps === void 0 ? void 0 : pageProps.isMobile),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, (0,_object_spread/* default */.Z)({}, pageProps))
                                            }),
                                            pathname !== "/conversations" && pathname !== "/lucky-wheel" && /*#__PURE__*/ (0,jsx_runtime.jsx)(SupportCenter, {
                                                isShowIconFBPage: isShowIconFBPage,
                                                isAuthenticated: pageProps === null || pageProps === void 0 ? void 0 : pageProps.isAuthenticated,
                                                toggleChat: toggleChat
                                            }),
                                            pathname !== "/conversations" && /*#__PURE__*/ (0,jsx_runtime.jsx)(utils/* ScrollToTop */.pU, (0,_object_spread/* default */.Z)({}, router)),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_toastify_esm/* ToastContainer */.Ix, {
                                                limit: 2,
                                                pauseOnHover: false,
                                                hideProgressBar: true,
                                                autoClose: 2000,
                                                closeOnClick: true
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: "insider-queue-init",
                strategy: "beforeInteractive",
                children: "window.InsiderQueue = window.InsiderQueue || [];"
            }),
            sysconfig/* INSIDER_ID */.jY && sysconfig/* INSIDER_SCRIPT_DOMAIN */.sS && /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: "insider-tag",
                src: "//".concat(sysconfig/* INSIDER_SCRIPT_DOMAIN */.sS, "/ins.js?id=").concat(sysconfig/* INSIDER_ID */.jY),
                strategy: "afterInteractive"
            }),
            sysconfig/* ENV */.Vi === "prd" && isMobileV2 && isTrackingMobileV2 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                        strategy: "lazyOnload",
                        src: "https://www.googletagmanager.com/gtag/js?id=".concat(gtag/* GA_TRACKING_ID_V2 */.uy, "&l=dataLayerGAV2")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                        strategy: "lazyOnload",
                        children: "\n                    window.dataLayerGAV2 = window.dataLayerGAV2 || [];\n                    function gtagGAV2(){dataLayerGAV2.push(arguments);}\n                    gtagGAV2('js', new Date());\n                    gtagGAV2('config', '".concat(gtag/* GA_TRACKING_ID_V2 */.uy, "', {\n                    page_path: window.location.pathname,\n                    });\n                ")
                    })
                ]
            })
        ]
    });
};
// MyApp.getInitialProps = async (appContext) => ({ ...(await App.getInitialProps(appContext)) });
MyApp.getInitialProps = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(appContext) {
        var time, appProps, host, isMobile, UA, _tmp, _tmp1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    time = +new Date();
                    return [
                        4,
                        app["default"].getInitialProps(appContext)
                    ];
                case 1:
                    appProps = _state.sent();
                    host = "";
                    try {
                        host = appContext.ctx.req.headers.host || "";
                    } catch (error) {
                        host = "can't detect host";
                    }
                    isMobile = "";
                    try {
                        UA = appContext.ctx.req.headers["user-agent"];
                        isMobile = Boolean(UA.match(Device/* MOBILE */.J));
                    } catch (error1) {
                        isMobile = "can not detect device - ".concat(error1);
                    }
                    _tmp = {};
                    _tmp1 = {};
                    return [
                        2,
                        (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)(_tmp, appProps), (_tmp1.host = host, _tmp1.buildId = publicRuntimeConfig.buildId, _tmp1.timeAPP = +new Date() - time, _tmp1.pageProps = {
                            isMobile: isMobile
                        }, _tmp1))
                    ];
            }
        });
    });
    return function(appContext) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var _app = ((0,esm/* appWithTranslation */.Jc)(MyApp, (next_i18next_config_default())));


/***/ }),

/***/ 84378:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10253);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97582);
/* harmony import */ var clients__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15149);




var getRegions = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(ctx) {
        var regionsRes;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        clients__WEBPACK_IMPORTED_MODULE_0__/* .AddressClient.getRegions */ .uQ.getRegions(ctx)
                    ];
                case 1:
                    regionsRes = _state.sent();
                    return [
                        2,
                        regionsRes
                    ];
            }
        });
    });
    return function getRegions(ctx) {
        return _ref.apply(this, arguments);
    };
}();
var getProvinces = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(ctx) {
        var provincesRes, provinces;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        clients__WEBPACK_IMPORTED_MODULE_0__/* .AddressClient.getProvinces */ .uQ.getProvinces(ctx)
                    ];
                case 1:
                    provincesRes = _state.sent();
                    if (!(0,clients__WEBPACK_IMPORTED_MODULE_0__/* .isValid */ .JY)(provincesRes)) {
                        return [
                            2,
                            []
                        ];
                    }
                    provinces = provincesRes.data.map(function(param) {
                        var label = param.name, value = param.code, _regionCode = param.regionCode, regionCode = _regionCode === void 0 ? null : _regionCode;
                        return {
                            label: label,
                            value: value,
                            regionCode: regionCode
                        };
                    }).sort(function(a, b) {
                        return a.label.localeCompare(b.label);
                    });
                    return [
                        2,
                        provinces
                    ];
            }
        });
    });
    return function getProvinces(ctx) {
        return _ref.apply(this, arguments);
    };
}();
var getAllCountriesMock = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(param) {
        var ctx, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            ctx = param.ctx;
            _tmp = {};
            return [
                2,
                clients__WEBPACK_IMPORTED_MODULE_0__/* .AddressClient.getAllCountriesMock */ .uQ.getAllCountriesMock((_tmp.ctx = ctx, _tmp))
            ];
        });
    });
    return function getAllCountriesMock(_) {
        return _ref.apply(this, arguments);
    };
}();
var getAllProvinceMock = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(param) {
        var ctx, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            ctx = param.ctx;
            _tmp = {};
            return [
                2,
                clients__WEBPACK_IMPORTED_MODULE_0__/* .AddressClient.getAllProvinceMock */ .uQ.getAllProvinceMock((_tmp.ctx = ctx, _tmp))
            ];
        });
    });
    return function getAllProvinceMock(_) {
        return _ref.apply(this, arguments);
    };
}();
var getAllCountries = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(param) {
        var ctx, countryRes, _tmp, countries;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ctx = param.ctx;
                    _tmp = {};
                    return [
                        4,
                        clients__WEBPACK_IMPORTED_MODULE_0__/* .AddressClient.getAllCountries */ .uQ.getAllCountries((_tmp.ctx = ctx, _tmp))
                    ];
                case 1:
                    countryRes = _state.sent();
                    if (!(0,clients__WEBPACK_IMPORTED_MODULE_0__/* .isValid */ .JY)(countryRes)) {
                        return [
                            2,
                            []
                        ];
                    }
                    countries = countryRes.data.map(function(param) {
                        var label = param.name, value = param.code;
                        return {
                            label: label,
                            value: value
                        };
                    }).sort(function(a, b) {
                        return a.label.localeCompare(b.label);
                    });
                    return [
                        2,
                        countries
                    ];
            }
        });
    });
    return function getAllCountries(_) {
        return _ref.apply(this, arguments);
    };
}();
var getDistrictsByProvince = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(provinceCode) {
        var res;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        clients__WEBPACK_IMPORTED_MODULE_0__/* .AddressClient.getDistrictsByProvince */ .uQ.getDistrictsByProvince(provinceCode)
                    ];
                case 1:
                    res = _state.sent();
                    if (!(0,clients__WEBPACK_IMPORTED_MODULE_0__/* .isValid */ .JY)(res)) {
                        return [
                            2,
                            []
                        ];
                    }
                    return [
                        2,
                        res.data.map(function(param) {
                            var label = param.name, value = param.code;
                            return {
                                label: label,
                                value: value
                            };
                        }).sort(function(a, b) {
                            return a.label.localeCompare(b.label);
                        })
                    ];
            }
        });
    });
    return function getDistrictsByProvince(provinceCode) {
        return _ref.apply(this, arguments);
    };
}();
var getWardsByDistrict = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(districtCode) {
        var res;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        clients__WEBPACK_IMPORTED_MODULE_0__/* .AddressClient.getWardsByDistrict */ .uQ.getWardsByDistrict(districtCode)
                    ];
                case 1:
                    res = _state.sent();
                    if (!(0,clients__WEBPACK_IMPORTED_MODULE_0__/* .isValid */ .JY)(res)) {
                        return [
                            2,
                            []
                        ];
                    }
                    return [
                        2,
                        res.data.map(function(param) {
                            var label = param.name, value = param.code;
                            return {
                                label: label,
                                value: value
                            };
                        }).sort(function(a, b) {
                            return a.label.localeCompare(b.label);
                        })
                    ];
            }
        });
    });
    return function getWardsByDistrict(districtCode) {
        return _ref.apply(this, arguments);
    };
}();
var getMasterAddressString = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(param) {
        var ctx, provinceCode, districtCode, wardCode, ref, wardRes, districtRes, provinceRes, masterAddress;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ctx = param.ctx, provinceCode = param.provinceCode, districtCode = param.districtCode, wardCode = param.wardCode;
                    return [
                        4,
                        Promise.all([
                            wardCode && clients__WEBPACK_IMPORTED_MODULE_0__/* .AddressClient.getWardByCode */ .uQ.getWardByCode(ctx, wardCode),
                            clients__WEBPACK_IMPORTED_MODULE_0__/* .AddressClient.getDistrictByCode */ .uQ.getDistrictByCode(ctx, districtCode),
                            clients__WEBPACK_IMPORTED_MODULE_0__/* .AddressClient.getProvinceByCode */ .uQ.getProvinceByCode(ctx, provinceCode)
                        ])
                    ];
                case 1:
                    ref = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"].apply */ .Z.apply(void 0, [
                        _state.sent(),
                        3
                    ]), wardRes = ref[0], districtRes = ref[1], provinceRes = ref[2];
                    masterAddress = "";
                    if ((0,clients__WEBPACK_IMPORTED_MODULE_0__/* .isValid */ .JY)(wardRes)) masterAddress += "".concat((0,clients__WEBPACK_IMPORTED_MODULE_0__/* .getFirst */ .Xi)(wardRes).name, ", ");
                    if ((0,clients__WEBPACK_IMPORTED_MODULE_0__/* .isValid */ .JY)(districtRes)) masterAddress += "".concat((0,clients__WEBPACK_IMPORTED_MODULE_0__/* .getFirst */ .Xi)(districtRes).name, ", ");
                    if ((0,clients__WEBPACK_IMPORTED_MODULE_0__/* .isValid */ .JY)(provinceRes)) masterAddress += (0,clients__WEBPACK_IMPORTED_MODULE_0__/* .getFirst */ .Xi)(provinceRes).name;
                    return [
                        2,
                        masterAddress
                    ];
            }
        });
    });
    return function getMasterAddressString(_) {
        return _ref.apply(this, arguments);
    };
}();
var getMasterAddressObject = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(param) {
        var ctx, provinceCode, districtCode, wardCode, ref, ref1, ref2, ref3, wardRes, districtRes, provinceRes, masterAddressObj, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ctx = param.ctx, provinceCode = param.provinceCode, districtCode = param.districtCode, wardCode = param.wardCode;
                    return [
                        4,
                        Promise.all([
                            wardCode && clients__WEBPACK_IMPORTED_MODULE_0__/* .AddressClient.getWardByCode */ .uQ.getWardByCode(ctx, wardCode),
                            clients__WEBPACK_IMPORTED_MODULE_0__/* .AddressClient.getDistrictByCode */ .uQ.getDistrictByCode(ctx, districtCode),
                            clients__WEBPACK_IMPORTED_MODULE_0__/* .AddressClient.getProvinceByCode */ .uQ.getProvinceByCode(ctx, provinceCode)
                        ])
                    ];
                case 1:
                    ref3 = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"].apply */ .Z.apply(void 0, [
                        _state.sent(),
                        3
                    ]), wardRes = ref3[0], districtRes = ref3[1], provinceRes = ref3[2];
                    _tmp = {};
                    masterAddressObj = _tmp;
                    if ((0,clients__WEBPACK_IMPORTED_MODULE_0__/* .isValid */ .JY)(wardRes)) masterAddressObj.ward = ((ref = (0,clients__WEBPACK_IMPORTED_MODULE_0__/* .getFirst */ .Xi)(wardRes)) === null || ref === void 0 ? void 0 : ref.name) || "";
                    if ((0,clients__WEBPACK_IMPORTED_MODULE_0__/* .isValid */ .JY)(districtRes)) masterAddressObj.district = ((ref1 = (0,clients__WEBPACK_IMPORTED_MODULE_0__/* .getFirst */ .Xi)(districtRes)) === null || ref1 === void 0 ? void 0 : ref1.name) || "";
                    if ((0,clients__WEBPACK_IMPORTED_MODULE_0__/* .isValid */ .JY)(provinceRes)) masterAddressObj.province = ((ref2 = (0,clients__WEBPACK_IMPORTED_MODULE_0__/* .getFirst */ .Xi)(provinceRes)) === null || ref2 === void 0 ? void 0 : ref2.name) || "";
                    return [
                        2,
                        masterAddressObj
                    ];
            }
        });
    });
    return function getMasterAddressObject(_) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ __webpack_exports__["Z"] = ({
    getProvinces: getProvinces,
    getDistrictsByProvince: getDistrictsByProvince,
    getWardsByDistrict: getWardsByDistrict,
    getMasterAddressString: getMasterAddressString,
    getMasterAddressObject: getMasterAddressObject,
    getAllCountries: getAllCountries,
    getAllCountriesMock: getAllCountriesMock,
    getAllProvinceMock: getAllProvinceMock,
    getRegions: getRegions
});


/***/ }),

/***/ 59606:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports loginLocal, login, signUp, registerGuest, loginv1, passwordRecovery, passwordUpdate, newPWUpdate */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97582);
/* harmony import */ var clients__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15149);



var loginLocal = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(body) {
        var _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        clients__WEBPACK_IMPORTED_MODULE_0__/* .AuthClient.loginLocal */ .LY.loginLocal(body)
                    ];
                case 1:
                    _state.sent();
                    _tmp = {};
                    return [
                        2,
                        _tmp
                    ];
            }
        });
    });
    return function loginLocal(body) {
        return _ref.apply(this, arguments);
    };
}();
var login = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(param) {
        var username, password, _type, type, authRes, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    username = param.username, password = param.password, _type = param.type, type = _type === void 0 ? "CUSTOMER" : _type;
                    _tmp = {};
                    return [
                        4,
                        clients__WEBPACK_IMPORTED_MODULE_0__/* .AuthClient.login */ .LY.login((_tmp.username = username, _tmp.password = password, _tmp.type = type, _tmp))
                    ];
                case 1:
                    authRes = _state.sent();
                    if (!(0,clients__WEBPACK_IMPORTED_MODULE_0__/* .isValid */ .JY)(authRes)) {
                        return [
                            2,
                            authRes
                        ];
                    }
                    return [
                        2,
                        authRes
                    ];
            }
        });
    });
    return function login(_) {
        return _ref.apply(this, arguments);
    };
}();
var signUp = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(data) {
        var signUpRes;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        clients__WEBPACK_IMPORTED_MODULE_0__/* .AuthClient.signUp */ .LY.signUp(data)
                    ];
                case 1:
                    signUpRes = _state.sent();
                    return [
                        2,
                        signUpRes
                    ];
            }
        });
    });
    return function signUp(data) {
        return _ref.apply(this, arguments);
    };
}();
var registerGuest = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(data) {
        var registerGuestRes;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        clients__WEBPACK_IMPORTED_MODULE_0__/* .AuthClient.registerGuest */ .LY.registerGuest(data)
                    ];
                case 1:
                    registerGuestRes = _state.sent();
                    return [
                        2,
                        registerGuestRes
                    ];
            }
        });
    });
    return function registerGuest(data) {
        return _ref.apply(this, arguments);
    };
}();
var loginv1 = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(param) {
        var tokenv1, registerUserV1, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    tokenv1 = param.tokenv1;
                    _tmp = {};
                    return [
                        4,
                        clients__WEBPACK_IMPORTED_MODULE_0__/* .AuthClient.registerV1 */ .LY.registerV1((_tmp.t = tokenv1, _tmp))
                    ];
                case 1:
                    registerUserV1 = _state.sent();
                    return [
                        2,
                        registerUserV1
                    ];
            }
        });
    });
    return function loginv1(_) {
        return _ref.apply(this, arguments);
    };
}();
var passwordRecovery = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(data) {
        var passwordRecoveryRes;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        clients__WEBPACK_IMPORTED_MODULE_0__/* .AuthClient.passwordRecovery */ .LY.passwordRecovery(data)
                    ];
                case 1:
                    passwordRecoveryRes = _state.sent();
                    return [
                        2,
                        passwordRecoveryRes
                    ];
            }
        });
    });
    return function passwordRecovery(data) {
        return _ref.apply(this, arguments);
    };
}();
var passwordUpdate = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(data) {
        var passwordUpdateRes;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        clients__WEBPACK_IMPORTED_MODULE_0__/* .AuthClient.passwordUpdate */ .LY.passwordUpdate(data)
                    ];
                case 1:
                    passwordUpdateRes = _state.sent();
                    return [
                        2,
                        passwordUpdateRes
                    ];
            }
        });
    });
    return function passwordUpdate(data) {
        return _ref.apply(this, arguments);
    };
}();
var newPWUpdate = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(data) {
        var newPWUpdateRes;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        clients__WEBPACK_IMPORTED_MODULE_0__/* .AuthClient.newPassword */ .LY.newPassword(data)
                    ];
                case 1:
                    newPWUpdateRes = _state.sent();
                    return [
                        2,
                        newPWUpdateRes
                    ];
            }
        });
    });
    return function newPWUpdate(data) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ __webpack_exports__["ZP"] = ({
    login: login,
    loginv1: loginv1,
    signUp: signUp,
    registerGuest: registerGuest,
    loginLocal: loginLocal,
    passwordRecovery: passwordRecovery,
    passwordUpdate: passwordUpdate,
    newPWUpdate: newPWUpdate
});


/***/ }),

/***/ 29455:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "VF": function() { return /* binding */ getListLoyalty; }
/* harmony export */ });
/* unused harmony exports getReferralList, sendSms, retrySendSMS, getListAddress, getBindingLINE */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(97582);
/* harmony import */ var clients__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15149);
/* harmony import */ var utils_DateTimeUtils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33213);
/* harmony import */ var utils_ResponseUtils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73744);
/* harmony import */ var utils_ValidateUtils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70220);
/* harmony import */ var _AddressService__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(84378);









var getReferralList = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(param) {
        var _offset, offset, _limit, limit, params, _tmp, res, _tmp1;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _offset = param.offset, offset = _offset === void 0 ? clients__WEBPACK_IMPORTED_MODULE_0__/* .OFFSET_DEFAULT */ .M6 : _offset, _limit = param.limit, limit = _limit === void 0 ? clients__WEBPACK_IMPORTED_MODULE_0__/* .LIMIT_DEFAULT */ .J0 : _limit;
                    _tmp = {};
                    params = (_tmp.offset = offset, _tmp.limit = limit, _tmp);
                    _tmp1 = {};
                    return [
                        4,
                        clients__WEBPACK_IMPORTED_MODULE_0__/* .CustomerClient.getReferral */ .YP.getReferral((_tmp1.params = params, _tmp1))
                    ];
                case 1:
                    res = _state.sent();
                    if ((0,clients__WEBPACK_IMPORTED_MODULE_0__/* .isValid */ .JY)(res)) {
                        res.data = res.data.map(function(referral) {
                            var _lastTimeSendSMS = referral.lastTimeSendSMS, lastTimeSendSMS = _lastTimeSendSMS === void 0 ? null : _lastTimeSendSMS, _smsTotalSent = referral.smsTotalSent, smsTotalSent = _smsTotalSent === void 0 ? 0 : _smsTotalSent, expireTime = referral.expireTime;
                            // check expired
                            if (utils_DateTimeUtils__WEBPACK_IMPORTED_MODULE_1__/* ["default"].compareTime */ .ZP.compareTime(expireTime, Date.now()) < 0) {
                                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, referral), {
                                    canResendSMS: false,
                                    // message: 'Không thể gửi. Bạn đã quá thời hạn gửi đến số điện thoại này!',
                                    message: "can_not_send_you_have_passed_the_deadline_to_send_to_this_number"
                                });
                            }
                            // check send total
                            if (smsTotalSent >= 5) {
                                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, referral), {
                                    canResendSMS: false,
                                    // message: 'Không thể gửi. Bạn không thể gửi quá 5 lần!',
                                    message: "can_not_send_you_cannot_submit_more_than_5_times"
                                });
                            }
                            // check > 3h
                            var dateLastSend = new Date(lastTimeSendSMS).getTime();
                            var curTime = new Date().getTime();
                            if (curTime - dateLastSend <= 10800000) {
                                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, referral), {
                                    canResendSMS: false,
                                    // message: 'Chưa thể gửi lại. Trong vòng 3 giờ, bạn chỉ có thể gửi 1 tin SMS!',
                                    message: "unable_to_resend"
                                });
                            }
                            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, referral), {
                                canResendSMS: true
                            });
                        });
                    }
                    return [
                        2,
                        res
                    ];
            }
        });
    });
    return function getReferralList(_) {
        return _ref.apply(this, arguments);
    };
}();
var sendSms = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(param) {
        var phoneNumber, res, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    phoneNumber = param.phoneNumber;
                    if ((0,utils_ValidateUtils__WEBPACK_IMPORTED_MODULE_3__/* .isEmpty */ .xb)(phoneNumber)) {
                        // return invalid('Số điện thoại không đúng định dạng');
                        return [
                            2,
                            (0,utils_ResponseUtils__WEBPACK_IMPORTED_MODULE_2__/* .invalid */ .I1)("invalid_phone_number")
                        ];
                    }
                    _tmp = {};
                    return [
                        4,
                        clients__WEBPACK_IMPORTED_MODULE_0__/* .CustomerClient.sendSms */ .YP.sendSms((_tmp.phoneNumber = phoneNumber, _tmp))
                    ];
                case 1:
                    res = _state.sent();
                    if (!(0,clients__WEBPACK_IMPORTED_MODULE_0__/* .isValid */ .JY)(res)) {
                        return [
                            2,
                            res
                        ];
                    }
                    return [
                        2,
                        res
                    ];
            }
        });
    });
    return function sendSms(_) {
        return _ref.apply(this, arguments);
    };
}();
var retrySendSMS = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(param) {
        var code, res, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    code = param.code;
                    _tmp = {};
                    return [
                        4,
                        clients__WEBPACK_IMPORTED_MODULE_0__/* .CustomerClient.retrySendSms */ .YP.retrySendSms((_tmp.code = code, _tmp))
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res
                    ];
            }
        });
    });
    return function retrySendSMS(_) {
        return _ref.apply(this, arguments);
    };
}();
var getListAddress = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(param) {
        var ctx, res, _tmp, data, addressInfoList;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ctx = param.ctx;
                    _tmp = {};
                    return [
                        4,
                        clients__WEBPACK_IMPORTED_MODULE_0__/* .CustomerClient.getListAddress */ .YP.getListAddress((_tmp.ctx = ctx, _tmp))
                    ];
                case 1:
                    res = _state.sent();
                    if (!(0,clients__WEBPACK_IMPORTED_MODULE_0__/* .isValid */ .JY)(res)) return [
                        2,
                        []
                    ];
                    data = (0,clients__WEBPACK_IMPORTED_MODULE_0__/* .getData */ .Yu)(res);
                    return [
                        4,
                        Promise.all(data.map(function() {
                            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(info) {
                                var masterAddress, _tmp, _tmp1;
                                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                _AddressService__WEBPACK_IMPORTED_MODULE_4__/* ["default"].getMasterAddressString */ .Z.getMasterAddressString(info)
                                            ];
                                        case 1:
                                            masterAddress = _state.sent();
                                            _tmp = {};
                                            _tmp1 = {};
                                            return [
                                                2,
                                                (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_tmp, info), (_tmp1.masterAddress = "".concat(info.address, ", ").concat(masterAddress), _tmp1))
                                            ];
                                    }
                                });
                            });
                            return function(info) {
                                return _ref.apply(this, arguments);
                            };
                        }()))
                    ];
                case 2:
                    addressInfoList = _state.sent();
                    addressInfoList = addressInfoList.sort(function(a, b) {
                        return utils_DateTimeUtils__WEBPACK_IMPORTED_MODULE_1__/* ["default"].compareTime */ .ZP.compareTime(a.createdTime, b.createdTime);
                    });
                    return [
                        2,
                        addressInfoList
                    ];
            }
        });
    });
    return function getListAddress(_) {
        return _ref.apply(this, arguments);
    };
}();
var getListLoyalty = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(param) {
        var ctx, res, loyaltys, promotionIDs, promosResp, _tmp, promoMap, _tmp1, promos;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ctx = param.ctx;
                    return [
                        4,
                        clients__WEBPACK_IMPORTED_MODULE_0__/* .CustomerClient.getListLoyalty */ .YP.getListLoyalty(ctx)
                    ];
                case 1:
                    res = _state.sent();
                    if (!(0,clients__WEBPACK_IMPORTED_MODULE_0__/* .isValid */ .JY)(res)) return [
                        2,
                        []
                    ];
                    loyaltys = (0,clients__WEBPACK_IMPORTED_MODULE_0__/* .getData */ .Yu)(res);
                    promotionIDs = loyaltys.map(function(loyalty) {
                        return loyalty.promotionId;
                    });
                    _tmp = {};
                    return [
                        4,
                        clients__WEBPACK_IMPORTED_MODULE_0__/* .PromoClient.getPromotionListByIDs */ .yK.getPromotionListByIDs((_tmp.ctx = ctx, _tmp.promotionIDs = promotionIDs, _tmp))
                    ];
                case 2:
                    promosResp = _state.sent();
                    _tmp1 = {};
                    if ((0,clients__WEBPACK_IMPORTED_MODULE_0__/* .isValid */ .JY)(promosResp)) {
                        promoMap = _tmp1;
                        promos = (0,clients__WEBPACK_IMPORTED_MODULE_0__/* .getData */ .Yu)(promosResp);
                        promos.forEach(function(promo) {
                            promoMap[promo.promotionId] = promo;
                        });
                        loyaltys = loyaltys.map(function(loyalty) {
                            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, loyalty), {
                                promotion: promoMap[loyalty.promotionId]
                            });
                        }).filter(function(loyalty) {
                            var ref;
                            return utils_DateTimeUtils__WEBPACK_IMPORTED_MODULE_1__/* ["default"].compareTime */ .ZP.compareTime(loyalty === null || loyalty === void 0 ? void 0 : (ref = loyalty.promotion) === null || ref === void 0 ? void 0 : ref.endTime, Date.now()) > 0;
                        }).sort(function(a, b) {
                            return a.point - b.point;
                        });
                    }
                    return [
                        2,
                        loyaltys
                    ];
            }
        });
    });
    return function getListLoyalty(_) {
        return _ref.apply(this, arguments);
    };
}();
var getBindingLINE = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(param) {
        var _customerID, customerID, res, _tmp, data;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _customerID = param.customerID, customerID = _customerID === void 0 ? "" : _customerID;
                    _tmp = {};
                    return [
                        4,
                        clients__WEBPACK_IMPORTED_MODULE_0__/* .CustomerClient.getBindingLINE */ .YP.getBindingLINE((_tmp.customerID = customerID, _tmp))
                    ];
                case 1:
                    res = _state.sent();
                    if (!(0,clients__WEBPACK_IMPORTED_MODULE_0__/* .isValid */ .JY)(res)) return [
                        2,
                        []
                    ];
                    data = (0,clients__WEBPACK_IMPORTED_MODULE_0__/* .getFirst */ .Xi)(res);
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function getBindingLINE(_) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ __webpack_exports__["ZP"] = ({
    getReferralList: getReferralList,
    sendSms: sendSms,
    retrySendSMS: retrySendSMS,
    getListAddress: getListAddress,
    getListLoyalty: getListLoyalty,
    getBindingLINE: getBindingLINE
});


/***/ }),

/***/ 79528:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports getSections, getTrendSearchs */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97582);
/* harmony import */ var clients__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15149);





var getSections = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(_param) {
        var _q, q, restProps, _tmp, result, _tmp1;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            _tmp = {};
            _q = _param.q, q = _q === void 0 ? _tmp : _q, restProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
                "q"
            ]);
            _tmp1 = {};
            result = clients__WEBPACK_IMPORTED_MODULE_0__/* .MarketingClient.getSections */ .c.getSections((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((_tmp1.q = q, _tmp1), restProps));
            return [
                2,
                result
            ];
        });
    });
    return function getSections(_param) {
        return _ref.apply(this, arguments);
    };
}();
var getTrendSearchs = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(_param) {
        var isActive, props, result, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            isActive = _param.isActive, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
                "isActive"
            ]);
            _tmp = {};
            result = clients__WEBPACK_IMPORTED_MODULE_0__/* .MarketingClient.getTrendSearch */ .c.getTrendSearch((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((_tmp.isActive = isActive, _tmp), props));
            return [
                2,
                result
            ];
        });
    });
    return function getTrendSearchs(_param) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ __webpack_exports__["ZP"] = ({
    getSections: getSections,
    getTrendSearchs: getTrendSearchs
});


/***/ }),

/***/ 5108:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C6": function() { return /* binding */ searchProductsByVoucherFilter; },
/* harmony export */   "Fz": function() { return /* binding */ mapDataProduct; },
/* harmony export */   "Pc": function() { return /* binding */ getProductInfoMapFromSkus; }
/* harmony export */ });
/* unused harmony exports findDiscountPercent, convertSlug, searchProductsQuickOrder, searchProductsMobile, getListTabs, loadDataQuickOrder, loadDataQuickOrderServer, getSubstituteProducts, loadDataProduct, loadDataProductWeb, loadDataProductMobileClient, loadDataProductMobileServer, getProductInfoFromSkus, getProductInfoFromSkusForSeller, loadDataProductDetail, getDataProductBySlug, getDataProductsBySlugs, getSettingTags, getTagNameFromIds, getDeals, getDealsClient, getStoreProductClient, getProductOfSeller, getHistoryBySkus */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(29815);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(97582);
/* harmony import */ var clients__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15149);
/* harmony import */ var clients_CatClientV2__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12141);
/* harmony import */ var clients_ProductClientV2__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22997);
/* harmony import */ var constants_APIUriV2__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83679);
/* harmony import */ var constants_data__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66520);
/* harmony import */ var constants_Enums__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(71569);
/* harmony import */ var constants_Images__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(13270);
/* harmony import */ var sysconfig__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(66225);
/* harmony import */ var utils_ArrUtils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(33769);
/* harmony import */ var utils_FormatNumber__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(44097);
/* harmony import */ var utils_ImageUtils__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(13744);
/* harmony import */ var utils_ProductLimitUtils__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(40110);
/* harmony import */ var utils_StringUtils__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(52380);
/* harmony import */ var utils_ValidateUtils__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(70220);
/* harmony import */ var _UserService__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(89349);





















var findDiscountPercent = function(salePrice, displayPrice) {
    if (salePrice === displayPrice || displayPrice > salePrice) return 0;
    var percentDiscountProduct = (salePrice - displayPrice) / salePrice * 100;
    if (percentDiscountProduct > 100) percentDiscountProduct = 100;
    return Math.floor(percentDiscountProduct);
};
var convertSlug = function(slug) {
    return (slug === null || slug === void 0 ? void 0 : slug.toLowerCase()) || slug;
};
var DEFAULT_SEARCH_STRATEGY = {
    text: true,
    keyword: true,
    ingredient: true
};
/*
Hàm convert thông tin product từ API trả về và chỉ dùng 1 số phần thôi 
dùng trong tất cả các hàm ở web
*/ // limit order message, see utils/ProductLimitUtils (BV-2070)
function getLimitOrder(limitPerDay, limitPerOrder, unit) {
    return (0,utils_ProductLimitUtils__WEBPACK_IMPORTED_MODULE_11__/* .buildLimitOrderMessage */ .n2)({
        limitPerDay: limitPerDay,
        limitPerOrder: limitPerOrder,
        unit: unit || sysconfig__WEBPACK_IMPORTED_MODULE_7__/* .CONFIG_GLOBAL.UNIT */ .P9.UNIT,
        templates: {
            perDay: sysconfig__WEBPACK_IMPORTED_MODULE_7__/* .CONFIG_GLOBAL.messageLimitOrderDay */ .P9.messageLimitOrderDay,
            perOrder: sysconfig__WEBPACK_IMPORTED_MODULE_7__/* .CONFIG_GLOBAL.messageLimitOrderTime */ .P9.messageLimitOrderTime,
            andPerOrder: sysconfig__WEBPACK_IMPORTED_MODULE_7__/* .CONFIG_GLOBAL.messageAndLimit */ .P9.messageAndLimit
        }
    });
}
// 19Apr22 : thêm config limitPerDay -> chỉ áp dụng cho normal , ko áp dụng cho deal/ campaign /
var convertProductV2 = function() {
    var item = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var ref, ref1, ref2;
    // console.log('convertProductV2  > item', item);
    // console.log('convertProductV2  > item product ', item.product);
    // console.log('convertProductV2  > item sku', item.sku);
    // console.log('convertProductV2  > item deal', item.deal);
    // const { product, sku, deal = null } = item;
    var ref3 = item || {}, _isAvailable = ref3.isAvailable, isAvailable = _isAvailable === void 0 ? true : _isAvailable, product = ref3.product, sku = ref3.sku, _deal = ref3.deal, deal = _deal === void 0 ? null : _deal, _nextPriceLevel = ref3.nextPriceLevel, nextPriceLevel = _nextPriceLevel === void 0 ? {} : _nextPriceLevel, _campaign = ref3.campaign, campaign = _campaign === void 0 ? null : _campaign, _skuDescription = ref3.skuDescription, skuDescription = _skuDescription === void 0 ? {} : _skuDescription, _limitPerDay = ref3.limitPerDay, limitPerDay = _limitPerDay === void 0 ? 0 : _limitPerDay, _quantityPurchasedToday = ref3.quantityPurchasedToday, quantityPurchasedToday = _quantityPurchasedToday === void 0 ? 0 : _quantityPurchasedToday, _consumedMaxQuantity = ref3.consumedMaxQuantity, consumedMaxQuantity = _consumedMaxQuantity === void 0 ? null : _consumedMaxQuantity, _withoutLogin = ref3.// feature display product without login
    withoutLogin, withoutLogin = _withoutLogin === void 0 ? false : _withoutLogin, _isProductCard = ref3.isProductCard, isProductCard = _isProductCard === void 0 ? false : _isProductCard, _isAvailabilityForCustomerScope = ref3.isAvailabilityForCustomerScope, isAvailabilityForCustomerScope = _isAvailabilityForCustomerScope === void 0 ? true : _isAvailabilityForCustomerScope;
    var ref4 = product || {}, _categoryCodes = ref4.categoryCodes, categoryCodes = _categoryCodes === void 0 ? null : _categoryCodes, _name = ref4.name, name = _name === void 0 ? "" : _name, _origin = ref4.origin, origin = _origin === void 0 ? "" : _origin, _volume = ref4.volume, volume = _volume === void 0 ? null : _volume, _unit = ref4.unit, unit = _unit === void 0 ? null : _unit, _manufacturerCode = ref4.manufacturerCode, manufacturerCode = _manufacturerCode === void 0 ? null : _manufacturerCode, _ingredients = ref4.ingredients, ingredients = _ingredients === void 0 ? [] : _ingredients, _ingredientCodes = ref4.ingredientCodes, ingredientCodes = _ingredientCodes === void 0 ? [] : _ingredientCodes, _productID = ref4.productID, productID = _productID === void 0 ? "" : _productID, _documentFiles = ref4.documentFiles, documentFiles = _documentFiles === void 0 ? [] : _documentFiles, _weight = ref4.weight, weight = _weight === void 0 ? 0 : _weight, _height = ref4.height, height = _height === void 0 ? 1 : _height, _length = ref4.length, length = _length === void 0 ? 1 : _length, _width = ref4.width, width = _width === void 0 ? 1 : _width;
    // requiredCertificates: [ 'GPP', 'BUSINESS_CERTIFICATE', 'BUSINESS_LICENSE' ],
    var ref5 = sku || {}, _maxQuantityPerOrder = ref5.maxQuantityPerOrder, maxQuantityPerOrder = _maxQuantityPerOrder === void 0 ? null : _maxQuantityPerOrder, _productCode = ref5.productCode, productCode = _productCode === void 0 ? "" : _productCode, _retailPriceType = ref5.retailPriceType, retailPriceType = _retailPriceType === void 0 ? "" : _retailPriceType, _retailPriceValue = ref5.retailPriceValue, retailPriceValue = _retailPriceValue === void 0 ? 0 : _retailPriceValue, _sellerCode = ref5.sellerCode, sellerCode = _sellerCode === void 0 ? null : _sellerCode, _status = ref5.status, status = _status === void 0 ? "" : _status, _code = ref5.code, code = _code === void 0 ? "" : _code, _tags = ref5.tags, tags = _tags === void 0 ? [] : _tags, _slug = ref5.slug, slug = _slug === void 0 ? null : _slug, _statusData = ref5.statusData, statusData = _statusData === void 0 ? null : _statusData, type = ref5.type, _skus = ref5.skus, skus = _skus === void 0 ? [] : _skus, _point = ref5.point, point = _point === void 0 ? null : _point, _pointMultiplier = ref5.pointMultiplier, pointMultiplier = _pointMultiplier === void 0 ? null : _pointMultiplier, isActive = ref5.isActive, _lotDates = ref5.lotDates, lotDates = _lotDates === void 0 ? [] : _lotDates, _requiredCertificates = ref5.requiredCertificates, requiredCertificates = _requiredCertificates === void 0 ? [] : _requiredCertificates;
    var ref6 = deal || {}, maxQuantityDeal = ref6.maxQuantity;
    var tagExpired = lotDates.find(function(ele) {
        return (ele === null || ele === void 0 ? void 0 : ele.isNearExpired) === true;
    }) || {};
    var _expiredDate = tagExpired.expiredDate, expiredDate = _expiredDate === void 0 ? "" : _expiredDate, _isNearExpired = tagExpired.isNearExpired, isNearExpired = _isNearExpired === void 0 ? false : _isNearExpired;
    // giá hợp đồng
    var isContractPrice = type === "SKU_CONTRACT";
    var isDeal = deal && (deal === null || deal === void 0 ? void 0 : deal.status) === "ACTIVE" && new Date(deal === null || deal === void 0 ? void 0 : deal.startTime) <= new Date() ? true : null;
    var imageUrls = isDeal && (deal === null || deal === void 0 ? void 0 : (ref = deal.imageUrls) === null || ref === void 0 ? void 0 : ref.length) > 0 ? deal === null || deal === void 0 ? void 0 : deal.imageUrls : (item === null || item === void 0 ? void 0 : (ref1 = item.product) === null || ref1 === void 0 ? void 0 : ref1.imageUrls) || [];
    var descriptionInfo = (item === null || item === void 0 ? void 0 : item.description) || {};
    if (skuDescription && (skuDescription === null || skuDescription === void 0 ? void 0 : skuDescription.description)) {
        descriptionInfo.description = skuDescription.description;
    }
    // const salePrice = deal?.price || retailPriceValue;
    // ưu tiên campaign
    var isCampaign = !!campaign || false;
    var isHappeningCampaign = campaign && (campaign === null || campaign === void 0 ? void 0 : campaign.isShow) || false;
    // anpham: push status into tags
    // [...tags] ở nhánh fallback: tránh push('NEAR_EXPIRATION') mutate thẳng mảng tags gốc
    // của response (gây tích luỹ tag trùng khi cùng 1 sku được map lại).
    var newTags = status !== "NORMAL" && status !== "NEAR_EXPIRATION" && (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(tags).concat([
        status
    ]) || (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(tags);
    if (isNearExpired) newTags.push("NEAR_EXPIRATION");
    var isNew = (tags === null || tags === void 0 ? void 0 : tags.indexOf(sysconfig__WEBPACK_IMPORTED_MODULE_7__/* .TAG_NEW */ .cC)) >= 0;
    // logic check sản phẩm này có dc hiển thị hay ko ở đây
    var errorMessageProduct = null;
    var customMessageproduct = null;
    var requireGPPMessage = null;
    if ((sysconfig__WEBPACK_IMPORTED_MODULE_7__/* .SELLER_CODES_REQUIRE_GPP */ .uU === null || sysconfig__WEBPACK_IMPORTED_MODULE_7__/* .SELLER_CODES_REQUIRE_GPP */ .uU === void 0 ? void 0 : sysconfig__WEBPACK_IMPORTED_MODULE_7__/* .SELLER_CODES_REQUIRE_GPP.length */ .uU.length) > 0 && sellerCode && sysconfig__WEBPACK_IMPORTED_MODULE_7__/* .SELLER_CODES_REQUIRE_GPP.indexOf */ .uU.indexOf(sellerCode) >= 0) {
        // requireGPPMessage = 'Yêu cầu cung cấp GPP và giấy phép kinh doanh';
        requireGPPMessage = "requireGPPMessage";
    }
    // off isAvailable
    // feature display product without login
    if (!withoutLogin) {
        if (!retailPriceValue || retailPriceValue === 0 || status === "STOP_SELLING") {
            // errorMessageProduct = 'Đang cập nhật giá';
            errorMessageProduct = "STOP_SELLING";
        }
        if (isAvailable !== null && !isAvailable) {
            // errorMessageProduct = 'Sản phẩm chưa hỗ trợ giao vùng này';
            // TODO: update message
            if (!isAvailabilityForCustomerScope) {
                errorMessageProduct = "not_support_scope";
            } else {
                errorMessageProduct = "not_support_delivery";
            }
        }
        if (!isActive) {
            // errorMessageProduct = 'Sản phẩm tạm ngưng bán';
            errorMessageProduct = "SUSPENDED";
        }
        switch(status){
            case "SUSPENDED":
                // errorMessageProduct = 'Sản phẩm đã ngưng bán';
                errorMessageProduct = "SUSPENDED";
                break;
            case "STOP_PRODUCING":
                // errorMessageProduct = 'Sản phẩm ngưng sản xuất';
                errorMessageProduct = "STOP_PRODUCING";
                break;
            case "OUT_OF_STOCK":
                // errorMessageProduct = 'Sản phẩm tạm hết hàng';
                errorMessageProduct = "OUT_OF_STOCK";
                break;
            default:
        }
    }
    var ref7;
    var dealPrice = (ref7 = isDeal && deal && (deal === null || deal === void 0 ? void 0 : deal.price)) !== null && ref7 !== void 0 ? ref7 : null;
    var imagesProxy = (0,utils_ImageUtils__WEBPACK_IMPORTED_MODULE_10__/* .getProxyImageList */ .V5)(imageUrls);
    var isGift = status === "GIFT";
    // variable template
    // update formatedCurrency
    var displayPrice = dealPrice !== null && dealPrice !== void 0 ? dealPrice : retailPriceValue;
    // product type
    var productType = "NORMAL";
    var typeItem = "NORMAL";
    var hidenPrice = null;
    // BV-2070: the per-order limit is optional. Not configured (null/0) means "no limit", which the
    // UI already represents with MAX_PRODUCT_QTY_DISPLAY (input clamp, deal/campaign min, bulk order).
    var maxQuantityPerOrderItem = (0,utils_ProductLimitUtils__WEBPACK_IMPORTED_MODULE_11__/* .normalizeMaxQuantityPerOrder */ .wy)(maxQuantityPerOrder);
    var maxQuantity = maxQuantityPerOrderItem;
    // percentage of quantity sold and sold out condition
    var percentDealSold;
    // available products to be able to buy in campaign
    var availableProducts;
    var discountPercentage;
    var messageLimitOrder = getLimitOrder(limitPerDay, maxQuantityPerOrderItem, unit);
    // nếu có campaign
    if (isHappeningCampaign) {
        var campaignInfo = campaign.campaign, tmp = campaign.maxQuantityPerOrder, maxQuantityPerOrderCampaign = tmp === void 0 ? maxQuantityPerOrderItem : tmp, maxQuantityCampaign = campaign.quantity, retailPriceCampaign = campaign.retailPriceValue, _soldQuantity = campaign.soldQuantity, soldQuantity = _soldQuantity === void 0 ? 0 : _soldQuantity;
        percentDealSold = soldQuantity / (campaign === null || campaign === void 0 ? void 0 : campaign.quantity) * 100;
        if (percentDealSold < 100) {
            newTags.push("DEAL");
            discountPercentage = findDiscountPercent(retailPriceValue, retailPriceCampaign);
            availableProducts = Math.min(maxQuantityCampaign - soldQuantity, (0,utils_ProductLimitUtils__WEBPACK_IMPORTED_MODULE_11__/* .normalizeMaxQuantityPerOrder */ .wy)(maxQuantityPerOrderCampaign));
            if ((campaignInfo === null || campaignInfo === void 0 ? void 0 : campaignInfo.campaignType) === "NORMAL") {
                productType = "MEGA_DAY";
            } else if ((campaignInfo === null || campaignInfo === void 0 ? void 0 : campaignInfo.campaignType) === "FLASH_SALE") {
                productType = "FLASH_SALE";
                newTags.push(productType);
            }
            // price for campaign
            typeItem = "CAMPAIGN";
            displayPrice = retailPriceCampaign;
            maxQuantity = maxQuantityCampaign;
        } else {
            productType = "NORMAL";
            customMessageproduct = "Bạn đ\xe3 bỏ lỡ gi\xe1 khuyến m\xe3i ".concat((0,utils_FormatNumber__WEBPACK_IMPORTED_MODULE_9__/* .formatCurrency */ .xG)(retailPriceCampaign));
        }
    } else if (isDeal) {
        productType = "DEAL";
        typeItem = "DEAL";
        // MIN
        maxQuantity = Math.min(maxQuantityDeal, maxQuantityPerOrderItem);
        discountPercentage = findDiscountPercent(retailPriceValue, dealPrice);
        newTags.push(productType);
        availableProducts = (deal === null || deal === void 0 ? void 0 : deal.maxQuantity) - (deal === null || deal === void 0 ? void 0 : deal.quantity) || 0;
        percentDealSold = ((deal === null || deal === void 0 ? void 0 : deal.quantity) || 0) / (deal === null || deal === void 0 ? void 0 : deal.maxQuantity) * 100;
    } else {
        productType = "NORMAL";
    // availableProducts = limitPerDay;
    }
    // end
    // @deprecase
    // tag giao hang 7 days
    // if (tags?.indexOf(TAG_7DAYS) >= 0) {
    //   newTags.push('TAG_7DAYS');
    // }
    if (isProductCard) {
        var ref8;
        return {
            consumedMaxQuantity: consumedMaxQuantity,
            isNew: isNew,
            isAvailable: isAvailable,
            defaultImage: isGift ? imagesProxy[0] || constants_Images__WEBPACK_IMPORTED_MODULE_6__/* .GIFT_IMAGE */ .AON : imagesProxy[0] || "",
            imageUrls: imageUrls,
            originalImages: (0,utils_ImageUtils__WEBPACK_IMPORTED_MODULE_10__/* .getProxyImageList */ .V5)((item === null || item === void 0 ? void 0 : (ref8 = item.product) === null || ref8 === void 0 ? void 0 : ref8.imageUrls) || []),
            maxQuantity: maxQuantity,
            maxQuantityPerOrder: maxQuantityPerOrderItem,
            maxQuantityPerDay: limitPerDay,
            limitPerDay: limitPerDay,
            quantityPurchasedToday: quantityPurchasedToday,
            // price
            salePrice: retailPriceValue,
            salePriceFormated: (0,utils_FormatNumber__WEBPACK_IMPORTED_MODULE_9__/* .formatCurrency */ .xG)(retailPriceValue) || "",
            dealPrice: dealPrice,
            dealPriceFormated: (0,utils_FormatNumber__WEBPACK_IMPORTED_MODULE_9__/* .formatCurrency */ .xG)(dealPrice) || "",
            displayPrice: displayPrice,
            displayPriceFormated: (0,utils_FormatNumber__WEBPACK_IMPORTED_MODULE_9__/* .formatCurrency */ .xG)(displayPrice) || "",
            hidenPrice: hidenPrice,
            // sku
            sku: code,
            // combo
            skus: skus,
            skuId: productCode,
            // code
            slug: convertSlug(slug),
            status: status,
            // deal
            // nếu tồn tại campaing thì sẽ ko tồn tại deal- thuannc 06Jan2022
            deal: isCampaign ? null : deal,
            isDeal: isDeal,
            // seller
            sellerCode: sellerCode,
            seller: withoutLogin ? {} : {
                code: sellerCode,
                slug: slug
            },
            // info
            // DONE: name deal thuannc
            name: isDeal && deal && (deal === null || deal === void 0 ? void 0 : deal.name) || name,
            nameNormal: name,
            productId: productID,
            unit: unit,
            volume: (0,utils_StringUtils__WEBPACK_IMPORTED_MODULE_12__/* .capitalizeTextFirst */ .eq)(volume),
            statusData: statusData,
            productSkuType: type,
            tags: withoutLogin ? [] : newTags || null,
            type: typeItem || null,
            productType: productType,
            isGift: isGift,
            errorMessageProduct: errorMessageProduct,
            customMessageproduct: customMessageproduct,
            requiredCertificates: requiredCertificates,
            // campaign
            isCampaign: isCampaign,
            campaign: campaign,
            discountPercent: discountPercentage || 0,
            isHappeningCampaign: isHappeningCampaign,
            availableProducts: availableProducts || 0,
            // percentage discount for progress
            percentDealSold: percentDealSold || 0,
            isContractPrice: isContractPrice,
            // plus points
            point: point,
            pointMultiplier: pointMultiplier,
            messageLimitOrder: messageLimitOrder,
            isActive: isActive,
            expiredDate: expiredDate
        };
    }
    var productInfo = {
        consumedMaxQuantity: consumedMaxQuantity,
        isNew: isNew,
        isAvailable: isAvailable,
        imageUrls: imageUrls,
        imagesProxy: isGift ? imagesProxy || [
            constants_Images__WEBPACK_IMPORTED_MODULE_6__/* .GIFT_IMAGE */ .AON
        ] : imagesProxy,
        defaultImage: isGift ? imagesProxy[0] || constants_Images__WEBPACK_IMPORTED_MODULE_6__/* .GIFT_IMAGE */ .AON : imagesProxy[0] || "",
        originalImages: (0,utils_ImageUtils__WEBPACK_IMPORTED_MODULE_10__/* .getProxyImageList */ .V5)((item === null || item === void 0 ? void 0 : (ref2 = item.product) === null || ref2 === void 0 ? void 0 : ref2.imageUrls) || []),
        maxQuantity: maxQuantity,
        maxQuantityPerOrder: maxQuantityPerOrderItem,
        maxQuantityPerDay: limitPerDay,
        limitPerDay: limitPerDay,
        quantityPurchasedToday: quantityPurchasedToday,
        // price
        salePrice: retailPriceValue,
        salePriceFormated: (0,utils_FormatNumber__WEBPACK_IMPORTED_MODULE_9__/* .formatCurrency */ .xG)(retailPriceValue) || "",
        dealPrice: dealPrice,
        dealPriceFormated: (0,utils_FormatNumber__WEBPACK_IMPORTED_MODULE_9__/* .formatCurrency */ .xG)(dealPrice) || "",
        nextPrice: isDeal || isCampaign ? 0 : (nextPriceLevel === null || nextPriceLevel === void 0 ? void 0 : nextPriceLevel.price) || 0,
        nextLevel: (nextPriceLevel === null || nextPriceLevel === void 0 ? void 0 : nextPriceLevel.code) || "",
        displayPrice: displayPrice,
        displayPriceFormated: (0,utils_FormatNumber__WEBPACK_IMPORTED_MODULE_9__/* .formatCurrency */ .xG)(displayPrice) || "",
        hidenPrice: hidenPrice,
        // sku
        sku: code,
        // combo
        skus: skus,
        skuId: productCode,
        kind: retailPriceType,
        // code
        slug: convertSlug(slug),
        status: status,
        ingredients: ingredients,
        ingredientCodes: ingredientCodes,
        manufacturerCode: manufacturerCode,
        categoryCodes: categoryCodes,
        // type
        // deal
        // nếu tồn tại campaing thì sẽ ko tồn tại deal- thuannc 06Jan2022
        deal: isCampaign ? null : deal,
        isDeal: isDeal,
        // seller
        sellerCode: sellerCode,
        seller: withoutLogin ? {} : {
            code: sellerCode,
            slug: slug
        },
        // info
        // DONE: name deal thuannc
        name: isDeal && deal && (deal === null || deal === void 0 ? void 0 : deal.name) || name,
        nameNormal: name,
        productId: productID,
        unit: unit,
        origin: origin,
        description: descriptionInfo,
        volume: (0,utils_StringUtils__WEBPACK_IMPORTED_MODULE_12__/* .capitalizeTextFirst */ .eq)(volume),
        weight: weight,
        productVolume: width * height * length,
        statusData: statusData,
        productSkuType: type,
        tags: withoutLogin ? [] : newTags || null,
        type: typeItem || null,
        productType: productType,
        isGift: isGift,
        errorMessageProduct: errorMessageProduct,
        customMessageproduct: customMessageproduct,
        requireGPPMessage: requireGPPMessage,
        requiredCertificates: requiredCertificates,
        documentFiles: documentFiles,
        // campaign
        isCampaign: isCampaign,
        campaign: campaign,
        discountPercent: discountPercentage || 0,
        isHappeningCampaign: isHappeningCampaign,
        availableProducts: availableProducts || 0,
        // percentage discount for progress
        percentDealSold: percentDealSold || 0,
        isContractPrice: isContractPrice,
        // plus points
        point: point,
        pointMultiplier: pointMultiplier,
        messageLimitOrder: messageLimitOrder,
        isActive: isActive,
        expiredDate: expiredDate
    };
    // ưu tiên tag theo thứ tự -> hang_dat_truoc,...
    // console.log('convertProductV2  > ', productInfo);
    return productInfo;
};
var mapDataProduct = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(param) {
        var ctx, result, _isGetQuantity, isGetQuantity, _withoutLogin, withoutLogin, _isAvailable, isAvailable, _isProductCard, isProductCard, cartObject, limitSkus, ref, tmp, dataProducts, _tmp, data, skuCodes, tasks, _tmp1, _tmp2, e;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ctx = param.ctx, result = param.result, _isGetQuantity = param.isGetQuantity, isGetQuantity = _isGetQuantity === void 0 ? true : _isGetQuantity, _withoutLogin = param.withoutLogin, withoutLogin = _withoutLogin === void 0 ? false : _withoutLogin, _isAvailable = param.isAvailable, isAvailable = _isAvailable === void 0 ? false : _isAvailable, _isProductCard = param.isProductCard, isProductCard = _isProductCard === void 0 ? false : _isProductCard;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    if (!(0,clients__WEBPACK_IMPORTED_MODULE_0__/* .isValid */ .JY)(result)) {
                        return [
                            2,
                            result
                        ];
                    }
                    cartObject = new Map();
                    limitSkus = new Map();
                    _tmp = {};
                    ref = result || _tmp, tmp = ref.data, dataProducts = tmp === void 0 ? [] : tmp;
                    data = dataProducts;
                    if (isAvailable) {
                        data = data.filter(function(item) {
                            return item.isAvailable;
                        });
                    }
                    skuCodes = data.map(function(item) {
                        var ref;
                        return item === null || item === void 0 ? void 0 : (ref = item.sku) === null || ref === void 0 ? void 0 : ref.code;
                    });
                    // BV-2408: lấy luôn giới hạn mua/ngày cho SP thay thế (skuReplace từ frontend-apis)
                    data.forEach(function(item) {
                        var ref;
                        item === null || item === void 0 ? void 0 : (ref = item.skuReplace) === null || ref === void 0 ? void 0 : ref.forEach(function(sub) {
                            var ref;
                            return (sub === null || sub === void 0 ? void 0 : (ref = sub.sku) === null || ref === void 0 ? void 0 : ref.code) && skuCodes.push(sub.sku.code);
                        });
                    });
                    if (!!withoutLogin) return [
                        3,
                        3
                    ];
                    tasks = [];
                    _tmp1 = {};
                    if (isGetQuantity) {
                        tasks.push(clients__WEBPACK_IMPORTED_MODULE_0__/* .CartClientV2.getCartItemList */ .HP.getCartItemList((_tmp1.ctx = ctx, _tmp1)).then(function(cartRes) {
                            if ((0,clients__WEBPACK_IMPORTED_MODULE_0__/* .isValid */ .JY)(cartRes)) {
                                var cartItems = (0,clients__WEBPACK_IMPORTED_MODULE_0__/* .getData */ .Yu)(cartRes);
                                if ((cartItems === null || cartItems === void 0 ? void 0 : cartItems.length) > 0) {
                                    cartObject = (0,utils_ArrUtils__WEBPACK_IMPORTED_MODULE_8__/* .convertArrayToMap */ .lE)(cartItems, "sku");
                                }
                            }
                        }));
                    }
                    _tmp2 = {};
                    // lấy config theo ngày
                    tasks.push(clients__WEBPACK_IMPORTED_MODULE_0__/* .ProductClientV2.getSkusLimit */ .j4.getSkusLimit((_tmp2.ctx = ctx, _tmp2.skuCodes = skuCodes, _tmp2)).then(function(limitSkusRes) {
                        var ref;
                        var skusLimitData = (ref = (0,clients__WEBPACK_IMPORTED_MODULE_0__/* .getData */ .Yu)(limitSkusRes)) === null || ref === void 0 ? void 0 : ref.filter(function(item) {
                            return item.isActive;
                        });
                        limitSkus = (0,utils_ArrUtils__WEBPACK_IMPORTED_MODULE_8__/* .convertArrayToMap */ .lE)(skusLimitData, "itemCode");
                    }));
                    return [
                        4,
                        Promise.all(tasks)
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    // eslint-disable-next-line no-param-reassign
                    result.data = (data === null || data === void 0 ? void 0 : data.map(function(item) {
                        var ref, ref1, ref2, ref3, ref4;
                        // 20Apr thêm limitPerDay
                        var info = convertProductV2((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)({}, item), {
                            limitPerDay: ((ref1 = limitSkus === null || limitSkus === void 0 ? void 0 : limitSkus.get(item === null || item === void 0 ? void 0 : (ref = item.sku) === null || ref === void 0 ? void 0 : ref.itemCode)) === null || ref1 === void 0 ? void 0 : ref1.quantity) || 0,
                            withoutLogin: withoutLogin,
                            isProductCard: isProductCard
                        }));
                        // BV-2408: SP thay thế convert cùng format SP chính
                        var skuReplace = ((ref3 = item === null || item === void 0 ? void 0 : (ref2 = item.skuReplace) === null || ref2 === void 0 ? void 0 : ref2.filter(function(sub) {
                            var ref;
                            return sub === null || sub === void 0 ? void 0 : (ref = sub.sku) === null || ref === void 0 ? void 0 : ref.code;
                        })) === null || ref3 === void 0 ? void 0 : ref3.map(function(sub) {
                            var ref, ref1, ref2;
                            var subInfo = convertProductV2((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)({}, sub), {
                                limitPerDay: ((ref1 = limitSkus === null || limitSkus === void 0 ? void 0 : limitSkus.get(sub === null || sub === void 0 ? void 0 : (ref = sub.sku) === null || ref === void 0 ? void 0 : ref.itemCode)) === null || ref1 === void 0 ? void 0 : ref1.quantity) || 0,
                                withoutLogin: withoutLogin,
                                isProductCard: isProductCard
                            }));
                            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)({}, subInfo), {
                                isSKUReplace: true,
                                quantity: ((ref2 = cartObject === null || cartObject === void 0 ? void 0 : cartObject.get(subInfo.sku)) === null || ref2 === void 0 ? void 0 : ref2.quantity) || 0
                            });
                        })) || [];
                        return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)({}, info, (item === null || item === void 0 ? void 0 : item.isSKUReplace) && {
                            isSKUReplace: true
                        }), {
                            quantity: ((ref4 = cartObject === null || cartObject === void 0 ? void 0 : cartObject.get(info.sku)) === null || ref4 === void 0 ? void 0 : ref4.quantity) || 0
                        }), skuReplace.length > 0 && {
                            skuReplace: skuReplace
                        });
                    })) || [];
                    return [
                        2,
                        result
                    ];
                case 4:
                    e = _state.sent();
                    console.error(e);
                    return [
                        2,
                        null
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return function mapDataProduct(_) {
        return _ref.apply(this, arguments);
    };
}();
// map with limit skus
// deprecated 22Feb2023 - Dinh Tran
// export const mapDataProductWithoutCart = async ({ result }) => {
//   try {
//     const { data = [] } = result || {};
//     // eslint-disable-next-line no-param-reassign
//     result.data = data.map((item) => {
//       const info = convertProductV2(item);
//       return {
//         ...info,
//       };
//     });
//     return result;
//   } catch (e) {
//     console.error(e);
//     return null;
//   }
// };
// search product
var searchProductsQuickOrder = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(keyword) {
        var page, body, _tmp, result, _tmp1, _tmp2;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    page = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : 1;
                    _tmp = {};
                    body = (_tmp.offset = (page - 1) * constants_data__WEBPACK_IMPORTED_MODULE_4__/* .PAGE_SIZE_30 */ .AV, _tmp.text = keyword || null, _tmp.limit = constants_data__WEBPACK_IMPORTED_MODULE_4__/* .PAGE_SIZE_30 */ .AV, _tmp.getTotal = true, _tmp.getPrice = true, _tmp.searchStrategy = DEFAULT_SEARCH_STRATEGY, _tmp);
                    _tmp1 = {};
                    return [
                        4,
                        clients__WEBPACK_IMPORTED_MODULE_0__/* .ProductClientV2.getProductQuickOrder */ .j4.getProductQuickOrder((_tmp1.body = body, _tmp1))
                    ];
                case 1:
                    result = _state.sent();
                    if (!(0,clients__WEBPACK_IMPORTED_MODULE_0__/* .isValid */ .JY)(result)) {
                        return [
                            2,
                            result
                        ];
                    }
                    _tmp2 = {};
                    return [
                        2,
                        mapDataProduct((_tmp2.result = result, _tmp2.isGetQuantity = true, _tmp2))
                    ];
            }
        });
    });
    return function searchProductsQuickOrder(keyword) {
        return _ref.apply(this, arguments);
    };
}();
// Sản phẩm áp dụng của voucher: filter lấy nguyên `filterProduct` BE trả về
// (skus, sellers, productCodes, tags, tagIn, skuNotIn)
var searchProductsByVoucherFilter = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(param) {
        var _filter, filter, _text, text, _page, page, _limit, limit, _tmp, body, _tmp1, result, _tmp2, _tmp3;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    _filter = param.filter, filter = _filter === void 0 ? _tmp : _filter, _text = param.text, text = _text === void 0 ? "" : _text, _page = param.page, page = _page === void 0 ? 1 : _page, _limit = param.limit, limit = _limit === void 0 ? constants_data__WEBPACK_IMPORTED_MODULE_4__/* .PAGE_SIZE_30 */ .AV : _limit;
                    _tmp1 = {};
                    body = (_tmp1.offset = (page - 1) * limit, _tmp1.text = text || null, _tmp1.limit = limit, _tmp1.getTotal = true, _tmp1.getPrice = true, _tmp1.isAvailable = true, _tmp1.searchStrategy = DEFAULT_SEARCH_STRATEGY, _tmp1.filter = filter, _tmp1.// bắt product-service TH/KH áp đủ filter của voucher (skus/skuNotIn/tags) kể cả khi có text
                    strictFilter = true, _tmp1);
                    _tmp2 = {};
                    return [
                        4,
                        clients__WEBPACK_IMPORTED_MODULE_0__/* .ProductClientV2.getFuzzySearchClient */ .j4.getFuzzySearchClient((_tmp2.body = body, _tmp2.skipInvalidReport = true, _tmp2))
                    ];
                case 1:
                    result = _state.sent();
                    if (!(0,clients__WEBPACK_IMPORTED_MODULE_0__/* .isValid */ .JY)(result)) {
                        return [
                            2,
                            result
                        ];
                    }
                    _tmp3 = {};
                    return [
                        2,
                        mapDataProduct((_tmp3.result = result, _tmp3.isGetQuantity = true, _tmp3))
                    ];
            }
        });
    });
    return function searchProductsByVoucherFilter(_) {
        return _ref.apply(this, arguments);
    };
}();
// Mobile Product V2
var searchProductsMobile = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(keyword, page, query) {
        var category, manufacturer, sort, text, tag, filter, _tmp, defaultQuerySearch, searchText, searchSort, searchPage, body, _tmp1, _tmp2, result, _tmp3, _tmp4;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    category = query.category, manufacturer = query.manufacturer, sort = query.sort, text = query.text, tag = query.tag;
                    _tmp = {};
                    filter = _tmp;
                    defaultQuerySearch = "";
                    if (category) {
                        filter.category = query.category;
                    }
                    if (manufacturer) {
                        filter.manufacturer = query.manufacturer;
                    }
                    if (tag) {
                        filter.tag = query.tag;
                    }
                    searchText = keyword || text || defaultQuerySearch;
                    searchSort = !keyword ? sort : "";
                    searchPage = Number(page) || Number(query === null || query === void 0 ? void 0 : query.page) || 1;
                    _tmp1 = {};
                    _tmp2 = {};
                    body = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(_tmp1, query), (_tmp2.offset = Number(page - 1) * constants_data__WEBPACK_IMPORTED_MODULE_4__/* .PAGE_SIZE */ .IV, _tmp2.text = searchText, _tmp2.limit = constants_data__WEBPACK_IMPORTED_MODULE_4__/* .PAGE_SIZE */ .IV, _tmp2.getTotal = true, _tmp2.getPrice = true, _tmp2.searchStrategy = DEFAULT_SEARCH_STRATEGY, _tmp2.filter = filter, _tmp2.sort = searchSort, _tmp2.isAvailable = (query === null || query === void 0 ? void 0 : query.isAvailable) === "true", _tmp2.page = searchPage, _tmp2));
                    _tmp3 = {};
                    return [
                        4,
                        clients__WEBPACK_IMPORTED_MODULE_0__/* .ProductClientV2.getFuzzySearchBffClient */ .j4.getFuzzySearchBffClient((_tmp3.body = body, _tmp3))
                    ];
                case 1:
                    result = _state.sent();
                    if (!(0,clients__WEBPACK_IMPORTED_MODULE_0__/* .isValid */ .JY)(result)) {
                        return [
                            2,
                            result
                        ];
                    }
                    _tmp4 = {};
                    return [
                        2,
                        mapDataProduct((_tmp4.result = result, _tmp4.isGetQuantity = false, _tmp4))
                    ];
            }
        });
    });
    return function searchProductsMobile(keyword, page, query) {
        return _ref.apply(this, arguments);
    };
}();
var getListTabs = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(param) {
        var ctx, res, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ctx = param.ctx;
                    _tmp = {};
                    return [
                        4,
                        clients__WEBPACK_IMPORTED_MODULE_0__/* .ProductClientV2.getTabs */ .j4.getTabs((_tmp.ctx = ctx, _tmp))
                    ];
                case 1:
                    res = _state.sent();
                    if (!(0,clients__WEBPACK_IMPORTED_MODULE_0__/* .isValid */ .JY)(res)) {
                        return [
                            2,
                            []
                        ];
                    }
                    return [
                        2,
                        res.data
                    ];
            }
        });
    });
    return function getListTabs(_) {
        return _ref.apply(this, arguments);
    };
}();
var loadDataQuickOrder = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(param) {
        var _page, page, body, _tmp, result, _tmp1, _tmp2;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _page = param.page, page = _page === void 0 ? 1 : _page;
                    _tmp = {};
                    body = (_tmp.offset = (page - 1) * constants_data__WEBPACK_IMPORTED_MODULE_4__/* .PAGE_SIZE_30 */ .AV, _tmp.limit = constants_data__WEBPACK_IMPORTED_MODULE_4__/* .PAGE_SIZE_30 */ .AV, _tmp.getTotal = true, _tmp.getPrice = true, _tmp.searchStrategy = DEFAULT_SEARCH_STRATEGY, _tmp);
                    _tmp1 = {};
                    return [
                        4,
                        clients__WEBPACK_IMPORTED_MODULE_0__/* .ProductClientV2.getProductQuickOrder */ .j4.getProductQuickOrder((_tmp1.body = body, _tmp1))
                    ];
                case 1:
                    result = _state.sent();
                    if (!(0,clients__WEBPACK_IMPORTED_MODULE_0__/* .isValid */ .JY)(result)) return [
                        2,
                        result
                    ];
                    _tmp2 = {};
                    return [
                        2,
                        mapDataProduct((_tmp2.result = result, _tmp2.isGetQuantity = false, _tmp2))
                    ];
            }
        });
    });
    return function loadDataQuickOrder(_) {
        return _ref.apply(this, arguments);
    };
}();
// BV-2408: SSR trang đặt hàng nhanh qua frontend-apis /quick-order/fuzzy
var loadDataQuickOrderServer = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(param) {
        var ctx, _text, text, _page, page, body, _tmp, result, _tmp1, _tmp2;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ctx = param.ctx, _text = param.text, text = _text === void 0 ? "" : _text, _page = param.page, page = _page === void 0 ? 1 : _page;
                    _tmp = {};
                    body = (_tmp.offset = (page - 1) * constants_data__WEBPACK_IMPORTED_MODULE_4__/* .PAGE_SIZE_30 */ .AV, _tmp.text = text || null, _tmp.limit = constants_data__WEBPACK_IMPORTED_MODULE_4__/* .PAGE_SIZE_30 */ .AV, _tmp.getTotal = true, _tmp.getPrice = true, _tmp.searchStrategy = DEFAULT_SEARCH_STRATEGY, _tmp);
                    _tmp1 = {};
                    return [
                        4,
                        clients__WEBPACK_IMPORTED_MODULE_0__/* .ProductClientV2.getProductQuickOrder */ .j4.getProductQuickOrder((_tmp1.ctx = ctx, _tmp1.body = body, _tmp1))
                    ];
                case 1:
                    result = _state.sent();
                    if (!(0,clients__WEBPACK_IMPORTED_MODULE_0__/* .isValid */ .JY)(result)) return [
                        2,
                        result
                    ];
                    _tmp2 = {};
                    return [
                        2,
                        mapDataProduct((_tmp2.ctx = ctx, _tmp2.result = result, _tmp2))
                    ];
            }
        });
    });
    return function loadDataQuickOrderServer(_) {
        return _ref.apply(this, arguments);
    };
}();
// BV-2408: danh sách SP thay thế của 1 SP (trang /substitutes)
var getSubstituteProducts = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(param) {
        var slug, _offset, offset, _limit, limit, result, _tmp, _tmp1;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    slug = param.slug, _offset = param.offset, offset = _offset === void 0 ? 0 : _offset, _limit = param.limit, limit = _limit === void 0 ? 10 : _limit;
                    _tmp = {};
                    return [
                        4,
                        clients__WEBPACK_IMPORTED_MODULE_0__/* .ProductClientV2.getReplaceProduct */ .j4.getReplaceProduct((_tmp.slug = slug, _tmp.offset = offset, _tmp.limit = limit, _tmp))
                    ];
                case 1:
                    result = _state.sent();
                    if (!(0,clients__WEBPACK_IMPORTED_MODULE_0__/* .isValid */ .JY)(result)) return [
                        2,
                        result
                    ];
                    _tmp1 = {};
                    return [
                        2,
                        mapDataProduct((_tmp1.result = result, _tmp1.isProductCard = true, _tmp1))
                    ];
            }
        });
    });
    return function getSubstituteProducts(_) {
        return _ref.apply(this, arguments);
    };
}();
var checkCurrentTab = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(param) {
        var ctx, filter, query, tabs, _tmp, currentTab;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ctx = param.ctx, filter = param.filter;
                    query = ctx.query;
                    if (!query.currentTab) return [
                        3,
                        2
                    ];
                    _tmp = {};
                    return [
                        4,
                        getListTabs((_tmp.ctx = ctx, _tmp))
                    ];
                case 1:
                    tabs = _state.sent();
                    currentTab = tabs.find(function(tab) {
                        return tab.slug === query.currentTab;
                    });
                    // eslint-disable-next-line no-param-reassign
                    if (currentTab) filter[currentTab.type.toLowerCase()] = currentTab.value;
                    _state.label = 2;
                case 2:
                    return [
                        2
                    ];
            }
        });
    });
    return function checkCurrentTab(_) {
        return _ref.apply(this, arguments);
    };
}();
// tabs truyền vào từ ssr / client
var loadDataProduct = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(param) {
        var ctx, _limit, limit, _tabs, tabs, isGetBodyOnly, ref, ref1, query, filter, _tmp, currentTab, _tmp1, categoryFilters, ref2, combinedCategoryFilters, sort, page, body, _tmp2, _tmp3, result, _tmp4, _tmp5;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ctx = param.ctx, _limit = param.limit, limit = _limit === void 0 ? constants_data__WEBPACK_IMPORTED_MODULE_4__/* .PAGE_SIZE_30 */ .AV : _limit, _tabs = param.tabs, tabs = _tabs === void 0 ? [] : _tabs, isGetBodyOnly = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : false;
                    query = ctx.query;
                    _tmp = {};
                    filter = _tmp;
                    if (!query.currentTab) return [
                        3,
                        3
                    ];
                    if (!((tabs === null || tabs === void 0 ? void 0 : tabs.length) > 0)) return [
                        3,
                        1
                    ];
                    currentTab = tabs.find(function(tab) {
                        return tab.slug === query.currentTab;
                    });
                    if (currentTab) filter[currentTab.type.toLowerCase()] = currentTab.value;
                    return [
                        3,
                        3
                    ];
                case 1:
                    _tmp1 = {};
                    return [
                        4,
                        checkCurrentTab((_tmp1.ctx = ctx, _tmp1.filter = filter, _tmp1))
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    // check tag
                    if (query.tag) {
                        filter.tag = query.tag;
                    }
                    if (query.filter) {
                        categoryFilters = [];
                        try {
                            ;
                            categoryFilters = ((ref2 = JSON.parse(query.filter)) === null || ref2 === void 0 ? void 0 : ref2.categoryFilters) || [];
                        } catch (e) {
                            categoryFilters = [];
                        }
                        combinedCategoryFilters = categoryFilters.filter(function(item) {
                            return item.isCombined;
                        }) || [];
                        categoryFilters = categoryFilters.filter(function(cat) {
                            var ref, ref1;
                            return cat.code !== ((ref = cat.categoryCodes) === null || ref === void 0 ? void 0 : ref[0]) || ((ref1 = cat.efficacyCodes) === null || ref1 === void 0 ? void 0 : ref1.length) > 0 || combinedCategoryFilters.every(function(item) {
                                var ref;
                                return !((ref = item.categoryCodes) === null || ref === void 0 ? void 0 : ref.includes(cat.code));
                            });
                        });
                        filter = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)({}, filter), {
                            categoryFilters: categoryFilters
                        });
                    }
                    sort = (query === null || query === void 0 ? void 0 : query.sort) || "";
                    page = Number((query === null || query === void 0 ? void 0 : query.page) - 1 || 0);
                    _tmp2 = {};
                    _tmp3 = {};
                    body = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(_tmp2, ctx.query), (_tmp3.text = (ctx === null || ctx === void 0 ? void 0 : (ref = ctx.query) === null || ref === void 0 ? void 0 : ref.q) || (ctx === null || ctx === void 0 ? void 0 : (ref1 = ctx.query) === null || ref1 === void 0 ? void 0 : ref1.text) || null, _tmp3.offset = page * constants_data__WEBPACK_IMPORTED_MODULE_4__/* .PAGE_SIZE_30 */ .AV, _tmp3.limit = limit, _tmp3.getTotal = true, _tmp3.filter = filter, _tmp3.sort = sort, _tmp3.searchStrategy = DEFAULT_SEARCH_STRATEGY, _tmp3));
                    if (isGetBodyOnly) return [
                        2,
                        body
                    ];
                    _tmp4 = {};
                    return [
                        4,
                        clients__WEBPACK_IMPORTED_MODULE_0__/* .ProductClientV2.getFuzzySearchClient */ .j4.getFuzzySearchClient((_tmp4.ctx = ctx, _tmp4.body = body, _tmp4))
                    ];
                case 4:
                    result = _state.sent();
                    if (!(0,clients__WEBPACK_IMPORTED_MODULE_0__/* .isValid */ .JY)(result)) return [
                        2,
                        result
                    ];
                    _tmp5 = {};
                    return [
                        2,
                        mapDataProduct((_tmp5.ctx = ctx, _tmp5.result = result, _tmp5))
                    ];
            }
        });
    });
    return function loadDataProduct(_) {
        return _ref.apply(this, arguments);
    };
}();
// TODO:
var loadDataProductWeb = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(param) {
        var query, _filter, filter, isGetBodyOnly, _tmp, formatQueryProvinceCode, categoryFilters, ref, combinedCategoryFilters, sort, page, searchType, searchStrategy, _tmp1, body, _tmp2, _tmp3, result, _tmp4, _tmp5;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    query = param.query, _filter = param.filter, filter = _filter === void 0 ? _tmp : _filter, isGetBodyOnly = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : false;
                    // check currentTab -> filter
                    if (query.tag) {
                        if (query.tag === "DOCQUYENGIATOT" && query.provinceCode !== undefined) {
                            formatQueryProvinceCode = "PROVINCE_".concat(query.provinceCode);
                            // eslint-disable-next-line no-param-reassign
                            filter.tags = [
                                query.tag,
                                formatQueryProvinceCode
                            ];
                        } else {
                            // eslint-disable-next-line no-param-reassign
                            filter.tag = query.tag;
                        }
                    }
                    if (query.manufacturer) {
                        // eslint-disable-next-line no-param-reassign
                        filter.manufacturer = query.manufacturer;
                    }
                    if (query.category) {
                        // eslint-disable-next-line no-param-reassign
                        filter.category = query.category;
                    }
                    if (query.ingredient) {
                        // eslint-disable-next-line no-param-reassign
                        filter.ingredient = query.ingredient;
                    }
                    if (query.filter) {
                        categoryFilters = [];
                        try {
                            ;
                            categoryFilters = ((ref = JSON.parse(query.filter)) === null || ref === void 0 ? void 0 : ref.categoryFilters) || [];
                        } catch (e) {
                            categoryFilters = [];
                        }
                        combinedCategoryFilters = categoryFilters.filter(function(item) {
                            return item.isCombined;
                        }) || [];
                        categoryFilters = categoryFilters.filter(function(cat) {
                            var ref, ref1;
                            return cat.code !== ((ref = cat.categoryCodes) === null || ref === void 0 ? void 0 : ref[0]) || ((ref1 = cat.efficacyCodes) === null || ref1 === void 0 ? void 0 : ref1.length) > 0 || combinedCategoryFilters.every(function(item) {
                                var ref;
                                return !((ref = item.categoryCodes) === null || ref === void 0 ? void 0 : ref.includes(cat.code));
                            });
                        });
                        // eslint-disable-next-line no-param-reassign
                        filter = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)({}, filter), {
                            categoryFilters: categoryFilters
                        });
                    }
                    sort = (query === null || query === void 0 ? void 0 : query.sort) || "";
                    page = Number((query === null || query === void 0 ? void 0 : query.page) - 1 || 0);
                    searchType = Number((query === null || query === void 0 ? void 0 : query.searchType) || constants_data__WEBPACK_IMPORTED_MODULE_4__/* .THUOC_VA_HOAT_CHAT */ .K_);
                    _tmp1 = {};
                    searchStrategy = (_tmp1.text = true, _tmp1.keyword = true, _tmp1.ingredient = searchType === constants_data__WEBPACK_IMPORTED_MODULE_4__/* .THUOC_VA_HOAT_CHAT */ .K_, _tmp1);
                    _tmp2 = {};
                    _tmp3 = {};
                    body = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(_tmp2, query), (_tmp3.text = (query === null || query === void 0 ? void 0 : query.q) || (query === null || query === void 0 ? void 0 : query.text) || null, _tmp3.offset = page * constants_data__WEBPACK_IMPORTED_MODULE_4__/* .PAGE_SIZE_30 */ .AV, _tmp3.limit = constants_data__WEBPACK_IMPORTED_MODULE_4__/* .PAGE_SIZE_30 */ .AV, _tmp3.getTotal = true, _tmp3.filter = filter, _tmp3.sort = sort, _tmp3.isAvailable = (query === null || query === void 0 ? void 0 : query.isAvailable) === "true", _tmp3.searchStrategy = searchStrategy, _tmp3));
                    if (isGetBodyOnly) return [
                        2,
                        body
                    ];
                    _tmp4 = {};
                    return [
                        4,
                        clients__WEBPACK_IMPORTED_MODULE_0__/* .ProductClientV2.getFuzzySearchClient */ .j4.getFuzzySearchClient((_tmp4.body = body, _tmp4))
                    ];
                case 1:
                    result = _state.sent();
                    // const result = await POST({ url: FUZZY_SEARCH, body });
                    if (!(0,clients__WEBPACK_IMPORTED_MODULE_0__/* .isValid */ .JY)(result)) return [
                        2,
                        result
                    ];
                    _tmp5 = {};
                    return [
                        2,
                        mapDataProduct((_tmp5.result = result, _tmp5.isProductCard = true, _tmp5))
                    ];
            }
        });
    });
    return function loadDataProductWeb(_) {
        return _ref.apply(this, arguments);
    };
}();
// Mobile V2 Product
// export const loadDataProductMobile = async ({ ctx }) => {
//   const { query } = ctx;
//   const page = Number(query?.page - 1 || 0);
//   const sort = query?.sort || '';
//   const cat = query.category;
//   const filter = {};
//   // check currentTab -> filter
//   await checkCurrentTab({ ctx, filter });
//   // check tag
//   if (query.tag) {
//     filter.tag = query.tag;
//   }
//   if (cat) {
//     filter.category = cat;
//   }
//   if (query.manufacturer) {
//     filter.manufacturer = query.manufacturer;
//   }
//   const body = {
//     ...ctx.query,
//     text: ctx?.query?.q || ctx?.query?.text || null,
//     offset: page * PAGE_SIZE_30,
//     limit: PAGE_SIZE_30,
//     getTotal: true,
//     filter,
//     sort,
//     searchStrategy: DEFAULT_SEARCH_STRATEGY,
//     // allSku: true,
//   };
//   // const result = await POST({ url: FUZZY_SEARCH, body, ctx });
//   const result = await ProductClientV2.getFuzzySearchClient({ ctx, body });
//   if (!isValid(result)) return result;
//   return mapDataProduct({ ctx, result });
// };
var loadDataProductMobileClient = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(param) {
        var _page, page, query, _isEmptySearch, isEmptySearch, filter, _tmp, defaultQuerySearch, formatQueryProvinceCode, sort, searchPage, searchType, searchStrategy, _tmp1, searchText, body, _tmp2, _tmp3, result, _tmp4, _tmp5;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _page = param.page, page = _page === void 0 ? 1 : _page, query = param.query, _isEmptySearch = param.isEmptySearch, isEmptySearch = _isEmptySearch === void 0 ? false : _isEmptySearch;
                    _tmp = {};
                    filter = _tmp;
                    defaultQuerySearch = "";
                    // check currentTab -> filter
                    if (query.tag) {
                        if (query.tag === "DOCQUYENGIATOT" && query.provinceCode !== undefined) {
                            formatQueryProvinceCode = "PROVINCE_".concat(query.provinceCode);
                            // eslint-disable-next-line no-param-reassign
                            filter.tags = [
                                query.tag,
                                formatQueryProvinceCode
                            ];
                        } else {
                            // eslint-disable-next-line no-param-reassign
                            filter.tag = query.tag;
                        }
                    }
                    if (query.category) {
                        filter.category = query.category;
                    }
                    if (query.manufacturer) {
                        filter.manufacturer = query.manufacturer;
                    }
                    sort = (query === null || query === void 0 ? void 0 : query.sort) || "";
                    searchPage = Number(page) || Number(query === null || query === void 0 ? void 0 : query.page) || 1;
                    searchType = Number((query === null || query === void 0 ? void 0 : query.searchType) || constants_data__WEBPACK_IMPORTED_MODULE_4__/* .THUOC_VA_HOAT_CHAT */ .K_);
                    _tmp1 = {};
                    searchStrategy = (_tmp1.text = true, _tmp1.keyword = true, _tmp1.ingredient = searchType === constants_data__WEBPACK_IMPORTED_MODULE_4__/* .THUOC_VA_HOAT_CHAT */ .K_, _tmp1);
                    searchText = isEmptySearch ? defaultQuerySearch : (query === null || query === void 0 ? void 0 : query.q) || (query === null || query === void 0 ? void 0 : query.text);
                    _tmp2 = {};
                    _tmp3 = {};
                    body = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(_tmp2, query), (_tmp3.page = searchPage, _tmp3.text = searchText, _tmp3.offset = (searchPage - 1) * constants_data__WEBPACK_IMPORTED_MODULE_4__/* .PAGE_SIZE */ .IV, _tmp3.limit = constants_data__WEBPACK_IMPORTED_MODULE_4__/* .PAGE_SIZE */ .IV, _tmp3.getTotal = true, _tmp3.getPrice = true, _tmp3.filter = filter, _tmp3.sort = sort, _tmp3.isAvailable = (query === null || query === void 0 ? void 0 : query.isAvailable) === "true", _tmp3.searchStrategy = searchStrategy, _tmp3));
                    _tmp4 = {};
                    return [
                        4,
                        clients__WEBPACK_IMPORTED_MODULE_0__/* .ProductClientV2.getFuzzySearchBffClient */ .j4.getFuzzySearchBffClient((_tmp4.body = body, _tmp4))
                    ];
                case 1:
                    result = _state.sent();
                    if (!(0,clients__WEBPACK_IMPORTED_MODULE_0__/* .isValid */ .JY)(result)) return [
                        2,
                        result
                    ];
                    _tmp5 = {};
                    return [
                        2,
                        mapDataProduct((_tmp5.result = result, _tmp5))
                    ];
            }
        });
    });
    return function loadDataProductMobileClient(_) {
        return _ref.apply(this, arguments);
    };
}();
var loadDataProductMobileServer = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(param) {
        var ctx, _page, page, query, _isEmptySearch, isEmptySearch, filter, _tmp, defaultQuerySearch, sort, searchPage, searchType, searchStrategy, _tmp1, searchText, body, _tmp2, _tmp3, result, _tmp4, _tmp5;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ctx = param.ctx, _page = param.page, page = _page === void 0 ? 1 : _page, query = param.query, _isEmptySearch = param.isEmptySearch, isEmptySearch = _isEmptySearch === void 0 ? false : _isEmptySearch;
                    _tmp = {};
                    filter = _tmp;
                    defaultQuerySearch = "";
                    // check currentTab -> filter
                    if (query.tag) {
                        filter.tag = query.tag;
                    }
                    if (query.category) {
                        filter.category = query.category;
                    }
                    if (query.manufacturer) {
                        filter.manufacturer = query.manufacturer;
                    }
                    sort = (query === null || query === void 0 ? void 0 : query.sort) || "";
                    searchPage = Number(page) || Number(query === null || query === void 0 ? void 0 : query.page) || 1;
                    searchType = Number((query === null || query === void 0 ? void 0 : query.searchType) || constants_data__WEBPACK_IMPORTED_MODULE_4__/* .THUOC_VA_HOAT_CHAT */ .K_);
                    _tmp1 = {};
                    searchStrategy = (_tmp1.text = true, _tmp1.keyword = true, _tmp1.ingredient = searchType === constants_data__WEBPACK_IMPORTED_MODULE_4__/* .THUOC_VA_HOAT_CHAT */ .K_, _tmp1);
                    searchText = isEmptySearch ? defaultQuerySearch : (query === null || query === void 0 ? void 0 : query.q) || (query === null || query === void 0 ? void 0 : query.text);
                    _tmp2 = {};
                    _tmp3 = {};
                    body = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(_tmp2, query), (_tmp3.page = searchPage, _tmp3.text = searchText, _tmp3.offset = (searchPage - 1) * constants_data__WEBPACK_IMPORTED_MODULE_4__/* .PAGE_SIZE */ .IV, _tmp3.limit = constants_data__WEBPACK_IMPORTED_MODULE_4__/* .PAGE_SIZE */ .IV, _tmp3.getTotal = true, _tmp3.getPrice = true, _tmp3.filter = filter, _tmp3.sort = sort, _tmp3.isAvailable = (query === null || query === void 0 ? void 0 : query.isAvailable) === "true", _tmp3.searchStrategy = searchStrategy, _tmp3));
                    _tmp4 = {};
                    return [
                        4,
                        clients__WEBPACK_IMPORTED_MODULE_0__/* .ProductClientV2.getFuzzySearchClient */ .j4.getFuzzySearchClient((_tmp4.ctx = ctx, _tmp4.body = body, _tmp4))
                    ];
                case 1:
                    result = _state.sent();
                    if (!(0,clients__WEBPACK_IMPORTED_MODULE_0__/* .isValid */ .JY)(result)) return [
                        2,
                        result
                    ];
                    _tmp5 = {};
                    return [
                        2,
                        mapDataProduct((_tmp5.result = result, _tmp5))
                    ];
            }
        });
    });
    return function loadDataProductMobileServer(_) {
        return _ref.apply(this, arguments);
    };
}();
var loadProductFuzzy = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(_param) {
        var ctx, offset, _limit, limit, filter, _text, text, _sort, sort, _isUseRawData, isUseRawData, params, body, _tmp, result, _tmp1, mappedData, _tmp2, _tmp3;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ctx = _param.ctx, offset = _param.offset, _limit = _param.limit, limit = _limit === void 0 ? constants_data__WEBPACK_IMPORTED_MODULE_4__/* .PAGE_SIZE_30 */ .AV : _limit, filter = _param.filter, _text = _param.text, text = _text === void 0 ? "" : _text, _sort = _param.sort, sort = _sort === void 0 ? "" : _sort, _isUseRawData = _param.isUseRawData, isUseRawData = _isUseRawData === void 0 ? false : _isUseRawData, params = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(_param, [
                        "ctx",
                        "offset",
                        "limit",
                        "filter",
                        "text",
                        "sort",
                        "isUseRawData"
                    ]);
                    _tmp = {};
                    body = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)((_tmp.text = text, _tmp.offset = offset, _tmp.limit = limit, _tmp.getTotal = true, _tmp.sort = sort, _tmp.filter = filter, _tmp.searchStrategy = DEFAULT_SEARCH_STRATEGY, _tmp), params);
                    _tmp1 = {};
                    return [
                        4,
                        clients__WEBPACK_IMPORTED_MODULE_0__/* .ProductClientV2.getFuzzySearchClient */ .j4.getFuzzySearchClient((_tmp1.ctx = ctx, _tmp1.body = body, _tmp1))
                    ];
                case 1:
                    result = _state.sent();
                    if (isUseRawData) return [
                        2,
                        result
                    ];
                    _tmp2 = {};
                    return [
                        4,
                        mapDataProduct((_tmp2.ctx = ctx, _tmp2.result = result, _tmp2))
                    ];
                case 2:
                    mappedData = _state.sent();
                    _tmp3 = {};
                    // const result = await POST({ url, ctx, body });
                    return [
                        2,
                        (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(_tmp3, mappedData)
                    ];
            }
        });
    });
    return function loadProductFuzzy(_param) {
        return _ref.apply(this, arguments);
    };
}();
var loadProductWithFilter = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(param) {
        var ctx, offset, _limit, limit, filter, _text, text, _sort, sort, isGetBodyOnly, body, _tmp, result, _tmp1, _tmp2;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ctx = param.ctx, offset = param.offset, _limit = param.limit, limit = _limit === void 0 ? constants_data__WEBPACK_IMPORTED_MODULE_4__/* .PAGE_SIZE_30 */ .AV : _limit, filter = param.filter, _text = param.text, text = _text === void 0 ? "" : _text, _sort = param.sort, sort = _sort === void 0 ? "" : _sort, isGetBodyOnly = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : false;
                    _tmp = {};
                    body = (_tmp.text = text, _tmp.offset = offset, _tmp.limit = limit, _tmp.getTotal = true, _tmp.sort = sort, _tmp.filter = filter, _tmp.searchStrategy = DEFAULT_SEARCH_STRATEGY, _tmp);
                    if (isGetBodyOnly) return [
                        2,
                        body
                    ];
                    _tmp1 = {};
                    return [
                        4,
                        clients__WEBPACK_IMPORTED_MODULE_0__/* .ProductClientV2.getFuzzySearchClient */ .j4.getFuzzySearchClient((_tmp1.ctx = ctx, _tmp1.body = body, _tmp1.isBasic = true, _tmp1))
                    ];
                case 1:
                    result = _state.sent();
                    if (!(0,clients__WEBPACK_IMPORTED_MODULE_0__/* .isValid */ .JY)(result)) return [
                        2,
                        result
                    ];
                    _tmp2 = {};
                    return [
                        2,
                        mapDataProduct((_tmp2.ctx = ctx, _tmp2.result = result, _tmp2))
                    ];
            }
        });
    });
    return function loadProductWithFilter(_) {
        return _ref.apply(this, arguments);
    };
}();
var loadProductWithTag = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(_param) {
        var ctx, slug, offset, params, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
            ctx = _param.ctx, slug = _param.slug, offset = _param.offset, params = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(_param, [
                "ctx",
                "slug",
                "offset"
            ]);
            _tmp = {};
            return [
                2,
                loadProductWithFilter((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)((_tmp.ctx = ctx, _tmp.offset = offset, _tmp.filter = {
                    tag: slug
                }, _tmp), params))
            ];
        });
    });
    return function loadProductWithTag(_param) {
        return _ref.apply(this, arguments);
    };
}();
var loadProductWithIngredient = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(param) {
        var ctx, code, offset, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
            ctx = param.ctx, code = param.code, offset = param.offset;
            _tmp = {};
            return [
                2,
                loadProductWithFilter((_tmp.ctx = ctx, _tmp.offset = offset, _tmp.filter = {
                    ingredient: code
                }, _tmp))
            ];
        });
    });
    return function loadProductWithIngredient(_) {
        return _ref.apply(this, arguments);
    };
}();
var loadProductWithSeller = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(_param) {
        var isGetBodyOnly, ctx, code, offset, params, _tmp;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
            isGetBodyOnly = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : false;
            ctx = _param.ctx, code = _param.code, offset = _param.offset, params = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(_param, [
                "ctx",
                "code",
                "offset"
            ]);
            _tmp = {};
            return [
                2,
                loadProductWithFilter((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)((_tmp.ctx = ctx, _tmp.offset = offset, _tmp.filter = {
                    seller: code
                }, _tmp), params), isGetBodyOnly)
            ];
        });
    });
    return function loadProductWithSeller(_param) {
        return _ref.apply(this, arguments);
    };
}();
var loadProductByManufacturer = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(_param) {
        var isGetBodyOnly, ctx, code, offset, params, _tmp;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
            isGetBodyOnly = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : false;
            ctx = _param.ctx, code = _param.code, offset = _param.offset, params = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(_param, [
                "ctx",
                "code",
                "offset"
            ]);
            _tmp = {};
            return [
                2,
                loadProductWithFilter((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)((_tmp.ctx = ctx, _tmp.offset = offset, _tmp.filter = {
                    manufacturer: code
                }, _tmp), params), isGetBodyOnly)
            ];
        });
    });
    return function loadProductByManufacturer(_param) {
        return _ref.apply(this, arguments);
    };
}();
function loadProductWithCategory(_) {
    return _loadProductWithCategory.apply(this, arguments);
}
function _loadProductWithCategory() {
    _loadProductWithCategory = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(param) {
        var ctx, ref, query, page, sort, catInfo, cat, filter, _tmp, _tmp1, _tmp2;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ctx = param.ctx;
                    query = ctx.query;
                    page = Number((query === null || query === void 0 ? void 0 : query.page) - 1 || 0);
                    sort = (query === null || query === void 0 ? void 0 : query.sort) || "";
                    return [
                        4,
                        clients_CatClientV2__WEBPACK_IMPORTED_MODULE_1__/* ["default"].loadCategoryInfoBySlug */ .Z.loadCategoryInfoBySlug(ctx)
                    ];
                case 1:
                    catInfo = _state.sent();
                    cat = (catInfo === null || catInfo === void 0 ? void 0 : (ref = catInfo[0]) === null || ref === void 0 ? void 0 : ref.code) || "";
                    _tmp = {};
                    filter = _tmp;
                    _tmp1 = {};
                    // check currentTab -> filter
                    return [
                        4,
                        checkCurrentTab((_tmp1.ctx = ctx, _tmp1.filter = filter, _tmp1))
                    ];
                case 2:
                    _state.sent();
                    // end
                    if (cat) {
                        filter.category = cat;
                    }
                    _tmp2 = {};
                    return [
                        2,
                        loadProductWithFilter((_tmp2.ctx = ctx, _tmp2.offset = page * constants_data__WEBPACK_IMPORTED_MODULE_4__/* .PAGE_SIZE_30 */ .AV, _tmp2.sort = sort, _tmp2.filter = filter, _tmp2))
                    ];
            }
        });
    });
    return _loadProductWithCategory.apply(this, arguments);
}
function loadProductWithManufacturer(_) {
    return _loadProductWithManufacturer.apply(this, arguments);
}
function _loadProductWithManufacturer() {
    _loadProductWithManufacturer = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(param) {
        var ctx, ref, query, page, sort, manufacturerInfo, manufacturer, filter, _tmp, _tmp1, _tmp2;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ctx = param.ctx;
                    query = ctx.query;
                    page = Number((query === null || query === void 0 ? void 0 : query.page) - 1 || 0);
                    sort = (query === null || query === void 0 ? void 0 : query.sort) || "";
                    return [
                        4,
                        clients_CatClientV2__WEBPACK_IMPORTED_MODULE_1__/* ["default"].loadManufacturerInfoBySlug */ .Z.loadManufacturerInfoBySlug(ctx)
                    ];
                case 1:
                    manufacturerInfo = _state.sent();
                    manufacturer = (manufacturerInfo === null || manufacturerInfo === void 0 ? void 0 : (ref = manufacturerInfo[0]) === null || ref === void 0 ? void 0 : ref.code) || "";
                    _tmp = {};
                    filter = _tmp;
                    try {
                        filter = JSON.parse(query.filter || "{}");
                    } catch (e) {
                        filter = {};
                    }
                    _tmp1 = {};
                    // check currentTab -> filter
                    return [
                        4,
                        checkCurrentTab((_tmp1.ctx = ctx, _tmp1.filter = filter, _tmp1))
                    ];
                case 2:
                    _state.sent();
                    // end
                    if (manufacturer) {
                        filter.manufacturer = manufacturer;
                    }
                    _tmp2 = {};
                    return [
                        2,
                        loadProductWithFilter((_tmp2.ctx = ctx, _tmp2.offset = page * constants_data__WEBPACK_IMPORTED_MODULE_4__/* .PAGE_SIZE_30 */ .AV, _tmp2.sort = sort, _tmp2.filter = filter, _tmp2))
                    ];
            }
        });
    });
    return _loadProductWithManufacturer.apply(this, arguments);
}
var LIMIT = 50;
var getProductInfoFromSkus = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(param) {
        var ctx, skus, _useCache, useCache, _getPrice, getPrice, customerLevel, locationCode, customerId, body, _tmp, skuListArray, i, userInfo, ref, level, provinceCode, id, _tmp1, responses, mapLimitSkus, _tmp2, responsesLimitSkus, listSkusLimited, mapSkuPurchased, _tmp3, responseSkuHistory, _tmp4, ref1, newData, _tmp5;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ctx = param.ctx, skus = param.skus, _useCache = param.useCache, useCache = _useCache === void 0 ? true : _useCache, _getPrice = param.getPrice, getPrice = _getPrice === void 0 ? true : _getPrice, customerLevel = param.customerLevel, locationCode = param.locationCode, customerId = param.customerId;
                    _tmp = {};
                    body = (_tmp.ctx = ctx, _tmp.limit = LIMIT, _tmp.useCache = useCache, _tmp.getPrice = getPrice, _tmp);
                    skuListArray = [];
                    for(i = 0; i < skus.length; i += LIMIT){
                        skuListArray.push(skus.slice(i, i + LIMIT));
                    }
                    if (!getPrice) return [
                        3,
                        3
                    ];
                    if (!(!customerLevel || !locationCode)) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        (0,_UserService__WEBPACK_IMPORTED_MODULE_14__/* .getAccount */ .D0)(ctx)
                    ];
                case 1:
                    userInfo = _state.sent();
                    _tmp1 = {};
                    ref = (0,clients__WEBPACK_IMPORTED_MODULE_0__/* .getFirst */ .Xi)(userInfo, _tmp1), level = ref.level, provinceCode = ref.provinceCode, id = ref.customerID;
                    body.customerLevel = level;
                    body.locationCode = provinceCode;
                    body.customerId = id;
                    return [
                        3,
                        3
                    ];
                case 2:
                    body.customerLevel = customerLevel;
                    body.locationCode = locationCode;
                    body.customerId = customerId;
                    _state.label = 3;
                case 3:
                    return [
                        4,
                        Promise.all(skuListArray.map(function(codes) {
                            return (0,clients_ProductClientV2__WEBPACK_IMPORTED_MODULE_2__/* .getProducts */ .Xp)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)({}, body), {
                                codes: codes
                            }));
                        }))
                    ];
                case 4:
                    responses = _state.sent();
                    _tmp2 = {};
                    mapLimitSkus = _tmp2;
                    return [
                        4,
                        Promise.all(skuListArray.map(function(codes) {
                            return clients__WEBPACK_IMPORTED_MODULE_0__/* .ProductClientV2.getSkusLimit */ .j4.getSkusLimit({
                                ctx: ctx,
                                skuCodes: codes
                            });
                        }))
                    ];
                case 5:
                    responsesLimitSkus = _state.sent();
                    listSkusLimited = [];
                    responsesLimitSkus.forEach(function(param) {
                        var data = param.data;
                        var ref;
                        (ref = data === null || data === void 0 ? void 0 : data.filter(function(item) {
                            return item === null || item === void 0 ? void 0 : item.isActive;
                        })) === null || ref === void 0 ? void 0 : ref.forEach(function(skuLimit) {
                            mapLimitSkus[skuLimit.itemCode] = skuLimit;
                            listSkusLimited.push(skuLimit.sku);
                        });
                    });
                    _tmp3 = {};
                    mapSkuPurchased = _tmp3;
                    if (!(listSkusLimited.length > 0)) return [
                        3,
                        7
                    ];
                    _tmp4 = {};
                    return [
                        4,
                        clients__WEBPACK_IMPORTED_MODULE_0__/* .ProductClientV2.getSkusBuyed */ .j4.getSkusBuyed((_tmp4.ctx = ctx, _tmp4.skuCodes = listSkusLimited, _tmp4))
                    ];
                case 6:
                    responseSkuHistory = _state.sent();
                    if ((0,clients__WEBPACK_IMPORTED_MODULE_0__/* .isValid */ .JY)(responseSkuHistory)) {
                        ;
                        (ref1 = (0,clients__WEBPACK_IMPORTED_MODULE_0__/* .getData */ .Yu)(responseSkuHistory)) === null || ref1 === void 0 ? void 0 : ref1.forEach(function(item) {
                            mapSkuPurchased[item.itemCode] = item;
                        });
                    }
                    _state.label = 7;
                case 7:
                    newData = [];
                    responses.forEach(function(param) {
                        var data = param.data;
                        data === null || data === void 0 ? void 0 : data.forEach(function(product) {
                            var ref, ref1;
                            var sku = product === null || product === void 0 ? void 0 : (ref = product.sku) === null || ref === void 0 ? void 0 : ref.itemCode;
                            var limitSku = mapLimitSkus[sku] || {};
                            newData.push(convertProductV2((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)({}, product), {
                                limitPerDay: (limitSku === null || limitSku === void 0 ? void 0 : limitSku.quantity) || 0,
                                quantityPurchasedToday: ((ref1 = mapSkuPurchased[sku]) === null || ref1 === void 0 ? void 0 : ref1.quantity) || 0
                            })));
                        });
                    });
                    _tmp5 = {};
                    return [
                        2,
                        (_tmp5.status = constants_Enums__WEBPACK_IMPORTED_MODULE_5__/* .HTTP_STATUS.Ok */ .MG.Ok, _tmp5.data = newData, _tmp5)
                    ];
            }
        });
    });
    return function getProductInfoFromSkus(_) {
        return _ref.apply(this, arguments);
    };
}();
var getProductInfoFromSkusForSeller = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(param) {
        var ctx, skus, _useCache, useCache, _getPrice, getPrice, customerLevel, locationCode, customerId, body, _tmp, skuListArray, i, userInfo, ref, level, provinceCode, id, _tmp1, responses, newData, cartObject, cartRes, cart, _tmp2;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ctx = param.ctx, skus = param.skus, _useCache = param.useCache, useCache = _useCache === void 0 ? true : _useCache, _getPrice = param.getPrice, getPrice = _getPrice === void 0 ? true : _getPrice, customerLevel = param.customerLevel, locationCode = param.locationCode, customerId = param.customerId;
                    _tmp = {};
                    body = (_tmp.ctx = ctx, _tmp.limit = LIMIT, _tmp.useCache = useCache, _tmp.getPrice = getPrice, _tmp);
                    skuListArray = [];
                    for(i = 0; i < skus.length; i += LIMIT){
                        skuListArray.push(skus.slice(i, i + LIMIT));
                    }
                    if (!getPrice) return [
                        3,
                        3
                    ];
                    if (!(!customerLevel || !locationCode)) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        (0,_UserService__WEBPACK_IMPORTED_MODULE_14__/* .getAccount */ .D0)(ctx)
                    ];
                case 1:
                    userInfo = _state.sent();
                    _tmp1 = {};
                    ref = (0,clients__WEBPACK_IMPORTED_MODULE_0__/* .getFirst */ .Xi)(userInfo, _tmp1), level = ref.level, provinceCode = ref.provinceCode, id = ref.customerID;
                    body.customerLevel = level;
                    body.locationCode = provinceCode;
                    body.customerId = id;
                    return [
                        3,
                        3
                    ];
                case 2:
                    body.customerLevel = customerLevel;
                    body.locationCode = locationCode;
                    body.customerId = customerId;
                    _state.label = 3;
                case 3:
                    return [
                        4,
                        Promise.all(skuListArray.map(function(codes) {
                            return (0,clients_ProductClientV2__WEBPACK_IMPORTED_MODULE_2__/* .getProducts */ .Xp)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)({}, body), {
                                codes: codes
                            }));
                        }))
                    ];
                case 4:
                    responses = _state.sent();
                    newData = [];
                    cartObject = new Map();
                    return [
                        4,
                        clients__WEBPACK_IMPORTED_MODULE_0__/* .CartClientV2.loadDataCart */ .HP.loadDataCart(ctx)
                    ];
                case 5:
                    cartRes = _state.sent();
                    if ((0,clients__WEBPACK_IMPORTED_MODULE_0__/* .isValid */ .JY)(cartRes)) {
                        cart = cartRes.data[0];
                        if (cart && !(0,utils_ValidateUtils__WEBPACK_IMPORTED_MODULE_13__/* .isEmpty */ .xb)(cart.cartItems)) {
                            cartObject = (0,utils_ArrUtils__WEBPACK_IMPORTED_MODULE_8__/* .convertArrayToMap */ .lE)(cart.cartItems, "sku");
                        }
                    }
                    responses.forEach(function(param) {
                        var data = param.data;
                        data === null || data === void 0 ? void 0 : data.forEach(function(product) {
                            var ref, ref1;
                            newData.push((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)({}, convertProductV2(product)), {
                                quantity: ((ref1 = cartObject.get(product === null || product === void 0 ? void 0 : (ref = product.sku) === null || ref === void 0 ? void 0 : ref.code)) === null || ref1 === void 0 ? void 0 : ref1.quantity) || 0
                            }));
                        });
                    });
                    _tmp2 = {};
                    return [
                        2,
                        (_tmp2.status = constants_Enums__WEBPACK_IMPORTED_MODULE_5__/* .HTTP_STATUS.Ok */ .MG.Ok, _tmp2.data = newData, _tmp2)
                    ];
            }
        });
    });
    return function getProductInfoFromSkusForSeller(_) {
        return _ref.apply(this, arguments);
    };
}();
var getProductInfoMapFromSkus = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(param) {
        var ctx, skus, _useCache, useCache, _getPrice, getPrice, customerLevel, locationCode, customerID, body, _tmp, skuListArray, i, userInfo, ref, level, provinceCode, id, _tmp1, mapProducts, _tmp2, responses, mapLimitSkus, _tmp3, responsesLimitSkus, listSkusLimited, mapSkuPurchased, _tmp4, responseSkuHistory, _tmp5, ref1, _tmp6;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ctx = param.ctx, skus = param.skus, _useCache = param.useCache, useCache = _useCache === void 0 ? true : _useCache, _getPrice = param.getPrice, getPrice = _getPrice === void 0 ? true : _getPrice, customerLevel = param.customerLevel, locationCode = param.locationCode, customerID = param.customerID;
                    _tmp = {};
                    body = (_tmp.ctx = ctx, _tmp.limit = LIMIT, _tmp.useCache = useCache, _tmp.getPrice = getPrice, _tmp);
                    skuListArray = [];
                    for(i = 0; i < skus.length; i += LIMIT){
                        skuListArray.push(skus.slice(i, i + LIMIT));
                    }
                    if (!(!customerLevel || !locationCode)) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        (0,_UserService__WEBPACK_IMPORTED_MODULE_14__/* .getAccount */ .D0)(ctx)
                    ];
                case 1:
                    userInfo = _state.sent();
                    _tmp1 = {};
                    ref = (0,clients__WEBPACK_IMPORTED_MODULE_0__/* .getFirst */ .Xi)(userInfo, _tmp1), level = ref.level, provinceCode = ref.provinceCode, id = ref.customerID;
                    body.customerLevel = level;
                    body.locationCode = provinceCode;
                    body.customerId = id;
                    return [
                        3,
                        3
                    ];
                case 2:
                    body.customerLevel = customerLevel;
                    body.locationCode = locationCode;
                    body.customerId = customerID;
                    _state.label = 3;
                case 3:
                    _tmp2 = {};
                    mapProducts = _tmp2;
                    return [
                        4,
                        Promise.all(skuListArray.map(function(codes) {
                            return (0,clients_ProductClientV2__WEBPACK_IMPORTED_MODULE_2__/* .getProducts */ .Xp)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)({}, body), {
                                codes: codes
                            }));
                        }))
                    ];
                case 4:
                    responses = _state.sent();
                    _tmp3 = {};
                    mapLimitSkus = _tmp3;
                    return [
                        4,
                        Promise.all(skuListArray.map(function(codes) {
                            return clients__WEBPACK_IMPORTED_MODULE_0__/* .ProductClientV2.getSkusLimit */ .j4.getSkusLimit({
                                ctx: ctx,
                                skuCodes: codes
                            });
                        }))
                    ];
                case 5:
                    responsesLimitSkus = _state.sent();
                    listSkusLimited = [];
                    responsesLimitSkus.forEach(function(param) {
                        var data = param.data;
                        var ref;
                        (ref = data === null || data === void 0 ? void 0 : data.filter(function(item) {
                            return item.isActive;
                        })) === null || ref === void 0 ? void 0 : ref.forEach(function(skuLimit) {
                            mapLimitSkus[skuLimit.itemCode] = skuLimit;
                            listSkusLimited.push(skuLimit.sku);
                        });
                    });
                    _tmp4 = {};
                    mapSkuPurchased = _tmp4;
                    if (!(listSkusLimited.length > 0)) return [
                        3,
                        7
                    ];
                    _tmp5 = {};
                    return [
                        4,
                        clients__WEBPACK_IMPORTED_MODULE_0__/* .ProductClientV2.getSkusBuyed */ .j4.getSkusBuyed((_tmp5.ctx = ctx, _tmp5.skuCodes = listSkusLimited, _tmp5))
                    ];
                case 6:
                    responseSkuHistory = _state.sent();
                    if ((0,clients__WEBPACK_IMPORTED_MODULE_0__/* .isValid */ .JY)(responseSkuHistory)) {
                        ;
                        (ref1 = (0,clients__WEBPACK_IMPORTED_MODULE_0__/* .getData */ .Yu)(responseSkuHistory)) === null || ref1 === void 0 ? void 0 : ref1.forEach(function(item) {
                            mapSkuPurchased[item.itemCode] = item;
                        });
                    }
                    _state.label = 7;
                case 7:
                    responses.forEach(function(param) {
                        var data = param.data;
                        data === null || data === void 0 ? void 0 : data.forEach(function(product) {
                            var ref, ref1;
                            var sku = product === null || product === void 0 ? void 0 : (ref = product.sku) === null || ref === void 0 ? void 0 : ref.itemCode;
                            var info = convertProductV2((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)({}, product), {
                                limitPerDay: ((ref1 = mapLimitSkus[sku]) === null || ref1 === void 0 ? void 0 : ref1.quantity) || 0,
                                quantityPurchasedToday: mapSkuPurchased[sku] || 0,
                                campaign: product.campaign || {}
                            }));
                            mapProducts[info === null || info === void 0 ? void 0 : info.sku] = info;
                        });
                    });
                    _tmp6 = {};
                    return [
                        2,
                        (_tmp6.status = constants_Enums__WEBPACK_IMPORTED_MODULE_5__/* .HTTP_STATUS.Ok */ .MG.Ok, _tmp6.data = [
                            mapProducts
                        ], _tmp6)
                    ];
            }
        });
    });
    return function getProductInfoMapFromSkus(_) {
        return _ref.apply(this, arguments);
    };
}();
var loadDataProductDetail = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(param) {
        var ctx, query, params, _tmp, url, result, _tmp1, _tmp2;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ctx = param.ctx;
                    query = ctx.query;
                    _tmp = {};
                    params = (_tmp.q = convertSlug(query.slug), _tmp);
                    url = "/marketplace/product/v2/product/detail";
                    _tmp1 = {};
                    return [
                        4,
                        (0,clients__WEBPACK_IMPORTED_MODULE_0__/* .GET */ .HT)((_tmp1.url = url, _tmp1.ctx = ctx, _tmp1.isBasic = true, _tmp1.params = params, _tmp1))
                    ];
                case 1:
                    result = _state.sent();
                    if (!(0,clients__WEBPACK_IMPORTED_MODULE_0__/* .isValid */ .JY)(result)) return [
                        2,
                        result
                    ];
                    _tmp2 = {};
                    return [
                        2,
                        mapDataProduct((_tmp2.ctx = ctx, _tmp2.result = result, _tmp2))
                    ];
            }
        });
    });
    return function loadDataProductDetail(_) {
        return _ref.apply(this, arguments);
    };
}();
// export const loadDataProductDetailWithoutCTX = async ({ slug }) => {
//   const params = {
//     q: convertSlug(slug),
//   };
//   const url = `/marketplace/product/v2/product/detail`;
//   const result = await GET({
//     url,
//     isBasic: true,
//     params,
//   });
//   if (!isValid(result)) return result;
//   return mapDataProduct({ result });
// };
var getDataProductBySlug = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(param) {
        var ctx, slug, params, _tmp, url, result, _tmp1, _tmp2;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ctx = param.ctx, slug = param.slug;
                    _tmp = {};
                    params = (_tmp.q = convertSlug(slug), _tmp);
                    url = "/marketplace/product/v2/product/detail";
                    _tmp1 = {};
                    return [
                        4,
                        (0,clients__WEBPACK_IMPORTED_MODULE_0__/* .GET */ .HT)((_tmp1.url = url, _tmp1.ctx = ctx, _tmp1.isBasic = true, _tmp1.params = params, _tmp1))
                    ];
                case 1:
                    result = _state.sent();
                    if (!(0,clients__WEBPACK_IMPORTED_MODULE_0__/* .isValid */ .JY)(result)) return [
                        2,
                        result
                    ];
                    _tmp2 = {};
                    return [
                        2,
                        mapDataProduct((_tmp2.ctx = ctx, _tmp2.result = result, _tmp2))
                    ];
            }
        });
    });
    return function getDataProductBySlug(_) {
        return _ref.apply(this, arguments);
    };
}();
var getDataProductsBySlugs = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(param) {
        var ctx, slugs, _isBasic, isBasic, ref, url, results, result, _tmp, _tmp1;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ctx = param.ctx, slugs = param.slugs, _isBasic = param.isBasic, isBasic = _isBasic === void 0 ? true : _isBasic;
                    url = "/marketplace/product/v2/product/detail";
                    return [
                        4,
                        Promise.all(slugs.map(function(slug) {
                            var params = {
                                q: convertSlug(slug)
                            };
                            return (0,clients__WEBPACK_IMPORTED_MODULE_0__/* .GET */ .HT)({
                                url: url,
                                ctx: ctx,
                                isBasic: isBasic,
                                params: params
                            });
                        }))
                    ];
                case 1:
                    results = _state.sent();
                    _tmp = {};
                    result = (_tmp.status = constants_Enums__WEBPACK_IMPORTED_MODULE_5__/* .HTTP_STATUS.Ok */ .MG.Ok, _tmp.data = ((ref = results === null || results === void 0 ? void 0 : results.filter(function(res) {
                        return (0,clients__WEBPACK_IMPORTED_MODULE_0__/* .isValid */ .JY)(res);
                    })) === null || ref === void 0 ? void 0 : ref.map(function(productRes) {
                        return (0,clients__WEBPACK_IMPORTED_MODULE_0__/* .getFirst */ .Xi)(productRes);
                    })) || [], _tmp);
                    _tmp1 = {};
                    // filter isAvailable
                    return [
                        2,
                        mapDataProduct((_tmp1.ctx = ctx, _tmp1.result = result, _tmp1.isGetQuantity = false, _tmp1.isAvailable = true, _tmp1))
                    ];
            }
        });
    // return result;
    });
    return function getDataProductsBySlugs(_) {
        return _ref.apply(this, arguments);
    };
}();
var getSettingTags = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(param) {
        var ctx, params, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
            ctx = param.ctx, params = param.params;
            _tmp = {};
            return [
                2,
                clients__WEBPACK_IMPORTED_MODULE_0__/* .ProductClientV2.getSettingTags */ .j4.getSettingTags((_tmp.ctx = ctx, _tmp.params = params, _tmp.isBasic = true, _tmp))
            ];
        });
    });
    return function getSettingTags(_) {
        return _ref.apply(this, arguments);
    };
}();
var getTagNameFromIds = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(param) {
        var params, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
            params = param.params;
            _tmp = {};
            return [
                2,
                clients__WEBPACK_IMPORTED_MODULE_0__/* .ProductClientV2.getTagNameFromIds */ .j4.getTagNameFromIds((_tmp.params = params, _tmp))
            ];
        });
    });
    return function getTagNameFromIds(_) {
        return _ref.apply(this, arguments);
    };
}();
var getDeals = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(param) {
        var ctx, _sellerCode, sellerCode, isGetBodyOnly, query, page, body, _tmp, ref, result, _tmp1, deals, _tmp2, now, data, _tmp3, _tmp4;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ctx = param.ctx, _sellerCode = param.sellerCode, sellerCode = _sellerCode === void 0 ? "" : _sellerCode, isGetBodyOnly = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : false;
                    query = ctx.query;
                    page = Number((query === null || query === void 0 ? void 0 : query.page) - 1 || 0);
                    _tmp = {};
                    body = _tmp;
                    if (sellerCode) {
                        body = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)({}, ctx.query), {
                            offset: page * constants_data__WEBPACK_IMPORTED_MODULE_4__/* .PAGE_SIZE_30 */ .AV,
                            limit: constants_data__WEBPACK_IMPORTED_MODULE_4__/* .PAGE_SIZE_30 */ .AV,
                            getTotal: true,
                            getDealOnly: true,
                            filter: {
                                sellers: [
                                    sellerCode
                                ]
                            },
                            text: ""
                        });
                    } else {
                        ;
                        body = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)({}, ctx.query), {
                            text: (ctx === null || ctx === void 0 ? void 0 : (ref = ctx.query) === null || ref === void 0 ? void 0 : ref.q) || null,
                            offset: page * constants_data__WEBPACK_IMPORTED_MODULE_4__/* .PAGE_SIZE_30 */ .AV,
                            limit: constants_data__WEBPACK_IMPORTED_MODULE_4__/* .PAGE_SIZE_30 */ .AV,
                            getTotal: true,
                            getDealOnly: true
                        });
                    }
                    body.searchStrategy = DEFAULT_SEARCH_STRATEGY;
                    if (isGetBodyOnly) return [
                        2,
                        body
                    ];
                    _tmp1 = {};
                    return [
                        4,
                        clients__WEBPACK_IMPORTED_MODULE_0__/* .ProductClientV2.getFuzzySearchClient */ .j4.getFuzzySearchClient((_tmp1.ctx = ctx, _tmp1.body = body, _tmp1.isBasic = true, _tmp1))
                    ];
                case 1:
                    result = _state.sent();
                    if (!(0,clients__WEBPACK_IMPORTED_MODULE_0__/* .isValid */ .JY)(result)) return [
                        2,
                        result
                    ];
                    _tmp2 = {};
                    return [
                        4,
                        mapDataProduct((_tmp2.ctx = ctx, _tmp2.result = result, _tmp2))
                    ];
                case 2:
                    deals = _state.sent();
                    now = new Date();
                    data = (0,clients__WEBPACK_IMPORTED_MODULE_0__/* .getData */ .Yu)(deals, []).filter(function(item) {
                        var ref;
                        return new Date((item === null || item === void 0 ? void 0 : (ref = item.deal) === null || ref === void 0 ? void 0 : ref.readyTime) || 0) < now;
                    });
                    _tmp3 = {};
                    _tmp4 = {};
                    return [
                        2,
                        (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(_tmp3, deals), (_tmp4.data = data, _tmp4))
                    ];
            }
        });
    });
    return function getDeals(_) {
        return _ref.apply(this, arguments);
    };
}();
// without ctx
var getDealsClient = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(param) {
        var query, _sellerCode, sellerCode, _limit, limit, isGetBodyOnly, page, body, _tmp, searchResult, _tmp1, dealsRes, _tmp2, data, _tmp3, _tmp4;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    query = param.query, _sellerCode = param.sellerCode, sellerCode = _sellerCode === void 0 ? "" : _sellerCode, _limit = param.limit, limit = _limit === void 0 ? constants_data__WEBPACK_IMPORTED_MODULE_4__/* .PAGE_SIZE_30 */ .AV : _limit, isGetBodyOnly = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : false;
                    page = Number((query === null || query === void 0 ? void 0 : query.page) - 1 || 0);
                    _tmp = {};
                    body = _tmp;
                    if (sellerCode) {
                        body = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)({}, query), {
                            offset: page * limit,
                            limit: limit,
                            getTotal: true,
                            getDealOnly: true,
                            filter: {
                                sellers: [
                                    sellerCode
                                ]
                            },
                            text: ""
                        });
                    } else {
                        body = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)({}, query), {
                            text: (query === null || query === void 0 ? void 0 : query.q) || null,
                            offset: page * limit,
                            limit: limit,
                            getTotal: true,
                            getDealOnly: true
                        });
                    }
                    if (isGetBodyOnly) return [
                        2,
                        body
                    ];
                    _tmp1 = {};
                    return [
                        4,
                        clients__WEBPACK_IMPORTED_MODULE_0__/* .ProductClientV2.getFuzzySearchClient */ .j4.getFuzzySearchClient((_tmp1.body = body, _tmp1))
                    ];
                case 1:
                    searchResult = _state.sent();
                    if (!(0,clients__WEBPACK_IMPORTED_MODULE_0__/* .isValid */ .JY)(searchResult)) return [
                        2,
                        searchResult
                    ];
                    _tmp2 = {};
                    return [
                        4,
                        mapDataProduct((_tmp2.result = searchResult, _tmp2))
                    ];
                case 2:
                    dealsRes = _state.sent();
                    data = (0,clients__WEBPACK_IMPORTED_MODULE_0__/* .getData */ .Yu)(dealsRes);
                    _tmp3 = {};
                    _tmp4 = {};
                    return [
                        2,
                        (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(_tmp3, dealsRes), (_tmp4.data = data, _tmp4))
                    ];
            }
        });
    });
    return function getDealsClient(_) {
        return _ref.apply(this, arguments);
    };
}();
var getStoreProductClient = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(param) {
        var query, _sellerCode, sellerCode, _keywords, keywords, _sectionStore, sectionStore, _isDeal, isDeal, page, body, _tmp, searchResult, _tmp1, dataRes, _tmp2, _tmp3;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    query = param.query, _sellerCode = param.sellerCode, sellerCode = _sellerCode === void 0 ? "" : _sellerCode, _keywords = param.keywords, keywords = _keywords === void 0 ? "" : _keywords, _sectionStore = param.sectionStore, sectionStore = _sectionStore === void 0 ? "" : _sectionStore, _isDeal = param.isDeal, isDeal = _isDeal === void 0 ? false : _isDeal;
                    page = Number((query === null || query === void 0 ? void 0 : query.page) - 1 || 0);
                    _tmp = {};
                    body = _tmp;
                    if (sellerCode) {
                        body = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)({
                            offset: page * constants_data__WEBPACK_IMPORTED_MODULE_4__/* .PAGE_SIZE_30 */ .AV,
                            limit: constants_data__WEBPACK_IMPORTED_MODULE_4__/* .PAGE_SIZE_30 */ .AV,
                            getTotal: true,
                            getDealOnly: isDeal,
                            filter: {
                                sellers: [
                                    sellerCode
                                ],
                                sectionStore: sectionStore
                            },
                            text: keywords
                        }, query);
                    } else {
                        body = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)({}, query), {
                            text: keywords,
                            offset: page * constants_data__WEBPACK_IMPORTED_MODULE_4__/* .PAGE_SIZE_30 */ .AV,
                            limit: constants_data__WEBPACK_IMPORTED_MODULE_4__/* .PAGE_SIZE_30 */ .AV,
                            getTotal: true,
                            getDealOnly: isDeal
                        });
                    }
                    _tmp1 = {};
                    return [
                        4,
                        clients__WEBPACK_IMPORTED_MODULE_0__/* .ProductClientV2.getFuzzySearchClient */ .j4.getFuzzySearchClient((_tmp1.body = body, _tmp1))
                    ];
                case 1:
                    searchResult = _state.sent();
                    if (!(0,clients__WEBPACK_IMPORTED_MODULE_0__/* .isValid */ .JY)(searchResult)) return [
                        2,
                        searchResult
                    ];
                    _tmp2 = {};
                    return [
                        4,
                        mapDataProduct((_tmp2.result = searchResult, _tmp2))
                    ];
                case 2:
                    dataRes = _state.sent();
                    _tmp3 = {};
                    return [
                        2,
                        (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(_tmp3, dataRes)
                    ];
            }
        });
    });
    return function getStoreProductClient(_) {
        return _ref.apply(this, arguments);
    };
}();
// TODO:
var getProductsByIds = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(_param) {
        var _ids, ids, restProps, idsListArray, i, responses, newData, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _ids = _param.ids, ids = _ids === void 0 ? [] : _ids, restProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(_param, [
                        "ids"
                    ]);
                    idsListArray = [];
                    for(i = 0; i < ids.length; i += LIMIT){
                        idsListArray.push(ids.slice(i, i + LIMIT));
                    }
                    return [
                        4,
                        Promise.all(idsListArray.map(function(productIds) {
                            return clients__WEBPACK_IMPORTED_MODULE_0__/* .ProductClientV2.getProductsByIds */ .j4.getProductsByIds((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)({
                                ids: productIds,
                                limit: productIds.length
                            }, restProps));
                        }))
                    ];
                case 1:
                    responses = _state.sent();
                    newData = [];
                    responses === null || responses === void 0 ? void 0 : responses.forEach(function(res) {
                        var ref;
                        res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.forEach(function(product) {
                            newData.push(product);
                        });
                    });
                    _tmp = {};
                    return [
                        2,
                        (_tmp.status = constants_Enums__WEBPACK_IMPORTED_MODULE_5__/* .HTTP_STATUS.Ok */ .MG.Ok, _tmp.data = newData, _tmp)
                    ];
            }
        });
    });
    return function getProductsByIds(_param) {
        return _ref.apply(this, arguments);
    };
}();
// without ctx
var getProductsByCodes = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(_param) {
        var _codes, codes, restProps, responses, newData, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _codes = _param.codes, codes = _codes === void 0 ? [] : _codes, restProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(_param, [
                        "codes"
                    ]);
                    return [
                        4,
                        Promise.all(codes.map(function(productCodes) {
                            return clients__WEBPACK_IMPORTED_MODULE_0__/* .ProductClientV2.getProductsByCodes */ .j4.getProductsByCodes((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)({
                                codes: [
                                    productCodes
                                ]
                            }, restProps));
                        }))
                    ];
                case 1:
                    responses = _state.sent();
                    newData = [];
                    responses === null || responses === void 0 ? void 0 : responses.forEach(function(res) {
                        var ref;
                        res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.forEach(function(product) {
                            newData.push(product);
                        });
                    });
                    _tmp = {};
                    return [
                        2,
                        (_tmp.status = constants_Enums__WEBPACK_IMPORTED_MODULE_5__/* .HTTP_STATUS.Ok */ .MG.Ok, _tmp.data = newData, _tmp)
                    ];
            }
        });
    });
    return function getProductsByCodes(_param) {
        return _ref.apply(this, arguments);
    };
}();
var getDescriptionByProductId = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(_param) {
        var ctx, productId, restProps, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
            ctx = _param.ctx, productId = _param.productId, restProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(_param, [
                "ctx",
                "productId"
            ]);
            _tmp = {};
            return [
                2,
                clients__WEBPACK_IMPORTED_MODULE_0__/* .ProductClientV2.getDescriptionById */ .j4.getDescriptionById((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)((_tmp.productId = productId, _tmp.ctx = ctx, _tmp), restProps))
            ];
        });
    });
    return function getDescriptionByProductId(_param) {
        return _ref.apply(this, arguments);
    };
}();
var getProductOfSeller = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(param) {
        var ctx, params, result, _tmp, data, skus, productMapRes, _tmp1, mapProduct, _tmp2, productInfo, _tmp3;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ctx = param.ctx, params = param.params;
                    _tmp = {};
                    return [
                        4,
                        clients__WEBPACK_IMPORTED_MODULE_0__/* .SellerClient.getProductBySeller */ .vQ.getProductBySeller((_tmp.ctx = ctx, _tmp.params = params, _tmp))
                    ];
                case 1:
                    result = _state.sent();
                    if (!(0,clients__WEBPACK_IMPORTED_MODULE_0__/* .isValid */ .JY)(result)) return [
                        2,
                        result
                    ];
                    data = (0,clients__WEBPACK_IMPORTED_MODULE_0__/* .getData */ .Yu)(result);
                    skus = data.map(function(param) {
                        var code = param.code;
                        return code;
                    });
                    _tmp1 = {};
                    return [
                        4,
                        getProductInfoMapFromSkus((_tmp1.ctx = ctx, _tmp1.skus = skus, _tmp1))
                    ];
                case 2:
                    productMapRes = _state.sent();
                    if (!(0,clients__WEBPACK_IMPORTED_MODULE_0__/* .isValid */ .JY)(productMapRes)) return [
                        2,
                        productMapRes
                    ];
                    _tmp2 = {};
                    mapProduct = (0,clients__WEBPACK_IMPORTED_MODULE_0__/* .getFirst */ .Xi)(productMapRes, _tmp2);
                    productInfo = skus.map(function(sku) {
                        return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)({}, mapProduct[sku]);
                    });
                    _tmp3 = {};
                    return [
                        2,
                        (_tmp3.total = (result === null || result === void 0 ? void 0 : result.total) || 0, _tmp3.data = productInfo, _tmp3.status = "OK", _tmp3)
                    ];
            }
        });
    });
    return function getProductOfSeller(_) {
        return _ref.apply(this, arguments);
    };
}();
var getFilesProduct = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(param) {
        var ctx, refCode, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
            ctx = param.ctx, refCode = param.refCode;
            _tmp = {};
            return [
                2,
                clients__WEBPACK_IMPORTED_MODULE_0__/* .ProductClientV2.getFilesProduct */ .j4.getFilesProduct((_tmp.ctx = ctx, _tmp.refCode = refCode, _tmp))
            ];
        });
    });
    return function getFilesProduct(_) {
        return _ref.apply(this, arguments);
    };
}();
var getProductByCampaign = function(param) {
    var ctx = param.ctx, text = param.text, _campaignCode = param.campaignCode, campaignCode = _campaignCode === void 0 ? null : _campaignCode, _offset = param.offset, offset = _offset === void 0 ? 0 : _offset, _limit = param.limit, limit = _limit === void 0 ? 30 : _limit, isGetBodyOnly = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return loadProductWithFilter({
        ctx: ctx,
        text: text,
        filter: {
            campaign: campaignCode
        },
        offset: offset,
        limit: limit
    }, isGetBodyOnly);
};
var getDescriptionBySkus = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(param) {
        var ctx, sku, description, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ctx = param.ctx, sku = param.sku;
                    _tmp = {};
                    return [
                        4,
                        clients__WEBPACK_IMPORTED_MODULE_0__/* .ProductClientV2.getDescriptionBySku */ .j4.getDescriptionBySku((_tmp.ctx = ctx, _tmp.sku = sku, _tmp))
                    ];
                case 1:
                    description = _state.sent();
                    if (!(0,clients__WEBPACK_IMPORTED_MODULE_0__/* .isValid */ .JY)(description)) return [
                        2,
                        null
                    ];
                    return [
                        2,
                        (0,clients__WEBPACK_IMPORTED_MODULE_0__/* .getFirst */ .Xi)(description)
                    ];
            }
        });
    });
    return function getDescriptionBySkus(_) {
        return _ref.apply(this, arguments);
    };
}();
var getHistoryBySkus = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(param) {
        var ctx, _skuCodes, skuCodes, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
            ctx = param.ctx, _skuCodes = param.skuCodes, skuCodes = _skuCodes === void 0 ? null : _skuCodes;
            _tmp = {};
            (0,clients__WEBPACK_IMPORTED_MODULE_0__/* .POST */ .a4)((_tmp.ctx = ctx, _tmp.url = constants_APIUriV2__WEBPACK_IMPORTED_MODULE_3__/* .ORDER_API.SKU_HISTORY */ .EM.SKU_HISTORY, _tmp.body = {
                skuCodes: skuCodes
            }, _tmp));
            return [
                2
            ];
        });
    });
    return function getHistoryBySkus(_) {
        return _ref.apply(this, arguments);
    };
}();
var getDetailProductWithoutLogin = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(param) {
        var ctx, provinceCode, ref, url, params, _tmp, result, _tmp1, _tmp2;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ctx = param.ctx, provinceCode = param.provinceCode;
                    url = "/marketplace/product/v2/product/detail-raw";
                    _tmp = {};
                    params = (_tmp.q = convertSlug((ctx === null || ctx === void 0 ? void 0 : (ref = ctx.query) === null || ref === void 0 ? void 0 : ref.slug) || null), _tmp.provinceCode = provinceCode, _tmp);
                    _tmp1 = {};
                    return [
                        4,
                        (0,clients__WEBPACK_IMPORTED_MODULE_0__/* .GET */ .HT)((_tmp1.ctx = ctx, _tmp1.url = url, _tmp1.params = params, _tmp1.provinceCode = provinceCode, _tmp1.isBasic = true, _tmp1))
                    ];
                case 1:
                    result = _state.sent();
                    if (!(0,clients__WEBPACK_IMPORTED_MODULE_0__/* .isValid */ .JY)(result)) return [
                        2,
                        result
                    ];
                    _tmp2 = {};
                    return [
                        2,
                        mapDataProduct((_tmp2.ctx = ctx, _tmp2.result = result, _tmp2.isGetQuantity = false, _tmp2.withoutLogin = true, _tmp2))
                    ];
            }
        });
    });
    return function getDetailProductWithoutLogin(_) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ __webpack_exports__["ZP"] = ({
    findDiscountPercent: findDiscountPercent,
    loadDataProduct: loadDataProduct,
    loadDataProductWeb: loadDataProductWeb,
    // loadDataProductMobile,
    loadDataProductMobileClient: loadDataProductMobileClient,
    mapDataProduct: mapDataProduct,
    searchProductsQuickOrder: searchProductsQuickOrder,
    searchProductsByVoucherFilter: searchProductsByVoucherFilter,
    searchProductsMobile: searchProductsMobile,
    loadDataQuickOrder: loadDataQuickOrder,
    loadDataQuickOrderServer: loadDataQuickOrderServer,
    getSubstituteProducts: getSubstituteProducts,
    loadProductWithCategory: loadProductWithCategory,
    loadProductWithManufacturer: loadProductWithManufacturer,
    getListTabs: getListTabs,
    getProductInfoMapFromSkus: getProductInfoMapFromSkus,
    loadDataProductDetail: loadDataProductDetail,
    getSettingTags: getSettingTags,
    getTagNameFromIds: getTagNameFromIds,
    getDeals: getDeals,
    loadProductWithFilter: loadProductWithFilter,
    loadProductWithTag: loadProductWithTag,
    loadProductWithIngredient: loadProductWithIngredient,
    getProductInfoFromSkus: getProductInfoFromSkus,
    getProductsByIds: getProductsByIds,
    getFilesProduct: getFilesProduct,
    getProductOfSeller: getProductOfSeller,
    loadProductWithSeller: loadProductWithSeller,
    loadProductByManufacturer: loadProductByManufacturer,
    getDescriptionByProductId: getDescriptionByProductId,
    getProductByCampaign: getProductByCampaign,
    getDataProductBySlug: getDataProductBySlug,
    getDataProductsBySlugs: getDataProductsBySlugs,
    getDescriptionBySkus: getDescriptionBySkus,
    loadProductFuzzy: loadProductFuzzy,
    convertProductV2: convertProductV2,
    getDetailProductWithoutLogin: getDetailProductWithoutLogin,
    getProductInfoFromSkusForSeller: getProductInfoFromSkusForSeller,
    getDealsClient: getDealsClient,
    getHistoryBySkus: getHistoryBySkus,
    getProductsByCodes: getProductsByCodes,
    getStoreProductClient: getStoreProductClient,
    loadDataProductMobileServer: loadDataProductMobileServer
});


/***/ }),

/***/ 89349:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D0": function() { return /* binding */ getAccount; },
/* harmony export */   "fn": function() { return /* binding */ getAccountInfo; }
/* harmony export */ });
/* unused harmony export getAccountSessionToken */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97582);
/* harmony import */ var clients__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15149);





var wrapInfo = function(info) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, info), {
        isActive: info.status === "ACTIVE",
        isQuest: info.level === "LEVEL_GUEST",
        createdTime: null,
        lastUpdatedTime: null
    });
};
var getAccount = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(ctx) {
        var userRes, info, wrapData, _tmp, _tmp1;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    userRes = null;
                    if (!ctx) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        clients__WEBPACK_IMPORTED_MODULE_0__/* .AuthClient.getUserWithContext */ .LY.getUserWithContext(ctx)
                    ];
                case 1:
                    userRes = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 2:
                    return [
                        4,
                        clients__WEBPACK_IMPORTED_MODULE_0__/* .AuthClient.getUser */ .LY.getUser()
                    ];
                case 3:
                    userRes = _state.sent();
                    _state.label = 4;
                case 4:
                    if (!(0,clients__WEBPACK_IMPORTED_MODULE_0__/* .isValid */ .JY)(userRes)) {
                        return [
                            2,
                            userRes
                        ];
                    }
                    info = (0,clients__WEBPACK_IMPORTED_MODULE_0__/* .getFirst */ .Xi)(userRes);
                    wrapData = wrapInfo(info);
                    _tmp = {};
                    _tmp1 = {};
                    // change data
                    return [
                        2,
                        (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_tmp, userRes), (_tmp1.data = [
                            wrapData
                        ], _tmp1))
                    ];
            }
        });
    });
    return function getAccount(ctx) {
        return _ref.apply(this, arguments);
    };
}();
// get core account
var getAccountInfo = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(param) {
        var ctx, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            ctx = param.ctx;
            _tmp = {};
            return [
                2,
                clients__WEBPACK_IMPORTED_MODULE_0__/* .AuthClient.getAccountInfo */ .LY.getAccountInfo((_tmp.ctx = ctx, _tmp))
            ];
        });
    });
    return function getAccountInfo(_) {
        return _ref.apply(this, arguments);
    };
}();
var getAccountSessionToken = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(param) {
        var ctx, ref, rest, _tmp, data;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ctx = param.ctx;
                    _tmp = {};
                    return [
                        4,
                        getAccountInfo((_tmp.ctx = ctx, _tmp))
                    ];
                case 1:
                    rest = _state.sent();
                    if (!(0,clients__WEBPACK_IMPORTED_MODULE_0__/* .isValid */ .JY)(rest)) {
                        return [
                            2,
                            null
                        ];
                    }
                    data = (0,clients__WEBPACK_IMPORTED_MODULE_0__/* .getFirst */ .Xi)(rest);
                    return [
                        2,
                        ((ref = data.session) === null || ref === void 0 ? void 0 : ref.token) || null
                    ];
            }
        });
    });
    return function getAccountSessionToken(_) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ __webpack_exports__["ZP"] = ({
    getAccount: getAccount,
    getAccountSessionToken: getAccountSessionToken,
    getAccountInfo: getAccountInfo
});


/***/ }),

/***/ 788:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "e8": function() { return /* reexport */ AuthService/* default */.ZP; },
  "Uf": function() { return /* reexport */ CampaignService; },
  "Ni": function() { return /* reexport */ CartService; },
  "vZ": function() { return /* reexport */ CustomerService/* default */.ZP; },
  "f7": function() { return /* reexport */ MarketingService/* default */.ZP; },
  "px": function() { return /* reexport */ OrderService; },
  "ft": function() { return /* reexport */ PricingService; },
  "Rl": function() { return /* reexport */ ProductServiceV2/* default */.ZP; },
  "d$": function() { return /* reexport */ RewardsService; },
  "J": function() { return /* reexport */ SmartRecommendationService; },
  "Qy": function() { return /* reexport */ WebService; }
});

// UNUSED EXPORTS: PromoService, SellerService, UserService, doWithServerSide

// EXTERNAL MODULE: ./src/services/AuthService.js
var AuthService = __webpack_require__(59606);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./src/clients/index.js + 20 modules
var clients = __webpack_require__(15149);
;// CONCATENATED MODULE: ./src/services/CampaignService.js



var getCampaignDetailBySlug = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx, query, params, _tmp, url, result, _tmp1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ctx = param.ctx;
                    query = ctx.query;
                    _tmp = {};
                    params = (_tmp.q = JSON.stringify({
                        slug: query.slug
                    }), _tmp);
                    url = "/marketplace/promotion/v1/campaign";
                    _tmp1 = {};
                    return [
                        4,
                        (0,clients/* GET */.HT)((_tmp1.url = url, _tmp1.ctx = ctx, _tmp1.params = params, _tmp1))
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        2,
                        result
                    ];
            }
        });
    });
    return function getCampaignDetailBySlug(_) {
        return _ref.apply(this, arguments);
    };
}();
// without ctx
var getCampaignDetailBySlugClient = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(slug) {
        var params, _tmp, url, result, _tmp1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    params = (_tmp.q = JSON.stringify({
                        slug: slug
                    }), _tmp);
                    url = "/marketplace/promotion/v1/campaign";
                    _tmp1 = {};
                    return [
                        4,
                        (0,clients/* GET */.HT)((_tmp1.url = url, _tmp1.params = params, _tmp1))
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        2,
                        result
                    ];
            }
        });
    });
    return function getCampaignDetailBySlugClient(slug) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var CampaignService = ({
    getCampaignDetailBySlug: getCampaignDetailBySlug,
    getCampaignDetailBySlugClient: getCampaignDetailBySlugClient
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./src/clients/CartClientV2.js
var CartClientV2 = __webpack_require__(10741);
// EXTERNAL MODULE: ./src/utils/ValidateUtils.js
var ValidateUtils = __webpack_require__(70220);
// EXTERNAL MODULE: ./src/services/ProductServiceV2.js
var ProductServiceV2 = __webpack_require__(5108);
;// CONCATENATED MODULE: ./src/services/CartService.js









var getCartInfo = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx;
        return (0,tslib_es6.__generator)(this, function(_state) {
            ctx = param.ctx;
            return [
                2,
                CartClientV2/* default.loadDataCart */.Z.loadDataCart(ctx)
            ];
        });
    });
    return function getCartInfo(_) {
        return _ref.apply(this, arguments);
    };
}();
var getInfoCartItem = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx, data, _getPrice, getPrice, skus, mapInfoRes, _tmp, mapInfo;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ctx = param.ctx, data = param.data, _getPrice = param.getPrice, getPrice = _getPrice === void 0 ? true : _getPrice;
                    if ((0,ValidateUtils/* isEmpty */.xb)(data)) {
                        return [
                            2,
                            []
                        ];
                    }
                    skus = data.reduce(function(accumulator, item) {
                        if (item === null || item === void 0 ? void 0 : item.sku) return (0,_to_consumable_array/* default */.Z)(accumulator).concat([
                            item.sku
                        ]);
                        return accumulator;
                    }, []);
                    if (skus.length === 0) {
                        return [
                            2,
                            []
                        ];
                    }
                    _tmp = {};
                    return [
                        4,
                        (0,ProductServiceV2/* getProductInfoMapFromSkus */.Pc)((_tmp.ctx = ctx, _tmp.skus = skus, _tmp.getPrice = getPrice, _tmp))
                    ];
                case 1:
                    mapInfoRes = _state.sent();
                    mapInfo = (0,clients/* getFirst */.Xi)(mapInfoRes);
                    // sort những item nào có lỗi sẽ hiện lên trước
                    data.sort(function(a, b) {
                        return a.errorCode && !b.errorCode ? -1 : 1;
                    });
                    return [
                        2,
                        data.map(function(item) {
                            // TODO: ẩn nhà cung cấp
                            var ref = mapInfo[item.sku] || {}, imagesProxy = ref.imagesProxy, volume = ref.volume, name = ref.name, slug = ref.slug, _deal = ref.deal, deal = _deal === void 0 ? {} : _deal, isDeal = ref.isDeal, isGift = ref.isGift, productId = ref.productId, _salePrice = ref.salePrice, salePrice = _salePrice === void 0 ? 0 : _salePrice, _displayPrice = ref.displayPrice, displayPrice = _displayPrice === void 0 ? 0 : _displayPrice, _dealPrice = ref.dealPrice, dealPrice = _dealPrice === void 0 ? 0 : _dealPrice, tags = ref.tags, seller = ref.seller, statusData = ref.statusData, limitPerDay = ref.limitPerDay, maxQuantityPerDay = ref.maxQuantityPerDay, quantityPurchasedToday = ref.quantityPurchasedToday, messageLimitOrder = ref.messageLimitOrder, categoryCodes = ref.categoryCodes, campaign = ref.campaign;
                            // const salePrice = deal?.dealType === 'COMBO' || !deal ? item.price : item.salePrice;
                            var disableAddTocart = item.errorCode === "NOT_ACTIVE_SKU" || item.errorCode === "SUSPENDED_SKU" || item.errorCode === "OUT_OF_STOCK_SKU" || item.errorCode === "CART_ITEM_INVALID" || item.errorCode === "NOT_AVAILABLE_SKU" || item.errorCode === "NOT_AVAILABLE_SCOPE" || item.errorCode === "NOT_FOUND_SKU" || item.errorCode === "NOT_FOUND_PRICE_SKU" || item.errorCode === "COMBO_INVALID" || false;
                            /*
    // nếu item (cart item ) là deal thì có thêm 1 field là  salePrice ( giá gốc )
    // nếu không là deal thì chỉ có price 
    nhưng khi hiển thị ở cartProductBuy lại chỉ check salePrice , nên nếu 
    Updaate chỗ này để nếu có saleprice thì lấy giá saleprice , còn nếu ko có thì lấy giá price theo cartItem 
    salePrice: item.salePrice || item.price,
*/ var info = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                                salePrice: salePrice,
                                displayPrice: displayPrice,
                                dealPrice: dealPrice,
                                errorCode: item.errorCode || "",
                                imagesProxy: imagesProxy,
                                volume: volume,
                                name: name,
                                slug: (slug === null || slug === void 0 ? void 0 : slug.toLowerCase()) || slug,
                                deal: deal,
                                isDeal: isDeal,
                                seller: seller,
                                isGift: isGift,
                                disableAddTocart: disableAddTocart,
                                productId: productId,
                                tags: tags,
                                statusData: statusData,
                                limitPerDay: limitPerDay,
                                maxQuantityPerDay: maxQuantityPerDay,
                                quantityPurchasedToday: quantityPurchasedToday,
                                messageLimitOrder: messageLimitOrder,
                                categoryCodes: categoryCodes,
                                campaign: campaign
                            });
                            return info;
                        })
                    ];
            }
        });
    });
    return function getInfoCartItem(_) {
        return _ref.apply(this, arguments);
    };
}();
var checkoutCart = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(body) {
        var _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    return [
                        4,
                        CartClientV2/* default.updateCart */.Z.updateCart((_tmp.body = body, _tmp))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        CartClientV2/* default.checkout */.Z.checkout(body)
                    ];
            }
        });
    });
    return function checkoutCart(body) {
        return _ref.apply(this, arguments);
    };
}();
var getCartInfoWithProduct = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx, cartRs, _tmp, cartInfo, cartItems, listItems, _tmp1, _tmp2, _tmp3;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ctx = param.ctx;
                    _tmp = {};
                    return [
                        4,
                        getCartInfo((_tmp.ctx = ctx, _tmp))
                    ];
                case 1:
                    cartRs = _state.sent();
                    if (!(0,clients/* isValid */.JY)(cartRs)) {
                        return [
                            2,
                            cartRs
                        ];
                    }
                    cartInfo = (0,clients/* getFirst */.Xi)(cartRs);
                    cartItems = cartInfo.cartItems;
                    _tmp1 = {};
                    return [
                        4,
                        getInfoCartItem((_tmp1.ctx = ctx, _tmp1.data = cartItems, _tmp1.getPrice = false, _tmp1))
                    ];
                case 2:
                    listItems = _state.sent();
                    cartInfo.cartItems = listItems;
                    _tmp2 = {};
                    _tmp3 = {};
                    return [
                        2,
                        (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)(_tmp2, cartRs), (_tmp3.data = [
                            cartInfo
                        ], _tmp3))
                    ];
            }
        });
    });
    return function getCartInfoWithProduct(_) {
        return _ref.apply(this, arguments);
    };
}();
var reOrder = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(body) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2,
                CartClientV2/* default.reOrder */.Z.reOrder(body)
            ];
        });
    });
    return function reOrder(body) {
        return _ref.apply(this, arguments);
    };
}();
// APO-08
// chọn / bỏ chọn 1 item
var selectCartItem = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var sku, skus, isSelected, cartNo, quantity, name, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            sku = param.sku, skus = param.skus, isSelected = param.isSelected, cartNo = param.cartNo, quantity = param.quantity, name = param.name;
            _tmp = {};
            return [
                2,
                CartClientV2/* default.selectCartItem */.Z.selectCartItem((_tmp.sku = sku, _tmp.skus = skus, _tmp.isSelected = isSelected, _tmp.cartNo = cartNo, _tmp.quantity = quantity, _tmp.name = name, _tmp))
            ];
        });
    });
    return function selectCartItem(_) {
        return _ref.apply(this, arguments);
    };
}();
var selectAllCartItem = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var cartNo, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            cartNo = param.cartNo;
            _tmp = {};
            return [
                2,
                CartClientV2/* default.selectCartItem */.Z.selectCartItem((_tmp.isAppliedAll = true, _tmp.isSelected = true, _tmp.cartNo = cartNo, _tmp))
            ];
        });
    });
    return function selectAllCartItem(_) {
        return _ref.apply(this, arguments);
    };
}();
var unSelectAllCartItem = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var cartNo, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            cartNo = param.cartNo;
            _tmp = {};
            return [
                2,
                CartClientV2/* default.selectCartItem */.Z.selectCartItem((_tmp.isAppliedAll = true, _tmp.isSelected = false, _tmp.cartNo = cartNo, _tmp))
            ];
        });
    });
    return function unSelectAllCartItem(_) {
        return _ref.apply(this, arguments);
    };
}();
var validateCart = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx, body, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            ctx = param.ctx, body = param.body;
            _tmp = {};
            return [
                2,
                CartClientV2/* default.verifyPayment */.Z.verifyPayment((_tmp.ctx = ctx, _tmp.body = body, _tmp))
            ];
        });
    });
    return function validateCart(_) {
        return _ref.apply(this, arguments);
    };
}();
// skus rỗng = xác nhận toàn bộ item biến động giá trong giỏ
var confirmChangePrice = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var _skus, skus, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            _skus = param.skus, skus = _skus === void 0 ? [] : _skus;
            _tmp = {};
            return [
                2,
                CartClientV2/* default.confirmChangePrice */.Z.confirmChangePrice((_tmp.skus = skus, _tmp))
            ];
        });
    });
    return function confirmChangePrice(_) {
        return _ref.apply(this, arguments);
    };
}();
var getPaymentLink = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var orderId, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            orderId = param.orderId;
            _tmp = {};
            return [
                2,
                CartClientV2/* default.getPaymentLink */.Z.getPaymentLink((_tmp.orderId = orderId, _tmp))
            ];
        });
    });
    return function getPaymentLink(_) {
        return _ref.apply(this, arguments);
    };
}();
var getCartIngredient = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2,
                CartClientV2/* default.getCartIngredient */.Z.getCartIngredient()
            ];
        });
    });
    return function getCartIngredient() {
        return _ref.apply(this, arguments);
    };
}();
var getPaymentInfoWithBeamGateway = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx, orderId, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            ctx = param.ctx, orderId = param.orderId;
            _tmp = {};
            return [
                2,
                CartClientV2/* default.getPaymentInfoWithBeamGateway */.Z.getPaymentInfoWithBeamGateway((_tmp.ctx = ctx, _tmp.orderId = orderId, _tmp))
            ];
        });
    });
    return function getPaymentInfoWithBeamGateway(_) {
        return _ref.apply(this, arguments);
    };
}();
var trackingPaymentStatusBeamGateway = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx, orderId, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            ctx = param.ctx, orderId = param.orderId;
            _tmp = {};
            return [
                2,
                CartClientV2/* default.trackingPaymentStatusBeamGateway */.Z.trackingPaymentStatusBeamGateway((_tmp.ctx = ctx, _tmp.orderId = orderId, _tmp))
            ];
        });
    });
    return function trackingPaymentStatusBeamGateway(_) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var CartService = ({
    getInfoCartItem: getInfoCartItem,
    checkoutCart: checkoutCart,
    getCartInfoWithProduct: getCartInfoWithProduct,
    reOrder: reOrder,
    selectCartItem: selectCartItem,
    selectAllCartItem: selectAllCartItem,
    unSelectAllCartItem: unSelectAllCartItem,
    validateCart: validateCart,
    confirmChangePrice: confirmChangePrice,
    getPaymentLink: getPaymentLink,
    getCartIngredient: getCartIngredient,
    getPaymentInfoWithBeamGateway: getPaymentInfoWithBeamGateway,
    trackingPaymentStatusBeamGateway: trackingPaymentStatusBeamGateway
});

// EXTERNAL MODULE: ./src/services/CustomerService.js
var CustomerService = __webpack_require__(29455);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./src/constants/Enums/index.js
var Enums = __webpack_require__(71569);
// EXTERNAL MODULE: ./src/utils/index.js + 5 modules
var utils = __webpack_require__(76480);
// EXTERNAL MODULE: ./src/services/AddressService.js
var AddressService = __webpack_require__(84378);
;// CONCATENATED MODULE: ./src/services/PricingService.js





var getListPaymentMethod = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx, params, ref, paymentsRes, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ctx = param.ctx, params = param.params;
                    _tmp = {};
                    return [
                        4,
                        clients/* PricingClients.getPaymentMethod */.C9.getPaymentMethod((_tmp.ctx = ctx, _tmp.params = params, _tmp))
                    ];
                case 1:
                    paymentsRes = _state.sent();
                    if (!(0,clients/* isValid */.JY)(paymentsRes)) {
                        return [
                            2,
                            []
                        ];
                    }
                    // add filter status === ON
                    return [
                        2,
                        (ref = paymentsRes.data) === null || ref === void 0 ? void 0 : ref.filter(function(param) {
                            var status = param.status;
                            return status === "ON";
                        }).sort(function(a, b) {
                            return ((a === null || a === void 0 ? void 0 : a.priority) || 0) - ((b === null || b === void 0 ? void 0 : b.priority) || 0);
                        }).map(function(item) {
                            var ref = item || {}, _paymentLocations = ref.paymentLocations, paymentLocations = _paymentLocations === void 0 ? [] : _paymentLocations;
                            var mapLocationFee = {};
                            paymentLocations === null || paymentLocations === void 0 ? void 0 : paymentLocations.forEach(function(delivery) {
                                var ref = delivery || {}, _feeDiscountPercentage = ref.feeDiscountPercentage, feeDiscountPercentage = _feeDiscountPercentage === void 0 ? 0 : _feeDiscountPercentage, _locationCodes = ref.locationCodes, locationCodes = _locationCodes === void 0 ? [] : _locationCodes;
                                locationCodes === null || locationCodes === void 0 ? void 0 : locationCodes.forEach(function(locationCode) {
                                    mapLocationFee[locationCode] = "".concat(feeDiscountPercentage);
                                });
                            });
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                                mapLocationFee: mapLocationFee
                            });
                        })
                    ];
            }
        });
    });
    return function getListPaymentMethod(_) {
        return _ref.apply(this, arguments);
    };
}();
var getListDeliveryMethod = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx, params, ref, deliveryRes, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ctx = param.ctx, params = param.params;
                    _tmp = {};
                    return [
                        4,
                        clients/* PricingClients.getDeliveryMethod */.C9.getDeliveryMethod((_tmp.ctx = ctx, _tmp.params = params, _tmp))
                    ];
                case 1:
                    deliveryRes = _state.sent();
                    if (!(0,clients/* isValid */.JY)(deliveryRes)) {
                        return [
                            2,
                            []
                        ];
                    }
                    // add filter status == ON
                    return [
                        2,
                        (ref = deliveryRes.data) === null || ref === void 0 ? void 0 : ref.filter(function(param) {
                            var status = param.status;
                            return status === "ON";
                        }).sort(function(a, b) {
                            return ((a === null || a === void 0 ? void 0 : a.priority) || 0) - ((b === null || b === void 0 ? void 0 : b.priority) || 0);
                        })// convert map price
                        .map(function(item) {
                            var deliveryLocations = item.deliveryLocations;
                            var mapLocationFee = {};
                            deliveryLocations === null || deliveryLocations === void 0 ? void 0 : deliveryLocations.forEach(function(delivery) {
                                var ref = delivery || {}, _feeValue = ref.feeValue, feeValue = _feeValue === void 0 ? 0 : _feeValue, _locationCodes = ref.locationCodes, locationCodes = _locationCodes === void 0 ? [] : _locationCodes;
                                locationCodes === null || locationCodes === void 0 ? void 0 : locationCodes.forEach(function(locationCode) {
                                    mapLocationFee[locationCode] = feeValue;
                                });
                            });
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                                mapLocationFee: mapLocationFee
                            });
                        })
                    ];
            }
        });
    });
    return function getListDeliveryMethod(_) {
        return _ref.apply(this, arguments);
    };
}();
var getDetailPaymentMethod = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx, paymentMethodCode, paymentMethodRes, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ctx = param.ctx, paymentMethodCode = param.paymentMethodCode;
                    _tmp = {};
                    return [
                        4,
                        clients/* PricingClients.getDetailPaymentMethod */.C9.getDetailPaymentMethod((_tmp.ctx = ctx, _tmp.paymentMethodCode = paymentMethodCode, _tmp))
                    ];
                case 1:
                    paymentMethodRes = _state.sent();
                    return [
                        2,
                        paymentMethodRes
                    ];
            }
        });
    });
    return function getDetailPaymentMethod(_) {
        return _ref.apply(this, arguments);
    };
}();
var getDetailDeliveryMethod = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx, deliveryPlatformCode, deliveryMethodRes, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ctx = param.ctx, deliveryPlatformCode = param.deliveryPlatformCode;
                    _tmp = {};
                    return [
                        4,
                        clients/* PricingClients.getDetailDeliveryMethod */.C9.getDetailDeliveryMethod((_tmp.ctx = ctx, _tmp.deliveryPlatformCode = deliveryPlatformCode, _tmp))
                    ];
                case 1:
                    deliveryMethodRes = _state.sent();
                    return [
                        2,
                        deliveryMethodRes
                    ];
            }
        });
    });
    return function getDetailDeliveryMethod(_) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var PricingService = ({
    getListPaymentMethod: getListPaymentMethod,
    getListDeliveryMethod: getListDeliveryMethod,
    getDetailPaymentMethod: getDetailPaymentMethod,
    getDetailDeliveryMethod: getDetailDeliveryMethod
});

;// CONCATENATED MODULE: ./src/services/OrderService.js












var deleteOrder = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var orderId, res, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    orderId = param.orderId;
                    _tmp = {};
                    return [
                        4,
                        clients/* OrderClient.deleteOrder */.ZT.deleteOrder((_tmp.orderId = orderId, _tmp))
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res
                    ];
            }
        });
    });
    return function deleteOrder(_) {
        return _ref.apply(this, arguments);
    };
}();
var getOrderCountInWeek = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx, ref, res, _tmp, orders, firstDateOfWeek;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ctx = param.ctx;
                    _tmp = {};
                    return [
                        4,
                        clients/* OrderClient.getOrders */.ZT.getOrders((_tmp.ctx = ctx, _tmp.limit = 7, _tmp))
                    ];
                case 1:
                    res = _state.sent();
                    if (!(0,clients/* isValid */.JY)(res)) {
                        return [
                            2,
                            0
                        ];
                    }
                    orders = (0,clients/* getData */.Yu)(res) || [];
                    firstDateOfWeek = utils/* DateTimeUtils.getFirstDateOfWeek */.IM.getFirstDateOfWeek();
                    return [
                        2,
                        ((ref = orders === null || orders === void 0 ? void 0 : orders.filter(function(item) {
                            return item.status !== "CANCEL" && new Date(item.createdTime) > firstDateOfWeek;
                        })) === null || ref === void 0 ? void 0 : ref.length) || 0
                    ];
            }
        });
    });
    return function getOrderCountInWeek(_) {
        return _ref.apply(this, arguments);
    };
}();
var startDate = 1626282000000;
var getOrderCountInWeekStartDate = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx, ref, res, _tmp, orders, newDate, firstDateOfWeek, firstDateCal;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ctx = param.ctx;
                    _tmp = {};
                    return [
                        4,
                        clients/* OrderClient.getOrders */.ZT.getOrders((_tmp.ctx = ctx, _tmp.limit = 7, _tmp))
                    ];
                case 1:
                    res = _state.sent();
                    if (!(0,clients/* isValid */.JY)(res)) {
                        return [
                            2,
                            0
                        ];
                    }
                    orders = (0,clients/* getData */.Yu)(res) || [];
                    newDate = new Date();
                    firstDateOfWeek = Math.max(newDate.getTime() - 7 * 24 * 3600000, startDate);
                    firstDateCal = new Date(firstDateOfWeek);
                    firstDateCal.setHours(0, 0, 0, 0);
                    return [
                        2,
                        ((ref = orders === null || orders === void 0 ? void 0 : orders.filter(function(item) {
                            return item.status !== "CANCEL" && new Date(item.createdTime) > firstDateCal;
                        })) === null || ref === void 0 ? void 0 : ref.length) || 0
                    ];
            }
        });
    });
    return function getOrderCountInWeekStartDate(_) {
        return _ref.apply(this, arguments);
    };
}();
var MINUTES_30 = 1800000;
function getInfoOrderItem(_) {
    return _getInfoOrderItem.apply(this, arguments);
}
function _getInfoOrderItem() {
    _getInfoOrderItem = (0,_async_to_generator/* default */.Z)(function(param) {
        var _orderItems, orderItems, ctx, skus, _tmp, _tmp1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            _orderItems = param.orderItems, orderItems = _orderItems === void 0 ? [] : _orderItems, ctx = param.ctx;
            skus = orderItems.reduce(function(accumulator, item) {
                if (item === null || item === void 0 ? void 0 : item.sku) return (0,_to_consumable_array/* default */.Z)(accumulator).concat([
                    item.sku
                ]);
                return accumulator;
            }, []);
            _tmp = {};
            if (skus.length === 0) {
                return [
                    2,
                    (_tmp.status = Enums/* HTTP_STATUS.Forbidden */.MG.Forbidden, _tmp.message = "Dữ liệu kh\xf4ng đủ", _tmp)
                ];
            }
            _tmp1 = {};
            return [
                2,
                (0,ProductServiceV2/* getProductInfoMapFromSkus */.Pc)((_tmp1.skus = skus, _tmp1.ctx = ctx, _tmp1))
            ];
        });
    });
    return _getInfoOrderItem.apply(this, arguments);
}
var getOrderById = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx, orderId, orderRes, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ctx = param.ctx, orderId = param.orderId;
                    _tmp = {};
                    return [
                        4,
                        clients/* OrderClient.getOrderById */.ZT.getOrderById((_tmp.id = Number(orderId), _tmp.ctx = ctx, _tmp))
                    ];
                case 1:
                    orderRes = _state.sent();
                    return [
                        2,
                        orderRes
                    ];
            }
        });
    });
    return function getOrderById(_) {
        return _ref.apply(this, arguments);
    };
}();
// get order detail ( page order detail )
var getOrderDetail = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx, orderId, customerLevel, locationCode, _getCombo, getCombo, orderRes, _tmp, order, _tmp1, _orderCode, orderCode, deliveryMethod, paymentMethod, status, createdTime, customerProvinceCode, customerDistrictCode, customerWardCode, customerShippingAddress, _redeemCode, redeemCode, _redeemApplyResult, redeemApplyResult, _totalDiscount, totalDiscount, _orderItems, orderItems, convertRedeem, _tmp2, ref, skuGift, _tmp3, masterAddress, _tmp4, ref1, productsRes, paymentRes, deliveryRes, _tmp5, _tmp6, _tmp7, invoiceRes, _tmp8, invoiceData, paymentInfo, deliveryInfo, products, orderItemInfoRes, _tmp9, comboProductsInfo, _tmp10, getProductInfoBySubSkus, orderItemInfoMap;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ctx = param.ctx, orderId = param.orderId, customerLevel = param.customerLevel, locationCode = param.locationCode, _getCombo = param.getCombo, getCombo = _getCombo === void 0 ? true : _getCombo;
                    _tmp = {};
                    return [
                        4,
                        clients/* OrderClient.getOrderById */.ZT.getOrderById((_tmp.id = Number(orderId), _tmp.ctx = ctx, _tmp))
                    ];
                case 1:
                    orderRes = _state.sent();
                    if (!(0,clients/* isValid */.JY)(orderRes)) {
                        return [
                            2,
                            orderRes
                        ];
                    }
                    _tmp1 = {};
                    order = (0,clients/* getFirst */.Xi)(orderRes, _tmp1);
                    _orderCode = order.orderCode, orderCode = _orderCode === void 0 ? "" : _orderCode, deliveryMethod = order.deliveryMethod, paymentMethod = order.paymentMethod, status = order.status, createdTime = order.createdTime, customerProvinceCode = order.customerProvinceCode, customerDistrictCode = order.customerDistrictCode, customerWardCode = order.customerWardCode, customerShippingAddress = order.customerShippingAddress, _redeemCode = order.redeemCode, redeemCode = _redeemCode === void 0 ? null : _redeemCode, _redeemApplyResult = order.redeemApplyResult, redeemApplyResult = _redeemApplyResult === void 0 ? null : _redeemApplyResult, _totalDiscount = order.totalDiscount, totalDiscount = _totalDiscount === void 0 ? null : _totalDiscount, _orderItems = order.orderItems, orderItems = _orderItems === void 0 ? [] : _orderItems;
                    _tmp2 = {};
                    _tmp3 = {};
                    if ((redeemCode === null || redeemCode === void 0 ? void 0 : redeemCode.length) > 0 && !redeemApplyResult) {
                        convertRedeem = [];
                        if (totalDiscount > 0) {
                            convertRedeem.push((_tmp2.code = redeemCode[0], _tmp2.discountValue = totalDiscount, _tmp2.canUse = true, _tmp2));
                        } else {
                            ;
                            skuGift = (ref = orderItems === null || orderItems === void 0 ? void 0 : orderItems.find(function(item) {
                                return (item === null || item === void 0 ? void 0 : item.type) === "GIFT";
                            })) === null || ref === void 0 ? void 0 : ref.sku;
                            // Thuy29Dec2022: cần convert vì ko migrate cho đơn hàng cũ
                            if (skuGift) {
                                convertRedeem.push((_tmp3.code = redeemCode[0], _tmp3.gifts = [
                                    {
                                        sku: skuGift,
                                        quantity: 1
                                    }
                                ], _tmp3.canUse = true, _tmp3));
                            }
                        }
                        order.redeemApplyResult = convertRedeem;
                    }
                    _tmp4 = {};
                    return [
                        4,
                        AddressService/* default.getMasterAddressString */.Z.getMasterAddressString((_tmp4.ctx = ctx, _tmp4.provinceCode = customerProvinceCode, _tmp4.districtCode = customerDistrictCode, _tmp4.wardCode = customerWardCode, _tmp4))
                    ];
                case 2:
                    masterAddress = _state.sent();
                    order.masterAddress = "".concat(customerShippingAddress, ", ").concat(masterAddress);
                    // logic check update
                    // order can edit if status === wait to confirm && 30 minutes
                    order.canEdit = status === Enums/* ENUM_ORDER_STATUS.WAIT_TO_CONFIRM */.TJ.WAIT_TO_CONFIRM && +new Date() - +new Date(createdTime) <= MINUTES_30;
                    _tmp5 = {};
                    _tmp6 = {};
                    _tmp7 = {};
                    return [
                        4,
                        Promise.all([
                            clients/* OrderClient.getProductByOrderCode */.ZT.getProductByOrderCode((_tmp5.orderCode = orderCode, _tmp5.ctx = ctx, _tmp5)),
                            getDetailPaymentMethod((_tmp6.ctx = ctx, _tmp6.paymentMethodCode = paymentMethod, _tmp6)),
                            getDetailDeliveryMethod((_tmp7.ctx = ctx, _tmp7.deliveryPlatformCode = deliveryMethod, _tmp7))
                        ])
                    ];
                case 3:
                    ref1 = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                        _state.sent(),
                        3
                    ]), productsRes = ref1[0], paymentRes = ref1[1], deliveryRes = ref1[2];
                    _tmp8 = {};
                    return [
                        4,
                        clients/* OrderClient.getInvoicesByOrderId */.ZT.getInvoicesByOrderId((_tmp8.ctx = ctx, _tmp8.orderId = orderId, _tmp8))
                    ];
                case 4:
                    invoiceRes = _state.sent();
                    if ((0,clients/* isValid */.JY)(invoiceRes)) {
                        invoiceData = (0,clients/* getFirst */.Xi)(invoiceRes);
                        order.invoices = (invoiceData === null || invoiceData === void 0 ? void 0 : invoiceData.invoices) || [];
                    }
                    // }
                    order.invoiceInfo = (0,clients/* getFirst */.Xi)(invoiceRes);
                    paymentInfo = (0,clients/* getFirst */.Xi)(paymentRes);
                    deliveryInfo = (0,clients/* getFirst */.Xi)(deliveryRes);
                    order.paymentMethodName = paymentInfo === null || paymentInfo === void 0 ? void 0 : paymentInfo.name;
                    order.deliveryMethodName = (deliveryInfo === null || deliveryInfo === void 0 ? void 0 : deliveryInfo.name) || null;
                    orderRes.data = [
                        order
                    ];
                    if (!(0,clients/* isValidWithoutData */.Wk)(productsRes)) {
                        return [
                            2,
                            orderRes
                        ];
                    }
                    products = (0,clients/* getData */.Yu)(productsRes, []);
                    // check can edit :  order have item combo or deal can't edit
                    order.canEdit = order.canEdit && products.filter(function(item) {
                        return item && (item.type === Enums/* ENUM_ORDER_TYPE.DEAL */.eb.DEAL || item.type === Enums/* ENUM_ORDER_TYPE.COMBO */.eb.COMBO || item.type === Enums/* ENUM_ORDER_TYPE.CAMPAIGN */.eb.CAMPAIGN);
                    }).length === 0;
                    _tmp9 = {};
                    return [
                        4,
                        getInfoOrderItem((_tmp9.orderItems = products, _tmp9.ctx = ctx, _tmp9))
                    ];
                case 5:
                    orderItemInfoRes = _state.sent();
                    order.products = products;
                    _tmp10 = {};
                    comboProductsInfo = _tmp10;
                    if (!getCombo) return [
                        3,
                        7
                    ];
                    getProductInfoBySubSkus = function() {
                        var _ref = (0,_async_to_generator/* default */.Z)(function() {
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                return [
                                    2,
                                    Promise.all(products.map(function() {
                                        var _ref = (0,_async_to_generator/* default */.Z)(function(product) {
                                            var _subItems, subItems, comboList, skuArr, comboListInfo, _tmp, mapProductCombo, _tmp1;
                                            return (0,tslib_es6.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        _subItems = product.subItems, subItems = _subItems === void 0 ? [] : _subItems;
                                                        comboList = [];
                                                        skuArr = subItems.reduce(function(pV, cV) {
                                                            return pV.concat(cV.sku);
                                                        }, []);
                                                        _tmp = {};
                                                        return [
                                                            4,
                                                            (0,ProductServiceV2/* getProductInfoMapFromSkus */.Pc)((_tmp.ctx = ctx, _tmp.skus = skuArr, _tmp.customerLevel = customerLevel, _tmp.locationCode = locationCode, _tmp))
                                                        ];
                                                    case 1:
                                                        comboListInfo = _state.sent();
                                                        _tmp1 = {};
                                                        if ((0,clients/* isValid */.JY)(comboListInfo)) {
                                                            mapProductCombo = (0,clients/* getFirst */.Xi)(comboListInfo, _tmp1);
                                                            comboList = (subItems === null || subItems === void 0 ? void 0 : subItems.map(function(item) {
                                                                return (0,_object_spread/* default */.Z)({}, mapProductCombo[item === null || item === void 0 ? void 0 : item.sku], item);
                                                            })) || null;
                                                        }
                                                        return [
                                                            2,
                                                            comboList
                                                        ];
                                                }
                                            });
                                        });
                                        return function(product) {
                                            return _ref.apply(this, arguments);
                                        };
                                    }()))
                                ];
                            });
                        });
                        return function getProductInfoBySubSkus() {
                            return _ref.apply(this, arguments);
                        };
                    }();
                    return [
                        4,
                        getProductInfoBySubSkus()
                    ];
                case 6:
                    comboProductsInfo = _state.sent();
                    _state.label = 7;
                case 7:
                    if ((0,clients/* isValid */.JY)(orderItemInfoRes)) {
                        orderItemInfoMap = orderItemInfoRes.data[0];
                        order.products = order.products.map(function(product, key) {
                            var ref;
                            return (0,_object_spread/* default */.Z)({
                                comboList: comboProductsInfo[key] || null,
                                productInfo: orderItemInfoMap[product === null || product === void 0 ? void 0 : product.sku] || {},
                                campaign: ((ref = orderItemInfoMap[product === null || product === void 0 ? void 0 : product.sku]) === null || ref === void 0 ? void 0 : ref.campaign) || {}
                            }, product);
                        });
                    }
                    orderRes.data = [
                        order
                    ];
                    return [
                        2,
                        orderRes
                    ];
            }
        });
    });
    return function getOrderDetail(_) {
        return _ref.apply(this, arguments);
    };
}();
// get order report ( order report file )
var getOrderReport = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx, orderId, ref, orderRes, _tmp, order, _tmp1, productIds, productList, _tmp2;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ctx = param.ctx, orderId = param.orderId;
                    _tmp = {};
                    return [
                        4,
                        clients/* OrderClient.getOrderById */.ZT.getOrderById((_tmp.id = Number(orderId), _tmp.ctx = ctx, _tmp))
                    ];
                case 1:
                    orderRes = _state.sent();
                    if (!(0,clients/* isValid */.JY)(orderRes)) {
                        return [
                            2,
                            orderRes
                        ];
                    }
                    _tmp1 = {};
                    order = (0,clients/* getFirst */.Xi)(orderRes, _tmp1);
                    productIds = (ref = order.orderItems) === null || ref === void 0 ? void 0 : ref.map(function(product) {
                        return product.productID;
                    });
                    _tmp2 = {};
                    return [
                        4,
                        ProductServiceV2/* default.getProductsByIds */.ZP.getProductsByIds((_tmp2.ids = productIds, _tmp2))
                    ];
                case 2:
                    productList = _state.sent();
                    order.products = (0,clients/* getData */.Yu)(productList);
                    orderRes.data = [
                        order
                    ];
                    return [
                        2,
                        orderRes
                    ];
            }
        });
    });
    return function getOrderReport(_) {
        return _ref.apply(this, arguments);
    };
}();
var getOrders = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx, status, offset, limit, q, orderRes, _tmp, orderListData, orders;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ctx = param.ctx, status = param.status, offset = param.offset, limit = param.limit, q = param.q;
                    _tmp = {};
                    return [
                        4,
                        clients/* OrderClient.getOrders */.ZT.getOrders((_tmp.status = status, _tmp.ctx = ctx, _tmp.offset = offset, _tmp.limit = limit, _tmp.q = q, _tmp))
                    ];
                case 1:
                    orderRes = _state.sent();
                    if (!(0,clients/* isValid */.JY)(orderRes)) return [
                        2,
                        orderRes
                    ];
                    orderListData = (0,clients/* getData */.Yu)(orderRes);
                    return [
                        4,
                        Promise.all(orderListData.map(function() {
                            var _ref = (0,_async_to_generator/* default */.Z)(function(order) {
                                var createdTime, orderStatus, orderCode, orderId, invoiceInfo, _tmp, invoiceRes, _tmp1, canEdit, productRes, _tmp2, products, _tmp3, _tmp4, _tmp5, _tmp6, _tmp7, _tmp8, _tmp9, _tmp10;
                                return (0,tslib_es6.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            createdTime = order.createdTime, orderStatus = order.status, orderCode = order.orderCode, orderId = order.orderId;
                                            _tmp = {};
                                            invoiceInfo = _tmp;
                                            _tmp1 = {};
                                            return [
                                                4,
                                                clients/* OrderClient.getInvoicesByOrderId */.ZT.getInvoicesByOrderId((_tmp1.ctx = ctx, _tmp1.orderId = orderId, _tmp1))
                                            ];
                                        case 1:
                                            invoiceRes = _state.sent();
                                            canEdit = orderStatus === Enums/* ENUM_ORDER_STATUS.WAIT_TO_CONFIRM */.TJ.WAIT_TO_CONFIRM && +new Date() - +new Date(createdTime) <= MINUTES_30;
                                            _tmp2 = {};
                                            return [
                                                4,
                                                clients/* OrderClient.getProductByOrderCode */.ZT.getProductByOrderCode((_tmp2.orderCode = orderCode, _tmp2.ctx = ctx, _tmp2))
                                            ];
                                        case 2:
                                            productRes = _state.sent();
                                            products = productRes.data;
                                            _tmp3 = {};
                                            _tmp4 = {};
                                            if (!(0,clients/* isValid */.JY)(invoiceRes)) return [
                                                2,
                                                (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)(_tmp3, order), (_tmp4.invoiceInfo = invoiceInfo, _tmp4.products = products, _tmp4))
                                            ];
                                            //  const invoiceData = getFirst(invoiceRes);
                                            // invoices = invoiceData?.invoices || [];
                                            invoiceInfo = (0,clients/* getFirst */.Xi)(invoiceRes);
                                            _tmp5 = {};
                                            _tmp6 = {};
                                            //  }
                                            if (!canEdit) return [
                                                2,
                                                (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)(_tmp5, order), (_tmp6.canEdit = canEdit, _tmp6.invoiceInfo = invoiceInfo, _tmp6.products = products, _tmp6))
                                            ];
                                            _tmp7 = {};
                                            _tmp8 = {};
                                            if (!(0,clients/* isValid */.JY)(productRes)) return [
                                                2,
                                                (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)(_tmp7, order), (_tmp8.canEdit = canEdit, _tmp8.products = products, _tmp8))
                                            ];
                                            canEdit = products.filter(function(item) {
                                                return item && item.type !== Enums/* ENUM_ORDER_TYPE.NORMAL */.eb.NORMAL;
                                            }).length === 0;
                                            _tmp9 = {};
                                            _tmp10 = {};
                                            return [
                                                2,
                                                (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)(_tmp9, order), (_tmp10.canEdit = canEdit, _tmp10.invoiceInfo = invoiceInfo, _tmp10.products = products, _tmp10))
                                            ];
                                    }
                                });
                            });
                            return function(order) {
                                return _ref.apply(this, arguments);
                            };
                        }()))
                    ];
                case 2:
                    orders = _state.sent();
                    orderRes.data = orders;
                    return [
                        2,
                        orderRes
                    ];
            }
        });
    });
    return function getOrders(_) {
        return _ref.apply(this, arguments);
    };
}();
var getAllOrders = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx, status, orderRes, _tmp, orderListData, orders;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ctx = param.ctx, status = param.status;
                    _tmp = {};
                    return [
                        4,
                        clients/* OrderClient.getAllOrders */.ZT.getAllOrders((_tmp.status = status, _tmp.ctx = ctx, _tmp))
                    ];
                case 1:
                    orderRes = _state.sent();
                    if (!(0,clients/* isValid */.JY)(orderRes)) return [
                        2,
                        orderRes
                    ];
                    orderListData = (0,clients/* getData */.Yu)(orderRes);
                    return [
                        4,
                        Promise.all(orderListData.map(function() {
                            var _ref = (0,_async_to_generator/* default */.Z)(function(order) {
                                var orderCode, productRes, _tmp, _tmp1, productsInfo, _tmp2, _tmp3;
                                return (0,tslib_es6.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            orderCode = order.orderCode;
                                            _tmp = {};
                                            return [
                                                4,
                                                clients/* OrderClient.getProductByOrderCode */.ZT.getProductByOrderCode((_tmp.orderCode = orderCode, _tmp.ctx = ctx, _tmp))
                                            ];
                                        case 1:
                                            productRes = _state.sent();
                                            _tmp1 = {};
                                            if (!(0,clients/* isValid */.JY)(productRes)) return [
                                                2,
                                                (0,_object_spread/* default */.Z)(_tmp1, order)
                                            ];
                                            productsInfo = productRes.data;
                                            _tmp2 = {};
                                            _tmp3 = {};
                                            return [
                                                2,
                                                (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)(_tmp2, order), (_tmp3.productsInfo = productsInfo, _tmp3))
                                            ];
                                    }
                                });
                            });
                            return function(order) {
                                return _ref.apply(this, arguments);
                            };
                        }()))
                    ];
                case 2:
                    orders = _state.sent();
                    orderRes.data = orders;
                    return [
                        2,
                        orderRes
                    ];
            }
        });
    });
    return function getAllOrders(_) {
        return _ref.apply(this, arguments);
    };
}();
var getOrderInvoiceFee = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx, orderId, res, _tmp, data;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ctx = param.ctx, orderId = param.orderId;
                    _tmp = {};
                    return [
                        4,
                        clients/* OrderClient.getInvoiceFee */.ZT.getInvoiceFee((_tmp.ctx = ctx, _tmp.orderId = orderId, _tmp))
                    ];
                case 1:
                    res = _state.sent();
                    data = (0,clients/* getData */.Yu)(res);
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function getOrderInvoiceFee(_) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var OrderService = ({
    deleteOrder: deleteOrder,
    getOrderDetail: getOrderDetail,
    getOrders: getOrders,
    getInfoOrderItem: getInfoOrderItem,
    getOrderCountInWeek: getOrderCountInWeek,
    getOrderCountInWeekStartDate: getOrderCountInWeekStartDate,
    getOrderById: getOrderById,
    getOrderInvoiceFee: getOrderInvoiceFee,
    getOrderReport: getOrderReport
});

// EXTERNAL MODULE: ./src/utils/FormatNumber.js
var FormatNumber = __webpack_require__(44097);
;// CONCATENATED MODULE: ./src/services/PromoService.js











var parseReward = function(reward) {
    if (!reward) {
        return null;
    }
    var type = reward.type, absoluteDiscount = reward.absoluteDiscount;
    switch(type){
        case Enums/* PROMO_REWARD_TYPE.ABSOLUTE */.k0.ABSOLUTE:
            return {
                message: "Giảm ".concat((0,FormatNumber/* formatCurrency */.xG)(absoluteDiscount))
            };
        default:
            return null;
    }
};
var parseCondition = function(condition) {
    if (!condition) return null;
    var type = condition.type, minOrderValue = condition.minOrderValue, productConditions = condition.productConditions;
    var message = [];
    switch(type){
        case "ORDER_VALUE":
            if (minOrderValue) {
                message.push("Gi\xe1 trị đơn h\xe0ng từ ".concat((0,FormatNumber/* formatCurrency */.xG)(minOrderValue)));
            }
            break;
        case "PRODUCT_TAG":
            if (productConditions) {
                productConditions.forEach(function(_item) {
                    var sellerCodes = _item.sellerCodes, minQuantity = _item.minQuantity;
                    message.push("Cần mua \xedt nhất ".concat((0,FormatNumber/* formatNumber */.uf)(minQuantity), " sản phẩm c\xf3 m\xe3 {productTag} của người b\xe1n ").concat(sellerCodes.join(","), "\n          "));
                });
            }
            break;
        case "PRODUCT":
            if (productConditions) {
                productConditions.forEach(function(_item) {
                    var productId = _item.productId, sellerCodes = _item.sellerCodes, minQuantity = _item.minQuantity;
                    message.push("Cần mua \xedt nhất ".concat((0,FormatNumber/* formatNumber */.uf)(minQuantity), " sản phẩm c\xf3 m\xe3 ").concat(productId, " của người b\xe1n ").concat(sellerCodes.join(","), "\n          "));
                });
            }
            break;
        case "PRODUCT_CATEGORY":
            if (productConditions) {
                productConditions.forEach(function(_item) {
                    var productId = _item.productId, sellerCodes = _item.sellerCodes, minQuantity = _item.minQuantity;
                    message.push("Cần mua \xedt nhất ".concat((0,FormatNumber/* formatNumber */.uf)(minQuantity), " sản phẩm c\xf3 hoạt chất ").concat(productId, " của người b\xe1n ").concat(sellerCodes.join(","), "\n          "));
                });
            }
            break;
        case "PRODUCER":
            if (productConditions) {
                productConditions.forEach(function(_item) {
                    var producerCode = _item.producerCode, sellerCodes = _item.sellerCodes, minQuantity = _item.minQuantity;
                    message.push("Cần mua \xedt nhất ".concat((0,FormatNumber/* formatNumber */.uf)(minQuantity), " sản phẩm của nh\xe0 sản xuất ").concat(producerCode, " của người b\xe1n ").concat(sellerCodes.join(",")));
                });
            }
            break;
        case "INGREDIENT":
            if (productConditions) {
                productConditions.forEach(function(_item) {
                    var ingredientCode = _item.ingredientCode, sellerCodes = _item.sellerCodes, minQuantity = _item.minQuantity;
                    message.push("Cần mua \xedt nhất ".concat((0,FormatNumber/* formatNumber */.uf)(minQuantity), " sản phẩm c\xf3 hoạt chất ").concat(ingredientCode, " của người b\xe1n ").concat(sellerCodes.join(","), "\n          "));
                });
            }
            break;
        case "NO_RULE":
            break;
        default:
    }
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, condition), {
        message: message
    });
};
var parseListReward = function(rewards) {
    return rewards === null || rewards === void 0 ? void 0 : rewards.map(function(reward) {
        return parseReward(reward);
    });
};
var parseListCondition = function(conditions) {
    return conditions === null || conditions === void 0 ? void 0 : conditions.map(function(cond) {
        return parseCondition(cond);
    });
};
var parseVoucherDetail = function(voucherInfo) {
    if (!voucherInfo) return null;
    var _rewards = voucherInfo.rewards, rewards = _rewards === void 0 ? [] : _rewards, _conditions = voucherInfo.conditions, conditions = _conditions === void 0 ? [] : _conditions;
    var rewardsVi = parseListReward(rewards);
    var conditionsVi = parseListCondition(conditions) || {};
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, voucherInfo), {
        rewardsVi: rewardsVi,
        conditionsVi: conditionsVi
    });
};
var getPromotionDetailByVoucherCode = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var voucherCode, res, _tmp, voucherInfo, ref, conditions, rewards, _tmp1, _tmp2, _tmp3;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    voucherCode = param.voucherCode;
                    if ((0,ValidateUtils/* isEmpty */.xb)(voucherCode)) {
                        return [
                            2,
                            null
                        ];
                    }
                    _tmp = {};
                    return [
                        4,
                        clients/* PromoClient.getPromoDetailByVoucherCode */.yK.getPromoDetailByVoucherCode((_tmp.voucherCode = voucherCode, _tmp))
                    ];
                case 1:
                    res = _state.sent();
                    voucherInfo = (0,clients/* getFirst */.Xi)(res);
                    _tmp1 = {};
                    ref = (voucherInfo === null || voucherInfo === void 0 ? void 0 : voucherInfo.promotion) || _tmp1, conditions = ref.conditions, rewards = ref.rewards;
                    _tmp2 = {};
                    _tmp3 = {};
                    return [
                        2,
                        parseVoucherDetail((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)(_tmp2, voucherInfo), (_tmp3.conditions = conditions, _tmp3.rewards = rewards, _tmp3)))
                    ];
            }
        });
    });
    return function getPromotionDetailByVoucherCode(_) {
        return _ref.apply(this, arguments);
    };
}();
var beautyPromo = function(param) {
    var conditions = param.conditions, code = param.code, endTime = param.endTime, promotionName = param.promotionName, description = param.description, promotionType = param.promotionType, status = param.status, type = param.type, voucherId = param.voucherId, rewards = param.rewards, startTime = param.startTime, voucherCodes = param.voucherCodes;
    return {
        conditions: conditions,
        code: code,
        endTime: endTime,
        promotionName: promotionName,
        description: description,
        promotionType: promotionType,
        status: status,
        type: type,
        voucherId: voucherId,
        rewards: rewards,
        startTime: startTime,
        voucherCodes: voucherCodes
    };
};
function getPromoActive(_) {
    return _getPromoActive.apply(this, arguments);
}
function _getPromoActive() {
    _getPromoActive = (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx, promoRes, _tmp, promos;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ctx = param.ctx;
                    _tmp = {};
                    return [
                        4,
                        clients/* PromoClient.getPromosActive */.yK.getPromosActive((_tmp.ctx = ctx, _tmp))
                    ];
                case 1:
                    promoRes = _state.sent();
                    if (!(0,clients/* isValid */.JY)(promoRes)) {
                        return [
                            2,
                            []
                        ];
                    }
                    promos = (0,clients/* getData */.Yu)(promoRes);
                    return [
                        2,
                        promos.map(function(item) {
                            return beautyPromo(item);
                        })
                    ];
            }
        });
    });
    return _getPromoActive.apply(this, arguments);
}
var validateScopes = function(param) {
    var regionCode = param.regionCode, scopes = param.scopes, provinceCode = param.provinceCode, _regionList = param.regionList, regionList = _regionList === void 0 ? [] : _regionList;
    // validate
    var result = true;
    if (scopes && (regionCode || regionList)) {
        scopes.forEach(function(item) {
            switch(item.type){
                case "AREA":
                    if (item.quantityType === "MANY") {
                        var ref, ref1;
                        result = (item === null || item === void 0 ? void 0 : (ref = item.areaCodes) === null || ref === void 0 ? void 0 : ref.indexOf(regionCode)) >= 0 || (item === null || item === void 0 ? void 0 : (ref1 = item.areaCodes) === null || ref1 === void 0 ? void 0 : ref1.indexOf(provinceCode)) >= 0;
                        // nếu check ko có province / region ở trên thì mới check tiếp danh sách region
                        if (!result && (regionList === null || regionList === void 0 ? void 0 : regionList.length) > 0) {
                            var ref2, ref3;
                            result = ((ref3 = item === null || item === void 0 ? void 0 : (ref2 = item.areaCodes) === null || ref2 === void 0 ? void 0 : ref2.filter(function(areaCode) {
                                return (regionList === null || regionList === void 0 ? void 0 : regionList.indexOf(areaCode)) >= 0;
                            })) === null || ref3 === void 0 ? void 0 : ref3.length) > 0 || false;
                        }
                    } else {
                        result = true;
                    }
                    break;
                default:
            }
        });
    }
    return result;
};
function getVouchersActiveOrder(_) {
    return _getVouchersActiveOrder.apply(this, arguments);
}
function _getVouchersActiveOrder() {
    _getVouchersActiveOrder = // get voucher active
    (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx, voucherRes, _tmp, vouchers;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ctx = param.ctx;
                    _tmp = {};
                    return [
                        4,
                        clients/* PromoClient.getVoucherActiveOrder */.yK.getVoucherActiveOrder((_tmp.ctx = ctx, _tmp))
                    ];
                case 1:
                    voucherRes = _state.sent();
                    if (!(0,clients/* isValid */.JY)(voucherRes)) {
                        return [
                            2,
                            []
                        ];
                    }
                    vouchers = (0,clients/* getData */.Yu)(voucherRes);
                    return [
                        2,
                        vouchers.filter(function(voucherItem) {
                            var _voucher = voucherItem.voucher, voucher = _voucher === void 0 ? {} : _voucher, _userPromotion = voucherItem.userPromotion, userPromotion = _userPromotion === void 0 ? {} : _userPromotion;
                            var _amount = userPromotion.amount, amount = _amount === void 0 ? 0 : _amount;
                            var maxUsagePerCustomer = voucher.maxUsagePerCustomer, maxUsage = voucher.maxUsage, _usageTotal = voucher.usageTotal, usageTotal = _usageTotal === void 0 ? 0 : _usageTotal;
                            // validate scopes
                            // const { scopes = [] } = promotion;
                            // const isValidateScope = validateScopes({ scopes, regionCode, provinceCode });
                            var checkMaxUsage = !(maxUsage && usageTotal >= maxUsage || maxUsagePerCustomer && amount >= maxUsagePerCustomer);
                            return checkMaxUsage;
                        }).map(function(voucherItem) {
                            var _voucher = voucherItem.voucher, voucher = _voucher === void 0 ? {} : _voucher, _userPromotion = voucherItem.userPromotion, userPromotion = _userPromotion === void 0 ? {} : _userPromotion, _conditionDescription = voucherItem.conditionDescription, conditionDescription = _conditionDescription === void 0 ? "" : _conditionDescription, _canUse = voucherItem.canUse, canUse = _canUse === void 0 ? false : _canUse;
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, voucher), {
                                userPromotion: userPromotion,
                                conditionDescription: conditionDescription,
                                canUse: canUse
                            });
                        })
                    ];
            }
        });
    });
    return _getVouchersActiveOrder.apply(this, arguments);
}
function getVouchersActive(_) {
    return _getVouchersActive.apply(this, arguments);
}
function _getVouchersActive() {
    _getVouchersActive = // get voucher active
    (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx, _regionCode, regionCode, _regionList, regionList, voucherRes, _tmp, vouchers;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ctx = param.ctx, _regionCode = param.regionCode, regionCode = _regionCode === void 0 ? null : _regionCode, _regionList = param.regionList, regionList = _regionList === void 0 ? [] : _regionList;
                    _tmp = {};
                    return [
                        4,
                        clients/* PromoClient.getVoucherActive */.yK.getVoucherActive((_tmp.ctx = ctx, _tmp))
                    ];
                case 1:
                    voucherRes = _state.sent();
                    if (!(0,clients/* isValid */.JY)(voucherRes)) {
                        return [
                            2,
                            []
                        ];
                    }
                    vouchers = (0,clients/* getData */.Yu)(voucherRes);
                    return [
                        2,
                        vouchers.filter(function(voucherItem) {
                            var _voucher = voucherItem.voucher, voucher = _voucher === void 0 ? {} : _voucher, _userPromotion = voucherItem.userPromotion, userPromotion = _userPromotion === void 0 ? {} : _userPromotion;
                            var _amount = userPromotion.amount, amount = _amount === void 0 ? 0 : _amount;
                            var maxUsagePerCustomer = voucher.maxUsagePerCustomer, maxUsage = voucher.maxUsage, _usageTotal = voucher.usageTotal, usageTotal = _usageTotal === void 0 ? 0 : _usageTotal, _promotion = voucher.promotion, promotion = _promotion === void 0 ? {} : _promotion;
                            // validate scopes
                            var _scopes = promotion.scopes, scopes = _scopes === void 0 ? [] : _scopes;
                            var isValidateScope = validateScopes({
                                scopes: scopes,
                                regionCode: regionCode,
                                regionList: regionList
                            });
                            var checkMaxUsage = !(maxUsage && usageTotal >= maxUsage || maxUsagePerCustomer && amount >= maxUsagePerCustomer);
                            return isValidateScope && checkMaxUsage;
                        }).map(function(voucherItem) {
                            var _voucher = voucherItem.voucher, voucher = _voucher === void 0 ? {} : _voucher, _userPromotion = voucherItem.userPromotion, userPromotion = _userPromotion === void 0 ? {} : _userPromotion;
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, voucher), {
                                userPromotion: userPromotion
                            });
                        })
                    ];
            }
        });
    });
    return _getVouchersActive.apply(this, arguments);
}
function getMyVoucher(_) {
    return _getMyVoucher.apply(this, arguments);
}
function _getMyVoucher() {
    _getMyVoucher = (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx, offset, limit, voucherRes, _tmp, vouchers, promotionIDs, promoRes, _tmp1, promoMap, _tmp2, promos;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ctx = param.ctx, offset = param.offset, limit = param.limit;
                    _tmp = {};
                    return [
                        4,
                        clients/* PromoClient.getMyVoucher */.yK.getMyVoucher((_tmp.ctx = ctx, _tmp.offset = offset, _tmp.limit = limit, _tmp))
                    ];
                case 1:
                    voucherRes = _state.sent();
                    vouchers = (0,clients/* getData */.Yu)(voucherRes);
                    promotionIDs = vouchers.map(function(voucher) {
                        var ref;
                        return ((ref = voucher.voucher) === null || ref === void 0 ? void 0 : ref.promotionId) || 0;
                    });
                    _tmp1 = {};
                    return [
                        4,
                        clients/* PromoClient.getPromotionListByIDs */.yK.getPromotionListByIDs((_tmp1.ctx = ctx, _tmp1.promotionIDs = promotionIDs, _tmp1))
                    ];
                case 2:
                    promoRes = _state.sent();
                    if (!(0,clients/* isValid */.JY)(promoRes)) return [
                        2,
                        vouchers
                    ];
                    _tmp2 = {};
                    promoMap = _tmp2;
                    promos = (0,clients/* getData */.Yu)(promoRes);
                    promos.forEach(function(promo) {
                        promoMap[promo.promotionId] = promo;
                    });
                    return [
                        2,
                        vouchers.map(function(voucherInfo) {
                            var ref = voucherInfo || {}, _voucher = ref.voucher, voucher = _voucher === void 0 ? {} : _voucher;
                            var ref1 = promoMap[voucher.promotionId] || {}, conditions = ref1.conditions, rewards = ref1.rewards;
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, promoMap[voucher.promotionId], parseVoucherDetail((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, voucher), {
                                conditions: conditions,
                                rewards: rewards
                            }))), {
                                isExpired: utils/* DateTimeUtils.compareTime */.IM.compareTime(voucher.endTime, Date.now()) < 0,
                                used: (voucherInfo === null || voucherInfo === void 0 ? void 0 : voucherInfo.userPromotion) || {}
                            });
                        })
                    ];
            }
        });
    });
    return _getMyVoucher.apply(this, arguments);
}
// deprecated 22Feb2023 - Dinh Tran
// export const parseListConditionVoucher = (vouchers = [], regionCode) =>
//   vouchers.reduce((voucherList, promo) => {
//     const { conditions, voucherCodes = [], rewards, promotionType } = promo;
//     return [
//       ...voucherList,
//       ...voucherCodes?.map((v) =>
//         parseVoucherDetail({
//           ...v,
//           conditions,
//           rewards,
//           promotionType,
//           regionCode,
//         }),
//       ),
//     ];
//   }, []);
var isHaveGift = function(voucher) {
    return (voucher === null || voucher === void 0 ? void 0 : voucher.rewards) && voucher.rewards.length > 0 && voucher.rewards[0].gifts && voucher.rewards[0].gifts.length > 0;
};
// deprecated 22Feb2023 - Dinh Tran
// export const convertVouchers = async ({ vouchers }) => {
//   vouchers?.reduce((voucherList, promo) => {
//     const { conditions, voucherCodes = [], rewards } = promo;
//     return [
//       ...voucherList,
//       ...voucherCodes?.map((voucher) => {
//         const rewardsVi = parseListReward(rewards);
//         const conditionsVi = parseListCondition(conditions);
//         return { ...voucher, rewardsVi, conditionsVi };
//       }),
//     ];
//   });
//   const skus = vouchers
//     .filter((voucher) => isHaveGift(voucher))
//     .reduce((acc, cur) => {
//       const giftCodes = cur.rewards[0].gifts.map((gift) => gift.sku);
//       return [...acc, ...giftCodes];
//     }, []);
//   let voucherList = vouchers;
//   const productMapRes = await ProductServiceV2.getProductInfoMapFromSkus({ skus, getPrice: false });
//   if (isValid(productMapRes)) {
//     const productMap = getFirst(productMapRes);
//     voucherList = vouchers.map((voucher) => {
//       if (isHaveGift(voucher)) {
//         const { gifts } = voucher.rewards[0];
//         const giftList = [];
//         gifts.forEach((gift) => {
//           giftList.push(productMap[gift.sku]);
//         });
//         return {
//           ...voucher,
//           giftList,
//           promotionType: PROMO_REWARD_TYPE.GIFT,
//         };
//       }
//       return voucher;
//     });
//   }
//   return voucherList;
// };
// cheat
var getVouchers = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var getProductBySkus, vouchers, _tmp, skus, voucherList, productMapRes, _tmp1, productMap;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    getProductBySkus = param.getProductBySkus;
                    _tmp = {};
                    return [
                        4,
                        getVouchersActiveOrder(_tmp)
                    ];
                case 1:
                    vouchers = _state.sent().map(function(item) {
                        var ref;
                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (item === null || item === void 0 ? void 0 : item.promotion) || {}, item), {
                            rewardsVi: parseListReward(item === null || item === void 0 ? void 0 : (ref = item.promotion) === null || ref === void 0 ? void 0 : ref.rewards)
                        });
                    });
                    skus = vouchers.filter(function(voucher) {
                        return isHaveGift(voucher);
                    }).reduce(function(acc, cur) {
                        var giftCodes = cur.rewards[0].gifts.map(function(gift) {
                            return gift.sku;
                        });
                        return (0,_to_consumable_array/* default */.Z)(acc).concat((0,_to_consumable_array/* default */.Z)(giftCodes));
                    }, []);
                    voucherList = vouchers;
                    _tmp1 = {};
                    return [
                        4,
                        getProductBySkus((_tmp1.skus = skus, _tmp1.getPrice = false, _tmp1))
                    ];
                case 2:
                    productMapRes = _state.sent();
                    if ((0,clients/* isValid */.JY)(productMapRes)) {
                        productMap = (0,clients/* getFirst */.Xi)(productMapRes);
                        voucherList = vouchers.map(function(voucher) {
                            if (isHaveGift(voucher)) {
                                var gifts = voucher.rewards[0].gifts;
                                var giftList = [];
                                gifts.forEach(function(gift) {
                                    giftList.push(productMap[gift.sku]);
                                });
                                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, voucher), {
                                    giftList: giftList,
                                    promotionType: Enums/* PROMO_REWARD_TYPE.GIFT */.k0.GIFT
                                });
                            }
                            return voucher;
                        });
                    }
                    return [
                        2,
                        voucherList
                    ];
            }
        });
    });
    return function getVouchers(_) {
        return _ref.apply(this, arguments);
    };
}();
var getPromoCodeDetail = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(voucherCode) {
        var promoDetailResult, _tmp, data, promotion, giftList, isGift, skus, productMapRes, _tmp1, _tmp2, _tmp3;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    return [
                        4,
                        clients/* PromoClient.getPromoDetailByVoucherCode */.yK.getPromoDetailByVoucherCode((_tmp.voucherCode = voucherCode, _tmp))
                    ];
                case 1:
                    promoDetailResult = _state.sent();
                    if (!(0,clients/* isValid */.JY)(promoDetailResult)) {
                        return [
                            2,
                            promoDetailResult
                        ];
                    }
                    data = (0,clients/* getFirst */.Xi)(promoDetailResult);
                    promotion = data.promotion;
                    giftList = [];
                    isGift = isHaveGift(promotion);
                    if (!isGift) return [
                        3,
                        3
                    ];
                    skus = promotion.rewards[0].gifts.map(function(item) {
                        return item.sku;
                    });
                    _tmp1 = {};
                    return [
                        4,
                        ProductServiceV2/* default.getProductInfoMapFromSkus */.ZP.getProductInfoMapFromSkus((_tmp1.skus = skus, _tmp1.getPrice = false, _tmp1))
                    ];
                case 2:
                    productMapRes = _state.sent();
                    if ((0,clients/* isValid */.JY)(productMapRes)) {
                        giftList = Object.values((0,clients/* getFirst */.Xi)(productMapRes));
                    }
                    _state.label = 3;
                case 3:
                    _tmp2 = {};
                    _tmp3 = {};
                    return [
                        2,
                        (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)(_tmp2, promoDetailResult), (_tmp3.data = [
                            parseVoucherDetail((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, promotion, data), {
                                voucherCodes: [
                                    (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
                                        promotion: null
                                    })
                                ],
                                giftList: giftList
                            })), 
                        ], _tmp3))
                    ];
            }
        });
    });
    return function getPromoCodeDetail(voucherCode) {
        return _ref.apply(this, arguments);
    };
}();
// regionList : danh sách mã vùng ( region )
var getClassifyVoucherCodes = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx, regionCode, regionList, vouchers, _tmp, myVouchers, otherVouchers, _tmp1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ctx = param.ctx, regionCode = param.regionCode, regionList = param.regionList;
                    _tmp = {};
                    return [
                        4,
                        getVouchersActiveOrder((_tmp.ctx = ctx, _tmp.regionCode = regionCode, _tmp.regionList = regionList, _tmp))
                    ];
                case 1:
                    vouchers = _state.sent();
                    myVouchers = vouchers.filter(function(voucher) {
                        return (voucher === null || voucher === void 0 ? void 0 : voucher.appliedCustomers) && voucher.appliedCustomers.length > 0;
                    });
                    otherVouchers = vouchers.filter(function(voucher) {
                        var ref;
                        return !(voucher === null || voucher === void 0 ? void 0 : (ref = voucher.appliedCustomers) === null || ref === void 0 ? void 0 : ref.length) > 0;
                    });
                    _tmp1 = {};
                    return [
                        2,
                        (_tmp1.myVouchers = myVouchers, _tmp1.otherVouchers = otherVouchers, _tmp1)
                    ];
            }
        });
    });
    return function getClassifyVoucherCodes(_) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var PromoService = ({
    getPromoActive: getPromoActive,
    getMyVoucher: getMyVoucher,
    getPromotionDetailByVoucherCode: getPromotionDetailByVoucherCode,
    parseListReward: parseListReward,
    parseReward: parseReward,
    getPromoCodeDetail: getPromoCodeDetail,
    getClassifyVoucherCodes: getClassifyVoucherCodes,
    getVouchersActive: getVouchersActive,
    getVouchers: getVouchers,
    getVouchersActiveOrder: getVouchersActiveOrder
});

// EXTERNAL MODULE: ./src/constants/APIUriV2.js
var APIUriV2 = __webpack_require__(83679);
// EXTERNAL MODULE: ./src/clients/Clients.js + 1 modules
var Clients = __webpack_require__(38307);
;// CONCATENATED MODULE: ./src/clients/RewardsClient.js




function getRewards(_) {
    return _getRewards.apply(this, arguments);
}
function _getRewards() {
    _getRewards = (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx, _offset, offset, _limit, limit, _status, status, url, params, _tmp, _tmp1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            ctx = param.ctx, _offset = param.offset, offset = _offset === void 0 ? Clients.OFFSET_DEFAULT : _offset, _limit = param.limit, limit = _limit === void 0 ? Clients.LIMIT_DEFAULT : _limit, _status = param.status, status = _status === void 0 ? null : _status;
            url = APIUriV2/* REWARDS_API */["if"];
            _tmp = {};
            params = (_tmp.offset = offset, _tmp.limit = limit, _tmp.getTotal = true, _tmp.status = status, _tmp.q = JSON.stringify({
                status: status
            }), _tmp);
            _tmp1 = {};
            return [
                2,
                (0,Clients.GET)((_tmp1.url = url, _tmp1.ctx = ctx, _tmp1.params = params, _tmp1))
            ];
        });
    });
    return _getRewards.apply(this, arguments);
}
function getRewardDetail(_) {
    return _getRewardDetail.apply(this, arguments);
}
function _getRewardDetail() {
    _getRewardDetail = (0,_async_to_generator/* default */.Z)(function(param) {
        var id, url, params, _tmp, _tmp1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            id = param.id;
            url = APIUriV2/* REWARD_DETAIL */.Jy;
            _tmp = {};
            params = (_tmp.id = id, _tmp);
            _tmp1 = {};
            return [
                2,
                (0,Clients.GET)((_tmp1.url = url, _tmp1.params = params, _tmp1))
            ];
        });
    });
    return _getRewardDetail.apply(this, arguments);
}
function getListRewardBySeller(_) {
    return _getListRewardBySeller.apply(this, arguments);
}
function _getListRewardBySeller() {
    _getListRewardBySeller = (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx, _offset, offset, _limit, limit, sellerCode, url, params, _tmp, _tmp1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            ctx = param.ctx, _offset = param.offset, offset = _offset === void 0 ? Clients.OFFSET_DEFAULT : _offset, _limit = param.limit, limit = _limit === void 0 ? Clients.LIMIT_DEFAULT : _limit, sellerCode = param.sellerCode;
            url = APIUriV2/* REWARDS_BY_SELLER */.AY;
            _tmp = {};
            params = (_tmp.offset = offset, _tmp.limit = limit, _tmp.getTotal = true, _tmp.q = JSON.stringify({
                sellerCode: sellerCode
            }), _tmp);
            _tmp1 = {};
            return [
                2,
                (0,Clients.GET)((_tmp1.url = url, _tmp1.ctx = ctx, _tmp1.params = params, _tmp1))
            ];
        });
    });
    return _getListRewardBySeller.apply(this, arguments);
}
/* harmony default export */ var RewardsClient = ({
    getRewards: getRewards,
    getRewardDetail: getRewardDetail,
    getListRewardBySeller: getListRewardBySeller
});

;// CONCATENATED MODULE: ./src/services/RewardsService.js





var getListReward = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx, offset, limit, status, result, _tmp, listReward, total, _tmp1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ctx = param.ctx, offset = param.offset, limit = param.limit, status = param.status;
                    _tmp = {};
                    return [
                        4,
                        getRewards((_tmp.ctx = ctx, _tmp.offset = offset, _tmp.limit = limit, _tmp.status = status, _tmp))
                    ];
                case 1:
                    result = _state.sent();
                    if (!(0,clients/* isValid */.JY)(result)) return [
                        2,
                        null
                    ];
                    listReward = (0,clients/* getData */.Yu)(result);
                    total = result.total;
                    _tmp1 = {};
                    // const now = new Date();
                    // const rewards = listReward.map((item) => {
                    //   if (item?.details[0]?.result === undefined) {
                    //     if (new Date(item?.startTime) > now) return { ...item, status: 'UPCOMING' };
                    //     if (new Date(item?.startTime) <= now && new Date(item?.endTime) >= now) return { ...item, status: 'IN_PROGRESS' };
                    //     return { ...item, status: 'EXPIRED' };
                    //   }
                    //   return { ...item, status: item?.details[0]?.result?.status || '' };
                    // });
                    return [
                        2,
                        (_tmp1.data = listReward, _tmp1.total = total, _tmp1)
                    ];
            }
        });
    });
    return function getListReward(_) {
        return _ref.apply(this, arguments);
    };
}();
// clone lại hàm getListReward bỏ đi parameter ctx
// lý do: get list từ Clients side => không có ctx
var getListRewardMobileV2 = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var offset, limit, status, result, _tmp, listReward, total, _tmp1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    offset = param.offset, limit = param.limit, status = param.status;
                    _tmp = {};
                    return [
                        4,
                        getRewards((_tmp.offset = offset, _tmp.limit = limit, _tmp.status = status, _tmp))
                    ];
                case 1:
                    result = _state.sent();
                    if (!(0,clients/* isValid */.JY)(result)) return [
                        2,
                        null
                    ];
                    listReward = (0,clients/* getData */.Yu)(result);
                    total = result.total;
                    _tmp1 = {};
                    return [
                        2,
                        (_tmp1.data = listReward, _tmp1.total = total, _tmp1)
                    ];
            }
        });
    });
    return function getListRewardMobileV2(_) {
        return _ref.apply(this, arguments);
    };
}();
var getNumberOfEveryStatus = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx, ref, totalRes, upcomingRes, inProcessRes, expiredRes, _tmp, _tmp1, _tmp2, _tmp3, _tmp4;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ctx = param.ctx;
                    _tmp = {};
                    _tmp1 = {};
                    _tmp2 = {};
                    _tmp3 = {};
                    return [
                        4,
                        Promise.all([
                            getRewards((_tmp.ctx = ctx, _tmp.offset = 0, _tmp.limit = 1, _tmp)),
                            getRewards((_tmp1.ctx = ctx, _tmp1.status = "UPCOMING", _tmp1.offset = 0, _tmp1.limit = 1, _tmp1)),
                            getRewards((_tmp2.ctx = ctx, _tmp2.status = "PROCESSING", _tmp2.offset = 0, _tmp2.limit = 1, _tmp2)),
                            getRewards((_tmp3.ctx = ctx, _tmp3.status = "EXPIRED", _tmp3.offset = 0, _tmp3.limit = 1, _tmp3))
                        ])
                    ];
                case 1:
                    ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                        _state.sent(),
                        4
                    ]), totalRes = ref[0], upcomingRes = ref[1], inProcessRes = ref[2], expiredRes = ref[3];
                    _tmp4 = {};
                    return [
                        2,
                        (_tmp4.ALL = (totalRes === null || totalRes === void 0 ? void 0 : totalRes.total) || 0, _tmp4.UPCOMING = (upcomingRes === null || upcomingRes === void 0 ? void 0 : upcomingRes.total) || 0, _tmp4.PROCESSING = (inProcessRes === null || inProcessRes === void 0 ? void 0 : inProcessRes.total) || 0, _tmp4.EXPIRED = (expiredRes === null || expiredRes === void 0 ? void 0 : expiredRes.total) || 0, _tmp4)
                    ];
            }
        });
    });
    return function getNumberOfEveryStatus(_) {
        return _ref.apply(this, arguments);
    };
}();
// clone lại hàm getNumberOfEveryStatus bỏ đi parameter ctx
// lý do: get list từ Clients side => không có ctx
var getNumberOfEveryStatusMobileV2 = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function() {
        var ref, totalRes, upcomingRes, inProcessRes, expiredRes, _tmp, _tmp1, _tmp2, _tmp3, _tmp4;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    _tmp1 = {};
                    _tmp2 = {};
                    _tmp3 = {};
                    return [
                        4,
                        Promise.all([
                            getRewards((_tmp.offset = 0, _tmp.limit = 1, _tmp)),
                            getRewards((_tmp1.status = "UPCOMING", _tmp1.offset = 0, _tmp1.limit = 1, _tmp1)),
                            getRewards((_tmp2.status = "PROCESSING", _tmp2.offset = 0, _tmp2.limit = 1, _tmp2)),
                            getRewards((_tmp3.status = "EXPIRED", _tmp3.offset = 0, _tmp3.limit = 1, _tmp3))
                        ])
                    ];
                case 1:
                    ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                        _state.sent(),
                        4
                    ]), totalRes = ref[0], upcomingRes = ref[1], inProcessRes = ref[2], expiredRes = ref[3];
                    _tmp4 = {};
                    return [
                        2,
                        (_tmp4.ALL = (totalRes === null || totalRes === void 0 ? void 0 : totalRes.total) || 0, _tmp4.UPCOMING = (upcomingRes === null || upcomingRes === void 0 ? void 0 : upcomingRes.total) || 0, _tmp4.PROCESSING = (inProcessRes === null || inProcessRes === void 0 ? void 0 : inProcessRes.total) || 0, _tmp4.EXPIRED = (expiredRes === null || expiredRes === void 0 ? void 0 : expiredRes.total) || 0, _tmp4)
                    ];
            }
        });
    });
    return function getNumberOfEveryStatusMobileV2() {
        return _ref.apply(this, arguments);
    };
}();
var getRewardDetailById = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
        var result, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    return [
                        4,
                        getRewardDetail((_tmp.id = id, _tmp))
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        2,
                        result
                    ];
            }
        });
    });
    return function getRewardDetailById(id) {
        return _ref.apply(this, arguments);
    };
}();
var getRewardsBySeller = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var sellerCode, result, _tmp, data, banners, _tmp1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    sellerCode = param.sellerCode;
                    _tmp = {};
                    return [
                        4,
                        getListRewardBySeller((_tmp.sellerCode = sellerCode, _tmp))
                    ];
                case 1:
                    result = _state.sent();
                    if (!(0,clients/* isValid */.JY)(result)) return [
                        2,
                        null
                    ];
                    data = (0,clients/* getData */.Yu)(result);
                    banners = [];
                    data.forEach(function(item) {
                        var _imageUrls = item.imageUrls, imageUrls = _imageUrls === void 0 ? [] : _imageUrls;
                        if (imageUrls.length > 0) banners.push(imageUrls[0]);
                    });
                    _tmp1 = {};
                    return [
                        2,
                        (_tmp1.banners = banners, _tmp1.data = data, _tmp1)
                    ];
            }
        });
    });
    return function getRewardsBySeller(_) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var RewardsService = ({
    getListReward: getListReward,
    getRewardDetailById: getRewardDetailById,
    getNumberOfEveryStatus: getNumberOfEveryStatus,
    getRewardsBySeller: getRewardsBySeller,
    getListRewardMobileV2: getListRewardMobileV2,
    getNumberOfEveryStatusMobileV2: getNumberOfEveryStatusMobileV2
});

// EXTERNAL MODULE: ./src/clients/SellerClient.js
var SellerClient = __webpack_require__(15537);
;// CONCATENATED MODULE: ./src/services/SellerService.js









// get all data for server side -> return data mapped
var getAllSellers = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx, sellerResult, _tmp, sellers, _tmp1, _tmp2;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ctx = param.ctx;
                    _tmp = {};
                    return [
                        4,
                        SellerClient/* default.getAllSellers */.Z.getAllSellers((_tmp.ctx = ctx, _tmp))
                    ];
                case 1:
                    sellerResult = _state.sent();
                    if (!(0,clients/* isValid */.JY)(sellerResult)) {
                        return [
                            2,
                            sellerResult
                        ];
                    }
                    sellers = (0,clients/* getData */.Yu)(sellerResult);
                    _tmp1 = {};
                    _tmp2 = {};
                    return [
                        2,
                        (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)(_tmp1, sellerResult), (_tmp2.data = sellers === null || sellers === void 0 ? void 0 : sellers.map(function(param) {
                            var name = param.name, code = param.code, sellerID = param.sellerID;
                            return {
                                name: name,
                                code: code,
                                sellerID: sellerID
                            };
                        }), _tmp2))
                    ];
            }
        });
    });
    return function getAllSellers(_) {
        return _ref.apply(this, arguments);
    };
}();
var getSellerBanner = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx, sellerCode, bannerResult, _tmp, bannerList, banners, _tmp1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ctx = param.ctx, sellerCode = param.sellerCode;
                    _tmp = {};
                    return [
                        4,
                        SellerClient/* default.getListBanner */.Z.getListBanner((_tmp.ctx = ctx, _tmp.sellerCode = sellerCode, _tmp))
                    ];
                case 1:
                    bannerResult = _state.sent();
                    bannerList = (0,clients/* getData */.Yu)(bannerResult);
                    banners = bannerList.map(function(item) {
                        return {
                            targetURL: (item === null || item === void 0 ? void 0 : item.link) || "",
                            imgURL: (item === null || item === void 0 ? void 0 : item.images[0]) || "",
                            name: (item === null || item === void 0 ? void 0 : item.name) || ""
                        };
                    });
                    _tmp1 = {};
                    return [
                        2,
                        (_tmp1.status = Enums/* HTTP_STATUS.Ok */.MG.Ok, _tmp1.data = banners, _tmp1)
                    ];
            }
        });
    });
    return function getSellerBanner(_) {
        return _ref.apply(this, arguments);
    };
}();
var getSellerInfo = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx, slug, infoResult, _tmp, info, ref, sellerCode, _tmp1, listStoreActive, _tmp2;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ctx = param.ctx, slug = param.slug;
                    _tmp = {};
                    return [
                        4,
                        SellerClient/* default.getSellerInfo */.Z.getSellerInfo((_tmp.ctx = ctx, _tmp.slug = slug, _tmp))
                    ];
                case 1:
                    infoResult = _state.sent();
                    if (!(0,clients/* isValid */.JY)(infoResult)) {
                        return [
                            2,
                            null
                        ];
                    }
                    info = (0,clients/* getFirst */.Xi)(infoResult);
                    _tmp1 = {};
                    ref = info || _tmp1, sellerCode = ref.code;
                    _tmp2 = {};
                    return [
                        4,
                        SellerClient/* default.getListStoreActive */.Z.getListStoreActive((_tmp2.sellerCode = sellerCode, _tmp2.ctx = ctx, _tmp2))
                    ];
                case 2:
                    listStoreActive = _state.sent();
                    if (!(0,clients/* isValid */.JY)(listStoreActive)) {
                        return [
                            2,
                            null
                        ];
                    }
                    return [
                        2,
                        info
                    ];
            }
        });
    });
    return function getSellerInfo(_) {
        return _ref.apply(this, arguments);
    };
}();
var getStoreInfo = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx, slug, infoResult, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ctx = param.ctx, slug = param.slug;
                    _tmp = {};
                    return [
                        4,
                        SellerClient/* default.getStoreInfo */.Z.getStoreInfo((_tmp.ctx = ctx, _tmp.slug = slug, _tmp))
                    ];
                case 1:
                    infoResult = _state.sent();
                    if (!(0,clients/* isValid */.JY)(infoResult)) {
                        return [
                            2,
                            null
                        ];
                    }
                    return [
                        2,
                        (0,clients/* getFirst */.Xi)(infoResult)
                    ];
            }
        });
    });
    return function getStoreInfo(_) {
        return _ref.apply(this, arguments);
    };
}();
var getListSearchStore = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx, body, listStoreActiveRes, _tmp, data, promiseAll, total, topProductsRes, topProductsArr, topProducts, sellerMapTopProduct, _tmp1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ctx = param.ctx, body = param.body;
                    _tmp = {};
                    return [
                        4,
                        SellerClient/* default.searchStore */.Z.searchStore((_tmp.ctx = ctx, _tmp.body = body, _tmp))
                    ];
                case 1:
                    listStoreActiveRes = _state.sent();
                    if (!(0,clients/* isValid */.JY)(listStoreActiveRes)) {
                        return [
                            2,
                            null
                        ];
                    }
                    data = (0,clients/* getData */.Yu)(listStoreActiveRes);
                    promiseAll = [];
                    total = listStoreActiveRes.total;
                    data.forEach(function(ele) {
                        var code = ele.code;
                        promiseAll.push(ProductServiceV2/* default.loadProductWithSeller */.ZP.loadProductWithSeller({
                            ctx: ctx,
                            code: code,
                            offset: 0,
                            limit: 3,
                            text: ""
                        }));
                    });
                    return [
                        4,
                        Promise.all(promiseAll)
                    ];
                case 2:
                    topProductsRes = _state.sent();
                    topProductsArr = [];
                    topProductsRes.forEach(function(ele) {
                        topProductsArr.push((0,clients/* getData */.Yu)(ele));
                    });
                    topProducts = topProductsArr.map(function(item) {
                        var ref;
                        var sellerCode = ((ref = item[0]) === null || ref === void 0 ? void 0 : ref.sellerCode) || "";
                        return {
                            sellerCode: sellerCode,
                            topProducts: item
                        };
                    });
                    sellerMapTopProduct = data.map(function(item) {
                        var code = item.code;
                        var obj = topProducts.find(function(ele) {
                            return ele.sellerCode === code;
                        });
                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                            product: {
                                sellerCode: code,
                                topProducts: (obj === null || obj === void 0 ? void 0 : obj.topProducts.slice(0, 3)) || {}
                            }
                        });
                    });
                    _tmp1 = {};
                    return [
                        2,
                        (_tmp1.sellerMapTopProduct = sellerMapTopProduct, _tmp1.total = total, _tmp1)
                    ];
            }
        });
    });
    return function getListSearchStore(_) {
        return _ref.apply(this, arguments);
    };
}();
var getSearchStoreByName = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx, params, listStoreRes, _tmp, data, promiseAll, total, topProductsRes, topProductsArr, topProducts, sellerMapTopProduct, _tmp1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ctx = param.ctx, params = param.params;
                    _tmp = {};
                    return [
                        4,
                        SellerClient/* default.searchStoreByText */.Z.searchStoreByText((_tmp.ctx = ctx, _tmp.params = params, _tmp))
                    ];
                case 1:
                    listStoreRes = _state.sent();
                    if (!(0,clients/* isValid */.JY)(listStoreRes)) {
                        return [
                            2,
                            null
                        ];
                    }
                    data = (0,clients/* getData */.Yu)(listStoreRes);
                    promiseAll = [];
                    total = listStoreRes.total;
                    data.forEach(function(ele) {
                        var code = ele.code;
                        promiseAll.push(ProductServiceV2/* default.loadProductWithSeller */.ZP.loadProductWithSeller({
                            ctx: ctx,
                            code: code,
                            offset: 0,
                            limit: 3,
                            text: ""
                        }));
                    });
                    return [
                        4,
                        Promise.all(promiseAll)
                    ];
                case 2:
                    topProductsRes = _state.sent();
                    topProductsArr = [];
                    topProductsRes.forEach(function(ele) {
                        topProductsArr.push((0,clients/* getData */.Yu)(ele));
                    });
                    topProducts = topProductsArr.map(function(item) {
                        var ref;
                        var sellerCode = ((ref = item[0]) === null || ref === void 0 ? void 0 : ref.sellerCode) || "";
                        return {
                            sellerCode: sellerCode,
                            topProducts: item
                        };
                    });
                    sellerMapTopProduct = data.map(function(item) {
                        var code = item.code;
                        var obj = topProducts.find(function(ele) {
                            return ele.sellerCode === code;
                        });
                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                            product: {
                                sellerCode: code,
                                topProducts: (obj === null || obj === void 0 ? void 0 : obj.topProducts.slice(0, 3)) || {}
                            }
                        });
                    });
                    _tmp1 = {};
                    return [
                        2,
                        (_tmp1.sellerMapTopProduct = sellerMapTopProduct, _tmp1.total = total, _tmp1)
                    ];
            }
        });
    });
    return function getSearchStoreByName(_) {
        return _ref.apply(this, arguments);
    };
}();
var getSearchProducts = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx, body, result, _tmp, deals, _tmp1, now, data, _tmp2, _tmp3;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ctx = param.ctx, body = param.body;
                    _tmp = {};
                    return [
                        4,
                        SellerClient/* default.searchProductInSellers */.Z.searchProductInSellers((_tmp.ctx = ctx, _tmp.body = body, _tmp))
                    ];
                case 1:
                    result = _state.sent();
                    if (!(0,clients/* isValid */.JY)(result)) return [
                        2,
                        result
                    ];
                    _tmp1 = {};
                    return [
                        4,
                        (0,ProductServiceV2/* mapDataProduct */.Fz)((_tmp1.ctx = ctx, _tmp1.result = result, _tmp1))
                    ];
                case 2:
                    deals = _state.sent();
                    now = new Date();
                    data = (0,clients/* getData */.Yu)(deals, []).filter(function(item) {
                        var ref, ref1;
                        return (item === null || item === void 0 ? void 0 : (ref = item.deal) === null || ref === void 0 ? void 0 : ref.readyTime) && new Date(item === null || item === void 0 ? void 0 : (ref1 = item.deal) === null || ref1 === void 0 ? void 0 : ref1.readyTime) < now;
                    });
                    _tmp2 = {};
                    _tmp3 = {};
                    return [
                        2,
                        (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)(_tmp2, deals), (_tmp3.data = data, _tmp3))
                    ];
            }
        });
    });
    return function getSearchProducts(_) {
        return _ref.apply(this, arguments);
    };
}();
var getLandingPageSeller = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx, sellerCode, result, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ctx = param.ctx, sellerCode = param.sellerCode;
                    _tmp = {};
                    return [
                        4,
                        SellerClient/* default.getLandingPageSeller */.Z.getLandingPageSeller((_tmp.ctx = ctx, _tmp.sellerCode = sellerCode, _tmp))
                    ];
                case 1:
                    result = _state.sent();
                    if (!(0,clients/* isValid */.JY)(result)) return [
                        2,
                        null
                    ];
                    return [
                        2,
                        (0,clients/* getFirst */.Xi)(result)
                    ];
            }
        });
    });
    return function getLandingPageSeller(_) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var SellerService = ({
    getAllSellers: getAllSellers,
    getSellerBanner: getSellerBanner,
    getSellerInfo: getSellerInfo,
    getListSearchStore: getListSearchStore,
    getSearchProducts: getSearchProducts,
    getLandingPageSeller: getLandingPageSeller,
    getStoreInfo: getStoreInfo,
    getSearchStoreByName: getSearchStoreByName
});

;// CONCATENATED MODULE: ./src/clients/SmartRecommendationClient.js




var getRecommendProduct = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx, body, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            ctx = param.ctx, body = param.body;
            _tmp = {};
            return [
                2,
                (0,Clients.POST)((_tmp.url = APIUriV2/* SMART_RECOMMENDATION_API.RECOMMEND */.hX.RECOMMEND, _tmp.ctx = ctx, _tmp.body = body, _tmp))
            ];
        });
    });
    return function getRecommendProduct(_) {
        return _ref.apply(this, arguments);
    };
}();
var getRecommendProductForHomePage = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx, body, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            ctx = param.ctx, body = param.body;
            _tmp = {};
            return [
                2,
                (0,Clients.POST)((_tmp.url = APIUriV2/* SMART_RECOMMENDATION_API.RECOMMEND_FOR_HOMEPAGE */.hX.RECOMMEND_FOR_HOMEPAGE, _tmp.ctx = ctx, _tmp.body = body, _tmp))
            ];
        });
    });
    return function getRecommendProductForHomePage(_) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var SmartRecommendationClient = ({
    getRecommendProduct: getRecommendProduct,
    getRecommendProductForHomePage: getRecommendProductForHomePage
});

;// CONCATENATED MODULE: ./src/services/SmartRecommendationService.js

var getRecommendation = function(param) {
    var ctx = param.ctx, body = param.body;
    return getRecommendProduct({
        ctx: ctx,
        body: body
    });
};
var getRecommendationForHomePage = function(param) {
    var ctx = param.ctx, body = param.body;
    return getRecommendProductForHomePage({
        ctx: ctx,
        body: body
    });
};
/* harmony default export */ var SmartRecommendationService = ({
    getRecommendation: getRecommendation,
    getRecommendationForHomePage: getRecommendationForHomePage
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
;// CONCATENATED MODULE: ./src/clients/AccountingClient.js




var getDebt = function(param) {
    var customerId = param.customerId, ctx = param.ctx;
    return (0,Clients.POST)({
        url: APIUriV2/* ACCOUNTING_API.debt */.EL.debt,
        body: {
            q: {
                customerId: customerId
            }
        },
        ctx: ctx
    });
};
var getDebtCheck = function(param) {
    var customerId = param.customerId, ctx = param.ctx;
    return (0,Clients.POST)({
        url: APIUriV2/* ACCOUNTING_API.DEBT_CHECK */.EL.DEBT_CHECK,
        body: {
            customerId: customerId
        },
        ctx: ctx
    });
};
var getListOrders = function(param) {
    var orderId = param.orderId, ctx = param.ctx;
    return (0,Clients.POST)({
        url: APIUriV2/* ACCOUNTING_API.DEBT_ORDER */.EL.DEBT_ORDER,
        body: {
            q: {
                orderId: orderId
            }
        },
        ctx: ctx,
        debug: false
    });
};
// curl --location --request POST 'https://api.v2-stg.thuocsi.vn/payment/wallet/v1/me/transaction/list' \
// --data-raw '{
//     "q": {
//         "status": "SUCCESS",
//         "moneySource": "CREDIT"
//     }
// }'
var getListTransactions = function(_param) {
    var orderId = _param.orderId, _debug = _param.debug, debug = _debug === void 0 ? false : _debug, _status = _param.status, status = _status === void 0 ? null : _status, _moneySource = _param.moneySource, moneySource = _moneySource === void 0 ? "CREDIT" : _moneySource, ctx = _param.ctx, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "orderId",
        "debug",
        "status",
        "moneySource",
        "ctx"
    ]);
    return (0,Clients.POST)({
        url: APIUriV2/* PAYMENT_WALLET_API.TRANSACTIONS */.Tz.TRANSACTIONS,
        body: {
            q: (0,_object_spread/* default */.Z)({
                refAll: [
                    "ORDER/".concat(orderId)
                ],
                moneySource: moneySource,
                status: status
            }, restProps),
            debug: debug
        },
        ctx: ctx
    });
};
/* harmony default export */ var AccountingClient = ({
    getDebt: getDebt,
    getDebtCheck: getDebtCheck,
    getListOrders: getListOrders,
    getListTransactions: getListTransactions
});

// EXTERNAL MODULE: ./src/constants/Paths/index.js
var Paths = __webpack_require__(199);
// EXTERNAL MODULE: ./src/constants/ToggleFeature/index.js
var ToggleFeature = __webpack_require__(71523);
// EXTERNAL MODULE: ./src/sysconfig/index.js
var sysconfig = __webpack_require__(66225);
// EXTERNAL MODULE: ./src/utils/CookieParser.js
var CookieParser = __webpack_require__(44777);
// EXTERNAL MODULE: ./src/utils/InactiveCustomerUtils.js
var InactiveCustomerUtils = __webpack_require__(29183);
// EXTERNAL MODULE: ./src/clients/CatClientV2.js
var CatClientV2 = __webpack_require__(12141);
// EXTERNAL MODULE: ./src/constants/manufacturer.js
var manufacturer = __webpack_require__(59893);
// EXTERNAL MODULE: ./src/utils/CacheUtils.js
var CacheUtils = __webpack_require__(85618);
;// CONCATENATED MODULE: ./src/services/MockService.js












var KEY_CACHE_BANNERS = "API_BANNERS";
var getBanners = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(ctx) {
        var ref, data, bannerRes;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    data = CacheUtils/* default.getCacheValue */.Z.getCacheValue(KEY_CACHE_BANNERS);
                    if (data) {
                        return [
                            2,
                            data
                        ];
                    }
                    return [
                        4,
                        clients/* MarketingClient.getListBanner */.c.getListBanner(ctx)
                    ];
                case 1:
                    bannerRes = _state.sent();
                    data = (0,clients/* isValid */.JY)(bannerRes) ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, bannerRes), {
                        data: (ref = (0,clients/* getData */.Yu)(bannerRes)) === null || ref === void 0 ? void 0 : ref.filter(function(item) {
                            return item && item.isVisible;
                        }).map(function(item) {
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                                createdTime: null,
                                lastUpdatedTime: null,
                                _id: null
                            });
                        })
                    }) : null;
                    CacheUtils/* default.setCacheKeyobject */.Z.setCacheKeyobject(KEY_CACHE_BANNERS, data);
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function getBanners(ctx) {
        return _ref.apply(this, arguments);
    };
}();
var KEY_CACHE_POLICIES = "API_POLICIES";
var getPolicies = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(ctx) {
        var ref, data, policiesRes;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    data = CacheUtils/* default.getCacheValue */.Z.getCacheValue(KEY_CACHE_POLICIES);
                    if (data) {
                        return [
                            2,
                            data
                        ];
                    }
                    return [
                        4,
                        clients/* MarketingClient.getPolicies */.c.getPolicies(ctx)
                    ];
                case 1:
                    policiesRes = _state.sent();
                    data = (0,clients/* isValid */.JY)(policiesRes) ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, policiesRes), {
                        data: (ref = (0,clients/* getData */.Yu)(policiesRes)) === null || ref === void 0 ? void 0 : ref.filter(function(item) {
                            return item && !item.isDelete && item.status === "ON";
                        }).map(function(item) {
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                                createdTime: null,
                                lastUpdatedTime: null,
                                _id: null
                            });
                        })
                    }) : null;
                    CacheUtils/* default.setCacheKeyobject */.Z.setCacheKeyobject(KEY_CACHE_POLICIES, data);
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function getPolicies(ctx) {
        return _ref.apply(this, arguments);
    };
}();
var KEY_CACHE_TAGS = "API_TAGS";
var getTags = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function() {
        var ref, data, tagsRes, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    data = CacheUtils/* default.getCacheValue */.Z.getCacheValue(KEY_CACHE_TAGS);
                    if (data) {
                        return [
                            2,
                            data
                        ];
                    }
                    _tmp = {};
                    return [
                        4,
                        clients/* ProductClientV2.getSettingTags */.j4.getSettingTags(_tmp)
                    ];
                case 1:
                    tagsRes = _state.sent();
                    data = (ref = (0,clients/* getData */.Yu)(tagsRes)) === null || ref === void 0 ? void 0 : ref.map(function(param) {
                        var _code = param.code, code = _code === void 0 ? null : _code, _name = param.name, name = _name === void 0 ? null : _name, _slug = param.slug, slug = _slug === void 0 ? null : _slug, _textColor = param.textColor, textColor = _textColor === void 0 ? null : _textColor, _preIcon = param.preIcon, preIcon = _preIcon === void 0 ? null : _preIcon, _nameAsTooltip = param.nameAsTooltip, nameAsTooltip = _nameAsTooltip === void 0 ? null : _nameAsTooltip, _style = param.style, style = _style === void 0 ? null : _style, _visible = param.visible, visible = _visible === void 0 ? false : _visible, _priority = param.priority, priority = _priority === void 0 ? null : _priority;
                        return {
                            code: code,
                            name: name,
                            slug: slug,
                            textColor: textColor,
                            preIcon: preIcon,
                            nameAsTooltip: nameAsTooltip,
                            style: style,
                            visible: visible,
                            priority: priority
                        };
                    });
                    CacheUtils/* default.setCacheKey */.Z.setCacheKey(KEY_CACHE_TAGS, data);
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function getTags() {
        return _ref.apply(this, arguments);
    };
}();
var KEY_CACHE_TABS = "API_TABS";
var getTabs = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function() {
        var ref, ref1, data, tabResult, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    data = CacheUtils/* default.getCacheValue */.Z.getCacheValue(KEY_CACHE_TABS);
                    if (data) {
                        return [
                            2,
                            data
                        ];
                    }
                    _tmp = {};
                    return [
                        4,
                        clients/* ProductClientV2.getTabs */.j4.getTabs(_tmp)
                    ];
                case 1:
                    tabResult = _state.sent();
                    data = (ref1 = (ref = (0,clients/* getData */.Yu)(tabResult)) === null || ref === void 0 ? void 0 : ref.sort(function(a, b) {
                        return ((a === null || a === void 0 ? void 0 : a.ordinalNumber) || 0) - ((b === null || b === void 0 ? void 0 : b.ordinalNumber) || 0);
                    })) === null || ref1 === void 0 ? void 0 : ref1.map(function(param) {
                        var name = param.name, slug = param.slug, type = param.type, _value = param.value, value = _value === void 0 ? null : _value;
                        return {
                            name: name,
                            slug: slug,
                            type: type,
                            value: value
                        };
                    });
                    CacheUtils/* default.setCacheKey */.Z.setCacheKey(KEY_CACHE_TABS, data);
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function getTabs() {
        return _ref.apply(this, arguments);
    };
}();
var KEY_CACHE_COUNTRIES = "API_MASTER_DATA_COUNTRY";
var getListCountries = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function() {
        var data, countryRes, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    data = CacheUtils/* default.getCacheValue */.Z.getCacheValue(KEY_CACHE_COUNTRIES);
                    if (!!data) return [
                        3,
                        2
                    ];
                    _tmp = {};
                    return [
                        4,
                        clients/* AddressClient.getAllCountries */.uQ.getAllCountries(_tmp)
                    ];
                case 1:
                    countryRes = _state.sent();
                    data = (0,clients/* getData */.Yu)(countryRes);
                    CacheUtils/* default.setCacheKey */.Z.setCacheKey(KEY_CACHE_COUNTRIES, data);
                    _state.label = 2;
                case 2:
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function getListCountries() {
        return _ref.apply(this, arguments);
    };
}();
var KEY_CACHE_PROVINCES = "API_MASTER_DATA_PROVINCES";
var getListProvinves = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function() {
        var data, provinesRes;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    data = CacheUtils/* default.getCacheValue */.Z.getCacheValue(KEY_CACHE_PROVINCES);
                    if (!!data) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        clients/* AddressClient.getProvinces */.uQ.getProvinces()
                    ];
                case 1:
                    provinesRes = _state.sent();
                    data = (0,clients/* getData */.Yu)(provinesRes);
                    CacheUtils/* default.setCacheKey */.Z.setCacheKey(KEY_CACHE_PROVINCES, data);
                    _state.label = 2;
                case 2:
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function getListProvinves() {
        return _ref.apply(this, arguments);
    };
}();
var KEY_CACHE_SELLERS = "API_SELLERS";
var getListSellers = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function() {
        var data, sellersRes, _tmp, dataSellers;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    data = CacheUtils/* default.getCacheValue */.Z.getCacheValue(KEY_CACHE_SELLERS);
                    if (!!data) return [
                        3,
                        2
                    ];
                    _tmp = {};
                    return [
                        4,
                        clients/* SellerClient.getAllSellers */.vQ.getAllSellers(_tmp)
                    ];
                case 1:
                    sellersRes = _state.sent();
                    dataSellers = (0,clients/* getData */.Yu)(sellersRes);
                    data = dataSellers === null || dataSellers === void 0 ? void 0 : dataSellers.map(function(param) {
                        var name = param.name, code = param.code, sellerID = param.sellerID;
                        return {
                            name: name,
                            code: code,
                            sellerID: sellerID
                        };
                    });
                    CacheUtils/* default.setCacheKey */.Z.setCacheKey(KEY_CACHE_SELLERS, data);
                    _state.label = 2;
                case 2:
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function getListSellers() {
        return _ref.apply(this, arguments);
    };
}();
var KEY_CACHE_HASHTAG_TOP_SEARCH = "API_HASHTAG_TOP_SEARCH";
var getListHashtagTopSearch = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function() {
        var data, ref, ref1, ref2, topSearchRes, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    data = CacheUtils/* default.getCacheValue */.Z.getCacheValue(KEY_CACHE_HASHTAG_TOP_SEARCH);
                    if (!!data) return [
                        3,
                        2
                    ];
                    _tmp = {};
                    return [
                        4,
                        (0,clients/* GET */.HT)((_tmp.url = APIUriV2/* MARKETING_API.HASHTAG_TOP_SEARCH */.ud.HASHTAG_TOP_SEARCH, _tmp.isBasic = true, _tmp.cache = true, _tmp.cacheServer = false, _tmp))
                    ];
                case 1:
                    topSearchRes = _state.sent();
                    data = ((ref2 = (ref1 = topSearchRes === null || topSearchRes === void 0 ? void 0 : (ref = topSearchRes.data) === null || ref === void 0 ? void 0 : ref.filter(function(item) {
                        if (!(item === null || item === void 0 ? void 0 : item.isActive)) return false;
                        var currentTime = new Date();
                        var startDisplayTime = new Date(item.startDisplayTime);
                        if (currentTime < startDisplayTime) return false;
                        var endDisplayTime = new Date(item.endDisplayTime);
                        if (currentTime > endDisplayTime) return false;
                        return true;
                    })) === null || ref1 === void 0 ? void 0 : ref1.sort(function(hashtag1, hashtag2) {
                        return (hashtag1 === null || hashtag1 === void 0 ? void 0 : hashtag1.ordinalNumber) - (hashtag2 === null || hashtag2 === void 0 ? void 0 : hashtag2.ordinalNumber);
                    })) === null || ref2 === void 0 ? void 0 : ref2.map(function(param) {
                        var _code = param.code, code = _code === void 0 ? "" : _code, _hashtag = param.hashtag, hashtag = _hashtag === void 0 ? "" : _hashtag, _url = param.url, url = _url === void 0 ? "" : _url;
                        return {
                            code: code,
                            hashtag: hashtag,
                            url: (url === null || url === void 0 ? void 0 : url.startsWith(sysconfig/* WEB_HOST */.Ul)) ? url.replace(sysconfig/* WEB_HOST */.Ul, "") : url
                        };
                    })) || [];
                    CacheUtils/* default.setCacheKey */.Z.setCacheKey(KEY_CACHE_HASHTAG_TOP_SEARCH, data);
                    _state.label = 2;
                case 2:
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function getListHashtagTopSearch() {
        return _ref.apply(this, arguments);
    };
}();
var KEY_CACHE_COUNTDOWN_BAR = "API_COUNTDOWN_BAR";
// countdown bar cần ẩn/hiện đúng thời điểm start/end nên chỉ cache raw list trong thời gian ngắn,
// còn filter theo isActive/startDisplayTime/endDisplayTime phải chạy lại trên mỗi request
var TTL_CACHE_COUNTDOWN_BAR = 60;
var getListCountdownBar = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function() {
        var ref, ref1, rawCountdownBars, countdownBarRes, _tmp, currentTime;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    rawCountdownBars = CacheUtils/* default.getCacheValue */.Z.getCacheValue(KEY_CACHE_COUNTDOWN_BAR);
                    if (!!rawCountdownBars) return [
                        3,
                        2
                    ];
                    _tmp = {};
                    return [
                        4,
                        (0,clients/* GET */.HT)((_tmp.url = APIUriV2/* MARKETING_API.COUNTDOWN_BAR */.ud.COUNTDOWN_BAR, _tmp.isBasic = true, _tmp.cache = true, _tmp.cacheServer = false, _tmp))
                    ];
                case 1:
                    countdownBarRes = _state.sent();
                    rawCountdownBars = (countdownBarRes === null || countdownBarRes === void 0 ? void 0 : countdownBarRes.data) || [];
                    CacheUtils/* default.setCacheKey */.Z.setCacheKey(KEY_CACHE_COUNTDOWN_BAR, rawCountdownBars, TTL_CACHE_COUNTDOWN_BAR);
                    _state.label = 2;
                case 2:
                    currentTime = new Date();
                    return [
                        2,
                        ((ref1 = (ref = rawCountdownBars === null || rawCountdownBars === void 0 ? void 0 : rawCountdownBars.filter(function(item) {
                            if (!(item === null || item === void 0 ? void 0 : item.isActive)) return false;
                            var startDisplayTime = new Date(item.startDisplayTime);
                            if (currentTime < startDisplayTime) return false;
                            var endDisplayTime = new Date(item.endDisplayTime);
                            if (currentTime > endDisplayTime) return false;
                            return true;
                        })) === null || ref === void 0 ? void 0 : ref.sort(function(cd1, cd2) {
                            var startDisplayTimeCD1 = new Date(cd1 === null || cd1 === void 0 ? void 0 : cd1.startDisplayTime);
                            var startDisplayTimeCD2 = new Date(cd2 === null || cd2 === void 0 ? void 0 : cd2.startDisplayTime);
                            return startDisplayTimeCD2 - startDisplayTimeCD1;
                        })) === null || ref1 === void 0 ? void 0 : ref1.map(function(param) {
                            var _imageType = param.imageType, imageType = _imageType === void 0 ? "" : _imageType, _imageUrl = param.imageUrl, imageUrl = _imageUrl === void 0 ? "" : _imageUrl, _name = param.name, name = _name === void 0 ? "" : _name, _type = param.type, type = _type === void 0 ? "" : _type, _url = param.url, url = _url === void 0 ? "" : _url, _code = param.code, code = _code === void 0 ? "" : _code, _backgroundColor = param.backgroundColor, backgroundColor = _backgroundColor === void 0 ? "" : _backgroundColor, _countdownbarID = param.countdownbarID, countdownbarID = _countdownbarID === void 0 ? "" : _countdownbarID, _displayPage = param.displayPage, displayPage = _displayPage === void 0 ? "" : _displayPage;
                            return {
                                imageType: imageType,
                                imageUrl: imageUrl,
                                name: name,
                                type: type,
                                url: url,
                                code: code,
                                backgroundColor: backgroundColor,
                                countdownbarID: countdownbarID,
                                displayPage: displayPage
                            };
                        })) || []
                    ];
            }
        });
    });
    return function getListCountdownBar() {
        return _ref.apply(this, arguments);
    };
}();
var KEY_CACHE_MENU_BAR = "API_MENU_BAR";
var getMenuBar = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function() {
        var data, ref, ref1, ref2, ref3, menuBarRes, _tmp, menuBar;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    data = CacheUtils/* default.getCacheValue */.Z.getCacheValue(KEY_CACHE_MENU_BAR);
                    if (!!data) return [
                        3,
                        2
                    ];
                    _tmp = {};
                    return [
                        4,
                        (0,clients/* GET */.HT)((_tmp.url = APIUriV2/* MARKETING_API.MENU_BAR */.ud.MENU_BAR, _tmp.isBasic = true, _tmp.cache = true, _tmp.cacheServer = false, _tmp))
                    ];
                case 1:
                    menuBarRes = _state.sent();
                    menuBar = ((ref3 = menuBarRes === null || menuBarRes === void 0 ? void 0 : (ref = menuBarRes.data) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.items) === null || ref2 === void 0 ? void 0 : ref2.filter(function(item) {
                        return item === null || item === void 0 ? void 0 : item.isActive;
                    })) === null || ref3 === void 0 ? void 0 : ref3.map(function(param) {
                        var _iconUrl = param.iconUrl, iconUrl = _iconUrl === void 0 ? "" : _iconUrl, _label = param.label, label = _label === void 0 ? "" : _label, _url = param.url, url = _url === void 0 ? "" : _url;
                        return {
                            iconUrl: iconUrl,
                            label: label,
                            url: url
                        };
                    })) || [];
                    data = menuBar;
                    CacheUtils/* default.setCacheKey */.Z.setCacheKey(KEY_CACHE_MENU_BAR, data);
                    _state.label = 2;
                case 2:
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function getMenuBar() {
        return _ref.apply(this, arguments);
    };
}();
var KEY_CACHE_INSIDER_SETTING = "API_INSIDER_SETTING";
var getInsiderSetting = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function() {
        var data, ref, insiderSettingRes, _tmp, insiderSetting;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    data = CacheUtils/* default.getCacheValue */.Z.getCacheValue(KEY_CACHE_INSIDER_SETTING);
                    if (!!data) return [
                        3,
                        2
                    ];
                    _tmp = {};
                    return [
                        4,
                        (0,clients/* GET */.HT)((_tmp.url = APIUriV2/* MARKETING_API.INSIDER_SETTING */.ud.INSIDER_SETTING, _tmp.isBasic = true, _tmp.cache = true, _tmp.cacheServer = false, _tmp))
                    ];
                case 1:
                    insiderSettingRes = _state.sent();
                    insiderSetting = ((ref = (0,clients/* getFirst */.Xi)(insiderSettingRes)) === null || ref === void 0 ? void 0 : ref.isActive) || false;
                    data = insiderSetting;
                    CacheUtils/* default.setCacheKey */.Z.setCacheKey(KEY_CACHE_INSIDER_SETTING, data, 30);
                    _state.label = 2;
                case 2:
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function getInsiderSetting() {
        return _ref.apply(this, arguments);
    };
}();
var KEY_CACHE_THUMBNAIL = "API_THUMBNAIL";
var getThumbnailList = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function() {
        var data, ref, thumbnailRes, _tmp, thumbnailList, mappedThumbnailList, thumbnailMap, _tmp1, defaultThumbnail, _tmp2;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    data = CacheUtils/* default.getCacheValue */.Z.getCacheValue(KEY_CACHE_THUMBNAIL);
                    if (!!data) return [
                        3,
                        2
                    ];
                    _tmp = {};
                    return [
                        4,
                        (0,clients/* GET */.HT)((_tmp.url = APIUriV2/* MARKETING_API.THUMBNAIL */.ud.THUMBNAIL, _tmp.isBasic = true, _tmp.cache = true, _tmp.cacheServer = false, _tmp))
                    ];
                case 1:
                    thumbnailRes = _state.sent();
                    thumbnailList = (thumbnailRes === null || thumbnailRes === void 0 ? void 0 : (ref = thumbnailRes.data) === null || ref === void 0 ? void 0 : ref.filter(function(item) {
                        return item === null || item === void 0 ? void 0 : item.isActive;
                    })) || [];
                    mappedThumbnailList = thumbnailList.map(function(thumbnail) {
                        return {
                            url: thumbnail.url.replace(/^[a-zA-Z]{3,5}:\/{2}[a-zA-Z0-9_.:-]+\//, "/") || "",
                            title: thumbnail.title || "",
                            pageTitle: thumbnail.pageTitle || "",
                            description: thumbnail.description || "",
                            imageUrl: thumbnail.imageUrl || ""
                        };
                    });
                    _tmp1 = {};
                    thumbnailMap = _tmp1;
                    mappedThumbnailList === null || mappedThumbnailList === void 0 ? void 0 : mappedThumbnailList.forEach(function(thumbnail) {
                        thumbnailMap[thumbnail.url] = thumbnail;
                    });
                    _tmp2 = {};
                    defaultThumbnail = thumbnailMap[Paths/* DEFAULT_THUMBNAIL_PATH */.cW] || _tmp2;
                    data = {
                        defaultThumbnail: defaultThumbnail,
                        thumbnailMap: thumbnailMap
                    };
                    CacheUtils/* default.setCacheKey */.Z.setCacheKey(KEY_CACHE_THUMBNAIL, data);
                    _state.label = 2;
                case 2:
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function getThumbnailList() {
        return _ref.apply(this, arguments);
    };
}();
// const getProductBySlugs = async () => {};
var KEY_CACHE_CATEGORIES = "API_CATEGORIES";
var getCategories = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function() {
        var data, dataCategories, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    data = CacheUtils/* default.getCacheValue */.Z.getCacheValue(KEY_CACHE_CATEGORIES);
                    if (!!data) return [
                        3,
                        2
                    ];
                    _tmp = {};
                    return [
                        4,
                        CatClientV2/* default.loadGroup */.Z.loadGroup((_tmp.params = {
                            getCache: true,
                            limit: 100
                        }, _tmp))
                    ];
                case 1:
                    dataCategories = _state.sent();
                    data = dataCategories === null || dataCategories === void 0 ? void 0 : dataCategories.map(function(param) {
                        var _code = param.code, code = _code === void 0 ? "" : _code, _name = param.name, name = _name === void 0 ? "" : _name, _slug = param.slug, slug = _slug === void 0 ? "" : _slug;
                        return {
                            code: code,
                            name: name,
                            slug: slug
                        };
                    });
                    CacheUtils/* default.setCacheKey */.Z.setCacheKey(KEY_CACHE_CATEGORIES, data);
                    _state.label = 2;
                case 2:
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function getCategories() {
        return _ref.apply(this, arguments);
    };
}();
var KEY_CACHE_API_MANUFACTUERS = "API_MANUFACTUERS";
var getManufacturers = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function() {
        var data, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    data = CacheUtils/* default.getCacheValue */.Z.getCacheValue(KEY_CACHE_API_MANUFACTUERS);
                    if (!!data) return [
                        3,
                        2
                    ];
                    _tmp = {};
                    return [
                        4,
                        clients/* ProductClientV2.loadDataManufacturer */.j4.loadDataManufacturer(_tmp)
                    ];
                case 1:
                    data = _state.sent();
                    data = data === null || data === void 0 ? void 0 : data.map(function(param) {
                        var _code = param.code, code = _code === void 0 ? "" : _code, _name = param.name, name = _name === void 0 ? "" : _name, _slug = param.slug, slug = _slug === void 0 ? "" : _slug, _id = param.id, id = _id === void 0 ? "" : _id, _shortName = param.shortName, shortName = _shortName === void 0 ? "" : _shortName;
                        return {
                            code: code,
                            name: name,
                            slug: slug,
                            id: id,
                            shortName: shortName
                        };
                    });
                    CacheUtils/* default.setCacheKey */.Z.setCacheKey(KEY_CACHE_API_MANUFACTUERS, data);
                    _state.label = 2;
                case 2:
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function getManufacturers() {
        return _ref.apply(this, arguments);
    };
}();
var KEY_CACHE_API_TOP_MANUFACTUERS = "API_TOP_MANUFACTUERS";
var getTopManufacturers = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function() {
        var dataManufacturer, data;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        getManufacturers()
                    ];
                case 1:
                    dataManufacturer = _state.sent();
                    data = dataManufacturer === null || dataManufacturer === void 0 ? void 0 : dataManufacturer.filter(function(item) {
                        return manufacturer/* TopManufacturer.indexOf */.j.indexOf(item === null || item === void 0 ? void 0 : item.code) >= 0;
                    });
                    if (data.length === 0) {
                        data = dataManufacturer === null || dataManufacturer === void 0 ? void 0 : dataManufacturer.slice(0, 20);
                    }
                    data = data === null || data === void 0 ? void 0 : data.map(function(param) {
                        var _code = param.code, code = _code === void 0 ? "" : _code, _name = param.name, name = _name === void 0 ? "" : _name, _slug = param.slug, slug = _slug === void 0 ? "" : _slug, _id = param.id, id = _id === void 0 ? "" : _id, _shortName = param.shortName, shortName = _shortName === void 0 ? "" : _shortName;
                        return {
                            code: code,
                            name: name,
                            slug: slug,
                            id: id,
                            shortName: shortName
                        };
                    });
                    CacheUtils/* default.setCacheKey */.Z.setCacheKey(KEY_CACHE_API_TOP_MANUFACTUERS, data);
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function getTopManufacturers() {
        return _ref.apply(this, arguments);
    };
}();
var KEY_CACHE_CHAT_SETTING = "API_CHAT_SETTING";
var getChatSetting = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function() {
        var data, ref, chatSettingRes, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    data = CacheUtils/* default.getCacheValue */.Z.getCacheValue(KEY_CACHE_CHAT_SETTING);
                    if (!!data) return [
                        3,
                        2
                    ];
                    _tmp = {};
                    return [
                        4,
                        (0,clients/* GET */.HT)((_tmp.url = APIUriV2/* MARKETING_API.CHAT_SETTING */.ud.CHAT_SETTING, _tmp.isBasic = true, _tmp.cache = true, _tmp.cacheServer = false, _tmp))
                    ];
                case 1:
                    chatSettingRes = _state.sent();
                    data = ((ref = (0,clients/* getFirst */.Xi)(chatSettingRes)) === null || ref === void 0 ? void 0 : ref.value) || Enums/* ENUMS_CHAT_SETTING_VALUE.THUOCSI */.u7.THUOCSI;
                    CacheUtils/* default.setCacheKey */.Z.setCacheKey(KEY_CACHE_CHAT_SETTING, data, 30);
                    _state.label = 2;
                case 2:
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function getChatSetting() {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var MockService = ({
    getTags: getTags,
    getTabs: getTabs,
    getListCountries: getListCountries,
    getListProvinves: getListProvinves,
    getListSellers: getListSellers,
    getListHashtagTopSearch: getListHashtagTopSearch,
    getListCountdownBar: getListCountdownBar,
    getBanners: getBanners,
    getMenuBar: getMenuBar,
    getCategories: getCategories,
    getManufacturers: getManufacturers,
    getTopManufacturers: getTopManufacturers,
    getInsiderSetting: getInsiderSetting,
    getThumbnailList: getThumbnailList,
    getChatSetting: getChatSetting,
    getPolicies: getPolicies
});

// EXTERNAL MODULE: ./src/services/UserService.js
var UserService = __webpack_require__(89349);
;// CONCATENATED MODULE: ./src/services/SsrService.js
/* provided dependency */ var process = __webpack_require__(83454);
/* eslint-disable no-underscore-dangle */ /* eslint-disable no-restricted-syntax */ 

















var defaultInitZustand = [
    "tabs",
    "tags",
    "hashtagTopSearch",
    "countdownBars",
    "banners",
    "policies",
    "menuBar",
    "cateogries",
    "insiderSetting",
    "thumbnailMap",
    "chatSetting",
    "appConfig",
    "getQuantity", 
];
var convertAccountInfo = function() {
    var acc = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return {
        accountId: (acc === null || acc === void 0 ? void 0 : acc.accountId) || "",
        email: (acc === null || acc === void 0 ? void 0 : acc.email) || "",
        fullname: (acc === null || acc === void 0 ? void 0 : acc.fullname) || "",
        phoneNumber: (acc === null || acc === void 0 ? void 0 : acc.phoneNumber) || "",
        status: (acc === null || acc === void 0 ? void 0 : acc.status) || "",
        type: (acc === null || acc === void 0 ? void 0 : acc.type) || "",
        username: (acc === null || acc === void 0 ? void 0 : acc.username) || "",
        createdTime: (acc === null || acc === void 0 ? void 0 : acc.createdTime) || "",
        isTempPassword: (acc === null || acc === void 0 ? void 0 : acc.isTempPassword) || false
    };
};
var getEnvToggleFunction = function() {
    var data = {};
    for(var key in process.env){
        if (key === null || key === void 0 ? void 0 : key.startsWith(ToggleFeature/* TOGGLE_FEATURE_PREFIX */.P)) data[key] = process.env[key];
    }
    return data;
};
var toggleFeatures = getEnvToggleFunction();
var doWithServerSide = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(ctx, callback) {
        var options, _tmp, ref, timeLogs, ref1, redirect, _namespaces, namespaces, serverSideTranslations, _isGetUser, isGetUser, _inititalZustand, inititalZustand, pageTitle, _useSubTitle, useSubTitle, _useTitleFromPage, useTitleFromPage, _isGetQuantity, isGetQuantity, _tmp1, lang, i18next, _tmp2, actions, namespacesGet, title, _tmp3, urlServer, zustandList, ref2, ref3, ref4, isAuthenticated, user, initialZustandState, _tmp4, isInvalidToken, cartQuantity, _tmp5, _tmp6, ref5, isBannedAccount, _tmp7, redirectUrl, _tmp8, ref6, ref7, _tmp9, timeGetAccount, timeCallback, result, _tmp10, timeExcuteDoWithServerSide, err, _tmp11;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    options = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : _tmp;
                    timeLogs = new Date();
                    _tmp1 = {};
                    ref1 = options || _tmp1, redirect = ref1.redirect, _namespaces = ref1.namespaces, namespaces = _namespaces === void 0 ? [] : _namespaces, serverSideTranslations = ref1.serverSideTranslations, _isGetUser = ref1.isGetUser, isGetUser = _isGetUser === void 0 ? true : _isGetUser, _inititalZustand = ref1.inititalZustand, inititalZustand = _inititalZustand === void 0 ? [] : _inititalZustand, pageTitle = ref1.pageTitle, _useSubTitle = ref1.useSubTitle, useSubTitle = _useSubTitle === void 0 ? true : _useSubTitle, _useTitleFromPage = ref1.useTitleFromPage, useTitleFromPage = _useTitleFromPage === void 0 ? false : _useTitleFromPage, _isGetQuantity = ref1.isGetQuantity, isGetQuantity = _isGetQuantity === void 0 ? true : _isGetQuantity;
                    lang = CookieParser/* default.getCookieFromCtx */.Z.getCookieFromCtx(ctx, "NEXT_LOCALE") || sysconfig/* LANG_DEFAULT */.YY;
                    ctx.locale = lang;
                    _tmp2 = {};
                    i18next = _tmp2;
                    actions = [];
                    namespacesGet = [];
                    title = "";
                    _tmp3 = {};
                    if (serverSideTranslations) {
                        // i18next = await serverSideTranslations(lang, ['common', 'apiErrors', 'alert-action', ...namespaces], { i18n: { defaultLocale: lang } });
                        //  only translate title
                        actions.push(serverSideTranslations(lang, [
                            "title"
                        ], (_tmp3.i18n = {
                            defaultLocale: lang
                        }, _tmp3)).then(function(res) {
                            var ref, ref1;
                            // lấy config next 18 từ pageProps ra -> tới file title -> lấy default
                            // truyền title vào props -> trả ra cho page & _app
                            var titleTranslate = ((ref1 = res === null || res === void 0 ? void 0 : (ref = res._nextI18Next) === null || ref === void 0 ? void 0 : ref.initialI18nStore[lang]) === null || ref1 === void 0 ? void 0 : ref1.title) || {};
                            title = (titleTranslate[pageTitle] || titleTranslate["default-title"]) + (useSubTitle ? " - ".concat(titleTranslate["sub-title"]) : "");
                            i18next = res;
                        }));
                    }
                    urlServer = ctx === null || ctx === void 0 ? void 0 : (ref = ctx.req) === null || ref === void 0 ? void 0 : ref.url;
                    zustandList = urlServer.includes("loading.json") ? [] : (0,_to_consumable_array/* default */.Z)(defaultInitZustand).concat((0,_to_consumable_array/* default */.Z)(inititalZustand));
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        ,
                        7
                    ]);
                    isAuthenticated = false;
                    user = null;
                    _tmp4 = {};
                    initialZustandState = (_tmp4.toggleFeatures = toggleFeatures, _tmp4);
                    isInvalidToken = false;
                    if (zustandList === null || zustandList === void 0 ? void 0 : zustandList.includes("tabs")) {
                        MockService.getTabs().then(function(tabs) {
                            initialZustandState.tabs = tabs;
                            initialZustandState.timeTabs = new Date() - timeLogs;
                        });
                    }
                    if (zustandList === null || zustandList === void 0 ? void 0 : zustandList.includes("tags")) {
                        actions.push(MockService.getTags().then(function(tags) {
                            initialZustandState.tags = tags;
                            initialZustandState.timeTags = new Date() - timeLogs;
                        }));
                    }
                    if (zustandList === null || zustandList === void 0 ? void 0 : zustandList.includes("countries")) {
                        actions.push(MockService.getListCountries().then(function(countries) {
                            initialZustandState.countries = countries;
                            initialZustandState.timeCountries = new Date() - timeLogs;
                        }));
                    }
                    if (zustandList === null || zustandList === void 0 ? void 0 : zustandList.includes("provinces")) {
                        actions.push(MockService.getListProvinves().then(function(provinces) {
                            initialZustandState.provinces = provinces;
                            initialZustandState.timeProvinces = new Date() - timeLogs;
                        }));
                    }
                    // if (zustandList.includes('sellers')) {
                    // if (inititalZustand.includes('sellers')) {
                    //   actions.push(
                    //     MockService.getListSellers().then((sellers) => {
                    //       initialZustandState.sellers = sellers;
                    //       initialZustandState.timehashtagSellers = new Date() - timeLogs;
                    //     }),
                    //   );
                    // }
                    if (zustandList.includes("hashtagTopSearch")) {
                        actions.push(MockService.getListHashtagTopSearch().then(function(hashtags) {
                            initialZustandState.hashtagTopSearch = hashtags;
                            initialZustandState.timehashtagTopSearch = new Date() - timeLogs;
                        }));
                    }
                    if (zustandList.includes("countdownBars")) {
                        actions.push(MockService.getListCountdownBar().then(function(countdownBars) {
                            initialZustandState.countdownBars = countdownBars;
                            initialZustandState.timeCountdownBars = new Date() - timeLogs;
                        }));
                    }
                    if (zustandList.includes("banners")) {
                        actions.push(MockService.getBanners().then(function(bannerRes) {
                            initialZustandState.banners = (0,clients/* getData */.Yu)(bannerRes);
                            initialZustandState.timeBanners = new Date() - timeLogs;
                        }));
                    }
                    if (zustandList.includes("policies")) {
                        actions.push(MockService.getPolicies().then(function(policiesRes) {
                            initialZustandState.policies = (0,clients/* getData */.Yu)(policiesRes);
                            initialZustandState.timePolicies = new Date() - timeLogs;
                        }));
                    }
                    if (zustandList.includes("menuBar")) {
                        actions.push(MockService.getMenuBar().then(function(menuBarRes) {
                            initialZustandState.menuBar = menuBarRes;
                            initialZustandState.timeMenuBar = new Date() - timeLogs;
                        }));
                    }
                    if (zustandList.includes("cateogries")) {
                        actions.push(MockService.getCategories().then(function(cagories) {
                            initialZustandState.cagories = cagories || [];
                            initialZustandState.timeCateogries = new Date() - timeLogs;
                        }));
                    }
                    // if (zustandList.includes('manufacturers')) {
                    //   actions.push(
                    //     MockService.getManufacturers().then((data) => {
                    //       initialZustandState.manufacturers = data || [];
                    //       initialZustandState.timeManufacturers = new Date() - timeLogs;
                    //     }),
                    //   );
                    // }
                    // if (zustandList.includes('topManufacturers')) {
                    //   actions.push(
                    //     MockService.getTopManufacturers().then((data) => {
                    //       initialZustandState.topManufacturers = data || [];
                    //       initialZustandState.timeTopManufacturers = new Date() - timeLogs;
                    //     }),
                    //   );
                    // }
                    if (zustandList.includes("insiderSetting")) {
                        actions.push(MockService.getInsiderSetting().then(function(insiderSettingRes) {
                            initialZustandState.insiderSetting = insiderSettingRes;
                            initialZustandState.timeInsiderSetting = new Date() - timeLogs;
                        }));
                    }
                    if (zustandList.includes("thumbnailMap")) {
                        actions.push(MockService.getThumbnailList().then(function(param) {
                            var defaultThumbnail = param.defaultThumbnail, thumbnailMap = param.thumbnailMap;
                            initialZustandState.thumbnailMap = thumbnailMap;
                            initialZustandState.defaultThumbnail = defaultThumbnail;
                            initialZustandState.timeThumbnails = new Date() - timeLogs;
                        }));
                    }
                    if (zustandList.includes("chatSetting")) {
                        actions.push(MockService.getChatSetting().then(function(chatSettingRes) {
                            initialZustandState.chatSetting = chatSettingRes;
                            initialZustandState.timeChatSetting = new Date() - timeLogs;
                        }));
                    }
                    cartQuantity = null;
                    _tmp5 = {};
                    if (zustandList.includes("getQuantity") && isGetQuantity) {
                        actions.push(clients/* CartClientV2.getCartItemList */.HP.getCartItemList((_tmp5.ctx = ctx, _tmp5)).then(function(cartRes) {
                            cartQuantity = (0,clients/* getData */.Yu)(cartRes);
                        }));
                    }
                    _tmp6 = {};
                    // App config
                    if (zustandList.includes("appConfig")) {
                        actions.push(clients/* ConfigManagerClient.getAppValueByCode */.WO.getAppValueByCode((_tmp6.appCode = sysconfig/* APP_CONFIG_CODE */.pC, _tmp6)).then(function(appConfig) {
                            initialZustandState.appConfig = (0,clients/* getData */.Yu)(appConfig) || [];
                            initialZustandState.timeAppConfig = new Date() - timeLogs;
                        }));
                    }
                    if (!isGetUser) return [
                        3,
                        3
                    ];
                    actions.push(// eslint-disable-next-line consistent-return
                    (0,UserService/* getAccount */.D0)(ctx).then(function() {
                        var _ref = (0,_async_to_generator/* default */.Z)(function(customerResp) {
                            var ref, debtRes, accResp, bankInfoRes, _tmp, _tmp1, _tmp2, ref1, accData;
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        // customer info
                                        isInvalidToken = (customerResp === null || customerResp === void 0 ? void 0 : customerResp.status) === Enums/* HTTP_STATUS.Unauthorized */.MG.Unauthorized;
                                        if (!(0,clients/* isValid */.JY)(customerResp)) return [
                                            3,
                                            2
                                        ];
                                        isAuthenticated = true;
                                        user = (0,clients/* getFirst */.Xi)(customerResp);
                                        _tmp = {};
                                        _tmp1 = {};
                                        _tmp2 = {};
                                        return [
                                            4,
                                            Promise.all([
                                                AccountingClient.getDebtCheck((_tmp.customerId = user.customerID, _tmp.ctx = ctx, _tmp)),
                                                (0,UserService/* getAccountInfo */.fn)((_tmp1.ctx = ctx, _tmp1)),
                                                clients/* CustomerClient.getBankAccountInfo */.YP.getBankAccountInfo((_tmp2.ctx = ctx, _tmp2))
                                            ])
                                        ];
                                    case 1:
                                        ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                                            _state.sent(),
                                            3
                                        ]), debtRes = ref[0], accResp = ref[1], bankInfoRes = ref[2];
                                        user.logs = {
                                            timeGetAccount: customerResp.timeFetchAPI,
                                            timeGetDebt: debtRes.timeFetchAPI,
                                            timeGetAcc: accResp.timeFetchAPI,
                                            timeGetBank: bankInfoRes.timeFetchAPI
                                        };
                                        if ((0,clients/* isValid */.JY)(debtRes)) {
                                            user.debt = (0,clients/* getFirst */.Xi)(debtRes) || null;
                                            if (user === null || user === void 0 ? void 0 : user.debt) {
                                                ;
                                                user.debt.isActive = user === null || user === void 0 ? void 0 : (ref1 = user.debt) === null || ref1 === void 0 ? void 0 : ref1.isValid;
                                                user.debt.balanceFormated = (0,FormatNumber/* formatCurrency */.xG)(user.debt.balance);
                                                if (user.debt.balance <= 0) {
                                                    user.debt.balanceMessageError = "Số hạn mức khả dụng kh\xf4ng đủ, vui l\xf2ng kiểm tra lại hạn mức hoặc thanh to\xe1n để tăng lại hạn mức.";
                                                }
                                            }
                                        }
                                        if ((0,clients/* isValid */.JY)(accResp)) {
                                            accData = (0,clients/* getFirst */.Xi)(accResp);
                                            user.bank = (0,clients/* getFirst */.Xi)(bankInfoRes);
                                            user.account = convertAccountInfo((accData === null || accData === void 0 ? void 0 : accData.account) || {});
                                            user.session = accData === null || accData === void 0 ? void 0 : accData.session;
                                            user.cookiesValue = (0,clients/* getSessionToken */.YW)(ctx) || ""; // add cookies values for check for authContext
                                        }
                                        _state.label = 2;
                                    case 2:
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        return function(customerResp) {
                            return _ref.apply(this, arguments);
                        };
                    }()));
                    return [
                        4,
                        Promise.all(actions)
                    ];
                case 2:
                    _state.sent();
                    isBannedAccount = (user === null || user === void 0 ? void 0 : (ref5 = user.tags) === null || ref5 === void 0 ? void 0 : ref5.indexOf(Enums/* CUSTOMER_TAG.BAN */.lk.BAN)) >= 0;
                    _tmp7 = {};
                    if (user && isBannedAccount && (ctx === null || ctx === void 0 ? void 0 : ctx.resolvedUrl) !== "/block-account") {
                        return [
                            2,
                            (_tmp7.redirect = {
                                destination: "/block-account",
                                permanent: false
                            }, _tmp7)
                        ];
                    }
                    _tmp8 = {};
                    if (!isAuthenticated && redirect) {
                        redirectUrl = redirect.url || Paths/* GUEST_HOME_PAGE */.L7;
                        return [
                            2,
                            (_tmp8.redirect = {
                                destination: redirectUrl,
                                permanent: false
                            }, _tmp8)
                        ];
                    }
                    _tmp9 = {};
                    // BV-1886: inactive customers are kept on /onboarding until their business profile is
                    // approved (app config HIDE_PRODUCT_INACTIVE_CUSTOMER, on by default).
                    // The redirect depends on the customer, so it must never be cached publicly
                    // (some pages set a public s-maxage before calling doWithServerSide).
                    if (isAuthenticated && (0,InactiveCustomerUtils/* isInactiveCustomerLocked */.YA)(user, initialZustandState.appConfig) && !(0,InactiveCustomerUtils/* isPathAllowedForLockedCustomer */.iL)(ctx === null || ctx === void 0 ? void 0 : ctx.resolvedUrl)) {
                        ;
                        ctx === null || ctx === void 0 ? void 0 : (ref6 = ctx.res) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.setHeader) === null || ref7 === void 0 ? void 0 : ref7.call(ref6, "Cache-Control", "private, no-cache, no-store, must-revalidate");
                        return [
                            2,
                            (_tmp9.redirect = {
                                destination: Paths/* ONBOARDING */.So,
                                permanent: false
                            }, _tmp9)
                        ];
                    }
                    return [
                        3,
                        3
                    ];
                case 3:
                    timeGetAccount = new Date() - timeLogs;
                    timeCallback = new Date();
                    _tmp10 = {};
                    result = callback(ctx, user, (0,_object_spread/* default */.Z)(_tmp10, initialZustandState));
                    if (!(result && (0,_instanceof/* default */.Z)(result, Promise))) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        result
                    ];
                case 4:
                    result = _state.sent();
                    _state.label = 5;
                case 5:
                    initialZustandState.user = user;
                    initialZustandState.timeLogs = +timeLogs;
                    result = result || {};
                    result.props = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (result === null || result === void 0 ? void 0 : result.props) || {}, i18next), {
                        initialZustandState: initialZustandState,
                        lang: lang
                    });
                    result.props.user = user || null;
                    result.props.title = title;
                    result.props.lang = lang;
                    result.props.namespaces = [
                        "common",
                        "header",
                        "popup-action",
                        "alert-action",
                        "title", 
                    ].concat((0,_to_consumable_array/* default */.Z)(namespaces));
                    // SEO_CONFIG
                    if (((ref2 = result.props) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.SEO_CONFIG) === null || ref3 === void 0 ? void 0 : ref3.title) && title && useTitleFromPage) {
                        result.props.SEO_CONFIG.title += " - ".concat(title);
                    }
                    result.props.SEO_CONFIG = (result === null || result === void 0 ? void 0 : (ref4 = result.props) === null || ref4 === void 0 ? void 0 : ref4.SEO_CONFIG) || {
                        title: title
                    };
                    // result.props.accountInfo = accountInfo || null;
                    result.props.isInvalidToken = isInvalidToken;
                    timeExcuteDoWithServerSide = +new Date() - +timeLogs;
                    result.props.isAuthenticated = isAuthenticated;
                    result.props.timeExcuteCallback = +new Date() - +timeCallback;
                    result.props.timeExcuteDoWithServerSide = timeExcuteDoWithServerSide;
                    result.props.cartQuantity = cartQuantity;
                    result.props.timeGetAccount = timeGetAccount;
                    return [
                        2,
                        result
                    ];
                case 6:
                    err = _state.sent();
                    _tmp11 = {};
                    return [
                        2,
                        (_tmp11.props = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, i18next), {
                            isAuthenticated: false,
                            user: null,
                            timeExcuteDoWithServerSide: +new Date() - +timeLogs,
                            // serialize err
                            err: JSON.stringify(err, Object.getOwnPropertyNames(err))
                        }), _tmp11)
                    ];
                case 7:
                    return [
                        2
                    ];
            }
        });
    });
    return function doWithServerSide(ctx, callback) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var SsrService = ({
    doWithServerSide: doWithServerSide
});

// EXTERNAL MODULE: ./src/constants/data/index.js
var data = __webpack_require__(66520);
// EXTERNAL MODULE: ./src/constants/Images/index.js
var Images = __webpack_require__(13270);
// EXTERNAL MODULE: ./src/utils/ArrUtils.js
var ArrUtils = __webpack_require__(33769);
// EXTERNAL MODULE: ./src/utils/ImageUtils.js
var ImageUtils = __webpack_require__(13744);
// EXTERNAL MODULE: ./src/utils/PriceBreakdownUtils.js
var PriceBreakdownUtils = __webpack_require__(85998);
// EXTERNAL MODULE: ./src/utils/ProductLimitUtils.js
var ProductLimitUtils = __webpack_require__(40110);
// EXTERNAL MODULE: ./src/utils/StringUtils.js
var StringUtils = __webpack_require__(52380);
;// CONCATENATED MODULE: ./src/utils/WebServiceUtils.js

var addQueryOption = function(param) {
    var _body = param.body, body = _body === void 0 ? null : _body, _params = param.params, params = _params === void 0 ? null : _params;
    var result = {};
    if (body) {
        var newBody = (0,_object_spread/* default */.Z)({}, body) || null;
        var queryOption = {
            consumedMaxQuantity: true,
            sellerInfo: true
        };
        newBody.queryOption = queryOption;
        result.body = newBody;
    }
    if (params) {
        var newParams = (0,_object_spread/* default */.Z)({}, params) || null;
        newParams.queryOption = "consumedMaxQuantity,sellerInfo,consumedMaxQuantity";
        result.params = newParams;
    }
    return result;
};
/* harmony default export */ var WebServiceUtils = ({
    addQueryOption: addQueryOption
});

;// CONCATENATED MODULE: ./src/services/WebService.js



















/* ============= CONSTANT ============== */ var DEFAULT_SEARCH_STRATEGY = {
    text: true,
    keyword: true,
    ingredient: true
};
var mapLimitOrderDay = {
    vn: "Đặt tối đa {quantity} {unit}/ng\xe0y",
    en: "Buy maximum {quantity} {unit}/day",
    cam: "កំណត់ {quantity} អតិបរមា {unit}/ថ្ងៃ",
    th: "กำหนดสูงสุด {quantity} {unit}/วัน"
};
var mapLimitOrderTime = {
    vn: "Đặt tối đa {quantity} {unit}/lần",
    en: "Buy maximum {quantity} {unit}/order",
    cam: "ទិញអតិបរមា {quantity} {unit}/មួយដង",
    th: "ตั้งค่าสูงสุด {quantity} {unit}/ครั้ง"
};
var mapAndLimit = {
    vn: "v\xe0 {quantity} {unit}/lần",
    en: "and maximum {quantity} {unit}/order",
    cam: "និងអតិបរមា {quantity} {unit}/មួយដង",
    th: "และ {quantity} {unit}/ครั้ง"
};
/* ============= PRIVATE FUNCTION ============== */ var convertSlug = function(slug) {
    return (slug === null || slug === void 0 ? void 0 : slug.toLowerCase()) || slug;
};
// null -> '' (formatCurrency(null) ra ฿0.00)
var formatOptionalCurrency = function(value) {
    return value === null || value === undefined ? "" : (0,FormatNumber/* formatCurrency */.xG)(value) || "";
};
var findDiscountPercent = function(salePrice, displayPrice) {
    if (salePrice === displayPrice || displayPrice > salePrice) return 0;
    var percentDiscountProduct = (salePrice - displayPrice) / salePrice * 100;
    if (percentDiscountProduct > 100) percentDiscountProduct = 100;
    return Math.floor(percentDiscountProduct);
};
// limit order message, see utils/ProductLimitUtils (BV-2070)
var getLimitOrder = function(limitPerDay, limitPerOrder, unit) {
    return (0,ProductLimitUtils/* buildLimitOrderMessage */.n2)({
        limitPerDay: limitPerDay,
        limitPerOrder: limitPerOrder,
        unit: unit || "sản phẩm",
        templates: {
            perDay: mapLimitOrderDay[sysconfig/* ENV_COUNTRY */.ng],
            perOrder: mapLimitOrderTime[sysconfig/* ENV_COUNTRY */.ng],
            andPerOrder: mapAndLimit[sysconfig/* ENV_COUNTRY */.ng]
        }
    });
};
var convertProductV2 = function() {
    var item = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, isGetFullTags = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var ref, ref1, ref2;
    var ref3 = item || {}, _isAvailable = ref3.isAvailable, isAvailable = _isAvailable === void 0 ? true : _isAvailable, product = ref3.product, sku = ref3.sku, _deal = ref3.deal, deal = _deal === void 0 ? null : _deal, _nextPriceLevel = ref3.nextPriceLevel, nextPriceLevel = _nextPriceLevel === void 0 ? {} : _nextPriceLevel, _campaign = ref3.campaign, campaign = _campaign === void 0 ? null : _campaign, _skuDescription = ref3.skuDescription, skuDescription = _skuDescription === void 0 ? {} : _skuDescription, _limitPerDay = ref3.limitPerDay, limitPerDay = _limitPerDay === void 0 ? 0 : _limitPerDay, _quantityPurchasedToday = ref3.quantityPurchasedToday, quantityPurchasedToday = _quantityPurchasedToday === void 0 ? 0 : _quantityPurchasedToday, _consumedMaxQuantity = ref3.consumedMaxQuantity, consumedMaxQuantity = _consumedMaxQuantity === void 0 ? null : _consumedMaxQuantity, _withoutLogin = ref3.// feature display product without login
    withoutLogin, withoutLogin = _withoutLogin === void 0 ? false : _withoutLogin, _isProductCard = ref3.isProductCard, isProductCard = _isProductCard === void 0 ? false : _isProductCard, _consumedTags = ref3.consumedTags, consumedTags = _consumedTags === void 0 ? [] : _consumedTags, _consumedPriorityTags = ref3.consumedPriorityTags, consumedPriorityTags = _consumedPriorityTags === void 0 ? [] : _consumedPriorityTags, _consumedPrice = ref3.// BV-1586: giá sau ưu đãi do BFF trả (chỉ khi khách đã đăng nhập và engine có kết quả)
    consumedPrice, consumedPrice = _consumedPrice === void 0 ? null : _consumedPrice, _discountPriceInfo = ref3.discountPriceInfo, discountPriceInfo = _discountPriceInfo === void 0 ? null : _discountPriceInfo;
    var ref4 = product || {}, _categoryCodes = ref4.categoryCodes, categoryCodes = _categoryCodes === void 0 ? null : _categoryCodes, _name = ref4.name, name = _name === void 0 ? "" : _name, _origin = ref4.origin, origin = _origin === void 0 ? "" : _origin, _volume = ref4.volume, volume = _volume === void 0 ? null : _volume, _unit = ref4.unit, unit = _unit === void 0 ? null : _unit, _manufacturerCode = ref4.manufacturerCode, manufacturerCode = _manufacturerCode === void 0 ? null : _manufacturerCode, _ingredients = ref4.ingredients, ingredients = _ingredients === void 0 ? [] : _ingredients, _ingredientCodes = ref4.ingredientCodes, ingredientCodes = _ingredientCodes === void 0 ? [] : _ingredientCodes, _productID = ref4.productID, productID = _productID === void 0 ? "" : _productID, _documentFiles = ref4.documentFiles, documentFiles = _documentFiles === void 0 ? [] : _documentFiles, _weight = ref4.weight, weight = _weight === void 0 ? 0 : _weight, _height = ref4.height, height = _height === void 0 ? 1 : _height, _length = ref4.length, length = _length === void 0 ? 1 : _length, _width = ref4.width, width = _width === void 0 ? 1 : _width, _sellerSubCategoryCode = ref4.sellerSubCategoryCode, sellerSubCategoryCode = _sellerSubCategoryCode === void 0 ? "" : _sellerSubCategoryCode;
    var ref5 = sku || {}, _maxQuantityPerOrder = ref5.maxQuantityPerOrder, maxQuantityPerOrder = _maxQuantityPerOrder === void 0 ? null : _maxQuantityPerOrder, _productCode = ref5.productCode, productCode = _productCode === void 0 ? "" : _productCode, _retailPriceType = ref5.retailPriceType, retailPriceType = _retailPriceType === void 0 ? "" : _retailPriceType, _retailPriceValue = ref5.retailPriceValue, retailPriceValue = _retailPriceValue === void 0 ? 0 : _retailPriceValue, _sellerCode = ref5.sellerCode, sellerCode = _sellerCode === void 0 ? null : _sellerCode, _status = ref5.status, status = _status === void 0 ? "" : _status, _code = ref5.code, code = _code === void 0 ? "" : _code, _tags = ref5.tags, tags = _tags === void 0 ? [] : _tags, _slug = ref5.slug, slug = _slug === void 0 ? null : _slug, _statusData = ref5.statusData, statusData = _statusData === void 0 ? null : _statusData, type = ref5.type, _skus = ref5.skus, skus = _skus === void 0 ? [] : _skus, _point = ref5.point, point = _point === void 0 ? null : _point, _pointMultiplier = ref5.pointMultiplier, pointMultiplier = _pointMultiplier === void 0 ? null : _pointMultiplier, isActive = ref5.isActive, _lotDates = ref5.lotDates, lotDates = _lotDates === void 0 ? [] : _lotDates, _requiredCertificates = ref5.requiredCertificates, requiredCertificates = _requiredCertificates === void 0 ? [] : _requiredCertificates, _isAvailabilityForCustomerScope = ref5.isAvailabilityForCustomerScope, isAvailabilityForCustomerScope = _isAvailabilityForCustomerScope === void 0 ? true : _isAvailabilityForCustomerScope;
    var ref6 = deal || {}, maxQuantityDeal = ref6.maxQuantity;
    var tagExpired = lotDates.find(function(ele) {
        return (ele === null || ele === void 0 ? void 0 : ele.isNearExpired) === true;
    }) || {};
    var _expiredDate = tagExpired.expiredDate, expiredDate = _expiredDate === void 0 ? "" : _expiredDate, _isNearExpired = tagExpired.isNearExpired, isNearExpired = _isNearExpired === void 0 ? false : _isNearExpired;
    // giá hợp đồng
    var isContractPrice = type === "SKU_CONTRACT";
    var isDeal = deal && (deal === null || deal === void 0 ? void 0 : deal.status) === "ACTIVE" && new Date(deal === null || deal === void 0 ? void 0 : deal.startTime) <= new Date() ? true : null;
    var imageUrls = isDeal && (deal === null || deal === void 0 ? void 0 : (ref = deal.imageUrls) === null || ref === void 0 ? void 0 : ref.length) > 0 ? deal === null || deal === void 0 ? void 0 : deal.imageUrls : (item === null || item === void 0 ? void 0 : (ref1 = item.product) === null || ref1 === void 0 ? void 0 : ref1.imageUrls) || [];
    var descriptionInfo = (item === null || item === void 0 ? void 0 : item.description) || {};
    if (skuDescription && (skuDescription === null || skuDescription === void 0 ? void 0 : skuDescription.description)) {
        descriptionInfo.description = skuDescription.description;
    }
    // const salePrice = deal?.price || retailPriceValue;
    // ưu tiên campaign
    var isCampaign = !!campaign || false;
    var isHappeningCampaign = campaign && (campaign === null || campaign === void 0 ? void 0 : campaign.isShow) || false;
    // anpham: push status into tags
    var newTags = status !== "NORMAL" && status !== "NEAR_EXPIRATION" && (0,_to_consumable_array/* default */.Z)(tags).concat([
        status
    ]) || (0,_to_consumable_array/* default */.Z)(tags);
    if (isNearExpired) newTags.push("NEAR_EXPIRATION");
    // const isNew = tags?.indexOf(TAG_NEW) >= 0;
    var isNew = (consumedTags === null || consumedTags === void 0 ? void 0 : consumedTags.indexOf(sysconfig/* TAG_NEW */.cC)) >= 0;
    // logic check sản phẩm này có dc hiển thị hay ko ở đây
    var errorMessageProduct = null;
    var customMessageproduct = null;
    var requireGPPMessage = null;
    if ((sysconfig/* SELLER_CODES_REQUIRE_GPP */.uU === null || sysconfig/* SELLER_CODES_REQUIRE_GPP */.uU === void 0 ? void 0 : sysconfig/* SELLER_CODES_REQUIRE_GPP.length */.uU.length) > 0 && sellerCode && sysconfig/* SELLER_CODES_REQUIRE_GPP.indexOf */.uU.indexOf(sellerCode) >= 0) {
        // requireGPPMessage = 'Yêu cầu cung cấp GPP và giấy phép kinh doanh';
        requireGPPMessage = "requireGPPMessage";
    }
    // off isAvailable
    // feature display product without login
    if (!withoutLogin) {
        if (!retailPriceValue || retailPriceValue === 0 || status === "STOP_SELLING") {
            // errorMessageProduct = 'Đang cập nhật giá';
            errorMessageProduct = "STOP_SELLING";
        }
        if (isAvailable !== null && !isAvailable) {
            // errorMessageProduct = 'Sản phẩm chưa hỗ trợ giao vùng này';
            if (!isAvailabilityForCustomerScope) {
                errorMessageProduct = "not_support_scope";
            } else {
                errorMessageProduct = "not_support_delivery";
            }
        }
        if (!isActive) {
            // errorMessageProduct = 'Sản phẩm tạm ngưng bán';
            errorMessageProduct = "SUSPENDED";
        }
        switch(status){
            case "SUSPENDED":
                // errorMessageProduct = 'Sản phẩm đã ngưng bán';
                errorMessageProduct = "SUSPENDED";
                break;
            case "STOP_PRODUCING":
                // errorMessageProduct = 'Sản phẩm ngưng sản xuất';
                errorMessageProduct = "STOP_PRODUCING";
                break;
            case "OUT_OF_STOCK":
                // errorMessageProduct = 'Sản phẩm tạm hết hàng';
                errorMessageProduct = "OUT_OF_STOCK";
                break;
            default:
        }
    }
    var ref7;
    var dealPrice = (ref7 = isDeal && deal && (deal === null || deal === void 0 ? void 0 : deal.price)) !== null && ref7 !== void 0 ? ref7 : null;
    var imagesProxy = (0,ImageUtils/* getProxyImageList */.V5)(imageUrls);
    var isGift = status === "GIFT";
    // variable template
    // update formatedCurrency
    var displayPrice = dealPrice !== null && dealPrice !== void 0 ? dealPrice : retailPriceValue;
    // product type
    var productType = "NORMAL";
    var typeItem = "NORMAL";
    var hidenPrice = null;
    // BV-2070: the per-order limit is optional. Not configured (null/0) means "no limit", which the
    // UI already represents with MAX_PRODUCT_QTY_DISPLAY (input clamp, deal/campaign min, bulk order).
    var maxQuantityPerOrderItem = (0,ProductLimitUtils/* normalizeMaxQuantityPerOrder */.wy)(maxQuantityPerOrder);
    var maxQuantity = maxQuantityPerOrderItem;
    // percentage of quantity sold and sold out condition
    var percentDealSold;
    // available products to be able to buy in campaign
    var availableProducts;
    var discountPercentage;
    var messageLimitOrder = getLimitOrder(limitPerDay, maxQuantityPerOrderItem, unit);
    // nếu có campaign
    if (isHappeningCampaign) {
        var campaignInfo = campaign.campaign, tmp = campaign.maxQuantityPerOrder, maxQuantityPerOrderCampaign = tmp === void 0 ? maxQuantityPerOrderItem : tmp, maxQuantityCampaign = campaign.quantity, retailPriceCampaign = campaign.retailPriceValue, _soldQuantity = campaign.soldQuantity, soldQuantity = _soldQuantity === void 0 ? 0 : _soldQuantity;
        percentDealSold = soldQuantity / (campaign === null || campaign === void 0 ? void 0 : campaign.quantity) * 100;
        if (percentDealSold < 100) {
            newTags.push("DEAL");
            discountPercentage = findDiscountPercent(retailPriceValue, retailPriceCampaign);
            availableProducts = Math.min(maxQuantityCampaign - soldQuantity, (0,ProductLimitUtils/* normalizeMaxQuantityPerOrder */.wy)(maxQuantityPerOrderCampaign));
            if ((campaignInfo === null || campaignInfo === void 0 ? void 0 : campaignInfo.campaignType) === "NORMAL") {
                productType = "MEGA_DAY";
            } else if ((campaignInfo === null || campaignInfo === void 0 ? void 0 : campaignInfo.campaignType) === "FLASH_SALE") {
                productType = "FLASH_SALE";
                newTags.push(productType);
            }
            // price for campaign
            typeItem = "CAMPAIGN";
            displayPrice = retailPriceCampaign;
            maxQuantity = maxQuantityCampaign;
        } else {
            productType = "NORMAL";
            customMessageproduct = "Bạn đ\xe3 bỏ lỡ gi\xe1 khuyến m\xe3i ".concat((0,FormatNumber/* formatCurrency */.xG)(retailPriceCampaign));
        }
    } else if (isDeal) {
        productType = "DEAL";
        typeItem = "DEAL";
        // MIN
        maxQuantity = Math.min(maxQuantityDeal, maxQuantityPerOrderItem);
        discountPercentage = findDiscountPercent(retailPriceValue, dealPrice);
        newTags.push(productType);
        availableProducts = (deal === null || deal === void 0 ? void 0 : deal.maxQuantity) - (deal === null || deal === void 0 ? void 0 : deal.quantity) || 0;
        percentDealSold = ((deal === null || deal === void 0 ? void 0 : deal.quantity) || 0) / (deal === null || deal === void 0 ? void 0 : deal.maxQuantity) * 100;
    } else {
        productType = "NORMAL";
    // availableProducts = limitPerDay;
    }
    // BV-1586: giá sau ưu đãi (deal + chiết khấu thanh toán + voucher). Thiếu field thì
    // isShowPriceAfterDiscount = false và các màn hiển thị như cũ.
    var priceAfterDiscountInfo = (0,PriceBreakdownUtils/* mapPriceAfterDiscount */.Rc)({
        consumedPrice: consumedPrice,
        discountPriceInfo: discountPriceInfo,
        priceAfterDeal: item === null || item === void 0 ? void 0 : item.priceAfterDeal,
        retailPriceValue: retailPriceValue,
        withoutLogin: withoutLogin
    });
    var priceAfterDiscountFields = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, priceAfterDiscountInfo), {
        priceAfterDiscountFormated: formatOptionalCurrency(priceAfterDiscountInfo.priceAfterDiscount),
        originPriceFormated: formatOptionalCurrency(priceAfterDiscountInfo.originPrice),
        priceAfterDealFormated: formatOptionalCurrency(priceAfterDiscountInfo.priceAfterDeal)
    });
    // end
    // @deprecase
    // tag giao hang 7 days
    // if (tags?.indexOf(TAG_7DAYS) >= 0) {
    //   newTags.push('TAG_7DAYS');
    // }
    if (isProductCard) {
        var ref8;
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            consumedMaxQuantity: consumedMaxQuantity,
            isNew: isNew,
            isAvailable: isAvailable,
            defaultImage: isGift ? imagesProxy[0] || Images/* GIFT_IMAGE */.AON : imagesProxy[0] || "",
            imageUrls: imageUrls,
            originalImages: (0,ImageUtils/* getProxyImageList */.V5)((item === null || item === void 0 ? void 0 : (ref8 = item.product) === null || ref8 === void 0 ? void 0 : ref8.imageUrls) || []),
            maxQuantity: maxQuantity,
            maxQuantityPerOrder: maxQuantityPerOrderItem,
            maxQuantityPerDay: isDeal || isCampaign ? 0 : limitPerDay,
            limitPerDay: limitPerDay,
            quantityPurchasedToday: quantityPurchasedToday,
            // price
            salePrice: retailPriceValue,
            salePriceFormated: (0,FormatNumber/* formatCurrency */.xG)(retailPriceValue) || "",
            dealPrice: dealPrice,
            dealPriceFormated: (0,FormatNumber/* formatCurrency */.xG)(dealPrice) || "",
            displayPrice: displayPrice,
            displayPriceFormated: (0,FormatNumber/* formatCurrency */.xG)(displayPrice) || "",
            hidenPrice: hidenPrice
        }, priceAfterDiscountFields), {
            // sku
            sku: code,
            // combo
            skus: skus,
            skuId: productCode,
            // code
            slug: convertSlug(slug),
            status: status,
            // deal
            // nếu tồn tại campaing thì sẽ ko tồn tại deal- thuannc 06Jan2022
            deal: isCampaign ? null : deal,
            isDeal: isDeal,
            // seller
            sellerCode: sellerCode,
            seller: withoutLogin ? {} : {
                code: sellerCode,
                slug: slug
            },
            // info
            // DONE: name deal thuannc
            name: isDeal && deal && (deal === null || deal === void 0 ? void 0 : deal.name) || name,
            nameNormal: name,
            productId: productID,
            unit: unit,
            volume: (0,StringUtils/* capitalizeTextFirst */.eq)(volume),
            statusData: statusData,
            productSkuType: type,
            // tags: withoutLogin ? [] : newTags || null,
            tags: function() {
                if (withoutLogin) return [];
                if (isGetFullTags) return newTags;
                // Dùng consumedTags (danh sách đầy đủ) thay vì consumedPriorityTags: BE đã cắt
                // consumedPriorityTags xuống tối đa 2 code theo luật riêng của nó, làm rơi mất tag
                // hợp lệ trước khi FE kịp áp rule. Việc lọc `visible` + sắp xếp theo `priority` của
                // CMS + giới hạn theo surface nay do utils/TagUtils đảm nhiệm.
                // Xem docs/product-tag-display-spec.md.
                return (consumedTags === null || consumedTags === void 0 ? void 0 : consumedTags.length) ? consumedTags : consumedPriorityTags;
            }(),
            type: typeItem || null,
            productType: productType,
            isGift: isGift,
            errorMessageProduct: errorMessageProduct,
            customMessageproduct: customMessageproduct,
            requiredCertificates: requiredCertificates,
            // campaign
            isCampaign: isCampaign,
            campaign: campaign,
            discountPercent: discountPercentage || 0,
            isHappeningCampaign: isHappeningCampaign,
            availableProducts: availableProducts || 0,
            // percentage discount for progress
            percentDealSold: percentDealSold || 0,
            isContractPrice: isContractPrice,
            // plus points
            point: point,
            pointMultiplier: pointMultiplier,
            messageLimitOrder: messageLimitOrder,
            isActive: isActive,
            expiredDate: expiredDate
        });
    }
    var productInfo = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        consumedMaxQuantity: consumedMaxQuantity,
        isNew: isNew,
        isAvailable: isAvailable,
        imageUrls: imageUrls,
        imagesProxy: isGift ? imagesProxy || [
            Images/* GIFT_IMAGE */.AON
        ] : imagesProxy,
        defaultImage: isGift ? imagesProxy[0] || Images/* GIFT_IMAGE */.AON : imagesProxy[0] || "",
        originalImages: (0,ImageUtils/* getProxyImageList */.V5)((item === null || item === void 0 ? void 0 : (ref2 = item.product) === null || ref2 === void 0 ? void 0 : ref2.imageUrls) || []),
        maxQuantity: maxQuantity,
        maxQuantityPerOrder: maxQuantityPerOrderItem,
        maxQuantityPerDay: isDeal || isCampaign ? 0 : limitPerDay,
        limitPerDay: limitPerDay,
        quantityPurchasedToday: quantityPurchasedToday,
        // price
        salePrice: retailPriceValue,
        salePriceFormated: (0,FormatNumber/* formatCurrency */.xG)(retailPriceValue) || "",
        dealPrice: dealPrice,
        dealPriceFormated: (0,FormatNumber/* formatCurrency */.xG)(dealPrice) || "",
        nextPrice: isDeal || isCampaign ? 0 : (nextPriceLevel === null || nextPriceLevel === void 0 ? void 0 : nextPriceLevel.price) || 0,
        nextLevel: (nextPriceLevel === null || nextPriceLevel === void 0 ? void 0 : nextPriceLevel.code) || "",
        displayPrice: displayPrice,
        displayPriceFormated: (0,FormatNumber/* formatCurrency */.xG)(displayPrice) || "",
        hidenPrice: hidenPrice
    }, priceAfterDiscountFields), {
        // sku
        sku: code,
        // combo
        skus: skus,
        skuId: productCode,
        kind: retailPriceType,
        // code
        slug: convertSlug(slug),
        status: status,
        ingredients: ingredients,
        ingredientCodes: ingredientCodes,
        manufacturerCode: manufacturerCode,
        categoryCodes: categoryCodes,
        // type
        // deal
        // nếu tồn tại campaing thì sẽ ko tồn tại deal- thuannc 06Jan2022
        deal: isCampaign ? null : deal,
        isDeal: isDeal,
        // seller
        sellerCode: sellerCode,
        seller: withoutLogin ? {} : {
            code: sellerCode,
            slug: slug
        },
        // info
        // DONE: name deal thuannc
        name: isDeal && deal && (deal === null || deal === void 0 ? void 0 : deal.name) || name,
        nameNormal: name,
        productId: productID,
        unit: unit,
        origin: origin,
        description: descriptionInfo,
        volume: (0,StringUtils/* capitalizeTextFirst */.eq)(volume),
        weight: weight,
        productVolume: width * height * length,
        statusData: statusData,
        productSkuType: type,
        // tags: withoutLogin ? [] : newTags || null,
        tags: function() {
            if (withoutLogin) return [];
            if (isGetFullTags) return newTags;
            // xem ghi chú ở nhánh trên: dùng danh sách đầy đủ, FE tự áp rule hiển thị
            return (consumedTags === null || consumedTags === void 0 ? void 0 : consumedTags.length) ? consumedTags : consumedPriorityTags;
        }(),
        type: typeItem || null,
        productType: productType,
        isGift: isGift,
        errorMessageProduct: errorMessageProduct,
        customMessageproduct: customMessageproduct,
        requireGPPMessage: requireGPPMessage,
        requiredCertificates: requiredCertificates,
        documentFiles: documentFiles,
        // campaign
        isCampaign: isCampaign,
        campaign: campaign,
        discountPercent: discountPercentage || 0,
        isHappeningCampaign: isHappeningCampaign,
        availableProducts: availableProducts || 0,
        // percentage discount for progress
        percentDealSold: percentDealSold || 0,
        isContractPrice: isContractPrice,
        // plus points
        point: point,
        pointMultiplier: pointMultiplier,
        messageLimitOrder: messageLimitOrder,
        isActive: isActive,
        expiredDate: expiredDate,
        sellerSubCategoryCode: sellerSubCategoryCode
    });
    // ưu tiên tag theo thứ tự -> hang_dat_truoc,...
    return productInfo;
};
// BV-2408: sản phẩm thay thế (skuReplace) do frontend-apis trả kèm ProductData khi queryOption có
// isGetSKUReplace + cờ trang. Convert cùng format với SP chính để dùng lại các card sẵn có.
var convertSkuReplace = function() {
    var skuReplace = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, limitSkus = ref.limitSkus, cartObject = ref.cartObject, _withoutLogin = ref.withoutLogin, withoutLogin = _withoutLogin === void 0 ? false : _withoutLogin, _isProductCard = ref.isProductCard, isProductCard = _isProductCard === void 0 ? false : _isProductCard, _isGetFullTags = ref.isGetFullTags, isGetFullTags = _isGetFullTags === void 0 ? false : _isGetFullTags;
    var ref1;
    return ((ref1 = skuReplace === null || skuReplace === void 0 ? void 0 : skuReplace.filter(function(sub) {
        var ref;
        return sub === null || sub === void 0 ? void 0 : (ref = sub.sku) === null || ref === void 0 ? void 0 : ref.code;
    })) === null || ref1 === void 0 ? void 0 : ref1.map(function(sub) {
        var ref, ref1, ref2;
        var info = convertProductV2((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, sub), {
            limitPerDay: ((ref1 = limitSkus === null || limitSkus === void 0 ? void 0 : limitSkus.get(sub === null || sub === void 0 ? void 0 : (ref = sub.sku) === null || ref === void 0 ? void 0 : ref.itemCode)) === null || ref1 === void 0 ? void 0 : ref1.quantity) || 0,
            withoutLogin: withoutLogin,
            isProductCard: isProductCard
        }), isGetFullTags);
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, info), {
            isSKUReplace: true,
            quantity: ((ref2 = cartObject === null || cartObject === void 0 ? void 0 : cartObject.get(info.sku)) === null || ref2 === void 0 ? void 0 : ref2.quantity) || 0
        });
    })) || [];
};
var mapDataProduct = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx, result, _isGetQuantity, isGetQuantity, _withoutLogin, withoutLogin, _isAvailable, isAvailable, _isProductCard, isProductCard, _isGetFullTags, isGetFullTags, cartObject, limitSkus, ref, tmp, dataProducts, _tmp, data, skuCodes, tasks, _tmp1, _tmp2, e;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ctx = param.ctx, result = param.result, _isGetQuantity = param.isGetQuantity, isGetQuantity = _isGetQuantity === void 0 ? false : _isGetQuantity, _withoutLogin = param.withoutLogin, withoutLogin = _withoutLogin === void 0 ? false : _withoutLogin, _isAvailable = param.isAvailable, isAvailable = _isAvailable === void 0 ? false : _isAvailable, _isProductCard = param.isProductCard, isProductCard = _isProductCard === void 0 ? false : _isProductCard, _isGetFullTags = param.isGetFullTags, isGetFullTags = _isGetFullTags === void 0 ? false : _isGetFullTags;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    if (!(0,clients/* isValid */.JY)(result)) {
                        return [
                            2,
                            result
                        ];
                    }
                    cartObject = new Map();
                    limitSkus = new Map();
                    _tmp = {};
                    ref = result || _tmp, tmp = ref.data, dataProducts = tmp === void 0 ? [] : tmp;
                    data = dataProducts;
                    if (isAvailable) {
                        data = data.filter(function(item) {
                            return item.isAvailable;
                        });
                    }
                    skuCodes = data.map(function(item) {
                        var ref;
                        return item === null || item === void 0 ? void 0 : (ref = item.sku) === null || ref === void 0 ? void 0 : ref.code;
                    });
                    // BV-2408: lấy luôn giới hạn mua/ngày cho SP thay thế
                    data.forEach(function(item) {
                        var ref;
                        item === null || item === void 0 ? void 0 : (ref = item.skuReplace) === null || ref === void 0 ? void 0 : ref.forEach(function(sub) {
                            var ref;
                            return (sub === null || sub === void 0 ? void 0 : (ref = sub.sku) === null || ref === void 0 ? void 0 : ref.code) && skuCodes.push(sub.sku.code);
                        });
                    });
                    if (!!withoutLogin) return [
                        3,
                        3
                    ];
                    tasks = [];
                    _tmp1 = {};
                    if (isGetQuantity) {
                        tasks.push(clients/* CartClientV2.getCartItemList */.HP.getCartItemList((_tmp1.ctx = ctx, _tmp1)).then(function(cartRes) {
                            if ((0,clients/* isValid */.JY)(cartRes)) {
                                var cartItems = (0,clients/* getData */.Yu)(cartRes);
                                if ((cartItems === null || cartItems === void 0 ? void 0 : cartItems.length) > 0) {
                                    cartObject = (0,ArrUtils/* convertArrayToMap */.lE)(cartItems, "sku");
                                }
                            }
                        }));
                    }
                    _tmp2 = {};
                    // lấy config theo ngày
                    tasks.push(clients/* ProductClientV2.getSkusLimit */.j4.getSkusLimit((_tmp2.ctx = ctx, _tmp2.skuCodes = skuCodes, _tmp2)).then(function(limitSkusRes) {
                        var ref;
                        var skusLimitData = (ref = (0,clients/* getData */.Yu)(limitSkusRes)) === null || ref === void 0 ? void 0 : ref.filter(function(item) {
                            return item.isActive;
                        });
                        limitSkus = (0,ArrUtils/* convertArrayToMap */.lE)(skusLimitData, "itemCode");
                    }));
                    return [
                        4,
                        Promise.all(tasks)
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    // eslint-disable-next-line no-param-reassign
                    result.data = (data === null || data === void 0 ? void 0 : data.map(function(item) {
                        var ref, ref1, ref2;
                        // 20Apr thêm limitPerDay
                        var info = convertProductV2((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                            limitPerDay: ((ref1 = limitSkus === null || limitSkus === void 0 ? void 0 : limitSkus.get(item === null || item === void 0 ? void 0 : (ref = item.sku) === null || ref === void 0 ? void 0 : ref.itemCode)) === null || ref1 === void 0 ? void 0 : ref1.quantity) || 0,
                            withoutLogin: withoutLogin,
                            isProductCard: isProductCard
                        }), isGetFullTags);
                        var skuReplace = convertSkuReplace(item === null || item === void 0 ? void 0 : item.skuReplace, {
                            limitSkus: limitSkus,
                            cartObject: cartObject,
                            withoutLogin: withoutLogin,
                            isProductCard: isProductCard,
                            isGetFullTags: isGetFullTags
                        });
                        return (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, info), {
                            quantity: ((ref2 = cartObject === null || cartObject === void 0 ? void 0 : cartObject.get(info.sku)) === null || ref2 === void 0 ? void 0 : ref2.quantity) || 0
                        }), skuReplace.length > 0 && {
                            skuReplace: skuReplace
                        });
                    })) || [];
                    return [
                        2,
                        result
                    ];
                case 4:
                    e = _state.sent();
                    console.error(e);
                    return [
                        2,
                        null
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return function mapDataProduct(_) {
        return _ref.apply(this, arguments);
    };
}();
function getDataProductDetail(_) {
    return _getDataProductDetail.apply(this, arguments);
}
function _getDataProductDetail() {
    _getDataProductDetail = /* ============= PUBLIC FUNCTION ============== */ (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx, _slug, slug, _isGetSKUReplace, isGetSKUReplace, params, _tmp, query, ref, newParams, _tmp1, result, _tmp2, _tmp3;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ctx = param.ctx, _slug = param.slug, slug = _slug === void 0 ? "" : _slug, _isGetSKUReplace = param.isGetSKUReplace, isGetSKUReplace = _isGetSKUReplace === void 0 ? false : _isGetSKUReplace;
                    _tmp = {};
                    params = _tmp;
                    if (slug) {
                        params.q = convertSlug(slug);
                    } else {
                        query = ctx.query;
                        params.q = convertSlug(query === null || query === void 0 ? void 0 : query.slug);
                    }
                    _tmp1 = {};
                    ref = WebServiceUtils.addQueryOption((_tmp1.params = params, _tmp1)), newParams = ref.params;
                    // BV-2408: frontend-apis tự bật productDetailPage cho /product/detail, chỉ cần isGetSKUReplace
                    if (isGetSKUReplace) {
                        newParams.queryOption = "".concat(newParams.queryOption, ",isGetSKUReplace,productDetailPage");
                    }
                    _tmp2 = {};
                    return [
                        4,
                        clients/* WebServiceClient.loadProductDetail */.Hf.loadProductDetail((_tmp2.ctx = ctx, _tmp2.params = newParams, _tmp2))
                    ];
                case 1:
                    result = _state.sent();
                    if (!(0,clients/* isValid */.JY)(result)) return [
                        2,
                        result
                    ];
                    _tmp3 = {};
                    return [
                        2,
                        mapDataProduct((_tmp3.ctx = ctx, _tmp3.result = result, _tmp3))
                    ];
            }
        });
    });
    return _getDataProductDetail.apply(this, arguments);
}
function getDataProductBySlugs(_) {
    return _getDataProductBySlugs.apply(this, arguments);
}
function _getDataProductBySlugs() {
    _getDataProductBySlugs = (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx, _slugs, slugs, _isGetFullTags, isGetFullTags, ref, results, result, _tmp, _tmp1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ctx = param.ctx, _slugs = param.slugs, slugs = _slugs === void 0 ? [] : _slugs, _isGetFullTags = param.isGetFullTags, isGetFullTags = _isGetFullTags === void 0 ? false : _isGetFullTags;
                    return [
                        4,
                        Promise.all(slugs.map(function(slug) {
                            var params = {
                                q: convertSlug(slug),
                                queryOption: {}
                            };
                            var ref = WebServiceUtils.addQueryOption({
                                params: params
                            }), newParams = ref.params;
                            return clients/* WebServiceClient.loadProductDetail */.Hf.loadProductDetail({
                                ctx: ctx,
                                params: newParams
                            });
                        }))
                    ];
                case 1:
                    results = _state.sent();
                    _tmp = {};
                    result = (_tmp.status = Enums/* HTTP_STATUS.Ok */.MG.Ok, _tmp.data = ((ref = results === null || results === void 0 ? void 0 : results.filter(function(res) {
                        return (0,clients/* isValid */.JY)(res);
                    })) === null || ref === void 0 ? void 0 : ref.map(function(productRes) {
                        return (0,clients/* getFirst */.Xi)(productRes);
                    })) || [], _tmp);
                    _tmp1 = {};
                    return [
                        2,
                        mapDataProduct((_tmp1.ctx = ctx, _tmp1.result = result, _tmp1.isGetQuantity = false, _tmp1.isAvailable = true, _tmp1.isGetFullTags = isGetFullTags, _tmp1))
                    ];
            }
        });
    });
    return _getDataProductBySlugs.apply(this, arguments);
}
function getProductsFuzzySearch(_) {
    return _getProductsFuzzySearch.apply(this, arguments);
}
function _getProductsFuzzySearch() {
    _getProductsFuzzySearch = // search
    // extraQueryOption: cờ queryOption bổ sung (addQueryOption ghi đè queryOption của body)
    (0,_async_to_generator/* default */.Z)(function(param) {
        var body, _ctx, ctx, _extraQueryOption, extraQueryOption, ref, bodyReq, _tmp, text, _tmp1, textSearch, lengthTextSearch, params, _tmp2, _tmp3, res;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    body = param.body, _ctx = param.ctx, ctx = _ctx === void 0 ? null : _ctx, _extraQueryOption = param.extraQueryOption, extraQueryOption = _extraQueryOption === void 0 ? null : _extraQueryOption;
                    _tmp = {};
                    ref = WebServiceUtils.addQueryOption((_tmp.body = body, _tmp)), bodyReq = ref.body;
                    if (extraQueryOption) {
                        bodyReq.queryOption = (0,_object_spread/* default */.Z)({}, bodyReq.queryOption, extraQueryOption);
                    }
                    _tmp1 = {};
                    text = (bodyReq || _tmp1).text;
                    // chặn search những keyword cấm
                    if (text) {
                        textSearch = text.toLocaleLowerCase().trim();
                        lengthTextSearch = textSearch === null || textSearch === void 0 ? void 0 : textSearch.split(" ").length;
                        if (lengthTextSearch === 1 && data/* PreventSearchKeywords.indexOf */.R9.indexOf(textSearch) >= 0 || textSearch.toLocaleLowerCase().startsWith("http") || data/* PreventSearchKeywordsAlias.indexOf */.a3.indexOf(utils/* StringUtils.changeAlias */.xZ.changeAlias(textSearch)) >= 0) {
                            return [
                                2,
                                utils/* ResponseUtils.notfound */.QV.notfound("Keyword is not valid")
                            ];
                        }
                    }
                    _tmp2 = {};
                    params = (_tmp2.body = bodyReq, _tmp2);
                    _tmp3 = {};
                    if (ctx) {
                        Object.assign(params, (_tmp3.ctx = ctx, _tmp3));
                    }
                    return [
                        4,
                        clients/* WebServiceClient.loadProductsFuzzySearch */.Hf.loadProductsFuzzySearch(params)
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res
                    ];
            }
        });
    });
    return _getProductsFuzzySearch.apply(this, arguments);
}
var loadProductFuzzy = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(_param) {
        var ctx, offset, _limit, limit, filter, _text, text, _sort, sort, _isUseRawData, isUseRawData, _extraQueryOption, extraQueryOption, params, body, _tmp, queryData, _tmp1, _tmp2, result, mappedData, _tmp3, _tmp4;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ctx = _param.ctx, offset = _param.offset, _limit = _param.limit, limit = _limit === void 0 ? data/* PAGE_SIZE_30 */.AV : _limit, filter = _param.filter, _text = _param.text, text = _text === void 0 ? "" : _text, _sort = _param.sort, sort = _sort === void 0 ? "" : _sort, _isUseRawData = _param.isUseRawData, isUseRawData = _isUseRawData === void 0 ? false : _isUseRawData, _extraQueryOption = _param.extraQueryOption, extraQueryOption = _extraQueryOption === void 0 ? null : _extraQueryOption, params = (0,_object_without_properties/* default */.Z)(_param, [
                        "ctx",
                        "offset",
                        "limit",
                        "filter",
                        "text",
                        "sort",
                        "isUseRawData",
                        "extraQueryOption"
                    ]);
                    _tmp = {};
                    body = (0,_object_spread/* default */.Z)((_tmp.text = text, _tmp.offset = offset, _tmp.limit = limit, _tmp.getTotal = true, _tmp.sort = sort, _tmp.filter = filter, _tmp.searchStrategy = DEFAULT_SEARCH_STRATEGY, _tmp), params);
                    _tmp1 = {};
                    queryData = (_tmp1.body = body, _tmp1.extraQueryOption = extraQueryOption, _tmp1);
                    _tmp2 = {};
                    if (ctx) {
                        Object.assign(queryData, (_tmp2.ctx = ctx, _tmp2));
                    }
                    return [
                        4,
                        getProductsFuzzySearch(queryData)
                    ];
                case 1:
                    result = _state.sent();
                    if (isUseRawData) return [
                        2,
                        result
                    ];
                    _tmp3 = {};
                    return [
                        4,
                        mapDataProduct((0,_object_spread/* default */.Z)((_tmp3.ctx = ctx, _tmp3.result = result, _tmp3), params))
                    ];
                case 2:
                    mappedData = _state.sent();
                    _tmp4 = {};
                    return [
                        2,
                        (0,_object_spread/* default */.Z)(_tmp4, mappedData)
                    ];
            }
        });
    });
    return function loadProductFuzzy(_param) {
        return _ref.apply(this, arguments);
    };
}();
var loadRecentProducts = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(_param) {
        var ctx, offset, _limit, limit, filter, _sort, sort, _isUseRawData, isUseRawData, params, body, _tmp, result, _tmp1, mappedData, _tmp2, _tmp3;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ctx = _param.ctx, offset = _param.offset, _limit = _param.limit, limit = _limit === void 0 ? data/* PAGE_SIZE_30 */.AV : _limit, filter = _param.filter, _sort = _param.sort, sort = _sort === void 0 ? "" : _sort, _isUseRawData = _param.isUseRawData, isUseRawData = _isUseRawData === void 0 ? false : _isUseRawData, params = (0,_object_without_properties/* default */.Z)(_param, [
                        "ctx",
                        "offset",
                        "limit",
                        "filter",
                        "sort",
                        "isUseRawData"
                    ]);
                    _tmp = {};
                    body = (0,_object_spread/* default */.Z)((_tmp.offset = offset, _tmp.limit = limit, _tmp.getTotal = true, _tmp.sort = sort, _tmp.filter = filter, _tmp), params);
                    _tmp1 = {};
                    return [
                        4,
                        clients/* WebServiceClient.loadRecentProducts */.Hf.loadRecentProducts((_tmp1.body = body, _tmp1))
                    ];
                case 1:
                    result = _state.sent();
                    if (isUseRawData) return [
                        2,
                        result
                    ];
                    _tmp2 = {};
                    return [
                        4,
                        mapDataProduct((0,_object_spread/* default */.Z)((_tmp2.ctx = ctx, _tmp2.result = result, _tmp2), params))
                    ];
                case 2:
                    mappedData = _state.sent();
                    _tmp3 = {};
                    return [
                        2,
                        (0,_object_spread/* default */.Z)(_tmp3, mappedData)
                    ];
            }
        });
    });
    return function loadRecentProducts(_param) {
        return _ref.apply(this, arguments);
    };
}();
function searchByKeywords() {
    return _searchByKeywords.apply(this, arguments);
}
function _searchByKeywords() {
    _searchByKeywords = (0,_async_to_generator/* default */.Z)(function() {
        var keyword, hasIngredients, searchStrategy, _tmp, body, _tmp1, result, _tmp2;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            keyword = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : "", hasIngredients = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : true;
            _tmp = {};
            searchStrategy = (_tmp.text = true, _tmp.keyword = true, _tmp.ingredient = hasIngredients, _tmp);
            _tmp1 = {};
            body = (_tmp1.text = keyword, _tmp1.offset = 0, _tmp1.limit = data/* PAGE_SIZE_30 */.AV, _tmp1.searchStrategy = searchStrategy, _tmp1);
            _tmp2 = {};
            result = getProductsFuzzySearch((_tmp2.body = body, _tmp2));
            return [
                2,
                (0,clients/* getData */.Yu)(result)
            ];
        });
    });
    return _searchByKeywords.apply(this, arguments);
}
function getCart(_) {
    return _getCart.apply(this, arguments);
}
function _getCart() {
    _getCart = // cart
    (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx, params, _tmp, cartRes, _tmp1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ctx = param.ctx;
                    _tmp = {};
                    params = _tmp;
                    params.queryOption = "price";
                    _tmp1 = {};
                    return [
                        4,
                        clients/* WebServiceClient.loadCart */.Hf.loadCart((_tmp1.ctx = ctx, _tmp1.params = params, _tmp1))
                    ];
                case 1:
                    cartRes = _state.sent();
                    if ((0,clients/* isValid */.JY)(cartRes)) {
                        return [
                            2,
                            (0,clients/* getFirst */.Xi)(cartRes)
                        ];
                    }
                    return [
                        2,
                        cartRes
                    ];
            }
        });
    });
    return _getCart.apply(this, arguments);
}
function isSubstituteEnabled() {
    return _isSubstituteEnabled.apply(this, arguments);
}
function _isSubstituteEnabled() {
    _isSubstituteEnabled = // BV-2408: SP thay thế trong giỏ. Giỏ hàng TH đọc từ marketplace/order nên gọi thêm frontend-apis
    // /cart với cờ cartPage để lấy skuReplace (tính trên cả giỏ, loại trừ SKU đã có trong giỏ).
    // Trả về { [sku SP chính]: [SP thay thế đã convert] }, rỗng khi tính năng tắt.
    // BV-2408: khách có bật SP thay thế không (frontend-apis /substitute/enabled). Gọi mỗi lần trước khi
    // lấy SP thay thế trong giỏ, không cache; lỗi -> coi như tắt.
    (0,_async_to_generator/* default */.Z)(function() {
        var ctx, _tmp, ref, res, _tmp1, e;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    ctx = (_arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : _tmp).ctx;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    _tmp1 = {};
                    return [
                        4,
                        clients/* ProductClientV2.getSubstituteEnabled */.j4.getSubstituteEnabled((_tmp1.ctx = ctx, _tmp1))
                    ];
                case 2:
                    res = _state.sent();
                    if (!(0,clients/* isValid */.JY)(res)) return [
                        2,
                        false
                    ];
                    return [
                        2,
                        !!((ref = (0,clients/* getFirst */.Xi)(res)) === null || ref === void 0 ? void 0 : ref.enabled)
                    ];
                case 3:
                    e = _state.sent();
                    return [
                        2,
                        false
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return _isSubstituteEnabled.apply(this, arguments);
}
function getCartSkuReplaceMap() {
    return _getCartSkuReplaceMap.apply(this, arguments);
}
function _getCartSkuReplaceMap() {
    _getCartSkuReplaceMap = (0,_async_to_generator/* default */.Z)(function() {
        var ctx, _tmp, _tmp1, _tmp2, params, _tmp3, cartRes, _tmp4, _tmp5, ref, _cartItems, cartItems, _tmp6, _tmp7, _tmp8;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    ctx = (_arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : _tmp).ctx;
                    _tmp1 = {};
                    return [
                        4,
                        isSubstituteEnabled((_tmp1.ctx = ctx, _tmp1))
                    ];
                case 1:
                    _tmp2 = {};
                    // tính năng tắt cho khách này -> không gọi thêm /cart
                    if (!_state.sent()) return [
                        2,
                        _tmp2
                    ];
                    _tmp3 = {};
                    params = (_tmp3.queryOption = "price,consumedMaxQuantity,sellerInfo,isGetSKUReplace,cartPage", _tmp3);
                    _tmp4 = {};
                    return [
                        4,
                        clients/* WebServiceClient.loadCart */.Hf.loadCart((_tmp4.ctx = ctx, _tmp4.params = params, _tmp4))
                    ];
                case 2:
                    cartRes = _state.sent();
                    _tmp5 = {};
                    if (!(0,clients/* isValid */.JY)(cartRes)) return [
                        2,
                        _tmp5
                    ];
                    _tmp6 = {};
                    ref = (0,clients/* getFirst */.Xi)(cartRes) || _tmp6, _cartItems = ref.cartItems, cartItems = _cartItems === void 0 ? [] : _cartItems;
                    _tmp7 = {};
                    _tmp8 = {};
                    return [
                        2,
                        (cartItems === null || cartItems === void 0 ? void 0 : cartItems.reduce(function(acc, item) {
                            var ref;
                            var skuReplace = convertSkuReplace(item === null || item === void 0 ? void 0 : (ref = item.productData) === null || ref === void 0 ? void 0 : ref.skuReplace);
                            if ((item === null || item === void 0 ? void 0 : item.sku) && skuReplace.length > 0) {
                                acc[item.sku] = skuReplace;
                            }
                            return acc;
                        }, _tmp7)) || _tmp8
                    ];
            }
        });
    });
    return _getCartSkuReplaceMap.apply(this, arguments);
}
// chuyển data mới thành cấu trúc cũ để ít thay đổi nhất
var convertProductLiteToProductNormal = function(data) {
    return data === null || data === void 0 ? void 0 : data.map(function(param) {
        var displayPrice = param.displayPrice, name = param.name, slug = param.slug, sellerInfo = param.sellerInfo;
        return {
            displayPrice: displayPrice,
            name: name,
            sku: {
                name: name,
                slug: slug,
                sellerCode: sellerInfo === null || sellerInfo === void 0 ? void 0 : sellerInfo.sellerCode,
                retailPriceValue: displayPrice
            },
            product: {
                name: name
            },
            slug: slug,
            sellerInfo: sellerInfo
        };
    });
};
// search lite dành cho mỗi cái search ở NAVBAR
var searchFuzzyLite = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(body) {
        var searchRes, data;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        clients/* WebServiceClient.searchFuzzyLite */.Hf.searchFuzzyLite(body)
                    ];
                case 1:
                    searchRes = _state.sent();
                    data = (0,clients/* getData */.Yu)(searchRes);
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function searchFuzzyLite(body) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var WebService = ({
    getDataProductDetail: getDataProductDetail,
    getDataProductBySlugs: getDataProductBySlugs,
    getProductsFuzzySearch: getProductsFuzzySearch,
    searchByKeywords: searchByKeywords,
    getCart: getCart,
    getCartSkuReplaceMap: getCartSkuReplaceMap,
    isSubstituteEnabled: isSubstituteEnabled,
    searchFuzzyLite: searchFuzzyLite,
    loadProductFuzzy: loadProductFuzzy,
    loadRecentProducts: loadRecentProducts
});

// EXTERNAL MODULE: ./src/services/MarketingService.js
var MarketingService = __webpack_require__(79528);
;// CONCATENATED MODULE: ./src/services/index.js
/* eslint-disable*/ 



// deprecated 22Feb2023 - Dinh Tran
// export { default as ExportSerivce } from './ExportService';


// deprecated 22Feb2023 - Dinh Tran
// export { default as ProductService } from './ProductService';











/***/ }),

/***/ 66225:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$K": function() { return /* binding */ FACEBOOK_MESSENGER_ID; },
/* harmony export */   "Ad": function() { return /* binding */ INSIDER_API_DOMAIN; },
/* harmony export */   "D8": function() { return /* binding */ SHOW_INSIDER_RECOMMEND; },
/* harmony export */   "F7": function() { return /* binding */ CLARITY_KEY; },
/* harmony export */   "FO": function() { return /* binding */ NOTIFY_IN_TOP_BAR; },
/* harmony export */   "Fc": function() { return /* binding */ DOMAIN_IMAGE_CACHE_LOADER; },
/* harmony export */   "Fp": function() { return /* binding */ FIREBASE_PROJECT_ID; },
/* harmony export */   "GO": function() { return /* binding */ IS_WEB_SERVICE_SEARCH_LITE; },
/* harmony export */   "GS": function() { return /* binding */ HOTLINE_TEXT; },
/* harmony export */   "H": function() { return /* binding */ API_HOST; },
/* harmony export */   "HB": function() { return /* binding */ FIREBASE_VAPID_KEY; },
/* harmony export */   "KV": function() { return /* binding */ LINE_OA; },
/* harmony export */   "KW": function() { return /* binding */ API_PRD_HOST_DOMAIN; },
/* harmony export */   "LA": function() { return /* binding */ ACCESS_TOKEN; },
/* harmony export */   "LU": function() { return /* binding */ FEATURE_SHOW_BUTTON_VERIFY_CART; },
/* harmony export */   "Ld": function() { return /* binding */ URL_INSIDER_POPUP; },
/* harmony export */   "N9": function() { return /* binding */ IS_WEB_SERVICE; },
/* harmony export */   "OL": function() { return /* binding */ RECAPTCHA_SITE_KEY; },
/* harmony export */   "P9": function() { return /* binding */ CONFIG_GLOBAL; },
/* harmony export */   "Q9": function() { return /* binding */ NOTIFY_IN_TOP_BAR_UIV2; },
/* harmony export */   "R$": function() { return /* binding */ ACCESS_TOKEN_LONGLIVE; },
/* harmony export */   "RL": function() { return /* binding */ QR_CODE_DOMAIN; },
/* harmony export */   "RR": function() { return /* binding */ BOT_TELE_CHANNEL_ID; },
/* harmony export */   "Ri": function() { return /* binding */ DOMAIN_SELLER_CENTER; },
/* harmony export */   "U3": function() { return /* binding */ MAX_ITEM_IN_CART; },
/* harmony export */   "UI": function() { return /* binding */ CURRENCY_SEPARATE; },
/* harmony export */   "Uk": function() { return /* binding */ MAAC_CHANNEL_ID; },
/* harmony export */   "Ul": function() { return /* binding */ WEB_HOST; },
/* harmony export */   "Vi": function() { return /* binding */ ENV; },
/* harmony export */   "WG": function() { return /* binding */ GCS_HOST; },
/* harmony export */   "WL": function() { return /* binding */ DOMAIN_WEB_HOST; },
/* harmony export */   "Wn": function() { return /* binding */ API_CHAT_DOMAIN; },
/* harmony export */   "YC": function() { return /* binding */ MAX_ORDER_IN_WEEK; },
/* harmony export */   "YY": function() { return /* binding */ LANG_DEFAULT; },
/* harmony export */   "Y_": function() { return /* binding */ HOTLINE; },
/* harmony export */   "Z3": function() { return /* binding */ MARCOM_API_DOMAIN; },
/* harmony export */   "_b": function() { return /* binding */ GCS_IMAGE; },
/* harmony export */   "_y": function() { return /* binding */ FIREBASE_SW_PATH; },
/* harmony export */   "bO": function() { return /* binding */ DISLIKE_FEEDBACK_CODE; },
/* harmony export */   "bp": function() { return /* binding */ NEW_MISSING_IMAGE; },
/* harmony export */   "cC": function() { return /* binding */ TAG_NEW; },
/* harmony export */   "cb": function() { return /* binding */ DOMAIN_FLAGSHIP_STORE; },
/* harmony export */   "ch": function() { return /* binding */ BOT_TELE_ORDER_TOKEN; },
/* harmony export */   "dq": function() { return /* binding */ TTL_CACHE_SERVER; },
/* harmony export */   "eo": function() { return /* binding */ FIREBASE_API_KEY; },
/* harmony export */   "fE": function() { return /* binding */ API_HOST_DOMAIN; },
/* harmony export */   "gF": function() { return /* binding */ FIREBASE_APP_ID; },
/* harmony export */   "gR": function() { return /* binding */ isPrd; },
/* harmony export */   "hQ": function() { return /* binding */ FDA_REGISTED_CODE; },
/* harmony export */   "i3": function() { return /* binding */ FIREBASE_MESSAGING_SENDER_ID; },
/* harmony export */   "ig": function() { return /* binding */ LINK_LICENSE; },
/* harmony export */   "iu": function() { return /* binding */ MOCK_API_HOST; },
/* harmony export */   "jY": function() { return /* binding */ INSIDER_ID; },
/* harmony export */   "jz": function() { return /* binding */ DOMAIN_CDN; },
/* harmony export */   "lE": function() { return /* binding */ TAG_HANG_DAT_TRUOC; },
/* harmony export */   "lZ": function() { return /* binding */ FACEBOOK_APP_ID; },
/* harmony export */   "lw": function() { return /* binding */ REASON_CANCEL_ORDER; },
/* harmony export */   "m1": function() { return /* binding */ TTL_CACHE_LOCAL; },
/* harmony export */   "mE": function() { return /* binding */ BASIC_AUTHEN; },
/* harmony export */   "mJ": function() { return /* binding */ PROXY_IMAGE; },
/* harmony export */   "mU": function() { return /* binding */ GG_IMAGE; },
/* harmony export */   "n$": function() { return /* binding */ MAX_SKU_IN_ORDER; },
/* harmony export */   "n8": function() { return /* binding */ TAG_PRODUCT_NEAR_EXPIRED; },
/* harmony export */   "ng": function() { return /* binding */ ENV_COUNTRY; },
/* harmony export */   "nt": function() { return /* binding */ REGION_MB; },
/* harmony export */   "oC": function() { return /* binding */ GENERAL_DOMAIN; },
/* harmony export */   "p7": function() { return /* binding */ FIREBASE_AUTH_DOMAIN; },
/* harmony export */   "pC": function() { return /* binding */ APP_CONFIG_CODE; },
/* harmony export */   "qd": function() { return /* binding */ FIREBASE_MEASUREMENT_ID; },
/* harmony export */   "qv": function() { return /* binding */ PROVINCES_TURN_OFF_PAYMENT; },
/* harmony export */   "sS": function() { return /* binding */ INSIDER_SCRIPT_DOMAIN; },
/* harmony export */   "sj": function() { return /* binding */ FIREBASE_STORAGE_BUCKET; },
/* harmony export */   "tc": function() { return /* binding */ DOMAIN_TS; },
/* harmony export */   "tp": function() { return /* binding */ CURRENCY_PREFIX; },
/* harmony export */   "uI": function() { return /* binding */ TIME_PREVENT_FEEDBACK_PRICE; },
/* harmony export */   "uU": function() { return /* binding */ SELLER_CODES_REQUIRE_GPP; },
/* harmony export */   "v5": function() { return /* binding */ CDN_GCS; },
/* harmony export */   "wA": function() { return /* binding */ CURRENCY; },
/* harmony export */   "wN": function() { return /* binding */ LIKE_FEEDBACK_CODE; },
/* harmony export */   "xE": function() { return /* binding */ REASON_VOUCHER_BIRTHDAY; },
/* harmony export */   "yN": function() { return /* binding */ RETURN_ORDER_DOMAIN; }
/* harmony export */ });
/* unused harmony exports CDN_PROXY_IMAGE, THUOCSI_DOMAIN, DOMAIN_FEEDBACK, FACEBOOK_PIXEL_CODE, FEATURE_WISHLIST, FEATURE_RE_ORDER, FEATURE_LEVEL, FEATURE_BANK_ACCOUNT, FEATURE_STORE, RETURN_ORDER_DOMAIN_TICKETID, TAG_7DAYS, GTM, GTM_NEW, DOMAIN, BOT_TELE_THREAD_ID, PROVINCES_IMAGE_FULL_WIDTH, FEATURE_CHAT, mapLimitOrderDay, mapLimitOrderTime, mapAndLimit, mapDefaultValue, messageLimitOrderDay, messageLimitOrderTime, messageAndLimit, PROJECT_ID */
/* provided dependency */ var process = __webpack_require__(83454);
var API_HOST = process.env.API_HOST || "/backend";
var API_HOST_DOMAIN = "https://api.stg.th.buymed.tech";
var API_CHAT_DOMAIN = "api.stg.th.buymed.tech";
var API_PRD_HOST_DOMAIN = process.env.NEXT_PUBLIC_API_PRD_HOST_DOMAIN;
// export const API_HOST = 'https://v2api.thuocsi.vn/';
var MOCK_API_HOST = process.env.MOCK_API_HOST || "/api";
var BASIC_AUTHEN = "Basic UEFSVE5FUi92Mi5jdXN0b21lci5jdXN0b21lcjpWNHRqTDI5UVQ0" || 0;
var DOMAIN_SELLER_CENTER = "https://try.thuocsi.vn/banhangcungthuocsi" || 0;
var FACEBOOK_MESSENGER_ID = process.env.NEXT_PUBLIC_FACEBOOK_MESSENGER_ID || "";
// export const FACEBOOK_APP_ID = process.env.NEXT_PUBLIC_FACEBOOK_MESSENGER_ID || '';
var FACEBOOK_APP_ID = 1074695020285628;
// export const DISCOVERY_URL = process.env.NEXT_PUBLIC_DISCOVERY || ''; // deprecated 22Feb2023 - Dinh Tran
// export const WEB_HOST = process.env.WEB_HOST || '';
// export const NEXT_I18NEXT_NAME_SPACES = ['common', 'apiErrors']; // deprecated 22Feb2023 - Dinh Tran
var DOMAIN_TS = "https://stg.th.buymed.tech" || 0;
// export const DOMAIN_TS_MIEN_BAC = process.env.NEXT_PUBLIC_DOMAIN_TS_MIEN_BAC || ''; // deprecated 22Feb2023 - Dinh Tran
var ENV = "stg" || 0;
var GG_IMAGE = "https://storage.googleapis.com" || 0;
// Host GCS proxy dùng chung cho mọi link ảnh/file (đứng trước storage.googleapis.com).
// Đây là single source: các biến legacy bên dưới (PROXY_IMAGE, GCS_IMAGE, DOMAIN_IMAGE_CACHE_LOADER)
// nếu không set riêng trong env sẽ tự quy về GCS_HOST.
var GCS_HOST = "https://gcs-global.buymed.com" || 0;
var PROXY_IMAGE = process.env.NEXT_PUBLIC_DOMAIN_PROXY_IMAGE || GCS_HOST;
var GCS_IMAGE = process.env.NEXT_PUBLIC_DOMAIN_GCS_IMAGE || GCS_HOST;
var CDN_GCS = "https://cdn-gcs-global.thuocsi.vn" || 0;
var CDN_PROXY_IMAGE = (/* unused pure expression or super */ null && ("https://cdn-th-img-proxy.buymed.tech" || 0));
var isPrd = ENV === "prd";
var LINK_LICENSE = "https://gcs-global.buymed.com/thuocsi-live/attachments/202107149d091089998b1b3f3e7e0c09" || 0;
var INSIDER_ID = "10014496";
var INSIDER_SCRIPT_DOMAIN = "buymedthailanduat.api.useinsider.com" || 0;
var INSIDER_API_DOMAIN = "https://recommendation.api.useinsider.com";
var SHOW_INSIDER_RECOMMEND = "off" === "on";
var THUOCSI_DOMAIN = "/";
var DOMAIN_FEEDBACK = (/* unused pure expression or super */ null && ("https://stg.th.buymed.tech/feedback" || 0));
var FACEBOOK_PIXEL_CODE = process.env.NEXT_PUBLIC_FACEBOOK_PIXEL_CODE || ""; // deprecated 22Feb2023 - Dinh Tran
var PROVINCES_TURN_OFF_PAYMENT = "[];" || 0;
// export const PROVINCES_DELAY_DELIVERY = process.env.NEXT_PUBLIC_FEATURE_PROVINCE_DELAY_DELIVERY || []; // deprecated 22Feb2023 - Dinh Tran
var NOTIFY_IN_TOP_BAR = process.env.NEXT_PUBLIC_FEATURE_NOTI_TOPBAR || "";
var NOTIFY_IN_TOP_BAR_UIV2 = process.env.NEXT_PUBLIC_FEATURE_NOTI_TOPBAR_UIV2 || "";
var MAX_SKU_IN_ORDER = process.env.NEXT_PUBLIC_FEATURE_MAX_SKU_IN_ORDER || 0;
var MAX_ORDER_IN_WEEK = process.env.NEXT_PUBLIC_FEATURE_MAX_ORDER_IN_WEEK || 0;
/// Feature on off here
var FEATURE_WISHLIST = (/* unused pure expression or super */ null && ( false || "on" === "on"));
var FEATURE_RE_ORDER = (/* unused pure expression or super */ null && ( false || "on" === "on"));
var FEATURE_LEVEL = (/* unused pure expression or super */ null && ( false || "on" === "on"));
var FEATURE_BANK_ACCOUNT = (/* unused pure expression or super */ null && ( false || "on" === "on"));
var SELLER_CODES_REQUIRE_GPP = "['K1YACBVI4O','B2G2UUUUUU','F9LFTHUJAB'];" || 0;
var FEATURE_STORE = (/* unused pure expression or super */ null && ( false || "off" === "on"));
/// QR CODE
var QR_CODE_DOMAIN = "https://buymed.co.th/qr/";
var TTL_CACHE_LOCAL = "600";
var TTL_CACHE_SERVER = "600" || 0;
var LIKE_FEEDBACK_CODE = "E2PAJE" || 0;
var DISLIKE_FEEDBACK_CODE = "WRGBKR" || 0;
var TIME_PREVENT_FEEDBACK_PRICE = process.env.NEXT_PUBLIC_TIME_PREVENT_FEEDBACK_PRICE || 1000;
// tag new
var TAG_NEW = "V2U1" || 0;
var TAG_PRODUCT_NEAR_EXPIRED = "T0T0" || 0;
// btn return order at /my-order
var RETURN_ORDER_DOMAIN = process.env.NEXT_PUBLIC_DOMAIN_POS || "";
var RETURN_ORDER_DOMAIN_TICKETID = (/* unused pure expression or super */ null && ("https://pos.thuocsi.vn/return-ticket/detail" || 0));
// tag 7 ngay
var TAG_7DAYS = (/* unused pure expression or super */ null && ("HANG_DAT_TRUOC" || 0));
var REGION_MB = "['46', '45', '44', '42', '40', '38', '37', '36', '35', '34', '33', '31', '30', '27', '26', '25', '24', '22', '20', '19', '17', '15', '14', '12', '11', '10', '08', '06', '04', '02', '01', '52', '51', '49', '48']" || 0;
var GTM = process.env.NEXT_PUBLIC_GTM || "";
var GTM_NEW = process.env.NEXT_PUBLIC_GTM_NEW || "";
// MAAC (Crescendo Lab) Web SDK — clWebChannelId. Rỗng = không load SDK, không bắn event.
var MAAC_CHANNEL_ID =  false || "";
var DOMAIN_FLAGSHIP_STORE = process.env.NEXT_PUBLIC_WEB_SELLER_FLAGSHIP_STORE || "";
var GENERAL_DOMAIN = ".stg.th.buymed.tech" || 0;
var DOMAIN = (/* unused pure expression or super */ null && ("http://stg.th.buymed.tech" || 0));
var WEB_HOST = "http://stg.th.buymed.tech" || 0;
var DOMAIN_WEB_HOST = "http://stg.th.buymed.tech" || 0;
var ACCESS_TOKEN = "ts_auth_access_token_stg" || 0;
var ACCESS_TOKEN_LONGLIVE = "ts_auth_access_token_longlive_stg" || 0;
var MAX_ITEM_IN_CART = "200" || 0;
var FEATURE_SHOW_BUTTON_VERIFY_CART =  false || "off" === "on";
var TAG_HANG_DAT_TRUOC = "HANG_DAT_TRUOC";
var BOT_TELE_ORDER_TOKEN = "6329164483:AAG6GTWiFCybvixotQFL7JHDtwfu2XSUfMw" || 0;
var BOT_TELE_CHANNEL_ID = "-1001988270354" || 0;
var BOT_TELE_THREAD_ID = (/* unused pure expression or super */ null && ("1005853" || 0));
var DOMAIN_IMAGE_CACHE_LOADER = process.env.NEXT_PUBLIC_LOADER_IMAGE || GCS_HOST;
var REASON_CANCEL_ORDER = "J6GBKR" || 0;
var REASON_VOUCHER_BIRTHDAY = process.env.NEXT_PUBLIC_VOUCHER_BIRTHDAY_CODE || "";
// Image
var PROVINCES_IMAGE_FULL_WIDTH = (/* unused pure expression or super */ null && ("['00']" || 0));
// export const IS_USE_FULL_WIDTH_ALL = PROVINCES_IMAGE_FULL_WIDTH?.includes('00'); // deprecated 22Feb2023 - Dinh Tran
var FEATURE_CHAT = (/* unused pure expression or super */ null && ( false || false));
// web service apis
var IS_WEB_SERVICE = "off" === "on";
var IS_WEB_SERVICE_SEARCH_LITE = "on" === "on";
// CONFIG COUNTRY
var mapConfigCurrency = {
    vn: "đ",
    cam: "$",
    kh: "$",
    th: "฿",
    en: "$",
    default: "$"
};
var mapConfigSeperate = {
    vn: ".",
    cam: "$&,",
    default: "$&,",
    kh: "$&,",
    th: ","
};
var mapConfigSetPrefix = {
    vn: false,
    cam: false,
    th: true,
    en: false,
    default: false
};
// translate text limit order
var mapLimitOrderDay = {
    vn: "Đặt tối đa {quantity} {unit}/ng\xe0y",
    en: "Buy maximum {quantity} {unit}/day",
    default: "Buy maximum {quantity} {unit}/day",
    kh: "កំណត់ {quantity} អតិបរមា {unit}/ថ្ងៃ",
    cam: "កំណត់ {quantity} អតិបរមា {unit}/ថ្ងៃ",
    th: "ซื้อสูงสุด {quantity} {unit}/วัน"
};
var mapLimitOrderTime = {
    vn: "Đặt tối đa {quantity} {unit}/lần",
    en: "Buy maximum {quantity} {unit}/order",
    default: "Buy maximum {quantity} {unit}/order",
    cam: "ទិញអតិបរមា {quantity} {unit}/មួយដង",
    kh: "ទិញអតិបរមា {quantity} {unit}/មួយដង",
    th: "ซื้อสูงสุด {quantity} {unit}/คำสั่ง"
};
var mapAndLimit = {
    vn: "v\xe0 {quantity} {unit}/lần",
    en: "and maximum {quantity} {unit}/order",
    default: "and maximum {quantity} {unit}/order",
    th: "และสูงสุด {quantity} {unit}/คำสั่ง",
    cam: "និងអតិបរមា {quantity} {unit}/មួយដង",
    kh: "និងអតិបរមា {quantity} {unit}/មួយដង"
};
var mapDefaultValue = {
    unit: {
        default: "product",
        vn: "sản phẩm"
    }
};
var ENV_COUNTRY = "th" || 0;
var LANG_DEFAULT = "th" || 0;
var messageLimitOrderDay = mapLimitOrderDay[ENV_COUNTRY] || mapLimitOrderDay.en;
var messageLimitOrderTime = mapLimitOrderTime[ENV_COUNTRY] || mapLimitOrderTime.en;
var messageAndLimit = mapAndLimit[ENV_COUNTRY] || mapAndLimit.en;
// currency
var CURRENCY = mapConfigCurrency[ENV_COUNTRY] || mapConfigCurrency.en;
var CURRENCY_SEPARATE = mapConfigSeperate[ENV_COUNTRY] || mapConfigSeperate.en;
var CURRENCY_PREFIX = mapConfigSetPrefix[ENV_COUNTRY] || mapConfigSetPrefix.en;
// country
// ao-1409: new logo
var NEW_MISSING_IMAGE = "https://gcs-global.buymed.com/thuocsi-live/web/static/images/logo-missing-th.svg" || 0;
var HOTLINE = "024830933" || 0;
var HOTLINE_TEXT = "02-483-0933" || 0;
var LINE_OA = "https://lin.ee/xWjviZO2" || 0;
// cdn
var DOMAIN_CDN = process.env.NEXT_PUBLIC_CDN || "";
var languageDefault = "en";
var CONFIG_GLOBAL = {
    COUNTRY: ENV_COUNTRY,
    UNIT: mapDefaultValue.unit[ENV_COUNTRY] || mapDefaultValue.unit.default,
    LANG: "th" || 0,
    messageLimitOrderDay: mapLimitOrderDay[ENV_COUNTRY] || mapLimitOrderDay.default,
    messageLimitOrderTime: mapLimitOrderTime[ENV_COUNTRY] || mapLimitOrderTime.default,
    messageAndLimit: mapAndLimit[ENV_COUNTRY] || mapAndLimit.default,
    CURRENCY: mapConfigCurrency[ENV_COUNTRY] || mapConfigCurrency.default,
    CURRENCY_SEPARATE: mapConfigSeperate[ENV_COUNTRY] || mapConfigSeperate.default,
    HOTLINE: HOTLINE,
    HOTLINE_TEXT: HOTLINE_TEXT,
    BRAND_NAME: "BuyMed",
    BRAND_NAME_LONG: "Buymed Siam"
};
var FDA_REGISTED_CODE = "G2ABCL" || 0;
var APP_CONFIG_CODE = "61PGEQ1P" || 0;
// insider marcom
var MARCOM_API_DOMAIN = "https://api.stg.buymed.tech" || 0;
var FIREBASE_API_KEY = "AIzaSyARqbyxcTeHVU2Gsxy_h2RCP5Ei1wwdp0M";
var FIREBASE_AUTH_DOMAIN = "buymedthailand---stg.firebaseapp.com";
var FIREBASE_PROJECT_ID = "buymedthailand---stg";
var FIREBASE_STORAGE_BUCKET = "buymedthailand---stg.appspot.com";
var FIREBASE_MESSAGING_SENDER_ID = "179114341665";
var FIREBASE_APP_ID = "1:179114341665:web:d33628cba9cca497aaba60";
var FIREBASE_MEASUREMENT_ID = "G-JEZECXRVFW";
var FIREBASE_VAPID_KEY = "BIHXdyII49YT4a1KQ1fYI7FdKoQ2XxiKBbSCt2dbg70C9D2z0Bo6vZFMxG6BppTvVL1RZA6KLQgFod0-WfhvYf4";
var FIREBASE_SW_PATH = "".concat("https://stg.th.buymed.tech", "/firebase-messaging-sw.js");
var URL_INSIDER_POPUP = "https://api.stg.buymed.tech/insider/content-rendering/v1/content.js" || 0;
var PROJECT_ID = (/* unused pure expression or super */ null && ("10003" || 0));
var RECAPTCHA_SITE_KEY = "6Lf23CQqAAAAACGGoN1UjueHpIUgn6DcqqSxz37c";
var CLARITY_KEY = "p4fh7q3ate" || 0;


/***/ }),

/***/ 33769:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J5": function() { return /* binding */ sortComparer; },
/* harmony export */   "PH": function() { return /* binding */ replacer; },
/* harmony export */   "RL": function() { return /* binding */ fillInRange; },
/* harmony export */   "TV": function() { return /* binding */ shuffle; },
/* harmony export */   "Zx": function() { return /* binding */ convertArrayToMapValue; },
/* harmony export */   "lE": function() { return /* binding */ convertArrayToMap; },
/* harmony export */   "yf": function() { return /* binding */ reviver; }
/* harmony export */ });
/* unused harmony export compare */
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82670);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29815);


var convertArrayToMap = function(arr, key) {
    return new Map(arr.map(function(obj) {
        return [
            obj[key],
            obj
        ];
    }));
};
var convertArrayToMapValue = function() {
    var arr = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], key = arguments.length > 1 ? arguments[1] : void 0, value = arguments.length > 2 ? arguments[2] : void 0;
    return new Map(arr.map(function(obj) {
        return [
            obj[key],
            obj[value]
        ];
    }));
};
var compare = function(a, b) {
    if (a < b) {
        return -1;
    }
    if (a > b) {
        return 1;
    }
    return 0;
};
var sortComparer = function(a, b) {
    return a.localeCompare(b);
};
var replacer = function(key, value) {
    if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(value, Map)) {
        return {
            dataType: "Map",
            value: Array.from(value.entries())
        };
    }
    return value;
};
var reviver = function(key, value) {
    if (typeof value === "object" && value !== null) {
        if (value.dataType === "Map") {
            return new Map(value.value);
        }
    }
    return value;
};
// deprecated 22Feb2023 - Dinh Tran
// export const unique = ({ data, key }) =>
//   data.reduce((accumulator, item = {}) => {
//     if (item[key]) return [...accumulator, item[key]];
//     return accumulator;
//   }, []);
var fillInRange = function() {
    var start = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, end = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    var length = end - start;
    return Array.from({
        length: length
    }, function(_, i) {
        return start + i;
    });
};
// var unique = a.filter(onlyUnique);
function onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
}
// shuffle array
var shuffle = function(array) {
    var result = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(array).sort(function() {
        return Math.random() - 0.5;
    });
    return result;
};
/* harmony default export */ __webpack_exports__["ZP"] = ({
    convertArrayToMap: convertArrayToMap,
    compare: compare,
    sortComparer: sortComparer,
    reviver: reviver,
    replacer: replacer,
    fillInRange: fillInRange,
    onlyUnique: onlyUnique
});


/***/ }),

/***/ 65342:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "If": function() { return /* binding */ changeDomainStorage; },
/* harmony export */   "Jw": function() { return /* binding */ getLinkImageStatic; },
/* harmony export */   "Lr": function() { return /* binding */ getLinkCacheFromGG; },
/* harmony export */   "Vv": function() { return /* binding */ getLinkImageStaticCache; },
/* harmony export */   "v5": function() { return /* binding */ getLinkImageStaticWebHost; }
/* harmony export */ });
/* unused harmony export getLinkImageCache */
/* harmony import */ var sysconfig__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66225);
/* harmony import */ var _ImageUtils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13744);


// đổi link storage (storage.googleapis.com...) về GCS_HOST, link khác giữ nguyên
var changeDomainStorage = function(url) {
    return (0,_ImageUtils__WEBPACK_IMPORTED_MODULE_1__/* .convertImage */ .BQ)({
        url: url
    });
};
// legacy: trước đây build link qua `${DOMAIN_IMAGE_CACHE_LOADER}/_next/image?url=...` (service
// cache-image cũ của VN); giờ convert thẳng về GCS_HOST kèm params width/height/quality
var getLinkImageCache = function(param) {
    var src = param.src, _width = param.width, width = _width === void 0 ? null : _width, _height = param.height, height = _height === void 0 ? null : _height, _quality = param.quality, quality = _quality === void 0 ? 100 : _quality;
    return convertImage({
        url: src,
        width: width,
        height: height,
        quality: quality
    });
};
var getLinkCacheFromGG = function(param) {
    var src = param.src, _width = param.width, width = _width === void 0 ? null : _width, _height = param.height, height = _height === void 0 ? null : _height, _quality = param.quality, quality = _quality === void 0 ? 100 : _quality;
    return (0,_ImageUtils__WEBPACK_IMPORTED_MODULE_1__/* .convertImage */ .BQ)({
        url: src,
        width: width,
        height: height,
        quality: quality
    });
};
// 2 hàm dưới xử lý ảnh static theo WEB_HOST/DOMAIN_CDN, không phải link storage
var getLinkImageStaticWebHost = function(url) {
    return (url === null || url === void 0 ? void 0 : url.startsWith(sysconfig__WEBPACK_IMPORTED_MODULE_0__/* .WEB_HOST */ .Ul)) || (url === null || url === void 0 ? void 0 : url.startsWith(sysconfig__WEBPACK_IMPORTED_MODULE_0__/* .PROXY_IMAGE */ .mJ)) ? url : sysconfig__WEBPACK_IMPORTED_MODULE_0__/* .WEB_HOST */ .Ul + url;
};
var getLinkImageStatic = function(url) {
    return ((url === null || url === void 0 ? void 0 : url.startsWith(sysconfig__WEBPACK_IMPORTED_MODULE_0__/* .WEB_HOST */ .Ul)) || (url === null || url === void 0 ? void 0 : url.startsWith(sysconfig__WEBPACK_IMPORTED_MODULE_0__/* .DOMAIN_CDN */ .jz)) || (url === null || url === void 0 ? void 0 : url.startsWith(sysconfig__WEBPACK_IMPORTED_MODULE_0__/* .PROXY_IMAGE */ .mJ)) ? url : sysconfig__WEBPACK_IMPORTED_MODULE_0__/* .WEB_HOST */ .Ul + url).replace("".concat(sysconfig__WEBPACK_IMPORTED_MODULE_0__/* .WEB_HOST */ .Ul), "".concat(sysconfig__WEBPACK_IMPORTED_MODULE_0__/* .DOMAIN_CDN */ .jz || sysconfig__WEBPACK_IMPORTED_MODULE_0__/* .WEB_HOST */ .Ul));
};
var getLinkImageStaticCache = function(param) {
    var url = param.url, _width = param.width, width = _width === void 0 ? null : _width, _height = param.height, height = _height === void 0 ? null : _height, _quality = param.quality, quality = _quality === void 0 ? 100 : _quality, _isCache = param.isCache, isCache = _isCache === void 0 ? true : _isCache;
    if (!isCache) {
        return (0,_ImageUtils__WEBPACK_IMPORTED_MODULE_1__/* .convertImage */ .BQ)({
            url: getLinkImageStatic(url)
        });
    }
    return (0,_ImageUtils__WEBPACK_IMPORTED_MODULE_1__/* .convertImage */ .BQ)({
        url: getLinkImageStatic(url),
        width: width,
        height: height,
        quality: quality
    });
};


/***/ }),

/***/ 85618:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var node_cache__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70321);
/* harmony import */ var node_cache__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(node_cache__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var sysconfig__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66225);


var cache = new (node_cache__WEBPACK_IMPORTED_MODULE_0___default())();
// default expire 15p , if value is null or arrays empty -> not cache
var setCacheKey = function(key, value) {
    var ttl = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : sysconfig__WEBPACK_IMPORTED_MODULE_1__/* .TTL_CACHE_SERVER */ .dq;
    if (value && value.length > 0) {
        return cache.set(key, value, ttl);
    }
    return null;
};
var setCacheKeyobject = function(key, value) {
    var ttl = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : sysconfig__WEBPACK_IMPORTED_MODULE_1__/* .TTL_CACHE_SERVER */ .dq;
    if (value) {
        return cache.set(key, value, ttl);
    }
    return null;
};
var getCacheValue = function(key) {
    return cache.get(key);
};
var getMultipleCacheValue = function(arr) {
    return cache.mget(arr);
};
// TAKE: get the cached value and remove the key from the cache.
var takeCacheValue = function(key) {
    return cache.take(key);
};
var isAvailableCacheKey = function(key) {
    return cache.has(key);
};
// Delete a key, returns the number of deleted entries.
var deleteByKey = function(key) {
    return cache.delete(key);
};
// Clear the interval timeout which is set on check period option
var closeCache = function() {
    return cache.close();
};
// Flush all data
var flushAllCache = function() {
    return cache.flushAll();
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    setCacheKey: setCacheKey,
    setCacheKeyobject: setCacheKeyobject,
    getCacheValue: getCacheValue,
    takeCacheValue: takeCacheValue,
    isAvailableCacheKey: isAvailableCacheKey,
    getMultipleCacheValue: getMultipleCacheValue,
    deleteByKey: deleteByKey,
    closeCache: closeCache,
    flushAllCache: flushAllCache
});


/***/ }),

/***/ 44777:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14924);

var CookiesParser = function(cookies) {
    return cookies.split(";").reduce(function(res, c) {
        var i = c.indexOf("=");
        var key = c.substr(0, i).trim();
        var val = c.substr(i + 1).trim();
        try {
            return Object.assign(res, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, key, JSON.parse(val)));
        } catch (error) {
            return Object.assign(res, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, key, val));
        }
    }, {});
};
var getCookieFromCtx = function(ctx, nameCookie) {
    var isURLDecoded = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var ref, ref1;
    var cookies = (ctx === null || ctx === void 0 ? void 0 : (ref = ctx.req) === null || ref === void 0 ? void 0 : (ref1 = ref.headers) === null || ref1 === void 0 ? void 0 : ref1.cookie) || null;
    if (!cookies || cookies == null) {
        return null;
    }
    var CookiesCtx = CookiesParser(cookies);
    return isURLDecoded ? decodeURIComponent(CookiesCtx[nameCookie]) : CookiesCtx[nameCookie];
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    getCookieFromCtx: getCookieFromCtx,
    CookiesParser: CookiesParser
});


/***/ }),

/***/ 33213:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "fN": function() { return /* binding */ formatMegaDayRange; },
/* harmony export */   "nr": function() { return /* binding */ getFirstDayOfMonth; }
/* harmony export */ });
/* unused harmony exports DAY_SECONDS, calStatusTimeFunc */
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10253);

var getFirstDateOfWeek = function() {
    var firstWeek = new Date();
    firstWeek.setDate(firstWeek.getDate() - firstWeek.getDay());
    firstWeek.setHours(24, 0, 0, 0);
    return firstWeek;
};
var getDateStart = function() {
    var date = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new Date();
    date.setHours(0, 0, 0, 0);
    return date;
};
var getDateEnd = function() {
    var date = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new Date();
    date.setHours(24, 0, 0, 0);
    return date;
};
function getDayOfWeek(n, t) {
    if (n === 1) return t("monday", {
        ns: "common"
    });
    if (n === 2) return t("tuesday", {
        ns: "common"
    });
    if (n === 3) return t("wednesday", {
        ns: "common"
    });
    if (n === 4) return t("thursday", {
        ns: "common"
    });
    if (n === 5) return t("friday", {
        ns: "common"
    });
    if (n === 6) return t("saturday", {
        ns: "common"
    });
    return t("sunday", {
        ns: "common"
    });
}
function getFormattedDate(date) {
    var format = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "DD/MM/YYYY";
    var month = date.getMonth() + 1;
    var day = date.getDate();
    var year = date.getFullYear();
    var hour = date.getHours();
    var minute = date.getMinutes();
    var second = date.getSeconds();
    return format.replace("DD", String(day).padStart(2, "0")).replace("MM", String(month).padStart(2, "0")).replace("YYYY", year).replace("HH", String(hour).padStart(2, "0")).replace("mm", String(minute).padStart(2, "0")).replace("ss", String(second).padStart(2, "0"));
}
function parseDateTimeToNumber(date) {
    var month = date.getMonth() + 1;
    var day = date.getDate();
    var year = date.getFullYear();
    return Number("".concat(year).concat(String(month).padStart(2, "0")).concat(String(day).padStart(2, "0")));
}
function diffDate(timeA, timeB) {
    return parseDateTimeToNumber(timeA) - parseDateTimeToNumber(timeB);
}
function getFormattedWithDate(date, t) {
    var format = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "d (DD/MM/YYYY)";
    var dayOfWeek = date.getDay();
    return getFormattedDate(date, format).replace("d", getDayOfWeek(dayOfWeek, t));
}
// https://stackoverflow.com/questions/492994/compare-two-dates-with-javascript
function compareTime(timeA, timeB) {
    var dA = new Date(timeA);
    var dB = new Date(timeB);
    var tA = dA.getTime();
    var tB = dB.getTime();
    if (tA === tB) return 0;
    if (dA > dB) return 1;
    return -1;
}
function compareDate(dateA, dateB) {
    var dA = new Date(dateA);
    var dB = new Date(dateB);
    var isEqualYear = dA.getFullYear() === dB.getFullYear();
    var isEqualMonth = dA.getMonth() === dB.getMonth();
    var isEqualDate = dA.getDate() === dB.getDate();
    return isEqualYear && isEqualMonth && isEqualDate;
}
function addHours(time) {
    var hours = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    var t = new Date(time);
    if (hours === 0) return t;
    t.setHours(t.getHours() + hours);
    return t;
}
//  Time ago func
var SECOND = 1;
var MINUTE = 60;
var HOUR = 3600;
var DAY = 86400;
var MONTH = 2629746;
var YEAR = 31556952;
var DECADE = 315569520;
var getTimeAgo = function(date, t) {
    var now = new Date();
    var diff = Math.round((now - +new Date(date)) / 1000);
    var unit = "";
    var num = 0;
    switch(true){
        case diff <= 0:
            return t("recently", {
                ns: "common"
            });
        case diff < MINUTE:
            num = Math.round(diff / SECOND);
            unit = t("seconds", {
                ns: "common"
            });
            break;
        case diff < HOUR:
            num = Math.round(diff / MINUTE);
            unit = t("minutes", {
                ns: "common"
            });
            break;
        case diff < DAY:
            num = Math.round(diff / HOUR);
            unit = t("hours", {
                ns: "common"
            });
            break;
        case diff < MONTH:
            num = Math.round(diff / DAY);
            unit = t("days", {
                ns: "common"
            });
            break;
        case diff < YEAR:
            num = Math.round(diff / MONTH);
            unit = t("months", {
                ns: "common"
            });
            break;
        case diff < DECADE:
            num = Math.round(diff / YEAR);
            unit = t("years", {
                ns: "common"
            });
            break;
        default:
            num = Math.round(diff / YEAR);
            unit = t("years", {
                ns: "common"
            });
    }
    var str = "";
    if (num) {
        str += "".concat(num, " ");
    }
    str += "".concat(unit);
    str += t("ago", {
        ns: "common"
    });
    return str;
};
var DAY_SECONDS = 24 * 60 * 60;
var getFirstDayOfMonth = function() {
    var date = new Date();
    date.setDate(1);
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    date.setMilliseconds(0);
    return date;
};
// hàm trả STATUS của time ACTIVE/DISABLED/NEXT
function calStatusTimeFunc(startTimeDate, endTimeDate) {
    var curTime = new Date();
    var status = "ACTIVE";
    if (endTimeDate < curTime) {
        status = "DISABLED";
    } else if (curTime < startTimeDate) {
        status = "NEXT";
    }
    return status;
}
// convert gmt7 time
function convertStartDate(time) {
    var start = new Date(time);
    start.setHours(0, 0, 0);
    return start.toISOString();
}
function convertEndDate(time) {
    var end = new Date(time);
    end.setHours(23, 59, 0);
    return end.toISOString();
}
var monthMap = {
    en: [
        "JAN",
        "FEB",
        "MAR",
        "APR",
        "MAY",
        "JUN",
        "JUL",
        "AUG",
        "SEP",
        "OCT",
        "NOV",
        "DEC"
    ],
    th: [
        "ม.ค.",
        "ก.พ.",
        "มี.ค.",
        "เม.ย.",
        "พ.ค.",
        "มิ.ย.",
        "ก.ค.",
        "ส.ค.",
        "ก.ย.",
        "ต.ค.",
        "พ.ย.",
        "ธ.ค.", 
    ]
};
var getYear = function(locale) {
    var year = new Date().getFullYear();
    return locale === "th" ? (year + 543).toString().slice(-2) : year.toString().slice(-2);
};
function formatMegaDayRange(from, to) {
    var locale = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "en" || 0;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(from.split("-").map(Number), 2), fromDay = ref[0], fromMonth = ref[1];
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(to.split("-").map(Number), 2), toDay = ref1[0], toMonth = ref1[1];
    var year = getYear(locale);
    var months = monthMap[locale];
    var fromStr = "".concat(fromDay, " ").concat(months[fromMonth - 1], " ").concat(year);
    var toStr = "".concat(toDay, " ").concat(months[toMonth - 1], " ").concat(year);
    return "".concat(fromStr, " - ").concat(toStr);
}
/* harmony default export */ __webpack_exports__["ZP"] = ({
    calStatusTimeFunc: calStatusTimeFunc,
    getFormattedDate: getFormattedDate,
    getDayOfWeek: getDayOfWeek,
    getFormattedWithDate: getFormattedWithDate,
    getTimeAgo: getTimeAgo,
    DAY_SECONDS: DAY_SECONDS,
    compareTime: compareTime,
    addHours: addHours,
    getFirstDayOfMonth: getFirstDayOfMonth,
    getFirstDateOfWeek: getFirstDateOfWeek,
    getDateStart: getDateStart,
    getDateEnd: getDateEnd,
    parseDateTimeToNumber: parseDateTimeToNumber,
    compareDate: compareDate,
    diffDate: diffDate,
    convertStartDate: convertStartDate,
    convertEndDate: convertEndDate,
    formatMegaDayRange: formatMegaDayRange
});


/***/ }),

/***/ 15067:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ useEnhancedReducer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29815);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* eslint-disable no-return-assign */ 

// update state when state change
var useEnhancedReducer = function(reducer, initState, initializer) {
    var lastState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(initState);
    var getState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        return lastState.current;
    }, []);
    return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,react__WEBPACK_IMPORTED_MODULE_0__.useReducer)(function(state, action) {
        return lastState.current = reducer(state, action);
    }, initState, initializer)).concat([
        getState, 
    ]);
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
    useEnhancedReducer: useEnhancedReducer
});


/***/ }),

/***/ 45901:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Qe": function() { return /* binding */ formatDate2; },
/* harmony export */   "T6": function() { return /* binding */ formatDate3; },
/* harmony export */   "ZT": function() { return /* binding */ formatDate4; },
/* harmony export */   "p6": function() { return /* binding */ formatDate; }
/* harmony export */ });
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42298);

function formatDate() {
    var val = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    if (!val) {
        return "";
    }
    var date = new Date(val);
    var dateStr = "".concat("00".concat(date.getDate()).slice(-2), "/").concat("00".concat(date.getMonth() + 1).slice(-2), "/").concat(date.getFullYear(), " ").concat("00".concat(date.getHours()).slice(-2), ":").concat("00".concat(date.getMinutes()).slice(-2), ":").concat("00".concat(date.getSeconds()).slice(-2));
    return dateStr || "";
}
function formatDate2() {
    var val = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    if (!val) {
        return "";
    }
    var date = new Date(val);
    var dateStr = "".concat("00".concat(date.getHours()).slice(-2), ":").concat("00".concat(date.getMinutes()).slice(-2), ":").concat("00".concat(date.getSeconds()).slice(-2), " Ng\xe0y ").concat("00".concat(date.getDate()).slice(-2), "/").concat("00".concat(date.getMonth() + 1).slice(-2), "/").concat(date.getFullYear(), " ");
    return dateStr || "";
}
function formatDate3() {
    var val = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", isDay = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (!val) {
        return "";
    }
    var date = (0,date_fns__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(new Date(val), isDay ? "dd/MM/yyyy" : "dd/MM/yyyy (HH:mm:ss)");
    return date || "";
}
function formatDate4() {
    var val = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", isDay = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (!val) {
        return "";
    }
    var date = (0,date_fns__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(new Date(val), isDay ? "dd/MM/yyyy" : "dd-MM-yyyy (HH:mm)");
    return date || "";
}
/* harmony default export */ __webpack_exports__["ZP"] = ({
    formatDate: formatDate,
    formatDate2: formatDate2
});


/***/ }),

/***/ 44097:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "kr": function() { return /* binding */ formatFloatNumber; },
/* harmony export */   "uf": function() { return /* binding */ formatNumber; },
/* harmony export */   "xG": function() { return /* binding */ formatCurrency; },
/* harmony export */   "xc": function() { return /* binding */ formatCurrencyNoCurrency; }
/* harmony export */ });
/* unused harmony exports convertLargeNumb, formatRoundOf */
/* harmony import */ var sysconfig__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66225);
/* harmony import */ var _ValidateUtils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70220);
/* eslint-disable no-restricted-properties */ 

// dùng currency theo env
var currencyFixed = [
    "$",
    "฿"
];
function formatCurrency(n) {
    var separate = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : sysconfig__WEBPACK_IMPORTED_MODULE_0__/* .CURRENCY_SEPARATE */ .UI, currency = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : sysconfig__WEBPACK_IMPORTED_MODULE_0__/* .CURRENCY */ .wA;
    // const num = ValidateUtils.isNumber(n) ? Number(n) : 0;
    var num = _ValidateUtils__WEBPACK_IMPORTED_MODULE_1__/* ["default"].isNumber */ .ZP.isNumber(n) ? parseFloat(Number(n).toFixed(2)) : 0;
    var s = String(currencyFixed.indexOf(currency) >= 0 ? num.toFixed(2) : num);
    var regex = /\B(?=(\d{3})+(?!\d))/g;
    var ret = "".concat(s.replace(regex, separate));
    // currency = 0 for empty currency
    var cur = currency || "";
    // nếu là $  thì $10 thay vì 10k đ
    if (currencyFixed.indexOf(currency) >= 0) {
        // nếu là số âm => -$10 thay vì $-10
        if (num < 0) {
            var newRet = ret.replace("-", "");
            return "-".concat(cur, " ").concat(newRet);
        }
        return "".concat(cur).concat(ret);
    }
    return ret + cur;
}
function formatCurrencyNoCurrency(n) {
    return formatCurrency(n, sysconfig__WEBPACK_IMPORTED_MODULE_0__/* .CURRENCY_SEPARATE */ .UI, "");
}
function formatNumber(n) {
    var separate = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : sysconfig__WEBPACK_IMPORTED_MODULE_0__/* .CURRENCY_SEPARATE */ .UI, toFixed = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    var num = _ValidateUtils__WEBPACK_IMPORTED_MODULE_1__/* ["default"].isNumber */ .ZP.isNumber(n) ? n : 0;
    if (num !== 0 && toFixed > 0) {
        var ref;
        num = parseFloat((ref = Number(num)) === null || ref === void 0 ? void 0 : ref.toFixed(toFixed));
    }
    var s = String(num);
    var regex = /\B(?=(\d{3})+(?!\d))/g;
    var ret = "".concat(s.replace(regex, separate));
    return ret;
}
function formatFloatNumber(n) {
    var shouldRound = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var num = _ValidateUtils__WEBPACK_IMPORTED_MODULE_1__/* ["default"].isNumber */ .ZP.isNumber(n) ? n : 0;
    var s = String(num);
    if (n % 1 !== 0) {
        var m = s.substr(0, s.indexOf(".") + 3);
        var numFormat = formatNumber(m);
        var index = numFormat.lastIndexOf(".");
        numFormat = "".concat(numFormat.substring(0, index), ".").concat(numFormat.substring(index + 1));
        if (shouldRound && numFormat.indexOf(",00") >= 0) {
            return numFormat.slice(0, -4); // làm tròn số, vd:3,003,081.18 -> 3,003,08
        }
        // bỏ check số dạng 15,04 -> 15
        // if (numFormat[numFormat.length - 2] === '0') {
        //   return numFormat.slice(0, -3);
        // }
        return numFormat;
    }
    return formatNumber(num);
}
function convertLargeNumb(x) {
    /* eslint-disable no-param-reassign */ if (Math.abs(x) < 1.0) {
        var e = parseInt(x.toString().split("e-")[1], 10);
        if (e) {
            x *= Math.pow(10, e) - 1;
            x = "0.".concat(new Array(e).join("0")).concat(x.toString().substring(2));
        }
    } else {
        var e1 = parseInt(x.toString().split("+")[1], 10);
        if (e1 > 20) {
            e1 -= 20;
            x /= Math.pow(10, e1);
            x += new Array(e1 + 1).join("0");
        }
    }
    return x;
}
function formatRoundOf(n, p) {
    var n1 = n * Math.pow(10, p + 1);
    var n2 = Math.floor(n1 / 10);
    if (n1 >= n2 * 10 + 5) {
        return (n2 + 1) / Math.pow(10, p);
    }
    return n2 / Math.pow(10, p);
}
/* harmony default export */ __webpack_exports__["ZP"] = ({
    formatNumber: formatNumber,
    formatCurrency: formatCurrency,
    formatFloatNumber: formatFloatNumber,
    formatRoundOf: formatRoundOf
});


/***/ }),

/***/ 34588:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Up": function() { return /* binding */ ImageFallbackBanner; },
/* harmony export */   "cE": function() { return /* binding */ ImageFallbackStoreImage; },
/* harmony export */   "ez": function() { return /* binding */ ImageFallbackStatic; },
/* harmony export */   "nZ": function() { return /* binding */ ImageFallbackProductImage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var constants_Images__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13270);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _CacheImageUtils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(65342);
/* harmony import */ var _ImageUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(13744);
/* harmony import */ var _myLoader__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(55156);
/* eslint-disable no-param-reassign */ 









var ImageFallback = function(_param) {
    var src = _param.src, fallbackSrc = _param.fallbackSrc, _loading = _param.loading, loading = _loading === void 0 ? "eager" : _loading, _isUseLoader = _param.isUseLoader, isUseLoader = _isUseLoader === void 0 ? true : _isUseLoader, _isUseLoaderCache = _param.isUseLoaderCache, isUseLoaderCache = _isUseLoaderCache === void 0 ? false : _isUseLoaderCache, _isUseLoaderCacheProxy = _param.isUseLoaderCacheProxy, isUseLoaderCacheProxy = _isUseLoaderCacheProxy === void 0 ? false : _isUseLoaderCacheProxy, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_param, [
        "src",
        "fallbackSrc",
        "loading",
        "isUseLoader",
        "isUseLoaderCache",
        "isUseLoaderCacheProxy"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), imgSrc = ref[0], setImgSrc = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(src), oldSrc = ref1[0], setOldSrc = ref1[1];
    if (oldSrc !== src) {
        if (isUseLoaderCache || isUseLoaderCacheProxy) {
            isUseLoaderCache = false;
            isUseLoaderCacheProxy = false;
        }
        setImgSrc(false);
        setOldSrc(src);
    }
    if (isUseLoader) {
        rest.loader = _myLoader__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP;
    }
    if (isUseLoaderCache) {
        rest.loader = _myLoader__WEBPACK_IMPORTED_MODULE_6__/* .myLoaderCacheInstant */ .UH;
    }
    if (isUseLoaderCacheProxy) {
        rest.loader = _myLoader__WEBPACK_IMPORTED_MODULE_6__/* .myLoaderCacheProxy */ .EX;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, rest), {
        src: imgSrc ? (0,_ImageUtils__WEBPACK_IMPORTED_MODULE_5__/* .getLinkGCS */ .jA)(fallbackSrc) : (0,_ImageUtils__WEBPACK_IMPORTED_MODULE_5__/* .getLinkGCS */ .jA)(src),
        onError: function() {
            setImgSrc(true);
        },
        loading: loading
    }));
};
var ImageFallbackBanner = function(_param) {
    var src = _param.src, width = _param.width, _q = _param.q, q = _q === void 0 ? 100 : _q, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_param, [
        "src",
        "width",
        "q"
    ]);
    return ImageFallback((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
        src: (0,_ImageUtils__WEBPACK_IMPORTED_MODULE_5__/* .getLinkCacheProxy */ .U4)({
            url: src,
            w: width,
            q: 70
        }),
        fallbackSrc: (0,_CacheImageUtils__WEBPACK_IMPORTED_MODULE_4__/* .getLinkCacheFromGG */ .Lr)({
            src: src
        }),
        isUseLoaderCacheProxy: true,
        width: width
    }, rest), {
        q: q
    }));
};
var ImageFallbackStatic = function(_param) {
    var src = _param.src, _q = _param.q, q = _q === void 0 ? 100 : _q, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_param, [
        "src",
        "q"
    ]);
    return ImageFallback((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
        src: (0,_CacheImageUtils__WEBPACK_IMPORTED_MODULE_4__/* .getLinkImageStatic */ .Jw)(src),
        fallbackSrc: (0,_CacheImageUtils__WEBPACK_IMPORTED_MODULE_4__/* .getLinkImageStatic */ .Jw)(src),
        isUseLoaderCacheProxy: true
    }, rest), {
        q: q
    }));
};
var ImageFallbackStoreImage = function(_param) {
    var _src = _param.src, src = _src === void 0 ? constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .STORE_IMAGE_DEFAULT */ .XDS : _src, _q = _param.q, q = _q === void 0 ? 100 : _q, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_param, [
        "src",
        "q"
    ]);
    return ImageFallback((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
        src: src || constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .STORE_IMAGE_DEFAULT */ .XDS,
        fallbackSrc: constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .STORE_IMAGE_DEFAULT */ .XDS,
        isUseLoaderCacheProxy: true,
        q: q
    }, rest));
};
var ImageFallbackProductImage = function(_param) {
    var _src = _param.src, src = _src === void 0 ? constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .MISSING_IMAGE */ .g_W : _src, _fallbackSrc = _param.fallbackSrc, fallbackSrc = _fallbackSrc === void 0 ? constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .MISSING_IMAGE */ .g_W : _fallbackSrc, _q = _param.q, q = _q === void 0 ? 100 : _q, _quality = _param.quality, quality = _quality === void 0 ? 100 : _quality, _loading = _param.loading, loading = _loading === void 0 ? "lazy" : _loading, _size = _param.size, size = _size === void 0 ? null : _size, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_param, [
        "src",
        "fallbackSrc",
        "q",
        "quality",
        "loading",
        "size"
    ]);
    return ImageFallback((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
        src: (src && size ? "".concat(src).concat((src === null || src === void 0 ? void 0 : src.includes("?")) ? "&" : "?", "size=").concat(size) : src || constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .MISSING_IMAGE */ .g_W) || constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .MISSING_IMAGE */ .g_W,
        fallbackSrc: fallbackSrc || src ? (0,_ImageUtils__WEBPACK_IMPORTED_MODULE_5__/* .getLinkProxyCDNFallback */ .F4)(fallbackSrc || src) : constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .MISSING_IMAGE */ .g_W,
        isUseLoaderCacheProxy: true,
        quality: quality,
        q: q,
        loading: loading
    }, rest));
};
/* harmony default export */ __webpack_exports__["ZP"] = (ImageFallback);



/***/ }),

/***/ 13744:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BQ": function() { return /* binding */ convertImage; },
/* harmony export */   "F4": function() { return /* binding */ getLinkProxyCDNFallback; },
/* harmony export */   "GD": function() { return /* binding */ getLinkProxyFile; },
/* harmony export */   "GM": function() { return /* binding */ getLinkCacheProxyProduct; },
/* harmony export */   "SW": function() { return /* binding */ getLinkProxyCDN; },
/* harmony export */   "U4": function() { return /* binding */ getLinkCacheProxy; },
/* harmony export */   "V5": function() { return /* binding */ getProxyImageList; },
/* harmony export */   "bq": function() { return /* binding */ getLinkProxyVideo; },
/* harmony export */   "jA": function() { return /* binding */ getLinkGCS; },
/* harmony export */   "re": function() { return /* binding */ getLinkCDNGCS; },
/* harmony export */   "w8": function() { return /* binding */ blobToBase64; }
/* harmony export */ });
/* unused harmony export getLinkProxy */
/* harmony import */ var sysconfig__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66225);

// Các host nguồn của ảnh trên storage — link thuộc các host này sẽ được quy về GCS_HOST.
// Link không thuộc host nào ở đây (ảnh static /images, WEB_HOST, CDN khác...) giữ nguyên.
var IMAGE_SOURCE_HOSTS = [
    sysconfig__WEBPACK_IMPORTED_MODULE_0__/* .GG_IMAGE */ .mU,
    sysconfig__WEBPACK_IMPORTED_MODULE_0__/* .GCS_IMAGE */ ._b,
    sysconfig__WEBPACK_IMPORTED_MODULE_0__/* .PROXY_IMAGE */ .mJ,
    sysconfig__WEBPACK_IMPORTED_MODULE_0__/* .DOMAIN_IMAGE_CACHE_LOADER */ .Fc,
    sysconfig__WEBPACK_IMPORTED_MODULE_0__/* .CDN_GCS */ .v5,
    sysconfig__WEBPACK_IMPORTED_MODULE_0__/* .GCS_HOST */ .WG, 
].filter(Boolean);
// Tham khảo convertImage của internal-wms-app.
// URL format: <GCS_HOST>/<bucket>/<path-to-object>?<parameters>
// Params hỗ trợ: width, height, quality (1 - 100) - đều optional.
var convertImage = function() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _url = ref.url, url = _url === void 0 ? null : _url, _width = ref.width, width = _width === void 0 ? null : _width, _height = ref.height, height = _height === void 0 ? null : _height, _quality = ref.quality, quality = _quality === void 0 ? null : _quality;
    if (!url) return url;
    var sourceHost = IMAGE_SOURCE_HOSTS.find(function(host) {
        return url.startsWith(host);
    });
    if (!sourceHost) return url;
    var path = url.replace(sourceHost, "").replace(/^\/+/, "");
    var params = [];
    if (width) params.push("width=".concat(width));
    if (height) params.push("height=".concat(height));
    if (quality) params.push("quality=".concat(quality));
    var query = params.length ? "".concat(path.indexOf("?") >= 0 ? "&" : "?").concat(params.join("&")) : "";
    return "".concat(sysconfig__WEBPACK_IMPORTED_MODULE_0__/* .GCS_HOST */ .WG, "/").concat(path).concat(query);
};
// storage có thể chứa file tên có khoảng trắng -> encode trước khi convert
var encodeImageUrl = function() {
    var url = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
    return url && encodeURI(url.replace(/\s/g, "%20"));
};
// getLinkCDNGCS xử lý file (không phải ảnh) -> chỉ quy host nguồn về CDN_GCS, giữ nguyên path.
// Khác convertImage (xử lý ảnh: quy về GCS_HOST và append params width/height/quality).
var convertToCDNGCS = function() {
    var url = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
    if (!url || !sysconfig__WEBPACK_IMPORTED_MODULE_0__/* .CDN_GCS */ .v5) return url;
    var sourceHost = IMAGE_SOURCE_HOSTS.find(function(host) {
        return url.startsWith(host);
    });
    if (!sourceHost) return url;
    var path = url.replace(sourceHost, "").replace(/^\/+/, "");
    return "".concat(sysconfig__WEBPACK_IMPORTED_MODULE_0__/* .CDN_GCS */ .v5, "/").concat(path);
};
var getLinkProxy = function() {
    var url = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _width = ref.width, width = _width === void 0 ? null : _width, _height = ref.height, height = _height === void 0 ? null : _height, _quality = ref.quality, quality = _quality === void 0 ? null : _quality;
    return convertImage({
        url: url,
        width: width,
        height: height,
        quality: quality
    });
};
var getLinkGCS = function() {
    var url = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _width = ref.width, width = _width === void 0 ? null : _width, _height = ref.height, height = _height === void 0 ? null : _height, _quality = ref.quality, quality = _quality === void 0 ? null : _quality;
    return convertImage({
        url: url,
        width: width,
        height: height,
        quality: quality
    });
};
var getLinkCDNGCS = function() {
    var url = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return convertToCDNGCS(url);
};
var getLinkCacheProxy = function(param) {
    var _url = param.url, url = _url === void 0 ? null : _url, _size = param.size, size = _size === void 0 ? "origin" : _size, _q = param.q, q = _q === void 0 ? 100 : _q, _w = param.w, w = _w === void 0 ? null : _w, _h = param.h, h = _h === void 0 ? null : _h, _isEmpty = param.isEmpty, isEmpty = _isEmpty === void 0 ? false : _isEmpty;
    if (isEmpty) {
        return convertImage({
            url: url
        });
    }
    return convertImage({
        url: url,
        width: w || size,
        height: h,
        quality: q
    });
};
var getLinkCacheProxyProduct = function(img) {
    return getLinkCacheProxy({
        url: img,
        isEmpty: true
    });
};
// thuannc change cache-image
// url đã convert về GCS_HOST (hoặc thuộc web host / CDN riêng) thì giữ nguyên, tránh append params trùng
var getProxyImageList = function() {
    var images = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], size = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    return (images === null || images === void 0 ? void 0 : images.map(function(url) {
        return (url === null || url === void 0 ? void 0 : url.startsWith(sysconfig__WEBPACK_IMPORTED_MODULE_0__/* .GCS_HOST */ .WG)) || sysconfig__WEBPACK_IMPORTED_MODULE_0__/* .WEB_HOST */ .Ul && (url === null || url === void 0 ? void 0 : url.startsWith(sysconfig__WEBPACK_IMPORTED_MODULE_0__/* .WEB_HOST */ .Ul)) || sysconfig__WEBPACK_IMPORTED_MODULE_0__/* .DOMAIN_CDN */ .jz && (url === null || url === void 0 ? void 0 : url.startsWith(sysconfig__WEBPACK_IMPORTED_MODULE_0__/* .DOMAIN_CDN */ .jz)) ? url : convertImage({
            url: url,
            width: size || null
        });
    })) || [];
};
var blobToBase64 = function(blob) {
    return new Promise(function(resolve) {
        var reader = new FileReader();
        reader.onloadend = function() {
            return resolve(reader.result);
        };
        reader.readAsDataURL(blob);
    });
};
var getLinkProxyVideo = function() {
    var url = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
    return convertImage({
        url: encodeImageUrl(url)
    });
};
var getLinkProxyFile = function() {
    var url = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
    return convertImage({
        url: encodeImageUrl(url)
    });
};
var getLinkProxyCDN = function() {
    var url = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _width = ref.width, width = _width === void 0 ? null : _width, _height = ref.height, height = _height === void 0 ? null : _height, _quality = ref.quality, quality = _quality === void 0 ? null : _quality;
    return convertImage({
        url: encodeImageUrl(url),
        width: width,
        height: height,
        quality: quality
    });
};
var getLinkProxyCDNFallback = function() {
    var url = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _width = ref.width, width = _width === void 0 ? null : _width, _height = ref.height, height = _height === void 0 ? null : _height, _quality = ref.quality, quality = _quality === void 0 ? null : _quality;
    return convertImage({
        url: encodeImageUrl(url),
        width: width,
        height: height,
        quality: quality
    });
};


/***/ }),

/***/ 29183:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "YA": function() { return /* binding */ isInactiveCustomerLocked; },
/* harmony export */   "iL": function() { return /* binding */ isPathAllowedForLockedCustomer; }
/* harmony export */ });
/* unused harmony exports HIDE_PRODUCT_INACTIVE_CUSTOMER, isHideProductInactiveEnabled */
/* harmony import */ var constants_Paths__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(199);

// App config key controlling whether inactive (TH) customers are locked to /onboarding
// and cannot see any product until their business profile is approved (BV-1886).
var HIDE_PRODUCT_INACTIVE_CUSTOMER = "HIDE_PRODUCT_INACTIVE_CUSTOMER";
// Pages a locked customer may still open. Everything else redirects to /onboarding.
var LOCKED_CUSTOMER_ALLOWED_PATHS = [
    constants_Paths__WEBPACK_IMPORTED_MODULE_0__/* .ONBOARDING */ .So,
    "/block-account"
];
// Same convention as ALLOW_CHECKOUT: status === 0 => off.
// Missing config (or any other status) => on, so the feature is enabled by default.
var isHideProductInactiveEnabled = function() {
    var appConfig = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    try {
        var ref;
        var item = appConfig === null || appConfig === void 0 ? void 0 : appConfig.find(function(cfg) {
            var ref;
            return (cfg === null || cfg === void 0 ? void 0 : (ref = cfg.value) === null || ref === void 0 ? void 0 : ref.key) === HIDE_PRODUCT_INACTIVE_CUSTOMER;
        });
        return (item === null || item === void 0 ? void 0 : (ref = item.value) === null || ref === void 0 ? void 0 : ref.status) !== 0;
    } catch (e) {
        return true;
    }
};
var isInactiveCustomerLocked = function(customer, appConfig) {
    return (customer === null || customer === void 0 ? void 0 : customer.status) === "INACTIVE" && isHideProductInactiveEnabled(appConfig);
};
// accepts a pathname or a resolvedUrl (with query string)
var isPathAllowedForLockedCustomer = function() {
    var path = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var pathname = (path || "").split("?")[0].replace(/\/+$/, "").toLowerCase();
    return LOCKED_CUSTOMER_ALLOWED_PATHS.includes(pathname);
};


/***/ }),

/***/ 78130:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CL": function() { return /* binding */ trackRemoveFromCart; },
/* harmony export */   "Ht": function() { return /* binding */ initHomePage; },
/* harmony export */   "Kc": function() { return /* binding */ trackAddToCart; },
/* harmony export */   "LI": function() { return /* binding */ trackProductDetail; },
/* harmony export */   "N4": function() { return /* binding */ trackCartPage; },
/* harmony export */   "Qc": function() { return /* binding */ trackPurchase; },
/* harmony export */   "_U": function() { return /* binding */ trackListingPage; },
/* harmony export */   "ap": function() { return /* binding */ resetInsiderUser; }
/* harmony export */ });
/* unused harmony exports INSIDER_PAGE_TYPE, insiderInit, resetInsiderInit, setPageType */
/* harmony import */ var constants_Paths__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(199);
/* harmony import */ var sysconfig__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66225);


var INSIDER_PAGE_TYPE = {
    CONFIRMATION: "Confirmation",
    OTHER: "Other"
};
// ─── Currency & Language mapping ──────────────────────────────────────────────
/**
 * Map ENV_COUNTRY → mã tiền tệ ISO 4217 (3 ký tự).
 * Insider SDK BẮT BUỘC ISO code (THB, VND, USD...), KHÔNG nhận symbol (฿, đ, $).
 */ var mapCurrencyISO = {
    th: "THB",
    vn: "VND",
    kh: "USD",
    cam: "USD",
    en: "USD"
};
var CURRENCY_ISO = mapCurrencyISO[sysconfig__WEBPACK_IMPORTED_MODULE_1__/* .ENV_COUNTRY */ .ng] || "THB";
/**
 * Map mã ngôn ngữ đơn (th, vi, en) → Locale identifier (th_TH, vi_VN, en_US).
 * Insider SDK BẮT BUỘC định dạng locale (vd: en_US, tr_TR, fr_FR).
 */ var mapLocaleIdentifier = {
    th: "th_TH",
    vi: "vi_VN",
    en: "en_US",
    km: "km_KH"
};
var toLocale = function(lang) {
    return mapLocaleIdentifier[lang] || "".concat(lang, "_").concat((lang || "").toUpperCase());
};
/**
 * Gán DOMAIN_WEB_HOST làm prefix cho URL (image hoặc product path).
 * Nếu URL đã là absolute (bắt đầu bằng http:// hoặc //) thì giữ nguyên.
 * Nếu URL là relative path (bắt đầu bằng /) thì thêm domain prefix.
 */ var toAbsoluteUrl = function(path) {
    if (!path) return "";
    if (path.startsWith("http://") || path.startsWith("https://") || path.startsWith("//")) {
        return path;
    }
    return "".concat(sysconfig__WEBPACK_IMPORTED_MODULE_1__/* .DOMAIN_WEB_HOST */ .WL).concat(path.startsWith("/") ? "" : "/").concat(path);
};
// ─── Core queue helper ────────────────────────────────────────────────────────
var getQueue = function() {
    if (false) {}
    window.InsiderQueue = window.InsiderQueue || [];
    return window.InsiderQueue;
};
/**
 * Push { type: 'init' } — PHẢI được gọi DUY NHẤT một lần mỗi page view.
 * Sử dụng flag window.__insiderInitCalled để ngăn duplicate.
 * Flag tự động reset khi gọi resetInsiderInit() (trước mỗi page navigation).
 */ var insiderInit = function() {
    var queue = getQueue();
    if (!queue) return;
    if (window.__insiderInitCalled) return;
    window.__insiderInitCalled = true;
    queue.push({
        type: "init"
    });
};
/**
 * Reset flag cho phép gọi insiderInit() lại — gọi trước khi push data cho page mới.
 * Cần dùng khi chuyển trang (SPA navigation) để init có thể chạy lại.
 */ var resetInsiderInit = function() {
    if (true) {
        window.__insiderInitCalled = false;
    }
};
// ─── Data converters (pure, không side-effect) ───────────────────────────────
var convertPhoneNumber = function(phone) {
    try {
        if (!phone) return "";
        if (phone.startsWith("+66")) return phone;
        if (phone.startsWith("66")) return "+".concat(phone);
        if (phone.startsWith("0")) return "+66".concat(phone.substring(1, phone.length));
        return "+66".concat(phone);
    } catch (error) {
        console.error("Insider convertPhoneNumber error:", error);
    }
    return "";
};
/**
 * Mapping user → Insider user attributes.
 * Quy tắc kiểu dữ liệu mặc định theo Insider SDK:
 *   - String  → '' (chuỗi rỗng, KHÔNG dùng null)
 *   - Number  → 0
 *   - Boolean → true / false
 */ var convertUser = function(user) {
    var ref, ref1;
    return {
        uuid: (user === null || user === void 0 ? void 0 : (ref = user.customerID) === null || ref === void 0 ? void 0 : ref.toString()) || (user === null || user === void 0 ? void 0 : (ref1 = user.code) === null || ref1 === void 0 ? void 0 : ref1.toString()) || "",
        email: (user === null || user === void 0 ? void 0 : user.email) || "",
        email_optin: Boolean(user === null || user === void 0 ? void 0 : user.email),
        phone_number: convertPhoneNumber((user === null || user === void 0 ? void 0 : user.phone) || (user === null || user === void 0 ? void 0 : user.phoneNumber)),
        sms_optin: true,
        name: (user === null || user === void 0 ? void 0 : user.name) || "",
        username: (user === null || user === void 0 ? void 0 : user.username) || (user === null || user === void 0 ? void 0 : user.code) || "",
        gdpr_optin: true,
        custom: {
            orders_count: Number(user === null || user === void 0 ? void 0 : user.ordersCount) || 0,
            is_activated: Boolean(user === null || user === void 0 ? void 0 : user.isActive),
            loyalty_point: Number(user === null || user === void 0 ? void 0 : user.point) || 0
        }
    };
};
/**
 * Mapping guest (user ẩn danh) → Insider user attributes.
 * Dùng để thu thập opt-in từ visitor chưa đăng nhập.
 * gdpr_optin: true để Insider có thể tạo profile và collect data.
 */ var convertGuestUser = function() {
    return {
        uuid: "",
        email: "",
        email_optin: false,
        phone_number: "",
        sms_optin: false,
        name: "",
        username: "",
        gdpr_optin: true
    };
};
/**
 * Mapping cart item → cấu trúc Insider cart item (dùng cho cart sync & cart page).
 * Quy tắc: String → '', Number → 0.
 */ var convertCartItem = function(param) {
    var item = param.item;
    var ref;
    return item && {
        id: String(item.productId || item.productID || ""),
        name: item.name || "",
        taxonomy: item.categoryCodes ? item.categoryCodes : [],
        unit_price: Number(item.currentPrice || item.salePrice || 0) || 0,
        unit_sale_price: Number(item.dealPrice || ((ref = item.deal) === null || ref === void 0 ? void 0 : ref.price) || item.price || 0) || 0,
        quantity: Number(item.quantity) || 0,
        url: toAbsoluteUrl((0,constants_Paths__WEBPACK_IMPORTED_MODULE_0__/* .getPathProductBySlug */ .hq)(item.slug)) || "",
        product_image_url: toAbsoluteUrl(item.imagesProxy && item.imagesProxy[0] || "")
    };
};
/**
 * Mapping order item → cấu trúc Insider purchase item.
 * Quy tắc: String → '', Number → 0, Array → [].
 */ var convertPurchaseItem = function(item) {
    var ref;
    return item && {
        id: String(item.productId || item.productID || ""),
        name: item.name || "",
        taxonomy: [],
        unit_price: Number(item.price || item.salePrice || 0) || 0,
        unit_sale_price: Number(((ref = item.deal) === null || ref === void 0 ? void 0 : ref.price) || item.salePrice || item.price || 0) || 0,
        url: toAbsoluteUrl((0,constants_Paths__WEBPACK_IMPORTED_MODULE_0__/* .getPathProductBySlug */ .hq)(item.slug)) || "",
        product_image_url: toAbsoluteUrl(item.imagesProxy && item.imagesProxy[0] || ""),
        quantity: Number(item.quantity) || 0
    };
};
/**
 * Mapping product → cấu trúc Insider add/remove cart event item.
 * Quy tắc: String → '', Number → 0, Array → [].
 */ var convertCartEventItem = function(product) {
    var ref, ref1;
    return {
        id: String(product.productId || product.skuId || ""),
        name: product.name || "",
        taxonomy: product.categoryCodes ? product.categoryCodes : [],
        unit_price: Number(product.price || product.salePrice || 0) || 0,
        unit_sale_price: Number(((ref = product.deal) === null || ref === void 0 ? void 0 : ref.price) || product.salePrice || product.price || 0) || 0,
        currency: CURRENCY_ISO,
        url: toAbsoluteUrl((0,constants_Paths__WEBPACK_IMPORTED_MODULE_0__/* .getPathProductBySlug */ .hq)(product.slug)) || "",
        product_image_url: toAbsoluteUrl(product.imagesProxy && product.imagesProxy[0] || ((ref1 = product.imageUrls) === null || ref1 === void 0 ? void 0 : ref1[0]) || ""),
        quantity: Number(product.quantity) || 0
    };
};
// ─── Push-only helpers (KHÔNG tự gọi init) ───────────────────────────────────
/**
 * Push { type: 'currency', value: 'THB' } — ISO 4217, bắt buộc trước init.
 */ var pushCurrency = function(queue) {
    queue.push({
        type: "currency",
        value: CURRENCY_ISO
    });
};
/**
 * Push { type: 'language', value: 'th_TH' } — Locale identifier, bắt buộc trước init.
 */ var pushLanguage = function(queue, language) {
    queue.push({
        type: "language",
        value: toLocale(language)
    });
};
/**
 * Push thông tin user (không kèm init).
 */ var pushUser = function(queue, user) {
    if (!user) return;
    queue.push({
        type: "user",
        value: convertUser(user)
    });
};
/**
 * Push trạng thái giỏ hàng (không kèm init).
 * SDK yêu cầu: total, subtotal, shipping_cost, quantity, items (Array).
 * @param {object} queue
 * @param {Array}  cartItems  - Danh sách sản phẩm
 * @param {object} cartTotals - { total, subtotal, shippingCost, quantity }
 */ var pushCart = function(queue, cartItems) {
    var cartTotals = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var items = Array.isArray(cartItems) ? cartItems.map(function(item) {
        return convertCartItem({
            item: item
        });
    }).filter(Boolean) : [];
    var totalQuantity = items.reduce(function(sum, i) {
        return sum + (Number(i.quantity) || 0);
    }, 0);
    queue.push({
        type: "cart",
        value: {
            total: Number(cartTotals.total) || 0,
            subtotal: Number(cartTotals.subtotal) || 0,
            shipping_cost: Number(cartTotals.shippingCost) || 0,
            quantity: Number(cartTotals.quantity) || totalQuantity,
            currency: CURRENCY_ISO,
            items: items
        }
    });
};
/**
 * Push page type (không kèm init).
 */ var pushPage = function(queue, pageData) {
    queue.push({
        type: "page",
        data: pageData
    });
};
// ─── Các hàm public giữ nguyên API cũ (tự gọi init để backward-compat) ──────
/**
 * Đồng bộ giỏ hàng — gọi từ CartReducer mỗi khi cart state thay đổi.
 * KHÔNG gọi insiderInit() vì hàm này chạy nhiều lần trong vòng đời trang.
 * init sẽ do page orchestrator (initHomePage, trackCartPage, v.v.) đảm nhận.
 */ var updateCartItem = function(cartItems) {
    var queue = getQueue();
    if (!queue || !cartItems) return;
    pushCart(queue, cartItems);
};
/**
 * Push user data vào queue — gọi từ AuthContext (root-level) cho cả logged-in lẫn guest.
 * Sử dụng flag window.__insiderUserPushed để đảm bảo chỉ push 1 lần
 * trong suốt vòng đời ứng dụng (application load).
 * Khi user thay đổi (login/logout), flag sẽ được reset và push lại.
 *
 * - user khả dụng → push user attributes thật.
 * - user null/undefined (guest) → push anonymous user với gdpr_optin: true
 *   để Insider tạo profile ẩn danh và collect opt-in.
 *
 * KHÔNG gọi insiderInit() — init sẽ do page orchestrator đảm nhận.
 */ var initUser = function(user) {
    var ref, ref1;
    var queue = getQueue();
    if (!queue) return;
    if (!user) {
        // Guest path — uuid sentinel '__guest__' để phân biệt với logged-in user (uuid='').
        if (window.__insiderUserPushed && window.__insiderUserUuid === "__guest__") return;
        window.__insiderUserPushed = true;
        window.__insiderUserUuid = "__guest__";
        queue.push({
            type: "user",
            value: convertGuestUser()
        });
        return;
    }
    // Logged-in path — so sánh uuid hiện tại để không push lại cùng user.
    var newUuid = (user === null || user === void 0 ? void 0 : (ref = user.customerID) === null || ref === void 0 ? void 0 : ref.toString()) || (user === null || user === void 0 ? void 0 : (ref1 = user.code) === null || ref1 === void 0 ? void 0 : ref1.toString()) || "";
    if (window.__insiderUserPushed && window.__insiderUserUuid === newUuid) return;
    window.__insiderUserPushed = true;
    window.__insiderUserUuid = newUuid;
    pushUser(queue, user);
};
/**
 * Reset flag user pushed — gọi khi logout để cho phép push user mới khi login lại.
 */ var resetInsiderUser = function() {
    if (true) {
        window.__insiderUserPushed = false;
        window.__insiderUserUuid = "";
    }
};
/**
 * Trang Confirmation — push page rồi gọi init ngay.
 */ var confirmation = function() {
    var queue = getQueue();
    if (!queue) return;
    resetInsiderInit();
    pushPage(queue, {
        type: "Confirmation"
    });
    insiderInit();
};
/**
 * Đăng ký thành công — push user + page rồi gọi init ngay.
 */ var registerSuccess = function(user) {
    var queue = getQueue();
    if (!queue || !user) return;
    resetInsiderInit();
    pushUser(queue, user);
    pushPage(queue, {
        type: "dangky_success"
    });
    insiderInit();
};
// ─── Hàm orchestrator cho từng page (currency → language → page event → init) ───
// User được push độc lập ở root-level (AuthContext.initUser) cho cả logged-in lẫn guest.
// Cart snapshot chỉ push trong trackCartPage / trackAddToCart / trackRemoveFromCart.
/**
 * Khởi tạo Insider tracking cho trang Home.
 * Thứ tự push: currency → language → home → init (1 lần).
 * @param {object} options
 * @param {string} options.language - Mã ngôn ngữ (vd: 'th', 'vi')
 */ var initHomePage = function() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _language = ref.language, language = _language === void 0 ? "th" : _language;
    var queue = getQueue();
    if (!queue) return;
    resetInsiderInit();
    pushCurrency(queue);
    pushLanguage(queue, language);
    queue.push({
        type: "home"
    });
    insiderInit();
};
/**
 * Orchestrator cho trang xác nhận đơn hàng (Purchase / Confirmation Page).
 * Thứ tự push: currency → language → purchase → init (1 lần).
 * @param {object} options
 * @param {object} options.order    - Dữ liệu đơn hàng
 * @param {string} options.language - Mã ngôn ngữ
 */ var trackPurchase = function() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, order = ref.order, _language = ref.language, language = _language === void 0 ? "th" : _language;
    var queue = getQueue();
    if (!queue || !order) return;
    try {
        resetInsiderInit();
        pushCurrency(queue);
        pushLanguage(queue, language);
        var orderId = order.orderId, orderCode = order.orderCode, totalPrice = order.totalPrice, _products = order.products, products = _products === void 0 ? [] : _products, _orderItems = order.orderItems, orderItems = _orderItems === void 0 ? [] : _orderItems;
        var sourceItems = products.length ? products : orderItems;
        queue.push({
            type: "purchase",
            value: {
                order_id: String(orderId || orderCode || ""),
                total: Number(totalPrice) || 0,
                currency: CURRENCY_ISO,
                items: sourceItems.map(convertPurchaseItem).filter(Boolean)
            }
        });
        insiderInit();
    } catch (error) {
        console.error("Insider trackPurchase error:", error);
    }
};
/**
 * Tracking thêm sản phẩm vào giỏ (Add to Cart event).
 * Push add_to_cart + cart snapshot. KHÔNG gọi insiderInit() vì init đã fire ở page orchestrator.
 */ var trackAddToCart = function(param) {
    var product = param.product, cartItems = param.cartItems, cartTotals = param.cartTotals;
    var queue = getQueue();
    if (!queue || !product) return;
    resetInsiderInit();
    queue.push({
        type: "add_to_cart",
        value: convertCartEventItem(product)
    });
    pushCart(queue, cartItems, cartTotals);
};
/**
 * Tracking xóa sản phẩm khỏi giỏ (Remove from Cart event).
 * Push remove_from_cart + cart snapshot. KHÔNG gọi insiderInit() vì init đã fire ở page orchestrator.
 */ var trackRemoveFromCart = function(param) {
    var product = param.product, cartItems = param.cartItems, cartTotals = param.cartTotals;
    var queue = getQueue();
    if (!queue || !product) return;
    resetInsiderInit();
    queue.push({
        type: "remove_from_cart",
        value: convertCartEventItem(product)
    });
    pushCart(queue, cartItems, cartTotals);
};
/**
 * Orchestrator cho trang giỏ hàng (Cart Page View).
 * Thứ tự push: currency → language → cart → init (1 lần).
 * @param {object} options
 * @param {Array}  options.cartItems  - Danh sách sản phẩm trong giỏ hàng
 * @param {object} options.cartTotals - { total, subtotal, shippingCost, quantity }
 * @param {string} options.language   - Mã ngôn ngữ
 */ var trackCartPage = function() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _cartItems = ref.cartItems, cartItems = _cartItems === void 0 ? [] : _cartItems, _cartTotals = ref.cartTotals, cartTotals = _cartTotals === void 0 ? {} : _cartTotals, _language = ref.language, language = _language === void 0 ? "th" : _language;
    var queue = getQueue();
    if (!queue) return;
    resetInsiderInit();
    pushCurrency(queue);
    pushLanguage(queue, language);
    pushCart(queue, cartItems, cartTotals);
    insiderInit();
};
/**
 * Orchestrator cho trang chi tiết sản phẩm (Product Detail Page).
 * Thứ tự push: currency → language → product → init (1 lần).
 * @param {object} options
 * @param {object} options.product  - Dữ liệu sản phẩm từ API
 * @param {string} options.language - Mã ngôn ngữ (vd: 'th', 'vi')
 */ var trackProductDetail = function() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, product = ref.product, _language = ref.language, language = _language === void 0 ? "th" : _language;
    var ref1, ref2;
    var queue = getQueue();
    if (!queue || !product) return;
    resetInsiderInit();
    pushCurrency(queue);
    pushLanguage(queue, language);
    queue.push({
        type: "product",
        value: {
            id: String(product.productId || product.skuId || ""),
            name: product.name || "",
            taxonomy: product.categoryCodes ? product.categoryCodes : [],
            unit_price: Number(product.price || product.salePrice || 0) || 0,
            unit_sale_price: Number(((ref1 = product.deal) === null || ref1 === void 0 ? void 0 : ref1.price) || product.salePrice || product.price || 0) || 0,
            currency: CURRENCY_ISO,
            url: toAbsoluteUrl((0,constants_Paths__WEBPACK_IMPORTED_MODULE_0__/* .getPathProductBySlug */ .hq)(product.slug)) || "",
            product_image_url: toAbsoluteUrl(((ref2 = product.imageUrls) === null || ref2 === void 0 ? void 0 : ref2[0]) || product.defaultImage || ""),
            custom: {
                seller_code: product.sellerCode
            }
        }
    });
    insiderInit();
};
/**
 * Orchestrator cho trang danh sách sản phẩm (Listing / Category Page).
 * Thứ tự push: currency → language → category → init (1 lần).
 * @param {object}   options
 * @param {string[]} options.taxonomy     - Mảng tên danh mục
 * @param {string}   options.language     - Mã ngôn ngữ
 * @param {Array}    options.productsInfo - Danh sách sản phẩm trong listing
 */ var trackListingPage = function() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _taxonomy = ref.taxonomy, taxonomy = _taxonomy === void 0 ? [] : _taxonomy, _language = ref.language, language = _language === void 0 ? "th" : _language, _productsInfo = ref.productsInfo, productsInfo = _productsInfo === void 0 ? [] : _productsInfo;
    var queue = getQueue();
    if (!queue) return;
    resetInsiderInit();
    pushCurrency(queue);
    pushLanguage(queue, language);
    queue.push({
        type: "category",
        value: {
            taxonomy: Array.isArray(taxonomy) ? taxonomy : [],
            breadcrumb: Array.isArray(taxonomy) ? taxonomy : [],
            products: productsInfo
        }
    });
    insiderInit();
};
/**
 * Cập nhật loại trang (page type) — dùng cho các trang không có orchestrator riêng.
 * Vẫn tự gọi init để backward-compatible với các trang hiện tại.
 */ function setPageType(type) {
    var queue = getQueue();
    if (!queue) return;
    resetInsiderInit();
    queue.push({
        type: "page",
        data: {
            type: type
        }
    });
    insiderInit();
}
/* harmony default export */ __webpack_exports__["ZP"] = ({
    initUser: initUser,
    confirmation: confirmation,
    convertCartItem: convertCartItem,
    updateCartItem: updateCartItem,
    registerSuccess: registerSuccess,
    setPageType: setPageType,
    trackPurchase: trackPurchase,
    initHomePage: initHomePage
});


/***/ }),

/***/ 79903:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ MonitorUtils; },
  "lq": function() { return /* binding */ mapScreenToEnum; },
  "Dw": function() { return /* binding */ mapSourceToEnum; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./src/clients/index.js + 20 modules
var clients = __webpack_require__(15149);
// EXTERNAL MODULE: ./src/constants/APIUri.js
var APIUri = __webpack_require__(17233);
// EXTERNAL MODULE: ./src/clients/Clients.js + 1 modules
var Clients = __webpack_require__(38307);
;// CONCATENATED MODULE: ./src/clients/MonitorClient.js


var collectEvent = function(event, metadata) {
    return (0,Clients.POST)({
        url: APIUri/* MONITOR_API.COLLECTOR */.SI.COLLECTOR,
        body: {
            event: event,
            metadata: metadata
        }
    });
};
/* harmony default export */ var MonitorClient = ({
    collectEvent: collectEvent
});

// EXTERNAL MODULE: ./src/constants/data/index.js
var data = __webpack_require__(66520);
// EXTERNAL MODULE: ./src/constants/Enums/index.js
var Enums = __webpack_require__(71569);
;// CONCATENATED MODULE: ./src/utils/MonitorUtils.js
// import MonitorClient from "clients/MonitorClient"








var convertProduct = function(product) {
    var _sellerInfo = product.sellerInfo, sellerInfo = _sellerInfo === void 0 ? {} : _sellerInfo, _sku = product.sku, sku = _sku === void 0 ? "" : _sku, _productId = product.productId, productId = _productId === void 0 ? "" : _productId;
    var ref = sellerInfo || {}, _sellerID = ref.sellerID, sellerID = _sellerID === void 0 ? "" : _sellerID;
    return {
        sku: sku,
        seller_id: sellerID.toString(),
        product_id: productId.toString()
    };
};
var mapSourceToEnum = function() {
    var product = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, path = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    if (product === null || product === void 0 ? void 0 : product.isSameCategoryProduct) return Enums/* ENUM_TRACKING_SOURCE.SAME_CATEGORY */.Ii.SAME_CATEGORY;
    if (product === null || product === void 0 ? void 0 : product.isRecommended) return Enums/* ENUM_TRACKING_SOURCE.RECOMMENDATION */.Ii.RECOMMENDATION;
    if (product === null || product === void 0 ? void 0 : product.isRecommendedByTS) return Enums/* ENUM_TRACKING_SOURCE.RECOMMENDATION_TS */.Ii.RECOMMENDATION_TS;
    return data/* SOURCE_TO_ENUM_TRACKING_SOURCE_MAP */.mJ[path] || "";
};
var mapScreenToEnum = function() {
    var product = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, path = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    if (product === null || product === void 0 ? void 0 : product.isSameCategoryProduct) return Enums/* ENUM_TRACKING_SOURCE.SAME_CATEGORY */.Ii.SAME_CATEGORY;
    return data/* SCREEN_TO_ENUM_TRACKING_SOURCE_MAP */.hV[path] || "";
};
// document: https://buymed.atlassian.net/wiki/spaces/V2U/pages/549847093/collector
// TODO: use path -> source :  quick-order, product-list, promotion, seller-home, recommendation, same-category, whislist
var sendSKUEvent = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(event, product) {
        var path, convertedProduct, metadata, _tmp, _tmp1, ref, productSentArray, productIndex, res, info, _tmp2, res1;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    path = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : "";
                    convertedProduct = convertProduct(product);
                    _tmp = {};
                    _tmp1 = {};
                    metadata = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)(_tmp, convertedProduct), (_tmp1.source = mapSourceToEnum(product, path), _tmp1.screen = mapScreenToEnum(product, path), _tmp1));
                    if (!path) metadata === null || metadata === void 0 ? void 0 : delete metadata.source;
                    if (!(event === Enums/* MONITORING_COLLECTOR_TYPE.SKU_IMPRESSION */.Hq.SKU_IMPRESSION)) return [
                        3,
                        2
                    ];
                    productSentArray = (ref = JSON.parse((localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem("collectorProductSentArray")) || "[]")) === null || ref === void 0 ? void 0 : ref.filter(function(item) {
                        return Date.now() - (item === null || item === void 0 ? void 0 : item.lastTimeSend) < 60000;
                    });
                    productIndex = productSentArray === null || productSentArray === void 0 ? void 0 : productSentArray.findIndex(function(prd) {
                        return (prd === null || prd === void 0 ? void 0 : prd.productId) === (convertedProduct === null || convertedProduct === void 0 ? void 0 : convertedProduct.product_id);
                    });
                    if (!(productIndex === -1)) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        MonitorClient.collectEvent(event, metadata)
                    ];
                case 1:
                    res = _state.sent();
                    _tmp2 = {};
                    if ((0,clients/* isValid */.JY)(res)) {
                        info = (_tmp2.lastTimeSend = Date.now(), _tmp2.productId = (convertedProduct === null || convertedProduct === void 0 ? void 0 : convertedProduct.product_id) || "", _tmp2);
                        productSentArray.push(info);
                        try {
                            localStorage.setItem("collectorProductSentArray", JSON.stringify(productSentArray));
                        } catch (error) {
                            window.localStorage.removeItem("collectorProductSentArray");
                        }
                    }
                    return [
                        2,
                        res
                    ];
                case 2:
                    return [
                        4,
                        MonitorClient.collectEvent(event, metadata)
                    ];
                case 3:
                    res1 = _state.sent();
                    return [
                        2,
                        res1
                    ];
            }
        });
    });
    return function sendSKUEvent(event, product) {
        return _ref.apply(this, arguments);
    };
}();
var sendLoginEvent = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(event, metadata) {
        var res;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        MonitorClient.collectEvent(event, metadata)
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res
                    ];
            }
        });
    });
    return function sendLoginEvent(event, metadata) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var MonitorUtils = ({
    sendSKUEvent: sendSKUEvent,
    sendLoginEvent: sendLoginEvent
});


/***/ }),

/***/ 25872:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_toastify__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91444);
/* harmony import */ var _StringUtils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52380);
/* eslint-disable jsx-a11y/alt-text */ 




// const MAP_CACHE_NOTIFY = new Map();
// const checkItem = ({ key }) => {
//   const isHas = MAP_CACHE_NOTIFY.has(key);
//   if (!isHas) {
//     MAP_CACHE_NOTIFY.set({ key, value: true });
//     setTimeout(() => {
//       MAP_CACHE_NOTIFY.delete(key);
//     }, 3000);
//   }
//   return isHas;
// };
var show = function(text, type, options) {
    // create toastId
    var toastId = (0,_StringUtils__WEBPACK_IMPORTED_MODULE_2__/* .hashCode */ .un)(text);
    // prevent duplicate message
    if (react_toastify__WEBPACK_IMPORTED_MODULE_1__/* .toast.isActive */ .Am.isActive(toastId)) {
        react_toastify__WEBPACK_IMPORTED_MODULE_1__/* .toast.update */ .Am.update(toastId, {
            autoClose: options.autoClose || 1500
        });
    } else {
        (0,react_toastify__WEBPACK_IMPORTED_MODULE_1__/* .toast */ .Am)(text, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
            toastId: toastId,
            type: type
        }, options));
    }
};
var info = function(text) {
    show(text, "info", {
        icon: function(param) {
            var theme = param.theme, type = param.type;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: "/static/images/toast/info.svg"
            });
        }
    });
};
var success = function(text) {
    show(text, "success", {
        icon: function(param) {
            var theme = param.theme, type = param.type;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: "/static/images/toast/success.svg"
            });
        }
    });
};
var dark = function(text) {
    show(text, "dark", {
        icon: function(param) {
            var theme = param.theme, type = param.type;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: "/static/images/toast/info.svg"
            });
        }
    });
};
var error = function(text, options) {
    show(text, "error", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, options), {
        icon: function(param) {
            var theme = param.theme, type = param.type;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: "/static/images/toast/error.svg"
            });
        }
    }));
};
var warn = function(text) {
    show(text, "warn", {
        icon: function(param) {
            var theme = param.theme, type = param.type;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: "/static/images/toast/warning.svg"
            });
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    info: info,
    success: success,
    dark: dark,
    error: error,
    warn: warn
});


/***/ }),

/***/ 51380:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ groupArrayOfObjects; }
/* harmony export */ });
var isEmpty = function(item) {
    return Object.keys(item) === 0;
};
var groupArrayOfObjects = function(list, key) {
    return list.reduce(function(rv, x) {
        // eslint-disable-next-line no-param-reassign
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
    }, {});
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    isEmpty: isEmpty,
    groupArrayOfObjects: groupArrayOfObjects
});


/***/ }),

/***/ 85998:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M_": function() { return /* binding */ getCartItemPriceAfterVoucher; },
/* harmony export */   "Rc": function() { return /* binding */ mapPriceAfterDiscount; },
/* harmony export */   "Z8": function() { return /* binding */ buildPriceBreakdownRows; },
/* harmony export */   "cb": function() { return /* binding */ PRICE_BREAKDOWN_ROW; }
/* harmony export */ });
/* unused harmony exports DISCOUNT_PRICE_KEY, toPriceNumber, normalizeDiscountPriceInfo, hasPriceAfterDiscount, formatPercentNumber, MIN_RATE_PERCENT_LABEL, formatRatePercent */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29815);
// BV-1586: giá sau ưu đãi (deal + chiết khấu thanh toán + voucher) ở PDP/PLP và giá đã giảm theo dòng
// trong giỏ. File này chỉ chứa hàm thuần (không import), dùng chung cho WebService, PriceBreakdown và giỏ.
//
// Dữ liệu từ BE (th_frontend-apis, contract docs/BV-1586 mục 5.1, 5.2):
//   consumedPrice.priceAfterDiscount, consumedPrice.totalDiscount, product.discountPriceInfo[]
//   discountPriceInfo[] = { key, index, discount, ...field theo key }
// Thiếu field (BE chưa deploy, chưa đăng nhập, lỗi engine) -> isShowPriceAfterDiscount = false, hiển thị như cũ.



var DISCOUNT_PRICE_KEY = {
    DEAL: "DEAL",
    BANK_DISCOUNT: "BANK_DISCOUNT",
    VOUCHER_PLATFORM: "VOUCHER_PLATFORM",
    VOUCHER_SELLER: "VOUCHER_SELLER"
};
var PRICE_BREAKDOWN_ROW = {
    ORIGIN_PRICE: "ORIGIN_PRICE",
    DEAL: DISCOUNT_PRICE_KEY.DEAL,
    PRICE_AFTER_DEAL: "PRICE_AFTER_DEAL",
    BANK_DISCOUNT: DISCOUNT_PRICE_KEY.BANK_DISCOUNT,
    VOUCHER_PLATFORM: DISCOUNT_PRICE_KEY.VOUCHER_PLATFORM,
    VOUCHER_SELLER: DISCOUNT_PRICE_KEY.VOUCHER_SELLER,
    FINAL_PRICE: "FINAL_PRICE"
};
var KNOWN_KEYS = Object.values(DISCOUNT_PRICE_KEY);
// null cho giá trị rỗng / không phải số, để phân biệt "không có" với 0
var toPriceNumber = function(value) {
    if (value === null || value === undefined || value === "" || typeof value === "boolean") return null;
    var num = Number(value);
    return Number.isFinite(num) ? num : null;
};
var round2 = function(value) {
    return Math.round((value + Number.EPSILON) * 100) / 100;
};
// Giữ dòng có key đã biết và discount > 0, sort theo index (thiếu index thì xếp cuối, giữ thứ tự BE)
var normalizeDiscountPriceInfo = function(list) {
    if (!Array.isArray(list)) return [];
    return list.map(function(line, position) {
        return {
            line: line,
            position: position
        };
    }).filter(function(param) {
        var line = param.line;
        return line && KNOWN_KEYS.indexOf(line.key) >= 0 && toPriceNumber(line.discount) > 0;
    }).sort(function(a, b) {
        var ref;
        var indexA = (ref = toPriceNumber(a.line.index)) !== null && ref !== void 0 ? ref : Number.MAX_SAFE_INTEGER;
        var ref1;
        var indexB = (ref1 = toPriceNumber(b.line.index)) !== null && ref1 !== void 0 ? ref1 : Number.MAX_SAFE_INTEGER;
        return indexA - indexB || a.position - b.position;
    }).map(function(param) {
        var line = param.line;
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, line), {
            discount: toPriceNumber(line.discount)
        });
    });
};
// Contract mục 6.2: chỉ hiển thị khi có priceAfterDiscount và có ít nhất 1 dòng khác DEAL với discount > 0
var hasPriceAfterDiscount = function() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, priceAfterDiscount = ref.priceAfterDiscount, discountPriceInfo = ref.discountPriceInfo;
    var finalPrice = toPriceNumber(priceAfterDiscount);
    if (finalPrice === null || finalPrice < 0) return false;
    return normalizeDiscountPriceInfo(discountPriceInfo).some(function(line) {
        return line.key !== DISCOUNT_PRICE_KEY.DEAL;
    });
};
// Map field BE vào product của web (WebService.convertProductV2). Không ghi đè field giá cũ.
// consumedPrice.totalDiscount không map: UI không dùng, và tên totalDiscount đã có nghĩa khác ở order.
var mapPriceAfterDiscount = function() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, consumedPrice = ref.consumedPrice, discountPriceInfo = ref.discountPriceInfo, priceAfterDeal = ref.priceAfterDeal, retailPriceValue = ref.retailPriceValue, _withoutLogin = ref.withoutLogin, withoutLogin = _withoutLogin === void 0 ? false : _withoutLogin;
    var lines = normalizeDiscountPriceInfo(discountPriceInfo);
    var priceAfterDiscount = toPriceNumber(consumedPrice === null || consumedPrice === void 0 ? void 0 : consumedPrice.priceAfterDiscount);
    var ref1;
    var originPrice = (ref1 = toPriceNumber(consumedPrice === null || consumedPrice === void 0 ? void 0 : consumedPrice.retailPriceValue)) !== null && ref1 !== void 0 ? ref1 : toPriceNumber(retailPriceValue);
    var dealLine = lines.find(function(line) {
        return line.key === DISCOUNT_PRICE_KEY.DEAL;
    });
    var ref2, ref3;
    // giá sau deal/campaign lấy từ BE (P = consumedPrice.currentPrice), chỉ tự suy ra khi BE thiếu
    var priceAfterDealValue = (ref3 = (ref2 = toPriceNumber(consumedPrice === null || consumedPrice === void 0 ? void 0 : consumedPrice.priceAfterDeal)) !== null && ref2 !== void 0 ? ref2 : toPriceNumber(priceAfterDeal)) !== null && ref3 !== void 0 ? ref3 : toPriceNumber(consumedPrice === null || consumedPrice === void 0 ? void 0 : consumedPrice.currentPrice);
    if (priceAfterDealValue === null && originPrice !== null) {
        priceAfterDealValue = dealLine ? round2(originPrice - dealLine.discount) : originPrice;
    }
    var isShowPriceAfterDiscount = !withoutLogin && originPrice !== null && hasPriceAfterDiscount({
        priceAfterDiscount: priceAfterDiscount,
        discountPriceInfo: lines
    });
    return {
        discountPriceInfo: lines,
        priceAfterDiscount: priceAfterDiscount,
        priceAfterDeal: priceAfterDealValue,
        originPrice: originPrice,
        isShowPriceAfterDiscount: isShowPriceAfterDiscount
    };
};
// Số % hiển thị: tối đa 2 chữ số thập phân, bỏ số 0 thừa (0.5 -> "0.5", 5 -> "5", 0.31428 -> "0.31")
var formatPercentNumber = function(value) {
    var num = toPriceNumber(value);
    if (num === null) return "";
    return String(round2(num));
};
// rate của VOUCHER_PLATFORM là tỉ lệ (0.0031428571) -> "0.31"
// rate > 0 nhưng làm tròn 2 chữ số ra 0 (vd 0.00002 -> 0.002%) -> "<0.01", không hiện "0%"
var MIN_RATE_PERCENT_LABEL = "<0.01";
var formatRatePercent = function(rate) {
    var num = toPriceNumber(rate);
    if (num === null || num <= 0) return "";
    var percent = num * 100;
    return round2(percent) > 0 ? formatPercentNumber(percent) : MIN_RATE_PERCENT_LABEL;
};
var defaultFormatPrice = function(value) {
    var num = toPriceNumber(value);
    return num === null ? "" : "฿".concat(num.toFixed(2));
};
var defaultFormatAmount = function(value) {
    var num = toPriceNumber(value);
    return num === null ? "" : String(num).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
var buildBankRow = function(line, formatDiscount) {
    var percent = formatPercentNumber(line.percent);
    return {
        id: PRICE_BREAKDOWN_ROW.BANK_DISCOUNT,
        // tiêu đề là tên phương thức thanh toán (pricing-v2), thiếu thì dùng nhãn chung
        label: line.paymentMethodName || "",
        labelKey: line.paymentMethodName ? "" : "priceBreakdown.bankDiscount",
        subKey: percent ? "priceBreakdown.bankDiscountSub" : "",
        subParams: {
            percent: percent
        },
        subText: "",
        value: formatDiscount(line.discount),
        isDiscount: true,
        voucherCode: ""
    };
};
var buildPlatformRow = function(line, formatDiscount, formatAmount) {
    var rate = formatRatePercent(line.rate);
    var minOrderValue = toPriceNumber(line.minOrderValue);
    var subKey = "";
    if (rate && minOrderValue > 0) subKey = "priceBreakdown.platformVoucherSub";
    else if (rate) subKey = "priceBreakdown.platformVoucherRateSub";
    return {
        id: PRICE_BREAKDOWN_ROW.VOUCHER_PLATFORM,
        label: "",
        labelKey: "priceBreakdown.platformVoucher",
        subKey: subKey,
        subParams: {
            rate: rate,
            minOrderValue: minOrderValue > 0 ? formatAmount(minOrderValue) : ""
        },
        subText: subKey ? "" : line.displayName || "",
        value: formatDiscount(line.discount),
        isDiscount: true,
        voucherCode: line.voucherCode || ""
    };
};
var buildSellerRow = function(line, formatDiscount) {
    return {
        id: PRICE_BREAKDOWN_ROW.VOUCHER_SELLER,
        label: "",
        labelKey: "priceBreakdown.sellerVoucher",
        subKey: "",
        subParams: {},
        subText: line.displayName || "",
        value: formatDiscount(line.discount),
        isDiscount: true,
        voucherCode: line.voucherCode || ""
    };
};
// Dựng các dòng của popover / bottom sheet "รายละเอียดราคา" (contract mục 6.3).
// Trả cấu trúc (key i18n + params + giá đã format) để popover và bottom sheet render giống nhau.
//   formatPrice: formatter THB của web (formatCurrency), formatAmount: số có dấu phân cách (formatNumber)
var buildPriceBreakdownRows = function() {
    var data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _formatPrice = ref.formatPrice, formatPrice = _formatPrice === void 0 ? defaultFormatPrice : _formatPrice, _formatAmount = ref.formatAmount, formatAmount = _formatAmount === void 0 ? defaultFormatAmount : _formatAmount;
    var ref1 = data || {}, originPrice = ref1.originPrice, priceAfterDeal = ref1.priceAfterDeal, priceAfterDiscount = ref1.priceAfterDiscount, discountPriceInfo = ref1.discountPriceInfo;
    if (!hasPriceAfterDiscount({
        priceAfterDiscount: priceAfterDiscount,
        discountPriceInfo: discountPriceInfo
    })) return [];
    var lines = normalizeDiscountPriceInfo(discountPriceInfo);
    var formatDiscount = function(value) {
        return "-".concat(formatPrice(Math.abs(value)));
    };
    var origin = toPriceNumber(originPrice);
    var priceRows = [
        {
            id: PRICE_BREAKDOWN_ROW.ORIGIN_PRICE,
            labelKey: "priceBreakdown.originPrice",
            value: formatPrice(origin)
        }, 
    ];
    var dealLine = lines.find(function(line) {
        return line.key === DISCOUNT_PRICE_KEY.DEAL;
    });
    if (dealLine) {
        var ref2;
        var afterDeal = (ref2 = toPriceNumber(priceAfterDeal)) !== null && ref2 !== void 0 ? ref2 : origin !== null ? round2(origin - dealLine.discount) : null;
        priceRows.push({
            id: PRICE_BREAKDOWN_ROW.DEAL,
            labelKey: "priceBreakdown.directDiscount",
            value: formatDiscount(dealLine.discount),
            isDiscount: true
        }, {
            id: PRICE_BREAKDOWN_ROW.PRICE_AFTER_DEAL,
            labelKey: "priceBreakdown.priceAfterDirectDiscount",
            value: formatPrice(afterDeal)
        });
    }
    var discountRows = lines.map(function(line) {
        switch(line.key){
            case DISCOUNT_PRICE_KEY.BANK_DISCOUNT:
                return buildBankRow(line, formatDiscount);
            case DISCOUNT_PRICE_KEY.VOUCHER_PLATFORM:
                return buildPlatformRow(line, formatDiscount, formatAmount);
            case DISCOUNT_PRICE_KEY.VOUCHER_SELLER:
                return buildSellerRow(line, formatDiscount);
            default:
                return null;
        }
    }).filter(Boolean);
    // divider sau nhóm giá (ngay dưới "หลังหักส่วนลดโดยตรง", hoặc "ราคาเดิม" khi không có deal)
    priceRows[priceRows.length - 1] = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, priceRows[priceRows.length - 1]), {
        hasDividerAfter: discountRows.length > 0
    });
    return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(priceRows).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(discountRows), [
        {
            id: PRICE_BREAKDOWN_ROW.FINAL_PRICE,
            labelKey: "priceBreakdown.finalPrice",
            noteKey: "priceBreakdown.finalPriceNote",
            value: formatPrice(priceAfterDiscount),
            isTotal: true,
            hasDividerBefore: true
        }, 
    ]);
};
// Giỏ hàng (contract mục 5.4): order-service trả cartItems[].price (đơn giá sau deal/campaign) và
// priceAfterVoucher (đơn giá sau voucher phân bổ vào SKU). Trả null khi không đủ điều kiện -> hiển thị như cũ.
// Luôn đọc price của chính cart item, không dùng salePrice/displayPrice (giá catalog do CartService ghép vào).
var getCartItemPriceAfterVoucher = function(item) {
    if (!item || item.isGift || item.isSelected === false) return null;
    var price = toPriceNumber(item.price);
    var priceAfterVoucher = toPriceNumber(item.priceAfterVoucher);
    if (price === null || priceAfterVoucher === null) return null;
    if (price <= 0 || priceAfterVoucher < 0 || priceAfterVoucher >= price) return null;
    return {
        price: price,
        priceAfterVoucher: priceAfterVoucher
    };
};


/***/ }),

/***/ 40110:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n2": function() { return /* binding */ buildLimitOrderMessage; },
/* harmony export */   "wy": function() { return /* binding */ normalizeMaxQuantityPerOrder; }
/* harmony export */ });
/* unused harmony exports hasLimitPerDay, hasLimitPerOrder */
/* harmony import */ var constants_data__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66520);
/* harmony import */ var utils_FormatNumber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44097);


/**
 * Purchase limits of a SKU (BV-2070).
 *
 * Both limits are optional and come from the CMS "Quantity limitation setting" menu:
 * - limit per day   : sku-limit.quantity (only when the config is active)
 * - limit per order : sku-main.maxQuantityPerOrder
 *
 * A missing limit arrives as null/undefined/0. MAX_PRODUCT_QTY_DISPLAY (100,000) is the legacy
 * "unlimited" sentinel the UI already relies on, so it is treated as "not configured" as well.
 */ var hasLimitPerDay = function(limitPerDay) {
    return Number(limitPerDay) > 0;
};
var hasLimitPerOrder = function(limitPerOrder) {
    return Number(limitPerOrder) > 0 && Number(limitPerOrder) < constants_data__WEBPACK_IMPORTED_MODULE_0__/* .MAX_PRODUCT_QTY_DISPLAY */ .Im;
};
/**
 * Max quantity per order usable by the UI: the configured value, or the "unlimited" sentinel
 * when nothing is configured (the quantity input clamps to this value).
 */ var normalizeMaxQuantityPerOrder = function(maxQuantityPerOrder) {
    return Number(maxQuantityPerOrder) > 0 ? Number(maxQuantityPerOrder) : constants_data__WEBPACK_IMPORTED_MODULE_0__/* .MAX_PRODUCT_QTY_DISPLAY */ .Im;
};
var fillTemplate = function(template, quantity, unit) {
    return (template === null || template === void 0 ? void 0 : template.replace("{quantity}", (0,utils_FormatNumber__WEBPACK_IMPORTED_MODULE_1__/* .formatNumber */ .uf)(quantity)).replace("{unit}", unit)) || "";
};
/**
 * Message shown under a product ("Buy maximum X unit/day and maximum Y unit/order").
 *
 * - nothing configured            -> ''
 * - only per day                  -> per-day message
 * - only per order                -> per-order message
 * - both, per day <= per order    -> per-day message (the per-order limit can never be reached)
 * - both, per day >  per order    -> per-day message + per-order message
 *
 * @param {object} params
 * @param {number|null} params.limitPerDay
 * @param {number|null} params.limitPerOrder
 * @param {string} params.unit
 * @param {{perDay: string, perOrder: string, andPerOrder: string}} params.templates
 *   templates with {quantity} and {unit} placeholders
 */ var buildLimitOrderMessage = function(param) {
    var limitPerDay = param.limitPerDay, limitPerOrder = param.limitPerOrder, unit = param.unit, _templates = param.templates, templates = _templates === void 0 ? {} : _templates;
    var perDayConfigured = hasLimitPerDay(limitPerDay);
    var perOrderConfigured = hasLimitPerOrder(limitPerOrder);
    if (!perDayConfigured && !perOrderConfigured) return "";
    if (!perOrderConfigured) return fillTemplate(templates.perDay, limitPerDay, unit);
    if (!perDayConfigured) return fillTemplate(templates.perOrder, limitPerOrder, unit);
    if (Number(limitPerDay) <= Number(limitPerOrder)) {
        return fillTemplate(templates.perDay, limitPerDay, unit);
    }
    return "".concat(fillTemplate(templates.perDay, limitPerDay, unit), " ").concat(fillTemplate(templates.andPerOrder, limitPerOrder, unit));
};


/***/ }),

/***/ 73744:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I1": function() { return /* binding */ invalid; }
/* harmony export */ });
/* unused harmony exports notfound, ok, error, existed, forbidden, unauthorized */
/* harmony import */ var constants_Enums__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71569);

var response = function(param) {
    var status = param.status, message = param.message;
    return {
        status: status,
        message: message
    };
};
var notfound = function(msg) {
    return response({
        status: constants_Enums__WEBPACK_IMPORTED_MODULE_0__/* .HTTP_STATUS.NotFound */ .MG.NotFound,
        msg: msg
    });
};
var invalid = function(msg) {
    return response({
        status: constants_Enums__WEBPACK_IMPORTED_MODULE_0__/* .HTTP_STATUS.invalid */ .MG.invalid,
        msg: msg
    });
};
var ok = function(data, msg) {
    return response({
        status: constants_Enums__WEBPACK_IMPORTED_MODULE_0__/* .HTTP_STATUS.Ok */ .MG.Ok,
        msg: msg,
        data: data
    });
};
var error = function(msg) {
    return response({
        status: constants_Enums__WEBPACK_IMPORTED_MODULE_0__/* .HTTP_STATUS.Error */ .MG.Error,
        msg: msg
    });
};
var existed = function(msg) {
    return response({
        status: constants_Enums__WEBPACK_IMPORTED_MODULE_0__/* .HTTP_STATUS.Existed */ .MG.Existed,
        msg: msg
    });
};
var forbidden = function(msg) {
    return response({
        status: constants_Enums__WEBPACK_IMPORTED_MODULE_0__/* .HTTP_STATUS.Forbidden */ .MG.Forbidden,
        msg: msg
    });
};
var unauthorized = function(msg) {
    return response({
        status: constants_Enums__WEBPACK_IMPORTED_MODULE_0__/* .HTTP_STATUS.Unauthorized */ .MG.Unauthorized,
        msg: msg
    });
};
// deprecated 22Feb2023 - Dinh Tran
// export const parse = (resp) => {
//   if (resp) {
//     return resp;
//   }
//   return error('Hệ thống đang tạm dừng, xin vui lòng thử lại sau');
// };
/* harmony default export */ __webpack_exports__["ZP"] = ({
    notfound: notfound,
    invalid: invalid,
    ok: ok,
    error: error,
    existed: existed,
    forbidden: forbidden,
    unauthorized: unauthorized
});


/***/ }),

/***/ 69702:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "cQ": function() { return /* binding */ getSessionTokenClient; },
/* harmony export */   "fR": function() { return /* binding */ setSessionTokenClient; },
/* harmony export */   "tq": function() { return /* binding */ removeSessionToken; }
/* harmony export */ });
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36808);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(js_cookie__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var sysconfig__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66225);


function getSessionTokenClient() {
    var tk = js_cookie__WEBPACK_IMPORTED_MODULE_0___default().get(sysconfig__WEBPACK_IMPORTED_MODULE_1__/* .ACCESS_TOKEN */ .LA, {
        domain: sysconfig__WEBPACK_IMPORTED_MODULE_1__/* .GENERAL_DOMAIN */ .oC
    });
    if (tk && tk.length > 0) {
        return tk;
    }
    var tkLong = js_cookie__WEBPACK_IMPORTED_MODULE_0___default().get(sysconfig__WEBPACK_IMPORTED_MODULE_1__/* .ACCESS_TOKEN_LONGLIVE */ .R$, {
        domain: sysconfig__WEBPACK_IMPORTED_MODULE_1__/* .GENERAL_DOMAIN */ .oC
    }) || "";
    return tkLong && tkLong !== "null" ? tkLong : "";
}
function setSessionTokenClient(value) {
    js_cookie__WEBPACK_IMPORTED_MODULE_0___default().set(sysconfig__WEBPACK_IMPORTED_MODULE_1__/* .ACCESS_TOKEN */ .LA, value, {
        domain: sysconfig__WEBPACK_IMPORTED_MODULE_1__/* .GENERAL_DOMAIN */ .oC
    });
    js_cookie__WEBPACK_IMPORTED_MODULE_0___default().set(sysconfig__WEBPACK_IMPORTED_MODULE_1__/* .ACCESS_TOKEN_LONGLIVE */ .R$, value, {
        domain: sysconfig__WEBPACK_IMPORTED_MODULE_1__/* .GENERAL_DOMAIN */ .oC
    });
}
// TODO: refactor contanst
var removeSessionToken = function() {
    js_cookie__WEBPACK_IMPORTED_MODULE_0___default().remove(sysconfig__WEBPACK_IMPORTED_MODULE_1__/* .ACCESS_TOKEN */ .LA, {
        domain: sysconfig__WEBPACK_IMPORTED_MODULE_1__/* .GENERAL_DOMAIN */ .oC
    });
    js_cookie__WEBPACK_IMPORTED_MODULE_0___default().remove(sysconfig__WEBPACK_IMPORTED_MODULE_1__/* .ACCESS_TOKEN */ .LA);
    js_cookie__WEBPACK_IMPORTED_MODULE_0___default().remove(sysconfig__WEBPACK_IMPORTED_MODULE_1__/* .ACCESS_TOKEN_LONGLIVE */ .R$, {
        domain: sysconfig__WEBPACK_IMPORTED_MODULE_1__/* .GENERAL_DOMAIN */ .oC
    });
    js_cookie__WEBPACK_IMPORTED_MODULE_0___default().remove(sysconfig__WEBPACK_IMPORTED_MODULE_1__/* .ACCESS_TOKEN_LONGLIVE */ .R$);
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
    getSessionTokenClient: getSessionTokenClient,
    removeSessionToken: removeSessionToken,
    setSessionTokenClient: setSessionTokenClient
});


/***/ }),

/***/ 52380:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "KX": function() { return /* binding */ getSlugFromUrl; },
/* harmony export */   "Mq": function() { return /* binding */ encodeUrl; },
/* harmony export */   "c7": function() { return /* binding */ capitalizeText; },
/* harmony export */   "eq": function() { return /* binding */ capitalizeTextFirst; },
/* harmony export */   "nH": function() { return /* binding */ formatPriceMap; },
/* harmony export */   "oK": function() { return /* binding */ changeAlias; },
/* harmony export */   "rd": function() { return /* binding */ trimText; },
/* harmony export */   "un": function() { return /* binding */ hashCode; },
/* harmony export */   "yk": function() { return /* binding */ phoneNumberPattern; },
/* harmony export */   "yr": function() { return /* binding */ truncateFileName; }
/* harmony export */ });
/* unused harmony exports firstUppercase, trimNumber, capitalizeFirstOfEachWords, truncateString */
/* harmony import */ var sysconfig__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66225);

var hashCode = function(text) {
    var hash = 0;
    var i;
    var chr;
    for(i = 0; i < text.length; i += 1){
        chr = text.charCodeAt(i);
        // eslint-disable-next-line no-bitwise
        hash = (hash << 5) - hash + chr;
        // eslint-disable-next-line no-bitwise
        hash |= 0; // Convert to 32bit integer
    }
    return hash;
};
var encodeUrl = function(url) {
    return encodeURIComponent(url);
};
var phoneNumberPattern = /(84|0|\+84)+([0-9]{9})\b/g;
var changeAlias = function(alias) {
    if (!alias || alias.length === 0) {
        return "";
    }
    var str = alias;
    str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
    str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
    str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
    str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
    str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
    str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
    str = str.replace(/đ/g, "d");
    str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, "A");
    str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, "E");
    str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, "I");
    str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, "O");
    str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, "U");
    str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, "Y");
    str = str.replace(/Đ/g, "D");
    str = str.trim();
    return str;
};
var searchStringInStrings = function(arr, str) {
    var _loop = function(i) {
        var w = arrSearch[i];
        if (w && w.length > 0 && changeAlias(w) !== w) {
            rsUnSigned = rsUnSigned.filter(function(el) {
                return el.name.toUpperCase().indexOf(w, 0) > -1;
            });
        }
    };
    if (!str || str.length === 0) {
        return arr;
    }
    var searchValue = str.toUpperCase();
    var searchValueUnsigned = changeAlias(searchValue);
    var isUnSigned = searchValue === searchValueUnsigned;
    var rsUnSigned = arr.filter(function(el) {
        var ref;
        return (el === null || el === void 0 ? void 0 : (ref = el.unsignedKey) === null || ref === void 0 ? void 0 : ref.toUpperCase().indexOf(searchValueUnsigned, 0)) > -1;
    });
    if (isUnSigned) {
        return rsUnSigned;
    }
    var arrSearch = searchValue.split(" ");
    for(var i = 0; i <= arrSearch.length; i += 1)_loop(i);
    return rsUnSigned;
};
var firstUppercase = function(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
};
var capitalizeTextFirst = function(text) {
    return firstUppercase((text === null || text === void 0 ? void 0 : text.toLocaleLowerCase()) || "");
};
var capitalizeText = function(phrase) {
    if (phrase === undefined) {
        return "";
    }
    return phrase.toLowerCase().split(" ").map(function(word) {
        return word.charAt(0).toUpperCase() + word.slice(1);
    }).join(" ");
};
var trimText = function(text) {
    return text.trim().split(" ").filter(function(character) {
        return character !== "";
    }).join(" ");
};
var trimNumber = function(number) {
    return number.trim().split(" ").filter(function(digit) {
        return digit !== "";
    }).join("");
};
var titleCase = function(str) {
    var splitStr = str.toLowerCase().split(" ");
    for(var i = 0; i < splitStr.length; i += 1){
        // You do not need to check if i is larger than splitStr length, as your for does that for you
        // Assign it back to the array
        splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    // Directly return the joined string
    return splitStr.join(" ");
};
var capitalizeFirstOfEachWords = function(text) {
    var ref;
    var splitStr = (ref = text === null || text === void 0 ? void 0 : text.trim()) === null || ref === void 0 ? void 0 : ref.split(" ");
    if ((splitStr === null || splitStr === void 0 ? void 0 : splitStr.length) > 0) {
        var titleCaseArray = splitStr.map(function(word) {
            var ref;
            return (((ref = word[0]) === null || ref === void 0 ? void 0 : ref.toUpperCase()) || "") + word.slice(1);
        });
        return titleCaseArray.join(" ") || "";
    }
    return "";
};
var truncateString = function(text) {
    var length = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 32, suffix = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "...";
    if (typeof text !== "string") {
        throw Error("text must be a string");
    }
    return text.length > length ? "".concat(text.substring(0, length)).concat(suffix) : text;
};
var truncateFileName = function(path) {
    var length = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 32, suffix = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "...";
    if (typeof path !== "string") {
        throw Error("path must be a string");
    }
    var pathInfo = path.split(".");
    var extension = pathInfo.pop().toLowerCase();
    var fileName = pathInfo.join("");
    return "".concat(truncateString(fileName, length, suffix), ".").concat(extension);
};
var toBase64 = function(str) {
    return  false ? 0 : window.btoa(str);
};
var getSlugFromUrl = function(param) {
    var _url = param.url, url = _url === void 0 ? "" : _url;
    if (!url) return "";
    var urlSplits = url.split("/");
    return urlSplits.length > 0 ? urlSplits[urlSplits.length - 1] : url;
};
// todo
var formatPriceMap = function(price) {
    switch(sysconfig__WEBPACK_IMPORTED_MODULE_0__/* .ENV_COUNTRY */ .ng){
        case "vn":
            return "".concat(price, "đ");
        default:
            return "".concat(sysconfig__WEBPACK_IMPORTED_MODULE_0__/* .CURRENCY */ .wA, " ").concat(price);
    }
};
/* harmony default export */ __webpack_exports__["ZP"] = ({
    hashCode: hashCode,
    changeAlias: changeAlias,
    encodeUrl: encodeUrl,
    searchStringInStrings: searchStringInStrings,
    capitalizeText: capitalizeText,
    capitalizeTextFirst: capitalizeTextFirst,
    firstUppercase: firstUppercase,
    trimText: trimText,
    trimNumber: trimNumber,
    titleCase: titleCase,
    capitalizeFirstOfEachWords: capitalizeFirstOfEachWords,
    toBase64: toBase64,
    getSlugFromUrl: getSlugFromUrl,
    truncateString: truncateString,
    truncateFileName: truncateFileName,
    phoneNumberPattern: phoneNumberPattern
});


/***/ }),

/***/ 70220:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "oD": function() { return /* binding */ groupTypeofFileByExtension; },
/* harmony export */   "r$": function() { return /* binding */ cleanAccents; },
/* harmony export */   "xb": function() { return /* binding */ isEmpty; }
/* harmony export */ });
/* unused harmony exports isDigits, formValidateEmail, validateMst, isFullName */
/* harmony import */ var sysconfig__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66225);

var validateEmail = function(email) {
    var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
};
var validateAsciiEmail = function(email) {
    var re = /^[A-Za-z0-9_](?:[A-Za-z0-9_]|-(?=[A-Za-z0-9_])|\.(?=[A-Za-z0-9_]))*@(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\.)+[A-Za-z]{2,}$/;
    return re.test(email);
};
var isEmpty = function(val) {
    return !val || val.length === 0 || typeof val === "object" && Object.keys(val).length === 0;
};
var checkLength = function(val, length) {
    if (isEmpty(val)) {
        return false;
    }
    if (val.length > length) {
        return false;
    }
    return true;
};
var isNumber = function(str) {
    try {
        if (typeof str === "number") return true;
        if (typeof str !== "string") return false;
        return !Number.isNaN(str) && !Number.isNaN(parseFloat(str));
    } catch (error) {
        return false;
    }
};
var isDigits = function(str) {
    var reg = /^\d+$/;
    return reg.test(str);
};
var formValidateEmail = function(e) {
    if (validateEmail(e.target.value)) {
        return true;
    }
    return false;
};
// let ENV_COUNTRY = 'th';
var validatePhone = function(phone) {
    // regex phone VN
    // const re = /^(09|07|08|05|03|02[0|1|2|3|4|5|6|7|8|9])+([0-9]{8})\b/;
    var re = /^(09|07|08|05|03|02[0-9])[0-9]{8}$/;
    // regex phone Cam
    var camRegex = /^(0[1|6|7|8|9][0-9])([0-9]{7})$/;
    var thRegex = /^0[689]\d{8}$/;
    if (sysconfig__WEBPACK_IMPORTED_MODULE_0__/* .ENV_COUNTRY */ .ng === "vn") return re.test(String(phone));
    if (sysconfig__WEBPACK_IMPORTED_MODULE_0__/* .ENV_COUNTRY */ .ng === "cam") return camRegex.test(String(phone));
    if (sysconfig__WEBPACK_IMPORTED_MODULE_0__/* .ENV_COUNTRY */ .ng === "th") return re.test(String(phone)) || camRegex.test(String(phone)) || thRegex.test(String(phone));
    return  true || 0;
};
function Error(message, type) {
    this.message = message;
    this.type = type;
}
var Success = function(message, type) {
    return {
        message: message,
        validate: true,
        type: type
    };
};
var funcValidateEmail = function(email) {
    if (isEmpty(email)) throw new Error("not_entered_your_email", "email");
    if (!validateEmail(email)) throw new Error("email_not_correct_format", "email");
};
var funcValidateName = function(name) {
    if (isEmpty(name)) throw new Error("not_entered_your_name", "name");
    if ((name === null || name === void 0 ? void 0 : name.length) <= 2) throw new Error("name_min2", "name");
};
// eslint-disable-next-line operator-linebreak
var funcValidatePassword = function(pass) {
    if (isEmpty(pass)) throw new Error("not_entered_your_password", "password");
    if (pass.length < 8 || pass.length > 30) {
        // throw new Error('password_must_be_entered_min2_and_max30_character', 'password');
        // Đã fix content 8 - 30
        throw new Error("password_must_be_entered_min2_and_max30_character", "password");
    }
};
var funcValidatePhoneNumber = function(phone) {
    if (isEmpty(phone)) throw new Error("not_entered_your_phoneNumber", "phone");
    if (!validatePhone(phone)) {
        throw new Error("phone_not_correct_format", "phone");
    }
};
var validateMst = function() {
    var mst = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    if (isEmpty(mst)) {
        return "not_entered_tax_code";
    }
    var lengthMst = mst.length;
    if (lengthMst !== 13) {
        return "message_tax_number_format";
    }
    if (!isDigits(mst)) {
        return "message_tax_code_wrong_format";
    }
    // ✅ Kiểm tra nếu tất cả đều là cùng một số
    if (/^(\d)\1{12}$/.test(mst)) {
        return "message_tax_code_wrong_format";
    }
    return null;
};
var validateData = {
    email: funcValidateEmail,
    name: funcValidateName,
    password: funcValidatePassword,
    phoneNumber: funcValidatePhoneNumber,
    mst: validateMst
};
var cleanAccents = function(text) {
    var str = text;
    str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
    str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
    str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
    str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
    str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
    str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
    str = str.replace(/đ/g, "d");
    str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, "A");
    str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, "E");
    str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, "I");
    str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, "O");
    str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, "U");
    str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, "Y");
    str = str.replace(/Đ/g, "D");
    // Combining Diacritical Marks
    str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, ""); // huyền, sắc, hỏi, ngã, nặng
    str = str.replace(/\u02C6|\u0306|\u031B/g, ""); // mũ â (ê), mũ ă, mũ ơ (ư)
    return str;
};
var isFullName = function(str) {
    var regex = /^[a-zA-Z]([-']?[a-zA-Z]+)*( [a-zA-Z]([-']?[a-zA-Z]+)*)+$/;
    return regex.test(str);
};
var groupTypeofFileByExtension = function(extension) {
    if (!extension) throw new Error("Invalid extension: ".concat(extension));
    var TYPE_OF_EXTENSION = {
        PDF: [
            "pdf"
        ],
        IMAGE: [
            "apng",
            "avif",
            "gif",
            "jpg",
            "jpeg",
            "jfif",
            "pjpeg",
            "pjp",
            "png",
            "svg",
            "webp"
        ],
        VIDEO: [
            "webm",
            "mkv",
            "flv",
            "vob",
            "ogv",
            "ogg",
            "drc",
            "gifv",
            "avi",
            "mov",
            "yuv",
            "mp4",
            "m4p",
            "m4v",
            "mpg",
            "mp2",
            "mpeg", 
        ],
        XLS: [
            "xlsx",
            "xlsm",
            "xlsb",
            "xltx",
            "xltm",
            "xls",
            "xlt",
            "xml",
            "xlam",
            "xla",
            "xlw",
            "xlr"
        ],
        DOCS: [
            "odt",
            "txt",
            "ppt",
            "pptx",
            "ods"
        ]
    };
    var type = Object.keys(TYPE_OF_EXTENSION).find(function(key) {
        return TYPE_OF_EXTENSION[key].includes(extension);
    });
    return type || "OTHER"; // return OTHER if can't find any type
};
function validatePostcode(input, expectedLength) {
    // Convert number to string
    var str = typeof input === "number" ? input.toString() : input;
    // Check if it's all digits
    var isNumeric = /^\d+$/.test(str);
    // Reject leading zeros (if length > 1)
    var hasLeadingZero = str.length > 1 && str.startsWith("0");
    return str.length === expectedLength && isNumeric && !hasLeadingZero;
}
/* harmony default export */ __webpack_exports__["ZP"] = ({
    validateEmail: validateEmail,
    isEmpty: isEmpty,
    isNumber: isNumber,
    checkLength: checkLength,
    formValidateEmail: formValidateEmail,
    validatePhone: validatePhone,
    Error: Error,
    Success: Success,
    validateData: validateData,
    validateMst: validateMst,
    cleanAccents: cleanAccents,
    isDigits: isDigits,
    isFullName: isFullName,
    groupTypeofFileByExtension: groupTypeofFileByExtension,
    validatePostcode: validatePostcode,
    validateAsciiEmail: validateAsciiEmail
});


/***/ }),

/***/ 66661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$y": function() { return /* binding */ remainTime; },
/* harmony export */   "ZP": function() { return /* binding */ calculateTimeLeft; },
/* harmony export */   "nw": function() { return /* binding */ calculateTimeLeftWithoutColon; },
/* harmony export */   "tt": function() { return /* binding */ calculateTimeLeftMinutesSeconds; }
/* harmony export */ });
function calculateTimeLeft(time) {
    var remainingTime = +new Date(time) - +new Date();
    var timeLeft = {};
    if (remainingTime > 0) {
        var days = Math.floor(remainingTime / (1000 * 60 * 60 * 24));
        var hours = Math.floor(remainingTime / (1000 * 60 * 60) % 24).toString().padStart(2, "0");
        var minutes = " : ".concat(Math.floor(remainingTime / 1000 / 60 % 60).toString().padStart(2, "0"), " : ");
        var seconds = Math.floor(remainingTime / 1000 % 60).toString().padStart(2, "0");
        timeLeft = {
            days: days,
            hours: hours,
            minutes: minutes,
            seconds: seconds
        };
    }
    return timeLeft;
};
var ONE_DAY = 86400000;
var remainTime = function(time1, time2) {
    return (time1 - time2) / ONE_DAY;
};
function calculateTimeLeftWithoutColon(time) {
    var remainingTime = +new Date(time) - +new Date();
    var timeLeft = {};
    if (remainingTime > 0) {
        var days = Math.floor(remainingTime / (1000 * 60 * 60 * 24));
        var hours = Math.floor(remainingTime / (1000 * 60 * 60) % 24).toString().padStart(2, "0");
        var minutes = Math.floor(remainingTime / 1000 / 60 % 60).toString().padStart(2, "0");
        var seconds = Math.floor(remainingTime / 1000 % 60).toString().padStart(2, "0");
        timeLeft = {
            days: days,
            hours: hours,
            minutes: minutes,
            seconds: seconds
        };
    }
    return timeLeft;
}
function calculateTimeLeftMinutesSeconds(time) {
    var remainingTime = +new Date(time) - +new Date();
    var timeLeft = {};
    if (remainingTime > 0) {
        var totalMinutes = Math.floor(remainingTime / (1000 * 60));
        var minutes = totalMinutes.toString().padStart(2, "0");
        var seconds = Math.floor(remainingTime / 1000 % 60).toString().padStart(2, "0");
        timeLeft = {
            minutes: minutes,
            seconds: seconds
        };
    }
    return timeLeft;
}


/***/ }),

/***/ 74118:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EI": function() { return /* binding */ debounceFunc400; },
/* harmony export */   "Nr": function() { return /* binding */ useDebounce; },
/* harmony export */   "V9": function() { return /* binding */ debounceFunc300; },
/* harmony export */   "X4": function() { return /* binding */ debounceFunc500; },
/* harmony export */   "X_": function() { return /* binding */ debounceFunc100; },
/* harmony export */   "dW": function() { return /* binding */ debounceFunc200; },
/* harmony export */   "zB": function() { return /* binding */ debounceFunc1000; }
/* harmony export */ });
/* unused harmony export debounceFunc */
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29815);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


var debounce = function(func, wait) {
    var timeout;
    return function executedFunction() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var later = function() {
            clearTimeout(timeout);
            func.apply(void 0, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(args));
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
};
var debounceFunc = function(time) {
    return debounce(function(cb) {
        return cb();
    }, time);
};
var debounceFunc100 = debounceFunc(100);
var debounceFunc200 = debounceFunc(200);
var debounceFunc300 = debounceFunc(300);
var debounceFunc400 = debounceFunc(400);
var debounceFunc500 = debounceFunc(500);
var debounceFunc1000 = debounceFunc(1000);
// export const debounceFunc1500 = debounceFunc(1500); // deprecated 22Feb2023 - Dinh Tran
var DEFAULT_DELAY = 300;
var useDebounce = function(value) {
    var delay = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : DEFAULT_DELAY;
    // State and setters for debounced value
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(value), debouncedValue = ref[0], setDebouncedValue = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var handler = setTimeout(function() {
            setDebouncedValue(value);
        }, delay);
        return function() {
            clearTimeout(handler);
        };
    }, [
        value,
        delay
    ]);
    return debouncedValue;
};
/* harmony default export */ __webpack_exports__["ZP"] = (debounce);


/***/ }),

/***/ 70627:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports FACEBOOK_PIXEL_CODE, event, addPaymentInfo, search, lead */
/* provided dependency */ var process = __webpack_require__(83454);
/* eslint-disable camelcase */ var FACEBOOK_PIXEL_CODE = process.env.NEXT_PUBLIC_FACEBOOK_PIXEL_CODE; // deprecated 22Feb2023 - Dinh Tran
// https://developers.facebook.com/docs/facebook-pixel/advanced/
var event = function(name) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (window && window.fbq) window.fbq("track", name, options);
};
var convertProduct = function(item) {
    return {
        content_name: item === null || item === void 0 ? void 0 : item.name,
        content_category: item === null || item === void 0 ? void 0 : item.category,
        content_ids: [
            item === null || item === void 0 ? void 0 : item.sku
        ],
        content_type: (item === null || item === void 0 ? void 0 : item.type) || "product",
        value: (item === null || item === void 0 ? void 0 : item.displayPrice) || 0,
        currency: (item === null || item === void 0 ? void 0 : item.currency) || "BATH"
    };
};
var pageview = function() {
    if (window && window.fbq) window.fbq("track", "PageView");
};
var addPaymentInfo = function() {
    event("AddPaymentInfo");
};
var addToCart = function(item) {
    event("AddToCart", convertProduct(item));
};
var addToWishlist = function(item) {
    event("AddToWishlist", convertProduct(item));
};
// deprecated 22Feb2023 - Dinh Tran
var completeLead = function() {
    event("Lead");
};
var completeRegistration = function() {
    event("CompleteRegistration");
};
var search = function() {
    event("Search");
};
var submitApplication = function() {
    event("SubmitApplication");
};
/*
content_name: 'Really Fast Running Shoes',
  content_category: 'Apparel & Accessories > Shoes',
  content_ids: ['1234'],
  content_type: 'product',
  value: 0.50,
  currency: 'USD'
*/ var viewContent = function(item) {
    return event("ViewContent", convertProduct(item));
};
/*
  {
    content_ids: ['partner_event_id'],
    eventref: 'fb_oea' // or set to empty string
    currency: 'USD'  // your currency string value goes here
    num_items: 1, // your number of tickets purchased value goes here
    value: 15.30, // your total transaction value goes here
  }
*/ var purchase = function(param) {
    var content_ids = param.content_ids, _currency = param.currency, currency = _currency === void 0 ? "BATH" : _currency, _num_items = param.num_items, num_items = _num_items === void 0 ? 0 : _num_items, _value = param.value, value = _value === void 0 ? 0 : _value;
    return event("Purchase", {
        content_ids: content_ids,
        currency: currency,
        num_items: num_items,
        value: value
    });
};
var lead = function() {
    return event("Lead");
};
var initiateCheckout = function() {
    return event("InitiateCheckout");
};
/* harmony default export */ __webpack_exports__["ZP"] = ({
    pageview: pageview,
    event: event,
    search: search,
    purchase: purchase,
    initiateCheckout: initiateCheckout,
    lead: lead,
    viewContent: viewContent,
    submitApplication: submitApplication,
    addPaymentInfo: addPaymentInfo,
    addToCart: addToCart,
    addToWishlist: addToWishlist,
    completeLead: completeLead,
    completeRegistration: completeRegistration
});


/***/ }),

/***/ 23482:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var constants_Paths__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(199);

var getLinkTagDeal = function(param, type) {
    var tmp = param.campaign, campaignWithProduct = tmp === void 0 ? {} : tmp;
    var link = "";
    var campaign = (campaignWithProduct || {}).campaign;
    var ref = campaign || {}, campaignType = ref.campaignType, linkTagBySlug = ref.slug;
    if (campaignType !== "DAILY_DEAL") {
        link = "".concat(constants_Paths__WEBPACK_IMPORTED_MODULE_0__/* .KHUYEN_MAI */ .ab, "/").concat(linkTagBySlug);
    }
    // deal
    if (!campaignWithProduct || Object.keys(campaignWithProduct).length === 0) link = "/deals";
    if (type === "CAMPAIGN" && Object.keys(campaignWithProduct || {}).length === 0) link = constants_Paths__WEBPACK_IMPORTED_MODULE_0__/* .PATH_PROMOTIONS */ .qJ;
    return link;
};
/* harmony default export */ __webpack_exports__["Z"] = (getLinkTagDeal);


/***/ }),

/***/ 57059:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "uy": function() { return /* binding */ GA_TRACKING_ID_V2; }
/* harmony export */ });
/* unused harmony exports GA_TRACKING_ID, GA_TRACKING_GLOBAL_ID, pageview, event, eventV2, eventSimple, eventSimpleV2, addToCartInPage, viewItemInPage, addToCart */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var constants_Paths__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(199);
/* provided dependency */ var process = __webpack_require__(83454);
/* eslint-disable no-param-reassign */ // CHange event



// https://thuocsi1-my.sharepoint.com/:x:/g/personal/thao_thuocsi_vn/Ectdykk4E59Pkyzi_lWivnMBapW58CEv3KtbOMUKhakyOg?e=hTiArp
var GA_TRACKING_ID = "G-P6R3F40XGS";
var GA_TRACKING_GLOBAL_ID = process.env.NEXT_PUBLIC_GA_GLOBAL;
var GA_TRACKING_ID_V2 = process.env.NEXT_PUBLIC_GA_MOBILEV2;
// https://developers.google.com/analytics/devguides/collection/gtagjs/pages
var pageview = function(url, user) {
    if (GA_TRACKING_ID && window.gtagGA && !(url === null || url === void 0 ? void 0 : url.endsWith("/loading"))) {
        var data = {
            user_id: (user === null || user === void 0 ? void 0 : user.customerID) || "",
            client_id: (user === null || user === void 0 ? void 0 : user.customerID) || "",
            customer_id: (user === null || user === void 0 ? void 0 : user.customerID) || "",
            page_path: url,
            user_properties: {
                scope: (user === null || user === void 0 ? void 0 : user.scope) || "",
                level: (user === null || user === void 0 ? void 0 : user.level) || "",
                color: (user === null || user === void 0 ? void 0 : user.color) || "",
                customer_id: (user === null || user === void 0 ? void 0 : user.customerID) || ""
            }
        };
        window.gtagGA("config", GA_TRACKING_ID, data);
    }
    if (GA_TRACKING_GLOBAL_ID && window.gtagGlobal && !(url === null || url === void 0 ? void 0 : url.endsWith("/loading"))) {
        var data1 = {
            user_id: (user === null || user === void 0 ? void 0 : user.customerID) || "",
            client_id: (user === null || user === void 0 ? void 0 : user.customerID) || "",
            customer_id: "th-".concat((user === null || user === void 0 ? void 0 : user.customerID) || ""),
            page_path: url,
            user_properties: {
                scope: (user === null || user === void 0 ? void 0 : user.scope) || "",
                level: (user === null || user === void 0 ? void 0 : user.level) || "",
                color: (user === null || user === void 0 ? void 0 : user.color) || "",
                customer_id: "th-".concat((user === null || user === void 0 ? void 0 : user.customerID) || "")
            }
        };
        window.gtagGlobal("config", GA_TRACKING_GLOBAL_ID, data1);
    }
};
// https://developers.google.com/analytics/devguides/collection/gtagjs/events
var event = function(param) {
    var action = param.action, params = param.params;
    if (window && window.gtagGA) {
        window.gtagGA("event", action, params);
    }
};
var eventV2 = function(param) {
    var action = param.action, params = param.params;
    if (window && window.gtagGAV2) {
        window.gtagGAV2("event", action, params);
    }
};
var showModalDiscovery = function(param) {
    var sku = param.sku;
    return event({
        action: "discovery_show_detail",
        params: {
            event_category: "discovery",
            event_label: "Show detail discovery",
            value: sku
        }
    });
};
var displayTopSearch = function() {
    return event({
        action: "display_topSearch",
        params: {
            event_category: "TopSearch",
            event_label: "Display Top Search"
        }
    });
};
var displayCountDownBar = function() {
    return event({
        action: "display_countDownBar",
        params: {
            event_category: "CountDownBar",
            event_label: "Display CountDownBar"
        }
    });
};
var clickTopSearch = function(param) {
    var _url = param.url, url = _url === void 0 ? "" : _url, _hashtag = param.hashtag, hashtag = _hashtag === void 0 ? "" : _hashtag;
    return event({
        action: "click",
        params: {
            event_category: "Homepage",
            value: url,
            event_label: "Click top search: ".concat(hashtag)
        }
    });
};
var convertCategory = function() {
    var categories = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    var mapCategory = {};
    categories === null || categories === void 0 ? void 0 : categories.forEach(function(category, i) {
        mapCategory["item_category".concat(i >= 1 ? i + 1 : "")] = category;
    });
    return mapCategory;
};
var convertProduct = function(product) {
    var itemBrand = "";
    var ref = (product === null || product === void 0 ? void 0 : product.sellerInfo) || {}, sellerID = ref.sellerID, name = ref.name, code = ref.code;
    if (sellerID && name && code) {
        // brand:  `${product?.sellerInfo?.name ? `${product?.sellerInfo?.name} - ` : ''}${product?.sellerCode || ''}`
        // chỉnh lại format theo chuẩn bên mkt gửi
        itemBrand = "".concat(sellerID, " - ").concat(name, " (").concat(code, ")");
    }
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
        item_id: (product === null || product === void 0 ? void 0 : product.productId) || "",
        item_name: (product === null || product === void 0 ? void 0 : product.name) || "",
        price: "".concat(product === null || product === void 0 ? void 0 : product.displayPrice) || "",
        value: (product === null || product === void 0 ? void 0 : product.displayPrice) || "",
        // tags: product?.tags || '',
        quantity: (product === null || product === void 0 ? void 0 : product.quantity) || 0,
        search_keyword: (product === null || product === void 0 ? void 0 : product.searchKey) || (product === null || product === void 0 ? void 0 : product.search_keyword) || "",
        item_brand: itemBrand
    }, convertCategory((product === null || product === void 0 ? void 0 : product.categoryCodes) || []));
};
// eslint-disable-next-line camelcase
var eventSimple = function(action, event_category, event_label) {
    return event({
        action: action,
        params: {
            event_category: event_category,
            event_label: event_label
        }
    });
};
// eslint-disable-next-line camelcase
var eventSimpleV2 = function(action, event_category, event_label) {
    return eventV2({
        action: action,
        params: {
            event_category: event_category,
            event_label: event_label
        }
    });
};
var eventEcommerce = function(param) {
    var action = param.action, products = param.products, _params = param.params, params = _params === void 0 ? {} : _params;
    // if (window.CONVERT_USD_TO_KHR) {
    //   // convert to USD
    //   if (params?.currency === 'KHR') params.currency = 'USD';
    //   if (products?.length > 0)
    //     products = products.map((product) => {
    //       product.displayPrice /= window.CONVERT_USD_TO_KHR;
    //       return product;
    //     });
    //   if (params?.value) params.value /= window.CONVERT_USD_TO_KHR;
    //   if (params?.shipping) params.shipping /= window.CONVERT_USD_TO_KHR;
    // }
    event({
        action: action,
        params: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, params), {
            items: (products === null || products === void 0 ? void 0 : products.map(function(product) {
                return convertProduct(product);
            })) || []
        })
    });
};
// CONSTANTS and MAP
var TIME_TO_TRACK = [
    10,
    30,
    90,
    300,
    600
];
var mapPathToCategory = function(path) {
    if (path === "/user/wishlist" || path === "/productviewed") return "My account";
    if (path === "/quick-order") return "Quick order";
    if (path === constants_Paths__WEBPACK_IMPORTED_MODULE_0__/* .PATH_PROMOTIONS */ .qJ) return "Promotion";
    if (path === constants_Paths__WEBPACK_IMPORTED_MODULE_0__/* .KHUYEN_MAI */ .ab) return "Promotion";
    if (path.includes("seller") || path.includes("flagship-store") || path.includes("product-listing")) return "Sellers";
    return path;
};
var mapPathToLabel = {
    "/user/wishlist": "Add To Cart mục sản phẩm quan t\xe2m",
    "/productviewed": "Add To Cart mục sản phẩm đ\xe3 xem"
};
var clickMenubar = function(item) {
    return eventSimple("click", "Homepage", "Click menubar <NAME: ".concat(item.name, " | URL: ").concat(item.url, ">"));
};
var clickCountdownbar = function(item) {
    return eventSimple("click", "Homepage", "Click countdownbar <TYPE: ".concat(item.imageType, " | URL: ").concat(item.url, ">"));
};
var clickBanner = function(item) {
    return eventSimple("click", "Homepage", "Click banner <URL: ".concat(item.link, ">"));
};
var showBanner = function(item) {
    return eventSimple("impression", "Homepage", "Show banner <URL: ".concat(item.link, ">"));
};
// Click event category product
var clickTabInProduct = function(tab) {
    return eventSimple("click", "Product", "Click tab <".concat(tab, ">"));
};
var clickViewShop = function(shop) {
    return eventSimple("click", "Product", 'Button "Xem store" '.concat(shop));
};
var clickCategoryDrugsTitle = function(ingredient) {
    return eventSimple("click", "Product", "Từng danh mục trong Nh\xf3m thuốc: ".concat(ingredient));
};
var clickCategoryManufacturerTitle = function(manufacturer) {
    return eventSimple("click", "Product", "Từng danh mục trong Nh\xe0 sản xuất: ".concat(manufacturer));
};
var clickTagInProduct = function(tag) {
    return eventSimple("click", "Product", "Click Tag ".concat(tag));
};
var clickViewAllProductSameManufacturer = function() {
    return eventSimple("click", "Product", 'Button "Xem tất cả" | Sản phẩm c\xf9ng nh\xe0 b\xe1n h\xe0ng');
};
var clickViewAllProductSameIngredient = function() {
    return eventSimple("click", "Product", 'Button "Xem tất cả" | C\xf9ng hoạt chất');
};
// Sellers event
var clickViewAllSellers = function() {
    return eventSimple("click", "Sellers", 'Button  "xem tất cả"');
};
var clickSellerNameID = function(sellerName, ID) {
    return eventSimple("click", "Sellers", "Click seller name: ".concat(sellerName, " - ID: ").concat(ID));
};
var clickFlagshipStoreNameID = function(storeName, ID) {
    return eventSimple("click", "Sellers", "Click flagship-store name: ".concat(storeName, " - ID: ").concat(ID));
};
// Click event category order
var clickUsePromoCode = function() {
    return eventSimple("click", "Order", 'Click mục "D\xf9ng m\xe3 giảm gi\xe1" trong trang cart');
};
var clickUseDirectlyPromoCode = function(code) {
    return eventSimple("click", "Order", "Click d\xf9ng ngay m\xe3 giảm gi\xe1 ".concat(code));
};
// Time tracking
var timeTracking = function(label, eventCategory, time) {
    return eventSimple("timing_".concat(time), eventCategory, label);
};
// Scroll depth
var scrollDepth = function(label, eventCategory, scrollPercent) {
    return eventSimple("scrolldepth_".concat(scrollPercent, "_percent"), eventCategory, label);
};
// My Account
var clickTrackingOrder = function() {
    return eventSimple("click", "My account", 'Click v\xe0o Trang "Tra cứu vận đơn"');
};
var clickRewardDetail = function(name, id) {
    return eventSimple("click", "My account", "Click Reward Name: ".concat(name, " | ID: ").concat(id));
};
// Promotion
var clickViewAllPromotion = function(promotion) {
    return eventSimple("click", "Promotion", 'Button "Xem tất cả" '.concat(promotion));
};
var clickActivePromotionButton = function() {
    return eventSimple("click", "Promotion", '\xf4 khung giờ "Đang diễn ra"');
};
var clickNextPromotionButton = function() {
    return eventSimple("click", "Promotion", '\xf4 khung giờ "Sắp diễn ra"');
};
// Search
var mapEventBySearchType = {
    1: "Search",
    2: "Search_ingredient",
    3: "Search_seller",
    4: "Search_drug"
};
var clickSearch = function(type, keyword) {
    return eventSimple(mapEventBySearchType[type], "Search", 'Keyword: "'.concat(keyword, '"'));
};
var searchInQuickOrder = function(keyword) {
    return eventSimple("Search_Quick_order", "Quick order", 'Keyword: "'.concat(keyword, '"'));
};
// Custom Ecommerce event with path
var addToCartInPage = function(product, path) {
    eventEcommerce({
        action: "add_to_cart",
        products: [
            product
        ],
        params: {
            currency: "THB",
            event_category: mapPathToCategory(path),
            event_label: mapPathToLabel[path] || "Add To Cart"
        }
    });
};
var viewItemInPage = function(param) {
    var product = param.product, path = param.path;
    eventEcommerce({
        action: "click_item",
        params: {
            content_type: "Product",
            event_category: mapPathToCategory(path),
            event_label: "View Product Detail Has SKU:".concat((product === null || product === void 0 ? void 0 : product.sku) || "")
        },
        products: [
            product
        ]
    });
};
var toggleMobileV2 = function(state) {
    return eventSimple("click", "Toggle Mobile V2", state ? "V1 to V2" : "V2 to V1");
};
var viewBlog = function() {
    return eventSimple("view_blog", "Engagement", "View Blog");
};
var viewCareer = function() {
    return eventSimple("view_career", "Engagement", "View Career");
};
var viewSeller = function() {
    return eventSimple("view_seller", "Engagement", "View Seller");
};
var popup = function() {
    return eventSimple("popup", "Engagement", "Click popup");
};
var callHotline = function() {
    return eventSimple("call", "Engagement", "Call Hotline");
};
var sendEmail = function() {
    return eventSimple("send_mail", "Engagement", "Send Mail");
};
var chat = function() {
    return eventSimple("chat", "Engagement", "Chat Facebook");
};
var fanpage = function() {
    return eventSimple("fanpage", "Engagement", "Fanpage");
};
var downloadIos = function() {
    return eventSimple("download_IOS", "Engagement", "Donwload App IOS");
};
var downloadAndroid = function() {
    return eventSimple("download_android", "Engagement", "Donwload App Android");
};
var referral = function() {
    return eventSimple("referral", "Engagement", "Referral SMS");
};
var register = function() {
    return eventSimple("register", "User - Web", "Register");
};
var registedCompleted = function() {
    return eventSimple("registedCompleted", "User - Web", "Registed Completed");
};
var sendFeedback = function() {
    return eventSimple("send_feedback", "Order", "Send Feedback");
};
var requestInvoice = function() {
    return eventSimple("request_invoice", "Order", "Request Invoice");
};
var viewPromotion = function() {
    return eventSimple("view_promotion", "Promotion", "View Discount Codes");
};
var selectPromotion = function() {
    var promotions = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return event({
        action: "select_content",
        params: {
            event_category: "Promotion",
            event_label: "Select Discount Codes",
            promotions: promotions
        }
    });
};
// const removePromotion = () => eventSimple('remove_promotion', 'Promotion', 'Remove Discount Codes');
var exchangePoint = function() {
    return eventSimple("exchange_point", "Promotion", "Redeem Accumulation Points");
};
var reOrderShowPopup = function() {
    return eventSimple("re_order_click", "ReOrder", "Show popup re-order");
};
var reOrderClickOk = function() {
    return eventSimple("re_order_click_ok", "ReOrder", "Click ok re-order");
};
var reOrderClickCancel = function() {
    return eventSimple("re_order_click_cancel", "ReOrder", "Click cancel re-order");
};
var voteV2 = function(state) {
    return eventSimpleV2("click", "user_choose_option", state);
};
var surveyV2 = function(state) {
    return eventSimpleV2("click", "user_click_survey", state);
};
// thuannc
// https://thuocsi1.sharepoint.com/:x:/s/MarketingTeam-Thuocsivn/EaYMD88U9jtLqH8UHbDXwbUBXFIXejaN3MJWOxU86-lwJg?e=Ev3bVq
var clickBtnSignInAction = function() {
    return eventSimple("click", "Homepage", "Click Sign In");
};
var clickBtnSignUpAction = function() {
    return eventSimple("click", "Homepage", "Click Sign Up");
};
var addToCart = function(product) {
    eventEcommerce({
        action: "add_to_cart",
        products: [
            product
        ],
        params: {
            currency: "THB",
            event_category: "Product",
            event_label: "Add To Cart"
        }
    });
};
var addToWishList = function(product) {
    eventEcommerce({
        action: "add_to_wishlist",
        params: {
            event_category: "Product",
            event_label: "Add To Wishlist"
        },
        products: [
            product
        ]
    });
};
var removeFromCart = function(product) {
    eventEcommerce({
        action: "remove_from_cart",
        params: {
            event_category: "Product",
            event_label: "Remove from cart"
        },
        products: [
            product
        ]
    });
};
var beginCheckout = function(cartInfo) {
    var ref = cartInfo || {}, cartItems = ref.cartItems, _redeemApplyResult = ref.redeemApplyResult, redeemApplyResult = _redeemApplyResult === void 0 ? [] : _redeemApplyResult;
    var voucherInfo = redeemApplyResult[0] || null;
    var ref1 = voucherInfo || {}, _code = ref1.code, code = _code === void 0 ? null : _code, _canUse = ref1.canUse, canUse = _canUse === void 0 ? false : _canUse;
    eventEcommerce({
        action: "begin_checkout",
        params: {
            coupon: canUse && code,
            event_category: "Order",
            event_label: "Go To Checkout"
        },
        products: cartItems
    });
};
var purchase = function(param) {
    var cartId = param.cartId, _cartItems = param.cartItems, cartItems = _cartItems === void 0 ? [] : _cartItems, _totalPrice = param.totalPrice, totalPrice = _totalPrice === void 0 ? 0 : _totalPrice, _deliveryMethodFee = param.deliveryMethodFee, deliveryMethodFee = _deliveryMethodFee === void 0 ? 0 : _deliveryMethodFee, _redeemApplyResult = param.redeemApplyResult, redeemApplyResult = _redeemApplyResult === void 0 ? [] : _redeemApplyResult;
    var voucherInfo = redeemApplyResult[0] || null;
    var ref = voucherInfo || {}, _code = ref.code, code = _code === void 0 ? null : _code, _canUse = ref.canUse, canUse = _canUse === void 0 ? false : _canUse;
    eventEcommerce({
        action: "purchase",
        params: {
            id: cartId,
            coupon: canUse && code,
            transaction_id: cartId,
            shipping: deliveryMethodFee || 0,
            value: totalPrice,
            currency: "THB",
            event_category: "Order",
            event_label: "Action Checkout"
        },
        products: cartItems
    });
};
var viewContent = function(param) {
    var product = param.product;
    eventEcommerce({
        action: "click_item",
        params: {
            content_type: "Product",
            event_category: "Product",
            event_label: "View Product Detail Has SKU:".concat((product === null || product === void 0 ? void 0 : product.sku) || "")
        },
        products: [
            product
        ]
    });
};
var selectItem = function(param) {
    var product = param.product;
    eventEcommerce({
        action: "select_item",
        params: {
            content_type: "Product",
            event_category: "Product",
            event_label: "Select Item View Product Detail Has SKU:".concat((product === null || product === void 0 ? void 0 : product.sku) || "")
        },
        products: [
            product
        ]
    });
};
var viewContentDetail = function(param) {
    var product = param.product;
    eventEcommerce({
        action: "view_item",
        params: {
            content_type: "Product",
            event_category: "Product",
            event_label: "View Product Detail Has SKU:".concat((product === null || product === void 0 ? void 0 : product.sku) || "")
        },
        products: [
            product
        ]
    });
};
var refund = function(param) {
    var orderId = param.orderId, products = param.products, totalPrice = param.totalPrice, _redeemCode = param.redeemCode, redeemCode = _redeemCode === void 0 ? [] : _redeemCode;
    return eventEcommerce({
        action: "refund",
        params: {
            currency: "THB",
            transaction_id: orderId,
            coupon: redeemCode.length > 0 && redeemCode[0] || null,
            id: orderId,
            value: totalPrice,
            event_category: "Order",
            event_label: "Cancel Order"
        },
        products: products
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = ({
    refund: refund,
    pageview: pageview,
    event: event,
    addToCart: addToCart,
    viewContent: viewContent,
    eventEcommerce: eventEcommerce,
    removeFromCart: removeFromCart,
    beginCheckout: beginCheckout,
    timeTracking: timeTracking,
    purchase: purchase,
    addToWishList: addToWishList,
    clickRewardDetail: clickRewardDetail,
    clickUsePromoCode: clickUsePromoCode,
    viewBlog: viewBlog,
    viewCareer: viewCareer,
    viewSeller: viewSeller,
    popup: popup,
    callHotline: callHotline,
    sendEmail: sendEmail,
    fanpage: fanpage,
    downloadAndroid: downloadAndroid,
    clickViewAllPromotion: clickViewAllPromotion,
    downloadIos: downloadIos,
    referral: referral,
    chat: chat,
    sendFeedback: sendFeedback,
    requestInvoice: requestInvoice,
    viewPromotion: viewPromotion,
    exchangePoint: exchangePoint,
    reOrderShowPopup: reOrderShowPopup,
    reOrderClickCancel: reOrderClickCancel,
    reOrderClickOk: reOrderClickOk,
    selectPromotion: selectPromotion,
    register: register,
    registedCompleted: registedCompleted,
    displayTopSearch: displayTopSearch,
    clickTopSearch: clickTopSearch,
    displayCountDownBar: displayCountDownBar,
    showModalDiscovery: showModalDiscovery,
    clickMenubar: clickMenubar,
    clickCountdownbar: clickCountdownbar,
    clickBanner: clickBanner,
    clickTabInProduct: clickTabInProduct,
    clickViewShop: clickViewShop,
    clickCategoryDrugsTitle: clickCategoryDrugsTitle,
    clickCategoryManufacturerTitle: clickCategoryManufacturerTitle,
    clickTrackingOrder: clickTrackingOrder,
    TIME_TO_TRACK: TIME_TO_TRACK,
    addToCartInPage: addToCartInPage,
    clickTagInProduct: clickTagInProduct,
    clickViewAllProductSameManufacturer: clickViewAllProductSameManufacturer,
    clickViewAllProductSameIngredient: clickViewAllProductSameIngredient,
    viewItemInPage: viewItemInPage,
    clickViewAllSellers: clickViewAllSellers,
    clickSellerNameID: clickSellerNameID,
    clickFlagshipStoreNameID: clickFlagshipStoreNameID,
    scrollDepth: scrollDepth,
    mapPathToCategory: mapPathToCategory,
    clickActivePromotionButton: clickActivePromotionButton,
    clickNextPromotionButton: clickNextPromotionButton,
    clickUseDirectlyPromoCode: clickUseDirectlyPromoCode,
    clickSearch: clickSearch,
    searchInQuickOrder: searchInQuickOrder,
    toggleMobileV2: toggleMobileV2,
    showBanner: showBanner,
    voteV2: voteV2,
    surveyV2: surveyV2,
    selectItem: selectItem,
    viewContentDetail: viewContentDetail,
    clickBtnSignInAction: clickBtnSignInAction,
    clickBtnSignUpAction: clickBtnSignUpAction
});


/***/ }),

/***/ 76480:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "bS": function() { return /* reexport */ CookieParser/* default */.Z; },
  "IM": function() { return /* reexport */ DateTimeUtils/* default */.ZP; },
  "iC": function() { return /* reexport */ FormDataUtils; },
  "r2": function() { return /* reexport */ FormatDate/* default */.ZP; },
  "AV": function() { return /* reexport */ FormatNumber/* default */.ZP; },
  "oy": function() { return /* reexport */ ImageFallback/* default */.ZP; },
  "QP": function() { return /* reexport */ NotifyUtils/* default */.Z; },
  "QV": function() { return /* reexport */ ResponseUtils/* default */.ZP; },
  "pU": function() { return /* reexport */ ScrollToTop; },
  "xZ": function() { return /* reexport */ StringUtils/* default */.ZP; },
  "nH": function() { return /* reexport */ Tracking; },
  "IN": function() { return /* reexport */ ValidateUtils/* default */.ZP; },
  "VZ": function() { return /* reexport */ calculateTimeLeft/* default */.ZP; },
  "Ds": function() { return /* reexport */ debounce/* default */.ZP; },
  "Fk": function() { return /* reexport */ getLinkTagDeal/* default */.Z; },
  "SX": function() { return /* reexport */ gtag/* default */.ZP; },
  "tQ": function() { return /* reexport */ myLoader/* default */.ZP; },
  "d7": function() { return /* reexport */ regUtils; },
  "MW": function() { return /* reexport */ routeHandler/* default */.Z; },
  "fc": function() { return /* reexport */ utils_screenOrientation; }
});

// EXTERNAL MODULE: ./src/utils/CookieParser.js
var CookieParser = __webpack_require__(44777);
// EXTERNAL MODULE: ./src/utils/DateTimeUtils.js
var DateTimeUtils = __webpack_require__(33213);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
;// CONCATENATED MODULE: ./src/utils/FormDataUtils.js

var convert = function(event) {
    var data = new FormData(event.target);
    var result = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // eslint-disable-next-line no-restricted-syntax
        for(var _iterator = data.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _value = (0,_sliced_to_array/* default */.Z)(_step.value, 2), key = _value[0], value = _value[1];
            result[key] = value;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return result;
};
/* harmony default export */ var FormDataUtils = ({
    convert: convert
});

// EXTERNAL MODULE: ./src/utils/FormatDate.js
var FormatDate = __webpack_require__(45901);
// EXTERNAL MODULE: ./src/utils/FormatNumber.js
var FormatNumber = __webpack_require__(44097);
// EXTERNAL MODULE: ./src/utils/ImageFallback.js
var ImageFallback = __webpack_require__(34588);
// EXTERNAL MODULE: ./src/utils/NotifyUtils.js
var NotifyUtils = __webpack_require__(25872);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/index.es.js
var index_es = __webpack_require__(51436);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js
var react_fontawesome_index_es = __webpack_require__(67814);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/utils/backToTop.js




function ScrollToTop(param) {
    var pathname = param.pathname;
    var divRef = (0,react.useRef)(null);
    var page = pathname.replace(/[/]/g, "");
    // Show button when page is scorlled upto given distance
    var toggleVisibility = function() {
        var ref, ref1, ref2, ref3;
        if (window.pageYOffset > 300 && !((ref = divRef.current) === null || ref === void 0 ? void 0 : (ref1 = ref.classList) === null || ref1 === void 0 ? void 0 : ref1.contains("visible"))) {
            var ref4, ref5;
            (ref4 = divRef.current) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.classList) === null || ref5 === void 0 ? void 0 : ref5.add("visible");
        }
        if (window.pageYOffset <= 300 && ((ref2 = divRef.current) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.classList) === null || ref3 === void 0 ? void 0 : ref3.contains("visible"))) {
            var ref6, ref7;
            (ref6 = divRef.current) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.classList) === null || ref7 === void 0 ? void 0 : ref7.remove("visible");
        }
    };
    // Set the top cordinate to 0
    // make scrolling smooth
    var scrollToTop = function() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };
    (0,react.useEffect)(function() {
        window.addEventListener("scroll", toggleVisibility);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: divRef,
        className: "back-to-top ".concat(page),
        onClick: scrollToTop,
        role: "presentation",
        style: {
            backgroundColor: "#005C29"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            style: {
                paddingTop: "6px",
                color: "#fff"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_fontawesome_index_es.FontAwesomeIcon, {
                icon: index_es.faChevronUp,
                style: {
                    width: "16px",
                    height: "16px"
                }
            })
        })
    });
};

// EXTERNAL MODULE: ./src/utils/calculateTimeLeft.js
var calculateTimeLeft = __webpack_require__(66661);
// EXTERNAL MODULE: ./src/utils/debounce.js
var debounce = __webpack_require__(74118);
// EXTERNAL MODULE: ./src/utils/getLinkTagDeal.js
var getLinkTagDeal = __webpack_require__(23482);
// EXTERNAL MODULE: ./src/utils/gtag.js
var gtag = __webpack_require__(57059);
// EXTERNAL MODULE: ./src/utils/myLoader.js
var myLoader = __webpack_require__(55156);
;// CONCATENATED MODULE: ./src/utils/regUtils.js
var PHONE_REGEX = /^(09|07|08|05|03|02[0|1|2|3|4|5|6|7|8|9])+([0-9]{8})\b/;
var EMAIL_REGEX = /^$|^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
var PHONE_REGEX_CAM = /^([0-9]{9,10})\b/;
var PHONE_REGEX_VN = /^(09|07|08|05|03|02[0|1|2|3|4|5|6|7|8|9])+([0-9]{8})\b/;
var PHONE_REGEX_TH = /^([0-9]{6,10})\b/;
var PHONE_REGEX_EN = /^([0-9]{5,10})\b/;
var MAP_PHONE_REGEX = {
    vn: PHONE_REGEX_VN,
    en: PHONE_REGEX_EN,
    cam: PHONE_REGEX_CAM,
    th: PHONE_REGEX_TH
};
/* harmony default export */ var regUtils = ({
    PHONE_REGEX: PHONE_REGEX,
    PHONE_REGEX_VN: PHONE_REGEX_VN,
    PHONE_REGEX_CAM: PHONE_REGEX_CAM,
    EMAIL_REGEX: EMAIL_REGEX,
    MAP_PHONE_REGEX: MAP_PHONE_REGEX
});

// EXTERNAL MODULE: ./src/utils/ResponseUtils.js
var ResponseUtils = __webpack_require__(73744);
// EXTERNAL MODULE: ./src/utils/routeHandler.js
var routeHandler = __webpack_require__(30368);
;// CONCATENATED MODULE: ./src/utils/screenOrientation.js
function screenOrientation(window) {
    if (typeof window !== "undefined" && window.orientation === 90 || window.orientation === -90) {
        return true;
    }
    return false;
}
/* harmony default export */ var utils_screenOrientation = (screenOrientation);

// EXTERNAL MODULE: ./src/utils/StringUtils.js
var StringUtils = __webpack_require__(52380);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./src/clients/index.js + 20 modules
var clients = __webpack_require__(15149);
;// CONCATENATED MODULE: ./src/utils/Tracking.js





function trackingFunc(eventAction, body) {
    return _trackingFunc.apply(this, arguments);
}
function _trackingFunc() {
    _trackingFunc = (0,_async_to_generator/* default */.Z)(function(eventAction, body) {
        var _tmp, _tmp1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            _tmp = {};
            _tmp1 = {};
            return [
                2,
                clients/* TrackingActionClient.tracking */.jn.tracking((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)(_tmp, body), (_tmp1.eventAction = eventAction, _tmp1)))
            ];
        });
    });
    return _trackingFunc.apply(this, arguments);
}
/* harmony default export */ var Tracking = ({
    trackingFunc: trackingFunc
});

// EXTERNAL MODULE: ./src/utils/ValidateUtils.js
var ValidateUtils = __webpack_require__(70220);
;// CONCATENATED MODULE: ./src/utils/index.js
/* eslint-disable import/no-cycle */ 


// export { default as deviceUtils } from './deviceUtils';
// export { default as fbpixel } from './fbpixel';




// export { default as RequestUtils } from './RequestUtils';















/***/ }),

/***/ 36753:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var constants_Paths__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(199);
/* harmony import */ var sysconfig__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66225);


/**
 * MAAC (Crescendo Lab) Web SDK — lớp DUY NHẤT biết về format event của MAAC.
 * Không component nào được tự push vào window.dataLayer.
 *
 * Cơ chế: plugin `clPluginDataLayer` monkey-patch window.dataLayer.push, validate mỗi entry
 * bằng zod rồi gọi clSdk.clRe.record(). Entry KHÔNG hợp lệ bị drop IM LẶNG (chỉ clDebug.warn,
 * không throw) — nên mọi field phải đúng type ngay từ đây.
 *
 * Format bắt buộc: { 0: 'event', 1: <event_name>, 2: <props> }
 * KHÔNG dùng { event, ecommerce } như snippet trong ticket BV-1372 — schema của plugin yêu cầu
 * object có key 0/1/2 (dạng `arguments` của gtag), nên format đó fail validate và bị drop.
 *
 * Chi tiết + schema đã verify: docs/maac-sdk-tracking-plan.md
 */ var MAAC_EVENT = {
    ADD_TO_CART: "add_to_cart",
    REMOVE_FROM_CART: "remove_from_cart",
    PURCHASE: "purchase"
};
var mapCurrencyISO = {
    th: "THB",
    vn: "VND",
    kh: "USD",
    cam: "USD",
    en: "USD"
};
var CURRENCY_ISO = mapCurrencyISO[sysconfig__WEBPACK_IMPORTED_MODULE_1__/* .ENV_COUNTRY */ .ng] || "THB";
// ─── Type coercion ───────────────────────────────────────────────────────────
/**
 * SDK CHỈ validate item_id + item_name; price/quantity/revenue đi qua .passthrough()
 * và KHÔNG được validate. Gửi string (vd '490') không hề báo lỗi nhưng hỏng data ở backend
 * — nên mọi field số bắt buộc đi qua hàm này.
 */ var toNumber = function(value) {
    var num = Number(value);
    return Number.isFinite(num) ? num : 0;
};
var toStr = function(value) {
    return value === null || value === undefined ? "" : String(value);
};
/**
 * Chuyển số điện thoại TH sang E.164 (+66...). MAAC skip im lặng field phone thiếu country code.
 */ var convertPhoneNumber = function(phone) {
    try {
        if (!phone) return "";
        var value = toStr(phone).trim();
        if (!value) return "";
        if (value.startsWith("+66")) return value;
        if (value.startsWith("66")) return "+".concat(value);
        if (value.startsWith("0")) return "+66".concat(value.substring(1));
        return "+66".concat(value);
    } catch (error) {
        console.error("MAAC convertPhoneNumber error:", error);
    }
    return "";
};
/**
 * Gán DOMAIN_WEB_HOST làm prefix cho URL relative. URL đã absolute thì giữ nguyên.
 */ var toAbsoluteUrl = function(path) {
    if (!path) return "";
    if (path.startsWith("http://") || path.startsWith("https://") || path.startsWith("//")) {
        return path;
    }
    return "".concat(sysconfig__WEBPACK_IMPORTED_MODULE_1__/* .DOMAIN_WEB_HOST */ .WL).concat(path.startsWith("/") ? "" : "/").concat(path);
};
// ─── dataLayer helpers ───────────────────────────────────────────────────────
var getDataLayer = function() {
    if (false) {}
    window.dataLayer = window.dataLayer || [];
    return window.dataLayer;
};
/**
 * Push ecommerce event theo native index format. items rỗng bị SDK drop nên chặn sớm ở đây.
 */ var pushEvent = function(eventName, props) {
    if (!sysconfig__WEBPACK_IMPORTED_MODULE_1__/* .MAAC_CHANNEL_ID */ .Uk) return;
    var dataLayer = getDataLayer();
    if (!dataLayer) return;
    try {
        var ref;
        if (!(props === null || props === void 0 ? void 0 : (ref = props.items) === null || ref === void 0 ? void 0 : ref.length)) return;
        dataLayer.push({
            0: "event",
            1: eventName,
            2: props
        });
    } catch (error) {
        console.error("MAAC pushEvent error:", error);
    }
};
// ─── Converters ──────────────────────────────────────────────────────────────
/**
 * Mapping product/cartItem → MAAC item.
 * item_id dùng `sku` — phải NHẤT QUÁN giữa add_to_cart và purchase, nếu không
 * Cart Retargeting không match được sản phẩm.
 *
 * KHÔNG reuse gtag.convertProduct: hàm đó gửi price dạng string (`${displayPrice}`),
 * đúng anti-pattern MAAC cảnh báo.
 */ var convertItem = function(product) {
    var ref, ref1, ref2;
    var ref3, ref4;
    var item = {
        item_id: toStr(product === null || product === void 0 ? void 0 : product.sku),
        item_name: (product === null || product === void 0 ? void 0 : product.name) || "",
        // displayPrice ưu tiên: với sản phẩm combo, price gốc là 1000 nên phải lấy giá theo cartItem
        price: toNumber((ref4 = (ref3 = product === null || product === void 0 ? void 0 : product.displayPrice) !== null && ref3 !== void 0 ? ref3 : product === null || product === void 0 ? void 0 : product.price) !== null && ref4 !== void 0 ? ref4 : product === null || product === void 0 ? void 0 : product.salePrice),
        quantity: toNumber(product === null || product === void 0 ? void 0 : product.quantity)
    };
    var itemBrand = (product === null || product === void 0 ? void 0 : (ref = product.sellerInfo) === null || ref === void 0 ? void 0 : ref.name) || "";
    if (itemBrand) item.item_brand = itemBrand;
    if (product === null || product === void 0 ? void 0 : product.slug) {
        var link = toAbsoluteUrl((0,constants_Paths__WEBPACK_IMPORTED_MODULE_0__/* .getPathProductBySlug */ .hq)(product.slug));
        if (link) item.link = link;
    }
    var imageLink = toAbsoluteUrl((product === null || product === void 0 ? void 0 : (ref1 = product.imagesProxy) === null || ref1 === void 0 ? void 0 : ref1[0]) || (product === null || product === void 0 ? void 0 : (ref2 = product.imageUrls) === null || ref2 === void 0 ? void 0 : ref2[0]) || "");
    if (imageLink) item.image_link = imageLink;
    return item;
};
var convertItems = function() {
    var products = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return (products || []).map(convertItem).filter(function(item) {
        return item.item_id && item.item_name;
    });
};
// ─── Public API ──────────────────────────────────────────────────────────────
/**
 * Cart event (add_to_cart / remove_from_cart).
 * Theo spec MAAC, event-level chỉ có `items` + `currency` — KHÔNG gửi `value`, vì SDK
 * transform `value` → `revenue`, sẽ làm bẩn số liệu revenue bằng event giỏ hàng.
 *
 * `product.quantity` mà caller truyền vào là DELTA (số lượng vừa thêm/bớt), không phải
 * tổng trong giỏ — đúng semantic "user adds an item to the cart" của MAAC.
 */ var trackCartEvent = function(eventName, product) {
    if (!(product === null || product === void 0 ? void 0 : product.sku)) return;
    var items = convertItems([
        product
    ]);
    pushEvent(eventName, {
        currency: CURRENCY_ISO,
        items: items
    });
};
var trackAddToCart = function(product) {
    return trackCartEvent(MAAC_EVENT.ADD_TO_CART, product);
};
var trackRemoveFromCart = function(product) {
    return trackCartEvent(MAAC_EVENT.REMOVE_FROM_CART, product);
};
/**
 * Purchase event. Bắn tại thời điểm TẠO ĐƠN (không phải trang thankyou) để không mất event
 * ở 2 nhánh redirect waiting-payment / cổng thanh toán ngoài.
 *
 * transaction_id PHẢI là orderId (mã đơn thật) — SDK dedup theo field này, nên F5 hay bắn lại
 * cùng orderId sẽ không bị tính 2 lần.
 *
 * @param {object}   options
 * @param {string}   options.orderId  - Mã đơn, dùng làm transaction_id
 * @param {number}   options.revenue  - Tổng tiền đơn
 * @param {number}   [options.shipping]
 * @param {number}   [options.tax]
 * @param {string}   [options.coupon]
 * @param {object[]} [options.products] - Danh sách sản phẩm của đơn
 */ var trackPurchase = function() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, orderId = ref.orderId, revenue = ref.revenue, shipping = ref.shipping, tax = ref.tax, coupon = ref.coupon, _products = ref.products, products = _products === void 0 ? [] : _products;
    if (!orderId) return;
    var props = {
        transaction_id: toStr(orderId),
        // SDK transform: value → revenue: Number(value). Gửi `value` là thoả field revenue bắt buộc.
        value: toNumber(revenue),
        currency: CURRENCY_ISO,
        items: convertItems(products)
    };
    if (shipping !== undefined && shipping !== null) props.shipping = toNumber(shipping);
    if (tax !== undefined && tax !== null) props.tax = toNumber(tax);
    if (coupon) props.coupon = toStr(coupon);
    pushEvent(MAAC_EVENT.PURCHASE, props);
};
// Chỉ push lại khi customerId đổi — tránh spam mỗi lần re-render/điều hướng.
var lastIdentifiedId = "";
/**
 * WebSDK Identify — gắn browsing footprint ẩn danh vào member để MAAC map sang LINE user.
 * Không có bước này thì workflow gửi LINE message sau khi đặt hàng KHÔNG chạy được.
 *
 * Lưu ý: clIdentity dùng format { event, params } — KHÁC hoàn toàn format {0,1,2} của
 * ecommerce event, vì clIdentity do core SDK xử lý, không đi qua clPluginDataLayer.
 *
 * Prerequisite phía MAAC: bật "Web footprint tracking" cho Web Channel. Nếu chưa bật,
 * MAAC bỏ qua toàn bộ identify và KHÔNG báo lỗi.
 */ var identify = function(user) {
    if (!sysconfig__WEBPACK_IMPORTED_MODULE_1__/* .MAAC_CHANNEL_ID */ .Uk) return;
    var customerId = toStr((user === null || user === void 0 ? void 0 : user.customerID) || (user === null || user === void 0 ? void 0 : user.code));
    // Không push cho khách ẩn danh: thiếu customerId thì MAAC không tạo/không update member.
    if (!customerId || customerId === lastIdentifiedId) return;
    var dataLayer = getDataLayer();
    if (!dataLayer) return;
    try {
        var params = {
            customerId: customerId
        };
        if (user === null || user === void 0 ? void 0 : user.email) params.email = user.email;
        if (user === null || user === void 0 ? void 0 : user.name) params.name = user.name;
        var phone = convertPhoneNumber((user === null || user === void 0 ? void 0 : user.phone) || (user === null || user === void 0 ? void 0 : user.phoneNumber));
        if (phone) params.phone = phone;
        dataLayer.push({
            event: "clIdentity",
            params: params
        });
        lastIdentifiedId = customerId;
    } catch (error) {
        // clIdentity là non-blocking, không được làm ảnh hưởng hoạt động của web.
        console.error("MAAC identify error:", error);
    }
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    trackAddToCart: trackAddToCart,
    trackRemoveFromCart: trackRemoveFromCart,
    trackPurchase: trackPurchase,
    identify: identify
});


/***/ }),

/***/ 55156:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EX": function() { return /* binding */ myLoaderCacheProxy; },
/* harmony export */   "UH": function() { return /* binding */ myLoaderCacheInstant; }
/* harmony export */ });
/* unused harmony export myLoaderCache */
/* harmony import */ var sysconfig__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66225);

var myLoader = function(param) {
    var src = param.src, width = param.width, quality = param.quality;
    return "".concat(src).concat(src.indexOf("?") >= 0 ? "&" : "?", "w=").concat(width, "&q=").concat(quality || 100);
};
var myLoaderCache = function(param) {
    var src = param.src, width = param.width, quality = param.quality;
    return "".concat(sysconfig__WEBPACK_IMPORTED_MODULE_0__/* .DOMAIN_IMAGE_CACHE_LOADER */ .Fc, "/_next/image?url=").concat(encodeURIComponent(src), "&width=").concat(width, "&quality=").concat(quality || 75);
};
var myLoaderCacheProxy = function(param) {
    var src = param.src, width = param.width, _quality = param.quality, quality = _quality === void 0 ? 100 : _quality;
    return (src === null || src === void 0 ? void 0 : src.startsWith(sysconfig__WEBPACK_IMPORTED_MODULE_0__/* .DOMAIN_IMAGE_CACHE_LOADER */ .Fc)) ? src : "".concat(sysconfig__WEBPACK_IMPORTED_MODULE_0__/* .DOMAIN_IMAGE_CACHE_LOADER */ .Fc).concat(src.replace("https://", "").replace("http://", "")).concat(src.indexOf("?") >= 0 ? "&" : "?").concat(width && (src === null || src === void 0 ? void 0 : src.indexOf(".svg")) === -1 ? "width=".concat(width) : "").concat(quality ? "&quality=".concat(quality) : "");
};
var myLoaderCacheInstant = myLoaderCache;
/* harmony default export */ __webpack_exports__["ZP"] = (myLoader);


/***/ }),

/***/ 15563:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RM": function() { return /* binding */ captureUtmLandingURL; },
/* harmony export */   "RQ": function() { return /* binding */ getRegisterURL; }
/* harmony export */ });
/* unused harmony exports UTM_LANDING_URL_STORAGE_KEY, getUtmQueryString */
// BV-1681 / BV-2304: keep the UTM landing URL ("last click") so sign-up can send it as `registerURL`
// even when the URL changes before the customer registers (e.g. `/?register=true`, terms page, in-site navigation).
var UTM_LANDING_URL_STORAGE_KEY = "bm_utm_landing_url";
var UTM_PARAMS = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_term",
    "utm_content"
];
var isBrowser = function() {
    return "object" !== "undefined";
};
// true when the query string has at least one non-empty utm_* param
var hasUtmParams = function(search) {
    var searchParams = new URLSearchParams(search || "");
    return UTM_PARAMS.some(function(key) {
        return !!searchParams.get(key);
    });
};
// `?utm_...` built from the non-empty utm_* params of a Next.js `ctx.query` (server-safe), '' when none.
// Used to keep UTM when the guest root page redirects to the guest home page.
var getUtmQueryString = function() {
    var query = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var searchParams = new URLSearchParams();
    UTM_PARAMS.forEach(function(key) {
        var value = Array.isArray(query[key]) ? query[key][0] : query[key];
        if (value) searchParams.set(key, value);
    });
    var queryString = searchParams.toString();
    return queryString ? "?".concat(queryString) : "";
};
// Store the current URL when it carries UTM params; always overwrite (last click wins).
var captureUtmLandingURL = function() {
    if (!isBrowser()) return;
    try {
        if (hasUtmParams(window.location.search)) {
            window.sessionStorage.setItem(UTM_LANDING_URL_STORAGE_KEY, window.location.href);
        }
    } catch (error) {
    // sessionStorage unavailable (private mode, blocked storage): ignore
    }
};
// URL to send as `registerURL`: current URL if it has UTM, else the stored UTM landing URL, else the current URL.
var getRegisterURL = function() {
    if (!isBrowser()) return "";
    var currentURL = window.location.href;
    try {
        if (hasUtmParams(window.location.search)) return currentURL;
        return window.sessionStorage.getItem(UTM_LANDING_URL_STORAGE_KEY) || currentURL;
    } catch (error) {
        return currentURL;
    }
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
    captureUtmLandingURL: captureUtmLandingURL,
    getRegisterURL: getRegisterURL,
    getUtmQueryString: getUtmQueryString
});


/***/ }),

/***/ 30368:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26042);
/* harmony import */ var constants_Paths__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(199);
/* eslint-disable array-callback-return */ 

// check === sellers?type=all
var isSellerPageTypeAll = function(router) {
    var ref, ref1;
    return constants_Paths__WEBPACK_IMPORTED_MODULE_0__/* .SELLERS */ .UI === router.pathname && ((router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.type) === "all" || (router === null || router === void 0 ? void 0 : (ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.type) === "flagship");
};
var isBottomNavigation = function(router) {
    if (isSellerPageTypeAll(router)) return false;
    if (constants_Paths__WEBPACK_IMPORTED_MODULE_0__/* .BOTTOM_NAVIGATION_PAGES.includes */ .xD.includes(router.pathname)) return true;
    return false;
};
var changeParameterUrl = function(router) {
    var query = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, method = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "push", options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
        shallow: true
    };
    router[method]({
        pathname: router.route,
        query: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, router.query, query),
        options: options
    });
};
// deprecated 22Feb2023 - Dinh Tran
// change parameter without re-render pages (replace)
// export const replaceParams = (query = {}) => {
//   const url = new URL(window.location);
//   if (url) {
//     Object.keys(query).map((q) => {
//       url.searchParams.set(q, query[q]);
//     });
//     window.history.replaceState(null, '', url.toString());
//   }
// };
// change parameter without re-render pages (push)
// export const pushParams = (query = {}) => {
//   const url = new URL(window.location);
//   if (url) {
//     Object.keys(query).map((q) => {
//       url.searchParams.set(q, query[q]);
//     });
//     window.history.pushState(null, '', url.toString());
//   }
// };
/* harmony default export */ __webpack_exports__["Z"] = ({
    isBottomNavigation: isBottomNavigation,
    changeParameterUrl: changeParameterUrl
});


/***/ }),

/***/ 38901:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports TIKTOK_PIXEL_ID, eventTiktok */
/* provided dependency */ var process = __webpack_require__(83454);
var TIKTOK_PIXEL_ID = process.env.NEXT_PUBLIC_TIKTOK_PIXEL_ID || null;
var convertProduct = function(item, cart) {
    var ref;
    return item ? {
        contents: [
            {
                content_name: item === null || item === void 0 ? void 0 : item.name,
                content_id: item === null || item === void 0 ? void 0 : item.sku,
                quantity: (item === null || item === void 0 ? void 0 : item.quantity) || 1,
                price: (item === null || item === void 0 ? void 0 : item.displayPrice) || (item === null || item === void 0 ? void 0 : item.price) || 0
            }, 
        ],
        content_type: "product",
        currency: (item === null || item === void 0 ? void 0 : item.currency) || "THB",
        value: (cart === null || cart === void 0 ? void 0 : cart.totalPrice) || null
    } : {
        contents: cart === null || cart === void 0 ? void 0 : (ref = cart.cartItems) === null || ref === void 0 ? void 0 : ref.map(function(p) {
            return {
                content_name: p === null || p === void 0 ? void 0 : p.name,
                content_id: p === null || p === void 0 ? void 0 : p.sku,
                quantity: (p === null || p === void 0 ? void 0 : p.quantity) || 1
            };
        }),
        content_type: "product",
        value: cart.totalPrice || 0,
        currency: (item === null || item === void 0 ? void 0 : item.currency) || "THB"
    };
};
var eventTiktok = function(name) {
    var data = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    try {
        if (window && window.ttq) window.ttq.track(name, data);
    } catch (error) {
        console.error("Tiktok event error", error);
    }
};
var viewProduct = function(product) {
    try {
        eventTiktok("ViewContent", convertProduct(product));
    } catch (error) {
        console.error("Tiktok viewProduct error", error);
    }
};
var addToCart = function(product, cart) {
    try {
        eventTiktok("AddToCart", convertProduct(product, cart));
    } catch (error) {
        console.error("Tiktok addToCart error", error);
    }
};
var addToWishlist = function(product, cart) {
    try {
        eventTiktok("AddToWishlist", convertProduct(product, cart));
    } catch (error) {
        console.error("Tiktok addToWishlist error", error);
    }
};
// const purchase = ({ content_ids, currency = 'BATH', num_items = 0, value = 0 }) => event('Purchase', { content_ids, currency, num_items, value });
var purchase = function(param) {
    var totalPrice = param.totalPrice, totalQuantity = param.totalQuantity, _currency = param.currency, currency = _currency === void 0 ? "" : _currency, orderId = param.orderId, orderID = param.orderID;
    try {
        eventTiktok("PlaceAnOrder", {
            content_type: "product",
            value: totalPrice,
            quantity: totalQuantity,
            currency: currency || "THB",
            content_id: orderID || orderId || ""
        });
    } catch (error) {
        console.error("Tiktok purchase error", error);
    }
};
var completePayment = function(param) {
    var totalPrice = param.totalPrice, totalQuantity = param.totalQuantity, _currency = param.currency, currency = _currency === void 0 ? "" : _currency, orderId = param.orderId, orderID = param.orderID;
    try {
        eventTiktok("CompletePayment", {
            content_type: "product",
            value: totalPrice,
            quantity: totalQuantity,
            currency: currency || "THB",
            content_id: orderID || orderId || ""
        });
    } catch (error) {
        console.error("Tiktok purchase error", error);
    }
};
var initiateCheckout = function(cart) {
    try {
        eventTiktok("InitiateCheckout", {
            content_id: cart.cartId || cart.cartID || "",
            value: cart.totalPrice,
            currency: "THB",
            quantity: cart.totalQuantity
        });
    } catch (error) {
        console.error("Tiktok initiateCheckout error", error);
    }
};
// These events are still missing.
// 1. SubmitApplication
// 2. CompleteRegister
// 3. Purchase
var completeRegistration = function() {
    try {
        eventTiktok("CompleteRegistration", {
            content_id: "register"
        });
    } catch (error) {
        console.error("Tiktok CompleteRegistration error", error);
    }
};
var submitApplication = function() {
    try {
        eventTiktok("SubmitApplication", {
            content_id: "register"
        });
    } catch (error) {
        console.error("Tiktok SubmitApplication error", error);
    }
};
// SubmitForm
var submitForm = function() {
    try {
        eventTiktok("SubmitForm", {
            content_id: "register"
        });
    } catch (error) {
        console.error("Tiktok SubmitForm error", error);
    }
};
/* harmony default export */ __webpack_exports__["ZP"] = ({
    TIKTOK_PIXEL_ID: TIKTOK_PIXEL_ID,
    viewProduct: viewProduct,
    addToCart: addToCart,
    addToWishlist: addToWishlist,
    initiateCheckout: initiateCheckout,
    purchase: purchase,
    completePayment: completePayment,
    completeRegistration: completeRegistration,
    submitApplication: submitApplication,
    submitForm: submitForm
});


/***/ }),

/***/ 39423:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ storeGlobal; },
  "o": function() { return /* binding */ useStore; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./src/constants/Enums/index.js
var Enums = __webpack_require__(71569);
// EXTERNAL MODULE: ./src/constants/Paths/index.js
var Paths = __webpack_require__(199);
// EXTERNAL MODULE: ./src/constants/ToggleFeature/index.js
var ToggleFeature = __webpack_require__(71523);
// EXTERNAL MODULE: ./node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__(36808);
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/sysconfig/index.js
var sysconfig = __webpack_require__(66225);
// EXTERNAL MODULE: ./src/utils/FormatNumber.js
var FormatNumber = __webpack_require__(44097);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js + 1 modules
var esm = __webpack_require__(36902);
;// CONCATENATED MODULE: ./node_modules/zustand/esm/context.js



function createContext() {
  const ZustandContext = (0,react.createContext)(void 0);
  const Provider = ({
    createStore,
    children
  }) => {
    const storeRef = (0,react.useRef)();
    if (!storeRef.current) {
      storeRef.current = createStore();
    }
    return (0,react.createElement)(
      ZustandContext.Provider,
      { value: storeRef.current },
      children
    );
  };
  const useBoundStore = (selector, equalityFn) => {
    const store = (0,react.useContext)(ZustandContext);
    if (!store) {
      throw new Error(
        "Seems like you have not used zustand provider as an ancestor."
      );
    }
    return (0,esm/* useStore */.oR)(
      store,
      selector,
      equalityFn
    );
  };
  const useStoreApi = () => {
    const store = (0,react.useContext)(ZustandContext);
    if (!store) {
      throw new Error(
        "Seems like you have not used zustand provider as an ancestor."
      );
    }
    return (0,react.useMemo)(
      () => ({
        getState: store.getState,
        setState: store.setState,
        subscribe: store.subscribe,
        destroy: store.destroy
      }),
      [store]
    );
  };
  return {
    Provider,
    useStore: useBoundStore,
    useStoreApi
  };
}



;// CONCATENATED MODULE: ./src/zustand-lib/storeGlobal.js











var store;
var getDefaultInitialState = function() {
    return {
        lastUpdate: Date.now(),
        tabs: [],
        banners: [],
        policies: [],
        tags: [],
        provinces: [],
        hashtagTopSearch: [],
        sellers: [],
        user: {},
        // manufacturers: [],
        // topManufacturers: [],
        categories: [],
        countdownBars: [],
        insiderSetting: true,
        thumbnailMap: {},
        defaultThumbnail: {},
        logs: false,
        toggleFeatures: {},
        chatSetting: Enums/* ENUMS_CHAT_SETTING_VALUE.THUOCSI */.u7.THUOCSI,
        isShowLocalThuocssiVn: false,
        timeLogs: 0,
        timeInitStoreGlobalDefaultInitialState: +new Date(),
        regionsMB: [],
        isMienBac: null
    };
};
var zustandContext = createContext();
var Provider = zustandContext.Provider;
// An example of how to get types
/** @type {import('zustand/index').UseStore<typeof initialState>} */ var useStore = zustandContext.useStore;
var initializeStore = function() {
    var preloadedState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return (0,esm/* default */.ZP)(function(set, get) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, getDefaultInitialState(), preloadedState), {
            timeInitStoreGlobal: +new Date(),
            timeInitStoreGlobalCreate: +new Date(),
            // TODO: feature-debt
            // logic công nợ
            getDebt: function() {
                var ref, ref1;
                return (ref = get()) === null || ref === void 0 ? void 0 : (ref1 = ref.user) === null || ref1 === void 0 ? void 0 : ref1.debt;
            },
            getDebtActive: function() {
                var ref, ref1;
                var debt = (ref = get()) === null || ref === void 0 ? void 0 : (ref1 = ref.user) === null || ref1 === void 0 ? void 0 : ref1.debt; // lấy debt dễ hơn
                return debt && (debt === null || debt === void 0 ? void 0 : debt.contractStatus) === "ACTIVE" ? debt : null;
            },
            getAvailableDebtBalance: function(param) {
                var _isFormated = param.isFormated, isFormated = _isFormated === void 0 ? false : _isFormated, _isCurrency = param.isCurrency, isCurrency = _isCurrency === void 0 ? true : _isCurrency;
                var ref, ref1;
                var debt = (ref = get()) === null || ref === void 0 ? void 0 : (ref1 = ref.user) === null || ref1 === void 0 ? void 0 : ref1.debt;
                // check statuss contract active
                // APO-1700 - bỏ đ
                if (!debt || (debt === null || debt === void 0 ? void 0 : debt.contractStatus) !== "ACTIVE") return "0";
                var balance = (debt === null || debt === void 0 ? void 0 : debt.balance) || 0;
                if (!isCurrency) return (0,FormatNumber/* formatCurrency */.xG)(balance, ".", 0);
                if (isFormated) return (0,FormatNumber/* formatCurrency */.xG)(balance);
                return balance;
            },
            // end debt
            getCustomer: function() {
                var ref;
                return (ref = get()) === null || ref === void 0 ? void 0 : ref.user;
            },
            getAccount: function() {
                var ref, ref1;
                return (ref = get()) === null || ref === void 0 ? void 0 : (ref1 = ref.user) === null || ref1 === void 0 ? void 0 : ref1.account;
            },
            getSession: function() {
                var ref, ref1;
                return (ref = get()) === null || ref === void 0 ? void 0 : (ref1 = ref.user) === null || ref1 === void 0 ? void 0 : ref1.account;
            },
            // hostname
            getHostName: function() {
                var ref;
                return window && (window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.hostname) || "";
            },
            // internet isShowLocalThuocssiVn
            getIsShowLocalThuocssiVn: function() {
                // time excute with do server side
                var ref = get(), timeLogs = ref.timeLogs, timeInitStoreGlobal = ref.timeInitStoreGlobal;
                // time client - time in server
                var timeLatency = timeInitStoreGlobal - timeLogs;
                return timeLatency > 1000;
            },
            setIsShowLocalThuocssiVn: function(value) {
                return set({
                    isShowLocalThuocssiVn: value
                });
            },
            // cập nhật lại app config khi refetch ở client (vd: kiểm tra cờ bảo trì lúc checkout)
            setAppConfig: function() {
                var appConfig = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
                return set({
                    appConfig: appConfig
                });
            },
            // end
            // Lưu ý: hàm này match theo `code`, không phải slug (tên hàm là di sản). Tag mới nên
            // dùng utils/TagUtils (getTagRegistry + resolveVisibleTags) thay vì gọi trực tiếp.
            getStyleBySlugOfTag: function(code) {
                var ref, ref1, ref2;
                return (ref2 = (ref = get()) === null || ref === void 0 ? void 0 : (ref1 = ref.tags) === null || ref1 === void 0 ? void 0 : ref1.filter(function(item) {
                    return item.visible;
                })) === null || ref2 === void 0 ? void 0 : ref2.find(function(item) {
                    return item.code === code;
                });
            },
            // Cố ý KHÔNG lọc `visible`: `visible` nghĩa là "hiện chip này trên sản phẩm", không phải
            // "trang tag này tồn tại". Hai consumer là breadcrumb của /tag/[slug]
            // (components-v3/organisms/ProductList, components/organisms/ProductListing); thêm filter
            // vào đây sẽ làm trống tiêu đề của mọi tag không bật "show on product".
            getTagBySlug: function(slug) {
                var ref, ref1;
                return (ref = get()) === null || ref === void 0 ? void 0 : (ref1 = ref.tags) === null || ref1 === void 0 ? void 0 : ref1.find(function(item) {
                    return item.slug === slug;
                });
            },
            getRegionByProvinceCode: function(provinceCode) {
                var ref, ref1, ref2;
                return ((ref2 = (ref = get()) === null || ref === void 0 ? void 0 : (ref1 = ref.provinces) === null || ref1 === void 0 ? void 0 : ref1.find(function(item) {
                    return item.value === provinceCode;
                })) === null || ref2 === void 0 ? void 0 : ref2.regionCode) || null;
            },
            getSellerByCode: function(code) {
                var ref, ref1;
                return ((ref = get()) === null || ref === void 0 ? void 0 : (ref1 = ref.sellers) === null || ref1 === void 0 ? void 0 : ref1.find(function(seller) {
                    return seller.code === code;
                })) || {};
            },
            getThumbnail: function() {
                var pathname = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Paths/* DEFAULT_THUMBNAIL_PATH */.cW;
                var ref;
                return ((ref = get()) === null || ref === void 0 ? void 0 : ref.thumbnailMap[pathname]) || {};
            },
            getDefaultThumbnail: function() {
                var ref;
                return ((ref = get()) === null || ref === void 0 ? void 0 : ref.defaultThumbnail) || {};
            },
            toggleFeature: function(featureName) {
                var value = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, ref = arguments.length > 2 ? arguments[2] : void 0, _isCookie = ref.isCookie, isCookie = _isCookie === void 0 ? false : _isCookie;
                // console.log('🚀 ~ file: storeGlobal.js ~ line 51 ~ create ~ featureName', featureName, value, isCookie);
                if (isCookie) js_cookie_default().set(featureName, value, {
                    domain: sysconfig/* GENERAL_DOMAIN */.oC,
                    sameSite: "Lax"
                });
            },
            validateFeature: function() {
                var featureName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var ref;
                var ref1 = options || {}, _isCookie = ref1.isCookie, isCookie = _isCookie === void 0 ? false : _isCookie;
                // console.log(
                //   '🚀 ~ file: storeGlobal.js ~ line 58 ~ create ~ featureName',
                //   featureName,
                //   isCookie,
                //   typeof Cookies.get(featureName),
                //   Cookies.get(featureName) === 'true',
                // );
                if (isCookie) {
                    return js_cookie_default().get(featureName) === "true";
                }
                var toggleFeatures = ((ref = get()) === null || ref === void 0 ? void 0 : ref.toggleFeatures) || {};
                // on / off tính năng với user : bằng customerId / accountId /phone
                // get config .env
                // TOGGLE_FEATURE_CHAT_ENABLE = on / off
                // TOGGLE_FEATURE_CHAT_TYPE = proviceCode / accountID / customerID / phone
                // TOGGLE_FEATURE_CHAT_VALUES = ['00','123','0974860956']
                var enable = toggleFeatures["".concat(ToggleFeature/* TOGGLE_FEATURE_PREFIX */.P + featureName, "_ENABLE")] === "on";
                // if feature not enable in env => false
                if (enable) {
                    var values = toggleFeatures["".concat(ToggleFeature/* TOGGLE_FEATURE_PREFIX */.P).concat(featureName, "_VALUES")];
                    // values contains 00 -> all
                    if (values.indexOf("00") >= 0) {
                        return true;
                    }
                    var type = toggleFeatures["".concat(ToggleFeature/* TOGGLE_FEATURE_PREFIX */.P).concat(featureName, "_TYPE")];
                    var user = get().user;
                    switch(type){
                        case "provinceCode":
                            return values.indexOf("".concat(user === null || user === void 0 ? void 0 : user.provinceCode)) >= 0;
                        case "accountID":
                            return values.indexOf("".concat(user === null || user === void 0 ? void 0 : user.accountID)) >= 0;
                        case "customerID":
                            return values.indexOf("".concat(user === null || user === void 0 ? void 0 : user.customerID)) >= 0;
                        case "phone":
                            return values.indexOf("".concat(user === null || user === void 0 ? void 0 : user.phone)) >= 0;
                        // phone
                        case "ENV_COUNTRY":
                            return values.indexOf(sysconfig/* ENV_COUNTRY */.ng) >= 0;
                        default:
                            return true;
                    }
                }
                return false;
            }
        });
    });
};
function useCreateStore(serverInitialState) {
    // Server side code: For SSR & SSG, always use a new store.
    if (false) {}
    // End of server side code
    // Client side code:
    // Next.js always re-uses same store regardless of whether page is a SSR or SSG or CSR type.
    var isReusingStore = Boolean(store);
    store = store !== null && store !== void 0 ? store : initializeStore(serverInitialState);
    // When next.js re-renders _app while re-using an older store, then replace current state with
    // the new state (in the next render cycle).
    // (Why next render cycle? Because react cannot re-render while a render is already in progress.
    // i.e. we cannot do a setState() as that will initiate a re-render)
    //
    // eslint complaining "React Hooks must be called in the exact same order in every component render"
    // is ignorable as this code runs in same order in a given environment (i.e. client or server)
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0,react.useLayoutEffect)(function() {
        // serverInitialState is undefined for CSR pages. It is up to you if you want to reset
        // states on CSR page navigation or not. I have chosen not to, but if you choose to,
        // then add `serverInitialState = getDefaultInitialState()` here.
        if (serverInitialState && isReusingStore) {
            store.setState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, store.getState(), serverInitialState), {
                timeInitStoreGlobal: +new Date(),
                timeInitStoreGlobalInitialState: +new Date()
            }), true);
        }
    });
    return function() {
        return store;
    };
}
/* harmony default export */ var storeGlobal = ({
    useCreateStore: useCreateStore,
    Provider: Provider,
    initializeStore: initializeStore,
    useStoreGlobal: useStore
});


/***/ }),

/***/ 35810:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KEY_ACCESS */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36808);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(js_cookie__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_device_detect__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85518);
/* harmony import */ var sysconfig__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66225);
/* harmony import */ var utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76480);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36902);






var defaultState = {
    beta: false,
    mobileProductScrolling: true,
    isMobileV2Value: null
};
var KEY_ACCESS = "mv2Settings";
var dataSaved = js_cookie__WEBPACK_IMPORTED_MODULE_0___default().get(KEY_ACCESS) ? JSON.parse(js_cookie__WEBPACK_IMPORTED_MODULE_0___default().get(KEY_ACCESS)) : defaultState;
// middleware store data by cookies
var persistByCookies = function(config) {
    return function(set, get, api) {
        return config(function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var newValue = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, dataSaved, args[0]);
            js_cookie__WEBPACK_IMPORTED_MODULE_0___default().set(KEY_ACCESS, newValue, {
                domain: sysconfig__WEBPACK_IMPORTED_MODULE_2__/* .GENERAL_DOMAIN */ .oC,
                sameSite: "Lax"
            });
            set(function() {
                return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, get(), newValue);
            });
        }, get, api);
    };
};
var useMobileV2 = (0,zustand__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(persistByCookies(function(set, get) {
    return {
        beta: dataSaved === null || dataSaved === void 0 ? void 0 : dataSaved.beta,
        mobileProductScrolling: true,
        toggleBeta: function() {
            var ref, ref1, ref2;
            set({
                beta: !((ref = get()) === null || ref === void 0 ? void 0 : ref.beta),
                isMobileV2Value: !((ref1 = get()) === null || ref1 === void 0 ? void 0 : ref1.isMobileV2Value)
            });
            utils__WEBPACK_IMPORTED_MODULE_3__/* .gtag.toggleMobileV2 */ .SX.toggleMobileV2((ref2 = get()) === null || ref2 === void 0 ? void 0 : ref2.beta);
        },
        toggleMobileProductScrolling: function() {
            var ref;
            return set({
                mobileProductScrolling: !((ref = get()) === null || ref === void 0 ? void 0 : ref.mobileProductScrolling)
            });
        },
        isMobileV2: function() {
            var ref;
            if (typeof ((ref = get()) === null || ref === void 0 ? void 0 : ref.isMobileV2Value) === "boolean") {
                var ref1;
                return ((ref1 = get()) === null || ref1 === void 0 ? void 0 : ref1.isMobileV2Value) && !react_device_detect__WEBPACK_IMPORTED_MODULE_1__/* .isDesktop */ .nI;
            }
            var data = js_cookie__WEBPACK_IMPORTED_MODULE_0___default().get(KEY_ACCESS) ? JSON.parse(js_cookie__WEBPACK_IMPORTED_MODULE_0___default().get(KEY_ACCESS)) : defaultState;
            var isMobileV2 = !react_device_detect__WEBPACK_IMPORTED_MODULE_1__/* .isDesktop */ .nI && (data === null || data === void 0 ? void 0 : data.beta);
            set({
                isMobileV2Value: isMobileV2
            });
            return isMobileV2;
        },
        removeCookies: function() {
            var data = js_cookie__WEBPACK_IMPORTED_MODULE_0___default().remove(KEY_ACCESS, {
                domain: sysconfig__WEBPACK_IMPORTED_MODULE_2__/* .GENERAL_DOMAIN */ .oC
            });
            return data;
        },
        isTrackingMobileV2:  false || "stg" === "uat"
    };
}, {
    name: "mobileV2"
}));
/* harmony default export */ __webpack_exports__["Z"] = (useMobileV2);


/***/ }),

/***/ 25886:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29815);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36902);
/* eslint-disable no-param-reassign */ /* eslint-disable no-plusplus */ 



var INITIAL_STATE = {
    listConversation: [],
    listMessageChat: [],
    currentConversation: null,
    sessionID: "",
    messageTotal: 0,
    messageSeen: 0,
    conversationID: "",
    lastestMessageID: "",
    triggerScrollBottom: 0,
    triggerCurrentDay: 0,
    triggerRating: 0,
    timeAutoTransferStatusToCompleted: 0,
    chatStatus: "",
    triggerFocusInput: false,
    triggerBlurInput: false,
    masterAddressObj: null,
    isWebView: false,
    triggerFetchMoreListTag: 0
};
var useChat = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(function(set, get) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, INITIAL_STATE), {
        setConversation: function(payload) {
            var ref;
            var cur = (ref = get()) === null || ref === void 0 ? void 0 : ref.listConversation;
            var updateCur = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(cur).concat([
                payload
            ]);
            set((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, get()), {
                listConversation: updateCur
            }));
            set((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, get()), {
                listMessageChat: payload
            }));
        },
        setSessionID: function(payload) {
            set((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, get()), {
                sessionID: payload
            }));
        },
        setRAWListMessageChat: function(payload) {
            set((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, get()), {
                listMessageChat: payload
            }));
        },
        clearListMessageChat: function() {
            set({
                listMessageChat: ""
            });
        },
        clearState: function() {
            set(INITIAL_STATE);
        },
        setMessageTotal: function(payload) {
            set((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, get()), {
                messageTotal: payload
            }));
        },
        setMessageSeen: function(orderMessage) {
            set((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, get()), {
                messageSeen: orderMessage
            }));
        },
        setCurrentConversation: function(conversation) {
            set({
                currentConversation: conversation
            });
        },
        setConversationID: function(conversationID) {
            set((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, get()), {
                conversationID: conversationID
            }));
        },
        setLastestMessageID: function(lastestMessageID) {
            set((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, get()), {
                lastestMessageID: lastestMessageID
            }));
        },
        setTriggerScrollBottom: function() {
            var ref;
            set((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, get()), {
                triggerScrollBottom: ((ref = get()) === null || ref === void 0 ? void 0 : ref.triggerScrollBottom) + 1
            }));
        },
        setTriggerCurrentDay: function() {
            var ref;
            set((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, get()), {
                triggerCurrentDay: ((ref = get()) === null || ref === void 0 ? void 0 : ref.triggerCurrentDay) + 1
            }));
        },
        setTriggerRating: function() {
            var ref;
            set((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, get()), {
                triggerRating: ((ref = get()) === null || ref === void 0 ? void 0 : ref.triggerRating) + 1
            }));
        },
        setTimeAutoTransferStatusToCompleted: function(time) {
            set((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, get()), {
                timeAutoTransferStatusToCompleted: time
            }));
        },
        clearTriggerRating: function() {
            set({
                triggerRating: INITIAL_STATE.triggerRating
            });
        },
        setChatStatus: function(status) {
            set((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, get()), {
                chatStatus: status
            }));
        },
        setTriggerFocusInput: function() {
            set((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, get()), {
                triggerFocusInput: true
            }));
        },
        clearTriggerFocusInput: function() {
            set((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, get()), {
                triggerFocusInput: INITIAL_STATE.triggerFocusInput
            }));
        },
        setTriggerBlurInput: function() {
            set((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, get()), {
                triggerBlurInput: true
            }));
        },
        clearTriggerBlurInput: function() {
            set((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, get()), {
                triggerBlurInput: false
            }));
        },
        setMasterAddressObj: function(payload) {
            set((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, get()), {
                masterAddressObj: payload
            }));
        },
        setIsWebView: function(payload) {
            set((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, get()), {
                isWebView: payload
            }));
        },
        setTriggerFetchMoreListTag: function() {
            var ref;
            set((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, get()), {
                triggerFetchMoreListTag: ((ref = get()) === null || ref === void 0 ? void 0 : ref.triggerFetchMoreListTag) + 1
            }));
        },
        setViewPortOffset: function(value) {
            set((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, get()), {
                viewPortOffset: value
            }));
        },
        clearViewPortOffset: function() {
            set((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, get()), {
                viewPortOffset: INITIAL_STATE.viewPortOffset
            }));
        }
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (useChat);


/***/ }),

/***/ 51400:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36808);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(js_cookie__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var sysconfig__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66225);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36902);
/* harmony import */ var zustand_middleware__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38597);





var INITIAL_STATE = {
    fullName: null,
    phoneNumber: null,
    guestID: null,
    sessionID: null,
    userID: null
};
var useChatGuest = (0,zustand__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)((0,zustand_middleware__WEBPACK_IMPORTED_MODULE_3__/* .persist */ .tJ)(function(set, get) {
    return {
        guestInfo: INITIAL_STATE,
        setInfoGuest: function setInfoGuest(payload) {
            set(function(state) {
                return {
                    guestInfo: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, state.guestInfo, payload)
                };
            });
        },
        removeGuestInfo: function() {
            return set({
                guestInfo: {}
            });
        },
        getInfoGuest: function() {
            return get().guestInfo;
        },
        setGuestId: function(guestID) {
            js_cookie__WEBPACK_IMPORTED_MODULE_0___default().set("guestID", guestID, {
                domain: sysconfig__WEBPACK_IMPORTED_MODULE_1__/* .GENERAL_DOMAIN */ .oC,
                sameSite: "Lax"
            });
        },
        removeGuestId: function() {
            js_cookie__WEBPACK_IMPORTED_MODULE_0___default().remove("guestID");
        }
    };
}, {
    name: "guest_chat"
}));
/* harmony default export */ __webpack_exports__["Z"] = (useChatGuest);


/***/ }),

/***/ 14626:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ zustand_lib_useSellers; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./src/clients/index.js + 20 modules
var clients = __webpack_require__(15149);
// EXTERNAL MODULE: ./src/clients/MockClient.js
var MockClient = __webpack_require__(57601);
// EXTERNAL MODULE: ./src/constants/Enums/index.js
var Enums = __webpack_require__(71569);
// EXTERNAL MODULE: ./src/sysconfig/index.js
var sysconfig = __webpack_require__(66225);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
;// CONCATENATED MODULE: ./src/constants/data/sellers.js



var mapShortNames = {
    "Th\xe0nh Phố HCM": "TPHCM",
    "H\xe0 Nội": "HN",
    "TP H\xe0 Nội": "HN",
    "Miền Nam": "MN",
    "Trung Ương": "TW",
    "Việt Nam": "VN",
    "Hộ Kinh Doanh": "HKD",
    "Chi Nh\xe1nh": "CN",
    "Y Tế": "YT",
    "Một Th\xe0nh Vi\xean": "MTV",
    "Vật Tư Y Tế": "VTYT",
    "Nh\xe0 cung cấp": "NCC",
    "Trang Thiết Bị Y Tế": "TTBYT",
    "Trang TBYT": "TTBYT",
    "Thương Mại V\xe0 Dịch Vụ": "TMDV",
    "TM-DV": "TMDV",
    "Đầu Tư v\xe0 Ph\xe1t Triển": "ĐTPT",
    "Kinh Doanh tổng hợp": "KDTH",
    "Dụng Cụ Y Tế ": "DCYT",
    "Dược Phẩm": "DP",
    "C\xf4ng Nghệ": "CN",
    "Y Học Cổ Truyền": "YHCT",
    "Xuất Nhập Khẩu": "XNK",
    "Xuất khẩu": "XK",
    "Dược Mỹ Phẩm": "DMP",
    "Doanh Nghiệp Tư Nh\xe2n": "DNTN",
    "Sản xuất": "SX",
    "H\xf3a Mỹ Phẩm": "HMP",
    "Đại l\xfd": "ĐL",
    "Đại l\xfd ph\xe2n phối": "ĐLPP",
    "Hợp t\xe1c x\xe3 N\xf4ng nghiệp c\xf4ng nghệ cao": "HTXNNCNC",
    "Trung T\xe2m DV Y Tế Tổng Hợp": "TTDVYTTH",
    "Cửa h\xe0ng": "CH",
    "C\xf4ng ty Cổ phần": "CTCP",
    "C\xf4ng ty CP": "CTCP",
    "CTY Cổ Phần": "CTCP",
    "C\xf4ng Ty Cổ Phẩn Quốc Tế": "CTCPQT",
    "C\xf4ng ty CP quốc tế": "CTCPQT",
    "C\xf4ng Ty CP Dược": "CTCPD",
    "C\xf4ng Ty Cổ Phần Dược": "CTCPD",
    "C\xf4ng ty C\xf4̉ ph\xe2̀n Dược ph\xe2̉m": "CTCPDP",
    "C\xf4ng ty Cổ Phần Dược Vật Tư Y Tế": "CTCPDVTYT",
    "C\xf4ng Ty CP Dược Phẩm": "CTCPDP",
    "C\xf4ng Ty CP Dược Phẩm C\xf4ng Nghệ Cao": "CTCPDPCNC",
    "C\xf4ng Ty CP Dược Phẩm Quốc Tế": "CTCPDPQT",
    "C\xf4ng ty CP DP QT": "CTCPDPQT",
    "C\xf4ng Ty Cổ Phần Dược Liệu": "CTCPDL",
    "C\xf4ng Ty CP Dược Liệu V\xe0 Thiết Bị Y Tế": "CTCPDLTBYT",
    "C\xf4ng Ty CP Dược & TBYT": "CTCPDTBYT",
    "C\xf4ng Ty Cổ Phần Đ\xf4ng Dược": "CTCPĐD",
    "C\xf4ng Ty Cổ Phần Đ\xf4ng Nam Dược": "CTCPĐND",
    "C\xf4ng ty C\xf4̉ ph\xe2̀n H\xf3a-Dược ph\xe2̉m": "CTCPHDP",
    "C\xf4ng ty Cổ phần Đầu tư": "CTCPDĐT",
    "C\xf4ng Ty CPĐT": "CTCPDĐT",
    "C\xf4ng ty Cổ Phần Đầu Tư Dược Phẩm": "CTCPĐTDP",
    "C\xf4ng ty Cổ Phần Đầu Tư Kinh Doanh Dược Phẩm": "CTCPĐTKDDP",
    "C\xf4ng Ty Cổ Phần Đầu Tư V\xe0 Ph\xe1t Triển": "CTCPĐTPT",
    "C\xf4ng Ty CP Đầu Tư V\xe0 Ph\xe1t Triển": "CTCPĐTPT",
    "C\xf4ng ty CP ĐTPT & TM": "CTCPĐTPTTM",
    "C\xf4ng Ty CP Đầu Tư Thương Mại": "CTCPĐTTM",
    "C\xf4ng ty CP đ\xf4ng nam dược": "CTCPĐTDND",
    "C\xf4ng ty CP Kinh Doanh v\xe0 Ph\xe1t Triển": "CTCPKDPT",
    "C\xf4ng Ty Cổ Phần Ph\xe1t Triển & Đầu Tư Thương Mại": "CTCPPTĐTTM",
    "C\xf4ng ty Cổ Phần Giải Ph\xe1p Sức Khỏe v\xe0 Sắc Đẹp": "CTCPGPSKSĐ",
    "C\xf4ng ty CPXNK": "CTCPXNK",
    "C\xf4ng Ty C\xf4̉ Ph\xe2̀n XNK Y T\xeá": "CTCPXNKYT",
    "C\xf4ng ty CPTM XNK Dược liệu": "CTCPXNKDL",
    "C\xf4ng ty C\xf4̉ ph\xe2̀n XNK Dược ph\xe2̉m": "CTCPXNKDP",
    "C\xf4ng Ty Cổ Phần Sản Xuất Thương Mại Trang Thiết Bị Y Tế": "CTCPSXTMTTBYT",
    "C\xf4ng Ty Cổ Phần Sản Xuất V\xe0 Xuất Nhập Khẩu": "CTCPSXXNK",
    "C\xf4ng ty cổ phần sản xuất, thương mại v\xe0 dịch vụ": "CTCPSXTMDV",
    "C\xf4ng ty Cổ phần dịch vụ & đầu tư thương mại": "CTCPDVĐTTM",
    "C\xf4ng ty Cổ phần Li\xean doanh Dược phẩm": "CTCPLDDP",
    "C\xf4ng ty Cổ phần Li\xean doanh Dược phẩm Quốc tế": "CTCPLDDPQT",
    "C\xf4ng Ty Cổ Phần Tập Đo\xe0n": "CTCPTĐ",
    "C\xf4ng Ty CP Tập Đo\xe0n Dược Phẩm": "CTCPTĐDP",
    "C\xf4ng Ty CP Tập Đo\xe0n Dược Sức Khỏe v\xe0 Sắc Đẹp": "CTCPTĐDSKSĐ",
    "C\xf4ng Ty Cổ Phần Thiết Bị": "CTCPTB",
    "C\xf4ng Ty CP TBYT": "CTCPTBYT",
    "C\xf4ng ty cổ phần thực phẩm dinh dưỡng hữu cơ": "CTCPTPDDHC",
    "C\xf4ng Ty Cổ Phần Thương Mại": "CTCPTM",
    "C\xf4ng Ty Cổ Phần TM": "CTCPTM",
    "C\xf4ng ty CPTM": "CTCPTM",
    "C\xf4ng Ty Cổ Phần Thương Mại & Thiết Bị Y Tế": "CTCPTMTBYT",
    "C\xf4ng Ty Cổ Phần TM Thiết Bị Y Tế": "CTCPTMTBYT",
    "C\xf4ng Ty CP Thương Mại C\xf4ng Nghệ Dươc Phẩm": "CTCPTMCNDP",
    "C\xf4ng ty cổ phần thương mại dịch vụ được liệu": "CTCPTMDVDL",
    "C\xf4ng ty cổ phần Đầu tư, Thương mại v\xe0 Dịch vụ": "CTCPDTTMDV",
    "C\xf4ng Ty CP TM V\xe0 ĐT": "CTCPTMĐT",
    "C\xf4ng Ty Cổ Phần Thương Mại Dịch Vụ": "CTCPTMDV",
    "C\xf4ng Ty CP Thương Mại Dịch Vụ": "CTCPTMDV",
    "C\xf4ng ty C\xf4̉ ph\xe2̀n Thương mại Dịch vụ T\xf4̉ng hợp": "CTCPTMDVTH",
    "C\xf4ng Ty Cổ Phần Thương Mại Dịch Vụ Dược Phẩm": "CTCPTMDVDP",
    "C\xf4ng ty C\xf4̉ ph\xe2̀n Dược ph\xe2̉m và Dịch vụ y t\xeá": "CTCPTMDVYT",
    "C\xf4ng Ty CP TM DV H\xf3a Dược V\xe0 TBYT": "CTCPTMDVHDTBYT",
    "C\xf4ng Ty CP TM XNK Dược Phẩm": "CTCPTMXNKDP",
    "C\xf4ng Ty CP TM&SX Dược Phẩm": "CTCPTMSXDP",
    "C\xf4ng Ty Cổ Phần Thương Mại Dược Phẩm": "CTCPTMDP",
    "C\xf4ng Ty CP TM Dược Phẩm": "CTCPTMDP",
    "C\xf4ng Ty Cổ Phần Thương Mại Quốc Tế": "CTCPTMQT",
    "C\xf4ng Ty CP Thương Mại V\xe0 Y Tế": "CTCPTMYT",
    "C\xf4ng Ty Cổ Phần Thương Mại v\xe0 Dịch Vụ MTK": "CTCPTMDVMKT",
    "C\xf4ng Ty Cổ phần Thương Mại Xuất Nhập Khẩu": "CTCPTMXNK",
    "C\xf4ng Ty Cổ Phần TM - XNK": "CTCPTMXNK",
    "C\xd4NG TY CỔ PHẦN TM XUẤT NHẬP KHẨU": "CTCPTMXNK",
    "C\xf4ng Ty Cổ Phần Tinh Dầu V\xe0 Hương Liệu": "CTCPTDHL",
    "C\xf4ng Ty Cổ Phần Tổng Hợp": "CTCPTH",
    "C\xf4ng Ty Cổ Phần Trang Thiết Bị Y Tế": "CTCPTTBYT",
    "C\xf4ng Ty CP Trang Thiết Bị Y Tế": "CTCPTTBYT",
    "C\xf4ng Ty CP C\xf4ng Nghệ Y Tế": "CTCPCNYT",
    "C\xf4ng Ty CP Tổ Hợp Y Tế Cổ Truyền Biến Chủng": "CTCPTHYTCTBC",
    "C\xf4ng ty CP Tư vấn v\xe0 đầu tư dịch vụ y tế": "CTCPTVĐTDVYT",
    "C\xf4ng Ty Dược Mỹ Phẩm": "CTDMP",
    "C\xf4ng Ty TNHH": "CTTNHH",
    "Cty TNHH": "CTTNHH",
    "C\xf4ng Ty TNHH Cao Dược Liệu": "CTTNHHCDL",
    "C\xf4ng ty TNHH Chăm sóc sắc đẹp": "CTTNHHCSSK",
    "C\xf4ng Ty TNHH C\xf4ng Nghệ": "CTTNHHCN",
    "C\xf4ng Ty TNHH C\xf4ng Nghệ Dược Phẩm": "CTTNHHCNDP",
    "C\xf4ng Ty TNHH C\xf4ng nghệ Sinh học": "CTTNHHCNSH",
    "C\xf4ng Ty TNHH C\xf4ng Nghệ Vật Tư Y Tế": "CTTNHHVTYT",
    "C\xf4ng Ty TNHH Dịch Vụ Đầu Tư Ph\xe1t Triển Y Tế": "CTTNHHDVĐTPTYT",
    "C\xf4ng Ty TNHH Dịch Vụ Thương Mại Tổng Hợp": "CTTNHHDVTMTH",
    "C\xf4ng Ty TNHH Dịch Vu Tổng Hợp": "CTTNHHDVTH",
    "C\xf4ng Ty TNHH Dịch Vụ Xuất Nhập Khẩu To\xe0n Cầu": "CTTNHHDVXNKTC",
    "C\xf4ng Ty TNHH Dược": "CTTNHHD",
    "C\xf4ng Ty TNHH Dược Phẩm": "CTTNHHDP",
    "C\xf4ng Ty TNHH Dược Liệu": "CTTNHHDL",
    "C\xf4ng Ty TNHH Dược Liệu Quốc Tế": "CTTNHHDLQT",
    "C\xf4ng Ty TNHH Dược Mỹ Phẩm": "CTTNHHDMP",
    "C\xf4ng Ty TNHH Đầu Tư": "CTTNHHĐT",
    " C\xf4ng Ty TNHH ĐT": "CTTNHHĐT",
    "C\xf4ng Ty TNHH Đầu Tư - DV - TM": "CTTNHHĐTDVTM",
    "C\xf4ng Ty TNHH Đầu Tư - Sản Xuất - TM - Dịch Vụ": "CTTNHHĐTSXTMDV",
    "C\xf4ng Ty TNHH ĐT - SX - TM&DV": "CTTNHHĐTSXTMDV",
    "C\xf4ng Ty TNHH ĐT KD TM": "CTTNHHĐTKDTM",
    "C\xf4ng ty TNHH ĐT SX & XNK": "CTTNHHĐTSXXNK",
    "C\xf4ng Ty TNHH Đầu Tư & Thương Mại Dược Phẩm": "CTTNHHĐTTMDP",
    "C\xf4ng Ty TNHH Đầu Tư Ph\xe1t Triển": "CTTNHHĐTPT",
    "C\xf4ng Ty TNHH Đầu Tư Thương Mại": "CTTNHHĐTTM",
    "C\xf4ng Ty TNHH Đầu Tư TM Dịch Vụ": "CTTNHHĐTTMDV",
    "C\xf4ng Ty TNHH Đầu Tư TM DV": "CTTNHHĐTTMDV",
    "C\xf4ng Ty TNHH Đầu Tư TM&DV": "CTTNHHĐTTMDV",
    "C\xd4NG TY TNHH ĐẦU TƯ TRANG THIẾT BỊ Y TẾ": "CTTNHHĐTTTBYT",
    "C\xf4ng Ty TNHH Một Th\xe0nh Vi\xean": "CTTNHHMTV",
    "C\xf4ng Ty TNHH MT": "CTTNHHMTV",
    "C\xf4ng ty TNHH MTV": "CTTNHHMTV",
    "C\xf4ng Ty TNHH MTV Dược Phẩm": "CTTNHHMTVDP",
    "C\xf4ng ty TNHH MTV Dược mỹ phẩm": "CTTNHHMTVDMP",
    "C\xf4ng ty TNHH MTV Đầu tư": "CTTNHHMTVĐT",
    "C\xf4ng Ty TNHH MTV Đầu Tư v\xe0 Ph\xe1t Triển": "CTTNHHMTVĐTPT",
    "C\xf4ng ty TNHH MTV Thương mại dịch vụ": "CTTNHHMTVTMDV",
    "C\xf4ng Ty TNHH MTV TM - DV Vụ": "CTTNHHMTVTMDV",
    "C\xf4ng Ty TNHH MTV TM DV Quốc Tế": "C\xf4ng Ty TNHH MTV TM DV Quốc Tế",
    "C\xf4ng Ty TNHH MTV Thương Mai Dược Phẩm": "CTTNHHMTVTMDP",
    "C\xf4ng Ty TNHH MTV TM v\xe0 XNK": "CTTNHHMTVTMXNK",
    "C\xf4ng Ty TNHH MTV TM&XNK": "CTTNHHMTVTMXNK",
    "C\xf4ng Ty TNHH Một Th\xe0nh Vi\xean Dược Phẩm": "CTTNHHMTVDP",
    "C\xf4ng Ty TNHH Mỹ Phẩm": "CTTNHHMP",
    "C\xf4ng Ty TNHH Nghi\xean Cứu C\xf4ng Nghệ Vật Tư Y Tế": "CTTNHHNCCNVTYT",
    "C\xf4ng Ty TNHH Nu\xf4i Trồng, Sản Xuất V\xe0 Chế Biến Dược Liệu": "CTTNHHNTSXCBDL",
    "C\xf4ng Ty TNHH NT, SX v\xe0 CB Dược Liệu": "CTTNHHNTSXCBDL",
    "C\xf4ng Ty TNHH Ph\xe1t Triển Thương Mại V\xe0 Dịch Vụ": "CTTNHHPTTMDV",
    "C\xf4ng Ty TNHH Ph\xe1t Triển TM&DV": "CTTNHHPTTMDV",
    "C\xf4ng Ty TNHH Ph\xe1t Triển XNK": "CTTNHHSXTMDVXNK",
    "C\xd4NG TY TNHH SẢN XUẤT-THƯƠNG MẠI-XUẤT NHẬP KHẨU": "CTTNHHSXTMXNK",
    "C\xf4ng Ty TNHH SX-TM-XNK": "CTTNHHSXTMXNK",
    "C\xf4ng Ty TNHH Sản Xuất V\xe0 TM Dược Phẩm": "CTTNHHSXTMDP",
    "C\xf4ng ty TNHH Tập Đo\xe0n Dược Phẩm": "CTTNHHTĐDP",
    "C\xf4ng Ty TNHH Thảo Dược": "CTTNHHTD",
    "C\xf4ng Ty TNHH Thiết Bị Vật Tư Y Tế": "CTTNHHTBVTYT",
    "C\xf4ng ty TNHH Thiết bị Nha khoa": "CTTNHHTBNK",
    "C\xf4ng Ty TNHH Thiết Bị Y Tế": "CTTNHHTBYT",
    "C\xf4ng Ty TNHH Thương Mại": "CTTNHHTM",
    "C\xf4ng ty TNHH Thương Mại & Dịch Vụ": "CTTNHHTMDV",
    "C\xf4ng Ty TNHH Thương Mại v\xe0 Dịch Vụ": "CTTNHHTMDV",
    "C\xf4ng ty TNHH TM & DV": "CTTNHHTMDV",
    "C\xf4ng Ty TNHH TM Dịch Vụ": "CTTNHHTMDV",
    "C\xf4ng Ty TNHH TM DV Dược Phẩm": "CTTNHHTMDVDP",
    "C\xf4ng Ty TNHH TM DV Thực Phẩm": "CTTNHHTMDVTP",
    "C\xd4NG TY TNHH THƯƠNG MẠI DỊCH VỤ KỸ THUẬT": "CTTNHHTMKT",
    "C\xf4ng Ty TNHH Thương Mại Dược Phẩm": "CTTNHHTMDP",
    "C\xf4ng Ty TNHH TM DP": "CTTNHHTMDP",
    "C\xf4ng ty TNHH TM Dược phẩm": "CTTNHHTMDP",
    "C\xf4ng ty TNHH TM v\xe0 DP": "CTTNHHTMDP",
    "C\xf4ng Ty TNHH Thương Mại DP": "CTTNHHTMDP",
    "C\xf4ng ty TNHH thương mại quốc tế": "CTTNHHTMQT",
    "C\xf4ng Ty TNHH Thương Mại v\xe0 Dược": "CTTNHHTMD",
    "C\xf4ng ty TNHH Thương Mại v\xe0 Dược Phẩm": "CTTNHHTMDP",
    "C\xf4ng ty TNHH TM & DP": "CTTNHHTMDP",
    "C\xf4ng ty TNHH TM & XNK": "CTTNHHTMXNK",
    "C\xf4ng Ty TNHH Tư Vấn": "CTTNHHTV",
    "C\xf4ng Ty TNHH Văn Ph\xf2ng Phẩm V\xe0 Thương Mại Dịch Vụ": "CTTNHHVPPTMDV",
    "C\xf4ng Ty TNHH Viện Nghi\xean Cứu": "CTTNHHVNC",
    "C\xf4ng Ty TNHH XNK TM Dịch Vụ": "CTTNHHXNKTMDV",
    "C\xf4ng Ty TNHH Y Dược": "CTTNHHYD"
};
var mapShortNamesLowercase = Object.keys(mapShortNames).reduce(function(x, y) {
    var a = y.toLowerCase();
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, x), (0,_define_property/* default */.Z)({}, a, mapShortNames[y]));
}, {});

// EXTERNAL MODULE: ./src/utils/StringUtils.js
var StringUtils = __webpack_require__(52380);
;// CONCATENATED MODULE: ./src/utils/SellerUtils.js


var convertShortNames = function(name) {
    if (!name) {
        return "";
    }
    var newName = name === null || name === void 0 ? void 0 : name.toLowerCase();
    Object.keys(mapShortNamesLowercase).forEach(function(keyname) {
        if (newName.indexOf(keyname) >= 0) {
            newName = newName.replace(keyname, mapShortNamesLowercase[keyname]);
        }
    });
    // eslint-disable-next-line import/no-named-as-default-member
    return StringUtils/* default.capitalizeFirstOfEachWords */.ZP.capitalizeFirstOfEachWords(newName);
};
var convertSeller = function(param) {
    var code = param.code, name = param.name, slug = param.slug, _sellerClass = param.sellerClass, sellerClass = _sellerClass === void 0 ? "" : _sellerClass, sellerType = param.sellerType, status = param.status, slugStore = param.slugStore, sellerStore = param.sellerStore, _avatar = param.avatar, avatar = _avatar === void 0 ? null : _avatar, _isVip = param.isVip, isVip = _isVip === void 0 ? null : _isVip, sellerID = param.sellerID;
    var ref = sellerStore || {}, landingPages = ref.landingPages, storeName = ref.name, tmp = ref.slug, storeSlug = tmp === void 0 ? "" : tmp, storeLogo = ref.logo, statusStore = ref.status;
    return {
        sellerID: sellerID,
        code: code,
        name: storeName && statusStore === "ACTIVE" ? convertShortNames(storeName) : convertShortNames(name),
        fullName: statusStore === "ACTIVE" ? storeName : name,
        slug: statusStore === "ACTIVE" && storeSlug ? storeSlug : slug,
        sellerType: sellerType,
        isInternal: sellerClass === "INTERNAL",
        status: status,
        statusStore: statusStore,
        slugStore: statusStore === "ACTIVE" ? slugStore : slug,
        landingPage: (landingPages === null || landingPages === void 0 ? void 0 : landingPages.length) > 0 && landingPages[0] || "",
        isVip: isVip,
        avatar: statusStore === "ACTIVE" && storeLogo ? storeLogo : avatar,
        storeSlug: storeSlug,
        isStore: status === "ACTIVE" && statusStore === "ACTIVE" && storeSlug
    };
};
/* harmony default export */ var SellerUtils = ({
    convertSeller: convertSeller,
    convertShortNames: convertShortNames
});

// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js + 1 modules
var esm = __webpack_require__(36902);
// EXTERNAL MODULE: ./node_modules/zustand/esm/middleware.js
var middleware = __webpack_require__(38597);
;// CONCATENATED MODULE: ./src/zustand-lib/useSellers.js
/* eslint-disable no-param-reassign */ /* eslint-disable react-hooks/rules-of-hooks */ 










// getNameSeller = (props) => {
//   const { seller = {}, tags = [] } = props;
//   const { code } = seller;
//   const isVAT = tags?.indexOf('HOADONNHANH') >= 0 || false;
//   // const { mapSeller = new Map(), mapStoreActives = new Map() } = useSetting();
//   const sellerInfo = mapSeller?.get(code) || null;
//   let sellerName = '';
//   let isDisplayStore = true;
//   let fullNameSeller = '';
//   const { isVip = false, slug = '' } = sellerInfo || {};
//   const linkSeller = sellerInfo?.landingPage?.startsWith('https://try.thuocsi.vn')
//     ? sellerInfo?.landingPage
//     : `/seller-products/${sellerInfo?.slugStore || sellerInfo?.slug}`;
//   let linkStore = `/seller/${slug}`;
//   if (isVip) {
//     linkStore = DOMAIN_FLAGSHIP_STORE.replace('{seller}', slug) || `/flagship-store/${slug}`;
//   }
//   if (sellerInfo?.isInternal) {
//     fullNameSeller = 'MEDX';
//     if (isVAT) {
//       sellerName = 'MEDX';
//     }
//   } else if (sellerInfo?.sellerType === 'ENTERPRISE') {
//     sellerName = sellerInfo?.name || '';
//     fullNameSeller = sellerInfo?.fullName || '';
//   } else {
//     sellerName = 'Đối tác của thuocsi';
//     isDisplayStore = false;
//     fullNameSeller = 'Đối tác của thuocsi';
//   }
//   return { sellerName, linkStore, linkSeller, isDisplayStore, fullNameSeller, ...sellerInfo };
// };
var timeCache = 10 * 60 * 1000;
var defaultState = {
    mapSellers: {}
};
var convertNameSeller = function(sellerInfo) {
    var tags = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    var ref;
    var isVAT = (tags === null || tags === void 0 ? void 0 : tags.indexOf("HOADONNHANH")) >= 0 || false;
    var sellerName = "";
    var isDisplayStore = true;
    var fullNameSeller = "";
    var curTime = +new Date();
    var ref1 = sellerInfo || {}, _isVip = ref1.isVip, isVip = _isVip === void 0 ? false : _isVip, name = ref1.name, status = ref1.status, _slug = ref1.slug, slug = _slug === void 0 ? "" : _slug, sellerType = ref1.sellerType, sellerID = ref1.sellerID, code = ref1.code, avatar = ref1.avatar, sellerClass = ref1.sellerClass;
    var linkSeller = (sellerInfo === null || sellerInfo === void 0 ? void 0 : (ref = sellerInfo.landingPage) === null || ref === void 0 ? void 0 : ref.startsWith("https://try.thuocsi.vn")) ? sellerInfo === null || sellerInfo === void 0 ? void 0 : sellerInfo.landingPage : "/seller-products/".concat((sellerInfo === null || sellerInfo === void 0 ? void 0 : sellerInfo.slugStore) || (sellerInfo === null || sellerInfo === void 0 ? void 0 : sellerInfo.slug));
    var linkStore = "/seller/".concat(slug);
    if (isVip) {
        linkStore = sysconfig/* DOMAIN_FLAGSHIP_STORE.replace */.cb.replace("{seller}", slug) || "/flagship-store/".concat(slug);
    }
    if (sellerInfo === null || sellerInfo === void 0 ? void 0 : sellerInfo.isInternal) {
        fullNameSeller = "MEDX";
        if (isVAT) {
            sellerName = "MEDX";
        }
    } else if ((sellerInfo === null || sellerInfo === void 0 ? void 0 : sellerInfo.sellerType) === "ENTERPRISE") {
        sellerName = (sellerInfo === null || sellerInfo === void 0 ? void 0 : sellerInfo.name) || "";
        fullNameSeller = (sellerInfo === null || sellerInfo === void 0 ? void 0 : sellerInfo.fullName) || "";
    } else {
        sellerName = "Partner of ".concat(Enums/* BRAND_NAME */.RS);
        isDisplayStore = false;
        fullNameSeller = "Partner of ".concat(Enums/* BRAND_NAME */.RS);
        linkSeller = "/partner/".concat(code);
    }
    return {
        isVip: isVip,
        name: name,
        linkSeller: linkSeller,
        linkStore: linkStore,
        sellerName: sellerName,
        isDisplayStore: isDisplayStore,
        fullNameSeller: fullNameSeller,
        status: status,
        slug: slug,
        sellerType: sellerType,
        sellerID: sellerID,
        code: code,
        avatar: avatar,
        sellerClass: sellerClass,
        ttl: curTime + timeCache,
        createdTime: curTime
    };
};
var convertSellerCache = function(sellerInfo) {
    var curTime = +new Date();
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, sellerInfo), {
        ttl: curTime + timeCache,
        createdTime: curTime
    });
};
var useSellers = (0,esm/* default */.ZP)((0,middleware/* persist */.tJ)(function(set, get) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultState), {
        getNameSeller: function(param) {
            var sellerInfo = param.sellerInfo, tags = param.tags;
            var ref;
            var code = (sellerInfo || {}).code;
            var mapSellers = ((ref = get()) === null || ref === void 0 ? void 0 : ref.mapSellers) || {};
            var seller = mapSellers[code];
            if (seller) {
                var ref1;
                if (seller.ttl < +new Date()) (ref1 = get()) === null || ref1 === void 0 ? void 0 : ref1.revalidateSellerByCode({
                    code: code
                });
                return convertNameSeller(seller, tags);
            }
            return convertNameSeller(sellerInfo, tags);
        },
        getSellerByCodeSync: function(param) {
            var code = param.code, _tags = param.tags, tags = _tags === void 0 ? [] : _tags;
            var ref, ref1;
            var mapSellers = ((ref = get()) === null || ref === void 0 ? void 0 : ref.mapSellers) || {};
            var sellerInfo = mapSellers[code];
            if (sellerInfo) {
                if (sellerInfo.ttl < +new Date()) {
                    var ref2;
                    (ref2 = get()) === null || ref2 === void 0 ? void 0 : ref2.revalidateSellerByCode({
                        code: code
                    });
                }
                return convertNameSeller(sellerInfo, tags);
            }
            (ref1 = get()) === null || ref1 === void 0 ? void 0 : ref1.revalidateSellerByCode({
                code: code
            });
            return null;
        },
        getSellerByCodes: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
                var codes;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    codes = param.codes;
                    return [
                        2,
                        codes === null || codes === void 0 ? void 0 : codes.map(function(code) {
                            var ref;
                            return (ref = get()) === null || ref === void 0 ? void 0 : ref.revalidateSellerByCode({
                                code: code
                            });
                        })
                    ];
                });
            });
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }(),
        getSellerByCode: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
                var code, tags, ref, ref1, mapSellers, _tmp, sellerInfo, ref2, _tmp1, _tmp2;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            code = param.code, tags = param.tags;
                            _tmp = {};
                            mapSellers = ((ref = get()) === null || ref === void 0 ? void 0 : ref.mapSellers) || _tmp;
                            sellerInfo = mapSellers[code];
                            _tmp1 = {};
                            if (sellerInfo) {
                                ;
                                if (sellerInfo.ttl < +new Date()) (ref2 = get()) === null || ref2 === void 0 ? void 0 : ref2.revalidateSellerByCode((_tmp1.code = code, _tmp1));
                                return [
                                    2,
                                    convertNameSeller(sellerInfo, tags)
                                ];
                            }
                            _tmp2 = {};
                            return [
                                4,
                                (ref1 = get()) === null || ref1 === void 0 ? void 0 : ref1.revalidateSellerByCode((_tmp2.code = code, _tmp2))
                            ];
                        case 1:
                            sellerInfo = _state.sent();
                            return [
                                2,
                                convertNameSeller(sellerInfo, tags)
                            ];
                    }
                });
            });
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }(),
        revalidateSellerByCode: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
                var _code, code, ref, mapSellers, _tmp, sellerResult, _tmp1, sellerInfo, _tmp2;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _code = param.code, code = _code === void 0 ? [] : _code;
                            _tmp = {};
                            mapSellers = ((ref = get()) === null || ref === void 0 ? void 0 : ref.mapSellers) || _tmp;
                            _tmp1 = {};
                            return [
                                4,
                                clients/* SellerClient.getSellerByCode */.vQ.getSellerByCode((_tmp1.sellerCode = code, _tmp1))
                            ];
                        case 1:
                            sellerResult = _state.sent();
                            // invalid seller result return null
                            if (!(0,clients/* isValid */.JY)(sellerResult)) {
                                return [
                                    2,
                                    null
                                ];
                            }
                            sellerInfo = SellerUtils.convertSeller((0,clients/* getFirst */.Xi)(sellerResult));
                            _tmp2 = {};
                            if (sellerInfo) {
                                mapSellers[code] = convertSellerCache(sellerInfo);
                                set((_tmp2.mapSellers = mapSellers, _tmp2));
                            }
                            return [
                                2,
                                sellerInfo || null
                            ];
                    }
                });
            });
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }(),
        initAllSellers: function() {
            MockClient/* default.getAllSellers */.Z.getAllSellers().then(function(listSellerResult) {
                var ref, ref1;
                var mapSellers = ((ref = get()) === null || ref === void 0 ? void 0 : ref.mapSellers) || {};
                (ref1 = (0,clients/* getData */.Yu)(listSellerResult)) === null || ref1 === void 0 ? void 0 : ref1.forEach(function(item) {
                    mapSellers[item.code] = convertSellerCache(item);
                });
                set({
                    mapSellers: mapSellers
                });
            });
        },
        reset: function() {
            useSellers.persist.clearStorage();
            set(defaultState);
        }
    });
}, {
    name: "sellerv2"
}));
// // then somewhere in your app
// const myStore = useSellers();
// useEffect(() => {
//   const intervalId = setInterval(() => {
//     myStore.reset();
//   }, 1000 * 60 * 5);
//   return () => {
//     clearInterval(intervalId);
//   };
// }, []);
/* harmony default export */ var zustand_lib_useSellers = (useSellers);


/***/ }),

/***/ 21876:
/***/ (function(module) {

var __dirname = "/";
(function(){var e={675:function(e,r){"use strict";r.byteLength=byteLength;r.toByteArray=toByteArray;r.fromByteArray=fromByteArray;var t=[];var f=[];var n=typeof Uint8Array!=="undefined"?Uint8Array:Array;var i="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";for(var o=0,u=i.length;o<u;++o){t[o]=i[o];f[i.charCodeAt(o)]=o}f["-".charCodeAt(0)]=62;f["_".charCodeAt(0)]=63;function getLens(e){var r=e.length;if(r%4>0){throw new Error("Invalid string. Length must be a multiple of 4")}var t=e.indexOf("=");if(t===-1)t=r;var f=t===r?0:4-t%4;return[t,f]}function byteLength(e){var r=getLens(e);var t=r[0];var f=r[1];return(t+f)*3/4-f}function _byteLength(e,r,t){return(r+t)*3/4-t}function toByteArray(e){var r;var t=getLens(e);var i=t[0];var o=t[1];var u=new n(_byteLength(e,i,o));var a=0;var s=o>0?i-4:i;var h;for(h=0;h<s;h+=4){r=f[e.charCodeAt(h)]<<18|f[e.charCodeAt(h+1)]<<12|f[e.charCodeAt(h+2)]<<6|f[e.charCodeAt(h+3)];u[a++]=r>>16&255;u[a++]=r>>8&255;u[a++]=r&255}if(o===2){r=f[e.charCodeAt(h)]<<2|f[e.charCodeAt(h+1)]>>4;u[a++]=r&255}if(o===1){r=f[e.charCodeAt(h)]<<10|f[e.charCodeAt(h+1)]<<4|f[e.charCodeAt(h+2)]>>2;u[a++]=r>>8&255;u[a++]=r&255}return u}function tripletToBase64(e){return t[e>>18&63]+t[e>>12&63]+t[e>>6&63]+t[e&63]}function encodeChunk(e,r,t){var f;var n=[];for(var i=r;i<t;i+=3){f=(e[i]<<16&16711680)+(e[i+1]<<8&65280)+(e[i+2]&255);n.push(tripletToBase64(f))}return n.join("")}function fromByteArray(e){var r;var f=e.length;var n=f%3;var i=[];var o=16383;for(var u=0,a=f-n;u<a;u+=o){i.push(encodeChunk(e,u,u+o>a?a:u+o))}if(n===1){r=e[f-1];i.push(t[r>>2]+t[r<<4&63]+"==")}else if(n===2){r=(e[f-2]<<8)+e[f-1];i.push(t[r>>10]+t[r>>4&63]+t[r<<2&63]+"=")}return i.join("")}},72:function(e,r,t){"use strict";
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */var f=t(675);var n=t(783);var i=typeof Symbol==="function"&&typeof Symbol.for==="function"?Symbol.for("nodejs.util.inspect.custom"):null;r.Buffer=Buffer;r.SlowBuffer=SlowBuffer;r.INSPECT_MAX_BYTES=50;var o=2147483647;r.kMaxLength=o;Buffer.TYPED_ARRAY_SUPPORT=typedArraySupport();if(!Buffer.TYPED_ARRAY_SUPPORT&&typeof console!=="undefined"&&typeof console.error==="function"){console.error("This browser lacks typed array (Uint8Array) support which is required by "+"`buffer` v5.x. Use `buffer` v4.x if you require old browser support.")}function typedArraySupport(){try{var e=new Uint8Array(1);var r={foo:function(){return 42}};Object.setPrototypeOf(r,Uint8Array.prototype);Object.setPrototypeOf(e,r);return e.foo()===42}catch(e){return false}}Object.defineProperty(Buffer.prototype,"parent",{enumerable:true,get:function(){if(!Buffer.isBuffer(this))return undefined;return this.buffer}});Object.defineProperty(Buffer.prototype,"offset",{enumerable:true,get:function(){if(!Buffer.isBuffer(this))return undefined;return this.byteOffset}});function createBuffer(e){if(e>o){throw new RangeError('The value "'+e+'" is invalid for option "size"')}var r=new Uint8Array(e);Object.setPrototypeOf(r,Buffer.prototype);return r}function Buffer(e,r,t){if(typeof e==="number"){if(typeof r==="string"){throw new TypeError('The "string" argument must be of type string. Received type number')}return allocUnsafe(e)}return from(e,r,t)}Buffer.poolSize=8192;function from(e,r,t){if(typeof e==="string"){return fromString(e,r)}if(ArrayBuffer.isView(e)){return fromArrayLike(e)}if(e==null){throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, "+"or Array-like Object. Received type "+typeof e)}if(isInstance(e,ArrayBuffer)||e&&isInstance(e.buffer,ArrayBuffer)){return fromArrayBuffer(e,r,t)}if(typeof SharedArrayBuffer!=="undefined"&&(isInstance(e,SharedArrayBuffer)||e&&isInstance(e.buffer,SharedArrayBuffer))){return fromArrayBuffer(e,r,t)}if(typeof e==="number"){throw new TypeError('The "value" argument must not be of type number. Received type number')}var f=e.valueOf&&e.valueOf();if(f!=null&&f!==e){return Buffer.from(f,r,t)}var n=fromObject(e);if(n)return n;if(typeof Symbol!=="undefined"&&Symbol.toPrimitive!=null&&typeof e[Symbol.toPrimitive]==="function"){return Buffer.from(e[Symbol.toPrimitive]("string"),r,t)}throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, "+"or Array-like Object. Received type "+typeof e)}Buffer.from=function(e,r,t){return from(e,r,t)};Object.setPrototypeOf(Buffer.prototype,Uint8Array.prototype);Object.setPrototypeOf(Buffer,Uint8Array);function assertSize(e){if(typeof e!=="number"){throw new TypeError('"size" argument must be of type number')}else if(e<0){throw new RangeError('The value "'+e+'" is invalid for option "size"')}}function alloc(e,r,t){assertSize(e);if(e<=0){return createBuffer(e)}if(r!==undefined){return typeof t==="string"?createBuffer(e).fill(r,t):createBuffer(e).fill(r)}return createBuffer(e)}Buffer.alloc=function(e,r,t){return alloc(e,r,t)};function allocUnsafe(e){assertSize(e);return createBuffer(e<0?0:checked(e)|0)}Buffer.allocUnsafe=function(e){return allocUnsafe(e)};Buffer.allocUnsafeSlow=function(e){return allocUnsafe(e)};function fromString(e,r){if(typeof r!=="string"||r===""){r="utf8"}if(!Buffer.isEncoding(r)){throw new TypeError("Unknown encoding: "+r)}var t=byteLength(e,r)|0;var f=createBuffer(t);var n=f.write(e,r);if(n!==t){f=f.slice(0,n)}return f}function fromArrayLike(e){var r=e.length<0?0:checked(e.length)|0;var t=createBuffer(r);for(var f=0;f<r;f+=1){t[f]=e[f]&255}return t}function fromArrayBuffer(e,r,t){if(r<0||e.byteLength<r){throw new RangeError('"offset" is outside of buffer bounds')}if(e.byteLength<r+(t||0)){throw new RangeError('"length" is outside of buffer bounds')}var f;if(r===undefined&&t===undefined){f=new Uint8Array(e)}else if(t===undefined){f=new Uint8Array(e,r)}else{f=new Uint8Array(e,r,t)}Object.setPrototypeOf(f,Buffer.prototype);return f}function fromObject(e){if(Buffer.isBuffer(e)){var r=checked(e.length)|0;var t=createBuffer(r);if(t.length===0){return t}e.copy(t,0,0,r);return t}if(e.length!==undefined){if(typeof e.length!=="number"||numberIsNaN(e.length)){return createBuffer(0)}return fromArrayLike(e)}if(e.type==="Buffer"&&Array.isArray(e.data)){return fromArrayLike(e.data)}}function checked(e){if(e>=o){throw new RangeError("Attempt to allocate Buffer larger than maximum "+"size: 0x"+o.toString(16)+" bytes")}return e|0}function SlowBuffer(e){if(+e!=e){e=0}return Buffer.alloc(+e)}Buffer.isBuffer=function isBuffer(e){return e!=null&&e._isBuffer===true&&e!==Buffer.prototype};Buffer.compare=function compare(e,r){if(isInstance(e,Uint8Array))e=Buffer.from(e,e.offset,e.byteLength);if(isInstance(r,Uint8Array))r=Buffer.from(r,r.offset,r.byteLength);if(!Buffer.isBuffer(e)||!Buffer.isBuffer(r)){throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array')}if(e===r)return 0;var t=e.length;var f=r.length;for(var n=0,i=Math.min(t,f);n<i;++n){if(e[n]!==r[n]){t=e[n];f=r[n];break}}if(t<f)return-1;if(f<t)return 1;return 0};Buffer.isEncoding=function isEncoding(e){switch(String(e).toLowerCase()){case"hex":case"utf8":case"utf-8":case"ascii":case"latin1":case"binary":case"base64":case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return true;default:return false}};Buffer.concat=function concat(e,r){if(!Array.isArray(e)){throw new TypeError('"list" argument must be an Array of Buffers')}if(e.length===0){return Buffer.alloc(0)}var t;if(r===undefined){r=0;for(t=0;t<e.length;++t){r+=e[t].length}}var f=Buffer.allocUnsafe(r);var n=0;for(t=0;t<e.length;++t){var i=e[t];if(isInstance(i,Uint8Array)){i=Buffer.from(i)}if(!Buffer.isBuffer(i)){throw new TypeError('"list" argument must be an Array of Buffers')}i.copy(f,n);n+=i.length}return f};function byteLength(e,r){if(Buffer.isBuffer(e)){return e.length}if(ArrayBuffer.isView(e)||isInstance(e,ArrayBuffer)){return e.byteLength}if(typeof e!=="string"){throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. '+"Received type "+typeof e)}var t=e.length;var f=arguments.length>2&&arguments[2]===true;if(!f&&t===0)return 0;var n=false;for(;;){switch(r){case"ascii":case"latin1":case"binary":return t;case"utf8":case"utf-8":return utf8ToBytes(e).length;case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return t*2;case"hex":return t>>>1;case"base64":return base64ToBytes(e).length;default:if(n){return f?-1:utf8ToBytes(e).length}r=(""+r).toLowerCase();n=true}}}Buffer.byteLength=byteLength;function slowToString(e,r,t){var f=false;if(r===undefined||r<0){r=0}if(r>this.length){return""}if(t===undefined||t>this.length){t=this.length}if(t<=0){return""}t>>>=0;r>>>=0;if(t<=r){return""}if(!e)e="utf8";while(true){switch(e){case"hex":return hexSlice(this,r,t);case"utf8":case"utf-8":return utf8Slice(this,r,t);case"ascii":return asciiSlice(this,r,t);case"latin1":case"binary":return latin1Slice(this,r,t);case"base64":return base64Slice(this,r,t);case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return utf16leSlice(this,r,t);default:if(f)throw new TypeError("Unknown encoding: "+e);e=(e+"").toLowerCase();f=true}}}Buffer.prototype._isBuffer=true;function swap(e,r,t){var f=e[r];e[r]=e[t];e[t]=f}Buffer.prototype.swap16=function swap16(){var e=this.length;if(e%2!==0){throw new RangeError("Buffer size must be a multiple of 16-bits")}for(var r=0;r<e;r+=2){swap(this,r,r+1)}return this};Buffer.prototype.swap32=function swap32(){var e=this.length;if(e%4!==0){throw new RangeError("Buffer size must be a multiple of 32-bits")}for(var r=0;r<e;r+=4){swap(this,r,r+3);swap(this,r+1,r+2)}return this};Buffer.prototype.swap64=function swap64(){var e=this.length;if(e%8!==0){throw new RangeError("Buffer size must be a multiple of 64-bits")}for(var r=0;r<e;r+=8){swap(this,r,r+7);swap(this,r+1,r+6);swap(this,r+2,r+5);swap(this,r+3,r+4)}return this};Buffer.prototype.toString=function toString(){var e=this.length;if(e===0)return"";if(arguments.length===0)return utf8Slice(this,0,e);return slowToString.apply(this,arguments)};Buffer.prototype.toLocaleString=Buffer.prototype.toString;Buffer.prototype.equals=function equals(e){if(!Buffer.isBuffer(e))throw new TypeError("Argument must be a Buffer");if(this===e)return true;return Buffer.compare(this,e)===0};Buffer.prototype.inspect=function inspect(){var e="";var t=r.INSPECT_MAX_BYTES;e=this.toString("hex",0,t).replace(/(.{2})/g,"$1 ").trim();if(this.length>t)e+=" ... ";return"<Buffer "+e+">"};if(i){Buffer.prototype[i]=Buffer.prototype.inspect}Buffer.prototype.compare=function compare(e,r,t,f,n){if(isInstance(e,Uint8Array)){e=Buffer.from(e,e.offset,e.byteLength)}if(!Buffer.isBuffer(e)){throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. '+"Received type "+typeof e)}if(r===undefined){r=0}if(t===undefined){t=e?e.length:0}if(f===undefined){f=0}if(n===undefined){n=this.length}if(r<0||t>e.length||f<0||n>this.length){throw new RangeError("out of range index")}if(f>=n&&r>=t){return 0}if(f>=n){return-1}if(r>=t){return 1}r>>>=0;t>>>=0;f>>>=0;n>>>=0;if(this===e)return 0;var i=n-f;var o=t-r;var u=Math.min(i,o);var a=this.slice(f,n);var s=e.slice(r,t);for(var h=0;h<u;++h){if(a[h]!==s[h]){i=a[h];o=s[h];break}}if(i<o)return-1;if(o<i)return 1;return 0};function bidirectionalIndexOf(e,r,t,f,n){if(e.length===0)return-1;if(typeof t==="string"){f=t;t=0}else if(t>2147483647){t=2147483647}else if(t<-2147483648){t=-2147483648}t=+t;if(numberIsNaN(t)){t=n?0:e.length-1}if(t<0)t=e.length+t;if(t>=e.length){if(n)return-1;else t=e.length-1}else if(t<0){if(n)t=0;else return-1}if(typeof r==="string"){r=Buffer.from(r,f)}if(Buffer.isBuffer(r)){if(r.length===0){return-1}return arrayIndexOf(e,r,t,f,n)}else if(typeof r==="number"){r=r&255;if(typeof Uint8Array.prototype.indexOf==="function"){if(n){return Uint8Array.prototype.indexOf.call(e,r,t)}else{return Uint8Array.prototype.lastIndexOf.call(e,r,t)}}return arrayIndexOf(e,[r],t,f,n)}throw new TypeError("val must be string, number or Buffer")}function arrayIndexOf(e,r,t,f,n){var i=1;var o=e.length;var u=r.length;if(f!==undefined){f=String(f).toLowerCase();if(f==="ucs2"||f==="ucs-2"||f==="utf16le"||f==="utf-16le"){if(e.length<2||r.length<2){return-1}i=2;o/=2;u/=2;t/=2}}function read(e,r){if(i===1){return e[r]}else{return e.readUInt16BE(r*i)}}var a;if(n){var s=-1;for(a=t;a<o;a++){if(read(e,a)===read(r,s===-1?0:a-s)){if(s===-1)s=a;if(a-s+1===u)return s*i}else{if(s!==-1)a-=a-s;s=-1}}}else{if(t+u>o)t=o-u;for(a=t;a>=0;a--){var h=true;for(var c=0;c<u;c++){if(read(e,a+c)!==read(r,c)){h=false;break}}if(h)return a}}return-1}Buffer.prototype.includes=function includes(e,r,t){return this.indexOf(e,r,t)!==-1};Buffer.prototype.indexOf=function indexOf(e,r,t){return bidirectionalIndexOf(this,e,r,t,true)};Buffer.prototype.lastIndexOf=function lastIndexOf(e,r,t){return bidirectionalIndexOf(this,e,r,t,false)};function hexWrite(e,r,t,f){t=Number(t)||0;var n=e.length-t;if(!f){f=n}else{f=Number(f);if(f>n){f=n}}var i=r.length;if(f>i/2){f=i/2}for(var o=0;o<f;++o){var u=parseInt(r.substr(o*2,2),16);if(numberIsNaN(u))return o;e[t+o]=u}return o}function utf8Write(e,r,t,f){return blitBuffer(utf8ToBytes(r,e.length-t),e,t,f)}function asciiWrite(e,r,t,f){return blitBuffer(asciiToBytes(r),e,t,f)}function latin1Write(e,r,t,f){return asciiWrite(e,r,t,f)}function base64Write(e,r,t,f){return blitBuffer(base64ToBytes(r),e,t,f)}function ucs2Write(e,r,t,f){return blitBuffer(utf16leToBytes(r,e.length-t),e,t,f)}Buffer.prototype.write=function write(e,r,t,f){if(r===undefined){f="utf8";t=this.length;r=0}else if(t===undefined&&typeof r==="string"){f=r;t=this.length;r=0}else if(isFinite(r)){r=r>>>0;if(isFinite(t)){t=t>>>0;if(f===undefined)f="utf8"}else{f=t;t=undefined}}else{throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported")}var n=this.length-r;if(t===undefined||t>n)t=n;if(e.length>0&&(t<0||r<0)||r>this.length){throw new RangeError("Attempt to write outside buffer bounds")}if(!f)f="utf8";var i=false;for(;;){switch(f){case"hex":return hexWrite(this,e,r,t);case"utf8":case"utf-8":return utf8Write(this,e,r,t);case"ascii":return asciiWrite(this,e,r,t);case"latin1":case"binary":return latin1Write(this,e,r,t);case"base64":return base64Write(this,e,r,t);case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return ucs2Write(this,e,r,t);default:if(i)throw new TypeError("Unknown encoding: "+f);f=(""+f).toLowerCase();i=true}}};Buffer.prototype.toJSON=function toJSON(){return{type:"Buffer",data:Array.prototype.slice.call(this._arr||this,0)}};function base64Slice(e,r,t){if(r===0&&t===e.length){return f.fromByteArray(e)}else{return f.fromByteArray(e.slice(r,t))}}function utf8Slice(e,r,t){t=Math.min(e.length,t);var f=[];var n=r;while(n<t){var i=e[n];var o=null;var u=i>239?4:i>223?3:i>191?2:1;if(n+u<=t){var a,s,h,c;switch(u){case 1:if(i<128){o=i}break;case 2:a=e[n+1];if((a&192)===128){c=(i&31)<<6|a&63;if(c>127){o=c}}break;case 3:a=e[n+1];s=e[n+2];if((a&192)===128&&(s&192)===128){c=(i&15)<<12|(a&63)<<6|s&63;if(c>2047&&(c<55296||c>57343)){o=c}}break;case 4:a=e[n+1];s=e[n+2];h=e[n+3];if((a&192)===128&&(s&192)===128&&(h&192)===128){c=(i&15)<<18|(a&63)<<12|(s&63)<<6|h&63;if(c>65535&&c<1114112){o=c}}}}if(o===null){o=65533;u=1}else if(o>65535){o-=65536;f.push(o>>>10&1023|55296);o=56320|o&1023}f.push(o);n+=u}return decodeCodePointsArray(f)}var u=4096;function decodeCodePointsArray(e){var r=e.length;if(r<=u){return String.fromCharCode.apply(String,e)}var t="";var f=0;while(f<r){t+=String.fromCharCode.apply(String,e.slice(f,f+=u))}return t}function asciiSlice(e,r,t){var f="";t=Math.min(e.length,t);for(var n=r;n<t;++n){f+=String.fromCharCode(e[n]&127)}return f}function latin1Slice(e,r,t){var f="";t=Math.min(e.length,t);for(var n=r;n<t;++n){f+=String.fromCharCode(e[n])}return f}function hexSlice(e,r,t){var f=e.length;if(!r||r<0)r=0;if(!t||t<0||t>f)t=f;var n="";for(var i=r;i<t;++i){n+=s[e[i]]}return n}function utf16leSlice(e,r,t){var f=e.slice(r,t);var n="";for(var i=0;i<f.length;i+=2){n+=String.fromCharCode(f[i]+f[i+1]*256)}return n}Buffer.prototype.slice=function slice(e,r){var t=this.length;e=~~e;r=r===undefined?t:~~r;if(e<0){e+=t;if(e<0)e=0}else if(e>t){e=t}if(r<0){r+=t;if(r<0)r=0}else if(r>t){r=t}if(r<e)r=e;var f=this.subarray(e,r);Object.setPrototypeOf(f,Buffer.prototype);return f};function checkOffset(e,r,t){if(e%1!==0||e<0)throw new RangeError("offset is not uint");if(e+r>t)throw new RangeError("Trying to access beyond buffer length")}Buffer.prototype.readUIntLE=function readUIntLE(e,r,t){e=e>>>0;r=r>>>0;if(!t)checkOffset(e,r,this.length);var f=this[e];var n=1;var i=0;while(++i<r&&(n*=256)){f+=this[e+i]*n}return f};Buffer.prototype.readUIntBE=function readUIntBE(e,r,t){e=e>>>0;r=r>>>0;if(!t){checkOffset(e,r,this.length)}var f=this[e+--r];var n=1;while(r>0&&(n*=256)){f+=this[e+--r]*n}return f};Buffer.prototype.readUInt8=function readUInt8(e,r){e=e>>>0;if(!r)checkOffset(e,1,this.length);return this[e]};Buffer.prototype.readUInt16LE=function readUInt16LE(e,r){e=e>>>0;if(!r)checkOffset(e,2,this.length);return this[e]|this[e+1]<<8};Buffer.prototype.readUInt16BE=function readUInt16BE(e,r){e=e>>>0;if(!r)checkOffset(e,2,this.length);return this[e]<<8|this[e+1]};Buffer.prototype.readUInt32LE=function readUInt32LE(e,r){e=e>>>0;if(!r)checkOffset(e,4,this.length);return(this[e]|this[e+1]<<8|this[e+2]<<16)+this[e+3]*16777216};Buffer.prototype.readUInt32BE=function readUInt32BE(e,r){e=e>>>0;if(!r)checkOffset(e,4,this.length);return this[e]*16777216+(this[e+1]<<16|this[e+2]<<8|this[e+3])};Buffer.prototype.readIntLE=function readIntLE(e,r,t){e=e>>>0;r=r>>>0;if(!t)checkOffset(e,r,this.length);var f=this[e];var n=1;var i=0;while(++i<r&&(n*=256)){f+=this[e+i]*n}n*=128;if(f>=n)f-=Math.pow(2,8*r);return f};Buffer.prototype.readIntBE=function readIntBE(e,r,t){e=e>>>0;r=r>>>0;if(!t)checkOffset(e,r,this.length);var f=r;var n=1;var i=this[e+--f];while(f>0&&(n*=256)){i+=this[e+--f]*n}n*=128;if(i>=n)i-=Math.pow(2,8*r);return i};Buffer.prototype.readInt8=function readInt8(e,r){e=e>>>0;if(!r)checkOffset(e,1,this.length);if(!(this[e]&128))return this[e];return(255-this[e]+1)*-1};Buffer.prototype.readInt16LE=function readInt16LE(e,r){e=e>>>0;if(!r)checkOffset(e,2,this.length);var t=this[e]|this[e+1]<<8;return t&32768?t|4294901760:t};Buffer.prototype.readInt16BE=function readInt16BE(e,r){e=e>>>0;if(!r)checkOffset(e,2,this.length);var t=this[e+1]|this[e]<<8;return t&32768?t|4294901760:t};Buffer.prototype.readInt32LE=function readInt32LE(e,r){e=e>>>0;if(!r)checkOffset(e,4,this.length);return this[e]|this[e+1]<<8|this[e+2]<<16|this[e+3]<<24};Buffer.prototype.readInt32BE=function readInt32BE(e,r){e=e>>>0;if(!r)checkOffset(e,4,this.length);return this[e]<<24|this[e+1]<<16|this[e+2]<<8|this[e+3]};Buffer.prototype.readFloatLE=function readFloatLE(e,r){e=e>>>0;if(!r)checkOffset(e,4,this.length);return n.read(this,e,true,23,4)};Buffer.prototype.readFloatBE=function readFloatBE(e,r){e=e>>>0;if(!r)checkOffset(e,4,this.length);return n.read(this,e,false,23,4)};Buffer.prototype.readDoubleLE=function readDoubleLE(e,r){e=e>>>0;if(!r)checkOffset(e,8,this.length);return n.read(this,e,true,52,8)};Buffer.prototype.readDoubleBE=function readDoubleBE(e,r){e=e>>>0;if(!r)checkOffset(e,8,this.length);return n.read(this,e,false,52,8)};function checkInt(e,r,t,f,n,i){if(!Buffer.isBuffer(e))throw new TypeError('"buffer" argument must be a Buffer instance');if(r>n||r<i)throw new RangeError('"value" argument is out of bounds');if(t+f>e.length)throw new RangeError("Index out of range")}Buffer.prototype.writeUIntLE=function writeUIntLE(e,r,t,f){e=+e;r=r>>>0;t=t>>>0;if(!f){var n=Math.pow(2,8*t)-1;checkInt(this,e,r,t,n,0)}var i=1;var o=0;this[r]=e&255;while(++o<t&&(i*=256)){this[r+o]=e/i&255}return r+t};Buffer.prototype.writeUIntBE=function writeUIntBE(e,r,t,f){e=+e;r=r>>>0;t=t>>>0;if(!f){var n=Math.pow(2,8*t)-1;checkInt(this,e,r,t,n,0)}var i=t-1;var o=1;this[r+i]=e&255;while(--i>=0&&(o*=256)){this[r+i]=e/o&255}return r+t};Buffer.prototype.writeUInt8=function writeUInt8(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,1,255,0);this[r]=e&255;return r+1};Buffer.prototype.writeUInt16LE=function writeUInt16LE(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,2,65535,0);this[r]=e&255;this[r+1]=e>>>8;return r+2};Buffer.prototype.writeUInt16BE=function writeUInt16BE(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,2,65535,0);this[r]=e>>>8;this[r+1]=e&255;return r+2};Buffer.prototype.writeUInt32LE=function writeUInt32LE(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,4,4294967295,0);this[r+3]=e>>>24;this[r+2]=e>>>16;this[r+1]=e>>>8;this[r]=e&255;return r+4};Buffer.prototype.writeUInt32BE=function writeUInt32BE(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,4,4294967295,0);this[r]=e>>>24;this[r+1]=e>>>16;this[r+2]=e>>>8;this[r+3]=e&255;return r+4};Buffer.prototype.writeIntLE=function writeIntLE(e,r,t,f){e=+e;r=r>>>0;if(!f){var n=Math.pow(2,8*t-1);checkInt(this,e,r,t,n-1,-n)}var i=0;var o=1;var u=0;this[r]=e&255;while(++i<t&&(o*=256)){if(e<0&&u===0&&this[r+i-1]!==0){u=1}this[r+i]=(e/o>>0)-u&255}return r+t};Buffer.prototype.writeIntBE=function writeIntBE(e,r,t,f){e=+e;r=r>>>0;if(!f){var n=Math.pow(2,8*t-1);checkInt(this,e,r,t,n-1,-n)}var i=t-1;var o=1;var u=0;this[r+i]=e&255;while(--i>=0&&(o*=256)){if(e<0&&u===0&&this[r+i+1]!==0){u=1}this[r+i]=(e/o>>0)-u&255}return r+t};Buffer.prototype.writeInt8=function writeInt8(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,1,127,-128);if(e<0)e=255+e+1;this[r]=e&255;return r+1};Buffer.prototype.writeInt16LE=function writeInt16LE(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,2,32767,-32768);this[r]=e&255;this[r+1]=e>>>8;return r+2};Buffer.prototype.writeInt16BE=function writeInt16BE(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,2,32767,-32768);this[r]=e>>>8;this[r+1]=e&255;return r+2};Buffer.prototype.writeInt32LE=function writeInt32LE(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,4,2147483647,-2147483648);this[r]=e&255;this[r+1]=e>>>8;this[r+2]=e>>>16;this[r+3]=e>>>24;return r+4};Buffer.prototype.writeInt32BE=function writeInt32BE(e,r,t){e=+e;r=r>>>0;if(!t)checkInt(this,e,r,4,2147483647,-2147483648);if(e<0)e=4294967295+e+1;this[r]=e>>>24;this[r+1]=e>>>16;this[r+2]=e>>>8;this[r+3]=e&255;return r+4};function checkIEEE754(e,r,t,f,n,i){if(t+f>e.length)throw new RangeError("Index out of range");if(t<0)throw new RangeError("Index out of range")}function writeFloat(e,r,t,f,i){r=+r;t=t>>>0;if(!i){checkIEEE754(e,r,t,4,34028234663852886e22,-34028234663852886e22)}n.write(e,r,t,f,23,4);return t+4}Buffer.prototype.writeFloatLE=function writeFloatLE(e,r,t){return writeFloat(this,e,r,true,t)};Buffer.prototype.writeFloatBE=function writeFloatBE(e,r,t){return writeFloat(this,e,r,false,t)};function writeDouble(e,r,t,f,i){r=+r;t=t>>>0;if(!i){checkIEEE754(e,r,t,8,17976931348623157e292,-17976931348623157e292)}n.write(e,r,t,f,52,8);return t+8}Buffer.prototype.writeDoubleLE=function writeDoubleLE(e,r,t){return writeDouble(this,e,r,true,t)};Buffer.prototype.writeDoubleBE=function writeDoubleBE(e,r,t){return writeDouble(this,e,r,false,t)};Buffer.prototype.copy=function copy(e,r,t,f){if(!Buffer.isBuffer(e))throw new TypeError("argument should be a Buffer");if(!t)t=0;if(!f&&f!==0)f=this.length;if(r>=e.length)r=e.length;if(!r)r=0;if(f>0&&f<t)f=t;if(f===t)return 0;if(e.length===0||this.length===0)return 0;if(r<0){throw new RangeError("targetStart out of bounds")}if(t<0||t>=this.length)throw new RangeError("Index out of range");if(f<0)throw new RangeError("sourceEnd out of bounds");if(f>this.length)f=this.length;if(e.length-r<f-t){f=e.length-r+t}var n=f-t;if(this===e&&typeof Uint8Array.prototype.copyWithin==="function"){this.copyWithin(r,t,f)}else if(this===e&&t<r&&r<f){for(var i=n-1;i>=0;--i){e[i+r]=this[i+t]}}else{Uint8Array.prototype.set.call(e,this.subarray(t,f),r)}return n};Buffer.prototype.fill=function fill(e,r,t,f){if(typeof e==="string"){if(typeof r==="string"){f=r;r=0;t=this.length}else if(typeof t==="string"){f=t;t=this.length}if(f!==undefined&&typeof f!=="string"){throw new TypeError("encoding must be a string")}if(typeof f==="string"&&!Buffer.isEncoding(f)){throw new TypeError("Unknown encoding: "+f)}if(e.length===1){var n=e.charCodeAt(0);if(f==="utf8"&&n<128||f==="latin1"){e=n}}}else if(typeof e==="number"){e=e&255}else if(typeof e==="boolean"){e=Number(e)}if(r<0||this.length<r||this.length<t){throw new RangeError("Out of range index")}if(t<=r){return this}r=r>>>0;t=t===undefined?this.length:t>>>0;if(!e)e=0;var i;if(typeof e==="number"){for(i=r;i<t;++i){this[i]=e}}else{var o=Buffer.isBuffer(e)?e:Buffer.from(e,f);var u=o.length;if(u===0){throw new TypeError('The value "'+e+'" is invalid for argument "value"')}for(i=0;i<t-r;++i){this[i+r]=o[i%u]}}return this};var a=/[^+/0-9A-Za-z-_]/g;function base64clean(e){e=e.split("=")[0];e=e.trim().replace(a,"");if(e.length<2)return"";while(e.length%4!==0){e=e+"="}return e}function utf8ToBytes(e,r){r=r||Infinity;var t;var f=e.length;var n=null;var i=[];for(var o=0;o<f;++o){t=e.charCodeAt(o);if(t>55295&&t<57344){if(!n){if(t>56319){if((r-=3)>-1)i.push(239,191,189);continue}else if(o+1===f){if((r-=3)>-1)i.push(239,191,189);continue}n=t;continue}if(t<56320){if((r-=3)>-1)i.push(239,191,189);n=t;continue}t=(n-55296<<10|t-56320)+65536}else if(n){if((r-=3)>-1)i.push(239,191,189)}n=null;if(t<128){if((r-=1)<0)break;i.push(t)}else if(t<2048){if((r-=2)<0)break;i.push(t>>6|192,t&63|128)}else if(t<65536){if((r-=3)<0)break;i.push(t>>12|224,t>>6&63|128,t&63|128)}else if(t<1114112){if((r-=4)<0)break;i.push(t>>18|240,t>>12&63|128,t>>6&63|128,t&63|128)}else{throw new Error("Invalid code point")}}return i}function asciiToBytes(e){var r=[];for(var t=0;t<e.length;++t){r.push(e.charCodeAt(t)&255)}return r}function utf16leToBytes(e,r){var t,f,n;var i=[];for(var o=0;o<e.length;++o){if((r-=2)<0)break;t=e.charCodeAt(o);f=t>>8;n=t%256;i.push(n);i.push(f)}return i}function base64ToBytes(e){return f.toByteArray(base64clean(e))}function blitBuffer(e,r,t,f){for(var n=0;n<f;++n){if(n+t>=r.length||n>=e.length)break;r[n+t]=e[n]}return n}function isInstance(e,r){return e instanceof r||e!=null&&e.constructor!=null&&e.constructor.name!=null&&e.constructor.name===r.name}function numberIsNaN(e){return e!==e}var s=function(){var e="0123456789abcdef";var r=new Array(256);for(var t=0;t<16;++t){var f=t*16;for(var n=0;n<16;++n){r[f+n]=e[t]+e[n]}}return r}()},783:function(e,r){
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
r.read=function(e,r,t,f,n){var i,o;var u=n*8-f-1;var a=(1<<u)-1;var s=a>>1;var h=-7;var c=t?n-1:0;var l=t?-1:1;var p=e[r+c];c+=l;i=p&(1<<-h)-1;p>>=-h;h+=u;for(;h>0;i=i*256+e[r+c],c+=l,h-=8){}o=i&(1<<-h)-1;i>>=-h;h+=f;for(;h>0;o=o*256+e[r+c],c+=l,h-=8){}if(i===0){i=1-s}else if(i===a){return o?NaN:(p?-1:1)*Infinity}else{o=o+Math.pow(2,f);i=i-s}return(p?-1:1)*o*Math.pow(2,i-f)};r.write=function(e,r,t,f,n,i){var o,u,a;var s=i*8-n-1;var h=(1<<s)-1;var c=h>>1;var l=n===23?Math.pow(2,-24)-Math.pow(2,-77):0;var p=f?0:i-1;var y=f?1:-1;var g=r<0||r===0&&1/r<0?1:0;r=Math.abs(r);if(isNaN(r)||r===Infinity){u=isNaN(r)?1:0;o=h}else{o=Math.floor(Math.log(r)/Math.LN2);if(r*(a=Math.pow(2,-o))<1){o--;a*=2}if(o+c>=1){r+=l/a}else{r+=l*Math.pow(2,1-c)}if(r*a>=2){o++;a/=2}if(o+c>=h){u=0;o=h}else if(o+c>=1){u=(r*a-1)*Math.pow(2,n);o=o+c}else{u=r*Math.pow(2,c-1)*Math.pow(2,n);o=0}}for(;n>=8;e[t+p]=u&255,p+=y,u/=256,n-=8){}o=o<<n|u;s+=n;for(;s>0;e[t+p]=o&255,p+=y,o/=256,s-=8){}e[t+p-y]|=g*128}}};var r={};function __nccwpck_require__(t){var f=r[t];if(f!==undefined){return f.exports}var n=r[t]={exports:{}};var i=true;try{e[t](n,n.exports,__nccwpck_require__);i=false}finally{if(i)delete r[t]}return n.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var t=__nccwpck_require__(72);module.exports=t})();

/***/ }),

/***/ 25293:
/***/ (function(module) {

var __dirname = "/";
(function(){"use strict";var e={864:function(e){var t=typeof Reflect==="object"?Reflect:null;var n=t&&typeof t.apply==="function"?t.apply:function ReflectApply(e,t,n){return Function.prototype.apply.call(e,t,n)};var r;if(t&&typeof t.ownKeys==="function"){r=t.ownKeys}else if(Object.getOwnPropertySymbols){r=function ReflectOwnKeys(e){return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e))}}else{r=function ReflectOwnKeys(e){return Object.getOwnPropertyNames(e)}}function ProcessEmitWarning(e){if(console&&console.warn)console.warn(e)}var i=Number.isNaN||function NumberIsNaN(e){return e!==e};function EventEmitter(){EventEmitter.init.call(this)}e.exports=EventEmitter;e.exports.once=once;EventEmitter.EventEmitter=EventEmitter;EventEmitter.prototype._events=undefined;EventEmitter.prototype._eventsCount=0;EventEmitter.prototype._maxListeners=undefined;var s=10;function checkListener(e){if(typeof e!=="function"){throw new TypeError('The "listener" argument must be of type Function. Received type '+typeof e)}}Object.defineProperty(EventEmitter,"defaultMaxListeners",{enumerable:true,get:function(){return s},set:function(e){if(typeof e!=="number"||e<0||i(e)){throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received '+e+".")}s=e}});EventEmitter.init=function(){if(this._events===undefined||this._events===Object.getPrototypeOf(this)._events){this._events=Object.create(null);this._eventsCount=0}this._maxListeners=this._maxListeners||undefined};EventEmitter.prototype.setMaxListeners=function setMaxListeners(e){if(typeof e!=="number"||e<0||i(e)){throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received '+e+".")}this._maxListeners=e;return this};function _getMaxListeners(e){if(e._maxListeners===undefined)return EventEmitter.defaultMaxListeners;return e._maxListeners}EventEmitter.prototype.getMaxListeners=function getMaxListeners(){return _getMaxListeners(this)};EventEmitter.prototype.emit=function emit(e){var t=[];for(var r=1;r<arguments.length;r++)t.push(arguments[r]);var i=e==="error";var s=this._events;if(s!==undefined)i=i&&s.error===undefined;else if(!i)return false;if(i){var o;if(t.length>0)o=t[0];if(o instanceof Error){throw o}var f=new Error("Unhandled error."+(o?" ("+o.message+")":""));f.context=o;throw f}var u=s[e];if(u===undefined)return false;if(typeof u==="function"){n(u,this,t)}else{var a=u.length;var c=arrayClone(u,a);for(var r=0;r<a;++r)n(c[r],this,t)}return true};function _addListener(e,t,n,r){var i;var s;var o;checkListener(n);s=e._events;if(s===undefined){s=e._events=Object.create(null);e._eventsCount=0}else{if(s.newListener!==undefined){e.emit("newListener",t,n.listener?n.listener:n);s=e._events}o=s[t]}if(o===undefined){o=s[t]=n;++e._eventsCount}else{if(typeof o==="function"){o=s[t]=r?[n,o]:[o,n]}else if(r){o.unshift(n)}else{o.push(n)}i=_getMaxListeners(e);if(i>0&&o.length>i&&!o.warned){o.warned=true;var f=new Error("Possible EventEmitter memory leak detected. "+o.length+" "+String(t)+" listeners "+"added. Use emitter.setMaxListeners() to "+"increase limit");f.name="MaxListenersExceededWarning";f.emitter=e;f.type=t;f.count=o.length;ProcessEmitWarning(f)}}return e}EventEmitter.prototype.addListener=function addListener(e,t){return _addListener(this,e,t,false)};EventEmitter.prototype.on=EventEmitter.prototype.addListener;EventEmitter.prototype.prependListener=function prependListener(e,t){return _addListener(this,e,t,true)};function onceWrapper(){if(!this.fired){this.target.removeListener(this.type,this.wrapFn);this.fired=true;if(arguments.length===0)return this.listener.call(this.target);return this.listener.apply(this.target,arguments)}}function _onceWrap(e,t,n){var r={fired:false,wrapFn:undefined,target:e,type:t,listener:n};var i=onceWrapper.bind(r);i.listener=n;r.wrapFn=i;return i}EventEmitter.prototype.once=function once(e,t){checkListener(t);this.on(e,_onceWrap(this,e,t));return this};EventEmitter.prototype.prependOnceListener=function prependOnceListener(e,t){checkListener(t);this.prependListener(e,_onceWrap(this,e,t));return this};EventEmitter.prototype.removeListener=function removeListener(e,t){var n,r,i,s,o;checkListener(t);r=this._events;if(r===undefined)return this;n=r[e];if(n===undefined)return this;if(n===t||n.listener===t){if(--this._eventsCount===0)this._events=Object.create(null);else{delete r[e];if(r.removeListener)this.emit("removeListener",e,n.listener||t)}}else if(typeof n!=="function"){i=-1;for(s=n.length-1;s>=0;s--){if(n[s]===t||n[s].listener===t){o=n[s].listener;i=s;break}}if(i<0)return this;if(i===0)n.shift();else{spliceOne(n,i)}if(n.length===1)r[e]=n[0];if(r.removeListener!==undefined)this.emit("removeListener",e,o||t)}return this};EventEmitter.prototype.off=EventEmitter.prototype.removeListener;EventEmitter.prototype.removeAllListeners=function removeAllListeners(e){var t,n,r;n=this._events;if(n===undefined)return this;if(n.removeListener===undefined){if(arguments.length===0){this._events=Object.create(null);this._eventsCount=0}else if(n[e]!==undefined){if(--this._eventsCount===0)this._events=Object.create(null);else delete n[e]}return this}if(arguments.length===0){var i=Object.keys(n);var s;for(r=0;r<i.length;++r){s=i[r];if(s==="removeListener")continue;this.removeAllListeners(s)}this.removeAllListeners("removeListener");this._events=Object.create(null);this._eventsCount=0;return this}t=n[e];if(typeof t==="function"){this.removeListener(e,t)}else if(t!==undefined){for(r=t.length-1;r>=0;r--){this.removeListener(e,t[r])}}return this};function _listeners(e,t,n){var r=e._events;if(r===undefined)return[];var i=r[t];if(i===undefined)return[];if(typeof i==="function")return n?[i.listener||i]:[i];return n?unwrapListeners(i):arrayClone(i,i.length)}EventEmitter.prototype.listeners=function listeners(e){return _listeners(this,e,true)};EventEmitter.prototype.rawListeners=function rawListeners(e){return _listeners(this,e,false)};EventEmitter.listenerCount=function(e,t){if(typeof e.listenerCount==="function"){return e.listenerCount(t)}else{return listenerCount.call(e,t)}};EventEmitter.prototype.listenerCount=listenerCount;function listenerCount(e){var t=this._events;if(t!==undefined){var n=t[e];if(typeof n==="function"){return 1}else if(n!==undefined){return n.length}}return 0}EventEmitter.prototype.eventNames=function eventNames(){return this._eventsCount>0?r(this._events):[]};function arrayClone(e,t){var n=new Array(t);for(var r=0;r<t;++r)n[r]=e[r];return n}function spliceOne(e,t){for(;t+1<e.length;t++)e[t]=e[t+1];e.pop()}function unwrapListeners(e){var t=new Array(e.length);for(var n=0;n<t.length;++n){t[n]=e[n].listener||e[n]}return t}function once(e,t){return new Promise((function(n,r){function errorListener(n){e.removeListener(t,resolver);r(n)}function resolver(){if(typeof e.removeListener==="function"){e.removeListener("error",errorListener)}n([].slice.call(arguments))}eventTargetAgnosticAddListener(e,t,resolver,{once:true});if(t!=="error"){addErrorHandlerIfEventEmitter(e,errorListener,{once:true})}}))}function addErrorHandlerIfEventEmitter(e,t,n){if(typeof e.on==="function"){eventTargetAgnosticAddListener(e,"error",t,n)}}function eventTargetAgnosticAddListener(e,t,n,r){if(typeof e.on==="function"){if(r.once){e.once(t,n)}else{e.on(t,n)}}else if(typeof e.addEventListener==="function"){e.addEventListener(t,(function wrapListener(i){if(r.once){e.removeEventListener(t,wrapListener)}n(i)}))}else{throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type '+typeof e)}}}};var t={};function __nccwpck_require__(n){var r=t[n];if(r!==undefined){return r.exports}var i=t[n]={exports:{}};var s=true;try{e[n](i,i.exports,__nccwpck_require__);s=false}finally{if(s)delete t[n]}return i.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var n=__nccwpck_require__(864);module.exports=n})();

/***/ }),

/***/ 59621:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapLoad":"styles_wrapLoad__koJen","loading-3":"styles_loading-3__xROrF","loading-3-sub":"styles_loading-3-sub__rB9h3","animateTS":"styles_animateTS__zCk8U","textclip":"styles_textclip__N7GRf"};

/***/ }),

/***/ 6837:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__SpsMg","wrapper":"styles_wrapper__yHcHx","progress":"styles_progress__8TPzZ","fullWidth":"styles_fullWidth__zc8my","MuiAlert-message":"styles_MuiAlert-message____aBe","content":"styles_content__Pd93b"};

/***/ }),

/***/ 5673:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 40993:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 20472:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 39988:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 77663:
/***/ (function(module) {

var __dirname = "/";
(function(){var e={229:function(e){var t=e.exports={};var r;var n;function defaultSetTimout(){throw new Error("setTimeout has not been defined")}function defaultClearTimeout(){throw new Error("clearTimeout has not been defined")}(function(){try{if(typeof setTimeout==="function"){r=setTimeout}else{r=defaultSetTimout}}catch(e){r=defaultSetTimout}try{if(typeof clearTimeout==="function"){n=clearTimeout}else{n=defaultClearTimeout}}catch(e){n=defaultClearTimeout}})();function runTimeout(e){if(r===setTimeout){return setTimeout(e,0)}if((r===defaultSetTimout||!r)&&setTimeout){r=setTimeout;return setTimeout(e,0)}try{return r(e,0)}catch(t){try{return r.call(null,e,0)}catch(t){return r.call(this,e,0)}}}function runClearTimeout(e){if(n===clearTimeout){return clearTimeout(e)}if((n===defaultClearTimeout||!n)&&clearTimeout){n=clearTimeout;return clearTimeout(e)}try{return n(e)}catch(t){try{return n.call(null,e)}catch(t){return n.call(this,e)}}}var i=[];var o=false;var u;var a=-1;function cleanUpNextTick(){if(!o||!u){return}o=false;if(u.length){i=u.concat(i)}else{a=-1}if(i.length){drainQueue()}}function drainQueue(){if(o){return}var e=runTimeout(cleanUpNextTick);o=true;var t=i.length;while(t){u=i;i=[];while(++a<t){if(u){u[a].run()}}a=-1;t=i.length}u=null;o=false;runClearTimeout(e)}t.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1){for(var r=1;r<arguments.length;r++){t[r-1]=arguments[r]}}i.push(new Item(e,t));if(i.length===1&&!o){runTimeout(drainQueue)}};function Item(e,t){this.fun=e;this.array=t}Item.prototype.run=function(){this.fun.apply(null,this.array)};t.title="browser";t.browser=true;t.env={};t.argv=[];t.version="";t.versions={};function noop(){}t.on=noop;t.addListener=noop;t.once=noop;t.off=noop;t.removeListener=noop;t.removeAllListeners=noop;t.emit=noop;t.prependListener=noop;t.prependOnceListener=noop;t.listeners=function(e){return[]};t.binding=function(e){throw new Error("process.binding is not supported")};t.cwd=function(){return"/"};t.chdir=function(e){throw new Error("process.chdir is not supported")};t.umask=function(){return 0}}};var t={};function __nccwpck_require__(r){var n=t[r];if(n!==undefined){return n.exports}var i=t[r]={exports:{}};var o=true;try{e[r](i,i.exports,__nccwpck_require__);o=false}finally{if(o)delete t[r]}return i.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var r=__nccwpck_require__(229);module.exports=r})();

/***/ }),

/***/ 5152:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(90638)


/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5443)


/***/ }),

/***/ 25675:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(28045)


/***/ }),

/***/ 11163:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(90387)


/***/ }),

/***/ 4298:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(20699)


/***/ }),

/***/ 70321:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/*
 * node-cache 5.1.2 ( 2020-07-01 )
 * https://github.com/node-cache/node-cache
 *
 * Released under the MIT license
 * https://github.com/node-cache/node-cache/blob/master/LICENSE
 *
 * Maintained by  (  )
*/
(function() {
  var exports;

  exports = module.exports = __webpack_require__(35282);

  exports.version = '5.1.2';

}).call(this);


/***/ }),

/***/ 35282:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* provided dependency */ var Buffer = __webpack_require__(21876)["Buffer"];
/*
 * node-cache 5.1.2 ( 2020-07-01 )
 * https://github.com/node-cache/node-cache
 *
 * Released under the MIT license
 * https://github.com/node-cache/node-cache/blob/master/LICENSE
 *
 * Maintained by  (  )
*/
(function() {
  var EventEmitter, NodeCache, clone,
    splice = [].splice,
    boundMethodCheck = function(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new Error('Bound instance method accessed before binding'); } },
    indexOf = [].indexOf;

  clone = __webpack_require__(16313);

  EventEmitter = (__webpack_require__(25293).EventEmitter);

  // generate superclass
  module.exports = NodeCache = (function() {
    class NodeCache extends EventEmitter {
      constructor(options = {}) {
        super();
        // ## get

        // get a cached key and change the stats

        // **Parameters:**

        // * `key` ( String | Number ): cache key

        // **Example:**

        //	myCache.get "myKey", ( err, val )

        this.get = this.get.bind(this);
        // ## mget

        // get multiple cached keys at once and change the stats

        // **Parameters:**

        // * `keys` ( String|Number[] ): an array of keys

        // **Example:**

        //	myCache.mget [ "foo", "bar" ]

        this.mget = this.mget.bind(this);
        // ## set

        // set a cached key and change the stats

        // **Parameters:**

        // * `key` ( String | Number ): cache key
        // * `value` ( Any ): A element to cache. If the option `option.forceString` is `true` the module trys to translate it to a serialized JSON
        // * `[ ttl ]` ( Number | String ): ( optional ) The time to live in seconds.

        // **Example:**

        //	myCache.set "myKey", "my_String Value"

        //	myCache.set "myKey", "my_String Value", 10

        this.set = this.set.bind(this);
        
        // ## mset

        // set multiple keys at once

        // **Parameters:**

        // * `keyValueSet` ( Object[] ): an array of object which includes key,value and ttl

        // **Example:**

        //	myCache.mset(
        //		[
        //			{
        //				key: "myKey",
        //				val: "myValue",
        //				ttl: [ttl in seconds]
        //			}
        //		])

        this.mset = this.mset.bind(this);
        // ## del

        // remove keys

        // **Parameters:**

        // * `keys` ( String | Number | String|Number[] ): cache key to delete or a array of cache keys

        // **Return**

        // ( Number ): Number of deleted keys

        // **Example:**

        //	myCache.del( "myKey" )

        this.del = this.del.bind(this);
        // ## take

        // get the cached value and remove the key from the cache.
        // Equivalent to calling `get(key)` + `del(key)`.
        // Useful for implementing `single use` mechanism such as OTP, where once a value is read it will become obsolete.

        // **Parameters:**

        // * `key` ( String | Number ): cache key

        // **Example:**

        //	myCache.take "myKey", ( err, val )

        this.take = this.take.bind(this);
        // ## ttl

        // reset or redefine the ttl of a key. `ttl` = 0 means infinite lifetime.
        // If `ttl` is not passed the default ttl is used.
        // If `ttl` < 0 the key will be deleted.

        // **Parameters:**

        // * `key` ( String | Number ): cache key to reset the ttl value
        // * `ttl` ( Number ): ( optional -> options.stdTTL || 0 ) The time to live in seconds

        // **Return**

        // ( Boolen ): key found and ttl set

        // **Example:**

        //	myCache.ttl( "myKey" ) // will set ttl to default ttl

        //	myCache.ttl( "myKey", 1000 )

        this.ttl = this.ttl.bind(this);
        // ## getTtl

        // receive the ttl of a key.

        // **Parameters:**

        // * `key` ( String | Number ): cache key to check the ttl value

        // **Return**

        // ( Number|undefined ): The timestamp in ms when the key will expire, 0 if it will never expire or undefined if it not exists

        // **Example:**

        //	myCache.getTtl( "myKey" )

        this.getTtl = this.getTtl.bind(this);
        // ## keys

        // list all keys within this cache

        // **Return**

        // ( Array ): An array of all keys

        // **Example:**

        //     _keys = myCache.keys()

        //     # [ "foo", "bar", "fizz", "buzz", "anotherKeys" ]

        this.keys = this.keys.bind(this);
        // ## has

        // Check if a key is cached

        // **Parameters:**

        // * `key` ( String | Number ): cache key to check the ttl value

        // **Return**

        // ( Boolean ): A boolean that indicates if the key is cached

        // **Example:**

        //     _exists = myCache.has('myKey')

        //     # true

        this.has = this.has.bind(this);
        // ## getStats

        // get the stats

        // **Parameters:**

        // -

        // **Return**

        // ( Object ): Stats data

        // **Example:**

        //     myCache.getStats()
        //     # {
        //     # hits: 0,
        //     # misses: 0,
        //     # keys: 0,
        //     # ksize: 0,
        //     # vsize: 0
        //     # }

        this.getStats = this.getStats.bind(this);
        // ## flushAll

        // flush the whole data and reset the stats

        // **Example:**

        //     myCache.flushAll()

        //     myCache.getStats()
        //     # {
        //     # hits: 0,
        //     # misses: 0,
        //     # keys: 0,
        //     # ksize: 0,
        //     # vsize: 0
        //     # }

        this.flushAll = this.flushAll.bind(this);
        
        // ## flushStats

        // flush the stats and reset all counters to 0

        // **Example:**

        //     myCache.flushStats()

        //     myCache.getStats()
        //     # {
        //     # hits: 0,
        //     # misses: 0,
        //     # keys: 0,
        //     # ksize: 0,
        //     # vsize: 0
        //     # }

        this.flushStats = this.flushStats.bind(this);
        // ## close

        // This will clear the interval timeout which is set on checkperiod option.

        // **Example:**

        //     myCache.close()

        this.close = this.close.bind(this);
        // ## _checkData

        // internal housekeeping method.
        // Check all the cached data and delete the invalid values
        this._checkData = this._checkData.bind(this);
        // ## _check

        // internal method the check the value. If it's not valid any more delete it
        this._check = this._check.bind(this);
        // ## _isInvalidKey

        // internal method to check if the type of a key is either `number` or `string`
        this._isInvalidKey = this._isInvalidKey.bind(this);
        // ## _wrap

        // internal method to wrap a value in an object with some metadata
        this._wrap = this._wrap.bind(this);
        // ## _getValLength

        // internal method to calculate the value length
        this._getValLength = this._getValLength.bind(this);
        // ## _error

        // internal method to handle an error message
        this._error = this._error.bind(this);
        // ## _initErrors

        // internal method to generate error message templates
        this._initErrors = this._initErrors.bind(this);
        this.options = options;
        this._initErrors();
        // container for cached data
        this.data = {};
        // module options
        this.options = Object.assign({
          // convert all elements to string
          forceString: false,
          // used standard size for calculating value size
          objectValueSize: 80,
          promiseValueSize: 80,
          arrayValueSize: 40,
          // standard time to live in seconds. 0 = infinity;
          stdTTL: 0,
          // time in seconds to check all data and delete expired keys
          checkperiod: 600,
          // en/disable cloning of variables. If `true` you'll get a copy of the cached variable. If `false` you'll save and get just the reference
          useClones: true,
          // whether values should be deleted automatically at expiration
          deleteOnExpire: true,
          // enable legacy callbacks
          enableLegacyCallbacks: false,
          // max amount of keys that are being stored
          maxKeys: -1
        }, this.options);
        // generate functions with callbacks (legacy)
        if (this.options.enableLegacyCallbacks) {
          console.warn("WARNING! node-cache legacy callback support will drop in v6.x");
          ["get", "mget", "set", "del", "ttl", "getTtl", "keys", "has"].forEach((methodKey) => {
            var oldMethod;
            // reference real function
            oldMethod = this[methodKey];
            this[methodKey] = function(...args) {
              var cb, err, ref, res;
              ref = args, [...args] = ref, [cb] = splice.call(args, -1);
              // return a callback if cb is defined and a function
              if (typeof cb === "function") {
                try {
                  res = oldMethod(...args);
                  cb(null, res);
                } catch (error1) {
                  err = error1;
                  cb(err);
                }
              } else {
                return oldMethod(...args, cb);
              }
            };
          });
        }
        // statistics container
        this.stats = {
          hits: 0,
          misses: 0,
          keys: 0,
          ksize: 0,
          vsize: 0
        };
        // pre allocate valid keytypes array
        this.validKeyTypes = ["string", "number"];
        // initalize checking period
        this._checkData();
        return;
      }

      get(key) {
        var _ret, err;
        boundMethodCheck(this, NodeCache);
        // handle invalid key types
        if ((err = this._isInvalidKey(key)) != null) {
          throw err;
        }
        // get data and incremet stats
        if ((this.data[key] != null) && this._check(key, this.data[key])) {
          this.stats.hits++;
          _ret = this._unwrap(this.data[key]);
          // return data
          return _ret;
        } else {
          // if not found return undefined
          this.stats.misses++;
          return void 0;
        }
      }

      mget(keys) {
        var _err, err, i, key, len, oRet;
        boundMethodCheck(this, NodeCache);
        // convert a string to an array of one key
        if (!Array.isArray(keys)) {
          _err = this._error("EKEYSTYPE");
          throw _err;
        }
        // define return
        oRet = {};
        for (i = 0, len = keys.length; i < len; i++) {
          key = keys[i];
          // handle invalid key types
          if ((err = this._isInvalidKey(key)) != null) {
            throw err;
          }
          // get data and increment stats
          if ((this.data[key] != null) && this._check(key, this.data[key])) {
            this.stats.hits++;
            oRet[key] = this._unwrap(this.data[key]);
          } else {
            // if not found return a error
            this.stats.misses++;
          }
        }
        // return all found keys
        return oRet;
      }

      set(key, value, ttl) {
        var _err, err, existent;
        boundMethodCheck(this, NodeCache);
        // check if cache is overflowing
        if (this.options.maxKeys > -1 && this.stats.keys >= this.options.maxKeys) {
          _err = this._error("ECACHEFULL");
          throw _err;
        }
        // force the data to string
        if (this.options.forceString && !typeof value === "string") {
          value = JSON.stringify(value);
        }
        // set default ttl if not passed
        if (ttl == null) {
          ttl = this.options.stdTTL;
        }
        // handle invalid key types
        if ((err = this._isInvalidKey(key)) != null) {
          throw err;
        }
        // internal helper variables
        existent = false;
        // remove existing data from stats
        if (this.data[key]) {
          existent = true;
          this.stats.vsize -= this._getValLength(this._unwrap(this.data[key], false));
        }
        // set the value
        this.data[key] = this._wrap(value, ttl);
        this.stats.vsize += this._getValLength(value);
        // only add the keys and key-size if the key is new
        if (!existent) {
          this.stats.ksize += this._getKeyLength(key);
          this.stats.keys++;
        }
        this.emit("set", key, value);
        // return true
        return true;
      }

      mset(keyValueSet) {
        var _err, err, i, j, key, keyValuePair, len, len1, ttl, val;
        boundMethodCheck(this, NodeCache);
        // check if cache is overflowing
        if (this.options.maxKeys > -1 && this.stats.keys + keyValueSet.length >= this.options.maxKeys) {
          _err = this._error("ECACHEFULL");
          throw _err;
        }

// loop over keyValueSet to validate key and ttl
        for (i = 0, len = keyValueSet.length; i < len; i++) {
          keyValuePair = keyValueSet[i];
          ({key, val, ttl} = keyValuePair);
          // check if there is ttl and it's a number
          if (ttl && typeof ttl !== "number") {
            _err = this._error("ETTLTYPE");
            throw _err;
          }
          // handle invalid key types
          if ((err = this._isInvalidKey(key)) != null) {
            throw err;
          }
        }
        for (j = 0, len1 = keyValueSet.length; j < len1; j++) {
          keyValuePair = keyValueSet[j];
          ({key, val, ttl} = keyValuePair);
          this.set(key, val, ttl);
        }
        return true;
      }

      del(keys) {
        var delCount, err, i, key, len, oldVal;
        boundMethodCheck(this, NodeCache);
        // convert keys to an array of itself
        if (!Array.isArray(keys)) {
          keys = [keys];
        }
        delCount = 0;
        for (i = 0, len = keys.length; i < len; i++) {
          key = keys[i];
          // handle invalid key types
          if ((err = this._isInvalidKey(key)) != null) {
            throw err;
          }
          // only delete if existent
          if (this.data[key] != null) {
            // calc the stats
            this.stats.vsize -= this._getValLength(this._unwrap(this.data[key], false));
            this.stats.ksize -= this._getKeyLength(key);
            this.stats.keys--;
            delCount++;
            // delete the value
            oldVal = this.data[key];
            delete this.data[key];
            // return true
            this.emit("del", key, oldVal.v);
          }
        }
        return delCount;
      }

      take(key) {
        var _ret;
        boundMethodCheck(this, NodeCache);
        _ret = this.get(key);
        if ((_ret != null)) {
          this.del(key);
        }
        return _ret;
      }

      ttl(key, ttl) {
        var err;
        boundMethodCheck(this, NodeCache);
        ttl || (ttl = this.options.stdTTL);
        if (!key) {
          return false;
        }
        // handle invalid key types
        if ((err = this._isInvalidKey(key)) != null) {
          throw err;
        }
        // check for existent data and update the ttl value
        if ((this.data[key] != null) && this._check(key, this.data[key])) {
          // if ttl < 0 delete the key. otherwise reset the value
          if (ttl >= 0) {
            this.data[key] = this._wrap(this.data[key].v, ttl, false);
          } else {
            this.del(key);
          }
          return true;
        } else {
          // return false if key has not been found
          return false;
        }
      }

      getTtl(key) {
        var _ttl, err;
        boundMethodCheck(this, NodeCache);
        if (!key) {
          return void 0;
        }
        // handle invalid key types
        if ((err = this._isInvalidKey(key)) != null) {
          throw err;
        }
        // check for existant data and update the ttl value
        if ((this.data[key] != null) && this._check(key, this.data[key])) {
          _ttl = this.data[key].t;
          return _ttl;
        } else {
          // return undefined if key has not been found
          return void 0;
        }
      }

      keys() {
        var _keys;
        boundMethodCheck(this, NodeCache);
        _keys = Object.keys(this.data);
        return _keys;
      }

      has(key) {
        var _exists;
        boundMethodCheck(this, NodeCache);
        _exists = (this.data[key] != null) && this._check(key, this.data[key]);
        return _exists;
      }

      getStats() {
        boundMethodCheck(this, NodeCache);
        return this.stats;
      }

      flushAll(_startPeriod = true) {
        boundMethodCheck(this, NodeCache);
        // parameter just for testing

        // set data empty
        this.data = {};
        // reset stats
        this.stats = {
          hits: 0,
          misses: 0,
          keys: 0,
          ksize: 0,
          vsize: 0
        };
        // reset check period
        this._killCheckPeriod();
        this._checkData(_startPeriod);
        this.emit("flush");
      }

      flushStats() {
        boundMethodCheck(this, NodeCache);
        // reset stats
        this.stats = {
          hits: 0,
          misses: 0,
          keys: 0,
          ksize: 0,
          vsize: 0
        };
        this.emit("flush_stats");
      }

      close() {
        boundMethodCheck(this, NodeCache);
        this._killCheckPeriod();
      }

      _checkData(startPeriod = true) {
        var key, ref, value;
        boundMethodCheck(this, NodeCache);
        ref = this.data;
        // run the housekeeping method
        for (key in ref) {
          value = ref[key];
          this._check(key, value);
        }
        if (startPeriod && this.options.checkperiod > 0) {
          this.checkTimeout = setTimeout(this._checkData, this.options.checkperiod * 1000, startPeriod);
          if ((this.checkTimeout != null) && (this.checkTimeout.unref != null)) {
            this.checkTimeout.unref();
          }
        }
      }

      // ## _killCheckPeriod

      // stop the checkdata period. Only needed to abort the script in testing mode.
      _killCheckPeriod() {
        if (this.checkTimeout != null) {
          return clearTimeout(this.checkTimeout);
        }
      }

      _check(key, data) {
        var _retval;
        boundMethodCheck(this, NodeCache);
        _retval = true;
        // data is invalid if the ttl is too old and is not 0
        // console.log data.t < Date.now(), data.t, Date.now()
        if (data.t !== 0 && data.t < Date.now()) {
          if (this.options.deleteOnExpire) {
            _retval = false;
            this.del(key);
          }
          this.emit("expired", key, this._unwrap(data));
        }
        return _retval;
      }

      _isInvalidKey(key) {
        var ref;
        boundMethodCheck(this, NodeCache);
        if (ref = typeof key, indexOf.call(this.validKeyTypes, ref) < 0) {
          return this._error("EKEYTYPE", {
            type: typeof key
          });
        }
      }

      _wrap(value, ttl, asClone = true) {
        var livetime, now, oReturn, ttlMultiplicator;
        boundMethodCheck(this, NodeCache);
        if (!this.options.useClones) {
          asClone = false;
        }
        // define the time to live
        now = Date.now();
        livetime = 0;
        ttlMultiplicator = 1000;
        // use given ttl
        if (ttl === 0) {
          livetime = 0;
        } else if (ttl) {
          livetime = now + (ttl * ttlMultiplicator);
        } else {
          // use standard ttl
          if (this.options.stdTTL === 0) {
            livetime = this.options.stdTTL;
          } else {
            livetime = now + (this.options.stdTTL * ttlMultiplicator);
          }
        }
        // return the wrapped value
        return oReturn = {
          t: livetime,
          v: asClone ? clone(value) : value
        };
      }

      // ## _unwrap

      // internal method to extract get the value out of the wrapped value
      _unwrap(value, asClone = true) {
        if (!this.options.useClones) {
          asClone = false;
        }
        if (value.v != null) {
          if (asClone) {
            return clone(value.v);
          } else {
            return value.v;
          }
        }
        return null;
      }

      // ## _getKeyLength

      // internal method the calculate the key length
      _getKeyLength(key) {
        return key.toString().length;
      }

      _getValLength(value) {
        boundMethodCheck(this, NodeCache);
        if (typeof value === "string") {
          // if the value is a String get the real length
          return value.length;
        } else if (this.options.forceString) {
          // force string if it's defined and not passed
          return JSON.stringify(value).length;
        } else if (Array.isArray(value)) {
          // if the data is an Array multiply each element with a defined default length
          return this.options.arrayValueSize * value.length;
        } else if (typeof value === "number") {
          return 8;
        } else if (typeof (value != null ? value.then : void 0) === "function") {
          // if the data is a Promise, use defined default
          // (can't calculate actual/resolved value size synchronously)
          return this.options.promiseValueSize;
        } else if (typeof Buffer !== "undefined" && Buffer !== null ? Buffer.isBuffer(value) : void 0) {
          return value.length;
        } else if ((value != null) && typeof value === "object") {
          // if the data is an Object multiply each element with a defined default length
          return this.options.objectValueSize * Object.keys(value).length;
        } else if (typeof value === "boolean") {
          return 8;
        } else {
          // default fallback
          return 0;
        }
      }

      _error(type, data = {}) {
        var error;
        boundMethodCheck(this, NodeCache);
        // generate the error object
        error = new Error();
        error.name = type;
        error.errorcode = type;
        error.message = this.ERRORS[type] != null ? this.ERRORS[type](data) : "-";
        error.data = data;
        // return the error object
        return error;
      }

      _initErrors() {
        var _errMsg, _errT, ref;
        boundMethodCheck(this, NodeCache);
        this.ERRORS = {};
        ref = this._ERRORS;
        for (_errT in ref) {
          _errMsg = ref[_errT];
          this.ERRORS[_errT] = this.createErrorMessage(_errMsg);
        }
      }

      createErrorMessage(errMsg) {
        return function(args) {
          return errMsg.replace("__key", args.type);
        };
      }

    };

    NodeCache.prototype._ERRORS = {
      "ENOTFOUND": "Key `__key` not found",
      "ECACHEFULL": "Cache max keys amount exceeded",
      "EKEYTYPE": "The key argument has to be of type `string` or `number`. Found: `__key`",
      "EKEYSTYPE": "The keys argument has to be an array.",
      "ETTLTYPE": "The ttl argument has to be a number."
    };

    return NodeCache;

  }).call(this);

}).call(this);


/***/ }),

/***/ 92703:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(50414);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 45697:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(92703)();
}


/***/ }),

/***/ 50414:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 85518:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = __webpack_require__(67294);
var React__default = _interopDefault(React);

var UAParser = __webpack_require__(23451);

var ClientUAInstance = new UAParser();
var browser = ClientUAInstance.getBrowser();
var cpu = ClientUAInstance.getCPU();
var device = ClientUAInstance.getDevice();
var engine = ClientUAInstance.getEngine();
var os = ClientUAInstance.getOS();
var ua = ClientUAInstance.getUA();
var setUa = function setUa(userAgentString) {
  return ClientUAInstance.setUA(userAgentString);
};
var parseUserAgent = function parseUserAgent(userAgent) {
  if (!userAgent) {
    console.error('No userAgent string was provided');
    return;
  }

  var UserAgentInstance = new UAParser(userAgent);
  return {
    UA: UserAgentInstance,
    browser: UserAgentInstance.getBrowser(),
    cpu: UserAgentInstance.getCPU(),
    device: UserAgentInstance.getDevice(),
    engine: UserAgentInstance.getEngine(),
    os: UserAgentInstance.getOS(),
    ua: UserAgentInstance.getUA(),
    setUserAgent: function setUserAgent(userAgentString) {
      return UserAgentInstance.setUA(userAgentString);
    }
  };
};

var UAHelper = /*#__PURE__*/Object.freeze({
  ClientUAInstance: ClientUAInstance,
  browser: browser,
  cpu: cpu,
  device: device,
  engine: engine,
  os: os,
  ua: ua,
  setUa: setUa,
  parseUserAgent: parseUserAgent
});

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var DeviceTypes = {
  Mobile: 'mobile',
  Tablet: 'tablet',
  SmartTv: 'smarttv',
  Console: 'console',
  Wearable: 'wearable',
  Embedded: 'embedded',
  Browser: undefined
};
var BrowserTypes = {
  Chrome: 'Chrome',
  Firefox: 'Firefox',
  Opera: 'Opera',
  Yandex: 'Yandex',
  Safari: 'Safari',
  InternetExplorer: 'Internet Explorer',
  Edge: 'Edge',
  Chromium: 'Chromium',
  Ie: 'IE',
  MobileSafari: 'Mobile Safari',
  EdgeChromium: 'Edge Chromium',
  MIUI: 'MIUI Browser',
  SamsungBrowser: 'Samsung Browser'
};
var OsTypes = {
  IOS: 'iOS',
  Android: 'Android',
  WindowsPhone: 'Windows Phone',
  Windows: 'Windows',
  MAC_OS: 'Mac OS'
};
var InitialDeviceTypes = {
  isMobile: false,
  isTablet: false,
  isBrowser: false,
  isSmartTV: false,
  isConsole: false,
  isWearable: false
};

var checkDeviceType = function checkDeviceType(type) {
  switch (type) {
    case DeviceTypes.Mobile:
      return {
        isMobile: true
      };

    case DeviceTypes.Tablet:
      return {
        isTablet: true
      };

    case DeviceTypes.SmartTv:
      return {
        isSmartTV: true
      };

    case DeviceTypes.Console:
      return {
        isConsole: true
      };

    case DeviceTypes.Wearable:
      return {
        isWearable: true
      };

    case DeviceTypes.Browser:
      return {
        isBrowser: true
      };

    case DeviceTypes.Embedded:
      return {
        isEmbedded: true
      };

    default:
      return InitialDeviceTypes;
  }
};
var setUserAgent = function setUserAgent(userAgent) {
  return setUa(userAgent);
};
var setDefaults = function setDefaults(p) {
  var d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'none';
  return p ? p : d;
};
var getNavigatorInstance = function getNavigatorInstance() {
  if (typeof window !== 'undefined') {
    if (window.navigator || navigator) {
      return window.navigator || navigator;
    }
  }

  return false;
};
var isIOS13Check = function isIOS13Check(type) {
  var nav = getNavigatorInstance();
  return nav && nav.platform && (nav.platform.indexOf(type) !== -1 || nav.platform === 'MacIntel' && nav.maxTouchPoints > 1 && !window.MSStream);
};

var browserPayload = function browserPayload(isBrowser, browser, engine, os, ua) {
  return {
    isBrowser: isBrowser,
    browserMajorVersion: setDefaults(browser.major),
    browserFullVersion: setDefaults(browser.version),
    browserName: setDefaults(browser.name),
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};
var mobilePayload = function mobilePayload(type, device, os, ua) {
  return _objectSpread2({}, type, {
    vendor: setDefaults(device.vendor),
    model: setDefaults(device.model),
    os: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    ua: setDefaults(ua)
  });
};
var smartTvPayload = function smartTvPayload(isSmartTV, engine, os, ua) {
  return {
    isSmartTV: isSmartTV,
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};
var consolePayload = function consolePayload(isConsole, engine, os, ua) {
  return {
    isConsole: isConsole,
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};
var wearablePayload = function wearablePayload(isWearable, engine, os, ua) {
  return {
    isWearable: isWearable,
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};
var embeddedPayload = function embeddedPayload(isEmbedded, device, engine, os, ua) {
  return {
    isEmbedded: isEmbedded,
    vendor: setDefaults(device.vendor),
    model: setDefaults(device.model),
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};

function deviceDetect(userAgent) {
  var _ref = userAgent ? parseUserAgent(userAgent) : UAHelper,
      device = _ref.device,
      browser = _ref.browser,
      engine = _ref.engine,
      os = _ref.os,
      ua = _ref.ua;

  var type = checkDeviceType(device.type);
  var isBrowser = type.isBrowser,
      isMobile = type.isMobile,
      isTablet = type.isTablet,
      isSmartTV = type.isSmartTV,
      isConsole = type.isConsole,
      isWearable = type.isWearable,
      isEmbedded = type.isEmbedded;

  if (isBrowser) {
    return browserPayload(isBrowser, browser, engine, os, ua);
  }

  if (isSmartTV) {
    return smartTvPayload(isSmartTV, engine, os, ua);
  }

  if (isConsole) {
    return consolePayload(isConsole, engine, os, ua);
  }

  if (isMobile) {
    return mobilePayload(type, device, os, ua);
  }

  if (isTablet) {
    return mobilePayload(type, device, os, ua);
  }

  if (isWearable) {
    return wearablePayload(isWearable, engine, os, ua);
  }

  if (isEmbedded) {
    return embeddedPayload(isEmbedded, device, engine, os, ua);
  }
}

var isMobileType = function isMobileType(_ref) {
  var type = _ref.type;
  return type === DeviceTypes.Mobile;
};
var isTabletType = function isTabletType(_ref2) {
  var type = _ref2.type;
  return type === DeviceTypes.Tablet;
};
var isMobileAndTabletType = function isMobileAndTabletType(_ref3) {
  var type = _ref3.type;
  return type === DeviceTypes.Mobile || type === DeviceTypes.Tablet;
};
var isSmartTVType = function isSmartTVType(_ref4) {
  var type = _ref4.type;
  return type === DeviceTypes.SmartTv;
};
var isBrowserType = function isBrowserType(_ref5) {
  var type = _ref5.type;
  return type === DeviceTypes.Browser;
};
var isWearableType = function isWearableType(_ref6) {
  var type = _ref6.type;
  return type === DeviceTypes.Wearable;
};
var isConsoleType = function isConsoleType(_ref7) {
  var type = _ref7.type;
  return type === DeviceTypes.Console;
};
var isEmbeddedType = function isEmbeddedType(_ref8) {
  var type = _ref8.type;
  return type === DeviceTypes.Embedded;
};
var getMobileVendor = function getMobileVendor(_ref9) {
  var vendor = _ref9.vendor;
  return setDefaults(vendor);
};
var getMobileModel = function getMobileModel(_ref10) {
  var model = _ref10.model;
  return setDefaults(model);
};
var getDeviceType = function getDeviceType(_ref11) {
  var type = _ref11.type;
  return setDefaults(type, 'browser');
}; // os types

var isAndroidType = function isAndroidType(_ref12) {
  var name = _ref12.name;
  return name === OsTypes.Android;
};
var isWindowsType = function isWindowsType(_ref13) {
  var name = _ref13.name;
  return name === OsTypes.Windows;
};
var isMacOsType = function isMacOsType(_ref14) {
  var name = _ref14.name;
  return name === OsTypes.MAC_OS;
};
var isWinPhoneType = function isWinPhoneType(_ref15) {
  var name = _ref15.name;
  return name === OsTypes.WindowsPhone;
};
var isIOSType = function isIOSType(_ref16) {
  var name = _ref16.name;
  return name === OsTypes.IOS;
};
var getOsVersion = function getOsVersion(_ref17) {
  var version = _ref17.version;
  return setDefaults(version);
};
var getOsName = function getOsName(_ref18) {
  var name = _ref18.name;
  return setDefaults(name);
}; // browser types

var isChromeType = function isChromeType(_ref19) {
  var name = _ref19.name;
  return name === BrowserTypes.Chrome;
};
var isFirefoxType = function isFirefoxType(_ref20) {
  var name = _ref20.name;
  return name === BrowserTypes.Firefox;
};
var isChromiumType = function isChromiumType(_ref21) {
  var name = _ref21.name;
  return name === BrowserTypes.Chromium;
};
var isEdgeType = function isEdgeType(_ref22) {
  var name = _ref22.name;
  return name === BrowserTypes.Edge;
};
var isYandexType = function isYandexType(_ref23) {
  var name = _ref23.name;
  return name === BrowserTypes.Yandex;
};
var isSafariType = function isSafariType(_ref24) {
  var name = _ref24.name;
  return name === BrowserTypes.Safari || name === BrowserTypes.MobileSafari;
};
var isMobileSafariType = function isMobileSafariType(_ref25) {
  var name = _ref25.name;
  return name === BrowserTypes.MobileSafari;
};
var isOperaType = function isOperaType(_ref26) {
  var name = _ref26.name;
  return name === BrowserTypes.Opera;
};
var isIEType = function isIEType(_ref27) {
  var name = _ref27.name;
  return name === BrowserTypes.InternetExplorer || name === BrowserTypes.Ie;
};
var isMIUIType = function isMIUIType(_ref28) {
  var name = _ref28.name;
  return name === BrowserTypes.MIUI;
};
var isSamsungBrowserType = function isSamsungBrowserType(_ref29) {
  var name = _ref29.name;
  return name === BrowserTypes.SamsungBrowser;
};
var getBrowserFullVersion = function getBrowserFullVersion(_ref30) {
  var version = _ref30.version;
  return setDefaults(version);
};
var getBrowserVersion = function getBrowserVersion(_ref31) {
  var major = _ref31.major;
  return setDefaults(major);
};
var getBrowserName = function getBrowserName(_ref32) {
  var name = _ref32.name;
  return setDefaults(name);
}; // engine types

var getEngineName = function getEngineName(_ref33) {
  var name = _ref33.name;
  return setDefaults(name);
};
var getEngineVersion = function getEngineVersion(_ref34) {
  var version = _ref34.version;
  return setDefaults(version);
};
var isElectronType = function isElectronType() {
  var nav = getNavigatorInstance();
  var ua = nav && nav.userAgent && nav.userAgent.toLowerCase();
  return typeof ua === 'string' ? /electron/.test(ua) : false;
};
var isEdgeChromiumType = function isEdgeChromiumType(ua) {
  return typeof ua === 'string' && ua.indexOf('Edg/') !== -1;
};
var getIOS13 = function getIOS13() {
  var nav = getNavigatorInstance();
  return nav && (/iPad|iPhone|iPod/.test(nav.platform) || nav.platform === 'MacIntel' && nav.maxTouchPoints > 1) && !window.MSStream;
};
var getIPad13 = function getIPad13() {
  return isIOS13Check('iPad');
};
var getIphone13 = function getIphone13() {
  return isIOS13Check('iPhone');
};
var getIPod13 = function getIPod13() {
  return isIOS13Check('iPod');
};
var getUseragent = function getUseragent(userAg) {
  return setDefaults(userAg);
};

function buildSelectorsObject(options) {
  var _ref = options ? options : UAHelper,
      device = _ref.device,
      browser = _ref.browser,
      os = _ref.os,
      engine = _ref.engine,
      ua = _ref.ua;

  return {
    isSmartTV: isSmartTVType(device),
    isConsole: isConsoleType(device),
    isWearable: isWearableType(device),
    isEmbedded: isEmbeddedType(device),
    isMobileSafari: isMobileSafariType(browser) || getIPad13(),
    isChromium: isChromiumType(browser),
    isMobile: isMobileAndTabletType(device) || getIPad13(),
    isMobileOnly: isMobileType(device),
    isTablet: isTabletType(device) || getIPad13(),
    isBrowser: isBrowserType(device),
    isDesktop: isBrowserType(device),
    isAndroid: isAndroidType(os),
    isWinPhone: isWinPhoneType(os),
    isIOS: isIOSType(os) || getIPad13(),
    isChrome: isChromeType(browser),
    isFirefox: isFirefoxType(browser),
    isSafari: isSafariType(browser),
    isOpera: isOperaType(browser),
    isIE: isIEType(browser),
    osVersion: getOsVersion(os),
    osName: getOsName(os),
    fullBrowserVersion: getBrowserFullVersion(browser),
    browserVersion: getBrowserVersion(browser),
    browserName: getBrowserName(browser),
    mobileVendor: getMobileVendor(device),
    mobileModel: getMobileModel(device),
    engineName: getEngineName(engine),
    engineVersion: getEngineVersion(engine),
    getUA: getUseragent(ua),
    isEdge: isEdgeType(browser) || isEdgeChromiumType(ua),
    isYandex: isYandexType(browser),
    deviceType: getDeviceType(device),
    isIOS13: getIOS13(),
    isIPad13: getIPad13(),
    isIPhone13: getIphone13(),
    isIPod13: getIPod13(),
    isElectron: isElectronType(),
    isEdgeChromium: isEdgeChromiumType(ua),
    isLegacyEdge: isEdgeType(browser) && !isEdgeChromiumType(ua),
    isWindows: isWindowsType(os),
    isMacOs: isMacOsType(os),
    isMIUI: isMIUIType(browser),
    isSamsungBrowser: isSamsungBrowserType(browser)
  };
}

var isSmartTV = isSmartTVType(device);
var isConsole = isConsoleType(device);
var isWearable = isWearableType(device);
var isEmbedded = isEmbeddedType(device);
var isMobileSafari = isMobileSafariType(browser) || getIPad13();
var isChromium = isChromiumType(browser);
var isMobile = isMobileAndTabletType(device) || getIPad13();
var isMobileOnly = isMobileType(device);
var isTablet = isTabletType(device) || getIPad13();
var isBrowser = isBrowserType(device);
var isDesktop = isBrowserType(device);
var isAndroid = isAndroidType(os);
var isWinPhone = isWinPhoneType(os);
var isIOS = isIOSType(os) || getIPad13();
var isChrome = isChromeType(browser);
var isFirefox = isFirefoxType(browser);
var isSafari = isSafariType(browser);
var isOpera = isOperaType(browser);
var isIE = isIEType(browser);
var osVersion = getOsVersion(os);
var osName = getOsName(os);
var fullBrowserVersion = getBrowserFullVersion(browser);
var browserVersion = getBrowserVersion(browser);
var browserName = getBrowserName(browser);
var mobileVendor = getMobileVendor(device);
var mobileModel = getMobileModel(device);
var engineName = getEngineName(engine);
var engineVersion = getEngineVersion(engine);
var getUA = getUseragent(ua);
var isEdge = isEdgeType(browser) || isEdgeChromiumType(ua);
var isYandex = isYandexType(browser);
var deviceType = getDeviceType(device);
var isIOS13 = getIOS13();
var isIPad13 = getIPad13();
var isIPhone13 = getIphone13();
var isIPod13 = getIPod13();
var isElectron = isElectronType();
var isEdgeChromium = isEdgeChromiumType(ua);
var isLegacyEdge = isEdgeType(browser) && !isEdgeChromiumType(ua);
var isWindows = isWindowsType(os);
var isMacOs = isMacOsType(os);
var isMIUI = isMIUIType(browser);
var isSamsungBrowser = isSamsungBrowserType(browser);
var getSelectorsByUserAgent = function getSelectorsByUserAgent(userAgent) {
  if (!userAgent || typeof userAgent !== 'string') {
    console.error('No valid user agent string was provided');
    return;
  }

  var _UAHelper$parseUserAg = parseUserAgent(userAgent),
      device = _UAHelper$parseUserAg.device,
      browser = _UAHelper$parseUserAg.browser,
      os = _UAHelper$parseUserAg.os,
      engine = _UAHelper$parseUserAg.engine,
      ua = _UAHelper$parseUserAg.ua;

  return buildSelectorsObject({
    device: device,
    browser: browser,
    os: os,
    engine: engine,
    ua: ua
  });
};

var AndroidView = function AndroidView(_ref) {
  var renderWithFragment = _ref.renderWithFragment,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["renderWithFragment", "children"]);

  return isAndroid ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var BrowserView = function BrowserView(_ref2) {
  var renderWithFragment = _ref2.renderWithFragment,
      children = _ref2.children,
      props = _objectWithoutProperties(_ref2, ["renderWithFragment", "children"]);

  return isBrowser ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var IEView = function IEView(_ref3) {
  var renderWithFragment = _ref3.renderWithFragment,
      children = _ref3.children,
      props = _objectWithoutProperties(_ref3, ["renderWithFragment", "children"]);

  return isIE ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var IOSView = function IOSView(_ref4) {
  var renderWithFragment = _ref4.renderWithFragment,
      children = _ref4.children,
      props = _objectWithoutProperties(_ref4, ["renderWithFragment", "children"]);

  return isIOS ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var MobileView = function MobileView(_ref5) {
  var renderWithFragment = _ref5.renderWithFragment,
      children = _ref5.children,
      props = _objectWithoutProperties(_ref5, ["renderWithFragment", "children"]);

  return isMobile ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var TabletView = function TabletView(_ref6) {
  var renderWithFragment = _ref6.renderWithFragment,
      children = _ref6.children,
      props = _objectWithoutProperties(_ref6, ["renderWithFragment", "children"]);

  return isTablet ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var WinPhoneView = function WinPhoneView(_ref7) {
  var renderWithFragment = _ref7.renderWithFragment,
      children = _ref7.children,
      props = _objectWithoutProperties(_ref7, ["renderWithFragment", "children"]);

  return isWinPhone ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var MobileOnlyView = function MobileOnlyView(_ref8) {
  var renderWithFragment = _ref8.renderWithFragment,
      children = _ref8.children,
      viewClassName = _ref8.viewClassName,
      style = _ref8.style,
      props = _objectWithoutProperties(_ref8, ["renderWithFragment", "children", "viewClassName", "style"]);

  return isMobileOnly ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var SmartTVView = function SmartTVView(_ref9) {
  var renderWithFragment = _ref9.renderWithFragment,
      children = _ref9.children,
      props = _objectWithoutProperties(_ref9, ["renderWithFragment", "children"]);

  return isSmartTV ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var ConsoleView = function ConsoleView(_ref10) {
  var renderWithFragment = _ref10.renderWithFragment,
      children = _ref10.children,
      props = _objectWithoutProperties(_ref10, ["renderWithFragment", "children"]);

  return isConsole ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var WearableView = function WearableView(_ref11) {
  var renderWithFragment = _ref11.renderWithFragment,
      children = _ref11.children,
      props = _objectWithoutProperties(_ref11, ["renderWithFragment", "children"]);

  return isWearable ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var CustomView = function CustomView(_ref12) {
  var renderWithFragment = _ref12.renderWithFragment,
      children = _ref12.children,
      viewClassName = _ref12.viewClassName,
      style = _ref12.style,
      condition = _ref12.condition,
      props = _objectWithoutProperties(_ref12, ["renderWithFragment", "children", "viewClassName", "style", "condition"]);

  return condition ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};

function withOrientationChange(WrappedComponent) {
  return /*#__PURE__*/function (_React$Component) {
    _inherits(_class, _React$Component);

    function _class(props) {
      var _this;

      _classCallCheck(this, _class);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(_class).call(this, props));
      _this.isEventListenerAdded = false;
      _this.handleOrientationChange = _this.handleOrientationChange.bind(_assertThisInitialized(_this));
      _this.onOrientationChange = _this.onOrientationChange.bind(_assertThisInitialized(_this));
      _this.onPageLoad = _this.onPageLoad.bind(_assertThisInitialized(_this));
      _this.state = {
        isLandscape: false,
        isPortrait: false
      };
      return _this;
    }

    _createClass(_class, [{
      key: "handleOrientationChange",
      value: function handleOrientationChange() {
        if (!this.isEventListenerAdded) {
          this.isEventListenerAdded = true;
        }

        var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
        this.setState({
          isPortrait: orientation === 0,
          isLandscape: orientation === 90
        });
      }
    }, {
      key: "onOrientationChange",
      value: function onOrientationChange() {
        this.handleOrientationChange();
      }
    }, {
      key: "onPageLoad",
      value: function onPageLoad() {
        this.handleOrientationChange();
      }
    }, {
      key: "componentDidMount",
      value: function componentDidMount() {
        if ((typeof window === "undefined" ? "undefined" : _typeof(window)) !== undefined && isMobile) {
          if (!this.isEventListenerAdded) {
            this.handleOrientationChange();
            window.addEventListener("load", this.onPageLoad, false);
          } else {
            window.removeEventListener("load", this.onPageLoad, false);
          }

          window.addEventListener("resize", this.onOrientationChange, false);
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        window.removeEventListener("resize", this.onOrientationChange, false);
      }
    }, {
      key: "render",
      value: function render() {
        return React__default.createElement(WrappedComponent, _extends({}, this.props, {
          isLandscape: this.state.isLandscape,
          isPortrait: this.state.isPortrait
        }));
      }
    }]);

    return _class;
  }(React__default.Component);
}

function useMobileOrientation() {
  var _useState = React.useState(function () {
    var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
    return {
      isPortrait: orientation === 0,
      isLandscape: orientation === 90,
      orientation: orientation === 0 ? 'portrait' : 'landscape'
    };
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var handleOrientationChange = React.useCallback(function () {
    var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
    var next = {
      isPortrait: orientation === 0,
      isLandscape: orientation === 90,
      orientation: orientation === 0 ? 'portrait' : 'landscape'
    };
    state.orientation !== next.orientation && setState(next);
  }, [state.orientation]);
  React.useEffect(function () {
    if ((typeof window === "undefined" ? "undefined" : _typeof(window)) !== undefined && isMobile) {
      handleOrientationChange();
      window.addEventListener("load", handleOrientationChange, false);
      window.addEventListener("resize", handleOrientationChange, false);
    }

    return function () {
      window.removeEventListener("resize", handleOrientationChange, false);
      window.removeEventListener("load", handleOrientationChange, false);
    };
  }, [handleOrientationChange]);
  return state;
}

function useDeviceData(userAgent) {
  var hookUserAgent = userAgent ? userAgent : window.navigator.userAgent;
  return parseUserAgent(hookUserAgent);
}

function useDeviceSelectors(userAgent) {
  var hookUserAgent = userAgent ? userAgent : window.navigator.userAgent;
  var deviceData = useDeviceData(hookUserAgent);
  var selectors = buildSelectorsObject(deviceData);
  return [selectors, deviceData];
}

__webpack_unused_export__ = AndroidView;
__webpack_unused_export__ = BrowserTypes;
__webpack_unused_export__ = BrowserView;
__webpack_unused_export__ = ConsoleView;
__webpack_unused_export__ = CustomView;
__webpack_unused_export__ = IEView;
__webpack_unused_export__ = IOSView;
__webpack_unused_export__ = MobileOnlyView;
__webpack_unused_export__ = MobileView;
__webpack_unused_export__ = OsTypes;
__webpack_unused_export__ = SmartTVView;
__webpack_unused_export__ = TabletView;
__webpack_unused_export__ = WearableView;
__webpack_unused_export__ = WinPhoneView;
__webpack_unused_export__ = browserName;
__webpack_unused_export__ = browserVersion;
__webpack_unused_export__ = deviceDetect;
__webpack_unused_export__ = deviceType;
__webpack_unused_export__ = engineName;
__webpack_unused_export__ = engineVersion;
__webpack_unused_export__ = fullBrowserVersion;
__webpack_unused_export__ = getSelectorsByUserAgent;
__webpack_unused_export__ = getUA;
exports.Dt = isAndroid;
__webpack_unused_export__ = isBrowser;
__webpack_unused_export__ = isChrome;
__webpack_unused_export__ = isChromium;
__webpack_unused_export__ = isConsole;
exports.nI = isDesktop;
__webpack_unused_export__ = isEdge;
__webpack_unused_export__ = isEdgeChromium;
__webpack_unused_export__ = isElectron;
__webpack_unused_export__ = isEmbedded;
__webpack_unused_export__ = isFirefox;
__webpack_unused_export__ = isIE;
exports.gn = isIOS;
__webpack_unused_export__ = isIOS13;
__webpack_unused_export__ = isIPad13;
__webpack_unused_export__ = isIPhone13;
__webpack_unused_export__ = isIPod13;
__webpack_unused_export__ = isLegacyEdge;
__webpack_unused_export__ = isMIUI;
__webpack_unused_export__ = isMacOs;
exports.tq = isMobile;
__webpack_unused_export__ = isMobileOnly;
__webpack_unused_export__ = isMobileSafari;
__webpack_unused_export__ = isOpera;
__webpack_unused_export__ = isSafari;
__webpack_unused_export__ = isSamsungBrowser;
__webpack_unused_export__ = isSmartTV;
exports.Em = isTablet;
__webpack_unused_export__ = isWearable;
__webpack_unused_export__ = isWinPhone;
__webpack_unused_export__ = isWindows;
__webpack_unused_export__ = isYandex;
__webpack_unused_export__ = mobileModel;
__webpack_unused_export__ = mobileVendor;
__webpack_unused_export__ = osName;
__webpack_unused_export__ = osVersion;
__webpack_unused_export__ = parseUserAgent;
__webpack_unused_export__ = setUserAgent;
__webpack_unused_export__ = useDeviceData;
__webpack_unused_export__ = useDeviceSelectors;
__webpack_unused_export__ = useMobileOrientation;
__webpack_unused_export__ = withOrientationChange;


/***/ }),

/***/ 69921:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b=60103,c=60106,d=60107,e=60108,f=60114,g=60109,h=60110,k=60112,l=60113,m=60120,n=60115,p=60116,q=60121,r=60122,u=60117,v=60129,w=60131;
if("function"===typeof Symbol&&Symbol.for){var x=Symbol.for;b=x("react.element");c=x("react.portal");d=x("react.fragment");e=x("react.strict_mode");f=x("react.profiler");g=x("react.provider");h=x("react.context");k=x("react.forward_ref");l=x("react.suspense");m=x("react.suspense_list");n=x("react.memo");p=x("react.lazy");q=x("react.block");r=x("react.server.block");u=x("react.fundamental");v=x("react.debug_trace_mode");w=x("react.legacy_hidden")}
function y(a){if("object"===typeof a&&null!==a){var t=a.$$typeof;switch(t){case b:switch(a=a.type,a){case d:case f:case e:case l:case m:return a;default:switch(a=a&&a.$$typeof,a){case h:case k:case p:case n:case g:return a;default:return t}}case c:return t}}}var z=g,A=b,B=k,C=d,D=p,E=n,F=c,G=f,H=e,I=l;__webpack_unused_export__=h;__webpack_unused_export__=z;__webpack_unused_export__=A;__webpack_unused_export__=B;__webpack_unused_export__=C;__webpack_unused_export__=D;__webpack_unused_export__=E;__webpack_unused_export__=F;__webpack_unused_export__=G;__webpack_unused_export__=H;
__webpack_unused_export__=I;__webpack_unused_export__=function(){return!1};__webpack_unused_export__=function(){return!1};__webpack_unused_export__=function(a){return y(a)===h};__webpack_unused_export__=function(a){return y(a)===g};__webpack_unused_export__=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===b};__webpack_unused_export__=function(a){return y(a)===k};__webpack_unused_export__=function(a){return y(a)===d};__webpack_unused_export__=function(a){return y(a)===p};__webpack_unused_export__=function(a){return y(a)===n};
__webpack_unused_export__=function(a){return y(a)===c};__webpack_unused_export__=function(a){return y(a)===f};__webpack_unused_export__=function(a){return y(a)===e};__webpack_unused_export__=function(a){return y(a)===l};exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===d||a===f||a===v||a===e||a===l||a===m||a===w||"object"===typeof a&&null!==a&&(a.$$typeof===p||a.$$typeof===n||a.$$typeof===g||a.$$typeof===h||a.$$typeof===k||a.$$typeof===u||a.$$typeof===q||a[0]===r)?!0:!1};
exports.typeOf=y;


/***/ }),

/***/ 59864:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(69921);
} else {}


/***/ }),

/***/ 98885:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ esm_Transition; }
});

// UNUSED EXPORTS: ENTERED, ENTERING, EXITED, EXITING, UNMOUNTED

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
var inheritsLoose = __webpack_require__(94578);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
;// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/config.js
/* harmony default export */ var config = ({
  disabled: false
});
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/TransitionGroupContext.js
var TransitionGroupContext = __webpack_require__(220);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/utils/reflow.js
var reflow = __webpack_require__(59391);
;// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/Transition.js









var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

var Transition = /*#__PURE__*/function (_React$Component) {
  (0,inheritsLoose/* default */.Z)(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  } // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }
  ;

  var _proto = Transition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      if (nextStatus === ENTERING) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var node = this.props.nodeRef ? this.props.nodeRef.current : react_dom.findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
          // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
          // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.

          if (node) (0,reflow/* forceReflow */.Q)(node);
        }

        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;

    var _ref2 = this.props.nodeRef ? [appearing] : [react_dom.findDOMNode(this), appearing],
        maybeNode = _ref2[0],
        maybeAppearing = _ref2[1];

    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter || config.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(maybeNode);
      });
      return;
    }

    this.props.onEnter(maybeNode, maybeAppearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(maybeNode, maybeAppearing);

      _this2.onTransitionEnd(enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(maybeNode, maybeAppearing);
        });
      });
    });
  };

  _proto.performExit = function performExit() {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    var maybeNode = this.props.nodeRef ? undefined : react_dom.findDOMNode(this); // no exit animation skip right to EXITED

    if (!exit || config.disabled) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(maybeNode);
      });
      return;
    }

    this.props.onExit(maybeNode);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(maybeNode);

      _this3.onTransitionEnd(timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(maybeNode);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
    this.setNextCallback(handler);
    var node = this.props.nodeRef ? this.props.nodeRef.current : react_dom.findDOMNode(this);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback],
          maybeNode = _ref3[0],
          maybeNextCallback = _ref3[1];

      this.props.addEndListener(maybeNode, maybeNextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        _in = _this$props.in,
        _mountOnEnter = _this$props.mountOnEnter,
        _unmountOnExit = _this$props.unmountOnExit,
        _appear = _this$props.appear,
        _enter = _this$props.enter,
        _exit = _this$props.exit,
        _timeout = _this$props.timeout,
        _addEndListener = _this$props.addEndListener,
        _onEnter = _this$props.onEnter,
        _onEntering = _this$props.onEntering,
        _onEntered = _this$props.onEntered,
        _onExit = _this$props.onExit,
        _onExiting = _this$props.onExiting,
        _onExited = _this$props.onExited,
        _nodeRef = _this$props.nodeRef,
        childProps = (0,objectWithoutPropertiesLoose/* default */.Z)(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);

    return (
      /*#__PURE__*/
      // allows for nested Transitions
      react.createElement(TransitionGroupContext/* default.Provider */.Z.Provider, {
        value: null
      }, typeof children === 'function' ? children(status, childProps) : react.cloneElement(react.Children.only(children), childProps))
    );
  };

  return Transition;
}(react.Component);

Transition.contextType = TransitionGroupContext/* default */.Z;
Transition.propTypes =  false ? 0 : {}; // Name the function so it is clearer in the documentation

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
/* harmony default export */ var esm_Transition = (Transition);

/***/ }),

/***/ 220:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/* harmony default export */ __webpack_exports__["Z"] = (react__WEBPACK_IMPORTED_MODULE_0__.createContext(null));

/***/ }),

/***/ 59391:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ forceReflow; }
/* harmony export */ });
var forceReflow = function forceReflow(node) {
  return node.scrollTop;
};

/***/ }),

/***/ 96774:
/***/ (function(module) {

//

module.exports = function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (ret !== void 0) {
    return !!ret;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

  // Test for A's keys different from B.
  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];

    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (ret === false || (ret === void 0 && valueA !== valueB)) {
      return false;
    }
  }

  return true;
};


/***/ }),

/***/ 186:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "f6": function() { return /* binding */ Le; },
  "ZP": function() { return /* binding */ styled_components_browser_esm; }
});

// UNUSED EXPORTS: ServerStyleSheet, StyleSheetConsumer, StyleSheetContext, StyleSheetManager, ThemeConsumer, ThemeContext, __PRIVATE__, createGlobalStyle, css, isStyledComponent, keyframes, useTheme, version, withTheme

// EXTERNAL MODULE: ./node_modules/react-is/index.js
var react_is = __webpack_require__(59864);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/shallowequal/index.js
var shallowequal = __webpack_require__(96774);
var shallowequal_default = /*#__PURE__*/__webpack_require__.n(shallowequal);
;// CONCATENATED MODULE: ./node_modules/@emotion/stylis/dist/stylis.browser.esm.js
function stylis_min (W) {
  function M(d, c, e, h, a) {
    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
      g = e.charCodeAt(l);
      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);

      if (0 === b + n + v + m) {
        if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
          switch (g) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;

            default:
              f += e.charAt(l);
          }

          g = 59;
        }

        switch (g) {
          case 123:
            f = f.trim();
            q = f.charCodeAt(0);
            k = 1;

            for (t = ++l; l < B;) {
              switch (g = e.charCodeAt(l)) {
                case 123:
                  k++;
                  break;

                case 125:
                  k--;
                  break;

                case 47:
                  switch (g = e.charCodeAt(l + 1)) {
                    case 42:
                    case 47:
                      a: {
                        for (u = l + 1; u < J; ++u) {
                          switch (e.charCodeAt(u)) {
                            case 47:
                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                l = u + 1;
                                break a;
                              }

                              break;

                            case 10:
                              if (47 === g) {
                                l = u + 1;
                                break a;
                              }

                          }
                        }

                        l = u;
                      }

                  }

                  break;

                case 91:
                  g++;

                case 40:
                  g++;

                case 34:
                case 39:
                  for (; l++ < J && e.charCodeAt(l) !== g;) {
                  }

              }

              if (0 === k) break;
              l++;
            }

            k = e.substring(t, l);
            0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));

            switch (q) {
              case 64:
                0 < r && (f = f.replace(N, ''));
                g = f.charCodeAt(1);

                switch (g) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    r = c;
                    break;

                  default:
                    r = O;
                }

                k = M(c, r, k, g, a + 1);
                t = k.length;
                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                if (0 < t) switch (g) {
                  case 115:
                    f = f.replace(da, ea);

                  case 100:
                  case 109:
                  case 45:
                    k = f + '{' + k + '}';
                    break;

                  case 107:
                    f = f.replace(fa, '$1 $2');
                    k = f + '{' + k + '}';
                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                    break;

                  default:
                    k = f + k, 112 === h && (k = (p += k, ''));
                } else k = '';
                break;

              default:
                k = M(c, X(c, f, I), k, h, a + 1);
            }

            F += k;
            k = I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
            break;

          case 125:
          case 59:
            f = (0 < r ? f.replace(N, '') : f).trim();
            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
              case 0:
                break;

              case 64:
                if (105 === g || 99 === g) {
                  G += f + e.charAt(l);
                  break;
                }

              default:
                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
            }
            I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
        }
      }

      switch (g) {
        case 13:
        case 10:
          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
          z = 1;
          D++;
          break;

        case 59:
        case 125:
          if (0 === b + n + v + m) {
            z++;
            break;
          }

        default:
          z++;
          y = e.charAt(l);

          switch (g) {
            case 9:
            case 32:
              if (0 === n + m + b) switch (x) {
                case 44:
                case 58:
                case 9:
                case 32:
                  y = '';
                  break;

                default:
                  32 !== g && (y = ' ');
              }
              break;

            case 0:
              y = '\\0';
              break;

            case 12:
              y = '\\f';
              break;

            case 11:
              y = '\\v';
              break;

            case 38:
              0 === n + b + m && (r = I = 1, y = '\f' + y);
              break;

            case 108:
              if (0 === n + b + m + E && 0 < u) switch (l - u) {
                case 2:
                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);

                case 8:
                  111 === K && (E = K);
              }
              break;

            case 58:
              0 === n + b + m && (u = l);
              break;

            case 44:
              0 === b + v + n + m && (r = 1, y += '\r');
              break;

            case 34:
            case 39:
              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
              break;

            case 91:
              0 === n + b + v && m++;
              break;

            case 93:
              0 === n + b + v && m--;
              break;

            case 41:
              0 === n + b + m && v--;
              break;

            case 40:
              if (0 === n + b + m) {
                if (0 === q) switch (2 * x + 3 * K) {
                  case 533:
                    break;

                  default:
                    q = 1;
                }
                v++;
              }

              break;

            case 64:
              0 === b + v + n + m + u + k && (k = 1);
              break;

            case 42:
            case 47:
              if (!(0 < n + m + v)) switch (b) {
                case 0:
                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
                    case 235:
                      b = 47;
                      break;

                    case 220:
                      t = l, b = 42;
                  }

                  break;

                case 42:
                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
              }
          }

          0 === b && (f += y);
      }

      K = x;
      x = g;
      l++;
    }

    t = p.length;

    if (0 < t) {
      r = c;
      if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
      p = r.join(',') + '{' + p + '}';

      if (0 !== w * E) {
        2 !== w || L(p, 2) || (E = 0);

        switch (E) {
          case 111:
            p = p.replace(ha, ':-moz-$1') + p;
            break;

          case 112:
            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
        }

        E = 0;
      }
    }

    return G + p + F;
  }

  function X(d, c, e) {
    var h = c.trim().split(ia);
    c = h;
    var a = h.length,
        m = d.length;

    switch (m) {
      case 0:
      case 1:
        var b = 0;

        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
          c[b] = Z(d, c[b], e).trim();
        }

        break;

      default:
        var v = b = 0;

        for (c = []; b < a; ++b) {
          for (var n = 0; n < m; ++n) {
            c[v++] = Z(d[n] + ' ', h[b], e).trim();
          }
        }

    }

    return c;
  }

  function Z(d, c, e) {
    var h = c.charCodeAt(0);
    33 > h && (h = (c = c.trim()).charCodeAt(0));

    switch (h) {
      case 38:
        return c.replace(F, '$1' + d.trim());

      case 58:
        return d.trim() + c.replace(F, '$1' + d.trim());

      default:
        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
    }

    return d + c;
  }

  function P(d, c, e, h) {
    var a = d + ';',
        m = 2 * c + 3 * e + 4 * h;

    if (944 === m) {
      d = a.indexOf(':', 9) + 1;
      var b = a.substring(d, a.length - 1).trim();
      b = a.substring(0, d).trim() + b + ';';
      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
    }

    if (0 === w || 2 === w && !L(a, 1)) return a;

    switch (m) {
      case 1015:
        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;

      case 951:
        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;

      case 963:
        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;

      case 1009:
        if (100 !== a.charCodeAt(4)) break;

      case 969:
      case 942:
        return '-webkit-' + a + a;

      case 978:
        return '-webkit-' + a + '-moz-' + a + a;

      case 1019:
      case 983:
        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;

      case 883:
        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
        if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
        break;

      case 932:
        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
          case 103:
            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;

          case 115:
            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;

          case 98:
            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
        }
        return '-webkit-' + a + '-ms-' + a + a;

      case 964:
        return '-webkit-' + a + '-ms-flex-' + a + a;

      case 1023:
        if (99 !== a.charCodeAt(8)) break;
        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;

      case 1005:
        return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;

      case 1e3:
        b = a.substring(13).trim();
        c = b.indexOf('-') + 1;

        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
          case 226:
            b = a.replace(G, 'tb');
            break;

          case 232:
            b = a.replace(G, 'tb-rl');
            break;

          case 220:
            b = a.replace(G, 'lr');
            break;

          default:
            return a;
        }

        return '-webkit-' + a + '-ms-' + b + a;

      case 1017:
        if (-1 === a.indexOf('sticky', 9)) break;

      case 975:
        c = (a = d).length - 10;
        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();

        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
          case 203:
            if (111 > b.charCodeAt(8)) break;

          case 115:
            a = a.replace(b, '-webkit-' + b) + ';' + a;
            break;

          case 207:
          case 102:
            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
        }

        return a + ';';

      case 938:
        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
          case 105:
            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;

          case 115:
            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;

          default:
            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
        }
        break;

      case 973:
      case 989:
        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;

      case 931:
      case 953:
        if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
        break;

      case 962:
        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
    }

    return a;
  }

  function L(d, c) {
    var e = d.indexOf(1 === c ? ':' : '{'),
        h = d.substring(0, 3 !== c ? e : 10);
    e = d.substring(e + 1, d.length - 1);
    return R(2 !== c ? h : h.replace(na, '$1'), e, c);
  }

  function ea(d, c) {
    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
    return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
  }

  function H(d, c, e, h, a, m, b, v, n, q) {
    for (var g = 0, x = c, w; g < A; ++g) {
      switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;

        default:
          x = w;
      }
    }

    if (x !== c) return x;
  }

  function T(d) {
    switch (d) {
      case void 0:
      case null:
        A = S.length = 0;
        break;

      default:
        if ('function' === typeof d) S[A++] = d;else if ('object' === typeof d) for (var c = 0, e = d.length; c < e; ++c) {
          T(d[c]);
        } else Y = !!d | 0;
    }

    return T;
  }

  function U(d) {
    d = d.prefix;
    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
    return U;
  }

  function B(d, c) {
    var e = d;
    33 > e.charCodeAt(0) && (e = e.trim());
    V = e;
    e = [V];

    if (0 < A) {
      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
      void 0 !== h && 'string' === typeof h && (c = h);
    }

    var a = M(O, e, c, 0, 0);
    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
    V = '';
    E = 0;
    z = D = 1;
    return a;
  }

  var ca = /^\0+/g,
      N = /[\0\r\f]/g,
      aa = /: */g,
      ka = /zoo|gra/,
      ma = /([,: ])(transform)/g,
      ia = /,\r+?/g,
      F = /([\t\r\n ])*\f?&/g,
      fa = /@(k\w+)\s*(\S*)\s*/,
      Q = /::(place)/g,
      ha = /:(read-only)/g,
      G = /[svh]\w+-[tblr]{2}/,
      da = /\(\s*(.*)\s*\)/g,
      oa = /([\s\S]*?);/g,
      ba = /-self|flex-/g,
      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
      la = /stretch|:\s*\w+\-(?:conte|avail)/,
      ja = /([^-])(image-set\()/,
      z = 1,
      D = 1,
      E = 0,
      w = 1,
      O = [],
      S = [],
      A = 0,
      R = null,
      Y = 0,
      V = '';
  B.use = T;
  B.set = U;
  void 0 !== W && U(W);
  return B;
}

/* harmony default export */ var stylis_browser_esm = (stylis_min);

;// CONCATENATED MODULE: ./node_modules/@emotion/unitless/dist/unitless.browser.esm.js
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

/* harmony default export */ var unitless_browser_esm = (unitlessKeys);

// EXTERNAL MODULE: ./node_modules/@emotion/is-prop-valid/dist/emotion-is-prop-valid.esm.js
var emotion_is_prop_valid_esm = __webpack_require__(71068);
// EXTERNAL MODULE: ./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(8679);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
;// CONCATENATED MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js
/* provided dependency */ var process = __webpack_require__(83454);
function y(){return(y=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e}).apply(this,arguments)}var v=function(e,t){for(var n=[e[0]],r=0,o=t.length;r<o;r+=1)n.push(t[r],e[r+1]);return n},g=function(t){return null!==t&&"object"==typeof t&&"[object Object]"===(t.toString?t.toString():Object.prototype.toString.call(t))&&!(0,react_is.typeOf)(t)},S=Object.freeze([]),w=Object.freeze({});function E(e){return"function"==typeof e}function b(e){return false||e.displayName||e.name||"Component"}function _(e){return e&&"string"==typeof e.styledComponentId}var N="undefined"!=typeof process&&void 0!==process.env&&(process.env.REACT_APP_SC_ATTR||process.env.SC_ATTR)||"data-styled",A="5.3.11",C="undefined"!=typeof window&&"HTMLElement"in window,I=Boolean("boolean"==typeof SC_DISABLE_SPEEDY?SC_DISABLE_SPEEDY:"undefined"!=typeof process&&void 0!==process.env&&(void 0!==process.env.REACT_APP_SC_DISABLE_SPEEDY&&""!==process.env.REACT_APP_SC_DISABLE_SPEEDY?"false"!==process.env.REACT_APP_SC_DISABLE_SPEEDY&&process.env.REACT_APP_SC_DISABLE_SPEEDY:void 0!==process.env.SC_DISABLE_SPEEDY&&""!==process.env.SC_DISABLE_SPEEDY?"false"!==process.env.SC_DISABLE_SPEEDY&&process.env.SC_DISABLE_SPEEDY:"production"!=="production")),P={},O= false?0:{};function R(){for(var e=arguments.length<=0?void 0:arguments[0],t=[],n=1,r=arguments.length;n<r;n+=1)t.push(n<0||arguments.length<=n?void 0:arguments[n]);return t.forEach((function(t){e=e.replace(/%[a-z]/,t)})),e}function D(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];throw true?new Error("An error occurred. See https://git.io/JUIaE#"+e+" for more information."+(n.length>0?" Args: "+n.join(", "):"")):0}var j=function(){function e(e){this.groupSizes=new Uint32Array(512),this.length=512,this.tag=e}var t=e.prototype;return t.indexOfGroup=function(e){for(var t=0,n=0;n<e;n++)t+=this.groupSizes[n];return t},t.insertRules=function(e,t){if(e>=this.groupSizes.length){for(var n=this.groupSizes,r=n.length,o=r;e>=o;)(o<<=1)<0&&D(16,""+e);this.groupSizes=new Uint32Array(o),this.groupSizes.set(n),this.length=o;for(var s=r;s<o;s++)this.groupSizes[s]=0}for(var i=this.indexOfGroup(e+1),a=0,c=t.length;a<c;a++)this.tag.insertRule(i,t[a])&&(this.groupSizes[e]++,i++)},t.clearGroup=function(e){if(e<this.length){var t=this.groupSizes[e],n=this.indexOfGroup(e),r=n+t;this.groupSizes[e]=0;for(var o=n;o<r;o++)this.tag.deleteRule(n)}},t.getGroup=function(e){var t="";if(e>=this.length||0===this.groupSizes[e])return t;for(var n=this.groupSizes[e],r=this.indexOfGroup(e),o=r+n,s=r;s<o;s++)t+=this.tag.getRule(s)+"/*!sc*/\n";return t},e}(),T=new Map,x=new Map,k=1,V=function(e){if(T.has(e))return T.get(e);for(;x.has(k);)k++;var t=k++;return false&&0,T.set(e,t),x.set(t,e),t},B=function(e){return x.get(e)},z=function(e,t){t>=k&&(k=t+1),T.set(e,t),x.set(t,e)},M="style["+N+'][data-styled-version="5.3.11"]',G=new RegExp("^"+N+'\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'),L=function(e,t,n){for(var r,o=n.split(","),s=0,i=o.length;s<i;s++)(r=o[s])&&e.registerName(t,r)},F=function(e,t){for(var n=(t.textContent||"").split("/*!sc*/\n"),r=[],o=0,s=n.length;o<s;o++){var i=n[o].trim();if(i){var a=i.match(G);if(a){var c=0|parseInt(a[1],10),u=a[2];0!==c&&(z(u,c),L(e,u,a[3]),e.getTag().insertRules(c,r)),r.length=0}else r.push(i)}}},Y=function(){return true?__webpack_require__.nc:0},q=function(e){var t=document.head,n=e||t,r=document.createElement("style"),o=function(e){for(var t=e.childNodes,n=t.length;n>=0;n--){var r=t[n];if(r&&1===r.nodeType&&r.hasAttribute(N))return r}}(n),s=void 0!==o?o.nextSibling:null;r.setAttribute(N,"active"),r.setAttribute("data-styled-version","5.3.11");var i=Y();return i&&r.setAttribute("nonce",i),n.insertBefore(r,s),r},H=function(){function e(e){var t=this.element=q(e);t.appendChild(document.createTextNode("")),this.sheet=function(e){if(e.sheet)return e.sheet;for(var t=document.styleSheets,n=0,r=t.length;n<r;n++){var o=t[n];if(o.ownerNode===e)return o}D(17)}(t),this.length=0}var t=e.prototype;return t.insertRule=function(e,t){try{return this.sheet.insertRule(t,e),this.length++,!0}catch(e){return!1}},t.deleteRule=function(e){this.sheet.deleteRule(e),this.length--},t.getRule=function(e){var t=this.sheet.cssRules[e];return void 0!==t&&"string"==typeof t.cssText?t.cssText:""},e}(),$=function(){function e(e){var t=this.element=q(e);this.nodes=t.childNodes,this.length=0}var t=e.prototype;return t.insertRule=function(e,t){if(e<=this.length&&e>=0){var n=document.createTextNode(t),r=this.nodes[e];return this.element.insertBefore(n,r||null),this.length++,!0}return!1},t.deleteRule=function(e){this.element.removeChild(this.nodes[e]),this.length--},t.getRule=function(e){return e<this.length?this.nodes[e].textContent:""},e}(),W=function(){function e(e){this.rules=[],this.length=0}var t=e.prototype;return t.insertRule=function(e,t){return e<=this.length&&(this.rules.splice(e,0,t),this.length++,!0)},t.deleteRule=function(e){this.rules.splice(e,1),this.length--},t.getRule=function(e){return e<this.length?this.rules[e]:""},e}(),U=C,J={isServer:!C,useCSSOMInjection:!I},X=function(){function e(e,t,n){void 0===e&&(e=w),void 0===t&&(t={}),this.options=y({},J,{},e),this.gs=t,this.names=new Map(n),this.server=!!e.isServer,!this.server&&C&&U&&(U=!1,function(e){for(var t=document.querySelectorAll(M),n=0,r=t.length;n<r;n++){var o=t[n];o&&"active"!==o.getAttribute(N)&&(F(e,o),o.parentNode&&o.parentNode.removeChild(o))}}(this))}e.registerId=function(e){return V(e)};var t=e.prototype;return t.reconstructWithOptions=function(t,n){return void 0===n&&(n=!0),new e(y({},this.options,{},t),this.gs,n&&this.names||void 0)},t.allocateGSInstance=function(e){return this.gs[e]=(this.gs[e]||0)+1},t.getTag=function(){return this.tag||(this.tag=(n=(t=this.options).isServer,r=t.useCSSOMInjection,o=t.target,e=n?new W(o):r?new H(o):new $(o),new j(e)));var e,t,n,r,o},t.hasNameForId=function(e,t){return this.names.has(e)&&this.names.get(e).has(t)},t.registerName=function(e,t){if(V(e),this.names.has(e))this.names.get(e).add(t);else{var n=new Set;n.add(t),this.names.set(e,n)}},t.insertRules=function(e,t,n){this.registerName(e,t),this.getTag().insertRules(V(e),n)},t.clearNames=function(e){this.names.has(e)&&this.names.get(e).clear()},t.clearRules=function(e){this.getTag().clearGroup(V(e)),this.clearNames(e)},t.clearTag=function(){this.tag=void 0},t.toString=function(){return function(e){for(var t=e.getTag(),n=t.length,r="",o=0;o<n;o++){var s=B(o);if(void 0!==s){var i=e.names.get(s),a=t.getGroup(o);if(i&&a&&i.size){var c=N+".g"+o+'[id="'+s+'"]',u="";void 0!==i&&i.forEach((function(e){e.length>0&&(u+=e+",")})),r+=""+a+c+'{content:"'+u+'"}/*!sc*/\n'}}}return r}(this)},e}(),Z=/(a)(d)/gi,K=function(e){return String.fromCharCode(e+(e>25?39:97))};function Q(e){var t,n="";for(t=Math.abs(e);t>52;t=t/52|0)n=K(t%52)+n;return(K(t%52)+n).replace(Z,"$1-$2")}var ee=function(e,t){for(var n=t.length;n;)e=33*e^t.charCodeAt(--n);return e},te=function(e){return ee(5381,e)};function ne(e){for(var t=0;t<e.length;t+=1){var n=e[t];if(E(n)&&!_(n))return!1}return!0}var re=te("5.3.11"),oe=function(){function e(e,t,n){this.rules=e,this.staticRulesId="",this.isStatic= true&&(void 0===n||n.isStatic)&&ne(e),this.componentId=t,this.baseHash=ee(re,t),this.baseStyle=n,X.registerId(t)}return e.prototype.generateAndInjectStyles=function(e,t,n){var r=this.componentId,o=[];if(this.baseStyle&&o.push(this.baseStyle.generateAndInjectStyles(e,t,n)),this.isStatic&&!n.hash)if(this.staticRulesId&&t.hasNameForId(r,this.staticRulesId))o.push(this.staticRulesId);else{var s=_e(this.rules,e,t,n).join(""),i=Q(ee(this.baseHash,s)>>>0);if(!t.hasNameForId(r,i)){var a=n(s,"."+i,void 0,r);t.insertRules(r,i,a)}o.push(i),this.staticRulesId=i}else{for(var c=this.rules.length,u=ee(this.baseHash,n.hash),l="",d=0;d<c;d++){var h=this.rules[d];if("string"==typeof h)l+=h, false&&(0);else if(h){var p=_e(h,e,t,n),f=Array.isArray(p)?p.join(""):p;u=ee(u,f+d),l+=f}}if(l){var m=Q(u>>>0);if(!t.hasNameForId(r,m)){var y=n(l,"."+m,void 0,r);t.insertRules(r,m,y)}o.push(m)}}return o.join(" ")},e}(),se=/^\s*\/\/.*$/gm,ie=[":","[",".","#"];function ae(e){var t,n,r,o,s=void 0===e?w:e,i=s.options,a=void 0===i?w:i,c=s.plugins,u=void 0===c?S:c,l=new stylis_browser_esm(a),d=[],p=function(e){function t(t){if(t)try{e(t+"}")}catch(e){}}return function(n,r,o,s,i,a,c,u,l,d){switch(n){case 1:if(0===l&&64===r.charCodeAt(0))return e(r+";"),"";break;case 2:if(0===u)return r+"/*|*/";break;case 3:switch(u){case 102:case 112:return e(o[0]+r),"";default:return r+(0===d?"/*|*/":"")}case-2:r.split("/*|*/}").forEach(t)}}}((function(e){d.push(e)})),f=function(e,r,s){return 0===r&&-1!==ie.indexOf(s[n.length])||s.match(o)?e:"."+t};function m(e,s,i,a){void 0===a&&(a="&");var c=e.replace(se,""),u=s&&i?i+" "+s+" { "+c+" }":c;return t=a,n=s,r=new RegExp("\\"+n+"\\b","g"),o=new RegExp("(\\"+n+"\\b){2,}"),l(i||!s?"":s,u)}return l.use([].concat(u,[function(e,t,o){2===e&&o.length&&o[0].lastIndexOf(n)>0&&(o[0]=o[0].replace(r,f))},p,function(e){if(-2===e){var t=d;return d=[],t}}])),m.hash=u.length?u.reduce((function(e,t){return t.name||D(15),ee(e,t.name)}),5381).toString():"",m}var ce=react.createContext(),ue=ce.Consumer,le=react.createContext(),de=(le.Consumer,new X),he=ae();function pe(){return (0,react.useContext)(ce)||de}function fe(){return (0,react.useContext)(le)||he}function me(e){var t=(0,react.useState)(e.stylisPlugins),n=t[0],s=t[1],c=pe(),u=(0,react.useMemo)((function(){var t=c;return e.sheet?t=e.sheet:e.target&&(t=t.reconstructWithOptions({target:e.target},!1)),e.disableCSSOMInjection&&(t=t.reconstructWithOptions({useCSSOMInjection:!1})),t}),[e.disableCSSOMInjection,e.sheet,e.target]),l=(0,react.useMemo)((function(){return ae({options:{prefix:!e.disableVendorPrefixes},plugins:n})}),[e.disableVendorPrefixes,n]);return (0,react.useEffect)((function(){shallowequal_default()(n,e.stylisPlugins)||s(e.stylisPlugins)}),[e.stylisPlugins]),react.createElement(ce.Provider,{value:u},react.createElement(le.Provider,{value:l}, false?0:e.children))}var ye=function(){function e(e,t){var n=this;this.inject=function(e,t){void 0===t&&(t=he);var r=n.name+t.hash;e.hasNameForId(n.id,r)||e.insertRules(n.id,r,t(n.rules,r,"@keyframes"))},this.toString=function(){return D(12,String(n.name))},this.name=e,this.id="sc-keyframes-"+e,this.rules=t}return e.prototype.getName=function(e){return void 0===e&&(e=he),this.name+e.hash},e}(),ve=/([A-Z])/,ge=/([A-Z])/g,Se=/^ms-/,we=function(e){return"-"+e.toLowerCase()};function Ee(e){return ve.test(e)?e.replace(ge,we).replace(Se,"-ms-"):e}var be=function(e){return null==e||!1===e||""===e};function _e(e,n,r,o){if(Array.isArray(e)){for(var s,i=[],a=0,c=e.length;a<c;a+=1)""!==(s=_e(e[a],n,r,o))&&(Array.isArray(s)?i.push.apply(i,s):i.push(s));return i}if(be(e))return"";if(_(e))return"."+e.styledComponentId;if(E(e)){if("function"!=typeof(l=e)||l.prototype&&l.prototype.isReactComponent||!n)return e;var u=e(n);return false&&0,_e(u,n,r,o)}var l;return e instanceof ye?r?(e.inject(r,o),e.getName(o)):e:g(e)?function e(t,n){var r,o,s=[];for(var i in t)t.hasOwnProperty(i)&&!be(t[i])&&(Array.isArray(t[i])&&t[i].isCss||E(t[i])?s.push(Ee(i)+":",t[i],";"):g(t[i])?s.push.apply(s,e(t[i],i)):s.push(Ee(i)+": "+(r=i,null==(o=t[i])||"boolean"==typeof o||""===o?"":"number"!=typeof o||0===o||r in unitless_browser_esm||r.startsWith("--")?String(o).trim():o+"px")+";"));return n?[n+" {"].concat(s,["}"]):s}(e):e.toString()}var Ne=function(e){return Array.isArray(e)&&(e.isCss=!0),e};function Ae(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];return E(e)||g(e)?Ne(_e(v(S,[e].concat(n)))):0===n.length&&1===e.length&&"string"==typeof e[0]?e:Ne(_e(v(e,n)))}var Ce=/invalid hook call/i,Ie=new Set,Pe=function(e,t){if(false){ var o, n, r; }},Oe=function(e,t,n){return void 0===n&&(n=w),e.theme!==n.theme&&e.theme||t||n.theme},Re=/[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g,De=/(^-|-$)/g;function je(e){return e.replace(Re,"-").replace(De,"")}var Te=function(e){return Q(te(e)>>>0)};function xe(e){return"string"==typeof e&&( true||0)}var ke=function(e){return"function"==typeof e||"object"==typeof e&&null!==e&&!Array.isArray(e)},Ve=function(e){return"__proto__"!==e&&"constructor"!==e&&"prototype"!==e};function Be(e,t,n){var r=e[n];ke(t)&&ke(r)?ze(r,t):e[n]=t}function ze(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];for(var o=0,s=n;o<s.length;o++){var i=s[o];if(ke(i))for(var a in i)Ve(a)&&Be(e,i[a],a)}return e}var Me=react.createContext(),Ge=Me.Consumer;function Le(e){var t=(0,react.useContext)(Me),n=(0,react.useMemo)((function(){return function(e,t){if(!e)return D(14);if(E(e)){var n=e(t);return true?n:0}return Array.isArray(e)||"object"!=typeof e?D(8):t?y({},t,{},e):e}(e.theme,t)}),[e.theme,t]);return e.children?react.createElement(Me.Provider,{value:n},e.children):null}var Fe={};function Ye(e,t,n){var o=_(e),i=!xe(e),a=t.attrs,c=void 0===a?S:a,l=t.componentId,d=void 0===l?function(e,t){var n="string"!=typeof e?"sc":je(e);Fe[n]=(Fe[n]||0)+1;var r=n+"-"+Te("5.3.11"+n+Fe[n]);return t?t+"-"+r:r}(t.displayName,t.parentComponentId):l,h=t.displayName,p=void 0===h?function(e){return xe(e)?"styled."+e:"Styled("+b(e)+")"}(e):h,v=t.displayName&&t.componentId?je(t.displayName)+"-"+t.componentId:t.componentId||d,g=o&&e.attrs?Array.prototype.concat(e.attrs,c).filter(Boolean):c,N=t.shouldForwardProp;o&&e.shouldForwardProp&&(N=t.shouldForwardProp?function(n,r,o){return e.shouldForwardProp(n,r,o)&&t.shouldForwardProp(n,r,o)}:e.shouldForwardProp);var A,C=new oe(n,v,o?e.componentStyle:void 0),I=C.isStatic&&0===c.length,P=function(e,t){return function(e,t,n,r){var o=e.attrs,i=e.componentStyle,a=e.defaultProps,c=e.foldedComponentIds,l=e.shouldForwardProp,d=e.styledComponentId,h=e.target,p=function(e,t,n){void 0===e&&(e=w);var r=y({},t,{theme:e}),o={};return n.forEach((function(e){var t,n,s,i=e;for(t in E(i)&&(i=i(r)),i)r[t]=o[t]="className"===t?(n=o[t],s=i[t],n&&s?n+" "+s:n||s):i[t]})),[r,o]}(Oe(t,(0,react.useContext)(Me),a)||w,t,o),m=p[0],v=p[1],g=function(e,t,n,r){var o=pe(),s=fe(),i=t?e.generateAndInjectStyles(w,o,s):e.generateAndInjectStyles(n,o,s);return false&&0,i}(i,r,m, false?0:void 0),S=n,b=v.$as||t.$as||v.as||t.as||h,_=xe(b),N=v!==t?y({},t,{},v):t,A={};for(var C in N)"$"!==C[0]&&"as"!==C&&("forwardedAs"===C?A.as=N[C]:(l?l(C,emotion_is_prop_valid_esm/* default */.Z,b):!_||(0,emotion_is_prop_valid_esm/* default */.Z)(C))&&(A[C]=N[C]));return t.style&&v.style!==t.style&&(A.style=y({},t.style,{},v.style)),A.className=Array.prototype.concat(c,d,g!==d?g:null,t.className,v.className).filter(Boolean).join(" "),A.ref=S,(0,react.createElement)(b,A)}(A,e,t,I)};return P.displayName=p,(A=react.forwardRef(P)).attrs=g,A.componentStyle=C,A.displayName=p,A.shouldForwardProp=N,A.foldedComponentIds=o?Array.prototype.concat(e.foldedComponentIds,e.styledComponentId):S,A.styledComponentId=v,A.target=o?e.target:e,A.withComponent=function(e){var r=t.componentId,o=function(e,t){if(null==e)return{};var n,r,o={},s=Object.keys(e);for(r=0;r<s.length;r++)n=s[r],t.indexOf(n)>=0||(o[n]=e[n]);return o}(t,["componentId"]),s=r&&r+"-"+(xe(e)?e:je(b(e)));return Ye(e,y({},o,{attrs:g,componentId:s}),n)},Object.defineProperty(A,"defaultProps",{get:function(){return this._foldedDefaultProps},set:function(t){this._foldedDefaultProps=o?ze({},e.defaultProps,t):t}}), false&&(0),Object.defineProperty(A,"toString",{value:function(){return"."+A.styledComponentId}}),i&&hoist_non_react_statics_cjs_default()(A,e,{attrs:!0,componentStyle:!0,displayName:!0,foldedComponentIds:!0,shouldForwardProp:!0,styledComponentId:!0,target:!0,withComponent:!0}),A}var qe=function(e){return function e(t,r,o){if(void 0===o&&(o=w),!(0,react_is.isValidElementType)(r))return D(1,String(r));var s=function(){return t(r,o,Ae.apply(void 0,arguments))};return s.withConfig=function(n){return e(t,r,y({},o,{},n))},s.attrs=function(n){return e(t,r,y({},o,{attrs:Array.prototype.concat(o.attrs,n).filter(Boolean)}))},s}(Ye,e)};["a","abbr","address","area","article","aside","audio","b","base","bdi","bdo","big","blockquote","body","br","button","canvas","caption","cite","code","col","colgroup","data","datalist","dd","del","details","dfn","dialog","div","dl","dt","em","embed","fieldset","figcaption","figure","footer","form","h1","h2","h3","h4","h5","h6","head","header","hgroup","hr","html","i","iframe","img","input","ins","kbd","keygen","label","legend","li","link","main","map","mark","marquee","menu","menuitem","meta","meter","nav","noscript","object","ol","optgroup","option","output","p","param","picture","pre","progress","q","rp","rt","ruby","s","samp","script","section","select","small","source","span","strong","style","sub","summary","sup","table","tbody","td","textarea","tfoot","th","thead","time","title","tr","track","u","ul","var","video","wbr","circle","clipPath","defs","ellipse","foreignObject","g","image","line","linearGradient","marker","mask","path","pattern","polygon","polyline","radialGradient","rect","stop","svg","text","textPath","tspan"].forEach((function(e){qe[e]=qe(e)}));var He=function(){function e(e,t){this.rules=e,this.componentId=t,this.isStatic=ne(e),X.registerId(this.componentId+1)}var t=e.prototype;return t.createStyles=function(e,t,n,r){var o=r(_e(this.rules,t,n,r).join(""),""),s=this.componentId+e;n.insertRules(s,s,o)},t.removeStyles=function(e,t){t.clearRules(this.componentId+e)},t.renderStyles=function(e,t,n,r){e>2&&X.registerId(this.componentId+e),this.removeStyles(e,n),this.createStyles(e,t,n,r)},e}();function $e(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),o=1;o<t;o++)n[o-1]=arguments[o];var i=Ae.apply(void 0,[e].concat(n)),a="sc-global-"+Te(JSON.stringify(i)),u=new He(i,a);function d(e){var t=pe(),n=fe(),o=s(Me),d=c(t.allocateGSInstance(a)).current;return false&&0, false&&0,t.server&&h(d,e,t,o,n),l((function(){if(!t.server)return h(d,e,t,o,n),function(){return u.removeStyles(d,t)}}),[d,e,t,o,n]),null}function h(e,t,n,r,o){if(u.isStatic)u.renderStyles(e,P,n,o);else{var s=y({},t,{theme:Oe(t,r,d.defaultProps)});u.renderStyles(e,s,n,o)}}return false&&0,r.memo(d)}function We(e){ false&&0;for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];var o=Ae.apply(void 0,[e].concat(n)).join(""),s=Te(o);return new ye(s,o)}var Ue=function(){function e(){var e=this;this._emitSheetCSS=function(){var t=e.instance.toString();if(!t)return"";var n=Y();return"<style "+[n&&'nonce="'+n+'"',N+'="true"','data-styled-version="5.3.11"'].filter(Boolean).join(" ")+">"+t+"</style>"},this.getStyleTags=function(){return e.sealed?D(2):e._emitSheetCSS()},this.getStyleElement=function(){var t;if(e.sealed)return D(2);var n=((t={})[N]="",t["data-styled-version"]="5.3.11",t.dangerouslySetInnerHTML={__html:e.instance.toString()},t),o=Y();return o&&(n.nonce=o),[react.createElement("style",y({},n,{key:"sc-0-0"}))]},this.seal=function(){e.sealed=!0},this.instance=new X({isServer:!0}),this.sealed=!1}var t=e.prototype;return t.collectStyles=function(e){return this.sealed?D(2):react.createElement(me,{sheet:this.instance},e)},t.interleaveWithNodeStream=function(e){return D(3)},e}(),Je=function(e){var t=r.forwardRef((function(t,n){var o=s(Me),i=e.defaultProps,a=Oe(t,o,i);return false&&0,r.createElement(e,y({},t,{theme:a,ref:n}))}));return m(t,e),t.displayName="WithTheme("+b(e)+")",t},Xe=function(){return s(Me)},Ze={StyleSheet:X,masterSheet:de}; false&&0, false&&(0);/* harmony default export */ var styled_components_browser_esm = (qe);
//# sourceMappingURL=styled-components.browser.esm.js.map


/***/ }),

/***/ 23451:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/* UAParser.js v1.0.41
   Copyright © 2012-2025 Faisal Salman <f@faisalman.com>
   MIT License */
(function(window,undefined){"use strict";var LIBVERSION="1.0.41",EMPTY="",UNKNOWN="?",FUNC_TYPE="function",UNDEF_TYPE="undefined",OBJ_TYPE="object",STR_TYPE="string",MAJOR="major",MODEL="model",NAME="name",TYPE="type",VENDOR="vendor",VERSION="version",ARCHITECTURE="architecture",CONSOLE="console",MOBILE="mobile",TABLET="tablet",SMARTTV="smarttv",WEARABLE="wearable",EMBEDDED="embedded",UA_MAX_LENGTH=500;var AMAZON="Amazon",APPLE="Apple",ASUS="ASUS",BLACKBERRY="BlackBerry",BROWSER="Browser",CHROME="Chrome",EDGE="Edge",FIREFOX="Firefox",GOOGLE="Google",HONOR="Honor",HUAWEI="Huawei",LENOVO="Lenovo",LG="LG",MICROSOFT="Microsoft",MOTOROLA="Motorola",NVIDIA="Nvidia",ONEPLUS="OnePlus",OPERA="Opera",OPPO="OPPO",SAMSUNG="Samsung",SHARP="Sharp",SONY="Sony",XIAOMI="Xiaomi",ZEBRA="Zebra",FACEBOOK="Facebook",CHROMIUM_OS="Chromium OS",MAC_OS="Mac OS",SUFFIX_BROWSER=" Browser";var extend=function(regexes,extensions){var mergedRegexes={};for(var i in regexes){if(extensions[i]&&extensions[i].length%2===0){mergedRegexes[i]=extensions[i].concat(regexes[i])}else{mergedRegexes[i]=regexes[i]}}return mergedRegexes},enumerize=function(arr){var enums={};for(var i=0;i<arr.length;i++){enums[arr[i].toUpperCase()]=arr[i]}return enums},has=function(str1,str2){return typeof str1===STR_TYPE?lowerize(str2).indexOf(lowerize(str1))!==-1:false},lowerize=function(str){return str.toLowerCase()},majorize=function(version){return typeof version===STR_TYPE?version.replace(/[^\d\.]/g,EMPTY).split(".")[0]:undefined},trim=function(str,len){if(typeof str===STR_TYPE){str=str.replace(/^\s\s*/,EMPTY);return typeof len===UNDEF_TYPE?str:str.substring(0,UA_MAX_LENGTH)}};var rgxMapper=function(ua,arrays){var i=0,j,k,p,q,matches,match;while(i<arrays.length&&!matches){var regex=arrays[i],props=arrays[i+1];j=k=0;while(j<regex.length&&!matches){if(!regex[j]){break}matches=regex[j++].exec(ua);if(!!matches){for(p=0;p<props.length;p++){match=matches[++k];q=props[p];if(typeof q===OBJ_TYPE&&q.length>0){if(q.length===2){if(typeof q[1]==FUNC_TYPE){this[q[0]]=q[1].call(this,match)}else{this[q[0]]=q[1]}}else if(q.length===3){if(typeof q[1]===FUNC_TYPE&&!(q[1].exec&&q[1].test)){this[q[0]]=match?q[1].call(this,match,q[2]):undefined}else{this[q[0]]=match?match.replace(q[1],q[2]):undefined}}else if(q.length===4){this[q[0]]=match?q[3].call(this,match.replace(q[1],q[2])):undefined}}else{this[q]=match?match:undefined}}}}i+=2}},strMapper=function(str,map){for(var i in map){if(typeof map[i]===OBJ_TYPE&&map[i].length>0){for(var j=0;j<map[i].length;j++){if(has(map[i][j],str)){return i===UNKNOWN?undefined:i}}}else if(has(map[i],str)){return i===UNKNOWN?undefined:i}}return map.hasOwnProperty("*")?map["*"]:str};var oldSafariMap={"1.0":"/8",1.2:"/1",1.3:"/3","2.0":"/412","2.0.2":"/416","2.0.3":"/417","2.0.4":"/419","?":"/"},windowsVersionMap={ME:"4.90","NT 3.11":"NT3.51","NT 4.0":"NT4.0",2e3:"NT 5.0",XP:["NT 5.1","NT 5.2"],Vista:"NT 6.0",7:"NT 6.1",8:"NT 6.2",8.1:"NT 6.3",10:["NT 6.4","NT 10.0"],RT:"ARM"};var regexes={browser:[[/\b(?:crmo|crios)\/([\w\.]+)/i],[VERSION,[NAME,"Chrome"]],[/edg(?:e|ios|a)?\/([\w\.]+)/i],[VERSION,[NAME,"Edge"]],[/(opera mini)\/([-\w\.]+)/i,/(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,/(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i],[NAME,VERSION],[/opios[\/ ]+([\w\.]+)/i],[VERSION,[NAME,OPERA+" Mini"]],[/\bop(?:rg)?x\/([\w\.]+)/i],[VERSION,[NAME,OPERA+" GX"]],[/\bopr\/([\w\.]+)/i],[VERSION,[NAME,OPERA]],[/\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i],[VERSION,[NAME,"Baidu"]],[/\b(?:mxbrowser|mxios|myie2)\/?([-\w\.]*)\b/i],[VERSION,[NAME,"Maxthon"]],[/(kindle)\/([\w\.]+)/i,/(lunascape|maxthon|netfront|jasmine|blazer|sleipnir)[\/ ]?([\w\.]*)/i,/(avant|iemobile|slim(?:browser|boat|jet))[\/ ]?([\d\.]*)/i,/(?:ms|\()(ie) ([\w\.]+)/i,/(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|duckduckgo|klar|helio|(?=comodo_)?dragon)\/([-\w\.]+)/i,/(heytap|ovi|115)browser\/([\d\.]+)/i,/(weibo)__([\d\.]+)/i],[NAME,VERSION],[/quark(?:pc)?\/([-\w\.]+)/i],[VERSION,[NAME,"Quark"]],[/\bddg\/([\w\.]+)/i],[VERSION,[NAME,"DuckDuckGo"]],[/(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i],[VERSION,[NAME,"UC"+BROWSER]],[/microm.+\bqbcore\/([\w\.]+)/i,/\bqbcore\/([\w\.]+).+microm/i,/micromessenger\/([\w\.]+)/i],[VERSION,[NAME,"WeChat"]],[/konqueror\/([\w\.]+)/i],[VERSION,[NAME,"Konqueror"]],[/trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i],[VERSION,[NAME,"IE"]],[/ya(?:search)?browser\/([\w\.]+)/i],[VERSION,[NAME,"Yandex"]],[/slbrowser\/([\w\.]+)/i],[VERSION,[NAME,"Smart Lenovo "+BROWSER]],[/(avast|avg)\/([\w\.]+)/i],[[NAME,/(.+)/,"$1 Secure "+BROWSER],VERSION],[/\bfocus\/([\w\.]+)/i],[VERSION,[NAME,FIREFOX+" Focus"]],[/\bopt\/([\w\.]+)/i],[VERSION,[NAME,OPERA+" Touch"]],[/coc_coc\w+\/([\w\.]+)/i],[VERSION,[NAME,"Coc Coc"]],[/dolfin\/([\w\.]+)/i],[VERSION,[NAME,"Dolphin"]],[/coast\/([\w\.]+)/i],[VERSION,[NAME,OPERA+" Coast"]],[/miuibrowser\/([\w\.]+)/i],[VERSION,[NAME,"MIUI"+SUFFIX_BROWSER]],[/fxios\/([\w\.-]+)/i],[VERSION,[NAME,FIREFOX]],[/\bqihoobrowser\/?([\w\.]*)/i],[VERSION,[NAME,"360"]],[/\b(qq)\/([\w\.]+)/i],[[NAME,/(.+)/,"$1Browser"],VERSION],[/(oculus|sailfish|huawei|vivo|pico)browser\/([\w\.]+)/i],[[NAME,/(.+)/,"$1"+SUFFIX_BROWSER],VERSION],[/samsungbrowser\/([\w\.]+)/i],[VERSION,[NAME,SAMSUNG+" Internet"]],[/metasr[\/ ]?([\d\.]+)/i],[VERSION,[NAME,"Sogou Explorer"]],[/(sogou)mo\w+\/([\d\.]+)/i],[[NAME,"Sogou Mobile"],VERSION],[/(electron)\/([\w\.]+) safari/i,/(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,/m?(qqbrowser|2345(?=browser|chrome|explorer))\w*[\/ ]?v?([\w\.]+)/i],[NAME,VERSION],[/(lbbrowser|rekonq)/i,/\[(linkedin)app\]/i],[NAME],[/ome\/([\w\.]+) \w* ?(iron) saf/i,/ome\/([\w\.]+).+qihu (360)[es]e/i],[VERSION,NAME],[/((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i],[[NAME,FACEBOOK],VERSION],[/(Klarna)\/([\w\.]+)/i,/(kakao(?:talk|story))[\/ ]([\w\.]+)/i,/(naver)\(.*?(\d+\.[\w\.]+).*\)/i,/(daum)apps[\/ ]([\w\.]+)/i,/safari (line)\/([\w\.]+)/i,/\b(line)\/([\w\.]+)\/iab/i,/(alipay)client\/([\w\.]+)/i,/(twitter)(?:and| f.+e\/([\w\.]+))/i,/(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i],[NAME,VERSION],[/\bgsa\/([\w\.]+) .*safari\//i],[VERSION,[NAME,"GSA"]],[/musical_ly(?:.+app_?version\/|_)([\w\.]+)/i],[VERSION,[NAME,"TikTok"]],[/headlesschrome(?:\/([\w\.]+)| )/i],[VERSION,[NAME,CHROME+" Headless"]],[/ wv\).+(chrome)\/([\w\.]+)/i],[[NAME,CHROME+" WebView"],VERSION],[/droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i],[VERSION,[NAME,"Android "+BROWSER]],[/(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i],[NAME,VERSION],[/version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i],[VERSION,[NAME,"Mobile Safari"]],[/version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i],[VERSION,NAME],[/webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i],[NAME,[VERSION,strMapper,oldSafariMap]],[/(webkit|khtml)\/([\w\.]+)/i],[NAME,VERSION],[/(navigator|netscape\d?)\/([-\w\.]+)/i],[[NAME,"Netscape"],VERSION],[/(wolvic|librewolf)\/([\w\.]+)/i],[NAME,VERSION],[/mobile vr; rv:([\w\.]+)\).+firefox/i],[VERSION,[NAME,FIREFOX+" Reality"]],[/ekiohf.+(flow)\/([\w\.]+)/i,/(swiftfox)/i,/(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror)[\/ ]?([\w\.\+]+)/i,/(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,/(firefox)\/([\w\.]+)/i,/(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,/(amaya|dillo|doris|icab|ladybird|lynx|mosaic|netsurf|obigo|polaris|w3m|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,/\b(links) \(([\w\.]+)/i],[NAME,[VERSION,/_/g,"."]],[/(cobalt)\/([\w\.]+)/i],[NAME,[VERSION,/master.|lts./,""]]],cpu:[[/\b((amd|x|x86[-_]?|wow|win)64)\b/i],[[ARCHITECTURE,"amd64"]],[/(ia32(?=;))/i,/\b((i[346]|x)86)(pc)?\b/i],[[ARCHITECTURE,"ia32"]],[/\b(aarch64|arm(v?[89]e?l?|_?64))\b/i],[[ARCHITECTURE,"arm64"]],[/\b(arm(v[67])?ht?n?[fl]p?)\b/i],[[ARCHITECTURE,"armhf"]],[/( (ce|mobile); ppc;|\/[\w\.]+arm\b)/i],[[ARCHITECTURE,"arm"]],[/((ppc|powerpc)(64)?)( mac|;|\))/i],[[ARCHITECTURE,/ower/,EMPTY,lowerize]],[/ sun4\w[;\)]/i],[[ARCHITECTURE,"sparc"]],[/\b(avr32|ia64(?=;)|68k(?=\))|\barm(?=v([1-7]|[5-7]1)l?|;|eabi)|(irix|mips|sparc)(64)?\b|pa-risc)/i],[[ARCHITECTURE,lowerize]]],device:[[/\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i],[MODEL,[VENDOR,SAMSUNG],[TYPE,TABLET]],[/\b((?:s[cgp]h|gt|sm)-(?![lr])\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,/samsung[- ]((?!sm-[lr])[-\w]+)/i,/sec-(sgh\w+)/i],[MODEL,[VENDOR,SAMSUNG],[TYPE,MOBILE]],[/(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i],[MODEL,[VENDOR,APPLE],[TYPE,MOBILE]],[/\((ipad);[-\w\),; ]+apple/i,/applecoremedia\/[\w\.]+ \((ipad)/i,/\b(ipad)\d\d?,\d\d?[;\]].+ios/i],[MODEL,[VENDOR,APPLE],[TYPE,TABLET]],[/(macintosh);/i],[MODEL,[VENDOR,APPLE]],[/\b(sh-?[altvz]?\d\d[a-ekm]?)/i],[MODEL,[VENDOR,SHARP],[TYPE,MOBILE]],[/\b((?:brt|eln|hey2?|gdi|jdn)-a?[lnw]09|(?:ag[rm]3?|jdn2|kob2)-a?[lw]0[09]hn)(?: bui|\)|;)/i],[MODEL,[VENDOR,HONOR],[TYPE,TABLET]],[/honor([-\w ]+)[;\)]/i],[MODEL,[VENDOR,HONOR],[TYPE,MOBILE]],[/\b((?:ag[rs][2356]?k?|bah[234]?|bg[2o]|bt[kv]|cmr|cpn|db[ry]2?|jdn2|got|kob2?k?|mon|pce|scm|sht?|[tw]gr|vrd)-[ad]?[lw][0125][09]b?|605hw|bg2-u03|(?:gem|fdr|m2|ple|t1)-[7a]0[1-4][lu]|t1-a2[13][lw]|mediapad[\w\. ]*(?= bui|\)))\b(?!.+d\/s)/i],[MODEL,[VENDOR,HUAWEI],[TYPE,TABLET]],[/(?:huawei)([-\w ]+)[;\)]/i,/\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i],[MODEL,[VENDOR,HUAWEI],[TYPE,MOBILE]],[/oid[^\)]+; (2[\dbc]{4}(182|283|rp\w{2})[cgl]|m2105k81a?c)(?: bui|\))/i,/\b((?:red)?mi[-_ ]?pad[\w- ]*)(?: bui|\))/i],[[MODEL,/_/g," "],[VENDOR,XIAOMI],[TYPE,TABLET]],[/\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,/\b; (\w+) build\/hm\1/i,/\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,/\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,/oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,/\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite|pro)?)(?: bui|\))/i,/ ([\w ]+) miui\/v?\d/i],[[MODEL,/_/g," "],[VENDOR,XIAOMI],[TYPE,MOBILE]],[/; (\w+) bui.+ oppo/i,/\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i],[MODEL,[VENDOR,OPPO],[TYPE,MOBILE]],[/\b(opd2(\d{3}a?))(?: bui|\))/i],[MODEL,[VENDOR,strMapper,{OnePlus:["304","403","203"],"*":OPPO}],[TYPE,TABLET]],[/vivo (\w+)(?: bui|\))/i,/\b(v[12]\d{3}\w?[at])(?: bui|;)/i],[MODEL,[VENDOR,"Vivo"],[TYPE,MOBILE]],[/\b(rmx[1-3]\d{3})(?: bui|;|\))/i],[MODEL,[VENDOR,"Realme"],[TYPE,MOBILE]],[/\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,/\bmot(?:orola)?[- ](\w*)/i,/((?:moto(?! 360)[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i],[MODEL,[VENDOR,MOTOROLA],[TYPE,MOBILE]],[/\b(mz60\d|xoom[2 ]{0,2}) build\//i],[MODEL,[VENDOR,MOTOROLA],[TYPE,TABLET]],[/((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i],[MODEL,[VENDOR,LG],[TYPE,TABLET]],[/(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,/\blg[-e;\/ ]+((?!browser|netcast|android tv|watch)\w+)/i,/\blg-?([\d\w]+) bui/i],[MODEL,[VENDOR,LG],[TYPE,MOBILE]],[/(ideatab[-\w ]+|602lv|d-42a|a101lv|a2109a|a3500-hv|s[56]000|pb-6505[my]|tb-?x?\d{3,4}(?:f[cu]|xu|[av])|yt\d?-[jx]?\d+[lfmx])( bui|;|\)|\/)/i,/lenovo ?(b[68]0[08]0-?[hf]?|tab(?:[\w- ]+?)|tb[\w-]{6,7})( bui|;|\)|\/)/i],[MODEL,[VENDOR,LENOVO],[TYPE,TABLET]],[/(nokia) (t[12][01])/i],[VENDOR,MODEL,[TYPE,TABLET]],[/(?:maemo|nokia).*(n900|lumia \d+|rm-\d+)/i,/nokia[-_ ]?(([-\w\. ]*))/i],[[MODEL,/_/g," "],[TYPE,MOBILE],[VENDOR,"Nokia"]],[/(pixel (c|tablet))\b/i],[MODEL,[VENDOR,GOOGLE],[TYPE,TABLET]],[/droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i],[MODEL,[VENDOR,GOOGLE],[TYPE,MOBILE]],[/droid.+; (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i],[MODEL,[VENDOR,SONY],[TYPE,MOBILE]],[/sony tablet [ps]/i,/\b(?:sony)?sgp\w+(?: bui|\))/i],[[MODEL,"Xperia Tablet"],[VENDOR,SONY],[TYPE,TABLET]],[/ (kb2005|in20[12]5|be20[12][59])\b/i,/(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i],[MODEL,[VENDOR,ONEPLUS],[TYPE,MOBILE]],[/(alexa)webm/i,/(kf[a-z]{2}wi|aeo(?!bc)\w\w)( bui|\))/i,/(kf[a-z]+)( bui|\)).+silk\//i],[MODEL,[VENDOR,AMAZON],[TYPE,TABLET]],[/((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i],[[MODEL,/(.+)/g,"Fire Phone $1"],[VENDOR,AMAZON],[TYPE,MOBILE]],[/(playbook);[-\w\),; ]+(rim)/i],[MODEL,VENDOR,[TYPE,TABLET]],[/\b((?:bb[a-f]|st[hv])100-\d)/i,/\(bb10; (\w+)/i],[MODEL,[VENDOR,BLACKBERRY],[TYPE,MOBILE]],[/(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i],[MODEL,[VENDOR,ASUS],[TYPE,TABLET]],[/ (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i],[MODEL,[VENDOR,ASUS],[TYPE,MOBILE]],[/(nexus 9)/i],[MODEL,[VENDOR,"HTC"],[TYPE,TABLET]],[/(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,/(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,/(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i],[VENDOR,[MODEL,/_/g," "],[TYPE,MOBILE]],[/droid [\w\.]+; ((?:8[14]9[16]|9(?:0(?:48|60|8[01])|1(?:3[27]|66)|2(?:6[69]|9[56])|466))[gqswx])\w*(\)| bui)/i],[MODEL,[VENDOR,"TCL"],[TYPE,TABLET]],[/(itel) ((\w+))/i],[[VENDOR,lowerize],MODEL,[TYPE,strMapper,{tablet:["p10001l","w7001"],"*":"mobile"}]],[/droid.+; ([ab][1-7]-?[0178a]\d\d?)/i],[MODEL,[VENDOR,"Acer"],[TYPE,TABLET]],[/droid.+; (m[1-5] note) bui/i,/\bmz-([-\w]{2,})/i],[MODEL,[VENDOR,"Meizu"],[TYPE,MOBILE]],[/; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i],[MODEL,[VENDOR,"Ulefone"],[TYPE,MOBILE]],[/; (energy ?\w+)(?: bui|\))/i,/; energizer ([\w ]+)(?: bui|\))/i],[MODEL,[VENDOR,"Energizer"],[TYPE,MOBILE]],[/; cat (b35);/i,/; (b15q?|s22 flip|s48c|s62 pro)(?: bui|\))/i],[MODEL,[VENDOR,"Cat"],[TYPE,MOBILE]],[/((?:new )?andromax[\w- ]+)(?: bui|\))/i],[MODEL,[VENDOR,"Smartfren"],[TYPE,MOBILE]],[/droid.+; (a(?:015|06[35]|142p?))/i],[MODEL,[VENDOR,"Nothing"],[TYPE,MOBILE]],[/; (x67 5g|tikeasy \w+|ac[1789]\d\w+)( b|\))/i,/archos ?(5|gamepad2?|([\w ]*[t1789]|hello) ?\d+[\w ]*)( b|\))/i],[MODEL,[VENDOR,"Archos"],[TYPE,TABLET]],[/archos ([\w ]+)( b|\))/i,/; (ac[3-6]\d\w{2,8})( b|\))/i],[MODEL,[VENDOR,"Archos"],[TYPE,MOBILE]],[/(imo) (tab \w+)/i,/(infinix) (x1101b?)/i],[VENDOR,MODEL,[TYPE,TABLET]],[/(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus(?! zenw)|dell|jolla|meizu|motorola|polytron|infinix|tecno|micromax|advan)[-_ ]?([-\w]*)/i,/; (hmd|imo) ([\w ]+?)(?: bui|\))/i,/(hp) ([\w ]+\w)/i,/(microsoft); (lumia[\w ]+)/i,/(lenovo)[-_ ]?([-\w ]+?)(?: bui|\)|\/)/i,/(oppo) ?([\w ]+) bui/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/(kobo)\s(ereader|touch)/i,/(hp).+(touchpad(?!.+tablet)|tablet)/i,/(kindle)\/([\w\.]+)/i,/(nook)[\w ]+build\/(\w+)/i,/(dell) (strea[kpr\d ]*[\dko])/i,/(le[- ]+pan)[- ]+(\w{1,9}) bui/i,/(trinity)[- ]*(t\d{3}) bui/i,/(gigaset)[- ]+(q\w{1,9}) bui/i,/(vodafone) ([\w ]+)(?:\)| bui)/i],[VENDOR,MODEL,[TYPE,TABLET]],[/(surface duo)/i],[MODEL,[VENDOR,MICROSOFT],[TYPE,TABLET]],[/droid [\d\.]+; (fp\du?)(?: b|\))/i],[MODEL,[VENDOR,"Fairphone"],[TYPE,MOBILE]],[/(u304aa)/i],[MODEL,[VENDOR,"AT&T"],[TYPE,MOBILE]],[/\bsie-(\w*)/i],[MODEL,[VENDOR,"Siemens"],[TYPE,MOBILE]],[/\b(rct\w+) b/i],[MODEL,[VENDOR,"RCA"],[TYPE,TABLET]],[/\b(venue[\d ]{2,7}) b/i],[MODEL,[VENDOR,"Dell"],[TYPE,TABLET]],[/\b(q(?:mv|ta)\w+) b/i],[MODEL,[VENDOR,"Verizon"],[TYPE,TABLET]],[/\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i],[MODEL,[VENDOR,"Barnes & Noble"],[TYPE,TABLET]],[/\b(tm\d{3}\w+) b/i],[MODEL,[VENDOR,"NuVision"],[TYPE,TABLET]],[/\b(k88) b/i],[MODEL,[VENDOR,"ZTE"],[TYPE,TABLET]],[/\b(nx\d{3}j) b/i],[MODEL,[VENDOR,"ZTE"],[TYPE,MOBILE]],[/\b(gen\d{3}) b.+49h/i],[MODEL,[VENDOR,"Swiss"],[TYPE,MOBILE]],[/\b(zur\d{3}) b/i],[MODEL,[VENDOR,"Swiss"],[TYPE,TABLET]],[/\b((zeki)?tb.*\b) b/i],[MODEL,[VENDOR,"Zeki"],[TYPE,TABLET]],[/\b([yr]\d{2}) b/i,/\b(dragon[- ]+touch |dt)(\w{5}) b/i],[[VENDOR,"Dragon Touch"],MODEL,[TYPE,TABLET]],[/\b(ns-?\w{0,9}) b/i],[MODEL,[VENDOR,"Insignia"],[TYPE,TABLET]],[/\b((nxa|next)-?\w{0,9}) b/i],[MODEL,[VENDOR,"NextBook"],[TYPE,TABLET]],[/\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i],[[VENDOR,"Voice"],MODEL,[TYPE,MOBILE]],[/\b(lvtel\-)?(v1[12]) b/i],[[VENDOR,"LvTel"],MODEL,[TYPE,MOBILE]],[/\b(ph-1) /i],[MODEL,[VENDOR,"Essential"],[TYPE,MOBILE]],[/\b(v(100md|700na|7011|917g).*\b) b/i],[MODEL,[VENDOR,"Envizen"],[TYPE,TABLET]],[/\b(trio[-\w\. ]+) b/i],[MODEL,[VENDOR,"MachSpeed"],[TYPE,TABLET]],[/\btu_(1491) b/i],[MODEL,[VENDOR,"Rotor"],[TYPE,TABLET]],[/((?:tegranote|shield t(?!.+d tv))[\w- ]*?)(?: b|\))/i],[MODEL,[VENDOR,NVIDIA],[TYPE,TABLET]],[/(sprint) (\w+)/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/(kin\.[onetw]{3})/i],[[MODEL,/\./g," "],[VENDOR,MICROSOFT],[TYPE,MOBILE]],[/droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i],[MODEL,[VENDOR,ZEBRA],[TYPE,TABLET]],[/droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i],[MODEL,[VENDOR,ZEBRA],[TYPE,MOBILE]],[/smart-tv.+(samsung)/i],[VENDOR,[TYPE,SMARTTV]],[/hbbtv.+maple;(\d+)/i],[[MODEL,/^/,"SmartTV"],[VENDOR,SAMSUNG],[TYPE,SMARTTV]],[/(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i],[[VENDOR,LG],[TYPE,SMARTTV]],[/(apple) ?tv/i],[VENDOR,[MODEL,APPLE+" TV"],[TYPE,SMARTTV]],[/crkey/i],[[MODEL,CHROME+"cast"],[VENDOR,GOOGLE],[TYPE,SMARTTV]],[/droid.+aft(\w+)( bui|\))/i],[MODEL,[VENDOR,AMAZON],[TYPE,SMARTTV]],[/(shield \w+ tv)/i],[MODEL,[VENDOR,NVIDIA],[TYPE,SMARTTV]],[/\(dtv[\);].+(aquos)/i,/(aquos-tv[\w ]+)\)/i],[MODEL,[VENDOR,SHARP],[TYPE,SMARTTV]],[/(bravia[\w ]+)( bui|\))/i],[MODEL,[VENDOR,SONY],[TYPE,SMARTTV]],[/(mi(tv|box)-?\w+) bui/i],[MODEL,[VENDOR,XIAOMI],[TYPE,SMARTTV]],[/Hbbtv.*(technisat) (.*);/i],[VENDOR,MODEL,[TYPE,SMARTTV]],[/\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,/hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i],[[VENDOR,trim],[MODEL,trim],[TYPE,SMARTTV]],[/droid.+; ([\w- ]+) (?:android tv|smart[- ]?tv)/i],[MODEL,[TYPE,SMARTTV]],[/\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i],[[TYPE,SMARTTV]],[/(ouya)/i,/(nintendo) ([wids3utch]+)/i],[VENDOR,MODEL,[TYPE,CONSOLE]],[/droid.+; (shield)( bui|\))/i],[MODEL,[VENDOR,NVIDIA],[TYPE,CONSOLE]],[/(playstation \w+)/i],[MODEL,[VENDOR,SONY],[TYPE,CONSOLE]],[/\b(xbox(?: one)?(?!; xbox))[\); ]/i],[MODEL,[VENDOR,MICROSOFT],[TYPE,CONSOLE]],[/\b(sm-[lr]\d\d[0156][fnuw]?s?|gear live)\b/i],[MODEL,[VENDOR,SAMSUNG],[TYPE,WEARABLE]],[/((pebble))app/i,/(asus|google|lg|oppo) ((pixel |zen)?watch[\w ]*)( bui|\))/i],[VENDOR,MODEL,[TYPE,WEARABLE]],[/(ow(?:19|20)?we?[1-3]{1,3})/i],[MODEL,[VENDOR,OPPO],[TYPE,WEARABLE]],[/(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i],[MODEL,[VENDOR,APPLE],[TYPE,WEARABLE]],[/(opwwe\d{3})/i],[MODEL,[VENDOR,ONEPLUS],[TYPE,WEARABLE]],[/(moto 360)/i],[MODEL,[VENDOR,MOTOROLA],[TYPE,WEARABLE]],[/(smartwatch 3)/i],[MODEL,[VENDOR,SONY],[TYPE,WEARABLE]],[/(g watch r)/i],[MODEL,[VENDOR,LG],[TYPE,WEARABLE]],[/droid.+; (wt63?0{2,3})\)/i],[MODEL,[VENDOR,ZEBRA],[TYPE,WEARABLE]],[/droid.+; (glass) \d/i],[MODEL,[VENDOR,GOOGLE],[TYPE,WEARABLE]],[/(pico) (4|neo3(?: link|pro)?)/i],[VENDOR,MODEL,[TYPE,WEARABLE]],[/; (quest( \d| pro)?)/i],[MODEL,[VENDOR,FACEBOOK],[TYPE,WEARABLE]],[/(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i],[VENDOR,[TYPE,EMBEDDED]],[/(aeobc)\b/i],[MODEL,[VENDOR,AMAZON],[TYPE,EMBEDDED]],[/(homepod).+mac os/i],[MODEL,[VENDOR,APPLE],[TYPE,EMBEDDED]],[/windows iot/i],[[TYPE,EMBEDDED]],[/droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i],[MODEL,[TYPE,MOBILE]],[/droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i],[MODEL,[TYPE,TABLET]],[/\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i],[[TYPE,TABLET]],[/(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i],[[TYPE,MOBILE]],[/droid .+?; ([\w\. -]+)( bui|\))/i],[MODEL,[VENDOR,"Generic"]]],engine:[[/windows.+ edge\/([\w\.]+)/i],[VERSION,[NAME,EDGE+"HTML"]],[/(arkweb)\/([\w\.]+)/i],[NAME,VERSION],[/webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i],[VERSION,[NAME,"Blink"]],[/(presto)\/([\w\.]+)/i,/(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna|servo)\/([\w\.]+)/i,/ekioh(flow)\/([\w\.]+)/i,/(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,/(icab)[\/ ]([23]\.[\d\.]+)/i,/\b(libweb)/i],[NAME,VERSION],[/ladybird\//i],[[NAME,"LibWeb"]],[/rv\:([\w\.]{1,9})\b.+(gecko)/i],[VERSION,NAME]],os:[[/microsoft (windows) (vista|xp)/i],[NAME,VERSION],[/(windows (?:phone(?: os)?|mobile|iot))[\/ ]?([\d\.\w ]*)/i],[NAME,[VERSION,strMapper,windowsVersionMap]],[/windows nt 6\.2; (arm)/i,/windows[\/ ]([ntce\d\. ]+\w)(?!.+xbox)/i,/(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i],[[VERSION,strMapper,windowsVersionMap],[NAME,"Windows"]],[/[adehimnop]{4,7}\b(?:.*os ([\w]+) like mac|; opera)/i,/(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,/cfnetwork\/.+darwin/i],[[VERSION,/_/g,"."],[NAME,"iOS"]],[/(mac os x) ?([\w\. ]*)/i,/(macintosh|mac_powerpc\b)(?!.+haiku)/i],[[NAME,MAC_OS],[VERSION,/_/g,"."]],[/droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i],[VERSION,NAME],[/(ubuntu) ([\w\.]+) like android/i],[[NAME,/(.+)/,"$1 Touch"],VERSION],[/(android|bada|blackberry|kaios|maemo|meego|openharmony|qnx|rim tablet os|sailfish|series40|symbian|tizen|webos)\w*[-\/; ]?([\d\.]*)/i],[NAME,VERSION],[/\(bb(10);/i],[VERSION,[NAME,BLACKBERRY]],[/(?:symbian ?os|symbos|s60(?=;)|series ?60)[-\/ ]?([\w\.]*)/i],[VERSION,[NAME,"Symbian"]],[/mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i],[VERSION,[NAME,FIREFOX+" OS"]],[/web0s;.+rt(tv)/i,/\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i],[VERSION,[NAME,"webOS"]],[/watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i],[VERSION,[NAME,"watchOS"]],[/crkey\/([\d\.]+)/i],[VERSION,[NAME,CHROME+"cast"]],[/(cros) [\w]+(?:\)| ([\w\.]+)\b)/i],[[NAME,CHROMIUM_OS],VERSION],[/panasonic;(viera)/i,/(netrange)mmh/i,/(nettv)\/(\d+\.[\w\.]+)/i,/(nintendo|playstation) ([wids345portablevuch]+)/i,/(xbox); +xbox ([^\);]+)/i,/\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,/(mint)[\/\(\) ]?(\w*)/i,/(mageia|vectorlinux)[; ]/i,/([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,/(hurd|linux)(?: arm\w*| x86\w*| ?)([\w\.]*)/i,/(gnu) ?([\w\.]*)/i,/\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,/(haiku) (\w+)/i],[NAME,VERSION],[/(sunos) ?([\w\.\d]*)/i],[[NAME,"Solaris"],VERSION],[/((?:open)?solaris)[-\/ ]?([\w\.]*)/i,/(aix) ((\d)(?=\.|\)| )[\w\.])*/i,/\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,/(unix) ?([\w\.]*)/i],[NAME,VERSION]]};var UAParser=function(ua,extensions){if(typeof ua===OBJ_TYPE){extensions=ua;ua=undefined}if(!(this instanceof UAParser)){return new UAParser(ua,extensions).getResult()}var _navigator=typeof window!==UNDEF_TYPE&&window.navigator?window.navigator:undefined;var _ua=ua||(_navigator&&_navigator.userAgent?_navigator.userAgent:EMPTY);var _uach=_navigator&&_navigator.userAgentData?_navigator.userAgentData:undefined;var _rgxmap=extensions?extend(regexes,extensions):regexes;var _isSelfNav=_navigator&&_navigator.userAgent==_ua;this.getBrowser=function(){var _browser={};_browser[NAME]=undefined;_browser[VERSION]=undefined;rgxMapper.call(_browser,_ua,_rgxmap.browser);_browser[MAJOR]=majorize(_browser[VERSION]);if(_isSelfNav&&_navigator&&_navigator.brave&&typeof _navigator.brave.isBrave==FUNC_TYPE){_browser[NAME]="Brave"}return _browser};this.getCPU=function(){var _cpu={};_cpu[ARCHITECTURE]=undefined;rgxMapper.call(_cpu,_ua,_rgxmap.cpu);return _cpu};this.getDevice=function(){var _device={};_device[VENDOR]=undefined;_device[MODEL]=undefined;_device[TYPE]=undefined;rgxMapper.call(_device,_ua,_rgxmap.device);if(_isSelfNav&&!_device[TYPE]&&_uach&&_uach.mobile){_device[TYPE]=MOBILE}if(_isSelfNav&&_device[MODEL]=="Macintosh"&&_navigator&&typeof _navigator.standalone!==UNDEF_TYPE&&_navigator.maxTouchPoints&&_navigator.maxTouchPoints>2){_device[MODEL]="iPad";_device[TYPE]=TABLET}return _device};this.getEngine=function(){var _engine={};_engine[NAME]=undefined;_engine[VERSION]=undefined;rgxMapper.call(_engine,_ua,_rgxmap.engine);return _engine};this.getOS=function(){var _os={};_os[NAME]=undefined;_os[VERSION]=undefined;rgxMapper.call(_os,_ua,_rgxmap.os);if(_isSelfNav&&!_os[NAME]&&_uach&&_uach.platform&&_uach.platform!="Unknown"){_os[NAME]=_uach.platform.replace(/chrome os/i,CHROMIUM_OS).replace(/macos/i,MAC_OS)}return _os};this.getResult=function(){return{ua:this.getUA(),browser:this.getBrowser(),engine:this.getEngine(),os:this.getOS(),device:this.getDevice(),cpu:this.getCPU()}};this.getUA=function(){return _ua};this.setUA=function(ua){_ua=typeof ua===STR_TYPE&&ua.length>UA_MAX_LENGTH?trim(ua,UA_MAX_LENGTH):ua;return this};this.setUA(_ua);return this};UAParser.VERSION=LIBVERSION;UAParser.BROWSER=enumerize([NAME,VERSION,MAJOR]);UAParser.CPU=enumerize([ARCHITECTURE]);UAParser.DEVICE=enumerize([MODEL,VENDOR,TYPE,CONSOLE,MOBILE,SMARTTV,TABLET,WEARABLE,EMBEDDED]);UAParser.ENGINE=UAParser.OS=enumerize([NAME,VERSION]);if(typeof exports!==UNDEF_TYPE){if("object"!==UNDEF_TYPE&&module.exports){exports=module.exports=UAParser}exports.UAParser=UAParser}else{if("function"===FUNC_TYPE&&__webpack_require__.amdO){!(__WEBPACK_AMD_DEFINE_RESULT__ = (function(){return UAParser}).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))}else if(typeof window!==UNDEF_TYPE){window.UAParser=UAParser}}var $=typeof window!==UNDEF_TYPE&&(window.jQuery||window.Zepto);if($&&!$.ua){var parser=new UAParser;$.ua=parser.getResult();$.ua.get=function(){return parser.getUA()};$.ua.set=function(ua){parser.setUA(ua);var result=parser.getResult();for(var prop in result){$.ua[prop]=result[prop]}}}})(typeof window==="object"?window:this);

/***/ }),

/***/ 53250:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var e=__webpack_require__(67294);function h(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var k="function"===typeof Object.is?Object.is:h,l=e.useState,m=e.useEffect,n=e.useLayoutEffect,p=e.useDebugValue;function q(a,b){var d=b(),f=l({inst:{value:d,getSnapshot:b}}),c=f[0].inst,g=f[1];n(function(){c.value=d;c.getSnapshot=b;r(c)&&g({inst:c})},[a,d,b]);m(function(){r(c)&&g({inst:c});return a(function(){r(c)&&g({inst:c})})},[a]);p(d);return d}
function r(a){var b=a.getSnapshot;a=a.value;try{var d=b();return!k(a,d)}catch(f){return!0}}function t(a,b){return b()}var u="undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement?t:q;exports.useSyncExternalStore=void 0!==e.useSyncExternalStore?e.useSyncExternalStore:u;


/***/ }),

/***/ 50139:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var h=__webpack_require__(67294),n=__webpack_require__(61688);function p(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var q="function"===typeof Object.is?Object.is:p,r=n.useSyncExternalStore,t=h.useRef,u=h.useEffect,v=h.useMemo,w=h.useDebugValue;
exports.useSyncExternalStoreWithSelector=function(a,b,e,l,g){var c=t(null);if(null===c.current){var f={hasValue:!1,value:null};c.current=f}else f=c.current;c=v(function(){function a(a){if(!c){c=!0;d=a;a=l(a);if(void 0!==g&&f.hasValue){var b=f.value;if(g(b,a))return k=b}return k=a}b=k;if(q(d,a))return b;var e=l(a);if(void 0!==g&&g(b,e))return b;d=a;return k=e}var c=!1,d,k,m=void 0===e?null:e;return[function(){return a(b())},null===m?void 0:function(){return a(m())}]},[b,e,l,g]);var d=r(a,c[0],c[1]);
u(function(){f.hasValue=!0;f.value=d},[d]);w(d);return d};


/***/ }),

/***/ 61688:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(53250);
} else {}


/***/ }),

/***/ 52798:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(50139);
} else {}


/***/ }),

/***/ 71739:
/***/ (function(module) {

/**
 * This file automatically generated from `pre-publish.js`.
 * Do not manually edit.
 */

module.exports = {
  "area": true,
  "base": true,
  "br": true,
  "col": true,
  "embed": true,
  "hr": true,
  "img": true,
  "input": true,
  "link": true,
  "meta": true,
  "param": true,
  "source": true,
  "track": true,
  "wbr": true
};


/***/ }),

/***/ 36902:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ create$1; },
  "oR": function() { return /* binding */ useStore; }
});

// UNUSED EXPORTS: createStore

;// CONCATENATED MODULE: ./node_modules/zustand/esm/vanilla.js
const createStoreImpl = (createState) => {
  let state;
  const listeners = /* @__PURE__ */ new Set();
  const setState = (partial, replace) => {
    const nextState = typeof partial === "function" ? partial(state) : partial;
    if (nextState !== state) {
      const previousState = state;
      state = replace ? nextState : Object.assign({}, state, nextState);
      listeners.forEach((listener) => listener(state, previousState));
    }
  };
  const getState = () => state;
  const subscribe = (listener) => {
    listeners.add(listener);
    return () => listeners.delete(listener);
  };
  const destroy = () => listeners.clear();
  const api = { setState, getState, subscribe, destroy };
  state = createState(
    setState,
    getState,
    api
  );
  return api;
};
const createStore = (createState) => createState ? createStoreImpl(createState) : createStoreImpl;



// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/use-sync-external-store/shim/with-selector.js
var with_selector = __webpack_require__(52798);
;// CONCATENATED MODULE: ./node_modules/zustand/esm/index.js






const { useSyncExternalStoreWithSelector } = with_selector;
function useStore(api, selector = api.getState, equalityFn) {
  const slice = useSyncExternalStoreWithSelector(
    api.subscribe,
    api.getState,
    api.getServerState || api.getState,
    selector,
    equalityFn
  );
  (0,react.useDebugValue)(slice);
  return slice;
}
const createImpl = (createState) => {
  const api = typeof createState === "function" ? createStore(createState) : createState;
  const useBoundStore = (selector, equalityFn) => useStore(api, selector, equalityFn);
  Object.assign(useBoundStore, api);
  return useBoundStore;
};
const create = (createState) => createState ? createImpl(createState) : createImpl;
var create$1 = create;




/***/ }),

/***/ 38597:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "mW": function() { return /* binding */ devtools; },
/* harmony export */   "tJ": function() { return /* binding */ persist; }
/* harmony export */ });
/* unused harmony exports combine, redux, subscribeWithSelector */
const reduxImpl = (reducer, initial) => (set, _get, api) => {
  api.dispatch = (action) => {
    set((state) => reducer(state, action), false, action);
    return action;
  };
  api.dispatchFromDevtools = true;
  return { dispatch: (...a) => api.dispatch(...a), ...initial };
};
const redux = (/* unused pure expression or super */ null && (reduxImpl));

const devtoolsImpl = (fn, devtoolsOptions = {}) => (set, get, api) => {
  const { enabled, anonymousActionType, ...options } = devtoolsOptions;
  let extensionConnector;
  try {
    extensionConnector = (enabled != null ? enabled : (/* unsupported import.meta.env */ undefined && 0) !== "production") && window.__REDUX_DEVTOOLS_EXTENSION__;
  } catch {
  }
  if (!extensionConnector) {
    if ( true && enabled) {
      console.warn(
        "[zustand devtools middleware] Please install/enable Redux devtools extension"
      );
    }
    return fn(set, get, api);
  }
  const extension = extensionConnector.connect(options);
  let isRecording = true;
  api.setState = (state, replace, nameOrAction) => {
    const r = set(state, replace);
    if (!isRecording)
      return r;
    extension.send(
      nameOrAction === void 0 ? { type: anonymousActionType || "anonymous" } : typeof nameOrAction === "string" ? { type: nameOrAction } : nameOrAction,
      get()
    );
    return r;
  };
  const setStateFromDevtools = (...a) => {
    const originalIsRecording = isRecording;
    isRecording = false;
    set(...a);
    isRecording = originalIsRecording;
  };
  const initialState = fn(api.setState, get, api);
  extension.init(initialState);
  if (api.dispatchFromDevtools && typeof api.dispatch === "function") {
    let didWarnAboutReservedActionType = false;
    const originalDispatch = api.dispatch;
    api.dispatch = (...a) => {
      if ( true && a[0].type === "__setState" && !didWarnAboutReservedActionType) {
        console.warn(
          '[zustand devtools middleware] "__setState" action type is reserved to set state from the devtools. Avoid using it.'
        );
        didWarnAboutReservedActionType = true;
      }
      originalDispatch(...a);
    };
  }
  extension.subscribe((message) => {
    var _a;
    switch (message.type) {
      case "ACTION":
        if (typeof message.payload !== "string") {
          console.error(
            "[zustand devtools middleware] Unsupported action format"
          );
          return;
        }
        return parseJsonThen(
          message.payload,
          (action) => {
            if (action.type === "__setState") {
              setStateFromDevtools(action.state);
              return;
            }
            if (!api.dispatchFromDevtools)
              return;
            if (typeof api.dispatch !== "function")
              return;
            api.dispatch(action);
          }
        );
      case "DISPATCH":
        switch (message.payload.type) {
          case "RESET":
            setStateFromDevtools(initialState);
            return extension.init(api.getState());
          case "COMMIT":
            return extension.init(api.getState());
          case "ROLLBACK":
            return parseJsonThen(message.state, (state) => {
              setStateFromDevtools(state);
              extension.init(api.getState());
            });
          case "JUMP_TO_STATE":
          case "JUMP_TO_ACTION":
            return parseJsonThen(message.state, (state) => {
              setStateFromDevtools(state);
            });
          case "IMPORT_STATE": {
            const { nextLiftedState } = message.payload;
            const lastComputedState = (_a = nextLiftedState.computedStates.slice(-1)[0]) == null ? void 0 : _a.state;
            if (!lastComputedState)
              return;
            setStateFromDevtools(lastComputedState);
            extension.send(
              null,
              nextLiftedState
            );
            return;
          }
          case "PAUSE_RECORDING":
            return isRecording = !isRecording;
        }
        return;
    }
  });
  return initialState;
};
const devtools = devtoolsImpl;
const parseJsonThen = (stringified, f) => {
  let parsed;
  try {
    parsed = JSON.parse(stringified);
  } catch (e) {
    console.error(
      "[zustand devtools middleware] Could not parse the received json",
      e
    );
  }
  if (parsed !== void 0)
    f(parsed);
};

const subscribeWithSelectorImpl = (fn) => (set, get, api) => {
  const origSubscribe = api.subscribe;
  api.subscribe = (selector, optListener, options) => {
    let listener = selector;
    if (optListener) {
      const equalityFn = (options == null ? void 0 : options.equalityFn) || Object.is;
      let currentSlice = selector(api.getState());
      listener = (state) => {
        const nextSlice = selector(state);
        if (!equalityFn(currentSlice, nextSlice)) {
          const previousSlice = currentSlice;
          optListener(currentSlice = nextSlice, previousSlice);
        }
      };
      if (options == null ? void 0 : options.fireImmediately) {
        optListener(currentSlice, currentSlice);
      }
    }
    return origSubscribe(listener);
  };
  const initialState = fn(set, get, api);
  return initialState;
};
const subscribeWithSelector = (/* unused pure expression or super */ null && (subscribeWithSelectorImpl));

const combine = (initialState, create) => (...a) => Object.assign({}, initialState, create(...a));

const toThenable = (fn) => (input) => {
  try {
    const result = fn(input);
    if (result instanceof Promise) {
      return result;
    }
    return {
      then(onFulfilled) {
        return toThenable(onFulfilled)(result);
      },
      catch(_onRejected) {
        return this;
      }
    };
  } catch (e) {
    return {
      then(_onFulfilled) {
        return this;
      },
      catch(onRejected) {
        return toThenable(onRejected)(e);
      }
    };
  }
};
const persistImpl = (config, baseOptions) => (set, get, api) => {
  let options = {
    getStorage: () => localStorage,
    serialize: JSON.stringify,
    deserialize: JSON.parse,
    partialize: (state) => state,
    version: 0,
    merge: (persistedState, currentState) => ({
      ...currentState,
      ...persistedState
    }),
    ...baseOptions
  };
  let hasHydrated = false;
  const hydrationListeners = /* @__PURE__ */ new Set();
  const finishHydrationListeners = /* @__PURE__ */ new Set();
  let storage;
  try {
    storage = options.getStorage();
  } catch (e) {
  }
  if (!storage) {
    return config(
      (...args) => {
        console.warn(
          `[zustand persist middleware] Unable to update item '${options.name}', the given storage is currently unavailable.`
        );
        set(...args);
      },
      get,
      api
    );
  }
  const thenableSerialize = toThenable(options.serialize);
  const setItem = () => {
    const state = options.partialize({ ...get() });
    let errorInSync;
    const thenable = thenableSerialize({ state, version: options.version }).then(
      (serializedValue) => storage.setItem(options.name, serializedValue)
    ).catch((e) => {
      errorInSync = e;
    });
    if (errorInSync) {
      throw errorInSync;
    }
    return thenable;
  };
  const savedSetState = api.setState;
  api.setState = (state, replace) => {
    savedSetState(state, replace);
    void setItem();
  };
  const configResult = config(
    (...args) => {
      set(...args);
      void setItem();
    },
    get,
    api
  );
  let stateFromStorage;
  const hydrate = () => {
    var _a;
    if (!storage)
      return;
    hasHydrated = false;
    hydrationListeners.forEach((cb) => cb(get()));
    const postRehydrationCallback = ((_a = options.onRehydrateStorage) == null ? void 0 : _a.call(options, get())) || void 0;
    return toThenable(storage.getItem.bind(storage))(options.name).then((storageValue) => {
      if (storageValue) {
        return options.deserialize(storageValue);
      }
    }).then((deserializedStorageValue) => {
      if (deserializedStorageValue) {
        if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
          if (options.migrate) {
            return options.migrate(
              deserializedStorageValue.state,
              deserializedStorageValue.version
            );
          }
          console.error(
            `State loaded from storage couldn't be migrated since no migrate function was provided`
          );
        } else {
          return deserializedStorageValue.state;
        }
      }
    }).then((migratedState) => {
      var _a2;
      stateFromStorage = options.merge(
        migratedState,
        (_a2 = get()) != null ? _a2 : configResult
      );
      set(stateFromStorage, true);
      return setItem();
    }).then(() => {
      postRehydrationCallback == null ? void 0 : postRehydrationCallback(stateFromStorage, void 0);
      hasHydrated = true;
      finishHydrationListeners.forEach((cb) => cb(stateFromStorage));
    }).catch((e) => {
      postRehydrationCallback == null ? void 0 : postRehydrationCallback(void 0, e);
    });
  };
  api.persist = {
    setOptions: (newOptions) => {
      options = {
        ...options,
        ...newOptions
      };
      if (newOptions.getStorage) {
        storage = newOptions.getStorage();
      }
    },
    clearStorage: () => {
      storage == null ? void 0 : storage.removeItem(options.name);
    },
    getOptions: () => options,
    rehydrate: () => hydrate(),
    hasHydrated: () => hasHydrated,
    onHydrate: (cb) => {
      hydrationListeners.add(cb);
      return () => {
        hydrationListeners.delete(cb);
      };
    },
    onFinishHydration: (cb) => {
      finishHydrationListeners.add(cb);
      return () => {
        finishHydrationListeners.delete(cb);
      };
    }
  };
  hydrate();
  return stateFromStorage || configResult;
};
const persist = persistImpl;




/***/ }),

/***/ 64836:
/***/ (function(module) {

function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 75263:
/***/ (function(module) {

var cache;
function _interopRequireWildcard(e, t) {
  if (!t && e && e.__esModule) return e;
  var r,
    c,
    a = Object.defineProperty,
    n = {
      __proto__: null,
      "default": e
    };
  if (Object(e) !== e) return n;
  if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) {
    if (cache.has(e)) return cache.get(e);
    cache.set(e, n);
  }
  for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]);
  return n;
}
module.exports = _interopRequireWildcard, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 7638:
/***/ (function(module, exports, __webpack_require__) {

var fetchApi = typeof fetch === 'function' ? fetch : undefined
if (typeof __webpack_require__.g !== 'undefined' && __webpack_require__.g.fetch) {
  fetchApi = __webpack_require__.g.fetch
} else if (typeof window !== 'undefined' && window.fetch) {
  fetchApi = window.fetch
}

if ( true && typeof window === 'undefined') {
  var f = fetchApi || __webpack_require__(54098)
  if (f.default) f = f.default
  exports["default"] = f
  module.exports = exports.default
}


/***/ }),

/***/ 78122:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _utils = __webpack_require__(58144);
var _request = _interopRequireDefault(__webpack_require__(93183));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var getDefaults = function getDefaults() {
  return {
    loadPath: '/locales/{{lng}}/{{ns}}.json',
    addPath: '/locales/add/{{lng}}/{{ns}}',
    parse: function parse(data) {
      return JSON.parse(data);
    },
    stringify: JSON.stringify,
    parsePayload: function parsePayload(namespace, key, fallbackValue) {
      return _defineProperty({}, key, fallbackValue || '');
    },
    parseLoadPayload: function parseLoadPayload(languages, namespaces) {
      return undefined;
    },
    request: _request.default,
    reloadInterval: typeof window !== 'undefined' ? false : 60 * 60 * 1000,
    customHeaders: {},
    queryStringParams: {},
    crossDomain: false,
    withCredentials: false,
    overrideMimeType: false,
    requestOptions: {
      mode: 'cors',
      credentials: 'same-origin',
      cache: 'default'
    }
  };
};
var Backend = function () {
  function Backend(services) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var allOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    _classCallCheck(this, Backend);
    this.services = services;
    this.options = options;
    this.allOptions = allOptions;
    this.type = 'backend';
    this.init(services, options, allOptions);
  }
  return _createClass(Backend, [{
    key: "init",
    value: function init(services) {
      var _this = this;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var allOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      this.services = services;
      this.options = _objectSpread(_objectSpread(_objectSpread({}, getDefaults()), this.options || {}), options);
      this.allOptions = allOptions;
      if (this.services && this.options.reloadInterval) {
        var timer = setInterval(function () {
          return _this.reload();
        }, this.options.reloadInterval);
        if (_typeof(timer) === 'object' && typeof timer.unref === 'function') timer.unref();
      }
    }
  }, {
    key: "readMulti",
    value: function readMulti(languages, namespaces, callback) {
      this._readAny(languages, languages, namespaces, namespaces, callback);
    }
  }, {
    key: "read",
    value: function read(language, namespace, callback) {
      this._readAny([language], language, [namespace], namespace, callback);
    }
  }, {
    key: "_readAny",
    value: function _readAny(languages, loadUrlLanguages, namespaces, loadUrlNamespaces, callback) {
      var _this2 = this;
      var loadPath = this.options.loadPath;
      if (typeof this.options.loadPath === 'function') {
        loadPath = this.options.loadPath(languages, namespaces);
      }
      loadPath = (0, _utils.makePromise)(loadPath);
      loadPath.then(function (resolvedLoadPath) {
        if (!resolvedLoadPath) return callback(null, {});
        var url = _this2.services.interpolator.interpolate(resolvedLoadPath, {
          lng: languages.join('+'),
          ns: namespaces.join('+')
        });
        _this2.loadUrl(url, callback, loadUrlLanguages, loadUrlNamespaces);
      });
    }
  }, {
    key: "loadUrl",
    value: function loadUrl(url, callback, languages, namespaces) {
      var _this3 = this;
      var lng = typeof languages === 'string' ? [languages] : languages;
      var ns = typeof namespaces === 'string' ? [namespaces] : namespaces;
      var payload = this.options.parseLoadPayload(lng, ns);
      this.options.request(this.options, url, payload, function (err, res) {
        if (res && (res.status >= 500 && res.status < 600 || !res.status)) return callback('failed loading ' + url + '; status code: ' + res.status, true);
        if (res && res.status >= 400 && res.status < 500) return callback('failed loading ' + url + '; status code: ' + res.status, false);
        if (!res && err && err.message) {
          var errorMessage = err.message.toLowerCase();
          var isNetworkError = ['failed', 'fetch', 'network', 'load'].find(function (term) {
            return errorMessage.indexOf(term) > -1;
          });
          if (isNetworkError) {
            return callback('failed loading ' + url + ': ' + err.message, true);
          }
        }
        if (err) return callback(err, false);
        var ret, parseErr;
        try {
          if (typeof res.data === 'string') {
            ret = _this3.options.parse(res.data, languages, namespaces);
          } else {
            ret = res.data;
          }
        } catch (e) {
          parseErr = 'failed parsing ' + url + ' to json';
        }
        if (parseErr) return callback(parseErr, false);
        callback(null, ret);
      });
    }
  }, {
    key: "create",
    value: function create(languages, namespace, key, fallbackValue, callback) {
      var _this4 = this;
      if (!this.options.addPath) return;
      if (typeof languages === 'string') languages = [languages];
      var payload = this.options.parsePayload(namespace, key, fallbackValue);
      var finished = 0;
      var dataArray = [];
      var resArray = [];
      languages.forEach(function (lng) {
        var addPath = _this4.options.addPath;
        if (typeof _this4.options.addPath === 'function') {
          addPath = _this4.options.addPath(lng, namespace);
        }
        var url = _this4.services.interpolator.interpolate(addPath, {
          lng: lng,
          ns: namespace
        });
        _this4.options.request(_this4.options, url, payload, function (data, res) {
          finished += 1;
          dataArray.push(data);
          resArray.push(res);
          if (finished === languages.length) {
            if (typeof callback === 'function') callback(dataArray, resArray);
          }
        });
      });
    }
  }, {
    key: "reload",
    value: function reload() {
      var _this5 = this;
      var _this$services = this.services,
        backendConnector = _this$services.backendConnector,
        languageUtils = _this$services.languageUtils,
        logger = _this$services.logger;
      var currentLanguage = backendConnector.language;
      if (currentLanguage && currentLanguage.toLowerCase() === 'cimode') return;
      var toLoad = [];
      var append = function append(lng) {
        var lngs = languageUtils.toResolveHierarchy(lng);
        lngs.forEach(function (l) {
          if (toLoad.indexOf(l) < 0) toLoad.push(l);
        });
      };
      append(currentLanguage);
      if (this.allOptions.preload) this.allOptions.preload.forEach(function (l) {
        return append(l);
      });
      toLoad.forEach(function (lng) {
        _this5.allOptions.ns.forEach(function (ns) {
          backendConnector.read(lng, ns, 'read', null, null, function (err, data) {
            if (err) logger.warn("loading namespace ".concat(ns, " for language ").concat(lng, " failed"), err);
            if (!err && data) logger.log("loaded namespace ".concat(ns, " for language ").concat(lng), data);
            backendConnector.loaded("".concat(lng, "|").concat(ns), err, data);
          });
        });
      });
    }
  }]);
}();
Backend.type = 'backend';
var _default = exports["default"] = Backend;
module.exports = exports.default;

/***/ }),

/***/ 93183:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _utils = __webpack_require__(58144);
var fetchNode = _interopRequireWildcard(__webpack_require__(7638));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var fetchApi = typeof fetch === 'function' ? fetch : undefined;
if (typeof __webpack_require__.g !== 'undefined' && __webpack_require__.g.fetch) {
  fetchApi = __webpack_require__.g.fetch;
} else if (typeof window !== 'undefined' && window.fetch) {
  fetchApi = window.fetch;
}
var XmlHttpRequestApi;
if ((0, _utils.hasXMLHttpRequest)()) {
  if (typeof __webpack_require__.g !== 'undefined' && __webpack_require__.g.XMLHttpRequest) {
    XmlHttpRequestApi = __webpack_require__.g.XMLHttpRequest;
  } else if (typeof window !== 'undefined' && window.XMLHttpRequest) {
    XmlHttpRequestApi = window.XMLHttpRequest;
  }
}
var ActiveXObjectApi;
if (typeof ActiveXObject === 'function') {
  if (typeof __webpack_require__.g !== 'undefined' && __webpack_require__.g.ActiveXObject) {
    ActiveXObjectApi = __webpack_require__.g.ActiveXObject;
  } else if (typeof window !== 'undefined' && window.ActiveXObject) {
    ActiveXObjectApi = window.ActiveXObject;
  }
}
if (!fetchApi && fetchNode && !XmlHttpRequestApi && !ActiveXObjectApi) fetchApi = fetchNode.default || fetchNode;
if (typeof fetchApi !== 'function') fetchApi = undefined;
var addQueryString = function addQueryString(url, params) {
  if (params && _typeof(params) === 'object') {
    var queryString = '';
    for (var paramName in params) {
      queryString += '&' + encodeURIComponent(paramName) + '=' + encodeURIComponent(params[paramName]);
    }
    if (!queryString) return url;
    url = url + (url.indexOf('?') !== -1 ? '&' : '?') + queryString.slice(1);
  }
  return url;
};
var fetchIt = function fetchIt(url, fetchOptions, callback, altFetch) {
  var resolver = function resolver(response) {
    if (!response.ok) return callback(response.statusText || 'Error', {
      status: response.status
    });
    response.text().then(function (data) {
      callback(null, {
        status: response.status,
        data: data
      });
    }).catch(callback);
  };
  if (altFetch) {
    var altResponse = altFetch(url, fetchOptions);
    if (altResponse instanceof Promise) {
      altResponse.then(resolver).catch(callback);
      return;
    }
  }
  if (typeof fetch === 'function') {
    fetch(url, fetchOptions).then(resolver).catch(callback);
  } else {
    fetchApi(url, fetchOptions).then(resolver).catch(callback);
  }
};
var omitFetchOptions = false;
var requestWithFetch = function requestWithFetch(options, url, payload, callback) {
  if (options.queryStringParams) {
    url = addQueryString(url, options.queryStringParams);
  }
  var headers = _objectSpread({}, typeof options.customHeaders === 'function' ? options.customHeaders() : options.customHeaders);
  if (typeof window === 'undefined' && typeof __webpack_require__.g !== 'undefined' && typeof __webpack_require__.g.process !== 'undefined' && __webpack_require__.g.process.versions && __webpack_require__.g.process.versions.node) {
    headers['User-Agent'] = "i18next-http-backend (node/".concat(__webpack_require__.g.process.version, "; ").concat(__webpack_require__.g.process.platform, " ").concat(__webpack_require__.g.process.arch, ")");
  }
  if (payload) headers['Content-Type'] = 'application/json';
  var reqOptions = typeof options.requestOptions === 'function' ? options.requestOptions(payload) : options.requestOptions;
  var fetchOptions = _objectSpread({
    method: payload ? 'POST' : 'GET',
    body: payload ? options.stringify(payload) : undefined,
    headers: headers
  }, omitFetchOptions ? {} : reqOptions);
  var altFetch = typeof options.alternateFetch === 'function' && options.alternateFetch.length >= 1 ? options.alternateFetch : undefined;
  try {
    fetchIt(url, fetchOptions, callback, altFetch);
  } catch (e) {
    if (!reqOptions || Object.keys(reqOptions).length === 0 || !e.message || e.message.indexOf('not implemented') < 0) {
      return callback(e);
    }
    try {
      Object.keys(reqOptions).forEach(function (opt) {
        delete fetchOptions[opt];
      });
      fetchIt(url, fetchOptions, callback, altFetch);
      omitFetchOptions = true;
    } catch (err) {
      callback(err);
    }
  }
};
var requestWithXmlHttpRequest = function requestWithXmlHttpRequest(options, url, payload, callback) {
  if (payload && _typeof(payload) === 'object') {
    payload = addQueryString('', payload).slice(1);
  }
  if (options.queryStringParams) {
    url = addQueryString(url, options.queryStringParams);
  }
  try {
    var x;
    if (XmlHttpRequestApi) {
      x = new XmlHttpRequestApi();
    } else {
      x = new ActiveXObjectApi('MSXML2.XMLHTTP.3.0');
    }
    x.open(payload ? 'POST' : 'GET', url, 1);
    if (!options.crossDomain) {
      x.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    }
    x.withCredentials = !!options.withCredentials;
    if (payload) {
      x.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    }
    if (x.overrideMimeType) {
      x.overrideMimeType('application/json');
    }
    var h = options.customHeaders;
    h = typeof h === 'function' ? h() : h;
    if (h) {
      for (var i in h) {
        x.setRequestHeader(i, h[i]);
      }
    }
    x.onreadystatechange = function () {
      x.readyState > 3 && callback(x.status >= 400 ? x.statusText : null, {
        status: x.status,
        data: x.responseText
      });
    };
    x.send(payload);
  } catch (e) {
    console && console.log(e);
  }
};
var request = function request(options, url, payload, callback) {
  if (typeof payload === 'function') {
    callback = payload;
    payload = undefined;
  }
  callback = callback || function () {};
  if (fetchApi && url.indexOf('file:') !== 0) {
    return requestWithFetch(options, url, payload, callback);
  }
  if ((0, _utils.hasXMLHttpRequest)() || typeof ActiveXObject === 'function') {
    return requestWithXmlHttpRequest(options, url, payload, callback);
  }
  callback(new Error('No fetch and no xhr implementation found!'));
};
var _default = exports["default"] = request;
module.exports = exports.default;

/***/ }),

/***/ 58144:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.defaults = defaults;
exports.hasXMLHttpRequest = hasXMLHttpRequest;
exports.makePromise = makePromise;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var arr = [];
var each = arr.forEach;
var slice = arr.slice;
function defaults(obj) {
  each.call(slice.call(arguments, 1), function (source) {
    if (source) {
      for (var prop in source) {
        if (obj[prop] === undefined) obj[prop] = source[prop];
      }
    }
  });
  return obj;
}
function hasXMLHttpRequest() {
  return typeof XMLHttpRequest === 'function' || (typeof XMLHttpRequest === "undefined" ? "undefined" : _typeof(XMLHttpRequest)) === 'object';
}
function isPromise(maybePromise) {
  return !!maybePromise && typeof maybePromise.then === 'function';
}
function makePromise(maybePromise) {
  if (isPromise(maybePromise)) {
    return maybePromise;
  }
  return Promise.resolve(maybePromise);
}

/***/ }),

/***/ 30907:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}


/***/ }),

/***/ 83878:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayWithHoles; }
/* harmony export */ });
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}


/***/ }),

/***/ 97326:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _assertThisInitialized; }
/* harmony export */ });
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}


/***/ }),

/***/ 15671:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _classCallCheck; }
/* harmony export */ });
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}


/***/ }),

/***/ 43144:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _createClass; }
/* harmony export */ });
/* harmony import */ var _toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83997);

function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0,_toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}


/***/ }),

/***/ 4942:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
/* harmony import */ var _toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83997);

function _defineProperty(e, r, t) {
  return (r = (0,_toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}


/***/ }),

/***/ 87462:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _extends; }
/* harmony export */ });
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}


/***/ }),

/***/ 94578:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _inheritsLoose; }
/* harmony export */ });
/* harmony import */ var _setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89611);

function _inheritsLoose(t, o) {
  t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0,_setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(t, o);
}


/***/ }),

/***/ 59199:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _iterableToArray; }
/* harmony export */ });
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}


/***/ }),

/***/ 25267:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _nonIterableRest; }
/* harmony export */ });
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


/***/ }),

/***/ 45987:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectWithoutProperties; }
/* harmony export */ });
/* harmony import */ var _objectWithoutPropertiesLoose_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63366);

function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = (0,_objectWithoutPropertiesLoose_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}


/***/ }),

/***/ 63366:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectWithoutPropertiesLoose; }
/* harmony export */ });
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}


/***/ }),

/***/ 89611:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _setPrototypeOf; }
/* harmony export */ });
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}


/***/ }),

/***/ 97685:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
var arrayWithHoles = __webpack_require__(83878);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(40181);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
var nonIterableRest = __webpack_require__(25267);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(r, e) {
  return (0,arrayWithHoles/* default */.Z)(r) || _iterableToArrayLimit(r, e) || (0,unsupportedIterableToArray/* default */.Z)(r, e) || (0,nonIterableRest/* default */.Z)();
}


/***/ }),

/***/ 74902:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
var arrayLikeToArray = __webpack_require__(30907);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return (0,arrayLikeToArray/* default */.Z)(r);
}

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArray.js
var iterableToArray = __webpack_require__(59199);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(40181);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js




function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || (0,iterableToArray/* default */.Z)(r) || (0,unsupportedIterableToArray/* default */.Z)(r) || _nonIterableSpread();
}


/***/ }),

/***/ 83997:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ toPropertyKey; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(71002);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toPrimitive.js

function toPrimitive(t, e) {
  if ("object" != (0,esm_typeof/* default */.Z)(t) || !t) return t;
  var r;
  if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) {
    var i = r.call(t, e || "default");
    if ("object" != (0,esm_typeof/* default */.Z)(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === e ? String : Number)(t);
}

;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toPropertyKey.js


function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == (0,esm_typeof/* default */.Z)(i) ? i : i + "";
}


/***/ }),

/***/ 71002:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _typeof; }
/* harmony export */ });
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}


/***/ }),

/***/ 40181:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30907);

function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(r, a) : void 0;
  }
}


/***/ }),

/***/ 20943:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}


/***/ }),

/***/ 39474:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayWithHoles; }
/* harmony export */ });
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}


/***/ }),

/***/ 47568:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}


/***/ }),

/***/ 14924:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}


/***/ }),

/***/ 40872:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _extends; }
/* harmony export */ });
function extends_() {
  extends_ = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return extends_.apply(this, arguments);
}

function _extends() {
  return extends_.apply(this, arguments);
}


/***/ }),

/***/ 82670:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _instanceof; }
/* harmony export */ });
function _instanceof(left, right) {
  if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
    return !!right[Symbol.hasInstance](left);
  } else {
    return left instanceof right;
  }
}

/***/ }),

/***/ 13375:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _iterableToArray; }
/* harmony export */ });
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


/***/ }),

/***/ 53128:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _nonIterableRest; }
/* harmony export */ });
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


/***/ }),

/***/ 26042:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpread; }
/* harmony export */ });
/* harmony import */ var _define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14924);


function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      (0,_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    });
  }

  return target;
}

/***/ }),

/***/ 69396:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpreadProps; }
/* harmony export */ });
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}

function _objectSpreadProps(target, source) {
  source = source != null ? source : {}
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(
        target,
        key,
        Object.getOwnPropertyDescriptor(source, key)
      );
    });
  }

  return target;
}

/***/ }),

/***/ 99534:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties_loose.mjs
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs


function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ }),

/***/ 10253:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _slicedToArray; }
/* harmony export */ });
/* harmony import */ var _array_with_holes_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39474);
/* harmony import */ var _iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13375);
/* harmony import */ var _non_iterable_rest_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53128);
/* harmony import */ var _unsupported_iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91566);





function _slicedToArray(arr, i) {
  return (0,_array_with_holes_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(arr) || (0,_iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(arr, i) || (0,_unsupported_iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(arr, i) || (0,_non_iterable_rest_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
}


/***/ }),

/***/ 29815:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_array_like_to_array.mjs
var _array_like_to_array = __webpack_require__(20943);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_without_holes.mjs


function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,_array_like_to_array/* default */.Z)(arr);
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(13375);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_spread.mjs
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(91566);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs





function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr) || (0,_unsupported_iterable_to_array/* default */.Z)(arr) || _nonIterableSpread();
}


/***/ }),

/***/ 91566:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20943);


function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}


/***/ }),

/***/ 67421:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a3": function() { return /* reexport */ I18nextProvider; },
  "$G": function() { return /* reexport */ useTranslation_useTranslation; }
});

// UNUSED EXPORTS: I18nContext, Trans, TransWithoutContext, Translation, composeInitialProps, date, getDefaults, getI18n, getInitialProps, initReactI18next, number, plural, select, selectOrdinal, setDefaults, setI18n, time, useSSR, withSSR, withTranslation

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/void-elements/index.js
var void_elements = __webpack_require__(71739);
var void_elements_default = /*#__PURE__*/__webpack_require__.n(void_elements);
;// CONCATENATED MODULE: ./node_modules/html-parse-stringify/dist/html-parse-stringify.module.js
var e=/\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?("[^"]*"|'[^']*')/g;function n(n){var r={type:"tag",name:"",voidElement:!1,attrs:{},children:[]},i=n.match(/<\/?([^\s]+?)[/\s>]/);if(i&&(r.name=i[1],((void_elements_default())[i[1]]||"/"===n.charAt(n.length-2))&&(r.voidElement=!0),r.name.startsWith("!--"))){var s=n.indexOf("--\x3e");return{type:"comment",comment:-1!==s?n.slice(4,s):""}}for(var a=new RegExp(e),c=null;null!==(c=a.exec(n));)if(c[0].trim())if(c[1]){var l=c[1].trim(),o=[l,""];l.indexOf("=")>-1&&(o=l.split("=")),r.attrs[o[0]]=o[1],a.lastIndex--}else c[2]&&(r.attrs[c[2]]=c[3].trim().substring(1,c[3].length-1));return r}var r=/<[a-zA-Z0-9\-\!\/](?:"[^"]*"|'[^']*'|[^'">])*>/g,i=/^\s*$/,s=Object.create(null);function a(t,e){switch(e.type){case"text":return t+e.content;case"tag":return t+="<"+e.name+(e.attrs?function(t){var e=[];for(var n in t)e.push(n+'="'+t[n]+'"');return e.length?" "+e.join(" "):""}(e.attrs):"")+(e.voidElement?"/>":">"),e.voidElement?t:t+e.children.reduce(a,"")+"</"+e.name+">";case"comment":return t+"\x3c!--"+e.comment+"--\x3e"}}var c={parse:function(t,e){e||(e={}),e.components||(e.components=s);var a,c=[],l=[],o=-1,u=!1;if(0!==t.indexOf("<")){var h=t.indexOf("<");c.push({type:"text",content:-1===h?t:t.substring(0,h)})}for(var v,f=[];v=r.exec(t);)f.push(v);return f.forEach(function(t,e){var n=t[0];if(n&&!n.startsWith("\x3c!--")){for(var r=0,i=0,s=-1,a=null,c=0;c<n.length;c++){var l=n.charAt(c);a?l===a&&(a=null):'"'===l||"'"===l?a=l:"<"===l?2==++r&&(s=c):">"===l&&i++}var o=s>-1&&/[a-zA-Z0-9\-!/]/.test(n.charAt(s+1));if(r>i&&o){var u=n.substring(0,s),h=n.substring(u.length);f[e][0]=h,f[e].index+=u.length}}}),f.forEach(function(r,s){var h=r[0];if(h){var v=r.index;if(u){if(h!=="</"+a.name+">")return;u=!1}var m,d,p="/"!==h.charAt(1),x=h.startsWith("\x3c!--"),g=v+h.length,y=t.charAt(g),E=f[s+1];if("<"===y&&E){var A=t.substring(g,E.index);m=A.split("<").length>A.split(">").length}if(x){var b=n(h);if(o<0)return c.push(b),c;(d=l[o]).children.push(b);var O=t.slice(g,E?E.index:void 0);return O.length>0&&d.children.push({type:"text",content:O}),c}if(p&&(o++,"tag"===(a=n(h)).type&&e.components[a.name]&&(a.type="component",u=!0),a.voidElement||u||!y||"<"===y||a.children.push({type:"text",content:t.slice(g,E?E.index:void 0)}),0===o&&c.push(a),(d=l[o-1])&&d.children.push(a),l[o]=a),(!p||a.voidElement)&&(o>-1&&(a.voidElement||a.name===h.slice(2,-1))&&(o--,a=-1===o?c:l[o]),!u&&("<"!==y||m)&&y)){d=-1===o?c:l[o].children;var W=E?E.index:-1,j=t.slice(g,-1===W?void 0:W);i.test(j)&&(j=" "),(W>-1&&o+d.length>=0||" "!==j)&&d.push({type:"text",content:j})}}}),c},stringify:function(t){return t.reduce(function(t,e){return t+a("",e)},"")}};/* harmony default export */ var html_parse_stringify_module = ((/* unused pure expression or super */ null && (c)));
//# sourceMappingURL=html-parse-stringify.module.js.map

;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/utils.js
function utils_warn() {
  if (console && console.warn) {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    if (utils_isString(args[0])) args[0] = `react-i18next:: ${args[0]}`;
    console.warn(...args);
  }
}
const alreadyWarned = {};
function utils_warnOnce() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }
  if (utils_isString(args[0]) && alreadyWarned[args[0]]) return;
  if (utils_isString(args[0])) alreadyWarned[args[0]] = new Date();
  utils_warn(...args);
}
const loadedClb = (i18n, cb) => () => {
  if (i18n.isInitialized) {
    cb();
  } else {
    const initialized = () => {
      setTimeout(() => {
        i18n.off('initialized', initialized);
      }, 0);
      cb();
    };
    i18n.on('initialized', initialized);
  }
};
const loadNamespaces = (i18n, ns, cb) => {
  i18n.loadNamespaces(ns, loadedClb(i18n, cb));
};
const loadLanguages = (i18n, lng, ns, cb) => {
  if (utils_isString(ns)) ns = [ns];
  ns.forEach(n => {
    if (i18n.options.ns.indexOf(n) < 0) i18n.options.ns.push(n);
  });
  i18n.loadLanguages(lng, loadedClb(i18n, cb));
};
const oldI18nextHasLoadedNamespace = function (ns, i18n) {
  let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  const lng = i18n.languages[0];
  const fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
  const lastLng = i18n.languages[i18n.languages.length - 1];
  if (lng.toLowerCase() === 'cimode') return true;
  const loadNotPending = (l, n) => {
    const loadState = i18n.services.backendConnector.state[`${l}|${n}`];
    return loadState === -1 || loadState === 2;
  };
  if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns)) return false;
  if (i18n.hasResourceBundle(lng, ns)) return true;
  if (!i18n.services.backendConnector.backend || i18n.options.resources && !i18n.options.partialBundledLanguages) return true;
  if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
  return false;
};
const hasLoadedNamespace = function (ns, i18n) {
  let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  if (!i18n.languages || !i18n.languages.length) {
    utils_warnOnce('i18n.languages were undefined or empty', i18n.languages);
    return true;
  }
  const isNewerI18next = i18n.options.ignoreJSONStructure !== undefined;
  if (!isNewerI18next) {
    return oldI18nextHasLoadedNamespace(ns, i18n, options);
  }
  return i18n.hasLoadedNamespace(ns, {
    lng: options.lng,
    precheck: (i18nInstance, loadNotPending) => {
      if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
    }
  });
};
const utils_getDisplayName = Component => Component.displayName || Component.name || (utils_isString(Component) && Component.length > 0 ? Component : 'Unknown');
const utils_isString = obj => typeof obj === 'string';
const utils_isObject = obj => typeof obj === 'object' && obj !== null;
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/unescape.js
const matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
const htmlEntities = {
  '&amp;': '&',
  '&#38;': '&',
  '&lt;': '<',
  '&#60;': '<',
  '&gt;': '>',
  '&#62;': '>',
  '&apos;': "'",
  '&#39;': "'",
  '&quot;': '"',
  '&#34;': '"',
  '&nbsp;': ' ',
  '&#160;': ' ',
  '&copy;': '©',
  '&#169;': '©',
  '&reg;': '®',
  '&#174;': '®',
  '&hellip;': '…',
  '&#8230;': '…',
  '&#x2F;': '/',
  '&#47;': '/'
};
const unescapeHtmlEntity = m => htmlEntities[m];
const unescape_unescape = text => text.replace(matchHtmlEntity, unescapeHtmlEntity);
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/defaults.js

let defaultOptions = {
  bindI18n: 'languageChanged',
  bindI18nStore: '',
  transEmptyNodeValue: '',
  transSupportBasicHtmlNodes: true,
  transWrapTextNodes: '',
  transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p'],
  useSuspense: true,
  unescape: unescape_unescape
};
const setDefaults = function () {
  let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  defaultOptions = {
    ...defaultOptions,
    ...options
  };
};
const defaults_getDefaults = () => defaultOptions;
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/TransWithoutContext.js





const hasChildren = (node, checkLength) => {
  if (!node) return false;
  const base = node.props ? node.props.children : node.children;
  if (checkLength) return base.length > 0;
  return !!base;
};
const getChildren = node => {
  if (!node) return [];
  const children = node.props ? node.props.children : node.children;
  return node.props && node.props.i18nIsDynamicList ? getAsArray(children) : children;
};
const hasValidReactChildren = children => Array.isArray(children) && children.every(isValidElement);
const getAsArray = data => Array.isArray(data) ? data : [data];
const mergeProps = (source, target) => {
  const newTarget = {
    ...target
  };
  newTarget.props = Object.assign(source.props, target.props);
  return newTarget;
};
const nodesToString = (children, i18nOptions) => {
  if (!children) return '';
  let stringNode = '';
  const childrenArray = getAsArray(children);
  const keepArray = i18nOptions.transSupportBasicHtmlNodes && i18nOptions.transKeepBasicHtmlNodesFor ? i18nOptions.transKeepBasicHtmlNodesFor : [];
  childrenArray.forEach((child, childIndex) => {
    if (isString(child)) {
      stringNode += `${child}`;
    } else if (isValidElement(child)) {
      const {
        props,
        type
      } = child;
      const childPropsCount = Object.keys(props).length;
      const shouldKeepChild = keepArray.indexOf(type) > -1;
      const childChildren = props.children;
      if (!childChildren && shouldKeepChild && !childPropsCount) {
        stringNode += `<${type}/>`;
      } else if (!childChildren && (!shouldKeepChild || childPropsCount) || props.i18nIsDynamicList) {
        stringNode += `<${childIndex}></${childIndex}>`;
      } else if (shouldKeepChild && childPropsCount === 1 && isString(childChildren)) {
        stringNode += `<${type}>${childChildren}</${type}>`;
      } else {
        const content = nodesToString(childChildren, i18nOptions);
        stringNode += `<${childIndex}>${content}</${childIndex}>`;
      }
    } else if (child === null) {
      warn(`Trans: the passed in value is invalid - seems you passed in a null child.`);
    } else if (isObject(child)) {
      const {
        format,
        ...clone
      } = child;
      const keys = Object.keys(clone);
      if (keys.length === 1) {
        const value = format ? `${keys[0]}, ${format}` : keys[0];
        stringNode += `{{${value}}}`;
      } else {
        warn(`react-i18next: the passed in object contained more than one variable - the object should look like {{ value, format }} where format is optional.`, child);
      }
    } else {
      warn(`Trans: the passed in value is invalid - seems you passed in a variable like {number} - please pass in variables for interpolation as full objects like {{number}}.`, child);
    }
  });
  return stringNode;
};
const renderNodes = (children, targetString, i18n, i18nOptions, combinedTOpts, shouldUnescape) => {
  if (targetString === '') return [];
  const keepArray = i18nOptions.transKeepBasicHtmlNodesFor || [];
  const emptyChildrenButNeedsHandling = targetString && new RegExp(keepArray.map(keep => `<${keep}`).join('|')).test(targetString);
  if (!children && !emptyChildrenButNeedsHandling && !shouldUnescape) return [targetString];
  const data = {};
  const getData = childs => {
    const childrenArray = getAsArray(childs);
    childrenArray.forEach(child => {
      if (isString(child)) return;
      if (hasChildren(child)) getData(getChildren(child));else if (isObject(child) && !isValidElement(child)) Object.assign(data, child);
    });
  };
  getData(children);
  const ast = HTML.parse(`<0>${targetString}</0>`);
  const opts = {
    ...data,
    ...combinedTOpts
  };
  const renderInner = (child, node, rootReactNode) => {
    const childs = getChildren(child);
    const mappedChildren = mapAST(childs, node.children, rootReactNode);
    return hasValidReactChildren(childs) && mappedChildren.length === 0 || child.props && child.props.i18nIsDynamicList ? childs : mappedChildren;
  };
  const pushTranslatedJSX = (child, inner, mem, i, isVoid) => {
    if (child.dummy) {
      child.children = inner;
      mem.push(cloneElement(child, {
        key: i
      }, isVoid ? undefined : inner));
    } else {
      mem.push(...Children.map([child], c => {
        const props = {
          ...c.props
        };
        delete props.i18nIsDynamicList;
        return createElement(c.type, {
          ...props,
          key: i,
          ref: c.ref
        }, isVoid ? null : inner);
      }));
    }
  };
  const mapAST = (reactNode, astNode, rootReactNode) => {
    const reactNodes = getAsArray(reactNode);
    const astNodes = getAsArray(astNode);
    return astNodes.reduce((mem, node, i) => {
      const translationContent = node.children && node.children[0] && node.children[0].content && i18n.services.interpolator.interpolate(node.children[0].content, opts, i18n.language);
      if (node.type === 'tag') {
        let tmp = reactNodes[parseInt(node.name, 10)];
        if (rootReactNode.length === 1 && !tmp) tmp = rootReactNode[0][node.name];
        if (!tmp) tmp = {};
        const child = Object.keys(node.attrs).length !== 0 ? mergeProps({
          props: node.attrs
        }, tmp) : tmp;
        const isElement = isValidElement(child);
        const isValidTranslationWithChildren = isElement && hasChildren(node, true) && !node.voidElement;
        const isEmptyTransWithHTML = emptyChildrenButNeedsHandling && isObject(child) && child.dummy && !isElement;
        const isKnownComponent = isObject(children) && Object.hasOwnProperty.call(children, node.name);
        if (isString(child)) {
          const value = i18n.services.interpolator.interpolate(child, opts, i18n.language);
          mem.push(value);
        } else if (hasChildren(child) || isValidTranslationWithChildren) {
          const inner = renderInner(child, node, rootReactNode);
          pushTranslatedJSX(child, inner, mem, i);
        } else if (isEmptyTransWithHTML) {
          const inner = mapAST(reactNodes, node.children, rootReactNode);
          pushTranslatedJSX(child, inner, mem, i);
        } else if (Number.isNaN(parseFloat(node.name))) {
          if (isKnownComponent) {
            const inner = renderInner(child, node, rootReactNode);
            pushTranslatedJSX(child, inner, mem, i, node.voidElement);
          } else if (i18nOptions.transSupportBasicHtmlNodes && keepArray.indexOf(node.name) > -1) {
            if (node.voidElement) {
              mem.push(createElement(node.name, {
                key: `${node.name}-${i}`
              }));
            } else {
              const inner = mapAST(reactNodes, node.children, rootReactNode);
              mem.push(createElement(node.name, {
                key: `${node.name}-${i}`
              }, inner));
            }
          } else if (node.voidElement) {
            mem.push(`<${node.name} />`);
          } else {
            const inner = mapAST(reactNodes, node.children, rootReactNode);
            mem.push(`<${node.name}>${inner}</${node.name}>`);
          }
        } else if (isObject(child) && !isElement) {
          const content = node.children[0] ? translationContent : null;
          if (content) mem.push(content);
        } else {
          pushTranslatedJSX(child, translationContent, mem, i, node.children.length !== 1 || !translationContent);
        }
      } else if (node.type === 'text') {
        const wrapTextNodes = i18nOptions.transWrapTextNodes;
        const content = shouldUnescape ? i18nOptions.unescape(i18n.services.interpolator.interpolate(node.content, opts, i18n.language)) : i18n.services.interpolator.interpolate(node.content, opts, i18n.language);
        if (wrapTextNodes) {
          mem.push(createElement(wrapTextNodes, {
            key: `${node.name}-${i}`
          }, content));
        } else {
          mem.push(content);
        }
      }
      return mem;
    }, []);
  };
  const result = mapAST([{
    dummy: true,
    children: children || []
  }], ast, getAsArray(children || []));
  return getChildren(result[0]);
};
function Trans(_ref) {
  let {
    children,
    count,
    parent,
    i18nKey,
    context,
    tOptions = {},
    values,
    defaults,
    components,
    ns,
    i18n: i18nFromProps,
    t: tFromProps,
    shouldUnescape,
    ...additionalProps
  } = _ref;
  const i18n = i18nFromProps || getI18n();
  if (!i18n) {
    warnOnce('You will need to pass in an i18next instance by using i18nextReactModule');
    return children;
  }
  const t = tFromProps || i18n.t.bind(i18n) || (k => k);
  const reactI18nextOptions = {
    ...getDefaults(),
    ...(i18n.options && i18n.options.react)
  };
  let namespaces = ns || t.ns || i18n.options && i18n.options.defaultNS;
  namespaces = isString(namespaces) ? [namespaces] : namespaces || ['translation'];
  const nodeAsString = nodesToString(children, reactI18nextOptions);
  const defaultValue = defaults || nodeAsString || reactI18nextOptions.transEmptyNodeValue || i18nKey;
  const {
    hashTransKey
  } = reactI18nextOptions;
  const key = i18nKey || (hashTransKey ? hashTransKey(nodeAsString || defaultValue) : nodeAsString || defaultValue);
  if (i18n.options && i18n.options.interpolation && i18n.options.interpolation.defaultVariables) {
    values = values && Object.keys(values).length > 0 ? {
      ...values,
      ...i18n.options.interpolation.defaultVariables
    } : {
      ...i18n.options.interpolation.defaultVariables
    };
  }
  const interpolationOverride = values || count !== undefined || !children ? tOptions.interpolation : {
    interpolation: {
      ...tOptions.interpolation,
      prefix: '#$?',
      suffix: '?$#'
    }
  };
  const combinedTOpts = {
    ...tOptions,
    context: context || tOptions.context,
    count,
    ...values,
    ...interpolationOverride,
    defaultValue,
    ns: namespaces
  };
  const translation = key ? t(key, combinedTOpts) : defaultValue;
  if (components) {
    Object.keys(components).forEach(c => {
      const comp = components[c];
      if (typeof comp.type === 'function' || !comp.props || !comp.props.children || translation.indexOf(`${c}/>`) < 0 && translation.indexOf(`${c} />`) < 0) return;
      function Componentized() {
        return createElement(Fragment, null, comp);
      }
      components[c] = createElement(Componentized);
    });
  }
  const content = renderNodes(components || children, translation, i18n, reactI18nextOptions, combinedTOpts, shouldUnescape);
  const useAsParent = parent !== undefined ? parent : reactI18nextOptions.defaultTransParent;
  return useAsParent ? createElement(useAsParent, additionalProps, content) : content;
}
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/i18nInstance.js
let i18nInstance;
const setI18n = instance => {
  i18nInstance = instance;
};
const i18nInstance_getI18n = () => i18nInstance;
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/initReactI18next.js


const initReactI18next = {
  type: '3rdParty',
  init(instance) {
    setDefaults(instance.options.react);
    setI18n(instance);
  }
};
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/context.js





const context_I18nContext = (0,react.createContext)();
class ReportNamespaces {
  constructor() {
    this.usedNamespaces = {};
  }
  addUsedNamespaces(namespaces) {
    namespaces.forEach(ns => {
      if (!this.usedNamespaces[ns]) this.usedNamespaces[ns] = true;
    });
  }
  getUsedNamespaces = () => Object.keys(this.usedNamespaces);
}
const context_composeInitialProps = ForComponent => async ctx => {
  const componentsInitialProps = ForComponent.getInitialProps ? await ForComponent.getInitialProps(ctx) : {};
  const i18nInitialProps = getInitialProps();
  return {
    ...componentsInitialProps,
    ...i18nInitialProps
  };
};
const getInitialProps = () => {
  const i18n = getI18n();
  const namespaces = i18n.reportNamespaces ? i18n.reportNamespaces.getUsedNamespaces() : [];
  const ret = {};
  const initialI18nStore = {};
  i18n.languages.forEach(l => {
    initialI18nStore[l] = {};
    namespaces.forEach(ns => {
      initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
    });
  });
  ret.initialI18nStore = initialI18nStore;
  ret.initialLanguage = i18n.language;
  return ret;
};
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/Trans.js




function Trans_Trans(_ref) {
  let {
    children,
    count,
    parent,
    i18nKey,
    context,
    tOptions = {},
    values,
    defaults,
    components,
    ns,
    i18n: i18nFromProps,
    t: tFromProps,
    shouldUnescape,
    ...additionalProps
  } = _ref;
  const {
    i18n: i18nFromContext,
    defaultNS: defaultNSFromContext
  } = useContext(I18nContext) || {};
  const i18n = i18nFromProps || i18nFromContext || getI18n();
  const t = tFromProps || i18n && i18n.t.bind(i18n);
  return TransWithoutContext({
    children,
    count,
    parent,
    i18nKey,
    context,
    tOptions,
    values,
    defaults,
    components,
    ns: ns || t && t.ns || defaultNSFromContext || i18n && i18n.options && i18n.options.defaultNS,
    i18n,
    t: tFromProps,
    shouldUnescape,
    ...additionalProps
  });
}
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js



const usePrevious = (value, ignore) => {
  const ref = (0,react.useRef)();
  (0,react.useEffect)(() => {
    ref.current = ignore ? ref.current : value;
  }, [value, ignore]);
  return ref.current;
};
const alwaysNewT = (i18n, language, namespace, keyPrefix) => i18n.getFixedT(language, namespace, keyPrefix);
const useMemoizedT = (i18n, language, namespace, keyPrefix) => (0,react.useCallback)(alwaysNewT(i18n, language, namespace, keyPrefix), [i18n, language, namespace, keyPrefix]);
const useTranslation_useTranslation = function (ns) {
  let props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const {
    i18n: i18nFromProps
  } = props;
  const {
    i18n: i18nFromContext,
    defaultNS: defaultNSFromContext
  } = (0,react.useContext)(context_I18nContext) || {};
  const i18n = i18nFromProps || i18nFromContext || i18nInstance_getI18n();
  if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new ReportNamespaces();
  if (!i18n) {
    utils_warnOnce('You will need to pass in an i18next instance by using initReactI18next');
    const notReadyT = (k, optsOrDefaultValue) => {
      if (utils_isString(optsOrDefaultValue)) return optsOrDefaultValue;
      if (utils_isObject(optsOrDefaultValue) && utils_isString(optsOrDefaultValue.defaultValue)) return optsOrDefaultValue.defaultValue;
      return Array.isArray(k) ? k[k.length - 1] : k;
    };
    const retNotReady = [notReadyT, {}, false];
    retNotReady.t = notReadyT;
    retNotReady.i18n = {};
    retNotReady.ready = false;
    return retNotReady;
  }
  if (i18n.options.react && i18n.options.react.wait !== undefined) utils_warnOnce('It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.');
  const i18nOptions = {
    ...defaults_getDefaults(),
    ...i18n.options.react,
    ...props
  };
  const {
    useSuspense,
    keyPrefix
  } = i18nOptions;
  let namespaces = ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
  namespaces = utils_isString(namespaces) ? [namespaces] : namespaces || ['translation'];
  if (i18n.reportNamespaces.addUsedNamespaces) i18n.reportNamespaces.addUsedNamespaces(namespaces);
  const ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every(n => hasLoadedNamespace(n, i18n, i18nOptions));
  const memoGetT = useMemoizedT(i18n, props.lng || null, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix);
  const getT = () => memoGetT;
  const getNewT = () => alwaysNewT(i18n, props.lng || null, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix);
  const [t, setT] = (0,react.useState)(getT);
  let joinedNS = namespaces.join();
  if (props.lng) joinedNS = `${props.lng}${joinedNS}`;
  const previousJoinedNS = usePrevious(joinedNS);
  const isMounted = (0,react.useRef)(true);
  (0,react.useEffect)(() => {
    const {
      bindI18n,
      bindI18nStore
    } = i18nOptions;
    isMounted.current = true;
    if (!ready && !useSuspense) {
      if (props.lng) {
        loadLanguages(i18n, props.lng, namespaces, () => {
          if (isMounted.current) setT(getNewT);
        });
      } else {
        loadNamespaces(i18n, namespaces, () => {
          if (isMounted.current) setT(getNewT);
        });
      }
    }
    if (ready && previousJoinedNS && previousJoinedNS !== joinedNS && isMounted.current) {
      setT(getNewT);
    }
    const boundReset = () => {
      if (isMounted.current) setT(getNewT);
    };
    if (bindI18n && i18n) i18n.on(bindI18n, boundReset);
    if (bindI18nStore && i18n) i18n.store.on(bindI18nStore, boundReset);
    return () => {
      isMounted.current = false;
      if (bindI18n && i18n) bindI18n.split(' ').forEach(e => i18n.off(e, boundReset));
      if (bindI18nStore && i18n) bindI18nStore.split(' ').forEach(e => i18n.store.off(e, boundReset));
    };
  }, [i18n, joinedNS]);
  (0,react.useEffect)(() => {
    if (isMounted.current && ready) {
      setT(getT);
    }
  }, [i18n, keyPrefix, ready]);
  const ret = [t, i18n, ready];
  ret.t = t;
  ret.i18n = i18n;
  ret.ready = ready;
  if (ready) return ret;
  if (!ready && !useSuspense) return ret;
  throw new Promise(resolve => {
    if (props.lng) {
      loadLanguages(i18n, props.lng, namespaces, () => resolve());
    } else {
      loadNamespaces(i18n, namespaces, () => resolve());
    }
  });
};
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/withTranslation.js



const withTranslation = function (ns) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function Extend(WrappedComponent) {
    function I18nextWithTranslation(_ref) {
      let {
        forwardedRef,
        ...rest
      } = _ref;
      const [t, i18n, ready] = useTranslation(ns, {
        ...rest,
        keyPrefix: options.keyPrefix
      });
      const passDownProps = {
        ...rest,
        t,
        i18n,
        tReady: ready
      };
      if (options.withRef && forwardedRef) {
        passDownProps.ref = forwardedRef;
      } else if (!options.withRef && forwardedRef) {
        passDownProps.forwardedRef = forwardedRef;
      }
      return createElement(WrappedComponent, passDownProps);
    }
    I18nextWithTranslation.displayName = `withI18nextTranslation(${getDisplayName(WrappedComponent)})`;
    I18nextWithTranslation.WrappedComponent = WrappedComponent;
    const forwardRef = (props, ref) => createElement(I18nextWithTranslation, Object.assign({}, props, {
      forwardedRef: ref
    }));
    return options.withRef ? forwardRefReact(forwardRef) : I18nextWithTranslation;
  };
};
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/Translation.js

function Translation(props) {
  const {
    ns,
    children,
    ...options
  } = props;
  const [t, i18n, ready] = useTranslation(ns, options);
  return children(t, {
    i18n,
    lng: i18n.language
  }, ready);
}
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/I18nextProvider.js


function I18nextProvider(_ref) {
  let {
    i18n,
    defaultNS,
    children
  } = _ref;
  const value = (0,react.useMemo)(() => ({
    i18n,
    defaultNS
  }), [i18n, defaultNS]);
  return (0,react.createElement)(context_I18nContext.Provider, {
    value
  }, children);
}
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/useSSR.js


const useSSR_useSSR = function (initialI18nStore, initialLanguage) {
  let props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  const {
    i18n: i18nFromProps
  } = props;
  const {
    i18n: i18nFromContext
  } = useContext(I18nContext) || {};
  const i18n = i18nFromProps || i18nFromContext || getI18n();
  if (i18n.options && i18n.options.isClone) return;
  if (initialI18nStore && !i18n.initializedStoreOnce) {
    i18n.services.resourceStore.data = initialI18nStore;
    i18n.options.ns = Object.values(initialI18nStore).reduce((mem, lngResources) => {
      Object.keys(lngResources).forEach(ns => {
        if (mem.indexOf(ns) < 0) mem.push(ns);
      });
      return mem;
    }, i18n.options.ns);
    i18n.initializedStoreOnce = true;
    i18n.isInitialized = true;
  }
  if (initialLanguage && !i18n.initializedLanguageOnce) {
    i18n.changeLanguage(initialLanguage);
    i18n.initializedLanguageOnce = true;
  }
};
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/withSSR.js




const withSSR = () => function Extend(WrappedComponent) {
  function I18nextWithSSR(_ref) {
    let {
      initialI18nStore,
      initialLanguage,
      ...rest
    } = _ref;
    useSSR(initialI18nStore, initialLanguage);
    return createElement(WrappedComponent, {
      ...rest
    });
  }
  I18nextWithSSR.getInitialProps = composeInitialProps(WrappedComponent);
  I18nextWithSSR.displayName = `withI18nextSSR(${getDisplayName(WrappedComponent)})`;
  I18nextWithSSR.WrappedComponent = WrappedComponent;
  return I18nextWithSSR;
};
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/index.js












const date = () => '';
const time = () => '';
const number = () => '';
const es_select = () => '';
const plural = () => '';
const selectOrdinal = () => '';

/***/ }),

/***/ 91444:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Ix": function() { return /* binding */ k; },
  "Am": function() { return /* binding */ Q; }
});

// UNUSED EXPORTS: Bounce, Flip, Icons, Slide, Zoom, collapseToast, cssTransition, useToast, useToastContainer

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/react-toastify/node_modules/clsx/dist/clsx.m.js
function r(e){var t,f,n="";if("string"==typeof e||"number"==typeof e)n+=e;else if("object"==typeof e)if(Array.isArray(e))for(t=0;t<e.length;t++)e[t]&&(f=r(e[t]))&&(n&&(n+=" "),n+=f);else for(t in e)e[t]&&(n&&(n+=" "),n+=t);return n}function clsx(){for(var e,t,f=0,n="";f<arguments.length;)(e=arguments[f++])&&(t=r(e))&&(n&&(n+=" "),n+=t);return n}/* harmony default export */ var clsx_m = (clsx);
;// CONCATENATED MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.mjs
'use client';
const u=t=>"number"==typeof t&&!isNaN(t),d=t=>"string"==typeof t,p=t=>"function"==typeof t,m=t=>d(t)||p(t)?t:null,f=t=>(0,react.isValidElement)(t)||d(t)||p(t)||u(t);function g(t,e,n){void 0===n&&(n=300);const{scrollHeight:o,style:s}=t;requestAnimationFrame(()=>{s.minHeight="initial",s.height=o+"px",s.transition=`all ${n}ms`,requestAnimationFrame(()=>{s.height="0",s.padding="0",s.margin="0",setTimeout(e,n)})})}function h(e){let{enter:a,exit:r,appendPosition:i=!1,collapse:l=!0,collapseDuration:c=300}=e;return function(e){let{children:u,position:d,preventExitTransition:p,done:m,nodeRef:f,isIn:h}=e;const y=i?`${a}--${d}`:a,v=i?`${r}--${d}`:r,T=(0,react.useRef)(0);return (0,react.useLayoutEffect)(()=>{const t=f.current,e=y.split(" "),n=o=>{o.target===f.current&&(t.dispatchEvent(new Event("d")),t.removeEventListener("animationend",n),t.removeEventListener("animationcancel",n),0===T.current&&"animationcancel"!==o.type&&t.classList.remove(...e))};t.classList.add(...e),t.addEventListener("animationend",n),t.addEventListener("animationcancel",n)},[]),(0,react.useEffect)(()=>{const t=f.current,e=()=>{t.removeEventListener("animationend",e),l?g(t,m,c):m()};h||(p?e():(T.current=1,t.className+=` ${v}`,t.addEventListener("animationend",e)))},[h]),react.createElement(react.Fragment,null,u)}}function y(t,e){return null!=t?{content:t.content,containerId:t.props.containerId,id:t.props.toastId,theme:t.props.theme,type:t.props.type,data:t.props.data||{},isLoading:t.props.isLoading,icon:t.props.icon,status:e}:{}}const v={list:new Map,emitQueue:new Map,on(t,e){return this.list.has(t)||this.list.set(t,[]),this.list.get(t).push(e),this},off(t,e){if(e){const n=this.list.get(t).filter(t=>t!==e);return this.list.set(t,n),this}return this.list.delete(t),this},cancelEmit(t){const e=this.emitQueue.get(t);return e&&(e.forEach(clearTimeout),this.emitQueue.delete(t)),this},emit(t){this.list.has(t)&&this.list.get(t).forEach(e=>{const n=setTimeout(()=>{e(...[].slice.call(arguments,1))},0);this.emitQueue.has(t)||this.emitQueue.set(t,[]),this.emitQueue.get(t).push(n)})}},T=e=>{let{theme:n,type:o,...s}=e;return react.createElement("svg",{viewBox:"0 0 24 24",width:"100%",height:"100%",fill:"colored"===n?"currentColor":`var(--toastify-icon-color-${o})`,...s})},E={info:function(e){return react.createElement(T,{...e},react.createElement("path",{d:"M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm.25 5a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5zm2.25 13.5h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1a2 2 0 012 2v4.75a.25.25 0 00.25.25h.75a1 1 0 110 2z"}))},warning:function(e){return react.createElement(T,{...e},react.createElement("path",{d:"M23.32 17.191L15.438 2.184C14.728.833 13.416 0 11.996 0c-1.42 0-2.733.833-3.443 2.184L.533 17.448a4.744 4.744 0 000 4.368C1.243 23.167 2.555 24 3.975 24h16.05C22.22 24 24 22.044 24 19.632c0-.904-.251-1.746-.68-2.44zm-9.622 1.46c0 1.033-.724 1.823-1.698 1.823s-1.698-.79-1.698-1.822v-.043c0-1.028.724-1.822 1.698-1.822s1.698.79 1.698 1.822v.043zm.039-12.285l-.84 8.06c-.057.581-.408.943-.897.943-.49 0-.84-.367-.896-.942l-.84-8.065c-.057-.624.25-1.095.779-1.095h1.91c.528.005.84.476.784 1.1z"}))},success:function(e){return react.createElement(T,{...e},react.createElement("path",{d:"M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 01-1.43.188l-4.888-3.908a1 1 0 111.25-1.562l4.076 3.261 6.227-8.451a1 1 0 111.61 1.183z"}))},error:function(e){return react.createElement(T,{...e},react.createElement("path",{d:"M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z"}))},spinner:function(){return react.createElement("div",{className:"Toastify__spinner"})}};function C(t){const[,o]=(0,react.useReducer)(t=>t+1,0),[l,c]=(0,react.useState)([]),g=(0,react.useRef)(null),h=(0,react.useRef)(new Map).current,T=t=>-1!==l.indexOf(t),C=(0,react.useRef)({toastKey:1,displayedToast:0,count:0,queue:[],props:t,containerId:null,isToastActive:T,getToast:t=>h.get(t)}).current;function b(t){let{containerId:e}=t;const{limit:n}=C.props;!n||e&&C.containerId!==e||(C.count-=C.queue.length,C.queue=[])}function I(t){c(e=>null==t?[]:e.filter(e=>e!==t))}function _(){const{toastContent:t,toastProps:e,staleId:n}=C.queue.shift();O(t,e,n)}function L(t,n){let{delay:s,staleId:r,...i}=n;if(!f(t)||function(t){return!g.current||C.props.enableMultiContainer&&t.containerId!==C.props.containerId||h.has(t.toastId)&&null==t.updateId}(i))return;const{toastId:l,updateId:c,data:T}=i,{props:b}=C,L=()=>I(l),N=null==c;N&&C.count++;const M={...b,style:b.toastStyle,key:C.toastKey++,...Object.fromEntries(Object.entries(i).filter(t=>{let[e,n]=t;return null!=n})),toastId:l,updateId:c,data:T,closeToast:L,isIn:!1,className:m(i.className||b.toastClassName),bodyClassName:m(i.bodyClassName||b.bodyClassName),progressClassName:m(i.progressClassName||b.progressClassName),autoClose:!i.isLoading&&(R=i.autoClose,w=b.autoClose,!1===R||u(R)&&R>0?R:w),deleteToast(){const t=y(h.get(l),"removed");h.delete(l),v.emit(4,t);const e=C.queue.length;if(C.count=null==l?C.count-C.displayedToast:C.count-1,C.count<0&&(C.count=0),e>0){const t=null==l?C.props.limit:1;if(1===e||1===t)C.displayedToast++,_();else{const n=t>e?e:t;C.displayedToast=n;for(let t=0;t<n;t++)_()}}else o()}};var R,w;M.iconOut=function(t){let{theme:n,type:o,isLoading:s,icon:r}=t,i=null;const l={theme:n,type:o};return!1===r||(p(r)?i=r(l):(0,react.isValidElement)(r)?i=(0,react.cloneElement)(r,l):d(r)||u(r)?i=r:s?i=E.spinner():(t=>t in E)(o)&&(i=E[o](l))),i}(M),p(i.onOpen)&&(M.onOpen=i.onOpen),p(i.onClose)&&(M.onClose=i.onClose),M.closeButton=b.closeButton,!1===i.closeButton||f(i.closeButton)?M.closeButton=i.closeButton:!0===i.closeButton&&(M.closeButton=!f(b.closeButton)||b.closeButton);let x=t;(0,react.isValidElement)(t)&&!d(t.type)?x=(0,react.cloneElement)(t,{closeToast:L,toastProps:M,data:T}):p(t)&&(x=t({closeToast:L,toastProps:M,data:T})),b.limit&&b.limit>0&&C.count>b.limit&&N?C.queue.push({toastContent:x,toastProps:M,staleId:r}):u(s)?setTimeout(()=>{O(x,M,r)},s):O(x,M,r)}function O(t,e,n){const{toastId:o}=e;n&&h.delete(n);const s={content:t,props:e};h.set(o,s),c(t=>[...t,o].filter(t=>t!==n)),v.emit(4,y(s,null==s.props.updateId?"added":"updated"))}return (0,react.useEffect)(()=>(C.containerId=t.containerId,v.cancelEmit(3).on(0,L).on(1,t=>g.current&&I(t)).on(5,b).emit(2,C),()=>{h.clear(),v.emit(3,C)}),[]),(0,react.useEffect)(()=>{C.props=t,C.isToastActive=T,C.displayedToast=l.length}),{getToastToRender:function(e){const n=new Map,o=Array.from(h.values());return t.newestOnTop&&o.reverse(),o.forEach(t=>{const{position:e}=t.props;n.has(e)||n.set(e,[]),n.get(e).push(t)}),Array.from(n,t=>e(t[0],t[1]))},containerRef:g,isToastActive:T}}function b(t){return t.targetTouches&&t.targetTouches.length>=1?t.targetTouches[0].clientX:t.clientX}function I(t){return t.targetTouches&&t.targetTouches.length>=1?t.targetTouches[0].clientY:t.clientY}function _(t){const[o,a]=(0,react.useState)(!1),[r,l]=(0,react.useState)(!1),c=(0,react.useRef)(null),u=(0,react.useRef)({start:0,x:0,y:0,delta:0,removalDistance:0,canCloseOnClick:!0,canDrag:!1,boundingRect:null,didMove:!1}).current,d=(0,react.useRef)(t),{autoClose:m,pauseOnHover:f,closeToast:g,onClick:h,closeOnClick:y}=t;function v(e){if(t.draggable){"touchstart"===e.nativeEvent.type&&e.nativeEvent.preventDefault(),u.didMove=!1,document.addEventListener("mousemove",_),document.addEventListener("mouseup",L),document.addEventListener("touchmove",_),document.addEventListener("touchend",L);const n=c.current;u.canCloseOnClick=!0,u.canDrag=!0,u.boundingRect=n.getBoundingClientRect(),n.style.transition="",u.x=b(e.nativeEvent),u.y=I(e.nativeEvent),"x"===t.draggableDirection?(u.start=u.x,u.removalDistance=n.offsetWidth*(t.draggablePercent/100)):(u.start=u.y,u.removalDistance=n.offsetHeight*(80===t.draggablePercent?1.5*t.draggablePercent:t.draggablePercent/100))}}function T(e){if(u.boundingRect){const{top:n,bottom:o,left:s,right:a}=u.boundingRect;"touchend"!==e.nativeEvent.type&&t.pauseOnHover&&u.x>=s&&u.x<=a&&u.y>=n&&u.y<=o?C():E()}}function E(){a(!0)}function C(){a(!1)}function _(e){const n=c.current;u.canDrag&&n&&(u.didMove=!0,o&&C(),u.x=b(e),u.y=I(e),u.delta="x"===t.draggableDirection?u.x-u.start:u.y-u.start,u.start!==u.x&&(u.canCloseOnClick=!1),n.style.transform=`translate${t.draggableDirection}(${u.delta}px)`,n.style.opacity=""+(1-Math.abs(u.delta/u.removalDistance)))}function L(){document.removeEventListener("mousemove",_),document.removeEventListener("mouseup",L),document.removeEventListener("touchmove",_),document.removeEventListener("touchend",L);const e=c.current;if(u.canDrag&&u.didMove&&e){if(u.canDrag=!1,Math.abs(u.delta)>u.removalDistance)return l(!0),void t.closeToast();e.style.transition="transform 0.2s, opacity 0.2s",e.style.transform=`translate${t.draggableDirection}(0)`,e.style.opacity="1"}}(0,react.useEffect)(()=>{d.current=t}),(0,react.useEffect)(()=>(c.current&&c.current.addEventListener("d",E,{once:!0}),p(t.onOpen)&&t.onOpen((0,react.isValidElement)(t.children)&&t.children.props),()=>{const t=d.current;p(t.onClose)&&t.onClose((0,react.isValidElement)(t.children)&&t.children.props)}),[]),(0,react.useEffect)(()=>(t.pauseOnFocusLoss&&(document.hasFocus()||C(),window.addEventListener("focus",E),window.addEventListener("blur",C)),()=>{t.pauseOnFocusLoss&&(window.removeEventListener("focus",E),window.removeEventListener("blur",C))}),[t.pauseOnFocusLoss]);const O={onMouseDown:v,onTouchStart:v,onMouseUp:T,onTouchEnd:T};return m&&f&&(O.onMouseEnter=C,O.onMouseLeave=E),y&&(O.onClick=t=>{h&&h(t),u.canCloseOnClick&&g()}),{playToast:E,pauseToast:C,isRunning:o,preventExitTransition:r,toastRef:c,eventHandlers:O}}function L(e){let{closeToast:n,theme:o,ariaLabel:s="close"}=e;return react.createElement("button",{className:`Toastify__close-button Toastify__close-button--${o}`,type:"button",onClick:t=>{t.stopPropagation(),n(t)},"aria-label":s},react.createElement("svg",{"aria-hidden":"true",viewBox:"0 0 14 16"},react.createElement("path",{fillRule:"evenodd",d:"M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z"})))}function O(e){let{delay:n,isRunning:o,closeToast:s,type:a="default",hide:r,className:i,style:l,controlledProgress:u,progress:d,rtl:m,isIn:f,theme:g}=e;const h=r||u&&0===d,y={...l,animationDuration:`${n}ms`,animationPlayState:o?"running":"paused",opacity:h?0:1};u&&(y.transform=`scaleX(${d})`);const v=clsx_m("Toastify__progress-bar",u?"Toastify__progress-bar--controlled":"Toastify__progress-bar--animated",`Toastify__progress-bar-theme--${g}`,`Toastify__progress-bar--${a}`,{"Toastify__progress-bar--rtl":m}),T=p(i)?i({rtl:m,type:a,defaultClassName:v}):clsx_m(v,i);return react.createElement("div",{role:"progressbar","aria-hidden":h?"true":"false","aria-label":"notification timer",className:T,style:y,[u&&d>=1?"onTransitionEnd":"onAnimationEnd"]:u&&d<1?null:()=>{f&&s()}})}const N=n=>{const{isRunning:o,preventExitTransition:s,toastRef:r,eventHandlers:i}=_(n),{closeButton:l,children:u,autoClose:d,onClick:m,type:f,hideProgressBar:g,closeToast:h,transition:y,position:v,className:T,style:E,bodyClassName:C,bodyStyle:b,progressClassName:I,progressStyle:N,updateId:M,role:R,progress:w,rtl:x,toastId:$,deleteToast:k,isIn:P,isLoading:B,iconOut:D,closeOnClick:A,theme:z}=n,F=clsx_m("Toastify__toast",`Toastify__toast-theme--${z}`,`Toastify__toast--${f}`,{"Toastify__toast--rtl":x},{"Toastify__toast--close-on-click":A}),H=p(T)?T({rtl:x,position:v,type:f,defaultClassName:F}):clsx_m(F,T),S=!!w||!d,q={closeToast:h,type:f,theme:z};let Q=null;return!1===l||(Q=p(l)?l(q):(0,react.isValidElement)(l)?(0,react.cloneElement)(l,q):L(q)),react.createElement(y,{isIn:P,done:k,position:v,preventExitTransition:s,nodeRef:r},react.createElement("div",{id:$,onClick:m,className:H,...i,style:E,ref:r},react.createElement("div",{...P&&{role:R},className:p(C)?C({type:f}):clsx_m("Toastify__toast-body",C),style:b},null!=D&&react.createElement("div",{className:clsx_m("Toastify__toast-icon",{"Toastify--animate-icon Toastify__zoom-enter":!B})},D),react.createElement("div",null,u)),Q,react.createElement(O,{...M&&!S?{key:`pb-${M}`}:{},rtl:x,theme:z,delay:d,isRunning:o,isIn:P,closeToast:h,hide:g,type:f,style:N,className:I,controlledProgress:S,progress:w||0})))},M=function(t,e){return void 0===e&&(e=!1),{enter:`Toastify--animate Toastify__${t}-enter`,exit:`Toastify--animate Toastify__${t}-exit`,appendPosition:e}},R=h(M("bounce",!0)),w=h(M("slide",!0)),x=h(M("zoom")),$=h(M("flip")),k=(0,react.forwardRef)((e,n)=>{const{getToastToRender:o,containerRef:a,isToastActive:r}=C(e),{className:i,style:l,rtl:u,containerId:d}=e;function f(t){const e=clsx_m("Toastify__toast-container",`Toastify__toast-container--${t}`,{"Toastify__toast-container--rtl":u});return p(i)?i({position:t,rtl:u,defaultClassName:e}):clsx_m(e,m(i))}return (0,react.useEffect)(()=>{n&&(n.current=a.current)},[]),react.createElement("div",{ref:a,className:"Toastify",id:d},o((e,n)=>{const o=n.length?{...l}:{...l,pointerEvents:"none"};return react.createElement("div",{className:f(e),style:o,key:`container-${e}`},n.map((e,o)=>{let{content:s,props:a}=e;return react.createElement(N,{...a,isIn:r(a.toastId),style:{...a.style,"--nth":o+1,"--len":n.length},key:`toast-${a.key}`},s)}))}))});k.displayName="ToastContainer",k.defaultProps={position:"top-right",transition:R,autoClose:5e3,closeButton:L,pauseOnHover:!0,pauseOnFocusLoss:!0,closeOnClick:!0,draggable:!0,draggablePercent:80,draggableDirection:"x",role:"alert",theme:"light"};let P,B=new Map,D=[],A=1;function z(){return""+A++}function F(t){return t&&(d(t.toastId)||u(t.toastId))?t.toastId:z()}function H(t,e){return B.size>0?v.emit(0,t,e):D.push({content:t,options:e}),e.toastId}function S(t,e){return{...e,type:e&&e.type||t,toastId:F(e)}}function q(t){return(e,n)=>H(e,S(t,n))}function Q(t,e){return H(t,S("default",e))}Q.loading=(t,e)=>H(t,S("default",{isLoading:!0,autoClose:!1,closeOnClick:!1,closeButton:!1,draggable:!1,...e})),Q.promise=function(t,e,n){let o,{pending:s,error:a,success:r}=e;s&&(o=d(s)?Q.loading(s,n):Q.loading(s.render,{...n,...s}));const i={isLoading:null,autoClose:null,closeOnClick:null,closeButton:null,draggable:null},l=(t,e,s)=>{if(null==e)return void Q.dismiss(o);const a={type:t,...i,...n,data:s},r=d(e)?{render:e}:e;return o?Q.update(o,{...a,...r}):Q(r.render,{...a,...r}),s},c=p(t)?t():t;return c.then(t=>l("success",r,t)).catch(t=>l("error",a,t)),c},Q.success=q("success"),Q.info=q("info"),Q.error=q("error"),Q.warning=q("warning"),Q.warn=Q.warning,Q.dark=(t,e)=>H(t,S("default",{theme:"dark",...e})),Q.dismiss=t=>{B.size>0?v.emit(1,t):D=D.filter(e=>null!=t&&e.options.toastId!==t)},Q.clearWaitingQueue=function(t){return void 0===t&&(t={}),v.emit(5,t)},Q.isActive=t=>{let e=!1;return B.forEach(n=>{n.isToastActive&&n.isToastActive(t)&&(e=!0)}),e},Q.update=function(t,e){void 0===e&&(e={}),setTimeout(()=>{const n=function(t,e){let{containerId:n}=e;const o=B.get(n||P);return o&&o.getToast(t)}(t,e);if(n){const{props:o,content:s}=n,a={delay:100,...o,...e,toastId:e.toastId||t,updateId:z()};a.toastId!==t&&(a.staleId=t);const r=a.render||s;delete a.render,H(r,a)}},0)},Q.done=t=>{Q.update(t,{progress:1})},Q.onChange=t=>(v.on(4,t),()=>{v.off(4,t)}),Q.POSITION={TOP_LEFT:"top-left",TOP_RIGHT:"top-right",TOP_CENTER:"top-center",BOTTOM_LEFT:"bottom-left",BOTTOM_RIGHT:"bottom-right",BOTTOM_CENTER:"bottom-center"},Q.TYPE={INFO:"info",SUCCESS:"success",WARNING:"warning",ERROR:"error",DEFAULT:"default"},v.on(2,t=>{P=t.containerId||t,B.set(P,t),D.forEach(t=>{v.emit(0,t.content,t.options)}),D=[]}).on(3,t=>{B.delete(t.containerId||t),0===B.size&&v.off(0).off(1).off(5)});
//# sourceMappingURL=react-toastify.esm.mjs.map


/***/ }),

/***/ 71911:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "pt": function() { return /* reexport */ Autoplay; },
  "W_": function() { return /* reexport */ Navigation; },
  "tl": function() { return /* reexport */ Pagination; },
  "eZ": function() { return /* reexport */ Virtual; },
  "ZP": function() { return /* reexport */ core; }
});

// UNUSED EXPORTS: A11y, Controller, EffectCards, EffectCoverflow, EffectCreative, EffectCube, EffectFade, EffectFlip, FreeMode, Grid, HashNavigation, History, Keyboard, Lazy, Manipulation, Mousewheel, Parallax, Scrollbar, Swiper, Thumbs, Zoom

;// CONCATENATED MODULE: ./node_modules/ssr-window/ssr-window.esm.js
/**
 * SSR Window 4.0.2
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2021, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: December 13, 2021
 */
/* eslint-disable no-param-reassign */
function ssr_window_esm_isObject(obj) {
    return (obj !== null &&
        typeof obj === 'object' &&
        'constructor' in obj &&
        obj.constructor === Object);
}
function extend(target = {}, src = {}) {
    Object.keys(src).forEach((key) => {
        if (typeof target[key] === 'undefined')
            target[key] = src[key];
        else if (ssr_window_esm_isObject(src[key]) &&
            ssr_window_esm_isObject(target[key]) &&
            Object.keys(src[key]).length > 0) {
            extend(target[key], src[key]);
        }
    });
}

const ssrDocument = {
    body: {},
    addEventListener() { },
    removeEventListener() { },
    activeElement: {
        blur() { },
        nodeName: '',
    },
    querySelector() {
        return null;
    },
    querySelectorAll() {
        return [];
    },
    getElementById() {
        return null;
    },
    createEvent() {
        return {
            initEvent() { },
        };
    },
    createElement() {
        return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute() { },
            getElementsByTagName() {
                return [];
            },
        };
    },
    createElementNS() {
        return {};
    },
    importNode() {
        return null;
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: '',
    },
};
function ssr_window_esm_getDocument() {
    const doc = typeof document !== 'undefined' ? document : {};
    extend(doc, ssrDocument);
    return doc;
}

const ssrWindow = {
    document: ssrDocument,
    navigator: {
        userAgent: '',
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: '',
    },
    history: {
        replaceState() { },
        pushState() { },
        go() { },
        back() { },
    },
    CustomEvent: function CustomEvent() {
        return this;
    },
    addEventListener() { },
    removeEventListener() { },
    getComputedStyle() {
        return {
            getPropertyValue() {
                return '';
            },
        };
    },
    Image() { },
    Date() { },
    screen: {},
    setTimeout() { },
    clearTimeout() { },
    matchMedia() {
        return {};
    },
    requestAnimationFrame(callback) {
        if (typeof setTimeout === 'undefined') {
            callback();
            return null;
        }
        return setTimeout(callback, 0);
    },
    cancelAnimationFrame(id) {
        if (typeof setTimeout === 'undefined') {
            return;
        }
        clearTimeout(id);
    },
};
function ssr_window_esm_getWindow() {
    const win = typeof window !== 'undefined' ? window : {};
    extend(win, ssrWindow);
    return win;
}



;// CONCATENATED MODULE: ./node_modules/dom7/dom7.esm.js
/**
 * Dom7 4.0.6
 * Minimalistic JavaScript library for DOM manipulation, with a jQuery-compatible API
 * https://framework7.io/docs/dom7.html
 *
 * Copyright 2023, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: February 2, 2023
 */


/* eslint-disable no-proto */
function makeReactive(obj) {
  const proto = obj.__proto__;
  Object.defineProperty(obj, '__proto__', {
    get() {
      return proto;
    },

    set(value) {
      proto.__proto__ = value;
    }

  });
}

class Dom7 extends Array {
  constructor(items) {
    if (typeof items === 'number') {
      super(items);
    } else {
      super(...(items || []));
      makeReactive(this);
    }
  }

}

function arrayFlat(arr = []) {
  const res = [];
  arr.forEach(el => {
    if (Array.isArray(el)) {
      res.push(...arrayFlat(el));
    } else {
      res.push(el);
    }
  });
  return res;
}
function arrayFilter(arr, callback) {
  return Array.prototype.filter.call(arr, callback);
}
function arrayUnique(arr) {
  const uniqueArray = [];

  for (let i = 0; i < arr.length; i += 1) {
    if (uniqueArray.indexOf(arr[i]) === -1) uniqueArray.push(arr[i]);
  }

  return uniqueArray;
}
function toCamelCase(string) {
  return string.toLowerCase().replace(/-(.)/g, (match, group) => group.toUpperCase());
}

// eslint-disable-next-line

function qsa(selector, context) {
  if (typeof selector !== 'string') {
    return [selector];
  }

  const a = [];
  const res = context.querySelectorAll(selector);

  for (let i = 0; i < res.length; i += 1) {
    a.push(res[i]);
  }

  return a;
}

function dom7_esm_$(selector, context) {
  const window = ssr_window_esm_getWindow();
  const document = ssr_window_esm_getDocument();
  let arr = [];

  if (!context && selector instanceof Dom7) {
    return selector;
  }

  if (!selector) {
    return new Dom7(arr);
  }

  if (typeof selector === 'string') {
    const html = selector.trim();

    if (html.indexOf('<') >= 0 && html.indexOf('>') >= 0) {
      let toCreate = 'div';
      if (html.indexOf('<li') === 0) toCreate = 'ul';
      if (html.indexOf('<tr') === 0) toCreate = 'tbody';
      if (html.indexOf('<td') === 0 || html.indexOf('<th') === 0) toCreate = 'tr';
      if (html.indexOf('<tbody') === 0) toCreate = 'table';
      if (html.indexOf('<option') === 0) toCreate = 'select';
      const tempParent = document.createElement(toCreate);
      tempParent.innerHTML = html;

      for (let i = 0; i < tempParent.childNodes.length; i += 1) {
        arr.push(tempParent.childNodes[i]);
      }
    } else {
      arr = qsa(selector.trim(), context || document);
    } // arr = qsa(selector, document);

  } else if (selector.nodeType || selector === window || selector === document) {
    arr.push(selector);
  } else if (Array.isArray(selector)) {
    if (selector instanceof Dom7) return selector;
    arr = selector;
  }

  return new Dom7(arrayUnique(arr));
}

dom7_esm_$.fn = Dom7.prototype;

// eslint-disable-next-line

function addClass(...classes) {
  const classNames = arrayFlat(classes.map(c => c.split(' ')));
  this.forEach(el => {
    el.classList.add(...classNames);
  });
  return this;
}

function removeClass(...classes) {
  const classNames = arrayFlat(classes.map(c => c.split(' ')));
  this.forEach(el => {
    el.classList.remove(...classNames);
  });
  return this;
}

function toggleClass(...classes) {
  const classNames = arrayFlat(classes.map(c => c.split(' ')));
  this.forEach(el => {
    classNames.forEach(className => {
      el.classList.toggle(className);
    });
  });
}

function hasClass(...classes) {
  const classNames = arrayFlat(classes.map(c => c.split(' ')));
  return arrayFilter(this, el => {
    return classNames.filter(className => el.classList.contains(className)).length > 0;
  }).length > 0;
}

function attr(attrs, value) {
  if (arguments.length === 1 && typeof attrs === 'string') {
    // Get attr
    if (this[0]) return this[0].getAttribute(attrs);
    return undefined;
  } // Set attrs


  for (let i = 0; i < this.length; i += 1) {
    if (arguments.length === 2) {
      // String
      this[i].setAttribute(attrs, value);
    } else {
      // Object
      for (const attrName in attrs) {
        this[i][attrName] = attrs[attrName];
        this[i].setAttribute(attrName, attrs[attrName]);
      }
    }
  }

  return this;
}

function removeAttr(attr) {
  for (let i = 0; i < this.length; i += 1) {
    this[i].removeAttribute(attr);
  }

  return this;
}

function prop(props, value) {
  if (arguments.length === 1 && typeof props === 'string') {
    // Get prop
    if (this[0]) return this[0][props];
  } else {
    // Set props
    for (let i = 0; i < this.length; i += 1) {
      if (arguments.length === 2) {
        // String
        this[i][props] = value;
      } else {
        // Object
        for (const propName in props) {
          this[i][propName] = props[propName];
        }
      }
    }

    return this;
  }

  return this;
}

function data(key, value) {
  let el;

  if (typeof value === 'undefined') {
    el = this[0];
    if (!el) return undefined; // Get value

    if (el.dom7ElementDataStorage && key in el.dom7ElementDataStorage) {
      return el.dom7ElementDataStorage[key];
    }

    const dataKey = el.getAttribute(`data-${key}`);

    if (dataKey) {
      return dataKey;
    }

    return undefined;
  } // Set value


  for (let i = 0; i < this.length; i += 1) {
    el = this[i];
    if (!el.dom7ElementDataStorage) el.dom7ElementDataStorage = {};
    el.dom7ElementDataStorage[key] = value;
  }

  return this;
}

function removeData(key) {
  for (let i = 0; i < this.length; i += 1) {
    const el = this[i];

    if (el.dom7ElementDataStorage && el.dom7ElementDataStorage[key]) {
      el.dom7ElementDataStorage[key] = null;
      delete el.dom7ElementDataStorage[key];
    }
  }
}

function dataset() {
  const el = this[0];
  if (!el) return undefined;
  const dataset = {}; // eslint-disable-line

  if (el.dataset) {
    for (const dataKey in el.dataset) {
      dataset[dataKey] = el.dataset[dataKey];
    }
  } else {
    for (let i = 0; i < el.attributes.length; i += 1) {
      const attr = el.attributes[i];

      if (attr.name.indexOf('data-') >= 0) {
        dataset[toCamelCase(attr.name.split('data-')[1])] = attr.value;
      }
    }
  }

  for (const key in dataset) {
    if (dataset[key] === 'false') dataset[key] = false;else if (dataset[key] === 'true') dataset[key] = true;else if (parseFloat(dataset[key]) === dataset[key] * 1) dataset[key] *= 1;
  }

  return dataset;
}

function val(value) {
  if (typeof value === 'undefined') {
    // get value
    const el = this[0];
    if (!el) return undefined;

    if (el.multiple && el.nodeName.toLowerCase() === 'select') {
      const values = [];

      for (let i = 0; i < el.selectedOptions.length; i += 1) {
        values.push(el.selectedOptions[i].value);
      }

      return values;
    }

    return el.value;
  } // set value


  for (let i = 0; i < this.length; i += 1) {
    const el = this[i];

    if (Array.isArray(value) && el.multiple && el.nodeName.toLowerCase() === 'select') {
      for (let j = 0; j < el.options.length; j += 1) {
        el.options[j].selected = value.indexOf(el.options[j].value) >= 0;
      }
    } else {
      el.value = value;
    }
  }

  return this;
}

function value(value) {
  return this.val(value);
}

function transform(transform) {
  for (let i = 0; i < this.length; i += 1) {
    this[i].style.transform = transform;
  }

  return this;
}

function transition(duration) {
  for (let i = 0; i < this.length; i += 1) {
    this[i].style.transitionDuration = typeof duration !== 'string' ? `${duration}ms` : duration;
  }

  return this;
}

function on(...args) {
  let [eventType, targetSelector, listener, capture] = args;

  if (typeof args[1] === 'function') {
    [eventType, listener, capture] = args;
    targetSelector = undefined;
  }

  if (!capture) capture = false;

  function handleLiveEvent(e) {
    const target = e.target;
    if (!target) return;
    const eventData = e.target.dom7EventData || [];

    if (eventData.indexOf(e) < 0) {
      eventData.unshift(e);
    }

    if (dom7_esm_$(target).is(targetSelector)) listener.apply(target, eventData);else {
      const parents = dom7_esm_$(target).parents(); // eslint-disable-line

      for (let k = 0; k < parents.length; k += 1) {
        if (dom7_esm_$(parents[k]).is(targetSelector)) listener.apply(parents[k], eventData);
      }
    }
  }

  function handleEvent(e) {
    const eventData = e && e.target ? e.target.dom7EventData || [] : [];

    if (eventData.indexOf(e) < 0) {
      eventData.unshift(e);
    }

    listener.apply(this, eventData);
  }

  const events = eventType.split(' ');
  let j;

  for (let i = 0; i < this.length; i += 1) {
    const el = this[i];

    if (!targetSelector) {
      for (j = 0; j < events.length; j += 1) {
        const event = events[j];
        if (!el.dom7Listeners) el.dom7Listeners = {};
        if (!el.dom7Listeners[event]) el.dom7Listeners[event] = [];
        el.dom7Listeners[event].push({
          listener,
          proxyListener: handleEvent
        });
        el.addEventListener(event, handleEvent, capture);
      }
    } else {
      // Live events
      for (j = 0; j < events.length; j += 1) {
        const event = events[j];
        if (!el.dom7LiveListeners) el.dom7LiveListeners = {};
        if (!el.dom7LiveListeners[event]) el.dom7LiveListeners[event] = [];
        el.dom7LiveListeners[event].push({
          listener,
          proxyListener: handleLiveEvent
        });
        el.addEventListener(event, handleLiveEvent, capture);
      }
    }
  }

  return this;
}

function off(...args) {
  let [eventType, targetSelector, listener, capture] = args;

  if (typeof args[1] === 'function') {
    [eventType, listener, capture] = args;
    targetSelector = undefined;
  }

  if (!capture) capture = false;
  const events = eventType.split(' ');

  for (let i = 0; i < events.length; i += 1) {
    const event = events[i];

    for (let j = 0; j < this.length; j += 1) {
      const el = this[j];
      let handlers;

      if (!targetSelector && el.dom7Listeners) {
        handlers = el.dom7Listeners[event];
      } else if (targetSelector && el.dom7LiveListeners) {
        handlers = el.dom7LiveListeners[event];
      }

      if (handlers && handlers.length) {
        for (let k = handlers.length - 1; k >= 0; k -= 1) {
          const handler = handlers[k];

          if (listener && handler.listener === listener) {
            el.removeEventListener(event, handler.proxyListener, capture);
            handlers.splice(k, 1);
          } else if (listener && handler.listener && handler.listener.dom7proxy && handler.listener.dom7proxy === listener) {
            el.removeEventListener(event, handler.proxyListener, capture);
            handlers.splice(k, 1);
          } else if (!listener) {
            el.removeEventListener(event, handler.proxyListener, capture);
            handlers.splice(k, 1);
          }
        }
      }
    }
  }

  return this;
}

function once(...args) {
  const dom = this;
  let [eventName, targetSelector, listener, capture] = args;

  if (typeof args[1] === 'function') {
    [eventName, listener, capture] = args;
    targetSelector = undefined;
  }

  function onceHandler(...eventArgs) {
    listener.apply(this, eventArgs);
    dom.off(eventName, targetSelector, onceHandler, capture);

    if (onceHandler.dom7proxy) {
      delete onceHandler.dom7proxy;
    }
  }

  onceHandler.dom7proxy = listener;
  return dom.on(eventName, targetSelector, onceHandler, capture);
}

function trigger(...args) {
  const window = ssr_window_esm_getWindow();
  const events = args[0].split(' ');
  const eventData = args[1];

  for (let i = 0; i < events.length; i += 1) {
    const event = events[i];

    for (let j = 0; j < this.length; j += 1) {
      const el = this[j];

      if (window.CustomEvent) {
        const evt = new window.CustomEvent(event, {
          detail: eventData,
          bubbles: true,
          cancelable: true
        });
        el.dom7EventData = args.filter((data, dataIndex) => dataIndex > 0);
        el.dispatchEvent(evt);
        el.dom7EventData = [];
        delete el.dom7EventData;
      }
    }
  }

  return this;
}

function transitionStart(callback) {
  const dom = this;

  function fireCallBack(e) {
    if (e.target !== this) return;
    callback.call(this, e);
    dom.off('transitionstart', fireCallBack);
  }

  if (callback) {
    dom.on('transitionstart', fireCallBack);
  }

  return this;
}

function transitionEnd(callback) {
  const dom = this;

  function fireCallBack(e) {
    if (e.target !== this) return;
    callback.call(this, e);
    dom.off('transitionend', fireCallBack);
  }

  if (callback) {
    dom.on('transitionend', fireCallBack);
  }

  return this;
}

function animationEnd(callback) {
  const dom = this;

  function fireCallBack(e) {
    if (e.target !== this) return;
    callback.call(this, e);
    dom.off('animationend', fireCallBack);
  }

  if (callback) {
    dom.on('animationend', fireCallBack);
  }

  return this;
}

function width() {
  const window = getWindow();

  if (this[0] === window) {
    return window.innerWidth;
  }

  if (this.length > 0) {
    return parseFloat(this.css('width'));
  }

  return null;
}

function dom7_esm_outerWidth(includeMargins) {
  if (this.length > 0) {
    if (includeMargins) {
      const styles = this.styles();
      return this[0].offsetWidth + parseFloat(styles.getPropertyValue('margin-right')) + parseFloat(styles.getPropertyValue('margin-left'));
    }

    return this[0].offsetWidth;
  }

  return null;
}

function height() {
  const window = getWindow();

  if (this[0] === window) {
    return window.innerHeight;
  }

  if (this.length > 0) {
    return parseFloat(this.css('height'));
  }

  return null;
}

function dom7_esm_outerHeight(includeMargins) {
  if (this.length > 0) {
    if (includeMargins) {
      const styles = this.styles();
      return this[0].offsetHeight + parseFloat(styles.getPropertyValue('margin-top')) + parseFloat(styles.getPropertyValue('margin-bottom'));
    }

    return this[0].offsetHeight;
  }

  return null;
}

function offset() {
  if (this.length > 0) {
    const window = ssr_window_esm_getWindow();
    const document = ssr_window_esm_getDocument();
    const el = this[0];
    const box = el.getBoundingClientRect();
    const body = document.body;
    const clientTop = el.clientTop || body.clientTop || 0;
    const clientLeft = el.clientLeft || body.clientLeft || 0;
    const scrollTop = el === window ? window.scrollY : el.scrollTop;
    const scrollLeft = el === window ? window.scrollX : el.scrollLeft;
    return {
      top: box.top + scrollTop - clientTop,
      left: box.left + scrollLeft - clientLeft
    };
  }

  return null;
}

function hide() {
  for (let i = 0; i < this.length; i += 1) {
    this[i].style.display = 'none';
  }

  return this;
}

function show() {
  const window = getWindow();

  for (let i = 0; i < this.length; i += 1) {
    const el = this[i];

    if (el.style.display === 'none') {
      el.style.display = '';
    }

    if (window.getComputedStyle(el, null).getPropertyValue('display') === 'none') {
      // Still not visible
      el.style.display = 'block';
    }
  }

  return this;
}

function styles() {
  const window = ssr_window_esm_getWindow();
  if (this[0]) return window.getComputedStyle(this[0], null);
  return {};
}

function css(props, value) {
  const window = ssr_window_esm_getWindow();
  let i;

  if (arguments.length === 1) {
    if (typeof props === 'string') {
      // .css('width')
      if (this[0]) return window.getComputedStyle(this[0], null).getPropertyValue(props);
    } else {
      // .css({ width: '100px' })
      for (i = 0; i < this.length; i += 1) {
        for (const prop in props) {
          this[i].style[prop] = props[prop];
        }
      }

      return this;
    }
  }

  if (arguments.length === 2 && typeof props === 'string') {
    // .css('width', '100px')
    for (i = 0; i < this.length; i += 1) {
      this[i].style[props] = value;
    }

    return this;
  }

  return this;
}

function each(callback) {
  if (!callback) return this;
  this.forEach((el, index) => {
    callback.apply(el, [el, index]);
  });
  return this;
}

function filter(callback) {
  const result = arrayFilter(this, callback);
  return dom7_esm_$(result);
}

function html(html) {
  if (typeof html === 'undefined') {
    return this[0] ? this[0].innerHTML : null;
  }

  for (let i = 0; i < this.length; i += 1) {
    this[i].innerHTML = html;
  }

  return this;
}

function dom7_esm_text(text) {
  if (typeof text === 'undefined') {
    return this[0] ? this[0].textContent.trim() : null;
  }

  for (let i = 0; i < this.length; i += 1) {
    this[i].textContent = text;
  }

  return this;
}

function is(selector) {
  const window = ssr_window_esm_getWindow();
  const document = ssr_window_esm_getDocument();
  const el = this[0];
  let compareWith;
  let i;
  if (!el || typeof selector === 'undefined') return false;

  if (typeof selector === 'string') {
    if (el.matches) return el.matches(selector);
    if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);
    if (el.msMatchesSelector) return el.msMatchesSelector(selector);
    compareWith = dom7_esm_$(selector);

    for (i = 0; i < compareWith.length; i += 1) {
      if (compareWith[i] === el) return true;
    }

    return false;
  }

  if (selector === document) {
    return el === document;
  }

  if (selector === window) {
    return el === window;
  }

  if (selector.nodeType || selector instanceof Dom7) {
    compareWith = selector.nodeType ? [selector] : selector;

    for (i = 0; i < compareWith.length; i += 1) {
      if (compareWith[i] === el) return true;
    }

    return false;
  }

  return false;
}

function index() {
  let child = this[0];
  let i;

  if (child) {
    i = 0; // eslint-disable-next-line

    while ((child = child.previousSibling) !== null) {
      if (child.nodeType === 1) i += 1;
    }

    return i;
  }

  return undefined;
}

function eq(index) {
  if (typeof index === 'undefined') return this;
  const length = this.length;

  if (index > length - 1) {
    return dom7_esm_$([]);
  }

  if (index < 0) {
    const returnIndex = length + index;
    if (returnIndex < 0) return dom7_esm_$([]);
    return dom7_esm_$([this[returnIndex]]);
  }

  return dom7_esm_$([this[index]]);
}

function append(...els) {
  let newChild;
  const document = ssr_window_esm_getDocument();

  for (let k = 0; k < els.length; k += 1) {
    newChild = els[k];

    for (let i = 0; i < this.length; i += 1) {
      if (typeof newChild === 'string') {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = newChild;

        while (tempDiv.firstChild) {
          this[i].appendChild(tempDiv.firstChild);
        }
      } else if (newChild instanceof Dom7) {
        for (let j = 0; j < newChild.length; j += 1) {
          this[i].appendChild(newChild[j]);
        }
      } else {
        this[i].appendChild(newChild);
      }
    }
  }

  return this;
}

function appendTo(parent) {
  dom7_esm_$(parent).append(this);
  return this;
}

function prepend(newChild) {
  const document = ssr_window_esm_getDocument();
  let i;
  let j;

  for (i = 0; i < this.length; i += 1) {
    if (typeof newChild === 'string') {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = newChild;

      for (j = tempDiv.childNodes.length - 1; j >= 0; j -= 1) {
        this[i].insertBefore(tempDiv.childNodes[j], this[i].childNodes[0]);
      }
    } else if (newChild instanceof Dom7) {
      for (j = 0; j < newChild.length; j += 1) {
        this[i].insertBefore(newChild[j], this[i].childNodes[0]);
      }
    } else {
      this[i].insertBefore(newChild, this[i].childNodes[0]);
    }
  }

  return this;
}

function prependTo(parent) {
  dom7_esm_$(parent).prepend(this);
  return this;
}

function insertBefore(selector) {
  const before = dom7_esm_$(selector);

  for (let i = 0; i < this.length; i += 1) {
    if (before.length === 1) {
      before[0].parentNode.insertBefore(this[i], before[0]);
    } else if (before.length > 1) {
      for (let j = 0; j < before.length; j += 1) {
        before[j].parentNode.insertBefore(this[i].cloneNode(true), before[j]);
      }
    }
  }
}

function insertAfter(selector) {
  const after = dom7_esm_$(selector);

  for (let i = 0; i < this.length; i += 1) {
    if (after.length === 1) {
      after[0].parentNode.insertBefore(this[i], after[0].nextSibling);
    } else if (after.length > 1) {
      for (let j = 0; j < after.length; j += 1) {
        after[j].parentNode.insertBefore(this[i].cloneNode(true), after[j].nextSibling);
      }
    }
  }
}

function next(selector) {
  if (this.length > 0) {
    if (selector) {
      if (this[0].nextElementSibling && dom7_esm_$(this[0].nextElementSibling).is(selector)) {
        return dom7_esm_$([this[0].nextElementSibling]);
      }

      return dom7_esm_$([]);
    }

    if (this[0].nextElementSibling) return dom7_esm_$([this[0].nextElementSibling]);
    return dom7_esm_$([]);
  }

  return dom7_esm_$([]);
}

function nextAll(selector) {
  const nextEls = [];
  let el = this[0];
  if (!el) return dom7_esm_$([]);

  while (el.nextElementSibling) {
    const next = el.nextElementSibling; // eslint-disable-line

    if (selector) {
      if (dom7_esm_$(next).is(selector)) nextEls.push(next);
    } else nextEls.push(next);

    el = next;
  }

  return dom7_esm_$(nextEls);
}

function prev(selector) {
  if (this.length > 0) {
    const el = this[0];

    if (selector) {
      if (el.previousElementSibling && dom7_esm_$(el.previousElementSibling).is(selector)) {
        return dom7_esm_$([el.previousElementSibling]);
      }

      return dom7_esm_$([]);
    }

    if (el.previousElementSibling) return dom7_esm_$([el.previousElementSibling]);
    return dom7_esm_$([]);
  }

  return dom7_esm_$([]);
}

function prevAll(selector) {
  const prevEls = [];
  let el = this[0];
  if (!el) return dom7_esm_$([]);

  while (el.previousElementSibling) {
    const prev = el.previousElementSibling; // eslint-disable-line

    if (selector) {
      if (dom7_esm_$(prev).is(selector)) prevEls.push(prev);
    } else prevEls.push(prev);

    el = prev;
  }

  return dom7_esm_$(prevEls);
}

function siblings(selector) {
  return this.nextAll(selector).add(this.prevAll(selector));
}

function dom7_esm_parent(selector) {
  const parents = []; // eslint-disable-line

  for (let i = 0; i < this.length; i += 1) {
    if (this[i].parentNode !== null) {
      if (selector) {
        if (dom7_esm_$(this[i].parentNode).is(selector)) parents.push(this[i].parentNode);
      } else {
        parents.push(this[i].parentNode);
      }
    }
  }

  return dom7_esm_$(parents);
}

function parents(selector) {
  const parents = []; // eslint-disable-line

  for (let i = 0; i < this.length; i += 1) {
    let parent = this[i].parentNode; // eslint-disable-line

    while (parent) {
      if (selector) {
        if (dom7_esm_$(parent).is(selector)) parents.push(parent);
      } else {
        parents.push(parent);
      }

      parent = parent.parentNode;
    }
  }

  return dom7_esm_$(parents);
}

function closest(selector) {
  let closest = this; // eslint-disable-line

  if (typeof selector === 'undefined') {
    return dom7_esm_$([]);
  }

  if (!closest.is(selector)) {
    closest = closest.parents(selector).eq(0);
  }

  return closest;
}

function find(selector) {
  const foundElements = [];

  for (let i = 0; i < this.length; i += 1) {
    const found = this[i].querySelectorAll(selector);

    for (let j = 0; j < found.length; j += 1) {
      foundElements.push(found[j]);
    }
  }

  return dom7_esm_$(foundElements);
}

function children(selector) {
  const children = []; // eslint-disable-line

  for (let i = 0; i < this.length; i += 1) {
    const childNodes = this[i].children;

    for (let j = 0; j < childNodes.length; j += 1) {
      if (!selector || dom7_esm_$(childNodes[j]).is(selector)) {
        children.push(childNodes[j]);
      }
    }
  }

  return dom7_esm_$(children);
}

function remove() {
  for (let i = 0; i < this.length; i += 1) {
    if (this[i].parentNode) this[i].parentNode.removeChild(this[i]);
  }

  return this;
}

function detach() {
  return this.remove();
}

function add(...els) {
  const dom = this;
  let i;
  let j;

  for (i = 0; i < els.length; i += 1) {
    const toAdd = dom7_esm_$(els[i]);

    for (j = 0; j < toAdd.length; j += 1) {
      dom.push(toAdd[j]);
    }
  }

  return dom;
}

function empty() {
  for (let i = 0; i < this.length; i += 1) {
    const el = this[i];

    if (el.nodeType === 1) {
      for (let j = 0; j < el.childNodes.length; j += 1) {
        if (el.childNodes[j].parentNode) {
          el.childNodes[j].parentNode.removeChild(el.childNodes[j]);
        }
      }

      el.textContent = '';
    }
  }

  return this;
}

// eslint-disable-next-line

function scrollTo(...args) {
  const window = getWindow();
  let [left, top, duration, easing, callback] = args;

  if (args.length === 4 && typeof easing === 'function') {
    callback = easing;
    [left, top, duration, callback, easing] = args;
  }

  if (typeof easing === 'undefined') easing = 'swing';
  return this.each(function animate() {
    const el = this;
    let currentTop;
    let currentLeft;
    let maxTop;
    let maxLeft;
    let newTop;
    let newLeft;
    let scrollTop; // eslint-disable-line

    let scrollLeft; // eslint-disable-line

    let animateTop = top > 0 || top === 0;
    let animateLeft = left > 0 || left === 0;

    if (typeof easing === 'undefined') {
      easing = 'swing';
    }

    if (animateTop) {
      currentTop = el.scrollTop;

      if (!duration) {
        el.scrollTop = top;
      }
    }

    if (animateLeft) {
      currentLeft = el.scrollLeft;

      if (!duration) {
        el.scrollLeft = left;
      }
    }

    if (!duration) return;

    if (animateTop) {
      maxTop = el.scrollHeight - el.offsetHeight;
      newTop = Math.max(Math.min(top, maxTop), 0);
    }

    if (animateLeft) {
      maxLeft = el.scrollWidth - el.offsetWidth;
      newLeft = Math.max(Math.min(left, maxLeft), 0);
    }

    let startTime = null;
    if (animateTop && newTop === currentTop) animateTop = false;
    if (animateLeft && newLeft === currentLeft) animateLeft = false;

    function render(time = new Date().getTime()) {
      if (startTime === null) {
        startTime = time;
      }

      const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
      const easeProgress = easing === 'linear' ? progress : 0.5 - Math.cos(progress * Math.PI) / 2;
      let done;
      if (animateTop) scrollTop = currentTop + easeProgress * (newTop - currentTop);
      if (animateLeft) scrollLeft = currentLeft + easeProgress * (newLeft - currentLeft);

      if (animateTop && newTop > currentTop && scrollTop >= newTop) {
        el.scrollTop = newTop;
        done = true;
      }

      if (animateTop && newTop < currentTop && scrollTop <= newTop) {
        el.scrollTop = newTop;
        done = true;
      }

      if (animateLeft && newLeft > currentLeft && scrollLeft >= newLeft) {
        el.scrollLeft = newLeft;
        done = true;
      }

      if (animateLeft && newLeft < currentLeft && scrollLeft <= newLeft) {
        el.scrollLeft = newLeft;
        done = true;
      }

      if (done) {
        if (callback) callback();
        return;
      }

      if (animateTop) el.scrollTop = scrollTop;
      if (animateLeft) el.scrollLeft = scrollLeft;
      window.requestAnimationFrame(render);
    }

    window.requestAnimationFrame(render);
  });
} // scrollTop(top, duration, easing, callback) {


function scrollTop(...args) {
  let [top, duration, easing, callback] = args;

  if (args.length === 3 && typeof easing === 'function') {
    [top, duration, callback, easing] = args;
  }

  const dom = this;

  if (typeof top === 'undefined') {
    if (dom.length > 0) return dom[0].scrollTop;
    return null;
  }

  return dom.scrollTo(undefined, top, duration, easing, callback);
}

function scrollLeft(...args) {
  let [left, duration, easing, callback] = args;

  if (args.length === 3 && typeof easing === 'function') {
    [left, duration, callback, easing] = args;
  }

  const dom = this;

  if (typeof left === 'undefined') {
    if (dom.length > 0) return dom[0].scrollLeft;
    return null;
  }

  return dom.scrollTo(left, undefined, duration, easing, callback);
}

// eslint-disable-next-line

function animate(initialProps, initialParams) {
  const window = getWindow();
  const els = this;
  const a = {
    props: Object.assign({}, initialProps),
    params: Object.assign({
      duration: 300,
      easing: 'swing' // or 'linear'

      /* Callbacks
      begin(elements)
      complete(elements)
      progress(elements, complete, remaining, start, tweenValue)
      */

    }, initialParams),
    elements: els,
    animating: false,
    que: [],

    easingProgress(easing, progress) {
      if (easing === 'swing') {
        return 0.5 - Math.cos(progress * Math.PI) / 2;
      }

      if (typeof easing === 'function') {
        return easing(progress);
      }

      return progress;
    },

    stop() {
      if (a.frameId) {
        window.cancelAnimationFrame(a.frameId);
      }

      a.animating = false;
      a.elements.each(el => {
        const element = el;
        delete element.dom7AnimateInstance;
      });
      a.que = [];
    },

    done(complete) {
      a.animating = false;
      a.elements.each(el => {
        const element = el;
        delete element.dom7AnimateInstance;
      });
      if (complete) complete(els);

      if (a.que.length > 0) {
        const que = a.que.shift();
        a.animate(que[0], que[1]);
      }
    },

    animate(props, params) {
      if (a.animating) {
        a.que.push([props, params]);
        return a;
      }

      const elements = []; // Define & Cache Initials & Units

      a.elements.each((el, index) => {
        let initialFullValue;
        let initialValue;
        let unit;
        let finalValue;
        let finalFullValue;
        if (!el.dom7AnimateInstance) a.elements[index].dom7AnimateInstance = a;
        elements[index] = {
          container: el
        };
        Object.keys(props).forEach(prop => {
          initialFullValue = window.getComputedStyle(el, null).getPropertyValue(prop).replace(',', '.');
          initialValue = parseFloat(initialFullValue);
          unit = initialFullValue.replace(initialValue, '');
          finalValue = parseFloat(props[prop]);
          finalFullValue = props[prop] + unit;
          elements[index][prop] = {
            initialFullValue,
            initialValue,
            unit,
            finalValue,
            finalFullValue,
            currentValue: initialValue
          };
        });
      });
      let startTime = null;
      let time;
      let elementsDone = 0;
      let propsDone = 0;
      let done;
      let began = false;
      a.animating = true;

      function render() {
        time = new Date().getTime();
        let progress;
        let easeProgress; // let el;

        if (!began) {
          began = true;
          if (params.begin) params.begin(els);
        }

        if (startTime === null) {
          startTime = time;
        }

        if (params.progress) {
          // eslint-disable-next-line
          params.progress(els, Math.max(Math.min((time - startTime) / params.duration, 1), 0), startTime + params.duration - time < 0 ? 0 : startTime + params.duration - time, startTime);
        }

        elements.forEach(element => {
          const el = element;
          if (done || el.done) return;
          Object.keys(props).forEach(prop => {
            if (done || el.done) return;
            progress = Math.max(Math.min((time - startTime) / params.duration, 1), 0);
            easeProgress = a.easingProgress(params.easing, progress);
            const {
              initialValue,
              finalValue,
              unit
            } = el[prop];
            el[prop].currentValue = initialValue + easeProgress * (finalValue - initialValue);
            const currentValue = el[prop].currentValue;

            if (finalValue > initialValue && currentValue >= finalValue || finalValue < initialValue && currentValue <= finalValue) {
              el.container.style[prop] = finalValue + unit;
              propsDone += 1;

              if (propsDone === Object.keys(props).length) {
                el.done = true;
                elementsDone += 1;
              }

              if (elementsDone === elements.length) {
                done = true;
              }
            }

            if (done) {
              a.done(params.complete);
              return;
            }

            el.container.style[prop] = currentValue + unit;
          });
        });
        if (done) return; // Then call

        a.frameId = window.requestAnimationFrame(render);
      }

      a.frameId = window.requestAnimationFrame(render);
      return a;
    }

  };

  if (a.elements.length === 0) {
    return els;
  }

  let animateInstance;

  for (let i = 0; i < a.elements.length; i += 1) {
    if (a.elements[i].dom7AnimateInstance) {
      animateInstance = a.elements[i].dom7AnimateInstance;
    } else a.elements[i].dom7AnimateInstance = a;
  }

  if (!animateInstance) {
    animateInstance = a;
  }

  if (initialProps === 'stop') {
    animateInstance.stop();
  } else {
    animateInstance.animate(a.props, a.params);
  }

  return els;
}

function stop() {
  const els = this;

  for (let i = 0; i < els.length; i += 1) {
    if (els[i].dom7AnimateInstance) {
      els[i].dom7AnimateInstance.stop();
    }
  }
}

const noTrigger = 'resize scroll'.split(' ');

function shortcut(name) {
  function eventHandler(...args) {
    if (typeof args[0] === 'undefined') {
      for (let i = 0; i < this.length; i += 1) {
        if (noTrigger.indexOf(name) < 0) {
          if (name in this[i]) this[i][name]();else {
            dom7_esm_$(this[i]).trigger(name);
          }
        }
      }

      return this;
    }

    return this.on(name, ...args);
  }

  return eventHandler;
}

const click = shortcut('click');
const dom7_esm_blur = shortcut('blur');
const dom7_esm_focus = shortcut('focus');
const focusin = shortcut('focusin');
const focusout = shortcut('focusout');
const keyup = shortcut('keyup');
const keydown = shortcut('keydown');
const keypress = shortcut('keypress');
const dom7_esm_submit = shortcut('submit');
const change = shortcut('change');
const mousedown = shortcut('mousedown');
const mousemove = shortcut('mousemove');
const mouseup = shortcut('mouseup');
const mouseenter = shortcut('mouseenter');
const mouseleave = shortcut('mouseleave');
const mouseout = shortcut('mouseout');
const mouseover = shortcut('mouseover');
const touchstart = shortcut('touchstart');
const touchend = shortcut('touchend');
const touchmove = shortcut('touchmove');
const resize = shortcut('resize');
const dom7_esm_scroll = shortcut('scroll');

/* harmony default export */ var dom7_esm = ((/* unused pure expression or super */ null && (dom7_esm_$)));


;// CONCATENATED MODULE: ./node_modules/swiper/shared/dom.js

const Methods = {
  addClass: addClass,
  removeClass: removeClass,
  hasClass: hasClass,
  toggleClass: toggleClass,
  attr: attr,
  removeAttr: removeAttr,
  transform: transform,
  transition: transition,
  on: on,
  off: off,
  trigger: trigger,
  transitionEnd: transitionEnd,
  outerWidth: dom7_esm_outerWidth,
  outerHeight: dom7_esm_outerHeight,
  styles: styles,
  offset: offset,
  css: css,
  each: each,
  html: html,
  text: dom7_esm_text,
  is: is,
  index: index,
  eq: eq,
  append: append,
  prepend: prepend,
  next: next,
  nextAll: nextAll,
  prev: prev,
  prevAll: prevAll,
  parent: dom7_esm_parent,
  parents: parents,
  closest: closest,
  find: find,
  children: children,
  filter: filter,
  remove: remove
};
Object.keys(Methods).forEach(methodName => {
  Object.defineProperty(dom7_esm_$.fn, methodName, {
    value: Methods[methodName],
    writable: true
  });
});
/* harmony default export */ var dom = (dom7_esm_$);
;// CONCATENATED MODULE: ./node_modules/swiper/shared/utils.js


function deleteProps(obj) {
  const object = obj;
  Object.keys(object).forEach(key => {
    try {
      object[key] = null;
    } catch (e) {// no getter for object
    }

    try {
      delete object[key];
    } catch (e) {// something got wrong
    }
  });
}

function utils_nextTick(callback, delay = 0) {
  return setTimeout(callback, delay);
}

function utils_now() {
  return Date.now();
}

function utils_getComputedStyle(el) {
  const window = ssr_window_esm_getWindow();
  let style;

  if (window.getComputedStyle) {
    style = window.getComputedStyle(el, null);
  }

  if (!style && el.currentStyle) {
    style = el.currentStyle;
  }

  if (!style) {
    style = el.style;
  }

  return style;
}

function utils_getTranslate(el, axis = 'x') {
  const window = ssr_window_esm_getWindow();
  let matrix;
  let curTransform;
  let transformMatrix;
  const curStyle = utils_getComputedStyle(el, null);

  if (window.WebKitCSSMatrix) {
    curTransform = curStyle.transform || curStyle.webkitTransform;

    if (curTransform.split(',').length > 6) {
      curTransform = curTransform.split(', ').map(a => a.replace(',', '.')).join(', ');
    } // Some old versions of Webkit choke when 'none' is passed; pass
    // empty string instead in this case


    transformMatrix = new window.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
  } else {
    transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
    matrix = transformMatrix.toString().split(',');
  }

  if (axis === 'x') {
    // Latest Chrome and webkits Fix
    if (window.WebKitCSSMatrix) curTransform = transformMatrix.m41; // Crazy IE10 Matrix
    else if (matrix.length === 16) curTransform = parseFloat(matrix[12]); // Normal Browsers
    else curTransform = parseFloat(matrix[4]);
  }

  if (axis === 'y') {
    // Latest Chrome and webkits Fix
    if (window.WebKitCSSMatrix) curTransform = transformMatrix.m42; // Crazy IE10 Matrix
    else if (matrix.length === 16) curTransform = parseFloat(matrix[13]); // Normal Browsers
    else curTransform = parseFloat(matrix[5]);
  }

  return curTransform || 0;
}

function utils_isObject(o) {
  return typeof o === 'object' && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === 'Object';
}

function isNode(node) {
  // eslint-disable-next-line
  if (typeof window !== 'undefined' && typeof window.HTMLElement !== 'undefined') {
    return node instanceof HTMLElement;
  }

  return node && (node.nodeType === 1 || node.nodeType === 11);
}

function utils_extend(...args) {
  const to = Object(args[0]);
  const noExtend = ['__proto__', 'constructor', 'prototype'];

  for (let i = 1; i < args.length; i += 1) {
    const nextSource = args[i];

    if (nextSource !== undefined && nextSource !== null && !isNode(nextSource)) {
      const keysArray = Object.keys(Object(nextSource)).filter(key => noExtend.indexOf(key) < 0);

      for (let nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1) {
        const nextKey = keysArray[nextIndex];
        const desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);

        if (desc !== undefined && desc.enumerable) {
          if (utils_isObject(to[nextKey]) && utils_isObject(nextSource[nextKey])) {
            if (nextSource[nextKey].__swiper__) {
              to[nextKey] = nextSource[nextKey];
            } else {
              utils_extend(to[nextKey], nextSource[nextKey]);
            }
          } else if (!utils_isObject(to[nextKey]) && utils_isObject(nextSource[nextKey])) {
            to[nextKey] = {};

            if (nextSource[nextKey].__swiper__) {
              to[nextKey] = nextSource[nextKey];
            } else {
              utils_extend(to[nextKey], nextSource[nextKey]);
            }
          } else {
            to[nextKey] = nextSource[nextKey];
          }
        }
      }
    }
  }

  return to;
}

function setCSSProperty(el, varName, varValue) {
  el.style.setProperty(varName, varValue);
}

function animateCSSModeScroll({
  swiper,
  targetPosition,
  side
}) {
  const window = ssr_window_esm_getWindow();
  const startPosition = -swiper.translate;
  let startTime = null;
  let time;
  const duration = swiper.params.speed;
  swiper.wrapperEl.style.scrollSnapType = 'none';
  window.cancelAnimationFrame(swiper.cssModeFrameID);
  const dir = targetPosition > startPosition ? 'next' : 'prev';

  const isOutOfBound = (current, target) => {
    return dir === 'next' && current >= target || dir === 'prev' && current <= target;
  };

  const animate = () => {
    time = new Date().getTime();

    if (startTime === null) {
      startTime = time;
    }

    const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
    const easeProgress = 0.5 - Math.cos(progress * Math.PI) / 2;
    let currentPosition = startPosition + easeProgress * (targetPosition - startPosition);

    if (isOutOfBound(currentPosition, targetPosition)) {
      currentPosition = targetPosition;
    }

    swiper.wrapperEl.scrollTo({
      [side]: currentPosition
    });

    if (isOutOfBound(currentPosition, targetPosition)) {
      swiper.wrapperEl.style.overflow = 'hidden';
      swiper.wrapperEl.style.scrollSnapType = '';
      setTimeout(() => {
        swiper.wrapperEl.style.overflow = '';
        swiper.wrapperEl.scrollTo({
          [side]: currentPosition
        });
      });
      window.cancelAnimationFrame(swiper.cssModeFrameID);
      return;
    }

    swiper.cssModeFrameID = window.requestAnimationFrame(animate);
  };

  animate();
}


;// CONCATENATED MODULE: ./node_modules/swiper/shared/get-support.js

let support;

function calcSupport() {
  const window = ssr_window_esm_getWindow();
  const document = ssr_window_esm_getDocument();
  return {
    smoothScroll: document.documentElement && 'scrollBehavior' in document.documentElement.style,
    touch: !!('ontouchstart' in window || window.DocumentTouch && document instanceof window.DocumentTouch),
    passiveListener: function checkPassiveListener() {
      let supportsPassive = false;

      try {
        const opts = Object.defineProperty({}, 'passive', {
          // eslint-disable-next-line
          get() {
            supportsPassive = true;
          }

        });
        window.addEventListener('testPassiveListener', null, opts);
      } catch (e) {// No support
      }

      return supportsPassive;
    }(),
    gestures: function checkGestures() {
      return 'ongesturestart' in window;
    }()
  };
}

function getSupport() {
  if (!support) {
    support = calcSupport();
  }

  return support;
}


;// CONCATENATED MODULE: ./node_modules/swiper/shared/get-device.js


let deviceCached;

function calcDevice({
  userAgent
} = {}) {
  const support = getSupport();
  const window = ssr_window_esm_getWindow();
  const platform = window.navigator.platform;
  const ua = userAgent || window.navigator.userAgent;
  const device = {
    ios: false,
    android: false
  };
  const screenWidth = window.screen.width;
  const screenHeight = window.screen.height;
  const android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line

  let ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
  const ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
  const iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
  const windows = platform === 'Win32';
  let macos = platform === 'MacIntel'; // iPadOs 13 fix

  const iPadScreens = ['1024x1366', '1366x1024', '834x1194', '1194x834', '834x1112', '1112x834', '768x1024', '1024x768', '820x1180', '1180x820', '810x1080', '1080x810'];

  if (!ipad && macos && support.touch && iPadScreens.indexOf(`${screenWidth}x${screenHeight}`) >= 0) {
    ipad = ua.match(/(Version)\/([\d.]+)/);
    if (!ipad) ipad = [0, 1, '13_0_0'];
    macos = false;
  } // Android


  if (android && !windows) {
    device.os = 'android';
    device.android = true;
  }

  if (ipad || iphone || ipod) {
    device.os = 'ios';
    device.ios = true;
  } // Export object


  return device;
}

function getDevice(overrides = {}) {
  if (!deviceCached) {
    deviceCached = calcDevice(overrides);
  }

  return deviceCached;
}


;// CONCATENATED MODULE: ./node_modules/swiper/shared/get-browser.js

let browser;

function calcBrowser() {
  const window = ssr_window_esm_getWindow();

  function isSafari() {
    const ua = window.navigator.userAgent.toLowerCase();
    return ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0;
  }

  return {
    isSafari: isSafari(),
    isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window.navigator.userAgent)
  };
}

function getBrowser() {
  if (!browser) {
    browser = calcBrowser();
  }

  return browser;
}


;// CONCATENATED MODULE: ./node_modules/swiper/core/modules/resize/resize.js

function Resize({
  swiper,
  on,
  emit
}) {
  const window = ssr_window_esm_getWindow();
  let observer = null;
  let animationFrame = null;

  const resizeHandler = () => {
    if (!swiper || swiper.destroyed || !swiper.initialized) return;
    emit('beforeResize');
    emit('resize');
  };

  const createObserver = () => {
    if (!swiper || swiper.destroyed || !swiper.initialized) return;
    observer = new ResizeObserver(entries => {
      animationFrame = window.requestAnimationFrame(() => {
        const {
          width,
          height
        } = swiper;
        let newWidth = width;
        let newHeight = height;
        entries.forEach(({
          contentBoxSize,
          contentRect,
          target
        }) => {
          if (target && target !== swiper.el) return;
          newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
          newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
        });

        if (newWidth !== width || newHeight !== height) {
          resizeHandler();
        }
      });
    });
    observer.observe(swiper.el);
  };

  const removeObserver = () => {
    if (animationFrame) {
      window.cancelAnimationFrame(animationFrame);
    }

    if (observer && observer.unobserve && swiper.el) {
      observer.unobserve(swiper.el);
      observer = null;
    }
  };

  const orientationChangeHandler = () => {
    if (!swiper || swiper.destroyed || !swiper.initialized) return;
    emit('orientationchange');
  };

  on('init', () => {
    if (swiper.params.resizeObserver && typeof window.ResizeObserver !== 'undefined') {
      createObserver();
      return;
    }

    window.addEventListener('resize', resizeHandler);
    window.addEventListener('orientationchange', orientationChangeHandler);
  });
  on('destroy', () => {
    removeObserver();
    window.removeEventListener('resize', resizeHandler);
    window.removeEventListener('orientationchange', orientationChangeHandler);
  });
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/modules/observer/observer.js

function Observer({
  swiper,
  extendParams,
  on,
  emit
}) {
  const observers = [];
  const window = ssr_window_esm_getWindow();

  const attach = (target, options = {}) => {
    const ObserverFunc = window.MutationObserver || window.WebkitMutationObserver;
    const observer = new ObserverFunc(mutations => {
      // The observerUpdate event should only be triggered
      // once despite the number of mutations.  Additional
      // triggers are redundant and are very costly
      if (mutations.length === 1) {
        emit('observerUpdate', mutations[0]);
        return;
      }

      const observerUpdate = function observerUpdate() {
        emit('observerUpdate', mutations[0]);
      };

      if (window.requestAnimationFrame) {
        window.requestAnimationFrame(observerUpdate);
      } else {
        window.setTimeout(observerUpdate, 0);
      }
    });
    observer.observe(target, {
      attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
      childList: typeof options.childList === 'undefined' ? true : options.childList,
      characterData: typeof options.characterData === 'undefined' ? true : options.characterData
    });
    observers.push(observer);
  };

  const init = () => {
    if (!swiper.params.observer) return;

    if (swiper.params.observeParents) {
      const containerParents = swiper.$el.parents();

      for (let i = 0; i < containerParents.length; i += 1) {
        attach(containerParents[i]);
      }
    } // Observe container


    attach(swiper.$el[0], {
      childList: swiper.params.observeSlideChildren
    }); // Observe wrapper

    attach(swiper.$wrapperEl[0], {
      attributes: false
    });
  };

  const destroy = () => {
    observers.forEach(observer => {
      observer.disconnect();
    });
    observers.splice(0, observers.length);
  };

  extendParams({
    observer: false,
    observeParents: false,
    observeSlideChildren: false
  });
  on('init', init);
  on('destroy', destroy);
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/events-emitter.js
/* eslint-disable no-underscore-dangle */
/* harmony default export */ var events_emitter = ({
  on(events, handler, priority) {
    const self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (typeof handler !== 'function') return self;
    const method = priority ? 'unshift' : 'push';
    events.split(' ').forEach(event => {
      if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
      self.eventsListeners[event][method](handler);
    });
    return self;
  },

  once(events, handler, priority) {
    const self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (typeof handler !== 'function') return self;

    function onceHandler(...args) {
      self.off(events, onceHandler);

      if (onceHandler.__emitterProxy) {
        delete onceHandler.__emitterProxy;
      }

      handler.apply(self, args);
    }

    onceHandler.__emitterProxy = handler;
    return self.on(events, onceHandler, priority);
  },

  onAny(handler, priority) {
    const self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (typeof handler !== 'function') return self;
    const method = priority ? 'unshift' : 'push';

    if (self.eventsAnyListeners.indexOf(handler) < 0) {
      self.eventsAnyListeners[method](handler);
    }

    return self;
  },

  offAny(handler) {
    const self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (!self.eventsAnyListeners) return self;
    const index = self.eventsAnyListeners.indexOf(handler);

    if (index >= 0) {
      self.eventsAnyListeners.splice(index, 1);
    }

    return self;
  },

  off(events, handler) {
    const self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (!self.eventsListeners) return self;
    events.split(' ').forEach(event => {
      if (typeof handler === 'undefined') {
        self.eventsListeners[event] = [];
      } else if (self.eventsListeners[event]) {
        self.eventsListeners[event].forEach((eventHandler, index) => {
          if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) {
            self.eventsListeners[event].splice(index, 1);
          }
        });
      }
    });
    return self;
  },

  emit(...args) {
    const self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (!self.eventsListeners) return self;
    let events;
    let data;
    let context;

    if (typeof args[0] === 'string' || Array.isArray(args[0])) {
      events = args[0];
      data = args.slice(1, args.length);
      context = self;
    } else {
      events = args[0].events;
      data = args[0].data;
      context = args[0].context || self;
    }

    data.unshift(context);
    const eventsArray = Array.isArray(events) ? events : events.split(' ');
    eventsArray.forEach(event => {
      if (self.eventsAnyListeners && self.eventsAnyListeners.length) {
        self.eventsAnyListeners.forEach(eventHandler => {
          eventHandler.apply(context, [event, ...data]);
        });
      }

      if (self.eventsListeners && self.eventsListeners[event]) {
        self.eventsListeners[event].forEach(eventHandler => {
          eventHandler.apply(context, data);
        });
      }
    });
    return self;
  }

});
;// CONCATENATED MODULE: ./node_modules/swiper/core/update/updateSize.js
function updateSize() {
  const swiper = this;
  let width;
  let height;
  const $el = swiper.$el;

  if (typeof swiper.params.width !== 'undefined' && swiper.params.width !== null) {
    width = swiper.params.width;
  } else {
    width = $el[0].clientWidth;
  }

  if (typeof swiper.params.height !== 'undefined' && swiper.params.height !== null) {
    height = swiper.params.height;
  } else {
    height = $el[0].clientHeight;
  }

  if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) {
    return;
  } // Subtract paddings


  width = width - parseInt($el.css('padding-left') || 0, 10) - parseInt($el.css('padding-right') || 0, 10);
  height = height - parseInt($el.css('padding-top') || 0, 10) - parseInt($el.css('padding-bottom') || 0, 10);
  if (Number.isNaN(width)) width = 0;
  if (Number.isNaN(height)) height = 0;
  Object.assign(swiper, {
    width,
    height,
    size: swiper.isHorizontal() ? width : height
  });
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/update/updateSlides.js

function updateSlides() {
  const swiper = this;

  function getDirectionLabel(property) {
    if (swiper.isHorizontal()) {
      return property;
    } // prettier-ignore


    return {
      'width': 'height',
      'margin-top': 'margin-left',
      'margin-bottom ': 'margin-right',
      'margin-left': 'margin-top',
      'margin-right': 'margin-bottom',
      'padding-left': 'padding-top',
      'padding-right': 'padding-bottom',
      'marginRight': 'marginBottom'
    }[property];
  }

  function getDirectionPropertyValue(node, label) {
    return parseFloat(node.getPropertyValue(getDirectionLabel(label)) || 0);
  }

  const params = swiper.params;
  const {
    $wrapperEl,
    size: swiperSize,
    rtlTranslate: rtl,
    wrongRTL
  } = swiper;
  const isVirtual = swiper.virtual && params.virtual.enabled;
  const previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
  const slides = $wrapperEl.children(`.${swiper.params.slideClass}`);
  const slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
  let snapGrid = [];
  const slidesGrid = [];
  const slidesSizesGrid = [];
  let offsetBefore = params.slidesOffsetBefore;

  if (typeof offsetBefore === 'function') {
    offsetBefore = params.slidesOffsetBefore.call(swiper);
  }

  let offsetAfter = params.slidesOffsetAfter;

  if (typeof offsetAfter === 'function') {
    offsetAfter = params.slidesOffsetAfter.call(swiper);
  }

  const previousSnapGridLength = swiper.snapGrid.length;
  const previousSlidesGridLength = swiper.slidesGrid.length;
  let spaceBetween = params.spaceBetween;
  let slidePosition = -offsetBefore;
  let prevSlideSize = 0;
  let index = 0;

  if (typeof swiperSize === 'undefined') {
    return;
  }

  if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
    spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiperSize;
  }

  swiper.virtualSize = -spaceBetween; // reset margins

  if (rtl) slides.css({
    marginLeft: '',
    marginBottom: '',
    marginTop: ''
  });else slides.css({
    marginRight: '',
    marginBottom: '',
    marginTop: ''
  }); // reset cssMode offsets

  if (params.centeredSlides && params.cssMode) {
    setCSSProperty(swiper.wrapperEl, '--swiper-centered-offset-before', '');
    setCSSProperty(swiper.wrapperEl, '--swiper-centered-offset-after', '');
  }

  const gridEnabled = params.grid && params.grid.rows > 1 && swiper.grid;

  if (gridEnabled) {
    swiper.grid.initSlides(slidesLength);
  } // Calc slides


  let slideSize;
  const shouldResetSlideSize = params.slidesPerView === 'auto' && params.breakpoints && Object.keys(params.breakpoints).filter(key => {
    return typeof params.breakpoints[key].slidesPerView !== 'undefined';
  }).length > 0;

  for (let i = 0; i < slidesLength; i += 1) {
    slideSize = 0;
    const slide = slides.eq(i);

    if (gridEnabled) {
      swiper.grid.updateSlide(i, slide, slidesLength, getDirectionLabel);
    }

    if (slide.css('display') === 'none') continue; // eslint-disable-line

    if (params.slidesPerView === 'auto') {
      if (shouldResetSlideSize) {
        slides[i].style[getDirectionLabel('width')] = ``;
      }

      const slideStyles = getComputedStyle(slide[0]);
      const currentTransform = slide[0].style.transform;
      const currentWebKitTransform = slide[0].style.webkitTransform;

      if (currentTransform) {
        slide[0].style.transform = 'none';
      }

      if (currentWebKitTransform) {
        slide[0].style.webkitTransform = 'none';
      }

      if (params.roundLengths) {
        slideSize = swiper.isHorizontal() ? slide.outerWidth(true) : slide.outerHeight(true);
      } else {
        // eslint-disable-next-line
        const width = getDirectionPropertyValue(slideStyles, 'width');
        const paddingLeft = getDirectionPropertyValue(slideStyles, 'padding-left');
        const paddingRight = getDirectionPropertyValue(slideStyles, 'padding-right');
        const marginLeft = getDirectionPropertyValue(slideStyles, 'margin-left');
        const marginRight = getDirectionPropertyValue(slideStyles, 'margin-right');
        const boxSizing = slideStyles.getPropertyValue('box-sizing');

        if (boxSizing && boxSizing === 'border-box') {
          slideSize = width + marginLeft + marginRight;
        } else {
          const {
            clientWidth,
            offsetWidth
          } = slide[0];
          slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
        }
      }

      if (currentTransform) {
        slide[0].style.transform = currentTransform;
      }

      if (currentWebKitTransform) {
        slide[0].style.webkitTransform = currentWebKitTransform;
      }

      if (params.roundLengths) slideSize = Math.floor(slideSize);
    } else {
      slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
      if (params.roundLengths) slideSize = Math.floor(slideSize);

      if (slides[i]) {
        slides[i].style[getDirectionLabel('width')] = `${slideSize}px`;
      }
    }

    if (slides[i]) {
      slides[i].swiperSlideSize = slideSize;
    }

    slidesSizesGrid.push(slideSize);

    if (params.centeredSlides) {
      slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
      if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
      if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
      if (Math.abs(slidePosition) < 1 / 1000) slidePosition = 0;
      if (params.roundLengths) slidePosition = Math.floor(slidePosition);
      if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
      slidesGrid.push(slidePosition);
    } else {
      if (params.roundLengths) slidePosition = Math.floor(slidePosition);
      if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
      slidesGrid.push(slidePosition);
      slidePosition = slidePosition + slideSize + spaceBetween;
    }

    swiper.virtualSize += slideSize + spaceBetween;
    prevSlideSize = slideSize;
    index += 1;
  }

  swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;

  if (rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) {
    $wrapperEl.css({
      width: `${swiper.virtualSize + params.spaceBetween}px`
    });
  }

  if (params.setWrapperSize) {
    $wrapperEl.css({
      [getDirectionLabel('width')]: `${swiper.virtualSize + params.spaceBetween}px`
    });
  }

  if (gridEnabled) {
    swiper.grid.updateWrapperSize(slideSize, snapGrid, getDirectionLabel);
  } // Remove last grid elements depending on width


  if (!params.centeredSlides) {
    const newSlidesGrid = [];

    for (let i = 0; i < snapGrid.length; i += 1) {
      let slidesGridItem = snapGrid[i];
      if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);

      if (snapGrid[i] <= swiper.virtualSize - swiperSize) {
        newSlidesGrid.push(slidesGridItem);
      }
    }

    snapGrid = newSlidesGrid;

    if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) {
      snapGrid.push(swiper.virtualSize - swiperSize);
    }
  }

  if (snapGrid.length === 0) snapGrid = [0];

  if (params.spaceBetween !== 0) {
    const key = swiper.isHorizontal() && rtl ? 'marginLeft' : getDirectionLabel('marginRight');
    slides.filter((_, slideIndex) => {
      if (!params.cssMode) return true;

      if (slideIndex === slides.length - 1) {
        return false;
      }

      return true;
    }).css({
      [key]: `${spaceBetween}px`
    });
  }

  if (params.centeredSlides && params.centeredSlidesBounds) {
    let allSlidesSize = 0;
    slidesSizesGrid.forEach(slideSizeValue => {
      allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
    });
    allSlidesSize -= params.spaceBetween;
    const maxSnap = allSlidesSize - swiperSize;
    snapGrid = snapGrid.map(snap => {
      if (snap < 0) return -offsetBefore;
      if (snap > maxSnap) return maxSnap + offsetAfter;
      return snap;
    });
  }

  if (params.centerInsufficientSlides) {
    let allSlidesSize = 0;
    slidesSizesGrid.forEach(slideSizeValue => {
      allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
    });
    allSlidesSize -= params.spaceBetween;

    if (allSlidesSize < swiperSize) {
      const allSlidesOffset = (swiperSize - allSlidesSize) / 2;
      snapGrid.forEach((snap, snapIndex) => {
        snapGrid[snapIndex] = snap - allSlidesOffset;
      });
      slidesGrid.forEach((snap, snapIndex) => {
        slidesGrid[snapIndex] = snap + allSlidesOffset;
      });
    }
  }

  Object.assign(swiper, {
    slides,
    snapGrid,
    slidesGrid,
    slidesSizesGrid
  });

  if (params.centeredSlides && params.cssMode && !params.centeredSlidesBounds) {
    setCSSProperty(swiper.wrapperEl, '--swiper-centered-offset-before', `${-snapGrid[0]}px`);
    setCSSProperty(swiper.wrapperEl, '--swiper-centered-offset-after', `${swiper.size / 2 - slidesSizesGrid[slidesSizesGrid.length - 1] / 2}px`);
    const addToSnapGrid = -swiper.snapGrid[0];
    const addToSlidesGrid = -swiper.slidesGrid[0];
    swiper.snapGrid = swiper.snapGrid.map(v => v + addToSnapGrid);
    swiper.slidesGrid = swiper.slidesGrid.map(v => v + addToSlidesGrid);
  }

  if (slidesLength !== previousSlidesLength) {
    swiper.emit('slidesLengthChange');
  }

  if (snapGrid.length !== previousSnapGridLength) {
    if (swiper.params.watchOverflow) swiper.checkOverflow();
    swiper.emit('snapGridLengthChange');
  }

  if (slidesGrid.length !== previousSlidesGridLength) {
    swiper.emit('slidesGridLengthChange');
  }

  if (params.watchSlidesProgress) {
    swiper.updateSlidesOffset();
  }

  if (!isVirtual && !params.cssMode && (params.effect === 'slide' || params.effect === 'fade')) {
    const backFaceHiddenClass = `${params.containerModifierClass}backface-hidden`;
    const hasClassBackfaceClassAdded = swiper.$el.hasClass(backFaceHiddenClass);

    if (slidesLength <= params.maxBackfaceHiddenSlides) {
      if (!hasClassBackfaceClassAdded) swiper.$el.addClass(backFaceHiddenClass);
    } else if (hasClassBackfaceClassAdded) {
      swiper.$el.removeClass(backFaceHiddenClass);
    }
  }
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/update/updateAutoHeight.js

function updateAutoHeight(speed) {
  const swiper = this;
  const activeSlides = [];
  const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
  let newHeight = 0;
  let i;

  if (typeof speed === 'number') {
    swiper.setTransition(speed);
  } else if (speed === true) {
    swiper.setTransition(swiper.params.speed);
  }

  const getSlideByIndex = index => {
    if (isVirtual) {
      return swiper.slides.filter(el => parseInt(el.getAttribute('data-swiper-slide-index'), 10) === index)[0];
    }

    return swiper.slides.eq(index)[0];
  }; // Find slides currently in view


  if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
    if (swiper.params.centeredSlides) {
      (swiper.visibleSlides || dom([])).each(slide => {
        activeSlides.push(slide);
      });
    } else {
      for (i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1) {
        const index = swiper.activeIndex + i;
        if (index > swiper.slides.length && !isVirtual) break;
        activeSlides.push(getSlideByIndex(index));
      }
    }
  } else {
    activeSlides.push(getSlideByIndex(swiper.activeIndex));
  } // Find new height from highest slide in view


  for (i = 0; i < activeSlides.length; i += 1) {
    if (typeof activeSlides[i] !== 'undefined') {
      const height = activeSlides[i].offsetHeight;
      newHeight = height > newHeight ? height : newHeight;
    }
  } // Update Height


  if (newHeight || newHeight === 0) swiper.$wrapperEl.css('height', `${newHeight}px`);
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/update/updateSlidesOffset.js
function updateSlidesOffset() {
  const swiper = this;
  const slides = swiper.slides;

  for (let i = 0; i < slides.length; i += 1) {
    slides[i].swiperSlideOffset = swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop;
  }
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/update/updateSlidesProgress.js

function updateSlidesProgress(translate = this && this.translate || 0) {
  const swiper = this;
  const params = swiper.params;
  const {
    slides,
    rtlTranslate: rtl,
    snapGrid
  } = swiper;
  if (slides.length === 0) return;
  if (typeof slides[0].swiperSlideOffset === 'undefined') swiper.updateSlidesOffset();
  let offsetCenter = -translate;
  if (rtl) offsetCenter = translate; // Visible Slides

  slides.removeClass(params.slideVisibleClass);
  swiper.visibleSlidesIndexes = [];
  swiper.visibleSlides = [];

  for (let i = 0; i < slides.length; i += 1) {
    const slide = slides[i];
    let slideOffset = slide.swiperSlideOffset;

    if (params.cssMode && params.centeredSlides) {
      slideOffset -= slides[0].swiperSlideOffset;
    }

    const slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + params.spaceBetween);
    const originalSlideProgress = (offsetCenter - snapGrid[0] + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + params.spaceBetween);
    const slideBefore = -(offsetCenter - slideOffset);
    const slideAfter = slideBefore + swiper.slidesSizesGrid[i];
    const isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;

    if (isVisible) {
      swiper.visibleSlides.push(slide);
      swiper.visibleSlidesIndexes.push(i);
      slides.eq(i).addClass(params.slideVisibleClass);
    }

    slide.progress = rtl ? -slideProgress : slideProgress;
    slide.originalProgress = rtl ? -originalSlideProgress : originalSlideProgress;
  }

  swiper.visibleSlides = dom(swiper.visibleSlides);
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/update/updateProgress.js
function updateProgress(translate) {
  const swiper = this;

  if (typeof translate === 'undefined') {
    const multiplier = swiper.rtlTranslate ? -1 : 1; // eslint-disable-next-line

    translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
  }

  const params = swiper.params;
  const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
  let {
    progress,
    isBeginning,
    isEnd
  } = swiper;
  const wasBeginning = isBeginning;
  const wasEnd = isEnd;

  if (translatesDiff === 0) {
    progress = 0;
    isBeginning = true;
    isEnd = true;
  } else {
    progress = (translate - swiper.minTranslate()) / translatesDiff;
    isBeginning = progress <= 0;
    isEnd = progress >= 1;
  }

  Object.assign(swiper, {
    progress,
    isBeginning,
    isEnd
  });
  if (params.watchSlidesProgress || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);

  if (isBeginning && !wasBeginning) {
    swiper.emit('reachBeginning toEdge');
  }

  if (isEnd && !wasEnd) {
    swiper.emit('reachEnd toEdge');
  }

  if (wasBeginning && !isBeginning || wasEnd && !isEnd) {
    swiper.emit('fromEdge');
  }

  swiper.emit('progress', progress);
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/update/updateSlidesClasses.js
function updateSlidesClasses() {
  const swiper = this;
  const {
    slides,
    params,
    $wrapperEl,
    activeIndex,
    realIndex
  } = swiper;
  const isVirtual = swiper.virtual && params.virtual.enabled;
  slides.removeClass(`${params.slideActiveClass} ${params.slideNextClass} ${params.slidePrevClass} ${params.slideDuplicateActiveClass} ${params.slideDuplicateNextClass} ${params.slideDuplicatePrevClass}`);
  let activeSlide;

  if (isVirtual) {
    activeSlide = swiper.$wrapperEl.find(`.${params.slideClass}[data-swiper-slide-index="${activeIndex}"]`);
  } else {
    activeSlide = slides.eq(activeIndex);
  } // Active classes


  activeSlide.addClass(params.slideActiveClass);

  if (params.loop) {
    // Duplicate to all looped slides
    if (activeSlide.hasClass(params.slideDuplicateClass)) {
      $wrapperEl.children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${realIndex}"]`).addClass(params.slideDuplicateActiveClass);
    } else {
      $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${realIndex}"]`).addClass(params.slideDuplicateActiveClass);
    }
  } // Next Slide


  let nextSlide = activeSlide.nextAll(`.${params.slideClass}`).eq(0).addClass(params.slideNextClass);

  if (params.loop && nextSlide.length === 0) {
    nextSlide = slides.eq(0);
    nextSlide.addClass(params.slideNextClass);
  } // Prev Slide


  let prevSlide = activeSlide.prevAll(`.${params.slideClass}`).eq(0).addClass(params.slidePrevClass);

  if (params.loop && prevSlide.length === 0) {
    prevSlide = slides.eq(-1);
    prevSlide.addClass(params.slidePrevClass);
  }

  if (params.loop) {
    // Duplicate to all looped slides
    if (nextSlide.hasClass(params.slideDuplicateClass)) {
      $wrapperEl.children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${nextSlide.attr('data-swiper-slide-index')}"]`).addClass(params.slideDuplicateNextClass);
    } else {
      $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${nextSlide.attr('data-swiper-slide-index')}"]`).addClass(params.slideDuplicateNextClass);
    }

    if (prevSlide.hasClass(params.slideDuplicateClass)) {
      $wrapperEl.children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${prevSlide.attr('data-swiper-slide-index')}"]`).addClass(params.slideDuplicatePrevClass);
    } else {
      $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${prevSlide.attr('data-swiper-slide-index')}"]`).addClass(params.slideDuplicatePrevClass);
    }
  }

  swiper.emitSlidesClasses();
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/update/updateActiveIndex.js
function updateActiveIndex(newActiveIndex) {
  const swiper = this;
  const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
  const {
    slidesGrid,
    snapGrid,
    params,
    activeIndex: previousIndex,
    realIndex: previousRealIndex,
    snapIndex: previousSnapIndex
  } = swiper;
  let activeIndex = newActiveIndex;
  let snapIndex;

  if (typeof activeIndex === 'undefined') {
    for (let i = 0; i < slidesGrid.length; i += 1) {
      if (typeof slidesGrid[i + 1] !== 'undefined') {
        if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) {
          activeIndex = i;
        } else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) {
          activeIndex = i + 1;
        }
      } else if (translate >= slidesGrid[i]) {
        activeIndex = i;
      }
    } // Normalize slideIndex


    if (params.normalizeSlideIndex) {
      if (activeIndex < 0 || typeof activeIndex === 'undefined') activeIndex = 0;
    }
  }

  if (snapGrid.indexOf(translate) >= 0) {
    snapIndex = snapGrid.indexOf(translate);
  } else {
    const skip = Math.min(params.slidesPerGroupSkip, activeIndex);
    snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
  }

  if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;

  if (activeIndex === previousIndex) {
    if (snapIndex !== previousSnapIndex) {
      swiper.snapIndex = snapIndex;
      swiper.emit('snapIndexChange');
    }

    return;
  } // Get real index


  const realIndex = parseInt(swiper.slides.eq(activeIndex).attr('data-swiper-slide-index') || activeIndex, 10);
  Object.assign(swiper, {
    snapIndex,
    realIndex,
    previousIndex,
    activeIndex
  });
  swiper.emit('activeIndexChange');
  swiper.emit('snapIndexChange');

  if (previousRealIndex !== realIndex) {
    swiper.emit('realIndexChange');
  }

  if (swiper.initialized || swiper.params.runCallbacksOnInit) {
    swiper.emit('slideChange');
  }
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/update/updateClickedSlide.js

function updateClickedSlide(e) {
  const swiper = this;
  const params = swiper.params;
  const slide = dom(e).closest(`.${params.slideClass}`)[0];
  let slideFound = false;
  let slideIndex;

  if (slide) {
    for (let i = 0; i < swiper.slides.length; i += 1) {
      if (swiper.slides[i] === slide) {
        slideFound = true;
        slideIndex = i;
        break;
      }
    }
  }

  if (slide && slideFound) {
    swiper.clickedSlide = slide;

    if (swiper.virtual && swiper.params.virtual.enabled) {
      swiper.clickedIndex = parseInt(dom(slide).attr('data-swiper-slide-index'), 10);
    } else {
      swiper.clickedIndex = slideIndex;
    }
  } else {
    swiper.clickedSlide = undefined;
    swiper.clickedIndex = undefined;
    return;
  }

  if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) {
    swiper.slideToClickedSlide();
  }
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/update/index.js









/* harmony default export */ var update = ({
  updateSize: updateSize,
  updateSlides: updateSlides,
  updateAutoHeight: updateAutoHeight,
  updateSlidesOffset: updateSlidesOffset,
  updateSlidesProgress: updateSlidesProgress,
  updateProgress: updateProgress,
  updateSlidesClasses: updateSlidesClasses,
  updateActiveIndex: updateActiveIndex,
  updateClickedSlide: updateClickedSlide
});
;// CONCATENATED MODULE: ./node_modules/swiper/core/translate/getTranslate.js

function getSwiperTranslate(axis = this.isHorizontal() ? 'x' : 'y') {
  const swiper = this;
  const {
    params,
    rtlTranslate: rtl,
    translate,
    $wrapperEl
  } = swiper;

  if (params.virtualTranslate) {
    return rtl ? -translate : translate;
  }

  if (params.cssMode) {
    return translate;
  }

  let currentTranslate = utils_getTranslate($wrapperEl[0], axis);
  if (rtl) currentTranslate = -currentTranslate;
  return currentTranslate || 0;
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/translate/setTranslate.js
function setTranslate(translate, byController) {
  const swiper = this;
  const {
    rtlTranslate: rtl,
    params,
    $wrapperEl,
    wrapperEl,
    progress
  } = swiper;
  let x = 0;
  let y = 0;
  const z = 0;

  if (swiper.isHorizontal()) {
    x = rtl ? -translate : translate;
  } else {
    y = translate;
  }

  if (params.roundLengths) {
    x = Math.floor(x);
    y = Math.floor(y);
  }

  if (params.cssMode) {
    wrapperEl[swiper.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = swiper.isHorizontal() ? -x : -y;
  } else if (!params.virtualTranslate) {
    $wrapperEl.transform(`translate3d(${x}px, ${y}px, ${z}px)`);
  }

  swiper.previousTranslate = swiper.translate;
  swiper.translate = swiper.isHorizontal() ? x : y; // Check if we need to update progress

  let newProgress;
  const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();

  if (translatesDiff === 0) {
    newProgress = 0;
  } else {
    newProgress = (translate - swiper.minTranslate()) / translatesDiff;
  }

  if (newProgress !== progress) {
    swiper.updateProgress(translate);
  }

  swiper.emit('setTranslate', swiper.translate, byController);
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/translate/minTranslate.js
function minTranslate() {
  return -this.snapGrid[0];
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/translate/maxTranslate.js
function maxTranslate() {
  return -this.snapGrid[this.snapGrid.length - 1];
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/translate/translateTo.js

function translateTo(translate = 0, speed = this.params.speed, runCallbacks = true, translateBounds = true, internal) {
  const swiper = this;
  const {
    params,
    wrapperEl
  } = swiper;

  if (swiper.animating && params.preventInteractionOnTransition) {
    return false;
  }

  const minTranslate = swiper.minTranslate();
  const maxTranslate = swiper.maxTranslate();
  let newTranslate;
  if (translateBounds && translate > minTranslate) newTranslate = minTranslate;else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;else newTranslate = translate; // Update progress

  swiper.updateProgress(newTranslate);

  if (params.cssMode) {
    const isH = swiper.isHorizontal();

    if (speed === 0) {
      wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
    } else {
      if (!swiper.support.smoothScroll) {
        animateCSSModeScroll({
          swiper,
          targetPosition: -newTranslate,
          side: isH ? 'left' : 'top'
        });
        return true;
      }

      wrapperEl.scrollTo({
        [isH ? 'left' : 'top']: -newTranslate,
        behavior: 'smooth'
      });
    }

    return true;
  }

  if (speed === 0) {
    swiper.setTransition(0);
    swiper.setTranslate(newTranslate);

    if (runCallbacks) {
      swiper.emit('beforeTransitionStart', speed, internal);
      swiper.emit('transitionEnd');
    }
  } else {
    swiper.setTransition(speed);
    swiper.setTranslate(newTranslate);

    if (runCallbacks) {
      swiper.emit('beforeTransitionStart', speed, internal);
      swiper.emit('transitionStart');
    }

    if (!swiper.animating) {
      swiper.animating = true;

      if (!swiper.onTranslateToWrapperTransitionEnd) {
        swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
          if (!swiper || swiper.destroyed) return;
          if (e.target !== this) return;
          swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
          swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
          swiper.onTranslateToWrapperTransitionEnd = null;
          delete swiper.onTranslateToWrapperTransitionEnd;

          if (runCallbacks) {
            swiper.emit('transitionEnd');
          }
        };
      }

      swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
      swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
    }
  }

  return true;
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/translate/index.js





/* harmony default export */ var translate = ({
  getTranslate: getSwiperTranslate,
  setTranslate: setTranslate,
  minTranslate: minTranslate,
  maxTranslate: maxTranslate,
  translateTo: translateTo
});
;// CONCATENATED MODULE: ./node_modules/swiper/core/transition/setTransition.js
function setTransition(duration, byController) {
  const swiper = this;

  if (!swiper.params.cssMode) {
    swiper.$wrapperEl.transition(duration);
  }

  swiper.emit('setTransition', duration, byController);
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/transition/transitionEmit.js
function transitionEmit({
  swiper,
  runCallbacks,
  direction,
  step
}) {
  const {
    activeIndex,
    previousIndex
  } = swiper;
  let dir = direction;

  if (!dir) {
    if (activeIndex > previousIndex) dir = 'next';else if (activeIndex < previousIndex) dir = 'prev';else dir = 'reset';
  }

  swiper.emit(`transition${step}`);

  if (runCallbacks && activeIndex !== previousIndex) {
    if (dir === 'reset') {
      swiper.emit(`slideResetTransition${step}`);
      return;
    }

    swiper.emit(`slideChangeTransition${step}`);

    if (dir === 'next') {
      swiper.emit(`slideNextTransition${step}`);
    } else {
      swiper.emit(`slidePrevTransition${step}`);
    }
  }
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/transition/transitionStart.js

function transitionStart_transitionStart(runCallbacks = true, direction) {
  const swiper = this;
  const {
    params
  } = swiper;
  if (params.cssMode) return;

  if (params.autoHeight) {
    swiper.updateAutoHeight();
  }

  transitionEmit({
    swiper,
    runCallbacks,
    direction,
    step: 'Start'
  });
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/transition/transitionEnd.js

function transitionEnd_transitionEnd(runCallbacks = true, direction) {
  const swiper = this;
  const {
    params
  } = swiper;
  swiper.animating = false;
  if (params.cssMode) return;
  swiper.setTransition(0);
  transitionEmit({
    swiper,
    runCallbacks,
    direction,
    step: 'End'
  });
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/transition/index.js



/* harmony default export */ var core_transition = ({
  setTransition: setTransition,
  transitionStart: transitionStart_transitionStart,
  transitionEnd: transitionEnd_transitionEnd
});
;// CONCATENATED MODULE: ./node_modules/swiper/core/slide/slideTo.js

function slideTo(index = 0, speed = this.params.speed, runCallbacks = true, internal, initial) {
  if (typeof index !== 'number' && typeof index !== 'string') {
    throw new Error(`The 'index' argument cannot have type other than 'number' or 'string'. [${typeof index}] given.`);
  }

  if (typeof index === 'string') {
    /**
     * The `index` argument converted from `string` to `number`.
     * @type {number}
     */
    const indexAsNumber = parseInt(index, 10);
    /**
     * Determines whether the `index` argument is a valid `number`
     * after being converted from the `string` type.
     * @type {boolean}
     */

    const isValidNumber = isFinite(indexAsNumber);

    if (!isValidNumber) {
      throw new Error(`The passed-in 'index' (string) couldn't be converted to 'number'. [${index}] given.`);
    } // Knowing that the converted `index` is a valid number,
    // we can update the original argument's value.


    index = indexAsNumber;
  }

  const swiper = this;
  let slideIndex = index;
  if (slideIndex < 0) slideIndex = 0;
  const {
    params,
    snapGrid,
    slidesGrid,
    previousIndex,
    activeIndex,
    rtlTranslate: rtl,
    wrapperEl,
    enabled
  } = swiper;

  if (swiper.animating && params.preventInteractionOnTransition || !enabled && !internal && !initial) {
    return false;
  }

  const skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
  let snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
  if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
  const translate = -snapGrid[snapIndex]; // Normalize slideIndex

  if (params.normalizeSlideIndex) {
    for (let i = 0; i < slidesGrid.length; i += 1) {
      const normalizedTranslate = -Math.floor(translate * 100);
      const normalizedGrid = Math.floor(slidesGrid[i] * 100);
      const normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);

      if (typeof slidesGrid[i + 1] !== 'undefined') {
        if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGrid) / 2) {
          slideIndex = i;
        } else if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext) {
          slideIndex = i + 1;
        }
      } else if (normalizedTranslate >= normalizedGrid) {
        slideIndex = i;
      }
    }
  } // Directions locks


  if (swiper.initialized && slideIndex !== activeIndex) {
    if (!swiper.allowSlideNext && translate < swiper.translate && translate < swiper.minTranslate()) {
      return false;
    }

    if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
      if ((activeIndex || 0) !== slideIndex) return false;
    }
  }

  if (slideIndex !== (previousIndex || 0) && runCallbacks) {
    swiper.emit('beforeSlideChangeStart');
  } // Update progress


  swiper.updateProgress(translate);
  let direction;
  if (slideIndex > activeIndex) direction = 'next';else if (slideIndex < activeIndex) direction = 'prev';else direction = 'reset'; // Update Index

  if (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate) {
    swiper.updateActiveIndex(slideIndex); // Update Height

    if (params.autoHeight) {
      swiper.updateAutoHeight();
    }

    swiper.updateSlidesClasses();

    if (params.effect !== 'slide') {
      swiper.setTranslate(translate);
    }

    if (direction !== 'reset') {
      swiper.transitionStart(runCallbacks, direction);
      swiper.transitionEnd(runCallbacks, direction);
    }

    return false;
  }

  if (params.cssMode) {
    const isH = swiper.isHorizontal();
    const t = rtl ? translate : -translate;

    if (speed === 0) {
      const isVirtual = swiper.virtual && swiper.params.virtual.enabled;

      if (isVirtual) {
        swiper.wrapperEl.style.scrollSnapType = 'none';
        swiper._immediateVirtual = true;
      }

      wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;

      if (isVirtual) {
        requestAnimationFrame(() => {
          swiper.wrapperEl.style.scrollSnapType = '';
          swiper._swiperImmediateVirtual = false;
        });
      }
    } else {
      if (!swiper.support.smoothScroll) {
        animateCSSModeScroll({
          swiper,
          targetPosition: t,
          side: isH ? 'left' : 'top'
        });
        return true;
      }

      wrapperEl.scrollTo({
        [isH ? 'left' : 'top']: t,
        behavior: 'smooth'
      });
    }

    return true;
  }

  swiper.setTransition(speed);
  swiper.setTranslate(translate);
  swiper.updateActiveIndex(slideIndex);
  swiper.updateSlidesClasses();
  swiper.emit('beforeTransitionStart', speed, internal);
  swiper.transitionStart(runCallbacks, direction);

  if (speed === 0) {
    swiper.transitionEnd(runCallbacks, direction);
  } else if (!swiper.animating) {
    swiper.animating = true;

    if (!swiper.onSlideToWrapperTransitionEnd) {
      swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
        if (!swiper || swiper.destroyed) return;
        if (e.target !== this) return;
        swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
        swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
        swiper.onSlideToWrapperTransitionEnd = null;
        delete swiper.onSlideToWrapperTransitionEnd;
        swiper.transitionEnd(runCallbacks, direction);
      };
    }

    swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
    swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
  }

  return true;
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/slide/slideToLoop.js
function slideToLoop(index = 0, speed = this.params.speed, runCallbacks = true, internal) {
  if (typeof index === 'string') {
    /**
     * The `index` argument converted from `string` to `number`.
     * @type {number}
     */
    const indexAsNumber = parseInt(index, 10);
    /**
     * Determines whether the `index` argument is a valid `number`
     * after being converted from the `string` type.
     * @type {boolean}
     */

    const isValidNumber = isFinite(indexAsNumber);

    if (!isValidNumber) {
      throw new Error(`The passed-in 'index' (string) couldn't be converted to 'number'. [${index}] given.`);
    } // Knowing that the converted `index` is a valid number,
    // we can update the original argument's value.


    index = indexAsNumber;
  }

  const swiper = this;
  let newIndex = index;

  if (swiper.params.loop) {
    newIndex += swiper.loopedSlides;
  }

  return swiper.slideTo(newIndex, speed, runCallbacks, internal);
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/slide/slideNext.js
/* eslint no-unused-vars: "off" */
function slideNext(speed = this.params.speed, runCallbacks = true, internal) {
  const swiper = this;
  const {
    animating,
    enabled,
    params
  } = swiper;
  if (!enabled) return swiper;
  let perGroup = params.slidesPerGroup;

  if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
    perGroup = Math.max(swiper.slidesPerViewDynamic('current', true), 1);
  }

  const increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;

  if (params.loop) {
    if (animating && params.loopPreventsSlide) return false;
    swiper.loopFix(); // eslint-disable-next-line

    swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
  }

  if (params.rewind && swiper.isEnd) {
    return swiper.slideTo(0, speed, runCallbacks, internal);
  }

  return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/slide/slidePrev.js
/* eslint no-unused-vars: "off" */
function slidePrev(speed = this.params.speed, runCallbacks = true, internal) {
  const swiper = this;
  const {
    params,
    animating,
    snapGrid,
    slidesGrid,
    rtlTranslate,
    enabled
  } = swiper;
  if (!enabled) return swiper;

  if (params.loop) {
    if (animating && params.loopPreventsSlide) return false;
    swiper.loopFix(); // eslint-disable-next-line

    swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
  }

  const translate = rtlTranslate ? swiper.translate : -swiper.translate;

  function normalize(val) {
    if (val < 0) return -Math.floor(Math.abs(val));
    return Math.floor(val);
  }

  const normalizedTranslate = normalize(translate);
  const normalizedSnapGrid = snapGrid.map(val => normalize(val));
  let prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];

  if (typeof prevSnap === 'undefined' && params.cssMode) {
    let prevSnapIndex;
    snapGrid.forEach((snap, snapIndex) => {
      if (normalizedTranslate >= snap) {
        // prevSnap = snap;
        prevSnapIndex = snapIndex;
      }
    });

    if (typeof prevSnapIndex !== 'undefined') {
      prevSnap = snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex];
    }
  }

  let prevIndex = 0;

  if (typeof prevSnap !== 'undefined') {
    prevIndex = slidesGrid.indexOf(prevSnap);
    if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;

    if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
      prevIndex = prevIndex - swiper.slidesPerViewDynamic('previous', true) + 1;
      prevIndex = Math.max(prevIndex, 0);
    }
  }

  if (params.rewind && swiper.isBeginning) {
    const lastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
    return swiper.slideTo(lastIndex, speed, runCallbacks, internal);
  }

  return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/slide/slideReset.js
/* eslint no-unused-vars: "off" */
function slideReset(speed = this.params.speed, runCallbacks = true, internal) {
  const swiper = this;
  return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/slide/slideToClosest.js
/* eslint no-unused-vars: "off" */
function slideToClosest(speed = this.params.speed, runCallbacks = true, internal, threshold = 0.5) {
  const swiper = this;
  let index = swiper.activeIndex;
  const skip = Math.min(swiper.params.slidesPerGroupSkip, index);
  const snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
  const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;

  if (translate >= swiper.snapGrid[snapIndex]) {
    // The current translate is on or after the current snap index, so the choice
    // is between the current index and the one after it.
    const currentSnap = swiper.snapGrid[snapIndex];
    const nextSnap = swiper.snapGrid[snapIndex + 1];

    if (translate - currentSnap > (nextSnap - currentSnap) * threshold) {
      index += swiper.params.slidesPerGroup;
    }
  } else {
    // The current translate is before the current snap index, so the choice
    // is between the current index and the one before it.
    const prevSnap = swiper.snapGrid[snapIndex - 1];
    const currentSnap = swiper.snapGrid[snapIndex];

    if (translate - prevSnap <= (currentSnap - prevSnap) * threshold) {
      index -= swiper.params.slidesPerGroup;
    }
  }

  index = Math.max(index, 0);
  index = Math.min(index, swiper.slidesGrid.length - 1);
  return swiper.slideTo(index, speed, runCallbacks, internal);
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/slide/slideToClickedSlide.js


function slideToClickedSlide() {
  const swiper = this;
  const {
    params,
    $wrapperEl
  } = swiper;
  const slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
  let slideToIndex = swiper.clickedIndex;
  let realIndex;

  if (params.loop) {
    if (swiper.animating) return;
    realIndex = parseInt(dom(swiper.clickedSlide).attr('data-swiper-slide-index'), 10);

    if (params.centeredSlides) {
      if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
        swiper.loopFix();
        slideToIndex = $wrapperEl.children(`.${params.slideClass}[data-swiper-slide-index="${realIndex}"]:not(.${params.slideDuplicateClass})`).eq(0).index();
        utils_nextTick(() => {
          swiper.slideTo(slideToIndex);
        });
      } else {
        swiper.slideTo(slideToIndex);
      }
    } else if (slideToIndex > swiper.slides.length - slidesPerView) {
      swiper.loopFix();
      slideToIndex = $wrapperEl.children(`.${params.slideClass}[data-swiper-slide-index="${realIndex}"]:not(.${params.slideDuplicateClass})`).eq(0).index();
      utils_nextTick(() => {
        swiper.slideTo(slideToIndex);
      });
    } else {
      swiper.slideTo(slideToIndex);
    }
  } else {
    swiper.slideTo(slideToIndex);
  }
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/slide/index.js







/* harmony default export */ var slide = ({
  slideTo: slideTo,
  slideToLoop: slideToLoop,
  slideNext: slideNext,
  slidePrev: slidePrev,
  slideReset: slideReset,
  slideToClosest: slideToClosest,
  slideToClickedSlide: slideToClickedSlide
});
;// CONCATENATED MODULE: ./node_modules/swiper/core/loop/loopCreate.js


function loopCreate() {
  const swiper = this;
  const document = ssr_window_esm_getDocument();
  const {
    params,
    $wrapperEl
  } = swiper; // Remove duplicated slides

  const $selector = $wrapperEl.children().length > 0 ? dom($wrapperEl.children()[0].parentNode) : $wrapperEl;
  $selector.children(`.${params.slideClass}.${params.slideDuplicateClass}`).remove();
  let slides = $selector.children(`.${params.slideClass}`);

  if (params.loopFillGroupWithBlank) {
    const blankSlidesNum = params.slidesPerGroup - slides.length % params.slidesPerGroup;

    if (blankSlidesNum !== params.slidesPerGroup) {
      for (let i = 0; i < blankSlidesNum; i += 1) {
        const blankNode = dom(document.createElement('div')).addClass(`${params.slideClass} ${params.slideBlankClass}`);
        $selector.append(blankNode);
      }

      slides = $selector.children(`.${params.slideClass}`);
    }
  }

  if (params.slidesPerView === 'auto' && !params.loopedSlides) params.loopedSlides = slides.length;
  swiper.loopedSlides = Math.ceil(parseFloat(params.loopedSlides || params.slidesPerView, 10));
  swiper.loopedSlides += params.loopAdditionalSlides;

  if (swiper.loopedSlides > slides.length && swiper.params.loopedSlidesLimit) {
    swiper.loopedSlides = slides.length;
  }

  const prependSlides = [];
  const appendSlides = [];
  slides.each((el, index) => {
    const slide = dom(el);
    slide.attr('data-swiper-slide-index', index);
  });

  for (let i = 0; i < swiper.loopedSlides; i += 1) {
    const index = i - Math.floor(i / slides.length) * slides.length;
    appendSlides.push(slides.eq(index)[0]);
    prependSlides.unshift(slides.eq(slides.length - index - 1)[0]);
  }

  for (let i = 0; i < appendSlides.length; i += 1) {
    $selector.append(dom(appendSlides[i].cloneNode(true)).addClass(params.slideDuplicateClass));
  }

  for (let i = prependSlides.length - 1; i >= 0; i -= 1) {
    $selector.prepend(dom(prependSlides[i].cloneNode(true)).addClass(params.slideDuplicateClass));
  }
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/loop/loopFix.js
function loopFix() {
  const swiper = this;
  swiper.emit('beforeLoopFix');
  const {
    activeIndex,
    slides,
    loopedSlides,
    allowSlidePrev,
    allowSlideNext,
    snapGrid,
    rtlTranslate: rtl
  } = swiper;
  let newIndex;
  swiper.allowSlidePrev = true;
  swiper.allowSlideNext = true;
  const snapTranslate = -snapGrid[activeIndex];
  const diff = snapTranslate - swiper.getTranslate(); // Fix For Negative Oversliding

  if (activeIndex < loopedSlides) {
    newIndex = slides.length - loopedSlides * 3 + activeIndex;
    newIndex += loopedSlides;
    const slideChanged = swiper.slideTo(newIndex, 0, false, true);

    if (slideChanged && diff !== 0) {
      swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    }
  } else if (activeIndex >= slides.length - loopedSlides) {
    // Fix For Positive Oversliding
    newIndex = -slides.length + activeIndex + loopedSlides;
    newIndex += loopedSlides;
    const slideChanged = swiper.slideTo(newIndex, 0, false, true);

    if (slideChanged && diff !== 0) {
      swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    }
  }

  swiper.allowSlidePrev = allowSlidePrev;
  swiper.allowSlideNext = allowSlideNext;
  swiper.emit('loopFix');
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/loop/loopDestroy.js
function loopDestroy() {
  const swiper = this;
  const {
    $wrapperEl,
    params,
    slides
  } = swiper;
  $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass},.${params.slideClass}.${params.slideBlankClass}`).remove();
  slides.removeAttr('data-swiper-slide-index');
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/loop/index.js



/* harmony default export */ var loop = ({
  loopCreate: loopCreate,
  loopFix: loopFix,
  loopDestroy: loopDestroy
});
;// CONCATENATED MODULE: ./node_modules/swiper/core/grab-cursor/setGrabCursor.js
function setGrabCursor(moving) {
  const swiper = this;
  if (swiper.support.touch || !swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
  const el = swiper.params.touchEventsTarget === 'container' ? swiper.el : swiper.wrapperEl;
  el.style.cursor = 'move';
  el.style.cursor = moving ? 'grabbing' : 'grab';
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/grab-cursor/unsetGrabCursor.js
function unsetGrabCursor() {
  const swiper = this;

  if (swiper.support.touch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) {
    return;
  }

  swiper[swiper.params.touchEventsTarget === 'container' ? 'el' : 'wrapperEl'].style.cursor = '';
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/grab-cursor/index.js


/* harmony default export */ var grab_cursor = ({
  setGrabCursor: setGrabCursor,
  unsetGrabCursor: unsetGrabCursor
});
;// CONCATENATED MODULE: ./node_modules/swiper/core/events/onTouchStart.js


 // Modified from https://stackoverflow.com/questions/54520554/custom-element-getrootnode-closest-function-crossing-multiple-parent-shadowd

function closestElement(selector, base = this) {
  function __closestFrom(el) {
    if (!el || el === ssr_window_esm_getDocument() || el === ssr_window_esm_getWindow()) return null;
    if (el.assignedSlot) el = el.assignedSlot;
    const found = el.closest(selector);

    if (!found && !el.getRootNode) {
      return null;
    }

    return found || __closestFrom(el.getRootNode().host);
  }

  return __closestFrom(base);
}

function onTouchStart(event) {
  const swiper = this;
  const document = ssr_window_esm_getDocument();
  const window = ssr_window_esm_getWindow();
  const data = swiper.touchEventsData;
  const {
    params,
    touches,
    enabled
  } = swiper;
  if (!enabled) return;

  if (swiper.animating && params.preventInteractionOnTransition) {
    return;
  }

  if (!swiper.animating && params.cssMode && params.loop) {
    swiper.loopFix();
  }

  let e = event;
  if (e.originalEvent) e = e.originalEvent;
  let $targetEl = dom(e.target);

  if (params.touchEventsTarget === 'wrapper') {
    if (!$targetEl.closest(swiper.wrapperEl).length) return;
  }

  data.isTouchEvent = e.type === 'touchstart';
  if (!data.isTouchEvent && 'which' in e && e.which === 3) return;
  if (!data.isTouchEvent && 'button' in e && e.button > 0) return;
  if (data.isTouched && data.isMoved) return; // change target el for shadow root component

  const swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== ''; // eslint-disable-next-line

  const eventPath = event.composedPath ? event.composedPath() : event.path;

  if (swipingClassHasValue && e.target && e.target.shadowRoot && eventPath) {
    $targetEl = dom(eventPath[0]);
  }

  const noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : `.${params.noSwipingClass}`;
  const isTargetShadow = !!(e.target && e.target.shadowRoot); // use closestElement for shadow root element to get the actual closest for nested shadow root element

  if (params.noSwiping && (isTargetShadow ? closestElement(noSwipingSelector, $targetEl[0]) : $targetEl.closest(noSwipingSelector)[0])) {
    swiper.allowClick = true;
    return;
  }

  if (params.swipeHandler) {
    if (!$targetEl.closest(params.swipeHandler)[0]) return;
  }

  touches.currentX = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
  touches.currentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
  const startX = touches.currentX;
  const startY = touches.currentY; // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore

  const edgeSwipeDetection = params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
  const edgeSwipeThreshold = params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;

  if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window.innerWidth - edgeSwipeThreshold)) {
    if (edgeSwipeDetection === 'prevent') {
      event.preventDefault();
    } else {
      return;
    }
  }

  Object.assign(data, {
    isTouched: true,
    isMoved: false,
    allowTouchCallbacks: true,
    isScrolling: undefined,
    startMoving: undefined
  });
  touches.startX = startX;
  touches.startY = startY;
  data.touchStartTime = utils_now();
  swiper.allowClick = true;
  swiper.updateSize();
  swiper.swipeDirection = undefined;
  if (params.threshold > 0) data.allowThresholdMove = false;

  if (e.type !== 'touchstart') {
    let preventDefault = true;

    if ($targetEl.is(data.focusableElements)) {
      preventDefault = false;

      if ($targetEl[0].nodeName === 'SELECT') {
        data.isTouched = false;
      }
    }

    if (document.activeElement && dom(document.activeElement).is(data.focusableElements) && document.activeElement !== $targetEl[0]) {
      document.activeElement.blur();
    }

    const shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;

    if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !$targetEl[0].isContentEditable) {
      e.preventDefault();
    }
  }

  if (swiper.params.freeMode && swiper.params.freeMode.enabled && swiper.freeMode && swiper.animating && !params.cssMode) {
    swiper.freeMode.onTouchStart();
  }

  swiper.emit('touchStart', e);
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/events/onTouchMove.js



function onTouchMove(event) {
  const document = ssr_window_esm_getDocument();
  const swiper = this;
  const data = swiper.touchEventsData;
  const {
    params,
    touches,
    rtlTranslate: rtl,
    enabled
  } = swiper;
  if (!enabled) return;
  let e = event;
  if (e.originalEvent) e = e.originalEvent;

  if (!data.isTouched) {
    if (data.startMoving && data.isScrolling) {
      swiper.emit('touchMoveOpposite', e);
    }

    return;
  }

  if (data.isTouchEvent && e.type !== 'touchmove') return;
  const targetTouch = e.type === 'touchmove' && e.targetTouches && (e.targetTouches[0] || e.changedTouches[0]);
  const pageX = e.type === 'touchmove' ? targetTouch.pageX : e.pageX;
  const pageY = e.type === 'touchmove' ? targetTouch.pageY : e.pageY;

  if (e.preventedByNestedSwiper) {
    touches.startX = pageX;
    touches.startY = pageY;
    return;
  }

  if (!swiper.allowTouchMove) {
    if (!dom(e.target).is(data.focusableElements)) {
      swiper.allowClick = false;
    }

    if (data.isTouched) {
      Object.assign(touches, {
        startX: pageX,
        startY: pageY,
        currentX: pageX,
        currentY: pageY
      });
      data.touchStartTime = utils_now();
    }

    return;
  }

  if (data.isTouchEvent && params.touchReleaseOnEdges && !params.loop) {
    if (swiper.isVertical()) {
      // Vertical
      if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
        data.isTouched = false;
        data.isMoved = false;
        return;
      }
    } else if (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate()) {
      return;
    }
  }

  if (data.isTouchEvent && document.activeElement) {
    if (e.target === document.activeElement && dom(e.target).is(data.focusableElements)) {
      data.isMoved = true;
      swiper.allowClick = false;
      return;
    }
  }

  if (data.allowTouchCallbacks) {
    swiper.emit('touchMove', e);
  }

  if (e.targetTouches && e.targetTouches.length > 1) return;
  touches.currentX = pageX;
  touches.currentY = pageY;
  const diffX = touches.currentX - touches.startX;
  const diffY = touches.currentY - touches.startY;
  if (swiper.params.threshold && Math.sqrt(diffX ** 2 + diffY ** 2) < swiper.params.threshold) return;

  if (typeof data.isScrolling === 'undefined') {
    let touchAngle;

    if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) {
      data.isScrolling = false;
    } else {
      // eslint-disable-next-line
      if (diffX * diffX + diffY * diffY >= 25) {
        touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
        data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
      }
    }
  }

  if (data.isScrolling) {
    swiper.emit('touchMoveOpposite', e);
  }

  if (typeof data.startMoving === 'undefined') {
    if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) {
      data.startMoving = true;
    }
  }

  if (data.isScrolling) {
    data.isTouched = false;
    return;
  }

  if (!data.startMoving) {
    return;
  }

  swiper.allowClick = false;

  if (!params.cssMode && e.cancelable) {
    e.preventDefault();
  }

  if (params.touchMoveStopPropagation && !params.nested) {
    e.stopPropagation();
  }

  if (!data.isMoved) {
    if (params.loop && !params.cssMode) {
      swiper.loopFix();
    }

    data.startTranslate = swiper.getTranslate();
    swiper.setTransition(0);

    if (swiper.animating) {
      swiper.$wrapperEl.trigger('webkitTransitionEnd transitionend');
    }

    data.allowMomentumBounce = false; // Grab Cursor

    if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
      swiper.setGrabCursor(true);
    }

    swiper.emit('sliderFirstMove', e);
  }

  swiper.emit('sliderMove', e);
  data.isMoved = true;
  let diff = swiper.isHorizontal() ? diffX : diffY;
  touches.diff = diff;
  diff *= params.touchRatio;
  if (rtl) diff = -diff;
  swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
  data.currentTranslate = diff + data.startTranslate;
  let disableParentSwiper = true;
  let resistanceRatio = params.resistanceRatio;

  if (params.touchReleaseOnEdges) {
    resistanceRatio = 0;
  }

  if (diff > 0 && data.currentTranslate > swiper.minTranslate()) {
    disableParentSwiper = false;
    if (params.resistance) data.currentTranslate = swiper.minTranslate() - 1 + (-swiper.minTranslate() + data.startTranslate + diff) ** resistanceRatio;
  } else if (diff < 0 && data.currentTranslate < swiper.maxTranslate()) {
    disableParentSwiper = false;
    if (params.resistance) data.currentTranslate = swiper.maxTranslate() + 1 - (swiper.maxTranslate() - data.startTranslate - diff) ** resistanceRatio;
  }

  if (disableParentSwiper) {
    e.preventedByNestedSwiper = true;
  } // Directions locks


  if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) {
    data.currentTranslate = data.startTranslate;
  }

  if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) {
    data.currentTranslate = data.startTranslate;
  }

  if (!swiper.allowSlidePrev && !swiper.allowSlideNext) {
    data.currentTranslate = data.startTranslate;
  } // Threshold


  if (params.threshold > 0) {
    if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
      if (!data.allowThresholdMove) {
        data.allowThresholdMove = true;
        touches.startX = touches.currentX;
        touches.startY = touches.currentY;
        data.currentTranslate = data.startTranslate;
        touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
        return;
      }
    } else {
      data.currentTranslate = data.startTranslate;
      return;
    }
  }

  if (!params.followFinger || params.cssMode) return; // Update active index in free mode

  if (params.freeMode && params.freeMode.enabled && swiper.freeMode || params.watchSlidesProgress) {
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  }

  if (swiper.params.freeMode && params.freeMode.enabled && swiper.freeMode) {
    swiper.freeMode.onTouchMove();
  } // Update progress


  swiper.updateProgress(data.currentTranslate); // Update translate

  swiper.setTranslate(data.currentTranslate);
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/events/onTouchEnd.js

function onTouchEnd(event) {
  const swiper = this;
  const data = swiper.touchEventsData;
  const {
    params,
    touches,
    rtlTranslate: rtl,
    slidesGrid,
    enabled
  } = swiper;
  if (!enabled) return;
  let e = event;
  if (e.originalEvent) e = e.originalEvent;

  if (data.allowTouchCallbacks) {
    swiper.emit('touchEnd', e);
  }

  data.allowTouchCallbacks = false;

  if (!data.isTouched) {
    if (data.isMoved && params.grabCursor) {
      swiper.setGrabCursor(false);
    }

    data.isMoved = false;
    data.startMoving = false;
    return;
  } // Return Grab Cursor


  if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
    swiper.setGrabCursor(false);
  } // Time diff


  const touchEndTime = utils_now();
  const timeDiff = touchEndTime - data.touchStartTime; // Tap, doubleTap, Click

  if (swiper.allowClick) {
    const pathTree = e.path || e.composedPath && e.composedPath();
    swiper.updateClickedSlide(pathTree && pathTree[0] || e.target);
    swiper.emit('tap click', e);

    if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) {
      swiper.emit('doubleTap doubleClick', e);
    }
  }

  data.lastClickTime = utils_now();
  utils_nextTick(() => {
    if (!swiper.destroyed) swiper.allowClick = true;
  });

  if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 || data.currentTranslate === data.startTranslate) {
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    return;
  }

  data.isTouched = false;
  data.isMoved = false;
  data.startMoving = false;
  let currentPos;

  if (params.followFinger) {
    currentPos = rtl ? swiper.translate : -swiper.translate;
  } else {
    currentPos = -data.currentTranslate;
  }

  if (params.cssMode) {
    return;
  }

  if (swiper.params.freeMode && params.freeMode.enabled) {
    swiper.freeMode.onTouchEnd({
      currentPos
    });
    return;
  } // Find current slide


  let stopIndex = 0;
  let groupSize = swiper.slidesSizesGrid[0];

  for (let i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup) {
    const increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;

    if (typeof slidesGrid[i + increment] !== 'undefined') {
      if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + increment]) {
        stopIndex = i;
        groupSize = slidesGrid[i + increment] - slidesGrid[i];
      }
    } else if (currentPos >= slidesGrid[i]) {
      stopIndex = i;
      groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
    }
  }

  let rewindFirstIndex = null;
  let rewindLastIndex = null;

  if (params.rewind) {
    if (swiper.isBeginning) {
      rewindLastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
    } else if (swiper.isEnd) {
      rewindFirstIndex = 0;
    }
  } // Find current slide size


  const ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
  const increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;

  if (timeDiff > params.longSwipesMs) {
    // Long touches
    if (!params.longSwipes) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }

    if (swiper.swipeDirection === 'next') {
      if (ratio >= params.longSwipesRatio) swiper.slideTo(params.rewind && swiper.isEnd ? rewindFirstIndex : stopIndex + increment);else swiper.slideTo(stopIndex);
    }

    if (swiper.swipeDirection === 'prev') {
      if (ratio > 1 - params.longSwipesRatio) {
        swiper.slideTo(stopIndex + increment);
      } else if (rewindLastIndex !== null && ratio < 0 && Math.abs(ratio) > params.longSwipesRatio) {
        swiper.slideTo(rewindLastIndex);
      } else {
        swiper.slideTo(stopIndex);
      }
    }
  } else {
    // Short swipes
    if (!params.shortSwipes) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }

    const isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);

    if (!isNavButtonTarget) {
      if (swiper.swipeDirection === 'next') {
        swiper.slideTo(rewindFirstIndex !== null ? rewindFirstIndex : stopIndex + increment);
      }

      if (swiper.swipeDirection === 'prev') {
        swiper.slideTo(rewindLastIndex !== null ? rewindLastIndex : stopIndex);
      }
    } else if (e.target === swiper.navigation.nextEl) {
      swiper.slideTo(stopIndex + increment);
    } else {
      swiper.slideTo(stopIndex);
    }
  }
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/events/onResize.js
function onResize() {
  const swiper = this;
  const {
    params,
    el
  } = swiper;
  if (el && el.offsetWidth === 0) return; // Breakpoints

  if (params.breakpoints) {
    swiper.setBreakpoint();
  } // Save locks


  const {
    allowSlideNext,
    allowSlidePrev,
    snapGrid
  } = swiper; // Disable locks on resize

  swiper.allowSlideNext = true;
  swiper.allowSlidePrev = true;
  swiper.updateSize();
  swiper.updateSlides();
  swiper.updateSlidesClasses();

  if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides) {
    swiper.slideTo(swiper.slides.length - 1, 0, false, true);
  } else {
    swiper.slideTo(swiper.activeIndex, 0, false, true);
  }

  if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
    swiper.autoplay.run();
  } // Return locks after resize


  swiper.allowSlidePrev = allowSlidePrev;
  swiper.allowSlideNext = allowSlideNext;

  if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) {
    swiper.checkOverflow();
  }
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/events/onClick.js
function onClick(e) {
  const swiper = this;
  if (!swiper.enabled) return;

  if (!swiper.allowClick) {
    if (swiper.params.preventClicks) e.preventDefault();

    if (swiper.params.preventClicksPropagation && swiper.animating) {
      e.stopPropagation();
      e.stopImmediatePropagation();
    }
  }
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/events/onScroll.js
function onScroll() {
  const swiper = this;
  const {
    wrapperEl,
    rtlTranslate,
    enabled
  } = swiper;
  if (!enabled) return;
  swiper.previousTranslate = swiper.translate;

  if (swiper.isHorizontal()) {
    swiper.translate = -wrapperEl.scrollLeft;
  } else {
    swiper.translate = -wrapperEl.scrollTop;
  } // eslint-disable-next-line


  if (swiper.translate === 0) swiper.translate = 0;
  swiper.updateActiveIndex();
  swiper.updateSlidesClasses();
  let newProgress;
  const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();

  if (translatesDiff === 0) {
    newProgress = 0;
  } else {
    newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
  }

  if (newProgress !== swiper.progress) {
    swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
  }

  swiper.emit('setTranslate', swiper.translate, false);
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/events/index.js







let dummyEventAttached = false;

function dummyEventListener() {}

const events = (swiper, method) => {
  const document = ssr_window_esm_getDocument();
  const {
    params,
    touchEvents,
    el,
    wrapperEl,
    device,
    support
  } = swiper;
  const capture = !!params.nested;
  const domMethod = method === 'on' ? 'addEventListener' : 'removeEventListener';
  const swiperMethod = method; // Touch Events

  if (!support.touch) {
    el[domMethod](touchEvents.start, swiper.onTouchStart, false);
    document[domMethod](touchEvents.move, swiper.onTouchMove, capture);
    document[domMethod](touchEvents.end, swiper.onTouchEnd, false);
  } else {
    const passiveListener = touchEvents.start === 'touchstart' && support.passiveListener && params.passiveListeners ? {
      passive: true,
      capture: false
    } : false;
    el[domMethod](touchEvents.start, swiper.onTouchStart, passiveListener);
    el[domMethod](touchEvents.move, swiper.onTouchMove, support.passiveListener ? {
      passive: false,
      capture
    } : capture);
    el[domMethod](touchEvents.end, swiper.onTouchEnd, passiveListener);

    if (touchEvents.cancel) {
      el[domMethod](touchEvents.cancel, swiper.onTouchEnd, passiveListener);
    }
  } // Prevent Links Clicks


  if (params.preventClicks || params.preventClicksPropagation) {
    el[domMethod]('click', swiper.onClick, true);
  }

  if (params.cssMode) {
    wrapperEl[domMethod]('scroll', swiper.onScroll);
  } // Resize handler


  if (params.updateOnWindowResize) {
    swiper[swiperMethod](device.ios || device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', onResize, true);
  } else {
    swiper[swiperMethod]('observerUpdate', onResize, true);
  }
};

function attachEvents() {
  const swiper = this;
  const document = ssr_window_esm_getDocument();
  const {
    params,
    support
  } = swiper;
  swiper.onTouchStart = onTouchStart.bind(swiper);
  swiper.onTouchMove = onTouchMove.bind(swiper);
  swiper.onTouchEnd = onTouchEnd.bind(swiper);

  if (params.cssMode) {
    swiper.onScroll = onScroll.bind(swiper);
  }

  swiper.onClick = onClick.bind(swiper);

  if (support.touch && !dummyEventAttached) {
    document.addEventListener('touchstart', dummyEventListener);
    dummyEventAttached = true;
  }

  events(swiper, 'on');
}

function detachEvents() {
  const swiper = this;
  events(swiper, 'off');
}

/* harmony default export */ var core_events = ({
  attachEvents,
  detachEvents
});
;// CONCATENATED MODULE: ./node_modules/swiper/core/breakpoints/setBreakpoint.js


const isGridEnabled = (swiper, params) => {
  return swiper.grid && params.grid && params.grid.rows > 1;
};

function setBreakpoint() {
  const swiper = this;
  const {
    activeIndex,
    initialized,
    loopedSlides = 0,
    params,
    $el
  } = swiper;
  const breakpoints = params.breakpoints;
  if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return; // Get breakpoint for window width and update parameters

  const breakpoint = swiper.getBreakpoint(breakpoints, swiper.params.breakpointsBase, swiper.el);
  if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
  const breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
  const breakpointParams = breakpointOnlyParams || swiper.originalParams;
  const wasMultiRow = isGridEnabled(swiper, params);
  const isMultiRow = isGridEnabled(swiper, breakpointParams);
  const wasEnabled = params.enabled;

  if (wasMultiRow && !isMultiRow) {
    $el.removeClass(`${params.containerModifierClass}grid ${params.containerModifierClass}grid-column`);
    swiper.emitContainerClasses();
  } else if (!wasMultiRow && isMultiRow) {
    $el.addClass(`${params.containerModifierClass}grid`);

    if (breakpointParams.grid.fill && breakpointParams.grid.fill === 'column' || !breakpointParams.grid.fill && params.grid.fill === 'column') {
      $el.addClass(`${params.containerModifierClass}grid-column`);
    }

    swiper.emitContainerClasses();
  } // Toggle navigation, pagination, scrollbar


  ['navigation', 'pagination', 'scrollbar'].forEach(prop => {
    const wasModuleEnabled = params[prop] && params[prop].enabled;
    const isModuleEnabled = breakpointParams[prop] && breakpointParams[prop].enabled;

    if (wasModuleEnabled && !isModuleEnabled) {
      swiper[prop].disable();
    }

    if (!wasModuleEnabled && isModuleEnabled) {
      swiper[prop].enable();
    }
  });
  const directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
  const needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);

  if (directionChanged && initialized) {
    swiper.changeDirection();
  }

  utils_extend(swiper.params, breakpointParams);
  const isEnabled = swiper.params.enabled;
  Object.assign(swiper, {
    allowTouchMove: swiper.params.allowTouchMove,
    allowSlideNext: swiper.params.allowSlideNext,
    allowSlidePrev: swiper.params.allowSlidePrev
  });

  if (wasEnabled && !isEnabled) {
    swiper.disable();
  } else if (!wasEnabled && isEnabled) {
    swiper.enable();
  }

  swiper.currentBreakpoint = breakpoint;
  swiper.emit('_beforeBreakpoint', breakpointParams);

  if (needsReLoop && initialized) {
    swiper.loopDestroy();
    swiper.loopCreate();
    swiper.updateSlides();
    swiper.slideTo(activeIndex - loopedSlides + swiper.loopedSlides, 0, false);
  }

  swiper.emit('breakpoint', breakpointParams);
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/breakpoints/getBreakpoint.js

function getBreakpoint(breakpoints, base = 'window', containerEl) {
  if (!breakpoints || base === 'container' && !containerEl) return undefined;
  let breakpoint = false;
  const window = ssr_window_esm_getWindow();
  const currentHeight = base === 'window' ? window.innerHeight : containerEl.clientHeight;
  const points = Object.keys(breakpoints).map(point => {
    if (typeof point === 'string' && point.indexOf('@') === 0) {
      const minRatio = parseFloat(point.substr(1));
      const value = currentHeight * minRatio;
      return {
        value,
        point
      };
    }

    return {
      value: point,
      point
    };
  });
  points.sort((a, b) => parseInt(a.value, 10) - parseInt(b.value, 10));

  for (let i = 0; i < points.length; i += 1) {
    const {
      point,
      value
    } = points[i];

    if (base === 'window') {
      if (window.matchMedia(`(min-width: ${value}px)`).matches) {
        breakpoint = point;
      }
    } else if (value <= containerEl.clientWidth) {
      breakpoint = point;
    }
  }

  return breakpoint || 'max';
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/breakpoints/index.js


/* harmony default export */ var breakpoints = ({
  setBreakpoint: setBreakpoint,
  getBreakpoint: getBreakpoint
});
;// CONCATENATED MODULE: ./node_modules/swiper/core/classes/addClasses.js
function prepareClasses(entries, prefix) {
  const resultClasses = [];
  entries.forEach(item => {
    if (typeof item === 'object') {
      Object.keys(item).forEach(classNames => {
        if (item[classNames]) {
          resultClasses.push(prefix + classNames);
        }
      });
    } else if (typeof item === 'string') {
      resultClasses.push(prefix + item);
    }
  });
  return resultClasses;
}

function addClasses() {
  const swiper = this;
  const {
    classNames,
    params,
    rtl,
    $el,
    device,
    support
  } = swiper; // prettier-ignore

  const suffixes = prepareClasses(['initialized', params.direction, {
    'pointer-events': !support.touch
  }, {
    'free-mode': swiper.params.freeMode && params.freeMode.enabled
  }, {
    'autoheight': params.autoHeight
  }, {
    'rtl': rtl
  }, {
    'grid': params.grid && params.grid.rows > 1
  }, {
    'grid-column': params.grid && params.grid.rows > 1 && params.grid.fill === 'column'
  }, {
    'android': device.android
  }, {
    'ios': device.ios
  }, {
    'css-mode': params.cssMode
  }, {
    'centered': params.cssMode && params.centeredSlides
  }, {
    'watch-progress': params.watchSlidesProgress
  }], params.containerModifierClass);
  classNames.push(...suffixes);
  $el.addClass([...classNames].join(' '));
  swiper.emitContainerClasses();
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/classes/removeClasses.js
function removeClasses() {
  const swiper = this;
  const {
    $el,
    classNames
  } = swiper;
  $el.removeClass(classNames.join(' '));
  swiper.emitContainerClasses();
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/classes/index.js


/* harmony default export */ var classes = ({
  addClasses: addClasses,
  removeClasses: removeClasses
});
;// CONCATENATED MODULE: ./node_modules/swiper/core/images/loadImage.js


function loadImage(imageEl, src, srcset, sizes, checkForComplete, callback) {
  const window = ssr_window_esm_getWindow();
  let image;

  function onReady() {
    if (callback) callback();
  }

  const isPicture = dom(imageEl).parent('picture')[0];

  if (!isPicture && (!imageEl.complete || !checkForComplete)) {
    if (src) {
      image = new window.Image();
      image.onload = onReady;
      image.onerror = onReady;

      if (sizes) {
        image.sizes = sizes;
      }

      if (srcset) {
        image.srcset = srcset;
      }

      if (src) {
        image.src = src;
      }
    } else {
      onReady();
    }
  } else {
    // image already loaded...
    onReady();
  }
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/images/preloadImages.js
function preloadImages() {
  const swiper = this;
  swiper.imagesToLoad = swiper.$el.find('img');

  function onReady() {
    if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper.destroyed) return;
    if (swiper.imagesLoaded !== undefined) swiper.imagesLoaded += 1;

    if (swiper.imagesLoaded === swiper.imagesToLoad.length) {
      if (swiper.params.updateOnImagesReady) swiper.update();
      swiper.emit('imagesReady');
    }
  }

  for (let i = 0; i < swiper.imagesToLoad.length; i += 1) {
    const imageEl = swiper.imagesToLoad[i];
    swiper.loadImage(imageEl, imageEl.currentSrc || imageEl.getAttribute('src'), imageEl.srcset || imageEl.getAttribute('srcset'), imageEl.sizes || imageEl.getAttribute('sizes'), true, onReady);
  }
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/images/index.js


/* harmony default export */ var core_images = ({
  loadImage: loadImage,
  preloadImages: preloadImages
});
;// CONCATENATED MODULE: ./node_modules/swiper/core/check-overflow/index.js
function checkOverflow() {
  const swiper = this;
  const {
    isLocked: wasLocked,
    params
  } = swiper;
  const {
    slidesOffsetBefore
  } = params;

  if (slidesOffsetBefore) {
    const lastSlideIndex = swiper.slides.length - 1;
    const lastSlideRightEdge = swiper.slidesGrid[lastSlideIndex] + swiper.slidesSizesGrid[lastSlideIndex] + slidesOffsetBefore * 2;
    swiper.isLocked = swiper.size > lastSlideRightEdge;
  } else {
    swiper.isLocked = swiper.snapGrid.length === 1;
  }

  if (params.allowSlideNext === true) {
    swiper.allowSlideNext = !swiper.isLocked;
  }

  if (params.allowSlidePrev === true) {
    swiper.allowSlidePrev = !swiper.isLocked;
  }

  if (wasLocked && wasLocked !== swiper.isLocked) {
    swiper.isEnd = false;
  }

  if (wasLocked !== swiper.isLocked) {
    swiper.emit(swiper.isLocked ? 'lock' : 'unlock');
  }
}

/* harmony default export */ var check_overflow = ({
  checkOverflow
});
;// CONCATENATED MODULE: ./node_modules/swiper/core/defaults.js
/* harmony default export */ var defaults = ({
  init: true,
  direction: 'horizontal',
  touchEventsTarget: 'wrapper',
  initialSlide: 0,
  speed: 300,
  cssMode: false,
  updateOnWindowResize: true,
  resizeObserver: true,
  nested: false,
  createElements: false,
  enabled: true,
  focusableElements: 'input, select, option, textarea, button, video, label',
  // Overrides
  width: null,
  height: null,
  //
  preventInteractionOnTransition: false,
  // ssr
  userAgent: null,
  url: null,
  // To support iOS's swipe-to-go-back gesture (when being used in-app).
  edgeSwipeDetection: false,
  edgeSwipeThreshold: 20,
  // Autoheight
  autoHeight: false,
  // Set wrapper width
  setWrapperSize: false,
  // Virtual Translate
  virtualTranslate: false,
  // Effects
  effect: 'slide',
  // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
  // Breakpoints
  breakpoints: undefined,
  breakpointsBase: 'window',
  // Slides grid
  spaceBetween: 0,
  slidesPerView: 1,
  slidesPerGroup: 1,
  slidesPerGroupSkip: 0,
  slidesPerGroupAuto: false,
  centeredSlides: false,
  centeredSlidesBounds: false,
  slidesOffsetBefore: 0,
  // in px
  slidesOffsetAfter: 0,
  // in px
  normalizeSlideIndex: true,
  centerInsufficientSlides: false,
  // Disable swiper and hide navigation when container not overflow
  watchOverflow: true,
  // Round length
  roundLengths: false,
  // Touches
  touchRatio: 1,
  touchAngle: 45,
  simulateTouch: true,
  shortSwipes: true,
  longSwipes: true,
  longSwipesRatio: 0.5,
  longSwipesMs: 300,
  followFinger: true,
  allowTouchMove: true,
  threshold: 0,
  touchMoveStopPropagation: false,
  touchStartPreventDefault: true,
  touchStartForcePreventDefault: false,
  touchReleaseOnEdges: false,
  // Unique Navigation Elements
  uniqueNavElements: true,
  // Resistance
  resistance: true,
  resistanceRatio: 0.85,
  // Progress
  watchSlidesProgress: false,
  // Cursor
  grabCursor: false,
  // Clicks
  preventClicks: true,
  preventClicksPropagation: true,
  slideToClickedSlide: false,
  // Images
  preloadImages: true,
  updateOnImagesReady: true,
  // loop
  loop: false,
  loopAdditionalSlides: 0,
  loopedSlides: null,
  loopedSlidesLimit: true,
  loopFillGroupWithBlank: false,
  loopPreventsSlide: true,
  // rewind
  rewind: false,
  // Swiping/no swiping
  allowSlidePrev: true,
  allowSlideNext: true,
  swipeHandler: null,
  // '.swipe-handler',
  noSwiping: true,
  noSwipingClass: 'swiper-no-swiping',
  noSwipingSelector: null,
  // Passive Listeners
  passiveListeners: true,
  maxBackfaceHiddenSlides: 10,
  // NS
  containerModifierClass: 'swiper-',
  // NEW
  slideClass: 'swiper-slide',
  slideBlankClass: 'swiper-slide-invisible-blank',
  slideActiveClass: 'swiper-slide-active',
  slideDuplicateActiveClass: 'swiper-slide-duplicate-active',
  slideVisibleClass: 'swiper-slide-visible',
  slideDuplicateClass: 'swiper-slide-duplicate',
  slideNextClass: 'swiper-slide-next',
  slideDuplicateNextClass: 'swiper-slide-duplicate-next',
  slidePrevClass: 'swiper-slide-prev',
  slideDuplicatePrevClass: 'swiper-slide-duplicate-prev',
  wrapperClass: 'swiper-wrapper',
  // Callbacks
  runCallbacksOnInit: true,
  // Internals
  _emitClasses: false
});
;// CONCATENATED MODULE: ./node_modules/swiper/core/moduleExtendParams.js

function moduleExtendParams(params, allModulesParams) {
  return function extendParams(obj = {}) {
    const moduleParamName = Object.keys(obj)[0];
    const moduleParams = obj[moduleParamName];

    if (typeof moduleParams !== 'object' || moduleParams === null) {
      utils_extend(allModulesParams, obj);
      return;
    }

    if (['navigation', 'pagination', 'scrollbar'].indexOf(moduleParamName) >= 0 && params[moduleParamName] === true) {
      params[moduleParamName] = {
        auto: true
      };
    }

    if (!(moduleParamName in params && 'enabled' in moduleParams)) {
      utils_extend(allModulesParams, obj);
      return;
    }

    if (params[moduleParamName] === true) {
      params[moduleParamName] = {
        enabled: true
      };
    }

    if (typeof params[moduleParamName] === 'object' && !('enabled' in params[moduleParamName])) {
      params[moduleParamName].enabled = true;
    }

    if (!params[moduleParamName]) params[moduleParamName] = {
      enabled: false
    };
    utils_extend(allModulesParams, obj);
  };
}
;// CONCATENATED MODULE: ./node_modules/swiper/core/core.js
/* eslint no-param-reassign: "off" */






















const prototypes = {
  eventsEmitter: events_emitter,
  update: update,
  translate: translate,
  transition: core_transition,
  slide: slide,
  loop: loop,
  grabCursor: grab_cursor,
  events: core_events,
  breakpoints: breakpoints,
  checkOverflow: check_overflow,
  classes: classes,
  images: core_images
};
const extendedDefaults = {};

class Swiper {
  constructor(...args) {
    let el;
    let params;

    if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === 'Object') {
      params = args[0];
    } else {
      [el, params] = args;
    }

    if (!params) params = {};
    params = utils_extend({}, params);
    if (el && !params.el) params.el = el;

    if (params.el && dom(params.el).length > 1) {
      const swipers = [];
      dom(params.el).each(containerEl => {
        const newParams = utils_extend({}, params, {
          el: containerEl
        });
        swipers.push(new Swiper(newParams));
      }); // eslint-disable-next-line no-constructor-return

      return swipers;
    } // Swiper Instance


    const swiper = this;
    swiper.__swiper__ = true;
    swiper.support = getSupport();
    swiper.device = getDevice({
      userAgent: params.userAgent
    });
    swiper.browser = getBrowser();
    swiper.eventsListeners = {};
    swiper.eventsAnyListeners = [];
    swiper.modules = [...swiper.__modules__];

    if (params.modules && Array.isArray(params.modules)) {
      swiper.modules.push(...params.modules);
    }

    const allModulesParams = {};
    swiper.modules.forEach(mod => {
      mod({
        swiper,
        extendParams: moduleExtendParams(params, allModulesParams),
        on: swiper.on.bind(swiper),
        once: swiper.once.bind(swiper),
        off: swiper.off.bind(swiper),
        emit: swiper.emit.bind(swiper)
      });
    }); // Extend defaults with modules params

    const swiperParams = utils_extend({}, defaults, allModulesParams); // Extend defaults with passed params

    swiper.params = utils_extend({}, swiperParams, extendedDefaults, params);
    swiper.originalParams = utils_extend({}, swiper.params);
    swiper.passedParams = utils_extend({}, params); // add event listeners

    if (swiper.params && swiper.params.on) {
      Object.keys(swiper.params.on).forEach(eventName => {
        swiper.on(eventName, swiper.params.on[eventName]);
      });
    }

    if (swiper.params && swiper.params.onAny) {
      swiper.onAny(swiper.params.onAny);
    } // Save Dom lib


    swiper.$ = dom; // Extend Swiper

    Object.assign(swiper, {
      enabled: swiper.params.enabled,
      el,
      // Classes
      classNames: [],
      // Slides
      slides: dom(),
      slidesGrid: [],
      snapGrid: [],
      slidesSizesGrid: [],

      // isDirection
      isHorizontal() {
        return swiper.params.direction === 'horizontal';
      },

      isVertical() {
        return swiper.params.direction === 'vertical';
      },

      // Indexes
      activeIndex: 0,
      realIndex: 0,
      //
      isBeginning: true,
      isEnd: false,
      // Props
      translate: 0,
      previousTranslate: 0,
      progress: 0,
      velocity: 0,
      animating: false,
      // Locks
      allowSlideNext: swiper.params.allowSlideNext,
      allowSlidePrev: swiper.params.allowSlidePrev,
      // Touch Events
      touchEvents: function touchEvents() {
        const touch = ['touchstart', 'touchmove', 'touchend', 'touchcancel'];
        const desktop = ['pointerdown', 'pointermove', 'pointerup'];
        swiper.touchEventsTouch = {
          start: touch[0],
          move: touch[1],
          end: touch[2],
          cancel: touch[3]
        };
        swiper.touchEventsDesktop = {
          start: desktop[0],
          move: desktop[1],
          end: desktop[2]
        };
        return swiper.support.touch || !swiper.params.simulateTouch ? swiper.touchEventsTouch : swiper.touchEventsDesktop;
      }(),
      touchEventsData: {
        isTouched: undefined,
        isMoved: undefined,
        allowTouchCallbacks: undefined,
        touchStartTime: undefined,
        isScrolling: undefined,
        currentTranslate: undefined,
        startTranslate: undefined,
        allowThresholdMove: undefined,
        // Form elements to match
        focusableElements: swiper.params.focusableElements,
        // Last click time
        lastClickTime: utils_now(),
        clickTimeout: undefined,
        // Velocities
        velocities: [],
        allowMomentumBounce: undefined,
        isTouchEvent: undefined,
        startMoving: undefined
      },
      // Clicks
      allowClick: true,
      // Touches
      allowTouchMove: swiper.params.allowTouchMove,
      touches: {
        startX: 0,
        startY: 0,
        currentX: 0,
        currentY: 0,
        diff: 0
      },
      // Images
      imagesToLoad: [],
      imagesLoaded: 0
    });
    swiper.emit('_swiper'); // Init

    if (swiper.params.init) {
      swiper.init();
    } // Return app instance
    // eslint-disable-next-line no-constructor-return


    return swiper;
  }

  enable() {
    const swiper = this;
    if (swiper.enabled) return;
    swiper.enabled = true;

    if (swiper.params.grabCursor) {
      swiper.setGrabCursor();
    }

    swiper.emit('enable');
  }

  disable() {
    const swiper = this;
    if (!swiper.enabled) return;
    swiper.enabled = false;

    if (swiper.params.grabCursor) {
      swiper.unsetGrabCursor();
    }

    swiper.emit('disable');
  }

  setProgress(progress, speed) {
    const swiper = this;
    progress = Math.min(Math.max(progress, 0), 1);
    const min = swiper.minTranslate();
    const max = swiper.maxTranslate();
    const current = (max - min) * progress + min;
    swiper.translateTo(current, typeof speed === 'undefined' ? 0 : speed);
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  }

  emitContainerClasses() {
    const swiper = this;
    if (!swiper.params._emitClasses || !swiper.el) return;
    const cls = swiper.el.className.split(' ').filter(className => {
      return className.indexOf('swiper') === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
    });
    swiper.emit('_containerClasses', cls.join(' '));
  }

  getSlideClasses(slideEl) {
    const swiper = this;
    if (swiper.destroyed) return '';
    return slideEl.className.split(' ').filter(className => {
      return className.indexOf('swiper-slide') === 0 || className.indexOf(swiper.params.slideClass) === 0;
    }).join(' ');
  }

  emitSlidesClasses() {
    const swiper = this;
    if (!swiper.params._emitClasses || !swiper.el) return;
    const updates = [];
    swiper.slides.each(slideEl => {
      const classNames = swiper.getSlideClasses(slideEl);
      updates.push({
        slideEl,
        classNames
      });
      swiper.emit('_slideClass', slideEl, classNames);
    });
    swiper.emit('_slideClasses', updates);
  }

  slidesPerViewDynamic(view = 'current', exact = false) {
    const swiper = this;
    const {
      params,
      slides,
      slidesGrid,
      slidesSizesGrid,
      size: swiperSize,
      activeIndex
    } = swiper;
    let spv = 1;

    if (params.centeredSlides) {
      let slideSize = slides[activeIndex].swiperSlideSize;
      let breakLoop;

      for (let i = activeIndex + 1; i < slides.length; i += 1) {
        if (slides[i] && !breakLoop) {
          slideSize += slides[i].swiperSlideSize;
          spv += 1;
          if (slideSize > swiperSize) breakLoop = true;
        }
      }

      for (let i = activeIndex - 1; i >= 0; i -= 1) {
        if (slides[i] && !breakLoop) {
          slideSize += slides[i].swiperSlideSize;
          spv += 1;
          if (slideSize > swiperSize) breakLoop = true;
        }
      }
    } else {
      // eslint-disable-next-line
      if (view === 'current') {
        for (let i = activeIndex + 1; i < slides.length; i += 1) {
          const slideInView = exact ? slidesGrid[i] + slidesSizesGrid[i] - slidesGrid[activeIndex] < swiperSize : slidesGrid[i] - slidesGrid[activeIndex] < swiperSize;

          if (slideInView) {
            spv += 1;
          }
        }
      } else {
        // previous
        for (let i = activeIndex - 1; i >= 0; i -= 1) {
          const slideInView = slidesGrid[activeIndex] - slidesGrid[i] < swiperSize;

          if (slideInView) {
            spv += 1;
          }
        }
      }
    }

    return spv;
  }

  update() {
    const swiper = this;
    if (!swiper || swiper.destroyed) return;
    const {
      snapGrid,
      params
    } = swiper; // Breakpoints

    if (params.breakpoints) {
      swiper.setBreakpoint();
    }

    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateProgress();
    swiper.updateSlidesClasses();

    function setTranslate() {
      const translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
      const newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
      swiper.setTranslate(newTranslate);
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    }

    let translated;

    if (swiper.params.freeMode && swiper.params.freeMode.enabled) {
      setTranslate();

      if (swiper.params.autoHeight) {
        swiper.updateAutoHeight();
      }
    } else {
      if ((swiper.params.slidesPerView === 'auto' || swiper.params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) {
        translated = swiper.slideTo(swiper.slides.length - 1, 0, false, true);
      } else {
        translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
      }

      if (!translated) {
        setTranslate();
      }
    }

    if (params.watchOverflow && snapGrid !== swiper.snapGrid) {
      swiper.checkOverflow();
    }

    swiper.emit('update');
  }

  changeDirection(newDirection, needUpdate = true) {
    const swiper = this;
    const currentDirection = swiper.params.direction;

    if (!newDirection) {
      // eslint-disable-next-line
      newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
    }

    if (newDirection === currentDirection || newDirection !== 'horizontal' && newDirection !== 'vertical') {
      return swiper;
    }

    swiper.$el.removeClass(`${swiper.params.containerModifierClass}${currentDirection}`).addClass(`${swiper.params.containerModifierClass}${newDirection}`);
    swiper.emitContainerClasses();
    swiper.params.direction = newDirection;
    swiper.slides.each(slideEl => {
      if (newDirection === 'vertical') {
        slideEl.style.width = '';
      } else {
        slideEl.style.height = '';
      }
    });
    swiper.emit('changeDirection');
    if (needUpdate) swiper.update();
    return swiper;
  }

  changeLanguageDirection(direction) {
    const swiper = this;
    if (swiper.rtl && direction === 'rtl' || !swiper.rtl && direction === 'ltr') return;
    swiper.rtl = direction === 'rtl';
    swiper.rtlTranslate = swiper.params.direction === 'horizontal' && swiper.rtl;

    if (swiper.rtl) {
      swiper.$el.addClass(`${swiper.params.containerModifierClass}rtl`);
      swiper.el.dir = 'rtl';
    } else {
      swiper.$el.removeClass(`${swiper.params.containerModifierClass}rtl`);
      swiper.el.dir = 'ltr';
    }

    swiper.update();
  }

  mount(el) {
    const swiper = this;
    if (swiper.mounted) return true; // Find el

    const $el = dom(el || swiper.params.el);
    el = $el[0];

    if (!el) {
      return false;
    }

    el.swiper = swiper;

    const getWrapperSelector = () => {
      return `.${(swiper.params.wrapperClass || '').trim().split(' ').join('.')}`;
    };

    const getWrapper = () => {
      if (el && el.shadowRoot && el.shadowRoot.querySelector) {
        const res = dom(el.shadowRoot.querySelector(getWrapperSelector())); // Children needs to return slot items

        res.children = options => $el.children(options);

        return res;
      }

      if (!$el.children) {
        return dom($el).children(getWrapperSelector());
      }

      return $el.children(getWrapperSelector());
    }; // Find Wrapper


    let $wrapperEl = getWrapper();

    if ($wrapperEl.length === 0 && swiper.params.createElements) {
      const document = ssr_window_esm_getDocument();
      const wrapper = document.createElement('div');
      $wrapperEl = dom(wrapper);
      wrapper.className = swiper.params.wrapperClass;
      $el.append(wrapper);
      $el.children(`.${swiper.params.slideClass}`).each(slideEl => {
        $wrapperEl.append(slideEl);
      });
    }

    Object.assign(swiper, {
      $el,
      el,
      $wrapperEl,
      wrapperEl: $wrapperEl[0],
      mounted: true,
      // RTL
      rtl: el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl',
      rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl'),
      wrongRTL: $wrapperEl.css('display') === '-webkit-box'
    });
    return true;
  }

  init(el) {
    const swiper = this;
    if (swiper.initialized) return swiper;
    const mounted = swiper.mount(el);
    if (mounted === false) return swiper;
    swiper.emit('beforeInit'); // Set breakpoint

    if (swiper.params.breakpoints) {
      swiper.setBreakpoint();
    } // Add Classes


    swiper.addClasses(); // Create loop

    if (swiper.params.loop) {
      swiper.loopCreate();
    } // Update size


    swiper.updateSize(); // Update slides

    swiper.updateSlides();

    if (swiper.params.watchOverflow) {
      swiper.checkOverflow();
    } // Set Grab Cursor


    if (swiper.params.grabCursor && swiper.enabled) {
      swiper.setGrabCursor();
    }

    if (swiper.params.preloadImages) {
      swiper.preloadImages();
    } // Slide To Initial Slide


    if (swiper.params.loop) {
      swiper.slideTo(swiper.params.initialSlide + swiper.loopedSlides, 0, swiper.params.runCallbacksOnInit, false, true);
    } else {
      swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
    } // Attach events


    swiper.attachEvents(); // Init Flag

    swiper.initialized = true; // Emit

    swiper.emit('init');
    swiper.emit('afterInit');
    return swiper;
  }

  destroy(deleteInstance = true, cleanStyles = true) {
    const swiper = this;
    const {
      params,
      $el,
      $wrapperEl,
      slides
    } = swiper;

    if (typeof swiper.params === 'undefined' || swiper.destroyed) {
      return null;
    }

    swiper.emit('beforeDestroy'); // Init Flag

    swiper.initialized = false; // Detach events

    swiper.detachEvents(); // Destroy loop

    if (params.loop) {
      swiper.loopDestroy();
    } // Cleanup styles


    if (cleanStyles) {
      swiper.removeClasses();
      $el.removeAttr('style');
      $wrapperEl.removeAttr('style');

      if (slides && slides.length) {
        slides.removeClass([params.slideVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass].join(' ')).removeAttr('style').removeAttr('data-swiper-slide-index');
      }
    }

    swiper.emit('destroy'); // Detach emitter events

    Object.keys(swiper.eventsListeners).forEach(eventName => {
      swiper.off(eventName);
    });

    if (deleteInstance !== false) {
      swiper.$el[0].swiper = null;
      deleteProps(swiper);
    }

    swiper.destroyed = true;
    return null;
  }

  static extendDefaults(newDefaults) {
    utils_extend(extendedDefaults, newDefaults);
  }

  static get extendedDefaults() {
    return extendedDefaults;
  }

  static get defaults() {
    return defaults;
  }

  static installModule(mod) {
    if (!Swiper.prototype.__modules__) Swiper.prototype.__modules__ = [];
    const modules = Swiper.prototype.__modules__;

    if (typeof mod === 'function' && modules.indexOf(mod) < 0) {
      modules.push(mod);
    }
  }

  static use(module) {
    if (Array.isArray(module)) {
      module.forEach(m => Swiper.installModule(m));
      return Swiper;
    }

    Swiper.installModule(module);
    return Swiper;
  }

}

Object.keys(prototypes).forEach(prototypeGroup => {
  Object.keys(prototypes[prototypeGroup]).forEach(protoMethod => {
    Swiper.prototype[protoMethod] = prototypes[prototypeGroup][protoMethod];
  });
});
Swiper.use([Resize, Observer]);
/* harmony default export */ var core = (Swiper);
;// CONCATENATED MODULE: ./node_modules/swiper/modules/virtual/virtual.js


function Virtual({
  swiper,
  extendParams,
  on,
  emit
}) {
  extendParams({
    virtual: {
      enabled: false,
      slides: [],
      cache: true,
      renderSlide: null,
      renderExternal: null,
      renderExternalUpdate: true,
      addSlidesBefore: 0,
      addSlidesAfter: 0
    }
  });
  let cssModeTimeout;
  swiper.virtual = {
    cache: {},
    from: undefined,
    to: undefined,
    slides: [],
    offset: 0,
    slidesGrid: []
  };

  function renderSlide(slide, index) {
    const params = swiper.params.virtual;

    if (params.cache && swiper.virtual.cache[index]) {
      return swiper.virtual.cache[index];
    }

    const $slideEl = params.renderSlide ? dom(params.renderSlide.call(swiper, slide, index)) : dom(`<div class="${swiper.params.slideClass}" data-swiper-slide-index="${index}">${slide}</div>`);
    if (!$slideEl.attr('data-swiper-slide-index')) $slideEl.attr('data-swiper-slide-index', index);
    if (params.cache) swiper.virtual.cache[index] = $slideEl;
    return $slideEl;
  }

  function update(force) {
    const {
      slidesPerView,
      slidesPerGroup,
      centeredSlides
    } = swiper.params;
    const {
      addSlidesBefore,
      addSlidesAfter
    } = swiper.params.virtual;
    const {
      from: previousFrom,
      to: previousTo,
      slides,
      slidesGrid: previousSlidesGrid,
      offset: previousOffset
    } = swiper.virtual;

    if (!swiper.params.cssMode) {
      swiper.updateActiveIndex();
    }

    const activeIndex = swiper.activeIndex || 0;
    let offsetProp;
    if (swiper.rtlTranslate) offsetProp = 'right';else offsetProp = swiper.isHorizontal() ? 'left' : 'top';
    let slidesAfter;
    let slidesBefore;

    if (centeredSlides) {
      slidesAfter = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesAfter;
      slidesBefore = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesBefore;
    } else {
      slidesAfter = slidesPerView + (slidesPerGroup - 1) + addSlidesAfter;
      slidesBefore = slidesPerGroup + addSlidesBefore;
    }

    const from = Math.max((activeIndex || 0) - slidesBefore, 0);
    const to = Math.min((activeIndex || 0) + slidesAfter, slides.length - 1);
    const offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);
    Object.assign(swiper.virtual, {
      from,
      to,
      offset,
      slidesGrid: swiper.slidesGrid
    });

    function onRendered() {
      swiper.updateSlides();
      swiper.updateProgress();
      swiper.updateSlidesClasses();

      if (swiper.lazy && swiper.params.lazy.enabled) {
        swiper.lazy.load();
      }

      emit('virtualUpdate');
    }

    if (previousFrom === from && previousTo === to && !force) {
      if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) {
        swiper.slides.css(offsetProp, `${offset}px`);
      }

      swiper.updateProgress();
      emit('virtualUpdate');
      return;
    }

    if (swiper.params.virtual.renderExternal) {
      swiper.params.virtual.renderExternal.call(swiper, {
        offset,
        from,
        to,
        slides: function getSlides() {
          const slidesToRender = [];

          for (let i = from; i <= to; i += 1) {
            slidesToRender.push(slides[i]);
          }

          return slidesToRender;
        }()
      });

      if (swiper.params.virtual.renderExternalUpdate) {
        onRendered();
      } else {
        emit('virtualUpdate');
      }

      return;
    }

    const prependIndexes = [];
    const appendIndexes = [];

    if (force) {
      swiper.$wrapperEl.find(`.${swiper.params.slideClass}`).remove();
    } else {
      for (let i = previousFrom; i <= previousTo; i += 1) {
        if (i < from || i > to) {
          swiper.$wrapperEl.find(`.${swiper.params.slideClass}[data-swiper-slide-index="${i}"]`).remove();
        }
      }
    }

    for (let i = 0; i < slides.length; i += 1) {
      if (i >= from && i <= to) {
        if (typeof previousTo === 'undefined' || force) {
          appendIndexes.push(i);
        } else {
          if (i > previousTo) appendIndexes.push(i);
          if (i < previousFrom) prependIndexes.push(i);
        }
      }
    }

    appendIndexes.forEach(index => {
      swiper.$wrapperEl.append(renderSlide(slides[index], index));
    });
    prependIndexes.sort((a, b) => b - a).forEach(index => {
      swiper.$wrapperEl.prepend(renderSlide(slides[index], index));
    });
    swiper.$wrapperEl.children('.swiper-slide').css(offsetProp, `${offset}px`);
    onRendered();
  }

  function appendSlide(slides) {
    if (typeof slides === 'object' && 'length' in slides) {
      for (let i = 0; i < slides.length; i += 1) {
        if (slides[i]) swiper.virtual.slides.push(slides[i]);
      }
    } else {
      swiper.virtual.slides.push(slides);
    }

    update(true);
  }

  function prependSlide(slides) {
    const activeIndex = swiper.activeIndex;
    let newActiveIndex = activeIndex + 1;
    let numberOfNewSlides = 1;

    if (Array.isArray(slides)) {
      for (let i = 0; i < slides.length; i += 1) {
        if (slides[i]) swiper.virtual.slides.unshift(slides[i]);
      }

      newActiveIndex = activeIndex + slides.length;
      numberOfNewSlides = slides.length;
    } else {
      swiper.virtual.slides.unshift(slides);
    }

    if (swiper.params.virtual.cache) {
      const cache = swiper.virtual.cache;
      const newCache = {};
      Object.keys(cache).forEach(cachedIndex => {
        const $cachedEl = cache[cachedIndex];
        const cachedElIndex = $cachedEl.attr('data-swiper-slide-index');

        if (cachedElIndex) {
          $cachedEl.attr('data-swiper-slide-index', parseInt(cachedElIndex, 10) + numberOfNewSlides);
        }

        newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = $cachedEl;
      });
      swiper.virtual.cache = newCache;
    }

    update(true);
    swiper.slideTo(newActiveIndex, 0);
  }

  function removeSlide(slidesIndexes) {
    if (typeof slidesIndexes === 'undefined' || slidesIndexes === null) return;
    let activeIndex = swiper.activeIndex;

    if (Array.isArray(slidesIndexes)) {
      for (let i = slidesIndexes.length - 1; i >= 0; i -= 1) {
        swiper.virtual.slides.splice(slidesIndexes[i], 1);

        if (swiper.params.virtual.cache) {
          delete swiper.virtual.cache[slidesIndexes[i]];
        }

        if (slidesIndexes[i] < activeIndex) activeIndex -= 1;
        activeIndex = Math.max(activeIndex, 0);
      }
    } else {
      swiper.virtual.slides.splice(slidesIndexes, 1);

      if (swiper.params.virtual.cache) {
        delete swiper.virtual.cache[slidesIndexes];
      }

      if (slidesIndexes < activeIndex) activeIndex -= 1;
      activeIndex = Math.max(activeIndex, 0);
    }

    update(true);
    swiper.slideTo(activeIndex, 0);
  }

  function removeAllSlides() {
    swiper.virtual.slides = [];

    if (swiper.params.virtual.cache) {
      swiper.virtual.cache = {};
    }

    update(true);
    swiper.slideTo(0, 0);
  }

  on('beforeInit', () => {
    if (!swiper.params.virtual.enabled) return;
    swiper.virtual.slides = swiper.params.virtual.slides;
    swiper.classNames.push(`${swiper.params.containerModifierClass}virtual`);
    swiper.params.watchSlidesProgress = true;
    swiper.originalParams.watchSlidesProgress = true;

    if (!swiper.params.initialSlide) {
      update();
    }
  });
  on('setTranslate', () => {
    if (!swiper.params.virtual.enabled) return;

    if (swiper.params.cssMode && !swiper._immediateVirtual) {
      clearTimeout(cssModeTimeout);
      cssModeTimeout = setTimeout(() => {
        update();
      }, 100);
    } else {
      update();
    }
  });
  on('init update resize', () => {
    if (!swiper.params.virtual.enabled) return;

    if (swiper.params.cssMode) {
      setCSSProperty(swiper.wrapperEl, '--swiper-virtual-size', `${swiper.virtualSize}px`);
    }
  });
  Object.assign(swiper.virtual, {
    appendSlide,
    prependSlide,
    removeSlide,
    removeAllSlides,
    update
  });
}
;// CONCATENATED MODULE: ./node_modules/swiper/modules/keyboard/keyboard.js
/* eslint-disable consistent-return */


function Keyboard({
  swiper,
  extendParams,
  on,
  emit
}) {
  const document = getDocument();
  const window = getWindow();
  swiper.keyboard = {
    enabled: false
  };
  extendParams({
    keyboard: {
      enabled: false,
      onlyInViewport: true,
      pageUpDown: true
    }
  });

  function handle(event) {
    if (!swiper.enabled) return;
    const {
      rtlTranslate: rtl
    } = swiper;
    let e = event;
    if (e.originalEvent) e = e.originalEvent; // jquery fix

    const kc = e.keyCode || e.charCode;
    const pageUpDown = swiper.params.keyboard.pageUpDown;
    const isPageUp = pageUpDown && kc === 33;
    const isPageDown = pageUpDown && kc === 34;
    const isArrowLeft = kc === 37;
    const isArrowRight = kc === 39;
    const isArrowUp = kc === 38;
    const isArrowDown = kc === 40; // Directions locks

    if (!swiper.allowSlideNext && (swiper.isHorizontal() && isArrowRight || swiper.isVertical() && isArrowDown || isPageDown)) {
      return false;
    }

    if (!swiper.allowSlidePrev && (swiper.isHorizontal() && isArrowLeft || swiper.isVertical() && isArrowUp || isPageUp)) {
      return false;
    }

    if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) {
      return undefined;
    }

    if (document.activeElement && document.activeElement.nodeName && (document.activeElement.nodeName.toLowerCase() === 'input' || document.activeElement.nodeName.toLowerCase() === 'textarea')) {
      return undefined;
    }

    if (swiper.params.keyboard.onlyInViewport && (isPageUp || isPageDown || isArrowLeft || isArrowRight || isArrowUp || isArrowDown)) {
      let inView = false; // Check that swiper should be inside of visible area of window

      if (swiper.$el.parents(`.${swiper.params.slideClass}`).length > 0 && swiper.$el.parents(`.${swiper.params.slideActiveClass}`).length === 0) {
        return undefined;
      }

      const $el = swiper.$el;
      const swiperWidth = $el[0].clientWidth;
      const swiperHeight = $el[0].clientHeight;
      const windowWidth = window.innerWidth;
      const windowHeight = window.innerHeight;
      const swiperOffset = swiper.$el.offset();
      if (rtl) swiperOffset.left -= swiper.$el[0].scrollLeft;
      const swiperCoord = [[swiperOffset.left, swiperOffset.top], [swiperOffset.left + swiperWidth, swiperOffset.top], [swiperOffset.left, swiperOffset.top + swiperHeight], [swiperOffset.left + swiperWidth, swiperOffset.top + swiperHeight]];

      for (let i = 0; i < swiperCoord.length; i += 1) {
        const point = swiperCoord[i];

        if (point[0] >= 0 && point[0] <= windowWidth && point[1] >= 0 && point[1] <= windowHeight) {
          if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line

          inView = true;
        }
      }

      if (!inView) return undefined;
    }

    if (swiper.isHorizontal()) {
      if (isPageUp || isPageDown || isArrowLeft || isArrowRight) {
        if (e.preventDefault) e.preventDefault();else e.returnValue = false;
      }

      if ((isPageDown || isArrowRight) && !rtl || (isPageUp || isArrowLeft) && rtl) swiper.slideNext();
      if ((isPageUp || isArrowLeft) && !rtl || (isPageDown || isArrowRight) && rtl) swiper.slidePrev();
    } else {
      if (isPageUp || isPageDown || isArrowUp || isArrowDown) {
        if (e.preventDefault) e.preventDefault();else e.returnValue = false;
      }

      if (isPageDown || isArrowDown) swiper.slideNext();
      if (isPageUp || isArrowUp) swiper.slidePrev();
    }

    emit('keyPress', kc);
    return undefined;
  }

  function enable() {
    if (swiper.keyboard.enabled) return;
    $(document).on('keydown', handle);
    swiper.keyboard.enabled = true;
  }

  function disable() {
    if (!swiper.keyboard.enabled) return;
    $(document).off('keydown', handle);
    swiper.keyboard.enabled = false;
  }

  on('init', () => {
    if (swiper.params.keyboard.enabled) {
      enable();
    }
  });
  on('destroy', () => {
    if (swiper.keyboard.enabled) {
      disable();
    }
  });
  Object.assign(swiper.keyboard, {
    enable,
    disable
  });
}
;// CONCATENATED MODULE: ./node_modules/swiper/modules/mousewheel/mousewheel.js
/* eslint-disable consistent-return */



function Mousewheel({
  swiper,
  extendParams,
  on,
  emit
}) {
  const window = getWindow();
  extendParams({
    mousewheel: {
      enabled: false,
      releaseOnEdges: false,
      invert: false,
      forceToAxis: false,
      sensitivity: 1,
      eventsTarget: 'container',
      thresholdDelta: null,
      thresholdTime: null
    }
  });
  swiper.mousewheel = {
    enabled: false
  };
  let timeout;
  let lastScrollTime = now();
  let lastEventBeforeSnap;
  const recentWheelEvents = [];

  function normalize(e) {
    // Reasonable defaults
    const PIXEL_STEP = 10;
    const LINE_HEIGHT = 40;
    const PAGE_HEIGHT = 800;
    let sX = 0;
    let sY = 0; // spinX, spinY

    let pX = 0;
    let pY = 0; // pixelX, pixelY
    // Legacy

    if ('detail' in e) {
      sY = e.detail;
    }

    if ('wheelDelta' in e) {
      sY = -e.wheelDelta / 120;
    }

    if ('wheelDeltaY' in e) {
      sY = -e.wheelDeltaY / 120;
    }

    if ('wheelDeltaX' in e) {
      sX = -e.wheelDeltaX / 120;
    } // side scrolling on FF with DOMMouseScroll


    if ('axis' in e && e.axis === e.HORIZONTAL_AXIS) {
      sX = sY;
      sY = 0;
    }

    pX = sX * PIXEL_STEP;
    pY = sY * PIXEL_STEP;

    if ('deltaY' in e) {
      pY = e.deltaY;
    }

    if ('deltaX' in e) {
      pX = e.deltaX;
    }

    if (e.shiftKey && !pX) {
      // if user scrolls with shift he wants horizontal scroll
      pX = pY;
      pY = 0;
    }

    if ((pX || pY) && e.deltaMode) {
      if (e.deltaMode === 1) {
        // delta in LINE units
        pX *= LINE_HEIGHT;
        pY *= LINE_HEIGHT;
      } else {
        // delta in PAGE units
        pX *= PAGE_HEIGHT;
        pY *= PAGE_HEIGHT;
      }
    } // Fall-back if spin cannot be determined


    if (pX && !sX) {
      sX = pX < 1 ? -1 : 1;
    }

    if (pY && !sY) {
      sY = pY < 1 ? -1 : 1;
    }

    return {
      spinX: sX,
      spinY: sY,
      pixelX: pX,
      pixelY: pY
    };
  }

  function handleMouseEnter() {
    if (!swiper.enabled) return;
    swiper.mouseEntered = true;
  }

  function handleMouseLeave() {
    if (!swiper.enabled) return;
    swiper.mouseEntered = false;
  }

  function animateSlider(newEvent) {
    if (swiper.params.mousewheel.thresholdDelta && newEvent.delta < swiper.params.mousewheel.thresholdDelta) {
      // Prevent if delta of wheel scroll delta is below configured threshold
      return false;
    }

    if (swiper.params.mousewheel.thresholdTime && now() - lastScrollTime < swiper.params.mousewheel.thresholdTime) {
      // Prevent if time between scrolls is below configured threshold
      return false;
    } // If the movement is NOT big enough and
    // if the last time the user scrolled was too close to the current one (avoid continuously triggering the slider):
    //   Don't go any further (avoid insignificant scroll movement).


    if (newEvent.delta >= 6 && now() - lastScrollTime < 60) {
      // Return false as a default
      return true;
    } // If user is scrolling towards the end:
    //   If the slider hasn't hit the latest slide or
    //   if the slider is a loop and
    //   if the slider isn't moving right now:
    //     Go to next slide and
    //     emit a scroll event.
    // Else (the user is scrolling towards the beginning) and
    // if the slider hasn't hit the first slide or
    // if the slider is a loop and
    // if the slider isn't moving right now:
    //   Go to prev slide and
    //   emit a scroll event.


    if (newEvent.direction < 0) {
      if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
        swiper.slideNext();
        emit('scroll', newEvent.raw);
      }
    } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
      swiper.slidePrev();
      emit('scroll', newEvent.raw);
    } // If you got here is because an animation has been triggered so store the current time


    lastScrollTime = new window.Date().getTime(); // Return false as a default

    return false;
  }

  function releaseScroll(newEvent) {
    const params = swiper.params.mousewheel;

    if (newEvent.direction < 0) {
      if (swiper.isEnd && !swiper.params.loop && params.releaseOnEdges) {
        // Return true to animate scroll on edges
        return true;
      }
    } else if (swiper.isBeginning && !swiper.params.loop && params.releaseOnEdges) {
      // Return true to animate scroll on edges
      return true;
    }

    return false;
  }

  function handle(event) {
    let e = event;
    let disableParentSwiper = true;
    if (!swiper.enabled) return;
    const params = swiper.params.mousewheel;

    if (swiper.params.cssMode) {
      e.preventDefault();
    }

    let target = swiper.$el;

    if (swiper.params.mousewheel.eventsTarget !== 'container') {
      target = $(swiper.params.mousewheel.eventsTarget);
    }

    if (!swiper.mouseEntered && !target[0].contains(e.target) && !params.releaseOnEdges) return true;
    if (e.originalEvent) e = e.originalEvent; // jquery fix

    let delta = 0;
    const rtlFactor = swiper.rtlTranslate ? -1 : 1;
    const data = normalize(e);

    if (params.forceToAxis) {
      if (swiper.isHorizontal()) {
        if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) delta = -data.pixelX * rtlFactor;else return true;
      } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) delta = -data.pixelY;else return true;
    } else {
      delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
    }

    if (delta === 0) return true;
    if (params.invert) delta = -delta; // Get the scroll positions

    let positions = swiper.getTranslate() + delta * params.sensitivity;
    if (positions >= swiper.minTranslate()) positions = swiper.minTranslate();
    if (positions <= swiper.maxTranslate()) positions = swiper.maxTranslate(); // When loop is true:
    //     the disableParentSwiper will be true.
    // When loop is false:
    //     if the scroll positions is not on edge,
    //     then the disableParentSwiper will be true.
    //     if the scroll on edge positions,
    //     then the disableParentSwiper will be false.

    disableParentSwiper = swiper.params.loop ? true : !(positions === swiper.minTranslate() || positions === swiper.maxTranslate());
    if (disableParentSwiper && swiper.params.nested) e.stopPropagation();

    if (!swiper.params.freeMode || !swiper.params.freeMode.enabled) {
      // Register the new event in a variable which stores the relevant data
      const newEvent = {
        time: now(),
        delta: Math.abs(delta),
        direction: Math.sign(delta),
        raw: event
      }; // Keep the most recent events

      if (recentWheelEvents.length >= 2) {
        recentWheelEvents.shift(); // only store the last N events
      }

      const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
      recentWheelEvents.push(newEvent); // If there is at least one previous recorded event:
      //   If direction has changed or
      //   if the scroll is quicker than the previous one:
      //     Animate the slider.
      // Else (this is the first time the wheel is moved):
      //     Animate the slider.

      if (prevEvent) {
        if (newEvent.direction !== prevEvent.direction || newEvent.delta > prevEvent.delta || newEvent.time > prevEvent.time + 150) {
          animateSlider(newEvent);
        }
      } else {
        animateSlider(newEvent);
      } // If it's time to release the scroll:
      //   Return now so you don't hit the preventDefault.


      if (releaseScroll(newEvent)) {
        return true;
      }
    } else {
      // Freemode or scrollContainer:
      // If we recently snapped after a momentum scroll, then ignore wheel events
      // to give time for the deceleration to finish. Stop ignoring after 500 msecs
      // or if it's a new scroll (larger delta or inverse sign as last event before
      // an end-of-momentum snap).
      const newEvent = {
        time: now(),
        delta: Math.abs(delta),
        direction: Math.sign(delta)
      };
      const ignoreWheelEvents = lastEventBeforeSnap && newEvent.time < lastEventBeforeSnap.time + 500 && newEvent.delta <= lastEventBeforeSnap.delta && newEvent.direction === lastEventBeforeSnap.direction;

      if (!ignoreWheelEvents) {
        lastEventBeforeSnap = undefined;

        if (swiper.params.loop) {
          swiper.loopFix();
        }

        let position = swiper.getTranslate() + delta * params.sensitivity;
        const wasBeginning = swiper.isBeginning;
        const wasEnd = swiper.isEnd;
        if (position >= swiper.minTranslate()) position = swiper.minTranslate();
        if (position <= swiper.maxTranslate()) position = swiper.maxTranslate();
        swiper.setTransition(0);
        swiper.setTranslate(position);
        swiper.updateProgress();
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();

        if (!wasBeginning && swiper.isBeginning || !wasEnd && swiper.isEnd) {
          swiper.updateSlidesClasses();
        }

        if (swiper.params.freeMode.sticky) {
          // When wheel scrolling starts with sticky (aka snap) enabled, then detect
          // the end of a momentum scroll by storing recent (N=15?) wheel events.
          // 1. do all N events have decreasing or same (absolute value) delta?
          // 2. did all N events arrive in the last M (M=500?) msecs?
          // 3. does the earliest event have an (absolute value) delta that's
          //    at least P (P=1?) larger than the most recent event's delta?
          // 4. does the latest event have a delta that's smaller than Q (Q=6?) pixels?
          // If 1-4 are "yes" then we're near the end of a momentum scroll deceleration.
          // Snap immediately and ignore remaining wheel events in this scroll.
          // See comment above for "remaining wheel events in this scroll" determination.
          // If 1-4 aren't satisfied, then wait to snap until 500ms after the last event.
          clearTimeout(timeout);
          timeout = undefined;

          if (recentWheelEvents.length >= 15) {
            recentWheelEvents.shift(); // only store the last N events
          }

          const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
          const firstEvent = recentWheelEvents[0];
          recentWheelEvents.push(newEvent);

          if (prevEvent && (newEvent.delta > prevEvent.delta || newEvent.direction !== prevEvent.direction)) {
            // Increasing or reverse-sign delta means the user started scrolling again. Clear the wheel event log.
            recentWheelEvents.splice(0);
          } else if (recentWheelEvents.length >= 15 && newEvent.time - firstEvent.time < 500 && firstEvent.delta - newEvent.delta >= 1 && newEvent.delta <= 6) {
            // We're at the end of the deceleration of a momentum scroll, so there's no need
            // to wait for more events. Snap ASAP on the next tick.
            // Also, because there's some remaining momentum we'll bias the snap in the
            // direction of the ongoing scroll because it's better UX for the scroll to snap
            // in the same direction as the scroll instead of reversing to snap.  Therefore,
            // if it's already scrolled more than 20% in the current direction, keep going.
            const snapToThreshold = delta > 0 ? 0.8 : 0.2;
            lastEventBeforeSnap = newEvent;
            recentWheelEvents.splice(0);
            timeout = nextTick(() => {
              swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
            }, 0); // no delay; move on next tick
          }

          if (!timeout) {
            // if we get here, then we haven't detected the end of a momentum scroll, so
            // we'll consider a scroll "complete" when there haven't been any wheel events
            // for 500ms.
            timeout = nextTick(() => {
              const snapToThreshold = 0.5;
              lastEventBeforeSnap = newEvent;
              recentWheelEvents.splice(0);
              swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
            }, 500);
          }
        } // Emit event


        if (!ignoreWheelEvents) emit('scroll', e); // Stop autoplay

        if (swiper.params.autoplay && swiper.params.autoplayDisableOnInteraction) swiper.autoplay.stop(); // Return page scroll on edge positions

        if (position === swiper.minTranslate() || position === swiper.maxTranslate()) return true;
      }
    }

    if (e.preventDefault) e.preventDefault();else e.returnValue = false;
    return false;
  }

  function events(method) {
    let target = swiper.$el;

    if (swiper.params.mousewheel.eventsTarget !== 'container') {
      target = $(swiper.params.mousewheel.eventsTarget);
    }

    target[method]('mouseenter', handleMouseEnter);
    target[method]('mouseleave', handleMouseLeave);
    target[method]('wheel', handle);
  }

  function enable() {
    if (swiper.params.cssMode) {
      swiper.wrapperEl.removeEventListener('wheel', handle);
      return true;
    }

    if (swiper.mousewheel.enabled) return false;
    events('on');
    swiper.mousewheel.enabled = true;
    return true;
  }

  function disable() {
    if (swiper.params.cssMode) {
      swiper.wrapperEl.addEventListener(event, handle);
      return true;
    }

    if (!swiper.mousewheel.enabled) return false;
    events('off');
    swiper.mousewheel.enabled = false;
    return true;
  }

  on('init', () => {
    if (!swiper.params.mousewheel.enabled && swiper.params.cssMode) {
      disable();
    }

    if (swiper.params.mousewheel.enabled) enable();
  });
  on('destroy', () => {
    if (swiper.params.cssMode) {
      enable();
    }

    if (swiper.mousewheel.enabled) disable();
  });
  Object.assign(swiper.mousewheel, {
    enable,
    disable
  });
}
;// CONCATENATED MODULE: ./node_modules/swiper/shared/create-element-if-not-defined.js

function create_element_if_not_defined_createElementIfNotDefined(swiper, originalParams, params, checkProps) {
  const document = ssr_window_esm_getDocument();

  if (swiper.params.createElements) {
    Object.keys(checkProps).forEach(key => {
      if (!params[key] && params.auto === true) {
        let element = swiper.$el.children(`.${checkProps[key]}`)[0];

        if (!element) {
          element = document.createElement('div');
          element.className = checkProps[key];
          swiper.$el.append(element);
        }

        params[key] = element;
        originalParams[key] = element;
      }
    });
  }

  return params;
}
;// CONCATENATED MODULE: ./node_modules/swiper/modules/navigation/navigation.js


function Navigation({
  swiper,
  extendParams,
  on,
  emit
}) {
  extendParams({
    navigation: {
      nextEl: null,
      prevEl: null,
      hideOnClick: false,
      disabledClass: 'swiper-button-disabled',
      hiddenClass: 'swiper-button-hidden',
      lockClass: 'swiper-button-lock',
      navigationDisabledClass: 'swiper-navigation-disabled'
    }
  });
  swiper.navigation = {
    nextEl: null,
    $nextEl: null,
    prevEl: null,
    $prevEl: null
  };

  function getEl(el) {
    let $el;

    if (el) {
      $el = dom(el);

      if (swiper.params.uniqueNavElements && typeof el === 'string' && $el.length > 1 && swiper.$el.find(el).length === 1) {
        $el = swiper.$el.find(el);
      }
    }

    return $el;
  }

  function toggleEl($el, disabled) {
    const params = swiper.params.navigation;

    if ($el && $el.length > 0) {
      $el[disabled ? 'addClass' : 'removeClass'](params.disabledClass);
      if ($el[0] && $el[0].tagName === 'BUTTON') $el[0].disabled = disabled;

      if (swiper.params.watchOverflow && swiper.enabled) {
        $el[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
      }
    }
  }

  function update() {
    // Update Navigation Buttons
    if (swiper.params.loop) return;
    const {
      $nextEl,
      $prevEl
    } = swiper.navigation;
    toggleEl($prevEl, swiper.isBeginning && !swiper.params.rewind);
    toggleEl($nextEl, swiper.isEnd && !swiper.params.rewind);
  }

  function onPrevClick(e) {
    e.preventDefault();
    if (swiper.isBeginning && !swiper.params.loop && !swiper.params.rewind) return;
    swiper.slidePrev();
    emit('navigationPrev');
  }

  function onNextClick(e) {
    e.preventDefault();
    if (swiper.isEnd && !swiper.params.loop && !swiper.params.rewind) return;
    swiper.slideNext();
    emit('navigationNext');
  }

  function init() {
    const params = swiper.params.navigation;
    swiper.params.navigation = create_element_if_not_defined_createElementIfNotDefined(swiper, swiper.originalParams.navigation, swiper.params.navigation, {
      nextEl: 'swiper-button-next',
      prevEl: 'swiper-button-prev'
    });
    if (!(params.nextEl || params.prevEl)) return;
    const $nextEl = getEl(params.nextEl);
    const $prevEl = getEl(params.prevEl);

    if ($nextEl && $nextEl.length > 0) {
      $nextEl.on('click', onNextClick);
    }

    if ($prevEl && $prevEl.length > 0) {
      $prevEl.on('click', onPrevClick);
    }

    Object.assign(swiper.navigation, {
      $nextEl,
      nextEl: $nextEl && $nextEl[0],
      $prevEl,
      prevEl: $prevEl && $prevEl[0]
    });

    if (!swiper.enabled) {
      if ($nextEl) $nextEl.addClass(params.lockClass);
      if ($prevEl) $prevEl.addClass(params.lockClass);
    }
  }

  function destroy() {
    const {
      $nextEl,
      $prevEl
    } = swiper.navigation;

    if ($nextEl && $nextEl.length) {
      $nextEl.off('click', onNextClick);
      $nextEl.removeClass(swiper.params.navigation.disabledClass);
    }

    if ($prevEl && $prevEl.length) {
      $prevEl.off('click', onPrevClick);
      $prevEl.removeClass(swiper.params.navigation.disabledClass);
    }
  }

  on('init', () => {
    if (swiper.params.navigation.enabled === false) {
      // eslint-disable-next-line
      disable();
    } else {
      init();
      update();
    }
  });
  on('toEdge fromEdge lock unlock', () => {
    update();
  });
  on('destroy', () => {
    destroy();
  });
  on('enable disable', () => {
    const {
      $nextEl,
      $prevEl
    } = swiper.navigation;

    if ($nextEl) {
      $nextEl[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.navigation.lockClass);
    }

    if ($prevEl) {
      $prevEl[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.navigation.lockClass);
    }
  });
  on('click', (_s, e) => {
    const {
      $nextEl,
      $prevEl
    } = swiper.navigation;
    const targetEl = e.target;

    if (swiper.params.navigation.hideOnClick && !dom(targetEl).is($prevEl) && !dom(targetEl).is($nextEl)) {
      if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl))) return;
      let isHidden;

      if ($nextEl) {
        isHidden = $nextEl.hasClass(swiper.params.navigation.hiddenClass);
      } else if ($prevEl) {
        isHidden = $prevEl.hasClass(swiper.params.navigation.hiddenClass);
      }

      if (isHidden === true) {
        emit('navigationShow');
      } else {
        emit('navigationHide');
      }

      if ($nextEl) {
        $nextEl.toggleClass(swiper.params.navigation.hiddenClass);
      }

      if ($prevEl) {
        $prevEl.toggleClass(swiper.params.navigation.hiddenClass);
      }
    }
  });

  const enable = () => {
    swiper.$el.removeClass(swiper.params.navigation.navigationDisabledClass);
    init();
    update();
  };

  const disable = () => {
    swiper.$el.addClass(swiper.params.navigation.navigationDisabledClass);
    destroy();
  };

  Object.assign(swiper.navigation, {
    enable,
    disable,
    update,
    init,
    destroy
  });
}
;// CONCATENATED MODULE: ./node_modules/swiper/shared/classes-to-selector.js
function classes_to_selector_classesToSelector(classes = '') {
  return `.${classes.trim().replace(/([\.:!\/])/g, '\\$1') // eslint-disable-line
  .replace(/ /g, '.')}`;
}
;// CONCATENATED MODULE: ./node_modules/swiper/modules/pagination/pagination.js



function Pagination({
  swiper,
  extendParams,
  on,
  emit
}) {
  const pfx = 'swiper-pagination';
  extendParams({
    pagination: {
      el: null,
      bulletElement: 'span',
      clickable: false,
      hideOnClick: false,
      renderBullet: null,
      renderProgressbar: null,
      renderFraction: null,
      renderCustom: null,
      progressbarOpposite: false,
      type: 'bullets',
      // 'bullets' or 'progressbar' or 'fraction' or 'custom'
      dynamicBullets: false,
      dynamicMainBullets: 1,
      formatFractionCurrent: number => number,
      formatFractionTotal: number => number,
      bulletClass: `${pfx}-bullet`,
      bulletActiveClass: `${pfx}-bullet-active`,
      modifierClass: `${pfx}-`,
      currentClass: `${pfx}-current`,
      totalClass: `${pfx}-total`,
      hiddenClass: `${pfx}-hidden`,
      progressbarFillClass: `${pfx}-progressbar-fill`,
      progressbarOppositeClass: `${pfx}-progressbar-opposite`,
      clickableClass: `${pfx}-clickable`,
      lockClass: `${pfx}-lock`,
      horizontalClass: `${pfx}-horizontal`,
      verticalClass: `${pfx}-vertical`,
      paginationDisabledClass: `${pfx}-disabled`
    }
  });
  swiper.pagination = {
    el: null,
    $el: null,
    bullets: []
  };
  let bulletSize;
  let dynamicBulletIndex = 0;

  function isPaginationDisabled() {
    return !swiper.params.pagination.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0;
  }

  function setSideBullets($bulletEl, position) {
    const {
      bulletActiveClass
    } = swiper.params.pagination;
    $bulletEl[position]().addClass(`${bulletActiveClass}-${position}`)[position]().addClass(`${bulletActiveClass}-${position}-${position}`);
  }

  function update() {
    // Render || Update Pagination bullets/items
    const rtl = swiper.rtl;
    const params = swiper.params.pagination;
    if (isPaginationDisabled()) return;
    const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
    const $el = swiper.pagination.$el; // Current/Total

    let current;
    const total = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;

    if (swiper.params.loop) {
      current = Math.ceil((swiper.activeIndex - swiper.loopedSlides) / swiper.params.slidesPerGroup);

      if (current > slidesLength - 1 - swiper.loopedSlides * 2) {
        current -= slidesLength - swiper.loopedSlides * 2;
      }

      if (current > total - 1) current -= total;
      if (current < 0 && swiper.params.paginationType !== 'bullets') current = total + current;
    } else if (typeof swiper.snapIndex !== 'undefined') {
      current = swiper.snapIndex;
    } else {
      current = swiper.activeIndex || 0;
    } // Types


    if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
      const bullets = swiper.pagination.bullets;
      let firstIndex;
      let lastIndex;
      let midIndex;

      if (params.dynamicBullets) {
        bulletSize = bullets.eq(0)[swiper.isHorizontal() ? 'outerWidth' : 'outerHeight'](true);
        $el.css(swiper.isHorizontal() ? 'width' : 'height', `${bulletSize * (params.dynamicMainBullets + 4)}px`);

        if (params.dynamicMainBullets > 1 && swiper.previousIndex !== undefined) {
          dynamicBulletIndex += current - (swiper.previousIndex - swiper.loopedSlides || 0);

          if (dynamicBulletIndex > params.dynamicMainBullets - 1) {
            dynamicBulletIndex = params.dynamicMainBullets - 1;
          } else if (dynamicBulletIndex < 0) {
            dynamicBulletIndex = 0;
          }
        }

        firstIndex = Math.max(current - dynamicBulletIndex, 0);
        lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
        midIndex = (lastIndex + firstIndex) / 2;
      }

      bullets.removeClass(['', '-next', '-next-next', '-prev', '-prev-prev', '-main'].map(suffix => `${params.bulletActiveClass}${suffix}`).join(' '));

      if ($el.length > 1) {
        bullets.each(bullet => {
          const $bullet = dom(bullet);
          const bulletIndex = $bullet.index();

          if (bulletIndex === current) {
            $bullet.addClass(params.bulletActiveClass);
          }

          if (params.dynamicBullets) {
            if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) {
              $bullet.addClass(`${params.bulletActiveClass}-main`);
            }

            if (bulletIndex === firstIndex) {
              setSideBullets($bullet, 'prev');
            }

            if (bulletIndex === lastIndex) {
              setSideBullets($bullet, 'next');
            }
          }
        });
      } else {
        const $bullet = bullets.eq(current);
        const bulletIndex = $bullet.index();
        $bullet.addClass(params.bulletActiveClass);

        if (params.dynamicBullets) {
          const $firstDisplayedBullet = bullets.eq(firstIndex);
          const $lastDisplayedBullet = bullets.eq(lastIndex);

          for (let i = firstIndex; i <= lastIndex; i += 1) {
            bullets.eq(i).addClass(`${params.bulletActiveClass}-main`);
          }

          if (swiper.params.loop) {
            if (bulletIndex >= bullets.length) {
              for (let i = params.dynamicMainBullets; i >= 0; i -= 1) {
                bullets.eq(bullets.length - i).addClass(`${params.bulletActiveClass}-main`);
              }

              bullets.eq(bullets.length - params.dynamicMainBullets - 1).addClass(`${params.bulletActiveClass}-prev`);
            } else {
              setSideBullets($firstDisplayedBullet, 'prev');
              setSideBullets($lastDisplayedBullet, 'next');
            }
          } else {
            setSideBullets($firstDisplayedBullet, 'prev');
            setSideBullets($lastDisplayedBullet, 'next');
          }
        }
      }

      if (params.dynamicBullets) {
        const dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
        const bulletsOffset = (bulletSize * dynamicBulletsLength - bulletSize) / 2 - midIndex * bulletSize;
        const offsetProp = rtl ? 'right' : 'left';
        bullets.css(swiper.isHorizontal() ? offsetProp : 'top', `${bulletsOffset}px`);
      }
    }

    if (params.type === 'fraction') {
      $el.find(classes_to_selector_classesToSelector(params.currentClass)).text(params.formatFractionCurrent(current + 1));
      $el.find(classes_to_selector_classesToSelector(params.totalClass)).text(params.formatFractionTotal(total));
    }

    if (params.type === 'progressbar') {
      let progressbarDirection;

      if (params.progressbarOpposite) {
        progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
      } else {
        progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
      }

      const scale = (current + 1) / total;
      let scaleX = 1;
      let scaleY = 1;

      if (progressbarDirection === 'horizontal') {
        scaleX = scale;
      } else {
        scaleY = scale;
      }

      $el.find(classes_to_selector_classesToSelector(params.progressbarFillClass)).transform(`translate3d(0,0,0) scaleX(${scaleX}) scaleY(${scaleY})`).transition(swiper.params.speed);
    }

    if (params.type === 'custom' && params.renderCustom) {
      $el.html(params.renderCustom(swiper, current + 1, total));
      emit('paginationRender', $el[0]);
    } else {
      emit('paginationUpdate', $el[0]);
    }

    if (swiper.params.watchOverflow && swiper.enabled) {
      $el[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
    }
  }

  function render() {
    // Render Container
    const params = swiper.params.pagination;
    if (isPaginationDisabled()) return;
    const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
    const $el = swiper.pagination.$el;
    let paginationHTML = '';

    if (params.type === 'bullets') {
      let numberOfBullets = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;

      if (swiper.params.freeMode && swiper.params.freeMode.enabled && !swiper.params.loop && numberOfBullets > slidesLength) {
        numberOfBullets = slidesLength;
      }

      for (let i = 0; i < numberOfBullets; i += 1) {
        if (params.renderBullet) {
          paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
        } else {
          paginationHTML += `<${params.bulletElement} class="${params.bulletClass}"></${params.bulletElement}>`;
        }
      }

      $el.html(paginationHTML);
      swiper.pagination.bullets = $el.find(classes_to_selector_classesToSelector(params.bulletClass));
    }

    if (params.type === 'fraction') {
      if (params.renderFraction) {
        paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
      } else {
        paginationHTML = `<span class="${params.currentClass}"></span>` + ' / ' + `<span class="${params.totalClass}"></span>`;
      }

      $el.html(paginationHTML);
    }

    if (params.type === 'progressbar') {
      if (params.renderProgressbar) {
        paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
      } else {
        paginationHTML = `<span class="${params.progressbarFillClass}"></span>`;
      }

      $el.html(paginationHTML);
    }

    if (params.type !== 'custom') {
      emit('paginationRender', swiper.pagination.$el[0]);
    }
  }

  function init() {
    swiper.params.pagination = create_element_if_not_defined_createElementIfNotDefined(swiper, swiper.originalParams.pagination, swiper.params.pagination, {
      el: 'swiper-pagination'
    });
    const params = swiper.params.pagination;
    if (!params.el) return;
    let $el = dom(params.el);
    if ($el.length === 0) return;

    if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1) {
      $el = swiper.$el.find(params.el); // check if it belongs to another nested Swiper

      if ($el.length > 1) {
        $el = $el.filter(el => {
          if (dom(el).parents('.swiper')[0] !== swiper.el) return false;
          return true;
        });
      }
    }

    if (params.type === 'bullets' && params.clickable) {
      $el.addClass(params.clickableClass);
    }

    $el.addClass(params.modifierClass + params.type);
    $el.addClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);

    if (params.type === 'bullets' && params.dynamicBullets) {
      $el.addClass(`${params.modifierClass}${params.type}-dynamic`);
      dynamicBulletIndex = 0;

      if (params.dynamicMainBullets < 1) {
        params.dynamicMainBullets = 1;
      }
    }

    if (params.type === 'progressbar' && params.progressbarOpposite) {
      $el.addClass(params.progressbarOppositeClass);
    }

    if (params.clickable) {
      $el.on('click', classes_to_selector_classesToSelector(params.bulletClass), function onClick(e) {
        e.preventDefault();
        let index = dom(this).index() * swiper.params.slidesPerGroup;
        if (swiper.params.loop) index += swiper.loopedSlides;
        swiper.slideTo(index);
      });
    }

    Object.assign(swiper.pagination, {
      $el,
      el: $el[0]
    });

    if (!swiper.enabled) {
      $el.addClass(params.lockClass);
    }
  }

  function destroy() {
    const params = swiper.params.pagination;
    if (isPaginationDisabled()) return;
    const $el = swiper.pagination.$el;
    $el.removeClass(params.hiddenClass);
    $el.removeClass(params.modifierClass + params.type);
    $el.removeClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
    if (swiper.pagination.bullets && swiper.pagination.bullets.removeClass) swiper.pagination.bullets.removeClass(params.bulletActiveClass);

    if (params.clickable) {
      $el.off('click', classes_to_selector_classesToSelector(params.bulletClass));
    }
  }

  on('init', () => {
    if (swiper.params.pagination.enabled === false) {
      // eslint-disable-next-line
      disable();
    } else {
      init();
      render();
      update();
    }
  });
  on('activeIndexChange', () => {
    if (swiper.params.loop) {
      update();
    } else if (typeof swiper.snapIndex === 'undefined') {
      update();
    }
  });
  on('snapIndexChange', () => {
    if (!swiper.params.loop) {
      update();
    }
  });
  on('slidesLengthChange', () => {
    if (swiper.params.loop) {
      render();
      update();
    }
  });
  on('snapGridLengthChange', () => {
    if (!swiper.params.loop) {
      render();
      update();
    }
  });
  on('destroy', () => {
    destroy();
  });
  on('enable disable', () => {
    const {
      $el
    } = swiper.pagination;

    if ($el) {
      $el[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.pagination.lockClass);
    }
  });
  on('lock unlock', () => {
    update();
  });
  on('click', (_s, e) => {
    const targetEl = e.target;
    const {
      $el
    } = swiper.pagination;

    if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && $el && $el.length > 0 && !dom(targetEl).hasClass(swiper.params.pagination.bulletClass)) {
      if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
      const isHidden = $el.hasClass(swiper.params.pagination.hiddenClass);

      if (isHidden === true) {
        emit('paginationShow');
      } else {
        emit('paginationHide');
      }

      $el.toggleClass(swiper.params.pagination.hiddenClass);
    }
  });

  const enable = () => {
    swiper.$el.removeClass(swiper.params.pagination.paginationDisabledClass);

    if (swiper.pagination.$el) {
      swiper.pagination.$el.removeClass(swiper.params.pagination.paginationDisabledClass);
    }

    init();
    render();
    update();
  };

  const disable = () => {
    swiper.$el.addClass(swiper.params.pagination.paginationDisabledClass);

    if (swiper.pagination.$el) {
      swiper.pagination.$el.addClass(swiper.params.pagination.paginationDisabledClass);
    }

    destroy();
  };

  Object.assign(swiper.pagination, {
    enable,
    disable,
    render,
    update,
    init,
    destroy
  });
}
;// CONCATENATED MODULE: ./node_modules/swiper/modules/scrollbar/scrollbar.js




function Scrollbar({
  swiper,
  extendParams,
  on,
  emit
}) {
  const document = getDocument();
  let isTouched = false;
  let timeout = null;
  let dragTimeout = null;
  let dragStartPos;
  let dragSize;
  let trackSize;
  let divider;
  extendParams({
    scrollbar: {
      el: null,
      dragSize: 'auto',
      hide: false,
      draggable: false,
      snapOnRelease: true,
      lockClass: 'swiper-scrollbar-lock',
      dragClass: 'swiper-scrollbar-drag',
      scrollbarDisabledClass: 'swiper-scrollbar-disabled',
      horizontalClass: `swiper-scrollbar-horizontal`,
      verticalClass: `swiper-scrollbar-vertical`
    }
  });
  swiper.scrollbar = {
    el: null,
    dragEl: null,
    $el: null,
    $dragEl: null
  };

  function setTranslate() {
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
    const {
      scrollbar,
      rtlTranslate: rtl,
      progress
    } = swiper;
    const {
      $dragEl,
      $el
    } = scrollbar;
    const params = swiper.params.scrollbar;
    let newSize = dragSize;
    let newPos = (trackSize - dragSize) * progress;

    if (rtl) {
      newPos = -newPos;

      if (newPos > 0) {
        newSize = dragSize - newPos;
        newPos = 0;
      } else if (-newPos + dragSize > trackSize) {
        newSize = trackSize + newPos;
      }
    } else if (newPos < 0) {
      newSize = dragSize + newPos;
      newPos = 0;
    } else if (newPos + dragSize > trackSize) {
      newSize = trackSize - newPos;
    }

    if (swiper.isHorizontal()) {
      $dragEl.transform(`translate3d(${newPos}px, 0, 0)`);
      $dragEl[0].style.width = `${newSize}px`;
    } else {
      $dragEl.transform(`translate3d(0px, ${newPos}px, 0)`);
      $dragEl[0].style.height = `${newSize}px`;
    }

    if (params.hide) {
      clearTimeout(timeout);
      $el[0].style.opacity = 1;
      timeout = setTimeout(() => {
        $el[0].style.opacity = 0;
        $el.transition(400);
      }, 1000);
    }
  }

  function setTransition(duration) {
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
    swiper.scrollbar.$dragEl.transition(duration);
  }

  function updateSize() {
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
    const {
      scrollbar
    } = swiper;
    const {
      $dragEl,
      $el
    } = scrollbar;
    $dragEl[0].style.width = '';
    $dragEl[0].style.height = '';
    trackSize = swiper.isHorizontal() ? $el[0].offsetWidth : $el[0].offsetHeight;
    divider = swiper.size / (swiper.virtualSize + swiper.params.slidesOffsetBefore - (swiper.params.centeredSlides ? swiper.snapGrid[0] : 0));

    if (swiper.params.scrollbar.dragSize === 'auto') {
      dragSize = trackSize * divider;
    } else {
      dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
    }

    if (swiper.isHorizontal()) {
      $dragEl[0].style.width = `${dragSize}px`;
    } else {
      $dragEl[0].style.height = `${dragSize}px`;
    }

    if (divider >= 1) {
      $el[0].style.display = 'none';
    } else {
      $el[0].style.display = '';
    }

    if (swiper.params.scrollbar.hide) {
      $el[0].style.opacity = 0;
    }

    if (swiper.params.watchOverflow && swiper.enabled) {
      scrollbar.$el[swiper.isLocked ? 'addClass' : 'removeClass'](swiper.params.scrollbar.lockClass);
    }
  }

  function getPointerPosition(e) {
    if (swiper.isHorizontal()) {
      return e.type === 'touchstart' || e.type === 'touchmove' ? e.targetTouches[0].clientX : e.clientX;
    }

    return e.type === 'touchstart' || e.type === 'touchmove' ? e.targetTouches[0].clientY : e.clientY;
  }

  function setDragPosition(e) {
    const {
      scrollbar,
      rtlTranslate: rtl
    } = swiper;
    const {
      $el
    } = scrollbar;
    let positionRatio;
    positionRatio = (getPointerPosition(e) - $el.offset()[swiper.isHorizontal() ? 'left' : 'top'] - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
    positionRatio = Math.max(Math.min(positionRatio, 1), 0);

    if (rtl) {
      positionRatio = 1 - positionRatio;
    }

    const position = swiper.minTranslate() + (swiper.maxTranslate() - swiper.minTranslate()) * positionRatio;
    swiper.updateProgress(position);
    swiper.setTranslate(position);
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  }

  function onDragStart(e) {
    const params = swiper.params.scrollbar;
    const {
      scrollbar,
      $wrapperEl
    } = swiper;
    const {
      $el,
      $dragEl
    } = scrollbar;
    isTouched = true;
    dragStartPos = e.target === $dragEl[0] || e.target === $dragEl ? getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? 'left' : 'top'] : null;
    e.preventDefault();
    e.stopPropagation();
    $wrapperEl.transition(100);
    $dragEl.transition(100);
    setDragPosition(e);
    clearTimeout(dragTimeout);
    $el.transition(0);

    if (params.hide) {
      $el.css('opacity', 1);
    }

    if (swiper.params.cssMode) {
      swiper.$wrapperEl.css('scroll-snap-type', 'none');
    }

    emit('scrollbarDragStart', e);
  }

  function onDragMove(e) {
    const {
      scrollbar,
      $wrapperEl
    } = swiper;
    const {
      $el,
      $dragEl
    } = scrollbar;
    if (!isTouched) return;
    if (e.preventDefault) e.preventDefault();else e.returnValue = false;
    setDragPosition(e);
    $wrapperEl.transition(0);
    $el.transition(0);
    $dragEl.transition(0);
    emit('scrollbarDragMove', e);
  }

  function onDragEnd(e) {
    const params = swiper.params.scrollbar;
    const {
      scrollbar,
      $wrapperEl
    } = swiper;
    const {
      $el
    } = scrollbar;
    if (!isTouched) return;
    isTouched = false;

    if (swiper.params.cssMode) {
      swiper.$wrapperEl.css('scroll-snap-type', '');
      $wrapperEl.transition('');
    }

    if (params.hide) {
      clearTimeout(dragTimeout);
      dragTimeout = nextTick(() => {
        $el.css('opacity', 0);
        $el.transition(400);
      }, 1000);
    }

    emit('scrollbarDragEnd', e);

    if (params.snapOnRelease) {
      swiper.slideToClosest();
    }
  }

  function events(method) {
    const {
      scrollbar,
      touchEventsTouch,
      touchEventsDesktop,
      params,
      support
    } = swiper;
    const $el = scrollbar.$el;
    if (!$el) return;
    const target = $el[0];
    const activeListener = support.passiveListener && params.passiveListeners ? {
      passive: false,
      capture: false
    } : false;
    const passiveListener = support.passiveListener && params.passiveListeners ? {
      passive: true,
      capture: false
    } : false;
    if (!target) return;
    const eventMethod = method === 'on' ? 'addEventListener' : 'removeEventListener';

    if (!support.touch) {
      target[eventMethod](touchEventsDesktop.start, onDragStart, activeListener);
      document[eventMethod](touchEventsDesktop.move, onDragMove, activeListener);
      document[eventMethod](touchEventsDesktop.end, onDragEnd, passiveListener);
    } else {
      target[eventMethod](touchEventsTouch.start, onDragStart, activeListener);
      target[eventMethod](touchEventsTouch.move, onDragMove, activeListener);
      target[eventMethod](touchEventsTouch.end, onDragEnd, passiveListener);
    }
  }

  function enableDraggable() {
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
    events('on');
  }

  function disableDraggable() {
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
    events('off');
  }

  function init() {
    const {
      scrollbar,
      $el: $swiperEl
    } = swiper;
    swiper.params.scrollbar = createElementIfNotDefined(swiper, swiper.originalParams.scrollbar, swiper.params.scrollbar, {
      el: 'swiper-scrollbar'
    });
    const params = swiper.params.scrollbar;
    if (!params.el) return;
    let $el = $(params.el);

    if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1 && $swiperEl.find(params.el).length === 1) {
      $el = $swiperEl.find(params.el);
    }

    $el.addClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
    let $dragEl = $el.find(`.${swiper.params.scrollbar.dragClass}`);

    if ($dragEl.length === 0) {
      $dragEl = $(`<div class="${swiper.params.scrollbar.dragClass}"></div>`);
      $el.append($dragEl);
    }

    Object.assign(scrollbar, {
      $el,
      el: $el[0],
      $dragEl,
      dragEl: $dragEl[0]
    });

    if (params.draggable) {
      enableDraggable();
    }

    if ($el) {
      $el[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.scrollbar.lockClass);
    }
  }

  function destroy() {
    const params = swiper.params.scrollbar;
    const $el = swiper.scrollbar.$el;

    if ($el) {
      $el.removeClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
    }

    disableDraggable();
  }

  on('init', () => {
    if (swiper.params.scrollbar.enabled === false) {
      // eslint-disable-next-line
      disable();
    } else {
      init();
      updateSize();
      setTranslate();
    }
  });
  on('update resize observerUpdate lock unlock', () => {
    updateSize();
  });
  on('setTranslate', () => {
    setTranslate();
  });
  on('setTransition', (_s, duration) => {
    setTransition(duration);
  });
  on('enable disable', () => {
    const {
      $el
    } = swiper.scrollbar;

    if ($el) {
      $el[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.scrollbar.lockClass);
    }
  });
  on('destroy', () => {
    destroy();
  });

  const enable = () => {
    swiper.$el.removeClass(swiper.params.scrollbar.scrollbarDisabledClass);

    if (swiper.scrollbar.$el) {
      swiper.scrollbar.$el.removeClass(swiper.params.scrollbar.scrollbarDisabledClass);
    }

    init();
    updateSize();
    setTranslate();
  };

  const disable = () => {
    swiper.$el.addClass(swiper.params.scrollbar.scrollbarDisabledClass);

    if (swiper.scrollbar.$el) {
      swiper.scrollbar.$el.addClass(swiper.params.scrollbar.scrollbarDisabledClass);
    }

    destroy();
  };

  Object.assign(swiper.scrollbar, {
    enable,
    disable,
    updateSize,
    setTranslate,
    init,
    destroy
  });
}
;// CONCATENATED MODULE: ./node_modules/swiper/modules/parallax/parallax.js

function Parallax({
  swiper,
  extendParams,
  on
}) {
  extendParams({
    parallax: {
      enabled: false
    }
  });

  const setTransform = (el, progress) => {
    const {
      rtl
    } = swiper;
    const $el = $(el);
    const rtlFactor = rtl ? -1 : 1;
    const p = $el.attr('data-swiper-parallax') || '0';
    let x = $el.attr('data-swiper-parallax-x');
    let y = $el.attr('data-swiper-parallax-y');
    const scale = $el.attr('data-swiper-parallax-scale');
    const opacity = $el.attr('data-swiper-parallax-opacity');

    if (x || y) {
      x = x || '0';
      y = y || '0';
    } else if (swiper.isHorizontal()) {
      x = p;
      y = '0';
    } else {
      y = p;
      x = '0';
    }

    if (x.indexOf('%') >= 0) {
      x = `${parseInt(x, 10) * progress * rtlFactor}%`;
    } else {
      x = `${x * progress * rtlFactor}px`;
    }

    if (y.indexOf('%') >= 0) {
      y = `${parseInt(y, 10) * progress}%`;
    } else {
      y = `${y * progress}px`;
    }

    if (typeof opacity !== 'undefined' && opacity !== null) {
      const currentOpacity = opacity - (opacity - 1) * (1 - Math.abs(progress));
      $el[0].style.opacity = currentOpacity;
    }

    if (typeof scale === 'undefined' || scale === null) {
      $el.transform(`translate3d(${x}, ${y}, 0px)`);
    } else {
      const currentScale = scale - (scale - 1) * (1 - Math.abs(progress));
      $el.transform(`translate3d(${x}, ${y}, 0px) scale(${currentScale})`);
    }
  };

  const setTranslate = () => {
    const {
      $el,
      slides,
      progress,
      snapGrid
    } = swiper;
    $el.children('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each(el => {
      setTransform(el, progress);
    });
    slides.each((slideEl, slideIndex) => {
      let slideProgress = slideEl.progress;

      if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== 'auto') {
        slideProgress += Math.ceil(slideIndex / 2) - progress * (snapGrid.length - 1);
      }

      slideProgress = Math.min(Math.max(slideProgress, -1), 1);
      $(slideEl).find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each(el => {
        setTransform(el, slideProgress);
      });
    });
  };

  const setTransition = (duration = swiper.params.speed) => {
    const {
      $el
    } = swiper;
    $el.find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each(parallaxEl => {
      const $parallaxEl = $(parallaxEl);
      let parallaxDuration = parseInt($parallaxEl.attr('data-swiper-parallax-duration'), 10) || duration;
      if (duration === 0) parallaxDuration = 0;
      $parallaxEl.transition(parallaxDuration);
    });
  };

  on('beforeInit', () => {
    if (!swiper.params.parallax.enabled) return;
    swiper.params.watchSlidesProgress = true;
    swiper.originalParams.watchSlidesProgress = true;
  });
  on('init', () => {
    if (!swiper.params.parallax.enabled) return;
    setTranslate();
  });
  on('setTranslate', () => {
    if (!swiper.params.parallax.enabled) return;
    setTranslate();
  });
  on('setTransition', (_swiper, duration) => {
    if (!swiper.params.parallax.enabled) return;
    setTransition(duration);
  });
}
;// CONCATENATED MODULE: ./node_modules/swiper/modules/zoom/zoom.js



function Zoom({
  swiper,
  extendParams,
  on,
  emit
}) {
  const window = getWindow();
  extendParams({
    zoom: {
      enabled: false,
      maxRatio: 3,
      minRatio: 1,
      toggle: true,
      containerClass: 'swiper-zoom-container',
      zoomedSlideClass: 'swiper-slide-zoomed'
    }
  });
  swiper.zoom = {
    enabled: false
  };
  let currentScale = 1;
  let isScaling = false;
  let gesturesEnabled;
  let fakeGestureTouched;
  let fakeGestureMoved;
  const gesture = {
    $slideEl: undefined,
    slideWidth: undefined,
    slideHeight: undefined,
    $imageEl: undefined,
    $imageWrapEl: undefined,
    maxRatio: 3
  };
  const image = {
    isTouched: undefined,
    isMoved: undefined,
    currentX: undefined,
    currentY: undefined,
    minX: undefined,
    minY: undefined,
    maxX: undefined,
    maxY: undefined,
    width: undefined,
    height: undefined,
    startX: undefined,
    startY: undefined,
    touchesStart: {},
    touchesCurrent: {}
  };
  const velocity = {
    x: undefined,
    y: undefined,
    prevPositionX: undefined,
    prevPositionY: undefined,
    prevTime: undefined
  };
  let scale = 1;
  Object.defineProperty(swiper.zoom, 'scale', {
    get() {
      return scale;
    },

    set(value) {
      if (scale !== value) {
        const imageEl = gesture.$imageEl ? gesture.$imageEl[0] : undefined;
        const slideEl = gesture.$slideEl ? gesture.$slideEl[0] : undefined;
        emit('zoomChange', value, imageEl, slideEl);
      }

      scale = value;
    }

  });

  function getDistanceBetweenTouches(e) {
    if (e.targetTouches.length < 2) return 1;
    const x1 = e.targetTouches[0].pageX;
    const y1 = e.targetTouches[0].pageY;
    const x2 = e.targetTouches[1].pageX;
    const y2 = e.targetTouches[1].pageY;
    const distance = Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);
    return distance;
  } // Events


  function onGestureStart(e) {
    const support = swiper.support;
    const params = swiper.params.zoom;
    fakeGestureTouched = false;
    fakeGestureMoved = false;

    if (!support.gestures) {
      if (e.type !== 'touchstart' || e.type === 'touchstart' && e.targetTouches.length < 2) {
        return;
      }

      fakeGestureTouched = true;
      gesture.scaleStart = getDistanceBetweenTouches(e);
    }

    if (!gesture.$slideEl || !gesture.$slideEl.length) {
      gesture.$slideEl = $(e.target).closest(`.${swiper.params.slideClass}`);
      if (gesture.$slideEl.length === 0) gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
      gesture.$imageEl = gesture.$slideEl.find(`.${params.containerClass}`).eq(0).find('picture, img, svg, canvas, .swiper-zoom-target').eq(0);
      gesture.$imageWrapEl = gesture.$imageEl.parent(`.${params.containerClass}`);
      gesture.maxRatio = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;

      if (gesture.$imageWrapEl.length === 0) {
        gesture.$imageEl = undefined;
        return;
      }
    }

    if (gesture.$imageEl) {
      gesture.$imageEl.transition(0);
    }

    isScaling = true;
  }

  function onGestureChange(e) {
    const support = swiper.support;
    const params = swiper.params.zoom;
    const zoom = swiper.zoom;

    if (!support.gestures) {
      if (e.type !== 'touchmove' || e.type === 'touchmove' && e.targetTouches.length < 2) {
        return;
      }

      fakeGestureMoved = true;
      gesture.scaleMove = getDistanceBetweenTouches(e);
    }

    if (!gesture.$imageEl || gesture.$imageEl.length === 0) {
      if (e.type === 'gesturechange') onGestureStart(e);
      return;
    }

    if (support.gestures) {
      zoom.scale = e.scale * currentScale;
    } else {
      zoom.scale = gesture.scaleMove / gesture.scaleStart * currentScale;
    }

    if (zoom.scale > gesture.maxRatio) {
      zoom.scale = gesture.maxRatio - 1 + (zoom.scale - gesture.maxRatio + 1) ** 0.5;
    }

    if (zoom.scale < params.minRatio) {
      zoom.scale = params.minRatio + 1 - (params.minRatio - zoom.scale + 1) ** 0.5;
    }

    gesture.$imageEl.transform(`translate3d(0,0,0) scale(${zoom.scale})`);
  }

  function onGestureEnd(e) {
    const device = swiper.device;
    const support = swiper.support;
    const params = swiper.params.zoom;
    const zoom = swiper.zoom;

    if (!support.gestures) {
      if (!fakeGestureTouched || !fakeGestureMoved) {
        return;
      }

      if (e.type !== 'touchend' || e.type === 'touchend' && e.changedTouches.length < 2 && !device.android) {
        return;
      }

      fakeGestureTouched = false;
      fakeGestureMoved = false;
    }

    if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
    zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
    gesture.$imageEl.transition(swiper.params.speed).transform(`translate3d(0,0,0) scale(${zoom.scale})`);
    currentScale = zoom.scale;
    isScaling = false;
    if (zoom.scale === 1) gesture.$slideEl = undefined;
  }

  function onTouchStart(e) {
    const device = swiper.device;
    if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
    if (image.isTouched) return;
    if (device.android && e.cancelable) e.preventDefault();
    image.isTouched = true;
    image.touchesStart.x = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
    image.touchesStart.y = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
  }

  function onTouchMove(e) {
    const zoom = swiper.zoom;
    if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
    swiper.allowClick = false;
    if (!image.isTouched || !gesture.$slideEl) return;

    if (!image.isMoved) {
      image.width = gesture.$imageEl[0].offsetWidth;
      image.height = gesture.$imageEl[0].offsetHeight;
      image.startX = getTranslate(gesture.$imageWrapEl[0], 'x') || 0;
      image.startY = getTranslate(gesture.$imageWrapEl[0], 'y') || 0;
      gesture.slideWidth = gesture.$slideEl[0].offsetWidth;
      gesture.slideHeight = gesture.$slideEl[0].offsetHeight;
      gesture.$imageWrapEl.transition(0);
    } // Define if we need image drag


    const scaledWidth = image.width * zoom.scale;
    const scaledHeight = image.height * zoom.scale;
    if (scaledWidth < gesture.slideWidth && scaledHeight < gesture.slideHeight) return;
    image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
    image.maxX = -image.minX;
    image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
    image.maxY = -image.minY;
    image.touchesCurrent.x = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
    image.touchesCurrent.y = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;

    if (!image.isMoved && !isScaling) {
      if (swiper.isHorizontal() && (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x || Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)) {
        image.isTouched = false;
        return;
      }

      if (!swiper.isHorizontal() && (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y || Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)) {
        image.isTouched = false;
        return;
      }
    }

    if (e.cancelable) {
      e.preventDefault();
    }

    e.stopPropagation();
    image.isMoved = true;
    image.currentX = image.touchesCurrent.x - image.touchesStart.x + image.startX;
    image.currentY = image.touchesCurrent.y - image.touchesStart.y + image.startY;

    if (image.currentX < image.minX) {
      image.currentX = image.minX + 1 - (image.minX - image.currentX + 1) ** 0.8;
    }

    if (image.currentX > image.maxX) {
      image.currentX = image.maxX - 1 + (image.currentX - image.maxX + 1) ** 0.8;
    }

    if (image.currentY < image.minY) {
      image.currentY = image.minY + 1 - (image.minY - image.currentY + 1) ** 0.8;
    }

    if (image.currentY > image.maxY) {
      image.currentY = image.maxY - 1 + (image.currentY - image.maxY + 1) ** 0.8;
    } // Velocity


    if (!velocity.prevPositionX) velocity.prevPositionX = image.touchesCurrent.x;
    if (!velocity.prevPositionY) velocity.prevPositionY = image.touchesCurrent.y;
    if (!velocity.prevTime) velocity.prevTime = Date.now();
    velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
    velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
    if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) velocity.x = 0;
    if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) velocity.y = 0;
    velocity.prevPositionX = image.touchesCurrent.x;
    velocity.prevPositionY = image.touchesCurrent.y;
    velocity.prevTime = Date.now();
    gesture.$imageWrapEl.transform(`translate3d(${image.currentX}px, ${image.currentY}px,0)`);
  }

  function onTouchEnd() {
    const zoom = swiper.zoom;
    if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;

    if (!image.isTouched || !image.isMoved) {
      image.isTouched = false;
      image.isMoved = false;
      return;
    }

    image.isTouched = false;
    image.isMoved = false;
    let momentumDurationX = 300;
    let momentumDurationY = 300;
    const momentumDistanceX = velocity.x * momentumDurationX;
    const newPositionX = image.currentX + momentumDistanceX;
    const momentumDistanceY = velocity.y * momentumDurationY;
    const newPositionY = image.currentY + momentumDistanceY; // Fix duration

    if (velocity.x !== 0) momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x);
    if (velocity.y !== 0) momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y);
    const momentumDuration = Math.max(momentumDurationX, momentumDurationY);
    image.currentX = newPositionX;
    image.currentY = newPositionY; // Define if we need image drag

    const scaledWidth = image.width * zoom.scale;
    const scaledHeight = image.height * zoom.scale;
    image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
    image.maxX = -image.minX;
    image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
    image.maxY = -image.minY;
    image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
    image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);
    gesture.$imageWrapEl.transition(momentumDuration).transform(`translate3d(${image.currentX}px, ${image.currentY}px,0)`);
  }

  function onTransitionEnd() {
    const zoom = swiper.zoom;

    if (gesture.$slideEl && swiper.previousIndex !== swiper.activeIndex) {
      if (gesture.$imageEl) {
        gesture.$imageEl.transform('translate3d(0,0,0) scale(1)');
      }

      if (gesture.$imageWrapEl) {
        gesture.$imageWrapEl.transform('translate3d(0,0,0)');
      }

      zoom.scale = 1;
      currentScale = 1;
      gesture.$slideEl = undefined;
      gesture.$imageEl = undefined;
      gesture.$imageWrapEl = undefined;
    }
  }

  function zoomIn(e) {
    const zoom = swiper.zoom;
    const params = swiper.params.zoom;

    if (!gesture.$slideEl) {
      if (e && e.target) {
        gesture.$slideEl = $(e.target).closest(`.${swiper.params.slideClass}`);
      }

      if (!gesture.$slideEl) {
        if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) {
          gesture.$slideEl = swiper.$wrapperEl.children(`.${swiper.params.slideActiveClass}`);
        } else {
          gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
        }
      }

      gesture.$imageEl = gesture.$slideEl.find(`.${params.containerClass}`).eq(0).find('picture, img, svg, canvas, .swiper-zoom-target').eq(0);
      gesture.$imageWrapEl = gesture.$imageEl.parent(`.${params.containerClass}`);
    }

    if (!gesture.$imageEl || gesture.$imageEl.length === 0 || !gesture.$imageWrapEl || gesture.$imageWrapEl.length === 0) return;

    if (swiper.params.cssMode) {
      swiper.wrapperEl.style.overflow = 'hidden';
      swiper.wrapperEl.style.touchAction = 'none';
    }

    gesture.$slideEl.addClass(`${params.zoomedSlideClass}`);
    let touchX;
    let touchY;
    let offsetX;
    let offsetY;
    let diffX;
    let diffY;
    let translateX;
    let translateY;
    let imageWidth;
    let imageHeight;
    let scaledWidth;
    let scaledHeight;
    let translateMinX;
    let translateMinY;
    let translateMaxX;
    let translateMaxY;
    let slideWidth;
    let slideHeight;

    if (typeof image.touchesStart.x === 'undefined' && e) {
      touchX = e.type === 'touchend' ? e.changedTouches[0].pageX : e.pageX;
      touchY = e.type === 'touchend' ? e.changedTouches[0].pageY : e.pageY;
    } else {
      touchX = image.touchesStart.x;
      touchY = image.touchesStart.y;
    }

    zoom.scale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
    currentScale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;

    if (e) {
      slideWidth = gesture.$slideEl[0].offsetWidth;
      slideHeight = gesture.$slideEl[0].offsetHeight;
      offsetX = gesture.$slideEl.offset().left + window.scrollX;
      offsetY = gesture.$slideEl.offset().top + window.scrollY;
      diffX = offsetX + slideWidth / 2 - touchX;
      diffY = offsetY + slideHeight / 2 - touchY;
      imageWidth = gesture.$imageEl[0].offsetWidth;
      imageHeight = gesture.$imageEl[0].offsetHeight;
      scaledWidth = imageWidth * zoom.scale;
      scaledHeight = imageHeight * zoom.scale;
      translateMinX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
      translateMinY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
      translateMaxX = -translateMinX;
      translateMaxY = -translateMinY;
      translateX = diffX * zoom.scale;
      translateY = diffY * zoom.scale;

      if (translateX < translateMinX) {
        translateX = translateMinX;
      }

      if (translateX > translateMaxX) {
        translateX = translateMaxX;
      }

      if (translateY < translateMinY) {
        translateY = translateMinY;
      }

      if (translateY > translateMaxY) {
        translateY = translateMaxY;
      }
    } else {
      translateX = 0;
      translateY = 0;
    }

    gesture.$imageWrapEl.transition(300).transform(`translate3d(${translateX}px, ${translateY}px,0)`);
    gesture.$imageEl.transition(300).transform(`translate3d(0,0,0) scale(${zoom.scale})`);
  }

  function zoomOut() {
    const zoom = swiper.zoom;
    const params = swiper.params.zoom;

    if (!gesture.$slideEl) {
      if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) {
        gesture.$slideEl = swiper.$wrapperEl.children(`.${swiper.params.slideActiveClass}`);
      } else {
        gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
      }

      gesture.$imageEl = gesture.$slideEl.find(`.${params.containerClass}`).eq(0).find('picture, img, svg, canvas, .swiper-zoom-target').eq(0);
      gesture.$imageWrapEl = gesture.$imageEl.parent(`.${params.containerClass}`);
    }

    if (!gesture.$imageEl || gesture.$imageEl.length === 0 || !gesture.$imageWrapEl || gesture.$imageWrapEl.length === 0) return;

    if (swiper.params.cssMode) {
      swiper.wrapperEl.style.overflow = '';
      swiper.wrapperEl.style.touchAction = '';
    }

    zoom.scale = 1;
    currentScale = 1;
    gesture.$imageWrapEl.transition(300).transform('translate3d(0,0,0)');
    gesture.$imageEl.transition(300).transform('translate3d(0,0,0) scale(1)');
    gesture.$slideEl.removeClass(`${params.zoomedSlideClass}`);
    gesture.$slideEl = undefined;
  } // Toggle Zoom


  function zoomToggle(e) {
    const zoom = swiper.zoom;

    if (zoom.scale && zoom.scale !== 1) {
      // Zoom Out
      zoomOut();
    } else {
      // Zoom In
      zoomIn(e);
    }
  }

  function getListeners() {
    const support = swiper.support;
    const passiveListener = swiper.touchEvents.start === 'touchstart' && support.passiveListener && swiper.params.passiveListeners ? {
      passive: true,
      capture: false
    } : false;
    const activeListenerWithCapture = support.passiveListener ? {
      passive: false,
      capture: true
    } : true;
    return {
      passiveListener,
      activeListenerWithCapture
    };
  }

  function getSlideSelector() {
    return `.${swiper.params.slideClass}`;
  }

  function toggleGestures(method) {
    const {
      passiveListener
    } = getListeners();
    const slideSelector = getSlideSelector();
    swiper.$wrapperEl[method]('gesturestart', slideSelector, onGestureStart, passiveListener);
    swiper.$wrapperEl[method]('gesturechange', slideSelector, onGestureChange, passiveListener);
    swiper.$wrapperEl[method]('gestureend', slideSelector, onGestureEnd, passiveListener);
  }

  function enableGestures() {
    if (gesturesEnabled) return;
    gesturesEnabled = true;
    toggleGestures('on');
  }

  function disableGestures() {
    if (!gesturesEnabled) return;
    gesturesEnabled = false;
    toggleGestures('off');
  } // Attach/Detach Events


  function enable() {
    const zoom = swiper.zoom;
    if (zoom.enabled) return;
    zoom.enabled = true;
    const support = swiper.support;
    const {
      passiveListener,
      activeListenerWithCapture
    } = getListeners();
    const slideSelector = getSlideSelector(); // Scale image

    if (support.gestures) {
      swiper.$wrapperEl.on(swiper.touchEvents.start, enableGestures, passiveListener);
      swiper.$wrapperEl.on(swiper.touchEvents.end, disableGestures, passiveListener);
    } else if (swiper.touchEvents.start === 'touchstart') {
      swiper.$wrapperEl.on(swiper.touchEvents.start, slideSelector, onGestureStart, passiveListener);
      swiper.$wrapperEl.on(swiper.touchEvents.move, slideSelector, onGestureChange, activeListenerWithCapture);
      swiper.$wrapperEl.on(swiper.touchEvents.end, slideSelector, onGestureEnd, passiveListener);

      if (swiper.touchEvents.cancel) {
        swiper.$wrapperEl.on(swiper.touchEvents.cancel, slideSelector, onGestureEnd, passiveListener);
      }
    } // Move image


    swiper.$wrapperEl.on(swiper.touchEvents.move, `.${swiper.params.zoom.containerClass}`, onTouchMove, activeListenerWithCapture);
  }

  function disable() {
    const zoom = swiper.zoom;
    if (!zoom.enabled) return;
    const support = swiper.support;
    zoom.enabled = false;
    const {
      passiveListener,
      activeListenerWithCapture
    } = getListeners();
    const slideSelector = getSlideSelector(); // Scale image

    if (support.gestures) {
      swiper.$wrapperEl.off(swiper.touchEvents.start, enableGestures, passiveListener);
      swiper.$wrapperEl.off(swiper.touchEvents.end, disableGestures, passiveListener);
    } else if (swiper.touchEvents.start === 'touchstart') {
      swiper.$wrapperEl.off(swiper.touchEvents.start, slideSelector, onGestureStart, passiveListener);
      swiper.$wrapperEl.off(swiper.touchEvents.move, slideSelector, onGestureChange, activeListenerWithCapture);
      swiper.$wrapperEl.off(swiper.touchEvents.end, slideSelector, onGestureEnd, passiveListener);

      if (swiper.touchEvents.cancel) {
        swiper.$wrapperEl.off(swiper.touchEvents.cancel, slideSelector, onGestureEnd, passiveListener);
      }
    } // Move image


    swiper.$wrapperEl.off(swiper.touchEvents.move, `.${swiper.params.zoom.containerClass}`, onTouchMove, activeListenerWithCapture);
  }

  on('init', () => {
    if (swiper.params.zoom.enabled) {
      enable();
    }
  });
  on('destroy', () => {
    disable();
  });
  on('touchStart', (_s, e) => {
    if (!swiper.zoom.enabled) return;
    onTouchStart(e);
  });
  on('touchEnd', (_s, e) => {
    if (!swiper.zoom.enabled) return;
    onTouchEnd(e);
  });
  on('doubleTap', (_s, e) => {
    if (!swiper.animating && swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) {
      zoomToggle(e);
    }
  });
  on('transitionEnd', () => {
    if (swiper.zoom.enabled && swiper.params.zoom.enabled) {
      onTransitionEnd();
    }
  });
  on('slideChange', () => {
    if (swiper.zoom.enabled && swiper.params.zoom.enabled && swiper.params.cssMode) {
      onTransitionEnd();
    }
  });
  Object.assign(swiper.zoom, {
    enable,
    disable,
    in: zoomIn,
    out: zoomOut,
    toggle: zoomToggle
  });
}
;// CONCATENATED MODULE: ./node_modules/swiper/modules/lazy/lazy.js


function Lazy({
  swiper,
  extendParams,
  on,
  emit
}) {
  extendParams({
    lazy: {
      checkInView: false,
      enabled: false,
      loadPrevNext: false,
      loadPrevNextAmount: 1,
      loadOnTransitionStart: false,
      scrollingElement: '',
      elementClass: 'swiper-lazy',
      loadingClass: 'swiper-lazy-loading',
      loadedClass: 'swiper-lazy-loaded',
      preloaderClass: 'swiper-lazy-preloader'
    }
  });
  swiper.lazy = {};
  let scrollHandlerAttached = false;
  let initialImageLoaded = false;

  function loadInSlide(index, loadInDuplicate = true) {
    const params = swiper.params.lazy;
    if (typeof index === 'undefined') return;
    if (swiper.slides.length === 0) return;
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    const $slideEl = isVirtual ? swiper.$wrapperEl.children(`.${swiper.params.slideClass}[data-swiper-slide-index="${index}"]`) : swiper.slides.eq(index);
    const $images = $slideEl.find(`.${params.elementClass}:not(.${params.loadedClass}):not(.${params.loadingClass})`);

    if ($slideEl.hasClass(params.elementClass) && !$slideEl.hasClass(params.loadedClass) && !$slideEl.hasClass(params.loadingClass)) {
      $images.push($slideEl[0]);
    }

    if ($images.length === 0) return;
    $images.each(imageEl => {
      const $imageEl = $(imageEl);
      $imageEl.addClass(params.loadingClass);
      const background = $imageEl.attr('data-background');
      const src = $imageEl.attr('data-src');
      const srcset = $imageEl.attr('data-srcset');
      const sizes = $imageEl.attr('data-sizes');
      const $pictureEl = $imageEl.parent('picture');
      swiper.loadImage($imageEl[0], src || background, srcset, sizes, false, () => {
        if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper && !swiper.params || swiper.destroyed) return;

        if (background) {
          $imageEl.css('background-image', `url("${background}")`);
          $imageEl.removeAttr('data-background');
        } else {
          if (srcset) {
            $imageEl.attr('srcset', srcset);
            $imageEl.removeAttr('data-srcset');
          }

          if (sizes) {
            $imageEl.attr('sizes', sizes);
            $imageEl.removeAttr('data-sizes');
          }

          if ($pictureEl.length) {
            $pictureEl.children('source').each(sourceEl => {
              const $source = $(sourceEl);

              if ($source.attr('data-srcset')) {
                $source.attr('srcset', $source.attr('data-srcset'));
                $source.removeAttr('data-srcset');
              }
            });
          }

          if (src) {
            $imageEl.attr('src', src);
            $imageEl.removeAttr('data-src');
          }
        }

        $imageEl.addClass(params.loadedClass).removeClass(params.loadingClass);
        $slideEl.find(`.${params.preloaderClass}`).remove();

        if (swiper.params.loop && loadInDuplicate) {
          const slideOriginalIndex = $slideEl.attr('data-swiper-slide-index');

          if ($slideEl.hasClass(swiper.params.slideDuplicateClass)) {
            const originalSlide = swiper.$wrapperEl.children(`[data-swiper-slide-index="${slideOriginalIndex}"]:not(.${swiper.params.slideDuplicateClass})`);
            loadInSlide(originalSlide.index(), false);
          } else {
            const duplicatedSlide = swiper.$wrapperEl.children(`.${swiper.params.slideDuplicateClass}[data-swiper-slide-index="${slideOriginalIndex}"]`);
            loadInSlide(duplicatedSlide.index(), false);
          }
        }

        emit('lazyImageReady', $slideEl[0], $imageEl[0]);

        if (swiper.params.autoHeight) {
          swiper.updateAutoHeight();
        }
      });
      emit('lazyImageLoad', $slideEl[0], $imageEl[0]);
    });
  }

  function load() {
    const {
      $wrapperEl,
      params: swiperParams,
      slides,
      activeIndex
    } = swiper;
    const isVirtual = swiper.virtual && swiperParams.virtual.enabled;
    const params = swiperParams.lazy;
    let slidesPerView = swiperParams.slidesPerView;

    if (slidesPerView === 'auto') {
      slidesPerView = 0;
    }

    function slideExist(index) {
      if (isVirtual) {
        if ($wrapperEl.children(`.${swiperParams.slideClass}[data-swiper-slide-index="${index}"]`).length) {
          return true;
        }
      } else if (slides[index]) return true;

      return false;
    }

    function slideIndex(slideEl) {
      if (isVirtual) {
        return $(slideEl).attr('data-swiper-slide-index');
      }

      return $(slideEl).index();
    }

    if (!initialImageLoaded) initialImageLoaded = true;

    if (swiper.params.watchSlidesProgress) {
      $wrapperEl.children(`.${swiperParams.slideVisibleClass}`).each(slideEl => {
        const index = isVirtual ? $(slideEl).attr('data-swiper-slide-index') : $(slideEl).index();
        loadInSlide(index);
      });
    } else if (slidesPerView > 1) {
      for (let i = activeIndex; i < activeIndex + slidesPerView; i += 1) {
        if (slideExist(i)) loadInSlide(i);
      }
    } else {
      loadInSlide(activeIndex);
    }

    if (params.loadPrevNext) {
      if (slidesPerView > 1 || params.loadPrevNextAmount && params.loadPrevNextAmount > 1) {
        const amount = params.loadPrevNextAmount;
        const spv = Math.ceil(slidesPerView);
        const maxIndex = Math.min(activeIndex + spv + Math.max(amount, spv), slides.length);
        const minIndex = Math.max(activeIndex - Math.max(spv, amount), 0); // Next Slides

        for (let i = activeIndex + spv; i < maxIndex; i += 1) {
          if (slideExist(i)) loadInSlide(i);
        } // Prev Slides


        for (let i = minIndex; i < activeIndex; i += 1) {
          if (slideExist(i)) loadInSlide(i);
        }
      } else {
        const nextSlide = $wrapperEl.children(`.${swiperParams.slideNextClass}`);
        if (nextSlide.length > 0) loadInSlide(slideIndex(nextSlide));
        const prevSlide = $wrapperEl.children(`.${swiperParams.slidePrevClass}`);
        if (prevSlide.length > 0) loadInSlide(slideIndex(prevSlide));
      }
    }
  }

  function checkInViewOnLoad() {
    const window = getWindow();
    if (!swiper || swiper.destroyed) return;
    const $scrollElement = swiper.params.lazy.scrollingElement ? $(swiper.params.lazy.scrollingElement) : $(window);
    const isWindow = $scrollElement[0] === window;
    const scrollElementWidth = isWindow ? window.innerWidth : $scrollElement[0].offsetWidth;
    const scrollElementHeight = isWindow ? window.innerHeight : $scrollElement[0].offsetHeight;
    const swiperOffset = swiper.$el.offset();
    const {
      rtlTranslate: rtl
    } = swiper;
    let inView = false;
    if (rtl) swiperOffset.left -= swiper.$el[0].scrollLeft;
    const swiperCoord = [[swiperOffset.left, swiperOffset.top], [swiperOffset.left + swiper.width, swiperOffset.top], [swiperOffset.left, swiperOffset.top + swiper.height], [swiperOffset.left + swiper.width, swiperOffset.top + swiper.height]];

    for (let i = 0; i < swiperCoord.length; i += 1) {
      const point = swiperCoord[i];

      if (point[0] >= 0 && point[0] <= scrollElementWidth && point[1] >= 0 && point[1] <= scrollElementHeight) {
        if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line

        inView = true;
      }
    }

    const passiveListener = swiper.touchEvents.start === 'touchstart' && swiper.support.passiveListener && swiper.params.passiveListeners ? {
      passive: true,
      capture: false
    } : false;

    if (inView) {
      load();
      $scrollElement.off('scroll', checkInViewOnLoad, passiveListener);
    } else if (!scrollHandlerAttached) {
      scrollHandlerAttached = true;
      $scrollElement.on('scroll', checkInViewOnLoad, passiveListener);
    }
  }

  on('beforeInit', () => {
    if (swiper.params.lazy.enabled && swiper.params.preloadImages) {
      swiper.params.preloadImages = false;
    }
  });
  on('init', () => {
    if (swiper.params.lazy.enabled) {
      if (swiper.params.lazy.checkInView) {
        checkInViewOnLoad();
      } else {
        load();
      }
    }
  });
  on('scroll', () => {
    if (swiper.params.freeMode && swiper.params.freeMode.enabled && !swiper.params.freeMode.sticky) {
      load();
    }
  });
  on('scrollbarDragMove resize _freeModeNoMomentumRelease', () => {
    if (swiper.params.lazy.enabled) {
      if (swiper.params.lazy.checkInView) {
        checkInViewOnLoad();
      } else {
        load();
      }
    }
  });
  on('transitionStart', () => {
    if (swiper.params.lazy.enabled) {
      if (swiper.params.lazy.loadOnTransitionStart || !swiper.params.lazy.loadOnTransitionStart && !initialImageLoaded) {
        if (swiper.params.lazy.checkInView) {
          checkInViewOnLoad();
        } else {
          load();
        }
      }
    }
  });
  on('transitionEnd', () => {
    if (swiper.params.lazy.enabled && !swiper.params.lazy.loadOnTransitionStart) {
      if (swiper.params.lazy.checkInView) {
        checkInViewOnLoad();
      } else {
        load();
      }
    }
  });
  on('slideChange', () => {
    const {
      lazy,
      cssMode,
      watchSlidesProgress,
      touchReleaseOnEdges,
      resistanceRatio
    } = swiper.params;

    if (lazy.enabled && (cssMode || watchSlidesProgress && (touchReleaseOnEdges || resistanceRatio === 0))) {
      load();
    }
  });
  on('destroy', () => {
    if (!swiper.$el) return;
    swiper.$el.find(`.${swiper.params.lazy.loadingClass}`).removeClass(swiper.params.lazy.loadingClass);
  });
  Object.assign(swiper.lazy, {
    load,
    loadInSlide
  });
}
;// CONCATENATED MODULE: ./node_modules/swiper/modules/controller/controller.js
/* eslint no-bitwise: ["error", { "allow": [">>"] }] */

function Controller({
  swiper,
  extendParams,
  on
}) {
  extendParams({
    controller: {
      control: undefined,
      inverse: false,
      by: 'slide' // or 'container'

    }
  });
  swiper.controller = {
    control: undefined
  };

  function LinearSpline(x, y) {
    const binarySearch = function search() {
      let maxIndex;
      let minIndex;
      let guess;
      return (array, val) => {
        minIndex = -1;
        maxIndex = array.length;

        while (maxIndex - minIndex > 1) {
          guess = maxIndex + minIndex >> 1;

          if (array[guess] <= val) {
            minIndex = guess;
          } else {
            maxIndex = guess;
          }
        }

        return maxIndex;
      };
    }();

    this.x = x;
    this.y = y;
    this.lastIndex = x.length - 1; // Given an x value (x2), return the expected y2 value:
    // (x1,y1) is the known point before given value,
    // (x3,y3) is the known point after given value.

    let i1;
    let i3;

    this.interpolate = function interpolate(x2) {
      if (!x2) return 0; // Get the indexes of x1 and x3 (the array indexes before and after given x2):

      i3 = binarySearch(this.x, x2);
      i1 = i3 - 1; // We have our indexes i1 & i3, so we can calculate already:
      // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1

      return (x2 - this.x[i1]) * (this.y[i3] - this.y[i1]) / (this.x[i3] - this.x[i1]) + this.y[i1];
    };

    return this;
  } // xxx: for now i will just save one spline function to to


  function getInterpolateFunction(c) {
    if (!swiper.controller.spline) {
      swiper.controller.spline = swiper.params.loop ? new LinearSpline(swiper.slidesGrid, c.slidesGrid) : new LinearSpline(swiper.snapGrid, c.snapGrid);
    }
  }

  function setTranslate(_t, byController) {
    const controlled = swiper.controller.control;
    let multiplier;
    let controlledTranslate;
    const Swiper = swiper.constructor;

    function setControlledTranslate(c) {
      // this will create an Interpolate function based on the snapGrids
      // x is the Grid of the scrolled scroller and y will be the controlled scroller
      // it makes sense to create this only once and recall it for the interpolation
      // the function does a lot of value caching for performance
      const translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;

      if (swiper.params.controller.by === 'slide') {
        getInterpolateFunction(c); // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
        // but it did not work out

        controlledTranslate = -swiper.controller.spline.interpolate(-translate);
      }

      if (!controlledTranslate || swiper.params.controller.by === 'container') {
        multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
        controlledTranslate = (translate - swiper.minTranslate()) * multiplier + c.minTranslate();
      }

      if (swiper.params.controller.inverse) {
        controlledTranslate = c.maxTranslate() - controlledTranslate;
      }

      c.updateProgress(controlledTranslate);
      c.setTranslate(controlledTranslate, swiper);
      c.updateActiveIndex();
      c.updateSlidesClasses();
    }

    if (Array.isArray(controlled)) {
      for (let i = 0; i < controlled.length; i += 1) {
        if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
          setControlledTranslate(controlled[i]);
        }
      }
    } else if (controlled instanceof Swiper && byController !== controlled) {
      setControlledTranslate(controlled);
    }
  }

  function setTransition(duration, byController) {
    const Swiper = swiper.constructor;
    const controlled = swiper.controller.control;
    let i;

    function setControlledTransition(c) {
      c.setTransition(duration, swiper);

      if (duration !== 0) {
        c.transitionStart();

        if (c.params.autoHeight) {
          nextTick(() => {
            c.updateAutoHeight();
          });
        }

        c.$wrapperEl.transitionEnd(() => {
          if (!controlled) return;

          if (c.params.loop && swiper.params.controller.by === 'slide') {
            c.loopFix();
          }

          c.transitionEnd();
        });
      }
    }

    if (Array.isArray(controlled)) {
      for (i = 0; i < controlled.length; i += 1) {
        if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
          setControlledTransition(controlled[i]);
        }
      }
    } else if (controlled instanceof Swiper && byController !== controlled) {
      setControlledTransition(controlled);
    }
  }

  function removeSpline() {
    if (!swiper.controller.control) return;

    if (swiper.controller.spline) {
      swiper.controller.spline = undefined;
      delete swiper.controller.spline;
    }
  }

  on('beforeInit', () => {
    swiper.controller.control = swiper.params.controller.control;
  });
  on('update', () => {
    removeSpline();
  });
  on('resize', () => {
    removeSpline();
  });
  on('observerUpdate', () => {
    removeSpline();
  });
  on('setTranslate', (_s, translate, byController) => {
    if (!swiper.controller.control) return;
    swiper.controller.setTranslate(translate, byController);
  });
  on('setTransition', (_s, duration, byController) => {
    if (!swiper.controller.control) return;
    swiper.controller.setTransition(duration, byController);
  });
  Object.assign(swiper.controller, {
    setTranslate,
    setTransition
  });
}
;// CONCATENATED MODULE: ./node_modules/swiper/modules/a11y/a11y.js


function A11y({
  swiper,
  extendParams,
  on
}) {
  extendParams({
    a11y: {
      enabled: true,
      notificationClass: 'swiper-notification',
      prevSlideMessage: 'Previous slide',
      nextSlideMessage: 'Next slide',
      firstSlideMessage: 'This is the first slide',
      lastSlideMessage: 'This is the last slide',
      paginationBulletMessage: 'Go to slide {{index}}',
      slideLabelMessage: '{{index}} / {{slidesLength}}',
      containerMessage: null,
      containerRoleDescriptionMessage: null,
      itemRoleDescriptionMessage: null,
      slideRole: 'group',
      id: null
    }
  });
  swiper.a11y = {
    clicked: false
  };
  let liveRegion = null;

  function notify(message) {
    const notification = liveRegion;
    if (notification.length === 0) return;
    notification.html('');
    notification.html(message);
  }

  function getRandomNumber(size = 16) {
    const randomChar = () => Math.round(16 * Math.random()).toString(16);

    return 'x'.repeat(size).replace(/x/g, randomChar);
  }

  function makeElFocusable($el) {
    $el.attr('tabIndex', '0');
  }

  function makeElNotFocusable($el) {
    $el.attr('tabIndex', '-1');
  }

  function addElRole($el, role) {
    $el.attr('role', role);
  }

  function addElRoleDescription($el, description) {
    $el.attr('aria-roledescription', description);
  }

  function addElControls($el, controls) {
    $el.attr('aria-controls', controls);
  }

  function addElLabel($el, label) {
    $el.attr('aria-label', label);
  }

  function addElId($el, id) {
    $el.attr('id', id);
  }

  function addElLive($el, live) {
    $el.attr('aria-live', live);
  }

  function disableEl($el) {
    $el.attr('aria-disabled', true);
  }

  function enableEl($el) {
    $el.attr('aria-disabled', false);
  }

  function onEnterOrSpaceKey(e) {
    if (e.keyCode !== 13 && e.keyCode !== 32) return;
    const params = swiper.params.a11y;
    const $targetEl = $(e.target);

    if (swiper.navigation && swiper.navigation.$nextEl && $targetEl.is(swiper.navigation.$nextEl)) {
      if (!(swiper.isEnd && !swiper.params.loop)) {
        swiper.slideNext();
      }

      if (swiper.isEnd) {
        notify(params.lastSlideMessage);
      } else {
        notify(params.nextSlideMessage);
      }
    }

    if (swiper.navigation && swiper.navigation.$prevEl && $targetEl.is(swiper.navigation.$prevEl)) {
      if (!(swiper.isBeginning && !swiper.params.loop)) {
        swiper.slidePrev();
      }

      if (swiper.isBeginning) {
        notify(params.firstSlideMessage);
      } else {
        notify(params.prevSlideMessage);
      }
    }

    if (swiper.pagination && $targetEl.is(classesToSelector(swiper.params.pagination.bulletClass))) {
      $targetEl[0].click();
    }
  }

  function updateNavigation() {
    if (swiper.params.loop || swiper.params.rewind || !swiper.navigation) return;
    const {
      $nextEl,
      $prevEl
    } = swiper.navigation;

    if ($prevEl && $prevEl.length > 0) {
      if (swiper.isBeginning) {
        disableEl($prevEl);
        makeElNotFocusable($prevEl);
      } else {
        enableEl($prevEl);
        makeElFocusable($prevEl);
      }
    }

    if ($nextEl && $nextEl.length > 0) {
      if (swiper.isEnd) {
        disableEl($nextEl);
        makeElNotFocusable($nextEl);
      } else {
        enableEl($nextEl);
        makeElFocusable($nextEl);
      }
    }
  }

  function hasPagination() {
    return swiper.pagination && swiper.pagination.bullets && swiper.pagination.bullets.length;
  }

  function hasClickablePagination() {
    return hasPagination() && swiper.params.pagination.clickable;
  }

  function updatePagination() {
    const params = swiper.params.a11y;
    if (!hasPagination()) return;
    swiper.pagination.bullets.each(bulletEl => {
      const $bulletEl = $(bulletEl);

      if (swiper.params.pagination.clickable) {
        makeElFocusable($bulletEl);

        if (!swiper.params.pagination.renderBullet) {
          addElRole($bulletEl, 'button');
          addElLabel($bulletEl, params.paginationBulletMessage.replace(/\{\{index\}\}/, $bulletEl.index() + 1));
        }
      }

      if ($bulletEl.is(`.${swiper.params.pagination.bulletActiveClass}`)) {
        $bulletEl.attr('aria-current', 'true');
      } else {
        $bulletEl.removeAttr('aria-current');
      }
    });
  }

  const initNavEl = ($el, wrapperId, message) => {
    makeElFocusable($el);

    if ($el[0].tagName !== 'BUTTON') {
      addElRole($el, 'button');
      $el.on('keydown', onEnterOrSpaceKey);
    }

    addElLabel($el, message);
    addElControls($el, wrapperId);
  };

  const handlePointerDown = () => {
    swiper.a11y.clicked = true;
  };

  const handlePointerUp = () => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        if (!swiper.destroyed) {
          swiper.a11y.clicked = false;
        }
      });
    });
  };

  const handleFocus = e => {
    if (swiper.a11y.clicked) return;
    const slideEl = e.target.closest(`.${swiper.params.slideClass}`);
    if (!slideEl || !swiper.slides.includes(slideEl)) return;
    const isActive = swiper.slides.indexOf(slideEl) === swiper.activeIndex;
    const isVisible = swiper.params.watchSlidesProgress && swiper.visibleSlides && swiper.visibleSlides.includes(slideEl);
    if (isActive || isVisible) return;
    if (e.sourceCapabilities && e.sourceCapabilities.firesTouchEvents) return;

    if (swiper.isHorizontal()) {
      swiper.el.scrollLeft = 0;
    } else {
      swiper.el.scrollTop = 0;
    }

    swiper.slideTo(swiper.slides.indexOf(slideEl), 0);
  };

  const initSlides = () => {
    const params = swiper.params.a11y;

    if (params.itemRoleDescriptionMessage) {
      addElRoleDescription($(swiper.slides), params.itemRoleDescriptionMessage);
    }

    if (params.slideRole) {
      addElRole($(swiper.slides), params.slideRole);
    }

    const slidesLength = swiper.params.loop ? swiper.slides.filter(el => !el.classList.contains(swiper.params.slideDuplicateClass)).length : swiper.slides.length;

    if (params.slideLabelMessage) {
      swiper.slides.each((slideEl, index) => {
        const $slideEl = $(slideEl);
        const slideIndex = swiper.params.loop ? parseInt($slideEl.attr('data-swiper-slide-index'), 10) : index;
        const ariaLabelMessage = params.slideLabelMessage.replace(/\{\{index\}\}/, slideIndex + 1).replace(/\{\{slidesLength\}\}/, slidesLength);
        addElLabel($slideEl, ariaLabelMessage);
      });
    }
  };

  const init = () => {
    const params = swiper.params.a11y;
    swiper.$el.append(liveRegion); // Container

    const $containerEl = swiper.$el;

    if (params.containerRoleDescriptionMessage) {
      addElRoleDescription($containerEl, params.containerRoleDescriptionMessage);
    }

    if (params.containerMessage) {
      addElLabel($containerEl, params.containerMessage);
    } // Wrapper


    const $wrapperEl = swiper.$wrapperEl;
    const wrapperId = params.id || $wrapperEl.attr('id') || `swiper-wrapper-${getRandomNumber(16)}`;
    const live = swiper.params.autoplay && swiper.params.autoplay.enabled ? 'off' : 'polite';
    addElId($wrapperEl, wrapperId);
    addElLive($wrapperEl, live); // Slide

    initSlides(); // Navigation

    let $nextEl;
    let $prevEl;

    if (swiper.navigation && swiper.navigation.$nextEl) {
      $nextEl = swiper.navigation.$nextEl;
    }

    if (swiper.navigation && swiper.navigation.$prevEl) {
      $prevEl = swiper.navigation.$prevEl;
    }

    if ($nextEl && $nextEl.length) {
      initNavEl($nextEl, wrapperId, params.nextSlideMessage);
    }

    if ($prevEl && $prevEl.length) {
      initNavEl($prevEl, wrapperId, params.prevSlideMessage);
    } // Pagination


    if (hasClickablePagination()) {
      swiper.pagination.$el.on('keydown', classesToSelector(swiper.params.pagination.bulletClass), onEnterOrSpaceKey);
    } // Tab focus


    swiper.$el.on('focus', handleFocus, true);
    swiper.$el.on('pointerdown', handlePointerDown, true);
    swiper.$el.on('pointerup', handlePointerUp, true);
  };

  function destroy() {
    if (liveRegion && liveRegion.length > 0) liveRegion.remove();
    let $nextEl;
    let $prevEl;

    if (swiper.navigation && swiper.navigation.$nextEl) {
      $nextEl = swiper.navigation.$nextEl;
    }

    if (swiper.navigation && swiper.navigation.$prevEl) {
      $prevEl = swiper.navigation.$prevEl;
    }

    if ($nextEl) {
      $nextEl.off('keydown', onEnterOrSpaceKey);
    }

    if ($prevEl) {
      $prevEl.off('keydown', onEnterOrSpaceKey);
    } // Pagination


    if (hasClickablePagination()) {
      swiper.pagination.$el.off('keydown', classesToSelector(swiper.params.pagination.bulletClass), onEnterOrSpaceKey);
    } // Tab focus


    swiper.$el.off('focus', handleFocus, true);
    swiper.$el.off('pointerdown', handlePointerDown, true);
    swiper.$el.off('pointerup', handlePointerUp, true);
  }

  on('beforeInit', () => {
    liveRegion = $(`<span class="${swiper.params.a11y.notificationClass}" aria-live="assertive" aria-atomic="true"></span>`);
  });
  on('afterInit', () => {
    if (!swiper.params.a11y.enabled) return;
    init();
  });
  on('slidesLengthChange snapGridLengthChange slidesGridLengthChange', () => {
    if (!swiper.params.a11y.enabled) return;
    initSlides();
  });
  on('fromEdge toEdge afterInit lock unlock', () => {
    if (!swiper.params.a11y.enabled) return;
    updateNavigation();
  });
  on('paginationUpdate', () => {
    if (!swiper.params.a11y.enabled) return;
    updatePagination();
  });
  on('destroy', () => {
    if (!swiper.params.a11y.enabled) return;
    destroy();
  });
}
;// CONCATENATED MODULE: ./node_modules/swiper/modules/history/history.js

function History({
  swiper,
  extendParams,
  on
}) {
  extendParams({
    history: {
      enabled: false,
      root: '',
      replaceState: false,
      key: 'slides',
      keepQuery: false
    }
  });
  let initialized = false;
  let paths = {};

  const slugify = text => {
    return text.toString().replace(/\s+/g, '-').replace(/[^\w-]+/g, '').replace(/--+/g, '-').replace(/^-+/, '').replace(/-+$/, '');
  };

  const getPathValues = urlOverride => {
    const window = getWindow();
    let location;

    if (urlOverride) {
      location = new URL(urlOverride);
    } else {
      location = window.location;
    }

    const pathArray = location.pathname.slice(1).split('/').filter(part => part !== '');
    const total = pathArray.length;
    const key = pathArray[total - 2];
    const value = pathArray[total - 1];
    return {
      key,
      value
    };
  };

  const setHistory = (key, index) => {
    const window = getWindow();
    if (!initialized || !swiper.params.history.enabled) return;
    let location;

    if (swiper.params.url) {
      location = new URL(swiper.params.url);
    } else {
      location = window.location;
    }

    const slide = swiper.slides.eq(index);
    let value = slugify(slide.attr('data-history'));

    if (swiper.params.history.root.length > 0) {
      let root = swiper.params.history.root;
      if (root[root.length - 1] === '/') root = root.slice(0, root.length - 1);
      value = `${root}/${key}/${value}`;
    } else if (!location.pathname.includes(key)) {
      value = `${key}/${value}`;
    }

    if (swiper.params.history.keepQuery) {
      value += location.search;
    }

    const currentState = window.history.state;

    if (currentState && currentState.value === value) {
      return;
    }

    if (swiper.params.history.replaceState) {
      window.history.replaceState({
        value
      }, null, value);
    } else {
      window.history.pushState({
        value
      }, null, value);
    }
  };

  const scrollToSlide = (speed, value, runCallbacks) => {
    if (value) {
      for (let i = 0, length = swiper.slides.length; i < length; i += 1) {
        const slide = swiper.slides.eq(i);
        const slideHistory = slugify(slide.attr('data-history'));

        if (slideHistory === value && !slide.hasClass(swiper.params.slideDuplicateClass)) {
          const index = slide.index();
          swiper.slideTo(index, speed, runCallbacks);
        }
      }
    } else {
      swiper.slideTo(0, speed, runCallbacks);
    }
  };

  const setHistoryPopState = () => {
    paths = getPathValues(swiper.params.url);
    scrollToSlide(swiper.params.speed, paths.value, false);
  };

  const init = () => {
    const window = getWindow();
    if (!swiper.params.history) return;

    if (!window.history || !window.history.pushState) {
      swiper.params.history.enabled = false;
      swiper.params.hashNavigation.enabled = true;
      return;
    }

    initialized = true;
    paths = getPathValues(swiper.params.url);
    if (!paths.key && !paths.value) return;
    scrollToSlide(0, paths.value, swiper.params.runCallbacksOnInit);

    if (!swiper.params.history.replaceState) {
      window.addEventListener('popstate', setHistoryPopState);
    }
  };

  const destroy = () => {
    const window = getWindow();

    if (!swiper.params.history.replaceState) {
      window.removeEventListener('popstate', setHistoryPopState);
    }
  };

  on('init', () => {
    if (swiper.params.history.enabled) {
      init();
    }
  });
  on('destroy', () => {
    if (swiper.params.history.enabled) {
      destroy();
    }
  });
  on('transitionEnd _freeModeNoMomentumRelease', () => {
    if (initialized) {
      setHistory(swiper.params.history.key, swiper.activeIndex);
    }
  });
  on('slideChange', () => {
    if (initialized && swiper.params.cssMode) {
      setHistory(swiper.params.history.key, swiper.activeIndex);
    }
  });
}
;// CONCATENATED MODULE: ./node_modules/swiper/modules/hash-navigation/hash-navigation.js


function HashNavigation({
  swiper,
  extendParams,
  emit,
  on
}) {
  let initialized = false;
  const document = getDocument();
  const window = getWindow();
  extendParams({
    hashNavigation: {
      enabled: false,
      replaceState: false,
      watchState: false
    }
  });

  const onHashChange = () => {
    emit('hashChange');
    const newHash = document.location.hash.replace('#', '');
    const activeSlideHash = swiper.slides.eq(swiper.activeIndex).attr('data-hash');

    if (newHash !== activeSlideHash) {
      const newIndex = swiper.$wrapperEl.children(`.${swiper.params.slideClass}[data-hash="${newHash}"]`).index();
      if (typeof newIndex === 'undefined') return;
      swiper.slideTo(newIndex);
    }
  };

  const setHash = () => {
    if (!initialized || !swiper.params.hashNavigation.enabled) return;

    if (swiper.params.hashNavigation.replaceState && window.history && window.history.replaceState) {
      window.history.replaceState(null, null, `#${swiper.slides.eq(swiper.activeIndex).attr('data-hash')}` || '');
      emit('hashSet');
    } else {
      const slide = swiper.slides.eq(swiper.activeIndex);
      const hash = slide.attr('data-hash') || slide.attr('data-history');
      document.location.hash = hash || '';
      emit('hashSet');
    }
  };

  const init = () => {
    if (!swiper.params.hashNavigation.enabled || swiper.params.history && swiper.params.history.enabled) return;
    initialized = true;
    const hash = document.location.hash.replace('#', '');

    if (hash) {
      const speed = 0;

      for (let i = 0, length = swiper.slides.length; i < length; i += 1) {
        const slide = swiper.slides.eq(i);
        const slideHash = slide.attr('data-hash') || slide.attr('data-history');

        if (slideHash === hash && !slide.hasClass(swiper.params.slideDuplicateClass)) {
          const index = slide.index();
          swiper.slideTo(index, speed, swiper.params.runCallbacksOnInit, true);
        }
      }
    }

    if (swiper.params.hashNavigation.watchState) {
      $(window).on('hashchange', onHashChange);
    }
  };

  const destroy = () => {
    if (swiper.params.hashNavigation.watchState) {
      $(window).off('hashchange', onHashChange);
    }
  };

  on('init', () => {
    if (swiper.params.hashNavigation.enabled) {
      init();
    }
  });
  on('destroy', () => {
    if (swiper.params.hashNavigation.enabled) {
      destroy();
    }
  });
  on('transitionEnd _freeModeNoMomentumRelease', () => {
    if (initialized) {
      setHash();
    }
  });
  on('slideChange', () => {
    if (initialized && swiper.params.cssMode) {
      setHash();
    }
  });
}
;// CONCATENATED MODULE: ./node_modules/swiper/modules/autoplay/autoplay.js
/* eslint no-underscore-dangle: "off" */

/* eslint no-use-before-define: "off" */


function Autoplay({
  swiper,
  extendParams,
  on,
  emit
}) {
  let timeout;
  swiper.autoplay = {
    running: false,
    paused: false
  };
  extendParams({
    autoplay: {
      enabled: false,
      delay: 3000,
      waitForTransition: true,
      disableOnInteraction: true,
      stopOnLastSlide: false,
      reverseDirection: false,
      pauseOnMouseEnter: false
    }
  });

  function run() {
    if (!swiper.size) {
      swiper.autoplay.running = false;
      swiper.autoplay.paused = false;
      return;
    }

    const $activeSlideEl = swiper.slides.eq(swiper.activeIndex);
    let delay = swiper.params.autoplay.delay;

    if ($activeSlideEl.attr('data-swiper-autoplay')) {
      delay = $activeSlideEl.attr('data-swiper-autoplay') || swiper.params.autoplay.delay;
    }

    clearTimeout(timeout);
    timeout = utils_nextTick(() => {
      let autoplayResult;

      if (swiper.params.autoplay.reverseDirection) {
        if (swiper.params.loop) {
          swiper.loopFix();
          autoplayResult = swiper.slidePrev(swiper.params.speed, true, true);
          emit('autoplay');
        } else if (!swiper.isBeginning) {
          autoplayResult = swiper.slidePrev(swiper.params.speed, true, true);
          emit('autoplay');
        } else if (!swiper.params.autoplay.stopOnLastSlide) {
          autoplayResult = swiper.slideTo(swiper.slides.length - 1, swiper.params.speed, true, true);
          emit('autoplay');
        } else {
          stop();
        }
      } else if (swiper.params.loop) {
        swiper.loopFix();
        autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
        emit('autoplay');
      } else if (!swiper.isEnd) {
        autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
        emit('autoplay');
      } else if (!swiper.params.autoplay.stopOnLastSlide) {
        autoplayResult = swiper.slideTo(0, swiper.params.speed, true, true);
        emit('autoplay');
      } else {
        stop();
      }

      if (swiper.params.cssMode && swiper.autoplay.running) run();else if (autoplayResult === false) {
        run();
      }
    }, delay);
  }

  function start() {
    if (typeof timeout !== 'undefined') return false;
    if (swiper.autoplay.running) return false;
    swiper.autoplay.running = true;
    emit('autoplayStart');
    run();
    return true;
  }

  function stop() {
    if (!swiper.autoplay.running) return false;
    if (typeof timeout === 'undefined') return false;

    if (timeout) {
      clearTimeout(timeout);
      timeout = undefined;
    }

    swiper.autoplay.running = false;
    emit('autoplayStop');
    return true;
  }

  function pause(speed) {
    if (!swiper.autoplay.running) return;
    if (swiper.autoplay.paused) return;
    if (timeout) clearTimeout(timeout);
    swiper.autoplay.paused = true;

    if (speed === 0 || !swiper.params.autoplay.waitForTransition) {
      swiper.autoplay.paused = false;
      run();
    } else {
      ['transitionend', 'webkitTransitionEnd'].forEach(event => {
        swiper.$wrapperEl[0].addEventListener(event, onTransitionEnd);
      });
    }
  }

  function onVisibilityChange() {
    const document = ssr_window_esm_getDocument();

    if (document.visibilityState === 'hidden' && swiper.autoplay.running) {
      pause();
    }

    if (document.visibilityState === 'visible' && swiper.autoplay.paused) {
      run();
      swiper.autoplay.paused = false;
    }
  }

  function onTransitionEnd(e) {
    if (!swiper || swiper.destroyed || !swiper.$wrapperEl) return;
    if (e.target !== swiper.$wrapperEl[0]) return;
    ['transitionend', 'webkitTransitionEnd'].forEach(event => {
      swiper.$wrapperEl[0].removeEventListener(event, onTransitionEnd);
    });
    swiper.autoplay.paused = false;

    if (!swiper.autoplay.running) {
      stop();
    } else {
      run();
    }
  }

  function onMouseEnter() {
    if (swiper.params.autoplay.disableOnInteraction) {
      stop();
    } else {
      emit('autoplayPause');
      pause();
    }

    ['transitionend', 'webkitTransitionEnd'].forEach(event => {
      swiper.$wrapperEl[0].removeEventListener(event, onTransitionEnd);
    });
  }

  function onMouseLeave() {
    if (swiper.params.autoplay.disableOnInteraction) {
      return;
    }

    swiper.autoplay.paused = false;
    emit('autoplayResume');
    run();
  }

  function attachMouseEvents() {
    if (swiper.params.autoplay.pauseOnMouseEnter) {
      swiper.$el.on('mouseenter', onMouseEnter);
      swiper.$el.on('mouseleave', onMouseLeave);
    }
  }

  function detachMouseEvents() {
    swiper.$el.off('mouseenter', onMouseEnter);
    swiper.$el.off('mouseleave', onMouseLeave);
  }

  on('init', () => {
    if (swiper.params.autoplay.enabled) {
      start();
      const document = ssr_window_esm_getDocument();
      document.addEventListener('visibilitychange', onVisibilityChange);
      attachMouseEvents();
    }
  });
  on('beforeTransitionStart', (_s, speed, internal) => {
    if (swiper.autoplay.running) {
      if (internal || !swiper.params.autoplay.disableOnInteraction) {
        swiper.autoplay.pause(speed);
      } else {
        stop();
      }
    }
  });
  on('sliderFirstMove', () => {
    if (swiper.autoplay.running) {
      if (swiper.params.autoplay.disableOnInteraction) {
        stop();
      } else {
        pause();
      }
    }
  });
  on('touchEnd', () => {
    if (swiper.params.cssMode && swiper.autoplay.paused && !swiper.params.autoplay.disableOnInteraction) {
      run();
    }
  });
  on('destroy', () => {
    detachMouseEvents();

    if (swiper.autoplay.running) {
      stop();
    }

    const document = ssr_window_esm_getDocument();
    document.removeEventListener('visibilitychange', onVisibilityChange);
  });
  Object.assign(swiper.autoplay, {
    pause,
    run,
    start,
    stop
  });
}
;// CONCATENATED MODULE: ./node_modules/swiper/modules/thumbs/thumbs.js


function Thumb({
  swiper,
  extendParams,
  on
}) {
  extendParams({
    thumbs: {
      swiper: null,
      multipleActiveThumbs: true,
      autoScrollOffset: 0,
      slideThumbActiveClass: 'swiper-slide-thumb-active',
      thumbsContainerClass: 'swiper-thumbs'
    }
  });
  let initialized = false;
  let swiperCreated = false;
  swiper.thumbs = {
    swiper: null
  };

  function onThumbClick() {
    const thumbsSwiper = swiper.thumbs.swiper;
    if (!thumbsSwiper || thumbsSwiper.destroyed) return;
    const clickedIndex = thumbsSwiper.clickedIndex;
    const clickedSlide = thumbsSwiper.clickedSlide;
    if (clickedSlide && $(clickedSlide).hasClass(swiper.params.thumbs.slideThumbActiveClass)) return;
    if (typeof clickedIndex === 'undefined' || clickedIndex === null) return;
    let slideToIndex;

    if (thumbsSwiper.params.loop) {
      slideToIndex = parseInt($(thumbsSwiper.clickedSlide).attr('data-swiper-slide-index'), 10);
    } else {
      slideToIndex = clickedIndex;
    }

    if (swiper.params.loop) {
      let currentIndex = swiper.activeIndex;

      if (swiper.slides.eq(currentIndex).hasClass(swiper.params.slideDuplicateClass)) {
        swiper.loopFix(); // eslint-disable-next-line

        swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
        currentIndex = swiper.activeIndex;
      }

      const prevIndex = swiper.slides.eq(currentIndex).prevAll(`[data-swiper-slide-index="${slideToIndex}"]`).eq(0).index();
      const nextIndex = swiper.slides.eq(currentIndex).nextAll(`[data-swiper-slide-index="${slideToIndex}"]`).eq(0).index();
      if (typeof prevIndex === 'undefined') slideToIndex = nextIndex;else if (typeof nextIndex === 'undefined') slideToIndex = prevIndex;else if (nextIndex - currentIndex < currentIndex - prevIndex) slideToIndex = nextIndex;else slideToIndex = prevIndex;
    }

    swiper.slideTo(slideToIndex);
  }

  function init() {
    const {
      thumbs: thumbsParams
    } = swiper.params;
    if (initialized) return false;
    initialized = true;
    const SwiperClass = swiper.constructor;

    if (thumbsParams.swiper instanceof SwiperClass) {
      swiper.thumbs.swiper = thumbsParams.swiper;
      Object.assign(swiper.thumbs.swiper.originalParams, {
        watchSlidesProgress: true,
        slideToClickedSlide: false
      });
      Object.assign(swiper.thumbs.swiper.params, {
        watchSlidesProgress: true,
        slideToClickedSlide: false
      });
    } else if (isObject(thumbsParams.swiper)) {
      const thumbsSwiperParams = Object.assign({}, thumbsParams.swiper);
      Object.assign(thumbsSwiperParams, {
        watchSlidesProgress: true,
        slideToClickedSlide: false
      });
      swiper.thumbs.swiper = new SwiperClass(thumbsSwiperParams);
      swiperCreated = true;
    }

    swiper.thumbs.swiper.$el.addClass(swiper.params.thumbs.thumbsContainerClass);
    swiper.thumbs.swiper.on('tap', onThumbClick);
    return true;
  }

  function update(initial) {
    const thumbsSwiper = swiper.thumbs.swiper;
    if (!thumbsSwiper || thumbsSwiper.destroyed) return;
    const slidesPerView = thumbsSwiper.params.slidesPerView === 'auto' ? thumbsSwiper.slidesPerViewDynamic() : thumbsSwiper.params.slidesPerView; // Activate thumbs

    let thumbsToActivate = 1;
    const thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;

    if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) {
      thumbsToActivate = swiper.params.slidesPerView;
    }

    if (!swiper.params.thumbs.multipleActiveThumbs) {
      thumbsToActivate = 1;
    }

    thumbsToActivate = Math.floor(thumbsToActivate);
    thumbsSwiper.slides.removeClass(thumbActiveClass);

    if (thumbsSwiper.params.loop || thumbsSwiper.params.virtual && thumbsSwiper.params.virtual.enabled) {
      for (let i = 0; i < thumbsToActivate; i += 1) {
        thumbsSwiper.$wrapperEl.children(`[data-swiper-slide-index="${swiper.realIndex + i}"]`).addClass(thumbActiveClass);
      }
    } else {
      for (let i = 0; i < thumbsToActivate; i += 1) {
        thumbsSwiper.slides.eq(swiper.realIndex + i).addClass(thumbActiveClass);
      }
    }

    const autoScrollOffset = swiper.params.thumbs.autoScrollOffset;
    const useOffset = autoScrollOffset && !thumbsSwiper.params.loop;

    if (swiper.realIndex !== thumbsSwiper.realIndex || useOffset) {
      let currentThumbsIndex = thumbsSwiper.activeIndex;
      let newThumbsIndex;
      let direction;

      if (thumbsSwiper.params.loop) {
        if (thumbsSwiper.slides.eq(currentThumbsIndex).hasClass(thumbsSwiper.params.slideDuplicateClass)) {
          thumbsSwiper.loopFix(); // eslint-disable-next-line

          thumbsSwiper._clientLeft = thumbsSwiper.$wrapperEl[0].clientLeft;
          currentThumbsIndex = thumbsSwiper.activeIndex;
        } // Find actual thumbs index to slide to


        const prevThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).prevAll(`[data-swiper-slide-index="${swiper.realIndex}"]`).eq(0).index();
        const nextThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).nextAll(`[data-swiper-slide-index="${swiper.realIndex}"]`).eq(0).index();

        if (typeof prevThumbsIndex === 'undefined') {
          newThumbsIndex = nextThumbsIndex;
        } else if (typeof nextThumbsIndex === 'undefined') {
          newThumbsIndex = prevThumbsIndex;
        } else if (nextThumbsIndex - currentThumbsIndex === currentThumbsIndex - prevThumbsIndex) {
          newThumbsIndex = thumbsSwiper.params.slidesPerGroup > 1 ? nextThumbsIndex : currentThumbsIndex;
        } else if (nextThumbsIndex - currentThumbsIndex < currentThumbsIndex - prevThumbsIndex) {
          newThumbsIndex = nextThumbsIndex;
        } else {
          newThumbsIndex = prevThumbsIndex;
        }

        direction = swiper.activeIndex > swiper.previousIndex ? 'next' : 'prev';
      } else {
        newThumbsIndex = swiper.realIndex;
        direction = newThumbsIndex > swiper.previousIndex ? 'next' : 'prev';
      }

      if (useOffset) {
        newThumbsIndex += direction === 'next' ? autoScrollOffset : -1 * autoScrollOffset;
      }

      if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
        if (thumbsSwiper.params.centeredSlides) {
          if (newThumbsIndex > currentThumbsIndex) {
            newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
          } else {
            newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
          }
        } else if (newThumbsIndex > currentThumbsIndex && thumbsSwiper.params.slidesPerGroup === 1) {// newThumbsIndex = newThumbsIndex - slidesPerView + 1;
        }

        thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : undefined);
      }
    }
  }

  on('beforeInit', () => {
    const {
      thumbs
    } = swiper.params;
    if (!thumbs || !thumbs.swiper) return;
    init();
    update(true);
  });
  on('slideChange update resize observerUpdate', () => {
    update();
  });
  on('setTransition', (_s, duration) => {
    const thumbsSwiper = swiper.thumbs.swiper;
    if (!thumbsSwiper || thumbsSwiper.destroyed) return;
    thumbsSwiper.setTransition(duration);
  });
  on('beforeDestroy', () => {
    const thumbsSwiper = swiper.thumbs.swiper;
    if (!thumbsSwiper || thumbsSwiper.destroyed) return;

    if (swiperCreated) {
      thumbsSwiper.destroy();
    }
  });
  Object.assign(swiper.thumbs, {
    init,
    update
  });
}
;// CONCATENATED MODULE: ./node_modules/swiper/modules/free-mode/free-mode.js

function freeMode({
  swiper,
  extendParams,
  emit,
  once
}) {
  extendParams({
    freeMode: {
      enabled: false,
      momentum: true,
      momentumRatio: 1,
      momentumBounce: true,
      momentumBounceRatio: 1,
      momentumVelocityRatio: 1,
      sticky: false,
      minimumVelocity: 0.02
    }
  });

  function onTouchStart() {
    const translate = swiper.getTranslate();
    swiper.setTranslate(translate);
    swiper.setTransition(0);
    swiper.touchEventsData.velocities.length = 0;
    swiper.freeMode.onTouchEnd({
      currentPos: swiper.rtl ? swiper.translate : -swiper.translate
    });
  }

  function onTouchMove() {
    const {
      touchEventsData: data,
      touches
    } = swiper; // Velocity

    if (data.velocities.length === 0) {
      data.velocities.push({
        position: touches[swiper.isHorizontal() ? 'startX' : 'startY'],
        time: data.touchStartTime
      });
    }

    data.velocities.push({
      position: touches[swiper.isHorizontal() ? 'currentX' : 'currentY'],
      time: now()
    });
  }

  function onTouchEnd({
    currentPos
  }) {
    const {
      params,
      $wrapperEl,
      rtlTranslate: rtl,
      snapGrid,
      touchEventsData: data
    } = swiper; // Time diff

    const touchEndTime = now();
    const timeDiff = touchEndTime - data.touchStartTime;

    if (currentPos < -swiper.minTranslate()) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }

    if (currentPos > -swiper.maxTranslate()) {
      if (swiper.slides.length < snapGrid.length) {
        swiper.slideTo(snapGrid.length - 1);
      } else {
        swiper.slideTo(swiper.slides.length - 1);
      }

      return;
    }

    if (params.freeMode.momentum) {
      if (data.velocities.length > 1) {
        const lastMoveEvent = data.velocities.pop();
        const velocityEvent = data.velocities.pop();
        const distance = lastMoveEvent.position - velocityEvent.position;
        const time = lastMoveEvent.time - velocityEvent.time;
        swiper.velocity = distance / time;
        swiper.velocity /= 2;

        if (Math.abs(swiper.velocity) < params.freeMode.minimumVelocity) {
          swiper.velocity = 0;
        } // this implies that the user stopped moving a finger then released.
        // There would be no events with distance zero, so the last event is stale.


        if (time > 150 || now() - lastMoveEvent.time > 300) {
          swiper.velocity = 0;
        }
      } else {
        swiper.velocity = 0;
      }

      swiper.velocity *= params.freeMode.momentumVelocityRatio;
      data.velocities.length = 0;
      let momentumDuration = 1000 * params.freeMode.momentumRatio;
      const momentumDistance = swiper.velocity * momentumDuration;
      let newPosition = swiper.translate + momentumDistance;
      if (rtl) newPosition = -newPosition;
      let doBounce = false;
      let afterBouncePosition;
      const bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeMode.momentumBounceRatio;
      let needsLoopFix;

      if (newPosition < swiper.maxTranslate()) {
        if (params.freeMode.momentumBounce) {
          if (newPosition + swiper.maxTranslate() < -bounceAmount) {
            newPosition = swiper.maxTranslate() - bounceAmount;
          }

          afterBouncePosition = swiper.maxTranslate();
          doBounce = true;
          data.allowMomentumBounce = true;
        } else {
          newPosition = swiper.maxTranslate();
        }

        if (params.loop && params.centeredSlides) needsLoopFix = true;
      } else if (newPosition > swiper.minTranslate()) {
        if (params.freeMode.momentumBounce) {
          if (newPosition - swiper.minTranslate() > bounceAmount) {
            newPosition = swiper.minTranslate() + bounceAmount;
          }

          afterBouncePosition = swiper.minTranslate();
          doBounce = true;
          data.allowMomentumBounce = true;
        } else {
          newPosition = swiper.minTranslate();
        }

        if (params.loop && params.centeredSlides) needsLoopFix = true;
      } else if (params.freeMode.sticky) {
        let nextSlide;

        for (let j = 0; j < snapGrid.length; j += 1) {
          if (snapGrid[j] > -newPosition) {
            nextSlide = j;
            break;
          }
        }

        if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === 'next') {
          newPosition = snapGrid[nextSlide];
        } else {
          newPosition = snapGrid[nextSlide - 1];
        }

        newPosition = -newPosition;
      }

      if (needsLoopFix) {
        once('transitionEnd', () => {
          swiper.loopFix();
        });
      } // Fix duration


      if (swiper.velocity !== 0) {
        if (rtl) {
          momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
        } else {
          momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
        }

        if (params.freeMode.sticky) {
          // If freeMode.sticky is active and the user ends a swipe with a slow-velocity
          // event, then durations can be 20+ seconds to slide one (or zero!) slides.
          // It's easy to see this when simulating touch with mouse events. To fix this,
          // limit single-slide swipes to the default slide duration. This also has the
          // nice side effect of matching slide speed if the user stopped moving before
          // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
          // For faster swipes, also apply limits (albeit higher ones).
          const moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
          const currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];

          if (moveDistance < currentSlideSize) {
            momentumDuration = params.speed;
          } else if (moveDistance < 2 * currentSlideSize) {
            momentumDuration = params.speed * 1.5;
          } else {
            momentumDuration = params.speed * 2.5;
          }
        }
      } else if (params.freeMode.sticky) {
        swiper.slideToClosest();
        return;
      }

      if (params.freeMode.momentumBounce && doBounce) {
        swiper.updateProgress(afterBouncePosition);
        swiper.setTransition(momentumDuration);
        swiper.setTranslate(newPosition);
        swiper.transitionStart(true, swiper.swipeDirection);
        swiper.animating = true;
        $wrapperEl.transitionEnd(() => {
          if (!swiper || swiper.destroyed || !data.allowMomentumBounce) return;
          emit('momentumBounce');
          swiper.setTransition(params.speed);
          setTimeout(() => {
            swiper.setTranslate(afterBouncePosition);
            $wrapperEl.transitionEnd(() => {
              if (!swiper || swiper.destroyed) return;
              swiper.transitionEnd();
            });
          }, 0);
        });
      } else if (swiper.velocity) {
        emit('_freeModeNoMomentumRelease');
        swiper.updateProgress(newPosition);
        swiper.setTransition(momentumDuration);
        swiper.setTranslate(newPosition);
        swiper.transitionStart(true, swiper.swipeDirection);

        if (!swiper.animating) {
          swiper.animating = true;
          $wrapperEl.transitionEnd(() => {
            if (!swiper || swiper.destroyed) return;
            swiper.transitionEnd();
          });
        }
      } else {
        swiper.updateProgress(newPosition);
      }

      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    } else if (params.freeMode.sticky) {
      swiper.slideToClosest();
      return;
    } else if (params.freeMode) {
      emit('_freeModeNoMomentumRelease');
    }

    if (!params.freeMode.momentum || timeDiff >= params.longSwipesMs) {
      swiper.updateProgress();
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    }
  }

  Object.assign(swiper, {
    freeMode: {
      onTouchStart,
      onTouchMove,
      onTouchEnd
    }
  });
}
;// CONCATENATED MODULE: ./node_modules/swiper/modules/effect-cube/effect-cube.js


function EffectCube({
  swiper,
  extendParams,
  on
}) {
  extendParams({
    cubeEffect: {
      slideShadows: true,
      shadow: true,
      shadowOffset: 20,
      shadowScale: 0.94
    }
  });

  const createSlideShadows = ($slideEl, progress, isHorizontal) => {
    let shadowBefore = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
    let shadowAfter = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');

    if (shadowBefore.length === 0) {
      shadowBefore = $(`<div class="swiper-slide-shadow-${isHorizontal ? 'left' : 'top'}"></div>`);
      $slideEl.append(shadowBefore);
    }

    if (shadowAfter.length === 0) {
      shadowAfter = $(`<div class="swiper-slide-shadow-${isHorizontal ? 'right' : 'bottom'}"></div>`);
      $slideEl.append(shadowAfter);
    }

    if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
    if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
  };

  const recreateShadows = () => {
    // create new ones
    const isHorizontal = swiper.isHorizontal();
    swiper.slides.each(slideEl => {
      const progress = Math.max(Math.min(slideEl.progress, 1), -1);
      createSlideShadows($(slideEl), progress, isHorizontal);
    });
  };

  const setTranslate = () => {
    const {
      $el,
      $wrapperEl,
      slides,
      width: swiperWidth,
      height: swiperHeight,
      rtlTranslate: rtl,
      size: swiperSize,
      browser
    } = swiper;
    const params = swiper.params.cubeEffect;
    const isHorizontal = swiper.isHorizontal();
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    let wrapperRotate = 0;
    let $cubeShadowEl;

    if (params.shadow) {
      if (isHorizontal) {
        $cubeShadowEl = $wrapperEl.find('.swiper-cube-shadow');

        if ($cubeShadowEl.length === 0) {
          $cubeShadowEl = $('<div class="swiper-cube-shadow"></div>');
          $wrapperEl.append($cubeShadowEl);
        }

        $cubeShadowEl.css({
          height: `${swiperWidth}px`
        });
      } else {
        $cubeShadowEl = $el.find('.swiper-cube-shadow');

        if ($cubeShadowEl.length === 0) {
          $cubeShadowEl = $('<div class="swiper-cube-shadow"></div>');
          $el.append($cubeShadowEl);
        }
      }
    }

    for (let i = 0; i < slides.length; i += 1) {
      const $slideEl = slides.eq(i);
      let slideIndex = i;

      if (isVirtual) {
        slideIndex = parseInt($slideEl.attr('data-swiper-slide-index'), 10);
      }

      let slideAngle = slideIndex * 90;
      let round = Math.floor(slideAngle / 360);

      if (rtl) {
        slideAngle = -slideAngle;
        round = Math.floor(-slideAngle / 360);
      }

      const progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
      let tx = 0;
      let ty = 0;
      let tz = 0;

      if (slideIndex % 4 === 0) {
        tx = -round * 4 * swiperSize;
        tz = 0;
      } else if ((slideIndex - 1) % 4 === 0) {
        tx = 0;
        tz = -round * 4 * swiperSize;
      } else if ((slideIndex - 2) % 4 === 0) {
        tx = swiperSize + round * 4 * swiperSize;
        tz = swiperSize;
      } else if ((slideIndex - 3) % 4 === 0) {
        tx = -swiperSize;
        tz = 3 * swiperSize + swiperSize * 4 * round;
      }

      if (rtl) {
        tx = -tx;
      }

      if (!isHorizontal) {
        ty = tx;
        tx = 0;
      }

      const transform = `rotateX(${isHorizontal ? 0 : -slideAngle}deg) rotateY(${isHorizontal ? slideAngle : 0}deg) translate3d(${tx}px, ${ty}px, ${tz}px)`;

      if (progress <= 1 && progress > -1) {
        wrapperRotate = slideIndex * 90 + progress * 90;
        if (rtl) wrapperRotate = -slideIndex * 90 - progress * 90;
      }

      $slideEl.transform(transform);

      if (params.slideShadows) {
        createSlideShadows($slideEl, progress, isHorizontal);
      }
    }

    $wrapperEl.css({
      '-webkit-transform-origin': `50% 50% -${swiperSize / 2}px`,
      'transform-origin': `50% 50% -${swiperSize / 2}px`
    });

    if (params.shadow) {
      if (isHorizontal) {
        $cubeShadowEl.transform(`translate3d(0px, ${swiperWidth / 2 + params.shadowOffset}px, ${-swiperWidth / 2}px) rotateX(90deg) rotateZ(0deg) scale(${params.shadowScale})`);
      } else {
        const shadowAngle = Math.abs(wrapperRotate) - Math.floor(Math.abs(wrapperRotate) / 90) * 90;
        const multiplier = 1.5 - (Math.sin(shadowAngle * 2 * Math.PI / 360) / 2 + Math.cos(shadowAngle * 2 * Math.PI / 360) / 2);
        const scale1 = params.shadowScale;
        const scale2 = params.shadowScale / multiplier;
        const offset = params.shadowOffset;
        $cubeShadowEl.transform(`scale3d(${scale1}, 1, ${scale2}) translate3d(0px, ${swiperHeight / 2 + offset}px, ${-swiperHeight / 2 / scale2}px) rotateX(-90deg)`);
      }
    }

    const zFactor = browser.isSafari || browser.isWebView ? -swiperSize / 2 : 0;
    $wrapperEl.transform(`translate3d(0px,0,${zFactor}px) rotateX(${swiper.isHorizontal() ? 0 : wrapperRotate}deg) rotateY(${swiper.isHorizontal() ? -wrapperRotate : 0}deg)`);
    $wrapperEl[0].style.setProperty('--swiper-cube-translate-z', `${zFactor}px`);
  };

  const setTransition = duration => {
    const {
      $el,
      slides
    } = swiper;
    slides.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);

    if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) {
      $el.find('.swiper-cube-shadow').transition(duration);
    }
  };

  effectInit({
    effect: 'cube',
    swiper,
    on,
    setTranslate,
    setTransition,
    recreateShadows,
    getEffectParams: () => swiper.params.cubeEffect,
    perspective: () => true,
    overwriteParams: () => ({
      slidesPerView: 1,
      slidesPerGroup: 1,
      watchSlidesProgress: true,
      resistanceRatio: 0,
      spaceBetween: 0,
      centeredSlides: false,
      virtualTranslate: true
    })
  });
}
;// CONCATENATED MODULE: ./node_modules/swiper/shared/create-shadow.js

function create_shadow_createShadow(params, $slideEl, side) {
  const shadowClass = `swiper-slide-shadow${side ? `-${side}` : ''}`;
  const $shadowContainer = params.transformEl ? $slideEl.find(params.transformEl) : $slideEl;
  let $shadowEl = $shadowContainer.children(`.${shadowClass}`);

  if (!$shadowEl.length) {
    $shadowEl = $(`<div class="swiper-slide-shadow${side ? `-${side}` : ''}"></div>`);
    $shadowContainer.append($shadowEl);
  }

  return $shadowEl;
}
;// CONCATENATED MODULE: ./node_modules/swiper/modules/effect-flip/effect-flip.js





function EffectFlip({
  swiper,
  extendParams,
  on
}) {
  extendParams({
    flipEffect: {
      slideShadows: true,
      limitRotation: true,
      transformEl: null
    }
  });

  const createSlideShadows = ($slideEl, progress, params) => {
    let shadowBefore = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
    let shadowAfter = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');

    if (shadowBefore.length === 0) {
      shadowBefore = createShadow(params, $slideEl, swiper.isHorizontal() ? 'left' : 'top');
    }

    if (shadowAfter.length === 0) {
      shadowAfter = createShadow(params, $slideEl, swiper.isHorizontal() ? 'right' : 'bottom');
    }

    if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
    if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
  };

  const recreateShadows = () => {
    // Set shadows
    const params = swiper.params.flipEffect;
    swiper.slides.each(slideEl => {
      const $slideEl = $(slideEl);
      let progress = $slideEl[0].progress;

      if (swiper.params.flipEffect.limitRotation) {
        progress = Math.max(Math.min(slideEl.progress, 1), -1);
      }

      createSlideShadows($slideEl, progress, params);
    });
  };

  const setTranslate = () => {
    const {
      slides,
      rtlTranslate: rtl
    } = swiper;
    const params = swiper.params.flipEffect;

    for (let i = 0; i < slides.length; i += 1) {
      const $slideEl = slides.eq(i);
      let progress = $slideEl[0].progress;

      if (swiper.params.flipEffect.limitRotation) {
        progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
      }

      const offset = $slideEl[0].swiperSlideOffset;
      const rotate = -180 * progress;
      let rotateY = rotate;
      let rotateX = 0;
      let tx = swiper.params.cssMode ? -offset - swiper.translate : -offset;
      let ty = 0;

      if (!swiper.isHorizontal()) {
        ty = tx;
        tx = 0;
        rotateX = -rotateY;
        rotateY = 0;
      } else if (rtl) {
        rotateY = -rotateY;
      }

      $slideEl[0].style.zIndex = -Math.abs(Math.round(progress)) + slides.length;

      if (params.slideShadows) {
        createSlideShadows($slideEl, progress, params);
      }

      const transform = `translate3d(${tx}px, ${ty}px, 0px) rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;
      const $targetEl = effectTarget(params, $slideEl);
      $targetEl.transform(transform);
    }
  };

  const setTransition = duration => {
    const {
      transformEl
    } = swiper.params.flipEffect;
    const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
    $transitionElements.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
    effectVirtualTransitionEnd({
      swiper,
      duration,
      transformEl
    });
  };

  effectInit({
    effect: 'flip',
    swiper,
    on,
    setTranslate,
    setTransition,
    recreateShadows,
    getEffectParams: () => swiper.params.flipEffect,
    perspective: () => true,
    overwriteParams: () => ({
      slidesPerView: 1,
      slidesPerGroup: 1,
      watchSlidesProgress: true,
      spaceBetween: 0,
      virtualTranslate: !swiper.params.cssMode
    })
  });
}
;// CONCATENATED MODULE: ./node_modules/swiper/modules/effect-coverflow/effect-coverflow.js



function EffectCoverflow({
  swiper,
  extendParams,
  on
}) {
  extendParams({
    coverflowEffect: {
      rotate: 50,
      stretch: 0,
      depth: 100,
      scale: 1,
      modifier: 1,
      slideShadows: true,
      transformEl: null
    }
  });

  const setTranslate = () => {
    const {
      width: swiperWidth,
      height: swiperHeight,
      slides,
      slidesSizesGrid
    } = swiper;
    const params = swiper.params.coverflowEffect;
    const isHorizontal = swiper.isHorizontal();
    const transform = swiper.translate;
    const center = isHorizontal ? -transform + swiperWidth / 2 : -transform + swiperHeight / 2;
    const rotate = isHorizontal ? params.rotate : -params.rotate;
    const translate = params.depth; // Each slide offset from center

    for (let i = 0, length = slides.length; i < length; i += 1) {
      const $slideEl = slides.eq(i);
      const slideSize = slidesSizesGrid[i];
      const slideOffset = $slideEl[0].swiperSlideOffset;
      const centerOffset = (center - slideOffset - slideSize / 2) / slideSize;
      const offsetMultiplier = typeof params.modifier === 'function' ? params.modifier(centerOffset) : centerOffset * params.modifier;
      let rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
      let rotateX = isHorizontal ? 0 : rotate * offsetMultiplier; // var rotateZ = 0

      let translateZ = -translate * Math.abs(offsetMultiplier);
      let stretch = params.stretch; // Allow percentage to make a relative stretch for responsive sliders

      if (typeof stretch === 'string' && stretch.indexOf('%') !== -1) {
        stretch = parseFloat(params.stretch) / 100 * slideSize;
      }

      let translateY = isHorizontal ? 0 : stretch * offsetMultiplier;
      let translateX = isHorizontal ? stretch * offsetMultiplier : 0;
      let scale = 1 - (1 - params.scale) * Math.abs(offsetMultiplier); // Fix for ultra small values

      if (Math.abs(translateX) < 0.001) translateX = 0;
      if (Math.abs(translateY) < 0.001) translateY = 0;
      if (Math.abs(translateZ) < 0.001) translateZ = 0;
      if (Math.abs(rotateY) < 0.001) rotateY = 0;
      if (Math.abs(rotateX) < 0.001) rotateX = 0;
      if (Math.abs(scale) < 0.001) scale = 0;
      const slideTransform = `translate3d(${translateX}px,${translateY}px,${translateZ}px)  rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale(${scale})`;
      const $targetEl = effectTarget(params, $slideEl);
      $targetEl.transform(slideTransform);
      $slideEl[0].style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;

      if (params.slideShadows) {
        // Set shadows
        let $shadowBeforeEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
        let $shadowAfterEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');

        if ($shadowBeforeEl.length === 0) {
          $shadowBeforeEl = createShadow(params, $slideEl, isHorizontal ? 'left' : 'top');
        }

        if ($shadowAfterEl.length === 0) {
          $shadowAfterEl = createShadow(params, $slideEl, isHorizontal ? 'right' : 'bottom');
        }

        if ($shadowBeforeEl.length) $shadowBeforeEl[0].style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0;
        if ($shadowAfterEl.length) $shadowAfterEl[0].style.opacity = -offsetMultiplier > 0 ? -offsetMultiplier : 0;
      }
    }
  };

  const setTransition = duration => {
    const {
      transformEl
    } = swiper.params.coverflowEffect;
    const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
    $transitionElements.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
  };

  effectInit({
    effect: 'coverflow',
    swiper,
    on,
    setTranslate,
    setTransition,
    perspective: () => true,
    overwriteParams: () => ({
      watchSlidesProgress: true
    })
  });
}
;// CONCATENATED MODULE: ./node_modules/swiper/modules/effect-creative/effect-creative.js




function EffectCreative({
  swiper,
  extendParams,
  on
}) {
  extendParams({
    creativeEffect: {
      transformEl: null,
      limitProgress: 1,
      shadowPerProgress: false,
      progressMultiplier: 1,
      perspective: true,
      prev: {
        translate: [0, 0, 0],
        rotate: [0, 0, 0],
        opacity: 1,
        scale: 1
      },
      next: {
        translate: [0, 0, 0],
        rotate: [0, 0, 0],
        opacity: 1,
        scale: 1
      }
    }
  });

  const getTranslateValue = value => {
    if (typeof value === 'string') return value;
    return `${value}px`;
  };

  const setTranslate = () => {
    const {
      slides,
      $wrapperEl,
      slidesSizesGrid
    } = swiper;
    const params = swiper.params.creativeEffect;
    const {
      progressMultiplier: multiplier
    } = params;
    const isCenteredSlides = swiper.params.centeredSlides;

    if (isCenteredSlides) {
      const margin = slidesSizesGrid[0] / 2 - swiper.params.slidesOffsetBefore || 0;
      $wrapperEl.transform(`translateX(calc(50% - ${margin}px))`);
    }

    for (let i = 0; i < slides.length; i += 1) {
      const $slideEl = slides.eq(i);
      const slideProgress = $slideEl[0].progress;
      const progress = Math.min(Math.max($slideEl[0].progress, -params.limitProgress), params.limitProgress);
      let originalProgress = progress;

      if (!isCenteredSlides) {
        originalProgress = Math.min(Math.max($slideEl[0].originalProgress, -params.limitProgress), params.limitProgress);
      }

      const offset = $slideEl[0].swiperSlideOffset;
      const t = [swiper.params.cssMode ? -offset - swiper.translate : -offset, 0, 0];
      const r = [0, 0, 0];
      let custom = false;

      if (!swiper.isHorizontal()) {
        t[1] = t[0];
        t[0] = 0;
      }

      let data = {
        translate: [0, 0, 0],
        rotate: [0, 0, 0],
        scale: 1,
        opacity: 1
      };

      if (progress < 0) {
        data = params.next;
        custom = true;
      } else if (progress > 0) {
        data = params.prev;
        custom = true;
      } // set translate


      t.forEach((value, index) => {
        t[index] = `calc(${value}px + (${getTranslateValue(data.translate[index])} * ${Math.abs(progress * multiplier)}))`;
      }); // set rotates

      r.forEach((value, index) => {
        r[index] = data.rotate[index] * Math.abs(progress * multiplier);
      });
      $slideEl[0].style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
      const translateString = t.join(', ');
      const rotateString = `rotateX(${r[0]}deg) rotateY(${r[1]}deg) rotateZ(${r[2]}deg)`;
      const scaleString = originalProgress < 0 ? `scale(${1 + (1 - data.scale) * originalProgress * multiplier})` : `scale(${1 - (1 - data.scale) * originalProgress * multiplier})`;
      const opacityString = originalProgress < 0 ? 1 + (1 - data.opacity) * originalProgress * multiplier : 1 - (1 - data.opacity) * originalProgress * multiplier;
      const transform = `translate3d(${translateString}) ${rotateString} ${scaleString}`; // Set shadows

      if (custom && data.shadow || !custom) {
        let $shadowEl = $slideEl.children('.swiper-slide-shadow');

        if ($shadowEl.length === 0 && data.shadow) {
          $shadowEl = createShadow(params, $slideEl);
        }

        if ($shadowEl.length) {
          const shadowOpacity = params.shadowPerProgress ? progress * (1 / params.limitProgress) : progress;
          $shadowEl[0].style.opacity = Math.min(Math.max(Math.abs(shadowOpacity), 0), 1);
        }
      }

      const $targetEl = effectTarget(params, $slideEl);
      $targetEl.transform(transform).css({
        opacity: opacityString
      });

      if (data.origin) {
        $targetEl.css('transform-origin', data.origin);
      }
    }
  };

  const setTransition = duration => {
    const {
      transformEl
    } = swiper.params.creativeEffect;
    const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
    $transitionElements.transition(duration).find('.swiper-slide-shadow').transition(duration);
    effectVirtualTransitionEnd({
      swiper,
      duration,
      transformEl,
      allSlides: true
    });
  };

  effectInit({
    effect: 'creative',
    swiper,
    on,
    setTranslate,
    setTransition,
    perspective: () => swiper.params.creativeEffect.perspective,
    overwriteParams: () => ({
      watchSlidesProgress: true,
      virtualTranslate: !swiper.params.cssMode
    })
  });
}
;// CONCATENATED MODULE: ./node_modules/swiper/modules/effect-cards/effect-cards.js




function EffectCards({
  swiper,
  extendParams,
  on
}) {
  extendParams({
    cardsEffect: {
      slideShadows: true,
      transformEl: null,
      rotate: true,
      perSlideRotate: 2,
      perSlideOffset: 8
    }
  });

  const setTranslate = () => {
    const {
      slides,
      activeIndex
    } = swiper;
    const params = swiper.params.cardsEffect;
    const {
      startTranslate,
      isTouched
    } = swiper.touchEventsData;
    const currentTranslate = swiper.translate;

    for (let i = 0; i < slides.length; i += 1) {
      const $slideEl = slides.eq(i);
      const slideProgress = $slideEl[0].progress;
      const progress = Math.min(Math.max(slideProgress, -4), 4);
      let offset = $slideEl[0].swiperSlideOffset;

      if (swiper.params.centeredSlides && !swiper.params.cssMode) {
        swiper.$wrapperEl.transform(`translateX(${swiper.minTranslate()}px)`);
      }

      if (swiper.params.centeredSlides && swiper.params.cssMode) {
        offset -= slides[0].swiperSlideOffset;
      }

      let tX = swiper.params.cssMode ? -offset - swiper.translate : -offset;
      let tY = 0;
      const tZ = -100 * Math.abs(progress);
      let scale = 1;
      let rotate = -params.perSlideRotate * progress;
      let tXAdd = params.perSlideOffset - Math.abs(progress) * 0.75;
      const slideIndex = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.from + i : i;
      const isSwipeToNext = (slideIndex === activeIndex || slideIndex === activeIndex - 1) && progress > 0 && progress < 1 && (isTouched || swiper.params.cssMode) && currentTranslate < startTranslate;
      const isSwipeToPrev = (slideIndex === activeIndex || slideIndex === activeIndex + 1) && progress < 0 && progress > -1 && (isTouched || swiper.params.cssMode) && currentTranslate > startTranslate;

      if (isSwipeToNext || isSwipeToPrev) {
        const subProgress = (1 - Math.abs((Math.abs(progress) - 0.5) / 0.5)) ** 0.5;
        rotate += -28 * progress * subProgress;
        scale += -0.5 * subProgress;
        tXAdd += 96 * subProgress;
        tY = `${-25 * subProgress * Math.abs(progress)}%`;
      }

      if (progress < 0) {
        // next
        tX = `calc(${tX}px + (${tXAdd * Math.abs(progress)}%))`;
      } else if (progress > 0) {
        // prev
        tX = `calc(${tX}px + (-${tXAdd * Math.abs(progress)}%))`;
      } else {
        tX = `${tX}px`;
      }

      if (!swiper.isHorizontal()) {
        const prevY = tY;
        tY = tX;
        tX = prevY;
      }

      const scaleString = progress < 0 ? `${1 + (1 - scale) * progress}` : `${1 - (1 - scale) * progress}`;
      const transform = `
        translate3d(${tX}, ${tY}, ${tZ}px)
        rotateZ(${params.rotate ? rotate : 0}deg)
        scale(${scaleString})
      `;

      if (params.slideShadows) {
        // Set shadows
        let $shadowEl = $slideEl.find('.swiper-slide-shadow');

        if ($shadowEl.length === 0) {
          $shadowEl = createShadow(params, $slideEl);
        }

        if ($shadowEl.length) $shadowEl[0].style.opacity = Math.min(Math.max((Math.abs(progress) - 0.5) / 0.5, 0), 1);
      }

      $slideEl[0].style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
      const $targetEl = effectTarget(params, $slideEl);
      $targetEl.transform(transform);
    }
  };

  const setTransition = duration => {
    const {
      transformEl
    } = swiper.params.cardsEffect;
    const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
    $transitionElements.transition(duration).find('.swiper-slide-shadow').transition(duration);
    effectVirtualTransitionEnd({
      swiper,
      duration,
      transformEl
    });
  };

  effectInit({
    effect: 'cards',
    swiper,
    on,
    setTranslate,
    setTransition,
    perspective: () => true,
    overwriteParams: () => ({
      watchSlidesProgress: true,
      virtualTranslate: !swiper.params.cssMode
    })
  });
}
;// CONCATENATED MODULE: ./node_modules/swiper/swiper.esm.js
/**
 * Swiper 8.4.7
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2023 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: January 30, 2023
 */



























/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,179], function() { return __webpack_exec__(91118), __webpack_exec__(90387); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);